(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea8ae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea8ae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aSiaI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6ObR8"));

});
parcelRegister("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRegister("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRegister("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("d2lNW", function(module, exports) {
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

module.exports = (parcelRequire("h8vP0"));

});
parcelRegister("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRegister("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});




parcelRegister("aJx1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d07ba38ace95d14$export$2e2bcd8739ae039; });
function $7d07ba38ace95d14$export$2e2bcd8739ae039() {
    return $7d07ba38ace95d14$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7d07ba38ace95d14$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("4qr5a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $fecb99b999628060$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $fecb99b999628060$export$2e2bcd8739ae039; });
function $fecb99b999628060$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fecb99b999628060$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fecb99b999628060$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fecb99b999628060$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fecb99b999628060$export$2e2bcd8739ae039 = $fecb99b999628060$export$4f5d2d50c9deca37;

});

parcelRegister("bisEj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839799496b62fb71$var$ReactIs, $839799496b62fb71$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jpdgm"))();

});
parcelRegister("jpdgm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $L7tyD = parcelRequire("L7tyD");
function $e20aa3d84dea372f$var$emptyFunction() {}
function $e20aa3d84dea372f$var$emptyFunctionWithReset() {}
$e20aa3d84dea372f$var$emptyFunctionWithReset.resetWarningCache = $e20aa3d84dea372f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $L7tyD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e20aa3d84dea372f$var$emptyFunctionWithReset,
        resetWarningCache: $e20aa3d84dea372f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("L7tyD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $08da306d15728f79$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $08da306d15728f79$var$ReactPropTypesSecret;

});



parcelRegister("jR9u2", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("eH0la", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});

parcelRegister("eXtb5", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $ae3d3578c845e26a$export$bf730a2d8bf68b42; }, function (v) { return $ae3d3578c845e26a$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ae3d3578c845e26a$export$bf730a2d8bf68b42;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ePGDo = parcelRequire("ePGDo");
function $ae3d3578c845e26a$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ae3d3578c845e26a$var$q = "function" === typeof Object.is ? Object.is : $ae3d3578c845e26a$var$p, $ae3d3578c845e26a$var$r = $ePGDo.useSyncExternalStore, $ae3d3578c845e26a$var$t = $exYeM.useRef, $ae3d3578c845e26a$var$u = $exYeM.useEffect, $ae3d3578c845e26a$var$v = $exYeM.useMemo, $ae3d3578c845e26a$var$w = $exYeM.useDebugValue;
$ae3d3578c845e26a$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $ae3d3578c845e26a$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $ae3d3578c845e26a$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($ae3d3578c845e26a$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $ae3d3578c845e26a$var$r(a, c[0], c[1]);
    $ae3d3578c845e26a$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $ae3d3578c845e26a$var$w(d);
    return d;
};

});
parcelRegister("ePGDo", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kvD72"));

});
parcelRegister("kvD72", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $eee50ad7e4fe08dc$export$306c0aa65ff9ec16; }, function (v) { return $eee50ad7e4fe08dc$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eee50ad7e4fe08dc$export$306c0aa65ff9ec16;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $eee50ad7e4fe08dc$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $eee50ad7e4fe08dc$var$k = "function" === typeof Object.is ? Object.is : $eee50ad7e4fe08dc$var$h, $eee50ad7e4fe08dc$var$l = $exYeM.useState, $eee50ad7e4fe08dc$var$m = $exYeM.useEffect, $eee50ad7e4fe08dc$var$n = $exYeM.useLayoutEffect, $eee50ad7e4fe08dc$var$p = $exYeM.useDebugValue;
function $eee50ad7e4fe08dc$var$q(a, b) {
    var d = b(), f = $eee50ad7e4fe08dc$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $eee50ad7e4fe08dc$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $eee50ad7e4fe08dc$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $eee50ad7e4fe08dc$var$m(function() {
        $eee50ad7e4fe08dc$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $eee50ad7e4fe08dc$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $eee50ad7e4fe08dc$var$p(d);
    return d;
}
function $eee50ad7e4fe08dc$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$eee50ad7e4fe08dc$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $eee50ad7e4fe08dc$var$t(a, b) {
    return b();
}
var $eee50ad7e4fe08dc$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $eee50ad7e4fe08dc$var$t : $eee50ad7e4fe08dc$var$q;
$eee50ad7e4fe08dc$export$306c0aa65ff9ec16 = void 0 !== $exYeM.useSyncExternalStore ? $exYeM.useSyncExternalStore : $eee50ad7e4fe08dc$var$u;

});



parcelRegister("bb2ZQ", function(module, exports) {
/*
 Highcharts JS v11.1.0 (2023-06-05)

 Boost module

 (c) 2010-2021 Highsoft AS
 Author: Torstein Honsi

 License: www.highcharts.com/license

*/ "use strict";
(function(a) {
    (0, module.exports) ? (a["default"] = a, module.exports = a) : "function" === typeof define && define.amd ? define("highcharts/modules/boost", [
        "highcharts"
    ], function(t) {
        a(t);
        a.Highcharts = t;
        return a;
    }) : a("undefined" !== typeof Highcharts ? Highcharts : void 0);
})(function(a) {
    function t(a, d, g, v) {
        a.hasOwnProperty(d) || (a[d] = v.apply(null, g), "function" === typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: d,
                module: a[d]
            }
        })));
    }
    a = a ? a._modules : {};
    t(a, "Extensions/Boost/Boostables.js", [], function() {
        return "area areaspline arearange column columnrange bar line scatter heatmap bubble treemap".split(" ");
    });
    t(a, "Extensions/Boost/BoostableMap.js", [
        a["Extensions/Boost/Boostables.js"]
    ], function(a) {
        const d = {};
        a.forEach((a)=>{
            d[a] = !0;
        });
        return d;
    });
    t(a, "Extensions/Boost/BoostChart.js", [
        a["Extensions/Boost/BoostableMap.js"],
        a["Core/Utilities.js"]
    ], function(a, d) {
        function g(e) {
            const b = e.series, d = e.boost = e.boost || {};
            var l = e.options.boost || {}, D = u(l.seriesThreshold, 50);
            if (b.length >= D) return !0;
            if (1 === b.length) return !1;
            l = l.allowForce;
            if ("undefined" === typeof l) {
                l = !0;
                for (var g of e.xAxis)if (u(g.min, -Infinity) > u(g.dataMin, -Infinity) || u(g.max, Infinity) < u(g.dataMax, Infinity)) {
                    l = !1;
                    break;
                }
            }
            if ("undefined" !== typeof d.forceChartBoost) {
                if (l) return d.forceChartBoost;
                d.forceChartBoost = void 0;
            }
            g = e = 0;
            for (const d of b)D = d.options, 0 !== D.boostThreshold && !1 !== d.visible && "heatmap" !== d.type && (a[d.type] && ++e, B(d.processedXData, D.data, d.points) >= (D.boostThreshold || Number.MAX_VALUE) && ++g);
            d.forceChartBoost = l && (e === b.length && 0 < g || 5 < g);
            return d.forceChartBoost;
        }
        function v(e) {
            b(e, "predraw", function() {
                e.boost = e.boost || {};
                e.boost.forceChartBoost = void 0;
                e.boosted = !1;
                e.boost.clear && e.boost.clear();
                e.boost.canvas && e.boost.wgl && g(e) && e.boost.wgl.allocateBuffer(e);
                e.boost.markerGroup && e.xAxis && 0 < e.xAxis.length && e.yAxis && 0 < e.yAxis.length && e.boost.markerGroup.translate(e.xAxis[0].pos, e.yAxis[0].pos);
            });
            b(e, "render", function() {
                e.boost && e.boost.wgl && g(e) && e.boost.wgl.render(e);
            });
            let a = -1, d = -1;
            b(e.pointer, "afterGetHoverData", ()=>{
                var b = e.hoverSeries;
                e.boost = e.boost || {};
                if (e.boost.markerGroup && b) {
                    const g = e.inverted ? b.yAxis : b.xAxis;
                    b = e.inverted ? b.xAxis : b.yAxis;
                    if (g && g.pos !== a || b && b.pos !== d) e.boost.markerGroup.translate(g.pos, b.pos), a = g.pos, d = b.pos;
                }
            });
        }
        function B(...b) {
            let e = -Number.MAX_VALUE;
            b.forEach(function(b) {
                if ("undefined" !== typeof b && null !== b && "undefined" !== typeof b.length && 0 < b.length) return e = b.length, !0;
            });
            return e;
        }
        const { addEvent: b, pick: u } = d, D = [];
        return {
            compose: function(b, a) {
                a && d.pushUnique(D, b) && b.prototype.callbacks.push(v);
                return b;
            },
            getBoostClipRect: function(b, a) {
                const e = {
                    x: b.plotLeft,
                    y: b.plotTop,
                    width: b.plotWidth,
                    height: b.plotHeight
                };
                a === b && (a = b.inverted ? b.xAxis : b.yAxis, 1 >= a.length ? (e.y = Math.min(a[0].pos, e.y), e.height = a[0].pos - b.plotTop + a[0].len) : e.height = b.plotHeight);
                return e;
            },
            isChartSeriesBoosting: g
        };
    });
    t(a, "Extensions/Boost/WGLDrawMode.js", [], function() {
        return {
            area: "LINES",
            arearange: "LINES",
            areaspline: "LINES",
            column: "LINES",
            columnrange: "LINES",
            bar: "LINES",
            line: "LINE_STRIP",
            scatter: "POINTS",
            heatmap: "TRIANGLES",
            treemap: "TRIANGLES",
            bubble: "POINTS"
        };
    });
    t(a, "Extensions/Boost/WGLShader.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { clamp: d, error: g, pick: v } = a;
        class B {
            constructor(b){
                this.errors = [];
                this.uLocations = {};
                (this.gl = b) && this.createShader();
            }
            bind() {
                this.gl && this.shaderProgram && this.gl.useProgram(this.shaderProgram);
            }
            createShader() {
                const b = this.stringToProgram("#version 100\n#define LN10 2.302585092994046\nprecision highp float;\nattribute vec4 aVertexPosition;\nattribute vec4 aColor;\nvarying highp vec2 position;\nvarying highp vec4 vColor;\nuniform mat4 uPMatrix;\nuniform float pSize;\nuniform float translatedThreshold;\nuniform bool hasThreshold;\nuniform bool skipTranslation;\nuniform float xAxisTrans;\nuniform float xAxisMin;\nuniform float xAxisMinPad;\nuniform float xAxisPointRange;\nuniform float xAxisLen;\nuniform bool  xAxisPostTranslate;\nuniform float xAxisOrdinalSlope;\nuniform float xAxisOrdinalOffset;\nuniform float xAxisPos;\nuniform bool  xAxisCVSCoord;\nuniform bool  xAxisIsLog;\nuniform bool  xAxisReversed;\nuniform float yAxisTrans;\nuniform float yAxisMin;\nuniform float yAxisMinPad;\nuniform float yAxisPointRange;\nuniform float yAxisLen;\nuniform bool  yAxisPostTranslate;\nuniform float yAxisOrdinalSlope;\nuniform float yAxisOrdinalOffset;\nuniform float yAxisPos;\nuniform bool  yAxisCVSCoord;\nuniform bool  yAxisIsLog;\nuniform bool  yAxisReversed;\nuniform bool  isBubble;\nuniform bool  bubbleSizeByArea;\nuniform float bubbleZMin;\nuniform float bubbleZMax;\nuniform float bubbleZThreshold;\nuniform float bubbleMinSize;\nuniform float bubbleMaxSize;\nuniform bool  bubbleSizeAbs;\nuniform bool  isInverted;\nfloat bubbleRadius(){\nfloat value = aVertexPosition.w;\nfloat zMax = bubbleZMax;\nfloat zMin = bubbleZMin;\nfloat radius = 0.0;\nfloat pos = 0.0;\nfloat zRange = zMax - zMin;\nif (bubbleSizeAbs){\nvalue = value - bubbleZThreshold;\nzMax = max(zMax - bubbleZThreshold, zMin - bubbleZThreshold);\nzMin = 0.0;\n}\nif (value < zMin){\nradius = bubbleZMin / 2.0 - 1.0;\n} else {\npos = zRange > 0.0 ? (value - zMin) / zRange : 0.5;\nif (bubbleSizeByArea && pos > 0.0){\npos = sqrt(pos);\n}\nradius = ceil(bubbleMinSize + pos * (bubbleMaxSize - bubbleMinSize)) / 2.0;\n}\nreturn radius * 2.0;\n}\nfloat translate(float val,\nfloat pointPlacement,\nfloat localA,\nfloat localMin,\nfloat minPixelPadding,\nfloat pointRange,\nfloat len,\nbool  cvsCoord,\nbool  isLog,\nbool  reversed\n){\nfloat sign = 1.0;\nfloat cvsOffset = 0.0;\nif (cvsCoord) {\nsign *= -1.0;\ncvsOffset = len;\n}\nif (isLog) {\nval = log(val) / LN10;\n}\nif (reversed) {\nsign *= -1.0;\ncvsOffset -= sign * len;\n}\nreturn sign * (val - localMin) * localA + cvsOffset + \n(sign * minPixelPadding);\n}\nfloat xToPixels(float value) {\nif (skipTranslation){\nreturn value;// + xAxisPos;\n}\nreturn translate(value, 0.0, xAxisTrans, xAxisMin, xAxisMinPad, xAxisPointRange, xAxisLen, xAxisCVSCoord, xAxisIsLog, xAxisReversed);// + xAxisPos;\n}\nfloat yToPixels(float value, float checkTreshold) {\nfloat v;\nif (skipTranslation){\nv = value;// + yAxisPos;\n} else {\nv = translate(value, 0.0, yAxisTrans, yAxisMin, yAxisMinPad, yAxisPointRange, yAxisLen, yAxisCVSCoord, yAxisIsLog, yAxisReversed);// + yAxisPos;\nif (v > yAxisLen) {\nv = yAxisLen;\n}\n}\nif (checkTreshold > 0.0 && hasThreshold) {\nv = min(v, translatedThreshold);\n}\nreturn v;\n}\nvoid main(void) {\nif (isBubble){\ngl_PointSize = bubbleRadius();\n} else {\ngl_PointSize = pSize;\n}\nvColor = aColor;\nif (skipTranslation && isInverted) {\ngl_Position = uPMatrix * vec4(aVertexPosition.y + yAxisPos, aVertexPosition.x + xAxisPos, 0.0, 1.0);\n} else if (isInverted) {\ngl_Position = uPMatrix * vec4(yToPixels(aVertexPosition.y, aVertexPosition.z) + yAxisPos, xToPixels(aVertexPosition.x) + xAxisPos, 0.0, 1.0);\n} else {\ngl_Position = uPMatrix * vec4(xToPixels(aVertexPosition.x) + xAxisPos, yToPixels(aVertexPosition.y, aVertexPosition.z) + yAxisPos, 0.0, 1.0);\n}\n}", "vertex"), a = this.stringToProgram("precision highp float;\nuniform vec4 fillColor;\nvarying highp vec2 position;\nvarying highp vec4 vColor;\nuniform sampler2D uSampler;\nuniform bool isCircle;\nuniform bool hasColor;\nvoid main(void) {\nvec4 col = fillColor;\nvec4 tcol = texture2D(uSampler, gl_PointCoord.st);\nif (hasColor) {\ncol = vColor;\n}\nif (isCircle) {\ncol *= tcol;\nif (tcol.r < 0.0) {\ndiscard;\n} else {\ngl_FragColor = col;\n}\n} else {\ngl_FragColor = col;\n}\n}", "fragment"), d = (b)=>this.gl.getUniformLocation(this.shaderProgram, b);
                if (!b || !a) return this.shaderProgram = !1, this.handleErrors(), !1;
                this.shaderProgram = this.gl.createProgram();
                this.gl.attachShader(this.shaderProgram, b);
                this.gl.attachShader(this.shaderProgram, a);
                this.gl.linkProgram(this.shaderProgram);
                if (!this.gl.getProgramParameter(this.shaderProgram, this.gl.LINK_STATUS)) return this.errors.push(this.gl.getProgramInfoLog(this.shaderProgram)), this.handleErrors(), this.shaderProgram = !1;
                this.gl.useProgram(this.shaderProgram);
                this.gl.bindAttribLocation(this.shaderProgram, 0, "aVertexPosition");
                this.pUniform = d("uPMatrix");
                this.psUniform = d("pSize");
                this.fcUniform = d("fillColor");
                this.isBubbleUniform = d("isBubble");
                this.bubbleSizeAbsUniform = d("bubbleSizeAbs");
                this.bubbleSizeAreaUniform = d("bubbleSizeByArea");
                this.uSamplerUniform = d("uSampler");
                this.skipTranslationUniform = d("skipTranslation");
                this.isCircleUniform = d("isCircle");
                this.isInverted = d("isInverted");
                return !0;
            }
            handleErrors() {
                this.errors.length && g("[highcharts boost] shader error - " + this.errors.join("\n"));
            }
            stringToProgram(b, a) {
                const d = this.gl.createShader("vertex" === a ? this.gl.VERTEX_SHADER : this.gl.FRAGMENT_SHADER);
                this.gl.shaderSource(d, b);
                this.gl.compileShader(d);
                return this.gl.getShaderParameter(d, this.gl.COMPILE_STATUS) ? d : (this.errors.push("when compiling " + a + " shader:\n" + this.gl.getShaderInfoLog(d)), !1);
            }
            destroy() {
                this.gl && this.shaderProgram && (this.gl.deleteProgram(this.shaderProgram), this.shaderProgram = !1);
            }
            fillColorUniform() {
                return this.fcUniform;
            }
            getProgram() {
                return this.shaderProgram;
            }
            pointSizeUniform() {
                return this.psUniform;
            }
            perspectiveUniform() {
                return this.pUniform;
            }
            reset() {
                this.gl && this.shaderProgram && (this.gl.uniform1i(this.isBubbleUniform, 0), this.gl.uniform1i(this.isCircleUniform, 0));
            }
            setBubbleUniforms(b, a, g, e = 1) {
                const B = b.options;
                let u = Number.MAX_VALUE, l = -Number.MAX_VALUE;
                if (this.gl && this.shaderProgram && b.is("bubble")) {
                    const U = b.getPxExtremes();
                    u = v(B.zMin, d(a, !1 === B.displayNegative ? B.zThreshold : -Number.MAX_VALUE, u));
                    l = v(B.zMax, Math.max(l, g));
                    this.gl.uniform1i(this.isBubbleUniform, 1);
                    this.gl.uniform1i(this.isCircleUniform, 1);
                    this.gl.uniform1i(this.bubbleSizeAreaUniform, "width" !== b.options.sizeBy);
                    this.gl.uniform1i(this.bubbleSizeAbsUniform, b.options.sizeByAbsoluteValue);
                    this.setUniform("bubbleMinSize", U.minPxSize * e);
                    this.setUniform("bubbleMaxSize", U.maxPxSize * e);
                    this.setUniform("bubbleZMin", u);
                    this.setUniform("bubbleZMax", l);
                    this.setUniform("bubbleZThreshold", b.options.zThreshold);
                }
            }
            setColor(b) {
                this.gl && this.shaderProgram && this.gl.uniform4f(this.fcUniform, b[0] / 255, b[1] / 255, b[2] / 255, b[3]);
            }
            setDrawAsCircle(b) {
                this.gl && this.shaderProgram && this.gl.uniform1i(this.isCircleUniform, b ? 1 : 0);
            }
            setInverted(b) {
                this.gl && this.shaderProgram && this.gl.uniform1i(this.isInverted, b);
            }
            setPMatrix(b) {
                this.gl && this.shaderProgram && this.gl.uniformMatrix4fv(this.pUniform, !1, b);
            }
            setPointSize(b) {
                this.gl && this.shaderProgram && this.gl.uniform1f(this.psUniform, b);
            }
            setSkipTranslation(b) {
                this.gl && this.shaderProgram && this.gl.uniform1i(this.skipTranslationUniform, !0 === b ? 1 : 0);
            }
            setTexture(b) {
                this.gl && this.shaderProgram && this.gl.uniform1i(this.uSamplerUniform, b);
            }
            setUniform(b, a) {
                this.gl && this.shaderProgram && (b = this.uLocations[b] = this.uLocations[b] || this.gl.getUniformLocation(this.shaderProgram, b), this.gl.uniform1f(b, a));
            }
        }
        return B;
    });
    t(a, "Extensions/Boost/WGLVertexBuffer.js", [], function() {
        class a {
            constructor(a, g, v){
                this.buffer = !1;
                this.iterator = 0;
                this.vertAttribute = this.preAllocated = !1;
                this.components = v || 2;
                this.dataComponents = v;
                this.gl = a;
                this.shader = g;
            }
            allocate(a) {
                this.iterator = -1;
                this.preAllocated = new Float32Array(4 * a);
            }
            bind() {
                if (!this.buffer) return !1;
                this.gl.vertexAttribPointer(this.vertAttribute, this.components, this.gl.FLOAT, !1, 0, 0);
            }
            build(a, g, v) {
                let d;
                this.data = a || [];
                if (!(this.data && 0 !== this.data.length || this.preAllocated)) return this.destroy(), !1;
                this.components = v || this.components;
                this.buffer && this.gl.deleteBuffer(this.buffer);
                this.preAllocated || (d = new Float32Array(this.data));
                this.buffer = this.gl.createBuffer();
                this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.buffer);
                this.gl.bufferData(this.gl.ARRAY_BUFFER, this.preAllocated || d, this.gl.STATIC_DRAW);
                this.vertAttribute = this.gl.getAttribLocation(this.shader.getProgram(), g);
                this.gl.enableVertexAttribArray(this.vertAttribute);
                return !0;
            }
            destroy() {
                this.buffer && (this.gl.deleteBuffer(this.buffer), this.vertAttribute = this.buffer = !1);
                this.iterator = 0;
                this.components = this.dataComponents || 2;
                this.data = [];
            }
            push(a, g, v, B) {
                this.preAllocated && (this.preAllocated[++this.iterator] = a, this.preAllocated[++this.iterator] = g, this.preAllocated[++this.iterator] = v, this.preAllocated[++this.iterator] = B);
            }
            render(a, g, v) {
                const d = this.preAllocated ? this.preAllocated.length : this.data.length;
                if (!this.buffer || !d) return !1;
                if (!a || a > d || 0 > a) a = 0;
                if (!g || g > d) g = d;
                if (a >= g) return !1;
                this.gl.drawArrays(this.gl[v || "POINTS"], a / this.components, (g - a) / this.components);
                return !0;
            }
        }
        return a;
    });
    t(a, "Extensions/Boost/WGLRenderer.js", [
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"],
        a["Extensions/Boost/WGLDrawMode.js"],
        a["Extensions/Boost/WGLShader.js"],
        a["Extensions/Boost/WGLVertexBuffer.js"]
    ], function(a, d, g, v, B, b) {
        const { parse: u } = a, { doc: D, win: e } = d, { isNumber: t, isObject: U, merge: l, objectEach: H, pick: L } = g, z = {
            column: !0,
            columnrange: !0,
            bar: !0,
            area: !0,
            areaspline: !0,
            arearange: !0
        }, I = {
            scatter: !0,
            bubble: !0
        }, J = [
            "webgl",
            "experimental-webgl",
            "moz-webgl",
            "webkit-3d"
        ];
        class N {
            static orthoMatrix(c, a) {
                return [
                    2 / c,
                    0,
                    0,
                    0,
                    0,
                    -(2 / a),
                    0,
                    0,
                    0,
                    0,
                    -2,
                    0,
                    -1,
                    1,
                    -1,
                    1
                ];
            }
            static seriesPointCount(c) {
                let a;
                if (c.boosted) {
                    var b = !!c.options.stacking;
                    a = c.xData || c.options.xData || c.processedXData;
                    b = (b ? c.data : a || c.options.data).length;
                    "treemap" === c.type ? b *= 12 : "heatmap" === c.type ? b *= 6 : z[c.type] && (b *= 2);
                    return b;
                }
                return 0;
            }
            constructor(c){
                this.data = [];
                this.height = 0;
                this.isInited = !1;
                this.markerData = [];
                this.series = [];
                this.textureHandles = {};
                this.width = 0;
                this.postRenderCallback = c;
                this.settings = {
                    pointSize: 1,
                    lineWidth: 1,
                    fillColor: "#AA00AA",
                    useAlpha: !0,
                    usePreallocated: !1,
                    useGPUTranslations: !1,
                    debug: {
                        timeRendering: !1,
                        timeSeriesProcessing: !1,
                        timeSetup: !1,
                        timeBufferCopy: !1,
                        timeKDTree: !1,
                        showSkipSummary: !1
                    }
                };
            }
            getPixelRatio() {
                return this.settings.pixelRatio || e.devicePixelRatio || 1;
            }
            setOptions(c) {
                "pixelRatio" in c || (c.pixelRatio = 1);
                l(!0, this.settings, c);
            }
            allocateBuffer(c) {
                const a = this.vbuffer;
                let b = 0;
                this.settings.usePreallocated && (c.series.forEach((c)=>{
                    c.boosted && (b += N.seriesPointCount(c));
                }), a && a.allocate(b));
            }
            allocateBufferForSingleSeries(c) {
                const a = this.vbuffer;
                let b = 0;
                this.settings.usePreallocated && (c.boosted && (b = N.seriesPointCount(c)), a && a.allocate(b));
            }
            clear() {
                const c = this.gl;
                c && c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            }
            pushSeriesData(c, a) {
                const b = this.data, f = this.settings, ka = this.vbuffer;
                var h = c.pointArrayMap && "low,high" === c.pointArrayMap.join(",");
                const q = c.chart, n = c.options, m = !!n.stacking, d = n.data;
                var e = c.xAxis.getExtremes();
                const Z = e.min;
                e = e.max;
                var p = c.yAxis.getExtremes();
                const g = p.min, v = p.max;
                var l = c.xData || n.xData || c.processedXData;
                const B = c.yData || n.yData || c.processedYData, t = c.zData || n.zData || c.processedZData, C = c.yAxis, D = c.xAxis, L = !l || 0 === l.length;
                p = n.connectNulls;
                var w = c.points || !1;
                const F = m ? c.data : l || d;
                l = {
                    x: Number.MAX_VALUE,
                    y: 0
                };
                const I = {
                    x: -Number.MAX_VALUE,
                    y: 0
                }, k = "undefined" === typeof q.index, r = z[c.type], V = n.zoneAxis || "y", ba = n.zones || !1, sa = n.threshold, ia = this.getPixelRatio();
                let ua = c.chart.plotWidth, ca = !1, R = !1;
                let W, J = 0;
                var X = !1;
                let A, x, H, E = -1, Y = !1, da = !1, ea, N = !1, ja = !1, y = !1, fa = !1, na = !0, S = !0, ha, G = !1, P = !1, oa = 0;
                if (!(n.boostData && 0 < n.boostData.length)) {
                    n.gapSize && (P = "value" !== n.gapUnit ? n.gapSize * c.closestPointRange : n.gapSize);
                    if (ba && (ha = [], ba.forEach((a, c)=>{
                        if (a.color) {
                            const k = u(a.color).rgba;
                            k[0] /= 255;
                            k[1] /= 255;
                            k[2] /= 255;
                            ha[c] = k;
                            G || "undefined" !== typeof a.value || (G = k);
                        }
                    }), !G)) {
                        var T = c.pointAttribs && c.pointAttribs().fill || c.color;
                        G = u(T).rgba;
                        G[0] /= 255;
                        G[1] /= 255;
                        G[2] /= 255;
                    }
                    q.inverted && (ua = c.chart.plotHeight);
                    c.closestPointRangePx = Number.MAX_VALUE;
                    var M = (c)=>{
                        c && (a.colorData.push(c[0]), a.colorData.push(c[1]), a.colorData.push(c[2]), a.colorData.push(c[3]));
                    }, Q = (c, k, r, h = 1, V)=>{
                        M(V);
                        1 === ia || f.useGPUTranslations && !a.skipTranslation || (c *= ia, k *= ia, h *= ia);
                        f.usePreallocated && ka ? (ka.push(c, k, r ? 1 : 0, h), oa += 4) : (b.push(c), b.push(k), b.push(r ? ia : 0), b.push(h));
                    }, Ba = ()=>{
                        a.segments.length && (a.segments[a.segments.length - 1].to = b.length || oa);
                    };
                    T = ()=>{
                        a.segments.length && a.segments[a.segments.length - 1].from === (b.length || oa) || (Ba(), a.segments.push({
                            from: b.length || oa
                        }));
                    };
                    var Ca = (a, c, k, b, r)=>{
                        M(r);
                        Q(a + k, c);
                        M(r);
                        Q(a, c);
                        M(r);
                        Q(a, c + b);
                        M(r);
                        Q(a, c + b);
                        M(r);
                        Q(a + k, c + b);
                        M(r);
                        Q(a + k, c);
                    };
                    T();
                    if (w && 0 < w.length) a.skipTranslation = !0, a.drawMode = "TRIANGLES", w[0].node && w[0].node.levelDynamic && w.sort((a, c)=>{
                        if (a.node) {
                            if (a.node.levelDynamic > c.node.levelDynamic) return 1;
                            if (a.node.levelDynamic < c.node.levelDynamic) return -1;
                        }
                        return 0;
                    }), w.forEach((a)=>{
                        var k = a.plotY;
                        if ("undefined" !== typeof k && !isNaN(k) && null !== a.y && a.shapeArgs) {
                            let { x: b = 0, y: r = 0, width: h = 0, height: V = 0 } = a.shapeArgs;
                            k = q.styledMode ? a.series.colorAttribs(a) : k = a.series.pointAttribs(a);
                            a = k["stroke-width"] || 0;
                            y = u(k.fill).rgba;
                            y[0] /= 255;
                            y[1] /= 255;
                            y[2] /= 255;
                            c.is("treemap") && (a = a || 1, W = u(k.stroke).rgba, W[0] /= 255, W[1] /= 255, W[2] /= 255, Ca(b, r, h, V, W), a /= 2);
                            c.is("heatmap") && q.inverted && (b = D.len - b, r = C.len - r, h = -h, V = -V);
                            Ca(b + a, r + a, h - 2 * a, V - 2 * a, y);
                        }
                    });
                    else {
                        for(; E < F.length - 1;){
                            w = F[++E];
                            if ("undefined" === typeof w) continue;
                            if (k) break;
                            const b = d && d[E];
                            !L && U(b, !0) && b.color && (y = u(b.color).rgba, y[0] /= 255, y[1] /= 255, y[2] /= 255);
                            L ? (A = w[0], x = w[1], F[E + 1] && (da = F[E + 1][0]), F[E - 1] && (Y = F[E - 1][0]), 3 <= w.length && (H = w[2], w[2] > a.zMax && (a.zMax = w[2]), w[2] < a.zMin && (a.zMin = w[2]))) : (A = w, x = B[E], F[E + 1] && (da = F[E + 1]), F[E - 1] && (Y = F[E - 1]), t && t.length && (H = t[E], t[E] > a.zMax && (a.zMax = t[E]), t[E] < a.zMin && (a.zMin = t[E])));
                            if (p || null !== A && null !== x) {
                                if (da && da >= Z && da <= e && (N = !0), Y && Y >= Z && Y <= e && (ja = !0), h ? (L && (x = w.slice(1, 3)), ea = x[0], x = x[1]) : m && (A = w.x, x = w.stackY, ea = x - w.y), null !== g && "undefined" !== typeof g && null !== v && "undefined" !== typeof v && (na = x >= g && x <= v), A > e && I.x < e && (I.x = A, I.y = x), A < Z && l.x > Z && (l.x = A, l.y = x), null !== x || !p) {
                                    if (null !== x && (na || N || ja)) {
                                        if ((da >= Z || A >= Z) && (Y <= e || A <= e) && (fa = !0), fa || N || ja) {
                                            P && A - Y > P && T();
                                            if (ba) {
                                                let a;
                                                ba.some((c, k)=>{
                                                    const b = ba[k - 1];
                                                    return "x" === V ? "undefined" !== typeof c.value && A <= c.value ? (ha[k] && (!b || A >= b.value) && (a = ha[k]), !0) : !1 : "undefined" !== typeof c.value && x <= c.value ? (ha[k] && (!b || x >= b.value) && (a = ha[k]), !0) : !1;
                                                });
                                                y = a || G || y;
                                            }
                                            if (!f.useGPUTranslations && (a.skipTranslation = !0, A = D.toPixels(A, !0), x = C.toPixels(x, !0), A > ua && "POINTS" === a.drawMode)) continue;
                                            a.hasMarkers && fa && !1 !== ca && (c.closestPointRangePx = Math.min(c.closestPointRangePx, Math.abs(A - ca)));
                                            if (!f.useGPUTranslations && !f.usePreallocated && ca && 1 > Math.abs(A - ca) && R && 1 > Math.abs(x - R)) f.debug.showSkipSummary && ++J;
                                            else {
                                                if (r) {
                                                    X = ea;
                                                    if (!1 === ea || "undefined" === typeof ea) X = 0 > x ? x : 0;
                                                    h || m || (X = Math.max(null === sa ? g : sa, g));
                                                    f.useGPUTranslations || (X = C.toPixels(X, !0));
                                                    Q(A, X, 0, 0, y);
                                                }
                                                n.step && !S && Q(A, R, 0, 2, y);
                                                Q(A, x, 0, "bubble" === c.type ? H || 1 : 2, y);
                                                ca = A;
                                                R = x;
                                                X = !0;
                                                S = !1;
                                            }
                                        }
                                    } else T();
                                }
                            } else T();
                        }
                        f.debug.showSkipSummary && console.log("skipped points:", J);
                        h = (c, k)=>{
                            f.useGPUTranslations || (a.skipTranslation = !0, c.x = D.toPixels(c.x, !0), c.y = C.toPixels(c.y, !0));
                            k ? this.data = [
                                c.x,
                                c.y,
                                0,
                                2
                            ].concat(this.data) : Q(c.x, c.y, 0, 2);
                        };
                        X || !1 === p || "line_strip" !== c.drawMode || (l.x < Number.MAX_VALUE && h(l, !0), I.x > -Number.MAX_VALUE && h(I));
                    }
                    Ba();
                }
            }
            pushSeries(a) {
                var c = this.markerData;
                const b = this.series, f = this.settings;
                0 < b.length && b[b.length - 1].hasMarkers && (b[b.length - 1].markerTo = c.length);
                f.debug.timeSeriesProcessing && console.time("building " + a.type + " series");
                c = {
                    segments: [],
                    markerFrom: c.length,
                    colorData: [],
                    series: a,
                    zMin: Number.MAX_VALUE,
                    zMax: -Number.MAX_VALUE,
                    hasMarkers: a.options.marker ? !1 !== a.options.marker.enabled : !1,
                    showMarkers: !0,
                    drawMode: v[a.type] || "LINE_STRIP"
                };
                a.index >= b.length ? b.push(c) : b[a.index] = c;
                this.pushSeriesData(a, c);
                f.debug.timeSeriesProcessing && console.timeEnd("building " + a.type + " series");
            }
            flush() {
                const a = this.vbuffer;
                this.data = [];
                this.markerData = [];
                this.series = [];
                a && a.destroy();
            }
            setXAxis(a) {
                const c = this.shader;
                if (c) {
                    var b = this.getPixelRatio();
                    c.setUniform("xAxisTrans", a.transA * b);
                    c.setUniform("xAxisMin", a.min);
                    c.setUniform("xAxisMinPad", a.minPixelPadding * b);
                    c.setUniform("xAxisPointRange", a.pointRange);
                    c.setUniform("xAxisLen", a.len * b);
                    c.setUniform("xAxisPos", a.pos * b);
                    c.setUniform("xAxisCVSCoord", !a.horiz);
                    c.setUniform("xAxisIsLog", !!a.logarithmic);
                    c.setUniform("xAxisReversed", !!a.reversed);
                }
            }
            setYAxis(a) {
                const c = this.shader;
                if (c) {
                    var b = this.getPixelRatio();
                    c.setUniform("yAxisTrans", a.transA * b);
                    c.setUniform("yAxisMin", a.min);
                    c.setUniform("yAxisMinPad", a.minPixelPadding * b);
                    c.setUniform("yAxisPointRange", a.pointRange);
                    c.setUniform("yAxisLen", a.len * b);
                    c.setUniform("yAxisPos", a.pos * b);
                    c.setUniform("yAxisCVSCoord", !a.horiz);
                    c.setUniform("yAxisIsLog", !!a.logarithmic);
                    c.setUniform("yAxisReversed", !!a.reversed);
                }
            }
            setThreshold(a, b) {
                const c = this.shader;
                c && (c.setUniform("hasThreshold", a), c.setUniform("translatedThreshold", b));
            }
            renderChart(c) {
                const e = this.gl, g = this.settings, f = this.shader, K = this.vbuffer, h = this.getPixelRatio();
                if (c) this.width = c.chartWidth * h, this.height = c.chartHeight * h;
                else return !1;
                const q = this.height, n = this.width;
                if (!(e && f && n && q)) return !1;
                g.debug.timeRendering && console.time("gl rendering");
                e.canvas.width = n;
                e.canvas.height = q;
                f.bind();
                e.viewport(0, 0, n, q);
                f.setPMatrix(N.orthoMatrix(n, q));
                1 < g.lineWidth && !d.isMS && e.lineWidth(g.lineWidth);
                K && (K.build(this.data, "aVertexPosition", 4), K.bind());
                f.setInverted(c.inverted);
                this.series.forEach((m, d)=>{
                    const n = m.series.options;
                    var q = n.marker, p = "undefined" !== typeof n.lineWidth ? n.lineWidth : 1, l = n.threshold;
                    const v = t(l), la = m.series.yAxis.getThreshold(l);
                    l = L(n.marker ? n.marker.enabled : null, m.series.xAxis.isRadial ? !0 : null, m.series.closestPointRangePx > 2 * ((n.marker ? n.marker.radius : 10) || 10));
                    q = this.textureHandles[q && q.symbol || m.series.symbol] || this.textureHandles.circle;
                    if (0 !== m.segments.length && m.segments[0].from !== m.segments[0].to && (q.isReady && (e.bindTexture(e.TEXTURE_2D, q.handle), f.setTexture(q.handle)), c.styledMode ? q = m.series.markerGroup && m.series.markerGroup.getStyle("fill") : (q = "POINTS" === m.drawMode && m.series.pointAttribs && m.series.pointAttribs().fill || m.series.color, n.colorByPoint && (q = m.series.chart.options.colors[d])), m.series.fillOpacity && n.fillOpacity && (q = new a(q).setOpacity(L(n.fillOpacity, 1)).get()), q = u(q).rgba, g.useAlpha || (q[3] = 1), "LINES" === m.drawMode && g.useAlpha && 1 > q[3] && (q[3] /= 10), "add" === n.boostBlending ? (e.blendFunc(e.SRC_ALPHA, e.ONE), e.blendEquation(e.FUNC_ADD)) : "mult" === n.boostBlending || "multiply" === n.boostBlending ? e.blendFunc(e.DST_COLOR, e.ZERO) : "darken" === n.boostBlending ? (e.blendFunc(e.ONE, e.ONE), e.blendEquation(e.FUNC_MIN)) : e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA), f.reset(), 0 < m.colorData.length ? (f.setUniform("hasColor", 1), d = new b(e, f), d.build(m.colorData, "aColor", 4), d.bind()) : e.disableVertexAttribArray(e.getAttribLocation(f.getProgram(), "aColor")), f.setColor(q), this.setXAxis(m.series.xAxis), this.setYAxis(m.series.yAxis), this.setThreshold(v, la), "POINTS" === m.drawMode && f.setPointSize(2 * L(n.marker && n.marker.radius, .5) * h), f.setSkipTranslation(m.skipTranslation), "bubble" === m.series.type && f.setBubbleUniforms(m.series, m.zMin, m.zMax, h), f.setDrawAsCircle(I[m.series.type] || !1), K)) {
                        if (0 < p || "LINE_STRIP" !== m.drawMode) for(p = 0; p < m.segments.length; p++)K.render(m.segments[p].from, m.segments[p].to, m.drawMode);
                        if (m.hasMarkers && l) for(f.setPointSize(2 * L(n.marker && n.marker.radius, 5) * h), f.setDrawAsCircle(!0), p = 0; p < m.segments.length; p++)K.render(m.segments[p].from, m.segments[p].to, "POINTS");
                    }
                });
                g.debug.timeRendering && console.timeEnd("gl rendering");
                this.postRenderCallback && this.postRenderCallback(this);
                this.flush();
            }
            render(a) {
                this.clear();
                if (a.renderer.forExport) return this.renderChart(a);
                this.isInited ? this.renderChart(a) : setTimeout(()=>{
                    this.render(a);
                }, 1);
            }
            setSize(a, b) {
                const c = this.shader;
                !c || this.width === a && this.height === b || (this.width = a, this.height = b, c.bind(), c.setPMatrix(N.orthoMatrix(a, b)));
            }
            init(a, e) {
                const c = this.settings;
                this.isInited = !1;
                if (!a) return !1;
                c.debug.timeSetup && console.time("gl setup");
                for(let b = 0; b < J.length && !(this.gl = a.getContext(J[b], {})); ++b);
                const f = this.gl;
                if (f) e || this.flush();
                else return !1;
                f.enable(f.BLEND);
                f.blendFunc(f.SRC_ALPHA, f.ONE_MINUS_SRC_ALPHA);
                f.disable(f.DEPTH_TEST);
                f.depthFunc(f.LESS);
                a = this.shader = new B(f);
                if (!a) return !1;
                this.vbuffer = new b(f, a);
                a = (a, b)=>{
                    const c = {
                        isReady: !1,
                        texture: D.createElement("canvas"),
                        handle: f.createTexture()
                    }, e = c.texture.getContext("2d");
                    this.textureHandles[a] = c;
                    c.texture.width = 512;
                    c.texture.height = 512;
                    e.mozImageSmoothingEnabled = !1;
                    e.webkitImageSmoothingEnabled = !1;
                    e.msImageSmoothingEnabled = !1;
                    e.imageSmoothingEnabled = !1;
                    e.strokeStyle = "rgba(255, 255, 255, 0)";
                    e.fillStyle = "#FFF";
                    b(e);
                    try {
                        f.activeTexture(f.TEXTURE0), f.bindTexture(f.TEXTURE_2D, c.handle), f.texImage2D(f.TEXTURE_2D, 0, f.RGBA, f.RGBA, f.UNSIGNED_BYTE, c.texture), f.texParameteri(f.TEXTURE_2D, f.TEXTURE_WRAP_S, f.CLAMP_TO_EDGE), f.texParameteri(f.TEXTURE_2D, f.TEXTURE_WRAP_T, f.CLAMP_TO_EDGE), f.texParameteri(f.TEXTURE_2D, f.TEXTURE_MAG_FILTER, f.LINEAR), f.texParameteri(f.TEXTURE_2D, f.TEXTURE_MIN_FILTER, f.LINEAR), f.bindTexture(f.TEXTURE_2D, null), c.isReady = !0;
                    } catch (m) {}
                };
                a("circle", (a)=>{
                    a.beginPath();
                    a.arc(256, 256, 256, 0, 2 * Math.PI);
                    a.stroke();
                    a.fill();
                });
                a("square", (a)=>{
                    a.fillRect(0, 0, 512, 512);
                });
                a("diamond", (a)=>{
                    a.beginPath();
                    a.moveTo(256, 0);
                    a.lineTo(512, 256);
                    a.lineTo(256, 512);
                    a.lineTo(0, 256);
                    a.lineTo(256, 0);
                    a.fill();
                });
                a("triangle", (a)=>{
                    a.beginPath();
                    a.moveTo(0, 512);
                    a.lineTo(256, 0);
                    a.lineTo(512, 512);
                    a.lineTo(0, 512);
                    a.fill();
                });
                a("triangle-down", (a)=>{
                    a.beginPath();
                    a.moveTo(0, 0);
                    a.lineTo(256, 512);
                    a.lineTo(512, 0);
                    a.lineTo(0, 0);
                    a.fill();
                });
                this.isInited = !0;
                c.debug.timeSetup && console.timeEnd("gl setup");
                return !0;
            }
            destroy() {
                const a = this.gl, b = this.shader, e = this.vbuffer;
                this.flush();
                e && e.destroy();
                b && b.destroy();
                a && (H(this.textureHandles, (b)=>{
                    b.handle && a.deleteTexture(b.handle);
                }), a.canvas.width = 1, a.canvas.height = 1);
            }
        }
        return N;
    });
    t(a, "Extensions/Boost/BoostSeries.js", [
        a["Extensions/Boost/BoostableMap.js"],
        a["Extensions/Boost/Boostables.js"],
        a["Extensions/Boost/BoostChart.js"],
        a["Core/Defaults.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"],
        a["Extensions/Boost/WGLRenderer.js"]
    ], function(a, d, g, v, t, b, u) {
        function D(a, b) {
            const c = b.boost;
            a && c && c.target && c.canvas && !m(b.chart) && a.allocateBufferForSingleSeries(b);
        }
        function e(a) {
            return ta(a && a.options && a.options.boost && a.options.boost.enabled, !0);
        }
        function B(a, b) {
            const c = a.constructor, k = a.seriesGroup || b.group;
            let e = a.chartWidth, r = a.chartHeight, h = a, q = "undefined" !== typeof SVGForeignObjectElement;
            h = m(a) ? a : b;
            const d = h.boost = h.boost || {};
            q = !1;
            ra || (ra = pa.createElement("canvas"));
            d.target || (d.canvas = ra, a.renderer.forExport || !q ? (h.renderTarget = d.target = a.renderer.image("", 0, 0, e, r).addClass("highcharts-boost-canvas").add(k), d.clear = function() {
                d.target.attr({
                    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                });
            }, d.copy = function() {
                d.resize();
                d.target.attr({
                    href: d.canvas.toDataURL("image/png")
                });
            }) : (d.targetFo = a.renderer.createElement("foreignObject").add(k), h.renderTarget = d.target = pa.createElement("canvas"), d.targetCtx = d.target.getContext("2d"), d.targetFo.element.appendChild(d.target), d.clear = function() {
                d.target.width = d.canvas.width;
                d.target.height = d.canvas.height;
            }, d.copy = function() {
                d.target.width = d.canvas.width;
                d.target.height = d.canvas.height;
                d.targetCtx.drawImage(d.canvas, 0, 0);
            }), d.resize = function() {
                e = a.chartWidth;
                r = a.chartHeight;
                (d.targetFo || d.target).attr({
                    x: 0,
                    y: 0,
                    width: e,
                    height: r
                }).css({
                    pointerEvents: "none",
                    mixedBlendMode: "normal",
                    opacity: 1
                });
                h instanceof c && h.boost.markerGroup.translate(a.plotLeft, a.plotTop);
            }, d.clipRect = a.renderer.clipRect(), (d.targetFo || d.target).clip(d.clipRect), h instanceof c && (h.boost.markerGroup = h.renderer.g().add(k).translate(b.xAxis.pos, b.yAxis.pos)));
            d.canvas.width = e;
            d.canvas.height = r;
            d.clipRect && d.clipRect.attr(n(a, h));
            d.resize();
            d.clear();
            d.wgl || (d.wgl = new u((a)=>{
                a.settings.debug.timeBufferCopy && console.time("buffer copy");
                d.copy();
                a.settings.debug.timeBufferCopy && console.timeEnd("buffer copy");
            }), d.wgl.init(d.canvas) || ya("[highcharts boost] - unable to init WebGL renderer"), d.wgl.setOptions(a.options.boost || {}), h instanceof c && d.wgl.allocateBuffer(a));
            d.wgl.setSize(e, r);
            return d.wgl;
        }
        function U(a) {
            const b = a.points;
            if (b) {
                let a, c;
                for(c = 0; c < b.length; c += 1)(a = b[c]) && a.destroyElements && a.destroyElements();
            }
            [
                "graph",
                "area",
                "tracker"
            ].forEach((b)=>{
                const c = a[b];
                c && (a[b] = c.destroy());
            });
            a.getZonesGraphs && a.getZonesGraphs([
                [
                    "graph",
                    "highcharts-graph"
                ]
            ]).forEach((b)=>{
                const c = a[b[0]];
                c && (a[b[0]] = c.destroy());
            });
        }
        function l(a, b, c, d, e, h) {
            e = e || 0;
            d = d || 3E3;
            const k = e + d;
            let r = !0;
            for(; r && e < k && e < a.length;)r = b(a[e], e), ++e;
            r && (e < a.length ? h ? l(a, b, c, d, e, h) : p.requestAnimationFrame ? p.requestAnimationFrame(function() {
                l(a, b, c, d, e);
            }) : setTimeout(l, 0, a, b, c, d, e) : c && c());
        }
        function H(a) {
            a.boost = a.boost || {
                getPoint: (b)=>c(a, b)
            };
            const b = a.boost.altered = [];
            [
                "allowDG",
                "directTouch",
                "stickyTracking"
            ].forEach((c)=>{
                b.push({
                    prop: c,
                    val: a[c],
                    own: Object.hasOwnProperty.call(a, c)
                });
            });
            a.allowDG = !1;
            a.directTouch = !1;
            a.stickyTracking = !0;
            a.finishedAnimating = !0;
            a.labelBySeries && (a.labelBySeries = a.labelBySeries.destroy());
        }
        function L(a) {
            const b = a.boost;
            b && ((b.altered || []).forEach((b)=>{
                b.own ? a[b.prop] = b.val : delete a[b.prop];
            }), b.clear && b.clear());
        }
        function z(a, b) {
            const c = a.options, e = a.xAxis && a.xAxis.options, d = a.yAxis && a.yAxis.options;
            a = a.colorAxis && a.colorAxis.options;
            return c.data.length > (c.boostThreshold || Number.MAX_VALUE) && C(d.min) && C(d.max) && (!b || C(e.min) && C(e.max)) && (!a || C(a.min) && C(a.max));
        }
        function I() {
            const a = this, b = a.chart;
            b.boost && b.boost.markerGroup === a.markerGroup && (a.markerGroup = null);
            b.hoverPoints && (b.hoverPoints = b.hoverPoints.filter(function(b) {
                return b.series === a;
            }));
            b.hoverPoint && b.hoverPoint.series === a && (b.hoverPoint = null);
        }
        function J() {
            const a = this.boost;
            a && a.canvas && a.target && (a.wgl && a.wgl.clear(), a.clear && a.clear());
        }
        function N(a) {
            const b = a.boost;
            b && b.canvas && b.target && b.wgl && !m(a.chart) && b.wgl.render(a.chart);
        }
        function c(a, b) {
            var c = a.options;
            const e = a.xAxis;
            var d = a.pointClass;
            if (b instanceof d) return b;
            c = a.xData || c.xData || a.processedXData || !1;
            d = (new d).init(a, a.options.data[b.i], c ? c[b.i] : void 0);
            d.category = ta(e.categories ? e.categories[d.x] : d.x, d.x);
            d.dist = b.dist;
            d.distX = b.distX;
            d.plotX = b.plotX;
            d.plotY = b.plotY;
            d.index = b.i;
            d.percentage = b.percentage;
            d.isInside = a.isPointInside(d);
            return d;
        }
        function ka() {
            function a(a, b) {
                const h = "undefined" === typeof c.index;
                let f;
                let q, m = !1, k = !0;
                if ("undefined" === typeof a) return !0;
                if (!h) {
                    if (L) {
                        f = a[0];
                        var r = a[1];
                    } else f = a, r = n[b];
                    u ? (L && (r = a.slice(1, 3)), m = r[0], r = r[1]) : pa && (f = a.x, r = a.stackY, m = r - a.y, q = a.percentage);
                    I || (k = (r || 0) >= w && r <= v);
                    if (f >= g && f <= p && k) {
                        if (a = d.toPixels(f, !0), la) {
                            if ("undefined" === typeof P || a === ma) {
                                u || (m = r);
                                if ("undefined" === typeof K || r > G) G = r, K = b;
                                if ("undefined" === typeof P || m < H) H = m, P = b;
                            }
                            y && a === ma || ("undefined" !== typeof P && (r = e.toPixels(G, !0), J = e.toPixels(H, !0), M(a, r, K, q), J !== r && M(a, J, P, q)), P = K = void 0, ma = a);
                        } else r = Math.ceil(e.toPixels(r, !0)), M(a, r, b, q);
                    }
                }
                return !h;
            }
            var b = this.options || {};
            const c = this.chart, d = this.xAxis, e = this.yAxis, h = b.xData || this.processedXData, n = b.yData || this.processedYData, q = b.data;
            var f = d.getExtremes();
            const g = f.min, p = f.max;
            f = e.getExtremes();
            const w = f.min, v = f.max, x = {}, la = !!this.sampling, t = b.enableMouseTracking;
            f = b.threshold;
            const u = this.pointArrayMap && "low,high" === this.pointArrayMap.join(","), pa = !!b.stacking, z = this.cropStart || 0, I = this.requireSorting, L = !h, y = "x" === b.findNearestPointBy, C = this.xData || this.options.xData || this.processedXData || !1;
            b = !1;
            let ma, J = e.getThreshold(f), H, G, P, K;
            b = B(c, this);
            c.boosted = !0;
            if (this.visible) {
                (this.points || this.graph) && U(this);
                m(c) ? (this.markerGroup && this.markerGroup !== c.boost.markerGroup && this.markerGroup.destroy(), this.markerGroup = c.boost.markerGroup, this.boost && this.boost.target && (this.renderTarget = this.boost.target = this.boost.target.destroy())) : (c.boost && this.markerGroup === c.boost.markerGroup && (this.markerGroup = void 0), this.markerGroup = this.plotGroup("markerGroup", "markers", !0, 1, c.seriesGroup));
                var T = this.points = [], M = (a, b, h, f)=>{
                    const q = C ? C[z + h] : !1, n = (a)=>{
                        c.inverted && (a = d.len - a, b = e.len - b);
                        T.push({
                            destroy: Z,
                            x: q,
                            clientX: a,
                            plotX: a,
                            plotY: b,
                            i: z + h,
                            percentage: f
                        });
                    };
                    a = Math.ceil(a);
                    F = y ? a : a + "," + b;
                    t && (x[F] ? q === C[C.length - 1] && (T.length--, n(a)) : (x[F] = !0, n(a)));
                };
                this.buildKDTree = Z;
                b && (D(b, this), b.pushSeries(this), N(this));
                var Q = b.settings;
                b = ()=>{
                    O(this, "renderedCanvas");
                    delete this.buildKDTree;
                    this.buildKDTree();
                    Q.debug.timeKDTree && console.timeEnd("kd tree building");
                };
                c.renderer.forExport || (Q.debug.timeKDTree && console.time("kd tree building"), l(pa ? this.data : h || q, a, b));
            }
        }
        function va(a) {
            let b = !0;
            this.chart.options && this.chart.options.boost && (b = "undefined" === typeof this.chart.options.boost.enabled ? !0 : this.chart.options.boost.enabled);
            if (!b || !this.boosted) return a.call(this);
            this.chart.boosted = !0;
            if (a = B(this.chart, this)) D(a, this), a.pushSeries(this);
            N(this);
        }
        function f(b, c, d) {
            function h(b) {
                const c = this.options.stacking && ("translate" === d || "generatePoints" === d);
                this.boosted && !c && e(this.chart) && "heatmap" !== this.type && "treemap" !== this.type && a[this.type] && 0 !== this.options.boostThreshold ? "render" === d && this.renderCanvas && this.renderCanvas() : b.call(this);
            }
            aa(b, d, h);
            "translate" === d && [
                "column",
                "arearange",
                "columnrange",
                "heatmap",
                "treemap"
            ].forEach(function(a) {
                c[a] && aa(c[a].prototype, d, h);
            });
        }
        function K(a) {
            return this.boosted && z(this) ? {} : a.apply(this, [].slice.call(arguments, 1));
        }
        function h(b) {
            var c = this.options.data;
            const d = (a)=>this.forceCrop ? !1 : m(this.chart) || (a ? a.length : 0) >= (this.options.boostThreshold || Number.MAX_VALUE);
            e(this.chart) && a[this.type] ? (d(c) && "heatmap" !== this.type && "treemap" !== this.type && !this.options.stacking && z(this, !0) || (b.apply(this, [].slice.call(arguments, 1)), c = this.processedXData), (this.boosted = d(c)) ? (this.options.data && this.options.data.length && (c = this.getFirstValidPoint(this.options.data), C(c) || qa(c) || ya(12, !1, this.chart)), H(this)) : L(this)) : b.apply(this, [].slice.call(arguments, 1));
        }
        function q(a) {
            const b = a.apply(this, [].slice.call(arguments, 1));
            return this.boost && b ? this.boost.getPoint(b) : b;
        }
        const { getBoostClipRect: n, isChartSeriesBoosting: m } = g, { getOptions: la } = v, { doc: pa, noop: Z, win: p } = t, { addEvent: ma, error: ya, extend: wa, fireEvent: O, isArray: qa, isNumber: C, pick: ta, wrap: aa } = b, w = [];
        let F, ra;
        return {
            compose: function(a, c, e) {
                if (b.pushUnique(w, a)) {
                    ma(a, "destroy", I);
                    ma(a, "hide", J);
                    const b = a.prototype;
                    e && (b.renderCanvas = ka);
                    aa(b, "getExtremes", K);
                    aa(b, "processData", h);
                    aa(b, "searchPoint", q);
                    [
                        "translate",
                        "generatePoints",
                        "drawTracker",
                        "drawPoints",
                        "render"
                    ].forEach((a)=>f(b, c, a));
                }
                if (b.pushUnique(w, la)) {
                    const a = la().plotOptions;
                    d.forEach((b)=>{
                        const d = a[b];
                        d && (d.boostThreshold = 5E3, d.boostData = [], c[b].prototype.fillOpacity = !0);
                    });
                }
                if (e) {
                    const { area: a, areaspline: d, bubble: h, column: f, heatmap: q, scatter: n, treemap: m } = c;
                    a && b.pushUnique(w, a) && wa(a.prototype, {
                        fill: !0,
                        fillOpacity: !0,
                        sampling: !0
                    });
                    d && b.pushUnique(w, d) && wa(d.prototype, {
                        fill: !0,
                        fillOpacity: !0,
                        sampling: !0
                    });
                    h && b.pushUnique(w, h) && (e = h.prototype, delete e.buildKDTree, aa(e, "markerAttribs", function(a) {
                        return this.boosted ? !1 : a.apply(this, [].slice.call(arguments, 1));
                    }));
                    f && b.pushUnique(w, f) && wa(f.prototype, {
                        fill: !0,
                        sampling: !0
                    });
                    n && b.pushUnique(w, n) && (n.prototype.fill = !0);
                    [
                        q,
                        m
                    ].forEach((a)=>{
                        a && b.pushUnique(w, a) && aa(a.prototype, "drawPoints", va);
                    });
                }
                return a;
            },
            destroyGraphics: U,
            eachAsync: l,
            getPoint: c
        };
    });
    t(a, "Extensions/BoostCanvas.js", [
        a["Extensions/Boost/BoostChart.js"],
        a["Extensions/Boost/BoostSeries.js"],
        a["Core/Chart/Chart.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, d, g, v, t, b, u, D) {
        const { getBoostClipRect: e, isChartSeriesBoosting: B } = a, { destroyGraphics: U } = d, { parse: l } = v, { doc: H, noop: L } = t, { seriesTypes: z } = u, { addEvent: I, extend: J, fireEvent: N, isNumber: c, merge: ka, pick: va, wrap: f } = D;
        let K;
        return function() {
            t.seriesTypes.heatmap && f(t.seriesTypes.heatmap.prototype, "drawPoints", function() {
                const a = this.chart, b = this.getContext(), c = this.chart.inverted, d = this.xAxis, e = this.yAxis;
                b ? (this.points.forEach(function(h) {
                    let f = h.plotY;
                    if ("undefined" !== typeof f && !isNaN(f) && null !== h.y && b) {
                        const { x: f = 0, y: n = 0, width: q = 0, height: m = 0 } = h.shapeArgs || {};
                        h = a.styledMode ? h.series.colorAttribs(h) : h.series.pointAttribs(h);
                        b.fillStyle = h.fill;
                        c ? b.fillRect(e.len - n + d.left, d.len - f + e.top, -m, -q) : b.fillRect(f + d.left, n + e.top, q, m);
                    }
                }), this.canvasToSVG()) : this.chart.showLoading("Your browser doesn't support HTML5 canvas, <br>please use a modern browser");
            });
            J(b.prototype, {
                getContext: function() {
                    const a = this.chart, b = B(a) ? a : this, c = b === a ? a.seriesGroup : a.seriesGroup || this.group;
                    let d = a.chartWidth, g = a.chartHeight, l, t = function(a, b, c, d, e, h, f) {
                        a.call(this, c, b, d, e, h, f);
                    };
                    const p = b.boost = b.boost || {};
                    l = p.targetCtx;
                    p.canvas || (p.canvas = H.createElement("canvas"), p.target = a.renderer.image("", 0, 0, d, g).addClass("highcharts-boost-canvas").add(c), l = p.targetCtx = p.canvas.getContext("2d"), a.inverted && [
                        "moveTo",
                        "lineTo",
                        "rect",
                        "arc"
                    ].forEach((a)=>{
                        f(l, a, t);
                    }), p.copy = function() {
                        p.target.attr({
                            href: p.canvas.toDataURL("image/png")
                        });
                    }, p.clear = function() {
                        l.clearRect(0, 0, p.canvas.width, p.canvas.height);
                        b === p.target && p.target.attr({
                            href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                        });
                    }, p.clipRect = a.renderer.clipRect(), p.target.clip(p.clipRect));
                    p.canvas.width !== d && (p.canvas.width = d);
                    p.canvas.height !== g && (p.canvas.height = g);
                    p.target.attr({
                        x: 0,
                        y: 0,
                        width: d,
                        height: g,
                        style: "pointer-events: none",
                        href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                    });
                    p.clipRect && p.clipRect.attr(e(a, b));
                    return l;
                },
                canvasToSVG: function() {
                    B(this.chart) ? this.boost && this.boost.clear && this.boost.clear() : this.boost && this.boost.copy ? this.boost.copy() : this.chart.boost && this.chart.boost.copy && this.chart.boost.copy();
                },
                cvsLineTo: function(a, b, c) {
                    a.lineTo(b, c);
                },
                renderCanvas: function() {
                    let a = this, b = a.options, e = a.chart, f = this.xAxis, g = this.yAxis;
                    var t = (e.options.boost || {}).timeRendering || !1;
                    let u, p = 0;
                    var z = a.processedXData;
                    let B = a.processedYData, H = b.data;
                    var O = f.getExtremes();
                    let qa = O.min, C = O.max;
                    O = g.getExtremes();
                    let ta = O.min, aa = O.max, w = {}, F, ra = !!a.sampling, k, r = b.marker && b.marker.radius, V = this.cvsDrawPoint, ba = b.lineWidth ? this.cvsLineTo : void 0, sa = r && 1 >= r ? this.cvsMarkerSquare : this.cvsMarkerCircle, ia = this.cvsStrokeBatch || 1E3, ua = b.enableMouseTracking, ca;
                    O = b.threshold;
                    let R = g.getThreshold(O), W = c(O), za = R, X = this.fill, A = a.pointArrayMap && "low,high" === a.pointArrayMap.join(","), x = !!b.stacking, Aa = a.cropStart || 0;
                    O = e.options.loading;
                    let E = a.requireSorting, Y, da = b.connectNulls, ea = !z, xa, ja, y, fa, na, S = x ? a.data : z || H, ha = a.fillOpacity ? v.parse(a.color).setOpacity(va(b.fillOpacity, .75)).get() : a.color, G = function() {
                        X ? (u.fillStyle = ha, u.fill()) : (u.strokeStyle = a.color, u.lineWidth = b.lineWidth, u.stroke());
                    }, P = function(b, c, d, f) {
                        0 === p && (u.beginPath(), ba && (u.lineJoin = "round"));
                        e.scroller && "highcharts-navigator-series" === a.options.className ? (c += e.scroller.top, d && (d += e.scroller.top)) : c += e.plotTop;
                        b += e.plotLeft;
                        Y ? u.moveTo(b, c) : V ? V(u, b, c, d, ca) : ba ? ba(u, b, c) : sa && sa.call(a, u, b, c, r, f);
                        p += 1;
                        p === ia && (G(), p = 0);
                        ca = {
                            clientX: b,
                            plotY: c,
                            yBottom: d
                        };
                    }, oa = "x" === b.findNearestPointBy, T = this.xData || this.options.xData || this.processedXData || !1, M = function(a, b, c) {
                        na = oa ? a : a + "," + b;
                        ua && !w[na] && (w[na] = !0, e.inverted && (a = f.len - a, b = g.len - b), k.push({
                            x: T ? T[Aa + c] : !1,
                            clientX: a,
                            plotX: a,
                            plotY: b,
                            i: Aa + c
                        }));
                    };
                    z = this.boost || {};
                    z.target && z.target.attr({
                        href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                    });
                    (this.points || this.graph) && U(this);
                    a.plotGroup("group", "series", a.visible ? "visible" : "hidden", b.zIndex, e.seriesGroup);
                    a.markerGroup = a.group;
                    I(a, "destroy", function() {
                        a.markerGroup = null;
                    });
                    k = this.points = [];
                    u = this.getContext();
                    a.buildKDTree = L;
                    z.clear && z.clear();
                    this.visible && (99999 < H.length && (e.options.loading = ka(O, {
                        labelStyle: {
                            backgroundColor: l("#ffffff").setOpacity(.75).get(),
                            padding: "1em",
                            borderRadius: "0.5em"
                        },
                        style: {
                            backgroundColor: "none",
                            opacity: 1
                        }
                    }), D.clearTimeout(K), e.showLoading("Drawing..."), e.options.loading = O), t && console.time("canvas rendering"), d.eachAsync(S, function(b, c) {
                        let d, h = !1, m = !1, q = !1, n = !1, p = "undefined" === typeof e.index, r = !0;
                        if (!p) {
                            if (ea) {
                                var l = b[0];
                                var k = b[1];
                                S[c + 1] && (q = S[c + 1][0]);
                                S[c - 1] && (n = S[c - 1][0]);
                            } else l = b, k = B[c], S[c + 1] && (q = S[c + 1]), S[c - 1] && (n = S[c - 1]);
                            q && q >= qa && q <= C && (h = !0);
                            n && n >= qa && n <= C && (m = !0);
                            A ? (ea && (k = b.slice(1, 3)), d = k[0], k = k[1]) : x && (l = b.x, k = b.stackY, d = k - b.y);
                            b = null === k;
                            E || (r = k >= ta && k <= aa);
                            if (!b && (l >= qa && l <= C && r || h || m)) {
                                if (l = Math.round(f.toPixels(l, !0)), ra) {
                                    if ("undefined" === typeof y || l === F) {
                                        A || (d = k);
                                        if ("undefined" === typeof fa || k > ja) ja = k, fa = c;
                                        if ("undefined" === typeof y || d < xa) xa = d, y = c;
                                    }
                                    l !== F && ("undefined" !== typeof y && (k = g.toPixels(ja, !0), R = g.toPixels(xa, !0), P(l, W ? Math.min(k, za) : k, W ? Math.max(R, za) : R, c), M(l, k, fa), R !== k && M(l, R, y)), y = fa = void 0, F = l);
                                } else k = Math.round(g.toPixels(k, !0)), P(l, k, R, c), M(l, k, c);
                            }
                            Y = b && !da;
                            0 === c % 5E4 && (a.boost && a.boost.copy ? a.boost.copy() : a.chart.boost && a.chart.boost.copy && a.chart.boost.copy());
                        }
                        return !p;
                    }, function() {
                        const b = e.loadingDiv, c = e.loadingShown;
                        G();
                        a.canvasToSVG();
                        t && console.timeEnd("canvas rendering");
                        N(a, "renderedCanvas");
                        c && (J(b.style, {
                            transition: "opacity 250ms",
                            opacity: 0
                        }), e.loadingShown = !1, K = setTimeout(function() {
                            b.parentNode && b.parentNode.removeChild(b);
                            e.loadingDiv = e.loadingSpan = null;
                        }, 250));
                        delete a.buildKDTree;
                        a.buildKDTree();
                    }, e.renderer.forExport ? Number.MAX_VALUE : void 0));
                }
            });
            z.scatter.prototype.cvsMarkerCircle = function(a, b, c, d) {
                a.moveTo(b, c);
                a.arc(b, c, d, 0, 2 * Math.PI, !1);
            };
            z.scatter.prototype.cvsMarkerSquare = function(a, b, c, d) {
                a.rect(b - d, c - d, 2 * d, 2 * d);
            };
            z.scatter.prototype.fill = !0;
            z.bubble && (z.bubble.prototype.cvsMarkerCircle = function(a, b, c, d, e) {
                a.moveTo(b, c);
                a.arc(b, c, this.radii && this.radii[e], 0, 2 * Math.PI, !1);
            }, z.bubble.prototype.cvsStrokeBatch = 1);
            J(z.area.prototype, {
                cvsDrawPoint: function(a, b, c, d, e) {
                    e && b !== e.clientX && (a.moveTo(e.clientX, e.yBottom), a.lineTo(e.clientX, e.plotY), a.lineTo(b, c), a.lineTo(b, d));
                },
                fill: !0,
                fillOpacity: !0,
                sampling: !0
            });
            J(z.column.prototype, {
                cvsDrawPoint: function(a, b, c, d) {
                    a.rect(b - 1, c, 1, d - c);
                },
                fill: !0,
                sampling: !0
            });
            g.prototype.callbacks.push(function(a) {
                I(a, "predraw", function() {
                    const a = this.boost || {};
                    a.target && a.target.attr({
                        href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
                    });
                    a.canvas && a.canvas.getContext("2d").clearRect(0, 0, a.canvas.width, a.canvas.height);
                });
                I(a, "render", function() {
                    a.boost && a.boost.copy && a.boost.copy();
                });
            });
        };
    });
    t(a, "Extensions/Boost/NamedColors.js", [], function() {
        return {
            defaultHTMLColorMap: {
                aliceblue: "#f0f8ff",
                antiquewhite: "#faebd7",
                aqua: "#00ffff",
                aquamarine: "#7fffd4",
                azure: "#f0ffff",
                beige: "#f5f5dc",
                bisque: "#ffe4c4",
                blanchedalmond: "#ffebcd",
                blue: "#0000ff",
                blueviolet: "#8a2be2",
                brown: "#a52a2a",
                burlywood: "#deb887",
                cadetblue: "#5f9ea0",
                chartreuse: "#7fff00",
                chocolate: "#d2691e",
                coral: "#ff7f50",
                cornflowerblue: "#6495ed",
                cornsilk: "#fff8dc",
                crimson: "#dc143c",
                cyan: "#00ffff",
                darkblue: "#00008b",
                darkcyan: "#008b8b",
                darkgoldenrod: "#b8860b",
                darkgray: "#a9a9a9",
                darkgreen: "#006400",
                darkkhaki: "#bdb76b",
                darkmagenta: "#8b008b",
                darkolivegreen: "#556b2f",
                darkorange: "#ff8c00",
                darkorchid: "#9932cc",
                darkred: "#8b0000",
                darksalmon: "#e9967a",
                darkseagreen: "#8fbc8f",
                darkslateblue: "#483d8b",
                darkslategray: "#2f4f4f",
                darkturquoise: "#00ced1",
                darkviolet: "#9400d3",
                deeppink: "#ff1493",
                deepskyblue: "#00bfff",
                dimgray: "#696969",
                dodgerblue: "#1e90ff",
                feldspar: "#d19275",
                firebrick: "#b22222",
                floralwhite: "#fffaf0",
                forestgreen: "#228b22",
                fuchsia: "#ff00ff",
                gainsboro: "#dcdcdc",
                ghostwhite: "#f8f8ff",
                gold: "#ffd700",
                goldenrod: "#daa520",
                gray: "#808080",
                grey: "#808080",
                green: "#008000",
                greenyellow: "#adff2f",
                honeydew: "#f0fff0",
                hotpink: "#ff69b4",
                indianred: "#cd5c5c",
                indigo: "#4b0082",
                ivory: "#fffff0",
                khaki: "#f0e68c",
                lavender: "#e6e6fa",
                lavenderblush: "#fff0f5",
                lawngreen: "#7cfc00",
                lemonchiffon: "#fffacd",
                lightblue: "#add8e6",
                lightcoral: "#f08080",
                lightcyan: "#e0ffff",
                lightgoldenrodyellow: "#fafad2",
                lightgrey: "#d3d3d3",
                lightgreen: "#90ee90",
                lightpink: "#ffb6c1",
                lightsalmon: "#ffa07a",
                lightseagreen: "#20b2aa",
                lightskyblue: "#87cefa",
                lightslateblue: "#8470ff",
                lightslategray: "#778899",
                lightsteelblue: "#b0c4de",
                lightyellow: "#ffffe0",
                lime: "#00ff00",
                limegreen: "#32cd32",
                linen: "#faf0e6",
                magenta: "#ff00ff",
                maroon: "#800000",
                mediumaquamarine: "#66cdaa",
                mediumblue: "#0000cd",
                mediumorchid: "#ba55d3",
                mediumpurple: "#9370d8",
                mediumseagreen: "#3cb371",
                mediumslateblue: "#7b68ee",
                mediumspringgreen: "#00fa9a",
                mediumturquoise: "#48d1cc",
                mediumvioletred: "#c71585",
                midnightblue: "#191970",
                mintcream: "#f5fffa",
                mistyrose: "#ffe4e1",
                moccasin: "#ffe4b5",
                navajowhite: "#ffdead",
                navy: "#000080",
                oldlace: "#fdf5e6",
                olive: "#808000",
                olivedrab: "#6b8e23",
                orange: "#ffa500",
                orangered: "#ff4500",
                orchid: "#da70d6",
                palegoldenrod: "#eee8aa",
                palegreen: "#98fb98",
                paleturquoise: "#afeeee",
                palevioletred: "#d87093",
                papayawhip: "#ffefd5",
                peachpuff: "#ffdab9",
                peru: "#cd853f",
                pink: "#ffc0cb",
                plum: "#dda0dd",
                powderblue: "#b0e0e6",
                purple: "#800080",
                red: "#ff0000",
                rosybrown: "#bc8f8f",
                royalblue: "#4169e1",
                saddlebrown: "#8b4513",
                salmon: "#fa8072",
                sandybrown: "#f4a460",
                seagreen: "#2e8b57",
                seashell: "#fff5ee",
                sienna: "#a0522d",
                silver: "#c0c0c0",
                skyblue: "#87ceeb",
                slateblue: "#6a5acd",
                slategray: "#708090",
                snow: "#fffafa",
                springgreen: "#00ff7f",
                steelblue: "#4682b4",
                tan: "#d2b48c",
                teal: "#008080",
                thistle: "#d8bfd8",
                tomato: "#ff6347",
                turquoise: "#40e0d0",
                violet: "#ee82ee",
                violetred: "#d02090",
                wheat: "#f5deb3",
                whitesmoke: "#f5f5f5",
                yellow: "#ffff00",
                yellowgreen: "#9acd32"
            }
        };
    });
    t(a, "Extensions/Boost/Boost.js", [
        a["Extensions/Boost/BoostChart.js"],
        a["Extensions/Boost/BoostSeries.js"],
        a["Core/Globals.js"],
        a["Extensions/BoostCanvas.js"],
        a["Extensions/Boost/NamedColors.js"],
        a["Core/Utilities.js"]
    ], function(a, d, g, t, B, b) {
        function u() {
            let a, b = !1;
            if ("undefined" !== typeof v.WebGLRenderingContext) {
                a = e.createElement("canvas");
                for(let d = 0; d < l.length; ++d)try {
                    if (b = a.getContext(l[d]), "undefined" !== typeof b && null !== b) return !0;
                } catch (I) {}
            }
            return !1;
        }
        const { win: v, doc: e } = g, { error: U } = b, Da = [], l = [
            "webgl",
            "experimental-webgl",
            "moz-webgl",
            "webkit-3d"
        ];
        g = {
            compose: function(e, g, l, v) {
                const z = u();
                z || ("undefined" !== typeof t ? t() : U(26));
                v && b.pushUnique(Da, v) && (v.names = Object.assign(Object.assign({}, v.names), B.defaultHTMLColorMap));
                a.compose(e, z);
                d.compose(g, l, z);
            },
            hasWebGLSupport: u
        };
        "";
        return g;
    });
    t(a, "masters/modules/boost.src.js", [
        a["Core/Globals.js"],
        a["Extensions/Boost/Boost.js"]
    ], function(a, d) {
        a.hasWebGLSupport = d.hasWebGLSupport;
        d.compose(a.Chart, a.Series, a.seriesTypes, a.Color);
    });
});

});

parcelRegister("b6McJ", function(module, exports) {
/*
 Highstock JS v11.1.0 (2023-06-05)

 Indicator series type for Highcharts Stock

 (c) 2010-2021 Pawel Fus, Sebastian Bochan

 License: www.highcharts.com/license
*/ "use strict";
var $8165a59d4607f6db$var$$jscomp = $8165a59d4607f6db$var$$jscomp || {};
$8165a59d4607f6db$var$$jscomp.scope = {};
$8165a59d4607f6db$var$$jscomp.arrayIteratorImpl = function(a) {
    var b = 0;
    return function() {
        return b < a.length ? {
            done: !1,
            value: a[b++]
        } : {
            done: !0
        };
    };
};
$8165a59d4607f6db$var$$jscomp.arrayIterator = function(a) {
    return {
        next: $8165a59d4607f6db$var$$jscomp.arrayIteratorImpl(a)
    };
};
$8165a59d4607f6db$var$$jscomp.ASSUME_ES5 = !1;
$8165a59d4607f6db$var$$jscomp.ASSUME_NO_NATIVE_MAP = !1;
$8165a59d4607f6db$var$$jscomp.ASSUME_NO_NATIVE_SET = !1;
$8165a59d4607f6db$var$$jscomp.SIMPLE_FROUND_POLYFILL = !1;
$8165a59d4607f6db$var$$jscomp.ISOLATE_POLYFILLS = !1;
$8165a59d4607f6db$var$$jscomp.defineProperty = $8165a59d4607f6db$var$$jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
    if (a == Array.prototype || a == Object.prototype) return a;
    a[b] = c.value;
    return a;
};
$8165a59d4607f6db$var$$jscomp.getGlobal = function(a) {
    a = [
        "object" == typeof globalThis && globalThis,
        a,
        "object" == typeof window && window,
        "object" == typeof self && self,
        "object" == typeof $parcel$global && $parcel$global
    ];
    for(var b = 0; b < a.length; ++b){
        var c = a[b];
        if (c && c.Math == Math) return c;
    }
    throw Error("Cannot find global object");
};
$8165a59d4607f6db$var$$jscomp.global = $8165a59d4607f6db$var$$jscomp.getGlobal(module.exports);
$8165a59d4607f6db$var$$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";
$8165a59d4607f6db$var$$jscomp.initSymbol = function() {
    $8165a59d4607f6db$var$$jscomp.initSymbol = function() {};
    $8165a59d4607f6db$var$$jscomp.global.Symbol || ($8165a59d4607f6db$var$$jscomp.global.Symbol = $8165a59d4607f6db$var$$jscomp.Symbol);
};
$8165a59d4607f6db$var$$jscomp.SymbolClass = function(a, b) {
    this.$jscomp$symbol$id_ = a;
    $8165a59d4607f6db$var$$jscomp.defineProperty(this, "description", {
        configurable: !0,
        writable: !0,
        value: b
    });
};
$8165a59d4607f6db$var$$jscomp.SymbolClass.prototype.toString = function() {
    return this.$jscomp$symbol$id_;
};
$8165a59d4607f6db$var$$jscomp.Symbol = function() {
    function a(c) {
        if (this instanceof a) throw new TypeError("Symbol is not a constructor");
        return new $8165a59d4607f6db$var$$jscomp.SymbolClass($8165a59d4607f6db$var$$jscomp.SYMBOL_PREFIX + (c || "") + "_" + b++, c);
    }
    var b = 0;
    return a;
}();
$8165a59d4607f6db$var$$jscomp.initSymbolIterator = function() {
    $8165a59d4607f6db$var$$jscomp.initSymbol();
    var a = $8165a59d4607f6db$var$$jscomp.global.Symbol.iterator;
    a || (a = $8165a59d4607f6db$var$$jscomp.global.Symbol.iterator = $8165a59d4607f6db$var$$jscomp.global.Symbol("Symbol.iterator"));
    "function" != typeof Array.prototype[a] && $8165a59d4607f6db$var$$jscomp.defineProperty(Array.prototype, a, {
        configurable: !0,
        writable: !0,
        value: function() {
            return $8165a59d4607f6db$var$$jscomp.iteratorPrototype($8165a59d4607f6db$var$$jscomp.arrayIteratorImpl(this));
        }
    });
    $8165a59d4607f6db$var$$jscomp.initSymbolIterator = function() {};
};
$8165a59d4607f6db$var$$jscomp.initSymbolAsyncIterator = function() {
    $8165a59d4607f6db$var$$jscomp.initSymbol();
    var a = $8165a59d4607f6db$var$$jscomp.global.Symbol.asyncIterator;
    a || (a = $8165a59d4607f6db$var$$jscomp.global.Symbol.asyncIterator = $8165a59d4607f6db$var$$jscomp.global.Symbol("Symbol.asyncIterator"));
    $8165a59d4607f6db$var$$jscomp.initSymbolAsyncIterator = function() {};
};
$8165a59d4607f6db$var$$jscomp.iteratorPrototype = function(a) {
    $8165a59d4607f6db$var$$jscomp.initSymbolIterator();
    a = {
        next: a
    };
    a[$8165a59d4607f6db$var$$jscomp.global.Symbol.iterator] = function() {
        return this;
    };
    return a;
};
$8165a59d4607f6db$var$$jscomp.iteratorFromArray = function(a, b) {
    $8165a59d4607f6db$var$$jscomp.initSymbolIterator();
    a instanceof String && (a += "");
    var c = 0, d = {
        next: function() {
            if (c < a.length) {
                var e = c++;
                return {
                    value: b(e, a[e]),
                    done: !1
                };
            }
            d.next = function() {
                return {
                    done: !0,
                    value: void 0
                };
            };
            return d.next();
        }
    };
    d[Symbol.iterator] = function() {
        return d;
    };
    return d;
};
$8165a59d4607f6db$var$$jscomp.polyfills = {};
$8165a59d4607f6db$var$$jscomp.propertyToPolyfillSymbol = {};
$8165a59d4607f6db$var$$jscomp.POLYFILL_PREFIX = "$jscp$";
$8165a59d4607f6db$var$$jscomp.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
var $8165a59d4607f6db$var$$jscomp$lookupPolyfilledValue = function(a, b) {
    var c = $8165a59d4607f6db$var$$jscomp.propertyToPolyfillSymbol[b];
    if (null == c) return a[b];
    c = a[c];
    return void 0 !== c ? c : a[b];
};
$8165a59d4607f6db$var$$jscomp.polyfill = function(a, b, c, d) {
    b && ($8165a59d4607f6db$var$$jscomp.ISOLATE_POLYFILLS ? $8165a59d4607f6db$var$$jscomp.polyfillIsolated(a, b, c, d) : $8165a59d4607f6db$var$$jscomp.polyfillUnisolated(a, b, c, d));
};
$8165a59d4607f6db$var$$jscomp.polyfillUnisolated = function(a, b, c, d) {
    c = $8165a59d4607f6db$var$$jscomp.global;
    a = a.split(".");
    for(d = 0; d < a.length - 1; d++){
        var e = a[d];
        e in c || (c[e] = {});
        c = c[e];
    }
    a = a[a.length - 1];
    d = c[a];
    b = b(d);
    b != d && null != b && $8165a59d4607f6db$var$$jscomp.defineProperty(c, a, {
        configurable: !0,
        writable: !0,
        value: b
    });
};
$8165a59d4607f6db$var$$jscomp.polyfillIsolated = function(a, b, c, d) {
    var e = a.split(".");
    a = 1 === e.length;
    d = e[0];
    d = !a && d in $8165a59d4607f6db$var$$jscomp.polyfills ? $8165a59d4607f6db$var$$jscomp.polyfills : $8165a59d4607f6db$var$$jscomp.global;
    for(var m = 0; m < e.length - 1; m++){
        var t = e[m];
        t in d || (d[t] = {});
        d = d[t];
    }
    e = e[e.length - 1];
    c = $8165a59d4607f6db$var$$jscomp.IS_SYMBOL_NATIVE && "es6" === c ? d[e] : null;
    b = b(c);
    null != b && (a ? $8165a59d4607f6db$var$$jscomp.defineProperty($8165a59d4607f6db$var$$jscomp.polyfills, e, {
        configurable: !0,
        writable: !0,
        value: b
    }) : b !== c && ($8165a59d4607f6db$var$$jscomp.propertyToPolyfillSymbol[e] = $8165a59d4607f6db$var$$jscomp.IS_SYMBOL_NATIVE ? $8165a59d4607f6db$var$$jscomp.global.Symbol(e) : $8165a59d4607f6db$var$$jscomp.POLYFILL_PREFIX + e, e = $8165a59d4607f6db$var$$jscomp.propertyToPolyfillSymbol[e], $8165a59d4607f6db$var$$jscomp.defineProperty(d, e, {
        configurable: !0,
        writable: !0,
        value: b
    })));
};
$8165a59d4607f6db$var$$jscomp.polyfill("Array.prototype.values", function(a) {
    return a ? a : function() {
        return $8165a59d4607f6db$var$$jscomp.iteratorFromArray(this, function(a, c) {
            return c;
        });
    };
}, "es8", "es3");
(function(a) {
    (0, module.exports) ? (a["default"] = a, module.exports = a) : "function" === typeof define && define.amd ? define("highcharts/indicators/indicators", [
        "highcharts",
        "highcharts/modules/stock"
    ], function(b) {
        a(b);
        a.Highcharts = b;
        return a;
    }) : a("undefined" !== typeof Highcharts ? Highcharts : void 0);
})(function(a) {
    function b(a, b, e, m) {
        a.hasOwnProperty(b) || (a[b] = m.apply(null, e), "function" === typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: b,
                module: a[b]
            }
        })));
    }
    a = a ? a._modules : {};
    b(a, "Stock/Indicators/SMA/SMAIndicator.js", [
        a["Core/Chart/Chart.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, b, e) {
        const { line: c } = b.seriesTypes, { addEvent: d, fireEvent: v, error: u, extend: g, isArray: w, merge: n, pick: q, splat: h } = e;
        class k extends c {
            constructor(){
                super(...arguments);
                this.points = this.options = this.linkedParent = this.dataEventsToUnbind = this.data = void 0;
            }
            destroy() {
                this.dataEventsToUnbind.forEach(function(a) {
                    a();
                });
                super.destroy.apply(this, arguments);
            }
            getName() {
                const a = [];
                let b = this.name;
                b || ((this.nameComponents || []).forEach(function(b, c) {
                    a.push(this.options.params[b] + q(this.nameSuffixes[c], ""));
                }, this), b = (this.nameBase || this.type.toUpperCase()) + (this.nameComponents ? " (" + a.join(", ") + ")" : ""));
                return b;
            }
            getValues(a, b) {
                const c = b.period, d = a.xData;
                a = a.yData;
                const e = a.length, n = [], g = [], p = [];
                let l = -1, h = 0, k, q = 0;
                if (!(d.length < c)) {
                    for(w(a[0]) && (l = b.index ? b.index : 0); h < c - 1;)q += 0 > l ? a[h] : a[h][l], h++;
                    for(b = h; b < e; b++)q += 0 > l ? a[b] : a[b][l], k = [
                        d[b],
                        q / c
                    ], n.push(k), g.push(k[0]), p.push(k[1]), q -= 0 > l ? a[b - h] : a[b - h][l];
                    return {
                        values: n,
                        xData: g,
                        yData: p
                    };
                }
            }
            init(b, c) {
                const f = this;
                super.init.call(f, b, c);
                c = d(a, "afterLinkSeries", function({ isUpdating: a }) {
                    if (!a) {
                        if (a = !!f.dataEventsToUnbind.length, f.linkedParent) {
                            if (a || (f.dataEventsToUnbind.push(d(f.linkedParent, "updatedData", function() {
                                f.recalculateValues();
                            })), f.calculateOn.xAxis && f.dataEventsToUnbind.push(d(f.linkedParent.xAxis, f.calculateOn.xAxis, function() {
                                f.recalculateValues();
                            }))), "init" === f.calculateOn.chart) f.processedYData || f.recalculateValues();
                            else if (!a) {
                                const a = d(f.chart, f.calculateOn.chart, function() {
                                    f.recalculateValues();
                                    a();
                                });
                            }
                        } else return u("Series " + f.options.linkedTo + " not found! Check `linkedTo`.", !1, b);
                    }
                }, {
                    order: 0
                });
                f.dataEventsToUnbind = [];
                f.eventsToUnbind.push(c);
            }
            recalculateValues() {
                const a = [], b = this.points || [];
                var c = (this.xData || []).length, d = {
                    values: [],
                    xData: [],
                    yData: []
                };
                let e = !0;
                let n;
                d = this.linkedParent.options && this.linkedParent.yData && this.linkedParent.yData.length ? this.getValues(this.linkedParent, this.options.params) || d : d;
                if (c && !this.hasGroupedData && this.visible && this.points) {
                    if (this.cropped) {
                        if (this.xAxis) {
                            var g = this.xAxis.min;
                            n = this.xAxis.max;
                        }
                        c = this.cropData(d.xData, d.yData, g, n);
                        for(g = 0; g < c.xData.length; g++)a.push([
                            c.xData[g]
                        ].concat(h(c.yData[g])));
                        c = d.xData.indexOf(this.xData[0]);
                        g = d.xData.indexOf(this.xData[this.xData.length - 1]);
                        -1 === c && g === d.xData.length - 2 && a[0][0] === b[0].x && a.shift();
                        this.updateData(a);
                    } else if (this.updateAllPoints || d.xData.length !== c - 1 && d.xData.length !== c + 1) e = !1, this.updateData(d.values);
                }
                e && (this.xData = d.xData, this.yData = d.yData, this.options.data = d.values);
                this.calculateOn.xAxis && this.processedXData && (delete this.processedXData, this.isDirty = !0, this.redraw());
                this.isDirtyData = !!this.linkedSeries.length;
                v(this, "updatedData");
            }
            processData() {
                const a = this.options.compareToMain, b = this.linkedParent;
                super.processData.apply(this, arguments);
                this.dataModify && b && b.dataModify && b.dataModify.compareValue && a && (this.dataModify.compareValue = b.dataModify.compareValue);
            }
        }
        k.defaultOptions = n(c.defaultOptions, {
            name: void 0,
            tooltip: {
                valueDecimals: 4
            },
            linkedTo: void 0,
            compareToMain: !1,
            params: {
                index: 3,
                period: 14
            }
        });
        g(k.prototype, {
            calculateOn: {
                chart: "init"
            },
            hasDerivedData: !0,
            nameComponents: [
                "period"
            ],
            nameSuffixes: [],
            useCommonDataGrouping: !0
        });
        b.registerSeriesType("sma", k);
        "";
        return k;
    });
    b(a, "Stock/Indicators/EMA/EMAIndicator.js", [
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, b) {
        const { sma: c } = a.seriesTypes, { correctFloat: d, isArray: t, merge: v } = b;
        class u extends c {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            accumulatePeriodPoints(a, b, c) {
                let d = 0, e = 0, g;
                for(; e < a;)g = 0 > b ? c[e] : c[e][b], d += g, e++;
                return d;
            }
            calculateEma(a, b, c, e, h, k, p) {
                a = a[c - 1];
                b = 0 > k ? b[c - 1] : b[c - 1][k];
                e = "undefined" === typeof h ? p : d(b * e + h * (1 - e));
                return [
                    a,
                    e
                ];
            }
            getValues(a, b) {
                var c = b.period;
                const d = a.xData, e = (a = a.yData) ? a.length : 0, g = 2 / (c + 1), p = [], l = [], f = [];
                let m = -1;
                if (!(e < c)) {
                    t(a[0]) && (m = b.index ? b.index : 0);
                    b = this.accumulatePeriodPoints(c, m, a);
                    for(b /= c; c < e + 1; c++){
                        var r = this.calculateEma(d, a, c, g, r, m, b);
                        p.push(r);
                        l.push(r[0]);
                        f.push(r[1]);
                        r = r[1];
                    }
                    return {
                        values: p,
                        xData: l,
                        yData: f
                    };
                }
            }
        }
        u.defaultOptions = v(c.defaultOptions, {
            params: {
                index: 3,
                period: 9
            }
        });
        a.registerSeriesType("ema", u);
        "";
        return u;
    });
    b(a, "masters/indicators/indicators.src.js", [], function() {});
});

});

parcelRegister("4N9yf", function(module, exports) {
"use strict";
(function(a) {
    (0, module.exports) ? (a["default"] = a, module.exports = a) : "function" === typeof define && define.amd ? define([
        "highcharts"
    ], function(c) {
        a(c);
        a.Highcharts = c;
        return a;
    }) : a("undefined" !== typeof Highcharts ? Highcharts : void 0);
})(function(a) {
    (function(a, b, d, e) {
        a.hasOwnProperty(b) || (a[b] = e.apply(null, d), "function" === typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: b,
                module: a[b]
            }
        })));
    })(a ? a._modules : {}, "masters/indicators/ema.src.js", [], function() {});
});

});

parcelRegister("7bZYo", function(module, exports) {
"use strict";
function $53c9a209c5ff86ba$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $53c9a209c5ff86ba$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $53c9a209c5ff86ba$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $53c9a209c5ff86ba$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53c9a209c5ff86ba$var$_react = $53c9a209c5ff86ba$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $53c9a209c5ff86ba$var$_propTypes = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("bisEj")));

var $53c9a209c5ff86ba$var$_Calendar = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("lvReq")));

var $75YCw = parcelRequire("75YCw");

var $1iPS5 = parcelRequire("1iPS5");

var $53c9a209c5ff86ba$var$_max = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("8YdnK")));

var $53c9a209c5ff86ba$var$_isWithinInterval = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("dJtzp")));

var $53c9a209c5ff86ba$var$_min = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("2aONL")));

var $53c9a209c5ff86ba$var$_addDays = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("czacj")));

var $53c9a209c5ff86ba$var$_differenceInCalendarDays = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("irUS8")));

var $53c9a209c5ff86ba$var$_isBefore = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("1x9Sk")));

var $53c9a209c5ff86ba$var$_classnames = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("eH0la")));

var $53c9a209c5ff86ba$var$_styles = $53c9a209c5ff86ba$var$_interopRequireDefault((parcelRequire("lnHjO")));
function $53c9a209c5ff86ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $53c9a209c5ff86ba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($53c9a209c5ff86ba$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $53c9a209c5ff86ba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $53c9a209c5ff86ba$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $53c9a209c5ff86ba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $53c9a209c5ff86ba$var$_extends() {
    $53c9a209c5ff86ba$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $53c9a209c5ff86ba$var$_extends.apply(this, arguments);
}
function $53c9a209c5ff86ba$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $53c9a209c5ff86ba$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $53c9a209c5ff86ba$var$ownKeys(Object(source), true).forEach(function(key) {
            $53c9a209c5ff86ba$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $53c9a209c5ff86ba$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $53c9a209c5ff86ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $53c9a209c5ff86ba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53c9a209c5ff86ba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $53c9a209c5ff86ba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53c9a209c5ff86ba$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $53c9a209c5ff86ba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $53c9a209c5ff86ba$var$_setPrototypeOf(subClass, superClass);
}
function $53c9a209c5ff86ba$var$_setPrototypeOf(o, p) {
    $53c9a209c5ff86ba$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $53c9a209c5ff86ba$var$_setPrototypeOf(o, p);
}
function $53c9a209c5ff86ba$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $53c9a209c5ff86ba$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $53c9a209c5ff86ba$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $53c9a209c5ff86ba$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $53c9a209c5ff86ba$var$_possibleConstructorReturn(this, result);
    };
}
function $53c9a209c5ff86ba$var$_possibleConstructorReturn(self, call) {
    if (call && ($53c9a209c5ff86ba$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $53c9a209c5ff86ba$var$_assertThisInitialized(self);
}
function $53c9a209c5ff86ba$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $53c9a209c5ff86ba$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $53c9a209c5ff86ba$var$_getPrototypeOf(o) {
    $53c9a209c5ff86ba$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $53c9a209c5ff86ba$var$_getPrototypeOf(o);
}
function $53c9a209c5ff86ba$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $53c9a209c5ff86ba$var$DateRange = /*#__PURE__*/ function(_Component) {
    $53c9a209c5ff86ba$var$_inherits(DateRange, _Component);
    var _super = $53c9a209c5ff86ba$var$_createSuper(DateRange);
    function DateRange(props, context) {
        var _this;
        $53c9a209c5ff86ba$var$_classCallCheck(this, DateRange);
        _this = _super.call(this, props, context);
        $53c9a209c5ff86ba$var$_defineProperty($53c9a209c5ff86ba$var$_assertThisInitialized(_this), "calcNewSelection", function(value) {
            var isSingleValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
            var _this$props = _this.props, ranges = _this$props.ranges, onChange = _this$props.onChange, maxDate = _this$props.maxDate, moveRangeOnFirstSelection = _this$props.moveRangeOnFirstSelection, retainEndDateOnFirstSelection = _this$props.retainEndDateOnFirstSelection, disabledDates = _this$props.disabledDates;
            var focusedRangeIndex = focusedRange[0];
            var selectedRange = ranges[focusedRangeIndex];
            if (!selectedRange || !onChange) return {};
            var startDate = selectedRange.startDate, endDate = selectedRange.endDate;
            var now = new Date();
            var nextFocusRange;
            if (!isSingleValue) {
                startDate = value.startDate;
                endDate = value.endDate;
            } else if (focusedRange[1] === 0) {
                // startDate selection
                var dayOffset = (0, $53c9a209c5ff86ba$var$_differenceInCalendarDays.default)(endDate || now, startDate);
                var calculateEndDate = function calculateEndDate() {
                    if (moveRangeOnFirstSelection) return (0, $53c9a209c5ff86ba$var$_addDays.default)(value, dayOffset);
                    if (retainEndDateOnFirstSelection) {
                        if (!endDate || (0, $53c9a209c5ff86ba$var$_isBefore.default)(value, endDate)) return endDate;
                        return value;
                    }
                    return value || now;
                };
                startDate = value;
                endDate = calculateEndDate();
                if (maxDate) endDate = (0, $53c9a209c5ff86ba$var$_min.default)([
                    endDate,
                    maxDate
                ]);
                nextFocusRange = [
                    focusedRange[0],
                    1
                ];
            } else endDate = value;
             // reverse dates if startDate before endDate
            var isStartDateSelected = focusedRange[1] === 0;
            if ((0, $53c9a209c5ff86ba$var$_isBefore.default)(endDate, startDate)) {
                isStartDateSelected = !isStartDateSelected;
                var _ref = [
                    endDate,
                    startDate
                ];
                startDate = _ref[0];
                endDate = _ref[1];
            }
            var inValidDatesWithinRange = disabledDates.filter(function(disabledDate) {
                return (0, $53c9a209c5ff86ba$var$_isWithinInterval.default)(disabledDate, {
                    start: startDate,
                    end: endDate
                });
            });
            if (inValidDatesWithinRange.length > 0) {
                if (isStartDateSelected) startDate = (0, $53c9a209c5ff86ba$var$_addDays.default)((0, $53c9a209c5ff86ba$var$_max.default)(inValidDatesWithinRange), 1);
                else endDate = (0, $53c9a209c5ff86ba$var$_addDays.default)((0, $53c9a209c5ff86ba$var$_min.default)(inValidDatesWithinRange), -1);
            }
            if (!nextFocusRange) {
                var nextFocusRangeIndex = (0, $1iPS5.findNextRangeIndex)(_this.props.ranges, focusedRange[0]);
                nextFocusRange = [
                    nextFocusRangeIndex,
                    0
                ];
            }
            return {
                wasValid: !(inValidDatesWithinRange.length > 0),
                range: {
                    startDate: startDate,
                    endDate: endDate
                },
                nextFocusRange: nextFocusRange
            };
        });
        $53c9a209c5ff86ba$var$_defineProperty($53c9a209c5ff86ba$var$_assertThisInitialized(_this), "setSelection", function(value, isSingleValue) {
            var _this$props2 = _this.props, onChange = _this$props2.onChange, ranges = _this$props2.ranges, onRangeFocusChange = _this$props2.onRangeFocusChange;
            var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
            var focusedRangeIndex = focusedRange[0];
            var selectedRange = ranges[focusedRangeIndex];
            if (!selectedRange) return;
            var newSelection = _this.calcNewSelection(value, isSingleValue);
            onChange($53c9a209c5ff86ba$var$_defineProperty({}, selectedRange.key || "range".concat(focusedRangeIndex + 1), $53c9a209c5ff86ba$var$_objectSpread($53c9a209c5ff86ba$var$_objectSpread({}, selectedRange), newSelection.range)));
            _this.setState({
                focusedRange: newSelection.nextFocusRange,
                preview: null
            });
            onRangeFocusChange && onRangeFocusChange(newSelection.nextFocusRange);
        });
        $53c9a209c5ff86ba$var$_defineProperty($53c9a209c5ff86ba$var$_assertThisInitialized(_this), "handleRangeFocusChange", function(focusedRange) {
            _this.setState({
                focusedRange: focusedRange
            });
            _this.props.onRangeFocusChange && _this.props.onRangeFocusChange(focusedRange);
        });
        $53c9a209c5ff86ba$var$_defineProperty($53c9a209c5ff86ba$var$_assertThisInitialized(_this), "updatePreview", function(val) {
            var _ranges$focusedRange$;
            if (!val) {
                _this.setState({
                    preview: null
                });
                return;
            }
            var _this$props3 = _this.props, rangeColors = _this$props3.rangeColors, ranges = _this$props3.ranges;
            var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
            var color = ((_ranges$focusedRange$ = ranges[focusedRange[0]]) === null || _ranges$focusedRange$ === void 0 ? void 0 : _ranges$focusedRange$.color) || rangeColors[focusedRange[0]] || color;
            _this.setState({
                preview: $53c9a209c5ff86ba$var$_objectSpread($53c9a209c5ff86ba$var$_objectSpread({}, val.range), {}, {
                    color: color
                })
            });
        });
        _this.state = {
            focusedRange: props.initialFocusedRange || [
                (0, $1iPS5.findNextRangeIndex)(props.ranges),
                0
            ],
            preview: null
        };
        _this.styles = (0, $1iPS5.generateStyles)([
            $53c9a209c5ff86ba$var$_styles.default,
            props.classNames
        ]);
        return _this;
    }
    $53c9a209c5ff86ba$var$_createClass(DateRange, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                return /*#__PURE__*/ $53c9a209c5ff86ba$var$_react.default.createElement($53c9a209c5ff86ba$var$_Calendar.default, $53c9a209c5ff86ba$var$_extends({
                    focusedRange: this.state.focusedRange,
                    onRangeFocusChange: this.handleRangeFocusChange,
                    preview: this.state.preview,
                    onPreviewChange: function onPreviewChange(value) {
                        _this2.updatePreview(value ? _this2.calcNewSelection(value) : null);
                    }
                }, this.props, {
                    displayMode: "dateRange",
                    className: (0, $53c9a209c5ff86ba$var$_classnames.default)(this.styles.dateRangeWrapper, this.props.className),
                    onChange: this.setSelection,
                    updateRange: function updateRange(val) {
                        return _this2.setSelection(val, false);
                    },
                    ref: function ref(target) {
                        _this2.calendar = target;
                    }
                }));
            }
        }
    ]);
    return DateRange;
}($53c9a209c5ff86ba$var$_react.Component);
$53c9a209c5ff86ba$var$DateRange.defaultProps = {
    classNames: {},
    ranges: [],
    moveRangeOnFirstSelection: false,
    retainEndDateOnFirstSelection: false,
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    disabledDates: []
};
$53c9a209c5ff86ba$var$DateRange.propTypes = $53c9a209c5ff86ba$var$_objectSpread($53c9a209c5ff86ba$var$_objectSpread({}, $53c9a209c5ff86ba$var$_Calendar.default.propTypes), {}, {
    onChange: $53c9a209c5ff86ba$var$_propTypes.default.func,
    onRangeFocusChange: $53c9a209c5ff86ba$var$_propTypes.default.func,
    className: $53c9a209c5ff86ba$var$_propTypes.default.string,
    ranges: $53c9a209c5ff86ba$var$_propTypes.default.arrayOf($75YCw.rangeShape),
    moveRangeOnFirstSelection: $53c9a209c5ff86ba$var$_propTypes.default.bool,
    retainEndDateOnFirstSelection: $53c9a209c5ff86ba$var$_propTypes.default.bool
});
var $53c9a209c5ff86ba$var$_default = $53c9a209c5ff86ba$var$DateRange;
module.exports.default = $53c9a209c5ff86ba$var$_default;

});
parcelRegister("lvReq", function(module, exports) {
"use strict";
function $fa95c8f016f697e3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fa95c8f016f697e3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fa95c8f016f697e3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fa95c8f016f697e3$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa95c8f016f697e3$var$_react = $fa95c8f016f697e3$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $fa95c8f016f697e3$var$_propTypes = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("bisEj")));

var $75YCw = parcelRequire("75YCw");

var $fa95c8f016f697e3$var$_Month = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("kVI1U")));

var $fa95c8f016f697e3$var$_DateInput = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("bc0cf")));

var $1iPS5 = parcelRequire("1iPS5");

var $fa95c8f016f697e3$var$_classnames3 = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("eH0la")));

var $fa95c8f016f697e3$var$_reactList = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("j02gD")));

var $bk2sv = parcelRequire("bk2sv");

var $fa95c8f016f697e3$var$_max = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("8YdnK")));

var $fa95c8f016f697e3$var$_min = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("2aONL")));

var $fa95c8f016f697e3$var$_differenceInDays = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("bitEh")));

var $fa95c8f016f697e3$var$_isSameMonth = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("2kgE1")));

var $fa95c8f016f697e3$var$_addDays = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("czacj")));

var $fa95c8f016f697e3$var$_endOfMonth = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("2xHvS")));

var $fa95c8f016f697e3$var$_startOfMonth = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("YqHFX")));

var $fa95c8f016f697e3$var$_differenceInCalendarMonths = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("11VSy")));

var $fa95c8f016f697e3$var$_setMonth2 = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("f5GCE")));

var $fa95c8f016f697e3$var$_setYear2 = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("bnuCe")));

var $fa95c8f016f697e3$var$_addYears = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("cy9Tj")));

var $fa95c8f016f697e3$var$_isSameDay = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("l9Ijw")));

var $fa95c8f016f697e3$var$_endOfWeek = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("h3DSD")));

var $fa95c8f016f697e3$var$_startOfWeek = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("9zB2r")));

var $fa95c8f016f697e3$var$_eachDayOfInterval = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("ehFje")));

var $fa95c8f016f697e3$var$_format = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("iAkvZ")));

var $fa95c8f016f697e3$var$_subMonths = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("hCFcD")));

var $fa95c8f016f697e3$var$_addMonths = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("5Zyd5")));

var $fa95c8f016f697e3$var$_enUS = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("fxjwv")));

var $fa95c8f016f697e3$var$_styles = $fa95c8f016f697e3$var$_interopRequireDefault((parcelRequire("lnHjO")));

var $6iT59 = parcelRequire("6iT59");
function $fa95c8f016f697e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fa95c8f016f697e3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fa95c8f016f697e3$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fa95c8f016f697e3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $fa95c8f016f697e3$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fa95c8f016f697e3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fa95c8f016f697e3$var$_extends() {
    $fa95c8f016f697e3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fa95c8f016f697e3$var$_extends.apply(this, arguments);
}
function $fa95c8f016f697e3$var$_toConsumableArray(arr) {
    return $fa95c8f016f697e3$var$_arrayWithoutHoles(arr) || $fa95c8f016f697e3$var$_iterableToArray(arr) || $fa95c8f016f697e3$var$_unsupportedIterableToArray(arr) || $fa95c8f016f697e3$var$_nonIterableSpread();
}
function $fa95c8f016f697e3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fa95c8f016f697e3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fa95c8f016f697e3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fa95c8f016f697e3$var$_arrayLikeToArray(o, minLen);
}
function $fa95c8f016f697e3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $fa95c8f016f697e3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $fa95c8f016f697e3$var$_arrayLikeToArray(arr);
}
function $fa95c8f016f697e3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fa95c8f016f697e3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fa95c8f016f697e3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fa95c8f016f697e3$var$ownKeys(Object(source), true).forEach(function(key) {
            $fa95c8f016f697e3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fa95c8f016f697e3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fa95c8f016f697e3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fa95c8f016f697e3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fa95c8f016f697e3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fa95c8f016f697e3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fa95c8f016f697e3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fa95c8f016f697e3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fa95c8f016f697e3$var$_setPrototypeOf(subClass, superClass);
}
function $fa95c8f016f697e3$var$_setPrototypeOf(o, p) {
    $fa95c8f016f697e3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fa95c8f016f697e3$var$_setPrototypeOf(o, p);
}
function $fa95c8f016f697e3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fa95c8f016f697e3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $fa95c8f016f697e3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fa95c8f016f697e3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fa95c8f016f697e3$var$_possibleConstructorReturn(this, result);
    };
}
function $fa95c8f016f697e3$var$_possibleConstructorReturn(self, call) {
    if (call && ($fa95c8f016f697e3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $fa95c8f016f697e3$var$_assertThisInitialized(self);
}
function $fa95c8f016f697e3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fa95c8f016f697e3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fa95c8f016f697e3$var$_getPrototypeOf(o) {
    $fa95c8f016f697e3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fa95c8f016f697e3$var$_getPrototypeOf(o);
}
function $fa95c8f016f697e3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $fa95c8f016f697e3$var$Calendar = /*#__PURE__*/ function(_PureComponent) {
    $fa95c8f016f697e3$var$_inherits(Calendar, _PureComponent);
    var _super = $fa95c8f016f697e3$var$_createSuper(Calendar);
    function Calendar(_props, context) {
        var _this;
        $fa95c8f016f697e3$var$_classCallCheck(this, Calendar);
        _this = _super.call(this, _props, context);
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "focusToDate", function(date) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;
            var preventUnnecessary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            if (!props.scroll.enabled) {
                if (preventUnnecessary && props.preventSnapRefocus) {
                    var focusedDateDiff = (0, $fa95c8f016f697e3$var$_differenceInCalendarMonths.default)(date, _this.state.focusedDate);
                    var isAllowedForward = props.calendarFocus === "forwards" && focusedDateDiff >= 0;
                    var isAllowedBackward = props.calendarFocus === "backwards" && focusedDateDiff <= 0;
                    if ((isAllowedForward || isAllowedBackward) && Math.abs(focusedDateDiff) < props.months) return;
                }
                _this.setState({
                    focusedDate: date
                });
                return;
            }
            var targetMonthIndex = (0, $fa95c8f016f697e3$var$_differenceInCalendarMonths.default)(date, props.minDate, _this.dateOptions);
            var visibleMonths = _this.list.getVisibleRange();
            if (preventUnnecessary && visibleMonths.includes(targetMonthIndex)) return;
            _this.isFirstRender = true;
            _this.list.scrollTo(targetMonthIndex);
            _this.setState({
                focusedDate: date
            });
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "updateShownDate", function() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            var newProps = props.scroll.enabled ? $fa95c8f016f697e3$var$_objectSpread($fa95c8f016f697e3$var$_objectSpread({}, props), {}, {
                months: _this.list.getVisibleRange().length
            }) : props;
            var newFocus = (0, $1iPS5.calcFocusDate)(_this.state.focusedDate, newProps);
            _this.focusToDate(newFocus, newProps);
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "updatePreview", function(val) {
            if (!val) {
                _this.setState({
                    preview: null
                });
                return;
            }
            var preview = {
                startDate: val,
                endDate: val,
                color: _this.props.color
            };
            _this.setState({
                preview: preview
            });
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "changeShownDate", function(value) {
            var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "set";
            var focusedDate = _this.state.focusedDate;
            var _this$props = _this.props, onShownDateChange = _this$props.onShownDateChange, minDate = _this$props.minDate, maxDate = _this$props.maxDate;
            var modeMapper = {
                monthOffset: function monthOffset() {
                    return (0, $fa95c8f016f697e3$var$_addMonths.default)(focusedDate, value);
                },
                setMonth: function(_setMonth) {
                    function setMonth() {
                        return _setMonth.apply(this, arguments);
                    }
                    setMonth.toString = function() {
                        return _setMonth.toString();
                    };
                    return setMonth;
                }(function() {
                    return (0, $fa95c8f016f697e3$var$_setMonth2.default)(focusedDate, value);
                }),
                setYear: function(_setYear) {
                    function setYear() {
                        return _setYear.apply(this, arguments);
                    }
                    setYear.toString = function() {
                        return _setYear.toString();
                    };
                    return setYear;
                }(function() {
                    return (0, $fa95c8f016f697e3$var$_setYear2.default)(focusedDate, value);
                }),
                set: function set() {
                    return value;
                }
            };
            var newDate = (0, $fa95c8f016f697e3$var$_min.default)([
                (0, $fa95c8f016f697e3$var$_max.default)([
                    modeMapper[mode](),
                    minDate
                ]),
                maxDate
            ]);
            _this.focusToDate(newDate, _this.props, false);
            onShownDateChange && onShownDateChange(newDate);
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "handleRangeFocusChange", function(rangesIndex, rangeItemIndex) {
            _this.props.onRangeFocusChange && _this.props.onRangeFocusChange([
                rangesIndex,
                rangeItemIndex
            ]);
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "handleScroll", function() {
            var _this$props2 = _this.props, onShownDateChange = _this$props2.onShownDateChange, minDate = _this$props2.minDate;
            var focusedDate = _this.state.focusedDate;
            var _assertThisInitialize = $fa95c8f016f697e3$var$_assertThisInitialized(_this), isFirstRender = _assertThisInitialize.isFirstRender;
            var visibleMonths = _this.list.getVisibleRange(); // prevent scroll jump with wrong visible value
            if (visibleMonths[0] === undefined) return;
            var visibleMonth = (0, $fa95c8f016f697e3$var$_addMonths.default)(minDate, visibleMonths[0] || 0);
            var isFocusedToDifferent = !(0, $fa95c8f016f697e3$var$_isSameMonth.default)(visibleMonth, focusedDate);
            if (isFocusedToDifferent && !isFirstRender) {
                _this.setState({
                    focusedDate: visibleMonth
                });
                onShownDateChange && onShownDateChange(visibleMonth);
            }
            _this.isFirstRender = false;
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "renderMonthAndYear", function(focusedDate, changeShownDate, props) {
            var showMonthArrow = props.showMonthArrow, minDate = props.minDate, maxDate = props.maxDate, showMonthAndYearPickers = props.showMonthAndYearPickers, ariaLabels = props.ariaLabels;
            var upperYearLimit = (maxDate || Calendar.defaultProps.maxDate).getFullYear();
            var lowerYearLimit = (minDate || Calendar.defaultProps.minDate).getFullYear();
            var styles = _this.styles;
            return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("div", {
                onMouseUp: function onMouseUp(e) {
                    return e.stopPropagation();
                },
                className: styles.monthAndYearWrapper
            }, showMonthArrow ? /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("button", {
                type: "button",
                className: (0, $fa95c8f016f697e3$var$_classnames3.default)(styles.nextPrevButton, styles.prevButton),
                onClick: function onClick() {
                    return changeShownDate(-1, "monthOffset");
                },
                "aria-label": ariaLabels.prevButton
            }, /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("i", null)) : null, showMonthAndYearPickers ? /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("span", {
                className: styles.monthAndYearPickers
            }, /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("span", {
                className: styles.monthPicker
            }, /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("select", {
                value: focusedDate.getMonth(),
                onChange: function onChange(e) {
                    return changeShownDate(e.target.value, "setMonth");
                },
                "aria-label": ariaLabels.monthPicker
            }, _this.state.monthNames.map(function(monthName, i) {
                return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("option", {
                    key: i,
                    value: i
                }, monthName);
            }))), /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("span", {
                className: styles.monthAndYearDivider
            }), /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("span", {
                className: styles.yearPicker
            }, /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("select", {
                value: focusedDate.getFullYear(),
                onChange: function onChange(e) {
                    return changeShownDate(e.target.value, "setYear");
                },
                "aria-label": ariaLabels.yearPicker
            }, new Array(upperYearLimit - lowerYearLimit + 1).fill(upperYearLimit).map(function(val, i) {
                var year = val - i;
                return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("option", {
                    key: year,
                    value: year
                }, year);
            })))) : /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("span", {
                className: styles.monthAndYearPickers
            }, _this.state.monthNames[focusedDate.getMonth()], " ", focusedDate.getFullYear()), showMonthArrow ? /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("button", {
                type: "button",
                className: (0, $fa95c8f016f697e3$var$_classnames3.default)(styles.nextPrevButton, styles.nextButton),
                onClick: function onClick() {
                    return changeShownDate(1, "monthOffset");
                },
                "aria-label": ariaLabels.nextButton
            }, /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("i", null)) : null);
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "renderDateDisplay", function() {
            var _this$props3 = _this.props, focusedRange = _this$props3.focusedRange, color = _this$props3.color, ranges = _this$props3.ranges, rangeColors = _this$props3.rangeColors, dateDisplayFormat = _this$props3.dateDisplayFormat, editableDateInputs = _this$props3.editableDateInputs, startDatePlaceholder = _this$props3.startDatePlaceholder, endDatePlaceholder = _this$props3.endDatePlaceholder, ariaLabels = _this$props3.ariaLabels;
            var defaultColor = rangeColors[focusedRange[0]] || color;
            var styles = _this.styles;
            return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("div", {
                className: styles.dateDisplayWrapper
            }, ranges.map(function(range, i) {
                if (range.showDateDisplay === false || range.disabled && !range.showDateDisplay) return null;
                return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("div", {
                    className: styles.dateDisplay,
                    key: i,
                    style: {
                        color: range.color || defaultColor
                    }
                }, /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement($fa95c8f016f697e3$var$_DateInput.default, {
                    className: (0, $fa95c8f016f697e3$var$_classnames3.default)(styles.dateDisplayItem, $fa95c8f016f697e3$var$_defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 0)),
                    readOnly: !editableDateInputs,
                    disabled: range.disabled,
                    value: range.startDate,
                    placeholder: startDatePlaceholder,
                    dateOptions: _this.dateOptions,
                    dateDisplayFormat: dateDisplayFormat,
                    ariaLabel: ariaLabels.dateInput && ariaLabels.dateInput[range.key] && ariaLabels.dateInput[range.key].startDate,
                    onChange: _this.onDragSelectionEnd,
                    onFocus: function onFocus() {
                        return _this.handleRangeFocusChange(i, 0);
                    }
                }), /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement($fa95c8f016f697e3$var$_DateInput.default, {
                    className: (0, $fa95c8f016f697e3$var$_classnames3.default)(styles.dateDisplayItem, $fa95c8f016f697e3$var$_defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 1)),
                    readOnly: !editableDateInputs,
                    disabled: range.disabled,
                    value: range.endDate,
                    placeholder: endDatePlaceholder,
                    dateOptions: _this.dateOptions,
                    dateDisplayFormat: dateDisplayFormat,
                    ariaLabel: ariaLabels.dateInput && ariaLabels.dateInput[range.key] && ariaLabels.dateInput[range.key].endDate,
                    onChange: _this.onDragSelectionEnd,
                    onFocus: function onFocus() {
                        return _this.handleRangeFocusChange(i, 1);
                    }
                }));
            }));
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "onDragSelectionStart", function(date) {
            var _this$props4 = _this.props, onChange = _this$props4.onChange, dragSelectionEnabled = _this$props4.dragSelectionEnabled;
            if (dragSelectionEnabled) _this.setState({
                drag: {
                    status: true,
                    range: {
                        startDate: date,
                        endDate: date
                    },
                    disablePreview: true
                }
            });
            else onChange && onChange(date);
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "onDragSelectionEnd", function(date) {
            var _this$props5 = _this.props, updateRange = _this$props5.updateRange, displayMode = _this$props5.displayMode, onChange = _this$props5.onChange, dragSelectionEnabled = _this$props5.dragSelectionEnabled;
            if (!dragSelectionEnabled) return;
            if (displayMode === "date" || !_this.state.drag.status) {
                onChange && onChange(date);
                return;
            }
            var newRange = {
                startDate: _this.state.drag.range.startDate,
                endDate: date
            };
            if (displayMode !== "dateRange" || (0, $fa95c8f016f697e3$var$_isSameDay.default)(newRange.startDate, date)) _this.setState({
                drag: {
                    status: false,
                    range: {}
                }
            }, function() {
                return onChange && onChange(date);
            });
            else _this.setState({
                drag: {
                    status: false,
                    range: {}
                }
            }, function() {
                updateRange && updateRange(newRange);
            });
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "onDragSelectionMove", function(date) {
            var drag = _this.state.drag;
            if (!drag.status || !_this.props.dragSelectionEnabled) return;
            _this.setState({
                drag: {
                    status: drag.status,
                    range: {
                        startDate: drag.range.startDate,
                        endDate: date
                    },
                    disablePreview: true
                }
            });
        });
        $fa95c8f016f697e3$var$_defineProperty($fa95c8f016f697e3$var$_assertThisInitialized(_this), "estimateMonthSize", function(index, cache) {
            var _this$props6 = _this.props, direction = _this$props6.direction, minDate = _this$props6.minDate;
            var scrollArea = _this.state.scrollArea;
            if (cache) {
                _this.listSizeCache = cache;
                if (cache[index]) return cache[index];
            }
            if (direction === "horizontal") return scrollArea.monthWidth;
            var monthStep = (0, $fa95c8f016f697e3$var$_addMonths.default)(minDate, index);
            var _getMonthDisplayRange = (0, $1iPS5.getMonthDisplayRange)(monthStep, _this.dateOptions), start = _getMonthDisplayRange.start, end = _getMonthDisplayRange.end;
            var isLongMonth = (0, $fa95c8f016f697e3$var$_differenceInDays.default)(end, start, _this.dateOptions) + 1 > 35;
            return isLongMonth ? scrollArea.longMonthHeight : scrollArea.monthHeight;
        });
        _this.dateOptions = {
            locale: _props.locale
        };
        if (_props.weekStartsOn !== undefined) _this.dateOptions.weekStartsOn = _props.weekStartsOn;
        _this.styles = (0, $1iPS5.generateStyles)([
            $fa95c8f016f697e3$var$_styles.default,
            _props.classNames
        ]);
        _this.listSizeCache = {};
        _this.isFirstRender = true;
        _this.state = {
            monthNames: _this.getMonthNames(),
            focusedDate: (0, $1iPS5.calcFocusDate)(null, _props),
            drag: {
                status: false,
                range: {
                    startDate: null,
                    endDate: null
                },
                disablePreview: false
            },
            scrollArea: _this.calcScrollArea(_props)
        };
        return _this;
    }
    $fa95c8f016f697e3$var$_createClass(Calendar, [
        {
            key: "getMonthNames",
            value: function getMonthNames() {
                var _this2 = this;
                return $fa95c8f016f697e3$var$_toConsumableArray(Array(12).keys()).map(function(i) {
                    return _this2.props.locale.localize.month(i);
                });
            }
        },
        {
            key: "calcScrollArea",
            value: function calcScrollArea(props) {
                var direction = props.direction, months = props.months, scroll = props.scroll;
                if (!scroll.enabled) return {
                    enabled: false
                };
                var longMonthHeight = scroll.longMonthHeight || scroll.monthHeight;
                if (direction === "vertical") return {
                    enabled: true,
                    monthHeight: scroll.monthHeight || 220,
                    longMonthHeight: longMonthHeight || 260,
                    calendarWidth: "auto",
                    calendarHeight: (scroll.calendarHeight || longMonthHeight || 240) * months
                };
                return {
                    enabled: true,
                    monthWidth: scroll.monthWidth || 332,
                    calendarWidth: (scroll.calendarWidth || scroll.monthWidth || 332) * months,
                    monthHeight: longMonthHeight || 300,
                    calendarHeight: longMonthHeight || 300
                };
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this3 = this;
                if (this.props.scroll.enabled) // prevent react-list's initial render focus problem
                setTimeout(function() {
                    return _this3.focusToDate(_this3.state.focusedDate);
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var propMapper = {
                    dateRange: "ranges",
                    date: "date"
                };
                var targetProp = propMapper[this.props.displayMode];
                if (this.props[targetProp] !== prevProps[targetProp]) this.updateShownDate(this.props);
                if (prevProps.locale !== this.props.locale || prevProps.weekStartsOn !== this.props.weekStartsOn) {
                    this.dateOptions = {
                        locale: this.props.locale
                    };
                    if (this.props.weekStartsOn !== undefined) this.dateOptions.weekStartsOn = this.props.weekStartsOn;
                    this.setState({
                        monthNames: this.getMonthNames()
                    });
                }
                if (!(0, $bk2sv.shallowEqualObjects)(prevProps.scroll, this.props.scroll)) this.setState({
                    scrollArea: this.calcScrollArea(this.props)
                });
            }
        },
        {
            key: "renderWeekdays",
            value: function renderWeekdays() {
                var _this4 = this;
                var now = new Date();
                return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("div", {
                    className: this.styles.weekDays
                }, (0, $fa95c8f016f697e3$var$_eachDayOfInterval.default)({
                    start: (0, $fa95c8f016f697e3$var$_startOfWeek.default)(now, this.dateOptions),
                    end: (0, $fa95c8f016f697e3$var$_endOfWeek.default)(now, this.dateOptions)
                }).map(function(day, i) {
                    return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("span", {
                        className: _this4.styles.weekDay,
                        key: i
                    }, (0, $fa95c8f016f697e3$var$_format.default)(day, _this4.props.weekdayDisplayFormat, _this4.dateOptions));
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props7 = this.props, showDateDisplay = _this$props7.showDateDisplay, onPreviewChange = _this$props7.onPreviewChange, scroll = _this$props7.scroll, direction = _this$props7.direction, disabledDates = _this$props7.disabledDates, disabledDay = _this$props7.disabledDay, maxDate = _this$props7.maxDate, minDate = _this$props7.minDate, rangeColors = _this$props7.rangeColors, color = _this$props7.color, navigatorRenderer = _this$props7.navigatorRenderer, className = _this$props7.className, preview = _this$props7.preview;
                var _this$state = this.state, scrollArea = _this$state.scrollArea, focusedDate = _this$state.focusedDate;
                var isVertical = direction === "vertical";
                var monthAndYearRenderer = navigatorRenderer || this.renderMonthAndYear;
                var ranges = this.props.ranges.map(function(range, i) {
                    return $fa95c8f016f697e3$var$_objectSpread($fa95c8f016f697e3$var$_objectSpread({}, range), {}, {
                        color: range.color || rangeColors[i] || color
                    });
                });
                return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("div", {
                    className: (0, $fa95c8f016f697e3$var$_classnames3.default)(this.styles.calendarWrapper, className),
                    onMouseUp: function onMouseUp() {
                        return _this5.setState({
                            drag: {
                                status: false,
                                range: {}
                            }
                        });
                    },
                    onMouseLeave: function onMouseLeave() {
                        _this5.setState({
                            drag: {
                                status: false,
                                range: {}
                            }
                        });
                    }
                }, showDateDisplay && this.renderDateDisplay(), monthAndYearRenderer(focusedDate, this.changeShownDate, this.props), scroll.enabled ? /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("div", null, isVertical && this.renderWeekdays(this.dateOptions), /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("div", {
                    className: (0, $fa95c8f016f697e3$var$_classnames3.default)(this.styles.infiniteMonths, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal),
                    onMouseLeave: function onMouseLeave() {
                        return onPreviewChange && onPreviewChange();
                    },
                    style: {
                        width: scrollArea.calendarWidth + 11,
                        height: scrollArea.calendarHeight + 11
                    },
                    onScroll: this.handleScroll
                }, /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement($fa95c8f016f697e3$var$_reactList.default, {
                    length: (0, $fa95c8f016f697e3$var$_differenceInCalendarMonths.default)((0, $fa95c8f016f697e3$var$_endOfMonth.default)(maxDate), (0, $fa95c8f016f697e3$var$_addDays.default)((0, $fa95c8f016f697e3$var$_startOfMonth.default)(minDate), -1), this.dateOptions),
                    treshold: 500,
                    type: "variable",
                    ref: function ref(target) {
                        return _this5.list = target;
                    },
                    itemSizeEstimator: this.estimateMonthSize,
                    axis: isVertical ? "y" : "x",
                    itemRenderer: function itemRenderer(index, key) {
                        var monthStep = (0, $fa95c8f016f697e3$var$_addMonths.default)(minDate, index);
                        return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement($fa95c8f016f697e3$var$_Month.default, $fa95c8f016f697e3$var$_extends({}, _this5.props, {
                            onPreviewChange: onPreviewChange || _this5.updatePreview,
                            preview: preview || _this5.state.preview,
                            ranges: ranges,
                            key: key,
                            drag: _this5.state.drag,
                            dateOptions: _this5.dateOptions,
                            disabledDates: disabledDates,
                            disabledDay: disabledDay,
                            month: monthStep,
                            onDragSelectionStart: _this5.onDragSelectionStart,
                            onDragSelectionEnd: _this5.onDragSelectionEnd,
                            onDragSelectionMove: _this5.onDragSelectionMove,
                            onMouseLeave: function onMouseLeave() {
                                return onPreviewChange && onPreviewChange();
                            },
                            styles: _this5.styles,
                            style: isVertical ? {
                                height: _this5.estimateMonthSize(index)
                            } : {
                                height: scrollArea.monthHeight,
                                width: _this5.estimateMonthSize(index)
                            },
                            showMonthName: true,
                            showWeekDays: !isVertical
                        }));
                    }
                }))) : /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement("div", {
                    className: (0, $fa95c8f016f697e3$var$_classnames3.default)(this.styles.months, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal)
                }, new Array(this.props.months).fill(null).map(function(_, i) {
                    var monthStep = (0, $fa95c8f016f697e3$var$_addMonths.default)(_this5.state.focusedDate, i);
                    if (_this5.props.calendarFocus === "backwards") monthStep = (0, $fa95c8f016f697e3$var$_subMonths.default)(_this5.state.focusedDate, _this5.props.months - 1 - i);
                    return /*#__PURE__*/ $fa95c8f016f697e3$var$_react.default.createElement($fa95c8f016f697e3$var$_Month.default, $fa95c8f016f697e3$var$_extends({}, _this5.props, {
                        onPreviewChange: onPreviewChange || _this5.updatePreview,
                        preview: preview || _this5.state.preview,
                        ranges: ranges,
                        key: i,
                        drag: _this5.state.drag,
                        dateOptions: _this5.dateOptions,
                        disabledDates: disabledDates,
                        disabledDay: disabledDay,
                        month: monthStep,
                        onDragSelectionStart: _this5.onDragSelectionStart,
                        onDragSelectionEnd: _this5.onDragSelectionEnd,
                        onDragSelectionMove: _this5.onDragSelectionMove,
                        onMouseLeave: function onMouseLeave() {
                            return onPreviewChange && onPreviewChange();
                        },
                        styles: _this5.styles,
                        showWeekDays: !isVertical || i === 0,
                        showMonthName: !isVertical || i > 0
                    }));
                })));
            }
        }
    ]);
    return Calendar;
}($fa95c8f016f697e3$var$_react.PureComponent);
$fa95c8f016f697e3$var$Calendar.defaultProps = {
    showMonthArrow: true,
    showMonthAndYearPickers: true,
    disabledDates: [],
    disabledDay: function disabledDay() {},
    classNames: {},
    locale: $fa95c8f016f697e3$var$_enUS.default,
    ranges: [],
    focusedRange: [
        0,
        0
    ],
    dateDisplayFormat: "MMM d, yyyy",
    monthDisplayFormat: "MMM yyyy",
    weekdayDisplayFormat: "E",
    dayDisplayFormat: "d",
    showDateDisplay: true,
    showPreview: true,
    displayMode: "date",
    months: 1,
    color: "#3d91ff",
    scroll: {
        enabled: false
    },
    direction: "vertical",
    maxDate: (0, $fa95c8f016f697e3$var$_addYears.default)(new Date(), 20),
    minDate: (0, $fa95c8f016f697e3$var$_addYears.default)(new Date(), -100),
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    startDatePlaceholder: "Early",
    endDatePlaceholder: "Continuous",
    editableDateInputs: false,
    dragSelectionEnabled: true,
    fixedHeight: false,
    calendarFocus: "forwards",
    preventSnapRefocus: false,
    ariaLabels: {}
};
$fa95c8f016f697e3$var$Calendar.propTypes = {
    showMonthArrow: $fa95c8f016f697e3$var$_propTypes.default.bool,
    showMonthAndYearPickers: $fa95c8f016f697e3$var$_propTypes.default.bool,
    disabledDates: $fa95c8f016f697e3$var$_propTypes.default.array,
    disabledDay: $fa95c8f016f697e3$var$_propTypes.default.func,
    minDate: $fa95c8f016f697e3$var$_propTypes.default.object,
    maxDate: $fa95c8f016f697e3$var$_propTypes.default.object,
    date: $fa95c8f016f697e3$var$_propTypes.default.object,
    onChange: $fa95c8f016f697e3$var$_propTypes.default.func,
    onPreviewChange: $fa95c8f016f697e3$var$_propTypes.default.func,
    onRangeFocusChange: $fa95c8f016f697e3$var$_propTypes.default.func,
    classNames: $fa95c8f016f697e3$var$_propTypes.default.object,
    locale: $fa95c8f016f697e3$var$_propTypes.default.object,
    shownDate: $fa95c8f016f697e3$var$_propTypes.default.object,
    onShownDateChange: $fa95c8f016f697e3$var$_propTypes.default.func,
    ranges: $fa95c8f016f697e3$var$_propTypes.default.arrayOf($75YCw.rangeShape),
    preview: $fa95c8f016f697e3$var$_propTypes.default.shape({
        startDate: $fa95c8f016f697e3$var$_propTypes.default.object,
        endDate: $fa95c8f016f697e3$var$_propTypes.default.object,
        color: $fa95c8f016f697e3$var$_propTypes.default.string
    }),
    dateDisplayFormat: $fa95c8f016f697e3$var$_propTypes.default.string,
    monthDisplayFormat: $fa95c8f016f697e3$var$_propTypes.default.string,
    weekdayDisplayFormat: $fa95c8f016f697e3$var$_propTypes.default.string,
    weekStartsOn: $fa95c8f016f697e3$var$_propTypes.default.number,
    dayDisplayFormat: $fa95c8f016f697e3$var$_propTypes.default.string,
    focusedRange: $fa95c8f016f697e3$var$_propTypes.default.arrayOf($fa95c8f016f697e3$var$_propTypes.default.number),
    initialFocusedRange: $fa95c8f016f697e3$var$_propTypes.default.arrayOf($fa95c8f016f697e3$var$_propTypes.default.number),
    months: $fa95c8f016f697e3$var$_propTypes.default.number,
    className: $fa95c8f016f697e3$var$_propTypes.default.string,
    showDateDisplay: $fa95c8f016f697e3$var$_propTypes.default.bool,
    showPreview: $fa95c8f016f697e3$var$_propTypes.default.bool,
    displayMode: $fa95c8f016f697e3$var$_propTypes.default.oneOf([
        "dateRange",
        "date"
    ]),
    color: $fa95c8f016f697e3$var$_propTypes.default.string,
    updateRange: $fa95c8f016f697e3$var$_propTypes.default.func,
    scroll: $fa95c8f016f697e3$var$_propTypes.default.shape({
        enabled: $fa95c8f016f697e3$var$_propTypes.default.bool,
        monthHeight: $fa95c8f016f697e3$var$_propTypes.default.number,
        longMonthHeight: $fa95c8f016f697e3$var$_propTypes.default.number,
        monthWidth: $fa95c8f016f697e3$var$_propTypes.default.number,
        calendarWidth: $fa95c8f016f697e3$var$_propTypes.default.number,
        calendarHeight: $fa95c8f016f697e3$var$_propTypes.default.number
    }),
    direction: $fa95c8f016f697e3$var$_propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    startDatePlaceholder: $fa95c8f016f697e3$var$_propTypes.default.string,
    endDatePlaceholder: $fa95c8f016f697e3$var$_propTypes.default.string,
    navigatorRenderer: $fa95c8f016f697e3$var$_propTypes.default.func,
    rangeColors: $fa95c8f016f697e3$var$_propTypes.default.arrayOf($fa95c8f016f697e3$var$_propTypes.default.string),
    editableDateInputs: $fa95c8f016f697e3$var$_propTypes.default.bool,
    dragSelectionEnabled: $fa95c8f016f697e3$var$_propTypes.default.bool,
    fixedHeight: $fa95c8f016f697e3$var$_propTypes.default.bool,
    calendarFocus: $fa95c8f016f697e3$var$_propTypes.default.string,
    preventSnapRefocus: $fa95c8f016f697e3$var$_propTypes.default.bool,
    ariaLabels: $6iT59.ariaLabelsShape
};
var $fa95c8f016f697e3$var$_default = $fa95c8f016f697e3$var$Calendar;
module.exports.default = $fa95c8f016f697e3$var$_default;

});
parcelRegister("75YCw", function(module, exports) {
"use strict";
function $52a805f924e1c770$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $52a805f924e1c770$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $52a805f924e1c770$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $52a805f924e1c770$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.rangeShape = void 0;

var $52a805f924e1c770$var$_react = $52a805f924e1c770$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $52a805f924e1c770$var$_propTypes = $52a805f924e1c770$var$_interopRequireDefault((parcelRequire("bisEj")));

var $52a805f924e1c770$var$_classnames4 = $52a805f924e1c770$var$_interopRequireDefault((parcelRequire("eH0la")));

var $52a805f924e1c770$var$_endOfDay = $52a805f924e1c770$var$_interopRequireDefault((parcelRequire("kNidb")));

var $52a805f924e1c770$var$_isBefore = $52a805f924e1c770$var$_interopRequireDefault((parcelRequire("1x9Sk")));

var $52a805f924e1c770$var$_isAfter = $52a805f924e1c770$var$_interopRequireDefault((parcelRequire("lRjt5")));

var $52a805f924e1c770$var$_isSameDay = $52a805f924e1c770$var$_interopRequireDefault((parcelRequire("l9Ijw")));

var $52a805f924e1c770$var$_format = $52a805f924e1c770$var$_interopRequireDefault((parcelRequire("iAkvZ")));

var $52a805f924e1c770$var$_startOfDay = $52a805f924e1c770$var$_interopRequireDefault((parcelRequire("jmtco")));
function $52a805f924e1c770$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52a805f924e1c770$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($52a805f924e1c770$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $52a805f924e1c770$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $52a805f924e1c770$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $52a805f924e1c770$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $52a805f924e1c770$var$_extends() {
    $52a805f924e1c770$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $52a805f924e1c770$var$_extends.apply(this, arguments);
}
function $52a805f924e1c770$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $52a805f924e1c770$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $52a805f924e1c770$var$ownKeys(Object(source), true).forEach(function(key) {
            $52a805f924e1c770$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $52a805f924e1c770$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $52a805f924e1c770$var$_toConsumableArray(arr) {
    return $52a805f924e1c770$var$_arrayWithoutHoles(arr) || $52a805f924e1c770$var$_iterableToArray(arr) || $52a805f924e1c770$var$_unsupportedIterableToArray(arr) || $52a805f924e1c770$var$_nonIterableSpread();
}
function $52a805f924e1c770$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $52a805f924e1c770$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $52a805f924e1c770$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $52a805f924e1c770$var$_arrayLikeToArray(o, minLen);
}
function $52a805f924e1c770$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $52a805f924e1c770$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $52a805f924e1c770$var$_arrayLikeToArray(arr);
}
function $52a805f924e1c770$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $52a805f924e1c770$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $52a805f924e1c770$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $52a805f924e1c770$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $52a805f924e1c770$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $52a805f924e1c770$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $52a805f924e1c770$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $52a805f924e1c770$var$_setPrototypeOf(subClass, superClass);
}
function $52a805f924e1c770$var$_setPrototypeOf(o, p) {
    $52a805f924e1c770$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $52a805f924e1c770$var$_setPrototypeOf(o, p);
}
function $52a805f924e1c770$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $52a805f924e1c770$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $52a805f924e1c770$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $52a805f924e1c770$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $52a805f924e1c770$var$_possibleConstructorReturn(this, result);
    };
}
function $52a805f924e1c770$var$_possibleConstructorReturn(self, call) {
    if (call && ($52a805f924e1c770$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $52a805f924e1c770$var$_assertThisInitialized(self);
}
function $52a805f924e1c770$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $52a805f924e1c770$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $52a805f924e1c770$var$_getPrototypeOf(o) {
    $52a805f924e1c770$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $52a805f924e1c770$var$_getPrototypeOf(o);
}
function $52a805f924e1c770$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $52a805f924e1c770$var$DayCell = /*#__PURE__*/ function(_Component) {
    $52a805f924e1c770$var$_inherits(DayCell, _Component);
    var _super = $52a805f924e1c770$var$_createSuper(DayCell);
    function DayCell(props, context) {
        var _this;
        $52a805f924e1c770$var$_classCallCheck(this, DayCell);
        _this = _super.call(this, props, context);
        $52a805f924e1c770$var$_defineProperty($52a805f924e1c770$var$_assertThisInitialized(_this), "handleKeyEvent", function(event) {
            var _this$props = _this.props, day = _this$props.day, onMouseDown = _this$props.onMouseDown, onMouseUp = _this$props.onMouseUp;
            if ([
                13,
                32
            ].includes(event.keyCode)) {
                if (event.type === "keydown") onMouseDown(day);
                else onMouseUp(day);
            }
        });
        $52a805f924e1c770$var$_defineProperty($52a805f924e1c770$var$_assertThisInitialized(_this), "handleMouseEvent", function(event) {
            var _this$props2 = _this.props, day = _this$props2.day, disabled = _this$props2.disabled, onPreviewChange = _this$props2.onPreviewChange, onMouseEnter = _this$props2.onMouseEnter, onMouseDown = _this$props2.onMouseDown, onMouseUp = _this$props2.onMouseUp;
            var stateChanges = {};
            if (disabled) {
                onPreviewChange();
                return;
            }
            switch(event.type){
                case "mouseenter":
                    onMouseEnter(day);
                    onPreviewChange(day);
                    stateChanges.hover = true;
                    break;
                case "blur":
                case "mouseleave":
                    stateChanges.hover = false;
                    break;
                case "mousedown":
                    stateChanges.active = true;
                    onMouseDown(day);
                    break;
                case "mouseup":
                    event.stopPropagation();
                    stateChanges.active = false;
                    onMouseUp(day);
                    break;
                case "focus":
                    onPreviewChange(day);
                    break;
            }
            if (Object.keys(stateChanges).length) _this.setState(stateChanges);
        });
        $52a805f924e1c770$var$_defineProperty($52a805f924e1c770$var$_assertThisInitialized(_this), "getClassNames", function() {
            var _classnames;
            var _this$props3 = _this.props, isPassive = _this$props3.isPassive, isToday = _this$props3.isToday, isWeekend = _this$props3.isWeekend, isStartOfWeek = _this$props3.isStartOfWeek, isEndOfWeek = _this$props3.isEndOfWeek, isStartOfMonth = _this$props3.isStartOfMonth, isEndOfMonth = _this$props3.isEndOfMonth, disabled = _this$props3.disabled, styles = _this$props3.styles;
            return (0, $52a805f924e1c770$var$_classnames4.default)(styles.day, (_classnames = {}, $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayPassive, isPassive), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayDisabled, disabled), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayToday, isToday), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayWeekend, isWeekend), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayStartOfWeek, isStartOfWeek), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayEndOfWeek, isEndOfWeek), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayStartOfMonth, isStartOfMonth), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayEndOfMonth, isEndOfMonth), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayHovered, _this.state.hover), $52a805f924e1c770$var$_defineProperty(_classnames, styles.dayActive, _this.state.active), _classnames));
        });
        $52a805f924e1c770$var$_defineProperty($52a805f924e1c770$var$_assertThisInitialized(_this), "renderPreviewPlaceholder", function() {
            var _classnames2;
            var _this$props4 = _this.props, preview = _this$props4.preview, day = _this$props4.day, styles = _this$props4.styles;
            if (!preview) return null;
            var startDate = preview.startDate ? (0, $52a805f924e1c770$var$_endOfDay.default)(preview.startDate) : null;
            var endDate = preview.endDate ? (0, $52a805f924e1c770$var$_startOfDay.default)(preview.endDate) : null;
            var isInRange = (!startDate || (0, $52a805f924e1c770$var$_isAfter.default)(day, startDate)) && (!endDate || (0, $52a805f924e1c770$var$_isBefore.default)(day, endDate));
            var isStartEdge = !isInRange && (0, $52a805f924e1c770$var$_isSameDay.default)(day, startDate);
            var isEndEdge = !isInRange && (0, $52a805f924e1c770$var$_isSameDay.default)(day, endDate);
            return /*#__PURE__*/ $52a805f924e1c770$var$_react.default.createElement("span", {
                className: (0, $52a805f924e1c770$var$_classnames4.default)((_classnames2 = {}, $52a805f924e1c770$var$_defineProperty(_classnames2, styles.dayStartPreview, isStartEdge), $52a805f924e1c770$var$_defineProperty(_classnames2, styles.dayInPreview, isInRange), $52a805f924e1c770$var$_defineProperty(_classnames2, styles.dayEndPreview, isEndEdge), _classnames2)),
                style: {
                    color: preview.color
                }
            });
        });
        $52a805f924e1c770$var$_defineProperty($52a805f924e1c770$var$_assertThisInitialized(_this), "renderSelectionPlaceholders", function() {
            var _this$props5 = _this.props, styles = _this$props5.styles, ranges = _this$props5.ranges, day = _this$props5.day;
            if (_this.props.displayMode === "date") {
                var isSelected = (0, $52a805f924e1c770$var$_isSameDay.default)(_this.props.day, _this.props.date);
                return isSelected ? /*#__PURE__*/ $52a805f924e1c770$var$_react.default.createElement("span", {
                    className: styles.selected,
                    style: {
                        color: _this.props.color
                    }
                }) : null;
            }
            var inRanges = ranges.reduce(function(result, range) {
                var startDate = range.startDate;
                var endDate = range.endDate;
                if (startDate && endDate && (0, $52a805f924e1c770$var$_isBefore.default)(endDate, startDate)) {
                    var _ref = [
                        endDate,
                        startDate
                    ];
                    startDate = _ref[0];
                    endDate = _ref[1];
                }
                startDate = startDate ? (0, $52a805f924e1c770$var$_endOfDay.default)(startDate) : null;
                endDate = endDate ? (0, $52a805f924e1c770$var$_startOfDay.default)(endDate) : null;
                var isInRange = (!startDate || (0, $52a805f924e1c770$var$_isAfter.default)(day, startDate)) && (!endDate || (0, $52a805f924e1c770$var$_isBefore.default)(day, endDate));
                var isStartEdge = !isInRange && (0, $52a805f924e1c770$var$_isSameDay.default)(day, startDate);
                var isEndEdge = !isInRange && (0, $52a805f924e1c770$var$_isSameDay.default)(day, endDate);
                if (isInRange || isStartEdge || isEndEdge) return [].concat($52a805f924e1c770$var$_toConsumableArray(result), [
                    $52a805f924e1c770$var$_objectSpread({
                        isStartEdge: isStartEdge,
                        isEndEdge: isEndEdge,
                        isInRange: isInRange
                    }, range)
                ]);
                return result;
            }, []);
            return inRanges.map(function(range, i) {
                var _classnames3;
                return /*#__PURE__*/ $52a805f924e1c770$var$_react.default.createElement("span", {
                    key: i,
                    className: (0, $52a805f924e1c770$var$_classnames4.default)((_classnames3 = {}, $52a805f924e1c770$var$_defineProperty(_classnames3, styles.startEdge, range.isStartEdge), $52a805f924e1c770$var$_defineProperty(_classnames3, styles.endEdge, range.isEndEdge), $52a805f924e1c770$var$_defineProperty(_classnames3, styles.inRange, range.isInRange), _classnames3)),
                    style: {
                        color: range.color || _this.props.color
                    }
                });
            });
        });
        _this.state = {
            hover: false,
            active: false
        };
        return _this;
    }
    $52a805f924e1c770$var$_createClass(DayCell, [
        {
            key: "render",
            value: function render() {
                var dayContentRenderer = this.props.dayContentRenderer;
                return /*#__PURE__*/ $52a805f924e1c770$var$_react.default.createElement("button", $52a805f924e1c770$var$_extends({
                    type: "button",
                    onMouseEnter: this.handleMouseEvent,
                    onMouseLeave: this.handleMouseEvent,
                    onFocus: this.handleMouseEvent,
                    onMouseDown: this.handleMouseEvent,
                    onMouseUp: this.handleMouseEvent,
                    onBlur: this.handleMouseEvent,
                    onPauseCapture: this.handleMouseEvent,
                    onKeyDown: this.handleKeyEvent,
                    onKeyUp: this.handleKeyEvent,
                    className: this.getClassNames(this.props.styles)
                }, this.props.disabled || this.props.isPassive ? {
                    tabIndex: -1
                } : {}, {
                    style: {
                        color: this.props.color
                    }
                }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), /*#__PURE__*/ $52a805f924e1c770$var$_react.default.createElement("span", {
                    className: this.props.styles.dayNumber
                }, (dayContentRenderer === null || dayContentRenderer === void 0 ? void 0 : dayContentRenderer(this.props.day)) || /*#__PURE__*/ $52a805f924e1c770$var$_react.default.createElement("span", null, (0, $52a805f924e1c770$var$_format.default)(this.props.day, this.props.dayDisplayFormat))));
            }
        }
    ]);
    return DayCell;
}($52a805f924e1c770$var$_react.Component);
$52a805f924e1c770$var$DayCell.defaultProps = {};
var $52a805f924e1c770$var$rangeShape = $52a805f924e1c770$var$_propTypes.default.shape({
    startDate: $52a805f924e1c770$var$_propTypes.default.object,
    endDate: $52a805f924e1c770$var$_propTypes.default.object,
    color: $52a805f924e1c770$var$_propTypes.default.string,
    key: $52a805f924e1c770$var$_propTypes.default.string,
    autoFocus: $52a805f924e1c770$var$_propTypes.default.bool,
    disabled: $52a805f924e1c770$var$_propTypes.default.bool,
    showDateDisplay: $52a805f924e1c770$var$_propTypes.default.bool
});
module.exports.rangeShape = $52a805f924e1c770$var$rangeShape;
$52a805f924e1c770$var$DayCell.propTypes = {
    day: $52a805f924e1c770$var$_propTypes.default.object.isRequired,
    dayDisplayFormat: $52a805f924e1c770$var$_propTypes.default.string,
    date: $52a805f924e1c770$var$_propTypes.default.object,
    ranges: $52a805f924e1c770$var$_propTypes.default.arrayOf($52a805f924e1c770$var$rangeShape),
    preview: $52a805f924e1c770$var$_propTypes.default.shape({
        startDate: $52a805f924e1c770$var$_propTypes.default.object,
        endDate: $52a805f924e1c770$var$_propTypes.default.object,
        color: $52a805f924e1c770$var$_propTypes.default.string
    }),
    onPreviewChange: $52a805f924e1c770$var$_propTypes.default.func,
    previewColor: $52a805f924e1c770$var$_propTypes.default.string,
    disabled: $52a805f924e1c770$var$_propTypes.default.bool,
    isPassive: $52a805f924e1c770$var$_propTypes.default.bool,
    isToday: $52a805f924e1c770$var$_propTypes.default.bool,
    isWeekend: $52a805f924e1c770$var$_propTypes.default.bool,
    isStartOfWeek: $52a805f924e1c770$var$_propTypes.default.bool,
    isEndOfWeek: $52a805f924e1c770$var$_propTypes.default.bool,
    isStartOfMonth: $52a805f924e1c770$var$_propTypes.default.bool,
    isEndOfMonth: $52a805f924e1c770$var$_propTypes.default.bool,
    color: $52a805f924e1c770$var$_propTypes.default.string,
    displayMode: $52a805f924e1c770$var$_propTypes.default.oneOf([
        "dateRange",
        "date"
    ]),
    styles: $52a805f924e1c770$var$_propTypes.default.object,
    onMouseDown: $52a805f924e1c770$var$_propTypes.default.func,
    onMouseUp: $52a805f924e1c770$var$_propTypes.default.func,
    onMouseEnter: $52a805f924e1c770$var$_propTypes.default.func,
    dayContentRenderer: $52a805f924e1c770$var$_propTypes.default.func
};
var $52a805f924e1c770$var$_default = $52a805f924e1c770$var$DayCell;
module.exports.default = $52a805f924e1c770$var$_default;

});
parcelRegister("kNidb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f23682b0b5b2d802$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $f23682b0b5b2d802$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});
parcelRegister("2XKMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2285621ea3fa8491$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $fnuNu = parcelRequire("fnuNu");
function $2285621ea3fa8491$export$2e2bcd8739ae039(argument) {
    (0, $fnuNu.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $ana82.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("ana82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78d3e8b7d5e47526$export$2e2bcd8739ae039; });
function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fnuNu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b320e4b5494ae3f6$export$2e2bcd8739ae039; });
function $b320e4b5494ae3f6$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});



parcelRegister("1x9Sk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $11e0888ce93790e3$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $11e0888ce93790e3$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $fnuNu.default)(2, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var dateToCompare = (0, $2XKMM.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("lRjt5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $fe9da62f9bebba04$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $fe9da62f9bebba04$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $fnuNu.default)(2, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var dateToCompare = (0, $2XKMM.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("l9Ijw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f66cd00649fade9f$export$2e2bcd8739ae039; });

var $jmtco = parcelRequire("jmtco");

var $fnuNu = parcelRequire("fnuNu");
function $f66cd00649fade9f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fnuNu.default)(2, arguments);
    var dateLeftStartOfDay = (0, $jmtco.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $jmtco.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});
parcelRegister("jmtco", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e186b8b389b84e48$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $e186b8b389b84e48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("iAkvZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d87b809bda78551e$export$2e2bcd8739ae039; });

var $hdCHw = parcelRequire("hdCHw");

var $5oyvs = parcelRequire("5oyvs");

var $2XKMM = parcelRequire("2XKMM");

var $iMjQs = parcelRequire("iMjQs");

var $3zmft = parcelRequire("3zmft");

var $4xr1p = parcelRequire("4xr1p");

var $2Xm3o = parcelRequire("2Xm3o");

var $k35UP = parcelRequire("k35UP");

var $fnuNu = parcelRequire("fnuNu");

var $g2dw1 = parcelRequire("g2dw1");

var $1vnJS = parcelRequire("1vnJS");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $d87b809bda78551e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $d87b809bda78551e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $d87b809bda78551e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $d87b809bda78551e$var$doubleQuoteRegExp = /''/g;
var $d87b809bda78551e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d87b809bda78551e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $fnuNu.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $1vnJS.default);
    var firstWeekContainsDate = (0, $k35UP.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $k35UP.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $2XKMM.default)(dirtyDate);
    if (!(0, $hdCHw.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $4xr1p.default)(originalDate);
    var utcDate = (0, $5oyvs.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($d87b809bda78551e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $3zmft.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($d87b809bda78551e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $d87b809bda78551e$var$cleanEscapedString(substring);
        var formatter = (0, $iMjQs.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $2Xm3o.isProtectedWeekYearToken)(substring)) (0, $2Xm3o.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $2Xm3o.isProtectedDayOfYearToken)(substring)) (0, $2Xm3o.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($d87b809bda78551e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $d87b809bda78551e$var$cleanEscapedString(input) {
    var matched = input.match($d87b809bda78551e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($d87b809bda78551e$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("hdCHw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c891abca0473dd2d$export$2e2bcd8739ae039; });

var $fJsWq = parcelRequire("fJsWq");

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $c891abca0473dd2d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    if (!(0, $fJsWq.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $2XKMM.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("fJsWq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b741822595cea3a4$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $fnuNu = parcelRequire("fnuNu");
function $b741822595cea3a4$export$2e2bcd8739ae039(value) {
    (0, $fnuNu.default)(1, arguments);
    return value instanceof Date || (0, $ana82.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});


parcelRegister("5oyvs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ed9f5de8fc7a4e8$export$2e2bcd8739ae039; });

var $hEtRc = parcelRequire("hEtRc");

var $fnuNu = parcelRequire("fnuNu");

var $k35UP = parcelRequire("k35UP");
function $3ed9f5de8fc7a4e8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fnuNu.default)(2, arguments);
    var amount = (0, $k35UP.default)(dirtyAmount);
    return (0, $hEtRc.default)(dirtyDate, -amount);
}

});
parcelRegister("hEtRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd9d55142ab92e73$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $cd9d55142ab92e73$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fnuNu.default)(2, arguments);
    var timestamp = (0, $2XKMM.default)(dirtyDate).getTime();
    var amount = (0, $k35UP.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("k35UP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e988ad2ce58d9c6e$export$2e2bcd8739ae039; });
function $e988ad2ce58d9c6e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("iMjQs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dabc1a88c48a0b4a$export$2e2bcd8739ae039; });

var $6wkLt = parcelRequire("6wkLt");

var $3F9zF = parcelRequire("3F9zF");

var $kgVAH = parcelRequire("kgVAH");

var $ccjH5 = parcelRequire("ccjH5");

var $giKOM = parcelRequire("giKOM");

var $aPk8F = parcelRequire("aPk8F");

var $hT45u = parcelRequire("hT45u");
var $dabc1a88c48a0b4a$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $dabc1a88c48a0b4a$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $hT45u.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $giKOM.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $aPk8F.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $aPk8F.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $kgVAH.default)(date);
        // Padding
        return (0, $aPk8F.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $aPk8F.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $aPk8F.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $aPk8F.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $hT45u.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $aPk8F.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $ccjH5.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $aPk8F.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $3F9zF.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $aPk8F.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $hT45u.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $6wkLt.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $aPk8F.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $aPk8F.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $aPk8F.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $aPk8F.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $hT45u.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $hT45u.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $aPk8F.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $aPk8F.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $hT45u.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $hT45u.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $hT45u.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $dabc1a88c48a0b4a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $dabc1a88c48a0b4a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $dabc1a88c48a0b4a$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $dabc1a88c48a0b4a$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $aPk8F.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $aPk8F.default)(timestamp, token.length);
    }
};
function $dabc1a88c48a0b4a$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $aPk8F.default)(minutes, 2);
}
function $dabc1a88c48a0b4a$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $aPk8F.default)(Math.abs(offset) / 60, 2);
    }
    return $dabc1a88c48a0b4a$var$formatTimezone(offset, dirtyDelimiter);
}
function $dabc1a88c48a0b4a$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $aPk8F.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $aPk8F.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $dabc1a88c48a0b4a$export$2e2bcd8739ae039 = $dabc1a88c48a0b4a$var$formatters;

});
parcelRegister("6wkLt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bf5d6a9545895ce$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
var $4bf5d6a9545895ce$var$MILLISECONDS_IN_DAY = 86400000;
function $4bf5d6a9545895ce$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $4bf5d6a9545895ce$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("3F9zF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aaca0b5e621bcb8$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $ivpDK = parcelRequire("ivpDK");

var $1yDku = parcelRequire("1yDku");

var $fnuNu = parcelRequire("fnuNu");
var $2aaca0b5e621bcb8$var$MILLISECONDS_IN_WEEK = 604800000;
function $2aaca0b5e621bcb8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var diff = (0, $ivpDK.default)(date).getTime() - (0, $1yDku.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2aaca0b5e621bcb8$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("ivpDK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d78f02d3a8ed773a$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $d78f02d3a8ed773a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $2XKMM.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("1yDku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1227796d448c0cba$export$2e2bcd8739ae039; });

var $kgVAH = parcelRequire("kgVAH");

var $ivpDK = parcelRequire("ivpDK");

var $fnuNu = parcelRequire("fnuNu");
function $1227796d448c0cba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var year = (0, $kgVAH.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $ivpDK.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("kgVAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec21f9a77b67097d$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");

var $ivpDK = parcelRequire("ivpDK");
function $ec21f9a77b67097d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $ivpDK.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $ivpDK.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("ccjH5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e15e1d41b5594be$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $6FkVE = parcelRequire("6FkVE");

var $8DoDd = parcelRequire("8DoDd");

var $fnuNu = parcelRequire("fnuNu");
var $8e15e1d41b5594be$var$MILLISECONDS_IN_WEEK = 604800000;
function $8e15e1d41b5594be$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var diff = (0, $6FkVE.default)(date, options).getTime() - (0, $8DoDd.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8e15e1d41b5594be$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("6FkVE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4da6ce6e331a379d$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");

var $k35UP = parcelRequire("k35UP");

var $g2dw1 = parcelRequire("g2dw1");
function $4da6ce6e331a379d$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fnuNu.default)(1, arguments);
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var weekStartsOn = (0, $k35UP.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2XKMM.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("g2dw1", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $bac751230e4fc222$export$430a3269e24b912e; });
var $bac751230e4fc222$var$defaultOptions = {};
function $bac751230e4fc222$export$430a3269e24b912e() {
    return $bac751230e4fc222$var$defaultOptions;
}
function $bac751230e4fc222$export$95365be1b0704abc(newOptions) {
    $bac751230e4fc222$var$defaultOptions = newOptions;
}

});


parcelRegister("8DoDd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $649512878ed71410$export$2e2bcd8739ae039; });

var $giKOM = parcelRequire("giKOM");

var $fnuNu = parcelRequire("fnuNu");

var $6FkVE = parcelRequire("6FkVE");

var $k35UP = parcelRequire("k35UP");

var $g2dw1 = parcelRequire("g2dw1");
function $649512878ed71410$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fnuNu.default)(1, arguments);
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var firstWeekContainsDate = (0, $k35UP.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $giKOM.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $6FkVE.default)(firstWeek, options);
    return date;
}

});
parcelRegister("giKOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bde2a4d7c75e3bf6$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");

var $6FkVE = parcelRequire("6FkVE");

var $k35UP = parcelRequire("k35UP");

var $g2dw1 = parcelRequire("g2dw1");
function $bde2a4d7c75e3bf6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var firstWeekContainsDate = (0, $k35UP.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $6FkVE.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $6FkVE.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("aPk8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e1e49f3280ac08a$export$2e2bcd8739ae039; });
function $7e1e49f3280ac08a$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("hT45u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d05abe6e05e9075a$export$2e2bcd8739ae039; });

var $aPk8F = parcelRequire("aPk8F");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $d05abe6e05e9075a$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $aPk8F.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $aPk8F.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $aPk8F.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $aPk8F.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $aPk8F.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $aPk8F.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $aPk8F.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $aPk8F.default)(fractionalSeconds, token.length);
    }
};
var $d05abe6e05e9075a$export$2e2bcd8739ae039 = $d05abe6e05e9075a$var$formatters;

});


parcelRegister("3zmft", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2995e6109b28643a$export$2e2bcd8739ae039; });
var $2995e6109b28643a$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $2995e6109b28643a$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $2995e6109b28643a$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $2995e6109b28643a$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $2995e6109b28643a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $2995e6109b28643a$var$timeLongFormatter(timePattern, formatLong));
};
var $2995e6109b28643a$var$longFormatters = {
    p: $2995e6109b28643a$var$timeLongFormatter,
    P: $2995e6109b28643a$var$dateTimeLongFormatter
};
var $2995e6109b28643a$export$2e2bcd8739ae039 = $2995e6109b28643a$var$longFormatters;

});

parcelRegister("4xr1p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34df346d5c5052d9$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $34df346d5c5052d9$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("2Xm3o", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $227232e093313922$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $227232e093313922$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $227232e093313922$export$8073c1ae88f0e727; });
var $227232e093313922$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $227232e093313922$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $227232e093313922$export$c6cc36aa33304772(token) {
    return $227232e093313922$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $227232e093313922$export$c6b49d6dceb604a1(token) {
    return $227232e093313922$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $227232e093313922$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("1vnJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $118b19c6d90f072d$export$2e2bcd8739ae039; });

var $fxjwv = parcelRequire("fxjwv");
var $118b19c6d90f072d$export$2e2bcd8739ae039 = (0, $fxjwv.default);

});
parcelRegister("fxjwv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b4f914fe53c31e55$export$2e2bcd8739ae039; });

var $duWDl = parcelRequire("duWDl");

var $eUuwK = parcelRequire("eUuwK");

var $3pgtb = parcelRequire("3pgtb");

var $22YaG = parcelRequire("22YaG");

var $dLHDP = parcelRequire("dLHDP");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b4f914fe53c31e55$var$locale = {
    code: "en-US",
    formatDistance: (0, $duWDl.default),
    formatLong: (0, $eUuwK.default),
    formatRelative: (0, $3pgtb.default),
    localize: (0, $22YaG.default),
    match: (0, $dLHDP.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b4f914fe53c31e55$export$2e2bcd8739ae039 = $b4f914fe53c31e55$var$locale;

});
parcelRegister("duWDl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039; });
var $9d3b8f1bbb60dc8e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $9d3b8f1bbb60dc8e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9d3b8f1bbb60dc8e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039 = $9d3b8f1bbb60dc8e$var$formatDistance;

});

parcelRegister("eUuwK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adadf9b5f344c056$export$2e2bcd8739ae039; });

var $ael97 = parcelRequire("ael97");
var $adadf9b5f344c056$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $adadf9b5f344c056$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $adadf9b5f344c056$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $adadf9b5f344c056$var$formatLong = {
    date: (0, $ael97.default)({
        formats: $adadf9b5f344c056$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $ael97.default)({
        formats: $adadf9b5f344c056$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $ael97.default)({
        formats: $adadf9b5f344c056$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $adadf9b5f344c056$export$2e2bcd8739ae039 = $adadf9b5f344c056$var$formatLong;

});
parcelRegister("ael97", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $772b9d5c5acb67c6$export$2e2bcd8739ae039; });
function $772b9d5c5acb67c6$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("3pgtb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27b07b6969b3b18a$export$2e2bcd8739ae039; });
var $27b07b6969b3b18a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $27b07b6969b3b18a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $27b07b6969b3b18a$var$formatRelativeLocale[token];
};
var $27b07b6969b3b18a$export$2e2bcd8739ae039 = $27b07b6969b3b18a$var$formatRelative;

});

parcelRegister("22YaG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17da716efdeaa8e3$export$2e2bcd8739ae039; });

var $3PIkV = parcelRequire("3PIkV");
var $17da716efdeaa8e3$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $17da716efdeaa8e3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $17da716efdeaa8e3$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $17da716efdeaa8e3$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $17da716efdeaa8e3$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $17da716efdeaa8e3$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $17da716efdeaa8e3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $17da716efdeaa8e3$var$localize = {
    ordinalNumber: $17da716efdeaa8e3$var$ordinalNumber,
    era: (0, $3PIkV.default)({
        values: $17da716efdeaa8e3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $3PIkV.default)({
        values: $17da716efdeaa8e3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $3PIkV.default)({
        values: $17da716efdeaa8e3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $3PIkV.default)({
        values: $17da716efdeaa8e3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $3PIkV.default)({
        values: $17da716efdeaa8e3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $17da716efdeaa8e3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $17da716efdeaa8e3$export$2e2bcd8739ae039 = $17da716efdeaa8e3$var$localize;

});
parcelRegister("3PIkV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ca886d2c8d77e4d$export$2e2bcd8739ae039; });
function $2ca886d2c8d77e4d$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("dLHDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0618466070b1817$export$2e2bcd8739ae039; });

var $iCg6R = parcelRequire("iCg6R");

var $bueNU = parcelRequire("bueNU");
var $a0618466070b1817$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $a0618466070b1817$var$parseOrdinalNumberPattern = /\d+/i;
var $a0618466070b1817$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $a0618466070b1817$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $a0618466070b1817$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $a0618466070b1817$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a0618466070b1817$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $a0618466070b1817$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a0618466070b1817$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $a0618466070b1817$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $a0618466070b1817$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $a0618466070b1817$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $a0618466070b1817$var$match = {
    ordinalNumber: (0, $bueNU.default)({
        matchPattern: $a0618466070b1817$var$matchOrdinalNumberPattern,
        parsePattern: $a0618466070b1817$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $iCg6R.default)({
        matchPatterns: $a0618466070b1817$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $iCg6R.default)({
        matchPatterns: $a0618466070b1817$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $iCg6R.default)({
        matchPatterns: $a0618466070b1817$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $iCg6R.default)({
        matchPatterns: $a0618466070b1817$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $iCg6R.default)({
        matchPatterns: $a0618466070b1817$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a0618466070b1817$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a0618466070b1817$export$2e2bcd8739ae039 = $a0618466070b1817$var$match;

});
parcelRegister("iCg6R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8d845ab692d6dea$export$2e2bcd8739ae039; });
function $d8d845ab692d6dea$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $d8d845ab692d6dea$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $d8d845ab692d6dea$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d8d845ab692d6dea$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d8d845ab692d6dea$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("bueNU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85cdfad058df8fd3$export$2e2bcd8739ae039; });
function $85cdfad058df8fd3$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("kVI1U", function(module, exports) {
"use strict";
function $f3cb48ec8ee3ff40$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f3cb48ec8ee3ff40$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f3cb48ec8ee3ff40$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f3cb48ec8ee3ff40$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3cb48ec8ee3ff40$var$_react = $f3cb48ec8ee3ff40$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $f3cb48ec8ee3ff40$var$_propTypes = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("bisEj")));

var $f3cb48ec8ee3ff40$var$_DayCell = $f3cb48ec8ee3ff40$var$_interopRequireWildcard((parcelRequire("75YCw")));

var $f3cb48ec8ee3ff40$var$_eachDayOfInterval = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("ehFje")));

var $f3cb48ec8ee3ff40$var$_isWithinInterval = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("dJtzp")));

var $f3cb48ec8ee3ff40$var$_isWeekend = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("iZuO7")));

var $f3cb48ec8ee3ff40$var$_isAfter = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("lRjt5")));

var $f3cb48ec8ee3ff40$var$_isSameDay = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("l9Ijw")));

var $f3cb48ec8ee3ff40$var$_isBefore = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("1x9Sk")));

var $f3cb48ec8ee3ff40$var$_endOfWeek = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("h3DSD")));

var $f3cb48ec8ee3ff40$var$_startOfWeek = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("9zB2r")));

var $f3cb48ec8ee3ff40$var$_endOfDay = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("kNidb")));

var $f3cb48ec8ee3ff40$var$_startOfDay = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("jmtco")));

var $f3cb48ec8ee3ff40$var$_format = $f3cb48ec8ee3ff40$var$_interopRequireDefault((parcelRequire("iAkvZ")));

var $1iPS5 = parcelRequire("1iPS5");
function $f3cb48ec8ee3ff40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f3cb48ec8ee3ff40$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f3cb48ec8ee3ff40$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f3cb48ec8ee3ff40$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $f3cb48ec8ee3ff40$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f3cb48ec8ee3ff40$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f3cb48ec8ee3ff40$var$_extends() {
    $f3cb48ec8ee3ff40$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f3cb48ec8ee3ff40$var$_extends.apply(this, arguments);
}
function $f3cb48ec8ee3ff40$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f3cb48ec8ee3ff40$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f3cb48ec8ee3ff40$var$ownKeys(Object(source), true).forEach(function(key) {
            $f3cb48ec8ee3ff40$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f3cb48ec8ee3ff40$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f3cb48ec8ee3ff40$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f3cb48ec8ee3ff40$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f3cb48ec8ee3ff40$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f3cb48ec8ee3ff40$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f3cb48ec8ee3ff40$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f3cb48ec8ee3ff40$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f3cb48ec8ee3ff40$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f3cb48ec8ee3ff40$var$_setPrototypeOf(subClass, superClass);
}
function $f3cb48ec8ee3ff40$var$_setPrototypeOf(o, p) {
    $f3cb48ec8ee3ff40$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f3cb48ec8ee3ff40$var$_setPrototypeOf(o, p);
}
function $f3cb48ec8ee3ff40$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f3cb48ec8ee3ff40$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f3cb48ec8ee3ff40$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f3cb48ec8ee3ff40$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f3cb48ec8ee3ff40$var$_possibleConstructorReturn(this, result);
    };
}
function $f3cb48ec8ee3ff40$var$_possibleConstructorReturn(self, call) {
    if (call && ($f3cb48ec8ee3ff40$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f3cb48ec8ee3ff40$var$_assertThisInitialized(self);
}
function $f3cb48ec8ee3ff40$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f3cb48ec8ee3ff40$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f3cb48ec8ee3ff40$var$_getPrototypeOf(o) {
    $f3cb48ec8ee3ff40$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f3cb48ec8ee3ff40$var$_getPrototypeOf(o);
}
function $f3cb48ec8ee3ff40$var$renderWeekdays(styles, dateOptions, weekdayDisplayFormat) {
    var now = new Date();
    return /*#__PURE__*/ $f3cb48ec8ee3ff40$var$_react.default.createElement("div", {
        className: styles.weekDays
    }, (0, $f3cb48ec8ee3ff40$var$_eachDayOfInterval.default)({
        start: (0, $f3cb48ec8ee3ff40$var$_startOfWeek.default)(now, dateOptions),
        end: (0, $f3cb48ec8ee3ff40$var$_endOfWeek.default)(now, dateOptions)
    }).map(function(day, i) {
        return /*#__PURE__*/ $f3cb48ec8ee3ff40$var$_react.default.createElement("span", {
            className: styles.weekDay,
            key: i
        }, (0, $f3cb48ec8ee3ff40$var$_format.default)(day, weekdayDisplayFormat, dateOptions));
    }));
}
var $f3cb48ec8ee3ff40$var$Month = /*#__PURE__*/ function(_PureComponent) {
    $f3cb48ec8ee3ff40$var$_inherits(Month, _PureComponent);
    var _super = $f3cb48ec8ee3ff40$var$_createSuper(Month);
    function Month() {
        $f3cb48ec8ee3ff40$var$_classCallCheck(this, Month);
        return _super.apply(this, arguments);
    }
    $f3cb48ec8ee3ff40$var$_createClass(Month, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var now = new Date();
                var _this$props = this.props, displayMode = _this$props.displayMode, focusedRange = _this$props.focusedRange, drag = _this$props.drag, styles = _this$props.styles, disabledDates = _this$props.disabledDates, disabledDay = _this$props.disabledDay;
                var minDate = this.props.minDate && (0, $f3cb48ec8ee3ff40$var$_startOfDay.default)(this.props.minDate);
                var maxDate = this.props.maxDate && (0, $f3cb48ec8ee3ff40$var$_endOfDay.default)(this.props.maxDate);
                var monthDisplay = (0, $1iPS5.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight);
                var ranges = this.props.ranges;
                if (displayMode === "dateRange" && drag.status) {
                    var _drag$range = drag.range, startDate = _drag$range.startDate, endDate = _drag$range.endDate;
                    ranges = ranges.map(function(range, i) {
                        if (i !== focusedRange[0]) return range;
                        return $f3cb48ec8ee3ff40$var$_objectSpread($f3cb48ec8ee3ff40$var$_objectSpread({}, range), {}, {
                            startDate: startDate,
                            endDate: endDate
                        });
                    });
                }
                var showPreview = this.props.showPreview && !drag.disablePreview;
                return /*#__PURE__*/ $f3cb48ec8ee3ff40$var$_react.default.createElement("div", {
                    className: styles.month,
                    style: this.props.style
                }, this.props.showMonthName ? /*#__PURE__*/ $f3cb48ec8ee3ff40$var$_react.default.createElement("div", {
                    className: styles.monthName
                }, (0, $f3cb48ec8ee3ff40$var$_format.default)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && $f3cb48ec8ee3ff40$var$renderWeekdays(styles, this.props.dateOptions, this.props.weekdayDisplayFormat), /*#__PURE__*/ $f3cb48ec8ee3ff40$var$_react.default.createElement("div", {
                    className: styles.days,
                    onMouseLeave: this.props.onMouseLeave
                }, (0, $f3cb48ec8ee3ff40$var$_eachDayOfInterval.default)({
                    start: monthDisplay.start,
                    end: monthDisplay.end
                }).map(function(day, index) {
                    var isStartOfMonth = (0, $f3cb48ec8ee3ff40$var$_isSameDay.default)(day, monthDisplay.startDateOfMonth);
                    var isEndOfMonth = (0, $f3cb48ec8ee3ff40$var$_isSameDay.default)(day, monthDisplay.endDateOfMonth);
                    var isOutsideMinMax = minDate && (0, $f3cb48ec8ee3ff40$var$_isBefore.default)(day, minDate) || maxDate && (0, $f3cb48ec8ee3ff40$var$_isAfter.default)(day, maxDate);
                    var isDisabledSpecifically = disabledDates.some(function(disabledDate) {
                        return (0, $f3cb48ec8ee3ff40$var$_isSameDay.default)(disabledDate, day);
                    });
                    var isDisabledDay = disabledDay(day);
                    return /*#__PURE__*/ $f3cb48ec8ee3ff40$var$_react.default.createElement($f3cb48ec8ee3ff40$var$_DayCell.default, $f3cb48ec8ee3ff40$var$_extends({}, _this.props, {
                        ranges: ranges,
                        day: day,
                        preview: showPreview ? _this.props.preview : null,
                        isWeekend: (0, $f3cb48ec8ee3ff40$var$_isWeekend.default)(day, _this.props.dateOptions),
                        isToday: (0, $f3cb48ec8ee3ff40$var$_isSameDay.default)(day, now),
                        isStartOfWeek: (0, $f3cb48ec8ee3ff40$var$_isSameDay.default)(day, (0, $f3cb48ec8ee3ff40$var$_startOfWeek.default)(day, _this.props.dateOptions)),
                        isEndOfWeek: (0, $f3cb48ec8ee3ff40$var$_isSameDay.default)(day, (0, $f3cb48ec8ee3ff40$var$_endOfWeek.default)(day, _this.props.dateOptions)),
                        isStartOfMonth: isStartOfMonth,
                        isEndOfMonth: isEndOfMonth,
                        key: index,
                        disabled: isOutsideMinMax || isDisabledSpecifically || isDisabledDay,
                        isPassive: !(0, $f3cb48ec8ee3ff40$var$_isWithinInterval.default)(day, {
                            start: monthDisplay.startDateOfMonth,
                            end: monthDisplay.endDateOfMonth
                        }),
                        styles: styles,
                        onMouseDown: _this.props.onDragSelectionStart,
                        onMouseUp: _this.props.onDragSelectionEnd,
                        onMouseEnter: _this.props.onDragSelectionMove,
                        dragRange: drag.range,
                        drag: drag.status
                    }));
                })));
            }
        }
    ]);
    return Month;
}($f3cb48ec8ee3ff40$var$_react.PureComponent);
$f3cb48ec8ee3ff40$var$Month.defaultProps = {};
$f3cb48ec8ee3ff40$var$Month.propTypes = {
    style: $f3cb48ec8ee3ff40$var$_propTypes.default.object,
    styles: $f3cb48ec8ee3ff40$var$_propTypes.default.object,
    month: $f3cb48ec8ee3ff40$var$_propTypes.default.object,
    drag: $f3cb48ec8ee3ff40$var$_propTypes.default.object,
    dateOptions: $f3cb48ec8ee3ff40$var$_propTypes.default.object,
    disabledDates: $f3cb48ec8ee3ff40$var$_propTypes.default.array,
    disabledDay: $f3cb48ec8ee3ff40$var$_propTypes.default.func,
    preview: $f3cb48ec8ee3ff40$var$_propTypes.default.shape({
        startDate: $f3cb48ec8ee3ff40$var$_propTypes.default.object,
        endDate: $f3cb48ec8ee3ff40$var$_propTypes.default.object
    }),
    showPreview: $f3cb48ec8ee3ff40$var$_propTypes.default.bool,
    displayMode: $f3cb48ec8ee3ff40$var$_propTypes.default.oneOf([
        "dateRange",
        "date"
    ]),
    minDate: $f3cb48ec8ee3ff40$var$_propTypes.default.object,
    maxDate: $f3cb48ec8ee3ff40$var$_propTypes.default.object,
    ranges: $f3cb48ec8ee3ff40$var$_propTypes.default.arrayOf($f3cb48ec8ee3ff40$var$_DayCell.rangeShape),
    focusedRange: $f3cb48ec8ee3ff40$var$_propTypes.default.arrayOf($f3cb48ec8ee3ff40$var$_propTypes.default.number),
    onDragSelectionStart: $f3cb48ec8ee3ff40$var$_propTypes.default.func,
    onDragSelectionEnd: $f3cb48ec8ee3ff40$var$_propTypes.default.func,
    onDragSelectionMove: $f3cb48ec8ee3ff40$var$_propTypes.default.func,
    onMouseLeave: $f3cb48ec8ee3ff40$var$_propTypes.default.func,
    monthDisplayFormat: $f3cb48ec8ee3ff40$var$_propTypes.default.string,
    weekdayDisplayFormat: $f3cb48ec8ee3ff40$var$_propTypes.default.string,
    dayDisplayFormat: $f3cb48ec8ee3ff40$var$_propTypes.default.string,
    showWeekDays: $f3cb48ec8ee3ff40$var$_propTypes.default.bool,
    showMonthName: $f3cb48ec8ee3ff40$var$_propTypes.default.bool,
    fixedHeight: $f3cb48ec8ee3ff40$var$_propTypes.default.bool
};
var $f3cb48ec8ee3ff40$var$_default = $f3cb48ec8ee3ff40$var$Month;
module.exports.default = $f3cb48ec8ee3ff40$var$_default;

});
parcelRegister("ehFje", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a662b26130678ea8$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $a662b26130678ea8$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $fnuNu.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $2XKMM.default)(interval.start);
    var endDate = (0, $2XKMM.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
    while(currentDate.getTime() <= endTime){
        dates.push((0, $2XKMM.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

});

parcelRegister("dJtzp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9ff66a5d682467d6$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $9ff66a5d682467d6$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $fnuNu.default)(2, arguments);
    var time = (0, $2XKMM.default)(dirtyDate).getTime();
    var startTime = (0, $2XKMM.default)(interval.start).getTime();
    var endTime = (0, $2XKMM.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}

});

parcelRegister("iZuO7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $dd35d23387142922$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $dd35d23387142922$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var day = date.getDay();
    return day === 0 || day === 6;
}

});

parcelRegister("h3DSD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c6b1a6da55ca19a0$export$2e2bcd8739ae039; });

var $g2dw1 = parcelRequire("g2dw1");

var $2XKMM = parcelRequire("2XKMM");

var $k35UP = parcelRequire("k35UP");

var $fnuNu = parcelRequire("fnuNu");
function $c6b1a6da55ca19a0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fnuNu.default)(1, arguments);
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var weekStartsOn = (0, $k35UP.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2XKMM.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("9zB2r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6f841cfcdd03d288$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $k35UP = parcelRequire("k35UP");

var $fnuNu = parcelRequire("fnuNu");

var $g2dw1 = parcelRequire("g2dw1");
function $6f841cfcdd03d288$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fnuNu.default)(1, arguments);
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var weekStartsOn = (0, $k35UP.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2XKMM.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("1iPS5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcFocusDate = $0f2fb56ece72b1f7$var$calcFocusDate;
module.exports.findNextRangeIndex = $0f2fb56ece72b1f7$var$findNextRangeIndex;
module.exports.getMonthDisplayRange = $0f2fb56ece72b1f7$var$getMonthDisplayRange;
module.exports.generateStyles = $0f2fb56ece72b1f7$var$generateStyles;

var $0f2fb56ece72b1f7$var$_classnames = $0f2fb56ece72b1f7$var$_interopRequireDefault((parcelRequire("eH0la")));

var $0f2fb56ece72b1f7$var$_addDays = $0f2fb56ece72b1f7$var$_interopRequireDefault((parcelRequire("czacj")));

var $0f2fb56ece72b1f7$var$_differenceInCalendarMonths = $0f2fb56ece72b1f7$var$_interopRequireDefault((parcelRequire("11VSy")));

var $0f2fb56ece72b1f7$var$_differenceInCalendarDays = $0f2fb56ece72b1f7$var$_interopRequireDefault((parcelRequire("irUS8")));

var $0f2fb56ece72b1f7$var$_endOfWeek = $0f2fb56ece72b1f7$var$_interopRequireDefault((parcelRequire("h3DSD")));

var $0f2fb56ece72b1f7$var$_startOfWeek = $0f2fb56ece72b1f7$var$_interopRequireDefault((parcelRequire("9zB2r")));

var $0f2fb56ece72b1f7$var$_endOfMonth = $0f2fb56ece72b1f7$var$_interopRequireDefault((parcelRequire("2xHvS")));

var $0f2fb56ece72b1f7$var$_startOfMonth = $0f2fb56ece72b1f7$var$_interopRequireDefault((parcelRequire("YqHFX")));
function $0f2fb56ece72b1f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0f2fb56ece72b1f7$var$calcFocusDate(currentFocusedDate, props) {
    var shownDate = props.shownDate, date = props.date, months = props.months, ranges = props.ranges, focusedRange = props.focusedRange, displayMode = props.displayMode; // find primary date according the props
    var targetInterval;
    if (displayMode === "dateRange") {
        var range = ranges[focusedRange[0]] || {};
        targetInterval = {
            start: range.startDate,
            end: range.endDate
        };
    } else targetInterval = {
        start: date,
        end: date
    };
    targetInterval.start = (0, $0f2fb56ece72b1f7$var$_startOfMonth.default)(targetInterval.start || new Date());
    targetInterval.end = (0, $0f2fb56ece72b1f7$var$_endOfMonth.default)(targetInterval.end || targetInterval.start);
    var targetDate = targetInterval.start || targetInterval.end || shownDate || new Date(); // initial focus
    if (!currentFocusedDate) return shownDate || targetDate; // // just return targetDate for native scrolled calendars
    // if (props.scroll.enabled) return targetDate;
    if ((0, $0f2fb56ece72b1f7$var$_differenceInCalendarMonths.default)(targetInterval.start, targetInterval.end) > months) // don't change focused if new selection in view area
    return currentFocusedDate;
    return targetDate;
}
function $0f2fb56ece72b1f7$var$findNextRangeIndex(ranges) {
    var currentRangeIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var nextIndex = ranges.findIndex(function(range, i) {
        return i > currentRangeIndex && range.autoFocus !== false && !range.disabled;
    });
    if (nextIndex !== -1) return nextIndex;
    return ranges.findIndex(function(range) {
        return range.autoFocus !== false && !range.disabled;
    });
}
function $0f2fb56ece72b1f7$var$getMonthDisplayRange(date, dateOptions, fixedHeight) {
    var startDateOfMonth = (0, $0f2fb56ece72b1f7$var$_startOfMonth.default)(date, dateOptions);
    var endDateOfMonth = (0, $0f2fb56ece72b1f7$var$_endOfMonth.default)(date, dateOptions);
    var startDateOfCalendar = (0, $0f2fb56ece72b1f7$var$_startOfWeek.default)(startDateOfMonth, dateOptions);
    var endDateOfCalendar = (0, $0f2fb56ece72b1f7$var$_endOfWeek.default)(endDateOfMonth, dateOptions);
    if (fixedHeight && (0, $0f2fb56ece72b1f7$var$_differenceInCalendarDays.default)(endDateOfCalendar, startDateOfCalendar) <= 34) endDateOfCalendar = (0, $0f2fb56ece72b1f7$var$_addDays.default)(endDateOfCalendar, 7);
    return {
        start: startDateOfCalendar,
        end: endDateOfCalendar,
        startDateOfMonth: startDateOfMonth,
        endDateOfMonth: endDateOfMonth
    };
}
function $0f2fb56ece72b1f7$var$generateStyles(sources) {
    if (!sources.length) return {};
    var generatedStyles = sources.filter(function(source) {
        return Boolean(source);
    }).reduce(function(styles, styleSource) {
        Object.keys(styleSource).forEach(function(key) {
            styles[key] = (0, $0f2fb56ece72b1f7$var$_classnames.default)(styles[key], styleSource[key]);
        });
        return styles;
    }, {});
    return generatedStyles;
}

});
parcelRegister("czacj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9260a9ed67d17426$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $9260a9ed67d17426$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fnuNu.default)(2, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var amount = (0, $k35UP.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("11VSy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0c02c7faee7ab2f0$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $0c02c7faee7ab2f0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fnuNu.default)(2, arguments);
    var dateLeft = (0, $2XKMM.default)(dirtyDateLeft);
    var dateRight = (0, $2XKMM.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("irUS8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d6e6dd41b8cf835a$export$2e2bcd8739ae039; });

var $4xr1p = parcelRequire("4xr1p");

var $jmtco = parcelRequire("jmtco");

var $fnuNu = parcelRequire("fnuNu");
var $d6e6dd41b8cf835a$var$MILLISECONDS_IN_DAY = 86400000;
function $d6e6dd41b8cf835a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fnuNu.default)(2, arguments);
    var startOfDayLeft = (0, $jmtco.default)(dirtyDateLeft);
    var startOfDayRight = (0, $jmtco.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $4xr1p.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $4xr1p.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $d6e6dd41b8cf835a$var$MILLISECONDS_IN_DAY);
}

});

parcelRegister("2xHvS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1da06aa14904949d$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $1da06aa14904949d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("YqHFX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0b5a5175ac65e18c$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $0b5a5175ac65e18c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("bc0cf", function(module, exports) {
"use strict";
function $8260f7bd87aa1a8b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8260f7bd87aa1a8b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8260f7bd87aa1a8b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8260f7bd87aa1a8b$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8260f7bd87aa1a8b$var$_react = $8260f7bd87aa1a8b$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $8260f7bd87aa1a8b$var$_propTypes = $8260f7bd87aa1a8b$var$_interopRequireDefault((parcelRequire("bisEj")));

var $8260f7bd87aa1a8b$var$_classnames = $8260f7bd87aa1a8b$var$_interopRequireDefault((parcelRequire("eH0la")));

var $8260f7bd87aa1a8b$var$_isEqual = $8260f7bd87aa1a8b$var$_interopRequireDefault((parcelRequire("6hzdd")));

var $8260f7bd87aa1a8b$var$_isValid = $8260f7bd87aa1a8b$var$_interopRequireDefault((parcelRequire("hdCHw")));

var $8260f7bd87aa1a8b$var$_parse = $8260f7bd87aa1a8b$var$_interopRequireDefault((parcelRequire("kERRE")));

var $8260f7bd87aa1a8b$var$_format = $8260f7bd87aa1a8b$var$_interopRequireDefault((parcelRequire("iAkvZ")));
function $8260f7bd87aa1a8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8260f7bd87aa1a8b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8260f7bd87aa1a8b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8260f7bd87aa1a8b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $8260f7bd87aa1a8b$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8260f7bd87aa1a8b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8260f7bd87aa1a8b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8260f7bd87aa1a8b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8260f7bd87aa1a8b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8260f7bd87aa1a8b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8260f7bd87aa1a8b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8260f7bd87aa1a8b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8260f7bd87aa1a8b$var$_setPrototypeOf(subClass, superClass);
}
function $8260f7bd87aa1a8b$var$_setPrototypeOf(o, p) {
    $8260f7bd87aa1a8b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8260f7bd87aa1a8b$var$_setPrototypeOf(o, p);
}
function $8260f7bd87aa1a8b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8260f7bd87aa1a8b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8260f7bd87aa1a8b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8260f7bd87aa1a8b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8260f7bd87aa1a8b$var$_possibleConstructorReturn(this, result);
    };
}
function $8260f7bd87aa1a8b$var$_possibleConstructorReturn(self, call) {
    if (call && ($8260f7bd87aa1a8b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8260f7bd87aa1a8b$var$_assertThisInitialized(self);
}
function $8260f7bd87aa1a8b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8260f7bd87aa1a8b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8260f7bd87aa1a8b$var$_getPrototypeOf(o) {
    $8260f7bd87aa1a8b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8260f7bd87aa1a8b$var$_getPrototypeOf(o);
}
function $8260f7bd87aa1a8b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8260f7bd87aa1a8b$var$DateInput = /*#__PURE__*/ function(_PureComponent) {
    $8260f7bd87aa1a8b$var$_inherits(DateInput, _PureComponent);
    var _super = $8260f7bd87aa1a8b$var$_createSuper(DateInput);
    function DateInput(props, context) {
        var _this;
        $8260f7bd87aa1a8b$var$_classCallCheck(this, DateInput);
        _this = _super.call(this, props, context);
        $8260f7bd87aa1a8b$var$_defineProperty($8260f7bd87aa1a8b$var$_assertThisInitialized(_this), "onKeyDown", function(e) {
            var value = _this.state.value;
            if (e.key === "Enter") _this.update(value);
        });
        $8260f7bd87aa1a8b$var$_defineProperty($8260f7bd87aa1a8b$var$_assertThisInitialized(_this), "onChange", function(e) {
            _this.setState({
                value: e.target.value,
                changed: true,
                invalid: false
            });
        });
        $8260f7bd87aa1a8b$var$_defineProperty($8260f7bd87aa1a8b$var$_assertThisInitialized(_this), "onBlur", function() {
            var value = _this.state.value;
            _this.update(value);
        });
        _this.state = {
            invalid: false,
            changed: false,
            value: _this.formatDate(props)
        };
        return _this;
    }
    $8260f7bd87aa1a8b$var$_createClass(DateInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var value = prevProps.value;
                if (!(0, $8260f7bd87aa1a8b$var$_isEqual.default)(value, this.props.value)) this.setState({
                    value: this.formatDate(this.props)
                });
            }
        },
        {
            key: "formatDate",
            value: function formatDate(_ref) {
                var value = _ref.value, dateDisplayFormat = _ref.dateDisplayFormat, dateOptions = _ref.dateOptions;
                if (value && (0, $8260f7bd87aa1a8b$var$_isValid.default)(value)) return (0, $8260f7bd87aa1a8b$var$_format.default)(value, dateDisplayFormat, dateOptions);
                return "";
            }
        },
        {
            key: "update",
            value: function update(value) {
                var _this$state = this.state, invalid = _this$state.invalid, changed = _this$state.changed;
                if (invalid || !changed || !value) return;
                var _this$props = this.props, onChange = _this$props.onChange, dateDisplayFormat = _this$props.dateDisplayFormat, dateOptions = _this$props.dateOptions;
                var parsed = (0, $8260f7bd87aa1a8b$var$_parse.default)(value, dateDisplayFormat, new Date(), dateOptions);
                if ((0, $8260f7bd87aa1a8b$var$_isValid.default)(parsed)) this.setState({
                    changed: false
                }, function() {
                    return onChange(parsed);
                });
                else this.setState({
                    invalid: true
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, readOnly = _this$props2.readOnly, placeholder = _this$props2.placeholder, ariaLabel = _this$props2.ariaLabel, disabled = _this$props2.disabled, onFocus = _this$props2.onFocus;
                var _this$state2 = this.state, value = _this$state2.value, invalid = _this$state2.invalid;
                return /*#__PURE__*/ $8260f7bd87aa1a8b$var$_react.default.createElement("span", {
                    className: (0, $8260f7bd87aa1a8b$var$_classnames.default)("rdrDateInput", className)
                }, /*#__PURE__*/ $8260f7bd87aa1a8b$var$_react.default.createElement("input", {
                    readOnly: readOnly,
                    disabled: disabled,
                    value: value,
                    placeholder: placeholder,
                    "aria-label": ariaLabel,
                    onKeyDown: this.onKeyDown,
                    onChange: this.onChange,
                    onBlur: this.onBlur,
                    onFocus: onFocus
                }), invalid && /*#__PURE__*/ $8260f7bd87aa1a8b$var$_react.default.createElement("span", {
                    className: "rdrWarning"
                }, "\u26A0"));
            }
        }
    ]);
    return DateInput;
}($8260f7bd87aa1a8b$var$_react.PureComponent);
$8260f7bd87aa1a8b$var$DateInput.propTypes = {
    value: $8260f7bd87aa1a8b$var$_propTypes.default.object,
    placeholder: $8260f7bd87aa1a8b$var$_propTypes.default.string,
    disabled: $8260f7bd87aa1a8b$var$_propTypes.default.bool,
    readOnly: $8260f7bd87aa1a8b$var$_propTypes.default.bool,
    dateOptions: $8260f7bd87aa1a8b$var$_propTypes.default.object,
    dateDisplayFormat: $8260f7bd87aa1a8b$var$_propTypes.default.string,
    ariaLabel: $8260f7bd87aa1a8b$var$_propTypes.default.string,
    className: $8260f7bd87aa1a8b$var$_propTypes.default.string,
    onFocus: $8260f7bd87aa1a8b$var$_propTypes.default.func.isRequired,
    onChange: $8260f7bd87aa1a8b$var$_propTypes.default.func.isRequired
};
$8260f7bd87aa1a8b$var$DateInput.defaultProps = {
    readOnly: true,
    disabled: false,
    dateDisplayFormat: "MMM D, YYYY"
};
var $8260f7bd87aa1a8b$var$_default = $8260f7bd87aa1a8b$var$DateInput;
module.exports.default = $8260f7bd87aa1a8b$var$_default;

});
parcelRegister("6hzdd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $492fa4fddb17a11d$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $492fa4fddb17a11d$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $fnuNu.default)(2, arguments);
    var dateLeft = (0, $2XKMM.default)(dirtyLeftDate);
    var dateRight = (0, $2XKMM.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("kERRE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f0a153661e1d7e62$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $3Aptn = parcelRequire("3Aptn");

var $1vnJS = parcelRequire("1vnJS");

var $5oyvs = parcelRequire("5oyvs");

var $2XKMM = parcelRequire("2XKMM");

var $gXiwJ = parcelRequire("gXiwJ");

var $3zmft = parcelRequire("3zmft");

var $4xr1p = parcelRequire("4xr1p");

var $2Xm3o = parcelRequire("2Xm3o");

var $k35UP = parcelRequire("k35UP");

var $fnuNu = parcelRequire("fnuNu");

var $5Su6w = parcelRequire("5Su6w");

var $jqsZh = parcelRequire("jqsZh");

var $g2dw1 = parcelRequire("g2dw1");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $f0a153661e1d7e62$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $f0a153661e1d7e62$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $f0a153661e1d7e62$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $f0a153661e1d7e62$var$doubleQuoteRegExp = /''/g;
var $f0a153661e1d7e62$var$notWhitespaceRegExp = /\S/;
var $f0a153661e1d7e62$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $f0a153661e1d7e62$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $fnuNu.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $1vnJS.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $k35UP.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $k35UP.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $2XKMM.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $5Su6w.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($f0a153661e1d7e62$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $3zmft.default)) {
            var longFormatter = (0, $3zmft.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($f0a153661e1d7e62$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $3Aptn.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $2Xm3o.isProtectedWeekYearToken)(token)) (0, $2Xm3o.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $2Xm3o.isProtectedDayOfYearToken)(token)) (0, $2Xm3o.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $jqsZh.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($f0a153661e1d7e62$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $f0a153661e1d7e62$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $ana82.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $f0a153661e1d7e62$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $2XKMM.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $5oyvs.default)(date, (0, $4xr1p.default)(date));
    var flags = {};
    var _iterator2 = (0, $3Aptn.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $gXiwJ.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $f0a153661e1d7e62$var$cleanEscapedString(input) {
    return input.match($f0a153661e1d7e62$var$escapedStringRegExp)[1].replace($f0a153661e1d7e62$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("3Aptn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29c87e3f6b0a3b4e$export$2e2bcd8739ae039; });

var $45CPT = parcelRequire("45CPT");
function $29c87e3f6b0a3b4e$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $45CPT.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("45CPT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fa5c1109958a2fc$export$2e2bcd8739ae039; });

var $5z2Zn = parcelRequire("5z2Zn");
function $2fa5c1109958a2fc$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5z2Zn.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5z2Zn.default)(r, a) : void 0;
    }
}

});
parcelRegister("5z2Zn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40d28a29bc3d0243$export$2e2bcd8739ae039; });
function $40d28a29bc3d0243$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("gXiwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c58087165184dc10$export$2e2bcd8739ae039; });
function $c58087165184dc10$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("5Su6w", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $447958f32e80cf99$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $447958f32e80cf99$export$5aaf7ff7f09ea4ee; });

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $lB7P9 = parcelRequire("lB7P9");
var $447958f32e80cf99$var$TIMEZONE_UNIT_PRIORITY = 10;
var $447958f32e80cf99$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $kd56n.default)(this, Setter);
        (0, $lB7P9.default)(this, "priority", void 0);
        (0, $lB7P9.default)(this, "subPriority", 0);
    }
    (0, $6kKbN.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $447958f32e80cf99$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $8EMLg.default)(ValueSetter, _Setter);
    var _super = (0, $1ZRiV.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $kd56n.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $6kKbN.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($447958f32e80cf99$export$81d53e3678089a6);
var $447958f32e80cf99$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $8EMLg.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $1ZRiV.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $kd56n.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this2), "priority", $447958f32e80cf99$var$TIMEZONE_UNIT_PRIORITY);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $6kKbN.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($447958f32e80cf99$export$81d53e3678089a6);

});
parcelRegister("bYAPj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b81dd4f51678982$export$2e2bcd8739ae039; });
function $8b81dd4f51678982$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("8EMLg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d7e21dc5e0f704$export$2e2bcd8739ae039; });

var $5NwIB = parcelRequire("5NwIB");
function $64d7e21dc5e0f704$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $5NwIB.default)(t, e);
}

});
parcelRegister("5NwIB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $438ae88f4b206ba2$export$2e2bcd8739ae039; });
function $438ae88f4b206ba2$export$2e2bcd8739ae039(t, e) {
    return $438ae88f4b206ba2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $438ae88f4b206ba2$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("1ZRiV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1744d611733dc217$export$2e2bcd8739ae039; });

var $1wiRZ = parcelRequire("1wiRZ");

var $fVf3e = parcelRequire("fVf3e");

var $trDLD = parcelRequire("trDLD");
function $1744d611733dc217$export$2e2bcd8739ae039(t) {
    var r = (0, $fVf3e.default)();
    return function() {
        var e, o = (0, $1wiRZ.default)(t);
        if (r) {
            var s = (0, $1wiRZ.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $trDLD.default)(this, e);
    };
}

});
parcelRegister("1wiRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11b76ac3717bcb79$export$2e2bcd8739ae039; });
function $11b76ac3717bcb79$export$2e2bcd8739ae039(t) {
    return $11b76ac3717bcb79$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $11b76ac3717bcb79$export$2e2bcd8739ae039(t);
}

});

parcelRegister("fVf3e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b977dabd4d3277fe$export$2e2bcd8739ae039; });
function $b977dabd4d3277fe$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b977dabd4d3277fe$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("trDLD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0588265b6dbabb0b$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $bYAPj = parcelRequire("bYAPj");
function $0588265b6dbabb0b$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $ana82.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $bYAPj.default)(t);
}

});


parcelRegister("kd56n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb68faaebde2ec0f$export$2e2bcd8739ae039; });
function $eb68faaebde2ec0f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6kKbN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49c8709106076573$export$2e2bcd8739ae039; });

var $d9KNw = parcelRequire("d9KNw");
function $49c8709106076573$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $d9KNw.default)(o.key), o);
    }
}
function $49c8709106076573$export$2e2bcd8739ae039(e, r, t) {
    return r && $49c8709106076573$var$_defineProperties(e.prototype, r), t && $49c8709106076573$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("d9KNw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99406aaafdabc25e$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $g7Qem = parcelRequire("g7Qem");
function $99406aaafdabc25e$export$2e2bcd8739ae039(t) {
    var i = (0, $g7Qem.default)(t, "string");
    return "symbol" == (0, $ana82.default)(i) ? i : i + "";
}

});
parcelRegister("g7Qem", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbd5d0b4a89d436f$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");
function $bbd5d0b4a89d436f$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ana82.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ana82.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("lB7P9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb931f60d8d226d8$export$2e2bcd8739ae039; });

var $d9KNw = parcelRequire("d9KNw");
function $fb931f60d8d226d8$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d9KNw.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("jqsZh", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $e246ee57e0aa4053$export$19131010e7fd8373; });

var $54rnT = parcelRequire("54rnT");

var $TVAX3 = parcelRequire("TVAX3");

var $Exi4T = parcelRequire("Exi4T");

var $j7DqM = parcelRequire("j7DqM");

var $4SkXR = parcelRequire("4SkXR");

var $ljAQy = parcelRequire("ljAQy");

var $eLQge = parcelRequire("eLQge");

var $jeKQ9 = parcelRequire("jeKQ9");

var $ajklC = parcelRequire("ajklC");

var $bLfER = parcelRequire("bLfER");

var $4hf2D = parcelRequire("4hf2D");

var $BZQVC = parcelRequire("BZQVC");

var $awBOQ = parcelRequire("awBOQ");

var $dy6hd = parcelRequire("dy6hd");

var $6WIgd = parcelRequire("6WIgd");

var $fM2w8 = parcelRequire("fM2w8");

var $5U0hi = parcelRequire("5U0hi");

var $aFR1H = parcelRequire("aFR1H");

var $6Tv0s = parcelRequire("6Tv0s");

var $9cQLD = parcelRequire("9cQLD");

var $hwPdQ = parcelRequire("hwPdQ");

var $2WwPy = parcelRequire("2WwPy");

var $lGIwN = parcelRequire("lGIwN");

var $jasXC = parcelRequire("jasXC");

var $24XKh = parcelRequire("24XKh");

var $kaDnO = parcelRequire("kaDnO");

var $bo0g9 = parcelRequire("bo0g9");

var $7qtq2 = parcelRequire("7qtq2");

var $aP5Ps = parcelRequire("aP5Ps");

var $kbQxI = parcelRequire("kbQxI");

var $lNNTb = parcelRequire("lNNTb");
var $e246ee57e0aa4053$export$19131010e7fd8373 = {
    G: new (0, $54rnT.EraParser)(),
    y: new (0, $TVAX3.YearParser)(),
    Y: new (0, $Exi4T.LocalWeekYearParser)(),
    R: new (0, $j7DqM.ISOWeekYearParser)(),
    u: new (0, $4SkXR.ExtendedYearParser)(),
    Q: new (0, $ljAQy.QuarterParser)(),
    q: new (0, $eLQge.StandAloneQuarterParser)(),
    M: new (0, $jeKQ9.MonthParser)(),
    L: new (0, $ajklC.StandAloneMonthParser)(),
    w: new (0, $bLfER.LocalWeekParser)(),
    I: new (0, $4hf2D.ISOWeekParser)(),
    d: new (0, $BZQVC.DateParser)(),
    D: new (0, $awBOQ.DayOfYearParser)(),
    E: new (0, $dy6hd.DayParser)(),
    e: new (0, $6WIgd.LocalDayParser)(),
    c: new (0, $fM2w8.StandAloneLocalDayParser)(),
    i: new (0, $5U0hi.ISODayParser)(),
    a: new (0, $aFR1H.AMPMParser)(),
    b: new (0, $6Tv0s.AMPMMidnightParser)(),
    B: new (0, $9cQLD.DayPeriodParser)(),
    h: new (0, $hwPdQ.Hour1to12Parser)(),
    H: new (0, $2WwPy.Hour0to23Parser)(),
    K: new (0, $lGIwN.Hour0To11Parser)(),
    k: new (0, $jasXC.Hour1To24Parser)(),
    m: new (0, $24XKh.MinuteParser)(),
    s: new (0, $kaDnO.SecondParser)(),
    S: new (0, $bo0g9.FractionOfSecondParser)(),
    X: new (0, $7qtq2.ISOTimezoneWithZParser)(),
    x: new (0, $aP5Ps.ISOTimezoneParser)(),
    t: new (0, $kbQxI.TimestampSecondsParser)(),
    T: new (0, $lNNTb.TimestampMillisecondsParser)()
};

});
parcelRegister("54rnT", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $3b12916df021def5$export$8e5a1d3f85a9688; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");
var $3b12916df021def5$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(EraParser, _Parser);
    var _super = (0, $1ZRiV.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $kd56n.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 140);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $ktOdQ.Parser));

});
parcelRegister("ktOdQ", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $ee8d792dbdb18a2c$export$7acfa6ed01010e37; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $lB7P9 = parcelRequire("lB7P9");

var $5Su6w = parcelRequire("5Su6w");
var $ee8d792dbdb18a2c$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $kd56n.default)(this, Parser);
        (0, $lB7P9.default)(this, "incompatibleTokens", void 0);
        (0, $lB7P9.default)(this, "priority", void 0);
        (0, $lB7P9.default)(this, "subPriority", void 0);
    }
    (0, $6kKbN.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $5Su6w.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("TVAX3", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $0a81d055917143cc$export$48d352de7cd4a988; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $0a81d055917143cc$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(YearParser, _Parser);
    var _super = (0, $1ZRiV.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $kd56n.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 130);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $8VaKB.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $8VaKB.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $ktOdQ.Parser));

});
parcelRegister("8VaKB", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $67ebfc78955a0cfd$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $67ebfc78955a0cfd$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $67ebfc78955a0cfd$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $67ebfc78955a0cfd$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $67ebfc78955a0cfd$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $67ebfc78955a0cfd$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $67ebfc78955a0cfd$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $67ebfc78955a0cfd$export$3d50627710b84d75; });

var $gyoTg = parcelRequire("gyoTg");

var $9J8nL = parcelRequire("9J8nL");
function $67ebfc78955a0cfd$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $67ebfc78955a0cfd$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $gyoTg.millisecondsInHour) + minutes * (0, $gyoTg.millisecondsInMinute) + seconds * (0, $gyoTg.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $67ebfc78955a0cfd$export$d931c43c4608a164(dateString) {
    return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).anyDigitsSigned, dateString);
}
function $67ebfc78955a0cfd$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).singleDigit, dateString);
        case 2:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).twoDigits, dateString);
        case 3:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).threeDigits, dateString);
        case 4:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).fourDigits, dateString);
        default:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $67ebfc78955a0cfd$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388((0, $9J8nL.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $67ebfc78955a0cfd$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $67ebfc78955a0cfd$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $67ebfc78955a0cfd$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $67ebfc78955a0cfd$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("gyoTg", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $c0d321040488d36f$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $c0d321040488d36f$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $c0d321040488d36f$export$397c2d5776aa9055; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $c0d321040488d36f$export$dfd9b671c89acc8e = 7;
var $c0d321040488d36f$export$3913210603d8e9ae = 365.2425;
var $c0d321040488d36f$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $c0d321040488d36f$export$91246f0b9bd9beff = 60000;
var $c0d321040488d36f$export$7f72910d6dfd237a = 3600000;
var $c0d321040488d36f$export$397c2d5776aa9055 = 1000;
var $c0d321040488d36f$export$4dec998e48f9c246 = -$c0d321040488d36f$export$81caae6e1cc7a622;
var $c0d321040488d36f$export$f2f5ae5a8e2d8f9f = 60;
var $c0d321040488d36f$export$3c58128db900d44e = 3;
var $c0d321040488d36f$export$80d7e435f744f319 = 12;
var $c0d321040488d36f$export$4db7641526e3241f = 4;
var $c0d321040488d36f$export$698aec755e92c695 = 3600;
var $c0d321040488d36f$export$a77c1a7ebebe2a5a = 60;
var $c0d321040488d36f$export$815a9362476d2fe3 = $c0d321040488d36f$export$698aec755e92c695 * 24;
var $c0d321040488d36f$export$34804a017b31e2fe = $c0d321040488d36f$export$815a9362476d2fe3 * 7;
var $c0d321040488d36f$export$7271e9e3478110d1 = $c0d321040488d36f$export$815a9362476d2fe3 * $c0d321040488d36f$export$3913210603d8e9ae;
var $c0d321040488d36f$export$8e6600bbdee7dabb = $c0d321040488d36f$export$7271e9e3478110d1 / 12;
var $c0d321040488d36f$export$be1dccf2de902d31 = $c0d321040488d36f$export$8e6600bbdee7dabb * 3;

});

parcelRegister("9J8nL", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $714ed18f41f4ccb1$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $714ed18f41f4ccb1$export$a7ee192b982af9c1; });
var $714ed18f41f4ccb1$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $714ed18f41f4ccb1$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("Exi4T", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $079d8f5b6569f325$export$b8ef38dfcf05d5db; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");

var $giKOM = parcelRequire("giKOM");

var $6FkVE = parcelRequire("6FkVE");
var $079d8f5b6569f325$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $1ZRiV.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $kd56n.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 130);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $8VaKB.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $giKOM.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $8VaKB.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $6FkVE.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $6FkVE.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("j7DqM", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $debd41f1eded8c29$export$951d1df011fde06f; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");

var $ivpDK = parcelRequire("ivpDK");
var $debd41f1eded8c29$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $1ZRiV.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $kd56n.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 130);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $8VaKB.parseNDigitsSigned)(4, dateString);
                return (0, $8VaKB.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $ivpDK.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("4SkXR", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $38cc77b13c288cf9$export$bad9d2ea38e8f1a; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $38cc77b13c288cf9$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(ExtendedYearParser, _Parser);
    var _super = (0, $1ZRiV.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $kd56n.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 130);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $8VaKB.parseNDigitsSigned)(4, dateString);
                return (0, $8VaKB.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("ljAQy", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $f847f44f386bcfc5$export$5cb0f701186dde1d; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $f847f44f386bcfc5$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(QuarterParser, _Parser);
    var _super = (0, $1ZRiV.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $kd56n.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 120);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("eLQge", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $ac0dfe648097b544$export$300c0c2990e20e6d; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $ac0dfe648097b544$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $1ZRiV.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $kd56n.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 120);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("jeKQ9", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $e013a896e95c456a$export$400dd8b40ef138a3; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $8VaKB = parcelRequire("8VaKB");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");
var $e013a896e95c456a$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(MonthParser, _Parser);
    var _super = (0, $1ZRiV.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $kd56n.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 110);
        return _this;
    }
    (0, $6kKbN.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $8VaKB.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("ajklC", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $781b765fdd62f14d$export$1d7eaa53eaa5deba; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $781b765fdd62f14d$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $1ZRiV.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $kd56n.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 110);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $8VaKB.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("bLfER", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $89003ad73a25afd4$export$c4005ffc174e07c0; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");

var $lVeRd = parcelRequire("lVeRd");

var $6FkVE = parcelRequire("6FkVE");
var $89003ad73a25afd4$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(LocalWeekParser, _Parser);
    var _super = (0, $1ZRiV.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $kd56n.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 100);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $6FkVE.default)((0, $lVeRd.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $ktOdQ.Parser));

});
parcelRegister("lVeRd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff5a722dab64bdf7$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $2XKMM = parcelRequire("2XKMM");

var $ccjH5 = parcelRequire("ccjH5");

var $fnuNu = parcelRequire("fnuNu");
function $ff5a722dab64bdf7$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $fnuNu.default)(2, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var week = (0, $k35UP.default)(dirtyWeek);
    var diff = (0, $ccjH5.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("4hf2D", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $31d46ae366f98a50$export$6fc8dbedd560a6af; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");

var $1ApRJ = parcelRequire("1ApRJ");

var $ivpDK = parcelRequire("ivpDK");
var $31d46ae366f98a50$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(ISOWeekParser, _Parser);
    var _super = (0, $1ZRiV.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $kd56n.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 100);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $ivpDK.default)((0, $1ApRJ.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $ktOdQ.Parser));

});
parcelRegister("1ApRJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $127d37a03719a19a$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $2XKMM = parcelRequire("2XKMM");

var $3F9zF = parcelRequire("3F9zF");

var $fnuNu = parcelRequire("fnuNu");
function $127d37a03719a19a$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $fnuNu.default)(2, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var isoWeek = (0, $k35UP.default)(dirtyISOWeek);
    var diff = (0, $3F9zF.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("BZQVC", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $07236f785ad7961b$export$e8d4b28a20981dd2; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $8VaKB = parcelRequire("8VaKB");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");
var $07236f785ad7961b$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $07236f785ad7961b$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $07236f785ad7961b$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(DateParser, _Parser);
    var _super = (0, $1ZRiV.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $kd56n.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 90);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "subPriority", 1);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $8VaKB.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $07236f785ad7961b$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $07236f785ad7961b$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("awBOQ", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $7a9a3a9adb6b2b24$export$6cfe0d613455f615; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $7a9a3a9adb6b2b24$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(DayOfYearParser, _Parser);
    var _super = (0, $1ZRiV.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $kd56n.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 90);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "subpriority", 1);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $8VaKB.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("dy6hd", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $9dd351c2bbeda5cf$export$1b03c8b76262f7bd; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $6zoOz = parcelRequire("6zoOz");
var $9dd351c2bbeda5cf$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(DayParser, _Parser);
    var _super = (0, $1ZRiV.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $kd56n.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 90);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $6zoOz.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $ktOdQ.Parser));

});
parcelRegister("6zoOz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c8942a7339ffc90$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");

var $k35UP = parcelRequire("k35UP");

var $g2dw1 = parcelRequire("g2dw1");
function $4c8942a7339ffc90$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fnuNu.default)(2, arguments);
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var weekStartsOn = (0, $k35UP.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2XKMM.default)(dirtyDate);
    var day = (0, $k35UP.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("6WIgd", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $50ea7e139d8abdc7$export$44d1c127ab42c480; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");

var $6zoOz = parcelRequire("6zoOz");
var $50ea7e139d8abdc7$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(LocalDayParser, _Parser);
    var _super = (0, $1ZRiV.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $kd56n.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 90);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $8VaKB.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $6zoOz.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("fM2w8", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $b7bd4a999151d892$export$e447a647caaaec1d; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");

var $6zoOz = parcelRequire("6zoOz");
var $b7bd4a999151d892$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $1ZRiV.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $kd56n.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 90);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $8VaKB.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $6zoOz.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("5U0hi", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $44c265ea90de47cc$export$693fb1e525095b2a; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");

var $bRRoD = parcelRequire("bRRoD");
var $44c265ea90de47cc$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(ISODayParser, _Parser);
    var _super = (0, $1ZRiV.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $kd56n.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 90);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $8VaKB.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $8VaKB.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $8VaKB.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $8VaKB.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $bRRoD.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $ktOdQ.Parser));

});
parcelRegister("bRRoD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a3e1056ff057fc0$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");

var $k35UP = parcelRequire("k35UP");
function $8a3e1056ff057fc0$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $fnuNu.default)(2, arguments);
    var day = (0, $k35UP.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $2XKMM.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("aFR1H", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $7c56ddad40ae4e3c$export$8d1e08492351df91; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $7c56ddad40ae4e3c$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(AMPMParser, _Parser);
    var _super = (0, $1ZRiV.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $kd56n.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 80);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $8VaKB.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("6Tv0s", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $504fee55b80105ea$export$73ca2bd0a17d273; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $504fee55b80105ea$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $1ZRiV.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $kd56n.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 80);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $8VaKB.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("9cQLD", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $6b3e2a85523742a8$export$bb9212adf05373db; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $6b3e2a85523742a8$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(DayPeriodParser, _Parser);
    var _super = (0, $1ZRiV.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $kd56n.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 80);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $8VaKB.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("hwPdQ", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $cc2d2884737f8763$export$8a04050a727a1756; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $cc2d2884737f8763$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(Hour1to12Parser, _Parser);
    var _super = (0, $1ZRiV.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $kd56n.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 70);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $ktOdQ.Parser));

});

parcelRegister("2WwPy", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $224a7700d78f3d38$export$e56f4dea2c3e56dd; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $224a7700d78f3d38$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(Hour0to23Parser, _Parser);
    var _super = (0, $1ZRiV.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $kd56n.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 70);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $ktOdQ.Parser));

});

parcelRegister("lGIwN", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $fca00f899bc15805$export$cbbe855312f87d77; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $fca00f899bc15805$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(Hour0To11Parser, _Parser);
    var _super = (0, $1ZRiV.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $kd56n.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 70);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $ktOdQ.Parser));

});

parcelRegister("jasXC", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $df456a73f197b571$export$6008046d2b34b6a5; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $df456a73f197b571$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(Hour1To24Parser, _Parser);
    var _super = (0, $1ZRiV.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $kd56n.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 70);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $ktOdQ.Parser));

});

parcelRegister("24XKh", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $183a4cb8635a97c6$export$2b52670d9e2be53; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $183a4cb8635a97c6$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(MinuteParser, _Parser);
    var _super = (0, $1ZRiV.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $kd56n.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 60);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("kaDnO", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $eaf34a7a667cc75c$export$94d46d540cf1366a; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $eaf34a7a667cc75c$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(SecondParser, _Parser);
    var _super = (0, $1ZRiV.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $kd56n.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 50);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $8VaKB.parseNumericPattern)((0, $9J8nL.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $8VaKB.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("bo0g9", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $84a223207d30f404$export$b8e6f8b2d70893b1; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $84a223207d30f404$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $1ZRiV.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $kd56n.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 30);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $8VaKB.mapValue)((0, $8VaKB.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("7qtq2", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $5681c814dce1d928$export$104d901d49fea29b; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $5681c814dce1d928$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $1ZRiV.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $kd56n.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 10);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("aP5Ps", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $7e133054fb21759f$export$12910e5204b52b9; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $9J8nL = parcelRequire("9J8nL");

var $8VaKB = parcelRequire("8VaKB");
var $7e133054fb21759f$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $1ZRiV.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $kd56n.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 10);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $6kKbN.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $8VaKB.parseTimezonePattern)((0, $9J8nL.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("kbQxI", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $eb2d97a5037eae57$export$2cd8bf877a05e96; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $eb2d97a5037eae57$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $1ZRiV.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $kd56n.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 40);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $6kKbN.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $8VaKB.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $ktOdQ.Parser));

});

parcelRegister("lNNTb", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $fdf4df812fca4067$export$6d8f69c6906d6368; });

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $bYAPj = parcelRequire("bYAPj");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $lB7P9 = parcelRequire("lB7P9");

var $ktOdQ = parcelRequire("ktOdQ");

var $8VaKB = parcelRequire("8VaKB");
var $fdf4df812fca4067$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $8EMLg.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $1ZRiV.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $kd56n.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "priority", 20);
        (0, $lB7P9.default)((0, $bYAPj.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $6kKbN.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $8VaKB.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $ktOdQ.Parser));

});




parcelRegister("j02gD", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define("react-list", [
        "prop-types",
        "react"
    ], factory);
    else {
        var mod;
        factory((parcelRequire("bisEj")), (parcelRequire("exYeM")));
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : module.exports, function(_propTypes, _react) {
    "use strict";
    _propTypes = _interopRequireDefault(_propTypes);
    _react = _interopRequireWildcard(_react);
    var _class, _temp;
    function _getRequireWildcardCache() {
        if (typeof WeakMap !== "function") return null;
        var cache = new WeakMap();
        _getRequireWildcardCache = function _getRequireWildcardCache() {
            return cache;
        };
        return cache;
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
            "default": obj
        };
        var cache = _getRequireWildcardCache();
        if (cache && cache.has(obj)) return cache.get(obj);
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        if (cache) cache.set(obj, newObj);
        return newObj;
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self1);
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var CLIENT_SIZE_KEYS = {
        x: "clientWidth",
        y: "clientHeight"
    };
    var CLIENT_START_KEYS = {
        x: "clientTop",
        y: "clientLeft"
    };
    var INNER_SIZE_KEYS = {
        x: "innerWidth",
        y: "innerHeight"
    };
    var OFFSET_SIZE_KEYS = {
        x: "offsetWidth",
        y: "offsetHeight"
    };
    var OFFSET_START_KEYS = {
        x: "offsetLeft",
        y: "offsetTop"
    };
    var OVERFLOW_KEYS = {
        x: "overflowX",
        y: "overflowY"
    };
    var SCROLL_SIZE_KEYS = {
        x: "scrollWidth",
        y: "scrollHeight"
    };
    var SCROLL_START_KEYS = {
        x: "scrollLeft",
        y: "scrollTop"
    };
    var SIZE_KEYS = {
        x: "width",
        y: "height"
    };
    var NOOP = function NOOP() {}; // If a browser doesn't support the `options` argument to
    // add/removeEventListener, we need to check, otherwise we will
    // accidentally set `capture` with a truthy value.
    var PASSIVE = function() {
        if (typeof window === "undefined") return false;
        var hasSupport = false;
        try {
            document.createElement("div").addEventListener("test", NOOP, {
                get passive () {
                    hasSupport = true;
                    return false;
                }
            });
        } catch (e) {}
        return hasSupport;
    }() ? {
        passive: true
    } : false;
    var UNSTABLE_MESSAGE = "ReactList failed to reach a stable state.";
    var MAX_SYNC_UPDATES = 40;
    var isEqualSubset = function isEqualSubset(a, b) {
        for(var key in b){
            if (a[key] !== b[key]) return false;
        }
        return true;
    };
    var defaultScrollParentGetter = function defaultScrollParentGetter(component) {
        var axis = component.props.axis;
        var el = component.getEl();
        var overflowKey = OVERFLOW_KEYS[axis];
        while(el = el.parentElement)switch(window.getComputedStyle(el)[overflowKey]){
            case "auto":
            case "scroll":
            case "overlay":
                return el;
        }
        return window;
    };
    var defaultScrollParentViewportSizeGetter = function defaultScrollParentViewportSizeGetter(component) {
        var axis = component.props.axis;
        var scrollParent = component.scrollParent;
        return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
    };
    var constrain = function constrain(props, state) {
        var length = props.length, minSize = props.minSize, type = props.type;
        var from = state.from, size = state.size, itemsPerRow = state.itemsPerRow;
        size = Math.max(size, minSize);
        var mod = size % itemsPerRow;
        if (mod) size += itemsPerRow - mod;
        if (size > length) size = length;
        from = type === "simple" || !from ? 0 : Math.max(Math.min(from, length - size), 0);
        if (mod = from % itemsPerRow) {
            from -= mod;
            size += mod;
        }
        if (from === state.from && size == state.size) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
            from: from,
            size: size
        });
    };
    module.exports = (_temp = _class = /*#__PURE__*/ function(_Component) {
        _inherits(ReactList, _Component);
        var _super = _createSuper(ReactList);
        _createClass(ReactList, null, [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(props, state) {
                    var newState = constrain(props, state);
                    return newState === state ? null : newState;
                }
            }
        ]);
        function ReactList(props) {
            var _this;
            _classCallCheck(this, ReactList);
            _this = _super.call(this, props);
            _this.state = constrain(props, {
                itemsPerRow: 1,
                from: props.initialIndex,
                size: 0
            });
            _this.cache = {};
            _this.cachedScrollPosition = null;
            _this.prevPrevState = {};
            _this.unstable = false;
            _this.updateCounter = 0;
            return _this;
        }
        _createClass(ReactList, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this);
                    window.addEventListener("resize", this.updateFrameAndClearCache);
                    this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _this2 = this;
                    // Viewport scroll is no longer useful if axis changes
                    if (this.props.axis !== prevProps.axis) this.clearSizeCache(); // If the list has reached an unstable state, prevent an infinite loop.
                    if (this.unstable) return;
                    if (++this.updateCounter > MAX_SYNC_UPDATES) {
                        this.unstable = true;
                        return console.error(UNSTABLE_MESSAGE);
                    }
                    if (!this.updateCounterTimeoutId) this.updateCounterTimeoutId = setTimeout(function() {
                        _this2.updateCounter = 0;
                        delete _this2.updateCounterTimeoutId;
                    }, 0);
                    this.updateFrame();
                }
            },
            {
                key: "maybeSetState",
                value: function maybeSetState(b, cb) {
                    if (isEqualSubset(this.state, b)) return cb();
                    this.setState(b, cb);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.updateFrameAndClearCache);
                    this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, PASSIVE);
                    this.scrollParent.removeEventListener("mousewheel", NOOP, PASSIVE);
                }
            },
            {
                key: "getOffset",
                value: function getOffset(el) {
                    var axis = this.props.axis;
                    var offset = el[CLIENT_START_KEYS[axis]] || 0;
                    var offsetKey = OFFSET_START_KEYS[axis];
                    do offset += el[offsetKey] || 0;
                    while (el = el.offsetParent);
                    return offset;
                }
            },
            {
                key: "getEl",
                value: function getEl() {
                    return this.el || this.items;
                }
            },
            {
                key: "getScrollPosition",
                value: function getScrollPosition() {
                    // Cache scroll position as this causes a forced synchronous layout.
                    if (typeof this.cachedScrollPosition === "number") return this.cachedScrollPosition;
                    var scrollParent = this.scrollParent;
                    var axis = this.props.axis;
                    var scrollKey = SCROLL_START_KEYS[axis];
                    var actual = scrollParent === window ? // always return document.documentElement[scrollKey] as 0, so take
                    // whichever has a value.
                    document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
                    var max = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this);
                    var scroll = Math.max(0, Math.min(actual, max));
                    var el = this.getEl();
                    this.cachedScrollPosition = this.getOffset(scrollParent) + scroll - this.getOffset(el);
                    return this.cachedScrollPosition;
                }
            },
            {
                key: "setScroll",
                value: function setScroll(offset) {
                    var scrollParent = this.scrollParent;
                    var axis = this.props.axis;
                    offset += this.getOffset(this.getEl());
                    if (scrollParent === window) return window.scrollTo(0, offset);
                    offset -= this.getOffset(this.scrollParent);
                    scrollParent[SCROLL_START_KEYS[axis]] = offset;
                }
            },
            {
                key: "getScrollSize",
                value: function getScrollSize() {
                    var scrollParent = this.scrollParent;
                    var _document = document, body = _document.body, documentElement = _document.documentElement;
                    var key = SCROLL_SIZE_KEYS[this.props.axis];
                    return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
                }
            },
            {
                key: "hasDeterminateSize",
                value: function hasDeterminateSize() {
                    var _this$props = this.props, itemSizeGetter = _this$props.itemSizeGetter, type = _this$props.type;
                    return type === "uniform" || itemSizeGetter;
                }
            },
            {
                key: "getStartAndEnd",
                value: function getStartAndEnd() {
                    var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
                    var scroll = this.getScrollPosition();
                    var start = Math.max(0, scroll - threshold);
                    var end = scroll + this.props.scrollParentViewportSizeGetter(this) + threshold;
                    if (this.hasDeterminateSize()) end = Math.min(end, this.getSpaceBefore(this.props.length));
                    return {
                        start: start,
                        end: end
                    };
                }
            },
            {
                key: "getItemSizeAndItemsPerRow",
                value: function getItemSizeAndItemsPerRow() {
                    var _this$props2 = this.props, axis = _this$props2.axis, useStaticSize = _this$props2.useStaticSize;
                    var _this$state = this.state, itemSize = _this$state.itemSize, itemsPerRow = _this$state.itemsPerRow;
                    if (useStaticSize && itemSize && itemsPerRow) return {
                        itemSize: itemSize,
                        itemsPerRow: itemsPerRow
                    };
                    var itemEls = this.items.children;
                    if (!itemEls.length) return {};
                    var firstEl = itemEls[0]; // Firefox has a problem where it will return a *slightly* (less than
                    // thousandths of a pixel) different size for the same element between
                    // renders. This can cause an infinite render loop, so only change the
                    // itemSize when it is significantly different.
                    var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
                    var delta = Math.abs(firstElSize - itemSize);
                    if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
                    if (!itemSize) return {};
                    var startKey = OFFSET_START_KEYS[axis];
                    var firstStart = firstEl[startKey];
                    itemsPerRow = 1;
                    for(var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow])++itemsPerRow;
                    return {
                        itemSize: itemSize,
                        itemsPerRow: itemsPerRow
                    };
                }
            },
            {
                key: "clearSizeCache",
                value: function clearSizeCache() {
                    this.cachedScrollPosition = null;
                } // Called by 'scroll' and 'resize' events, clears scroll position cache.
            },
            {
                key: "updateFrameAndClearCache",
                value: function updateFrameAndClearCache(cb) {
                    this.clearSizeCache();
                    return this.updateFrame(cb);
                }
            },
            {
                key: "updateFrame",
                value: function updateFrame(cb) {
                    this.updateScrollParent();
                    if (typeof cb != "function") cb = NOOP;
                    switch(this.props.type){
                        case "simple":
                            return this.updateSimpleFrame(cb);
                        case "variable":
                            return this.updateVariableFrame(cb);
                        case "uniform":
                            return this.updateUniformFrame(cb);
                    }
                }
            },
            {
                key: "updateScrollParent",
                value: function updateScrollParent() {
                    var prev = this.scrollParent;
                    this.scrollParent = this.props.scrollParentGetter(this);
                    if (prev === this.scrollParent) return;
                    if (prev) {
                        prev.removeEventListener("scroll", this.updateFrameAndClearCache);
                        prev.removeEventListener("mousewheel", NOOP);
                    } // If we have a new parent, cached parent dimensions are no longer useful.
                    this.clearSizeCache();
                    this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, PASSIVE); // You have to attach mousewheel listener to the scrollable element.
                    // Just an empty listener. After that onscroll events will be fired synchronously.
                    this.scrollParent.addEventListener("mousewheel", NOOP, PASSIVE);
                }
            },
            {
                key: "updateSimpleFrame",
                value: function updateSimpleFrame(cb) {
                    var _this$getStartAndEnd = this.getStartAndEnd(), end = _this$getStartAndEnd.end;
                    var itemEls = this.items.children;
                    var elEnd = 0;
                    if (itemEls.length) {
                        var axis = this.props.axis;
                        var firstItemEl = itemEls[0];
                        var lastItemEl = itemEls[itemEls.length - 1];
                        elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
                    }
                    if (elEnd > end) return cb();
                    var _this$props3 = this.props, pageSize = _this$props3.pageSize, length = _this$props3.length;
                    var size = Math.min(this.state.size + pageSize, length);
                    this.maybeSetState({
                        size: size
                    }, cb);
                }
            },
            {
                key: "updateVariableFrame",
                value: function updateVariableFrame(cb) {
                    if (!this.props.itemSizeGetter) this.cacheSizes();
                    var _this$getStartAndEnd2 = this.getStartAndEnd(), start = _this$getStartAndEnd2.start, end = _this$getStartAndEnd2.end;
                    var _this$props4 = this.props, length = _this$props4.length, pageSize = _this$props4.pageSize;
                    var space = 0;
                    var from = 0;
                    var size = 0;
                    var maxFrom = length - 1;
                    while(from < maxFrom){
                        var itemSize = this.getSizeOfItem(from);
                        if (itemSize == null || space + itemSize > start) break;
                        space += itemSize;
                        ++from;
                    }
                    var maxSize = length - from;
                    while(size < maxSize && space < end){
                        var _itemSize = this.getSizeOfItem(from + size);
                        if (_itemSize == null) {
                            size = Math.min(size + pageSize, maxSize);
                            break;
                        }
                        space += _itemSize;
                        ++size;
                    }
                    this.maybeSetState(constrain(this.props, {
                        from: from,
                        itemsPerRow: 1,
                        size: size
                    }), cb);
                }
            },
            {
                key: "updateUniformFrame",
                value: function updateUniformFrame(cb) {
                    var _this$getItemSizeAndI = this.getItemSizeAndItemsPerRow(), itemSize = _this$getItemSizeAndI.itemSize, itemsPerRow = _this$getItemSizeAndI.itemsPerRow;
                    if (!itemSize || !itemsPerRow) return cb();
                    var _this$getStartAndEnd3 = this.getStartAndEnd(), start = _this$getStartAndEnd3.start, end = _this$getStartAndEnd3.end;
                    var _constrain = constrain(this.props, {
                        from: Math.floor(start / itemSize) * itemsPerRow,
                        size: (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow,
                        itemsPerRow: itemsPerRow
                    }), from = _constrain.from, size = _constrain.size;
                    return this.maybeSetState({
                        itemsPerRow: itemsPerRow,
                        from: from,
                        itemSize: itemSize,
                        size: size
                    }, cb);
                }
            },
            {
                key: "getSpaceBefore",
                value: function getSpaceBefore(index) {
                    var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (cache[index] != null) return cache[index]; // Try the static itemSize.
                    var _this$state2 = this.state, itemSize = _this$state2.itemSize, itemsPerRow = _this$state2.itemsPerRow;
                    if (itemSize) return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
                     // Find the closest space to index there is a cached value for.
                    var from = index;
                    while(from > 0 && cache[--from] == null); // Finally, accumulate sizes of items from - index.
                    var space = cache[from] || 0;
                    for(var i = from; i < index; ++i){
                        cache[i] = space;
                        var _itemSize2 = this.getSizeOfItem(i);
                        if (_itemSize2 == null) break;
                        space += _itemSize2;
                    }
                    return cache[index] = space;
                }
            },
            {
                key: "cacheSizes",
                value: function cacheSizes() {
                    var cache = this.cache;
                    var from = this.state.from;
                    var itemEls = this.items.children;
                    var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
                    for(var i = 0, l = itemEls.length; i < l; ++i)cache[from + i] = itemEls[i][sizeKey];
                }
            },
            {
                key: "getSizeOfItem",
                value: function getSizeOfItem(index) {
                    var cache = this.cache, items = this.items;
                    var _this$props5 = this.props, axis = _this$props5.axis, itemSizeGetter = _this$props5.itemSizeGetter, itemSizeEstimator = _this$props5.itemSizeEstimator, type = _this$props5.type;
                    var _this$state3 = this.state, from = _this$state3.from, itemSize = _this$state3.itemSize, size = _this$state3.size; // Try the static itemSize.
                    if (itemSize) return itemSize; // Try the itemSizeGetter.
                    if (itemSizeGetter) return itemSizeGetter(index); // Try the cache.
                    if (index in cache) return cache[index]; // Try the DOM.
                    if (type === "simple" && index >= from && index < from + size && items) {
                        var itemEl = items.children[index - from];
                        if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
                    } // Try the itemSizeEstimator.
                    if (itemSizeEstimator) return itemSizeEstimator(index, cache);
                }
            },
            {
                key: "scrollTo",
                value: function scrollTo(index) {
                    if (index != null) this.setScroll(this.getSpaceBefore(index));
                }
            },
            {
                key: "scrollAround",
                value: function scrollAround(index) {
                    var current = this.getScrollPosition();
                    var bottom = this.getSpaceBefore(index);
                    var top = bottom - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(index);
                    var min = Math.min(top, bottom);
                    var max = Math.max(top, bottom);
                    if (current <= min) return this.setScroll(min);
                    if (current > max) return this.setScroll(max);
                }
            },
            {
                key: "getVisibleRange",
                value: function getVisibleRange() {
                    var _this$state4 = this.state, from = _this$state4.from, size = _this$state4.size;
                    var _this$getStartAndEnd4 = this.getStartAndEnd(0), start = _this$getStartAndEnd4.start, end = _this$getStartAndEnd4.end;
                    var cache = {};
                    var first, last;
                    for(var i = from; i < from + size; ++i){
                        var itemStart = this.getSpaceBefore(i, cache);
                        var itemEnd = itemStart + this.getSizeOfItem(i);
                        if (first == null && itemEnd > start) first = i;
                        if (first != null && itemStart < end) last = i;
                    }
                    return [
                        first,
                        last
                    ];
                }
            },
            {
                key: "renderItems",
                value: function renderItems() {
                    var _this3 = this;
                    var _this$props6 = this.props, itemRenderer = _this$props6.itemRenderer, itemsRenderer = _this$props6.itemsRenderer;
                    var _this$state5 = this.state, from = _this$state5.from, size = _this$state5.size;
                    var items = [];
                    for(var i = 0; i < size; ++i)items.push(itemRenderer(from + i, i));
                    return itemsRenderer(items, function(c) {
                        return _this3.items = c;
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this4 = this;
                    var _this$props7 = this.props, axis = _this$props7.axis, length = _this$props7.length, type = _this$props7.type, useTranslate3d = _this$props7.useTranslate3d;
                    var _this$state6 = this.state, from = _this$state6.from, itemsPerRow = _this$state6.itemsPerRow;
                    var items = this.renderItems();
                    if (type === "simple") return items;
                    var style = {
                        position: "relative"
                    };
                    var cache = {};
                    var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
                    var size = this.getSpaceBefore(bottom, cache);
                    if (size) {
                        style[SIZE_KEYS[axis]] = size;
                        if (axis === "x") style.overflowX = "hidden";
                    }
                    var offset = this.getSpaceBefore(from, cache);
                    var x = axis === "x" ? offset : 0;
                    var y = axis === "y" ? offset : 0;
                    var transform = useTranslate3d ? "translate3d(".concat(x, "px, ").concat(y, "px, 0)") : "translate(".concat(x, "px, ").concat(y, "px)");
                    var listStyle = {
                        msTransform: transform,
                        WebkitTransform: transform,
                        transform: transform
                    };
                    return /*#__PURE__*/ _react["default"].createElement("div", {
                        style: style,
                        ref: function ref(c) {
                            return _this4.el = c;
                        }
                    }, /*#__PURE__*/ _react["default"].createElement("div", {
                        style: listStyle
                    }, items));
                }
            }
        ]);
        return ReactList;
    }(_react.Component), _defineProperty(_class, "displayName", "ReactList"), _defineProperty(_class, "propTypes", {
        axis: _propTypes["default"].oneOf([
            "x",
            "y"
        ]),
        initialIndex: _propTypes["default"].number,
        itemRenderer: _propTypes["default"].func,
        itemSizeEstimator: _propTypes["default"].func,
        itemSizeGetter: _propTypes["default"].func,
        itemsRenderer: _propTypes["default"].func,
        length: _propTypes["default"].number,
        minSize: _propTypes["default"].number,
        pageSize: _propTypes["default"].number,
        scrollParentGetter: _propTypes["default"].func,
        scrollParentViewportSizeGetter: _propTypes["default"].func,
        threshold: _propTypes["default"].number,
        type: _propTypes["default"].oneOf([
            "simple",
            "variable",
            "uniform"
        ]),
        useStaticSize: _propTypes["default"].bool,
        useTranslate3d: _propTypes["default"].bool
    }), _defineProperty(_class, "defaultProps", {
        axis: "y",
        itemRenderer: function itemRenderer(index, key) {
            return /*#__PURE__*/ _react["default"].createElement("div", {
                key: key
            }, index);
        },
        itemsRenderer: function itemsRenderer(items, ref) {
            return /*#__PURE__*/ _react["default"].createElement("div", {
                ref: ref
            }, items);
        },
        length: 0,
        minSize: 1,
        pageSize: 10,
        scrollParentGetter: defaultScrollParentGetter,
        scrollParentViewportSizeGetter: defaultScrollParentViewportSizeGetter,
        threshold: 100,
        type: "simple",
        useStaticSize: false,
        useTranslate3d: false
    }), _temp);
});

});

parcelRegister("bk2sv", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", function () { return $83e3783accc5ff33$export$3e67810a3f0e9f1c; });
function $83e3783accc5ff33$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $83e3783accc5ff33$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    var len = arrA.length;
    if (arrB.length !== len) return false;
    for(var i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}

});

parcelRegister("8YdnK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $687e4eba6b739049$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $687e4eba6b739049$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $fnuNu.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $ana82.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $2XKMM.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("2aONL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1953ec1884275a13$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $1953ec1884275a13$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $fnuNu.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $ana82.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $2XKMM.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("bitEh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $83985fc780dba6d7$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $irUS8 = parcelRequire("irUS8");

var $fnuNu = parcelRequire("fnuNu");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $83985fc780dba6d7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fnuNu.default)(2, arguments);
    var dateLeft = (0, $2XKMM.default)(dirtyDateLeft);
    var dateRight = (0, $2XKMM.default)(dirtyDateRight);
    var sign = $83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $irUS8.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("2kgE1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1b1a5c4dabfd9a23$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $1b1a5c4dabfd9a23$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fnuNu.default)(2, arguments);
    var dateLeft = (0, $2XKMM.default)(dirtyDateLeft);
    var dateRight = (0, $2XKMM.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("f5GCE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $02d5d00a8b5e20ed$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $2XKMM = parcelRequire("2XKMM");

var $jtDyl = parcelRequire("jtDyl");

var $fnuNu = parcelRequire("fnuNu");
function $02d5d00a8b5e20ed$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $fnuNu.default)(2, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var month = (0, $k35UP.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $jtDyl.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("jtDyl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2df6822c62eb97d$export$2e2bcd8739ae039; });

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $e2df6822c62eb97d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("bnuCe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8489974b89942ada$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $8489974b89942ada$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $fnuNu.default)(2, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var year = (0, $k35UP.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("cy9Tj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9230552dbfa14bda$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $5Zyd5 = parcelRequire("5Zyd5");

var $fnuNu = parcelRequire("fnuNu");
function $9230552dbfa14bda$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fnuNu.default)(2, arguments);
    var amount = (0, $k35UP.default)(dirtyAmount);
    return (0, $5Zyd5.default)(dirtyDate, amount * 12);
}

});
parcelRegister("5Zyd5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $45cd2fa86cd3abf5$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $45cd2fa86cd3abf5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fnuNu.default)(2, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    var amount = (0, $k35UP.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});


parcelRegister("hCFcD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $cd45f25018a6a3b6$export$2e2bcd8739ae039; });

var $k35UP = parcelRequire("k35UP");

var $5Zyd5 = parcelRequire("5Zyd5");

var $fnuNu = parcelRequire("fnuNu");
function $cd45f25018a6a3b6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fnuNu.default)(2, arguments);
    var amount = (0, $k35UP.default)(dirtyAmount);
    return (0, $5Zyd5.default)(dirtyDate, -amount);
}

});

parcelRegister("lnHjO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f90d59201aa3a02c$var$_default = {
    dateRangeWrapper: "rdrDateRangeWrapper",
    calendarWrapper: "rdrCalendarWrapper",
    dateDisplay: "rdrDateDisplay",
    dateDisplayItem: "rdrDateDisplayItem",
    dateDisplayItemActive: "rdrDateDisplayItemActive",
    monthAndYearWrapper: "rdrMonthAndYearWrapper",
    monthAndYearPickers: "rdrMonthAndYearPickers",
    nextPrevButton: "rdrNextPrevButton",
    month: "rdrMonth",
    weekDays: "rdrWeekDays",
    weekDay: "rdrWeekDay",
    days: "rdrDays",
    day: "rdrDay",
    dayNumber: "rdrDayNumber",
    dayPassive: "rdrDayPassive",
    dayToday: "rdrDayToday",
    dayStartOfWeek: "rdrDayStartOfWeek",
    dayEndOfWeek: "rdrDayEndOfWeek",
    daySelected: "rdrDaySelected",
    dayDisabled: "rdrDayDisabled",
    dayStartOfMonth: "rdrDayStartOfMonth",
    dayEndOfMonth: "rdrDayEndOfMonth",
    dayWeekend: "rdrDayWeekend",
    dayStartPreview: "rdrDayStartPreview",
    dayInPreview: "rdrDayInPreview",
    dayEndPreview: "rdrDayEndPreview",
    dayHovered: "rdrDayHovered",
    dayActive: "rdrDayActive",
    inRange: "rdrInRange",
    endEdge: "rdrEndEdge",
    startEdge: "rdrStartEdge",
    prevButton: "rdrPprevButton",
    nextButton: "rdrNextButton",
    selected: "rdrSelected",
    months: "rdrMonths",
    monthPicker: "rdrMonthPicker",
    yearPicker: "rdrYearPicker",
    dateDisplayWrapper: "rdrDateDisplayWrapper",
    definedRangesWrapper: "rdrDefinedRangesWrapper",
    staticRanges: "rdrStaticRanges",
    staticRange: "rdrStaticRange",
    inputRanges: "rdrInputRanges",
    inputRange: "rdrInputRange",
    inputRangeInput: "rdrInputRangeInput",
    dateRangePickerWrapper: "rdrDateRangePickerWrapper",
    staticRangeLabel: "rdrStaticRangeLabel",
    staticRangeSelected: "rdrStaticRangeSelected",
    monthName: "rdrMonthName",
    infiniteMonths: "rdrInfiniteMonths",
    monthsVertical: "rdrMonthsVertical",
    monthsHorizontal: "rdrMonthsHorizontal"
};
module.exports.default = $f90d59201aa3a02c$var$_default;

});

parcelRegister("6iT59", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ariaLabelsShape = void 0;

var $496f26af76ebf3d1$var$_propTypes = $496f26af76ebf3d1$var$_interopRequireDefault((parcelRequire("bisEj")));
function $496f26af76ebf3d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $496f26af76ebf3d1$var$ariaLabelsShape = $496f26af76ebf3d1$var$_propTypes.default.shape({
    dateInput: $496f26af76ebf3d1$var$_propTypes.default.objectOf($496f26af76ebf3d1$var$_propTypes.default.shape({
        startDate: $496f26af76ebf3d1$var$_propTypes.default.string,
        endDate: $496f26af76ebf3d1$var$_propTypes.default.string
    })),
    monthPicker: $496f26af76ebf3d1$var$_propTypes.default.string,
    yearPicker: $496f26af76ebf3d1$var$_propTypes.default.string,
    prevButton: $496f26af76ebf3d1$var$_propTypes.default.string,
    nextButton: $496f26af76ebf3d1$var$_propTypes.default.string
});
module.exports.ariaLabelsShape = $496f26af76ebf3d1$var$ariaLabelsShape;

});



parcelRegister("fFM5j", function(module, exports) {
"use strict";
function $b68ffbfb72a85570$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b68ffbfb72a85570$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b68ffbfb72a85570$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b68ffbfb72a85570$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b68ffbfb72a85570$var$_react = $b68ffbfb72a85570$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $b68ffbfb72a85570$var$_propTypes = $b68ffbfb72a85570$var$_interopRequireDefault((parcelRequire("bisEj")));

var $b68ffbfb72a85570$var$_DateRange = $b68ffbfb72a85570$var$_interopRequireDefault((parcelRequire("7bZYo")));

var $b68ffbfb72a85570$var$_DefinedRange = $b68ffbfb72a85570$var$_interopRequireDefault((parcelRequire("jalqW")));

var $1iPS5 = parcelRequire("1iPS5");

var $b68ffbfb72a85570$var$_classnames = $b68ffbfb72a85570$var$_interopRequireDefault((parcelRequire("eH0la")));

var $b68ffbfb72a85570$var$_styles = $b68ffbfb72a85570$var$_interopRequireDefault((parcelRequire("lnHjO")));
function $b68ffbfb72a85570$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b68ffbfb72a85570$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b68ffbfb72a85570$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b68ffbfb72a85570$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $b68ffbfb72a85570$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b68ffbfb72a85570$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b68ffbfb72a85570$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b68ffbfb72a85570$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b68ffbfb72a85570$var$ownKeys(Object(source), true).forEach(function(key) {
            $b68ffbfb72a85570$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b68ffbfb72a85570$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b68ffbfb72a85570$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b68ffbfb72a85570$var$_extends() {
    $b68ffbfb72a85570$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b68ffbfb72a85570$var$_extends.apply(this, arguments);
}
function $b68ffbfb72a85570$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b68ffbfb72a85570$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b68ffbfb72a85570$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b68ffbfb72a85570$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b68ffbfb72a85570$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b68ffbfb72a85570$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b68ffbfb72a85570$var$_setPrototypeOf(subClass, superClass);
}
function $b68ffbfb72a85570$var$_setPrototypeOf(o, p) {
    $b68ffbfb72a85570$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b68ffbfb72a85570$var$_setPrototypeOf(o, p);
}
function $b68ffbfb72a85570$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b68ffbfb72a85570$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b68ffbfb72a85570$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b68ffbfb72a85570$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b68ffbfb72a85570$var$_possibleConstructorReturn(this, result);
    };
}
function $b68ffbfb72a85570$var$_possibleConstructorReturn(self, call) {
    if (call && ($b68ffbfb72a85570$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b68ffbfb72a85570$var$_assertThisInitialized(self);
}
function $b68ffbfb72a85570$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b68ffbfb72a85570$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b68ffbfb72a85570$var$_getPrototypeOf(o) {
    $b68ffbfb72a85570$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b68ffbfb72a85570$var$_getPrototypeOf(o);
}
var $b68ffbfb72a85570$var$DateRangePicker = /*#__PURE__*/ function(_Component) {
    $b68ffbfb72a85570$var$_inherits(DateRangePicker, _Component);
    var _super = $b68ffbfb72a85570$var$_createSuper(DateRangePicker);
    function DateRangePicker(props) {
        var _this;
        $b68ffbfb72a85570$var$_classCallCheck(this, DateRangePicker);
        _this = _super.call(this, props);
        _this.state = {
            focusedRange: [
                (0, $1iPS5.findNextRangeIndex)(props.ranges),
                0
            ]
        };
        _this.styles = (0, $1iPS5.generateStyles)([
            $b68ffbfb72a85570$var$_styles.default,
            props.classNames
        ]);
        return _this;
    }
    $b68ffbfb72a85570$var$_createClass(DateRangePicker, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var focusedRange = this.state.focusedRange;
                return /*#__PURE__*/ $b68ffbfb72a85570$var$_react.default.createElement("div", {
                    className: (0, $b68ffbfb72a85570$var$_classnames.default)(this.styles.dateRangePickerWrapper, this.props.className)
                }, /*#__PURE__*/ $b68ffbfb72a85570$var$_react.default.createElement($b68ffbfb72a85570$var$_DefinedRange.default, $b68ffbfb72a85570$var$_extends({
                    focusedRange: focusedRange,
                    onPreviewChange: function onPreviewChange(value) {
                        return _this2.dateRange.updatePreview(value ? _this2.dateRange.calcNewSelection(value, typeof value === "string") : null);
                    }
                }, this.props, {
                    range: this.props.ranges[focusedRange[0]],
                    className: undefined
                })), /*#__PURE__*/ $b68ffbfb72a85570$var$_react.default.createElement($b68ffbfb72a85570$var$_DateRange.default, $b68ffbfb72a85570$var$_extends({
                    onRangeFocusChange: function onRangeFocusChange(focusedRange) {
                        return _this2.setState({
                            focusedRange: focusedRange
                        });
                    },
                    focusedRange: focusedRange
                }, this.props, {
                    ref: function ref(t) {
                        return _this2.dateRange = t;
                    },
                    className: undefined
                })));
            }
        }
    ]);
    return DateRangePicker;
}($b68ffbfb72a85570$var$_react.Component);
$b68ffbfb72a85570$var$DateRangePicker.defaultProps = {};
$b68ffbfb72a85570$var$DateRangePicker.propTypes = $b68ffbfb72a85570$var$_objectSpread($b68ffbfb72a85570$var$_objectSpread($b68ffbfb72a85570$var$_objectSpread({}, $b68ffbfb72a85570$var$_DateRange.default.propTypes), $b68ffbfb72a85570$var$_DefinedRange.default.propTypes), {}, {
    className: $b68ffbfb72a85570$var$_propTypes.default.string
});
var $b68ffbfb72a85570$var$_default = $b68ffbfb72a85570$var$DateRangePicker;
module.exports.default = $b68ffbfb72a85570$var$_default;

});
parcelRegister("jalqW", function(module, exports) {
"use strict";
function $df3f93be333a7757$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $df3f93be333a7757$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $df3f93be333a7757$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $df3f93be333a7757$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df3f93be333a7757$var$_react = $df3f93be333a7757$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $df3f93be333a7757$var$_propTypes = $df3f93be333a7757$var$_interopRequireDefault((parcelRequire("bisEj")));

var $df3f93be333a7757$var$_styles = $df3f93be333a7757$var$_interopRequireDefault((parcelRequire("lnHjO")));

var $fmkuw = parcelRequire("fmkuw");

var $75YCw = parcelRequire("75YCw");

var $df3f93be333a7757$var$_InputRangeField = $df3f93be333a7757$var$_interopRequireDefault((parcelRequire("4VYjP")));

var $df3f93be333a7757$var$_classnames = $df3f93be333a7757$var$_interopRequireDefault((parcelRequire("eH0la")));
function $df3f93be333a7757$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $df3f93be333a7757$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($df3f93be333a7757$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $df3f93be333a7757$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $df3f93be333a7757$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $df3f93be333a7757$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $df3f93be333a7757$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $df3f93be333a7757$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $df3f93be333a7757$var$ownKeys(Object(source), true).forEach(function(key) {
            $df3f93be333a7757$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $df3f93be333a7757$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $df3f93be333a7757$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $df3f93be333a7757$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $df3f93be333a7757$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $df3f93be333a7757$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $df3f93be333a7757$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $df3f93be333a7757$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $df3f93be333a7757$var$_setPrototypeOf(subClass, superClass);
}
function $df3f93be333a7757$var$_setPrototypeOf(o, p) {
    $df3f93be333a7757$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $df3f93be333a7757$var$_setPrototypeOf(o, p);
}
function $df3f93be333a7757$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $df3f93be333a7757$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $df3f93be333a7757$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $df3f93be333a7757$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $df3f93be333a7757$var$_possibleConstructorReturn(this, result);
    };
}
function $df3f93be333a7757$var$_possibleConstructorReturn(self, call) {
    if (call && ($df3f93be333a7757$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $df3f93be333a7757$var$_assertThisInitialized(self);
}
function $df3f93be333a7757$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $df3f93be333a7757$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $df3f93be333a7757$var$_getPrototypeOf(o) {
    $df3f93be333a7757$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $df3f93be333a7757$var$_getPrototypeOf(o);
}
function $df3f93be333a7757$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $df3f93be333a7757$var$DefinedRange = /*#__PURE__*/ function(_Component) {
    $df3f93be333a7757$var$_inherits(DefinedRange, _Component);
    var _super = $df3f93be333a7757$var$_createSuper(DefinedRange);
    function DefinedRange(props) {
        var _this;
        $df3f93be333a7757$var$_classCallCheck(this, DefinedRange);
        _this = _super.call(this, props);
        $df3f93be333a7757$var$_defineProperty($df3f93be333a7757$var$_assertThisInitialized(_this), "handleRangeChange", function(range) {
            var _this$props = _this.props, onChange = _this$props.onChange, ranges = _this$props.ranges, focusedRange = _this$props.focusedRange;
            var selectedRange = ranges[focusedRange[0]];
            if (!onChange || !selectedRange) return;
            onChange($df3f93be333a7757$var$_defineProperty({}, selectedRange.key || "range".concat(focusedRange[0] + 1), $df3f93be333a7757$var$_objectSpread($df3f93be333a7757$var$_objectSpread({}, selectedRange), range)));
        });
        _this.state = {
            rangeOffset: 0,
            focusedInput: -1
        };
        return _this;
    }
    $df3f93be333a7757$var$_createClass(DefinedRange, [
        {
            key: "getRangeOptionValue",
            value: function getRangeOptionValue(option) {
                var _this$props2 = this.props, _this$props2$ranges = _this$props2.ranges, ranges = _this$props2$ranges === void 0 ? [] : _this$props2$ranges, _this$props2$focusedR = _this$props2.focusedRange, focusedRange = _this$props2$focusedR === void 0 ? [] : _this$props2$focusedR;
                if (typeof option.getCurrentValue !== "function") return "";
                var selectedRange = ranges[focusedRange[0]] || {};
                return option.getCurrentValue(selectedRange) || "";
            }
        },
        {
            key: "getSelectedRange",
            value: function getSelectedRange(ranges, staticRange) {
                var focusedRangeIndex = ranges.findIndex(function(range) {
                    if (!range.startDate || !range.endDate || range.disabled) return false;
                    return staticRange.isSelected(range);
                });
                var selectedRange = ranges[focusedRangeIndex];
                return {
                    selectedRange: selectedRange,
                    focusedRangeIndex: focusedRangeIndex
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, headerContent = _this$props3.headerContent, footerContent = _this$props3.footerContent, onPreviewChange = _this$props3.onPreviewChange, inputRanges = _this$props3.inputRanges, staticRanges = _this$props3.staticRanges, ranges = _this$props3.ranges, renderStaticRangeLabel = _this$props3.renderStaticRangeLabel, rangeColors = _this$props3.rangeColors, className = _this$props3.className;
                return /*#__PURE__*/ $df3f93be333a7757$var$_react.default.createElement("div", {
                    className: (0, $df3f93be333a7757$var$_classnames.default)($df3f93be333a7757$var$_styles.default.definedRangesWrapper, className)
                }, headerContent, /*#__PURE__*/ $df3f93be333a7757$var$_react.default.createElement("div", {
                    className: $df3f93be333a7757$var$_styles.default.staticRanges
                }, staticRanges.map(function(staticRange, i) {
                    var _this2$getSelectedRan = _this2.getSelectedRange(ranges, staticRange), selectedRange = _this2$getSelectedRan.selectedRange, focusedRangeIndex = _this2$getSelectedRan.focusedRangeIndex;
                    var labelContent;
                    if (staticRange.hasCustomRendering) labelContent = renderStaticRangeLabel(staticRange);
                    else labelContent = staticRange.label;
                    return /*#__PURE__*/ $df3f93be333a7757$var$_react.default.createElement("button", {
                        type: "button",
                        className: (0, $df3f93be333a7757$var$_classnames.default)($df3f93be333a7757$var$_styles.default.staticRange, $df3f93be333a7757$var$_defineProperty({}, $df3f93be333a7757$var$_styles.default.staticRangeSelected, Boolean(selectedRange))),
                        style: {
                            color: selectedRange ? selectedRange.color || rangeColors[focusedRangeIndex] : null
                        },
                        key: i,
                        onClick: function onClick() {
                            return _this2.handleRangeChange(staticRange.range(_this2.props));
                        },
                        onFocus: function onFocus() {
                            return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
                        },
                        onMouseOver: function onMouseOver() {
                            return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
                        },
                        onMouseLeave: function onMouseLeave() {
                            onPreviewChange && onPreviewChange();
                        }
                    }, /*#__PURE__*/ $df3f93be333a7757$var$_react.default.createElement("span", {
                        tabIndex: -1,
                        className: $df3f93be333a7757$var$_styles.default.staticRangeLabel
                    }, labelContent));
                })), /*#__PURE__*/ $df3f93be333a7757$var$_react.default.createElement("div", {
                    className: $df3f93be333a7757$var$_styles.default.inputRanges
                }, inputRanges.map(function(rangeOption, i) {
                    return /*#__PURE__*/ $df3f93be333a7757$var$_react.default.createElement($df3f93be333a7757$var$_InputRangeField.default, {
                        key: i,
                        styles: $df3f93be333a7757$var$_styles.default,
                        label: rangeOption.label,
                        onFocus: function onFocus() {
                            return _this2.setState({
                                focusedInput: i,
                                rangeOffset: 0
                            });
                        },
                        onBlur: function onBlur() {
                            return _this2.setState({
                                rangeOffset: 0
                            });
                        },
                        onChange: function onChange(value) {
                            return _this2.handleRangeChange(rangeOption.range(value, _this2.props));
                        },
                        value: _this2.getRangeOptionValue(rangeOption)
                    });
                })), footerContent);
            }
        }
    ]);
    return DefinedRange;
}($df3f93be333a7757$var$_react.Component);
$df3f93be333a7757$var$DefinedRange.propTypes = {
    inputRanges: $df3f93be333a7757$var$_propTypes.default.array,
    staticRanges: $df3f93be333a7757$var$_propTypes.default.array,
    ranges: $df3f93be333a7757$var$_propTypes.default.arrayOf($75YCw.rangeShape),
    focusedRange: $df3f93be333a7757$var$_propTypes.default.arrayOf($df3f93be333a7757$var$_propTypes.default.number),
    onPreviewChange: $df3f93be333a7757$var$_propTypes.default.func,
    onChange: $df3f93be333a7757$var$_propTypes.default.func,
    footerContent: $df3f93be333a7757$var$_propTypes.default.any,
    headerContent: $df3f93be333a7757$var$_propTypes.default.any,
    rangeColors: $df3f93be333a7757$var$_propTypes.default.arrayOf($df3f93be333a7757$var$_propTypes.default.string),
    className: $df3f93be333a7757$var$_propTypes.default.string,
    renderStaticRangeLabel: $df3f93be333a7757$var$_propTypes.default.func
};
$df3f93be333a7757$var$DefinedRange.defaultProps = {
    inputRanges: $fmkuw.defaultInputRanges,
    staticRanges: $fmkuw.defaultStaticRanges,
    ranges: [],
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    focusedRange: [
        0,
        0
    ]
};
var $df3f93be333a7757$var$_default = $df3f93be333a7757$var$DefinedRange;
module.exports.default = $df3f93be333a7757$var$_default;

});
parcelRegister("fmkuw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createStaticRanges = $b2e8ce3788764d69$var$createStaticRanges;
module.exports.defaultInputRanges = module.exports.defaultStaticRanges = void 0;

var $b2e8ce3788764d69$var$_differenceInCalendarDays = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("irUS8")));

var $b2e8ce3788764d69$var$_isSameDay = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("l9Ijw")));

var $b2e8ce3788764d69$var$_endOfWeek = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("h3DSD")));

var $b2e8ce3788764d69$var$_startOfWeek = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("9zB2r")));

var $b2e8ce3788764d69$var$_addMonths = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("5Zyd5")));

var $b2e8ce3788764d69$var$_endOfMonth = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("2xHvS")));

var $b2e8ce3788764d69$var$_startOfMonth = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("YqHFX")));

var $b2e8ce3788764d69$var$_startOfDay = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("jmtco")));

var $b2e8ce3788764d69$var$_endOfDay = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("kNidb")));

var $b2e8ce3788764d69$var$_addDays = $b2e8ce3788764d69$var$_interopRequireDefault((parcelRequire("czacj")));
function $b2e8ce3788764d69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2e8ce3788764d69$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b2e8ce3788764d69$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b2e8ce3788764d69$var$ownKeys(Object(source), true).forEach(function(key) {
            $b2e8ce3788764d69$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b2e8ce3788764d69$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b2e8ce3788764d69$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b2e8ce3788764d69$var$defineds = {
    startOfWeek: (0, $b2e8ce3788764d69$var$_startOfWeek.default)(new Date()),
    endOfWeek: (0, $b2e8ce3788764d69$var$_endOfWeek.default)(new Date()),
    startOfLastWeek: (0, $b2e8ce3788764d69$var$_startOfWeek.default)((0, $b2e8ce3788764d69$var$_addDays.default)(new Date(), -7)),
    endOfLastWeek: (0, $b2e8ce3788764d69$var$_endOfWeek.default)((0, $b2e8ce3788764d69$var$_addDays.default)(new Date(), -7)),
    startOfToday: (0, $b2e8ce3788764d69$var$_startOfDay.default)(new Date()),
    endOfToday: (0, $b2e8ce3788764d69$var$_endOfDay.default)(new Date()),
    startOfYesterday: (0, $b2e8ce3788764d69$var$_startOfDay.default)((0, $b2e8ce3788764d69$var$_addDays.default)(new Date(), -1)),
    endOfYesterday: (0, $b2e8ce3788764d69$var$_endOfDay.default)((0, $b2e8ce3788764d69$var$_addDays.default)(new Date(), -1)),
    startOfMonth: (0, $b2e8ce3788764d69$var$_startOfMonth.default)(new Date()),
    endOfMonth: (0, $b2e8ce3788764d69$var$_endOfMonth.default)(new Date()),
    startOfLastMonth: (0, $b2e8ce3788764d69$var$_startOfMonth.default)((0, $b2e8ce3788764d69$var$_addMonths.default)(new Date(), -1)),
    endOfLastMonth: (0, $b2e8ce3788764d69$var$_endOfMonth.default)((0, $b2e8ce3788764d69$var$_addMonths.default)(new Date(), -1))
};
var $b2e8ce3788764d69$var$staticRangeHandler = {
    range: {},
    isSelected: function isSelected(range) {
        var definedRange = this.range();
        return (0, $b2e8ce3788764d69$var$_isSameDay.default)(range.startDate, definedRange.startDate) && (0, $b2e8ce3788764d69$var$_isSameDay.default)(range.endDate, definedRange.endDate);
    }
};
function $b2e8ce3788764d69$var$createStaticRanges(ranges) {
    return ranges.map(function(range) {
        return $b2e8ce3788764d69$var$_objectSpread($b2e8ce3788764d69$var$_objectSpread({}, $b2e8ce3788764d69$var$staticRangeHandler), range);
    });
}
var $b2e8ce3788764d69$var$defaultStaticRanges = $b2e8ce3788764d69$var$createStaticRanges([
    {
        label: "Today",
        range: function range() {
            return {
                startDate: $b2e8ce3788764d69$var$defineds.startOfToday,
                endDate: $b2e8ce3788764d69$var$defineds.endOfToday
            };
        }
    },
    {
        label: "Yesterday",
        range: function range() {
            return {
                startDate: $b2e8ce3788764d69$var$defineds.startOfYesterday,
                endDate: $b2e8ce3788764d69$var$defineds.endOfYesterday
            };
        }
    },
    {
        label: "This Week",
        range: function range() {
            return {
                startDate: $b2e8ce3788764d69$var$defineds.startOfWeek,
                endDate: $b2e8ce3788764d69$var$defineds.endOfWeek
            };
        }
    },
    {
        label: "Last Week",
        range: function range() {
            return {
                startDate: $b2e8ce3788764d69$var$defineds.startOfLastWeek,
                endDate: $b2e8ce3788764d69$var$defineds.endOfLastWeek
            };
        }
    },
    {
        label: "This Month",
        range: function range() {
            return {
                startDate: $b2e8ce3788764d69$var$defineds.startOfMonth,
                endDate: $b2e8ce3788764d69$var$defineds.endOfMonth
            };
        }
    },
    {
        label: "Last Month",
        range: function range() {
            return {
                startDate: $b2e8ce3788764d69$var$defineds.startOfLastMonth,
                endDate: $b2e8ce3788764d69$var$defineds.endOfLastMonth
            };
        }
    }
]);
module.exports.defaultStaticRanges = $b2e8ce3788764d69$var$defaultStaticRanges;
var $b2e8ce3788764d69$var$defaultInputRanges = [
    {
        label: "days up to today",
        range: function range(value) {
            return {
                startDate: (0, $b2e8ce3788764d69$var$_addDays.default)($b2e8ce3788764d69$var$defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
                endDate: $b2e8ce3788764d69$var$defineds.endOfToday
            };
        },
        getCurrentValue: function getCurrentValue(range) {
            if (!(0, $b2e8ce3788764d69$var$_isSameDay.default)(range.endDate, $b2e8ce3788764d69$var$defineds.endOfToday)) return "-";
            if (!range.startDate) return "\u221E";
            return (0, $b2e8ce3788764d69$var$_differenceInCalendarDays.default)($b2e8ce3788764d69$var$defineds.endOfToday, range.startDate) + 1;
        }
    },
    {
        label: "days starting today",
        range: function range(value) {
            var today = new Date();
            return {
                startDate: today,
                endDate: (0, $b2e8ce3788764d69$var$_addDays.default)(today, Math.max(Number(value), 1) - 1)
            };
        },
        getCurrentValue: function getCurrentValue(range) {
            if (!(0, $b2e8ce3788764d69$var$_isSameDay.default)(range.startDate, $b2e8ce3788764d69$var$defineds.startOfToday)) return "-";
            if (!range.endDate) return "\u221E";
            return (0, $b2e8ce3788764d69$var$_differenceInCalendarDays.default)(range.endDate, $b2e8ce3788764d69$var$defineds.startOfToday) + 1;
        }
    }
];
module.exports.defaultInputRanges = $b2e8ce3788764d69$var$defaultInputRanges;

});

parcelRegister("4VYjP", function(module, exports) {
"use strict";
function $397b4658accad689$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $397b4658accad689$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $397b4658accad689$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $397b4658accad689$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $397b4658accad689$var$_react = $397b4658accad689$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $397b4658accad689$var$_propTypes = $397b4658accad689$var$_interopRequireDefault((parcelRequire("bisEj")));
function $397b4658accad689$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $397b4658accad689$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($397b4658accad689$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $397b4658accad689$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $397b4658accad689$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $397b4658accad689$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $397b4658accad689$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $397b4658accad689$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $397b4658accad689$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $397b4658accad689$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $397b4658accad689$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $397b4658accad689$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $397b4658accad689$var$_setPrototypeOf(subClass, superClass);
}
function $397b4658accad689$var$_setPrototypeOf(o, p) {
    $397b4658accad689$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $397b4658accad689$var$_setPrototypeOf(o, p);
}
function $397b4658accad689$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $397b4658accad689$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $397b4658accad689$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $397b4658accad689$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $397b4658accad689$var$_possibleConstructorReturn(this, result);
    };
}
function $397b4658accad689$var$_possibleConstructorReturn(self, call) {
    if (call && ($397b4658accad689$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $397b4658accad689$var$_assertThisInitialized(self);
}
function $397b4658accad689$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $397b4658accad689$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $397b4658accad689$var$_getPrototypeOf(o) {
    $397b4658accad689$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $397b4658accad689$var$_getPrototypeOf(o);
}
function $397b4658accad689$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $397b4658accad689$var$MIN = 0;
var $397b4658accad689$var$MAX = 99999;
var $397b4658accad689$var$InputRangeField = /*#__PURE__*/ function(_Component) {
    $397b4658accad689$var$_inherits(InputRangeField, _Component);
    var _super = $397b4658accad689$var$_createSuper(InputRangeField);
    function InputRangeField(props, context) {
        var _this;
        $397b4658accad689$var$_classCallCheck(this, InputRangeField);
        _this = _super.call(this, props, context);
        $397b4658accad689$var$_defineProperty($397b4658accad689$var$_assertThisInitialized(_this), "onChange", function(e) {
            var onChange = _this.props.onChange;
            var value = parseInt(e.target.value, 10);
            value = isNaN(value) ? 0 : Math.max(Math.min($397b4658accad689$var$MAX, value), $397b4658accad689$var$MIN);
            onChange(value);
        });
        return _this;
    }
    $397b4658accad689$var$_createClass(InputRangeField, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this$props = this.props, value = _this$props.value, label = _this$props.label, placeholder = _this$props.placeholder;
                return value !== nextProps.value || label !== nextProps.label || placeholder !== nextProps.placeholder;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, label = _this$props2.label, placeholder = _this$props2.placeholder, value = _this$props2.value, styles = _this$props2.styles, onBlur = _this$props2.onBlur, onFocus = _this$props2.onFocus;
                return /*#__PURE__*/ $397b4658accad689$var$_react.default.createElement("div", {
                    className: styles.inputRange
                }, /*#__PURE__*/ $397b4658accad689$var$_react.default.createElement("input", {
                    className: styles.inputRangeInput,
                    placeholder: placeholder,
                    value: value,
                    min: $397b4658accad689$var$MIN,
                    max: $397b4658accad689$var$MAX,
                    onChange: this.onChange,
                    onFocus: onFocus,
                    onBlur: onBlur
                }), /*#__PURE__*/ $397b4658accad689$var$_react.default.createElement("span", {
                    className: styles.inputRangeLabel
                }, label));
            }
        }
    ]);
    return InputRangeField;
}($397b4658accad689$var$_react.Component);
$397b4658accad689$var$InputRangeField.propTypes = {
    value: $397b4658accad689$var$_propTypes.default.oneOfType([
        $397b4658accad689$var$_propTypes.default.string,
        $397b4658accad689$var$_propTypes.default.number
    ]),
    label: $397b4658accad689$var$_propTypes.default.oneOfType([
        $397b4658accad689$var$_propTypes.default.element,
        $397b4658accad689$var$_propTypes.default.node
    ]).isRequired,
    placeholder: $397b4658accad689$var$_propTypes.default.string,
    styles: $397b4658accad689$var$_propTypes.default.shape({
        inputRange: $397b4658accad689$var$_propTypes.default.string,
        inputRangeInput: $397b4658accad689$var$_propTypes.default.string,
        inputRangeLabel: $397b4658accad689$var$_propTypes.default.string
    }).isRequired,
    onBlur: $397b4658accad689$var$_propTypes.default.func.isRequired,
    onFocus: $397b4658accad689$var$_propTypes.default.func.isRequired,
    onChange: $397b4658accad689$var$_propTypes.default.func.isRequired
};
$397b4658accad689$var$InputRangeField.defaultProps = {
    value: "",
    placeholder: "-"
};
var $397b4658accad689$var$_default = $397b4658accad689$var$InputRangeField;
module.exports.default = $397b4658accad689$var$_default;

});



parcelRegister("7HKs8", function(module, exports) {

var $8ThvE = parcelRequire("8ThvE");

var $jjS2x = parcelRequire("jjS2x");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8ThvE.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $jjS2x;
module.exports = isBuffer;

});
parcelRegister("8ThvE", function(module, exports) {

var $lyxRX = parcelRequire("lyxRX");
/** Detect free variable `self`. */ var $67910ad3df1b1086$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $67910ad3df1b1086$var$root = $lyxRX || $67910ad3df1b1086$var$freeSelf || Function("return this")();
module.exports = $67910ad3df1b1086$var$root;

});
parcelRegister("lyxRX", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $fb170ba8a9c2191f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $fb170ba8a9c2191f$var$freeGlobal;

});


parcelRegister("jjS2x", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e109b5e12b59d0d6$var$stubFalse() {
    return false;
}
module.exports = $e109b5e12b59d0d6$var$stubFalse;

});


parcelRegister("7vc1R", function(module, exports) {

var $lyxRX = parcelRequire("lyxRX");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $lyxRX.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("kswOL", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $i945l = parcelRequire("i945l");

var $1GzxI = parcelRequire("1GzxI");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $i945l.validateField)(curve.Fp);
    (0, $1GzxI.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $i945l.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});
parcelRegister("i945l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $1GzxI = parcelRequire("1GzxI");
// prettier-ignore
const $d35c3c82524fc7f9$var$_0n = BigInt(0), $d35c3c82524fc7f9$var$_1n = BigInt(1), $d35c3c82524fc7f9$var$_2n = BigInt(2), $d35c3c82524fc7f9$var$_3n = BigInt(3);
// prettier-ignore
const $d35c3c82524fc7f9$var$_4n = BigInt(4), $d35c3c82524fc7f9$var$_5n = BigInt(5), $d35c3c82524fc7f9$var$_8n = BigInt(8);
// prettier-ignore
const $d35c3c82524fc7f9$var$_9n = BigInt(9), $d35c3c82524fc7f9$var$_16n = BigInt(16);
// Calculates a modulo b
function $d35c3c82524fc7f9$var$mod(a, b) {
    const result = a % b;
    return result >= $d35c3c82524fc7f9$var$_0n ? result : b + result;
}
module.exports.mod = $d35c3c82524fc7f9$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $d35c3c82524fc7f9$var$pow(num, power, modulo) {
    if (modulo <= $d35c3c82524fc7f9$var$_0n || power < $d35c3c82524fc7f9$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $d35c3c82524fc7f9$var$_1n) return $d35c3c82524fc7f9$var$_0n;
    let res = $d35c3c82524fc7f9$var$_1n;
    while(power > $d35c3c82524fc7f9$var$_0n){
        if (power & $d35c3c82524fc7f9$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $d35c3c82524fc7f9$var$_1n;
    }
    return res;
}
module.exports.pow = $d35c3c82524fc7f9$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $d35c3c82524fc7f9$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $d35c3c82524fc7f9$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $d35c3c82524fc7f9$var$pow2;
// Inverses number over modulo
function $d35c3c82524fc7f9$var$invert(number, modulo) {
    if (number === $d35c3c82524fc7f9$var$_0n || modulo <= $d35c3c82524fc7f9$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $d35c3c82524fc7f9$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $d35c3c82524fc7f9$var$_0n, y = $d35c3c82524fc7f9$var$_1n, u = $d35c3c82524fc7f9$var$_1n, v = $d35c3c82524fc7f9$var$_0n;
    while(a !== $d35c3c82524fc7f9$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $d35c3c82524fc7f9$var$_1n) throw new Error("invert: does not exist");
    return $d35c3c82524fc7f9$var$mod(x, modulo);
}
module.exports.invert = $d35c3c82524fc7f9$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $d35c3c82524fc7f9$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $d35c3c82524fc7f9$var$_1n) / $d35c3c82524fc7f9$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $d35c3c82524fc7f9$var$_1n, S = 0; Q % $d35c3c82524fc7f9$var$_2n === $d35c3c82524fc7f9$var$_0n; Q /= $d35c3c82524fc7f9$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $d35c3c82524fc7f9$var$_2n; Z < P && $d35c3c82524fc7f9$var$pow(Z, legendreC, P) !== P - $d35c3c82524fc7f9$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $d35c3c82524fc7f9$var$_1n) / $d35c3c82524fc7f9$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $d35c3c82524fc7f9$var$_1n) / $d35c3c82524fc7f9$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $d35c3c82524fc7f9$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $d35c3c82524fc7f9$var$tonelliShanks;
function $d35c3c82524fc7f9$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $d35c3c82524fc7f9$var$_4n === $d35c3c82524fc7f9$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $d35c3c82524fc7f9$var$_1n) / $d35c3c82524fc7f9$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $d35c3c82524fc7f9$var$_8n === $d35c3c82524fc7f9$var$_5n) {
        const c1 = (P - $d35c3c82524fc7f9$var$_5n) / $d35c3c82524fc7f9$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $d35c3c82524fc7f9$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $d35c3c82524fc7f9$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $d35c3c82524fc7f9$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $d35c3c82524fc7f9$var$tonelliShanks(P);
}
module.exports.FpSqrt = $d35c3c82524fc7f9$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $d35c3c82524fc7f9$var$isNegativeLE = (num, modulo)=>($d35c3c82524fc7f9$var$mod(num, modulo) & $d35c3c82524fc7f9$var$_1n) === $d35c3c82524fc7f9$var$_1n;
module.exports.isNegativeLE = $d35c3c82524fc7f9$var$isNegativeLE;
// prettier-ignore
const $d35c3c82524fc7f9$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $d35c3c82524fc7f9$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $d35c3c82524fc7f9$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $1GzxI.validateObject)(field, opts);
}
module.exports.validateField = $d35c3c82524fc7f9$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $d35c3c82524fc7f9$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $d35c3c82524fc7f9$var$_0n) throw new Error("Expected power > 0");
    if (power === $d35c3c82524fc7f9$var$_0n) return f.ONE;
    if (power === $d35c3c82524fc7f9$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $d35c3c82524fc7f9$var$_0n){
        if (power & $d35c3c82524fc7f9$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $d35c3c82524fc7f9$var$_1n;
    }
    return p;
}
module.exports.FpPow = $d35c3c82524fc7f9$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $d35c3c82524fc7f9$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $d35c3c82524fc7f9$var$FpInvertBatch;
function $d35c3c82524fc7f9$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $d35c3c82524fc7f9$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $d35c3c82524fc7f9$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $d35c3c82524fc7f9$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $d35c3c82524fc7f9$var$_1n) / $d35c3c82524fc7f9$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $d35c3c82524fc7f9$var$FpIsSquare;
// CURVE.n lengths
function $d35c3c82524fc7f9$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $d35c3c82524fc7f9$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $d35c3c82524fc7f9$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $d35c3c82524fc7f9$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $d35c3c82524fc7f9$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $d35c3c82524fc7f9$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $1GzxI.bitMask)(BITS),
        ZERO: $d35c3c82524fc7f9$var$_0n,
        ONE: $d35c3c82524fc7f9$var$_1n,
        create: (num)=>$d35c3c82524fc7f9$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $d35c3c82524fc7f9$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $d35c3c82524fc7f9$var$_0n,
        isOdd: (num)=>(num & $d35c3c82524fc7f9$var$_1n) === $d35c3c82524fc7f9$var$_1n,
        neg: (num)=>$d35c3c82524fc7f9$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$d35c3c82524fc7f9$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$d35c3c82524fc7f9$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$d35c3c82524fc7f9$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$d35c3c82524fc7f9$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$d35c3c82524fc7f9$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$d35c3c82524fc7f9$var$mod(lhs * $d35c3c82524fc7f9$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$d35c3c82524fc7f9$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$d35c3c82524fc7f9$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $1GzxI.numberToBytesLE)(num, BYTES) : (0, $1GzxI.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $1GzxI.bytesToNumberLE)(bytes) : (0, $1GzxI.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $d35c3c82524fc7f9$var$Field;
function $d35c3c82524fc7f9$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $d35c3c82524fc7f9$var$FpSqrtOdd;
function $d35c3c82524fc7f9$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $d35c3c82524fc7f9$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $d35c3c82524fc7f9$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $1GzxI.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $d35c3c82524fc7f9$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $1GzxI.bytesToNumberLE)(hash) : (0, $1GzxI.bytesToNumberBE)(hash);
    return $d35c3c82524fc7f9$var$mod(num, groupOrder - $d35c3c82524fc7f9$var$_1n) + $d35c3c82524fc7f9$var$_1n;
}
module.exports.hashToPrivateScalar = $d35c3c82524fc7f9$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $d35c3c82524fc7f9$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $d35c3c82524fc7f9$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $d35c3c82524fc7f9$var$getMinHashLength(fieldOrder) {
    const length = $d35c3c82524fc7f9$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $d35c3c82524fc7f9$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $d35c3c82524fc7f9$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $d35c3c82524fc7f9$var$getFieldBytesLength(fieldOrder);
    const minLen = $d35c3c82524fc7f9$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $1GzxI.bytesToNumberBE)(key) : (0, $1GzxI.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $d35c3c82524fc7f9$var$mod(num, fieldOrder - $d35c3c82524fc7f9$var$_1n) + $d35c3c82524fc7f9$var$_1n;
    return isLE ? (0, $1GzxI.numberToBytesLE)(reduced, fieldLen) : (0, $1GzxI.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $d35c3c82524fc7f9$var$mapHashToField;

});
parcelRegister("1GzxI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $13a548bfcdef076f$var$_0n = BigInt(0);
const $13a548bfcdef076f$var$_1n = BigInt(1);
const $13a548bfcdef076f$var$_2n = BigInt(2);
const $13a548bfcdef076f$var$u8a = (a)=>a instanceof Uint8Array;
const $13a548bfcdef076f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $13a548bfcdef076f$var$bytesToHex(bytes) {
    if (!$13a548bfcdef076f$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $13a548bfcdef076f$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $13a548bfcdef076f$var$bytesToHex;
function $13a548bfcdef076f$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $13a548bfcdef076f$var$numberToHexUnpadded;
function $13a548bfcdef076f$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $13a548bfcdef076f$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $13a548bfcdef076f$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $13a548bfcdef076f$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $13a548bfcdef076f$var$bytesToNumberBE(bytes) {
    return $13a548bfcdef076f$var$hexToNumber($13a548bfcdef076f$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $13a548bfcdef076f$var$bytesToNumberBE;
function $13a548bfcdef076f$var$bytesToNumberLE(bytes) {
    if (!$13a548bfcdef076f$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $13a548bfcdef076f$var$hexToNumber($13a548bfcdef076f$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $13a548bfcdef076f$var$bytesToNumberLE;
function $13a548bfcdef076f$var$numberToBytesBE(n, len) {
    return $13a548bfcdef076f$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $13a548bfcdef076f$var$numberToBytesBE;
function $13a548bfcdef076f$var$numberToBytesLE(n, len) {
    return $13a548bfcdef076f$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $13a548bfcdef076f$var$numberToBytesLE;
// Unpadded, rarely used
function $13a548bfcdef076f$var$numberToVarBytesBE(n) {
    return $13a548bfcdef076f$var$hexToBytes($13a548bfcdef076f$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $13a548bfcdef076f$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $13a548bfcdef076f$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $13a548bfcdef076f$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($13a548bfcdef076f$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $13a548bfcdef076f$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $13a548bfcdef076f$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$13a548bfcdef076f$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $13a548bfcdef076f$var$concatBytes;
function $13a548bfcdef076f$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $13a548bfcdef076f$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $13a548bfcdef076f$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $13a548bfcdef076f$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $13a548bfcdef076f$var$bitLen(n) {
    let len;
    for(len = 0; n > $13a548bfcdef076f$var$_0n; n >>= $13a548bfcdef076f$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $13a548bfcdef076f$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $13a548bfcdef076f$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $13a548bfcdef076f$var$_1n;
}
module.exports.bitGet = $13a548bfcdef076f$var$bitGet;
/**
 * Sets single bit at position.
 */ const $13a548bfcdef076f$var$bitSet = (n, pos, value)=>{
    return n | (value ? $13a548bfcdef076f$var$_1n : $13a548bfcdef076f$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $13a548bfcdef076f$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $13a548bfcdef076f$var$bitMask = (n)=>($13a548bfcdef076f$var$_2n << BigInt(n - 1)) - $13a548bfcdef076f$var$_1n;
module.exports.bitMask = $13a548bfcdef076f$var$bitMask;
// DRBG
const $13a548bfcdef076f$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $13a548bfcdef076f$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $13a548bfcdef076f$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $13a548bfcdef076f$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $13a548bfcdef076f$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $13a548bfcdef076f$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($13a548bfcdef076f$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($13a548bfcdef076f$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $13a548bfcdef076f$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $13a548bfcdef076f$var$createHmacDrbg;
// Validating curves and fields
const $13a548bfcdef076f$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $13a548bfcdef076f$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $13a548bfcdef076f$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $13a548bfcdef076f$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});



parcelRegister("ibFd0", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("aJNJC")).then(()=>parcelRequire("19jRU"));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case "preload":
            return $1c132cac09cd18d9$var$cachedPreloads;
        case "prefetch":
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("4MAdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37b7bcec438d5140$var$React = $37b7bcec438d5140$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $cRM2F = parcelRequire("cRM2F");

var $37b7bcec438d5140$var$_clsx = $37b7bcec438d5140$var$_interopRequireDefault((parcelRequire("4qr5a")));

var $koqIv = parcelRequire("koqIv");

var $01ySn = parcelRequire("01ySn");

var $37b7bcec438d5140$var$_GridItem = $37b7bcec438d5140$var$_interopRequireDefault((parcelRequire("4QVpD")));

var $37b7bcec438d5140$var$_ReactGridLayoutPropTypes = $37b7bcec438d5140$var$_interopRequireDefault((parcelRequire("cbjrM")));
function $37b7bcec438d5140$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $37b7bcec438d5140$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($37b7bcec438d5140$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $37b7bcec438d5140$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $37b7bcec438d5140$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $37b7bcec438d5140$var$_defineProperty(obj, key, value) {
    key = $37b7bcec438d5140$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $37b7bcec438d5140$var$_toPropertyKey(arg) {
    var key = $37b7bcec438d5140$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $37b7bcec438d5140$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  CompactType,
  GridResizeEvent,
  GridDragEvent,
  DragOverEvent,
  Layout,
  DroppingPosition,
  LayoutItem
} from "./utils";*/ // Types
/*:: import type { PositionParams } from "./calculateUtils";*/ /*:: type State = {
  activeDrag: ?LayoutItem,
  layout: Layout,
  mounted: boolean,
  oldDragItem: ?LayoutItem,
  oldLayout: ?Layout,
  oldResizeItem: ?LayoutItem,
  resizing: boolean,
  droppingDOMNode: ?ReactElement<any>,
  droppingPosition?: DroppingPosition,
  // Mirrored props
  children: ReactChildrenArray<ReactElement<any>>,
  compactType?: CompactType,
  propsLayout?: Layout
};*/ /*:: import type { Props, DefaultProps } from "./ReactGridLayoutPropTypes";*/ // End Types
const $37b7bcec438d5140$var$layoutClassName = "react-grid-layout";
let $37b7bcec438d5140$var$isFirefox = false;
// Try...catch will protect from navigator not existing (e.g. node) or a bad implementation of navigator
try {
    $37b7bcec438d5140$var$isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
/* Ignore */ }
/**
 * A reactive, fluid grid layout with draggable, resizable components.
 */ class $37b7bcec438d5140$var$ReactGridLayout extends $37b7bcec438d5140$var$React.Component /*:: <Props, State>*/  {
    constructor(){
        super(...arguments);
        $37b7bcec438d5140$var$_defineProperty(this, "state", {
            activeDrag: null,
            layout: (0, $koqIv.synchronizeLayoutWithChildren)(this.props.layout, this.props.children, this.props.cols, // Legacy support for verticalCompact: false
            (0, $koqIv.compactType)(this.props), this.props.allowOverlap),
            mounted: false,
            oldDragItem: null,
            oldLayout: null,
            oldResizeItem: null,
            resizing: false,
            droppingDOMNode: null,
            children: []
        });
        $37b7bcec438d5140$var$_defineProperty(this, "dragEnterCounter", 0);
        /**
     * When dragging starts
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $37b7bcec438d5140$var$_defineProperty(this, "onDragStart", (i /*: string*/ , x /*: number*/ , y /*: number*/ , _ref /*:: */ )=>{
            let { e: e, node: node } /*: GridDragEvent*/  = _ref /*: GridDragEvent*/ ;
            const { layout: layout } = this.state;
            const l = (0, $koqIv.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            this.setState({
                oldDragItem: (0, $koqIv.cloneLayoutItem)(l),
                oldLayout: layout,
                activeDrag: placeholder
            });
            return this.props.onDragStart(layout, l, l, null, e, node);
        });
        /**
     * Each drag movement create a new dragelement and move the element to the dragged location
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $37b7bcec438d5140$var$_defineProperty(this, "onDrag", (i, x, y, _ref2)=>{
            let { e: e, node: node } = _ref2;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, allowOverlap: allowOverlap, preventCollision: preventCollision } = this.props;
            const l = (0, $koqIv.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            // Move the element to the dragged location.
            const isUserAction = true;
            layout = (0, $koqIv.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $koqIv.compactType)(this.props), cols, allowOverlap);
            this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
            this.setState({
                layout: allowOverlap ? layout : (0, $koqIv.compact)(layout, (0, $koqIv.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        /**
     * When dragging stops, figure out which position the element is closest to and update its x and y.
     * @param  {String} i Index of the child.
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $37b7bcec438d5140$var$_defineProperty(this, "onDragStop", (i, x, y, _ref3)=>{
            let { e: e, node: node } = _ref3;
            if (!this.state.activeDrag) return;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            const l = (0, $koqIv.getLayoutItem)(layout, i);
            if (!l) return;
            // Move the element here
            const isUserAction = true;
            layout = (0, $koqIv.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $koqIv.compactType)(this.props), cols, allowOverlap);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $koqIv.compact)(layout, (0, $koqIv.compactType)(this.props), cols);
            this.props.onDragStop(newLayout, oldDragItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldDragItem: null,
                oldLayout: null
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        $37b7bcec438d5140$var$_defineProperty(this, "onResizeStart", (i, w, h, _ref4)=>{
            let { e: e, node: node } = _ref4;
            const { layout: layout } = this.state;
            const l = (0, $koqIv.getLayoutItem)(layout, i);
            if (!l) return;
            this.setState({
                oldResizeItem: (0, $koqIv.cloneLayoutItem)(l),
                oldLayout: this.state.layout,
                resizing: true
            });
            this.props.onResizeStart(layout, l, l, null, e, node);
        });
        $37b7bcec438d5140$var$_defineProperty(this, "onResize", (i, w, h, _ref5)=>{
            let { e: e, node: node, size: size, handle: handle } = _ref5;
            const { oldResizeItem: oldResizeItem } = this.state;
            const { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            let shouldMoveItem = false;
            let finalLayout;
            let x;
            let y;
            const [newLayout, l] = (0, $koqIv.withLayoutItem)(layout, i, (l)=>{
                let hasCollisions;
                x = l.x;
                y = l.y;
                if ([
                    "sw",
                    "w",
                    "nw",
                    "n",
                    "ne"
                ].indexOf(handle) !== -1) {
                    if ([
                        "sw",
                        "nw",
                        "w"
                    ].indexOf(handle) !== -1) {
                        x = l.x + (l.w - w);
                        w = l.x !== x && x < 0 ? l.w : w;
                        x = x < 0 ? 0 : x;
                    }
                    if ([
                        "ne",
                        "n",
                        "nw"
                    ].indexOf(handle) !== -1) {
                        y = l.y + (l.h - h);
                        h = l.y !== y && y < 0 ? l.h : h;
                        y = y < 0 ? 0 : y;
                    }
                    shouldMoveItem = true;
                }
                // Something like quad tree should be used
                // to find collisions faster
                if (preventCollision && !allowOverlap) {
                    const collisions = (0, $koqIv.getAllCollisions)(layout, {
                        ...l,
                        w: w,
                        h: h,
                        x: x,
                        y: y
                    }).filter((layoutItem)=>layoutItem.i !== l.i);
                    hasCollisions = collisions.length > 0;
                    // If we're colliding, we need adjust the placeholder.
                    if (hasCollisions) {
                        // Reset layoutItem dimensions if there were collisions
                        y = l.y;
                        h = l.h;
                        x = l.x;
                        w = l.w;
                        shouldMoveItem = false;
                    }
                }
                l.w = w;
                l.h = h;
                return l;
            });
            // Shouldn't ever happen, but typechecking makes it necessary
            if (!l) return;
            finalLayout = newLayout;
            if (shouldMoveItem) {
                // Move the element to the new position.
                const isUserAction = true;
                finalLayout = (0, $koqIv.moveElement)(newLayout, l, x, y, isUserAction, this.props.preventCollision, (0, $koqIv.compactType)(this.props), cols, allowOverlap);
            }
            // Create placeholder element (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                static: true,
                i: i
            };
            this.props.onResize(finalLayout, oldResizeItem, l, placeholder, e, node);
            // Re-compact the newLayout and set the drag placeholder.
            this.setState({
                layout: allowOverlap ? finalLayout : (0, $koqIv.compact)(finalLayout, (0, $koqIv.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        $37b7bcec438d5140$var$_defineProperty(this, "onResizeStop", (i, w, h, _ref6)=>{
            let { e: e, node: node } = _ref6;
            const { layout: layout, oldResizeItem: oldResizeItem } = this.state;
            const { cols: cols, allowOverlap: allowOverlap } = this.props;
            const l = (0, $koqIv.getLayoutItem)(layout, i);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $koqIv.compact)(layout, (0, $koqIv.compactType)(this.props), cols);
            this.props.onResizeStop(newLayout, oldResizeItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldResizeItem: null,
                oldLayout: null,
                resizing: false
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        // Called while dragging an element. Part of browser native drag/drop API.
        // Native event target might be the layout itself, or an element within the layout.
        $37b7bcec438d5140$var$_defineProperty(this, "onDragOver", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            // we should ignore events from layout's children in Firefox
            // to avoid unpredictable jumping of a dropping placeholder
            // FIXME remove this hack
            if ($37b7bcec438d5140$var$isFirefox && // $FlowIgnore can't figure this out
            !e.nativeEvent.target?.classList.contains($37b7bcec438d5140$var$layoutClassName)) return false;
            const { droppingItem: droppingItem, onDropDragOver: onDropDragOver, margin: margin, cols: cols, rowHeight: rowHeight, maxRows: maxRows, width: width, containerPadding: containerPadding, transformScale: transformScale } = this.props;
            // Allow user to customize the dropping item or short-circuit the drop based on the results
            // of the `onDragOver(e: Event)` callback.
            const onDragOverResult = onDropDragOver?.(e);
            if (onDragOverResult === false) {
                if (this.state.droppingDOMNode) this.removeDroppingPlaceholder();
                return false;
            }
            const finalDroppingItem = {
                ...droppingItem,
                ...onDragOverResult
            };
            const { layout: layout } = this.state;
            // $FlowIgnore missing def
            const gridRect = e.currentTarget.getBoundingClientRect(); // The grid's position in the viewport
            // Calculate the mouse position relative to the grid
            const layerX = e.clientX - gridRect.left;
            const layerY = e.clientY - gridRect.top;
            const droppingPosition = {
                left: layerX / transformScale,
                top: layerY / transformScale,
                e: e
            };
            if (!this.state.droppingDOMNode) {
                const positionParams /*: PositionParams*/  = {
                    cols: cols,
                    margin: margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    containerWidth: width,
                    containerPadding: containerPadding || margin
                };
                const calculatedPosition = (0, $01ySn.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
                this.setState({
                    droppingDOMNode: /*#__PURE__*/ $37b7bcec438d5140$var$React.createElement("div", {
                        key: finalDroppingItem.i
                    }),
                    droppingPosition: droppingPosition,
                    layout: [
                        ...layout,
                        {
                            ...finalDroppingItem,
                            x: calculatedPosition.x,
                            y: calculatedPosition.y,
                            static: false,
                            isDraggable: true
                        }
                    ]
                });
            } else if (this.state.droppingPosition) {
                const { left: left, top: top } = this.state.droppingPosition;
                const shouldUpdatePosition = left != layerX || top != layerY;
                if (shouldUpdatePosition) this.setState({
                    droppingPosition: droppingPosition
                });
            }
        });
        $37b7bcec438d5140$var$_defineProperty(this, "removeDroppingPlaceholder", ()=>{
            const { droppingItem: droppingItem, cols: cols } = this.props;
            const { layout: layout } = this.state;
            const newLayout = (0, $koqIv.compact)(layout.filter((l)=>l.i !== droppingItem.i), (0, $koqIv.compactType)(this.props), cols, this.props.allowOverlap);
            this.setState({
                layout: newLayout,
                droppingDOMNode: null,
                activeDrag: null,
                droppingPosition: undefined
            });
        });
        $37b7bcec438d5140$var$_defineProperty(this, "onDragLeave", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter--;
            // onDragLeave can be triggered on each layout's child.
            // But we know that count of dragEnter and dragLeave events
            // will be balanced after leaving the layout's container
            // so we can increase and decrease count of dragEnter and
            // when it'll be equal to 0 we'll remove the placeholder
            if (this.dragEnterCounter === 0) this.removeDroppingPlaceholder();
        });
        $37b7bcec438d5140$var$_defineProperty(this, "onDragEnter", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter++;
        });
        $37b7bcec438d5140$var$_defineProperty(this, "onDrop", (e /*: Event*/ )=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            const { droppingItem: droppingItem } = this.props;
            const { layout: layout } = this.state;
            const item = layout.find((l)=>l.i === droppingItem.i);
            // reset dragEnter counter on drop
            this.dragEnterCounter = 0;
            this.removeDroppingPlaceholder();
            this.props.onDrop(layout, item, e);
        });
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
        // Possibly call back with layout on mount. This should be done after correcting the layout width
        // to ensure we don't rerender with the wrong width.
        this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
    static getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State> | null*/ {
        let newLayoutBase;
        if (prevState.activeDrag) return null;
        // Legacy support for compactType
        // Allow parent to set layout directly.
        if (!(0, $cRM2F.deepEqual)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) newLayoutBase = nextProps.layout;
        else if (!(0, $koqIv.childrenEqual)(nextProps.children, prevState.children)) // If children change, also regenerate the layout. Use our state
        // as the base in case because it may be more up to date than
        // what is in props.
        newLayoutBase = prevState.layout;
        // We need to regenerate the layout.
        if (newLayoutBase) {
            const newLayout = (0, $koqIv.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, $koqIv.compactType)(nextProps), nextProps.allowOverlap);
            return {
                layout: newLayout,
                // We need to save these props to state for using
                // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
                compactType: nextProps.compactType,
                children: nextProps.children,
                propsLayout: nextProps.layout
            };
        }
        return null;
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        return(// NOTE: this is almost always unequal. Therefore the only way to get better performance
        // from SCU is if the user intentionally memoizes children. If they do, and they can
        // handle changes properly, performance will increase.
        this.props.children !== nextProps.children || !(0, $koqIv.fastRGLPropsEqual)(this.props, nextProps, $cRM2F.deepEqual) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition);
    }
    componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
        if (!this.state.activeDrag) {
            const newLayout = this.state.layout;
            const oldLayout = prevState.layout;
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        }
    }
    /**
   * Calculates a pixel value for the container.
   * @return {String} Container height in pixels.
   */ containerHeight() /*: ?string*/ {
        if (!this.props.autoSize) return;
        const nbRow = (0, $koqIv.bottom)(this.state.layout);
        const containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
        return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
    }
    onLayoutMaybeChanged(newLayout /*: Layout*/ , oldLayout /*: ?Layout*/ ) {
        if (!oldLayout) oldLayout = this.state.layout;
        if (!(0, $cRM2F.deepEqual)(oldLayout, newLayout)) this.props.onLayoutChange(newLayout);
    }
    /**
   * Create a placeholder object.
   * @return {Element} Placeholder div.
   */ placeholder() /*: ?ReactElement<any>*/ {
        const { activeDrag: activeDrag } = this.state;
        if (!activeDrag) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, useCSSTransforms: useCSSTransforms, transformScale: transformScale } = this.props;
        // {...this.state.activeDrag} is pretty slow, actually
        return /*#__PURE__*/ $37b7bcec438d5140$var$React.createElement($37b7bcec438d5140$var$_GridItem.default, {
            w: activeDrag.w,
            h: activeDrag.h,
            x: activeDrag.x,
            y: activeDrag.y,
            i: activeDrag.i,
            className: `react-grid-placeholder ${this.state.resizing ? "placeholder-resizing" : ""}`,
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            isDraggable: false,
            isResizable: false,
            isBounded: false,
            useCSSTransforms: useCSSTransforms,
            transformScale: transformScale
        }, /*#__PURE__*/ $37b7bcec438d5140$var$React.createElement("div", null));
    }
    /**
   * Given a grid item, set its style attributes & surround in a <Draggable>.
   * @param  {Element} child React element.
   * @return {Element}       Element wrapped in draggable and properly placed.
   */ processGridItem(child /*: ReactElement<any>*/ , isDroppingItem /*: boolean*/ ) /*: ?ReactElement<any>*/ {
        if (!child || !child.key) return;
        const l = (0, $koqIv.getLayoutItem)(this.state.layout, String(child.key));
        if (!l) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, isDraggable: isDraggable, isResizable: isResizable, isBounded: isBounded, useCSSTransforms: useCSSTransforms, transformScale: transformScale, draggableCancel: draggableCancel, draggableHandle: draggableHandle, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const { mounted: mounted, droppingPosition: droppingPosition } = this.state;
        // Determine user manipulations possible.
        // If an item is static, it can't be manipulated by default.
        // Any properties defined directly on the grid item will take precedence.
        const draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
        const resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
        const resizeHandlesOptions = l.resizeHandles || resizeHandles;
        // isBounded set on child if set on parent, and child is not explicitly false
        const bounded = draggable && isBounded && l.isBounded !== false;
        return /*#__PURE__*/ $37b7bcec438d5140$var$React.createElement($37b7bcec438d5140$var$_GridItem.default, {
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            cancel: draggableCancel,
            handle: draggableHandle,
            onDragStop: this.onDragStop,
            onDragStart: this.onDragStart,
            onDrag: this.onDrag,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            isDraggable: draggable,
            isResizable: resizable,
            isBounded: bounded,
            useCSSTransforms: useCSSTransforms && mounted,
            usePercentages: !mounted,
            transformScale: transformScale,
            w: l.w,
            h: l.h,
            x: l.x,
            y: l.y,
            i: l.i,
            minH: l.minH,
            minW: l.minW,
            maxH: l.maxH,
            maxW: l.maxW,
            static: l.static,
            droppingPosition: isDroppingItem ? droppingPosition : undefined,
            resizeHandles: resizeHandlesOptions,
            resizeHandle: resizeHandle
        }, child);
    }
    render() /*: React.Element<"div">*/ {
        const { className: className, style: style, isDroppable: isDroppable, innerRef: innerRef } = this.props;
        const mergedClassName = (0, $37b7bcec438d5140$var$_clsx.default)($37b7bcec438d5140$var$layoutClassName, className);
        const mergedStyle = {
            height: this.containerHeight(),
            ...style
        };
        return /*#__PURE__*/ $37b7bcec438d5140$var$React.createElement("div", {
            ref: innerRef,
            className: mergedClassName,
            style: mergedStyle,
            onDrop: isDroppable ? this.onDrop : $koqIv.noop,
            onDragLeave: isDroppable ? this.onDragLeave : $koqIv.noop,
            onDragEnter: isDroppable ? this.onDragEnter : $koqIv.noop,
            onDragOver: isDroppable ? this.onDragOver : $koqIv.noop
        }, $37b7bcec438d5140$var$React.Children.map(this.props.children, (child)=>this.processGridItem(child)), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
    }
}
module.exports.default = $37b7bcec438d5140$var$ReactGridLayout;
// TODO publish internal ReactClass displayName transform
$37b7bcec438d5140$var$_defineProperty($37b7bcec438d5140$var$ReactGridLayout, "displayName", "ReactGridLayout");
// Refactored to another module to make way for preval
$37b7bcec438d5140$var$_defineProperty($37b7bcec438d5140$var$ReactGridLayout, "propTypes", $37b7bcec438d5140$var$_ReactGridLayoutPropTypes.default);
$37b7bcec438d5140$var$_defineProperty($37b7bcec438d5140$var$ReactGridLayout, "defaultProps", {
    autoSize: true,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: Infinity,
    // infinite vertical growth
    layout: [],
    margin: [
        10,
        10
    ],
    isBounded: false,
    isDraggable: true,
    isResizable: true,
    allowOverlap: false,
    isDroppable: false,
    useCSSTransforms: true,
    transformScale: 1,
    verticalCompact: true,
    compactType: "vertical",
    preventCollision: false,
    droppingItem: {
        i: "__dropping-elem__",
        h: 1,
        w: 1
    },
    resizeHandles: [
        "se"
    ],
    onLayoutChange: $koqIv.noop,
    onDragStart: $koqIv.noop,
    onDrag: $koqIv.noop,
    onDragStop: $koqIv.noop,
    onResizeStart: $koqIv.noop,
    onResize: $koqIv.noop,
    onResizeStop: $koqIv.noop,
    onDrop: $koqIv.noop,
    onDropDragOver: $koqIv.noop
});

});
parcelRegister("cRM2F", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    /**
   * Default equality comparator pass-through, used as the standard `isEqual` creator for
   * use inside the built comparator.
   */ function createDefaultIsNestedEqual(comparator) {
        return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
            return comparator(a, b, meta);
        };
    }
    /**
   * Wrap the provided `areItemsEqual` method to manage the circular cache, allowing
   * for circular references to be safely included in the comparison without creating
   * stack overflows.
   */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, isEqual, cache) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, isEqual, cache);
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, isEqual, cache);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
   * Targeted shallow merge of two objects.
   *
   * @NOTE
   * This exists as a tinier compiled version of the `__assign` helper that
   * `tsc` injects in case of `Object.assign` not being present.
   */ function merge(a, b) {
        var merged = {};
        for(var key in a)merged[key] = a[key];
        for(var key in b)merged[key] = b[key];
        return merged;
    }
    /**
   * Whether the value is a plain object.
   *
   * @NOTE
   * This is a same-realm compariosn only.
   */ function isPlainObject(value) {
        return value.constructor === Object || value.constructor == null;
    }
    /**
   * When the value is `Promise`-like, aka "then-able".
   */ function isPromiseLike(value) {
        return typeof value.then === "function";
    }
    /**
   * Whether the values passed are strictly equal or both NaN.
   */ function sameValueZeroEqual(a, b) {
        return a === b || a !== a && b !== b;
    }
    var ARGUMENTS_TAG = "[object Arguments]";
    var BOOLEAN_TAG = "[object Boolean]";
    var DATE_TAG = "[object Date]";
    var REG_EXP_TAG = "[object RegExp]";
    var MAP_TAG = "[object Map]";
    var NUMBER_TAG = "[object Number]";
    var OBJECT_TAG = "[object Object]";
    var SET_TAG = "[object Set]";
    var STRING_TAG = "[object String]";
    var toString = Object.prototype.toString;
    function createComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, createIsNestedEqual = _a.createIsNestedEqual;
        var isEqual = createIsNestedEqual(comparator);
        /**
       * compare the value of the two objects and return true if they are equivalent in values
       */ function comparator(a, b, meta) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return a !== a && b !== b;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid the `toString.call()` cost unless necessary.
            if (isPlainObject(a) && isPlainObject(b)) return areObjectsEqual(a, b, isEqual, meta);
            // `isArray()` works on subclasses and is cross-realm, so we can again avoid
            // the `toString.call()` cost unless necessary by just checking if either
            // and then both are arrays.
            var aArray = Array.isArray(a);
            var bArray = Array.isArray(b);
            if (aArray || bArray) return aArray === bArray && areArraysEqual(a, b, isEqual, meta);
            // Since this is a custom object, use the classic `toString.call()` to get its
            // type. This is reasonably performant in modern environments like v8 and
            // SpiderMonkey, and allows for cross-realm comparison when other checks like
            // `instanceof` do not.
            var aTag = toString.call(a);
            if (aTag !== toString.call(b)) return false;
            if (aTag === DATE_TAG) // `getTime()` showed better results compared to alternatives like `valueOf()`
            // or the unary `+` operator.
            return areDatesEqual(a, b, isEqual, meta);
            if (aTag === REG_EXP_TAG) return areRegExpsEqual(a, b, isEqual, meta);
            if (aTag === MAP_TAG) return areMapsEqual(a, b, isEqual, meta);
            if (aTag === SET_TAG) return areSetsEqual(a, b, isEqual, meta);
            // If a simple object tag, then we can prioritize a simple object comparison because
            // it is likely a custom class. If an arguments tag, it should be treated as a standard
            // object.
            if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) // The exception for value comparison is `Promise`-like contracts. These should be
            // treated the same as standard `Promise` objects, which means strict equality.
            return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual(a, b, isEqual, meta);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) return sameValueZeroEqual(a.valueOf(), b.valueOf());
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        }
        return comparator;
    }
    /**
   * Whether the arrays are equal in value.
   */ function areArraysEqual(a, b, isEqual, meta) {
        var index = a.length;
        if (b.length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isEqual(a[index], b[index], index, index, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the arrays are equal in value, including circular references.
   */ var areArraysEqualCircular = createIsCircular(areArraysEqual);
    /**
   * Whether the dates passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides.
   */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
   * Whether the `Map`s are equal in value.
   */ function areMapsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        var indexA = 0;
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndexB = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndexB] && (hasMatch = isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndexB] = true;
                matchIndexB++;
            });
            indexA++;
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Map`s are equal in value, including circular references.
   */ var areMapsEqualCircular = createIsCircular(areMapsEqual);
    var OWNER = "_owner";
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Whether the objects are equal in value.
   */ function areObjectsEqual(a, b, isEqual, meta) {
        var keysA = Object.keys(a);
        var index = keysA.length;
        if (Object.keys(b).length !== index) return false;
        var key;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            key = keysA[index];
            if (key === OWNER) {
                var reactElementA = !!a.$$typeof;
                var reactElementB = !!b.$$typeof;
                if ((reactElementA || reactElementB) && reactElementA !== reactElementB) return false;
            }
            if (!hasOwnProperty.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the objects are equal in value, including circular references.
   */ var areObjectsEqualCircular = createIsCircular(areObjectsEqual);
    /**
   * Whether the regexps passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides. An example of this would be supporting a
   * pre-ES2015 environment where the `flags` property is not available.
   */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
   * Whether the `Set`s are equal in value.
   */ function areSetsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndex = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndex] = true;
                matchIndex++;
            });
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Set`s are equal in value, including circular references.
   */ var areSetsEqualCircular = createIsCircular(areSetsEqual);
    var DEFAULT_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqual,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqual,
        areObjectsEqual: areObjectsEqual,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqual,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqualCircular,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqualCircular,
        areObjectsEqual: areObjectsEqualCircular,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqualCircular,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var isDeepEqual = createComparator(DEFAULT_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value.
   */ function deepEqual(a, b) {
        return isDeepEqual(a, b, undefined);
    }
    var isShallowEqual = createComparator(merge(DEFAULT_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value.
   */ function shallowEqual(a, b) {
        return isShallowEqual(a, b, undefined);
    }
    var isCircularDeepEqual = createComparator(DEFAULT_CIRCULAR_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value, including circular references.
   */ function circularDeepEqual(a, b) {
        return isCircularDeepEqual(a, b, new WeakMap());
    }
    var isCircularShallowEqual = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value, including circular references.
   */ function circularShallowEqual(a, b) {
        return isCircularShallowEqual(a, b, new WeakMap());
    }
    /**
   * Create a custom equality comparison method.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `RegExp.prototype.flags` out of the box.
   */ function createCustomEqual(getComparatorOptions) {
        return createComparator(merge(DEFAULT_CONFIG, getComparatorOptions(DEFAULT_CONFIG)));
    }
    /**
   * Create a custom equality comparison method that handles circular references. This is very
   * similar to `createCustomEqual`, with the only difference being that `meta` expects to be
   * populated with a `WeakMap`-like contract.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `WeakMap` out of the box.
   */ function createCustomCircularEqual(getComparatorOptions) {
        var comparator = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, getComparatorOptions(DEFAULT_CIRCULAR_CONFIG)));
        return function(a, b, meta) {
            if (meta === void 0) meta = new WeakMap();
            return comparator(a, b, meta);
        };
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomCircularEqual = createCustomCircularEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("koqIv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bottom = $ed8ac5f8b2ab9eb2$var$bottom;
module.exports.childrenEqual = $ed8ac5f8b2ab9eb2$var$childrenEqual;
module.exports.cloneLayout = $ed8ac5f8b2ab9eb2$var$cloneLayout;
module.exports.cloneLayoutItem = $ed8ac5f8b2ab9eb2$var$cloneLayoutItem;
module.exports.collides = $ed8ac5f8b2ab9eb2$var$collides;
module.exports.compact = $ed8ac5f8b2ab9eb2$var$compact;
module.exports.compactItem = $ed8ac5f8b2ab9eb2$var$compactItem;
module.exports.compactType = $ed8ac5f8b2ab9eb2$var$compactType;
module.exports.correctBounds = $ed8ac5f8b2ab9eb2$var$correctBounds;
module.exports.fastPositionEqual = $ed8ac5f8b2ab9eb2$var$fastPositionEqual;
module.exports.fastRGLPropsEqual = void 0;
module.exports.getAllCollisions = $ed8ac5f8b2ab9eb2$var$getAllCollisions;
module.exports.getFirstCollision = $ed8ac5f8b2ab9eb2$var$getFirstCollision;
module.exports.getLayoutItem = $ed8ac5f8b2ab9eb2$var$getLayoutItem;
module.exports.getStatics = $ed8ac5f8b2ab9eb2$var$getStatics;
module.exports.modifyLayout = $ed8ac5f8b2ab9eb2$var$modifyLayout;
module.exports.moveElement = $ed8ac5f8b2ab9eb2$var$moveElement;
module.exports.moveElementAwayFromCollision = $ed8ac5f8b2ab9eb2$var$moveElementAwayFromCollision;
module.exports.noop = void 0;
module.exports.perc = $ed8ac5f8b2ab9eb2$var$perc;
module.exports.resizeItemInDirection = $ed8ac5f8b2ab9eb2$var$resizeItemInDirection;
module.exports.setTopLeft = $ed8ac5f8b2ab9eb2$var$setTopLeft;
module.exports.setTransform = $ed8ac5f8b2ab9eb2$var$setTransform;
module.exports.sortLayoutItems = $ed8ac5f8b2ab9eb2$var$sortLayoutItems;
module.exports.sortLayoutItemsByColRow = $ed8ac5f8b2ab9eb2$var$sortLayoutItemsByColRow;
module.exports.sortLayoutItemsByRowCol = $ed8ac5f8b2ab9eb2$var$sortLayoutItemsByRowCol;
module.exports.synchronizeLayoutWithChildren = $ed8ac5f8b2ab9eb2$var$synchronizeLayoutWithChildren;
module.exports.validateLayout = $ed8ac5f8b2ab9eb2$var$validateLayout;
module.exports.withLayoutItem = $ed8ac5f8b2ab9eb2$var$withLayoutItem;

var $cRM2F = parcelRequire("cRM2F");

var $ed8ac5f8b2ab9eb2$var$_react = $ed8ac5f8b2ab9eb2$var$_interopRequireDefault((parcelRequire("exYeM")));
function $ed8ac5f8b2ab9eb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: export type ResizeHandleAxis =
  | "s"
  | "w"
  | "e"
  | "n"
  | "sw"
  | "nw"
  | "se"
  | "ne";*/ /*:: export type LayoutItem = {
  w: number,
  h: number,
  x: number,
  y: number,
  i: string,
  minW?: number,
  minH?: number,
  maxW?: number,
  maxH?: number,
  moved?: boolean,
  static?: boolean,
  isDraggable?: ?boolean,
  isResizable?: ?boolean,
  resizeHandles?: Array<ResizeHandleAxis>,
  isBounded?: ?boolean
};*/ /*:: export type Layout = $ReadOnlyArray<LayoutItem>;*/ /*:: export type Position = {
  left: number,
  top: number,
  width: number,
  height: number
};*/ /*:: export type ReactDraggableCallbackData = {
  node: HTMLElement,
  x?: number,
  y?: number,
  deltaX: number,
  deltaY: number,
  lastX?: number,
  lastY?: number
};*/ /*:: export type PartialPosition = { left: number, top: number };*/ /*:: export type DroppingPosition = { left: number, top: number, e: Event };*/ /*:: export type Size = { width: number, height: number };*/ /*:: export type GridDragEvent = {
  e: Event,
  node: HTMLElement,
  newPosition: PartialPosition
};*/ /*:: export type GridResizeEvent = {
  e: Event,
  node: HTMLElement,
  size: Size,
  handle: string
};*/ /*:: export type DragOverEvent = MouseEvent & {
  nativeEvent: {
    layerX: number,
    layerY: number,
    ...Event
  }
};*/ /*:: export type Pick<FromType, Properties: { [string]: 0 }> = $Exact<
  $ObjMapi<Properties, <K, V>(k: K, v: V) => $ElementType<FromType, K>>
>;*/ // Helpful port from TS
/*:: type REl = ReactElement<any>;*/ /*:: export type ReactChildren = ReactChildrenArray<REl>;*/ /*:: export type EventCallback = (
  Layout,
  oldItem: ?LayoutItem,
  newItem: ?LayoutItem,
  placeholder: ?LayoutItem,
  Event,
  ?HTMLElement
) => void;*/ // All callbacks are of the signature (layout, oldItem, newItem, placeholder, e).
/*:: export type CompactType = ?("horizontal" | "vertical");*/ const $ed8ac5f8b2ab9eb2$var$isProduction = true;
const $ed8ac5f8b2ab9eb2$var$DEBUG = false;
/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */ function $ed8ac5f8b2ab9eb2$var$bottom(layout /*: Layout*/ ) /*: number*/ {
    let max = 0, bottomY;
    for(let i = 0, len = layout.length; i < len; i++){
        bottomY = layout[i].y + layout[i].h;
        if (bottomY > max) max = bottomY;
    }
    return max;
}
function $ed8ac5f8b2ab9eb2$var$cloneLayout(layout /*: Layout*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)newLayout[i] = $ed8ac5f8b2ab9eb2$var$cloneLayoutItem(layout[i]);
    return newLayout;
}
// Modify a layoutItem inside a layout. Returns a new Layout,
// does not mutate. Carries over all other LayoutItems unmodified.
function $ed8ac5f8b2ab9eb2$var$modifyLayout(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)if (layoutItem.i === layout[i].i) newLayout[i] = layoutItem;
    else newLayout[i] = layout[i];
    return newLayout;
}
// Function to be called to modify a layout item.
// Does defensive clones to ensure the layout is not modified.
function $ed8ac5f8b2ab9eb2$var$withLayoutItem(layout /*: Layout*/ , itemKey /*: string*/ , cb /*: LayoutItem => LayoutItem*/ ) /*: [Layout, ?LayoutItem]*/ {
    let item = $ed8ac5f8b2ab9eb2$var$getLayoutItem(layout, itemKey);
    if (!item) return [
        layout,
        null
    ];
    item = cb($ed8ac5f8b2ab9eb2$var$cloneLayoutItem(item)); // defensive clone then modify
    // FIXME could do this faster if we already knew the index
    layout = $ed8ac5f8b2ab9eb2$var$modifyLayout(layout, item);
    return [
        layout,
        item
    ];
}
// Fast path to cloning, since this is monomorphic
function $ed8ac5f8b2ab9eb2$var$cloneLayoutItem(layoutItem /*: LayoutItem*/ ) /*: LayoutItem*/ {
    return {
        w: layoutItem.w,
        h: layoutItem.h,
        x: layoutItem.x,
        y: layoutItem.y,
        i: layoutItem.i,
        minW: layoutItem.minW,
        maxW: layoutItem.maxW,
        minH: layoutItem.minH,
        maxH: layoutItem.maxH,
        moved: Boolean(layoutItem.moved),
        static: Boolean(layoutItem.static),
        // These can be null/undefined
        isDraggable: layoutItem.isDraggable,
        isResizable: layoutItem.isResizable,
        resizeHandles: layoutItem.resizeHandles,
        isBounded: layoutItem.isBounded
    };
}
/**
 * Comparing React `children` is a bit difficult. This is a good way to compare them.
 * This will catch differences in keys, order, and length.
 */ function $ed8ac5f8b2ab9eb2$var$childrenEqual(a /*: ReactChildren*/ , b /*: ReactChildren*/ ) /*: boolean*/ {
    return (0, $cRM2F.deepEqual)($ed8ac5f8b2ab9eb2$var$_react.default.Children.map(a, (c)=>c?.key), $ed8ac5f8b2ab9eb2$var$_react.default.Children.map(b, (c)=>c?.key)) && (0, $cRM2F.deepEqual)($ed8ac5f8b2ab9eb2$var$_react.default.Children.map(a, (c)=>c?.props["data-grid"]), $ed8ac5f8b2ab9eb2$var$_react.default.Children.map(b, (c)=>c?.props["data-grid"]));
}

/**
 * See `fastRGLPropsEqual.js`.
 * We want this to run as fast as possible - it is called often - and to be
 * resilient to new props that we add. So rather than call lodash.isEqual,
 * which isn't suited to comparing props very well, we use this specialized
 * function in conjunction with preval to generate the fastest possible comparison
 * function, tuned for exactly our props.
 */ /*:: type FastRGLPropsEqual = (Object, Object, Function) => boolean;*/ const $ed8ac5f8b2ab9eb2$var$fastRGLPropsEqual /*: FastRGLPropsEqual*/  = module.exports.fastRGLPropsEqual = (parcelRequire("hm2hA"));
// Like the above, but a lot simpler.
function $ed8ac5f8b2ab9eb2$var$fastPositionEqual(a /*: Position*/ , b /*: Position*/ ) /*: boolean*/ {
    return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
/**
 * Given two layoutitems, check if they collide.
 */ function $ed8ac5f8b2ab9eb2$var$collides(l1 /*: LayoutItem*/ , l2 /*: LayoutItem*/ ) /*: boolean*/ {
    if (l1.i === l2.i) return false; // same element
    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
    return true; // boxes overlap
}
/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * Does not modify layout items (clones). Creates a new layout array.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @param  {Boolean} allowOverlap When `true`, allows overlapping grid items.
 * @return {Array}       Compacted Layout.
 */ function $ed8ac5f8b2ab9eb2$var$compact(layout /*: Layout*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // Statics go in the compareWith array right away so items flow around them.
    const compareWith = $ed8ac5f8b2ab9eb2$var$getStatics(layout);
    // We go through the items by row and column.
    const sorted = $ed8ac5f8b2ab9eb2$var$sortLayoutItems(layout, compactType);
    // Holding for new items.
    const out = Array(layout.length);
    for(let i = 0, len = sorted.length; i < len; i++){
        let l = $ed8ac5f8b2ab9eb2$var$cloneLayoutItem(sorted[i]);
        // Don't move static elements
        if (!l.static) {
            l = $ed8ac5f8b2ab9eb2$var$compactItem(compareWith, l, compactType, cols, sorted, allowOverlap);
            // Add to comparison array. We only collide with items before this one.
            // Statics are already in this array.
            compareWith.push(l);
        }
        // Add to output array to make sure they still come out in the right order.
        out[layout.indexOf(sorted[i])] = l;
        // Clear moved flag, if it exists.
        l.moved = false;
    }
    return out;
}
const $ed8ac5f8b2ab9eb2$var$heightWidth = {
    x: "w",
    y: "h"
};
/**
 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
 */ function $ed8ac5f8b2ab9eb2$var$resolveCompactionCollision(layout /*: Layout*/ , item /*: LayoutItem*/ , moveToCoord /*: number*/ , axis /*: "x" | "y"*/ ) {
    const sizeProp = $ed8ac5f8b2ab9eb2$var$heightWidth[axis];
    item[axis] += 1;
    const itemIndex = layout.map((layoutItem)=>{
        return layoutItem.i;
    }).indexOf(item.i);
    // Go through each item we collide with.
    for(let i = itemIndex + 1; i < layout.length; i++){
        const otherItem = layout[i];
        // Ignore static items
        if (otherItem.static) continue;
        // Optimization: we can break early if we know we're past this el
        // We can do this b/c it's a sorted layout
        if (otherItem.y > item.y + item.h) break;
        if ($ed8ac5f8b2ab9eb2$var$collides(item, otherItem)) $ed8ac5f8b2ab9eb2$var$resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
    item[axis] = moveToCoord;
}
/**
 * Compact an item in the layout.
 *
 * Modifies item.
 *
 */ function $ed8ac5f8b2ab9eb2$var$compactItem(compareWith /*: Layout*/ , l /*: LayoutItem*/ , compactType /*: CompactType*/ , cols /*: number*/ , fullLayout /*: Layout*/ , allowOverlap /*: ?boolean*/ ) /*: LayoutItem*/ {
    const compactV = compactType === "vertical";
    const compactH = compactType === "horizontal";
    if (compactV) {
        // Bottom 'y' possible is the bottom of the layout.
        // This allows you to do nice stuff like specify {y: Infinity}
        // This is here because the layout must be sorted in order to get the correct bottom `y`.
        l.y = Math.min($ed8ac5f8b2ab9eb2$var$bottom(compareWith), l.y);
        // Move the element up as far as it can go without colliding.
        while(l.y > 0 && !$ed8ac5f8b2ab9eb2$var$getFirstCollision(compareWith, l))l.y--;
    } else if (compactH) // Move the element left as far as it can go without colliding.
    while(l.x > 0 && !$ed8ac5f8b2ab9eb2$var$getFirstCollision(compareWith, l))l.x--;
    // Move it down, and keep moving it down if it's colliding.
    let collides;
    // Checking the compactType null value to avoid breaking the layout when overlapping is allowed.
    while((collides = $ed8ac5f8b2ab9eb2$var$getFirstCollision(compareWith, l)) && !(compactType === null && allowOverlap)){
        if (compactH) $ed8ac5f8b2ab9eb2$var$resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
        else $ed8ac5f8b2ab9eb2$var$resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
        // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
        if (compactH && l.x + l.w > cols) {
            l.x = cols - l.w;
            l.y++;
            // ALso move element as left as we can
            while(l.x > 0 && !$ed8ac5f8b2ab9eb2$var$getFirstCollision(compareWith, l))l.x--;
        }
    }
    // Ensure that there are no negative positions
    l.y = Math.max(l.y, 0);
    l.x = Math.max(l.x, 0);
    return l;
}
/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * Modifies layout items.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */ function $ed8ac5f8b2ab9eb2$var$correctBounds(layout /*: Layout*/ , bounds /*: { cols: number }*/ ) /*: Layout*/ {
    const collidesWith = $ed8ac5f8b2ab9eb2$var$getStatics(layout);
    for(let i = 0, len = layout.length; i < len; i++){
        const l = layout[i];
        // Overflows right
        if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
        // Overflows left
        if (l.x < 0) {
            l.x = 0;
            l.w = bounds.cols;
        }
        if (!l.static) collidesWith.push(l);
        else // If this is static and collides with other statics, we must move it down.
        // We have to do something nicer than just letting them overlap.
        while($ed8ac5f8b2ab9eb2$var$getFirstCollision(collidesWith, l))l.y++;
    }
    return layout;
}
/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */ function $ed8ac5f8b2ab9eb2$var$getLayoutItem(layout /*: Layout*/ , id /*: string*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if (layout[i].i === id) return layout[i];
    }
}
/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */ function $ed8ac5f8b2ab9eb2$var$getFirstCollision(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if ($ed8ac5f8b2ab9eb2$var$collides(layout[i], layoutItem)) return layout[i];
    }
}
function $ed8ac5f8b2ab9eb2$var$getAllCollisions(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>$ed8ac5f8b2ab9eb2$var$collides(l, layoutItem));
}
/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */ function $ed8ac5f8b2ab9eb2$var$getStatics(layout /*: Layout*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>l.static);
}
/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * Modifies layout items.
 *
 * @param  {Array}      layout            Full layout to modify.
 * @param  {LayoutItem} l                 element to move.
 * @param  {Number}     [x]               X position in grid units.
 * @param  {Number}     [y]               Y position in grid units.
 */ function $ed8ac5f8b2ab9eb2$var$moveElement(layout /*: Layout*/ , l /*: LayoutItem*/ , x /*: ?number*/ , y /*: ?number*/ , isUserAction /*: ?boolean*/ , preventCollision /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // If this is static and not explicitly enabled as draggable,
    // no move is possible, so we can short-circuit this immediately.
    if (l.static && l.isDraggable !== true) return layout;
    // Short-circuit if nothing to do.
    if (l.y === y && l.x === x) return layout;
    $ed8ac5f8b2ab9eb2$var$log(`Moving element ${l.i} to [${String(x)},${String(y)}] from [${l.x},${l.y}]`);
    const oldX = l.x;
    const oldY = l.y;
    // This is quite a bit faster than extending the object
    if (typeof x === "number") l.x = x;
    if (typeof y === "number") l.y = y;
    l.moved = true;
    // If this collides with anything, move it.
    // When doing this comparison, we have to sort the items we compare with
    // to ensure, in the case of multiple collisions, that we're getting the
    // nearest collision.
    let sorted = $ed8ac5f8b2ab9eb2$var$sortLayoutItems(layout, compactType);
    const movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false;
    // $FlowIgnore acceptable modification of read-only array as it was recently cloned
    if (movingUp) sorted = sorted.reverse();
    const collisions = $ed8ac5f8b2ab9eb2$var$getAllCollisions(sorted, l);
    const hasCollisions = collisions.length > 0;
    // We may have collisions. We can short-circuit if we've turned off collisions or
    // allowed overlap.
    if (hasCollisions && allowOverlap) // Easy, we don't need to resolve collisions. But we *did* change the layout,
    // so clone it on the way out.
    return $ed8ac5f8b2ab9eb2$var$cloneLayout(layout);
    else if (hasCollisions && preventCollision) {
        // If we are preventing collision but not allowing overlap, we need to
        // revert the position of this element so it goes to where it came from, rather
        // than the user's desired location.
        $ed8ac5f8b2ab9eb2$var$log(`Collision prevented on ${l.i}, reverting.`);
        l.x = oldX;
        l.y = oldY;
        l.moved = false;
        return layout; // did not change so don't clone
    }
    // Move each item that collides away from this element.
    for(let i = 0, len = collisions.length; i < len; i++){
        const collision = collisions[i];
        $ed8ac5f8b2ab9eb2$var$log(`Resolving collision between ${l.i} at [${l.x},${l.y}] and ${collision.i} at [${collision.x},${collision.y}]`);
        // Short circuit so we can't infinite loop
        if (collision.moved) continue;
        // Don't move static items - we have to move *this* element away
        if (collision.static) layout = $ed8ac5f8b2ab9eb2$var$moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
        else layout = $ed8ac5f8b2ab9eb2$var$moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
    }
    return layout;
}
/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 */ function $ed8ac5f8b2ab9eb2$var$moveElementAwayFromCollision(layout /*: Layout*/ , collidesWith /*: LayoutItem*/ , itemToMove /*: LayoutItem*/ , isUserAction /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ ) /*: Layout*/ {
    const compactH = compactType === "horizontal";
    // Compact vertically if not set to horizontal
    const compactV = compactType === "vertical";
    const preventCollision = collidesWith.static; // we're already colliding (not for static items)
    // If there is enough space above the collision to put this element, move it there.
    // We only do this on the main collision as this can get funky in cascades and cause
    // unwanted swapping behavior.
    if (isUserAction) {
        // Reset isUserAction flag because we're not in the main collision anymore.
        isUserAction = false;
        // Make a mock item so we don't modify the item here, only modify in moveElement.
        const fakeItem /*: LayoutItem*/  = {
            x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
            y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
            w: itemToMove.w,
            h: itemToMove.h,
            i: "-1"
        };
        const firstCollision = $ed8ac5f8b2ab9eb2$var$getFirstCollision(layout, fakeItem);
        const collisionNorth = firstCollision && firstCollision.y + firstCollision.h > collidesWith.y;
        const collisionWest = firstCollision && collidesWith.x + collidesWith.w > firstCollision.x;
        // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
        if (!firstCollision) {
            $ed8ac5f8b2ab9eb2$var$log(`Doing reverse collision on ${itemToMove.i} up to [${fakeItem.x},${fakeItem.y}].`);
            return $ed8ac5f8b2ab9eb2$var$moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
        } else if (collisionNorth && compactV) return $ed8ac5f8b2ab9eb2$var$moveElement(layout, itemToMove, undefined, collidesWith.y + 1, isUserAction, preventCollision, compactType, cols);
        else if (collisionNorth && compactType == null) {
            collidesWith.y = itemToMove.y;
            itemToMove.y = itemToMove.y + itemToMove.h;
            return layout;
        } else if (collisionWest && compactH) return $ed8ac5f8b2ab9eb2$var$moveElement(layout, collidesWith, itemToMove.x, undefined, isUserAction, preventCollision, compactType, cols);
    }
    const newX = compactH ? itemToMove.x + 1 : undefined;
    const newY = compactV ? itemToMove.y + 1 : undefined;
    if (newX == null && newY == null) return layout;
    return $ed8ac5f8b2ab9eb2$var$moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
}
/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */ function $ed8ac5f8b2ab9eb2$var$perc(num /*: number*/ ) /*: string*/ {
    return num * 100 + "%";
}
/**
 * Helper functions to constrain dimensions of a GridItem
 */ const $ed8ac5f8b2ab9eb2$var$constrainWidth = (left /*: number*/ , currentWidth /*: number*/ , newWidth /*: number*/ , containerWidth /*: number*/ )=>{
    return left + newWidth > containerWidth ? currentWidth : newWidth;
};
const $ed8ac5f8b2ab9eb2$var$constrainHeight = (top /*: number*/ , currentHeight /*: number*/ , newHeight /*: number*/ )=>{
    return top < 0 ? currentHeight : newHeight;
};
const $ed8ac5f8b2ab9eb2$var$constrainLeft = (left /*: number*/ )=>Math.max(0, left);
const $ed8ac5f8b2ab9eb2$var$constrainTop = (top /*: number*/ )=>Math.max(0, top);
const $ed8ac5f8b2ab9eb2$var$resizeNorth = (currentSize, _ref, _containerWidth)=>{
    let { left: left, height: height, width: width } = _ref;
    const top = currentSize.top - (height - currentSize.height);
    return {
        left: left,
        width: width,
        height: $ed8ac5f8b2ab9eb2$var$constrainHeight(top, currentSize.height, height),
        top: $ed8ac5f8b2ab9eb2$var$constrainTop(top)
    };
};
const $ed8ac5f8b2ab9eb2$var$resizeEast = (currentSize, _ref2, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref2;
    return {
        top: top,
        height: height,
        width: $ed8ac5f8b2ab9eb2$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        left: $ed8ac5f8b2ab9eb2$var$constrainLeft(left)
    };
};
const $ed8ac5f8b2ab9eb2$var$resizeWest = (currentSize, _ref3, containerWidth)=>{
    let { top: top, height: height, width: width } = _ref3;
    const left = currentSize.left - (width - currentSize.width);
    return {
        height: height,
        width: left < 0 ? currentSize.width : $ed8ac5f8b2ab9eb2$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        top: $ed8ac5f8b2ab9eb2$var$constrainTop(top),
        left: $ed8ac5f8b2ab9eb2$var$constrainLeft(left)
    };
};
const $ed8ac5f8b2ab9eb2$var$resizeSouth = (currentSize, _ref4, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref4;
    return {
        width: width,
        left: left,
        height: $ed8ac5f8b2ab9eb2$var$constrainHeight(top, currentSize.height, height),
        top: $ed8ac5f8b2ab9eb2$var$constrainTop(top)
    };
};
const $ed8ac5f8b2ab9eb2$var$resizeNorthEast = function() {
    return $ed8ac5f8b2ab9eb2$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $ed8ac5f8b2ab9eb2$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $ed8ac5f8b2ab9eb2$var$resizeNorthWest = function() {
    return $ed8ac5f8b2ab9eb2$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $ed8ac5f8b2ab9eb2$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $ed8ac5f8b2ab9eb2$var$resizeSouthEast = function() {
    return $ed8ac5f8b2ab9eb2$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $ed8ac5f8b2ab9eb2$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $ed8ac5f8b2ab9eb2$var$resizeSouthWest = function() {
    return $ed8ac5f8b2ab9eb2$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $ed8ac5f8b2ab9eb2$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $ed8ac5f8b2ab9eb2$var$ordinalResizeHandlerMap = {
    n: $ed8ac5f8b2ab9eb2$var$resizeNorth,
    ne: $ed8ac5f8b2ab9eb2$var$resizeNorthEast,
    e: $ed8ac5f8b2ab9eb2$var$resizeEast,
    se: $ed8ac5f8b2ab9eb2$var$resizeSouthEast,
    s: $ed8ac5f8b2ab9eb2$var$resizeSouth,
    sw: $ed8ac5f8b2ab9eb2$var$resizeSouthWest,
    w: $ed8ac5f8b2ab9eb2$var$resizeWest,
    nw: $ed8ac5f8b2ab9eb2$var$resizeNorthWest
};
/**
 * Helper for clamping width and position when resizing an item.
 */ function $ed8ac5f8b2ab9eb2$var$resizeItemInDirection(direction /*: ResizeHandleAxis*/ , currentSize /*: Position*/ , newSize /*: Position*/ , containerWidth /*: number*/ ) /*: Position*/ {
    const ordinalHandler = $ed8ac5f8b2ab9eb2$var$ordinalResizeHandlerMap[direction];
    // Shouldn't be possible given types; that said, don't fail hard
    if (!ordinalHandler) return newSize;
    return ordinalHandler(currentSize, {
        ...currentSize,
        ...newSize
    }, containerWidth);
}
function $ed8ac5f8b2ab9eb2$var$setTransform(_ref5 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref5 /*: Position*/ ;
    // Replace unitless items with px
    const translate = `translate(${left}px,${top}px)`;
    return {
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
function $ed8ac5f8b2ab9eb2$var$setTopLeft(_ref6 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref6 /*: Position*/ ;
    return {
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */ function $ed8ac5f8b2ab9eb2$var$sortLayoutItems(layout /*: Layout*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    if (compactType === "horizontal") return $ed8ac5f8b2ab9eb2$var$sortLayoutItemsByColRow(layout);
    if (compactType === "vertical") return $ed8ac5f8b2ab9eb2$var$sortLayoutItemsByRowCol(layout);
    else return layout;
}
/**
 * Sort layout items by row ascending and column ascending.
 *
 * Does not modify Layout.
 */ function $ed8ac5f8b2ab9eb2$var$sortLayoutItemsByRowCol(layout /*: Layout*/ ) /*: Layout*/ {
    // Slice to clone array as sort modifies
    return layout.slice(0).sort(function(a, b) {
        if (a.y > b.y || a.y === b.y && a.x > b.x) return 1;
        else if (a.y === b.y && a.x === b.x) // Without this, we can get different sort results in IE vs. Chrome/FF
        return 0;
        return -1;
    });
}
/**
 * Sort layout items by column ascending then row ascending.
 *
 * Does not modify Layout.
 */ function $ed8ac5f8b2ab9eb2$var$sortLayoutItemsByColRow(layout /*: Layout*/ ) /*: Layout*/ {
    return layout.slice(0).sort(function(a, b) {
        if (a.x > b.x || a.x === b.x && a.y > b.y) return 1;
        return -1;
    });
}
/**
 * Generate a layout using the initialLayout and children as a template.
 * Missing entries will be added, extraneous ones will be truncated.
 *
 * Does not modify initialLayout.
 *
 * @param  {Array}  initialLayout Layout passed in through props.
 * @param  {String} breakpoint    Current responsive breakpoint.
 * @param  {?String} compact      Compaction option.
 * @return {Array}                Working layout.
 */ function $ed8ac5f8b2ab9eb2$var$synchronizeLayoutWithChildren(initialLayout /*: Layout*/ , children /*: ReactChildren*/ , cols /*: number*/ , compactType /*: CompactType*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    initialLayout = initialLayout || [];
    // Generate one layout item per child.
    const layout /*: LayoutItem[]*/  = [];
    $ed8ac5f8b2ab9eb2$var$_react.default.Children.forEach(children, (child /*: ReactElement<any>*/ )=>{
        // Child may not exist
        if (child?.key == null) return;
        const exists = $ed8ac5f8b2ab9eb2$var$getLayoutItem(initialLayout, String(child.key));
        const g = child.props["data-grid"];
        // Don't overwrite the layout item if it's already in the initial layout.
        // If it has a `data-grid` property, prefer that over what's in the layout.
        if (exists && g == null) layout.push($ed8ac5f8b2ab9eb2$var$cloneLayoutItem(exists));
        else // Hey, this item has a data-grid property, use it.
        if (g) {
            if (!$ed8ac5f8b2ab9eb2$var$isProduction) $ed8ac5f8b2ab9eb2$var$validateLayout([
                g
            ], "ReactGridLayout.children");
            // FIXME clone not really necessary here
            layout.push($ed8ac5f8b2ab9eb2$var$cloneLayoutItem({
                ...g,
                i: child.key
            }));
        } else // Nothing provided: ensure this is added to the bottom
        // FIXME clone not really necessary here
        layout.push($ed8ac5f8b2ab9eb2$var$cloneLayoutItem({
            w: 1,
            h: 1,
            x: 0,
            y: $ed8ac5f8b2ab9eb2$var$bottom(layout),
            i: String(child.key)
        }));
    });
    // Correct the layout.
    const correctedLayout = $ed8ac5f8b2ab9eb2$var$correctBounds(layout, {
        cols: cols
    });
    return allowOverlap ? correctedLayout : $ed8ac5f8b2ab9eb2$var$compact(correctedLayout, compactType, cols);
}
/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */ function $ed8ac5f8b2ab9eb2$var$validateLayout(layout /*: Layout*/ ) /*: void*/ {
    let contextName /*: string*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
    const subProps = [
        "x",
        "y",
        "w",
        "h"
    ];
    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
    for(let i = 0, len = layout.length; i < len; i++){
        const item = layout[i];
        for(let j = 0; j < subProps.length; j++){
            const key = subProps[j];
            const value = item[key];
            if (typeof value !== "number" || Number.isNaN(value)) throw new Error(`ReactGridLayout: ${contextName}[${i}].${key} must be a number! Received: ${value} (${typeof value})`);
        }
        if (typeof item.i !== "undefined" && typeof item.i !== "string") throw new Error(`ReactGridLayout: ${contextName}[${i}].i must be a string! Received: ${item.i} (${typeof item.i})`);
    }
}
// Legacy support for verticalCompact: false
function $ed8ac5f8b2ab9eb2$var$compactType(props /*: ?{ verticalCompact: boolean, compactType: CompactType }*/ ) /*: CompactType*/ {
    const { verticalCompact: verticalCompact, compactType: compactType } = props || {};
    return verticalCompact === false ? null : compactType;
}
function $ed8ac5f8b2ab9eb2$var$log() {
    if (!$ed8ac5f8b2ab9eb2$var$DEBUG) return;
    // eslint-disable-next-line no-console
    console.log(...arguments);
}
const $ed8ac5f8b2ab9eb2$var$noop = ()=>{};
module.exports.noop = $ed8ac5f8b2ab9eb2$var$noop;

});
parcelRegister("hm2hA", function(module, exports) {
// this file was prevaled
module.exports = function fastRGLPropsEqual(a, b, isEqualImpl) {
    if (a === b) return true;
    return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};

});


parcelRegister("01ySn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcGridColWidth = $004b25c52f6c55d9$var$calcGridColWidth;
module.exports.calcGridItemPosition = $004b25c52f6c55d9$var$calcGridItemPosition;
module.exports.calcGridItemWHPx = $004b25c52f6c55d9$var$calcGridItemWHPx;
module.exports.calcWH = $004b25c52f6c55d9$var$calcWH;
module.exports.calcXY = $004b25c52f6c55d9$var$calcXY;
module.exports.clamp = $004b25c52f6c55d9$var$clamp;
/*:: import type { Position } from "./utils";*/ /*:: export type PositionParams = {
  margin: [number, number],
  containerPadding: [number, number],
  containerWidth: number,
  cols: number,
  rowHeight: number,
  maxRows: number
};*/ // Helper for generating column width
function $004b25c52f6c55d9$var$calcGridColWidth(positionParams /*: PositionParams*/ ) /*: number*/ {
    const { margin: margin, containerPadding: containerPadding, containerWidth: containerWidth, cols: cols } = positionParams;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
// This can either be called:
// calcGridItemWHPx(w, colWidth, margin[0])
// or
// calcGridItemWHPx(h, rowHeight, margin[1])
function $004b25c52f6c55d9$var$calcGridItemWHPx(gridUnits /*: number*/ , colOrRowSize /*: number*/ , marginPx /*: number*/ ) /*: number*/ {
    // 0 * Infinity === NaN, which causes problems with resize contraints
    if (!Number.isFinite(gridUnits)) return gridUnits;
    return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
/**
 * Return position on the page given an x, y, w, h.
 * left, top, width, height are all in pixels.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number}  x                      X coordinate in grid units.
 * @param  {Number}  y                      Y coordinate in grid units.
 * @param  {Number}  w                      W coordinate in grid units.
 * @param  {Number}  h                      H coordinate in grid units.
 * @return {Position}                       Object containing coords.
 */ function $004b25c52f6c55d9$var$calcGridItemPosition(positionParams /*: PositionParams*/ , x /*: number*/ , y /*: number*/ , w /*: number*/ , h /*: number*/ , state /*: ?Object*/ ) /*: Position*/ {
    const { margin: margin, containerPadding: containerPadding, rowHeight: rowHeight } = positionParams;
    const colWidth = $004b25c52f6c55d9$var$calcGridColWidth(positionParams);
    const out = {};
    // If resizing, use the exact width and height as returned from resizing callbacks.
    if (state && state.resizing) {
        out.width = Math.round(state.resizing.width);
        out.height = Math.round(state.resizing.height);
    } else {
        out.width = $004b25c52f6c55d9$var$calcGridItemWHPx(w, colWidth, margin[0]);
        out.height = $004b25c52f6c55d9$var$calcGridItemWHPx(h, rowHeight, margin[1]);
    }
    // If dragging, use the exact width and height as returned from dragging callbacks.
    if (state && state.dragging) {
        out.top = Math.round(state.dragging.top);
        out.left = Math.round(state.dragging.left);
    } else if (state && state.resizing && typeof state.resizing.top === "number" && typeof state.resizing.left === "number") {
        out.top = Math.round(state.resizing.top);
        out.left = Math.round(state.resizing.left);
    } else {
        out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
        out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
    }
    return out;
}
/**
 * Translate x and y coordinates from pixels to grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number} top                     Top position (relative to parent) in pixels.
 * @param  {Number} left                    Left position (relative to parent) in pixels.
 * @param  {Number} w                       W coordinate in grid units.
 * @param  {Number} h                       H coordinate in grid units.
 * @return {Object}                         x and y in grid units.
 */ function $004b25c52f6c55d9$var$calcXY(positionParams /*: PositionParams*/ , top /*: number*/ , left /*: number*/ , w /*: number*/ , h /*: number*/ ) /*: { x: number, y: number }*/ {
    const { margin: margin, containerPadding: containerPadding, cols: cols, rowHeight: rowHeight, maxRows: maxRows } = positionParams;
    const colWidth = $004b25c52f6c55d9$var$calcGridColWidth(positionParams);
    // left = containerPaddingX + x * (colWidth + marginX)
    // x * (colWidth + marginX) = left - containerPaddingX
    // x = (left - containerPaddingX) / (colWidth + marginX)
    let x = Math.round((left - containerPadding[0]) / (colWidth + margin[0]));
    let y = Math.round((top - containerPadding[1]) / (rowHeight + margin[1]));
    // Capping
    x = $004b25c52f6c55d9$var$clamp(x, 0, cols - w);
    y = $004b25c52f6c55d9$var$clamp(y, 0, maxRows - h);
    return {
        x: x,
        y: y
    };
}
/**
 * Given a height and width in pixel values, calculate grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calcluations.
 * @param  {Number} height                  Height in pixels.
 * @param  {Number} width                   Width in pixels.
 * @param  {Number} x                       X coordinate in grid units.
 * @param  {Number} y                       Y coordinate in grid units.
 * @param {String} handle Resize Handle.
 * @return {Object}                         w, h as grid units.
 */ function $004b25c52f6c55d9$var$calcWH(positionParams /*: PositionParams*/ , width /*: number*/ , height /*: number*/ , x /*: number*/ , y /*: number*/ , handle /*: string*/ ) /*: { w: number, h: number }*/ {
    const { margin: margin, maxRows: maxRows, cols: cols, rowHeight: rowHeight } = positionParams;
    const colWidth = $004b25c52f6c55d9$var$calcGridColWidth(positionParams);
    // width = colWidth * w - (margin * (w - 1))
    // ...
    // w = (width + margin) / (colWidth + margin)
    let w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    let h = Math.round((height + margin[1]) / (rowHeight + margin[1]));
    // Capping
    let _w = $004b25c52f6c55d9$var$clamp(w, 0, cols - x);
    let _h = $004b25c52f6c55d9$var$clamp(h, 0, maxRows - y);
    if ([
        "sw",
        "w",
        "nw"
    ].indexOf(handle) !== -1) _w = $004b25c52f6c55d9$var$clamp(w, 0, cols);
    if ([
        "nw",
        "n",
        "ne"
    ].indexOf(handle) !== -1) _h = $004b25c52f6c55d9$var$clamp(h, 0, maxRows);
    return {
        w: _w,
        h: _h
    };
}
// Similar to _.clamp
function $004b25c52f6c55d9$var$clamp(num /*: number*/ , lowerBound /*: number*/ , upperBound /*: number*/ ) /*: number*/ {
    return Math.max(Math.min(num, upperBound), lowerBound);
}

});

parcelRegister("4QVpD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38888dae3223d5b1$var$_react = $38888dae3223d5b1$var$_interopRequireDefault((parcelRequire("exYeM")));

var $38888dae3223d5b1$var$_propTypes = $38888dae3223d5b1$var$_interopRequireDefault((parcelRequire("bisEj")));

var $fquW1 = parcelRequire("fquW1");

var $d9APM = parcelRequire("d9APM");

var $koqIv = parcelRequire("koqIv");

var $01ySn = parcelRequire("01ySn");

var $cbjrM = parcelRequire("cbjrM");

var $38888dae3223d5b1$var$_clsx = $38888dae3223d5b1$var$_interopRequireDefault((parcelRequire("4qr5a")));
function $38888dae3223d5b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $38888dae3223d5b1$var$_defineProperty(obj, key, value) {
    key = $38888dae3223d5b1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $38888dae3223d5b1$var$_toPropertyKey(arg) {
    var key = $38888dae3223d5b1$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $38888dae3223d5b1$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type { Element as ReactElement, Node as ReactNode } from "react";*/ /*:: import type {
  ReactDraggableCallbackData,
  GridDragEvent,
  GridResizeEvent,
  DroppingPosition,
  Position,
  ResizeHandleAxis
} from "./utils";*/ /*:: import type { PositionParams } from "./calculateUtils";*/ /*:: import type { ResizeHandle, ReactRef } from "./ReactGridLayoutPropTypes";*/ /*:: type PartialPosition = { top: number, left: number };*/ /*:: type GridItemCallback<Data: GridDragEvent | GridResizeEvent> = (
  i: string,
  w: number,
  h: number,
  Data
) => void;*/ /*:: type ResizeCallbackData = {
  node: HTMLElement,
  size: Position,
  handle: ResizeHandleAxis
};*/ /*:: type GridItemResizeCallback = (
  e: Event,
  data: ResizeCallbackData,
  position: Position
) => void;*/ /*:: type State = {
  resizing: ?{ top: number, left: number, width: number, height: number },
  dragging: ?{ top: number, left: number },
  className: string
};*/ /*:: type Props = {
  children: ReactElement<any>,
  cols: number,
  containerWidth: number,
  margin: [number, number],
  containerPadding: [number, number],
  rowHeight: number,
  maxRows: number,
  isDraggable: boolean,
  isResizable: boolean,
  isBounded: boolean,
  static?: boolean,
  useCSSTransforms?: boolean,
  usePercentages?: boolean,
  transformScale: number,
  droppingPosition?: DroppingPosition,

  className: string,
  style?: Object,
  // Draggability
  cancel: string,
  handle: string,

  x: number,
  y: number,
  w: number,
  h: number,

  minW: number,
  maxW: number,
  minH: number,
  maxH: number,
  i: string,

  resizeHandles?: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,

  onDrag?: GridItemCallback<GridDragEvent>,
  onDragStart?: GridItemCallback<GridDragEvent>,
  onDragStop?: GridItemCallback<GridDragEvent>,
  onResize?: GridItemCallback<GridResizeEvent>,
  onResizeStart?: GridItemCallback<GridResizeEvent>,
  onResizeStop?: GridItemCallback<GridResizeEvent>
};*/ /*:: type DefaultProps = {
  className: string,
  cancel: string,
  handle: string,
  minH: number,
  minW: number,
  maxH: number,
  maxW: number,
  transformScale: number
};*/ /**
 * An individual item within a ReactGridLayout.
 */ class $38888dae3223d5b1$var$GridItem extends $38888dae3223d5b1$var$_react.default.Component /*:: <Props, State>*/  {
    constructor(){
        super(...arguments);
        $38888dae3223d5b1$var$_defineProperty(this, "state", {
            resizing: null,
            dragging: null,
            className: ""
        });
        $38888dae3223d5b1$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $38888dae3223d5b1$var$_react.default.createRef());
        /**
     * onDragStart event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $38888dae3223d5b1$var$_defineProperty(this, "onDragStart", (e, _ref)=>{
            let { node: node } = _ref;
            const { onDragStart: onDragStart, transformScale: transformScale } = this.props;
            if (!onDragStart) return;
            const newPosition /*: PartialPosition*/  = {
                top: 0,
                left: 0
            };
            // TODO: this wont work on nested parents
            const { offsetParent: offsetParent } = node;
            if (!offsetParent) return;
            const parentRect = offsetParent.getBoundingClientRect();
            const clientRect = node.getBoundingClientRect();
            const cLeft = clientRect.left / transformScale;
            const pLeft = parentRect.left / transformScale;
            const cTop = clientRect.top / transformScale;
            const pTop = parentRect.top / transformScale;
            newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
            newPosition.top = cTop - pTop + offsetParent.scrollTop;
            this.setState({
                dragging: newPosition
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $01ySn.calcXY)(this.getPositionParams(), newPosition.top, newPosition.left, this.props.w, this.props.h);
            return onDragStart.call(this, this.props.i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDrag event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $38888dae3223d5b1$var$_defineProperty(this, "onDrag", (e, _ref2)=>{
            let { node: node, deltaX: deltaX, deltaY: deltaY } = _ref2;
            const { onDrag: onDrag } = this.props;
            if (!onDrag) return;
            if (!this.state.dragging) throw new Error("onDrag called before onDragStart.");
            let top = this.state.dragging.top + deltaY;
            let left = this.state.dragging.left + deltaX;
            const { isBounded: isBounded, i: i, w: w, h: h, containerWidth: containerWidth } = this.props;
            const positionParams = this.getPositionParams();
            // Boundary calculations; keeps items within the grid
            if (isBounded) {
                const { offsetParent: offsetParent } = node;
                if (offsetParent) {
                    const { margin: margin, rowHeight: rowHeight, containerPadding: containerPadding } = this.props;
                    const bottomBoundary = offsetParent.clientHeight - (0, $01ySn.calcGridItemWHPx)(h, rowHeight, margin[1]);
                    top = (0, $01ySn.clamp)(top - containerPadding[1], 0, bottomBoundary);
                    const colWidth = (0, $01ySn.calcGridColWidth)(positionParams);
                    const rightBoundary = containerWidth - (0, $01ySn.calcGridItemWHPx)(w, colWidth, margin[0]);
                    left = (0, $01ySn.clamp)(left - containerPadding[0], 0, rightBoundary);
                }
            }
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            this.setState({
                dragging: newPosition
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $01ySn.calcXY)(positionParams, top, left, w, h);
            return onDrag.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDragStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $38888dae3223d5b1$var$_defineProperty(this, "onDragStop", (e, _ref3)=>{
            let { node: node } = _ref3;
            const { onDragStop: onDragStop } = this.props;
            if (!onDragStop) return;
            if (!this.state.dragging) throw new Error("onDragEnd called before onDragStart.");
            const { w: w, h: h, i: i } = this.props;
            const { left: left, top: top } = this.state.dragging;
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            this.setState({
                dragging: null
            });
            const { x: x, y: y } = (0, $01ySn.calcXY)(this.getPositionParams(), top, left, w, h);
            return onDragStop.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onResizeStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node and size information
     */ $38888dae3223d5b1$var$_defineProperty(this, "onResizeStop", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStop"));
        // onResizeStart event handler
        $38888dae3223d5b1$var$_defineProperty(this, "onResizeStart", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStart"));
        // onResize event handler
        $38888dae3223d5b1$var$_defineProperty(this, "onResize", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResize"));
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        // We can't deeply compare children. If the developer memoizes them, we can
        // use this optimization.
        if (this.props.children !== nextProps.children) return true;
        if (this.props.droppingPosition !== nextProps.droppingPosition) return true;
        // TODO memoize these calculations so they don't take so long?
        const oldPosition = (0, $01ySn.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
        const newPosition = (0, $01ySn.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
        return !(0, $koqIv.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
    }
    componentDidMount() {
        this.moveDroppingItem({});
    }
    componentDidUpdate(prevProps /*: Props*/ ) {
        this.moveDroppingItem(prevProps);
    }
    // When a droppingPosition is present, this means we should fire a move event, as if we had moved
    // this element by `x, y` pixels.
    moveDroppingItem(prevProps /*: Props*/ ) {
        const { droppingPosition: droppingPosition } = this.props;
        if (!droppingPosition) return;
        const node = this.elementRef.current;
        // Can't find DOM node (are we unmounted?)
        if (!node) return;
        const prevDroppingPosition = prevProps.droppingPosition || {
            left: 0,
            top: 0
        };
        const { dragging: dragging } = this.state;
        const shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
        if (!dragging) this.onDragStart(droppingPosition.e, {
            node: node,
            deltaX: droppingPosition.left,
            deltaY: droppingPosition.top
        });
        else if (shouldDrag) {
            const deltaX = droppingPosition.left - dragging.left;
            const deltaY = droppingPosition.top - dragging.top;
            this.onDrag(droppingPosition.e, {
                node: node,
                deltaX: deltaX,
                deltaY: deltaY
            });
        }
    }
    getPositionParams() /*: PositionParams*/ {
        let props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        return {
            cols: props.cols,
            containerPadding: props.containerPadding,
            containerWidth: props.containerWidth,
            margin: props.margin,
            maxRows: props.maxRows,
            rowHeight: props.rowHeight
        };
    }
    /**
   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
   * well when server rendering, and the only way to do that properly is to use percentage width/left because
   * we don't know exactly what the browser viewport is.
   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
   *
   * @param  {Object} pos Position object with width, height, left, top.
   * @return {Object}     Style object.
   */ createStyle(pos /*: Position*/ ) /*: { [key: string]: ?string }*/ {
        const { usePercentages: usePercentages, containerWidth: containerWidth, useCSSTransforms: useCSSTransforms } = this.props;
        let style;
        // CSS Transforms support (default)
        if (useCSSTransforms) style = (0, $koqIv.setTransform)(pos);
        else {
            // top,left (slow)
            style = (0, $koqIv.setTopLeft)(pos);
            // This is used for server rendering.
            if (usePercentages) {
                style.left = (0, $koqIv.perc)(pos.left / containerWidth);
                style.width = (0, $koqIv.perc)(pos.width / containerWidth);
            }
        }
        return style;
    }
    /**
   * Mix a Draggable instance into a child.
   * @param  {Element} child    Child element.
   * @return {Element}          Child wrapped in Draggable.
   */ mixinDraggable(child /*: ReactElement<any>*/ , isDraggable /*: boolean*/ ) /*: ReactElement<any>*/ {
        return /*#__PURE__*/ $38888dae3223d5b1$var$_react.default.createElement($fquW1.DraggableCore, {
            disabled: !isDraggable,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop,
            handle: this.props.handle,
            cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
            scale: this.props.transformScale,
            nodeRef: this.elementRef
        }, child);
    }
    /**
   * Utility function to setup callback handler definitions for
   * similarily structured resize events.
   */ curryResizeHandler(position /*: Position*/ , handler /*: Function*/ ) /*: Function*/ {
        return (e /*: Event*/ , data /*: ResizeCallbackData*/ )=>/*: Function*/ handler(e, data, position);
    }
    /**
   * Mix a Resizable instance into a child.
   * @param  {Element} child    Child element.
   * @param  {Object} position  Position object (pixel values)
   * @return {Element}          Child wrapped in Resizable.
   */ mixinResizable(child /*: ReactElement<any>*/ , position /*: Position*/ , isResizable /*: boolean*/ ) /*: ReactElement<any>*/ {
        const { cols: cols, minW: minW, minH: minH, maxW: maxW, maxH: maxH, transformScale: transformScale, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const positionParams = this.getPositionParams();
        // This is the max possible width - doesn't go to infinity because of the width of the window
        const maxWidth = (0, $01ySn.calcGridItemPosition)(positionParams, 0, 0, cols, 0).width;
        // Calculate min/max constraints using our min & maxes
        const mins = (0, $01ySn.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
        const maxes = (0, $01ySn.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
        const minConstraints = [
            mins.width,
            mins.height
        ];
        const maxConstraints = [
            Math.min(maxes.width, maxWidth),
            Math.min(maxes.height, Infinity)
        ];
        return /*#__PURE__*/ $38888dae3223d5b1$var$_react.default.createElement($d9APM.Resizable, {
            draggableOpts: {
                disabled: !isResizable
            },
            className: isResizable ? undefined : "react-resizable-hide",
            width: position.width,
            height: position.height,
            minConstraints: minConstraints,
            maxConstraints: maxConstraints,
            onResizeStop: this.curryResizeHandler(position, this.onResizeStop),
            onResizeStart: this.curryResizeHandler(position, this.onResizeStart),
            onResize: this.curryResizeHandler(position, this.onResize),
            transformScale: transformScale,
            resizeHandles: resizeHandles,
            handle: resizeHandle
        }, child);
    }
    /**
   * Wrapper around resize events to provide more useful data.
   */ onResizeHandler(e /*: Event*/ , _ref4 /*:: */ , // 'size' is updated position
    position /*: Position*/ , // existing position
    handlerName /*: string*/ ) /*: void*/ {
        let { node: node, size: size, handle: handle } /*: ResizeCallbackData*/  = _ref4 /*: ResizeCallbackData*/ ;
        const handler = this.props[handlerName];
        if (!handler) return;
        const { x: x, y: y, i: i, maxH: maxH, minH: minH, containerWidth: containerWidth } = this.props;
        const { minW: minW, maxW: maxW } = this.props;
        // Clamping of dimensions based on resize direction
        let updatedSize = size;
        if (node) {
            updatedSize = (0, $koqIv.resizeItemInDirection)(handle, position, size, containerWidth);
            this.setState({
                resizing: handlerName === "onResizeStop" ? null : updatedSize
            });
        }
        // Get new XY based on pixel size
        let { w: w, h: h } = (0, $01ySn.calcWH)(this.getPositionParams(), updatedSize.width, updatedSize.height, x, y, handle);
        // Min/max capping.
        // minW should be at least 1 (TODO propTypes validation?)
        w = (0, $01ySn.clamp)(w, Math.max(minW, 1), maxW);
        h = (0, $01ySn.clamp)(h, minH, maxH);
        handler.call(this, i, w, h, {
            e: e,
            node: node,
            size: updatedSize,
            handle: handle
        });
    }
    render() /*: ReactNode*/ {
        const { x: x, y: y, w: w, h: h, isDraggable: isDraggable, isResizable: isResizable, droppingPosition: droppingPosition, useCSSTransforms: useCSSTransforms } = this.props;
        const pos = (0, $01ySn.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
        const child = $38888dae3223d5b1$var$_react.default.Children.only(this.props.children);
        // Create the child element. We clone the existing element but modify its className and style.
        let newChild = /*#__PURE__*/ $38888dae3223d5b1$var$_react.default.cloneElement(child, {
            ref: this.elementRef,
            className: (0, $38888dae3223d5b1$var$_clsx.default)("react-grid-item", child.props.className, this.props.className, {
                static: this.props.static,
                resizing: Boolean(this.state.resizing),
                "react-draggable": isDraggable,
                "react-draggable-dragging": Boolean(this.state.dragging),
                dropping: Boolean(droppingPosition),
                cssTransforms: useCSSTransforms
            }),
            // We can set the width and height on the child, but unfortunately we can't set the position.
            style: {
                ...this.props.style,
                ...child.props.style,
                ...this.createStyle(pos)
            }
        });
        // Resizable support. This is usually on but the user can toggle it off.
        newChild = this.mixinResizable(newChild, pos, isResizable);
        // Draggable support. This is always on, except for with placeholders.
        newChild = this.mixinDraggable(newChild, isDraggable);
        return newChild;
    }
}
module.exports.default = $38888dae3223d5b1$var$GridItem;
$38888dae3223d5b1$var$_defineProperty($38888dae3223d5b1$var$GridItem, "propTypes", {
    // Children must be only a single element
    children: $38888dae3223d5b1$var$_propTypes.default.element,
    // General grid attributes
    cols: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
    containerWidth: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
    rowHeight: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
    margin: $38888dae3223d5b1$var$_propTypes.default.array.isRequired,
    maxRows: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
    containerPadding: $38888dae3223d5b1$var$_propTypes.default.array.isRequired,
    // These are all in grid units
    x: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
    y: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
    w: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
    h: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
    // All optional
    minW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minWidth not Number");
        if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxWidth not Number");
        if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minHeight not Number");
        if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxHeight not Number");
        if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: $38888dae3223d5b1$var$_propTypes.default.string.isRequired,
    // Resize handle options
    resizeHandles: $cbjrM.resizeHandleAxesType,
    resizeHandle: $cbjrM.resizeHandleType,
    // Functions
    onDragStop: $38888dae3223d5b1$var$_propTypes.default.func,
    onDragStart: $38888dae3223d5b1$var$_propTypes.default.func,
    onDrag: $38888dae3223d5b1$var$_propTypes.default.func,
    onResizeStop: $38888dae3223d5b1$var$_propTypes.default.func,
    onResizeStart: $38888dae3223d5b1$var$_propTypes.default.func,
    onResize: $38888dae3223d5b1$var$_propTypes.default.func,
    // Flags
    isDraggable: $38888dae3223d5b1$var$_propTypes.default.bool.isRequired,
    isResizable: $38888dae3223d5b1$var$_propTypes.default.bool.isRequired,
    isBounded: $38888dae3223d5b1$var$_propTypes.default.bool.isRequired,
    static: $38888dae3223d5b1$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $38888dae3223d5b1$var$_propTypes.default.bool.isRequired,
    transformScale: $38888dae3223d5b1$var$_propTypes.default.number,
    // Others
    className: $38888dae3223d5b1$var$_propTypes.default.string,
    // Selector for draggable handle
    handle: $38888dae3223d5b1$var$_propTypes.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: $38888dae3223d5b1$var$_propTypes.default.string,
    // Current position of a dropping element
    droppingPosition: $38888dae3223d5b1$var$_propTypes.default.shape({
        e: $38888dae3223d5b1$var$_propTypes.default.object.isRequired,
        left: $38888dae3223d5b1$var$_propTypes.default.number.isRequired,
        top: $38888dae3223d5b1$var$_propTypes.default.number.isRequired
    })
});
$38888dae3223d5b1$var$_defineProperty($38888dae3223d5b1$var$GridItem, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: Infinity,
    maxW: Infinity,
    transformScale: 1
});

});
parcelRegister("fquW1", function(module, exports) {
"use strict";

var $3Au3K = parcelRequire("3Au3K");
var $b3b147c2121f0b43$require$Draggable = $3Au3K.default;
var $b3b147c2121f0b43$require$DraggableCore = $3Au3K.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $b3b147c2121f0b43$require$Draggable;
module.exports.default = $b3b147c2121f0b43$require$Draggable;
module.exports.DraggableCore = $b3b147c2121f0b43$require$DraggableCore;

});
parcelRegister("3Au3K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $29cc0d123db42035$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $29cc0d123db42035$var$React = $29cc0d123db42035$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $29cc0d123db42035$var$_propTypes = $29cc0d123db42035$var$_interopRequireDefault((parcelRequire("bisEj")));

var $29cc0d123db42035$var$_reactDom = $29cc0d123db42035$var$_interopRequireDefault((parcelRequire("d2lNW")));

var $29cc0d123db42035$var$_clsx = $29cc0d123db42035$var$_interopRequireDefault((parcelRequire("f4H2M")));

var $kxion = parcelRequire("kxion");

var $dqNWo = parcelRequire("dqNWo");

var $cNyfi = parcelRequire("cNyfi");

var $29cc0d123db42035$var$_DraggableCore = $29cc0d123db42035$var$_interopRequireDefault((parcelRequire("8Y5QS")));

var $29cc0d123db42035$var$_log = $29cc0d123db42035$var$_interopRequireDefault((parcelRequire("5S6CN")));
function $29cc0d123db42035$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $29cc0d123db42035$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($29cc0d123db42035$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $29cc0d123db42035$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $29cc0d123db42035$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $29cc0d123db42035$var$_extends() {
    $29cc0d123db42035$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $29cc0d123db42035$var$_extends.apply(this, arguments);
}
function $29cc0d123db42035$var$_defineProperty(obj, key, value) {
    key = $29cc0d123db42035$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $29cc0d123db42035$var$_toPropertyKey(arg) {
    var key = $29cc0d123db42035$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $29cc0d123db42035$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $29cc0d123db42035$var$Draggable extends $29cc0d123db42035$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $29cc0d123db42035$var$_log.default)("Draggable: getDerivedStateFromProps %j", {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $29cc0d123db42035$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $29cc0d123db42035$var$_log.default)("Draggable: onDragStart: %j", coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $dqNWo.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $29cc0d123db42035$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $29cc0d123db42035$var$_log.default)("Draggable: onDrag: %j", coreData);
            const uiData = (0, $dqNWo.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $dqNWo.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $29cc0d123db42035$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $dqNWo.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $29cc0d123db42035$var$_log.default)("Draggable: onDragStop: %j", coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $29cc0d123db42035$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $dqNWo.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $dqNWo.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $kxion.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $kxion.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $29cc0d123db42035$var$_clsx.default)(children.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $29cc0d123db42035$var$React.createElement($29cc0d123db42035$var$_DraggableCore.default, $29cc0d123db42035$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $29cc0d123db42035$var$React.cloneElement($29cc0d123db42035$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
module.exports.default = $29cc0d123db42035$var$Draggable;
$29cc0d123db42035$var$_defineProperty($29cc0d123db42035$var$Draggable, "displayName", "Draggable");
$29cc0d123db42035$var$_defineProperty($29cc0d123db42035$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$29cc0d123db42035$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $29cc0d123db42035$var$_propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $29cc0d123db42035$var$_propTypes.default.oneOfType([
        $29cc0d123db42035$var$_propTypes.default.shape({
            left: $29cc0d123db42035$var$_propTypes.default.number,
            right: $29cc0d123db42035$var$_propTypes.default.number,
            top: $29cc0d123db42035$var$_propTypes.default.number,
            bottom: $29cc0d123db42035$var$_propTypes.default.number
        }),
        $29cc0d123db42035$var$_propTypes.default.string,
        $29cc0d123db42035$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $29cc0d123db42035$var$_propTypes.default.string,
    defaultClassNameDragging: $29cc0d123db42035$var$_propTypes.default.string,
    defaultClassNameDragged: $29cc0d123db42035$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $29cc0d123db42035$var$_propTypes.default.shape({
        x: $29cc0d123db42035$var$_propTypes.default.number,
        y: $29cc0d123db42035$var$_propTypes.default.number
    }),
    positionOffset: $29cc0d123db42035$var$_propTypes.default.shape({
        x: $29cc0d123db42035$var$_propTypes.default.oneOfType([
            $29cc0d123db42035$var$_propTypes.default.number,
            $29cc0d123db42035$var$_propTypes.default.string
        ]),
        y: $29cc0d123db42035$var$_propTypes.default.oneOfType([
            $29cc0d123db42035$var$_propTypes.default.number,
            $29cc0d123db42035$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $29cc0d123db42035$var$_propTypes.default.shape({
        x: $29cc0d123db42035$var$_propTypes.default.number,
        y: $29cc0d123db42035$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $cNyfi.dontSetMe,
    style: $cNyfi.dontSetMe,
    transform: $cNyfi.dontSetMe
});
$29cc0d123db42035$var$_defineProperty($29cc0d123db42035$var$Draggable, "defaultProps", {
    ...$29cc0d123db42035$var$_DraggableCore.default.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});

});
parcelRegister("f4H2M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $af989e543686b60f$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $af989e543686b60f$export$2e2bcd8739ae039; });
function $af989e543686b60f$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $af989e543686b60f$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $af989e543686b60f$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $af989e543686b60f$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $af989e543686b60f$export$2e2bcd8739ae039 = $af989e543686b60f$export$4f5d2d50c9deca37;

});

parcelRegister("kxion", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $ef352809d5fc10bb$var$addClassName;
module.exports.addEvent = $ef352809d5fc10bb$var$addEvent;
module.exports.addUserSelectStyles = $ef352809d5fc10bb$var$addUserSelectStyles;
module.exports.createCSSTransform = $ef352809d5fc10bb$var$createCSSTransform;
module.exports.createSVGTransform = $ef352809d5fc10bb$var$createSVGTransform;
module.exports.getTouch = $ef352809d5fc10bb$var$getTouch;
module.exports.getTouchIdentifier = $ef352809d5fc10bb$var$getTouchIdentifier;
module.exports.getTranslation = $ef352809d5fc10bb$var$getTranslation;
module.exports.innerHeight = $ef352809d5fc10bb$var$innerHeight;
module.exports.innerWidth = $ef352809d5fc10bb$var$innerWidth;
module.exports.matchesSelector = $ef352809d5fc10bb$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $ef352809d5fc10bb$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $ef352809d5fc10bb$var$offsetXYFromParent;
module.exports.outerHeight = $ef352809d5fc10bb$var$outerHeight;
module.exports.outerWidth = $ef352809d5fc10bb$var$outerWidth;
module.exports.removeClassName = $ef352809d5fc10bb$var$removeClassName;
module.exports.removeEvent = $ef352809d5fc10bb$var$removeEvent;
module.exports.removeUserSelectStyles = $ef352809d5fc10bb$var$removeUserSelectStyles;

var $cNyfi = parcelRequire("cNyfi");

var $ef352809d5fc10bb$var$_getPrefix = $ef352809d5fc10bb$var$_interopRequireWildcard((parcelRequire("61Fu8")));
function $ef352809d5fc10bb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ef352809d5fc10bb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ef352809d5fc10bb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ef352809d5fc10bb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $ef352809d5fc10bb$var$matchesSelectorFunc = "";
function $ef352809d5fc10bb$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$ef352809d5fc10bb$var$matchesSelectorFunc) $ef352809d5fc10bb$var$matchesSelectorFunc = (0, $cNyfi.findInArray)([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $cNyfi.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $cNyfi.isFunction)(el[$ef352809d5fc10bb$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$ef352809d5fc10bb$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $ef352809d5fc10bb$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($ef352809d5fc10bb$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $ef352809d5fc10bb$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = handler;
}
function $ef352809d5fc10bb$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = null;
}
function $ef352809d5fc10bb$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $cNyfi.int)(computedStyle.borderTopWidth);
    height += (0, $cNyfi.int)(computedStyle.borderBottomWidth);
    return height;
}
function $ef352809d5fc10bb$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $cNyfi.int)(computedStyle.borderLeftWidth);
    width += (0, $cNyfi.int)(computedStyle.borderRightWidth);
    return width;
}
function $ef352809d5fc10bb$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $cNyfi.int)(computedStyle.paddingTop);
    height -= (0, $cNyfi.int)(computedStyle.paddingBottom);
    return height;
}
function $ef352809d5fc10bb$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $cNyfi.int)(computedStyle.paddingLeft);
    width -= (0, $cNyfi.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $ef352809d5fc10bb$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $ef352809d5fc10bb$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $ef352809d5fc10bb$var$getTranslation(controlPos, positionOffset, "px");
    return {
        [(0, $ef352809d5fc10bb$var$_getPrefix.browserPrefixToKey)("transform", $ef352809d5fc10bb$var$_getPrefix.default)]: translation
    };
}
function $ef352809d5fc10bb$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $ef352809d5fc10bb$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $ef352809d5fc10bb$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $ef352809d5fc10bb$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $cNyfi.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $cNyfi.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $ef352809d5fc10bb$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $ef352809d5fc10bb$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $ef352809d5fc10bb$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $ef352809d5fc10bb$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $ef352809d5fc10bb$var$removeClassName(doc.body, "react-draggable-transparent-selection");
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $ef352809d5fc10bb$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $ef352809d5fc10bb$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
}

});
parcelRegister("cNyfi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $9514a023e1957a3c$var$dontSetMe;
module.exports.findInArray = $9514a023e1957a3c$var$findInArray;
module.exports.int = $9514a023e1957a3c$var$int;
module.exports.isFunction = $9514a023e1957a3c$var$isFunction;
module.exports.isNum = $9514a023e1957a3c$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $9514a023e1957a3c$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $9514a023e1957a3c$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $9514a023e1957a3c$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === "number" && !isNaN(num);
}
function $9514a023e1957a3c$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $9514a023e1957a3c$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});

parcelRegister("61Fu8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $463304240e3e1bde$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $463304240e3e1bde$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $463304240e3e1bde$var$getPrefix;
const $463304240e3e1bde$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $463304240e3e1bde$var$getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === "undefined") return "";
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < $463304240e3e1bde$var$prefixes.length; i++){
        if ($463304240e3e1bde$var$browserPrefixToKey(prop, $463304240e3e1bde$var$prefixes[i]) in style) return $463304240e3e1bde$var$prefixes[i];
    }
    return "";
}
function $463304240e3e1bde$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat($463304240e3e1bde$var$kebabToTitleCase(prop)) : prop;
}
function $463304240e3e1bde$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $463304240e3e1bde$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $463304240e3e1bde$var$_default = module.exports.default = $463304240e3e1bde$var$getPrefix();

});


parcelRegister("dqNWo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $9c74714c468402f2$var$canDragX;
module.exports.canDragY = $9c74714c468402f2$var$canDragY;
module.exports.createCoreData = $9c74714c468402f2$var$createCoreData;
module.exports.createDraggableData = $9c74714c468402f2$var$createDraggableData;
module.exports.getBoundPosition = $9c74714c468402f2$var$getBoundPosition;
module.exports.getControlPosition = $9c74714c468402f2$var$getControlPosition;
module.exports.snapToGrid = $9c74714c468402f2$var$snapToGrid;

var $cNyfi = parcelRequire("cNyfi");

var $kxion = parcelRequire("kxion");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $9c74714c468402f2$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : $9c74714c468402f2$var$cloneBounds(bounds);
    const node = $9c74714c468402f2$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $cNyfi.int)(boundNodeStyle.paddingLeft) + (0, $cNyfi.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $cNyfi.int)(boundNodeStyle.paddingTop) + (0, $cNyfi.int)(nodeStyle.marginTop),
            right: (0, $kxion.innerWidth)(boundNodeEl) - (0, $kxion.outerWidth)(node) - node.offsetLeft + (0, $cNyfi.int)(boundNodeStyle.paddingRight) - (0, $cNyfi.int)(nodeStyle.marginRight),
            bottom: (0, $kxion.innerHeight)(boundNodeEl) - (0, $kxion.outerHeight)(node) - node.offsetTop + (0, $cNyfi.int)(boundNodeStyle.paddingBottom) - (0, $cNyfi.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $cNyfi.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $cNyfi.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $cNyfi.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $cNyfi.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $9c74714c468402f2$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $9c74714c468402f2$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $9c74714c468402f2$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
// Get {x, y} positions from event.
function $9c74714c468402f2$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === "number" ? (0, $kxion.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null; // not the right touch
    const node = $9c74714c468402f2$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $kxion.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $9c74714c468402f2$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $cNyfi.isNum)(draggable.lastX);
    const node = $9c74714c468402f2$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $9c74714c468402f2$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $9c74714c468402f2$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $9c74714c468402f2$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("8Y5QS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6878775ee3282ad3$var$React = $6878775ee3282ad3$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $6878775ee3282ad3$var$_propTypes = $6878775ee3282ad3$var$_interopRequireDefault((parcelRequire("bisEj")));

var $6878775ee3282ad3$var$_reactDom = $6878775ee3282ad3$var$_interopRequireDefault((parcelRequire("d2lNW")));

var $kxion = parcelRequire("kxion");

var $dqNWo = parcelRequire("dqNWo");

var $cNyfi = parcelRequire("cNyfi");

var $6878775ee3282ad3$var$_log = $6878775ee3282ad3$var$_interopRequireDefault((parcelRequire("5S6CN")));
function $6878775ee3282ad3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6878775ee3282ad3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6878775ee3282ad3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6878775ee3282ad3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6878775ee3282ad3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6878775ee3282ad3$var$_defineProperty(obj, key, value) {
    key = $6878775ee3282ad3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6878775ee3282ad3$var$_toPropertyKey(arg) {
    var key = $6878775ee3282ad3$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6878775ee3282ad3$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $6878775ee3282ad3$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
// Default to mouse events.
let $6878775ee3282ad3$var$dragEventFor = $6878775ee3282ad3$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $6878775ee3282ad3$var$DraggableCore extends $6878775ee3282ad3$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $6878775ee3282ad3$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $6878775ee3282ad3$var$_defineProperty(this, "lastX", NaN);
        $6878775ee3282ad3$var$_defineProperty(this, "lastY", NaN);
        $6878775ee3282ad3$var$_defineProperty(this, "touchIdentifier", null);
        $6878775ee3282ad3$var$_defineProperty(this, "mounted", false);
        $6878775ee3282ad3$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $kxion.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $kxion.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === "touchstart") e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $kxion.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $dqNWo.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $dqNWo.createCoreData)(this, x, y);
            (0, $6878775ee3282ad3$var$_log.default)("DraggableCore: handleDragStart: %j", coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $6878775ee3282ad3$var$_log.default)("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $kxion.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $kxion.addEvent)(ownerDocument, $6878775ee3282ad3$var$dragEventFor.move, this.handleDrag);
            (0, $kxion.addEvent)(ownerDocument, $6878775ee3282ad3$var$dragEventFor.stop, this.handleDragStop);
        });
        $6878775ee3282ad3$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $dqNWo.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $dqNWo.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $dqNWo.createCoreData)(this, x, y);
            (0, $6878775ee3282ad3$var$_log.default)("DraggableCore: handleDrag: %j", coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent("MouseEvents");
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $6878775ee3282ad3$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $dqNWo.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $dqNWo.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $dqNWo.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $kxion.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $6878775ee3282ad3$var$_log.default)("DraggableCore: handleDragStop: %j", coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $6878775ee3282ad3$var$_log.default)("DraggableCore: Removing handlers");
                (0, $kxion.removeEvent)(thisNode.ownerDocument, $6878775ee3282ad3$var$dragEventFor.move, this.handleDrag);
                (0, $kxion.removeEvent)(thisNode.ownerDocument, $6878775ee3282ad3$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $6878775ee3282ad3$var$_defineProperty(this, "onMouseDown", (e)=>{
            $6878775ee3282ad3$var$dragEventFor = $6878775ee3282ad3$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $6878775ee3282ad3$var$_defineProperty(this, "onMouseUp", (e)=>{
            $6878775ee3282ad3$var$dragEventFor = $6878775ee3282ad3$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $6878775ee3282ad3$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $6878775ee3282ad3$var$dragEventFor = $6878775ee3282ad3$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $6878775ee3282ad3$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $6878775ee3282ad3$var$dragEventFor = $6878775ee3282ad3$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $kxion.addEvent)(thisNode, $6878775ee3282ad3$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $kxion.removeEvent)(ownerDocument, $6878775ee3282ad3$var$eventsFor.mouse.move, this.handleDrag);
            (0, $kxion.removeEvent)(ownerDocument, $6878775ee3282ad3$var$eventsFor.touch.move, this.handleDrag);
            (0, $kxion.removeEvent)(ownerDocument, $6878775ee3282ad3$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $kxion.removeEvent)(ownerDocument, $6878775ee3282ad3$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $kxion.removeEvent)(thisNode, $6878775ee3282ad3$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $kxion.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : $6878775ee3282ad3$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $6878775ee3282ad3$var$React.cloneElement($6878775ee3282ad3$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $6878775ee3282ad3$var$DraggableCore;
$6878775ee3282ad3$var$_defineProperty($6878775ee3282ad3$var$DraggableCore, "displayName", "DraggableCore");
$6878775ee3282ad3$var$_defineProperty($6878775ee3282ad3$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $6878775ee3282ad3$var$_propTypes.default.bool,
    children: $6878775ee3282ad3$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $6878775ee3282ad3$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $6878775ee3282ad3$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $6878775ee3282ad3$var$_propTypes.default.arrayOf($6878775ee3282ad3$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $6878775ee3282ad3$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $6878775ee3282ad3$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $6878775ee3282ad3$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $6878775ee3282ad3$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $6878775ee3282ad3$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $6878775ee3282ad3$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $6878775ee3282ad3$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $6878775ee3282ad3$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $cNyfi.dontSetMe,
    style: $cNyfi.dontSetMe,
    transform: $cNyfi.dontSetMe
});
$6878775ee3282ad3$var$_defineProperty($6878775ee3282ad3$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("5S6CN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4467226f83359556$var$log;
/*eslint no-console:0*/ function $4467226f83359556$var$log() {}

});




parcelRegister("d9APM", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};

module.exports.Resizable = (parcelRequire("a2tEy")).default;

module.exports.ResizableBox = (parcelRequire("7wHSs")).default;

});
parcelRegister("a2tEy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $74f117c10fc14979$export$1e511d4a378977f5; }, function (v) { return $74f117c10fc14979$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $74f117c10fc14979$export$2e2bcd8739ae039; }, function (v) { return $74f117c10fc14979$export$2e2bcd8739ae039 = v; });
var $74f117c10fc14979$export$1e511d4a378977f5;
var $74f117c10fc14979$export$2e2bcd8739ae039;
"use strict";
$74f117c10fc14979$export$1e511d4a378977f5 = true;
$74f117c10fc14979$export$2e2bcd8739ae039 = void 0;

var $74f117c10fc14979$var$React = $74f117c10fc14979$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $fquW1 = parcelRequire("fquW1");

var $BfXsS = parcelRequire("BfXsS");

var $haou7 = parcelRequire("haou7");
var $74f117c10fc14979$var$_excluded = [
    "children",
    "className",
    "draggableOpts",
    "width",
    "height",
    "handle",
    "handleSize",
    "lockAspectRatio",
    "axis",
    "minConstraints",
    "maxConstraints",
    "onResize",
    "onResizeStop",
    "onResizeStart",
    "resizeHandles",
    "transformScale"
];
function $74f117c10fc14979$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($74f117c10fc14979$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $74f117c10fc14979$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $74f117c10fc14979$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $74f117c10fc14979$var$_extends() {
    $74f117c10fc14979$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $74f117c10fc14979$var$_extends.apply(this, arguments);
}
function $74f117c10fc14979$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $74f117c10fc14979$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $74f117c10fc14979$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $74f117c10fc14979$var$ownKeys(Object(source), !0).forEach(function(key) {
            $74f117c10fc14979$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $74f117c10fc14979$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $74f117c10fc14979$var$_defineProperty(obj, key, value) {
    key = $74f117c10fc14979$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $74f117c10fc14979$var$_toPropertyKey(arg) {
    var key = $74f117c10fc14979$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $74f117c10fc14979$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $74f117c10fc14979$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $74f117c10fc14979$var$_setPrototypeOf(subClass, superClass);
}
function $74f117c10fc14979$var$_setPrototypeOf(o, p) {
    $74f117c10fc14979$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $74f117c10fc14979$var$_setPrototypeOf(o, p);
}
// The base <Resizable> component.
// This component does not have state and relies on the parent to set its props based on callback data.
var $74f117c10fc14979$var$Resizable = /*#__PURE__*/ function(_React$Component) {
    $74f117c10fc14979$var$_inheritsLoose(Resizable, _React$Component);
    function Resizable() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleRefs = {};
        _this.lastHandleRect = null;
        _this.slack = null;
        return _this;
    }
    var _proto = Resizable.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.resetData();
    };
    _proto.resetData = function resetData() {
        this.lastHandleRect = this.slack = null;
    };
    _proto.runConstraints = function runConstraints(width, height) {
        var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
        // short circuit
        if (!minConstraints && !maxConstraints && !lockAspectRatio) return [
            width,
            height
        ];
        // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (lockAspectRatio) {
            var ratio = this.props.width / this.props.height;
            var deltaW = width - this.props.width;
            var deltaH = height - this.props.height;
            // Find which coordinate was greater and should push the other toward it.
            // E.g.:
            // ratio = 1, deltaW = 10, deltaH = 5, deltaH should become 10.
            // ratio = 2, deltaW = 10, deltaH = 6, deltaW should become 12.
            if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) height = width / ratio;
            else width = height * ratio;
        }
        var oldW = width, oldH = height;
        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        var _ref = this.slack || [
            0,
            0
        ], slackW = _ref[0], slackH = _ref[1];
        width += slackW;
        height += slackH;
        if (minConstraints) {
            width = Math.max(minConstraints[0], width);
            height = Math.max(minConstraints[1], height);
        }
        if (maxConstraints) {
            width = Math.min(maxConstraints[0], width);
            height = Math.min(maxConstraints[1], height);
        }
        // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    } /**
   * Wrapper around drag events to provide more useful data.
   *
   * @param  {String} handlerName Handler name to wrap.
   * @return {Function}           Handler function.
   */ ;
    _proto.resizeHandler = function resizeHandler(handlerName, axis) {
        var _this2 = this;
        return function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === "onResizeStart") _this2.resetData();
            // Axis restrictions
            var canDragX = (_this2.props.axis === "both" || _this2.props.axis === "x") && axis !== "n" && axis !== "s";
            var canDragY = (_this2.props.axis === "both" || _this2.props.axis === "y") && axis !== "e" && axis !== "w";
            // No dragging possible.
            if (!canDragX && !canDragY) return;
            // Decompose axis for later use
            var axisV = axis[0];
            var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            var handleRect = node.getBoundingClientRect();
            if (_this2.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === "w") {
                    var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === "n") {
                    var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            }
            // Storage of last rect so we know how much it has really moved.
            _this2.lastHandleRect = handleRect;
            // Reverse delta if using top or left drag handles.
            if (axisH === "w") deltaX = -deltaX;
            if (axisV === "n") deltaY = -deltaY;
            // Update w/h by the deltas. Also factor in transformScale.
            var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
            var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0);
            // Run user-provided constraints.
            var _this2$runConstraints = _this2.runConstraints(width, height);
            width = _this2$runConstraints[0];
            height = _this2$runConstraints[1];
            var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
            // Call user-supplied callback if present.
            var cb = typeof _this2.props[handlerName] === "function" ? _this2.props[handlerName] : null;
            // Don't call 'onResize' if dimensions haven't changed.
            var shouldSkipCb = handlerName === "onResize" && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                e.persist == null || e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            }
            // Reset internal data
            if (handlerName === "onResizeStop") _this2.resetData();
        };
    };
    _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
        var handle = this.props.handle;
        // No handle provided, make the default
        if (!handle) return /*#__PURE__*/ $74f117c10fc14979$var$React.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + handleAxis,
            ref: ref
        });
        // Handle is a function, such as:
        // `handle={(handleAxis) => <span className={...} />}`
        if (typeof handle === "function") return handle(handleAxis, ref);
        // Handle is a React component (composite or DOM).
        var isDOMElement = typeof handle.type === "string";
        var props = $74f117c10fc14979$var$_objectSpread({
            ref: ref
        }, isDOMElement ? {} : {
            handleAxis: handleAxis
        });
        return /*#__PURE__*/ $74f117c10fc14979$var$React.cloneElement(handle, props);
    };
    _proto.render = function render() {
        var _this3 = this;
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts, width = _this$props2.width, height = _this$props2.height, handle = _this$props2.handle, handleSize = _this$props2.handleSize, lockAspectRatio = _this$props2.lockAspectRatio, axis = _this$props2.axis, minConstraints = _this$props2.minConstraints, maxConstraints = _this$props2.maxConstraints, onResize = _this$props2.onResize, onResizeStop = _this$props2.onResizeStop, onResizeStart = _this$props2.onResizeStart, resizeHandles = _this$props2.resizeHandles, transformScale = _this$props2.transformScale, p = $74f117c10fc14979$var$_objectWithoutPropertiesLoose(_this$props2, $74f117c10fc14979$var$_excluded);
        // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // 1. Its original children (resizable's child's children), and
        // 2. One or more draggable handles.
        return (0, $BfXsS.cloneElement)(children, $74f117c10fc14979$var$_objectSpread($74f117c10fc14979$var$_objectSpread({}, p), {}, {
            className: (className ? className + " " : "") + "react-resizable",
            children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
                var _this3$handleRefs$han;
                // Create a ref to the handle so that `<DraggableCore>` doesn't have to use ReactDOM.findDOMNode().
                var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /*#__PURE__*/ $74f117c10fc14979$var$React.createRef();
                return /*#__PURE__*/ $74f117c10fc14979$var$React.createElement($fquW1.DraggableCore, $74f117c10fc14979$var$_extends({}, draggableOpts, {
                    nodeRef: ref,
                    key: "resizableHandle-" + handleAxis,
                    onStop: _this3.resizeHandler("onResizeStop", handleAxis),
                    onStart: _this3.resizeHandler("onResizeStart", handleAxis),
                    onDrag: _this3.resizeHandler("onResize", handleAxis)
                }), _this3.renderResizeHandle(handleAxis, ref));
            }))
        }));
    };
    return Resizable;
}($74f117c10fc14979$var$React.Component);
$74f117c10fc14979$export$2e2bcd8739ae039 = $74f117c10fc14979$var$Resizable;
$74f117c10fc14979$var$Resizable.propTypes = $haou7.resizableProps;
$74f117c10fc14979$var$Resizable.defaultProps = {
    axis: "both",
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        "se"
    ],
    transformScale: 1
};

});
parcelRegister("BfXsS", function(module, exports) {

$parcel$export(module.exports, "cloneElement", function () { return $06ffd5c3b31028d2$export$e530037191fcd5d7; }, function (v) { return $06ffd5c3b31028d2$export$e530037191fcd5d7 = v; });
var $06ffd5c3b31028d2$export$1e511d4a378977f5;
var $06ffd5c3b31028d2$export$e530037191fcd5d7;
"use strict";
$06ffd5c3b31028d2$export$1e511d4a378977f5 = true;
$06ffd5c3b31028d2$export$e530037191fcd5d7 = $06ffd5c3b31028d2$var$cloneElement;

var $06ffd5c3b31028d2$var$_react = $06ffd5c3b31028d2$var$_interopRequireDefault((parcelRequire("exYeM")));
function $06ffd5c3b31028d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $06ffd5c3b31028d2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $06ffd5c3b31028d2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $06ffd5c3b31028d2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $06ffd5c3b31028d2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $06ffd5c3b31028d2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $06ffd5c3b31028d2$var$_defineProperty(obj, key, value) {
    key = $06ffd5c3b31028d2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $06ffd5c3b31028d2$var$_toPropertyKey(arg) {
    var key = $06ffd5c3b31028d2$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $06ffd5c3b31028d2$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// React.addons.cloneWithProps look-alike that merges style & className.
function $06ffd5c3b31028d2$var$cloneElement(element, props) {
    if (props.style && element.props.style) props.style = $06ffd5c3b31028d2$var$_objectSpread($06ffd5c3b31028d2$var$_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ $06ffd5c3b31028d2$var$_react.default.cloneElement(element, props);
}

});

parcelRegister("haou7", function(module, exports) {

$parcel$export(module.exports, "resizableProps", function () { return $c7f65cfd06b865c0$export$32a002ec6a601762; }, function (v) { return $c7f65cfd06b865c0$export$32a002ec6a601762 = v; });
var $c7f65cfd06b865c0$export$1e511d4a378977f5;
var $c7f65cfd06b865c0$export$32a002ec6a601762;
"use strict";
$c7f65cfd06b865c0$export$1e511d4a378977f5 = true;
$c7f65cfd06b865c0$export$32a002ec6a601762 = void 0;

var $c7f65cfd06b865c0$var$_propTypes = $c7f65cfd06b865c0$var$_interopRequireDefault((parcelRequire("bisEj")));
parcelRequire("fquW1");
function $c7f65cfd06b865c0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c7f65cfd06b865c0$var$resizableProps = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: $c7f65cfd06b865c0$var$_propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    className: $c7f65cfd06b865c0$var$_propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: $c7f65cfd06b865c0$var$_propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: $c7f65cfd06b865c0$var$_propTypes.default.shape({
        allowAnyClick: $c7f65cfd06b865c0$var$_propTypes.default.bool,
        cancel: $c7f65cfd06b865c0$var$_propTypes.default.string,
        children: $c7f65cfd06b865c0$var$_propTypes.default.node,
        disabled: $c7f65cfd06b865c0$var$_propTypes.default.bool,
        enableUserSelectHack: $c7f65cfd06b865c0$var$_propTypes.default.bool,
        offsetParent: $c7f65cfd06b865c0$var$_propTypes.default.node,
        grid: $c7f65cfd06b865c0$var$_propTypes.default.arrayOf($c7f65cfd06b865c0$var$_propTypes.default.number),
        handle: $c7f65cfd06b865c0$var$_propTypes.default.string,
        nodeRef: $c7f65cfd06b865c0$var$_propTypes.default.object,
        onStart: $c7f65cfd06b865c0$var$_propTypes.default.func,
        onDrag: $c7f65cfd06b865c0$var$_propTypes.default.func,
        onStop: $c7f65cfd06b865c0$var$_propTypes.default.func,
        onMouseDown: $c7f65cfd06b865c0$var$_propTypes.default.func,
        scale: $c7f65cfd06b865c0$var$_propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: function height() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var props = args[0];
        // Required if resizing height or both
        if (props.axis === "both" || props.axis === "y") {
            var _PropTypes$number;
            return (_PropTypes$number = $c7f65cfd06b865c0$var$_propTypes.default.number).isRequired.apply(_PropTypes$number, args);
        }
        return $c7f65cfd06b865c0$var$_propTypes.default.number.apply($c7f65cfd06b865c0$var$_propTypes.default, args);
    },
    /*
  * Customize cursor resize handle
  * */ handle: $c7f65cfd06b865c0$var$_propTypes.default.oneOfType([
        $c7f65cfd06b865c0$var$_propTypes.default.node,
        $c7f65cfd06b865c0$var$_propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: $c7f65cfd06b865c0$var$_propTypes.default.arrayOf($c7f65cfd06b865c0$var$_propTypes.default.number),
    lockAspectRatio: $c7f65cfd06b865c0$var$_propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: $c7f65cfd06b865c0$var$_propTypes.default.arrayOf($c7f65cfd06b865c0$var$_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: $c7f65cfd06b865c0$var$_propTypes.default.arrayOf($c7f65cfd06b865c0$var$_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: $c7f65cfd06b865c0$var$_propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: $c7f65cfd06b865c0$var$_propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: $c7f65cfd06b865c0$var$_propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: $c7f65cfd06b865c0$var$_propTypes.default.arrayOf($c7f65cfd06b865c0$var$_propTypes.default.oneOf([
        "s",
        "w",
        "e",
        "n",
        "sw",
        "nw",
        "se",
        "ne"
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: $c7f65cfd06b865c0$var$_propTypes.default.number,
    /*
   * Initial width
   */ width: function width() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var props = args[0];
        // Required if resizing width or both
        if (props.axis === "both" || props.axis === "x") {
            var _PropTypes$number2;
            return (_PropTypes$number2 = $c7f65cfd06b865c0$var$_propTypes.default.number).isRequired.apply(_PropTypes$number2, args);
        }
        return $c7f65cfd06b865c0$var$_propTypes.default.number.apply($c7f65cfd06b865c0$var$_propTypes.default, args);
    }
};
$c7f65cfd06b865c0$export$32a002ec6a601762 = $c7f65cfd06b865c0$var$resizableProps;

});


parcelRegister("7wHSs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57ad8eb2b984fe7e$export$2e2bcd8739ae039; }, function (v) { return $57ad8eb2b984fe7e$export$2e2bcd8739ae039 = v; });
var $57ad8eb2b984fe7e$export$1e511d4a378977f5;
var $57ad8eb2b984fe7e$export$2e2bcd8739ae039;
"use strict";
$57ad8eb2b984fe7e$export$1e511d4a378977f5 = true;
$57ad8eb2b984fe7e$export$2e2bcd8739ae039 = void 0;

var $57ad8eb2b984fe7e$var$React = $57ad8eb2b984fe7e$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $57ad8eb2b984fe7e$var$_propTypes = $57ad8eb2b984fe7e$var$_interopRequireDefault((parcelRequire("bisEj")));

var $57ad8eb2b984fe7e$var$_Resizable = $57ad8eb2b984fe7e$var$_interopRequireDefault((parcelRequire("a2tEy")));

var $haou7 = parcelRequire("haou7");
var $57ad8eb2b984fe7e$var$_excluded = [
    "handle",
    "handleSize",
    "onResize",
    "onResizeStart",
    "onResizeStop",
    "draggableOpts",
    "minConstraints",
    "maxConstraints",
    "lockAspectRatio",
    "axis",
    "width",
    "height",
    "resizeHandles",
    "style",
    "transformScale"
];
function $57ad8eb2b984fe7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $57ad8eb2b984fe7e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($57ad8eb2b984fe7e$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $57ad8eb2b984fe7e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $57ad8eb2b984fe7e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $57ad8eb2b984fe7e$var$_extends() {
    $57ad8eb2b984fe7e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $57ad8eb2b984fe7e$var$_extends.apply(this, arguments);
}
function $57ad8eb2b984fe7e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $57ad8eb2b984fe7e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $57ad8eb2b984fe7e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $57ad8eb2b984fe7e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $57ad8eb2b984fe7e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $57ad8eb2b984fe7e$var$_defineProperty(obj, key, value) {
    key = $57ad8eb2b984fe7e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $57ad8eb2b984fe7e$var$_toPropertyKey(arg) {
    var key = $57ad8eb2b984fe7e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $57ad8eb2b984fe7e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $57ad8eb2b984fe7e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $57ad8eb2b984fe7e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $57ad8eb2b984fe7e$var$_setPrototypeOf(subClass, superClass);
}
function $57ad8eb2b984fe7e$var$_setPrototypeOf(o, p) {
    $57ad8eb2b984fe7e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $57ad8eb2b984fe7e$var$_setPrototypeOf(o, p);
}
var $57ad8eb2b984fe7e$var$ResizableBox = /*#__PURE__*/ function(_React$Component) {
    $57ad8eb2b984fe7e$var$_inheritsLoose(ResizableBox, _React$Component);
    function ResizableBox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            width: _this.props.width,
            height: _this.props.height,
            propsWidth: _this.props.width,
            propsHeight: _this.props.height
        };
        _this.onResize = function(e, data) {
            var size = data.size;
            if (_this.props.onResize) {
                e.persist == null || e.persist();
                _this.setState(size, function() {
                    return _this.props.onResize && _this.props.onResize(e, data);
                });
            } else _this.setState(size);
        };
        return _this;
    }
    ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    };
    var _proto = ResizableBox.prototype;
    _proto.render = function render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = $57ad8eb2b984fe7e$var$_objectWithoutPropertiesLoose(_this$props, $57ad8eb2b984fe7e$var$_excluded);
        return /*#__PURE__*/ $57ad8eb2b984fe7e$var$React.createElement($57ad8eb2b984fe7e$var$_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ $57ad8eb2b984fe7e$var$React.createElement("div", $57ad8eb2b984fe7e$var$_extends({}, props, {
            style: $57ad8eb2b984fe7e$var$_objectSpread($57ad8eb2b984fe7e$var$_objectSpread({}, style), {}, {
                width: this.state.width + "px",
                height: this.state.height + "px"
            })
        })));
    };
    return ResizableBox;
}($57ad8eb2b984fe7e$var$React.Component);
$57ad8eb2b984fe7e$export$2e2bcd8739ae039 = $57ad8eb2b984fe7e$var$ResizableBox;
// PropTypes are identical to <Resizable>, except that children are not strictly required to be present.
$57ad8eb2b984fe7e$var$ResizableBox.propTypes = $57ad8eb2b984fe7e$var$_objectSpread($57ad8eb2b984fe7e$var$_objectSpread({}, $haou7.resizableProps), {}, {
    children: $57ad8eb2b984fe7e$var$_propTypes.default.element
});

});


parcelRegister("cbjrM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resizeHandleType = module.exports.resizeHandleAxesType = module.exports.default = void 0;

var $8de598e39d05f0f1$var$_propTypes = $8de598e39d05f0f1$var$_interopRequireDefault((parcelRequire("bisEj")));

var $8de598e39d05f0f1$var$_react = $8de598e39d05f0f1$var$_interopRequireDefault((parcelRequire("exYeM")));
function $8de598e39d05f0f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*:: import type {
  Ref,
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  DragOverEvent,
  EventCallback,
  CompactType,
  Layout,
  LayoutItem,
  ResizeHandleAxis
} from "./utils";*/ /*:: export type ReactRef<T: HTMLElement> = {|
  +current: T | null
|};*/ // util
/*:: export type ResizeHandle =
  | ReactElement<any>
  | ((
      resizeHandleAxis: ResizeHandleAxis,
      ref: ReactRef<HTMLElement>
    ) => ReactElement<any>);*/ // Defines which resize handles should be rendered (default: 'se')
// Allows for any combination of:
// 's' - South handle (bottom-center)
// 'w' - West handle (left-center)
// 'e' - East handle (right-center)
// 'n' - North handle (top-center)
// 'sw' - Southwest handle (bottom-left)
// 'nw' - Northwest handle (top-left)
// 'se' - Southeast handle (bottom-right)
// 'ne' - Northeast handle (top-right)
const $8de598e39d05f0f1$var$resizeHandleAxesType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleAxesType = $8de598e39d05f0f1$var$_propTypes.default.arrayOf($8de598e39d05f0f1$var$_propTypes.default.oneOf([
    "s",
    "w",
    "e",
    "n",
    "sw",
    "nw",
    "se",
    "ne"
]));
// Custom component for resize handles
const $8de598e39d05f0f1$var$resizeHandleType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleType = $8de598e39d05f0f1$var$_propTypes.default.oneOfType([
    $8de598e39d05f0f1$var$_propTypes.default.node,
    $8de598e39d05f0f1$var$_propTypes.default.func
]);

/*:: export type Props = {|
  className: string,
  style: Object,
  width: number,
  autoSize: boolean,
  cols: number,
  draggableCancel: string,
  draggableHandle: string,
  verticalCompact: boolean,
  compactType: CompactType,
  layout: Layout,
  margin: [number, number],
  containerPadding: ?[number, number],
  rowHeight: number,
  maxRows: number,
  isBounded: boolean,
  isDraggable: boolean,
  isResizable: boolean,
  isDroppable: boolean,
  preventCollision: boolean,
  useCSSTransforms: boolean,
  transformScale: number,
  droppingItem: $Shape<LayoutItem>,
  resizeHandles: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,
  allowOverlap: boolean,

  // Callbacks
  onLayoutChange: Layout => void,
  onDrag: EventCallback,
  onDragStart: EventCallback,
  onDragStop: EventCallback,
  onResize: EventCallback,
  onResizeStart: EventCallback,
  onResizeStop: EventCallback,
  onDropDragOver: (e: DragOverEvent) => ?({| w?: number, h?: number |} | false),
  onDrop: (layout: Layout, item: ?LayoutItem, e: Event) => void,
  children: ReactChildrenArray<ReactElement<any>>,
  innerRef?: Ref<"div">
|};*/ /*:: export type DefaultProps = $Diff<
  Props,
  {
    children: ReactChildrenArray<ReactElement<any>>,
    width: number
  }
>;*/ var $8de598e39d05f0f1$var$_default = module.exports.default = {
    //
    // Basic props
    //
    className: $8de598e39d05f0f1$var$_propTypes.default.string,
    style: $8de598e39d05f0f1$var$_propTypes.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: $8de598e39d05f0f1$var$_propTypes.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: $8de598e39d05f0f1$var$_propTypes.default.bool,
    // # of cols.
    cols: $8de598e39d05f0f1$var$_propTypes.default.number,
    // A selector that will not be draggable.
    draggableCancel: $8de598e39d05f0f1$var$_propTypes.default.string,
    // A selector for the draggable handler
    draggableHandle: $8de598e39d05f0f1$var$_propTypes.default.string,
    // Deprecated
    verticalCompact: function(props /*: Props*/ ) {
        props.verticalCompact;
    },
    // Choose vertical or hotizontal compaction
    compactType: $8de598e39d05f0f1$var$_propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function(props /*: Props*/ ) {
        var layout = props.layout;
        // I hope you're setting the data-grid property on the grid items
        if (layout === undefined) return;
        (parcelRequire("koqIv")).validateLayout(layout, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: $8de598e39d05f0f1$var$_propTypes.default.arrayOf($8de598e39d05f0f1$var$_propTypes.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: $8de598e39d05f0f1$var$_propTypes.default.arrayOf($8de598e39d05f0f1$var$_propTypes.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: $8de598e39d05f0f1$var$_propTypes.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: $8de598e39d05f0f1$var$_propTypes.default.number,
    //
    // Flags
    //
    isBounded: $8de598e39d05f0f1$var$_propTypes.default.bool,
    isDraggable: $8de598e39d05f0f1$var$_propTypes.default.bool,
    isResizable: $8de598e39d05f0f1$var$_propTypes.default.bool,
    // If true, grid can be placed one over the other.
    allowOverlap: $8de598e39d05f0f1$var$_propTypes.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: $8de598e39d05f0f1$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $8de598e39d05f0f1$var$_propTypes.default.bool,
    // parent layout transform scale
    transformScale: $8de598e39d05f0f1$var$_propTypes.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: $8de598e39d05f0f1$var$_propTypes.default.bool,
    // Resize handle options
    resizeHandles: $8de598e39d05f0f1$var$resizeHandleAxesType,
    resizeHandle: $8de598e39d05f0f1$var$resizeHandleType,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: $8de598e39d05f0f1$var$_propTypes.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: $8de598e39d05f0f1$var$_propTypes.default.func,
    // Calls on each drag movement.
    onDrag: $8de598e39d05f0f1$var$_propTypes.default.func,
    // Calls when drag is complete.
    onDragStop: $8de598e39d05f0f1$var$_propTypes.default.func,
    //Calls when resize starts.
    onResizeStart: $8de598e39d05f0f1$var$_propTypes.default.func,
    // Calls when resize movement happens.
    onResize: $8de598e39d05f0f1$var$_propTypes.default.func,
    // Calls when resize is complete.
    onResizeStop: $8de598e39d05f0f1$var$_propTypes.default.func,
    // Calls when some element is dropped.
    onDrop: $8de598e39d05f0f1$var$_propTypes.default.func,
    //
    // Other validations
    //
    droppingItem: $8de598e39d05f0f1$var$_propTypes.default.shape({
        i: $8de598e39d05f0f1$var$_propTypes.default.string.isRequired,
        w: $8de598e39d05f0f1$var$_propTypes.default.number.isRequired,
        h: $8de598e39d05f0f1$var$_propTypes.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function(props /*: Props*/ , propName /*: string*/ ) {
        const children = props[propName];
        // Check children keys for duplicates. Throw if found.
        const keys = {};
        $8de598e39d05f0f1$var$_react.default.Children.forEach(children, function(child) {
            if (child?.key == null) return;
            if (keys[child.key]) throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
            keys[child.key] = true;
        });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: $8de598e39d05f0f1$var$_propTypes.default.any
};

});



parcelRegister("NhNjE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $094261519ed013ae$var$React = $094261519ed013ae$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $094261519ed013ae$var$_propTypes = $094261519ed013ae$var$_interopRequireDefault((parcelRequire("bisEj")));

var $cRM2F = parcelRequire("cRM2F");

var $koqIv = parcelRequire("koqIv");

var $jCBCS = parcelRequire("jCBCS");

var $094261519ed013ae$var$_ReactGridLayout = $094261519ed013ae$var$_interopRequireDefault((parcelRequire("4MAdt")));
function $094261519ed013ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $094261519ed013ae$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($094261519ed013ae$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $094261519ed013ae$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $094261519ed013ae$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $094261519ed013ae$var$_extends() {
    $094261519ed013ae$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $094261519ed013ae$var$_extends.apply(this, arguments);
}
function $094261519ed013ae$var$_defineProperty(obj, key, value) {
    key = $094261519ed013ae$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $094261519ed013ae$var$_toPropertyKey(arg) {
    var key = $094261519ed013ae$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $094261519ed013ae$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import { type Layout, type Pick } from "./utils";*/  /*:: import { type ResponsiveLayout, type OnLayoutChangeCallback, type Breakpoints } from "./responsiveUtils";*/ 
// $FlowFixMe[method-unbinding]
const $094261519ed013ae$var$type = (obj)=>Object.prototype.toString.call(obj);
/**
 * Get a value of margin or containerPadding.
 *
 * @param  {Array | Object} param Margin | containerPadding, e.g. [10, 10] | {lg: [10, 10], ...}.
 * @param  {String} breakpoint   Breakpoint: lg, md, sm, xs and etc.
 * @return {Array}
 */ function $094261519ed013ae$var$getIndentationValue(param /*: { [key: string]: T } | T*/ , breakpoint /*: string*/ ) /*: T*/ {
    // $FlowIgnore TODO fix this typedef
    if (param == null) return null;
    // $FlowIgnore TODO fix this typedef
    return Array.isArray(param) ? param : param[breakpoint];
}
/*:: type State = {
  layout: Layout,
  breakpoint: string,
  cols: number,
  layouts?: ResponsiveLayout<string>
};*/ /*:: type Props<Breakpoint: string = string> = {|
  ...React.ElementConfig<typeof ReactGridLayout>,

  // Responsive config
  breakpoint?: ?Breakpoint,
  breakpoints: Breakpoints<Breakpoint>,
  cols: { [key: Breakpoint]: number },
  layouts: ResponsiveLayout<Breakpoint>,
  width: number,
  margin: { [key: Breakpoint]: [number, number] } | [number, number],
  /* prettier-ignore *-/
  containerPadding: { [key: Breakpoint]: ?[number, number] } | ?[number, number],

  // Callbacks
  onBreakpointChange: (Breakpoint, cols: number) => void,
  onLayoutChange: OnLayoutChangeCallback,
  onWidthChange: (
    containerWidth: number,
    margin: [number, number],
    cols: number,
    containerPadding: ?[number, number]
  ) => void
|};*/ /*:: type DefaultProps = Pick<
  Props<>,
  {|
    allowOverlap: 0,
    breakpoints: 0,
    cols: 0,
    containerPadding: 0,
    layouts: 0,
    margin: 0,
    onBreakpointChange: 0,
    onLayoutChange: 0,
    onWidthChange: 0
  |}
>;*/ class $094261519ed013ae$var$ResponsiveReactGridLayout extends $094261519ed013ae$var$React.Component {
    constructor(){
        super(...arguments);
        $094261519ed013ae$var$_defineProperty(this, "state", this.generateInitialState());
        // wrap layouts so we do not need to pass layouts to child
        $094261519ed013ae$var$_defineProperty(this, "onLayoutChange", (layout /*: Layout*/ )=>{
            this.props.onLayoutChange(layout, {
                ...this.props.layouts,
                [this.state.breakpoint]: layout
            });
        });
    }
    generateInitialState() /*: State*/ {
        const { width: width, breakpoints: breakpoints, layouts: layouts, cols: cols } = this.props;
        const breakpoint = (0, $jCBCS.getBreakpointFromWidth)(breakpoints, width);
        const colNo = (0, $jCBCS.getColsFromBreakpoint)(breakpoint, cols);
        // verticalCompact compatibility, now deprecated
        const compactType = this.props.verticalCompact === false ? null : this.props.compactType;
        // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
        // for this layout.
        const initialLayout = (0, $jCBCS.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
        return {
            layout: initialLayout,
            breakpoint: breakpoint,
            cols: colNo
        };
    }
    static getDerivedStateFromProps(nextProps /*: Props<*>*/ , prevState /*: State*/ ) /*: ?$Shape<State>*/ {
        if (!(0, $cRM2F.deepEqual)(nextProps.layouts, prevState.layouts)) {
            // Allow parent to set layouts directly.
            const { breakpoint: breakpoint, cols: cols } = prevState;
            // Since we're setting an entirely new layout object, we must generate a new responsive layout
            // if one does not exist.
            const newLayout = (0, $jCBCS.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, cols, nextProps.compactType);
            return {
                layout: newLayout,
                layouts: nextProps.layouts
            };
        }
        return null;
    }
    componentDidUpdate(prevProps /*: Props<*>*/ ) {
        // Allow parent to set width or breakpoint directly.
        if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, $cRM2F.deepEqual)(this.props.breakpoints, prevProps.breakpoints) || !(0, $cRM2F.deepEqual)(this.props.cols, prevProps.cols)) this.onWidthChange(prevProps);
    }
    /**
   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
   * Width changes are necessary to figure out the widget widths.
   */ onWidthChange(prevProps /*: Props<*>*/ ) {
        const { breakpoints: breakpoints, cols: cols, layouts: layouts, compactType: compactType } = this.props;
        const newBreakpoint = this.props.breakpoint || (0, $jCBCS.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
        const lastBreakpoint = this.state.breakpoint;
        const newCols /*: number*/  = (0, $jCBCS.getColsFromBreakpoint)(newBreakpoint, cols);
        const newLayouts = {
            ...layouts
        };
        // Breakpoint change
        if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
            // Preserve the current layout if the current breakpoint is not present in the next layouts.
            if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, $koqIv.cloneLayout)(this.state.layout);
            // Find or generate a new layout.
            let layout = (0, $jCBCS.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType);
            // This adds missing items.
            layout = (0, $koqIv.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType, this.props.allowOverlap);
            // Store the new layout.
            newLayouts[newBreakpoint] = layout;
            // callbacks
            this.props.onBreakpointChange(newBreakpoint, newCols);
            this.props.onLayoutChange(layout, newLayouts);
            this.setState({
                breakpoint: newBreakpoint,
                layout: layout,
                cols: newCols
            });
        }
        const margin = $094261519ed013ae$var$getIndentationValue(this.props.margin, newBreakpoint);
        const containerPadding = $094261519ed013ae$var$getIndentationValue(this.props.containerPadding, newBreakpoint);
        //call onWidthChange on every change of width, not only on breakpoint changes
        this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
    }
    render() /*: React.Element<typeof ReactGridLayout>*/ {
        /* eslint-disable no-unused-vars */ const { breakpoint: breakpoint, breakpoints: breakpoints, cols: cols, layouts: layouts, margin: margin, containerPadding: containerPadding, onBreakpointChange: onBreakpointChange, onLayoutChange: onLayoutChange, onWidthChange: onWidthChange, ...other } = this.props;
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $094261519ed013ae$var$React.createElement($094261519ed013ae$var$_ReactGridLayout.default, $094261519ed013ae$var$_extends({}, other, {
            // $FlowIgnore should allow nullable here due to DefaultProps
            margin: $094261519ed013ae$var$getIndentationValue(margin, this.state.breakpoint),
            containerPadding: $094261519ed013ae$var$getIndentationValue(containerPadding, this.state.breakpoint),
            onLayoutChange: this.onLayoutChange,
            layout: this.state.layout,
            cols: this.state.cols
        }));
    }
}
module.exports.default = $094261519ed013ae$var$ResponsiveReactGridLayout;
// This should only include propTypes needed in this code; RGL itself
// will do validation of the rest props passed to it.
$094261519ed013ae$var$_defineProperty($094261519ed013ae$var$ResponsiveReactGridLayout, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: $094261519ed013ae$var$_propTypes.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: $094261519ed013ae$var$_propTypes.default.object,
    allowOverlap: $094261519ed013ae$var$_propTypes.default.bool,
    // # of cols. This is a breakpoint -> cols map
    cols: $094261519ed013ae$var$_propTypes.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: $094261519ed013ae$var$_propTypes.default.oneOfType([
        $094261519ed013ae$var$_propTypes.default.array,
        $094261519ed013ae$var$_propTypes.default.object
    ]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: $094261519ed013ae$var$_propTypes.default.oneOfType([
        $094261519ed013ae$var$_propTypes.default.array,
        $094261519ed013ae$var$_propTypes.default.object
    ]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts (props /*: Props<>*/ , propName /*: string*/ ) {
        if ($094261519ed013ae$var$type(props[propName]) !== "[object Object]") throw new Error("Layout property must be an object. Received: " + $094261519ed013ae$var$type(props[propName]));
        Object.keys(props[propName]).forEach((key)=>{
            if (!(key in props.breakpoints)) throw new Error("Each key in layouts must align with a key in breakpoints.");
            (0, $koqIv.validateLayout)(props.layouts[key], "layouts." + key);
        });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: $094261519ed013ae$var$_propTypes.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: $094261519ed013ae$var$_propTypes.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: $094261519ed013ae$var$_propTypes.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: $094261519ed013ae$var$_propTypes.default.func
});
$094261519ed013ae$var$_defineProperty($094261519ed013ae$var$ResponsiveReactGridLayout, "defaultProps", {
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    },
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    containerPadding: {
        lg: null,
        md: null,
        sm: null,
        xs: null,
        xxs: null
    },
    layouts: {},
    margin: [
        10,
        10
    ],
    allowOverlap: false,
    onBreakpointChange: $koqIv.noop,
    onLayoutChange: $koqIv.noop,
    onWidthChange: $koqIv.noop
});

});
parcelRegister("jCBCS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findOrGenerateResponsiveLayout = $e48ec0af593c1448$var$findOrGenerateResponsiveLayout;
module.exports.getBreakpointFromWidth = $e48ec0af593c1448$var$getBreakpointFromWidth;
module.exports.getColsFromBreakpoint = $e48ec0af593c1448$var$getColsFromBreakpoint;
module.exports.sortBreakpoints = $e48ec0af593c1448$var$sortBreakpoints;

var $koqIv = parcelRequire("koqIv");
/*:: import type { CompactType, Layout } from "./utils";*/ /*:: export type Breakpoint = string;*/ /*:: export type DefaultBreakpoints = "lg" | "md" | "sm" | "xs" | "xxs";*/ /*:: export type ResponsiveLayout<T: Breakpoint> = {
  +[breakpoint: T]: Layout
};*/ // + indicates read-only
/*:: export type Breakpoints<T: Breakpoint> = {
  +[breakpoint: T]: number
};*/ /*:: export type OnLayoutChangeCallback = (
  Layout,
  { [key: Breakpoint]: Layout }
) => void;*/ /**
 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
 *
 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
 * @param  {Number} width Screen width.
 * @return {String}       Highest breakpoint that is less than width.
 */ function $e48ec0af593c1448$var$getBreakpointFromWidth(breakpoints /*: Breakpoints<Breakpoint>*/ , width /*: number*/ ) /*: Breakpoint*/ {
    const sorted = $e48ec0af593c1448$var$sortBreakpoints(breakpoints);
    let matching = sorted[0];
    for(let i = 1, len = sorted.length; i < len; i++){
        const breakpointName = sorted[i];
        if (width > breakpoints[breakpointName]) matching = breakpointName;
    }
    return matching;
}
/**
 * Given a breakpoint, get the # of cols set for it.
 * @param  {String} breakpoint Breakpoint name.
 * @param  {Object} cols       Map of breakpoints to cols.
 * @return {Number}            Number of cols.
 */ function $e48ec0af593c1448$var$getColsFromBreakpoint(breakpoint /*: Breakpoint*/ , cols /*: Breakpoints<Breakpoint>*/ ) /*: number*/ {
    if (!cols[breakpoint]) throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
    return cols[breakpoint];
}
/**
 * Given existing layouts and a new breakpoint, find or generate a new layout.
 *
 * This finds the layout above the new one and generates from it, if it exists.
 *
 * @param  {Object} layouts     Existing layouts.
 * @param  {Array} breakpoints All breakpoints.
 * @param  {String} breakpoint New breakpoint.
 * @param  {String} breakpoint Last breakpoint (for fallback).
 * @param  {Number} cols       Column count at new breakpoint.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}             New layout.
 */ function $e48ec0af593c1448$var$findOrGenerateResponsiveLayout(layouts /*: ResponsiveLayout<Breakpoint>*/ , breakpoints /*: Breakpoints<Breakpoint>*/ , breakpoint /*: Breakpoint*/ , lastBreakpoint /*: Breakpoint*/ , cols /*: number*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    // If it already exists, just return it.
    if (layouts[breakpoint]) return (0, $koqIv.cloneLayout)(layouts[breakpoint]);
    // Find or generate the next layout
    let layout = layouts[lastBreakpoint];
    const breakpointsSorted = $e48ec0af593c1448$var$sortBreakpoints(breakpoints);
    const breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
    for(let i = 0, len = breakpointsAbove.length; i < len; i++){
        const b = breakpointsAbove[i];
        if (layouts[b]) {
            layout = layouts[b];
            break;
        }
    }
    layout = (0, $koqIv.cloneLayout)(layout || []); // clone layout so we don't modify existing items
    return (0, $koqIv.compact)((0, $koqIv.correctBounds)(layout, {
        cols: cols
    }), compactType, cols);
}
/**
 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
 * e.g. ['xxs', 'xs', 'sm', ...]
 *
 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
 * @return {Array}              Sorted breakpoints.
 */ function $e48ec0af593c1448$var$sortBreakpoints(breakpoints /*: Breakpoints<Breakpoint>*/ ) /*: Array<Breakpoint>*/ {
    const keys /*: Array<string>*/  = Object.keys(breakpoints);
    return keys.sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
}

});


parcelRegister("7Fvrs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5954c075180d93ce$var$WidthProvideRGL;

var $5954c075180d93ce$var$React = $5954c075180d93ce$var$_interopRequireWildcard((parcelRequire("exYeM")));

var $5954c075180d93ce$var$_propTypes = $5954c075180d93ce$var$_interopRequireDefault((parcelRequire("bisEj")));

var $5954c075180d93ce$var$_resizeObserverPolyfill = $5954c075180d93ce$var$_interopRequireDefault((parcelRequire("c5QNC")));

var $5954c075180d93ce$var$_clsx = $5954c075180d93ce$var$_interopRequireDefault((parcelRequire("4qr5a")));
function $5954c075180d93ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5954c075180d93ce$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5954c075180d93ce$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $5954c075180d93ce$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $5954c075180d93ce$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $5954c075180d93ce$var$_extends() {
    $5954c075180d93ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5954c075180d93ce$var$_extends.apply(this, arguments);
}
function $5954c075180d93ce$var$_defineProperty(obj, key, value) {
    key = $5954c075180d93ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5954c075180d93ce$var$_toPropertyKey(arg) {
    var key = $5954c075180d93ce$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5954c075180d93ce$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type { ReactRef } from "../ReactGridLayoutPropTypes";*/ /*:: type WPDefaultProps = {|
  measureBeforeMount: boolean
|};*/ /*:: type WPProps = {|
  className?: string,
  style?: Object,
  ...WPDefaultProps
|};*/ // eslint-disable-next-line no-unused-vars
/*:: type WPState = {|
  width: number
|};*/ /*:: type ComposedProps<Config> = {|
  ...Config,
  measureBeforeMount?: boolean,
  className?: string,
  style?: Object,
  width?: number
|};*/ const $5954c075180d93ce$var$layoutClassName = "react-grid-layout";
/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */ function $5954c075180d93ce$var$WidthProvideRGL(ComposedComponent /*: React.AbstractComponent<Config>*/ ) /*: React.AbstractComponent<ComposedProps<Config>>*/ {
    var _class;
    return _class = class WidthProvider extends $5954c075180d93ce$var$React.Component {
        constructor(){
            super(...arguments);
            $5954c075180d93ce$var$_defineProperty(this, "state", {
                width: 1280
            });
            $5954c075180d93ce$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $5954c075180d93ce$var$React.createRef());
            $5954c075180d93ce$var$_defineProperty(this, "mounted", false);
            $5954c075180d93ce$var$_defineProperty(this, "resizeObserver", void 0);
        }
        componentDidMount() {
            this.mounted = true;
            this.resizeObserver = new $5954c075180d93ce$var$_resizeObserverPolyfill.default((entries)=>{
                const node = this.elementRef.current;
                if (node instanceof HTMLElement) {
                    const width = entries[0].contentRect.width;
                    this.setState({
                        width: width
                    });
                }
            });
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.observe(node);
        }
        componentWillUnmount() {
            this.mounted = false;
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.unobserve(node);
            this.resizeObserver.disconnect();
        }
        render() {
            const { measureBeforeMount: measureBeforeMount, ...rest } = this.props;
            if (measureBeforeMount && !this.mounted) return /*#__PURE__*/ $5954c075180d93ce$var$React.createElement("div", {
                className: (0, $5954c075180d93ce$var$_clsx.default)(this.props.className, $5954c075180d93ce$var$layoutClassName),
                style: this.props.style,
                ref: this.elementRef
            });
            return /*#__PURE__*/ $5954c075180d93ce$var$React.createElement(ComposedComponent, $5954c075180d93ce$var$_extends({
                innerRef: this.elementRef
            }, rest, this.state));
        }
    }, $5954c075180d93ce$var$_defineProperty(_class, "defaultProps", {
        measureBeforeMount: false
    }), $5954c075180d93ce$var$_defineProperty(_class, "propTypes", {
        // If true, will not render children until mounted. Useful for getting the exact width before
        // rendering, to prevent any unsightly resizing.
        measureBeforeMount: $5954c075180d93ce$var$_propTypes.default.bool
    }), _class;
}

});
parcelRegister("c5QNC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8cdee88549d6396f$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $8cdee88549d6396f$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $8cdee88549d6396f$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $8cdee88549d6396f$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $8cdee88549d6396f$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($8cdee88549d6396f$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $8cdee88549d6396f$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $8cdee88549d6396f$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $8cdee88549d6396f$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $8cdee88549d6396f$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $8cdee88549d6396f$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $8cdee88549d6396f$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $8cdee88549d6396f$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $8cdee88549d6396f$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $8cdee88549d6396f$var$throttle(this.refresh.bind(this), $8cdee88549d6396f$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$8cdee88549d6396f$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($8cdee88549d6396f$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$8cdee88549d6396f$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $8cdee88549d6396f$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $8cdee88549d6396f$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $8cdee88549d6396f$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $8cdee88549d6396f$var$global$1;
};
// Placeholder of an empty content rectangle.
var $8cdee88549d6396f$var$emptyRect = $8cdee88549d6396f$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $8cdee88549d6396f$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $8cdee88549d6396f$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $8cdee88549d6396f$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $8cdee88549d6396f$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $8cdee88549d6396f$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $8cdee88549d6396f$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $8cdee88549d6396f$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $8cdee88549d6396f$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $8cdee88549d6396f$var$emptyRect;
    var styles = $8cdee88549d6396f$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $8cdee88549d6396f$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $8cdee88549d6396f$var$toFloat(styles.width), height = $8cdee88549d6396f$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $8cdee88549d6396f$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $8cdee88549d6396f$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$8cdee88549d6396f$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $8cdee88549d6396f$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $8cdee88549d6396f$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $8cdee88549d6396f$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $8cdee88549d6396f$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $8cdee88549d6396f$var$isDocumentElement(target) {
    return target === $8cdee88549d6396f$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $8cdee88549d6396f$var$getContentRect(target) {
    if (!$8cdee88549d6396f$var$isBrowser) return $8cdee88549d6396f$var$emptyRect;
    if ($8cdee88549d6396f$var$isSVGGraphicsElement(target)) return $8cdee88549d6396f$var$getSVGContentRect(target);
    return $8cdee88549d6396f$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $8cdee88549d6396f$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $8cdee88549d6396f$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $8cdee88549d6396f$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $8cdee88549d6396f$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $8cdee88549d6396f$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $8cdee88549d6396f$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $8cdee88549d6396f$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $8cdee88549d6396f$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $8cdee88549d6396f$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $8cdee88549d6396f$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $8cdee88549d6396f$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $8cdee88549d6396f$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $8cdee88549d6396f$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $8cdee88549d6396f$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $8cdee88549d6396f$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $8cdee88549d6396f$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $8cdee88549d6396f$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $8cdee88549d6396f$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $8cdee88549d6396f$var$ResizeObserverController.getInstance();
        var observer = new $8cdee88549d6396f$var$ResizeObserverSPI(callback, controller, this);
        $8cdee88549d6396f$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $8cdee88549d6396f$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $8cdee88549d6396f$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $8cdee88549d6396f$var$index = function() {
    // Export existing implementation if available.
    if (typeof $8cdee88549d6396f$var$global$1.ResizeObserver !== "undefined") return $8cdee88549d6396f$var$global$1.ResizeObserver;
    return $8cdee88549d6396f$var$ResizeObserver;
}();
var $8cdee88549d6396f$export$2e2bcd8739ae039 = $8cdee88549d6396f$var$index;

});


parcelRegister("1wVs5", function(module, exports) {
"use strict";

});

parcelRegister("5LzvA", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $432ce2c97be196b5$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $432ce2c97be196b5$var$MAX_UINT32 = 4294967295;
function $432ce2c97be196b5$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $2iVwY = parcelRequire("2iVwY");
var $432ce2c97be196b5$require$Buffer = $2iVwY.Buffer;
var $432ce2c97be196b5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($432ce2c97be196b5$var$crypto && $432ce2c97be196b5$var$crypto.getRandomValues) module.exports = $432ce2c97be196b5$var$randomBytes;
else module.exports = $432ce2c97be196b5$var$oldBrowser;
function $432ce2c97be196b5$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $432ce2c97be196b5$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $432ce2c97be196b5$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $432ce2c97be196b5$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $432ce2c97be196b5$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $432ce2c97be196b5$var$crypto.getRandomValues(bytes.slice(generated, generated + $432ce2c97be196b5$var$MAX_BYTES));
        else $432ce2c97be196b5$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $6qd2L.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("2iVwY", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $3aNd6 = parcelRequire("3aNd6");
var $1ad9e3a3bba0ff2c$var$Buffer = $3aNd6.Buffer;
// alternative to using Object.keys for old browsers
function $1ad9e3a3bba0ff2c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1ad9e3a3bba0ff2c$var$Buffer.from && $1ad9e3a3bba0ff2c$var$Buffer.alloc && $1ad9e3a3bba0ff2c$var$Buffer.allocUnsafe && $1ad9e3a3bba0ff2c$var$Buffer.allocUnsafeSlow) module.exports = $3aNd6;
else {
    // Copy properties from require('buffer')
    $1ad9e3a3bba0ff2c$var$copyProps($3aNd6, module.exports);
    module.exports.Buffer = $1ad9e3a3bba0ff2c$var$SafeBuffer;
}
function $1ad9e3a3bba0ff2c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1ad9e3a3bba0ff2c$var$Buffer(arg, encodingOrOffset, length);
}
$1ad9e3a3bba0ff2c$var$SafeBuffer.prototype = Object.create($1ad9e3a3bba0ff2c$var$Buffer.prototype);
// Copy static methods from Buffer
$1ad9e3a3bba0ff2c$var$copyProps($1ad9e3a3bba0ff2c$var$Buffer, $1ad9e3a3bba0ff2c$var$SafeBuffer);
$1ad9e3a3bba0ff2c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1ad9e3a3bba0ff2c$var$Buffer(arg, encodingOrOffset, length);
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1ad9e3a3bba0ff2c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1ad9e3a3bba0ff2c$var$Buffer(size);
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $3aNd6.SlowBuffer(size);
};

});
parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a; }, function (v) { return $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $24f87a6f86a8996f$export$599f31c3813fae4d; }, function (v) { return $24f87a6f86a8996f$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
var $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
var $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    var buf = $24f87a6f86a8996f$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    var buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        var len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        var buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $24f87a6f86a8996f$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("3YkjF", function(module, exports) {
"use strict";

var $9M38k = parcelRequire("9M38k");

var $lcOGj = parcelRequire("lcOGj");

var $5rZkB = parcelRequire("5rZkB");

var $dyOkR = parcelRequire("dyOkR");

var $7J5an = parcelRequire("7J5an");
function $2e46bc157f22bc9c$var$Hash(hash) {
    $7J5an.call(this, "digest");
    this._hash = hash;
}
$9M38k($2e46bc157f22bc9c$var$Hash, $7J5an);
$2e46bc157f22bc9c$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$2e46bc157f22bc9c$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $lcOGj();
    if (alg === "rmd160" || alg === "ripemd160") return new $5rZkB();
    return new $2e46bc157f22bc9c$var$Hash($dyOkR(alg));
};

});
parcelRegister("9M38k", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("lcOGj", function(module, exports) {
"use strict";

var $9M38k = parcelRequire("9M38k");

var $9dLwd = parcelRequire("9dLwd");

var $2iVwY = parcelRequire("2iVwY");
var $f702083ccc12df34$require$Buffer = $2iVwY.Buffer;
var $f702083ccc12df34$var$ARRAY16 = new Array(16);
function $f702083ccc12df34$var$MD5() {
    $9dLwd.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$9M38k($f702083ccc12df34$var$MD5, $9dLwd);
$f702083ccc12df34$var$MD5.prototype._update = function() {
    var M = $f702083ccc12df34$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f702083ccc12df34$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f702083ccc12df34$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f702083ccc12df34$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f702083ccc12df34$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f702083ccc12df34$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f702083ccc12df34$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f702083ccc12df34$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f702083ccc12df34$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f702083ccc12df34$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f702083ccc12df34$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f702083ccc12df34$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f702083ccc12df34$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f702083ccc12df34$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f702083ccc12df34$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f702083ccc12df34$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f702083ccc12df34$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f702083ccc12df34$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f702083ccc12df34$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f702083ccc12df34$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f702083ccc12df34$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f702083ccc12df34$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f702083ccc12df34$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f702083ccc12df34$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f702083ccc12df34$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f702083ccc12df34$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f702083ccc12df34$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f702083ccc12df34$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f702083ccc12df34$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f702083ccc12df34$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f702083ccc12df34$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f702083ccc12df34$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f702083ccc12df34$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f702083ccc12df34$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f702083ccc12df34$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f702083ccc12df34$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f702083ccc12df34$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f702083ccc12df34$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f702083ccc12df34$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f702083ccc12df34$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f702083ccc12df34$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f702083ccc12df34$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f702083ccc12df34$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f702083ccc12df34$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f702083ccc12df34$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f702083ccc12df34$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f702083ccc12df34$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f702083ccc12df34$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f702083ccc12df34$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f702083ccc12df34$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f702083ccc12df34$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f702083ccc12df34$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f702083ccc12df34$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f702083ccc12df34$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f702083ccc12df34$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f702083ccc12df34$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f702083ccc12df34$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f702083ccc12df34$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f702083ccc12df34$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f702083ccc12df34$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f702083ccc12df34$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f702083ccc12df34$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f702083ccc12df34$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f702083ccc12df34$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f702083ccc12df34$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f702083ccc12df34$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f702083ccc12df34$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f702083ccc12df34$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f702083ccc12df34$var$fnF(a, b, c, d, m, k, s) {
    return $f702083ccc12df34$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f702083ccc12df34$var$fnG(a, b, c, d, m, k, s) {
    return $f702083ccc12df34$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f702083ccc12df34$var$fnH(a, b, c, d, m, k, s) {
    return $f702083ccc12df34$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f702083ccc12df34$var$fnI(a, b, c, d, m, k, s) {
    return $f702083ccc12df34$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f702083ccc12df34$var$MD5;

});
parcelRegister("9dLwd", function(module, exports) {
"use strict";

var $2iVwY = parcelRequire("2iVwY");
var $6b6a302b0674114c$require$Buffer = $2iVwY.Buffer;

var $ltxkj = parcelRequire("ltxkj");
var $6b6a302b0674114c$require$Transform = $ltxkj.Transform;

var $9M38k = parcelRequire("9M38k");
function $6b6a302b0674114c$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$6b6a302b0674114c$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $6b6a302b0674114c$var$HashBase(blockSize) {
    $6b6a302b0674114c$require$Transform.call(this);
    this._block = $6b6a302b0674114c$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$9M38k($6b6a302b0674114c$var$HashBase, $6b6a302b0674114c$require$Transform);
$6b6a302b0674114c$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6b6a302b0674114c$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6b6a302b0674114c$var$HashBase.prototype.update = function(data, encoding) {
    $6b6a302b0674114c$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$6b6a302b0674114c$require$Buffer.isBuffer(data)) data = $6b6a302b0674114c$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$6b6a302b0674114c$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$6b6a302b0674114c$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$6b6a302b0674114c$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $6b6a302b0674114c$var$HashBase;

});
parcelRegister("ltxkj", function(module, exports) {

exports = module.exports = (parcelRequire("fTX3U"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("kYljA"));

exports.Duplex = (parcelRequire("9ODku"));

exports.Transform = (parcelRequire("aurW9"));

exports.PassThrough = (parcelRequire("aGOT9"));

exports.finished = (parcelRequire("jR9FH"));

exports.pipeline = (parcelRequire("6tlF8"));

});
parcelRegister("fTX3U", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6qd2L = parcelRequire("6qd2L");
"use strict";
module.exports = $b939ce8bc6ca2d01$var$Readable;
/*<replacement>*/ var $b939ce8bc6ca2d01$var$Duplex;
/*</replacement>*/ $b939ce8bc6ca2d01$var$Readable.ReadableState = $b939ce8bc6ca2d01$var$ReadableState;

var $dG33B = parcelRequire("dG33B");
var $b939ce8bc6ca2d01$require$EE = $dG33B.EventEmitter;
var $b939ce8bc6ca2d01$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $igIdM = parcelRequire("igIdM");

var $3aNd6 = parcelRequire("3aNd6");
var $b939ce8bc6ca2d01$require$Buffer = $3aNd6.Buffer;
var $b939ce8bc6ca2d01$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $b939ce8bc6ca2d01$var$_uint8ArrayToBuffer(chunk) {
    return $b939ce8bc6ca2d01$require$Buffer.from(chunk);
}
function $b939ce8bc6ca2d01$var$_isUint8Array(obj) {
    return $b939ce8bc6ca2d01$require$Buffer.isBuffer(obj) || obj instanceof $b939ce8bc6ca2d01$var$OurUint8Array;
}

var $1wVs5 = parcelRequire("1wVs5");
var $b939ce8bc6ca2d01$var$debug;
if ($1wVs5 && $1wVs5.debuglog) $b939ce8bc6ca2d01$var$debug = $1wVs5.debuglog("stream");
else $b939ce8bc6ca2d01$var$debug = function debug() {};

var $sBkSV = parcelRequire("sBkSV");

var $g0P9t = parcelRequire("g0P9t");

var $dpXeK = parcelRequire("dpXeK");
var $b939ce8bc6ca2d01$var$getHighWaterMark = $dpXeK.getHighWaterMark;

var $bVf07 = parcelRequire("bVf07");
var $b939ce8bc6ca2d01$require$_require$codes = $bVf07.codes;
var $b939ce8bc6ca2d01$var$ERR_INVALID_ARG_TYPE = $b939ce8bc6ca2d01$require$_require$codes.ERR_INVALID_ARG_TYPE, $b939ce8bc6ca2d01$var$ERR_STREAM_PUSH_AFTER_EOF = $b939ce8bc6ca2d01$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $b939ce8bc6ca2d01$var$ERR_METHOD_NOT_IMPLEMENTED = $b939ce8bc6ca2d01$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $b939ce8bc6ca2d01$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $b939ce8bc6ca2d01$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $b939ce8bc6ca2d01$var$StringDecoder;
var $b939ce8bc6ca2d01$var$createReadableStreamAsyncIterator;
var $b939ce8bc6ca2d01$var$from;

(parcelRequire("9M38k"))($b939ce8bc6ca2d01$var$Readable, $igIdM);
var $b939ce8bc6ca2d01$var$errorOrDestroy = $g0P9t.errorOrDestroy;
var $b939ce8bc6ca2d01$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $b939ce8bc6ca2d01$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $b939ce8bc6ca2d01$var$ReadableState(options, stream, isDuplex) {
    $b939ce8bc6ca2d01$var$Duplex = $b939ce8bc6ca2d01$var$Duplex || (parcelRequire("9ODku"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $b939ce8bc6ca2d01$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $b939ce8bc6ca2d01$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $sBkSV();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$b939ce8bc6ca2d01$var$StringDecoder) $b939ce8bc6ca2d01$var$StringDecoder = (parcelRequire("g6ehz")).StringDecoder;
        this.decoder = new $b939ce8bc6ca2d01$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $b939ce8bc6ca2d01$var$Readable(options) {
    $b939ce8bc6ca2d01$var$Duplex = $b939ce8bc6ca2d01$var$Duplex || (parcelRequire("9ODku"));
    if (!(this instanceof $b939ce8bc6ca2d01$var$Readable)) return new $b939ce8bc6ca2d01$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $b939ce8bc6ca2d01$var$Duplex;
    this._readableState = new $b939ce8bc6ca2d01$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $igIdM.call(this);
}
Object.defineProperty($b939ce8bc6ca2d01$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$b939ce8bc6ca2d01$var$Readable.prototype.destroy = $g0P9t.destroy;
$b939ce8bc6ca2d01$var$Readable.prototype._undestroy = $g0P9t.undestroy;
$b939ce8bc6ca2d01$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$b939ce8bc6ca2d01$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $b939ce8bc6ca2d01$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $b939ce8bc6ca2d01$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$b939ce8bc6ca2d01$var$Readable.prototype.unshift = function(chunk) {
    return $b939ce8bc6ca2d01$var$readableAddChunk(this, chunk, null, true, false);
};
function $b939ce8bc6ca2d01$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $b939ce8bc6ca2d01$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $b939ce8bc6ca2d01$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $b939ce8bc6ca2d01$var$chunkInvalid(state, chunk);
        if (er) $b939ce8bc6ca2d01$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $b939ce8bc6ca2d01$require$Buffer.prototype) chunk = $b939ce8bc6ca2d01$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $b939ce8bc6ca2d01$var$errorOrDestroy(stream, new $b939ce8bc6ca2d01$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $b939ce8bc6ca2d01$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $b939ce8bc6ca2d01$var$errorOrDestroy(stream, new $b939ce8bc6ca2d01$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $b939ce8bc6ca2d01$var$addChunk(stream, state, chunk, false);
                    else $b939ce8bc6ca2d01$var$maybeReadMore(stream, state);
                } else $b939ce8bc6ca2d01$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $b939ce8bc6ca2d01$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $b939ce8bc6ca2d01$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $b939ce8bc6ca2d01$var$emitReadable(stream);
    }
    $b939ce8bc6ca2d01$var$maybeReadMore(stream, state);
}
function $b939ce8bc6ca2d01$var$chunkInvalid(state, chunk) {
    var er;
    if (!$b939ce8bc6ca2d01$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $b939ce8bc6ca2d01$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$b939ce8bc6ca2d01$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$b939ce8bc6ca2d01$var$Readable.prototype.setEncoding = function(enc) {
    if (!$b939ce8bc6ca2d01$var$StringDecoder) $b939ce8bc6ca2d01$var$StringDecoder = (parcelRequire("g6ehz")).StringDecoder;
    var decoder = new $b939ce8bc6ca2d01$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $b939ce8bc6ca2d01$var$MAX_HWM = 0x40000000;
function $b939ce8bc6ca2d01$var$computeNewHighWaterMark(n) {
    if (n >= $b939ce8bc6ca2d01$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $b939ce8bc6ca2d01$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $b939ce8bc6ca2d01$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $b939ce8bc6ca2d01$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$b939ce8bc6ca2d01$var$Readable.prototype.read = function(n) {
    $b939ce8bc6ca2d01$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $b939ce8bc6ca2d01$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $b939ce8bc6ca2d01$var$endReadable(this);
        else $b939ce8bc6ca2d01$var$emitReadable(this);
        return null;
    }
    n = $b939ce8bc6ca2d01$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $b939ce8bc6ca2d01$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $b939ce8bc6ca2d01$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $b939ce8bc6ca2d01$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $b939ce8bc6ca2d01$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $b939ce8bc6ca2d01$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $b939ce8bc6ca2d01$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $b939ce8bc6ca2d01$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $b939ce8bc6ca2d01$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $b939ce8bc6ca2d01$var$onEofChunk(stream, state) {
    $b939ce8bc6ca2d01$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $b939ce8bc6ca2d01$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $b939ce8bc6ca2d01$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $b939ce8bc6ca2d01$var$emitReadable(stream) {
    var state = stream._readableState;
    $b939ce8bc6ca2d01$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $b939ce8bc6ca2d01$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $6qd2L.nextTick($b939ce8bc6ca2d01$var$emitReadable_, stream);
    }
}
function $b939ce8bc6ca2d01$var$emitReadable_(stream) {
    var state = stream._readableState;
    $b939ce8bc6ca2d01$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $b939ce8bc6ca2d01$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $b939ce8bc6ca2d01$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $6qd2L.nextTick($b939ce8bc6ca2d01$var$maybeReadMore_, stream, state);
    }
}
function $b939ce8bc6ca2d01$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $b939ce8bc6ca2d01$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$b939ce8bc6ca2d01$var$Readable.prototype._read = function(n) {
    $b939ce8bc6ca2d01$var$errorOrDestroy(this, new $b939ce8bc6ca2d01$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$b939ce8bc6ca2d01$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $b939ce8bc6ca2d01$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6qd2L.stdout && dest !== $6qd2L.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $6qd2L.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $b939ce8bc6ca2d01$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $b939ce8bc6ca2d01$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $b939ce8bc6ca2d01$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $b939ce8bc6ca2d01$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $b939ce8bc6ca2d01$var$debug("ondata");
        var ret = dest.write(chunk);
        $b939ce8bc6ca2d01$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $b939ce8bc6ca2d01$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $b939ce8bc6ca2d01$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $b939ce8bc6ca2d01$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($b939ce8bc6ca2d01$var$EElistenerCount(dest, "error") === 0) $b939ce8bc6ca2d01$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $b939ce8bc6ca2d01$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $b939ce8bc6ca2d01$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $b939ce8bc6ca2d01$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $b939ce8bc6ca2d01$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $b939ce8bc6ca2d01$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $b939ce8bc6ca2d01$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $b939ce8bc6ca2d01$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $b939ce8bc6ca2d01$var$flow(src);
        }
    };
}
$b939ce8bc6ca2d01$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $b939ce8bc6ca2d01$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$b939ce8bc6ca2d01$var$Readable.prototype.on = function(ev, fn) {
    var res = $igIdM.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $b939ce8bc6ca2d01$var$debug("on readable", state.length, state.reading);
            if (state.length) $b939ce8bc6ca2d01$var$emitReadable(this);
            else if (!state.reading) $6qd2L.nextTick($b939ce8bc6ca2d01$var$nReadingNextTick, this);
        }
    }
    return res;
};
$b939ce8bc6ca2d01$var$Readable.prototype.addListener = $b939ce8bc6ca2d01$var$Readable.prototype.on;
$b939ce8bc6ca2d01$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $igIdM.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6qd2L.nextTick($b939ce8bc6ca2d01$var$updateReadableListening, this);
    return res;
};
$b939ce8bc6ca2d01$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $igIdM.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6qd2L.nextTick($b939ce8bc6ca2d01$var$updateReadableListening, this);
    return res;
};
function $b939ce8bc6ca2d01$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $b939ce8bc6ca2d01$var$nReadingNextTick(self1) {
    $b939ce8bc6ca2d01$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$b939ce8bc6ca2d01$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $b939ce8bc6ca2d01$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $b939ce8bc6ca2d01$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $b939ce8bc6ca2d01$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $6qd2L.nextTick($b939ce8bc6ca2d01$var$resume_, stream, state);
    }
}
function $b939ce8bc6ca2d01$var$resume_(stream, state) {
    $b939ce8bc6ca2d01$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $b939ce8bc6ca2d01$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$b939ce8bc6ca2d01$var$Readable.prototype.pause = function() {
    $b939ce8bc6ca2d01$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $b939ce8bc6ca2d01$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $b939ce8bc6ca2d01$var$flow(stream) {
    var state = stream._readableState;
    $b939ce8bc6ca2d01$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$b939ce8bc6ca2d01$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $b939ce8bc6ca2d01$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $b939ce8bc6ca2d01$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $b939ce8bc6ca2d01$var$kProxyEvents.length; n++)stream.on($b939ce8bc6ca2d01$var$kProxyEvents[n], this.emit.bind(this, $b939ce8bc6ca2d01$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $b939ce8bc6ca2d01$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $b939ce8bc6ca2d01$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($b939ce8bc6ca2d01$var$createReadableStreamAsyncIterator === undefined) $b939ce8bc6ca2d01$var$createReadableStreamAsyncIterator = (parcelRequire("jw1Sa"));
    return $b939ce8bc6ca2d01$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($b939ce8bc6ca2d01$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($b939ce8bc6ca2d01$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($b939ce8bc6ca2d01$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$b939ce8bc6ca2d01$var$Readable._fromList = $b939ce8bc6ca2d01$var$fromList;
Object.defineProperty($b939ce8bc6ca2d01$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $b939ce8bc6ca2d01$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $b939ce8bc6ca2d01$var$endReadable(stream) {
    var state = stream._readableState;
    $b939ce8bc6ca2d01$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $6qd2L.nextTick($b939ce8bc6ca2d01$var$endReadableNT, state, stream);
    }
}
function $b939ce8bc6ca2d01$var$endReadableNT(state, stream) {
    $b939ce8bc6ca2d01$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $b939ce8bc6ca2d01$var$Readable.from = function(iterable, opts) {
    if ($b939ce8bc6ca2d01$var$from === undefined) $b939ce8bc6ca2d01$var$from = (parcelRequire("HH1jY"));
    return $b939ce8bc6ca2d01$var$from($b939ce8bc6ca2d01$var$Readable, iterable, opts);
};
function $b939ce8bc6ca2d01$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("dG33B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $9f5191ad6e142a03$var$R = typeof Reflect === "object" ? Reflect : null;
var $9f5191ad6e142a03$var$ReflectApply = $9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.apply === "function" ? $9f5191ad6e142a03$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9f5191ad6e142a03$var$ReflectOwnKeys;
if ($9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.ownKeys === "function") $9f5191ad6e142a03$var$ReflectOwnKeys = $9f5191ad6e142a03$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9f5191ad6e142a03$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9f5191ad6e142a03$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9f5191ad6e142a03$var$EventEmitter() {
    $9f5191ad6e142a03$var$EventEmitter.init.call(this);
}
module.exports = $9f5191ad6e142a03$var$EventEmitter;
module.exports.once = $9f5191ad6e142a03$var$once;
// Backwards-compat with node 0.10.x
$9f5191ad6e142a03$var$EventEmitter.EventEmitter = $9f5191ad6e142a03$var$EventEmitter;
$9f5191ad6e142a03$var$EventEmitter.prototype._events = undefined;
$9f5191ad6e142a03$var$EventEmitter.prototype._eventsCount = 0;
$9f5191ad6e142a03$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9f5191ad6e142a03$var$defaultMaxListeners = 10;
function $9f5191ad6e142a03$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($9f5191ad6e142a03$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $9f5191ad6e142a03$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $9f5191ad6e142a03$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $9f5191ad6e142a03$var$defaultMaxListeners = arg;
    }
});
$9f5191ad6e142a03$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9f5191ad6e142a03$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $9f5191ad6e142a03$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $9f5191ad6e142a03$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9f5191ad6e142a03$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9f5191ad6e142a03$var$_getMaxListeners(this);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $9f5191ad6e142a03$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9f5191ad6e142a03$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9f5191ad6e142a03$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9f5191ad6e142a03$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9f5191ad6e142a03$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9f5191ad6e142a03$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, false);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.on = $9f5191ad6e142a03$var$EventEmitter.prototype.addListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, true);
};
function $9f5191ad6e142a03$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9f5191ad6e142a03$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9f5191ad6e142a03$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.once = function once(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.on(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.prependListener(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9f5191ad6e142a03$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9f5191ad6e142a03$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.off = $9f5191ad6e142a03$var$EventEmitter.prototype.removeListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9f5191ad6e142a03$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9f5191ad6e142a03$var$unwrapListeners(evlistener) : $9f5191ad6e142a03$var$arrayClone(evlistener, evlistener.length);
}
$9f5191ad6e142a03$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, true);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, false);
};
$9f5191ad6e142a03$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $9f5191ad6e142a03$var$listenerCount.call(emitter, type);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.listenerCount = $9f5191ad6e142a03$var$listenerCount;
function $9f5191ad6e142a03$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9f5191ad6e142a03$var$ReflectOwnKeys(this._events) : [];
};
function $9f5191ad6e142a03$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9f5191ad6e142a03$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9f5191ad6e142a03$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9f5191ad6e142a03$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("igIdM", function(module, exports) {

module.exports = (parcelRequire("dG33B")).EventEmitter;

});

parcelRegister("sBkSV", function(module, exports) {
"use strict";
function $055f93c320144819$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $055f93c320144819$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $055f93c320144819$var$ownKeys(Object(source), !0).forEach(function(key) {
            $055f93c320144819$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $055f93c320144819$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $055f93c320144819$var$_defineProperty(obj, key, value) {
    key = $055f93c320144819$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $055f93c320144819$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $055f93c320144819$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $055f93c320144819$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $055f93c320144819$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $055f93c320144819$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $055f93c320144819$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $055f93c320144819$var$_toPropertyKey(arg) {
    var key = $055f93c320144819$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $055f93c320144819$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $3aNd6 = parcelRequire("3aNd6");
var $055f93c320144819$var$Buffer = $3aNd6.Buffer;

var $1wVs5 = parcelRequire("1wVs5");
var $055f93c320144819$var$inspect = $1wVs5.inspect;
var $055f93c320144819$var$custom = $055f93c320144819$var$inspect && $055f93c320144819$var$inspect.custom || "inspect";
function $055f93c320144819$var$copyBuffer(src, target, offset) {
    $055f93c320144819$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $055f93c320144819$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $055f93c320144819$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $055f93c320144819$var$Buffer.alloc(0);
                var ret = $055f93c320144819$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $055f93c320144819$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $055f93c320144819$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $055f93c320144819$var$custom,
            value: function value(_, options) {
                return $055f93c320144819$var$inspect(this, $055f93c320144819$var$_objectSpread($055f93c320144819$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("g0P9t", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $ba84531f4ccf27bc$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $6qd2L.nextTick($ba84531f4ccf27bc$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $6qd2L.nextTick($ba84531f4ccf27bc$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $6qd2L.nextTick($ba84531f4ccf27bc$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $6qd2L.nextTick($ba84531f4ccf27bc$var$emitErrorAndCloseNT, _this, err);
            } else $6qd2L.nextTick($ba84531f4ccf27bc$var$emitCloseNT, _this);
        } else if (cb) {
            $6qd2L.nextTick($ba84531f4ccf27bc$var$emitCloseNT, _this);
            cb(err);
        } else $6qd2L.nextTick($ba84531f4ccf27bc$var$emitCloseNT, _this);
    });
    return this;
}
function $ba84531f4ccf27bc$var$emitErrorAndCloseNT(self, err) {
    $ba84531f4ccf27bc$var$emitErrorNT(self, err);
    $ba84531f4ccf27bc$var$emitCloseNT(self);
}
function $ba84531f4ccf27bc$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $ba84531f4ccf27bc$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $ba84531f4ccf27bc$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $ba84531f4ccf27bc$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $ba84531f4ccf27bc$var$destroy,
    undestroy: $ba84531f4ccf27bc$var$undestroy,
    errorOrDestroy: $ba84531f4ccf27bc$var$errorOrDestroy
};

});

parcelRegister("dpXeK", function(module, exports) {
"use strict";

var $9c4b8f587c23c595$var$ERR_INVALID_OPT_VALUE = (parcelRequire("bVf07")).codes.ERR_INVALID_OPT_VALUE;
function $9c4b8f587c23c595$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $9c4b8f587c23c595$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $9c4b8f587c23c595$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $9c4b8f587c23c595$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $9c4b8f587c23c595$var$getHighWaterMark
};

});
parcelRegister("bVf07", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $8ae0a7780ceafce1$export$e45cb6485273080e; }, function (v) { return $8ae0a7780ceafce1$export$e45cb6485273080e = v; });
var $8ae0a7780ceafce1$export$e45cb6485273080e;
"use strict";
function $8ae0a7780ceafce1$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $8ae0a7780ceafce1$var$codes = {};
function $8ae0a7780ceafce1$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $8ae0a7780ceafce1$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $8ae0a7780ceafce1$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $8ae0a7780ceafce1$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $8ae0a7780ceafce1$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $8ae0a7780ceafce1$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $8ae0a7780ceafce1$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$8ae0a7780ceafce1$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$8ae0a7780ceafce1$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $8ae0a7780ceafce1$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($8ae0a7780ceafce1$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($8ae0a7780ceafce1$var$oneOf(expected, "type"));
    else {
        var type = $8ae0a7780ceafce1$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($8ae0a7780ceafce1$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$8ae0a7780ceafce1$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$8ae0a7780ceafce1$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$8ae0a7780ceafce1$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$8ae0a7780ceafce1$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$8ae0a7780ceafce1$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$8ae0a7780ceafce1$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$8ae0a7780ceafce1$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$8ae0a7780ceafce1$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$8ae0a7780ceafce1$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$8ae0a7780ceafce1$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$8ae0a7780ceafce1$export$e45cb6485273080e = $8ae0a7780ceafce1$var$codes;

});


parcelRegister("9ODku", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $6qd2L = parcelRequire("6qd2L");
"use strict";
/*<replacement>*/ var $72574a92b810775d$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $72574a92b810775d$var$Duplex;

var $fTX3U = parcelRequire("fTX3U");

var $kYljA = parcelRequire("kYljA");

(parcelRequire("9M38k"))($72574a92b810775d$var$Duplex, $fTX3U);
// Allow the keys array to be GC'ed.
var $72574a92b810775d$var$keys = $72574a92b810775d$var$objectKeys($kYljA.prototype);
for(var $72574a92b810775d$var$v = 0; $72574a92b810775d$var$v < $72574a92b810775d$var$keys.length; $72574a92b810775d$var$v++){
    var $72574a92b810775d$var$method = $72574a92b810775d$var$keys[$72574a92b810775d$var$v];
    if (!$72574a92b810775d$var$Duplex.prototype[$72574a92b810775d$var$method]) $72574a92b810775d$var$Duplex.prototype[$72574a92b810775d$var$method] = $kYljA.prototype[$72574a92b810775d$var$method];
}
function $72574a92b810775d$var$Duplex(options) {
    if (!(this instanceof $72574a92b810775d$var$Duplex)) return new $72574a92b810775d$var$Duplex(options);
    $fTX3U.call(this, options);
    $kYljA.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $72574a92b810775d$var$onend);
        }
    }
}
Object.defineProperty($72574a92b810775d$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($72574a92b810775d$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($72574a92b810775d$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $72574a92b810775d$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $6qd2L.nextTick($72574a92b810775d$var$onEndNT, this);
}
function $72574a92b810775d$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($72574a92b810775d$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("kYljA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $6qd2L = parcelRequire("6qd2L");
"use strict";
module.exports = $f449f1ece320c6d1$var$Writable;
/* <replacement> */ function $f449f1ece320c6d1$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $f449f1ece320c6d1$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $f449f1ece320c6d1$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $f449f1ece320c6d1$var$Duplex;
/*</replacement>*/ $f449f1ece320c6d1$var$Writable.WritableState = $f449f1ece320c6d1$var$WritableState;

/*<replacement>*/ var $f449f1ece320c6d1$var$internalUtil = {
    deprecate: (parcelRequire("3ZPxO"))
};

var $igIdM = parcelRequire("igIdM");

var $3aNd6 = parcelRequire("3aNd6");
var $f449f1ece320c6d1$require$Buffer = $3aNd6.Buffer;
var $f449f1ece320c6d1$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $f449f1ece320c6d1$var$_uint8ArrayToBuffer(chunk) {
    return $f449f1ece320c6d1$require$Buffer.from(chunk);
}
function $f449f1ece320c6d1$var$_isUint8Array(obj) {
    return $f449f1ece320c6d1$require$Buffer.isBuffer(obj) || obj instanceof $f449f1ece320c6d1$var$OurUint8Array;
}

var $g0P9t = parcelRequire("g0P9t");

var $dpXeK = parcelRequire("dpXeK");
var $f449f1ece320c6d1$var$getHighWaterMark = $dpXeK.getHighWaterMark;

var $bVf07 = parcelRequire("bVf07");
var $f449f1ece320c6d1$require$_require$codes = $bVf07.codes;
var $f449f1ece320c6d1$var$ERR_INVALID_ARG_TYPE = $f449f1ece320c6d1$require$_require$codes.ERR_INVALID_ARG_TYPE, $f449f1ece320c6d1$var$ERR_METHOD_NOT_IMPLEMENTED = $f449f1ece320c6d1$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f449f1ece320c6d1$var$ERR_MULTIPLE_CALLBACK = $f449f1ece320c6d1$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f449f1ece320c6d1$var$ERR_STREAM_CANNOT_PIPE = $f449f1ece320c6d1$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $f449f1ece320c6d1$var$ERR_STREAM_DESTROYED = $f449f1ece320c6d1$require$_require$codes.ERR_STREAM_DESTROYED, $f449f1ece320c6d1$var$ERR_STREAM_NULL_VALUES = $f449f1ece320c6d1$require$_require$codes.ERR_STREAM_NULL_VALUES, $f449f1ece320c6d1$var$ERR_STREAM_WRITE_AFTER_END = $f449f1ece320c6d1$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $f449f1ece320c6d1$var$ERR_UNKNOWN_ENCODING = $f449f1ece320c6d1$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $f449f1ece320c6d1$var$errorOrDestroy = $g0P9t.errorOrDestroy;

(parcelRequire("9M38k"))($f449f1ece320c6d1$var$Writable, $igIdM);
function $f449f1ece320c6d1$var$nop() {}

function $f449f1ece320c6d1$var$WritableState(options, stream, isDuplex) {
    $f449f1ece320c6d1$var$Duplex = $f449f1ece320c6d1$var$Duplex || (parcelRequire("9ODku"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $f449f1ece320c6d1$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $f449f1ece320c6d1$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $f449f1ece320c6d1$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $f449f1ece320c6d1$var$CorkedRequest(this);
}
$f449f1ece320c6d1$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($f449f1ece320c6d1$var$WritableState.prototype, "buffer", {
            get: $f449f1ece320c6d1$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $f449f1ece320c6d1$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $f449f1ece320c6d1$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($f449f1ece320c6d1$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($f449f1ece320c6d1$var$realHasInstance.call(this, object)) return true;
            if (this !== $f449f1ece320c6d1$var$Writable) return false;
            return object && object._writableState instanceof $f449f1ece320c6d1$var$WritableState;
        }
    });
} else $f449f1ece320c6d1$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $f449f1ece320c6d1$var$Writable(options) {
    $f449f1ece320c6d1$var$Duplex = $f449f1ece320c6d1$var$Duplex || (parcelRequire("9ODku"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f449f1ece320c6d1$var$Duplex;
    if (!isDuplex && !$f449f1ece320c6d1$var$realHasInstance.call($f449f1ece320c6d1$var$Writable, this)) return new $f449f1ece320c6d1$var$Writable(options);
    this._writableState = new $f449f1ece320c6d1$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $igIdM.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$f449f1ece320c6d1$var$Writable.prototype.pipe = function() {
    $f449f1ece320c6d1$var$errorOrDestroy(this, new $f449f1ece320c6d1$var$ERR_STREAM_CANNOT_PIPE());
};
function $f449f1ece320c6d1$var$writeAfterEnd(stream, cb) {
    var er = new $f449f1ece320c6d1$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $f449f1ece320c6d1$var$errorOrDestroy(stream, er);
    $6qd2L.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $f449f1ece320c6d1$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $f449f1ece320c6d1$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $f449f1ece320c6d1$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $f449f1ece320c6d1$var$errorOrDestroy(stream, er);
        $6qd2L.nextTick(cb, er);
        return false;
    }
    return true;
}
$f449f1ece320c6d1$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $f449f1ece320c6d1$var$_isUint8Array(chunk);
    if (isBuf && !$f449f1ece320c6d1$require$Buffer.isBuffer(chunk)) chunk = $f449f1ece320c6d1$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $f449f1ece320c6d1$var$nop;
    if (state.ending) $f449f1ece320c6d1$var$writeAfterEnd(this, cb);
    else if (isBuf || $f449f1ece320c6d1$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $f449f1ece320c6d1$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$f449f1ece320c6d1$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$f449f1ece320c6d1$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f449f1ece320c6d1$var$clearBuffer(this, state);
    }
};
$f449f1ece320c6d1$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $f449f1ece320c6d1$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($f449f1ece320c6d1$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $f449f1ece320c6d1$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $f449f1ece320c6d1$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($f449f1ece320c6d1$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f449f1ece320c6d1$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $f449f1ece320c6d1$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $f449f1ece320c6d1$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $f449f1ece320c6d1$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $f449f1ece320c6d1$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f449f1ece320c6d1$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $6qd2L.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $6qd2L.nextTick($f449f1ece320c6d1$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $f449f1ece320c6d1$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $f449f1ece320c6d1$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $f449f1ece320c6d1$var$finishMaybe(stream, state);
    }
}
function $f449f1ece320c6d1$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $f449f1ece320c6d1$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $f449f1ece320c6d1$var$ERR_MULTIPLE_CALLBACK();
    $f449f1ece320c6d1$var$onwriteStateUpdate(state);
    if (er) $f449f1ece320c6d1$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $f449f1ece320c6d1$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f449f1ece320c6d1$var$clearBuffer(stream, state);
        if (sync) $6qd2L.nextTick($f449f1ece320c6d1$var$afterWrite, stream, state, finished, cb);
        else $f449f1ece320c6d1$var$afterWrite(stream, state, finished, cb);
    }
}
function $f449f1ece320c6d1$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $f449f1ece320c6d1$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $f449f1ece320c6d1$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $f449f1ece320c6d1$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $f449f1ece320c6d1$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $f449f1ece320c6d1$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $f449f1ece320c6d1$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $f449f1ece320c6d1$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$f449f1ece320c6d1$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $f449f1ece320c6d1$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$f449f1ece320c6d1$var$Writable.prototype._writev = null;
$f449f1ece320c6d1$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $f449f1ece320c6d1$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($f449f1ece320c6d1$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $f449f1ece320c6d1$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $f449f1ece320c6d1$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $f449f1ece320c6d1$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $f449f1ece320c6d1$var$finishMaybe(stream, state);
    });
}
function $f449f1ece320c6d1$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $6qd2L.nextTick($f449f1ece320c6d1$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $f449f1ece320c6d1$var$finishMaybe(stream, state) {
    var need = $f449f1ece320c6d1$var$needFinish(state);
    if (need) {
        $f449f1ece320c6d1$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $f449f1ece320c6d1$var$endWritable(stream, state, cb) {
    state.ending = true;
    $f449f1ece320c6d1$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $6qd2L.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $f449f1ece320c6d1$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($f449f1ece320c6d1$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$f449f1ece320c6d1$var$Writable.prototype.destroy = $g0P9t.destroy;
$f449f1ece320c6d1$var$Writable.prototype._undestroy = $g0P9t.undestroy;
$f449f1ece320c6d1$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("3ZPxO", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $2e8f0d3e23525401$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $2e8f0d3e23525401$var$deprecate(fn, msg) {
    if ($2e8f0d3e23525401$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($2e8f0d3e23525401$var$config("throwDeprecation")) throw new Error(msg);
            else if ($2e8f0d3e23525401$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $2e8f0d3e23525401$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("g6ehz", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $bb88490a7c25ef82$export$63a7aa211a91ed69; }, function (v) { return $bb88490a7c25ef82$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $bb88490a7c25ef82$export$63a7aa211a91ed69;
"use strict";

var $2iVwY = parcelRequire("2iVwY");
var $bb88490a7c25ef82$require$Buffer = $2iVwY.Buffer;
/*</replacement>*/ var $bb88490a7c25ef82$var$isEncoding = $bb88490a7c25ef82$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $bb88490a7c25ef82$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $bb88490a7c25ef82$var$normalizeEncoding(enc) {
    var nenc = $bb88490a7c25ef82$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($bb88490a7c25ef82$require$Buffer.isEncoding === $bb88490a7c25ef82$var$isEncoding || !$bb88490a7c25ef82$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$bb88490a7c25ef82$export$63a7aa211a91ed69 = $bb88490a7c25ef82$var$StringDecoder;
function $bb88490a7c25ef82$var$StringDecoder(encoding) {
    this.encoding = $bb88490a7c25ef82$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $bb88490a7c25ef82$var$utf16Text;
            this.end = $bb88490a7c25ef82$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $bb88490a7c25ef82$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $bb88490a7c25ef82$var$base64Text;
            this.end = $bb88490a7c25ef82$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $bb88490a7c25ef82$var$simpleWrite;
            this.end = $bb88490a7c25ef82$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $bb88490a7c25ef82$require$Buffer.allocUnsafe(nb);
}
$bb88490a7c25ef82$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$bb88490a7c25ef82$var$StringDecoder.prototype.end = $bb88490a7c25ef82$var$utf8End;
// Returns only complete characters in a Buffer
$bb88490a7c25ef82$var$StringDecoder.prototype.text = $bb88490a7c25ef82$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$bb88490a7c25ef82$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $bb88490a7c25ef82$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $bb88490a7c25ef82$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $bb88490a7c25ef82$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $bb88490a7c25ef82$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $bb88490a7c25ef82$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $bb88490a7c25ef82$var$utf8Text(buf, i) {
    var total = $bb88490a7c25ef82$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $bb88490a7c25ef82$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $bb88490a7c25ef82$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $bb88490a7c25ef82$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $bb88490a7c25ef82$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $bb88490a7c25ef82$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $bb88490a7c25ef82$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $bb88490a7c25ef82$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("jw1Sa", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
"use strict";
var $e3527557620090dc$var$_Object$setPrototypeO;
function $e3527557620090dc$var$_defineProperty(obj, key, value) {
    key = $e3527557620090dc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e3527557620090dc$var$_toPropertyKey(arg) {
    var key = $e3527557620090dc$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e3527557620090dc$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $jR9FH = parcelRequire("jR9FH");
var $e3527557620090dc$var$kLastResolve = Symbol("lastResolve");
var $e3527557620090dc$var$kLastReject = Symbol("lastReject");
var $e3527557620090dc$var$kError = Symbol("error");
var $e3527557620090dc$var$kEnded = Symbol("ended");
var $e3527557620090dc$var$kLastPromise = Symbol("lastPromise");
var $e3527557620090dc$var$kHandlePromise = Symbol("handlePromise");
var $e3527557620090dc$var$kStream = Symbol("stream");
function $e3527557620090dc$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $e3527557620090dc$var$readAndResolve(iter) {
    var resolve = iter[$e3527557620090dc$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$e3527557620090dc$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$e3527557620090dc$var$kLastPromise] = null;
            iter[$e3527557620090dc$var$kLastResolve] = null;
            iter[$e3527557620090dc$var$kLastReject] = null;
            resolve($e3527557620090dc$var$createIterResult(data, false));
        }
    }
}
function $e3527557620090dc$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $6qd2L.nextTick($e3527557620090dc$var$readAndResolve, iter);
}
function $e3527557620090dc$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$e3527557620090dc$var$kEnded]) {
                resolve($e3527557620090dc$var$createIterResult(undefined, true));
                return;
            }
            iter[$e3527557620090dc$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $e3527557620090dc$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $e3527557620090dc$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($e3527557620090dc$var$_Object$setPrototypeO = {
    get stream () {
        return this[$e3527557620090dc$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$e3527557620090dc$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$e3527557620090dc$var$kEnded]) return Promise.resolve($e3527557620090dc$var$createIterResult(undefined, true));
        if (this[$e3527557620090dc$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $6qd2L.nextTick(function() {
                if (_this[$e3527557620090dc$var$kError]) reject(_this[$e3527557620090dc$var$kError]);
                else resolve($e3527557620090dc$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$e3527557620090dc$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($e3527557620090dc$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$e3527557620090dc$var$kStream].read();
            if (data !== null) return Promise.resolve($e3527557620090dc$var$createIterResult(data, false));
            promise = new Promise(this[$e3527557620090dc$var$kHandlePromise]);
        }
        this[$e3527557620090dc$var$kLastPromise] = promise;
        return promise;
    }
}, $e3527557620090dc$var$_defineProperty($e3527557620090dc$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $e3527557620090dc$var$_defineProperty($e3527557620090dc$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$e3527557620090dc$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($e3527557620090dc$var$createIterResult(undefined, true));
        });
    });
}), $e3527557620090dc$var$_Object$setPrototypeO), $e3527557620090dc$var$AsyncIteratorPrototype);
var $e3527557620090dc$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($e3527557620090dc$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $e3527557620090dc$var$_defineProperty(_Object$create, $e3527557620090dc$var$kStream, {
        value: stream,
        writable: true
    }), $e3527557620090dc$var$_defineProperty(_Object$create, $e3527557620090dc$var$kLastResolve, {
        value: null,
        writable: true
    }), $e3527557620090dc$var$_defineProperty(_Object$create, $e3527557620090dc$var$kLastReject, {
        value: null,
        writable: true
    }), $e3527557620090dc$var$_defineProperty(_Object$create, $e3527557620090dc$var$kError, {
        value: null,
        writable: true
    }), $e3527557620090dc$var$_defineProperty(_Object$create, $e3527557620090dc$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $e3527557620090dc$var$_defineProperty(_Object$create, $e3527557620090dc$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$e3527557620090dc$var$kStream].read();
            if (data) {
                iterator[$e3527557620090dc$var$kLastPromise] = null;
                iterator[$e3527557620090dc$var$kLastResolve] = null;
                iterator[$e3527557620090dc$var$kLastReject] = null;
                resolve($e3527557620090dc$var$createIterResult(data, false));
            } else {
                iterator[$e3527557620090dc$var$kLastResolve] = resolve;
                iterator[$e3527557620090dc$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$e3527557620090dc$var$kLastPromise] = null;
    $jR9FH(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$e3527557620090dc$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$e3527557620090dc$var$kLastPromise] = null;
                iterator[$e3527557620090dc$var$kLastResolve] = null;
                iterator[$e3527557620090dc$var$kLastReject] = null;
                reject(err);
            }
            iterator[$e3527557620090dc$var$kError] = err;
            return;
        }
        var resolve = iterator[$e3527557620090dc$var$kLastResolve];
        if (resolve !== null) {
            iterator[$e3527557620090dc$var$kLastPromise] = null;
            iterator[$e3527557620090dc$var$kLastResolve] = null;
            iterator[$e3527557620090dc$var$kLastReject] = null;
            resolve($e3527557620090dc$var$createIterResult(undefined, true));
        }
        iterator[$e3527557620090dc$var$kEnded] = true;
    });
    stream.on("readable", $e3527557620090dc$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $e3527557620090dc$var$createReadableStreamAsyncIterator;

});
parcelRegister("jR9FH", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $e74a781be47696f3$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("bVf07")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $e74a781be47696f3$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $e74a781be47696f3$var$noop() {}
function $e74a781be47696f3$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $e74a781be47696f3$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $e74a781be47696f3$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $e74a781be47696f3$var$once(callback || $e74a781be47696f3$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $e74a781be47696f3$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $e74a781be47696f3$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($e74a781be47696f3$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $e74a781be47696f3$var$eos;

});


parcelRegister("HH1jY", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("aurW9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $7a326069a7c7eb90$var$Transform;

var $bVf07 = parcelRequire("bVf07");
var $7a326069a7c7eb90$require$_require$codes = $bVf07.codes;
var $7a326069a7c7eb90$var$ERR_METHOD_NOT_IMPLEMENTED = $7a326069a7c7eb90$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7a326069a7c7eb90$var$ERR_MULTIPLE_CALLBACK = $7a326069a7c7eb90$require$_require$codes.ERR_MULTIPLE_CALLBACK, $7a326069a7c7eb90$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $7a326069a7c7eb90$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $7a326069a7c7eb90$var$ERR_TRANSFORM_WITH_LENGTH_0 = $7a326069a7c7eb90$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $9ODku = parcelRequire("9ODku");

(parcelRequire("9M38k"))($7a326069a7c7eb90$var$Transform, $9ODku);
function $7a326069a7c7eb90$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $7a326069a7c7eb90$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $7a326069a7c7eb90$var$Transform(options) {
    if (!(this instanceof $7a326069a7c7eb90$var$Transform)) return new $7a326069a7c7eb90$var$Transform(options);
    $9ODku.call(this, options);
    this._transformState = {
        afterTransform: $7a326069a7c7eb90$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $7a326069a7c7eb90$var$prefinish);
}
function $7a326069a7c7eb90$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $7a326069a7c7eb90$var$done(_this, er, data);
    });
    else $7a326069a7c7eb90$var$done(this, null, null);
}
$7a326069a7c7eb90$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $9ODku.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$7a326069a7c7eb90$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $7a326069a7c7eb90$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$7a326069a7c7eb90$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$7a326069a7c7eb90$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$7a326069a7c7eb90$var$Transform.prototype._destroy = function(err, cb) {
    $9ODku.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $7a326069a7c7eb90$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $7a326069a7c7eb90$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $7a326069a7c7eb90$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("aGOT9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $7c854d04512cedde$var$PassThrough;

var $aurW9 = parcelRequire("aurW9");

(parcelRequire("9M38k"))($7c854d04512cedde$var$PassThrough, $aurW9);
function $7c854d04512cedde$var$PassThrough(options) {
    if (!(this instanceof $7c854d04512cedde$var$PassThrough)) return new $7c854d04512cedde$var$PassThrough(options);
    $aurW9.call(this, options);
}
$7c854d04512cedde$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("6tlF8", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $4b664137de05488d$var$eos;
function $4b664137de05488d$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $bVf07 = parcelRequire("bVf07");
var $4b664137de05488d$require$_require$codes = $bVf07.codes;
var $4b664137de05488d$var$ERR_MISSING_ARGS = $4b664137de05488d$require$_require$codes.ERR_MISSING_ARGS, $4b664137de05488d$var$ERR_STREAM_DESTROYED = $4b664137de05488d$require$_require$codes.ERR_STREAM_DESTROYED;
function $4b664137de05488d$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $4b664137de05488d$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $4b664137de05488d$var$destroyer(stream, reading, writing, callback) {
    callback = $4b664137de05488d$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($4b664137de05488d$var$eos === undefined) $4b664137de05488d$var$eos = (parcelRequire("jR9FH"));
    $4b664137de05488d$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($4b664137de05488d$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $4b664137de05488d$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $4b664137de05488d$var$call(fn) {
    fn();
}
function $4b664137de05488d$var$pipe(from, to) {
    return from.pipe(to);
}
function $4b664137de05488d$var$popCallback(streams) {
    if (!streams.length) return $4b664137de05488d$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $4b664137de05488d$var$noop;
    return streams.pop();
}
function $4b664137de05488d$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $4b664137de05488d$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $4b664137de05488d$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $4b664137de05488d$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($4b664137de05488d$var$call);
            if (reading) return;
            destroys.forEach($4b664137de05488d$var$call);
            callback(error);
        });
    });
    return streams.reduce($4b664137de05488d$var$pipe);
}
module.exports = $4b664137de05488d$var$pipeline;

});




parcelRegister("5rZkB", function(module, exports) {
"use strict";

var $3aNd6 = parcelRequire("3aNd6");
var $3f7f0c7c6bfb16d8$require$Buffer = $3aNd6.Buffer;

var $9M38k = parcelRequire("9M38k");

var $9dLwd = parcelRequire("9dLwd");
var $3f7f0c7c6bfb16d8$var$ARRAY16 = new Array(16);
var $3f7f0c7c6bfb16d8$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $3f7f0c7c6bfb16d8$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $3f7f0c7c6bfb16d8$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $3f7f0c7c6bfb16d8$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $3f7f0c7c6bfb16d8$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $3f7f0c7c6bfb16d8$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $3f7f0c7c6bfb16d8$var$RIPEMD160() {
    $9dLwd.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$9M38k($3f7f0c7c6bfb16d8$var$RIPEMD160, $9dLwd);
$3f7f0c7c6bfb16d8$var$RIPEMD160.prototype._update = function() {
    var words = $3f7f0c7c6bfb16d8$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $3f7f0c7c6bfb16d8$var$fn1(al, bl, cl, dl, el, words[$3f7f0c7c6bfb16d8$var$zl[i]], $3f7f0c7c6bfb16d8$var$hl[0], $3f7f0c7c6bfb16d8$var$sl[i]);
            tr = $3f7f0c7c6bfb16d8$var$fn5(ar, br, cr, dr, er, words[$3f7f0c7c6bfb16d8$var$zr[i]], $3f7f0c7c6bfb16d8$var$hr[0], $3f7f0c7c6bfb16d8$var$sr[i]);
        } else if (i < 32) {
            tl = $3f7f0c7c6bfb16d8$var$fn2(al, bl, cl, dl, el, words[$3f7f0c7c6bfb16d8$var$zl[i]], $3f7f0c7c6bfb16d8$var$hl[1], $3f7f0c7c6bfb16d8$var$sl[i]);
            tr = $3f7f0c7c6bfb16d8$var$fn4(ar, br, cr, dr, er, words[$3f7f0c7c6bfb16d8$var$zr[i]], $3f7f0c7c6bfb16d8$var$hr[1], $3f7f0c7c6bfb16d8$var$sr[i]);
        } else if (i < 48) {
            tl = $3f7f0c7c6bfb16d8$var$fn3(al, bl, cl, dl, el, words[$3f7f0c7c6bfb16d8$var$zl[i]], $3f7f0c7c6bfb16d8$var$hl[2], $3f7f0c7c6bfb16d8$var$sl[i]);
            tr = $3f7f0c7c6bfb16d8$var$fn3(ar, br, cr, dr, er, words[$3f7f0c7c6bfb16d8$var$zr[i]], $3f7f0c7c6bfb16d8$var$hr[2], $3f7f0c7c6bfb16d8$var$sr[i]);
        } else if (i < 64) {
            tl = $3f7f0c7c6bfb16d8$var$fn4(al, bl, cl, dl, el, words[$3f7f0c7c6bfb16d8$var$zl[i]], $3f7f0c7c6bfb16d8$var$hl[3], $3f7f0c7c6bfb16d8$var$sl[i]);
            tr = $3f7f0c7c6bfb16d8$var$fn2(ar, br, cr, dr, er, words[$3f7f0c7c6bfb16d8$var$zr[i]], $3f7f0c7c6bfb16d8$var$hr[3], $3f7f0c7c6bfb16d8$var$sr[i]);
        } else {
            tl = $3f7f0c7c6bfb16d8$var$fn5(al, bl, cl, dl, el, words[$3f7f0c7c6bfb16d8$var$zl[i]], $3f7f0c7c6bfb16d8$var$hl[4], $3f7f0c7c6bfb16d8$var$sl[i]);
            tr = $3f7f0c7c6bfb16d8$var$fn1(ar, br, cr, dr, er, words[$3f7f0c7c6bfb16d8$var$zr[i]], $3f7f0c7c6bfb16d8$var$hr[4], $3f7f0c7c6bfb16d8$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $3f7f0c7c6bfb16d8$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $3f7f0c7c6bfb16d8$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$3f7f0c7c6bfb16d8$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $3f7f0c7c6bfb16d8$require$Buffer.alloc ? $3f7f0c7c6bfb16d8$require$Buffer.alloc(20) : new $3f7f0c7c6bfb16d8$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $3f7f0c7c6bfb16d8$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $3f7f0c7c6bfb16d8$var$fn1(a, b, c, d, e, m, k, s) {
    return $3f7f0c7c6bfb16d8$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $3f7f0c7c6bfb16d8$var$fn2(a, b, c, d, e, m, k, s) {
    return $3f7f0c7c6bfb16d8$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $3f7f0c7c6bfb16d8$var$fn3(a, b, c, d, e, m, k, s) {
    return $3f7f0c7c6bfb16d8$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $3f7f0c7c6bfb16d8$var$fn4(a, b, c, d, e, m, k, s) {
    return $3f7f0c7c6bfb16d8$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $3f7f0c7c6bfb16d8$var$fn5(a, b, c, d, e, m, k, s) {
    return $3f7f0c7c6bfb16d8$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $3f7f0c7c6bfb16d8$var$RIPEMD160;

});

parcelRegister("dyOkR", function(module, exports) {
var $9df57eef21d68983$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $9df57eef21d68983$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$9df57eef21d68983$var$exports.sha = (parcelRequire("bbxhk"));

$9df57eef21d68983$var$exports.sha1 = (parcelRequire("b0IFf"));

$9df57eef21d68983$var$exports.sha224 = (parcelRequire("huIqO"));

$9df57eef21d68983$var$exports.sha256 = (parcelRequire("4TDA6"));

$9df57eef21d68983$var$exports.sha384 = (parcelRequire("bgXbc"));

$9df57eef21d68983$var$exports.sha512 = (parcelRequire("bUefF"));

});
parcelRegister("bbxhk", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $9M38k = parcelRequire("9M38k");

var $j0V8X = parcelRequire("j0V8X");

var $2iVwY = parcelRequire("2iVwY");
var $824a8931aeda35eb$require$Buffer = $2iVwY.Buffer;
var $824a8931aeda35eb$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $824a8931aeda35eb$var$W = new Array(80);
function $824a8931aeda35eb$var$Sha() {
    this.init();
    this._w = $824a8931aeda35eb$var$W;
    $j0V8X.call(this, 64, 56);
}
$9M38k($824a8931aeda35eb$var$Sha, $j0V8X);
$824a8931aeda35eb$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $824a8931aeda35eb$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $824a8931aeda35eb$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $824a8931aeda35eb$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$824a8931aeda35eb$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $824a8931aeda35eb$var$rotl5(a) + $824a8931aeda35eb$var$ft(s, b, c, d) + e + W[j] + $824a8931aeda35eb$var$K[s] | 0;
        e = d;
        d = c;
        c = $824a8931aeda35eb$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$824a8931aeda35eb$var$Sha.prototype._hash = function() {
    var H = $824a8931aeda35eb$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $824a8931aeda35eb$var$Sha;

});
parcelRegister("j0V8X", function(module, exports) {

var $2iVwY = parcelRequire("2iVwY");
var $dd7a57eb1c675d10$require$Buffer = $2iVwY.Buffer;
// prototype class for hash functions
function $dd7a57eb1c675d10$var$Hash(blockSize, finalSize) {
    this._block = $dd7a57eb1c675d10$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$dd7a57eb1c675d10$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $dd7a57eb1c675d10$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$dd7a57eb1c675d10$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$dd7a57eb1c675d10$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $dd7a57eb1c675d10$var$Hash;

});


parcelRegister("b0IFf", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $9M38k = parcelRequire("9M38k");

var $j0V8X = parcelRequire("j0V8X");

var $2iVwY = parcelRequire("2iVwY");
var $8042572d99760716$require$Buffer = $2iVwY.Buffer;
var $8042572d99760716$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $8042572d99760716$var$W = new Array(80);
function $8042572d99760716$var$Sha1() {
    this.init();
    this._w = $8042572d99760716$var$W;
    $j0V8X.call(this, 64, 56);
}
$9M38k($8042572d99760716$var$Sha1, $j0V8X);
$8042572d99760716$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $8042572d99760716$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $8042572d99760716$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $8042572d99760716$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $8042572d99760716$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$8042572d99760716$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $8042572d99760716$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $8042572d99760716$var$rotl5(a) + $8042572d99760716$var$ft(s, b, c, d) + e + W[j] + $8042572d99760716$var$K[s] | 0;
        e = d;
        d = c;
        c = $8042572d99760716$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$8042572d99760716$var$Sha1.prototype._hash = function() {
    var H = $8042572d99760716$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $8042572d99760716$var$Sha1;

});

parcelRegister("huIqO", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $9M38k = parcelRequire("9M38k");

var $4TDA6 = parcelRequire("4TDA6");

var $j0V8X = parcelRequire("j0V8X");

var $2iVwY = parcelRequire("2iVwY");
var $cbc7b4274d3636ca$require$Buffer = $2iVwY.Buffer;
var $cbc7b4274d3636ca$var$W = new Array(64);
function $cbc7b4274d3636ca$var$Sha224() {
    this.init();
    this._w = $cbc7b4274d3636ca$var$W // new Array(64)
    ;
    $j0V8X.call(this, 64, 56);
}
$9M38k($cbc7b4274d3636ca$var$Sha224, $4TDA6);
$cbc7b4274d3636ca$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$cbc7b4274d3636ca$var$Sha224.prototype._hash = function() {
    var H = $cbc7b4274d3636ca$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $cbc7b4274d3636ca$var$Sha224;

});
parcelRegister("4TDA6", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $9M38k = parcelRequire("9M38k");

var $j0V8X = parcelRequire("j0V8X");

var $2iVwY = parcelRequire("2iVwY");
var $390b008084da52b2$require$Buffer = $2iVwY.Buffer;
var $390b008084da52b2$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $390b008084da52b2$var$W = new Array(64);
function $390b008084da52b2$var$Sha256() {
    this.init();
    this._w = $390b008084da52b2$var$W // new Array(64)
    ;
    $j0V8X.call(this, 64, 56);
}
$9M38k($390b008084da52b2$var$Sha256, $j0V8X);
$390b008084da52b2$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $390b008084da52b2$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $390b008084da52b2$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $390b008084da52b2$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $390b008084da52b2$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $390b008084da52b2$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $390b008084da52b2$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$390b008084da52b2$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $390b008084da52b2$var$gamma1(W[i - 2]) + W[i - 7] + $390b008084da52b2$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $390b008084da52b2$var$sigma1(e) + $390b008084da52b2$var$ch(e, f, g) + $390b008084da52b2$var$K[j] + W[j] | 0;
        var T2 = $390b008084da52b2$var$sigma0(a) + $390b008084da52b2$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$390b008084da52b2$var$Sha256.prototype._hash = function() {
    var H = $390b008084da52b2$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $390b008084da52b2$var$Sha256;

});


parcelRegister("bgXbc", function(module, exports) {

var $9M38k = parcelRequire("9M38k");

var $bUefF = parcelRequire("bUefF");

var $j0V8X = parcelRequire("j0V8X");

var $2iVwY = parcelRequire("2iVwY");
var $834f18284530e918$require$Buffer = $2iVwY.Buffer;
var $834f18284530e918$var$W = new Array(160);
function $834f18284530e918$var$Sha384() {
    this.init();
    this._w = $834f18284530e918$var$W;
    $j0V8X.call(this, 128, 112);
}
$9M38k($834f18284530e918$var$Sha384, $bUefF);
$834f18284530e918$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$834f18284530e918$var$Sha384.prototype._hash = function() {
    var H = $834f18284530e918$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $834f18284530e918$var$Sha384;

});
parcelRegister("bUefF", function(module, exports) {

var $9M38k = parcelRequire("9M38k");

var $j0V8X = parcelRequire("j0V8X");

var $2iVwY = parcelRequire("2iVwY");
var $8aaffac98d1a27e6$require$Buffer = $2iVwY.Buffer;
var $8aaffac98d1a27e6$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8aaffac98d1a27e6$var$W = new Array(160);
function $8aaffac98d1a27e6$var$Sha512() {
    this.init();
    this._w = $8aaffac98d1a27e6$var$W;
    $j0V8X.call(this, 128, 112);
}
$9M38k($8aaffac98d1a27e6$var$Sha512, $j0V8X);
$8aaffac98d1a27e6$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8aaffac98d1a27e6$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8aaffac98d1a27e6$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8aaffac98d1a27e6$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8aaffac98d1a27e6$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8aaffac98d1a27e6$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8aaffac98d1a27e6$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8aaffac98d1a27e6$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8aaffac98d1a27e6$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8aaffac98d1a27e6$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8aaffac98d1a27e6$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8aaffac98d1a27e6$var$Gamma0(xh, xl);
        var gamma0l = $8aaffac98d1a27e6$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8aaffac98d1a27e6$var$Gamma1(xh, xl);
        var gamma1l = $8aaffac98d1a27e6$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8aaffac98d1a27e6$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8aaffac98d1a27e6$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8aaffac98d1a27e6$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8aaffac98d1a27e6$var$maj(ah, bh, ch);
        var majl = $8aaffac98d1a27e6$var$maj(al, bl, cl);
        var sigma0h = $8aaffac98d1a27e6$var$sigma0(ah, al);
        var sigma0l = $8aaffac98d1a27e6$var$sigma0(al, ah);
        var sigma1h = $8aaffac98d1a27e6$var$sigma1(eh, el);
        var sigma1l = $8aaffac98d1a27e6$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8aaffac98d1a27e6$var$K[j];
        var Kil = $8aaffac98d1a27e6$var$K[j + 1];
        var chh = $8aaffac98d1a27e6$var$Ch(eh, fh, gh);
        var chl = $8aaffac98d1a27e6$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8aaffac98d1a27e6$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8aaffac98d1a27e6$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8aaffac98d1a27e6$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8aaffac98d1a27e6$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8aaffac98d1a27e6$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8aaffac98d1a27e6$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8aaffac98d1a27e6$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8aaffac98d1a27e6$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8aaffac98d1a27e6$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8aaffac98d1a27e6$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8aaffac98d1a27e6$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8aaffac98d1a27e6$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8aaffac98d1a27e6$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8aaffac98d1a27e6$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8aaffac98d1a27e6$var$getCarry(this._hl, hl) | 0;
};
$8aaffac98d1a27e6$var$Sha512.prototype._hash = function() {
    var H = $8aaffac98d1a27e6$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8aaffac98d1a27e6$var$Sha512;

});



parcelRegister("7J5an", function(module, exports) {

var $2iVwY = parcelRequire("2iVwY");
var $5a00be4cf4830ced$require$Buffer = $2iVwY.Buffer;

var $g5acy = parcelRequire("g5acy");
var $5a00be4cf4830ced$require$Transform = $g5acy.Transform;

var $g6ehz = parcelRequire("g6ehz");
var $5a00be4cf4830ced$require$StringDecoder = $g6ehz.StringDecoder;

var $9M38k = parcelRequire("9M38k");
function $5a00be4cf4830ced$var$CipherBase(hashMode) {
    $5a00be4cf4830ced$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$9M38k($5a00be4cf4830ced$var$CipherBase, $5a00be4cf4830ced$require$Transform);
$5a00be4cf4830ced$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $5a00be4cf4830ced$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$5a00be4cf4830ced$var$CipherBase.prototype.setAutoPadding = function() {};
$5a00be4cf4830ced$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$5a00be4cf4830ced$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$5a00be4cf4830ced$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$5a00be4cf4830ced$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$5a00be4cf4830ced$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$5a00be4cf4830ced$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $5a00be4cf4830ced$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$5a00be4cf4830ced$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $5a00be4cf4830ced$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $5a00be4cf4830ced$var$CipherBase;

});
parcelRegister("g5acy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $bb5506cc58c54722$var$Stream;

var $dG33B = parcelRequire("dG33B");
var $bb5506cc58c54722$require$EE = $dG33B.EventEmitter;

var $9M38k = parcelRequire("9M38k");
$9M38k($bb5506cc58c54722$var$Stream, $bb5506cc58c54722$require$EE);

$bb5506cc58c54722$var$Stream.Readable = (parcelRequire("fTX3U"));

$bb5506cc58c54722$var$Stream.Writable = (parcelRequire("kYljA"));

$bb5506cc58c54722$var$Stream.Duplex = (parcelRequire("9ODku"));

$bb5506cc58c54722$var$Stream.Transform = (parcelRequire("aurW9"));

$bb5506cc58c54722$var$Stream.PassThrough = (parcelRequire("aGOT9"));

$bb5506cc58c54722$var$Stream.finished = (parcelRequire("jR9FH"));

$bb5506cc58c54722$var$Stream.pipeline = (parcelRequire("6tlF8"));
// Backwards-compat with node 0.4.x
$bb5506cc58c54722$var$Stream.Stream = $bb5506cc58c54722$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $bb5506cc58c54722$var$Stream() {
    $bb5506cc58c54722$require$EE.call(this);
}
$bb5506cc58c54722$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($bb5506cc58c54722$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("2Mjvp", function(module, exports) {
"use strict";

var $9M38k = parcelRequire("9M38k");

var $iOiNP = parcelRequire("iOiNP");

var $7J5an = parcelRequire("7J5an");

var $2iVwY = parcelRequire("2iVwY");
var $205f31deee8ea11c$require$Buffer = $2iVwY.Buffer;

var $6mFYn = parcelRequire("6mFYn");

var $5rZkB = parcelRequire("5rZkB");

var $dyOkR = parcelRequire("dyOkR");
var $205f31deee8ea11c$var$ZEROS = $205f31deee8ea11c$require$Buffer.alloc(128);
function $205f31deee8ea11c$var$Hmac(alg, key) {
    $7J5an.call(this, "digest");
    if (typeof key === "string") key = $205f31deee8ea11c$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $5rZkB() : $dyOkR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $205f31deee8ea11c$require$Buffer.concat([
        key,
        $205f31deee8ea11c$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $205f31deee8ea11c$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $205f31deee8ea11c$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $5rZkB() : $dyOkR(alg);
    this._hash.update(ipad);
}
$9M38k($205f31deee8ea11c$var$Hmac, $7J5an);
$205f31deee8ea11c$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$205f31deee8ea11c$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $5rZkB() : $dyOkR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $205f31deee8ea11c$var$Hmac("rmd160", key);
    if (alg === "md5") return new $iOiNP($6mFYn, key);
    return new $205f31deee8ea11c$var$Hmac(alg, key);
};

});
parcelRegister("iOiNP", function(module, exports) {
"use strict";

var $9M38k = parcelRequire("9M38k");

var $2iVwY = parcelRequire("2iVwY");
var $db1b7b572dfcf52f$require$Buffer = $2iVwY.Buffer;

var $7J5an = parcelRequire("7J5an");
var $db1b7b572dfcf52f$var$ZEROS = $db1b7b572dfcf52f$require$Buffer.alloc(128);
var $db1b7b572dfcf52f$var$blocksize = 64;
function $db1b7b572dfcf52f$var$Hmac(alg, key) {
    $7J5an.call(this, "digest");
    if (typeof key === "string") key = $db1b7b572dfcf52f$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $db1b7b572dfcf52f$var$blocksize) key = alg(key);
    else if (key.length < $db1b7b572dfcf52f$var$blocksize) key = $db1b7b572dfcf52f$require$Buffer.concat([
        key,
        $db1b7b572dfcf52f$var$ZEROS
    ], $db1b7b572dfcf52f$var$blocksize);
    var ipad = this._ipad = $db1b7b572dfcf52f$require$Buffer.allocUnsafe($db1b7b572dfcf52f$var$blocksize);
    var opad = this._opad = $db1b7b572dfcf52f$require$Buffer.allocUnsafe($db1b7b572dfcf52f$var$blocksize);
    for(var i = 0; i < $db1b7b572dfcf52f$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$9M38k($db1b7b572dfcf52f$var$Hmac, $7J5an);
$db1b7b572dfcf52f$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$db1b7b572dfcf52f$var$Hmac.prototype._final = function() {
    var h = this._alg($db1b7b572dfcf52f$require$Buffer.concat(this._hash));
    return this._alg($db1b7b572dfcf52f$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $db1b7b572dfcf52f$var$Hmac;

});

parcelRegister("6mFYn", function(module, exports) {

var $lcOGj = parcelRequire("lcOGj");
module.exports = function(buffer) {
    return new $lcOGj().update(buffer).digest();
};

});


parcelRegister("1rAns", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});

parcelRegister("4xsnO", function(module, exports) {

var $2iVwY = parcelRequire("2iVwY");
var $34e042c92d4dd134$require$Buffer = $2iVwY.Buffer;

var $G7Hg3 = parcelRequire("G7Hg3");

var $jmEqX = parcelRequire("jmEqX");

var $f0ZIh = parcelRequire("f0ZIh");

var $cLL9z = parcelRequire("cLL9z");
var $34e042c92d4dd134$var$ZERO_BUF;
var $34e042c92d4dd134$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $34e042c92d4dd134$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $34e042c92d4dd134$var$checks = [];
function $34e042c92d4dd134$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$34e042c92d4dd134$var$subtle || !$34e042c92d4dd134$var$subtle.importKey || !$34e042c92d4dd134$var$subtle.deriveBits) return Promise.resolve(false);
    if ($34e042c92d4dd134$var$checks[algo] !== undefined) return $34e042c92d4dd134$var$checks[algo];
    $34e042c92d4dd134$var$ZERO_BUF = $34e042c92d4dd134$var$ZERO_BUF || $34e042c92d4dd134$require$Buffer.alloc(8);
    var prom = $34e042c92d4dd134$var$browserPbkdf2($34e042c92d4dd134$var$ZERO_BUF, $34e042c92d4dd134$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $34e042c92d4dd134$var$checks[algo] = prom;
    return prom;
}
var $34e042c92d4dd134$var$nextTick;
function $34e042c92d4dd134$var$getNextTick() {
    if ($34e042c92d4dd134$var$nextTick) return $34e042c92d4dd134$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $34e042c92d4dd134$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $34e042c92d4dd134$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $34e042c92d4dd134$var$nextTick = $parcel$global.setImmediate;
    else $34e042c92d4dd134$var$nextTick = $parcel$global.setTimeout;
    return $34e042c92d4dd134$var$nextTick;
}
function $34e042c92d4dd134$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $34e042c92d4dd134$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $34e042c92d4dd134$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $34e042c92d4dd134$require$Buffer.from(res);
    });
}
function $34e042c92d4dd134$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $34e042c92d4dd134$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $34e042c92d4dd134$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $34e042c92d4dd134$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $34e042c92d4dd134$var$getNextTick()(function() {
            var out;
            try {
                out = $f0ZIh(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $G7Hg3(iterations, keylen);
    password = $cLL9z(password, $jmEqX, "Password");
    salt = $cLL9z(salt, $jmEqX, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $34e042c92d4dd134$var$resolvePromise($34e042c92d4dd134$var$checkNative(algo).then(function(resp) {
        if (resp) return $34e042c92d4dd134$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $f0ZIh(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("G7Hg3", function(module, exports) {
var $07e9e4c3a6c974da$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $07e9e4c3a6c974da$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("jmEqX", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
var $e18f6fb1dda106ec$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $e18f6fb1dda106ec$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $e18f6fb1dda106ec$var$pVersionMajor = parseInt($6qd2L.version.split(".")[0].slice(1), 10);
    $e18f6fb1dda106ec$var$defaultEncoding = $e18f6fb1dda106ec$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $e18f6fb1dda106ec$var$defaultEncoding = "utf-8";
module.exports = $e18f6fb1dda106ec$var$defaultEncoding;

});

parcelRegister("f0ZIh", function(module, exports) {

var $6mFYn = parcelRequire("6mFYn");

var $5rZkB = parcelRequire("5rZkB");

var $dyOkR = parcelRequire("dyOkR");

var $2iVwY = parcelRequire("2iVwY");
var $aee6ba0eaa5584de$require$Buffer = $2iVwY.Buffer;

var $G7Hg3 = parcelRequire("G7Hg3");

var $jmEqX = parcelRequire("jmEqX");

var $cLL9z = parcelRequire("cLL9z");
var $aee6ba0eaa5584de$var$ZEROS = $aee6ba0eaa5584de$require$Buffer.alloc(128);
var $aee6ba0eaa5584de$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $aee6ba0eaa5584de$var$Hmac(alg, key, saltLen) {
    var hash = $aee6ba0eaa5584de$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $aee6ba0eaa5584de$require$Buffer.concat([
        key,
        $aee6ba0eaa5584de$var$ZEROS
    ], blocksize);
    var ipad = $aee6ba0eaa5584de$require$Buffer.allocUnsafe(blocksize + $aee6ba0eaa5584de$var$sizes[alg]);
    var opad = $aee6ba0eaa5584de$require$Buffer.allocUnsafe(blocksize + $aee6ba0eaa5584de$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $aee6ba0eaa5584de$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $aee6ba0eaa5584de$var$sizes[alg];
}
$aee6ba0eaa5584de$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $aee6ba0eaa5584de$var$getDigest(alg) {
    function shaFunc(data) {
        return $dyOkR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $5rZkB().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $6mFYn;
    return shaFunc;
}
function $aee6ba0eaa5584de$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $G7Hg3(iterations, keylen);
    password = $cLL9z(password, $jmEqX, "Password");
    salt = $cLL9z(salt, $jmEqX, "Salt");
    digest = digest || "sha1";
    var hmac = new $aee6ba0eaa5584de$var$Hmac(digest, password, salt.length);
    var DK = $aee6ba0eaa5584de$require$Buffer.allocUnsafe(keylen);
    var block1 = $aee6ba0eaa5584de$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $aee6ba0eaa5584de$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $aee6ba0eaa5584de$var$pbkdf2;

});
parcelRegister("cLL9z", function(module, exports) {

var $2iVwY = parcelRequire("2iVwY");
var $94be7379e1f60236$require$Buffer = $2iVwY.Buffer;
module.exports = function(thing, encoding, name) {
    if ($94be7379e1f60236$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $94be7379e1f60236$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $94be7379e1f60236$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});



parcelRegister("jn6kT", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $e1a51482643e6872$export$cfaef8ed399428b0; }, function (v) { return $e1a51482643e6872$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $e1a51482643e6872$export$a80c7deaea7cbd80; }, function (v) { return $e1a51482643e6872$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $e1a51482643e6872$export$ed7577ae6e1cd0ef; }, function (v) { return $e1a51482643e6872$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $e1a51482643e6872$export$5dcbef3aa594f567; }, function (v) { return $e1a51482643e6872$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $e1a51482643e6872$export$5bc8001ca71ed9c5; }, function (v) { return $e1a51482643e6872$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $e1a51482643e6872$export$3e714e2c5d5d8cb2; }, function (v) { return $e1a51482643e6872$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $e1a51482643e6872$export$94c3e544fd062b7f; }, function (v) { return $e1a51482643e6872$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $e1a51482643e6872$export$9f77e0932fb78f72; }, function (v) { return $e1a51482643e6872$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $e1a51482643e6872$export$d865ce2836f5927f; }, function (v) { return $e1a51482643e6872$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $e1a51482643e6872$export$95e62ad65da8b7d2; }, function (v) { return $e1a51482643e6872$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $e1a51482643e6872$export$209139ff098c441a; }, function (v) { return $e1a51482643e6872$export$209139ff098c441a = v; });
var $e1a51482643e6872$export$cfaef8ed399428b0;
var $e1a51482643e6872$export$a80c7deaea7cbd80;
var $e1a51482643e6872$export$ed7577ae6e1cd0ef;
var $e1a51482643e6872$export$5dcbef3aa594f567;
var $e1a51482643e6872$export$5bc8001ca71ed9c5;
var $e1a51482643e6872$export$3e714e2c5d5d8cb2;
var $e1a51482643e6872$export$94c3e544fd062b7f;
var $e1a51482643e6872$export$9f77e0932fb78f72;
var $e1a51482643e6872$export$d865ce2836f5927f;
var $e1a51482643e6872$export$95e62ad65da8b7d2;
var $e1a51482643e6872$export$209139ff098c441a;
"use strict";
$e1a51482643e6872$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$e1a51482643e6872$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$e1a51482643e6872$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$e1a51482643e6872$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$e1a51482643e6872$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$e1a51482643e6872$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $e1a51482643e6872$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$e1a51482643e6872$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $e1a51482643e6872$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $e1a51482643e6872$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $e1a51482643e6872$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $e1a51482643e6872$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$e1a51482643e6872$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $e1a51482643e6872$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$e1a51482643e6872$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $e1a51482643e6872$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $e1a51482643e6872$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $e1a51482643e6872$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$e1a51482643e6872$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $e1a51482643e6872$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $e1a51482643e6872$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$e1a51482643e6872$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("DGe5D", function(module, exports) {
"use strict";

var $3HhhI = parcelRequire("3HhhI");
function $077465e344ec3ccf$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $077465e344ec3ccf$var$Cipher;
$077465e344ec3ccf$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$077465e344ec3ccf$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$077465e344ec3ccf$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$077465e344ec3ccf$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$077465e344ec3ccf$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$077465e344ec3ccf$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$077465e344ec3ccf$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$077465e344ec3ccf$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$077465e344ec3ccf$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$077465e344ec3ccf$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$077465e344ec3ccf$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $3HhhI.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("3HhhI", function(module, exports) {
module.exports = $2b12cba0fb516430$var$assert;
function $2b12cba0fb516430$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$2b12cba0fb516430$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("3y8O7", function(module, exports) {
"use strict";

var $3HhhI = parcelRequire("3HhhI");

var $9M38k = parcelRequire("9M38k");

var $jn6kT = parcelRequire("jn6kT");

var $DGe5D = parcelRequire("DGe5D");
function $295b61082e9a09fd$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $295b61082e9a09fd$var$DES(options) {
    $DGe5D.call(this, options);
    var state = new $295b61082e9a09fd$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$9M38k($295b61082e9a09fd$var$DES, $DGe5D);
module.exports = $295b61082e9a09fd$var$DES;
$295b61082e9a09fd$var$DES.create = function create(options) {
    return new $295b61082e9a09fd$var$DES(options);
};
var $295b61082e9a09fd$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$295b61082e9a09fd$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $3HhhI.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $jn6kT.readUInt32BE(key, 0);
    var kR = $jn6kT.readUInt32BE(key, 4);
    $jn6kT.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $295b61082e9a09fd$var$shiftTable[i >>> 1];
        kL = $jn6kT.r28shl(kL, shift);
        kR = $jn6kT.r28shl(kR, shift);
        $jn6kT.pc2(kL, kR, state.keys, i);
    }
};
$295b61082e9a09fd$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $jn6kT.readUInt32BE(inp, inOff);
    var r = $jn6kT.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $jn6kT.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $jn6kT.writeUInt32BE(out, l, outOff);
    $jn6kT.writeUInt32BE(out, r, outOff + 4);
};
$295b61082e9a09fd$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$295b61082e9a09fd$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$3HhhI.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$295b61082e9a09fd$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $jn6kT.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $jn6kT.substitute(keyL, keyR);
        var f = $jn6kT.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $jn6kT.rip(r, l, out, off);
};
$295b61082e9a09fd$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $jn6kT.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $jn6kT.substitute(keyL, keyR);
        var f = $jn6kT.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $jn6kT.rip(l, r, out, off);
};

});

parcelRegister("gmK95", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $bea27efa1be77a34$export$f9bb8d20ccc7477a; }, function (v) { return $bea27efa1be77a34$export$f9bb8d20ccc7477a = v; });
var $bea27efa1be77a34$export$f9bb8d20ccc7477a;
"use strict";

var $3HhhI = parcelRequire("3HhhI");

var $9M38k = parcelRequire("9M38k");
var $bea27efa1be77a34$var$proto = {};
function $bea27efa1be77a34$var$CBCState(iv) {
    $3HhhI.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $bea27efa1be77a34$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $9M38k(CBC, Base);
    var keys = Object.keys($bea27efa1be77a34$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $bea27efa1be77a34$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$bea27efa1be77a34$export$f9bb8d20ccc7477a = $bea27efa1be77a34$var$instantiate;
$bea27efa1be77a34$var$proto._cbcInit = function _cbcInit() {
    var state = new $bea27efa1be77a34$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$bea27efa1be77a34$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("7CBPk", function(module, exports) {
"use strict";

var $3HhhI = parcelRequire("3HhhI");

var $9M38k = parcelRequire("9M38k");

var $DGe5D = parcelRequire("DGe5D");

var $3y8O7 = parcelRequire("3y8O7");
function $58c96c9f78cab1f6$var$EDEState(type, key) {
    $3HhhI.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $3y8O7.create({
            type: "encrypt",
            key: k1
        }),
        $3y8O7.create({
            type: "decrypt",
            key: k2
        }),
        $3y8O7.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $3y8O7.create({
            type: "decrypt",
            key: k3
        }),
        $3y8O7.create({
            type: "encrypt",
            key: k2
        }),
        $3y8O7.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $58c96c9f78cab1f6$var$EDE(options) {
    $DGe5D.call(this, options);
    var state = new $58c96c9f78cab1f6$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$9M38k($58c96c9f78cab1f6$var$EDE, $DGe5D);
module.exports = $58c96c9f78cab1f6$var$EDE;
$58c96c9f78cab1f6$var$EDE.create = function create(options) {
    return new $58c96c9f78cab1f6$var$EDE(options);
};
$58c96c9f78cab1f6$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$58c96c9f78cab1f6$var$EDE.prototype._pad = $3y8O7.prototype._pad;
$58c96c9f78cab1f6$var$EDE.prototype._unpad = $3y8O7.prototype._unpad;

});

parcelRegister("85Pkp", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $5e469b145a0212b7$export$5b0f6292f11d1d18; }, function (v) { return $5e469b145a0212b7$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $5e469b145a0212b7$export$e85a0c9a1067c5d3; }, function (v) { return $5e469b145a0212b7$export$e85a0c9a1067c5d3 = v; });
var $5e469b145a0212b7$export$5b0f6292f11d1d18;
var $5e469b145a0212b7$export$e85a0c9a1067c5d3;
$5e469b145a0212b7$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$5e469b145a0212b7$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("2pjOJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $1c0d49d9d0283a00$export$5b0f6292f11d1d18; }, function (v) { return $1c0d49d9d0283a00$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $1c0d49d9d0283a00$export$e85a0c9a1067c5d3; }, function (v) { return $1c0d49d9d0283a00$export$e85a0c9a1067c5d3 = v; });
var $1c0d49d9d0283a00$export$5b0f6292f11d1d18;
var $1c0d49d9d0283a00$export$e85a0c9a1067c5d3;

var $55HY9 = parcelRequire("55HY9");
$1c0d49d9d0283a00$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $55HY9(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$1c0d49d9d0283a00$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $55HY9(out, pad);
};

});
parcelRegister("55HY9", function(module, exports) {

var $3aNd6 = parcelRequire("3aNd6");
var $3b4f86bcaca4d41d$require$Buffer = $3aNd6.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $3b4f86bcaca4d41d$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("jB2l1", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $e44349566d68ad9d$export$5b0f6292f11d1d18; }, function (v) { return $e44349566d68ad9d$export$5b0f6292f11d1d18 = v; });
var $e44349566d68ad9d$export$5b0f6292f11d1d18;

var $2iVwY = parcelRequire("2iVwY");
var $e44349566d68ad9d$require$Buffer = $2iVwY.Buffer;

var $55HY9 = parcelRequire("55HY9");
function $e44349566d68ad9d$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $55HY9(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $e44349566d68ad9d$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$e44349566d68ad9d$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $e44349566d68ad9d$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $e44349566d68ad9d$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $e44349566d68ad9d$require$Buffer.concat([
                out,
                $e44349566d68ad9d$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $e44349566d68ad9d$require$Buffer.concat([
                out,
                $e44349566d68ad9d$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("iFxgj", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $d975db7b9649af74$export$5b0f6292f11d1d18; }, function (v) { return $d975db7b9649af74$export$5b0f6292f11d1d18 = v; });
var $d975db7b9649af74$export$5b0f6292f11d1d18;

var $2iVwY = parcelRequire("2iVwY");
var $d975db7b9649af74$require$Buffer = $2iVwY.Buffer;
function $d975db7b9649af74$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $d975db7b9649af74$require$Buffer.concat([
        self._prev.slice(1),
        $d975db7b9649af74$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$d975db7b9649af74$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $d975db7b9649af74$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $d975db7b9649af74$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("72Qiw", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $52114990a4ad44f4$export$5b0f6292f11d1d18; }, function (v) { return $52114990a4ad44f4$export$5b0f6292f11d1d18 = v; });
var $52114990a4ad44f4$export$5b0f6292f11d1d18;

var $2iVwY = parcelRequire("2iVwY");
var $52114990a4ad44f4$require$Buffer = $2iVwY.Buffer;
function $52114990a4ad44f4$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $52114990a4ad44f4$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $52114990a4ad44f4$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $52114990a4ad44f4$require$Buffer.allocUnsafe(buffer.length);
    buffer = $52114990a4ad44f4$require$Buffer.concat([
        buffer,
        $52114990a4ad44f4$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$52114990a4ad44f4$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $52114990a4ad44f4$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $52114990a4ad44f4$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("7H3x3", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $599f49f516b06ef1$export$5b0f6292f11d1d18; }, function (v) { return $599f49f516b06ef1$export$5b0f6292f11d1d18 = v; });
var $599f49f516b06ef1$export$5b0f6292f11d1d18;

var $3aNd6 = parcelRequire("3aNd6");
var $599f49f516b06ef1$require$Buffer = $3aNd6.Buffer;

var $55HY9 = parcelRequire("55HY9");
function $599f49f516b06ef1$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$599f49f516b06ef1$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $599f49f516b06ef1$require$Buffer.concat([
        self._cache,
        $599f49f516b06ef1$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $55HY9(chunk, pad);
};

});

parcelRegister("1l11m", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $0f988b5dcbb94715$export$5b0f6292f11d1d18; }, function (v) { return $0f988b5dcbb94715$export$5b0f6292f11d1d18 = v; });
var $0f988b5dcbb94715$export$5b0f6292f11d1d18;

var $55HY9 = parcelRequire("55HY9");

var $2iVwY = parcelRequire("2iVwY");
var $0f988b5dcbb94715$require$Buffer = $2iVwY.Buffer;

var $dxWEj = parcelRequire("dxWEj");
function $0f988b5dcbb94715$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $dxWEj(self._prev);
    return out;
}
var $0f988b5dcbb94715$var$blockSize = 16;
$0f988b5dcbb94715$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $0f988b5dcbb94715$var$blockSize);
    var start = self._cache.length;
    self._cache = $0f988b5dcbb94715$require$Buffer.concat([
        self._cache,
        $0f988b5dcbb94715$require$Buffer.allocUnsafe(chunkNum * $0f988b5dcbb94715$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $0f988b5dcbb94715$var$getBlock(self);
        var offset = start + i * $0f988b5dcbb94715$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $55HY9(chunk, pad);
};

});
parcelRegister("dxWEj", function(module, exports) {
function $9dcbd9ed10b2b6c3$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $9dcbd9ed10b2b6c3$var$incr32;

});


parcelRegister("jIdU0", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("d34BP", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lQohp", function(module, exports) {
var $fe7149c3d8eea021$var$r;
module.exports = function rand(len) {
    if (!$fe7149c3d8eea021$var$r) $fe7149c3d8eea021$var$r = new $fe7149c3d8eea021$var$Rand(null);
    return $fe7149c3d8eea021$var$r.generate(len);
};
function $fe7149c3d8eea021$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $fe7149c3d8eea021$var$Rand;
$fe7149c3d8eea021$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$fe7149c3d8eea021$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $fe7149c3d8eea021$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $fe7149c3d8eea021$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $fe7149c3d8eea021$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $fe7149c3d8eea021$var$crypto = (parcelRequire("1wVs5"));
    if (typeof $fe7149c3d8eea021$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $fe7149c3d8eea021$var$Rand.prototype._rand = function _rand(n) {
        return $fe7149c3d8eea021$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("fE5db", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("2Zf1j", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("6QeS9", function(module, exports) {
"use strict";
var $4fb322c7b092d0a7$var$utils = module.exports;

var $ivl6O = parcelRequire("ivl6O");

var $3HhhI = parcelRequire("3HhhI");

var $6dCtp = parcelRequire("6dCtp");
$4fb322c7b092d0a7$var$utils.assert = $3HhhI;
$4fb322c7b092d0a7$var$utils.toArray = $6dCtp.toArray;
$4fb322c7b092d0a7$var$utils.zero2 = $6dCtp.zero2;
$4fb322c7b092d0a7$var$utils.toHex = $6dCtp.toHex;
$4fb322c7b092d0a7$var$utils.encode = $6dCtp.encode;
// Represent num in a w-NAF form
function $4fb322c7b092d0a7$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$4fb322c7b092d0a7$var$utils.getNAF = $4fb322c7b092d0a7$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $4fb322c7b092d0a7$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$4fb322c7b092d0a7$var$utils.getJSF = $4fb322c7b092d0a7$var$getJSF;
function $4fb322c7b092d0a7$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$4fb322c7b092d0a7$var$utils.cachedProperty = $4fb322c7b092d0a7$var$cachedProperty;
function $4fb322c7b092d0a7$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $4fb322c7b092d0a7$var$utils.toArray(bytes, "hex") : bytes;
}
$4fb322c7b092d0a7$var$utils.parseBytes = $4fb322c7b092d0a7$var$parseBytes;
function $4fb322c7b092d0a7$var$intFromLE(bytes) {
    return new $ivl6O(bytes, "hex", "le");
}
$4fb322c7b092d0a7$var$utils.intFromLE = $4fb322c7b092d0a7$var$intFromLE;

});
parcelRegister("ivl6O", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("6dCtp", function(module, exports) {
"use strict";
var $4871ccf58d45b2be$var$utils = module.exports;
function $4871ccf58d45b2be$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$4871ccf58d45b2be$var$utils.toArray = $4871ccf58d45b2be$var$toArray;
function $4871ccf58d45b2be$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$4871ccf58d45b2be$var$utils.zero2 = $4871ccf58d45b2be$var$zero2;
function $4871ccf58d45b2be$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $4871ccf58d45b2be$var$zero2(msg[i].toString(16));
    return res;
}
$4871ccf58d45b2be$var$utils.toHex = $4871ccf58d45b2be$var$toHex;
$4871ccf58d45b2be$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $4871ccf58d45b2be$var$toHex(arr);
    else return arr;
};

});


parcelRegister("ku149", function(module, exports) {
"use strict";
var $ee976faeddc2f34b$var$curve = module.exports;

$ee976faeddc2f34b$var$curve.base = (parcelRequire("5dI8g"));

$ee976faeddc2f34b$var$curve.short = (parcelRequire("4g1cT"));

$ee976faeddc2f34b$var$curve.mont = (parcelRequire("kNrGu"));

$ee976faeddc2f34b$var$curve.edwards = (parcelRequire("8akTx"));

});
parcelRegister("5dI8g", function(module, exports) {
"use strict";

var $ivl6O = parcelRequire("ivl6O");

var $6QeS9 = parcelRequire("6QeS9");
var $3cd0666d0fe353f1$var$getNAF = $6QeS9.getNAF;
var $3cd0666d0fe353f1$var$getJSF = $6QeS9.getJSF;
var $3cd0666d0fe353f1$var$assert = $6QeS9.assert;
function $3cd0666d0fe353f1$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $ivl6O(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $ivl6O.red(conf.prime) : $ivl6O.mont(this.p);
    // Useful for many curves
    this.zero = new $ivl6O(0).toRed(this.red);
    this.one = new $ivl6O(1).toRed(this.red);
    this.two = new $ivl6O(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $ivl6O(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $3cd0666d0fe353f1$var$BaseCurve;
$3cd0666d0fe353f1$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$3cd0666d0fe353f1$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$3cd0666d0fe353f1$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $3cd0666d0fe353f1$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $3cd0666d0fe353f1$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$3cd0666d0fe353f1$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $3cd0666d0fe353f1$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $3cd0666d0fe353f1$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$3cd0666d0fe353f1$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $3cd0666d0fe353f1$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $3cd0666d0fe353f1$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $3cd0666d0fe353f1$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $3cd0666d0fe353f1$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$3cd0666d0fe353f1$var$BaseCurve.BasePoint = $3cd0666d0fe353f1$var$BasePoint;
$3cd0666d0fe353f1$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$3cd0666d0fe353f1$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$3cd0666d0fe353f1$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $6QeS9.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $3cd0666d0fe353f1$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $3cd0666d0fe353f1$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$3cd0666d0fe353f1$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$3cd0666d0fe353f1$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$3cd0666d0fe353f1$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $6QeS9.encode(this._encode(compact), enc);
};
$3cd0666d0fe353f1$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$3cd0666d0fe353f1$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$3cd0666d0fe353f1$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$3cd0666d0fe353f1$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$3cd0666d0fe353f1$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$3cd0666d0fe353f1$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("4g1cT", function(module, exports) {
"use strict";

var $6QeS9 = parcelRequire("6QeS9");

var $ivl6O = parcelRequire("ivl6O");

var $9M38k = parcelRequire("9M38k");

var $5dI8g = parcelRequire("5dI8g");
var $319997b4d67b1b2b$var$assert = $6QeS9.assert;
function $319997b4d67b1b2b$var$ShortCurve(conf) {
    $5dI8g.call(this, "short", conf);
    this.a = new $ivl6O(conf.a, 16).toRed(this.red);
    this.b = new $ivl6O(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$9M38k($319997b4d67b1b2b$var$ShortCurve, $5dI8g);
module.exports = $319997b4d67b1b2b$var$ShortCurve;
$319997b4d67b1b2b$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $ivl6O(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $ivl6O(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $319997b4d67b1b2b$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $ivl6O(vec.a, 16),
            b: new $ivl6O(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$319997b4d67b1b2b$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $ivl6O.mont(num);
    var tinv = new $ivl6O(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $ivl6O(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$319997b4d67b1b2b$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $ivl6O(1);
    var y1 = new $ivl6O(0);
    var x2 = new $ivl6O(0);
    var y2 = new $ivl6O(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$319997b4d67b1b2b$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$319997b4d67b1b2b$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $ivl6O(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$319997b4d67b1b2b$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$319997b4d67b1b2b$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $319997b4d67b1b2b$var$Point(curve, x, y, isRed) {
    $5dI8g.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $ivl6O(x, 16);
        this.y = new $ivl6O(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$9M38k($319997b4d67b1b2b$var$Point, $5dI8g.BasePoint);
$319997b4d67b1b2b$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $319997b4d67b1b2b$var$Point(this, x, y, isRed);
};
$319997b4d67b1b2b$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $319997b4d67b1b2b$var$Point.fromJSON(this, obj, red);
};
$319997b4d67b1b2b$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$319997b4d67b1b2b$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$319997b4d67b1b2b$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$319997b4d67b1b2b$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$319997b4d67b1b2b$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$319997b4d67b1b2b$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$319997b4d67b1b2b$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$319997b4d67b1b2b$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$319997b4d67b1b2b$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$319997b4d67b1b2b$var$Point.prototype.mul = function mul(k) {
    k = new $ivl6O(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$319997b4d67b1b2b$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$319997b4d67b1b2b$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$319997b4d67b1b2b$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$319997b4d67b1b2b$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$319997b4d67b1b2b$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $319997b4d67b1b2b$var$JPoint(curve, x, y, z) {
    $5dI8g.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $ivl6O(0);
    } else {
        this.x = new $ivl6O(x, 16);
        this.y = new $ivl6O(y, 16);
        this.z = new $ivl6O(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$9M38k($319997b4d67b1b2b$var$JPoint, $5dI8g.BasePoint);
$319997b4d67b1b2b$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $319997b4d67b1b2b$var$JPoint(this, x, y, z);
};
$319997b4d67b1b2b$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$319997b4d67b1b2b$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$319997b4d67b1b2b$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$319997b4d67b1b2b$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$319997b4d67b1b2b$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$319997b4d67b1b2b$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$319997b4d67b1b2b$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$319997b4d67b1b2b$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$319997b4d67b1b2b$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$319997b4d67b1b2b$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$319997b4d67b1b2b$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $ivl6O(k, kbase);
    return this.curve._wnafMul(this, k);
};
$319997b4d67b1b2b$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$319997b4d67b1b2b$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$319997b4d67b1b2b$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$319997b4d67b1b2b$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("kNrGu", function(module, exports) {
"use strict";

var $ivl6O = parcelRequire("ivl6O");

var $9M38k = parcelRequire("9M38k");

var $5dI8g = parcelRequire("5dI8g");

var $6QeS9 = parcelRequire("6QeS9");
function $f23ddbcc61ada7d7$var$MontCurve(conf) {
    $5dI8g.call(this, "mont", conf);
    this.a = new $ivl6O(conf.a, 16).toRed(this.red);
    this.b = new $ivl6O(conf.b, 16).toRed(this.red);
    this.i4 = new $ivl6O(4).toRed(this.red).redInvm();
    this.two = new $ivl6O(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$9M38k($f23ddbcc61ada7d7$var$MontCurve, $5dI8g);
module.exports = $f23ddbcc61ada7d7$var$MontCurve;
$f23ddbcc61ada7d7$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $f23ddbcc61ada7d7$var$Point(curve, x, z) {
    $5dI8g.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $ivl6O(x, 16);
        this.z = new $ivl6O(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$9M38k($f23ddbcc61ada7d7$var$Point, $5dI8g.BasePoint);
$f23ddbcc61ada7d7$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($6QeS9.toArray(bytes, enc), 1);
};
$f23ddbcc61ada7d7$var$MontCurve.prototype.point = function point(x, z) {
    return new $f23ddbcc61ada7d7$var$Point(this, x, z);
};
$f23ddbcc61ada7d7$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $f23ddbcc61ada7d7$var$Point.fromJSON(this, obj);
};
$f23ddbcc61ada7d7$var$Point.prototype.precompute = function precompute() {
// No-op
};
$f23ddbcc61ada7d7$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$f23ddbcc61ada7d7$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $f23ddbcc61ada7d7$var$Point(curve, obj[0], obj[1] || curve.one);
};
$f23ddbcc61ada7d7$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$f23ddbcc61ada7d7$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$f23ddbcc61ada7d7$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$f23ddbcc61ada7d7$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$f23ddbcc61ada7d7$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$f23ddbcc61ada7d7$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$f23ddbcc61ada7d7$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$f23ddbcc61ada7d7$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$f23ddbcc61ada7d7$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$f23ddbcc61ada7d7$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$f23ddbcc61ada7d7$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("8akTx", function(module, exports) {
"use strict";

var $6QeS9 = parcelRequire("6QeS9");

var $ivl6O = parcelRequire("ivl6O");

var $9M38k = parcelRequire("9M38k");

var $5dI8g = parcelRequire("5dI8g");
var $5f1f772aeb113a28$var$assert = $6QeS9.assert;
function $5f1f772aeb113a28$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $5dI8g.call(this, "edwards", conf);
    this.a = new $ivl6O(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $ivl6O(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $ivl6O(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $5f1f772aeb113a28$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$9M38k($5f1f772aeb113a28$var$EdwardsCurve, $5dI8g);
module.exports = $5f1f772aeb113a28$var$EdwardsCurve;
$5f1f772aeb113a28$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$5f1f772aeb113a28$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$5f1f772aeb113a28$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$5f1f772aeb113a28$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $ivl6O(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$5f1f772aeb113a28$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $ivl6O(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$5f1f772aeb113a28$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $5f1f772aeb113a28$var$Point(curve, x, y, z, t) {
    $5dI8g.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $ivl6O(x, 16);
        this.y = new $ivl6O(y, 16);
        this.z = z ? new $ivl6O(z, 16) : this.curve.one;
        this.t = t && new $ivl6O(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$9M38k($5f1f772aeb113a28$var$Point, $5dI8g.BasePoint);
$5f1f772aeb113a28$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $5f1f772aeb113a28$var$Point.fromJSON(this, obj);
};
$5f1f772aeb113a28$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $5f1f772aeb113a28$var$Point(this, x, y, z, t);
};
$5f1f772aeb113a28$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $5f1f772aeb113a28$var$Point(curve, obj[0], obj[1], obj[2]);
};
$5f1f772aeb113a28$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$5f1f772aeb113a28$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$5f1f772aeb113a28$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$5f1f772aeb113a28$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$5f1f772aeb113a28$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$5f1f772aeb113a28$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$5f1f772aeb113a28$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$5f1f772aeb113a28$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$5f1f772aeb113a28$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$5f1f772aeb113a28$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$5f1f772aeb113a28$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$5f1f772aeb113a28$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$5f1f772aeb113a28$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$5f1f772aeb113a28$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$5f1f772aeb113a28$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$5f1f772aeb113a28$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$5f1f772aeb113a28$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$5f1f772aeb113a28$var$Point.prototype.toP = $5f1f772aeb113a28$var$Point.prototype.normalize;
$5f1f772aeb113a28$var$Point.prototype.mixedAdd = $5f1f772aeb113a28$var$Point.prototype.add;

});


parcelRegister("awhMH", function(module, exports) {
"use strict";
var $7a8ab02cd48b5de6$var$curves = module.exports;

var $9uYJF = parcelRequire("9uYJF");

var $ku149 = parcelRequire("ku149");

var $6QeS9 = parcelRequire("6QeS9");
var $7a8ab02cd48b5de6$var$assert = $6QeS9.assert;
function $7a8ab02cd48b5de6$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $ku149.short(options);
    else if (options.type === "edwards") this.curve = new $ku149.edwards(options);
    else this.curve = new $ku149.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $7a8ab02cd48b5de6$var$assert(this.g.validate(), "Invalid curve");
    $7a8ab02cd48b5de6$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$7a8ab02cd48b5de6$var$curves.PresetCurve = $7a8ab02cd48b5de6$var$PresetCurve;
function $7a8ab02cd48b5de6$var$defineCurve(name, options) {
    Object.defineProperty($7a8ab02cd48b5de6$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $7a8ab02cd48b5de6$var$PresetCurve(options);
            Object.defineProperty($7a8ab02cd48b5de6$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$7a8ab02cd48b5de6$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $9uYJF.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$7a8ab02cd48b5de6$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $9uYJF.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$7a8ab02cd48b5de6$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $9uYJF.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$7a8ab02cd48b5de6$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $9uYJF.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$7a8ab02cd48b5de6$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $9uYJF.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$7a8ab02cd48b5de6$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $9uYJF.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$7a8ab02cd48b5de6$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $9uYJF.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $7a8ab02cd48b5de6$var$pre;

try {
    $7a8ab02cd48b5de6$var$pre = (parcelRequire("cjJ4Z"));
} catch (e) {
    $7a8ab02cd48b5de6$var$pre = undefined;
}
$7a8ab02cd48b5de6$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $9uYJF.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $7a8ab02cd48b5de6$var$pre
    ]
});

});
parcelRegister("9uYJF", function(module, exports) {
var $6ea6073ac8c9a5a1$var$hash = module.exports;

$6ea6073ac8c9a5a1$var$hash.utils = (parcelRequire("6Q6eW"));

$6ea6073ac8c9a5a1$var$hash.common = (parcelRequire("8VZkF"));

$6ea6073ac8c9a5a1$var$hash.sha = (parcelRequire("25CHA"));

$6ea6073ac8c9a5a1$var$hash.ripemd = (parcelRequire("k2Ctf"));

$6ea6073ac8c9a5a1$var$hash.hmac = (parcelRequire("l5NpJ"));
// Proxy hash functions to the main object
$6ea6073ac8c9a5a1$var$hash.sha1 = $6ea6073ac8c9a5a1$var$hash.sha.sha1;
$6ea6073ac8c9a5a1$var$hash.sha256 = $6ea6073ac8c9a5a1$var$hash.sha.sha256;
$6ea6073ac8c9a5a1$var$hash.sha224 = $6ea6073ac8c9a5a1$var$hash.sha.sha224;
$6ea6073ac8c9a5a1$var$hash.sha384 = $6ea6073ac8c9a5a1$var$hash.sha.sha384;
$6ea6073ac8c9a5a1$var$hash.sha512 = $6ea6073ac8c9a5a1$var$hash.sha.sha512;
$6ea6073ac8c9a5a1$var$hash.ripemd160 = $6ea6073ac8c9a5a1$var$hash.ripemd.ripemd160;

});
parcelRegister("6Q6eW", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $4fac708d00383443$export$69f1b2dcda23c5f8; }, function (v) { return $4fac708d00383443$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $4fac708d00383443$export$45b10814cc054894; }, function (v) { return $4fac708d00383443$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $4fac708d00383443$export$7ea66e3774a60b67; }, function (v) { return $4fac708d00383443$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $4fac708d00383443$export$34a52f00f601f6f1; }, function (v) { return $4fac708d00383443$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $4fac708d00383443$export$812b0cbd5e8a72ab; }, function (v) { return $4fac708d00383443$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $4fac708d00383443$export$f24f9e11d63bb314; }, function (v) { return $4fac708d00383443$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $4fac708d00383443$export$b71357c7e07ca1f1; }, function (v) { return $4fac708d00383443$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $4fac708d00383443$export$2e58a4b541fdcbe8; }, function (v) { return $4fac708d00383443$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $4fac708d00383443$export$183b950bde9faab8; }, function (v) { return $4fac708d00383443$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $4fac708d00383443$export$4785c77169fea59e; }, function (v) { return $4fac708d00383443$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $4fac708d00383443$export$242a185dfcffac5b; }, function (v) { return $4fac708d00383443$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $4fac708d00383443$export$58c04ae0ae31877d; }, function (v) { return $4fac708d00383443$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $4fac708d00383443$export$d058ca695f8c6f11; }, function (v) { return $4fac708d00383443$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $4fac708d00383443$export$a1efd7fc3e986367; }, function (v) { return $4fac708d00383443$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $4fac708d00383443$export$bbfea4a2b5abaab4; }, function (v) { return $4fac708d00383443$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $4fac708d00383443$export$97ad4afc7de86152; }, function (v) { return $4fac708d00383443$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $4fac708d00383443$export$ce4673d9a79f6a4b; }, function (v) { return $4fac708d00383443$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $4fac708d00383443$export$786cc99fc6eedc0b; }, function (v) { return $4fac708d00383443$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $4fac708d00383443$export$45c59b9a1848dd0; }, function (v) { return $4fac708d00383443$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $4fac708d00383443$export$50d8f613e76d3034; }, function (v) { return $4fac708d00383443$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $4fac708d00383443$export$b8e83683c60ee162; }, function (v) { return $4fac708d00383443$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $4fac708d00383443$export$aeeb51790d1bcc4a; }, function (v) { return $4fac708d00383443$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $4fac708d00383443$export$bb7c616f719ad9c; }, function (v) { return $4fac708d00383443$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $4fac708d00383443$export$4d63290824f9d7df; }, function (v) { return $4fac708d00383443$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $4fac708d00383443$export$2f64ceb90ef28ea1; }, function (v) { return $4fac708d00383443$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $4fac708d00383443$export$8d2089d465f6d10d; }, function (v) { return $4fac708d00383443$export$8d2089d465f6d10d = v; });
var $4fac708d00383443$export$69f1b2dcda23c5f8;
var $4fac708d00383443$export$45b10814cc054894;
var $4fac708d00383443$export$7ea66e3774a60b67;
var $4fac708d00383443$export$34a52f00f601f6f1;
var $4fac708d00383443$export$812b0cbd5e8a72ab;
var $4fac708d00383443$export$f24f9e11d63bb314;
var $4fac708d00383443$export$b71357c7e07ca1f1;
var $4fac708d00383443$export$2e58a4b541fdcbe8;
var $4fac708d00383443$export$183b950bde9faab8;
var $4fac708d00383443$export$4785c77169fea59e;
var $4fac708d00383443$export$242a185dfcffac5b;
var $4fac708d00383443$export$58c04ae0ae31877d;
var $4fac708d00383443$export$d058ca695f8c6f11;
var $4fac708d00383443$export$a1efd7fc3e986367;
var $4fac708d00383443$export$bbfea4a2b5abaab4;
var $4fac708d00383443$export$97ad4afc7de86152;
var $4fac708d00383443$export$ce4673d9a79f6a4b;
var $4fac708d00383443$export$786cc99fc6eedc0b;
var $4fac708d00383443$export$45c59b9a1848dd0;
var $4fac708d00383443$export$50d8f613e76d3034;
var $4fac708d00383443$export$b8e83683c60ee162;
var $4fac708d00383443$export$aeeb51790d1bcc4a;
var $4fac708d00383443$export$bb7c616f719ad9c;
var $4fac708d00383443$export$4d63290824f9d7df;
var $4fac708d00383443$export$2f64ceb90ef28ea1;
var $4fac708d00383443$export$8d2089d465f6d10d;
"use strict";

var $3HhhI = parcelRequire("3HhhI");

var $9M38k = parcelRequire("9M38k");
$4fac708d00383443$export$69f1b2dcda23c5f8 = $9M38k;
function $4fac708d00383443$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $4fac708d00383443$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($4fac708d00383443$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$4fac708d00383443$export$45b10814cc054894 = $4fac708d00383443$var$toArray;
function $4fac708d00383443$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $4fac708d00383443$var$zero2(msg[i].toString(16));
    return res;
}
$4fac708d00383443$export$7ea66e3774a60b67 = $4fac708d00383443$var$toHex;
function $4fac708d00383443$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$4fac708d00383443$export$34a52f00f601f6f1 = $4fac708d00383443$var$htonl;
function $4fac708d00383443$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $4fac708d00383443$var$htonl(w);
        res += $4fac708d00383443$var$zero8(w.toString(16));
    }
    return res;
}
$4fac708d00383443$export$812b0cbd5e8a72ab = $4fac708d00383443$var$toHex32;
function $4fac708d00383443$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$4fac708d00383443$export$f24f9e11d63bb314 = $4fac708d00383443$var$zero2;
function $4fac708d00383443$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$4fac708d00383443$export$b71357c7e07ca1f1 = $4fac708d00383443$var$zero8;
function $4fac708d00383443$var$join32(msg, start, end, endian) {
    var len = end - start;
    $3HhhI(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$4fac708d00383443$export$2e58a4b541fdcbe8 = $4fac708d00383443$var$join32;
function $4fac708d00383443$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$4fac708d00383443$export$183b950bde9faab8 = $4fac708d00383443$var$split32;
function $4fac708d00383443$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$4fac708d00383443$export$4785c77169fea59e = $4fac708d00383443$var$rotr32;
function $4fac708d00383443$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$4fac708d00383443$export$242a185dfcffac5b = $4fac708d00383443$var$rotl32;
function $4fac708d00383443$var$sum32(a, b) {
    return a + b >>> 0;
}
$4fac708d00383443$export$58c04ae0ae31877d = $4fac708d00383443$var$sum32;
function $4fac708d00383443$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$4fac708d00383443$export$d058ca695f8c6f11 = $4fac708d00383443$var$sum32_3;
function $4fac708d00383443$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$4fac708d00383443$export$a1efd7fc3e986367 = $4fac708d00383443$var$sum32_4;
function $4fac708d00383443$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$4fac708d00383443$export$bbfea4a2b5abaab4 = $4fac708d00383443$var$sum32_5;
function $4fac708d00383443$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$4fac708d00383443$export$97ad4afc7de86152 = $4fac708d00383443$var$sum64;
function $4fac708d00383443$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$4fac708d00383443$export$ce4673d9a79f6a4b = $4fac708d00383443$var$sum64_hi;
function $4fac708d00383443$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$4fac708d00383443$export$786cc99fc6eedc0b = $4fac708d00383443$var$sum64_lo;
function $4fac708d00383443$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$4fac708d00383443$export$45c59b9a1848dd0 = $4fac708d00383443$var$sum64_4_hi;
function $4fac708d00383443$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$4fac708d00383443$export$50d8f613e76d3034 = $4fac708d00383443$var$sum64_4_lo;
function $4fac708d00383443$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$4fac708d00383443$export$b8e83683c60ee162 = $4fac708d00383443$var$sum64_5_hi;
function $4fac708d00383443$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$4fac708d00383443$export$aeeb51790d1bcc4a = $4fac708d00383443$var$sum64_5_lo;
function $4fac708d00383443$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$4fac708d00383443$export$bb7c616f719ad9c = $4fac708d00383443$var$rotr64_hi;
function $4fac708d00383443$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$4fac708d00383443$export$4d63290824f9d7df = $4fac708d00383443$var$rotr64_lo;
function $4fac708d00383443$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$4fac708d00383443$export$2f64ceb90ef28ea1 = $4fac708d00383443$var$shr64_hi;
function $4fac708d00383443$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$4fac708d00383443$export$8d2089d465f6d10d = $4fac708d00383443$var$shr64_lo;

});

parcelRegister("8VZkF", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $681338e6d9aeb4fc$export$8687658379b577e6; }, function (v) { return $681338e6d9aeb4fc$export$8687658379b577e6 = v; });
var $681338e6d9aeb4fc$export$8687658379b577e6;
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");

var $3HhhI = parcelRequire("3HhhI");
function $681338e6d9aeb4fc$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$681338e6d9aeb4fc$export$8687658379b577e6 = $681338e6d9aeb4fc$var$BlockHash;
$681338e6d9aeb4fc$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $6Q6eW.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $6Q6eW.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$681338e6d9aeb4fc$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $3HhhI(this.pending === null);
    return this._digest(enc);
};
$681338e6d9aeb4fc$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("25CHA", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $185a11cc7f9d2e82$export$5091bdda49ba90f5; }, function (v) { return $185a11cc7f9d2e82$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $185a11cc7f9d2e82$export$97b70509d4e397ea; }, function (v) { return $185a11cc7f9d2e82$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $185a11cc7f9d2e82$export$bced8d2aada2d1c9; }, function (v) { return $185a11cc7f9d2e82$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $185a11cc7f9d2e82$export$612d47d55dedde45; }, function (v) { return $185a11cc7f9d2e82$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $185a11cc7f9d2e82$export$a888d2532e6dc7bb; }, function (v) { return $185a11cc7f9d2e82$export$a888d2532e6dc7bb = v; });
var $185a11cc7f9d2e82$export$5091bdda49ba90f5;
var $185a11cc7f9d2e82$export$97b70509d4e397ea;
var $185a11cc7f9d2e82$export$bced8d2aada2d1c9;
var $185a11cc7f9d2e82$export$612d47d55dedde45;
var $185a11cc7f9d2e82$export$a888d2532e6dc7bb;
"use strict";

$185a11cc7f9d2e82$export$5091bdda49ba90f5 = (parcelRequire("5rHBt"));

$185a11cc7f9d2e82$export$97b70509d4e397ea = (parcelRequire("hIA7b"));

$185a11cc7f9d2e82$export$bced8d2aada2d1c9 = (parcelRequire("2XoRY"));

$185a11cc7f9d2e82$export$612d47d55dedde45 = (parcelRequire("5fGdA"));

$185a11cc7f9d2e82$export$a888d2532e6dc7bb = (parcelRequire("lajWD"));

});
parcelRegister("5rHBt", function(module, exports) {
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");

var $8VZkF = parcelRequire("8VZkF");

var $c4BvY = parcelRequire("c4BvY");
var $3f714c167d52894f$var$rotl32 = $6Q6eW.rotl32;
var $3f714c167d52894f$var$sum32 = $6Q6eW.sum32;
var $3f714c167d52894f$var$sum32_5 = $6Q6eW.sum32_5;
var $3f714c167d52894f$var$ft_1 = $c4BvY.ft_1;
var $3f714c167d52894f$var$BlockHash = $8VZkF.BlockHash;
var $3f714c167d52894f$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $3f714c167d52894f$var$SHA1() {
    if (!(this instanceof $3f714c167d52894f$var$SHA1)) return new $3f714c167d52894f$var$SHA1();
    $3f714c167d52894f$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$6Q6eW.inherits($3f714c167d52894f$var$SHA1, $3f714c167d52894f$var$BlockHash);
module.exports = $3f714c167d52894f$var$SHA1;
$3f714c167d52894f$var$SHA1.blockSize = 512;
$3f714c167d52894f$var$SHA1.outSize = 160;
$3f714c167d52894f$var$SHA1.hmacStrength = 80;
$3f714c167d52894f$var$SHA1.padLength = 64;
$3f714c167d52894f$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $3f714c167d52894f$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $3f714c167d52894f$var$sum32_5($3f714c167d52894f$var$rotl32(a, 5), $3f714c167d52894f$var$ft_1(s, b, c, d), e, W[i], $3f714c167d52894f$var$sha1_K[s]);
        e = d;
        d = c;
        c = $3f714c167d52894f$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $3f714c167d52894f$var$sum32(this.h[0], a);
    this.h[1] = $3f714c167d52894f$var$sum32(this.h[1], b);
    this.h[2] = $3f714c167d52894f$var$sum32(this.h[2], c);
    this.h[3] = $3f714c167d52894f$var$sum32(this.h[3], d);
    this.h[4] = $3f714c167d52894f$var$sum32(this.h[4], e);
};
$3f714c167d52894f$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6Q6eW.toHex32(this.h, "big");
    else return $6Q6eW.split32(this.h, "big");
};

});
parcelRegister("c4BvY", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $8ca2f562e1f5070a$export$5a92649d7ddb9f63; }, function (v) { return $8ca2f562e1f5070a$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $8ca2f562e1f5070a$export$c6d0d020c3a6269; }, function (v) { return $8ca2f562e1f5070a$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $8ca2f562e1f5070a$export$eb90c27fca05f956; }, function (v) { return $8ca2f562e1f5070a$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $8ca2f562e1f5070a$export$14a4a98e063b1999; }, function (v) { return $8ca2f562e1f5070a$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $8ca2f562e1f5070a$export$d20cecfa1564c686; }, function (v) { return $8ca2f562e1f5070a$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $8ca2f562e1f5070a$export$44fd472a12fc6db; }, function (v) { return $8ca2f562e1f5070a$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $8ca2f562e1f5070a$export$1ed238bb6ea1dd47; }, function (v) { return $8ca2f562e1f5070a$export$1ed238bb6ea1dd47 = v; });
var $8ca2f562e1f5070a$export$5a92649d7ddb9f63;
var $8ca2f562e1f5070a$export$c6d0d020c3a6269;
var $8ca2f562e1f5070a$export$eb90c27fca05f956;
var $8ca2f562e1f5070a$export$cc992891a14496a1;
var $8ca2f562e1f5070a$export$14a4a98e063b1999;
var $8ca2f562e1f5070a$export$d20cecfa1564c686;
var $8ca2f562e1f5070a$export$44fd472a12fc6db;
var $8ca2f562e1f5070a$export$1ed238bb6ea1dd47;
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");
var $8ca2f562e1f5070a$var$rotr32 = $6Q6eW.rotr32;
function $8ca2f562e1f5070a$var$ft_1(s, x, y, z) {
    if (s === 0) return $8ca2f562e1f5070a$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $8ca2f562e1f5070a$var$p32(x, y, z);
    if (s === 2) return $8ca2f562e1f5070a$var$maj32(x, y, z);
}
$8ca2f562e1f5070a$export$5a92649d7ddb9f63 = $8ca2f562e1f5070a$var$ft_1;
function $8ca2f562e1f5070a$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$8ca2f562e1f5070a$export$c6d0d020c3a6269 = $8ca2f562e1f5070a$var$ch32;
function $8ca2f562e1f5070a$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$8ca2f562e1f5070a$export$eb90c27fca05f956 = $8ca2f562e1f5070a$var$maj32;
function $8ca2f562e1f5070a$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$8ca2f562e1f5070a$export$cc992891a14496a1 = $8ca2f562e1f5070a$var$p32;
function $8ca2f562e1f5070a$var$s0_256(x) {
    return $8ca2f562e1f5070a$var$rotr32(x, 2) ^ $8ca2f562e1f5070a$var$rotr32(x, 13) ^ $8ca2f562e1f5070a$var$rotr32(x, 22);
}
$8ca2f562e1f5070a$export$14a4a98e063b1999 = $8ca2f562e1f5070a$var$s0_256;
function $8ca2f562e1f5070a$var$s1_256(x) {
    return $8ca2f562e1f5070a$var$rotr32(x, 6) ^ $8ca2f562e1f5070a$var$rotr32(x, 11) ^ $8ca2f562e1f5070a$var$rotr32(x, 25);
}
$8ca2f562e1f5070a$export$d20cecfa1564c686 = $8ca2f562e1f5070a$var$s1_256;
function $8ca2f562e1f5070a$var$g0_256(x) {
    return $8ca2f562e1f5070a$var$rotr32(x, 7) ^ $8ca2f562e1f5070a$var$rotr32(x, 18) ^ x >>> 3;
}
$8ca2f562e1f5070a$export$44fd472a12fc6db = $8ca2f562e1f5070a$var$g0_256;
function $8ca2f562e1f5070a$var$g1_256(x) {
    return $8ca2f562e1f5070a$var$rotr32(x, 17) ^ $8ca2f562e1f5070a$var$rotr32(x, 19) ^ x >>> 10;
}
$8ca2f562e1f5070a$export$1ed238bb6ea1dd47 = $8ca2f562e1f5070a$var$g1_256;

});


parcelRegister("hIA7b", function(module, exports) {
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");

var $2XoRY = parcelRequire("2XoRY");
function $ce628f61c71bf940$var$SHA224() {
    if (!(this instanceof $ce628f61c71bf940$var$SHA224)) return new $ce628f61c71bf940$var$SHA224();
    $2XoRY.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$6Q6eW.inherits($ce628f61c71bf940$var$SHA224, $2XoRY);
module.exports = $ce628f61c71bf940$var$SHA224;
$ce628f61c71bf940$var$SHA224.blockSize = 512;
$ce628f61c71bf940$var$SHA224.outSize = 224;
$ce628f61c71bf940$var$SHA224.hmacStrength = 192;
$ce628f61c71bf940$var$SHA224.padLength = 64;
$ce628f61c71bf940$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $6Q6eW.toHex32(this.h.slice(0, 7), "big");
    else return $6Q6eW.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("2XoRY", function(module, exports) {
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");

var $8VZkF = parcelRequire("8VZkF");

var $c4BvY = parcelRequire("c4BvY");

var $3HhhI = parcelRequire("3HhhI");
var $2274620deb3dddea$var$sum32 = $6Q6eW.sum32;
var $2274620deb3dddea$var$sum32_4 = $6Q6eW.sum32_4;
var $2274620deb3dddea$var$sum32_5 = $6Q6eW.sum32_5;
var $2274620deb3dddea$var$ch32 = $c4BvY.ch32;
var $2274620deb3dddea$var$maj32 = $c4BvY.maj32;
var $2274620deb3dddea$var$s0_256 = $c4BvY.s0_256;
var $2274620deb3dddea$var$s1_256 = $c4BvY.s1_256;
var $2274620deb3dddea$var$g0_256 = $c4BvY.g0_256;
var $2274620deb3dddea$var$g1_256 = $c4BvY.g1_256;
var $2274620deb3dddea$var$BlockHash = $8VZkF.BlockHash;
var $2274620deb3dddea$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $2274620deb3dddea$var$SHA256() {
    if (!(this instanceof $2274620deb3dddea$var$SHA256)) return new $2274620deb3dddea$var$SHA256();
    $2274620deb3dddea$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $2274620deb3dddea$var$sha256_K;
    this.W = new Array(64);
}
$6Q6eW.inherits($2274620deb3dddea$var$SHA256, $2274620deb3dddea$var$BlockHash);
module.exports = $2274620deb3dddea$var$SHA256;
$2274620deb3dddea$var$SHA256.blockSize = 512;
$2274620deb3dddea$var$SHA256.outSize = 256;
$2274620deb3dddea$var$SHA256.hmacStrength = 192;
$2274620deb3dddea$var$SHA256.padLength = 64;
$2274620deb3dddea$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $2274620deb3dddea$var$sum32_4($2274620deb3dddea$var$g1_256(W[i - 2]), W[i - 7], $2274620deb3dddea$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $3HhhI(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $2274620deb3dddea$var$sum32_5(h, $2274620deb3dddea$var$s1_256(e), $2274620deb3dddea$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $2274620deb3dddea$var$sum32($2274620deb3dddea$var$s0_256(a), $2274620deb3dddea$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $2274620deb3dddea$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $2274620deb3dddea$var$sum32(T1, T2);
    }
    this.h[0] = $2274620deb3dddea$var$sum32(this.h[0], a);
    this.h[1] = $2274620deb3dddea$var$sum32(this.h[1], b);
    this.h[2] = $2274620deb3dddea$var$sum32(this.h[2], c);
    this.h[3] = $2274620deb3dddea$var$sum32(this.h[3], d);
    this.h[4] = $2274620deb3dddea$var$sum32(this.h[4], e);
    this.h[5] = $2274620deb3dddea$var$sum32(this.h[5], f);
    this.h[6] = $2274620deb3dddea$var$sum32(this.h[6], g);
    this.h[7] = $2274620deb3dddea$var$sum32(this.h[7], h);
};
$2274620deb3dddea$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6Q6eW.toHex32(this.h, "big");
    else return $6Q6eW.split32(this.h, "big");
};

});


parcelRegister("5fGdA", function(module, exports) {
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");

var $lajWD = parcelRequire("lajWD");
function $3d2f1a1d10cc5741$var$SHA384() {
    if (!(this instanceof $3d2f1a1d10cc5741$var$SHA384)) return new $3d2f1a1d10cc5741$var$SHA384();
    $lajWD.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$6Q6eW.inherits($3d2f1a1d10cc5741$var$SHA384, $lajWD);
module.exports = $3d2f1a1d10cc5741$var$SHA384;
$3d2f1a1d10cc5741$var$SHA384.blockSize = 1024;
$3d2f1a1d10cc5741$var$SHA384.outSize = 384;
$3d2f1a1d10cc5741$var$SHA384.hmacStrength = 192;
$3d2f1a1d10cc5741$var$SHA384.padLength = 128;
$3d2f1a1d10cc5741$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6Q6eW.toHex32(this.h.slice(0, 12), "big");
    else return $6Q6eW.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lajWD", function(module, exports) {
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");

var $8VZkF = parcelRequire("8VZkF");

var $3HhhI = parcelRequire("3HhhI");
var $f68a00bd15a95284$var$rotr64_hi = $6Q6eW.rotr64_hi;
var $f68a00bd15a95284$var$rotr64_lo = $6Q6eW.rotr64_lo;
var $f68a00bd15a95284$var$shr64_hi = $6Q6eW.shr64_hi;
var $f68a00bd15a95284$var$shr64_lo = $6Q6eW.shr64_lo;
var $f68a00bd15a95284$var$sum64 = $6Q6eW.sum64;
var $f68a00bd15a95284$var$sum64_hi = $6Q6eW.sum64_hi;
var $f68a00bd15a95284$var$sum64_lo = $6Q6eW.sum64_lo;
var $f68a00bd15a95284$var$sum64_4_hi = $6Q6eW.sum64_4_hi;
var $f68a00bd15a95284$var$sum64_4_lo = $6Q6eW.sum64_4_lo;
var $f68a00bd15a95284$var$sum64_5_hi = $6Q6eW.sum64_5_hi;
var $f68a00bd15a95284$var$sum64_5_lo = $6Q6eW.sum64_5_lo;
var $f68a00bd15a95284$var$BlockHash = $8VZkF.BlockHash;
var $f68a00bd15a95284$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $f68a00bd15a95284$var$SHA512() {
    if (!(this instanceof $f68a00bd15a95284$var$SHA512)) return new $f68a00bd15a95284$var$SHA512();
    $f68a00bd15a95284$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $f68a00bd15a95284$var$sha512_K;
    this.W = new Array(160);
}
$6Q6eW.inherits($f68a00bd15a95284$var$SHA512, $f68a00bd15a95284$var$BlockHash);
module.exports = $f68a00bd15a95284$var$SHA512;
$f68a00bd15a95284$var$SHA512.blockSize = 1024;
$f68a00bd15a95284$var$SHA512.outSize = 512;
$f68a00bd15a95284$var$SHA512.hmacStrength = 192;
$f68a00bd15a95284$var$SHA512.padLength = 128;
$f68a00bd15a95284$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $f68a00bd15a95284$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $f68a00bd15a95284$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $f68a00bd15a95284$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $f68a00bd15a95284$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $f68a00bd15a95284$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $f68a00bd15a95284$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$f68a00bd15a95284$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $3HhhI(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $f68a00bd15a95284$var$s1_512_hi(eh, el);
        var c1_lo = $f68a00bd15a95284$var$s1_512_lo(eh, el);
        var c2_hi = $f68a00bd15a95284$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $f68a00bd15a95284$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $f68a00bd15a95284$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $f68a00bd15a95284$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $f68a00bd15a95284$var$s0_512_hi(ah, al);
        c0_lo = $f68a00bd15a95284$var$s0_512_lo(ah, al);
        c1_hi = $f68a00bd15a95284$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $f68a00bd15a95284$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $f68a00bd15a95284$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $f68a00bd15a95284$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $f68a00bd15a95284$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $f68a00bd15a95284$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $f68a00bd15a95284$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $f68a00bd15a95284$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $f68a00bd15a95284$var$sum64(this.h, 0, ah, al);
    $f68a00bd15a95284$var$sum64(this.h, 2, bh, bl);
    $f68a00bd15a95284$var$sum64(this.h, 4, ch, cl);
    $f68a00bd15a95284$var$sum64(this.h, 6, dh, dl);
    $f68a00bd15a95284$var$sum64(this.h, 8, eh, el);
    $f68a00bd15a95284$var$sum64(this.h, 10, fh, fl);
    $f68a00bd15a95284$var$sum64(this.h, 12, gh, gl);
    $f68a00bd15a95284$var$sum64(this.h, 14, hh, hl);
};
$f68a00bd15a95284$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6Q6eW.toHex32(this.h, "big");
    else return $6Q6eW.split32(this.h, "big");
};
function $f68a00bd15a95284$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$s0_512_hi(xh, xl) {
    var c0_hi = $f68a00bd15a95284$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $f68a00bd15a95284$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $f68a00bd15a95284$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$s0_512_lo(xh, xl) {
    var c0_lo = $f68a00bd15a95284$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $f68a00bd15a95284$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $f68a00bd15a95284$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$s1_512_hi(xh, xl) {
    var c0_hi = $f68a00bd15a95284$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $f68a00bd15a95284$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $f68a00bd15a95284$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$s1_512_lo(xh, xl) {
    var c0_lo = $f68a00bd15a95284$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $f68a00bd15a95284$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $f68a00bd15a95284$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$g0_512_hi(xh, xl) {
    var c0_hi = $f68a00bd15a95284$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $f68a00bd15a95284$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $f68a00bd15a95284$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$g0_512_lo(xh, xl) {
    var c0_lo = $f68a00bd15a95284$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $f68a00bd15a95284$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $f68a00bd15a95284$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$g1_512_hi(xh, xl) {
    var c0_hi = $f68a00bd15a95284$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $f68a00bd15a95284$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $f68a00bd15a95284$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $f68a00bd15a95284$var$g1_512_lo(xh, xl) {
    var c0_lo = $f68a00bd15a95284$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $f68a00bd15a95284$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $f68a00bd15a95284$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("k2Ctf", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $e971d60ba995d869$export$d1cea0ee4e3f0d3e; }, function (v) { return $e971d60ba995d869$export$d1cea0ee4e3f0d3e = v; });
var $e971d60ba995d869$export$d1cea0ee4e3f0d3e;
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");

var $8VZkF = parcelRequire("8VZkF");
var $e971d60ba995d869$var$rotl32 = $6Q6eW.rotl32;
var $e971d60ba995d869$var$sum32 = $6Q6eW.sum32;
var $e971d60ba995d869$var$sum32_3 = $6Q6eW.sum32_3;
var $e971d60ba995d869$var$sum32_4 = $6Q6eW.sum32_4;
var $e971d60ba995d869$var$BlockHash = $8VZkF.BlockHash;
function $e971d60ba995d869$var$RIPEMD160() {
    if (!(this instanceof $e971d60ba995d869$var$RIPEMD160)) return new $e971d60ba995d869$var$RIPEMD160();
    $e971d60ba995d869$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$6Q6eW.inherits($e971d60ba995d869$var$RIPEMD160, $e971d60ba995d869$var$BlockHash);
$e971d60ba995d869$export$d1cea0ee4e3f0d3e = $e971d60ba995d869$var$RIPEMD160;
$e971d60ba995d869$var$RIPEMD160.blockSize = 512;
$e971d60ba995d869$var$RIPEMD160.outSize = 160;
$e971d60ba995d869$var$RIPEMD160.hmacStrength = 192;
$e971d60ba995d869$var$RIPEMD160.padLength = 64;
$e971d60ba995d869$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $e971d60ba995d869$var$sum32($e971d60ba995d869$var$rotl32($e971d60ba995d869$var$sum32_4(A, $e971d60ba995d869$var$f(j, B, C, D), msg[$e971d60ba995d869$var$r[j] + start], $e971d60ba995d869$var$K(j)), $e971d60ba995d869$var$s[j]), E);
        A = E;
        E = D;
        D = $e971d60ba995d869$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $e971d60ba995d869$var$sum32($e971d60ba995d869$var$rotl32($e971d60ba995d869$var$sum32_4(Ah, $e971d60ba995d869$var$f(79 - j, Bh, Ch, Dh), msg[$e971d60ba995d869$var$rh[j] + start], $e971d60ba995d869$var$Kh(j)), $e971d60ba995d869$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $e971d60ba995d869$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $e971d60ba995d869$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $e971d60ba995d869$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $e971d60ba995d869$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $e971d60ba995d869$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $e971d60ba995d869$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$e971d60ba995d869$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $6Q6eW.toHex32(this.h, "little");
    else return $6Q6eW.split32(this.h, "little");
};
function $e971d60ba995d869$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $e971d60ba995d869$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $e971d60ba995d869$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $e971d60ba995d869$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $e971d60ba995d869$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $e971d60ba995d869$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $e971d60ba995d869$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("l5NpJ", function(module, exports) {
"use strict";

var $6Q6eW = parcelRequire("6Q6eW");

var $3HhhI = parcelRequire("3HhhI");
function $f5b065389057d4c4$var$Hmac(hash, key, enc) {
    if (!(this instanceof $f5b065389057d4c4$var$Hmac)) return new $f5b065389057d4c4$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($6Q6eW.toArray(key, enc));
}
module.exports = $f5b065389057d4c4$var$Hmac;
$f5b065389057d4c4$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $3HhhI(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$f5b065389057d4c4$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$f5b065389057d4c4$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("cjJ4Z", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("kfPZx", function(module, exports) {
"use strict";

var $ivl6O = parcelRequire("ivl6O");

var $ib04l = parcelRequire("ib04l");

var $6QeS9 = parcelRequire("6QeS9");

var $awhMH = parcelRequire("awhMH");

var $lQohp = parcelRequire("lQohp");
var $ebed89cd9550074e$var$assert = $6QeS9.assert;

var $eIzz6 = parcelRequire("eIzz6");

var $etHh4 = parcelRequire("etHh4");
function $ebed89cd9550074e$var$EC(options) {
    if (!(this instanceof $ebed89cd9550074e$var$EC)) return new $ebed89cd9550074e$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $ebed89cd9550074e$var$assert(Object.prototype.hasOwnProperty.call($awhMH, options), "Unknown curve " + options);
        options = $awhMH[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $awhMH.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $ebed89cd9550074e$var$EC;
$ebed89cd9550074e$var$EC.prototype.keyPair = function keyPair(options) {
    return new $eIzz6(this, options);
};
$ebed89cd9550074e$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $eIzz6.fromPrivate(this, priv, enc);
};
$ebed89cd9550074e$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $eIzz6.fromPublic(this, pub, enc);
};
$ebed89cd9550074e$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $ib04l({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $lQohp(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $ivl6O(2));
    for(;;){
        var priv = new $ivl6O(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$ebed89cd9550074e$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$ebed89cd9550074e$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $ivl6O(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $ib04l({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $ivl6O(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $ivl6O(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $etHh4({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$ebed89cd9550074e$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $ivl6O(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $etHh4(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$ebed89cd9550074e$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $ebed89cd9550074e$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $etHh4(signature, enc);
    var n = this.n;
    var e = new $ivl6O(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$ebed89cd9550074e$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $etHh4(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("ib04l", function(module, exports) {
"use strict";

var $9uYJF = parcelRequire("9uYJF");

var $6dCtp = parcelRequire("6dCtp");

var $3HhhI = parcelRequire("3HhhI");
function $d3b94ec61ebe06df$var$HmacDRBG(options) {
    if (!(this instanceof $d3b94ec61ebe06df$var$HmacDRBG)) return new $d3b94ec61ebe06df$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $6dCtp.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $6dCtp.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $6dCtp.toArray(options.pers, options.persEnc || "hex");
    $3HhhI(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $d3b94ec61ebe06df$var$HmacDRBG;
$d3b94ec61ebe06df$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$d3b94ec61ebe06df$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $9uYJF.hmac(this.hash, this.K);
};
$d3b94ec61ebe06df$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$d3b94ec61ebe06df$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $6dCtp.toArray(entropy, entropyEnc);
    add = $6dCtp.toArray(add, addEnc);
    $3HhhI(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$d3b94ec61ebe06df$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $6dCtp.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $6dCtp.encode(res, enc);
};

});

parcelRegister("eIzz6", function(module, exports) {
"use strict";

var $ivl6O = parcelRequire("ivl6O");

var $6QeS9 = parcelRequire("6QeS9");
var $ab70c33eaa58e8b5$var$assert = $6QeS9.assert;
function $ab70c33eaa58e8b5$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $ab70c33eaa58e8b5$var$KeyPair;
$ab70c33eaa58e8b5$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $ab70c33eaa58e8b5$var$KeyPair) return pub;
    return new $ab70c33eaa58e8b5$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$ab70c33eaa58e8b5$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $ab70c33eaa58e8b5$var$KeyPair) return priv;
    return new $ab70c33eaa58e8b5$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$ab70c33eaa58e8b5$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$ab70c33eaa58e8b5$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$ab70c33eaa58e8b5$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$ab70c33eaa58e8b5$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $ivl6O(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$ab70c33eaa58e8b5$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $ab70c33eaa58e8b5$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $ab70c33eaa58e8b5$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$ab70c33eaa58e8b5$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $ab70c33eaa58e8b5$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$ab70c33eaa58e8b5$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$ab70c33eaa58e8b5$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$ab70c33eaa58e8b5$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("etHh4", function(module, exports) {
"use strict";

var $ivl6O = parcelRequire("ivl6O");

var $6QeS9 = parcelRequire("6QeS9");
var $a8a55782c496b8b5$var$assert = $6QeS9.assert;
function $a8a55782c496b8b5$var$Signature(options, enc) {
    if (options instanceof $a8a55782c496b8b5$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $a8a55782c496b8b5$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $ivl6O(options.r, 16);
    this.s = new $ivl6O(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $a8a55782c496b8b5$var$Signature;
function $a8a55782c496b8b5$var$Position() {
    this.place = 0;
}
function $a8a55782c496b8b5$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $a8a55782c496b8b5$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$a8a55782c496b8b5$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $6QeS9.toArray(data, enc);
    var p = new $a8a55782c496b8b5$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $a8a55782c496b8b5$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $a8a55782c496b8b5$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $a8a55782c496b8b5$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $ivl6O(r);
    this.s = new $ivl6O(s);
    this.recoveryParam = null;
    return true;
};
function $a8a55782c496b8b5$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$a8a55782c496b8b5$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $a8a55782c496b8b5$var$rmPadding(r);
    s = $a8a55782c496b8b5$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $a8a55782c496b8b5$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $a8a55782c496b8b5$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $a8a55782c496b8b5$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $6QeS9.encode(res, enc);
};

});


parcelRegister("krSjs", function(module, exports) {
"use strict";

var $9uYJF = parcelRequire("9uYJF");

var $awhMH = parcelRequire("awhMH");

var $6QeS9 = parcelRequire("6QeS9");
var $ee3075ac41432417$var$assert = $6QeS9.assert;
var $ee3075ac41432417$var$parseBytes = $6QeS9.parseBytes;

var $9FJx4 = parcelRequire("9FJx4");

var $jGNZJ = parcelRequire("jGNZJ");
function $ee3075ac41432417$var$EDDSA(curve) {
    $ee3075ac41432417$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $ee3075ac41432417$var$EDDSA)) return new $ee3075ac41432417$var$EDDSA(curve);
    curve = $awhMH[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $9uYJF.sha512;
}
module.exports = $ee3075ac41432417$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $ee3075ac41432417$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $ee3075ac41432417$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $ee3075ac41432417$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $ee3075ac41432417$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$ee3075ac41432417$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $6QeS9.intFromLE(hash.digest()).umod(this.curve.n);
};
$ee3075ac41432417$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $9FJx4.fromPublic(this, pub);
};
$ee3075ac41432417$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $9FJx4.fromSecret(this, secret);
};
$ee3075ac41432417$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $jGNZJ) return sig;
    return new $jGNZJ(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $ee3075ac41432417$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$ee3075ac41432417$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $6QeS9.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $6QeS9.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$ee3075ac41432417$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$ee3075ac41432417$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $6QeS9.intFromLE(bytes);
};
$ee3075ac41432417$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("9FJx4", function(module, exports) {
"use strict";

var $6QeS9 = parcelRequire("6QeS9");
var $70ab432f2a22baf0$var$assert = $6QeS9.assert;
var $70ab432f2a22baf0$var$parseBytes = $6QeS9.parseBytes;
var $70ab432f2a22baf0$var$cachedProperty = $6QeS9.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $70ab432f2a22baf0$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $70ab432f2a22baf0$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $70ab432f2a22baf0$var$parseBytes(params.pub);
}
$70ab432f2a22baf0$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $70ab432f2a22baf0$var$KeyPair) return pub;
    return new $70ab432f2a22baf0$var$KeyPair(eddsa, {
        pub: pub
    });
};
$70ab432f2a22baf0$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $70ab432f2a22baf0$var$KeyPair) return secret;
    return new $70ab432f2a22baf0$var$KeyPair(eddsa, {
        secret: secret
    });
};
$70ab432f2a22baf0$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$70ab432f2a22baf0$var$cachedProperty($70ab432f2a22baf0$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$70ab432f2a22baf0$var$cachedProperty($70ab432f2a22baf0$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$70ab432f2a22baf0$var$cachedProperty($70ab432f2a22baf0$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$70ab432f2a22baf0$var$cachedProperty($70ab432f2a22baf0$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$70ab432f2a22baf0$var$cachedProperty($70ab432f2a22baf0$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$70ab432f2a22baf0$var$cachedProperty($70ab432f2a22baf0$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$70ab432f2a22baf0$var$KeyPair.prototype.sign = function sign(message) {
    $70ab432f2a22baf0$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$70ab432f2a22baf0$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$70ab432f2a22baf0$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $70ab432f2a22baf0$var$assert(this._secret, "KeyPair is public only");
    return $6QeS9.encode(this.secret(), enc);
};
$70ab432f2a22baf0$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $6QeS9.encode(this.pubBytes(), enc);
};
module.exports = $70ab432f2a22baf0$var$KeyPair;

});

parcelRegister("jGNZJ", function(module, exports) {
"use strict";

var $ivl6O = parcelRequire("ivl6O");

var $6QeS9 = parcelRequire("6QeS9");
var $e558b87d3a72a086$var$assert = $6QeS9.assert;
var $e558b87d3a72a086$var$cachedProperty = $6QeS9.cachedProperty;
var $e558b87d3a72a086$var$parseBytes = $6QeS9.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $e558b87d3a72a086$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $e558b87d3a72a086$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $e558b87d3a72a086$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $ivl6O) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$e558b87d3a72a086$var$cachedProperty($e558b87d3a72a086$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$e558b87d3a72a086$var$cachedProperty($e558b87d3a72a086$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$e558b87d3a72a086$var$cachedProperty($e558b87d3a72a086$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$e558b87d3a72a086$var$cachedProperty($e558b87d3a72a086$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$e558b87d3a72a086$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$e558b87d3a72a086$var$Signature.prototype.toHex = function toHex() {
    return $6QeS9.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $e558b87d3a72a086$var$Signature;

});


parcelRegister("h5RIu", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4rYR9", function(module, exports) {
"use strict";

var $9DtWQ = parcelRequire("9DtWQ");

var $d7NBn = parcelRequire("d7NBn");

var $9M38k = parcelRequire("9M38k");
const $33d8e3cfed7d7f81$var$api = module.exports;
$33d8e3cfed7d7f81$var$api.define = function define(name, body) {
    return new $33d8e3cfed7d7f81$var$Entity(name, body);
};
function $33d8e3cfed7d7f81$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$33d8e3cfed7d7f81$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $9M38k(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$33d8e3cfed7d7f81$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($d7NBn[enc]);
    return this.decoders[enc];
};
$33d8e3cfed7d7f81$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$33d8e3cfed7d7f81$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($9DtWQ[enc]);
    return this.encoders[enc];
};
$33d8e3cfed7d7f81$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("9DtWQ", function(module, exports) {
"use strict";
const $703efca27711b2f2$var$encoders = module.exports;

$703efca27711b2f2$var$encoders.der = (parcelRequire("ehoJ3"));

$703efca27711b2f2$var$encoders.pem = (parcelRequire("ihKRW"));

});
parcelRegister("ehoJ3", function(module, exports) {
"use strict";

var $9M38k = parcelRequire("9M38k");

var $fyPIX = parcelRequire("fyPIX");
var $a655d53c258dc13e$require$Buffer = $fyPIX.Buffer;

var $87qhe = parcelRequire("87qhe");

var $fVCoR = parcelRequire("fVCoR");
function $a655d53c258dc13e$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $a655d53c258dc13e$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $a655d53c258dc13e$var$DEREncoder;
$a655d53c258dc13e$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $a655d53c258dc13e$var$DERNode(parent) {
    $87qhe.call(this, "der", parent);
}
$9M38k($a655d53c258dc13e$var$DERNode, $87qhe);
$a655d53c258dc13e$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $a655d53c258dc13e$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $a655d53c258dc13e$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $a655d53c258dc13e$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$a655d53c258dc13e$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $a655d53c258dc13e$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$a655d53c258dc13e$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $a655d53c258dc13e$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $a655d53c258dc13e$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$a655d53c258dc13e$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $a655d53c258dc13e$var$two(date.getUTCFullYear()),
        $a655d53c258dc13e$var$two(date.getUTCMonth() + 1),
        $a655d53c258dc13e$var$two(date.getUTCDate()),
        $a655d53c258dc13e$var$two(date.getUTCHours()),
        $a655d53c258dc13e$var$two(date.getUTCMinutes()),
        $a655d53c258dc13e$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $a655d53c258dc13e$var$two(date.getUTCFullYear() % 100),
        $a655d53c258dc13e$var$two(date.getUTCMonth() + 1),
        $a655d53c258dc13e$var$two(date.getUTCDate()),
        $a655d53c258dc13e$var$two(date.getUTCHours()),
        $a655d53c258dc13e$var$two(date.getUTCMinutes()),
        $a655d53c258dc13e$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$a655d53c258dc13e$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$a655d53c258dc13e$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$a655d53c258dc13e$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $a655d53c258dc13e$require$Buffer.from(numArray);
    }
    if ($a655d53c258dc13e$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $a655d53c258dc13e$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($a655d53c258dc13e$require$Buffer.from(out));
};
$a655d53c258dc13e$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$a655d53c258dc13e$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$a655d53c258dc13e$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $a655d53c258dc13e$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($fVCoR.tagByName.hasOwnProperty(tag)) res = $fVCoR.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $fVCoR.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("fyPIX", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6qd2L = parcelRequire("6qd2L");
"use strict";

var $3aNd6 = parcelRequire("3aNd6");
var $b542274fe9529a97$var$Buffer = $3aNd6.Buffer;
var $b542274fe9529a97$var$safer = {};
var $b542274fe9529a97$var$key;
for($b542274fe9529a97$var$key in $3aNd6){
    if (!$3aNd6.hasOwnProperty($b542274fe9529a97$var$key)) continue;
    if ($b542274fe9529a97$var$key === "SlowBuffer" || $b542274fe9529a97$var$key === "Buffer") continue;
    $b542274fe9529a97$var$safer[$b542274fe9529a97$var$key] = $3aNd6[$b542274fe9529a97$var$key];
}
var $b542274fe9529a97$var$Safer = $b542274fe9529a97$var$safer.Buffer = {};
for($b542274fe9529a97$var$key in $b542274fe9529a97$var$Buffer){
    if (!$b542274fe9529a97$var$Buffer.hasOwnProperty($b542274fe9529a97$var$key)) continue;
    if ($b542274fe9529a97$var$key === "allocUnsafe" || $b542274fe9529a97$var$key === "allocUnsafeSlow") continue;
    $b542274fe9529a97$var$Safer[$b542274fe9529a97$var$key] = $b542274fe9529a97$var$Buffer[$b542274fe9529a97$var$key];
}
$b542274fe9529a97$var$safer.Buffer.prototype = $b542274fe9529a97$var$Buffer.prototype;
if (!$b542274fe9529a97$var$Safer.from || $b542274fe9529a97$var$Safer.from === Uint8Array.from) $b542274fe9529a97$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $b542274fe9529a97$var$Buffer(value, encodingOrOffset, length);
};
if (!$b542274fe9529a97$var$Safer.alloc) $b542274fe9529a97$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $b542274fe9529a97$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$b542274fe9529a97$var$safer.kStringMaxLength) try {
    $b542274fe9529a97$var$safer.kStringMaxLength = $6qd2L.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$b542274fe9529a97$var$safer.constants) {
    $b542274fe9529a97$var$safer.constants = {
        MAX_LENGTH: $b542274fe9529a97$var$safer.kMaxLength
    };
    if ($b542274fe9529a97$var$safer.kStringMaxLength) $b542274fe9529a97$var$safer.constants.MAX_STRING_LENGTH = $b542274fe9529a97$var$safer.kStringMaxLength;
}
module.exports = $b542274fe9529a97$var$safer;

});

parcelRegister("87qhe", function(module, exports) {
"use strict";

var $2OGYe = parcelRequire("2OGYe");
var $5e935c3ec09e4656$require$Reporter = $2OGYe.Reporter;

var $1i2LU = parcelRequire("1i2LU");
var $5e935c3ec09e4656$require$EncoderBuffer = $1i2LU.EncoderBuffer;

var $1i2LU = parcelRequire("1i2LU");
var $5e935c3ec09e4656$require$DecoderBuffer = $1i2LU.DecoderBuffer;

var $3HhhI = parcelRequire("3HhhI");
// Supported tags
const $5e935c3ec09e4656$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $5e935c3ec09e4656$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($5e935c3ec09e4656$var$tags);
// Overrided methods list
const $5e935c3ec09e4656$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $5e935c3ec09e4656$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $5e935c3ec09e4656$var$Node;
const $5e935c3ec09e4656$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$5e935c3ec09e4656$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $5e935c3ec09e4656$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$5e935c3ec09e4656$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $5e935c3ec09e4656$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$5e935c3ec09e4656$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $3HhhI(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $3HhhI.equal(state.children.length, 1, "Root node can have only one child");
};
$5e935c3ec09e4656$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $3HhhI(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $3HhhI(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$5e935c3ec09e4656$var$overrided.forEach(function(method) {
    $5e935c3ec09e4656$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$5e935c3ec09e4656$var$tags.forEach(function(tag) {
    $5e935c3ec09e4656$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $3HhhI(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$5e935c3ec09e4656$var$Node.prototype.use = function use(item) {
    $3HhhI(item);
    const state = this._baseState;
    $3HhhI(state.use === null);
    state.use = item;
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $3HhhI(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $3HhhI(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $3HhhI(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $3HhhI(state.key === null);
    state.key = newKey;
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $3HhhI(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$5e935c3ec09e4656$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $3HhhI(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$5e935c3ec09e4656$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $5e935c3ec09e4656$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$5e935c3ec09e4656$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$5e935c3ec09e4656$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $3HhhI(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$5e935c3ec09e4656$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$5e935c3ec09e4656$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $5e935c3ec09e4656$require$EncoderBuffer(data, this.reporter);
};
$5e935c3ec09e4656$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$5e935c3ec09e4656$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $5e935c3ec09e4656$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$5e935c3ec09e4656$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $3HhhI(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$5e935c3ec09e4656$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$5e935c3ec09e4656$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$5e935c3ec09e4656$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("2OGYe", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $20d195591b126f0b$export$957313a2f485e5ed; }, function (v) { return $20d195591b126f0b$export$957313a2f485e5ed = v; });
var $20d195591b126f0b$export$957313a2f485e5ed;
"use strict";

var $9M38k = parcelRequire("9M38k");
function $20d195591b126f0b$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$20d195591b126f0b$export$957313a2f485e5ed = $20d195591b126f0b$var$Reporter;
$20d195591b126f0b$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $20d195591b126f0b$var$ReporterError;
};
$20d195591b126f0b$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$20d195591b126f0b$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$20d195591b126f0b$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$20d195591b126f0b$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$20d195591b126f0b$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$20d195591b126f0b$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$20d195591b126f0b$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$20d195591b126f0b$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$20d195591b126f0b$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $20d195591b126f0b$var$ReporterError;
    if (inherited) err = msg;
    else err = new $20d195591b126f0b$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$20d195591b126f0b$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $20d195591b126f0b$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$9M38k($20d195591b126f0b$var$ReporterError, Error);
$20d195591b126f0b$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $20d195591b126f0b$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("1i2LU", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $0f099f46fe17328d$export$bf9f79cdc4a49163; }, function (v) { return $0f099f46fe17328d$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $0f099f46fe17328d$export$8ff24f7760c7a78e; }, function (v) { return $0f099f46fe17328d$export$8ff24f7760c7a78e = v; });
var $0f099f46fe17328d$export$bf9f79cdc4a49163;
var $0f099f46fe17328d$export$8ff24f7760c7a78e;
"use strict";

var $9M38k = parcelRequire("9M38k");

var $2OGYe = parcelRequire("2OGYe");
var $0f099f46fe17328d$require$Reporter = $2OGYe.Reporter;

var $fyPIX = parcelRequire("fyPIX");
var $0f099f46fe17328d$require$Buffer = $fyPIX.Buffer;
function $0f099f46fe17328d$var$DecoderBuffer(base, options) {
    $0f099f46fe17328d$require$Reporter.call(this, options);
    if (!$0f099f46fe17328d$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$9M38k($0f099f46fe17328d$var$DecoderBuffer, $0f099f46fe17328d$require$Reporter);
$0f099f46fe17328d$export$bf9f79cdc4a49163 = $0f099f46fe17328d$var$DecoderBuffer;
$0f099f46fe17328d$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $0f099f46fe17328d$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $0f099f46fe17328d$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$0f099f46fe17328d$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $0f099f46fe17328d$require$Reporter.prototype.save.call(this)
    };
};
$0f099f46fe17328d$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $0f099f46fe17328d$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $0f099f46fe17328d$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$0f099f46fe17328d$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$0f099f46fe17328d$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$0f099f46fe17328d$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $0f099f46fe17328d$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$0f099f46fe17328d$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $0f099f46fe17328d$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$0f099f46fe17328d$var$EncoderBuffer.isEncoderBuffer(item)) item = new $0f099f46fe17328d$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $0f099f46fe17328d$require$Buffer.byteLength(value);
    } else if ($0f099f46fe17328d$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$0f099f46fe17328d$export$8ff24f7760c7a78e = $0f099f46fe17328d$var$EncoderBuffer;
$0f099f46fe17328d$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $0f099f46fe17328d$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$0f099f46fe17328d$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $0f099f46fe17328d$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($0f099f46fe17328d$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("fVCoR", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $b989f754e15de51f$export$3584c46ed60baee8; }, function (v) { return $b989f754e15de51f$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $b989f754e15de51f$export$f18596ef8d632e49; }, function (v) { return $b989f754e15de51f$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $b989f754e15de51f$export$2b067c6666111485; }, function (v) { return $b989f754e15de51f$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $b989f754e15de51f$export$f17df38a421ab9e3; }, function (v) { return $b989f754e15de51f$export$f17df38a421ab9e3 = v; });
var $b989f754e15de51f$export$3584c46ed60baee8;
var $b989f754e15de51f$export$f18596ef8d632e49;
var $b989f754e15de51f$export$2b067c6666111485;
var $b989f754e15de51f$export$f17df38a421ab9e3;
"use strict";
// Helper
function $b989f754e15de51f$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$b989f754e15de51f$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$b989f754e15de51f$export$f18596ef8d632e49 = $b989f754e15de51f$var$reverse($b989f754e15de51f$export$3584c46ed60baee8);
$b989f754e15de51f$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$b989f754e15de51f$export$f17df38a421ab9e3 = $b989f754e15de51f$var$reverse($b989f754e15de51f$export$2b067c6666111485);

});


parcelRegister("ihKRW", function(module, exports) {
"use strict";

var $9M38k = parcelRequire("9M38k");

var $ehoJ3 = parcelRequire("ehoJ3");
function $d4fe2bc2fa6ce07b$var$PEMEncoder(entity) {
    $ehoJ3.call(this, entity);
    this.enc = "pem";
}
$9M38k($d4fe2bc2fa6ce07b$var$PEMEncoder, $ehoJ3);
module.exports = $d4fe2bc2fa6ce07b$var$PEMEncoder;
$d4fe2bc2fa6ce07b$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $ehoJ3.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("d7NBn", function(module, exports) {
"use strict";
const $98e267b9671d3522$var$decoders = module.exports;

$98e267b9671d3522$var$decoders.der = (parcelRequire("khPLl"));

$98e267b9671d3522$var$decoders.pem = (parcelRequire("bY9OC"));

});
parcelRegister("khPLl", function(module, exports) {
"use strict";

var $9M38k = parcelRequire("9M38k");

var $h5RIu = parcelRequire("h5RIu");

var $1i2LU = parcelRequire("1i2LU");
var $ec4d8c2c8a35ac9a$require$DecoderBuffer = $1i2LU.DecoderBuffer;

var $87qhe = parcelRequire("87qhe");

var $fVCoR = parcelRequire("fVCoR");
function $ec4d8c2c8a35ac9a$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $ec4d8c2c8a35ac9a$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $ec4d8c2c8a35ac9a$var$DERDecoder;
$ec4d8c2c8a35ac9a$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$ec4d8c2c8a35ac9a$require$DecoderBuffer.isDecoderBuffer(data)) data = new $ec4d8c2c8a35ac9a$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $ec4d8c2c8a35ac9a$var$DERNode(parent) {
    $87qhe.call(this, "der", parent);
}
$9M38k($ec4d8c2c8a35ac9a$var$DERNode, $87qhe);
$ec4d8c2c8a35ac9a$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $ec4d8c2c8a35ac9a$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $ec4d8c2c8a35ac9a$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $ec4d8c2c8a35ac9a$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $ec4d8c2c8a35ac9a$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $ec4d8c2c8a35ac9a$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $h5RIu(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$ec4d8c2c8a35ac9a$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $ec4d8c2c8a35ac9a$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $fVCoR.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $fVCoR.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $ec4d8c2c8a35ac9a$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("bY9OC", function(module, exports) {
"use strict";

var $9M38k = parcelRequire("9M38k");

var $fyPIX = parcelRequire("fyPIX");
var $8b6ce972567cc771$require$Buffer = $fyPIX.Buffer;

var $khPLl = parcelRequire("khPLl");
function $8b6ce972567cc771$var$PEMDecoder(entity) {
    $khPLl.call(this, entity);
    this.enc = "pem";
}
$9M38k($8b6ce972567cc771$var$PEMDecoder, $khPLl);
module.exports = $8b6ce972567cc771$var$PEMDecoder;
$8b6ce972567cc771$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $8b6ce972567cc771$require$Buffer.from(base64, "base64");
    return $khPLl.prototype.decode.call(this, input, options);
};

});



parcelRegister("kkA7e", function(module, exports) {
"use strict";
const $ecd1b0be611f49a8$var$base = module.exports;

$ecd1b0be611f49a8$var$base.Reporter = (parcelRequire("2OGYe")).Reporter;

$ecd1b0be611f49a8$var$base.DecoderBuffer = (parcelRequire("1i2LU")).DecoderBuffer;

$ecd1b0be611f49a8$var$base.EncoderBuffer = (parcelRequire("1i2LU")).EncoderBuffer;

$ecd1b0be611f49a8$var$base.Node = (parcelRequire("87qhe"));

});

parcelRegister("bkbIO", function(module, exports) {
"use strict";
const $83eaa7a49f3b27d8$var$constants = module.exports;
// Helper
$83eaa7a49f3b27d8$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$83eaa7a49f3b27d8$var$constants.der = (parcelRequire("fVCoR"));

});

parcelRegister("HdImS", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $dyqKK = parcelRequire("dyqKK");
var $081ea7b4199ce44f$var$Time = $dyqKK.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $081ea7b4199ce44f$var$AttributeTypeValue = $dyqKK.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $081ea7b4199ce44f$var$AlgorithmIdentifier = $dyqKK.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $081ea7b4199ce44f$var$SubjectPublicKeyInfo = $dyqKK.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($081ea7b4199ce44f$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $081ea7b4199ce44f$var$RelativeDistinguishedName = $dyqKK.define("RelativeDistinguishedName", function() {
    this.setof($081ea7b4199ce44f$var$AttributeTypeValue);
});
var $081ea7b4199ce44f$var$RDNSequence = $dyqKK.define("RDNSequence", function() {
    this.seqof($081ea7b4199ce44f$var$RelativeDistinguishedName);
});
var $081ea7b4199ce44f$var$Name = $dyqKK.define("Name", function() {
    this.choice({
        rdnSequence: this.use($081ea7b4199ce44f$var$RDNSequence)
    });
});
var $081ea7b4199ce44f$var$Validity = $dyqKK.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($081ea7b4199ce44f$var$Time), this.key("notAfter").use($081ea7b4199ce44f$var$Time));
});
var $081ea7b4199ce44f$var$Extension = $dyqKK.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $081ea7b4199ce44f$var$TBSCertificate = $dyqKK.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($081ea7b4199ce44f$var$AlgorithmIdentifier), this.key("issuer").use($081ea7b4199ce44f$var$Name), this.key("validity").use($081ea7b4199ce44f$var$Validity), this.key("subject").use($081ea7b4199ce44f$var$Name), this.key("subjectPublicKeyInfo").use($081ea7b4199ce44f$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($081ea7b4199ce44f$var$Extension).optional());
});
var $081ea7b4199ce44f$var$X509Certificate = $dyqKK.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($081ea7b4199ce44f$var$TBSCertificate), this.key("signatureAlgorithm").use($081ea7b4199ce44f$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $081ea7b4199ce44f$var$X509Certificate;

});
parcelRegister("dyqKK", function(module, exports) {
"use strict";
const $9de333edba9ff167$var$asn1 = module.exports;

$9de333edba9ff167$var$asn1.bignum = (parcelRequire("h5RIu"));

$9de333edba9ff167$var$asn1.define = (parcelRequire("4rYR9")).define;

$9de333edba9ff167$var$asn1.base = (parcelRequire("kkA7e"));

$9de333edba9ff167$var$asn1.constants = (parcelRequire("bkbIO"));

$9de333edba9ff167$var$asn1.decoders = (parcelRequire("d7NBn"));

$9de333edba9ff167$var$asn1.encoders = (parcelRequire("9DtWQ"));

});


parcelRegister("6mKpT", function(module, exports) {

var $3aNd6 = parcelRequire("3aNd6");
var $4a28cd8d276707fb$require$Buffer = $3aNd6.Buffer;

var $7AZol = parcelRequire("7AZol");

var $iAg24 = parcelRequire("iAg24");
module.exports = function createECDH(curve) {
    return new $4a28cd8d276707fb$var$ECDH(curve);
};
var $4a28cd8d276707fb$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$4a28cd8d276707fb$var$aliases.p224 = $4a28cd8d276707fb$var$aliases.secp224r1;
$4a28cd8d276707fb$var$aliases.p256 = $4a28cd8d276707fb$var$aliases.secp256r1 = $4a28cd8d276707fb$var$aliases.prime256v1;
$4a28cd8d276707fb$var$aliases.p192 = $4a28cd8d276707fb$var$aliases.secp192r1 = $4a28cd8d276707fb$var$aliases.prime192v1;
$4a28cd8d276707fb$var$aliases.p384 = $4a28cd8d276707fb$var$aliases.secp384r1;
$4a28cd8d276707fb$var$aliases.p521 = $4a28cd8d276707fb$var$aliases.secp521r1;
function $4a28cd8d276707fb$var$ECDH(curve) {
    this.curveType = $4a28cd8d276707fb$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $7AZol.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$4a28cd8d276707fb$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$4a28cd8d276707fb$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$4a28cd8d276707fb$require$Buffer.isBuffer(other)) other = new $4a28cd8d276707fb$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $4a28cd8d276707fb$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$4a28cd8d276707fb$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $4a28cd8d276707fb$var$formatReturnValue(key, enc);
};
$4a28cd8d276707fb$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $4a28cd8d276707fb$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$4a28cd8d276707fb$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$4a28cd8d276707fb$require$Buffer.isBuffer(pub)) pub = new $4a28cd8d276707fb$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$4a28cd8d276707fb$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$4a28cd8d276707fb$require$Buffer.isBuffer(priv)) priv = new $4a28cd8d276707fb$require$Buffer(priv, enc);
    var _priv = new $iAg24(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $4a28cd8d276707fb$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $4a28cd8d276707fb$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $4a28cd8d276707fb$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $4a28cd8d276707fb$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("7AZol", function(module, exports) {
"use strict";
var $587b84509a841541$var$elliptic = module.exports;

$587b84509a841541$var$elliptic.version = (parcelRequire("2Zf1j")).version;

$587b84509a841541$var$elliptic.utils = (parcelRequire("6QeS9"));

$587b84509a841541$var$elliptic.rand = (parcelRequire("lQohp"));

$587b84509a841541$var$elliptic.curve = (parcelRequire("ku149"));

$587b84509a841541$var$elliptic.curves = (parcelRequire("awhMH"));

// Protocols
$587b84509a841541$var$elliptic.ec = (parcelRequire("kfPZx"));

$587b84509a841541$var$elliptic.eddsa = (parcelRequire("krSjs"));

});

parcelRegister("iAg24", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("dQ8X2", function(module, exports) {

var $9rqjB = parcelRequire("9rqjB");

var $5LzvA = parcelRequire("5LzvA");

var $3YkjF = parcelRequire("3YkjF");

var $hLnyP = parcelRequire("hLnyP");

var $kQRUZ = parcelRequire("kQRUZ");

var $33Lt4 = parcelRequire("33Lt4");

var $1gODx = parcelRequire("1gODx");

var $gT4EJ = parcelRequire("gT4EJ");

var $2iVwY = parcelRequire("2iVwY");
var $a137133161efdf39$require$Buffer = $2iVwY.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $9rqjB(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $a137133161efdf39$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $a137133161efdf39$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $33Lt4(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $gT4EJ(paddedMsg, key);
    else return $1gODx(paddedMsg, key);
};
function $a137133161efdf39$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $3YkjF("sha1").update($a137133161efdf39$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $a137133161efdf39$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $5LzvA(hLen);
    var maskedDb = $kQRUZ($a137133161efdf39$require$Buffer.concat([
        iHash,
        ps,
        $a137133161efdf39$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $hLnyP(seed, dblen));
    var maskedSeed = $kQRUZ(seed, $hLnyP(maskedDb, hLen));
    return new $33Lt4($a137133161efdf39$require$Buffer.concat([
        $a137133161efdf39$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $a137133161efdf39$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $a137133161efdf39$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $a137133161efdf39$var$nonZero(k - mLen - 3);
    return new $33Lt4($a137133161efdf39$require$Buffer.concat([
        $a137133161efdf39$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $a137133161efdf39$require$Buffer.alloc(1),
        msg
    ], k));
}
function $a137133161efdf39$var$nonZero(len) {
    var out = $a137133161efdf39$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $5LzvA(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $5LzvA(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("9rqjB", function(module, exports) {

var $fP5sh = parcelRequire("fP5sh");

var $dikIX = parcelRequire("dikIX");

var $fMPNM = parcelRequire("fMPNM");

var $eHJJG = parcelRequire("eHJJG");

var $6hZjq = parcelRequire("6hZjq");

var $2iVwY = parcelRequire("2iVwY");
var $6dfb0c5200159a85$require$Buffer = $2iVwY.Buffer;
module.exports = $6dfb0c5200159a85$var$parseKeys;
function $6dfb0c5200159a85$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$6dfb0c5200159a85$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $6dfb0c5200159a85$require$Buffer.from(buffer);
    var stripped = $fMPNM(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fP5sh.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fP5sh.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fP5sh.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fP5sh.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fP5sh.EncryptedPrivateKey.decode(data, "der");
            data = $6dfb0c5200159a85$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fP5sh.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fP5sh.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fP5sh.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fP5sh.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fP5sh.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fP5sh.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fP5sh.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fP5sh.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$6dfb0c5200159a85$var$parseKeys.signature = $fP5sh.signature;
function $6dfb0c5200159a85$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $dikIX[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $6hZjq.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $eHJJG.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $6dfb0c5200159a85$require$Buffer.concat(out);
}

});
parcelRegister("fP5sh", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $b84fd9b8eea162e3$export$c98397a6eb8d0678; }, function (v) { return $b84fd9b8eea162e3$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $b84fd9b8eea162e3$export$f4aab6816f64fa6b; }, function (v) { return $b84fd9b8eea162e3$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $b84fd9b8eea162e3$export$4471f5c65d097c11; }, function (v) { return $b84fd9b8eea162e3$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $b84fd9b8eea162e3$export$ca8b6604d6ce14de; }, function (v) { return $b84fd9b8eea162e3$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $b84fd9b8eea162e3$export$8f54525b330fd87b; }, function (v) { return $b84fd9b8eea162e3$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $b84fd9b8eea162e3$export$23cd2842b44ca3e7; }, function (v) { return $b84fd9b8eea162e3$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $b84fd9b8eea162e3$export$245c9aaa9f5ce4ce; }, function (v) { return $b84fd9b8eea162e3$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $b84fd9b8eea162e3$export$8ad762e3e6399afe; }, function (v) { return $b84fd9b8eea162e3$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $b84fd9b8eea162e3$export$32ef6f92e22c6ab0; }, function (v) { return $b84fd9b8eea162e3$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $b84fd9b8eea162e3$export$c9cd164b539ebb63; }, function (v) { return $b84fd9b8eea162e3$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b84fd9b8eea162e3$export$c98397a6eb8d0678;
var $b84fd9b8eea162e3$export$f4aab6816f64fa6b;
var $b84fd9b8eea162e3$export$4471f5c65d097c11;
var $b84fd9b8eea162e3$export$ca8b6604d6ce14de;
var $b84fd9b8eea162e3$export$8f54525b330fd87b;
var $b84fd9b8eea162e3$export$23cd2842b44ca3e7;
var $b84fd9b8eea162e3$export$245c9aaa9f5ce4ce;
var $b84fd9b8eea162e3$export$8ad762e3e6399afe;
var $b84fd9b8eea162e3$export$32ef6f92e22c6ab0;
var $b84fd9b8eea162e3$export$c9cd164b539ebb63;
"use strict";

var $dyqKK = parcelRequire("dyqKK");

$b84fd9b8eea162e3$export$c98397a6eb8d0678 = (parcelRequire("HdImS"));
var $b84fd9b8eea162e3$var$RSAPrivateKey = $dyqKK.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$b84fd9b8eea162e3$export$f4aab6816f64fa6b = $b84fd9b8eea162e3$var$RSAPrivateKey;
var $b84fd9b8eea162e3$var$RSAPublicKey = $dyqKK.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$b84fd9b8eea162e3$export$4471f5c65d097c11 = $b84fd9b8eea162e3$var$RSAPublicKey;
var $b84fd9b8eea162e3$var$PublicKey = $dyqKK.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b84fd9b8eea162e3$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b84fd9b8eea162e3$export$ca8b6604d6ce14de = $b84fd9b8eea162e3$var$PublicKey;
var $b84fd9b8eea162e3$var$AlgorithmIdentifier = $dyqKK.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $b84fd9b8eea162e3$var$PrivateKeyInfo = $dyqKK.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($b84fd9b8eea162e3$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b84fd9b8eea162e3$export$8f54525b330fd87b = $b84fd9b8eea162e3$var$PrivateKeyInfo;
var $b84fd9b8eea162e3$var$EncryptedPrivateKeyInfo = $dyqKK.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b84fd9b8eea162e3$export$23cd2842b44ca3e7 = $b84fd9b8eea162e3$var$EncryptedPrivateKeyInfo;
var $b84fd9b8eea162e3$var$DSAPrivateKey = $dyqKK.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$b84fd9b8eea162e3$export$245c9aaa9f5ce4ce = $b84fd9b8eea162e3$var$DSAPrivateKey;
$b84fd9b8eea162e3$export$8ad762e3e6399afe = $dyqKK.define("DSAparam", function() {
    this.int();
});
var $b84fd9b8eea162e3$var$ECPrivateKey = $dyqKK.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b84fd9b8eea162e3$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b84fd9b8eea162e3$export$32ef6f92e22c6ab0 = $b84fd9b8eea162e3$var$ECPrivateKey;
var $b84fd9b8eea162e3$var$ECParameters = $dyqKK.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b84fd9b8eea162e3$export$c9cd164b539ebb63 = $dyqKK.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});

parcelRegister("dikIX", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("fMPNM", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $b7e3857cb582fcea$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $b7e3857cb582fcea$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $b7e3857cb582fcea$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $aXh1Z = parcelRequire("aXh1Z");

var $eHJJG = parcelRequire("eHJJG");

var $2iVwY = parcelRequire("2iVwY");
var $b7e3857cb582fcea$require$Buffer = $2iVwY.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($b7e3857cb582fcea$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($b7e3857cb582fcea$var$fullRegex);
        decrypted = $b7e3857cb582fcea$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $b7e3857cb582fcea$require$Buffer.from(match[2], "hex");
        var cipherText = $b7e3857cb582fcea$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $aXh1Z(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $eHJJG.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $b7e3857cb582fcea$require$Buffer.concat(out);
    }
    var tag = key.match($b7e3857cb582fcea$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("aXh1Z", function(module, exports) {

var $2iVwY = parcelRequire("2iVwY");
var $7f9ca01205e24197$require$Buffer = $2iVwY.Buffer;

var $lcOGj = parcelRequire("lcOGj");
/* eslint-disable camelcase */ function $7f9ca01205e24197$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$7f9ca01205e24197$require$Buffer.isBuffer(password)) password = $7f9ca01205e24197$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$7f9ca01205e24197$require$Buffer.isBuffer(salt)) salt = $7f9ca01205e24197$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $7f9ca01205e24197$require$Buffer.alloc(keyLen);
    var iv = $7f9ca01205e24197$require$Buffer.alloc(ivLen || 0);
    var tmp = $7f9ca01205e24197$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $lcOGj();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $7f9ca01205e24197$var$EVP_BytesToKey;

});

parcelRegister("eHJJG", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $ab488f00464387c9$export$2f64596b8cbf08b4; }, function (v) { return $ab488f00464387c9$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $ab488f00464387c9$export$36b6d6ef312eab39; }, function (v) { return $ab488f00464387c9$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $ab488f00464387c9$export$58a258485f1e49f6; }, function (v) { return $ab488f00464387c9$export$58a258485f1e49f6 = v; });
var $ab488f00464387c9$export$bdd223f16383713e;
var $ab488f00464387c9$export$26e5786e8ac8e530;
var $ab488f00464387c9$export$2f64596b8cbf08b4;
var $ab488f00464387c9$export$20533d26f07f1ee0;
var $ab488f00464387c9$export$12ada9414fbc594c;
var $ab488f00464387c9$export$2ce6d8d0e8b04e1a;
var $ab488f00464387c9$export$36b6d6ef312eab39;
var $ab488f00464387c9$export$f5e7e39d57cd9700;
var $ab488f00464387c9$export$dedd8dc3dc62b370;
var $ab488f00464387c9$export$58a258485f1e49f6;

var $55HZb = parcelRequire("55HZb");

var $gjhe8 = parcelRequire("gjhe8");

var $iydUh = parcelRequire("iydUh");
function $ab488f00464387c9$var$getCiphers() {
    return Object.keys($iydUh);
}
$ab488f00464387c9$export$bdd223f16383713e = $ab488f00464387c9$export$26e5786e8ac8e530 = $55HZb.createCipher;
$ab488f00464387c9$export$2f64596b8cbf08b4 = $ab488f00464387c9$export$20533d26f07f1ee0 = $55HZb.createCipheriv;
$ab488f00464387c9$export$12ada9414fbc594c = $ab488f00464387c9$export$2ce6d8d0e8b04e1a = $gjhe8.createDecipher;
$ab488f00464387c9$export$36b6d6ef312eab39 = $ab488f00464387c9$export$f5e7e39d57cd9700 = $gjhe8.createDecipheriv;
$ab488f00464387c9$export$dedd8dc3dc62b370 = $ab488f00464387c9$export$58a258485f1e49f6 = $ab488f00464387c9$var$getCiphers;

});
parcelRegister("55HZb", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $3b4f8a0f6fcbd523$export$2f64596b8cbf08b4; }, function (v) { return $3b4f8a0f6fcbd523$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $3b4f8a0f6fcbd523$export$bdd223f16383713e; }, function (v) { return $3b4f8a0f6fcbd523$export$bdd223f16383713e = v; });
var $3b4f8a0f6fcbd523$export$2f64596b8cbf08b4;
var $3b4f8a0f6fcbd523$export$bdd223f16383713e;

var $l6VnM = parcelRequire("l6VnM");

var $5hO7b = parcelRequire("5hO7b");

var $2iVwY = parcelRequire("2iVwY");
var $3b4f8a0f6fcbd523$require$Buffer = $2iVwY.Buffer;

var $8Yseu = parcelRequire("8Yseu");

var $7J5an = parcelRequire("7J5an");

var $gNloh = parcelRequire("gNloh");

var $aXh1Z = parcelRequire("aXh1Z");

var $9M38k = parcelRequire("9M38k");
function $3b4f8a0f6fcbd523$var$Cipher(mode, key, iv) {
    $7J5an.call(this);
    this._cache = new $3b4f8a0f6fcbd523$var$Splitter();
    this._cipher = new $gNloh.AES(key);
    this._prev = $3b4f8a0f6fcbd523$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$9M38k($3b4f8a0f6fcbd523$var$Cipher, $7J5an);
$3b4f8a0f6fcbd523$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $3b4f8a0f6fcbd523$require$Buffer.concat(out);
};
var $3b4f8a0f6fcbd523$var$PADDING = $3b4f8a0f6fcbd523$require$Buffer.alloc(16, 0x10);
$3b4f8a0f6fcbd523$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($3b4f8a0f6fcbd523$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$3b4f8a0f6fcbd523$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $3b4f8a0f6fcbd523$var$Splitter() {
    this.cache = $3b4f8a0f6fcbd523$require$Buffer.allocUnsafe(0);
}
$3b4f8a0f6fcbd523$var$Splitter.prototype.add = function(data) {
    this.cache = $3b4f8a0f6fcbd523$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$3b4f8a0f6fcbd523$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$3b4f8a0f6fcbd523$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $3b4f8a0f6fcbd523$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $3b4f8a0f6fcbd523$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $3b4f8a0f6fcbd523$var$createCipheriv(suite, password, iv) {
    var config = $l6VnM[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $3b4f8a0f6fcbd523$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $3b4f8a0f6fcbd523$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $8Yseu(config.module, password, iv);
    else if (config.type === "auth") return new $5hO7b(config.module, password, iv);
    return new $3b4f8a0f6fcbd523$var$Cipher(config.module, password, iv);
}
function $3b4f8a0f6fcbd523$var$createCipher(suite, password) {
    var config = $l6VnM[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $aXh1Z(password, false, config.key, config.iv);
    return $3b4f8a0f6fcbd523$var$createCipheriv(suite, keys.key, keys.iv);
}
$3b4f8a0f6fcbd523$export$2f64596b8cbf08b4 = $3b4f8a0f6fcbd523$var$createCipheriv;
$3b4f8a0f6fcbd523$export$bdd223f16383713e = $3b4f8a0f6fcbd523$var$createCipher;

});
parcelRegister("l6VnM", function(module, exports) {








var $f5e6ab7fae30bec6$var$modeModules = {
    ECB: (parcelRequire("85Pkp")),
    CBC: (parcelRequire("2pjOJ")),
    CFB: (parcelRequire("jB2l1")),
    CFB8: (parcelRequire("iFxgj")),
    CFB1: (parcelRequire("72Qiw")),
    OFB: (parcelRequire("7H3x3")),
    CTR: (parcelRequire("1l11m")),
    GCM: (parcelRequire("1l11m"))
};

var $iydUh = parcelRequire("iydUh");
for(var $f5e6ab7fae30bec6$var$key in $iydUh)$iydUh[$f5e6ab7fae30bec6$var$key].module = $f5e6ab7fae30bec6$var$modeModules[$iydUh[$f5e6ab7fae30bec6$var$key].mode];
module.exports = $iydUh;

});
parcelRegister("iydUh", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("5hO7b", function(module, exports) {

var $gNloh = parcelRequire("gNloh");

var $2iVwY = parcelRequire("2iVwY");
var $3d956a11ccd5ca1b$require$Buffer = $2iVwY.Buffer;

var $7J5an = parcelRequire("7J5an");

var $9M38k = parcelRequire("9M38k");

var $3cPdQ = parcelRequire("3cPdQ");

var $55HY9 = parcelRequire("55HY9");

var $dxWEj = parcelRequire("dxWEj");
function $3d956a11ccd5ca1b$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $3d956a11ccd5ca1b$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $3d956a11ccd5ca1b$require$Buffer.concat([
            iv,
            $3d956a11ccd5ca1b$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $3d956a11ccd5ca1b$require$Buffer.concat([
            iv,
            $3d956a11ccd5ca1b$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $3cPdQ(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($3d956a11ccd5ca1b$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($3d956a11ccd5ca1b$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $3d956a11ccd5ca1b$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $3d956a11ccd5ca1b$require$Buffer.from(self._finID);
    $dxWEj(out);
    return out;
}
function $3d956a11ccd5ca1b$var$StreamCipher(mode, key, iv, decrypt) {
    $7J5an.call(this);
    var h = $3d956a11ccd5ca1b$require$Buffer.alloc(4, 0);
    this._cipher = new $gNloh.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $3cPdQ(ck);
    iv = $3d956a11ccd5ca1b$var$calcIv(this, iv, ck);
    this._prev = $3d956a11ccd5ca1b$require$Buffer.from(iv);
    this._cache = $3d956a11ccd5ca1b$require$Buffer.allocUnsafe(0);
    this._secCache = $3d956a11ccd5ca1b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$9M38k($3d956a11ccd5ca1b$var$StreamCipher, $7J5an);
$3d956a11ccd5ca1b$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $3d956a11ccd5ca1b$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$3d956a11ccd5ca1b$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $55HY9(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $3d956a11ccd5ca1b$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$3d956a11ccd5ca1b$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$3d956a11ccd5ca1b$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$3d956a11ccd5ca1b$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$3d956a11ccd5ca1b$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $3d956a11ccd5ca1b$var$StreamCipher;

});
parcelRegister("gNloh", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $c3a1d0b121297640$export$b80fbe1c3a2b92b5; }, function (v) { return $c3a1d0b121297640$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $c3a1d0b121297640$export$b80fbe1c3a2b92b5;

var $2iVwY = parcelRequire("2iVwY");
var $c3a1d0b121297640$require$Buffer = $2iVwY.Buffer;
function $c3a1d0b121297640$var$asUInt32Array(buf) {
    if (!$c3a1d0b121297640$require$Buffer.isBuffer(buf)) buf = $c3a1d0b121297640$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $c3a1d0b121297640$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $c3a1d0b121297640$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $c3a1d0b121297640$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $c3a1d0b121297640$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $c3a1d0b121297640$var$AES(key) {
    this._key = $c3a1d0b121297640$var$asUInt32Array(key);
    this._reset();
}
$c3a1d0b121297640$var$AES.blockSize = 16;
$c3a1d0b121297640$var$AES.keySize = 32;
$c3a1d0b121297640$var$AES.prototype.blockSize = $c3a1d0b121297640$var$AES.blockSize;
$c3a1d0b121297640$var$AES.prototype.keySize = $c3a1d0b121297640$var$AES.keySize;
$c3a1d0b121297640$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $c3a1d0b121297640$var$G.SBOX[t >>> 24] << 24 | $c3a1d0b121297640$var$G.SBOX[t >>> 16 & 0xff] << 16 | $c3a1d0b121297640$var$G.SBOX[t >>> 8 & 0xff] << 8 | $c3a1d0b121297640$var$G.SBOX[t & 0xff];
            t ^= $c3a1d0b121297640$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $c3a1d0b121297640$var$G.SBOX[t >>> 24] << 24 | $c3a1d0b121297640$var$G.SBOX[t >>> 16 & 0xff] << 16 | $c3a1d0b121297640$var$G.SBOX[t >>> 8 & 0xff] << 8 | $c3a1d0b121297640$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $c3a1d0b121297640$var$G.INV_SUB_MIX[0][$c3a1d0b121297640$var$G.SBOX[tt >>> 24]] ^ $c3a1d0b121297640$var$G.INV_SUB_MIX[1][$c3a1d0b121297640$var$G.SBOX[tt >>> 16 & 0xff]] ^ $c3a1d0b121297640$var$G.INV_SUB_MIX[2][$c3a1d0b121297640$var$G.SBOX[tt >>> 8 & 0xff]] ^ $c3a1d0b121297640$var$G.INV_SUB_MIX[3][$c3a1d0b121297640$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$c3a1d0b121297640$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $c3a1d0b121297640$var$asUInt32Array(M);
    return $c3a1d0b121297640$var$cryptBlock(M, this._keySchedule, $c3a1d0b121297640$var$G.SUB_MIX, $c3a1d0b121297640$var$G.SBOX, this._nRounds);
};
$c3a1d0b121297640$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $c3a1d0b121297640$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$c3a1d0b121297640$var$AES.prototype.decryptBlock = function(M) {
    M = $c3a1d0b121297640$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $c3a1d0b121297640$var$cryptBlock(M, this._invKeySchedule, $c3a1d0b121297640$var$G.INV_SUB_MIX, $c3a1d0b121297640$var$G.INV_SBOX, this._nRounds);
    var buf = $c3a1d0b121297640$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$c3a1d0b121297640$var$AES.prototype.scrub = function() {
    $c3a1d0b121297640$var$scrubVec(this._keySchedule);
    $c3a1d0b121297640$var$scrubVec(this._invKeySchedule);
    $c3a1d0b121297640$var$scrubVec(this._key);
};
$c3a1d0b121297640$export$b80fbe1c3a2b92b5 = $c3a1d0b121297640$var$AES;

});

parcelRegister("3cPdQ", function(module, exports) {

var $2iVwY = parcelRequire("2iVwY");
var $255a39cb2ff69147$require$Buffer = $2iVwY.Buffer;
var $255a39cb2ff69147$var$ZEROES = $255a39cb2ff69147$require$Buffer.alloc(16, 0);
function $255a39cb2ff69147$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $255a39cb2ff69147$var$fromArray(out) {
    var buf = $255a39cb2ff69147$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $255a39cb2ff69147$var$GHASH(key) {
    this.h = key;
    this.state = $255a39cb2ff69147$require$Buffer.alloc(16, 0);
    this.cache = $255a39cb2ff69147$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$255a39cb2ff69147$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$255a39cb2ff69147$var$GHASH.prototype._multiply = function() {
    var Vi = $255a39cb2ff69147$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $255a39cb2ff69147$var$fromArray(Zi);
};
$255a39cb2ff69147$var$GHASH.prototype.update = function(buf) {
    this.cache = $255a39cb2ff69147$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$255a39cb2ff69147$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($255a39cb2ff69147$require$Buffer.concat([
        this.cache,
        $255a39cb2ff69147$var$ZEROES
    ], 16));
    this.ghash($255a39cb2ff69147$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $255a39cb2ff69147$var$GHASH;

});


parcelRegister("8Yseu", function(module, exports) {

var $gNloh = parcelRequire("gNloh");

var $2iVwY = parcelRequire("2iVwY");
var $6889d3bbcc7d644b$require$Buffer = $2iVwY.Buffer;

var $7J5an = parcelRequire("7J5an");

var $9M38k = parcelRequire("9M38k");
function $6889d3bbcc7d644b$var$StreamCipher(mode, key, iv, decrypt) {
    $7J5an.call(this);
    this._cipher = new $gNloh.AES(key);
    this._prev = $6889d3bbcc7d644b$require$Buffer.from(iv);
    this._cache = $6889d3bbcc7d644b$require$Buffer.allocUnsafe(0);
    this._secCache = $6889d3bbcc7d644b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$9M38k($6889d3bbcc7d644b$var$StreamCipher, $7J5an);
$6889d3bbcc7d644b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$6889d3bbcc7d644b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $6889d3bbcc7d644b$var$StreamCipher;

});


parcelRegister("gjhe8", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $031072b82e97f5e0$export$12ada9414fbc594c; }, function (v) { return $031072b82e97f5e0$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $031072b82e97f5e0$export$36b6d6ef312eab39; }, function (v) { return $031072b82e97f5e0$export$36b6d6ef312eab39 = v; });
var $031072b82e97f5e0$export$12ada9414fbc594c;
var $031072b82e97f5e0$export$36b6d6ef312eab39;

var $5hO7b = parcelRequire("5hO7b");

var $2iVwY = parcelRequire("2iVwY");
var $031072b82e97f5e0$require$Buffer = $2iVwY.Buffer;

var $l6VnM = parcelRequire("l6VnM");

var $8Yseu = parcelRequire("8Yseu");

var $7J5an = parcelRequire("7J5an");

var $gNloh = parcelRequire("gNloh");

var $aXh1Z = parcelRequire("aXh1Z");

var $9M38k = parcelRequire("9M38k");
function $031072b82e97f5e0$var$Decipher(mode, key, iv) {
    $7J5an.call(this);
    this._cache = new $031072b82e97f5e0$var$Splitter();
    this._last = void 0;
    this._cipher = new $gNloh.AES(key);
    this._prev = $031072b82e97f5e0$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$9M38k($031072b82e97f5e0$var$Decipher, $7J5an);
$031072b82e97f5e0$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $031072b82e97f5e0$require$Buffer.concat(out);
};
$031072b82e97f5e0$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $031072b82e97f5e0$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$031072b82e97f5e0$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $031072b82e97f5e0$var$Splitter() {
    this.cache = $031072b82e97f5e0$require$Buffer.allocUnsafe(0);
}
$031072b82e97f5e0$var$Splitter.prototype.add = function(data) {
    this.cache = $031072b82e97f5e0$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$031072b82e97f5e0$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$031072b82e97f5e0$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $031072b82e97f5e0$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $031072b82e97f5e0$var$createDecipheriv(suite, password, iv) {
    var config = $l6VnM[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $031072b82e97f5e0$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $031072b82e97f5e0$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $8Yseu(config.module, password, iv, true);
    else if (config.type === "auth") return new $5hO7b(config.module, password, iv, true);
    return new $031072b82e97f5e0$var$Decipher(config.module, password, iv);
}
function $031072b82e97f5e0$var$createDecipher(suite, password) {
    var config = $l6VnM[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $aXh1Z(password, false, config.key, config.iv);
    return $031072b82e97f5e0$var$createDecipheriv(suite, keys.key, keys.iv);
}
$031072b82e97f5e0$export$12ada9414fbc594c = $031072b82e97f5e0$var$createDecipher;
$031072b82e97f5e0$export$36b6d6ef312eab39 = $031072b82e97f5e0$var$createDecipheriv;

});



parcelRegister("6hZjq", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $4943e3f0b0919caa$export$448fa22aedc9dbca; }, function (v) { return $4943e3f0b0919caa$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $4943e3f0b0919caa$export$b80c7ba289c8fa56; }, function (v) { return $4943e3f0b0919caa$export$b80c7ba289c8fa56 = v; });
var $4943e3f0b0919caa$export$448fa22aedc9dbca;
var $4943e3f0b0919caa$export$b80c7ba289c8fa56;

$4943e3f0b0919caa$export$448fa22aedc9dbca = (parcelRequire("4xsnO"));

$4943e3f0b0919caa$export$b80c7ba289c8fa56 = (parcelRequire("f0ZIh"));

});


parcelRegister("hLnyP", function(module, exports) {

var $3YkjF = parcelRequire("3YkjF");

var $2iVwY = parcelRequire("2iVwY");
var $cee91a2363f2c8db$require$Buffer = $2iVwY.Buffer;
module.exports = function(seed, len) {
    var t = $cee91a2363f2c8db$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $cee91a2363f2c8db$var$i2ops(i++);
        t = $cee91a2363f2c8db$require$Buffer.concat([
            t,
            $3YkjF("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $cee91a2363f2c8db$var$i2ops(c) {
    var out = $cee91a2363f2c8db$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("kQRUZ", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("33Lt4", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("1gODx", function(module, exports) {

var $33Lt4 = parcelRequire("33Lt4");

var $2iVwY = parcelRequire("2iVwY");
var $0ece9077c6764b90$require$Buffer = $2iVwY.Buffer;
function $0ece9077c6764b90$var$withPublic(paddedMsg, key) {
    return $0ece9077c6764b90$require$Buffer.from(paddedMsg.toRed($33Lt4.mont(key.modulus)).redPow(new $33Lt4(key.publicExponent)).fromRed().toArray());
}
module.exports = $0ece9077c6764b90$var$withPublic;

});

parcelRegister("gT4EJ", function(module, exports) {

var $3aNd6 = parcelRequire("3aNd6");
var $032c374e70956dea$require$Buffer = $3aNd6.Buffer;

var $fE5db = parcelRequire("fE5db");

var $5LzvA = parcelRequire("5LzvA");
function $032c374e70956dea$var$blind(priv) {
    var r = $032c374e70956dea$var$getr(priv);
    var blinder = r.toRed($fE5db.mont(priv.modulus)).redPow(new $fE5db(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $032c374e70956dea$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $fE5db($5LzvA(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $032c374e70956dea$var$crt(msg, priv) {
    var blinds = $032c374e70956dea$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $fE5db(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($fE5db.mont(priv.prime1));
    var c2 = blinded.toRed($fE5db.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($032c374e70956dea$require$Buffer, "be", len);
}
$032c374e70956dea$var$crt.getr = $032c374e70956dea$var$getr;
module.exports = $032c374e70956dea$var$crt;

});


parcelRegister("8TX9t", function(module, exports) {

var $9rqjB = parcelRequire("9rqjB");

var $hLnyP = parcelRequire("hLnyP");

var $kQRUZ = parcelRequire("kQRUZ");

var $33Lt4 = parcelRequire("33Lt4");

var $gT4EJ = parcelRequire("gT4EJ");

var $3YkjF = parcelRequire("3YkjF");

var $1gODx = parcelRequire("1gODx");

var $2iVwY = parcelRequire("2iVwY");
var $67b1581ec5a4d17c$require$Buffer = $2iVwY.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $9rqjB(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $33Lt4(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $1gODx(new $33Lt4(enc), key);
    else msg = $gT4EJ(enc, key);
    var zBuffer = $67b1581ec5a4d17c$require$Buffer.alloc(k - msg.length);
    msg = $67b1581ec5a4d17c$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $67b1581ec5a4d17c$var$oaep(key, msg);
    else if (padding === 1) return $67b1581ec5a4d17c$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $67b1581ec5a4d17c$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $3YkjF("sha1").update($67b1581ec5a4d17c$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $kQRUZ(maskedSeed, $hLnyP(maskedDb, hLen));
    var db = $kQRUZ(maskedDb, $hLnyP(seed, k - hLen - 1));
    if ($67b1581ec5a4d17c$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $67b1581ec5a4d17c$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $67b1581ec5a4d17c$var$compare(a, b) {
    a = $67b1581ec5a4d17c$require$Buffer.from(a);
    b = $67b1581ec5a4d17c$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("heMYq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $c8c9bba15c8e4dea$var$_gtag = $c8c9bba15c8e4dea$var$_interopRequireDefault((parcelRequire("cukwf")));

var $c8c9bba15c8e4dea$var$_format = $c8c9bba15c8e4dea$var$_interopRequireDefault((parcelRequire("epRbd")));
var $c8c9bba15c8e4dea$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $c8c9bba15c8e4dea$var$_excluded2 = [
    "title",
    "location"
], $c8c9bba15c8e4dea$var$_excluded3 = [
    "page",
    "hitType"
];
function $c8c9bba15c8e4dea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c8c9bba15c8e4dea$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c8c9bba15c8e4dea$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c8c9bba15c8e4dea$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c8c9bba15c8e4dea$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c8c9bba15c8e4dea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c8c9bba15c8e4dea$var$_typeof(obj);
}
function $c8c9bba15c8e4dea$var$_toConsumableArray(arr) {
    return $c8c9bba15c8e4dea$var$_arrayWithoutHoles(arr) || $c8c9bba15c8e4dea$var$_iterableToArray(arr) || $c8c9bba15c8e4dea$var$_unsupportedIterableToArray(arr) || $c8c9bba15c8e4dea$var$_nonIterableSpread();
}
function $c8c9bba15c8e4dea$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8c9bba15c8e4dea$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c8c9bba15c8e4dea$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c8c9bba15c8e4dea$var$_arrayLikeToArray(arr);
}
function $c8c9bba15c8e4dea$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c8c9bba15c8e4dea$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c8c9bba15c8e4dea$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c8c9bba15c8e4dea$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c8c9bba15c8e4dea$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c8c9bba15c8e4dea$var$_slicedToArray(arr, i) {
    return $c8c9bba15c8e4dea$var$_arrayWithHoles(arr) || $c8c9bba15c8e4dea$var$_iterableToArrayLimit(arr, i) || $c8c9bba15c8e4dea$var$_unsupportedIterableToArray(arr, i) || $c8c9bba15c8e4dea$var$_nonIterableRest();
}
function $c8c9bba15c8e4dea$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8c9bba15c8e4dea$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c8c9bba15c8e4dea$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c8c9bba15c8e4dea$var$_arrayLikeToArray(o, minLen);
}
function $c8c9bba15c8e4dea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c8c9bba15c8e4dea$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c8c9bba15c8e4dea$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c8c9bba15c8e4dea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c8c9bba15c8e4dea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c8c9bba15c8e4dea$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c8c9bba15c8e4dea$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c8c9bba15c8e4dea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c8c9bba15c8e4dea$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c8c9bba15c8e4dea$var$_defineProperty(obj, key, value) {
    key = $c8c9bba15c8e4dea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c8c9bba15c8e4dea$var$_toPropertyKey(arg) {
    var key = $c8c9bba15c8e4dea$var$_toPrimitive(arg, "string");
    return $c8c9bba15c8e4dea$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c8c9bba15c8e4dea$var$_toPrimitive(input, hint) {
    if ($c8c9bba15c8e4dea$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c8c9bba15c8e4dea$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $c8c9bba15c8e4dea$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $c8c9bba15c8e4dea$var$_classCallCheck(this, GA4);
        $c8c9bba15c8e4dea$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $c8c9bba15c8e4dea$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $c8c9bba15c8e4dea$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $c8c9bba15c8e4dea$var$_objectSpread($c8c9bba15c8e4dea$var$_objectSpread($c8c9bba15c8e4dea$var$_objectSpread({}, _this._toGtagOptions($c8c9bba15c8e4dea$var$_objectSpread($c8c9bba15c8e4dea$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $c8c9bba15c8e4dea$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $c8c9bba15c8e4dea$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($c8c9bba15c8e4dea$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $c8c9bba15c8e4dea$var$_objectSpread($c8c9bba15c8e4dea$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $c8c9bba15c8e4dea$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $c8c9bba15c8e4dea$var$_objectWithoutProperties(_args$, $c8c9bba15c8e4dea$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $c8c9bba15c8e4dea$var$_objectWithoutProperties(_this$_toGtagOptions, $c8c9bba15c8e4dea$var$_excluded2);
                _this._gtag("event", "page_view", $c8c9bba15c8e4dea$var$_objectSpread($c8c9bba15c8e4dea$var$_objectSpread($c8c9bba15c8e4dea$var$_objectSpread($c8c9bba15c8e4dea$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $c8c9bba15c8e4dea$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $c8c9bba15c8e4dea$var$_objectWithoutProperties(_args$2, $c8c9bba15c8e4dea$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $c8c9bba15c8e4dea$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $c8c9bba15c8e4dea$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $c8c9bba15c8e4dea$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $c8c9bba15c8e4dea$var$_format["default"])(category),
                    eventAction: (0, $c8c9bba15c8e4dea$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $c8c9bba15c8e4dea$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $c8c9bba15c8e4dea$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $c8c9bba15c8e4dea$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $c8c9bba15c8e4dea$var$GA4;
var $c8c9bba15c8e4dea$var$_default = new $c8c9bba15c8e4dea$var$GA4();
module.exports["default"] = $c8c9bba15c8e4dea$var$_default;

});
parcelRegister("cukwf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $917834073a80429d$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $917834073a80429d$var$_default = $917834073a80429d$var$gtag;
module.exports["default"] = $917834073a80429d$var$_default;

});

parcelRegister("epRbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a7eca6e28aa48df3$var$format;
var $a7eca6e28aa48df3$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $a7eca6e28aa48df3$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($a7eca6e28aa48df3$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $a7eca6e28aa48df3$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $a7eca6e28aa48df3$var$redacted = "REDACTED (Potential Email Address)";
function $a7eca6e28aa48df3$var$redactEmail(string) {
    if ($a7eca6e28aa48df3$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $a7eca6e28aa48df3$var$redacted;
    }
    return string;
}
function $a7eca6e28aa48df3$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $a7eca6e28aa48df3$var$toTitleCase(s);
    if (redactingEmail) _str = $a7eca6e28aa48df3$var$redactEmail(_str);
    return _str;
}

});


// WEVR.AI V2
// James Launder & Matt Webb
// 22/07/23
// Charting and News Completed enough to launch

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
parcelRequire("d2lNW");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";

var $d2lNW = parcelRequire("d2lNW");
var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $d2lNW.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $d2lNW.hydrateRoot;



var $aSiaI = parcelRequire("aSiaI");
/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d09e32d367368ff7$var$_extends() {
    $d09e32d367368ff7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d09e32d367368ff7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d09e32d367368ff7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d09e32d367368ff7$export$e19cd5f9376f8cee || ($d09e32d367368ff7$export$e19cd5f9376f8cee = {}));
const $d09e32d367368ff7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d09e32d367368ff7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d09e32d367368ff7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d09e32d367368ff7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d09e32d367368ff7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d09e32d367368ff7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d09e32d367368ff7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d09e32d367368ff7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d09e32d367368ff7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d09e32d367368ff7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d09e32d367368ff7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d09e32d367368ff7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d09e32d367368ff7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d09e32d367368ff7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d09e32d367368ff7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
        $d09e32d367368ff7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d09e32d367368ff7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d09e32d367368ff7$var$ResultType || ($d09e32d367368ff7$var$ResultType = {}));
const $d09e32d367368ff7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d09e32d367368ff7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d09e32d367368ff7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d09e32d367368ff7$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d09e32d367368ff7$var$isIndexRoute(route)) {
            let indexRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d09e32d367368ff7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d09e32d367368ff7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d09e32d367368ff7$var$flattenRoutes(routes);
    $d09e32d367368ff7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $d09e32d367368ff7$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $d09e32d367368ff7$var$safelyDecodeURI(pathname));
    return matches;
}
function $d09e32d367368ff7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d09e32d367368ff7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d09e32d367368ff7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d09e32d367368ff7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d09e32d367368ff7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d09e32d367368ff7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d09e32d367368ff7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d09e32d367368ff7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d09e32d367368ff7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d09e32d367368ff7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d09e32d367368ff7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d09e32d367368ff7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d09e32d367368ff7$var$paramRe = /^:\w+$/;
const $d09e32d367368ff7$var$dynamicSegmentValue = 3;
const $d09e32d367368ff7$var$indexRouteValue = 2;
const $d09e32d367368ff7$var$emptySegmentValue = 1;
const $d09e32d367368ff7$var$staticSegmentValue = 10;
const $d09e32d367368ff7$var$splatPenalty = -2;
const $d09e32d367368ff7$var$isSplat = (s)=>s === "*";
function $d09e32d367368ff7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d09e32d367368ff7$var$isSplat)) initialScore += $d09e32d367368ff7$var$splatPenalty;
    if (index) initialScore += $d09e32d367368ff7$var$indexRouteValue;
    return segments.filter((s)=>!$d09e32d367368ff7$var$isSplat(s)).reduce((score, segment)=>score + ($d09e32d367368ff7$var$paramRe.test(segment) ? $d09e32d367368ff7$var$dynamicSegmentValue : segment === "" ? $d09e32d367368ff7$var$emptySegmentValue : $d09e32d367368ff7$var$staticSegmentValue), initialScore);
}
function $d09e32d367368ff7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d09e32d367368ff7$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d09e32d367368ff7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d09e32d367368ff7$export$a5c6d149b50c1d86($d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d09e32d367368ff7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d09e32d367368ff7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d09e32d367368ff7$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d09e32d367368ff7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $d09e32d367368ff7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $d09e32d367368ff7$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d09e32d367368ff7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d09e32d367368ff7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $d09e32d367368ff7$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $d09e32d367368ff7$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d09e32d367368ff7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d09e32d367368ff7$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d09e32d367368ff7$var$normalizeSearch(search),
        hash: $d09e32d367368ff7$var$normalizeHash(hash)
    };
}
function $d09e32d367368ff7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d09e32d367368ff7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d09e32d367368ff7$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $d09e32d367368ff7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d09e32d367368ff7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d09e32d367368ff7$var$_extends({}, toArg);
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d09e32d367368ff7$var$getInvalidPathError("?", "pathname", "search", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "pathname", "hash", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d09e32d367368ff7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d09e32d367368ff7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d09e32d367368ff7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d09e32d367368ff7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d09e32d367368ff7$export$42a99a7a4bc0e76a extends Error {
}
class $d09e32d367368ff7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d09e32d367368ff7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d09e32d367368ff7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d09e32d367368ff7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d09e32d367368ff7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $d09e32d367368ff7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d09e32d367368ff7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d09e32d367368ff7$var$unwrapTrackedPromise(value) {
    if (!$d09e32d367368ff7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d09e32d367368ff7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d09e32d367368ff7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d09e32d367368ff7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $d09e32d367368ff7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d09e32d367368ff7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d09e32d367368ff7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d09e32d367368ff7$var$validMutationMethods = new Set($d09e32d367368ff7$var$validMutationMethodsArr);
const $d09e32d367368ff7$var$validRequestMethodsArr = [
    "get",
    ...$d09e32d367368ff7$var$validMutationMethodsArr
];
const $d09e32d367368ff7$var$validRequestMethods = new Set($d09e32d367368ff7$var$validRequestMethodsArr);
const $d09e32d367368ff7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d09e32d367368ff7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d09e32d367368ff7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d09e32d367368ff7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d09e32d367368ff7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d09e32d367368ff7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d09e32d367368ff7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $d09e32d367368ff7$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $d09e32d367368ff7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d09e32d367368ff7$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $d09e32d367368ff7$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d09e32d367368ff7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($d09e32d367368ff7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d09e32d367368ff7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d09e32d367368ff7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d09e32d367368ff7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d09e32d367368ff7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$d09e32d367368ff7$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $d09e32d367368ff7$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d09e32d367368ff7$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d09e32d367368ff7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $d09e32d367368ff7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($d09e32d367368ff7$var$isDeferredResult(result)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d09e32d367368ff7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d09e32d367368ff7$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d09e32d367368ff7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($d09e32d367368ff7$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d09e32d367368ff7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d09e32d367368ff7$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $d09e32d367368ff7$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $d09e32d367368ff7$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $d09e32d367368ff7$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($d09e32d367368ff7$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($d09e32d367368ff7$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($d09e32d367368ff7$var$isDeferredResult(actionResult)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d09e32d367368ff7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d09e32d367368ff7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d09e32d367368ff7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($d09e32d367368ff7$var$_extends({
                errors: errors,
                loaderData: $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $d09e32d367368ff7$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d09e32d367368ff7$var$isDeferredResult(result)) result = await $d09e32d367368ff7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $d09e32d367368ff7$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $d09e32d367368ff7$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace : $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d09e32d367368ff7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($d09e32d367368ff7$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $d09e32d367368ff7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d09e32d367368ff7$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $d09e32d367368ff7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d09e32d367368ff7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $d09e32d367368ff7$var$callLoaderOrAction("loader", $d09e32d367368ff7$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $d09e32d367368ff7$var$ResultType.error,
                        error: $d09e32d367368ff7$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d09e32d367368ff7$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d09e32d367368ff7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d09e32d367368ff7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d09e32d367368ff7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d09e32d367368ff7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d09e32d367368ff7$export$4d0306f8f6a4585b = Symbol("deferred");
function $d09e32d367368ff7$export$3336b097a6fbc59a(routes, opts) {
    $d09e32d367368ff7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d09e32d367368ff7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d09e32d367368ff7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d09e32d367368ff7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $d09e32d367368ff7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d09e32d367368ff7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d09e32d367368ff7$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $d09e32d367368ff7$var$isResponse(result) ? result : $d09e32d367368ff7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($d09e32d367368ff7$var$isQueryRouteResponse(e)) {
                if (e.type === $d09e32d367368ff7$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d09e32d367368ff7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        } else {
            result = await $d09e32d367368ff7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($d09e32d367368ff7$var$isDeferredResult(result)) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d09e32d367368ff7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $d09e32d367368ff7$var$_extends({}, context, {
                statusCode: $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $d09e32d367368ff7$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d09e32d367368ff7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d09e32d367368ff7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d09e32d367368ff7$export$fec11da027c70692(routes, context, error) {
    let newContext = $d09e32d367368ff7$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d09e32d367368ff7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d09e32d367368ff7$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d09e32d367368ff7$export$cae722b0cc860f13(to ? to : ".", $d09e32d367368ff7$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$d09e32d367368ff7$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d09e32d367368ff7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d09e32d367368ff7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d09e32d367368ff7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d09e32d367368ff7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d09e32d367368ff7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d09e32d367368ff7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d09e32d367368ff7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d09e32d367368ff7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d09e32d367368ff7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d09e32d367368ff7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d09e32d367368ff7$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($d09e32d367368ff7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d09e32d367368ff7$var$shouldRevalidateLoader(match, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d09e32d367368ff7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $d09e32d367368ff7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $d09e32d367368ff7$var$shouldRevalidateLoader(fetcherMatch, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d09e32d367368ff7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d09e32d367368ff7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d09e32d367368ff7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d09e32d367368ff7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d09e32d367368ff7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d09e32d367368ff7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d09e32d367368ff7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $d09e32d367368ff7$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d09e32d367368ff7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d09e32d367368ff7$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d09e32d367368ff7$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $d09e32d367368ff7$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($d09e32d367368ff7$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($d09e32d367368ff7$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $d09e32d367368ff7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(location)) location = $d09e32d367368ff7$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $d09e32d367368ff7$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $d09e32d367368ff7$var$ResultType.error ? $d09e32d367368ff7$var$ResultType.error : $d09e32d367368ff7$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $d09e32d367368ff7$var$ResultType.error) return {
            type: resultType,
            error: new $d09e32d367368ff7$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $d09e32d367368ff7$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($d09e32d367368ff7$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $d09e32d367368ff7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d09e32d367368ff7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d09e32d367368ff7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d09e32d367368ff7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d09e32d367368ff7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($d09e32d367368ff7$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $d09e32d367368ff7$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($d09e32d367368ff7$var$isErrorResult(result)) {
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d09e32d367368ff7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d09e32d367368ff7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d09e32d367368ff7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d09e32d367368ff7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d09e32d367368ff7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d09e32d367368ff7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d09e32d367368ff7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d09e32d367368ff7$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d09e32d367368ff7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d09e32d367368ff7$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d09e32d367368ff7$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $d09e32d367368ff7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(path) : path;
    return $d09e32d367368ff7$export$fe53371bee54353d($d09e32d367368ff7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d09e32d367368ff7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d09e32d367368ff7$var$isDeferredResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.deferred;
}
function $d09e32d367368ff7$var$isErrorResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.error;
}
function $d09e32d367368ff7$var$isRedirectResult(result) {
    return (result && result.type) === $d09e32d367368ff7$var$ResultType.redirect;
}
function $d09e32d367368ff7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d09e32d367368ff7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d09e32d367368ff7$var$isRedirectResponse(result) {
    if (!$d09e32d367368ff7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d09e32d367368ff7$var$isQueryRouteResponse(obj) {
    return obj && $d09e32d367368ff7$var$isResponse(obj.response) && (obj.type === $d09e32d367368ff7$var$ResultType.data || obj.type === $d09e32d367368ff7$var$ResultType.error);
}
function $d09e32d367368ff7$var$isValidMethod(method) {
    return $d09e32d367368ff7$var$validRequestMethods.has(method.toLowerCase());
}
function $d09e32d367368ff7$var$isMutationMethod(method) {
    return $d09e32d367368ff7$var$validMutationMethods.has(method.toLowerCase());
}
async function $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d09e32d367368ff7$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $d09e32d367368ff7$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $d09e32d367368ff7$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $d09e32d367368ff7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d09e32d367368ff7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d09e32d367368ff7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d09e32d367368ff7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d09e32d367368ff7$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d09e32d367368ff7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d09e32d367368ff7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d09e32d367368ff7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d09e32d367368ff7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $d09e32d367368ff7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}

/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");

function $b0e6fcd50b7ef685$var$_extends() {
    $b0e6fcd50b7ef685$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0e6fcd50b7ef685$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $b0e6fcd50b7ef685$export$3add0d5dce533e2e = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$145dfa71566a64dc = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$var$AwaitContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $b0e6fcd50b7ef685$export$26749e8557646306 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$c7914228fb69b0f5 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$9072aa6dd1f93057 = /*#__PURE__*/ $exYeM.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $b0e6fcd50b7ef685$var$RouteErrorContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $b0e6fcd50b7ef685$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $b0e6fcd50b7ef685$export$9c954a9d03d32f4a() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $b0e6fcd50b7ef685$export$45d76561a5302f2b() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $b0e6fcd50b7ef685$export$1b3f31771c5d07c() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $b0e6fcd50b7ef685$export$6c330e8992e8a295(pattern) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    return $exYeM.useMemo(()=>(0, $d09e32d367368ff7$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $b0e6fcd50b7ef685$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $exYeM.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $b0e6fcd50b7ef685$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $b0e6fcd50b7ef685$var$useNavigateStable() : $b0e6fcd50b7ef685$var$useNavigateUnstable();
}
function $b0e6fcd50b7ef685$var$useNavigateUnstable() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d09e32d367368ff7$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$OutletContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $b0e6fcd50b7ef685$export$4138103a3ae699cc() {
    return $exYeM.useContext($b0e6fcd50b7ef685$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(context) {
    let outlet = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d09e32d367368ff7$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $exYeM.useMemo(()=>(0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $b0e6fcd50b7ef685$export$5d3fca4a98652595(routes, locationArg) {
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: parentMatches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $d09e32d367368ff7$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $d09e32d367368ff7$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $b0e6fcd50b7ef685$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b0e6fcd50b7ef685$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $d09e32d367368ff7$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b0e6fcd50b7ef685$var$DefaultErrorComponent() {
    let error = $b0e6fcd50b7ef685$export$ed527bf60f6e05f2();
    let message = (0, $d09e32d367368ff7$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $exYeM.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $exYeM.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $b0e6fcd50b7ef685$var$defaultErrorElement = /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DefaultErrorComponent, null);
class $b0e6fcd50b7ef685$var$RenderErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $b0e6fcd50b7ef685$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b0e6fcd50b7ef685$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $b0e6fcd50b7ef685$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $exYeM.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $b0e6fcd50b7ef685$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($b0e6fcd50b7ef685$var$DataRouterHook || {});
var $b0e6fcd50b7ef685$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($b0e6fcd50b7ef685$var$DataRouterStateHook || {});
function $b0e6fcd50b7ef685$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b0e6fcd50b7ef685$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    !ctx && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b0e6fcd50b7ef685$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext($b0e6fcd50b7ef685$export$145dfa71566a64dc);
    !state && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return state;
}
function $b0e6fcd50b7ef685$var$useRouteContext(hookName) {
    let route = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $b0e6fcd50b7ef685$var$useCurrentRouteId(hookName) {
    let route = $b0e6fcd50b7ef685$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $b0e6fcd50b7ef685$export$5fc8298006ad9e58() {
    return $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b0e6fcd50b7ef685$export$d0fd4b7106de2769() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b0e6fcd50b7ef685$export$600dc272ed516c15() {
    let dataRouterContext = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseRevalidator);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRevalidator);
    return $exYeM.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b0e6fcd50b7ef685$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseMatches);
    return $exYeM.useMemo(()=>matches.map((m)=>(0, $d09e32d367368ff7$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b0e6fcd50b7ef685$export$1448a5050d252c4d() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b0e6fcd50b7ef685$export$fd5d37484eab868d(routeId) {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b0e6fcd50b7ef685$export$fdc00f3f26066d5e() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseActionData);
    let route = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $b0e6fcd50b7ef685$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $exYeM.useContext($b0e6fcd50b7ef685$var$RouteErrorContext);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $b0e6fcd50b7ef685$export$78a72ddb39bdd145() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $b0e6fcd50b7ef685$export$17f53340677d5831() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $b0e6fcd50b7ef685$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $b0e6fcd50b7ef685$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseBlocker);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $exYeM.useState("");
    let blockerFunction = $exYeM.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $b0e6fcd50b7ef685$var$_extends({}, currentLocation, {
                pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $b0e6fcd50b7ef685$var$_extends({}, nextLocation, {
                pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $exYeM.useEffect(()=>{
        let key = String(++$b0e6fcd50b7ef685$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $exYeM.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $d09e32d367368ff7$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $b0e6fcd50b7ef685$var$useNavigateStable() {
    let { router: router } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseNavigateStable);
    let id = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $b0e6fcd50b7ef685$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$alreadyWarned = {};
function $b0e6fcd50b7ef685$var$warningOnce(key, cond, message) {
    if (!cond && !$b0e6fcd50b7ef685$var$alreadyWarned[key]) $b0e6fcd50b7ef685$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b0e6fcd50b7ef685$var$START_TRANSITION = "startTransition";
const $b0e6fcd50b7ef685$var$startTransitionImpl = $exYeM[$b0e6fcd50b7ef685$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b0e6fcd50b7ef685$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl ? $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $b0e6fcd50b7ef685$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $b0e6fcd50b7ef685$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl ? $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $b0e6fcd50b7ef685$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let navigate = $b0e6fcd50b7ef685$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, (0, $d09e32d367368ff7$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $exYeM.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $b0e6fcd50b7ef685$export$910ae8079b2c2852(props) {
    return $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $b0e6fcd50b7ef685$export$e7b0ac011bb776c6(_props) {
    (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $b0e6fcd50b7ef685$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $d09e32d367368ff7$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $exYeM.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $d09e32d367368ff7$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $exYeM.useMemo(()=>{
        let trailingPathname = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $b0e6fcd50b7ef685$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $b0e6fcd50b7ef685$export$5d3fca4a98652595($b0e6fcd50b7ef685$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b0e6fcd50b7ef685$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$ResolveAwait, null, children));
}
var $b0e6fcd50b7ef685$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($b0e6fcd50b7ef685$var$AwaitRenderStatus || {});
const $b0e6fcd50b7ef685$var$neverSettledPromise = new Promise(()=>{});
class $b0e6fcd50b7ef685$var$AwaitErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.error : promise._data !== undefined ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.success : $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && promise._error instanceof (0, $d09e32d367368ff7$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $b0e6fcd50b7ef685$var$neverSettledPromise;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $b0e6fcd50b7ef685$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $b0e6fcd50b7ef685$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $b0e6fcd50b7ef685$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $exYeM.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $exYeM.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $b0e6fcd50b7ef685$export$e7b0ac011bb776c6) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b0e6fcd50b7ef685$export$daf73786167a7f72(matches) {
    return $b0e6fcd50b7ef685$var$_renderMatches(matches);
}
function $b0e6fcd50b7ef685$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $exYeM.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $exYeM.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $b0e6fcd50b7ef685$export$f30f7e456d254e83(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b0e6fcd50b7ef685$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $b0e6fcd50b7ef685$export$52b333d321859367
    }).initialize();
}



function $2cc1d3688dd37f6f$var$_extends() {
    $2cc1d3688dd37f6f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2cc1d3688dd37f6f$var$_extends.apply(this, arguments);
}
function $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $2cc1d3688dd37f6f$var$defaultMethod = "get";
const $2cc1d3688dd37f6f$var$defaultEncType = "application/x-www-form-urlencoded";
function $2cc1d3688dd37f6f$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $2cc1d3688dd37f6f$var$isButtonElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $2cc1d3688dd37f6f$var$isFormElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $2cc1d3688dd37f6f$var$isInputElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $2cc1d3688dd37f6f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$2cc1d3688dd37f6f$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $2cc1d3688dd37f6f$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = null;
function $2cc1d3688dd37f6f$var$isFormDataSubmitterSupported() {
    if ($2cc1d3688dd37f6f$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = true;
    }
    return $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter;
}
const $2cc1d3688dd37f6f$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $2cc1d3688dd37f6f$var$getFormEncType(encType) {
    if (encType != null && !$2cc1d3688dd37f6f$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($2cc1d3688dd37f6f$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        formData = new FormData(target);
    } else if ($2cc1d3688dd37f6f$var$isButtonElement(target) || $2cc1d3688dd37f6f$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("formenctype")) || $2cc1d3688dd37f6f$var$getFormEncType(form.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$2cc1d3688dd37f6f$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($2cc1d3688dd37f6f$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $2cc1d3688dd37f6f$var$defaultMethod;
        action = null;
        encType = $2cc1d3688dd37f6f$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $2cc1d3688dd37f6f$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $2cc1d3688dd37f6f$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $2cc1d3688dd37f6f$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $2cc1d3688dd37f6f$export$1f3f55432a00e06d(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b0e6fcd50b7ef685$export$52b333d321859367)
    }).initialize();
}
function $2cc1d3688dd37f6f$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b0e6fcd50b7ef685$export$52b333d321859367)
    }).initialize();
}
function $2cc1d3688dd37f6f$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $2cc1d3688dd37f6f$var$_extends({}, state, {
        errors: $2cc1d3688dd37f6f$var$deserializeErrors(state.errors)
    });
    return state;
}
function $2cc1d3688dd37f6f$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $d09e32d367368ff7$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2cc1d3688dd37f6f$var$START_TRANSITION = "startTransition";
const $2cc1d3688dd37f6f$var$startTransitionImpl = $exYeM[$2cc1d3688dd37f6f$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $2cc1d3688dd37f6f$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $2cc1d3688dd37f6f$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $2cc1d3688dd37f6f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a = /*#__PURE__*/ $exYeM.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref4, $2cc1d3688dd37f6f$var$_excluded);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($2cc1d3688dd37f6f$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $b0e6fcd50b7ef685$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $2cc1d3688dd37f6f$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $exYeM.createElement("a", $2cc1d3688dd37f6f$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d = /*#__PURE__*/ $exYeM.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref5, $2cc1d3688dd37f6f$var$_excluded2);
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let routerState = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc));
    let { navigator: navigator } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$a6c7ac8248d6e38a, $2cc1d3688dd37f6f$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $2cc1d3688dd37f6f$export$a7fed597f4b8afd8 = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
    let submit = $2cc1d3688dd37f6f$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$var$FormImpl, $2cc1d3688dd37f6f$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $2cc1d3688dd37f6f$var$FormImpl = /*#__PURE__*/ $exYeM.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $2cc1d3688dd37f6f$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref6, $2cc1d3688dd37f6f$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $exYeM.createElement("form", $2cc1d3688dd37f6f$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $2cc1d3688dd37f6f$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $2cc1d3688dd37f6f$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $2cc1d3688dd37f6f$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($2cc1d3688dd37f6f$var$DataRouterHook || ($2cc1d3688dd37f6f$var$DataRouterHook = {}));
var $2cc1d3688dd37f6f$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($2cc1d3688dd37f6f$var$DataRouterStateHook || ($2cc1d3688dd37f6f$var$DataRouterStateHook = {}));
function $2cc1d3688dd37f6f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2cc1d3688dd37f6f$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$3add0d5dce533e2e));
    !ctx && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2cc1d3688dd37f6f$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc));
    !state && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $2cc1d3688dd37f6f$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $exYeM.useCallback((event)=>{
        if ($2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $d09e32d367368ff7$export$fe53371bee54353d)(location) === (0, $d09e32d367368ff7$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $2cc1d3688dd37f6f$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $exYeM.useRef($2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $exYeM.useRef(false);
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let searchParams = $exYeM.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $2cc1d3688dd37f6f$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    let setSearchParams = $exYeM.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $2cc1d3688dd37f6f$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $2cc1d3688dd37f6f$export$47c85c6e3a081d3() {
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let currentRouteId = (0, $b0e6fcd50b7ef685$export$5fc8298006ad9e58)();
    return $exYeM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $2cc1d3688dd37f6f$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $2cc1d3688dd37f6f$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    return $exYeM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $2cc1d3688dd37f6f$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let routeContext = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$9072aa6dd1f93057));
    !routeContext && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $2cc1d3688dd37f6f$var$_extends({}, (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $d09e32d367368ff7$export$fe53371bee54353d)(path);
}
function $2cc1d3688dd37f6f$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
        let submit = $2cc1d3688dd37f6f$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$var$FormImpl, $2cc1d3688dd37f6f$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $2cc1d3688dd37f6f$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $2cc1d3688dd37f6f$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseFetcher);
    let route = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$9072aa6dd1f93057));
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $exYeM.useState(()=>String(++$2cc1d3688dd37f6f$var$fetcherId));
    let [Form] = $exYeM.useState(()=>{
        !routeId && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        return $2cc1d3688dd37f6f$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $exYeM.useState(()=>(href)=>{
            !router && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
            !routeId && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $2cc1d3688dd37f6f$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $exYeM.useMemo(()=>$2cc1d3688dd37f6f$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $exYeM.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $2cc1d3688dd37f6f$export$fa996778a3a31087() {
    let state = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $2cc1d3688dd37f6f$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $2cc1d3688dd37f6f$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let matches = (0, $b0e6fcd50b7ef685$export$2378eb7f5ff86053)();
    let navigation = (0, $b0e6fcd50b7ef685$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $exYeM.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $2cc1d3688dd37f6f$var$usePageHide($exYeM.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $2cc1d3688dd37f6f$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($2cc1d3688dd37f6f$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $2cc1d3688dd37f6f$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($2cc1d3688dd37f6f$var$_extends({}, location, {
                    pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($2cc1d3688dd37f6f$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $2cc1d3688dd37f6f$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $b0e6fcd50b7ef685$export$2af03a1de5c0910)(when);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

// Created by James Launder inspired by tailwind ui
// standard footer

var $aSiaI = parcelRequire("aSiaI");

const $591b4fc8950b1730$var$navigation = {
    main: [
        {
            name: "Explore",
            href: "/Explore?blockchain=Ethereum"
        },
        {
            name: "Discover",
            href: "/Discover"
        },
        {
            name: "Footprint",
            href: "/Footprint"
        },
        {
            name: "Dashboard",
            href: "/Dashboard"
        },
        {
            name: "Pricing",
            href: "/Pricing"
        },
        {
            name: "FAQ",
            href: "/FAQ"
        },
        {
            name: "Legal",
            href: "/Legal"
        },
        {
            name: "Contact Us",
            href: "/Contact"
        },
        {
            name: "Glossary",
            href: "/Glossary"
        }
    ],
    social: [
        {
            name: "Facebook",
            href: "https://www.facebook.com/WevrPtyLtd/",
            icon: (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
                        clipRule: "evenodd"
                    })
                })
        },
        {
            name: "Twitter",
            href: "https://twitter.com/wevr_ai",
            icon: (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                    })
                })
        },
        {
            name: "Medium",
            href: "https://medium.com/@wevr.ai",
            icon: (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    ...props,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                        d: "M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"
                    })
                })
        },
        {
            name: "TikTok",
            href: "https://www.tiktok.com/@wevr_ai",
            icon: (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                        d: "M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
                    })
                })
        },
        {
            name: "Youtube",
            href: "https://www.youtube.com/@wevrai",
            icon: (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                        d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                    })
                })
        }
    ]
};
function $591b4fc8950b1730$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $aSiaI.jsx)("footer", {
        className: "border-t border",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "mx-auto max-w-7xl overflow-hidden py-10 px-4 sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("nav", {
                    className: "-mx-5 pt-4 flex flex-wrap justify-center",
                    "aria-label": "Footer",
                    children: [
                        $591b4fc8950b1730$var$navigation.main.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "px-5 py-2",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                    to: item.href,
                                    className: "text-base text-gray-500 hover:text-gray-900",
                                    children: item.name
                                })
                            }, item.name)),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "px-5 py-2",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                href: "https://docs.wevr.ai",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "text-base text-gray-500 hover:text-gray-900",
                                children: "Documentation"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "px-5 py-2",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                href: "https://blog.wevr.ai",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "text-base text-gray-500 hover:text-gray-900",
                                children: "Blog"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "mt-8 flex justify-center space-x-6",
                    children: $591b4fc8950b1730$var$navigation.social.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                            href: item.href,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "text-gray-400 hover:text-gray-500 items-center flex",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "sr-only",
                                    children: item.name
                                }),
                                item.icon ? /*#__PURE__*/ (0, $aSiaI.jsx)(item.icon, {
                                    className: "h-6 w-6",
                                    "aria-hidden": "true"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: item.name
                                })
                            ]
                        }, item.name))
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
                    className: "mt-8 text-center text-base text-gray-400",
                    children: [
                        "\xa9 ",
                        new Date().getFullYear(),
                        " Wevr Pty Ltd All rights reserved. ACN: 665 121 540"
                    ]
                })
            ]
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $79f42255615f1616$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}


function $73fd0be368b973e0$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $73fd0be368b973e0$export$4659b591c19bdf3d), t;
}


var $6da0b689c34972b7$export$617d79dae526d2cf = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($6da0b689c34972b7$export$617d79dae526d2cf || {}), $6da0b689c34972b7$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($6da0b689c34972b7$export$80c0a745e59f7989 || {});
function $6da0b689c34972b7$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: a, features: s, visible: n = !0, name: f }) {
    let o = $6da0b689c34972b7$var$N(t, r);
    if (n) return $6da0b689c34972b7$var$c(o, e, a, f);
    let u = s != null ? s : 0;
    if (u & 2) {
        let { static: l = !1, ...p } = o;
        if (l) return $6da0b689c34972b7$var$c(p, e, a, f);
    }
    if (u & 1) {
        let { unmount: l = !0, ...p } = o;
        return (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(l ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $6da0b689c34972b7$var$c({
                    ...p,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, a, f);
            }
        });
    }
    return $6da0b689c34972b7$var$c(o, e, a, f);
}
function $6da0b689c34972b7$var$c(r, t = {}, e, a) {
    let { as: s = e, children: n, refName: f = "ref", ...o } = $6da0b689c34972b7$var$g(r, [
        "unmount",
        "static"
    ]), u = r.ref !== void 0 ? {
        [f]: r.ref
    } : {}, l = typeof n == "function" ? n(t) : n;
    "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(t));
    let p = {};
    if (t) {
        let i = !1, m = [];
        for (let [y, d] of Object.entries(t))typeof d == "boolean" && (i = !0), d === !0 && m.push(y);
        i && (p["data-headlessui-state"] = m.join(" "));
    }
    if (s === (0, $exYeM.Fragment) && Object.keys($6da0b689c34972b7$export$8e16b83750b44988(o)).length > 0) {
        if (!(0, $exYeM.isValidElement)(l) || Array.isArray(l) && l.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${a} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(o).map((d)=>`  - ${d}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((d)=>`  - ${d}`).join(`
`)
        ].join(`
`));
        let i = l.props, m = typeof (i == null ? void 0 : i.className) == "function" ? (...d)=>(0, $79f42255615f1616$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className(...d), o.className) : (0, $79f42255615f1616$export$ce4ab0c55987d1ff)(i == null ? void 0 : i.className, o.className), y = m ? {
            className: m
        } : {};
        return (0, $exYeM.cloneElement)(l, Object.assign({}, $6da0b689c34972b7$var$N(l.props, $6da0b689c34972b7$export$8e16b83750b44988($6da0b689c34972b7$var$g(o, [
            "ref"
        ]))), p, u, $6da0b689c34972b7$var$w(l.ref, u.ref), y));
    }
    return (0, $exYeM.createElement)(s, Object.assign({}, $6da0b689c34972b7$var$g(o, [
        "ref"
    ]), s !== (0, $exYeM.Fragment) && u, s !== (0, $exYeM.Fragment) && p), l);
}
function $6da0b689c34972b7$var$w(...r) {
    return {
        ref: r.every((t)=>t == null) ? void 0 : (t)=>{
            for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
        }
    };
}
function $6da0b689c34972b7$var$N(...r) {
    var a;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let s of r)for(let n in s)n.startsWith("on") && typeof s[n] == "function" ? ((a = e[n]) != null || (e[n] = []), e[n].push(s[n])) : t[n] = s[n];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((s)=>[
            s,
            void 0
        ])));
    for(let s in e)Object.assign(t, {
        [s] (n, ...f) {
            let o = e[s];
            for (let u of o){
                if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
                u(n, ...f);
            }
        }
    });
    return t;
}
function $6da0b689c34972b7$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $exYeM.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $6da0b689c34972b7$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $6da0b689c34972b7$var$g(r, t = []) {
    let e = Object.assign({}, r);
    for (let a of t)a in e && delete e[a];
    return e;
}



var $exYeM = parcelRequire("exYeM");
let $d2513f66ac282f05$var$n = (0, $exYeM.createContext)(null);
$d2513f66ac282f05$var$n.displayName = "OpenClosedContext";
var $d2513f66ac282f05$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($d2513f66ac282f05$export$7254cc27399e90bd || {});
function $d2513f66ac282f05$export$fc6fdf0ecf360e() {
    return (0, $exYeM.useContext)($d2513f66ac282f05$var$n);
}
function $d2513f66ac282f05$export$2a0ed818b175f558({ value: o, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d2513f66ac282f05$var$n.Provider, {
        value: o
    }, r);
}




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $206745f75df36d9f$var$i = Object.defineProperty;
var $206745f75df36d9f$var$d = (t, e, n)=>e in t ? $206745f75df36d9f$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $206745f75df36d9f$var$r = (t, e, n)=>($206745f75df36d9f$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $206745f75df36d9f$var$o {
    constructor(){
        $206745f75df36d9f$var$r(this, "current", this.detect());
        $206745f75df36d9f$var$r(this, "handoffState", "pending");
        $206745f75df36d9f$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $206745f75df36d9f$export$a7b6bc01c63cdfc3 = new $206745f75df36d9f$var$o;


let $de1371c4941e924f$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).isServer ? (0, $exYeM.useEffect)(e, f) : (0, $exYeM.useLayoutEffect)(e, f);
};


function $a674dbdb004593f0$export$80c2a3957bcb42ea() {
    let e = (0, $exYeM.useRef)(!1);
    return (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}




var $exYeM = parcelRequire("exYeM");

function $8dd7f512f0d6b4ee$export$86c4283a11f23f95(e) {
    let r = (0, $exYeM.useRef)(e);
    return (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}



var $exYeM = parcelRequire("exYeM");

function $eea6929722880e02$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $exYeM ? ((o)=>o.useSyncExternalStore)($exYeM)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $eea6929722880e02$export$44ab2b9f2d09b0fa() {
    let r = $eea6929722880e02$var$s(), [e, n] = $exYeM.useState((0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && n(!1), $exYeM.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $exYeM.useEffect(()=>(0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).handoff(), []), r ? !1 : e;
}



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

let $0fe40135503fe52e$export$90fc3a17d93f704c = function(t) {
    let e = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};


let $b45ba282b8330326$var$u = Symbol();
function $b45ba282b8330326$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$b45ba282b8330326$var$u]: n
    });
}
function $b45ba282b8330326$export$f6a25a78204acc7e(...t) {
    let n = (0, $exYeM.useRef)(t);
    (0, $exYeM.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$b45ba282b8330326$var$u])) ? void 0 : c;
}


function $2f9987d626f1ea56$export$d2de3aaeafa91619(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}


function $92b943bceaf40d00$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $fb27e053aa71d13a$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $92b943bceaf40d00$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $fb27e053aa71d13a$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}



function $63650b5e4ce8a4d6$var$g(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $63650b5e4ce8a4d6$var$v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function $63650b5e4ce8a4d6$var$b(t, e) {
    let n = (0, $fb27e053aa71d13a$export$12b26c28a05aa001)();
    if (!t) return n.dispose;
    let { transitionDuration: m, transitionDelay: a } = getComputedStyle(t), [u, p] = [
        m,
        a
    ].map((l)=>{
        let [r = 0] = l.split(",").filter(Boolean).map((i)=>i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, T)=>T - i);
        return r;
    }), o = u + p;
    if (o !== 0) {
        n.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, o), r.addEventListener(t, "transitionrun", (i)=>{
                i.target === i.currentTarget && r.dispose();
            });
        });
        let l = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), l());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function $63650b5e4ce8a4d6$export$66bb15e2994e6a26(t, e, n, m) {
    let a = n ? "enter" : "leave", u = (0, $fb27e053aa71d13a$export$12b26c28a05aa001)(), p = m !== void 0 ? (0, $2f9987d626f1ea56$export$d2de3aaeafa91619)(m) : ()=>{};
    a === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let o = (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), l = (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $63650b5e4ce8a4d6$var$v(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $63650b5e4ce8a4d6$var$g(t, ...e.base, ...o, ...r), u.nextFrame(()=>{
        $63650b5e4ce8a4d6$var$v(t, ...e.base, ...o, ...r), $63650b5e4ce8a4d6$var$g(t, ...e.base, ...o, ...l), $63650b5e4ce8a4d6$var$b(t, ()=>($63650b5e4ce8a4d6$var$v(t, ...e.base, ...o), $63650b5e4ce8a4d6$var$g(t, ...e.base, ...e.entered), p()));
    }), u.dispose;
}




var $exYeM = parcelRequire("exYeM");

function $1a42d470fe7d2fb4$export$fd183955ff4b45d9() {
    let [e] = (0, $exYeM.useState)((0, $fb27e053aa71d13a$export$12b26c28a05aa001));
    return (0, $exYeM.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}





function $5973326d35cf9792$export$7b286972b8d8ccbf({ immediate: t, container: s, direction: n, classes: u, onStart: a, onStop: c }) {
    let l = (0, $a674dbdb004593f0$export$80c2a3957bcb42ea)(), d = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)(), e = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(n);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        t && (e.current = "enter");
    }, [
        t
    ]), (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        let r = (0, $fb27e053aa71d13a$export$12b26c28a05aa001)();
        d.add(r.dispose);
        let i = s.current;
        if (i && e.current !== "idle" && l.current) return r.dispose(), a.current(e.current), r.add((0, $63650b5e4ce8a4d6$export$66bb15e2994e6a26)(i, u.current, e.current === "enter", ()=>{
            r.dispose(), c.current(e.current);
        })), r.dispose;
    }, [
        n
    ]);
}






var $exYeM = parcelRequire("exYeM");

function $103a9133e78b2210$export$2879604e6aec4ab(a = 0) {
    let [l, r] = (0, $exYeM.useState)(a), t = (0, $a674dbdb004593f0$export$80c2a3957bcb42ea)(), o = (0, $exYeM.useCallback)((e)=>{
        t.current && r((u)=>u | e);
    }, [
        l,
        t
    ]), m = (0, $exYeM.useCallback)((e)=>Boolean(l & e), [
        l
    ]), s = (0, $exYeM.useCallback)((e)=>{
        t.current && r((u)=>u & ~e);
    }, [
        r,
        t
    ]), g = (0, $exYeM.useCallback)((e)=>{
        t.current && r((u)=>u ^ e);
    }, [
        r
    ]);
    return {
        flags: l,
        addFlag: o,
        hasFlag: m,
        removeFlag: s,
        toggleFlag: g
    };
}


function $e43b19f549669bf9$var$S(t = "") {
    return t.split(" ").filter((n)=>n.trim().length > 1);
}
let $e43b19f549669bf9$var$_ = (0, $exYeM.createContext)(null);
$e43b19f549669bf9$var$_.displayName = "TransitionContext";
var $e43b19f549669bf9$var$be = ((r)=>(r.Visible = "visible", r.Hidden = "hidden", r))($e43b19f549669bf9$var$be || {});
function $e43b19f549669bf9$var$Se() {
    let t = (0, $exYeM.useContext)($e43b19f549669bf9$var$_);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
function $e43b19f549669bf9$var$Ne() {
    let t = (0, $exYeM.useContext)($e43b19f549669bf9$var$M);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
let $e43b19f549669bf9$var$M = (0, $exYeM.createContext)(null);
$e43b19f549669bf9$var$M.displayName = "NestingContext";
function $e43b19f549669bf9$var$U(t) {
    return "children" in t ? $e43b19f549669bf9$var$U(t.children) : t.current.filter(({ el: n })=>n.current !== null).filter(({ state: n })=>n === "visible").length > 0;
}
function $e43b19f549669bf9$var$oe(t, n) {
    let r = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(t), s = (0, $exYeM.useRef)([]), y = (0, $a674dbdb004593f0$export$80c2a3957bcb42ea)(), D = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)(), c = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((i, e = (0, $6da0b689c34972b7$export$80c0a745e59f7989).Hidden)=>{
        let a = s.current.findIndex(({ el: o })=>o === i);
        a !== -1 && ((0, $73fd0be368b973e0$export$4659b591c19bdf3d)(e, {
            [(0, $6da0b689c34972b7$export$80c0a745e59f7989).Unmount] () {
                s.current.splice(a, 1);
            },
            [(0, $6da0b689c34972b7$export$80c0a745e59f7989).Hidden] () {
                s.current[a].state = "hidden";
            }
        }), D.microTask(()=>{
            var o;
            !$e43b19f549669bf9$var$U(s) && y.current && ((o = r.current) == null || o.call(r));
        }));
    }), x = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((i)=>{
        let e = s.current.find(({ el: a })=>a === i);
        return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
            el: i,
            state: "visible"
        }), ()=>c(i, (0, $6da0b689c34972b7$export$80c0a745e59f7989).Unmount);
    }), p = (0, $exYeM.useRef)([]), h = (0, $exYeM.useRef)(Promise.resolve()), u = (0, $exYeM.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), v = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((i, e, a)=>{
        p.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(([o])=>o !== i)), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                p.current.push(o);
            })
        ]), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                Promise.all(u.current[e].map(([f, P])=>P)).then(()=>o());
            })
        ]), e === "enter" ? h.current = h.current.then(()=>n == null ? void 0 : n.wait.current).then(()=>a(e)) : a(e);
    }), d = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((i, e, a)=>{
        Promise.all(u.current[e].splice(0).map(([o, f])=>f)).then(()=>{
            var o;
            (o = p.current.shift()) == null || o();
        }).then(()=>a(e));
    });
    return (0, $exYeM.useMemo)(()=>({
            children: s,
            register: x,
            unregister: c,
            onStart: v,
            onStop: d,
            wait: h,
            chains: u
        }), [
        x,
        c,
        s,
        v,
        d,
        u,
        h
    ]);
}
function $e43b19f549669bf9$var$xe() {}
let $e43b19f549669bf9$var$Pe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $e43b19f549669bf9$var$se(t) {
    var r;
    let n = {};
    for (let s of $e43b19f549669bf9$var$Pe)n[s] = (r = t[s]) != null ? r : $e43b19f549669bf9$var$xe;
    return n;
}
function $e43b19f549669bf9$var$Re(t) {
    let n = (0, $exYeM.useRef)($e43b19f549669bf9$var$se(t));
    return (0, $exYeM.useEffect)(()=>{
        n.current = $e43b19f549669bf9$var$se(t);
    }, [
        t
    ]), n;
}
let $e43b19f549669bf9$var$ye = "div", $e43b19f549669bf9$var$ae = (0, $6da0b689c34972b7$export$617d79dae526d2cf).RenderStrategy;
function $e43b19f549669bf9$var$De(t, n) {
    var K, Q;
    let { beforeEnter: r, afterEnter: s, beforeLeave: y, afterLeave: D, enter: c, enterFrom: x, enterTo: p, entered: h, leave: u, leaveFrom: v, leaveTo: d, ...i } = t, e = (0, $exYeM.useRef)(null), a = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(e, n), o = (K = i.unmount) == null || K ? (0, $6da0b689c34972b7$export$80c0a745e59f7989).Unmount : (0, $6da0b689c34972b7$export$80c0a745e59f7989).Hidden, { show: f, appear: P, initial: T } = $e43b19f549669bf9$var$Se(), [l, j] = (0, $exYeM.useState)(f ? "visible" : "hidden"), q = $e43b19f549669bf9$var$Ne(), { register: O, unregister: V } = q;
    (0, $exYeM.useEffect)(()=>O(e), [
        O,
        e
    ]), (0, $exYeM.useEffect)(()=>{
        if (o === (0, $6da0b689c34972b7$export$80c0a745e59f7989).Hidden && e.current) {
            if (f && l !== "visible") {
                j("visible");
                return;
            }
            return (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(l, {
                ["hidden"]: ()=>V(e),
                ["visible"]: ()=>O(e)
            });
        }
    }, [
        l,
        e,
        O,
        V,
        f,
        o
    ]);
    let k = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)({
        base: $e43b19f549669bf9$var$S(i.className),
        enter: $e43b19f549669bf9$var$S(c),
        enterFrom: $e43b19f549669bf9$var$S(x),
        enterTo: $e43b19f549669bf9$var$S(p),
        entered: $e43b19f549669bf9$var$S(h),
        leave: $e43b19f549669bf9$var$S(u),
        leaveFrom: $e43b19f549669bf9$var$S(v),
        leaveTo: $e43b19f549669bf9$var$S(d)
    }), w = $e43b19f549669bf9$var$Re({
        beforeEnter: r,
        afterEnter: s,
        beforeLeave: y,
        afterLeave: D
    }), G = (0, $eea6929722880e02$export$44ab2b9f2d09b0fa)();
    (0, $exYeM.useEffect)(()=>{
        if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        e,
        l,
        G
    ]);
    let ue = T && !P, z = P && f && T, Te = (()=>!G || ue ? "idle" : f ? "enter" : "leave")(), H = (0, $103a9133e78b2210$export$2879604e6aec4ab)(0), de = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((g)=>(0, $73fd0be368b973e0$export$4659b591c19bdf3d)(g, {
            enter: ()=>{
                H.addFlag((0, $d2513f66ac282f05$export$7254cc27399e90bd).Opening), w.current.beforeEnter();
            },
            leave: ()=>{
                H.addFlag((0, $d2513f66ac282f05$export$7254cc27399e90bd).Closing), w.current.beforeLeave();
            },
            idle: ()=>{}
        })), fe = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((g)=>(0, $73fd0be368b973e0$export$4659b591c19bdf3d)(g, {
            enter: ()=>{
                H.removeFlag((0, $d2513f66ac282f05$export$7254cc27399e90bd).Opening), w.current.afterEnter();
            },
            leave: ()=>{
                H.removeFlag((0, $d2513f66ac282f05$export$7254cc27399e90bd).Closing), w.current.afterLeave();
            },
            idle: ()=>{}
        })), A = $e43b19f549669bf9$var$oe(()=>{
        j("hidden"), V(e);
    }, q);
    (0, $5973326d35cf9792$export$7b286972b8d8ccbf)({
        immediate: z,
        container: e,
        classes: k,
        direction: Te,
        onStart: (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)((g)=>{
            A.onStart(e, g, de);
        }),
        onStop: (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)((g)=>{
            A.onStop(e, g, fe), g === "leave" && !$e43b19f549669bf9$var$U(A) && (j("hidden"), V(e));
        })
    });
    let R = i, me = {
        ref: a
    };
    return z ? R = {
        ...R,
        className: (0, $79f42255615f1616$export$ce4ab0c55987d1ff)(i.className, ...k.current.enter, ...k.current.enterFrom)
    } : (R.className = (0, $79f42255615f1616$export$ce4ab0c55987d1ff)(i.className, (Q = e.current) == null ? void 0 : Q.className), R.className === "" && delete R.className), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($e43b19f549669bf9$var$M.Provider, {
        value: A
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d2513f66ac282f05$export$2a0ed818b175f558), {
        value: (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(l, {
            ["visible"]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open,
            ["hidden"]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Closed
        }) | H.flags
    }, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: me,
        theirProps: R,
        defaultTag: $e43b19f549669bf9$var$ye,
        features: $e43b19f549669bf9$var$ae,
        visible: l === "visible",
        name: "Transition.Child"
    })));
}
function $e43b19f549669bf9$var$He(t, n) {
    let { show: r, appear: s = !1, unmount: y = !0, ...D } = t, c = (0, $exYeM.useRef)(null), x = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(c, n);
    (0, $eea6929722880e02$export$44ab2b9f2d09b0fa)();
    let p = (0, $d2513f66ac282f05$export$fc6fdf0ecf360e)();
    if (r === void 0 && p !== null && (r = (p & (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open) === (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open), ![
        !0,
        !1
    ].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [h, u] = (0, $exYeM.useState)(r ? "visible" : "hidden"), v = $e43b19f549669bf9$var$oe(()=>{
        u("hidden");
    }), [d, i] = (0, $exYeM.useState)(!0), e = (0, $exYeM.useRef)([
        r
    ]);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
    }, [
        e,
        r
    ]);
    let a = (0, $exYeM.useMemo)(()=>({
            show: r,
            appear: s,
            initial: d
        }), [
        r,
        s,
        d
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (r) u("visible");
        else if (!$e43b19f549669bf9$var$U(v)) u("hidden");
        else {
            let T = c.current;
            if (!T) return;
            let l = T.getBoundingClientRect();
            l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
        }
    }, [
        r,
        v
    ]);
    let o = {
        unmount: y
    }, f = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }), P = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        var T;
        d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($e43b19f549669bf9$var$M.Provider, {
        value: v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($e43b19f549669bf9$var$_.Provider, {
        value: a
    }, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ...o,
            as: (0, $exYeM.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($e43b19f549669bf9$var$le, {
                ref: x,
                ...o,
                ...D,
                beforeEnter: f,
                beforeLeave: P
            })
        },
        theirProps: {},
        defaultTag: (0, $exYeM.Fragment),
        features: $e43b19f549669bf9$var$ae,
        visible: h === "visible",
        name: "Transition"
    })));
}
function $e43b19f549669bf9$var$Fe(t, n) {
    let r = (0, $exYeM.useContext)($e43b19f549669bf9$var$_) !== null, s = (0, $d2513f66ac282f05$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, !r && s ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($e43b19f549669bf9$var$W, {
        ref: n,
        ...t
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($e43b19f549669bf9$var$le, {
        ref: n,
        ...t
    }));
}
let $e43b19f549669bf9$var$W = (0, $6da0b689c34972b7$export$e43f39796049410c)($e43b19f549669bf9$var$He), $e43b19f549669bf9$var$le = (0, $6da0b689c34972b7$export$e43f39796049410c)($e43b19f549669bf9$var$De), $e43b19f549669bf9$var$Le = (0, $6da0b689c34972b7$export$e43f39796049410c)($e43b19f549669bf9$var$Fe), $e43b19f549669bf9$export$be58926105124dd4 = Object.assign($e43b19f549669bf9$var$W, {
    Child: $e43b19f549669bf9$var$Le,
    Root: $e43b19f549669bf9$var$W
});




var $exYeM = parcelRequire("exYeM");
function $a023194119fceba9$var$UserCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
        clipRule: "evenodd"
    }));
}
const $a023194119fceba9$var$ForwardRef = $exYeM.forwardRef($a023194119fceba9$var$UserCircleIcon);
var $a023194119fceba9$export$2e2bcd8739ae039 = $a023194119fceba9$var$ForwardRef;


var $71c100fee4a7a173$exports = {};

$71c100fee4a7a173$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "WevrLogoTextBeta.8ba9d2c8.svg";


var $0a8af33ef04486b7$exports = {};

$0a8af33ef04486b7$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "WevrLogoPrimary.a2f6d063.svg";


// Created by James Launder
// this context allows all the components to access the User which is the query data returned from middleware
// this allows this data to be used to verify as its checked every time the location changes
// causes one more re-render but thats just the cost of security ig

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $baa96523396bdf41$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $baa96523396bdf41$export$18a094aefa070634 = (obj, member, getter)=>{
    $baa96523396bdf41$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $baa96523396bdf41$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $baa96523396bdf41$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $baa96523396bdf41$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $baa96523396bdf41$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $baa96523396bdf41$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $baa96523396bdf41$export$18a094aefa070634(obj, member, getter);
        }
    });
var $baa96523396bdf41$export$fa92d15b718fce20 = (obj, member, method)=>{
    $baa96523396bdf41$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $54cfa1b7ba8b31b7$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $54cfa1b7ba8b31b7$export$8793edee2d425525() {
    return void 0;
}
function $54cfa1b7ba8b31b7$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $54cfa1b7ba8b31b7$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $54cfa1b7ba8b31b7$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $54cfa1b7ba8b31b7$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $54cfa1b7ba8b31b7$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$54cfa1b7ba8b31b7$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $54cfa1b7ba8b31b7$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($54cfa1b7ba8b31b7$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $54cfa1b7ba8b31b7$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$54cfa1b7ba8b31b7$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $54cfa1b7ba8b31b7$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $54cfa1b7ba8b31b7$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $54cfa1b7ba8b31b7$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$54cfa1b7ba8b31b7$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $54cfa1b7ba8b31b7$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$54cfa1b7ba8b31b7$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $54cfa1b7ba8b31b7$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $54cfa1b7ba8b31b7$export$7a8558113332b71e(a) && $54cfa1b7ba8b31b7$export$7a8558113332b71e(b);
    if (array || $54cfa1b7ba8b31b7$export$53b83ca8eaab0383(a) && $54cfa1b7ba8b31b7$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $54cfa1b7ba8b31b7$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $54cfa1b7ba8b31b7$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $54cfa1b7ba8b31b7$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $54cfa1b7ba8b31b7$export$53b83ca8eaab0383(o) {
    if (!$54cfa1b7ba8b31b7$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$54cfa1b7ba8b31b7$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $54cfa1b7ba8b31b7$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $54cfa1b7ba8b31b7$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $54cfa1b7ba8b31b7$export$4304cb76768ca134(callback) {
    $54cfa1b7ba8b31b7$export$e772c8ff12451969(0).then(callback);
}
function $54cfa1b7ba8b31b7$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $54cfa1b7ba8b31b7$export$77a71fc411098696(prevData, data);
    return data;
}
function $54cfa1b7ba8b31b7$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $54cfa1b7ba8b31b7$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $54cfa1b7ba8b31b7$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}




function $c2ff7b8ef1de8f46$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $54cfa1b7ba8b31b7$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $54cfa1b7ba8b31b7$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
}
var $c2ff7b8ef1de8f46$export$520687f44db6e1ab = $c2ff7b8ef1de8f46$export$316a8efd03cd1458();




// src/subscribable.ts
var $d4b58c4894ac9142$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $e6aefbda2a6ae529$var$_focused, $e6aefbda2a6ae529$var$_cleanup, $e6aefbda2a6ae529$var$_setup;
var $e6aefbda2a6ae529$export$86f1af424b2ca4de = class extends (0, $d4b58c4894ac9142$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $e6aefbda2a6ae529$var$_focused, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $e6aefbda2a6ae529$var$_cleanup, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $e6aefbda2a6ae529$var$_setup, void 0);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $e6aefbda2a6ae529$var$_setup, (onFocus)=>{
            if (!(0, $54cfa1b7ba8b31b7$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $e6aefbda2a6ae529$var$_cleanup)) this.setEventListener((0, $baa96523396bdf41$export$18a094aefa070634)(this, $e6aefbda2a6ae529$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $e6aefbda2a6ae529$var$_cleanup)) == null || _a.call(this);
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $e6aefbda2a6ae529$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $e6aefbda2a6ae529$var$_setup, setup);
        (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $e6aefbda2a6ae529$var$_cleanup)) == null || _a.call(this);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $e6aefbda2a6ae529$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $e6aefbda2a6ae529$var$_focused) !== focused;
        if (changed) {
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $e6aefbda2a6ae529$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $baa96523396bdf41$export$18a094aefa070634)(this, $e6aefbda2a6ae529$var$_focused) === "boolean") return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $e6aefbda2a6ae529$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$e6aefbda2a6ae529$var$_focused = new WeakMap();
$e6aefbda2a6ae529$var$_cleanup = new WeakMap();
$e6aefbda2a6ae529$var$_setup = new WeakMap();
var $e6aefbda2a6ae529$export$6bf54661be5b02cf = new $e6aefbda2a6ae529$export$86f1af424b2ca4de();








var $767e6f8a936e9e12$var$_online, $767e6f8a936e9e12$var$_cleanup, $767e6f8a936e9e12$var$_setup;
var $767e6f8a936e9e12$export$58774fb55d5ff7fc = class extends (0, $d4b58c4894ac9142$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $767e6f8a936e9e12$var$_online, true);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $767e6f8a936e9e12$var$_cleanup, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $767e6f8a936e9e12$var$_setup, void 0);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $767e6f8a936e9e12$var$_setup, (onOnline)=>{
            if (!(0, $54cfa1b7ba8b31b7$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $767e6f8a936e9e12$var$_cleanup)) this.setEventListener((0, $baa96523396bdf41$export$18a094aefa070634)(this, $767e6f8a936e9e12$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $767e6f8a936e9e12$var$_cleanup)) == null || _a.call(this);
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $767e6f8a936e9e12$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $767e6f8a936e9e12$var$_setup, setup);
        (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $767e6f8a936e9e12$var$_cleanup)) == null || _a.call(this);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $767e6f8a936e9e12$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $767e6f8a936e9e12$var$_online) !== online;
        if (changed) {
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $767e6f8a936e9e12$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $767e6f8a936e9e12$var$_online);
    }
};
$767e6f8a936e9e12$var$_online = new WeakMap();
$767e6f8a936e9e12$var$_cleanup = new WeakMap();
$767e6f8a936e9e12$var$_setup = new WeakMap();
var $767e6f8a936e9e12$export$b113e788b2dd3fdc = new $767e6f8a936e9e12$export$58774fb55d5ff7fc();



function $537d0c641c62b96c$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $537d0c641c62b96c$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $767e6f8a936e9e12$export$b113e788b2dd3fdc).isOnline() : true;
}
var $537d0c641c62b96c$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $537d0c641c62b96c$export$986cc6445c1d323(value) {
    return value instanceof $537d0c641c62b96c$export$a8430ed4188f35a9;
}
function $537d0c641c62b96c$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $537d0c641c62b96c$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $e6aefbda2a6ae529$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $767e6f8a936e9e12$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $54cfa1b7ba8b31b7$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $537d0c641c62b96c$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $54cfa1b7ba8b31b7$export$e772c8ff12451969)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if ($537d0c641c62b96c$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}


var $31d08b987957f909$var$_client, $31d08b987957f909$var$_currentQuery, $31d08b987957f909$var$_currentQueryInitialState, $31d08b987957f909$var$_currentResult, $31d08b987957f909$var$_currentResultState, $31d08b987957f909$var$_currentResultOptions, $31d08b987957f909$var$_selectError, $31d08b987957f909$var$_selectFn, $31d08b987957f909$var$_selectResult, $31d08b987957f909$var$_lastQueryWithDefinedData, $31d08b987957f909$var$_staleTimeoutId, $31d08b987957f909$var$_refetchIntervalId, $31d08b987957f909$var$_currentRefetchInterval, $31d08b987957f909$var$_trackedProps, $31d08b987957f909$var$_executeFetch, $31d08b987957f909$var$executeFetch_fn, $31d08b987957f909$var$_updateStaleTimeout, $31d08b987957f909$var$updateStaleTimeout_fn, $31d08b987957f909$var$_computeRefetchInterval, $31d08b987957f909$var$computeRefetchInterval_fn, $31d08b987957f909$var$_updateRefetchInterval, $31d08b987957f909$var$updateRefetchInterval_fn, $31d08b987957f909$var$_updateTimers, $31d08b987957f909$var$updateTimers_fn, $31d08b987957f909$var$_clearStaleTimeout, $31d08b987957f909$var$clearStaleTimeout_fn, $31d08b987957f909$var$_clearRefetchInterval, $31d08b987957f909$var$clearRefetchInterval_fn, $31d08b987957f909$var$_updateQuery, $31d08b987957f909$var$updateQuery_fn, $31d08b987957f909$var$_notify, $31d08b987957f909$var$notify_fn;
var $31d08b987957f909$export$a06cf8c0066f0d4c = class extends (0, $d4b58c4894ac9142$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_executeFetch);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_updateStaleTimeout);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_computeRefetchInterval);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_updateRefetchInterval);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_updateTimers);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_clearStaleTimeout);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_clearRefetchInterval);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_updateQuery);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_notify);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_client, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_currentQuery, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_currentQueryInitialState, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_currentResult, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_currentResultState, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_currentResultOptions, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_selectError, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_selectFn, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_lastQueryWithDefinedData, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_staleTimeoutId, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_refetchIntervalId, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_currentRefetchInterval, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $31d08b987957f909$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_client, client);
        this.options = options;
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery).addObserver(this);
            if ($31d08b987957f909$var$shouldFetchOnMount((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery), this.options)) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_executeFetch, $31d08b987957f909$var$executeFetch_fn).call(this);
            (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_updateTimers, $31d08b987957f909$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $31d08b987957f909$var$shouldFetchOn((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $31d08b987957f909$var$shouldFetchOn((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_clearStaleTimeout, $31d08b987957f909$var$clearStaleTimeout_fn).call(this);
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_clearRefetchInterval, $31d08b987957f909$var$clearRefetchInterval_fn).call(this);
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery);
        this.options = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client).defaultQueryOptions(options);
        if (!(0, $54cfa1b7ba8b31b7$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery),
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_updateQuery, $31d08b987957f909$var$updateQuery_fn).call(this);
        const mounted = this.hasListeners();
        if (mounted && $31d08b987957f909$var$shouldFetchOptionally((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_executeFetch, $31d08b987957f909$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_updateStaleTimeout, $31d08b987957f909$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_computeRefetchInterval, $31d08b987957f909$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentRefetchInterval))) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_updateRefetchInterval, $31d08b987957f909$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client).getQueryCache().build((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client), options);
        const result = this.createResult(query, options);
        if ($31d08b987957f909$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentResult, result);
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentResultOptions, this.options);
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentResultState, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult);
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_trackedProps).add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client).defaultQueryOptions(options);
        const query = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client).getQueryCache().build((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_executeFetch, $31d08b987957f909$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult);
        const prevResultState = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResultState);
        const prevResultOptions = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQueryInitialState);
        const { state: state } = query;
        let { error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $31d08b987957f909$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $31d08b987957f909$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $537d0c641c62b96c$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!state.dataUpdatedAt) status = "pending";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        }
        if (options.select && typeof state.data !== "undefined") {
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_selectFn)) data = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_selectResult);
            else try {
                (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_selectFn, options.select);
                data = options.select(state.data);
                data = (0, $54cfa1b7ba8b31b7$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_selectResult, data);
                (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_selectError, null);
            } catch (selectError) {
                (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_selectError, selectError);
            }
        } else data = state.data;
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_selectError, null);
                } catch (selectError) {
                    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_selectError, selectError);
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $54cfa1b7ba8b31b7$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_selectError)) {
            error = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_selectError);
            data = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: state.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $31d08b987957f909$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult);
        const nextResult = this.createResult((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery), this.options);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentResultState, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery).state);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentResultOptions, this.options);
        if ((0, $54cfa1b7ba8b31b7$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResultState).data !== void 0) (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_lastQueryWithDefinedData, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery));
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_notify, $31d08b987957f909$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_updateTimers, $31d08b987957f909$var$updateTimers_fn).call(this);
    }
};
$31d08b987957f909$var$_client = new WeakMap();
$31d08b987957f909$var$_currentQuery = new WeakMap();
$31d08b987957f909$var$_currentQueryInitialState = new WeakMap();
$31d08b987957f909$var$_currentResult = new WeakMap();
$31d08b987957f909$var$_currentResultState = new WeakMap();
$31d08b987957f909$var$_currentResultOptions = new WeakMap();
$31d08b987957f909$var$_selectError = new WeakMap();
$31d08b987957f909$var$_selectFn = new WeakMap();
$31d08b987957f909$var$_selectResult = new WeakMap();
$31d08b987957f909$var$_lastQueryWithDefinedData = new WeakMap();
$31d08b987957f909$var$_staleTimeoutId = new WeakMap();
$31d08b987957f909$var$_refetchIntervalId = new WeakMap();
$31d08b987957f909$var$_currentRefetchInterval = new WeakMap();
$31d08b987957f909$var$_trackedProps = new WeakMap();
$31d08b987957f909$var$_executeFetch = new WeakSet();
$31d08b987957f909$var$executeFetch_fn = function(fetchOptions) {
    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_updateQuery, $31d08b987957f909$var$updateQuery_fn).call(this);
    let promise = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $54cfa1b7ba8b31b7$export$8793edee2d425525));
    return promise;
};
$31d08b987957f909$var$_updateStaleTimeout = new WeakSet();
$31d08b987957f909$var$updateStaleTimeout_fn = function() {
    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_clearStaleTimeout, $31d08b987957f909$var$clearStaleTimeout_fn).call(this);
    if ((0, $54cfa1b7ba8b31b7$export$6acf61af03e62db) || (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult).isStale || !(0, $54cfa1b7ba8b31b7$export$e539f754e934e270)(this.options.staleTime)) return;
    const time = (0, $54cfa1b7ba8b31b7$export$811b83d62bcf47f0)((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$31d08b987957f909$var$_computeRefetchInterval = new WeakSet();
$31d08b987957f909$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$31d08b987957f909$var$_updateRefetchInterval = new WeakSet();
$31d08b987957f909$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_clearRefetchInterval, $31d08b987957f909$var$clearRefetchInterval_fn).call(this);
    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentRefetchInterval, nextInterval);
    if ((0, $54cfa1b7ba8b31b7$export$6acf61af03e62db) || this.options.enabled === false || !(0, $54cfa1b7ba8b31b7$export$e539f754e934e270)((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentRefetchInterval)) || (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentRefetchInterval) === 0) return;
    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $e6aefbda2a6ae529$export$6bf54661be5b02cf).isFocused()) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_executeFetch, $31d08b987957f909$var$executeFetch_fn).call(this);
    }, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentRefetchInterval)));
};
$31d08b987957f909$var$_updateTimers = new WeakSet();
$31d08b987957f909$var$updateTimers_fn = function() {
    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_updateStaleTimeout, $31d08b987957f909$var$updateStaleTimeout_fn).call(this);
    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_updateRefetchInterval, $31d08b987957f909$var$updateRefetchInterval_fn).call(this, (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $31d08b987957f909$var$_computeRefetchInterval, $31d08b987957f909$var$computeRefetchInterval_fn).call(this));
};
$31d08b987957f909$var$_clearStaleTimeout = new WeakSet();
$31d08b987957f909$var$clearStaleTimeout_fn = function() {
    if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_staleTimeoutId)) {
        clearTimeout((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_staleTimeoutId));
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_staleTimeoutId, void 0);
    }
};
$31d08b987957f909$var$_clearRefetchInterval = new WeakSet();
$31d08b987957f909$var$clearRefetchInterval_fn = function() {
    if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_refetchIntervalId)) {
        clearInterval((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_refetchIntervalId));
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_refetchIntervalId, void 0);
    }
};
$31d08b987957f909$var$_updateQuery = new WeakSet();
$31d08b987957f909$var$updateQuery_fn = function() {
    const query = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client).getQueryCache().build((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client), this.options);
    if (query === (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery)) return;
    const prevQuery = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery);
    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentQuery, query);
    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $31d08b987957f909$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$31d08b987957f909$var$_notify = new WeakSet();
$31d08b987957f909$var$notify_fn = function(notifyOptions) {
    (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentResult));
        });
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_client).getQueryCache().notify({
            query: (0, $baa96523396bdf41$export$18a094aefa070634)(this, $31d08b987957f909$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $31d08b987957f909$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $31d08b987957f909$var$shouldFetchOnMount(query, options) {
    return $31d08b987957f909$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $31d08b987957f909$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $31d08b987957f909$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $31d08b987957f909$var$isStale(query, options);
    }
    return false;
}
function $31d08b987957f909$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $31d08b987957f909$var$isStale(query, options);
}
function $31d08b987957f909$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}
function $31d08b987957f909$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $54cfa1b7ba8b31b7$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
"use client";
function $31d3dbc25c6d00e2$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $31d3dbc25c6d00e2$var$QueryErrorResetBoundaryContext = $exYeM.createContext($31d3dbc25c6d00e2$var$createValue());
var $31d3dbc25c6d00e2$export$50dfac555130cafd = ()=>$exYeM.useContext($31d3dbc25c6d00e2$var$QueryErrorResetBoundaryContext);
var $31d3dbc25c6d00e2$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $exYeM.useState(()=>$31d3dbc25c6d00e2$var$createValue());
    return /* @__PURE__ */ $exYeM.createElement($31d3dbc25c6d00e2$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};



var $exYeM = parcelRequire("exYeM");
"use client";
var $1773e073a683367a$export$da112d31b0149f31 = $exYeM.createContext(void 0);
var $1773e073a683367a$export$22e77b9572c4fded = (queryClient)=>{
    const client = $exYeM.useContext($1773e073a683367a$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $1773e073a683367a$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $exYeM.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ $exYeM.createElement($1773e073a683367a$export$da112d31b0149f31.Provider, {
        value: client
    }, children);
};



var $exYeM = parcelRequire("exYeM");
"use client";
var $e19e6b604ff985b0$var$IsRestoringContext = $exYeM.createContext(false);
var $e19e6b604ff985b0$export$4da0178d6b5f553 = ()=>$exYeM.useContext($e19e6b604ff985b0$var$IsRestoringContext);
var $e19e6b604ff985b0$export$593807d4e94f9621 = $e19e6b604ff985b0$var$IsRestoringContext.Provider;



var $exYeM = parcelRequire("exYeM");
// src/utils.ts
function $47c0fb03fd415629$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}


"use client";
var $a2a707fd2d0e1a70$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $a2a707fd2d0e1a70$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $exYeM.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $a2a707fd2d0e1a70$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $47c0fb03fd415629$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $15fb4845b820c283$export$8bed2f8d02206063 = (_error, query)=>typeof query.state.data === "undefined";
var $15fb4845b820c283$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var $15fb4845b820c283$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $15fb4845b820c283$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $15fb4845b820c283$export$e0a3f29513afe430(result, isRestoring);
var $15fb4845b820c283$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $3be1b872616a21ba$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $1773e073a683367a$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $e19e6b604ff985b0$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $31d3dbc25c6d00e2$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $15fb4845b820c283$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $a2a707fd2d0e1a70$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $a2a707fd2d0e1a70$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $exYeM.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $exYeM.useSyncExternalStore($exYeM.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $exYeM.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $15fb4845b820c283$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $15fb4845b820c283$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $a2a707fd2d0e1a70$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: observer.getCurrentQuery()
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $9bc35366a9d51f8d$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $3be1b872616a21ba$export$fff0865807e996c5)(options, (0, $31d08b987957f909$export$a06cf8c0066f0d4c), queryClient);
}


// main api end point, all the calls refer to this to get URL
// if adding new server create a new call here and add the new URL to the .env
"use strict";
function $fc8f2e2c969d032f$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $8ca3655f37d9652c$var$toString } = Object.prototype;
const { getPrototypeOf: $8ca3655f37d9652c$var$getPrototypeOf } = Object;
const $8ca3655f37d9652c$var$kindOf = ((cache)=>(thing)=>{
        const str = $8ca3655f37d9652c$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $8ca3655f37d9652c$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$8ca3655f37d9652c$var$kindOf(thing) === type;
};
const $8ca3655f37d9652c$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $8ca3655f37d9652c$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $8ca3655f37d9652c$var$isUndefined = $8ca3655f37d9652c$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8ca3655f37d9652c$var$isBuffer(val) {
    return val !== null && !$8ca3655f37d9652c$var$isUndefined(val) && val.constructor !== null && !$8ca3655f37d9652c$var$isUndefined(val.constructor) && $8ca3655f37d9652c$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $8ca3655f37d9652c$var$isArrayBuffer = $8ca3655f37d9652c$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8ca3655f37d9652c$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $8ca3655f37d9652c$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $8ca3655f37d9652c$var$isString = $8ca3655f37d9652c$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $8ca3655f37d9652c$var$isFunction = $8ca3655f37d9652c$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $8ca3655f37d9652c$var$isNumber = $8ca3655f37d9652c$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $8ca3655f37d9652c$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $8ca3655f37d9652c$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $8ca3655f37d9652c$var$isPlainObject = (val)=>{
    if ($8ca3655f37d9652c$var$kindOf(val) !== "object") return false;
    const prototype = $8ca3655f37d9652c$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $8ca3655f37d9652c$var$isDate = $8ca3655f37d9652c$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ca3655f37d9652c$var$isFile = $8ca3655f37d9652c$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $8ca3655f37d9652c$var$isBlob = $8ca3655f37d9652c$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ca3655f37d9652c$var$isFileList = $8ca3655f37d9652c$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $8ca3655f37d9652c$var$isStream = (val)=>$8ca3655f37d9652c$var$isObject(val) && $8ca3655f37d9652c$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $8ca3655f37d9652c$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $8ca3655f37d9652c$var$isFunction(thing.append) && ((kind = $8ca3655f37d9652c$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $8ca3655f37d9652c$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $8ca3655f37d9652c$var$isURLSearchParams = $8ca3655f37d9652c$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $8ca3655f37d9652c$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $8ca3655f37d9652c$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8ca3655f37d9652c$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $8ca3655f37d9652c$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $8ca3655f37d9652c$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $8ca3655f37d9652c$var$isContextDefined = (context)=>!$8ca3655f37d9652c$var$isUndefined(context) && context !== $8ca3655f37d9652c$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $8ca3655f37d9652c$var$merge() {
    const { caseless: caseless } = $8ca3655f37d9652c$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $8ca3655f37d9652c$var$findKey(result, key) || key;
        if ($8ca3655f37d9652c$var$isPlainObject(result[targetKey]) && $8ca3655f37d9652c$var$isPlainObject(val)) result[targetKey] = $8ca3655f37d9652c$var$merge(result[targetKey], val);
        else if ($8ca3655f37d9652c$var$isPlainObject(val)) result[targetKey] = $8ca3655f37d9652c$var$merge({}, val);
        else if ($8ca3655f37d9652c$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $8ca3655f37d9652c$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $8ca3655f37d9652c$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $8ca3655f37d9652c$var$forEach(b, (val, key)=>{
        if (thisArg && $8ca3655f37d9652c$var$isFunction(val)) a[key] = (0, $fc8f2e2c969d032f$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $8ca3655f37d9652c$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $8ca3655f37d9652c$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $8ca3655f37d9652c$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $8ca3655f37d9652c$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $8ca3655f37d9652c$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $8ca3655f37d9652c$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($8ca3655f37d9652c$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$8ca3655f37d9652c$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $8ca3655f37d9652c$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $8ca3655f37d9652c$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $8ca3655f37d9652c$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $8ca3655f37d9652c$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $8ca3655f37d9652c$var$isHTMLForm = $8ca3655f37d9652c$var$kindOfTest("HTMLFormElement");
const $8ca3655f37d9652c$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $8ca3655f37d9652c$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $8ca3655f37d9652c$var$isRegExp = $8ca3655f37d9652c$var$kindOfTest("RegExp");
const $8ca3655f37d9652c$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $8ca3655f37d9652c$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $8ca3655f37d9652c$var$freezeMethods = (obj)=>{
    $8ca3655f37d9652c$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($8ca3655f37d9652c$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$8ca3655f37d9652c$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $8ca3655f37d9652c$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $8ca3655f37d9652c$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $8ca3655f37d9652c$var$noop = ()=>{};
const $8ca3655f37d9652c$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $8ca3655f37d9652c$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $8ca3655f37d9652c$var$DIGIT = "0123456789";
const $8ca3655f37d9652c$var$ALPHABET = {
    DIGIT: $8ca3655f37d9652c$var$DIGIT,
    ALPHA: $8ca3655f37d9652c$var$ALPHA,
    ALPHA_DIGIT: $8ca3655f37d9652c$var$ALPHA + $8ca3655f37d9652c$var$ALPHA.toUpperCase() + $8ca3655f37d9652c$var$DIGIT
};
const $8ca3655f37d9652c$var$generateString = (size = 16, alphabet = $8ca3655f37d9652c$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $8ca3655f37d9652c$var$isSpecCompliantForm(thing) {
    return !!(thing && $8ca3655f37d9652c$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $8ca3655f37d9652c$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($8ca3655f37d9652c$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $8ca3655f37d9652c$var$isArray(source) ? [] : {};
                $8ca3655f37d9652c$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$8ca3655f37d9652c$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $8ca3655f37d9652c$var$isAsyncFn = $8ca3655f37d9652c$var$kindOfTest("AsyncFunction");
const $8ca3655f37d9652c$var$isThenable = (thing)=>thing && ($8ca3655f37d9652c$var$isObject(thing) || $8ca3655f37d9652c$var$isFunction(thing)) && $8ca3655f37d9652c$var$isFunction(thing.then) && $8ca3655f37d9652c$var$isFunction(thing.catch);
var $8ca3655f37d9652c$export$2e2bcd8739ae039 = {
    isArray: $8ca3655f37d9652c$var$isArray,
    isArrayBuffer: $8ca3655f37d9652c$var$isArrayBuffer,
    isBuffer: $8ca3655f37d9652c$var$isBuffer,
    isFormData: $8ca3655f37d9652c$var$isFormData,
    isArrayBufferView: $8ca3655f37d9652c$var$isArrayBufferView,
    isString: $8ca3655f37d9652c$var$isString,
    isNumber: $8ca3655f37d9652c$var$isNumber,
    isBoolean: $8ca3655f37d9652c$var$isBoolean,
    isObject: $8ca3655f37d9652c$var$isObject,
    isPlainObject: $8ca3655f37d9652c$var$isPlainObject,
    isUndefined: $8ca3655f37d9652c$var$isUndefined,
    isDate: $8ca3655f37d9652c$var$isDate,
    isFile: $8ca3655f37d9652c$var$isFile,
    isBlob: $8ca3655f37d9652c$var$isBlob,
    isRegExp: $8ca3655f37d9652c$var$isRegExp,
    isFunction: $8ca3655f37d9652c$var$isFunction,
    isStream: $8ca3655f37d9652c$var$isStream,
    isURLSearchParams: $8ca3655f37d9652c$var$isURLSearchParams,
    isTypedArray: $8ca3655f37d9652c$var$isTypedArray,
    isFileList: $8ca3655f37d9652c$var$isFileList,
    forEach: $8ca3655f37d9652c$var$forEach,
    merge: $8ca3655f37d9652c$var$merge,
    extend: $8ca3655f37d9652c$var$extend,
    trim: $8ca3655f37d9652c$var$trim,
    stripBOM: $8ca3655f37d9652c$var$stripBOM,
    inherits: $8ca3655f37d9652c$var$inherits,
    toFlatObject: $8ca3655f37d9652c$var$toFlatObject,
    kindOf: $8ca3655f37d9652c$var$kindOf,
    kindOfTest: $8ca3655f37d9652c$var$kindOfTest,
    endsWith: $8ca3655f37d9652c$var$endsWith,
    toArray: $8ca3655f37d9652c$var$toArray,
    forEachEntry: $8ca3655f37d9652c$var$forEachEntry,
    matchAll: $8ca3655f37d9652c$var$matchAll,
    isHTMLForm: $8ca3655f37d9652c$var$isHTMLForm,
    hasOwnProperty: $8ca3655f37d9652c$var$hasOwnProperty,
    hasOwnProp: $8ca3655f37d9652c$var$hasOwnProperty,
    reduceDescriptors: $8ca3655f37d9652c$var$reduceDescriptors,
    freezeMethods: $8ca3655f37d9652c$var$freezeMethods,
    toObjectSet: $8ca3655f37d9652c$var$toObjectSet,
    toCamelCase: $8ca3655f37d9652c$var$toCamelCase,
    noop: $8ca3655f37d9652c$var$noop,
    toFiniteNumber: $8ca3655f37d9652c$var$toFiniteNumber,
    findKey: $8ca3655f37d9652c$var$findKey,
    global: $8ca3655f37d9652c$var$_global,
    isContextDefined: $8ca3655f37d9652c$var$isContextDefined,
    ALPHABET: $8ca3655f37d9652c$var$ALPHABET,
    generateString: $8ca3655f37d9652c$var$generateString,
    isSpecCompliantForm: $8ca3655f37d9652c$var$isSpecCompliantForm,
    toJSONObject: $8ca3655f37d9652c$var$toJSONObject,
    isAsyncFn: $8ca3655f37d9652c$var$isAsyncFn,
    isThenable: $8ca3655f37d9652c$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $44aee3fe793a4c74$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).inherits($44aee3fe793a4c74$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $44aee3fe793a4c74$var$prototype = $44aee3fe793a4c74$var$AxiosError.prototype;
const $44aee3fe793a4c74$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $44aee3fe793a4c74$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($44aee3fe793a4c74$var$AxiosError, $44aee3fe793a4c74$var$descriptors);
Object.defineProperty($44aee3fe793a4c74$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$44aee3fe793a4c74$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($44aee3fe793a4c74$var$prototype);
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $44aee3fe793a4c74$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $44aee3fe793a4c74$export$2e2bcd8739ae039 = $44aee3fe793a4c74$var$AxiosError;


// eslint-disable-next-line strict
var $82d0d0537dc0bac3$export$2e2bcd8739ae039 = null;



var $3aNd6 = parcelRequire("3aNd6");
var $0c29ca57d54f85e9$require$Buffer = $3aNd6.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $0c29ca57d54f85e9$var$isVisitable(thing) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $0c29ca57d54f85e9$var$removeBrackets(key) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $0c29ca57d54f85e9$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $0c29ca57d54f85e9$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $0c29ca57d54f85e9$var$isFlatArray(arr) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(arr) && !arr.some($0c29ca57d54f85e9$var$isVisitable);
}
const $0c29ca57d54f85e9$var$predicates = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject((0, $8ca3655f37d9652c$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $0c29ca57d54f85e9$var$toFormData(obj, formData, options) {
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $82d0d0537dc0bac3$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $0c29ca57d54f85e9$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) && $0c29ca57d54f85e9$var$isFlatArray(value) || ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFileList(value) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $0c29ca57d54f85e9$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $0c29ca57d54f85e9$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($0c29ca57d54f85e9$var$isVisitable(value)) return true;
        formData.append($0c29ca57d54f85e9$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($0c29ca57d54f85e9$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $0c29ca57d54f85e9$var$isVisitable
    });
    function build(value, path) {
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $0c29ca57d54f85e9$export$2e2bcd8739ae039 = $0c29ca57d54f85e9$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $63e4e0dff2b7ef1a$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $63e4e0dff2b7ef1a$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(params, this, options);
}
const $63e4e0dff2b7ef1a$var$prototype = $63e4e0dff2b7ef1a$var$AxiosURLSearchParams.prototype;
$63e4e0dff2b7ef1a$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$63e4e0dff2b7ef1a$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $63e4e0dff2b7ef1a$var$encode);
    } : $63e4e0dff2b7ef1a$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $63e4e0dff2b7ef1a$export$2e2bcd8739ae039 = $63e4e0dff2b7ef1a$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4858799f155a4706$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $4858799f155a4706$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4858799f155a4706$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $63e4e0dff2b7ef1a$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $089e14d5c08cea15$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $089e14d5c08cea15$export$2e2bcd8739ae039 = $089e14d5c08cea15$var$InterceptorManager;





"use strict";
var $c54b4d6d29e2eb6b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $d2ba66411c13cc9b$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $63e4e0dff2b7ef1a$export$2e2bcd8739ae039);


"use strict";
var $7cdf1698dc68a071$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e86ffb493d13ed1$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $97999e9cdfd9bdaf$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $d2ba66411c13cc9b$export$2e2bcd8739ae039,
        FormData: $7cdf1698dc68a071$export$2e2bcd8739ae039,
        Blob: $2e86ffb493d13ed1$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $dcb238ff33d5089b$exports = {};

$parcel$export($dcb238ff33d5089b$exports, "hasBrowserEnv", function () { return $dcb238ff33d5089b$export$c4996c4b7b93b0bf; });
$parcel$export($dcb238ff33d5089b$exports, "hasStandardBrowserEnv", function () { return $dcb238ff33d5089b$export$c0bcc9250309d66; });
$parcel$export($dcb238ff33d5089b$exports, "hasStandardBrowserWebWorkerEnv", function () { return $dcb238ff33d5089b$export$c81692cf5af97dac; });
const $dcb238ff33d5089b$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $dcb238ff33d5089b$export$c0bcc9250309d66 = ((product)=>{
    return $dcb238ff33d5089b$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $dcb238ff33d5089b$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $96659b0ab5a2bc56$export$2e2bcd8739ae039 = {
    ...$dcb238ff33d5089b$exports,
    ...(0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039)
};


"use strict";
function $3444de215011fd2b$export$2e2bcd8739ae039(data, options) {
    return (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(data, new (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).isNode && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $bdd273a6ec9f935e$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $bdd273a6ec9f935e$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $bdd273a6ec9f935e$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $bdd273a6ec9f935e$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(formData) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($bdd273a6ec9f935e$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $bdd273a6ec9f935e$export$2e2bcd8739ae039 = $bdd273a6ec9f935e$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $8d19883a18ea96be$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $8d19883a18ea96be$var$defaults = {
    transitional: (0, $c54b4d6d29e2eb6b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $bdd273a6ec9f935e$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBuffer(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isStream(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFile(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $3444de215011fd2b$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $8d19883a18ea96be$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $8d19883a18ea96be$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).from(e, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $8d19883a18ea96be$var$defaults.headers[method] = {};
});
var $8d19883a18ea96be$export$2e2bcd8739ae039 = $8d19883a18ea96be$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $102410410d0dc09d$var$ignoreDuplicateOf = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $102410410d0dc09d$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $102410410d0dc09d$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $c2923f037e2bae4f$var$$internals = Symbol("internals");
function $c2923f037e2bae4f$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c2923f037e2bae4f$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) ? value.map($c2923f037e2bae4f$var$normalizeValue) : String(value);
}
function $c2923f037e2bae4f$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c2923f037e2bae4f$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c2923f037e2bae4f$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c2923f037e2bae4f$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c2923f037e2bae4f$var$buildAccessors(obj, header) {
    const accessorName = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c2923f037e2bae4f$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c2923f037e2bae4f$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c2923f037e2bae4f$var$isValidHeaderName(header)) setHeaders((0, $102410410d0dc09d$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c2923f037e2bae4f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c2923f037e2bae4f$var$parseTokens(value);
                if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c2923f037e2bae4f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c2923f037e2bae4f$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c2923f037e2bae4f$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c2923f037e2bae4f$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c2923f037e2bae4f$var$$internals] = this[$c2923f037e2bae4f$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c2923f037e2bae4f$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c2923f037e2bae4f$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).reduceDescriptors($c2923f037e2bae4f$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).freezeMethods($c2923f037e2bae4f$var$AxiosHeaders);
var $c2923f037e2bae4f$export$2e2bcd8739ae039 = $c2923f037e2bae4f$var$AxiosHeaders;


"use strict";
function $e27ce2658796d30f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $8d19883a18ea96be$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $ffcdf0443516cf49$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $a251e9fa67c89486$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).inherits($a251e9fa67c89486$var$CanceledError, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $a251e9fa67c89486$export$2e2bcd8739ae039 = $a251e9fa67c89486$var$CanceledError;







"use strict";
function $df046ee58fb378eb$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $e52288d5ced91a0f$export$2e2bcd8739ae039 = (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $57cabc98a428ac0d$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b453718e09262365$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $c5c7eeec01fb8b89$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $57cabc98a428ac0d$export$2e2bcd8739ae039)(requestedURL)) return (0, $b453718e09262365$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $6c85e22328488296$export$2e2bcd8739ae039 = (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $39416e5131ec2dd8$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a1af1a7f806b22ba$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a1af1a7f806b22ba$export$2e2bcd8739ae039 = $a1af1a7f806b22ba$var$speedometer;


"use strict";
function $85bd0ac91b9e9771$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $a1af1a7f806b22ba$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $85bd0ac91b9e9771$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $85bd0ac91b9e9771$export$2e2bcd8739ae039 = $85bd0ac91b9e9771$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $c5c7eeec01fb8b89$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $4858799f155a4706$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $df046ee58fb378eb$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Request aborted", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Network Error", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $c54b4d6d29e2eb6b$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ETIMEDOUT : (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $6c85e22328488296$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $e52288d5ced91a0f$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $85bd0ac91b9e9771$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $85bd0ac91b9e9771$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $39416e5131ec2dd8$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $96659b0ab5a2bc56$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $b57d5c296e05dd0f$var$knownAdapters = {
    http: (0, $82d0d0537dc0bac3$export$2e2bcd8739ae039),
    xhr: (0, $85bd0ac91b9e9771$export$2e2bcd8739ae039)
};
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach($b57d5c296e05dd0f$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $b57d5c296e05dd0f$var$renderReason = (reason)=>`- ${reason}`;
const $b57d5c296e05dd0f$var$isResolvedHandle = (adapter)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $b57d5c296e05dd0f$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$b57d5c296e05dd0f$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $b57d5c296e05dd0f$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($b57d5c296e05dd0f$var$renderReason).join("\n") : " " + $b57d5c296e05dd0f$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $b57d5c296e05dd0f$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $03c1ec60679d4a92$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(null, config);
}
function $03c1ec60679d4a92$export$2e2bcd8739ae039(config) {
    $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
    config.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $b57d5c296e05dd0f$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $8d19883a18ea96be$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ffcdf0443516cf49$export$2e2bcd8739ae039)(reason)) {
            $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $ed738da9502ca495$var$headersToObject = (thing)=>thing instanceof (0, $c2923f037e2bae4f$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $ed738da9502ca495$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(target) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($ed738da9502ca495$var$headersToObject(a), $ed738da9502ca495$var$headersToObject(b), true)
    };
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $f1f155cc89389bcb$export$a4ad2735b021c132 = "1.6.5";



"use strict";
const $73047b42f9e782d3$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $73047b42f9e782d3$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $73047b42f9e782d3$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $73047b42f9e782d3$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $f1f155cc89389bcb$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$73047b42f9e782d3$var$deprecatedWarnings[opt]) {
            $73047b42f9e782d3$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $73047b42f9e782d3$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("options must be an object", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $73047b42f9e782d3$export$2e2bcd8739ae039 = {
    assertOptions: $73047b42f9e782d3$var$assertOptions,
    validators: $73047b42f9e782d3$var$validators
};



"use strict";
const $6c6ea2375c06af66$var$validators = (0, $73047b42f9e782d3$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $6c6ea2375c06af66$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $089e14d5c08cea15$export$2e2bcd8739ae039)(),
            response: new (0, $089e14d5c08cea15$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $ed738da9502ca495$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean),
            forcedJSONParsing: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean),
            clarifyTimeoutError: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $6c6ea2375c06af66$var$validators.function,
                serialize: $6c6ea2375c06af66$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $03c1ec60679d4a92$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $03c1ec60679d4a92$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $ed738da9502ca495$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $c5c7eeec01fb8b89$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $4858799f155a4706$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6c6ea2375c06af66$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $ed738da9502ca495$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $ed738da9502ca495$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $6c6ea2375c06af66$var$Axios.prototype[method] = generateHTTPMethod();
    $6c6ea2375c06af66$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $6c6ea2375c06af66$export$2e2bcd8739ae039 = $6c6ea2375c06af66$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $52ff30ac6ac58fe8$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $52ff30ac6ac58fe8$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $52ff30ac6ac58fe8$export$2e2bcd8739ae039 = $52ff30ac6ac58fe8$var$CancelToken;






"use strict";
function $6fd2256c627864a1$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $eecd01492f51a517$export$2e2bcd8739ae039(payload) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $3f8e319a46440ea5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($3f8e319a46440ea5$var$HttpStatusCode).forEach(([key, value])=>{
    $3f8e319a46440ea5$var$HttpStatusCode[value] = key;
});
var $3f8e319a46440ea5$export$2e2bcd8739ae039 = $3f8e319a46440ea5$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $eb999ef253053d6e$var$createInstance(defaultConfig) {
    const context = new (0, $6c6ea2375c06af66$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $fc8f2e2c969d032f$export$2e2bcd8739ae039)((0, $6c6ea2375c06af66$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).extend(instance, (0, $6c6ea2375c06af66$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $eb999ef253053d6e$var$createInstance((0, $ed738da9502ca495$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $eb999ef253053d6e$var$axios = $eb999ef253053d6e$var$createInstance((0, $8d19883a18ea96be$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$eb999ef253053d6e$var$axios.Axios = (0, $6c6ea2375c06af66$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$eb999ef253053d6e$var$axios.CanceledError = (0, $a251e9fa67c89486$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.CancelToken = (0, $52ff30ac6ac58fe8$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.isCancel = (0, $ffcdf0443516cf49$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.VERSION = (0, $f1f155cc89389bcb$export$a4ad2735b021c132);
$eb999ef253053d6e$var$axios.toFormData = (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039);
// Expose AxiosError class
$eb999ef253053d6e$var$axios.AxiosError = (0, $44aee3fe793a4c74$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$eb999ef253053d6e$var$axios.Cancel = $eb999ef253053d6e$var$axios.CanceledError;
// Expose all/spread
$eb999ef253053d6e$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$eb999ef253053d6e$var$axios.spread = (0, $6fd2256c627864a1$export$2e2bcd8739ae039);
// Expose isAxiosError
$eb999ef253053d6e$var$axios.isAxiosError = (0, $eecd01492f51a517$export$2e2bcd8739ae039);
// Expose mergeConfig
$eb999ef253053d6e$var$axios.mergeConfig = (0, $ed738da9502ca495$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.AxiosHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.formToJSON = (thing)=>(0, $bdd273a6ec9f935e$export$2e2bcd8739ae039)((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$eb999ef253053d6e$var$axios.getAdapter = (0, $b57d5c296e05dd0f$export$2e2bcd8739ae039).getAdapter;
$eb999ef253053d6e$var$axios.HttpStatusCode = (0, $3f8e319a46440ea5$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.default = $eb999ef253053d6e$var$axios;
var // this module should only have a default export
$eb999ef253053d6e$export$2e2bcd8739ae039 = $eb999ef253053d6e$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $9fc967f4cbe5a6f7$export$1c00760e9e5a4e95, AxiosError: $9fc967f4cbe5a6f7$export$c1fbed17c2f6a328, CanceledError: $9fc967f4cbe5a6f7$export$1ab0c6b20d94fa14, isCancel: $9fc967f4cbe5a6f7$export$3b22524397b493c6, CancelToken: $9fc967f4cbe5a6f7$export$fd08e3cb425f0d61, VERSION: $9fc967f4cbe5a6f7$export$a4ad2735b021c132, all: $9fc967f4cbe5a6f7$export$84bf76cd7afc7469, Cancel: $9fc967f4cbe5a6f7$export$848c9b7ead0df967, isAxiosError: $9fc967f4cbe5a6f7$export$fbafdbe06a5b5a9a, spread: $9fc967f4cbe5a6f7$export$3ae0fd4797ed47c8, toFormData: $9fc967f4cbe5a6f7$export$10ae0d317ea97f8b, AxiosHeaders: $9fc967f4cbe5a6f7$export$4e7d6ff0f3e6520, HttpStatusCode: $9fc967f4cbe5a6f7$export$a972f69c851492b3, formToJSON: $9fc967f4cbe5a6f7$export$86d7c59254d6a2c9, getAdapter: $9fc967f4cbe5a6f7$export$17ddc20a97d669e2, mergeConfig: $9fc967f4cbe5a6f7$export$7ec1ebcfa9d8bd6a } = (0, $eb999ef253053d6e$export$2e2bcd8739ae039);


var $ca6473885cd32228$export$2e2bcd8739ae039 = (0, $eb999ef253053d6e$export$2e2bcd8739ae039).create({
    baseURL: "https://api.wevr.ai/V2",
    headers: {
        "Content-type": "application/json"
    }
});



var $exYeM = parcelRequire("exYeM");
function $1f481e020e075882$export$2e2bcd8739ae039() {
    const [errorCode, setErrorCode] = (0, $exYeM.useState)(null);
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const { isError: isError, isLoading: isLoading, isFetching: isFetching, data: data, refetch: refetch } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "validateUser"
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/user/validate", {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }).catch(function(error) {
                localStorage.removeItem("user");
                setErrorCode(error.response.status);
                return null;
            });
            return data;
        }
    });
    return {
        isError: isError,
        data: data,
        isLoading: isLoading,
        isFetching: isFetching,
        errorCode: errorCode,
        refetch: refetch
    };
}


const $d48470880d35c8fc$export$38ee920e59704589 = /*#__PURE__*/ (0, $exYeM.createContext)();
const $d48470880d35c8fc$export$88f24fd8fcfab6ca = ({ children: children })=>{
    const [userData, setUserData] = (0, $exYeM.useState)(null);
    const [signOut, setSignOut] = (0, $exYeM.useState)(false); // set to true when signing out
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const validateUser = (0, $1f481e020e075882$export$2e2bcd8739ae039)();
    const checkUser = ()=>{
        if (validateUser.isError) {
            localStorage.removeItem("user");
            setUserData(null);
            setSignOut(true);
        } else if (!(validateUser.isFetching && validateUser.isLoading) && validateUser.data != null) setUserData(validateUser?.data?.data);
    };
    (0, $exYeM.useEffect)(()=>{
        signOut && localStorage.removeItem("user");
    }, [
        signOut
    ]);
    (0, $exYeM.useEffect)(()=>{
        checkUser();
    }, [
        validateUser
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (localStorage.getItem("user") != null) validateUser.refetch();
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($d48470880d35c8fc$export$38ee920e59704589.Provider, {
        value: {
            userData: userData,
            signOut: signOut,
            setSignOut: setSignOut,
            validateUser: validateUser
        },
        children: children
    });
};


function $c93813fc9a74a923$export$1343a74baacb0543(...inputs) {
    return inputs.filter(Boolean).join(" ");
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $exYeM = parcelRequire("exYeM");
function $e1a745ecb8941240$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $exYeM.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $exYeM.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $exYeM.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $e1a745ecb8941240$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $exYeM.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $exYeM.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $exYeM.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $exYeM.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $e1a745ecb8941240$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $e1a745ecb8941240$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $exYeM.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}


function $a20bcd1655f7f422$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$a0301a3b12ffad9c$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $exYeM.useCallback)($a0301a3b12ffad9c$export$43e446d32b3d21af(...refs), refs);
}


/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $exYeM.Children).toArray(children);
    const slottable = childrenArray.find($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $exYeM.Children).count(newElement) > 1) return (0, $exYeM.Children).only(null);
                return /*#__PURE__*/ (0, $exYeM.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $exYeM.createElement)($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone, (0, $aJx1R.default)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $exYeM.isValidElement)(newElement) ? /*#__PURE__*/ (0, $exYeM.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $exYeM.createElement)($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone, (0, $aJx1R.default)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$8d4dfd758f40b63f$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $exYeM.isValidElement)(children)) return /*#__PURE__*/ (0, $exYeM.cloneElement)(children, {
        ...$8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $a0301a3b12ffad9c$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $exYeM.Children).count(children) > 1 ? (0, $exYeM.Children).only(null) : null;
});
$8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $exYeM.isValidElement)(child) && child.type === $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45;
}
function $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $8d4dfd758f40b63f$export$be92b6f5f03c0fe9 = $8d4dfd758f40b63f$export$8c6ed5c666ac1360;


const $9b1158d53fe98b0a$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $9b1158d53fe98b0a$export$250ffa63cdc0d034 = $9b1158d53fe98b0a$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : node;
        (0, $exYeM.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $exYeM.createElement)(Comp, (0, $aJx1R.default)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $9b1158d53fe98b0a$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $d2lNW.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $9b1158d53fe98b0a$export$be92b6f5f03c0fe9 = $9b1158d53fe98b0a$export$250ffa63cdc0d034;



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $cec6513cd2787f04$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $exYeM.useRef)(callback);
    (0, $exYeM.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $exYeM.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $ceaa710ce91b202b$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $ceaa710ce91b202b$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $exYeM.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $ceaa710ce91b202b$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $exYeM.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $exYeM.useRef)(value);
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    (0, $exYeM.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $exYeM = parcelRequire("exYeM");
const $9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $9cee77c98b858c29$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)($9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $9cee77c98b858c29$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $exYeM.useContext)($9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $9cee77c98b858c29$export$2881499e37b75b9a = $9cee77c98b858c29$export$c760c09fdd558351;



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");


var $exYeM = parcelRequire("exYeM");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $96a334e7374a91f2$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $exYeM.useLayoutEffect) : ()=>{};


function $4a876f8b5705075b$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $exYeM.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $4a876f8b5705075b$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $4a876f8b5705075b$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $exYeM.Children).only(children);
    const ref = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $exYeM.cloneElement)(child, {
        ref: ref
    }) : null;
};
$4a876f8b5705075b$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $4a876f8b5705075b$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $exYeM.useState)();
    const stylesRef = (0, $exYeM.useRef)({});
    const prevPresentRef = (0, $exYeM.useRef)(present);
    const prevAnimationNameRef = (0, $exYeM.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $4a876f8b5705075b$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $exYeM.useEffect)(()=>{
        const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $d2lNW.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $exYeM.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}



var $exYeM = parcelRequire("exYeM");

const $6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$useReactId = $exYeM["useId".toString()] || (()=>undefined);
let $6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$count = 0;
function $6e53b15deb1e14e9$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $exYeM.useState($6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $exYeM = parcelRequire("exYeM");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $ac7c84a01af4e06e$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");

/**
 * Listens for when the escape key is down
 */ function $34fe34d34d8734af$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $exYeM.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $0516f19b588c56c0$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $exYeM.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $0516f19b588c56c0$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $exYeM.useContext)($0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $exYeM.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $exYeM.useState)({});
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $0516f19b588c56c0$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $0516f19b588c56c0$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $34fe34d34d8734af$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $exYeM.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $exYeM.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $exYeM.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($0516f19b588c56c0$export$177fb62ff3ec1f22, {
    displayName: $0516f19b588c56c0$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $0516f19b588c56c0$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $0516f19b588c56c0$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = (0, $exYeM.useContext)($0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $exYeM.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($0516f19b588c56c0$export$4d5eb2109db14228, {
    displayName: $0516f19b588c56c0$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $0516f19b588c56c0$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $exYeM.useRef)(false);
    const handleClickRef = (0, $exYeM.useRef)(()=>{});
    (0, $exYeM.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $0516f19b588c56c0$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $0516f19b588c56c0$export$be92b6f5f03c0fe9 = $0516f19b588c56c0$export$177fb62ff3ec1f22;
const $0516f19b588c56c0$export$aecb2ddcb55c95be = $0516f19b588c56c0$export$4d5eb2109db14228;



var $exYeM = parcelRequire("exYeM");
function $e863f772c7a65c44$export$5cae361ad82dce8b(value) {
    const ref = (0, $exYeM.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0, $exYeM.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}





var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $4ed20962d3818fe0$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $4ed20962d3818fe0$export$439d29a4e110a164 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $aJx1R.default)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($4ed20962d3818fe0$export$439d29a4e110a164, {
    displayName: $4ed20962d3818fe0$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $4ed20962d3818fe0$export$be92b6f5f03c0fe9 = $4ed20962d3818fe0$export$439d29a4e110a164;


/* -------------------------------------------------------------------------------------------------
 * NavigationMenu
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NAVIGATION_MENU_NAME = "NavigationMenu";
const [$4154bcd1c7b06c2d$var$$322c88a641701f3b$var$Collection, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useCollection, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NAVIGATION_MENU_NAME);
const [$4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroupCollection, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useFocusGroupCollection, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$createFocusGroupCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NAVIGATION_MENU_NAME);
const [$4154bcd1c7b06c2d$var$$322c88a641701f3b$var$createNavigationMenuContext, $4154bcd1c7b06c2d$export$fb8ea5af8c9fcdf0] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NAVIGATION_MENU_NAME, [
    $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$createCollectionScope,
    $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$createFocusGroupCollectionScope
]);
const [$4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuProviderImpl, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext] = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$createNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NAVIGATION_MENU_NAME);
const [$4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ViewportContentProvider, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useViewportContentContext] = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$createNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NAVIGATION_MENU_NAME);
const $4154bcd1c7b06c2d$export$5b2278cf1e8bcae2 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, delayDuration: delayDuration = 200, skipDelayDuration: skipDelayDuration = 300, orientation: orientation = "horizontal", dir: dir, ...NavigationMenuProps } = props;
    const [navigationMenu, setNavigationMenu] = (0, $exYeM.useState)(null);
    const composedRef = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNavigationMenu(node));
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const openTimerRef = (0, $exYeM.useRef)(0);
    const closeTimerRef = (0, $exYeM.useRef)(0);
    const skipDelayTimerRef = (0, $exYeM.useRef)(0);
    const [isOpenDelayed, setIsOpenDelayed] = (0, $exYeM.useState)(true);
    const [value1 = "", setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: (value)=>{
            const isOpen = value !== "";
            const hasSkipDelayDuration = skipDelayDuration > 0;
            if (isOpen) {
                window.clearTimeout(skipDelayTimerRef.current);
                if (hasSkipDelayDuration) setIsOpenDelayed(false);
            } else {
                window.clearTimeout(skipDelayTimerRef.current);
                skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
            }
            onValueChange === null || onValueChange === void 0 || onValueChange(value);
        },
        defaultProp: defaultValue
    });
    const startCloseTimer = (0, $exYeM.useCallback)(()=>{
        window.clearTimeout(closeTimerRef.current);
        closeTimerRef.current = window.setTimeout(()=>setValue(""), 150);
    }, [
        setValue
    ]);
    const handleOpen = (0, $exYeM.useCallback)((itemValue)=>{
        window.clearTimeout(closeTimerRef.current);
        setValue(itemValue);
    }, [
        setValue
    ]);
    const handleDelayedOpen = (0, $exYeM.useCallback)((itemValue)=>{
        const isOpenItem = value1 === itemValue;
        if (isOpenItem) // then we want to clear the close timer immediately.
        window.clearTimeout(closeTimerRef.current);
        else openTimerRef.current = window.setTimeout(()=>{
            window.clearTimeout(closeTimerRef.current);
            setValue(itemValue);
        }, delayDuration);
    }, [
        value1,
        setValue,
        delayDuration
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            window.clearTimeout(openTimerRef.current);
            window.clearTimeout(closeTimerRef.current);
            window.clearTimeout(skipDelayTimerRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuProvider, {
        scope: __scopeNavigationMenu,
        isRootMenu: true,
        value: value1,
        dir: direction,
        orientation: orientation,
        rootNavigationMenu: navigationMenu,
        onTriggerEnter: (itemValue)=>{
            window.clearTimeout(openTimerRef.current);
            if (isOpenDelayed) handleDelayedOpen(itemValue);
            else handleOpen(itemValue);
        },
        onTriggerLeave: ()=>{
            window.clearTimeout(openTimerRef.current);
            startCloseTimer();
        },
        onContentEnter: ()=>window.clearTimeout(closeTimerRef.current),
        onContentLeave: startCloseTimer,
        onItemSelect: (itemValue)=>{
            setValue((prevValue)=>prevValue === itemValue ? "" : itemValue);
        },
        onItemDismiss: ()=>setValue("")
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).nav, (0, $aJx1R.default)({
        "aria-label": "Main",
        "data-orientation": orientation,
        dir: direction
    }, NavigationMenuProps, {
        ref: composedRef
    })));
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$5b2278cf1e8bcae2, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NAVIGATION_MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * NavigationMenuSub
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$SUB_NAME = "NavigationMenuSub";
const $4154bcd1c7b06c2d$export$5958edd6c4ee7c79 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", ...subProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$SUB_NAME, __scopeNavigationMenu);
    const [value = "", setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuProvider, {
        scope: __scopeNavigationMenu,
        isRootMenu: false,
        value: value,
        dir: context.dir,
        orientation: orientation,
        rootNavigationMenu: context.rootNavigationMenu,
        onTriggerEnter: (itemValue)=>setValue(itemValue),
        onItemSelect: (itemValue)=>setValue(itemValue),
        onItemDismiss: ()=>setValue("")
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "data-orientation": orientation
    }, subProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$5958edd6c4ee7c79, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$SUB_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuProvider = (props)=>{
    const { scope: scope, isRootMenu: isRootMenu, rootNavigationMenu: rootNavigationMenu, dir: dir, orientation: orientation, children: children, value: value, onItemSelect: onItemSelect, onItemDismiss: onItemDismiss, onTriggerEnter: onTriggerEnter, onTriggerLeave: onTriggerLeave, onContentEnter: onContentEnter, onContentLeave: onContentLeave } = props;
    const [viewport, setViewport] = (0, $exYeM.useState)(null);
    const [viewportContent, setViewportContent] = (0, $exYeM.useState)(new Map());
    const [indicatorTrack, setIndicatorTrack] = (0, $exYeM.useState)(null);
    return /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuProviderImpl, {
        scope: scope,
        isRootMenu: isRootMenu,
        rootNavigationMenu: rootNavigationMenu,
        value: value,
        previousValue: (0, $e863f772c7a65c44$export$5cae361ad82dce8b)(value),
        baseId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        dir: dir,
        orientation: orientation,
        viewport: viewport,
        onViewportChange: setViewport,
        indicatorTrack: indicatorTrack,
        onIndicatorTrackChange: setIndicatorTrack,
        onTriggerEnter: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onTriggerEnter),
        onTriggerLeave: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onTriggerLeave),
        onContentEnter: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onContentEnter),
        onContentLeave: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onContentLeave),
        onItemSelect: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onItemSelect),
        onItemDismiss: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onItemDismiss),
        onViewportContentChange: (0, $exYeM.useCallback)((contentValue, contentData)=>{
            setViewportContent((prevContent)=>{
                prevContent.set(contentValue, contentData);
                return new Map(prevContent);
            });
        }, []),
        onViewportContentRemove: (0, $exYeM.useCallback)((contentValue)=>{
            setViewportContent((prevContent)=>{
                if (!prevContent.has(contentValue)) return prevContent;
                prevContent.delete(contentValue);
                return new Map(prevContent);
            });
        }, [])
    }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$Collection.Provider, {
        scope: scope
    }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ViewportContentProvider, {
        scope: scope,
        items: viewportContent
    }, children)));
};
/* -------------------------------------------------------------------------------------------------
 * NavigationMenuList
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$LIST_NAME = "NavigationMenuList";
const $4154bcd1c7b06c2d$export$c361068a95fd2286 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, ...listProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$LIST_NAME, __scopeNavigationMenu);
    const list = /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).ul, (0, $aJx1R.default)({
        "data-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    }));
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        style: {
            position: "relative"
        },
        ref: context.onIndicatorTrackChange
    }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$Collection.Slot, {
        scope: __scopeNavigationMenu
    }, context.isRootMenu ? /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroup, {
        asChild: true
    }, list) : list));
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$c361068a95fd2286, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * NavigationMenuItem
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ITEM_NAME = "NavigationMenuItem";
const [$4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuItemContextProvider, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuItemContext] = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$createNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ITEM_NAME);
const $4154bcd1c7b06c2d$export$ffdbb83a2de845c2 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, value: valueProp, ...itemProps } = props;
    const autoValue = (0, $6e53b15deb1e14e9$export$f680877a34711e37)(); // We need to provide an initial deterministic value as `useId` will return
    // empty string on the first render and we don't want to match our internal "closed" value.
    const value = valueProp || autoValue || "LEGACY_REACT_AUTO_VALUE";
    const contentRef = (0, $exYeM.useRef)(null);
    const triggerRef = (0, $exYeM.useRef)(null);
    const focusProxyRef = (0, $exYeM.useRef)(null);
    const restoreContentTabOrderRef = (0, $exYeM.useRef)(()=>{});
    const wasEscapeCloseRef = (0, $exYeM.useRef)(false);
    const handleContentEntry = (0, $exYeM.useCallback)((side = "start")=>{
        if (contentRef.current) {
            restoreContentTabOrderRef.current();
            const candidates = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$getTabbableCandidates(contentRef.current);
            if (candidates.length) $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$focusFirst(side === "start" ? candidates : candidates.reverse());
        }
    }, []);
    const handleContentExit = (0, $exYeM.useCallback)(()=>{
        if (contentRef.current) {
            const candidates = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$getTabbableCandidates(contentRef.current);
            if (candidates.length) restoreContentTabOrderRef.current = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$removeFromTabOrder(candidates);
        }
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuItemContextProvider, {
        scope: __scopeNavigationMenu,
        value: value,
        triggerRef: triggerRef,
        contentRef: contentRef,
        focusProxyRef: focusProxyRef,
        wasEscapeCloseRef: wasEscapeCloseRef,
        onEntryKeyDown: handleContentEntry,
        onFocusProxyEnter: handleContentEntry,
        onRootContentClose: handleContentExit,
        onContentFocusOutside: handleContentExit
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).li, (0, $aJx1R.default)({}, itemProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$ffdbb83a2de845c2, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * NavigationMenuTrigger
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$TRIGGER_NAME = "NavigationMenuTrigger";
const $4154bcd1c7b06c2d$export$37fe8002734d8f2 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, disabled: disabled, ...triggerProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$TRIGGER_NAME, props.__scopeNavigationMenu);
    const itemContext = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuItemContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$TRIGGER_NAME, props.__scopeNavigationMenu);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(ref, itemContext.triggerRef, forwardedRef);
    const triggerId = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$makeTriggerId(context.baseId, itemContext.value);
    const contentId = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$makeContentId(context.baseId, itemContext.value);
    const hasPointerMoveOpenedRef = (0, $exYeM.useRef)(false);
    const wasClickCloseRef = (0, $exYeM.useRef)(false);
    const open = itemContext.value === context.value;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$Collection.ItemSlot, {
        scope: __scopeNavigationMenu,
        value: itemContext.value
    }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroupItem, {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        id: triggerId,
        disabled: disabled,
        "data-disabled": disabled ? "" : undefined,
        "data-state": $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$getOpenState(open),
        "aria-expanded": open,
        "aria-controls": contentId
    }, triggerProps, {
        ref: composedRefs,
        onPointerEnter: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerEnter, ()=>{
            wasClickCloseRef.current = false;
            itemContext.wasEscapeCloseRef.current = false;
        }),
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerMove, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$whenMouse(()=>{
            if (disabled || wasClickCloseRef.current || itemContext.wasEscapeCloseRef.current || hasPointerMoveOpenedRef.current) return;
            context.onTriggerEnter(itemContext.value);
            hasPointerMoveOpenedRef.current = true;
        })),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerLeave, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$whenMouse(()=>{
            if (disabled) return;
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        })),
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>{
            context.onItemSelect(itemContext.value);
            wasClickCloseRef.current = open;
        }),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const verticalEntryKey = context.dir === "rtl" ? "ArrowLeft" : "ArrowRight";
            const entryKey = {
                horizontal: "ArrowDown",
                vertical: verticalEntryKey
            }[context.orientation];
            if (open && event.key === entryKey) {
                itemContext.onEntryKeyDown(); // Prevent FocusGroupItem from handling the event
                event.preventDefault();
            }
        })
    })))), open && /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4ed20962d3818fe0$export$be92b6f5f03c0fe9), {
        "aria-hidden": true,
        tabIndex: 0,
        ref: itemContext.focusProxyRef,
        onFocus: (event)=>{
            const content = itemContext.contentRef.current;
            const prevFocusedElement = event.relatedTarget;
            const wasTriggerFocused = prevFocusedElement === ref.current;
            const wasFocusFromContent = content === null || content === void 0 ? void 0 : content.contains(prevFocusedElement);
            if (wasTriggerFocused || !wasFocusFromContent) itemContext.onFocusProxyEnter(wasTriggerFocused ? "start" : "end");
        }
    }), context.viewport && /*#__PURE__*/ (0, $exYeM.createElement)("span", {
        "aria-owns": contentId
    })));
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$37fe8002734d8f2, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * NavigationMenuLink
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$LINK_NAME = "NavigationMenuLink";
const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$LINK_SELECT = "navigationMenu.linkSelect";
const $4154bcd1c7b06c2d$export$6893bf21536567da = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, active: active, onSelect: onSelect, ...linkProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroupItem, {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).a, (0, $aJx1R.default)({
        "data-active": active ? "" : undefined,
        "aria-current": active ? "page" : undefined
    }, linkProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, (event1)=>{
            const target = event1.target;
            const linkSelectEvent = new CustomEvent($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$LINK_SELECT, {
                bubbles: true,
                cancelable: true
            });
            target.addEventListener($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$LINK_SELECT, (event)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event), {
                once: true
            });
            (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(target, linkSelectEvent);
            if (!linkSelectEvent.defaultPrevented && !event1.metaKey) {
                const rootContentDismissEvent = new CustomEvent($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ROOT_CONTENT_DISMISS, {
                    bubbles: true,
                    cancelable: true
                });
                (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(target, rootContentDismissEvent);
            }
        }, {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$6893bf21536567da, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$LINK_NAME
});
/* -------------------------------------------------------------------------------------------------
 * NavigationMenuIndicator
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$INDICATOR_NAME = "NavigationMenuIndicator";
const $4154bcd1c7b06c2d$export$8ddb526647c0d8fb = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...indicatorProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$INDICATOR_NAME, props.__scopeNavigationMenu);
    const isVisible = Boolean(context.value);
    return context.indicatorTrack ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(/*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || isVisible
    }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuIndicatorImpl, (0, $aJx1R.default)({}, indicatorProps, {
        ref: forwardedRef
    }))), context.indicatorTrack) : null;
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$8ddb526647c0d8fb, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$INDICATOR_NAME
});
const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuIndicatorImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, ...indicatorProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$INDICATOR_NAME, __scopeNavigationMenu);
    const getItems = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useCollection(__scopeNavigationMenu);
    const [activeTrigger, setActiveTrigger] = (0, $exYeM.useState)(null);
    const [position, setPosition] = (0, $exYeM.useState)(null);
    const isHorizontal = context.orientation === "horizontal";
    const isVisible = Boolean(context.value);
    (0, $exYeM.useEffect)(()=>{
        var _items$find;
        const items = getItems();
        const triggerNode = (_items$find = items.find((item)=>item.value === context.value)) === null || _items$find === void 0 ? void 0 : _items$find.ref.current;
        if (triggerNode) setActiveTrigger(triggerNode);
    }, [
        getItems,
        context.value
    ]);
    /**
   * Update position when the indicator or parent track size changes
   */ const handlePositionChange = ()=>{
        if (activeTrigger) setPosition({
            size: isHorizontal ? activeTrigger.offsetWidth : activeTrigger.offsetHeight,
            offset: isHorizontal ? activeTrigger.offsetLeft : activeTrigger.offsetTop
        });
    };
    $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useResizeObserver(activeTrigger, handlePositionChange);
    $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useResizeObserver(context.indicatorTrack, handlePositionChange); // We need to wait for the indicator position to be available before rendering to
    // snap immediately into position rather than transitioning from initial
    return position ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "aria-hidden": true,
        "data-state": isVisible ? "visible" : "hidden",
        "data-orientation": context.orientation
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            position: "absolute",
            ...isHorizontal ? {
                left: 0,
                width: position.size + "px",
                transform: `translateX(${position.offset}px)`
            } : {
                top: 0,
                height: position.size + "px",
                transform: `translateY(${position.offset}px)`
            },
            ...indicatorProps.style
        }
    })) : null;
});
/* -------------------------------------------------------------------------------------------------
 * NavigationMenuContent
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$CONTENT_NAME = "NavigationMenuContent";
const $4154bcd1c7b06c2d$export$38e00e996c2f93f7 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...contentProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$CONTENT_NAME, props.__scopeNavigationMenu);
    const itemContext = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuItemContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$CONTENT_NAME, props.__scopeNavigationMenu);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(itemContext.contentRef, forwardedRef);
    const open = itemContext.value === context.value;
    const commonProps = {
        value: itemContext.value,
        triggerRef: itemContext.triggerRef,
        focusProxyRef: itemContext.focusProxyRef,
        wasEscapeCloseRef: itemContext.wasEscapeCloseRef,
        onContentFocusOutside: itemContext.onContentFocusOutside,
        onRootContentClose: itemContext.onRootContentClose,
        ...contentProps
    };
    return !context.viewport ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuContentImpl, (0, $aJx1R.default)({
        "data-state": $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$getOpenState(open)
    }, commonProps, {
        ref: composedRefs,
        onPointerEnter: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerEnter, context.onContentEnter),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerLeave, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$whenMouse(context.onContentLeave)),
        style: {
            // Prevent interaction when animating out
            pointerEvents: !open && context.isRootMenu ? "none" : undefined,
            ...commonProps.style
        }
    }))) : /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ViewportContentMounter, (0, $aJx1R.default)({
        forceMount: forceMount
    }, commonProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$38e00e996c2f93f7, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ViewportContentMounter = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$CONTENT_NAME, props.__scopeNavigationMenu);
    const { onViewportContentChange: onViewportContentChange, onViewportContentRemove: onViewportContentRemove } = context;
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        onViewportContentChange(props.value, {
            ref: forwardedRef,
            ...props
        });
    }, [
        props,
        forwardedRef,
        onViewportContentChange
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        return ()=>onViewportContentRemove(props.value);
    }, [
        props.value,
        onViewportContentRemove
    ]); // Content is proxied into the viewport
    return null;
});
/* -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ROOT_CONTENT_DISMISS = "navigationMenu.rootContentDismiss";
const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, value: value, triggerRef: triggerRef, focusProxyRef: focusProxyRef, wasEscapeCloseRef: wasEscapeCloseRef, onRootContentClose: onRootContentClose, onContentFocusOutside: onContentFocusOutside, ...contentProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$CONTENT_NAME, __scopeNavigationMenu);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(ref, forwardedRef);
    const triggerId = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$makeTriggerId(context.baseId, value);
    const contentId = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$makeContentId(context.baseId, value);
    const getItems = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useCollection(__scopeNavigationMenu);
    const prevMotionAttributeRef = (0, $exYeM.useRef)(null);
    const { onItemDismiss: onItemDismiss } = context;
    (0, $exYeM.useEffect)(()=>{
        const content = ref.current; // Bubble dismiss to the root content node and focus its trigger
        if (context.isRootMenu && content) {
            const handleClose = ()=>{
                var _triggerRef$current;
                onItemDismiss();
                onRootContentClose();
                if (content.contains(document.activeElement)) (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            };
            content.addEventListener($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ROOT_CONTENT_DISMISS, handleClose);
            return ()=>content.removeEventListener($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ROOT_CONTENT_DISMISS, handleClose);
        }
    }, [
        context.isRootMenu,
        props.value,
        triggerRef,
        onItemDismiss,
        onRootContentClose
    ]);
    const motionAttribute = (0, $exYeM.useMemo)(()=>{
        const items = getItems();
        const values = items.map((item)=>item.value);
        if (context.dir === "rtl") values.reverse();
        const index = values.indexOf(context.value);
        const prevIndex = values.indexOf(context.previousValue);
        const isSelected = value === context.value;
        const wasSelected = prevIndex === values.indexOf(value); // We only want to update selected and the last selected content
        // this avoids animations being interrupted outside of that range
        if (!isSelected && !wasSelected) return prevMotionAttributeRef.current;
        const attribute = (()=>{
            // Don't provide a direction on the initial open
            if (index !== prevIndex) {
                // If we're moving to this item from another
                if (isSelected && prevIndex !== -1) return index > prevIndex ? "from-end" : "from-start"; // If we're leaving this item for another
                if (wasSelected && index !== -1) return index > prevIndex ? "to-start" : "to-end";
            } // Otherwise we're entering from closed or leaving the list
            // entirely and should not animate in any direction
            return null;
        })();
        prevMotionAttributeRef.current = attribute;
        return attribute;
    }, [
        context.previousValue,
        context.value,
        context.dir,
        getItems,
        value
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroup, {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), (0, $aJx1R.default)({
        id: contentId,
        "aria-labelledby": triggerId,
        "data-motion": motionAttribute,
        "data-orientation": context.orientation
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>{
            var _ref$current;
            const rootContentDismissEvent = new Event($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ROOT_CONTENT_DISMISS, {
                bubbles: true,
                cancelable: true
            });
            (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.dispatchEvent(rootContentDismissEvent);
        },
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
            var _context$rootNavigati;
            onContentFocusOutside();
            const target = event.target; // Only dismiss content when focus moves outside of the menu
            if ((_context$rootNavigati = context.rootNavigationMenu) !== null && _context$rootNavigati !== void 0 && _context$rootNavigati.contains(target)) event.preventDefault();
        }),
        onPointerDownOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            var _context$viewport;
            const target = event.target;
            const isTrigger = getItems().some((item)=>{
                var _item$ref$current;
                return (_item$ref$current = item.ref.current) === null || _item$ref$current === void 0 ? void 0 : _item$ref$current.contains(target);
            });
            const isRootViewport = context.isRootMenu && ((_context$viewport = context.viewport) === null || _context$viewport === void 0 ? void 0 : _context$viewport.contains(target));
            if (isTrigger || isRootViewport || !context.isRootMenu) event.preventDefault();
        }),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
            const isTabKey = event.key === "Tab" && !isMetaKey;
            if (isTabKey) {
                const candidates = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$getTabbableCandidates(event.currentTarget);
                const focusedElement = document.activeElement;
                const index = candidates.findIndex((candidate)=>candidate === focusedElement);
                const isMovingBackwards = event.shiftKey;
                const nextCandidates = isMovingBackwards ? candidates.slice(0, index).reverse() : candidates.slice(index + 1, candidates.length);
                if ($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$focusFirst(nextCandidates)) event.preventDefault();
                else {
                    var _focusProxyRef$curren;
                    // If we can't focus that means we're at the edges
                    // so focus the proxy and let browser handle
                    // tab/shift+tab keypress on the proxy instead
                    (_focusProxyRef$curren = focusProxyRef.current) === null || _focusProxyRef$curren === void 0 || _focusProxyRef$curren.focus();
                }
            }
        }),
        onEscapeKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onEscapeKeyDown, (event)=>{
            // prevent the dropdown from reopening
            // after the escape key has been pressed
            wasEscapeCloseRef.current = true;
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * NavigationMenuViewport
 * -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$VIEWPORT_NAME = "NavigationMenuViewport";
const $4154bcd1c7b06c2d$export$ee880b97cc6d44a5 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...viewportProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$VIEWPORT_NAME, props.__scopeNavigationMenu);
    const open = Boolean(context.value);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuViewportImpl, (0, $aJx1R.default)({}, viewportProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($4154bcd1c7b06c2d$export$ee880b97cc6d44a5, {
    displayName: $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuViewportImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props1, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, children: children, ...viewportImplProps } = props1;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$VIEWPORT_NAME, __scopeNavigationMenu);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.onViewportChange);
    const viewportContentContext = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useViewportContentContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$CONTENT_NAME, props1.__scopeNavigationMenu);
    const [size, setSize] = (0, $exYeM.useState)(null);
    const [content, setContent] = (0, $exYeM.useState)(null);
    const viewportWidth = size ? (size === null || size === void 0 ? void 0 : size.width) + "px" : undefined;
    const viewportHeight = size ? (size === null || size === void 0 ? void 0 : size.height) + "px" : undefined;
    const open = Boolean(context.value); // We persist the last active content value as the viewport may be animating out
    // and we want the content to remain mounted for the lifecycle of the viewport.
    const activeContentValue = open ? context.value : context.previousValue;
    /**
   * Update viewport size to match the active content node.
   * We prefer offset dimensions over `getBoundingClientRect` as the latter respects CSS transform.
   * For example, if content animates in from `scale(0.5)` the dimensions would be anything
   * from `0.5` to `1` of the intended size.
   */ const handleSizeChange = ()=>{
        if (content) setSize({
            width: content.offsetWidth,
            height: content.offsetHeight
        });
    };
    $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useResizeObserver(content, handleSizeChange);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "data-state": $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$getOpenState(open),
        "data-orientation": context.orientation
    }, viewportImplProps, {
        ref: composedRefs,
        style: {
            // Prevent interaction when animating out
            pointerEvents: !open && context.isRootMenu ? "none" : undefined,
            ["--radix-navigation-menu-viewport-width"]: viewportWidth,
            ["--radix-navigation-menu-viewport-height"]: viewportHeight,
            ...viewportImplProps.style
        },
        onPointerEnter: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props1.onPointerEnter, context.onContentEnter),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props1.onPointerLeave, $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$whenMouse(context.onContentLeave))
    }), Array.from(viewportContentContext.items).map(([value, { ref: ref, forceMount: forceMount, ...props }])=>{
        const isActive = activeContentValue === value;
        return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
            key: value,
            present: forceMount || isActive
        }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$NavigationMenuContentImpl, (0, $aJx1R.default)({}, props, {
            ref: (0, $a0301a3b12ffad9c$export$43e446d32b3d21af)(ref, (node)=>{
                // We only want to update the stored node when another is available
                // as we need to smoothly transition between them.
                if (isActive && node) setContent(node);
            })
        })));
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FOCUS_GROUP_NAME = "FocusGroup";
const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroup = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, ...groupProps } = props;
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FOCUS_GROUP_NAME, __scopeNavigationMenu);
    return /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroupCollection.Provider, {
        scope: __scopeNavigationMenu
    }, /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroupCollection.Slot, {
        scope: __scopeNavigationMenu
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        dir: context.dir
    }, groupProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ARROW_KEYS = [
    "ArrowRight",
    "ArrowLeft",
    "ArrowUp",
    "ArrowDown"
];
const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FOCUS_GROUP_ITEM_NAME = "FocusGroupItem";
const $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroupItem = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, ...groupProps } = props;
    const getItems = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useFocusGroupCollection(__scopeNavigationMenu);
    const context = $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useNavigationMenuContext($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FOCUS_GROUP_ITEM_NAME, __scopeNavigationMenu);
    return /*#__PURE__*/ (0, $exYeM.createElement)($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$FocusGroupCollection.ItemSlot, {
        scope: __scopeNavigationMenu
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({}, groupProps, {
        ref: forwardedRef,
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isFocusNavigationKey = [
                "Home",
                "End",
                ...$4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ARROW_KEYS
            ].includes(event.key);
            if (isFocusNavigationKey) {
                let candidateNodes = getItems().map((item)=>item.ref.current);
                const prevItemKey = context.dir === "rtl" ? "ArrowRight" : "ArrowLeft";
                const prevKeys = [
                    prevItemKey,
                    "ArrowUp",
                    "End"
                ];
                if (prevKeys.includes(event.key)) candidateNodes.reverse();
                if ($4154bcd1c7b06c2d$var$$322c88a641701f3b$var$ARROW_KEYS.includes(event.key)) {
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$4154bcd1c7b06c2d$var$$322c88a641701f3b$var$focusFirst(candidateNodes)); // Prevent page scroll while navigating
                event.preventDefault();
            }
        })
    })));
});
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
function $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$removeFromTabOrder(candidates) {
    candidates.forEach((candidate)=>{
        candidate.dataset.tabindex = candidate.getAttribute("tabindex") || "";
        candidate.setAttribute("tabindex", "-1");
    });
    return ()=>{
        candidates.forEach((candidate)=>{
            const prevTabIndex = candidate.dataset.tabindex;
            candidate.setAttribute("tabindex", prevTabIndex);
        });
    };
}
function $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$useResizeObserver(element, onResize) {
    const handleResize = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onResize);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        let rAF = 0;
        if (element) {
            /**
       * Resize Observer will throw an often benign error that says `ResizeObserver loop
       * completed with undelivered notifications`. This means that ResizeObserver was not
       * able to deliver all observations within a single animation frame, so we use
       * `requestAnimationFrame` to ensure we don't deliver unnecessary observations.
       * Further reading: https://github.com/WICG/resize-observer/issues/38
       */ const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
function $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
function $4154bcd1c7b06c2d$var$$322c88a641701f3b$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : undefined;
}
/* -----------------------------------------------------------------------------------------------*/ const $4154bcd1c7b06c2d$export$be92b6f5f03c0fe9 = $4154bcd1c7b06c2d$export$5b2278cf1e8bcae2;
const $4154bcd1c7b06c2d$export$d7a01e11500dfb6f = $4154bcd1c7b06c2d$export$5958edd6c4ee7c79;
const $4154bcd1c7b06c2d$export$54c2e3dc7acea9f5 = $4154bcd1c7b06c2d$export$c361068a95fd2286;
const $4154bcd1c7b06c2d$export$6d08773d2e66f8f2 = $4154bcd1c7b06c2d$export$ffdbb83a2de845c2;
const $4154bcd1c7b06c2d$export$41fb9f06171c75f4 = $4154bcd1c7b06c2d$export$37fe8002734d8f2;
const $4154bcd1c7b06c2d$export$a6c7ac8248d6e38a = $4154bcd1c7b06c2d$export$6893bf21536567da;
const $4154bcd1c7b06c2d$export$adb584737d712b70 = $4154bcd1c7b06c2d$export$8ddb526647c0d8fb;
const $4154bcd1c7b06c2d$export$7c6e2c02157bb7d2 = $4154bcd1c7b06c2d$export$38e00e996c2f93f7;
const $4154bcd1c7b06c2d$export$d5c6c08dc2d3ca7 = $4154bcd1c7b06c2d$export$ee880b97cc6d44a5;


function $d8021cd32a79bac1$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $d8021cd32a79bac1$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $d8021cd32a79bac1$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $d8021cd32a79bac1$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $d8021cd32a79bac1$export$2e2bcd8739ae039 = $d8021cd32a79bac1$export$4f5d2d50c9deca37;


const $f6c488ee7ea67d84$var$falsyToString = (value)=>typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
const $f6c488ee7ea67d84$export$a274e22fb40f762e = (0, $d8021cd32a79bac1$export$4f5d2d50c9deca37);
const $f6c488ee7ea67d84$export$87dc52566e90b739 = (base, config)=>{
    return (props)=>{
        var ref;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $f6c488ee7ea67d84$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $f6c488ee7ea67d84$var$falsyToString(variantProp) || $f6c488ee7ea67d84$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param1;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $f6c488ee7ea67d84$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};


/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $exYeM = parcelRequire("exYeM");
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $a1147f4a87d207e2$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $a1147f4a87d207e2$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && array.indexOf(className) === index;
    }).join(" ");


/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $exYeM = parcelRequire("exYeM");
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $52e2014e5c8e37ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $ed583ad681cca9df$export$2e2bcd8739ae039 = (0, $exYeM.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $exYeM.createElement)("svg", {
        ref: ref,
        ...(0, $52e2014e5c8e37ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $a1147f4a87d207e2$export$3d46f4579dba46e5)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $exYeM.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $84967fc29334d97c$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $exYeM.forwardRef)(({ className: className, ...props }, ref)=>(0, $exYeM.createElement)((0, $ed583ad681cca9df$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $a1147f4a87d207e2$export$3d46f4579dba46e5)(`lucide-${(0, $a1147f4a87d207e2$export$73bda83cddbc7187)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};


const $e150fda29aff442d$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("ChevronDown", [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
]);



const $cc1ac42df0575647$export$5b2278cf1e8bcae2 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)($4154bcd1c7b06c2d$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("relative z-50 flex max-w-max flex-1 items-center justify-center", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $aSiaI.jsx)($cc1ac42df0575647$export$ee880b97cc6d44a5, {})
        ]
    }));
$cc1ac42df0575647$export$5b2278cf1e8bcae2.displayName = $4154bcd1c7b06c2d$export$be92b6f5f03c0fe9.displayName;
const $cc1ac42df0575647$export$c361068a95fd2286 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($4154bcd1c7b06c2d$export$54c2e3dc7acea9f5, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("ml-10 flex items-center space-x-4 font-roboto font-light", className),
        ...props
    }));
$cc1ac42df0575647$export$c361068a95fd2286.displayName = $4154bcd1c7b06c2d$export$54c2e3dc7acea9f5.displayName;
const $cc1ac42df0575647$export$ffdbb83a2de845c2 = $4154bcd1c7b06c2d$export$6d08773d2e66f8f2;
const $cc1ac42df0575647$export$3da993e9cee53072 = (0, $f6c488ee7ea67d84$export$87dc52566e90b739)("flex h-16 px-3 py-2 text-black items-center text-center border-b-2 border-white hover:text-primary focus:outline-none data-[state=open]:bg-white");
const $cc1ac42df0575647$export$37fe8002734d8f2 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)($4154bcd1c7b06c2d$export$41fb9f06171c75f4, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)($cc1ac42df0575647$export$3da993e9cee53072(), className),
        ...props,
        children: [
            children,
            " ",
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e150fda29aff442d$export$2e2bcd8739ae039), {
                className: "relative top-[1px] ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180",
                "aria-hidden": "true"
            })
        ]
    }));
$cc1ac42df0575647$export$37fe8002734d8f2.displayName = $4154bcd1c7b06c2d$export$41fb9f06171c75f4.displayName;
const $cc1ac42df0575647$export$38e00e996c2f93f7 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($4154bcd1c7b06c2d$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("left-0 top-0 w-full z-50 data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 md:absolute md:w-auto bg-white", className),
        ...props
    }));
$cc1ac42df0575647$export$38e00e996c2f93f7.displayName = $4154bcd1c7b06c2d$export$7c6e2c02157bb7d2.displayName;
const $cc1ac42df0575647$export$6893bf21536567da = $4154bcd1c7b06c2d$export$a6c7ac8248d6e38a;
const $cc1ac42df0575647$export$ee880b97cc6d44a5 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("absolute left-0 top-full flex justify-center z-50"),
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($4154bcd1c7b06c2d$export$d5c6c08dc2d3ca7, {
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("origin-top-center relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border bg-surface text-onSurface shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 md:w-[var(--radix-navigation-menu-viewport-width)]", className),
            ref: ref,
            ...props
        })
    }));
$cc1ac42df0575647$export$ee880b97cc6d44a5.displayName = $4154bcd1c7b06c2d$export$d5c6c08dc2d3ca7.displayName;
const $cc1ac42df0575647$export$8ddb526647c0d8fb = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($4154bcd1c7b06c2d$export$adb584737d712b70, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("top-full z-50 flex h-1.5 items-end justify-center overflow-hidden data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in", className),
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm bg-border shadow-md"
        })
    }));
$cc1ac42df0575647$export$8ddb526647c0d8fb.displayName = $4154bcd1c7b06c2d$export$adb584737d712b70.displayName;


const $6f16b426af245be2$var$exploreComponents = [
    {
        title: "Ethereum Charts",
        href: "/Explore?blockchain=Ethereum",
        description: "Ethereum charts contains a wide array of onchain charts."
    },
    {
        title: "Ethereum Tables",
        href: "/Explore/Tables?blockchain=Ethereum",
        description: "Ethereum tables contains a vast variety of Crypto tables."
    },
    {
        title: "Bitcoin Tables",
        href: "/Explore/Tables?blockchain=Bitcoin",
        description: "Bitcoin tables contains a vast variety of Crypto tables."
    },
    {
        title: "Bitcoin Charts",
        href: "/Explore?blockchain=Bitcoin",
        description: "Bitcoin charts contains a wide array of onchain charts"
    }
];
const $6f16b426af245be2$var$tablesLink = {
    title: "Tables",
    href: "/Explore/Tables?blockchain=Ethereum"
};
function $6f16b426af245be2$var$Nav() {
    const [isOpen, setIsOpen] = (0, $exYeM.useState)(false);
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { validateUser: validateUser } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    let activeClassNameSmall = "flex border-b-2 border-primary px-3 py-2 rounded-md text-sm font-medium items-center text-center text-primary";
    let notActiveClassNameSmall = "flex px-3 py-2 rounded-md text-sm font-medium text-black items-center text-center border-b-2 border-white hover:text-primary";
    let activeClassName = "flex border-b-2 border-primary h-16 px-3 py-2 items-center text-center text-primary";
    let notActiveClassName = "flex h-16 px-3 py-2 text-black items-center text-center border-b-2 border-white hover:text-primary";
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("nav", {
            className: "bg-white bg-clip-padding backdrop-filter backdrop-blur-xl z-50 shadow-md",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "px-4 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center justify-between h-16",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-center h-full",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                            to: "/",
                                            end: true,
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                className: "h-9",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($71c100fee4a7a173$exports))),
                                                alt: "Wevr"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "hidden lg:flex",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $cc1ac42df0575647$export$5b2278cf1e8bcae2), {
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $cc1ac42df0575647$export$c361068a95fd2286), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $cc1ac42df0575647$export$ffdbb83a2de845c2), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$37fe8002734d8f2), {
                                                                    className: notActiveClassName,
                                                                    children: "Explore"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$38e00e996c2f93f7), {
                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                                                        className: "grid gap-3 p-6 md:w-[400px] lg:w-[500px] lg:grid-cols-[.75fr_1fr] bg-white shadow-lg rounded-md z-50",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                                className: "row-span-3 z-50",
                                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$6893bf21536567da), {
                                                                                    asChild: true,
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                                                                        className: "flex h-full w-full select-none flex-col justify-end rounded-md bg-gradient-to-b from-muted/50 to-muted p-6 no-underline outline-none focus:shadow-md relative",
                                                                                        to: $6f16b426af245be2$var$exploreComponents[0].href,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                                className: "mb-2 mt-4 text-lg font-semibold",
                                                                                                children: $6f16b426af245be2$var$exploreComponents[0].title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                                                                className: "text-sm leading-tight text-muted-foreground",
                                                                                                children: $6f16b426af245be2$var$exploreComponents[0].description
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8af33ef04486b7$exports))),
                                                                                                alt: "Logo",
                                                                                                className: "h-6 w-6 absolute top-4 right-4"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            $6f16b426af245be2$var$exploreComponents.slice(1).map((component)=>/*#__PURE__*/ (0, $aSiaI.jsx)($6f16b426af245be2$var$ListItem, {
                                                                                    title: component.title,
                                                                                    href: component.href,
                                                                                    children: component.description
                                                                                }, component.title))
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$ffdbb83a2de845c2), {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                                                to: "/Discover",
                                                                className: ({ isActive: isActive })=>isActive ? activeClassName : notActiveClassName,
                                                                children: "Discover"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$ffdbb83a2de845c2), {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                                                to: "/Footprint",
                                                                className: ({ isActive: isActive })=>isActive ? activeClassName : notActiveClassName,
                                                                children: "Footprint"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$ffdbb83a2de845c2), {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                                                to: "/query",
                                                                className: ({ isActive: isActive })=>isActive ? activeClassName : notActiveClassName,
                                                                children: "Query"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$ffdbb83a2de845c2), {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                                                to: "/Dashboard",
                                                                className: ({ isActive: isActive })=>isActive ? activeClassName : notActiveClassName,
                                                                children: "Dashboard"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$ffdbb83a2de845c2), {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                                                to: "/Alerts",
                                                                className: ({ isActive: isActive })=>isActive ? activeClassName : notActiveClassName,
                                                                children: "Alerts"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$ffdbb83a2de845c2), {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                                                to: "/Pricing",
                                                                className: ({ isActive: isActive })=>isActive ? activeClassName : notActiveClassName,
                                                                children: "Pricing"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$ee880b97cc6d44a5), {})
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "hidden lg:block place-content-end",
                                children: validateUser.isLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
                                            "aria-hidden": "true",
                                            className: "w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-primary",
                                            viewBox: "0 0 100 101",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                    fill: "currentColor"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                    fill: "currentFill"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "sr-only",
                                            children: "Loading..."
                                        })
                                    ]
                                }) : localStorage.getItem("user") === null ? /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                    type: "button",
                                    className: "inline-flex items-center px-3 py-2 font-semibold hover:text-white bg-surfaceVariant border border-primaryContainer shadow-md rounded-lg hover:bg-primary",
                                    onClick: ()=>{
                                        navigate("/signin");
                                    },
                                    children: "Login"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        className: "group inline-flex items-center px-4 py-2",
                                        onClick: ()=>{
                                            navigate("/UserSettings");
                                        },
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a023194119fceba9$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-onSurfaceVariant rounded-2xl group-hover:text-primary",
                                            "aria-hidden": "true"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "-mr-2 flex lg:hidden",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                    onClick: ()=>setIsOpen(!isOpen),
                                    type: "button",
                                    className: "bg-surfaceVariant border border-primaryContainer inline-flex items-center justify-center p-2 rounded-md text-primary hover:text-primaryContainer hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white",
                                    "aria-controls": "mobile-menu",
                                    "aria-expanded": "false",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "sr-only",
                                            children: "Open main menu"
                                        }),
                                        !isOpen ? /*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                                            className: "block h-6 w-6",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: "2",
                                                d: "M4 6h16M4 12h16M4 18h16"
                                            })
                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                                            className: "block h-6 w-6",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: "2",
                                                d: "M6 18L18 6M6 6l12 12"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                    show: isOpen,
                    enter: "transition ease-out duration-100 transform",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    leave: "transition ease-in duration-75 transform",
                    leaveFrom: "opacity-100 scale-100",
                    leaveTo: "opacity-0 scale-95",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "lg:hidden z-50",
                        id: "mobile-menu",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "grid grid-cols-2 items-center font-roboto font-light",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                    to: "/Explore?blockchain=Ethereum",
                                    className: ({ isActive: isActive })=>isActive ? activeClassNameSmall : notActiveClassNameSmall,
                                    children: "Explore"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                    to: $6f16b426af245be2$var$tablesLink.href,
                                    className: ({ isActive: isActive })=>isActive ? activeClassNameSmall : notActiveClassNameSmall,
                                    children: $6f16b426af245be2$var$tablesLink.title
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                    to: "/Discover",
                                    className: ({ isActive: isActive })=>isActive ? activeClassNameSmall : notActiveClassNameSmall,
                                    children: "Discover"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                    to: "/Footprint",
                                    className: ({ isActive: isActive })=>isActive ? activeClassNameSmall : notActiveClassNameSmall,
                                    children: "Footprint"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                    to: "/query",
                                    className: ({ isActive: isActive })=>isActive ? activeClassNameSmall : notActiveClassNameSmall,
                                    children: "Query"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                    to: "/Dashboard",
                                    className: ({ isActive: isActive })=>isActive ? activeClassNameSmall : notActiveClassNameSmall,
                                    children: "Dashboard"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                    to: "/Alerts",
                                    className: ({ isActive: isActive })=>isActive ? activeClassNameSmall : notActiveClassNameSmall,
                                    children: "Alerts"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                    to: "/Pricing",
                                    className: ({ isActive: isActive })=>isActive ? activeClassNameSmall : notActiveClassNameSmall,
                                    children: "Pricing"
                                }),
                                validateUser.isLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
                                            "aria-hidden": "true",
                                            className: "w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-primary",
                                            viewBox: "0 0 100 101",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                    fill: "currentColor"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                    fill: "currentFill"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "sr-only",
                                            children: "Loading..."
                                        })
                                    ]
                                }) : localStorage.getItem("user") === null ? /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                    type: "button",
                                    className: notActiveClassNameSmall,
                                    onClick: ()=>{
                                        navigate("/signin");
                                    },
                                    children: "Login"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        className: "group inline-flex items-center px-4 py-2",
                                        onClick: ()=>{
                                            navigate("/UserSettings");
                                        },
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a023194119fceba9$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-onSurfaceVariant rounded-2xl group-hover:text-primary",
                                            "aria-hidden": "true"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
const $6f16b426af245be2$var$ListItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, title: title, href: href, children: children, ...props })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc1ac42df0575647$export$6893bf21536567da), {
            asChild: true,
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                to: href,
                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground", className),
                onClick: ()=>{},
                ...props,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "text-sm font-bold leading-none",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "line-clamp-2 text-sm leading-snug text-muted-foreground",
                        children: children
                    })
                ]
            })
        })
    });
});
$6f16b426af245be2$var$ListItem.displayName = "ListItem";
var $6f16b426af245be2$export$2e2bcd8739ae039 = $6f16b426af245be2$var$Nav;


var $4cde099517bdf0a6$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $4cde099517bdf0a6$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});



var $exYeM = parcelRequire("exYeM");
/**
 * A function to wrap elements with a "wrapper" on a condition
 * @param {object} wrappingOptions
 *  condition == boolean condition, when to wrap
 *  wrapper == style to wrap. e.g <div>{children}</div>
 *  children == react passes whatever is between tags as children. Don't supply this yourself.
 */ var $01d2b1f1c1a3ca7d$export$39aecc95f0365819 = function ConditionalWrapper(_ref) {
    var condition = _ref.condition, wrapper = _ref.wrapper, children = _ref.children;
    return condition ? wrapper(children) : children;
};
function $01d2b1f1c1a3ca7d$var$_extends() {
    $01d2b1f1c1a3ca7d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01d2b1f1c1a3ca7d$var$_extends.apply(this, arguments);
}
function $01d2b1f1c1a3ca7d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $01d2b1f1c1a3ca7d$var$_setPrototypeOf(subClass, superClass);
}
function $01d2b1f1c1a3ca7d$var$_setPrototypeOf(o, p) {
    $01d2b1f1c1a3ca7d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $01d2b1f1c1a3ca7d$var$_setPrototypeOf(o, p);
}
function $01d2b1f1c1a3ca7d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $01d2b1f1c1a3ca7d$export$8eb3892b442747bd = {
    TOP: "top",
    BOTTOM: "bottom",
    NONE: "none"
};
var $01d2b1f1c1a3ca7d$export$a83cc8fc1e235be1;
(function(SAME_SITE_OPTIONS) {
    SAME_SITE_OPTIONS["STRICT"] = "strict";
    SAME_SITE_OPTIONS["LAX"] = "lax";
    SAME_SITE_OPTIONS["NONE"] = "none";
})($01d2b1f1c1a3ca7d$export$a83cc8fc1e235be1 || ($01d2b1f1c1a3ca7d$export$a83cc8fc1e235be1 = {}));
var $01d2b1f1c1a3ca7d$export$294703df038a1b6f = {
    HIDDEN: "hidden",
    SHOW: "show",
    BY_COOKIE_VALUE: "byCookieValue"
};
var $01d2b1f1c1a3ca7d$export$2ba1cf4ce66b15cf = "CookieConsent";
var $01d2b1f1c1a3ca7d$var$_excluded = [
    "children"
];
var $01d2b1f1c1a3ca7d$var$DefaultButtonComponent = function DefaultButtonComponent(_ref) {
    var children = _ref.children, props = $01d2b1f1c1a3ca7d$var$_objectWithoutPropertiesLoose(_ref, $01d2b1f1c1a3ca7d$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("button", Object.assign({}, props), children);
};
var $01d2b1f1c1a3ca7d$var$defaultCookieConsentProps = {
    disableStyles: false,
    hideOnAccept: true,
    hideOnDecline: true,
    location: $01d2b1f1c1a3ca7d$export$8eb3892b442747bd.BOTTOM,
    visible: $01d2b1f1c1a3ca7d$export$294703df038a1b6f.BY_COOKIE_VALUE,
    onAccept: function onAccept(_acceptedByScrolling) {},
    onDecline: function onDecline() {},
    cookieName: $01d2b1f1c1a3ca7d$export$2ba1cf4ce66b15cf,
    cookieValue: "true",
    declineCookieValue: "false",
    setDeclineCookie: true,
    buttonText: "I understand",
    declineButtonText: "I decline",
    debug: false,
    expires: 365,
    containerClasses: "CookieConsent",
    contentClasses: "",
    buttonClasses: "",
    buttonWrapperClasses: "",
    declineButtonClasses: "",
    buttonId: "rcc-confirm-button",
    declineButtonId: "rcc-decline-button",
    extraCookieOptions: {},
    disableButtonStyles: false,
    enableDeclineButton: false,
    flipButtons: false,
    sameSite: $01d2b1f1c1a3ca7d$export$a83cc8fc1e235be1.LAX,
    ButtonComponent: $01d2b1f1c1a3ca7d$var$DefaultButtonComponent,
    overlay: false,
    overlayClasses: "",
    onOverlayClick: function onOverlayClick() {},
    acceptOnOverlayClick: false,
    ariaAcceptLabel: "Accept cookies",
    ariaDeclineLabel: "Decline cookies",
    acceptOnScroll: false,
    acceptOnScrollPercentage: 25,
    customContentAttributes: {},
    customContainerAttributes: {},
    customButtonProps: {},
    customDeclineButtonProps: {},
    customButtonWrapperAttributes: {},
    style: {},
    buttonStyle: {},
    declineButtonStyle: {},
    contentStyle: {},
    overlayStyle: {}
};
var $01d2b1f1c1a3ca7d$var$defaultState = {
    visible: false,
    style: {
        alignItems: "baseline",
        background: "#353535",
        color: "white",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        left: "0",
        position: "fixed",
        width: "100%",
        zIndex: "999"
    },
    buttonStyle: {
        background: "#ffd42d",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "black",
        cursor: "pointer",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
    },
    declineButtonStyle: {
        background: "#c12a2a",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "#e5e5e5",
        cursor: "pointer",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
    },
    contentStyle: {
        flex: "1 0 300px",
        margin: "15px"
    },
    overlayStyle: {
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: "999",
        backgroundColor: "rgba(0,0,0,0.3)"
    }
};
/**
 * Returns the value of the consent cookie
 * Retrieves the regular value first and if not found the legacy one according
 * to: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
 * @param {*} name optional name of the cookie
 */ var $01d2b1f1c1a3ca7d$export$a8e4ce6c059bdd6b = function getCookieConsentValue(name) {
    if (name === void 0) name = $01d2b1f1c1a3ca7d$export$2ba1cf4ce66b15cf;
    var cookieValue = (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).get(name); // if the cookieValue is undefined check for the legacy cookie
    if (cookieValue === undefined) return (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).get($01d2b1f1c1a3ca7d$export$ee149ea8a5f63691(name));
    return cookieValue;
};
/**
 * Reset the consent cookie
 * Remove the cookie on browser in order to allow user to change their consent
 * @param {*} name optional name of the cookie
 */ var $01d2b1f1c1a3ca7d$export$f3238b6dfe3e6b67 = function resetCookieConsentValue(name) {
    if (name === void 0) name = $01d2b1f1c1a3ca7d$export$2ba1cf4ce66b15cf;
    (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).remove(name);
};
/**
 * Get the legacy cookie name by the regular cookie name
 * @param {string} name of cookie to get
 */ var $01d2b1f1c1a3ca7d$export$ee149ea8a5f63691 = function getLegacyCookieName(name) {
    return name + "-legacy";
};
var $01d2b1f1c1a3ca7d$export$e06767a507a85916 = /*#__PURE__*/ function(_Component) {
    $01d2b1f1c1a3ca7d$var$_inheritsLoose(CookieConsent, _Component);
    function CookieConsent() {
        var _this;
        _this = _Component.apply(this, arguments) || this;
        _this.state = $01d2b1f1c1a3ca7d$var$defaultState;
        /**
     * checks whether scroll has exceeded set amount and fire accept if so.
     */ _this.handleScroll = function() {
            var acceptOnScrollPercentage = _this.props.acceptOnScrollPercentage; // (top / height) - height * 100
            var rootNode = document.documentElement;
            var body = document.body;
            var top = "scrollTop";
            var height = "scrollHeight";
            var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;
            if (percentage > acceptOnScrollPercentage) _this.accept(true);
        };
        _this.removeScrollListener = function() {
            var acceptOnScroll = _this.props.acceptOnScroll;
            if (acceptOnScroll) window.removeEventListener("scroll", _this.handleScroll);
        };
        return _this;
    }
    var _proto = CookieConsent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var debug = this.props.debug; // if cookie undefined or debug
        if (this.getCookieValue() === undefined || debug) {
            this.setState({
                visible: true
            }); // if acceptOnScroll is set to true and (cookie is undefined or debug is set to true), add a listener.
            if (this.props.acceptOnScroll) window.addEventListener("scroll", this.handleScroll, {
                passive: true
            });
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // remove listener if still set
        this.removeScrollListener();
    } /**
   * Set a persistent accept cookie
   */ ;
    _proto.accept = function accept(acceptedByScrolling) {
        var _acceptedByScrolling;
        if (acceptedByScrolling === void 0) acceptedByScrolling = false;
        var _this$props = this.props, cookieName = _this$props.cookieName, cookieValue = _this$props.cookieValue, hideOnAccept = _this$props.hideOnAccept, onAccept = _this$props.onAccept;
        this.setCookie(cookieName, cookieValue);
        onAccept((_acceptedByScrolling = acceptedByScrolling) != null ? _acceptedByScrolling : false);
        if (hideOnAccept) {
            this.setState({
                visible: false
            });
            this.removeScrollListener();
        }
    } /**
   * Handle a click on the overlay
   */ ;
    _proto.overlayClick = function overlayClick() {
        var _this$props2 = this.props, acceptOnOverlayClick = _this$props2.acceptOnOverlayClick, onOverlayClick = _this$props2.onOverlayClick;
        if (acceptOnOverlayClick) this.accept();
        onOverlayClick();
    } /**
   * Set a persistent decline cookie
   */ ;
    _proto.decline = function decline() {
        var _this$props3 = this.props, cookieName = _this$props3.cookieName, declineCookieValue = _this$props3.declineCookieValue, hideOnDecline = _this$props3.hideOnDecline, onDecline = _this$props3.onDecline, setDeclineCookie = _this$props3.setDeclineCookie;
        if (setDeclineCookie) this.setCookie(cookieName, declineCookieValue);
        onDecline();
        if (hideOnDecline) this.setState({
            visible: false
        });
    } /**
   * Function to set the consent cookie based on the provided variables
   * Sets two cookies to handle incompatible browsers, more details:
   * https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
   */ ;
    _proto.setCookie = function setCookie(cookieName, cookieValue) {
        var _this$props4 = this.props, extraCookieOptions = _this$props4.extraCookieOptions, expires = _this$props4.expires, sameSite = _this$props4.sameSite;
        var cookieSecurity = this.props.cookieSecurity;
        if (cookieSecurity === undefined) cookieSecurity = window.location ? window.location.protocol === "https:" : true;
        var cookieOptions = $01d2b1f1c1a3ca7d$var$_extends({
            expires: expires
        }, extraCookieOptions, {
            sameSite: sameSite,
            secure: cookieSecurity
        }); // Fallback for older browsers where can not set SameSite=None,
        // SEE: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
        if (sameSite === $01d2b1f1c1a3ca7d$export$a83cc8fc1e235be1.NONE) (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).set($01d2b1f1c1a3ca7d$export$ee149ea8a5f63691(cookieName), cookieValue, cookieOptions);
         // set the regular cookie
        (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).set(cookieName, cookieValue, cookieOptions);
    } /**
   * Returns the value of the consent cookie
   * Retrieves the regular value first and if not found the legacy one according
   * to: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
   */ ;
    _proto.getCookieValue = function getCookieValue() {
        var cookieName = this.props.cookieName;
        return $01d2b1f1c1a3ca7d$export$a8e4ce6c059bdd6b(cookieName);
    };
    _proto.render = function render() {
        var _this2 = this;
        // If the bar shouldn't be visible don't render anything.
        switch(this.props.visible){
            case $01d2b1f1c1a3ca7d$export$294703df038a1b6f.HIDDEN:
                return null;
            case $01d2b1f1c1a3ca7d$export$294703df038a1b6f.BY_COOKIE_VALUE:
                if (!this.state.visible) return null;
                break;
        }
        var _this$props5 = this.props, location = _this$props5.location, style = _this$props5.style, buttonStyle = _this$props5.buttonStyle, declineButtonStyle = _this$props5.declineButtonStyle, contentStyle = _this$props5.contentStyle, disableStyles = _this$props5.disableStyles, buttonText = _this$props5.buttonText, declineButtonText = _this$props5.declineButtonText, containerClasses = _this$props5.containerClasses, contentClasses = _this$props5.contentClasses, buttonClasses = _this$props5.buttonClasses, buttonWrapperClasses = _this$props5.buttonWrapperClasses, declineButtonClasses = _this$props5.declineButtonClasses, buttonId = _this$props5.buttonId, declineButtonId = _this$props5.declineButtonId, disableButtonStyles = _this$props5.disableButtonStyles, enableDeclineButton = _this$props5.enableDeclineButton, flipButtons = _this$props5.flipButtons, ButtonComponent = _this$props5.ButtonComponent, overlay = _this$props5.overlay, overlayClasses = _this$props5.overlayClasses, overlayStyle = _this$props5.overlayStyle, ariaAcceptLabel = _this$props5.ariaAcceptLabel, ariaDeclineLabel = _this$props5.ariaDeclineLabel, customContainerAttributes = _this$props5.customContainerAttributes, customContentAttributes = _this$props5.customContentAttributes, customButtonProps = _this$props5.customButtonProps, customDeclineButtonProps = _this$props5.customDeclineButtonProps, customButtonWrapperAttributes = _this$props5.customButtonWrapperAttributes;
        var myStyle = {};
        var myButtonStyle = {};
        var myDeclineButtonStyle = {};
        var myContentStyle = {};
        var myOverlayStyle = {};
        if (disableStyles) {
            // if styles are disabled use the provided styles (or none)
            myStyle = Object.assign({}, style);
            myButtonStyle = Object.assign({}, buttonStyle);
            myDeclineButtonStyle = Object.assign({}, declineButtonStyle);
            myContentStyle = Object.assign({}, contentStyle);
            myOverlayStyle = Object.assign({}, overlayStyle);
        } else {
            // if styles aren't disabled merge them with the styles that are provided (or use default styles)
            myStyle = Object.assign({}, $01d2b1f1c1a3ca7d$var$_extends({}, this.state.style, style));
            myContentStyle = Object.assign({}, $01d2b1f1c1a3ca7d$var$_extends({}, this.state.contentStyle, contentStyle));
            myOverlayStyle = Object.assign({}, $01d2b1f1c1a3ca7d$var$_extends({}, this.state.overlayStyle, overlayStyle)); // switch to disable JUST the button styles
            if (disableButtonStyles) {
                myButtonStyle = Object.assign({}, buttonStyle);
                myDeclineButtonStyle = Object.assign({}, declineButtonStyle);
            } else {
                myButtonStyle = Object.assign({}, $01d2b1f1c1a3ca7d$var$_extends({}, this.state.buttonStyle, buttonStyle));
                myDeclineButtonStyle = Object.assign({}, $01d2b1f1c1a3ca7d$var$_extends({}, this.state.declineButtonStyle, declineButtonStyle));
            }
        } // syntactic sugar to enable user to easily select top / bottom
        switch(location){
            case $01d2b1f1c1a3ca7d$export$8eb3892b442747bd.TOP:
                myStyle.top = "0";
                break;
            case $01d2b1f1c1a3ca7d$export$8eb3892b442747bd.BOTTOM:
                myStyle.bottom = "0";
                break;
        }
        var buttonsToRender = []; // add decline button
        enableDeclineButton && buttonsToRender.push((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ButtonComponent, Object.assign({
            key: "declineButton",
            style: myDeclineButtonStyle,
            className: declineButtonClasses,
            id: declineButtonId,
            "aria-label": ariaDeclineLabel,
            onClick: function onClick() {
                _this2.decline();
            }
        }, customDeclineButtonProps), declineButtonText)); // add accept button
        buttonsToRender.push((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ButtonComponent, Object.assign({
            key: "acceptButton",
            style: myButtonStyle,
            className: buttonClasses,
            id: buttonId,
            "aria-label": ariaAcceptLabel,
            onClick: function onClick() {
                _this2.accept();
            }
        }, customButtonProps), buttonText));
        if (flipButtons) buttonsToRender.reverse();
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($01d2b1f1c1a3ca7d$export$39aecc95f0365819, {
            condition: overlay,
            wrapper: function wrapper(children) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
                    style: myOverlayStyle,
                    className: overlayClasses,
                    onClick: function onClick() {
                        _this2.overlayClick();
                    }
                }, children);
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", Object.assign({
            className: "" + containerClasses,
            style: myStyle
        }, customContainerAttributes), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", Object.assign({
            style: myContentStyle,
            className: contentClasses
        }, customContentAttributes), this.props.children), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", Object.assign({
            className: "" + buttonWrapperClasses
        }, customButtonWrapperAttributes), buttonsToRender.map(function(button) {
            return button;
        }))));
    };
    return CookieConsent;
}((0, $exYeM.Component));
$01d2b1f1c1a3ca7d$export$e06767a507a85916.defaultProps = $01d2b1f1c1a3ca7d$var$defaultCookieConsentProps;
var $01d2b1f1c1a3ca7d$export$2e2bcd8739ae039 = $01d2b1f1c1a3ca7d$export$e06767a507a85916;



// Created By James Launder
// used to reset the scroll to the top on Nav

var $exYeM = parcelRequire("exYeM");

function $b501c948585434ce$export$2e2bcd8739ae039() {
    const { pathname: pathname } = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    (0, $exYeM.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    return null;
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
function $65f63127b2f025f8$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z",
        clipRule: "evenodd"
    }));
}
const $65f63127b2f025f8$var$ForwardRef = $exYeM.forwardRef($65f63127b2f025f8$var$XMarkIcon);
var $65f63127b2f025f8$export$2e2bcd8739ae039 = $65f63127b2f025f8$var$ForwardRef;



function $120f2c20f9a06b03$export$2e2bcd8739ae039({ enabled: enabled, setEnabled: setEnabled }) {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    if (!enabled) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {});
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full h-16 sm:h-8 bg-primary text-white flex justify-center",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                className: "font-monda text-white text-sm sm:text-base px-8 sm:block hidden",
                onClick: ()=>{
                    navigate("/Pricing");
                },
                children: "FOOTPRINT LAUNCH SALE 50% off your first payment for all tiers!"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                className: "font-monda text-white text-sm sm:text-base px-8 sm:hidden block",
                onClick: ()=>{
                    navigate("/Pricing");
                },
                children: "FOOTPRINT LAUNCH SALE 50% off"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                className: "absolute sm:top-0 top-4 right-4 p-1",
                onClick: ()=>setEnabled(false),
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 text-white group-hover:text-surfaceVariant"
                })
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");






var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $965ca2171585ad7a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $965ca2171585ad7a$export$602eac185826482c = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(/*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($965ca2171585ad7a$export$602eac185826482c, {
    displayName: $965ca2171585ad7a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $965ca2171585ad7a$export$be92b6f5f03c0fe9 = $965ca2171585ad7a$export$602eac185826482c;








/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
const [$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$Collection, $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useCollection, $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)("Toast");
const [$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createToastContext, $b2f94c4ddacb0237$export$8a359da18fbc9073] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)("Toast", [
    $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createCollectionScope
]);
const [$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastProviderProvider, $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext] = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createToastContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$PROVIDER_NAME);
const $b2f94c4ddacb0237$export$f5d03d415824e0e = (props)=>{
    const { __scopeToast: __scopeToast, label: label = "Notification", duration: duration = 5000, swipeDirection: swipeDirection = "right", swipeThreshold: swipeThreshold = 50, children: children } = props;
    const [viewport, setViewport] = (0, $exYeM.useState)(null);
    const [toastCount, setToastCount] = (0, $exYeM.useState)(0);
    const isFocusedToastEscapeKeyDownRef = (0, $exYeM.useRef)(false);
    const isClosePausedRef = (0, $exYeM.useRef)(false);
    return /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0, $exYeM.useCallback)(()=>setToastCount((prevCount)=>prevCount + 1), []),
        onToastRemove: (0, $exYeM.useCallback)(()=>setToastCount((prevCount)=>prevCount - 1), []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$b2f94c4ddacb0237$export$f5d03d415824e0e.propTypes = {
    label (props) {
        if (props.label && typeof props.label === "string" && !props.label.trim()) {
            const error = `Invalid prop \`label\` supplied to \`${$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$f5d03d415824e0e, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    "F8"
];
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
const $b2f94c4ddacb0237$export$6192c2425ecfd989 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, hotkey: hotkey = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY, label: label = "Notifications ({hotkey})", ...viewportProps } = props;
    const context = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    const getItems = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useCollection(__scopeToast);
    const wrapperRef = (0, $exYeM.useRef)(null);
    const headFocusProxyRef = (0, $exYeM.useRef)(null);
    const tailFocusProxyRef = (0, $exYeM.useRef)(null);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    const hasToasts = context.toastCount > 0;
    (0, $exYeM.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key);
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        hotkey
    ]);
    (0, $exYeM.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        const viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            const handlePause = ()=>{
                if (!context.isClosePausedRef.current) {
                    const pauseEvent = new CustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            const handleResume = ()=>{
                if (context.isClosePausedRef.current) {
                    const resumeEvent = new CustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            const handleFocusOutResume = (event)=>{
                const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            const handlePointerLeaveResume = ()=>{
                const isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener("focusin", handlePause);
            wrapper.addEventListener("focusout", handleFocusOutResume);
            wrapper.addEventListener("pointermove", handlePause);
            wrapper.addEventListener("pointerleave", handlePointerLeaveResume);
            window.addEventListener("blur", handlePause);
            window.addEventListener("focus", handleResume);
            return ()=>{
                wrapper.removeEventListener("focusin", handlePause);
                wrapper.removeEventListener("focusout", handleFocusOutResume);
                wrapper.removeEventListener("pointermove", handlePause);
                wrapper.removeEventListener("pointerleave", handlePointerLeaveResume);
                window.removeEventListener("blur", handlePause);
                window.removeEventListener("focus", handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    const getSortedTabbableCandidates = (0, $exYeM.useCallback)(({ tabbingDirection: tabbingDirection })=>{
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem)=>{
            const toastNode = toastItem.ref.current;
            const toastTabbableCandidates = [
                toastNode,
                ...$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
            ];
            return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0, $exYeM.useEffect)(()=>{
        const viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            const handleKeyDown = (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === "Tab" && !isMetaKey;
                if (isTabKey) {
                    const focusedElement = document.activeElement;
                    const isTabbingBackwards = event.shiftKey;
                    const targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
                    const sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    const index = sortedCandidates.findIndex((candidate)=>candidate === focusedElement);
                    if ($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener("keydown", handleKeyDown);
            return ()=>viewport.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$aecb2ddcb55c95be), {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace("{hotkey}", hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : "none"
        }
    }, hasToasts && /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "forwards"
            });
            $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).ol, (0, $aJx1R.default)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "backwards"
            });
            $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$6192c2425ecfd989, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, onFocusFromOutsideViewport: onFocusFromOutsideViewport, ...proxyProps } = props;
    const context = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4ed20962d3818fe0$export$439d29a4e110a164), (0, $aJx1R.default)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: "fixed"
        },
        onFocus: (event)=>{
            var _context$viewport;
            const prevFocusedElement = event.relatedTarget;
            const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FocusProxy, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME = "Toast";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
const $b2f94c4ddacb0237$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, ...toastProps } = props;
    const [open = true, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastImpl, (0, $aJx1R.default)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: ()=>setOpen(false),
        onPause: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(props.onPause),
        onResume: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(props.onResume),
        onSwipeStart: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onSwipeStart, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onSwipeMove, (event)=>{
            const { x: x, y: y } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "move");
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y}px`);
        }),
        onSwipeCancel: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onSwipeCancel, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "cancel");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onSwipeEnd, (event)=>{
            const { x: x, y: y } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "end");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y}px`);
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$8d8dc7d5f743331b, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastInteractiveProvider, $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastInteractiveContext] = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createToastContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME, {
    onClose () {}
});
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, type: type = "foreground", duration: durationProp, open: open, onClose: onClose, onEscapeKeyDown: onEscapeKeyDown, onPause: onPause, onResume: onResume, onSwipeStart: onSwipeStart, onSwipeMove: onSwipeMove, onSwipeCancel: onSwipeCancel, onSwipeEnd: onSwipeEnd, ...toastProps } = props;
    const context = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [node1, setNode] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const pointerStartRef = (0, $exYeM.useRef)(null);
    const swipeDeltaRef = (0, $exYeM.useRef)(null);
    const duration1 = durationProp || context.duration;
    const closeTimerStartTimeRef = (0, $exYeM.useRef)(0);
    const closeTimerRemainingTimeRef = (0, $exYeM.useRef)(duration1);
    const closeTimerRef = (0, $exYeM.useRef)(0);
    const { onToastAdd: onToastAdd, onToastRemove: onToastRemove } = context;
    const handleClose = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(()=>{
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    const startTimer = (0, $exYeM.useCallback)((duration)=>{
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0, $exYeM.useEffect)(()=>{
        const viewport = context.viewport;
        if (viewport) {
            const handleResume = ()=>{
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            const handlePause = ()=>{
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return ()=>{
                viewport.removeEventListener($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0, $exYeM.useEffect)(()=>{
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0, $exYeM.useEffect)(()=>{
        onToastAdd();
        return ()=>onToastRemove();
    }, [
        onToastAdd,
        onToastRemove
    ]);
    const announceTextContent = (0, $exYeM.useMemo)(()=>{
        return node1 ? $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, announceTextContent && /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0, $d2lNW.createPortal)(/*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$be92b6f5f03c0fe9), {
        asChild: true,
        onEscapeKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(onEscapeKeyDown, ()=>{
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).li, (0, $aJx1R.default)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? "open" : "closed",
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: {
            userSelect: "none",
            touchAction: "none",
            ...props.style
        },
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key !== "Escape") return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (!pointerStartRef.current) return;
            const x = event.clientX - pointerStartRef.current.x;
            const y = event.clientY - pointerStartRef.current.y;
            const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            const isHorizontalSwipe = [
                "left",
                "right"
            ].includes(context.swipeDirection);
            const clamp = [
                "left",
                "up"
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            const clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            const clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
            const delta = {
                x: clampedX,
                y: clampedY
            };
            const eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerUp, (event1)=>{
            const delta = swipeDeltaRef.current;
            const target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                const toast = event1.currentTarget;
                const eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener("click", (event)=>event.preventDefault(), {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type (props) {
        if (props.type && ![
            "foreground",
            "background"
        ].includes(props.type)) {
            const error = `Invalid prop \`type\` supplied to \`${$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounce = (props)=>{
    const { __scopeToast: __scopeToast, children: children, ...announceProps } = props;
    const context = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [renderAnnounceText, setRenderAnnounceText] = (0, $exYeM.useState)(false);
    const [isAnnounced, setIsAnnounced] = (0, $exYeM.useState)(false); // render text content in the next frame to ensure toast is announced in NVDA
    $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useNextFrame(()=>setRenderAnnounceText(true)); // cleanup after announcing
    (0, $exYeM.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsAnnounced(true), 1000);
        return ()=>window.clearTimeout(timer);
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4ed20962d3818fe0$export$439d29a4e110a164), announceProps, renderAnnounceText && /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TITLE_NAME = "ToastTitle";
const $b2f94c4ddacb0237$export$16d42d7c29b95a4 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...titleProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$16d42d7c29b95a4, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$DESCRIPTION_NAME = "ToastDescription";
const $b2f94c4ddacb0237$export$ecddd96c53621d9a = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...descriptionProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$ecddd96c53621d9a, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
const $b2f94c4ddacb0237$export$3019feecfda683d2 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { altText: altText, ...actionProps } = props;
    if (!altText) return null;
    return /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$export$811e70f61c205839, (0, $aJx1R.default)({}, actionProps, {
        ref: forwardedRef
    })));
});
$b2f94c4ddacb0237$export$3019feecfda683d2.propTypes = {
    altText (props) {
        if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ACTION_NAME}\``);
        return null;
    }
};
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$3019feecfda683d2, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
const $b2f94c4ddacb0237$export$811e70f61c205839 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...closeProps } = props;
    const interactiveContext = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastInteractiveContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$811e70f61c205839, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, altText: altText, ...announceExcludeProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getAnnounceTextContent(container) {
    const textContent = [];
    const childNodes = Array.from(container.childNodes);
    childNodes.forEach((node)=>{
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isHTMLElement(node)) {
            const isHidden = node.ariaHidden || node.hidden || node.style.display === "none";
            const isExcluded = node.dataset.radixToastAnnounceExclude === "";
            if (!isHidden) {
                if (isExcluded) {
                    const altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else textContent.push(...$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getAnnounceTextContent(node));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const currentTarget = detail.originalEvent.currentTarget;
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0)=>{
    const deltaX = Math.abs(delta.x);
    const deltaY = Math.abs(delta.y);
    const isDeltaX = deltaX > deltaY;
    if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useNextFrame(callback = ()=>{}) {
    const fn = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(callback);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        let raf1 = 0;
        let raf2 = 0;
        raf1 = window.requestAnimationFrame(()=>raf2 = window.requestAnimationFrame(fn));
        return ()=>{
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
const $b2f94c4ddacb0237$export$2881499e37b75b9a = $b2f94c4ddacb0237$export$f5d03d415824e0e;
const $b2f94c4ddacb0237$export$d5c6c08dc2d3ca7 = $b2f94c4ddacb0237$export$6192c2425ecfd989;
const $b2f94c4ddacb0237$export$be92b6f5f03c0fe9 = $b2f94c4ddacb0237$export$8d8dc7d5f743331b;
const $b2f94c4ddacb0237$export$f99233281efd08a0 = $b2f94c4ddacb0237$export$16d42d7c29b95a4;
const $b2f94c4ddacb0237$export$393edc798c47379d = $b2f94c4ddacb0237$export$ecddd96c53621d9a;
const $b2f94c4ddacb0237$export$e19cd5f9376f8cee = $b2f94c4ddacb0237$export$3019feecfda683d2;
const $b2f94c4ddacb0237$export$f39c2d165cd861fe = $b2f94c4ddacb0237$export$811e70f61c205839;




var $exYeM = parcelRequire("exYeM");
function $5446b367e373134d$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
        clipRule: "evenodd"
    }));
}
const $5446b367e373134d$var$ForwardRef = $exYeM.forwardRef($5446b367e373134d$var$CheckCircleIcon);
var $5446b367e373134d$export$2e2bcd8739ae039 = $5446b367e373134d$var$ForwardRef;



const $2458c9343e33c7dd$export$f5d03d415824e0e = $b2f94c4ddacb0237$export$2881499e37b75b9a;
const $2458c9343e33c7dd$export$6192c2425ecfd989 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($b2f94c4ddacb0237$export$d5c6c08dc2d3ca7, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:right-0 sm:top-0 sm:flex-col md:max-w-[420px]", className),
        ...props
    }));
$2458c9343e33c7dd$export$6192c2425ecfd989.displayName = $b2f94c4ddacb0237$export$d5c6c08dc2d3ca7.displayName;
const $2458c9343e33c7dd$var$toastVariants = (0, $f6c488ee7ea67d84$export$87dc52566e90b739)("group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full", {
    variants: {
        variant: {
            default: "border bg-background text-foreground",
            destructive: "destructive group border-red-500 bg-surface text-black",
            success: "group border-green-500 bg-green-50 text-black",
            successV2: "group bg-white text-black flex items-center"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
const $2458c9343e33c7dd$export$8d8dc7d5f743331b = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, variant: variant, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)($b2f94c4ddacb0237$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)($2458c9343e33c7dd$var$toastVariants({
            variant: variant
        }), className),
        ...props
    });
});
$2458c9343e33c7dd$export$8d8dc7d5f743331b.displayName = $b2f94c4ddacb0237$export$be92b6f5f03c0fe9.displayName;
const $2458c9343e33c7dd$export$3019feecfda683d2 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($b2f94c4ddacb0237$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive", className),
        ...props
    }));
$2458c9343e33c7dd$export$3019feecfda683d2.displayName = $b2f94c4ddacb0237$export$e19cd5f9376f8cee.displayName;
const $2458c9343e33c7dd$export$811e70f61c205839 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($b2f94c4ddacb0237$export$f39c2d165cd861fe, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600", className),
        "toast-close": "",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
            className: "h-6 w-6"
        })
    }));
$2458c9343e33c7dd$export$811e70f61c205839.displayName = $b2f94c4ddacb0237$export$f39c2d165cd861fe.displayName;
const $2458c9343e33c7dd$export$16d42d7c29b95a4 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($b2f94c4ddacb0237$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("text-md font-semibold", className),
        ...props
    }));
$2458c9343e33c7dd$export$16d42d7c29b95a4.displayName = $b2f94c4ddacb0237$export$f99233281efd08a0.displayName;
const $2458c9343e33c7dd$export$ecddd96c53621d9a = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($b2f94c4ddacb0237$export$393edc798c47379d, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("text-md opacity-90", className),
        ...props
    }));
$2458c9343e33c7dd$export$ecddd96c53621d9a.displayName = $b2f94c4ddacb0237$export$393edc798c47379d.displayName;
function $2458c9343e33c7dd$export$2f245cd310f15a5({ title: title, description: description, ...props }) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($2458c9343e33c7dd$export$8d8dc7d5f743331b, {
        variant: "successV2",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center space-x-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5446b367e373134d$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 text-green-500"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        children: title && /*#__PURE__*/ (0, $aSiaI.jsx)($2458c9343e33c7dd$export$16d42d7c29b95a4, {
                            children: title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($2458c9343e33c7dd$export$811e70f61c205839, {})
        ]
    });
}


// Inspired by react-hot-toast library

var $exYeM = parcelRequire("exYeM");
const $37283260ab9dbfc4$var$TOAST_LIMIT = 1;
const $37283260ab9dbfc4$var$TOAST_REMOVE_DELAY = 1000000;
const $37283260ab9dbfc4$var$actionTypes = {
    ADD_TOAST: "ADD_TOAST",
    UPDATE_TOAST: "UPDATE_TOAST",
    DISMISS_TOAST: "DISMISS_TOAST",
    REMOVE_TOAST: "REMOVE_TOAST"
};
let $37283260ab9dbfc4$var$count = 0;
function $37283260ab9dbfc4$var$genId() {
    $37283260ab9dbfc4$var$count = ($37283260ab9dbfc4$var$count + 1) % Number.MAX_SAFE_INTEGER;
    return $37283260ab9dbfc4$var$count.toString();
}
const $37283260ab9dbfc4$var$toastTimeouts = new Map();
const $37283260ab9dbfc4$var$addToRemoveQueue = (toastId)=>{
    if ($37283260ab9dbfc4$var$toastTimeouts.has(toastId)) return;
    const timeout = setTimeout(()=>{
        $37283260ab9dbfc4$var$toastTimeouts.delete(toastId);
        $37283260ab9dbfc4$var$dispatch({
            type: "REMOVE_TOAST",
            toastId: toastId
        });
    }, $37283260ab9dbfc4$var$TOAST_REMOVE_DELAY);
    $37283260ab9dbfc4$var$toastTimeouts.set(toastId, timeout);
};
const $37283260ab9dbfc4$var$reducer = (state, action)=>{
    switch(action.type){
        case "ADD_TOAST":
            return {
                ...state,
                toasts: [
                    action.toast,
                    ...state.toasts
                ].slice(0, $37283260ab9dbfc4$var$TOAST_LIMIT)
            };
        case "UPDATE_TOAST":
            return {
                ...state,
                toasts: state.toasts.map((t)=>t.id === action.toast.id ? {
                        ...t,
                        ...action.toast
                    } : t)
            };
        case "DISMISS_TOAST":
            {
                const { toastId: toastId } = action;
                if (toastId) $37283260ab9dbfc4$var$addToRemoveQueue(toastId);
                else state.toasts.forEach((toast)=>{
                    $37283260ab9dbfc4$var$addToRemoveQueue(toast.id);
                });
                return {
                    ...state,
                    toasts: state.toasts.map((t)=>t.id === toastId || toastId === undefined ? {
                            ...t,
                            open: false
                        } : t)
                };
            }
        case "REMOVE_TOAST":
            if (action.toastId === undefined) return {
                ...state,
                toasts: []
            };
            return {
                ...state,
                toasts: state.toasts.filter((t)=>t.id !== action.toastId)
            };
    }
};
const $37283260ab9dbfc4$var$listeners = [];
let $37283260ab9dbfc4$var$memoryState = {
    toasts: []
};
function $37283260ab9dbfc4$var$dispatch(action) {
    $37283260ab9dbfc4$var$memoryState = $37283260ab9dbfc4$var$reducer($37283260ab9dbfc4$var$memoryState, action);
    $37283260ab9dbfc4$var$listeners.forEach((listener)=>{
        listener($37283260ab9dbfc4$var$memoryState);
    });
}
function $37283260ab9dbfc4$export$b410431fab84fa58(props) {
    const id = $37283260ab9dbfc4$var$genId();
    const update = (props)=>$37283260ab9dbfc4$var$dispatch({
            type: "UPDATE_TOAST",
            toast: {
                ...props,
                id: id
            }
        });
    const dismiss = ()=>$37283260ab9dbfc4$var$dispatch({
            type: "DISMISS_TOAST",
            toastId: id
        });
    $37283260ab9dbfc4$var$dispatch({
        type: "ADD_TOAST",
        toast: {
            ...props,
            id: id,
            open: true,
            onOpenChange: (open)=>{
                if (!open) dismiss();
            }
        }
    });
    return {
        id: id,
        dismiss: dismiss,
        update: update
    };
}
function $37283260ab9dbfc4$export$a407b657d3044108() {
    const [state, setState] = $exYeM.useState($37283260ab9dbfc4$var$memoryState);
    $exYeM.useEffect(()=>{
        $37283260ab9dbfc4$var$listeners.push(setState);
        return ()=>{
            const index = $37283260ab9dbfc4$var$listeners.indexOf(setState);
            if (index > -1) $37283260ab9dbfc4$var$listeners.splice(index, 1);
        };
    }, [
        state
    ]);
    return {
        ...state,
        toast: $37283260ab9dbfc4$export$b410431fab84fa58,
        dismiss: (toastId)=>$37283260ab9dbfc4$var$dispatch({
                type: "DISMISS_TOAST",
                toastId: toastId
            }),
        successV2: (props)=>$37283260ab9dbfc4$export$b410431fab84fa58({
                ...props,
                variant: "successV2",
                duration: props.duration || 2000
            })
    };
}


"use client";
function $8b7edcfa9205b458$export$fb98e3a2a4cd92d7() {
    const { toasts: toasts } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2458c9343e33c7dd$export$f5d03d415824e0e), {
        children: [
            toasts.map(function({ id: id, variant: variant, title: title, description: description, action: action, ...props }) {
                if (variant === "successV2") return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2458c9343e33c7dd$export$2f245cd310f15a5), {
                    title: title,
                    description: description,
                    ...props
                }, id);
                return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2458c9343e33c7dd$export$8d8dc7d5f743331b), {
                    ...props,
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "grid gap-1",
                            children: [
                                title && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2458c9343e33c7dd$export$16d42d7c29b95a4), {
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2458c9343e33c7dd$export$ecddd96c53621d9a), {
                                    children: description
                                })
                            ]
                        }),
                        action,
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2458c9343e33c7dd$export$811e70f61c205839), {})
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2458c9343e33c7dd$export$6192c2425ecfd989), {})
        ]
    });
}


function $972492a0d7f6249c$var$Root() {
    const handleDeclineCookie = ()=>{
        //remove google analytics cookies
        (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).remove("_ga_E7XCZRLHGN");
        (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).remove("_ga");
        (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).remove("_gat");
        (0, (/*@__PURE__*/$parcel$interopDefault($4cde099517bdf0a6$exports))).remove("_gid");
    };
    const [coupon, setCoupon] = (0, $exYeM.useState)(true);
    // Main screen has the nav bar, main section and footer.
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative z-0 max-w-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $120f2c20f9a06b03$export$2e2bcd8739ae039), {
                enabled: coupon,
                setEnabled: setCoupon
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b501c948585434ce$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $d48470880d35c8fc$export$88f24fd8fcfab6ca), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("header", {
                        className: "relative z-30",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6f16b426af245be2$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$910ae8079b2c2852), {}),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b7edcfa9205b458$export$fb98e3a2a4cd92d7), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("footer", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $591b4fc8950b1730$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "mx-auto px-20 rounded-lg",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $01d2b1f1c1a3ca7d$export$2e2bcd8739ae039), {
                            style: {
                                background: "#FA9173",
                                color: "#FFFFFF"
                            },
                            buttonStyle: {
                                color: "#000000",
                                borderRadius: "0.5rem",
                                backgroundColor: "#E6DCDC"
                            },
                            declineButtonStyle: {
                                color: "#000000",
                                borderRadius: "0.5rem",
                                backgroundColor: "#EF4444"
                            },
                            expires: 5,
                            enableDeclineButton: true,
                            flipButtons: true,
                            // debug={true}
                            onDecline: handleDeclineCookie,
                            children: "This website uses cookies to enhance the user experience."
                        })
                    })
                ]
            })
        ]
    });
}
var $972492a0d7f6249c$export$2e2bcd8739ae039 = $972492a0d7f6249c$var$Root;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
var $ced65f573f1e2f6e$exports = {};

$ced65f573f1e2f6e$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "query.99507992.png";



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");
var $77321b8aa25b5324$exports = {};
"use strict";
Object.defineProperty($77321b8aa25b5324$exports, Symbol.toStringTag, {
    value: "Module"
});
const $77321b8aa25b5324$var$CLASS_PART_SEPARATOR = "-";
function $77321b8aa25b5324$var$createClassUtils(config) {
    const classMap = $77321b8aa25b5324$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    function getClassGroupId(className) {
        const classParts = className.split($77321b8aa25b5324$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $77321b8aa25b5324$var$getGroupRecursive(classParts, classMap) || $77321b8aa25b5324$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $77321b8aa25b5324$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $77321b8aa25b5324$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($77321b8aa25b5324$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
}
const $77321b8aa25b5324$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $77321b8aa25b5324$var$getGroupIdForArbitraryProperty(className) {
    if ($77321b8aa25b5324$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $77321b8aa25b5324$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $77321b8aa25b5324$var$createClassMap(config) {
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $77321b8aa25b5324$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $77321b8aa25b5324$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $77321b8aa25b5324$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === "string") {
            const classPartObjectToEdit = classDefinition === "" ? classPartObject : $77321b8aa25b5324$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($77321b8aa25b5324$var$isThemeGetter(classDefinition)) {
                $77321b8aa25b5324$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $77321b8aa25b5324$var$processClassesRecursively(classGroup, $77321b8aa25b5324$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $77321b8aa25b5324$var$getPart(classPartObject, path) {
    let currentClassPartObject = classPartObject;
    path.split($77321b8aa25b5324$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $77321b8aa25b5324$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $77321b8aa25b5324$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $77321b8aa25b5324$var$createLruCache(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}
const $77321b8aa25b5324$var$IMPORTANT_MODIFIER = "!";
function $77321b8aa25b5324$var$createSplitModifiers(config) {
    const separator = config.separator;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($77321b8aa25b5324$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $77321b8aa25b5324$var$sortModifiers(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
}
function $77321b8aa25b5324$var$createConfigUtils(config) {
    return {
        cache: $77321b8aa25b5324$var$createLruCache(config.cacheSize),
        splitModifiers: $77321b8aa25b5324$var$createSplitModifiers(config),
        ...$77321b8aa25b5324$var$createClassUtils(config)
    };
}
const $77321b8aa25b5324$var$SPLIT_CLASSES_REGEX = /\s+/;
function $77321b8aa25b5324$var$mergeClassList(classList, configUtils) {
    const { splitModifiers: splitModifiers, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = new Set();
    return classList.trim().split($77321b8aa25b5324$var$SPLIT_CLASSES_REGEX).map((originalClassName)=>{
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = splitModifiers(originalClassName);
        let classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        const variantModifier = $77321b8aa25b5324$var$sortModifiers(modifiers).join(":");
        const modifierId = hasImportantModifier ? variantModifier + $77321b8aa25b5324$var$IMPORTANT_MODIFIER : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter((parsed)=>{
        if (!parsed.isTailwindClass) return true;
        const { modifierId: modifierId, classGroupId: classGroupId, hasPostfixModifier: hasPostfixModifier } = parsed;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach((group)=>classGroupsInConflict.add(modifierId + group));
        return true;
    }).reverse().map((parsed)=>parsed.originalClassName).join(" ");
}
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $77321b8aa25b5324$var$twJoin() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $77321b8aa25b5324$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $77321b8aa25b5324$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    let resolvedValue;
    let string = "";
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $77321b8aa25b5324$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $77321b8aa25b5324$var$createTailwindMerge(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $77321b8aa25b5324$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $77321b8aa25b5324$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($77321b8aa25b5324$var$twJoin.apply(null, arguments));
    };
}
function $77321b8aa25b5324$var$fromTheme(key) {
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
}
const $77321b8aa25b5324$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $77321b8aa25b5324$var$fractionRegex = /^\d+\/\d+$/;
const $77321b8aa25b5324$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
const $77321b8aa25b5324$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $77321b8aa25b5324$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $77321b8aa25b5324$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $77321b8aa25b5324$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $77321b8aa25b5324$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function $77321b8aa25b5324$var$isLength(value) {
    return $77321b8aa25b5324$var$isNumber(value) || $77321b8aa25b5324$var$stringLengths.has(value) || $77321b8aa25b5324$var$fractionRegex.test(value);
}
function $77321b8aa25b5324$var$isArbitraryLength(value) {
    return $77321b8aa25b5324$var$getIsArbitraryValue(value, "length", $77321b8aa25b5324$var$isLengthOnly);
}
function $77321b8aa25b5324$var$isNumber(value) {
    return Boolean(value) && !Number.isNaN(Number(value));
}
function $77321b8aa25b5324$var$isArbitraryNumber(value) {
    return $77321b8aa25b5324$var$getIsArbitraryValue(value, "number", $77321b8aa25b5324$var$isNumber);
}
function $77321b8aa25b5324$var$isInteger(value) {
    return Boolean(value) && Number.isInteger(Number(value));
}
function $77321b8aa25b5324$var$isPercent(value) {
    return value.endsWith("%") && $77321b8aa25b5324$var$isNumber(value.slice(0, -1));
}
function $77321b8aa25b5324$var$isArbitraryValue(value) {
    return $77321b8aa25b5324$var$arbitraryValueRegex.test(value);
}
function $77321b8aa25b5324$var$isTshirtSize(value) {
    return $77321b8aa25b5324$var$tshirtUnitRegex.test(value);
}
const $77321b8aa25b5324$var$sizeLabels = /*#__PURE__*/ new Set([
    "length",
    "size",
    "percentage"
]);
function $77321b8aa25b5324$var$isArbitrarySize(value) {
    return $77321b8aa25b5324$var$getIsArbitraryValue(value, $77321b8aa25b5324$var$sizeLabels, $77321b8aa25b5324$var$isNever);
}
function $77321b8aa25b5324$var$isArbitraryPosition(value) {
    return $77321b8aa25b5324$var$getIsArbitraryValue(value, "position", $77321b8aa25b5324$var$isNever);
}
const $77321b8aa25b5324$var$imageLabels = /*#__PURE__*/ new Set([
    "image",
    "url"
]);
function $77321b8aa25b5324$var$isArbitraryImage(value) {
    return $77321b8aa25b5324$var$getIsArbitraryValue(value, $77321b8aa25b5324$var$imageLabels, $77321b8aa25b5324$var$isImage);
}
function $77321b8aa25b5324$var$isArbitraryShadow(value) {
    return $77321b8aa25b5324$var$getIsArbitraryValue(value, "", $77321b8aa25b5324$var$isShadow);
}
function $77321b8aa25b5324$var$isAny() {
    return true;
}
function $77321b8aa25b5324$var$getIsArbitraryValue(value, label, testValue) {
    const result = $77321b8aa25b5324$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === "string" ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
}
function $77321b8aa25b5324$var$isLengthOnly(value) {
    // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    return $77321b8aa25b5324$var$lengthUnitRegex.test(value) && !$77321b8aa25b5324$var$colorFunctionRegex.test(value);
}
function $77321b8aa25b5324$var$isNever() {
    return false;
}
function $77321b8aa25b5324$var$isShadow(value) {
    return $77321b8aa25b5324$var$shadowRegex.test(value);
}
function $77321b8aa25b5324$var$isImage(value) {
    return $77321b8aa25b5324$var$imageRegex.test(value);
}
const $77321b8aa25b5324$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $77321b8aa25b5324$var$isAny,
    isArbitraryImage: $77321b8aa25b5324$var$isArbitraryImage,
    isArbitraryLength: $77321b8aa25b5324$var$isArbitraryLength,
    isArbitraryNumber: $77321b8aa25b5324$var$isArbitraryNumber,
    isArbitraryPosition: $77321b8aa25b5324$var$isArbitraryPosition,
    isArbitraryShadow: $77321b8aa25b5324$var$isArbitraryShadow,
    isArbitrarySize: $77321b8aa25b5324$var$isArbitrarySize,
    isArbitraryValue: $77321b8aa25b5324$var$isArbitraryValue,
    isInteger: $77321b8aa25b5324$var$isInteger,
    isLength: $77321b8aa25b5324$var$isLength,
    isNumber: $77321b8aa25b5324$var$isNumber,
    isPercent: $77321b8aa25b5324$var$isPercent,
    isTshirtSize: $77321b8aa25b5324$var$isTshirtSize
}, Symbol.toStringTag, {
    value: "Module"
});
function $77321b8aa25b5324$var$getDefaultConfig() {
    const colors = $77321b8aa25b5324$var$fromTheme("colors");
    const spacing = $77321b8aa25b5324$var$fromTheme("spacing");
    const blur = $77321b8aa25b5324$var$fromTheme("blur");
    const brightness = $77321b8aa25b5324$var$fromTheme("brightness");
    const borderColor = $77321b8aa25b5324$var$fromTheme("borderColor");
    const borderRadius = $77321b8aa25b5324$var$fromTheme("borderRadius");
    const borderSpacing = $77321b8aa25b5324$var$fromTheme("borderSpacing");
    const borderWidth = $77321b8aa25b5324$var$fromTheme("borderWidth");
    const contrast = $77321b8aa25b5324$var$fromTheme("contrast");
    const grayscale = $77321b8aa25b5324$var$fromTheme("grayscale");
    const hueRotate = $77321b8aa25b5324$var$fromTheme("hueRotate");
    const invert = $77321b8aa25b5324$var$fromTheme("invert");
    const gap = $77321b8aa25b5324$var$fromTheme("gap");
    const gradientColorStops = $77321b8aa25b5324$var$fromTheme("gradientColorStops");
    const gradientColorStopPositions = $77321b8aa25b5324$var$fromTheme("gradientColorStopPositions");
    const inset = $77321b8aa25b5324$var$fromTheme("inset");
    const margin = $77321b8aa25b5324$var$fromTheme("margin");
    const opacity = $77321b8aa25b5324$var$fromTheme("opacity");
    const padding = $77321b8aa25b5324$var$fromTheme("padding");
    const saturate = $77321b8aa25b5324$var$fromTheme("saturate");
    const scale = $77321b8aa25b5324$var$fromTheme("scale");
    const sepia = $77321b8aa25b5324$var$fromTheme("sepia");
    const skew = $77321b8aa25b5324$var$fromTheme("skew");
    const space = $77321b8aa25b5324$var$fromTheme("space");
    const translate = $77321b8aa25b5324$var$fromTheme("translate");
    const getOverscroll = ()=>[
            "auto",
            "contain",
            "none"
        ];
    const getOverflow = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            "auto",
            $77321b8aa25b5324$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $77321b8aa25b5324$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            "",
            $77321b8aa25b5324$var$isLength,
            $77321b8aa25b5324$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            "auto",
            $77321b8aa25b5324$var$isNumber,
            $77321b8aa25b5324$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    const getLineStyles = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    const getBlendModes = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ];
    const getAlign = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    const getZeroAndEmpty = ()=>[
            "",
            "0",
            $77321b8aa25b5324$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    const getNumber = ()=>[
            $77321b8aa25b5324$var$isNumber,
            $77321b8aa25b5324$var$isArbitraryNumber
        ];
    const getNumberAndArbitrary = ()=>[
            $77321b8aa25b5324$var$isNumber,
            $77321b8aa25b5324$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ":",
        theme: {
            colors: [
                $77321b8aa25b5324$var$isAny
            ],
            spacing: [
                $77321b8aa25b5324$var$isLength,
                $77321b8aa25b5324$var$isArbitraryLength
            ],
            blur: [
                "none",
                "",
                $77321b8aa25b5324$var$isTshirtSize,
                $77321b8aa25b5324$var$isArbitraryValue
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                $77321b8aa25b5324$var$isTshirtSize,
                $77321b8aa25b5324$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $77321b8aa25b5324$var$isPercent,
                $77321b8aa25b5324$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $77321b8aa25b5324$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [
                        ...getPositions(),
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        $77321b8aa25b5324$var$isInteger,
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        $77321b8aa25b5324$var$isInteger,
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        $77321b8aa25b5324$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                $77321b8aa25b5324$var$isInteger,
                                $77321b8aa25b5324$var$isArbitraryValue
                            ]
                        },
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        $77321b8aa25b5324$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                $77321b8aa25b5324$var$isInteger,
                                $77321b8aa25b5324$var$isArbitraryValue
                            ]
                        },
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal",
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal",
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [
                        ...getAlign(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svw",
                        "lvw",
                        "dvw",
                        $77321b8aa25b5324$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        $77321b8aa25b5324$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        $77321b8aa25b5324$var$isArbitraryValue,
                        spacing,
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                $77321b8aa25b5324$var$isTshirtSize
                            ]
                        },
                        $77321b8aa25b5324$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $77321b8aa25b5324$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        $77321b8aa25b5324$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        $77321b8aa25b5324$var$isArbitraryValue,
                        spacing,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $77321b8aa25b5324$var$isArbitraryValue,
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        $77321b8aa25b5324$var$isTshirtSize,
                        $77321b8aa25b5324$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        $77321b8aa25b5324$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        $77321b8aa25b5324$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        $77321b8aa25b5324$var$isNumber,
                        $77321b8aa25b5324$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        $77321b8aa25b5324$var$isLength,
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [
                        ...getLineStyles(),
                        "wavy"
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        $77321b8aa25b5324$var$isLength,
                        $77321b8aa25b5324$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        $77321b8aa25b5324$var$isLength,
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [
                        ...getPositions(),
                        $77321b8aa25b5324$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        $77321b8aa25b5324$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        $77321b8aa25b5324$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [
                        ...getLineStyles(),
                        "hidden"
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        "",
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        $77321b8aa25b5324$var$isLength,
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        $77321b8aa25b5324$var$isLength,
                        $77321b8aa25b5324$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        $77321b8aa25b5324$var$isLength,
                        $77321b8aa25b5324$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        $77321b8aa25b5324$var$isTshirtSize,
                        $77321b8aa25b5324$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        $77321b8aa25b5324$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": [
                        ...getBlendModes(),
                        "plus-lighter",
                        "plus-darker"
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        $77321b8aa25b5324$var$isTshirtSize,
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $77321b8aa25b5324$var$isInteger,
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $77321b8aa25b5324$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        $77321b8aa25b5324$var$isLength,
                        $77321b8aa25b5324$var$isArbitraryLength,
                        $77321b8aa25b5324$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ function $77321b8aa25b5324$var$mergeConfigs(baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, extend: extend = {}, override: override = {} }) {
    $77321b8aa25b5324$var$overrideProperty(baseConfig, "cacheSize", cacheSize);
    $77321b8aa25b5324$var$overrideProperty(baseConfig, "prefix", prefix);
    $77321b8aa25b5324$var$overrideProperty(baseConfig, "separator", separator);
    for(const configKey in override)$77321b8aa25b5324$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$77321b8aa25b5324$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
}
function $77321b8aa25b5324$var$overrideProperty(baseObject, overrideKey, overrideValue) {
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
}
function $77321b8aa25b5324$var$overrideConfigProperties(baseObject, overrideObject) {
    if (overrideObject) for(const key in overrideObject)$77321b8aa25b5324$var$overrideProperty(baseObject, key, overrideObject[key]);
}
function $77321b8aa25b5324$var$mergeConfigProperties(baseObject, mergeObject) {
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
}
function $77321b8aa25b5324$var$extendTailwindMerge(configExtension, ...createConfig) {
    return typeof configExtension === "function" ? $77321b8aa25b5324$var$createTailwindMerge($77321b8aa25b5324$var$getDefaultConfig, configExtension, ...createConfig) : $77321b8aa25b5324$var$createTailwindMerge(()=>$77321b8aa25b5324$var$mergeConfigs($77321b8aa25b5324$var$getDefaultConfig(), configExtension), ...createConfig);
}
const $77321b8aa25b5324$var$twMerge = /*#__PURE__*/ $77321b8aa25b5324$var$createTailwindMerge($77321b8aa25b5324$var$getDefaultConfig);
$77321b8aa25b5324$exports.createTailwindMerge = $77321b8aa25b5324$var$createTailwindMerge;
$77321b8aa25b5324$exports.extendTailwindMerge = $77321b8aa25b5324$var$extendTailwindMerge;
$77321b8aa25b5324$exports.fromTheme = $77321b8aa25b5324$var$fromTheme;
$77321b8aa25b5324$exports.getDefaultConfig = $77321b8aa25b5324$var$getDefaultConfig;
$77321b8aa25b5324$exports.mergeConfigs = $77321b8aa25b5324$var$mergeConfigs;
$77321b8aa25b5324$exports.twJoin = $77321b8aa25b5324$var$twJoin;
$77321b8aa25b5324$exports.twMerge = $77321b8aa25b5324$var$twMerge;
$77321b8aa25b5324$exports.validators = $77321b8aa25b5324$var$validators;


function $ff07379829b191ac$export$1343a74baacb0543(...inputs) {
    return (0, $77321b8aa25b5324$exports.twMerge)((0, $4qr5a.default)(inputs));
}


const $bf340fcd35780694$var$BorderBeam = ({ className: className, size: size = 200, duration: duration = 15, anchor: anchor = 90, borderWidth: borderWidth = 1.5, colorFrom: colorFrom = "#ffaa40", colorTo: colorTo = "#9c40ff", delay: delay = 0 })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        style: {
            "--size": size,
            "--duration": duration,
            "--anchor": anchor,
            "--border-width": borderWidth,
            "--color-from": colorFrom,
            "--color-to": colorTo,
            "--delay": `-${delay}s`
        },
        className: (0, $ff07379829b191ac$export$1343a74baacb0543)("pointer-events-none absolute inset-0 rounded-[inherit] [border:calc(var(--border-width)*1px)_solid_transparent]", // mask styles
        "![mask-clip:padding-box,border-box] ![mask-composite:intersect] [mask:linear-gradient(transparent,transparent),linear-gradient(white,white)]", // pseudo styles
        "after:absolute after:aspect-square after:w-[calc(var(--size)*1px)] after:animate-border-beam after:[animation-delay:var(--delay)] after:[background:linear-gradient(to_left,var(--color-from),var(--color-to),transparent)] after:[offset-anchor:calc(var(--anchor)*1%)_50%] after:[offset-path:rect(0_auto_auto_0_round_calc(var(--size)*1px))]", className)
    });
};
var $bf340fcd35780694$export$2e2bcd8739ae039 = $bf340fcd35780694$var$BorderBeam;


const $3ac8698b5e8ca48d$var$BORDER_BEAM_CONFIG = {
    size: 450,
    duration: 12,
    colorFrom: "#FF6B35",
    colorTo: "#FF8C61",
    borderWidth: 2
};
const $3ac8698b5e8ca48d$var$ImagePlaceholder = "https://via.placeholder.com/1280x720?text=Image+Not+Found";
const $3ac8698b5e8ca48d$var$OptimizedImage = /*#__PURE__*/ (0, $exYeM.memo)(({ src: src, alt: alt, className: className, width: width, height: height })=>{
    const [imageSrc, setImageSrc] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(src);
    const handleError = ()=>{
        setImageSrc($3ac8698b5e8ca48d$var$ImagePlaceholder);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
        src: imageSrc,
        alt: alt,
        width: width,
        height: height,
        className: className,
        onError: handleError
    });
});
$3ac8698b5e8ca48d$var$OptimizedImage.displayName = "OptimizedImage";
const $3ac8698b5e8ca48d$var$BeamContainer = /*#__PURE__*/ (0, $exYeM.memo)(({ children: children })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "relative rounded-2xl bg-white/80 backdrop-blur-md shadow-xl min-h-[300px] sm:min-h-[400px] md:min-h-[600px] lg:min-h-[800px] max-w-[1280px] mx-auto",
        children: children
    }));
$3ac8698b5e8ca48d$var$BeamContainer.displayName = "BeamContainer";
const $3ac8698b5e8ca48d$var$PrimaryFeatures = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("section", {
        className: "relative overflow-hidden pb-10",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "container mx-auto px-4 relative z-10",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)($3ac8698b5e8ca48d$var$BeamContainer, {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bf340fcd35780694$export$2e2bcd8739ae039), {
                        ...$3ac8698b5e8ca48d$var$BORDER_BEAM_CONFIG,
                        delay: 0,
                        anchor: 0,
                        style: {
                            zIndex: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bf340fcd35780694$export$2e2bcd8739ae039), {
                        ...$3ac8698b5e8ca48d$var$BORDER_BEAM_CONFIG,
                        delay: 7,
                        anchor: 100,
                        style: {
                            zIndex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative z-10 w-full h-full rounded-xl overflow-hidden p-2",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)($3ac8698b5e8ca48d$var$OptimizedImage, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ced65f573f1e2f6e$exports))),
                            alt: "Alpha",
                            className: "w-full h-full object-cover",
                            width: 1884,
                            height: 916
                        })
                    })
                ]
            })
        })
    });
};
var $3ac8698b5e8ca48d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $exYeM.memo)($3ac8698b5e8ca48d$var$PrimaryFeatures);



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $788049de1171759f$var$ArrowSmallRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M3.75 12a.75.75 0 01.75-.75h13.19l-5.47-5.47a.75.75 0 011.06-1.06l6.75 6.75a.75.75 0 010 1.06l-6.75 6.75a.75.75 0 11-1.06-1.06l5.47-5.47H4.5a.75.75 0 01-.75-.75z",
        clipRule: "evenodd"
    }));
}
const $788049de1171759f$var$ForwardRef = $exYeM.forwardRef($788049de1171759f$var$ArrowSmallRightIcon);
var $788049de1171759f$export$2e2bcd8739ae039 = $788049de1171759f$var$ForwardRef;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * @public
 */ const $2d642de93cca1124$export$22a697fb29aac98d = (0, $exYeM.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $exYeM = parcelRequire("exYeM");
const $9a6e4e852eb4f373$export$2285bbca2c666415 = (0, $exYeM.createContext)({});



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * @public
 */ const $32835478aabc17b5$export$f224e4635b6f8ce2 = (0, $exYeM.createContext)(null);




var $exYeM = parcelRequire("exYeM");
const $c763d68aeba74b31$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $0e2d049f2abcd2c9$export$700979bc83e7db82 = (0, $c763d68aeba74b31$export$4e09c449d6c407f7) ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);



var $exYeM = parcelRequire("exYeM");
const $1cdfc9563e072a56$export$40f10139ecf1f171 = (0, $exYeM.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $ccc055b4a72c1347$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $99c2b47e65be39f1$export$ed7b8fa9dbf0105d = "framerAppearId";
const $99c2b47e65be39f1$export$8592e1c077c890a6 = "data-" + (0, $ccc055b4a72c1347$export$9fd24a634729c672)($99c2b47e65be39f1$export$ed7b8fa9dbf0105d);


const $3cdabdabfda62d22$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


class $734cfe98781f7335$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $734cfe98781f7335$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $734cfe98781f7335$var$Queue();
    let nextFrame = new $734cfe98781f7335$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
                callback(frameData);
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $2c4ecd0dc095867d$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $2c4ecd0dc095867d$var$maxElapsed = 40;
function $2c4ecd0dc095867d$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $2c4ecd0dc095867d$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $734cfe98781f7335$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>{
        steps[stepId].process(state);
    };
    const processBatch = ()=>{
        const timestamp = (0, $3cdabdabfda62d22$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $2c4ecd0dc095867d$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $2c4ecd0dc095867d$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $2c4ecd0dc095867d$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$2c4ecd0dc095867d$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $a1ef008917ac1826$export$bb76eed83315504c, cancel: $a1ef008917ac1826$export$3252729004b8456e } = (0, $2c4ecd0dc095867d$export$510b0596a933801a)(queueMicrotask, false);


function $7be42aa7b9b2349b$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



var $exYeM = parcelRequire("exYeM");
/**
 * Internal, exported only for usage in Framer
 */ const $df9c3e45a16d5ebc$export$da5f7b802957459a = (0, $exYeM.createContext)({});


let $d1d2872af74835eb$var$scheduleHandoffComplete = false;
function $d1d2872af74835eb$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $exYeM.useContext)((0, $9a6e4e852eb4f373$export$2285bbca2c666415));
    const lazyContext = (0, $exYeM.useContext)((0, $1cdfc9563e072a56$export$40f10139ecf1f171));
    const presenceContext = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $exYeM.useContext)((0, $2d642de93cca1124$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $exYeM.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $exYeM.useContext)((0, $df9c3e45a16d5ebc$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $d1d2872af74835eb$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $exYeM.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $exYeM.useRef)(Boolean(props[0, $99c2b47e65be39f1$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $0e2d049f2abcd2c9$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $a1ef008917ac1826$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $exYeM.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            if (!$d1d2872af74835eb$var$scheduleHandoffComplete) {
                $d1d2872af74835eb$var$scheduleHandoffComplete = true;
                queueMicrotask($d1d2872af74835eb$var$completeHandoff);
            }
        }
    });
    return visualElement;
}
function $d1d2872af74835eb$var$completeHandoff() {
    window.HandoffComplete = true;
}
function $d1d2872af74835eb$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $d1d2872af74835eb$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: ()=>visualElement.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $d1d2872af74835eb$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $d1d2872af74835eb$var$getClosestProjectingNode(visualElement.parent);
}



var $exYeM = parcelRequire("exYeM");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $3e0b35cdea07cd56$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $exYeM.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $exYeM = parcelRequire("exYeM");

/**
 * Decides if the supplied variable is variant label
 */ function $a36779356b36fa8a$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $0c915d7372d9814d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $46d8d186c05e43b0$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $46d8d186c05e43b0$export$1405a65085f40b9 = [
    "initial",
    ...$46d8d186c05e43b0$export$16e45afcc206d3a8
];


function $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d(props) {
    return (0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(props.animate) || (0, $46d8d186c05e43b0$export$1405a65085f40b9).some((name)=>(0, $a36779356b36fa8a$export$720b90e312cea233)(props[name]));
}
function $6d3c07e99f9f7e5a$export$ce46fa4165cdec40(props) {
    return Boolean($6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $d9dc1d37927f1414$export$12fc32fc096a04a3(props, context) {
    if ((0, $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a36779356b36fa8a$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a36779356b36fa8a$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $1fba5faa46b4b8c9$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $d9dc1d37927f1414$export$12fc32fc096a04a3)(props, (0, $exYeM.useContext)((0, $9a6e4e852eb4f373$export$2285bbca2c666415)));
    return (0, $exYeM.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $1fba5faa46b4b8c9$var$variantLabelsAsDependency(initial),
        $1fba5faa46b4b8c9$var$variantLabelsAsDependency(animate)
    ]);
}
function $1fba5faa46b4b8c9$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $f7fe4e10b799a8b2$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $f7fe4e10b799a8b2$export$65570e08d843624d = {};
for(const key in $f7fe4e10b799a8b2$var$featureProps)$f7fe4e10b799a8b2$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$f7fe4e10b799a8b2$var$featureProps[key].some((name)=>!!props[name])
};


function $ffc510cd2c0997fc$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $f7fe4e10b799a8b2$export$65570e08d843624d)[key] = {
        ...(0, $f7fe4e10b799a8b2$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $exYeM = parcelRequire("exYeM");
const $0d8fa753a19a110b$export$a3579ca508007a95 = (0, $exYeM.createContext)({});



const $352246c6734b361d$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $002ee5308395fa07$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $ffc510cd2c0997fc$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $exYeM.useContext)((0, $2d642de93cca1124$export$22a697fb29aac98d)),
            ...props,
            layoutId: $002ee5308395fa07$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $1fba5faa46b4b8c9$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $c763d68aeba74b31$export$4e09c449d6c407f7)) {
            $002ee5308395fa07$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $002ee5308395fa07$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $d1d2872af74835eb$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $aSiaI.jsxs)((0, $9a6e4e852eb4f373$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $aSiaI.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $3e0b35cdea07cd56$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefComponent = (0, $exYeM.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $352246c6734b361d$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $002ee5308395fa07$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $exYeM.useContext)((0, $0d8fa753a19a110b$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $002ee5308395fa07$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $exYeM.useContext)((0, $1cdfc9563e072a56$export$40f10139ecf1f171)).strict;
}
function $002ee5308395fa07$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $f7fe4e10b799a8b2$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $6b2ebacab9b54f79$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $002ee5308395fa07$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $3382724af6d1489a$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $9c5a7490b01b42fd$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $3382724af6d1489a$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
const $93099dc5c3aa7524$export$91ddd985b97788d1 = {};
function $93099dc5c3aa7524$export$de9e7791c71225fd(correctors) {
    Object.assign($93099dc5c3aa7524$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $da211e07316d6e39$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $da211e07316d6e39$export$7b42a0094fb00b6e = new Set($da211e07316d6e39$export$280dc01950909d86);


function $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $93099dc5c3aa7524$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $65e8d3d378a9947e$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $9384da345cfe955b$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $9384da345cfe955b$var$numTransforms = (0, $da211e07316d6e39$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $9384da345cfe955b$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $9384da345cfe955b$var$numTransforms; i++){
        const key = (0, $da211e07316d6e39$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $9384da345cfe955b$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $7788fac55eb8bc79$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $7788fac55eb8bc79$export$9de1236619d9e756 = $7788fac55eb8bc79$var$checkStringStartsWith("--");
const $7788fac55eb8bc79$var$startsAsVariableToken = $7788fac55eb8bc79$var$checkStringStartsWith("var(--");
const $7788fac55eb8bc79$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $7788fac55eb8bc79$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $7788fac55eb8bc79$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $7788fac55eb8bc79$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $6a51529d989adf9c$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $b55556710a8b54c0$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $3b3d1d8d17c11467$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $3b3d1d8d17c11467$export$58f0f39f63f3cf42 = {
    ...$3b3d1d8d17c11467$export$98e628dec113755e,
    transform: (v)=>(0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $3b3d1d8d17c11467$export$dcdf75081b88279d = {
    ...$3b3d1d8d17c11467$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $eb49388da280e24f$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $eb49388da280e24f$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $eb49388da280e24f$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $eb49388da280e24f$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $eb49388da280e24f$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $e8f3e6c5adc69edc$var$createUnitType = (unit)=>({
        test: (v)=>(0, $eb49388da280e24f$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $e8f3e6c5adc69edc$export$41fc368e1a942b97 = $e8f3e6c5adc69edc$var$createUnitType("deg");
const $e8f3e6c5adc69edc$export$626336c2cd4b14de = $e8f3e6c5adc69edc$var$createUnitType("%");
const $e8f3e6c5adc69edc$export$91c0eda1d06bf008 = $e8f3e6c5adc69edc$var$createUnitType("px");
const $e8f3e6c5adc69edc$export$f91e8c45a95a32f2 = $e8f3e6c5adc69edc$var$createUnitType("vh");
const $e8f3e6c5adc69edc$export$aed3d7b7d206c196 = $e8f3e6c5adc69edc$var$createUnitType("vw");
const $e8f3e6c5adc69edc$export$44e2e1705876d7ed = {
    ...$e8f3e6c5adc69edc$export$626336c2cd4b14de,
    parse: (v)=>$e8f3e6c5adc69edc$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$e8f3e6c5adc69edc$export$626336c2cd4b14de.transform(v * 100)
};



const $d16ea4f0603eeb66$export$7d260a2a5f8bc19e = {
    ...(0, $3b3d1d8d17c11467$export$98e628dec113755e),
    transform: Math.round
};


const $0d74cfa63198be03$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderTopWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderRightWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    radius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    maxWidth: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    height: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    maxHeight: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    size: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    top: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    right: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    bottom: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    left: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    paddingTop: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    paddingRight: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    paddingBottom: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    paddingLeft: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    margin: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    marginTop: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    marginRight: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    marginBottom: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    marginLeft: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    rotateX: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    rotateY: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    rotateZ: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    scale: $3b3d1d8d17c11467$export$dcdf75081b88279d,
    scaleX: (0, $3b3d1d8d17c11467$export$dcdf75081b88279d),
    scaleY: (0, $3b3d1d8d17c11467$export$dcdf75081b88279d),
    scaleZ: (0, $3b3d1d8d17c11467$export$dcdf75081b88279d),
    skew: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    skewX: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    skewY: (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    distance: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    translateX: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    translateY: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    translateZ: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    x: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    y: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    z: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    perspective: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    transformPerspective: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    opacity: (0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42),
    originX: (0, $e8f3e6c5adc69edc$export$44e2e1705876d7ed),
    originY: (0, $e8f3e6c5adc69edc$export$44e2e1705876d7ed),
    originZ: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $d16ea4f0603eeb66$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42),
    numOctaves: (0, $d16ea4f0603eeb66$export$7d260a2a5f8bc19e)
};


function $d5a7ccaf3657bbce$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $7788fac55eb8bc79$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $0d74cfa63198be03$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $6a51529d989adf9c$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $9384da345cfe955b$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $43cb856997daead8$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $582c92f88e1a1e68$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $65e8d3d378a9947e$export$605d60a2578142d3)(source[key]) && !(0, $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $582c92f88e1a1e68$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $exYeM.useMemo)(()=>{
        const state = (0, $43cb856997daead8$export$8940b483cf52eeda)();
        (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $582c92f88e1a1e68$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $582c92f88e1a1e68$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $582c92f88e1a1e68$var$useInitialMotionValues(props, visualState, isStatic));
    return style;
}
function $582c92f88e1a1e68$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $582c92f88e1a1e68$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $1f4002463fc06750$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $1f4002463fc06750$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $1f4002463fc06750$var$validMotionProps.has(key);
}


let $a52b0ca54619c60e$var$shouldForward = (key)=>!(0, $1f4002463fc06750$export$2f9c46555243bf04)(key);
function $a52b0ca54619c60e$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $a52b0ca54619c60e$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $1f4002463fc06750$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $a52b0ca54619c60e$export$59d6962c470509a5($a52b0ca54619c60e$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $a52b0ca54619c60e$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($a52b0ca54619c60e$var$shouldForward(key) || forwardMotionProps === true && (0, $1f4002463fc06750$export$2f9c46555243bf04)(key) || !isDom && !(0, $1f4002463fc06750$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $exYeM = parcelRequire("exYeM");



function $de9ca7d9f74b1dc4$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $de9ca7d9f74b1dc4$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $de9ca7d9f74b1dc4$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $de9ca7d9f74b1dc4$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $ecef2446ddaf0120$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $ecef2446ddaf0120$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $ecef2446ddaf0120$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $ecef2446ddaf0120$var$dashKeys : $ecef2446ddaf0120$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $22afbc6679b4fb16$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $de9ca7d9f74b1dc4$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $ecef2446ddaf0120$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $93153305d91bad5b$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $43cb856997daead8$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $e49695f00398c04d$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $678da409a301bad8$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $exYeM.useMemo)(()=>{
        const state = (0, $93153305d91bad5b$export$41be8b43e1c4d4f9)();
        (0, $22afbc6679b4fb16$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $e49695f00398c04d$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $582c92f88e1a1e68$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $9f5d406889886ff1$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? (0, $678da409a301bad8$export$84309c4f53cb1bd5) : (0, $582c92f88e1a1e68$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $a52b0ca54619c60e$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $exYeM.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $exYeM.useMemo)(()=>(0, $65e8d3d378a9947e$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $exYeM.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $4d3a9c3652fbcbe3$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $53f5831d8ff6fe26$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $6ecc69af052e005d$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $4d3a9c3652fbcbe3$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $53f5831d8ff6fe26$export$28931db5d57958e5).has(key) ? (0, $ccc055b4a72c1347$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $e87aa36d3552d0b1$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $65e8d3d378a9947e$export$605d60a2578142d3)(prevProps.style[key]) || (0, $57cc9ca03e37ffaf$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}



function $4c74588f3910fe04$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $e87aa36d3552d0b1$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(props[key]) || (0, $65e8d3d378a9947e$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $da211e07316d6e39$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $exYeM = parcelRequire("exYeM");


function $1527d424ce16b34c$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $1527d424ce16b34c$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $1527d424ce16b34c$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $1527d424ce16b34c$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}



var $exYeM = parcelRequire("exYeM");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $73d7e626f45c1838$export$fe4300aa8eebea86(init) {
    const ref = (0, $exYeM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $6f683bc80c6d969e$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $0d15acf980467e42$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $0d15acf980467e42$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $a6687c7d507e2d36$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $0d15acf980467e42$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $30ccd5a4894de23b$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $30ccd5a4894de23b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $30ccd5a4894de23b$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $exYeM.useContext)((0, $9a6e4e852eb4f373$export$2285bbca2c666415));
        const presenceContext = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
        const make = ()=>$30ccd5a4894de23b$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $73d7e626f45c1838$export$fe4300aa8eebea86)(make);
    };
function $30ccd5a4894de23b$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $6d3c07e99f9f7e5a$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $1527d424ce16b34c$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $001eda3aa79c6ebe$export$8793edee2d425525 = (any)=>any;



const { schedule: $301e135f87ffeb5c$export$2cef06c20297c17d, cancel: $301e135f87ffeb5c$export$ec99c0ef4978dccb, state: $301e135f87ffeb5c$export$fff89137e9e818ce, steps: $301e135f87ffeb5c$export$be3f796aed065412 } = (0, $2c4ecd0dc095867d$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $001eda3aa79c6ebe$export$8793edee2d425525), true);


const $a38e3c634edf90c1$export$44dabd3fae512e85 = {
    useVisualState: (0, $30ccd5a4894de23b$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $4c74588f3910fe04$export$16da615486abaa45),
        createRenderState: (0, $93153305d91bad5b$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $301e135f87ffeb5c$export$2cef06c20297c17d).render(()=>{
                (0, $22afbc6679b4fb16$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $e49695f00398c04d$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $6ecc69af052e005d$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $7e738ddebc5e1ace$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $30ccd5a4894de23b$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $e87aa36d3552d0b1$export$16da615486abaa45,
        createRenderState: (0, $43cb856997daead8$export$8940b483cf52eeda)
    })
};


function $e939d64425c6240c$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? (0, $a38e3c634edf90c1$export$44dabd3fae512e85) : (0, $7e738ddebc5e1ace$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $9f5d406889886ff1$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $a8c57a49f398792d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $5332f0d6324f3440$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $19290b72856733e8$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $19290b72856733e8$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $5332f0d6324f3440$export$a4cf9c8a4b063a6e)(event) && handler(event, $19290b72856733e8$export$12f84bb882d06e1a(event));
};


function $a3b5ca0718993d16$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(target, eventName, (0, $19290b72856733e8$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $3e3ea55737c24d5c$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $3e3ea55737c24d5c$export$a4627e546088548d = (...transformers)=>transformers.reduce($3e3ea55737c24d5c$var$combineFunctions);


function $96522e0a3b96b9e4$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $96522e0a3b96b9e4$var$globalHorizontalLock = $96522e0a3b96b9e4$export$518c5fc2dcb7974b("dragHorizontal");
const $96522e0a3b96b9e4$var$globalVerticalLock = $96522e0a3b96b9e4$export$518c5fc2dcb7974b("dragVertical");
function $96522e0a3b96b9e4$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $96522e0a3b96b9e4$var$globalVerticalLock();
    else if (drag === "x") lock = $96522e0a3b96b9e4$var$globalHorizontalLock();
    else {
        const openHorizontal = $96522e0a3b96b9e4$var$globalHorizontalLock();
        const openVertical = $96522e0a3b96b9e4$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $96522e0a3b96b9e4$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $96522e0a3b96b9e4$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $c280630d94a7df00$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $4eb998171579f70f$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $96522e0a3b96b9e4$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $4eb998171579f70f$export$93a81ea037eac456 extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $3e3ea55737c24d5c$export$a4627e546088548d)($4eb998171579f70f$var$addHoverEvent(this.node, true), $4eb998171579f70f$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $f67fa3b39a62de2d$export$d4826db40d47595b extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $3e3ea55737c24d5c$export$a4627e546088548d)((0, $a8c57a49f398792d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $67a7f133a245336d$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $67a7f133a245336d$export$e841ada32ff745b(parent, child.parentElement);
};




function $b8443dc0347df040$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $19290b72856733e8$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $b8443dc0347df040$export$f026abdbba7f0c9e extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $001eda3aa79c6ebe$export$8793edee2d425525);
        this.removeEndListeners = (0, $001eda3aa79c6ebe$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $001eda3aa79c6ebe$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $67a7f133a245336d$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $3e3ea55737c24d5c$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b8443dc0347df040$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $b8443dc0347df040$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b8443dc0347df040$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $3e3ea55737c24d5c$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $96522e0a3b96b9e4$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $3e3ea55737c24d5c$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $6e6be83e8d5cf4f5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $6e6be83e8d5cf4f5$var$observers = new WeakMap();
const $6e6be83e8d5cf4f5$var$fireObserverCallback = (entry)=>{
    const callback = $6e6be83e8d5cf4f5$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $6e6be83e8d5cf4f5$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($6e6be83e8d5cf4f5$var$fireObserverCallback);
};
function $6e6be83e8d5cf4f5$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$6e6be83e8d5cf4f5$var$observers.has(lookupRoot)) $6e6be83e8d5cf4f5$var$observers.set(lookupRoot, {});
    const rootObservers = $6e6be83e8d5cf4f5$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($6e6be83e8d5cf4f5$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $6e6be83e8d5cf4f5$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $6e6be83e8d5cf4f5$var$initIntersectionObserver(options);
    $6e6be83e8d5cf4f5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $6e6be83e8d5cf4f5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $da2908b1137e754a$var$thresholdNames = {
    some: 0,
    all: 1
};
class $da2908b1137e754a$export$150851c8cc2f0c72 extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $da2908b1137e754a$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $6e6be83e8d5cf4f5$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($da2908b1137e754a$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $da2908b1137e754a$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $60b1baafc37a77f3$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $da2908b1137e754a$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b8443dc0347df040$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $f67fa3b39a62de2d$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $4eb998171579f70f$export$93a81ea037eac456)
    }
};





function $423df1fac2a0b98a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




function $730ab9aa0424fb5a$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $1527d424ce16b34c$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}





/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $bfda710cf857a073$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $bfda710cf857a073$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $d51b9411f6ccbbd1$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $d51b9411f6ccbbd1$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $d51b9411f6ccbbd1$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $d51b9411f6ccbbd1$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $d51b9411f6ccbbd1$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $d51b9411f6ccbbd1$var$keyframesTransition;
    else if ((0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $d51b9411f6ccbbd1$var$criticallyDampedSpring(keyframes[1]) : $d51b9411f6ccbbd1$var$underDampedSpring;
    return $d51b9411f6ccbbd1$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $1d127c5bbdfabc9c$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $1d127c5bbdfabc9c$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $f006002175d4313e$export$888a3d84909f9e3d = {
    current: false
};


const $511bcb3f09b5d5d2$var$isNotNull = (value)=>value !== null;
function $511bcb3f09b5d5d2$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($511bcb3f09b5d5d2$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





let $960d9779faf6f40c$var$now;
function $960d9779faf6f40c$var$clearTime() {
    $960d9779faf6f40c$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $960d9779faf6f40c$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($960d9779faf6f40c$var$now === undefined) $960d9779faf6f40c$export$2da9be4cfdb689b1.set((0, $301e135f87ffeb5c$export$fff89137e9e818ce).isProcessing || (0, $3cdabdabfda62d22$export$dd826089e3c5e502).useManualTiming ? (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp : performance.now());
        return $960d9779faf6f40c$var$now;
    },
    set: (newTime)=>{
        $960d9779faf6f40c$var$now = newTime;
        queueMicrotask($960d9779faf6f40c$var$clearTime);
    }
};


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $dc25af1e857ab50f$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $79eb9ac4c2b846cb$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $dc25af1e857ab50f$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $21125973824588d9$export$491112666e282270 = (0, $001eda3aa79c6ebe$export$8793edee2d425525);
let $21125973824588d9$export$f5708dca728d7177 = (0, $001eda3aa79c6ebe$export$8793edee2d425525);
var $21125973824588d9$var$check, $21125973824588d9$var$message, $21125973824588d9$var$check1, $21125973824588d9$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $fe062db003bcffb8$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $43d08db277fd08bd$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $43d08db277fd08bd$export$b9f0c1f373aee2b0(current) {
    const match = $43d08db277fd08bd$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $43d08db277fd08bd$var$maxDepth = 4;
function $43d08db277fd08bd$export$289398774300c991(current, element, depth = 1) {
    (0, $21125973824588d9$export$f5708dca728d7177)(depth <= $43d08db277fd08bd$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $43d08db277fd08bd$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $fe062db003bcffb8$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $7788fac55eb8bc79$export$31f9caa2600b5723)(fallback) ? $43d08db277fd08bd$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






const $c21fcd3807f5d2f0$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $c21fcd3807f5d2f0$export$8e5250d1aa9bf370 = (v)=>v === (0, $3b3d1d8d17c11467$export$98e628dec113755e) || v === (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008);
const $c21fcd3807f5d2f0$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $c21fcd3807f5d2f0$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $c21fcd3807f5d2f0$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $c21fcd3807f5d2f0$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $c21fcd3807f5d2f0$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $c21fcd3807f5d2f0$var$nonTranslationalTransformKeys = (0, $da211e07316d6e39$export$280dc01950909d86).filter((key)=>!$c21fcd3807f5d2f0$var$transformKeys.has(key));
function $c21fcd3807f5d2f0$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $c21fcd3807f5d2f0$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $c21fcd3807f5d2f0$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $c21fcd3807f5d2f0$var$getTranslateFromMatrix(4, 13),
    y: $c21fcd3807f5d2f0$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$c21fcd3807f5d2f0$export$781d46a8aa670d52.translateX = $c21fcd3807f5d2f0$export$781d46a8aa670d52.x;
$c21fcd3807f5d2f0$export$781d46a8aa670d52.translateY = $c21fcd3807f5d2f0$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $0a85921ea474cb14$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $e8457b7d67ceabe9$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $b2fd586ec5020ed9$export$d176691c1998a1f5 = [
    (0, $3b3d1d8d17c11467$export$98e628dec113755e),
    (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008),
    (0, $e8f3e6c5adc69edc$export$626336c2cd4b14de),
    (0, $e8f3e6c5adc69edc$export$41fc368e1a942b97),
    (0, $e8f3e6c5adc69edc$export$aed3d7b7d206c196),
    (0, $e8f3e6c5adc69edc$export$f91e8c45a95a32f2),
    (0, $e8457b7d67ceabe9$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $b2fd586ec5020ed9$export$eefdd52e3ccae428 = (v)=>$b2fd586ec5020ed9$export$d176691c1998a1f5.find((0, $0a85921ea474cb14$export$6eae4d0a6a7ca7cd)(v));




const $80c84fe89f88d202$var$toResolve = new Set();
let $80c84fe89f88d202$var$isScheduled = false;
let $80c84fe89f88d202$var$anyNeedsMeasurement = false;
function $80c84fe89f88d202$var$measureAllKeyframes() {
    if ($80c84fe89f88d202$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($80c84fe89f88d202$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $c21fcd3807f5d2f0$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $80c84fe89f88d202$var$anyNeedsMeasurement = false;
    $80c84fe89f88d202$var$isScheduled = false;
    $80c84fe89f88d202$var$toResolve.forEach((resolver)=>resolver.complete());
    $80c84fe89f88d202$var$toResolve.clear();
}
function $80c84fe89f88d202$var$readAllKeyframes() {
    $80c84fe89f88d202$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $80c84fe89f88d202$var$anyNeedsMeasurement = true;
    });
}
function $80c84fe89f88d202$export$78b96d2a12593b05() {
    $80c84fe89f88d202$var$readAllKeyframes();
    $80c84fe89f88d202$var$measureAllKeyframes();
}
class $80c84fe89f88d202$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $80c84fe89f88d202$var$toResolve.add(this);
            if (!$80c84fe89f88d202$var$isScheduled) {
                $80c84fe89f88d202$var$isScheduled = true;
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read($80c84fe89f88d202$var$readAllKeyframes);
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).resolveKeyframes($80c84fe89f88d202$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $80c84fe89f88d202$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $80c84fe89f88d202$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $75e61ee5dd842e4f$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $eb49388da280e24f$export$844ec244b1367d54)(v) && (0, $eb49388da280e24f$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $75e61ee5dd842e4f$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $eb49388da280e24f$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $eb49388da280e24f$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $85af50c0409e6514$var$clampRgbUnit = (v)=>(0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 255, v);
const $85af50c0409e6514$export$7a99c86b5b1f4c9e = {
    ...(0, $3b3d1d8d17c11467$export$98e628dec113755e),
    transform: (v)=>Math.round($85af50c0409e6514$var$clampRgbUnit(v))
};
const $85af50c0409e6514$export$4e46ac54fc82cf3b = {
    test: (0, $75e61ee5dd842e4f$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $75e61ee5dd842e4f$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(red) + ", " + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(green) + ", " + $85af50c0409e6514$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $eb49388da280e24f$export$83d2e9e3e4ee39ed)((0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $aeb63d9188419d43$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $aeb63d9188419d43$export$834dfc94dde4b3d8 = {
    test: (0, $75e61ee5dd842e4f$export$2c8400d58aca05e)("#"),
    parse: $aeb63d9188419d43$var$parseHex,
    transform: (0, $85af50c0409e6514$export$4e46ac54fc82cf3b).transform
};






const $849448f5a3a709c4$export$810b04175080204c = {
    test: (0, $75e61ee5dd842e4f$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $75e61ee5dd842e4f$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).transform((0, $eb49388da280e24f$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).transform((0, $eb49388da280e24f$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $eb49388da280e24f$export$83d2e9e3e4ee39ed)((0, $3b3d1d8d17c11467$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $9aa3b4c939055303$export$35e9368ef982300f = {
    test: (v)=>(0, $85af50c0409e6514$export$4e46ac54fc82cf3b).test(v) || (0, $aeb63d9188419d43$export$834dfc94dde4b3d8).test(v) || (0, $849448f5a3a709c4$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $85af50c0409e6514$export$4e46ac54fc82cf3b).test(v)) return (0, $85af50c0409e6514$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $849448f5a3a709c4$export$810b04175080204c).test(v)) return (0, $849448f5a3a709c4$export$810b04175080204c).parse(v);
        else return (0, $aeb63d9188419d43$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $eb49388da280e24f$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $85af50c0409e6514$export$4e46ac54fc82cf3b).transform(v) : (0, $849448f5a3a709c4$export$810b04175080204c).transform(v);
    }
};



function $20185419c445ef46$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $eb49388da280e24f$export$844ec244b1367d54)(v) && (((_a = v.match((0, $eb49388da280e24f$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $eb49388da280e24f$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $20185419c445ef46$var$NUMBER_TOKEN = "number";
const $20185419c445ef46$var$COLOR_TOKEN = "color";
const $20185419c445ef46$var$VAR_TOKEN = "var";
const $20185419c445ef46$var$VAR_FUNCTION_TOKEN = "var(";
const $20185419c445ef46$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $20185419c445ef46$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $20185419c445ef46$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($20185419c445ef46$var$complexRegex, (parsedValue)=>{
        if ((0, $9aa3b4c939055303$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($20185419c445ef46$var$COLOR_TOKEN);
            values.push((0, $9aa3b4c939055303$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($20185419c445ef46$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($20185419c445ef46$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($20185419c445ef46$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $20185419c445ef46$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($20185419c445ef46$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $20185419c445ef46$var$parseComplexValue(v) {
    return $20185419c445ef46$export$b61fc7c44bf646d5(v).values;
}
function $20185419c445ef46$var$createTransformer(source) {
    const { split: split, types: types } = $20185419c445ef46$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $20185419c445ef46$var$NUMBER_TOKEN) output += (0, $eb49388da280e24f$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $20185419c445ef46$var$COLOR_TOKEN) output += (0, $9aa3b4c939055303$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $20185419c445ef46$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $20185419c445ef46$var$getAnimatableNone(v) {
    const parsed = $20185419c445ef46$var$parseComplexValue(v);
    const transformer = $20185419c445ef46$var$createTransformer(v);
    return transformer(parsed.map($20185419c445ef46$var$convertNumbersToZero));
}
const $20185419c445ef46$export$83a0e34f1302825b = {
    test: $20185419c445ef46$var$test,
    parse: $20185419c445ef46$var$parseComplexValue,
    createTransformer: $20185419c445ef46$var$createTransformer,
    getAnimatableNone: $20185419c445ef46$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $c9578b271c7cac5c$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c9578b271c7cac5c$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $eb49388da280e24f$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c9578b271c7cac5c$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c9578b271c7cac5c$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $c9578b271c7cac5c$export$3dea766d36a8935f = {
    ...(0, $20185419c445ef46$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c9578b271c7cac5c$var$functionRegex);
        return functions ? functions.map($c9578b271c7cac5c$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $10ea5fd01401393b$export$98cd7c72c5a731fb = {
    ...(0, $0d74cfa63198be03$export$eec14432cd1cb67b),
    color: // Color props
    $9aa3b4c939055303$export$35e9368ef982300f,
    backgroundColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    outlineColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    fill: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    stroke: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    borderTopColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    borderRightColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    borderBottomColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    borderLeftColor: (0, $9aa3b4c939055303$export$35e9368ef982300f),
    filter: $c9578b271c7cac5c$export$3dea766d36a8935f,
    WebkitFilter: (0, $c9578b271c7cac5c$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $10ea5fd01401393b$export$67d1babe0338d23b = (key)=>$10ea5fd01401393b$export$98cd7c72c5a731fb[key];


function $f39674aa42131bf6$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c9578b271c7cac5c$export$3dea766d36a8935f)) defaultValueType = (0, $20185419c445ef46$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $3f14005f681887c7$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $3f14005f681887c7$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$3f14005f681887c7$var$invalidTemplates.has(keyframe) && (0, $20185419c445ef46$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $f39674aa42131bf6$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $891e5637f91f7d52$export$4983792d11b61017 extends (0, $80c84fe89f88d202$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue){
        super(unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $7788fac55eb8bc79$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $43d08db277fd08bd$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $c21fcd3807f5d2f0$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $b2fd586ec5020ed9$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $c21fcd3807f5d2f0$export$8e5250d1aa9bf370)(originType) && (0, $c21fcd3807f5d2f0$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $79eb9ac4c2b846cb$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $3f14005f681887c7$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $c21fcd3807f5d2f0$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $c21fcd3807f5d2f0$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


function $14eb16b16cce0ebe$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}








/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ad3409c8def06c51$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $20185419c445ef46$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $1f73039afafc0199$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $1f73039afafc0199$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $ad3409c8def06c51$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $ad3409c8def06c51$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $21125973824588d9$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $1f73039afafc0199$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



class $ed332976403bd896$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $80c84fe89f88d202$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $1f73039afafc0199$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $f006002175d4313e$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $511bcb3f09b5d5d2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $802cd06bac70029a$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $0ea446648b330676$var$velocitySampleDuration = 5; // ms
function $0ea446648b330676$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $0ea446648b330676$var$velocitySampleDuration, 0);
    return (0, $802cd06bac70029a$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $13cfb88998c1052a$var$safeMin = 0.001;
const $13cfb88998c1052a$export$a3cdb76e84ee608e = 0.01;
const $13cfb88998c1052a$export$1824b851fad8862b = 10.0;
const $13cfb88998c1052a$export$ff08f2d53484465 = 0.05;
const $13cfb88998c1052a$export$201ca48e54038115 = 1;
function $13cfb88998c1052a$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $21125973824588d9$export$491112666e282270)(duration <= (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)($13cfb88998c1052a$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)($13cfb88998c1052a$export$ff08f2d53484465, $13cfb88998c1052a$export$201ca48e54038115, dampingRatio);
    duration = (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)($13cfb88998c1052a$export$a3cdb76e84ee608e, $13cfb88998c1052a$export$1824b851fad8862b, (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $13cfb88998c1052a$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $13cfb88998c1052a$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $13cfb88998c1052a$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $13cfb88998c1052a$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$13cfb88998c1052a$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $13cfb88998c1052a$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $13cfb88998c1052a$var$rootIterations = 12;
function $13cfb88998c1052a$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $13cfb88998c1052a$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $13cfb88998c1052a$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $9c2b8560de502fe4$var$durationKeys = [
    "duration",
    "bounce"
];
const $9c2b8560de502fe4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $9c2b8560de502fe4$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $9c2b8560de502fe4$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$9c2b8560de502fe4$var$isSpringType(options, $9c2b8560de502fe4$var$physicsKeys) && $9c2b8560de502fe4$var$isSpringType(options, $9c2b8560de502fe4$var$durationKeys)) {
        const derived = (0, $13cfb88998c1052a$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $9c2b8560de502fe4$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $9c2b8560de502fe4$var$getSpringOptions({
        ...options,
        velocity: -(0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $13cfb88998c1052a$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $0ea446648b330676$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $385208c905445c33$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $9c2b8560de502fe4$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $0ea446648b330676$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $3737dbfe96debfa1$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $3737dbfe96debfa1$var$subdivisionPrecision = 0.0000001;
const $3737dbfe96debfa1$var$subdivisionMaxIterations = 12;
function $3737dbfe96debfa1$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $3737dbfe96debfa1$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $3737dbfe96debfa1$var$subdivisionPrecision && ++i < $3737dbfe96debfa1$var$subdivisionMaxIterations);
    return currentT;
}
function $3737dbfe96debfa1$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $001eda3aa79c6ebe$export$8793edee2d425525;
    const getTForX = (aX)=>$3737dbfe96debfa1$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $3737dbfe96debfa1$var$calcBezier(getTForX(t), mY1, mY2);
}


const $c8b74045bf313d3a$export$929e5a82286172a6 = (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c8b74045bf313d3a$export$57636bb43b1ccbb0 = (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c8b74045bf313d3a$export$c07234257a03d5e9 = (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $aeb97d5b77acc966$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $491548cdece44f33$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $5a530d260e29c865$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $2c3e49d3e54725d4$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $2c3e49d3e54725d4$export$c8d67a19199d1a50 = (0, $5a530d260e29c865$export$2c07eeff45156d4d)($2c3e49d3e54725d4$export$e444123e42d03385);
const $2c3e49d3e54725d4$export$30d3455eee55bed5 = (0, $491548cdece44f33$export$f946554fb8aeaf0d)($2c3e49d3e54725d4$export$e444123e42d03385);





const $d8f936f95fb21cba$export$77edfce482316a60 = (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $d8f936f95fb21cba$export$b01116c84cdfe1a2 = (0, $5a530d260e29c865$export$2c07eeff45156d4d)($d8f936f95fb21cba$export$77edfce482316a60);
const $d8f936f95fb21cba$export$ddc5fd596f6c71b2 = (0, $491548cdece44f33$export$f946554fb8aeaf0d)($d8f936f95fb21cba$export$b01116c84cdfe1a2);



const $e12b7a3993b78d59$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $d8f936f95fb21cba$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $88c8bfe8b7e57b27$var$easingLookup = {
    linear: (0, $001eda3aa79c6ebe$export$8793edee2d425525),
    easeIn: $c8b74045bf313d3a$export$929e5a82286172a6,
    easeInOut: $c8b74045bf313d3a$export$c07234257a03d5e9,
    easeOut: $c8b74045bf313d3a$export$57636bb43b1ccbb0,
    circIn: $2c3e49d3e54725d4$export$e444123e42d03385,
    circInOut: $2c3e49d3e54725d4$export$30d3455eee55bed5,
    circOut: $2c3e49d3e54725d4$export$c8d67a19199d1a50,
    backIn: $d8f936f95fb21cba$export$b01116c84cdfe1a2,
    backInOut: $d8f936f95fb21cba$export$ddc5fd596f6c71b2,
    backOut: $d8f936f95fb21cba$export$77edfce482316a60,
    anticipate: $e12b7a3993b78d59$export$6b0af63b873d419e
};
const $88c8bfe8b7e57b27$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $21125973824588d9$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $3737dbfe96debfa1$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $21125973824588d9$export$f5708dca728d7177)($88c8bfe8b7e57b27$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $88c8bfe8b7e57b27$var$easingLookup[definition];
    }
    return definition;
};





/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $98fa8bab6764d451$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $588ba3a890ebeea1$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $f2fd9537b9736456$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f2fd9537b9736456$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $f2fd9537b9736456$var$hueToRgb(p, q, hue + 1 / 3);
        green = $f2fd9537b9736456$var$hueToRgb(p, q, hue);
        blue = $f2fd9537b9736456$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $01245b4a979f486f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $01245b4a979f486f$var$colorTypes = [
    (0, $aeb63d9188419d43$export$834dfc94dde4b3d8),
    (0, $85af50c0409e6514$export$4e46ac54fc82cf3b),
    (0, $849448f5a3a709c4$export$810b04175080204c)
];
const $01245b4a979f486f$var$getColorType = (v)=>$01245b4a979f486f$var$colorTypes.find((type)=>type.test(v));
function $01245b4a979f486f$var$asRGBA(color) {
    const type = $01245b4a979f486f$var$getColorType(color);
    (0, $21125973824588d9$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $849448f5a3a709c4$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $f2fd9537b9736456$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $01245b4a979f486f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $01245b4a979f486f$var$asRGBA(from);
    const toRGBA = $01245b4a979f486f$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $01245b4a979f486f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $85af50c0409e6514$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $ec496a39a81ed2a5$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $ec496a39a81ed2a5$export$fed62ccc3fb1a568(origin, target) {
    if ($ec496a39a81ed2a5$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $c4df8059f4d4f707$var$mixNumber(a, b) {
    return (p)=>(0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $c4df8059f4d4f707$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $c4df8059f4d4f707$var$mixNumber;
    else if (typeof a === "string") return (0, $7788fac55eb8bc79$export$31f9caa2600b5723)(a) ? (0, $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1) : (0, $9aa3b4c939055303$export$35e9368ef982300f).test(a) ? (0, $01245b4a979f486f$export$51e568cf5c039bac) : $c4df8059f4d4f707$export$65516310a87d8205;
    else if (Array.isArray(a)) return $c4df8059f4d4f707$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $9aa3b4c939055303$export$35e9368ef982300f).test(a) ? (0, $01245b4a979f486f$export$51e568cf5c039bac) : $c4df8059f4d4f707$export$ebc23b6840c51ba1;
    return 0, $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1;
}
function $c4df8059f4d4f707$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$c4df8059f4d4f707$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $c4df8059f4d4f707$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $c4df8059f4d4f707$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $c4df8059f4d4f707$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $c4df8059f4d4f707$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $20185419c445ef46$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $20185419c445ef46$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $20185419c445ef46$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $ec496a39a81ed2a5$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $ec496a39a81ed2a5$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $ec496a39a81ed2a5$export$fed62ccc3fb1a568)(origin, target);
        return (0, $3e3ea55737c24d5c$export$a4627e546088548d)($c4df8059f4d4f707$export$3bbefa2f402845c4($c4df8059f4d4f707$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $21125973824588d9$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $84d949ffc7ebc4e9$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $db0fe8fe6e0bf583$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $c4df8059f4d4f707$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $7a8f7810cf7f62f1$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $db0fe8fe6e0bf583$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $001eda3aa79c6ebe$export$8793edee2d425525) : ease;
            mixer = (0, $3e3ea55737c24d5c$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $7a8f7810cf7f62f1$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $21125973824588d9$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $7a8f7810cf7f62f1$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $98fa8bab6764d451$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $c3be58b89be3196b$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $98fa8bab6764d451$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $514a1d36e18c8614$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $c3be58b89be3196b$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $14aaf33a81a363c0$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $a21436596a4cb4a3$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c8b74045bf313d3a$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $a21436596a4cb4a3$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $aeb97d5b77acc966$export$216948827bbdc797)(ease) ? ease.map((0, $88c8bfe8b7e57b27$export$ef97fe084f156ca4)) : (0, $88c8bfe8b7e57b27$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $14aaf33a81a363c0$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $514a1d36e18c8614$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $7a8f7810cf7f62f1$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $a21436596a4cb4a3$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $2c9655bdaefca666$export$f4ff70a5b4808fd8 = 20000;
function $2c9655bdaefca666$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $2c9655bdaefca666$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $2c9655bdaefca666$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $f493cd23202dddb3$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $301e135f87ffeb5c$export$fff89137e9e818ce).isProcessing ? (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp : (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now()
    };
};



const $bdbd2d344da3cfef$var$generators = {
    decay: (0, $385208c905445c33$export$ee3ff3a17106998),
    inertia: $385208c905445c33$export$ee3ff3a17106998,
    tween: (0, $a21436596a4cb4a3$export$d25ddfdf17c3ad3e),
    keyframes: (0, $a21436596a4cb4a3$export$d25ddfdf17c3ad3e),
    spring: $9c2b8560de502fe4$export$b36281d89752ae66
};
const $bdbd2d344da3cfef$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $bdbd2d344da3cfef$export$fd98d9cca67a58bc extends (0, $ed332976403bd896$export$d1e4f34b9c2550c1) {
    constructor({ KeyframeResolver: KeyframeResolver$1 = (0, $80c84fe89f88d202$export$74d34ca3182f1750), ...options }){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        if (name && motionValue && motionValue.owner) this.resolver = motionValue.owner.resolveKeyframes(keyframes, onResolved, name, motionValue);
        else this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $bdbd2d344da3cfef$var$generators[type] || (0, $a21436596a4cb4a3$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $a21436596a4cb4a3$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $3e3ea55737c24d5c$export$a4627e546088548d)($bdbd2d344da3cfef$var$percentToProgress, (0, $db0fe8fe6e0bf583$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $2c9655bdaefca666$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $511bcb3f09b5d5d2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $f493cd23202dddb3$export$c1033964b5ad7fef), onPlay: onPlay } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime || this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $bdbd2d344da3cfef$export$ee9b76de7353d815(options) {
    return new $bdbd2d344da3cfef$export$fd98d9cca67a58bc(options);
}


const $775b0dd2cff56849$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $d454d8d346a47741$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $d454d8d346a47741$export$2cf569f5e2221176 || (0, $775b0dd2cff56849$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($d454d8d346a47741$export$fcdd8f3f2160beda));
}
const $d454d8d346a47741$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $d454d8d346a47741$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $d454d8d346a47741$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $d454d8d346a47741$var$mapEasingToNativeEasingWithDefault(easing) {
    return $d454d8d346a47741$export$916ea73bcd3a6030(easing) || $d454d8d346a47741$export$2cf569f5e2221176.easeOut;
}
function $d454d8d346a47741$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $775b0dd2cff56849$export$ff43f99925d7366b)(easing)) return $d454d8d346a47741$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($d454d8d346a47741$var$mapEasingToNativeEasingWithDefault);
    else return $d454d8d346a47741$export$2cf569f5e2221176[easing];
}


function $0717cb5fef3b9569$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $d454d8d346a47741$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $a16b4fc0114fb32a$var$supportsWaapi = (0, $14eb16b16cce0ebe$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $a16b4fc0114fb32a$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $a16b4fc0114fb32a$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $a16b4fc0114fb32a$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $a16b4fc0114fb32a$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || options.name === "backgroundColor" || !(0, $d454d8d346a47741$export$fcdd8f3f2160beda)(options.ease);
}
function $a16b4fc0114fb32a$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $bdbd2d344da3cfef$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $a16b4fc0114fb32a$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $a16b4fc0114fb32a$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $a16b4fc0114fb32a$var$sampleDelta,
        ease: "linear"
    };
}
class $a16b4fc0114fb32a$export$2a45abb4e6513325 extends (0, $ed332976403bd896$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        this.resolver = new (0, $891e5637f91f7d52$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($a16b4fc0114fb32a$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, ...options } = this.options;
            const pregeneratedAnimation = $a16b4fc0114fb32a$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $0717cb5fef3b9569$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $511bcb3f09b5d5d2$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $001eda3aa79c6ebe$export$8793edee2d425525;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $001eda3aa79c6ebe$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, ...options } = this.options;
            const sampleAnimation = new (0, $bdbd2d344da3cfef$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $a16b4fc0114fb32a$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $a16b4fc0114fb32a$var$sampleDelta);
        }
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $a16b4fc0114fb32a$var$supportsWaapi() && name && $a16b4fc0114fb32a$var$acceleratedValues.has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




function $327b272f50abb932$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(onFrame);
}



const $86e86c2597ba3556$export$20d68f04f30763a5 = (0, $14eb16b16cce0ebe$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $3abee9a5ece0b64c$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $86e86c2597ba3556$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $327b272f50abb932$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


const $b414a5ed52d2ead3$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $1d127c5bbdfabc9c$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $1d127c5bbdfabc9c$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $d51b9411f6ccbbd1$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $f006002175d4313e$export$888a3d84909f9e3d).current || (0, $3cdabdabfda62d22$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $511bcb3f09b5d5d2$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $3abee9a5ece0b64c$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $a16b4fc0114fb32a$export$2a45abb4e6513325).supports(options)) return new (0, $a16b4fc0114fb32a$export$2a45abb4e6513325)(options);
        else return new (0, $bdbd2d344da3cfef$export$fd98d9cca67a58bc)(options);
    };



function $78c97899e24aca1c$export$98397f3adbf6259f(value) {
    return Boolean((0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) && value.add);
}



function $d2a9bfd104bd5453$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $d2a9bfd104bd5453$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $d2a9bfd104bd5453$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $97358bb0f01597b3$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $4b2846f88af5423d$var$MAX_VELOCITY_DELTA = 30;
const $4b2846f88af5423d$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $4b2846f88af5423d$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $4b2846f88af5423d$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.2.11";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $4b2846f88af5423d$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($4b2846f88af5423d$export$67fcd818a264039d.current) $4b2846f88af5423d$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $4b2846f88af5423d$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $4b2846f88af5423d$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $802cd06bac70029a$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $4b2846f88af5423d$export$ce8bdc721e76545f(init, options) {
    return new $4b2846f88af5423d$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $e4befcaa41a4f540$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(value));
}
function $e4befcaa41a4f540$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $730ab9aa0424fb5a$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $0d15acf980467e42$export$5485128c47bd48bb)(target[key]);
        $e4befcaa41a4f540$var$setMotionValue(visualElement, key, value);
    }
}




function $a2e0096f48bfe337$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.getProps()[0, $99c2b47e65be39f1$export$8592e1c077c890a6];
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $63d62870b9fa1dce$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $63d62870b9fa1dce$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $63d62870b9fa1dce$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $1d127c5bbdfabc9c$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.HandoffAppearAnimations) {
            const appearId = (0, $a2e0096f48bfe337$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $301e135f87ffeb5c$export$2cef06c20297c17d));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $b414a5ed52d2ead3$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) {
            if ((0, $78c97899e24aca1c$export$98397f3adbf6259f)(willChange)) {
                willChange.add(key);
                animation.then(()=>willChange.remove(key));
            }
            animations.push(animation);
        }
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $e4befcaa41a4f540$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $f24a58bcb9fc172f$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $730ab9aa0424fb5a$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $63d62870b9fa1dce$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $f24a58bcb9fc172f$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f24a58bcb9fc172f$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($f24a58bcb9fc172f$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($f24a58bcb9fc172f$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $f24a58bcb9fc172f$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}



function $e364f8e011fb793b$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $f24a58bcb9fc172f$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $f24a58bcb9fc172f$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $730ab9aa0424fb5a$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $63d62870b9fa1dce$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>{
            visualElement.notify("AnimationComplete", definition);
        });
    });
}


const $b147b3fbcf8b2fc8$var$reversePriorityOrder = [
    ...(0, $46d8d186c05e43b0$export$16e45afcc206d3a8)
].reverse();
const $b147b3fbcf8b2fc8$var$numAnimationTypes = (0, $46d8d186c05e43b0$export$16e45afcc206d3a8).length;
function $b147b3fbcf8b2fc8$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $e364f8e011fb793b$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $b147b3fbcf8b2fc8$export$bb53502b7a672aa8(visualElement) {
    let animate = $b147b3fbcf8b2fc8$var$animateList(visualElement);
    let state = $b147b3fbcf8b2fc8$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $730ab9aa0424fb5a$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $b147b3fbcf8b2fc8$var$numAnimationTypes; i++){
            const type = $b147b3fbcf8b2fc8$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a36779356b36fa8a$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $b147b3fbcf8b2fc8$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(next) && (0, $6f683bc80c6d969e$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $423df1fac2a0b98a$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $b147b3fbcf8b2fc8$var$createState();
            isInitialRender = true;
        }
    };
}
function $b147b3fbcf8b2fc8$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $423df1fac2a0b98a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $b147b3fbcf8b2fc8$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $b147b3fbcf8b2fc8$var$createState() {
    return {
        animate: $b147b3fbcf8b2fc8$var$createTypeState(true),
        whileInView: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileHover: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileTap: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileDrag: $b147b3fbcf8b2fc8$var$createTypeState(),
        whileFocus: $b147b3fbcf8b2fc8$var$createTypeState(),
        exit: $b147b3fbcf8b2fc8$var$createTypeState()
    };
}



class $4c042cb37597b7b9$export$b45b3fe5caabdca extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $b147b3fbcf8b2fc8$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $0c915d7372d9814d$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $1d482825f4aa3400$var$id = 0;
class $1d482825f4aa3400$export$4989d1eb6104cc6c extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $1d482825f4aa3400$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $7170ce59c2debd45$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $4c042cb37597b7b9$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $1d482825f4aa3400$export$4989d1eb6104cc6c)
    }
};









const $4139a982bce3ebbd$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $4139a982bce3ebbd$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $4139a982bce3ebbd$export$9f17032d917177de(a.x, b.x);
    const yDelta = $4139a982bce3ebbd$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $8f5d92e6e3694ff2$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $8f5d92e6e3694ff2$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $4139a982bce3ebbd$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $301e135f87ffeb5c$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $8f5d92e6e3694ff2$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $8f5d92e6e3694ff2$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $8f5d92e6e3694ff2$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $5332f0d6324f3440$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $19290b72856733e8$export$12f84bb882d06e1a)(event);
        const initialInfo = $8f5d92e6e3694ff2$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $301e135f87ffeb5c$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $8f5d92e6e3694ff2$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $3e3ea55737c24d5c$export$a4627e546088548d)((0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $8f5d92e6e3694ff2$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $8f5d92e6e3694ff2$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $8f5d92e6e3694ff2$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $8f5d92e6e3694ff2$var$subtractPoint(point, $8f5d92e6e3694ff2$var$lastDevicePoint(history)),
        offset: $8f5d92e6e3694ff2$var$subtractPoint(point, $8f5d92e6e3694ff2$var$startDevicePoint(history)),
        velocity: $8f5d92e6e3694ff2$var$getVelocity(history, 0.1)
    };
}
function $8f5d92e6e3694ff2$var$startDevicePoint(history) {
    return history[0];
}
function $8f5d92e6e3694ff2$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $8f5d92e6e3694ff2$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $8f5d92e6e3694ff2$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $a1e42a4af2333fb7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $a1e42a4af2333fb7$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $a1e42a4af2333fb7$export$c1c127004b72a37(target) / $a1e42a4af2333fb7$export$c1c127004b72a37(source);
    if ($a1e42a4af2333fb7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($a1e42a4af2333fb7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $a1e42a4af2333fb7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $a1e42a4af2333fb7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $a1e42a4af2333fb7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $a1e42a4af2333fb7$export$c1c127004b72a37(relative);
}
function $a1e42a4af2333fb7$export$426154f9d100f99(target, relative, parent) {
    $a1e42a4af2333fb7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $a1e42a4af2333fb7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $a1e42a4af2333fb7$export$c1c127004b72a37(layout);
}
function $a1e42a4af2333fb7$export$2785bfcc929c5650(target, layout, parent) {
    $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $a1e42a4af2333fb7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $80b0c15e89836697$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $80b0c15e89836697$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $80b0c15e89836697$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $80b0c15e89836697$export$690c180aa5775042(layoutBox.x, left, right),
        y: $80b0c15e89836697$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $80b0c15e89836697$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $80b0c15e89836697$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $80b0c15e89836697$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $80b0c15e89836697$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $80b0c15e89836697$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(source);
    const targetLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $98fa8bab6764d451$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $98fa8bab6764d451$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $80b0c15e89836697$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $80b0c15e89836697$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $80b0c15e89836697$export$7c5eaef8f4723d22(dragElastic = $80b0c15e89836697$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $80b0c15e89836697$export$a3366d3bac43a742;
    return {
        x: $80b0c15e89836697$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $80b0c15e89836697$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $80b0c15e89836697$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $80b0c15e89836697$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $704cbd53c53f9d5c$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $704cbd53c53f9d5c$export$3d227df54007d73a = ()=>({
        x: $704cbd53c53f9d5c$export$ff25708b37f72782(),
        y: $704cbd53c53f9d5c$export$ff25708b37f72782()
    });
const $704cbd53c53f9d5c$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $704cbd53c53f9d5c$export$6459fc9e86be362e = ()=>({
        x: $704cbd53c53f9d5c$export$6db76765312617ac(),
        y: $704cbd53c53f9d5c$export$6db76765312617ac()
    });


function $2c62bc0ac9269350$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $51f4355a9b48a0fa$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $51f4355a9b48a0fa$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $51f4355a9b48a0fa$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $43492ab836cff22d$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $43492ab836cff22d$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$43492ab836cff22d$var$isIdentityScale(scale) || !$43492ab836cff22d$var$isIdentityScale(scaleX) || !$43492ab836cff22d$var$isIdentityScale(scaleY);
}
function $43492ab836cff22d$export$a545127cf1fbb600(values) {
    return $43492ab836cff22d$export$bdf30dca883ea463(values) || $43492ab836cff22d$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $43492ab836cff22d$export$bf80f5f8f4dc327f(values) {
    return $43492ab836cff22d$var$is2DTranslate(values.x) || $43492ab836cff22d$var$is2DTranslate(values.y);
}
function $43492ab836cff22d$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $3cadfa9c5538c02d$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $3cadfa9c5538c02d$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $3cadfa9c5538c02d$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $3cadfa9c5538c02d$export$d80074982803af5c(box, { x: x, y: y }) {
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $3cadfa9c5538c02d$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $3cadfa9c5538c02d$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $3cadfa9c5538c02d$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) $3cadfa9c5538c02d$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $3cadfa9c5538c02d$var$snapToDefault(treeScale.x);
    treeScale.y = $3cadfa9c5538c02d$var$snapToDefault(treeScale.y);
}
function $3cadfa9c5538c02d$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $3cadfa9c5538c02d$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $3cadfa9c5538c02d$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $3cadfa9c5538c02d$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $3cadfa9c5538c02d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $3cadfa9c5538c02d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $3cadfa9c5538c02d$export$58b16271041fbfb(box, transform) {
    $3cadfa9c5538c02d$export$625f1dd140a2f5e7(box.x, transform, $3cadfa9c5538c02d$var$xKeys);
    $3cadfa9c5538c02d$export$625f1dd140a2f5e7(box.y, transform, $3cadfa9c5538c02d$var$yKeys);
}


function $5df6dc38d07b7e46$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $51f4355a9b48a0fa$export$d3955c6a8f65a36b)((0, $51f4355a9b48a0fa$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $5df6dc38d07b7e46$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $5df6dc38d07b7e46$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $332a2655753b90cb$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};



const $8c2f26a6b37d6dc9$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $8c2f26a6b37d6dc9$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $19290b72856733e8$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $96522e0a3b96b9e4$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $8c2f26a6b37d6dc9$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $8f5d92e6e3694ff2$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $332a2655753b90cb$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $80b0c15e89836697$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $80b0c15e89836697$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $80b0c15e89836697$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $80b0c15e89836697$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $21125973824588d9$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $5df6dc38d07b7e46$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $80b0c15e89836697$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $51f4355a9b48a0fa$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $51f4355a9b48a0fa$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $b414a5ed52d2ead3$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement));
    }
    stopAnimation() {
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $80b0c15e89836697$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            if (!$8c2f26a6b37d6dc9$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $8c2f26a6b37d6dc9$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $7be42aa7b9b2349b$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $a8c57a49f398792d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $80b0c15e89836697$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $8c2f26a6b37d6dc9$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $8c2f26a6b37d6dc9$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $aedcddc2627aa96c$export$5d97dc2872682820 extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $001eda3aa79c6ebe$export$8793edee2d425525);
        this.removeListeners = (0, $001eda3aa79c6ebe$export$8793edee2d425525);
        this.controls = new (0, $8c2f26a6b37d6dc9$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $001eda3aa79c6ebe$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $07770208fc6498da$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $07770208fc6498da$export$b4f8f1ee75ce5859 extends (0, $c280630d94a7df00$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $001eda3aa79c6ebe$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $8f5d92e6e3694ff2$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $332a2655753b90cb$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $07770208fc6498da$var$asyncHandler(onPanSessionStart),
            onStart: $07770208fc6498da$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $a3b5ca0718993d16$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $eecb2e495db1f2fd$export$2a8c16d82a0a0e26() {
    const context = (0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $exYeM.useId)();
    (0, $exYeM.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $eecb2e495db1f2fd$export$8249053f690ea39a() {
    return $eecb2e495db1f2fd$export$ee27c052bca048fb((0, $exYeM.useContext)((0, $32835478aabc17b5$export$f224e4635b6f8ce2)));
}
function $eecb2e495db1f2fd$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $d92fcbc1a711d121$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $58b16b9942e44958$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $58b16b9942e44958$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $58b16b9942e44958$export$fafff692be55225d(latest, node.target.x);
        const y = $58b16b9942e44958$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $011a5e472cdf5fa8$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $20185419c445ef46$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $20185419c445ef46$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};





class $c3c24be56499347e$var$MeasureLayoutWithContext extends (0, $exYeM.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $93099dc5c3aa7524$export$de9e7791c71225fd)($c3c24be56499347e$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $a1ef008917ac1826$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $c3c24be56499347e$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $eecb2e495db1f2fd$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $exYeM.useContext)((0, $0d8fa753a19a110b$export$a3579ca508007a95));
    return (0, $aSiaI.jsx)($c3c24be56499347e$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $exYeM.useContext)((0, $df9c3e45a16d5ebc$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $c3c24be56499347e$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $58b16b9942e44958$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $58b16b9942e44958$export$5eafb6257a5844c),
    boxShadow: (0, $011a5e472cdf5fa8$export$eb0bc629e74dcf8)
};








const $b0eff65bd8993999$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $b0eff65bd8993999$var$numBorders = $b0eff65bd8993999$var$borders.length;
const $b0eff65bd8993999$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $b0eff65bd8993999$var$isPx = (value)=>typeof value === "number" || (0, $e8f3e6c5adc69edc$export$91c0eda1d06bf008).test(value);
function $b0eff65bd8993999$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $b0eff65bd8993999$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $b0eff65bd8993999$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $b0eff65bd8993999$var$numBorders; i++){
        const borderLabel = `border${$b0eff65bd8993999$var$borders[i]}Radius`;
        let followRadius = $b0eff65bd8993999$var$getRadius(follow, borderLabel);
        let leadRadius = $b0eff65bd8993999$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $b0eff65bd8993999$var$isPx(followRadius) === $b0eff65bd8993999$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)($b0eff65bd8993999$var$asNumber(followRadius), $b0eff65bd8993999$var$asNumber(leadRadius), progress), 0);
            if ((0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).test(leadRadius) || (0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $b0eff65bd8993999$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $b0eff65bd8993999$var$easeCrossfadeIn = $b0eff65bd8993999$var$compress(0, 0.5, (0, $2c3e49d3e54725d4$export$c8d67a19199d1a50));
const $b0eff65bd8993999$var$easeCrossfadeOut = $b0eff65bd8993999$var$compress(0.5, 0.95, (0, $001eda3aa79c6ebe$export$8793edee2d425525));
function $b0eff65bd8993999$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $98fa8bab6764d451$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $350541e2d10af992$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $350541e2d10af992$export$c53fd88f45d77e4b(box, originBox) {
    $350541e2d10af992$export$a0230ae482601ae8(box.x, originBox.x);
    $350541e2d10af992$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $e3be0578d1881dff$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $3cadfa9c5538c02d$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $3cadfa9c5538c02d$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $e3be0578d1881dff$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $e8f3e6c5adc69edc$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $e3be0578d1881dff$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $e3be0578d1881dff$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $e3be0578d1881dff$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $e3be0578d1881dff$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $e3be0578d1881dff$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $e3be0578d1881dff$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $e3be0578d1881dff$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $e3be0578d1881dff$export$42b76f1d0d16d5b(box.x, transforms, $e3be0578d1881dff$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $e3be0578d1881dff$export$42b76f1d0d16d5b(box.y, transforms, $e3be0578d1881dff$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $62d95540b2cf82c6$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $62d95540b2cf82c6$export$a7ec7642fe550fb6(delta) {
    return $62d95540b2cf82c6$var$isAxisDeltaZero(delta.x) && $62d95540b2cf82c6$var$isAxisDeltaZero(delta.y);
}
function $62d95540b2cf82c6$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $62d95540b2cf82c6$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $62d95540b2cf82c6$export$c5706146bc63213(box) {
    return (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(box.x) / (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(box.y);
}



class $b677bc2ebc452ee9$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $e1a92a4c0809d32f$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $80818efe87296e52$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $06918006e178146a$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $d2a9bfd104bd5453$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $80818efe87296e52$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






/**
 * Timeout defined in ms
 */ function $ada4fe415778225f$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $301e135f87ffeb5c$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(checkElapsed);
}



function $c6d089d6a3230b9d$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $02609ec916d1eee0$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $4f9c70393d0d9e1f$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value : (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $b414a5ed52d2ead3$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}








const $691a2a8b4741efa1$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $691a2a8b4741efa1$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $691a2a8b4741efa1$var$animationTarget = 1000;
let $691a2a8b4741efa1$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $691a2a8b4741efa1$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $691a2a8b4741efa1$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $691a2a8b4741efa1$var$isOptimisedAppearTree(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return false;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return false;
    else if ((0, $a2e0096f48bfe337$export$5f8d21e84d1d84fc)(visualElement)) return true;
    else if (projectionNode.parent && !projectionNode.parent.hasCheckedOptimisedAppear) return $691a2a8b4741efa1$var$isOptimisedAppearTree(projectionNode.parent);
    else return false;
}
function $691a2a8b4741efa1$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $691a2a8b4741efa1$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $691a2a8b4741efa1$var$projectionFrameData.totalNodes = $691a2a8b4741efa1$var$projectionFrameData.resolvedTargetDeltas = $691a2a8b4741efa1$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($691a2a8b4741efa1$export$131f2f0cc5fe9609);
                this.nodes.forEach($691a2a8b4741efa1$var$resolveTargetDelta);
                this.nodes.forEach($691a2a8b4741efa1$var$calcProjection);
                this.nodes.forEach($691a2a8b4741efa1$export$c2664f37bc951031);
                (0, $c6d089d6a3230b9d$export$e5185e241753e543)($691a2a8b4741efa1$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $06918006e178146a$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $02609ec916d1eee0$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $ada4fe415778225f$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($691a2a8b4741efa1$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $691a2a8b4741efa1$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $62d95540b2cf82c6$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $1d127c5bbdfabc9c$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $691a2a8b4741efa1$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($691a2a8b4741efa1$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.HandoffCancelAllAnimations && $691a2a8b4741efa1$var$isOptimisedAppearTree(this)) window.HandoffCancelAllAnimations();
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($691a2a8b4741efa1$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($691a2a8b4741efa1$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($691a2a8b4741efa1$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($691a2a8b4741efa1$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($691a2a8b4741efa1$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $960d9779faf6f40c$export$2da9be4cfdb689b1).now();
            (0, $301e135f87ffeb5c$export$fff89137e9e818ce).delta = (0, $b55556710a8b54c0$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp);
            (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp = now;
            (0, $301e135f87ffeb5c$export$fff89137e9e818ce).isProcessing = true;
            (0, $301e135f87ffeb5c$export$be3f796aed065412).update.process((0, $301e135f87ffeb5c$export$fff89137e9e818ce));
            (0, $301e135f87ffeb5c$export$be3f796aed065412).preRender.process((0, $301e135f87ffeb5c$export$fff89137e9e818ce));
            (0, $301e135f87ffeb5c$export$be3f796aed065412).render.process((0, $301e135f87ffeb5c$export$fff89137e9e818ce));
            (0, $301e135f87ffeb5c$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $a1ef008917ac1826$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($691a2a8b4741efa1$var$clearSnapshot);
            this.sharedNodes.forEach($691a2a8b4741efa1$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $301e135f87ffeb5c$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $62d95540b2cf82c6$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $691a2a8b4741efa1$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $3cadfa9c5538c02d$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $43492ab836cff22d$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $43492ab836cff22d$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $350541e2d10af992$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $e3be0578d1881dff$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) (0, $e3be0578d1881dff$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $a1e42a4af2333fb7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $3cadfa9c5538c02d$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $691a2a8b4741efa1$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $43492ab836cff22d$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $43492ab836cff22d$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $301e135f87ffeb5c$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $350541e2d10af992$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $3cadfa9c5538c02d$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $e1a92a4c0809d32f$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $691a2a8b4741efa1$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($691a2a8b4741efa1$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $691a2a8b4741efa1$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $691a2a8b4741efa1$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $691a2a8b4741efa1$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $62d95540b2cf82c6$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $350541e2d10af992$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $b0eff65bd8993999$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $301e135f87ffeb5c$export$2cef06c20297c17d).update(()=>{
                (0, $d92fcbc1a711d121$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $4f9c70393d0d9e1f$export$335a17c977067b99)(0, $691a2a8b4741efa1$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($691a2a8b4741efa1$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $691a2a8b4741efa1$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                const xLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $350541e2d10af992$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $3cadfa9c5538c02d$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $b677bc2ebc452ee9$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $691a2a8b4741efa1$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $691a2a8b4741efa1$var$transformAxes.length; i++){
                $691a2a8b4741efa1$var$resetDistortingTransform(`rotate${$691a2a8b4741efa1$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $691a2a8b4741efa1$var$resetDistortingTransform(`skew${$691a2a8b4741efa1$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $691a2a8b4741efa1$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $43492ab836cff22d$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $e1a92a4c0809d32f$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $93099dc5c3aa7524$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $93099dc5c3aa7524$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $a6687c7d507e2d36$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($691a2a8b4741efa1$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $691a2a8b4741efa1$var$updateLayout(node) {
    node.updateLayout();
}
function $691a2a8b4741efa1$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($691a2a8b4741efa1$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $2c62bc0ac9269350$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $a1e42a4af2333fb7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
        (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $704cbd53c53f9d5c$export$3d227df54007d73a)();
        if (isShared) (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $a1e42a4af2333fb7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $62d95540b2cf82c6$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
                    (0, $a1e42a4af2333fb7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $62d95540b2cf82c6$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $691a2a8b4741efa1$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $691a2a8b4741efa1$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $691a2a8b4741efa1$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $691a2a8b4741efa1$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $691a2a8b4741efa1$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $691a2a8b4741efa1$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $691a2a8b4741efa1$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $691a2a8b4741efa1$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $691a2a8b4741efa1$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $691a2a8b4741efa1$var$calcProjection(node) {
    node.calcProjection();
}
function $691a2a8b4741efa1$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $691a2a8b4741efa1$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $691a2a8b4741efa1$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $691a2a8b4741efa1$export$6ffd3e6ae339a132(output, from, to, p) {
    $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $691a2a8b4741efa1$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $691a2a8b4741efa1$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $691a2a8b4741efa1$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $691a2a8b4741efa1$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $691a2a8b4741efa1$var$roundPoint = $691a2a8b4741efa1$var$userAgentContains("applewebkit/") && !$691a2a8b4741efa1$var$userAgentContains("chrome/") ? Math.round : (0, $001eda3aa79c6ebe$export$8793edee2d425525);
function $691a2a8b4741efa1$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $691a2a8b4741efa1$var$roundPoint(axis.min);
    axis.max = $691a2a8b4741efa1$var$roundPoint(axis.max);
}
function $691a2a8b4741efa1$var$roundBox(box) {
    $691a2a8b4741efa1$var$roundAxis(box.x);
    $691a2a8b4741efa1$var$roundAxis(box.y);
}
function $691a2a8b4741efa1$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $a1e42a4af2333fb7$export$28d0384c4b79bde2)((0, $62d95540b2cf82c6$export$c5706146bc63213)(snapshot), (0, $62d95540b2cf82c6$export$c5706146bc63213)(layout), 0.2);
}




const $26dc2139c924a231$export$2d029a49a09b6177 = (0, $691a2a8b4741efa1$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $a8c57a49f398792d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $89f9370edb229af5$export$b91509fcf893b648 = {
    current: undefined
};
const $89f9370edb229af5$export$b61a9eb3dbde8858 = (0, $691a2a8b4741efa1$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$89f9370edb229af5$export$b91509fcf893b648.current) {
            const documentNode = new (0, $26dc2139c924a231$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $89f9370edb229af5$export$b91509fcf893b648.current = documentNode;
        }
        return $89f9370edb229af5$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $be25e9ea22024a07$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $07770208fc6498da$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $aedcddc2627aa96c$export$5d97dc2872682820),
        ProjectionNode: (0, $89f9370edb229af5$export$b61a9eb3dbde8858),
        MeasureLayout: $c3c24be56499347e$export$779f5fb01ad751cd
    }
};



var $exYeM = parcelRequire("exYeM");









// Does this device prefer reduced motion? Returns `null` server-side.
const $51b97d8ce853ec4e$export$ff7706047246b98b = {
    current: null
};
const $51b97d8ce853ec4e$export$6476d16e2fd2d0db = {
    current: false
};


function $aec9488d77744f8a$export$ca9f41fb23dded3d() {
    (0, $51b97d8ce853ec4e$export$6476d16e2fd2d0db).current = true;
    if (!(0, $c763d68aeba74b31$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $51b97d8ce853ec4e$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $51b97d8ce853ec4e$export$ff7706047246b98b).current = false;
}














function $36e186eef14354e1$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $78c97899e24aca1c$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $78c97899e24aca1c$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $2a8cc64b32f75635$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $b271d9f56e72d485$var$valueTypes = [
    ...(0, $b2fd586ec5020ed9$export$d176691c1998a1f5),
    (0, $9aa3b4c939055303$export$35e9368ef982300f),
    (0, $20185419c445ef46$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $b271d9f56e72d485$export$950e7e59ea1ffed7 = (v)=>$b271d9f56e72d485$var$valueTypes.find((0, $0a85921ea474cb14$export$6eae4d0a6a7ca7cd)(v));





const $47882417e3714d5d$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $47882417e3714d5d$var$numVariantProps = (0, $46d8d186c05e43b0$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $47882417e3714d5d$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        this.resolveKeyframes = (keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value)=>{
            return new this.KeyframeResolver(keyframes, onComplete, name, value, this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $80c84fe89f88d202$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $301e135f87ffeb5c$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $6d3c07e99f9f7e5a$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $6d3c07e99f9f7e5a$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $78c97899e24aca1c$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $2a8cc64b32f75635$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $51b97d8ce853ec4e$export$6476d16e2fd2d0db).current) (0, $aec9488d77744f8a$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $51b97d8ce853ec4e$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $2a8cc64b32f75635$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $301e135f87ffeb5c$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $301e135f87ffeb5c$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $f7fe4e10b799a8b2$export$65570e08d843624d){
            const featureDefinition = (0, $f7fe4e10b799a8b2$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $47882417e3714d5d$var$propEventHandlers.length; i++){
            const key = $47882417e3714d5d$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $36e186eef14354e1$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $47882417e3714d5d$var$numVariantProps; i++){
            const name = (0, $46d8d186c05e43b0$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $a36779356b36fa8a$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $4b2846f88af5423d$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $fe062db003bcffb8$export$65583ed5a868f2d9)(value) || (0, $dc25af1e857ab50f$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $b271d9f56e72d485$export$950e7e59ea1ffed7)(value) && (0, $20185419c445ef46$export$83a0e34f1302825b).test(target)) value = (0, $f39674aa42131bf6$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $65e8d3d378a9947e$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $1527d424ce16b34c$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $65e8d3d378a9947e$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $97358bb0f01597b3$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $8825121c87528f05$export$e49735c2a366bdc7 extends (0, $47882417e3714d5d$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $891e5637f91f7d52$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}



function $b877597daa557132$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $b877597daa557132$export$23fea75b03ac16b3 extends (0, $8825121c87528f05$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $b877597daa557132$export$3735103072e4a80(instance);
            const value = ((0, $7788fac55eb8bc79$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $5df6dc38d07b7e46$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $d5a7ccaf3657bbce$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $e87aa36d3552d0b1$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $4d3a9c3652fbcbe3$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $83f9c44d75db63b5$export$86bcdffbaf733d84 extends (0, $8825121c87528f05$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $da211e07316d6e39$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $10ea5fd01401393b$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $53f5831d8ff6fe26$export$28931db5d57958e5).has(key) ? (0, $ccc055b4a72c1347$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $704cbd53c53f9d5c$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $4c74588f3910fe04$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, options, props) {
        (0, $22afbc6679b4fb16$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $6ecc69af052e005d$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $e49695f00398c04d$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $38a6ac1b54bc169a$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $9c5a7490b01b42fd$export$88f3fc2fd3766989)(Component) ? new (0, $83f9c44d75db63b5$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $b877597daa557132$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $exYeM.Fragment),
        enableHardwareAcceleration: true
    });
};




const $f035b7047036e216$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $89f9370edb229af5$export$b61a9eb3dbde8858),
        MeasureLayout: $c3c24be56499347e$export$779f5fb01ad751cd
    }
};


const $8667dd4cd334d17b$var$preloadedFeatures = {
    ...(0, $7170ce59c2debd45$export$7f9953c70dacfd7f),
    ...(0, $60b1baafc37a77f3$export$e5b72898e5a201f1),
    ...(0, $be25e9ea22024a07$export$d7d5d435647ed5a0),
    ...(0, $f035b7047036e216$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $8667dd4cd334d17b$export$e25e478948902b8b = /*@__PURE__*/ (0, $6b2ebacab9b54f79$export$a28d6df673050e18)((Component, config)=>(0, $e939d64425c6240c$export$732916c0e88175fb)(Component, config, $8667dd4cd334d17b$var$preloadedFeatures, (0, $38a6ac1b54bc169a$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $8667dd4cd334d17b$export$546614c4a05701f9(key) {
    return (0, $002ee5308395fa07$export$46b7e4b9dc6110c3)((0, $e939d64425c6240c$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $8667dd4cd334d17b$var$preloadedFeatures, (0, $38a6ac1b54bc169a$export$56ba0183203348f5)));
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

const $5f3d4e3683a59e56$var$cn = (...classes)=>classes.filter(Boolean).join(" ");
const $5f3d4e3683a59e56$export$668799e4797757a8 = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "absolute inset-0 h-full w-full pointer-events-none z-0",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "absolute inset-0 h-full w-full bg-white pointer-events-none [mask-image:radial-gradient(ellipse_at_center,transparent,white)]"
            }),
            Array.from({
                length: 6
            }).map((_, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "flex",
                    children: Array.from({
                        length: 10
                    }).map((_, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)($5f3d4e3683a59e56$var$GridBlock, {}, `grid-row` + index))
                }, "grid-column" + index))
        ]
    });
};
const $5f3d4e3683a59e56$var$GridBlock = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col items-start justify-center  w-60",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($5f3d4e3683a59e56$var$Dot, {}),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($5f3d4e3683a59e56$var$SVG, {})
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($5f3d4e3683a59e56$var$SVGVertical, {
                className: "ml-3"
            })
        ]
    });
};
const $5f3d4e3683a59e56$var$Dot = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "h-6 w-6 bg-white  flex items-center justify-center rounded-full",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "h-2 w-2 bg-neutral-200  rounded-full"
        })
    });
};
const $5f3d4e3683a59e56$var$SVGVertical = ({ className: className })=>{
    const width = 1;
    const height = 140;
    const id = (0, $exYeM.useId)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).svg, {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: $5f3d4e3683a59e56$var$cn("text-neutral-100 ", className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M0.5 0.5V479",
                stroke: "currentColor",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).path, {
                d: "M0.5 0.5V479",
                stroke: `url(#gradient-${id})`,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("defs", {
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).linearGradient, {
                    id: `gradient-${id}`,
                    initial: {
                        x1: 2,
                        y1: -200,
                        x2: 2,
                        y2: -100
                    },
                    animate: {
                        x1: 2,
                        y1: 400,
                        x2: 2,
                        y2: 600
                    },
                    transition: {
                        repeat: Infinity,
                        duration: Math.random() * 2 + 1,
                        delay: Math.floor(Math.random() * 6) + 5
                    },
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).stop, {
                            offset: "0%",
                            stopColor: "transparent"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).stop, {
                            offset: "50%",
                            stopColor: "var(--neutral-200)"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).stop, {
                            offset: "100%",
                            stopColor: "transparent"
                        })
                    ]
                })
            })
        ]
    });
};
const $5f3d4e3683a59e56$var$SVG = ({ className: className })=>{
    const width = 300;
    const height = 1;
    const id = (0, $exYeM.useId)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).svg, {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: $5f3d4e3683a59e56$var$cn("text-neutral-100 ", className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M0.5 0.5H479",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).path, {
                d: "M0.5 0.5H479",
                stroke: `url(#gradient-${id})`,
                strokeWidth: 1
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("defs", {
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).linearGradient, {
                    id: `gradient-${id}`,
                    initial: {
                        x1: -200,
                        y1: 0,
                        x2: -100,
                        y2: 0
                    },
                    animate: {
                        x1: 400,
                        y1: 0,
                        x2: 600,
                        y2: 0
                    },
                    transition: {
                        repeat: Infinity,
                        duration: Math.random() * 2 + 1,
                        delay: Math.floor(Math.random() * 6) + 5
                    },
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).stop, {
                            offset: "0%",
                            stopColor: "transparent"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).stop, {
                            offset: "50%",
                            stopColor: "var(--neutral-200)"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).stop, {
                            offset: "100%",
                            stopColor: "transparent"
                        })
                    ]
                })
            })
        ]
    });
};
var $5f3d4e3683a59e56$export$2e2bcd8739ae039 = $5f3d4e3683a59e56$export$668799e4797757a8;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

const $30fc131f9923fe0a$var$AnimatedBadge = ({ children: children, href: href, newLabel: newLabel })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
        className: "mb-1.5 rounded-full bg-neutral-50  p-px text-sm md:shadow-2xl shadow-zinc-900",
        whileHover: {
            rotate: -2
        },
        transition: {
            duration: 0.3
        },
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
            href: href,
            target: "_blank",
            rel: " noreferrer noopener",
            className: "group cursor-pointer relative rounded-full no-underline inline-block w-fit mx-auto",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: "absolute inset-0 overflow-hidden rounded-full",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "absolute inset-0 rounded-full opacity-0 transition-opacity duration-500 group-hover:opacity-100 bg-primary"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "relative flex items-center z-10 rounded-full bg-neutral-100  py-1.5 px-4 ring-1 ring-white/10",
                    children: [
                        newLabel && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            className: "rounded-full bg-secondary-new px-2 py-0.5 text-neutral-700 mr-2 font-bold",
                            children: newLabel
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            className: "text-neutral-700  font-bold",
                            children: children
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                            fill: "none",
                            height: "16",
                            viewBox: "0 0 24 24",
                            width: "16",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "ml-2",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                d: "M10.75 8.75L14.25 12L10.75 15.25",
                                stroke: "currentColor",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "1.5"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: "absolute -bottom-0 left-[1.125rem] h-px w-[calc(100%-2.25rem)] bg-gradient-to-r from-neutral-400/0 via-neutral-400/90 to-neutral-400/0 transition-opacity duration-500 group-hover:opacity-40"
                })
            ]
        })
    });
};
const $30fc131f9923fe0a$var$App = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "p-8",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($30fc131f9923fe0a$var$AnimatedBadge, {
            href: "query",
            newLabel: "New",
            children: "Query is live!"
        })
    });
};
var $30fc131f9923fe0a$export$2e2bcd8739ae039 = $30fc131f9923fe0a$var$App;


const $fbbcad3c5e023440$var$GRID_BOX_SIZE = 32;
const $fbbcad3c5e023440$var$BEAM_WIDTH_OFFSET = 1;
const $fbbcad3c5e023440$var$AnimatedGetStartedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(({ onClick: onClick })=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
        onClick: onClick,
        className: `
      relative z-0 flex items-center justify-center overflow-hidden rounded-lg
      bg-primary px-6 py-3 text-md sm:text-lg font-semibold
      text-white transition-all duration-500 shadow-md hover:shadow-lg

      before:absolute before:inset-0
      before:-z-10 before:translate-x-[150%]
      before:translate-y-[150%] before:scale-[2.5]
      before:rounded-[100%] before:bg-white
      before:transition-transform before:duration-1000
      before:content-[""]

      hover:scale-105 hover:text-primary
      hover:before:translate-x-[0%]
      hover:before:translate-y-[0%]
      active:scale-95`,
        children: "Get started"
    }));
$fbbcad3c5e023440$var$AnimatedGetStartedButton.displayName = "AnimatedGetStartedButton";
const $fbbcad3c5e023440$var$useWindowSize = ()=>{
    const [windowSize, setWindowSize] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState({
        width: undefined,
        height: undefined
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const handleResize = ()=>setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};
const $fbbcad3c5e023440$var$Beam = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(({ top: top, left: left, transition: transition = {} })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
        initial: {
            y: 0,
            opacity: 0
        },
        animate: {
            opacity: [
                0,
                1,
                0
            ],
            y: 256
        },
        transition: {
            ease: "easeInOut",
            duration: 3,
            repeat: Infinity,
            repeatDelay: 1.5,
            ...transition
        },
        style: {
            top: top,
            left: left
        },
        className: "absolute z-10 h-[64px] w-[1px] bg-gradient-to-b from-primary/0 to-primary"
    }));
$fbbcad3c5e023440$var$Beam.displayName = "Beam";
const $fbbcad3c5e023440$var$Beams = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(()=>{
    const { width: width } = $fbbcad3c5e023440$var$useWindowSize();
    const numColumns = width ? Math.floor(width / $fbbcad3c5e023440$var$GRID_BOX_SIZE) : 0;
    const placements = (0, $exYeM.useMemo)(()=>[
            {
                top: $fbbcad3c5e023440$var$GRID_BOX_SIZE * 0,
                left: Math.floor(numColumns * 0.05) * $fbbcad3c5e023440$var$GRID_BOX_SIZE,
                transition: {
                    duration: 3.5,
                    repeatDelay: 5,
                    delay: 2
                }
            },
            {
                top: $fbbcad3c5e023440$var$GRID_BOX_SIZE * 12,
                left: Math.floor(numColumns * 0.15) * $fbbcad3c5e023440$var$GRID_BOX_SIZE,
                transition: {
                    duration: 3.5,
                    repeatDelay: 10,
                    delay: 4
                }
            },
            {
                top: $fbbcad3c5e023440$var$GRID_BOX_SIZE * 3,
                left: Math.floor(numColumns * 0.25) * $fbbcad3c5e023440$var$GRID_BOX_SIZE
            },
            {
                top: $fbbcad3c5e023440$var$GRID_BOX_SIZE * 9,
                left: Math.floor(numColumns * 0.75) * $fbbcad3c5e023440$var$GRID_BOX_SIZE,
                transition: {
                    duration: 2,
                    repeatDelay: 7.5,
                    delay: 3.5
                }
            },
            {
                top: 0,
                left: Math.floor(numColumns * 0.7) * $fbbcad3c5e023440$var$GRID_BOX_SIZE,
                transition: {
                    duration: 3,
                    repeatDelay: 2,
                    delay: 1
                }
            },
            {
                top: $fbbcad3c5e023440$var$GRID_BOX_SIZE * 2,
                left: Math.floor(numColumns * 1) * $fbbcad3c5e023440$var$GRID_BOX_SIZE - $fbbcad3c5e023440$var$GRID_BOX_SIZE,
                transition: {
                    duration: 5,
                    repeatDelay: 5,
                    delay: 5
                }
            }
        ], [
        numColumns
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: placements.map((p, i)=>/*#__PURE__*/ (0, $aSiaI.jsx)($fbbcad3c5e023440$var$Beam, {
                top: p.top,
                left: p.left - $fbbcad3c5e023440$var$BEAM_WIDTH_OFFSET,
                transition: p.transition || {}
            }, i))
    });
});
$fbbcad3c5e023440$var$Beams.displayName = "Beams";
const $fbbcad3c5e023440$var$GradientGrid = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(()=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        transition: {
            duration: 2.5,
            ease: "easeInOut"
        },
        className: "absolute inset-0 z-0",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                style: {
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32' height='32' fill='none' stroke-width='2' stroke='rgb(128 128 128 / 0.1)'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e")`
                },
                className: "absolute inset-0 z-0"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "absolute inset-0 z-10 bg-gradient-to-b from-white/0 to-white"
            })
        ]
    }));
$fbbcad3c5e023440$var$GradientGrid.displayName = "GradientGrid";
const $fbbcad3c5e023440$var$HeroSection = ()=>{
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const handleGetStarted = (0, $exYeM.useCallback)(()=>navigate("/Explore?blockchain=Ethereum"), [
        navigate
    ]);
    const handleLearnMore = (0, $exYeM.useCallback)(()=>navigate("/Pricing"), [
        navigate
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative pt-10 pb-20 sm:py-24 z-0 overflow-hidden bg-white",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5f3d4e3683a59e56$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                initial: {
                    opacity: 0.0,
                    y: 40
                },
                whileInView: {
                    opacity: 1,
                    y: 0
                },
                transition: {
                    delay: 0.2,
                    duration: 0.7,
                    ease: "easeInOut"
                },
                className: "relative mx-auto max-w-[90rem] pb-4 flex flex-col items-center text-center font-roboto gap-4 z-10",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $30fc131f9923fe0a$export$2e2bcd8739ae039), {
                        href: "#",
                        newLabel: "New",
                        children: "Query is live!"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("h1", {
                        className: "text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight text-gray-800 mb-4 font-monda leading-tight",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "block",
                                children: [
                                    "Transforming",
                                    " ",
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                        className: "relative inline-block",
                                        children: [
                                            "Data",
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "absolute bottom-0 left-0 w-full h-3 bg-primary opacity-50"
                                            })
                                        ]
                                    }),
                                    " ",
                                    "Into"
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "block",
                                children: [
                                    "Actionable",
                                    " ",
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                        className: "relative inline-block",
                                        children: [
                                            "Market",
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "absolute bottom-0 left-0 w-full h-3 bg-primary opacity-50"
                                            })
                                        ]
                                    }),
                                    " ",
                                    "Insights"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                        className: "mt-4 text-xl md:text-2xl text-gray-500 max-w-3xl",
                        children: "Unlock real-time blockchain insights with Wevr.ai. Our AI-powered tools decode market trends, sentiment, and on-chain activity, empowering investors and researchers to stay ahead in the crypto space."
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center gap-x-6 mt-10",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)($fbbcad3c5e023440$var$AnimatedGetStartedButton, {
                                onClick: handleGetStarted
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).button, {
                                onClick: handleLearnMore,
                                className: "text-gray-500 text-md sm:text-lg py-3 px-6 text-center font-semibold flex items-center gap-2 hover:text-secondary-dark group",
                                whileHover: "hover",
                                children: [
                                    "Learn more",
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).span, {
                                        variants: {
                                            hover: {
                                                x: 5
                                            }
                                        },
                                        transition: {
                                            type: "spring",
                                            stiffness: 400,
                                            damping: 10
                                        },
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $788049de1171759f$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$fbbcad3c5e023440$var$HeroSection.displayName = "HeroSection";
var $fbbcad3c5e023440$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo($fbbcad3c5e023440$var$HeroSection);



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

function $a949daf2cc278282$export$80c2a3957bcb42ea() {
    const isMounted = (0, $exYeM.useRef)(false);
    (0, $0e2d049f2abcd2c9$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



function $e3793b3f0bbd618f$export$91db9bc4f8ac944a() {
    const isMounted = (0, $a949daf2cc278282$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $exYeM.useState)(0);
    const forceRender = (0, $exYeM.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $exYeM.useCallback)(()=>(0, $301e135f87ffeb5c$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $da62d876e989a420$var$PopChildMeasure extends $exYeM.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $da62d876e989a420$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $exYeM.useId)();
    const ref = (0, $exYeM.useRef)(null);
    const size = (0, $exYeM.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $exYeM.useContext)((0, $2d642de93cca1124$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $exYeM.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $aSiaI.jsx)($da62d876e989a420$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $exYeM.cloneElement(children, {
            ref: ref
        })
    });
}


const $47d1b175d59538db$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $73d7e626f45c1838$export$fe4300aa8eebea86)($47d1b175d59538db$var$newChildrenMap);
    const id = (0, $exYeM.useId)();
    const context = (0, $exYeM.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $exYeM.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $exYeM.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $aSiaI.jsx)((0, $da62d876e989a420$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $aSiaI.jsx)((0, $32835478aabc17b5$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $47d1b175d59538db$var$newChildrenMap() {
    return new Map();
}





var $exYeM = parcelRequire("exYeM");
function $5575fd4776144082$export$f3a192d0cbd30b96(callback) {
    return (0, $exYeM.useEffect)(()=>()=>callback(), []);
}



const $9744623a78dc500b$var$getChildKey = (child)=>child.key || "";
function $9744623a78dc500b$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $9744623a78dc500b$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $9744623a78dc500b$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $exYeM.Children).forEach(children, (child)=>{
        if ((0, $exYeM.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $9744623a78dc500b$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $21125973824588d9$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $exYeM.useContext)((0, $0d8fa753a19a110b$export$a3579ca508007a95)).forceRender || (0, $e3793b3f0bbd618f$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $a949daf2cc278282$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $9744623a78dc500b$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $exYeM.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $exYeM.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $exYeM.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $exYeM.useRef)(true);
    (0, $0e2d049f2abcd2c9$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $9744623a78dc500b$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $5575fd4776144082$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: childrenToRender.map((child)=>(0, $aSiaI.jsx)((0, $47d1b175d59538db$export$979daf65881a382a), {
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                children: child
            }, $9744623a78dc500b$var$getChildKey(child)))
    });
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($9744623a78dc500b$var$getChildKey);
    const targetKeys = filteredChildren.map($9744623a78dc500b$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $9744623a78dc500b$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = (0, $aSiaI.jsx)((0, $47d1b175d59538db$export$979daf65881a382a), {
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                children: child
            }, $9744623a78dc500b$var$getChildKey(child));
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : (0, $aSiaI.jsx)((0, $47d1b175d59538db$export$979daf65881a382a), {
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode,
            children: child
        }, $9744623a78dc500b$var$getChildKey(child));
    });
    return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $exYeM.cloneElement)(child))
    });
};



// THIS FILE IS AUTO GENERATED
var $d4df56509c2f3a34$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "MIT",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $415593bdca1dce8c$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $415593bdca1dce8c$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext($415593bdca1dce8c$export$4a4ef469214f8641);


var $df56e6fd156449a5$var$_excluded = [
    "attr",
    "size",
    "title"
];
function $df56e6fd156449a5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $df56e6fd156449a5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $df56e6fd156449a5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $df56e6fd156449a5$var$_extends() {
    $df56e6fd156449a5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $df56e6fd156449a5$var$_extends.apply(this, arguments);
}
function $df56e6fd156449a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df56e6fd156449a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df56e6fd156449a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $df56e6fd156449a5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df56e6fd156449a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df56e6fd156449a5$var$_defineProperty(obj, key, value) {
    key = $df56e6fd156449a5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $df56e6fd156449a5$var$_toPropertyKey(t) {
    var i = $df56e6fd156449a5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $df56e6fd156449a5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $df56e6fd156449a5$var$Tree2Element(tree) {
    return tree && tree.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(node.tag, $df56e6fd156449a5$var$_objectSpread({
            key: i
        }, node.attr), $df56e6fd156449a5$var$Tree2Element(node.child)));
}
function $df56e6fd156449a5$export$6fce6cce1e9a936d(data) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($df56e6fd156449a5$export$a188ecdd443fe91a, $df56e6fd156449a5$var$_extends({
            attr: $df56e6fd156449a5$var$_objectSpread({}, data.attr)
        }, props), $df56e6fd156449a5$var$Tree2Element(data.child));
}
function $df56e6fd156449a5$export$a188ecdd443fe91a(props) {
    var elem = (conf)=>{
        var { attr: attr, size: size, title: title } = props, svgProps = $df56e6fd156449a5$var$_objectWithoutProperties(props, $df56e6fd156449a5$var$_excluded);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("svg", $df56e6fd156449a5$var$_extends({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $df56e6fd156449a5$var$_objectSpread($df56e6fd156449a5$var$_objectSpread({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("title", null, title), props.children);
    };
    return (0, $415593bdca1dce8c$export$a49f528ae1a4d0ed) !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $415593bdca1dce8c$export$a49f528ae1a4d0ed).Consumer, null, (conf)=>elem(conf)) : elem((0, $415593bdca1dce8c$export$4a4ef469214f8641));
}





function $37f9bcffaadb69fd$export$267f6a665e00ab4f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 18 12 15 21 9 3 6 12 2 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f15509c0f38da8af(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 15 17 21 7 21 12 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$8e5723405180c9a9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12.01",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$dbcde33461007065(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12.01",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$e155fac140286da3(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "12",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12.01",
                    "y2": "17"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$95a4188b594d565e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "10",
                    "x2": "6",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "18",
                    "x2": "6",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2eb341b7ea186bea(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "10",
                    "x2": "3",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$8917cc30b8759ee1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "10",
                    "x2": "3",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$97ded619a1b970b7(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "10",
                    "x2": "7",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "7",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f9204ad967d5d65e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H2a10 10 0 0 0 20 0h-3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a7e9a61a7dec6d79(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.31",
                    "y1": "8",
                    "x2": "20.05",
                    "y2": "17.94"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.69",
                    "y1": "8",
                    "x2": "21.17",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7.38",
                    "y1": "12",
                    "x2": "13.12",
                    "y2": "2.06"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.69",
                    "y1": "16",
                    "x2": "3.95",
                    "y2": "6.06"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.31",
                    "y1": "16",
                    "x2": "2.83",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.62",
                    "y1": "12",
                    "x2": "10.88",
                    "y2": "21.94"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b2485051e564fce1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 8 21 21 3 21 3 8"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "22",
                    "height": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "12",
                    "x2": "14",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$dd3f3c5a1d53d77e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 12 12 16 16 12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$1c4fa461fc2194d3(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "7",
                    "x2": "7",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 17 7 17 7 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$34909c4d498f141d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "7",
                    "x2": "17",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 7 17 17 7 17"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fe357b1c469bec96(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "5",
                    "x2": "12",
                    "y2": "19"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 12 12 19 5 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$9004e83bb5a50648(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 8 8 12 12 16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "12",
                    "x2": "8",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$7d058c8fc42b3484(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "12",
                    "x2": "5",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 19 5 12 12 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$eba7d9ce28178b15(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 16 16 12 12 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a305b640abe8c4e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 5 19 12 12 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d80098591ae56d4d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 12 12 8 8 12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5ee40d2503752d98(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "17",
                    "x2": "7",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 17 7 7 17 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$e2b35aa7c05e571c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "17",
                    "x2": "17",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 7 17 7 17 17"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$de137450acf89135(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "5 12 12 5 19 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d06ac557cb156c7d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b16440d451f09912(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$13af84db5d19481e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "20",
                    "x2": "18",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "20",
                    "x2": "6",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$563c74cc78537c0(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "20",
                    "x2": "18",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "20",
                    "x2": "6",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$77d74f3b256203a6(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "13",
                    "x2": "23",
                    "y2": "11"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 6 7 12 13 12 9 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$dbf8d6020cf07ed9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "6",
                    "width": "18",
                    "height": "12",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "13",
                    "x2": "23",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$9bf443402bff5176(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 21a2 2 0 0 1-3.46 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.63 13A17.89 17.89 0 0 1 18 8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8a6 6 0 0 0-9.33-5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$daf9245cff6c3210(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 21a2 2 0 0 1-3.46 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5b16f71cb5b67dde(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$98a4866a23333521(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$898b357cbb3f5d73(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$44ad51dbc660c15f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4e077b34ae10f582(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a30da76548081d26(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ce1c504ffe508904(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$10d5cacd9501bbfa(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "4",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "2",
                    "x2": "16",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "2",
                    "x2": "8",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "10",
                    "x2": "21",
                    "y2": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$182c5362e9e947b9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a5d4befc3914f30d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3344d3255389e578(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "20",
                    "x2": "2.01",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2a34cadb9c7fec6d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 4 12 14.01 9 11.01"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$10e5555822717586(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 11 12 14 22 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$12b035227cf9389b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 6 9 17 4 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ea5380252b30a193(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 12 15 18 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b69eb2f9a0945674(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 18 9 12 15 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a8d72316988d19f1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 18 15 12 9 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4bd212f78cb84d52(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 15 12 9 6 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a3a94d20ee4ea213(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 13 12 18 17 13"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 6 12 11 17 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c1724d494c6a158(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 17 6 12 11 7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 17 13 12 18 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fcbcb5f8e4c2cdc9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 17 18 12 13 7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 17 11 12 6 7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a9318b47104fc04c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 11 12 6 7 11"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 18 12 13 7 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$689268c79dea320b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21.17",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3.95",
                    "y1": "6.06",
                    "x2": "8.54",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10.88",
                    "y1": "21.94",
                    "x2": "15.46",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$688d8c1a5580bd89(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$718f31b68f165ef9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "2",
                    "width": "8",
                    "height": "4",
                    "rx": "1",
                    "ry": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b8ec2cad8fdf41a5(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 16 14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f8e48da087d8be8a(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "19",
                    "x2": "8",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "13",
                    "x2": "8",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "19",
                    "x2": "16",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "16",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$72cf629fb485b05b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 11 9 17 15 17 11 23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$dc6782f64d5d7013(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$712e01a64a6f77b9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "16",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "13",
                    "x2": "8",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$85ca6c13dc79416(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "16",
                    "x2": "8.01",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "20",
                    "x2": "8.01",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12.01",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "16",
                    "x2": "16.01",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "20",
                    "x2": "16.01",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$df461c3a33a72420(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c13019c948ecce83(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 18 22 12 16 6"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 2 12 8 18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f02be8db599c1e5e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "15.5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 8.5 12 15.5 2 8.5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 15.5 12 8.5 22 15.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "8.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a950ee04ed5abdb0(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 4.21 12 6.81 16.5 4.21"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 19.79 7.5 14.6 3 12"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 12 16.5 14.6 16.5 19.79"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2711c7e04972826d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h1a4 4 0 0 1 0 8h-1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "1",
                    "x2": "6",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "1",
                    "x2": "10",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "1",
                    "x2": "14",
                    "y2": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$82d4ac863d8199c6(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$7936c63f41b1a738(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$37f1a632f3f1e184(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d343a2f87ee72e20(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "13",
                    "height": "13",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$530c7651f0e4ae78(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 10 4 15 9 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v7a4 4 0 0 1-4 4H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$e6e1cd3d1c9d6915(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 10 20 15 15 20"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v7a4 4 0 0 0 4 4h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4d34c0a7548c0109(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 15 9 20 4 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-7a4 4 0 0 0-4 4v12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$bb2c53af7dc04770(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 9 9 4 4 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20h-7a4 4 0 0 1-4-4V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2d36a8e2d41456f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 15 15 20 20 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7a4 4 0 0 1 4 4v12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$aed74f5f80ec8ca8(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 15 4 20 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h7a4 4 0 0 0 4-4V4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$805d9902e2ab469c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 14 4 9 9 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20v-7a4 4 0 0 0-4-4H4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2d853753f202e10b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 14 20 9 15 4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20v-7a4 4 0 0 1 4-4h12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4848b5bec045556f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "4",
                    "width": "16",
                    "height": "16",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "1",
                    "x2": "9",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "1",
                    "x2": "15",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "20",
                    "x2": "9",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "20",
                    "x2": "15",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "9",
                    "x2": "23",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "14",
                    "x2": "23",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "9",
                    "x2": "4",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "14",
                    "x2": "4",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5d6c3f93b1569306(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "4",
                    "width": "22",
                    "height": "16",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "10",
                    "x2": "23",
                    "y2": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$9e0e87fd57502d8d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.13 1L6 16a2 2 0 0 0 2 2h15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6.13L16 6a2 2 0 0 1 2 2v15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$49dcd8c24ba6abdc(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "12",
                    "x2": "18",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "12",
                    "x2": "2",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "6",
                    "x2": "12",
                    "y2": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$93556a14caec4876(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "rx": "9",
                    "ry": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$1a0218dab79e6acd(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "9",
                    "x2": "12",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "18",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d4210adab954a159(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$87a88561efeb5120(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$e2dff6a1006d5778(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$12ec33f352eb0e16(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4eea32b38871a225(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "1",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5cc2db742c978330(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 17 12 21 16 17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "12",
                    "x2": "12",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d455598edb9cdf88(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 10 12 15 17 10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$663255e234895e9b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b93929b4cf937656(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$72c1672405f8cac2(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3160a2892d0a1e20(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$54abe8530fbf9c81(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$dd412c17c542d388(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "14",
                    "x2": "21",
                    "y2": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$83d97bd7471aa8d8(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f601afa691591de3(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f32046460092cd1d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d8fce91115a92d98(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 19 22 12 13 5 13 19"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "2 19 11 12 2 5 2 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$27382a65ccd06d6e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "8",
                    "x2": "2",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "y1": "15",
                    "x2": "9",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$afd3026aee940215(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f7397199414900f2(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "15",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$8e5e18b0d5d02ea1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "15",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$19d242ec0e154174(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "8",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "17",
                    "x2": "8",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 9 9 8 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$dc61d91398194410(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 2 13 9 20 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$7f2e92e34dfb7902(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "2.18",
                    "ry": "2.18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "2",
                    "x2": "7",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "2",
                    "x2": "17",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "7",
                    "x2": "7",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "17",
                    "x2": "7",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "17",
                    "x2": "22",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "7",
                    "x2": "22",
                    "y2": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ebb93a1afb2fac1e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$64fe6fee89cd58a9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "22",
                    "x2": "4",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f07ffcc4d8a2c8ce(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "14",
                    "x2": "15",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$eb2e7a79d02ed668(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "11",
                    "x2": "12",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "14",
                    "x2": "15",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3b7b3b63ca44d1fb(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ed9f7cf4f0026f09(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2da71e1804b6f1aa(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16s-1.5-2-4-2-4 2-4 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fa0c86613abdbc41(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 12 20 22 4 22 4 12"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f17cfdf6fa84f40d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "3",
                    "x2": "6",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9a9 9 0 0 1-9 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$57ae875db121999c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1.05",
                    "y1": "12",
                    "x2": "7",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.01",
                    "y1": "12",
                    "x2": "22.96",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$89028bc8fe9485e4(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21V9a9 9 0 0 0 9 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$345bfaac6794bcf3(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h3a2 2 0 0 1 2 2v7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "9",
                    "x2": "6",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b45303d4b027680(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$89ad6403022d3567(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$9532411a3b87e58c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c436bd52326ef6(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "7",
                    "height": "7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "3",
                    "width": "7",
                    "height": "7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "14",
                    "width": "7",
                    "height": "7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "14",
                    "width": "7",
                    "height": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$795bedee3407657b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "12",
                    "x2": "2",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "16",
                    "x2": "6.01",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "16",
                    "x2": "10.01",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a6234e125b97d4f9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "9",
                    "x2": "20",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "15",
                    "x2": "20",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "3",
                    "x2": "8",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "3",
                    "x2": "14",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$1ccadd16d8cae7ff(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18v-6a9 9 0 0 1 18 0v6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$967ac3e653e15c7c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$42bfa0ad96d58c78(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12.01",
                    "y2": "17"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5a63c278e9612374(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2dbad18710467f1a(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 22 9 12 15 12 15 22"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a5e7deed97e8be52(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "8.5",
                    "r": "1.5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 15 16 10 5 21"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$8df41d1420605672(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 16 12 14 15 10 15 8 12 2 12"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$6d8c744810a836d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12.01",
                    "y2": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ebdbf4f9f5cef570(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "5",
                    "ry": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "y1": "6.5",
                    "x2": "17.51",
                    "y2": "6.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f3e51bbe4b2254b7(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "4",
                    "x2": "10",
                    "y2": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "20",
                    "x2": "5",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "4",
                    "x2": "9",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$e1edceb9a27803ae(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ead8715503aa206e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 2 7 12 12 22 7 12 2"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 17 12 22 22 17"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 12 12 17 22 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c5159196dfb06325(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "9",
                    "x2": "21",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "21",
                    "x2": "9",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4b89084dd540ab27(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "9.17",
                    "y2": "9.17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "14.83",
                    "x2": "19.07",
                    "y2": "19.07"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "9.17",
                    "x2": "19.07",
                    "y2": "4.93"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "9.17",
                    "x2": "18.36",
                    "y2": "5.64"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "19.07",
                    "x2": "9.17",
                    "y2": "14.83"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$437fb001e3a1dc1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c2c3e635615f60e2(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$61316a66a2680992(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "9",
                    "width": "4",
                    "height": "12"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "4",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f35e526aef9384c3(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "21",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "18",
                    "x2": "21",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "3.01",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "12",
                    "x2": "3.01",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "18",
                    "x2": "3.01",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a2a03a7f204c9a2b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "7.76",
                    "y2": "7.76"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.24",
                    "y1": "16.24",
                    "x2": "19.07",
                    "y2": "19.07"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "6",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "19.07",
                    "x2": "7.76",
                    "y2": "16.24"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.24",
                    "y1": "7.76",
                    "x2": "19.07",
                    "y2": "4.93"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fc54281b4f076899(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "18",
                    "height": "11",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 10 0v4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ba59ace88551b501(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 17 15 12 10 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "12",
                    "x2": "3",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fa648a1b1cd7252e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 17 21 12 16 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "12",
                    "x2": "9",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$27a522d77d3d2d0(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22,6 12,13 2,6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ab316e04c4fb96fa(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$8333c1459f09a858(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "2",
                    "x2": "8",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "6",
                    "x2": "16",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$852110258456823(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 21 3 21 3 15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "3",
                    "x2": "14",
                    "y2": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "21",
                    "x2": "10",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$adff177e257c8166(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$abc08bc5980688a1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "15",
                    "x2": "16",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b50769225058330c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "12",
                    "x2": "21",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "18",
                    "x2": "21",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$91d40ccadbcaa6dc(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$49a9e42c2a6ffece(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2ea53e42be78e72b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "23",
                    "x2": "16",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$348220c4b7f2d758(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10v2a7 7 0 0 1-14 0v-2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "23",
                    "x2": "16",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$52e68ba7bb634014(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 14 10 14 10 20"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 10 14 10 14 4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "10",
                    "x2": "21",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "21",
                    "x2": "10",
                    "y2": "14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$476509ebc2f26d6e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$bba246dcbc7870e4(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$35534d1daae973a9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$6a0f8a0147922bb7(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$105b514200bcb0d7(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "3",
                    "width": "20",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "21",
                    "x2": "16",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fd61d60a57b49c46(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$9abca6f764c0a1ca(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$e7d9baa187481367(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5d53b998636c728f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13l6 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$725c09aded7eb198(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "5 9 2 12 5 15"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 5 12 2 15 5"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 19 12 22 9 19"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 9 22 12 19 15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "22"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b0938e003378ab3e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18V5l12-2v13"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$af9f6bab4a948d5(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 19 21 12 17 5 21 12 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$16d74993c11e543(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "3 11 22 2 13 21 11 13 3 11"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$33b10801cd3af8ff(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3081f0b32ed3dc59(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "16.5",
                    "y1": "9.4",
                    "x2": "7.5",
                    "y2": "4.21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c00bb0cc5868b468(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$cbd3dba13ee255b0(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "15",
                    "x2": "10",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "15",
                    "x2": "14",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3d4a4fdeb949ce6f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "4",
                    "width": "4",
                    "height": "16"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "4",
                    "width": "4",
                    "height": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3d8b351359898bf5(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19l7-7 3 3-7 7-3-3z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2l7.586 7.586"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$57628665534438ae(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "5",
                    "x2": "5",
                    "y2": "19"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "17.5",
                    "r": "2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5dafa2a769059963(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$efe11b9a623f0a7c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 1 23 5 19 9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "5",
                    "x2": "23",
                    "y2": "5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fb25afe8b8765154(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 2 16 8 22 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "16",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$cdce28fb1c312b97(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "17",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "1",
                    "x2": "23",
                    "y2": "7"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$95defb4444eec2fe(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "1",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$8f53edd09d52625d(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 7 23 1 17 1"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "8",
                    "x2": "23",
                    "y2": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fbcc38cc432837ad(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$cf5c74f5c9e34b73(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12A10 10 0 0 0 12 2v10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$63ac2a4ccaccfbd1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "10 8 16 12 10 16 10 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$af6bc9d78ff8665b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 3 19 12 5 21 5 3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$23b33cecb582b8d5(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ece0f5709a547496(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$689fe09b4199e823(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "5",
                    "x2": "12",
                    "y2": "19"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$a5bf41cb81ae473(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 10 12 14 16 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2606d8589e7177aa(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 6.64a9 9 0 1 1-12.73 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$95dd116dec35b14(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 6 2 18 2 18 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "14",
                    "width": "12",
                    "height": "8"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b82f164df0732a68(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$1ca0fe7999deb8e7(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 4 1 10 7 10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 20 23 14 17 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2d21aa9a27745075(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 4 23 10 17 10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 20 1 14 7 14"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$6f57f453a8536a97(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 1 21 5 17 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11V9a4 4 0 0 1 4-4h14"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 23 3 19 7 15"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13v2a4 4 0 0 1-4 4H3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d056b1c3d8b74afa(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 19 2 12 11 5 11 19"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 19 13 12 22 5 22 19"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$70f49501e9e85938(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 4 1 10 7 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b2facb794a39aa57(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 4 23 10 17 10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$7118af05ee41ff35(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11a9 9 0 0 1 9 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a16 16 0 0 1 16 16"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "1"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$1104f45674df9c12(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 21 17 13 7 13 7 21"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 3 7 8 15 8"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$97278c76d25f8f7c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "4",
                    "x2": "8.12",
                    "y2": "15.88"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.47",
                    "y1": "14.48",
                    "x2": "20",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.12",
                    "y1": "8.12",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ec3b49c1346d2396(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3ab14b0b4740d7e5(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "2",
                    "x2": "11",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 2 15 22 11 13 2 9 22 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$cede40f6fd34759f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "14",
                    "width": "20",
                    "height": "8",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "6",
                    "x2": "6.01",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "18",
                    "x2": "6.01",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5a7e50116f3b6280(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$1a2d68aa2edcf6c8(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "5",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "19",
                    "r": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.59",
                    "y1": "13.51",
                    "x2": "15.42",
                    "y2": "17.49"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15.41",
                    "y1": "6.51",
                    "x2": "8.59",
                    "y2": "10.49"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$884092218eeb6b2c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 6 12 2 8 6"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$cb94a82ec553b02e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$8514cd806705464b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4f5d42594a6c344f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10a4 4 0 0 1-8 0"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$9a07702d62565b4e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "21",
                    "r": "1"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$41f2813d6fc8a26f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 3 21 3 21 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "20",
                    "x2": "21",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 16 21 21 16 21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "15",
                    "x2": "21",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "4",
                    "x2": "9",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fbf6091c5d0aeb56(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "3",
                    "x2": "9",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$89616b0dc34e6f79(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "19 20 9 12 19 4 19 20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "19",
                    "x2": "5",
                    "y2": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$110e06cce8a5f711(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 4 15 12 5 20 5 4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "5",
                    "x2": "19",
                    "y2": "19"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$1d3569727e8ef180(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$6abd105ba43862d9(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "19.07",
                    "y2": "19.07"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2f24368ca37a6c53(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "21",
                    "x2": "4",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "10",
                    "x2": "4",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "21",
                    "x2": "20",
                    "y2": "16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "12",
                    "x2": "20",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "14",
                    "x2": "7",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "8",
                    "x2": "15",
                    "y2": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "16",
                    "x2": "23",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$22573315dbd4b066(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "2",
                    "width": "14",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$228e79cc490856f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14s1.5 2 4 2 4-2 4-2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$6710316ad223d692(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "6",
                    "x2": "12.01",
                    "y2": "6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$596dbbbe7ed59d47(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3d417a135f5d8fd0(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4eb91858b35e3dd6(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$132f6d87d53531ee(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "1",
                    "x2": "12",
                    "y2": "3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "4.22",
                    "x2": "5.64",
                    "y2": "5.64"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "18.36",
                    "x2": "19.78",
                    "y2": "19.78"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "12",
                    "x2": "3",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "12",
                    "x2": "23",
                    "y2": "12"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "19.78",
                    "x2": "5.64",
                    "y2": "18.36"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "5.64",
                    "x2": "19.78",
                    "y2": "4.22"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f1a9fd2222396582(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18a5 5 0 0 0-10 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "9"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "10.22",
                    "x2": "5.64",
                    "y2": "11.64"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "23",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "11.64",
                    "x2": "19.78",
                    "y2": "10.22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "22",
                    "x2": "1",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 12 2 16 6"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$920bec0eaee4bc30(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18a5 5 0 0 0-10 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "12",
                    "y2": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "10.22",
                    "x2": "5.64",
                    "y2": "11.64"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "23",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "11.64",
                    "x2": "19.78",
                    "y2": "10.22"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "22",
                    "x2": "1",
                    "y2": "22"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 5 12 9 8 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4530543bf3fdafc8(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$11489db666064400(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5f4e44affcbbc4c0(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "7",
                    "x2": "7.01",
                    "y2": "7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d1792b6fedabf003(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "6"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$cb8a6df29ab3beda(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 17 10 11 4 5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "20",
                    "y2": "19"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5b457b75d920e5c1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$efaae75895b388ae(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ce560eeab2610ecf(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4e4f04acb0afbbf1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "22",
                    "height": "14",
                    "rx": "7",
                    "ry": "7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$9a1cab46f20a3451(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "22",
                    "height": "14",
                    "rx": "7",
                    "ry": "7"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "3"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5a8a3c19116af3f1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b45f06eb58143962(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3 6 5 6 21 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "11",
                    "x2": "10",
                    "y2": "17"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "11",
                    "x2": "14",
                    "y2": "17"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d150dffb65638cb4(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3 6 5 6 21 6"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2b6e5173960f7231(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7",
                    "width": "3",
                    "height": "9"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "7",
                    "width": "3",
                    "height": "5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$473b4c32cb9c123a(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 18 13.5 8.5 8.5 13.5 1 6"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 18 23 18 23 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$fad9644d3e8957ad(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 6 13.5 15.5 8.5 10.5 1 18"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 6 23 6 23 12"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4bec88612e1cf49a(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$83296ef4c01a23c2(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "15",
                    "height": "13"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "16 8 20 8 23 11 23 16 16 16 16 8"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "18.5",
                    "r": "2.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "18.5",
                    "r": "2.5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$54e22194544dafeb(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "15",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 2 12 7 7 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$901b594beb98342(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3v16h5v4l4-4h5l4-4V2zM11 11V7M16 11V7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$1a4a79d50651dc0c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$6fd390f7231931c3(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 7 4 4 20 4 20 7"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "20",
                    "x2": "15",
                    "y2": "20"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "4",
                    "x2": "12",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$778ecbc768cf0497(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$21435156dc525c9c(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "21",
                    "x2": "20",
                    "y2": "21"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$51e31213368dc22f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "18",
                    "height": "11",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 9.9-1"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$dda53dfc047e1e57(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 12 8 16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "12",
                    "x2": "12",
                    "y2": "21"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 12 8 16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$21d8ed3329b3bc94(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 8 12 3 7 8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "3",
                    "x2": "12",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$982c731970b14d26(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 11 19 13 23 9"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$946a68f031019c38(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "11",
                    "x2": "17",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$d29888d481fb4bb2(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "8",
                    "x2": "20",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "11",
                    "x2": "17",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b89e2f833f36ed1e(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "8",
                    "x2": "23",
                    "y2": "13"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "8",
                    "x2": "18",
                    "y2": "13"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$db323b26626af533(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$b91acdc2f2196abd(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 21v-2a4 4 0 0 0-3-3.87"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.13a4 4 0 0 1 0 7.75"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2f017e47d1904bf5(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4b873a4f38d0e312(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "23 7 16 12 23 17 23 7"
                },
                "child": []
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "15",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$89a19527ac4bea7a(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "11.5",
                    "r": "4.5"
                },
                "child": []
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "11.5",
                    "r": "4.5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5.5",
                    "y1": "16",
                    "x2": "18.5",
                    "y2": "16"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2562182dbe6f48f1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.54 8.46a5 5 0 0 1 0 7.07"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$2aa37add4f006aa4(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$5211546efb69b8b1(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "9",
                    "x2": "17",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "9",
                    "x2": "23",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c245550c7099bcea(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ba9fedcf93fa9af0(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "7"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 9 12 12 13.5 13.5"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$f11e8a486cd09251(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.71 5.05A16 16 0 0 1 22.58 9"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12.01",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4f808f790823e5a5(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.55a11 11 0 0 1 14.08 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.42 9a16 16 0 0 1 21.16 0"
                },
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12.01",
                    "y2": "20"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$cddc74169eed0643(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$7b1b0eab235ada3f(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c94b846d8eff96de(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$ac22140d9ac7df07(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$c7222af9b49907b4(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "6",
                    "x2": "6",
                    "y2": "18"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "6",
                    "x2": "18",
                    "y2": "18"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$9f5af188e5de0552(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                },
                "child": []
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$feec27b6ec0ed725(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "12.41 6.75 13 2 10.57 4.92"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "18.57 12.91 21 10 15.66 10"
                },
                "child": []
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 8 3 14 12 14 11 22 16 16"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$4d144bd0444c3a46(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$38f6b9da82fb823b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "11",
                    "y1": "8",
                    "x2": "11",
                    "y2": "14"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "11",
                    "x2": "14",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}
function $37f9bcffaadb69fd$export$3d3849badba7351b(props) {
    return (0, $df56e6fd156449a5$export$6fce6cce1e9a936d)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                },
                "child": []
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "11",
                    "x2": "14",
                    "y2": "11"
                },
                "child": []
            }
        ]
    })(props);
}


var $2fe487a530bddc88$exports = {};

$2fe487a530bddc88$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "base.a5d2b23d.svg";


var $4384bf61a71023b3$exports = {};

$4384bf61a71023b3$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "bitcoin-1.d48db2ac.svg";


var $ac91fd8f1dffc709$exports = {};

$ac91fd8f1dffc709$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "linea.cd3a1e8c.svg";


var $ab932b76935e91c1$exports = {};

$ab932b76935e91c1$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "ethereum1.6a72ab43.svg";


var $08c17a8711343249$exports = {};

$08c17a8711343249$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "gnosis.61d3829e.svg";


var $61370147c2b77474$exports = {};

$61370147c2b77474$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "optimism.0579c3e6.svg";


const $247b409c2d935112$export$44e0b7df03818d37 = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("section", {
        className: "flex flex-col items-center justify-center gap-12 bg-white px-4 py-24 md:flex-row",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($247b409c2d935112$var$Copy, {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)($247b409c2d935112$var$LogoRolodex, {
                items: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($247b409c2d935112$var$LogoItem, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ab932b76935e91c1$exports))),
                        alt: "Ethereum"
                    }, 1),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($247b409c2d935112$var$LogoItem, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4384bf61a71023b3$exports))),
                        alt: "Bitcoin"
                    }, 2),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($247b409c2d935112$var$LogoItem, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($61370147c2b77474$exports))),
                        alt: "Optimism"
                    }, 3),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($247b409c2d935112$var$LogoItem, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2fe487a530bddc88$exports))),
                        alt: "Base"
                    }, 4),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($247b409c2d935112$var$LogoItem, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ac91fd8f1dffc709$exports))),
                        alt: "Linea"
                    }, 5),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($247b409c2d935112$var$LogoItem, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($08c17a8711343249$exports))),
                        alt: "Gnosis"
                    }, 6)
                ]
            })
        ]
    });
};
const $247b409c2d935112$var$Copy = ()=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "max-w-lg text-center md:text-start",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                className: "mb-3 text-5xl text-black font-monda",
                children: "Support for the most popular blockchains"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "mb-6 text-base leading-relaxed text-neutral-600",
                children: "Monitor Crypto Movements Instantly: See Fund Shifts, Identify New Projects, and Trace Transactions with 15-Second Node to Website Delay and Block-Level Precision."
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                href: "#",
                className: "group text-base uppercase text-primary transition-colors hover:text-primary-dark",
                children: [
                    "See all supported chains",
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $37f9bcffaadb69fd$export$e2b35aa7c05e571c), {
                        className: "inline-block text-lg transition-transform group-hover:rotate-45"
                    })
                ]
            })
        ]
    });
const $247b409c2d935112$var$DELAY_IN_MS = 2500;
const $247b409c2d935112$var$TRANSITION_DURATION_IN_SECS = 1.5;
const $247b409c2d935112$var$LogoRolodex = ({ items: items })=>{
    const intervalRef = (0, $exYeM.useRef)(null);
    const [index, setIndex] = (0, $exYeM.useState)(0);
    (0, $exYeM.useEffect)(()=>{
        intervalRef.current = setInterval(()=>{
            setIndex((pv)=>pv + 1);
        }, $247b409c2d935112$var$DELAY_IN_MS);
        return ()=>{
            clearInterval(intervalRef.current || undefined);
        };
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        style: {
            transform: "rotateY(-20deg)",
            transformStyle: "preserve-3d"
        },
        className: "relative z-0 h-52 w-72 shrink-0 rounded-xl border border-neutral-200 bg-secondary-new bg-opacity-30",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9744623a78dc500b$export$3ae376d12526dd6f), {
                mode: "sync",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                        style: {
                            y: "-50%",
                            x: "-50%",
                            clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 50%)",
                            zIndex: -index,
                            backfaceVisibility: "hidden"
                        },
                        transition: {
                            duration: $247b409c2d935112$var$TRANSITION_DURATION_IN_SECS,
                            ease: "easeInOut"
                        },
                        initial: {
                            rotateX: "0deg"
                        },
                        animate: {
                            rotateX: "0deg"
                        },
                        exit: {
                            rotateX: "-180deg"
                        },
                        className: "absolute left-1/2 top-1/2",
                        children: items[index % items.length]
                    }, index),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                        style: {
                            y: "-50%",
                            x: "-50%",
                            clipPath: "polygon(0 50%, 100% 50%, 100% 100%, 0 100%)",
                            zIndex: index,
                            backfaceVisibility: "hidden"
                        },
                        initial: {
                            rotateX: "180deg"
                        },
                        animate: {
                            rotateX: "0deg"
                        },
                        exit: {
                            rotateX: "0deg"
                        },
                        transition: {
                            duration: $247b409c2d935112$var$TRANSITION_DURATION_IN_SECS,
                            ease: "easeInOut"
                        },
                        className: "absolute left-1/2 top-1/2",
                        children: items[index % items.length]
                    }, (index + 1) * 2)
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("hr", {
                style: {
                    transform: "translateZ(1px)"
                },
                className: "absolute left-0 right-0 top-1/2 z-[999999999] -translate-y-1/2 border-t-2 border-neutral-200"
            })
        ]
    });
};
const $247b409c2d935112$var$LogoItem = ({ src: src, alt: alt })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $77321b8aa25b5324$exports.twMerge)("grid h-44 w-64 place-content-center rounded-lg bg-white"),
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: src,
            alt: alt,
            className: "max-h-16 w-auto object-contain"
        })
    });
};
var $247b409c2d935112$export$2e2bcd8739ae039 = $247b409c2d935112$export$44e0b7df03818d37;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


const $123f871e017f2022$var$getButtonVariantClass = (variant, size)=>{
    let baseClass = "inline-flex items-center justify-center whitespace-nowrap shadow-md rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";
    let variantClass = "";
    let sizeClass = "";
    switch(variant){
        case "destructive":
            variantClass = "bg-destructive text-destructive-foreground hover:bg-destructive/90";
            break;
        case "outline":
            variantClass = "border border-input border-onSurfaceVariant bg-white text-gray-900 hover:bg-primary hover:text-white";
            break;
        case "secondary":
            variantClass = "bg-secondary text-secondary-foreground hover:bg-secondary/80";
            break;
        case "ghost":
            variantClass = "hover:bg-accent hover:text-accent-foreground";
            break;
        case "link":
            variantClass = "text-primary underline-offset-4 hover:underline";
            break;
        default:
            variantClass = "bg-white text-gray-900 hover:bg-primary hover:text-white ";
    }
    switch(size){
        case "sm":
            sizeClass = "h-9 rounded-md px-3";
            break;
        case "lg":
            sizeClass = "h-11 rounded-md px-8";
            break;
        case "icon":
            sizeClass = "h-10 w-10";
            break;
        default:
            sizeClass = "h-10 px-4 py-2";
    }
    return `${baseClass} ${variantClass} ${sizeClass}`;
};
const $123f871e017f2022$export$353f5b6fc5456de1 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, variant: variant = "default", size: size = "default", asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : "button";
    const buttonClass = $123f871e017f2022$var$getButtonVariantClass(variant, size);
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Comp, {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)(buttonClass, className),
        ref: ref,
        ...props
    });
});
$123f871e017f2022$export$353f5b6fc5456de1.displayName = "Button";




var $exYeM = parcelRequire("exYeM");
function $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c12e32cf04d921d4$var$_excluded = [
    "color"
];
var $c12e32cf04d921d4$export$12f5813a529780ed = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877197 7.49984C0.877197 3.84216 3.84234 0.877014 7.50003 0.877014C11.1577 0.877014 14.1229 3.84216 14.1229 7.49984C14.1229 11.1575 11.1577 14.1227 7.50003 14.1227C3.84234 14.1227 0.877197 11.1575 0.877197 7.49984ZM7.50003 1.82701C4.36702 1.82701 1.8272 4.36683 1.8272 7.49984C1.8272 10.6328 4.36702 13.1727 7.50003 13.1727C10.633 13.1727 13.1729 10.6328 13.1729 7.49984C13.1729 4.36683 10.633 1.82701 7.50003 1.82701ZM7.12457 9.00001C7.06994 9.12735 6.33165 11.9592 6.33165 11.9592C6.26018 12.226 5.98601 12.3843 5.71928 12.3128C5.45255 12.2413 5.29425 11.9672 5.36573 11.7004C5.36573 11.7004 6.24661 8.87268 6.24661 8.27007V6.80099L4.28763 6.27608C4.0209 6.20461 3.86261 5.93045 3.93408 5.66371C4.00555 5.39698 4.27972 5.23869 4.54645 5.31016C4.54645 5.31016 6.20042 5.87268 6.84579 5.87268H8.15505C8.80042 5.87268 10.4534 5.31042 10.4534 5.31042C10.7202 5.23895 10.9943 5.39724 11.0658 5.66397C11.1373 5.93071 10.979 6.20487 10.7122 6.27635L8.74661 6.80303V8.27007C8.74661 8.87268 9.62663 11.6971 9.62663 11.6971C9.6981 11.9639 9.5398 12.238 9.27307 12.3095C9.00634 12.381 8.73217 12.2227 8.6607 11.956C8.6607 11.956 7.91994 9.12735 7.86866 9.00001C7.81994 8.87268 7.65006 8.87268 7.65006 8.87268H7.34317C7.34317 8.87268 7.16994 8.87268 7.12457 9.00001ZM7.50043 5.12007C8.12175 5.12007 8.62543 4.61639 8.62543 3.99507C8.62543 3.37375 8.12175 2.87007 7.50043 2.87007C6.87911 2.87007 6.37543 3.37375 6.37543 3.99507C6.37543 4.61639 6.87911 5.12007 7.50043 5.12007Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1 = [
    "color"
];
var $c12e32cf04d921d4$export$c40c07f3e63e590d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0 1.5C0 1.22386 0.223858 1 0.5 1H2.5C2.77614 1 3 1.22386 3 1.5C3 1.77614 2.77614 2 2.5 2H0.5C0.223858 2 0 1.77614 0 1.5ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5C15 1.77614 14.7761 2 14.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM0 7.5C0 7.22386 0.223858 7 0.5 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H0.5C0.223858 8 0 7.77614 0 7.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM0 13.5C0 13.2239 0.223858 13 0.5 13H2.5C2.77614 13 3 13.2239 3 13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H4.5C4.22386 14 4 13.7761 4 13.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2 = [
    "color"
];
var $c12e32cf04d921d4$export$315d3fae607b3916 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.5 1.75003C10.7107 1.75003 10.8988 1.88217 10.9703 2.08042L13.9703 10.4C14.064 10.6598 13.9293 10.9463 13.6696 11.04C13.4098 11.1336 13.1233 10.999 13.0296 10.7392L12.0477 8.01606H8.95227L7.97031 10.7392C7.87664 10.999 7.59012 11.1336 7.33035 11.04C7.07058 10.9463 6.93593 10.6598 7.0296 10.4L10.0296 2.08042C10.1011 1.88217 10.2892 1.75003 10.5 1.75003ZM10.5 3.72402L11.7411 7.16606H9.25877L10.5 3.72402ZM2.49949 2.09997C2.7204 2.09997 2.89949 2.27906 2.89949 2.49997L2.89949 9.53428L4.21664 8.21713C4.37285 8.06092 4.62612 8.06092 4.78233 8.21713C4.93854 8.37334 4.93854 8.6266 4.78233 8.78281L2.78233 10.7828C2.70732 10.8578 2.60557 10.9 2.49949 10.9C2.3934 10.9 2.29166 10.8578 2.21664 10.7828L0.216645 8.78281C0.0604349 8.6266 0.0604349 8.37334 0.216645 8.21713C0.372854 8.06092 0.62612 8.06092 0.78233 8.21713L2.09949 9.53428L2.09949 2.49997C2.09949 2.27906 2.27857 2.09997 2.49949 2.09997ZM0.0999695 13.5001C0.0999695 13.2791 0.279056 13.1001 0.499969 13.1001H14.5C14.7209 13.1001 14.9 13.2791 14.9 13.5001C14.9 13.721 14.7209 13.9001 14.5 13.9001H0.499969C0.279056 13.9001 0.0999695 13.721 0.0999695 13.5001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3 = [
    "color"
];
var $c12e32cf04d921d4$export$28c63a2a77a6b6ba = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9 3C9 2.44772 8.55229 2 8 2H7C6.44772 2 6 2.44772 6 3L6 14H1.5C1.22386 14 1 14.2239 1 14.5C1 14.7761 1.22386 15 1.5 15L6 15H9H13.5C13.7761 15 14 14.7761 14 14.5C14 14.2239 13.7761 14 13.5 14H9V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4 = [
    "color"
];
var $c12e32cf04d921d4$export$5284d356b9eb3ea0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.99988 6C1.44759 6 0.999877 6.44772 0.999877 7L0.999877 8C0.999877 8.55228 1.44759 9 1.99988 9L6.99988 9L6.99988 13.5C6.99988 13.7761 7.22374 14 7.49988 14C7.77602 14 7.99988 13.7761 7.99988 13.5L7.99988 9L12.9999 9C13.5522 9 13.9999 8.55228 13.9999 8L13.9999 7C13.9999 6.44772 13.5522 6 12.9999 6L7.99988 6L7.99988 1.5C7.99988 1.22386 7.77602 1 7.49988 1C7.22373 1 6.99988 1.22386 6.99988 1.5L6.99988 6L1.99988 6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$5 = [
    "color"
];
var $c12e32cf04d921d4$export$a87e0381c7863d70 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$5);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.99988 1C6.44759 1 5.99988 1.44772 5.99988 2V7H1.49988C1.22374 7 0.999878 7.22386 0.999878 7.5C0.999878 7.77614 1.22374 8 1.49988 8H5.99988V13C5.99988 13.5523 6.44759 14 6.99988 14H7.99988C8.55216 14 8.99988 13.5523 8.99988 13V8H13.4999C13.776 8 13.9999 7.77614 13.9999 7.5C13.9999 7.22386 13.776 7 13.4999 7H8.99988V2C8.99988 1.44772 8.55216 1 7.99988 1L6.99988 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$6 = [
    "color"
];
var $c12e32cf04d921d4$export$43a2a6205c884160 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$6);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.499995 0.999995C0.223855 0.999995 -5.58458e-07 1.22385 -5.46388e-07 1.49999L-2.18554e-08 13.4999C-9.78492e-09 13.776 0.223855 13.9999 0.499995 13.9999C0.776136 13.9999 0.999991 13.776 0.999991 13.4999L0.999991 8.99993L12 8.99993C12.5523 8.99993 13 8.55222 13 7.99993L13 6.99994C13 6.44766 12.5523 5.99995 12 5.99995L0.999991 5.99995L0.999991 1.49999C0.999991 1.22385 0.776135 0.999995 0.499995 0.999995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$7 = [
    "color"
];
var $c12e32cf04d921d4$export$589ba7400e24d687 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$7);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.4999 1C14.2237 1 13.9999 1.22386 13.9999 1.5L13.9999 6L2.99988 6C2.44759 6 1.99988 6.44772 1.99988 7L1.99988 8C1.99988 8.55228 2.44759 9 2.99988 9L13.9999 9L13.9999 13.5C13.9999 13.7761 14.2237 14 14.4999 14C14.776 14 14.9999 13.7761 14.9999 13.5L14.9999 9L14.9999 6L14.9999 1.5C14.9999 1.22386 14.776 1 14.4999 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$8 = [
    "color"
];
var $c12e32cf04d921d4$export$359aaf594ac84c59 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$8);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 0C1.22386 0 1 0.223858 1 0.5C1 0.776142 1.22386 1 1.5 1H6V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V1H13.5C13.7761 1 14 0.776142 14 0.5C14 0.223858 13.7761 0 13.5 0H9H6H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$9 = [
    "color"
];
var $c12e32cf04d921d4$export$c5eda4f4203e72ab = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$9);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0.75L9.75 3H5.25L7.5 0.75ZM7.5 14.25L9.75 12H5.25L7.5 14.25ZM3 5.25L0.75 7.5L3 9.75V5.25ZM14.25 7.5L12 5.25V9.75L14.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$a = [
    "color"
];
var $c12e32cf04d921d4$export$c3671dfffcc20189 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.8914 2.1937C9.1158 2.35464 9.16725 2.66701 9.00631 2.89141L2.47388 12H13.5C13.7761 12 14 12.2239 14 12.5C14 12.7762 13.7761 13 13.5 13H1.5C1.31254 13 1.14082 12.8952 1.0552 12.7284C0.969578 12.5616 0.984438 12.361 1.09369 12.2086L8.19369 2.30862C8.35462 2.08422 8.667 2.03277 8.8914 2.1937ZM11.1 6.50001C11.1 6.22387 11.3238 6.00001 11.6 6.00001C11.8761 6.00001 12.1 6.22387 12.1 6.50001C12.1 6.77615 11.8761 7.00001 11.6 7.00001C11.3238 7.00001 11.1 6.77615 11.1 6.50001ZM10.4 4.00001C10.1239 4.00001 9.90003 4.22387 9.90003 4.50001C9.90003 4.77615 10.1239 5.00001 10.4 5.00001C10.6762 5.00001 10.9 4.77615 10.9 4.50001C10.9 4.22387 10.6762 4.00001 10.4 4.00001ZM12.1 8.50001C12.1 8.22387 12.3238 8.00001 12.6 8.00001C12.8761 8.00001 13.1 8.22387 13.1 8.50001C13.1 8.77615 12.8761 9.00001 12.6 9.00001C12.3238 9.00001 12.1 8.77615 12.1 8.50001ZM13.4 10C13.1239 10 12.9 10.2239 12.9 10.5C12.9 10.7761 13.1239 11 13.4 11C13.6762 11 13.9 10.7761 13.9 10.5C13.9 10.2239 13.6762 10 13.4 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$b = [
    "color"
];
var $c12e32cf04d921d4$export$64abfa02d870a554 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$c = [
    "color"
];
var $c12e32cf04d921d4$export$ba8ee9ef4800b4a5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.3536 3.64644C11.5488 3.8417 11.5488 4.15828 11.3536 4.35354L4.70711 11L9 11C9.27614 11 9.5 11.2239 9.5 11.5C9.5 11.7761 9.27614 12 9 12L3.5 12C3.36739 12 3.24021 11.9473 3.14645 11.8536C3.05268 11.7598 3 11.6326 3 11.5L3 5.99999C3 5.72385 3.22386 5.49999 3.5 5.49999C3.77614 5.49999 4 5.72385 4 5.99999V10.2929L10.6464 3.64643C10.8417 3.45117 11.1583 3.45117 11.3536 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$d = [
    "color"
];
var $c12e32cf04d921d4$export$1a0b00ff4e10643e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.64645 3.64644C3.45118 3.8417 3.45118 4.15828 3.64645 4.35354L10.2929 11L6 11C5.72386 11 5.5 11.2239 5.5 11.5C5.5 11.7761 5.72386 12 6 12L11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5L12 5.99999C12 5.72385 11.7761 5.49999 11.5 5.49999C11.2239 5.49999 11 5.72385 11 5.99999V10.2929L4.35355 3.64643C4.15829 3.45117 3.84171 3.45117 3.64645 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$e = [
    "color"
];
var $c12e32cf04d921d4$export$1c939d3c9b6931b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 11.2929L11.1464 8.14645C11.3417 7.95118 11.6583 7.95118 11.8536 8.14645C12.0488 8.34171 12.0488 8.65829 11.8536 8.85355L7.85355 12.8536C7.75979 12.9473 7.63261 13 7.5 13C7.36739 13 7.24021 12.9473 7.14645 12.8536L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L7 11.2929L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$f = [
    "color"
];
var $c12e32cf04d921d4$export$8afed21ef5c2afa5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$g = [
    "color"
];
var $c12e32cf04d921d4$export$9ca09caa9c849d9c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$h = [
    "color"
];
var $c12e32cf04d921d4$export$9f5fe8cc556ac1f3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6465L4.70711 4L9 4C9.27614 4 9.5 3.77614 9.5 3.5C9.5 3.22386 9.27614 3 9 3L3.5 3C3.36739 3 3.24021 3.05268 3.14645 3.14645C3.05268 3.24022 3 3.36739 3 3.5L3 9.00001C3 9.27615 3.22386 9.50001 3.5 9.50001C3.77614 9.50001 4 9.27615 4 9.00001V4.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$i = [
    "color"
];
var $c12e32cf04d921d4$export$64a9bd58f7494197 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$j = [
    "color"
];
var $c12e32cf04d921d4$export$f1a507b991affc46 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.14645 2.14645C7.34171 1.95118 7.65829 1.95118 7.85355 2.14645L11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355C11.6583 7.04882 11.3417 7.04882 11.1464 6.85355L8 3.70711L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 3.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L7.14645 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$k = [
    "color"
];
var $c12e32cf04d921d4$export$843c734d18c2237 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 2H12.5C12.7761 2 13 2.22386 13 2.5V12.5C13 12.7761 12.7761 13 12.5 13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5ZM7.5 4C7.77614 4 8 3.77614 8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4ZM8 5.5C8 5.77614 7.77614 6 7.5 6C7.22386 6 7 5.77614 7 5.5C7 5.22386 7.22386 5 7.5 5C7.77614 5 8 5.22386 8 5.5ZM7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8ZM10 7.5C10 7.77614 9.77614 8 9.5 8C9.22386 8 9 7.77614 9 7.5C9 7.22386 9.22386 7 9.5 7C9.77614 7 10 7.22386 10 7.5ZM11.5 8C11.7761 8 12 7.77614 12 7.5C12 7.22386 11.7761 7 11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$l = [
    "color"
];
var $c12e32cf04d921d4$export$b1f22795a41806ac = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$m = [
    "color"
];
var $c12e32cf04d921d4$export$a7965fbad5d67169 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$n = [
    "color"
];
var $c12e32cf04d921d4$export$e32f68df2d27987 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 6H11.5C12.3284 6 13 6.67157 13 7.5C13 8.32843 12.3284 9 11.5 9H3.5C2.67157 9 2 8.32843 2 7.5C2 6.67157 2.67157 6 3.5 6ZM1 7.5C1 6.11929 2.11929 5 3.5 5H11.5C12.8807 5 14 6.11929 14 7.5C14 8.88071 12.8807 10 11.5 10H3.5C2.11929 10 1 8.88071 1 7.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$o = [
    "color"
];
var $c12e32cf04d921d4$export$472946dc5493045a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.5 1C11.7761 1 12 1.22386 12 1.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V1.5C11 1.22386 11.2239 1 11.5 1ZM9.5 3C9.77614 3 10 3.22386 10 3.5V13.5C10 13.7761 9.77614 14 9.5 14C9.22386 14 9 13.7761 9 13.5V3.5C9 3.22386 9.22386 3 9.5 3ZM13.5 3C13.7761 3 14 3.22386 14 3.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V3.5C13 3.22386 13.2239 3 13.5 3ZM5.5 4C5.77614 4 6 4.22386 6 4.5V13.5C6 13.7761 5.77614 14 5.5 14C5.22386 14 5 13.7761 5 13.5V4.5C5 4.22386 5.22386 4 5.5 4ZM1.5 5C1.77614 5 2 5.22386 2 5.5V13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5V5.5C1 5.22386 1.22386 5 1.5 5ZM7.5 5C7.77614 5 8 5.22386 8 5.5V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.5C7 5.22386 7.22386 5 7.5 5ZM3.5 7C3.77614 7 4 7.22386 4 7.5V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V7.5C3 7.22386 3.22386 7 3.5 7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$p = [
    "color"
];
var $c12e32cf04d921d4$export$2235404cc2cfe93c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.60124 1.25086C8.60124 1.75459 8.26278 2.17927 7.80087 2.30989C10.1459 2.4647 12 4.41582 12 6.79999V10.25C12 11.0563 12.0329 11.7074 12.7236 12.0528C12.931 12.1565 13.0399 12.3892 12.9866 12.6149C12.9333 12.8406 12.7319 13 12.5 13H8.16144C8.36904 13.1832 8.49997 13.4513 8.49997 13.75C8.49997 14.3023 8.05226 14.75 7.49997 14.75C6.94769 14.75 6.49997 14.3023 6.49997 13.75C6.49997 13.4513 6.63091 13.1832 6.83851 13H2.49999C2.2681 13 2.06664 12.8406 2.01336 12.6149C1.96009 12.3892 2.06897 12.1565 2.27638 12.0528C2.96708 11.7074 2.99999 11.0563 2.99999 10.25V6.79999C2.99999 4.41537 4.85481 2.46396 7.20042 2.3098C6.73867 2.17908 6.40036 1.75448 6.40036 1.25086C6.40036 0.643104 6.89304 0.150421 7.5008 0.150421C8.10855 0.150421 8.60124 0.643104 8.60124 1.25086ZM7.49999 3.29999C5.56699 3.29999 3.99999 4.86699 3.99999 6.79999V10.25L4.00002 10.3009C4.0005 10.7463 4.00121 11.4084 3.69929 12H11.3007C10.9988 11.4084 10.9995 10.7463 11 10.3009L11 10.25V6.79999C11 4.86699 9.43299 3.29999 7.49999 3.29999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$q = [
    "color"
];
var $c12e32cf04d921d4$export$cd91dad3f7d2f1be = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 9C3 6.5 4.5 4.25 7.5 1.5C10.5 4.25 12 6.5 12 9C12 11.4853 9.98528 13.5 7.5 13.5C5.01472 13.5 3 11.4853 3 9ZM10.9524 8.30307C9.67347 7.82121 8.2879 8.46208 6.98956 9.06259C5.9327 9.55142 4.93365 10.0135 4.09695 9.82153C4.03357 9.55804 4 9.28294 4 9C4 7.11203 5.02686 5.27195 7.5 2.87357C9.66837 4.97639 10.725 6.65004 10.9524 8.30307Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$r = [
    "color"
];
var $c12e32cf04d921d4$export$93cb139c864b0aec = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H11.5C11.7761 2 12 2.22386 12 2.5V13.5C12 13.6818 11.9014 13.8492 11.7424 13.9373C11.5834 14.0254 11.3891 14.0203 11.235 13.924L7.5 11.5896L3.765 13.924C3.61087 14.0203 3.41659 14.0254 3.25762 13.9373C3.09864 13.8492 3 13.6818 3 13.5V2.5ZM4 3V12.5979L6.97 10.7416C7.29427 10.539 7.70573 10.539 8.03 10.7416L11 12.5979V3H4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$s = [
    "color"
];
var $c12e32cf04d921d4$export$77df11a9db3bfb4e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.6818 3.09864 13.8492 3.25762 13.9373C3.41659 14.0254 3.61087 14.0203 3.765 13.924L7.5 11.5896L11.235 13.924C11.3891 14.0203 11.5834 14.0254 11.7424 13.9373C11.9014 13.8492 12 13.6818 12 13.5V2.5C12 2.22386 11.7761 2 11.5 2H3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$t = [
    "color"
];
var $c12e32cf04d921d4$export$2b8bb78df07fc3c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H14C14.4142 0.25 14.75 0.585786 14.75 1V14C14.75 14.4142 14.4142 14.75 14 14.75H1C0.585786 14.75 0.25 14.4142 0.25 14V1ZM1.75 1.75V13.25H13.25V1.75H1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$u = [
    "color"
];
var $c12e32cf04d921d4$export$1986587b5169c3d1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 13.25L14 13.25V14.75L1 14.75V13.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$v = [
    "color"
];
var $c12e32cf04d921d4$export$9e3588048b381346 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$w = [
    "color"
];
var $c12e32cf04d921d4$export$db4fc3403d513c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$x = [
    "color"
];
var $c12e32cf04d921d4$export$90857351d8240996 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.75 1L1.75 14L0.249999 14L0.25 1L1.75 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 5)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 5)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 3)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 3)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 9)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 9)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 11)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 11)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 1)",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$y = [
    "color"
];
var $c12e32cf04d921d4$export$fc99bfbabe8fe100 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$z = [
    "color"
];
var $c12e32cf04d921d4$export$d19e24a090b81f38 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.25 1L13.25 14L14.75 14L14.75 1L13.25 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 5)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 5)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 3)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 3)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 9)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 9)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 11)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 11)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 1)",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$A = [
    "color"
];
var $c12e32cf04d921d4$export$ca09e5ae294d45cc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$B = [
    "color"
];
var $c12e32cf04d921d4$export$fbe2d4727aba00b7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("path", {
        d: "M1 1.49994C1 1.2238 1.22386 0.999939 1.5 0.999939H6V1.99994H2V5.99994H1V1.49994ZM13 1.99994H9V0.999939H13.5C13.7761 0.999939 14 1.2238 14 1.49994V5.99994H13V1.99994ZM1 13.4999V8.99994H2V12.9999H6V13.9999H1.5C1.22386 13.9999 1 13.7761 1 13.4999ZM13 12.9999V8.99994H14V13.4999C14 13.7761 13.7761 13.9999 13.5 13.9999H9.5V12.9999H13Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$C = [
    "color"
];
var $c12e32cf04d921d4$export$99084cce0e645aeb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11ZM11 11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5C12 11.7761 11.7761 12 11.5 12C11.2239 12 11 11.7761 11 11.5ZM13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H8.5C8.77614 8 9 7.77614 9 7.5C9 7.22386 8.77614 7 8.5 7H6.5ZM11 7.5C11 7.22386 11.2239 7 11.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H11.5C11.2239 8 11 7.77614 11 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$D = [
    "color"
];
var $c12e32cf04d921d4$export$c244c53943ad4d08 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 1.75L1 1.75L1 0.249999L14 0.25L14 1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 10)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 10)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 12)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 12)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 6)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 6)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 4)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 4)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 10)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 12)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 6)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 4)",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$E = [
    "color"
];
var $c12e32cf04d921d4$export$26dc332286fcc660 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 3H14V4H1V3ZM1 6H14V8H1V6ZM14 10.25H1V12.75H14V10.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$F = [
    "color"
];
var $c12e32cf04d921d4$export$adedf1569d7107de = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$G = [
    "color"
];
var $c12e32cf04d921d4$export$742ea6014cb11378 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$H = [
    "color"
];
var $c12e32cf04d921d4$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$I = [
    "color"
];
var $c12e32cf04d921d4$export$5fda1783bb83f57b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.5 1C4.77614 1 5 1.22386 5 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12.5C13.3284 2 14 2.67157 14 3.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V3.5C1 2.67157 1.67157 2 2.5 2H4V1.5C4 1.22386 4.22386 1 4.5 1ZM10 3V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V3H12.5C12.7761 3 13 3.22386 13 3.5V5H2V3.5C2 3.22386 2.22386 3 2.5 3H4V3.5C4 3.77614 4.22386 4 4.5 4C4.77614 4 5 3.77614 5 3.5V3H10ZM2 6V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6H2ZM7 7.5C7 7.22386 7.22386 7 7.5 7C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7ZM11 7.5C11 7.22386 11.2239 7 11.5 7C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8C11.2239 8 11 7.77614 11 7.5ZM11.5 9C11.2239 9 11 9.22386 11 9.5C11 9.77614 11.2239 10 11.5 10C11.7761 10 12 9.77614 12 9.5C12 9.22386 11.7761 9 11.5 9ZM9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5ZM7.5 9C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10C7.77614 10 8 9.77614 8 9.5C8 9.22386 7.77614 9 7.5 9ZM5 9.5C5 9.22386 5.22386 9 5.5 9C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10C5.22386 10 5 9.77614 5 9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$J = [
    "color"
];
var $c12e32cf04d921d4$export$1bd12807c2fea239 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 3C1.44772 3 1 3.44772 1 4V11C1 11.5523 1.44772 12 2 12H13C13.5523 12 14 11.5523 14 11V4C14 3.44772 13.5523 3 13 3H2ZM0 4C0 2.89543 0.895431 2 2 2H13C14.1046 2 15 2.89543 15 4V11C15 12.1046 14.1046 13 13 13H2C0.895431 13 0 12.1046 0 11V4ZM2 4.25C2 4.11193 2.11193 4 2.25 4H4.75C4.88807 4 5 4.11193 5 4.25V5.75454C5 5.89261 4.88807 6.00454 4.75 6.00454H2.25C2.11193 6.00454 2 5.89261 2 5.75454V4.25ZM12.101 7.58421C12.101 9.02073 10.9365 10.1853 9.49998 10.1853C8.06346 10.1853 6.89893 9.02073 6.89893 7.58421C6.89893 6.14769 8.06346 4.98315 9.49998 4.98315C10.9365 4.98315 12.101 6.14769 12.101 7.58421ZM13.101 7.58421C13.101 9.57302 11.4888 11.1853 9.49998 11.1853C7.51117 11.1853 5.89893 9.57302 5.89893 7.58421C5.89893 5.5954 7.51117 3.98315 9.49998 3.98315C11.4888 3.98315 13.101 5.5954 13.101 7.58421Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$K = [
    "color"
];
var $c12e32cf04d921d4$export$16dbc2701f60a606 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$L = [
    "color"
];
var $c12e32cf04d921d4$export$cf8d533bd52e80e3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H12.5C12.7761 10 13 9.77614 13 9.5V3.5C13 3.22386 12.7761 3 12.5 3H2.5ZM1 9.5C1 10.1531 1.4174 10.7087 2 10.9146V11.5C2 12.3284 2.67157 13 3.5 13H11.5C12.3284 13 13 12.3284 13 11.5V10.9146C13.5826 10.7087 14 10.1531 14 9.5V3.5C14 2.67157 13.3284 2 12.5 2H2.5C1.67157 2 1 2.67157 1 3.5V9.5ZM12 11.5V11H3V11.5C3 11.7761 3.22386 12 3.5 12H11.5C11.7761 12 12 11.7761 12 11.5ZM5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H9.5C9.77614 7 10 6.77614 10 6.5C10 6.22386 9.77614 6 9.5 6H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$M = [
    "color"
];
var $c12e32cf04d921d4$export$e590b2572239e122 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12ZM5 6.5C5 6.22386 5.22386 6 5.5 6H7V4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V6H9.5C9.77614 6 10 6.22386 10 6.5C10 6.77614 9.77614 7 9.5 7H8V8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5V7H5.5C5.22386 7 5 6.77614 5 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$N = [
    "color"
];
var $c12e32cf04d921d4$export$73a4c78a4a00962 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$O = [
    "color"
];
var $c12e32cf04d921d4$export$810196a5854768f3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.81809 4.18179C8.99383 4.35753 8.99383 4.64245 8.81809 4.81819L6.13629 7.49999L8.81809 10.1818C8.99383 10.3575 8.99383 10.6424 8.81809 10.8182C8.64236 10.9939 8.35743 10.9939 8.1817 10.8182L5.1817 7.81819C5.09731 7.73379 5.0499 7.61933 5.0499 7.49999C5.0499 7.38064 5.09731 7.26618 5.1817 7.18179L8.1817 4.18179C8.35743 4.00605 8.64236 4.00605 8.81809 4.18179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$P = [
    "color"
];
var $c12e32cf04d921d4$export$5e4a7579d3e78657 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$Q = [
    "color"
];
var $c12e32cf04d921d4$export$432020ae7f5a1085 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$R = [
    "color"
];
var $c12e32cf04d921d4$export$7d1b8b90f61377d1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.18179 8.81819C4.00605 8.64245 4.00605 8.35753 4.18179 8.18179L7.18179 5.18179C7.26618 5.0974 7.38064 5.04999 7.49999 5.04999C7.61933 5.04999 7.73379 5.0974 7.81819 5.18179L10.8182 8.18179C10.9939 8.35753 10.9939 8.64245 10.8182 8.81819C10.6424 8.99392 10.3575 8.99392 10.1818 8.81819L7.49999 6.13638L4.81819 8.81819C4.64245 8.99392 4.35753 8.99392 4.18179 8.81819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$S = [
    "color"
];
var $c12e32cf04d921d4$export$83414514025c111b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$T = [
    "color"
];
var $c12e32cf04d921d4$export$7dd004358974b05d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$U = [
    "color"
];
var $c12e32cf04d921d4$export$54060461b8d0e637 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$V = [
    "color"
];
var $c12e32cf04d921d4$export$c0a1936901b0e55 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 3H12V12H3L3 3ZM2 3C2 2.44771 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44771 13 2 12.5523 2 12V3ZM10.3498 5.51105C10.506 5.28337 10.4481 4.97212 10.2204 4.81587C9.99275 4.65961 9.6815 4.71751 9.52525 4.94519L6.64048 9.14857L5.19733 7.40889C5.02102 7.19635 4.7058 7.16699 4.49327 7.34329C4.28073 7.5196 4.25137 7.83482 4.42767 8.04735L6.2934 10.2964C6.39348 10.4171 6.54437 10.4838 6.70097 10.4767C6.85757 10.4695 7.00177 10.3894 7.09047 10.2601L10.3498 5.51105Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$W = [
    "color"
];
var $c12e32cf04d921d4$export$4857d3f3f5f8319b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$X = [
    "color"
];
var $c12e32cf04d921d4$export$20bc5960c3c9eebb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$Y = [
    "color"
];
var $c12e32cf04d921d4$export$b837bd7eac09a33e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$Z = [
    "color"
];
var $c12e32cf04d921d4$export$7f01a6cbee61a0f2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$_ = [
    "color"
];
var $c12e32cf04d921d4$export$9c1c3f5a4a271817 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$_);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49991C0.877075 3.84222 3.84222 0.877075 7.49991 0.877075C11.1576 0.877075 14.1227 3.84222 14.1227 7.49991C14.1227 11.1576 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1576 0.877075 7.49991ZM7.49991 1.82708C4.36689 1.82708 1.82708 4.36689 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49991C13.1727 4.36689 10.6329 1.82708 7.49991 1.82708Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$$ = [
    "color"
];
var $c12e32cf04d921d4$export$10324e86d7995e4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$$);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM3.85768 3.15057C4.84311 2.32448 6.11342 1.82708 7.49991 1.82708C10.6329 1.82708 13.1727 4.36689 13.1727 7.49991C13.1727 8.88638 12.6753 10.1567 11.8492 11.1421L3.85768 3.15057ZM3.15057 3.85768C2.32448 4.84311 1.82708 6.11342 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C8.88638 13.1727 10.1567 12.6753 11.1421 11.8492L3.15057 3.85768Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$10 = [
    "color"
];
var $c12e32cf04d921d4$export$60f3f00eeba09710 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$10);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM11 2V2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.33579 3 4 2.66421 4 2.25V2H3.5C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V2.5C12 2.22386 11.7761 2 11.5 2H11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$11 = [
    "color"
];
var $c12e32cf04d921d4$export$1a4dc243f6e39802 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$11);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5C3 2.22386 3.22386 2 3.5 2H4V2.25C4 2.66421 4.33579 3 4.75 3H10.25C10.6642 3 11 2.66421 11 2.25V2H11.5C11.7761 2 12 2.22386 12 2.5V7H13V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5ZM10.5 9C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5C10 8.77614 10.2239 9 10.5 9ZM13 8.5C13 8.77614 12.7761 9 12.5 9C12.2239 9 12 8.77614 12 8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5ZM14.5 9C14.7761 9 15 8.77614 15 8.5C15 8.22386 14.7761 8 14.5 8C14.2239 8 14 8.22386 14 8.5C14 8.77614 14.2239 9 14.5 9ZM15 10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5ZM14.5 13C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5C14 12.7761 14.2239 13 14.5 13ZM14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11ZM9 12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12C8.77614 12 9 12.2239 9 12.5ZM8.5 15C8.77614 15 9 14.7761 9 14.5C9 14.2239 8.77614 14 8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15ZM11 14.5C11 14.7761 10.7761 15 10.5 15C10.2239 15 10 14.7761 10 14.5C10 14.2239 10.2239 14 10.5 14C10.7761 14 11 14.2239 11 14.5ZM12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$12 = [
    "color"
];
var $c12e32cf04d921d4$export$8099ab97743c966c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$12);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$13 = [
    "color"
];
var $c12e32cf04d921d4$export$8036f09137bee589 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$13);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$14 = [
    "color"
];
var $c12e32cf04d921d4$export$32cdc32ad6ae0658 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$14);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.71144 0.796902C7.57741 0.734357 7.42257 0.734357 7.28855 0.796902L1.28855 3.5969C1.11251 3.67905 0.999993 3.85573 0.999993 4.04999V10.95C0.999993 11.1443 1.11251 11.3209 1.28855 11.4031L7.28855 14.2031C7.42257 14.2656 7.57741 14.2656 7.71144 14.2031L13.7114 11.4031C13.8875 11.3209 14 11.1443 14 10.95V4.04999C14 3.85573 13.8875 3.67905 13.7114 3.5969L7.71144 0.796902ZM7.49999 3.15674L5.98039 2.51091L7.49999 1.80176L9.01959 2.51091L7.49999 3.15674ZM7.69556 4.16018L10.2382 3.07958L12.2719 4.02865L7.49999 6.05671L2.72808 4.02865L4.76181 3.07958L7.30442 4.16018C7.42939 4.2133 7.57059 4.2133 7.69556 4.16018ZM7.99999 6.93078L13 4.80578V7.92966L11.0821 8.8119C10.7273 8.97509 10.5 9.32988 10.5 9.72039V11.7982L7.99999 12.9649V6.93078ZM11.5 11.3316L13 10.6316V9.03039L11.5 9.72039V11.3316ZM6.99999 6.93078V12.9649L4.50231 11.7993V9.72036C4.50231 9.32985 4.27499 8.97506 3.92022 8.81187L1.99999 7.92856V4.80578L6.99999 6.93078ZM1.99999 10.6316L3.50231 11.3326L3.50231 9.72036L1.99999 9.02929V10.6316Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$15 = [
    "color"
];
var $c12e32cf04d921d4$export$bda33a04439dd942 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$15);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49985C0.877075 3.84216 3.84222 0.877014 7.49991 0.877014C11.1576 0.877014 14.1227 3.84216 14.1227 7.49985C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49985ZM3.78135 3.21565C4.68298 2.43239 5.83429 1.92904 7.09998 1.84089V6.53429L3.78135 3.21565ZM3.21567 3.78134C2.43242 4.68298 1.92909 5.83428 1.84095 7.09997H6.5343L3.21567 3.78134ZM6.5343 7.89997H1.84097C1.92916 9.16562 2.43253 10.3169 3.21579 11.2185L6.5343 7.89997ZM3.78149 11.7842C4.6831 12.5673 5.83435 13.0707 7.09998 13.1588V8.46566L3.78149 11.7842ZM7.89998 8.46566V13.1588C9.16559 13.0706 10.3168 12.5673 11.2184 11.7841L7.89998 8.46566ZM11.7841 11.2184C12.5673 10.3168 13.0707 9.16558 13.1588 7.89997H8.46567L11.7841 11.2184ZM8.46567 7.09997H13.1589C13.0707 5.83432 12.5674 4.68305 11.7842 3.78143L8.46567 7.09997ZM11.2185 3.21573C10.3169 2.43246 9.16565 1.92909 7.89998 1.8409V6.53429L11.2185 3.21573Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$16 = [
    "color"
];
var $c12e32cf04d921d4$export$bfc20b5a7dea0537 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$16);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.00012 1.5C8.00012 1.22386 7.77626 1 7.50012 1C7.22398 1 7.00012 1.22386 7.00012 1.5V13.5C7.00012 13.7761 7.22398 14 7.50012 14C7.77626 14 8.00012 13.7761 8.00012 13.5V1.5ZM3.31812 5.818C3.49386 5.64227 3.49386 5.35734 3.31812 5.18161C3.14239 5.00587 2.85746 5.00587 2.68173 5.18161L0.681729 7.18161C0.505993 7.35734 0.505993 7.64227 0.681729 7.818L2.68173 9.818C2.85746 9.99374 3.14239 9.99374 3.31812 9.818C3.49386 9.64227 3.49386 9.35734 3.31812 9.18161L2.08632 7.9498H5.50017C5.7487 7.9498 5.95017 7.74833 5.95017 7.4998C5.95017 7.25128 5.7487 7.0498 5.50017 7.0498H2.08632L3.31812 5.818ZM12.3181 5.18161C12.1424 5.00587 11.8575 5.00587 11.6817 5.18161C11.506 5.35734 11.506 5.64227 11.6817 5.818L12.9135 7.0498H9.50017C9.25164 7.0498 9.05017 7.25128 9.05017 7.4998C9.05017 7.74833 9.25164 7.9498 9.50017 7.9498H12.9135L11.6817 9.18161C11.506 9.35734 11.506 9.64227 11.6817 9.818C11.8575 9.99374 12.1424 9.99374 12.3181 9.818L14.3181 7.818C14.4939 7.64227 14.4939 7.35734 14.3181 7.18161L12.3181 5.18161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$17 = [
    "color"
];
var $c12e32cf04d921d4$export$38f001d9cffdd080 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$17);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.14998 14V1H0.849976V14H2.14998ZM6.14998 14V1H4.84998V14H6.14998ZM10.15 1V14H8.84998V1H10.15ZM14.15 14V1H12.85V14H14.15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$18 = [
    "color"
];
var $c12e32cf04d921d4$export$13d9ab7fa696f910 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$18);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.94969 7.49989C9.94969 8.85288 8.85288 9.94969 7.49989 9.94969C6.14691 9.94969 5.0501 8.85288 5.0501 7.49989C5.0501 6.14691 6.14691 5.0501 7.49989 5.0501C8.85288 5.0501 9.94969 6.14691 9.94969 7.49989ZM10.8632 8C10.6213 9.64055 9.20764 10.8997 7.49989 10.8997C5.79214 10.8997 4.37847 9.64055 4.13662 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H4.13659C4.37835 5.35935 5.79206 4.1001 7.49989 4.1001C9.20772 4.1001 10.6214 5.35935 10.8632 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H10.8632Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$19 = [
    "color"
];
var $c12e32cf04d921d4$export$a8e03ddff565be2c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$19);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.67129 3.14634C4.47603 3.34161 4.47603 3.65819 4.67129 3.85345L7.14616 6.32833C7.34142 6.52359 7.65801 6.52359 7.85327 6.32833L10.3281 3.85345C10.5234 3.65819 10.5234 3.34161 10.3281 3.14634L7.85327 0.671471C7.65801 0.476209 7.34142 0.476209 7.14616 0.671471L4.67129 3.14634ZM7.49971 5.26766L5.73195 3.4999L7.49971 1.73213L9.26748 3.4999L7.49971 5.26766ZM8.67129 7.14634C8.47603 7.34161 8.47603 7.65819 8.67129 7.85345L11.1462 10.3283C11.3414 10.5236 11.658 10.5236 11.8533 10.3283L14.3281 7.85345C14.5234 7.65819 14.5234 7.34161 14.3281 7.14634L11.8533 4.67147C11.658 4.47621 11.3414 4.47621 11.1462 4.67147L8.67129 7.14634ZM11.4997 9.26766L9.73195 7.4999L11.4997 5.73213L13.2675 7.4999L11.4997 9.26766ZM4.67129 11.8535C4.47603 11.6582 4.47603 11.3416 4.67129 11.1463L7.14616 8.67147C7.34142 8.47621 7.65801 8.47621 7.85327 8.67147L10.3281 11.1463C10.5234 11.3416 10.5234 11.6582 10.3281 11.8535L7.85327 14.3283C7.65801 14.5236 7.34142 14.5236 7.14616 14.3283L4.67129 11.8535ZM5.73195 11.4999L7.49971 13.2677L9.26748 11.4999L7.49971 9.73213L5.73195 11.4999ZM0.671288 7.14649C0.476026 7.34175 0.476026 7.65834 0.671288 7.8536L3.14616 10.3285C3.34142 10.5237 3.65801 10.5237 3.85327 10.3285L6.32814 7.8536C6.5234 7.65834 6.5234 7.34175 6.32814 7.14649L3.85327 4.67162C3.65801 4.47636 3.34142 4.47636 3.14616 4.67162L0.671288 7.14649ZM3.49972 9.26781L1.73195 7.50005L3.49972 5.73228L5.26748 7.50005L3.49972 9.26781Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1a = [
    "color"
];
var $c12e32cf04d921d4$export$467c6b1dbd59bc1e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.87935 1H3.9H11.1H11.1207C11.5231 0.999994 11.8553 0.999989 12.1259 1.0221C12.407 1.04506 12.6653 1.09434 12.908 1.21799C13.2843 1.40973 13.5903 1.7157 13.782 2.09202C13.9057 2.33469 13.9549 2.59304 13.9779 2.87409C14 3.14468 14 3.47686 14 3.87934V3.9V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H3.9H3.87934C3.47686 14 3.14468 14 2.87409 13.9779C2.59304 13.9549 2.33469 13.9057 2.09202 13.782C1.7157 13.5903 1.40973 13.2843 1.21799 12.908C1.09434 12.6653 1.04506 12.407 1.0221 12.1259C0.999989 11.8553 0.999994 11.5231 1 11.1207V11.1207V11.1V3.9V3.87935V3.87934C0.999994 3.47686 0.999989 3.14468 1.0221 2.87409C1.04506 2.59304 1.09434 2.33469 1.21799 2.09202C1.40973 1.7157 1.7157 1.40973 2.09202 1.21799C2.33469 1.09434 2.59304 1.04506 2.87409 1.0221C3.14469 0.999989 3.47687 0.999994 3.87935 1ZM2.95552 2.01878C2.73631 2.03669 2.62421 2.06915 2.54601 2.10899C2.35785 2.20487 2.20487 2.35785 2.10899 2.54601C2.06915 2.62421 2.03669 2.73631 2.01878 2.95552C2.00039 3.18056 2 3.47171 2 3.9V7H7V2H3.9C3.47171 2 3.18056 2.00039 2.95552 2.01878ZM7 8H2V11.1C2 11.5283 2.00039 11.8194 2.01878 12.0445C2.03669 12.2637 2.06915 12.3758 2.10899 12.454C2.20487 12.6422 2.35785 12.7951 2.54601 12.891C2.62421 12.9309 2.73631 12.9633 2.95552 12.9812C3.18056 12.9996 3.47171 13 3.9 13H7V8ZM8 8H13V11.1C13 11.5283 12.9996 11.8194 12.9812 12.0445C12.9633 12.2637 12.9309 12.3758 12.891 12.454C12.7951 12.6422 12.6422 12.7951 12.454 12.891C12.3758 12.9309 12.2637 12.9633 12.0445 12.9812C11.8194 12.9996 11.5283 13 11.1 13H8V8ZM13 7H8V2H11.1C11.5283 2 11.8194 2.00039 12.0445 2.01878C12.2637 2.03669 12.3758 2.06915 12.454 2.10899C12.6422 2.20487 12.7951 2.35785 12.891 2.54601C12.9309 2.62421 12.9633 2.73631 12.9812 2.95552C12.9996 3.18056 13 3.47171 13 3.9V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1b = [
    "color"
];
var $c12e32cf04d921d4$export$8b4f0e3d2d9d0b5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.85367 1.48956C7.65841 1.29429 7.34182 1.29429 7.14656 1.48956L1.48971 7.14641C1.29445 7.34167 1.29445 7.65825 1.48971 7.85352L7.14656 13.5104C7.34182 13.7056 7.65841 13.7056 7.85367 13.5104L13.5105 7.85352C13.7058 7.65825 13.7058 7.34167 13.5105 7.14641L7.85367 1.48956ZM7.5 2.55033L2.55037 7.49996L7.5 12.4496V2.55033Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1c = [
    "color"
];
var $c12e32cf04d921d4$export$4edbb1daceb32596 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.1465 1.48959C7.34176 1.29432 7.65835 1.29432 7.85361 1.48959L13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355L7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104L1.48965 7.85355C1.29439 7.65829 1.29439 7.3417 1.48965 7.14644L7.1465 1.48959ZM7.50005 2.55025L2.55031 7.49999L7.50005 12.4497L12.4498 7.49999L7.50005 2.55025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1d = [
    "color"
];
var $c12e32cf04d921d4$export$8a42855f849911b4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959L1.48965 7.14644C1.29439 7.3417 1.29439 7.65829 1.48965 7.85355L3.9645 10.3284L1.64644 12.6464C1.45118 12.8417 1.45118 13.1583 1.64644 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.6716 11.0355L7.1465 13.5104C7.34176 13.7057 7.65835 13.7057 7.85361 13.5104L13.5105 7.85355C13.7057 7.65829 13.7057 7.3417 13.5105 7.14644L11.0356 4.67154L13.3535 2.35355C13.5488 2.15829 13.5488 1.84171 13.3535 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.3285 3.96443L7.85361 1.48959ZM9.62135 4.67154L7.50005 2.55025L2.55031 7.49999L4.6716 9.62129L9.62135 4.67154ZM5.37871 10.3284L7.50005 12.4497L12.4498 7.49999L10.3285 5.37865L5.37871 10.3284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1e = [
    "color"
];
var $c12e32cf04d921d4$export$39c9cf5aa1336b1f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.8034 7.14644C12.9986 6.95118 13.3152 6.95118 13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355C13.3152 8.04881 12.9986 8.04881 12.8034 7.85355C12.6081 7.65828 12.6081 7.3417 12.8034 7.14644ZM12.0962 8.56065C12.2915 8.75592 12.2915 9.0725 12.0962 9.26776C11.901 9.46302 11.5844 9.46302 11.3891 9.26776C11.1939 9.0725 11.1939 8.75592 11.3891 8.56065C11.5844 8.36539 11.901 8.36539 12.0962 8.56065ZM10.682 9.97487C10.8773 10.1701 10.8773 10.4867 10.682 10.682C10.4868 10.8772 10.1702 10.8772 9.97493 10.682C9.77967 10.4867 9.77967 10.1701 9.97493 9.97487C10.1702 9.7796 10.4868 9.7796 10.682 9.97487ZM9.26782 11.3891C9.46308 11.5843 9.46308 11.9009 9.26782 12.0962C9.07256 12.2915 8.75598 12.2915 8.56071 12.0962C8.36545 11.9009 8.36545 11.5843 8.56072 11.3891C8.75598 11.1938 9.07256 11.1938 9.26782 11.3891ZM7.1465 13.5104C6.95124 13.3151 6.95124 12.9986 7.1465 12.8033C7.17091 12.7789 7.19721 12.7575 7.22494 12.7392C7.41901 12.6111 7.68275 12.6324 7.85361 12.8033C8.04887 12.9986 8.04887 13.3151 7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M2.90386 8.56065C2.7086 8.75592 2.7086 9.0725 2.90386 9.26776 3.09912 9.46302 3.41571 9.46302 3.61097 9.26776 3.80623 9.0725 3.80623 8.75592 3.61097 8.56065 3.41571 8.36539 3.09912 8.36539 2.90386 8.56065zM4.31807 9.97487C4.12281 10.1701 4.12281 10.4867 4.31807 10.682 4.51334 10.8772 4.82992 10.8772 5.02518 10.682 5.22044 10.4867 5.22044 10.1701 5.02518 9.97487 4.82992 9.7796 4.51334 9.7796 4.31807 9.97487zM5.73229 11.3891C5.53703 11.5843 5.53703 11.9009 5.73229 12.0962 5.92755 12.2914 6.24413 12.2915 6.43939 12.0962 6.63466 11.9009 6.63466 11.5843 6.43939 11.3891 6.24413 11.1938 5.92755 11.1938 5.73229 11.3891zM2.19675 7.85355C2.36761 7.68269 2.38897 7.41895 2.26082 7.22488 2.09046 6.96684 1.71063 6.92546 1.48965 7.14644 1.29439 7.3417 1.29439 7.65829 1.48965 7.85355 1.68491 8.04881 2.00149 8.04881 2.19675 7.85355zM3.61097 5.73223C3.41571 5.53696 3.09912 5.53696 2.90386 5.73223 2.7086 5.92749 2.7086 6.24407 2.90386 6.43933 3.09912 6.6346 3.41571 6.6346 3.61097 6.43933 3.80623 6.24407 3.80623 5.92749 3.61097 5.73223zM5.02518 4.31801C4.82992 4.12275 4.51334 4.12275 4.31807 4.31801 4.12281 4.51328 4.12281 4.82986 4.31807 5.02512 4.51334 5.22038 4.82992 5.22038 5.02518 5.02512 5.22044 4.82986 5.22044 4.51328 5.02518 4.31801zM6.43939 2.9038C6.24413 2.70854 5.92755 2.70854 5.73229 2.9038 5.53703 3.09906 5.53703 3.41564 5.73229 3.61091 5.92755 3.80617 6.24413 3.80617 6.43939 3.61091 6.63466 3.41564 6.63466 3.09906 6.43939 2.9038zM7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959 6.95124 1.68485 6.95124 2.00143 7.1465 2.19669 7.34176 2.39196 7.65835 2.39196 7.85361 2.19669 8.04887 2.00143 8.04887 1.68485 7.85361 1.48959zM9.26782 2.9038C9.07256 2.70854 8.75598 2.70854 8.56071 2.9038 8.36545 3.09906 8.36545 3.41564 8.56071 3.61091 8.75598 3.80617 9.07256 3.80617 9.26782 3.61091 9.46308 3.41564 9.46308 3.09906 9.26782 2.9038zM10.682 4.31801C10.4868 4.12275 10.1702 4.12275 9.97493 4.31801 9.77967 4.51328 9.77967 4.82986 9.97493 5.02512 10.1702 5.22038 10.4868 5.22038 10.682 5.02512 10.8773 4.82986 10.8773 4.51328 10.682 4.31801zM12.0962 5.73223C11.901 5.53696 11.5844 5.53696 11.3891 5.73223 11.1939 5.92749 11.1939 6.24407 11.3891 6.43933 11.5844 6.6346 11.901 6.6346 12.0962 6.43933 12.2915 6.24407 12.2915 5.92749 12.0962 5.73223z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$1f = [
    "color"
];
var $c12e32cf04d921d4$export$6d6da6edaddd5876 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM5 13H10V2L5 2L5 13ZM4 13C4 13.5523 4.44772 14 5 14H10C10.5523 14 11 13.5523 11 13V2C11 1.44772 10.5523 1 10 1H5C4.44772 1 4 1.44771 4 2V13ZM13.5 2C13.7761 2 14 1.77614 14 1.5C14 1.22386 13.7761 1 13.5 1C13.2239 1 13 1.22386 13 1.5C13 1.77614 13.2239 2 13.5 2ZM2 3.5C2 3.77614 1.77614 4 1.5 4C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3C1.77614 3 2 3.22386 2 3.5ZM13.5 4C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3C13.2239 3 13 3.22386 13 3.5C13 3.77614 13.2239 4 13.5 4ZM2 5.5C2 5.77614 1.77614 6 1.5 6C1.22386 6 1 5.77614 1 5.5C1 5.22386 1.22386 5 1.5 5C1.77614 5 2 5.22386 2 5.5ZM13.5 6C13.7761 6 14 5.77614 14 5.5C14 5.22386 13.7761 5 13.5 5C13.2239 5 13 5.22386 13 5.5C13 5.77614 13.2239 6 13.5 6ZM2 7.5C2 7.77614 1.77614 8 1.5 8C1.22386 8 1 7.77614 1 7.5C1 7.22386 1.22386 7 1.5 7C1.77614 7 2 7.22386 2 7.5ZM13.5 8C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5C13 7.77614 13.2239 8 13.5 8ZM2 9.5C2 9.77614 1.77614 10 1.5 10C1.22386 10 1 9.77614 1 9.5C1 9.22386 1.22386 9 1.5 9C1.77614 9 2 9.22386 2 9.5ZM13.5 10C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5C13 9.77614 13.2239 10 13.5 10ZM2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5ZM13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12ZM2 13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5C1 13.2239 1.22386 13 1.5 13C1.77614 13 2 13.2239 2 13.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1g = [
    "color"
];
var $c12e32cf04d921d4$export$4231f341127e9d59 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.0697 1.76746C12.4807 1.21947 11.4605 0.454311 11.0495 1.0023C10.6385 1.55028 11.6588 2.31544 12.0697 1.76746ZM8.39263 1.07811C7.15585 0.950602 5.7823 1.16348 4.58433 1.70937C3.38552 2.25563 2.32735 3.15309 1.78844 4.41832C1.37574 5.38724 1.01715 6.28113 1.00088 7.44354C0.984724 8.59844 1.30522 9.96898 2.13174 11.928C2.61142 13.0649 4.03963 13.5446 5.13895 13.8079C6.40836 14.1119 7.80857 14.1914 8.6644 14.0742C9.36515 13.9782 10.1448 13.8284 10.7987 13.297C11.8977 12.4039 12.9009 11.3955 13.4994 10.3393C14.104 9.27221 14.3256 8.09207 13.7216 6.95324C13.5628 6.65373 13.316 6.57734 13.0412 6.4923C12.9374 6.46016 12.8295 6.42678 12.7209 6.37966C11.6211 5.90234 10.9646 5.34963 10.9135 5.02876C10.8656 4.72808 10.9221 4.51463 10.9811 4.29181C11.0129 4.17199 11.0453 4.04947 11.0626 3.90922C11.0838 3.73737 11.0814 3.33319 10.6996 3.12761C10.4048 2.96888 10.2164 2.65843 10.0407 2.36904C9.99742 2.29775 9.95492 2.22773 9.9118 2.16158C9.62634 1.72367 9.20769 1.16213 8.39263 1.07811ZM4.99899 2.61935C3.96483 3.09058 3.12554 3.83097 2.70846 4.81018C2.29808 5.77368 2.01406 6.50873 2.00079 7.45753C1.98741 8.41385 2.25043 9.6368 3.0531 11.5393C3.39181 12.3421 4.62167 12.6557 5.37186 12.8354C6.5493 13.1174 7.822 13.1802 8.52868 13.0834C9.21271 12.9897 9.74568 12.8642 10.1681 12.5209C11.229 11.6587 12.121 10.7435 12.6293 9.84635C12.9349 9.30709 13.5141 7.7028 12.6292 7.3873C10.7539 6.71875 10.262 6.06669 9.99011 5.41268C9.80915 4.97744 9.82868 4.52282 9.95741 4.07885L9.95741 4.07884C9.97662 4.0126 9.99538 3.94791 10.0334 3.88882C9.81857 3.73676 9.6515 3.55195 9.51464 3.3715C9.42876 3.25828 9.3469 3.12099 9.26197 2.97856C9.01866 2.57052 8.75018 2.12027 8.29008 2.07283C7.22889 1.96343 6.03398 2.14772 4.99899 2.61935ZM13.2081 3.77471C13.441 3.22671 12.4547 2.63606 12.0822 3.10163C11.5817 3.72732 12.9029 4.49281 13.2081 3.77471ZM14.3672 2.26031C14.9668 2.27493 15.1551 1.11603 14.5718 0.949371C13.8076 0.731026 13.5918 2.24139 14.3672 2.26031ZM14.2857 5.09098C14.8644 5.10004 15.0462 4.38222 14.4832 4.27899C13.7455 4.14375 13.5373 5.07927 14.2857 5.09098ZM6.9075 4.28672C6.46898 4.66754 6.0522 4.15185 5.97983 3.7365C5.86848 3.09744 6.33696 2.56856 6.94823 2.91156C7.43344 3.18382 7.26678 3.97471 6.9075 4.28672ZM4.94455 5.88184C5.40885 5.41754 4.59567 4.57013 4.11425 5.05154C3.83338 5.33242 4.00936 5.65376 4.23744 5.88184C4.43271 6.0771 4.74929 6.0771 4.94455 5.88184ZM6.97716 6.71984C7.31181 7.38914 8.48804 6.79159 7.99413 6.14788C7.86519 5.97983 7.68657 5.9494 7.62145 5.94207C7.21217 5.89601 6.76349 6.2925 6.97716 6.71984ZM6.98798 8.72461C7.14066 9.1188 7.51122 9.3187 7.91915 9.1633C8.27434 9.02799 8.33186 8.39689 8.17175 8.07427C8.02331 7.77514 7.63956 7.67793 7.33747 7.79417C6.98512 7.92976 6.85672 8.38708 6.98576 8.71889L6.98798 8.72461ZM10.3885 8.84081C10.7575 8.6566 11.4617 8.82771 11.4617 9.31199C11.4617 9.71286 10.9587 10.2165 10.5634 10.2826C10.1813 10.3465 9.70515 9.97581 9.76648 9.57718C9.81445 9.26539 10.1217 8.97401 10.3885 8.84081ZM7.56704 10.8432C7.33461 10.7502 7.14353 10.8601 7.11437 10.8769L7.11279 10.8778C6.90782 10.9949 6.71383 11.2439 6.6747 11.4842C6.59018 12.0034 7.13199 12.1239 7.52661 12.0987C8.2074 12.0553 8.06547 11.0426 7.56704 10.8432ZM4.8805 10.8932C5.0674 10.7723 5.15658 10.5363 5.08293 10.3153C4.93046 9.79687 4.3246 9.71252 3.96561 10.1297C3.79336 10.3299 3.80749 10.6274 3.99214 10.8105L3.99495 10.814L3.9979 10.8176C4.22025 11.0942 4.63624 11.1857 4.8805 10.8932ZM3.04695 7.81318C3.33147 8.0977 3.60077 8.15067 3.98443 8.05859C4.60826 7.90887 4.13814 6.24299 3.047 6.87296C2.70939 7.06788 2.86716 7.63339 3.04695 7.81318Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1h = [
    "color"
];
var $c12e32cf04d921d4$export$51b6cd98f8778f0d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1i = [
    "color"
];
var $c12e32cf04d921d4$export$53250eb5c8bd1390 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.87737 12H9.9H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H9.9C8.77164 11 7.95545 10.9996 7.31352 10.9472C6.67744 10.8952 6.25662 10.7946 5.91103 10.6185C5.25247 10.283 4.71703 9.74753 4.38148 9.08897C4.20539 8.74338 4.10481 8.32256 4.05284 7.68648C4.00039 7.04455 4 6.22836 4 5.1V3.5C4 3.22386 3.77614 3 3.5 3C3.22386 3 3 3.22386 3 3.5V5.1V5.12263C3 6.22359 3 7.08052 3.05616 7.76791C3.11318 8.46584 3.23058 9.0329 3.49047 9.54296C3.9219 10.3897 4.61031 11.0781 5.45704 11.5095C5.9671 11.7694 6.53416 11.8868 7.23209 11.9438C7.91948 12 8.77641 12 9.87737 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1j = [
    "color"
];
var $c12e32cf04d921d4$export$13d7020d49a403c9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.12263 12H5.1H3.5C3.22386 12 3 11.7761 3 11.5C3 11.2239 3.22386 11 3.5 11H5.1C6.22836 11 7.04455 10.9996 7.68648 10.9472C8.32256 10.8952 8.74338 10.7946 9.08897 10.6185C9.74753 10.283 10.283 9.74753 10.6185 9.08897C10.7946 8.74338 10.8952 8.32256 10.9472 7.68648C10.9996 7.04455 11 6.22836 11 5.1V3.5C11 3.22386 11.2239 3 11.5 3C11.7761 3 12 3.22386 12 3.5V5.1V5.12263C12 6.22359 12 7.08052 11.9438 7.76791C11.8868 8.46584 11.7694 9.0329 11.5095 9.54296C11.0781 10.3897 10.3897 11.0781 9.54296 11.5095C9.0329 11.7694 8.46584 11.8868 7.76791 11.9438C7.08052 12 6.22359 12 5.12263 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1k = [
    "color"
];
var $c12e32cf04d921d4$export$e709160419ee2246 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.87737 3H9.9H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H9.9C8.77164 4 7.95545 4.00039 7.31352 4.05284C6.67744 4.10481 6.25662 4.20539 5.91103 4.38148C5.25247 4.71703 4.71703 5.25247 4.38148 5.91103C4.20539 6.25662 4.10481 6.67744 4.05284 7.31352C4.00039 7.95545 4 8.77164 4 9.9V11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5V9.9V9.87737C3 8.77641 3 7.91948 3.05616 7.23209C3.11318 6.53416 3.23058 5.9671 3.49047 5.45704C3.9219 4.61031 4.61031 3.9219 5.45704 3.49047C5.9671 3.23058 6.53416 3.11318 7.23209 3.05616C7.91948 3 8.77641 3 9.87737 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1l = [
    "color"
];
var $c12e32cf04d921d4$export$8e3e82083a0db3ff = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.12263 3H5.1H3.5C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H5.1C6.22836 4 7.04455 4.00039 7.68648 4.05284C8.32256 4.10481 8.74338 4.20539 9.08897 4.38148C9.74753 4.71703 10.283 5.25247 10.6185 5.91103C10.7946 6.25662 10.8952 6.67744 10.9472 7.31352C10.9996 7.95545 11 8.77164 11 9.9V11.5C11 11.7761 11.2239 12 11.5 12C11.7761 12 12 11.7761 12 11.5V9.9V9.87737C12 8.77641 12 7.91948 11.9438 7.23209C11.8868 6.53416 11.7694 5.9671 11.5095 5.45704C11.0781 4.61031 10.3897 3.9219 9.54296 3.49047C9.0329 3.23058 8.46584 3.11318 7.76791 3.05616C7.08052 3 6.22359 3 5.12263 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1m = [
    "color"
];
var $c12e32cf04d921d4$export$3473a9c28d168741 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 2L4.87935 2C4.47687 1.99999 4.14469 1.99999 3.87409 2.0221C3.59304 2.04506 3.33469 2.09434 3.09202 2.21799C2.7157 2.40973 2.40973 2.7157 2.21799 3.09202C2.09434 3.33469 2.04506 3.59304 2.0221 3.87409C1.99999 4.14468 1.99999 4.47686 2 4.87933V4.87935V5.5C2 5.77614 2.22386 6 2.5 6C2.77614 6 3 5.77614 3 5.5V4.9C3 4.47171 3.00039 4.18056 3.01878 3.95552C3.03669 3.73631 3.06915 3.62421 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.62421 3.06915 3.73631 3.03669 3.95552 3.01878C4.18056 3.00039 4.47171 3 4.9 3H5.5C5.77614 3 6 2.77614 6 2.5C6 2.22386 5.77614 2 5.5 2ZM13 9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5V10.1C12 10.5283 11.9996 10.8194 11.9812 11.0445C11.9633 11.2637 11.9309 11.3758 11.891 11.454C11.7951 11.6422 11.6422 11.7951 11.454 11.891C11.3758 11.9309 11.2637 11.9633 11.0445 11.9812C10.8194 11.9996 10.5283 12 10.1 12H9.5C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H10.1206C10.5231 13 10.8553 13 11.1259 12.9779C11.407 12.9549 11.6653 12.9057 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C12.9057 11.6653 12.9549 11.407 12.9779 11.1259C13 10.8553 13 10.5232 13 10.1207V10.1207V10.1207V10.1206V9.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V10.1C3 10.5283 3.00039 10.8194 3.01878 11.0445C3.03669 11.2637 3.06915 11.3758 3.10899 11.454C3.20487 11.6422 3.35785 11.7951 3.54601 11.891C3.62421 11.9309 3.73631 11.9633 3.95552 11.9812C4.18056 11.9996 4.47171 12 4.9 12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H4.87935C4.47687 13 4.14469 13 3.87409 12.9779C3.59304 12.9549 3.33469 12.9057 3.09202 12.782C2.7157 12.5903 2.40973 12.2843 2.21799 11.908C2.09434 11.6653 2.04506 11.407 2.0221 11.1259C1.99999 10.8553 1.99999 10.5231 2 10.1207V10.1206V10.1V9.5C2 9.22386 2.22386 9 2.5 9ZM10.1 3C10.5283 3 10.8194 3.00039 11.0445 3.01878C11.2637 3.03669 11.3758 3.06915 11.454 3.10899C11.6422 3.20487 11.7951 3.35785 11.891 3.54601C11.9309 3.62421 11.9633 3.73631 11.9812 3.95552C11.9996 4.18056 12 4.47171 12 4.9V5.5C12 5.77614 12.2239 6 12.5 6C12.7761 6 13 5.77614 13 5.5V4.87935V4.87934C13 4.47686 13 4.14468 12.9779 3.87409C12.9549 3.59304 12.9057 3.33469 12.782 3.09202C12.5903 2.7157 12.2843 2.40973 11.908 2.21799C11.6653 2.09434 11.407 2.04506 11.1259 2.0221C10.8553 1.99999 10.5231 1.99999 10.1206 2L10.1 2H9.5C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3H10.1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1n = [
    "color"
];
var $c12e32cf04d921d4$export$d947354b0bb44dfa = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.7217 1.84998 3.34851 3.90636 2.76336 4.99997H4.5C4.77614 4.99997 5 5.22383 5 5.49997C5 5.77611 4.77614 5.99997 4.5 5.99997H1.5C1.22386 5.99997 1 5.77611 1 5.49997V2.49997C1 2.22383 1.22386 1.99997 1.5 1.99997C1.77614 1.99997 2 2.22383 2 2.49997V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7 10V5.00001H8V10H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1o = [
    "color"
];
var $c12e32cf04d921d4$export$92a2757a17018399 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.72167 1.84998 3.34849 3.9064 2.76335 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H1.5C1.22386 6 1 5.77614 1 5.5V2.5C1 2.22386 1.22386 2 1.5 2C1.77614 2 2 2.22386 2 2.5V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7.5 4.00001C7.77614 4.00001 8 4.22387 8 4.50001V7.29291L9.85355 9.14646C10.0488 9.34172 10.0488 9.65831 9.85355 9.85357C9.65829 10.0488 9.34171 10.0488 9.14645 9.85357L7.14645 7.85357C7.05268 7.7598 7 7.63262 7 7.50001V4.50001C7 4.22387 7.22386 4.00001 7.5 4.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1p = [
    "color"
];
var $c12e32cf04d921d4$export$9816aad82d905e6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 8.00684e-07C3.77614 7.88614e-07 4 0.223859 4 0.500001L4 3.00006L11.5 3.00006C11.7761 3.00006 12 3.22392 12 3.50006L12 11.0001L14.5 11C14.7761 11 15 11.2238 15 11.5C15 11.7761 14.7762 12 14.5 12L12 12.0001L12 14.5C12 14.7761 11.7761 15 11.5 15C11.2239 15 11 14.7761 11 14.5L11 12.0001L3.5 12.0001C3.22386 12.0001 3 11.7762 3 11.5001L3 4.00005L0.499989 4C0.223847 4 -6.10541e-06 3.77613 -5.02576e-07 3.49999C5.13006e-06 3.22385 0.223867 3 0.50001 3L3 3.00005L3 0.500001C3 0.223859 3.22386 8.12755e-07 3.5 8.00684e-07ZM4 4.00006L4 11.0001L11 11.0001L11 4.00006L4 4.00006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1q = [
    "color"
];
var $c12e32cf04d921d4$export$8c97d895bfadca90 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1r = [
    "color"
];
var $c12e32cf04d921d4$export$b7fa469a3cb3cd4f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1s = [
    "color"
];
var $c12e32cf04d921d4$export$8710c0d3947fcfc3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1t = [
    "color"
];
var $c12e32cf04d921d4$export$d5c5855fccded9fe = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.50207C0.877075 3.84319 3.84319 0.877075 7.50208 0.877075C11.1609 0.877075 14.1271 3.84319 14.1271 7.50207C14.1271 11.1609 11.1609 14.1271 7.50208 14.1271C3.84319 14.1271 0.877075 11.1609 0.877075 7.50207ZM1.84898 7.00003C2.0886 4.26639 4.26639 2.0886 7.00003 1.84898V4.50003C7.00003 4.77617 7.22388 5.00003 7.50003 5.00003C7.77617 5.00003 8.00003 4.77617 8.00003 4.50003V1.84862C10.7356 2.08643 12.9154 4.26502 13.1552 7.00003H10.5C10.2239 7.00003 10 7.22388 10 7.50003C10 7.77617 10.2239 8.00003 10.5 8.00003H13.1555C12.9176 10.7369 10.7369 12.9176 8.00003 13.1555V10.5C8.00003 10.2239 7.77617 10 7.50003 10C7.22388 10 7.00003 10.2239 7.00003 10.5V13.1552C4.26502 12.9154 2.08643 10.7356 1.84862 8.00003H4.50003C4.77617 8.00003 5.00003 7.77617 5.00003 7.50003C5.00003 7.22388 4.77617 7.00003 4.50003 7.00003H1.84898Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1u = [
    "color"
];
var $c12e32cf04d921d4$export$d0fffbce0e008b09 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V1.80687C10.6922 2.0935 12.8167 4.28012 13.0068 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H12.9888C12.7094 10.6244 10.6244 12.7094 8 12.9888V14.5C8 14.7761 7.77614 15 7.5 15C7.22386 15 7 14.7761 7 14.5V13.0068C4.28012 12.8167 2.0935 10.6922 1.80687 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H1.78886C1.98376 4.21166 4.21166 1.98376 7 1.78886V0.5C7 0.223858 7.22386 0 7.5 0ZM8 12.0322V9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5V12.054C4.80517 11.8689 3.04222 10.1668 2.76344 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7H2.7417C2.93252 4.73662 4.73662 2.93252 7 2.7417V5.5C7 5.77614 7.22386 6 7.5 6C7.77614 6 8 5.77614 8 5.5V2.76344C10.1668 3.04222 11.8689 4.80517 12.054 7H9.5C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8H12.0322C11.7621 10.0991 10.0991 11.7621 8 12.0322Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1v = [
    "color"
];
var $c12e32cf04d921d4$export$18abdbf97bad2a11 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.60913 0.0634287C4.39082 0.0088505 4.16575 0.12393 4.08218 0.332867L3.1538 2.6538L0.832866 3.58218C0.702884 3.63417 0.604504 3.7437 0.566705 3.87849C0.528906 4.01329 0.555994 4.158 0.639992 4.26999L2.01148 6.09864L1.06343 9.89085C1.00944 10.1068 1.12145 10.3298 1.32691 10.4154L4.20115 11.613L5.62557 13.7496C5.73412 13.9124 5.93545 13.9864 6.12362 13.9327L9.62362 12.9327C9.62988 12.9309 9.63611 12.929 9.64229 12.9269L12.6423 11.9269C12.7923 11.8769 12.905 11.7519 12.9393 11.5976L13.9393 7.09761C13.9776 6.92506 13.9114 6.74605 13.77 6.63999L11.95 5.27499V2.99999C11.95 2.82955 11.8537 2.67373 11.7012 2.5975L8.70124 1.0975C8.67187 1.08282 8.64098 1.07139 8.60913 1.06343L4.60913 0.0634287ZM11.4323 6.01173L12.7748 7.01858L10.2119 9.15429C10.1476 9.20786 10.0995 9.2783 10.0731 9.35769L9.25382 11.8155L7.73849 10.8684C7.52774 10.7367 7.25011 10.8007 7.11839 11.0115C6.98667 11.2222 7.05074 11.4999 7.26149 11.6316L8.40341 12.3453L6.19221 12.9771L4.87441 11.0004C4.82513 10.9265 4.75508 10.8688 4.67307 10.8346L2.03046 9.73352L2.85134 6.44999H4.99999C5.24852 6.44999 5.44999 6.24852 5.44999 5.99999C5.44999 5.75146 5.24852 5.54999 4.99999 5.54999H2.72499L1.7123 4.19974L3.51407 3.47903L6.35769 4.4269C6.53655 4.48652 6.73361 4.42832 6.85138 4.28111L8.62413 2.06518L11.05 3.27811V5.19533L8.83287 6.08218C8.70996 6.13134 8.61494 6.23212 8.57308 6.35769L8.07308 7.85769C7.99449 8.09346 8.12191 8.34831 8.35769 8.4269C8.59346 8.50549 8.84831 8.37807 8.9269 8.14229L9.3609 6.84029L11.4323 6.01173ZM7.71052 1.76648L6.34462 3.47386L4.09505 2.724L4.77192 1.03183L7.71052 1.76648ZM10.2115 11.7885L12.116 11.1537L12.7745 8.19034L10.8864 9.76374L10.2115 11.7885Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1w = [
    "color"
];
var $c12e32cf04d921d4$export$315ae6298b7de94 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1x = [
    "color"
];
var $c12e32cf04d921d4$export$4e8767be554cec68 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1y = [
    "color"
];
var $c12e32cf04d921d4$export$d665abe9390574dd = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2C5.42215 2 6.0399 2.23054 6.42075 2.56379C6.79286 2.88939 7 3.36626 7 4V7H5.75C5.47386 7 5.25 7.22386 5.25 7.5C5.25 7.77614 5.47386 8 5.75 8H7V11C7 11.6337 6.79286 12.1106 6.42075 12.4362C6.0399 12.7695 5.42215 13 4.5 13C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14C5.57785 14 6.4601 13.7305 7.07925 13.1888C7.24168 13.0467 7.38169 12.8896 7.5 12.7198C7.61832 12.8896 7.75832 13.0467 7.92075 13.1888C8.5399 13.7305 9.42215 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.57785 13 8.9601 12.7695 8.57925 12.4362C8.20714 12.1106 8 11.6337 8 11V8H9.25C9.52614 8 9.75 7.77614 9.75 7.5C9.75 7.22386 9.52614 7 9.25 7H8V4C8 3.36626 8.20714 2.88939 8.57925 2.56379C8.9601 2.23054 9.57785 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.42215 1 8.5399 1.26946 7.92075 1.81121C7.75832 1.95333 7.61832 2.11043 7.5 2.28023C7.38168 2.11043 7.24168 1.95333 7.07925 1.81121C6.4601 1.26946 5.57785 1 4.5 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1z = [
    "color"
];
var $c12e32cf04d921d4$export$a2bc8cb49334c5d1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 7.5C5 7.22386 5.22386 7 5.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1A = [
    "color"
];
var $c12e32cf04d921d4$export$8fd9d8340b1bb79a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.8 1L2.74967 0.99997C2.52122 0.999752 2.32429 0.999564 2.14983 1.04145C1.60136 1.17312 1.17312 1.60136 1.04145 2.14983C0.999564 2.32429 0.999752 2.52122 0.99997 2.74967L1 2.8V5.2L0.99997 5.25033C0.999752 5.47878 0.999564 5.67572 1.04145 5.85017C1.17312 6.39864 1.60136 6.82688 2.14983 6.95856C2.32429 7.00044 2.52122 7.00025 2.74967 7.00003L2.8 7H5.2L5.25033 7.00003C5.47878 7.00025 5.67572 7.00044 5.85017 6.95856C6.39864 6.82688 6.82688 6.39864 6.95856 5.85017C7.00044 5.67572 7.00025 5.47878 7.00003 5.25033L7 5.2V2.8L7.00003 2.74967C7.00025 2.52122 7.00044 2.32429 6.95856 2.14983C6.82688 1.60136 6.39864 1.17312 5.85017 1.04145C5.67572 0.999564 5.47878 0.999752 5.25033 0.99997L5.2 1H2.8ZM2.38328 2.01382C2.42632 2.00348 2.49222 2 2.8 2H5.2C5.50779 2 5.57369 2.00348 5.61672 2.01382C5.79955 2.05771 5.94229 2.20045 5.98619 2.38328C5.99652 2.42632 6 2.49222 6 2.8V5.2C6 5.50779 5.99652 5.57369 5.98619 5.61672C5.94229 5.79955 5.79955 5.94229 5.61672 5.98619C5.57369 5.99652 5.50779 6 5.2 6H2.8C2.49222 6 2.42632 5.99652 2.38328 5.98619C2.20045 5.94229 2.05771 5.79955 2.01382 5.61672C2.00348 5.57369 2 5.50779 2 5.2V2.8C2 2.49222 2.00348 2.42632 2.01382 2.38328C2.05771 2.20045 2.20045 2.05771 2.38328 2.01382ZM9.8 1L9.74967 0.99997C9.52122 0.999752 9.32429 0.999564 9.14983 1.04145C8.60136 1.17312 8.17312 1.60136 8.04145 2.14983C7.99956 2.32429 7.99975 2.52122 7.99997 2.74967L8 2.8V5.2L7.99997 5.25033C7.99975 5.47878 7.99956 5.67572 8.04145 5.85017C8.17312 6.39864 8.60136 6.82688 9.14983 6.95856C9.32429 7.00044 9.52122 7.00025 9.74967 7.00003L9.8 7H12.2L12.2503 7.00003C12.4788 7.00025 12.6757 7.00044 12.8502 6.95856C13.3986 6.82688 13.8269 6.39864 13.9586 5.85017C14.0004 5.67572 14.0003 5.47878 14 5.25033L14 5.2V2.8L14 2.74967C14.0003 2.52122 14.0004 2.32429 13.9586 2.14983C13.8269 1.60136 13.3986 1.17312 12.8502 1.04145C12.6757 0.999564 12.4788 0.999752 12.2503 0.99997L12.2 1H9.8ZM9.38328 2.01382C9.42632 2.00348 9.49222 2 9.8 2H12.2C12.5078 2 12.5737 2.00348 12.6167 2.01382C12.7995 2.05771 12.9423 2.20045 12.9862 2.38328C12.9965 2.42632 13 2.49222 13 2.8V5.2C13 5.50779 12.9965 5.57369 12.9862 5.61672C12.9423 5.79955 12.7995 5.94229 12.6167 5.98619C12.5737 5.99652 12.5078 6 12.2 6H9.8C9.49222 6 9.42632 5.99652 9.38328 5.98619C9.20045 5.94229 9.05771 5.79955 9.01382 5.61672C9.00348 5.57369 9 5.50779 9 5.2V2.8C9 2.49222 9.00348 2.42632 9.01382 2.38328C9.05771 2.20045 9.20045 2.05771 9.38328 2.01382ZM2.74967 7.99997L2.8 8H5.2L5.25033 7.99997C5.47878 7.99975 5.67572 7.99956 5.85017 8.04145C6.39864 8.17312 6.82688 8.60136 6.95856 9.14983C7.00044 9.32429 7.00025 9.52122 7.00003 9.74967L7 9.8V12.2L7.00003 12.2503C7.00025 12.4788 7.00044 12.6757 6.95856 12.8502C6.82688 13.3986 6.39864 13.8269 5.85017 13.9586C5.67572 14.0004 5.47878 14.0003 5.25033 14L5.2 14H2.8L2.74967 14C2.52122 14.0003 2.32429 14.0004 2.14983 13.9586C1.60136 13.8269 1.17312 13.3986 1.04145 12.8502C0.999564 12.6757 0.999752 12.4788 0.99997 12.2503L1 12.2V9.8L0.99997 9.74967C0.999752 9.52122 0.999564 9.32429 1.04145 9.14983C1.17312 8.60136 1.60136 8.17312 2.14983 8.04145C2.32429 7.99956 2.52122 7.99975 2.74967 7.99997ZM2.8 9C2.49222 9 2.42632 9.00348 2.38328 9.01382C2.20045 9.05771 2.05771 9.20045 2.01382 9.38328C2.00348 9.42632 2 9.49222 2 9.8V12.2C2 12.5078 2.00348 12.5737 2.01382 12.6167C2.05771 12.7995 2.20045 12.9423 2.38328 12.9862C2.42632 12.9965 2.49222 13 2.8 13H5.2C5.50779 13 5.57369 12.9965 5.61672 12.9862C5.79955 12.9423 5.94229 12.7995 5.98619 12.6167C5.99652 12.5737 6 12.5078 6 12.2V9.8C6 9.49222 5.99652 9.42632 5.98619 9.38328C5.94229 9.20045 5.79955 9.05771 5.61672 9.01382C5.57369 9.00348 5.50779 9 5.2 9H2.8ZM9.8 8L9.74967 7.99997C9.52122 7.99975 9.32429 7.99956 9.14983 8.04145C8.60136 8.17312 8.17312 8.60136 8.04145 9.14983C7.99956 9.32429 7.99975 9.52122 7.99997 9.74967L8 9.8V12.2L7.99997 12.2503C7.99975 12.4788 7.99956 12.6757 8.04145 12.8502C8.17312 13.3986 8.60136 13.8269 9.14983 13.9586C9.32429 14.0004 9.52122 14.0003 9.74967 14L9.8 14H12.2L12.2503 14C12.4788 14.0003 12.6757 14.0004 12.8502 13.9586C13.3986 13.8269 13.8269 13.3986 13.9586 12.8502C14.0004 12.6757 14.0003 12.4788 14 12.2503L14 12.2V9.8L14 9.74967C14.0003 9.52122 14.0004 9.32429 13.9586 9.14983C13.8269 8.60136 13.3986 8.17312 12.8502 8.04145C12.6757 7.99956 12.4788 7.99975 12.2503 7.99997L12.2 8H9.8ZM9.38328 9.01382C9.42632 9.00348 9.49222 9 9.8 9H12.2C12.5078 9 12.5737 9.00348 12.6167 9.01382C12.7995 9.05771 12.9423 9.20045 12.9862 9.38328C12.9965 9.42632 13 9.49222 13 9.8V12.2C13 12.5078 12.9965 12.5737 12.9862 12.6167C12.9423 12.7995 12.7995 12.9423 12.6167 12.9862C12.5737 12.9965 12.5078 13 12.2 13H9.8C9.49222 13 9.42632 12.9965 9.38328 12.9862C9.20045 12.9423 9.05771 12.7995 9.01382 12.6167C9.00348 12.5737 9 12.5078 9 12.2V9.8C9 9.49222 9.00348 9.42632 9.01382 9.38328C9.05771 9.20045 9.20045 9.05771 9.38328 9.01382Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1B = [
    "color"
];
var $c12e32cf04d921d4$export$78a6319cfd8cd037 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 3.25C1 3.11193 1.11193 3 1.25 3H13.75C13.8881 3 14 3.11193 14 3.25V10.75C14 10.8881 13.8881 11 13.75 11H1.25C1.11193 11 1 10.8881 1 10.75V3.25ZM1.25 2C0.559643 2 0 2.55964 0 3.25V10.75C0 11.4404 0.559644 12 1.25 12H5.07341L4.82991 13.2986C4.76645 13.6371 5.02612 13.95 5.37049 13.95H9.62951C9.97389 13.95 10.2336 13.6371 10.1701 13.2986L9.92659 12H13.75C14.4404 12 15 11.4404 15 10.75V3.25C15 2.55964 14.4404 2 13.75 2H1.25ZM9.01091 12H5.98909L5.79222 13.05H9.20778L9.01091 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1C = [
    "color"
];
var $c12e32cf04d921d4$export$63405b713b830f28 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1D = [
    "color"
];
var $c12e32cf04d921d4$export$e9e14b59da099a2a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM1.82708 7.49991C1.82708 4.36689 4.36689 1.82707 7.49991 1.82707C10.6329 1.82707 13.1727 4.36689 13.1727 7.49991C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49991ZM8.37287 7.50006C8.37287 7.98196 7.98221 8.37263 7.5003 8.37263C7.01839 8.37263 6.62773 7.98196 6.62773 7.50006C6.62773 7.01815 7.01839 6.62748 7.5003 6.62748C7.98221 6.62748 8.37287 7.01815 8.37287 7.50006ZM9.32287 7.50006C9.32287 8.50664 8.50688 9.32263 7.5003 9.32263C6.49372 9.32263 5.67773 8.50664 5.67773 7.50006C5.67773 6.49348 6.49372 5.67748 7.5003 5.67748C8.50688 5.67748 9.32287 6.49348 9.32287 7.50006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1E = [
    "color"
];
var $c12e32cf04d921d4$export$bf776c57f6d5a7c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.07451 1.82584C5.03267 1.81926 4.99014 1.81825 4.94803 1.82284C4.10683 1.91446 2.82673 2.36828 2.07115 2.77808C2.02106 2.80525 1.97621 2.84112 1.93869 2.88402C1.62502 3.24266 1.34046 3.82836 1.11706 4.38186C0.887447 4.95076 0.697293 5.55032 0.588937 5.98354C0.236232 7.39369 0.042502 9.08728 0.0174948 10.6925C0.0162429 10.7729 0.0351883 10.8523 0.0725931 10.9234C0.373679 11.496 1.02015 12.027 1.66809 12.4152C2.32332 12.8078 3.08732 13.1182 3.70385 13.1778C3.85335 13.1922 4.00098 13.1358 4.10282 13.0255C4.2572 12.8581 4.5193 12.4676 4.71745 12.1643C4.80739 12.0267 4.89157 11.8953 4.95845 11.7901C5.62023 11.9106 6.45043 11.9801 7.50002 11.9801C8.54844 11.9801 9.37796 11.9107 10.0394 11.7905C10.1062 11.8957 10.1903 12.0269 10.2801 12.1643C10.4783 12.4676 10.7404 12.8581 10.8947 13.0255C10.9966 13.1358 11.1442 13.1922 11.2937 13.1778C11.9102 13.1182 12.6742 12.8078 13.3295 12.4152C13.9774 12.027 14.6239 11.496 14.925 10.9234C14.9624 10.8523 14.9813 10.7729 14.9801 10.6925C14.9551 9.08728 14.7613 7.39369 14.4086 5.98354C14.3003 5.55032 14.1101 4.95076 13.8805 4.38186C13.6571 3.82836 13.3725 3.24266 13.0589 2.88402C13.0214 2.84112 12.9765 2.80525 12.9264 2.77808C12.1708 2.36828 10.8907 1.91446 10.0495 1.82284C10.0074 1.81825 9.96489 1.81926 9.92305 1.82584C9.71676 1.85825 9.5391 1.96458 9.40809 2.06355C9.26977 2.16804 9.1413 2.29668 9.0304 2.42682C8.86968 2.61544 8.71437 2.84488 8.61428 3.06225C8.27237 3.03501 7.90138 3.02 7.5 3.02C7.0977 3.02 6.72593 3.03508 6.38337 3.06244C6.28328 2.84501 6.12792 2.61549 5.96716 2.42682C5.85626 2.29668 5.72778 2.16804 5.58947 2.06355C5.45846 1.96458 5.2808 1.85825 5.07451 1.82584ZM11.0181 11.5382C11.0395 11.5713 11.0615 11.6051 11.0838 11.6392C11.2169 11.843 11.3487 12.0385 11.4508 12.1809C11.8475 12.0916 12.352 11.8818 12.8361 11.5917C13.3795 11.2661 13.8098 10.8918 14.0177 10.5739C13.9852 9.06758 13.7993 7.50369 13.4773 6.21648C13.38 5.82759 13.2038 5.27021 12.9903 4.74117C12.7893 4.24326 12.5753 3.82162 12.388 3.5792C11.7376 3.24219 10.7129 2.88582 10.0454 2.78987C10.0308 2.79839 10.0113 2.81102 9.98675 2.82955C9.91863 2.881 9.84018 2.95666 9.76111 3.04945C9.71959 3.09817 9.68166 3.1471 9.64768 3.19449C9.953 3.25031 10.2253 3.3171 10.4662 3.39123C11.1499 3.6016 11.6428 3.89039 11.884 4.212C12.0431 4.42408 12.0001 4.72494 11.788 4.884C11.5759 5.04306 11.2751 5.00008 11.116 4.788C11.0572 4.70961 10.8001 4.4984 10.1838 4.30877C9.58933 4.12585 8.71356 3.98 7.5 3.98C6.28644 3.98 5.41067 4.12585 4.81616 4.30877C4.19988 4.4984 3.94279 4.70961 3.884 4.788C3.72494 5.00008 3.42408 5.04306 3.212 4.884C2.99992 4.72494 2.95694 4.42408 3.116 4.212C3.35721 3.89039 3.85011 3.6016 4.53383 3.39123C4.77418 3.31727 5.04571 3.25062 5.35016 3.19488C5.31611 3.14738 5.27808 3.09831 5.23645 3.04945C5.15738 2.95666 5.07893 2.881 5.01081 2.82955C4.98628 2.81102 4.96674 2.79839 4.95217 2.78987C4.28464 2.88582 3.25999 3.24219 2.60954 3.5792C2.42226 3.82162 2.20825 4.24326 2.00729 4.74117C1.79376 5.27021 1.61752 5.82759 1.52025 6.21648C1.19829 7.50369 1.01236 9.06758 0.97986 10.5739C1.18772 10.8918 1.61807 11.2661 2.16148 11.5917C2.64557 11.8818 3.15003 12.0916 3.5468 12.1809C3.64885 12.0385 3.78065 11.843 3.9138 11.6392C3.93626 11.6048 3.95838 11.5708 3.97996 11.5375C3.19521 11.2591 2.77361 10.8758 2.50064 10.4664C2.35359 10.2458 2.4132 9.94778 2.63377 9.80074C2.85435 9.65369 3.15236 9.71329 3.29941 9.93387C3.56077 10.3259 4.24355 11.0201 7.50002 11.0201C10.7565 11.0201 11.4392 10.326 11.7006 9.93386C11.8477 9.71329 12.1457 9.65369 12.3663 9.80074C12.5869 9.94779 12.6465 10.2458 12.4994 10.4664C12.2262 10.8762 11.8041 11.2598 11.0181 11.5382ZM4.08049 7.01221C4.32412 6.74984 4.65476 6.60162 5.00007 6.59998C5.34538 6.60162 5.67603 6.74984 5.91966 7.01221C6.16329 7.27459 6.30007 7.62974 6.30007 7.99998C6.30007 8.37021 6.16329 8.72536 5.91966 8.98774C5.67603 9.25011 5.34538 9.39833 5.00007 9.39998C4.65476 9.39833 4.32412 9.25011 4.08049 8.98774C3.83685 8.72536 3.70007 8.37021 3.70007 7.99998C3.70007 7.62974 3.83685 7.27459 4.08049 7.01221ZM9.99885 6.59998C9.65354 6.60162 9.3229 6.74984 9.07926 7.01221C8.83563 7.27459 8.69885 7.62974 8.69885 7.99998C8.69885 8.37021 8.83563 8.72536 9.07926 8.98774C9.3229 9.25011 9.65354 9.39833 9.99885 9.39998C10.3442 9.39833 10.6748 9.25011 10.9184 8.98774C11.1621 8.72536 11.2989 8.37021 11.2989 7.99998C11.2989 7.62974 11.1621 7.27459 10.9184 7.01221C10.6748 6.74984 10.3442 6.60162 9.99885 6.59998Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$1F = [
    "color"
];
var $c12e32cf04d921d4$export$67e4f137381994a7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1G = [
    "color"
];
var $c12e32cf04d921d4$export$4941448a902289ea = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1H = [
    "color"
];
var $c12e32cf04d921d4$export$1638d451d4588271 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 9.125C8.39746 9.125 9.125 8.39746 9.125 7.5C9.125 6.60254 8.39746 5.875 7.5 5.875C6.60254 5.875 5.875 6.60254 5.875 7.5C5.875 8.39746 6.60254 9.125 7.5 9.125ZM7.5 10.125C8.94975 10.125 10.125 8.94975 10.125 7.5C10.125 6.05025 8.94975 4.875 7.5 4.875C6.05025 4.875 4.875 6.05025 4.875 7.5C4.875 8.94975 6.05025 10.125 7.5 10.125Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1I = [
    "color"
];
var $c12e32cf04d921d4$export$5ce415a59e297ace = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$1J = [
    "color"
];
var $c12e32cf04d921d4$export$9789fa787c2a8e33 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1K = [
    "color"
];
var $c12e32cf04d921d4$export$f50786ff8e0cdf62 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1L = [
    "color"
];
var $c12e32cf04d921d4$export$de42cbda950c1561 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.85355 2.14645C3.65829 1.95118 3.34171 1.95118 3.14645 2.14645C2.95118 2.34171 2.95118 2.65829 3.14645 2.85355L7.14645 6.85355C7.34171 7.04882 7.65829 7.04882 7.85355 6.85355L11.8536 2.85355C12.0488 2.65829 12.0488 2.34171 11.8536 2.14645C11.6583 1.95118 11.3417 1.95118 11.1464 2.14645L7.5 5.79289L3.85355 2.14645ZM3.85355 8.14645C3.65829 7.95118 3.34171 7.95118 3.14645 8.14645C2.95118 8.34171 2.95118 8.65829 3.14645 8.85355L7.14645 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L11.8536 8.85355C12.0488 8.65829 12.0488 8.34171 11.8536 8.14645C11.6583 7.95118 11.3417 7.95118 11.1464 8.14645L7.5 11.7929L3.85355 8.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1M = [
    "color"
];
var $c12e32cf04d921d4$export$8f14af9007650906 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1N = [
    "color"
];
var $c12e32cf04d921d4$export$90b329a415b2a5d4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1O = [
    "color"
];
var $c12e32cf04d921d4$export$4625b0d11d3861cc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.1464 6.85355C11.3417 7.04882 11.6583 7.04882 11.8536 6.85355C12.0488 6.65829 12.0488 6.34171 11.8536 6.14645L7.85355 2.14645C7.65829 1.95118 7.34171 1.95118 7.14645 2.14645L3.14645 6.14645C2.95118 6.34171 2.95118 6.65829 3.14645 6.85355C3.34171 7.04882 3.65829 7.04882 3.85355 6.85355L7.5 3.20711L11.1464 6.85355ZM11.1464 12.8536C11.3417 13.0488 11.6583 13.0488 11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464L7.85355 8.14645C7.65829 7.95118 7.34171 7.95118 7.14645 8.14645L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L7.5 9.20711L11.1464 12.8536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1P = [
    "color"
];
var $c12e32cf04d921d4$export$4e54df4252b4a99c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1Q = [
    "color"
];
var $c12e32cf04d921d4$export$209fdd70701c1b6e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$1R = [
    "color"
];
var $c12e32cf04d921d4$export$829e9de7006febc4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1S = [
    "color"
];
var $c12e32cf04d921d4$export$e6848a231b25a576 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.49998 4.09998C2.27906 4.09998 2.09998 4.27906 2.09998 4.49998C2.09998 4.72089 2.27906 4.89998 2.49998 4.89998H12.5C12.7209 4.89998 12.9 4.72089 12.9 4.49998C12.9 4.27906 12.7209 4.09998 12.5 4.09998H2.49998ZM2.49998 6.09998C2.27906 6.09998 2.09998 6.27906 2.09998 6.49998C2.09998 6.72089 2.27906 6.89998 2.49998 6.89998H12.5C12.7209 6.89998 12.9 6.72089 12.9 6.49998C12.9 6.27906 12.7209 6.09998 12.5 6.09998H2.49998ZM2.09998 8.49998C2.09998 8.27906 2.27906 8.09998 2.49998 8.09998H12.5C12.7209 8.09998 12.9 8.27906 12.9 8.49998C12.9 8.72089 12.7209 8.89998 12.5 8.89998H2.49998C2.27906 8.89998 2.09998 8.72089 2.09998 8.49998ZM2.49998 10.1C2.27906 10.1 2.09998 10.2791 2.09998 10.5C2.09998 10.7209 2.27906 10.9 2.49998 10.9H12.5C12.7209 10.9 12.9 10.7209 12.9 10.5C12.9 10.2791 12.7209 10.1 12.5 10.1H2.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1T = [
    "color"
];
var $c12e32cf04d921d4$export$b72a86f6a31cd8d8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.09998 12.5C4.09998 12.7209 4.27906 12.9 4.49998 12.9C4.72089 12.9 4.89998 12.7209 4.89998 12.5L4.89998 2.50002C4.89998 2.27911 4.72089 2.10003 4.49998 2.10003C4.27906 2.10003 4.09998 2.27911 4.09998 2.50002L4.09998 12.5ZM6.09998 12.5C6.09998 12.7209 6.27906 12.9 6.49998 12.9C6.72089 12.9 6.89998 12.7209 6.89998 12.5L6.89998 2.50002C6.89998 2.27911 6.72089 2.10003 6.49998 2.10003C6.27906 2.10003 6.09998 2.27911 6.09998 2.50002L6.09998 12.5ZM8.49998 12.9C8.27906 12.9 8.09998 12.7209 8.09998 12.5L8.09998 2.50002C8.09998 2.27911 8.27906 2.10002 8.49998 2.10002C8.72089 2.10002 8.89998 2.27911 8.89998 2.50002L8.89998 12.5C8.89998 12.7209 8.72089 12.9 8.49998 12.9ZM10.1 12.5C10.1 12.7209 10.2791 12.9 10.5 12.9C10.7209 12.9 10.9 12.7209 10.9 12.5L10.9 2.50002C10.9 2.27911 10.7209 2.10002 10.5 2.10002C10.2791 2.10002 10.1 2.27911 10.1 2.50002L10.1 12.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1U = [
    "color"
];
var $c12e32cf04d921d4$export$d678e82375a26dcf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.3285 1.13607C10.1332 0.940809 9.81662 0.940808 9.62136 1.13607C9.42609 1.33133 9.42609 1.64792 9.62136 1.84318L10.2744 2.49619L5.42563 6.13274L4.31805 5.02516C4.12279 4.8299 3.80621 4.8299 3.61095 5.02516C3.41569 5.22042 3.41569 5.537 3.61095 5.73226L5.02516 7.14648L6.08582 8.20714L2.81545 11.4775C2.62019 11.6728 2.62019 11.9894 2.81545 12.1846C3.01072 12.3799 3.3273 12.3799 3.52256 12.1846L6.79293 8.91425L7.85359 9.97491L9.2678 11.3891C9.46306 11.5844 9.77965 11.5844 9.97491 11.3891C10.1702 11.1939 10.1702 10.8773 9.97491 10.682L8.86733 9.57443L12.5039 4.7257L13.1569 5.37871C13.3522 5.57397 13.6687 5.57397 13.864 5.37871C14.0593 5.18345 14.0593 4.86687 13.864 4.6716L12.8033 3.61094L11.3891 2.19673L10.3285 1.13607ZM6.13992 6.84702L10.9887 3.21047L11.7896 4.01142L8.15305 8.86015L6.13992 6.84702Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1V = [
    "color"
];
var $c12e32cf04d921d4$export$c6212c739d4cf8da = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1W = [
    "color"
];
var $c12e32cf04d921d4$export$e5daec7136b0534 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49999 3.09998C7.27907 3.09998 7.09999 3.27906 7.09999 3.49998C7.09999 3.72089 7.27907 3.89998 7.49999 3.89998H14.5C14.7209 3.89998 14.9 3.72089 14.9 3.49998C14.9 3.27906 14.7209 3.09998 14.5 3.09998H7.49999ZM7.49998 5.1C7.27907 5.1 7.09998 5.27908 7.09998 5.5C7.09998 5.72091 7.27907 5.9 7.49998 5.9H14.5C14.7209 5.9 14.9 5.72091 14.9 5.5C14.9 5.27908 14.7209 5.1 14.5 5.1H7.49998ZM7.1 7.5C7.1 7.27908 7.27909 7.1 7.5 7.1H14.5C14.7209 7.1 14.9 7.27908 14.9 7.5C14.9 7.72091 14.7209 7.9 14.5 7.9H7.5C7.27909 7.9 7.1 7.72091 7.1 7.5ZM7.49998 9.1C7.27907 9.1 7.09998 9.27908 7.09998 9.5C7.09998 9.72091 7.27907 9.9 7.49998 9.9H14.5C14.7209 9.9 14.9 9.72091 14.9 9.5C14.9 9.27908 14.7209 9.1 14.5 9.1H7.49998ZM7.09998 11.5C7.09998 11.2791 7.27907 11.1 7.49998 11.1H14.5C14.7209 11.1 14.9 11.2791 14.9 11.5C14.9 11.7209 14.7209 11.9 14.5 11.9H7.49998C7.27907 11.9 7.09998 11.7209 7.09998 11.5ZM2.5 9.25003L5 6.00003H0L2.5 9.25003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1X = [
    "color"
];
var $c12e32cf04d921d4$export$296bea1be8b4086a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2H12V13H4.5C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14H12C12.5523 14 13 13.5523 13 13V2C13 1.44772 12.5523 1 12 1H4.5ZM6.60355 4.89645C6.40829 4.70118 6.09171 4.70118 5.89645 4.89645C5.70118 5.09171 5.70118 5.40829 5.89645 5.60355L7.29289 7H0.5C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H7.29289L5.89645 9.39645C5.70118 9.59171 5.70118 9.90829 5.89645 10.1036C6.09171 10.2988 6.40829 10.2988 6.60355 10.1036L8.85355 7.85355C9.04882 7.65829 9.04882 7.34171 8.85355 7.14645L6.60355 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1Y = [
    "color"
];
var $c12e32cf04d921d4$export$5886b995403a6540 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3V5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5V2.5ZM9 2.5C9 2.22386 9.22386 2 9.5 2H12.5C12.7761 2 13 2.22386 13 2.5V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3H9.5C9.22386 3 9 2.77614 9 2.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H2.5C2.22386 13 2 12.7761 2 12.5V9.5C2 9.22386 2.22386 9 2.5 9ZM12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H9.5C9.22386 13 9 12.7761 9 12.5C9 12.2239 9.22386 12 9.5 12H12V9.5C12 9.22386 12.2239 9 12.5 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1Z = [
    "color"
];
var $c12e32cf04d921d4$export$c81ccc0bdd70284 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1_ = [
    "color"
];
var $c12e32cf04d921d4$export$808857d2db6c57a2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1_);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.94721 0.164594C7.66569 0.0238299 7.33431 0.0238302 7.05279 0.164594L0.552786 3.41459C0.214002 3.58399 0 3.93025 0 4.30902V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V4.30902C15 3.93025 14.786 3.58399 14.4472 3.41459L7.94721 0.164594ZM13.5689 4.09349L7.5 1.05902L1.43105 4.09349L7.5 7.29136L13.5689 4.09349ZM1 4.88366V12H14V4.88366L7.70977 8.19813C7.57848 8.26731 7.42152 8.26731 7.29023 8.19813L1 4.88366Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1$ = [
    "color"
];
var $c12e32cf04d921d4$export$b6c544816d254f36 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1$);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.36052 0.72921C8.55578 0.533948 8.87236 0.533948 9.06763 0.72921L14.2708 5.93235C14.466 6.12761 14.466 6.4442 14.2708 6.63946L8.95513 11.9551L7.3466 13.5636C6.76081 14.1494 5.81106 14.1494 5.22528 13.5636L1.43635 9.7747C0.850563 9.18891 0.850563 8.23917 1.43635 7.65338L3.04488 6.04485L8.36052 0.72921ZM8.71407 1.78987L4.10554 6.3984L8.60157 10.8944L13.2101 6.28591L8.71407 1.78987ZM7.89447 11.6015L3.39843 7.10551L2.14346 8.36049C1.94819 8.55575 1.94819 8.87233 2.14346 9.06759L5.93238 12.8565C6.12765 13.0518 6.44423 13.0518 6.63949 12.8565L7.89447 11.6015Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$20 = [
    "color"
];
var $c12e32cf04d921d4$export$b409b230b61d4724 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$20);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.8902 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$21 = [
    "color"
];
var $c12e32cf04d921d4$export$72b807c0098a555f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$21);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$22 = [
    "color"
];
var $c12e32cf04d921d4$export$7e82c66e763fb043 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$22);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 2C5.77614 2 6 2.22386 6 2.5V5.5C6 5.77614 5.77614 6 5.5 6H2.5C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5H5V2.5C5 2.22386 5.22386 2 5.5 2ZM9.5 2C9.77614 2 10 2.22386 10 2.5V5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H9.5C9.22386 6 9 5.77614 9 5.5V2.5C9 2.22386 9.22386 2 9.5 2ZM2 9.5C2 9.22386 2.22386 9 2.5 9H5.5C5.77614 9 6 9.22386 6 9.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V10H2.5C2.22386 10 2 9.77614 2 9.5ZM9 9.5C9 9.22386 9.22386 9 9.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H10V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$23 = [
    "color"
];
var $c12e32cf04d921d4$export$9bd11592bfa362e7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$23);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$24 = [
    "color"
];
var $c12e32cf04d921d4$export$f2c2531e46a6c1ea = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$24);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.7649 6.07596C14.9991 6.22231 15.0703 6.53079 14.9239 6.76495C14.4849 7.46743 13.9632 8.10645 13.3702 8.66305L14.5712 9.86406C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30817C11.805 9.90283 10.9089 10.3621 9.93375 10.651L10.383 12.3277C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76267 13.0115 9.4885 12.8532 9.41704 12.5865L8.95917 10.8775C8.48743 10.958 8.00036 10.9999 7.50001 10.9999C6.99965 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97064 12.94C4.7039 12.8686 4.5456 12.5944 4.61706 12.3277L5.06625 10.651C4.09111 10.3621 3.19503 9.90282 2.3989 9.30815L1.1359 10.5712C0.940638 10.7664 0.624058 10.7664 0.428798 10.5712C0.233537 10.3759 0.233537 10.0593 0.428798 9.86405L1.62982 8.66303C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53079 0.000898544 6.22231 0.235065 6.07596C0.469231 5.9296 0.777703 6.00079 0.924058 6.23496C1.40354 7.00213 1.989 7.68057 2.66233 8.2427C2.67315 8.25096 2.6837 8.25972 2.69397 8.26898C4.00897 9.35527 5.65537 9.99991 7.50001 9.99991C10.3078 9.99991 12.6564 8.5063 14.076 6.23495C14.2223 6.00079 14.5308 5.9296 14.7649 6.07596Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$25 = [
    "color"
];
var $c12e32cf04d921d4$export$3547759c3ff9b44c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$25);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$26 = [
    "color"
];
var $c12e32cf04d921d4$export$620653f31aa3377e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$26);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$27 = [
    "color"
];
var $c12e32cf04d921d4$export$b8f42e9471d5f647 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$27);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82708 7.49972C1.82708 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82708 10.6327 1.82708 7.49972ZM5.03747 9.21395C4.87949 8.98746 4.56782 8.93193 4.34133 9.08991C4.11484 9.24789 4.05931 9.55956 4.21729 9.78605C4.93926 10.8211 6.14033 11.5 7.50004 11.5C8.85974 11.5 10.0608 10.8211 10.7828 9.78605C10.9408 9.55956 10.8852 9.24789 10.6587 9.08991C10.4323 8.93193 10.1206 8.98746 9.9626 9.21395C9.41963 9.99238 8.51907 10.5 7.50004 10.5C6.481 10.5 5.58044 9.99238 5.03747 9.21395ZM5.37503 6.84998C5.85828 6.84998 6.25003 6.45815 6.25003 5.97498C6.25003 5.4918 5.85828 5.09998 5.37503 5.09998C4.89179 5.09998 4.50003 5.4918 4.50003 5.97498C4.50003 6.45815 4.89179 6.84998 5.37503 6.84998ZM10.5 5.97498C10.5 6.45815 10.1083 6.84998 9.62503 6.84998C9.14179 6.84998 8.75003 6.45815 8.75003 5.97498C8.75003 5.4918 9.14179 5.09998 9.62503 5.09998C10.1083 5.09998 10.5 5.4918 10.5 5.97498Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$28 = [
    "color"
];
var $c12e32cf04d921d4$export$2b3d0ca2fe16e98c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$28);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.00005 2.04999H5.52505C4.71043 2.04999 4.05005 2.71037 4.05005 3.52499C4.05005 4.33961 4.71043 4.99999 5.52505 4.99999H7.00005V2.04999ZM7.00005 1.04999H8.00005H9.47505C10.842 1.04999 11.95 2.15808 11.95 3.52499C11.95 4.33163 11.5642 5.04815 10.9669 5.49999C11.5642 5.95184 11.95 6.66836 11.95 7.475C11.95 8.8419 10.842 9.95 9.47505 9.95C8.92236 9.95 8.41198 9.76884 8.00005 9.46266V9.95L8.00005 11.425C8.00005 12.7919 6.89195 13.9 5.52505 13.9C4.15814 13.9 3.05005 12.7919 3.05005 11.425C3.05005 10.6183 3.43593 9.90184 4.03317 9.44999C3.43593 8.99814 3.05005 8.28163 3.05005 7.475C3.05005 6.66836 3.43594 5.95184 4.03319 5.5C3.43594 5.04815 3.05005 4.33163 3.05005 3.52499C3.05005 2.15808 4.15814 1.04999 5.52505 1.04999H7.00005ZM8.00005 2.04999V4.99999H9.47505C10.2897 4.99999 10.95 4.33961 10.95 3.52499C10.95 2.71037 10.2897 2.04999 9.47505 2.04999H8.00005ZM5.52505 8.94998H7.00005L7.00005 7.4788L7.00005 7.475L7.00005 7.4712V6H5.52505C4.71043 6 4.05005 6.66038 4.05005 7.475C4.05005 8.28767 4.70727 8.94684 5.5192 8.94999L5.52505 8.94998ZM4.05005 11.425C4.05005 10.6123 4.70727 9.95315 5.5192 9.94999L5.52505 9.95H7.00005L7.00005 11.425C7.00005 12.2396 6.33967 12.9 5.52505 12.9C4.71043 12.9 4.05005 12.2396 4.05005 11.425ZM8.00005 7.47206C8.00164 6.65879 8.66141 6 9.47505 6C10.2897 6 10.95 6.66038 10.95 7.475C10.95 8.28962 10.2897 8.95 9.47505 8.95C8.66141 8.95 8.00164 8.29121 8.00005 7.47794V7.47206Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$29 = [
    "color"
];
var $c12e32cf04d921d4$export$8c1a3d13e85d78b7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$29);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V6H8.5C8.22386 6 8 5.77614 8 5.5V2H3.5ZM9 2.70711L11.2929 5H9V2.70711ZM2 2.5C2 1.67157 2.67157 1 3.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645L12.8536 5.14645C12.9473 5.24021 13 5.36739 13 5.5V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2a = [
    "color"
];
var $c12e32cf04d921d4$export$3c5dbe056aa7c94f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.29289L12 4.70711V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.60355C13 4.40464 12.921 4.21388 12.7803 4.07322L9.85355 1.14645C9.75979 1.05268 9.63261 1 9.5 1H3.5ZM5.25 7C4.97386 7 4.75 7.22386 4.75 7.5C4.75 7.77614 4.97386 8 5.25 8H9.75C10.0261 8 10.25 7.77614 10.25 7.5C10.25 7.22386 10.0261 7 9.75 7H5.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2b = [
    "color"
];
var $c12e32cf04d921d4$export$ca191b730434e9b4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V4.70711L9.29289 2H3.5ZM2 2.5C2 1.67157 2.67157 1 3.5 1H9.5C9.63261 1 9.75979 1.05268 9.85355 1.14645L12.7803 4.07322C12.921 4.21388 13 4.40464 13 4.60355V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5ZM4.75 7.5C4.75 7.22386 4.97386 7 5.25 7H7V5.25C7 4.97386 7.22386 4.75 7.5 4.75C7.77614 4.75 8 4.97386 8 5.25V7H9.75C10.0261 7 10.25 7.22386 10.25 7.5C10.25 7.77614 10.0261 8 9.75 8H8V9.75C8 10.0261 7.77614 10.25 7.5 10.25C7.22386 10.25 7 10.0261 7 9.75V8H5.25C4.97386 8 4.75 7.77614 4.75 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2c = [
    "color"
];
var $c12e32cf04d921d4$export$605674723bcc715c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.08579C9.21839 2 9.34557 2.05268 9.43934 2.14645L11.8536 4.56066C11.9473 4.65443 12 4.78161 12 4.91421V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.91421C13 4.51639 12.842 4.13486 12.5607 3.85355L10.1464 1.43934C9.86514 1.15804 9.48361 1 9.08579 1H3.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2d = [
    "color"
];
var $c12e32cf04d921d4$export$1a2ae984f27cf526 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$2e = [
    "color"
];
var $c12e32cf04d921d4$export$79d8792587f7aca5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 4.5C2.5 3.09886 3.59886 2 5 2H12.499C12.7752 2 13 2.22386 13 2.5C13 2.77614 12.7761 3 12.5 3H8.69244L8.40509 3.85458C8.18869 4.49752 7.89401 5.37197 7.58091 6.29794C7.50259 6.52956 7.42308 6.76453 7.34332 7H8.5C8.77614 7 9 7.22386 9 7.5C9 7.77614 8.77614 8 8.5 8H7.00407C6.56724 9.28543 6.16435 10.4613 5.95799 11.0386C5.63627 11.9386 5.20712 12.4857 4.66741 12.7778C4.16335 13.0507 3.64154 13.0503 3.28378 13.05L3.25 13.05C2.94624 13.05 2.7 12.8037 2.7 12.5C2.7 12.1962 2.94624 11.95 3.25 11.95C3.64182 11.95 3.9035 11.9405 4.14374 11.8105C4.36443 11.691 4.65532 11.4148 4.92217 10.6683C5.10695 10.1514 5.45375 9.14134 5.8422 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.18187C6.30127 6.64785 6.42132 6.29323 6.53887 5.94559C6.85175 5.02025 7.14627 4.14631 7.36256 3.50368L7.53192 3H5C4.15114 3 3.5 3.65114 3.5 4.5C3.5 4.77614 3.27614 5 3 5C2.72386 5 2.5 4.77614 2.5 4.5Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$2f = [
    "color"
];
var $c12e32cf04d921d4$export$f5ac866b2a77627a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2g = [
    "color"
];
var $c12e32cf04d921d4$export$9f94aa21504b3fcd = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.79993 3.50017C4.79993 3.25164 5.0014 3.05017 5.24993 3.05017H9.74993C9.99845 3.05017 10.1999 3.25164 10.1999 3.50017C10.1999 3.7487 9.99845 3.95017 9.74993 3.95017H8.09993V11.05H9.74994C9.99847 11.05 10.1999 11.2515 10.1999 11.5C10.1999 11.7486 9.99847 11.95 9.74994 11.95H5.24994C5.00141 11.95 4.79994 11.7486 4.79994 11.5C4.79994 11.2515 5.00141 11.05 5.24994 11.05H6.89993V3.95017H5.24993C5.0014 3.95017 4.79993 3.7487 4.79993 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2h = [
    "color"
];
var $c12e32cf04d921d4$export$88890ea574fb3a19 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.78233 2.21707C2.70732 2.14206 2.60557 2.09991 2.49949 2.09991C2.3934 2.09991 2.29166 2.14206 2.21664 2.21707L0.216645 4.21707C0.0604351 4.37328 0.0604351 4.62655 0.216645 4.78276C0.372855 4.93897 0.626121 4.93897 0.78233 4.78276L2.09949 3.4656L2.09949 11.5342L0.78233 10.2171C0.62612 10.0609 0.372854 10.0609 0.216645 10.2171C0.0604349 10.3733 0.0604349 10.6265 0.216645 10.7828L2.21664 12.7828C2.29166 12.8578 2.3934 12.8999 2.49949 12.8999C2.60557 12.8999 2.70731 12.8578 2.78233 12.7828L4.78233 10.7828C4.93854 10.6265 4.93854 10.3733 4.78233 10.2171C4.62612 10.0609 4.37285 10.0609 4.21664 10.2171L2.89949 11.5342L2.89949 3.4656L4.21664 4.78276C4.37285 4.93897 4.62612 4.93897 4.78233 4.78276C4.93854 4.62655 4.93854 4.37328 4.78233 4.21707L2.78233 2.21707ZM10.5 2.74997C10.7107 2.74997 10.8988 2.88211 10.9703 3.08036L13.9703 11.3999C14.064 11.6597 13.9293 11.9462 13.6696 12.0399C13.4098 12.1336 13.1233 11.9989 13.0296 11.7392L12.0477 9.016H8.95228L7.97033 11.7392C7.87666 11.9989 7.59013 12.1336 7.33036 12.0399C7.07059 11.9462 6.93595 11.6597 7.02962 11.3999L10.0296 3.08036C10.1011 2.88211 10.2892 2.74997 10.5 2.74997ZM10.5 4.72396L11.7412 8.166H9.25879L10.5 4.72396Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2i = [
    "color"
];
var $c12e32cf04d921d4$export$805712ff48c03e2e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.03791 9.98075C0.934777 9.6583 1.11603 9.37719 1.40005 9.24871C1.68408 9.12022 2.09463 9.13412 2.27071 9.45426C2.85393 10.5147 3.64599 10.7282 4.48665 10.7282C5.52721 10.7282 6.29659 10.2615 6.29659 9.45426C6.29659 8.8047 5.9119 8.46416 4.87134 8.14253L4.15872 7.92181C2.64518 7.44883 1.88842 6.69206 1.88842 5.45601C1.88842 3.79743 3.27583 2.6875 5.24342 2.6875C6.91733 2.6875 7.97409 3.33536 8.43833 4.31065C8.57087 4.58909 8.57614 4.91294 8.22794 5.19114C7.87974 5.46934 7.52351 5.34799 7.23327 5.03839C6.47215 4.22653 5.99545 4.04968 5.25604 4.04968C4.1398 4.04968 3.547 4.63618 3.547 5.27943C3.547 5.86592 3.96322 6.23169 4.94702 6.5344L5.67856 6.76143C7.22994 7.23441 7.97409 7.95964 7.97409 9.17047C7.97409 10.7723 6.69389 12.0903 4.46143 12.0903C2.86612 12.0903 1.40005 11.1131 1.03791 9.98075ZM11.8491 8.77985C10.661 8.39543 10.1649 7.86114 10.1649 6.98805C10.1649 5.86736 11.1636 5.04639 12.6128 5.04639C13.8546 5.04639 14.6629 5.63345 14.9778 6.6346C15.0443 6.84599 14.9593 6.98006 14.7475 7.0491C14.5394 7.11697 14.3176 7.09974 14.238 6.89611C13.9356 6.12273 13.352 5.76311 12.5998 5.76311C11.6467 5.76311 11.0135 6.25178 11.0135 6.91638C11.0135 7.45066 11.3464 7.75038 12.2473 8.04358L12.8348 8.23254C14.062 8.62999 14.5516 9.13821 14.5516 10.0178C14.5516 11.1972 13.481 12.0442 11.9927 12.0442C10.6439 12.0442 9.65644 11.2809 9.41979 10.3361C9.36535 10.1188 9.41192 10.0287 9.70039 9.96184C9.98886 9.89499 10.0714 9.89918 10.1715 10.1369C10.4555 10.8114 11.1531 11.3275 12.0318 11.3275C12.9914 11.3275 13.6834 10.7802 13.6834 10.0634C13.6834 9.53567 13.3961 9.28807 12.4366 8.97532L11.8491 8.77985Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2j = [
    "color"
];
var $c12e32cf04d921d4$export$bbfc12447ec5dbe8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V4H5V1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5V4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H4V10H1.5C1.22386 10 1 10.2239 1 10.5C1 10.7761 1.22386 11 1.5 11H4V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V11H10V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H11V5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H11V1.5ZM10 10V5H5V10H10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2k = [
    "color"
];
var $c12e32cf04d921d4$export$49fa3bb64381879 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.3825 1.29567C3.46241 1.11432 3.64188 0.997284 3.84005 0.997284H11.5C11.7761 0.997284 12 1.22114 12 1.49728V5.5C12 5.77614 11.7761 6 11.5 6H8.63521L11.5288 9.16247C11.6626 9.3087 11.6974 9.52015 11.6175 9.70154C11.5376 9.88293 11.3582 10 11.16 10H8V13.5C8 13.7022 7.87818 13.8845 7.69134 13.9619C7.5045 14.0393 7.28945 13.9966 7.14645 13.8536L3.14645 9.85355C3.05268 9.75979 3 9.63261 3 9.5V5.5C3 5.22386 3.22386 5 3.5 5H6.36531L3.47105 1.83468C3.33732 1.68844 3.30259 1.47701 3.3825 1.29567ZM7.72032 5L4.97474 1.99728H11V5H7.72032ZM7.27978 6H4V9H7.5H10.0247L7.27978 6ZM4.70711 10L7 12.2929V10H4.70711Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2l = [
    "color"
];
var $c12e32cf04d921d4$export$70208e77f6c45b17 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.07095 0.650238C6.67391 0.650238 6.32977 0.925096 6.24198 1.31231L6.0039 2.36247C5.6249 2.47269 5.26335 2.62363 4.92436 2.81013L4.01335 2.23585C3.67748 2.02413 3.23978 2.07312 2.95903 2.35386L2.35294 2.95996C2.0722 3.2407 2.0232 3.6784 2.23493 4.01427L2.80942 4.92561C2.62307 5.2645 2.47227 5.62594 2.36216 6.00481L1.31209 6.24287C0.924883 6.33065 0.650024 6.6748 0.650024 7.07183V7.92897C0.650024 8.32601 0.924883 8.67015 1.31209 8.75794L2.36228 8.99603C2.47246 9.375 2.62335 9.73652 2.80979 10.0755L2.2354 10.9867C2.02367 11.3225 2.07267 11.7602 2.35341 12.041L2.95951 12.6471C3.24025 12.9278 3.67795 12.9768 4.01382 12.7651L4.92506 12.1907C5.26384 12.377 5.62516 12.5278 6.0039 12.6379L6.24198 13.6881C6.32977 14.0753 6.67391 14.3502 7.07095 14.3502H7.92809C8.32512 14.3502 8.66927 14.0753 8.75705 13.6881L8.99505 12.6383C9.37411 12.5282 9.73573 12.3773 10.0748 12.1909L10.986 12.7653C11.3218 12.977 11.7595 12.928 12.0403 12.6473L12.6464 12.0412C12.9271 11.7604 12.9761 11.3227 12.7644 10.9869L12.1902 10.076C12.3768 9.73688 12.5278 9.37515 12.638 8.99596L13.6879 8.75794C14.0751 8.67015 14.35 8.32601 14.35 7.92897V7.07183C14.35 6.6748 14.0751 6.33065 13.6879 6.24287L12.6381 6.00488C12.528 5.62578 12.3771 5.26414 12.1906 4.92507L12.7648 4.01407C12.9766 3.6782 12.9276 3.2405 12.6468 2.95975L12.0407 2.35366C11.76 2.07292 11.3223 2.02392 10.9864 2.23565L10.0755 2.80989C9.73622 2.62328 9.37437 2.47229 8.99505 2.36209L8.75705 1.31231C8.66927 0.925096 8.32512 0.650238 7.92809 0.650238H7.07095ZM4.92053 3.81251C5.44724 3.44339 6.05665 3.18424 6.71543 3.06839L7.07095 1.50024H7.92809L8.28355 3.06816C8.94267 3.18387 9.5524 3.44302 10.0794 3.81224L11.4397 2.9547L12.0458 3.56079L11.1882 4.92117C11.5573 5.44798 11.8164 6.0575 11.9321 6.71638L13.5 7.07183V7.92897L11.932 8.28444C11.8162 8.94342 11.557 9.55301 11.1878 10.0798L12.0453 11.4402L11.4392 12.0462L10.0787 11.1886C9.55192 11.5576 8.94241 11.8166 8.28355 11.9323L7.92809 13.5002H7.07095L6.71543 11.932C6.0569 11.8162 5.44772 11.5572 4.92116 11.1883L3.56055 12.046L2.95445 11.4399L3.81213 10.0794C3.4431 9.55266 3.18403 8.94326 3.06825 8.2845L1.50002 7.92897V7.07183L3.06818 6.71632C3.18388 6.05765 3.44283 5.44833 3.81171 4.92165L2.95398 3.561L3.56008 2.95491L4.92053 3.81251ZM9.02496 7.50008C9.02496 8.34226 8.34223 9.02499 7.50005 9.02499C6.65786 9.02499 5.97513 8.34226 5.97513 7.50008C5.97513 6.65789 6.65786 5.97516 7.50005 5.97516C8.34223 5.97516 9.02496 6.65789 9.02496 7.50008ZM9.92496 7.50008C9.92496 8.83932 8.83929 9.92499 7.50005 9.92499C6.1608 9.92499 5.07513 8.83932 5.07513 7.50008C5.07513 6.16084 6.1608 5.07516 7.50005 5.07516C8.83929 5.07516 9.92496 6.16084 9.92496 7.50008Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2m = [
    "color"
];
var $c12e32cf04d921d4$export$9a0862960670d05c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49933 0.25C3.49635 0.25 0.25 3.49593 0.25 7.50024C0.25 10.703 2.32715 13.4206 5.2081 14.3797C5.57084 14.446 5.70302 14.2222 5.70302 14.0299C5.70302 13.8576 5.69679 13.4019 5.69323 12.797C3.67661 13.235 3.25112 11.825 3.25112 11.825C2.92132 10.9874 2.44599 10.7644 2.44599 10.7644C1.78773 10.3149 2.49584 10.3238 2.49584 10.3238C3.22353 10.375 3.60629 11.0711 3.60629 11.0711C4.25298 12.1788 5.30335 11.8588 5.71638 11.6732C5.78225 11.205 5.96962 10.8854 6.17658 10.7043C4.56675 10.5209 2.87415 9.89918 2.87415 7.12104C2.87415 6.32925 3.15677 5.68257 3.62053 5.17563C3.54576 4.99226 3.29697 4.25521 3.69174 3.25691C3.69174 3.25691 4.30015 3.06196 5.68522 3.99973C6.26337 3.83906 6.8838 3.75895 7.50022 3.75583C8.1162 3.75895 8.73619 3.83906 9.31523 3.99973C10.6994 3.06196 11.3069 3.25691 11.3069 3.25691C11.7026 4.25521 11.4538 4.99226 11.3795 5.17563C11.8441 5.68257 12.1245 6.32925 12.1245 7.12104C12.1245 9.9063 10.4292 10.5192 8.81452 10.6985C9.07444 10.9224 9.30633 11.3648 9.30633 12.0413C9.30633 13.0102 9.29742 13.7922 9.29742 14.0299C9.29742 14.2239 9.42828 14.4496 9.79591 14.3788C12.6746 13.4179 14.75 10.7025 14.75 7.50024C14.75 3.49593 11.5036 0.25 7.49933 0.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2n = [
    "color"
];
var $c12e32cf04d921d4$export$a70e2e549144f66 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49996 1.80002C4.35194 1.80002 1.79996 4.352 1.79996 7.50002C1.79996 10.648 4.35194 13.2 7.49996 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.352 10.648 1.80002 7.49996 1.80002ZM0.899963 7.50002C0.899963 3.85494 3.85488 0.900024 7.49996 0.900024C11.145 0.900024 14.1 3.85494 14.1 7.50002C14.1 11.1451 11.145 14.1 7.49996 14.1C3.85488 14.1 0.899963 11.1451 0.899963 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M13.4999 7.89998H1.49994V7.09998H13.4999V7.89998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M7.09991 13.5V1.5H7.89991V13.5H7.09991zM10.375 7.49998C10.375 5.32724 9.59364 3.17778 8.06183 1.75656L8.53793 1.24341C10.2396 2.82218 11.075 5.17273 11.075 7.49998 11.075 9.82724 10.2396 12.1778 8.53793 13.7566L8.06183 13.2434C9.59364 11.8222 10.375 9.67273 10.375 7.49998zM3.99969 7.5C3.99969 5.17611 4.80786 2.82678 6.45768 1.24719L6.94177 1.75281C5.4582 3.17323 4.69969 5.32389 4.69969 7.5 4.6997 9.67611 5.45822 11.8268 6.94179 13.2472L6.45769 13.7528C4.80788 12.1732 3.9997 9.8239 3.99969 7.5z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49996 3.95801C9.66928 3.95801 11.8753 4.35915 13.3706 5.19448 13.5394 5.28875 13.5998 5.50197 13.5055 5.67073 13.4113 5.83948 13.198 5.89987 13.0293 5.8056 11.6794 5.05155 9.60799 4.65801 7.49996 4.65801 5.39192 4.65801 3.32052 5.05155 1.97064 5.8056 1.80188 5.89987 1.58866 5.83948 1.49439 5.67073 1.40013 5.50197 1.46051 5.28875 1.62927 5.19448 3.12466 4.35915 5.33063 3.95801 7.49996 3.95801zM7.49996 10.85C9.66928 10.85 11.8753 10.4488 13.3706 9.6135 13.5394 9.51924 13.5998 9.30601 13.5055 9.13726 13.4113 8.9685 13.198 8.90812 13.0293 9.00238 11.6794 9.75643 9.60799 10.15 7.49996 10.15 5.39192 10.15 3.32052 9.75643 1.97064 9.00239 1.80188 8.90812 1.58866 8.9685 1.49439 9.13726 1.40013 9.30601 1.46051 9.51924 1.62927 9.6135 3.12466 10.4488 5.33063 10.85 7.49996 10.85z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2o = [
    "color"
];
var $c12e32cf04d921d4$export$fa17e9a974485717 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.5 2H8V7H13V2.5C13 2.22386 12.7761 2 12.5 2ZM13 8H8V13H12.5C12.7761 13 13 12.7761 13 12.5V8ZM7 7V2H2.5C2.22386 2 2 2.22386 2 2.5V7H7ZM2 8V12.5C2 12.7761 2.22386 13 2.5 13H7V8H2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2p = [
    "color"
];
var $c12e32cf04d921d4$export$97eeb400c5f33310 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.44995 0.949951C1.31734 0.949951 1.19016 1.00263 1.0964 1.0964C1.00263 1.19017 0.949951 1.31735 0.949951 1.44995L0.949966 3.44995C0.949969 3.7261 1.17383 3.94995 1.44997 3.94995C1.72611 3.94995 1.94997 3.72609 1.94997 3.44995L1.94995 1.94995H3.44997C3.72611 1.94995 3.94997 1.72609 3.94997 1.44995C3.94997 1.17381 3.72611 0.949951 3.44997 0.949951H1.44995ZM5.94995 0.949951C5.67381 0.949951 5.44995 1.17381 5.44995 1.44995C5.44995 1.72609 5.67381 1.94995 5.94995 1.94995H8.94995C9.22609 1.94995 9.44995 1.72609 9.44995 1.44995C9.44995 1.17381 9.22609 0.949951 8.94995 0.949951H5.94995ZM5.44995 13.45C5.44995 13.1738 5.67381 12.95 5.94995 12.95H8.94995C9.22609 12.95 9.44995 13.1738 9.44995 13.45C9.44995 13.7261 9.22609 13.95 8.94995 13.95H5.94995C5.67381 13.95 5.44995 13.7261 5.44995 13.45ZM1.94995 5.94995C1.94995 5.67381 1.72609 5.44995 1.44995 5.44995C1.17381 5.44995 0.949951 5.67381 0.949951 5.94995V8.94995C0.949951 9.22609 1.17381 9.44995 1.44995 9.44995C1.72609 9.44995 1.94995 9.22609 1.94995 8.94995V5.94995ZM13.45 5.44995C13.7261 5.44995 13.95 5.67381 13.95 5.94995V8.94995C13.95 9.22609 13.7261 9.44995 13.45 9.44995C13.1738 9.44995 12.95 9.22609 12.95 8.94995V5.94995C12.95 5.67381 13.1738 5.44995 13.45 5.44995ZM11.45 0.949951C11.1738 0.949951 10.95 1.17381 10.95 1.44995C10.95 1.72609 11.1738 1.94995 11.45 1.94995H12.9499V3.44995C12.9499 3.72609 13.1738 3.94995 13.4499 3.94995C13.7261 3.94995 13.9499 3.72609 13.9499 3.44995V1.44995C13.9499 1.17381 13.7252 0.949951 13.449 0.949951H11.45ZM1.44995 10.95C1.72609 10.95 1.94995 11.1738 1.94995 11.45V12.95H3.44997C3.72611 12.95 3.94997 13.1738 3.94997 13.45C3.94997 13.7261 3.72611 13.95 3.44997 13.95H1.44995C1.17381 13.95 0.949951 13.7261 0.949951 13.45V11.45C0.949951 11.1738 1.17381 10.95 1.44995 10.95ZM13.95 11.45C13.95 11.1738 13.7261 10.95 13.45 10.95C13.1738 10.9499 12.95 11.1738 12.95 11.4499L12.9491 12.95H11.45C11.1738 12.95 10.95 13.1738 10.95 13.45C10.95 13.7261 11.1738 13.95 11.45 13.95H13.4499C13.7261 13.95 13.9499 13.7261 13.9499 13.45L13.95 11.45Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2q = [
    "color"
];
var $c12e32cf04d921d4$export$1106febb4d651860 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.00003 1.84861C4.10114 2.1017 1.82707 4.53515 1.82707 7.49972C1.82707 10.4643 4.10114 12.8977 7.00003 13.1508V1.84861ZM8.00003 13.1508C10.8988 12.8976 13.1727 10.4642 13.1727 7.49972C13.1727 4.53524 10.8988 2.10185 8.00003 1.84864V13.1508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2r = [
    "color"
];
var $c12e32cf04d921d4$export$991e44cd0549467c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.49988 1.82689C4.36688 1.8269 1.82707 4.36672 1.82707 7.49972C1.82707 10.6327 4.36688 13.1725 7.49988 13.1726V1.82689Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2s = [
    "color"
];
var $c12e32cf04d921d4$export$ea8e5ed9f4a6e89d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2t = [
    "color"
];
var $c12e32cf04d921d4$export$f9eb84fdaa009a42 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.8113 1.64706C6.62188 2.87918 6.68268 3.88523 6.76848 5.30499C6.78415 5.56426 6.80065 5.83732 6.81661 6.12808C6.83111 6.39208 6.63758 6.62172 6.37495 6.65217C6.11232 6.68262 5.87138 6.50334 5.82509 6.24304L5.74754 5.80698C5.64402 5.16529 5.48355 4.25481 5.17807 3.44741C4.86241 2.61312 4.4486 2.04121 3.93436 1.86044C3.64994 1.76104 3.41901 1.84279 3.25868 2.01052C3.08746 2.18962 2.9976 2.47065 3.0627 2.75399C3.2146 3.34424 3.44627 3.9167 3.69836 4.51802C3.72082 4.57158 3.74346 4.62543 3.76621 4.67954C3.9954 5.22457 4.23619 5.7972 4.41644 6.39081L4.41691 6.39238C4.562 6.87586 4.65646 7.2595 4.73086 7.56165C4.76034 7.68138 4.78667 7.78831 4.81175 7.88359C4.86768 8.09606 4.77836 8.32014 4.59161 8.43588C4.40486 8.55161 4.16445 8.53188 3.99907 8.38725C3.73749 8.15848 3.515 7.92784 3.31817 7.71802C3.27627 7.67335 3.23602 7.63018 3.19705 7.58838C3.04777 7.42826 2.91712 7.28812 2.78334 7.16029C2.45989 6.85122 2.18398 6.68004 1.80585 6.64369L1.80324 6.64343C1.56117 6.61888 1.41402 6.66441 1.31756 6.72627C1.21899 6.78947 1.11988 6.90414 1.03784 7.1123C0.976576 7.28492 1.01515 7.62987 1.1929 7.96911L1.19728 7.97747C1.40086 8.38452 1.74475 8.81587 2.18141 9.29299C2.39739 9.52898 2.62872 9.76849 2.86934 10.0174L2.87966 10.0281C3.11546 10.2721 3.35962 10.5247 3.59713 10.7827C4.4288 11.6863 5.27706 12.7538 5.4627 14H11.5087C11.5636 12.4353 11.8756 11.268 12.2875 10.1346C12.4454 9.70041 12.6121 9.28412 12.7826 8.85829C13.1097 8.04139 13.4509 7.18937 13.7705 6.10824C14.0989 4.99737 14.0097 4.37033 13.8613 4.03984C13.717 3.71858 13.4914 3.61786 13.3816 3.59606C13.1381 3.54774 13.0384 3.60947 12.9698 3.67901C12.867 3.78316 12.7698 3.98273 12.6921 4.30269C12.6166 4.61345 12.5752 4.96517 12.533 5.32501L12.5298 5.35285C12.4924 5.67242 12.4505 6.03016 12.3665 6.30098C12.3383 6.40699 12.2819 6.50407 12.1979 6.57539C12.1382 6.6261 12.0104 6.70818 11.8309 6.69312C11.5424 6.66891 11.3712 6.42143 11.365 6.14783C11.356 5.75454 11.3883 5.35864 11.4074 4.96608C11.4428 4.23646 11.477 3.5337 11.4245 2.8342L11.4242 2.82934C11.3916 2.32997 11.0493 2.00228 10.7007 1.9228C10.5305 1.88401 10.369 1.90601 10.2347 1.9835C10.103 2.05946 9.95535 2.21318 9.8574 2.51394L9.85631 2.51726C9.81525 2.6404 9.77298 2.87753 9.73606 3.2124C9.70044 3.53542 9.67337 3.91279 9.65156 4.29418C9.6329 4.62033 9.61785 4.9584 9.60434 5.26194C9.58728 5.64529 9.57267 5.97357 9.55633 6.1532C9.54983 6.22459 9.52939 6.29493 9.49501 6.35785C9.47356 6.39711 9.36115 6.60947 9.07106 6.61843C8.77917 6.62744 8.63975 6.40057 8.61698 6.35919C8.55634 6.24899 8.55066 6.11807 8.54754 5.99283C8.54474 5.88064 8.54294 5.71798 8.54174 5.54767C8.53935 5.20582 8.53935 4.81919 8.53935 4.70952C8.53935 3.6657 8.53838 2.65372 8.44714 1.64372C8.39183 1.24127 8.06278 1.00455 7.6436 1.00005C7.22399 0.995552 6.87918 1.22704 6.8113 1.64706ZM9.41219 1.3617C9.21469 0.448484 8.39913 0.00810324 7.65433 0.00011154C6.86452 -0.00836308 5.98761 0.465881 5.82365 1.49037L5.82318 1.49334C5.78239 1.7584 5.75229 2.01481 5.7309 2.26652C5.39423 1.67364 4.92622 1.14894 4.2655 0.916859C3.58661 0.679312 2.9492 0.887087 2.53582 1.31952C2.13415 1.73971 1.94438 2.36742 2.09031 2.98746L2.09269 2.99713C2.26478 3.66808 2.52396 4.30316 2.77613 4.90465C2.79814 4.95717 2.8201 5.00941 2.84194 5.06139C3.02139 5.48842 3.19378 5.89866 3.33871 6.31256C2.96404 5.98142 2.51925 5.70796 1.90276 5.6484C1.48865 5.60663 1.10391 5.67536 0.777805 5.88444C0.454239 6.0919 0.240671 6.40405 0.104187 6.75406L0.100868 6.76281C-0.10184 7.31286 0.0663312 7.97157 0.304895 8.42897C0.573704 8.96474 0.996104 9.47904 1.44372 9.96813C1.67046 10.2159 1.91136 10.4652 2.15033 10.7124L2.15682 10.7191C2.39524 10.9658 2.63217 11.2109 2.86134 11.4599C3.80937 12.49 4.50002 13.4632 4.50002 14.5C4.50002 14.7761 4.72388 15 5.00002 15H12C12.2762 15 12.5 14.7761 12.5 14.5C12.5 12.8212 12.8021 11.6462 13.2274 10.4762C13.3653 10.0968 13.5216 9.70579 13.6868 9.29247C14.0238 8.44922 14.398 7.51298 14.7295 6.39175C15.0956 5.15324 15.0559 4.25904 14.7735 3.63017C14.487 2.99208 13.9798 2.6953 13.5763 2.6152C13.1276 2.52614 12.7367 2.60475 12.4268 2.83081C12.4253 2.80773 12.4236 2.78468 12.4219 2.76167C12.3587 1.8105 11.6907 1.12285 10.923 0.947821C10.5346 0.859287 10.1111 0.900393 9.73509 1.11724C9.61852 1.18446 9.51055 1.26623 9.41219 1.3617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2u = [
    "color"
];
var $c12e32cf04d921d4$export$635e9dadffe43ee = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2v = [
    "color"
];
var $c12e32cf04d921d4$export$16f03ed71cfb60c9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.89346 2.35248C3.49195 2.35248 2.35248 3.49359 2.35248 4.90532C2.35248 6.38164 3.20954 7.9168 4.37255 9.33522C5.39396 10.581 6.59464 11.6702 7.50002 12.4778C8.4054 11.6702 9.60608 10.581 10.6275 9.33522C11.7905 7.9168 12.6476 6.38164 12.6476 4.90532C12.6476 3.49359 11.5081 2.35248 10.1066 2.35248C9.27059 2.35248 8.81894 2.64323 8.5397 2.95843C8.27877 3.25295 8.14623 3.58566 8.02501 3.88993C8.00391 3.9429 7.98315 3.99501 7.96211 4.04591C7.88482 4.23294 7.7024 4.35494 7.50002 4.35494C7.29765 4.35494 7.11523 4.23295 7.03793 4.04592C7.01689 3.99501 6.99612 3.94289 6.97502 3.8899C6.8538 3.58564 6.72126 3.25294 6.46034 2.95843C6.18109 2.64323 5.72945 2.35248 4.89346 2.35248ZM1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.0084 1.35248 6.73504 1.76049 7.20884 2.2953C7.32062 2.42147 7.41686 2.55382 7.50002 2.68545C7.58318 2.55382 7.67941 2.42147 7.79119 2.2953C8.265 1.76049 8.99164 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2w = [
    "color"
];
var $c12e32cf04d921d4$export$b4120a3a3b5e8fcd = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.25769 1.35248 6.86058 1.92336 7.50002 2.93545C8.13946 1.92336 8.74235 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2x = [
    "color"
];
var $c12e32cf04d921d4$export$141e350c1bf9e61a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.1813 1.68179C7.35704 1.50605 7.64196 1.50605 7.8177 1.68179L10.3177 4.18179C10.4934 4.35753 10.4934 4.64245 10.3177 4.81819C10.142 4.99392 9.85704 4.99392 9.6813 4.81819L7.9495 3.08638L7.9495 11.9136L9.6813 10.1818C9.85704 10.0061 10.142 10.0061 10.3177 10.1818C10.4934 10.3575 10.4934 10.6424 10.3177 10.8182L7.8177 13.3182C7.73331 13.4026 7.61885 13.45 7.4995 13.45C7.38015 13.45 7.26569 13.4026 7.1813 13.3182L4.6813 10.8182C4.50557 10.6424 4.50557 10.3575 4.6813 10.1818C4.85704 10.0061 5.14196 10.0061 5.3177 10.1818L7.0495 11.9136L7.0495 3.08638L5.3177 4.81819C5.14196 4.99392 4.85704 4.99392 4.6813 4.81819C4.50557 4.64245 4.50557 4.35753 4.6813 4.18179L7.1813 1.68179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2y = [
    "color"
];
var $c12e32cf04d921d4$export$9360f6250c6c6a8c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.3536 13.3536C12.1583 13.5488 11.8417 13.5488 11.6465 13.3536L6.39645 8.10355C6.36478 8.07188 6.33824 8.03702 6.31685 8H5.00002C4.78719 8 4.59769 7.86528 4.52777 7.66426L2.12777 0.764277C2.05268 0.548387 2.13355 0.309061 2.3242 0.182972C2.51486 0.0568819 2.76674 0.0761337 2.93602 0.229734L8.336 5.12972C8.44044 5.22449 8.50001 5.35897 8.50001 5.5V5.81684C8.53702 5.83824 8.57189 5.86478 8.60356 5.89645L13.8536 11.1464C14.0488 11.3417 14.0488 11.6583 13.8536 11.8536L12.3536 13.3536ZM8.25 6.95711L7.45711 7.75L12 12.2929L12.7929 11.5L8.25 6.95711ZM3.71669 2.28845L5.35549 7H6.2929L7.50001 5.79289V5.72146L3.71669 2.28845Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2z = [
    "color"
];
var $c12e32cf04d921d4$export$92c8767b874048d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.07926 0.222253C7.31275 -0.007434 7.6873 -0.007434 7.92079 0.222253L14.6708 6.86227C14.907 7.09465 14.9101 7.47453 14.6778 7.71076C14.4454 7.947 14.0655 7.95012 13.8293 7.71773L13 6.90201V12.5C13 12.7761 12.7762 13 12.5 13H2.50002C2.22388 13 2.00002 12.7761 2.00002 12.5V6.90201L1.17079 7.71773C0.934558 7.95012 0.554672 7.947 0.32229 7.71076C0.0899079 7.47453 0.0930283 7.09465 0.32926 6.86227L7.07926 0.222253ZM7.50002 1.49163L12 5.91831V12H10V8.49999C10 8.22385 9.77617 7.99999 9.50002 7.99999H6.50002C6.22388 7.99999 6.00002 8.22385 6.00002 8.49999V12H3.00002V5.91831L7.50002 1.49163ZM7.00002 12H9.00002V8.99999H7.00002V12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2A = [
    "color"
];
var $c12e32cf04d921d4$export$13a4588734565757 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0.0032959C6.80473 0.0032959 6.24953 0.281106 6.25 0.749995C6.25 0.997258 6.42446 1.12014 6.57687 1.22749C6.69507 1.31074 6.8 1.38465 6.8 1.5C6.8 1.7071 6.06224 1.74264 5.19789 1.78427C3.97553 1.84314 2.5 1.91421 2.5 2.5C2.5 2.77614 2.72386 3 3 3H12C12.2761 3 12.5 2.77614 12.5 2.5C12.5 1.91421 11.0245 1.84314 9.80211 1.78427C8.93776 1.74264 8.2 1.7071 8.2 1.5C8.2 1.38465 8.30493 1.31074 8.42313 1.22749C8.57554 1.12014 8.75 0.997258 8.75 0.749995C8.75047 0.281106 8.19527 0.0032959 7.5 0.0032959ZM2.89451 6.12266C2.25806 6.52471 1.90417 7.31118 2.02473 8.0556L2.83588 12.4772C3.00993 13.3562 3.7629 14 4.66061 14H10.3373C11.2354 14 11.9884 13.3562 12.1625 12.4772L12.9736 8.05607C13.089 7.32358 12.8284 6.53276 12.1331 6.09373C11.7283 5.83013 11.6412 5.33231 12.1331 5.12796C12.8284 4.86435 12.6948 4 12 4H10.3001H6.80005H2.99996C2.30469 4 2.19878 4.89328 2.89451 5.15689C3.38642 5.33231 3.29939 5.83013 2.89451 6.12266ZM8.20006 6.25C8.20006 5.81769 8.08572 5.37615 7.90635 5L4.11093 5C4.20626 5.21312 4.2419 5.43889 4.22904 5.65521C4.19522 6.22412 3.84587 6.66899 3.48016 6.93322L3.45492 6.95146L3.42858 6.9681C3.13407 7.15414 2.95801 7.53989 3.01058 7.88749L3.81797 12.2886C3.90513 12.7154 4.26148 13 4.66061 13H10.3373C10.737 13 11.0932 12.7153 11.1804 12.2886L11.9874 7.8898C12.048 7.48247 11.8954 7.12631 11.5992 6.93927L11.5875 6.93184L11.5875 6.93176C11.1947 6.67602 10.8331 6.22785 10.7986 5.64798C10.7846 5.412 10.8264 5.19397 10.9112 5H9.05517C9.01987 5.14611 9.00006 5.31201 9.00006 5.5C9.00006 5.9745 9.21679 6.37127 9.44367 6.78662C9.69284 7.24278 9.95425 7.72136 9.95425 8.34993C9.95425 9.2698 9.49868 9.84205 8.62189 9.84205C8.13206 9.84205 7.57818 9.46097 7.57818 8.75781C7.57818 8.35279 7.71558 8.01646 7.86121 7.65998C8.0254 7.25806 8.20006 6.83051 8.20006 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2B = [
    "color"
];
var $c12e32cf04d921d4$export$583b57cdbe59a84e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 11.0001V4.00006L1 4.00006L1 11.0001H14ZM15 4.00006V11.0001C15 11.5523 14.5523 12.0001 14 12.0001H1C0.447715 12.0001 0 11.5523 0 11.0001V4.00006C0 3.44778 0.447715 3.00006 1 3.00006H14C14.5523 3.00006 15 3.44778 15 4.00006ZM2 5.25C2 5.11193 2.11193 5 2.25 5H5.75C5.88807 5 6 5.11193 6 5.25V9.75C6 9.88807 5.88807 10 5.75 10H2.25C2.11193 10 2 9.88807 2 9.75V5.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5ZM7.5 5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2C = [
    "color"
];
var $c12e32cf04d921d4$export$4a122bafaa48b23d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2D = [
    "color"
];
var $c12e32cf04d921d4$export$7a1b52edf33ca2d9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2E = [
    "color"
];
var $c12e32cf04d921d4$export$f8fea9f50a4bfae6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.5 1C6.22386 1 6 1.22386 6 1.5C6 1.77614 6.22386 2 6.5 2C7.12671 2 7.45718 2.20028 7.65563 2.47812C7.8781 2.78957 8 3.28837 8 4V11C8 11.7116 7.8781 12.2104 7.65563 12.5219C7.45718 12.7997 7.12671 13 6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14C7.37329 14 8.04282 13.7003 8.46937 13.1031C8.47976 13.0886 8.48997 13.0739 8.5 13.0591C8.51003 13.0739 8.52024 13.0886 8.53063 13.1031C8.95718 13.7003 9.62671 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.87329 13 9.54282 12.7997 9.34437 12.5219C9.1219 12.2104 9 11.7116 9 11V4C9 3.28837 9.1219 2.78957 9.34437 2.47812C9.54282 2.20028 9.87329 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.62671 1 8.95718 1.29972 8.53063 1.89688C8.52024 1.91143 8.51003 1.92611 8.5 1.9409C8.48997 1.92611 8.47976 1.91143 8.46937 1.89688C8.04282 1.29972 7.37329 1 6.5 1ZM14 5H11V4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H11V10H14V5ZM6 4V5H1L1 10H6V11H1C0.447715 11 0 10.5523 0 10V5C0 4.44772 0.447715 4 1 4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2F = [
    "color"
];
var $c12e32cf04d921d4$export$632f10cfe13035ff = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.9091 12.909C13.2365 12.5817 13.4918 12.1895 13.6588 11.7577C13.8195 11.3443 13.9294 10.8718 13.961 10.1799C13.9926 9.48665 14.0001 9.26529 14.0001 7.50001C14.0001 5.73473 13.9926 5.51328 13.961 4.82008C13.9294 4.12821 13.8195 3.65573 13.6588 3.24228C13.4956 2.80857 13.2398 2.41567 12.9091 2.091C12.5844 1.76028 12.1915 1.50437 11.7578 1.34113C11.3443 1.18056 10.8718 1.0707 10.1799 1.03924C9.48675 1.00748 9.26537 1 7.50006 1C5.73476 1 5.51333 1.00748 4.82014 1.03912C4.12826 1.0707 3.65578 1.18056 3.24233 1.34125C2.80862 1.50447 2.41573 1.76032 2.09105 2.09098C1.76032 2.41563 1.5044 2.80852 1.34113 3.24225C1.18056 3.65573 1.0707 4.12821 1.03924 4.82008C1.00748 5.51328 1 5.73471 1 7.50001C1 9.26532 1.00748 9.48675 1.03924 10.1799C1.07083 10.8718 1.18069 11.3443 1.34138 11.7577C1.5046 12.1915 1.76045 12.5843 2.09111 12.909C2.41578 13.2397 2.80867 13.4955 3.24238 13.6587C3.65586 13.8194 4.12834 13.9293 4.82019 13.9609C5.51348 13.9925 5.73483 14 7.50012 14C9.2654 14 9.48685 13.9925 10.18 13.9609C10.8719 13.9293 11.3444 13.8194 11.7578 13.6587C12.1896 13.4917 12.5818 13.2364 12.9091 12.909ZM1.99949 6.73496C1.99974 6.94524 2.00005 7.19543 2.00005 7.50002C2.00005 7.80461 1.99974 8.0548 1.99949 8.26507C1.99849 9.08596 1.99824 9.29856 2.01963 9.7655C2.04625 10.3509 2.07823 10.7811 2.17588 11.1053C2.26976 11.417 2.37505 11.7342 2.7188 12.1171C3.06255 12.4999 3.39411 12.6733 3.81645 12.8007C4.23879 12.928 4.7696 12.9554 5.23052 12.9764C5.75332 13.0003 5.96052 13.0002 7.05714 12.9999L7.50006 12.9999C7.79304 12.9999 8.03569 13.0001 8.2409 13.0004C9.08195 13.0013 9.29425 13.0015 9.76575 12.9799C10.3512 12.9533 10.7814 12.9213 11.1056 12.8237C11.4173 12.7298 11.7345 12.6245 12.1173 12.2807C12.5001 11.937 12.6735 11.6054 12.8009 11.1831C12.9283 10.7607 12.9557 10.2299 12.9767 9.76902C13.0005 9.24689 13.0004 9.04027 13.0002 7.94749V7.94738L13.0001 7.50039L13.0001 7.05747C13.0004 5.96085 13.0005 5.75365 12.9766 5.23085C12.9556 4.76993 12.9282 4.23912 12.8009 3.81678C12.6735 3.39445 12.5001 3.06288 12.1173 2.71913C11.7345 2.37538 11.4172 2.27009 11.1056 2.17621C10.7813 2.07856 10.3511 2.04658 9.76571 2.01996C9.29421 1.99836 9.08194 1.99859 8.24092 1.99951H8.24092C8.0357 1.99974 7.79305 2.00001 7.50006 2.00001L7.05704 1.99993C5.96051 1.99964 5.75331 1.99958 5.23052 2.02343C4.7696 2.04446 4.23879 2.07183 3.81645 2.19921C3.39411 2.32659 3.06255 2.49999 2.7188 2.88281C2.37505 3.26562 2.26976 3.58286 2.17588 3.89453C2.07823 4.21874 2.04625 4.64894 2.01963 5.23437C1.99824 5.70131 1.99849 5.91401 1.99949 6.73496ZM7.49996 5.25015C6.25741 5.25015 5.25012 6.25744 5.25012 7.49999C5.25012 8.74254 6.25741 9.74983 7.49996 9.74983C8.74251 9.74983 9.7498 8.74254 9.7498 7.49999C9.7498 6.25744 8.74251 5.25015 7.49996 5.25015ZM4.25012 7.49999C4.25012 5.70515 5.70512 4.25015 7.49996 4.25015C9.2948 4.25015 10.7498 5.70515 10.7498 7.49999C10.7498 9.29483 9.2948 10.7498 7.49996 10.7498C5.70512 10.7498 4.25012 9.29483 4.25012 7.49999ZM10.9697 4.7803C11.3839 4.7803 11.7197 4.44452 11.7197 4.0303C11.7197 3.61609 11.3839 3.2803 10.9697 3.2803C10.5555 3.2803 10.2197 3.61609 10.2197 4.0303C10.2197 4.44452 10.5555 4.7803 10.9697 4.7803Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$2G = [
    "color"
];
var $c12e32cf04d921d4$export$97dac707ecee26f6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 4H1.5C1.22386 4 1 4.22386 1 4.5V10.5C1 10.7761 1.22386 11 1.5 11H13.5C13.7761 11 14 10.7761 14 10.5V4.5C14 4.22386 13.7761 4 13.5 4ZM1.5 3C0.671573 3 0 3.67157 0 4.5V10.5C0 11.3284 0.671573 12 1.5 12H13.5C14.3284 12 15 11.3284 15 10.5V4.5C15 3.67157 14.3284 3 13.5 3H1.5ZM2 5H3V6H2V5ZM5 5H4V6H5V5ZM6 5H7V6H6V5ZM9 5H8V6H9V5ZM10 5H11V6H10V5ZM13 5H12V6H13V5ZM11 7H12V8H11V7ZM13 9H12V10H13V9ZM9 7H10V8H9V7ZM8 7H7V8H8V7ZM5 7H6V8H5V7ZM4 7H3V8H4V7ZM2 9H3V10H2V9ZM11 9H4V10H11V9Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$2H = [
    "color"
];
var $c12e32cf04d921d4$export$73ea89eab1c37fa2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2I = [
    "color"
];
var $c12e32cf04d921d4$export$b94473071ddf9fbf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 4.25C2 4.11193 2.11193 4 2.25 4H12.75C12.8881 4 13 4.11193 13 4.25V11.5H2V4.25ZM2.25 3C1.55964 3 1 3.55964 1 4.25V12H0V12.5C0 12.7761 0.223858 13 0.5 13H14.5C14.7761 13 15 12.7761 15 12.5V12H14V4.25C14 3.55964 13.4404 3 12.75 3H2.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2J = [
    "color"
];
var $c12e32cf04d921d4$export$a00948e6c38bedc8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.75432 0.819537C7.59742 0.726821 7.4025 0.726821 7.24559 0.819537L1.74559 4.06954C1.59336 4.15949 1.49996 4.32317 1.49996 4.5C1.49996 4.67683 1.59336 4.84051 1.74559 4.93046L7.24559 8.18046C7.4025 8.27318 7.59742 8.27318 7.75432 8.18046L13.2543 4.93046C13.4066 4.84051 13.5 4.67683 13.5 4.5C13.5 4.32317 13.4066 4.15949 13.2543 4.06954L7.75432 0.819537ZM7.49996 7.16923L2.9828 4.5L7.49996 1.83077L12.0171 4.5L7.49996 7.16923ZM1.5695 7.49564C1.70998 7.2579 2.01659 7.17906 2.25432 7.31954L7.49996 10.4192L12.7456 7.31954C12.9833 7.17906 13.2899 7.2579 13.4304 7.49564C13.5709 7.73337 13.4921 8.03998 13.2543 8.18046L7.75432 11.4305C7.59742 11.5232 7.4025 11.5232 7.24559 11.4305L1.74559 8.18046C1.50786 8.03998 1.42901 7.73337 1.5695 7.49564ZM1.56949 10.4956C1.70998 10.2579 2.01658 10.1791 2.25432 10.3195L7.49996 13.4192L12.7456 10.3195C12.9833 10.1791 13.2899 10.2579 13.4304 10.4956C13.5709 10.7334 13.4921 11.04 13.2543 11.1805L7.75432 14.4305C7.59742 14.5232 7.4025 14.5232 7.24559 14.4305L1.74559 11.1805C1.50785 11.04 1.42901 10.7334 1.56949 10.4956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2K = [
    "color"
];
var $c12e32cf04d921d4$export$b5c6e0b0c099878a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9 2H6V13H9V2ZM10 2V13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2H10ZM2.5 2H5V13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2L = [
    "color"
];
var $c12e32cf04d921d4$export$2d8928fe752eaf76 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.68979 2.75C3.89667 2.74979 4.08232 2.87701 4.15679 3.07003L7.36662 11.39C7.46602 11.6477 7.33774 11.9371 7.0801 12.0365C6.82247 12.1359 6.53304 12.0076 6.43365 11.75L5.3825 9.02537H2.01133L0.966992 11.749C0.868128 12.0068 0.578964 12.1357 0.321126 12.0369C0.0632878 11.938 -0.0655864 11.6488 0.0332774 11.391L3.22344 3.07099C3.29751 2.87782 3.4829 2.75021 3.68979 2.75ZM3.69174 4.64284L5.05458 8.17537H2.33724L3.69174 4.64284ZM10.8989 5.20703C9.25818 5.20703 8.00915 6.68569 8.00915 8.60972C8.00915 10.6337 9.35818 12.0124 10.8989 12.0124C11.7214 12.0124 12.5744 11.6692 13.1543 11.0219V11.53C13.1543 11.7785 13.3557 11.98 13.6043 11.98C13.8528 11.98 14.0543 11.7785 14.0543 11.53V5.72C14.0543 5.47147 13.8528 5.27 13.6043 5.27C13.3557 5.27 13.1543 5.47147 13.1543 5.72V6.22317C12.6054 5.60095 11.7924 5.20703 10.8989 5.20703ZM13.1543 9.79823V7.30195C12.7639 6.58101 11.9414 6.05757 11.0868 6.05757C10.1088 6.05757 9.03503 6.96581 9.03503 8.60955C9.03503 10.1533 10.0088 11.1615 11.0868 11.1615C11.9701 11.1615 12.7719 10.4952 13.1543 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2M = [
    "color"
];
var $c12e32cf04d921d4$export$ba5807ad0c0f9980 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.69899 5.20703C2.05823 5.20703 0.809204 6.68569 0.809204 8.60972C0.809204 10.6337 2.15823 12.0124 3.69899 12.0124C4.52126 12.0124 5.37402 11.6693 5.9539 11.0223V11.53C5.9539 11.7785 6.15537 11.98 6.4039 11.98C6.65243 11.98 6.8539 11.7785 6.8539 11.53V5.72001C6.8539 5.47149 6.65243 5.27001 6.4039 5.27001C6.15537 5.27001 5.9539 5.47149 5.9539 5.72001V6.22269C5.40506 5.60075 4.59218 5.20703 3.69899 5.20703ZM5.9539 9.799V7.30117C5.56339 6.58064 4.74118 6.05757 3.8868 6.05757C2.9089 6.05757 1.83508 6.96581 1.83508 8.60955C1.83508 10.1533 2.80889 11.1615 3.8868 11.1615C4.76984 11.1615 5.57141 10.4957 5.9539 9.799ZM10.799 5.20703C9.15823 5.20703 7.9092 6.68569 7.9092 8.60972C7.9092 10.6337 9.25823 12.0124 10.799 12.0124C11.6215 12.0124 12.4744 11.6692 13.0543 11.0218V11.53C13.0543 11.7785 13.2558 11.98 13.5043 11.98C13.7529 11.98 13.9543 11.7785 13.9543 11.53V5.72C13.9543 5.47147 13.7529 5.27 13.5043 5.27C13.2558 5.27 13.0543 5.47147 13.0543 5.72V6.22318C12.5055 5.60095 11.6924 5.20703 10.799 5.20703ZM13.0543 9.79822V7.30196C12.664 6.58102 11.8415 6.05757 10.9868 6.05757C10.0089 6.05757 8.93508 6.96581 8.93508 8.60955C8.93508 10.1533 9.90889 11.1615 10.9868 11.1615C11.8702 11.1615 12.672 10.4952 13.0543 9.79822Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2N = [
    "color"
];
var $c12e32cf04d921d4$export$7e8527e8d8b03e5e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.2895 2.75C11.4964 2.74979 11.6821 2.87701 11.7565 3.07003L14.9664 11.39C15.0657 11.6477 14.9375 11.9371 14.6798 12.0365C14.4222 12.1359 14.1328 12.0076 14.0334 11.75L12.9822 9.02537H9.61106L8.56672 11.749C8.46786 12.0068 8.1787 12.1357 7.92086 12.0369C7.66302 11.938 7.53415 11.6488 7.63301 11.391L10.8232 3.07099C10.8972 2.87782 11.0826 2.75021 11.2895 2.75ZM11.2915 4.64284L12.6543 8.17537H9.93698L11.2915 4.64284ZM2.89895 5.20703C1.25818 5.20703 0.00915527 6.68569 0.00915527 8.60972C0.00915527 10.6337 1.35818 12.0124 2.89895 12.0124C3.72141 12.0124 4.57438 11.6692 5.15427 11.0219V11.53C5.15427 11.7785 5.35574 11.98 5.60427 11.98C5.8528 11.98 6.05427 11.7785 6.05427 11.53V5.72C6.05427 5.47147 5.8528 5.27 5.60427 5.27C5.35574 5.27 5.15427 5.47147 5.15427 5.72V6.22317C4.60543 5.60095 3.79236 5.20703 2.89895 5.20703ZM5.15427 9.79823V7.30195C4.76393 6.58101 3.94144 6.05757 3.08675 6.05757C2.10885 6.05757 1.03503 6.96581 1.03503 8.60955C1.03503 10.1533 2.00885 11.1615 3.08675 11.1615C3.97011 11.1615 4.77195 10.4952 5.15427 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2O = [
    "color"
];
var $c12e32cf04d921d4$export$9395c236dc77b2d2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.6255 2.75C3.83478 2.75 4.02192 2.88034 4.09448 3.07664L7.16985 11.3962C7.2656 11.6552 7.13324 11.9428 6.87423 12.0386C6.61522 12.1343 6.32763 12.002 6.23188 11.7429L5.22387 9.01603H2.02712L1.01911 11.7429C0.923362 12.002 0.635774 12.1343 0.376762 12.0386C0.117749 11.9428 -0.0146052 11.6552 0.0811401 11.3962L3.15651 3.07664C3.22908 2.88034 3.41621 2.75 3.6255 2.75ZM3.6255 4.69207L4.90966 8.16603H2.34133L3.6255 4.69207ZM11.3719 2.75C11.5811 2.75 11.7683 2.88034 11.8408 3.07664L14.9162 11.3962C15.012 11.6552 14.8796 11.9428 14.6206 12.0386C14.3616 12.1343 14.074 12.002 13.9782 11.7429L12.9702 9.01603H9.77348L8.76547 11.7429C8.66972 12.002 8.38213 12.1343 8.12312 12.0386C7.86411 11.9428 7.73175 11.6552 7.8275 11.3962L10.9029 3.07664C10.9754 2.88034 11.1626 2.75 11.3719 2.75ZM11.3719 4.69207L12.656 8.16603H10.0877L11.3719 4.69207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2P = [
    "color"
];
var $c12e32cf04d921d4$export$b5d24f94d82d9f2b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.55293 0.999969C4.75295 0.999969 4.93372 1.11917 5.0125 1.30301L8.01106 8.29982C8.11984 8.55363 8.00226 8.84757 7.74844 8.95635C7.49463 9.06512 7.20069 8.94754 7.09191 8.69373L6.11613 6.41685H2.98973L2.01395 8.69373C1.90517 8.94754 1.61123 9.06512 1.35742 8.95635C1.1036 8.84757 0.986023 8.55363 1.0948 8.29982L4.09336 1.30301C4.17214 1.11917 4.35291 0.999969 4.55293 0.999969ZM4.55293 2.76929L5.75186 5.56685H3.354L4.55293 2.76929ZM11.0562 9.00214C11.2617 9.00214 11.4463 8.87633 11.5215 8.68502L14.2733 1.68299C14.3743 1.42598 14.2478 1.13575 13.9908 1.03475C13.7338 0.933747 13.4436 1.06021 13.3426 1.31722L11.0562 7.13514L8.76973 1.31722C8.66873 1.06021 8.3785 0.933747 8.1215 1.03475C7.86449 1.13575 7.73802 1.42598 7.83902 1.68299L10.5908 8.68502C10.666 8.87633 10.8506 9.00214 11.0562 9.00214ZM14.9537 12.4999C14.9537 12.606 14.9115 12.7077 14.8365 12.7828L12.8365 14.7828C12.6803 14.939 12.4271 14.939 12.2708 14.7828C12.1146 14.6265 12.1146 14.3733 12.2708 14.2171L13.588 12.8999H1.51937L2.83653 14.2171C2.99274 14.3733 2.99274 14.6265 2.83653 14.7828C2.68032 14.939 2.42705 14.939 2.27084 14.7828L0.270843 12.7828C0.195828 12.7077 0.153687 12.606 0.153687 12.4999C0.153687 12.3938 0.195828 12.2921 0.270843 12.2171L2.27084 10.2171C2.42705 10.0609 2.68032 10.0609 2.83653 10.2171C2.99274 10.3733 2.99274 10.6265 2.83653 10.7828L1.51937 12.0999L13.588 12.0999L12.2708 10.7828C12.1146 10.6265 12.1146 10.3733 12.2708 10.2171C12.4271 10.0609 12.6803 10.0609 12.8365 10.2171L14.8365 12.2171C14.9115 12.2921 14.9537 12.3938 14.9537 12.4999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2Q = [
    "color"
];
var $c12e32cf04d921d4$export$afee984ac0331725 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2R = [
    "color"
];
var $c12e32cf04d921d4$export$9b61d117ad943959 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.78233 2.21713C3.70732 2.14212 3.60557 2.09998 3.49949 2.09998C3.3934 2.09998 3.29166 2.14212 3.21664 2.21713L1.21664 4.21713C1.06044 4.37334 1.06044 4.62661 1.21664 4.78282C1.37285 4.93903 1.62612 4.93903 1.78233 4.78282L3.09949 3.46566L3.09949 11.5343L1.78233 10.2171C1.62612 10.0609 1.37285 10.0609 1.21664 10.2171C1.06043 10.3733 1.06043 10.6266 1.21664 10.7828L3.21664 12.7828C3.29166 12.8578 3.3934 12.9 3.49949 12.9C3.60557 12.9 3.70731 12.8578 3.78233 12.7828L5.78233 10.7828C5.93854 10.6266 5.93854 10.3733 5.78233 10.2171C5.62612 10.0609 5.37285 10.0609 5.21664 10.2171L3.89949 11.5343L3.89949 3.46566L5.21664 4.78282C5.37285 4.93903 5.62612 4.93903 5.78233 4.78282C5.93854 4.62661 5.93854 4.37334 5.78233 4.21713L3.78233 2.21713ZM8.49998 3.99997C8.22383 3.99997 7.99998 4.22382 7.99998 4.49997C7.99998 4.77611 8.22383 4.99997 8.49998 4.99997H14.5C14.7761 4.99997 15 4.77611 15 4.49997C15 4.22382 14.7761 3.99997 14.5 3.99997H8.49998ZM7.99998 7.49997C7.99998 7.22382 8.22383 6.99997 8.49998 6.99997H14.5C14.7761 6.99997 15 7.22382 15 7.49997C15 7.77611 14.7761 7.99997 14.5 7.99997H8.49998C8.22383 7.99997 7.99998 7.77611 7.99998 7.49997ZM8.49998 9.99997C8.22383 9.99997 7.99998 10.2238 7.99998 10.5C7.99998 10.7761 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7761 15 10.5C15 10.2238 14.7761 9.99997 14.5 9.99997H8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2S = [
    "color"
];
var $c12e32cf04d921d4$export$c99cd348175308cb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.62471 4.00001L4.56402 4.00001C4.04134 3.99993 3.70687 3.99988 3.4182 4.055C2.2379 4.28039 1.29846 5.17053 1.05815 6.33035C0.999538 6.61321 0.999604 6.93998 0.999703 7.43689L0.999711 7.50001L0.999703 7.56313C0.999604 8.06004 0.999538 8.38681 1.05815 8.66967C1.29846 9.8295 2.2379 10.7196 3.4182 10.945C3.70688 11.0001 4.04135 11.0001 4.56403 11L4.62471 11H5.49971C5.77585 11 5.99971 10.7762 5.99971 10.5C5.99971 10.2239 5.77585 10 5.49971 10H4.62471C4.02084 10 3.78907 9.99777 3.60577 9.96277C2.80262 9.8094 2.19157 9.21108 2.03735 8.46678C2.00233 8.29778 1.99971 8.08251 1.99971 7.50001C1.99971 6.91752 2.00233 6.70225 2.03735 6.53324C2.19157 5.78895 2.80262 5.19062 3.60577 5.03725C3.78907 5.00225 4.02084 5.00001 4.62471 5.00001H5.49971C5.77585 5.00001 5.99971 4.77615 5.99971 4.50001C5.99971 4.22387 5.77585 4.00001 5.49971 4.00001H4.62471ZM10.3747 5.00001C10.9786 5.00001 11.2104 5.00225 11.3937 5.03725C12.1968 5.19062 12.8079 5.78895 12.9621 6.53324C12.9971 6.70225 12.9997 6.91752 12.9997 7.50001C12.9997 8.08251 12.9971 8.29778 12.9621 8.46678C12.8079 9.21108 12.1968 9.8094 11.3937 9.96277C11.2104 9.99777 10.9786 10 10.3747 10H9.49971C9.22357 10 8.99971 10.2239 8.99971 10.5C8.99971 10.7762 9.22357 11 9.49971 11H10.3747L10.4354 11C10.9581 11.0001 11.2925 11.0001 11.5812 10.945C12.7615 10.7196 13.701 9.8295 13.9413 8.66967C13.9999 8.38681 13.9998 8.06005 13.9997 7.56314L13.9997 7.50001L13.9997 7.43688C13.9998 6.93998 13.9999 6.61321 13.9413 6.33035C13.701 5.17053 12.7615 4.28039 11.5812 4.055C11.2925 3.99988 10.9581 3.99993 10.4354 4.00001L10.3747 4.00001H9.49971C9.22357 4.00001 8.99971 4.22387 8.99971 4.50001C8.99971 4.77615 9.22357 5.00001 9.49971 5.00001H10.3747ZM5.00038 7C4.72424 7 4.50038 7.22386 4.50038 7.5C4.50038 7.77614 4.72424 8 5.00038 8H10.0004C10.2765 8 10.5004 7.77614 10.5004 7.5C10.5004 7.22386 10.2765 7 10.0004 7H5.00038Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2T = [
    "color"
];
var $c12e32cf04d921d4$export$a0f93c0a3250ca9d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2U = [
    "color"
];
var $c12e32cf04d921d4$export$c2a4804b810abd59 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L13.3536 2.35355ZM2.03735 8.46678C2.17398 9.12619 2.66918 9.67103 3.33886 9.89338L2.57833 10.6539C1.80843 10.2534 1.23784 9.53693 1.05815 8.66967C0.999538 8.38681 0.999604 8.06004 0.999703 7.56313L0.999711 7.50001L0.999703 7.43689C0.999604 6.93998 0.999538 6.61321 1.05815 6.33035C1.29846 5.17053 2.2379 4.28039 3.4182 4.055C3.70687 3.99988 4.04134 3.99993 4.56402 4.00001L4.62471 4.00001H5.49971C5.77585 4.00001 5.99971 4.22387 5.99971 4.50001C5.99971 4.77615 5.77585 5.00001 5.49971 5.00001H4.62471C4.02084 5.00001 3.78907 5.00225 3.60577 5.03725C2.80262 5.19062 2.19157 5.78895 2.03735 6.53324C2.00233 6.70225 1.99971 6.91752 1.99971 7.50001C1.99971 8.08251 2.00233 8.29778 2.03735 8.46678ZM12.9621 6.53324C12.8255 5.87397 12.3304 5.32922 11.661 5.10679L12.4215 4.34631C13.1912 4.74686 13.7616 5.46323 13.9413 6.33035C13.9999 6.61321 13.9998 6.93998 13.9997 7.43688L13.9997 7.50001L13.9997 7.56314C13.9998 8.06005 13.9999 8.38681 13.9413 8.66967C13.701 9.8295 12.7615 10.7196 11.5812 10.945C11.2925 11.0001 10.9581 11.0001 10.4354 11L10.3747 11H9.49971C9.22357 11 8.99971 10.7762 8.99971 10.5C8.99971 10.2239 9.22357 10 9.49971 10H10.3747C10.9786 10 11.2104 9.99777 11.3937 9.96277C12.1968 9.8094 12.8079 9.21108 12.9621 8.46678C12.9971 8.29778 12.9997 8.08251 12.9997 7.50001C12.9997 6.91752 12.9971 6.70225 12.9621 6.53324Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2V = [
    "color"
];
var $c12e32cf04d921d4$export$c8d5b415f7d58ebc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.50021 0C4.77635 0 5.0002 0.223853 5.0002 0.49999V2.49995C5.0002 2.77609 4.77635 2.99994 4.50021 2.99994C4.22408 2.99994 4.00022 2.77609 4.00022 2.49995V0.49999C4.00022 0.223853 4.22408 0 4.50021 0ZM0.646451 0.64647C0.84171 0.451212 1.15829 0.451212 1.35354 0.64647L2.85351 2.14644C3.04877 2.3417 3.04877 2.65827 2.85351 2.85353C2.65826 3.04879 2.34168 3.04879 2.14642 2.85353L0.646452 1.35356C0.451193 1.1583 0.451193 0.841728 0.646451 0.64647ZM0.00030517 4.49991C0.00030517 4.22377 0.224158 3.99992 0.500295 3.99992H2.50025C2.77639 3.99992 3.00024 4.22377 3.00024 4.49991C3.00024 4.77605 2.77639 4.9999 2.50025 4.9999H0.500295C0.224158 4.9999 0.00030517 4.77605 0.00030517 4.49991ZM12.0001 10.4998C12.0001 10.2236 12.2239 9.9998 12.5001 9.9998H14.5C14.7761 9.9998 15 10.2236 15 10.4998C15 10.7759 14.7761 10.9998 14.5 10.9998H12.5001C12.2239 10.9998 12.0001 10.7759 12.0001 10.4998ZM10.5001 11.9998C10.7762 11.9998 11.0001 12.2236 11.0001 12.4997V14.4997C11.0001 14.7758 10.7762 14.9997 10.5001 14.9997C10.224 14.9997 10.0001 14.7758 10.0001 14.4997V12.4997C10.0001 12.2236 10.224 11.9998 10.5001 11.9998ZM12.1462 12.1462C12.3415 11.951 12.658 11.951 12.8533 12.1462L14.3533 13.6462C14.5485 13.8415 14.5485 14.158 14.3533 14.3533C14.158 14.5485 13.8414 14.5485 13.6462 14.3533L12.1462 12.8533C11.951 12.6581 11.951 12.3415 12.1462 12.1462ZM7.76478 3.69938C8.19177 3.27238 8.35724 3.11008 8.5116 3.00522C9.18794 2.54577 10.0431 2.53677 10.6784 2.95401C10.8227 3.04875 10.9767 3.19911 11.3886 3.61099C11.8005 4.02287 11.9509 4.17694 12.0456 4.3212C12.4628 4.95653 12.4539 5.81168 11.9944 6.48802C11.8895 6.64238 11.7272 6.80785 11.3002 7.23484L10.6815 7.85354C10.4863 8.0488 10.4863 8.36538 10.6815 8.56064C10.8768 8.75589 11.1934 8.75589 11.3886 8.56064L12.0073 7.94193L12.0502 7.89903C12.4199 7.5295 12.6564 7.29303 12.8216 7.04993C13.4968 6.05598 13.5316 4.7623 12.8815 3.77228C12.7229 3.53083 12.4918 3.29982 12.1404 2.94853L12.0957 2.9039L12.0511 2.85925C11.6998 2.50782 11.4688 2.27672 11.2273 2.11816C10.2373 1.46798 8.94364 1.50284 7.94968 2.17805C7.70659 2.34319 7.47012 2.57973 7.1006 2.94936L7.1006 2.94937L7.05769 2.99228L6.43898 3.61099C6.24372 3.80625 6.24372 4.12282 6.43898 4.31808C6.63424 4.51334 6.95081 4.51334 7.14607 4.31808L7.76478 3.69938ZM2.99191 7.05807L2.94899 7.10097C2.57935 7.4705 2.34282 7.70697 2.17767 7.95006C1.50246 8.94401 1.4676 10.2377 2.11778 11.2277C2.27634 11.4692 2.50744 11.7002 2.85886 12.0515L2.85888 12.0515L2.90352 12.0961L2.94815 12.1407L2.94815 12.1407L2.94817 12.1408C3.29945 12.4922 3.53045 12.7233 3.7719 12.8818C4.76193 13.532 6.0556 13.4972 7.04956 12.8219C7.29265 12.6568 7.52912 12.4203 7.89865 12.0506L7.94155 12.0077L8.56026 11.389C8.75552 11.1937 8.75552 10.8772 8.56026 10.6819C8.365 10.4867 8.04842 10.4867 7.85317 10.6819L7.23446 11.3006C6.80747 11.7276 6.642 11.8899 6.48764 11.9948C5.8113 12.4542 4.95615 12.4632 4.32082 12.046C4.17656 11.9512 4.02249 11.8009 3.61061 11.389C3.19873 10.9771 3.04837 10.8231 2.95363 10.6788C2.53639 10.0435 2.54539 9.18832 3.00484 8.51198C3.10971 8.35761 3.27201 8.19215 3.699 7.76516L4.3177 7.14645C4.51296 6.95119 4.51296 6.63462 4.3177 6.43936C4.12245 6.2441 3.80587 6.2441 3.61061 6.43936L2.99191 7.05807Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2W = [
    "color"
];
var $c12e32cf04d921d4$export$928cb2cfdd1b2e72 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.56427 3.99988C4.58422 3.99989 4.60445 3.99989 4.62496 3.99989H5.49996C5.7761 3.99989 5.99996 4.22375 5.99996 4.49989C5.99996 4.77603 5.7761 4.99989 5.49996 4.99989H4.62496C4.02108 4.99989 3.78932 5.00213 3.60601 5.03713C2.80287 5.1905 2.19181 5.78883 2.03759 6.53312C2.00257 6.70212 1.99996 6.91739 1.99996 7.49989C1.99996 8.08239 2.00257 8.29766 2.03759 8.46666C2.19181 9.21095 2.80287 9.80928 3.60601 9.96265C3.78932 9.99765 4.02108 9.99989 4.62496 9.99989H5.49996C5.7761 9.99989 5.99996 10.2237 5.99996 10.4999C5.99996 10.776 5.7761 10.9999 5.49996 10.9999H4.62496C4.60445 10.9999 4.58422 10.9999 4.56427 10.9999C4.04159 11 3.70712 11 3.41845 10.9449C2.23814 10.7195 1.29871 9.82937 1.05839 8.66955C0.999782 8.38669 0.999848 8.05992 0.999947 7.56301C0.999951 7.54227 0.999955 7.52123 0.999955 7.49989C0.999955 7.47855 0.999951 7.45751 0.999947 7.43677C0.999848 6.93986 0.999782 6.61309 1.05839 6.33023C1.29871 5.17041 2.23814 4.28027 3.41845 4.05488C3.70712 3.99976 4.04159 3.99981 4.56427 3.99988ZM11.3939 5.03713C11.2106 5.00213 10.9788 4.99989 10.375 4.99989H9.49996C9.22381 4.99989 8.99996 4.77603 8.99996 4.49989C8.99996 4.22375 9.22381 3.99989 9.49996 3.99989H10.375C10.3955 3.99989 10.4157 3.99989 10.4356 3.99988C10.9583 3.99981 11.2928 3.99976 11.5815 4.05488C12.7618 4.28027 13.7012 5.17041 13.9415 6.33023C14.0001 6.61309 14.0001 6.93985 14 7.43676C14 7.4575 14 7.47854 14 7.49989C14 7.52124 14 7.54228 14 7.56302C14.0001 8.05992 14.0001 8.38669 13.9415 8.66955C13.7012 9.82937 12.7618 10.7195 11.5815 10.9449C11.2928 11 10.9583 11 10.4356 10.9999C10.4157 10.9999 10.3955 10.9999 10.375 10.9999H9.49996C9.22381 10.9999 8.99996 10.776 8.99996 10.4999C8.99996 10.2237 9.22381 9.99989 9.49996 9.99989H10.375C10.9788 9.99989 11.2106 9.99765 11.3939 9.96265C12.197 9.80928 12.8081 9.21095 12.9623 8.46666C12.9973 8.29766 13 8.08239 13 7.49989C13 6.91739 12.9973 6.70212 12.9623 6.53312C12.8081 5.78883 12.197 5.1905 11.3939 5.03713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2X = [
    "color"
];
var $c12e32cf04d921d4$export$36a31df0698e942 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.6788 2.95419C10.0435 2.53694 9.18829 2.54594 8.51194 3.00541C8.35757 3.11027 8.1921 3.27257 7.7651 3.69957L7.14638 4.31829C6.95112 4.51355 6.63454 4.51355 6.43928 4.31829C6.24401 4.12303 6.24401 3.80645 6.43928 3.61119L7.058 2.99247C7.0725 2.97797 7.08679 2.96366 7.1009 2.94955C7.47044 2.57991 7.70691 2.34336 7.95001 2.17822C8.94398 1.50299 10.2377 1.46813 11.2277 2.11832C11.4692 2.27689 11.7002 2.508 12.0515 2.85942C12.0662 2.8741 12.081 2.88898 12.0961 2.90408C12.1112 2.91917 12.1261 2.93405 12.1408 2.94871C12.4922 3.30001 12.7233 3.53102 12.8819 3.77248C13.5321 4.76252 13.4972 6.05623 12.822 7.0502C12.6568 7.2933 12.4203 7.52976 12.0507 7.89929C12.0366 7.9134 12.0222 7.92771 12.0077 7.94221L11.389 8.56093C11.1938 8.7562 10.8772 8.7562 10.6819 8.56093C10.4867 8.36567 10.4867 8.04909 10.6819 7.85383L11.3006 7.23511C11.7276 6.80811 11.8899 6.64264 11.9948 6.48827C12.4543 5.81192 12.4633 4.95675 12.046 4.32141C11.9513 4.17714 11.8009 4.02307 11.389 3.61119C10.9771 3.1993 10.8231 3.04893 10.6788 2.95419ZM4.31796 6.43961C4.51322 6.63487 4.51322 6.95146 4.31796 7.14672L3.69924 7.76544C3.27224 8.19244 3.10993 8.35791 3.00507 8.51227C2.54561 9.18863 2.53661 10.0438 2.95385 10.6791C3.0486 10.8234 3.19896 10.9775 3.61085 11.3894C4.02274 11.8012 4.17681 11.9516 4.32107 12.0464C4.95642 12.4636 5.81158 12.4546 6.48794 11.9951C6.6423 11.8903 6.80777 11.728 7.23477 11.301L7.85349 10.6823C8.04875 10.487 8.36533 10.487 8.5606 10.6823C8.75586 10.8775 8.75586 11.1941 8.5606 11.3894L7.94188 12.0081C7.92738 12.0226 7.91307 12.0369 7.89897 12.051C7.52943 12.4206 7.29296 12.6572 7.04986 12.8223C6.05589 13.4976 4.76219 13.5324 3.77214 12.8822C3.53068 12.7237 3.29967 12.4925 2.94837 12.1411C2.93371 12.1264 2.91883 12.1116 2.90374 12.0965C2.88865 12.0814 2.87377 12.0665 2.8591 12.0518C2.50766 11.7005 2.27656 11.4695 2.11799 11.2281C1.4678 10.238 1.50265 8.94432 2.17788 7.95035C2.34303 7.70724 2.57957 7.47077 2.94922 7.10124C2.96333 7.08713 2.97763 7.07283 2.99213 7.05833L3.61085 6.43961C3.80611 6.24435 4.12269 6.24435 4.31796 6.43961Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2Y = [
    "color"
];
var $c12e32cf04d921d4$export$8ec07838913349db = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 1C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V2C14 1.44772 13.5523 1 13 1H2ZM3.05 6H4.95V12H3.05V6ZM5.075 4.005C5.075 4.59871 4.59371 5.08 4 5.08C3.4063 5.08 2.925 4.59871 2.925 4.005C2.925 3.41129 3.4063 2.93 4 2.93C4.59371 2.93 5.075 3.41129 5.075 4.005ZM12 8.35713C12 6.55208 10.8334 5.85033 9.67449 5.85033C9.29502 5.83163 8.91721 5.91119 8.57874 6.08107C8.32172 6.21007 8.05265 6.50523 7.84516 7.01853H7.79179V6.00044H6V12.0047H7.90616V8.8112C7.8786 8.48413 7.98327 8.06142 8.19741 7.80987C8.41156 7.55832 8.71789 7.49825 8.95015 7.46774H9.02258C9.62874 7.46774 10.0786 7.84301 10.0786 8.78868V12.0047H11.9847L12 8.35713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2Z = [
    "color"
];
var $c12e32cf04d921d4$export$9b1a2d77017d0edb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 5.25C1.91421 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 1.91421 3.75 1.5 3.75C1.08579 3.75 0.75 4.08579 0.75 4.5C0.75 4.91421 1.08579 5.25 1.5 5.25ZM4 4.5C4 4.22386 4.22386 4 4.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H4.5ZM2.25 7.5C2.25 7.91421 1.91421 8.25 1.5 8.25C1.08579 8.25 0.75 7.91421 0.75 7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5ZM1.5 11.25C1.91421 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 1.91421 9.75 1.5 9.75C1.08579 9.75 0.75 10.0858 0.75 10.5C0.75 10.9142 1.08579 11.25 1.5 11.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2_ = [
    "color"
];
var $c12e32cf04d921d4$export$f53936b98653a113 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2_);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2$ = [
    "color"
];
var $c12e32cf04d921d4$export$5f7f9efc246369d3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2$);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.4986 0C6.3257 0 5.36107 0.38943 4.73753 1.19361C4.23745 1.83856 4 2.68242 4 3.63325H5C5 2.84313 5.19691 2.23312 5.5278 1.80636C5.91615 1.30552 6.55152 1 7.4986 1C8.35683 1 8.96336 1.26502 9.35846 1.68623C9.75793 2.11211 10 2.76044 10 3.63601V6H3C2.44772 6 2 6.44772 2 7V13C2 13.5523 2.44772 14 3 14H12C12.5523 14 13 13.5523 13 13V7C13 6.44771 12.5523 6 12 6H11V3.63601C11 2.58135 10.7065 1.66167 10.0878 1.0021C9.46477 0.337871 8.57061 0 7.4986 0ZM3 7H12V13H3V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$30 = [
    "color"
];
var $c12e32cf04d921d4$export$fea8b3d7473481c5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$30);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9 3.63601C9 2.76044 9.24207 2.11211 9.64154 1.68623C10.0366 1.26502 10.6432 1 11.5014 1C12.4485 1 13.0839 1.30552 13.4722 1.80636C13.8031 2.23312 14 2.84313 14 3.63325H15C15 2.68242 14.7626 1.83856 14.2625 1.19361C13.6389 0.38943 12.6743 0 11.5014 0C10.4294 0 9.53523 0.337871 8.91218 1.0021C8.29351 1.66167 8 2.58135 8 3.63601V6H1C0.447715 6 0 6.44772 0 7V13C0 13.5523 0.447715 14 1 14H10C10.5523 14 11 13.5523 11 13V7C11 6.44772 10.5523 6 10 6H9V3.63601ZM1 7H10V13H1V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$31 = [
    "color"
];
var $c12e32cf04d921d4$export$ab1b7565a980cdcc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$31);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.35355 1.85355C3.54882 1.65829 3.54882 1.34171 3.35355 1.14645C3.15829 0.951184 2.84171 0.951184 2.64645 1.14645L0.646447 3.14645C0.451184 3.34171 0.451184 3.65829 0.646447 3.85355L2.64645 5.85355C2.84171 6.04882 3.15829 6.04882 3.35355 5.85355C3.54882 5.65829 3.54882 5.34171 3.35355 5.14645L2.20711 4H9.5C11.433 4 13 5.567 13 7.5C13 7.77614 13.2239 8 13.5 8C13.7761 8 14 7.77614 14 7.5C14 5.01472 11.9853 3 9.5 3H2.20711L3.35355 1.85355ZM2 7.5C2 7.22386 1.77614 7 1.5 7C1.22386 7 1 7.22386 1 7.5C1 9.98528 3.01472 12 5.5 12H12.7929L11.6464 13.1464C11.4512 13.3417 11.4512 13.6583 11.6464 13.8536C11.8417 14.0488 12.1583 14.0488 12.3536 13.8536L14.3536 11.8536C14.5488 11.6583 14.5488 11.3417 14.3536 11.1464L12.3536 9.14645C12.1583 8.95118 11.8417 8.95118 11.6464 9.14645C11.4512 9.34171 11.4512 9.65829 11.6464 9.85355L12.7929 11H5.5C3.567 11 2 9.433 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$32 = [
    "color"
];
var $c12e32cf04d921d4$export$bd662a7321ab10c4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$32);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.9 0.499976C13.9 0.279062 13.7209 0.0999756 13.5 0.0999756C13.2791 0.0999756 13.1 0.279062 13.1 0.499976V1.09998H12.5C12.2791 1.09998 12.1 1.27906 12.1 1.49998C12.1 1.72089 12.2791 1.89998 12.5 1.89998H13.1V2.49998C13.1 2.72089 13.2791 2.89998 13.5 2.89998C13.7209 2.89998 13.9 2.72089 13.9 2.49998V1.89998H14.5C14.7209 1.89998 14.9 1.72089 14.9 1.49998C14.9 1.27906 14.7209 1.09998 14.5 1.09998H13.9V0.499976ZM11.8536 3.14642C12.0488 3.34168 12.0488 3.65826 11.8536 3.85353L10.8536 4.85353C10.6583 5.04879 10.3417 5.04879 10.1465 4.85353C9.9512 4.65827 9.9512 4.34169 10.1465 4.14642L11.1464 3.14643C11.3417 2.95116 11.6583 2.95116 11.8536 3.14642ZM9.85357 5.14642C10.0488 5.34168 10.0488 5.65827 9.85357 5.85353L2.85355 12.8535C2.65829 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L9.14646 5.14642C9.34172 4.95116 9.65831 4.95116 9.85357 5.14642ZM13.5 5.09998C13.7209 5.09998 13.9 5.27906 13.9 5.49998V6.09998H14.5C14.7209 6.09998 14.9 6.27906 14.9 6.49998C14.9 6.72089 14.7209 6.89998 14.5 6.89998H13.9V7.49998C13.9 7.72089 13.7209 7.89998 13.5 7.89998C13.2791 7.89998 13.1 7.72089 13.1 7.49998V6.89998H12.5C12.2791 6.89998 12.1 6.72089 12.1 6.49998C12.1 6.27906 12.2791 6.09998 12.5 6.09998H13.1V5.49998C13.1 5.27906 13.2791 5.09998 13.5 5.09998ZM8.90002 0.499976C8.90002 0.279062 8.72093 0.0999756 8.50002 0.0999756C8.2791 0.0999756 8.10002 0.279062 8.10002 0.499976V1.09998H7.50002C7.2791 1.09998 7.10002 1.27906 7.10002 1.49998C7.10002 1.72089 7.2791 1.89998 7.50002 1.89998H8.10002V2.49998C8.10002 2.72089 8.2791 2.89998 8.50002 2.89998C8.72093 2.89998 8.90002 2.72089 8.90002 2.49998V1.89998H9.50002C9.72093 1.89998 9.90002 1.72089 9.90002 1.49998C9.90002 1.27906 9.72093 1.09998 9.50002 1.09998H8.90002V0.499976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$33 = [
    "color"
];
var $c12e32cf04d921d4$export$f7658c347b037c3f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$33);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$34 = [
    "color"
];
var $c12e32cf04d921d4$export$fca30e52ebed3683 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$34);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.49988 2.00012C1.77602 2.00012 1.99988 1.77626 1.99988 1.50012C1.99988 1.22398 1.77602 1.00012 1.49988 1.00012C1.22374 1.00012 0.999878 1.22398 0.999878 1.50012C0.999878 1.77626 1.22374 2.00012 1.49988 2.00012ZM4.49988 2.00012C4.77602 2.00012 4.99988 1.77626 4.99988 1.50012C4.99988 1.22398 4.77602 1.00012 4.49988 1.00012C4.22374 1.00012 3.99988 1.22398 3.99988 1.50012C3.99988 1.77626 4.22374 2.00012 4.49988 2.00012ZM7.99988 1.50012C7.99988 1.77626 7.77602 2.00012 7.49988 2.00012C7.22374 2.00012 6.99988 1.77626 6.99988 1.50012C6.99988 1.22398 7.22374 1.00012 7.49988 1.00012C7.77602 1.00012 7.99988 1.22398 7.99988 1.50012ZM10.4999 2.00012C10.776 2.00012 10.9999 1.77626 10.9999 1.50012C10.9999 1.22398 10.776 1.00012 10.4999 1.00012C10.2237 1.00012 9.99988 1.22398 9.99988 1.50012C9.99988 1.77626 10.2237 2.00012 10.4999 2.00012ZM13.9999 1.50012C13.9999 1.77626 13.776 2.00012 13.4999 2.00012C13.2237 2.00012 12.9999 1.77626 12.9999 1.50012C12.9999 1.22398 13.2237 1.00012 13.4999 1.00012C13.776 1.00012 13.9999 1.22398 13.9999 1.50012ZM1.49988 14.0001C1.77602 14.0001 1.99988 13.7763 1.99988 13.5001C1.99988 13.224 1.77602 13.0001 1.49988 13.0001C1.22374 13.0001 0.999878 13.224 0.999878 13.5001C0.999878 13.7763 1.22374 14.0001 1.49988 14.0001ZM1.99988 10.5001C1.99988 10.7763 1.77602 11.0001 1.49988 11.0001C1.22374 11.0001 0.999878 10.7763 0.999878 10.5001C0.999878 10.224 1.22374 10.0001 1.49988 10.0001C1.77602 10.0001 1.99988 10.224 1.99988 10.5001ZM1.49988 8.00012C1.77602 8.00012 1.99988 7.77626 1.99988 7.50012C1.99988 7.22398 1.77602 7.00012 1.49988 7.00012C1.22374 7.00012 0.999878 7.22398 0.999878 7.50012C0.999878 7.77626 1.22374 8.00012 1.49988 8.00012ZM1.99988 4.50012C1.99988 4.77626 1.77602 5.00012 1.49988 5.00012C1.22374 5.00012 0.999878 4.77626 0.999878 4.50012C0.999878 4.22398 1.22374 4.00012 1.49988 4.00012C1.77602 4.00012 1.99988 4.22398 1.99988 4.50012ZM13.4999 11.0001C13.776 11.0001 13.9999 10.7763 13.9999 10.5001C13.9999 10.224 13.776 10.0001 13.4999 10.0001C13.2237 10.0001 12.9999 10.224 12.9999 10.5001C12.9999 10.7763 13.2237 11.0001 13.4999 11.0001ZM13.9999 7.50012C13.9999 7.77626 13.776 8.00012 13.4999 8.00012C13.2237 8.00012 12.9999 7.77626 12.9999 7.50012C12.9999 7.22398 13.2237 7.00012 13.4999 7.00012C13.776 7.00012 13.9999 7.22398 13.9999 7.50012ZM13.4999 5.00012C13.776 5.00012 13.9999 4.77626 13.9999 4.50012C13.9999 4.22398 13.776 4.00012 13.4999 4.00012C13.2237 4.00012 12.9999 4.22398 12.9999 4.50012C12.9999 4.77626 13.2237 5.00012 13.4999 5.00012ZM4.99988 13.5001C4.99988 13.7763 4.77602 14.0001 4.49988 14.0001C4.22374 14.0001 3.99988 13.7763 3.99988 13.5001C3.99988 13.224 4.22374 13.0001 4.49988 13.0001C4.77602 13.0001 4.99988 13.224 4.99988 13.5001ZM7.49988 14.0001C7.77602 14.0001 7.99988 13.7763 7.99988 13.5001C7.99988 13.224 7.77602 13.0001 7.49988 13.0001C7.22374 13.0001 6.99988 13.224 6.99988 13.5001C6.99988 13.7763 7.22374 14.0001 7.49988 14.0001ZM10.9999 13.5001C10.9999 13.7763 10.776 14.0001 10.4999 14.0001C10.2237 14.0001 9.99988 13.7763 9.99988 13.5001C9.99988 13.224 10.2237 13.0001 10.4999 13.0001C10.776 13.0001 10.9999 13.224 10.9999 13.5001ZM13.4999 14.0001C13.776 14.0001 13.9999 13.7763 13.9999 13.5001C13.9999 13.224 13.776 13.0001 13.4999 13.0001C13.2237 13.0001 12.9999 13.224 12.9999 13.5001C12.9999 13.7763 13.2237 14.0001 13.4999 14.0001ZM3.99988 5.00012C3.99988 4.44784 4.44759 4.00012 4.99988 4.00012H9.99988C10.5522 4.00012 10.9999 4.44784 10.9999 5.00012V10.0001C10.9999 10.5524 10.5522 11.0001 9.99988 11.0001H4.99988C4.44759 11.0001 3.99988 10.5524 3.99988 10.0001V5.00012ZM4.99988 5.00012H9.99988V10.0001H4.99988V5.00012Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$35 = [
    "color"
];
var $c12e32cf04d921d4$export$afa4b2f99a1f67c0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$35);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 2H14V13H1L1 2ZM0 2C0 1.44772 0.447715 1 1 1H14C14.5523 1 15 1.44772 15 2V13C15 13.5523 14.5523 14 14 14H1C0.447715 14 0 13.5523 0 13V2ZM4.875 7.5C4.875 6.05025 6.05025 4.875 7.5 4.875C8.94975 4.875 10.125 6.05025 10.125 7.5C10.125 8.94975 8.94975 10.125 7.5 10.125C6.05025 10.125 4.875 8.94975 4.875 7.5ZM7.5 3.875C5.49797 3.875 3.875 5.49797 3.875 7.5C3.875 9.50203 5.49797 11.125 7.5 11.125C9.50203 11.125 11.125 9.50203 11.125 7.5C11.125 5.49797 9.50203 3.875 7.5 3.875Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$36 = [
    "color"
];
var $c12e32cf04d921d4$export$34d98fe14bf296c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$36);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 1C0.447715 1 0 1.44772 0 2V13C0 13.5523 0.447715 14 1 14H14C14.5523 14 15 13.5523 15 13V2C15 1.44772 14.5523 1 14 1H1ZM7.5 10.625C9.22589 10.625 10.625 9.22589 10.625 7.5C10.625 5.77411 9.22589 4.375 7.5 4.375C5.77411 4.375 4.375 5.77411 4.375 7.5C4.375 9.22589 5.77411 10.625 7.5 10.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$37 = [
    "color"
];
var $c12e32cf04d921d4$export$cb808a3c41736d8e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$37);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$38 = [
    "color"
];
var $c12e32cf04d921d4$export$80cd35ac42af1413 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$38);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$39 = [
    "color"
];
var $c12e32cf04d921d4$export$7829447535316b17 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$39);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.14921 3.99996C2.14921 2.97778 2.97784 2.14915 4.00002 2.14915C5.02219 2.14915 5.85083 2.97778 5.85083 3.99996C5.85083 5.02213 5.02219 5.85077 4.00002 5.85077C2.97784 5.85077 2.14921 5.02213 2.14921 3.99996ZM4.00002 1.24915C2.48079 1.24915 1.24921 2.48073 1.24921 3.99996C1.24921 5.51919 2.48079 6.75077 4.00002 6.75077C5.51925 6.75077 6.75083 5.51919 6.75083 3.99996C6.75083 2.48073 5.51925 1.24915 4.00002 1.24915ZM5.82034 11.0001L2.49998 12.8369V9.16331L5.82034 11.0001ZM2.63883 8.21159C2.17228 7.9535 1.59998 8.29093 1.59998 8.82411V13.1761C1.59998 13.7093 2.17228 14.0467 2.63883 13.7886L6.57235 11.6126C7.05389 11.3462 7.05389 10.654 6.57235 10.3876L2.63883 8.21159ZM8.30001 9.00003C8.30001 8.61343 8.61341 8.30003 9.00001 8.30003H13C13.3866 8.30003 13.7 8.61343 13.7 9.00003V13C13.7 13.3866 13.3866 13.7 13 13.7H9.00001C8.61341 13.7 8.30001 13.3866 8.30001 13V9.00003ZM9.20001 9.20003V12.8H12.8V9.20003H9.20001ZM13.4432 2.19311C13.6189 2.01737 13.6189 1.73245 13.4432 1.55671C13.2675 1.38098 12.9826 1.38098 12.8068 1.55671L11 3.36353L9.19321 1.55674C9.01748 1.381 8.73255 1.381 8.55682 1.55674C8.38108 1.73247 8.38108 2.0174 8.55682 2.19313L10.3636 3.99992L8.55682 5.80671C8.38108 5.98245 8.38108 6.26737 8.55682 6.44311C8.73255 6.61885 9.01748 6.61885 9.19321 6.44311L11 4.63632L12.8068 6.44314C12.9826 6.61887 13.2675 6.61887 13.4432 6.44314C13.6189 6.2674 13.6189 5.98247 13.4432 5.80674L11.6364 3.99992L13.4432 2.19311Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3a = [
    "color"
];
var $c12e32cf04d921d4$export$5560e721cf131890 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3b = [
    "color"
];
var $c12e32cf04d921d4$export$8154ac77932ca099 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5L4 7C4 7.01671 4.00082 7.03323 4.00242 7.04952C2.86009 7.28022 2 8.28967 2 9.5C2 10.7103 2.86009 11.7198 4.00242 11.9505C4.00082 11.9668 4 11.9833 4 12V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V12C5 11.9833 4.99918 11.9668 4.99758 11.9505C6.1399 11.7198 7 10.7103 7 9.5C7 8.28967 6.1399 7.28022 4.99758 7.04952C4.99918 7.03323 5 7.01671 5 7L5 1.5ZM11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V3C10 3.01671 10.0008 3.03323 10.0024 3.04952C8.8601 3.28022 8 4.28967 8 5.5C8 6.71033 8.8601 7.71978 10.0024 7.95048C10.0008 7.96677 10 7.98329 10 8V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V8C11 7.98329 10.9992 7.96677 10.9976 7.95048C12.1399 7.71978 13 6.71033 13 5.5C13 4.28967 12.1399 3.28022 10.9976 3.04952C10.9992 3.03323 11 3.01671 11 3V1.5ZM4.5 8C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11C5.32843 11 6 10.3284 6 9.5C6 8.67157 5.32843 8 4.5 8ZM9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3c = [
    "color"
];
var $c12e32cf04d921d4$export$4484d2284bbfa969 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4 2.5C4 2.22386 4.22386 2 4.5 2H10.5C10.7761 2 11 2.22386 11 2.5V12.5C11 12.7761 10.7761 13 10.5 13H4.5C4.22386 13 4 12.7761 4 12.5V2.5ZM4.5 1C3.67157 1 3 1.67157 3 2.5V12.5C3 13.3284 3.67157 14 4.5 14H10.5C11.3284 14 12 13.3284 12 12.5V2.5C12 1.67157 11.3284 1 10.5 1H4.5ZM6 11.65C5.8067 11.65 5.65 11.8067 5.65 12C5.65 12.1933 5.8067 12.35 6 12.35H9C9.1933 12.35 9.35 12.1933 9.35 12C9.35 11.8067 9.1933 11.65 9 11.65H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3d = [
    "color"
];
var $c12e32cf04d921d4$export$a2a3256d1cc3a69a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.25925 3.16667L4.37036 5.33333V1L7.25925 3.16667ZM1 8.22222L3.88889 6.05555L1 3.88889V8.22222ZM1 14L3.88889 11.8333L1 9.66666V14ZM7.74072 8.22222L10.6296 6.05555L7.74072 3.88889V8.22222ZM14 3.16667L11.1111 5.33333V1L14 3.16667ZM11.1111 11.1111L14 8.94444L11.1111 6.77777V11.1111ZM3.88889 11.1111L1 8.94444L3.88889 6.77777V11.1111ZM4.37036 6.05555L7.25925 8.22222V3.88889L4.37036 6.05555ZM3.88889 5.33333L1 3.16667L3.88889 1V5.33333ZM7.74072 3.16667L10.6296 5.33333V1L7.74072 3.16667ZM14 8.22222L11.1111 6.05555L14 3.88889V8.22222ZM11.1111 11.8333L14 14V9.66666L11.1111 11.8333Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3e = [
    "color"
];
var $c12e32cf04d921d4$export$41051b6be05d5fb0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.89998 0.499976C2.89998 0.279062 2.72089 0.0999756 2.49998 0.0999756C2.27906 0.0999756 2.09998 0.279062 2.09998 0.499976V1.09998H1.49998C1.27906 1.09998 1.09998 1.27906 1.09998 1.49998C1.09998 1.72089 1.27906 1.89998 1.49998 1.89998H2.09998V2.49998C2.09998 2.72089 2.27906 2.89998 2.49998 2.89998C2.72089 2.89998 2.89998 2.72089 2.89998 2.49998V1.89998H3.49998C3.72089 1.89998 3.89998 1.72089 3.89998 1.49998C3.89998 1.27906 3.72089 1.09998 3.49998 1.09998H2.89998V0.499976ZM5.89998 3.49998C5.89998 3.27906 5.72089 3.09998 5.49998 3.09998C5.27906 3.09998 5.09998 3.27906 5.09998 3.49998V4.09998H4.49998C4.27906 4.09998 4.09998 4.27906 4.09998 4.49998C4.09998 4.72089 4.27906 4.89998 4.49998 4.89998H5.09998V5.49998C5.09998 5.72089 5.27906 5.89998 5.49998 5.89998C5.72089 5.89998 5.89998 5.72089 5.89998 5.49998V4.89998H6.49998C6.72089 4.89998 6.89998 4.72089 6.89998 4.49998C6.89998 4.27906 6.72089 4.09998 6.49998 4.09998H5.89998V3.49998ZM1.89998 6.49998C1.89998 6.27906 1.72089 6.09998 1.49998 6.09998C1.27906 6.09998 1.09998 6.27906 1.09998 6.49998V7.09998H0.499976C0.279062 7.09998 0.0999756 7.27906 0.0999756 7.49998C0.0999756 7.72089 0.279062 7.89998 0.499976 7.89998H1.09998V8.49998C1.09998 8.72089 1.27906 8.89997 1.49998 8.89997C1.72089 8.89997 1.89998 8.72089 1.89998 8.49998V7.89998H2.49998C2.72089 7.89998 2.89998 7.72089 2.89998 7.49998C2.89998 7.27906 2.72089 7.09998 2.49998 7.09998H1.89998V6.49998ZM8.54406 0.98184L8.24618 0.941586C8.03275 0.917676 7.90692 1.1655 8.02936 1.34194C8.17013 1.54479 8.29981 1.75592 8.41754 1.97445C8.91878 2.90485 9.20322 3.96932 9.20322 5.10022C9.20322 8.37201 6.82247 11.0878 3.69887 11.6097C3.45736 11.65 3.20988 11.6772 2.96008 11.6906C2.74563 11.702 2.62729 11.9535 2.77721 12.1072C2.84551 12.1773 2.91535 12.2458 2.98667 12.3128L3.05883 12.3795L3.31883 12.6045L3.50684 12.7532L3.62796 12.8433L3.81491 12.9742L3.99079 13.089C4.11175 13.1651 4.23536 13.2375 4.36157 13.3059L4.62496 13.4412L4.88553 13.5607L5.18837 13.6828L5.43169 13.7686C5.56564 13.8128 5.70149 13.8529 5.83857 13.8885C5.94262 13.9155 6.04767 13.9401 6.15405 13.9622C6.27993 13.9883 6.40713 14.0109 6.53544 14.0298L6.85241 14.0685L7.11934 14.0892C7.24637 14.0965 7.37436 14.1002 7.50322 14.1002C11.1483 14.1002 14.1032 11.1453 14.1032 7.50023C14.1032 7.25044 14.0893 7.00389 14.0623 6.76131L14.0255 6.48407C13.991 6.26083 13.9453 6.04129 13.8891 5.82642C13.8213 5.56709 13.7382 5.31398 13.6409 5.06881L13.5279 4.80132L13.4507 4.63542L13.3766 4.48666C13.2178 4.17773 13.0353 3.88295 12.8312 3.60423L12.6782 3.40352L12.4793 3.16432L12.3157 2.98361L12.1961 2.85951L12.0355 2.70246L11.8134 2.50184L11.4925 2.24191L11.2483 2.06498L10.9562 1.87446L10.6346 1.68894L10.3073 1.52378L10.1938 1.47176L9.95488 1.3706L9.67791 1.2669L9.42566 1.1846L9.10075 1.09489L8.83599 1.03486L8.54406 0.98184ZM10.4032 5.30023C10.4032 4.27588 10.2002 3.29829 9.83244 2.40604C11.7623 3.28995 13.1032 5.23862 13.1032 7.50023C13.1032 10.593 10.596 13.1002 7.50322 13.1002C6.63646 13.1002 5.81597 12.9036 5.08355 12.5522C6.5419 12.0941 7.81081 11.2082 8.74322 10.0416C8.87963 10.2284 9.10028 10.3497 9.34928 10.3497C9.76349 10.3497 10.0993 10.0139 10.0993 9.59971C10.0993 9.24256 9.84965 8.94373 9.51535 8.86816C9.57741 8.75165 9.63653 8.63334 9.6926 8.51332C9.88358 8.63163 10.1088 8.69993 10.35 8.69993C11.0403 8.69993 11.6 8.14028 11.6 7.44993C11.6 6.75976 11.0406 6.20024 10.3505 6.19993C10.3853 5.90487 10.4032 5.60464 10.4032 5.30023Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3f = [
    "color"
];
var $c12e32cf04d921d4$export$3e0409b11e4da6d2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.81819 0.93179C7.64245 0.756054 7.35753 0.756054 7.18179 0.93179L5.43179 2.68179C5.25605 2.85753 5.25605 3.14245 5.43179 3.31819C5.60753 3.49392 5.89245 3.49392 6.06819 3.31819L6.99999 2.38638V5.49999C6.99999 5.77613 7.22385 5.99999 7.49999 5.99999C7.77613 5.99999 7.99999 5.77613 7.99999 5.49999V2.38638L8.93179 3.31819C9.10753 3.49392 9.39245 3.49392 9.56819 3.31819C9.74392 3.14245 9.74392 2.85753 9.56819 2.68179L7.81819 0.93179ZM7.99999 9.49999C7.99999 9.22385 7.77613 8.99999 7.49999 8.99999C7.22385 8.99999 6.99999 9.22385 6.99999 9.49999V12.6136L6.06819 11.6818C5.89245 11.5061 5.60753 11.5061 5.43179 11.6818C5.25605 11.8575 5.25605 12.1424 5.43179 12.3182L7.18179 14.0682C7.35753 14.2439 7.64245 14.2439 7.81819 14.0682L9.56819 12.3182C9.74392 12.1424 9.74392 11.8575 9.56819 11.6818C9.39245 11.5061 9.10753 11.5061 8.93179 11.6818L7.99999 12.6136V9.49999ZM8.99999 7.49999C8.99999 7.22385 9.22385 6.99999 9.49999 6.99999H12.6136L11.6818 6.06819C11.5061 5.89245 11.5061 5.60753 11.6818 5.43179C11.8575 5.25605 12.1424 5.25605 12.3182 5.43179L14.0682 7.18179C14.2439 7.35753 14.2439 7.64245 14.0682 7.81819L12.3182 9.56819C12.1424 9.74392 11.8575 9.74392 11.6818 9.56819C11.5061 9.39245 11.5061 9.10753 11.6818 8.93179L12.6136 7.99999H9.49999C9.22385 7.99999 8.99999 7.77613 8.99999 7.49999ZM3.31819 6.06819L2.38638 6.99999H5.49999C5.77613 6.99999 5.99999 7.22385 5.99999 7.49999C5.99999 7.77613 5.77613 7.99999 5.49999 7.99999H2.38638L3.31819 8.93179C3.49392 9.10753 3.49392 9.39245 3.31819 9.56819C3.14245 9.74392 2.85753 9.74392 2.68179 9.56819L0.93179 7.81819C0.756054 7.64245 0.756054 7.35753 0.93179 7.18179L2.68179 5.43179C2.85753 5.25605 3.14245 5.25605 3.31819 5.43179C3.49392 5.60753 3.49392 5.89245 3.31819 6.06819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3g = [
    "color"
];
var $c12e32cf04d921d4$export$f8668531034d5b61 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.25781 3.11684C3.67771 3.45796 3.83523 3.43193 4.62369 3.37933L12.0571 2.93299C12.2147 2.93299 12.0836 2.77571 12.0311 2.74957L10.7965 1.85711C10.56 1.67347 10.2448 1.46315 9.64083 1.51576L2.44308 2.04074C2.18059 2.06677 2.12815 2.19801 2.2327 2.30322L3.25781 3.11684ZM3.7041 4.84917V12.6704C3.7041 13.0907 3.91415 13.248 4.38693 13.222L12.5562 12.7493C13.0292 12.7233 13.0819 12.4341 13.0819 12.0927V4.32397C13.0819 3.98306 12.9508 3.79921 12.6612 3.82545L4.12422 4.32397C3.80918 4.35044 3.7041 4.50803 3.7041 4.84917ZM11.7688 5.26872C11.8212 5.50518 11.7688 5.74142 11.5319 5.76799L11.1383 5.84641V11.6205C10.7965 11.8042 10.4814 11.9092 10.2188 11.9092C9.79835 11.9092 9.69305 11.7779 9.37812 11.3844L6.80345 7.34249V11.2532L7.61816 11.437C7.61816 11.437 7.61816 11.9092 6.96086 11.9092L5.14879 12.0143C5.09615 11.9092 5.14879 11.647 5.33259 11.5944L5.80546 11.4634V6.29276L5.1489 6.24015C5.09625 6.00369 5.22739 5.66278 5.5954 5.63631L7.53935 5.50528L10.2188 9.5998V5.97765L9.53564 5.89924C9.4832 5.61018 9.69305 5.40028 9.95576 5.37425L11.7688 5.26872ZM1.83874 1.33212L9.32557 0.780787C10.245 0.701932 10.4815 0.754753 11.0594 1.17452L13.4492 2.85424C13.8436 3.14309 13.975 3.22173 13.975 3.53661V12.7493C13.975 13.3266 13.7647 13.6681 13.0293 13.7203L4.33492 14.2454C3.78291 14.2717 3.52019 14.193 3.23111 13.8253L1.47116 11.5419C1.1558 11.1216 1.02466 10.8071 1.02466 10.4392V2.25041C1.02466 1.77825 1.23504 1.38441 1.83874 1.33212Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$3h = [
    "color"
];
var $c12e32cf04d921d4$export$8af0311c2e327563 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 1.5C4.5 4.25 3 6.5 3 9C3 11.4853 5.01472 13.5 7.5 13.5C9.98528 13.5 12 11.4853 12 9C12 6.5 10.5 4.25 7.5 1.5ZM11 9C11 7.11203 9.97315 5.27195 7.5 2.87357C5.02686 5.27195 4 7.11203 4 9C4 10.933 5.567 12.5 7.5 12.5C9.433 12.5 11 10.933 11 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3i = [
    "color"
];
var $c12e32cf04d921d4$export$31dd750d53ed8eca = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$3j = [
    "color"
];
var $c12e32cf04d921d4$export$cc1d3fa780ad61dc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.49985 1.10001C3.27894 1.10001 3.09985 1.27909 3.09985 1.50001C3.09985 1.72092 3.27894 1.90001 3.49985 1.90001H11.4999C11.7208 1.90001 11.8999 1.72092 11.8999 1.50001C11.8999 1.27909 11.7208 1.10001 11.4999 1.10001H3.49985ZM4.99995 4.25001C4.99995 3.97387 4.77609 3.75001 4.49995 3.75001C4.22381 3.75001 3.99995 3.97387 3.99995 4.25001V9.55001C3.99995 11.483 5.56695 13.05 7.49995 13.05C9.43295 13.05 11 11.483 11 9.55001V4.25001C11 3.97387 10.7761 3.75001 10.5 3.75001C10.2238 3.75001 9.99995 3.97387 9.99995 4.25001V9.55001C9.99995 10.9307 8.88066 12.05 7.49995 12.05C6.11924 12.05 4.99995 10.9307 4.99995 9.55001V4.25001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3k = [
    "color"
];
var $c12e32cf04d921d4$export$2ff5a181c2f67fef = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.85714 2H12.1429C12.6162 2 13 2.38376 13 2.85714V12.1429C13 12.6162 12.6162 13 12.1429 13H2.85714C2.38376 13 2 12.6162 2 12.1429V2.85714C2 2.38376 2.38376 2 2.85714 2ZM1 2.85714C1 1.83147 1.83147 1 2.85714 1H12.1429C13.1685 1 14 1.83147 14 2.85714V12.1429C14 13.1685 13.1685 14 12.1429 14H2.85714C1.83147 14 1 13.1685 1 12.1429V2.85714ZM7.49988 5.00012C7.77602 5.00012 7.99988 4.77626 7.99988 4.50012C7.99988 4.22398 7.77602 4.00012 7.49988 4.00012C7.22374 4.00012 6.99988 4.22398 6.99988 4.50012C6.99988 4.77626 7.22374 5.00012 7.49988 5.00012ZM4.49988 11.0001C4.77602 11.0001 4.99988 10.7763 4.99988 10.5001C4.99988 10.224 4.77602 10.0001 4.49988 10.0001C4.22374 10.0001 3.99988 10.224 3.99988 10.5001C3.99988 10.7763 4.22374 11.0001 4.49988 11.0001ZM4.99988 7.50012C4.99988 7.77626 4.77602 8.00012 4.49988 8.00012C4.22374 8.00012 3.99988 7.77626 3.99988 7.50012C3.99988 7.22398 4.22374 7.00012 4.49988 7.00012C4.77602 7.00012 4.99988 7.22398 4.99988 7.50012ZM4.49988 5.00012C4.77602 5.00012 4.99988 4.77626 4.99988 4.50012C4.99988 4.22398 4.77602 4.00012 4.49988 4.00012C4.22374 4.00012 3.99988 4.22398 3.99988 4.50012C3.99988 4.77626 4.22374 5.00012 4.49988 5.00012ZM10.9999 10.5001C10.9999 10.7763 10.776 11.0001 10.4999 11.0001C10.2237 11.0001 9.99988 10.7763 9.99988 10.5001C9.99988 10.224 10.2237 10.0001 10.4999 10.0001C10.776 10.0001 10.9999 10.224 10.9999 10.5001ZM10.4999 8.00012C10.776 8.00012 10.9999 7.77626 10.9999 7.50012C10.9999 7.22398 10.776 7.00012 10.4999 7.00012C10.2237 7.00012 9.99988 7.22398 9.99988 7.50012C9.99988 7.77626 10.2237 8.00012 10.4999 8.00012ZM10.9999 4.50012C10.9999 4.77626 10.776 5.00012 10.4999 5.00012C10.2237 5.00012 9.99988 4.77626 9.99988 4.50012C9.99988 4.22398 10.2237 4.00012 10.4999 4.00012C10.776 4.00012 10.9999 4.22398 10.9999 4.50012ZM7.49988 11.0001C7.77602 11.0001 7.99988 10.7763 7.99988 10.5001C7.99988 10.224 7.77602 10.0001 7.49988 10.0001C7.22374 10.0001 6.99988 10.224 6.99988 10.5001C6.99988 10.7763 7.22374 11.0001 7.49988 11.0001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3l = [
    "color"
];
var $c12e32cf04d921d4$export$7e727ef41af0217d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.20308 1.04312C1.00481 0.954998 0.772341 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568117 1.75196L3.92115 7.50002L0.568117 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.772341 13.9952 1.00481 14.045 1.20308 13.9569L14.7031 7.95693C14.8836 7.87668 15 7.69762 15 7.50002C15 7.30243 14.8836 7.12337 14.7031 7.04312L1.20308 1.04312ZM4.84553 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22092 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22092 7.10002 9 7.10002H4.84553Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3m = [
    "color"
];
var $c12e32cf04d921d4$export$9b47433640e5db3a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3n = [
    "color"
];
var $c12e32cf04d921d4$export$41c6eabacaa37313 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1465 1.14645L3.71455 8.57836C3.62459 8.66832 3.55263 8.77461 3.50251 8.89155L2.04044 12.303C1.9599 12.491 2.00189 12.709 2.14646 12.8536C2.29103 12.9981 2.50905 13.0401 2.69697 12.9596L6.10847 11.4975C6.2254 11.4474 6.3317 11.3754 6.42166 11.2855L13.8536 3.85355C14.0488 3.65829 14.0488 3.34171 13.8536 3.14645L11.8536 1.14645ZM4.42166 9.28547L11.5 2.20711L12.7929 3.5L5.71455 10.5784L4.21924 11.2192L3.78081 10.7808L4.42166 9.28547Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3o = [
    "color"
];
var $c12e32cf04d921d4$export$bedf874c76d8ae34 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.1464 1.14645C12.3417 0.951184 12.6583 0.951184 12.8535 1.14645L14.8535 3.14645C15.0488 3.34171 15.0488 3.65829 14.8535 3.85355L10.9109 7.79618C10.8349 7.87218 10.7471 7.93543 10.651 7.9835L6.72359 9.94721C6.53109 10.0435 6.29861 10.0057 6.14643 9.85355C5.99425 9.70137 5.95652 9.46889 6.05277 9.27639L8.01648 5.34897C8.06455 5.25283 8.1278 5.16507 8.2038 5.08907L12.1464 1.14645ZM12.5 2.20711L8.91091 5.79618L7.87266 7.87267L8.12731 8.12732L10.2038 7.08907L13.7929 3.5L12.5 2.20711ZM9.99998 2L8.99998 3H4.9C4.47171 3 4.18056 3.00039 3.95552 3.01877C3.73631 3.03668 3.62421 3.06915 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3.06915 3.62421 3.03669 3.73631 3.01878 3.95552C3.00039 4.18056 3 4.47171 3 4.9V11.1C3 11.5283 3.00039 11.8194 3.01878 12.0445C3.03669 12.2637 3.06915 12.3758 3.10899 12.454C3.20487 12.6422 3.35785 12.7951 3.54601 12.891C3.62421 12.9309 3.73631 12.9633 3.95552 12.9812C4.18056 12.9996 4.47171 13 4.9 13H11.1C11.5283 13 11.8194 12.9996 12.0445 12.9812C12.2637 12.9633 12.3758 12.9309 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C12.9309 12.3758 12.9633 12.2637 12.9812 12.0445C12.9996 11.8194 13 11.5283 13 11.1V6.99998L14 5.99998V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H4.9H4.87934C4.47686 14 4.14468 14 3.87409 13.9779C3.59304 13.9549 3.33469 13.9057 3.09202 13.782C2.7157 13.5903 2.40973 13.2843 2.21799 12.908C2.09434 12.6653 2.04506 12.407 2.0221 12.1259C1.99999 11.8553 1.99999 11.5231 2 11.1207V11.1206V11.1V4.9V4.87935V4.87932V4.87931C1.99999 4.47685 1.99999 4.14468 2.0221 3.87409C2.04506 3.59304 2.09434 3.33469 2.21799 3.09202C2.40973 2.71569 2.7157 2.40973 3.09202 2.21799C3.33469 2.09434 3.59304 2.04506 3.87409 2.0221C4.14468 1.99999 4.47685 1.99999 4.87932 2H4.87935H4.9H9.99998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3p = [
    "color"
];
var $c12e32cf04d921d4$export$7dcc8f518762622d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3q = [
    "color"
];
var $c12e32cf04d921d4$export$b86b18d4ddcc0181 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.85001 7.50043C1.85001 4.37975 4.37963 1.85001 7.50001 1.85001C10.6204 1.85001 13.15 4.37975 13.15 7.50043C13.15 10.6211 10.6204 13.1509 7.50001 13.1509C4.37963 13.1509 1.85001 10.6211 1.85001 7.50043ZM7.50001 0.850006C3.82728 0.850006 0.850006 3.82753 0.850006 7.50043C0.850006 11.1733 3.82728 14.1509 7.50001 14.1509C11.1727 14.1509 14.15 11.1733 14.15 7.50043C14.15 3.82753 11.1727 0.850006 7.50001 0.850006ZM7.00001 8.00001V3.12811C7.16411 3.10954 7.33094 3.10001 7.50001 3.10001C9.93006 3.10001 11.9 5.07014 11.9 7.50043C11.9 7.66935 11.8905 7.83604 11.872 8.00001H7.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3r = [
    "color"
];
var $c12e32cf04d921d4$export$d5d0c446063e1490 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 5.5C3 7.983 4.99169 9 7 9V12.5C7 12.7761 7.22386 13 7.5 13C7.77614 13 8 12.7761 8 12.5V9V3.1H9V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V3.1H11.5C11.8038 3.1 12.05 2.85376 12.05 2.55C12.05 2.24624 11.8038 2 11.5 2H9.5H8H7.5H7C4.99169 2 3 3.017 3 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3s = [
    "color"
];
var $c12e32cf04d921d4$export$f65249e0566edf55 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.5 13.95C13.7485 13.95 13.95 13.7485 13.95 13.5C13.95 13.2514 13.7485 13.05 13.5 13.05L1.49995 13.05C1.25142 13.05 1.04995 13.2514 1.04995 13.5C1.04995 13.7485 1.25142 13.95 1.49995 13.95L13.5 13.95ZM11.0681 7.5683C11.2439 7.39257 11.2439 7.10764 11.0681 6.93191C10.8924 6.75617 10.6075 6.75617 10.4317 6.93191L7.94993 9.41371L7.94993 1.49998C7.94993 1.25146 7.74846 1.04998 7.49993 1.04998C7.2514 1.04998 7.04993 1.25146 7.04993 1.49998L7.04993 9.41371L4.56813 6.93191C4.39239 6.75617 4.10746 6.75617 3.93173 6.93191C3.75599 7.10764 3.75599 7.39257 3.93173 7.5683L7.18173 10.8183C7.35746 10.994 7.64239 10.994 7.81812 10.8183L11.0681 7.5683Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3t = [
    "color"
];
var $c12e32cf04d921d4$export$d57f0cfd6aca7ffa = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.05005 13.5C2.05005 13.7485 2.25152 13.95 2.50005 13.95C2.74858 13.95 2.95005 13.7485 2.95005 13.5L2.95005 1.49995C2.95005 1.25142 2.74858 1.04995 2.50005 1.04995C2.25152 1.04995 2.05005 1.25142 2.05005 1.49995L2.05005 13.5ZM8.4317 11.0681C8.60743 11.2439 8.89236 11.2439 9.06809 11.0681C9.24383 10.8924 9.24383 10.6075 9.06809 10.4317L6.58629 7.94993L14.5 7.94993C14.7485 7.94993 14.95 7.74846 14.95 7.49993C14.95 7.2514 14.7485 7.04993 14.5 7.04993L6.58629 7.04993L9.06809 4.56813C9.24383 4.39239 9.24383 4.10746 9.06809 3.93173C8.89236 3.75599 8.60743 3.75599 8.4317 3.93173L5.1817 7.18173C5.00596 7.35746 5.00596 7.64239 5.1817 7.81812L8.4317 11.0681Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3u = [
    "color"
];
var $c12e32cf04d921d4$export$fe9311722b59190b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.95 1.50005C12.95 1.25152 12.7485 1.05005 12.5 1.05005C12.2514 1.05005 12.05 1.25152 12.05 1.50005L12.05 13.5C12.05 13.7486 12.2514 13.95 12.5 13.95C12.7485 13.95 12.95 13.7486 12.95 13.5L12.95 1.50005ZM6.5683 3.93188C6.39257 3.75614 6.10764 3.75614 5.93191 3.93188C5.75617 4.10761 5.75617 4.39254 5.93191 4.56827L8.41371 7.05007L0.499984 7.05007C0.251456 7.05007 0.0499847 7.25155 0.0499847 7.50007C0.0499846 7.7486 0.251457 7.95007 0.499984 7.95007L8.41371 7.95007L5.93191 10.4319C5.75617 10.6076 5.75617 10.8925 5.93191 11.0683C6.10764 11.244 6.39257 11.244 6.56831 11.0683L9.8183 7.81827C9.99404 7.64254 9.99404 7.35761 9.8183 7.18188L6.5683 3.93188Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3v = [
    "color"
];
var $c12e32cf04d921d4$export$71e4148884d34eff = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.50005 1.05005C1.25152 1.05005 1.05005 1.25152 1.05005 1.50005C1.05005 1.74858 1.25152 1.95005 1.50005 1.95005L13.5 1.95005C13.7486 1.95005 13.95 1.74858 13.95 1.50005C13.95 1.25152 13.7486 1.05005 13.5 1.05005H1.50005ZM3.93188 7.43169C3.75614 7.60743 3.75614 7.89236 3.93188 8.06809C4.10761 8.24383 4.39254 8.24383 4.56827 8.06809L7.05007 5.58629V13.5C7.05007 13.7485 7.25155 13.95 7.50007 13.95C7.7486 13.95 7.95007 13.7485 7.95007 13.5L7.95007 5.58629L10.4319 8.06809C10.6076 8.24383 10.8925 8.24383 11.0683 8.06809C11.244 7.89235 11.244 7.60743 11.0683 7.43169L7.81827 4.18169C7.64254 4.00596 7.35761 4.00596 7.18188 4.18169L3.93188 7.43169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3w = [
    "color"
];
var $c12e32cf04d921d4$export$a6630b90defda83f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.24182 2.32181C3.3919 2.23132 3.5784 2.22601 3.73338 2.30781L12.7334 7.05781C12.8974 7.14436 13 7.31457 13 7.5C13 7.68543 12.8974 7.85564 12.7334 7.94219L3.73338 12.6922C3.5784 12.774 3.3919 12.7687 3.24182 12.6782C3.09175 12.5877 3 12.4252 3 12.25V2.75C3 2.57476 3.09175 2.4123 3.24182 2.32181ZM4 3.57925V11.4207L11.4288 7.5L4 3.57925Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3x = [
    "color"
];
var $c12e32cf04d921d4$export$f21ab0717a89c77f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3y = [
    "color"
];
var $c12e32cf04d921d4$export$75a23c9e49a976a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM7.50003 4C7.77617 4 8.00003 4.22386 8.00003 4.5V7H10.5C10.7762 7 11 7.22386 11 7.5C11 7.77614 10.7762 8 10.5 8H8.00003V10.5C8.00003 10.7761 7.77617 11 7.50003 11C7.22389 11 7.00003 10.7761 7.00003 10.5V8H4.50003C4.22389 8 4.00003 7.77614 4.00003 7.5C4.00003 7.22386 4.22389 7 4.50003 7H7.00003V4.5C7.00003 4.22386 7.22389 4 7.50003 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3z = [
    "color"
];
var $c12e32cf04d921d4$export$58a334b597cee6d6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3A = [
    "color"
];
var $c12e32cf04d921d4$export$2548f56a2855ec74 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3B = [
    "color"
];
var $c12e32cf04d921d4$export$62bd98fc131b5caa = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3C = [
    "color"
];
var $c12e32cf04d921d4$export$c617f5f26da0904b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 11.1575 3.84216 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1575 0.877045 7.49985 0.877045ZM1.82701 7.49988C1.82701 4.36686 4.36683 1.82704 7.49985 1.82704C10.6328 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6328 13.1727 7.49985 13.1727C4.36683 13.1727 1.82701 10.6329 1.82701 7.49988ZM7.49999 9.49999C8.60456 9.49999 9.49999 8.60456 9.49999 7.49999C9.49999 6.39542 8.60456 5.49999 7.49999 5.49999C6.39542 5.49999 5.49999 6.39542 5.49999 7.49999C5.49999 8.60456 6.39542 9.49999 7.49999 9.49999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3D = [
    "color"
];
var $c12e32cf04d921d4$export$b6cede2da0e4d831 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3E = [
    "color"
];
var $c12e32cf04d921d4$export$ca36f1a1d2d1ca14 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3F = [
    "color"
];
var $c12e32cf04d921d4$export$7637ad60dd86d3b1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3G = [
    "color"
];
var $c12e32cf04d921d4$export$199745d7f18c0761 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.04995 2.74995C3.04995 2.44619 2.80371 2.19995 2.49995 2.19995C2.19619 2.19995 1.94995 2.44619 1.94995 2.74995V12.25C1.94995 12.5537 2.19619 12.8 2.49995 12.8C2.80371 12.8 3.04995 12.5537 3.04995 12.25V2.74995ZM5.73333 2.30776C5.57835 2.22596 5.39185 2.23127 5.24177 2.32176C5.0917 2.41225 4.99995 2.57471 4.99995 2.74995V12.25C4.99995 12.4252 5.0917 12.5877 5.24177 12.6781C5.39185 12.7686 5.57835 12.7739 5.73333 12.6921L14.7333 7.94214C14.8973 7.85559 15 7.68539 15 7.49995C15 7.31452 14.8973 7.14431 14.7333 7.05776L5.73333 2.30776ZM5.99995 11.4207V3.5792L13.4287 7.49995L5.99995 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3H = [
    "color"
];
var $c12e32cf04d921d4$export$8e0d2500d5bd92ef = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.85357 3.85355L7.65355 3.05353C8.2981 2.40901 9.42858 1.96172 10.552 1.80125C11.1056 1.72217 11.6291 1.71725 12.0564 1.78124C12.4987 1.84748 12.7698 1.97696 12.8965 2.10357C13.0231 2.23018 13.1526 2.50125 13.2188 2.94357C13.2828 3.37086 13.2779 3.89439 13.1988 4.44801C13.0383 5.57139 12.591 6.70188 11.9464 7.34645L7.49999 11.7929L6.35354 10.6465C6.15827 10.4512 5.84169 10.4512 5.64643 10.6465C5.45117 10.8417 5.45117 11.1583 5.64643 11.3536L7.14644 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L8.40073 12.3064L9.57124 14.2572C9.65046 14.3893 9.78608 14.4774 9.9389 14.4963C10.0917 14.5151 10.2447 14.4624 10.3535 14.3536L12.3535 12.3536C12.4648 12.2423 12.5172 12.0851 12.495 11.9293L12.0303 8.67679L12.6536 8.05355C13.509 7.19808 14.0117 5.82855 14.1887 4.58943C14.2784 3.9618 14.2891 3.33847 14.2078 2.79546C14.1287 2.26748 13.9519 1.74482 13.6035 1.39645C13.2552 1.04809 12.7325 0.871332 12.2045 0.792264C11.6615 0.710945 11.0382 0.721644 10.4105 0.8113C9.17143 0.988306 7.80189 1.491 6.94644 2.34642L6.32322 2.96968L3.07071 2.50504C2.91492 2.48278 2.75773 2.53517 2.64645 2.64646L0.646451 4.64645C0.537579 4.75533 0.484938 4.90829 0.50375 5.0611C0.522563 5.21391 0.61073 5.34954 0.742757 5.42876L2.69364 6.59928L2.14646 7.14645C2.0527 7.24022 2.00002 7.3674 2.00002 7.50001C2.00002 7.63261 2.0527 7.75979 2.14646 7.85356L3.64647 9.35356C3.84173 9.54883 4.15831 9.54883 4.35357 9.35356C4.54884 9.1583 4.54884 8.84172 4.35357 8.64646L3.20712 7.50001L3.85357 6.85356L6.85357 3.85355ZM10.0993 13.1936L9.12959 11.5775L11.1464 9.56067L11.4697 11.8232L10.0993 13.1936ZM3.42251 5.87041L5.43935 3.85356L3.17678 3.53034L1.80638 4.90074L3.42251 5.87041ZM2.35356 10.3535C2.54882 10.1583 2.54882 9.8417 2.35356 9.64644C2.1583 9.45118 1.84171 9.45118 1.64645 9.64644L0.646451 10.6464C0.451188 10.8417 0.451188 11.1583 0.646451 11.3535C0.841713 11.5488 1.1583 11.5488 1.35356 11.3535L2.35356 10.3535ZM3.85358 11.8536C4.04884 11.6583 4.04885 11.3417 3.85359 11.1465C3.65833 10.9512 3.34175 10.9512 3.14648 11.1465L1.14645 13.1464C0.95119 13.3417 0.951187 13.6583 1.14645 13.8535C1.34171 14.0488 1.65829 14.0488 1.85355 13.8536L3.85358 11.8536ZM5.35356 13.3535C5.54882 13.1583 5.54882 12.8417 5.35356 12.6464C5.1583 12.4512 4.84171 12.4512 4.64645 12.6464L3.64645 13.6464C3.45119 13.8417 3.45119 14.1583 3.64645 14.3535C3.84171 14.5488 4.1583 14.5488 4.35356 14.3535L5.35356 13.3535ZM9.49997 6.74881C10.1897 6.74881 10.7488 6.1897 10.7488 5.5C10.7488 4.8103 10.1897 4.25118 9.49997 4.25118C8.81026 4.25118 8.25115 4.8103 8.25115 5.5C8.25115 6.1897 8.81026 6.74881 9.49997 6.74881Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3I = [
    "color"
];
var $c12e32cf04d921d4$export$f0960ce3e1a6f234 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.59664 2.93628C7.76085 3.06401 8.00012 2.94698 8.00012 2.73895V1.99998C9.98143 2 11.1848 2.3637 11.9105 3.08945C12.6363 3.81522 13 5.0186 13 6.99998C13 7.27613 13.2239 7.49998 13.5 7.49998C13.7761 7.49998 14 7.27613 14 6.99998C14 4.9438 13.6325 3.39719 12.6176 2.38234C11.6028 1.36752 10.0562 0.999999 8.00012 0.999984V0.261266C8.00012 0.0532293 7.76085 -0.0637944 7.59664 0.063928L6.00384 1.30277C5.87516 1.40286 5.87516 1.59735 6.00384 1.69744L7.59664 2.93628ZM9.5 5H2.5C2.22386 5 2 5.22386 2 5.5V12.5C2 12.7761 2.22386 13 2.5 13H9.5C9.77614 13 10 12.7761 10 12.5V5.5C10 5.22386 9.77614 5 9.5 5ZM2.5 4C1.67157 4 1 4.67157 1 5.5V12.5C1 13.3284 1.67157 14 2.5 14H9.5C10.3284 14 11 13.3284 11 12.5V5.5C11 4.67157 10.3284 4 9.5 4H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3J = [
    "color"
];
var $c12e32cf04d921d4$export$f0399077805ff597 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.81832 0.68179C7.64258 0.506054 7.35766 0.506054 7.18192 0.68179L5.18192 2.68179C5.00619 2.85753 5.00619 3.14245 5.18192 3.31819C5.35766 3.49392 5.64258 3.49392 5.81832 3.31819L7.05012 2.08638L7.05012 5.50023C7.05012 5.74876 7.25159 5.95023 7.50012 5.95023C7.74865 5.95023 7.95012 5.74876 7.95012 5.50023L7.95012 2.08638L9.18192 3.31819C9.35766 3.49392 9.64258 3.49392 9.81832 3.31819C9.99406 3.14245 9.99406 2.85753 9.81832 2.68179L7.81832 0.68179ZM7.95012 12.9136V9.50023C7.95012 9.2517 7.74865 9.05023 7.50012 9.05023C7.25159 9.05023 7.05012 9.2517 7.05012 9.50023V12.9136L5.81832 11.6818C5.64258 11.5061 5.35766 11.5061 5.18192 11.6818C5.00619 11.8575 5.00619 12.1424 5.18192 12.3182L7.18192 14.3182C7.26632 14.4026 7.38077 14.45 7.50012 14.45C7.61947 14.45 7.73393 14.4026 7.81832 14.3182L9.81832 12.3182C9.99406 12.1424 9.99406 11.8575 9.81832 11.6818C9.64258 11.5061 9.35766 11.5061 9.18192 11.6818L7.95012 12.9136ZM1.49994 7.00017C1.2238 7.00017 0.999939 7.22403 0.999939 7.50017C0.999939 7.77631 1.2238 8.00017 1.49994 8.00017L13.4999 8.00017C13.7761 8.00017 13.9999 7.77631 13.9999 7.50017C13.9999 7.22403 13.7761 7.00017 13.4999 7.00017L1.49994 7.00017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3K = [
    "color"
];
var $c12e32cf04d921d4$export$472271f3e918e2f4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 12.85L1 12.85L1 14.15L14 14.15L14 12.85ZM14 8.85002L1 8.85002L1 10.15L14 10.15L14 8.85002ZM1 4.85003L14 4.85003L14 6.15003L1 6.15002L1 4.85003ZM14 0.850025L1 0.850025L1 2.15002L14 2.15002L14 0.850025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3L = [
    "color"
];
var $c12e32cf04d921d4$export$c3403272e8c8becf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.5 4C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H14.5C14.7761 11 15 10.7761 15 10.5V4.5C15 4.22386 14.7761 4 14.5 4H0.5ZM1 10V5H2.075V7.5C2.075 7.73472 2.26528 7.925 2.5 7.925C2.73472 7.925 2.925 7.73472 2.925 7.5V5H4.075V6.5C4.075 6.73472 4.26528 6.925 4.5 6.925C4.73472 6.925 4.925 6.73472 4.925 6.5V5H6.075V6.5C6.075 6.73472 6.26528 6.925 6.5 6.925C6.73472 6.925 6.925 6.73472 6.925 6.5V5H8.075V7.5C8.075 7.73472 8.26528 7.925 8.5 7.925C8.73472 7.925 8.925 7.73472 8.925 7.5V5H10.075V6.5C10.075 6.73472 10.2653 6.925 10.5 6.925C10.7347 6.925 10.925 6.73472 10.925 6.5V5H12.075V6.5C12.075 6.73472 12.2653 6.925 12.5 6.925C12.7347 6.925 12.925 6.73472 12.925 6.5V5H14V10H1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3M = [
    "color"
];
var $c12e32cf04d921d4$export$e940813548ac56bd = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.5 0C0.223858 0 0 0.223858 0 0.5V14.5C0 14.7761 0.223858 15 0.5 15H4.5C4.77614 15 5 14.7761 5 14.5V5H14.5C14.7761 5 15 4.77614 15 4.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM1 4.07505L1 1H4.07502C4.07502 1 4.07502 1 4.07502 1L4.07505 4.07507L1 4.07505ZM0.999997 4.92505L1 14H4V12.925H2.75002C2.5153 12.925 2.32502 12.7348 2.32502 12.5C2.32502 12.2653 2.5153 12.075 2.75002 12.075H4V10.925H2.25002C2.0153 10.925 1.82502 10.7347 1.82502 10.5C1.82502 10.2653 2.0153 10.075 2.25002 10.075H4V8.92504L2.75002 8.92502C2.5153 8.92502 2.32502 8.73474 2.32502 8.50002C2.32503 8.26529 2.51531 8.07502 2.75003 8.07502L4 8.07504V6.92502L2.74999 6.925C2.51527 6.925 2.325 6.73472 2.325 6.5C2.325 6.26528 2.51529 6.075 2.75001 6.075L4 6.07502V4.92507L0.999997 4.92505ZM4.92505 4H6.075V2.75006C6.075 2.51534 6.26528 2.32506 6.5 2.32506C6.73472 2.32506 6.925 2.51534 6.925 2.75006V4H8.07502V2.75005C8.07502 2.51533 8.2653 2.32505 8.50002 2.32505C8.73474 2.32505 8.92502 2.51533 8.92502 2.75005V4H10.0751V2.25005C10.0751 2.01533 10.2653 1.82505 10.5001 1.82505C10.7348 1.82505 10.9251 2.01533 10.9251 2.25005V4H12.0751V2.75005C12.0751 2.51533 12.2654 2.32505 12.5001 2.32505C12.7348 2.32505 12.9251 2.51533 12.9251 2.75005V4H14V1H4.92502L4.92505 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3N = [
    "color"
];
var $c12e32cf04d921d4$export$ca010e7ed4ef0790 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.949988 4.48455C0.949988 5.34059 1.64395 6.03455 2.49999 6.03455C3.35603 6.03455 4.04999 5.34059 4.04999 4.48455C4.04999 3.6285 3.35603 2.93455 2.49999 2.93455C1.64395 2.93455 0.949988 3.6285 0.949988 4.48455ZM2.49999 6.93455C1.14689 6.93455 0.0499878 5.83764 0.0499878 4.48455C0.0499878 3.13145 1.14689 2.03455 2.49999 2.03455C3.85309 2.03455 4.94999 3.13145 4.94999 4.48455C4.94999 4.80813 4.88726 5.11707 4.77329 5.39985L5.73655 6.04413C5.72943 6.06656 5.72269 6.08914 5.71635 6.11188L5.56288 6.66186L5.21005 6.89773L4.21554 6.23366C3.77357 6.6672 3.168 6.93455 2.49999 6.93455ZM0.949991 10.5C0.949991 9.64394 1.64395 8.94998 2.49999 8.94998C3.35603 8.94998 4.04999 9.64394 4.04999 10.5C4.04999 11.356 3.35603 12.05 2.49999 12.05C1.64395 12.05 0.949991 11.356 0.949991 10.5ZM2.49999 8.04998C1.14689 8.04998 0.0499908 9.14688 0.0499908 10.5C0.0499908 11.8531 1.14689 12.95 2.49999 12.95C3.85309 12.95 4.94999 11.8531 4.94999 10.5C4.94999 10.1803 4.88877 9.87497 4.77743 9.595L15 2.75737L14.0486 2.85737C12.7077 2.9983 11.4091 3.40895 10.231 4.06461L7.15646 5.77564C6.92307 5.90553 6.75134 6.12339 6.67955 6.38066L6.42653 7.28737L4.22437 8.75957C3.78166 8.32091 3.17246 8.04998 2.49999 8.04998ZM7.14435 9.2149L7.15646 9.22176L10.231 10.9328C11.4091 11.5884 12.7077 11.9991 14.0486 12.14L15 12.24L8.81072 8.1003L7.14435 9.2149Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3O = [
    "color"
];
var $c12e32cf04d921d4$export$ab8815222a429372 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM2 5L2 10H13V5H2ZM2 4C1.44772 4 1 4.44772 1 5V10C1 10.5523 1.44772 11 2 11H13C13.5523 11 14 10.5523 14 10V5C14 4.44772 13.5523 4 13 4H2ZM1.5 14C1.77614 14 2 13.7761 2 13.5C2 13.2239 1.77614 13 1.5 13C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14ZM4 1.5C4 1.77614 3.77614 2 3.5 2C3.22386 2 3 1.77614 3 1.5C3 1.22386 3.22386 1 3.5 1C3.77614 1 4 1.22386 4 1.5ZM3.5 14C3.77614 14 4 13.7761 4 13.5C4 13.2239 3.77614 13 3.5 13C3.22386 13 3 13.2239 3 13.5C3 13.7761 3.22386 14 3.5 14ZM6 1.5C6 1.77614 5.77614 2 5.5 2C5.22386 2 5 1.77614 5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5ZM5.5 14C5.77614 14 6 13.7761 6 13.5C6 13.2239 5.77614 13 5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14ZM8 1.5C8 1.77614 7.77614 2 7.5 2C7.22386 2 7 1.77614 7 1.5C7 1.22386 7.22386 1 7.5 1C7.77614 1 8 1.22386 8 1.5ZM7.5 14C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13C7.22386 13 7 13.2239 7 13.5C7 13.7761 7.22386 14 7.5 14ZM10 1.5C10 1.77614 9.77614 2 9.5 2C9.22386 2 9 1.77614 9 1.5C9 1.22386 9.22386 1 9.5 1C9.77614 1 10 1.22386 10 1.5ZM9.5 14C9.77614 14 10 13.7761 10 13.5C10 13.2239 9.77614 13 9.5 13C9.22386 13 9 13.2239 9 13.5C9 13.7761 9.22386 14 9.5 14ZM12 1.5C12 1.77614 11.7761 2 11.5 2C11.2239 2 11 1.77614 11 1.5C11 1.22386 11.2239 1 11.5 1C11.7761 1 12 1.22386 12 1.5ZM11.5 14C11.7761 14 12 13.7761 12 13.5C12 13.2239 11.7761 13 11.5 13C11.2239 13 11 13.2239 11 13.5C11 13.7761 11.2239 14 11.5 14ZM14 1.5C14 1.77614 13.7761 2 13.5 2C13.2239 2 13 1.77614 13 1.5C13 1.22386 13.2239 1 13.5 1C13.7761 1 14 1.22386 14 1.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3P = [
    "color"
];
var $c12e32cf04d921d4$export$9a1f3409566e1d35 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6 3.5C6 2.67157 6.67157 2 7.5 2C8.32843 2 9 2.67157 9 3.5C9 4.32843 8.32843 5 7.5 5C6.67157 5 6 4.32843 6 3.5ZM8 5.94999C9.14112 5.71836 10 4.70948 10 3.5C10 2.11929 8.88071 1 7.5 1C6.11929 1 5 2.11929 5 3.5C5 4.70948 5.85888 5.71836 7 5.94999V13.5C7 13.7761 7.22386 14 7.5 14C7.77614 14 8 13.7761 8 13.5V5.94999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3Q = [
    "color"
];
var $c12e32cf04d921d4$export$8217100f92ae3d76 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10 3.5C10 4.70948 9.14112 5.71836 8 5.94999V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.94999C5.85888 5.71836 5 4.70948 5 3.5C5 2.11929 6.11929 1 7.5 1C8.88071 1 10 2.11929 10 3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3R = [
    "color"
];
var $c12e32cf04d921d4$export$30dea8f5f241e3b3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3S = [
    "color"
];
var $c12e32cf04d921d4$export$c7400a1254b7566e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".05",
        d: "M12.1619 3.85182C8.35817 4.88918 4.88936 8.358 3.85199 12.1617L3.3696 12.0301C4.45356 8.05564 8.05581 4.45339 12.0303 3.36943L12.1619 3.85182Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".1",
        d: "M11.8807 3.42707C8.03441 4.50542 4.50561 8.03422 3.42726 11.8805L2.94582 11.7456C4.07129 7.73121 7.7314 4.0711 11.7458 2.94563L11.8807 3.42707Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".15",
        d: "M11.5201 3.02556C7.69092 4.16199 4.16779 7.68323 3.02805 11.512L2.54883 11.3694C3.73676 7.37869 7.38659 3.73076 11.3778 2.54623L11.5201 3.02556Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".2",
        d: "M11.0468 2.66169C7.31117 3.87664 3.87918 7.3079 2.66298 11.0434L2.18754 10.8886C3.45324 7.00109 7.00445 3.45062 10.8921 2.18621L11.0468 2.66169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".25",
        d: "M10.5201 2.32365C6.92091 3.61447 3.62391 6.90876 2.32845 10.5073L1.858 10.338C3.20398 6.59909 6.61155 3.19424 10.3513 1.85301L10.5201 2.32365Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".3",
        d: "M9.90222 2.03122C6.50003 3.39465 3.39968 6.49367 2.03399 9.89551L1.56998 9.70924C2.98651 6.18076 6.18728 2.98133 9.71622 1.5671L9.90222 2.03122Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".35",
        d: "M9.20727 1.78873C6.06136 3.20349 3.21103 6.05203 1.79331 9.19738L1.33747 8.99192C2.80536 5.73528 5.74485 2.7976 9.0022 1.33272L9.20727 1.78873Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".4",
        d: "M8.40713 1.62085C5.59323 3.05117 3.05794 5.58509 1.62544 8.39847L1.17987 8.1716C2.66036 5.26397 5.27232 2.6534 8.18057 1.17513L8.40713 1.62085Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".45",
        d: "M7.46207 1.56747C5.08689 2.94695 2.95362 5.07912 1.57249 7.45379L1.14028 7.20241C2.56503 4.75273 4.7607 2.55818 7.21096 1.1351L7.46207 1.56747Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".5",
        d: "M6.30407 1.70487C4.51964 2.91063 2.90983 4.52061 1.7043 6.30513L1.28998 6.02524C2.5313 4.18773 4.18673 2.53214 6.02413 1.29059L6.30407 1.70487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3T = [
    "color"
];
var $c12e32cf04d921d4$export$126350cae9fbd558 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 9.1488 1.47969 10.657 2.4767 11.8162L1.64647 12.6464C1.45121 12.8417 1.45121 13.1583 1.64647 13.3535C1.84173 13.5488 2.15832 13.5488 2.35358 13.3535L3.18383 12.5233C4.34302 13.5202 5.8511 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34298 12.5233 3.1838L13.3536 2.35355C13.5488 2.15829 13.5488 1.8417 13.3536 1.64644C13.1583 1.45118 12.8417 1.45118 12.6465 1.64644L11.8162 2.47667C10.657 1.47966 9.14883 0.877045 7.49991 0.877045ZM11.1423 3.15065C10.1568 2.32449 8.88644 1.82704 7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 8.88641 2.32452 10.1568 3.15069 11.1422L11.1423 3.15065ZM3.85781 11.8493C4.84322 12.6753 6.11348 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11345 12.6754 4.84319 11.8493 3.85778L3.85781 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3U = [
    "color"
];
var $c12e32cf04d921d4$export$a3edb785270158f1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".05",
        d: "M12.1398 3.88617C13.8553 4.94159 15 6.83701 15 9.00001C15 12.3137 12.3137 15 9.00002 15C6.84351 15 4.95296 13.8621 3.89569 12.1552L4.32076 11.8919C5.29069 13.4578 7.02376 14.5 9.00002 14.5C12.0376 14.5 14.5 12.0375 14.5 9.00001C14.5 7.01781 13.4516 5.28027 11.8778 4.31203L12.1398 3.88617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".2",
        d: "M12.851 5.07321C13.8684 6.07106 14.5 7.46199 14.5 9C14.5 12.0375 12.0376 14.5 9.00004 14.5C7.46215 14.5 6.07132 13.8685 5.07349 12.8513L5.43043 12.5011C6.3381 13.4264 7.60186 14 9.00004 14C11.7614 14 14 11.7614 14 9C14 7.60171 13.4264 6.33786 12.5009 5.43017L12.851 5.07321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".35",
        d: "M13.3022 6.45071C13.7455 7.19737 14 8.06935 14 9.00001C14 11.7614 11.7614 14 9.00002 14C8.04868 14 7.15868 13.7341 6.40118 13.2724L6.66142 12.8454C7.34275 13.2607 8.14306 13.5 9.00002 13.5C11.4853 13.5 13.5 11.4853 13.5 9.00001C13.5 8.16165 13.271 7.37754 12.8722 6.70599L13.3022 6.45071Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".5",
        d: "M13.3745 7.94022C13.4566 8.28031 13.5 8.63525 13.5 9.00001C13.5 11.4853 11.4853 13.5 9.00003 13.5C8.61104 13.5 8.23323 13.4506 7.87268 13.3576L7.99759 12.8734C8.31768 12.956 8.65353 13 9.00003 13C11.2091 13 13 11.2091 13 9.00001C13 8.67509 12.9613 8.35953 12.8884 8.05757L13.3745 7.94022Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".65",
        d: "M12.9155 9.82133C12.5898 11.3813 11.3562 12.6072 9.79205 12.9215L9.69354 12.4313C11.0613 12.1565 12.1413 11.0834 12.4261 9.71915L12.9155 9.82133Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M1.2771 7.50253C1.2771 4.06456 4.06413 1.27753 7.5021 1.27753C10.94 1.27753 13.7271 4.06456 13.7271 7.50253C13.7271 10.9405 10.94 13.7275 7.5021 13.7275C4.06413 13.7275 1.2771 10.9405 1.2771 7.50253ZM7.5021 2.22753C4.5888 2.22753 2.2271 4.58923 2.2271 7.50253C2.2271 10.4158 4.5888 12.7775 7.5021 12.7775C10.4154 12.7775 12.7771 10.4158 12.7771 7.50253C12.7771 4.58923 10.4154 2.22753 7.5021 2.22753Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3V = [
    "color"
];
var $c12e32cf04d921d4$export$fe819ae1b3a84d32 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 7.50003C5 8.32845 4.32843 9.00003 3.5 9.00003C2.67157 9.00003 2 8.32845 2 7.50003C2 6.6716 2.67157 6.00003 3.5 6.00003C4.32843 6.00003 5 6.6716 5 7.50003ZM5.71313 8.66388C5.29445 9.45838 4.46048 10 3.5 10C2.11929 10 1 8.88074 1 7.50003C1 6.11931 2.11929 5.00003 3.5 5.00003C4.46048 5.00003 5.29445 5.54167 5.71313 6.33616L9.10424 4.21671C9.03643 3.98968 9 3.74911 9 3.50003C9 2.11932 10.1193 1.00003 11.5 1.00003C12.8807 1.00003 14 2.11932 14 3.50003C14 4.88074 12.8807 6.00003 11.5 6.00003C10.6915 6.00003 9.97264 5.61624 9.51566 5.0209L5.9853 7.22738C5.99502 7.31692 6 7.40789 6 7.50003C6 7.59216 5.99502 7.68312 5.9853 7.77267L9.51567 9.97915C9.97265 9.38382 10.6915 9.00003 11.5 9.00003C12.8807 9.00003 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5C9 11.2509 9.03643 11.0104 9.10425 10.7833L5.71313 8.66388ZM11.5 5.00003C12.3284 5.00003 13 4.32846 13 3.50003C13 2.6716 12.3284 2.00003 11.5 2.00003C10.6716 2.00003 10 2.6716 10 3.50003C10 4.32846 10.6716 5.00003 11.5 5.00003ZM13 11.5C13 12.3285 12.3284 13 11.5 13C10.6716 13 10 12.3285 10 11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3W = [
    "color"
];
var $c12e32cf04d921d4$export$fd8d21248a547675 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006L3 11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001L11.5 12.0001C11.7761 12.0001 12 11.7762 12 11.5001L12 5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006L10.25 5.00006C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006L11.5 4.00006C12.3284 4.00006 13 4.67163 13 5.50006L13 11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001L3.5 13.0001C2.67157 13.0001 2 12.3285 2 11.5001L2 5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006L4.75 4.00006C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006L3.5 5.00006ZM7 1.6364L5.5682 3.0682C5.39246 3.24393 5.10754 3.24393 4.9318 3.0682C4.75607 2.89246 4.75607 2.60754 4.9318 2.4318L7.1818 0.181802C7.26619 0.09741 7.38065 0.049999 7.5 0.049999C7.61935 0.049999 7.73381 0.09741 7.8182 0.181802L10.0682 2.4318C10.2439 2.60754 10.2439 2.89246 10.0682 3.0682C9.89246 3.24393 9.60754 3.24393 9.4318 3.0682L8 1.6364L8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5L7 1.6364Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3X = [
    "color"
];
var $c12e32cf04d921d4$export$f584b8d6931467fb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.3536 1.14645C12.1583 0.951184 11.8417 0.951184 11.6464 1.14645C11.4512 1.34171 11.4512 1.65829 11.6464 1.85355L12.7929 3H12C10.7037 3 9.71111 3.58423 8.87248 4.38931C8.20065 5.03427 7.59349 5.85684 6.99461 6.6682C6.86287 6.84668 6.73154 7.02462 6.6 7.2C5.10874 9.18835 3.49037 11 0.5 11C0.223858 11 0 11.2239 0 11.5C0 11.7761 0.223858 12 0.5 12C4.00963 12 5.89126 9.81165 7.4 7.8C7.54367 7.60845 7.6832 7.41962 7.81996 7.23454L7.82005 7.23443L7.82006 7.23441C8.41674 6.42695 8.96069 5.69085 9.56502 5.11069C10.2889 4.41577 11.0463 4 12 4H12.7929L11.6464 5.14645C11.4512 5.34171 11.4512 5.65829 11.6464 5.85355C11.8417 6.04882 12.1583 6.04882 12.3536 5.85355L14.3536 3.85355C14.5488 3.65829 14.5488 3.34171 14.3536 3.14645L12.3536 1.14645ZM0.5 3C3.35278 3 5.12992 4.44588 6.50548 6.06746L6.3762 6.24266C6.2483 6.4161 6.12293 6.58609 6 6.75C5.96397 6.79804 5.92798 6.84581 5.892 6.89331C4.57348 5.29306 3.02637 4 0.5 4C0.223858 4 0 3.77614 0 3.5C0 3.22386 0.223858 3 0.5 3ZM8.87248 10.6107C8.37284 10.131 7.90897 9.55314 7.45767 8.95468C7.64688 8.71693 7.82704 8.48061 8 8.25L8.08987 8.12987C8.58412 8.79402 9.05288 9.39766 9.56502 9.88931C10.2889 10.5842 11.0463 11 12 11H12.7929L11.6464 9.85355C11.4512 9.65829 11.4512 9.34171 11.6464 9.14645C11.8417 8.95118 12.1583 8.95118 12.3536 9.14645L14.3536 11.1464C14.5488 11.3417 14.5488 11.6583 14.3536 11.8536L12.3536 13.8536C12.1583 14.0488 11.8417 14.0488 11.6464 13.8536C11.4512 13.6583 11.4512 13.3417 11.6464 13.1464L12.7929 12H12C10.7037 12 9.71111 11.4158 8.87248 10.6107Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3Y = [
    "color"
];
var $c12e32cf04d921d4$export$9b9cddf895f6c38e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.5 3.04999C11.7485 3.04999 11.95 3.25146 11.95 3.49999V7.49999C11.95 7.74852 11.7485 7.94999 11.5 7.94999C11.2515 7.94999 11.05 7.74852 11.05 7.49999V4.58639L4.58638 11.05H7.49999C7.74852 11.05 7.94999 11.2515 7.94999 11.5C7.94999 11.7485 7.74852 11.95 7.49999 11.95L3.49999 11.95C3.38064 11.95 3.26618 11.9026 3.18179 11.8182C3.0974 11.7338 3.04999 11.6193 3.04999 11.5L3.04999 7.49999C3.04999 7.25146 3.25146 7.04999 3.49999 7.04999C3.74852 7.04999 3.94999 7.25146 3.94999 7.49999L3.94999 10.4136L10.4136 3.94999L7.49999 3.94999C7.25146 3.94999 7.04999 3.74852 7.04999 3.49999C7.04999 3.25146 7.25146 3.04999 7.49999 3.04999L11.5 3.04999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3Z = [
    "color"
];
var $c12e32cf04d921d4$export$5881b38319b9ceb7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.53731 0.826873C7.5125 0.824392 7.4875 0.824392 7.46269 0.826873L3.96269 1.17687C3.85672 1.18747 3.76025 1.24262 3.69736 1.32857L0.699771 5.42528C0.654046 5.48627 0.62647 5.56165 0.625057 5.6434C0.625019 5.6456 0.625 5.64781 0.625 5.65001C0.625 5.65052 0.625001 5.65103 0.625003 5.65153C0.625363 5.74237 0.658021 5.82559 0.712087 5.8903L7.21042 13.7883C7.28165 13.8749 7.38789 13.925 7.5 13.925C7.61211 13.925 7.71835 13.8749 7.78958 13.7883L14.2879 5.89031C14.342 5.8256 14.3746 5.74237 14.375 5.65153C14.375 5.65103 14.375 5.65052 14.375 5.65001C14.375 5.64849 14.375 5.64697 14.375 5.64545C14.3749 5.63963 14.3747 5.63382 14.3744 5.62801C14.37 5.55219 14.3431 5.48242 14.3002 5.42527L11.3026 1.32857C11.2397 1.24262 11.1433 1.18747 11.0373 1.17687L7.53731 0.826873ZM10.925 5.27501V5.25236L10.9223 5.27501H10.925ZM10.9342 5.17498H13.1877L11.2495 2.5261L10.9342 5.17498ZM10.5707 1.88395L8.04432 1.63131L10.1747 5.21034L10.5707 1.88395ZM6.95568 1.63131L4.42931 1.88395L4.82531 5.21034L6.95568 1.63131ZM3.75046 2.5261L1.81226 5.17498H4.0658L3.75046 2.5261ZM1.79416 6.02501L6.75861 12.0587L4.22371 6.0669C4.21787 6.0531 4.21314 6.0391 4.20949 6.02501H1.79416ZM5.15055 6.02501L7.49999 12.1085L9.84943 6.02501H9.78681H5.21319H5.15055ZM10.7905 6.02501C10.7869 6.0391 10.7821 6.0531 10.7763 6.0669L8.24139 12.0587L13.2058 6.02501H10.7905ZM7.5 2.18317L9.34038 5.27501H5.65962L7.5 2.18317Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3_ = [
    "color"
];
var $c12e32cf04d921d4$export$fab36db504d71648 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3_);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.10876 14L9.46582 1H10.8178L5.46074 14H4.10876Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3$ = [
    "color"
];
var $c12e32cf04d921d4$export$c1a54868c36d9c70 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3$);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.3004 7.49991C10.3004 8.4943 9.49426 9.30041 8.49988 9.30041C7.50549 9.30041 6.69938 8.4943 6.69938 7.49991C6.69938 6.50553 7.50549 5.69942 8.49988 5.69942C9.49426 5.69942 10.3004 6.50553 10.3004 7.49991ZM11.205 8C10.9699 9.28029 9.84816 10.2504 8.49988 10.2504C7.1516 10.2504 6.0299 9.28029 5.79473 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H5.7947C6.0298 5.71962 7.15154 4.74942 8.49988 4.74942C9.84822 4.74942 10.97 5.71962 11.2051 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H11.205Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$40 = [
    "color"
];
var $c12e32cf04d921d4$export$389ac29f15551cc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$40);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.4999 0.999994C14.2237 0.999994 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L9.99992 5.99995C9.44764 5.99995 8.99993 6.44766 8.99993 6.99994L8.99993 7.99994C8.99993 8.55222 9.44764 8.99993 9.99992 8.99993L13.9999 8.99993L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999994 14.4999 0.999994ZM4.99996 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999994 0.499996 0.999994C0.223856 0.999994 -9.7852e-09 1.22385 -2.18557e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99993L4.99996 8.99993C5.55224 8.99993 5.99995 8.55222 5.99995 7.99993L5.99995 6.99994C5.99995 6.44766 5.55224 5.99995 4.99996 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$41 = [
    "color"
];
var $c12e32cf04d921d4$export$d6c80469522241f6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$41);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1L9 1V5C9 5.55228 8.55228 6 8 6H7C6.44772 6 6 5.55228 6 5V1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 9C6.44772 9 6 9.44771 6 10V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9V10C9 9.44772 8.55228 9 8 9H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$42 = [
    "color"
];
var $c12e32cf04d921d4$export$d569b77eb092ec4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$42);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992ZM0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992ZM1.99998 6.99994C1.99998 6.44766 2.44769 5.99995 2.99998 5.99995L5.99995 5.99995C6.55223 5.99995 6.99994 6.44766 6.99994 6.99994L6.99994 7.99993C6.99994 8.55221 6.55223 8.99992 5.99995 8.99992L2.99998 8.99992C2.4477 8.99992 1.99998 8.55221 1.99998 7.99993L1.99998 6.99994ZM8.99993 5.99995C8.44765 5.99995 7.99993 6.44766 7.99993 6.99994L7.99993 7.99993C7.99993 8.55221 8.44765 8.99992 8.99993 8.99992L11.9999 8.99992C12.5522 8.99992 12.9999 8.55221 12.9999 7.99993L12.9999 6.99994C12.9999 6.44766 12.5522 5.99995 11.9999 5.99995L8.99993 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$43 = [
    "color"
];
var $c12e32cf04d921d4$export$7b2a11c2d6945102 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$43);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 2C6.44772 2 6 2.44772 6 3V6C6 6.55228 6.44772 7 7 7H8C8.55228 7 9 6.55228 9 6V3C9 2.44772 8.55228 2 8 2H7ZM7 8C6.44772 8 6 8.44771 6 9V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V9C9 8.44772 8.55228 8 8 8H7ZM1.49988 14C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H1.49988Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$44 = [
    "color"
];
var $c12e32cf04d921d4$export$7fee6559072912ad = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$44);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.46968 1.05085C7.64122 1.13475 7.75 1.30904 7.75 1.5V13.5C7.75 13.691 7.64122 13.8653 7.46968 13.9492C7.29813 14.0331 7.09377 14.0119 6.94303 13.8947L3.2213 11H1.5C0.671571 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.2213L6.94303 1.10533C7.09377 0.988085 7.29813 0.966945 7.46968 1.05085ZM6.75 2.52232L3.69983 4.89468C3.61206 4.96294 3.50405 5 3.39286 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77615 1.22386 10 1.5 10H3.39286C3.50405 10 3.61206 10.0371 3.69983 10.1053L6.75 12.4777V2.52232ZM10.2784 3.84804C10.4623 3.72567 10.7106 3.77557 10.833 3.95949C12.2558 6.09798 12.2558 8.90199 10.833 11.0405C10.7106 11.2244 10.4623 11.2743 10.2784 11.1519C10.0944 11.0296 10.0445 10.7813 10.1669 10.5973C11.4111 8.72728 11.4111 6.27269 10.1669 4.40264C10.0445 4.21871 10.0944 3.97041 10.2784 3.84804ZM12.6785 1.43044C12.5356 1.2619 12.2832 1.24104 12.1147 1.38386C11.9462 1.52667 11.9253 1.77908 12.0681 1.94762C14.7773 5.14488 14.7773 9.85513 12.0681 13.0524C11.9253 13.2209 11.9462 13.4733 12.1147 13.6161C12.2832 13.759 12.5356 13.7381 12.6785 13.5696C15.6406 10.0739 15.6406 4.92612 12.6785 1.43044Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$45 = [
    "color"
];
var $c12e32cf04d921d4$export$a45f43fe1bacf3af = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$45);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.833 3.95949C10.7106 3.77557 10.4623 3.72567 10.2784 3.84804C10.0944 3.97041 10.0445 4.21871 10.1669 4.40264C11.4111 6.27268 11.4111 8.72728 10.1669 10.5973C10.0445 10.7813 10.0944 11.0296 10.2784 11.1519C10.4623 11.2743 10.7106 11.2244 10.833 11.0405C12.2558 8.90199 12.2558 6.09798 10.833 3.95949Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$46 = [
    "color"
];
var $c12e32cf04d921d4$export$9ea4d02db3207a8b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$46);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.72361 1.05279C7.893 1.13749 8 1.31062 8 1.5V13.5C8 13.6894 7.893 13.8625 7.72361 13.9472C7.55421 14.0319 7.35151 14.0136 7.2 13.9L3.33333 11H1.5C0.671573 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.33333L7.2 1.1C7.35151 0.986371 7.55421 0.968093 7.72361 1.05279ZM7 2.5L3.8 4.9C3.71345 4.96491 3.60819 5 3.5 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77614 1.22386 10 1.5 10H3.5C3.60819 10 3.71345 10.0351 3.8 10.1L7 12.5V2.5ZM14.8536 5.14645C15.0488 5.34171 15.0488 5.65829 14.8536 5.85355L13.2071 7.5L14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355C14.6583 10.0488 14.3417 10.0488 14.1464 9.85355L12.5 8.20711L10.8536 9.85355C10.6583 10.0488 10.3417 10.0488 10.1464 9.85355C9.95118 9.65829 9.95118 9.34171 10.1464 9.14645L11.7929 7.5L10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645L12.5 6.79289L14.1464 5.14645C14.3417 4.95118 14.6583 4.95118 14.8536 5.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$47 = [
    "color"
];
var $c12e32cf04d921d4$export$c28fae3b5b7c9a0b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$47);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.083 5.05577C9.96066 4.87185 9.71235 4.82195 9.52843 4.94432C9.3445 5.06669 9.2946 5.31499 9.41697 5.49892C10.2207 6.70693 10.2207 8.29303 9.41697 9.50104C9.2946 9.68496 9.3445 9.93326 9.52843 10.0556C9.71235 10.178 9.96066 10.1281 10.083 9.94418C11.0653 8.46773 11.0653 6.53222 10.083 5.05577Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$48 = [
    "color"
];
var $c12e32cf04d921d4$export$c19d0dc844f6640 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$48);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 1H1.5H13.5H14V1.5V13.5V14H13.5H1.5H1V13.5V1.5V1ZM2 2V13H13V2H2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$49 = [
    "color"
];
var $c12e32cf04d921d4$export$f95b8a41f9121b54 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$49);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.75432 1.81954C7.59742 1.72682 7.4025 1.72682 7.24559 1.81954L1.74559 5.06954C1.59336 5.15949 1.49996 5.32317 1.49996 5.5C1.49996 5.67683 1.59336 5.84051 1.74559 5.93046L7.24559 9.18046C7.4025 9.27318 7.59742 9.27318 7.75432 9.18046L13.2543 5.93046C13.4066 5.84051 13.5 5.67683 13.5 5.5C13.5 5.32317 13.4066 5.15949 13.2543 5.06954L7.75432 1.81954ZM7.49996 8.16923L2.9828 5.5L7.49996 2.83077L12.0171 5.5L7.49996 8.16923ZM2.25432 8.31954C2.01658 8.17906 1.70998 8.2579 1.56949 8.49564C1.42901 8.73337 1.50785 9.03998 1.74559 9.18046L7.24559 12.4305C7.4025 12.5232 7.59742 12.5232 7.75432 12.4305L13.2543 9.18046C13.4921 9.03998 13.5709 8.73337 13.4304 8.49564C13.2899 8.2579 12.9833 8.17906 12.7456 8.31954L7.49996 11.4192L2.25432 8.31954Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4a = [
    "color"
];
var $c12e32cf04d921d4$export$2ee28caa7f1e962e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.97942 1.25171L6.9585 1.30199L5.58662 4.60039C5.54342 4.70426 5.44573 4.77523 5.3336 4.78422L1.7727 5.0697L1.71841 5.07405L1.38687 5.10063L1.08608 5.12475C0.820085 5.14607 0.712228 5.47802 0.914889 5.65162L1.14406 5.84793L1.39666 6.06431L1.43802 6.09974L4.15105 8.42374C4.23648 8.49692 4.2738 8.61176 4.24769 8.72118L3.41882 12.196L3.40618 12.249L3.32901 12.5725L3.25899 12.866C3.19708 13.1256 3.47945 13.3308 3.70718 13.1917L3.9647 13.0344L4.24854 12.861L4.29502 12.8326L7.34365 10.9705C7.43965 10.9119 7.5604 10.9119 7.6564 10.9705L10.705 12.8326L10.7515 12.861L11.0354 13.0344L11.2929 13.1917C11.5206 13.3308 11.803 13.1256 11.7411 12.866L11.671 12.5725L11.5939 12.249L11.5812 12.196L10.7524 8.72118C10.7263 8.61176 10.7636 8.49692 10.849 8.42374L13.562 6.09974L13.6034 6.06431L13.856 5.84793L14.0852 5.65162C14.2878 5.47802 14.18 5.14607 13.914 5.12475L13.6132 5.10063L13.2816 5.07405L13.2274 5.0697L9.66645 4.78422C9.55432 4.77523 9.45663 4.70426 9.41343 4.60039L8.04155 1.30199L8.02064 1.25171L7.89291 0.944609L7.77702 0.665992C7.67454 0.419604 7.32551 0.419604 7.22303 0.665992L7.10715 0.944609L6.97942 1.25171ZM7.50003 2.60397L6.50994 4.98442C6.32273 5.43453 5.89944 5.74207 5.41351 5.78103L2.84361 5.98705L4.8016 7.66428C5.17183 7.98142 5.33351 8.47903 5.2204 8.95321L4.62221 11.461L6.8224 10.1171C7.23842 9.86302 7.76164 9.86302 8.17766 10.1171L10.3778 11.461L9.77965 8.95321C9.66654 8.47903 9.82822 7.98142 10.1984 7.66428L12.1564 5.98705L9.58654 5.78103C9.10061 5.74207 8.67732 5.43453 8.49011 4.98442L7.50003 2.60397Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4b = [
    "color"
];
var $c12e32cf04d921d4$export$b9957ed2bd2cc18b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4c = [
    "color"
];
var $c12e32cf04d921d4$export$fa3807a0e988146 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 7.21321 1.87134 6.93143 1.91256 6.65615L9.56374 2.23875C9.86311 2.35627 10.15 2.49861 10.4219 2.66322L3.77065 6.50332C3.73669 6.52183 3.70482 6.5449 3.67602 6.57238C3.5911 6.65308 3.54245 6.76286 3.53682 6.87658C3.53359 6.9418 3.54451 7.00831 3.57086 7.07137C3.58927 7.1157 3.6149 7.15742 3.64744 7.19458C3.67306 7.22396 3.702 7.24941 3.73337 7.27069L7.32533 9.83813L3.87232 11.8317C2.63604 10.7953 1.84998 9.23944 1.84998 7.49998ZM8.36843 10.2751C8.37682 10.2706 8.38509 10.2659 8.39322 10.2608L9.84091 9.42499C9.84706 9.42163 9.85314 9.41812 9.85915 9.41446L11.3101 8.57677C11.3655 8.54649 11.4154 8.504 11.4554 8.44995C11.6034 8.25031 11.5616 7.96848 11.362 7.82046L7.82779 5.20017L11.2161 3.24393C12.4013 4.27963 13.15 5.80237 13.15 7.49998C13.15 7.83546 13.1207 8.16411 13.0647 8.48353L5.56875 12.8113C5.26138 12.6995 4.96646 12.5618 4.68662 12.4008L8.36843 10.2751ZM8.18149 9.34383L4.81659 6.93868L5.50918 6.53881L8.80604 8.98324L8.18149 9.34383ZM6.35875 6.04832L6.97822 5.69067L10.2751 8.13506L9.6556 8.49275L6.35875 6.04832ZM8.3318 1.91078L2.24263 5.42636C3.06941 3.33188 5.11164 1.84998 7.49998 1.84998C7.78258 1.84998 8.06033 1.87072 8.3318 1.91078ZM6.84684 13.1126C7.06114 13.1373 7.27908 13.15 7.49998 13.15C9.8246 13.15 11.8213 11.7461 12.6886 9.7399L6.84684 13.1126ZM7.49998 0.849976C3.82728 0.849976 0.849976 3.82728 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4d = [
    "color"
];
var $c12e32cf04d921d4$export$dc6949a98411e916 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 3C2 2.44772 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12V3ZM12 3H3V12H12V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4e = [
    "color"
];
var $c12e32cf04d921d4$export$93c9322cdb01abe0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L11.858 2.25806C12.1021 2.01398 12.4978 2.01398 12.7419 2.25806C12.986 2.50214 12.986 2.89786 12.7419 3.14194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13362 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.99998 4.5C7.99998 4.22386 7.77612 4 7.49998 4C7.22383 4 6.99998 4.22386 6.99998 4.5V9.5C6.99998 9.77614 7.22383 10 7.49998 10C7.77612 10 7.99998 9.77614 7.99998 9.5V4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4f = [
    "color"
];
var $c12e32cf04d921d4$export$672f8b757251d92b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99992L13.9999 8.99992L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4g = [
    "color"
];
var $c12e32cf04d921d4$export$dd3bd56329b5fe85 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H6H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM9 14V1L6 1V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4h = [
    "color"
];
var $c12e32cf04d921d4$export$25ec4ecc9c5701a5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4i = [
    "color"
];
var $c12e32cf04d921d4$export$cd27c497b93dbe8d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V0.5C7 0.223858 7.22386 0 7.5 0ZM2.1967 2.1967C2.39196 2.00144 2.70854 2.00144 2.90381 2.1967L4.31802 3.61091C4.51328 3.80617 4.51328 4.12276 4.31802 4.31802C4.12276 4.51328 3.80617 4.51328 3.61091 4.31802L2.1967 2.90381C2.00144 2.70854 2.00144 2.39196 2.1967 2.1967ZM0.5 7C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H2.5C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7H0.5ZM2.1967 12.8033C2.00144 12.608 2.00144 12.2915 2.1967 12.0962L3.61091 10.682C3.80617 10.4867 4.12276 10.4867 4.31802 10.682C4.51328 10.8772 4.51328 11.1938 4.31802 11.3891L2.90381 12.8033C2.70854 12.9986 2.39196 12.9986 2.1967 12.8033ZM12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12.5ZM10.682 4.31802C10.4867 4.12276 10.4867 3.80617 10.682 3.61091L12.0962 2.1967C12.2915 2.00144 12.608 2.00144 12.8033 2.1967C12.9986 2.39196 12.9986 2.70854 12.8033 2.90381L11.3891 4.31802C11.1938 4.51328 10.8772 4.51328 10.682 4.31802ZM8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5V14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V12.5ZM10.682 10.682C10.8772 10.4867 11.1938 10.4867 11.3891 10.682L12.8033 12.0962C12.9986 12.2915 12.9986 12.608 12.8033 12.8033C12.608 12.9986 12.2915 12.9986 12.0962 12.8033L10.682 11.3891C10.4867 11.1938 10.4867 10.8772 10.682 10.682ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4j = [
    "color"
];
var $c12e32cf04d921d4$export$381bc0c1798a0082 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4ZM7.67133 11C6.65183 10.175 6 8.91363 6 7.5C6 6.08637 6.65183 4.82498 7.67133 4H4.5C2.567 4 1 5.567 1 7.5C1 9.433 2.567 11 4.5 11H7.67133ZM0 7.5C0 5.01472 2.01472 3 4.5 3H10.5C12.9853 3 15 5.01472 15 7.5C15 9.98528 12.9853 12 10.5 12H4.5C2.01472 12 0 9.98528 0 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4k = [
    "color"
];
var $c12e32cf04d921d4$export$b6fcc44f764b8899 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4l = [
    "color"
];
var $c12e32cf04d921d4$export$560b0277c649ed6b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4m = [
    "color"
];
var $c12e32cf04d921d4$export$aea5b1a1d88a7a75 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.900024 7.50002C0.900024 3.85495 3.85495 0.900024 7.50002 0.900024C11.1451 0.900024 14.1 3.85495 14.1 7.50002C14.1 11.1451 11.1451 14.1 7.50002 14.1C3.85495 14.1 0.900024 11.1451 0.900024 7.50002ZM7.50002 1.80002C4.35201 1.80002 1.80002 4.35201 1.80002 7.50002C1.80002 10.648 4.35201 13.2 7.50002 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.35201 10.648 1.80002 7.50002 1.80002ZM3.07504 7.50002C3.07504 5.05617 5.05618 3.07502 7.50004 3.07502C9.94388 3.07502 11.925 5.05617 11.925 7.50002C11.925 9.94386 9.94388 11.925 7.50004 11.925C5.05618 11.925 3.07504 9.94386 3.07504 7.50002ZM7.50004 3.92502C5.52562 3.92502 3.92504 5.52561 3.92504 7.50002C3.92504 9.47442 5.52563 11.075 7.50004 11.075C9.47444 11.075 11.075 9.47442 11.075 7.50002C11.075 5.52561 9.47444 3.92502 7.50004 3.92502ZM7.50004 5.25002C6.2574 5.25002 5.25004 6.25739 5.25004 7.50002C5.25004 8.74266 6.2574 9.75002 7.50004 9.75002C8.74267 9.75002 9.75004 8.74266 9.75004 7.50002C9.75004 6.25738 8.74267 5.25002 7.50004 5.25002ZM6.05004 7.50002C6.05004 6.69921 6.69923 6.05002 7.50004 6.05002C8.30084 6.05002 8.95004 6.69921 8.95004 7.50002C8.95004 8.30083 8.30084 8.95002 7.50004 8.95002C6.69923 8.95002 6.05004 8.30083 6.05004 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4n = [
    "color"
];
var $c12e32cf04d921d4$export$4a7d2a945910cc57 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.94993 2.95002L3.94993 4.49998C3.94993 4.74851 3.74845 4.94998 3.49993 4.94998C3.2514 4.94998 3.04993 4.74851 3.04993 4.49998V2.50004C3.04993 2.45246 3.05731 2.40661 3.07099 2.36357C3.12878 2.18175 3.29897 2.05002 3.49993 2.05002H11.4999C11.6553 2.05002 11.7922 2.12872 11.8731 2.24842C11.9216 2.32024 11.9499 2.40682 11.9499 2.50002L11.9499 2.50004V4.49998C11.9499 4.74851 11.7485 4.94998 11.4999 4.94998C11.2514 4.94998 11.0499 4.74851 11.0499 4.49998V2.95002H8.04993V12.05H9.25428C9.50281 12.05 9.70428 12.2515 9.70428 12.5C9.70428 12.7486 9.50281 12.95 9.25428 12.95H5.75428C5.50575 12.95 5.30428 12.7486 5.30428 12.5C5.30428 12.2515 5.50575 12.05 5.75428 12.05H6.94993V2.95002H3.94993Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4o = [
    "color"
];
var $c12e32cf04d921d4$export$934aaa521722e7a1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.89949 5.50002C3.89949 5.27911 3.7204 5.10003 3.49949 5.10003C3.27857 5.10003 3.09949 5.27911 3.09949 5.50002L3.09949 12.5343L1.78233 11.2172C1.62612 11.061 1.37285 11.061 1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829L3.21664 13.7829C3.29166 13.8579 3.3934 13.9 3.49949 13.9C3.60557 13.9 3.70732 13.8579 3.78233 13.7829L5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172C5.62612 11.061 5.37285 11.061 5.21664 11.2172L3.89949 12.5343L3.89949 5.50002ZM8.49998 13C8.22383 13 7.99998 12.7762 7.99998 12.5C7.99998 12.2239 8.22383 12 8.49998 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7762 14.7761 13 14.5 13H8.49998ZM8.49998 10C8.22383 10 7.99998 9.77617 7.99998 9.50002C7.99998 9.22388 8.22383 9.00002 8.49998 9.00002H14.5C14.7761 9.00002 15 9.22388 15 9.50002C15 9.77617 14.7761 10 14.5 10H8.49998ZM7.99998 6.50002C7.99998 6.77617 8.22383 7.00002 8.49998 7.00002H14.5C14.7761 7.00002 15 6.77617 15 6.50002C15 6.22388 14.7761 6.00002 14.5 6.00002H8.49998C8.22383 6.00002 7.99998 6.22388 7.99998 6.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4p = [
    "color"
];
var $c12e32cf04d921d4$export$c0990f168a0bad08 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM3 10.5C3 10.2239 3.22386 10 3.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H3.5C3.22386 11 3 10.7761 3 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4q = [
    "color"
];
var $c12e32cf04d921d4$export$8ea3580a4e458099 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H2.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4r = [
    "color"
];
var $c12e32cf04d921d4$export$e9337773b10190a1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H7.5C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4s = [
    "color"
];
var $c12e32cf04d921d4$export$79a9a721b029c6d9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.49949 14.9C3.7204 14.9 3.89949 14.7209 3.89949 14.5L3.89949 10.4657L5.21664 11.7829C5.37285 11.9391 5.62612 11.9391 5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172L3.78233 9.21718C3.70732 9.14217 3.60557 9.10002 3.49949 9.10002C3.3934 9.10002 3.29166 9.14217 3.21664 9.21718L1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829C1.37285 11.9391 1.62612 11.9391 1.78233 11.7829L3.09949 10.4657L3.09949 14.5C3.09949 14.7209 3.27857 14.9 3.49949 14.9ZM7.99998 10.5C7.99998 10.7762 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7762 15 10.5C15 10.2239 14.7761 10 14.5 10H8.49998C8.22383 10 7.99998 10.2239 7.99998 10.5ZM7.99998 7.50002C7.99998 7.77617 8.22383 8.00002 8.49998 8.00002H14.5C14.7761 8.00002 15 7.77617 15 7.50002C15 7.22388 14.7761 7.00002 14.5 7.00002H8.49998C8.22383 7.00002 7.99998 7.22388 7.99998 7.50002ZM8.49998 5.00002C8.22383 5.00002 7.99998 4.77617 7.99998 4.50002C7.99998 4.22388 8.22383 4.00002 8.49998 4.00002H14.5C14.7761 4.00002 15 4.22388 15 4.50002C15 4.77617 14.7761 5.00002 14.5 5.00002H8.49998ZM3.89949 0.500025C3.89949 0.279111 3.7204 0.100025 3.49949 0.100025C3.27857 0.100025 3.09949 0.279111 3.09949 0.500025L3.09949 4.53434L1.78233 3.21718C1.62612 3.06097 1.37285 3.06097 1.21664 3.21718C1.06043 3.37339 1.06043 3.62666 1.21664 3.78287L3.21664 5.78287C3.29166 5.85788 3.3934 5.90002 3.49949 5.90002C3.60557 5.90002 3.70732 5.85788 3.78233 5.78287L5.78233 3.78287C5.93854 3.62666 5.93854 3.37339 5.78233 3.21718C5.62612 3.06097 5.37285 3.06097 5.21664 3.21718L3.89949 4.53434L3.89949 0.500025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4t = [
    "color"
];
var $c12e32cf04d921d4$export$2b644951427679e4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM7 7.5C7 7.22386 7.22386 7 7.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H4.5C4.22386 11 4 10.7761 4 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4u = [
    "color"
];
var $c12e32cf04d921d4$export$65298c635b1d5567 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.89949 9.49998C3.89949 9.72089 3.7204 9.89997 3.49949 9.89997C3.27857 9.89997 3.09949 9.72089 3.09949 9.49998L3.09949 2.46566L1.78233 3.78282C1.62612 3.93903 1.37285 3.93903 1.21664 3.78282C1.06043 3.62661 1.06043 3.37334 1.21664 3.21713L3.21664 1.21713C3.29166 1.14212 3.3934 1.09998 3.49949 1.09998C3.60557 1.09998 3.70732 1.14212 3.78233 1.21713L5.78233 3.21713C5.93854 3.37334 5.93854 3.62661 5.78233 3.78282C5.62612 3.93903 5.37285 3.93903 5.21664 3.78282L3.89949 2.46566L3.89949 9.49998ZM8.49998 1.99998C8.22383 1.99998 7.99998 2.22383 7.99998 2.49998C7.99998 2.77612 8.22383 2.99998 8.49998 2.99998H14.5C14.7761 2.99998 15 2.77612 15 2.49998C15 2.22383 14.7761 1.99998 14.5 1.99998H8.49998ZM8.49998 4.99998C8.22383 4.99998 7.99998 5.22383 7.99998 5.49998C7.99998 5.77612 8.22383 5.99998 8.49998 5.99998H14.5C14.7761 5.99998 15 5.77612 15 5.49998C15 5.22383 14.7761 4.99998 14.5 4.99998H8.49998ZM7.99998 8.49998C7.99998 8.22383 8.22383 7.99998 8.49998 7.99998H14.5C14.7761 7.99998 15 8.22383 15 8.49998C15 8.77612 14.7761 8.99998 14.5 8.99998H8.49998C8.22383 8.99998 7.99998 8.77612 7.99998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4v = [
    "color"
];
var $c12e32cf04d921d4$export$2407db3e81e79ec8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L11.9291 2.36383C11.9159 2.32246 11.897 2.28368 11.8732 2.24845C11.7923 2.12875 11.6554 2.05005 11.5001 2.05005H3.50005C3.29909 2.05005 3.1289 2.18178 3.07111 2.3636C3.05743 2.40665 3.05005 2.45249 3.05005 2.50007V4.50001C3.05005 4.74854 3.25152 4.95001 3.50005 4.95001C3.74858 4.95001 3.95005 4.74854 3.95005 4.50001V2.95005H6.95006V7.34284L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L6.95006 8.75705V12.0501H5.7544C5.50587 12.0501 5.3044 12.2515 5.3044 12.5001C5.3044 12.7486 5.50587 12.9501 5.7544 12.9501H9.2544C9.50293 12.9501 9.7044 12.7486 9.7044 12.5001C9.7044 12.2515 9.50293 12.0501 9.2544 12.0501H8.05006V7.65705L13.3536 2.35355ZM8.05006 6.24284L11.0501 3.24283V2.95005H8.05006V6.24284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4w = [
    "color"
];
var $c12e32cf04d921d4$export$d02861c1158d3b3d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 3.5C5 3.22386 5.22386 3 5.5 3H9.5C9.77614 3 10 3.22386 10 3.5V6H12.5C12.6873 6 12.8589 6.10467 12.9446 6.27121C13.0303 6.43774 13.0157 6.63821 12.9069 6.79062L7.90687 13.7906C7.81301 13.922 7.66148 14 7.5 14C7.33853 14 7.18699 13.922 7.09314 13.7906L2.09314 6.79062C1.98427 6.63821 1.96972 6.43774 2.05542 6.27121C2.14112 6.10467 2.31271 6 2.5 6H5V3.5ZM6 4V6.5C6 6.77614 5.77614 7 5.5 7H3.4716L7.5 12.6398L11.5284 7H9.5C9.22386 7 9 6.77614 9 6.5V4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4x = [
    "color"
];
var $c12e32cf04d921d4$export$90890f1931da847b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 7.5C1 7.66148 1.07798 7.81301 1.20938 7.90687L8.20938 12.9069C8.36179 13.0157 8.56226 13.0303 8.72879 12.9446C8.89533 12.8589 9 12.6873 9 12.5L9 10L11.5 10C11.7761 10 12 9.77614 12 9.5L12 5.5C12 5.22386 11.7761 5 11.5 5L9 5L9 2.5C9 2.31271 8.89533 2.14112 8.72879 2.05542C8.56226 1.96972 8.36179 1.98427 8.20938 2.09313L1.20938 7.09314C1.07798 7.18699 1 7.33853 1 7.5ZM8 3.4716L8 5.5C8 5.77614 8.22386 6 8.5 6L11 6L11 9L8.5 9C8.22386 9 8 9.22386 8 9.5L8 11.5284L2.36023 7.5L8 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4y = [
    "color"
];
var $c12e32cf04d921d4$export$72a6223ceb8df5ef = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 7.5C14 7.66148 13.922 7.81301 13.7906 7.90687L6.79062 12.9069C6.63821 13.0157 6.43774 13.0303 6.27121 12.9446C6.10467 12.8589 6 12.6873 6 12.5L6 10L3.5 10C3.22386 10 3 9.77614 3 9.5L3 5.5C3 5.22386 3.22386 5 3.5 5L6 5L6 2.5C6 2.31271 6.10467 2.14112 6.27121 2.05542C6.43774 1.96972 6.63821 1.98427 6.79062 2.09313L13.7906 7.09314C13.922 7.18699 14 7.33853 14 7.5ZM7 3.4716L7 5.5C7 5.77614 6.77614 6 6.5 6L4 6L4 9L6.5 9C6.77614 9 7 9.22386 7 9.5L7 11.5284L12.6398 7.5L7 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4z = [
    "color"
];
var $c12e32cf04d921d4$export$edde007a504cdbfe = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 1C7.66148 1 7.81301 1.07798 7.90687 1.20938L12.9069 8.20938C13.0157 8.36179 13.0303 8.56226 12.9446 8.72879C12.8589 8.89533 12.6873 9 12.5 9H10V11.5C10 11.7761 9.77614 12 9.5 12H5.5C5.22386 12 5 11.7761 5 11.5V9H2.5C2.31271 9 2.14112 8.89533 2.05542 8.72879C1.96972 8.56226 1.98427 8.36179 2.09314 8.20938L7.09314 1.20938C7.18699 1.07798 7.33853 1 7.5 1ZM3.4716 8H5.5C5.77614 8 6 8.22386 6 8.5V11H9V8.5C9 8.22386 9.22386 8 9.5 8H11.5284L7.5 2.36023L3.4716 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4A = [
    "color"
];
var $c12e32cf04d921d4$export$579848c7cccecf3f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4B = [
    "color"
];
var $c12e32cf04d921d4$export$872ef4fe88315cc3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4C = [
    "color"
];
var $c12e32cf04d921d4$export$df10b15f2353def5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.0502 2.74989C13.0502 2.44613 12.804 2.19989 12.5002 2.19989C12.1965 2.19989 11.9502 2.44613 11.9502 2.74989V7.2825C11.9046 7.18802 11.8295 7.10851 11.7334 7.05776L2.73338 2.30776C2.5784 2.22596 2.3919 2.23127 2.24182 2.32176C2.09175 2.41225 2 2.57471 2 2.74995V12.25C2 12.4252 2.09175 12.5877 2.24182 12.6781C2.3919 12.7686 2.5784 12.7739 2.73338 12.6921L11.7334 7.94214C11.8295 7.89139 11.9046 7.81188 11.9502 7.7174V12.2499C11.9502 12.5536 12.1965 12.7999 12.5002 12.7999C12.804 12.7999 13.0502 12.5536 13.0502 12.2499V2.74989ZM3 11.4207V3.5792L10.4288 7.49995L3 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4D = [
    "color"
];
var $c12e32cf04d921d4$export$6130ef86fd52e250 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.94976 2.74989C1.94976 2.44613 2.196 2.19989 2.49976 2.19989C2.80351 2.19989 3.04976 2.44613 3.04976 2.74989V7.2825C3.0954 7.18802 3.17046 7.10851 3.26662 7.05776L12.2666 2.30776C12.4216 2.22596 12.6081 2.23127 12.7582 2.32176C12.9083 2.41225 13 2.57471 13 2.74995V12.25C13 12.4252 12.9083 12.5877 12.7582 12.6781C12.6081 12.7686 12.4216 12.7739 12.2666 12.6921L3.26662 7.94214C3.17046 7.89139 3.0954 7.81188 3.04976 7.7174V12.2499C3.04976 12.5536 2.80351 12.7999 2.49976 12.7999C2.196 12.7999 1.94976 12.5536 1.94976 12.2499V2.74989ZM4.57122 7.49995L12 11.4207V3.5792L4.57122 7.49995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4E = [
    "color"
];
var $c12e32cf04d921d4$export$ee1fdf1996836514 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4F = [
    "color"
];
var $c12e32cf04d921d4$export$287e71cda35821ff = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".25",
        d: "M0 0H3V3H0V0ZM6 3H3V6H0V9H3V12H0V15H3V12H6V15H9V12H12V15H15V12H12V9H15V6H12V3H15V0H12V3H9V0H6V3ZM6 6V3H9V6H6ZM6 9H3V6H6V9ZM9 9V6H12V9H9ZM9 9H6V12H9V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4G = [
    "color"
];
var $c12e32cf04d921d4$export$d23329de703dffc4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 1C5.22386 1 5 1.22386 5 1.5C5 1.77614 5.22386 2 5.5 2H9.5C9.77614 2 10 1.77614 10 1.5C10 1.22386 9.77614 1 9.5 1H5.5ZM3 3.5C3 3.22386 3.22386 3 3.5 3H5H10H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H11V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V4L3.5 4C3.22386 4 3 3.77614 3 3.5ZM5 4H10V12H5V4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4H = [
    "color"
];
var $c12e32cf04d921d4$export$b445c2dc6993f9f8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4 6H11L7.5 10.5L4 6Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4I = [
    "color"
];
var $c12e32cf04d921d4$export$62f44957433ecfbf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9 4L9 11L4.5 7.5L9 4Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4J = [
    "color"
];
var $c12e32cf04d921d4$export$43e4d35e8a44b537 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6 11L6 4L10.5 7.5L6 11Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4K = [
    "color"
];
var $c12e32cf04d921d4$export$9ff28f4659896371 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4 9H11L7.5 4.5L4 9Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4L = [
    "color"
];
var $c12e32cf04d921d4$export$890946d7e35b6ab9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.23336 4.69629C7.23336 2.96884 8.63335 1.56857 10.36 1.56857C11.3736 1.56857 12.183 2.04804 12.7254 2.74385C13.3079 2.62467 13.8557 2.40913 14.3513 2.11508C14.1559 2.72598 13.7424 3.2396 13.2033 3.56463C13.2038 3.56568 13.2042 3.56674 13.2047 3.56779C13.7334 3.50361 14.2364 3.36302 14.7048 3.15546L14.7037 3.15715C14.3667 3.66183 13.9431 4.10736 13.4561 4.47034C13.4823 4.64672 13.4956 4.82427 13.4956 5.00079C13.4956 8.6871 10.6873 12.9746 5.52122 12.9746C3.93906 12.9746 2.46544 12.511 1.22505 11.7152C0.992632 11.5661 0.925108 11.2568 1.07423 11.0244C1.0874 11.0038 1.10183 10.9846 1.11734 10.9666C1.20582 10.8202 1.37438 10.7309 1.5554 10.7522C2.47066 10.8601 3.38568 10.7485 4.19219 10.3962C3.39226 10.0434 2.77129 9.35975 2.50204 8.51974C2.45359 8.3686 2.48835 8.20311 2.59351 8.08422C2.59716 8.0801 2.60087 8.07606 2.60464 8.0721C1.96391 7.50819 1.55973 6.68208 1.55973 5.76143V5.72759C1.55973 5.56814 1.64411 5.42059 1.78155 5.33974C1.82671 5.31317 1.87537 5.29511 1.92532 5.28558C1.70549 4.86154 1.58116 4.37984 1.58116 3.86958C1.58116 3.40165 1.58384 2.81192 1.91332 2.28081C1.98718 2.16175 2.10758 2.08915 2.2364 2.07195C2.42588 2.01237 2.64087 2.06969 2.77406 2.23302C3.86536 3.57126 5.44066 4.49583 7.23366 4.73961L7.23336 4.69629ZM5.52122 11.9746C4.73387 11.9746 3.97781 11.8435 3.27248 11.6023C4.13012 11.4538 4.95307 11.1159 5.66218 10.5602C5.81211 10.4427 5.87182 10.2435 5.81126 10.0629C5.7507 9.88234 5.583 9.75943 5.39255 9.75607C4.68968 9.74366 4.06712 9.39716 3.67793 8.86845C3.86828 8.85306 4.05428 8.82039 4.23445 8.77167C4.43603 8.71716 4.57363 8.53114 4.56674 8.32243C4.55985 8.11372 4.41029 7.93718 4.20555 7.89607C3.42694 7.73977 2.79883 7.16764 2.56169 6.42174C2.76255 6.47025 2.97102 6.4991 3.18482 6.5061C3.38563 6.51267 3.56646 6.38533 3.62795 6.19405C3.68943 6.00277 3.61666 5.79391 3.44963 5.68224C2.86523 5.29155 2.48116 4.62464 2.48116 3.86958C2.48116 3.70213 2.48352 3.55268 2.49355 3.41719C3.85115 4.79913 5.70873 5.68931 7.77588 5.79338C7.93225 5.80126 8.08328 5.73543 8.18395 5.61553C8.28463 5.49562 8.32332 5.33548 8.28851 5.18284C8.25255 5.02517 8.23336 4.86284 8.23336 4.69629C8.23336 3.52085 9.18591 2.56857 10.36 2.56857C11.5943 2.56857 12.4956 3.71208 12.4956 5.00079C12.4956 8.25709 10.0202 11.9746 5.52122 11.9746Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4M = [
    "color"
];
var $c12e32cf04d921d4$export$4ce1642bb7f15c79 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4N = [
    "color"
];
var $c12e32cf04d921d4$export$35f5c3e250802cd1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4O = [
    "color"
];
var $c12e32cf04d921d4$export$8df90684a752ef81 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.81825 1.18188C7.64251 1.00615 7.35759 1.00615 7.18185 1.18188L4.18185 4.18188C4.00611 4.35762 4.00611 4.64254 4.18185 4.81828C4.35759 4.99401 4.64251 4.99401 4.81825 4.81828L7.05005 2.58648V9.49996C7.05005 9.74849 7.25152 9.94996 7.50005 9.94996C7.74858 9.94996 7.95005 9.74849 7.95005 9.49996V2.58648L10.1819 4.81828C10.3576 4.99401 10.6425 4.99401 10.8182 4.81828C10.994 4.64254 10.994 4.35762 10.8182 4.18188L7.81825 1.18188ZM2.5 9.99997C2.77614 9.99997 3 10.2238 3 10.5V12C3 12.5538 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2238 12.2239 9.99997 12.5 9.99997C12.7761 9.99997 13 10.2238 13 10.5V12C13 13.104 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2238 2.22386 9.99997 2.5 9.99997Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4P = [
    "color"
];
var $c12e32cf04d921d4$export$6e6352268496f418 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4Q = [
    "color"
];
var $c12e32cf04d921d4$export$aff958e91ee0391a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4R = [
    "color"
];
var $c12e32cf04d921d4$export$18bf59af111847c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49998 1L6.92321 2.00307L1.17498 12L0.599976 13H1.7535H13.2464H14.4L13.825 12L8.07674 2.00307L7.49998 1ZM7.49998 3.00613L2.3285 12H12.6714L7.49998 3.00613Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4S = [
    "color"
];
var $c12e32cf04d921d4$export$4ec8735ec23c8112 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.76447 3.12199C5.63151 3.04859 6.56082 3 7.5 3C8.43918 3 9.36849 3.04859 10.2355 3.12199C11.2796 3.21037 11.9553 3.27008 12.472 3.39203C12.9425 3.50304 13.2048 3.64976 13.4306 3.88086C13.4553 3.90618 13.4902 3.94414 13.5133 3.97092C13.7126 4.20149 13.8435 4.4887 13.918 5.03283C13.9978 5.6156 14 6.37644 14 7.52493C14 8.66026 13.9978 9.41019 13.9181 9.98538C13.8439 10.5206 13.7137 10.8061 13.5125 11.0387C13.4896 11.0651 13.4541 11.1038 13.4296 11.1287C13.2009 11.3625 12.9406 11.5076 12.4818 11.6164C11.9752 11.7365 11.3143 11.7942 10.2878 11.8797C9.41948 11.9521 8.47566 12 7.5 12C6.52434 12 5.58052 11.9521 4.7122 11.8797C3.68572 11.7942 3.02477 11.7365 2.51816 11.6164C2.05936 11.5076 1.7991 11.3625 1.57037 11.1287C1.54593 11.1038 1.51035 11.0651 1.48748 11.0387C1.28628 10.8061 1.15612 10.5206 1.08193 9.98538C1.00221 9.41019 1 8.66026 1 7.52493C1 6.37644 1.00216 5.6156 1.082 5.03283C1.15654 4.4887 1.28744 4.20149 1.48666 3.97092C1.5098 3.94414 1.54468 3.90618 1.56942 3.88086C1.7952 3.64976 2.05752 3.50304 2.52796 3.39203C3.04473 3.27008 3.7204 3.21037 4.76447 3.12199ZM0 7.52493C0 5.28296 0 4.16198 0.729985 3.31713C0.766457 3.27491 0.815139 3.22194 0.854123 3.18204C1.63439 2.38339 2.64963 2.29744 4.68012 2.12555C5.56923 2.05028 6.52724 2 7.5 2C8.47276 2 9.43077 2.05028 10.3199 2.12555C12.3504 2.29744 13.3656 2.38339 14.1459 3.18204C14.1849 3.22194 14.2335 3.27491 14.27 3.31713C15 4.16198 15 5.28296 15 7.52493C15 9.74012 15 10.8477 14.2688 11.6929C14.2326 11.7348 14.1832 11.7885 14.1444 11.8281C13.3629 12.6269 12.3655 12.71 10.3709 12.8763C9.47971 12.9505 8.50782 13 7.5 13C6.49218 13 5.52028 12.9505 4.62915 12.8763C2.63446 12.71 1.63712 12.6269 0.855558 11.8281C0.816844 11.7885 0.767442 11.7348 0.731221 11.6929C0 10.8477 0 9.74012 0 7.52493ZM5.25 5.38264C5.25 5.20225 5.43522 5.08124 5.60041 5.15369L10.428 7.27105C10.6274 7.35853 10.6274 7.64147 10.428 7.72895L5.60041 9.84631C5.43522 9.91876 5.25 9.79775 5.25 9.61736V5.38264Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4T = [
    "color"
];
var $c12e32cf04d921d4$export$6262053f5289408a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7 2H1.5C1.22386 2 1 2.22386 1 2.5V7H7V2ZM8 2V7H14V2.5C14 2.22386 13.7761 2 13.5 2H8ZM7 8H1V12.5C1 12.7761 1.22386 13 1.5 13H7V8ZM8 13V8H14V12.5C14 12.7761 13.7761 13 13.5 13H8ZM1.5 1C0.671573 1 0 1.67157 0 2.5V12.5C0 13.3284 0.671573 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.67157 14.3284 1 13.5 1H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4U = [
    "color"
];
var $c12e32cf04d921d4$export$832ec864fd299632 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 2H13.5C13.7761 2 14 2.22386 14 2.5V7H1V2.5C1 2.22386 1.22386 2 1.5 2ZM1 8V12.5C1 12.7761 1.22386 13 1.5 13H13.5C13.7761 13 14 12.7761 14 12.5V8H1ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4V = [
    "color"
];
var $c12e32cf04d921d4$export$c65e16705969a7a8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 2.58711L1.85163 13H13.5C13.7761 13 14 12.7761 14 12.5V2.58711ZM0.762879 13.8067L0.825396 13.8796L0.854717 13.8545C1.05017 13.9478 1.26899 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.93949 14.6926 1.45078 14.2371 1.19331L14.1746 1.12037L14.1453 1.1455C13.9498 1.05222 13.731 1 13.5 1H1.5C0.671573 1 0 1.67157 0 2.5V12.5C0 13.0605 0.307435 13.5492 0.762879 13.8067ZM1 12.4129L13.1484 2H1.5C1.22386 2 1 2.22386 1 2.5V12.4129Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4W = [
    "color"
];
var $c12e32cf04d921d4$export$96186050b98a4434 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 2H13.5C13.7761 2 14 2.22386 14 2.5V12.5C14 12.7761 13.7761 13 13.5 13H8V2ZM7 2H1.5C1.22386 2 1 2.22386 1 2.5V12.5C1 12.7761 1.22386 13 1.5 13H7V2ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4X = [
    "color"
];
var $c12e32cf04d921d4$export$815859cc984b9edf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.81812 4.68161C4.99386 4.85734 4.99386 5.14227 4.81812 5.318L3.08632 7.0498H11.9135L10.1817 5.318C10.006 5.14227 10.006 4.85734 10.1817 4.68161C10.3575 4.50587 10.6424 4.50587 10.8181 4.68161L13.3181 7.18161C13.4939 7.35734 13.4939 7.64227 13.3181 7.818L10.8181 10.318C10.6424 10.4937 10.3575 10.4937 10.1817 10.318C10.006 10.1423 10.006 9.85734 10.1817 9.68161L11.9135 7.9498H3.08632L4.81812 9.68161C4.99386 9.85734 4.99386 10.1423 4.81812 10.318C4.64239 10.4937 4.35746 10.4937 4.18173 10.318L1.68173 7.818C1.50599 7.64227 1.50599 7.35734 1.68173 7.18161L4.18173 4.68161C4.35746 4.50587 4.64239 4.50587 4.81812 4.68161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4Y = [
    "color"
];
var $c12e32cf04d921d4$export$418cedbcfc990387 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159ZM4.25 6.5C4.25 6.22386 4.47386 6 4.75 6H6V4.75C6 4.47386 6.22386 4.25 6.5 4.25C6.77614 4.25 7 4.47386 7 4.75V6H8.25C8.52614 6 8.75 6.22386 8.75 6.5C8.75 6.77614 8.52614 7 8.25 7H7V8.25C7 8.52614 6.77614 8.75 6.5 8.75C6.22386 8.75 6 8.52614 6 8.25V7H4.75C4.47386 7 4.25 6.77614 4.25 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4Z = [
    "color"
];
var $c12e32cf04d921d4$export$fbd55a4c69e8e024 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10ZM6.5 11C7.56251 11 8.53901 10.6318 9.30884 10.0159L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.0159 9.30884C10.6318 8.53901 11 7.56251 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM4.75 6C4.47386 6 4.25 6.22386 4.25 6.5C4.25 6.77614 4.47386 7 4.75 7H8.25C8.52614 7 8.75 6.77614 8.75 6.5C8.75 6.22386 8.52614 6 8.25 6H4.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});


const $692ecf0d7b095d7b$export$5e53b3ed4c9a8059 = ({ children: children, className: className })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("grid w-full auto-rows-[22rem] grid-cols-3 gap-4", className),
        children: children
    });
};
$692ecf0d7b095d7b$export$5e53b3ed4c9a8059.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string
};
const $692ecf0d7b095d7b$export$2eedce50b658acd9 = ({ name: name, className: className, background: background, Icon: Icon, description: description, href: href, cta: cta })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        role: "article",
        "aria-labelledby": `card-title-${name}`,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("group relative col-span-3 flex flex-col justify-between overflow-hidden rounded-xl", "bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]", "transform-gpu  ", className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                "aria-hidden": "true",
                children: background
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "z-10 flex transform-gpu flex-col gap-1 p-6 transition-all duration-300 group-hover:-translate-y-10",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)(Icon, {
                        className: "h-12 w-12 origin-left transform-gpu text-primary transition-all duration-300 ease-in-out group-hover:scale-75",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        id: `card-title-${name}`,
                        className: "text-xl font-semibold text-neutral-700 ",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "max-w-lg text-neutral-400",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("absolute bottom-0 flex w-full translate-y-10 transform-gpu flex-row items-center p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100"),
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                    variant: "ghost",
                    asChild: true,
                    size: "sm",
                    className: "pointer-events-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                        href: href,
                        "aria-label": `${cta} about ${name}`,
                        children: [
                            `Explore ${name}`,
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c12e32cf04d921d4$export$9ca09caa9c849d9c), {
                                className: "ml-2 h-4 w-4",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "absolute inset-0 transform-gpu transition-all duration-300 group-hover:bg-black/[.03] pointer-events-none",
                "aria-hidden": "true"
            })
        ]
    });
$692ecf0d7b095d7b$export$2eedce50b658acd9.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node.isRequired,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).elementType.isRequired,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    cta: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired
};



var $exYeM = parcelRequire("exYeM");
function $47fa6b3f68cecb86$var$CircleStackIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
    }));
}
const $47fa6b3f68cecb86$var$ForwardRef = $exYeM.forwardRef($47fa6b3f68cecb86$var$CircleStackIcon);
var $47fa6b3f68cecb86$export$2e2bcd8739ae039 = $47fa6b3f68cecb86$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $a3d3d3fe956a6344$var$CommandLineIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z"
    }));
}
const $a3d3d3fe956a6344$var$ForwardRef = $exYeM.forwardRef($a3d3d3fe956a6344$var$CommandLineIcon);
var $a3d3d3fe956a6344$export$2e2bcd8739ae039 = $a3d3d3fe956a6344$var$ForwardRef;


/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8cd740242243a8d0$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("FileText", [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $81ae0332a0e1c941$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Share2", [
    [
        "circle",
        {
            cx: "18",
            cy: "5",
            r: "3",
            key: "gq8acd"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "12",
            r: "3",
            key: "w7nqdw"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "19",
            r: "3",
            key: "1xt0gg"
        }
    ],
    [
        "line",
        {
            x1: "8.59",
            x2: "15.42",
            y1: "13.51",
            y2: "17.49",
            key: "47mynk"
        }
    ],
    [
        "line",
        {
            x1: "15.41",
            x2: "8.59",
            y1: "6.51",
            y2: "10.49",
            key: "1n3mei"
        }
    ]
]);



var $aSiaI = parcelRequire("aSiaI");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

const $bd0da382ab617ae1$export$8f41670e286dcb89 = ({ className: className, containerRef: containerRef, fromRef: fromRef, toRef: toRef, curvature: curvature = 0, reverse: reverse = false, duration: duration = Math.random() * 3 + 4, delay: delay = 0, pathColor: pathColor = "gray", pathWidth: pathWidth = 2, pathOpacity: pathOpacity = 0.2, gradientStartColor: gradientStartColor = "#ffaa40", gradientStopColor: gradientStopColor = "#9c40ff", startXOffset: startXOffset = 0, startYOffset: startYOffset = 0, endXOffset: endXOffset = 0, endYOffset: endYOffset = 0 })=>{
    const id = (0, $exYeM.useId)();
    const [pathD, setPathD] = (0, $exYeM.useState)("");
    const [svgDimensions, setSvgDimensions] = (0, $exYeM.useState)({
        width: 0,
        height: 0
    });
    const gradientCoordinates = reverse ? {
        x1: [
            "90%",
            "-10%"
        ],
        x2: [
            "100%",
            "0%"
        ],
        y1: [
            "0%",
            "0%"
        ],
        y2: [
            "0%",
            "0%"
        ]
    } : {
        x1: [
            "10%",
            "110%"
        ],
        x2: [
            "0%",
            "100%"
        ],
        y1: [
            "0%",
            "0%"
        ],
        y2: [
            "0%",
            "0%"
        ]
    };
    (0, $exYeM.useEffect)(()=>{
        const updatePath = ()=>{
            if (containerRef.current && fromRef.current && toRef.current) {
                const containerRect = containerRef.current.getBoundingClientRect();
                const rectA = fromRef.current.getBoundingClientRect();
                const rectB = toRef.current.getBoundingClientRect();
                const svgWidth = containerRect.width;
                const svgHeight = containerRect.height;
                setSvgDimensions({
                    width: svgWidth,
                    height: svgHeight
                });
                const startX = rectA.left - containerRect.left + rectA.width / 2 + startXOffset;
                const startY = rectA.top - containerRect.top + rectA.height / 2 + startYOffset;
                const endX = rectB.left - containerRect.left + rectB.width / 2 + endXOffset;
                const endY = rectB.top - containerRect.top + rectB.height / 2 + endYOffset;
                const controlY = startY - curvature;
                const d = `M ${startX},${startY} Q ${(startX + endX) / 2},${controlY} ${endX},${endY}`;
                setPathD(d);
            }
        };
        const resizeObserver = new ResizeObserver((entries)=>{
            for (let entry of entries)updatePath();
        });
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        updatePath();
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerRef,
        fromRef,
        toRef,
        curvature,
        startXOffset,
        startYOffset,
        endXOffset,
        endYOffset
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        fill: "none",
        width: svgDimensions.width,
        height: svgDimensions.height,
        xmlns: "http://www.w3.org/2000/svg",
        className: `pointer-events-none absolute left-0 top-0 transform-gpu stroke-2 ${className}`,
        viewBox: `0 0 ${svgDimensions.width} ${svgDimensions.height}`,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: pathD,
                stroke: pathColor,
                strokeWidth: pathWidth,
                strokeOpacity: pathOpacity,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: pathD,
                strokeWidth: pathWidth,
                stroke: `url(#${id})`,
                strokeOpacity: "1",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("defs", {
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).linearGradient, {
                    className: "transform-gpu",
                    id: id,
                    gradientUnits: "userSpaceOnUse",
                    initial: {
                        x1: "0%",
                        x2: "0%",
                        y1: "0%",
                        y2: "0%"
                    },
                    animate: {
                        x1: gradientCoordinates.x1,
                        x2: gradientCoordinates.x2,
                        y1: gradientCoordinates.y1,
                        y2: gradientCoordinates.y2
                    },
                    transition: {
                        delay: delay,
                        duration: duration,
                        ease: [
                            0.16,
                            1,
                            0.3,
                            1
                        ],
                        repeat: Infinity,
                        repeatDelay: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                            stopColor: "#FA9173",
                            stopOpacity: "0"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                            stopColor: "#FA9173"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                            offset: "32.5%",
                            stopColor: "#FA9173"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                            offset: "100%",
                            stopColor: "#FA9173",
                            stopOpacity: "0"
                        })
                    ]
                })
            })
        ]
    });
};



var $exYeM = parcelRequire("exYeM");





var $671afd5da85dc45e$exports = {};

$671afd5da85dc45e$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "clickhouse.53526bb6.svg";



const $4086389d2a4d3813$var$Circle = /*#__PURE__*/ (0, $exYeM.forwardRef)(function Circle({ className: className, children: children }, ref) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $ff07379829b191ac$export$1343a74baacb0543)("z-10 flex h-12 w-12 items-center justify-center rounded-full border-2 bg-white p-3 ", className),
        children: children
    });
});
function $4086389d2a4d3813$export$2e2bcd8739ae039() {
    const containerRef = (0, $exYeM.useRef)(null);
    const div1Ref = (0, $exYeM.useRef)(null);
    const div2Ref = (0, $exYeM.useRef)(null);
    const div3Ref = (0, $exYeM.useRef)(null);
    const div4Ref = (0, $exYeM.useRef)(null);
    const div5Ref = (0, $exYeM.useRef)(null);
    const div6Ref = (0, $exYeM.useRef)(null);
    const div7Ref = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative flex w-full max-w-[500px] items-center justify-center overflow-hidden rounded-lg ",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex h-full w-full flex-col items-stretch justify-between gap-10",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-row items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Circle, {
                                ref: div1Ref,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Icons.base, {})
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Circle, {
                                ref: div5Ref,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Icons.bitcoin, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-row items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Circle, {
                                ref: div2Ref,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Icons.linea, {})
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Circle, {
                                ref: div4Ref,
                                className: "h-16 w-16",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Icons.clickhouse, {})
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Circle, {
                                ref: div6Ref,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Icons.ethereum, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-row items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Circle, {
                                ref: div3Ref,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Icons.gnosis, {})
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Circle, {
                                ref: div7Ref,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($4086389d2a4d3813$var$Icons.optimism, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bd0da382ab617ae1$export$8f41670e286dcb89), {
                containerRef: containerRef,
                fromRef: div1Ref,
                toRef: div4Ref,
                curvature: -75,
                endYOffset: -10
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bd0da382ab617ae1$export$8f41670e286dcb89), {
                containerRef: containerRef,
                fromRef: div2Ref,
                toRef: div4Ref
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bd0da382ab617ae1$export$8f41670e286dcb89), {
                containerRef: containerRef,
                fromRef: div3Ref,
                toRef: div4Ref,
                curvature: 75,
                endYOffset: 10
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bd0da382ab617ae1$export$8f41670e286dcb89), {
                containerRef: containerRef,
                fromRef: div5Ref,
                toRef: div4Ref,
                curvature: -75,
                endYOffset: -10,
                reverse: true
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bd0da382ab617ae1$export$8f41670e286dcb89), {
                containerRef: containerRef,
                fromRef: div6Ref,
                toRef: div4Ref,
                reverse: true
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bd0da382ab617ae1$export$8f41670e286dcb89), {
                containerRef: containerRef,
                fromRef: div7Ref,
                toRef: div4Ref,
                curvature: 75,
                endYOffset: 10,
                reverse: true
            })
        ]
    });
}
const $4086389d2a4d3813$var$Icons = {
    base: ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2fe487a530bddc88$exports))),
            alt: "Base Logo",
            width: "100",
            height: "100"
        }),
    bitcoin: ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4384bf61a71023b3$exports))),
            alt: "Bitcoin Logo",
            width: "100",
            height: "100"
        }),
    linea: ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ac91fd8f1dffc709$exports))),
            alt: "Linea Logo",
            width: "100",
            height: "100"
        }),
    ethereum: ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ab932b76935e91c1$exports))),
            alt: "Ethereum Logo",
            width: "100",
            height: "100"
        }),
    gnosis: ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($08c17a8711343249$exports))),
            alt: "Gnosis Logo",
            width: "100",
            height: "100"
        }),
    clickhouse: ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($671afd5da85dc45e$exports))),
            alt: "Clickhouse Logo",
            width: "100",
            height: "100"
        }),
    optimism: ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($61370147c2b77474$exports))),
            alt: "Zora Logo",
            width: "100",
            height: "100"
        })
};



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
const $f2e44304997303f6$var$ChartBar = ({ cursor: cursor, cardRef: cardRef, mouseOnCard: mouseOnCard })=>{
    const [gradientCenter, setGradientCenter] = (0, $exYeM.useState)({
        cx: "50%",
        cy: "50%"
    });
    (0, $exYeM.useEffect)(()=>{
        if (cardRef.current && cursor.x != null && cursor.y != null) {
            const cardRect = cardRef.current.getBoundingClientRect();
            const cxPercentage = cursor.x / cardRect.width * 100 - 24;
            const cyPercentage = cursor.y / cardRect.height * 100;
            setGradientCenter({
                cx: `${cxPercentage}%`,
                cy: `${cyPercentage}%`
            });
        }
    }, [
        cursor,
        cardRef
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        className: "w-96 h-96 duration-200 transition-all",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("defs", {
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("radialGradient", {
                    id: "emeraldGradient",
                    gradientUnits: "userSpaceOnUse",
                    cx: gradientCenter.cx,
                    cy: gradientCenter.cy,
                    r: "35%",
                    children: [
                        mouseOnCard && /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                            stopColor: "#FA9173"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                            offset: 1,
                            stopColor: "#404040"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                className: "fill-gray-500/50 ",
                stroke: "url(#emeraldGradient)",
                d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
            })
        ]
    });
};
var $f2e44304997303f6$export$2e2bcd8739ae039 = $f2e44304997303f6$var$ChartBar;


function $f4f51f43f7cd3dad$var$HoverImage({ link: link }) {
    const cardsRef = (0, $exYeM.useRef)(null);
    const [cursor, setCursor] = (0, $exYeM.useState)({
        x: 0,
        y: 0
    });
    const [mouseOnCard, setMouseOnCard] = (0, $exYeM.useState)(false);
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const handleMouseMove = (event)=>{
        if (cardsRef.current != null) {
            const rect = cardsRef.current.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            setCursor({
                x: x,
                y: y
            });
        }
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") navigate(link);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("section", {
        ref: cardsRef,
        onMouseMove: handleMouseMove,
        onMouseEnter: ()=>setMouseOnCard(true),
        onMouseLeave: ()=>setMouseOnCard(false),
        onClick: ()=>navigate(link),
        onKeyDown: handleKeyDown,
        role: "button",
        tabIndex: 0,
        className: "relative w-full h-[26rem] rounded-lg flex flex-row p-8 justify-between stroke-[0.1] hover:stroke-[0.2] cursor-pointer",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex flex-col w-2/5 justify-between"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-3/5 flex flex-col place-items-center p-4",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f2e44304997303f6$export$2e2bcd8739ae039), {
                    cursor: cursor,
                    cardRef: cardsRef,
                    mouseOnCard: mouseOnCard
                })
            })
        ]
    });
}
var $f4f51f43f7cd3dad$export$2e2bcd8739ae039 = $f4f51f43f7cd3dad$var$HoverImage;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

function $32dbda48f15f6422$var$TypingAnimation({ text: text, className: className, typingSpeed: typingSpeed = 50, deletingSpeed: deletingSpeed = 30, pauseDuration: pauseDuration = 100 }) {
    const [displayedText, setDisplayedText] = (0, $exYeM.useState)("");
    const [isTyping, setIsTyping] = (0, $exYeM.useState)(true);
    const [isDeleting, setIsDeleting] = (0, $exYeM.useState)(false);
    const [isPaused, setIsPaused] = (0, $exYeM.useState)(false);
    const [currentTextIndex, setCurrentTextIndex] = (0, $exYeM.useState)(0);
    const texts = Array.isArray(text) ? text : [
        text
    ];
    const moveToNextText = (0, $exYeM.useCallback)(()=>{
        setCurrentTextIndex((prevIndex)=>(prevIndex + 1) % texts.length);
        setIsTyping(true);
        setIsDeleting(false);
        setIsPaused(false);
        setDisplayedText("");
    }, [
        texts.length
    ]);
    // Handle typing and deleting
    (0, $exYeM.useEffect)(()=>{
        let timer;
        if (isTyping && !isPaused) {
            if (displayedText.length < texts[currentTextIndex].length) timer = setTimeout(()=>{
                setDisplayedText(texts[currentTextIndex].slice(0, displayedText.length + 1));
            }, typingSpeed);
            else {
                setIsTyping(false);
                setIsPaused(true);
            }
        } else if (isDeleting && !isPaused) {
            if (displayedText.length > 0) timer = setTimeout(()=>{
                setDisplayedText(displayedText.slice(0, -1));
            }, deletingSpeed);
            else moveToNextText();
        }
        return ()=>clearTimeout(timer);
    }, [
        displayedText,
        isTyping,
        isDeleting,
        isPaused,
        currentTextIndex,
        texts,
        typingSpeed,
        deletingSpeed,
        moveToNextText
    ]);
    // Handle pause and transition to deleting
    (0, $exYeM.useEffect)(()=>{
        let pauseTimer;
        if (isPaused) pauseTimer = setTimeout(()=>{
            setIsPaused(false);
            setIsDeleting(true);
        }, pauseDuration);
        return ()=>clearTimeout(pauseTimer);
    }, [
        isPaused,
        pauseDuration
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        className: (0, $ff07379829b191ac$export$1343a74baacb0543)("font-mono whitespace-pre-wrap break-words", className),
        children: displayedText
    });
}
var $32dbda48f15f6422$export$2e2bcd8739ae039 = $32dbda48f15f6422$var$TypingAnimation;


var $bdf625fc24abd869$exports = {};
/*
 Highcharts JS v11.1.0 (2023-06-05)

 (c) 2009-2021 Torstein Honsi

 License: www.highcharts.com/license
*/ "use strict";
(function(U, M) {
    (0, $bdf625fc24abd869$exports) ? (M["default"] = M, $bdf625fc24abd869$exports = U.document ? M(U) : M) : "function" === typeof define && define.amd ? define("highcharts/highcharts", function() {
        return M(U);
    }) : (U.Highcharts && U.Highcharts.error(16, !0), U.Highcharts = M(U));
})("undefined" !== typeof window ? window : $bdf625fc24abd869$exports, function(U) {
    function M(a, y, I, L) {
        a.hasOwnProperty(y) || (a[y] = L.apply(null, I), "function" === typeof CustomEvent && U.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: y,
                module: a[y]
            }
        })));
    }
    var a = {};
    M(a, "Core/Globals.js", [], function() {
        var a;
        (function(a) {
            a.SVG_NS = "http://www.w3.org/2000/svg";
            a.product = "Highcharts";
            a.version = "11.1.0";
            a.win = "undefined" !== typeof U ? U : {};
            a.doc = a.win.document;
            a.svg = a.doc && a.doc.createElementNS && !!a.doc.createElementNS(a.SVG_NS, "svg").createSVGRect;
            a.userAgent = a.win.navigator && a.win.navigator.userAgent || "";
            a.isChrome = -1 !== a.userAgent.indexOf("Chrome");
            a.isFirefox = -1 !== a.userAgent.indexOf("Firefox");
            a.isMS = /(edge|msie|trident)/i.test(a.userAgent) && !a.win.opera;
            a.isSafari = !a.isChrome && -1 !== a.userAgent.indexOf("Safari");
            a.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(a.userAgent);
            a.isWebKit = -1 !== a.userAgent.indexOf("AppleWebKit");
            a.deg2rad = 2 * Math.PI / 360;
            a.hasBidiBug = a.isFirefox && 4 > parseInt(a.userAgent.split("Firefox/")[1], 10);
            a.hasTouch = !!a.win.TouchEvent;
            a.marginNames = [
                "plotTop",
                "marginRight",
                "marginBottom",
                "plotLeft"
            ];
            a.noop = function() {};
            a.supportsPassiveEvents = function() {
                let x = !1;
                if (!a.isMS) {
                    const y = Object.defineProperty({}, "passive", {
                        get: function() {
                            x = !0;
                        }
                    });
                    a.win.addEventListener && a.win.removeEventListener && (a.win.addEventListener("testPassive", a.noop, y), a.win.removeEventListener("testPassive", a.noop, y));
                }
                return x;
            }();
            a.charts = [];
            a.dateFormats = {};
            a.seriesTypes = {};
            a.symbolSizes = {};
            a.chartCount = 0;
        })(a || (a = {}));
        "";
        return a;
    });
    M(a, "Core/Utilities.js", [
        a["Core/Globals.js"]
    ], function(a) {
        function x(c, b, f, k) {
            const n = b ? "Highcharts error" : "Highcharts warning";
            32 === c && (c = `${n}: Deprecated member`);
            const r = u(c);
            let e = r ? `${n} #${c}: www.highcharts.com/errors/${c}/` : c.toString();
            if ("undefined" !== typeof k) {
                let c = "";
                r && (e += "?");
                E(k, function(b, n) {
                    c += `\n - ${n}: ${b}`;
                    r && (e += encodeURI(n) + "=" + encodeURI(b));
                });
                e += c;
            }
            d(a, "displayError", {
                chart: f,
                code: c,
                message: e,
                params: k
            }, function() {
                if (b) throw Error(e);
                q.console && -1 === x.messages.indexOf(e) && console.warn(e);
            });
            x.messages.push(e);
        }
        function I(c, b) {
            return parseInt(c, b || 10);
        }
        function L(c) {
            return "string" === typeof c;
        }
        function C(c) {
            c = Object.prototype.toString.call(c);
            return "[object Array]" === c || "[object Array Iterator]" === c;
        }
        function z(c, b) {
            return !!c && "object" === typeof c && (!b || !C(c));
        }
        function H(c) {
            return z(c) && "number" === typeof c.nodeType;
        }
        function B(c) {
            const b = c && c.constructor;
            return !(!z(c, !0) || H(c) || !b || !b.name || "Object" === b.name);
        }
        function u(c) {
            return "number" === typeof c && !isNaN(c) && Infinity > c && -Infinity < c;
        }
        function v(c) {
            return "undefined" !== typeof c && null !== c;
        }
        function l(c, b, f) {
            const n = L(b) && !v(f);
            let d;
            const k = (b, f)=>{
                v(b) ? c.setAttribute(f, b) : n ? (d = c.getAttribute(f)) || "class" !== f || (d = c.getAttribute(f + "Name")) : c.removeAttribute(f);
            };
            L(b) ? k(f, b) : E(b, k);
            return d;
        }
        function p(c) {
            return C(c) ? c : [
                c
            ];
        }
        function t(c, b) {
            let n;
            c || (c = {});
            for(n in b)c[n] = b[n];
            return c;
        }
        function m() {
            const c = arguments, b = c.length;
            for(let n = 0; n < b; n++){
                const b = c[n];
                if ("undefined" !== typeof b && null !== b) return b;
            }
        }
        function h(c, b) {
            a.isMS && !a.svg && b && v(b.opacity) && (b.filter = `alpha(opacity=${100 * b.opacity})`);
            t(c.style, b);
        }
        function g(c) {
            return Math.pow(10, Math.floor(Math.log(c) / Math.LN10));
        }
        function e(c, b) {
            return 1E14 < c ? c : parseFloat(c.toPrecision(b || 14));
        }
        function w(c, b, f) {
            let n;
            if ("width" === b) return b = Math.min(c.offsetWidth, c.scrollWidth), f = c.getBoundingClientRect && c.getBoundingClientRect().width, f < b && f >= b - 1 && (b = Math.floor(f)), Math.max(0, b - (w(c, "padding-left", !0) || 0) - (w(c, "padding-right", !0) || 0));
            if ("height" === b) return Math.max(0, Math.min(c.offsetHeight, c.scrollHeight) - (w(c, "padding-top", !0) || 0) - (w(c, "padding-bottom", !0) || 0));
            if (c = q.getComputedStyle(c, void 0)) n = c.getPropertyValue(b), m(f, "opacity" !== b) && (n = I(n));
            return n;
        }
        function E(c, b, f) {
            for(const n in c)Object.hasOwnProperty.call(c, n) && b.call(f || c[n], c[n], n, c);
        }
        function F(c, b, f) {
            function n(b, n) {
                const f = c.removeEventListener;
                f && f.call(c, b, n, !1);
            }
            function d(f) {
                let d, K;
                c.nodeName && (b ? (d = {}, d[b] = !0) : d = f, E(d, function(c, b) {
                    if (f[b]) for(K = f[b].length; K--;)n(b, f[b][K].fn);
                }));
            }
            var k = "function" === typeof c && c.prototype || c;
            if (Object.hasOwnProperty.call(k, "hcEvents")) {
                const c = k.hcEvents;
                b ? (k = c[b] || [], f ? (c[b] = k.filter(function(c) {
                    return f !== c.fn;
                }), n(b, f)) : (d(c), c[b] = [])) : (d(c), delete k.hcEvents);
            }
        }
        function d(c, b, f, d) {
            f = f || {};
            if (r.createEvent && (c.dispatchEvent || c.fireEvent && c !== a)) {
                var n = r.createEvent("Events");
                n.initEvent(b, !0, !0);
                f = t(n, f);
                c.dispatchEvent ? c.dispatchEvent(f) : c.fireEvent(b, f);
            } else if (c.hcEvents) {
                f.target || t(f, {
                    preventDefault: function() {
                        f.defaultPrevented = !0;
                    },
                    target: c,
                    type: b
                });
                n = [];
                let d = c, K = !1;
                for(; d.hcEvents;)Object.hasOwnProperty.call(d, "hcEvents") && d.hcEvents[b] && (n.length && (K = !0), n.unshift.apply(n, d.hcEvents[b])), d = Object.getPrototypeOf(d);
                K && n.sort((c, b)=>c.order - b.order);
                n.forEach((b)=>{
                    !1 === b.fn.call(c, f) && f.preventDefault();
                });
            }
            d && !f.defaultPrevented && d.call(c, f);
        }
        const { charts: k, doc: r, win: q } = a;
        (x || (x = {})).messages = [];
        Math.easeInOutSine = function(c) {
            return -0.5 * (Math.cos(Math.PI * c) - 1);
        };
        var G = Array.prototype.find ? function(c, b) {
            return c.find(b);
        } : function(c, b) {
            let f;
            const n = c.length;
            for(f = 0; f < n; f++)if (b(c[f], f)) return c[f];
        };
        E({
            map: "map",
            each: "forEach",
            grep: "filter",
            reduce: "reduce",
            some: "some"
        }, function(c, b) {
            a[b] = function(f) {
                x(32, !1, void 0, {
                    [`Highcharts.${b}`]: `use Array.${c}`
                });
                return Array.prototype[c].apply(f, [].slice.call(arguments, 1));
            };
        });
        let b;
        const f = function() {
            const c = Math.random().toString(36).substring(2, 9) + "-";
            let f = 0;
            return function() {
                return "highcharts-" + (b ? "" : c) + f++;
            };
        }();
        q.jQuery && (q.jQuery.fn.highcharts = function() {
            const c = [].slice.call(arguments);
            if (this[0]) return c[0] ? (new a[L(c[0]) ? c.shift() : "Chart"](this[0], c[0], c[1]), this) : k[l(this[0], "data-highcharts-chart")];
        });
        G = {
            addEvent: function(c, b, f, d = {}) {
                var n = "function" === typeof c && c.prototype || c;
                Object.hasOwnProperty.call(n, "hcEvents") || (n.hcEvents = {});
                n = n.hcEvents;
                a.Point && c instanceof a.Point && c.series && c.series.chart && (c.series.chart.runTrackerClick = !0);
                const k = c.addEventListener;
                k && k.call(c, b, f, a.supportsPassiveEvents ? {
                    passive: void 0 === d.passive ? -1 !== b.indexOf("touch") : d.passive,
                    capture: !1
                } : !1);
                n[b] || (n[b] = []);
                n[b].push({
                    fn: f,
                    order: "number" === typeof d.order ? d.order : Infinity
                });
                n[b].sort((c, b)=>c.order - b.order);
                return function() {
                    F(c, b, f);
                };
            },
            arrayMax: function(c) {
                let b = c.length, f = c[0];
                for(; b--;)c[b] > f && (f = c[b]);
                return f;
            },
            arrayMin: function(c) {
                let b = c.length, f = c[0];
                for(; b--;)c[b] < f && (f = c[b]);
                return f;
            },
            attr: l,
            clamp: function(c, b, f) {
                return c > b ? c < f ? c : f : b;
            },
            clearTimeout: function(c) {
                v(c) && clearTimeout(c);
            },
            correctFloat: e,
            createElement: function(c, b, f, d, K) {
                c = r.createElement(c);
                b && t(c, b);
                K && h(c, {
                    padding: "0",
                    border: "none",
                    margin: "0"
                });
                f && h(c, f);
                d && d.appendChild(c);
                return c;
            },
            css: h,
            defined: v,
            destroyObjectProperties: function(c, b) {
                E(c, function(f, n) {
                    f && f !== b && f.destroy && f.destroy();
                    delete c[n];
                });
            },
            diffObjects: function(c, b, f, d) {
                function n(b, c, K, k) {
                    const A = f ? c : b;
                    E(b, function(f, q) {
                        if (!k && d && -1 < d.indexOf(q) && c[q]) {
                            f = p(f);
                            K[q] = [];
                            for(let b = 0; b < Math.max(f.length, c[q].length); b++)c[q][b] && (void 0 === f[b] ? K[q][b] = c[q][b] : (K[q][b] = {}, n(f[b], c[q][b], K[q][b], k + 1)));
                        } else if (z(f, !0) && !f.nodeType) K[q] = C(f) ? [] : {}, n(f, c[q] || {}, K[q], k + 1), 0 !== Object.keys(K[q]).length || "colorAxis" === q && 0 === k || delete K[q];
                        else if (b[q] !== c[q] || q in b && !(q in c)) K[q] = A[q];
                    });
                }
                const k = {};
                n(c, b, k, 0);
                return k;
            },
            discardElement: function(b) {
                b && b.parentElement && b.parentElement.removeChild(b);
            },
            erase: function(b, f) {
                let c = b.length;
                for(; c--;)if (b[c] === f) {
                    b.splice(c, 1);
                    break;
                }
            },
            error: x,
            extend: t,
            extendClass: function(b, f) {
                const c = function() {};
                c.prototype = new b;
                t(c.prototype, f);
                return c;
            },
            find: G,
            fireEvent: d,
            getClosestDistance: function(b, f) {
                const c = !f;
                let d, n, k, q;
                b.forEach((b)=>{
                    if (1 < b.length) for(q = n = b.length - 1; 0 < q; q--)k = b[q] - b[q - 1], 0 > k && !c ? (null === f || void 0 === f || f(), f = void 0) : k && ("undefined" === typeof d || k < d) && (d = k);
                });
                return d;
            },
            getMagnitude: g,
            getNestedProperty: function(b, f) {
                for(b = b.split("."); b.length && v(f);){
                    const c = b.shift();
                    if ("undefined" === typeof c || "__proto__" === c) return;
                    if ("this" === c) {
                        let b;
                        z(f) && (b = f["@this"]);
                        return null !== b && void 0 !== b ? b : f;
                    }
                    f = f[c];
                    if (!v(f) || "function" === typeof f || "number" === typeof f.nodeType || f === q) return;
                }
                return f;
            },
            getStyle: w,
            inArray: function(b, f, d) {
                x(32, !1, void 0, {
                    "Highcharts.inArray": "use Array.indexOf"
                });
                return f.indexOf(b, d);
            },
            insertItem: function(b, f) {
                const c = b.options.index, d = f.length;
                let n;
                for(n = b.options.isInternal ? d : 0; n < d + 1; n++)if (!f[n] || u(c) && c < m(f[n].options.index, f[n]._i) || f[n].options.isInternal) {
                    f.splice(n, 0, b);
                    break;
                }
                return n;
            },
            isArray: C,
            isClass: B,
            isDOMElement: H,
            isFunction: function(b) {
                return "function" === typeof b;
            },
            isNumber: u,
            isObject: z,
            isString: L,
            keys: function(b) {
                x(32, !1, void 0, {
                    "Highcharts.keys": "use Object.keys"
                });
                return Object.keys(b);
            },
            merge: function() {
                let b, f = arguments, d = {};
                const k = function(b, c) {
                    "object" !== typeof b && (b = {});
                    E(c, function(f, d) {
                        "__proto__" !== d && "constructor" !== d && (!z(f, !0) || B(f) || H(f) ? b[d] = c[d] : b[d] = k(b[d] || {}, f));
                    });
                    return b;
                };
                !0 === f[0] && (d = f[1], f = Array.prototype.slice.call(f, 2));
                const K = f.length;
                for(b = 0; b < K; b++)d = k(d, f[b]);
                return d;
            },
            normalizeTickInterval: function(b, f, d, k, K) {
                let c = b;
                d = m(d, g(b));
                const n = b / d;
                f || (f = K ? [
                    1,
                    1.2,
                    1.5,
                    2,
                    2.5,
                    3,
                    4,
                    5,
                    6,
                    8,
                    10
                ] : [
                    1,
                    2,
                    2.5,
                    5,
                    10
                ], !1 === k && (1 === d ? f = f.filter(function(b) {
                    return 0 === b % 1;
                }) : .1 >= d && (f = [
                    1 / d
                ])));
                for(k = 0; k < f.length && !(c = f[k], K && c * d >= b || !K && n <= (f[k] + (f[k + 1] || f[k])) / 2); k++);
                return c = e(c * d, -Math.round(Math.log(.001) / Math.LN10));
            },
            objectEach: E,
            offset: function(b) {
                const c = r.documentElement;
                b = b.parentElement || b.parentNode ? b.getBoundingClientRect() : {
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0
                };
                return {
                    top: b.top + (q.pageYOffset || c.scrollTop) - (c.clientTop || 0),
                    left: b.left + (q.pageXOffset || c.scrollLeft) - (c.clientLeft || 0),
                    width: b.width,
                    height: b.height
                };
            },
            pad: function(b, f, d) {
                return Array((f || 2) + 1 - String(b).replace("-", "").length).join(d || "0") + b;
            },
            pick: m,
            pInt: I,
            pushUnique: function(b, f) {
                return 0 > b.indexOf(f) && !!b.push(f);
            },
            relativeLength: function(b, f, d) {
                return /%$/.test(b) ? f * parseFloat(b) / 100 + (d || 0) : parseFloat(b);
            },
            removeEvent: F,
            splat: p,
            stableSort: function(b, f) {
                const c = b.length;
                let d, k;
                for(k = 0; k < c; k++)b[k].safeI = k;
                b.sort(function(b, c) {
                    d = f(b, c);
                    return 0 === d ? b.safeI - c.safeI : d;
                });
                for(k = 0; k < c; k++)delete b[k].safeI;
            },
            syncTimeout: function(b, f, d) {
                if (0 < f) return setTimeout(b, f, d);
                b.call(0, d);
                return -1;
            },
            timeUnits: {
                millisecond: 1,
                second: 1E3,
                minute: 6E4,
                hour: 36E5,
                day: 864E5,
                week: 6048E5,
                month: 24192E5,
                year: 314496E5
            },
            uniqueKey: f,
            useSerialIds: function(c) {
                return b = m(c, b);
            },
            wrap: function(b, f, d) {
                const c = b[f];
                b[f] = function() {
                    const b = arguments, f = this;
                    return d.apply(this, [
                        function() {
                            return c.apply(f, arguments.length ? arguments : b);
                        }
                    ].concat([].slice.call(arguments)));
                };
            }
        };
        "";
        return G;
    });
    M(a, "Core/Chart/ChartDefaults.js", [], function() {
        return {
            alignThresholds: !1,
            panning: {
                enabled: !1,
                type: "x"
            },
            styledMode: !1,
            borderRadius: 0,
            colorCount: 10,
            allowMutatingData: !0,
            ignoreHiddenSeries: !0,
            spacing: [
                10,
                10,
                15,
                10
            ],
            resetZoomButton: {
                theme: {
                    zIndex: 6
                },
                position: {
                    align: "right",
                    x: -10,
                    y: 10
                }
            },
            reflow: !0,
            type: "line",
            zooming: {
                singleTouch: !1,
                resetButton: {
                    theme: {
                        zIndex: 6
                    },
                    position: {
                        align: "right",
                        x: -10,
                        y: 10
                    }
                }
            },
            width: null,
            height: null,
            borderColor: "#334eff",
            backgroundColor: "#ffffff",
            plotBorderColor: "#cccccc"
        };
    });
    M(a, "Core/Color/Color.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        const { isNumber: x, merge: L, pInt: C } = y;
        class z {
            static parse(a) {
                return a ? new z(a) : z.None;
            }
            constructor(x){
                this.rgba = [
                    NaN,
                    NaN,
                    NaN,
                    NaN
                ];
                this.input = x;
                const B = a.Color;
                if (B && B !== z) return new B(x);
                this.init(x);
            }
            init(a) {
                let B;
                let u;
                if ("object" === typeof a && "undefined" !== typeof a.stops) this.stops = a.stops.map((l)=>new z(l[1]));
                else if ("string" === typeof a) {
                    this.input = a = z.names[a.toLowerCase()] || a;
                    if ("#" === a.charAt(0)) {
                        var v = a.length;
                        var l = parseInt(a.substr(1), 16);
                        7 === v ? B = [
                            (l & 16711680) >> 16,
                            (l & 65280) >> 8,
                            l & 255,
                            1
                        ] : 4 === v && (B = [
                            (l & 3840) >> 4 | (l & 3840) >> 8,
                            (l & 240) >> 4 | l & 240,
                            (l & 15) << 4 | l & 15,
                            1
                        ]);
                    }
                    if (!B) for(l = z.parsers.length; l-- && !B;)u = z.parsers[l], (v = u.regex.exec(a)) && (B = u.parse(v));
                }
                B && (this.rgba = B);
            }
            get(a) {
                const B = this.input, u = this.rgba;
                if ("object" === typeof B && "undefined" !== typeof this.stops) {
                    const v = L(B);
                    v.stops = [].slice.call(v.stops);
                    this.stops.forEach((l, p)=>{
                        v.stops[p] = [
                            v.stops[p][0],
                            l.get(a)
                        ];
                    });
                    return v;
                }
                return u && x(u[0]) ? "rgb" === a || !a && 1 === u[3] ? "rgb(" + u[0] + "," + u[1] + "," + u[2] + ")" : "a" === a ? `${u[3]}` : "rgba(" + u.join(",") + ")" : B;
            }
            brighten(a) {
                const B = this.rgba;
                if (this.stops) this.stops.forEach(function(u) {
                    u.brighten(a);
                });
                else if (x(a) && 0 !== a) for(let u = 0; 3 > u; u++)B[u] += C(255 * a), 0 > B[u] && (B[u] = 0), 255 < B[u] && (B[u] = 255);
                return this;
            }
            setOpacity(a) {
                this.rgba[3] = a;
                return this;
            }
            tweenTo(a, B) {
                const u = this.rgba, v = a.rgba;
                if (!x(u[0]) || !x(v[0])) return a.input || "none";
                a = 1 !== v[3] || 1 !== u[3];
                return (a ? "rgba(" : "rgb(") + Math.round(v[0] + (u[0] - v[0]) * (1 - B)) + "," + Math.round(v[1] + (u[1] - v[1]) * (1 - B)) + "," + Math.round(v[2] + (u[2] - v[2]) * (1 - B)) + (a ? "," + (v[3] + (u[3] - v[3]) * (1 - B)) : "") + ")";
            }
        }
        z.names = {
            white: "#ffffff",
            black: "#000000"
        };
        z.parsers = [
            {
                regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
                parse: function(a) {
                    return [
                        C(a[1]),
                        C(a[2]),
                        C(a[3]),
                        parseFloat(a[4], 10)
                    ];
                }
            },
            {
                regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
                parse: function(a) {
                    return [
                        C(a[1]),
                        C(a[2]),
                        C(a[3]),
                        1
                    ];
                }
            }
        ];
        z.None = new z("");
        "";
        return z;
    });
    M(a, "Core/Color/Palettes.js", [], function() {
        return {
            colors: "#2caffe #544fc5 #00e272 #fe6a35 #6b8abc #d568fb #2ee0ca #fa4b42 #feb56a #91e8e1".split(" ")
        };
    });
    M(a, "Core/Time.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        const { win: x } = a, { defined: L, error: C, extend: z, isObject: H, merge: B, objectEach: u, pad: v, pick: l, splat: p, timeUnits: t } = y, m = a.isSafari && x.Intl && x.Intl.DateTimeFormat.prototype.formatRange, h = a.isSafari && x.Intl && !x.Intl.DateTimeFormat.prototype.formatRange;
        class g {
            constructor(e){
                this.options = {};
                this.variableTimezone = this.useUTC = !1;
                this.Date = x.Date;
                this.getTimezoneOffset = this.timezoneOffsetFunction();
                this.update(e);
            }
            get(e, g) {
                if (this.variableTimezone || this.timezoneOffset) {
                    const h = g.getTime(), m = h - this.getTimezoneOffset(g);
                    g.setTime(m);
                    e = g["getUTC" + e]();
                    g.setTime(h);
                    return e;
                }
                return this.useUTC ? g["getUTC" + e]() : g["get" + e]();
            }
            set(e, g, h) {
                if (this.variableTimezone || this.timezoneOffset) {
                    if ("Milliseconds" === e || "Seconds" === e || "Minutes" === e && 0 === this.getTimezoneOffset(g) % 36E5) return g["setUTC" + e](h);
                    var w = this.getTimezoneOffset(g);
                    w = g.getTime() - w;
                    g.setTime(w);
                    g["setUTC" + e](h);
                    e = this.getTimezoneOffset(g);
                    w = g.getTime() + e;
                    return g.setTime(w);
                }
                return this.useUTC || m && "FullYear" === e ? g["setUTC" + e](h) : g["set" + e](h);
            }
            update(e = {}) {
                const g = l(e.useUTC, !0);
                this.options = e = B(!0, this.options, e);
                this.Date = e.Date || x.Date || Date;
                this.timezoneOffset = (this.useUTC = g) && e.timezoneOffset || void 0;
                this.getTimezoneOffset = this.timezoneOffsetFunction();
                this.variableTimezone = g && !(!e.getTimezoneOffset && !e.timezone);
            }
            makeTime(e, g, m, p, d, k) {
                let r, q, w;
                this.useUTC ? (r = this.Date.UTC.apply(0, arguments), q = this.getTimezoneOffset(r), r += q, w = this.getTimezoneOffset(r), q !== w ? r += w - q : q - 36E5 !== this.getTimezoneOffset(r - 36E5) || h || (r -= 36E5)) : r = new this.Date(e, g, l(m, 1), l(p, 0), l(d, 0), l(k, 0)).getTime();
                return r;
            }
            timezoneOffsetFunction() {
                const e = this, g = this.options, h = g.getTimezoneOffset, m = g.moment || x.moment;
                if (!this.useUTC) return function(d) {
                    return 6E4 * new Date(d.toString()).getTimezoneOffset();
                };
                if (g.timezone) {
                    if (m) return function(d) {
                        return 6E4 * -m.tz(d, g.timezone).utcOffset();
                    };
                    C(25);
                }
                return this.useUTC && h ? function(d) {
                    return 6E4 * h(d.valueOf());
                } : function() {
                    return 6E4 * (e.timezoneOffset || 0);
                };
            }
            dateFormat(e, g, h) {
                if (!L(g) || isNaN(g)) return a.defaultOptions.lang && a.defaultOptions.lang.invalidDate || "";
                e = l(e, "%Y-%m-%d %H:%M:%S");
                const m = this;
                var d = new this.Date(g);
                const k = this.get("Hours", d), r = this.get("Day", d), q = this.get("Date", d), w = this.get("Month", d), b = this.get("FullYear", d), f = a.defaultOptions.lang, c = f && f.weekdays, n = f && f.shortWeekdays;
                d = z({
                    a: n ? n[r] : c[r].substr(0, 3),
                    A: c[r],
                    d: v(q),
                    e: v(q, 2, " "),
                    w: r,
                    b: f.shortMonths[w],
                    B: f.months[w],
                    m: v(w + 1),
                    o: w + 1,
                    y: b.toString().substr(2, 2),
                    Y: b,
                    H: v(k),
                    k: k,
                    I: v(k % 12 || 12),
                    l: k % 12 || 12,
                    M: v(this.get("Minutes", d)),
                    p: 12 > k ? "AM" : "PM",
                    P: 12 > k ? "am" : "pm",
                    S: v(d.getSeconds()),
                    L: v(Math.floor(g % 1E3), 3)
                }, a.dateFormats);
                u(d, function(b, c) {
                    for(; -1 !== e.indexOf("%" + c);)e = e.replace("%" + c, "function" === typeof b ? b.call(m, g) : b);
                });
                return h ? e.substr(0, 1).toUpperCase() + e.substr(1) : e;
            }
            resolveDTLFormat(e) {
                return H(e, !0) ? e : (e = p(e), {
                    main: e[0],
                    from: e[1],
                    to: e[2]
                });
            }
            getTimeTicks(e, g, h, m) {
                const d = this, k = [], r = {};
                var q = new d.Date(g);
                const w = e.unitRange, b = e.count || 1;
                let f;
                m = l(m, 1);
                if (L(g)) {
                    d.set("Milliseconds", q, w >= t.second ? 0 : b * Math.floor(d.get("Milliseconds", q) / b));
                    w >= t.second && d.set("Seconds", q, w >= t.minute ? 0 : b * Math.floor(d.get("Seconds", q) / b));
                    w >= t.minute && d.set("Minutes", q, w >= t.hour ? 0 : b * Math.floor(d.get("Minutes", q) / b));
                    w >= t.hour && d.set("Hours", q, w >= t.day ? 0 : b * Math.floor(d.get("Hours", q) / b));
                    w >= t.day && d.set("Date", q, w >= t.month ? 1 : Math.max(1, b * Math.floor(d.get("Date", q) / b)));
                    if (w >= t.month) {
                        d.set("Month", q, w >= t.year ? 0 : b * Math.floor(d.get("Month", q) / b));
                        var c = d.get("FullYear", q);
                    }
                    w >= t.year && d.set("FullYear", q, c - c % b);
                    w === t.week && (c = d.get("Day", q), d.set("Date", q, d.get("Date", q) - c + m + (c < m ? -7 : 0)));
                    c = d.get("FullYear", q);
                    m = d.get("Month", q);
                    const n = d.get("Date", q), e = d.get("Hours", q);
                    g = q.getTime();
                    !d.variableTimezone && d.useUTC || !L(h) || (f = h - g > 4 * t.month || d.getTimezoneOffset(g) !== d.getTimezoneOffset(h));
                    g = q.getTime();
                    for(q = 1; g < h;)k.push(g), g = w === t.year ? d.makeTime(c + q * b, 0) : w === t.month ? d.makeTime(c, m + q * b) : !f || w !== t.day && w !== t.week ? f && w === t.hour && 1 < b ? d.makeTime(c, m, n, e + q * b) : g + w * b : d.makeTime(c, m, n + q * b * (w === t.day ? 1 : 7)), q++;
                    k.push(g);
                    w <= t.hour && 1E4 > k.length && k.forEach(function(b) {
                        0 === b % 18E5 && "000000000" === d.dateFormat("%H%M%S%L", b) && (r[b] = "day");
                    });
                }
                k.info = z(e, {
                    higherRanks: r,
                    totalRange: w * b
                });
                return k;
            }
            getDateFormat(e, g, h, m) {
                const d = this.dateFormat("%m-%d %H:%M:%S.%L", g), k = {
                    millisecond: 15,
                    second: 12,
                    minute: 9,
                    hour: 6,
                    day: 3
                };
                let r, q = "millisecond";
                for(r in t){
                    if (e === t.week && +this.dateFormat("%w", g) === h && "00:00:00.000" === d.substr(6)) {
                        r = "week";
                        break;
                    }
                    if (t[r] > e) {
                        r = q;
                        break;
                    }
                    if (k[r] && d.substr(k[r]) !== "01-01 00:00:00.000".substr(k[r])) break;
                    "week" !== r && (q = r);
                }
                return this.resolveDTLFormat(m[r]).main;
            }
        }
        "";
        return g;
    });
    M(a, "Core/Defaults.js", [
        a["Core/Chart/ChartDefaults.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Color/Palettes.js"],
        a["Core/Time.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z) {
        const { isTouchDevice: x, svg: B } = I, { merge: u } = z, v = {
            colors: L.colors,
            symbols: [
                "circle",
                "diamond",
                "square",
                "triangle",
                "triangle-down"
            ],
            lang: {
                loading: "Loading...",
                months: "January February March April May June July August September October November December".split(" "),
                shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
                weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
                decimalPoint: ".",
                numericSymbols: "kMGTPE".split(""),
                resetZoom: "Reset zoom",
                resetZoomTitle: "Reset zoom level 1:1",
                thousandsSep: " "
            },
            global: {},
            time: {
                Date: void 0,
                getTimezoneOffset: void 0,
                timezone: void 0,
                timezoneOffset: 0,
                useUTC: !0
            },
            chart: a,
            title: {
                style: {
                    color: "#333333",
                    fontWeight: "bold"
                },
                text: "Chart title",
                align: "center",
                margin: 15,
                widthAdjust: -44
            },
            subtitle: {
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "center",
                widthAdjust: -44
            },
            caption: {
                margin: 15,
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "left",
                verticalAlign: "bottom"
            },
            plotOptions: {},
            legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                className: "highcharts-no-tooltip",
                layout: "horizontal",
                itemMarginBottom: 2,
                itemMarginTop: 2,
                labelFormatter: function() {
                    return this.name;
                },
                borderColor: "#999999",
                borderRadius: 0,
                navigation: {
                    style: {
                        fontSize: "0.8em"
                    },
                    activeColor: "#0022ff",
                    inactiveColor: "#cccccc"
                },
                itemStyle: {
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    textDecoration: "none",
                    textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                    color: "#000000"
                },
                itemHiddenStyle: {
                    color: "#666666",
                    textDecoration: "line-through"
                },
                shadow: !1,
                itemCheckboxStyle: {
                    position: "absolute",
                    width: "13px",
                    height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                    style: {
                        fontSize: "0.8em",
                        fontWeight: "bold"
                    }
                }
            },
            loading: {
                labelStyle: {
                    fontWeight: "bold",
                    position: "relative",
                    top: "45%"
                },
                style: {
                    position: "absolute",
                    backgroundColor: "#ffffff",
                    opacity: .5,
                    textAlign: "center"
                }
            },
            tooltip: {
                enabled: !0,
                animation: B,
                borderRadius: 3,
                dateTimeLabelFormats: {
                    millisecond: "%A, %e %b, %H:%M:%S.%L",
                    second: "%A, %e %b, %H:%M:%S",
                    minute: "%A, %e %b, %H:%M",
                    hour: "%A, %e %b, %H:%M",
                    day: "%A, %e %b %Y",
                    week: "Week from %A, %e %b %Y",
                    month: "%B %Y",
                    year: "%Y"
                },
                footerFormat: "",
                headerShape: "callout",
                hideDelay: 500,
                padding: 8,
                shape: "callout",
                shared: !1,
                snap: x ? 25 : 10,
                headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
                backgroundColor: "#ffffff",
                borderWidth: void 0,
                shadow: !0,
                stickOnContact: !1,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "0.8em"
                },
                useHTML: !1
            },
            credits: {
                enabled: !0,
                href: "https://www.highcharts.com?credits",
                position: {
                    align: "right",
                    x: -10,
                    verticalAlign: "bottom",
                    y: -5
                },
                style: {
                    cursor: "pointer",
                    color: "#999999",
                    fontSize: "0.6em"
                },
                text: "Highcharts.com"
            }
        };
        v.chart.styledMode = !1;
        "";
        const l = new C(v.time);
        a = {
            defaultOptions: v,
            defaultTime: l,
            getOptions: function() {
                return v;
            },
            setOptions: function(a) {
                u(!0, v, a);
                if (a.time || a.global) I.time ? I.time.update(u(v.global, v.time, a.global, a.time)) : I.time = l;
                return v;
            }
        };
        "";
        return a;
    });
    M(a, "Core/Animation/Fx.js", [
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { parse: x } = a, { win: C } = y, { isNumber: z, objectEach: H } = I;
        class B {
            constructor(a, v, l){
                this.pos = NaN;
                this.options = v;
                this.elem = a;
                this.prop = l;
            }
            dSetter() {
                var a = this.paths;
                const v = a && a[0];
                a = a && a[1];
                const l = this.now || 0;
                let p = [];
                if (1 !== l && v && a) {
                    if (v.length === a.length && 1 > l) for(let t = 0; t < a.length; t++){
                        const m = v[t], h = a[t], g = [];
                        for(let e = 0; e < h.length; e++){
                            const w = m[e], a = h[e];
                            z(w) && z(a) && ("A" !== h[0] || 4 !== e && 5 !== e) ? g[e] = w + l * (a - w) : g[e] = a;
                        }
                        p.push(g);
                    }
                    else p = a;
                } else p = this.toD || [];
                this.elem.attr("d", p, void 0, !0);
            }
            update() {
                const a = this.elem, v = this.prop, l = this.now, p = this.options.step;
                if (this[v + "Setter"]) this[v + "Setter"]();
                else a.attr ? a.element && a.attr(v, l, null, !0) : a.style[v] = l + this.unit;
                p && p.call(a, l, this);
            }
            run(a, v, l) {
                const p = this, t = p.options, m = function(e) {
                    return m.stopped ? !1 : p.step(e);
                }, h = C.requestAnimationFrame || function(e) {
                    setTimeout(e, 13);
                }, g = function() {
                    for(let e = 0; e < B.timers.length; e++)B.timers[e]() || B.timers.splice(e--, 1);
                    B.timers.length && h(g);
                };
                a !== v || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = a, this.end = v, this.unit = l, this.now = this.start, this.pos = 0, m.elem = this.elem, m.prop = this.prop, m() && 1 === B.timers.push(m) && h(g)) : (delete t.curAnim[this.prop], t.complete && 0 === Object.keys(t.curAnim).length && t.complete.call(this.elem));
            }
            step(a) {
                const v = +new Date, l = this.options, p = this.elem, t = l.complete, m = l.duration, h = l.curAnim;
                let g;
                p.attr && !p.element ? a = !1 : a || v >= m + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), g = h[this.prop] = !0, H(h, function(e) {
                    !0 !== e && (g = !1);
                }), g && t && t.call(p), a = !1) : (this.pos = l.easing((v - this.startTime) / m), this.now = this.start + (this.end - this.start) * this.pos, this.update(), a = !0);
                return a;
            }
            initPath(a, v, l) {
                function p(d, k) {
                    for(; d.length < E;){
                        var r = d[0];
                        const q = k[E - d.length];
                        q && "M" === r[0] && (d[0] = "C" === q[0] ? [
                            "C",
                            r[1],
                            r[2],
                            r[1],
                            r[2],
                            r[1],
                            r[2]
                        ] : [
                            "L",
                            r[1],
                            r[2]
                        ]);
                        d.unshift(r);
                        g && (r = d.pop(), d.push(d[d.length - 1], r));
                    }
                }
                function t(d, k) {
                    for(; d.length < E;)if (k = d[Math.floor(d.length / e) - 1].slice(), "C" === k[0] && (k[1] = k[5], k[2] = k[6]), g) {
                        const r = d[Math.floor(d.length / e)].slice();
                        d.splice(d.length / 2, 0, k, r);
                    } else d.push(k);
                }
                const m = a.startX, h = a.endX;
                l = l.slice();
                const g = a.isArea, e = g ? 2 : 1;
                let w, E, F;
                v = v && v.slice();
                if (!v) return [
                    l,
                    l
                ];
                if (m && h && h.length) {
                    for(a = 0; a < m.length; a++)if (m[a] === h[0]) {
                        w = a;
                        break;
                    } else if (m[0] === h[h.length - m.length + a]) {
                        w = a;
                        F = !0;
                        break;
                    } else if (m[m.length - 1] === h[h.length - m.length + a]) {
                        w = m.length - a;
                        break;
                    }
                    "undefined" === typeof w && (v = []);
                }
                v.length && z(w) && (E = l.length + w * e, F ? (p(v, l), t(l, v)) : (p(l, v), t(v, l)));
                return [
                    v,
                    l
                ];
            }
            fillSetter() {
                B.prototype.strokeSetter.apply(this, arguments);
            }
            strokeSetter() {
                this.elem.attr(this.prop, x(this.start).tweenTo(x(this.end), this.pos), void 0, !0);
            }
        }
        B.timers = [];
        return B;
    });
    M(a, "Core/Animation/AnimationUtilities.js", [
        a["Core/Animation/Fx.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        function x(a) {
            return u(a) ? v({
                duration: 500,
                defer: 0
            }, a) : {
                duration: a ? 500 : 0,
                defer: 0
            };
        }
        function L(l, m) {
            let h = a.timers.length;
            for(; h--;)a.timers[h].elem !== l || m && m !== a.timers[h].prop || (a.timers[h].stopped = !0);
        }
        const { defined: C, getStyle: z, isArray: H, isNumber: B, isObject: u, merge: v, objectEach: l, pick: p } = y;
        return {
            animate: function(p, m, h) {
                let g, e = "", w, E, F;
                u(h) || (F = arguments, h = {
                    duration: F[2],
                    easing: F[3],
                    complete: F[4]
                });
                B(h.duration) || (h.duration = 400);
                h.easing = "function" === typeof h.easing ? h.easing : Math[h.easing] || Math.easeInOutSine;
                h.curAnim = v(m);
                l(m, function(d, k) {
                    L(p, k);
                    E = new a(p, h, k);
                    w = void 0;
                    "d" === k && H(m.d) ? (E.paths = E.initPath(p, p.pathArray, m.d), E.toD = m.d, g = 0, w = 1) : p.attr ? g = p.attr(k) : (g = parseFloat(z(p, k)) || 0, "opacity" !== k && (e = "px"));
                    w || (w = d);
                    "string" === typeof w && w.match("px") && (w = w.replace(/px/g, ""));
                    E.run(g, w, e);
                });
            },
            animObject: x,
            getDeferredAnimation: function(a, m, h) {
                const g = x(m);
                let e = 0, w = 0;
                (h ? [
                    h
                ] : a.series).forEach((h)=>{
                    h = x(h.options.animation);
                    e = m && C(m.defer) ? g.defer : Math.max(e, h.duration + h.defer);
                    w = Math.min(g.duration, h.duration);
                });
                a.renderer.forExport && (e = 0);
                return {
                    defer: Math.max(0, e - w),
                    duration: Math.min(e, w)
                };
            },
            setAnimation: function(a, m) {
                m.renderer.globalAnimation = p(a, m.options.chart.animation, !0);
            },
            stop: L
        };
    });
    M(a, "Core/Renderer/HTML/AST.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        const { SVG_NS: x, win: L } = a, { attr: C, createElement: z, css: H, error: B, isFunction: u, isString: v, objectEach: l, splat: p } = y;
        ({ trustedTypes: y } = L);
        const t = y && u(y.createPolicy) && y.createPolicy("highcharts", {
            createHTML: (e)=>e
        });
        y = t ? t.createHTML("") : "";
        try {
            var m = !!(new DOMParser).parseFromString(y, "text/html");
        } catch (e) {
            m = !1;
        }
        const h = m;
        class g {
            static filterUserAttributes(e) {
                l(e, (h, m)=>{
                    let a = !0;
                    -1 === g.allowedAttributes.indexOf(m) && (a = !1);
                    -1 !== [
                        "background",
                        "dynsrc",
                        "href",
                        "lowsrc",
                        "src"
                    ].indexOf(m) && (a = v(h) && g.allowedReferences.some((d)=>0 === h.indexOf(d)));
                    a || (B(33, !1, void 0, {
                        "Invalid attribute in config": `${m}`
                    }), delete e[m]);
                    v(h) && e[m] && (e[m] = h.replace(/</g, "&lt;"));
                });
                return e;
            }
            static parseStyle(e) {
                return e.split(";").reduce((e, g)=>{
                    g = g.split(":").map((d)=>d.trim());
                    const h = g.shift();
                    h && g.length && (e[h.replace(/-([a-z])/g, (d)=>d[1].toUpperCase())] = g.join(":"));
                    return e;
                }, {});
            }
            static setElementHTML(e, h) {
                e.innerHTML = g.emptyHTML;
                h && new g(h).addToDOM(e);
            }
            constructor(e){
                this.nodes = "string" === typeof e ? this.parseMarkup(e) : e;
            }
            addToDOM(e) {
                function h(e, m) {
                    let d;
                    p(e).forEach(function(k) {
                        var e = k.tagName;
                        const q = k.textContent ? a.doc.createTextNode(k.textContent) : void 0, w = g.bypassHTMLFiltering;
                        let b;
                        if (e) {
                            if ("#text" === e) b = q;
                            else if (-1 !== g.allowedTags.indexOf(e) || w) {
                                e = a.doc.createElementNS("svg" === e ? x : m.namespaceURI || x, e);
                                const f = k.attributes || {};
                                l(k, function(b, d) {
                                    "tagName" !== d && "attributes" !== d && "children" !== d && "style" !== d && "textContent" !== d && (f[d] = b);
                                });
                                C(e, w ? f : g.filterUserAttributes(f));
                                k.style && H(e, k.style);
                                q && e.appendChild(q);
                                h(k.children || [], e);
                                b = e;
                            } else B(33, !1, void 0, {
                                "Invalid tagName in config": e
                            });
                        }
                        b && m.appendChild(b);
                        d = b;
                    });
                    return d;
                }
                return h(this.nodes, e);
            }
            parseMarkup(e) {
                const m = [];
                e = e.trim().replace(/ style=(["'])/g, " data-style=$1");
                if (h) e = (new DOMParser).parseFromString(t ? t.createHTML(e) : e, "text/html");
                else {
                    const g = z("div");
                    g.innerHTML = e;
                    e = {
                        body: g
                    };
                }
                const a = (e, d)=>{
                    var k = e.nodeName.toLowerCase();
                    const r = {
                        tagName: k
                    };
                    "#text" === k && (r.textContent = e.textContent || "");
                    if (k = e.attributes) {
                        const d = {};
                        [].forEach.call(k, (k)=>{
                            "data-style" === k.name ? r.style = g.parseStyle(k.value) : d[k.name] = k.value;
                        });
                        r.attributes = d;
                    }
                    if (e.childNodes.length) {
                        const d = [];
                        [].forEach.call(e.childNodes, (k)=>{
                            a(k, d);
                        });
                        d.length && (r.children = d);
                    }
                    d.push(r);
                };
                [].forEach.call(e.body.childNodes, (e)=>a(e, m));
                return m;
            }
        }
        g.allowedAttributes = "alt aria-controls aria-describedby aria-expanded aria-haspopup aria-hidden aria-label aria-labelledby aria-live aria-pressed aria-readonly aria-roledescription aria-selected class clip-path color colspan cx cy d dx dy disabled fill flood-color flood-opacity height href id in markerHeight markerWidth offset opacity orient padding paddingLeft paddingRight patternUnits r refX refY role scope slope src startOffset stdDeviation stroke stroke-linecap stroke-width style tableValues result rowspan summary target tabindex text-align text-anchor textAnchor textLength title type valign width x x1 x2 xlink:href y y1 y2 zIndex".split(" ");
        g.allowedReferences = "https:// http:// mailto: / ../ ./ #".split(" ");
        g.allowedTags = "a abbr b br button caption circle clipPath code dd defs div dl dt em feComponentTransfer feDropShadow feFuncA feFuncB feFuncG feFuncR feGaussianBlur feOffset feMerge feMergeNode filter h1 h2 h3 h4 h5 h6 hr i img li linearGradient marker ol p path pattern pre rect small span stop strong style sub sup svg table text textPath thead title tbody tspan td th tr u ul #text".split(" ");
        g.emptyHTML = y;
        g.bypassHTMLFiltering = !1;
        "";
        return g;
    });
    M(a, "Core/Templating.js", [
        a["Core/Defaults.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        function x(h = "", g, e) {
            const a = /\{([a-zA-Z0-9:\.,;\-\/<>%_@"'= #\(\)]+)\}/g, l = /\(([a-zA-Z0-9:\.,;\-\/<>%_@"'= ]+)\)/g, v = [], d = /f$/, k = /\.([0-9])/, r = C.lang, q = e && e.time || z, G = e && e.numberFormatter || L, b = (b = "")=>{
                let c;
                return "true" === b ? !0 : "false" === b ? !1 : (c = Number(b)).toString() === b ? c : B(b, g);
            };
            let f, c, n = 0, P;
            for(; null !== (f = a.exec(h));){
                const b = l.exec(f[1]);
                b && (f = b, P = !0);
                c && c.isBlock || (c = {
                    ctx: g,
                    expression: f[1],
                    find: f[0],
                    isBlock: "#" === f[1].charAt(0),
                    start: f.index,
                    startInner: f.index + f[0].length,
                    length: f[0].length
                });
                var D = f[1].split(" ")[0].replace("#", "");
                m[D] && (c.isBlock && D === c.fn && n++, c.fn || (c.fn = D));
                D = "else" === f[1];
                if (c.isBlock && c.fn && (f[1] === `/${c.fn}` || D)) {
                    if (n) D || n--;
                    else {
                        var K = c.startInner;
                        K = h.substr(K, f.index - K);
                        void 0 === c.body ? (c.body = K, c.startInner = f.index + f[0].length) : c.elseBody = K;
                        c.find += K + f[0];
                        D || (v.push(c), c = void 0);
                    }
                } else c.isBlock || v.push(c);
                if (b && (null === c || void 0 === c || !c.isBlock)) break;
            }
            v.forEach((c)=>{
                const { body: f, elseBody: n, expression: K, fn: e } = c;
                var A;
                if (e) {
                    var a = [
                        c
                    ], w = K.split(" ");
                    for(A = m[e].length; A--;)a.unshift(b(w[A + 1]));
                    A = m[e].apply(g, a);
                    c.isBlock && "boolean" === typeof A && (A = x(A ? f : n, g));
                } else a = K.split(":"), A = b(a.shift() || ""), a.length && "number" === typeof A && (a = a.join(":"), d.test(a) ? (w = parseInt((a.match(k) || [
                    "",
                    "-1"
                ])[1], 10), null !== A && (A = G(A, w, r.decimalPoint, -1 < a.indexOf(",") ? r.thousandsSep : ""))) : A = q.dateFormat(a, A));
                h = h.replace(c.find, p(A, ""));
            });
            return P ? x(h, g, e) : h;
        }
        function L(h, g, e, a) {
            h = +h || 0;
            g = +g;
            const m = C.lang;
            var w = (h.toString().split(".")[1] || "").split("e")[0].length;
            const d = h.toString().split("e"), k = g;
            if (-1 === g) g = Math.min(w, 20);
            else if (!v(g)) g = 2;
            else if (g && d[1] && 0 > d[1]) {
                var r = g + +d[1];
                0 <= r ? (d[0] = (+d[0]).toExponential(r).split("e")[0], g = r) : (d[0] = d[0].split(".")[0] || 0, h = 20 > g ? (d[0] * Math.pow(10, d[1])).toFixed(g) : 0, d[1] = 0);
            }
            r = (Math.abs(d[1] ? d[0] : h) + Math.pow(10, -Math.max(g, w) - 1)).toFixed(g);
            w = String(t(r));
            const q = 3 < w.length ? w.length % 3 : 0;
            e = p(e, m.decimalPoint);
            a = p(a, m.thousandsSep);
            h = (0 > h ? "-" : "") + (q ? w.substr(0, q) + a : "");
            h = 0 > +d[1] && !k ? "0" : h + w.substr(q).replace(/(\d{3})(?=\d)/g, "$1" + a);
            g && (h += e + r.slice(-g));
            d[1] && 0 !== +h && (h += "e" + d[1]);
            return h;
        }
        const { defaultOptions: C, defaultTime: z } = a, { extend: H, getNestedProperty: B, isArray: u, isNumber: v, isObject: l, pick: p, pInt: t } = y, m = {
            add: (h, g)=>h + g,
            divide: (h, g)=>0 !== g ? h / g : "",
            eq: (h, g)=>h == g,
            each: function(h) {
                const g = arguments[arguments.length - 1];
                return u(h) ? h.map((e, a)=>x(g.body, H(l(e) ? e : {
                        "@this": e
                    }, {
                        "@index": a,
                        "@first": 0 === a,
                        "@last": a === h.length - 1
                    }))).join("") : !1;
            },
            ge: (h, g)=>h >= g,
            gt: (h, g)=>h > g,
            "if": (h)=>!!h,
            le: (h, g)=>h <= g,
            lt: (h, g)=>h < g,
            multiply: (h, g)=>h * g,
            ne: (h, g)=>h != g,
            subtract: (h, g)=>h - g,
            unless: (h)=>!h
        };
        return {
            dateFormat: function(h, g, e) {
                return z.dateFormat(h, g, e);
            },
            format: x,
            helpers: m,
            numberFormat: L
        };
    });
    M(a, "Core/Renderer/RendererUtilities.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { clamp: x, pick: I, stableSort: L } = a;
        var C;
        (function(a) {
            function y(a, u, v) {
                const l = a;
                var p = l.reducedLen || u, t = (e, g)=>(g.rank || 0) - (e.rank || 0);
                const m = (e, g)=>e.target - g.target;
                let h, g = !0, e = [], w = 0;
                for(h = a.length; h--;)w += a[h].size;
                if (w > p) {
                    L(a, t);
                    for(w = h = 0; w <= p;)w += a[h].size, h++;
                    e = a.splice(h - 1, a.length);
                }
                L(a, m);
                for(a = a.map((e)=>({
                        size: e.size,
                        targets: [
                            e.target
                        ],
                        align: I(e.align, .5)
                    })); g;){
                    for(h = a.length; h--;)p = a[h], t = (Math.min.apply(0, p.targets) + Math.max.apply(0, p.targets)) / 2, p.pos = x(t - p.size * p.align, 0, u - p.size);
                    h = a.length;
                    for(g = !1; h--;)0 < h && a[h - 1].pos + a[h - 1].size > a[h].pos && (a[h - 1].size += a[h].size, a[h - 1].targets = a[h - 1].targets.concat(a[h].targets), a[h - 1].align = .5, a[h - 1].pos + a[h - 1].size > u && (a[h - 1].pos = u - a[h - 1].size), a.splice(h, 1), g = !0);
                }
                l.push.apply(l, e);
                h = 0;
                a.some((e)=>{
                    let g = 0;
                    return (e.targets || []).some(()=>{
                        l[h].pos = e.pos + g;
                        if ("undefined" !== typeof v && Math.abs(l[h].pos - l[h].target) > v) return l.slice(0, h + 1).forEach((d)=>delete d.pos), l.reducedLen = (l.reducedLen || u) - .1 * u, l.reducedLen > .1 * u && y(l, u, v), !0;
                        g += l[h].size;
                        h++;
                        return !1;
                    });
                });
                L(l, m);
                return l;
            }
            a.distribute = y;
        })(C || (C = {}));
        return C;
    });
    M(a, "Core/Renderer/SVG/SVGElement.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L) {
        const { animate: x, animObject: z, stop: H } = a, { deg2rad: B, doc: u, svg: v, SVG_NS: l, win: p } = I, { addEvent: t, attr: m, createElement: h, css: g, defined: e, erase: w, extend: E, fireEvent: F, isArray: d, isFunction: k, isObject: r, isString: q, merge: G, objectEach: b, pick: f, pInt: c, syncTimeout: n, uniqueKey: P } = L;
        class D {
            constructor(){
                this.element = void 0;
                this.onEvents = {};
                this.opacity = 1;
                this.renderer = void 0;
                this.SVG_NS = l;
            }
            _defaultGetter(b) {
                b = f(this[b + "Value"], this[b], this.element ? this.element.getAttribute(b) : null, 0);
                /^[\-0-9\.]+$/.test(b) && (b = parseFloat(b));
                return b;
            }
            _defaultSetter(b, c, f) {
                f.setAttribute(c, b);
            }
            add(b) {
                const c = this.renderer, f = this.element;
                let d;
                b && (this.parentGroup = b);
                "undefined" !== typeof this.textStr && "text" === this.element.nodeName && c.buildText(this);
                this.added = !0;
                if (!b || b.handleZ || this.zIndex) d = this.zIndexSetter();
                d || (b ? b.element : c.box).appendChild(f);
                if (this.onAdd) this.onAdd();
                return this;
            }
            addClass(b, c) {
                const f = c ? "" : this.attr("class") || "";
                b = (b || "").split(/ /g).reduce(function(b, c) {
                    -1 === f.indexOf(c) && b.push(c);
                    return b;
                }, f ? [
                    f
                ] : []).join(" ");
                b !== f && this.attr("class", b);
                return this;
            }
            afterSetters() {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
            }
            align(b, c, d) {
                const k = {};
                var n = this.renderer, e = n.alignedObjects, A;
                let K, g;
                if (b) {
                    if (this.alignOptions = b, this.alignByTranslate = c, !d || q(d)) this.alignTo = A = d || "renderer", w(e, this), e.push(this), d = void 0;
                } else b = this.alignOptions, c = this.alignByTranslate, A = this.alignTo;
                d = f(d, n[A], "scrollablePlotBox" === A ? n.plotBox : void 0, n);
                A = b.align;
                const a = b.verticalAlign;
                n = (d.x || 0) + (b.x || 0);
                e = (d.y || 0) + (b.y || 0);
                "right" === A ? K = 1 : "center" === A && (K = 2);
                K && (n += (d.width - (b.width || 0)) / K);
                k[c ? "translateX" : "x"] = Math.round(n);
                "bottom" === a ? g = 1 : "middle" === a && (g = 2);
                g && (e += (d.height - (b.height || 0)) / g);
                k[c ? "translateY" : "y"] = Math.round(e);
                this[this.placed ? "animate" : "attr"](k);
                this.placed = !0;
                this.alignAttr = k;
                return this;
            }
            alignSetter(b) {
                const c = {
                    left: "start",
                    center: "middle",
                    right: "end"
                };
                c[b] && (this.alignValue = b, this.element.setAttribute("text-anchor", c[b]));
            }
            animate(c, d, k) {
                const e = z(f(d, this.renderer.globalAnimation, !0));
                d = e.defer;
                u.hidden && (e.duration = 0);
                0 !== e.duration ? (k && (e.complete = k), n(()=>{
                    this.element && x(this, c, e);
                }, d)) : (this.attr(c, void 0, k || e.complete), b(c, function(b, c) {
                    e.step && e.step.call(this, b, {
                        prop: c,
                        pos: 1,
                        elem: this
                    });
                }, this));
                return this;
            }
            applyTextOutline(b) {
                const c = this.element;
                -1 !== b.indexOf("contrast") && (b = b.replace(/contrast/g, this.renderer.getContrast(c.style.fill)));
                var f = b.split(" ");
                b = f[f.length - 1];
                if ((f = f[0]) && "none" !== f && I.svg) {
                    this.fakeTS = !0;
                    f = f.replace(/(^[\d\.]+)(.*?)$/g, function(b, c, f) {
                        return 2 * Number(c) + f;
                    });
                    this.removeTextOutline();
                    const d = u.createElementNS(l, "tspan");
                    m(d, {
                        "class": "highcharts-text-outline",
                        fill: b,
                        stroke: b,
                        "stroke-width": f,
                        "stroke-linejoin": "round"
                    });
                    b = c.querySelector("textPath") || c;
                    [].forEach.call(b.childNodes, (b)=>{
                        const c = b.cloneNode(!0);
                        c.removeAttribute && [
                            "fill",
                            "stroke",
                            "stroke-width",
                            "stroke"
                        ].forEach((b)=>c.removeAttribute(b));
                        d.appendChild(c);
                    });
                    let k = 0;
                    [].forEach.call(b.querySelectorAll("text tspan"), (b)=>{
                        k += Number(b.getAttribute("dy"));
                    });
                    f = u.createElementNS(l, "tspan");
                    f.textContent = "\u200B";
                    m(f, {
                        x: Number(c.getAttribute("x")),
                        dy: -k
                    });
                    d.appendChild(f);
                    b.insertBefore(d, b.firstChild);
                }
            }
            attr(c, f, d, k) {
                const n = this.element, e = D.symbolCustomAttribs;
                let A, q, g = this, a, K;
                "string" === typeof c && "undefined" !== typeof f && (A = c, c = {}, c[A] = f);
                "string" === typeof c ? g = (this[c + "Getter"] || this._defaultGetter).call(this, c, n) : (b(c, function(b, f) {
                    a = !1;
                    k || H(this, f);
                    this.symbolName && -1 !== e.indexOf(f) && (q || (this.symbolAttr(c), q = !0), a = !0);
                    !this.rotation || "x" !== f && "y" !== f || (this.doTransform = !0);
                    a || (K = this[f + "Setter"] || this._defaultSetter, K.call(this, b, f, n));
                }, this), this.afterSetters());
                d && d.call(this);
                return g;
            }
            clip(b) {
                return this.attr("clip-path", b ? "url(" + this.renderer.url + "#" + b.id + ")" : "none");
            }
            crisp(b, c) {
                c = c || b.strokeWidth || 0;
                const f = Math.round(c) % 2 / 2;
                b.x = Math.floor(b.x || this.x || 0) + f;
                b.y = Math.floor(b.y || this.y || 0) + f;
                b.width = Math.floor((b.width || this.width || 0) - 2 * f);
                b.height = Math.floor((b.height || this.height || 0) - 2 * f);
                e(b.strokeWidth) && (b.strokeWidth = c);
                return b;
            }
            complexColor(c, f, k) {
                const n = this.renderer;
                let q, g, A, a, r, K, h, J, m, O, w = [], l;
                F(this.renderer, "complexColor", {
                    args: arguments
                }, function() {
                    c.radialGradient ? g = "radialGradient" : c.linearGradient && (g = "linearGradient");
                    if (g) {
                        A = c[g];
                        r = n.gradients;
                        K = c.stops;
                        m = k.radialReference;
                        d(A) && (c[g] = A = {
                            x1: A[0],
                            y1: A[1],
                            x2: A[2],
                            y2: A[3],
                            gradientUnits: "userSpaceOnUse"
                        });
                        "radialGradient" === g && m && !e(A.gradientUnits) && (a = A, A = G(A, n.getRadialAttr(m, a), {
                            gradientUnits: "userSpaceOnUse"
                        }));
                        b(A, function(b, c) {
                            "id" !== c && w.push(c, b);
                        });
                        b(K, function(b) {
                            w.push(b);
                        });
                        w = w.join(",");
                        if (r[w]) O = r[w].attr("id");
                        else {
                            A.id = O = P();
                            const b = r[w] = n.createElement(g).attr(A).add(n.defs);
                            b.radAttr = a;
                            b.stops = [];
                            K.forEach(function(c) {
                                0 === c[1].indexOf("rgba") ? (q = y.parse(c[1]), h = q.get("rgb"), J = q.get("a")) : (h = c[1], J = 1);
                                c = n.createElement("stop").attr({
                                    offset: c[0],
                                    "stop-color": h,
                                    "stop-opacity": J
                                }).add(b);
                                b.stops.push(c);
                            });
                        }
                        l = "url(" + n.url + "#" + O + ")";
                        k.setAttribute(f, l);
                        k.gradient = w;
                        c.toString = function() {
                            return l;
                        };
                    }
                });
            }
            css(f) {
                const d = this.styles, k = {}, n = this.element;
                let e, q = !d;
                d && b(f, function(b, c) {
                    d && d[c] !== b && (k[c] = b, q = !0);
                });
                if (q) {
                    d && (f = E(d, k));
                    null === f.width || "auto" === f.width ? delete this.textWidth : "text" === n.nodeName.toLowerCase() && f.width && (e = this.textWidth = c(f.width));
                    this.styles = f;
                    e && !v && this.renderer.forExport && delete f.width;
                    const b = G(f);
                    n.namespaceURI === this.SVG_NS && ([
                        "textOutline",
                        "textOverflow",
                        "width"
                    ].forEach((c)=>b && delete b[c]), b.color && (b.fill = b.color));
                    g(n, b);
                }
                this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), f.textOutline && this.applyTextOutline(f.textOutline));
                return this;
            }
            dashstyleSetter(b) {
                let d = this["stroke-width"];
                "inherit" === d && (d = 1);
                if (b = b && b.toLowerCase()) {
                    const k = b.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                    for(b = k.length; b--;)k[b] = "" + c(k[b]) * f(d, NaN);
                    b = k.join(",").replace(/NaN/g, "none");
                    this.element.setAttribute("stroke-dasharray", b);
                }
            }
            destroy() {
                const c = this;
                var f = c.element || {};
                const d = c.renderer;
                var k = f.ownerSVGElement;
                let n = "SPAN" === f.nodeName && c.parentGroup || void 0;
                f.onclick = f.onmouseout = f.onmouseover = f.onmousemove = f.point = null;
                H(c);
                if (c.clipPath && k) {
                    const b = c.clipPath;
                    [].forEach.call(k.querySelectorAll("[clip-path],[CLIP-PATH]"), function(c) {
                        -1 < c.getAttribute("clip-path").indexOf(b.element.id) && c.removeAttribute("clip-path");
                    });
                    c.clipPath = b.destroy();
                }
                if (c.stops) {
                    for(k = 0; k < c.stops.length; k++)c.stops[k].destroy();
                    c.stops.length = 0;
                    c.stops = void 0;
                }
                for(c.safeRemoveChild(f); n && n.div && 0 === n.div.childNodes.length;)f = n.parentGroup, c.safeRemoveChild(n.div), delete n.div, n = f;
                c.alignTo && w(d.alignedObjects, c);
                b(c, function(b, f) {
                    c[f] && c[f].parentGroup === c && c[f].destroy && c[f].destroy();
                    delete c[f];
                });
            }
            dSetter(b, c, f) {
                d(b) && ("string" === typeof b[0] && (b = this.renderer.pathToSegments(b)), this.pathArray = b, b = b.reduce((b, c, f)=>c && c.join ? (f ? b + " " : "") + c.join(" ") : (c || "").toString(), ""));
                /(NaN| {2}|^$)/.test(b) && (b = "M 0 0");
                this[c] !== b && (f.setAttribute(c, b), this[c] = b);
            }
            fadeOut(b) {
                const c = this;
                c.animate({
                    opacity: 0
                }, {
                    duration: f(b, 150),
                    complete: function() {
                        c.hide();
                    }
                });
            }
            fillSetter(b, c, f) {
                "string" === typeof b ? f.setAttribute(c, b) : b && this.complexColor(b, c, f);
            }
            getBBox(b, c) {
                const { alignValue: d, element: n, renderer: q, styles: a, textStr: A } = this, { cache: r, cacheKeys: h } = q;
                var m = n.namespaceURI === this.SVG_NS;
                c = f(c, this.rotation, 0);
                var K = q.styledMode ? n && D.prototype.getStyle.call(n, "font-size") : a && a.fontSize;
                let J;
                let N;
                e(A) && (N = A.toString(), -1 === N.indexOf("<") && (N = N.replace(/[0-9]/g, "0")), N += [
                    "",
                    q.rootFontSize,
                    K,
                    c,
                    this.textWidth,
                    d,
                    a && a.textOverflow,
                    a && a.fontWeight
                ].join());
                N && !b && (J = r[N]);
                if (!J) {
                    if (m || q.forExport) {
                        try {
                            var O = this.fakeTS && function(b) {
                                const c = n.querySelector(".highcharts-text-outline");
                                c && g(c, {
                                    display: b
                                });
                            };
                            k(O) && O("none");
                            J = n.getBBox ? E({}, n.getBBox()) : {
                                width: n.offsetWidth,
                                height: n.offsetHeight,
                                x: 0,
                                y: 0
                            };
                            k(O) && O("");
                        } catch (fa) {
                            "";
                        }
                        if (!J || 0 > J.width) J = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        };
                    } else J = this.htmlGetBBox();
                    O = J.width;
                    b = J.height;
                    m && (J.height = b = ({
                        "11px,17": 14,
                        "13px,20": 16
                    })[`${K || ""},${Math.round(b)}`] || b);
                    if (c) {
                        m = Number(n.getAttribute("y") || 0) - J.y;
                        K = ({
                            right: 1,
                            center: .5
                        })[d || 0] || 0;
                        var w = c * B, l = (c - 90) * B, p = O * Math.cos(w);
                        c = O * Math.sin(w);
                        var G = Math.cos(l);
                        w = Math.sin(l);
                        O = J.x + K * (O - p) + m * G;
                        l = O + p;
                        G = l - b * G;
                        p = G - p;
                        m = J.y + m - K * c + m * w;
                        K = m + c;
                        b = K - b * w;
                        c = b - c;
                        J.x = Math.min(O, l, G, p);
                        J.y = Math.min(m, K, b, c);
                        J.width = Math.max(O, l, G, p) - J.x;
                        J.height = Math.max(m, K, b, c) - J.y;
                    }
                }
                if (N && ("" === A || 0 < J.height)) {
                    for(; 250 < h.length;)delete r[h.shift()];
                    r[N] || h.push(N);
                    r[N] = J;
                }
                return J;
            }
            getStyle(b) {
                return p.getComputedStyle(this.element || this, "").getPropertyValue(b);
            }
            hasClass(b) {
                return -1 !== ("" + this.attr("class")).split(" ").indexOf(b);
            }
            hide() {
                return this.attr({
                    visibility: "hidden"
                });
            }
            htmlGetBBox() {
                return {
                    height: 0,
                    width: 0,
                    x: 0,
                    y: 0
                };
            }
            init(b, c) {
                this.element = "span" === c ? h(c) : u.createElementNS(this.SVG_NS, c);
                this.renderer = b;
                F(this, "afterInit");
            }
            on(b, c) {
                const { onEvents: f } = this;
                if (f[b]) f[b]();
                f[b] = t(this.element, b, c);
                return this;
            }
            opacitySetter(b, c, f) {
                this.opacity = b = Number(Number(b).toFixed(3));
                f.setAttribute(c, b);
            }
            removeClass(b) {
                return this.attr("class", ("" + this.attr("class")).replace(q(b) ? new RegExp(`(^| )${b}( |$)`) : b, " ").replace(/ +/g, " ").trim());
            }
            removeTextOutline() {
                const b = this.element.querySelector("tspan.highcharts-text-outline");
                b && this.safeRemoveChild(b);
            }
            safeRemoveChild(b) {
                const c = b.parentNode;
                c && c.removeChild(b);
            }
            setRadialReference(b) {
                const c = this.element.gradient && this.renderer.gradients[this.element.gradient];
                this.element.radialReference = b;
                c && c.radAttr && c.animate(this.renderer.getRadialAttr(b, c.radAttr));
                return this;
            }
            setTextPath(b, c) {
                c = G(!0, {
                    enabled: !0,
                    attributes: {
                        dy: -5,
                        startOffset: "50%",
                        textAnchor: "middle"
                    }
                }, c);
                const f = this.renderer.url, d = this.text || this, k = d.textPath, { attributes: n, enabled: A } = c;
                b = b || k && k.path;
                k && k.undo();
                b && A ? (c = t(d, "afterModifyTree", (c)=>{
                    if (b && A) {
                        let A = b.attr("id");
                        A || b.attr("id", A = P());
                        var k = {
                            x: 0,
                            y: 0
                        };
                        e(n.dx) && (k.dx = n.dx, delete n.dx);
                        e(n.dy) && (k.dy = n.dy, delete n.dy);
                        d.attr(k);
                        this.attr({
                            transform: ""
                        });
                        this.box && (this.box = this.box.destroy());
                        k = c.nodes.slice(0);
                        c.nodes.length = 0;
                        c.nodes[0] = {
                            tagName: "textPath",
                            attributes: E(n, {
                                "text-anchor": n.textAnchor,
                                href: `${f}#${A}`
                            }),
                            children: k
                        };
                    }
                }), d.textPath = {
                    path: b,
                    undo: c
                }) : (d.attr({
                    dx: 0,
                    dy: 0
                }), delete d.textPath);
                this.added && (d.textCache = "", this.renderer.buildText(d));
                return this;
            }
            shadow(b) {
                var c;
                const { renderer: f } = this, d = G(90 === (null === (c = this.parentGroup) || void 0 === c ? void 0 : c.rotation) ? {
                    offsetX: -1,
                    offsetY: -1
                } : {}, r(b) ? b : {});
                c = f.shadowDefinition(d);
                return this.attr({
                    filter: b ? `url(${f.url}#${c})` : "none"
                });
            }
            show(b = !0) {
                return this.attr({
                    visibility: b ? "inherit" : "visible"
                });
            }
            ["stroke-widthSetter"](b, c, f) {
                this[c] = b;
                f.setAttribute(c, b);
            }
            strokeWidth() {
                if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                const b = this.getStyle("stroke-width");
                let f = 0, d;
                b.indexOf("px") === b.length - 2 ? f = c(b) : "" !== b && (d = u.createElementNS(l, "rect"), m(d, {
                    width: b,
                    "stroke-width": 0
                }), this.element.parentNode.appendChild(d), f = d.getBBox().width, d.parentNode.removeChild(d));
                return f;
            }
            symbolAttr(b) {
                const c = this;
                D.symbolCustomAttribs.forEach(function(d) {
                    c[d] = f(b[d], c[d]);
                });
                c.attr({
                    d: c.renderer.symbols[c.symbolName](c.x, c.y, c.width, c.height, c)
                });
            }
            textSetter(b) {
                b !== this.textStr && (delete this.textPxLength, this.textStr = b, this.added && this.renderer.buildText(this));
            }
            titleSetter(b) {
                const c = this.element, d = c.getElementsByTagName("title")[0] || u.createElementNS(this.SVG_NS, "title");
                c.insertBefore ? c.insertBefore(d, c.firstChild) : c.appendChild(d);
                d.textContent = String(f(b, "")).replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }
            toFront() {
                const b = this.element;
                b.parentNode.appendChild(b);
                return this;
            }
            translate(b, c) {
                return this.attr({
                    translateX: b,
                    translateY: c
                });
            }
            updateTransform() {
                const { element: b, matrix: c, rotation: d = 0, scaleX: k, scaleY: n, translateX: q = 0, translateY: A = 0 } = this, g = [
                    "translate(" + q + "," + A + ")"
                ];
                e(c) && g.push("matrix(" + c.join(",") + ")");
                d && g.push("rotate(" + d + " " + f(this.rotationOriginX, b.getAttribute("x"), 0) + " " + f(this.rotationOriginY, b.getAttribute("y") || 0) + ")");
                (e(k) || e(n)) && g.push("scale(" + f(k, 1) + " " + f(n, 1) + ")");
                g.length && !(this.text || this).textPath && b.setAttribute("transform", g.join(" "));
            }
            visibilitySetter(b, c, f) {
                "inherit" === b ? f.removeAttribute(c) : this[c] !== b && f.setAttribute(c, b);
                this[c] = b;
            }
            xGetter(b) {
                "circle" === this.element.nodeName && ("x" === b ? b = "cx" : "y" === b && (b = "cy"));
                return this._defaultGetter(b);
            }
            zIndexSetter(b, f) {
                var d = this.renderer, k = this.parentGroup;
                const n = (k || d).element || d.box, q = this.element;
                d = n === d.box;
                let A = !1, g;
                var a = this.added;
                let r;
                e(b) ? (q.setAttribute("data-z-index", b), b = +b, this[f] === b && (a = !1)) : e(this[f]) && q.removeAttribute("data-z-index");
                this[f] = b;
                if (a) {
                    (b = this.zIndex) && k && (k.handleZ = !0);
                    f = n.childNodes;
                    for(r = f.length - 1; 0 <= r && !A; r--)if (k = f[r], a = k.getAttribute("data-z-index"), g = !e(a), k !== q) {
                        if (0 > b && g && !d && !r) n.insertBefore(q, f[r]), A = !0;
                        else if (c(a) <= b || g && (!e(b) || 0 <= b)) n.insertBefore(q, f[r + 1]), A = !0;
                    }
                    A || (n.insertBefore(q, f[d ? 3 : 0]), A = !0);
                }
                return A;
            }
        }
        D.symbolCustomAttribs = "anchorX anchorY clockwise end height innerR r start width x y".split(" ");
        D.prototype.strokeSetter = D.prototype.fillSetter;
        D.prototype.yGetter = D.prototype.xGetter;
        D.prototype.matrixSetter = D.prototype.rotationOriginXSetter = D.prototype.rotationOriginYSetter = D.prototype.rotationSetter = D.prototype.scaleXSetter = D.prototype.scaleYSetter = D.prototype.translateXSetter = D.prototype.translateYSetter = D.prototype.verticalAlignSetter = function(b, c) {
            this[c] = b;
            this.doTransform = !0;
        };
        "";
        return D;
    });
    M(a, "Core/Renderer/RendererRegistry.js", [
        a["Core/Globals.js"]
    ], function(a) {
        var x;
        (function(x) {
            x.rendererTypes = {};
            let y;
            x.getRendererType = function(a = y) {
                return x.rendererTypes[a] || x.rendererTypes[y];
            };
            x.registerRendererType = function(C, z, H) {
                x.rendererTypes[C] = z;
                if (!y || H) y = C, a.Renderer = z;
            };
        })(x || (x = {}));
        return x;
    });
    M(a, "Core/Renderer/SVG/SVGLabel.js", [
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        const { defined: x, extend: L, isNumber: C, merge: z, pick: H, removeEvent: B } = y;
        class u extends a {
            constructor(a, l, p, t, m, h, g, e, w, E){
                super();
                this.paddingRightSetter = this.paddingLeftSetter = this.paddingSetter;
                this.init(a, "g");
                this.textStr = l;
                this.x = p;
                this.y = t;
                this.anchorX = h;
                this.anchorY = g;
                this.baseline = w;
                this.className = E;
                this.addClass("button" === E ? "highcharts-no-tooltip" : "highcharts-label");
                E && this.addClass("highcharts-" + E);
                this.text = a.text(void 0, 0, 0, e).attr({
                    zIndex: 1
                });
                let v;
                "string" === typeof m && ((v = /^url\((.*?)\)$/.test(m)) || this.renderer.symbols[m]) && (this.symbolKey = m);
                this.bBox = u.emptyBBox;
                this.padding = 3;
                this.baselineOffset = 0;
                this.needsBox = a.styledMode || v;
                this.deferredAttr = {};
                this.alignFactor = 0;
            }
            alignSetter(a) {
                a = ({
                    left: 0,
                    center: .5,
                    right: 1
                })[a];
                a !== this.alignFactor && (this.alignFactor = a, this.bBox && C(this.xSetting) && this.attr({
                    x: this.xSetting
                }));
            }
            anchorXSetter(a, l) {
                this.anchorX = a;
                this.boxAttr(l, Math.round(a) - this.getCrispAdjust() - this.xSetting);
            }
            anchorYSetter(a, l) {
                this.anchorY = a;
                this.boxAttr(l, a - this.ySetting);
            }
            boxAttr(a, l) {
                this.box ? this.box.attr(a, l) : this.deferredAttr[a] = l;
            }
            css(v) {
                if (v) {
                    const a = {};
                    v = z(v);
                    u.textProps.forEach((l)=>{
                        "undefined" !== typeof v[l] && (a[l] = v[l], delete v[l]);
                    });
                    this.text.css(a);
                    "fontSize" in a || "fontWeight" in a ? this.updateTextPadding() : ("width" in a || "textOverflow" in a) && this.updateBoxSize();
                }
                return a.prototype.css.call(this, v);
            }
            destroy() {
                B(this.element, "mouseenter");
                B(this.element, "mouseleave");
                this.text && this.text.destroy();
                this.box && (this.box = this.box.destroy());
                a.prototype.destroy.call(this);
            }
            fillSetter(a, l) {
                a && (this.needsBox = !0);
                this.fill = a;
                this.boxAttr(l, a);
            }
            getBBox() {
                this.textStr && 0 === this.bBox.width && 0 === this.bBox.height && this.updateBoxSize();
                const a = this.padding, l = H(this.paddingLeft, a);
                return {
                    width: this.width,
                    height: this.height,
                    x: this.bBox.x - l,
                    y: this.bBox.y - a
                };
            }
            getCrispAdjust() {
                return this.renderer.styledMode && this.box ? this.box.strokeWidth() % 2 / 2 : (this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            }
            heightSetter(a) {
                this.heightSetting = a;
            }
            onAdd() {
                this.text.add(this);
                this.attr({
                    text: H(this.textStr, ""),
                    x: this.x || 0,
                    y: this.y || 0
                });
                this.box && x(this.anchorX) && this.attr({
                    anchorX: this.anchorX,
                    anchorY: this.anchorY
                });
            }
            paddingSetter(a, l) {
                C(a) ? a !== this[l] && (this[l] = a, this.updateTextPadding()) : this[l] = void 0;
            }
            rSetter(a, l) {
                this.boxAttr(l, a);
            }
            strokeSetter(a, l) {
                this.stroke = a;
                this.boxAttr(l, a);
            }
            ["stroke-widthSetter"](a, l) {
                a && (this.needsBox = !0);
                this["stroke-width"] = a;
                this.boxAttr(l, a);
            }
            ["text-alignSetter"](a) {
                this.textAlign = a;
            }
            textSetter(a) {
                "undefined" !== typeof a && this.text.attr({
                    text: a
                });
                this.updateTextPadding();
            }
            updateBoxSize() {
                var a = this.text;
                const l = {}, p = this.padding, t = this.bBox = C(this.widthSetting) && C(this.heightSetting) && !this.textAlign || !x(a.textStr) ? u.emptyBBox : a.getBBox();
                this.width = this.getPaddedWidth();
                this.height = (this.heightSetting || t.height || 0) + 2 * p;
                const m = this.renderer.fontMetrics(a);
                this.baselineOffset = p + Math.min((this.text.firstLineMetrics || m).b, t.height || Infinity);
                this.heightSetting && (this.baselineOffset += (this.heightSetting - m.h) / 2);
                this.needsBox && !a.textPath && (this.box || (a = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect(), a.addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), a.add(this)), a = this.getCrispAdjust(), l.x = a, l.y = (this.baseline ? -this.baselineOffset : 0) + a, l.width = Math.round(this.width), l.height = Math.round(this.height), this.box.attr(L(l, this.deferredAttr)), this.deferredAttr = {});
            }
            updateTextPadding() {
                const a = this.text;
                if (!a.textPath) {
                    this.updateBoxSize();
                    const l = this.baseline ? 0 : this.baselineOffset;
                    let p = H(this.paddingLeft, this.padding);
                    x(this.widthSetting) && this.bBox && ("center" === this.textAlign || "right" === this.textAlign) && (p += ({
                        center: .5,
                        right: 1
                    })[this.textAlign] * (this.widthSetting - this.bBox.width));
                    if (p !== a.x || l !== a.y) a.attr("x", p), a.hasBoxWidthChanged && (this.bBox = a.getBBox(!0)), "undefined" !== typeof l && a.attr("y", l);
                    a.x = p;
                    a.y = l;
                }
            }
            widthSetter(a) {
                this.widthSetting = C(a) ? a : void 0;
            }
            getPaddedWidth() {
                var a = this.padding;
                const l = H(this.paddingLeft, a);
                a = H(this.paddingRight, a);
                return (this.widthSetting || this.bBox.width || 0) + l + a;
            }
            xSetter(a) {
                this.x = a;
                this.alignFactor && (a -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0);
                this.xSetting = Math.round(a);
                this.attr("translateX", this.xSetting);
            }
            ySetter(a) {
                this.ySetting = this.y = Math.round(a);
                this.attr("translateY", this.ySetting);
            }
        }
        u.emptyBBox = {
            width: 0,
            height: 0,
            x: 0,
            y: 0
        };
        u.textProps = "color direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow whiteSpace width".split(" ");
        return u;
    });
    M(a, "Core/Renderer/SVG/Symbols.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        function x(a, u, v, l, p) {
            const t = [];
            if (p) {
                const m = p.start || 0, h = H(p.r, v);
                v = H(p.r, l || v);
                l = (p.end || 0) - .001;
                const g = p.innerR, e = H(p.open, .001 > Math.abs((p.end || 0) - m - 2 * Math.PI)), w = Math.cos(m), E = Math.sin(m), F = Math.cos(l), d = Math.sin(l), k = H(p.longArc, .001 > l - m - Math.PI ? 0 : 1);
                let r = [
                    "A",
                    h,
                    v,
                    0,
                    k,
                    H(p.clockwise, 1),
                    a + h * F,
                    u + v * d
                ];
                r.params = {
                    start: m,
                    end: l,
                    cx: a,
                    cy: u
                };
                t.push([
                    "M",
                    a + h * w,
                    u + v * E
                ], r);
                C(g) && (r = [
                    "A",
                    g,
                    g,
                    0,
                    k,
                    C(p.clockwise) ? 1 - p.clockwise : 0,
                    a + g * w,
                    u + g * E
                ], r.params = {
                    start: l,
                    end: m,
                    cx: a,
                    cy: u
                }, t.push(e ? [
                    "M",
                    a + g * F,
                    u + g * d
                ] : [
                    "L",
                    a + g * F,
                    u + g * d
                ], r));
                e || t.push([
                    "Z"
                ]);
            }
            return t;
        }
        function I(a, u, v, l, p) {
            return p && p.r ? L(a, u, v, l, p) : [
                [
                    "M",
                    a,
                    u
                ],
                [
                    "L",
                    a + v,
                    u
                ],
                [
                    "L",
                    a + v,
                    u + l
                ],
                [
                    "L",
                    a,
                    u + l
                ],
                [
                    "Z"
                ]
            ];
        }
        function L(a, u, v, l, p) {
            p = (null === p || void 0 === p ? void 0 : p.r) || 0;
            return [
                [
                    "M",
                    a + p,
                    u
                ],
                [
                    "L",
                    a + v - p,
                    u
                ],
                [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    a + v,
                    u + p
                ],
                [
                    "L",
                    a + v,
                    u + l - p
                ],
                [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    a + v - p,
                    u + l
                ],
                [
                    "L",
                    a + p,
                    u + l
                ],
                [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    a,
                    u + l - p
                ],
                [
                    "L",
                    a,
                    u + p
                ],
                [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    a + p,
                    u
                ],
                [
                    "Z"
                ]
            ];
        }
        const { defined: C, isNumber: z, pick: H } = a;
        return {
            arc: x,
            callout: function(a, u, v, l, p) {
                const t = Math.min(p && p.r || 0, v, l), m = t + 6, h = p && p.anchorX;
                p = p && p.anchorY || 0;
                const g = L(a, u, v, l, {
                    r: t
                });
                if (!z(h)) return g;
                a + h >= v ? p > u + m && p < u + l - m ? g.splice(3, 1, [
                    "L",
                    a + v,
                    p - 6
                ], [
                    "L",
                    a + v + 6,
                    p
                ], [
                    "L",
                    a + v,
                    p + 6
                ], [
                    "L",
                    a + v,
                    u + l - t
                ]) : g.splice(3, 1, [
                    "L",
                    a + v,
                    l / 2
                ], [
                    "L",
                    h,
                    p
                ], [
                    "L",
                    a + v,
                    l / 2
                ], [
                    "L",
                    a + v,
                    u + l - t
                ]) : 0 >= a + h ? p > u + m && p < u + l - m ? g.splice(7, 1, [
                    "L",
                    a,
                    p + 6
                ], [
                    "L",
                    a - 6,
                    p
                ], [
                    "L",
                    a,
                    p - 6
                ], [
                    "L",
                    a,
                    u + t
                ]) : g.splice(7, 1, [
                    "L",
                    a,
                    l / 2
                ], [
                    "L",
                    h,
                    p
                ], [
                    "L",
                    a,
                    l / 2
                ], [
                    "L",
                    a,
                    u + t
                ]) : p && p > l && h > a + m && h < a + v - m ? g.splice(5, 1, [
                    "L",
                    h + 6,
                    u + l
                ], [
                    "L",
                    h,
                    u + l + 6
                ], [
                    "L",
                    h - 6,
                    u + l
                ], [
                    "L",
                    a + t,
                    u + l
                ]) : p && 0 > p && h > a + m && h < a + v - m && g.splice(1, 1, [
                    "L",
                    h - 6,
                    u
                ], [
                    "L",
                    h,
                    u - 6
                ], [
                    "L",
                    h + 6,
                    u
                ], [
                    "L",
                    v - t,
                    u
                ]);
                return g;
            },
            circle: function(a, u, v, l) {
                return x(a + v / 2, u + l / 2, v / 2, l / 2, {
                    start: .5 * Math.PI,
                    end: 2.5 * Math.PI,
                    open: !1
                });
            },
            diamond: function(a, u, v, l) {
                return [
                    [
                        "M",
                        a + v / 2,
                        u
                    ],
                    [
                        "L",
                        a + v,
                        u + l / 2
                    ],
                    [
                        "L",
                        a + v / 2,
                        u + l
                    ],
                    [
                        "L",
                        a,
                        u + l / 2
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            rect: I,
            roundedRect: L,
            square: I,
            triangle: function(a, u, v, l) {
                return [
                    [
                        "M",
                        a + v / 2,
                        u
                    ],
                    [
                        "L",
                        a + v,
                        u + l
                    ],
                    [
                        "L",
                        a,
                        u + l
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            "triangle-down": function(a, u, v, l) {
                return [
                    [
                        "M",
                        a,
                        u
                    ],
                    [
                        "L",
                        a + v,
                        u
                    ],
                    [
                        "L",
                        a + v / 2,
                        u + l
                    ],
                    [
                        "Z"
                    ]
                ];
            }
        };
    });
    M(a, "Core/Renderer/SVG/TextBuilder.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { doc: x, SVG_NS: C, win: z } = y, { attr: H, extend: B, fireEvent: u, isString: v, objectEach: l, pick: p } = I;
        class t {
            constructor(a){
                const h = a.styles;
                this.renderer = a.renderer;
                this.svgElement = a;
                this.width = a.textWidth;
                this.textLineHeight = h && h.lineHeight;
                this.textOutline = h && h.textOutline;
                this.ellipsis = !(!h || "ellipsis" !== h.textOverflow);
                this.noWrap = !(!h || "nowrap" !== h.whiteSpace);
            }
            buildSVG() {
                const m = this.svgElement, h = m.element;
                var g = m.renderer, e = p(m.textStr, "").toString();
                const w = -1 !== e.indexOf("<"), l = h.childNodes;
                g = !m.added && g.box;
                const t = /<br.*?>/g;
                var d = [
                    e,
                    this.ellipsis,
                    this.noWrap,
                    this.textLineHeight,
                    this.textOutline,
                    m.getStyle("font-size"),
                    this.width
                ].join();
                if (d !== m.textCache) {
                    m.textCache = d;
                    delete m.actualWidth;
                    for(d = l.length; d--;)h.removeChild(l[d]);
                    w || this.ellipsis || this.width || m.textPath || -1 !== e.indexOf(" ") && (!this.noWrap || t.test(e)) ? "" !== e && (g && g.appendChild(h), e = new a(e), this.modifyTree(e.nodes), e.addToDOM(h), this.modifyDOM(), this.ellipsis && -1 !== (h.textContent || "").indexOf("\u2026") && m.attr("title", this.unescapeEntities(m.textStr || "", [
                        "&lt;",
                        "&gt;"
                    ])), g && g.removeChild(h)) : h.appendChild(x.createTextNode(this.unescapeEntities(e)));
                    v(this.textOutline) && m.applyTextOutline && m.applyTextOutline(this.textOutline);
                }
            }
            modifyDOM() {
                const a = this.svgElement, h = H(a.element, "x");
                a.firstLineMetrics = void 0;
                let g;
                for(; g = a.element.firstChild;)if (/^[\s\u200B]*$/.test(g.textContent || " ")) a.element.removeChild(g);
                else break;
                [].forEach.call(a.element.querySelectorAll("tspan.highcharts-br"), (e, d)=>{
                    e.nextSibling && e.previousSibling && (0 === d && 1 === e.previousSibling.nodeType && (a.firstLineMetrics = a.renderer.fontMetrics(e.previousSibling)), H(e, {
                        dy: this.getLineHeight(e.nextSibling),
                        x: h
                    }));
                });
                const e = this.width || 0;
                if (e) {
                    var w = (g, d)=>{
                        var k = g.textContent || "";
                        const r = k.replace(/([^\^])-/g, "$1- ").split(" ");
                        var q = !this.noWrap && (1 < r.length || 1 < a.element.childNodes.length);
                        const m = this.getLineHeight(d);
                        let b = 0, f = a.actualWidth;
                        if (this.ellipsis) k && this.truncate(g, k, void 0, 0, Math.max(0, e - .8 * m), (b, f)=>b.substring(0, f) + "\u2026");
                        else if (q) {
                            k = [];
                            for(q = []; d.firstChild && d.firstChild !== g;)q.push(d.firstChild), d.removeChild(d.firstChild);
                            for(; r.length;)r.length && !this.noWrap && 0 < b && (k.push(g.textContent || ""), g.textContent = r.join(" ").replace(/- /g, "-")), this.truncate(g, void 0, r, 0 === b ? f || 0 : 0, e, (b, f)=>r.slice(0, f).join(" ").replace(/- /g, "-")), f = a.actualWidth, b++;
                            q.forEach((b)=>{
                                d.insertBefore(b, g);
                            });
                            k.forEach((b)=>{
                                d.insertBefore(x.createTextNode(b), g);
                                b = x.createElementNS(C, "tspan");
                                b.textContent = "\u200B";
                                H(b, {
                                    dy: m,
                                    x: h
                                });
                                d.insertBefore(b, g);
                            });
                        }
                    }, l = (e)=>{
                        [].slice.call(e.childNodes).forEach((d)=>{
                            d.nodeType === z.Node.TEXT_NODE ? w(d, e) : (-1 !== d.className.baseVal.indexOf("highcharts-br") && (a.actualWidth = 0), l(d));
                        });
                    };
                    l(a.element);
                }
            }
            getLineHeight(a) {
                a = a.nodeType === z.Node.TEXT_NODE ? a.parentElement : a;
                return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(a || this.svgElement.element).h;
            }
            modifyTree(a) {
                const h = (g, e)=>{
                    const { attributes: m = {}, children: l, style: p = {}, tagName: d } = g, k = this.renderer.styledMode;
                    if ("b" === d || "strong" === d) k ? m["class"] = "highcharts-strong" : p.fontWeight = "bold";
                    else if ("i" === d || "em" === d) k ? m["class"] = "highcharts-emphasized" : p.fontStyle = "italic";
                    p && p.color && (p.fill = p.color);
                    "br" === d ? (m["class"] = "highcharts-br", g.textContent = "\u200B", (e = a[e + 1]) && e.textContent && (e.textContent = e.textContent.replace(/^ +/gm, ""))) : "a" === d && l && l.some((d)=>"#text" === d.tagName) && (g.children = [
                        {
                            children: l,
                            tagName: "tspan"
                        }
                    ]);
                    "#text" !== d && "a" !== d && (g.tagName = "tspan");
                    B(g, {
                        attributes: m,
                        style: p
                    });
                    l && l.filter((d)=>"#text" !== d.tagName).forEach(h);
                };
                a.forEach(h);
                u(this.svgElement, "afterModifyTree", {
                    nodes: a
                });
            }
            truncate(a, h, g, e, l, p) {
                const m = this.svgElement, { rotation: d } = m, k = [];
                let r = g ? 1 : 0, q = (h || g || "").length, w = q, b, f;
                const c = function(b, c) {
                    b = c || b;
                    if ((c = a.parentNode) && "undefined" === typeof k[b] && c.getSubStringLength) try {
                        k[b] = e + c.getSubStringLength(0, g ? b + 1 : b);
                    } catch (D) {
                        "";
                    }
                    return k[b];
                };
                m.rotation = 0;
                f = c(a.textContent.length);
                if (e + f > l) {
                    for(; r <= q;)w = Math.ceil((r + q) / 2), g && (b = p(g, w)), f = c(w, b && b.length - 1), r === q ? r = q + 1 : f > l ? q = w - 1 : r = w;
                    0 === q ? a.textContent = "" : h && q === h.length - 1 || (a.textContent = b || p(h || g, w));
                }
                g && g.splice(0, w);
                m.actualWidth = f;
                m.rotation = d;
            }
            unescapeEntities(a, h) {
                l(this.renderer.escapes, function(g, e) {
                    h && -1 !== h.indexOf(g) || (a = a.toString().replace(new RegExp(g, "g"), e));
                });
                return a;
            }
        }
        return t;
    });
    M(a, "Core/Renderer/SVG/SVGRenderer.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGLabel.js"],
        a["Core/Renderer/SVG/Symbols.js"],
        a["Core/Renderer/SVG/TextBuilder.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z, H, B, u) {
        const { charts: v, deg2rad: l, doc: p, isFirefox: t, isMS: m, isWebKit: h, noop: g, SVG_NS: e, symbolSizes: w, win: E } = I, { addEvent: F, attr: d, createElement: k, css: r, defined: q, destroyObjectProperties: G, extend: b, isArray: f, isNumber: c, isObject: n, isString: P, merge: D, pick: K, pInt: x, uniqueKey: T } = u;
        let Z;
        class V {
            constructor(b, c, f, d, a, k, n){
                this.width = this.url = this.style = this.imgCount = this.height = this.gradients = this.globalAnimation = this.defs = this.chartIndex = this.cacheKeys = this.cache = this.boxWrapper = this.box = this.alignedObjects = void 0;
                this.init(b, c, f, d, a, k, n);
            }
            init(b, c, f, a, k, n, J) {
                const A = this.createElement("svg").attr({
                    version: "1.1",
                    "class": "highcharts-root"
                }), e = A.element;
                J || A.css(this.getStyle(a));
                b.appendChild(e);
                d(b, "dir", "ltr");
                -1 === b.innerHTML.indexOf("xmlns") && d(e, "xmlns", this.SVG_NS);
                this.box = e;
                this.boxWrapper = A;
                this.alignedObjects = [];
                this.url = this.getReferenceURL();
                this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 11.1.0"));
                this.defs = this.createElement("defs").add();
                this.allowHTML = n;
                this.forExport = k;
                this.styledMode = J;
                this.gradients = {};
                this.cache = {};
                this.cacheKeys = [];
                this.imgCount = 0;
                this.rootFontSize = A.getStyle("font-size");
                this.setSize(c, f, !1);
                let q;
                t && b.getBoundingClientRect && (c = function() {
                    r(b, {
                        left: 0,
                        top: 0
                    });
                    q = b.getBoundingClientRect();
                    r(b, {
                        left: Math.ceil(q.left) - q.left + "px",
                        top: Math.ceil(q.top) - q.top + "px"
                    });
                }, c(), this.unSubPixelFix = F(E, "resize", c));
            }
            definition(b) {
                return new a([
                    b
                ]).addToDOM(this.defs.element);
            }
            getReferenceURL() {
                if ((t || h) && p.getElementsByTagName("base").length) {
                    if (!q(Z)) {
                        var b = T();
                        b = new a([
                            {
                                tagName: "svg",
                                attributes: {
                                    width: 8,
                                    height: 8
                                },
                                children: [
                                    {
                                        tagName: "defs",
                                        children: [
                                            {
                                                tagName: "clipPath",
                                                attributes: {
                                                    id: b
                                                },
                                                children: [
                                                    {
                                                        tagName: "rect",
                                                        attributes: {
                                                            width: 4,
                                                            height: 4
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        tagName: "rect",
                                        attributes: {
                                            id: "hitme",
                                            width: 8,
                                            height: 8,
                                            "clip-path": `url(#${b})`,
                                            fill: "rgba(0,0,0,0.001)"
                                        }
                                    }
                                ]
                            }
                        ]).addToDOM(p.body);
                        r(b, {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            zIndex: 9E5
                        });
                        const c = p.elementFromPoint(6, 6);
                        Z = "hitme" === (c && c.id);
                        p.body.removeChild(b);
                    }
                    if (Z) return E.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20");
                }
                return "";
            }
            getStyle(c) {
                return this.style = b({
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontSize: "1rem"
                }, c);
            }
            setStyle(b) {
                this.boxWrapper.css(this.getStyle(b));
            }
            isHidden() {
                return !this.boxWrapper.getBBox().width;
            }
            destroy() {
                const b = this.defs;
                this.box = null;
                this.boxWrapper = this.boxWrapper.destroy();
                G(this.gradients || {});
                this.gradients = null;
                this.defs = b.destroy();
                this.unSubPixelFix && this.unSubPixelFix();
                return this.alignedObjects = null;
            }
            createElement(b) {
                const c = new this.Element;
                c.init(this, b);
                return c;
            }
            getRadialAttr(b, c) {
                return {
                    cx: b[0] - b[2] / 2 + (c.cx || 0) * b[2],
                    cy: b[1] - b[2] / 2 + (c.cy || 0) * b[2],
                    r: (c.r || 0) * b[2]
                };
            }
            shadowDefinition(b) {
                const c = [
                    `highcharts-drop-shadow-${this.chartIndex}`,
                    ...Object.keys(b).map((c)=>b[c])
                ].join("-").replace(/[^a-z0-9\-]/g, ""), f = D({
                    color: "#000000",
                    offsetX: 1,
                    offsetY: 1,
                    opacity: .15,
                    width: 5
                }, b);
                this.defs.element.querySelector(`#${c}`) || this.definition({
                    tagName: "filter",
                    attributes: {
                        id: c
                    },
                    children: [
                        {
                            tagName: "feDropShadow",
                            attributes: {
                                dx: f.offsetX,
                                dy: f.offsetY,
                                "flood-color": f.color,
                                "flood-opacity": Math.min(5 * f.opacity, 1),
                                stdDeviation: f.width / 2
                            }
                        }
                    ]
                });
                return c;
            }
            buildText(b) {
                new B(b).buildSVG();
            }
            getContrast(b) {
                b = y.parse(b).rgba.map((b)=>{
                    b /= 255;
                    return .03928 >= b ? b / 12.92 : Math.pow((b + .055) / 1.055, 2.4);
                });
                b = .2126 * b[0] + .7152 * b[1] + .0722 * b[2];
                return 1.05 / (b + .05) > (b + .05) / .05 ? "#FFFFFF" : "#000000";
            }
            button(c, f, d, k, e = {}, q, J, g, r, h) {
                const A = this.label(c, f, d, r, void 0, void 0, h, void 0, "button"), O = this.styledMode;
                c = e.states || {};
                let N = 0;
                e = D(e);
                delete e.states;
                const l = D({
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    fontWeight: "normal"
                }, e.style);
                delete e.style;
                let w = a.filterUserAttributes(e);
                A.attr(D({
                    padding: 8,
                    r: 2
                }, w));
                let p, G, R;
                O || (w = D({
                    fill: "#f7f7f7",
                    stroke: "#cccccc",
                    "stroke-width": 1
                }, w), q = D(w, {
                    fill: "#e6e6e6"
                }, a.filterUserAttributes(q || c.hover || {})), p = q.style, delete q.style, J = D(w, {
                    fill: "#e6e9ff",
                    style: {
                        color: "#000000",
                        fontWeight: "bold"
                    }
                }, a.filterUserAttributes(J || c.select || {})), G = J.style, delete J.style, g = D(w, {
                    style: {
                        color: "#cccccc"
                    }
                }, a.filterUserAttributes(g || c.disabled || {})), R = g.style, delete g.style);
                F(A.element, m ? "mouseover" : "mouseenter", function() {
                    3 !== N && A.setState(1);
                });
                F(A.element, m ? "mouseout" : "mouseleave", function() {
                    3 !== N && A.setState(N);
                });
                A.setState = function(b) {
                    1 !== b && (A.state = N = b);
                    A.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                        "normal",
                        "hover",
                        "pressed",
                        "disabled"
                    ][b || 0]);
                    O || (A.attr([
                        w,
                        q,
                        J,
                        g
                    ][b || 0]), b = [
                        l,
                        p,
                        G,
                        R
                    ][b || 0], n(b) && A.css(b));
                };
                O || (A.attr(w).css(b({
                    cursor: "default"
                }, l)), h && A.text.css({
                    pointerEvents: "none"
                }));
                return A.on("touchstart", (b)=>b.stopPropagation()).on("click", function(b) {
                    3 !== N && k.call(A, b);
                });
            }
            crispLine(b, c, f = "round") {
                const d = b[0], a = b[1];
                q(d[1]) && d[1] === a[1] && (d[1] = a[1] = Math[f](d[1]) - c % 2 / 2);
                q(d[2]) && d[2] === a[2] && (d[2] = a[2] = Math[f](d[2]) + c % 2 / 2);
                return b;
            }
            path(c) {
                const d = this.styledMode ? {} : {
                    fill: "none"
                };
                f(c) ? d.d = c : n(c) && b(d, c);
                return this.createElement("path").attr(d);
            }
            circle(b, c, f) {
                b = n(b) ? b : "undefined" === typeof b ? {} : {
                    x: b,
                    y: c,
                    r: f
                };
                c = this.createElement("circle");
                c.xSetter = c.ySetter = function(b, c, f) {
                    f.setAttribute("c" + c, b);
                };
                return c.attr(b);
            }
            arc(b, c, f, d, a, k) {
                n(b) ? (d = b, c = d.y, f = d.r, b = d.x) : d = {
                    innerR: d,
                    start: a,
                    end: k
                };
                b = this.symbol("arc", b, c, f, f, d);
                b.r = f;
                return b;
            }
            rect(c, f, a, k, e, q) {
                c = n(c) ? c : "undefined" === typeof c ? {} : {
                    x: c,
                    y: f,
                    r: e,
                    width: Math.max(a || 0, 0),
                    height: Math.max(k || 0, 0)
                };
                const A = this.createElement("rect");
                this.styledMode || ("undefined" !== typeof q && (c["stroke-width"] = q, b(c, A.crisp(c))), c.fill = "none");
                A.rSetter = function(b, c, f) {
                    A.r = b;
                    d(f, {
                        rx: b,
                        ry: b
                    });
                };
                A.rGetter = function() {
                    return A.r || 0;
                };
                return A.attr(c);
            }
            roundedRect(b) {
                return this.symbol("roundedRect").attr(b);
            }
            setSize(b, c, f) {
                this.width = b;
                this.height = c;
                this.boxWrapper.animate({
                    width: b,
                    height: c
                }, {
                    step: function() {
                        this.attr({
                            viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                        });
                    },
                    duration: K(f, !0) ? void 0 : 0
                });
                this.alignElements();
            }
            g(b) {
                const c = this.createElement("g");
                return b ? c.attr({
                    "class": "highcharts-" + b
                }) : c;
            }
            image(b, f, d, a, k, n) {
                const A = {
                    preserveAspectRatio: "none"
                };
                c(f) && (A.x = f);
                c(d) && (A.y = d);
                c(a) && (A.width = a);
                c(k) && (A.height = k);
                const e = this.createElement("image").attr(A);
                f = function(c) {
                    e.attr({
                        href: b
                    });
                    n.call(e, c);
                };
                n ? (e.attr({
                    href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                }), d = new E.Image, F(d, "load", f), d.src = b, d.complete && f({})) : e.attr({
                    href: b
                });
                return e;
            }
            symbol(c, f, a, n, e, g) {
                const A = this, h = /^url\((.*?)\)$/, O = h.test(c), m = !O && (this.symbols[c] ? c : "circle"), l = m && this.symbols[m];
                let D, G, P, t;
                if (l) "number" === typeof f && (G = l.call(this.symbols, Math.round(f || 0), Math.round(a || 0), n || 0, e || 0, g)), D = this.path(G), A.styledMode || D.attr("fill", "none"), b(D, {
                    symbolName: m || void 0,
                    x: f,
                    y: a,
                    width: n,
                    height: e
                }), g && b(D, g);
                else if (O) {
                    P = c.match(h)[1];
                    const b = D = this.image(P);
                    b.imgwidth = K(g && g.width, w[P] && w[P].width);
                    b.imgheight = K(g && g.height, w[P] && w[P].height);
                    t = (b)=>b.attr({
                            width: b.width,
                            height: b.height
                        });
                    [
                        "width",
                        "height"
                    ].forEach(function(c) {
                        b[c + "Setter"] = function(b, c) {
                            this[c] = b;
                            const { alignByTranslate: f, element: a, width: k, height: A, imgwidth: n, imgheight: e } = this;
                            b = this["img" + c];
                            if (q(b)) {
                                let J = 1;
                                g && "within" === g.backgroundSize && k && A ? (J = Math.min(k / n, A / e), d(a, {
                                    width: Math.round(n * J),
                                    height: Math.round(e * J)
                                })) : a && a.setAttribute(c, b);
                                f || this.translate(((k || 0) - n * J) / 2, ((A || 0) - e * J) / 2);
                            }
                        };
                    });
                    q(f) && b.attr({
                        x: f,
                        y: a
                    });
                    b.isImg = !0;
                    q(b.imgwidth) && q(b.imgheight) ? t(b) : (b.attr({
                        width: 0,
                        height: 0
                    }), k("img", {
                        onload: function() {
                            const c = v[A.chartIndex];
                            0 === this.width && (r(this, {
                                position: "absolute",
                                top: "-999em"
                            }), p.body.appendChild(this));
                            w[P] = {
                                width: this.width,
                                height: this.height
                            };
                            b.imgwidth = this.width;
                            b.imgheight = this.height;
                            b.element && t(b);
                            this.parentNode && this.parentNode.removeChild(this);
                            A.imgCount--;
                            if (!A.imgCount && c && !c.hasLoaded) c.onload();
                        },
                        src: P
                    }), this.imgCount++);
                }
                return D;
            }
            clipRect(b, c, f, d) {
                const a = T() + "-", k = this.createElement("clipPath").attr({
                    id: a
                }).add(this.defs);
                b = this.rect(b, c, f, d, 0).add(k);
                b.id = a;
                b.clipPath = k;
                b.count = 0;
                return b;
            }
            text(b, c, f, d) {
                const a = {};
                if (d && (this.allowHTML || !this.forExport)) return this.html(b, c, f);
                a.x = Math.round(c || 0);
                f && (a.y = Math.round(f));
                q(b) && (a.text = b);
                b = this.createElement("text").attr(a);
                if (!d || this.forExport && !this.allowHTML) b.xSetter = function(b, c, f) {
                    const d = f.getElementsByTagName("tspan"), a = f.getAttribute(c);
                    for(let f = 0, k; f < d.length; f++)k = d[f], k.getAttribute(c) === a && k.setAttribute(c, b);
                    f.setAttribute(c, b);
                };
                return b;
            }
            fontMetrics(b) {
                b = x(C.prototype.getStyle.call(b, "font-size") || 0);
                const c = 24 > b ? b + 3 : Math.round(1.2 * b);
                return {
                    h: c,
                    b: Math.round(.8 * c),
                    f: b
                };
            }
            rotCorr(b, c, f) {
                let d = b;
                c && f && (d = Math.max(d * Math.cos(c * l), 4));
                return {
                    x: -b / 3 * Math.sin(c * l),
                    y: d
                };
            }
            pathToSegments(b) {
                const f = [], d = [], a = {
                    A: 8,
                    C: 7,
                    H: 2,
                    L: 3,
                    M: 3,
                    Q: 5,
                    S: 5,
                    T: 3,
                    V: 2
                };
                for(let k = 0; k < b.length; k++)P(d[0]) && c(b[k]) && d.length === a[d[0].toUpperCase()] && b.splice(k, 0, d[0].replace("M", "L").replace("m", "l")), "string" === typeof b[k] && (d.length && f.push(d.slice(0)), d.length = 0), d.push(b[k]);
                f.push(d.slice(0));
                return f;
            }
            label(b, c, f, d, a, k, n, e, q) {
                return new z(this, b, c, f, d, a, k, n, e, q);
            }
            alignElements() {
                this.alignedObjects.forEach((b)=>b.align());
            }
        }
        b(V.prototype, {
            Element: C,
            SVG_NS: e,
            escapes: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                "'": "&#39;",
                '"': "&quot;"
            },
            symbols: H,
            draw: g
        });
        L.registerRendererType("svg", V, !0);
        "";
        return V;
    });
    M(a, "Core/Renderer/HTML/HTMLElement.js", [
        a["Core/Globals.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { isFirefox: x, isMS: C, isWebKit: z, win: H } = a, { css: B, defined: u, extend: v, pick: l, pInt: p } = I, t = [];
        class m extends y {
            static compose(a) {
                if (I.pushUnique(t, a)) {
                    const g = m.prototype, e = a.prototype;
                    e.getSpanCorrection = g.getSpanCorrection;
                    e.htmlCss = g.htmlCss;
                    e.htmlGetBBox = g.htmlGetBBox;
                    e.htmlUpdateTransform = g.htmlUpdateTransform;
                    e.setSpanRotation = g.setSpanRotation;
                }
                return a;
            }
            getSpanCorrection(a, g, e) {
                this.xCorr = -a * e;
                this.yCorr = -g;
            }
            htmlCss(a) {
                const g = "SPAN" === this.element.tagName && a && "width" in a, e = l(g && a.width, void 0);
                let h;
                g && (delete a.width, this.textWidth = e, h = !0);
                a && "ellipsis" === a.textOverflow && (a.whiteSpace = "nowrap", a.overflow = "hidden");
                this.styles = v(this.styles, a);
                B(this.element, a);
                h && this.htmlUpdateTransform();
                return this;
            }
            htmlGetBBox() {
                const a = this.element;
                return {
                    x: a.offsetLeft,
                    y: a.offsetTop,
                    width: a.offsetWidth,
                    height: a.offsetHeight
                };
            }
            htmlUpdateTransform() {
                if (this.added) {
                    var a = this.renderer, g = this.element, e = this.x || 0, m = this.y || 0, l = this.textAlign || "left", t = {
                        left: 0,
                        center: .5,
                        right: 1
                    }[l], d = this.styles, k = d && d.whiteSpace;
                    B(g, {
                        marginLeft: this.translateX || 0,
                        marginTop: this.translateY || 0
                    });
                    if ("SPAN" === g.tagName) {
                        d = this.rotation;
                        const q = this.textWidth && p(this.textWidth), h = [
                            d,
                            l,
                            g.innerHTML,
                            this.textWidth,
                            this.textAlign
                        ].join();
                        let b = !1;
                        if (q !== this.oldTextWidth) {
                            if (this.textPxLength) var r = this.textPxLength;
                            else B(g, {
                                width: "",
                                whiteSpace: k || "nowrap"
                            }), r = g.offsetWidth;
                            (q > this.oldTextWidth || r > q) && (/[ \-]/.test(g.textContent || g.innerText) || "ellipsis" === g.style.textOverflow) && (B(g, {
                                width: r > q || d ? q + "px" : "auto",
                                display: "block",
                                whiteSpace: k || "normal"
                            }), this.oldTextWidth = q, b = !0);
                        }
                        this.hasBoxWidthChanged = b;
                        h !== this.cTT && (a = a.fontMetrics(g).b, !u(d) || d === (this.oldRotation || 0) && l === this.oldAlign || this.setSpanRotation(d, t, a), this.getSpanCorrection(!u(d) && this.textPxLength || g.offsetWidth, a, t, d, l));
                        B(g, {
                            left: e + (this.xCorr || 0) + "px",
                            top: m + (this.yCorr || 0) + "px"
                        });
                        this.cTT = h;
                        this.oldRotation = d;
                        this.oldAlign = l;
                    }
                } else this.alignOnAdd = !0;
            }
            setSpanRotation(a, g, e) {
                const h = {}, m = C && !/Edge/.test(H.navigator.userAgent) ? "-ms-transform" : z ? "-webkit-transform" : x ? "MozTransform" : H.opera ? "-o-transform" : void 0;
                m && (h[m] = h.transform = "rotate(" + a + "deg)", h[m + (x ? "Origin" : "-origin")] = h.transformOrigin = 100 * g + "% " + e + "px", B(this.element, h));
            }
        }
        return m;
    });
    M(a, "Core/Renderer/HTML/HTMLRenderer.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L) {
        const { attr: x, createElement: z, extend: H, pick: B } = L, u = [];
        class v extends I {
            static compose(a) {
                L.pushUnique(u, a) && (a.prototype.html = v.prototype.html);
                return a;
            }
            html(l, p, t) {
                const m = this.createElement("span"), h = m.element, g = m.renderer, e = function(a, e) {
                    [
                        "opacity",
                        "visibility"
                    ].forEach(function(g) {
                        a[g + "Setter"] = function(d, k, r) {
                            const q = a.div ? a.div.style : e;
                            y.prototype[g + "Setter"].call(this, d, k, r);
                            q && (q[k] = d);
                        };
                    });
                    a.addedSetters = !0;
                };
                m.textSetter = function(e) {
                    e !== this.textStr && (delete this.bBox, delete this.oldTextWidth, a.setElementHTML(this.element, B(e, "")), this.textStr = e, m.doTransform = !0);
                };
                e(m, m.element.style);
                m.xSetter = m.ySetter = m.alignSetter = m.rotationSetter = function(a, e) {
                    "align" === e ? m.alignValue = m.textAlign = a : m[e] = a;
                    m.doTransform = !0;
                };
                m.afterSetters = function() {
                    this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
                };
                m.attr({
                    text: l,
                    x: Math.round(p),
                    y: Math.round(t)
                }).css({
                    position: "absolute"
                });
                g.styledMode || m.css({
                    fontFamily: this.style.fontFamily,
                    fontSize: this.style.fontSize
                });
                h.style.whiteSpace = "nowrap";
                m.css = m.htmlCss;
                m.add = function(a) {
                    const l = g.box.parentNode, w = [];
                    let d;
                    if (this.parentGroup = a) {
                        if (d = a.div, !d) {
                            for(; a;)w.push(a), a = a.parentGroup;
                            w.reverse().forEach(function(a) {
                                function k(f, c) {
                                    a[c] = f;
                                    "translateX" === c ? b.left = f + "px" : b.top = f + "px";
                                    a.doTransform = !0;
                                }
                                const q = x(a.element, "class"), g = a.styles || {};
                                d = a.div = a.div || z("div", q ? {
                                    className: q
                                } : void 0, {
                                    position: "absolute",
                                    left: (a.translateX || 0) + "px",
                                    top: (a.translateY || 0) + "px",
                                    display: a.display,
                                    opacity: a.opacity,
                                    visibility: a.visibility
                                }, d || l);
                                const b = d.style;
                                H(a, {
                                    classSetter: function(b) {
                                        return function(c) {
                                            this.element.setAttribute("class", c);
                                            b.className = c;
                                        };
                                    }(d),
                                    css: function(f) {
                                        m.css.call(a, f);
                                        [
                                            "cursor",
                                            "pointerEvents"
                                        ].forEach((c)=>{
                                            f[c] && (b[c] = f[c]);
                                        });
                                        return a;
                                    },
                                    on: function() {
                                        w[0].div && m.on.apply({
                                            element: w[0].div,
                                            onEvents: a.onEvents
                                        }, arguments);
                                        return a;
                                    },
                                    translateXSetter: k,
                                    translateYSetter: k
                                });
                                a.addedSetters || e(a);
                                a.css(g);
                            });
                        }
                    } else d = l;
                    d.appendChild(h);
                    m.added = !0;
                    m.alignOnAdd && m.htmlUpdateTransform();
                    return m;
                };
                return m;
            }
        }
        return v;
    });
    M(a, "Core/Axis/AxisDefaults.js", [], function() {
        var a;
        (function(a) {
            a.defaultXAxisOptions = {
                alignTicks: !0,
                allowDecimals: void 0,
                panningEnabled: !0,
                zIndex: 2,
                zoomEnabled: !0,
                dateTimeLabelFormats: {
                    millisecond: {
                        main: "%H:%M:%S.%L",
                        range: !1
                    },
                    second: {
                        main: "%H:%M:%S",
                        range: !1
                    },
                    minute: {
                        main: "%H:%M",
                        range: !1
                    },
                    hour: {
                        main: "%H:%M",
                        range: !1
                    },
                    day: {
                        main: "%e %b"
                    },
                    week: {
                        main: "%e %b"
                    },
                    month: {
                        main: "%b '%y"
                    },
                    year: {
                        main: "%Y"
                    }
                },
                endOnTick: !1,
                gridLineDashStyle: "Solid",
                gridZIndex: 1,
                labels: {
                    autoRotation: void 0,
                    autoRotationLimit: 80,
                    distance: 15,
                    enabled: !0,
                    indentation: 10,
                    overflow: "justify",
                    padding: 5,
                    reserveSpace: void 0,
                    rotation: void 0,
                    staggerLines: 0,
                    step: 0,
                    useHTML: !1,
                    zIndex: 7,
                    style: {
                        color: "#333333",
                        cursor: "default",
                        fontSize: "0.8em"
                    }
                },
                maxPadding: .01,
                minorGridLineDashStyle: "Solid",
                minorTickLength: 2,
                minorTickPosition: "outside",
                minorTicksPerMajor: 5,
                minPadding: .01,
                offset: void 0,
                opposite: !1,
                reversed: void 0,
                reversedStacks: !1,
                showEmpty: !0,
                showFirstLabel: !0,
                showLastLabel: !0,
                startOfWeek: 1,
                startOnTick: !1,
                tickLength: 10,
                tickPixelInterval: 100,
                tickmarkPlacement: "between",
                tickPosition: "outside",
                title: {
                    align: "middle",
                    rotation: 0,
                    useHTML: !1,
                    x: 0,
                    y: 0,
                    style: {
                        color: "#666666",
                        fontSize: "0.8em"
                    }
                },
                type: "linear",
                uniqueNames: !0,
                visible: !0,
                minorGridLineColor: "#f2f2f2",
                minorGridLineWidth: 1,
                minorTickColor: "#999999",
                lineColor: "#333333",
                lineWidth: 1,
                gridLineColor: "#e6e6e6",
                gridLineWidth: void 0,
                tickColor: "#333333"
            };
            a.defaultYAxisOptions = {
                reversedStacks: !0,
                endOnTick: !0,
                maxPadding: .05,
                minPadding: .05,
                tickPixelInterval: 72,
                showLastLabel: !0,
                labels: {
                    x: void 0
                },
                startOnTick: !0,
                title: {
                    rotation: 270,
                    text: "Values"
                },
                stackLabels: {
                    animation: {},
                    allowOverlap: !1,
                    enabled: !1,
                    crop: !0,
                    overflow: "justify",
                    formatter: function() {
                        const { numberFormatter: a } = this.axis.chart;
                        return a(this.total || 0, -1);
                    },
                    style: {
                        color: "#000000",
                        fontSize: "0.7em",
                        fontWeight: "bold",
                        textOutline: "1px contrast"
                    }
                },
                gridLineWidth: 1,
                lineWidth: 0
            };
            a.defaultLeftAxisOptions = {
                title: {
                    rotation: 270
                }
            };
            a.defaultRightAxisOptions = {
                title: {
                    rotation: 90
                }
            };
            a.defaultBottomAxisOptions = {
                labels: {
                    autoRotation: [
                        -45
                    ]
                },
                margin: 15,
                title: {
                    rotation: 0
                }
            };
            a.defaultTopAxisOptions = {
                labels: {
                    autoRotation: [
                        -45
                    ]
                },
                margin: 15,
                title: {
                    rotation: 0
                }
            };
        })(a || (a = {}));
        return a;
    });
    M(a, "Core/Foundation.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { addEvent: x, isFunction: I, objectEach: L, removeEvent: C } = a;
        var z;
        (function(a) {
            a.registerEventOptions = function(a, u) {
                a.eventOptions = a.eventOptions || {};
                L(u.events, function(v, l) {
                    a.eventOptions[l] !== v && (a.eventOptions[l] && (C(a, l, a.eventOptions[l]), delete a.eventOptions[l]), I(v) && (a.eventOptions[l] = v, x(a, l, v, {
                        order: 0
                    })));
                });
            };
        })(z || (z = {}));
        return z;
    });
    M(a, "Core/Axis/Tick.js", [
        a["Core/Templating.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { deg2rad: x } = y, { clamp: C, correctFloat: z, defined: H, destroyObjectProperties: B, extend: u, fireEvent: v, isNumber: l, merge: p, objectEach: t, pick: m } = I;
        class h {
            constructor(a, e, h, m, l){
                this.isNewLabel = this.isNew = !0;
                this.axis = a;
                this.pos = e;
                this.type = h || "";
                this.parameters = l || {};
                this.tickmarkOffset = this.parameters.tickmarkOffset;
                this.options = this.parameters.options;
                v(this, "init");
                h || m || this.addLabel();
            }
            addLabel() {
                const g = this, e = g.axis;
                var h = e.options;
                const p = e.chart;
                var t = e.categories;
                const d = e.logarithmic, k = e.names, r = g.pos, q = m(g.options && g.options.labels, h.labels);
                var G = e.tickPositions;
                const b = r === G[0], f = r === G[G.length - 1], c = (!q.step || 1 === q.step) && 1 === e.tickInterval;
                G = G.info;
                let n = g.label, P, D, K;
                t = this.parameters.category || (t ? m(t[r], k[r], r) : r);
                d && l(t) && (t = z(d.lin2log(t)));
                e.dateTime && (G ? (D = p.time.resolveDTLFormat(h.dateTimeLabelFormats[!h.grid && G.higherRanks[r] || G.unitName]), P = D.main) : l(t) && (P = e.dateTime.getXDateFormat(t, h.dateTimeLabelFormats || {})));
                g.isFirst = b;
                g.isLast = f;
                const x = {
                    axis: e,
                    chart: p,
                    dateTimeLabelFormat: P,
                    isFirst: b,
                    isLast: f,
                    pos: r,
                    tick: g,
                    tickPositionInfo: G,
                    value: t
                };
                v(this, "labelFormat", x);
                const B = (b)=>q.formatter ? q.formatter.call(b, b) : q.format ? (b.text = e.defaultLabelFormatter.call(b, b), a.format(q.format, b, p)) : e.defaultLabelFormatter.call(b, b);
                h = B.call(x, x);
                const y = D && D.list;
                g.shortenLabel = y ? function() {
                    for(K = 0; K < y.length; K++)if (u(x, {
                        dateTimeLabelFormat: y[K]
                    }), n.attr({
                        text: B.call(x, x)
                    }), n.getBBox().width < e.getSlotWidth(g) - 2 * q.padding) return;
                    n.attr({
                        text: ""
                    });
                } : void 0;
                c && e._addedPlotLB && g.moveLabel(h, q);
                H(n) || g.movedLabel ? n && n.textStr !== h && !c && (!n.textWidth || q.style.width || n.styles.width || n.css({
                    width: null
                }), n.attr({
                    text: h
                }), n.textPxLength = n.getBBox().width) : (g.label = n = g.createLabel({
                    x: 0,
                    y: 0
                }, h, q), g.rotation = 0);
            }
            createLabel(a, e, h) {
                const g = this.axis, m = g.chart;
                if (a = H(e) && h.enabled ? m.renderer.text(e, a.x, a.y, h.useHTML).add(g.labelGroup) : null) m.styledMode || a.css(p(h.style)), a.textPxLength = a.getBBox().width;
                return a;
            }
            destroy() {
                B(this, this.axis);
            }
            getPosition(a, e, h, m) {
                const g = this.axis, d = g.chart, k = m && d.oldChartHeight || d.chartHeight;
                a = {
                    x: a ? z(g.translate(e + h, void 0, void 0, m) + g.transB) : g.left + g.offset + (g.opposite ? (m && d.oldChartWidth || d.chartWidth) - g.right - g.left : 0),
                    y: a ? k - g.bottom + g.offset - (g.opposite ? g.height : 0) : z(k - g.translate(e + h, void 0, void 0, m) - g.transB)
                };
                a.y = C(a.y, -100000, 1E5);
                v(this, "afterGetPosition", {
                    pos: a
                });
                return a;
            }
            getLabelPosition(a, e, h, l, p, d, k, r) {
                const q = this.axis, g = q.transA, b = q.isLinked && q.linkedParent ? q.linkedParent.reversed : q.reversed, f = q.staggerLines, c = q.tickRotCorr || {
                    x: 0,
                    y: 0
                }, n = l || q.reserveSpaceDefault ? 0 : -q.labelOffset * ("center" === q.labelAlign ? .5 : 1), w = p.distance, D = {};
                h = 0 === q.side ? h.rotation ? -w : -h.getBBox().height : 2 === q.side ? c.y + w : Math.cos(h.rotation * x) * (c.y - h.getBBox(!1, 0).height / 2);
                H(p.y) && (h = 0 === q.side && q.horiz ? p.y + h : p.y);
                a = a + m(p.x, [
                    0,
                    1,
                    0,
                    -1
                ][q.side] * w) + n + c.x - (d && l ? d * g * (b ? -1 : 1) : 0);
                e = e + h - (d && !l ? d * g * (b ? 1 : -1) : 0);
                f && (l = k / (r || 1) % f, q.opposite && (l = f - l - 1), e += q.labelOffset / f * l);
                D.x = a;
                D.y = Math.round(e);
                v(this, "afterGetLabelPosition", {
                    pos: D,
                    tickmarkOffset: d,
                    index: k
                });
                return D;
            }
            getLabelSize() {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            }
            getMarkPath(a, e, h, m, l, d) {
                return d.crispLine([
                    [
                        "M",
                        a,
                        e
                    ],
                    [
                        "L",
                        a + (l ? 0 : -h),
                        e + (l ? h : 0)
                    ]
                ], m);
            }
            handleOverflow(a) {
                const e = this.axis, g = e.options.labels, h = a.x;
                var l = e.chart.chartWidth, d = e.chart.spacing;
                const k = m(e.labelLeft, Math.min(e.pos, d[3]));
                d = m(e.labelRight, Math.max(e.isRadial ? 0 : e.pos + e.len, l - d[1]));
                const r = this.label, q = this.rotation, p = {
                    left: 0,
                    center: .5,
                    right: 1
                }[e.labelAlign || r.attr("align")], b = r.getBBox().width, f = e.getSlotWidth(this), c = {};
                let n = f, t = 1, D;
                if (q || "justify" !== g.overflow) 0 > q && h - p * b < k ? D = Math.round(h / Math.cos(q * x) - k) : 0 < q && h + p * b > d && (D = Math.round((l - h) / Math.cos(q * x)));
                else if (l = h + (1 - p) * b, h - p * b < k ? n = a.x + n * (1 - p) - k : l > d && (n = d - a.x + n * p, t = -1), n = Math.min(f, n), n < f && "center" === e.labelAlign && (a.x += t * (f - n - p * (f - Math.min(b, n)))), b > n || e.autoRotation && (r.styles || {}).width) D = n;
                D && (this.shortenLabel ? this.shortenLabel() : (c.width = Math.floor(D) + "px", (g.style || {}).textOverflow || (c.textOverflow = "ellipsis"), r.css(c)));
            }
            moveLabel(a, e) {
                const g = this;
                var h = g.label;
                const m = g.axis;
                let d = !1;
                h && h.textStr === a ? (g.movedLabel = h, d = !0, delete g.label) : t(m.ticks, function(k) {
                    d || k.isNew || k === g || !k.label || k.label.textStr !== a || (g.movedLabel = k.label, d = !0, k.labelPos = g.movedLabel.xy, delete k.label);
                });
                d || !g.labelPos && !h || (h = g.labelPos || h.xy, g.movedLabel = g.createLabel(h, a, e), g.movedLabel && g.movedLabel.attr({
                    opacity: 0
                }));
            }
            render(a, e, h) {
                var g = this.axis, l = g.horiz, d = this.pos, k = m(this.tickmarkOffset, g.tickmarkOffset);
                d = this.getPosition(l, d, k, e);
                k = d.x;
                const r = d.y;
                g = l && k === g.pos + g.len || !l && r === g.pos ? -1 : 1;
                l = m(h, this.label && this.label.newOpacity, 1);
                h = m(h, 1);
                this.isActive = !0;
                this.renderGridLine(e, h, g);
                this.renderMark(d, h, g);
                this.renderLabel(d, e, l, a);
                this.isNew = !1;
                v(this, "afterRender");
            }
            renderGridLine(a, e, h) {
                const g = this.axis, l = g.options, d = {}, k = this.pos, r = this.type, q = m(this.tickmarkOffset, g.tickmarkOffset), p = g.chart.renderer;
                let b = this.gridLine, f = l.gridLineWidth, c = l.gridLineColor, n = l.gridLineDashStyle;
                "minor" === this.type && (f = l.minorGridLineWidth, c = l.minorGridLineColor, n = l.minorGridLineDashStyle);
                b || (g.chart.styledMode || (d.stroke = c, d["stroke-width"] = f || 0, d.dashstyle = n), r || (d.zIndex = 1), a && (e = 0), this.gridLine = b = p.path().attr(d).addClass("highcharts-" + (r ? r + "-" : "") + "grid-line").add(g.gridGroup));
                if (b && (h = g.getPlotLinePath({
                    value: k + q,
                    lineWidth: b.strokeWidth() * h,
                    force: "pass",
                    old: a,
                    acrossPanes: !1
                }))) b[a || this.isNew ? "attr" : "animate"]({
                    d: h,
                    opacity: e
                });
            }
            renderMark(a, e, h) {
                const g = this.axis;
                var l = g.options;
                const d = g.chart.renderer, k = this.type, r = g.tickSize(k ? k + "Tick" : "tick"), q = a.x;
                a = a.y;
                const p = m(l["minor" !== k ? "tickWidth" : "minorTickWidth"], !k && g.isXAxis ? 1 : 0);
                l = l["minor" !== k ? "tickColor" : "minorTickColor"];
                let b = this.mark;
                const f = !b;
                r && (g.opposite && (r[0] = -r[0]), b || (this.mark = b = d.path().addClass("highcharts-" + (k ? k + "-" : "") + "tick").add(g.axisGroup), g.chart.styledMode || b.attr({
                    stroke: l,
                    "stroke-width": p
                })), b[f ? "attr" : "animate"]({
                    d: this.getMarkPath(q, a, r[0], b.strokeWidth() * h, g.horiz, d),
                    opacity: e
                }));
            }
            renderLabel(a, e, h, p) {
                var g = this.axis;
                const d = g.horiz, k = g.options, r = this.label, q = k.labels, t = q.step;
                g = m(this.tickmarkOffset, g.tickmarkOffset);
                const b = a.x;
                a = a.y;
                let f = !0;
                r && l(b) && (r.xy = a = this.getLabelPosition(b, a, r, d, q, g, p, t), this.isFirst && !this.isLast && !k.showFirstLabel || this.isLast && !this.isFirst && !k.showLastLabel ? f = !1 : !d || q.step || q.rotation || e || 0 === h || this.handleOverflow(a), t && p % t && (f = !1), f && l(a.y) ? (a.opacity = h, r[this.isNewLabel ? "attr" : "animate"](a).show(!0), this.isNewLabel = !1) : (r.hide(), this.isNewLabel = !0));
            }
            replaceMovedLabel() {
                const a = this.label, e = this.axis;
                a && !this.isNew && (a.animate({
                    opacity: 0
                }, void 0, a.destroy), delete this.label);
                e.isDirty = !0;
                this.label = this.movedLabel;
                delete this.movedLabel;
            }
        }
        "";
        return h;
    });
    M(a, "Core/Axis/Axis.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/AxisDefaults.js"],
        a["Core/Color/Color.js"],
        a["Core/Defaults.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Axis/Tick.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z, H, B) {
        const { animObject: u } = a, { defaultOptions: v } = L, { registerEventOptions: l } = C, { deg2rad: p } = z, { arrayMax: t, arrayMin: m, clamp: h, correctFloat: g, defined: e, destroyObjectProperties: w, erase: x, error: F, extend: d, fireEvent: k, getClosestDistance: r, insertItem: q, isArray: G, isNumber: b, isString: f, merge: c, normalizeTickInterval: n, objectEach: P, pick: D, relativeLength: K, removeEvent: X, splat: T, syncTimeout: Z } = B, V = (b, c)=>n(c, void 0, void 0, D(b.options.allowDecimals, .5 > c || void 0 !== b.tickAmount), !!b.tickAmount);
        class Y {
            constructor(b, c, f){
                this.zoomEnabled = this.width = this.visible = this.userOptions = this.translationSlope = this.transB = this.transA = this.top = this.ticks = this.tickRotCorr = this.tickPositions = this.tickmarkOffset = this.tickInterval = this.tickAmount = this.side = this.series = this.right = this.positiveValuesOnly = this.pos = this.pointRangePadding = this.pointRange = this.plotLinesAndBandsGroups = this.plotLinesAndBands = this.paddedTicks = this.overlap = this.options = this.offset = this.names = this.minPixelPadding = this.minorTicks = this.minorTickInterval = this.min = this.maxLabelLength = this.max = this.len = this.left = this.labelFormatter = this.labelEdge = this.isLinked = this.index = this.height = this.hasVisibleSeries = this.hasNames = this.eventOptions = this.coll = this.closestPointRange = this.chart = this.bottom = this.alternateBands = void 0;
                this.init(b, c, f);
            }
            init(c, f, a = this.coll) {
                const d = "xAxis" === a;
                this.chart = c;
                this.horiz = this.isZAxis || (c.inverted ? !d : d);
                this.isXAxis = d;
                this.coll = a;
                k(this, "init", {
                    userOptions: f
                });
                this.opposite = D(f.opposite, this.opposite);
                this.side = D(f.side, this.side, this.horiz ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3);
                this.setOptions(f);
                a = this.options;
                const A = a.labels, n = a.type;
                this.userOptions = f;
                this.minPixelPadding = 0;
                this.reversed = D(a.reversed, this.reversed);
                this.visible = a.visible;
                this.zoomEnabled = a.zoomEnabled;
                this.hasNames = "category" === n || !0 === a.categories;
                this.categories = a.categories || (this.hasNames ? [] : void 0);
                this.names || (this.names = [], this.names.keys = {});
                this.plotLinesAndBandsGroups = {};
                this.positiveValuesOnly = !!this.logarithmic;
                this.isLinked = e(a.linkedTo);
                this.ticks = {};
                this.labelEdge = [];
                this.minorTicks = {};
                this.plotLinesAndBands = [];
                this.alternateBands = {};
                this.len = 0;
                this.minRange = this.userMinRange = a.minRange || a.maxZoom;
                this.range = a.range;
                this.offset = a.offset || 0;
                this.min = this.max = null;
                f = D(a.crosshair, T(c.options.tooltip.crosshairs)[d ? 0 : 1]);
                this.crosshair = !0 === f ? {} : f;
                -1 === c.axes.indexOf(this) && (d ? c.axes.splice(c.xAxis.length, 0, this) : c.axes.push(this), q(this, c[this.coll]));
                c.orderItems(this.coll);
                this.series = this.series || [];
                c.inverted && !this.isZAxis && d && "undefined" === typeof this.reversed && (this.reversed = !0);
                this.labelRotation = b(A.rotation) ? A.rotation : void 0;
                l(this, a);
                k(this, "afterInit");
            }
            setOptions(b) {
                this.options = c(y.defaultXAxisOptions, "yAxis" === this.coll && y.defaultYAxisOptions, [
                    y.defaultTopAxisOptions,
                    y.defaultRightAxisOptions,
                    y.defaultBottomAxisOptions,
                    y.defaultLeftAxisOptions
                ][this.side], c(v[this.coll], b));
                k(this, "afterSetOptions", {
                    userOptions: b
                });
            }
            defaultLabelFormatter(c) {
                var f = this.axis;
                ({ numberFormatter: c } = this.chart);
                const a = b(this.value) ? this.value : NaN, d = f.chart.time, k = this.dateTimeLabelFormat;
                var n = v.lang;
                const A = n.numericSymbols;
                n = n.numericSymbolMagnitude || 1E3;
                const e = f.logarithmic ? Math.abs(a) : f.tickInterval;
                let q = A && A.length, g;
                if (f.categories) g = `${this.value}`;
                else if (k) g = d.dateFormat(k, a);
                else if (q && 1E3 <= e) for(; q-- && "undefined" === typeof g;)f = Math.pow(n, q + 1), e >= f && 0 === 10 * a % f && null !== A[q] && 0 !== a && (g = c(a / f, -1) + A[q]);
                "undefined" === typeof g && (g = 1E4 <= Math.abs(a) ? c(a, -1) : c(a, -1, void 0, ""));
                return g;
            }
            getSeriesExtremes() {
                const c = this, f = c.chart;
                let a;
                k(this, "getSeriesExtremes", null, function() {
                    c.hasVisibleSeries = !1;
                    c.dataMin = c.dataMax = c.threshold = null;
                    c.softThreshold = !c.isXAxis;
                    c.series.forEach(function(d) {
                        if (d.visible || !f.options.chart.ignoreHiddenSeries) {
                            var k = d.options;
                            let f = k.threshold, n, A;
                            c.hasVisibleSeries = !0;
                            c.positiveValuesOnly && 0 >= f && (f = null);
                            if (c.isXAxis) (k = d.xData) && k.length && (k = c.logarithmic ? k.filter((b)=>0 < b) : k, a = d.getXExtremes(k), n = a.min, A = a.max, b(n) || n instanceof Date || (k = k.filter(b), a = d.getXExtremes(k), n = a.min, A = a.max), k.length && (c.dataMin = Math.min(D(c.dataMin, n), n), c.dataMax = Math.max(D(c.dataMax, A), A)));
                            else if (d = d.applyExtremes(), b(d.dataMin) && (n = d.dataMin, c.dataMin = Math.min(D(c.dataMin, n), n)), b(d.dataMax) && (A = d.dataMax, c.dataMax = Math.max(D(c.dataMax, A), A)), e(f) && (c.threshold = f), !k.softThreshold || c.positiveValuesOnly) c.softThreshold = !1;
                        }
                    });
                });
                k(this, "afterGetSeriesExtremes");
            }
            translate(c, f, a, d, k, n) {
                const e = this.linkedParent || this, A = d && e.old ? e.old.min : e.min;
                if (!b(A)) return NaN;
                const q = e.minPixelPadding;
                k = (e.isOrdinal || e.brokenAxis && e.brokenAxis.hasBreaks || e.logarithmic && k) && e.lin2val;
                let J = 1, h = 0;
                d = d && e.old ? e.old.transA : e.transA;
                d || (d = e.transA);
                a && (J *= -1, h = e.len);
                e.reversed && (J *= -1, h -= J * (e.sector || e.len));
                f ? (n = (c * J + h - q) / d + A, k && (n = e.lin2val(n))) : (k && (c = e.val2lin(c)), c = J * (c - A) * d, n = (e.isRadial ? c : g(c)) + h + J * q + (b(n) ? d * n : 0));
                return n;
            }
            toPixels(b, c) {
                return this.translate(b, !1, !this.horiz, void 0, !0) + (c ? 0 : this.pos);
            }
            toValue(b, c) {
                return this.translate(b - (c ? 0 : this.pos), !0, !this.horiz, void 0, !0);
            }
            getPlotLinePath(c) {
                function f(b, c, f) {
                    "pass" !== t && (b < c || b > f) && (t ? b = h(b, c, f) : K = !0);
                    return b;
                }
                const a = this, d = a.chart, n = a.left, e = a.top, A = c.old, q = c.value, g = c.lineWidth, r = A && d.oldChartHeight || d.chartHeight, m = A && d.oldChartWidth || d.chartWidth, l = a.transB;
                let p = c.translatedValue, t = c.force, P, w, R, Q, K;
                c = {
                    value: q,
                    lineWidth: g,
                    old: A,
                    force: t,
                    acrossPanes: c.acrossPanes,
                    translatedValue: p
                };
                k(this, "getPlotLinePath", c, function(c) {
                    p = D(p, a.translate(q, void 0, void 0, A));
                    p = h(p, -100000, 1E5);
                    P = R = Math.round(p + l);
                    w = Q = Math.round(r - p - l);
                    b(p) ? a.horiz ? (w = e, Q = r - a.bottom, P = R = f(P, n, n + a.width)) : (P = n, R = m - a.right, w = Q = f(w, e, e + a.height)) : (K = !0, t = !1);
                    c.path = K && !t ? null : d.renderer.crispLine([
                        [
                            "M",
                            P,
                            w
                        ],
                        [
                            "L",
                            R,
                            Q
                        ]
                    ], g || 1);
                });
                return c.path;
            }
            getLinearTickPositions(b, c, f) {
                const a = g(Math.floor(c / b) * b);
                f = g(Math.ceil(f / b) * b);
                const d = [];
                let k, n;
                g(a + b) === a && (n = 20);
                if (this.single) return [
                    c
                ];
                for(c = a; c <= f;){
                    d.push(c);
                    c = g(c + b, n);
                    if (c === k) break;
                    k = c;
                }
                return d;
            }
            getMinorTickInterval() {
                const b = this.options;
                return !0 === b.minorTicks ? D(b.minorTickInterval, "auto") : !1 === b.minorTicks ? null : b.minorTickInterval;
            }
            getMinorTickPositions() {
                var b = this.options;
                const c = this.tickPositions, f = this.minorTickInterval;
                var a = this.pointRangePadding || 0;
                const d = this.min - a;
                a = this.max + a;
                const k = a - d;
                let n = [];
                if (k && k / f < this.len / 3) {
                    const k = this.logarithmic;
                    if (k) this.paddedTicks.forEach(function(b, c, a) {
                        c && n.push.apply(n, k.getLogTickPositions(f, a[c - 1], a[c], !0));
                    });
                    else if (this.dateTime && "auto" === this.getMinorTickInterval()) n = n.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(f), d, a, b.startOfWeek));
                    else for(b = d + (c[0] - d) % f; b <= a && b !== n[0]; b += f)n.push(b);
                }
                0 !== n.length && this.trimTicks(n);
                return n;
            }
            adjustForMinRange() {
                const b = this.options, c = this.logarithmic;
                let f = this.min;
                var a = this.max;
                let d, k;
                if (this.isXAxis && "undefined" === typeof this.minRange && !c) {
                    if (e(b.min) || e(b.max) || e(b.floor) || e(b.ceiling)) this.minRange = null;
                    else {
                        var n = r(this.series.map((b)=>{
                            var c;
                            return (b.xIncrement ? null === (c = b.xData) || void 0 === c ? void 0 : c.slice(0, 2) : b.xData) || [];
                        })) || 0;
                        this.minRange = Math.min(5 * n, this.dataMax - this.dataMin);
                    }
                }
                a - f < this.minRange && (n = this.dataMax - this.dataMin >= this.minRange, k = this.minRange, a = (k - a + f) / 2, d = [
                    f - a,
                    D(b.min, f - a)
                ], n && (d[2] = c ? c.log2lin(this.dataMin) : this.dataMin), f = t(d), a = [
                    f + k,
                    D(b.max, f + k)
                ], n && (a[2] = c ? c.log2lin(this.dataMax) : this.dataMax), a = m(a), a - f < k && (d[0] = a - k, d[1] = D(b.min, a - k), f = t(d)));
                this.min = f;
                this.max = a;
            }
            getClosest() {
                let b, c;
                if (this.categories) c = 1;
                else {
                    const f = [];
                    this.series.forEach(function(b) {
                        var a;
                        const d = b.closestPointRange, k = b.visible || !b.chart.options.chart.ignoreHiddenSeries;
                        1 === (null === (a = b.xData) || void 0 === a ? void 0 : a.length) ? f.push(b.xData[0]) : !b.noSharedTooltip && e(d) && k && (c = e(c) ? Math.min(c, d) : d);
                    });
                    f.length && (f.sort((b, c)=>b - c), b = r([
                        f
                    ]));
                }
                return b && c ? Math.min(b, c) : b || c;
            }
            nameToX(b) {
                const c = G(this.options.categories), f = c ? this.categories : this.names;
                let a = b.options.x, d;
                b.series.requireSorting = !1;
                e(a) || (a = this.options.uniqueNames && f ? c ? f.indexOf(b.name) : D(f.keys[b.name], -1) : b.series.autoIncrement());
                -1 === a ? !c && f && (d = f.length) : d = a;
                "undefined" !== typeof d ? (this.names[d] = b.name, this.names.keys[b.name] = d) : b.x && (d = b.x);
                return d;
            }
            updateNames() {
                const b = this, c = this.names;
                0 < c.length && (Object.keys(c.keys).forEach(function(b) {
                    delete c.keys[b];
                }), c.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach(function(c) {
                    c.xIncrement = null;
                    if (!c.points || c.isDirtyData) b.max = Math.max(b.max, c.xData.length - 1), c.processData(), c.generatePoints();
                    c.data.forEach(function(f, a) {
                        let d;
                        f && f.options && "undefined" !== typeof f.name && (d = b.nameToX(f), "undefined" !== typeof d && d !== f.x && (f.x = d, c.xData[a] = d));
                    });
                }));
            }
            setAxisTranslation() {
                const b = this, c = b.max - b.min;
                var a = b.linkedParent;
                const d = !!b.categories, n = b.isXAxis;
                let e = b.axisPointRange || 0, q, g = 0, h = 0, r = b.transA;
                if (n || d || e) q = b.getClosest(), a ? (g = a.minPointOffset, h = a.pointRangePadding) : b.series.forEach(function(c) {
                    const a = d ? 1 : n ? D(c.options.pointRange, q, 0) : b.axisPointRange || 0, k = c.options.pointPlacement;
                    e = Math.max(e, a);
                    if (!b.single || d) c = c.is("xrange") ? !n : n, g = Math.max(g, c && f(k) ? 0 : a / 2), h = Math.max(h, c && "on" === k ? 0 : a);
                }), a = b.ordinal && b.ordinal.slope && q ? b.ordinal.slope / q : 1, b.minPointOffset = g *= a, b.pointRangePadding = h *= a, b.pointRange = Math.min(e, b.single && d ? 1 : c), n && q && (b.closestPointRange = q);
                b.translationSlope = b.transA = r = b.staticScale || b.len / (c + h || 1);
                b.transB = b.horiz ? b.left : b.bottom;
                b.minPixelPadding = r * g;
                k(this, "afterSetAxisTranslation");
            }
            minFromRange() {
                return this.max - this.range;
            }
            setTickInterval(c) {
                var f = this.chart;
                const a = this.logarithmic, d = this.options, n = this.isXAxis, q = this.isLinked, h = d.tickPixelInterval, A = this.categories, r = this.softThreshold;
                let m = d.maxPadding, l = d.minPadding;
                let p = b(d.tickInterval) && 0 <= d.tickInterval ? d.tickInterval : void 0, t = b(this.threshold) ? this.threshold : null, P, w, K;
                this.dateTime || A || q || this.getTickAmount();
                w = D(this.userMin, d.min);
                K = D(this.userMax, d.max);
                if (q) {
                    this.linkedParent = f[this.coll][d.linkedTo];
                    var R = this.linkedParent.getExtremes();
                    this.min = D(R.min, R.dataMin);
                    this.max = D(R.max, R.dataMax);
                    d.type !== this.linkedParent.options.type && F(11, 1, f);
                } else r && e(t) && (this.dataMin >= t ? (R = t, l = 0) : this.dataMax <= t && (P = t, m = 0)), this.min = D(w, R, this.dataMin), this.max = D(K, P, this.dataMax);
                a && (this.positiveValuesOnly && !c && 0 >= Math.min(this.min, D(this.dataMin, this.min)) && F(10, 1, f), this.min = g(a.log2lin(this.min), 16), this.max = g(a.log2lin(this.max), 16));
                this.range && e(this.max) && (this.userMin = this.min = w = Math.max(this.dataMin, this.minFromRange()), this.userMax = K = this.max, this.range = null);
                k(this, "foundExtremes");
                this.beforePadding && this.beforePadding();
                this.adjustForMinRange();
                !b(this.userMin) && b(d.softMin) && d.softMin < this.min && (this.min = w = d.softMin);
                !b(this.userMax) && b(d.softMax) && d.softMax > this.max && (this.max = K = d.softMax);
                !(A || this.axisPointRange || this.stacking && this.stacking.usePercentage || q) && e(this.min) && e(this.max) && (f = this.max - this.min) && (!e(w) && l && (this.min -= f * l), !e(K) && m && (this.max += f * m));
                !b(this.userMin) && b(d.floor) && (this.min = Math.max(this.min, d.floor));
                !b(this.userMax) && b(d.ceiling) && (this.max = Math.min(this.max, d.ceiling));
                r && e(this.dataMin) && (t = t || 0, !e(w) && this.min < t && this.dataMin >= t ? this.min = this.options.minRange ? Math.min(t, this.max - this.minRange) : t : !e(K) && this.max > t && this.dataMax <= t && (this.max = this.options.minRange ? Math.max(t, this.min + this.minRange) : t));
                b(this.min) && b(this.max) && !this.chart.polar && this.min > this.max && (e(this.options.min) ? this.max = this.min : e(this.options.max) && (this.min = this.max));
                this.tickInterval = this.min === this.max || "undefined" === typeof this.min || "undefined" === typeof this.max ? 1 : q && this.linkedParent && !p && h === this.linkedParent.options.tickPixelInterval ? p = this.linkedParent.tickInterval : D(p, this.tickAmount ? (this.max - this.min) / Math.max(this.tickAmount - 1, 1) : void 0, A ? 1 : (this.max - this.min) * h / Math.max(this.len, h));
                if (n && !c) {
                    const b = this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max);
                    this.series.forEach(function(c) {
                        c.forceCrop = c.forceCropping && c.forceCropping();
                        c.processData(b);
                    });
                    k(this, "postProcessData", {
                        hasExtremesChanged: b
                    });
                }
                this.setAxisTranslation();
                k(this, "initialAxisTranslation");
                this.pointRange && !p && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
                c = D(d.minTickInterval, this.dateTime && !this.series.some((b)=>b.noSharedTooltip) ? this.closestPointRange : 0);
                !p && this.tickInterval < c && (this.tickInterval = c);
                this.dateTime || this.logarithmic || p || (this.tickInterval = V(this, this.tickInterval));
                this.tickAmount || (this.tickInterval = this.unsquish());
                this.setTickPositions();
            }
            setTickPositions() {
                var c = this.options;
                const f = c.tickPositions, a = c.tickPositioner;
                var d = this.getMinorTickInterval(), n = this.hasVerticalPanning(), q = "colorAxis" === this.coll;
                const g = (q || !n) && c.startOnTick;
                n = (q || !n) && c.endOnTick;
                q = [];
                let h;
                this.tickmarkOffset = this.categories && "between" === c.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0;
                this.minorTickInterval = "auto" === d && this.tickInterval ? this.tickInterval / c.minorTicksPerMajor : d;
                this.single = this.min === this.max && e(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || !1 !== c.allowDecimals);
                if (f) q = f.slice();
                else if (b(this.min) && b(this.max)) {
                    if (this.ordinal && this.ordinal.positions || !((this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200))) {
                        if (this.dateTime) q = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, c.units), this.min, this.max, c.startOfWeek, this.ordinal && this.ordinal.positions, this.closestPointRange, !0);
                        else if (this.logarithmic) q = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                        else for(d = c = this.tickInterval; d <= 2 * c;)if (q = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && q.length > this.tickAmount) this.tickInterval = V(this, d *= 1.1);
                        else break;
                    } else q = [
                        this.min,
                        this.max
                    ], F(19, !1, this.chart);
                    q.length > this.len && (q = [
                        q[0],
                        q[q.length - 1]
                    ], q[0] === q[1] && (q.length = 1));
                    a && (this.tickPositions = q, (h = a.apply(this, [
                        this.min,
                        this.max
                    ])) && (q = h));
                }
                this.tickPositions = q;
                this.paddedTicks = q.slice(0);
                this.trimTicks(q, g, n);
                !this.isLinked && b(this.min) && b(this.max) && (this.single && 2 > q.length && !this.categories && !this.series.some((b)=>b.is("heatmap") && "between" === b.options.pointPlacement) && (this.min -= .5, this.max += .5), f || h || this.adjustTickAmount());
                k(this, "afterSetTickPositions");
            }
            trimTicks(b, c, f) {
                const a = b[0], d = b[b.length - 1], n = !this.isOrdinal && this.minPointOffset || 0;
                k(this, "trimTicks");
                if (!this.isLinked) {
                    if (c && -Infinity !== a) this.min = a;
                    else for(; this.min - n > b[0];)b.shift();
                    if (f) this.max = d;
                    else for(; this.max + n < b[b.length - 1];)b.pop();
                    0 === b.length && e(a) && !this.options.tickPositions && b.push((d + a) / 2);
                }
            }
            alignToOthers() {
                const c = this, f = [
                    this
                ], a = c.options, d = "yAxis" === this.coll && this.chart.options.chart.alignThresholds, k = [];
                let n;
                c.thresholdAlignment = void 0;
                if ((!1 !== this.chart.options.chart.alignTicks && a.alignTicks || d) && !1 !== a.startOnTick && !1 !== a.endOnTick && !c.logarithmic) {
                    const b = (b)=>{
                        const { horiz: c, options: f } = b;
                        return [
                            c ? f.left : f.top,
                            f.width,
                            f.height,
                            f.pane
                        ].join();
                    }, a = b(this);
                    this.chart[this.coll].forEach(function(d) {
                        const { series: k } = d;
                        k.length && k.some((b)=>b.visible) && d !== c && b(d) === a && (n = !0, f.push(d));
                    });
                }
                if (n && d) {
                    f.forEach((f)=>{
                        f = f.getThresholdAlignment(c);
                        b(f) && k.push(f);
                    });
                    const a = 1 < k.length ? k.reduce((b, c)=>b + c, 0) / k.length : void 0;
                    f.forEach((b)=>{
                        b.thresholdAlignment = a;
                    });
                }
                return n;
            }
            getThresholdAlignment(c) {
                (!b(this.dataMin) || this !== c && this.series.some((b)=>b.isDirty || b.isDirtyData)) && this.getSeriesExtremes();
                if (b(this.threshold)) return c = h((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1), this.options.reversed && (c = 1 - c), c;
            }
            getTickAmount() {
                const b = this.options, c = b.tickPixelInterval;
                let f = b.tickAmount;
                !e(b.tickInterval) && !f && this.len < c && !this.isRadial && !this.logarithmic && b.startOnTick && b.endOnTick && (f = 2);
                !f && this.alignToOthers() && (f = Math.ceil(this.len / c) + 1);
                4 > f && (this.finalTickAmt = f, f = 5);
                this.tickAmount = f;
            }
            adjustTickAmount() {
                const c = this, { finalTickAmt: f, max: a, min: d, options: k, tickPositions: n, tickAmount: q, thresholdAlignment: h } = c, r = n && n.length;
                var m = D(c.threshold, c.softThreshold ? 0 : null);
                var l = c.tickInterval;
                let p;
                b(h) && (p = .5 > h ? Math.ceil(h * (q - 1)) : Math.floor(h * (q - 1)), k.reversed && (p = q - 1 - p));
                if (c.hasData() && b(d) && b(a)) {
                    const h = ()=>{
                        c.transA *= (r - 1) / (q - 1);
                        c.min = k.startOnTick ? n[0] : Math.min(d, n[0]);
                        c.max = k.endOnTick ? n[n.length - 1] : Math.max(a, n[n.length - 1]);
                    };
                    if (b(p) && b(c.threshold)) {
                        for(; n[p] !== m || n.length !== q || n[0] > d || n[n.length - 1] < a;){
                            n.length = 0;
                            for(n.push(c.threshold); n.length < q;)void 0 === n[p] || n[p] > c.threshold ? n.unshift(g(n[0] - l)) : n.push(g(n[n.length - 1] + l));
                            if (l > 8 * c.tickInterval) break;
                            l *= 2;
                        }
                        h();
                    } else if (r < q) {
                        for(; n.length < q;)n.length % 2 || d === m ? n.push(g(n[n.length - 1] + l)) : n.unshift(g(n[0] - l));
                        h();
                    }
                    if (e(f)) {
                        for(l = m = n.length; l--;)(3 === f && 1 === l % 2 || 2 >= f && 0 < l && l < m - 1) && n.splice(l, 1);
                        c.finalTickAmt = void 0;
                    }
                }
            }
            setScale() {
                let b = !1, c = !1;
                this.series.forEach(function(f) {
                    b = b || f.isDirtyData || f.isDirty;
                    c = c || f.xAxis && f.xAxis.isDirty || !1;
                });
                this.setAxisSize();
                const f = this.len !== (this.old && this.old.len);
                f || b || c || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (this.stacking && (this.stacking.resetStacks(), this.stacking.buildStacks()), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), this.isDirty || (this.isDirty = f || this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max))) : this.stacking && this.stacking.cleanStacks();
                b && this.panningState && (this.panningState.isDirty = !0);
                k(this, "afterSetScale");
            }
            setExtremes(b, c, f, a, n) {
                const e = this, q = e.chart;
                f = D(f, !0);
                e.series.forEach(function(b) {
                    delete b.kdTree;
                });
                n = d(n, {
                    min: b,
                    max: c
                });
                k(e, "setExtremes", n, function() {
                    e.userMin = b;
                    e.userMax = c;
                    e.eventArgs = n;
                    f && q.redraw(a);
                });
            }
            zoom(b, c) {
                const f = this, a = this.dataMin, d = this.dataMax, n = this.options, q = Math.min(a, D(n.min, a)), g = Math.max(d, D(n.max, d));
                b = {
                    newMin: b,
                    newMax: c
                };
                k(this, "zoom", b, function(b) {
                    let c = b.newMin, n = b.newMax;
                    if (c !== f.min || n !== f.max) f.allowZoomOutside || (e(a) && (c < q && (c = q), c > g && (c = g)), e(d) && (n < q && (n = q), n > g && (n = g))), f.displayBtn = "undefined" !== typeof c || "undefined" !== typeof n, f.setExtremes(c, n, !1, void 0, {
                        trigger: "zoom"
                    });
                    b.zoomed = !0;
                });
                return b.zoomed;
            }
            setAxisSize() {
                const b = this.chart;
                var c = this.options;
                const f = c.offsets || [
                    0,
                    0,
                    0,
                    0
                ], a = this.horiz, d = this.width = Math.round(K(D(c.width, b.plotWidth - f[3] + f[1]), b.plotWidth)), n = this.height = Math.round(K(D(c.height, b.plotHeight - f[0] + f[2]), b.plotHeight)), k = this.top = Math.round(K(D(c.top, b.plotTop + f[0]), b.plotHeight, b.plotTop));
                c = this.left = Math.round(K(D(c.left, b.plotLeft + f[3]), b.plotWidth, b.plotLeft));
                this.bottom = b.chartHeight - n - k;
                this.right = b.chartWidth - d - c;
                this.len = Math.max(a ? d : n, 0);
                this.pos = a ? c : k;
            }
            getExtremes() {
                const b = this.logarithmic;
                return {
                    min: b ? g(b.lin2log(this.min)) : this.min,
                    max: b ? g(b.lin2log(this.max)) : this.max,
                    dataMin: this.dataMin,
                    dataMax: this.dataMax,
                    userMin: this.userMin,
                    userMax: this.userMax
                };
            }
            getThreshold(b) {
                var c = this.logarithmic;
                const f = c ? c.lin2log(this.min) : this.min;
                c = c ? c.lin2log(this.max) : this.max;
                null === b || -Infinity === b ? b = f : Infinity === b ? b = c : f > b ? b = f : c < b && (b = c);
                return this.translate(b, 0, 1, 0, 1);
            }
            autoLabelAlign(b) {
                const c = (D(b, 0) - 90 * this.side + 720) % 360;
                b = {
                    align: "center"
                };
                k(this, "autoLabelAlign", b, function(b) {
                    15 < c && 165 > c ? b.align = "right" : 195 < c && 345 > c && (b.align = "left");
                });
                return b.align;
            }
            tickSize(b) {
                const c = this.options, f = D(c["tick" === b ? "tickWidth" : "minorTickWidth"], "tick" === b && this.isXAxis && !this.categories ? 1 : 0);
                let a = c["tick" === b ? "tickLength" : "minorTickLength"], d;
                f && a && ("inside" === c[b + "Position"] && (a = -a), d = [
                    a,
                    f
                ]);
                b = {
                    tickSize: d
                };
                k(this, "afterTickSize", b);
                return b.tickSize;
            }
            labelMetrics() {
                const b = this.chart.renderer;
                var c = this.ticks;
                c = c[Object.keys(c)[0]] || {};
                return this.chart.renderer.fontMetrics(c.label || c.movedLabel || b.box);
            }
            unsquish() {
                const c = this.options.labels;
                var f = this.horiz;
                const a = this.tickInterval, d = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / a), n = c.rotation, k = .75 * this.labelMetrics().h, e = Math.max(this.max - this.min, 0), q = function(b) {
                    let c = b / (d || 1);
                    c = 1 < c ? Math.ceil(c) : 1;
                    c * a > e && Infinity !== b && Infinity !== d && e && (c = Math.ceil(e / a));
                    return g(c * a);
                };
                let h = a, r, l = Number.MAX_VALUE, m;
                if (f) {
                    if (c.staggerLines || (b(n) ? m = [
                        n
                    ] : d < c.autoRotationLimit && (m = c.autoRotation)), m) {
                        let b;
                        for (const c of m)if (c === n || c && -90 <= c && 90 >= c) f = q(Math.abs(k / Math.sin(p * c))), b = f + Math.abs(c / 360), b < l && (l = b, r = c, h = f);
                    }
                } else h = q(k);
                this.autoRotation = m;
                this.labelRotation = D(r, b(n) ? n : 0);
                return c.step ? a : h;
            }
            getSlotWidth(c) {
                const f = this.chart, a = this.horiz, d = this.options.labels, n = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), k = f.margin[3];
                if (c && b(c.slotWidth)) return c.slotWidth;
                if (a && 2 > d.step) return d.rotation ? 0 : (this.staggerLines || 1) * this.len / n;
                if (!a) {
                    c = d.style.width;
                    if (void 0 !== c) return parseInt(String(c), 10);
                    if (k) return k - f.spacing[3];
                }
                return .33 * f.chartWidth;
            }
            renderUnsquish() {
                const b = this.chart, c = b.renderer, a = this.tickPositions, d = this.ticks, n = this.options.labels, k = n.style, e = this.horiz, q = this.getSlotWidth();
                var g = Math.max(1, Math.round(q - 2 * n.padding));
                const h = {}, r = this.labelMetrics(), m = k.textOverflow;
                let l, p, D = 0;
                f(n.rotation) || (h.rotation = n.rotation || 0);
                a.forEach(function(b) {
                    b = d[b];
                    b.movedLabel && b.replaceMovedLabel();
                    b && b.label && b.label.textPxLength > D && (D = b.label.textPxLength);
                });
                this.maxLabelLength = D;
                if (this.autoRotation) D > g && D > r.h ? h.rotation = this.labelRotation : this.labelRotation = 0;
                else if (q && (l = g, !m)) for(p = "clip", g = a.length; !e && g--;){
                    var t = a[g];
                    if (t = d[t].label) t.styles && "ellipsis" === t.styles.textOverflow ? t.css({
                        textOverflow: "clip"
                    }) : t.textPxLength > q && t.css({
                        width: q + "px"
                    }), t.getBBox().height > this.len / a.length - (r.h - r.f) && (t.specificTextOverflow = "ellipsis");
                }
                h.rotation && (l = D > .5 * b.chartHeight ? .33 * b.chartHeight : D, m || (p = "ellipsis"));
                if (this.labelAlign = n.align || this.autoLabelAlign(this.labelRotation)) h.align = this.labelAlign;
                a.forEach(function(b) {
                    const c = (b = d[b]) && b.label, f = k.width, a = {};
                    c && (c.attr(h), b.shortenLabel ? b.shortenLabel() : l && !f && "nowrap" !== k.whiteSpace && (l < c.textPxLength || "SPAN" === c.element.tagName) ? (a.width = l + "px", m || (a.textOverflow = c.specificTextOverflow || p), c.css(a)) : c.styles && c.styles.width && !a.width && !f && c.css({
                        width: null
                    }), delete c.specificTextOverflow, b.rotation = h.rotation);
                }, this);
                this.tickRotCorr = c.rotCorr(r.b, this.labelRotation || 0, 0 !== this.side);
            }
            hasData() {
                return this.series.some(function(b) {
                    return b.hasData();
                }) || this.options.showEmpty && e(this.min) && e(this.max);
            }
            addTitle(b) {
                const f = this.chart.renderer, a = this.horiz, d = this.opposite, n = this.options.title, k = this.chart.styledMode;
                let e;
                this.axisTitle || ((e = n.textAlign) || (e = (a ? {
                    low: "left",
                    middle: "center",
                    high: "right"
                } : {
                    low: d ? "right" : "left",
                    middle: "center",
                    high: d ? "left" : "right"
                })[n.align]), this.axisTitle = f.text(n.text || "", 0, 0, n.useHTML).attr({
                    zIndex: 7,
                    rotation: n.rotation,
                    align: e
                }).addClass("highcharts-axis-title"), k || this.axisTitle.css(c(n.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0);
                k || n.style.width || this.isRadial || this.axisTitle.css({
                    width: this.len + "px"
                });
                this.axisTitle[b ? "show" : "hide"](b);
            }
            generateTick(b) {
                const c = this.ticks;
                c[b] ? c[b].addLabel() : c[b] = new H(this, b);
            }
            getOffset() {
                const c = this, { chart: f, horiz: a, options: d, side: n, ticks: q, tickPositions: g, coll: h, axisParent: r } = c, m = f.renderer, l = f.inverted && !c.isZAxis ? [
                    1,
                    0,
                    3,
                    2
                ][n] : n;
                var p = c.hasData();
                const t = d.title;
                var w = d.labels;
                const K = b(d.crossing);
                var G = f.axisOffset;
                const R = f.clipOffset, Q = [
                    -1,
                    1,
                    1,
                    -1
                ][n], v = d.className;
                let ja, u = 0, x;
                var E = 0;
                let F = 0;
                c.showAxis = ja = p || d.showEmpty;
                c.staggerLines = c.horiz && w.staggerLines || void 0;
                if (!c.axisGroup) {
                    const b = (b, c, f)=>m.g(b).attr({
                            zIndex: f
                        }).addClass(`highcharts-${h.toLowerCase()}${c} ` + (this.isRadial ? `highcharts-radial-axis${c} ` : "") + (v || "")).add(r);
                    c.gridGroup = b("grid", "-grid", d.gridZIndex);
                    c.axisGroup = b("axis", "", d.zIndex);
                    c.labelGroup = b("axis-labels", "-labels", w.zIndex);
                }
                p || c.isLinked ? (g.forEach(function(b) {
                    c.generateTick(b);
                }), c.renderUnsquish(), c.reserveSpaceDefault = 0 === n || 2 === n || ({
                    1: "left",
                    3: "right"
                })[n] === c.labelAlign, D(w.reserveSpace, K ? !1 : null, "center" === c.labelAlign ? !0 : null, c.reserveSpaceDefault) && g.forEach(function(b) {
                    F = Math.max(q[b].getLabelSize(), F);
                }), c.staggerLines && (F *= c.staggerLines), c.labelOffset = F * (c.opposite ? -1 : 1)) : P(q, function(b, c) {
                    b.destroy();
                    delete q[c];
                });
                t && t.text && !1 !== t.enabled && (c.addTitle(ja), ja && !K && !1 !== t.reserveSpace && (c.titleOffset = u = c.axisTitle.getBBox()[a ? "height" : "width"], x = t.offset, E = e(x) ? 0 : D(t.margin, a ? 5 : 10)));
                c.renderLine();
                c.offset = Q * D(d.offset, G[n] ? G[n] + (d.margin || 0) : 0);
                c.tickRotCorr = c.tickRotCorr || {
                    x: 0,
                    y: 0
                };
                p = 0 === n ? -c.labelMetrics().h : 2 === n ? c.tickRotCorr.y : 0;
                E = Math.abs(F) + E;
                F && (E = E - p + Q * (a ? D(w.y, c.tickRotCorr.y + Q * w.distance) : D(w.x, Q * w.distance)));
                c.axisTitleMargin = D(x, E);
                c.getMaxLabelDimensions && (c.maxLabelDimensions = c.getMaxLabelDimensions(q, g));
                "colorAxis" !== h && (w = this.tickSize("tick"), G[n] = Math.max(G[n], (c.axisTitleMargin || 0) + u + Q * c.offset, E, g && g.length && w ? w[0] + Q * c.offset : 0), G = !c.axisLine || d.offset ? 0 : 2 * Math.floor(c.axisLine.strokeWidth() / 2), R[l] = Math.max(R[l], G));
                k(this, "afterGetOffset");
            }
            getLinePath(b) {
                const c = this.chart, f = this.opposite;
                var a = this.offset;
                const d = this.horiz, n = this.left + (f ? this.width : 0) + a;
                a = c.chartHeight - this.bottom - (f ? this.height : 0) + a;
                f && (b *= -1);
                return c.renderer.crispLine([
                    [
                        "M",
                        d ? this.left : n,
                        d ? a : this.top
                    ],
                    [
                        "L",
                        d ? c.chartWidth - this.right : n,
                        d ? a : c.chartHeight - this.bottom
                    ]
                ], b);
            }
            renderLine() {
                this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
                    stroke: this.options.lineColor,
                    "stroke-width": this.options.lineWidth,
                    zIndex: 7
                }));
            }
            getTitlePosition(b) {
                var c = this.horiz, f = this.left;
                const a = this.top;
                var d = this.len;
                const n = this.options.title, e = c ? f : a, q = this.opposite, g = this.offset, h = n.x, r = n.y, l = this.chart.renderer.fontMetrics(b);
                b = b ? Math.max(b.getBBox(!1, 0).height - l.h - 1, 0) : 0;
                d = ({
                    low: e + (c ? 0 : d),
                    middle: e + d / 2,
                    high: e + (c ? d : 0)
                })[n.align];
                f = (c ? a + this.height : f) + (c ? 1 : -1) * (q ? -1 : 1) * (this.axisTitleMargin || 0) + [
                    -b,
                    b,
                    l.f,
                    -b
                ][this.side];
                c = {
                    x: c ? d + h : f + (q ? this.width : 0) + g + h,
                    y: c ? f + r - (q ? this.height : 0) + g : d + r
                };
                k(this, "afterGetTitlePosition", {
                    titlePosition: c
                });
                return c;
            }
            renderMinorTick(b, c) {
                const f = this.minorTicks;
                f[b] || (f[b] = new H(this, b, "minor"));
                c && f[b].isNew && f[b].render(null, !0);
                f[b].render(null, !1, 1);
            }
            renderTick(b, c, f) {
                const a = this.ticks;
                if (!this.isLinked || b >= this.min && b <= this.max || this.grid && this.grid.isColumn) a[b] || (a[b] = new H(this, b)), f && a[b].isNew && a[b].render(c, !0, -1), a[b].render(c);
            }
            render() {
                const c = this, f = c.chart, a = c.logarithmic, d = c.options, n = c.isLinked, e = c.tickPositions, q = c.axisTitle, g = c.ticks, h = c.minorTicks, r = c.alternateBands, l = d.stackLabels, m = d.alternateGridColor;
                var p = d.crossing;
                const D = c.tickmarkOffset, t = c.axisLine, w = c.showAxis, K = u(f.renderer.globalAnimation);
                let Q, G;
                c.labelEdge.length = 0;
                c.overlap = !1;
                [
                    g,
                    h,
                    r
                ].forEach(function(b) {
                    P(b, function(b) {
                        b.isActive = !1;
                    });
                });
                if (b(p)) {
                    const b = this.isXAxis ? f.yAxis[0] : f.xAxis[0], a = [
                        1,
                        -1,
                        -1,
                        1
                    ][this.side];
                    b && (p = b.toPixels(p, !0), c.horiz && (p = b.len - p), c.offset = a * p);
                }
                if (c.hasData() || n) {
                    const n = c.chart.hasRendered && c.old && b(c.old.min);
                    c.minorTickInterval && !c.categories && c.getMinorTickPositions().forEach(function(b) {
                        c.renderMinorTick(b, n);
                    });
                    e.length && (e.forEach(function(b, f) {
                        c.renderTick(b, f, n);
                    }), D && (0 === c.min || c.single) && (g[-1] || (g[-1] = new H(c, -1, null, !0)), g[-1].render(-1)));
                    m && e.forEach(function(b, d) {
                        G = "undefined" !== typeof e[d + 1] ? e[d + 1] + D : c.max - D;
                        0 === d % 2 && b < c.max && G <= c.max + (f.polar ? -D : D) && (r[b] || (r[b] = new z.PlotLineOrBand(c)), Q = b + D, r[b].options = {
                            from: a ? a.lin2log(Q) : Q,
                            to: a ? a.lin2log(G) : G,
                            color: m,
                            className: "highcharts-alternate-grid"
                        }, r[b].render(), r[b].isActive = !0);
                    });
                    c._addedPlotLB || (c._addedPlotLB = !0, (d.plotLines || []).concat(d.plotBands || []).forEach(function(b) {
                        c.addPlotBandOrLine(b);
                    }));
                }
                [
                    g,
                    h,
                    r
                ].forEach(function(b) {
                    const c = [], a = K.duration;
                    P(b, function(b, f) {
                        b.isActive || (b.render(f, !1, 0), b.isActive = !1, c.push(f));
                    });
                    Z(function() {
                        let f = c.length;
                        for(; f--;)b[c[f]] && !b[c[f]].isActive && (b[c[f]].destroy(), delete b[c[f]]);
                    }, b !== r && f.hasRendered && a ? a : 0);
                });
                t && (t[t.isPlaced ? "animate" : "attr"]({
                    d: this.getLinePath(t.strokeWidth())
                }), t.isPlaced = !0, t[w ? "show" : "hide"](w));
                q && w && (q[q.isNew ? "attr" : "animate"](c.getTitlePosition(q)), q.isNew = !1);
                l && l.enabled && c.stacking && c.stacking.renderStackTotals();
                c.old = {
                    len: c.len,
                    max: c.max,
                    min: c.min,
                    transA: c.transA,
                    userMax: c.userMax,
                    userMin: c.userMin
                };
                c.isDirty = !1;
                k(this, "afterRender");
            }
            redraw() {
                this.visible && (this.render(), this.plotLinesAndBands.forEach(function(b) {
                    b.render();
                }));
                this.series.forEach(function(b) {
                    b.isDirty = !0;
                });
            }
            getKeepProps() {
                return this.keepProps || Y.keepProps;
            }
            destroy(b) {
                const c = this, f = c.plotLinesAndBands, a = this.eventOptions;
                k(this, "destroy", {
                    keepEvents: b
                });
                b || X(c);
                [
                    c.ticks,
                    c.minorTicks,
                    c.alternateBands
                ].forEach(function(b) {
                    w(b);
                });
                if (f) for(b = f.length; b--;)f[b].destroy();
                "axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(b) {
                    c[b] && (c[b] = c[b].destroy());
                });
                for(const b in c.plotLinesAndBandsGroups)c.plotLinesAndBandsGroups[b] = c.plotLinesAndBandsGroups[b].destroy();
                P(c, function(b, f) {
                    -1 === c.getKeepProps().indexOf(f) && delete c[f];
                });
                this.eventOptions = a;
            }
            drawCrosshair(b, c) {
                const f = this.crosshair;
                var a = D(f && f.snap, !0);
                const n = this.chart;
                let q, g = this.cross;
                k(this, "drawCrosshair", {
                    e: b,
                    point: c
                });
                b || (b = this.cross && this.cross.e);
                if (f && !1 !== (e(c) || !a)) {
                    a ? e(c) && (q = D("colorAxis" !== this.coll ? c.crosshairPos : null, this.isXAxis ? c.plotX : this.len - c.plotY)) : q = b && (this.horiz ? b.chartX - this.pos : this.len - b.chartY + this.pos);
                    if (e(q)) {
                        var h = {
                            value: c && (this.isXAxis ? c.x : D(c.stackY, c.y)),
                            translatedValue: q
                        };
                        n.polar && d(h, {
                            isCrosshair: !0,
                            chartX: b && b.chartX,
                            chartY: b && b.chartY,
                            point: c
                        });
                        h = this.getPlotLinePath(h) || null;
                    }
                    if (!e(h)) {
                        this.hideCrosshair();
                        return;
                    }
                    a = this.categories && !this.isRadial;
                    g || (this.cross = g = n.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (a ? "category " : "thin ") + (f.className || "")).attr({
                        zIndex: D(f.zIndex, 2)
                    }).add(), n.styledMode || (g.attr({
                        stroke: f.color || (a ? I.parse("#ccd3ff").setOpacity(.25).get() : "#cccccc"),
                        "stroke-width": D(f.width, 1)
                    }).css({
                        "pointer-events": "none"
                    }), f.dashStyle && g.attr({
                        dashstyle: f.dashStyle
                    })));
                    g.show().attr({
                        d: h
                    });
                    a && !f.width && g.attr({
                        "stroke-width": this.transA
                    });
                    this.cross.e = b;
                } else this.hideCrosshair();
                k(this, "afterDrawCrosshair", {
                    e: b,
                    point: c
                });
            }
            hideCrosshair() {
                this.cross && this.cross.hide();
                k(this, "afterHideCrosshair");
            }
            hasVerticalPanning() {
                const b = this.chart.options.chart.panning;
                return !!(b && b.enabled && /y/.test(b.type));
            }
            update(b, f) {
                const a = this.chart;
                b = c(this.userOptions, b);
                this.destroy(!0);
                this.init(a, b);
                a.isDirtyBox = !0;
                D(f, !0) && a.redraw();
            }
            remove(b) {
                const c = this.chart, f = this.coll, a = this.series;
                let d = a.length;
                for(; d--;)a[d] && a[d].remove(!1);
                x(c.axes, this);
                x(c[f] || [], this);
                c.orderItems(f);
                this.destroy();
                c.isDirtyBox = !0;
                D(b, !0) && c.redraw();
            }
            setTitle(b, c) {
                this.update({
                    title: b
                }, c);
            }
            setCategories(b, c) {
                this.update({
                    categories: b
                }, c);
            }
        }
        Y.defaultOptions = y.defaultXAxisOptions;
        Y.keepProps = "coll extKey hcEvents names series userMax userMin".split(" ");
        "";
        return Y;
    });
    M(a, "Core/Axis/DateTimeAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { addEvent: x, getMagnitude: I, normalizeTickInterval: L, timeUnits: C } = a;
        var z;
        (function(y) {
            function B() {
                return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function u(a) {
                "datetime" !== a.userOptions.type ? this.dateTime = void 0 : this.dateTime || (this.dateTime = new l(this));
            }
            const v = [];
            y.compose = function(l) {
                a.pushUnique(v, l) && (l.keepProps.push("dateTime"), l.prototype.getTimeTicks = B, x(l, "init", u));
                return l;
            };
            class l {
                constructor(a){
                    this.axis = a;
                }
                normalizeTimeTickInterval(a, l) {
                    const m = l || [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                2,
                                3,
                                4,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ];
                    l = m[m.length - 1];
                    let h = C[l[0]], g = l[1], e;
                    for(e = 0; e < m.length && !(l = m[e], h = C[l[0]], g = l[1], m[e + 1] && a <= (h * g[g.length - 1] + C[m[e + 1][0]]) / 2); e++);
                    h === C.year && a < 5 * h && (g = [
                        1,
                        2,
                        5
                    ]);
                    a = L(a / h, g, "year" === l[0] ? Math.max(I(a / h), 1) : 1);
                    return {
                        unitRange: h,
                        count: a,
                        unitName: l[0]
                    };
                }
                getXDateFormat(a, l) {
                    const { axis: m } = this, h = m.chart.time;
                    return m.closestPointRange ? h.getDateFormat(m.closestPointRange, a, m.options.startOfWeek, l) || h.resolveDTLFormat(l.year).main : h.resolveDTLFormat(l.day).main;
                }
            }
            y.Additions = l;
        })(z || (z = {}));
        return z;
    });
    M(a, "Core/Axis/LogarithmicAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { addEvent: x, normalizeTickInterval: I, pick: L } = a;
        var C;
        (function(y) {
            function H(a) {
                let l = this.logarithmic;
                "logarithmic" !== a.userOptions.type ? this.logarithmic = void 0 : l || (this.logarithmic = new v(this));
            }
            function B() {
                const a = this.logarithmic;
                a && (this.lin2val = function(l) {
                    return a.lin2log(l);
                }, this.val2lin = function(l) {
                    return a.log2lin(l);
                });
            }
            const u = [];
            y.compose = function(l) {
                a.pushUnique(u, l) && (l.keepProps.push("logarithmic"), x(l, "init", H), x(l, "afterInit", B));
                return l;
            };
            class v {
                constructor(a){
                    this.axis = a;
                }
                getLogTickPositions(a, p, t, m) {
                    const h = this.axis;
                    var g = h.len, e = h.options;
                    let l = [];
                    m || (this.minorAutoInterval = void 0);
                    if (.5 <= a) a = Math.round(a), l = h.getLinearTickPositions(a, p, t);
                    else if (.08 <= a) {
                        e = Math.floor(p);
                        let h, w, d, k, r;
                        for(g = .3 < a ? [
                            1,
                            2,
                            4
                        ] : .15 < a ? [
                            1,
                            2,
                            4,
                            6,
                            8
                        ] : [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ]; e < t + 1 && !r; e++)for(w = g.length, h = 0; h < w && !r; h++)d = this.log2lin(this.lin2log(e) * g[h]), d > p && (!m || k <= t) && "undefined" !== typeof k && l.push(k), k > t && (r = !0), k = d;
                    } else p = this.lin2log(p), t = this.lin2log(t), a = m ? h.getMinorTickInterval() : e.tickInterval, a = L("auto" === a ? null : a, this.minorAutoInterval, e.tickPixelInterval / (m ? 5 : 1) * (t - p) / ((m ? g / h.tickPositions.length : g) || 1)), a = I(a), l = h.getLinearTickPositions(a, p, t).map(this.log2lin), m || (this.minorAutoInterval = a / 5);
                    m || (h.tickInterval = a);
                    return l;
                }
                lin2log(a) {
                    return Math.pow(10, a);
                }
                log2lin(a) {
                    return Math.log(a) / Math.LN10;
                }
            }
            y.Additions = v;
        })(C || (C = {}));
        return C;
    });
    M(a, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { erase: x, extend: I, isNumber: L } = a;
        var C;
        (function(y) {
            function H(a) {
                return this.addPlotBandOrLine(a, "plotBands");
            }
            function B(a, e) {
                const g = this.userOptions;
                let l = new h(this, a);
                this.visible && (l = l.render());
                if (l) {
                    this._addedPlotLB || (this._addedPlotLB = !0, (g.plotLines || []).concat(g.plotBands || []).forEach((a)=>{
                        this.addPlotBandOrLine(a);
                    }));
                    if (e) {
                        const h = g[e] || [];
                        h.push(a);
                        g[e] = h;
                    }
                    this.plotLinesAndBands.push(l);
                }
                return l;
            }
            function u(a) {
                return this.addPlotBandOrLine(a, "plotLines");
            }
            function v(a, e, h = this.options) {
                const g = this.getPlotLinePath({
                    value: e,
                    force: !0,
                    acrossPanes: h.acrossPanes
                }), l = [], d = this.horiz;
                e = !L(this.min) || !L(this.max) || a < this.min && e < this.min || a > this.max && e > this.max;
                a = this.getPlotLinePath({
                    value: a,
                    force: !0,
                    acrossPanes: h.acrossPanes
                });
                h = 1;
                let k;
                if (a && g) for(e && (k = a.toString() === g.toString(), h = 0), e = 0; e < a.length; e += 2){
                    const r = a[e], q = a[e + 1], m = g[e], b = g[e + 1];
                    "M" !== r[0] && "L" !== r[0] || "M" !== q[0] && "L" !== q[0] || "M" !== m[0] && "L" !== m[0] || "M" !== b[0] && "L" !== b[0] || (d && m[1] === r[1] ? (m[1] += h, b[1] += h) : d || m[2] !== r[2] || (m[2] += h, b[2] += h), l.push([
                        "M",
                        r[1],
                        r[2]
                    ], [
                        "L",
                        q[1],
                        q[2]
                    ], [
                        "L",
                        b[1],
                        b[2]
                    ], [
                        "L",
                        m[1],
                        m[2]
                    ], [
                        "Z"
                    ]));
                    l.isFlat = k;
                }
                return l;
            }
            function l(a) {
                this.removePlotBandOrLine(a);
            }
            function p(a) {
                const e = this.plotLinesAndBands, g = this.options, h = this.userOptions;
                if (e) {
                    let l = e.length;
                    for(; l--;)e[l].id === a && e[l].destroy();
                    [
                        g.plotLines || [],
                        h.plotLines || [],
                        g.plotBands || [],
                        h.plotBands || []
                    ].forEach(function(d) {
                        for(l = d.length; l--;)(d[l] || {}).id === a && x(d, d[l]);
                    });
                }
            }
            function t(a) {
                this.removePlotBandOrLine(a);
            }
            const m = [];
            let h;
            y.compose = function(g, e) {
                h || (h = g);
                a.pushUnique(m, e) && I(e.prototype, {
                    addPlotBand: H,
                    addPlotLine: u,
                    addPlotBandOrLine: B,
                    getPlotBandPath: v,
                    removePlotBand: l,
                    removePlotLine: t,
                    removePlotBandOrLine: p
                });
                return e;
            };
        })(C || (C = {}));
        return C;
    });
    M(a, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [
        a["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        const { arrayMax: x, arrayMin: L, defined: C, destroyObjectProperties: z, erase: H, fireEvent: B, merge: u, objectEach: v, pick: l } = y;
        class p {
            static compose(l) {
                return a.compose(p, l);
            }
            constructor(a, l){
                this.axis = a;
                l && (this.options = l, this.id = l.id);
            }
            render() {
                B(this, "render");
                const a = this, m = a.axis, h = m.horiz;
                var g = m.logarithmic;
                const e = a.options, p = e.color, x = l(e.zIndex, 0), F = e.events, d = {}, k = m.chart.renderer;
                let r = e.label, q = a.label, G = e.to, b = e.from, f = e.value, c = a.svgElem;
                var n = [];
                const P = C(b) && C(G);
                n = C(f);
                const D = !c, K = {
                    "class": "highcharts-plot-" + (P ? "band " : "line ") + (e.className || "")
                };
                let X = P ? "bands" : "lines";
                g && (b = g.log2lin(b), G = g.log2lin(G), f = g.log2lin(f));
                m.chart.styledMode || (n ? (K.stroke = p || "#999999", K["stroke-width"] = l(e.width, 1), e.dashStyle && (K.dashstyle = e.dashStyle)) : P && (K.fill = p || "#e6e9ff", e.borderWidth && (K.stroke = e.borderColor, K["stroke-width"] = e.borderWidth)));
                d.zIndex = x;
                X += "-" + x;
                (g = m.plotLinesAndBandsGroups[X]) || (m.plotLinesAndBandsGroups[X] = g = k.g("plot-" + X).attr(d).add());
                D && (a.svgElem = c = k.path().attr(K).add(g));
                if (n) n = m.getPlotLinePath({
                    value: f,
                    lineWidth: c.strokeWidth(),
                    acrossPanes: e.acrossPanes
                });
                else if (P) n = m.getPlotBandPath(b, G, e);
                else return;
                !a.eventsAdded && F && (v(F, function(b, f) {
                    c.on(f, function(b) {
                        F[f].apply(a, [
                            b
                        ]);
                    });
                }), a.eventsAdded = !0);
                (D || !c.d) && n && n.length ? c.attr({
                    d: n
                }) : c && (n ? (c.show(), c.animate({
                    d: n
                })) : c.d && (c.hide(), q && (a.label = q = q.destroy())));
                r && (C(r.text) || C(r.formatter)) && n && n.length && 0 < m.width && 0 < m.height && !n.isFlat ? (r = u({
                    align: h && P && "center",
                    x: h ? !P && 4 : 10,
                    verticalAlign: !h && P && "middle",
                    y: h ? P ? 16 : 10 : P ? 6 : -4,
                    rotation: h && !P && 90
                }, r), this.renderLabel(r, n, P, x)) : q && q.hide();
                return a;
            }
            renderLabel(a, l, h, g) {
                const e = this.axis;
                var m = e.chart.renderer;
                let p = this.label;
                p || (this.label = p = m.text(this.getLabelText(a), 0, 0, a.useHTML).attr({
                    align: a.textAlign || a.align,
                    rotation: a.rotation,
                    "class": "highcharts-plot-" + (h ? "band" : "line") + "-label " + (a.className || ""),
                    zIndex: g
                }).add(), e.chart.styledMode || p.css(u({
                    fontSize: "0.8em",
                    textOverflow: "ellipsis"
                }, a.style)));
                g = l.xBounds || [
                    l[0][1],
                    l[1][1],
                    h ? l[2][1] : l[0][1]
                ];
                l = l.yBounds || [
                    l[0][2],
                    l[1][2],
                    h ? l[2][2] : l[0][2]
                ];
                h = L(g);
                m = L(l);
                p.align(a, !1, {
                    x: h,
                    y: m,
                    width: x(g) - h,
                    height: x(l) - m
                });
                p.alignValue && "left" !== p.alignValue || (a = a.clip ? e.width : e.chart.chartWidth, p.css({
                    width: (90 === p.rotation ? e.height - (p.alignAttr.y - e.top) : a - (p.alignAttr.x - e.left)) + "px"
                }));
                p.show(!0);
            }
            getLabelText(a) {
                return C(a.formatter) ? a.formatter.call(this) : a.text;
            }
            destroy() {
                H(this.axis.plotLinesAndBands, this);
                delete this.axis;
                z(this);
            }
        }
        "";
        "";
        return p;
    });
    M(a, "Core/Tooltip.js", [
        a["Core/Templating.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C) {
        const { format: x } = a, { doc: H, isSafari: B } = y, { distribute: u } = I, { addEvent: v, clamp: l, css: p, discardElement: t, extend: m, fireEvent: h, isArray: g, isNumber: e, isString: w, merge: E, pick: F, splat: d, syncTimeout: k } = C;
        class r {
            constructor(a, d){
                this.allowShared = !0;
                this.container = void 0;
                this.crosshairs = [];
                this.distance = 0;
                this.isHidden = !0;
                this.isSticky = !1;
                this.now = {};
                this.options = {};
                this.outside = !1;
                this.chart = a;
                this.init(a, d);
            }
            bodyFormatter(a) {
                return a.map(function(a) {
                    const b = a.series.tooltipOptions;
                    return (b[(a.point.formatPrefix || "point") + "Formatter"] || a.point.tooltipFormatter).call(a.point, b[(a.point.formatPrefix || "point") + "Format"] || "");
                });
            }
            cleanSplit(a) {
                this.chart.series.forEach(function(d) {
                    const b = d && d.tt;
                    b && (!b.isActive || a ? d.tt = b.destroy() : b.isActive = !1);
                });
            }
            defaultFormatter(a) {
                const k = this.points || d(this);
                let b;
                b = [
                    a.tooltipFooterHeaderFormatter(k[0])
                ];
                b = b.concat(a.bodyFormatter(k));
                b.push(a.tooltipFooterHeaderFormatter(k[0], !0));
                return b;
            }
            destroy() {
                this.label && (this.label = this.label.destroy());
                this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy()));
                this.renderer && (this.renderer = this.renderer.destroy(), t(this.container));
                C.clearTimeout(this.hideTimer);
                C.clearTimeout(this.tooltipTimeout);
            }
            getAnchor(a, k) {
                var b = this.chart;
                const f = b.pointer, c = b.inverted, n = b.plotTop;
                b = b.plotLeft;
                a = d(a);
                a[0].series && a[0].series.yAxis && !a[0].series.yAxis.options.reversedStacks && (a = a.slice().reverse());
                if (this.followPointer && k) "undefined" === typeof k.chartX && (k = f.normalize(k)), a = [
                    k.chartX - b,
                    k.chartY - n
                ];
                else if (a[0].tooltipPos) a = a[0].tooltipPos;
                else {
                    let f = 0, d = 0;
                    a.forEach(function(b) {
                        if (b = b.pos(!0)) f += b[0], d += b[1];
                    });
                    f /= a.length;
                    d /= a.length;
                    this.shared && 1 < a.length && k && (c ? f = k.chartX : d = k.chartY);
                    a = [
                        f - b,
                        d - n
                    ];
                }
                return a.map(Math.round);
            }
            getClassName(a, d, b) {
                const f = a.series, c = f.options;
                return [
                    this.options.className,
                    "highcharts-label",
                    b && "highcharts-tooltip-header",
                    d ? "highcharts-tooltip-box" : "highcharts-tooltip",
                    !b && "highcharts-color-" + F(a.colorIndex, f.colorIndex),
                    c && c.className
                ].filter(w).join(" ");
            }
            getLabel() {
                const a = this, d = this.chart.styledMode, b = this.options, f = this.split && this.allowShared, c = b.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none");
                let n, k = this.chart.renderer;
                if (this.label) {
                    var e = !this.label.hasClass("highcharts-label");
                    (!f && e || f && !e) && this.destroy();
                }
                if (!this.label) {
                    if (this.outside) {
                        e = this.chart.options.chart.style;
                        const b = L.getRendererType();
                        this.container = n = y.doc.createElement("div");
                        n.className = "highcharts-tooltip-container";
                        p(n, {
                            position: "absolute",
                            top: "1px",
                            pointerEvents: c,
                            zIndex: Math.max(this.options.style.zIndex || 0, (e && e.zIndex || 0) + 3)
                        });
                        y.doc.body.appendChild(n);
                        this.renderer = k = new b(n, 0, 0, e, void 0, void 0, k.styledMode);
                    }
                    f ? this.label = k.g("tooltip") : (this.label = k.label("", 0, 0, b.shape, void 0, void 0, b.useHTML, void 0, "tooltip").attr({
                        padding: b.padding,
                        r: b.borderRadius
                    }), d || this.label.attr({
                        fill: b.backgroundColor,
                        "stroke-width": b.borderWidth || 0
                    }).css(b.style).css({
                        pointerEvents: c
                    }));
                    if (a.outside) {
                        const b = this.label, { xSetter: c, ySetter: f } = b;
                        b.xSetter = function(f) {
                            c.call(b, a.distance);
                            n.style.left = f + "px";
                        };
                        b.ySetter = function(c) {
                            f.call(b, a.distance);
                            n.style.top = c + "px";
                        };
                    }
                    this.label.attr({
                        zIndex: 8
                    }).shadow(b.shadow).add();
                }
                return this.label;
            }
            getPlayingField() {
                const { body: a, documentElement: d } = H, { chart: b, distance: f, outside: c } = this;
                return {
                    width: c ? Math.max(a.scrollWidth, d.scrollWidth, a.offsetWidth, d.offsetWidth, d.clientWidth) - 2 * f : b.chartWidth,
                    height: c ? Math.max(a.scrollHeight, d.scrollHeight, a.offsetHeight, d.offsetHeight, d.clientHeight) : b.chartHeight
                };
            }
            getPosition(a, d, b) {
                const f = this.chart, c = this.distance, n = {}, k = f.inverted && b.h || 0, e = this.outside;
                var q = this.getPlayingField();
                const g = q.width, h = q.height, r = f.pointer.getChartPosition();
                q = (n)=>{
                    const k = "x" === n;
                    return [
                        n,
                        k ? g : h,
                        k ? a : d
                    ].concat(e ? [
                        k ? a * r.scaleX : d * r.scaleY,
                        k ? r.left - c + (b.plotX + f.plotLeft) * r.scaleX : r.top - c + (b.plotY + f.plotTop) * r.scaleY,
                        0,
                        k ? g : h
                    ] : [
                        k ? a : d,
                        k ? b.plotX + f.plotLeft : b.plotY + f.plotTop,
                        k ? f.plotLeft : f.plotTop,
                        k ? f.plotLeft + f.plotWidth : f.plotTop + f.plotHeight
                    ]);
                };
                let l = q("y"), m = q("x"), p;
                q = !!b.negative;
                !f.polar && f.hoverSeries && f.hoverSeries.yAxis && f.hoverSeries.yAxis.reversed && (q = !q);
                const t = !this.followPointer && F(b.ttBelow, !f.inverted === q), w = function(b, a, f, d, q, g, h) {
                    const l = e ? "y" === b ? c * r.scaleY : c * r.scaleX : c, m = (f - d) / 2, p = d < q - c, J = q + c + d < a, D = q - l - f + m;
                    q = q + l - m;
                    if (t && J) n[b] = q;
                    else if (!t && p) n[b] = D;
                    else if (p) n[b] = Math.min(h - d, 0 > D - k ? D : D - k);
                    else if (J) n[b] = Math.max(g, q + k + f > a ? q : q + k);
                    else return !1;
                }, G = function(b, a, f, d, k) {
                    let e;
                    k < c || k > a - c ? e = !1 : n[b] = k < f / 2 ? 1 : k > a - d / 2 ? a - d - 2 : k - f / 2;
                    return e;
                }, v = function(b) {
                    const c = l;
                    l = m;
                    m = c;
                    p = b;
                }, J = function() {
                    !1 !== w.apply(0, l) ? !1 !== G.apply(0, m) || p || (v(!0), J()) : p ? n.x = n.y = 0 : (v(!0), J());
                };
                (f.inverted || 1 < this.len) && v();
                J();
                return n;
            }
            hide(a) {
                const d = this;
                C.clearTimeout(this.hideTimer);
                a = F(a, this.options.hideDelay);
                this.isHidden || (this.hideTimer = k(function() {
                    d.getLabel().fadeOut(a ? void 0 : a);
                    d.isHidden = !0;
                }, a));
            }
            init(a, d) {
                this.chart = a;
                this.options = d;
                this.crosshairs = [];
                this.now = {
                    x: 0,
                    y: 0
                };
                this.isHidden = !0;
                this.split = d.split && !a.inverted && !a.polar;
                this.shared = d.shared || this.split;
                this.outside = F(d.outside, !(!a.scrollablePixelsX && !a.scrollablePixelsY));
            }
            shouldStickOnContact(a) {
                return !(this.followPointer || !this.options.stickOnContact || a && !this.chart.pointer.inClass(a.target, "highcharts-tooltip"));
            }
            move(a, d, b, f) {
                const c = this, n = c.now, k = !1 !== c.options.animation && !c.isHidden && (1 < Math.abs(a - n.x) || 1 < Math.abs(d - n.y)), e = c.followPointer || 1 < c.len;
                m(n, {
                    x: k ? (2 * n.x + a) / 3 : a,
                    y: k ? (n.y + d) / 2 : d,
                    anchorX: e ? void 0 : k ? (2 * n.anchorX + b) / 3 : b,
                    anchorY: e ? void 0 : k ? (n.anchorY + f) / 2 : f
                });
                c.getLabel().attr(n);
                c.drawTracker();
                k && (C.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function() {
                    c && c.move(a, d, b, f);
                }, 32));
            }
            refresh(a, k) {
                const b = this.chart, f = this.options, c = b.pointer, n = d(a), e = n[0], q = [];
                var r = f.format, l = f.formatter || this.defaultFormatter;
                const m = this.shared, p = b.styledMode;
                let t = {};
                if (f.enabled && e.series) {
                    C.clearTimeout(this.hideTimer);
                    this.allowShared = !(!g(a) && a.series && a.series.noSharedTooltip);
                    this.followPointer = !this.split && e.series.tooltipOptions.followPointer;
                    a = this.getAnchor(a, k);
                    var v = a[0], G = a[1];
                    m && this.allowShared ? (c.applyInactiveState(n), n.forEach(function(b) {
                        b.setState("hover");
                        q.push(b.getLabelConfig());
                    }), t = e.getLabelConfig(), t.points = q) : t = e.getLabelConfig();
                    this.len = q.length;
                    r = w(r) ? x(r, t, b) : l.call(t, this);
                    l = e.series;
                    this.distance = F(l.tooltipOptions.distance, 16);
                    if (!1 === r) this.hide();
                    else {
                        if (this.split && this.allowShared) this.renderSplit(r, n);
                        else {
                            let d = v, g = G;
                            k && c.isDirectTouch && (d = k.chartX - b.plotLeft, g = k.chartY - b.plotTop);
                            if (b.polar || !1 === l.options.clip || n.some((b)=>c.isDirectTouch || b.series.shouldShowTooltip(d, g))) k = this.getLabel(), f.style.width && !p || k.css({
                                width: (this.outside ? this.getPlayingField() : b.spacingBox).width + "px"
                            }), k.attr({
                                text: r && r.join ? r.join("") : r
                            }), k.addClass(this.getClassName(e), !0), p || k.attr({
                                stroke: f.borderColor || e.color || l.color || "#666666"
                            }), this.updatePosition({
                                plotX: v,
                                plotY: G,
                                negative: e.negative,
                                ttBelow: e.ttBelow,
                                h: a[2] || 0
                            });
                            else {
                                this.hide();
                                return;
                            }
                        }
                        this.isHidden && this.label && this.label.attr({
                            opacity: 1
                        }).show();
                        this.isHidden = !1;
                    }
                    h(this, "refresh");
                }
            }
            renderSplit(a, d) {
                function b(b, c, a, d, n = !0) {
                    a ? (c = S ? 0 : z, b = l(b - d / 2, J.left, J.right - d - (f.outside ? W : 0))) : (c -= da, b = n ? b - d - x : b + x, b = l(b, n ? b : J.left, J.right));
                    return {
                        x: b,
                        y: c
                    };
                }
                const f = this, { chart: c, chart: { chartWidth: n, chartHeight: k, plotHeight: e, plotLeft: g, plotTop: h, pointer: q, scrollablePixelsY: r = 0, scrollablePixelsX: p, scrollingContainer: { scrollLeft: t, scrollTop: v } = {
                    scrollLeft: 0,
                    scrollTop: 0
                }, styledMode: G }, distance: x, options: E, options: { positioner: y } } = f, J = f.outside && "number" !== typeof p ? H.documentElement.getBoundingClientRect() : {
                    left: t,
                    right: t + n,
                    top: v,
                    bottom: v + k
                }, N = f.getLabel(), O = this.renderer || c.renderer, S = !(!c.xAxis[0] || !c.xAxis[0].opposite), { left: W, top: ha } = q.getChartPosition();
                let da = h + v, C = 0, z = e - r;
                w(a) && (a = [
                    !1,
                    a
                ]);
                a = a.slice(0, d.length + 1).reduce(function(c, a, n) {
                    if (!1 !== a && "" !== a) {
                        n = d[n - 1] || {
                            isHeader: !0,
                            plotX: d[0].plotX,
                            plotY: e,
                            series: {}
                        };
                        const D = n.isHeader;
                        var k = D ? f : n.series, q;
                        {
                            var r = n;
                            a = a.toString();
                            var m = k.tt;
                            const { isHeader: b, series: c } = r;
                            m || (m = {
                                padding: E.padding,
                                r: E.borderRadius
                            }, G || (m.fill = E.backgroundColor, m["stroke-width"] = null !== (q = E.borderWidth) && void 0 !== q ? q : 1), m = O.label("", 0, 0, E[b ? "headerShape" : "shape"], void 0, void 0, E.useHTML).addClass(f.getClassName(r, !0, b)).attr(m).add(N));
                            m.isActive = !0;
                            m.attr({
                                text: a
                            });
                            G || m.css(E.style).attr({
                                stroke: E.borderColor || r.color || c.color || "#333333"
                            });
                            q = m;
                        }
                        q = k.tt = q;
                        r = q.getBBox();
                        k = r.width + q.strokeWidth();
                        D && (C = r.height, z += C, S && (da -= C));
                        {
                            const { isHeader: b, plotX: c = 0, plotY: f = 0, series: d } = n;
                            if (b) {
                                a = g + c;
                                var p = h + e / 2;
                            } else {
                                const { xAxis: b, yAxis: n } = d;
                                a = b.pos + l(c, -x, b.len + x);
                                d.shouldShowTooltip(0, n.pos - h + f, {
                                    ignoreX: !0
                                }) && (p = n.pos + f);
                            }
                            a = l(a, J.left - x, J.right + x);
                            p = {
                                anchorX: a,
                                anchorY: p
                            };
                        }
                        const { anchorX: t, anchorY: Q } = p;
                        "number" === typeof Q ? (p = r.height + 1, r = y ? y.call(f, k, p, n) : b(t, Q, D, k), c.push({
                            align: y ? 0 : void 0,
                            anchorX: t,
                            anchorY: Q,
                            boxWidth: k,
                            point: n,
                            rank: F(r.rank, D ? 1 : 0),
                            size: p,
                            target: r.y,
                            tt: q,
                            x: r.x
                        })) : q.isActive = !1;
                    }
                    return c;
                }, []);
                !y && a.some((b)=>{
                    var { outside: c } = f;
                    c = (c ? W : 0) + b.anchorX;
                    return c < J.left && c + b.boxWidth < J.right ? !0 : c < W - J.left + b.boxWidth && J.right - c > c;
                }) && (a = a.map((c)=>{
                    const { x: a, y: f } = b(c.anchorX, c.anchorY, c.point.isHeader, c.boxWidth, !1);
                    return m(c, {
                        target: f,
                        x: a
                    });
                }));
                f.cleanSplit();
                u(a, z);
                var ca = W, L = W;
                a.forEach(function(b) {
                    const { x: c, boxWidth: a, isHeader: d } = b;
                    d || (f.outside && W + c < ca && (ca = W + c), !d && f.outside && ca + a > L && (L = W + c));
                });
                a.forEach(function(b) {
                    const { x: c, anchorX: a, anchorY: d, pos: n, point: { isHeader: k } } = b, e = {
                        visibility: "undefined" === typeof n ? "hidden" : "inherit",
                        x: c,
                        y: (n || 0) + da,
                        anchorX: a,
                        anchorY: d
                    };
                    if (f.outside && c < a) {
                        const b = W - ca;
                        0 < b && (k || (e.x = c + b, e.anchorX = a + b), k && (e.x = (L - ca) / 2, e.anchorX = a + b));
                    }
                    b.tt.attr(e);
                });
                const { container: R, outside: Q, renderer: la } = f;
                if (Q && R && la) {
                    const { width: b, height: c, x: a, y: f } = N.getBBox();
                    la.setSize(b + a, c + f, !1);
                    R.style.left = ca + "px";
                    R.style.top = ha + "px";
                }
                B && N.attr({
                    opacity: 1 === N.opacity ? .999 : 1
                });
            }
            drawTracker() {
                if (this.shouldStickOnContact()) {
                    var a = this.chart, d = this.label, b = this.shared ? a.hoverPoints : a.hoverPoint;
                    if (d && b) {
                        var f = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        };
                        b = this.getAnchor(b);
                        var c = d.getBBox();
                        b[0] += a.plotLeft - d.translateX;
                        b[1] += a.plotTop - d.translateY;
                        f.x = Math.min(0, b[0]);
                        f.y = Math.min(0, b[1]);
                        f.width = 0 > b[0] ? Math.max(Math.abs(b[0]), c.width - b[0]) : Math.max(Math.abs(b[0]), c.width);
                        f.height = 0 > b[1] ? Math.max(Math.abs(b[1]), c.height - Math.abs(b[1])) : Math.max(Math.abs(b[1]), c.height);
                        this.tracker ? this.tracker.attr(f) : (this.tracker = d.renderer.rect(f).addClass("highcharts-tracker").add(d), a.styledMode || this.tracker.attr({
                            fill: "rgba(0,0,0,0)"
                        }));
                    }
                } else this.tracker && (this.tracker = this.tracker.destroy());
            }
            styledModeFormat(a) {
                return a.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
            }
            tooltipFooterHeaderFormatter(a, d) {
                const b = a.series, f = b.tooltipOptions;
                var c = b.xAxis;
                const n = c && c.dateTime;
                c = {
                    isFooter: d,
                    labelConfig: a
                };
                let k = f.xDateFormat, g = f[d ? "footerFormat" : "headerFormat"];
                h(this, "headerFormatter", c, function(c) {
                    n && !k && e(a.key) && (k = n.getXDateFormat(a.key, f.dateTimeLabelFormats));
                    n && k && (a.point && a.point.tooltipDateKeys || [
                        "key"
                    ]).forEach(function(b) {
                        g = g.replace("{point." + b + "}", "{point." + b + ":" + k + "}");
                    });
                    b.chart.styledMode && (g = this.styledModeFormat(g));
                    c.text = x(g, {
                        point: a,
                        series: b
                    }, this.chart);
                });
                return c.text;
            }
            update(a) {
                this.destroy();
                this.init(this.chart, E(!0, this.options, a));
            }
            updatePosition(a) {
                const { chart: d, distance: b, options: f } = this;
                var c = d.pointer;
                const n = this.getLabel(), { left: k, top: e, scaleX: g, scaleY: h } = c.getChartPosition();
                c = (f.positioner || this.getPosition).call(this, n.width, n.height, a);
                let q = (a.plotX || 0) + d.plotLeft;
                a = (a.plotY || 0) + d.plotTop;
                let r;
                if (this.outside) {
                    f.positioner && (c.x += k - b, c.y += e - b);
                    r = (f.borderWidth || 0) + 2 * b;
                    this.renderer.setSize(n.width + r, n.height + r, !1);
                    if (1 !== g || 1 !== h) p(this.container, {
                        transform: `scale(${g}, ${h})`
                    }), q *= g, a *= h;
                    q += k - c.x;
                    a += e - c.y;
                }
                this.move(Math.round(c.x), Math.round(c.y || 0), q, a);
            }
        }
        (function(a) {
            const d = [];
            a.compose = function(b) {
                C.pushUnique(d, b) && v(b, "afterInit", function() {
                    const b = this.chart;
                    b.options.tooltip && (b.tooltip = new a(b, b.options.tooltip));
                });
            };
        })(r || (r = {}));
        "";
        return r;
    });
    M(a, "Core/Series/Point.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Defaults.js"],
        a["Core/Templating.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C) {
        const { animObject: x } = y, { defaultOptions: H } = I, { format: B } = L, { addEvent: u, defined: v, erase: l, extend: p, fireEvent: t, getNestedProperty: m, isArray: h, isFunction: g, isNumber: e, isObject: w, merge: E, objectEach: F, pick: d, syncTimeout: k, removeEvent: r, uniqueKey: q } = C;
        class G {
            constructor(){
                this.category = void 0;
                this.destroyed = !1;
                this.formatPrefix = "point";
                this.id = void 0;
                this.isNull = !1;
                this.percentage = this.options = this.name = void 0;
                this.selected = !1;
                this.total = this.shapeArgs = this.series = void 0;
                this.visible = !0;
                this.x = void 0;
            }
            animateBeforeDestroy() {
                const b = this, a = {
                    x: b.startXPos,
                    opacity: 0
                }, c = b.getGraphicalProps();
                c.singular.forEach(function(c) {
                    b[c] = b[c].animate("dataLabel" === c ? {
                        x: b[c].startXPos,
                        y: b[c].startYPos,
                        opacity: 0
                    } : a);
                });
                c.plural.forEach(function(c) {
                    b[c].forEach(function(c) {
                        c.element && c.animate(p({
                            x: b.startXPos
                        }, c.startYPos ? {
                            x: c.startXPos,
                            y: c.startYPos
                        } : {}));
                    });
                });
            }
            applyOptions(b, a) {
                const c = this.series, f = c.options.pointValKey || c.pointValKey;
                b = G.prototype.optionsToObject.call(this, b);
                p(this, b);
                this.options = this.options ? p(this.options, b) : b;
                b.group && delete this.group;
                b.dataLabels && delete this.dataLabels;
                f && (this.y = G.prototype.getNestedProperty.call(this, f));
                this.formatPrefix = (this.isNull = this.isValid && !this.isValid()) ? "null" : "point";
                this.selected && (this.state = "select");
                "name" in this && "undefined" === typeof a && c.xAxis && c.xAxis.hasNames && (this.x = c.xAxis.nameToX(this));
                "undefined" === typeof this.x && c ? this.x = "undefined" === typeof a ? c.autoIncrement() : a : e(b.x) && c.options.relativeXValue && (this.x = c.autoIncrement(b.x));
                return this;
            }
            destroy() {
                if (!this.destroyed) {
                    const a = this;
                    var b = a.series;
                    const c = b.chart;
                    b = b.options.dataSorting;
                    const d = c.hoverPoints, e = x(a.series.chart.renderer.globalAnimation), g = ()=>{
                        if (a.graphic || a.graphics || a.dataLabel || a.dataLabels) r(a), a.destroyElements();
                        for(const b in a)delete a[b];
                    };
                    a.legendItem && c.legend.destroyItem(a);
                    d && (a.setState(), l(d, a), d.length || (c.hoverPoints = null));
                    if (a === c.hoverPoint) a.onMouseOut();
                    b && b.enabled ? (this.animateBeforeDestroy(), k(g, e.duration)) : g();
                    c.pointCount--;
                }
                this.destroyed = !0;
            }
            destroyElements(b) {
                const a = this;
                b = a.getGraphicalProps(b);
                b.singular.forEach(function(b) {
                    a[b] = a[b].destroy();
                });
                b.plural.forEach(function(b) {
                    a[b].forEach(function(b) {
                        b && b.element && b.destroy();
                    });
                    delete a[b];
                });
            }
            firePointEvent(b, a, c) {
                const f = this, d = this.series.options;
                (d.point.events[b] || f.options && f.options.events && f.options.events[b]) && f.importEvents();
                "click" === b && d.allowPointSelect && (c = function(b) {
                    f.select && f.select(null, b.ctrlKey || b.metaKey || b.shiftKey);
                });
                t(f, b, a, c);
            }
            getClassName() {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + ("undefined" !== typeof this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            }
            getGraphicalProps(b) {
                const a = this, c = [], d = {
                    singular: [],
                    plural: []
                };
                let k, e;
                b = b || {
                    graphic: 1,
                    dataLabel: 1
                };
                b.graphic && c.push("graphic");
                b.dataLabel && c.push("dataLabel", "dataLabelPath", "dataLabelUpper", "connector");
                for(e = c.length; e--;)k = c[e], a[k] && d.singular.push(k);
                [
                    "graphic",
                    "dataLabel",
                    "connector"
                ].forEach(function(c) {
                    const f = c + "s";
                    b[c] && a[f] && d.plural.push(f);
                });
                return d;
            }
            getLabelConfig() {
                return {
                    x: this.category,
                    y: this.y,
                    color: this.color,
                    colorIndex: this.colorIndex,
                    key: this.name || this.category,
                    series: this.series,
                    point: this,
                    percentage: this.percentage,
                    total: this.total || this.stackTotal
                };
            }
            getNestedProperty(b) {
                if (b) return 0 === b.indexOf("custom.") ? m(b, this.options) : this[b];
            }
            getZone() {
                var b = this.series;
                const a = b.zones;
                b = b.zoneAxis || "y";
                let c, d = 0;
                for(c = a[d]; this[b] >= c.value;)c = a[++d];
                this.nonZonedColor || (this.nonZonedColor = this.color);
                this.color = c && c.color && !this.options.color ? c.color : this.nonZonedColor;
                return c;
            }
            hasNewShapeType() {
                return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
            }
            init(b, a, c) {
                this.series = b;
                this.applyOptions(a, c);
                this.id = v(this.id) ? this.id : q();
                this.resolveColor();
                b.chart.pointCount++;
                t(this, "afterInit");
                return this;
            }
            isValid() {
                return null !== this.x && e(this.y);
            }
            optionsToObject(b) {
                var a = this.series;
                const c = a.options.keys, d = c || a.pointArrayMap || [
                    "y"
                ], k = d.length;
                let g = {}, q = 0, r = 0;
                if (e(b) || null === b) g[d[0]] = b;
                else if (h(b)) for(!c && b.length > k && (a = typeof b[0], "string" === a ? g.name = b[0] : "number" === a && (g.x = b[0]), q++); r < k;)c && "undefined" === typeof b[q] || (0 < d[r].indexOf(".") ? G.prototype.setNestedProperty(g, b[q], d[r]) : g[d[r]] = b[q]), q++, r++;
                else "object" === typeof b && (g = b, b.dataLabels && (a._hasPointLabels = !0), b.marker && (a._hasPointMarkers = !0));
                return g;
            }
            pos(b, a = this.plotY) {
                if (!this.destroyed) {
                    const { plotX: c, series: f } = this, { chart: d, xAxis: k, yAxis: g } = f;
                    let h = 0, q = 0;
                    if (e(c) && e(a)) return b && (h = k ? k.pos : d.plotLeft, q = g ? g.pos : d.plotTop), d.inverted && k && g ? [
                        g.len - a + q,
                        k.len - c + h
                    ] : [
                        c + h,
                        a + q
                    ];
                }
            }
            resolveColor() {
                const b = this.series;
                var a = b.chart.styledMode;
                let c;
                var k = b.chart.options.chart.colorCount;
                delete this.nonZonedColor;
                b.options.colorByPoint ? (a || (k = b.options.colors || b.chart.options.colors, c = k[b.colorCounter], k = k.length), a = b.colorCounter, b.colorCounter++, b.colorCounter === k && (b.colorCounter = 0)) : (a || (c = b.color), a = b.colorIndex);
                this.colorIndex = d(this.options.colorIndex, a);
                this.color = d(this.options.color, c);
            }
            setNestedProperty(b, a, c) {
                c.split(".").reduce(function(b, c, f, d) {
                    b[c] = d.length - 1 === f ? a : w(b[c], !0) ? b[c] : {};
                    return b[c];
                }, b);
                return b;
            }
            shouldDraw() {
                return !this.isNull;
            }
            tooltipFormatter(b) {
                const a = this.series, c = a.tooltipOptions, k = d(c.valueDecimals, ""), e = c.valuePrefix || "", g = c.valueSuffix || "";
                a.chart.styledMode && (b = a.chart.tooltip.styledModeFormat(b));
                (a.pointArrayMap || [
                    "y"
                ]).forEach(function(c) {
                    c = "{point." + c;
                    if (e || g) b = b.replace(RegExp(c + "}", "g"), e + c + "}" + g);
                    b = b.replace(RegExp(c + "}", "g"), c + ":,." + k + "f}");
                });
                return B(b, {
                    point: this,
                    series: this.series
                }, a.chart);
            }
            update(b, a, c, k) {
                function f() {
                    n.applyOptions(b);
                    var f = g && n.hasMockGraphic;
                    f = null === n.y ? !f : f;
                    g && f && (n.graphic = g.destroy(), delete n.hasMockGraphic);
                    w(b, !0) && (g && g.element && b && b.marker && "undefined" !== typeof b.marker.symbol && (n.graphic = g.destroy()), b && b.dataLabels && n.dataLabel && (n.dataLabel = n.dataLabel.destroy()), n.connector && (n.connector = n.connector.destroy()));
                    r = n.index;
                    e.updateParallelArrays(n, r);
                    q.data[r] = w(q.data[r], !0) || w(b, !0) ? n.options : d(b, q.data[r]);
                    e.isDirty = e.isDirtyData = !0;
                    !e.fixedBox && e.hasCartesianSeries && (h.isDirtyBox = !0);
                    "point" === q.legendType && (h.isDirtyLegend = !0);
                    a && h.redraw(c);
                }
                const n = this, e = n.series, g = n.graphic, h = e.chart, q = e.options;
                let r;
                a = d(a, !0);
                !1 === k ? f() : n.firePointEvent("update", {
                    options: b
                }, f);
            }
            remove(b, a) {
                this.series.removePoint(this.series.data.indexOf(this), b, a);
            }
            select(b, a) {
                const c = this, f = c.series, k = f.chart;
                this.selectedStaging = b = d(b, !c.selected);
                c.firePointEvent(b ? "select" : "unselect", {
                    accumulate: a
                }, function() {
                    c.selected = c.options.selected = b;
                    f.options.data[f.data.indexOf(c)] = c.options;
                    c.setState(b && "select");
                    a || k.getSelectedPoints().forEach(function(b) {
                        const a = b.series;
                        b.selected && b !== c && (b.selected = b.options.selected = !1, a.options.data[a.data.indexOf(b)] = b.options, b.setState(k.hoverPoints && a.options.inactiveOtherPoints ? "inactive" : ""), b.firePointEvent("unselect"));
                    });
                });
                delete this.selectedStaging;
            }
            onMouseOver(b) {
                const a = this.series.chart, c = a.pointer;
                b = b ? c.normalize(b) : c.getChartCoordinatesFromPoint(this, a.inverted);
                c.runPointActions(b, this);
            }
            onMouseOut() {
                const b = this.series.chart;
                this.firePointEvent("mouseOut");
                this.series.options.inactiveOtherPoints || (b.hoverPoints || []).forEach(function(b) {
                    b.setState();
                });
                b.hoverPoints = b.hoverPoint = null;
            }
            importEvents() {
                if (!this.hasImportedEvents) {
                    const b = this, a = E(b.series.options.point, b.options).events;
                    b.events = a;
                    F(a, function(c, a) {
                        g(c) && u(b, a, c);
                    });
                    this.hasImportedEvents = !0;
                }
            }
            setState(b, f) {
                const c = this.series;
                var k = this.state, g = c.options.states[b || "normal"] || {}, h = H.plotOptions[c.type].marker && c.options.marker;
                const q = h && !1 === h.enabled, r = h && h.states && h.states[b || "normal"] || {}, l = !1 === r.enabled, m = this.marker || {}, w = c.chart, v = h && c.markerAttribs;
                let G = c.halo;
                var u;
                let x;
                var E = c.stateMarkerGraphic;
                b = b || "";
                if (!(b === this.state && !f || this.selected && "select" !== b || !1 === g.enabled || b && (l || q && !1 === r.enabled) || b && m.states && m.states[b] && !1 === m.states[b].enabled)) {
                    this.state = b;
                    v && (u = c.markerAttribs(this, b));
                    if (this.graphic && !this.hasMockGraphic) {
                        k && this.graphic.removeClass("highcharts-point-" + k);
                        b && this.graphic.addClass("highcharts-point-" + b);
                        if (!w.styledMode) {
                            k = c.pointAttribs(this, b);
                            x = d(w.options.chart.animation, g.animation);
                            const a = k.opacity;
                            c.options.inactiveOtherPoints && e(a) && ((this.dataLabels || []).forEach(function(b) {
                                b && !b.hasClass("highcharts-data-label-hidden") && b.animate({
                                    opacity: a
                                }, x);
                            }), this.connector && this.connector.animate({
                                opacity: a
                            }, x));
                            this.graphic.animate(k, x);
                        }
                        u && this.graphic.animate(u, d(w.options.chart.animation, r.animation, h.animation));
                        E && E.hide();
                    } else {
                        if (b && r) {
                            h = m.symbol || c.symbol;
                            E && E.currentSymbol !== h && (E = E.destroy());
                            if (u) {
                                if (E) E[f ? "animate" : "attr"]({
                                    x: u.x,
                                    y: u.y
                                });
                                else h && (c.stateMarkerGraphic = E = w.renderer.symbol(h, u.x, u.y, u.width, u.height).add(c.markerGroup), E.currentSymbol = h);
                            }
                            !w.styledMode && E && "inactive" !== this.state && E.attr(c.pointAttribs(this, b));
                        }
                        E && (E[b && this.isInside ? "show" : "hide"](), E.element.point = this, E.addClass(this.getClassName(), !0));
                    }
                    g = g.halo;
                    u = (E = this.graphic || E) && E.visibility || "inherit";
                    g && g.size && E && "hidden" !== u && !this.isCluster ? (G || (c.halo = G = w.renderer.path().add(E.parentGroup)), G.show()[f ? "animate" : "attr"]({
                        d: this.haloPath(g.size)
                    }), G.attr({
                        "class": "highcharts-halo highcharts-color-" + d(this.colorIndex, c.colorIndex) + (this.className ? " " + this.className : ""),
                        visibility: u,
                        zIndex: -1
                    }), G.point = this, w.styledMode || G.attr(p({
                        fill: this.color || c.color,
                        "fill-opacity": g.opacity
                    }, a.filterUserAttributes(g.attributes || {})))) : G && G.point && G.point.haloPath && G.animate({
                        d: G.point.haloPath(0)
                    }, null, G.hide);
                    t(this, "afterSetState", {
                        state: b
                    });
                }
            }
            haloPath(b) {
                const a = this.pos();
                return a ? this.series.chart.renderer.symbols.circle(Math.floor(a[0]) - b, a[1] - b, 2 * b, 2 * b) : [];
            }
        }
        "";
        return G;
    });
    M(a, "Core/Pointer.js", [
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { parse: x } = a, { charts: C, noop: z } = y, { addEvent: H, attr: B, css: u, defined: v, extend: l, find: p, fireEvent: t, isNumber: m, isObject: h, objectEach: g, offset: e, pick: w, splat: E } = I;
        class F {
            constructor(a, k){
                this.lastValidTouch = {};
                this.pinchDown = [];
                this.runChartClick = !1;
                this.eventsToUnbind = [];
                this.chart = a;
                this.hasDragged = !1;
                this.options = k;
                this.init(a, k);
            }
            applyInactiveState(a) {
                let d = [], e;
                (a || []).forEach(function(a) {
                    e = a.series;
                    d.push(e);
                    e.linkedParent && d.push(e.linkedParent);
                    e.linkedSeries && (d = d.concat(e.linkedSeries));
                    e.navigatorSeries && d.push(e.navigatorSeries);
                });
                this.chart.series.forEach(function(a) {
                    -1 === d.indexOf(a) ? a.setState("inactive", !0) : a.options.inactiveOtherPoints && a.setAllPointsToState("inactive");
                });
            }
            destroy() {
                const a = this;
                this.eventsToUnbind.forEach((a)=>a());
                this.eventsToUnbind = [];
                y.chartCount || (F.unbindDocumentMouseUp && (F.unbindDocumentMouseUp = F.unbindDocumentMouseUp()), F.unbindDocumentTouchEnd && (F.unbindDocumentTouchEnd = F.unbindDocumentTouchEnd()));
                clearInterval(a.tooltipTimeout);
                g(a, function(d, e) {
                    a[e] = void 0;
                });
            }
            getSelectionMarkerAttrs(a, k) {
                const d = {
                    args: {
                        chartX: a,
                        chartY: k
                    },
                    attrs: {},
                    shapeType: "rect"
                };
                t(this, "getSelectionMarkerAttrs", d, (d)=>{
                    const { chart: e, mouseDownX: b = 0, mouseDownY: f = 0, zoomHor: c, zoomVert: n } = this;
                    d = d.attrs;
                    let g;
                    d.x = e.plotLeft;
                    d.y = e.plotTop;
                    d.width = c ? 1 : e.plotWidth;
                    d.height = n ? 1 : e.plotHeight;
                    c && (g = a - b, d.width = Math.abs(g), d.x = (0 < g ? 0 : g) + b);
                    n && (g = k - f, d.height = Math.abs(g), d.y = (0 < g ? 0 : g) + f);
                });
                return d;
            }
            drag(a) {
                const d = this.chart, e = d.options.chart;
                var g = d.plotLeft;
                const l = d.plotTop, b = d.plotWidth, f = d.plotHeight, c = this.mouseDownX || 0, n = this.mouseDownY || 0, m = h(e.panning) ? e.panning && e.panning.enabled : e.panning, p = e.panKey && a[e.panKey + "Key"];
                let t = a.chartX, w = a.chartY, v = this.selectionMarker;
                if (!v || !v.touch) {
                    if (t < g ? t = g : t > g + b && (t = g + b), w < l ? w = l : w > l + f && (w = l + f), this.hasDragged = Math.sqrt(Math.pow(c - t, 2) + Math.pow(n - w, 2)), 10 < this.hasDragged) {
                        g = d.isInsidePlot(c - g, n - l, {
                            visiblePlotOnly: !0
                        });
                        const { shapeType: b, attrs: f } = this.getSelectionMarkerAttrs(t, w);
                        !d.hasCartesianSeries && !d.mapView || !this.zoomX && !this.zoomY || !g || p || v || (this.selectionMarker = v = d.renderer[b](), v.attr({
                            "class": "highcharts-selection-marker",
                            zIndex: 7
                        }).add(), d.styledMode || v.attr({
                            fill: e.selectionMarkerFill || x("#334eff").setOpacity(.25).get()
                        }));
                        v && v.attr(f);
                        g && !v && m && d.pan(a, e.panning);
                    }
                }
            }
            dragStart(a) {
                const d = this.chart;
                d.mouseIsDown = a.type;
                d.cancelClick = !1;
                d.mouseDownX = this.mouseDownX = a.chartX;
                d.mouseDownY = this.mouseDownY = a.chartY;
            }
            getSelectionBox(a) {
                const d = {
                    args: {
                        marker: a
                    },
                    result: {}
                };
                t(this, "getSelectionBox", d, (d)=>{
                    d.result = {
                        x: a.attr ? +a.attr("x") : a.x,
                        y: a.attr ? +a.attr("y") : a.y,
                        width: a.attr ? a.attr("width") : a.width,
                        height: a.attr ? a.attr("height") : a.height
                    };
                });
                return d.result;
            }
            drop(a) {
                const d = this, e = this.chart, g = this.hasPinched;
                if (this.selectionMarker) {
                    const { x: k, y: b, width: f, height: c } = this.getSelectionBox(this.selectionMarker), n = {
                        originalEvent: a,
                        xAxis: [],
                        yAxis: [],
                        x: k,
                        y: b,
                        width: f,
                        height: c
                    };
                    let h = !!e.mapView;
                    if (this.hasDragged || g) e.axes.forEach(function(e) {
                        if (e.zoomEnabled && v(e.min) && (g || d[({
                            xAxis: "zoomX",
                            yAxis: "zoomY"
                        })[e.coll]]) && m(k) && m(b) && m(f) && m(c)) {
                            var q = e.horiz;
                            const d = "touchend" === a.type ? e.minPixelPadding : 0, g = e.toValue((q ? k : b) + d);
                            q = e.toValue((q ? k + f : b + c) - d);
                            n[e.coll].push({
                                axis: e,
                                min: Math.min(g, q),
                                max: Math.max(g, q)
                            });
                            h = !0;
                        }
                    }), h && t(e, "selection", n, function(b) {
                        e.zoom(l(b, g ? {
                            animation: !1
                        } : null));
                    });
                    m(e.index) && (this.selectionMarker = this.selectionMarker.destroy());
                    g && this.scaleGroups();
                }
                e && m(e.index) && (u(e.container, {
                    cursor: e._cursor
                }), e.cancelClick = 10 < this.hasDragged, e.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
            }
            findNearestKDPoint(a, k, e) {
                let d;
                a.forEach(function(a) {
                    var b = !(a.noSharedTooltip && k) && 0 > a.options.findNearestPointBy.indexOf("y");
                    a = a.searchPoint(e, b);
                    if ((b = h(a, !0) && a.series) && !(b = !h(d, !0))) {
                        {
                            b = d.distX - a.distX;
                            const f = d.dist - a.dist, c = (a.series.group && a.series.group.zIndex) - (d.series.group && d.series.group.zIndex);
                            b = 0 !== b && k ? b : 0 !== f ? f : 0 !== c ? c : d.series.index > a.series.index ? -1 : 1;
                        }
                        b = 0 < b;
                    }
                    b && (d = a);
                });
                return d;
            }
            getChartCoordinatesFromPoint(a, k) {
                var d = a.series;
                const e = d.xAxis;
                d = d.yAxis;
                const g = a.shapeArgs;
                if (e && d) {
                    let b = w(a.clientX, a.plotX), f = a.plotY || 0;
                    a.isNode && g && m(g.x) && m(g.y) && (b = g.x, f = g.y);
                    return k ? {
                        chartX: d.len + d.pos - f,
                        chartY: e.len + e.pos - b
                    } : {
                        chartX: b + e.pos,
                        chartY: f + d.pos
                    };
                }
                if (g && g.x && g.y) return {
                    chartX: g.x,
                    chartY: g.y
                };
            }
            getChartPosition() {
                if (this.chartPosition) return this.chartPosition;
                var { container: a } = this.chart;
                const k = e(a);
                this.chartPosition = {
                    left: k.left,
                    top: k.top,
                    scaleX: 1,
                    scaleY: 1
                };
                const g = a.offsetWidth;
                a = a.offsetHeight;
                2 < g && 2 < a && (this.chartPosition.scaleX = k.width / g, this.chartPosition.scaleY = k.height / a);
                return this.chartPosition;
            }
            getCoordinates(a) {
                const d = {
                    xAxis: [],
                    yAxis: []
                };
                this.chart.axes.forEach(function(k) {
                    d[k.isXAxis ? "xAxis" : "yAxis"].push({
                        axis: k,
                        value: k.toValue(a[k.horiz ? "chartX" : "chartY"])
                    });
                });
                return d;
            }
            getHoverData(a, k, e, g, l, b) {
                const f = [];
                g = !(!g || !a);
                const c = function(b) {
                    return b.visible && !(!l && b.directTouch) && w(b.options.enableMouseTracking, !0);
                };
                let d, q = {
                    chartX: b ? b.chartX : void 0,
                    chartY: b ? b.chartY : void 0,
                    shared: l
                };
                t(this, "beforeGetHoverData", q);
                d = k && !k.stickyTracking ? [
                    k
                ] : e.filter((b)=>b.stickyTracking && (q.filter || c)(b));
                const r = g || !b ? a : this.findNearestKDPoint(d, l, b);
                k = r && r.series;
                r && (l && !k.noSharedTooltip ? (d = e.filter(function(b) {
                    return q.filter ? q.filter(b) : c(b) && !b.noSharedTooltip;
                }), d.forEach(function(b) {
                    let c = p(b.points, function(b) {
                        return b.x === r.x && !b.isNull;
                    });
                    h(c) && (b.boosted && b.boost && (c = b.boost.getPoint(c)), f.push(c));
                })) : f.push(r));
                q = {
                    hoverPoint: r
                };
                t(this, "afterGetHoverData", q);
                return {
                    hoverPoint: q.hoverPoint,
                    hoverSeries: k,
                    hoverPoints: f
                };
            }
            getPointFromEvent(a) {
                a = a.target;
                let d;
                for(; a && !d;)d = a.point, a = a.parentNode;
                return d;
            }
            onTrackerMouseOut(a) {
                a = a.relatedTarget;
                const d = this.chart.hoverSeries;
                this.isDirectTouch = !1;
                if (!(!d || !a || d.stickyTracking || this.inClass(a, "highcharts-tooltip") || this.inClass(a, "highcharts-series-" + d.index) && this.inClass(a, "highcharts-tracker"))) d.onMouseOut();
            }
            inClass(a, k) {
                let d;
                for(; a;){
                    if (d = B(a, "class")) {
                        if (-1 !== d.indexOf(k)) return !0;
                        if (-1 !== d.indexOf("highcharts-container")) return !1;
                    }
                    a = a.parentElement;
                }
            }
            init(a, k) {
                this.options = k;
                this.chart = a;
                this.runChartClick = !(!k.chart.events || !k.chart.events.click);
                this.pinchDown = [];
                this.lastValidTouch = {};
                this.setDOMEvents();
                t(this, "afterInit");
            }
            normalize(a, k) {
                var d = a.touches, e = d ? d.length ? d.item(0) : w(d.changedTouches, a.changedTouches)[0] : a;
                k || (k = this.getChartPosition());
                d = e.pageX - k.left;
                e = e.pageY - k.top;
                d /= k.scaleX;
                e /= k.scaleY;
                return l(a, {
                    chartX: Math.round(d),
                    chartY: Math.round(e)
                });
            }
            onContainerClick(a) {
                const d = this.chart, e = d.hoverPoint;
                a = this.normalize(a);
                const g = d.plotLeft, h = d.plotTop;
                d.cancelClick || (e && this.inClass(a.target, "highcharts-tracker") ? (t(e.series, "click", l(a, {
                    point: e
                })), d.hoverPoint && e.firePointEvent("click", a)) : (l(a, this.getCoordinates(a)), d.isInsidePlot(a.chartX - g, a.chartY - h, {
                    visiblePlotOnly: !0
                }) && t(d, "click", a)));
            }
            onContainerMouseDown(a) {
                const d = 1 === ((a.buttons || a.button) & 1);
                a = this.normalize(a);
                if (y.isFirefox && 0 !== a.button) this.onContainerMouseMove(a);
                if ("undefined" === typeof a.button || d) this.zoomOption(a), d && a.preventDefault && a.preventDefault(), this.dragStart(a);
            }
            onContainerMouseLeave(a) {
                const d = C[w(F.hoverChartIndex, -1)];
                a = this.normalize(a);
                d && a.relatedTarget && !this.inClass(a.relatedTarget, "highcharts-tooltip") && (d.pointer.reset(), d.pointer.chartPosition = void 0);
            }
            onContainerMouseEnter(a) {
                delete this.chartPosition;
            }
            onContainerMouseMove(a) {
                const d = this.chart, e = d.tooltip;
                a = this.normalize(a);
                this.setHoverChartIndex();
                ("mousedown" === d.mouseIsDown || this.touchSelect(a)) && this.drag(a);
                d.openMenu || !this.inClass(a.target, "highcharts-tracker") && !d.isInsidePlot(a.chartX - d.plotLeft, a.chartY - d.plotTop, {
                    visiblePlotOnly: !0
                }) || e && e.shouldStickOnContact(a) || (this.inClass(a.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(a));
            }
            onDocumentTouchEnd(a) {
                const d = C[w(F.hoverChartIndex, -1)];
                d && d.pointer.drop(a);
            }
            onContainerTouchMove(a) {
                if (this.touchSelect(a)) this.onContainerMouseMove(a);
                else this.touch(a);
            }
            onContainerTouchStart(a) {
                if (this.touchSelect(a)) this.onContainerMouseDown(a);
                else this.zoomOption(a), this.touch(a, !0);
            }
            onDocumentMouseMove(a) {
                const d = this.chart, e = d.tooltip, g = this.chartPosition;
                a = this.normalize(a, g);
                !g || d.isInsidePlot(a.chartX - d.plotLeft, a.chartY - d.plotTop, {
                    visiblePlotOnly: !0
                }) || e && e.shouldStickOnContact(a) || this.inClass(a.target, "highcharts-tracker") || this.reset();
            }
            onDocumentMouseUp(a) {
                const d = C[w(F.hoverChartIndex, -1)];
                d && d.pointer.drop(a);
            }
            pinch(a) {
                const d = this, e = d.chart, g = d.pinchDown, h = a.touches || [], b = h.length, f = d.lastValidTouch, c = d.hasZoom, n = {}, m = 1 === b && (d.inClass(a.target, "highcharts-tracker") && e.runTrackerClick || d.runChartClick), p = {};
                var v = d.chart.tooltip;
                v = 1 === b && w(v && v.options.followTouchMove, !0);
                let u = d.selectionMarker;
                1 < b ? d.initiated = !0 : v && (d.initiated = !1);
                c && d.initiated && !m && !1 !== a.cancelable && a.preventDefault();
                [].map.call(h, function(b) {
                    return d.normalize(b);
                });
                "touchstart" === a.type ? ([].forEach.call(h, function(b, a) {
                    g[a] = {
                        chartX: b.chartX,
                        chartY: b.chartY
                    };
                }), f.x = [
                    g[0].chartX,
                    g[1] && g[1].chartX
                ], f.y = [
                    g[0].chartY,
                    g[1] && g[1].chartY
                ], e.axes.forEach(function(b) {
                    if (b.zoomEnabled) {
                        const a = e.bounds[b.horiz ? "h" : "v"], c = b.minPixelPadding, f = b.toPixels(Math.min(w(b.options.min, b.dataMin), b.dataMin)), d = b.toPixels(Math.max(w(b.options.max, b.dataMax), b.dataMax)), n = Math.max(f, d);
                        a.min = Math.min(b.pos, Math.min(f, d) - c);
                        a.max = Math.max(b.pos + b.len, n + c);
                    }
                }), d.res = !0) : v ? this.runPointActions(d.normalize(a)) : g.length && (t(e, "touchpan", {
                    originalEvent: a
                }, ()=>{
                    u || (d.selectionMarker = u = l({
                        destroy: z,
                        touch: !0
                    }, e.plotBox));
                    d.pinchTranslate(g, h, n, u, p, f);
                    d.hasPinched = c;
                    d.scaleGroups(n, p);
                }), d.res && (d.res = !1, this.reset(!1, 0)));
            }
            pinchTranslate(a, e, g, h, l, b) {
                this.zoomHor && this.pinchTranslateDirection(!0, a, e, g, h, l, b);
                this.zoomVert && this.pinchTranslateDirection(!1, a, e, g, h, l, b);
            }
            pinchTranslateDirection(a, e, g, h, l, b, f, c) {
                const d = this.chart, k = a ? "x" : "y", q = a ? "X" : "Y", m = "chart" + q, r = a ? "width" : "height", p = d["plot" + (a ? "Left" : "Top")], t = d.inverted, w = d.bounds[a ? "h" : "v"], v = 1 === e.length, u = e[0][m], x = !v && e[1][m];
                e = function() {
                    "number" === typeof N && 20 < Math.abs(u - x) && (F = c || Math.abs(J - N) / Math.abs(u - x));
                    E = (p - J) / F + u;
                    G = d["plot" + (a ? "Width" : "Height")] / F;
                };
                let G, E, F = c || 1, J = g[0][m], N = !v && g[1][m], O;
                e();
                g = E;
                g < w.min ? (g = w.min, O = !0) : g + G > w.max && (g = w.max - G, O = !0);
                O ? (J -= .8 * (J - f[k][0]), "number" === typeof N && (N -= .8 * (N - f[k][1])), e()) : f[k] = [
                    J,
                    N
                ];
                t || (b[k] = E - p, b[r] = G);
                b = t ? 1 / F : F;
                l[r] = G;
                l[k] = g;
                h[t ? a ? "scaleY" : "scaleX" : "scale" + q] = F;
                h["translate" + q] = b * p + (J - b * u);
            }
            reset(a, e) {
                const d = this.chart, k = d.hoverSeries, g = d.hoverPoint, b = d.hoverPoints, f = d.tooltip, c = f && f.shared ? b : g;
                a && c && E(c).forEach(function(b) {
                    b.series.isCartesian && "undefined" === typeof b.plotX && (a = !1);
                });
                if (a) f && c && E(c).length && (f.refresh(c), f.shared && b ? b.forEach(function(b) {
                    b.setState(b.state, !0);
                    b.series.isCartesian && (b.series.xAxis.crosshair && b.series.xAxis.drawCrosshair(null, b), b.series.yAxis.crosshair && b.series.yAxis.drawCrosshair(null, b));
                }) : g && (g.setState(g.state, !0), d.axes.forEach(function(b) {
                    b.crosshair && g.series[b.coll] === b && b.drawCrosshair(null, g);
                })));
                else {
                    if (g) g.onMouseOut();
                    b && b.forEach(function(b) {
                        b.setState();
                    });
                    if (k) k.onMouseOut();
                    f && f.hide(e);
                    this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove());
                    d.axes.forEach(function(b) {
                        b.hideCrosshair();
                    });
                    this.hoverX = d.hoverPoints = d.hoverPoint = null;
                }
            }
            runPointActions(a, e, g) {
                const d = this.chart, k = d.tooltip && d.tooltip.options.enabled ? d.tooltip : void 0, b = k ? k.shared : !1;
                let f = e || d.hoverPoint, c = f && f.series || d.hoverSeries;
                e = this.getHoverData(f, c, d.series, (!a || "touchmove" !== a.type) && (!!e || c && c.directTouch && this.isDirectTouch), b, a);
                f = e.hoverPoint;
                c = e.hoverSeries;
                const n = e.hoverPoints;
                e = c && c.tooltipOptions.followPointer && !c.tooltipOptions.split;
                const h = b && c && !c.noSharedTooltip;
                if (f && (g || f !== d.hoverPoint || k && k.isHidden)) {
                    (d.hoverPoints || []).forEach(function(b) {
                        -1 === n.indexOf(b) && b.setState();
                    });
                    if (d.hoverSeries !== c) c.onMouseOver();
                    this.applyInactiveState(n);
                    (n || []).forEach(function(b) {
                        b.setState("hover");
                    });
                    d.hoverPoint && d.hoverPoint.firePointEvent("mouseOut");
                    if (!f.series) return;
                    d.hoverPoints = n;
                    d.hoverPoint = f;
                    f.firePointEvent("mouseOver", void 0, ()=>{
                        k && f && k.refresh(h ? n : f, a);
                    });
                } else e && k && !k.isHidden && (g = k.getAnchor([
                    {}
                ], a), d.isInsidePlot(g[0], g[1], {
                    visiblePlotOnly: !0
                }) && k.updatePosition({
                    plotX: g[0],
                    plotY: g[1]
                }));
                this.unDocMouseMove || (this.unDocMouseMove = H(d.container.ownerDocument, "mousemove", function(b) {
                    const a = C[F.hoverChartIndex];
                    if (a) a.pointer.onDocumentMouseMove(b);
                }), this.eventsToUnbind.push(this.unDocMouseMove));
                d.axes.forEach(function(b) {
                    const c = w((b.crosshair || {}).snap, !0);
                    let f;
                    c && ((f = d.hoverPoint) && f.series[b.coll] === b || (f = p(n, (a)=>a.series && a.series[b.coll] === b)));
                    f || !c ? b.drawCrosshair(a, f) : b.hideCrosshair();
                });
            }
            scaleGroups(a, e) {
                const d = this.chart;
                d.series.forEach(function(k) {
                    const g = a || k.getPlotBox();
                    k.group && (k.xAxis && k.xAxis.zoomEnabled || d.mapView) && (k.group.attr(g), k.markerGroup && (k.markerGroup.attr(g), k.markerGroup.clip(e ? d.clipRect : null)), k.dataLabelsGroup && k.dataLabelsGroup.attr(g));
                });
                d.clipRect.attr(e || d.clipBox);
            }
            setDOMEvents() {
                const a = this.chart.container, e = a.ownerDocument;
                a.onmousedown = this.onContainerMouseDown.bind(this);
                a.onmousemove = this.onContainerMouseMove.bind(this);
                a.onclick = this.onContainerClick.bind(this);
                this.eventsToUnbind.push(H(a, "mouseenter", this.onContainerMouseEnter.bind(this)));
                this.eventsToUnbind.push(H(a, "mouseleave", this.onContainerMouseLeave.bind(this)));
                F.unbindDocumentMouseUp || (F.unbindDocumentMouseUp = H(e, "mouseup", this.onDocumentMouseUp.bind(this)));
                let g = this.chart.renderTo.parentElement;
                for(; g && "BODY" !== g.tagName;)this.eventsToUnbind.push(H(g, "scroll", ()=>{
                    delete this.chartPosition;
                })), g = g.parentElement;
                y.hasTouch && (this.eventsToUnbind.push(H(a, "touchstart", this.onContainerTouchStart.bind(this), {
                    passive: !1
                })), this.eventsToUnbind.push(H(a, "touchmove", this.onContainerTouchMove.bind(this), {
                    passive: !1
                })), F.unbindDocumentTouchEnd || (F.unbindDocumentTouchEnd = H(e, "touchend", this.onDocumentTouchEnd.bind(this), {
                    passive: !1
                })));
            }
            setHoverChartIndex() {
                const a = this.chart, e = y.charts[w(F.hoverChartIndex, -1)];
                if (e && e !== a) e.pointer.onContainerMouseLeave({
                    relatedTarget: a.container
                });
                e && e.mouseIsDown || (F.hoverChartIndex = a.index);
            }
            touch(a, e) {
                const d = this.chart;
                let g, k;
                this.setHoverChartIndex();
                1 === a.touches.length ? (a = this.normalize(a), (k = d.isInsidePlot(a.chartX - d.plotLeft, a.chartY - d.plotTop, {
                    visiblePlotOnly: !0
                })) && !d.openMenu ? (e && this.runPointActions(a), "touchmove" === a.type && (e = this.pinchDown, g = e[0] ? 4 <= Math.sqrt(Math.pow(e[0].chartX - a.chartX, 2) + Math.pow(e[0].chartY - a.chartY, 2)) : !1), w(g, !0) && this.pinch(a)) : e && this.reset()) : 2 === a.touches.length && this.pinch(a);
            }
            touchSelect(a) {
                return !(!this.chart.zooming.singleTouch || !a.touches || 1 !== a.touches.length);
            }
            zoomOption(a) {
                const d = this.chart, e = d.inverted;
                var g = d.zooming.type || "";
                /touch/.test(a.type) && (g = w(d.zooming.pinchType, g));
                this.zoomX = a = /x/.test(g);
                this.zoomY = g = /y/.test(g);
                this.zoomHor = a && !e || g && e;
                this.zoomVert = g && !e || a && e;
                this.hasZoom = a || g;
            }
        }
        (function(a) {
            const d = [], e = [];
            a.compose = function(d) {
                I.pushUnique(e, d) && H(d, "beforeRender", function() {
                    this.pointer = new a(this, this.options);
                });
            };
            a.dissolve = function() {
                for(let a = 0, e = d.length; a < e; ++a)d[a]();
                d.length = 0;
            };
        })(F || (F = {}));
        "";
        return F;
    });
    M(a, "Core/Legend/Legend.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Templating.js"],
        a["Core/Globals.js"],
        a["Core/Series/Point.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z) {
        const { animObject: x, setAnimation: B } = a, { format: u } = y, { marginNames: v } = I, { distribute: l } = C, { addEvent: p, createElement: t, css: m, defined: h, discardElement: g, find: e, fireEvent: w, isNumber: E, merge: F, pick: d, relativeLength: k, stableSort: r, syncTimeout: q } = z;
        class G {
            constructor(b, a){
                this.allItems = [];
                this.contentGroup = this.box = void 0;
                this.display = !1;
                this.group = void 0;
                this.offsetWidth = this.maxLegendWidth = this.maxItemWidth = this.legendWidth = this.legendHeight = this.lastLineHeight = this.lastItemY = this.itemY = this.itemX = this.itemMarginTop = this.itemMarginBottom = this.itemHeight = this.initialItemY = 0;
                this.options = void 0;
                this.padding = 0;
                this.pages = [];
                this.proximate = !1;
                this.scrollGroup = void 0;
                this.widthOption = this.totalItemWidth = this.titleHeight = this.symbolWidth = this.symbolHeight = 0;
                this.chart = b;
                this.init(b, a);
            }
            init(b, a) {
                this.chart = b;
                this.setOptions(a);
                a.enabled && (this.render(), p(this.chart, "endResize", function() {
                    this.legend.positionCheckboxes();
                }), p(this.chart, "render", ()=>{
                    this.proximate && (this.proximatePositions(), this.positionItems());
                }));
            }
            setOptions(b) {
                const a = d(b.padding, 8);
                this.options = b;
                this.chart.styledMode || (this.itemStyle = b.itemStyle, this.itemHiddenStyle = F(this.itemStyle, b.itemHiddenStyle));
                this.itemMarginTop = b.itemMarginTop;
                this.itemMarginBottom = b.itemMarginBottom;
                this.padding = a;
                this.initialItemY = a - 5;
                this.symbolWidth = d(b.symbolWidth, 16);
                this.pages = [];
                this.proximate = "proximate" === b.layout && !this.chart.inverted;
                this.baseline = void 0;
            }
            update(b, a) {
                const c = this.chart;
                this.setOptions(F(!0, this.options, b));
                this.destroy();
                c.isDirtyLegend = c.isDirtyBox = !0;
                d(a, !0) && c.redraw();
                w(this, "afterUpdate");
            }
            colorizeItem(b, a) {
                const { group: c, label: f, line: d, symbol: e } = b.legendItem || {};
                if (c) c[a ? "removeClass" : "addClass"]("highcharts-legend-item-hidden");
                if (!this.chart.styledMode) {
                    const { itemHiddenStyle: c } = this, g = c.color, k = a ? b.color || g : g, n = b.options && b.options.marker;
                    let h = {
                        fill: k
                    };
                    null === f || void 0 === f || f.css(F(a ? this.itemStyle : c));
                    null === d || void 0 === d || d.attr({
                        stroke: k
                    });
                    e && (n && e.isMarker && (h = b.pointAttribs(), a || (h.stroke = h.fill = g)), e.attr(h));
                }
                w(this, "afterColorizeItem", {
                    item: b,
                    visible: a
                });
            }
            positionItems() {
                this.allItems.forEach(this.positionItem, this);
                this.chart.isResizing || this.positionCheckboxes();
            }
            positionItem(b) {
                const { group: a, x: c = 0, y: d = 0 } = b.legendItem || {};
                var e = this.options, g = e.symbolPadding;
                const k = !e.rtl;
                e = b.checkbox;
                a && a.element && (g = {
                    translateX: k ? c : this.legendWidth - c - 2 * g - 4,
                    translateY: d
                }, a[h(a.translateY) ? "animate" : "attr"](g, void 0, ()=>{
                    w(this, "afterPositionItem", {
                        item: b
                    });
                }));
                e && (e.x = c, e.y = d);
            }
            destroyItem(b) {
                const a = b.checkbox, c = b.legendItem || {};
                for (const b of [
                    "group",
                    "label",
                    "line",
                    "symbol"
                ])c[b] && (c[b] = c[b].destroy());
                a && g(a);
                b.legendItem = void 0;
            }
            destroy() {
                for (const b of this.getAllItems())this.destroyItem(b);
                for (const b of "clipRect up down pager nav box title group".split(" "))this[b] && (this[b] = this[b].destroy());
                this.display = null;
            }
            positionCheckboxes() {
                const b = this.group && this.group.alignAttr, a = this.clipHeight || this.legendHeight, c = this.titleHeight;
                let d;
                b && (d = b.translateY, this.allItems.forEach(function(f) {
                    const e = f.checkbox;
                    let g;
                    e && (g = d + c + e.y + (this.scrollOffset || 0) + 3, m(e, {
                        left: b.translateX + f.checkboxOffset + e.x - 20 + "px",
                        top: g + "px",
                        display: this.proximate || g > d - 6 && g < d + a - 6 ? "" : "none"
                    }));
                }, this));
            }
            renderTitle() {
                var b = this.options;
                const a = this.padding, c = b.title;
                let d = 0;
                c.text && (this.title || (this.title = this.chart.renderer.label(c.text, a - 3, a - 4, void 0, void 0, void 0, b.useHTML, void 0, "legend-title").attr({
                    zIndex: 1
                }), this.chart.styledMode || this.title.css(c.style), this.title.add(this.group)), c.width || this.title.css({
                    width: this.maxLegendWidth + "px"
                }), b = this.title.getBBox(), d = b.height, this.offsetWidth = b.width, this.contentGroup.attr({
                    translateY: d
                }));
                this.titleHeight = d;
            }
            setText(b) {
                const a = this.options;
                b.legendItem.label.attr({
                    text: a.labelFormat ? u(a.labelFormat, b, this.chart) : a.labelFormatter.call(b)
                });
            }
            renderItem(b) {
                const a = b.legendItem = b.legendItem || {};
                var c = this.chart, e = c.renderer;
                const g = this.options, k = this.symbolWidth, h = g.symbolPadding || 0, l = this.itemStyle, m = this.itemHiddenStyle, q = "horizontal" === g.layout ? d(g.itemDistance, 20) : 0, r = !g.rtl, p = !b.series, t = !p && b.series.drawLegendSymbol ? b.series : b;
                var w = t.options;
                const v = this.createCheckboxForItem && w && w.showCheckbox, u = g.useHTML, x = b.options.className;
                let J = a.label;
                w = k + h + q + (v ? 20 : 0);
                J || (a.group = e.g("legend-item").addClass("highcharts-" + t.type + "-series highcharts-color-" + b.colorIndex + (x ? " " + x : "") + (p ? " highcharts-series-" + b.index : "")).attr({
                    zIndex: 1
                }).add(this.scrollGroup), a.label = J = e.text("", r ? k + h : -h, this.baseline || 0, u), c.styledMode || J.css(F(b.visible ? l : m)), J.attr({
                    align: r ? "left" : "right",
                    zIndex: 2
                }).add(a.group), this.baseline || (this.fontMetrics = e.fontMetrics(J), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, J.attr("y", this.baseline), this.symbolHeight = d(g.symbolHeight, this.fontMetrics.f), g.squareSymbol && (this.symbolWidth = d(g.symbolWidth, Math.max(this.symbolHeight, 16)), w = this.symbolWidth + h + q + (v ? 20 : 0), r && J.attr("x", this.symbolWidth + h))), t.drawLegendSymbol(this, b), this.setItemEvents && this.setItemEvents(b, J, u));
                v && !b.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(b);
                this.colorizeItem(b, b.visible);
                !c.styledMode && l.width || J.css({
                    width: (g.itemWidth || this.widthOption || c.spacingBox.width) - w + "px"
                });
                this.setText(b);
                c = J.getBBox();
                e = this.fontMetrics && this.fontMetrics.h || 0;
                b.itemWidth = b.checkboxOffset = g.itemWidth || a.labelWidth || c.width + w;
                this.maxItemWidth = Math.max(this.maxItemWidth, b.itemWidth);
                this.totalItemWidth += b.itemWidth;
                this.itemHeight = b.itemHeight = Math.round(a.labelHeight || (c.height > 1.5 * e ? c.height : e));
            }
            layoutItem(b) {
                var a = this.options;
                const c = this.padding, e = "horizontal" === a.layout, g = b.itemHeight, k = this.itemMarginBottom, h = this.itemMarginTop, l = e ? d(a.itemDistance, 20) : 0, m = this.maxLegendWidth;
                a = a.alignColumns && this.totalItemWidth > m ? this.maxItemWidth : b.itemWidth;
                const q = b.legendItem || {};
                e && this.itemX - c + a > m && (this.itemX = c, this.lastLineHeight && (this.itemY += h + this.lastLineHeight + k), this.lastLineHeight = 0);
                this.lastItemY = h + this.itemY + k;
                this.lastLineHeight = Math.max(g, this.lastLineHeight);
                q.x = this.itemX;
                q.y = this.itemY;
                e ? this.itemX += a : (this.itemY += h + g + k, this.lastLineHeight = g);
                this.offsetWidth = this.widthOption || Math.max((e ? this.itemX - c - (b.checkbox ? 0 : l) : a) + c, this.offsetWidth);
            }
            getAllItems() {
                let b = [];
                this.chart.series.forEach(function(a) {
                    const c = a && a.options;
                    a && d(c.showInLegend, h(c.linkedTo) ? !1 : void 0, !0) && (b = b.concat((a.legendItem || {}).labels || ("point" === c.legendType ? a.data : a)));
                });
                w(this, "afterGetAllItems", {
                    allItems: b
                });
                return b;
            }
            getAlignment() {
                const b = this.options;
                return this.proximate ? b.align.charAt(0) + "tv" : b.floating ? "" : b.align.charAt(0) + b.verticalAlign.charAt(0) + b.layout.charAt(0);
            }
            adjustMargins(b, a) {
                const c = this.chart, f = this.options, e = this.getAlignment();
                e && [
                    /(lth|ct|rth)/,
                    /(rtv|rm|rbv)/,
                    /(rbh|cb|lbh)/,
                    /(lbv|lm|ltv)/
                ].forEach(function(g, k) {
                    g.test(e) && !h(b[k]) && (c[v[k]] = Math.max(c[v[k]], c.legend[(k + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                        1,
                        -1,
                        -1,
                        1
                    ][k] * f[k % 2 ? "x" : "y"] + d(f.margin, 12) + a[k] + (c.titleOffset[k] || 0)));
                });
            }
            proximatePositions() {
                const b = this.chart, a = [], c = "left" === this.options.align;
                this.allItems.forEach(function(d) {
                    var f;
                    var g = c;
                    let k;
                    d.yAxis && (d.xAxis.options.reversed && (g = !g), d.points && (f = e(g ? d.points : d.points.slice(0).reverse(), function(b) {
                        return E(b.plotY);
                    })), g = this.itemMarginTop + d.legendItem.label.getBBox().height + this.itemMarginBottom, k = d.yAxis.top - b.plotTop, d.visible ? (f = f ? f.plotY : d.yAxis.height, f += k - .3 * g) : f = k + d.yAxis.height, a.push({
                        target: f,
                        size: g,
                        item: d
                    }));
                }, this);
                let d;
                for (const c of l(a, b.plotHeight))d = c.item.legendItem || {}, E(c.pos) && (d.y = b.plotTop - b.spacing[0] + c.pos);
            }
            render() {
                const b = this.chart, a = b.renderer, c = this.options, d = this.padding;
                var e = this.getAllItems();
                let g, h = this.group, l = this.box;
                this.itemX = d;
                this.itemY = this.initialItemY;
                this.lastItemY = this.offsetWidth = 0;
                this.widthOption = k(c.width, b.spacingBox.width - d);
                var m = b.spacingBox.width - 2 * d - c.x;
                -1 < [
                    "rm",
                    "lm"
                ].indexOf(this.getAlignment().substring(0, 2)) && (m /= 2);
                this.maxLegendWidth = this.widthOption || m;
                h || (this.group = h = a.g("legend").addClass(c.className || "").attr({
                    zIndex: 7
                }).add(), this.contentGroup = a.g().attr({
                    zIndex: 1
                }).add(h), this.scrollGroup = a.g().add(this.contentGroup));
                this.renderTitle();
                r(e, (b, a)=>(b.options && b.options.legendIndex || 0) - (a.options && a.options.legendIndex || 0));
                c.reversed && e.reverse();
                this.allItems = e;
                this.display = m = !!e.length;
                this.itemHeight = this.totalItemWidth = this.maxItemWidth = this.lastLineHeight = 0;
                e.forEach(this.renderItem, this);
                e.forEach(this.layoutItem, this);
                e = (this.widthOption || this.offsetWidth) + d;
                g = this.lastItemY + this.lastLineHeight + this.titleHeight;
                g = this.handleOverflow(g);
                g += d;
                l || (this.box = l = a.rect().addClass("highcharts-legend-box").attr({
                    r: c.borderRadius
                }).add(h));
                b.styledMode || l.attr({
                    stroke: c.borderColor,
                    "stroke-width": c.borderWidth || 0,
                    fill: c.backgroundColor || "none"
                }).shadow(c.shadow);
                if (0 < e && 0 < g) l[l.placed ? "animate" : "attr"](l.crisp.call({}, {
                    x: 0,
                    y: 0,
                    width: e,
                    height: g
                }, l.strokeWidth()));
                h[m ? "show" : "hide"]();
                b.styledMode && "none" === h.getStyle("display") && (e = g = 0);
                this.legendWidth = e;
                this.legendHeight = g;
                m && this.align();
                this.proximate || this.positionItems();
                w(this, "afterRender");
            }
            align(b = this.chart.spacingBox) {
                const a = this.chart, c = this.options;
                let d = b.y;
                /(lth|ct|rth)/.test(this.getAlignment()) && 0 < a.titleOffset[0] ? d += a.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && 0 < a.titleOffset[2] && (d -= a.titleOffset[2]);
                d !== b.y && (b = F(b, {
                    y: d
                }));
                a.hasRendered || (this.group.placed = !1);
                this.group.align(F(c, {
                    width: this.legendWidth,
                    height: this.legendHeight,
                    verticalAlign: this.proximate ? "top" : c.verticalAlign
                }), !0, b);
            }
            handleOverflow(b) {
                const a = this, c = this.chart, e = c.renderer, g = this.options;
                var k = g.y;
                const h = "top" === g.verticalAlign, l = this.padding, m = g.maxHeight, q = g.navigation, r = d(q.animation, !0), p = q.arrowSize || 12, t = this.pages, w = this.allItems, v = function(b) {
                    "number" === typeof b ? E.attr({
                        height: b
                    }) : E && (a.clipRect = E.destroy(), a.contentGroup.clip());
                    a.contentGroup.div && (a.contentGroup.div.style.clip = b ? "rect(" + l + "px,9999px," + (l + b) + "px,0)" : "auto");
                }, u = function(b) {
                    a[b] = e.circle(0, 0, 1.3 * p).translate(p / 2, p / 2).add(O);
                    c.styledMode || a[b].attr("fill", "rgba(0,0,0,0.0001)");
                    return a[b];
                };
                let x, J, N;
                k = c.spacingBox.height + (h ? -k : k) - l;
                let O = this.nav, E = this.clipRect;
                "horizontal" !== g.layout || "middle" === g.verticalAlign || g.floating || (k /= 2);
                m && (k = Math.min(k, m));
                t.length = 0;
                b && 0 < k && b > k && !1 !== q.enabled ? (this.clipHeight = x = Math.max(k - 20 - this.titleHeight - l, 0), this.currentPage = d(this.currentPage, 1), this.fullHeight = b, w.forEach((b, a)=>{
                    N = b.legendItem || {};
                    b = N.y || 0;
                    const c = Math.round(N.label.getBBox().height);
                    let d = t.length;
                    if (!d || b - t[d - 1] > x && (J || b) !== t[d - 1]) t.push(J || b), d++;
                    N.pageIx = d - 1;
                    J && ((w[a - 1].legendItem || {}).pageIx = d - 1);
                    a === w.length - 1 && b + c - t[d - 1] > x && b > t[d - 1] && (t.push(b), N.pageIx = d);
                    b !== J && (J = b);
                }), E || (E = a.clipRect = e.clipRect(0, l - 2, 9999, 0), a.contentGroup.clip(E)), v(x), O || (this.nav = O = e.g().attr({
                    zIndex: 1
                }).add(this.group), this.up = e.symbol("triangle", 0, 0, p, p).add(O), u("upTracker").on("click", function() {
                    a.scroll(-1, r);
                }), this.pager = e.text("", 15, 10).addClass("highcharts-legend-navigation"), !c.styledMode && q.style && this.pager.css(q.style), this.pager.add(O), this.down = e.symbol("triangle-down", 0, 0, p, p).add(O), u("downTracker").on("click", function() {
                    a.scroll(1, r);
                })), a.scroll(0), b = k) : O && (v(), this.nav = O.destroy(), this.scrollGroup.attr({
                    translateY: 1
                }), this.clipHeight = 0);
                return b;
            }
            scroll(b, a) {
                const c = this.chart, f = this.pages, e = f.length, g = this.clipHeight, k = this.options.navigation, h = this.pager, l = this.padding;
                let m = this.currentPage + b;
                m > e && (m = e);
                0 < m && ("undefined" !== typeof a && B(a, c), this.nav.attr({
                    translateX: l,
                    translateY: g + this.padding + 7 + this.titleHeight,
                    visibility: "inherit"
                }), [
                    this.up,
                    this.upTracker
                ].forEach(function(b) {
                    b.attr({
                        "class": 1 === m ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }), h.attr({
                    text: m + "/" + e
                }), [
                    this.down,
                    this.downTracker
                ].forEach(function(b) {
                    b.attr({
                        x: 18 + this.pager.getBBox().width,
                        "class": m === e ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }, this), c.styledMode || (this.up.attr({
                    fill: 1 === m ? k.inactiveColor : k.activeColor
                }), this.upTracker.css({
                    cursor: 1 === m ? "default" : "pointer"
                }), this.down.attr({
                    fill: m === e ? k.inactiveColor : k.activeColor
                }), this.downTracker.css({
                    cursor: m === e ? "default" : "pointer"
                })), this.scrollOffset = -f[m - 1] + this.initialItemY, this.scrollGroup.animate({
                    translateY: this.scrollOffset
                }), this.currentPage = m, this.positionCheckboxes(), b = x(d(a, c.renderer.globalAnimation, !0)), q(()=>{
                    w(this, "afterScroll", {
                        currentPage: m
                    });
                }, b.duration));
            }
            setItemEvents(b, a, c) {
                const d = this, f = b.legendItem || {}, e = d.chart.renderer.boxWrapper, g = b instanceof L, k = "highcharts-legend-" + (g ? "point" : "series") + "-active", h = d.chart.styledMode;
                c = c ? [
                    a,
                    f.symbol
                ] : [
                    f.group
                ];
                const l = (a)=>{
                    d.allItems.forEach((c)=>{
                        b !== c && [
                            c
                        ].concat(c.linkedSeries || []).forEach((b)=>{
                            b.setState(a, !g);
                        });
                    });
                };
                for (const f of c)if (f) f.on("mouseover", function() {
                    b.visible && l("inactive");
                    b.setState("hover");
                    b.visible && e.addClass(k);
                    h || a.css(d.options.itemHoverStyle);
                }).on("mouseout", function() {
                    d.chart.styledMode || a.css(F(b.visible ? d.itemStyle : d.itemHiddenStyle));
                    l("");
                    e.removeClass(k);
                    b.setState();
                }).on("click", function(a) {
                    const c = function() {
                        b.setVisible && b.setVisible();
                        l(b.visible ? "inactive" : "");
                    };
                    e.removeClass(k);
                    a = {
                        browserEvent: a
                    };
                    b.firePointEvent ? b.firePointEvent("legendItemClick", a, c) : w(b, "legendItemClick", a, c);
                });
            }
            createCheckboxForItem(b) {
                b.checkbox = t("input", {
                    type: "checkbox",
                    className: "highcharts-legend-checkbox",
                    checked: b.selected,
                    defaultChecked: b.selected
                }, this.options.itemCheckboxStyle, this.chart.container);
                p(b.checkbox, "click", function(a) {
                    w(b.series || b, "checkboxClick", {
                        checked: a.target.checked,
                        item: b
                    }, function() {
                        b.select();
                    });
                });
            }
        }
        (function(b) {
            const a = [];
            b.compose = function(c) {
                z.pushUnique(a, c) && p(c, "beforeMargins", function() {
                    this.legend = new b(this, this.options.legend);
                });
            };
        })(G || (G = {}));
        "";
        return G;
    });
    M(a, "Core/Legend/LegendSymbol.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { extend: x, merge: I, pick: L } = a;
        var C;
        (function(a) {
            a.lineMarker = function(a, B) {
                B = this.legendItem = this.legendItem || {};
                var u = this.options;
                const v = a.symbolWidth, l = a.symbolHeight, p = l / 2, t = this.chart.renderer, m = B.group;
                a = a.baseline - Math.round(.3 * a.fontMetrics.b);
                let h = {}, g = u.marker, e = 0;
                this.chart.styledMode || (h = {
                    "stroke-width": Math.min(u.lineWidth || 0, 24)
                }, u.dashStyle ? h.dashstyle = u.dashStyle : "square" !== u.linecap && (h["stroke-linecap"] = "round"));
                B.line = t.path().addClass("highcharts-graph").attr(h).add(m);
                h["stroke-linecap"] && (e = Math.min(B.line.strokeWidth(), v) / 2);
                v && B.line.attr({
                    d: [
                        [
                            "M",
                            e,
                            a
                        ],
                        [
                            "L",
                            v - e,
                            a
                        ]
                    ]
                });
                g && !1 !== g.enabled && v && (u = Math.min(L(g.radius, p), p), 0 === this.symbol.indexOf("url") && (g = I(g, {
                    width: l,
                    height: l
                }), u = 0), B.symbol = B = t.symbol(this.symbol, v / 2 - u, a - u, 2 * u, 2 * u, x({
                    context: "legend"
                }, g)).addClass("highcharts-point").add(m), B.isMarker = !0);
            };
            a.rectangle = function(a, x) {
                x = x.legendItem || {};
                const u = a.symbolHeight, v = a.options.squareSymbol;
                x.symbol = this.chart.renderer.rect(v ? (a.symbolWidth - u) / 2 : 0, a.baseline - u + 1, v ? u : a.symbolWidth, u, L(a.options.symbolRadius, u / 2)).addClass("highcharts-point").attr({
                    zIndex: 3
                }).add(x.group);
            };
        })(C || (C = {}));
        return C;
    });
    M(a, "Core/Series/SeriesDefaults.js", [], function() {
        return {
            lineWidth: 1,
            allowPointSelect: !1,
            crisp: !0,
            showCheckbox: !1,
            animation: {
                duration: 1E3
            },
            enableMouseTracking: !0,
            events: {},
            marker: {
                enabledThreshold: 2,
                lineColor: "#ffffff",
                lineWidth: 0,
                radius: 4,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 150
                        },
                        enabled: !0,
                        radiusPlus: 2,
                        lineWidthPlus: 1
                    },
                    select: {
                        fillColor: "#cccccc",
                        lineColor: "#000000",
                        lineWidth: 2
                    }
                }
            },
            point: {
                events: {}
            },
            dataLabels: {
                animation: {},
                align: "center",
                borderWidth: 0,
                defer: !0,
                formatter: function() {
                    const { numberFormatter: a } = this.series.chart;
                    return "number" !== typeof this.y ? "" : a(this.y, -1);
                },
                padding: 5,
                style: {
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    color: "contrast",
                    textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0
            },
            cropThreshold: 300,
            opacity: 1,
            pointRange: 0,
            softThreshold: !0,
            states: {
                normal: {
                    animation: !0
                },
                hover: {
                    animation: {
                        duration: 150
                    },
                    lineWidthPlus: 1,
                    marker: {},
                    halo: {
                        size: 10,
                        opacity: .25
                    }
                },
                select: {
                    animation: {
                        duration: 0
                    }
                },
                inactive: {
                    animation: {
                        duration: 150
                    },
                    opacity: .2
                }
            },
            stickyTracking: !0,
            turboThreshold: 1E3,
            findNearestPointBy: "x"
        };
    });
    M(a, "Core/Series/SeriesRegistry.js", [
        a["Core/Globals.js"],
        a["Core/Defaults.js"],
        a["Core/Series/Point.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L) {
        const { defaultOptions: x } = y, { extendClass: z, merge: H } = L;
        var B;
        (function(u) {
            function v(a, p) {
                const l = x.plotOptions || {}, m = p.defaultOptions, h = p.prototype;
                h.type = a;
                h.pointClass || (h.pointClass = I);
                m && (l[a] = m);
                u.seriesTypes[a] = p;
            }
            u.seriesTypes = a.seriesTypes;
            u.registerSeriesType = v;
            u.seriesType = function(a, p, t, m, h) {
                const g = x.plotOptions || {};
                p = p || "";
                g[a] = H(g[p], t);
                v(a, z(u.seriesTypes[p] || function() {}, m));
                u.seriesTypes[a].prototype.type = a;
                h && (u.seriesTypes[a].prototype.pointClass = z(I, h));
                return u.seriesTypes[a];
            };
        })(B || (B = {}));
        return B;
    });
    M(a, "Core/Series/Series.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Defaults.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Legend/LegendSymbol.js"],
        a["Core/Series/Point.js"],
        a["Core/Series/SeriesDefaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z, H, B, u, v) {
        const { animObject: l, setAnimation: p } = a, { defaultOptions: t } = y, { registerEventOptions: m } = I, { hasTouch: h, svg: g, win: e } = L, { seriesTypes: w } = B, { arrayMax: x, arrayMin: F, clamp: d, correctFloat: k, defined: r, diffObjects: q, erase: G, error: b, extend: f, find: c, fireEvent: n, getClosestDistance: P, getNestedProperty: D, insertItem: K, isArray: X, isNumber: T, isString: Z, merge: V, objectEach: Y, pick: A, removeEvent: M, splat: ia, syncTimeout: ba } = v;
        class aa {
            constructor(){
                this.zones = this.yAxis = this.xAxis = this.userOptions = this.tooltipOptions = this.processedYData = this.processedXData = this.points = this.options = this.linkedSeries = this.index = this.eventsToUnbind = this.eventOptions = this.data = this.chart = this._i = void 0;
            }
            init(b, a) {
                n(this, "init", {
                    options: a
                });
                const c = this, d = b.series;
                this.eventsToUnbind = [];
                c.chart = b;
                c.options = c.setOptions(a);
                a = c.options;
                c.linkedSeries = [];
                c.bindAxes();
                f(c, {
                    name: a.name,
                    state: "",
                    visible: !1 !== a.visible,
                    selected: !0 === a.selected
                });
                m(this, a);
                const e = a.events;
                if (e && e.click || a.point && a.point.events && a.point.events.click || a.allowPointSelect) b.runTrackerClick = !0;
                c.getColor();
                c.getSymbol();
                c.parallelArrays.forEach(function(b) {
                    c[b + "Data"] || (c[b + "Data"] = []);
                });
                c.isCartesian && (b.hasCartesianSeries = !0);
                let g;
                d.length && (g = d[d.length - 1]);
                c._i = A(g && g._i, -1) + 1;
                c.opacity = c.options.opacity;
                b.orderItems("series", K(this, d));
                a.dataSorting && a.dataSorting.enabled ? c.setDataSortingOptions() : c.points || c.data || c.setData(a.data, !1);
                n(this, "afterInit");
            }
            is(b) {
                return w[b] && this instanceof w[b];
            }
            bindAxes() {
                const a = this, c = a.options, d = a.chart;
                let f;
                n(this, "bindAxes", null, function() {
                    (a.axisTypes || []).forEach(function(e) {
                        d[e].forEach(function(b) {
                            f = b.options;
                            if (A(c[e], 0) === b.index || "undefined" !== typeof c[e] && c[e] === f.id) K(a, b.series), a[e] = b, b.isDirty = !0;
                        });
                        a[e] || a.optionalAxis === e || b(18, !0, d);
                    });
                });
                n(this, "afterBindAxes");
            }
            updateParallelArrays(b, a, c) {
                const d = b.series, f = T(a) ? function(c) {
                    const f = "y" === c && d.toYData ? d.toYData(b) : b[c];
                    d[c + "Data"][a] = f;
                } : function(b) {
                    Array.prototype[a].apply(d[b + "Data"], c);
                };
                d.parallelArrays.forEach(f);
            }
            hasData() {
                return this.visible && "undefined" !== typeof this.dataMax && "undefined" !== typeof this.dataMin || this.visible && this.yData && 0 < this.yData.length;
            }
            autoIncrement(b) {
                var a = this.options;
                const c = a.pointIntervalUnit, d = a.relativeXValue, f = this.chart.time;
                let e = this.xIncrement, g;
                e = A(e, a.pointStart, 0);
                this.pointInterval = g = A(this.pointInterval, a.pointInterval, 1);
                d && T(b) && (g *= b);
                c && (a = new f.Date(e), "day" === c ? f.set("Date", a, f.get("Date", a) + g) : "month" === c ? f.set("Month", a, f.get("Month", a) + g) : "year" === c && f.set("FullYear", a, f.get("FullYear", a) + g), g = a.getTime() - e);
                if (d && T(b)) return e + g;
                this.xIncrement = e + g;
                return e;
            }
            setDataSortingOptions() {
                const b = this.options;
                f(this, {
                    requireSorting: !1,
                    sorted: !1,
                    enabledDataSorting: !0,
                    allowDG: !1
                });
                r(b.pointRange) || (b.pointRange = 1);
            }
            setOptions(b) {
                var a, c;
                const d = this.chart;
                var f = d.options.plotOptions, e = d.userOptions || {};
                const g = V(b);
                b = d.styledMode;
                const k = {
                    plotOptions: f,
                    userOptions: g
                };
                n(this, "setOptions", k);
                const h = k.plotOptions[this.type];
                e = e.plotOptions || {};
                const l = e.series || {}, m = t.plotOptions[this.type] || {}, q = e[this.type] || {};
                this.userOptions = k.userOptions;
                f = V(h, f.series, q, g);
                this.tooltipOptions = V(t.tooltip, null === (a = t.plotOptions.series) || void 0 === a ? void 0 : a.tooltip, null === m || void 0 === m ? void 0 : m.tooltip, d.userOptions.tooltip, null === (c = e.series) || void 0 === c ? void 0 : c.tooltip, q.tooltip, g.tooltip);
                this.stickyTracking = A(g.stickyTracking, q.stickyTracking, l.stickyTracking, this.tooltipOptions.shared && !this.noSharedTooltip ? !0 : f.stickyTracking);
                null === h.marker && delete f.marker;
                this.zoneAxis = f.zoneAxis;
                c = this.zones = (f.zones || []).slice();
                !f.negativeColor && !f.negativeFillColor || f.zones || (a = {
                    value: f[this.zoneAxis + "Threshold"] || f.threshold || 0,
                    className: "highcharts-negative"
                }, b || (a.color = f.negativeColor, a.fillColor = f.negativeFillColor), c.push(a));
                c.length && r(c[c.length - 1].value) && c.push(b ? {} : {
                    color: this.color,
                    fillColor: this.fillColor
                });
                n(this, "afterSetOptions", {
                    options: f
                });
                return f;
            }
            getName() {
                return A(this.options.name, "Series " + (this.index + 1));
            }
            getCyclic(b, a, c) {
                const d = this.chart, f = `${b}Index`, e = `${b}Counter`, g = (null === c || void 0 === c ? void 0 : c.length) || d.options.chart.colorCount;
                if (!a) {
                    var k = A("color" === b ? this.options.colorIndex : void 0, this[f]);
                    r(k) || (d.series.length || (d[e] = 0), k = d[e] % g, d[e] += 1);
                    c && (a = c[k]);
                }
                "undefined" !== typeof k && (this[f] = k);
                this[b] = a;
            }
            getColor() {
                this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || t.plotOptions[this.type].color, this.chart.options.colors);
            }
            getPointsCollection() {
                return (this.hasGroupedData ? this.points : this.data) || [];
            }
            getSymbol() {
                this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
            }
            findPointIndex(b, a) {
                const d = b.id, f = b.x, e = this.points;
                var g = this.options.dataSorting, k;
                let h, n;
                if (d) g = this.chart.get(d), g instanceof z && (k = g);
                else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
                    if (k = (a)=>!a.touched && a.index === b.index, g && g.matchByName ? k = (a)=>!a.touched && a.name === b.name : this.options.relativeXValue && (k = (a)=>!a.touched && a.options.x === b.x), k = c(e, k), !k) return;
                }
                k && (n = k && k.index, "undefined" !== typeof n && (h = !0));
                "undefined" === typeof n && T(f) && (n = this.xData.indexOf(f, a));
                -1 !== n && "undefined" !== typeof n && this.cropped && (n = n >= this.cropStart ? n - this.cropStart : n);
                !h && T(n) && e[n] && e[n].touched && (n = void 0);
                return n;
            }
            updateData(b, a) {
                const c = this.options, d = c.dataSorting, f = this.points, e = [], g = this.requireSorting, k = b.length === f.length;
                let n, h, l, m = !0;
                this.xIncrement = null;
                b.forEach(function(b, a) {
                    var h = r(b) && this.pointClass.prototype.optionsToObject.call({
                        series: this
                    }, b) || {};
                    const m = h.x;
                    if (h.id || T(m)) {
                        if (h = this.findPointIndex(h, l), -1 === h || "undefined" === typeof h ? e.push(b) : f[h] && b !== c.data[h] ? (f[h].update(b, !1, null, !1), f[h].touched = !0, g && (l = h + 1)) : f[h] && (f[h].touched = !0), !k || a !== h || d && d.enabled || this.hasDerivedData) n = !0;
                    } else e.push(b);
                }, this);
                if (n) for(b = f.length; b--;)(h = f[b]) && !h.touched && h.remove && h.remove(!1, a);
                else !k || d && d.enabled ? m = !1 : (b.forEach(function(b, a) {
                    b === f[a].y || f[a].destroyed || f[a].update(b, !1, null, !1);
                }), e.length = 0);
                f.forEach(function(b) {
                    b && (b.touched = !1);
                });
                if (!m) return !1;
                e.forEach(function(b) {
                    this.addPoint(b, !1, null, null, !1);
                }, this);
                null === this.xIncrement && this.xData && this.xData.length && (this.xIncrement = x(this.xData), this.autoIncrement());
                return !0;
            }
            setData(a, c = !0, d, f) {
                var e;
                const g = this, k = g.points, h = k && k.length || 0, n = g.options, l = g.chart, m = n.dataSorting, q = g.xAxis, p = n.turboThreshold, r = this.xData, t = this.yData;
                var w = g.pointArrayMap;
                w = w && w.length;
                const J = n.keys;
                let v, u = 0, O = 1, x = null;
                if (!l.options.chart.allowMutatingData) {
                    n.data && delete g.options.data;
                    g.userOptions.data && delete g.userOptions.data;
                    var N = V(!0, a);
                }
                a = N || a || [];
                N = a.length;
                m && m.enabled && (a = this.sortData(a));
                l.options.chart.allowMutatingData && !1 !== f && N && h && !g.cropped && !g.hasGroupedData && g.visible && !g.boosted && (v = this.updateData(a, d));
                if (!v) {
                    g.xIncrement = null;
                    g.colorCounter = 0;
                    this.parallelArrays.forEach(function(b) {
                        g[b + "Data"].length = 0;
                    });
                    if (p && N > p) {
                        if (x = g.getFirstValidPoint(a), T(x)) for(d = 0; d < N; d++)r[d] = this.autoIncrement(), t[d] = a[d];
                        else if (X(x)) {
                            if (w) {
                                if (x.length === w) for(d = 0; d < N; d++)r[d] = this.autoIncrement(), t[d] = a[d];
                                else for(d = 0; d < N; d++)f = a[d], r[d] = f[0], t[d] = f.slice(1, w + 1);
                            } else if (J && (u = J.indexOf("x"), O = J.indexOf("y"), u = 0 <= u ? u : 0, O = 0 <= O ? O : 1), 1 === x.length && (O = 0), u === O) for(d = 0; d < N; d++)r[d] = this.autoIncrement(), t[d] = a[d][O];
                            else for(d = 0; d < N; d++)f = a[d], r[d] = f[u], t[d] = f[O];
                        } else b(12, !1, l);
                    } else for(d = 0; d < N; d++)f = {
                        series: g
                    }, g.pointClass.prototype.applyOptions.apply(f, [
                        a[d]
                    ]), g.updateParallelArrays(f, d);
                    t && Z(t[0]) && b(14, !0, l);
                    g.data = [];
                    g.options.data = g.userOptions.data = a;
                    for(d = h; d--;)null === (e = k[d]) || void 0 === e || e.destroy();
                    q && (q.minRange = q.userMinRange);
                    g.isDirty = l.isDirtyBox = !0;
                    g.isDirtyData = !!k;
                    d = !1;
                }
                "point" === n.legendType && (this.processData(), this.generatePoints());
                c && l.redraw(d);
            }
            sortData(b) {
                const a = this, c = a.options.dataSorting.sortKey || "y", d = function(b, a) {
                    return r(a) && b.pointClass.prototype.optionsToObject.call({
                        series: b
                    }, a) || {};
                };
                b.forEach(function(c, f) {
                    b[f] = d(a, c);
                    b[f].index = f;
                }, this);
                b.concat().sort((b, a)=>{
                    b = D(c, b);
                    a = D(c, a);
                    return a < b ? -1 : a > b ? 1 : 0;
                }).forEach(function(b, a) {
                    b.x = a;
                }, this);
                a.linkedSeries && a.linkedSeries.forEach(function(a) {
                    const c = a.options, f = c.data;
                    c.dataSorting && c.dataSorting.enabled || !f || (f.forEach(function(c, e) {
                        f[e] = d(a, c);
                        b[e] && (f[e].x = b[e].x, f[e].index = e);
                    }), a.setData(f, !1));
                });
                return b;
            }
            getProcessedData(a) {
                const c = this;
                var d = c.xAxis, f = c.options;
                const e = f.cropThreshold, g = a || c.getExtremesFromAll || f.getExtremesFromAll, k = null === d || void 0 === d ? void 0 : d.logarithmic, h = c.isCartesian;
                let n = 0;
                let l;
                a = c.xData;
                f = c.yData;
                let m = !1;
                const q = a.length;
                if (d) {
                    var r = d.getExtremes();
                    l = r.min;
                    r = r.max;
                    m = !(!d.categories || d.names.length);
                }
                if (h && c.sorted && !g && (!e || q > e || c.forceCrop)) {
                    if (a[q - 1] < l || a[0] > r) a = [], f = [];
                    else if (c.yData && (a[0] < l || a[q - 1] > r)) {
                        var p = this.cropData(c.xData, c.yData, l, r);
                        a = p.xData;
                        f = p.yData;
                        n = p.start;
                        p = !0;
                    }
                }
                d = P([
                    k ? a.map(k.log2lin) : a
                ], ()=>c.requireSorting && !m && b(15, !1, c.chart));
                return {
                    xData: a,
                    yData: f,
                    cropped: p,
                    cropStart: n,
                    closestPointRange: d
                };
            }
            processData(b) {
                const a = this.xAxis;
                if (this.isCartesian && !this.isDirty && !a.isDirty && !this.yAxis.isDirty && !b) return !1;
                b = this.getProcessedData();
                this.cropped = b.cropped;
                this.cropStart = b.cropStart;
                this.processedXData = b.xData;
                this.processedYData = b.yData;
                this.closestPointRange = this.basePointRange = b.closestPointRange;
                n(this, "afterProcessData");
            }
            cropData(b, a, c, d, f) {
                const e = b.length;
                let g, k = 0, h = e;
                f = A(f, this.cropShoulder);
                for(g = 0; g < e; g++)if (b[g] >= c) {
                    k = Math.max(0, g - f);
                    break;
                }
                for(c = g; c < e; c++)if (b[c] > d) {
                    h = c + f;
                    break;
                }
                return {
                    xData: b.slice(k, h),
                    yData: a.slice(k, h),
                    start: k,
                    end: h
                };
            }
            generatePoints() {
                var b = this.options;
                const a = this.processedData || b.data, c = this.processedXData, d = this.processedYData, e = this.pointClass, g = c.length, k = this.cropStart || 0, h = this.hasGroupedData, l = b.keys, m = [];
                b = b.dataGrouping && b.dataGrouping.groupAll ? k : 0;
                let q;
                let r, p, t = this.data;
                if (!t && !h) {
                    var w = [];
                    w.length = a.length;
                    t = this.data = w;
                }
                l && h && (this.options.keys = !1);
                for(p = 0; p < g; p++)w = k + p, h ? (r = (new e).init(this, [
                    c[p]
                ].concat(ia(d[p]))), r.dataGroup = this.groupMap[b + p], r.dataGroup.options && (r.options = r.dataGroup.options, f(r, r.dataGroup.options), delete r.dataLabels)) : (r = t[w]) || "undefined" === typeof a[w] || (t[w] = r = (new e).init(this, a[w], c[p])), r && (r.index = h ? b + p : w, m[p] = r);
                this.options.keys = l;
                if (t && (g !== (q = t.length) || h)) for(p = 0; p < q; p++)p !== k || h || (p += g), t[p] && (t[p].destroyElements(), t[p].plotX = void 0);
                this.data = t;
                this.points = m;
                n(this, "afterGeneratePoints");
            }
            getXExtremes(b) {
                return {
                    min: F(b),
                    max: x(b)
                };
            }
            getExtremes(b, a) {
                const c = this.xAxis;
                var d = this.yAxis;
                const f = this.processedXData || this.xData, e = [], g = this.requireSorting ? this.cropShoulder : 0;
                d = d ? d.positiveValuesOnly : !1;
                let k, h = 0, l = 0, m = 0;
                b = b || this.stackedYData || this.processedYData || [];
                const q = b.length;
                if (c) {
                    var p = c.getExtremes();
                    h = p.min;
                    l = p.max;
                }
                for(k = 0; k < q; k++){
                    var r = f[k];
                    p = b[k];
                    var t = (T(p) || X(p)) && (p.length || 0 < p || !d);
                    r = a || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !c || (f[k + g] || r) >= h && (f[k - g] || r) <= l;
                    if (t && r) {
                        if (t = p.length) for(; t--;)T(p[t]) && (e[m++] = p[t]);
                        else e[m++] = p;
                    }
                }
                b = {
                    activeYData: e,
                    dataMin: F(e),
                    dataMax: x(e)
                };
                n(this, "afterGetExtremes", {
                    dataExtremes: b
                });
                return b;
            }
            applyExtremes() {
                const b = this.getExtremes();
                this.dataMin = b.dataMin;
                this.dataMax = b.dataMax;
                return b;
            }
            getFirstValidPoint(b) {
                const a = b.length;
                let c = 0, d = null;
                for(; null === d && c < a;)d = b[c], c++;
                return d;
            }
            translate() {
                var b;
                this.processedXData || this.processData();
                this.generatePoints();
                var a = this.options;
                const c = a.stacking, f = this.xAxis, e = f.categories, g = this.enabledDataSorting, h = this.yAxis, l = this.points, m = l.length, q = this.pointPlacementToXValue(), p = !!q, t = a.threshold;
                a = a.startFromThreshold ? t : 0;
                let w, v, u, x, D = Number.MAX_VALUE;
                for(w = 0; w < m; w++){
                    const n = l[w], m = n.x;
                    let J, Q, R = n.y, O = n.low;
                    const E = c && (null === (b = h.stacking) || void 0 === b ? void 0 : b.stacks[(this.negStacks && R < (a ? 0 : t) ? "-" : "") + this.stackKey]);
                    v = f.translate(m, !1, !1, !1, !0, q);
                    n.plotX = T(v) ? k(d(v, -100000, 1E5)) : void 0;
                    c && this.visible && E && E[m] && (x = this.getStackIndicator(x, m, this.index), !n.isNull && x.key && (J = E[m], Q = J.points[x.key]), J && X(Q) && (O = Q[0], R = Q[1], O === a && x.key === E[m].base && (O = A(T(t) ? t : h.min)), h.positiveValuesOnly && r(O) && 0 >= O && (O = void 0), n.total = n.stackTotal = A(J.total), n.percentage = r(n.y) && J.total ? n.y / J.total * 100 : void 0, n.stackY = R, this.irregularWidths || J.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis)));
                    n.yBottom = r(O) ? d(h.translate(O, !1, !0, !1, !0), -100000, 1E5) : void 0;
                    this.dataModify && (R = this.dataModify.modifyValue(R, w));
                    let N;
                    T(R) && void 0 !== n.plotX && (N = h.translate(R, !1, !0, !1, !0), N = T(N) ? d(N, -100000, 1E5) : void 0);
                    n.plotY = N;
                    n.isInside = this.isPointInside(n);
                    n.clientX = p ? k(f.translate(m, !1, !1, !1, !0, q)) : v;
                    n.negative = (n.y || 0) < (t || 0);
                    n.category = A(e && e[n.x], n.x);
                    n.isNull || !1 === n.visible || ("undefined" !== typeof u && (D = Math.min(D, Math.abs(v - u))), u = v);
                    n.zone = this.zones.length ? n.getZone() : void 0;
                    !n.graphic && this.group && g && (n.isNew = !0);
                }
                this.closestPointRangePx = D;
                n(this, "afterTranslate");
            }
            getValidPoints(b, a, c) {
                const d = this.chart;
                return (b || this.points || []).filter(function(b) {
                    const { plotX: f, plotY: e } = b;
                    return !c && (b.isNull || !T(e)) || a && !d.isInsidePlot(f, e, {
                        inverted: d.inverted
                    }) ? !1 : !1 !== b.visible;
                });
            }
            getClipBox() {
                const { chart: b, xAxis: a, yAxis: c } = this, d = V(b.clipBox);
                a && a.len !== b.plotSizeX && (d.width = a.len);
                c && c.len !== b.plotSizeY && (d.height = c.len);
                return d;
            }
            getSharedClipKey() {
                return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0);
            }
            setClip() {
                const { chart: b, group: a, markerGroup: c } = this, d = b.sharedClips, f = b.renderer, e = this.getClipBox(), g = this.getSharedClipKey();
                let k = d[g];
                k ? k.animate(e) : d[g] = k = f.clipRect(e);
                a && a.clip(!1 === this.options.clip ? void 0 : k);
                c && c.clip();
            }
            animate(b) {
                const { chart: a, group: c, markerGroup: d } = this, f = a.inverted;
                var e = l(this.options.animation), g = [
                    this.getSharedClipKey(),
                    e.duration,
                    e.easing,
                    e.defer
                ].join();
                let k = a.sharedClips[g], n = a.sharedClips[g + "m"];
                if (b && c) e = this.getClipBox(), k ? k.attr("height", e.height) : (e.width = 0, f && (e.x = a.plotHeight), k = a.renderer.clipRect(e), a.sharedClips[g] = k, n = a.renderer.clipRect({
                    x: -99,
                    y: -99,
                    width: f ? a.plotWidth + 199 : 99,
                    height: f ? 99 : a.plotHeight + 199
                }), a.sharedClips[g + "m"] = n), c.clip(k), d && d.clip(n);
                else if (k && !k.hasClass("highcharts-animating")) {
                    g = this.getClipBox();
                    const b = e.step;
                    d && d.element.childNodes.length && (e.step = function(a, c) {
                        b && b.apply(c, arguments);
                        "width" === c.prop && n && n.element && n.attr(f ? "height" : "width", a + 99);
                    });
                    k.addClass("highcharts-animating").animate(g, e);
                }
            }
            afterAnimate() {
                this.setClip();
                Y(this.chart.sharedClips, (b, a, c)=>{
                    b && !this.chart.container.querySelector(`[clip-path="url(#${b.id})"]`) && (b.destroy(), delete c[a]);
                });
                this.finishedAnimating = !0;
                n(this, "afterAnimate");
            }
            drawPoints(b = this.points) {
                const a = this.chart, c = a.styledMode, { colorAxis: d, options: f } = this, e = f.marker, g = this[this.specialGroup || "markerGroup"], k = this.xAxis, n = A(e.enabled, !k || k.isRadial ? !0 : null, this.closestPointRangePx >= e.enabledThreshold * e.radius);
                let h, l, m, q;
                let p, r;
                if (!1 !== e.enabled || this._hasPointMarkers) for(h = 0; h < b.length; h++){
                    l = b[h];
                    q = (m = l.graphic) ? "animate" : "attr";
                    var t = l.marker || {};
                    p = !!l.marker;
                    if ((n && "undefined" === typeof t.enabled || t.enabled) && !l.isNull && !1 !== l.visible) {
                        const b = A(t.symbol, this.symbol, "rect");
                        r = this.markerAttribs(l, l.selected && "select");
                        this.enabledDataSorting && (l.startXPos = k.reversed ? -(r.width || 0) : k.width);
                        const f = !1 !== l.isInside;
                        !m && f && (0 < (r.width || 0) || l.hasImage) && (l.graphic = m = a.renderer.symbol(b, r.x, r.y, r.width, r.height, p ? t : e).add(g), this.enabledDataSorting && a.hasRendered && (m.attr({
                            x: l.startXPos
                        }), q = "animate"));
                        m && "animate" === q && m[f ? "show" : "hide"](f).animate(r);
                        if (m) {
                            if (t = this.pointAttribs(l, c || !l.selected ? void 0 : "select"), c) d && m.css({
                                fill: t.fill
                            });
                            else m[q](t);
                        }
                        m && m.addClass(l.getClassName(), !0);
                    } else m && (l.graphic = m.destroy());
                }
            }
            markerAttribs(b, a) {
                const c = this.options;
                var d = c.marker;
                const f = b.marker || {}, e = f.symbol || d.symbol, g = {};
                let k = A(f.radius, d && d.radius);
                a && (d = d.states[a], a = f.states && f.states[a], k = A(a && a.radius, d && d.radius, k && k + (d && d.radiusPlus || 0)));
                b.hasImage = e && 0 === e.indexOf("url");
                b.hasImage && (k = 0);
                b = b.pos();
                T(k) && b && (g.x = b[0] - k, g.y = b[1] - k, c.crisp && (g.x = Math.floor(g.x)));
                k && (g.width = g.height = 2 * k);
                return g;
            }
            pointAttribs(b, a) {
                var c = this.options.marker, d = b && b.options;
                const f = d && d.marker || {};
                var e = d && d.color, g = b && b.color;
                const k = b && b.zone && b.zone.color;
                let n = this.color;
                b = A(f.lineWidth, c.lineWidth);
                d = 1;
                n = e || k || g || n;
                e = f.fillColor || c.fillColor || n;
                g = f.lineColor || c.lineColor || n;
                a = a || "normal";
                c = c.states[a] || {};
                a = f.states && f.states[a] || {};
                b = A(a.lineWidth, c.lineWidth, b + A(a.lineWidthPlus, c.lineWidthPlus, 0));
                e = a.fillColor || c.fillColor || e;
                g = a.lineColor || c.lineColor || g;
                d = A(a.opacity, c.opacity, d);
                return {
                    stroke: g,
                    "stroke-width": b,
                    fill: e,
                    opacity: d
                };
            }
            destroy(b) {
                const a = this, c = a.chart, d = /AppleWebKit\/533/.test(e.navigator.userAgent), f = a.data || [];
                let g, k, h, l;
                n(a, "destroy", {
                    keepEventsForUpdate: b
                });
                this.removeEvents(b);
                (a.axisTypes || []).forEach(function(b) {
                    (l = a[b]) && l.series && (G(l.series, a), l.isDirty = l.forceRedraw = !0);
                });
                a.legendItem && a.chart.legend.destroyItem(a);
                for(k = f.length; k--;)(h = f[k]) && h.destroy && h.destroy();
                a.clips && a.clips.forEach((b)=>b.destroy());
                v.clearTimeout(a.animationTimeout);
                Y(a, function(b, a) {
                    b instanceof u && !b.survive && (g = d && "group" === a ? "hide" : "destroy", b[g]());
                });
                c.hoverSeries === a && (c.hoverSeries = void 0);
                G(c.series, a);
                c.orderItems("series");
                Y(a, function(c, d) {
                    b && "hcEvents" === d || delete a[d];
                });
            }
            applyZones() {
                const b = this, a = this.chart, c = a.renderer, f = this.zones, e = this.clips || [], g = this.graph, k = this.area, n = Math.max(a.plotWidth, a.plotHeight), h = this[(this.zoneAxis || "y") + "Axis"], l = a.inverted;
                let m, q, p, r, t, w, v, u, x, D, E, G = !1;
                f.length && (g || k) && h && "undefined" !== typeof h.min ? (t = h.reversed, w = h.horiz, g && !this.showLine && g.hide(), k && k.hide(), r = h.getExtremes(), f.forEach(function(f, Q) {
                    m = t ? w ? a.plotWidth : 0 : w ? 0 : h.toPixels(r.min) || 0;
                    m = d(A(q, m), 0, n);
                    q = d(Math.round(h.toPixels(A(f.value, r.max), !0) || 0), 0, n);
                    G && (m = q = h.toPixels(r.max));
                    v = Math.abs(m - q);
                    u = Math.min(m, q);
                    x = Math.max(m, q);
                    h.isXAxis ? (p = {
                        x: l ? x : u,
                        y: 0,
                        width: v,
                        height: n
                    }, w || (p.x = a.plotHeight - p.x)) : (p = {
                        x: 0,
                        y: l ? x : u,
                        width: n,
                        height: v
                    }, w && (p.y = a.plotWidth - p.y));
                    e[Q] ? e[Q].animate(p) : e[Q] = c.clipRect(p);
                    D = b["zone-area-" + Q];
                    E = b["zone-graph-" + Q];
                    g && E && E.clip(e[Q]);
                    k && D && D.clip(e[Q]);
                    G = f.value > r.max;
                    b.resetZones && 0 === q && (q = void 0);
                }), this.clips = e) : b.visible && (g && g.show(), k && k.show());
            }
            plotGroup(b, a, c, d, f) {
                let e = this[b];
                const g = !e;
                c = {
                    visibility: c,
                    zIndex: d || .1
                };
                "undefined" === typeof this.opacity || this.chart.styledMode || "inactive" === this.state || (c.opacity = this.opacity);
                g && (this[b] = e = this.chart.renderer.g().add(f));
                e.addClass("highcharts-" + a + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (r(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (e.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0);
                e.attr(c)[g ? "attr" : "animate"](this.getPlotBox(a));
                return e;
            }
            getPlotBox(b) {
                let a = this.xAxis, c = this.yAxis;
                const d = this.chart;
                b = d.inverted && !d.polar && a && !1 !== this.invertible && "series" === b;
                d.inverted && (a = c, c = this.xAxis);
                return {
                    translateX: a ? a.left : d.plotLeft,
                    translateY: c ? c.top : d.plotTop,
                    rotation: b ? 90 : 0,
                    rotationOriginX: b ? (a.len - c.len) / 2 : 0,
                    rotationOriginY: b ? (a.len + c.len) / 2 : 0,
                    scaleX: b ? -1 : 1,
                    scaleY: 1
                };
            }
            removeEvents(b) {
                b || M(this);
                this.eventsToUnbind.length && (this.eventsToUnbind.forEach(function(b) {
                    b();
                }), this.eventsToUnbind.length = 0);
            }
            render() {
                const b = this;
                var a = b.chart;
                const c = b.options, d = l(c.animation), f = b.visible ? "inherit" : "hidden", e = c.zIndex, g = b.hasRendered;
                a = a.seriesGroup;
                let k = b.finishedAnimating ? 0 : d.duration;
                n(this, "render");
                b.plotGroup("group", "series", f, e, a);
                b.markerGroup = b.plotGroup("markerGroup", "markers", f, e, a);
                !1 !== c.clip && b.setClip();
                b.animate && k && b.animate(!0);
                b.drawGraph && (b.drawGraph(), b.applyZones());
                b.visible && b.drawPoints();
                b.drawDataLabels && b.drawDataLabels();
                b.redrawPoints && b.redrawPoints();
                b.drawTracker && c.enableMouseTracking && b.drawTracker();
                b.animate && k && b.animate();
                g || (k && d.defer && (k += d.defer), b.animationTimeout = ba(function() {
                    b.afterAnimate();
                }, k || 0));
                b.isDirty = !1;
                b.hasRendered = !0;
                n(b, "afterRender");
            }
            redraw() {
                const b = this.isDirty || this.isDirtyData;
                this.translate();
                this.render();
                b && delete this.kdTree;
            }
            searchPoint(b, a) {
                const c = this.xAxis, d = this.yAxis, f = this.chart.inverted;
                return this.searchKDTree({
                    clientX: f ? c.len - b.chartY + c.pos : b.chartX - c.pos,
                    plotY: f ? d.len - b.chartX + d.pos : b.chartY - d.pos
                }, a, b);
            }
            buildKDTree(b) {
                function a(b, d, f) {
                    var e = b && b.length;
                    let g;
                    if (e) return g = c.kdAxisArray[d % f], b.sort(function(b, a) {
                        return b[g] - a[g];
                    }), e = Math.floor(e / 2), {
                        point: b[e],
                        left: a(b.slice(0, e), d + 1, f),
                        right: a(b.slice(e + 1), d + 1, f)
                    };
                }
                this.buildingKdTree = !0;
                const c = this, d = -1 < c.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                delete c.kdTree;
                ba(function() {
                    c.kdTree = a(c.getValidPoints(null, !c.directTouch), d, d);
                    c.buildingKdTree = !1;
                }, c.options.kdNow || b && "touchstart" === b.type ? 0 : 1);
            }
            searchKDTree(b, a, c) {
                function d(b, a, c, n) {
                    const h = a.point;
                    var l = f.kdAxisArray[c % n];
                    let m = h;
                    var q = r(b[e]) && r(h[e]) ? Math.pow(b[e] - h[e], 2) : null;
                    var p = r(b[g]) && r(h[g]) ? Math.pow(b[g] - h[g], 2) : null;
                    p = (q || 0) + (p || 0);
                    h.dist = r(p) ? Math.sqrt(p) : Number.MAX_VALUE;
                    h.distX = r(q) ? Math.sqrt(q) : Number.MAX_VALUE;
                    l = b[l] - h[l];
                    p = 0 > l ? "left" : "right";
                    q = 0 > l ? "right" : "left";
                    a[p] && (p = d(b, a[p], c + 1, n), m = p[k] < m[k] ? p : h);
                    a[q] && Math.sqrt(l * l) < m[k] && (b = d(b, a[q], c + 1, n), m = b[k] < m[k] ? b : m);
                    return m;
                }
                const f = this, e = this.kdAxisArray[0], g = this.kdAxisArray[1], k = a ? "distX" : "dist";
                a = -1 < f.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                this.kdTree || this.buildingKdTree || this.buildKDTree(c);
                if (this.kdTree) return d(b, this.kdTree, a, a);
            }
            pointPlacementToXValue() {
                const { options: { pointPlacement: b, pointRange: a }, xAxis: c } = this;
                let d = b;
                "between" === d && (d = c.reversed ? -0.5 : .5);
                return T(d) ? d * (a || c.pointRange) : 0;
            }
            isPointInside(b) {
                const { chart: a, xAxis: c, yAxis: d } = this;
                return "undefined" !== typeof b.plotY && "undefined" !== typeof b.plotX && 0 <= b.plotY && b.plotY <= (d ? d.len : a.plotHeight) && 0 <= b.plotX && b.plotX <= (c ? c.len : a.plotWidth);
            }
            drawTracker() {
                const b = this, a = b.options, c = a.trackByArea, d = [].concat(c ? b.areaPath : b.graphPath), f = b.chart, e = f.pointer, k = f.renderer, l = f.options.tooltip.snap, m = b.tracker, q = function(c) {
                    if (a.enableMouseTracking && f.hoverSeries !== b) b.onMouseOver();
                }, p = "rgba(192,192,192," + (g ? .0001 : .002) + ")";
                m ? m.attr({
                    d: d
                }) : b.graph && (b.tracker = k.path(d).attr({
                    visibility: b.visible ? "inherit" : "hidden",
                    zIndex: 2
                }).addClass(c ? "highcharts-tracker-area" : "highcharts-tracker-line").add(b.group), f.styledMode || b.tracker.attr({
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    stroke: p,
                    fill: c ? p : "none",
                    "stroke-width": b.graph.strokeWidth() + (c ? 0 : 2 * l)
                }), [
                    b.tracker,
                    b.markerGroup,
                    b.dataLabelsGroup
                ].forEach(function(b) {
                    if (b && (b.addClass("highcharts-tracker").on("mouseover", q).on("mouseout", function(b) {
                        e.onTrackerMouseOut(b);
                    }), a.cursor && !f.styledMode && b.css({
                        cursor: a.cursor
                    }), h)) b.on("touchstart", q);
                }));
                n(this, "afterDrawTracker");
            }
            addPoint(b, a, c, d, f) {
                const e = this.options, g = this.data, k = this.chart;
                var h = this.xAxis;
                h = h && h.hasNames && h.names;
                const l = e.data, m = this.xData;
                let q, p;
                a = A(a, !0);
                const r = {
                    series: this
                };
                this.pointClass.prototype.applyOptions.apply(r, [
                    b
                ]);
                const t = r.x;
                p = m.length;
                if (this.requireSorting && t < m[p - 1]) for(q = !0; p && m[p - 1] > t;)p--;
                this.updateParallelArrays(r, "splice", [
                    p,
                    0,
                    0
                ]);
                this.updateParallelArrays(r, p);
                h && r.name && (h[t] = r.name);
                l.splice(p, 0, b);
                if (q || this.processedData) this.data.splice(p, 0, null), this.processData();
                "point" === e.legendType && this.generatePoints();
                c && (g[0] && g[0].remove ? g[0].remove(!1) : (g.shift(), this.updateParallelArrays(r, "shift"), l.shift()));
                !1 !== f && n(this, "addPoint", {
                    point: r
                });
                this.isDirtyData = this.isDirty = !0;
                a && k.redraw(d);
            }
            removePoint(b, a, c) {
                const d = this, f = d.data, e = f[b], g = d.points, k = d.chart, h = function() {
                    g && g.length === f.length && g.splice(b, 1);
                    f.splice(b, 1);
                    d.options.data.splice(b, 1);
                    d.updateParallelArrays(e || {
                        series: d
                    }, "splice", [
                        b,
                        1
                    ]);
                    e && e.destroy();
                    d.isDirty = !0;
                    d.isDirtyData = !0;
                    a && k.redraw();
                };
                p(c, k);
                a = A(a, !0);
                e ? e.firePointEvent("remove", null, h) : h();
            }
            remove(b, a, c, d) {
                function f() {
                    e.destroy(d);
                    g.isDirtyLegend = g.isDirtyBox = !0;
                    g.linkSeries(d);
                    A(b, !0) && g.redraw(a);
                }
                const e = this, g = e.chart;
                !1 !== c ? n(e, "remove", null, f) : f();
            }
            update(a, c) {
                a = q(a, this.userOptions);
                n(this, "update", {
                    options: a
                });
                const d = this, e = d.chart;
                var g = d.userOptions;
                const k = d.initialType || d.type;
                var h = e.options.plotOptions;
                const l = w[k].prototype;
                var m = d.finishedAnimating && {
                    animation: !1
                };
                const p = {};
                let r, t = [
                    "colorIndex",
                    "eventOptions",
                    "navigatorSeries",
                    "symbolIndex",
                    "baseSeries"
                ], v = a.type || g.type || e.options.chart.type;
                const u = !(this.hasDerivedData || v && v !== this.type || "undefined" !== typeof a.pointStart || "undefined" !== typeof a.pointInterval || "undefined" !== typeof a.relativeXValue || a.joinBy || a.mapData || d.hasOptionChanged("dataGrouping") || d.hasOptionChanged("pointStart") || d.hasOptionChanged("pointInterval") || d.hasOptionChanged("pointIntervalUnit") || d.hasOptionChanged("keys"));
                v = v || k;
                u && (t.push("data", "isDirtyData", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "_hasPointLabels", "clips", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX"), !1 !== a.visible && t.push("area", "graph"), d.parallelArrays.forEach(function(b) {
                    t.push(b + "Data");
                }), a.data && (a.dataSorting && f(d.options.dataSorting, a.dataSorting), this.setData(a.data, !1)));
                a = V(g, m, {
                    index: "undefined" === typeof g.index ? d.index : g.index,
                    pointStart: A(h && h.series && h.series.pointStart, g.pointStart, d.xData[0])
                }, !u && {
                    data: d.options.data
                }, a);
                u && a.data && (a.data = d.options.data);
                t = [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup",
                    "transformGroup"
                ].concat(t);
                t.forEach(function(b) {
                    t[b] = d[b];
                    delete d[b];
                });
                h = !1;
                if (w[v]) {
                    if (h = v !== d.type, d.remove(!1, !1, !1, !0), h) {
                        if (Object.setPrototypeOf) Object.setPrototypeOf(d, w[v].prototype);
                        else {
                            m = Object.hasOwnProperty.call(d, "hcEvents") && d.hcEvents;
                            for(r in l)d[r] = void 0;
                            f(d, w[v].prototype);
                            m ? d.hcEvents = m : delete d.hcEvents;
                        }
                    }
                } else b(17, !0, e, {
                    missingModuleFor: v
                });
                t.forEach(function(b) {
                    d[b] = t[b];
                });
                d.init(e, a);
                if (u && this.points) {
                    a = d.options;
                    if (!1 === a.visible) p.graphic = 1, p.dataLabel = 1;
                    else if (!d._hasPointLabels) {
                        const { marker: b, dataLabels: c } = a;
                        g = g.marker || {};
                        !b || !1 !== b.enabled && g.symbol === b.symbol && g.height === b.height && g.width === b.width || (p.graphic = 1);
                        c && !1 === c.enabled && (p.dataLabel = 1);
                    }
                    for (const b of this.points)b && b.series && (b.resolveColor(), Object.keys(p).length && b.destroyElements(p), !1 === a.showInLegend && b.legendItem && e.legend.destroyItem(b));
                }
                d.initialType = k;
                e.linkSeries();
                h && d.linkedSeries.length && (d.isDirtyData = !0);
                n(this, "afterUpdate");
                A(c, !0) && e.redraw(u ? void 0 : !1);
            }
            setName(b) {
                this.name = this.options.name = this.userOptions.name = b;
                this.chart.isDirtyLegend = !0;
            }
            hasOptionChanged(b) {
                const a = this.options[b], c = this.chart.options.plotOptions, d = this.userOptions[b];
                return d ? a !== d : a !== A(c && c[this.type] && c[this.type][b], c && c.series && c.series[b], a);
            }
            onMouseOver() {
                const b = this.chart, a = b.hoverSeries;
                b.pointer.setHoverChartIndex();
                if (a && a !== this) a.onMouseOut();
                this.options.events.mouseOver && n(this, "mouseOver");
                this.setState("hover");
                b.hoverSeries = this;
            }
            onMouseOut() {
                const b = this.options, a = this.chart, c = a.tooltip, d = a.hoverPoint;
                a.hoverSeries = null;
                if (d) d.onMouseOut();
                this && b.events.mouseOut && n(this, "mouseOut");
                !c || this.stickyTracking || c.shared && !this.noSharedTooltip || c.hide();
                a.series.forEach(function(b) {
                    b.setState("", !0);
                });
            }
            setState(b, a) {
                const c = this;
                var d = c.options;
                const f = c.graph, e = d.inactiveOtherPoints, g = d.states, k = A(g[b || "normal"] && g[b || "normal"].animation, c.chart.options.chart.animation);
                let h = d.lineWidth, n = 0, l = d.opacity;
                b = b || "";
                if (c.state !== b && ([
                    c.group,
                    c.markerGroup,
                    c.dataLabelsGroup
                ].forEach(function(a) {
                    a && (c.state && a.removeClass("highcharts-series-" + c.state), b && a.addClass("highcharts-series-" + b));
                }), c.state = b, !c.chart.styledMode)) {
                    if (g[b] && !1 === g[b].enabled) return;
                    b && (h = g[b].lineWidth || h + (g[b].lineWidthPlus || 0), l = A(g[b].opacity, l));
                    if (f && !f.dashstyle && T(h)) for(d = {
                        "stroke-width": h
                    }, f.animate(d, k); c["zone-graph-" + n];)c["zone-graph-" + n].animate(d, k), n += 1;
                    e || [
                        c.group,
                        c.markerGroup,
                        c.dataLabelsGroup,
                        c.labelBySeries
                    ].forEach(function(b) {
                        b && b.animate({
                            opacity: l
                        }, k);
                    });
                }
                a && e && c.points && c.setAllPointsToState(b || void 0);
            }
            setAllPointsToState(b) {
                this.points.forEach(function(a) {
                    a.setState && a.setState(b);
                });
            }
            setVisible(b, a) {
                const c = this, d = c.chart, f = d.options.chart.ignoreHiddenSeries, e = c.visible, g = (c.visible = b = c.options.visible = c.userOptions.visible = "undefined" === typeof b ? !e : b) ? "show" : "hide";
                [
                    "group",
                    "dataLabelsGroup",
                    "markerGroup",
                    "tracker",
                    "tt"
                ].forEach(function(b) {
                    if (c[b]) c[b][g]();
                });
                if (d.hoverSeries === c || (d.hoverPoint && d.hoverPoint.series) === c) c.onMouseOut();
                c.legendItem && d.legend.colorizeItem(c, b);
                c.isDirty = !0;
                c.options.stacking && d.series.forEach(function(b) {
                    b.options.stacking && b.visible && (b.isDirty = !0);
                });
                c.linkedSeries.forEach(function(a) {
                    a.setVisible(b, !1);
                });
                f && (d.isDirtyBox = !0);
                n(c, g);
                !1 !== a && d.redraw();
            }
            show() {
                this.setVisible(!0);
            }
            hide() {
                this.setVisible(!1);
            }
            select(b) {
                this.selected = b = this.options.selected = "undefined" === typeof b ? !this.selected : b;
                this.checkbox && (this.checkbox.checked = b);
                n(this, b ? "select" : "unselect");
            }
            shouldShowTooltip(b, a, c = {}) {
                c.series = this;
                c.visiblePlotOnly = !0;
                return this.chart.isInsidePlot(b, a, c);
            }
            drawLegendSymbol(b, a) {
                var c;
                null === (c = C[this.options.legendSymbol || "rectangle"]) || void 0 === c || c.call(this, b, a);
            }
        }
        aa.defaultOptions = H;
        aa.types = B.seriesTypes;
        aa.registerType = B.registerSeriesType;
        f(aa.prototype, {
            axisTypes: [
                "xAxis",
                "yAxis"
            ],
            coll: "series",
            colorCounter: 0,
            cropShoulder: 1,
            directTouch: !1,
            isCartesian: !0,
            kdAxisArray: [
                "clientX",
                "plotY"
            ],
            parallelArrays: [
                "x",
                "y"
            ],
            pointClass: z,
            requireSorting: !0,
            sorted: !0
        });
        B.series = aa;
        "";
        "";
        return aa;
    });
    M(a, "Core/Chart/Chart.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Defaults.js"],
        a["Core/Templating.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Time.js"],
        a["Core/Utilities.js"],
        a["Core/Renderer/HTML/AST.js"]
    ], function(a, y, I, L, C, z, H, B, u, v, l, p, t) {
        const { animate: m, animObject: h, setAnimation: g } = a, { defaultOptions: e, defaultTime: w } = I, { numberFormat: x } = L, { registerEventOptions: F } = C, { charts: d, doc: k, marginNames: r, svg: q, win: G } = z, { seriesTypes: b } = u, { addEvent: f, attr: c, createElement: n, css: P, defined: D, diffObjects: K, discardElement: X, erase: T, error: Z, extend: V, find: Y, fireEvent: A, getStyle: M, isArray: ia, isNumber: ba, isObject: aa, isString: J, merge: N, objectEach: O, pick: S, pInt: W, relativeLength: ha, removeEvent: da, splat: fa, syncTimeout: ka, uniqueKey: ca } = p;
        class ea {
            static chart(b, a, c) {
                return new ea(b, a, c);
            }
            constructor(b, a, c){
                this.series = this.renderTo = this.renderer = this.pointer = this.pointCount = this.plotWidth = this.plotTop = this.plotLeft = this.plotHeight = this.plotBox = this.options = this.numberFormatter = this.margin = this.labelCollectors = this.isResizing = this.index = this.eventOptions = this.container = this.colorCounter = this.clipBox = this.chartWidth = this.chartHeight = this.bounds = this.axisOffset = this.axes = void 0;
                this.sharedClips = {};
                this.zooming = this.yAxis = this.xAxis = this.userOptions = this.titleOffset = this.time = this.symbolCounter = this.spacingBox = this.spacing = void 0;
                this.getArgs(b, a, c);
            }
            getArgs(b, a, c) {
                J(b) || b.nodeName ? (this.renderTo = b, this.init(a, c)) : this.init(b, a);
            }
            setZoomOptions() {
                const b = this.options.chart, a = b.zooming;
                this.zooming = Object.assign(Object.assign({}, a), {
                    type: S(b.zoomType, a.type),
                    key: S(b.zoomKey, a.key),
                    pinchType: S(b.pinchType, a.pinchType),
                    singleTouch: S(b.zoomBySingleTouch, a.singleTouch, !1),
                    resetButton: N(a.resetButton, b.resetZoomButton)
                });
            }
            init(b, a) {
                A(this, "init", {
                    args: arguments
                }, function() {
                    const c = N(e, b), f = c.chart;
                    this.userOptions = V({}, b);
                    this.margin = [];
                    this.spacing = [];
                    this.bounds = {
                        h: {},
                        v: {}
                    };
                    this.labelCollectors = [];
                    this.callback = a;
                    this.isResizing = 0;
                    this.options = c;
                    this.axes = [];
                    this.series = [];
                    this.time = b.time && Object.keys(b.time).length ? new l(b.time) : z.time;
                    this.numberFormatter = f.numberFormatter || x;
                    this.styledMode = f.styledMode;
                    this.hasCartesianSeries = f.showAxes;
                    this.index = d.length;
                    d.push(this);
                    z.chartCount++;
                    F(this, f);
                    this.xAxis = [];
                    this.yAxis = [];
                    this.pointCount = this.colorCounter = this.symbolCounter = 0;
                    this.setZoomOptions();
                    A(this, "afterInit");
                    this.firstRender();
                });
            }
            initSeries(a) {
                var c = this.options.chart;
                c = a.type || c.type;
                const d = b[c];
                d || Z(17, !0, this, {
                    missingModuleFor: c
                });
                c = new d;
                "function" === typeof c.init && c.init(this, a);
                return c;
            }
            setSeriesData() {
                this.getSeriesOrderByLinks().forEach(function(b) {
                    b.points || b.data || !b.enabledDataSorting || b.setData(b.options.data, !1);
                });
            }
            getSeriesOrderByLinks() {
                return this.series.concat().sort(function(b, a) {
                    return b.linkedSeries.length || a.linkedSeries.length ? a.linkedSeries.length - b.linkedSeries.length : 0;
                });
            }
            orderItems(b, a = 0) {
                const c = this[b], d = this.options[b] = fa(this.options[b]).slice();
                b = this.userOptions[b] = this.userOptions[b] ? fa(this.userOptions[b]).slice() : [];
                this.hasRendered && (d.splice(a), b.splice(a));
                if (c) {
                    for(let f = a, e = c.length; f < e; ++f)if (a = c[f]) a.index = f, a instanceof B && (a.name = a.getName()), a.options.isInternal || (d[f] = a.options, b[f] = a.userOptions);
                }
            }
            isInsidePlot(b, a, c = {}) {
                const { inverted: d, plotBox: f, plotLeft: e, plotTop: g, scrollablePlotBox: k } = this;
                var h = 0;
                let n = 0;
                c.visiblePlotOnly && this.scrollingContainer && ({ scrollLeft: h, scrollTop: n } = this.scrollingContainer);
                const l = c.series, m = c.visiblePlotOnly && k || f;
                var q = c.inverted ? a : b;
                a = c.inverted ? b : a;
                b = {
                    x: q,
                    y: a,
                    isInsidePlot: !0,
                    options: c
                };
                if (!c.ignoreX) {
                    const a = l && (d && !this.polar ? l.yAxis : l.xAxis) || {
                        pos: e,
                        len: Infinity
                    };
                    q = c.paneCoordinates ? a.pos + q : e + q;
                    q >= Math.max(h + e, a.pos) && q <= Math.min(h + e + m.width, a.pos + a.len) || (b.isInsidePlot = !1);
                }
                !c.ignoreY && b.isInsidePlot && (h = !d && c.axis && !c.axis.isXAxis && c.axis || l && (d ? l.xAxis : l.yAxis) || {
                    pos: g,
                    len: Infinity
                }, c = c.paneCoordinates ? h.pos + a : g + a, c >= Math.max(n + g, h.pos) && c <= Math.min(n + g + m.height, h.pos + h.len) || (b.isInsidePlot = !1));
                A(this, "afterIsInsidePlot", b);
                return b.isInsidePlot;
            }
            redraw(b) {
                A(this, "beforeRedraw");
                const a = this.hasCartesianSeries ? this.axes : this.colorAxis || [], c = this.series, d = this.pointer, f = this.legend, e = this.userOptions.legend, k = this.renderer, h = k.isHidden(), n = [];
                let l, m, q = this.isDirtyBox, p = this.isDirtyLegend, r;
                k.rootFontSize = k.boxWrapper.getStyle("font-size");
                this.setResponsive && this.setResponsive(!1);
                g(this.hasRendered ? b : !1, this);
                h && this.temporaryDisplay();
                this.layOutTitles(!1);
                for(b = c.length; b--;)if (r = c[b], r.options.stacking || r.options.centerInCategory) {
                    if (m = !0, r.isDirty) {
                        l = !0;
                        break;
                    }
                }
                if (l) for(b = c.length; b--;)r = c[b], r.options.stacking && (r.isDirty = !0);
                c.forEach(function(b) {
                    b.isDirty && ("point" === b.options.legendType ? ("function" === typeof b.updateTotals && b.updateTotals(), p = !0) : e && (e.labelFormatter || e.labelFormat) && (p = !0));
                    b.isDirtyData && A(b, "updatedData");
                });
                p && f && f.options.enabled && (f.render(), this.isDirtyLegend = !1);
                m && this.getStacks();
                a.forEach(function(b) {
                    b.updateNames();
                    b.setScale();
                });
                this.getMargins();
                a.forEach(function(b) {
                    b.isDirty && (q = !0);
                });
                a.forEach(function(b) {
                    const a = b.min + "," + b.max;
                    b.extKey !== a && (b.extKey = a, n.push(function() {
                        A(b, "afterSetExtremes", V(b.eventArgs, b.getExtremes()));
                        delete b.eventArgs;
                    }));
                    (q || m) && b.redraw();
                });
                q && this.drawChartBox();
                A(this, "predraw");
                c.forEach(function(b) {
                    (q || b.isDirty) && b.visible && b.redraw();
                    b.isDirtyData = !1;
                });
                d && d.reset(!0);
                k.draw();
                A(this, "redraw");
                A(this, "render");
                h && this.temporaryDisplay(!0);
                n.forEach(function(b) {
                    b.call();
                });
            }
            get(b) {
                function a(a) {
                    return a.id === b || a.options && a.options.id === b;
                }
                const c = this.series;
                let d = Y(this.axes, a) || Y(this.series, a);
                for(let b = 0; !d && b < c.length; b++)d = Y(c[b].points || [], a);
                return d;
            }
            getAxes() {
                const b = this.options;
                A(this, "getAxes");
                for (const a of [
                    "xAxis",
                    "yAxis"
                ]){
                    const c = b[a] = fa(b[a] || {});
                    for (const b of c)new y(this, b, a);
                }
                A(this, "afterGetAxes");
            }
            getSelectedPoints() {
                return this.series.reduce((b, a)=>{
                    a.getPointsCollection().forEach((a)=>{
                        S(a.selectedStaging, a.selected) && b.push(a);
                    });
                    return b;
                }, []);
            }
            getSelectedSeries() {
                return this.series.filter(function(b) {
                    return b.selected;
                });
            }
            setTitle(b, a, c) {
                this.applyDescription("title", b);
                this.applyDescription("subtitle", a);
                this.applyDescription("caption", void 0);
                this.layOutTitles(c);
            }
            applyDescription(b, a) {
                const c = this, d = this.options[b] = N(this.options[b], a);
                let f = this[b];
                f && a && (this[b] = f = f.destroy());
                d && !f && (f = this.renderer.text(d.text, 0, 0, d.useHTML).attr({
                    align: d.align,
                    "class": "highcharts-" + b,
                    zIndex: d.zIndex || 4
                }).add(), f.update = function(a, d) {
                    c.applyDescription(b, a);
                    c.layOutTitles(d);
                }, this.styledMode || f.css(V("title" === b ? {
                    fontSize: this.options.isStock ? "1em" : "1.2em"
                } : {}, d.style)), this[b] = f);
            }
            layOutTitles(b = !0) {
                const a = [
                    0,
                    0,
                    0
                ], c = this.renderer, d = this.spacingBox;
                [
                    "title",
                    "subtitle",
                    "caption"
                ].forEach(function(b) {
                    const f = this[b], e = this.options[b], g = e.verticalAlign || "top";
                    b = "title" === b ? "top" === g ? -3 : 0 : "top" === g ? a[0] + 2 : 0;
                    if (f) {
                        f.css({
                            width: (e.width || d.width + (e.widthAdjust || 0)) + "px"
                        });
                        const k = c.fontMetrics(f).b, h = Math.round(f.getBBox(e.useHTML).height);
                        f.align(V({
                            y: "bottom" === g ? k : b + k,
                            height: h
                        }, e), !1, "spacingBox");
                        e.floating || ("top" === g ? a[0] = Math.ceil(a[0] + h) : "bottom" === g && (a[2] = Math.ceil(a[2] + h)));
                    }
                }, this);
                a[0] && "top" === (this.options.title.verticalAlign || "top") && (a[0] += this.options.title.margin);
                a[2] && "bottom" === this.options.caption.verticalAlign && (a[2] += this.options.caption.margin);
                const f = !this.titleOffset || this.titleOffset.join(",") !== a.join(",");
                this.titleOffset = a;
                A(this, "afterLayOutTitles");
                !this.isDirtyBox && f && (this.isDirtyBox = this.isDirtyLegend = f, this.hasRendered && b && this.isDirtyBox && this.redraw());
            }
            getContainerBox() {
                return {
                    width: M(this.renderTo, "width", !0) || 0,
                    height: M(this.renderTo, "height", !0) || 0
                };
            }
            getChartSize() {
                var b = this.options.chart;
                const a = b.width;
                b = b.height;
                const c = this.getContainerBox();
                this.chartWidth = Math.max(0, a || c.width || 600);
                this.chartHeight = Math.max(0, ha(b, this.chartWidth) || (1 < c.height ? c.height : 400));
                this.containerBox = c;
            }
            temporaryDisplay(b) {
                let a = this.renderTo;
                if (b) for(; a && a.style;)a.hcOrigStyle && (P(a, a.hcOrigStyle), delete a.hcOrigStyle), a.hcOrigDetached && (k.body.removeChild(a), a.hcOrigDetached = !1), a = a.parentNode;
                else for(; a && a.style;){
                    k.body.contains(a) || a.parentNode || (a.hcOrigDetached = !0, k.body.appendChild(a));
                    if ("none" === M(a, "display", !1) || a.hcOricDetached) a.hcOrigStyle = {
                        display: a.style.display,
                        height: a.style.height,
                        overflow: a.style.overflow
                    }, b = {
                        display: "block",
                        overflow: "hidden"
                    }, a !== this.renderTo && (b.height = 0), P(a, b), a.offsetWidth || a.style.setProperty("display", "block", "important");
                    a = a.parentNode;
                    if (a === k.body) break;
                }
            }
            setClassName(b) {
                this.container.className = "highcharts-container " + (b || "");
            }
            getContainer() {
                const b = this.options, a = b.chart;
                var f = ca();
                let e, h = this.renderTo;
                h || (this.renderTo = h = a.renderTo);
                J(h) && (this.renderTo = h = k.getElementById(h));
                h || Z(13, !0, this);
                var l = W(c(h, "data-highcharts-chart"));
                ba(l) && d[l] && d[l].hasRendered && d[l].destroy();
                c(h, "data-highcharts-chart", this.index);
                h.innerHTML = t.emptyHTML;
                a.skipClone || h.offsetWidth || this.temporaryDisplay();
                this.getChartSize();
                l = this.chartWidth;
                const m = this.chartHeight;
                P(h, {
                    overflow: "hidden"
                });
                this.styledMode || (e = V({
                    position: "relative",
                    overflow: "hidden",
                    width: l + "px",
                    height: m + "px",
                    textAlign: "left",
                    lineHeight: "normal",
                    zIndex: 0,
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                    userSelect: "none",
                    "touch-action": "manipulation",
                    outline: "none"
                }, a.style || {}));
                this.container = f = n("div", {
                    id: f
                }, e, h);
                this._cursor = f.style.cursor;
                this.renderer = new (a.renderer || !q ? H.getRendererType(a.renderer) : v)(f, l, m, void 0, a.forExport, b.exporting && b.exporting.allowHTML, this.styledMode);
                this.containerBox = this.getContainerBox();
                g(void 0, this);
                this.setClassName(a.className);
                if (this.styledMode) for(const a in b.defs)this.renderer.definition(b.defs[a]);
                else this.renderer.setStyle(a.style);
                this.renderer.chartIndex = this.index;
                A(this, "afterGetContainer");
            }
            getMargins(b) {
                const { spacing: a, margin: c, titleOffset: d } = this;
                this.resetMargins();
                d[0] && !D(c[0]) && (this.plotTop = Math.max(this.plotTop, d[0] + a[0]));
                d[2] && !D(c[2]) && (this.marginBottom = Math.max(this.marginBottom, d[2] + a[2]));
                this.legend && this.legend.display && this.legend.adjustMargins(c, a);
                A(this, "getMargins");
                b || this.getAxisMargins();
            }
            getAxisMargins() {
                const b = this, a = b.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], c = b.colorAxis, d = b.margin, f = function(b) {
                    b.forEach(function(b) {
                        b.visible && b.getOffset();
                    });
                };
                b.hasCartesianSeries ? f(b.axes) : c && c.length && f(c);
                r.forEach(function(c, f) {
                    D(d[f]) || (b[c] += a[f]);
                });
                b.setChartSize();
            }
            getOptions() {
                return K(this.userOptions, e);
            }
            reflow(b) {
                const a = this;
                var c = a.options.chart;
                c = D(c.width) && D(c.height);
                const d = a.containerBox, f = a.getContainerBox();
                delete a.pointer.chartPosition;
                if (!c && !a.isPrinting && d && f.width) {
                    if (f.width !== d.width || f.height !== d.height) p.clearTimeout(a.reflowTimeout), a.reflowTimeout = ka(function() {
                        a.container && a.setSize(void 0, void 0, !1);
                    }, b ? 100 : 0);
                    a.containerBox = f;
                }
            }
            setReflow() {
                const b = this;
                var a = (a)=>{
                    var c;
                    (null === (c = b.options) || void 0 === c ? 0 : c.chart.reflow) && b.hasLoaded && b.reflow(a);
                };
                "function" === typeof ResizeObserver ? new ResizeObserver(a).observe(b.renderTo) : (a = f(G, "resize", a), f(this, "destroy", a));
            }
            setSize(b, a, c) {
                const d = this, f = d.renderer;
                d.isResizing += 1;
                g(c, d);
                c = f.globalAnimation;
                d.oldChartHeight = d.chartHeight;
                d.oldChartWidth = d.chartWidth;
                "undefined" !== typeof b && (d.options.chart.width = b);
                "undefined" !== typeof a && (d.options.chart.height = a);
                d.getChartSize();
                d.styledMode || (c ? m : P)(d.container, {
                    width: d.chartWidth + "px",
                    height: d.chartHeight + "px"
                }, c);
                d.setChartSize(!0);
                f.setSize(d.chartWidth, d.chartHeight, c);
                d.axes.forEach(function(b) {
                    b.isDirty = !0;
                    b.setScale();
                });
                d.isDirtyLegend = !0;
                d.isDirtyBox = !0;
                d.layOutTitles();
                d.getMargins();
                d.redraw(c);
                d.oldChartHeight = null;
                A(d, "resize");
                ka(function() {
                    d && A(d, "endResize", null, function() {
                        --d.isResizing;
                    });
                }, h(c).duration);
            }
            setChartSize(b) {
                var a = this.inverted;
                const c = this.renderer;
                var d = this.chartWidth, f = this.chartHeight;
                const e = this.options.chart, g = this.spacing, k = this.clipOffset;
                let h, n, l, m;
                this.plotLeft = h = Math.round(this.plotLeft);
                this.plotTop = n = Math.round(this.plotTop);
                this.plotWidth = l = Math.max(0, Math.round(d - h - this.marginRight));
                this.plotHeight = m = Math.max(0, Math.round(f - n - this.marginBottom));
                this.plotSizeX = a ? m : l;
                this.plotSizeY = a ? l : m;
                this.plotBorderWidth = e.plotBorderWidth || 0;
                this.spacingBox = c.spacingBox = {
                    x: g[3],
                    y: g[0],
                    width: d - g[3] - g[1],
                    height: f - g[0] - g[2]
                };
                this.plotBox = c.plotBox = {
                    x: h,
                    y: n,
                    width: l,
                    height: m
                };
                a = 2 * Math.floor(this.plotBorderWidth / 2);
                d = Math.ceil(Math.max(a, k[3]) / 2);
                f = Math.ceil(Math.max(a, k[0]) / 2);
                this.clipBox = {
                    x: d,
                    y: f,
                    width: Math.floor(this.plotSizeX - Math.max(a, k[1]) / 2 - d),
                    height: Math.max(0, Math.floor(this.plotSizeY - Math.max(a, k[2]) / 2 - f))
                };
                b || (this.axes.forEach(function(b) {
                    b.setAxisSize();
                    b.setAxisTranslation();
                }), c.alignElements());
                A(this, "afterSetChartSize", {
                    skipAxes: b
                });
            }
            resetMargins() {
                A(this, "resetMargins");
                const b = this, a = b.options.chart;
                [
                    "margin",
                    "spacing"
                ].forEach(function(c) {
                    const d = a[c], f = aa(d) ? d : [
                        d,
                        d,
                        d,
                        d
                    ];
                    [
                        "Top",
                        "Right",
                        "Bottom",
                        "Left"
                    ].forEach(function(d, e) {
                        b[c][e] = S(a[c + d], f[e]);
                    });
                });
                r.forEach(function(a, c) {
                    b[a] = S(b.margin[c], b.spacing[c]);
                });
                b.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ];
                b.clipOffset = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            drawChartBox() {
                const b = this.options.chart, a = this.renderer, c = this.chartWidth, d = this.chartHeight, f = this.styledMode, e = this.plotBGImage;
                var g = b.backgroundColor;
                const k = b.plotBackgroundColor, h = b.plotBackgroundImage, n = this.plotLeft, l = this.plotTop, m = this.plotWidth, q = this.plotHeight, p = this.plotBox, r = this.clipRect, t = this.clipBox;
                let w = this.chartBackground, v = this.plotBackground, u = this.plotBorder, x, D, E = "animate";
                w || (this.chartBackground = w = a.rect().addClass("highcharts-background").add(), E = "attr");
                if (f) x = D = w.strokeWidth();
                else {
                    x = b.borderWidth || 0;
                    D = x + (b.shadow ? 8 : 0);
                    g = {
                        fill: g || "none"
                    };
                    if (x || w["stroke-width"]) g.stroke = b.borderColor, g["stroke-width"] = x;
                    w.attr(g).shadow(b.shadow);
                }
                w[E]({
                    x: D / 2,
                    y: D / 2,
                    width: c - D - x % 2,
                    height: d - D - x % 2,
                    r: b.borderRadius
                });
                E = "animate";
                v || (E = "attr", this.plotBackground = v = a.rect().addClass("highcharts-plot-background").add());
                v[E](p);
                f || (v.attr({
                    fill: k || "none"
                }).shadow(b.plotShadow), h && (e ? (h !== e.attr("href") && e.attr("href", h), e.animate(p)) : this.plotBGImage = a.image(h, n, l, m, q).add()));
                r ? r.animate({
                    width: t.width,
                    height: t.height
                }) : this.clipRect = a.clipRect(t);
                E = "animate";
                u || (E = "attr", this.plotBorder = u = a.rect().addClass("highcharts-plot-border").attr({
                    zIndex: 1
                }).add());
                f || u.attr({
                    stroke: b.plotBorderColor,
                    "stroke-width": b.plotBorderWidth || 0,
                    fill: "none"
                });
                u[E](u.crisp({
                    x: n,
                    y: l,
                    width: m,
                    height: q
                }, -u.strokeWidth()));
                this.isDirtyBox = !1;
                A(this, "afterDrawChartBox");
            }
            propFromSeries() {
                const a = this, c = a.options.chart, d = a.options.series;
                let f, e, g;
                [
                    "inverted",
                    "angular",
                    "polar"
                ].forEach(function(k) {
                    e = b[c.type];
                    g = c[k] || e && e.prototype[k];
                    for(f = d && d.length; !g && f--;)(e = b[d[f].type]) && e.prototype[k] && (g = !0);
                    a[k] = g;
                });
            }
            linkSeries(b) {
                const a = this, c = a.series;
                c.forEach(function(b) {
                    b.linkedSeries.length = 0;
                });
                c.forEach(function(b) {
                    let c = b.options.linkedTo;
                    J(c) && (c = ":previous" === c ? a.series[b.index - 1] : a.get(c)) && c.linkedParent !== b && (c.linkedSeries.push(b), b.linkedParent = c, c.enabledDataSorting && b.setDataSortingOptions(), b.visible = S(b.options.visible, c.options.visible, b.visible));
                });
                A(this, "afterLinkSeries", {
                    isUpdating: b
                });
            }
            renderSeries() {
                this.series.forEach(function(b) {
                    b.translate();
                    b.render();
                });
            }
            render() {
                const b = this.axes, a = this.colorAxis, c = this.renderer, d = function(b) {
                    b.forEach(function(b) {
                        b.visible && b.render();
                    });
                };
                let f = 0;
                this.setTitle();
                A(this, "beforeMargins");
                this.getStacks && this.getStacks();
                this.getMargins(!0);
                this.setChartSize();
                const e = this.plotWidth;
                b.some(function(b) {
                    if (b.horiz && b.visible && b.options.labels.enabled && b.series.length) return f = 21, !0;
                });
                const g = this.plotHeight = Math.max(this.plotHeight - f, 0);
                b.forEach(function(b) {
                    b.setScale();
                });
                this.getAxisMargins();
                const k = 1.1 < e / this.plotWidth, h = 1.05 < g / this.plotHeight;
                if (k || h) b.forEach(function(b) {
                    (b.horiz && k || !b.horiz && h) && b.setTickInterval(!0);
                }), this.getMargins();
                this.drawChartBox();
                this.hasCartesianSeries ? d(b) : a && a.length && d(a);
                this.seriesGroup || (this.seriesGroup = c.g("series-group").attr({
                    zIndex: 3
                }).shadow(this.options.chart.seriesGroupShadow).add());
                this.renderSeries();
                this.addCredits();
                this.setResponsive && this.setResponsive();
                this.hasRendered = !0;
            }
            addCredits(b) {
                const a = this, c = N(!0, this.options.credits, b);
                c.enabled && !this.credits && (this.credits = this.renderer.text(c.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                    c.href && (G.location.href = c.href);
                }).attr({
                    align: c.position.align,
                    zIndex: 8
                }), a.styledMode || this.credits.css(c.style), this.credits.add().align(c.position), this.credits.update = function(b) {
                    a.credits = a.credits.destroy();
                    a.addCredits(b);
                });
            }
            destroy() {
                const b = this, a = b.axes, c = b.series, f = b.container, e = f && f.parentNode;
                let g;
                A(b, "destroy");
                b.renderer.forExport ? T(d, b) : d[b.index] = void 0;
                z.chartCount--;
                b.renderTo.removeAttribute("data-highcharts-chart");
                da(b);
                for(g = a.length; g--;)a[g] = a[g].destroy();
                this.scroller && this.scroller.destroy && this.scroller.destroy();
                for(g = c.length; g--;)c[g] = c[g].destroy();
                "title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(a) {
                    const c = b[a];
                    c && c.destroy && (b[a] = c.destroy());
                });
                f && (f.innerHTML = t.emptyHTML, da(f), e && X(f));
                O(b, function(a, c) {
                    delete b[c];
                });
            }
            firstRender() {
                const b = this, a = b.options;
                b.getContainer();
                b.resetMargins();
                b.setChartSize();
                b.propFromSeries();
                b.getAxes();
                const c = ia(a.series) ? a.series : [];
                a.series = [];
                c.forEach(function(a) {
                    b.initSeries(a);
                });
                b.linkSeries();
                b.setSeriesData();
                A(b, "beforeRender");
                b.render();
                b.pointer.getChartPosition();
                if (!b.renderer.imgCount && !b.hasLoaded) b.onload();
                b.temporaryDisplay(!0);
            }
            onload() {
                this.callbacks.concat([
                    this.callback
                ]).forEach(function(b) {
                    b && "undefined" !== typeof this.index && b.apply(this, [
                        this
                    ]);
                }, this);
                A(this, "load");
                A(this, "render");
                D(this.index) && this.setReflow();
                this.warnIfA11yModuleNotLoaded();
                this.hasLoaded = !0;
            }
            warnIfA11yModuleNotLoaded() {
                const { options: b, title: a } = this;
                b && !this.accessibility && (this.renderer.boxWrapper.attr({
                    role: "img",
                    "aria-label": (a && a.element.textContent || "").replace(/</g, "&lt;")
                }), b.accessibility && !1 === b.accessibility.enabled || Z('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
            }
            addSeries(b, a, c) {
                const d = this;
                let f;
                b && (a = S(a, !0), A(d, "addSeries", {
                    options: b
                }, function() {
                    f = d.initSeries(b);
                    d.isDirtyLegend = !0;
                    d.linkSeries();
                    f.enabledDataSorting && f.setData(b.data, !1);
                    A(d, "afterAddSeries", {
                        series: f
                    });
                    a && d.redraw(c);
                }));
                return f;
            }
            addAxis(b, a, c, d) {
                return this.createAxis(a ? "xAxis" : "yAxis", {
                    axis: b,
                    redraw: c,
                    animation: d
                });
            }
            addColorAxis(b, a, c) {
                return this.createAxis("colorAxis", {
                    axis: b,
                    redraw: a,
                    animation: c
                });
            }
            createAxis(b, a) {
                b = new y(this, a.axis, b);
                S(a.redraw, !0) && this.redraw(a.animation);
                return b;
            }
            showLoading(b) {
                const a = this, c = a.options, d = c.loading, e = function() {
                    g && P(g, {
                        left: a.plotLeft + "px",
                        top: a.plotTop + "px",
                        width: a.plotWidth + "px",
                        height: a.plotHeight + "px"
                    });
                };
                let g = a.loadingDiv, k = a.loadingSpan;
                g || (a.loadingDiv = g = n("div", {
                    className: "highcharts-loading highcharts-loading-hidden"
                }, null, a.container));
                k || (a.loadingSpan = k = n("span", {
                    className: "highcharts-loading-inner"
                }, null, g), f(a, "redraw", e));
                g.className = "highcharts-loading";
                t.setElementHTML(k, S(b, c.lang.loading, ""));
                a.styledMode || (P(g, V(d.style, {
                    zIndex: 10
                })), P(k, d.labelStyle), a.loadingShown || (P(g, {
                    opacity: 0,
                    display: ""
                }), m(g, {
                    opacity: d.style.opacity || .5
                }, {
                    duration: d.showDuration || 0
                })));
                a.loadingShown = !0;
                e();
            }
            hideLoading() {
                const b = this.options, a = this.loadingDiv;
                a && (a.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || m(a, {
                    opacity: 0
                }, {
                    duration: b.loading.hideDuration || 100,
                    complete: function() {
                        P(a, {
                            display: "none"
                        });
                    }
                }));
                this.loadingShown = !1;
            }
            update(b, a, c, d) {
                const f = this, e = {
                    credits: "addCredits",
                    title: "setTitle",
                    subtitle: "setSubtitle",
                    caption: "setCaption"
                }, g = b.isResponsiveOptions, k = [];
                let h, n;
                A(f, "update", {
                    options: b
                });
                g || f.setResponsive(!1, !0);
                b = K(b, f.options);
                f.userOptions = N(f.userOptions, b);
                var m = b.chart;
                if (m) {
                    N(!0, f.options.chart, m);
                    this.setZoomOptions();
                    "className" in m && f.setClassName(m.className);
                    if ("inverted" in m || "polar" in m || "type" in m) {
                        f.propFromSeries();
                        var q = !0;
                    }
                    "alignTicks" in m && (q = !0);
                    "events" in m && F(this, m);
                    O(m, function(b, a) {
                        -1 !== f.propsRequireUpdateSeries.indexOf("chart." + a) && (h = !0);
                        -1 !== f.propsRequireDirtyBox.indexOf(a) && (f.isDirtyBox = !0);
                        -1 !== f.propsRequireReflow.indexOf(a) && (g ? f.isDirtyBox = !0 : n = !0);
                    });
                    !f.styledMode && m.style && f.renderer.setStyle(f.options.chart.style || {});
                }
                !f.styledMode && b.colors && (this.options.colors = b.colors);
                b.time && (this.time === w && (this.time = new l(b.time)), N(!0, f.options.time, b.time));
                O(b, function(a, c) {
                    if (f[c] && "function" === typeof f[c].update) f[c].update(a, !1);
                    else if ("function" === typeof f[e[c]]) f[e[c]](a);
                    else "colors" !== c && -1 === f.collectionsWithUpdate.indexOf(c) && N(!0, f.options[c], b[c]);
                    "chart" !== c && -1 !== f.propsRequireUpdateSeries.indexOf(c) && (h = !0);
                });
                this.collectionsWithUpdate.forEach(function(a) {
                    b[a] && (fa(b[a]).forEach(function(b, d) {
                        const e = D(b.id);
                        let g;
                        e && (g = f.get(b.id));
                        !g && f[a] && (g = f[a][S(b.index, d)]) && (e && D(g.options.id) || g.options.isInternal) && (g = void 0);
                        g && g.coll === a && (g.update(b, !1), c && (g.touched = !0));
                        !g && c && f.collectionsWithInit[a] && (f.collectionsWithInit[a][0].apply(f, [
                            b
                        ].concat(f.collectionsWithInit[a][1] || []).concat([
                            !1
                        ])).touched = !0);
                    }), c && f[a].forEach(function(b) {
                        b.touched || b.options.isInternal ? delete b.touched : k.push(b);
                    }));
                });
                k.forEach(function(b) {
                    b.chart && b.remove && b.remove(!1);
                });
                q && f.axes.forEach(function(b) {
                    b.update({}, !1);
                });
                h && f.getSeriesOrderByLinks().forEach(function(b) {
                    b.chart && b.update({}, !1);
                }, this);
                q = m && m.width;
                m = m && (J(m.height) ? ha(m.height, q || f.chartWidth) : m.height);
                n || ba(q) && q !== f.chartWidth || ba(m) && m !== f.chartHeight ? f.setSize(q, m, d) : S(a, !0) && f.redraw(d);
                A(f, "afterUpdate", {
                    options: b,
                    redraw: a,
                    animation: d
                });
            }
            setSubtitle(b, a) {
                this.applyDescription("subtitle", b);
                this.layOutTitles(a);
            }
            setCaption(b, a) {
                this.applyDescription("caption", b);
                this.layOutTitles(a);
            }
            showResetZoom() {
                function b() {
                    a.zoomOut();
                }
                const a = this, c = e.lang, d = a.zooming.resetButton, f = d.theme, g = "chart" === d.relativeTo || "spacingBox" === d.relativeTo ? null : "scrollablePlotBox";
                A(this, "beforeShowResetZoom", null, function() {
                    a.resetZoomButton = a.renderer.button(c.resetZoom, null, null, b, f).attr({
                        align: d.position.align,
                        title: c.resetZoomTitle
                    }).addClass("highcharts-reset-zoom").add().align(d.position, !1, g);
                });
                A(this, "afterShowResetZoom");
            }
            zoomOut() {
                A(this, "selection", {
                    resetSelection: !0
                }, this.zoom);
            }
            zoom(b) {
                const a = this, c = a.pointer;
                let d = !1, f;
                !b || b.resetSelection ? (a.axes.forEach(function(b) {
                    f = b.zoom();
                }), c.initiated = !1) : b.xAxis.concat(b.yAxis).forEach(function(b) {
                    const e = b.axis;
                    if (c[e.isXAxis ? "zoomX" : "zoomY"] && D(c.mouseDownX) && D(c.mouseDownY) && a.isInsidePlot(c.mouseDownX - a.plotLeft, c.mouseDownY - a.plotTop, {
                        axis: e
                    }) || !D(a.inverted ? c.mouseDownX : c.mouseDownY)) f = e.zoom(b.min, b.max), e.displayBtn && (d = !0);
                });
                const e = a.resetZoomButton;
                d && !e ? a.showResetZoom() : !d && aa(e) && (a.resetZoomButton = e.destroy());
                f && a.redraw(S(a.options.chart.animation, b && b.animation, 100 > a.pointCount));
            }
            pan(b, a) {
                const c = this, d = c.hoverPoints;
                a = "object" === typeof a ? a : {
                    enabled: a,
                    type: "x"
                };
                const f = c.options.chart;
                f && f.panning && (f.panning = a);
                const e = a.type;
                let g;
                A(this, "pan", {
                    originalEvent: b
                }, function() {
                    d && d.forEach(function(b) {
                        b.setState();
                    });
                    let a = c.xAxis;
                    "xy" === e ? a = a.concat(c.yAxis) : "y" === e && (a = c.yAxis);
                    const f = {};
                    a.forEach(function(a) {
                        if (a.options.panningEnabled && !a.options.isInternal) {
                            var d = a.horiz, k = b[d ? "chartX" : "chartY"];
                            d = d ? "mouseDownX" : "mouseDownY";
                            var h = c[d], n = a.minPointOffset || 0, l = a.reversed && !c.inverted || !a.reversed && c.inverted ? -1 : 1, m = a.getExtremes(), q = a.toValue(h - k, !0) + n * l, p = a.toValue(h + a.len - k, !0) - (n * l || a.isXAxis && a.pointRangePadding || 0), r = p < q;
                            l = a.hasVerticalPanning();
                            h = r ? p : q;
                            q = r ? q : p;
                            var t = a.panningState;
                            !l || a.isXAxis || t && !t.isDirty || a.series.forEach(function(b) {
                                var a = b.getProcessedData(!0);
                                a = b.getExtremes(a.yData, !0);
                                t || (t = {
                                    startMin: Number.MAX_VALUE,
                                    startMax: -Number.MAX_VALUE
                                });
                                ba(a.dataMin) && ba(a.dataMax) && (t.startMin = Math.min(S(b.options.threshold, Infinity), a.dataMin, t.startMin), t.startMax = Math.max(S(b.options.threshold, -Infinity), a.dataMax, t.startMax));
                            });
                            l = Math.min(S(t && t.startMin, m.dataMin), n ? m.min : a.toValue(a.toPixels(m.min) - a.minPixelPadding));
                            p = Math.max(S(t && t.startMax, m.dataMax), n ? m.max : a.toValue(a.toPixels(m.max) + a.minPixelPadding));
                            a.panningState = t;
                            a.isOrdinal || (n = l - h, 0 < n && (q += n, h = l), n = q - p, 0 < n && (q = p, h -= n), a.series.length && h !== m.min && q !== m.max && h >= l && q <= p && (a.setExtremes(h, q, !1, !1, {
                                trigger: "pan"
                            }), !c.resetZoomButton && h !== l && q !== p && e.match("y") && (c.showResetZoom(), a.displayBtn = !1), g = !0), f[d] = k);
                        }
                    });
                    O(f, (b, a)=>{
                        c[a] = b;
                    });
                    g && c.redraw(!1);
                    P(c.container, {
                        cursor: "move"
                    });
                });
            }
        }
        V(ea.prototype, {
            callbacks: [],
            collectionsWithInit: {
                xAxis: [
                    ea.prototype.addAxis,
                    [
                        !0
                    ]
                ],
                yAxis: [
                    ea.prototype.addAxis,
                    [
                        !1
                    ]
                ],
                series: [
                    ea.prototype.addSeries
                ]
            },
            collectionsWithUpdate: [
                "xAxis",
                "yAxis",
                "series"
            ],
            propsRequireDirtyBox: "backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
            propsRequireReflow: "margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
            propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" ")
        });
        "";
        return ea;
    });
    M(a, "Extensions/ScrollablePlotArea.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Chart/Chart.js"],
        a["Core/Series/Series.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z) {
        const { stop: x } = a, { addEvent: B, createElement: u, defined: v, merge: l, pick: p } = z;
        B(I, "afterSetChartSize", function(a) {
            var m = this.options.chart.scrollablePlotArea, h = m && m.minWidth;
            m = m && m.minHeight;
            let g;
            if (!this.renderer.forExport) {
                if (h) {
                    if (this.scrollablePixelsX = h = Math.max(0, h - this.chartWidth)) this.scrollablePlotBox = this.renderer.scrollablePlotBox = l(this.plotBox), this.plotBox.width = this.plotWidth += h, this.inverted ? this.clipBox.height += h : this.clipBox.width += h, g = {
                        1: {
                            name: "right",
                            value: h
                        }
                    };
                } else m && (this.scrollablePixelsY = h = Math.max(0, m - this.chartHeight), v(h) && (this.scrollablePlotBox = this.renderer.scrollablePlotBox = l(this.plotBox), this.plotBox.height = this.plotHeight += h, this.inverted ? this.clipBox.width += h : this.clipBox.height += h, g = {
                    2: {
                        name: "bottom",
                        value: h
                    }
                }));
                g && !a.skipAxes && this.axes.forEach(function(a) {
                    g[a.side] ? a.getPlotLinePath = function() {
                        let e = g[a.side].name, h = this[e], l;
                        this[e] = h - g[a.side].value;
                        l = y.prototype.getPlotLinePath.apply(this, arguments);
                        this[e] = h;
                        return l;
                    } : (a.setAxisSize(), a.setAxisTranslation());
                });
            }
        });
        B(I, "render", function() {
            this.scrollablePixelsX || this.scrollablePixelsY ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
        });
        I.prototype.setUpScrolling = function() {
            const a = {
                WebkitOverflowScrolling: "touch",
                overflowX: "hidden",
                overflowY: "hidden"
            };
            this.scrollablePixelsX && (a.overflowX = "auto");
            this.scrollablePixelsY && (a.overflowY = "auto");
            this.scrollingParent = u("div", {
                className: "highcharts-scrolling-parent"
            }, {
                position: "relative"
            }, this.renderTo);
            this.scrollingContainer = u("div", {
                className: "highcharts-scrolling"
            }, a, this.scrollingParent);
            let l;
            B(this.scrollingContainer, "scroll", ()=>{
                this.pointer && (delete this.pointer.chartPosition, this.hoverPoint && (l = this.hoverPoint), this.pointer.runPointActions(void 0, l, !0));
            });
            this.innerContainer = u("div", {
                className: "highcharts-inner-container"
            }, null, this.scrollingContainer);
            this.innerContainer.appendChild(this.container);
            this.setUpScrolling = null;
        };
        I.prototype.moveFixedElements = function() {
            let a = this.container, l = this.fixedRenderer, h = ".highcharts-breadcrumbs-group .highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-drillup-button .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "), g;
            this.scrollablePixelsX && !this.inverted ? g = ".highcharts-yaxis" : this.scrollablePixelsX && this.inverted ? g = ".highcharts-xaxis" : this.scrollablePixelsY && !this.inverted ? g = ".highcharts-xaxis" : this.scrollablePixelsY && this.inverted && (g = ".highcharts-yaxis");
            g && h.push(`${g}:not(.highcharts-radial-axis)`, `${g}-labels:not(.highcharts-radial-axis-labels)`);
            h.forEach(function(e) {
                [].forEach.call(a.querySelectorAll(e), function(a) {
                    (a.namespaceURI === l.SVG_NS ? l.box : l.box.parentNode).appendChild(a);
                    a.style.pointerEvents = "auto";
                });
            });
        };
        I.prototype.applyFixed = function() {
            var a = !this.fixedDiv, l = this.options.chart, h = l.scrollablePlotArea, g = C.getRendererType();
            a ? (this.fixedDiv = u("div", {
                className: "highcharts-fixed"
            }, {
                position: "absolute",
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: (l.style && l.style.zIndex || 0) + 2,
                top: 0
            }, null, !0), this.scrollingContainer && this.scrollingContainer.parentNode.insertBefore(this.fixedDiv, this.scrollingContainer), this.renderTo.style.overflow = "visible", this.fixedRenderer = l = new g(this.fixedDiv, this.chartWidth, this.chartHeight, this.options.chart.style), this.scrollableMask = l.path().attr({
                fill: this.options.chart.backgroundColor || "#fff",
                "fill-opacity": p(h.opacity, .85),
                zIndex: -1
            }).addClass("highcharts-scrollable-mask").add(), B(this, "afterShowResetZoom", this.moveFixedElements), B(this, "afterApplyDrilldown", this.moveFixedElements), B(this, "afterLayOutTitles", this.moveFixedElements)) : this.fixedRenderer.setSize(this.chartWidth, this.chartHeight);
            if (this.scrollableDirty || a) this.scrollableDirty = !1, this.moveFixedElements();
            l = this.chartWidth + (this.scrollablePixelsX || 0);
            g = this.chartHeight + (this.scrollablePixelsY || 0);
            x(this.container);
            this.container.style.width = l + "px";
            this.container.style.height = g + "px";
            this.renderer.boxWrapper.attr({
                width: l,
                height: g,
                viewBox: [
                    0,
                    0,
                    l,
                    g
                ].join(" ")
            });
            this.chartBackground.attr({
                width: l,
                height: g
            });
            this.scrollingContainer.style.height = this.chartHeight + "px";
            a && (h.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixelsX * h.scrollPositionX), h.scrollPositionY && (this.scrollingContainer.scrollTop = this.scrollablePixelsY * h.scrollPositionY));
            g = this.axisOffset;
            a = this.plotTop - g[0] - 1;
            h = this.plotLeft - g[3] - 1;
            l = this.plotTop + this.plotHeight + g[2] + 1;
            g = this.plotLeft + this.plotWidth + g[1] + 1;
            let e = this.plotLeft + this.plotWidth - (this.scrollablePixelsX || 0), w = this.plotTop + this.plotHeight - (this.scrollablePixelsY || 0);
            a = this.scrollablePixelsX ? [
                [
                    "M",
                    0,
                    a
                ],
                [
                    "L",
                    this.plotLeft - 1,
                    a
                ],
                [
                    "L",
                    this.plotLeft - 1,
                    l
                ],
                [
                    "L",
                    0,
                    l
                ],
                [
                    "Z"
                ],
                [
                    "M",
                    e,
                    a
                ],
                [
                    "L",
                    this.chartWidth,
                    a
                ],
                [
                    "L",
                    this.chartWidth,
                    l
                ],
                [
                    "L",
                    e,
                    l
                ],
                [
                    "Z"
                ]
            ] : this.scrollablePixelsY ? [
                [
                    "M",
                    h,
                    0
                ],
                [
                    "L",
                    h,
                    this.plotTop - 1
                ],
                [
                    "L",
                    g,
                    this.plotTop - 1
                ],
                [
                    "L",
                    g,
                    0
                ],
                [
                    "Z"
                ],
                [
                    "M",
                    h,
                    w
                ],
                [
                    "L",
                    h,
                    this.chartHeight
                ],
                [
                    "L",
                    g,
                    this.chartHeight
                ],
                [
                    "L",
                    g,
                    w
                ],
                [
                    "Z"
                ]
            ] : [
                [
                    "M",
                    0,
                    0
                ]
            ];
            "adjustHeight" !== this.redrawTrigger && this.scrollableMask.attr({
                d: a
            });
        };
        B(y, "afterInit", function() {
            this.chart.scrollableDirty = !0;
        });
        B(L, "show", function() {
            this.chart.scrollableDirty = !0;
        });
        "";
    });
    M(a, "Core/Axis/Stacking/StackItem.js", [
        a["Core/Templating.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { format: x } = a, { series: C } = y, { destroyObjectProperties: z, fireEvent: H, isNumber: B, pick: u } = I;
        class v {
            constructor(a, p, t, m, h){
                const g = a.chart.inverted, e = a.reversed;
                this.axis = a;
                a = this.isNegative = !!t !== !!e;
                this.options = p = p || {};
                this.x = m;
                this.cumulative = this.total = null;
                this.points = {};
                this.hasValidPoints = !1;
                this.stack = h;
                this.rightCliff = this.leftCliff = 0;
                this.alignOptions = {
                    align: p.align || (g ? a ? "left" : "right" : "center"),
                    verticalAlign: p.verticalAlign || (g ? "middle" : a ? "bottom" : "top"),
                    y: p.y,
                    x: p.x
                };
                this.textAlign = p.textAlign || (g ? a ? "right" : "left" : "center");
            }
            destroy() {
                z(this, this.axis);
            }
            render(a) {
                const l = this.axis.chart, t = this.options;
                var m = t.format;
                m = m ? x(m, this, l) : t.formatter.call(this);
                this.label ? this.label.attr({
                    text: m,
                    visibility: "hidden"
                }) : (this.label = l.renderer.label(m, null, void 0, t.shape, void 0, void 0, t.useHTML, !1, "stack-labels"), m = {
                    r: t.borderRadius || 0,
                    text: m,
                    padding: u(t.padding, 5),
                    visibility: "hidden"
                }, l.styledMode || (m.fill = t.backgroundColor, m.stroke = t.borderColor, m["stroke-width"] = t.borderWidth, this.label.css(t.style || {})), this.label.attr(m), this.label.added || this.label.add(a));
                this.label.labelrank = l.plotSizeY;
                H(this, "afterRender");
            }
            setOffset(a, p, t, m, h, g) {
                const { alignOptions: e, axis: l, label: v, options: x, textAlign: d } = this, k = l.chart;
                t = this.getStackBox({
                    xOffset: a,
                    width: p,
                    boxBottom: t,
                    boxTop: m,
                    defaultX: h,
                    xAxis: g
                });
                var { verticalAlign: r } = e;
                if (v && t) {
                    m = v.getBBox();
                    h = v.padding;
                    g = "justify" === u(x.overflow, "justify");
                    e.x = x.x || 0;
                    e.y = x.y || 0;
                    const { x: a, y: p } = this.adjustStackPosition({
                        labelBox: m,
                        verticalAlign: r,
                        textAlign: d
                    });
                    t.x -= a;
                    t.y -= p;
                    v.align(e, !1, t);
                    (r = k.isInsidePlot(v.alignAttr.x + e.x + a, v.alignAttr.y + e.y + p)) || (g = !1);
                    g && C.prototype.justifyDataLabel.call(l, v, e, v.alignAttr, m, t);
                    v.attr({
                        x: v.alignAttr.x,
                        y: v.alignAttr.y,
                        rotation: x.rotation,
                        rotationOriginX: m.width / 2,
                        rotationOriginY: m.height / 2
                    });
                    u(!g && x.crop, !0) && (r = B(v.x) && B(v.y) && k.isInsidePlot(v.x - h + v.width, v.y) && k.isInsidePlot(v.x + h, v.y));
                    v[r ? "show" : "hide"]();
                }
                H(this, "afterSetOffset", {
                    xOffset: a,
                    width: p
                });
            }
            adjustStackPosition({ labelBox: a, verticalAlign: p, textAlign: t }) {
                const l = {
                    bottom: 0,
                    middle: 1,
                    top: 2,
                    right: 1,
                    center: 0,
                    left: -1
                };
                return {
                    x: a.width / 2 + a.width / 2 * l[t],
                    y: a.height / 2 * l[p]
                };
            }
            getStackBox(a) {
                var l = this.axis;
                const t = l.chart, { boxTop: m, defaultX: h, xOffset: g, width: e, boxBottom: w } = a;
                var v = l.stacking.usePercentage ? 100 : u(m, this.total, 0);
                v = l.toPixels(v);
                a = a.xAxis || t.xAxis[0];
                const x = u(h, a.translate(this.x)) + g;
                l = l.toPixels(w || B(l.min) && l.logarithmic && l.logarithmic.lin2log(l.min) || 0);
                l = Math.abs(v - l);
                const d = this.isNegative;
                return t.inverted ? {
                    x: (d ? v : v - l) - t.plotLeft,
                    y: a.height - x - e,
                    width: l,
                    height: e
                } : {
                    x: x + a.transB - t.plotLeft,
                    y: (d ? v - l : v) - t.plotTop,
                    width: e,
                    height: l
                };
            }
        }
        "";
        return v;
    });
    M(a, "Core/Axis/Stacking/StackingAxis.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Axis/Stacking/StackItem.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C) {
        function x() {
            const b = this, a = b.inverted;
            b.yAxis.forEach((b)=>{
                b.stacking && b.stacking.stacks && b.hasVisibleSeries && (b.stacking.oldStacks = b.stacking.stacks);
            });
            b.series.forEach((c)=>{
                const d = c.xAxis && c.xAxis.options || {};
                !c.options.stacking || !0 !== c.visible && !1 !== b.options.chart.ignoreHiddenSeries || (c.stackKey = [
                    c.type,
                    q(c.options.stack, ""),
                    a ? d.top : d.left,
                    a ? d.height : d.width
                ].join());
            });
        }
        function H() {
            const b = this.stacking;
            if (b) {
                var a = b.stacks;
                r(a, function(b, c) {
                    E(b);
                    a[c] = null;
                });
                b && b.stackTotalGroup && b.stackTotalGroup.destroy();
            }
        }
        function B() {
            "yAxis" !== this.coll || this.stacking || (this.stacking = new G(this));
        }
        function u(b, a, d, e) {
            !w(b) || b.x !== a || e && b.stackKey !== e ? b = {
                x: a,
                index: 0,
                key: e,
                stackKey: e
            } : b.index++;
            b.key = [
                d,
                a,
                b.index
            ].join();
            return b;
        }
        function v() {
            const b = this, a = b.stackKey, d = b.yAxis.stacking.stacks, e = b.processedXData, g = b[b.options.stacking + "Stacker"];
            let k;
            g && [
                a,
                "-" + a
            ].forEach((a)=>{
                let c = e.length;
                let f;
                for(; c--;){
                    var h = e[c];
                    k = b.getStackIndicator(k, h, b.index, a);
                    (f = (h = d[a] && d[a][h]) && h.points[k.key]) && g.call(b, f, h, c);
                }
            });
        }
        function l(b, a, d) {
            a = a.total ? 100 / a.total : 0;
            b[0] = e(b[0] * a);
            b[1] = e(b[1] * a);
            this.stackedYData[d] = b[1];
        }
        function p() {
            const b = this.yAxis.stacking;
            this.options.centerInCategory && (this.is("column") || this.is("columnrange")) && !this.options.stacking && 1 < this.chart.series.length ? h.setStackedPoints.call(this, "group") : b && r(b.stacks, (a, d)=>{
                "group" === d.slice(-5) && (r(a, (b)=>b.destroy()), delete b.stacks[d]);
            });
        }
        function t(b) {
            var a = this.chart;
            const f = b || this.options.stacking;
            if (f && (!0 === this.visible || !1 === a.options.chart.ignoreHiddenSeries)) {
                var g = this.processedXData, k = this.processedYData, h = [], l = k.length, m = this.options, p = m.threshold, r = q(m.startFromThreshold && p, 0);
                m = m.stack;
                b = b ? `${this.type},${f}` : this.stackKey;
                var t = "-" + b, v = this.negStacks;
                a = "group" === f ? a.yAxis[0] : this.yAxis;
                var u = a.stacking.stacks, x = a.stacking.oldStacks, E, G;
                a.stacking.stacksTouched += 1;
                for(G = 0; G < l; G++){
                    var F = g[G];
                    var B = k[G];
                    var y = this.getStackIndicator(y, F, this.index);
                    var C = y.key;
                    var z = (E = v && B < (r ? 0 : p)) ? t : b;
                    u[z] || (u[z] = {});
                    u[z][F] || (x[z] && x[z][F] ? (u[z][F] = x[z][F], u[z][F].total = null) : u[z][F] = new L(a, a.options.stackLabels, !!E, F, m));
                    z = u[z][F];
                    null !== B ? (z.points[C] = z.points[this.index] = [
                        q(z.cumulative, r)
                    ], w(z.cumulative) || (z.base = C), z.touched = a.stacking.stacksTouched, 0 < y.index && !1 === this.singleStacks && (z.points[C][0] = z.points[this.index + "," + F + ",0"][0])) : z.points[C] = z.points[this.index] = null;
                    "percent" === f ? (E = E ? b : t, v && u[E] && u[E][F] ? (E = u[E][F], z.total = E.total = Math.max(E.total, z.total) + Math.abs(B) || 0) : z.total = e(z.total + (Math.abs(B) || 0))) : "group" === f ? (d(B) && (B = B[0]), null !== B && (z.total = (z.total || 0) + 1)) : z.total = e(z.total + (B || 0));
                    z.cumulative = "group" === f ? (z.total || 1) - 1 : e(q(z.cumulative, r) + (B || 0));
                    null !== B && (z.points[C].push(z.cumulative), h[G] = z.cumulative, z.hasValidPoints = !0);
                }
                "percent" === f && (a.stacking.usePercentage = !0);
                "group" !== f && (this.stackedYData = h);
                a.stacking.oldStacks = {};
            }
        }
        const { getDeferredAnimation: m } = a, { series: { prototype: h } } = I, { addEvent: g, correctFloat: e, defined: w, destroyObjectProperties: E, fireEvent: F, isArray: d, isNumber: k, objectEach: r, pick: q } = C;
        class G {
            constructor(b){
                this.oldStacks = {};
                this.stacks = {};
                this.stacksTouched = 0;
                this.axis = b;
            }
            buildStacks() {
                const b = this.axis, a = b.series, d = b.options.reversedStacks, e = a.length;
                let g, k;
                this.usePercentage = !1;
                for(k = e; k--;)g = a[d ? k : e - k - 1], g.setStackedPoints(), g.setGroupedPoints();
                for(k = 0; k < e; k++)a[k].modifyStacks();
                F(b, "afterBuildStacks");
            }
            cleanStacks() {
                let b;
                this.oldStacks && (b = this.stacks = this.oldStacks);
                r(b, function(b) {
                    r(b, function(b) {
                        b.cumulative = b.total;
                    });
                });
            }
            resetStacks() {
                r(this.stacks, (b)=>{
                    r(b, (a, d)=>{
                        k(a.touched) && a.touched < this.stacksTouched ? (a.destroy(), delete b[d]) : (a.total = null, a.cumulative = null);
                    });
                });
            }
            renderStackTotals() {
                var b = this.axis;
                const a = b.chart, d = a.renderer, e = this.stacks;
                b = m(a, b.options.stackLabels && b.options.stackLabels.animation || !1);
                const g = this.stackTotalGroup = this.stackTotalGroup || d.g("stack-labels").attr({
                    zIndex: 6,
                    opacity: 0
                }).add();
                g.translate(a.plotLeft, a.plotTop);
                r(e, function(b) {
                    r(b, function(b) {
                        b.render(g);
                    });
                });
                g.animate({
                    opacity: 1
                }, b);
            }
        }
        var b;
        (function(b) {
            const a = [];
            b.compose = function(b, c, d) {
                C.pushUnique(a, b) && (g(b, "init", B), g(b, "destroy", H));
                C.pushUnique(a, c) && (c.prototype.getStacks = x);
                C.pushUnique(a, d) && (b = d.prototype, b.getStackIndicator = u, b.modifyStacks = v, b.percentStacker = l, b.setGroupedPoints = p, b.setStackedPoints = t);
            };
        })(b || (b = {}));
        return b;
    });
    M(a, "Series/Line/LineSeries.js", [
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { defined: x, merge: C } = I;
        class z extends a {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            drawGraph() {
                const a = this, x = this.options, u = (this.gappedPath || this.getGraphPath).call(this), v = this.chart.styledMode;
                let l = [
                    [
                        "graph",
                        "highcharts-graph"
                    ]
                ];
                v || l[0].push(x.lineColor || this.color || "#cccccc", x.dashStyle);
                l = a.getZonesGraphs(l);
                l.forEach(function(l, t) {
                    var m = l[0];
                    let h = a[m];
                    const g = h ? "animate" : "attr";
                    h ? (h.endX = a.preventGraphAnimation ? null : u.xMap, h.animate({
                        d: u
                    })) : u.length && (a[m] = h = a.chart.renderer.path(u).addClass(l[1]).attr({
                        zIndex: 1
                    }).add(a.group));
                    h && !v && (m = {
                        stroke: l[2],
                        "stroke-width": x.lineWidth || 0,
                        fill: a.fillGraph && a.color || "none"
                    }, l[3] ? m.dashstyle = l[3] : "square" !== x.linecap && (m["stroke-linecap"] = m["stroke-linejoin"] = "round"), h[g](m).shadow(2 > t && x.shadow));
                    h && (h.startX = u.xMap, h.isArea = u.isArea);
                });
            }
            getGraphPath(a, B, u) {
                const v = this, l = v.options, p = [], t = [];
                let m, h = l.step;
                a = a || v.points;
                const g = a.reversed;
                g && a.reverse();
                (h = ({
                    right: 1,
                    center: 2
                })[h] || h && 3) && g && (h = 4 - h);
                a = this.getValidPoints(a, !1, !(l.connectNulls && !B && !u));
                a.forEach(function(e, g) {
                    const w = e.plotX, F = e.plotY, d = a[g - 1], k = e.isNull || "number" !== typeof F;
                    (e.leftCliff || d && d.rightCliff) && !u && (m = !0);
                    k && !x(B) && 0 < g ? m = !l.connectNulls : k && !B ? m = !0 : (0 === g || m ? g = [
                        [
                            "M",
                            e.plotX,
                            e.plotY
                        ]
                    ] : v.getPointSpline ? g = [
                        v.getPointSpline(a, e, g)
                    ] : h ? (g = 1 === h ? [
                        [
                            "L",
                            d.plotX,
                            F
                        ]
                    ] : 2 === h ? [
                        [
                            "L",
                            (d.plotX + w) / 2,
                            d.plotY
                        ],
                        [
                            "L",
                            (d.plotX + w) / 2,
                            F
                        ]
                    ] : [
                        [
                            "L",
                            w,
                            d.plotY
                        ]
                    ], g.push([
                        "L",
                        w,
                        F
                    ])) : g = [
                        [
                            "L",
                            w,
                            F
                        ]
                    ], t.push(e.x), h && (t.push(e.x), 2 === h && t.push(e.x)), p.push.apply(p, g), m = !1);
                });
                p.xMap = t;
                return v.graphPath = p;
            }
            getZonesGraphs(a) {
                this.zones.forEach(function(x, u) {
                    u = [
                        "zone-graph-" + u,
                        "highcharts-graph highcharts-zone-graph-" + u + " " + (x.className || "")
                    ];
                    this.chart.styledMode || u.push(x.color || this.color, x.dashStyle || this.options.dashStyle);
                    a.push(u);
                }, this);
                return a;
            }
        }
        z.defaultOptions = C(a.defaultOptions, {
            legendSymbol: "lineMarker"
        });
        y.registerSeriesType("line", z);
        "";
        return z;
    });
    M(a, "Series/Area/AreaSeries.js", [
        a["Core/Color/Color.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { seriesTypes: { line: x } } = y, { extend: C, merge: z, objectEach: H, pick: B } = I;
        class u extends x {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            drawGraph() {
                this.areaPath = [];
                super.drawGraph.apply(this);
                const a = this, l = this.areaPath, p = this.options, t = [
                    [
                        "area",
                        "highcharts-area",
                        this.color,
                        p.fillColor
                    ]
                ];
                this.zones.forEach(function(l, h) {
                    t.push([
                        "zone-area-" + h,
                        "highcharts-area highcharts-zone-area-" + h + " " + l.className,
                        l.color || a.color,
                        l.fillColor || p.fillColor
                    ]);
                });
                t.forEach(function(m) {
                    const h = m[0], g = {};
                    let e = a[h];
                    const t = e ? "animate" : "attr";
                    e ? (e.endX = a.preventGraphAnimation ? null : l.xMap, e.animate({
                        d: l
                    })) : (g.zIndex = 0, e = a[h] = a.chart.renderer.path(l).addClass(m[1]).add(a.group), e.isArea = !0);
                    a.chart.styledMode || (m[3] ? g.fill = m[3] : (g.fill = m[2], g["fill-opacity"] = B(p.fillOpacity, .75)));
                    e[t](g);
                    e.startX = l.xMap;
                    e.shiftUnit = p.step ? 2 : 1;
                });
            }
            getGraphPath(a) {
                var l = x.prototype.getGraphPath, p = this.options;
                const t = p.stacking, m = this.yAxis, h = [], g = [], e = this.index, w = m.stacking.stacks[this.stackKey], v = p.threshold, u = Math.round(m.getThreshold(p.threshold));
                p = B(p.connectNulls, "percent" === t);
                var d = function(d, b, f) {
                    var c = a[d];
                    d = t && w[c.x].points[e];
                    const n = c[f + "Null"] || 0;
                    f = c[f + "Cliff"] || 0;
                    let l, q;
                    c = !0;
                    f || n ? (l = (n ? d[0] : d[1]) + f, q = d[0] + f, c = !!n) : !t && a[b] && a[b].isNull && (l = q = v);
                    "undefined" !== typeof l && (g.push({
                        plotX: k,
                        plotY: null === l ? u : m.getThreshold(l),
                        isNull: c,
                        isCliff: !0
                    }), h.push({
                        plotX: k,
                        plotY: null === q ? u : m.getThreshold(q),
                        doCurve: !1
                    }));
                };
                let k;
                a = a || this.points;
                t && (a = this.getStackPoints(a));
                for(let e = 0, b = a.length; e < b; ++e){
                    t || (a[e].leftCliff = a[e].rightCliff = a[e].leftNull = a[e].rightNull = void 0);
                    var r = a[e].isNull;
                    k = B(a[e].rectPlotX, a[e].plotX);
                    var q = t ? B(a[e].yBottom, u) : u;
                    if (!r || p) p || d(e, e - 1, "left"), r && !t && p || (g.push(a[e]), h.push({
                        x: e,
                        plotX: k,
                        plotY: q
                    })), p || d(e, e + 1, "right");
                }
                d = l.call(this, g, !0, !0);
                h.reversed = !0;
                r = l.call(this, h, !0, !0);
                (q = r[0]) && "M" === q[0] && (r[0] = [
                    "L",
                    q[1],
                    q[2]
                ]);
                r = d.concat(r);
                r.length && r.push([
                    "Z"
                ]);
                l = l.call(this, g, !1, p);
                r.xMap = d.xMap;
                this.areaPath = r;
                return l;
            }
            getStackPoints(a) {
                const l = this, p = [], t = [], m = this.xAxis, h = this.yAxis, g = h.stacking.stacks[this.stackKey], e = {}, w = h.series, v = w.length, u = h.options.reversedStacks ? 1 : -1, d = w.indexOf(l);
                a = a || this.points;
                if (this.options.stacking) {
                    for(let d = 0; d < a.length; d++)a[d].leftNull = a[d].rightNull = void 0, e[a[d].x] = a[d];
                    H(g, function(a, d) {
                        null !== a.total && t.push(d);
                    });
                    t.sort(function(a, d) {
                        return a - d;
                    });
                    const k = w.map((a)=>a.visible);
                    t.forEach(function(a, q) {
                        let r = 0, b, f;
                        if (e[a] && !e[a].isNull) p.push(e[a]), [
                            -1,
                            1
                        ].forEach(function(c) {
                            const h = 1 === c ? "rightNull" : "leftNull", m = g[t[q + c]];
                            let p = 0;
                            if (m) {
                                let c = d;
                                for(; 0 <= c && c < v;){
                                    const d = w[c].index;
                                    b = m.points[d];
                                    b || (d === l.index ? e[a][h] = !0 : k[c] && (f = g[a].points[d]) && (p -= f[1] - f[0]));
                                    c += u;
                                }
                            }
                            e[a][1 === c ? "rightCliff" : "leftCliff"] = p;
                        });
                        else {
                            let c = d;
                            for(; 0 <= c && c < v;){
                                if (b = g[a].points[w[c].index]) {
                                    r = b[1];
                                    break;
                                }
                                c += u;
                            }
                            r = B(r, 0);
                            r = h.translate(r, 0, 1, 0, 1);
                            p.push({
                                isNull: !0,
                                plotX: m.translate(a, 0, 0, 0, 1),
                                x: a,
                                plotY: r,
                                yBottom: r
                            });
                        }
                    });
                }
                return p;
            }
        }
        u.defaultOptions = z(x.defaultOptions, {
            threshold: 0,
            legendSymbol: "rectangle"
        });
        C(u.prototype, {
            singleStacks: !1
        });
        y.registerSeriesType("area", u);
        "";
        return u;
    });
    M(a, "Series/Spline/SplineSeries.js", [
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        const { line: x } = a.seriesTypes, { merge: L, pick: C } = y;
        class z extends x {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            getPointSpline(a, x, u) {
                const v = x.plotX || 0, l = x.plotY || 0, p = a[u - 1];
                u = a[u + 1];
                let t, m;
                let h;
                if (p && !p.isNull && !1 !== p.doCurve && !x.isCliff && u && !u.isNull && !1 !== u.doCurve && !x.isCliff) {
                    a = p.plotY || 0;
                    var g = u.plotX || 0;
                    u = u.plotY || 0;
                    let e = 0;
                    t = (1.5 * v + (p.plotX || 0)) / 2.5;
                    m = (1.5 * l + a) / 2.5;
                    g = (1.5 * v + g) / 2.5;
                    h = (1.5 * l + u) / 2.5;
                    g !== t && (e = (h - m) * (g - v) / (g - t) + l - h);
                    m += e;
                    h += e;
                    m > a && m > l ? (m = Math.max(a, l), h = 2 * l - m) : m < a && m < l && (m = Math.min(a, l), h = 2 * l - m);
                    h > u && h > l ? (h = Math.max(u, l), m = 2 * l - h) : h < u && h < l && (h = Math.min(u, l), m = 2 * l - h);
                    x.rightContX = g;
                    x.rightContY = h;
                }
                x = [
                    "C",
                    C(p.rightContX, p.plotX, 0),
                    C(p.rightContY, p.plotY, 0),
                    C(t, v, 0),
                    C(m, l, 0),
                    v,
                    l
                ];
                p.rightContX = p.rightContY = void 0;
                return x;
            }
        }
        z.defaultOptions = L(x.defaultOptions);
        a.registerSeriesType("spline", z);
        "";
        return z;
    });
    M(a, "Series/AreaSpline/AreaSplineSeries.js", [
        a["Series/Spline/SplineSeries.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { area: x, area: { prototype: C } } = y.seriesTypes, { extend: z, merge: H } = I;
        class B extends a {
            constructor(){
                super(...arguments);
                this.options = this.points = this.data = void 0;
            }
        }
        B.defaultOptions = H(a.defaultOptions, x.defaultOptions);
        z(B.prototype, {
            getGraphPath: C.getGraphPath,
            getStackPoints: C.getStackPoints,
            drawGraph: C.drawGraph
        });
        y.registerSeriesType("areaspline", B);
        "";
        return B;
    });
    M(a, "Series/Column/ColumnSeriesDefaults.js", [], function() {
        "";
        return {
            borderRadius: 3,
            centerInCategory: !1,
            groupPadding: .2,
            marker: null,
            pointPadding: .1,
            minPointLength: 0,
            cropThreshold: 50,
            pointRange: null,
            states: {
                hover: {
                    halo: !1,
                    brightness: .1
                },
                select: {
                    color: "#cccccc",
                    borderColor: "#000000"
                }
            },
            dataLabels: {
                align: void 0,
                verticalAlign: void 0,
                y: void 0
            },
            startFromThreshold: !0,
            stickyTracking: !1,
            tooltip: {
                distance: 6
            },
            threshold: 0,
            borderColor: "#ffffff"
        };
    });
    M(a, "Series/Column/ColumnSeries.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Color/Color.js"],
        a["Series/Column/ColumnSeriesDefaults.js"],
        a["Core/Globals.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z, H) {
        const { animObject: x } = a, { parse: u } = y, { hasTouch: v, noop: l } = L, { clamp: p, defined: t, extend: m, fireEvent: h, isArray: g, isNumber: e, merge: w, pick: E, objectEach: F } = H;
        class d extends C {
            constructor(){
                super(...arguments);
                this.points = this.options = this.group = this.data = this.borderWidth = void 0;
            }
            animate(a) {
                const d = this, e = this.yAxis, g = e.pos, b = d.options, f = this.chart.inverted, c = {}, k = f ? "translateX" : "translateY";
                let h;
                a ? (c.scaleY = .001, a = p(e.toPixels(b.threshold), g, g + e.len), f ? c.translateX = a - e.len : c.translateY = a, d.clipBox && d.setClip(), d.group.attr(c)) : (h = Number(d.group.attr(k)), d.group.animate({
                    scaleY: 1
                }, m(x(d.options.animation), {
                    step: function(b, a) {
                        d.group && (c[k] = h + a.pos * (g - h), d.group.attr(c));
                    }
                })));
            }
            init(a, d) {
                super.init.apply(this, arguments);
                const e = this;
                a = e.chart;
                a.hasRendered && a.series.forEach(function(a) {
                    a.type === e.type && (a.isDirty = !0);
                });
            }
            getColumnMetrics() {
                const a = this;
                var d = a.options;
                const e = a.xAxis, g = a.yAxis;
                var b = e.options.reversedStacks;
                b = e.reversed && !b || !e.reversed && b;
                const f = {};
                let c, h = 0;
                !1 === d.grouping ? h = 1 : a.chart.series.forEach(function(b) {
                    const d = b.yAxis, e = b.options;
                    let k;
                    b.type !== a.type || !b.visible && a.chart.options.chart.ignoreHiddenSeries || g.len !== d.len || g.pos !== d.pos || (e.stacking && "group" !== e.stacking ? (c = b.stackKey, "undefined" === typeof f[c] && (f[c] = h++), k = f[c]) : !1 !== e.grouping && (k = h++), b.columnIndex = k);
                });
                const l = Math.min(Math.abs(e.transA) * (e.ordinal && e.ordinal.slope || d.pointRange || e.closestPointRange || e.tickInterval || 1), e.len), m = l * d.groupPadding, p = (l - 2 * m) / (h || 1);
                d = Math.min(d.maxPointWidth || e.len, E(d.pointWidth, p * (1 - 2 * d.pointPadding)));
                a.columnMetrics = {
                    width: d,
                    offset: (p - d) / 2 + (m + ((a.columnIndex || 0) + (b ? 1 : 0)) * p - l / 2) * (b ? -1 : 1),
                    paddedWidth: p,
                    columnCount: h
                };
                return a.columnMetrics;
            }
            crispCol(a, d, e, g) {
                var b = this.borderWidth, f = -(b % 2 ? .5 : 0);
                b = b % 2 ? .5 : 1;
                this.options.crisp && (e = Math.round(a + e) + f, a = Math.round(a) + f, e -= a);
                g = Math.round(d + g) + b;
                f = .5 >= Math.abs(d) && .5 < g;
                d = Math.round(d) + b;
                g -= d;
                f && g && (--d, g += 1);
                return {
                    x: a,
                    y: d,
                    width: e,
                    height: g
                };
            }
            adjustForMissingColumns(a, d, e, h) {
                const b = this.options.stacking;
                if (!e.isNull && 1 < h.columnCount) {
                    const f = this.yAxis.options.reversedStacks;
                    let c = 0, k = f ? 0 : -h.columnCount;
                    F(this.yAxis.stacking && this.yAxis.stacking.stacks, (a)=>{
                        if ("number" === typeof e.x) {
                            const d = a[e.x.toString()];
                            d && (a = d.points[this.index], b ? (a && (c = k), d.hasValidPoints && (f ? k++ : k--)) : g(a) && (a = Object.keys(d.points).filter((b)=>!b.match(",") && d.points[b] && 1 < d.points[b].length).map(parseFloat).sort((b, a)=>a - b), c = a.indexOf(this.index), k = a.length));
                        }
                    });
                    a = (e.plotX || 0) + ((k - 1) * h.paddedWidth + d) / 2 - d - c * h.paddedWidth;
                }
                return a;
            }
            translate() {
                const a = this, d = a.chart, g = a.options;
                var l = a.dense = 2 > a.closestPointRange * a.xAxis.transA;
                l = a.borderWidth = E(g.borderWidth, l ? 0 : 1);
                const b = a.xAxis, f = a.yAxis, c = g.threshold, n = E(g.minPointLength, 5), m = a.getColumnMetrics(), w = m.width, v = a.pointXOffset = m.offset, u = a.dataMin, x = a.dataMax;
                let F = a.barW = Math.max(w, 1 + 2 * l), y = a.translatedThreshold = f.getThreshold(c);
                d.inverted && (y -= .5);
                g.pointPadding && (F = Math.ceil(F));
                C.prototype.translate.apply(a);
                a.points.forEach(function(k) {
                    const h = E(k.yBottom, y);
                    var l = 999 + Math.abs(h), q = k.plotX || 0;
                    l = p(k.plotY, -l, f.len + l);
                    let r = Math.min(l, h), D = Math.max(l, h) - r, z = w, B = q + v, G = F;
                    n && Math.abs(D) < n && (D = n, q = !f.reversed && !k.negative || f.reversed && k.negative, e(c) && e(x) && k.y === c && x <= c && (f.min || 0) < c && (u !== x || (f.max || 0) <= c) && (q = !q, k.negative = !k.negative), r = Math.abs(r - y) > n ? h - n : y - (q ? n : 0));
                    t(k.options.pointWidth) && (z = G = Math.ceil(k.options.pointWidth), B -= Math.round((z - w) / 2));
                    g.centerInCategory && (B = a.adjustForMissingColumns(B, z, k, m));
                    k.barX = B;
                    k.pointWidth = z;
                    k.tooltipPos = d.inverted ? [
                        p(f.len + f.pos - d.plotLeft - l, f.pos - d.plotLeft, f.len + f.pos - d.plotLeft),
                        b.len + b.pos - d.plotTop - B - G / 2,
                        D
                    ] : [
                        b.left - d.plotLeft + B + G / 2,
                        p(l + f.pos - d.plotTop, f.pos - d.plotTop, f.len + f.pos - d.plotTop),
                        D
                    ];
                    k.shapeType = a.pointClass.prototype.shapeType || "roundedRect";
                    k.shapeArgs = a.crispCol(B, k.isNull ? y : r, G, k.isNull ? 0 : D);
                });
                h(this, "afterColumnTranslate");
            }
            drawGraph() {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            }
            pointAttribs(a, d) {
                const e = this.options;
                var g = this.pointAttrToOptions || {}, b = g.stroke || "borderColor";
                const f = g["stroke-width"] || "borderWidth";
                let c, k = a && a.color || this.color, h = a && a[b] || e[b] || k;
                g = a && a.options.dashStyle || e.dashStyle;
                let l = a && a[f] || e[f] || this[f] || 0, m = E(a && a.opacity, e.opacity, 1);
                a && this.zones.length && (c = a.getZone(), k = a.options.color || c && (c.color || a.nonZonedColor) || this.color, c && (h = c.borderColor || h, g = c.dashStyle || g, l = c.borderWidth || l));
                d && a && (a = w(e.states[d], a.options.states && a.options.states[d] || {}), d = a.brightness, k = a.color || "undefined" !== typeof d && u(k).brighten(a.brightness).get() || k, h = a[b] || h, l = a[f] || l, g = a.dashStyle || g, m = E(a.opacity, m));
                b = {
                    fill: k,
                    stroke: h,
                    "stroke-width": l,
                    opacity: m
                };
                g && (b.dashstyle = g);
                return b;
            }
            drawPoints(a = this.points) {
                const d = this, g = this.chart, k = d.options, b = g.renderer, f = k.animationLimit || 250;
                let c;
                a.forEach(function(a) {
                    let h = a.graphic, l = !!h, n = h && g.pointCount < f ? "animate" : "attr";
                    if (e(a.plotY) && null !== a.y) {
                        c = a.shapeArgs;
                        h && a.hasNewShapeType() && (h = h.destroy());
                        d.enabledDataSorting && (a.startXPos = d.xAxis.reversed ? -(c ? c.width || 0 : 0) : d.xAxis.width);
                        h || (a.graphic = h = b[a.shapeType](c).add(a.group || d.group)) && d.enabledDataSorting && g.hasRendered && g.pointCount < f && (h.attr({
                            x: a.startXPos
                        }), l = !0, n = "animate");
                        if (h && l) h[n](w(c));
                        g.styledMode || h[n](d.pointAttribs(a, a.selected && "select")).shadow(!1 !== a.allowShadow && k.shadow);
                        h && (h.addClass(a.getClassName(), !0), h.attr({
                            visibility: a.visible ? "inherit" : "hidden"
                        }));
                    } else h && (a.graphic = h.destroy());
                });
            }
            drawTracker(a = this.points) {
                const d = this, e = d.chart, k = e.pointer, b = function(a) {
                    const b = k.getPointFromEvent(a);
                    "undefined" !== typeof b && d.options.enableMouseTracking && (k.isDirectTouch = !0, b.onMouseOver(a));
                };
                let f;
                a.forEach(function(a) {
                    f = g(a.dataLabels) ? a.dataLabels : a.dataLabel ? [
                        a.dataLabel
                    ] : [];
                    a.graphic && (a.graphic.element.point = a);
                    f.forEach(function(b) {
                        b.div ? b.div.point = a : b.element.point = a;
                    });
                });
                d._hasTracking || (d.trackerGroups.forEach(function(a) {
                    if (d[a]) {
                        d[a].addClass("highcharts-tracker").on("mouseover", b).on("mouseout", function(a) {
                            k.onTrackerMouseOut(a);
                        });
                        if (v) d[a].on("touchstart", b);
                        !e.styledMode && d.options.cursor && d[a].css({
                            cursor: d.options.cursor
                        });
                    }
                }), d._hasTracking = !0);
                h(this, "afterDrawTracker");
            }
            remove() {
                const a = this, d = a.chart;
                d.hasRendered && d.series.forEach(function(d) {
                    d.type === a.type && (d.isDirty = !0);
                });
                C.prototype.remove.apply(a, arguments);
            }
        }
        d.defaultOptions = w(C.defaultOptions, I);
        m(d.prototype, {
            cropShoulder: 0,
            directTouch: !0,
            getSymbol: l,
            negStacks: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        });
        z.registerSeriesType("column", d);
        "";
        return d;
    });
    M(a, "Core/Series/DataLabel.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Templating.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { getDeferredAnimation: x } = a, { format: C } = y, { defined: z, extend: H, fireEvent: B, isArray: u, isString: v, merge: l, objectEach: p, pick: t, splat: m } = I;
        var h;
        (function(a) {
            function e(a, d, c, e, g) {
                const b = this.chart;
                var f = this.isCartesian && b.inverted;
                const k = this.enabledDataSorting;
                var h = a.plotX, l = a.plotY;
                const n = c.rotation;
                var m = c.align;
                l = z(h) && z(l) && b.isInsidePlot(h, Math.round(l), {
                    inverted: f,
                    paneCoordinates: !0,
                    series: this
                });
                let p = "justify" === t(c.overflow, k ? "none" : "justify");
                f = this.visible && !1 !== a.visible && z(h) && (a.series.forceDL || k && !p || l || t(c.inside, !!this.options.stacking) && e && b.isInsidePlot(h, f ? e.x + 1 : e.y + e.height - 1, {
                    inverted: f,
                    paneCoordinates: !0,
                    series: this
                }));
                h = a.pos();
                if (f && h) {
                    n && d.attr({
                        align: m
                    });
                    m = d.getBBox(!0);
                    var q = [
                        0,
                        0
                    ];
                    var r = b.renderer.fontMetrics(d).b;
                    e = H({
                        x: h[0],
                        y: Math.round(h[1]),
                        width: 0,
                        height: 0
                    }, e);
                    H(c, {
                        width: m.width,
                        height: m.height
                    });
                    n ? (p = !1, q = b.renderer.rotCorr(r, n), r = {
                        x: e.x + (c.x || 0) + e.width / 2 + q.x,
                        y: e.y + (c.y || 0) + ({
                            top: 0,
                            middle: .5,
                            bottom: 1
                        })[c.verticalAlign] * e.height
                    }, q = [
                        m.x - Number(d.attr("x")),
                        m.y - Number(d.attr("y"))
                    ], k && this.xAxis && !p && this.setDataLabelStartPos(a, d, g, l, r), d[g ? "attr" : "animate"](r)) : (k && this.xAxis && !p && this.setDataLabelStartPos(a, d, g, l, e), d.align(c, void 0, e), r = d.alignAttr);
                    if (p && 0 <= e.height) this.justifyDataLabel(d, c, r, m, e, g);
                    else if (t(c.crop, !0)) {
                        let { x: a, y: c } = r;
                        a += q[0];
                        c += q[1];
                        f = b.isInsidePlot(a, c, {
                            paneCoordinates: !0,
                            series: this
                        }) && b.isInsidePlot(a + m.width, c + m.height, {
                            paneCoordinates: !0,
                            series: this
                        });
                    }
                    if (c.shape && !n) d[g ? "attr" : "animate"]({
                        anchorX: h[0],
                        anchorY: h[1]
                    });
                }
                g && k && (d.placed = !1);
                f || k && !p ? d.show() : (d.hide(), d.placed = !1);
            }
            function g(a, d) {
                var b = d.filter;
                return b ? (d = b.operator, a = a[b.property], b = b.value, ">" === d && a > b || "<" === d && a < b || ">=" === d && a >= b || "<=" === d && a <= b || "==" === d && a == b || "===" === d && a === b ? !0 : !1) : !0;
            }
            function h() {
                return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
            }
            function F(a) {
                const b = this.hasRendered || 0, c = this.initDataLabelsGroup().attr({
                    opacity: +b
                });
                !b && c && (this.visible && c.show(), this.options.animation ? c.animate({
                    opacity: 1
                }, a) : c.attr({
                    opacity: 1
                }));
                return c;
            }
            function d(a = this.points) {
                var b, c;
                const d = this, e = d.chart, k = d.options, h = e.renderer, { backgroundColor: l, plotBackgroundColor: q } = e.options.chart, w = e.options.plotOptions, E = h.getContrast(v(q) && q || v(l) && l || "#000000");
                let F = k.dataLabels, A, y;
                var G = m(F)[0];
                const H = G.animation;
                G = G.defer ? x(e, H, d) : {
                    defer: 0,
                    duration: 0
                };
                F = r(r(null === (b = null === w || void 0 === w ? void 0 : w.series) || void 0 === b ? void 0 : b.dataLabels, null === (c = null === w || void 0 === w ? void 0 : w[d.type]) || void 0 === c ? void 0 : c.dataLabels), F);
                B(this, "drawDataLabels");
                if (u(F) || F.enabled || d._hasPointLabels) y = this.initDataLabels(G), a.forEach((a)=>{
                    var b;
                    const c = a.dataLabels || [];
                    A = m(r(F, a.dlOptions || (null === (b = a.options) || void 0 === b ? void 0 : b.dataLabels)));
                    A.forEach((b, f)=>{
                        var l, m = b.enabled && (!a.isNull || a.dataLabelOnNull) && g(a, b);
                        const n = a.connectors ? a.connectors[f] : a.connector, q = b.style || {};
                        let r = {}, w = c[f], u = !w;
                        const x = t(b.distance, a.labelDistance);
                        if (m) {
                            var A = t(b[a.formatPrefix + "Format"], b.format);
                            var F = a.getLabelConfig();
                            F = z(A) ? C(A, F, e) : (b[a.formatPrefix + "Formatter"] || b.formatter).call(F, b);
                            A = b.rotation;
                            e.styledMode || (q.color = t(b.color, q.color, v(d.color) ? d.color : void 0, "#000000"), "contrast" === q.color ? (a.contrastColor = h.getContrast(a.color || d.color), q.color = !z(x) && b.inside || 0 > (x || 0) || k.stacking ? a.contrastColor : E) : delete a.contrastColor, k.cursor && (q.cursor = k.cursor));
                            r = {
                                r: b.borderRadius || 0,
                                rotation: A,
                                padding: b.padding,
                                zIndex: 1
                            };
                            if (!e.styledMode) {
                                const { backgroundColor: c, borderColor: d } = b;
                                r.fill = "auto" === c ? a.color : c;
                                r.stroke = "auto" === d ? a.color : d;
                                r["stroke-width"] = b.borderWidth;
                            }
                            p(r, (a, b)=>{
                                "undefined" === typeof a && delete r[b];
                            });
                        }
                        !w || m && z(F) && !!w.div === !!b.useHTML && (w.rotation && b.rotation || w.rotation === b.rotation) || (w = void 0, u = !0, n && a.connector && (a.connector = a.connector.destroy(), a.connectors && (1 === a.connectors.length ? delete a.connectors : delete a.connectors[f])));
                        m && z(F) && (w ? r.text = F : (w = A ? h.text(F, 0, 0, b.useHTML).addClass("highcharts-data-label") : h.label(F, 0, 0, b.shape, void 0, void 0, b.useHTML, void 0, "data-label")) && w.addClass(" highcharts-data-label-color-" + a.colorIndex + " " + (b.className || "") + (b.useHTML ? " highcharts-tracker" : "")), w && (w.options = b, w.attr(r), e.styledMode || w.css(q).shadow(b.shadow), (m = b[a.formatPrefix + "TextPath"] || b.textPath) && !b.useHTML && (w.setTextPath((null === (l = a.getDataLabelPath) || void 0 === l ? void 0 : l.call(a, w)) || a.graphic, m), a.dataLabelPath && !m.enabled && (a.dataLabelPath = a.dataLabelPath.destroy())), w.added || w.add(y), d.alignDataLabel(a, w, b, void 0, u), w.isActive = !0, c[f] && c[f] !== w && c[f].destroy(), c[f] = w));
                    });
                    for(b = c.length; b--;)c[b].isActive ? c[b].isActive = !1 : (c[b].destroy(), c.splice(b, 1));
                    a.dataLabel = c[0];
                    a.dataLabels = c;
                });
                B(this, "afterDrawDataLabels");
            }
            function k(a, d, c, e, g, k) {
                const b = this.chart, f = d.align, h = d.verticalAlign, l = a.box ? 0 : a.padding || 0;
                let { x: m = 0, y: n = 0 } = d, p, q;
                p = (c.x || 0) + l;
                0 > p && ("right" === f && 0 <= m ? (d.align = "left", d.inside = !0) : m -= p, q = !0);
                p = (c.x || 0) + e.width - l;
                p > b.plotWidth && ("left" === f && 0 >= m ? (d.align = "right", d.inside = !0) : m += b.plotWidth - p, q = !0);
                p = c.y + l;
                0 > p && ("bottom" === h && 0 <= n ? (d.verticalAlign = "top", d.inside = !0) : n -= p, q = !0);
                p = (c.y || 0) + e.height - l;
                p > b.plotHeight && ("top" === h && 0 >= n ? (d.verticalAlign = "bottom", d.inside = !0) : n += b.plotHeight - p, q = !0);
                q && (d.x = m, d.y = n, a.placed = !k, a.align(d, void 0, g));
                return q;
            }
            function r(a, d) {
                let b = [], f;
                if (u(a) && !u(d)) b = a.map(function(a) {
                    return l(a, d);
                });
                else if (u(d) && !u(a)) b = d.map(function(b) {
                    return l(a, b);
                });
                else if (!u(a) && !u(d)) b = l(a, d);
                else if (u(a) && u(d)) for(f = Math.max(a.length, d.length); f--;)b[f] = l(a[f], d[f]);
                return b;
            }
            function q(a, d, c, e, g) {
                const b = this.chart, f = b.inverted, k = this.xAxis, h = k.reversed, l = f ? d.height / 2 : d.width / 2;
                a = (a = a.pointWidth) ? a / 2 : 0;
                d.startXPos = f ? g.x : h ? -l - a : k.width - l + a;
                d.startYPos = f ? h ? this.yAxis.height - l + a : -l - a : g.y;
                e ? "hidden" === d.visibility && (d.show(), d.attr({
                    opacity: 0
                }).animate({
                    opacity: 1
                })) : d.attr({
                    opacity: 1
                }).animate({
                    opacity: 0
                }, void 0, d.hide);
                b.hasRendered && (c && d.attr({
                    x: d.startXPos,
                    y: d.startYPos
                }), d.placed = !0);
            }
            const y = [];
            a.compose = function(a) {
                I.pushUnique(y, a) && (a = a.prototype, a.initDataLabelsGroup = h, a.initDataLabels = F, a.alignDataLabel = e, a.drawDataLabels = d, a.justifyDataLabel = k, a.setDataLabelStartPos = q);
            };
        })(h || (h = {}));
        "";
        return h;
    });
    M(a, "Series/Column/ColumnDataLabel.js", [
        a["Core/Series/DataLabel.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { series: x } = y, { merge: C, pick: z } = I;
        var H;
        (function(y) {
            function u(a, p, t, m, h) {
                let g = this.chart.inverted;
                var e = a.series;
                let l = (e.xAxis ? e.xAxis.len : this.chart.plotSizeX) || 0;
                e = (e.yAxis ? e.yAxis.len : this.chart.plotSizeY) || 0;
                var v = a.dlBox || a.shapeArgs;
                let u = z(a.below, a.plotY > z(this.translatedThreshold, e)), d = z(t.inside, !!this.options.stacking);
                v && (m = C(v), 0 > m.y && (m.height += m.y, m.y = 0), v = m.y + m.height - e, 0 < v && v < m.height && (m.height -= v), g && (m = {
                    x: e - m.y - m.height,
                    y: l - m.x - m.width,
                    width: m.height,
                    height: m.width
                }), d || (g ? (m.x += u ? 0 : m.width, m.width = 0) : (m.y += u ? m.height : 0, m.height = 0)));
                t.align = z(t.align, !g || d ? "center" : u ? "right" : "left");
                t.verticalAlign = z(t.verticalAlign, g || d ? "middle" : u ? "top" : "bottom");
                x.prototype.alignDataLabel.call(this, a, p, t, m, h);
                t.inside && a.contrastColor && p.css({
                    color: a.contrastColor
                });
            }
            const v = [];
            y.compose = function(l) {
                a.compose(x);
                I.pushUnique(v, l) && (l.prototype.alignDataLabel = u);
            };
        })(H || (H = {}));
        return H;
    });
    M(a, "Series/Bar/BarSeries.js", [
        a["Series/Column/ColumnSeries.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { extend: x, merge: C } = I;
        class z extends a {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
        }
        z.defaultOptions = C(a.defaultOptions, {});
        x(z.prototype, {
            inverted: !0
        });
        y.registerSeriesType("bar", z);
        "";
        return z;
    });
    M(a, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
        "";
        return {
            lineWidth: 0,
            findNearestPointBy: "xy",
            jitter: {
                x: 0,
                y: 0
            },
            marker: {
                enabled: !0
            },
            tooltip: {
                headerFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-size: 0.8em"> {series.name}</span><br/>',
                pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
            }
        };
    });
    M(a, "Series/Scatter/ScatterSeries.js", [
        a["Series/Scatter/ScatterSeriesDefaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { column: x, line: C } = y.seriesTypes, { addEvent: z, extend: H, merge: B } = I;
        class u extends C {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            applyJitter() {
                const a = this, l = this.options.jitter, p = this.points.length;
                l && this.points.forEach(function(t, m) {
                    [
                        "x",
                        "y"
                    ].forEach(function(h, g) {
                        let e = "plot" + h.toUpperCase(), w, v;
                        if (l[h] && !t.isNull) {
                            var u = a[h + "Axis"];
                            v = l[h] * u.transA;
                            u && !u.isLog && (w = Math.max(0, t[e] - v), u = Math.min(u.len, t[e] + v), g = 1E4 * Math.sin(m + g * p), g -= Math.floor(g), t[e] = w + (u - w) * g, "x" === h && (t.clientX = t.plotX));
                        }
                    });
                });
            }
            drawGraph() {
                this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
            }
        }
        u.defaultOptions = B(C.defaultOptions, a);
        H(u.prototype, {
            drawTracker: x.prototype.drawTracker,
            sorted: !1,
            requireSorting: !1,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ],
            takeOrdinalPosition: !1
        });
        z(u, "afterTranslate", function() {
            this.applyJitter();
        });
        y.registerSeriesType("scatter", u);
        return u;
    });
    M(a, "Series/CenteredUtilities.js", [
        a["Core/Globals.js"],
        a["Core/Series/Series.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { deg2rad: x } = a, { fireEvent: C, isNumber: z, pick: H, relativeLength: B } = I;
        var u;
        (function(a) {
            a.getCenter = function() {
                var a = this.options, p = this.chart;
                const t = 2 * (a.slicedOffset || 0), m = p.plotWidth - 2 * t, h = p.plotHeight - 2 * t;
                var g = a.center;
                const e = Math.min(m, h), w = a.thickness;
                var v = a.size;
                let u = a.innerSize || 0;
                "string" === typeof v && (v = parseFloat(v));
                "string" === typeof u && (u = parseFloat(u));
                a = [
                    H(g[0], "50%"),
                    H(g[1], "50%"),
                    H(v && 0 > v ? void 0 : a.size, "100%"),
                    H(u && 0 > u ? void 0 : a.innerSize || 0, "0%")
                ];
                !p.angular || this instanceof y || (a[3] = 0);
                for(g = 0; 4 > g; ++g)v = a[g], p = 2 > g || 2 === g && /%$/.test(v), a[g] = B(v, [
                    m,
                    h,
                    e,
                    a[2]
                ][g]) + (p ? t : 0);
                a[3] > a[2] && (a[3] = a[2]);
                z(w) && 2 * w < a[2] && 0 < w && (a[3] = a[2] - 2 * w);
                C(this, "afterGetCenter", {
                    positions: a
                });
                return a;
            };
            a.getStartAndEndRadians = function(a, p) {
                a = z(a) ? a : 0;
                p = z(p) && p > a && 360 > p - a ? p : a + 360;
                return {
                    start: x * (a + -90),
                    end: x * (p + -90)
                };
            };
        })(u || (u = {}));
        "";
        return u;
    });
    M(a, "Series/Pie/PiePoint.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Series/Point.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I) {
        const { setAnimation: x } = a, { addEvent: C, defined: z, extend: H, isNumber: B, pick: u, relativeLength: v } = I;
        class l extends y {
            constructor(){
                super(...arguments);
                this.series = this.options = this.labelDistance = void 0;
            }
            getConnectorPath() {
                const a = this.labelPosition, l = this.series.options.dataLabels, m = this.connectorShapes;
                let h = l.connectorShape;
                m[h] && (h = m[h]);
                return h.call(this, {
                    x: a.computed.x,
                    y: a.computed.y,
                    alignment: a.alignment
                }, a.connectorPosition, l);
            }
            getTranslate() {
                return this.sliced ? this.slicedTranslation : {
                    translateX: 0,
                    translateY: 0
                };
            }
            haloPath(a) {
                const l = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(l.x, l.y, l.r + a, l.r + a, {
                    innerR: l.r - 1,
                    start: l.start,
                    end: l.end,
                    borderRadius: l.borderRadius
                });
            }
            init() {
                super.init.apply(this, arguments);
                this.name = u(this.name, "Slice");
                const a = (a)=>{
                    this.slice("select" === a.type);
                };
                C(this, "select", a);
                C(this, "unselect", a);
                return this;
            }
            isValid() {
                return B(this.y) && 0 <= this.y;
            }
            setVisible(a, l) {
                const m = this.series, h = m.chart, g = m.options.ignoreHiddenPoint;
                l = u(l, g);
                a !== this.visible && (this.visible = this.options.visible = a = "undefined" === typeof a ? !this.visible : a, m.options.data[m.data.indexOf(this)] = this.options, [
                    "graphic",
                    "dataLabel",
                    "connector"
                ].forEach((e)=>{
                    if (this[e]) this[e][a ? "show" : "hide"](a);
                }), this.legendItem && h.legend.colorizeItem(this, a), a || "hover" !== this.state || this.setState(""), g && (m.isDirty = !0), l && h.redraw());
            }
            slice(a, l, m) {
                const h = this.series;
                x(m, h.chart);
                u(l, !0);
                this.sliced = this.options.sliced = z(a) ? a : !this.sliced;
                h.options.data[h.data.indexOf(this)] = this.options;
                this.graphic && this.graphic.animate(this.getTranslate());
            }
        }
        H(l.prototype, {
            connectorShapes: {
                fixedOffset: function(a, l, m) {
                    const h = l.breakAt;
                    l = l.touchingSliceAt;
                    return [
                        [
                            "M",
                            a.x,
                            a.y
                        ],
                        m.softConnector ? [
                            "C",
                            a.x + ("left" === a.alignment ? -5 : 5),
                            a.y,
                            2 * h.x - l.x,
                            2 * h.y - l.y,
                            h.x,
                            h.y
                        ] : [
                            "L",
                            h.x,
                            h.y
                        ],
                        [
                            "L",
                            l.x,
                            l.y
                        ]
                    ];
                },
                straight: function(a, l) {
                    l = l.touchingSliceAt;
                    return [
                        [
                            "M",
                            a.x,
                            a.y
                        ],
                        [
                            "L",
                            l.x,
                            l.y
                        ]
                    ];
                },
                crookedLine: function(a, l, m) {
                    const { breakAt: h, touchingSliceAt: g } = l;
                    ({ series: l } = this);
                    const [e, p, t] = l.center, u = t / 2, d = l.chart.plotWidth, k = l.chart.plotLeft;
                    l = "left" === a.alignment;
                    const { x: r, y: q } = a;
                    m.crookDistance ? (a = v(m.crookDistance, 1), a = l ? e + u + (d + k - e - u) * (1 - a) : k + (e - u) * a) : a = e + (p - q) * Math.tan((this.angle || 0) - Math.PI / 2);
                    m = [
                        [
                            "M",
                            r,
                            q
                        ]
                    ];
                    (l ? a <= r && a >= h.x : a >= r && a <= h.x) && m.push([
                        "L",
                        a,
                        q
                    ]);
                    m.push([
                        "L",
                        h.x,
                        h.y
                    ], [
                        "L",
                        g.x,
                        g.y
                    ]);
                    return m;
                }
            }
        });
        return l;
    });
    M(a, "Series/Pie/PieSeriesDefaults.js", [], function() {
        "";
        return {
            borderRadius: 3,
            center: [
                null,
                null
            ],
            clip: !1,
            colorByPoint: !0,
            dataLabels: {
                allowOverlap: !0,
                connectorPadding: 5,
                connectorShape: "crookedLine",
                crookDistance: void 0,
                distance: 30,
                enabled: !0,
                formatter: function() {
                    return this.point.isNull ? void 0 : this.point.name;
                },
                softConnector: !0,
                x: 0
            },
            fillColor: void 0,
            ignoreHiddenPoint: !0,
            inactiveOtherPoints: !0,
            legendType: "point",
            marker: null,
            size: null,
            showInLegend: !1,
            slicedOffset: 10,
            stickyTracking: !1,
            tooltip: {
                followPointer: !0
            },
            borderColor: "#ffffff",
            borderWidth: 1,
            lineWidth: void 0,
            states: {
                hover: {
                    brightness: .1
                }
            }
        };
    });
    M(a, "Series/Pie/PieSeries.js", [
        a["Series/CenteredUtilities.js"],
        a["Series/Column/ColumnSeries.js"],
        a["Core/Globals.js"],
        a["Series/Pie/PiePoint.js"],
        a["Series/Pie/PieSeriesDefaults.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/Symbols.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z, H, B, u) {
        const { getStartAndEndRadians: v } = a;
        ({ noop: I } = I);
        const { clamp: l, extend: p, fireEvent: t, merge: m, pick: h, relativeLength: g } = u;
        class e extends z {
            constructor(){
                super(...arguments);
                this.points = this.options = this.maxLabelDistance = this.data = this.center = void 0;
            }
            animate(a) {
                const e = this, g = e.points, d = e.startAngleRad;
                a || g.forEach(function(a) {
                    const g = a.graphic, k = a.shapeArgs;
                    g && k && (g.attr({
                        r: h(a.startR, e.center && e.center[3] / 2),
                        start: d,
                        end: d
                    }), g.animate({
                        r: k.r,
                        start: k.start,
                        end: k.end
                    }, e.options.animation));
                });
            }
            drawEmpty() {
                const a = this.startAngleRad, e = this.endAngleRad, g = this.options;
                let d, k;
                0 === this.total && this.center ? (d = this.center[0], k = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(d, k, this.center[1] / 2, 0, a, e).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
                    d: B.arc(d, k, this.center[2] / 2, 0, {
                        start: a,
                        end: e,
                        innerR: this.center[3] / 2
                    })
                }), this.chart.styledMode || this.graph.attr({
                    "stroke-width": g.borderWidth,
                    fill: g.fillColor || "none",
                    stroke: g.color || "#cccccc"
                })) : this.graph && (this.graph = this.graph.destroy());
            }
            drawPoints() {
                const a = this.chart.renderer;
                this.points.forEach(function(e) {
                    e.graphic && e.hasNewShapeType() && (e.graphic = e.graphic.destroy());
                    e.graphic || (e.graphic = a[e.shapeType](e.shapeArgs).add(e.series.group), e.delayedRendering = !0);
                });
            }
            generatePoints() {
                super.generatePoints();
                this.updateTotals();
            }
            getX(a, e, g) {
                const d = this.center, k = this.radii ? this.radii[g.index] || 0 : d[2] / 2;
                a = Math.asin(l((a - d[1]) / (k + g.labelDistance), -1, 1));
                return d[0] + (e ? -1 : 1) * Math.cos(a) * (k + g.labelDistance) + (0 < g.labelDistance ? (e ? -1 : 1) * this.options.dataLabels.padding : 0);
            }
            hasData() {
                return !!this.processedXData.length;
            }
            redrawPoints() {
                const a = this, e = a.chart;
                let g, d, k, h;
                this.drawEmpty();
                a.group && !e.styledMode && a.group.shadow(a.options.shadow);
                a.points.forEach(function(l) {
                    const q = {};
                    d = l.graphic;
                    !l.isNull && d ? (h = l.shapeArgs, g = l.getTranslate(), e.styledMode || (k = a.pointAttribs(l, l.selected && "select")), l.delayedRendering ? (d.setRadialReference(a.center).attr(h).attr(g), e.styledMode || d.attr(k).attr({
                        "stroke-linejoin": "round"
                    }), l.delayedRendering = !1) : (d.setRadialReference(a.center), e.styledMode || m(!0, q, k), m(!0, q, h, g), d.animate(q)), d.attr({
                        visibility: l.visible ? "inherit" : "hidden"
                    }), d.addClass(l.getClassName(), !0)) : d && (l.graphic = d.destroy());
                });
            }
            sortByAngle(a, e) {
                a.sort(function(a, d) {
                    return "undefined" !== typeof a.angle && (d.angle - a.angle) * e;
                });
            }
            translate(a) {
                t(this, "translate");
                this.generatePoints();
                var e = this.options;
                const l = e.slicedOffset, d = l + (e.borderWidth || 0);
                var k = v(e.startAngle, e.endAngle);
                const m = this.startAngleRad = k.start;
                k = (this.endAngleRad = k.end) - m;
                const q = this.points, p = e.dataLabels.distance;
                e = e.ignoreHiddenPoint;
                const b = q.length;
                let f, c, n, w = 0;
                a || (this.center = a = this.getCenter());
                for(c = 0; c < b; c++){
                    n = q[c];
                    var u = m + w * k;
                    !n.isValid() || e && !n.visible || (w += n.percentage / 100);
                    var x = m + w * k;
                    var y = {
                        x: a[0],
                        y: a[1],
                        r: a[2] / 2,
                        innerR: a[3] / 2,
                        start: Math.round(1E3 * u) / 1E3,
                        end: Math.round(1E3 * x) / 1E3
                    };
                    n.shapeType = "arc";
                    n.shapeArgs = y;
                    n.labelDistance = h(n.options.dataLabels && n.options.dataLabels.distance, p);
                    n.labelDistance = g(n.labelDistance, y.r);
                    this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, n.labelDistance);
                    x = (x + u) / 2;
                    x > 1.5 * Math.PI ? x -= 2 * Math.PI : x < -Math.PI / 2 && (x += 2 * Math.PI);
                    n.slicedTranslation = {
                        translateX: Math.round(Math.cos(x) * l),
                        translateY: Math.round(Math.sin(x) * l)
                    };
                    y = Math.cos(x) * a[2] / 2;
                    f = Math.sin(x) * a[2] / 2;
                    n.tooltipPos = [
                        a[0] + .7 * y,
                        a[1] + .7 * f
                    ];
                    n.half = x < -Math.PI / 2 || x > Math.PI / 2 ? 1 : 0;
                    n.angle = x;
                    u = Math.min(d, n.labelDistance / 5);
                    n.labelPosition = {
                        natural: {
                            x: a[0] + y + Math.cos(x) * n.labelDistance,
                            y: a[1] + f + Math.sin(x) * n.labelDistance
                        },
                        computed: {},
                        alignment: 0 > n.labelDistance ? "center" : n.half ? "right" : "left",
                        connectorPosition: {
                            breakAt: {
                                x: a[0] + y + Math.cos(x) * u,
                                y: a[1] + f + Math.sin(x) * u
                            },
                            touchingSliceAt: {
                                x: a[0] + y,
                                y: a[1] + f
                            }
                        }
                    };
                }
                t(this, "afterTranslate");
            }
            updateTotals() {
                const a = this.points, e = a.length, g = this.options.ignoreHiddenPoint;
                let d, k, h = 0;
                for(d = 0; d < e; d++)k = a[d], !k.isValid() || g && !k.visible || (h += k.y);
                this.total = h;
                for(d = 0; d < e; d++)k = a[d], k.percentage = 0 < h && (k.visible || !g) ? k.y / h * 100 : 0, k.total = h;
            }
        }
        e.defaultOptions = m(z.defaultOptions, C);
        p(e.prototype, {
            axisTypes: [],
            directTouch: !0,
            drawGraph: void 0,
            drawTracker: y.prototype.drawTracker,
            getCenter: a.getCenter,
            getSymbol: I,
            isCartesian: !1,
            noSharedTooltip: !0,
            pointAttribs: y.prototype.pointAttribs,
            pointClass: L,
            requireSorting: !1,
            searchPoint: I,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        });
        H.registerSeriesType("pie", e);
        return e;
    });
    M(a, "Series/Pie/PieDataLabel.js", [
        a["Core/Series/DataLabel.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C) {
        const { noop: x } = y, { distribute: H } = I, { series: B } = L, { arrayMax: u, clamp: v, defined: l, merge: p, pick: t, relativeLength: m } = C;
        var h;
        (function(g) {
            function e() {
                const a = this, d = a.data, e = a.chart, g = a.options.dataLabels || {}, b = g.connectorPadding, f = e.plotWidth, c = e.plotHeight, h = e.plotLeft, m = Math.round(e.chartWidth / 3), w = a.center, v = w[2] / 2, x = w[1], y = [
                    [],
                    []
                ], z = [
                    0,
                    0,
                    0,
                    0
                ], F = a.dataLabelPositioners;
                let C, A, E, I, L, M, J, N, O, S, W, U;
                a.visible && (g.enabled || a._hasPointLabels) && (d.forEach(function(a) {
                    a.dataLabel && a.visible && a.dataLabel.shortened && (a.dataLabel.attr({
                        width: "auto"
                    }).css({
                        width: "auto",
                        textOverflow: "clip"
                    }), a.dataLabel.shortened = !1);
                }), B.prototype.drawDataLabels.apply(a), d.forEach(function(a) {
                    a.dataLabel && (a.visible ? (y[a.half].push(a), a.dataLabel._pos = null, !l(g.style.width) && !l(a.options.dataLabels && a.options.dataLabels.style && a.options.dataLabels.style.width) && a.dataLabel.getBBox().width > m && (a.dataLabel.css({
                        width: Math.round(.7 * m) + "px"
                    }), a.dataLabel.shortened = !0)) : (a.dataLabel = a.dataLabel.destroy(), a.dataLabels && 1 === a.dataLabels.length && delete a.dataLabels));
                }), y.forEach((d, k)=>{
                    const m = d.length, n = [];
                    let q, p = 0;
                    if (m) {
                        a.sortByAngle(d, k - .5);
                        if (0 < a.maxLabelDistance) {
                            var r = Math.max(0, x - v - a.maxLabelDistance);
                            q = Math.min(x + v + a.maxLabelDistance, e.plotHeight);
                            d.forEach(function(a) {
                                0 < a.labelDistance && a.dataLabel && (a.top = Math.max(0, x - v - a.labelDistance), a.bottom = Math.min(x + v + a.labelDistance, e.plotHeight), p = a.dataLabel.getBBox().height || 21, a.distributeBox = {
                                    target: a.labelPosition.natural.y - a.top + p / 2,
                                    size: p,
                                    rank: a.y
                                }, n.push(a.distributeBox));
                            });
                            r = q + p - r;
                            H(n, r, r / 5);
                        }
                        for(W = 0; W < m; W++){
                            C = d[W];
                            M = C.labelPosition;
                            I = C.dataLabel;
                            S = !1 === C.visible ? "hidden" : "inherit";
                            O = r = M.natural.y;
                            n && l(C.distributeBox) && ("undefined" === typeof C.distributeBox.pos ? S = "hidden" : (J = C.distributeBox.size, O = F.radialDistributionY(C)));
                            delete C.positionIndex;
                            if (g.justify) N = F.justify(C, v, w);
                            else switch(g.alignTo){
                                case "connectors":
                                    N = F.alignToConnectors(d, k, f, h);
                                    break;
                                case "plotEdges":
                                    N = F.alignToPlotEdges(I, k, f, h);
                                    break;
                                default:
                                    N = F.radialDistributionX(a, C, O, r);
                            }
                            I._attr = {
                                visibility: S,
                                align: M.alignment
                            };
                            U = C.options.dataLabels || {};
                            I._pos = {
                                x: N + t(U.x, g.x) + (({
                                    left: b,
                                    right: -b
                                })[M.alignment] || 0),
                                y: O + t(U.y, g.y) - I.getBBox().height / 2
                            };
                            M && (M.computed.x = N, M.computed.y = O);
                            t(g.crop, !0) && (L = I.getBBox().width, r = null, N - L < b && 1 === k ? (r = Math.round(L - N + b), z[3] = Math.max(r, z[3])) : N + L > f - b && 0 === k && (r = Math.round(N + L - f + b), z[1] = Math.max(r, z[1])), 0 > O - J / 2 ? z[0] = Math.max(Math.round(-O + J / 2), z[0]) : O + J / 2 > c && (z[2] = Math.max(Math.round(O + J / 2 - c), z[2])), I.sideOverflow = r);
                        }
                    }
                }), 0 === u(z) || this.verifyDataLabelOverflow(z)) && (this.placeDataLabels(), this.points.forEach(function(b) {
                    U = p(g, b.options.dataLabels);
                    if (A = t(U.connectorWidth, 1)) {
                        let c;
                        E = b.connector;
                        if ((I = b.dataLabel) && I._pos && b.visible && 0 < b.labelDistance) {
                            S = I._attr.visibility;
                            if (c = !E) b.connector = E = e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + b.colorIndex + (b.className ? " " + b.className : "")).add(a.dataLabelsGroup), e.styledMode || E.attr({
                                "stroke-width": A,
                                stroke: U.connectorColor || b.color || "#666666"
                            });
                            E[c ? "attr" : "animate"]({
                                d: b.getConnectorPath()
                            });
                            E.attr("visibility", S);
                        } else E && (b.connector = E.destroy());
                    }
                }));
            }
            function h() {
                this.points.forEach(function(a) {
                    let d = a.dataLabel, e;
                    d && a.visible && ((e = d._pos) ? (d.sideOverflow && (d._attr.width = Math.max(d.getBBox().width - d.sideOverflow, 0), d.css({
                        width: d._attr.width + "px",
                        textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis"
                    }), d.shortened = !0), d.attr(d._attr), d[d.moved ? "animate" : "attr"](e), d.moved = !0) : d && d.attr({
                        y: -9999
                    }));
                    delete a.distributeBox;
                }, this);
            }
            function y(a) {
                let d = this.center, e = this.options, g = e.center, b = e.minSize || 80, f, c = null !== e.size;
                c || (null !== g[0] ? f = Math.max(d[2] - Math.max(a[1], a[3]), b) : (f = Math.max(d[2] - a[1] - a[3], b), d[0] += (a[3] - a[1]) / 2), null !== g[1] ? f = v(f, b, d[2] - Math.max(a[0], a[2])) : (f = v(f, b, d[2] - a[0] - a[2]), d[1] += (a[0] - a[2]) / 2), f < d[2] ? (d[2] = f, d[3] = Math.min(e.thickness ? Math.max(0, f - 2 * e.thickness) : Math.max(0, m(e.innerSize || 0, f)), f), this.translate(d), this.drawDataLabels && this.drawDataLabels()) : c = !0);
                return c;
            }
            const z = [], d = {
                radialDistributionY: function(a) {
                    return a.top + a.distributeBox.pos;
                },
                radialDistributionX: function(a, d, e, g) {
                    return a.getX(e < d.top + 2 || e > d.bottom - 2 ? g : e, d.half, d);
                },
                justify: function(a, d, e) {
                    return e[0] + (a.half ? -1 : 1) * (d + a.labelDistance);
                },
                alignToPlotEdges: function(a, d, e, g) {
                    a = a.getBBox().width;
                    return d ? a + g : e - a - g;
                },
                alignToConnectors: function(a, d, e, g) {
                    let b = 0, f;
                    a.forEach(function(a) {
                        f = a.dataLabel.getBBox().width;
                        f > b && (b = f);
                    });
                    return d ? b + g : e - b - g;
                }
            };
            g.compose = function(g) {
                a.compose(B);
                C.pushUnique(z, g) && (g = g.prototype, g.dataLabelPositioners = d, g.alignDataLabel = x, g.drawDataLabels = e, g.placeDataLabels = h, g.verifyDataLabelOverflow = y);
            };
        })(h || (h = {}));
        return h;
    });
    M(a, "Extensions/OverlappingDataLabels.js", [
        a["Core/Chart/Chart.js"],
        a["Core/Utilities.js"]
    ], function(a, y) {
        function x(a, l) {
            let p, t = !1;
            a && (p = a.newOpacity, a.oldOpacity !== p && (a.alignAttr && a.placed ? (a[p ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), t = !0, a.alignAttr.opacity = p, a[a.isOld ? "animate" : "attr"](a.alignAttr, null, function() {
                l.styledMode || a.css({
                    pointerEvents: p ? "auto" : "none"
                });
            }), C(l, "afterHideOverlappingLabel")) : a.attr({
                opacity: p
            })), a.isOld = !0);
            return t;
        }
        const { addEvent: L, fireEvent: C, isArray: z, isNumber: H, objectEach: B, pick: u } = y;
        L(a, "render", function() {
            let a = this, l = [];
            (this.labelCollectors || []).forEach(function(a) {
                l = l.concat(a());
            });
            (this.yAxis || []).forEach(function(a) {
                a.stacking && a.options.stackLabels && !a.options.stackLabels.allowOverlap && B(a.stacking.stacks, function(a) {
                    B(a, function(a) {
                        a.label && l.push(a.label);
                    });
                });
            });
            (this.series || []).forEach(function(p) {
                var t = p.options.dataLabels;
                p.visible && (!1 !== t.enabled || p._hasPointLabels) && (t = (m)=>m.forEach((h)=>{
                        h.visible && (z(h.dataLabels) ? h.dataLabels : h.dataLabel ? [
                            h.dataLabel
                        ] : []).forEach(function(g) {
                            const e = g.options;
                            g.labelrank = u(e.labelrank, h.labelrank, h.shapeArgs && h.shapeArgs.height);
                            e.allowOverlap ? (g.oldOpacity = g.opacity, g.newOpacity = 1, x(g, a)) : l.push(g);
                        });
                    }), t(p.nodes || []), t(p.points));
            });
            this.hideOverlappingLabels(l);
        });
        a.prototype.hideOverlappingLabels = function(a) {
            let l = this, p = a.length, t = l.renderer;
            var m;
            let h;
            let g, e, w, u = !1;
            var v = function(a) {
                let d, e;
                var g;
                let h = a.box ? 0 : a.padding || 0, b = g = 0, f, c;
                if (a && (!a.alignAttr || a.placed)) return d = a.alignAttr || {
                    x: a.attr("x"),
                    y: a.attr("y")
                }, e = a.parentGroup, a.width || (g = a.getBBox(), a.width = g.width, a.height = g.height, g = t.fontMetrics(a.element).h), f = a.width - 2 * h, (c = ({
                    left: "0",
                    center: "0.5",
                    right: "1"
                })[a.alignValue]) ? b = +c * f : H(a.x) && Math.round(a.x) !== a.translateX && (b = a.x - a.translateX), {
                    x: d.x + (e.translateX || 0) + h - (b || 0),
                    y: d.y + (e.translateY || 0) + h - g,
                    width: a.width - 2 * h,
                    height: a.height - 2 * h
                };
            };
            for(h = 0; h < p; h++)if (m = a[h]) m.oldOpacity = m.opacity, m.newOpacity = 1, m.absoluteBox = v(m);
            a.sort(function(a, e) {
                return (e.labelrank || 0) - (a.labelrank || 0);
            });
            for(h = 0; h < p; h++)for(e = (v = a[h]) && v.absoluteBox, m = h + 1; m < p; ++m)w = (g = a[m]) && g.absoluteBox, !e || !w || v === g || 0 === v.newOpacity || 0 === g.newOpacity || "hidden" === v.visibility || "hidden" === g.visibility || w.x >= e.x + e.width || w.x + w.width <= e.x || w.y >= e.y + e.height || w.y + w.height <= e.y || ((v.labelrank < g.labelrank ? v : g).newOpacity = 0);
            a.forEach(function(a) {
                x(a, l) && (u = !0);
            });
            u && C(l, "afterHideAllOverlappingLabels");
        };
    });
    M(a, "Extensions/BorderRadius.js", [
        a["Core/Defaults.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Utilities.js"]
    ], function(a, y, I, L, C, z) {
        const { defaultOptions: x } = a;
        ({ seriesTypes: a } = I);
        const { addEvent: B, extend: u, isObject: v, merge: l, relativeLength: p } = z, t = {
            radius: 0,
            scope: "stack",
            where: void 0
        }, m = (a, g)=>{
            v(a) || (a = {
                radius: a || 0
            });
            return l(t, g, a);
        };
        if (-1 === L.symbolCustomAttribs.indexOf("borderRadius")) {
            L.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY");
            const h = C.prototype.symbols.arc;
            C.prototype.symbols.arc = function(a, g, l, m, d = {}) {
                a = h(a, g, l, m, d);
                const { innerR: e = 0, r: r = l, start: q = 0, end: t = 0 } = d;
                if (d.open || !d.borderRadius) return a;
                l = t - q;
                g = Math.sin(l / 2);
                d = Math.max(Math.min(p(d.borderRadius || 0, r - e), (r - e) / 2, r * g / (1 + g)), 0);
                l = Math.min(d, l / Math.PI * 2 * e);
                for(g = a.length - 1; g--;){
                    let e = void 0, h = void 0, k = void 0;
                    m = a;
                    var b = g, f = 1 < g ? l : d, c = m[b], n = m[b + 1];
                    "Z" === n[0] && (n = m[0]);
                    "M" !== c[0] && "L" !== c[0] || "A" !== n[0] ? "A" !== c[0] || "M" !== n[0] && "L" !== n[0] || (k = n, h = c) : (k = c, h = n, e = !0);
                    if (k && h && h.params) {
                        c = h[1];
                        var w = h[5];
                        n = h.params;
                        const { start: a, end: d, cx: g, cy: l } = n;
                        var u = w ? c - f : c + f;
                        const p = u ? Math.asin(f / u) : 0;
                        w = w ? p : -p;
                        u *= Math.cos(p);
                        e ? (n.start = a + w, k[1] = g + u * Math.cos(a), k[2] = l + u * Math.sin(a), m.splice(b + 1, 0, [
                            "A",
                            f,
                            f,
                            0,
                            0,
                            1,
                            g + c * Math.cos(n.start),
                            l + c * Math.sin(n.start)
                        ])) : (n.end = d - w, h[6] = g + c * Math.cos(n.end), h[7] = l + c * Math.sin(n.end), m.splice(b + 1, 0, [
                            "A",
                            f,
                            f,
                            0,
                            0,
                            1,
                            g + u * Math.cos(d),
                            l + u * Math.sin(d)
                        ]));
                        h[4] = Math.abs(n.end - n.start) < Math.PI ? 0 : 1;
                    }
                }
                return a;
            };
            const g = C.prototype.symbols.roundedRect;
            C.prototype.symbols.roundedRect = function(a, h, l, m, d = {}) {
                const e = g(a, h, l, m, d), { r: p = 0, brBoxHeight: q = m, brBoxY: t = h } = d;
                var b = h - t, f = t + q - (h + m);
                d = -0.1 < b - p ? 0 : p;
                const c = -0.1 < f - p ? 0 : p;
                var n = Math.max(d && b, 0);
                const u = Math.max(c && f, 0);
                f = [
                    a + d,
                    h
                ];
                b = [
                    a + l - d,
                    h
                ];
                const w = [
                    a + l,
                    h + d
                ], v = [
                    a + l,
                    h + m - c
                ], x = [
                    a + l - c,
                    h + m
                ], y = [
                    a + c,
                    h + m
                ], z = [
                    a,
                    h + m - c
                ], B = [
                    a,
                    h + d
                ];
                if (n) {
                    const a = Math.sqrt(Math.pow(d, 2) - Math.pow(d - n, 2));
                    f[0] -= a;
                    b[0] += a;
                    w[1] = B[1] = h + d - n;
                }
                m < d - n && (n = Math.sqrt(Math.pow(d, 2) - Math.pow(d - n - m, 2)), w[0] = v[0] = a + l - d + n, x[0] = Math.min(w[0], x[0]), y[0] = Math.max(v[0], y[0]), z[0] = B[0] = a + d - n, w[1] = B[1] = h + m);
                u && (n = Math.sqrt(Math.pow(c, 2) - Math.pow(c - u, 2)), x[0] += n, y[0] -= n, v[1] = z[1] = h + m - c + u);
                m < c - u && (m = Math.sqrt(Math.pow(c, 2) - Math.pow(c - u - m, 2)), w[0] = v[0] = a + l - c + m, b[0] = Math.min(w[0], b[0]), f[0] = Math.max(v[0], f[0]), z[0] = B[0] = a + c - m, v[1] = z[1] = h);
                e.length = 0;
                e.push([
                    "M",
                    ...f
                ], [
                    "L",
                    ...b
                ], [
                    "A",
                    d,
                    d,
                    0,
                    0,
                    1,
                    ...w
                ], [
                    "L",
                    ...v
                ], [
                    "A",
                    c,
                    c,
                    0,
                    0,
                    1,
                    ...x
                ], [
                    "L",
                    ...y
                ], [
                    "A",
                    c,
                    c,
                    0,
                    0,
                    1,
                    ...z
                ], [
                    "L",
                    ...B
                ], [
                    "A",
                    d,
                    d,
                    0,
                    0,
                    1,
                    ...f
                ], [
                    "Z"
                ]);
                return e;
            };
            B(a.pie, "afterTranslate", function() {
                const a = m(this.options.borderRadius);
                for (const e of this.points){
                    const g = e.shapeArgs;
                    g && (g.borderRadius = p(a.radius, (g.r || 0) - (g.innerR || 0)));
                }
            });
            B(y, "afterColumnTranslate", function() {
                var a, g;
                if (this.options.borderRadius && (!this.chart.is3d || !this.chart.is3d())) {
                    const { options: e, yAxis: r } = this, q = "percent" === e.stacking;
                    var h = null === (g = null === (a = x.plotOptions) || void 0 === a ? void 0 : a[this.type]) || void 0 === g ? void 0 : g.borderRadius;
                    a = m(e.borderRadius, v(h) ? h : {});
                    g = r.options.reversed;
                    for (const k of this.points)if ({ shapeArgs: h } = k, "roundedRect" === k.shapeType && h) {
                        const { width: b = 0, height: f = 0, y: c = 0 } = h;
                        var l = c, d = f;
                        "stack" === a.scope && k.stackTotal && (l = r.translate(q ? 100 : k.stackTotal, !1, !0, !1, !0), d = r.translate(e.threshold || 0, !1, !0, !1, !0), d = this.crispCol(0, Math.min(l, d), 0, Math.abs(l - d)), l = d.y, d = d.height);
                        const m = -1 === (k.negative ? -1 : 1) * (g ? -1 : 1);
                        let t = a.where;
                        !t && this.is("waterfall") && Math.abs((k.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (t = "all");
                        t || (t = "end");
                        const v = Math.min(p(a.radius, b), b / 2, "all" === t ? f / 2 : Infinity) || 0;
                        "end" === t && (m && (l -= v), d += v);
                        u(h, {
                            brBoxHeight: d,
                            brBoxY: l,
                            r: v
                        });
                    }
                }
            }, {
                order: 9
            });
        }
        y = {
            optionsToObject: m
        };
        "";
        return y;
    });
    M(a, "Core/Responsive.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { diffObjects: x, extend: I, find: L, merge: C, pick: z, uniqueKey: H } = a;
        var B;
        (function(u) {
            function v(a, l) {
                const h = a.condition;
                (h.callback || function() {
                    return this.chartWidth <= z(h.maxWidth, Number.MAX_VALUE) && this.chartHeight <= z(h.maxHeight, Number.MAX_VALUE) && this.chartWidth >= z(h.minWidth, 0) && this.chartHeight >= z(h.minHeight, 0);
                }).call(this) && l.push(a._id);
            }
            function l(a, l) {
                const h = this.options.responsive;
                var g = this.currentResponsive;
                let e = [];
                !l && h && h.rules && h.rules.forEach((a)=>{
                    "undefined" === typeof a._id && (a._id = H());
                    this.matchResponsiveRule(a, e);
                }, this);
                l = C(...e.map((a)=>L((h || {}).rules || [], (e)=>e._id === a)).map((a)=>a && a.chartOptions));
                l.isResponsiveOptions = !0;
                e = e.toString() || void 0;
                e !== (g && g.ruleIds) && (g && this.update(g.undoOptions, a, !0), e ? (g = x(l, this.options, !0, this.collectionsWithUpdate), g.isResponsiveOptions = !0, this.currentResponsive = {
                    ruleIds: e,
                    mergedOptions: l,
                    undoOptions: g
                }, this.update(l, a, !0)) : this.currentResponsive = void 0);
            }
            const p = [];
            u.compose = function(t) {
                a.pushUnique(p, t) && I(t.prototype, {
                    matchResponsiveRule: v,
                    setResponsive: l
                });
                return t;
            };
        })(B || (B = {}));
        "";
        "";
        return B;
    });
    M(a, "masters/highcharts.src.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"],
        a["Core/Defaults.js"],
        a["Core/Animation/Fx.js"],
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Templating.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Renderer/HTML/HTMLElement.js"],
        a["Core/Renderer/HTML/HTMLRenderer.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Axis/DateTimeAxis.js"],
        a["Core/Axis/LogarithmicAxis.js"],
        a["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"],
        a["Core/Axis/Tick.js"],
        a["Core/Tooltip.js"],
        a["Core/Series/Point.js"],
        a["Core/Pointer.js"],
        a["Core/Legend/Legend.js"],
        a["Core/Chart/Chart.js"],
        a["Core/Axis/Stacking/StackingAxis.js"],
        a["Core/Axis/Stacking/StackItem.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Series/Column/ColumnSeries.js"],
        a["Series/Column/ColumnDataLabel.js"],
        a["Series/Pie/PieSeries.js"],
        a["Series/Pie/PieDataLabel.js"],
        a["Core/Series/DataLabel.js"],
        a["Core/Responsive.js"],
        a["Core/Color/Color.js"],
        a["Core/Time.js"]
    ], function(a, y, I, L, C, z, H, B, u, v, l, p, t, m, h, g, e, w, E, F, d, k, r, q, G, b, f, c, n, M, D, K, U, T) {
        a.animate = C.animate;
        a.animObject = C.animObject;
        a.getDeferredAnimation = C.getDeferredAnimation;
        a.setAnimation = C.setAnimation;
        a.stop = C.stop;
        a.timers = L.timers;
        a.AST = z;
        a.Axis = t;
        a.Chart = k;
        a.chart = k.chart;
        a.Fx = L;
        a.Legend = d;
        a.PlotLineOrBand = g;
        a.Point = E;
        a.Pointer = F;
        a.Series = G;
        a.StackItem = q;
        a.SVGElement = u;
        a.SVGRenderer = v;
        a.Templating = H;
        a.Tick = e;
        a.Time = T;
        a.Tooltip = w;
        a.Color = U;
        a.color = U.parse;
        p.compose(v);
        l.compose(u);
        F.compose(k);
        d.compose(k);
        a.defaultOptions = I.defaultOptions;
        a.getOptions = I.getOptions;
        a.time = I.defaultTime;
        a.setOptions = I.setOptions;
        a.dateFormat = H.dateFormat;
        a.format = H.format;
        a.numberFormat = H.numberFormat;
        a.addEvent = y.addEvent;
        a.arrayMax = y.arrayMax;
        a.arrayMin = y.arrayMin;
        a.attr = y.attr;
        a.clearTimeout = y.clearTimeout;
        a.correctFloat = y.correctFloat;
        a.createElement = y.createElement;
        a.css = y.css;
        a.defined = y.defined;
        a.destroyObjectProperties = y.destroyObjectProperties;
        a.discardElement = y.discardElement;
        a.distribute = B.distribute;
        a.erase = y.erase;
        a.error = y.error;
        a.extend = y.extend;
        a.extendClass = y.extendClass;
        a.find = y.find;
        a.fireEvent = y.fireEvent;
        a.getMagnitude = y.getMagnitude;
        a.getStyle = y.getStyle;
        a.inArray = y.inArray;
        a.isArray = y.isArray;
        a.isClass = y.isClass;
        a.isDOMElement = y.isDOMElement;
        a.isFunction = y.isFunction;
        a.isNumber = y.isNumber;
        a.isObject = y.isObject;
        a.isString = y.isString;
        a.keys = y.keys;
        a.merge = y.merge;
        a.normalizeTickInterval = y.normalizeTickInterval;
        a.objectEach = y.objectEach;
        a.offset = y.offset;
        a.pad = y.pad;
        a.pick = y.pick;
        a.pInt = y.pInt;
        a.relativeLength = y.relativeLength;
        a.removeEvent = y.removeEvent;
        a.seriesType = b.seriesType;
        a.splat = y.splat;
        a.stableSort = y.stableSort;
        a.syncTimeout = y.syncTimeout;
        a.timeUnits = y.timeUnits;
        a.uniqueKey = y.uniqueKey;
        a.useSerialIds = y.useSerialIds;
        a.wrap = y.wrap;
        c.compose(f);
        D.compose(G);
        m.compose(t);
        h.compose(t);
        M.compose(n);
        g.compose(t);
        K.compose(k);
        r.compose(t, k, G);
        w.compose(F);
        return a;
    });
    a["masters/highcharts.src.js"]._modules = a;
    return a["masters/highcharts.src.js"];
});


var $3b8e3559267404c5$exports = {};

!function(t, e) {
    $3b8e3559267404c5$exports = e((parcelRequire("exYeM")));
}("undefined" != typeof self ? self : $3b8e3559267404c5$exports, function(t) {
    return function(t) {
        function e(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
        }
        var r = {};
        return e.m = t, e.c = r, e.d = function(t, r, n) {
            e.o(t, r) || Object.defineProperty(t, r, {
                configurable: !1,
                enumerable: !0,
                get: n
            });
        }, e.n = function(t) {
            var r = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(r, "a", r), r;
        }, e.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, e.p = "", e(e.s = 0);
    }([
        function(t, e, r) {
            "use strict";
            function n() {
                return n = Object.assign ? Object.assign.bind() : function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var r = arguments[e];
                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
                    }
                    return t;
                }, n.apply(this, arguments);
            }
            function o(t) {
                return a(t) || i(t) || u(t) || c();
            }
            function c() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function u(t, e) {
                if (t) {
                    if ("string" == typeof t) return f(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? f(t, e) : void 0;
                }
            }
            function i(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }
            function a(t) {
                if (Array.isArray(t)) return f(t);
            }
            function f(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
                return n;
            }
            function s(t) {
                "@babel/helpers - typeof";
                return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), r.d(e, "HighchartsReact", function() {
                return d;
            });
            var p = r(1), l = r.n(p), y = "undefined" != typeof window ? p.useLayoutEffect : p.useEffect, d = Object(p.memo)(Object(p.forwardRef)(function(t, e) {
                var r = Object(p.useRef)(), c = Object(p.useRef)(), u = Object(p.useRef)(t.constructorType), i = Object(p.useRef)(t.highcharts);
                return y(function() {
                    function e() {
                        var e = t.highcharts || "object" === ("undefined" == typeof window ? "undefined" : s(window)) && window.Highcharts, n = t.constructorType || "chart";
                        e ? e[n] ? t.options ? c.current = e[n](r.current, t.options, t.callback) : console.warn('The "options" property was not passed.') : console.warn('The "constructorType" property is incorrect or some required module is not imported.') : console.warn('The "highcharts" property was not passed.');
                    }
                    if (c.current) {
                        if (!1 !== t.allowChartUpdate) {
                            if (t.constructorType !== u.current || t.highcharts !== i.current) u.current = t.constructorType, i.current = t.highcharts, e();
                            else if (!t.immutable && c.current) {
                                var n;
                                (n = c.current).update.apply(n, [
                                    t.options
                                ].concat(o(t.updateArgs || [
                                    !0,
                                    !0
                                ])));
                            } else e();
                        }
                    } else e();
                }, [
                    t.options,
                    t.allowChartUpdate,
                    t.updateArgs,
                    t.containerProps,
                    t.highcharts,
                    t.constructorType
                ]), y(function() {
                    return function() {
                        c.current && (c.current.destroy(), c.current = null);
                    };
                }, []), Object(p.useImperativeHandle)(e, function() {
                    return {
                        get chart () {
                            return c.current;
                        },
                        container: r
                    };
                }, []), l.a.createElement("div", n({}, t.containerProps, {
                    ref: r
                }));
            }));
            e.default = d;
        },
        function(e, r) {
            e.exports = t;
        }
    ]);
});


const $afa8480a38610e00$var$generateSentimentData = ()=>Array.from({
        length: 30
    }, ()=>Math.random() * 100);
const $afa8480a38610e00$var$SentimentChart = /*#__PURE__*/ (0, $exYeM.memo)(()=>{
    const [chartData, setChartData] = (0, $exYeM.useState)($afa8480a38610e00$var$generateSentimentData);
    (0, $exYeM.useEffect)(()=>{
        const interval = setInterval(()=>setChartData($afa8480a38610e00$var$generateSentimentData), 10000);
        return ()=>clearInterval(interval);
    }, []);
    const options = (0, $exYeM.useMemo)(()=>({
            chart: {
                type: "column",
                backgroundColor: "transparent",
                height: "80%",
                marginTop: 10,
                marginBottom: 100,
                animation: {
                    duration: 1000,
                    easing: "easeOutBounce"
                }
            },
            title: {
                text: null
            },
            xAxis: {
                visible: false
            },
            yAxis: {
                title: {
                    text: null
                },
                labels: {
                    style: {
                        color: "#888"
                    }
                },
                gridLineColor: "rgba(255,255,255,0.1)",
                min: 0,
                max: 100,
                tickPositions: [
                    50,
                    75,
                    100
                ],
                startOnTick: false,
                endOnTick: false
            },
            series: [
                {
                    name: "Market Sentiment",
                    data: chartData,
                    color: "#98fa73",
                    marker: {
                        enabled: false
                    }
                }
            ],
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            tooltip: {
                formatter: function() {
                    return `Sentiment: ${(0, (/*@__PURE__*/$parcel$interopDefault($bdf625fc24abd869$exports))).numberFormat(this.y, 2)}`;
                }
            },
            plotOptions: {
                series: {
                    lineWidth: 2,
                    animation: {
                        duration: 1000,
                        easing: "easeOutBounce"
                    }
                }
            }
        }), [
        chartData
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
        highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($bdf625fc24abd869$exports))),
        options: options
    });
});
$afa8480a38610e00$var$SentimentChart.displayName = "SentimentChart";
const $afa8480a38610e00$var$SQLCodeBox = /*#__PURE__*/ (0, $exYeM.memo)(()=>{
    const queries = [
        `SELECT blockchain, COUNT(*) as tx_count
FROM transactions
WHERE block_timestamp >= NOW() - INTERVAL 1 DAY
GROUP BY blockchain
ORDER BY tx_count DESC
LIMIT 5;`,
        `SELECT token_address, SUM(amount) as total_volume
FROM token_transfers
WHERE block_timestamp >= NOW() - INTERVAL 7 DAY
GROUP BY token_address
ORDER BY total_volume DESC
LIMIT 10;`,
        `SELECT from_address, COUNT(*) as interaction_count
FROM contract_interactions
WHERE contract_address = '0x1234...5678'
GROUP BY from_address
ORDER BY interaction_count DESC
LIMIT 15;`
    ];
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-full h-full flex flex-col ",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "flex-grow p-3 overflow-auto",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                className: "text-xs  p-2 rounded-md overflow-x-auto whitespace-pre-wrap break-words h-full",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                    className: "text-secondary-dark  font-bold",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $32dbda48f15f6422$export$2e2bcd8739ae039), {
                        text: queries,
                        className: "text-xs",
                        typingSpeed: 50,
                        deletingSpeed: 30,
                        pauseDuration: 200
                    })
                })
            })
        })
    });
});
$afa8480a38610e00$var$SQLCodeBox.displayName = "SQLCodeBox";
const $afa8480a38610e00$var$features = [
    {
        Icon: (0, $8cd740242243a8d0$export$2e2bcd8739ae039),
        name: "Market Sentiment",
        description: "Track market sentiment trends",
        href: "/Explore?blockchain=Ethereum",
        cta: "Explore market sentiment analysis",
        className: "col-span-3 lg:col-span-1",
        background: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "absolute inset-0 flex flex-col p-4",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex-grow mb-8",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($afa8480a38610e00$var$SentimentChart, {})
            })
        })
    },
    {
        Icon: (0, $81ae0332a0e1c941$export$2e2bcd8739ae039),
        name: "Blockchains",
        description: "Support for 6 Blockchains and 100+ dApps",
        href: "/Discover",
        cta: "Discover supported blockchains and dApps",
        className: "col-span-3 lg:col-span-2",
        background: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "absolute inset-0 flex items-center justify-center",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-full h-full max-w-[300px] lg:max-w-[500px] scale-75 lg:scale-100",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4086389d2a4d3813$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        Icon: (0, $47fa6b3f68cecb86$export$2e2bcd8739ae039),
        name: "Databases",
        description: "Access to more than 50TB of data",
        href: "/Explore/Tables?blockchain=Ethereum",
        cta: "Explore Ethereum blockchain tables",
        className: "col-span-3 lg:col-span-2",
        background: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "absolute right-2 top-4 h-[300px] w-[600px] border-none transition-all duration-300 ease-out [mask-image:linear-gradient(to_top,transparent_10%,#000_100%)] group-hover:scale-105",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f4f51f43f7cd3dad$export$2e2bcd8739ae039), {
                link: "/Explore?blockchain=Ethereum"
            })
        })
    },
    {
        Icon: (0, $a3d3d3fe956a6344$export$2e2bcd8739ae039),
        name: "SQL Query",
        description: "Write powerful SQL queries to analyze blockchain data",
        className: "col-span-3 lg:col-span-1",
        href: "/query",
        cta: "Try SQL queries for blockchain analysis",
        background: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "absolute inset-0 flex items-center justify-center p-3",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)($afa8480a38610e00$var$SQLCodeBox, {})
        })
    }
];
const $afa8480a38610e00$export$9c495915f352c9ae = /*#__PURE__*/ (0, $exYeM.memo)(()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "max-w-screen-xl mx-auto p-4",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $692ecf0d7b095d7b$export$5e53b3ed4c9a8059), {
            children: $afa8480a38610e00$var$features.map((feature, idx)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $692ecf0d7b095d7b$export$2eedce50b658acd9), {
                    ...feature
                }, idx))
        })
    });
});
$afa8480a38610e00$export$9c495915f352c9ae.displayName = "BentoDemo";
var $afa8480a38610e00$export$2e2bcd8739ae039 = $afa8480a38610e00$export$9c495915f352c9ae;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

const $a97f2348d6982ce0$var$TestimonialCard = /*#__PURE__*/ (0, $exYeM.memo)(({ img: img, name: name, username: username, body: body })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "shrink-0 w-80 rounded-xl overflow-hidden relative bg-gray-50  border border-gray-200  p-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center mb-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        src: img,
                        alt: `${name}'s profile`,
                        className: "w-12 h-12 rounded-full mr-3",
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h4", {
                                className: "font-semibold text-slate-900 ",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                                href: `https://twitter.com/${username}`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "text-sm text-primary hover:underline",
                                children: [
                                    "@",
                                    username
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "text-slate-600  text-sm",
                children: body
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "text-6xl absolute top-2 right-2 text-slate-200 "
            })
        ]
    }));
$a97f2348d6982ce0$var$TestimonialCard.displayName = "TestimonialCard";
const $a97f2348d6982ce0$var$TestimonialList = /*#__PURE__*/ (0, $exYeM.memo)(({ list: list, reverse: reverse = false, duration: duration = 50 })=>{
    const animationProps = (0, $exYeM.useMemo)(()=>({
            initial: {
                translateX: reverse ? "-100%" : "0%"
            },
            animate: {
                translateX: reverse ? "0%" : "-100%"
            },
            transition: {
                duration: duration,
                repeat: Infinity,
                ease: "linear"
            }
        }), [
        reverse,
        duration
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
        ...animationProps,
        className: "flex gap-4 px-2",
        children: list.map((t)=>/*#__PURE__*/ (0, $aSiaI.jsx)($a97f2348d6982ce0$var$TestimonialCard, {
                ...t
            }, t.username))
    });
});
$a97f2348d6982ce0$var$TestimonialList.displayName = "TestimonialList";
const $a97f2348d6982ce0$var$GradientOverlay = /*#__PURE__*/ (0, $exYeM.memo)(({ direction: direction })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: `absolute top-0 bottom-0 ${direction} w-24 z-10 bg-gradient-to-r from-white to-transparent  ${direction === "right-0" ? "rotate-180" : ""}`
    }));
$a97f2348d6982ce0$var$GradientOverlay.displayName = "GradientOverlay";
const $a97f2348d6982ce0$var$TwitterStyleTestimonials = ()=>{
    const memoizedTestimonials = (0, $exYeM.useMemo)(()=>({
            top: $a97f2348d6982ce0$var$testimonials.top,
            bottom: $a97f2348d6982ce0$var$testimonials.bottom
        }), []);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "bg-white  py-12",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "mb-8 px-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: "text-slate-900  text-4xl font-semibold text-center",
                        children: "What Our Users Say"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "text-center text-slate-600  text-sm mt-2 max-w-lg mx-auto",
                        children: "See what our users are saying about Wevr's real-time blockchain analytics"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "p-4 overflow-x-hidden relative",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($a97f2348d6982ce0$var$GradientOverlay, {
                        direction: "left-0"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)($a97f2348d6982ce0$var$TestimonialList, {
                                list: memoizedTestimonials.top,
                                duration: 125
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)($a97f2348d6982ce0$var$TestimonialList, {
                                list: memoizedTestimonials.top,
                                duration: 125
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)($a97f2348d6982ce0$var$TestimonialList, {
                                list: memoizedTestimonials.bottom,
                                duration: 175,
                                reverse: true
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)($a97f2348d6982ce0$var$TestimonialList, {
                                list: memoizedTestimonials.bottom,
                                duration: 175,
                                reverse: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($a97f2348d6982ce0$var$GradientOverlay, {
                        direction: "right-0"
                    })
                ]
            })
        ]
    });
};
const $a97f2348d6982ce0$var$testimonials = {
    top: [
        {
            name: "Kuriboh",
            username: "Cryptokuriboh",
            body: "Wevr's on-chain analytics have revolutionized my trading strategies. The real-time blockchain insights are incredible!",
            img: "https://pbs.twimg.com/profile_images/987239307382480896/NxN_Twcl_400x400.jpg"
        },
        {
            name: "chips_chubby",
            username: "chips_chubby",
            body: "The depth of on-chain data Wevr provides is unparalleled. It's a game-changer for crypto market analysis.",
            img: "https://pbs.twimg.com/profile_images/1567896867190751235/-gg1H1vo_400x400.jpg"
        },
        {
            name: "1960_c",
            username: "1960_c",
            body: "Wevr's blockchain footprint tracker and analytics tools have given me unprecedented visibility into network activities.",
            img: "https://pbs.twimg.com/profile_images/1758066059071168512/pI25vjQ-_400x400.jpg"
        },
        {
            name: "Meeshcrypto",
            username: "BigMeeshcrypto",
            body: "The on-chain whale tracking feature from Wevr is a goldmine for predicting market movements. Absolutely essential!",
            img: "https://pbs.twimg.com/profile_images/1786937382799089664/5EDHgtxC_400x400.jpg"
        },
        {
            name: "Brian",
            username: "Brian_crypt0",
            body: "Wevr's Query integration for blockchain data is seamless. It's made our DeFi analytics so much more comprehensive.",
            img: "https://pbs.twimg.com/profile_images/1462608806068690947/0IyTuJvp_400x400.jpg"
        }
    ],
    bottom: [
        {
            name: "Poor",
            username: "poorxbt",
            body: "The customizable on-chain analytics dashboards from Wevr have streamlined our entire crypto research workflow.",
            img: "https://pbs.twimg.com/profile_images/1460406250408005633/XLkh-YNu_400x400.jpg"
        },
        {
            name: "Joker",
            username: "cryptojokerrr",
            body: "Wevr's predictive on-chain analytics have given us a significant edge in tracking whale movements. Truly impressive!",
            img: "https://pbs.twimg.com/profile_images/1729735072063098880/XqJ4vyn__400x400.jpg"
        },
        {
            name: "kathryncryptox",
            username: "kathryncryptox",
            body: "The Near real-time blockchain data charts from Wevr are a game-changer for our algorithmic trading strategies.",
            img: "https://pbs.twimg.com/profile_images/1481111122405359619/5u0ZUS3S_400x400.jpg"
        },
        {
            name: "nofffman",
            username: "nofffman",
            body: "For blockchain auditing and on-chain security analysis, Wevr's tools are awesome. They've elevated our assessments.",
            img: "https://pbs.twimg.com/profile_images/1752198052428013568/Dxsf6DX3_400x400.jpg"
        },
        {
            name: "CoolingCrypto",
            username: "CoolingCrypto",
            body: "Wevr's on-chain analytics have been crucial in our token analysis and community engagement tracking.",
            img: "https://pbs.twimg.com/profile_images/1440297536015638540/bQi9PXBg_400x400.jpg"
        },
        {
            name: "Julie_crypto",
            username: "Julie_crypto",
            body: "The cross-chain data integration in Wevr's platform has revolutionized our multi-blockchain portfolio management.",
            img: "https://pbs.twimg.com/profile_images/1484303754573025282/YJ6qt2Pn_400x400.jpg"
        }
    ]
};
var $a97f2348d6982ce0$export$2e2bcd8739ae039 = $a97f2348d6982ce0$var$TwitterStyleTestimonials;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

function $25424049e4b46581$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $21125973824588d9$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}





function $8939fb823cdd3744$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}







function $5ff26010bb81787b$export$f2911d8192f464a8(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $02609ec916d1eee0$export$17eda790a720ec57)(element) ? new (0, $83f9c44d75db63b5$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $b877597daa557132$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
    node.mount(element);
    (0, $2a8cc64b32f75635$export$bc2a978a17abfdde).set(element, node);
}






/**
 * Create a progress => progress easing function from a generator.
 */ function $c857cd0523338c5d$export$7f1511d09ee75a99(options, scale = 100) {
    const generator = (0, $9c2b8560de502fe4$export$b36281d89752ae66)({
        keyframes: [
            0,
            scale
        ],
        ...options
    });
    const duration = Math.min((0, $2c9655bdaefca666$export$cbdd6b3d40ea54e2)(generator), (0, $2c9655bdaefca666$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $bfda710cf857a073$export$f64c3bfbc58eec0f)(duration)
    };
}








/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $4fb43d5eafdfa0de$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $c2c5fbfde5ece7ff$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};



function $22c21257f724bc07$export$41c5e731255a462(easing, i) {
    return (0, $aeb97d5b77acc966$export$216948827bbdc797)(easing) ? easing[(0, $c2c5fbfde5ece7ff$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}




function $d75088b14c070f48$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $d2a9bfd104bd5453$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $d75088b14c070f48$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $d75088b14c070f48$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $588ba3a890ebeea1$export$3bb0b4ff1037b8dd)(startTime, endTime, offset[i]),
        easing: (0, $22c21257f724bc07$export$41c5e731255a462)(easing, i)
    });
}


function $bc6a6fa05a24e3c5$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $3ec5a78411acff7f$var$defaultSegmentEasing = "easeInOut";
function $3ec5a78411acff7f$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $4fb43d5eafdfa0de$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $4fb43d5eafdfa0de$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numElements = 0)=>{
            const valueKeyframesAsList = $3ec5a78411acff7f$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $514a1d36e18c8614$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            if (numKeyframes <= 2 && type === "spring") {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $3ec5a78411acff7f$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $bfda710cf857a073$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $c857cd0523338c5d$export$7f1511d09ee75a99)(springTransition, absoluteDelta);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            const targetTime = startTime + duration;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $c3be58b89be3196b$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $d75088b14c070f48$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $3ec5a78411acff7f$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $3ec5a78411acff7f$var$getValueSequence("default", subjectSequence));
        } else {
            /**
             * Find all the elements specified in the definition and parse value
             * keyframes from their timeline definitions.
             */ const elements = (0, $25424049e4b46581$export$90ceba2564a894f8)(subject, scope, elementCache);
            const numElements = elements.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const element = elements[elementIndex];
                const subjectSequence = $3ec5a78411acff7f$var$getSubjectSequence(element, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $3ec5a78411acff7f$export$7c1391340308742e(transition, key), $3ec5a78411acff7f$var$getValueSequence(key, subjectSequence), elementIndex, numElements);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $bc6a6fa05a24e3c5$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $98fa8bab6764d451$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($3ec5a78411acff7f$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $3ec5a78411acff7f$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $3ec5a78411acff7f$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $3ec5a78411acff7f$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $3ec5a78411acff7f$export$7c1391340308742e(transition, key) {
    return transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $3ec5a78411acff7f$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $3ec5a78411acff7f$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($3ec5a78411acff7f$var$isNumber);



function $c4ccd7e590d8f350$var$animateElements(elementOrSelector, keyframes, options, scope) {
    const elements = (0, $25424049e4b46581$export$90ceba2564a894f8)(elementOrSelector, scope);
    const numElements = elements.length;
    (0, $21125973824588d9$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
    const animations = [];
    for(let i = 0; i < numElements; i++){
        const element = elements[i];
        /**
         * Check each element for an associated VisualElement. If none exists,
         * we need to create one.
         */ if (!(0, $2a8cc64b32f75635$export$bc2a978a17abfdde).has(element)) /**
             * TODO: We only need render-specific parts of the VisualElement.
             * With some additional work the size of the animate() function
             * could be reduced significantly.
             */ (0, $5ff26010bb81787b$export$f2911d8192f464a8)(element);
        const visualElement = (0, $2a8cc64b32f75635$export$bc2a978a17abfdde).get(element);
        const transition = {
            ...options
        };
        /**
         * Resolve stagger function if provided.
         */ if (typeof transition.delay === "function") transition.delay = transition.delay(i, numElements);
        animations.push(...(0, $63d62870b9fa1dce$export$68cacfeee78d98d2)(visualElement, {
            ...keyframes,
            transition: transition
        }, {}));
    }
    return new (0, $3abee9a5ece0b64c$export$c1e41718f71efe41)(animations);
}
const $c4ccd7e590d8f350$var$isSequence = (value)=>Array.isArray(value) && Array.isArray(value[0]);
function $c4ccd7e590d8f350$var$animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $3ec5a78411acff7f$export$1f0f44b51a4b2f73)(sequence, options, scope);
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        let animation;
        if ((0, $65e8d3d378a9947e$export$605d60a2578142d3)(subject)) animation = (0, $4f9c70393d0d9e1f$export$335a17c977067b99)(subject, keyframes.default, transition.default);
        else animation = $c4ccd7e590d8f350$var$animateElements(subject, keyframes, transition);
        animations.push(animation);
    });
    return new (0, $3abee9a5ece0b64c$export$c1e41718f71efe41)(animations);
}
const $c4ccd7e590d8f350$export$c17e592002be9b90 = (scope)=>{
    /**
     * Implementation
     */ function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
        let animation;
        if ($c4ccd7e590d8f350$var$isSequence(valueOrElementOrSequence)) animation = $c4ccd7e590d8f350$var$animateSequence(valueOrElementOrSequence, keyframes, scope);
        else if ((0, $8939fb823cdd3744$export$d276bfce3b1077ca)(keyframes)) animation = $c4ccd7e590d8f350$var$animateElements(valueOrElementOrSequence, keyframes, options, scope);
        else animation = (0, $4f9c70393d0d9e1f$export$335a17c977067b99)(valueOrElementOrSequence, keyframes, options);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
};
const $c4ccd7e590d8f350$export$e3607ec2d7a891c4 = $c4ccd7e590d8f350$export$c17e592002be9b90();


var $exYeM = parcelRequire("exYeM");

const $babbfe6b1e2be5f6$var$thresholds = {
    some: 0,
    all: 1
};
function $babbfe6b1e2be5f6$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "some" } = {}) {
    const elements = (0, $25424049e4b46581$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (typeof newOnEnd === "function") activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $babbfe6b1e2be5f6$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}


function $23ee835eea7d3354$export$2f62ee6831462844(ref, { root: root, margin: margin, amount: amount, once: once = false } = {}) {
    const [isInView, setInView] = (0, $exYeM.useState)(false);
    (0, $exYeM.useEffect)(()=>{
        if (!ref.current || once && isInView) return;
        const onEnter = ()=>{
            setInView(true);
            return once ? undefined : ()=>setInView(false);
        };
        const options = {
            root: root && root.current || undefined,
            margin: margin,
            amount: amount
        };
        return (0, $babbfe6b1e2be5f6$export$acb1e9cb9ce4ca56)(ref.current, onEnter, options);
    }, [
        root,
        ref,
        margin,
        once,
        amount
    ]);
    return isInView;
}


const $b69983d7517a1632$var$Stat = ({ num: num, suffix: suffix = "", decimals: decimals = 0, name: name })=>{
    const ref = (0, $exYeM.useRef)(null);
    const isInView = (0, $23ee835eea7d3354$export$2f62ee6831462844)(ref, {
        once: false
    });
    (0, $exYeM.useEffect)(()=>{
        if (!isInView || !ref.current) return;
        const controls = (0, $c4ccd7e590d8f350$export$e3607ec2d7a891c4)(0, num, {
            duration: 2.5,
            onUpdate (value) {
                ref.current.textContent = value.toFixed(decimals);
            }
        });
        return ()=>controls.stop();
    }, [
        num,
        decimals,
        isInView
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "text-center px-1 sm:px-2 md:px-4 flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold h-[1.5em] flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "w-16 sm:w-20 md:w-24 text-right",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            ref: ref,
                            className: "inline-block min-w-[2ch] sm:min-w-[3ch]"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "w-4 sm:w-6 md:w-8 text-left",
                        children: suffix
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "text-xs sm:text-sm text-gray-600 mt-1 sm:mt-2 w-full text-center",
                children: name
            })
        ]
    });
};
const $b69983d7517a1632$var$Divider = ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "self-stretch w-[1px] sm:w-[2px] md:w-[3px] bg-gradient-to-b from-[#FA9173] to-[#30459E] mx-1 sm:mx-2 md:mx-3 rounded-[1px] sm:rounded-[2px]"
    });
function $b69983d7517a1632$var$StatsSection() {
    const stats = [
        {
            name: "Blockchains",
            value: 6,
            suffix: ""
        },
        {
            name: "Charts",
            value: 600,
            suffix: "+"
        },
        {
            name: "Data processed",
            value: 50,
            suffix: "TB+"
        }
    ];
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "bg-white text-black py-6 sm:py-8 md:py-12 lg:py-16",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "container mx-auto px-2 sm:px-4",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                    className: "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-2 sm:mb-3 md:mb-4 font-monda",
                    children: "We have Got You Covered for Blockchain Data"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "text-center mb-4 sm:mb-6 md:mb-8 lg:mb-12 text-gray-600 max-w-3xl mx-auto text-xs sm:text-sm md:text-base",
                    children: "Monitor Crypto Movements Instantly: See Fund Shifts, Identify New Projects, and Trace Transactions with 15-Second Node to Website Delay and Block-Level Precision."
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex items-stretch",
                        children: stats.map((stat, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)($b69983d7517a1632$var$Stat, {
                                        num: stat.value,
                                        suffix: stat.suffix,
                                        name: stat.name,
                                        decimals: stat.name === "Data processed" ? 1 : 0
                                    }),
                                    index < stats.length - 1 && /*#__PURE__*/ (0, $aSiaI.jsx)($b69983d7517a1632$var$Divider, {})
                                ]
                            }, stat.name))
                    })
                })
            ]
        })
    });
}
var $b69983d7517a1632$export$2e2bcd8739ae039 = $b69983d7517a1632$var$StatsSection;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


function $a5f4bcb2cd1a58cb$export$97aa6615e67877bf() {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "blogPosts"
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/blog-posts").then((response)=>response.data)
    });
}


var $c3016444b4bdf528$exports = {};

$c3016444b4bdf528$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "CL-May-Week2.c9fa966e.png";


// Fallback data
const $c7745141a55ea3ae$var$fallbackPosts = [
    {
        id: 1,
        title: "What is Erc20 ?",
        description: "Wevr Ai what is ERC20? overview of what ERC-20 token standard is.",
        date: "June 2, 2024",
        author: {
            name: "XBTOlivia",
            role: "Author"
        },
        category: {
            title: "ERC20",
            href: "/category/ERC20"
        },
        href: "/what-is-erc20",
        imageData: (0, (/*@__PURE__*/$parcel$interopDefault($c3016444b4bdf528$exports)))
    },
    {
        id: 2,
        title: "What is Bigdata?",
        description: "Wevr Ai what is Bigdata? An overview of Big data and how it is related to web3/",
        date: "June 1, 2024",
        author: {
            name: "XBTOlivia",
            role: "Author"
        },
        category: {
            title: "Educate",
            href: "/category/Educate"
        },
        href: "/what-is-bigdata",
        imageData: (0, (/*@__PURE__*/$parcel$interopDefault($c3016444b4bdf528$exports)))
    },
    {
        id: 3,
        title: "What is an Airdrop?",
        description: "Wevr Ai What is an airdrop? an overview of Airdrops - the benefits and cons .",
        date: "May 23, 2024",
        author: {
            name: "XBTOlivia",
            role: "Author"
        },
        category: {
            title: "Educate",
            href: "/category/Educate"
        },
        href: "/what-is-an-airdrop",
        imageData: (0, (/*@__PURE__*/$parcel$interopDefault($c3016444b4bdf528$exports)))
    }
];
const $c7745141a55ea3ae$var$BlogPost = /*#__PURE__*/ (0, $exYeM.memo)(({ post: post, isLoading: isLoading })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("article", {
        className: "flex flex-col items-start justify-between",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "relative w-full",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                    href: `https://blog.wevr.ai/posts${post.href}`,
                    className: "block",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "aspect-[16/9] w-full overflow-hidden rounded-2xl bg-gray-100",
                            children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "animate-pulse bg-gray-200 h-full w-full"
                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                src: post.imageData || (0, (/*@__PURE__*/$parcel$interopDefault($c3016444b4bdf528$exports))),
                                alt: post.title,
                                onError: (e)=>{
                                    e.target.onerror = null;
                                    e.target.src = (0, (/*@__PURE__*/$parcel$interopDefault($c3016444b4bdf528$exports)));
                                },
                                className: "h-full w-full object-cover object-center",
                                loading: "lazy",
                                width: "400",
                                height: "225"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "max-w-xl",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "mt-8 flex items-center gap-x-4 text-xs",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("time", {
                                dateTime: post.datetime,
                                className: "text-gray-500",
                                children: post.date
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                href: `https://blog.wevr.ai/posts${post.category.href}`,
                                className: "relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100",
                                children: post.category.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "group relative",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                className: "mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                                    href: `https://blog.wevr.ai/posts${post.href}`,
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "absolute inset-0"
                                        }),
                                        post.title
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "mt-5 line-clamp-3 text-sm leading-6 text-gray-600",
                                children: post.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "relative mt-8 flex items-center gap-x-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                alt: `${post.author.name}'s avatar`,
                                src: `https://avatar.vercel.sh/${post.author.name}`,
                                className: "h-10 w-10 rounded-full bg-gray-100",
                                loading: "lazy",
                                width: "40",
                                height: "40"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "text-sm leading-6",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "font-semibold text-gray-900",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                                            href: `https://blog.wevr.ai/posts${post.author.href || ""}`,
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "absolute inset-0"
                                                }),
                                                post.author.name
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-gray-600",
                                        children: post.author.role
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
$c7745141a55ea3ae$var$BlogPost.displayName = "BlogPost";
const $c7745141a55ea3ae$var$BlogSection = ()=>{
    const { data: posts, isLoading: isLoading, isError: isError } = (0, $a5f4bcb2cd1a58cb$export$97aa6615e67877bf)();
    const displayPosts = (0, $exYeM.useMemo)(()=>isError ? $c7745141a55ea3ae$var$fallbackPosts : posts || $c7745141a55ea3ae$var$fallbackPosts, [
        posts,
        isError
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("section", {
        className: "bg-white py-24 sm:py-32",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "mx-auto max-w-7xl px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "mx-auto max-w-2xl text-center",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                            className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                href: "https://blog.wevr.ai/",
                                children: "From the blog"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                            className: "mt-2 text-lg leading-8 text-gray-600",
                            children: "Unlock blockchain insights with our expert on-chain research and analysis."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3",
                    children: displayPosts.map((post)=>/*#__PURE__*/ (0, $aSiaI.jsx)($c7745141a55ea3ae$var$BlogPost, {
                            post: post,
                            isLoading: isLoading
                        }, post.id))
                })
            ]
        })
    });
};
var $c7745141a55ea3ae$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $exYeM.memo)($c7745141a55ea3ae$var$BlogSection);



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b9988f74bc3c5cbb$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("BarChart2", [
    [
        "line",
        {
            x1: "18",
            x2: "18",
            y1: "20",
            y2: "10",
            key: "1xfpm4"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "20",
            y2: "4",
            key: "be30l9"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6",
            y1: "20",
            y2: "14",
            key: "1r4le6"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $94995d014ac31e76$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Bell", [
    [
        "path",
        {
            d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9",
            key: "1qo2s2"
        }
    ],
    [
        "path",
        {
            d: "M10.3 21a1.94 1.94 0 0 0 3.4 0",
            key: "qgo35s"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8f0982fc0c676e57$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("LineChart", [
    [
        "path",
        {
            d: "M3 3v18h18",
            key: "1s2lah"
        }
    ],
    [
        "path",
        {
            d: "m19 9-5 5-4-4-3 3",
            key: "2osh9i"
        }
    ]
]);


var $ca3a4baf4670cce2$exports = {};

$ca3a4baf4670cce2$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "chart-section.0f29c508.png";


var $bea2355ac13703dd$exports = {};

$bea2355ac13703dd$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "pairs_created.0fd9430a.png";


var $84f3640e9216fc77$exports = {};

$84f3640e9216fc77$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "nft-wevr.683bb794.png";


const $8930c6cc7b467242$var$features = [
    {
        title: "Comprehensive Blockchain Analytics",
        description: "Wevr.ai delivers powerful analytics across multiple blockchain networks, including Bitcoin, Ethereum, Base, Gnosis, Optimism, and Linear.",
        bullets: [
            "Advanced charting: Visualize complex on-chain data trends",
            "Detailed blockchain tables: Gain granular insights into every on-chain activity",
            "Multi-network analysis: Compare data across different blockchains"
        ],
        conclusion: "Our platform empowers traders, researchers, analysts, and developers to make data-driven decisions in the fast-paced world of cryptocurrencies and DeFi.",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ca3a4baf4670cce2$exports))),
        imageAlt: "Blockchain analytics dashboard",
        icon: (0, $8f0982fc0c676e57$export$2e2bcd8739ae039)
    },
    {
        title: "Custom Queries and Footprint Analysis",
        description: "Dive deep into blockchain data with our advanced research tools.",
        bullets: [
            "Custom Query Builder: Craft tailored blockchain queries and extract specific data points",
            "Footprint Analysis: Uncover the impact and reach of addresses, contracts, and tokens",
            "Fund flow tracking: Map out intricate webs of blockchain interactions"
        ],
        conclusion: "These tools enable everything from academic research and market intelligence to regulatory compliance and fraud detection, keeping you ahead in the evolving blockchain landscape.",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($bea2355ac13703dd$exports))),
        imageAlt: "Custom query and footprint analysis interface",
        icon: (0, $b9988f74bc3c5cbb$export$2e2bcd8739ae039)
    },
    {
        title: "Real-Time Monitoring and Custom Dashboards",
        description: "Stay on top of the dynamic crypto market with our real-time tools.",
        bullets: [
            "Live blockchain tracking: Get up-to-the-minute insights on network health and transactions",
            "Customizable dashboards: Consolidate your most important metrics in one view",
            "Alerts and notifications: Set up custom alerts for significant blockchain events"
        ],
        conclusion: "From traders and investors to developers and researchers, our platform provides the real-time data needed to make informed decisions in the fast-moving world of cryptocurrencies.",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($84f3640e9216fc77$exports))),
        imageAlt: "Real-time blockchain monitoring dashboard",
        icon: (0, $94995d014ac31e76$export$2e2bcd8739ae039)
    }
];
const $8930c6cc7b467242$var$BackgroundGrid = /*#__PURE__*/ (0, $exYeM.memo)(()=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        style: {
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32' height='32' fill='none' stroke='rgb(15 23 42 / 0.04)'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e")`
        },
        className: "absolute inset-0 z-0",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            style: {
                backgroundImage: "radial-gradient(at 15% 50%, rgba(255,255,255,0) 0, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%)"
            },
            className: "absolute inset-0"
        })
    }));
$8930c6cc7b467242$var$BackgroundGrid.displayName = "BackgroundGrid";
const $8930c6cc7b467242$var$IconBadge = /*#__PURE__*/ (0, $exYeM.memo)(({ Icon: Icon })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "rounded-md bg-primary/10 p-2 ring-1 ring-primary/20",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)(Icon, {
            className: "h-6 w-6 text-primary"
        })
    }));
$8930c6cc7b467242$var$IconBadge.displayName = "IconBadge";
const $8930c6cc7b467242$var$FeatureImage = /*#__PURE__*/ (0, $exYeM.memo)(({ src: src, alt: alt })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "lg:w-1/2 overflow-hidden rounded-xl",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: src,
            alt: alt,
            className: "w-full h-auto object-cover",
            loading: "lazy"
        })
    }));
$8930c6cc7b467242$var$FeatureImage.displayName = "FeatureImage";
const $8930c6cc7b467242$var$FeatureContent = /*#__PURE__*/ (0, $exYeM.memo)(({ feature: feature })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "lg:w-1/2 lg:mt-0 mt-8",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($8930c6cc7b467242$var$IconBadge, {
                        Icon: feature.icon
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: "text-2xl font-bold tracking-tight text-gray-900 font-monda ml-3",
                        children: feature.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                initial: {
                    opacity: 0,
                    y: 30
                },
                whileInView: {
                    opacity: 1,
                    y: 0
                },
                transition: {
                    duration: 0.4,
                    ease: "easeOut"
                },
                className: "mt-6 text-base leading-7 text-gray-600 space-y-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "font-medium text-gray-900",
                        children: feature.description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                        className: "list-disc list-inside space-y-2",
                        children: feature.bullets.map((bullet, i)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                children: bullet
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "italic",
                        children: feature.conclusion
                    })
                ]
            })
        ]
    }));
$8930c6cc7b467242$var$FeatureContent.displayName = "FeatureContent";
const $8930c6cc7b467242$var$Feature = /*#__PURE__*/ (0, $exYeM.memo)(({ feature: feature, index: index })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: `flex flex-col ${index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"} items-center mt-24 gap-x-8 gap-y-16`,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($8930c6cc7b467242$var$FeatureImage, {
                src: feature.imageUrl,
                alt: feature.imageAlt
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($8930c6cc7b467242$var$FeatureContent, {
                feature: feature
            })
        ]
    }));
$8930c6cc7b467242$var$Feature.displayName = "Feature";
const $8930c6cc7b467242$var$ZigzagFeaturesSection = ()=>{
    const memoizedFeatures = (0, $exYeM.useMemo)(()=>$8930c6cc7b467242$var$features, []);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative bg-white py-24 sm:py-32 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($8930c6cc7b467242$var$BackgroundGrid, {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative z-10 mx-auto max-w-7xl px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "mx-auto max-w-2xl lg:text-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                className: "text-base font-semibold leading-7 text-primary",
                                children: "Wevr.ai Features"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl font-monda",
                                children: "Unlock the Power of Blockchain Data"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "mt-6 text-lg leading-8 text-gray-600",
                                children: "Dive deep into on-chain and off-chain analytics with Wevr.ai. Our tools provide unparalleled insights into blockchain networks, empowering you in the world of crypto and DeFi."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none",
                        children: memoizedFeatures.map((feature, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)($8930c6cc7b467242$var$Feature, {
                                feature: feature,
                                index: index
                            }, feature.title))
                    })
                ]
            })
        ]
    });
};
var $8930c6cc7b467242$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $exYeM.memo)($8930c6cc7b467242$var$ZigzagFeaturesSection);



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $ad110a4e18e6d96b$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
        clipRule: "evenodd"
    }));
}
const $ad110a4e18e6d96b$var$ForwardRef = $exYeM.forwardRef($ad110a4e18e6d96b$var$CheckIcon);
var $ad110a4e18e6d96b$export$2e2bcd8739ae039 = $ad110a4e18e6d96b$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $7180da4ddbc080e8$var$MinusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M4 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H4.75A.75.75 0 014 10z",
        clipRule: "evenodd"
    }));
}
const $7180da4ddbc080e8$var$ForwardRef = $exYeM.forwardRef($7180da4ddbc080e8$var$MinusIcon);
var $7180da4ddbc080e8$export$2e2bcd8739ae039 = $7180da4ddbc080e8$var$ForwardRef;



const $376932ddbd60719e$var$tiers = [
    {
        name: "CryptoQuant",
        id: "tier-cryptoquant",
        mostPopular: false
    },
    {
        name: "Wevr.ai",
        id: "tier-wevr",
        href: "#",
        mostPopular: true
    },
    {
        name: "Glassnode",
        id: "tier-glassnode",
        mostPopular: false
    }
];
const $376932ddbd60719e$var$mobileTiers = [
    $376932ddbd60719e$var$tiers[1],
    $376932ddbd60719e$var$tiers[0],
    $376932ddbd60719e$var$tiers[2]
];
const $376932ddbd60719e$var$sections = [
    {
        name: "Analytics Features",
        features: [
            {
                name: "Real-time transaction monitoring",
                tiers: {
                    CryptoQuant: true,
                    "Wevr.ai": true,
                    Glassnode: true
                }
            },
            {
                name: "Address labeling",
                tiers: {
                    CryptoQuant: true,
                    "Wevr.ai": true,
                    Glassnode: true
                }
            },
            {
                name: "Smart contract analysis",
                tiers: {
                    CryptoQuant: false,
                    "Wevr.ai": true,
                    Glassnode: true
                }
            },
            {
                name: "Custom analytics dashboards",
                tiers: {
                    CryptoQuant: "Limited",
                    "Wevr.ai": "Unlimited",
                    Glassnode: "Limited"
                }
            },
            {
                name: "Query System",
                tiers: {
                    CryptoQuant: "Limited",
                    "Wevr.ai": "True",
                    Glassnode: "False"
                }
            }
        ]
    },
    {
        name: "Data Access",
        features: [
            {
                name: "Historical data access",
                tiers: {
                    CryptoQuant: "Pay walled",
                    "Wevr.ai": "Full access",
                    Glassnode: "Pay walled"
                }
            },
            {
                name: "Data granularity",
                tiers: {
                    CryptoQuant: "1 min",
                    "Wevr.ai": "Block time",
                    Glassnode: "10 min"
                }
            },
            {
                name: "API access",
                tiers: {
                    CryptoQuant: true,
                    "Wevr.ai": true,
                    Glassnode: true
                }
            },
            {
                name: "Bulk data export",
                tiers: {
                    CryptoQuant: false,
                    "Wevr.ai": true,
                    Glassnode: false
                }
            },
            {
                name: "Real-time alerts",
                tiers: {
                    CryptoQuant: true,
                    "Wevr.ai": true,
                    Glassnode: true
                }
            }
        ]
    },
    {
        name: "Cost and Licensing",
        features: [
            {
                name: "Pricing Options",
                tiers: {
                    CryptoQuant: "Basic, Pro",
                    "Wevr.ai": "Basic, Pro, Enterprise",
                    Glassnode: "Basic, Pro"
                }
            },
            {
                name: "Free Trial",
                tiers: {
                    CryptoQuant: false,
                    "Wevr.ai": true,
                    Glassnode: false
                }
            },
            {
                name: "Enterprise Licensing",
                tiers: {
                    CryptoQuant: true,
                    "Wevr.ai": true,
                    Glassnode: true
                }
            },
            {
                name: "Lowest Price",
                tiers: {
                    CryptoQuant: "$29/month",
                    "Wevr.ai": "$25/month",
                    Glassnode: "$29/month"
                }
            },
            {
                name: "Free Tier",
                tiers: {
                    CryptoQuant: true,
                    "Wevr.ai": true,
                    Glassnode: true
                }
            }
        ]
    }
];
function $376932ddbd60719e$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
const $376932ddbd60719e$var$BackgroundGrid = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "absolute inset-0 z-0 overflow-hidden",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            style: {
                backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32' height='32' fill='none' stroke='rgb(15 23 42 / 0.04)'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e")`
            },
            className: "absolute inset-0",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                style: {
                    backgroundImage: "radial-gradient(at 100% 50%, rgba(249,250,251,0) 0, rgba(249,250,251,1) 50%, rgba(249,250,251,1) 100%)"
                },
                className: "absolute inset-0"
            })
        })
    });
};
function $376932ddbd60719e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: " py-24 sm:py-32 relative bg-gray-50",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($376932ddbd60719e$var$BackgroundGrid, {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "mx-auto max-w-7xl px-6 lg:px-8 relative  z-10",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "mx-auto max-w-4xl text-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                className: "text-xl font-semibold leading-8 text-primary",
                                children: "Comparison"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl  font-monda",
                                children: "Blockchain Analytics Solutions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "mx-auto mt-6 max-w-2xl text-center text-xl leading-8 text-gray-600",
                        children: "Compare our advanced blockchain analytics platform with competitors to see why Wevr is the best choice for your project."
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "mx-auto mt-12 max-w-md space-y-8 sm:mt-16 lg:hidden z-10",
                        children: $376932ddbd60719e$var$mobileTiers.map((tier)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("section", {
                                className: $376932ddbd60719e$var$classNames(tier.mostPopular ? "rounded-xl bg-white shadow-md ring-1 ring-primary" : "rounded-xl bg-gray-50 shadow", "p-8"),
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                        id: tier.id,
                                        className: $376932ddbd60719e$var$classNames("text-4xl leading-10 text-gray-900 text-center mb-8", tier.mostPopular ? "font-bold" : "font-normal"),
                                        children: tier.name
                                    }),
                                    tier.mostPopular && /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                        href: tier.href,
                                        className: "block rounded-md bg-primary px-3 py-2 text-center text-lg font-semibold leading-6 text-white hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
                                        children: "Learn more"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                        role: "list",
                                        className: "mt-8 space-y-3 text-base leading-7 text-gray-600",
                                        children: $376932ddbd60719e$var$sections.map((section)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                                    role: "list",
                                                    className: "space-y-3",
                                                    children: section.features.map((feature)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                            className: "flex gap-x-3",
                                                            children: feature.tiers[tier.name] ? /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ad110a4e18e6d96b$export$2e2bcd8739ae039), {
                                                                        className: "h-7 w-6 flex-none text-secondary-dark font-extrabold",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                        children: [
                                                                            feature.name,
                                                                            " ",
                                                                            typeof feature.tiers[tier.name] === "string" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                                className: "text-gray-500",
                                                                                children: [
                                                                                    "(",
                                                                                    feature.tiers[tier.name],
                                                                                    ")"
                                                                                ]
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7180da4ddbc080e8$export$2e2bcd8739ae039), {
                                                                        className: "h-7 w-6 flex-none text-gray-400",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                        className: "text-gray-400",
                                                                        children: feature.name
                                                                    })
                                                                ]
                                                            })
                                                        }, feature.name))
                                                })
                                            }, section.name))
                                    })
                                ]
                            }, tier.id))
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "isolate mt-20 hidden lg:block z-10",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "relative -mx-8",
                            children: [
                                $376932ddbd60719e$var$tiers.some((tier)=>tier.mostPopular) ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "absolute inset-x-4 inset-y-0 -z-10 flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex w-1/4 px-4",
                                        "aria-hidden": "true",
                                        style: {
                                            marginLeft: `${($376932ddbd60719e$var$tiers.findIndex((tier)=>tier.mostPopular) + 1) * 25}%`
                                        },
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "w-full rounded-t-xl border-x border-t border-primary/10 bg-primary/5"
                                        })
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("table", {
                                    className: "w-full table-fixed border-separate border-spacing-x-8 text-left",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("caption", {
                                            className: "sr-only",
                                            children: "Blockchain analytics comparison"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("colgroup", {
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("col", {
                                                    className: "w-1/4"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("col", {
                                                    className: "w-1/4"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("col", {
                                                    className: "w-1/4"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("col", {
                                                    className: "w-1/4"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("td", {}),
                                                    $376932ddbd60719e$var$tiers.map((tier)=>/*#__PURE__*/ (0, $aSiaI.jsx)("th", {
                                                            scope: "col",
                                                            className: $376932ddbd60719e$var$classNames(tier.mostPopular ? "bg-primary/5 rounded-tl-xl rounded-tr-xl" : "", "relative w-1/4 px-6 pt-6 xl:px-8 xl:pt-8"),
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                className: "min-h-[120px] flex flex-col items-center justify-between",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: $376932ddbd60719e$var$classNames("text-4xl leading-10 text-gray-900 mb-4", tier.mostPopular ? "font-bold" : "font-normal"),
                                                                        children: tier.name
                                                                    }),
                                                                    tier.mostPopular && /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                                        href: tier.href,
                                                                        className: "w-full rounded-md bg-primary px-3 py-2 text-center text-lg font-semibold leading-6 text-white hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
                                                                        children: "Learn more"
                                                                    })
                                                                ]
                                                            })
                                                        }, tier.id))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("tbody", {
                                            children: $376932ddbd60719e$var$sections.map((section, sectionIdx)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("th", {
                                                                scope: "colgroup",
                                                                colSpan: 4,
                                                                className: $376932ddbd60719e$var$classNames(sectionIdx === 0 ? "pt-8" : "pt-16", "pb-4 text-lg font-semibold leading-6 text-gray-900"),
                                                                children: [
                                                                    section.name,
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "absolute inset-x-8 mt-4 h-px bg-gray-900/10"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        section.features.map((feature)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("th", {
                                                                        scope: "row",
                                                                        className: "py-4 text-base font-normal leading-7 text-gray-900",
                                                                        children: [
                                                                            feature.name,
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                className: "absolute inset-x-8 mt-4 h-px bg-gray-900/5"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    $376932ddbd60719e$var$tiers.map((tier)=>/*#__PURE__*/ (0, $aSiaI.jsx)("td", {
                                                                            className: "px-6 py-4 xl:px-8",
                                                                            children: typeof feature.tiers[tier.name] === "string" ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                className: "text-center text-base leading-7 text-gray-500",
                                                                                children: feature.tiers[tier.name]
                                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                                children: [
                                                                                    feature.tiers[tier.name] === true ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ad110a4e18e6d96b$export$2e2bcd8739ae039), {
                                                                                        className: "mx-auto h-8 w-8 text-secondary-dark font-extrabold",
                                                                                        "aria-hidden": "true"
                                                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7180da4ddbc080e8$export$2e2bcd8739ae039), {
                                                                                        className: "mx-auto h-6 w-6 text-gray-400",
                                                                                        "aria-hidden": "true"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                                        className: "sr-only",
                                                                                        children: [
                                                                                            feature.tiers[tier.name] === true ? "Included" : "Not included",
                                                                                            " ",
                                                                                            "in ",
                                                                                            tier.name
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }, tier.id))
                                                                ]
                                                            }, feature.name))
                                                    ]
                                                }, section.name))
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");


const $240537ed233702d5$var$BackgroundGrid = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        style: {
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32' height='32' fill='none' stroke='rgb(255 255 255 / 0.1)'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e")`
        },
        className: "absolute inset-0 z-0"
    });
};
const $240537ed233702d5$var$RoundedSlideButton = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
        className: `
        relative z-0 flex items-center gap-2 overflow-hidden rounded-lg border-[1px]
        border-white px-4 py-2 font-semibold
        uppercase text-white transition-all duration-500

        before:absolute before:inset-0
        before:-z-10 before:translate-x-[150%]
        before:translate-y-[150%] before:scale-[2.5]
        before:rounded-[100%] before:bg-white
        before:transition-transform before:duration-1000
        before:content-[""]

        hover:scale-105 hover:text-primary
        hover:before:translate-x-[0%]
        hover:before:translate-y-[0%]
        active:scale-95`,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $37f9bcffaadb69fd$export$ba59ace88551b501), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "Sign up free"
            })
        ]
    });
};
const $240537ed233702d5$var$GradientShadowButton = ({ to: to, children: children })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
        to: to,
        className: "group relative w-fit transition-transform duration-300 active:scale-95",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                className: "relative z-10 rounded-lg bg-white p-0.5 duration-300 group-hover:scale-105 shadow-md group-hover:shadow-lg",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: "block rounded-md px-4 py-2 font-semibold text-primary duration-300 group-hover:bg-primary group-hover:text-white",
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "pointer-events-none absolute -inset-4 z-0 transform-gpu rounded-2xl bg-gradient-to-br from-primary to-primary-light opacity-0 blur-xl transition-all duration-300 group-hover:opacity-30"
            })
        ]
    });
};
const $240537ed233702d5$var$CTASection = ({ headerText: headerText, bodyText: bodyText })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "px-4 py-16 sm:px-6 lg:px-8 relative",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "relative isolate overflow-hidden bg-primary/90 py-16 sm:py-24 lg:py-32 rounded-3xl",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)($240537ed233702d5$var$BackgroundGrid, {}),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "mx-auto max-w-7xl px-6 lg:px-8 relative z-10",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "max-w-xl lg:max-w-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                        className: "text-3xl font-bold tracking-tight text-white sm:text-4xl",
                                        children: headerText || "Ready to enhance your blockchain insights?"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "mt-4 text-lg font-medium leading-8 text-gray-100",
                                        children: bodyText || "Unlock powerful analytics and real-time data for smarter decision-making."
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "mt-6 flex max-w-md gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)($240537ed233702d5$var$GradientShadowButton, {
                                                to: "/Explore?blockchain=Ethereum",
                                                children: "Get started"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                                to: "/SignUp",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($240537ed233702d5$var$RoundedSlideButton, {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("dl", {
                                className: "grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex flex-col items-start",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "rounded-md bg-white/5 p-2 ring-1 ring-white/10",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
                                                    className: "h-6 w-6 text-white",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    strokeWidth: "1.5",
                                                    stroke: "currentColor",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("dt", {
                                                className: "mt-4 font-bold text-white text-lg",
                                                children: "Real-time updates"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("dd", {
                                                className: "mt-2 font-medium leading-7 text-gray-100",
                                                children: "Stay informed with live blockchain data and analytics."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex flex-col items-start",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "rounded-md bg-white/5 p-2 ring-1 ring-white/10",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
                                                    className: "h-6 w-6 text-white",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    strokeWidth: "1.5",
                                                    stroke: "currentColor",
                                                    "aria-hidden": "true",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            d: "M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            d: "M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("dt", {
                                                className: "mt-4 font-bold text-white text-lg",
                                                children: "Advanced analytics"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("dd", {
                                                className: "mt-2 font-medium leading-7 text-gray-100",
                                                children: "Gain deeper insights with our powerful analytical tools."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#98fa73] to-[#9089fc] opacity-30",
                        style: {
                            clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                        }
                    })
                })
            ]
        })
    });
};
var $240537ed233702d5$export$2e2bcd8739ae039 = $240537ed233702d5$var$CTASection;


//ThemeToggle.js

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $fa1ebad2112f9982$var$LightBulbIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M12 .75a8.25 8.25 0 00-4.135 15.39c.686.398 1.115 1.008 1.134 1.623a.75.75 0 00.577.706c.352.083.71.148 1.074.195.323.041.6-.218.6-.544v-4.661a6.714 6.714 0 01-.937-.171.75.75 0 11.374-1.453 5.261 5.261 0 002.626 0 .75.75 0 11.374 1.452 6.712 6.712 0 01-.937.172v4.66c0 .327.277.586.6.545.364-.047.722-.112 1.074-.195a.75.75 0 00.577-.706c.02-.615.448-1.225 1.134-1.623A8.25 8.25 0 0012 .75z"
    }), /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M9.013 19.9a.75.75 0 01.877-.597 11.319 11.319 0 004.22 0 .75.75 0 11.28 1.473 12.819 12.819 0 01-4.78 0 .75.75 0 01-.597-.876zM9.754 22.344a.75.75 0 01.824-.668 13.682 13.682 0 002.844 0 .75.75 0 11.156 1.492 15.156 15.156 0 01-3.156 0 .75.75 0 01-.668-.824z",
        clipRule: "evenodd"
    }));
}
const $fa1ebad2112f9982$var$ForwardRef = $exYeM.forwardRef($fa1ebad2112f9982$var$LightBulbIcon);
var $fa1ebad2112f9982$export$2e2bcd8739ae039 = $fa1ebad2112f9982$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $70abf0dac443e99c$var$MoonIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z",
        clipRule: "evenodd"
    }));
}
const $70abf0dac443e99c$var$ForwardRef = $exYeM.forwardRef($70abf0dac443e99c$var$MoonIcon);
var $70abf0dac443e99c$export$2e2bcd8739ae039 = $70abf0dac443e99c$var$ForwardRef;


//ThemeContext.js

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
const $3c721443a32700fa$var$getInitialTheme = ()=>{
    if (typeof window !== "undefined" && window.localStorage) {
        const storedPrefs = window.localStorage.getItem("color-theme");
        if (typeof storedPrefs === "string") return storedPrefs;
        const userMedia = window.matchMedia("(prefers-color-scheme: dark)");
        if (userMedia.matches) return "dark";
    }
    return "light"; // light theme as the default;
};
const $3c721443a32700fa$export$2c657da244d00bd6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext();
const $3c721443a32700fa$export$d8964aec282183a3 = ({ initialTheme: initialTheme, children: children })=>{
    const [theme, setTheme] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState($3c721443a32700fa$var$getInitialTheme);
    const rawSetTheme = (rawTheme)=>{
        const root = window.document.documentElement;
        const isDark = rawTheme === "dark";
        root.classList.remove(isDark ? "light" : "dark");
        root.classList.add(rawTheme);
        localStorage.setItem("color-theme", rawTheme);
    };
    if (initialTheme) rawSetTheme(initialTheme);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        rawSetTheme(theme);
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($3c721443a32700fa$export$2c657da244d00bd6.Provider, {
        value: {
            theme: theme,
            setTheme: setTheme
        },
        children: children
    });
};


const $2715733fd20989e1$var$Toggle = ()=>{
    const { theme: theme, setTheme: setTheme } = (0, $exYeM.useContext)((0, $3c721443a32700fa$export$2c657da244d00bd6));
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "transition duration-500 ease-in-out",
        children: theme === "dark" ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fa1ebad2112f9982$export$2e2bcd8739ae039), {
            onClick: ()=>setTheme(theme === "dark" ? "light" : "dark"),
            className: "h-6 w-6 text-gray-500 dark:text-yellow-400 text-2xl cursor-pointer"
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $70abf0dac443e99c$export$2e2bcd8739ae039), {
            onClick: ()=>setTheme(theme === "dark" ? "light" : "dark"),
            className: "h-6 w-6 text-gray-800 dark:text-gray-400 text-2xl cursor-pointer"
        })
    });
};
var $2715733fd20989e1$export$2e2bcd8739ae039 = $2715733fd20989e1$var$Toggle;


function $e391825e47c2285e$var$Homepage() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    (0, $exYeM.useEffect)(()=>{
        if (location.state?.pathname) {
            navigate("/", {
                replace: true
            });
            window.location.reload();
        }
    }, [
        location.state?.pathname
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fbbcad3c5e023440$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3ac8698b5e8ca48d$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8930c6cc7b467242$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b69983d7517a1632$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $376932ddbd60719e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $247b409c2d935112$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $afa8480a38610e00$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a97f2348d6982ce0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c7745141a55ea3ae$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $240537ed233702d5$export$2e2bcd8739ae039), {})
        ]
    });
}
var $e391825e47c2285e$export$2e2bcd8739ae039 = $e391825e47c2285e$var$Homepage;


// Created by James Launder
// the top level for all of charting

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

// Created By James Launder
// landing page for charting contains basic info

var $aSiaI = parcelRequire("aSiaI");
// created by James Launder
// simple chart that removes alot of the options from the main chart.

var $aSiaI = parcelRequire("aSiaI");
var $8bf0dc2281888f2c$exports = {};
/*
 Highstock JS v11.1.0 (2023-06-05)

 (c) 2009-2021 Torstein Honsi

 License: www.highcharts.com/license
*/ "use strict";
(function(S, L) {
    (0, $8bf0dc2281888f2c$exports) ? (L["default"] = L, $8bf0dc2281888f2c$exports = S.document ? L(S) : L) : "function" === typeof define && define.amd ? define("highcharts/highstock", function() {
        return L(S);
    }) : (S.Highcharts && S.Highcharts.error(16, !0), S.Highcharts = L(S));
})("undefined" !== typeof window ? window : $8bf0dc2281888f2c$exports, function(S) {
    function L(a, A, J, K) {
        a.hasOwnProperty(A) || (a[A] = K.apply(null, J), "function" === typeof CustomEvent && S.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
            detail: {
                path: A,
                module: a[A]
            }
        })));
    }
    var a = {};
    L(a, "Core/Globals.js", [], function() {
        var a;
        (function(a) {
            a.SVG_NS = "http://www.w3.org/2000/svg";
            a.product = "Highcharts";
            a.version = "11.1.0";
            a.win = "undefined" !== typeof S ? S : {};
            a.doc = a.win.document;
            a.svg = a.doc && a.doc.createElementNS && !!a.doc.createElementNS(a.SVG_NS, "svg").createSVGRect;
            a.userAgent = a.win.navigator && a.win.navigator.userAgent || "";
            a.isChrome = -1 !== a.userAgent.indexOf("Chrome");
            a.isFirefox = -1 !== a.userAgent.indexOf("Firefox");
            a.isMS = /(edge|msie|trident)/i.test(a.userAgent) && !a.win.opera;
            a.isSafari = !a.isChrome && -1 !== a.userAgent.indexOf("Safari");
            a.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(a.userAgent);
            a.isWebKit = -1 !== a.userAgent.indexOf("AppleWebKit");
            a.deg2rad = 2 * Math.PI / 360;
            a.hasBidiBug = a.isFirefox && 4 > parseInt(a.userAgent.split("Firefox/")[1], 10);
            a.hasTouch = !!a.win.TouchEvent;
            a.marginNames = [
                "plotTop",
                "marginRight",
                "marginBottom",
                "plotLeft"
            ];
            a.noop = function() {};
            a.supportsPassiveEvents = function() {
                let u = !1;
                if (!a.isMS) {
                    const A = Object.defineProperty({}, "passive", {
                        get: function() {
                            u = !0;
                        }
                    });
                    a.win.addEventListener && a.win.removeEventListener && (a.win.addEventListener("testPassive", a.noop, A), a.win.removeEventListener("testPassive", a.noop, A));
                }
                return u;
            }();
            a.charts = [];
            a.dateFormats = {};
            a.seriesTypes = {};
            a.symbolSizes = {};
            a.chartCount = 0;
        })(a || (a = {}));
        "";
        return a;
    });
    L(a, "Core/Utilities.js", [
        a["Core/Globals.js"]
    ], function(a) {
        function u(c, b, d, z) {
            const k = b ? "Highcharts error" : "Highcharts warning";
            32 === c && (c = `${k}: Deprecated member`);
            const w = t(c);
            let r = w ? `${k} #${c}: www.highcharts.com/errors/${c}/` : c.toString();
            if ("undefined" !== typeof z) {
                let c = "";
                w && (r += "?");
                M(z, function(b, k) {
                    c += `\n - ${k}: ${b}`;
                    w && (r += encodeURI(k) + "=" + encodeURI(b));
                });
                r += c;
            }
            f(a, "displayError", {
                chart: d,
                code: c,
                message: r,
                params: z
            }, function() {
                if (b) throw Error(r);
                l.console && -1 === u.messages.indexOf(r) && console.warn(r);
            });
            u.messages.push(r);
        }
        function J(c, b) {
            return parseInt(c, b || 10);
        }
        function K(c) {
            return "string" === typeof c;
        }
        function G(c) {
            c = Object.prototype.toString.call(c);
            return "[object Array]" === c || "[object Array Iterator]" === c;
        }
        function D(c, b) {
            return !!c && "object" === typeof c && (!b || !G(c));
        }
        function E(c) {
            return D(c) && "number" === typeof c.nodeType;
        }
        function B(c) {
            const b = c && c.constructor;
            return !(!D(c, !0) || E(c) || !b || !b.name || "Object" === b.name);
        }
        function t(c) {
            return "number" === typeof c && !isNaN(c) && Infinity > c && -Infinity < c;
        }
        function q(c) {
            return "undefined" !== typeof c && null !== c;
        }
        function m(c, b, d) {
            const k = K(b) && !q(d);
            let F;
            const w = (b, d)=>{
                q(b) ? c.setAttribute(d, b) : k ? (F = c.getAttribute(d)) || "class" !== d || (F = c.getAttribute(d + "Name")) : c.removeAttribute(d);
            };
            K(b) ? w(d, b) : M(b, w);
            return F;
        }
        function p(c) {
            return G(c) ? c : [
                c
            ];
        }
        function n(c, b) {
            let k;
            c || (c = {});
            for(k in b)c[k] = b[k];
            return c;
        }
        function h() {
            const c = arguments, b = c.length;
            for(let k = 0; k < b; k++){
                const b = c[k];
                if ("undefined" !== typeof b && null !== b) return b;
            }
        }
        function g(c, b) {
            a.isMS && !a.svg && b && q(b.opacity) && (b.filter = `alpha(opacity=${100 * b.opacity})`);
            n(c.style, b);
        }
        function e(c) {
            return Math.pow(10, Math.floor(Math.log(c) / Math.LN10));
        }
        function x(c, b) {
            return 1E14 < c ? c : parseFloat(c.toPrecision(b || 14));
        }
        function I(c, b, d) {
            let k;
            if ("width" === b) return b = Math.min(c.offsetWidth, c.scrollWidth), d = c.getBoundingClientRect && c.getBoundingClientRect().width, d < b && d >= b - 1 && (b = Math.floor(d)), Math.max(0, b - (I(c, "padding-left", !0) || 0) - (I(c, "padding-right", !0) || 0));
            if ("height" === b) return Math.max(0, Math.min(c.offsetHeight, c.scrollHeight) - (I(c, "padding-top", !0) || 0) - (I(c, "padding-bottom", !0) || 0));
            if (c = l.getComputedStyle(c, void 0)) k = c.getPropertyValue(b), h(d, "opacity" !== b) && (k = J(k));
            return k;
        }
        function M(c, b, d) {
            for(const k in c)Object.hasOwnProperty.call(c, k) && b.call(d || c[k], c[k], k, c);
        }
        function C(c, b, d) {
            function k(b, k) {
                const d = c.removeEventListener;
                d && d.call(c, b, k, !1);
            }
            function F(d) {
                let F, w;
                c.nodeName && (b ? (F = {}, F[b] = !0) : F = d, M(F, function(c, b) {
                    if (d[b]) for(w = d[b].length; w--;)k(b, d[b][w].fn);
                }));
            }
            var w = "function" === typeof c && c.prototype || c;
            if (Object.hasOwnProperty.call(w, "hcEvents")) {
                const c = w.hcEvents;
                b ? (w = c[b] || [], d ? (c[b] = w.filter(function(c) {
                    return d !== c.fn;
                }), k(b, d)) : (F(c), c[b] = [])) : (F(c), delete w.hcEvents);
            }
        }
        function f(c, b, d, f) {
            d = d || {};
            if (r.createEvent && (c.dispatchEvent || c.fireEvent && c !== a)) {
                var k = r.createEvent("Events");
                k.initEvent(b, !0, !0);
                d = n(k, d);
                c.dispatchEvent ? c.dispatchEvent(d) : c.fireEvent(b, d);
            } else if (c.hcEvents) {
                d.target || n(d, {
                    preventDefault: function() {
                        d.defaultPrevented = !0;
                    },
                    target: c,
                    type: b
                });
                k = [];
                let F = c, w = !1;
                for(; F.hcEvents;)Object.hasOwnProperty.call(F, "hcEvents") && F.hcEvents[b] && (k.length && (w = !0), k.unshift.apply(k, F.hcEvents[b])), F = Object.getPrototypeOf(F);
                w && k.sort((c, b)=>c.order - b.order);
                k.forEach((b)=>{
                    !1 === b.fn.call(c, d) && d.preventDefault();
                });
            }
            f && !d.defaultPrevented && f.call(c, d);
        }
        const { charts: y, doc: r, win: l } = a;
        (u || (u = {})).messages = [];
        Math.easeInOutSine = function(c) {
            return -0.5 * (Math.cos(Math.PI * c) - 1);
        };
        var v = Array.prototype.find ? function(c, b) {
            return c.find(b);
        } : function(c, b) {
            let k;
            const d = c.length;
            for(k = 0; k < d; k++)if (b(c[k], k)) return c[k];
        };
        M({
            map: "map",
            each: "forEach",
            grep: "filter",
            reduce: "reduce",
            some: "some"
        }, function(c, b) {
            a[b] = function(k) {
                u(32, !1, void 0, {
                    [`Highcharts.${b}`]: `use Array.${c}`
                });
                return Array.prototype[c].apply(k, [].slice.call(arguments, 1));
            };
        });
        let d;
        const b = function() {
            const c = Math.random().toString(36).substring(2, 9) + "-";
            let b = 0;
            return function() {
                return "highcharts-" + (d ? "" : c) + b++;
            };
        }();
        l.jQuery && (l.jQuery.fn.highcharts = function() {
            const c = [].slice.call(arguments);
            if (this[0]) return c[0] ? (new a[K(c[0]) ? c.shift() : "Chart"](this[0], c[0], c[1]), this) : y[m(this[0], "data-highcharts-chart")];
        });
        v = {
            addEvent: function(c, b, d, f = {}) {
                var k = "function" === typeof c && c.prototype || c;
                Object.hasOwnProperty.call(k, "hcEvents") || (k.hcEvents = {});
                k = k.hcEvents;
                a.Point && c instanceof a.Point && c.series && c.series.chart && (c.series.chart.runTrackerClick = !0);
                const w = c.addEventListener;
                w && w.call(c, b, d, a.supportsPassiveEvents ? {
                    passive: void 0 === f.passive ? -1 !== b.indexOf("touch") : f.passive,
                    capture: !1
                } : !1);
                k[b] || (k[b] = []);
                k[b].push({
                    fn: d,
                    order: "number" === typeof f.order ? f.order : Infinity
                });
                k[b].sort((c, b)=>c.order - b.order);
                return function() {
                    C(c, b, d);
                };
            },
            arrayMax: function(c) {
                let b = c.length, d = c[0];
                for(; b--;)c[b] > d && (d = c[b]);
                return d;
            },
            arrayMin: function(c) {
                let b = c.length, d = c[0];
                for(; b--;)c[b] < d && (d = c[b]);
                return d;
            },
            attr: m,
            clamp: function(c, b, d) {
                return c > b ? c < d ? c : d : b;
            },
            clearTimeout: function(c) {
                q(c) && clearTimeout(c);
            },
            correctFloat: x,
            createElement: function(c, b, d, f, F) {
                c = r.createElement(c);
                b && n(c, b);
                F && g(c, {
                    padding: "0",
                    border: "none",
                    margin: "0"
                });
                d && g(c, d);
                f && f.appendChild(c);
                return c;
            },
            css: g,
            defined: q,
            destroyObjectProperties: function(c, b) {
                M(c, function(k, d) {
                    k && k !== b && k.destroy && k.destroy();
                    delete c[d];
                });
            },
            diffObjects: function(c, b, d, f) {
                function k(c, b, F, w) {
                    const H = d ? b : c;
                    M(c, function(d, l) {
                        if (!w && f && -1 < f.indexOf(l) && b[l]) {
                            d = p(d);
                            F[l] = [];
                            for(let c = 0; c < Math.max(d.length, b[l].length); c++)b[l][c] && (void 0 === d[c] ? F[l][c] = b[l][c] : (F[l][c] = {}, k(d[c], b[l][c], F[l][c], w + 1)));
                        } else if (D(d, !0) && !d.nodeType) F[l] = G(d) ? [] : {}, k(d, b[l] || {}, F[l], w + 1), 0 !== Object.keys(F[l]).length || "colorAxis" === l && 0 === w || delete F[l];
                        else if (c[l] !== b[l] || l in c && !(l in b)) F[l] = H[l];
                    });
                }
                const w = {};
                k(c, b, w, 0);
                return w;
            },
            discardElement: function(c) {
                c && c.parentElement && c.parentElement.removeChild(c);
            },
            erase: function(c, b) {
                let k = c.length;
                for(; k--;)if (c[k] === b) {
                    c.splice(k, 1);
                    break;
                }
            },
            error: u,
            extend: n,
            extendClass: function(c, b) {
                const k = function() {};
                k.prototype = new c;
                n(k.prototype, b);
                return k;
            },
            find: v,
            fireEvent: f,
            getClosestDistance: function(c, b) {
                const k = !b;
                let d, F, f, l;
                c.forEach((c)=>{
                    if (1 < c.length) for(l = F = c.length - 1; 0 < l; l--)f = c[l] - c[l - 1], 0 > f && !k ? (null === b || void 0 === b || b(), b = void 0) : f && ("undefined" === typeof d || f < d) && (d = f);
                });
                return d;
            },
            getMagnitude: e,
            getNestedProperty: function(c, b) {
                for(c = c.split("."); c.length && q(b);){
                    const d = c.shift();
                    if ("undefined" === typeof d || "__proto__" === d) return;
                    if ("this" === d) {
                        let c;
                        D(b) && (c = b["@this"]);
                        return null !== c && void 0 !== c ? c : b;
                    }
                    b = b[d];
                    if (!q(b) || "function" === typeof b || "number" === typeof b.nodeType || b === l) return;
                }
                return b;
            },
            getStyle: I,
            inArray: function(c, b, d) {
                u(32, !1, void 0, {
                    "Highcharts.inArray": "use Array.indexOf"
                });
                return b.indexOf(c, d);
            },
            insertItem: function(c, b) {
                const d = c.options.index, k = b.length;
                let F;
                for(F = c.options.isInternal ? k : 0; F < k + 1; F++)if (!b[F] || t(d) && d < h(b[F].options.index, b[F]._i) || b[F].options.isInternal) {
                    b.splice(F, 0, c);
                    break;
                }
                return F;
            },
            isArray: G,
            isClass: B,
            isDOMElement: E,
            isFunction: function(b) {
                return "function" === typeof b;
            },
            isNumber: t,
            isObject: D,
            isString: K,
            keys: function(b) {
                u(32, !1, void 0, {
                    "Highcharts.keys": "use Object.keys"
                });
                return Object.keys(b);
            },
            merge: function() {
                let b, d = arguments, f = {};
                const l = function(b, c) {
                    "object" !== typeof b && (b = {});
                    M(c, function(d, k) {
                        "__proto__" !== k && "constructor" !== k && (!D(d, !0) || B(d) || E(d) ? b[k] = c[k] : b[k] = l(b[k] || {}, d));
                    });
                    return b;
                };
                !0 === d[0] && (f = d[1], d = Array.prototype.slice.call(d, 2));
                const F = d.length;
                for(b = 0; b < F; b++)f = l(f, d[b]);
                return f;
            },
            normalizeTickInterval: function(b, d, f, l, F) {
                let c = b;
                f = h(f, e(b));
                const k = b / f;
                d || (d = F ? [
                    1,
                    1.2,
                    1.5,
                    2,
                    2.5,
                    3,
                    4,
                    5,
                    6,
                    8,
                    10
                ] : [
                    1,
                    2,
                    2.5,
                    5,
                    10
                ], !1 === l && (1 === f ? d = d.filter(function(b) {
                    return 0 === b % 1;
                }) : .1 >= f && (d = [
                    1 / f
                ])));
                for(l = 0; l < d.length && !(c = d[l], F && c * f >= b || !F && k <= (d[l] + (d[l + 1] || d[l])) / 2); l++);
                return c = x(c * f, -Math.round(Math.log(.001) / Math.LN10));
            },
            objectEach: M,
            offset: function(b) {
                const c = r.documentElement;
                b = b.parentElement || b.parentNode ? b.getBoundingClientRect() : {
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0
                };
                return {
                    top: b.top + (l.pageYOffset || c.scrollTop) - (c.clientTop || 0),
                    left: b.left + (l.pageXOffset || c.scrollLeft) - (c.clientLeft || 0),
                    width: b.width,
                    height: b.height
                };
            },
            pad: function(b, d, f) {
                return Array((d || 2) + 1 - String(b).replace("-", "").length).join(f || "0") + b;
            },
            pick: h,
            pInt: J,
            pushUnique: function(b, d) {
                return 0 > b.indexOf(d) && !!b.push(d);
            },
            relativeLength: function(b, d, f) {
                return /%$/.test(b) ? d * parseFloat(b) / 100 + (f || 0) : parseFloat(b);
            },
            removeEvent: C,
            splat: p,
            stableSort: function(b, d) {
                const c = b.length;
                let k, F;
                for(F = 0; F < c; F++)b[F].safeI = F;
                b.sort(function(b, c) {
                    k = d(b, c);
                    return 0 === k ? b.safeI - c.safeI : k;
                });
                for(F = 0; F < c; F++)delete b[F].safeI;
            },
            syncTimeout: function(b, d, f) {
                if (0 < d) return setTimeout(b, d, f);
                b.call(0, f);
                return -1;
            },
            timeUnits: {
                millisecond: 1,
                second: 1E3,
                minute: 6E4,
                hour: 36E5,
                day: 864E5,
                week: 6048E5,
                month: 24192E5,
                year: 314496E5
            },
            uniqueKey: b,
            useSerialIds: function(b) {
                return d = h(b, d);
            },
            wrap: function(b, d, f) {
                const c = b[d];
                b[d] = function() {
                    const b = arguments, d = this;
                    return f.apply(this, [
                        function() {
                            return c.apply(d, arguments.length ? arguments : b);
                        }
                    ].concat([].slice.call(arguments)));
                };
            }
        };
        "";
        return v;
    });
    L(a, "Core/Chart/ChartDefaults.js", [], function() {
        return {
            alignThresholds: !1,
            panning: {
                enabled: !1,
                type: "x"
            },
            styledMode: !1,
            borderRadius: 0,
            colorCount: 10,
            allowMutatingData: !0,
            ignoreHiddenSeries: !0,
            spacing: [
                10,
                10,
                15,
                10
            ],
            resetZoomButton: {
                theme: {
                    zIndex: 6
                },
                position: {
                    align: "right",
                    x: -10,
                    y: 10
                }
            },
            reflow: !0,
            type: "line",
            zooming: {
                singleTouch: !1,
                resetButton: {
                    theme: {
                        zIndex: 6
                    },
                    position: {
                        align: "right",
                        x: -10,
                        y: 10
                    }
                }
            },
            width: null,
            height: null,
            borderColor: "#334eff",
            backgroundColor: "#ffffff",
            plotBorderColor: "#cccccc"
        };
    });
    L(a, "Core/Color/Color.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        const { isNumber: u, merge: K, pInt: G } = A;
        class D {
            static parse(a) {
                return a ? new D(a) : D.None;
            }
            constructor(u){
                this.rgba = [
                    NaN,
                    NaN,
                    NaN,
                    NaN
                ];
                this.input = u;
                const B = a.Color;
                if (B && B !== D) return new B(u);
                this.init(u);
            }
            init(a) {
                let B;
                let t;
                if ("object" === typeof a && "undefined" !== typeof a.stops) this.stops = a.stops.map((m)=>new D(m[1]));
                else if ("string" === typeof a) {
                    this.input = a = D.names[a.toLowerCase()] || a;
                    if ("#" === a.charAt(0)) {
                        var q = a.length;
                        var m = parseInt(a.substr(1), 16);
                        7 === q ? B = [
                            (m & 16711680) >> 16,
                            (m & 65280) >> 8,
                            m & 255,
                            1
                        ] : 4 === q && (B = [
                            (m & 3840) >> 4 | (m & 3840) >> 8,
                            (m & 240) >> 4 | m & 240,
                            (m & 15) << 4 | m & 15,
                            1
                        ]);
                    }
                    if (!B) for(m = D.parsers.length; m-- && !B;)t = D.parsers[m], (q = t.regex.exec(a)) && (B = t.parse(q));
                }
                B && (this.rgba = B);
            }
            get(a) {
                const B = this.input, t = this.rgba;
                if ("object" === typeof B && "undefined" !== typeof this.stops) {
                    const q = K(B);
                    q.stops = [].slice.call(q.stops);
                    this.stops.forEach((m, p)=>{
                        q.stops[p] = [
                            q.stops[p][0],
                            m.get(a)
                        ];
                    });
                    return q;
                }
                return t && u(t[0]) ? "rgb" === a || !a && 1 === t[3] ? "rgb(" + t[0] + "," + t[1] + "," + t[2] + ")" : "a" === a ? `${t[3]}` : "rgba(" + t.join(",") + ")" : B;
            }
            brighten(a) {
                const B = this.rgba;
                if (this.stops) this.stops.forEach(function(t) {
                    t.brighten(a);
                });
                else if (u(a) && 0 !== a) for(let t = 0; 3 > t; t++)B[t] += G(255 * a), 0 > B[t] && (B[t] = 0), 255 < B[t] && (B[t] = 255);
                return this;
            }
            setOpacity(a) {
                this.rgba[3] = a;
                return this;
            }
            tweenTo(a, B) {
                const t = this.rgba, q = a.rgba;
                if (!u(t[0]) || !u(q[0])) return a.input || "none";
                a = 1 !== q[3] || 1 !== t[3];
                return (a ? "rgba(" : "rgb(") + Math.round(q[0] + (t[0] - q[0]) * (1 - B)) + "," + Math.round(q[1] + (t[1] - q[1]) * (1 - B)) + "," + Math.round(q[2] + (t[2] - q[2]) * (1 - B)) + (a ? "," + (q[3] + (t[3] - q[3]) * (1 - B)) : "") + ")";
            }
        }
        D.names = {
            white: "#ffffff",
            black: "#000000"
        };
        D.parsers = [
            {
                regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
                parse: function(a) {
                    return [
                        G(a[1]),
                        G(a[2]),
                        G(a[3]),
                        parseFloat(a[4], 10)
                    ];
                }
            },
            {
                regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
                parse: function(a) {
                    return [
                        G(a[1]),
                        G(a[2]),
                        G(a[3]),
                        1
                    ];
                }
            }
        ];
        D.None = new D("");
        "";
        return D;
    });
    L(a, "Core/Color/Palettes.js", [], function() {
        return {
            colors: "#2caffe #544fc5 #00e272 #fe6a35 #6b8abc #d568fb #2ee0ca #fa4b42 #feb56a #91e8e1".split(" ")
        };
    });
    L(a, "Core/Time.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        const { win: u } = a, { defined: K, error: G, extend: D, isObject: E, merge: B, objectEach: t, pad: q, pick: m, splat: p, timeUnits: n } = A, h = a.isSafari && u.Intl && u.Intl.DateTimeFormat.prototype.formatRange, g = a.isSafari && u.Intl && !u.Intl.DateTimeFormat.prototype.formatRange;
        class e {
            constructor(x){
                this.options = {};
                this.variableTimezone = this.useUTC = !1;
                this.Date = u.Date;
                this.getTimezoneOffset = this.timezoneOffsetFunction();
                this.update(x);
            }
            get(x, e) {
                if (this.variableTimezone || this.timezoneOffset) {
                    const g = e.getTime(), h = g - this.getTimezoneOffset(e);
                    e.setTime(h);
                    x = e["getUTC" + x]();
                    e.setTime(g);
                    return x;
                }
                return this.useUTC ? e["getUTC" + x]() : e["get" + x]();
            }
            set(x, e, g) {
                if (this.variableTimezone || this.timezoneOffset) {
                    if ("Milliseconds" === x || "Seconds" === x || "Minutes" === x && 0 === this.getTimezoneOffset(e) % 36E5) return e["setUTC" + x](g);
                    var I = this.getTimezoneOffset(e);
                    I = e.getTime() - I;
                    e.setTime(I);
                    e["setUTC" + x](g);
                    x = this.getTimezoneOffset(e);
                    I = e.getTime() + x;
                    return e.setTime(I);
                }
                return this.useUTC || h && "FullYear" === x ? e["setUTC" + x](g) : e["set" + x](g);
            }
            update(e = {}) {
                const x = m(e.useUTC, !0);
                this.options = e = B(!0, this.options, e);
                this.Date = e.Date || u.Date || Date;
                this.timezoneOffset = (this.useUTC = x) && e.timezoneOffset || void 0;
                this.getTimezoneOffset = this.timezoneOffsetFunction();
                this.variableTimezone = x && !(!e.getTimezoneOffset && !e.timezone);
            }
            makeTime(e, h, n, q, f, y) {
                let r, l, v;
                this.useUTC ? (r = this.Date.UTC.apply(0, arguments), l = this.getTimezoneOffset(r), r += l, v = this.getTimezoneOffset(r), l !== v ? r += v - l : l - 36E5 !== this.getTimezoneOffset(r - 36E5) || g || (r -= 36E5)) : r = new this.Date(e, h, m(n, 1), m(q, 0), m(f, 0), m(y, 0)).getTime();
                return r;
            }
            timezoneOffsetFunction() {
                const e = this, g = this.options, h = g.getTimezoneOffset, n = g.moment || u.moment;
                if (!this.useUTC) return function(f) {
                    return 6E4 * new Date(f.toString()).getTimezoneOffset();
                };
                if (g.timezone) {
                    if (n) return function(f) {
                        return 6E4 * -n.tz(f, g.timezone).utcOffset();
                    };
                    G(25);
                }
                return this.useUTC && h ? function(f) {
                    return 6E4 * h(f.valueOf());
                } : function() {
                    return 6E4 * (e.timezoneOffset || 0);
                };
            }
            dateFormat(e, g, h) {
                if (!K(g) || isNaN(g)) return a.defaultOptions.lang && a.defaultOptions.lang.invalidDate || "";
                e = m(e, "%Y-%m-%d %H:%M:%S");
                const x = this;
                var f = new this.Date(g);
                const y = this.get("Hours", f), r = this.get("Day", f), l = this.get("Date", f), v = this.get("Month", f), d = this.get("FullYear", f), b = a.defaultOptions.lang, c = b && b.weekdays, k = b && b.shortWeekdays;
                f = D({
                    a: k ? k[r] : c[r].substr(0, 3),
                    A: c[r],
                    d: q(l),
                    e: q(l, 2, " "),
                    w: r,
                    b: b.shortMonths[v],
                    B: b.months[v],
                    m: q(v + 1),
                    o: v + 1,
                    y: d.toString().substr(2, 2),
                    Y: d,
                    H: q(y),
                    k: y,
                    I: q(y % 12 || 12),
                    l: y % 12 || 12,
                    M: q(this.get("Minutes", f)),
                    p: 12 > y ? "AM" : "PM",
                    P: 12 > y ? "am" : "pm",
                    S: q(f.getSeconds()),
                    L: q(Math.floor(g % 1E3), 3)
                }, a.dateFormats);
                t(f, function(b, c) {
                    for(; -1 !== e.indexOf("%" + c);)e = e.replace("%" + c, "function" === typeof b ? b.call(x, g) : b);
                });
                return h ? e.substr(0, 1).toUpperCase() + e.substr(1) : e;
            }
            resolveDTLFormat(e) {
                return E(e, !0) ? e : (e = p(e), {
                    main: e[0],
                    from: e[1],
                    to: e[2]
                });
            }
            getTimeTicks(e, g, h, q) {
                const f = this, y = [], r = {};
                var l = new f.Date(g);
                const v = e.unitRange, d = e.count || 1;
                let b;
                q = m(q, 1);
                if (K(g)) {
                    f.set("Milliseconds", l, v >= n.second ? 0 : d * Math.floor(f.get("Milliseconds", l) / d));
                    v >= n.second && f.set("Seconds", l, v >= n.minute ? 0 : d * Math.floor(f.get("Seconds", l) / d));
                    v >= n.minute && f.set("Minutes", l, v >= n.hour ? 0 : d * Math.floor(f.get("Minutes", l) / d));
                    v >= n.hour && f.set("Hours", l, v >= n.day ? 0 : d * Math.floor(f.get("Hours", l) / d));
                    v >= n.day && f.set("Date", l, v >= n.month ? 1 : Math.max(1, d * Math.floor(f.get("Date", l) / d)));
                    if (v >= n.month) {
                        f.set("Month", l, v >= n.year ? 0 : d * Math.floor(f.get("Month", l) / d));
                        var c = f.get("FullYear", l);
                    }
                    v >= n.year && f.set("FullYear", l, c - c % d);
                    v === n.week && (c = f.get("Day", l), f.set("Date", l, f.get("Date", l) - c + q + (c < q ? -7 : 0)));
                    c = f.get("FullYear", l);
                    q = f.get("Month", l);
                    const k = f.get("Date", l), w = f.get("Hours", l);
                    g = l.getTime();
                    !f.variableTimezone && f.useUTC || !K(h) || (b = h - g > 4 * n.month || f.getTimezoneOffset(g) !== f.getTimezoneOffset(h));
                    g = l.getTime();
                    for(l = 1; g < h;)y.push(g), g = v === n.year ? f.makeTime(c + l * d, 0) : v === n.month ? f.makeTime(c, q + l * d) : !b || v !== n.day && v !== n.week ? b && v === n.hour && 1 < d ? f.makeTime(c, q, k, w + l * d) : g + v * d : f.makeTime(c, q, k + l * d * (v === n.day ? 1 : 7)), l++;
                    y.push(g);
                    v <= n.hour && 1E4 > y.length && y.forEach(function(b) {
                        0 === b % 18E5 && "000000000" === f.dateFormat("%H%M%S%L", b) && (r[b] = "day");
                    });
                }
                y.info = D(e, {
                    higherRanks: r,
                    totalRange: v * d
                });
                return y;
            }
            getDateFormat(e, g, h, q) {
                const f = this.dateFormat("%m-%d %H:%M:%S.%L", g), y = {
                    millisecond: 15,
                    second: 12,
                    minute: 9,
                    hour: 6,
                    day: 3
                };
                let r, l = "millisecond";
                for(r in n){
                    if (e === n.week && +this.dateFormat("%w", g) === h && "00:00:00.000" === f.substr(6)) {
                        r = "week";
                        break;
                    }
                    if (n[r] > e) {
                        r = l;
                        break;
                    }
                    if (y[r] && f.substr(y[r]) !== "01-01 00:00:00.000".substr(y[r])) break;
                    "week" !== r && (l = r);
                }
                return this.resolveDTLFormat(q[r]).main;
            }
        }
        "";
        return e;
    });
    L(a, "Core/Defaults.js", [
        a["Core/Chart/ChartDefaults.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Color/Palettes.js"],
        a["Core/Time.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D) {
        const { isTouchDevice: u, svg: B } = J, { merge: t } = D, q = {
            colors: K.colors,
            symbols: [
                "circle",
                "diamond",
                "square",
                "triangle",
                "triangle-down"
            ],
            lang: {
                loading: "Loading...",
                months: "January February March April May June July August September October November December".split(" "),
                shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
                weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
                decimalPoint: ".",
                numericSymbols: "kMGTPE".split(""),
                resetZoom: "Reset zoom",
                resetZoomTitle: "Reset zoom level 1:1",
                thousandsSep: " "
            },
            global: {},
            time: {
                Date: void 0,
                getTimezoneOffset: void 0,
                timezone: void 0,
                timezoneOffset: 0,
                useUTC: !0
            },
            chart: a,
            title: {
                style: {
                    color: "#333333",
                    fontWeight: "bold"
                },
                text: "Chart title",
                align: "center",
                margin: 15,
                widthAdjust: -44
            },
            subtitle: {
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "center",
                widthAdjust: -44
            },
            caption: {
                margin: 15,
                style: {
                    color: "#666666",
                    fontSize: "0.8em"
                },
                text: "",
                align: "left",
                verticalAlign: "bottom"
            },
            plotOptions: {},
            legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                className: "highcharts-no-tooltip",
                layout: "horizontal",
                itemMarginBottom: 2,
                itemMarginTop: 2,
                labelFormatter: function() {
                    return this.name;
                },
                borderColor: "#999999",
                borderRadius: 0,
                navigation: {
                    style: {
                        fontSize: "0.8em"
                    },
                    activeColor: "#0022ff",
                    inactiveColor: "#cccccc"
                },
                itemStyle: {
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    textDecoration: "none",
                    textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                    color: "#000000"
                },
                itemHiddenStyle: {
                    color: "#666666",
                    textDecoration: "line-through"
                },
                shadow: !1,
                itemCheckboxStyle: {
                    position: "absolute",
                    width: "13px",
                    height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                    style: {
                        fontSize: "0.8em",
                        fontWeight: "bold"
                    }
                }
            },
            loading: {
                labelStyle: {
                    fontWeight: "bold",
                    position: "relative",
                    top: "45%"
                },
                style: {
                    position: "absolute",
                    backgroundColor: "#ffffff",
                    opacity: .5,
                    textAlign: "center"
                }
            },
            tooltip: {
                enabled: !0,
                animation: B,
                borderRadius: 3,
                dateTimeLabelFormats: {
                    millisecond: "%A, %e %b, %H:%M:%S.%L",
                    second: "%A, %e %b, %H:%M:%S",
                    minute: "%A, %e %b, %H:%M",
                    hour: "%A, %e %b, %H:%M",
                    day: "%A, %e %b %Y",
                    week: "Week from %A, %e %b %Y",
                    month: "%B %Y",
                    year: "%Y"
                },
                footerFormat: "",
                headerShape: "callout",
                hideDelay: 500,
                padding: 8,
                shape: "callout",
                shared: !1,
                snap: u ? 25 : 10,
                headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
                backgroundColor: "#ffffff",
                borderWidth: void 0,
                shadow: !0,
                stickOnContact: !1,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "0.8em"
                },
                useHTML: !1
            },
            credits: {
                enabled: !0,
                href: "https://www.highcharts.com?credits",
                position: {
                    align: "right",
                    x: -10,
                    verticalAlign: "bottom",
                    y: -5
                },
                style: {
                    cursor: "pointer",
                    color: "#999999",
                    fontSize: "0.6em"
                },
                text: "Highcharts.com"
            }
        };
        q.chart.styledMode = !1;
        "";
        const m = new G(q.time);
        a = {
            defaultOptions: q,
            defaultTime: m,
            getOptions: function() {
                return q;
            },
            setOptions: function(a) {
                t(!0, q, a);
                if (a.time || a.global) J.time ? J.time.update(t(q.global, q.time, a.global, a.time)) : J.time = m;
                return q;
            }
        };
        "";
        return a;
    });
    L(a, "Core/Animation/Fx.js", [
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { parse: u } = a, { win: G } = A, { isNumber: D, objectEach: E } = J;
        class B {
            constructor(a, q, m){
                this.pos = NaN;
                this.options = q;
                this.elem = a;
                this.prop = m;
            }
            dSetter() {
                var a = this.paths;
                const q = a && a[0];
                a = a && a[1];
                const m = this.now || 0;
                let p = [];
                if (1 !== m && q && a) {
                    if (q.length === a.length && 1 > m) for(let n = 0; n < a.length; n++){
                        const h = q[n], g = a[n], e = [];
                        for(let x = 0; x < g.length; x++){
                            const a = h[x], n = g[x];
                            D(a) && D(n) && ("A" !== g[0] || 4 !== x && 5 !== x) ? e[x] = a + m * (n - a) : e[x] = n;
                        }
                        p.push(e);
                    }
                    else p = a;
                } else p = this.toD || [];
                this.elem.attr("d", p, void 0, !0);
            }
            update() {
                const a = this.elem, q = this.prop, m = this.now, p = this.options.step;
                if (this[q + "Setter"]) this[q + "Setter"]();
                else a.attr ? a.element && a.attr(q, m, null, !0) : a.style[q] = m + this.unit;
                p && p.call(a, m, this);
            }
            run(a, q, m) {
                const p = this, n = p.options, h = function(e) {
                    return h.stopped ? !1 : p.step(e);
                }, g = G.requestAnimationFrame || function(e) {
                    setTimeout(e, 13);
                }, e = function() {
                    for(let e = 0; e < B.timers.length; e++)B.timers[e]() || B.timers.splice(e--, 1);
                    B.timers.length && g(e);
                };
                a !== q || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = a, this.end = q, this.unit = m, this.now = this.start, this.pos = 0, h.elem = this.elem, h.prop = this.prop, h() && 1 === B.timers.push(h) && g(e)) : (delete n.curAnim[this.prop], n.complete && 0 === Object.keys(n.curAnim).length && n.complete.call(this.elem));
            }
            step(a) {
                const q = +new Date, m = this.options, p = this.elem, n = m.complete, h = m.duration, g = m.curAnim;
                let e;
                p.attr && !p.element ? a = !1 : a || q >= h + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), e = g[this.prop] = !0, E(g, function(g) {
                    !0 !== g && (e = !1);
                }), e && n && n.call(p), a = !1) : (this.pos = m.easing((q - this.startTime) / h), this.now = this.start + (this.end - this.start) * this.pos, this.update(), a = !0);
                return a;
            }
            initPath(a, q, m) {
                function p(f, y) {
                    for(; f.length < M;){
                        var r = f[0];
                        const l = y[M - f.length];
                        l && "M" === r[0] && (f[0] = "C" === l[0] ? [
                            "C",
                            r[1],
                            r[2],
                            r[1],
                            r[2],
                            r[1],
                            r[2]
                        ] : [
                            "L",
                            r[1],
                            r[2]
                        ]);
                        f.unshift(r);
                        e && (r = f.pop(), f.push(f[f.length - 1], r));
                    }
                }
                function n(f, y) {
                    for(; f.length < M;)if (y = f[Math.floor(f.length / x) - 1].slice(), "C" === y[0] && (y[1] = y[5], y[2] = y[6]), e) {
                        const e = f[Math.floor(f.length / x)].slice();
                        f.splice(f.length / 2, 0, y, e);
                    } else f.push(y);
                }
                const h = a.startX, g = a.endX;
                m = m.slice();
                const e = a.isArea, x = e ? 2 : 1;
                let I, M, C;
                q = q && q.slice();
                if (!q) return [
                    m,
                    m
                ];
                if (h && g && g.length) {
                    for(a = 0; a < h.length; a++)if (h[a] === g[0]) {
                        I = a;
                        break;
                    } else if (h[0] === g[g.length - h.length + a]) {
                        I = a;
                        C = !0;
                        break;
                    } else if (h[h.length - 1] === g[g.length - h.length + a]) {
                        I = h.length - a;
                        break;
                    }
                    "undefined" === typeof I && (q = []);
                }
                q.length && D(I) && (M = m.length + I * x, C ? (p(q, m), n(m, q)) : (p(m, q), n(q, m)));
                return [
                    q,
                    m
                ];
            }
            fillSetter() {
                B.prototype.strokeSetter.apply(this, arguments);
            }
            strokeSetter() {
                this.elem.attr(this.prop, u(this.start).tweenTo(u(this.end), this.pos), void 0, !0);
            }
        }
        B.timers = [];
        return B;
    });
    L(a, "Core/Animation/AnimationUtilities.js", [
        a["Core/Animation/Fx.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        function u(a) {
            return t(a) ? q({
                duration: 500,
                defer: 0
            }, a) : {
                duration: a ? 500 : 0,
                defer: 0
            };
        }
        function K(n, h) {
            let g = a.timers.length;
            for(; g--;)a.timers[g].elem !== n || h && h !== a.timers[g].prop || (a.timers[g].stopped = !0);
        }
        const { defined: G, getStyle: D, isArray: E, isNumber: B, isObject: t, merge: q, objectEach: m, pick: p } = A;
        return {
            animate: function(n, h, g) {
                let e, x = "", I, p, C;
                t(g) || (C = arguments, g = {
                    duration: C[2],
                    easing: C[3],
                    complete: C[4]
                });
                B(g.duration) || (g.duration = 400);
                g.easing = "function" === typeof g.easing ? g.easing : Math[g.easing] || Math.easeInOutSine;
                g.curAnim = q(h);
                m(h, function(f, y) {
                    K(n, y);
                    p = new a(n, g, y);
                    I = void 0;
                    "d" === y && E(h.d) ? (p.paths = p.initPath(n, n.pathArray, h.d), p.toD = h.d, e = 0, I = 1) : n.attr ? e = n.attr(y) : (e = parseFloat(D(n, y)) || 0, "opacity" !== y && (x = "px"));
                    I || (I = f);
                    "string" === typeof I && I.match("px") && (I = I.replace(/px/g, ""));
                    p.run(e, I, x);
                });
            },
            animObject: u,
            getDeferredAnimation: function(a, h, g) {
                const e = u(h);
                let x = 0, n = 0;
                (g ? [
                    g
                ] : a.series).forEach((g)=>{
                    g = u(g.options.animation);
                    x = h && G(h.defer) ? e.defer : Math.max(x, g.duration + g.defer);
                    n = Math.min(e.duration, g.duration);
                });
                a.renderer.forExport && (x = 0);
                return {
                    defer: Math.max(0, x - n),
                    duration: Math.min(x, n)
                };
            },
            setAnimation: function(a, h) {
                h.renderer.globalAnimation = p(a, h.options.chart.animation, !0);
            },
            stop: K
        };
    });
    L(a, "Core/Renderer/HTML/AST.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        const { SVG_NS: u, win: K } = a, { attr: G, createElement: D, css: E, error: B, isFunction: t, isString: q, objectEach: m, splat: p } = A;
        ({ trustedTypes: A } = K);
        const n = A && t(A.createPolicy) && A.createPolicy("highcharts", {
            createHTML: (e)=>e
        });
        A = n ? n.createHTML("") : "";
        try {
            var h = !!(new DOMParser).parseFromString(A, "text/html");
        } catch (x) {
            h = !1;
        }
        const g = h;
        class e {
            static filterUserAttributes(g) {
                m(g, (x, h)=>{
                    let a = !0;
                    -1 === e.allowedAttributes.indexOf(h) && (a = !1);
                    -1 !== [
                        "background",
                        "dynsrc",
                        "href",
                        "lowsrc",
                        "src"
                    ].indexOf(h) && (a = q(x) && e.allowedReferences.some((f)=>0 === x.indexOf(f)));
                    a || (B(33, !1, void 0, {
                        "Invalid attribute in config": `${h}`
                    }), delete g[h]);
                    q(x) && g[h] && (g[h] = x.replace(/</g, "&lt;"));
                });
                return g;
            }
            static parseStyle(e) {
                return e.split(";").reduce((e, g)=>{
                    g = g.split(":").map((f)=>f.trim());
                    const x = g.shift();
                    x && g.length && (e[x.replace(/-([a-z])/g, (f)=>f[1].toUpperCase())] = g.join(":"));
                    return e;
                }, {});
            }
            static setElementHTML(g, h) {
                g.innerHTML = e.emptyHTML;
                h && new e(h).addToDOM(g);
            }
            constructor(e){
                this.nodes = "string" === typeof e ? this.parseMarkup(e) : e;
            }
            addToDOM(g) {
                function h(g, x) {
                    let f;
                    p(g).forEach(function(y) {
                        var r = y.tagName;
                        const l = y.textContent ? a.doc.createTextNode(y.textContent) : void 0, v = e.bypassHTMLFiltering;
                        let d;
                        if (r) {
                            if ("#text" === r) d = l;
                            else if (-1 !== e.allowedTags.indexOf(r) || v) {
                                r = a.doc.createElementNS("svg" === r ? u : x.namespaceURI || u, r);
                                const b = y.attributes || {};
                                m(y, function(c, d) {
                                    "tagName" !== d && "attributes" !== d && "children" !== d && "style" !== d && "textContent" !== d && (b[d] = c);
                                });
                                G(r, v ? b : e.filterUserAttributes(b));
                                y.style && E(r, y.style);
                                l && r.appendChild(l);
                                h(y.children || [], r);
                                d = r;
                            } else B(33, !1, void 0, {
                                "Invalid tagName in config": r
                            });
                        }
                        d && x.appendChild(d);
                        f = d;
                    });
                    return f;
                }
                return h(this.nodes, g);
            }
            parseMarkup(h) {
                const x = [];
                h = h.trim().replace(/ style=(["'])/g, " data-style=$1");
                if (g) h = (new DOMParser).parseFromString(n ? n.createHTML(h) : h, "text/html");
                else {
                    const e = D("div");
                    e.innerHTML = h;
                    h = {
                        body: e
                    };
                }
                const a = (g, f)=>{
                    var y = g.nodeName.toLowerCase();
                    const r = {
                        tagName: y
                    };
                    "#text" === y && (r.textContent = g.textContent || "");
                    if (y = g.attributes) {
                        const f = {};
                        [].forEach.call(y, (l)=>{
                            "data-style" === l.name ? r.style = e.parseStyle(l.value) : f[l.name] = l.value;
                        });
                        r.attributes = f;
                    }
                    if (g.childNodes.length) {
                        const f = [];
                        [].forEach.call(g.childNodes, (l)=>{
                            a(l, f);
                        });
                        f.length && (r.children = f);
                    }
                    f.push(r);
                };
                [].forEach.call(h.body.childNodes, (e)=>a(e, x));
                return x;
            }
        }
        e.allowedAttributes = "alt aria-controls aria-describedby aria-expanded aria-haspopup aria-hidden aria-label aria-labelledby aria-live aria-pressed aria-readonly aria-roledescription aria-selected class clip-path color colspan cx cy d dx dy disabled fill flood-color flood-opacity height href id in markerHeight markerWidth offset opacity orient padding paddingLeft paddingRight patternUnits r refX refY role scope slope src startOffset stdDeviation stroke stroke-linecap stroke-width style tableValues result rowspan summary target tabindex text-align text-anchor textAnchor textLength title type valign width x x1 x2 xlink:href y y1 y2 zIndex".split(" ");
        e.allowedReferences = "https:// http:// mailto: / ../ ./ #".split(" ");
        e.allowedTags = "a abbr b br button caption circle clipPath code dd defs div dl dt em feComponentTransfer feDropShadow feFuncA feFuncB feFuncG feFuncR feGaussianBlur feOffset feMerge feMergeNode filter h1 h2 h3 h4 h5 h6 hr i img li linearGradient marker ol p path pattern pre rect small span stop strong style sub sup svg table text textPath thead title tbody tspan td th tr u ul #text".split(" ");
        e.emptyHTML = A;
        e.bypassHTMLFiltering = !1;
        "";
        return e;
    });
    L(a, "Core/Templating.js", [
        a["Core/Defaults.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        function u(g = "", e, x) {
            const a = /\{([a-zA-Z0-9:\.,;\-\/<>%_@"'= #\(\)]+)\}/g, n = /\(([a-zA-Z0-9:\.,;\-\/<>%_@"'= ]+)\)/g, q = [], f = /f$/, y = /\.([0-9])/, r = G.lang, l = x && x.time || D, v = x && x.numberFormatter || K, d = (b = "")=>{
                let c;
                return "true" === b ? !0 : "false" === b ? !1 : (c = Number(b)).toString() === b ? c : B(b, e);
            };
            let b, c, k = 0, w;
            for(; null !== (b = a.exec(g));){
                const d = n.exec(b[1]);
                d && (b = d, w = !0);
                c && c.isBlock || (c = {
                    ctx: e,
                    expression: b[1],
                    find: b[0],
                    isBlock: "#" === b[1].charAt(0),
                    start: b.index,
                    startInner: b.index + b[0].length,
                    length: b[0].length
                });
                var z = b[1].split(" ")[0].replace("#", "");
                h[z] && (c.isBlock && z === c.fn && k++, c.fn || (c.fn = z));
                z = "else" === b[1];
                if (c.isBlock && c.fn && (b[1] === `/${c.fn}` || z)) {
                    if (k) z || k--;
                    else {
                        var F = c.startInner;
                        F = g.substr(F, b.index - F);
                        void 0 === c.body ? (c.body = F, c.startInner = b.index + b[0].length) : c.elseBody = F;
                        c.find += F + b[0];
                        z || (q.push(c), c = void 0);
                    }
                } else c.isBlock || q.push(c);
                if (d && (null === c || void 0 === c || !c.isBlock)) break;
            }
            q.forEach((b)=>{
                const { body: c, elseBody: k, expression: F, fn: w } = b;
                var H;
                if (w) {
                    var z = [
                        b
                    ], x = F.split(" ");
                    for(H = h[w].length; H--;)z.unshift(d(x[H + 1]));
                    H = h[w].apply(e, z);
                    b.isBlock && "boolean" === typeof H && (H = u(H ? c : k, e));
                } else z = F.split(":"), H = d(z.shift() || ""), z.length && "number" === typeof H && (z = z.join(":"), f.test(z) ? (x = parseInt((z.match(y) || [
                    "",
                    "-1"
                ])[1], 10), null !== H && (H = v(H, x, r.decimalPoint, -1 < z.indexOf(",") ? r.thousandsSep : ""))) : H = l.dateFormat(z, H));
                g = g.replace(b.find, p(H, ""));
            });
            return w ? u(g, e, x) : g;
        }
        function K(g, e, h, a) {
            g = +g || 0;
            e = +e;
            const x = G.lang;
            var m = (g.toString().split(".")[1] || "").split("e")[0].length;
            const f = g.toString().split("e"), y = e;
            if (-1 === e) e = Math.min(m, 20);
            else if (!q(e)) e = 2;
            else if (e && f[1] && 0 > f[1]) {
                var r = e + +f[1];
                0 <= r ? (f[0] = (+f[0]).toExponential(r).split("e")[0], e = r) : (f[0] = f[0].split(".")[0] || 0, g = 20 > e ? (f[0] * Math.pow(10, f[1])).toFixed(e) : 0, f[1] = 0);
            }
            r = (Math.abs(f[1] ? f[0] : g) + Math.pow(10, -Math.max(e, m) - 1)).toFixed(e);
            m = String(n(r));
            const l = 3 < m.length ? m.length % 3 : 0;
            h = p(h, x.decimalPoint);
            a = p(a, x.thousandsSep);
            g = (0 > g ? "-" : "") + (l ? m.substr(0, l) + a : "");
            g = 0 > +f[1] && !y ? "0" : g + m.substr(l).replace(/(\d{3})(?=\d)/g, "$1" + a);
            e && (g += h + r.slice(-e));
            f[1] && 0 !== +g && (g += "e" + f[1]);
            return g;
        }
        const { defaultOptions: G, defaultTime: D } = a, { extend: E, getNestedProperty: B, isArray: t, isNumber: q, isObject: m, pick: p, pInt: n } = A, h = {
            add: (g, e)=>g + e,
            divide: (g, e)=>0 !== e ? g / e : "",
            eq: (g, e)=>g == e,
            each: function(g) {
                const e = arguments[arguments.length - 1];
                return t(g) ? g.map((h, a)=>u(e.body, E(m(h) ? h : {
                        "@this": h
                    }, {
                        "@index": a,
                        "@first": 0 === a,
                        "@last": a === g.length - 1
                    }))).join("") : !1;
            },
            ge: (g, e)=>g >= e,
            gt: (g, e)=>g > e,
            "if": (g)=>!!g,
            le: (g, e)=>g <= e,
            lt: (g, e)=>g < e,
            multiply: (g, e)=>g * e,
            ne: (g, e)=>g != e,
            subtract: (g, e)=>g - e,
            unless: (g)=>!g
        };
        return {
            dateFormat: function(g, e, h) {
                return D.dateFormat(g, e, h);
            },
            format: u,
            helpers: h,
            numberFormat: K
        };
    });
    L(a, "Core/Renderer/RendererUtilities.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { clamp: u, pick: J, stableSort: K } = a;
        var G;
        (function(a) {
            function A(a, t, q) {
                const m = a;
                var p = m.reducedLen || t, n = (e, g)=>(g.rank || 0) - (e.rank || 0);
                const h = (e, g)=>e.target - g.target;
                let g, e = !0, x = [], I = 0;
                for(g = a.length; g--;)I += a[g].size;
                if (I > p) {
                    K(a, n);
                    for(I = g = 0; I <= p;)I += a[g].size, g++;
                    x = a.splice(g - 1, a.length);
                }
                K(a, h);
                for(a = a.map((e)=>({
                        size: e.size,
                        targets: [
                            e.target
                        ],
                        align: J(e.align, .5)
                    })); e;){
                    for(g = a.length; g--;)p = a[g], n = (Math.min.apply(0, p.targets) + Math.max.apply(0, p.targets)) / 2, p.pos = u(n - p.size * p.align, 0, t - p.size);
                    g = a.length;
                    for(e = !1; g--;)0 < g && a[g - 1].pos + a[g - 1].size > a[g].pos && (a[g - 1].size += a[g].size, a[g - 1].targets = a[g - 1].targets.concat(a[g].targets), a[g - 1].align = .5, a[g - 1].pos + a[g - 1].size > t && (a[g - 1].pos = t - a[g - 1].size), a.splice(g, 1), e = !0);
                }
                m.push.apply(m, x);
                g = 0;
                a.some((e)=>{
                    let a = 0;
                    return (e.targets || []).some(()=>{
                        m[g].pos = e.pos + a;
                        if ("undefined" !== typeof q && Math.abs(m[g].pos - m[g].target) > q) return m.slice(0, g + 1).forEach((f)=>delete f.pos), m.reducedLen = (m.reducedLen || t) - .1 * t, m.reducedLen > .1 * t && A(m, t, q), !0;
                        a += m[g].size;
                        g++;
                        return !1;
                    });
                });
                K(m, h);
                return m;
            }
            a.distribute = A;
        })(G || (G = {}));
        return G;
    });
    L(a, "Core/Renderer/SVG/SVGElement.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K) {
        const { animate: u, animObject: D, stop: E } = a, { deg2rad: B, doc: t, svg: q, SVG_NS: m, win: p } = J, { addEvent: n, attr: h, createElement: g, css: e, defined: x, erase: I, extend: M, fireEvent: C, isArray: f, isFunction: y, isObject: r, isString: l, merge: v, objectEach: d, pick: b, pInt: c, syncTimeout: k, uniqueKey: w } = K;
        class z {
            constructor(){
                this.element = void 0;
                this.onEvents = {};
                this.opacity = 1;
                this.renderer = void 0;
                this.SVG_NS = m;
            }
            _defaultGetter(c) {
                c = b(this[c + "Value"], this[c], this.element ? this.element.getAttribute(c) : null, 0);
                /^[\-0-9\.]+$/.test(c) && (c = parseFloat(c));
                return c;
            }
            _defaultSetter(b, c, d) {
                d.setAttribute(c, b);
            }
            add(b) {
                const c = this.renderer, d = this.element;
                let k;
                b && (this.parentGroup = b);
                "undefined" !== typeof this.textStr && "text" === this.element.nodeName && c.buildText(this);
                this.added = !0;
                if (!b || b.handleZ || this.zIndex) k = this.zIndexSetter();
                k || (b ? b.element : c.box).appendChild(d);
                if (this.onAdd) this.onAdd();
                return this;
            }
            addClass(b, c) {
                const d = c ? "" : this.attr("class") || "";
                b = (b || "").split(/ /g).reduce(function(b, c) {
                    -1 === d.indexOf(c) && b.push(c);
                    return b;
                }, d ? [
                    d
                ] : []).join(" ");
                b !== d && this.attr("class", b);
                return this;
            }
            afterSetters() {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
            }
            align(c, d, k) {
                const F = {};
                var f = this.renderer, e = f.alignedObjects, H;
                let w, r;
                if (c) {
                    if (this.alignOptions = c, this.alignByTranslate = d, !k || l(k)) this.alignTo = H = k || "renderer", I(e, this), e.push(this), k = void 0;
                } else c = this.alignOptions, d = this.alignByTranslate, H = this.alignTo;
                k = b(k, f[H], "scrollablePlotBox" === H ? f.plotBox : void 0, f);
                H = c.align;
                const z = c.verticalAlign;
                f = (k.x || 0) + (c.x || 0);
                e = (k.y || 0) + (c.y || 0);
                "right" === H ? w = 1 : "center" === H && (w = 2);
                w && (f += (k.width - (c.width || 0)) / w);
                F[d ? "translateX" : "x"] = Math.round(f);
                "bottom" === z ? r = 1 : "middle" === z && (r = 2);
                r && (e += (k.height - (c.height || 0)) / r);
                F[d ? "translateY" : "y"] = Math.round(e);
                this[this.placed ? "animate" : "attr"](F);
                this.placed = !0;
                this.alignAttr = F;
                return this;
            }
            alignSetter(b) {
                const c = {
                    left: "start",
                    center: "middle",
                    right: "end"
                };
                c[b] && (this.alignValue = b, this.element.setAttribute("text-anchor", c[b]));
            }
            animate(c, f, l) {
                const F = D(b(f, this.renderer.globalAnimation, !0));
                f = F.defer;
                t.hidden && (F.duration = 0);
                0 !== F.duration ? (l && (F.complete = l), k(()=>{
                    this.element && u(this, c, F);
                }, f)) : (this.attr(c, void 0, l || F.complete), d(c, function(b, c) {
                    F.step && F.step.call(this, b, {
                        prop: c,
                        pos: 1,
                        elem: this
                    });
                }, this));
                return this;
            }
            applyTextOutline(b) {
                const c = this.element;
                -1 !== b.indexOf("contrast") && (b = b.replace(/contrast/g, this.renderer.getContrast(c.style.fill)));
                var d = b.split(" ");
                b = d[d.length - 1];
                if ((d = d[0]) && "none" !== d && J.svg) {
                    this.fakeTS = !0;
                    d = d.replace(/(^[\d\.]+)(.*?)$/g, function(b, c, d) {
                        return 2 * Number(c) + d;
                    });
                    this.removeTextOutline();
                    const k = t.createElementNS(m, "tspan");
                    h(k, {
                        "class": "highcharts-text-outline",
                        fill: b,
                        stroke: b,
                        "stroke-width": d,
                        "stroke-linejoin": "round"
                    });
                    b = c.querySelector("textPath") || c;
                    [].forEach.call(b.childNodes, (b)=>{
                        const c = b.cloneNode(!0);
                        c.removeAttribute && [
                            "fill",
                            "stroke",
                            "stroke-width",
                            "stroke"
                        ].forEach((b)=>c.removeAttribute(b));
                        k.appendChild(c);
                    });
                    let F = 0;
                    [].forEach.call(b.querySelectorAll("text tspan"), (b)=>{
                        F += Number(b.getAttribute("dy"));
                    });
                    d = t.createElementNS(m, "tspan");
                    d.textContent = "\u200B";
                    h(d, {
                        x: Number(c.getAttribute("x")),
                        dy: -F
                    });
                    k.appendChild(d);
                    b.insertBefore(k, b.firstChild);
                }
            }
            attr(b, c, k, f) {
                const F = this.element, l = z.symbolCustomAttribs;
                let H, e, w = this, r, v;
                "string" === typeof b && "undefined" !== typeof c && (H = b, b = {}, b[H] = c);
                "string" === typeof b ? w = (this[b + "Getter"] || this._defaultGetter).call(this, b, F) : (d(b, function(c, d) {
                    r = !1;
                    f || E(this, d);
                    this.symbolName && -1 !== l.indexOf(d) && (e || (this.symbolAttr(b), e = !0), r = !0);
                    !this.rotation || "x" !== d && "y" !== d || (this.doTransform = !0);
                    r || (v = this[d + "Setter"] || this._defaultSetter, v.call(this, c, d, F));
                }, this), this.afterSetters());
                k && k.call(this);
                return w;
            }
            clip(b) {
                return this.attr("clip-path", b ? "url(" + this.renderer.url + "#" + b.id + ")" : "none");
            }
            crisp(b, c) {
                c = c || b.strokeWidth || 0;
                const d = Math.round(c) % 2 / 2;
                b.x = Math.floor(b.x || this.x || 0) + d;
                b.y = Math.floor(b.y || this.y || 0) + d;
                b.width = Math.floor((b.width || this.width || 0) - 2 * d);
                b.height = Math.floor((b.height || this.height || 0) - 2 * d);
                x(b.strokeWidth) && (b.strokeWidth = c);
                return b;
            }
            complexColor(b, c, k) {
                const F = this.renderer;
                let l, e, H, r, z, y, g, N, a, h, n = [], q;
                C(this.renderer, "complexColor", {
                    args: arguments
                }, function() {
                    b.radialGradient ? e = "radialGradient" : b.linearGradient && (e = "linearGradient");
                    if (e) {
                        H = b[e];
                        z = F.gradients;
                        y = b.stops;
                        a = k.radialReference;
                        f(H) && (b[e] = H = {
                            x1: H[0],
                            y1: H[1],
                            x2: H[2],
                            y2: H[3],
                            gradientUnits: "userSpaceOnUse"
                        });
                        "radialGradient" === e && a && !x(H.gradientUnits) && (r = H, H = v(H, F.getRadialAttr(a, r), {
                            gradientUnits: "userSpaceOnUse"
                        }));
                        d(H, function(b, c) {
                            "id" !== c && n.push(c, b);
                        });
                        d(y, function(b) {
                            n.push(b);
                        });
                        n = n.join(",");
                        if (z[n]) h = z[n].attr("id");
                        else {
                            H.id = h = w();
                            const b = z[n] = F.createElement(e).attr(H).add(F.defs);
                            b.radAttr = r;
                            b.stops = [];
                            y.forEach(function(c) {
                                0 === c[1].indexOf("rgba") ? (l = A.parse(c[1]), g = l.get("rgb"), N = l.get("a")) : (g = c[1], N = 1);
                                c = F.createElement("stop").attr({
                                    offset: c[0],
                                    "stop-color": g,
                                    "stop-opacity": N
                                }).add(b);
                                b.stops.push(c);
                            });
                        }
                        q = "url(" + F.url + "#" + h + ")";
                        k.setAttribute(c, q);
                        k.gradient = n;
                        b.toString = function() {
                            return q;
                        };
                    }
                });
            }
            css(b) {
                const k = this.styles, f = {}, F = this.element;
                let l, w = !k;
                k && d(b, function(b, c) {
                    k && k[c] !== b && (f[c] = b, w = !0);
                });
                if (w) {
                    k && (b = M(k, f));
                    null === b.width || "auto" === b.width ? delete this.textWidth : "text" === F.nodeName.toLowerCase() && b.width && (l = this.textWidth = c(b.width));
                    this.styles = b;
                    l && !q && this.renderer.forExport && delete b.width;
                    const d = v(b);
                    F.namespaceURI === this.SVG_NS && ([
                        "textOutline",
                        "textOverflow",
                        "width"
                    ].forEach((b)=>d && delete d[b]), d.color && (d.fill = d.color));
                    e(F, d);
                }
                this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), b.textOutline && this.applyTextOutline(b.textOutline));
                return this;
            }
            dashstyleSetter(d) {
                let k = this["stroke-width"];
                "inherit" === k && (k = 1);
                if (d = d && d.toLowerCase()) {
                    const f = d.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                    for(d = f.length; d--;)f[d] = "" + c(f[d]) * b(k, NaN);
                    d = f.join(",").replace(/NaN/g, "none");
                    this.element.setAttribute("stroke-dasharray", d);
                }
            }
            destroy() {
                const b = this;
                var c = b.element || {};
                const k = b.renderer;
                var f = c.ownerSVGElement;
                let l = "SPAN" === c.nodeName && b.parentGroup || void 0;
                c.onclick = c.onmouseout = c.onmouseover = c.onmousemove = c.point = null;
                E(b);
                if (b.clipPath && f) {
                    const c = b.clipPath;
                    [].forEach.call(f.querySelectorAll("[clip-path],[CLIP-PATH]"), function(b) {
                        -1 < b.getAttribute("clip-path").indexOf(c.element.id) && b.removeAttribute("clip-path");
                    });
                    b.clipPath = c.destroy();
                }
                if (b.stops) {
                    for(f = 0; f < b.stops.length; f++)b.stops[f].destroy();
                    b.stops.length = 0;
                    b.stops = void 0;
                }
                for(b.safeRemoveChild(c); l && l.div && 0 === l.div.childNodes.length;)c = l.parentGroup, b.safeRemoveChild(l.div), delete l.div, l = c;
                b.alignTo && I(k.alignedObjects, b);
                d(b, function(c, d) {
                    b[d] && b[d].parentGroup === b && b[d].destroy && b[d].destroy();
                    delete b[d];
                });
            }
            dSetter(b, c, d) {
                f(b) && ("string" === typeof b[0] && (b = this.renderer.pathToSegments(b)), this.pathArray = b, b = b.reduce((b, c, d)=>c && c.join ? (d ? b + " " : "") + c.join(" ") : (c || "").toString(), ""));
                /(NaN| {2}|^$)/.test(b) && (b = "M 0 0");
                this[c] !== b && (d.setAttribute(c, b), this[c] = b);
            }
            fadeOut(c) {
                const d = this;
                d.animate({
                    opacity: 0
                }, {
                    duration: b(c, 150),
                    complete: function() {
                        d.hide();
                    }
                });
            }
            fillSetter(b, c, d) {
                "string" === typeof b ? d.setAttribute(c, b) : b && this.complexColor(b, c, d);
            }
            getBBox(c, d) {
                const { alignValue: k, element: f, renderer: l, styles: F, textStr: H } = this, { cache: w, cacheKeys: r } = l;
                var v = f.namespaceURI === this.SVG_NS;
                d = b(d, this.rotation, 0);
                var g = l.styledMode ? f && z.prototype.getStyle.call(f, "font-size") : F && F.fontSize;
                let N;
                let a;
                x(H) && (a = H.toString(), -1 === a.indexOf("<") && (a = a.replace(/[0-9]/g, "0")), a += [
                    "",
                    l.rootFontSize,
                    g,
                    d,
                    this.textWidth,
                    k,
                    F && F.textOverflow,
                    F && F.fontWeight
                ].join());
                a && !c && (N = w[a]);
                if (!N) {
                    if (v || l.forExport) {
                        try {
                            var h = this.fakeTS && function(b) {
                                const c = f.querySelector(".highcharts-text-outline");
                                c && e(c, {
                                    display: b
                                });
                            };
                            y(h) && h("none");
                            N = f.getBBox ? M({}, f.getBBox()) : {
                                width: f.offsetWidth,
                                height: f.offsetHeight,
                                x: 0,
                                y: 0
                            };
                            y(h) && h("");
                        } catch (da) {
                            "";
                        }
                        if (!N || 0 > N.width) N = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        };
                    } else N = this.htmlGetBBox();
                    h = N.width;
                    c = N.height;
                    v && (N.height = c = ({
                        "11px,17": 14,
                        "13px,20": 16
                    })[`${g || ""},${Math.round(c)}`] || c);
                    if (d) {
                        v = Number(f.getAttribute("y") || 0) - N.y;
                        g = ({
                            right: 1,
                            center: .5
                        })[k || 0] || 0;
                        var n = d * B, q = (d - 90) * B, m = h * Math.cos(n);
                        d = h * Math.sin(n);
                        var p = Math.cos(q);
                        n = Math.sin(q);
                        h = N.x + g * (h - m) + v * p;
                        q = h + m;
                        p = q - c * p;
                        m = p - m;
                        v = N.y + v - g * d + v * n;
                        g = v + d;
                        c = g - c * n;
                        d = c - d;
                        N.x = Math.min(h, q, p, m);
                        N.y = Math.min(v, g, c, d);
                        N.width = Math.max(h, q, p, m) - N.x;
                        N.height = Math.max(v, g, c, d) - N.y;
                    }
                }
                if (a && ("" === H || 0 < N.height)) {
                    for(; 250 < r.length;)delete w[r.shift()];
                    w[a] || r.push(a);
                    w[a] = N;
                }
                return N;
            }
            getStyle(b) {
                return p.getComputedStyle(this.element || this, "").getPropertyValue(b);
            }
            hasClass(b) {
                return -1 !== ("" + this.attr("class")).split(" ").indexOf(b);
            }
            hide() {
                return this.attr({
                    visibility: "hidden"
                });
            }
            htmlGetBBox() {
                return {
                    height: 0,
                    width: 0,
                    x: 0,
                    y: 0
                };
            }
            init(b, c) {
                this.element = "span" === c ? g(c) : t.createElementNS(this.SVG_NS, c);
                this.renderer = b;
                C(this, "afterInit");
            }
            on(b, c) {
                const { onEvents: d } = this;
                if (d[b]) d[b]();
                d[b] = n(this.element, b, c);
                return this;
            }
            opacitySetter(b, c, d) {
                this.opacity = b = Number(Number(b).toFixed(3));
                d.setAttribute(c, b);
            }
            removeClass(b) {
                return this.attr("class", ("" + this.attr("class")).replace(l(b) ? new RegExp(`(^| )${b}( |$)`) : b, " ").replace(/ +/g, " ").trim());
            }
            removeTextOutline() {
                const b = this.element.querySelector("tspan.highcharts-text-outline");
                b && this.safeRemoveChild(b);
            }
            safeRemoveChild(b) {
                const c = b.parentNode;
                c && c.removeChild(b);
            }
            setRadialReference(b) {
                const c = this.element.gradient && this.renderer.gradients[this.element.gradient];
                this.element.radialReference = b;
                c && c.radAttr && c.animate(this.renderer.getRadialAttr(b, c.radAttr));
                return this;
            }
            setTextPath(b, c) {
                c = v(!0, {
                    enabled: !0,
                    attributes: {
                        dy: -5,
                        startOffset: "50%",
                        textAnchor: "middle"
                    }
                }, c);
                const d = this.renderer.url, k = this.text || this, f = k.textPath, { attributes: l, enabled: H } = c;
                b = b || f && f.path;
                f && f.undo();
                b && H ? (c = n(k, "afterModifyTree", (c)=>{
                    if (b && H) {
                        let H = b.attr("id");
                        H || b.attr("id", H = w());
                        var f = {
                            x: 0,
                            y: 0
                        };
                        x(l.dx) && (f.dx = l.dx, delete l.dx);
                        x(l.dy) && (f.dy = l.dy, delete l.dy);
                        k.attr(f);
                        this.attr({
                            transform: ""
                        });
                        this.box && (this.box = this.box.destroy());
                        f = c.nodes.slice(0);
                        c.nodes.length = 0;
                        c.nodes[0] = {
                            tagName: "textPath",
                            attributes: M(l, {
                                "text-anchor": l.textAnchor,
                                href: `${d}#${H}`
                            }),
                            children: f
                        };
                    }
                }), k.textPath = {
                    path: b,
                    undo: c
                }) : (k.attr({
                    dx: 0,
                    dy: 0
                }), delete k.textPath);
                this.added && (k.textCache = "", this.renderer.buildText(k));
                return this;
            }
            shadow(b) {
                var c;
                const { renderer: d } = this, k = v(90 === (null === (c = this.parentGroup) || void 0 === c ? void 0 : c.rotation) ? {
                    offsetX: -1,
                    offsetY: -1
                } : {}, r(b) ? b : {});
                c = d.shadowDefinition(k);
                return this.attr({
                    filter: b ? `url(${d.url}#${c})` : "none"
                });
            }
            show(b = !0) {
                return this.attr({
                    visibility: b ? "inherit" : "visible"
                });
            }
            ["stroke-widthSetter"](b, c, d) {
                this[c] = b;
                d.setAttribute(c, b);
            }
            strokeWidth() {
                if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                const b = this.getStyle("stroke-width");
                let d = 0, k;
                b.indexOf("px") === b.length - 2 ? d = c(b) : "" !== b && (k = t.createElementNS(m, "rect"), h(k, {
                    width: b,
                    "stroke-width": 0
                }), this.element.parentNode.appendChild(k), d = k.getBBox().width, k.parentNode.removeChild(k));
                return d;
            }
            symbolAttr(c) {
                const d = this;
                z.symbolCustomAttribs.forEach(function(k) {
                    d[k] = b(c[k], d[k]);
                });
                d.attr({
                    d: d.renderer.symbols[d.symbolName](d.x, d.y, d.width, d.height, d)
                });
            }
            textSetter(b) {
                b !== this.textStr && (delete this.textPxLength, this.textStr = b, this.added && this.renderer.buildText(this));
            }
            titleSetter(c) {
                const d = this.element, k = d.getElementsByTagName("title")[0] || t.createElementNS(this.SVG_NS, "title");
                d.insertBefore ? d.insertBefore(k, d.firstChild) : d.appendChild(k);
                k.textContent = String(b(c, "")).replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }
            toFront() {
                const b = this.element;
                b.parentNode.appendChild(b);
                return this;
            }
            translate(b, c) {
                return this.attr({
                    translateX: b,
                    translateY: c
                });
            }
            updateTransform() {
                const { element: c, matrix: d, rotation: k = 0, scaleX: f, scaleY: l, translateX: e = 0, translateY: H = 0 } = this, w = [
                    "translate(" + e + "," + H + ")"
                ];
                x(d) && w.push("matrix(" + d.join(",") + ")");
                k && w.push("rotate(" + k + " " + b(this.rotationOriginX, c.getAttribute("x"), 0) + " " + b(this.rotationOriginY, c.getAttribute("y") || 0) + ")");
                (x(f) || x(l)) && w.push("scale(" + b(f, 1) + " " + b(l, 1) + ")");
                w.length && !(this.text || this).textPath && c.setAttribute("transform", w.join(" "));
            }
            visibilitySetter(b, c, d) {
                "inherit" === b ? d.removeAttribute(c) : this[c] !== b && d.setAttribute(c, b);
                this[c] = b;
            }
            xGetter(b) {
                "circle" === this.element.nodeName && ("x" === b ? b = "cx" : "y" === b && (b = "cy"));
                return this._defaultGetter(b);
            }
            zIndexSetter(b, d) {
                var k = this.renderer, f = this.parentGroup;
                const l = (f || k).element || k.box, e = this.element;
                k = l === k.box;
                let H = !1, w;
                var r = this.added;
                let z;
                x(b) ? (e.setAttribute("data-z-index", b), b = +b, this[d] === b && (r = !1)) : x(this[d]) && e.removeAttribute("data-z-index");
                this[d] = b;
                if (r) {
                    (b = this.zIndex) && f && (f.handleZ = !0);
                    d = l.childNodes;
                    for(z = d.length - 1; 0 <= z && !H; z--)if (f = d[z], r = f.getAttribute("data-z-index"), w = !x(r), f !== e) {
                        if (0 > b && w && !k && !z) l.insertBefore(e, d[z]), H = !0;
                        else if (c(r) <= b || w && (!x(b) || 0 <= b)) l.insertBefore(e, d[z + 1]), H = !0;
                    }
                    H || (l.insertBefore(e, d[k ? 3 : 0]), H = !0);
                }
                return H;
            }
        }
        z.symbolCustomAttribs = "anchorX anchorY clockwise end height innerR r start width x y".split(" ");
        z.prototype.strokeSetter = z.prototype.fillSetter;
        z.prototype.yGetter = z.prototype.xGetter;
        z.prototype.matrixSetter = z.prototype.rotationOriginXSetter = z.prototype.rotationOriginYSetter = z.prototype.rotationSetter = z.prototype.scaleXSetter = z.prototype.scaleYSetter = z.prototype.translateXSetter = z.prototype.translateYSetter = z.prototype.verticalAlignSetter = function(b, c) {
            this[c] = b;
            this.doTransform = !0;
        };
        "";
        return z;
    });
    L(a, "Core/Renderer/RendererRegistry.js", [
        a["Core/Globals.js"]
    ], function(a) {
        var u;
        (function(u) {
            u.rendererTypes = {};
            let A;
            u.getRendererType = function(a = A) {
                return u.rendererTypes[a] || u.rendererTypes[A];
            };
            u.registerRendererType = function(G, D, E) {
                u.rendererTypes[G] = D;
                if (!A || E) A = G, a.Renderer = D;
            };
        })(u || (u = {}));
        return u;
    });
    L(a, "Core/Renderer/SVG/SVGLabel.js", [
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        const { defined: u, extend: K, isNumber: G, merge: D, pick: E, removeEvent: B } = A;
        class t extends a {
            constructor(a, m, p, n, h, g, e, x, I, M){
                super();
                this.paddingRightSetter = this.paddingLeftSetter = this.paddingSetter;
                this.init(a, "g");
                this.textStr = m;
                this.x = p;
                this.y = n;
                this.anchorX = g;
                this.anchorY = e;
                this.baseline = I;
                this.className = M;
                this.addClass("button" === M ? "highcharts-no-tooltip" : "highcharts-label");
                M && this.addClass("highcharts-" + M);
                this.text = a.text(void 0, 0, 0, x).attr({
                    zIndex: 1
                });
                let q;
                "string" === typeof h && ((q = /^url\((.*?)\)$/.test(h)) || this.renderer.symbols[h]) && (this.symbolKey = h);
                this.bBox = t.emptyBBox;
                this.padding = 3;
                this.baselineOffset = 0;
                this.needsBox = a.styledMode || q;
                this.deferredAttr = {};
                this.alignFactor = 0;
            }
            alignSetter(a) {
                a = ({
                    left: 0,
                    center: .5,
                    right: 1
                })[a];
                a !== this.alignFactor && (this.alignFactor = a, this.bBox && G(this.xSetting) && this.attr({
                    x: this.xSetting
                }));
            }
            anchorXSetter(a, m) {
                this.anchorX = a;
                this.boxAttr(m, Math.round(a) - this.getCrispAdjust() - this.xSetting);
            }
            anchorYSetter(a, m) {
                this.anchorY = a;
                this.boxAttr(m, a - this.ySetting);
            }
            boxAttr(a, m) {
                this.box ? this.box.attr(a, m) : this.deferredAttr[a] = m;
            }
            css(q) {
                if (q) {
                    const a = {};
                    q = D(q);
                    t.textProps.forEach((m)=>{
                        "undefined" !== typeof q[m] && (a[m] = q[m], delete q[m]);
                    });
                    this.text.css(a);
                    "fontSize" in a || "fontWeight" in a ? this.updateTextPadding() : ("width" in a || "textOverflow" in a) && this.updateBoxSize();
                }
                return a.prototype.css.call(this, q);
            }
            destroy() {
                B(this.element, "mouseenter");
                B(this.element, "mouseleave");
                this.text && this.text.destroy();
                this.box && (this.box = this.box.destroy());
                a.prototype.destroy.call(this);
            }
            fillSetter(a, m) {
                a && (this.needsBox = !0);
                this.fill = a;
                this.boxAttr(m, a);
            }
            getBBox() {
                this.textStr && 0 === this.bBox.width && 0 === this.bBox.height && this.updateBoxSize();
                const a = this.padding, m = E(this.paddingLeft, a);
                return {
                    width: this.width,
                    height: this.height,
                    x: this.bBox.x - m,
                    y: this.bBox.y - a
                };
            }
            getCrispAdjust() {
                return this.renderer.styledMode && this.box ? this.box.strokeWidth() % 2 / 2 : (this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            }
            heightSetter(a) {
                this.heightSetting = a;
            }
            onAdd() {
                this.text.add(this);
                this.attr({
                    text: E(this.textStr, ""),
                    x: this.x || 0,
                    y: this.y || 0
                });
                this.box && u(this.anchorX) && this.attr({
                    anchorX: this.anchorX,
                    anchorY: this.anchorY
                });
            }
            paddingSetter(a, m) {
                G(a) ? a !== this[m] && (this[m] = a, this.updateTextPadding()) : this[m] = void 0;
            }
            rSetter(a, m) {
                this.boxAttr(m, a);
            }
            strokeSetter(a, m) {
                this.stroke = a;
                this.boxAttr(m, a);
            }
            ["stroke-widthSetter"](a, m) {
                a && (this.needsBox = !0);
                this["stroke-width"] = a;
                this.boxAttr(m, a);
            }
            ["text-alignSetter"](a) {
                this.textAlign = a;
            }
            textSetter(a) {
                "undefined" !== typeof a && this.text.attr({
                    text: a
                });
                this.updateTextPadding();
            }
            updateBoxSize() {
                var a = this.text;
                const m = {}, p = this.padding, n = this.bBox = G(this.widthSetting) && G(this.heightSetting) && !this.textAlign || !u(a.textStr) ? t.emptyBBox : a.getBBox();
                this.width = this.getPaddedWidth();
                this.height = (this.heightSetting || n.height || 0) + 2 * p;
                const h = this.renderer.fontMetrics(a);
                this.baselineOffset = p + Math.min((this.text.firstLineMetrics || h).b, n.height || Infinity);
                this.heightSetting && (this.baselineOffset += (this.heightSetting - h.h) / 2);
                this.needsBox && !a.textPath && (this.box || (a = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect(), a.addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), a.add(this)), a = this.getCrispAdjust(), m.x = a, m.y = (this.baseline ? -this.baselineOffset : 0) + a, m.width = Math.round(this.width), m.height = Math.round(this.height), this.box.attr(K(m, this.deferredAttr)), this.deferredAttr = {});
            }
            updateTextPadding() {
                const a = this.text;
                if (!a.textPath) {
                    this.updateBoxSize();
                    const m = this.baseline ? 0 : this.baselineOffset;
                    let p = E(this.paddingLeft, this.padding);
                    u(this.widthSetting) && this.bBox && ("center" === this.textAlign || "right" === this.textAlign) && (p += ({
                        center: .5,
                        right: 1
                    })[this.textAlign] * (this.widthSetting - this.bBox.width));
                    if (p !== a.x || m !== a.y) a.attr("x", p), a.hasBoxWidthChanged && (this.bBox = a.getBBox(!0)), "undefined" !== typeof m && a.attr("y", m);
                    a.x = p;
                    a.y = m;
                }
            }
            widthSetter(a) {
                this.widthSetting = G(a) ? a : void 0;
            }
            getPaddedWidth() {
                var a = this.padding;
                const m = E(this.paddingLeft, a);
                a = E(this.paddingRight, a);
                return (this.widthSetting || this.bBox.width || 0) + m + a;
            }
            xSetter(a) {
                this.x = a;
                this.alignFactor && (a -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0);
                this.xSetting = Math.round(a);
                this.attr("translateX", this.xSetting);
            }
            ySetter(a) {
                this.ySetting = this.y = Math.round(a);
                this.attr("translateY", this.ySetting);
            }
        }
        t.emptyBBox = {
            width: 0,
            height: 0,
            x: 0,
            y: 0
        };
        t.textProps = "color direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow whiteSpace width".split(" ");
        return t;
    });
    L(a, "Core/Renderer/SVG/Symbols.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        function u(a, t, q, m, p) {
            const n = [];
            if (p) {
                const h = p.start || 0, g = E(p.r, q);
                q = E(p.r, m || q);
                m = (p.end || 0) - .001;
                const e = p.innerR, x = E(p.open, .001 > Math.abs((p.end || 0) - h - 2 * Math.PI)), I = Math.cos(h), M = Math.sin(h), C = Math.cos(m), f = Math.sin(m), y = E(p.longArc, .001 > m - h - Math.PI ? 0 : 1);
                let r = [
                    "A",
                    g,
                    q,
                    0,
                    y,
                    E(p.clockwise, 1),
                    a + g * C,
                    t + q * f
                ];
                r.params = {
                    start: h,
                    end: m,
                    cx: a,
                    cy: t
                };
                n.push([
                    "M",
                    a + g * I,
                    t + q * M
                ], r);
                G(e) && (r = [
                    "A",
                    e,
                    e,
                    0,
                    y,
                    G(p.clockwise) ? 1 - p.clockwise : 0,
                    a + e * I,
                    t + e * M
                ], r.params = {
                    start: m,
                    end: h,
                    cx: a,
                    cy: t
                }, n.push(x ? [
                    "M",
                    a + e * C,
                    t + e * f
                ] : [
                    "L",
                    a + e * C,
                    t + e * f
                ], r));
                x || n.push([
                    "Z"
                ]);
            }
            return n;
        }
        function J(a, t, q, m, p) {
            return p && p.r ? K(a, t, q, m, p) : [
                [
                    "M",
                    a,
                    t
                ],
                [
                    "L",
                    a + q,
                    t
                ],
                [
                    "L",
                    a + q,
                    t + m
                ],
                [
                    "L",
                    a,
                    t + m
                ],
                [
                    "Z"
                ]
            ];
        }
        function K(a, t, q, m, p) {
            p = (null === p || void 0 === p ? void 0 : p.r) || 0;
            return [
                [
                    "M",
                    a + p,
                    t
                ],
                [
                    "L",
                    a + q - p,
                    t
                ],
                [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    a + q,
                    t + p
                ],
                [
                    "L",
                    a + q,
                    t + m - p
                ],
                [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    a + q - p,
                    t + m
                ],
                [
                    "L",
                    a + p,
                    t + m
                ],
                [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    a,
                    t + m - p
                ],
                [
                    "L",
                    a,
                    t + p
                ],
                [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    a + p,
                    t
                ],
                [
                    "Z"
                ]
            ];
        }
        const { defined: G, isNumber: D, pick: E } = a;
        return {
            arc: u,
            callout: function(a, t, q, m, p) {
                const n = Math.min(p && p.r || 0, q, m), h = n + 6, g = p && p.anchorX;
                p = p && p.anchorY || 0;
                const e = K(a, t, q, m, {
                    r: n
                });
                if (!D(g)) return e;
                a + g >= q ? p > t + h && p < t + m - h ? e.splice(3, 1, [
                    "L",
                    a + q,
                    p - 6
                ], [
                    "L",
                    a + q + 6,
                    p
                ], [
                    "L",
                    a + q,
                    p + 6
                ], [
                    "L",
                    a + q,
                    t + m - n
                ]) : e.splice(3, 1, [
                    "L",
                    a + q,
                    m / 2
                ], [
                    "L",
                    g,
                    p
                ], [
                    "L",
                    a + q,
                    m / 2
                ], [
                    "L",
                    a + q,
                    t + m - n
                ]) : 0 >= a + g ? p > t + h && p < t + m - h ? e.splice(7, 1, [
                    "L",
                    a,
                    p + 6
                ], [
                    "L",
                    a - 6,
                    p
                ], [
                    "L",
                    a,
                    p - 6
                ], [
                    "L",
                    a,
                    t + n
                ]) : e.splice(7, 1, [
                    "L",
                    a,
                    m / 2
                ], [
                    "L",
                    g,
                    p
                ], [
                    "L",
                    a,
                    m / 2
                ], [
                    "L",
                    a,
                    t + n
                ]) : p && p > m && g > a + h && g < a + q - h ? e.splice(5, 1, [
                    "L",
                    g + 6,
                    t + m
                ], [
                    "L",
                    g,
                    t + m + 6
                ], [
                    "L",
                    g - 6,
                    t + m
                ], [
                    "L",
                    a + n,
                    t + m
                ]) : p && 0 > p && g > a + h && g < a + q - h && e.splice(1, 1, [
                    "L",
                    g - 6,
                    t
                ], [
                    "L",
                    g,
                    t - 6
                ], [
                    "L",
                    g + 6,
                    t
                ], [
                    "L",
                    q - n,
                    t
                ]);
                return e;
            },
            circle: function(a, t, q, m) {
                return u(a + q / 2, t + m / 2, q / 2, m / 2, {
                    start: .5 * Math.PI,
                    end: 2.5 * Math.PI,
                    open: !1
                });
            },
            diamond: function(a, t, q, m) {
                return [
                    [
                        "M",
                        a + q / 2,
                        t
                    ],
                    [
                        "L",
                        a + q,
                        t + m / 2
                    ],
                    [
                        "L",
                        a + q / 2,
                        t + m
                    ],
                    [
                        "L",
                        a,
                        t + m / 2
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            rect: J,
            roundedRect: K,
            square: J,
            triangle: function(a, t, q, m) {
                return [
                    [
                        "M",
                        a + q / 2,
                        t
                    ],
                    [
                        "L",
                        a + q,
                        t + m
                    ],
                    [
                        "L",
                        a,
                        t + m
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            "triangle-down": function(a, t, q, m) {
                return [
                    [
                        "M",
                        a,
                        t
                    ],
                    [
                        "L",
                        a + q,
                        t
                    ],
                    [
                        "L",
                        a + q / 2,
                        t + m
                    ],
                    [
                        "Z"
                    ]
                ];
            }
        };
    });
    L(a, "Core/Renderer/SVG/TextBuilder.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { doc: u, SVG_NS: G, win: D } = A, { attr: E, extend: B, fireEvent: t, isString: q, objectEach: m, pick: p } = J;
        class n {
            constructor(a){
                const g = a.styles;
                this.renderer = a.renderer;
                this.svgElement = a;
                this.width = a.textWidth;
                this.textLineHeight = g && g.lineHeight;
                this.textOutline = g && g.textOutline;
                this.ellipsis = !(!g || "ellipsis" !== g.textOverflow);
                this.noWrap = !(!g || "nowrap" !== g.whiteSpace);
            }
            buildSVG() {
                const h = this.svgElement, g = h.element;
                var e = h.renderer, x = p(h.textStr, "").toString();
                const n = -1 !== x.indexOf("<"), m = g.childNodes;
                e = !h.added && e.box;
                const C = /<br.*?>/g;
                var f = [
                    x,
                    this.ellipsis,
                    this.noWrap,
                    this.textLineHeight,
                    this.textOutline,
                    h.getStyle("font-size"),
                    this.width
                ].join();
                if (f !== h.textCache) {
                    h.textCache = f;
                    delete h.actualWidth;
                    for(f = m.length; f--;)g.removeChild(m[f]);
                    n || this.ellipsis || this.width || h.textPath || -1 !== x.indexOf(" ") && (!this.noWrap || C.test(x)) ? "" !== x && (e && e.appendChild(g), x = new a(x), this.modifyTree(x.nodes), x.addToDOM(g), this.modifyDOM(), this.ellipsis && -1 !== (g.textContent || "").indexOf("\u2026") && h.attr("title", this.unescapeEntities(h.textStr || "", [
                        "&lt;",
                        "&gt;"
                    ])), e && e.removeChild(g)) : g.appendChild(u.createTextNode(this.unescapeEntities(x)));
                    q(this.textOutline) && h.applyTextOutline && h.applyTextOutline(this.textOutline);
                }
            }
            modifyDOM() {
                const a = this.svgElement, g = E(a.element, "x");
                a.firstLineMetrics = void 0;
                let e;
                for(; e = a.element.firstChild;)if (/^[\s\u200B]*$/.test(e.textContent || " ")) a.element.removeChild(e);
                else break;
                [].forEach.call(a.element.querySelectorAll("tspan.highcharts-br"), (e, f)=>{
                    e.nextSibling && e.previousSibling && (0 === f && 1 === e.previousSibling.nodeType && (a.firstLineMetrics = a.renderer.fontMetrics(e.previousSibling)), E(e, {
                        dy: this.getLineHeight(e.nextSibling),
                        x: g
                    }));
                });
                const x = this.width || 0;
                if (x) {
                    var n = (e, f)=>{
                        var y = e.textContent || "";
                        const r = y.replace(/([^\^])-/g, "$1- ").split(" ");
                        var l = !this.noWrap && (1 < r.length || 1 < a.element.childNodes.length);
                        const v = this.getLineHeight(f);
                        let d = 0, b = a.actualWidth;
                        if (this.ellipsis) y && this.truncate(e, y, void 0, 0, Math.max(0, x - .8 * v), (b, d)=>b.substring(0, d) + "\u2026");
                        else if (l) {
                            y = [];
                            for(l = []; f.firstChild && f.firstChild !== e;)l.push(f.firstChild), f.removeChild(f.firstChild);
                            for(; r.length;)r.length && !this.noWrap && 0 < d && (y.push(e.textContent || ""), e.textContent = r.join(" ").replace(/- /g, "-")), this.truncate(e, void 0, r, 0 === d ? b || 0 : 0, x, (b, d)=>r.slice(0, d).join(" ").replace(/- /g, "-")), b = a.actualWidth, d++;
                            l.forEach((b)=>{
                                f.insertBefore(b, e);
                            });
                            y.forEach((b)=>{
                                f.insertBefore(u.createTextNode(b), e);
                                b = u.createElementNS(G, "tspan");
                                b.textContent = "\u200B";
                                E(b, {
                                    dy: v,
                                    x: g
                                });
                                f.insertBefore(b, e);
                            });
                        }
                    }, m = (e)=>{
                        [].slice.call(e.childNodes).forEach((f)=>{
                            f.nodeType === D.Node.TEXT_NODE ? n(f, e) : (-1 !== f.className.baseVal.indexOf("highcharts-br") && (a.actualWidth = 0), m(f));
                        });
                    };
                    m(a.element);
                }
            }
            getLineHeight(a) {
                a = a.nodeType === D.Node.TEXT_NODE ? a.parentElement : a;
                return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(a || this.svgElement.element).h;
            }
            modifyTree(a) {
                const g = (e, h)=>{
                    const { attributes: x = {}, children: n, style: m = {}, tagName: f } = e, y = this.renderer.styledMode;
                    if ("b" === f || "strong" === f) y ? x["class"] = "highcharts-strong" : m.fontWeight = "bold";
                    else if ("i" === f || "em" === f) y ? x["class"] = "highcharts-emphasized" : m.fontStyle = "italic";
                    m && m.color && (m.fill = m.color);
                    "br" === f ? (x["class"] = "highcharts-br", e.textContent = "\u200B", (h = a[h + 1]) && h.textContent && (h.textContent = h.textContent.replace(/^ +/gm, ""))) : "a" === f && n && n.some((f)=>"#text" === f.tagName) && (e.children = [
                        {
                            children: n,
                            tagName: "tspan"
                        }
                    ]);
                    "#text" !== f && "a" !== f && (e.tagName = "tspan");
                    B(e, {
                        attributes: x,
                        style: m
                    });
                    n && n.filter((f)=>"#text" !== f.tagName).forEach(g);
                };
                a.forEach(g);
                t(this.svgElement, "afterModifyTree", {
                    nodes: a
                });
            }
            truncate(a, g, e, x, n, m) {
                const h = this.svgElement, { rotation: f } = h, y = [];
                let r = e ? 1 : 0, l = (g || e || "").length, v = l, d, b;
                const c = function(b, c) {
                    b = c || b;
                    if ((c = a.parentNode) && "undefined" === typeof y[b] && c.getSubStringLength) try {
                        y[b] = x + c.getSubStringLength(0, e ? b + 1 : b);
                    } catch (z) {
                        "";
                    }
                    return y[b];
                };
                h.rotation = 0;
                b = c(a.textContent.length);
                if (x + b > n) {
                    for(; r <= l;)v = Math.ceil((r + l) / 2), e && (d = m(e, v)), b = c(v, d && d.length - 1), r === l ? r = l + 1 : b > n ? l = v - 1 : r = v;
                    0 === l ? a.textContent = "" : g && l === g.length - 1 || (a.textContent = d || m(g || e, v));
                }
                e && e.splice(0, v);
                h.actualWidth = b;
                h.rotation = f;
            }
            unescapeEntities(a, g) {
                m(this.renderer.escapes, function(e, h) {
                    g && -1 !== g.indexOf(e) || (a = a.toString().replace(new RegExp(e, "g"), h));
                });
                return a;
            }
        }
        return n;
    });
    L(a, "Core/Renderer/SVG/SVGRenderer.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGLabel.js"],
        a["Core/Renderer/SVG/Symbols.js"],
        a["Core/Renderer/SVG/TextBuilder.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E, B, t) {
        const { charts: q, deg2rad: m, doc: p, isFirefox: n, isMS: h, isWebKit: g, noop: e, SVG_NS: x, symbolSizes: I, win: M } = J, { addEvent: C, attr: f, createElement: y, css: r, defined: l, destroyObjectProperties: v, extend: d, isArray: b, isNumber: c, isObject: k, isString: w, merge: z, pick: F, pInt: O, uniqueKey: P } = t;
        let T;
        class u {
            constructor(b, c, d, k, f, a, l){
                this.width = this.url = this.style = this.imgCount = this.height = this.gradients = this.globalAnimation = this.defs = this.chartIndex = this.cacheKeys = this.cache = this.boxWrapper = this.box = this.alignedObjects = void 0;
                this.init(b, c, d, k, f, a, l);
            }
            init(b, c, d, k, a, l, e) {
                const H = this.createElement("svg").attr({
                    version: "1.1",
                    "class": "highcharts-root"
                }), w = H.element;
                e || H.css(this.getStyle(k));
                b.appendChild(w);
                f(b, "dir", "ltr");
                -1 === b.innerHTML.indexOf("xmlns") && f(w, "xmlns", this.SVG_NS);
                this.box = w;
                this.boxWrapper = H;
                this.alignedObjects = [];
                this.url = this.getReferenceURL();
                this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 11.1.0"));
                this.defs = this.createElement("defs").add();
                this.allowHTML = l;
                this.forExport = a;
                this.styledMode = e;
                this.gradients = {};
                this.cache = {};
                this.cacheKeys = [];
                this.imgCount = 0;
                this.rootFontSize = H.getStyle("font-size");
                this.setSize(c, d, !1);
                let z;
                n && b.getBoundingClientRect && (c = function() {
                    r(b, {
                        left: 0,
                        top: 0
                    });
                    z = b.getBoundingClientRect();
                    r(b, {
                        left: Math.ceil(z.left) - z.left + "px",
                        top: Math.ceil(z.top) - z.top + "px"
                    });
                }, c(), this.unSubPixelFix = C(M, "resize", c));
            }
            definition(b) {
                return new a([
                    b
                ]).addToDOM(this.defs.element);
            }
            getReferenceURL() {
                if ((n || g) && p.getElementsByTagName("base").length) {
                    if (!l(T)) {
                        var b = P();
                        b = new a([
                            {
                                tagName: "svg",
                                attributes: {
                                    width: 8,
                                    height: 8
                                },
                                children: [
                                    {
                                        tagName: "defs",
                                        children: [
                                            {
                                                tagName: "clipPath",
                                                attributes: {
                                                    id: b
                                                },
                                                children: [
                                                    {
                                                        tagName: "rect",
                                                        attributes: {
                                                            width: 4,
                                                            height: 4
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        tagName: "rect",
                                        attributes: {
                                            id: "hitme",
                                            width: 8,
                                            height: 8,
                                            "clip-path": `url(#${b})`,
                                            fill: "rgba(0,0,0,0.001)"
                                        }
                                    }
                                ]
                            }
                        ]).addToDOM(p.body);
                        r(b, {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            zIndex: 9E5
                        });
                        const c = p.elementFromPoint(6, 6);
                        T = "hitme" === (c && c.id);
                        p.body.removeChild(b);
                    }
                    if (T) return M.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20");
                }
                return "";
            }
            getStyle(b) {
                return this.style = d({
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontSize: "1rem"
                }, b);
            }
            setStyle(b) {
                this.boxWrapper.css(this.getStyle(b));
            }
            isHidden() {
                return !this.boxWrapper.getBBox().width;
            }
            destroy() {
                const b = this.defs;
                this.box = null;
                this.boxWrapper = this.boxWrapper.destroy();
                v(this.gradients || {});
                this.gradients = null;
                this.defs = b.destroy();
                this.unSubPixelFix && this.unSubPixelFix();
                return this.alignedObjects = null;
            }
            createElement(b) {
                const c = new this.Element;
                c.init(this, b);
                return c;
            }
            getRadialAttr(b, c) {
                return {
                    cx: b[0] - b[2] / 2 + (c.cx || 0) * b[2],
                    cy: b[1] - b[2] / 2 + (c.cy || 0) * b[2],
                    r: (c.r || 0) * b[2]
                };
            }
            shadowDefinition(b) {
                const c = [
                    `highcharts-drop-shadow-${this.chartIndex}`,
                    ...Object.keys(b).map((c)=>b[c])
                ].join("-").replace(/[^a-z0-9\-]/g, ""), d = z({
                    color: "#000000",
                    offsetX: 1,
                    offsetY: 1,
                    opacity: .15,
                    width: 5
                }, b);
                this.defs.element.querySelector(`#${c}`) || this.definition({
                    tagName: "filter",
                    attributes: {
                        id: c
                    },
                    children: [
                        {
                            tagName: "feDropShadow",
                            attributes: {
                                dx: d.offsetX,
                                dy: d.offsetY,
                                "flood-color": d.color,
                                "flood-opacity": Math.min(5 * d.opacity, 1),
                                stdDeviation: d.width / 2
                            }
                        }
                    ]
                });
                return c;
            }
            buildText(b) {
                new B(b).buildSVG();
            }
            getContrast(b) {
                b = A.parse(b).rgba.map((b)=>{
                    b /= 255;
                    return .03928 >= b ? b / 12.92 : Math.pow((b + .055) / 1.055, 2.4);
                });
                b = .2126 * b[0] + .7152 * b[1] + .0722 * b[2];
                return 1.05 / (b + .05) > (b + .05) / .05 ? "#FFFFFF" : "#000000";
            }
            button(b, c, f, l, e = {}, w, r, v, y, g) {
                const H = this.label(b, c, f, y, void 0, void 0, g, void 0, "button"), N = this.styledMode;
                b = e.states || {};
                let F = 0;
                e = z(e);
                delete e.states;
                const x = z({
                    color: "#333333",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    fontWeight: "normal"
                }, e.style);
                delete e.style;
                let n = a.filterUserAttributes(e);
                H.attr(z({
                    padding: 8,
                    r: 2
                }, n));
                let m, p, Q;
                N || (n = z({
                    fill: "#f7f7f7",
                    stroke: "#cccccc",
                    "stroke-width": 1
                }, n), w = z(n, {
                    fill: "#e6e6e6"
                }, a.filterUserAttributes(w || b.hover || {})), m = w.style, delete w.style, r = z(n, {
                    fill: "#e6e9ff",
                    style: {
                        color: "#000000",
                        fontWeight: "bold"
                    }
                }, a.filterUserAttributes(r || b.select || {})), p = r.style, delete r.style, v = z(n, {
                    style: {
                        color: "#cccccc"
                    }
                }, a.filterUserAttributes(v || b.disabled || {})), Q = v.style, delete v.style);
                C(H.element, h ? "mouseover" : "mouseenter", function() {
                    3 !== F && H.setState(1);
                });
                C(H.element, h ? "mouseout" : "mouseleave", function() {
                    3 !== F && H.setState(F);
                });
                H.setState = function(b) {
                    1 !== b && (H.state = F = b);
                    H.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                        "normal",
                        "hover",
                        "pressed",
                        "disabled"
                    ][b || 0]);
                    N || (H.attr([
                        n,
                        w,
                        r,
                        v
                    ][b || 0]), b = [
                        x,
                        m,
                        p,
                        Q
                    ][b || 0], k(b) && H.css(b));
                };
                N || (H.attr(n).css(d({
                    cursor: "default"
                }, x)), g && H.text.css({
                    pointerEvents: "none"
                }));
                return H.on("touchstart", (b)=>b.stopPropagation()).on("click", function(b) {
                    3 !== F && l.call(H, b);
                });
            }
            crispLine(b, c, d = "round") {
                const k = b[0], f = b[1];
                l(k[1]) && k[1] === f[1] && (k[1] = f[1] = Math[d](k[1]) - c % 2 / 2);
                l(k[2]) && k[2] === f[2] && (k[2] = f[2] = Math[d](k[2]) + c % 2 / 2);
                return b;
            }
            path(c) {
                const f = this.styledMode ? {} : {
                    fill: "none"
                };
                b(c) ? f.d = c : k(c) && d(f, c);
                return this.createElement("path").attr(f);
            }
            circle(b, c, d) {
                b = k(b) ? b : "undefined" === typeof b ? {} : {
                    x: b,
                    y: c,
                    r: d
                };
                c = this.createElement("circle");
                c.xSetter = c.ySetter = function(b, c, d) {
                    d.setAttribute("c" + c, b);
                };
                return c.attr(b);
            }
            arc(b, c, d, f, a, l) {
                k(b) ? (f = b, c = f.y, d = f.r, b = f.x) : f = {
                    innerR: f,
                    start: a,
                    end: l
                };
                b = this.symbol("arc", b, c, d, d, f);
                b.r = d;
                return b;
            }
            rect(b, c, a, l, e, w) {
                b = k(b) ? b : "undefined" === typeof b ? {} : {
                    x: b,
                    y: c,
                    r: e,
                    width: Math.max(a || 0, 0),
                    height: Math.max(l || 0, 0)
                };
                const H = this.createElement("rect");
                this.styledMode || ("undefined" !== typeof w && (b["stroke-width"] = w, d(b, H.crisp(b))), b.fill = "none");
                H.rSetter = function(b, c, d) {
                    H.r = b;
                    f(d, {
                        rx: b,
                        ry: b
                    });
                };
                H.rGetter = function() {
                    return H.r || 0;
                };
                return H.attr(b);
            }
            roundedRect(b) {
                return this.symbol("roundedRect").attr(b);
            }
            setSize(b, c, d) {
                this.width = b;
                this.height = c;
                this.boxWrapper.animate({
                    width: b,
                    height: c
                }, {
                    step: function() {
                        this.attr({
                            viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                        });
                    },
                    duration: F(d, !0) ? void 0 : 0
                });
                this.alignElements();
            }
            g(b) {
                const c = this.createElement("g");
                return b ? c.attr({
                    "class": "highcharts-" + b
                }) : c;
            }
            image(b, d, k, f, a, l) {
                const H = {
                    preserveAspectRatio: "none"
                };
                c(d) && (H.x = d);
                c(k) && (H.y = k);
                c(f) && (H.width = f);
                c(a) && (H.height = a);
                const e = this.createElement("image").attr(H);
                d = function(c) {
                    e.attr({
                        href: b
                    });
                    l.call(e, c);
                };
                l ? (e.attr({
                    href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                }), k = new M.Image, C(k, "load", d), k.src = b, k.complete && d({})) : e.attr({
                    href: b
                });
                return e;
            }
            symbol(b, c, k, a, e, w) {
                const H = this, z = /^url\((.*?)\)$/, v = z.test(b), g = !v && (this.symbols[b] ? b : "circle"), h = g && this.symbols[g];
                let x, n, m, Y;
                if (h) "number" === typeof c && (n = h.call(this.symbols, Math.round(c || 0), Math.round(k || 0), a || 0, e || 0, w)), x = this.path(n), H.styledMode || x.attr("fill", "none"), d(x, {
                    symbolName: g || void 0,
                    x: c,
                    y: k,
                    width: a,
                    height: e
                }), w && d(x, w);
                else if (v) {
                    m = b.match(z)[1];
                    const d = x = this.image(m);
                    d.imgwidth = F(w && w.width, I[m] && I[m].width);
                    d.imgheight = F(w && w.height, I[m] && I[m].height);
                    Y = (b)=>b.attr({
                            width: b.width,
                            height: b.height
                        });
                    [
                        "width",
                        "height"
                    ].forEach(function(b) {
                        d[b + "Setter"] = function(b, c) {
                            this[c] = b;
                            const { alignByTranslate: d, element: k, width: a, height: H, imgwidth: e, imgheight: r } = this;
                            b = this["img" + c];
                            if (l(b)) {
                                let l = 1;
                                w && "within" === w.backgroundSize && a && H ? (l = Math.min(a / e, H / r), f(k, {
                                    width: Math.round(e * l),
                                    height: Math.round(r * l)
                                })) : k && k.setAttribute(c, b);
                                d || this.translate(((a || 0) - e * l) / 2, ((H || 0) - r * l) / 2);
                            }
                        };
                    });
                    l(c) && d.attr({
                        x: c,
                        y: k
                    });
                    d.isImg = !0;
                    l(d.imgwidth) && l(d.imgheight) ? Y(d) : (d.attr({
                        width: 0,
                        height: 0
                    }), y("img", {
                        onload: function() {
                            const b = q[H.chartIndex];
                            0 === this.width && (r(this, {
                                position: "absolute",
                                top: "-999em"
                            }), p.body.appendChild(this));
                            I[m] = {
                                width: this.width,
                                height: this.height
                            };
                            d.imgwidth = this.width;
                            d.imgheight = this.height;
                            d.element && Y(d);
                            this.parentNode && this.parentNode.removeChild(this);
                            H.imgCount--;
                            if (!H.imgCount && b && !b.hasLoaded) b.onload();
                        },
                        src: m
                    }), this.imgCount++);
                }
                return x;
            }
            clipRect(b, c, d, k) {
                const f = P() + "-", a = this.createElement("clipPath").attr({
                    id: f
                }).add(this.defs);
                b = this.rect(b, c, d, k, 0).add(a);
                b.id = f;
                b.clipPath = a;
                b.count = 0;
                return b;
            }
            text(b, c, d, k) {
                const f = {};
                if (k && (this.allowHTML || !this.forExport)) return this.html(b, c, d);
                f.x = Math.round(c || 0);
                d && (f.y = Math.round(d));
                l(b) && (f.text = b);
                b = this.createElement("text").attr(f);
                if (!k || this.forExport && !this.allowHTML) b.xSetter = function(b, c, d) {
                    const k = d.getElementsByTagName("tspan"), f = d.getAttribute(c);
                    for(let d = 0, a; d < k.length; d++)a = k[d], a.getAttribute(c) === f && a.setAttribute(c, b);
                    d.setAttribute(c, b);
                };
                return b;
            }
            fontMetrics(b) {
                b = O(G.prototype.getStyle.call(b, "font-size") || 0);
                const c = 24 > b ? b + 3 : Math.round(1.2 * b);
                return {
                    h: c,
                    b: Math.round(.8 * c),
                    f: b
                };
            }
            rotCorr(b, c, d) {
                let k = b;
                c && d && (k = Math.max(k * Math.cos(c * m), 4));
                return {
                    x: -b / 3 * Math.sin(c * m),
                    y: k
                };
            }
            pathToSegments(b) {
                const d = [], k = [], f = {
                    A: 8,
                    C: 7,
                    H: 2,
                    L: 3,
                    M: 3,
                    Q: 5,
                    S: 5,
                    T: 3,
                    V: 2
                };
                for(let a = 0; a < b.length; a++)w(k[0]) && c(b[a]) && k.length === f[k[0].toUpperCase()] && b.splice(a, 0, k[0].replace("M", "L").replace("m", "l")), "string" === typeof b[a] && (k.length && d.push(k.slice(0)), k.length = 0), k.push(b[a]);
                d.push(k.slice(0));
                return d;
            }
            label(b, c, d, k, f, a, l, e, w) {
                return new D(this, b, c, d, k, f, a, l, e, w);
            }
            alignElements() {
                this.alignedObjects.forEach((b)=>b.align());
            }
        }
        d(u.prototype, {
            Element: G,
            SVG_NS: x,
            escapes: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                "'": "&#39;",
                '"': "&quot;"
            },
            symbols: E,
            draw: e
        });
        K.registerRendererType("svg", u, !0);
        "";
        return u;
    });
    L(a, "Core/Renderer/HTML/HTMLElement.js", [
        a["Core/Globals.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { isFirefox: u, isMS: G, isWebKit: D, win: E } = a, { css: B, defined: t, extend: q, pick: m, pInt: p } = J, n = [];
        class h extends A {
            static compose(a) {
                if (J.pushUnique(n, a)) {
                    const e = h.prototype, g = a.prototype;
                    g.getSpanCorrection = e.getSpanCorrection;
                    g.htmlCss = e.htmlCss;
                    g.htmlGetBBox = e.htmlGetBBox;
                    g.htmlUpdateTransform = e.htmlUpdateTransform;
                    g.setSpanRotation = e.setSpanRotation;
                }
                return a;
            }
            getSpanCorrection(a, e, h) {
                this.xCorr = -a * h;
                this.yCorr = -e;
            }
            htmlCss(a) {
                const e = "SPAN" === this.element.tagName && a && "width" in a, g = m(e && a.width, void 0);
                let h;
                e && (delete a.width, this.textWidth = g, h = !0);
                a && "ellipsis" === a.textOverflow && (a.whiteSpace = "nowrap", a.overflow = "hidden");
                this.styles = q(this.styles, a);
                B(this.element, a);
                h && this.htmlUpdateTransform();
                return this;
            }
            htmlGetBBox() {
                const a = this.element;
                return {
                    x: a.offsetLeft,
                    y: a.offsetTop,
                    width: a.offsetWidth,
                    height: a.offsetHeight
                };
            }
            htmlUpdateTransform() {
                if (this.added) {
                    var a = this.renderer, e = this.element, h = this.x || 0, n = this.y || 0, m = this.textAlign || "left", q = {
                        left: 0,
                        center: .5,
                        right: 1
                    }[m], f = this.styles, y = f && f.whiteSpace;
                    B(e, {
                        marginLeft: this.translateX || 0,
                        marginTop: this.translateY || 0
                    });
                    if ("SPAN" === e.tagName) {
                        f = this.rotation;
                        const l = this.textWidth && p(this.textWidth), v = [
                            f,
                            m,
                            e.innerHTML,
                            this.textWidth,
                            this.textAlign
                        ].join();
                        let d = !1;
                        if (l !== this.oldTextWidth) {
                            if (this.textPxLength) var r = this.textPxLength;
                            else B(e, {
                                width: "",
                                whiteSpace: y || "nowrap"
                            }), r = e.offsetWidth;
                            (l > this.oldTextWidth || r > l) && (/[ \-]/.test(e.textContent || e.innerText) || "ellipsis" === e.style.textOverflow) && (B(e, {
                                width: r > l || f ? l + "px" : "auto",
                                display: "block",
                                whiteSpace: y || "normal"
                            }), this.oldTextWidth = l, d = !0);
                        }
                        this.hasBoxWidthChanged = d;
                        v !== this.cTT && (a = a.fontMetrics(e).b, !t(f) || f === (this.oldRotation || 0) && m === this.oldAlign || this.setSpanRotation(f, q, a), this.getSpanCorrection(!t(f) && this.textPxLength || e.offsetWidth, a, q, f, m));
                        B(e, {
                            left: h + (this.xCorr || 0) + "px",
                            top: n + (this.yCorr || 0) + "px"
                        });
                        this.cTT = v;
                        this.oldRotation = f;
                        this.oldAlign = m;
                    }
                } else this.alignOnAdd = !0;
            }
            setSpanRotation(a, e, h) {
                const g = {}, x = G && !/Edge/.test(E.navigator.userAgent) ? "-ms-transform" : D ? "-webkit-transform" : u ? "MozTransform" : E.opera ? "-o-transform" : void 0;
                x && (g[x] = g.transform = "rotate(" + a + "deg)", g[x + (u ? "Origin" : "-origin")] = g.transformOrigin = 100 * e + "% " + h + "px", B(this.element, g));
            }
        }
        return h;
    });
    L(a, "Core/Renderer/HTML/HTMLRenderer.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K) {
        const { attr: u, createElement: D, extend: E, pick: B } = K, t = [];
        class q extends J {
            static compose(a) {
                K.pushUnique(t, a) && (a.prototype.html = q.prototype.html);
                return a;
            }
            html(m, p, n) {
                const h = this.createElement("span"), g = h.element, e = h.renderer, x = function(a, e) {
                    [
                        "opacity",
                        "visibility"
                    ].forEach(function(g) {
                        a[g + "Setter"] = function(f, y, r) {
                            const l = a.div ? a.div.style : e;
                            A.prototype[g + "Setter"].call(this, f, y, r);
                            l && (l[y] = f);
                        };
                    });
                    a.addedSetters = !0;
                };
                h.textSetter = function(e) {
                    e !== this.textStr && (delete this.bBox, delete this.oldTextWidth, a.setElementHTML(this.element, B(e, "")), this.textStr = e, h.doTransform = !0);
                };
                x(h, h.element.style);
                h.xSetter = h.ySetter = h.alignSetter = h.rotationSetter = function(a, e) {
                    "align" === e ? h.alignValue = h.textAlign = a : h[e] = a;
                    h.doTransform = !0;
                };
                h.afterSetters = function() {
                    this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
                };
                h.attr({
                    text: m,
                    x: Math.round(p),
                    y: Math.round(n)
                }).css({
                    position: "absolute"
                });
                e.styledMode || h.css({
                    fontFamily: this.style.fontFamily,
                    fontSize: this.style.fontSize
                });
                g.style.whiteSpace = "nowrap";
                h.css = h.htmlCss;
                h.add = function(a) {
                    const n = e.box.parentNode, m = [];
                    let f;
                    if (this.parentGroup = a) {
                        if (f = a.div, !f) {
                            for(; a;)m.push(a), a = a.parentGroup;
                            m.reverse().forEach(function(a) {
                                function e(b, c) {
                                    a[c] = b;
                                    "translateX" === c ? d.left = b + "px" : d.top = b + "px";
                                    a.doTransform = !0;
                                }
                                const l = u(a.element, "class"), v = a.styles || {};
                                f = a.div = a.div || D("div", l ? {
                                    className: l
                                } : void 0, {
                                    position: "absolute",
                                    left: (a.translateX || 0) + "px",
                                    top: (a.translateY || 0) + "px",
                                    display: a.display,
                                    opacity: a.opacity,
                                    visibility: a.visibility
                                }, f || n);
                                const d = f.style;
                                E(a, {
                                    classSetter: function(b) {
                                        return function(c) {
                                            this.element.setAttribute("class", c);
                                            b.className = c;
                                        };
                                    }(f),
                                    css: function(b) {
                                        h.css.call(a, b);
                                        [
                                            "cursor",
                                            "pointerEvents"
                                        ].forEach((c)=>{
                                            b[c] && (d[c] = b[c]);
                                        });
                                        return a;
                                    },
                                    on: function() {
                                        m[0].div && h.on.apply({
                                            element: m[0].div,
                                            onEvents: a.onEvents
                                        }, arguments);
                                        return a;
                                    },
                                    translateXSetter: e,
                                    translateYSetter: e
                                });
                                a.addedSetters || x(a);
                                a.css(v);
                            });
                        }
                    } else f = n;
                    f.appendChild(g);
                    h.added = !0;
                    h.alignOnAdd && h.htmlUpdateTransform();
                    return h;
                };
                return h;
            }
        }
        return q;
    });
    L(a, "Core/Axis/AxisDefaults.js", [], function() {
        var a;
        (function(a) {
            a.defaultXAxisOptions = {
                alignTicks: !0,
                allowDecimals: void 0,
                panningEnabled: !0,
                zIndex: 2,
                zoomEnabled: !0,
                dateTimeLabelFormats: {
                    millisecond: {
                        main: "%H:%M:%S.%L",
                        range: !1
                    },
                    second: {
                        main: "%H:%M:%S",
                        range: !1
                    },
                    minute: {
                        main: "%H:%M",
                        range: !1
                    },
                    hour: {
                        main: "%H:%M",
                        range: !1
                    },
                    day: {
                        main: "%e %b"
                    },
                    week: {
                        main: "%e %b"
                    },
                    month: {
                        main: "%b '%y"
                    },
                    year: {
                        main: "%Y"
                    }
                },
                endOnTick: !1,
                gridLineDashStyle: "Solid",
                gridZIndex: 1,
                labels: {
                    autoRotation: void 0,
                    autoRotationLimit: 80,
                    distance: 15,
                    enabled: !0,
                    indentation: 10,
                    overflow: "justify",
                    padding: 5,
                    reserveSpace: void 0,
                    rotation: void 0,
                    staggerLines: 0,
                    step: 0,
                    useHTML: !1,
                    zIndex: 7,
                    style: {
                        color: "#333333",
                        cursor: "default",
                        fontSize: "0.8em"
                    }
                },
                maxPadding: .01,
                minorGridLineDashStyle: "Solid",
                minorTickLength: 2,
                minorTickPosition: "outside",
                minorTicksPerMajor: 5,
                minPadding: .01,
                offset: void 0,
                opposite: !1,
                reversed: void 0,
                reversedStacks: !1,
                showEmpty: !0,
                showFirstLabel: !0,
                showLastLabel: !0,
                startOfWeek: 1,
                startOnTick: !1,
                tickLength: 10,
                tickPixelInterval: 100,
                tickmarkPlacement: "between",
                tickPosition: "outside",
                title: {
                    align: "middle",
                    rotation: 0,
                    useHTML: !1,
                    x: 0,
                    y: 0,
                    style: {
                        color: "#666666",
                        fontSize: "0.8em"
                    }
                },
                type: "linear",
                uniqueNames: !0,
                visible: !0,
                minorGridLineColor: "#f2f2f2",
                minorGridLineWidth: 1,
                minorTickColor: "#999999",
                lineColor: "#333333",
                lineWidth: 1,
                gridLineColor: "#e6e6e6",
                gridLineWidth: void 0,
                tickColor: "#333333"
            };
            a.defaultYAxisOptions = {
                reversedStacks: !0,
                endOnTick: !0,
                maxPadding: .05,
                minPadding: .05,
                tickPixelInterval: 72,
                showLastLabel: !0,
                labels: {
                    x: void 0
                },
                startOnTick: !0,
                title: {
                    rotation: 270,
                    text: "Values"
                },
                stackLabels: {
                    animation: {},
                    allowOverlap: !1,
                    enabled: !1,
                    crop: !0,
                    overflow: "justify",
                    formatter: function() {
                        const { numberFormatter: a } = this.axis.chart;
                        return a(this.total || 0, -1);
                    },
                    style: {
                        color: "#000000",
                        fontSize: "0.7em",
                        fontWeight: "bold",
                        textOutline: "1px contrast"
                    }
                },
                gridLineWidth: 1,
                lineWidth: 0
            };
            a.defaultLeftAxisOptions = {
                title: {
                    rotation: 270
                }
            };
            a.defaultRightAxisOptions = {
                title: {
                    rotation: 90
                }
            };
            a.defaultBottomAxisOptions = {
                labels: {
                    autoRotation: [
                        -45
                    ]
                },
                margin: 15,
                title: {
                    rotation: 0
                }
            };
            a.defaultTopAxisOptions = {
                labels: {
                    autoRotation: [
                        -45
                    ]
                },
                margin: 15,
                title: {
                    rotation: 0
                }
            };
        })(a || (a = {}));
        return a;
    });
    L(a, "Core/Foundation.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { addEvent: u, isFunction: J, objectEach: K, removeEvent: G } = a;
        var D;
        (function(a) {
            a.registerEventOptions = function(a, t) {
                a.eventOptions = a.eventOptions || {};
                K(t.events, function(q, m) {
                    a.eventOptions[m] !== q && (a.eventOptions[m] && (G(a, m, a.eventOptions[m]), delete a.eventOptions[m]), J(q) && (a.eventOptions[m] = q, u(a, m, q, {
                        order: 0
                    })));
                });
            };
        })(D || (D = {}));
        return D;
    });
    L(a, "Core/Axis/Tick.js", [
        a["Core/Templating.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { deg2rad: u } = A, { clamp: G, correctFloat: D, defined: E, destroyObjectProperties: B, extend: t, fireEvent: q, isNumber: m, merge: p, objectEach: n, pick: h } = J;
        class g {
            constructor(a, g, h, n, m){
                this.isNewLabel = this.isNew = !0;
                this.axis = a;
                this.pos = g;
                this.type = h || "";
                this.parameters = m || {};
                this.tickmarkOffset = this.parameters.tickmarkOffset;
                this.options = this.parameters.options;
                q(this, "init");
                h || n || this.addLabel();
            }
            addLabel() {
                const e = this, g = e.axis;
                var n = g.options;
                const p = g.chart;
                var C = g.categories;
                const f = g.logarithmic, y = g.names, r = e.pos, l = h(e.options && e.options.labels, n.labels);
                var v = g.tickPositions;
                const d = r === v[0], b = r === v[v.length - 1], c = (!l.step || 1 === l.step) && 1 === g.tickInterval;
                v = v.info;
                let k = e.label, w, z, F;
                C = this.parameters.category || (C ? h(C[r], y[r], r) : r);
                f && m(C) && (C = D(f.lin2log(C)));
                g.dateTime && (v ? (z = p.time.resolveDTLFormat(n.dateTimeLabelFormats[!n.grid && v.higherRanks[r] || v.unitName]), w = z.main) : m(C) && (w = g.dateTime.getXDateFormat(C, n.dateTimeLabelFormats || {})));
                e.isFirst = d;
                e.isLast = b;
                const O = {
                    axis: g,
                    chart: p,
                    dateTimeLabelFormat: w,
                    isFirst: d,
                    isLast: b,
                    pos: r,
                    tick: e,
                    tickPositionInfo: v,
                    value: C
                };
                q(this, "labelFormat", O);
                const P = (b)=>l.formatter ? l.formatter.call(b, b) : l.format ? (b.text = g.defaultLabelFormatter.call(b, b), a.format(l.format, b, p)) : g.defaultLabelFormatter.call(b, b);
                n = P.call(O, O);
                const T = z && z.list;
                e.shortenLabel = T ? function() {
                    for(F = 0; F < T.length; F++)if (t(O, {
                        dateTimeLabelFormat: T[F]
                    }), k.attr({
                        text: P.call(O, O)
                    }), k.getBBox().width < g.getSlotWidth(e) - 2 * l.padding) return;
                    k.attr({
                        text: ""
                    });
                } : void 0;
                c && g._addedPlotLB && e.moveLabel(n, l);
                E(k) || e.movedLabel ? k && k.textStr !== n && !c && (!k.textWidth || l.style.width || k.styles.width || k.css({
                    width: null
                }), k.attr({
                    text: n
                }), k.textPxLength = k.getBBox().width) : (e.label = k = e.createLabel({
                    x: 0,
                    y: 0
                }, n, l), e.rotation = 0);
            }
            createLabel(a, g, h) {
                const e = this.axis, n = e.chart;
                if (a = E(g) && h.enabled ? n.renderer.text(g, a.x, a.y, h.useHTML).add(e.labelGroup) : null) n.styledMode || a.css(p(h.style)), a.textPxLength = a.getBBox().width;
                return a;
            }
            destroy() {
                B(this, this.axis);
            }
            getPosition(a, g, h, n) {
                const e = this.axis, f = e.chart, y = n && f.oldChartHeight || f.chartHeight;
                a = {
                    x: a ? D(e.translate(g + h, void 0, void 0, n) + e.transB) : e.left + e.offset + (e.opposite ? (n && f.oldChartWidth || f.chartWidth) - e.right - e.left : 0),
                    y: a ? y - e.bottom + e.offset - (e.opposite ? e.height : 0) : D(y - e.translate(g + h, void 0, void 0, n) - e.transB)
                };
                a.y = G(a.y, -100000, 1E5);
                q(this, "afterGetPosition", {
                    pos: a
                });
                return a;
            }
            getLabelPosition(a, g, n, m, p, f, y, r) {
                const l = this.axis, e = l.transA, d = l.isLinked && l.linkedParent ? l.linkedParent.reversed : l.reversed, b = l.staggerLines, c = l.tickRotCorr || {
                    x: 0,
                    y: 0
                }, k = m || l.reserveSpaceDefault ? 0 : -l.labelOffset * ("center" === l.labelAlign ? .5 : 1), w = p.distance, z = {};
                n = 0 === l.side ? n.rotation ? -w : -n.getBBox().height : 2 === l.side ? c.y + w : Math.cos(n.rotation * u) * (c.y - n.getBBox(!1, 0).height / 2);
                E(p.y) && (n = 0 === l.side && l.horiz ? p.y + n : p.y);
                a = a + h(p.x, [
                    0,
                    1,
                    0,
                    -1
                ][l.side] * w) + k + c.x - (f && m ? f * e * (d ? -1 : 1) : 0);
                g = g + n - (f && !m ? f * e * (d ? 1 : -1) : 0);
                b && (m = y / (r || 1) % b, l.opposite && (m = b - m - 1), g += l.labelOffset / b * m);
                z.x = a;
                z.y = Math.round(g);
                q(this, "afterGetLabelPosition", {
                    pos: z,
                    tickmarkOffset: f,
                    index: y
                });
                return z;
            }
            getLabelSize() {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            }
            getMarkPath(a, g, h, n, m, f) {
                return f.crispLine([
                    [
                        "M",
                        a,
                        g
                    ],
                    [
                        "L",
                        a + (m ? 0 : -h),
                        g + (m ? h : 0)
                    ]
                ], n);
            }
            handleOverflow(a) {
                const e = this.axis, g = e.options.labels, n = a.x;
                var m = e.chart.chartWidth, f = e.chart.spacing;
                const y = h(e.labelLeft, Math.min(e.pos, f[3]));
                f = h(e.labelRight, Math.max(e.isRadial ? 0 : e.pos + e.len, m - f[1]));
                const r = this.label, l = this.rotation, v = {
                    left: 0,
                    center: .5,
                    right: 1
                }[e.labelAlign || r.attr("align")], d = r.getBBox().width, b = e.getSlotWidth(this), c = {};
                let k = b, w = 1, z;
                if (l || "justify" !== g.overflow) 0 > l && n - v * d < y ? z = Math.round(n / Math.cos(l * u) - y) : 0 < l && n + v * d > f && (z = Math.round((m - n) / Math.cos(l * u)));
                else if (m = n + (1 - v) * d, n - v * d < y ? k = a.x + k * (1 - v) - y : m > f && (k = f - a.x + k * v, w = -1), k = Math.min(b, k), k < b && "center" === e.labelAlign && (a.x += w * (b - k - v * (b - Math.min(d, k)))), d > k || e.autoRotation && (r.styles || {}).width) z = k;
                z && (this.shortenLabel ? this.shortenLabel() : (c.width = Math.floor(z) + "px", (g.style || {}).textOverflow || (c.textOverflow = "ellipsis"), r.css(c)));
            }
            moveLabel(a, g) {
                const e = this;
                var h = e.label;
                const m = e.axis;
                let f = !1;
                h && h.textStr === a ? (e.movedLabel = h, f = !0, delete e.label) : n(m.ticks, function(g) {
                    f || g.isNew || g === e || !g.label || g.label.textStr !== a || (e.movedLabel = g.label, f = !0, g.labelPos = e.movedLabel.xy, delete g.label);
                });
                f || !e.labelPos && !h || (h = e.labelPos || h.xy, e.movedLabel = e.createLabel(h, a, g), e.movedLabel && e.movedLabel.attr({
                    opacity: 0
                }));
            }
            render(a, g, n) {
                var e = this.axis, m = e.horiz, f = this.pos, y = h(this.tickmarkOffset, e.tickmarkOffset);
                f = this.getPosition(m, f, y, g);
                y = f.x;
                const r = f.y;
                e = m && y === e.pos + e.len || !m && r === e.pos ? -1 : 1;
                m = h(n, this.label && this.label.newOpacity, 1);
                n = h(n, 1);
                this.isActive = !0;
                this.renderGridLine(g, n, e);
                this.renderMark(f, n, e);
                this.renderLabel(f, g, m, a);
                this.isNew = !1;
                q(this, "afterRender");
            }
            renderGridLine(a, g, n) {
                const e = this.axis, m = e.options, f = {}, y = this.pos, r = this.type, l = h(this.tickmarkOffset, e.tickmarkOffset), v = e.chart.renderer;
                let d = this.gridLine, b = m.gridLineWidth, c = m.gridLineColor, k = m.gridLineDashStyle;
                "minor" === this.type && (b = m.minorGridLineWidth, c = m.minorGridLineColor, k = m.minorGridLineDashStyle);
                d || (e.chart.styledMode || (f.stroke = c, f["stroke-width"] = b || 0, f.dashstyle = k), r || (f.zIndex = 1), a && (g = 0), this.gridLine = d = v.path().attr(f).addClass("highcharts-" + (r ? r + "-" : "") + "grid-line").add(e.gridGroup));
                if (d && (n = e.getPlotLinePath({
                    value: y + l,
                    lineWidth: d.strokeWidth() * n,
                    force: "pass",
                    old: a,
                    acrossPanes: !1
                }))) d[a || this.isNew ? "attr" : "animate"]({
                    d: n,
                    opacity: g
                });
            }
            renderMark(a, g, n) {
                const e = this.axis;
                var m = e.options;
                const f = e.chart.renderer, y = this.type, r = e.tickSize(y ? y + "Tick" : "tick"), l = a.x;
                a = a.y;
                const v = h(m["minor" !== y ? "tickWidth" : "minorTickWidth"], !y && e.isXAxis ? 1 : 0);
                m = m["minor" !== y ? "tickColor" : "minorTickColor"];
                let d = this.mark;
                const b = !d;
                r && (e.opposite && (r[0] = -r[0]), d || (this.mark = d = f.path().addClass("highcharts-" + (y ? y + "-" : "") + "tick").add(e.axisGroup), e.chart.styledMode || d.attr({
                    stroke: m,
                    "stroke-width": v
                })), d[b ? "attr" : "animate"]({
                    d: this.getMarkPath(l, a, r[0], d.strokeWidth() * n, e.horiz, f),
                    opacity: g
                }));
            }
            renderLabel(a, g, n, p) {
                var e = this.axis;
                const f = e.horiz, y = e.options, r = this.label, l = y.labels, v = l.step;
                e = h(this.tickmarkOffset, e.tickmarkOffset);
                const d = a.x;
                a = a.y;
                let b = !0;
                r && m(d) && (r.xy = a = this.getLabelPosition(d, a, r, f, l, e, p, v), this.isFirst && !this.isLast && !y.showFirstLabel || this.isLast && !this.isFirst && !y.showLastLabel ? b = !1 : !f || l.step || l.rotation || g || 0 === n || this.handleOverflow(a), v && p % v && (b = !1), b && m(a.y) ? (a.opacity = n, r[this.isNewLabel ? "attr" : "animate"](a).show(!0), this.isNewLabel = !1) : (r.hide(), this.isNewLabel = !0));
            }
            replaceMovedLabel() {
                const a = this.label, g = this.axis;
                a && !this.isNew && (a.animate({
                    opacity: 0
                }, void 0, a.destroy), delete this.label);
                g.isDirty = !0;
                this.label = this.movedLabel;
                delete this.movedLabel;
            }
        }
        "";
        return g;
    });
    L(a, "Core/Axis/Axis.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/AxisDefaults.js"],
        a["Core/Color/Color.js"],
        a["Core/Defaults.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Axis/Tick.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E, B) {
        const { animObject: t } = a, { defaultOptions: q } = K, { registerEventOptions: m } = G, { deg2rad: p } = D, { arrayMax: n, arrayMin: h, clamp: g, correctFloat: e, defined: x, destroyObjectProperties: I, erase: u, error: C, extend: f, fireEvent: y, getClosestDistance: r, insertItem: l, isArray: v, isNumber: d, isString: b, merge: c, normalizeTickInterval: k, objectEach: w, pick: z, relativeLength: F, removeEvent: O, splat: P, syncTimeout: T } = B, U = (b, c)=>k(c, void 0, void 0, z(b.options.allowDecimals, .5 > c || void 0 !== b.tickAmount), !!b.tickAmount);
        class W {
            constructor(b, c, d){
                this.zoomEnabled = this.width = this.visible = this.userOptions = this.translationSlope = this.transB = this.transA = this.top = this.ticks = this.tickRotCorr = this.tickPositions = this.tickmarkOffset = this.tickInterval = this.tickAmount = this.side = this.series = this.right = this.positiveValuesOnly = this.pos = this.pointRangePadding = this.pointRange = this.plotLinesAndBandsGroups = this.plotLinesAndBands = this.paddedTicks = this.overlap = this.options = this.offset = this.names = this.minPixelPadding = this.minorTicks = this.minorTickInterval = this.min = this.maxLabelLength = this.max = this.len = this.left = this.labelFormatter = this.labelEdge = this.isLinked = this.index = this.height = this.hasVisibleSeries = this.hasNames = this.eventOptions = this.coll = this.closestPointRange = this.chart = this.bottom = this.alternateBands = void 0;
                this.init(b, c, d);
            }
            init(b, c, k = this.coll) {
                const a = "xAxis" === k;
                this.chart = b;
                this.horiz = this.isZAxis || (b.inverted ? !a : a);
                this.isXAxis = a;
                this.coll = k;
                y(this, "init", {
                    userOptions: c
                });
                this.opposite = z(c.opposite, this.opposite);
                this.side = z(c.side, this.side, this.horiz ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3);
                this.setOptions(c);
                k = this.options;
                const f = k.labels, e = k.type;
                this.userOptions = c;
                this.minPixelPadding = 0;
                this.reversed = z(k.reversed, this.reversed);
                this.visible = k.visible;
                this.zoomEnabled = k.zoomEnabled;
                this.hasNames = "category" === e || !0 === k.categories;
                this.categories = k.categories || (this.hasNames ? [] : void 0);
                this.names || (this.names = [], this.names.keys = {});
                this.plotLinesAndBandsGroups = {};
                this.positiveValuesOnly = !!this.logarithmic;
                this.isLinked = x(k.linkedTo);
                this.ticks = {};
                this.labelEdge = [];
                this.minorTicks = {};
                this.plotLinesAndBands = [];
                this.alternateBands = {};
                this.len = 0;
                this.minRange = this.userMinRange = k.minRange || k.maxZoom;
                this.range = k.range;
                this.offset = k.offset || 0;
                this.min = this.max = null;
                c = z(k.crosshair, P(b.options.tooltip.crosshairs)[a ? 0 : 1]);
                this.crosshair = !0 === c ? {} : c;
                -1 === b.axes.indexOf(this) && (a ? b.axes.splice(b.xAxis.length, 0, this) : b.axes.push(this), l(this, b[this.coll]));
                b.orderItems(this.coll);
                this.series = this.series || [];
                b.inverted && !this.isZAxis && a && "undefined" === typeof this.reversed && (this.reversed = !0);
                this.labelRotation = d(f.rotation) ? f.rotation : void 0;
                m(this, k);
                y(this, "afterInit");
            }
            setOptions(b) {
                this.options = c(A.defaultXAxisOptions, "yAxis" === this.coll && A.defaultYAxisOptions, [
                    A.defaultTopAxisOptions,
                    A.defaultRightAxisOptions,
                    A.defaultBottomAxisOptions,
                    A.defaultLeftAxisOptions
                ][this.side], c(q[this.coll], b));
                y(this, "afterSetOptions", {
                    userOptions: b
                });
            }
            defaultLabelFormatter(b) {
                var c = this.axis;
                ({ numberFormatter: b } = this.chart);
                const k = d(this.value) ? this.value : NaN, a = c.chart.time, f = this.dateTimeLabelFormat;
                var e = q.lang;
                const l = e.numericSymbols;
                e = e.numericSymbolMagnitude || 1E3;
                const H = c.logarithmic ? Math.abs(k) : c.tickInterval;
                let w = l && l.length, g;
                if (c.categories) g = `${this.value}`;
                else if (f) g = a.dateFormat(f, k);
                else if (w && 1E3 <= H) for(; w-- && "undefined" === typeof g;)c = Math.pow(e, w + 1), H >= c && 0 === 10 * k % c && null !== l[w] && 0 !== k && (g = b(k / c, -1) + l[w]);
                "undefined" === typeof g && (g = 1E4 <= Math.abs(k) ? b(k, -1) : b(k, -1, void 0, ""));
                return g;
            }
            getSeriesExtremes() {
                const b = this, c = b.chart;
                let k;
                y(this, "getSeriesExtremes", null, function() {
                    b.hasVisibleSeries = !1;
                    b.dataMin = b.dataMax = b.threshold = null;
                    b.softThreshold = !b.isXAxis;
                    b.series.forEach(function(a) {
                        if (a.visible || !c.options.chart.ignoreHiddenSeries) {
                            var f = a.options;
                            let c = f.threshold, e, l;
                            b.hasVisibleSeries = !0;
                            b.positiveValuesOnly && 0 >= c && (c = null);
                            if (b.isXAxis) (f = a.xData) && f.length && (f = b.logarithmic ? f.filter((b)=>0 < b) : f, k = a.getXExtremes(f), e = k.min, l = k.max, d(e) || e instanceof Date || (f = f.filter(d), k = a.getXExtremes(f), e = k.min, l = k.max), f.length && (b.dataMin = Math.min(z(b.dataMin, e), e), b.dataMax = Math.max(z(b.dataMax, l), l)));
                            else if (a = a.applyExtremes(), d(a.dataMin) && (e = a.dataMin, b.dataMin = Math.min(z(b.dataMin, e), e)), d(a.dataMax) && (l = a.dataMax, b.dataMax = Math.max(z(b.dataMax, l), l)), x(c) && (b.threshold = c), !f.softThreshold || b.positiveValuesOnly) b.softThreshold = !1;
                        }
                    });
                });
                y(this, "afterGetSeriesExtremes");
            }
            translate(b, c, k, a, f, l) {
                const w = this.linkedParent || this, H = a && w.old ? w.old.min : w.min;
                if (!d(H)) return NaN;
                const g = w.minPixelPadding;
                f = (w.isOrdinal || w.brokenAxis && w.brokenAxis.hasBreaks || w.logarithmic && f) && w.lin2val;
                let r = 1, z = 0;
                a = a && w.old ? w.old.transA : w.transA;
                a || (a = w.transA);
                k && (r *= -1, z = w.len);
                w.reversed && (r *= -1, z -= r * (w.sector || w.len));
                c ? (l = (b * r + z - g) / a + H, f && (l = w.lin2val(l))) : (f && (b = w.val2lin(b)), b = r * (b - H) * a, l = (w.isRadial ? b : e(b)) + z + r * g + (d(l) ? a * l : 0));
                return l;
            }
            toPixels(b, c) {
                return this.translate(b, !1, !this.horiz, void 0, !0) + (c ? 0 : this.pos);
            }
            toValue(b, c) {
                return this.translate(b - (c ? 0 : this.pos), !0, !this.horiz, void 0, !0);
            }
            getPlotLinePath(b) {
                function c(b, c, d) {
                    "pass" !== n && (b < c || b > d) && (n ? b = g(b, c, d) : O = !0);
                    return b;
                }
                const k = this, a = k.chart, f = k.left, e = k.top, l = b.old, w = b.value, H = b.lineWidth, r = l && a.oldChartHeight || a.chartHeight, v = l && a.oldChartWidth || a.chartWidth, F = k.transB;
                let h = b.translatedValue, n = b.force, m, x, p, q, O;
                b = {
                    value: w,
                    lineWidth: H,
                    old: l,
                    force: n,
                    acrossPanes: b.acrossPanes,
                    translatedValue: h
                };
                y(this, "getPlotLinePath", b, function(b) {
                    h = z(h, k.translate(w, void 0, void 0, l));
                    h = g(h, -100000, 1E5);
                    m = p = Math.round(h + F);
                    x = q = Math.round(r - h - F);
                    d(h) ? k.horiz ? (x = e, q = r - k.bottom, m = p = c(m, f, f + k.width)) : (m = f, p = v - k.right, x = q = c(x, e, e + k.height)) : (O = !0, n = !1);
                    b.path = O && !n ? null : a.renderer.crispLine([
                        [
                            "M",
                            m,
                            x
                        ],
                        [
                            "L",
                            p,
                            q
                        ]
                    ], H || 1);
                });
                return b.path;
            }
            getLinearTickPositions(b, c, d) {
                const k = e(Math.floor(c / b) * b);
                d = e(Math.ceil(d / b) * b);
                const a = [];
                let f, l;
                e(k + b) === k && (l = 20);
                if (this.single) return [
                    c
                ];
                for(c = k; c <= d;){
                    a.push(c);
                    c = e(c + b, l);
                    if (c === f) break;
                    f = c;
                }
                return a;
            }
            getMinorTickInterval() {
                const b = this.options;
                return !0 === b.minorTicks ? z(b.minorTickInterval, "auto") : !1 === b.minorTicks ? null : b.minorTickInterval;
            }
            getMinorTickPositions() {
                var b = this.options;
                const c = this.tickPositions, d = this.minorTickInterval;
                var k = this.pointRangePadding || 0;
                const a = this.min - k;
                k = this.max + k;
                const f = k - a;
                let l = [];
                if (f && f / d < this.len / 3) {
                    const f = this.logarithmic;
                    if (f) this.paddedTicks.forEach(function(b, c, k) {
                        c && l.push.apply(l, f.getLogTickPositions(d, k[c - 1], k[c], !0));
                    });
                    else if (this.dateTime && "auto" === this.getMinorTickInterval()) l = l.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(d), a, k, b.startOfWeek));
                    else for(b = a + (c[0] - a) % d; b <= k && b !== l[0]; b += d)l.push(b);
                }
                0 !== l.length && this.trimTicks(l);
                return l;
            }
            adjustForMinRange() {
                const b = this.options, c = this.logarithmic;
                let d = this.min;
                var k = this.max;
                let a, f;
                if (this.isXAxis && "undefined" === typeof this.minRange && !c) {
                    if (x(b.min) || x(b.max) || x(b.floor) || x(b.ceiling)) this.minRange = null;
                    else {
                        var l = r(this.series.map((b)=>{
                            var c;
                            return (b.xIncrement ? null === (c = b.xData) || void 0 === c ? void 0 : c.slice(0, 2) : b.xData) || [];
                        })) || 0;
                        this.minRange = Math.min(5 * l, this.dataMax - this.dataMin);
                    }
                }
                k - d < this.minRange && (l = this.dataMax - this.dataMin >= this.minRange, f = this.minRange, k = (f - k + d) / 2, a = [
                    d - k,
                    z(b.min, d - k)
                ], l && (a[2] = c ? c.log2lin(this.dataMin) : this.dataMin), d = n(a), k = [
                    d + f,
                    z(b.max, d + f)
                ], l && (k[2] = c ? c.log2lin(this.dataMax) : this.dataMax), k = h(k), k - d < f && (a[0] = k - f, a[1] = z(b.min, k - f), d = n(a)));
                this.min = d;
                this.max = k;
            }
            getClosest() {
                let b, c;
                if (this.categories) c = 1;
                else {
                    const d = [];
                    this.series.forEach(function(b) {
                        var k;
                        const a = b.closestPointRange, f = b.visible || !b.chart.options.chart.ignoreHiddenSeries;
                        1 === (null === (k = b.xData) || void 0 === k ? void 0 : k.length) ? d.push(b.xData[0]) : !b.noSharedTooltip && x(a) && f && (c = x(c) ? Math.min(c, a) : a);
                    });
                    d.length && (d.sort((b, c)=>b - c), b = r([
                        d
                    ]));
                }
                return b && c ? Math.min(b, c) : b || c;
            }
            nameToX(b) {
                const c = v(this.options.categories), d = c ? this.categories : this.names;
                let k = b.options.x, a;
                b.series.requireSorting = !1;
                x(k) || (k = this.options.uniqueNames && d ? c ? d.indexOf(b.name) : z(d.keys[b.name], -1) : b.series.autoIncrement());
                -1 === k ? !c && d && (a = d.length) : a = k;
                "undefined" !== typeof a ? (this.names[a] = b.name, this.names.keys[b.name] = a) : b.x && (a = b.x);
                return a;
            }
            updateNames() {
                const b = this, c = this.names;
                0 < c.length && (Object.keys(c.keys).forEach(function(b) {
                    delete c.keys[b];
                }), c.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach(function(c) {
                    c.xIncrement = null;
                    if (!c.points || c.isDirtyData) b.max = Math.max(b.max, c.xData.length - 1), c.processData(), c.generatePoints();
                    c.data.forEach(function(d, k) {
                        let a;
                        d && d.options && "undefined" !== typeof d.name && (a = b.nameToX(d), "undefined" !== typeof a && a !== d.x && (d.x = a, c.xData[k] = a));
                    });
                }));
            }
            setAxisTranslation() {
                const c = this, d = c.max - c.min;
                var k = c.linkedParent;
                const a = !!c.categories, f = c.isXAxis;
                let l = c.axisPointRange || 0, e, w = 0, g = 0, r = c.transA;
                if (f || a || l) e = c.getClosest(), k ? (w = k.minPointOffset, g = k.pointRangePadding) : c.series.forEach(function(d) {
                    const k = a ? 1 : f ? z(d.options.pointRange, e, 0) : c.axisPointRange || 0, r = d.options.pointPlacement;
                    l = Math.max(l, k);
                    if (!c.single || a) d = d.is("xrange") ? !f : f, w = Math.max(w, d && b(r) ? 0 : k / 2), g = Math.max(g, d && "on" === r ? 0 : k);
                }), k = c.ordinal && c.ordinal.slope && e ? c.ordinal.slope / e : 1, c.minPointOffset = w *= k, c.pointRangePadding = g *= k, c.pointRange = Math.min(l, c.single && a ? 1 : d), f && e && (c.closestPointRange = e);
                c.translationSlope = c.transA = r = c.staticScale || c.len / (d + g || 1);
                c.transB = c.horiz ? c.left : c.bottom;
                c.minPixelPadding = r * w;
                y(this, "afterSetAxisTranslation");
            }
            minFromRange() {
                return this.max - this.range;
            }
            setTickInterval(b) {
                var c = this.chart;
                const k = this.logarithmic, a = this.options, f = this.isXAxis, l = this.isLinked, w = a.tickPixelInterval, g = this.categories, r = this.softThreshold;
                let v = a.maxPadding, F = a.minPadding;
                let h = d(a.tickInterval) && 0 <= a.tickInterval ? a.tickInterval : void 0, H = d(this.threshold) ? this.threshold : null, n, m, p;
                this.dateTime || g || l || this.getTickAmount();
                m = z(this.userMin, a.min);
                p = z(this.userMax, a.max);
                if (l) {
                    this.linkedParent = c[this.coll][a.linkedTo];
                    var q = this.linkedParent.getExtremes();
                    this.min = z(q.min, q.dataMin);
                    this.max = z(q.max, q.dataMax);
                    a.type !== this.linkedParent.options.type && C(11, 1, c);
                } else r && x(H) && (this.dataMin >= H ? (q = H, F = 0) : this.dataMax <= H && (n = H, v = 0)), this.min = z(m, q, this.dataMin), this.max = z(p, n, this.dataMax);
                k && (this.positiveValuesOnly && !b && 0 >= Math.min(this.min, z(this.dataMin, this.min)) && C(10, 1, c), this.min = e(k.log2lin(this.min), 16), this.max = e(k.log2lin(this.max), 16));
                this.range && x(this.max) && (this.userMin = this.min = m = Math.max(this.dataMin, this.minFromRange()), this.userMax = p = this.max, this.range = null);
                y(this, "foundExtremes");
                this.beforePadding && this.beforePadding();
                this.adjustForMinRange();
                !d(this.userMin) && d(a.softMin) && a.softMin < this.min && (this.min = m = a.softMin);
                !d(this.userMax) && d(a.softMax) && a.softMax > this.max && (this.max = p = a.softMax);
                !(g || this.axisPointRange || this.stacking && this.stacking.usePercentage || l) && x(this.min) && x(this.max) && (c = this.max - this.min) && (!x(m) && F && (this.min -= c * F), !x(p) && v && (this.max += c * v));
                !d(this.userMin) && d(a.floor) && (this.min = Math.max(this.min, a.floor));
                !d(this.userMax) && d(a.ceiling) && (this.max = Math.min(this.max, a.ceiling));
                r && x(this.dataMin) && (H = H || 0, !x(m) && this.min < H && this.dataMin >= H ? this.min = this.options.minRange ? Math.min(H, this.max - this.minRange) : H : !x(p) && this.max > H && this.dataMax <= H && (this.max = this.options.minRange ? Math.max(H, this.min + this.minRange) : H));
                d(this.min) && d(this.max) && !this.chart.polar && this.min > this.max && (x(this.options.min) ? this.max = this.min : x(this.options.max) && (this.min = this.max));
                this.tickInterval = this.min === this.max || "undefined" === typeof this.min || "undefined" === typeof this.max ? 1 : l && this.linkedParent && !h && w === this.linkedParent.options.tickPixelInterval ? h = this.linkedParent.tickInterval : z(h, this.tickAmount ? (this.max - this.min) / Math.max(this.tickAmount - 1, 1) : void 0, g ? 1 : (this.max - this.min) * w / Math.max(this.len, w));
                if (f && !b) {
                    const b = this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max);
                    this.series.forEach(function(c) {
                        c.forceCrop = c.forceCropping && c.forceCropping();
                        c.processData(b);
                    });
                    y(this, "postProcessData", {
                        hasExtremesChanged: b
                    });
                }
                this.setAxisTranslation();
                y(this, "initialAxisTranslation");
                this.pointRange && !h && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
                b = z(a.minTickInterval, this.dateTime && !this.series.some((b)=>b.noSharedTooltip) ? this.closestPointRange : 0);
                !h && this.tickInterval < b && (this.tickInterval = b);
                this.dateTime || this.logarithmic || h || (this.tickInterval = U(this, this.tickInterval));
                this.tickAmount || (this.tickInterval = this.unsquish());
                this.setTickPositions();
            }
            setTickPositions() {
                var b = this.options;
                const c = b.tickPositions, k = b.tickPositioner;
                var a = this.getMinorTickInterval(), f = this.hasVerticalPanning(), l = "colorAxis" === this.coll;
                const e = (l || !f) && b.startOnTick;
                f = (l || !f) && b.endOnTick;
                l = [];
                let w;
                this.tickmarkOffset = this.categories && "between" === b.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0;
                this.minorTickInterval = "auto" === a && this.tickInterval ? this.tickInterval / b.minorTicksPerMajor : a;
                this.single = this.min === this.max && x(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || !1 !== b.allowDecimals);
                if (c) l = c.slice();
                else if (d(this.min) && d(this.max)) {
                    if (this.ordinal && this.ordinal.positions || !((this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200))) {
                        if (this.dateTime) l = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, b.units), this.min, this.max, b.startOfWeek, this.ordinal && this.ordinal.positions, this.closestPointRange, !0);
                        else if (this.logarithmic) l = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                        else for(a = b = this.tickInterval; a <= 2 * b;)if (l = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && l.length > this.tickAmount) this.tickInterval = U(this, a *= 1.1);
                        else break;
                    } else l = [
                        this.min,
                        this.max
                    ], C(19, !1, this.chart);
                    l.length > this.len && (l = [
                        l[0],
                        l[l.length - 1]
                    ], l[0] === l[1] && (l.length = 1));
                    k && (this.tickPositions = l, (w = k.apply(this, [
                        this.min,
                        this.max
                    ])) && (l = w));
                }
                this.tickPositions = l;
                this.paddedTicks = l.slice(0);
                this.trimTicks(l, e, f);
                !this.isLinked && d(this.min) && d(this.max) && (this.single && 2 > l.length && !this.categories && !this.series.some((b)=>b.is("heatmap") && "between" === b.options.pointPlacement) && (this.min -= .5, this.max += .5), c || w || this.adjustTickAmount());
                y(this, "afterSetTickPositions");
            }
            trimTicks(b, c, d) {
                const k = b[0], a = b[b.length - 1], f = !this.isOrdinal && this.minPointOffset || 0;
                y(this, "trimTicks");
                if (!this.isLinked) {
                    if (c && -Infinity !== k) this.min = k;
                    else for(; this.min - f > b[0];)b.shift();
                    if (d) this.max = a;
                    else for(; this.max + f < b[b.length - 1];)b.pop();
                    0 === b.length && x(k) && !this.options.tickPositions && b.push((a + k) / 2);
                }
            }
            alignToOthers() {
                const b = this, c = [
                    this
                ], k = b.options, a = "yAxis" === this.coll && this.chart.options.chart.alignThresholds, f = [];
                let l;
                b.thresholdAlignment = void 0;
                if ((!1 !== this.chart.options.chart.alignTicks && k.alignTicks || a) && !1 !== k.startOnTick && !1 !== k.endOnTick && !b.logarithmic) {
                    const d = (b)=>{
                        const { horiz: c, options: d } = b;
                        return [
                            c ? d.left : d.top,
                            d.width,
                            d.height,
                            d.pane
                        ].join();
                    }, k = d(this);
                    this.chart[this.coll].forEach(function(a) {
                        const { series: f } = a;
                        f.length && f.some((b)=>b.visible) && a !== b && d(a) === k && (l = !0, c.push(a));
                    });
                }
                if (l && a) {
                    c.forEach((c)=>{
                        c = c.getThresholdAlignment(b);
                        d(c) && f.push(c);
                    });
                    const k = 1 < f.length ? f.reduce((b, c)=>b + c, 0) / f.length : void 0;
                    c.forEach((b)=>{
                        b.thresholdAlignment = k;
                    });
                }
                return l;
            }
            getThresholdAlignment(b) {
                (!d(this.dataMin) || this !== b && this.series.some((b)=>b.isDirty || b.isDirtyData)) && this.getSeriesExtremes();
                if (d(this.threshold)) return b = g((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1), this.options.reversed && (b = 1 - b), b;
            }
            getTickAmount() {
                const b = this.options, c = b.tickPixelInterval;
                let d = b.tickAmount;
                !x(b.tickInterval) && !d && this.len < c && !this.isRadial && !this.logarithmic && b.startOnTick && b.endOnTick && (d = 2);
                !d && this.alignToOthers() && (d = Math.ceil(this.len / c) + 1);
                4 > d && (this.finalTickAmt = d, d = 5);
                this.tickAmount = d;
            }
            adjustTickAmount() {
                const b = this, { finalTickAmt: c, max: k, min: a, options: f, tickPositions: l, tickAmount: w, thresholdAlignment: g } = b, r = l && l.length;
                var v = z(b.threshold, b.softThreshold ? 0 : null);
                var F = b.tickInterval;
                let h;
                d(g) && (h = .5 > g ? Math.ceil(g * (w - 1)) : Math.floor(g * (w - 1)), f.reversed && (h = w - 1 - h));
                if (b.hasData() && d(a) && d(k)) {
                    const g = ()=>{
                        b.transA *= (r - 1) / (w - 1);
                        b.min = f.startOnTick ? l[0] : Math.min(a, l[0]);
                        b.max = f.endOnTick ? l[l.length - 1] : Math.max(k, l[l.length - 1]);
                    };
                    if (d(h) && d(b.threshold)) {
                        for(; l[h] !== v || l.length !== w || l[0] > a || l[l.length - 1] < k;){
                            l.length = 0;
                            for(l.push(b.threshold); l.length < w;)void 0 === l[h] || l[h] > b.threshold ? l.unshift(e(l[0] - F)) : l.push(e(l[l.length - 1] + F));
                            if (F > 8 * b.tickInterval) break;
                            F *= 2;
                        }
                        g();
                    } else if (r < w) {
                        for(; l.length < w;)l.length % 2 || a === v ? l.push(e(l[l.length - 1] + F)) : l.unshift(e(l[0] - F));
                        g();
                    }
                    if (x(c)) {
                        for(F = v = l.length; F--;)(3 === c && 1 === F % 2 || 2 >= c && 0 < F && F < v - 1) && l.splice(F, 1);
                        b.finalTickAmt = void 0;
                    }
                }
            }
            setScale() {
                let b = !1, c = !1;
                this.series.forEach(function(d) {
                    b = b || d.isDirtyData || d.isDirty;
                    c = c || d.xAxis && d.xAxis.isDirty || !1;
                });
                this.setAxisSize();
                const d = this.len !== (this.old && this.old.len);
                d || b || c || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (this.stacking && (this.stacking.resetStacks(), this.stacking.buildStacks()), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), this.isDirty || (this.isDirty = d || this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max))) : this.stacking && this.stacking.cleanStacks();
                b && this.panningState && (this.panningState.isDirty = !0);
                y(this, "afterSetScale");
            }
            setExtremes(b, c, d, k, a) {
                const l = this, e = l.chart;
                d = z(d, !0);
                l.series.forEach(function(b) {
                    delete b.kdTree;
                });
                a = f(a, {
                    min: b,
                    max: c
                });
                y(l, "setExtremes", a, function() {
                    l.userMin = b;
                    l.userMax = c;
                    l.eventArgs = a;
                    d && e.redraw(k);
                });
            }
            zoom(b, c) {
                const d = this, k = this.dataMin, a = this.dataMax, f = this.options, l = Math.min(k, z(f.min, k)), e = Math.max(a, z(f.max, a));
                b = {
                    newMin: b,
                    newMax: c
                };
                y(this, "zoom", b, function(b) {
                    let c = b.newMin, f = b.newMax;
                    if (c !== d.min || f !== d.max) d.allowZoomOutside || (x(k) && (c < l && (c = l), c > e && (c = e)), x(a) && (f < l && (f = l), f > e && (f = e))), d.displayBtn = "undefined" !== typeof c || "undefined" !== typeof f, d.setExtremes(c, f, !1, void 0, {
                        trigger: "zoom"
                    });
                    b.zoomed = !0;
                });
                return b.zoomed;
            }
            setAxisSize() {
                const b = this.chart;
                var c = this.options;
                const d = c.offsets || [
                    0,
                    0,
                    0,
                    0
                ], k = this.horiz, a = this.width = Math.round(F(z(c.width, b.plotWidth - d[3] + d[1]), b.plotWidth)), f = this.height = Math.round(F(z(c.height, b.plotHeight - d[0] + d[2]), b.plotHeight)), l = this.top = Math.round(F(z(c.top, b.plotTop + d[0]), b.plotHeight, b.plotTop));
                c = this.left = Math.round(F(z(c.left, b.plotLeft + d[3]), b.plotWidth, b.plotLeft));
                this.bottom = b.chartHeight - f - l;
                this.right = b.chartWidth - a - c;
                this.len = Math.max(k ? a : f, 0);
                this.pos = k ? c : l;
            }
            getExtremes() {
                const b = this.logarithmic;
                return {
                    min: b ? e(b.lin2log(this.min)) : this.min,
                    max: b ? e(b.lin2log(this.max)) : this.max,
                    dataMin: this.dataMin,
                    dataMax: this.dataMax,
                    userMin: this.userMin,
                    userMax: this.userMax
                };
            }
            getThreshold(b) {
                var c = this.logarithmic;
                const d = c ? c.lin2log(this.min) : this.min;
                c = c ? c.lin2log(this.max) : this.max;
                null === b || -Infinity === b ? b = d : Infinity === b ? b = c : d > b ? b = d : c < b && (b = c);
                return this.translate(b, 0, 1, 0, 1);
            }
            autoLabelAlign(b) {
                const c = (z(b, 0) - 90 * this.side + 720) % 360;
                b = {
                    align: "center"
                };
                y(this, "autoLabelAlign", b, function(b) {
                    15 < c && 165 > c ? b.align = "right" : 195 < c && 345 > c && (b.align = "left");
                });
                return b.align;
            }
            tickSize(b) {
                const c = this.options, d = z(c["tick" === b ? "tickWidth" : "minorTickWidth"], "tick" === b && this.isXAxis && !this.categories ? 1 : 0);
                let k = c["tick" === b ? "tickLength" : "minorTickLength"], a;
                d && k && ("inside" === c[b + "Position"] && (k = -k), a = [
                    k,
                    d
                ]);
                b = {
                    tickSize: a
                };
                y(this, "afterTickSize", b);
                return b.tickSize;
            }
            labelMetrics() {
                const b = this.chart.renderer;
                var c = this.ticks;
                c = c[Object.keys(c)[0]] || {};
                return this.chart.renderer.fontMetrics(c.label || c.movedLabel || b.box);
            }
            unsquish() {
                const b = this.options.labels;
                var c = this.horiz;
                const k = this.tickInterval, a = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / k), f = b.rotation, l = .75 * this.labelMetrics().h, w = Math.max(this.max - this.min, 0), g = function(b) {
                    let c = b / (a || 1);
                    c = 1 < c ? Math.ceil(c) : 1;
                    c * k > w && Infinity !== b && Infinity !== a && w && (c = Math.ceil(w / k));
                    return e(c * k);
                };
                let r = k, v, F = Number.MAX_VALUE, h;
                if (c) {
                    if (b.staggerLines || (d(f) ? h = [
                        f
                    ] : a < b.autoRotationLimit && (h = b.autoRotation)), h) {
                        let b;
                        for (const d of h)if (d === f || d && -90 <= d && 90 >= d) c = g(Math.abs(l / Math.sin(p * d))), b = c + Math.abs(d / 360), b < F && (F = b, v = d, r = c);
                    }
                } else r = g(l);
                this.autoRotation = h;
                this.labelRotation = z(v, d(f) ? f : 0);
                return b.step ? k : r;
            }
            getSlotWidth(b) {
                const c = this.chart, k = this.horiz, a = this.options.labels, f = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), l = c.margin[3];
                if (b && d(b.slotWidth)) return b.slotWidth;
                if (k && 2 > a.step) return a.rotation ? 0 : (this.staggerLines || 1) * this.len / f;
                if (!k) {
                    b = a.style.width;
                    if (void 0 !== b) return parseInt(String(b), 10);
                    if (l) return l - c.spacing[3];
                }
                return .33 * c.chartWidth;
            }
            renderUnsquish() {
                const c = this.chart, d = c.renderer, k = this.tickPositions, a = this.ticks, f = this.options.labels, l = f.style, e = this.horiz, w = this.getSlotWidth();
                var g = Math.max(1, Math.round(w - 2 * f.padding));
                const r = {}, z = this.labelMetrics(), v = l.textOverflow;
                let F, h, y = 0;
                b(f.rotation) || (r.rotation = f.rotation || 0);
                k.forEach(function(b) {
                    b = a[b];
                    b.movedLabel && b.replaceMovedLabel();
                    b && b.label && b.label.textPxLength > y && (y = b.label.textPxLength);
                });
                this.maxLabelLength = y;
                if (this.autoRotation) y > g && y > z.h ? r.rotation = this.labelRotation : this.labelRotation = 0;
                else if (w && (F = g, !v)) for(h = "clip", g = k.length; !e && g--;){
                    var n = k[g];
                    if (n = a[n].label) n.styles && "ellipsis" === n.styles.textOverflow ? n.css({
                        textOverflow: "clip"
                    }) : n.textPxLength > w && n.css({
                        width: w + "px"
                    }), n.getBBox().height > this.len / k.length - (z.h - z.f) && (n.specificTextOverflow = "ellipsis");
                }
                r.rotation && (F = y > .5 * c.chartHeight ? .33 * c.chartHeight : y, v || (h = "ellipsis"));
                if (this.labelAlign = f.align || this.autoLabelAlign(this.labelRotation)) r.align = this.labelAlign;
                k.forEach(function(b) {
                    const c = (b = a[b]) && b.label, d = l.width, k = {};
                    c && (c.attr(r), b.shortenLabel ? b.shortenLabel() : F && !d && "nowrap" !== l.whiteSpace && (F < c.textPxLength || "SPAN" === c.element.tagName) ? (k.width = F + "px", v || (k.textOverflow = c.specificTextOverflow || h), c.css(k)) : c.styles && c.styles.width && !k.width && !d && c.css({
                        width: null
                    }), delete c.specificTextOverflow, b.rotation = r.rotation);
                }, this);
                this.tickRotCorr = d.rotCorr(z.b, this.labelRotation || 0, 0 !== this.side);
            }
            hasData() {
                return this.series.some(function(b) {
                    return b.hasData();
                }) || this.options.showEmpty && x(this.min) && x(this.max);
            }
            addTitle(b) {
                const d = this.chart.renderer, k = this.horiz, a = this.opposite, f = this.options.title, l = this.chart.styledMode;
                let e;
                this.axisTitle || ((e = f.textAlign) || (e = (k ? {
                    low: "left",
                    middle: "center",
                    high: "right"
                } : {
                    low: a ? "right" : "left",
                    middle: "center",
                    high: a ? "left" : "right"
                })[f.align]), this.axisTitle = d.text(f.text || "", 0, 0, f.useHTML).attr({
                    zIndex: 7,
                    rotation: f.rotation,
                    align: e
                }).addClass("highcharts-axis-title"), l || this.axisTitle.css(c(f.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0);
                l || f.style.width || this.isRadial || this.axisTitle.css({
                    width: this.len + "px"
                });
                this.axisTitle[b ? "show" : "hide"](b);
            }
            generateTick(b) {
                const c = this.ticks;
                c[b] ? c[b].addLabel() : c[b] = new E(this, b);
            }
            getOffset() {
                const b = this, { chart: c, horiz: k, options: a, side: f, ticks: l, tickPositions: e, coll: g, axisParent: r } = b, v = c.renderer, F = c.inverted && !b.isZAxis ? [
                    1,
                    0,
                    3,
                    2
                ][f] : f;
                var h = b.hasData();
                const n = a.title;
                var m = a.labels;
                const p = d(a.crossing);
                var q = c.axisOffset;
                const O = c.clipOffset, I = [
                    -1,
                    1,
                    1,
                    -1
                ][f], t = a.className;
                let P, T = 0, u;
                var C = 0;
                let M = 0;
                b.showAxis = P = h || a.showEmpty;
                b.staggerLines = b.horiz && m.staggerLines || void 0;
                if (!b.axisGroup) {
                    const c = (b, c, d)=>v.g(b).attr({
                            zIndex: d
                        }).addClass(`highcharts-${g.toLowerCase()}${c} ` + (this.isRadial ? `highcharts-radial-axis${c} ` : "") + (t || "")).add(r);
                    b.gridGroup = c("grid", "-grid", a.gridZIndex);
                    b.axisGroup = c("axis", "", a.zIndex);
                    b.labelGroup = c("axis-labels", "-labels", m.zIndex);
                }
                h || b.isLinked ? (e.forEach(function(c) {
                    b.generateTick(c);
                }), b.renderUnsquish(), b.reserveSpaceDefault = 0 === f || 2 === f || ({
                    1: "left",
                    3: "right"
                })[f] === b.labelAlign, z(m.reserveSpace, p ? !1 : null, "center" === b.labelAlign ? !0 : null, b.reserveSpaceDefault) && e.forEach(function(b) {
                    M = Math.max(l[b].getLabelSize(), M);
                }), b.staggerLines && (M *= b.staggerLines), b.labelOffset = M * (b.opposite ? -1 : 1)) : w(l, function(b, c) {
                    b.destroy();
                    delete l[c];
                });
                n && n.text && !1 !== n.enabled && (b.addTitle(P), P && !p && !1 !== n.reserveSpace && (b.titleOffset = T = b.axisTitle.getBBox()[k ? "height" : "width"], u = n.offset, C = x(u) ? 0 : z(n.margin, k ? 5 : 10)));
                b.renderLine();
                b.offset = I * z(a.offset, q[f] ? q[f] + (a.margin || 0) : 0);
                b.tickRotCorr = b.tickRotCorr || {
                    x: 0,
                    y: 0
                };
                h = 0 === f ? -b.labelMetrics().h : 2 === f ? b.tickRotCorr.y : 0;
                C = Math.abs(M) + C;
                M && (C = C - h + I * (k ? z(m.y, b.tickRotCorr.y + I * m.distance) : z(m.x, I * m.distance)));
                b.axisTitleMargin = z(u, C);
                b.getMaxLabelDimensions && (b.maxLabelDimensions = b.getMaxLabelDimensions(l, e));
                "colorAxis" !== g && (m = this.tickSize("tick"), q[f] = Math.max(q[f], (b.axisTitleMargin || 0) + T + I * b.offset, C, e && e.length && m ? m[0] + I * b.offset : 0), q = !b.axisLine || a.offset ? 0 : 2 * Math.floor(b.axisLine.strokeWidth() / 2), O[F] = Math.max(O[F], q));
                y(this, "afterGetOffset");
            }
            getLinePath(b) {
                const c = this.chart, d = this.opposite;
                var k = this.offset;
                const a = this.horiz, f = this.left + (d ? this.width : 0) + k;
                k = c.chartHeight - this.bottom - (d ? this.height : 0) + k;
                d && (b *= -1);
                return c.renderer.crispLine([
                    [
                        "M",
                        a ? this.left : f,
                        a ? k : this.top
                    ],
                    [
                        "L",
                        a ? c.chartWidth - this.right : f,
                        a ? k : c.chartHeight - this.bottom
                    ]
                ], b);
            }
            renderLine() {
                this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
                    stroke: this.options.lineColor,
                    "stroke-width": this.options.lineWidth,
                    zIndex: 7
                }));
            }
            getTitlePosition(b) {
                var c = this.horiz, d = this.left;
                const k = this.top;
                var a = this.len;
                const f = this.options.title, l = c ? d : k, e = this.opposite, w = this.offset, g = f.x, r = f.y, z = this.chart.renderer.fontMetrics(b);
                b = b ? Math.max(b.getBBox(!1, 0).height - z.h - 1, 0) : 0;
                a = ({
                    low: l + (c ? 0 : a),
                    middle: l + a / 2,
                    high: l + (c ? a : 0)
                })[f.align];
                d = (c ? k + this.height : d) + (c ? 1 : -1) * (e ? -1 : 1) * (this.axisTitleMargin || 0) + [
                    -b,
                    b,
                    z.f,
                    -b
                ][this.side];
                c = {
                    x: c ? a + g : d + (e ? this.width : 0) + w + g,
                    y: c ? d + r - (e ? this.height : 0) + w : a + r
                };
                y(this, "afterGetTitlePosition", {
                    titlePosition: c
                });
                return c;
            }
            renderMinorTick(b, c) {
                const d = this.minorTicks;
                d[b] || (d[b] = new E(this, b, "minor"));
                c && d[b].isNew && d[b].render(null, !0);
                d[b].render(null, !1, 1);
            }
            renderTick(b, c, d) {
                const k = this.ticks;
                if (!this.isLinked || b >= this.min && b <= this.max || this.grid && this.grid.isColumn) k[b] || (k[b] = new E(this, b)), d && k[b].isNew && k[b].render(c, !0, -1), k[b].render(c);
            }
            render() {
                const b = this, c = b.chart, k = b.logarithmic, a = b.options, f = b.isLinked, l = b.tickPositions, e = b.axisTitle, g = b.ticks, r = b.minorTicks, z = b.alternateBands, v = a.stackLabels, F = a.alternateGridColor;
                var h = a.crossing;
                const n = b.tickmarkOffset, m = b.axisLine, x = b.showAxis, p = t(c.renderer.globalAnimation);
                let q, O;
                b.labelEdge.length = 0;
                b.overlap = !1;
                [
                    g,
                    r,
                    z
                ].forEach(function(b) {
                    w(b, function(b) {
                        b.isActive = !1;
                    });
                });
                if (d(h)) {
                    const d = this.isXAxis ? c.yAxis[0] : c.xAxis[0], k = [
                        1,
                        -1,
                        -1,
                        1
                    ][this.side];
                    d && (h = d.toPixels(h, !0), b.horiz && (h = d.len - h), b.offset = k * h);
                }
                if (b.hasData() || f) {
                    const f = b.chart.hasRendered && b.old && d(b.old.min);
                    b.minorTickInterval && !b.categories && b.getMinorTickPositions().forEach(function(c) {
                        b.renderMinorTick(c, f);
                    });
                    l.length && (l.forEach(function(c, d) {
                        b.renderTick(c, d, f);
                    }), n && (0 === b.min || b.single) && (g[-1] || (g[-1] = new E(b, -1, null, !0)), g[-1].render(-1)));
                    F && l.forEach(function(d, a) {
                        O = "undefined" !== typeof l[a + 1] ? l[a + 1] + n : b.max - n;
                        0 === a % 2 && d < b.max && O <= b.max + (c.polar ? -n : n) && (z[d] || (z[d] = new D.PlotLineOrBand(b)), q = d + n, z[d].options = {
                            from: k ? k.lin2log(q) : q,
                            to: k ? k.lin2log(O) : O,
                            color: F,
                            className: "highcharts-alternate-grid"
                        }, z[d].render(), z[d].isActive = !0);
                    });
                    b._addedPlotLB || (b._addedPlotLB = !0, (a.plotLines || []).concat(a.plotBands || []).forEach(function(c) {
                        b.addPlotBandOrLine(c);
                    }));
                }
                [
                    g,
                    r,
                    z
                ].forEach(function(b) {
                    const d = [], k = p.duration;
                    w(b, function(b, c) {
                        b.isActive || (b.render(c, !1, 0), b.isActive = !1, d.push(c));
                    });
                    T(function() {
                        let c = d.length;
                        for(; c--;)b[d[c]] && !b[d[c]].isActive && (b[d[c]].destroy(), delete b[d[c]]);
                    }, b !== z && c.hasRendered && k ? k : 0);
                });
                m && (m[m.isPlaced ? "animate" : "attr"]({
                    d: this.getLinePath(m.strokeWidth())
                }), m.isPlaced = !0, m[x ? "show" : "hide"](x));
                e && x && (e[e.isNew ? "attr" : "animate"](b.getTitlePosition(e)), e.isNew = !1);
                v && v.enabled && b.stacking && b.stacking.renderStackTotals();
                b.old = {
                    len: b.len,
                    max: b.max,
                    min: b.min,
                    transA: b.transA,
                    userMax: b.userMax,
                    userMin: b.userMin
                };
                b.isDirty = !1;
                y(this, "afterRender");
            }
            redraw() {
                this.visible && (this.render(), this.plotLinesAndBands.forEach(function(b) {
                    b.render();
                }));
                this.series.forEach(function(b) {
                    b.isDirty = !0;
                });
            }
            getKeepProps() {
                return this.keepProps || W.keepProps;
            }
            destroy(b) {
                const c = this, d = c.plotLinesAndBands, k = this.eventOptions;
                y(this, "destroy", {
                    keepEvents: b
                });
                b || O(c);
                [
                    c.ticks,
                    c.minorTicks,
                    c.alternateBands
                ].forEach(function(b) {
                    I(b);
                });
                if (d) for(b = d.length; b--;)d[b].destroy();
                "axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(b) {
                    c[b] && (c[b] = c[b].destroy());
                });
                for(const b in c.plotLinesAndBandsGroups)c.plotLinesAndBandsGroups[b] = c.plotLinesAndBandsGroups[b].destroy();
                w(c, function(b, d) {
                    -1 === c.getKeepProps().indexOf(d) && delete c[d];
                });
                this.eventOptions = k;
            }
            drawCrosshair(b, c) {
                const d = this.crosshair;
                var k = z(d && d.snap, !0);
                const a = this.chart;
                let l, e = this.cross;
                y(this, "drawCrosshair", {
                    e: b,
                    point: c
                });
                b || (b = this.cross && this.cross.e);
                if (d && !1 !== (x(c) || !k)) {
                    k ? x(c) && (l = z("colorAxis" !== this.coll ? c.crosshairPos : null, this.isXAxis ? c.plotX : this.len - c.plotY)) : l = b && (this.horiz ? b.chartX - this.pos : this.len - b.chartY + this.pos);
                    if (x(l)) {
                        var w = {
                            value: c && (this.isXAxis ? c.x : z(c.stackY, c.y)),
                            translatedValue: l
                        };
                        a.polar && f(w, {
                            isCrosshair: !0,
                            chartX: b && b.chartX,
                            chartY: b && b.chartY,
                            point: c
                        });
                        w = this.getPlotLinePath(w) || null;
                    }
                    if (!x(w)) {
                        this.hideCrosshair();
                        return;
                    }
                    k = this.categories && !this.isRadial;
                    e || (this.cross = e = a.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (k ? "category " : "thin ") + (d.className || "")).attr({
                        zIndex: z(d.zIndex, 2)
                    }).add(), a.styledMode || (e.attr({
                        stroke: d.color || (k ? J.parse("#ccd3ff").setOpacity(.25).get() : "#cccccc"),
                        "stroke-width": z(d.width, 1)
                    }).css({
                        "pointer-events": "none"
                    }), d.dashStyle && e.attr({
                        dashstyle: d.dashStyle
                    })));
                    e.show().attr({
                        d: w
                    });
                    k && !d.width && e.attr({
                        "stroke-width": this.transA
                    });
                    this.cross.e = b;
                } else this.hideCrosshair();
                y(this, "afterDrawCrosshair", {
                    e: b,
                    point: c
                });
            }
            hideCrosshair() {
                this.cross && this.cross.hide();
                y(this, "afterHideCrosshair");
            }
            hasVerticalPanning() {
                const b = this.chart.options.chart.panning;
                return !!(b && b.enabled && /y/.test(b.type));
            }
            update(b, d) {
                const k = this.chart;
                b = c(this.userOptions, b);
                this.destroy(!0);
                this.init(k, b);
                k.isDirtyBox = !0;
                z(d, !0) && k.redraw();
            }
            remove(b) {
                const c = this.chart, d = this.coll, k = this.series;
                let a = k.length;
                for(; a--;)k[a] && k[a].remove(!1);
                u(c.axes, this);
                u(c[d] || [], this);
                c.orderItems(d);
                this.destroy();
                c.isDirtyBox = !0;
                z(b, !0) && c.redraw();
            }
            setTitle(b, c) {
                this.update({
                    title: b
                }, c);
            }
            setCategories(b, c) {
                this.update({
                    categories: b
                }, c);
            }
        }
        W.defaultOptions = A.defaultXAxisOptions;
        W.keepProps = "coll extKey hcEvents names series userMax userMin".split(" ");
        "";
        return W;
    });
    L(a, "Core/Axis/DateTimeAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { addEvent: u, getMagnitude: J, normalizeTickInterval: K, timeUnits: G } = a;
        var D;
        (function(E) {
            function B() {
                return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function t(a) {
                "datetime" !== a.userOptions.type ? this.dateTime = void 0 : this.dateTime || (this.dateTime = new m(this));
            }
            const q = [];
            E.compose = function(m) {
                a.pushUnique(q, m) && (m.keepProps.push("dateTime"), m.prototype.getTimeTicks = B, u(m, "init", t));
                return m;
            };
            class m {
                constructor(a){
                    this.axis = a;
                }
                normalizeTimeTickInterval(a, n) {
                    const h = n || [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                2,
                                3,
                                4,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ];
                    n = h[h.length - 1];
                    let g = G[n[0]], e = n[1], m;
                    for(m = 0; m < h.length && !(n = h[m], g = G[n[0]], e = n[1], h[m + 1] && a <= (g * e[e.length - 1] + G[h[m + 1][0]]) / 2); m++);
                    g === G.year && a < 5 * g && (e = [
                        1,
                        2,
                        5
                    ]);
                    a = K(a / g, e, "year" === n[0] ? Math.max(J(a / g), 1) : 1);
                    return {
                        unitRange: g,
                        count: a,
                        unitName: n[0]
                    };
                }
                getXDateFormat(a, n) {
                    const { axis: h } = this, g = h.chart.time;
                    return h.closestPointRange ? g.getDateFormat(h.closestPointRange, a, h.options.startOfWeek, n) || g.resolveDTLFormat(n.year).main : g.resolveDTLFormat(n.day).main;
                }
            }
            E.Additions = m;
        })(D || (D = {}));
        return D;
    });
    L(a, "Core/Axis/LogarithmicAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { addEvent: u, normalizeTickInterval: J, pick: K } = a;
        var G;
        (function(A) {
            function E(a) {
                let m = this.logarithmic;
                "logarithmic" !== a.userOptions.type ? this.logarithmic = void 0 : m || (this.logarithmic = new q(this));
            }
            function B() {
                const a = this.logarithmic;
                a && (this.lin2val = function(m) {
                    return a.lin2log(m);
                }, this.val2lin = function(m) {
                    return a.log2lin(m);
                });
            }
            const t = [];
            A.compose = function(m) {
                a.pushUnique(t, m) && (m.keepProps.push("logarithmic"), u(m, "init", E), u(m, "afterInit", B));
                return m;
            };
            class q {
                constructor(a){
                    this.axis = a;
                }
                getLogTickPositions(a, p, n, h) {
                    const g = this.axis;
                    var e = g.len, m = g.options;
                    let q = [];
                    h || (this.minorAutoInterval = void 0);
                    if (.5 <= a) a = Math.round(a), q = g.getLinearTickPositions(a, p, n);
                    else if (.08 <= a) {
                        m = Math.floor(p);
                        let g, x, f, y, r;
                        for(e = .3 < a ? [
                            1,
                            2,
                            4
                        ] : .15 < a ? [
                            1,
                            2,
                            4,
                            6,
                            8
                        ] : [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ]; m < n + 1 && !r; m++)for(x = e.length, g = 0; g < x && !r; g++)f = this.log2lin(this.lin2log(m) * e[g]), f > p && (!h || y <= n) && "undefined" !== typeof y && q.push(y), y > n && (r = !0), y = f;
                    } else p = this.lin2log(p), n = this.lin2log(n), a = h ? g.getMinorTickInterval() : m.tickInterval, a = K("auto" === a ? null : a, this.minorAutoInterval, m.tickPixelInterval / (h ? 5 : 1) * (n - p) / ((h ? e / g.tickPositions.length : e) || 1)), a = J(a), q = g.getLinearTickPositions(a, p, n).map(this.log2lin), h || (this.minorAutoInterval = a / 5);
                    h || (g.tickInterval = a);
                    return q;
                }
                lin2log(a) {
                    return Math.pow(10, a);
                }
                log2lin(a) {
                    return Math.log(a) / Math.LN10;
                }
            }
            A.Additions = q;
        })(G || (G = {}));
        return G;
    });
    L(a, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { erase: u, extend: J, isNumber: K } = a;
        var G;
        (function(A) {
            function E(a) {
                return this.addPlotBandOrLine(a, "plotBands");
            }
            function B(a, h) {
                const e = this.userOptions;
                let n = new g(this, a);
                this.visible && (n = n.render());
                if (n) {
                    this._addedPlotLB || (this._addedPlotLB = !0, (e.plotLines || []).concat(e.plotBands || []).forEach((a)=>{
                        this.addPlotBandOrLine(a);
                    }));
                    if (h) {
                        const g = e[h] || [];
                        g.push(a);
                        e[h] = g;
                    }
                    this.plotLinesAndBands.push(n);
                }
                return n;
            }
            function t(a) {
                return this.addPlotBandOrLine(a, "plotLines");
            }
            function q(a, g, h = this.options) {
                const e = this.getPlotLinePath({
                    value: g,
                    force: !0,
                    acrossPanes: h.acrossPanes
                }), n = [], f = this.horiz;
                g = !K(this.min) || !K(this.max) || a < this.min && g < this.min || a > this.max && g > this.max;
                a = this.getPlotLinePath({
                    value: a,
                    force: !0,
                    acrossPanes: h.acrossPanes
                });
                h = 1;
                let y;
                if (a && e) for(g && (y = a.toString() === e.toString(), h = 0), g = 0; g < a.length; g += 2){
                    const r = a[g], l = a[g + 1], v = e[g], d = e[g + 1];
                    "M" !== r[0] && "L" !== r[0] || "M" !== l[0] && "L" !== l[0] || "M" !== v[0] && "L" !== v[0] || "M" !== d[0] && "L" !== d[0] || (f && v[1] === r[1] ? (v[1] += h, d[1] += h) : f || v[2] !== r[2] || (v[2] += h, d[2] += h), n.push([
                        "M",
                        r[1],
                        r[2]
                    ], [
                        "L",
                        l[1],
                        l[2]
                    ], [
                        "L",
                        d[1],
                        d[2]
                    ], [
                        "L",
                        v[1],
                        v[2]
                    ], [
                        "Z"
                    ]));
                    n.isFlat = y;
                }
                return n;
            }
            function m(a) {
                this.removePlotBandOrLine(a);
            }
            function p(a) {
                const e = this.plotLinesAndBands, g = this.options, h = this.userOptions;
                if (e) {
                    let n = e.length;
                    for(; n--;)e[n].id === a && e[n].destroy();
                    [
                        g.plotLines || [],
                        h.plotLines || [],
                        g.plotBands || [],
                        h.plotBands || []
                    ].forEach(function(f) {
                        for(n = f.length; n--;)(f[n] || {}).id === a && u(f, f[n]);
                    });
                }
            }
            function n(a) {
                this.removePlotBandOrLine(a);
            }
            const h = [];
            let g;
            A.compose = function(e, x) {
                g || (g = e);
                a.pushUnique(h, x) && J(x.prototype, {
                    addPlotBand: E,
                    addPlotLine: t,
                    addPlotBandOrLine: B,
                    getPlotBandPath: q,
                    removePlotBand: m,
                    removePlotLine: n,
                    removePlotBandOrLine: p
                });
                return x;
            };
        })(G || (G = {}));
        return G;
    });
    L(a, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [
        a["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        const { arrayMax: u, arrayMin: K, defined: G, destroyObjectProperties: D, erase: E, fireEvent: B, merge: t, objectEach: q, pick: m } = A;
        class p {
            static compose(n) {
                return a.compose(p, n);
            }
            constructor(a, h){
                this.axis = a;
                h && (this.options = h, this.id = h.id);
            }
            render() {
                B(this, "render");
                const a = this, h = a.axis, g = h.horiz;
                var e = h.logarithmic;
                const x = a.options, p = x.color, u = m(x.zIndex, 0), C = x.events, f = {}, y = h.chart.renderer;
                let r = x.label, l = a.label, v = x.to, d = x.from, b = x.value, c = a.svgElem;
                var k = [];
                const w = G(d) && G(v);
                k = G(b);
                const z = !c, F = {
                    "class": "highcharts-plot-" + (w ? "band " : "line ") + (x.className || "")
                };
                let O = w ? "bands" : "lines";
                e && (d = e.log2lin(d), v = e.log2lin(v), b = e.log2lin(b));
                h.chart.styledMode || (k ? (F.stroke = p || "#999999", F["stroke-width"] = m(x.width, 1), x.dashStyle && (F.dashstyle = x.dashStyle)) : w && (F.fill = p || "#e6e9ff", x.borderWidth && (F.stroke = x.borderColor, F["stroke-width"] = x.borderWidth)));
                f.zIndex = u;
                O += "-" + u;
                (e = h.plotLinesAndBandsGroups[O]) || (h.plotLinesAndBandsGroups[O] = e = y.g("plot-" + O).attr(f).add());
                z && (a.svgElem = c = y.path().attr(F).add(e));
                if (k) k = h.getPlotLinePath({
                    value: b,
                    lineWidth: c.strokeWidth(),
                    acrossPanes: x.acrossPanes
                });
                else if (w) k = h.getPlotBandPath(d, v, x);
                else return;
                !a.eventsAdded && C && (q(C, function(b, d) {
                    c.on(d, function(b) {
                        C[d].apply(a, [
                            b
                        ]);
                    });
                }), a.eventsAdded = !0);
                (z || !c.d) && k && k.length ? c.attr({
                    d: k
                }) : c && (k ? (c.show(), c.animate({
                    d: k
                })) : c.d && (c.hide(), l && (a.label = l = l.destroy())));
                r && (G(r.text) || G(r.formatter)) && k && k.length && 0 < h.width && 0 < h.height && !k.isFlat ? (r = t({
                    align: g && w && "center",
                    x: g ? !w && 4 : 10,
                    verticalAlign: !g && w && "middle",
                    y: g ? w ? 16 : 10 : w ? 6 : -4,
                    rotation: g && !w && 90
                }, r), this.renderLabel(r, k, w, u)) : l && l.hide();
                return a;
            }
            renderLabel(a, h, g, e) {
                const n = this.axis;
                var m = n.chart.renderer;
                let p = this.label;
                p || (this.label = p = m.text(this.getLabelText(a), 0, 0, a.useHTML).attr({
                    align: a.textAlign || a.align,
                    rotation: a.rotation,
                    "class": "highcharts-plot-" + (g ? "band" : "line") + "-label " + (a.className || ""),
                    zIndex: e
                }).add(), n.chart.styledMode || p.css(t({
                    fontSize: "0.8em",
                    textOverflow: "ellipsis"
                }, a.style)));
                e = h.xBounds || [
                    h[0][1],
                    h[1][1],
                    g ? h[2][1] : h[0][1]
                ];
                h = h.yBounds || [
                    h[0][2],
                    h[1][2],
                    g ? h[2][2] : h[0][2]
                ];
                g = K(e);
                m = K(h);
                p.align(a, !1, {
                    x: g,
                    y: m,
                    width: u(e) - g,
                    height: u(h) - m
                });
                p.alignValue && "left" !== p.alignValue || (a = a.clip ? n.width : n.chart.chartWidth, p.css({
                    width: (90 === p.rotation ? n.height - (p.alignAttr.y - n.top) : a - (p.alignAttr.x - n.left)) + "px"
                }));
                p.show(!0);
            }
            getLabelText(a) {
                return G(a.formatter) ? a.formatter.call(this) : a.text;
            }
            destroy() {
                E(this.axis.plotLinesAndBands, this);
                delete this.axis;
                D(this);
            }
        }
        "";
        "";
        return p;
    });
    L(a, "Core/Tooltip.js", [
        a["Core/Templating.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G) {
        const { format: u } = a, { doc: E, isSafari: B } = A, { distribute: t } = J, { addEvent: q, clamp: m, css: p, discardElement: n, extend: h, fireEvent: g, isArray: e, isNumber: x, isString: I, merge: M, pick: C, splat: f, syncTimeout: y } = G;
        class r {
            constructor(a, f){
                this.allowShared = !0;
                this.container = void 0;
                this.crosshairs = [];
                this.distance = 0;
                this.isHidden = !0;
                this.isSticky = !1;
                this.now = {};
                this.options = {};
                this.outside = !1;
                this.chart = a;
                this.init(a, f);
            }
            bodyFormatter(a) {
                return a.map(function(a) {
                    const d = a.series.tooltipOptions;
                    return (d[(a.point.formatPrefix || "point") + "Formatter"] || a.point.tooltipFormatter).call(a.point, d[(a.point.formatPrefix || "point") + "Format"] || "");
                });
            }
            cleanSplit(a) {
                this.chart.series.forEach(function(f) {
                    const d = f && f.tt;
                    d && (!d.isActive || a ? f.tt = d.destroy() : d.isActive = !1);
                });
            }
            defaultFormatter(a) {
                const l = this.points || f(this);
                let d;
                d = [
                    a.tooltipFooterHeaderFormatter(l[0])
                ];
                d = d.concat(a.bodyFormatter(l));
                d.push(a.tooltipFooterHeaderFormatter(l[0], !0));
                return d;
            }
            destroy() {
                this.label && (this.label = this.label.destroy());
                this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy()));
                this.renderer && (this.renderer = this.renderer.destroy(), n(this.container));
                G.clearTimeout(this.hideTimer);
                G.clearTimeout(this.tooltipTimeout);
            }
            getAnchor(a, e) {
                var d = this.chart;
                const b = d.pointer, c = d.inverted, k = d.plotTop;
                d = d.plotLeft;
                a = f(a);
                a[0].series && a[0].series.yAxis && !a[0].series.yAxis.options.reversedStacks && (a = a.slice().reverse());
                if (this.followPointer && e) "undefined" === typeof e.chartX && (e = b.normalize(e)), a = [
                    e.chartX - d,
                    e.chartY - k
                ];
                else if (a[0].tooltipPos) a = a[0].tooltipPos;
                else {
                    let b = 0, f = 0;
                    a.forEach(function(c) {
                        if (c = c.pos(!0)) b += c[0], f += c[1];
                    });
                    b /= a.length;
                    f /= a.length;
                    this.shared && 1 < a.length && e && (c ? b = e.chartX : f = e.chartY);
                    a = [
                        b - d,
                        f - k
                    ];
                }
                return a.map(Math.round);
            }
            getClassName(a, f, d) {
                const b = a.series, c = b.options;
                return [
                    this.options.className,
                    "highcharts-label",
                    d && "highcharts-tooltip-header",
                    f ? "highcharts-tooltip-box" : "highcharts-tooltip",
                    !d && "highcharts-color-" + C(a.colorIndex, b.colorIndex),
                    c && c.className
                ].filter(I).join(" ");
            }
            getLabel() {
                const a = this, f = this.chart.styledMode, d = this.options, b = this.split && this.allowShared, c = d.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none");
                let k, e = this.chart.renderer;
                if (this.label) {
                    var g = !this.label.hasClass("highcharts-label");
                    (!b && g || b && !g) && this.destroy();
                }
                if (!this.label) {
                    if (this.outside) {
                        g = this.chart.options.chart.style;
                        const b = K.getRendererType();
                        this.container = k = A.doc.createElement("div");
                        k.className = "highcharts-tooltip-container";
                        p(k, {
                            position: "absolute",
                            top: "1px",
                            pointerEvents: c,
                            zIndex: Math.max(this.options.style.zIndex || 0, (g && g.zIndex || 0) + 3)
                        });
                        A.doc.body.appendChild(k);
                        this.renderer = e = new b(k, 0, 0, g, void 0, void 0, e.styledMode);
                    }
                    b ? this.label = e.g("tooltip") : (this.label = e.label("", 0, 0, d.shape, void 0, void 0, d.useHTML, void 0, "tooltip").attr({
                        padding: d.padding,
                        r: d.borderRadius
                    }), f || this.label.attr({
                        fill: d.backgroundColor,
                        "stroke-width": d.borderWidth || 0
                    }).css(d.style).css({
                        pointerEvents: c
                    }));
                    if (a.outside) {
                        const b = this.label, { xSetter: c, ySetter: d } = b;
                        b.xSetter = function(d) {
                            c.call(b, a.distance);
                            k.style.left = d + "px";
                        };
                        b.ySetter = function(c) {
                            d.call(b, a.distance);
                            k.style.top = c + "px";
                        };
                    }
                    this.label.attr({
                        zIndex: 8
                    }).shadow(d.shadow).add();
                }
                return this.label;
            }
            getPlayingField() {
                const { body: a, documentElement: f } = E, { chart: d, distance: b, outside: c } = this;
                return {
                    width: c ? Math.max(a.scrollWidth, f.scrollWidth, a.offsetWidth, f.offsetWidth, f.clientWidth) - 2 * b : d.chartWidth,
                    height: c ? Math.max(a.scrollHeight, f.scrollHeight, a.offsetHeight, f.offsetHeight, f.clientHeight) : d.chartHeight
                };
            }
            getPosition(a, f, d) {
                const b = this.chart, c = this.distance, k = {}, l = b.inverted && d.h || 0, e = this.outside;
                var g = this.getPlayingField();
                const r = g.width, h = g.height, v = b.pointer.getChartPosition();
                g = (k)=>{
                    const l = "x" === k;
                    return [
                        k,
                        l ? r : h,
                        l ? a : f
                    ].concat(e ? [
                        l ? a * v.scaleX : f * v.scaleY,
                        l ? v.left - c + (d.plotX + b.plotLeft) * v.scaleX : v.top - c + (d.plotY + b.plotTop) * v.scaleY,
                        0,
                        l ? r : h
                    ] : [
                        l ? a : f,
                        l ? d.plotX + b.plotLeft : d.plotY + b.plotTop,
                        l ? b.plotLeft : b.plotTop,
                        l ? b.plotLeft + b.plotWidth : b.plotTop + b.plotHeight
                    ]);
                };
                let y = g("y"), n = g("x"), m;
                g = !!d.negative;
                !b.polar && b.hoverSeries && b.hoverSeries.yAxis && b.hoverSeries.yAxis.reversed && (g = !g);
                const p = !this.followPointer && C(d.ttBelow, !b.inverted === g), x = function(b, d, a, f, w, g, r) {
                    const z = e ? "y" === b ? c * v.scaleY : c * v.scaleX : c, h = (a - f) / 2, F = f < w - c, y = w + c + f < d, n = w - z - a + h;
                    w = w + z - h;
                    if (p && y) k[b] = w;
                    else if (!p && F) k[b] = n;
                    else if (F) k[b] = Math.min(r - f, 0 > n - l ? n : n - l);
                    else if (y) k[b] = Math.max(g, w + l + a > d ? w : w + l);
                    else return !1;
                }, q = function(b, d, a, f, l) {
                    let e;
                    l < c || l > d - c ? e = !1 : k[b] = l < a / 2 ? 1 : l > d - f / 2 ? d - f - 2 : l - a / 2;
                    return e;
                }, t = function(b) {
                    const c = y;
                    y = n;
                    n = c;
                    m = b;
                }, N = function() {
                    !1 !== x.apply(0, y) ? !1 !== q.apply(0, n) || m || (t(!0), N()) : m ? k.x = k.y = 0 : (t(!0), N());
                };
                (b.inverted || 1 < this.len) && t();
                N();
                return k;
            }
            hide(a) {
                const f = this;
                G.clearTimeout(this.hideTimer);
                a = C(a, this.options.hideDelay);
                this.isHidden || (this.hideTimer = y(function() {
                    f.getLabel().fadeOut(a ? void 0 : a);
                    f.isHidden = !0;
                }, a));
            }
            init(a, f) {
                this.chart = a;
                this.options = f;
                this.crosshairs = [];
                this.now = {
                    x: 0,
                    y: 0
                };
                this.isHidden = !0;
                this.split = f.split && !a.inverted && !a.polar;
                this.shared = f.shared || this.split;
                this.outside = C(f.outside, !(!a.scrollablePixelsX && !a.scrollablePixelsY));
            }
            shouldStickOnContact(a) {
                return !(this.followPointer || !this.options.stickOnContact || a && !this.chart.pointer.inClass(a.target, "highcharts-tooltip"));
            }
            move(a, f, d, b) {
                const c = this, k = c.now, l = !1 !== c.options.animation && !c.isHidden && (1 < Math.abs(a - k.x) || 1 < Math.abs(f - k.y)), e = c.followPointer || 1 < c.len;
                h(k, {
                    x: l ? (2 * k.x + a) / 3 : a,
                    y: l ? (k.y + f) / 2 : f,
                    anchorX: e ? void 0 : l ? (2 * k.anchorX + d) / 3 : d,
                    anchorY: e ? void 0 : l ? (k.anchorY + b) / 2 : b
                });
                c.getLabel().attr(k);
                c.drawTracker();
                l && (G.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function() {
                    c && c.move(a, f, d, b);
                }, 32));
            }
            refresh(a, r) {
                const d = this.chart, b = this.options, c = d.pointer, k = f(a), l = k[0], z = [];
                var h = b.format, y = b.formatter || this.defaultFormatter;
                const n = this.shared, v = d.styledMode;
                let m = {};
                if (b.enabled && l.series) {
                    G.clearTimeout(this.hideTimer);
                    this.allowShared = !(!e(a) && a.series && a.series.noSharedTooltip);
                    this.followPointer = !this.split && l.series.tooltipOptions.followPointer;
                    a = this.getAnchor(a, r);
                    var p = a[0], x = a[1];
                    n && this.allowShared ? (c.applyInactiveState(k), k.forEach(function(b) {
                        b.setState("hover");
                        z.push(b.getLabelConfig());
                    }), m = l.getLabelConfig(), m.points = z) : m = l.getLabelConfig();
                    this.len = z.length;
                    h = I(h) ? u(h, m, d) : y.call(m, this);
                    y = l.series;
                    this.distance = C(y.tooltipOptions.distance, 16);
                    if (!1 === h) this.hide();
                    else {
                        if (this.split && this.allowShared) this.renderSplit(h, k);
                        else {
                            let f = p, e = x;
                            r && c.isDirectTouch && (f = r.chartX - d.plotLeft, e = r.chartY - d.plotTop);
                            if (d.polar || !1 === y.options.clip || k.some((b)=>c.isDirectTouch || b.series.shouldShowTooltip(f, e))) r = this.getLabel(), b.style.width && !v || r.css({
                                width: (this.outside ? this.getPlayingField() : d.spacingBox).width + "px"
                            }), r.attr({
                                text: h && h.join ? h.join("") : h
                            }), r.addClass(this.getClassName(l), !0), v || r.attr({
                                stroke: b.borderColor || l.color || y.color || "#666666"
                            }), this.updatePosition({
                                plotX: p,
                                plotY: x,
                                negative: l.negative,
                                ttBelow: l.ttBelow,
                                h: a[2] || 0
                            });
                            else {
                                this.hide();
                                return;
                            }
                        }
                        this.isHidden && this.label && this.label.attr({
                            opacity: 1
                        }).show();
                        this.isHidden = !1;
                    }
                    g(this, "refresh");
                }
            }
            renderSplit(a, f) {
                function d(c, d, a, k, f = !0) {
                    a ? (d = R ? 0 : J, c = m(c - k / 2, N.left, N.right - k - (b.outside ? V : 0))) : (d -= D, c = f ? c - k - u : c + u, c = m(c, f ? c : N.left, N.right));
                    return {
                        x: c,
                        y: d
                    };
                }
                const b = this, { chart: c, chart: { chartWidth: k, chartHeight: l, plotHeight: e, plotLeft: g, plotTop: r, pointer: y, scrollablePixelsY: n = 0, scrollablePixelsX: v, scrollingContainer: { scrollLeft: p, scrollTop: x } = {
                    scrollLeft: 0,
                    scrollTop: 0
                }, styledMode: q }, distance: u, options: M, options: { positioner: A } } = b, N = b.outside && "number" !== typeof v ? E.documentElement.getBoundingClientRect() : {
                    left: p,
                    right: p + k,
                    top: x,
                    bottom: x + l
                }, X = b.getLabel(), Q = this.renderer || c.renderer, R = !(!c.xAxis[0] || !c.xAxis[0].opposite), { left: V, top: G } = y.getChartPosition();
                let D = r + x, K = 0, J = e - n;
                I(a) && (a = [
                    !1,
                    a
                ]);
                a = a.slice(0, f.length + 1).reduce(function(c, a, k) {
                    if (!1 !== a && "" !== a) {
                        k = f[k - 1] || {
                            isHeader: !0,
                            plotX: f[0].plotX,
                            plotY: e,
                            series: {}
                        };
                        const n = k.isHeader;
                        var l = n ? b : k.series, w;
                        {
                            var h = k;
                            a = a.toString();
                            var z = l.tt;
                            const { isHeader: c, series: d } = h;
                            z || (z = {
                                padding: M.padding,
                                r: M.borderRadius
                            }, q || (z.fill = M.backgroundColor, z["stroke-width"] = null !== (w = M.borderWidth) && void 0 !== w ? w : 1), z = Q.label("", 0, 0, M[c ? "headerShape" : "shape"], void 0, void 0, M.useHTML).addClass(b.getClassName(h, !0, c)).attr(z).add(X));
                            z.isActive = !0;
                            z.attr({
                                text: a
                            });
                            q || z.css(M.style).attr({
                                stroke: M.borderColor || h.color || d.color || "#333333"
                            });
                            w = z;
                        }
                        w = l.tt = w;
                        h = w.getBBox();
                        l = h.width + w.strokeWidth();
                        n && (K = h.height, J += K, R && (D -= K));
                        {
                            const { isHeader: b, plotX: c = 0, plotY: d = 0, series: f } = k;
                            if (b) {
                                a = g + c;
                                var y = r + e / 2;
                            } else {
                                const { xAxis: b, yAxis: k } = f;
                                a = b.pos + m(c, -u, b.len + u);
                                f.shouldShowTooltip(0, k.pos - r + d, {
                                    ignoreX: !0
                                }) && (y = k.pos + d);
                            }
                            a = m(a, N.left - u, N.right + u);
                            y = {
                                anchorX: a,
                                anchorY: y
                            };
                        }
                        const { anchorX: v, anchorY: F } = y;
                        "number" === typeof F ? (y = h.height + 1, h = A ? A.call(b, l, y, k) : d(v, F, n, l), c.push({
                            align: A ? 0 : void 0,
                            anchorX: v,
                            anchorY: F,
                            boxWidth: l,
                            point: k,
                            rank: C(h.rank, n ? 1 : 0),
                            size: y,
                            target: h.y,
                            tt: w,
                            x: h.x
                        })) : w.isActive = !1;
                    }
                    return c;
                }, []);
                !A && a.some((c)=>{
                    var { outside: d } = b;
                    d = (d ? V : 0) + c.anchorX;
                    return d < N.left && d + c.boxWidth < N.right ? !0 : d < V - N.left + c.boxWidth && N.right - d > d;
                }) && (a = a.map((b)=>{
                    const { x: c, y: a } = d(b.anchorX, b.anchorY, b.point.isHeader, b.boxWidth, !1);
                    return h(b, {
                        target: a,
                        x: c
                    });
                }));
                b.cleanSplit();
                t(a, J);
                var ba = V, L = V;
                a.forEach(function(c) {
                    const { x: d, boxWidth: a, isHeader: k } = c;
                    k || (b.outside && V + d < ba && (ba = V + d), !k && b.outside && ba + a > L && (L = V + d));
                });
                a.forEach(function(c) {
                    const { x: d, anchorX: a, anchorY: k, pos: f, point: { isHeader: l } } = c, e = {
                        visibility: "undefined" === typeof f ? "hidden" : "inherit",
                        x: d,
                        y: (f || 0) + D,
                        anchorX: a,
                        anchorY: k
                    };
                    if (b.outside && d < a) {
                        const b = V - ba;
                        0 < b && (l || (e.x = d + b, e.anchorX = a + b), l && (e.x = (L - ba) / 2, e.anchorX = a + b));
                    }
                    c.tt.attr(e);
                });
                const { container: fa, outside: ca, renderer: ka } = b;
                if (ca && fa && ka) {
                    const { width: b, height: c, x: d, y: a } = X.getBBox();
                    ka.setSize(b + d, c + a, !1);
                    fa.style.left = ba + "px";
                    fa.style.top = G + "px";
                }
                B && X.attr({
                    opacity: 1 === X.opacity ? .999 : 1
                });
            }
            drawTracker() {
                if (this.shouldStickOnContact()) {
                    var a = this.chart, f = this.label, d = this.shared ? a.hoverPoints : a.hoverPoint;
                    if (f && d) {
                        var b = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        };
                        d = this.getAnchor(d);
                        var c = f.getBBox();
                        d[0] += a.plotLeft - f.translateX;
                        d[1] += a.plotTop - f.translateY;
                        b.x = Math.min(0, d[0]);
                        b.y = Math.min(0, d[1]);
                        b.width = 0 > d[0] ? Math.max(Math.abs(d[0]), c.width - d[0]) : Math.max(Math.abs(d[0]), c.width);
                        b.height = 0 > d[1] ? Math.max(Math.abs(d[1]), c.height - Math.abs(d[1])) : Math.max(Math.abs(d[1]), c.height);
                        this.tracker ? this.tracker.attr(b) : (this.tracker = f.renderer.rect(b).addClass("highcharts-tracker").add(f), a.styledMode || this.tracker.attr({
                            fill: "rgba(0,0,0,0)"
                        }));
                    }
                } else this.tracker && (this.tracker = this.tracker.destroy());
            }
            styledModeFormat(a) {
                return a.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
            }
            tooltipFooterHeaderFormatter(a, f) {
                const d = a.series, b = d.tooltipOptions;
                var c = d.xAxis;
                const k = c && c.dateTime;
                c = {
                    isFooter: f,
                    labelConfig: a
                };
                let l = b.xDateFormat, e = b[f ? "footerFormat" : "headerFormat"];
                g(this, "headerFormatter", c, function(c) {
                    k && !l && x(a.key) && (l = k.getXDateFormat(a.key, b.dateTimeLabelFormats));
                    k && l && (a.point && a.point.tooltipDateKeys || [
                        "key"
                    ]).forEach(function(b) {
                        e = e.replace("{point." + b + "}", "{point." + b + ":" + l + "}");
                    });
                    d.chart.styledMode && (e = this.styledModeFormat(e));
                    c.text = u(e, {
                        point: a,
                        series: d
                    }, this.chart);
                });
                return c.text;
            }
            update(a) {
                this.destroy();
                this.init(this.chart, M(!0, this.options, a));
            }
            updatePosition(a) {
                const { chart: f, distance: d, options: b } = this;
                var c = f.pointer;
                const k = this.getLabel(), { left: l, top: e, scaleX: g, scaleY: r } = c.getChartPosition();
                c = (b.positioner || this.getPosition).call(this, k.width, k.height, a);
                let h = (a.plotX || 0) + f.plotLeft;
                a = (a.plotY || 0) + f.plotTop;
                let y;
                if (this.outside) {
                    b.positioner && (c.x += l - d, c.y += e - d);
                    y = (b.borderWidth || 0) + 2 * d;
                    this.renderer.setSize(k.width + y, k.height + y, !1);
                    if (1 !== g || 1 !== r) p(this.container, {
                        transform: `scale(${g}, ${r})`
                    }), h *= g, a *= r;
                    h += l - c.x;
                    a += e - c.y;
                }
                this.move(Math.round(c.x), Math.round(c.y || 0), h, a);
            }
        }
        (function(a) {
            const f = [];
            a.compose = function(d) {
                G.pushUnique(f, d) && q(d, "afterInit", function() {
                    const b = this.chart;
                    b.options.tooltip && (b.tooltip = new a(b, b.options.tooltip));
                });
            };
        })(r || (r = {}));
        "";
        return r;
    });
    L(a, "Core/Series/Point.js", [
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Defaults.js"],
        a["Core/Templating.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G) {
        const { animObject: u } = A, { defaultOptions: E } = J, { format: B } = K, { addEvent: t, defined: q, erase: m, extend: p, fireEvent: n, getNestedProperty: h, isArray: g, isFunction: e, isNumber: x, isObject: I, merge: M, objectEach: C, pick: f, syncTimeout: y, removeEvent: r, uniqueKey: l } = G;
        class v {
            constructor(){
                this.category = void 0;
                this.destroyed = !1;
                this.formatPrefix = "point";
                this.id = void 0;
                this.isNull = !1;
                this.percentage = this.options = this.name = void 0;
                this.selected = !1;
                this.total = this.shapeArgs = this.series = void 0;
                this.visible = !0;
                this.x = void 0;
            }
            animateBeforeDestroy() {
                const d = this, b = {
                    x: d.startXPos,
                    opacity: 0
                }, c = d.getGraphicalProps();
                c.singular.forEach(function(c) {
                    d[c] = d[c].animate("dataLabel" === c ? {
                        x: d[c].startXPos,
                        y: d[c].startYPos,
                        opacity: 0
                    } : b);
                });
                c.plural.forEach(function(b) {
                    d[b].forEach(function(b) {
                        b.element && b.animate(p({
                            x: d.startXPos
                        }, b.startYPos ? {
                            x: b.startXPos,
                            y: b.startYPos
                        } : {}));
                    });
                });
            }
            applyOptions(d, b) {
                const c = this.series, a = c.options.pointValKey || c.pointValKey;
                d = v.prototype.optionsToObject.call(this, d);
                p(this, d);
                this.options = this.options ? p(this.options, d) : d;
                d.group && delete this.group;
                d.dataLabels && delete this.dataLabels;
                a && (this.y = v.prototype.getNestedProperty.call(this, a));
                this.formatPrefix = (this.isNull = this.isValid && !this.isValid()) ? "null" : "point";
                this.selected && (this.state = "select");
                "name" in this && "undefined" === typeof b && c.xAxis && c.xAxis.hasNames && (this.x = c.xAxis.nameToX(this));
                "undefined" === typeof this.x && c ? this.x = "undefined" === typeof b ? c.autoIncrement() : b : x(d.x) && c.options.relativeXValue && (this.x = c.autoIncrement(d.x));
                return this;
            }
            destroy() {
                if (!this.destroyed) {
                    const b = this;
                    var d = b.series;
                    const c = d.chart;
                    d = d.options.dataSorting;
                    const a = c.hoverPoints, f = u(b.series.chart.renderer.globalAnimation), l = ()=>{
                        if (b.graphic || b.graphics || b.dataLabel || b.dataLabels) r(b), b.destroyElements();
                        for(const c in b)delete b[c];
                    };
                    b.legendItem && c.legend.destroyItem(b);
                    a && (b.setState(), m(a, b), a.length || (c.hoverPoints = null));
                    if (b === c.hoverPoint) b.onMouseOut();
                    d && d.enabled ? (this.animateBeforeDestroy(), y(l, f.duration)) : l();
                    c.pointCount--;
                }
                this.destroyed = !0;
            }
            destroyElements(d) {
                const b = this;
                d = b.getGraphicalProps(d);
                d.singular.forEach(function(c) {
                    b[c] = b[c].destroy();
                });
                d.plural.forEach(function(c) {
                    b[c].forEach(function(b) {
                        b && b.element && b.destroy();
                    });
                    delete b[c];
                });
            }
            firePointEvent(d, b, c) {
                const a = this, f = this.series.options;
                (f.point.events[d] || a.options && a.options.events && a.options.events[d]) && a.importEvents();
                "click" === d && f.allowPointSelect && (c = function(b) {
                    a.select && a.select(null, b.ctrlKey || b.metaKey || b.shiftKey);
                });
                n(a, d, b, c);
            }
            getClassName() {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + ("undefined" !== typeof this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            }
            getGraphicalProps(d) {
                const b = this, c = [], a = {
                    singular: [],
                    plural: []
                };
                let f, l;
                d = d || {
                    graphic: 1,
                    dataLabel: 1
                };
                d.graphic && c.push("graphic");
                d.dataLabel && c.push("dataLabel", "dataLabelPath", "dataLabelUpper", "connector");
                for(l = c.length; l--;)f = c[l], b[f] && a.singular.push(f);
                [
                    "graphic",
                    "dataLabel",
                    "connector"
                ].forEach(function(c) {
                    const k = c + "s";
                    d[c] && b[k] && a.plural.push(k);
                });
                return a;
            }
            getLabelConfig() {
                return {
                    x: this.category,
                    y: this.y,
                    color: this.color,
                    colorIndex: this.colorIndex,
                    key: this.name || this.category,
                    series: this.series,
                    point: this,
                    percentage: this.percentage,
                    total: this.total || this.stackTotal
                };
            }
            getNestedProperty(d) {
                if (d) return 0 === d.indexOf("custom.") ? h(d, this.options) : this[d];
            }
            getZone() {
                var d = this.series;
                const b = d.zones;
                d = d.zoneAxis || "y";
                let c, a = 0;
                for(c = b[a]; this[d] >= c.value;)c = b[++a];
                this.nonZonedColor || (this.nonZonedColor = this.color);
                this.color = c && c.color && !this.options.color ? c.color : this.nonZonedColor;
                return c;
            }
            hasNewShapeType() {
                return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
            }
            init(d, b, c) {
                this.series = d;
                this.applyOptions(b, c);
                this.id = q(this.id) ? this.id : l();
                this.resolveColor();
                d.chart.pointCount++;
                n(this, "afterInit");
                return this;
            }
            isValid() {
                return null !== this.x && x(this.y);
            }
            optionsToObject(d) {
                var b = this.series;
                const c = b.options.keys, a = c || b.pointArrayMap || [
                    "y"
                ], f = a.length;
                let l = {}, e = 0, r = 0;
                if (x(d) || null === d) l[a[0]] = d;
                else if (g(d)) for(!c && d.length > f && (b = typeof d[0], "string" === b ? l.name = d[0] : "number" === b && (l.x = d[0]), e++); r < f;)c && "undefined" === typeof d[e] || (0 < a[r].indexOf(".") ? v.prototype.setNestedProperty(l, d[e], a[r]) : l[a[r]] = d[e]), e++, r++;
                else "object" === typeof d && (l = d, d.dataLabels && (b._hasPointLabels = !0), d.marker && (b._hasPointMarkers = !0));
                return l;
            }
            pos(d, b = this.plotY) {
                if (!this.destroyed) {
                    const { plotX: c, series: a } = this, { chart: f, xAxis: l, yAxis: e } = a;
                    let g = 0, r = 0;
                    if (x(c) && x(b)) return d && (g = l ? l.pos : f.plotLeft, r = e ? e.pos : f.plotTop), f.inverted && l && e ? [
                        e.len - b + r,
                        l.len - c + g
                    ] : [
                        c + g,
                        b + r
                    ];
                }
            }
            resolveColor() {
                const d = this.series;
                var b = d.chart.styledMode;
                let c;
                var a = d.chart.options.chart.colorCount;
                delete this.nonZonedColor;
                d.options.colorByPoint ? (b || (a = d.options.colors || d.chart.options.colors, c = a[d.colorCounter], a = a.length), b = d.colorCounter, d.colorCounter++, d.colorCounter === a && (d.colorCounter = 0)) : (b || (c = d.color), b = d.colorIndex);
                this.colorIndex = f(this.options.colorIndex, b);
                this.color = f(this.options.color, c);
            }
            setNestedProperty(d, b, c) {
                c.split(".").reduce(function(c, d, a, f) {
                    c[d] = f.length - 1 === a ? b : I(c[d], !0) ? c[d] : {};
                    return c[d];
                }, d);
                return d;
            }
            shouldDraw() {
                return !this.isNull;
            }
            tooltipFormatter(d) {
                const b = this.series, c = b.tooltipOptions, a = f(c.valueDecimals, ""), l = c.valuePrefix || "", e = c.valueSuffix || "";
                b.chart.styledMode && (d = b.chart.tooltip.styledModeFormat(d));
                (b.pointArrayMap || [
                    "y"
                ]).forEach(function(b) {
                    b = "{point." + b;
                    if (l || e) d = d.replace(RegExp(b + "}", "g"), l + b + "}" + e);
                    d = d.replace(RegExp(b + "}", "g"), b + ":,." + a + "f}");
                });
                return B(d, {
                    point: this,
                    series: this.series
                }, b.chart);
            }
            update(d, b, c, a) {
                function k() {
                    l.applyOptions(d);
                    var a = g && l.hasMockGraphic;
                    a = null === l.y ? !a : a;
                    g && a && (l.graphic = g.destroy(), delete l.hasMockGraphic);
                    I(d, !0) && (g && g.element && d && d.marker && "undefined" !== typeof d.marker.symbol && (l.graphic = g.destroy()), d && d.dataLabels && l.dataLabel && (l.dataLabel = l.dataLabel.destroy()), l.connector && (l.connector = l.connector.destroy()));
                    y = l.index;
                    e.updateParallelArrays(l, y);
                    h.data[y] = I(h.data[y], !0) || I(d, !0) ? l.options : f(d, h.data[y]);
                    e.isDirty = e.isDirtyData = !0;
                    !e.fixedBox && e.hasCartesianSeries && (r.isDirtyBox = !0);
                    "point" === h.legendType && (r.isDirtyLegend = !0);
                    b && r.redraw(c);
                }
                const l = this, e = l.series, g = l.graphic, r = e.chart, h = e.options;
                let y;
                b = f(b, !0);
                !1 === a ? k() : l.firePointEvent("update", {
                    options: d
                }, k);
            }
            remove(d, b) {
                this.series.removePoint(this.series.data.indexOf(this), d, b);
            }
            select(d, b) {
                const c = this, a = c.series, l = a.chart;
                this.selectedStaging = d = f(d, !c.selected);
                c.firePointEvent(d ? "select" : "unselect", {
                    accumulate: b
                }, function() {
                    c.selected = c.options.selected = d;
                    a.options.data[a.data.indexOf(c)] = c.options;
                    c.setState(d && "select");
                    b || l.getSelectedPoints().forEach(function(b) {
                        const d = b.series;
                        b.selected && b !== c && (b.selected = b.options.selected = !1, d.options.data[d.data.indexOf(b)] = b.options, b.setState(l.hoverPoints && d.options.inactiveOtherPoints ? "inactive" : ""), b.firePointEvent("unselect"));
                    });
                });
                delete this.selectedStaging;
            }
            onMouseOver(d) {
                const b = this.series.chart, c = b.pointer;
                d = d ? c.normalize(d) : c.getChartCoordinatesFromPoint(this, b.inverted);
                c.runPointActions(d, this);
            }
            onMouseOut() {
                const d = this.series.chart;
                this.firePointEvent("mouseOut");
                this.series.options.inactiveOtherPoints || (d.hoverPoints || []).forEach(function(b) {
                    b.setState();
                });
                d.hoverPoints = d.hoverPoint = null;
            }
            importEvents() {
                if (!this.hasImportedEvents) {
                    const d = this, b = M(d.series.options.point, d.options).events;
                    d.events = b;
                    C(b, function(b, a) {
                        e(b) && t(d, a, b);
                    });
                    this.hasImportedEvents = !0;
                }
            }
            setState(d, b) {
                const c = this.series;
                var k = this.state, l = c.options.states[d || "normal"] || {}, e = E.plotOptions[c.type].marker && c.options.marker;
                const g = e && !1 === e.enabled, r = e && e.states && e.states[d || "normal"] || {}, h = !1 === r.enabled, y = this.marker || {}, v = c.chart, m = e && c.markerAttribs;
                let q = c.halo;
                var t;
                let I;
                var u = c.stateMarkerGraphic;
                d = d || "";
                if (!(d === this.state && !b || this.selected && "select" !== d || !1 === l.enabled || d && (h || g && !1 === r.enabled) || d && y.states && y.states[d] && !1 === y.states[d].enabled)) {
                    this.state = d;
                    m && (t = c.markerAttribs(this, d));
                    if (this.graphic && !this.hasMockGraphic) {
                        k && this.graphic.removeClass("highcharts-point-" + k);
                        d && this.graphic.addClass("highcharts-point-" + d);
                        if (!v.styledMode) {
                            k = c.pointAttribs(this, d);
                            I = f(v.options.chart.animation, l.animation);
                            const b = k.opacity;
                            c.options.inactiveOtherPoints && x(b) && ((this.dataLabels || []).forEach(function(c) {
                                c && !c.hasClass("highcharts-data-label-hidden") && c.animate({
                                    opacity: b
                                }, I);
                            }), this.connector && this.connector.animate({
                                opacity: b
                            }, I));
                            this.graphic.animate(k, I);
                        }
                        t && this.graphic.animate(t, f(v.options.chart.animation, r.animation, e.animation));
                        u && u.hide();
                    } else {
                        if (d && r) {
                            e = y.symbol || c.symbol;
                            u && u.currentSymbol !== e && (u = u.destroy());
                            if (t) {
                                if (u) u[b ? "animate" : "attr"]({
                                    x: t.x,
                                    y: t.y
                                });
                                else e && (c.stateMarkerGraphic = u = v.renderer.symbol(e, t.x, t.y, t.width, t.height).add(c.markerGroup), u.currentSymbol = e);
                            }
                            !v.styledMode && u && "inactive" !== this.state && u.attr(c.pointAttribs(this, d));
                        }
                        u && (u[d && this.isInside ? "show" : "hide"](), u.element.point = this, u.addClass(this.getClassName(), !0));
                    }
                    l = l.halo;
                    t = (u = this.graphic || u) && u.visibility || "inherit";
                    l && l.size && u && "hidden" !== t && !this.isCluster ? (q || (c.halo = q = v.renderer.path().add(u.parentGroup)), q.show()[b ? "animate" : "attr"]({
                        d: this.haloPath(l.size)
                    }), q.attr({
                        "class": "highcharts-halo highcharts-color-" + f(this.colorIndex, c.colorIndex) + (this.className ? " " + this.className : ""),
                        visibility: t,
                        zIndex: -1
                    }), q.point = this, v.styledMode || q.attr(p({
                        fill: this.color || c.color,
                        "fill-opacity": l.opacity
                    }, a.filterUserAttributes(l.attributes || {})))) : q && q.point && q.point.haloPath && q.animate({
                        d: q.point.haloPath(0)
                    }, null, q.hide);
                    n(this, "afterSetState", {
                        state: d
                    });
                }
            }
            haloPath(d) {
                const b = this.pos();
                return b ? this.series.chart.renderer.symbols.circle(Math.floor(b[0]) - d, b[1] - d, 2 * d, 2 * d) : [];
            }
        }
        "";
        return v;
    });
    L(a, "Core/Pointer.js", [
        a["Core/Color/Color.js"],
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { parse: u } = a, { charts: G, noop: D } = A, { addEvent: E, attr: B, css: t, defined: q, extend: m, find: p, fireEvent: n, isNumber: h, isObject: g, objectEach: e, offset: x, pick: I, splat: M } = J;
        class C {
            constructor(a, e){
                this.lastValidTouch = {};
                this.pinchDown = [];
                this.runChartClick = !1;
                this.eventsToUnbind = [];
                this.chart = a;
                this.hasDragged = !1;
                this.options = e;
                this.init(a, e);
            }
            applyInactiveState(a) {
                let f = [], e;
                (a || []).forEach(function(a) {
                    e = a.series;
                    f.push(e);
                    e.linkedParent && f.push(e.linkedParent);
                    e.linkedSeries && (f = f.concat(e.linkedSeries));
                    e.navigatorSeries && f.push(e.navigatorSeries);
                });
                this.chart.series.forEach(function(a) {
                    -1 === f.indexOf(a) ? a.setState("inactive", !0) : a.options.inactiveOtherPoints && a.setAllPointsToState("inactive");
                });
            }
            destroy() {
                const a = this;
                this.eventsToUnbind.forEach((a)=>a());
                this.eventsToUnbind = [];
                A.chartCount || (C.unbindDocumentMouseUp && (C.unbindDocumentMouseUp = C.unbindDocumentMouseUp()), C.unbindDocumentTouchEnd && (C.unbindDocumentTouchEnd = C.unbindDocumentTouchEnd()));
                clearInterval(a.tooltipTimeout);
                e(a, function(f, e) {
                    a[e] = void 0;
                });
            }
            getSelectionMarkerAttrs(a, e) {
                const f = {
                    args: {
                        chartX: a,
                        chartY: e
                    },
                    attrs: {},
                    shapeType: "rect"
                };
                n(this, "getSelectionMarkerAttrs", f, (f)=>{
                    const { chart: l, mouseDownX: d = 0, mouseDownY: b = 0, zoomHor: c, zoomVert: k } = this;
                    f = f.attrs;
                    let g;
                    f.x = l.plotLeft;
                    f.y = l.plotTop;
                    f.width = c ? 1 : l.plotWidth;
                    f.height = k ? 1 : l.plotHeight;
                    c && (g = a - d, f.width = Math.abs(g), f.x = (0 < g ? 0 : g) + d);
                    k && (g = e - b, f.height = Math.abs(g), f.y = (0 < g ? 0 : g) + b);
                });
                return f;
            }
            drag(a) {
                const f = this.chart, e = f.options.chart;
                var l = f.plotLeft;
                const h = f.plotTop, d = f.plotWidth, b = f.plotHeight, c = this.mouseDownX || 0, k = this.mouseDownY || 0, w = g(e.panning) ? e.panning && e.panning.enabled : e.panning, n = e.panKey && a[e.panKey + "Key"];
                let m = a.chartX, p = a.chartY, q = this.selectionMarker;
                if (!q || !q.touch) {
                    if (m < l ? m = l : m > l + d && (m = l + d), p < h ? p = h : p > h + b && (p = h + b), this.hasDragged = Math.sqrt(Math.pow(c - m, 2) + Math.pow(k - p, 2)), 10 < this.hasDragged) {
                        l = f.isInsidePlot(c - l, k - h, {
                            visiblePlotOnly: !0
                        });
                        const { shapeType: b, attrs: d } = this.getSelectionMarkerAttrs(m, p);
                        !f.hasCartesianSeries && !f.mapView || !this.zoomX && !this.zoomY || !l || n || q || (this.selectionMarker = q = f.renderer[b](), q.attr({
                            "class": "highcharts-selection-marker",
                            zIndex: 7
                        }).add(), f.styledMode || q.attr({
                            fill: e.selectionMarkerFill || u("#334eff").setOpacity(.25).get()
                        }));
                        q && q.attr(d);
                        l && !q && w && f.pan(a, e.panning);
                    }
                }
            }
            dragStart(a) {
                const f = this.chart;
                f.mouseIsDown = a.type;
                f.cancelClick = !1;
                f.mouseDownX = this.mouseDownX = a.chartX;
                f.mouseDownY = this.mouseDownY = a.chartY;
            }
            getSelectionBox(a) {
                const f = {
                    args: {
                        marker: a
                    },
                    result: {}
                };
                n(this, "getSelectionBox", f, (f)=>{
                    f.result = {
                        x: a.attr ? +a.attr("x") : a.x,
                        y: a.attr ? +a.attr("y") : a.y,
                        width: a.attr ? a.attr("width") : a.width,
                        height: a.attr ? a.attr("height") : a.height
                    };
                });
                return f.result;
            }
            drop(a) {
                const f = this, e = this.chart, l = this.hasPinched;
                if (this.selectionMarker) {
                    const { x: g, y: d, width: b, height: c } = this.getSelectionBox(this.selectionMarker), k = {
                        originalEvent: a,
                        xAxis: [],
                        yAxis: [],
                        x: g,
                        y: d,
                        width: b,
                        height: c
                    };
                    let r = !!e.mapView;
                    if (this.hasDragged || l) e.axes.forEach(function(e) {
                        if (e.zoomEnabled && q(e.min) && (l || f[({
                            xAxis: "zoomX",
                            yAxis: "zoomY"
                        })[e.coll]]) && h(g) && h(d) && h(b) && h(c)) {
                            var w = e.horiz;
                            const f = "touchend" === a.type ? e.minPixelPadding : 0, l = e.toValue((w ? g : d) + f);
                            w = e.toValue((w ? g + b : d + c) - f);
                            k[e.coll].push({
                                axis: e,
                                min: Math.min(l, w),
                                max: Math.max(l, w)
                            });
                            r = !0;
                        }
                    }), r && n(e, "selection", k, function(b) {
                        e.zoom(m(b, l ? {
                            animation: !1
                        } : null));
                    });
                    h(e.index) && (this.selectionMarker = this.selectionMarker.destroy());
                    l && this.scaleGroups();
                }
                e && h(e.index) && (t(e.container, {
                    cursor: e._cursor
                }), e.cancelClick = 10 < this.hasDragged, e.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
            }
            findNearestKDPoint(a, e, r) {
                let f;
                a.forEach(function(a) {
                    var d = !(a.noSharedTooltip && e) && 0 > a.options.findNearestPointBy.indexOf("y");
                    a = a.searchPoint(r, d);
                    if ((d = g(a, !0) && a.series) && !(d = !g(f, !0))) {
                        {
                            d = f.distX - a.distX;
                            const b = f.dist - a.dist, c = (a.series.group && a.series.group.zIndex) - (f.series.group && f.series.group.zIndex);
                            d = 0 !== d && e ? d : 0 !== b ? b : 0 !== c ? c : f.series.index > a.series.index ? -1 : 1;
                        }
                        d = 0 < d;
                    }
                    d && (f = a);
                });
                return f;
            }
            getChartCoordinatesFromPoint(a, e) {
                var f = a.series;
                const l = f.xAxis;
                f = f.yAxis;
                const g = a.shapeArgs;
                if (l && f) {
                    let d = I(a.clientX, a.plotX), b = a.plotY || 0;
                    a.isNode && g && h(g.x) && h(g.y) && (d = g.x, b = g.y);
                    return e ? {
                        chartX: f.len + f.pos - b,
                        chartY: l.len + l.pos - d
                    } : {
                        chartX: d + l.pos,
                        chartY: b + f.pos
                    };
                }
                if (g && g.x && g.y) return {
                    chartX: g.x,
                    chartY: g.y
                };
            }
            getChartPosition() {
                if (this.chartPosition) return this.chartPosition;
                var { container: a } = this.chart;
                const e = x(a);
                this.chartPosition = {
                    left: e.left,
                    top: e.top,
                    scaleX: 1,
                    scaleY: 1
                };
                const g = a.offsetWidth;
                a = a.offsetHeight;
                2 < g && 2 < a && (this.chartPosition.scaleX = e.width / g, this.chartPosition.scaleY = e.height / a);
                return this.chartPosition;
            }
            getCoordinates(a) {
                const f = {
                    xAxis: [],
                    yAxis: []
                };
                this.chart.axes.forEach(function(e) {
                    f[e.isXAxis ? "xAxis" : "yAxis"].push({
                        axis: e,
                        value: e.toValue(a[e.horiz ? "chartX" : "chartY"])
                    });
                });
                return f;
            }
            getHoverData(a, e, h, l, m, d) {
                const b = [];
                l = !(!l || !a);
                const c = function(b) {
                    return b.visible && !(!m && b.directTouch) && I(b.options.enableMouseTracking, !0);
                };
                let k, f = {
                    chartX: d ? d.chartX : void 0,
                    chartY: d ? d.chartY : void 0,
                    shared: m
                };
                n(this, "beforeGetHoverData", f);
                k = e && !e.stickyTracking ? [
                    e
                ] : h.filter((b)=>b.stickyTracking && (f.filter || c)(b));
                const r = l || !d ? a : this.findNearestKDPoint(k, m, d);
                e = r && r.series;
                r && (m && !e.noSharedTooltip ? (k = h.filter(function(b) {
                    return f.filter ? f.filter(b) : c(b) && !b.noSharedTooltip;
                }), k.forEach(function(c) {
                    let a = p(c.points, function(b) {
                        return b.x === r.x && !b.isNull;
                    });
                    g(a) && (c.boosted && c.boost && (a = c.boost.getPoint(a)), b.push(a));
                })) : b.push(r));
                f = {
                    hoverPoint: r
                };
                n(this, "afterGetHoverData", f);
                return {
                    hoverPoint: f.hoverPoint,
                    hoverSeries: e,
                    hoverPoints: b
                };
            }
            getPointFromEvent(a) {
                a = a.target;
                let f;
                for(; a && !f;)f = a.point, a = a.parentNode;
                return f;
            }
            onTrackerMouseOut(a) {
                a = a.relatedTarget;
                const f = this.chart.hoverSeries;
                this.isDirectTouch = !1;
                if (!(!f || !a || f.stickyTracking || this.inClass(a, "highcharts-tooltip") || this.inClass(a, "highcharts-series-" + f.index) && this.inClass(a, "highcharts-tracker"))) f.onMouseOut();
            }
            inClass(a, e) {
                let f;
                for(; a;){
                    if (f = B(a, "class")) {
                        if (-1 !== f.indexOf(e)) return !0;
                        if (-1 !== f.indexOf("highcharts-container")) return !1;
                    }
                    a = a.parentElement;
                }
            }
            init(a, e) {
                this.options = e;
                this.chart = a;
                this.runChartClick = !(!e.chart.events || !e.chart.events.click);
                this.pinchDown = [];
                this.lastValidTouch = {};
                this.setDOMEvents();
                n(this, "afterInit");
            }
            normalize(a, e) {
                var f = a.touches, l = f ? f.length ? f.item(0) : I(f.changedTouches, a.changedTouches)[0] : a;
                e || (e = this.getChartPosition());
                f = l.pageX - e.left;
                l = l.pageY - e.top;
                f /= e.scaleX;
                l /= e.scaleY;
                return m(a, {
                    chartX: Math.round(f),
                    chartY: Math.round(l)
                });
            }
            onContainerClick(a) {
                const f = this.chart, e = f.hoverPoint;
                a = this.normalize(a);
                const l = f.plotLeft, g = f.plotTop;
                f.cancelClick || (e && this.inClass(a.target, "highcharts-tracker") ? (n(e.series, "click", m(a, {
                    point: e
                })), f.hoverPoint && e.firePointEvent("click", a)) : (m(a, this.getCoordinates(a)), f.isInsidePlot(a.chartX - l, a.chartY - g, {
                    visiblePlotOnly: !0
                }) && n(f, "click", a)));
            }
            onContainerMouseDown(a) {
                const f = 1 === ((a.buttons || a.button) & 1);
                a = this.normalize(a);
                if (A.isFirefox && 0 !== a.button) this.onContainerMouseMove(a);
                if ("undefined" === typeof a.button || f) this.zoomOption(a), f && a.preventDefault && a.preventDefault(), this.dragStart(a);
            }
            onContainerMouseLeave(a) {
                const f = G[I(C.hoverChartIndex, -1)];
                a = this.normalize(a);
                f && a.relatedTarget && !this.inClass(a.relatedTarget, "highcharts-tooltip") && (f.pointer.reset(), f.pointer.chartPosition = void 0);
            }
            onContainerMouseEnter(a) {
                delete this.chartPosition;
            }
            onContainerMouseMove(a) {
                const f = this.chart, e = f.tooltip;
                a = this.normalize(a);
                this.setHoverChartIndex();
                ("mousedown" === f.mouseIsDown || this.touchSelect(a)) && this.drag(a);
                f.openMenu || !this.inClass(a.target, "highcharts-tracker") && !f.isInsidePlot(a.chartX - f.plotLeft, a.chartY - f.plotTop, {
                    visiblePlotOnly: !0
                }) || e && e.shouldStickOnContact(a) || (this.inClass(a.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(a));
            }
            onDocumentTouchEnd(a) {
                const f = G[I(C.hoverChartIndex, -1)];
                f && f.pointer.drop(a);
            }
            onContainerTouchMove(a) {
                if (this.touchSelect(a)) this.onContainerMouseMove(a);
                else this.touch(a);
            }
            onContainerTouchStart(a) {
                if (this.touchSelect(a)) this.onContainerMouseDown(a);
                else this.zoomOption(a), this.touch(a, !0);
            }
            onDocumentMouseMove(a) {
                const f = this.chart, e = f.tooltip, l = this.chartPosition;
                a = this.normalize(a, l);
                !l || f.isInsidePlot(a.chartX - f.plotLeft, a.chartY - f.plotTop, {
                    visiblePlotOnly: !0
                }) || e && e.shouldStickOnContact(a) || this.inClass(a.target, "highcharts-tracker") || this.reset();
            }
            onDocumentMouseUp(a) {
                const f = G[I(C.hoverChartIndex, -1)];
                f && f.pointer.drop(a);
            }
            pinch(a) {
                const f = this, e = f.chart, l = f.pinchDown, g = a.touches || [], d = g.length, b = f.lastValidTouch, c = f.hasZoom, k = {}, h = 1 === d && (f.inClass(a.target, "highcharts-tracker") && e.runTrackerClick || f.runChartClick), z = {};
                var F = f.chart.tooltip;
                F = 1 === d && I(F && F.options.followTouchMove, !0);
                let p = f.selectionMarker;
                1 < d ? f.initiated = !0 : F && (f.initiated = !1);
                c && f.initiated && !h && !1 !== a.cancelable && a.preventDefault();
                [].map.call(g, function(b) {
                    return f.normalize(b);
                });
                "touchstart" === a.type ? ([].forEach.call(g, function(b, c) {
                    l[c] = {
                        chartX: b.chartX,
                        chartY: b.chartY
                    };
                }), b.x = [
                    l[0].chartX,
                    l[1] && l[1].chartX
                ], b.y = [
                    l[0].chartY,
                    l[1] && l[1].chartY
                ], e.axes.forEach(function(b) {
                    if (b.zoomEnabled) {
                        const c = e.bounds[b.horiz ? "h" : "v"], a = b.minPixelPadding, d = b.toPixels(Math.min(I(b.options.min, b.dataMin), b.dataMin)), k = b.toPixels(Math.max(I(b.options.max, b.dataMax), b.dataMax)), f = Math.max(d, k);
                        c.min = Math.min(b.pos, Math.min(d, k) - a);
                        c.max = Math.max(b.pos + b.len, f + a);
                    }
                }), f.res = !0) : F ? this.runPointActions(f.normalize(a)) : l.length && (n(e, "touchpan", {
                    originalEvent: a
                }, ()=>{
                    p || (f.selectionMarker = p = m({
                        destroy: D,
                        touch: !0
                    }, e.plotBox));
                    f.pinchTranslate(l, g, k, p, z, b);
                    f.hasPinched = c;
                    f.scaleGroups(k, z);
                }), f.res && (f.res = !1, this.reset(!1, 0)));
            }
            pinchTranslate(a, e, g, l, h, d) {
                this.zoomHor && this.pinchTranslateDirection(!0, a, e, g, l, h, d);
                this.zoomVert && this.pinchTranslateDirection(!1, a, e, g, l, h, d);
            }
            pinchTranslateDirection(a, e, g, l, h, d, b, c) {
                const k = this.chart, f = a ? "x" : "y", r = a ? "X" : "Y", n = "chart" + r, m = a ? "width" : "height", v = k["plot" + (a ? "Left" : "Top")], y = k.inverted, p = k.bounds[a ? "h" : "v"], q = 1 === e.length, x = e[0][n], t = !q && e[1][n];
                e = function() {
                    "number" === typeof X && 20 < Math.abs(x - t) && (C = c || Math.abs(N - X) / Math.abs(x - t));
                    I = (v - N) / C + x;
                    u = k["plot" + (a ? "Width" : "Height")] / C;
                };
                let u, I, C = c || 1, N = g[0][n], X = !q && g[1][n], Q;
                e();
                g = I;
                g < p.min ? (g = p.min, Q = !0) : g + u > p.max && (g = p.max - u, Q = !0);
                Q ? (N -= .8 * (N - b[f][0]), "number" === typeof X && (X -= .8 * (X - b[f][1])), e()) : b[f] = [
                    N,
                    X
                ];
                y || (d[f] = I - v, d[m] = u);
                d = y ? 1 / C : C;
                h[m] = u;
                h[f] = g;
                l[y ? a ? "scaleY" : "scaleX" : "scale" + r] = C;
                l["translate" + r] = d * v + (N - d * x);
            }
            reset(a, e) {
                const f = this.chart, l = f.hoverSeries, g = f.hoverPoint, d = f.hoverPoints, b = f.tooltip, c = b && b.shared ? d : g;
                a && c && M(c).forEach(function(b) {
                    b.series.isCartesian && "undefined" === typeof b.plotX && (a = !1);
                });
                if (a) b && c && M(c).length && (b.refresh(c), b.shared && d ? d.forEach(function(b) {
                    b.setState(b.state, !0);
                    b.series.isCartesian && (b.series.xAxis.crosshair && b.series.xAxis.drawCrosshair(null, b), b.series.yAxis.crosshair && b.series.yAxis.drawCrosshair(null, b));
                }) : g && (g.setState(g.state, !0), f.axes.forEach(function(b) {
                    b.crosshair && g.series[b.coll] === b && b.drawCrosshair(null, g);
                })));
                else {
                    if (g) g.onMouseOut();
                    d && d.forEach(function(b) {
                        b.setState();
                    });
                    if (l) l.onMouseOut();
                    b && b.hide(e);
                    this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove());
                    f.axes.forEach(function(b) {
                        b.hideCrosshair();
                    });
                    this.hoverX = f.hoverPoints = f.hoverPoint = null;
                }
            }
            runPointActions(a, e, g) {
                const f = this.chart, h = f.tooltip && f.tooltip.options.enabled ? f.tooltip : void 0, d = h ? h.shared : !1;
                let b = e || f.hoverPoint, c = b && b.series || f.hoverSeries;
                e = this.getHoverData(b, c, f.series, (!a || "touchmove" !== a.type) && (!!e || c && c.directTouch && this.isDirectTouch), d, a);
                b = e.hoverPoint;
                c = e.hoverSeries;
                const k = e.hoverPoints;
                e = c && c.tooltipOptions.followPointer && !c.tooltipOptions.split;
                const w = d && c && !c.noSharedTooltip;
                if (b && (g || b !== f.hoverPoint || h && h.isHidden)) {
                    (f.hoverPoints || []).forEach(function(b) {
                        -1 === k.indexOf(b) && b.setState();
                    });
                    if (f.hoverSeries !== c) c.onMouseOver();
                    this.applyInactiveState(k);
                    (k || []).forEach(function(b) {
                        b.setState("hover");
                    });
                    f.hoverPoint && f.hoverPoint.firePointEvent("mouseOut");
                    if (!b.series) return;
                    f.hoverPoints = k;
                    f.hoverPoint = b;
                    b.firePointEvent("mouseOver", void 0, ()=>{
                        h && b && h.refresh(w ? k : b, a);
                    });
                } else e && h && !h.isHidden && (g = h.getAnchor([
                    {}
                ], a), f.isInsidePlot(g[0], g[1], {
                    visiblePlotOnly: !0
                }) && h.updatePosition({
                    plotX: g[0],
                    plotY: g[1]
                }));
                this.unDocMouseMove || (this.unDocMouseMove = E(f.container.ownerDocument, "mousemove", function(b) {
                    const c = G[C.hoverChartIndex];
                    if (c) c.pointer.onDocumentMouseMove(b);
                }), this.eventsToUnbind.push(this.unDocMouseMove));
                f.axes.forEach(function(b) {
                    const c = I((b.crosshair || {}).snap, !0);
                    let d;
                    c && ((d = f.hoverPoint) && d.series[b.coll] === b || (d = p(k, (c)=>c.series && c.series[b.coll] === b)));
                    d || !c ? b.drawCrosshair(a, d) : b.hideCrosshair();
                });
            }
            scaleGroups(a, e) {
                const f = this.chart;
                f.series.forEach(function(l) {
                    const g = a || l.getPlotBox();
                    l.group && (l.xAxis && l.xAxis.zoomEnabled || f.mapView) && (l.group.attr(g), l.markerGroup && (l.markerGroup.attr(g), l.markerGroup.clip(e ? f.clipRect : null)), l.dataLabelsGroup && l.dataLabelsGroup.attr(g));
                });
                f.clipRect.attr(e || f.clipBox);
            }
            setDOMEvents() {
                const a = this.chart.container, e = a.ownerDocument;
                a.onmousedown = this.onContainerMouseDown.bind(this);
                a.onmousemove = this.onContainerMouseMove.bind(this);
                a.onclick = this.onContainerClick.bind(this);
                this.eventsToUnbind.push(E(a, "mouseenter", this.onContainerMouseEnter.bind(this)));
                this.eventsToUnbind.push(E(a, "mouseleave", this.onContainerMouseLeave.bind(this)));
                C.unbindDocumentMouseUp || (C.unbindDocumentMouseUp = E(e, "mouseup", this.onDocumentMouseUp.bind(this)));
                let g = this.chart.renderTo.parentElement;
                for(; g && "BODY" !== g.tagName;)this.eventsToUnbind.push(E(g, "scroll", ()=>{
                    delete this.chartPosition;
                })), g = g.parentElement;
                A.hasTouch && (this.eventsToUnbind.push(E(a, "touchstart", this.onContainerTouchStart.bind(this), {
                    passive: !1
                })), this.eventsToUnbind.push(E(a, "touchmove", this.onContainerTouchMove.bind(this), {
                    passive: !1
                })), C.unbindDocumentTouchEnd || (C.unbindDocumentTouchEnd = E(e, "touchend", this.onDocumentTouchEnd.bind(this), {
                    passive: !1
                })));
            }
            setHoverChartIndex() {
                const a = this.chart, e = A.charts[I(C.hoverChartIndex, -1)];
                if (e && e !== a) e.pointer.onContainerMouseLeave({
                    relatedTarget: a.container
                });
                e && e.mouseIsDown || (C.hoverChartIndex = a.index);
            }
            touch(a, e) {
                const f = this.chart;
                let l, g;
                this.setHoverChartIndex();
                1 === a.touches.length ? (a = this.normalize(a), (g = f.isInsidePlot(a.chartX - f.plotLeft, a.chartY - f.plotTop, {
                    visiblePlotOnly: !0
                })) && !f.openMenu ? (e && this.runPointActions(a), "touchmove" === a.type && (e = this.pinchDown, l = e[0] ? 4 <= Math.sqrt(Math.pow(e[0].chartX - a.chartX, 2) + Math.pow(e[0].chartY - a.chartY, 2)) : !1), I(l, !0) && this.pinch(a)) : e && this.reset()) : 2 === a.touches.length && this.pinch(a);
            }
            touchSelect(a) {
                return !(!this.chart.zooming.singleTouch || !a.touches || 1 !== a.touches.length);
            }
            zoomOption(a) {
                const f = this.chart, e = f.inverted;
                var l = f.zooming.type || "";
                /touch/.test(a.type) && (l = I(f.zooming.pinchType, l));
                this.zoomX = a = /x/.test(l);
                this.zoomY = l = /y/.test(l);
                this.zoomHor = a && !e || l && e;
                this.zoomVert = l && !e || a && e;
                this.hasZoom = a || l;
            }
        }
        (function(a) {
            const f = [], e = [];
            a.compose = function(f) {
                J.pushUnique(e, f) && E(f, "beforeRender", function() {
                    this.pointer = new a(this, this.options);
                });
            };
            a.dissolve = function() {
                for(let a = 0, e = f.length; a < e; ++a)f[a]();
                f.length = 0;
            };
        })(C || (C = {}));
        "";
        return C;
    });
    L(a, "Core/Legend/Legend.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Templating.js"],
        a["Core/Globals.js"],
        a["Core/Series/Point.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D) {
        const { animObject: u, setAnimation: B } = a, { format: t } = A, { marginNames: q } = J, { distribute: m } = G, { addEvent: p, createElement: n, css: h, defined: g, discardElement: e, find: x, fireEvent: I, isNumber: M, merge: C, pick: f, relativeLength: y, stableSort: r, syncTimeout: l } = D;
        class v {
            constructor(a, b){
                this.allItems = [];
                this.contentGroup = this.box = void 0;
                this.display = !1;
                this.group = void 0;
                this.offsetWidth = this.maxLegendWidth = this.maxItemWidth = this.legendWidth = this.legendHeight = this.lastLineHeight = this.lastItemY = this.itemY = this.itemX = this.itemMarginTop = this.itemMarginBottom = this.itemHeight = this.initialItemY = 0;
                this.options = void 0;
                this.padding = 0;
                this.pages = [];
                this.proximate = !1;
                this.scrollGroup = void 0;
                this.widthOption = this.totalItemWidth = this.titleHeight = this.symbolWidth = this.symbolHeight = 0;
                this.chart = a;
                this.init(a, b);
            }
            init(a, b) {
                this.chart = a;
                this.setOptions(b);
                b.enabled && (this.render(), p(this.chart, "endResize", function() {
                    this.legend.positionCheckboxes();
                }), p(this.chart, "render", ()=>{
                    this.proximate && (this.proximatePositions(), this.positionItems());
                }));
            }
            setOptions(a) {
                const b = f(a.padding, 8);
                this.options = a;
                this.chart.styledMode || (this.itemStyle = a.itemStyle, this.itemHiddenStyle = C(this.itemStyle, a.itemHiddenStyle));
                this.itemMarginTop = a.itemMarginTop;
                this.itemMarginBottom = a.itemMarginBottom;
                this.padding = b;
                this.initialItemY = b - 5;
                this.symbolWidth = f(a.symbolWidth, 16);
                this.pages = [];
                this.proximate = "proximate" === a.layout && !this.chart.inverted;
                this.baseline = void 0;
            }
            update(a, b) {
                const c = this.chart;
                this.setOptions(C(!0, this.options, a));
                this.destroy();
                c.isDirtyLegend = c.isDirtyBox = !0;
                f(b, !0) && c.redraw();
                I(this, "afterUpdate");
            }
            colorizeItem(a, b) {
                const { group: c, label: d, line: f, symbol: e } = a.legendItem || {};
                if (c) c[b ? "removeClass" : "addClass"]("highcharts-legend-item-hidden");
                if (!this.chart.styledMode) {
                    const { itemHiddenStyle: c } = this, k = c.color, l = b ? a.color || k : k, g = a.options && a.options.marker;
                    let h = {
                        fill: l
                    };
                    null === d || void 0 === d || d.css(C(b ? this.itemStyle : c));
                    null === f || void 0 === f || f.attr({
                        stroke: l
                    });
                    e && (g && e.isMarker && (h = a.pointAttribs(), b || (h.stroke = h.fill = k)), e.attr(h));
                }
                I(this, "afterColorizeItem", {
                    item: a,
                    visible: b
                });
            }
            positionItems() {
                this.allItems.forEach(this.positionItem, this);
                this.chart.isResizing || this.positionCheckboxes();
            }
            positionItem(a) {
                const { group: b, x: c = 0, y: d = 0 } = a.legendItem || {};
                var f = this.options, e = f.symbolPadding;
                const l = !f.rtl;
                f = a.checkbox;
                b && b.element && (e = {
                    translateX: l ? c : this.legendWidth - c - 2 * e - 4,
                    translateY: d
                }, b[g(b.translateY) ? "animate" : "attr"](e, void 0, ()=>{
                    I(this, "afterPositionItem", {
                        item: a
                    });
                }));
                f && (f.x = c, f.y = d);
            }
            destroyItem(a) {
                const b = a.checkbox, c = a.legendItem || {};
                for (const b of [
                    "group",
                    "label",
                    "line",
                    "symbol"
                ])c[b] && (c[b] = c[b].destroy());
                b && e(b);
                a.legendItem = void 0;
            }
            destroy() {
                for (const a of this.getAllItems())this.destroyItem(a);
                for (const a of "clipRect up down pager nav box title group".split(" "))this[a] && (this[a] = this[a].destroy());
                this.display = null;
            }
            positionCheckboxes() {
                const a = this.group && this.group.alignAttr, b = this.clipHeight || this.legendHeight, c = this.titleHeight;
                let k;
                a && (k = a.translateY, this.allItems.forEach(function(d) {
                    const f = d.checkbox;
                    let e;
                    f && (e = k + c + f.y + (this.scrollOffset || 0) + 3, h(f, {
                        left: a.translateX + d.checkboxOffset + f.x - 20 + "px",
                        top: e + "px",
                        display: this.proximate || e > k - 6 && e < k + b - 6 ? "" : "none"
                    }));
                }, this));
            }
            renderTitle() {
                var a = this.options;
                const b = this.padding, c = a.title;
                let k = 0;
                c.text && (this.title || (this.title = this.chart.renderer.label(c.text, b - 3, b - 4, void 0, void 0, void 0, a.useHTML, void 0, "legend-title").attr({
                    zIndex: 1
                }), this.chart.styledMode || this.title.css(c.style), this.title.add(this.group)), c.width || this.title.css({
                    width: this.maxLegendWidth + "px"
                }), a = this.title.getBBox(), k = a.height, this.offsetWidth = a.width, this.contentGroup.attr({
                    translateY: k
                }));
                this.titleHeight = k;
            }
            setText(a) {
                const b = this.options;
                a.legendItem.label.attr({
                    text: b.labelFormat ? t(b.labelFormat, a, this.chart) : b.labelFormatter.call(a)
                });
            }
            renderItem(a) {
                const b = a.legendItem = a.legendItem || {};
                var c = this.chart, d = c.renderer;
                const e = this.options, l = this.symbolWidth, g = e.symbolPadding || 0, h = this.itemStyle, n = this.itemHiddenStyle, r = "horizontal" === e.layout ? f(e.itemDistance, 20) : 0, m = !e.rtl, v = !a.series, p = !v && a.series.drawLegendSymbol ? a.series : a;
                var q = p.options;
                const y = this.createCheckboxForItem && q && q.showCheckbox, x = e.useHTML, t = a.options.className;
                let N = b.label;
                q = l + g + r + (y ? 20 : 0);
                N || (b.group = d.g("legend-item").addClass("highcharts-" + p.type + "-series highcharts-color-" + a.colorIndex + (t ? " " + t : "") + (v ? " highcharts-series-" + a.index : "")).attr({
                    zIndex: 1
                }).add(this.scrollGroup), b.label = N = d.text("", m ? l + g : -g, this.baseline || 0, x), c.styledMode || N.css(C(a.visible ? h : n)), N.attr({
                    align: m ? "left" : "right",
                    zIndex: 2
                }).add(b.group), this.baseline || (this.fontMetrics = d.fontMetrics(N), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, N.attr("y", this.baseline), this.symbolHeight = f(e.symbolHeight, this.fontMetrics.f), e.squareSymbol && (this.symbolWidth = f(e.symbolWidth, Math.max(this.symbolHeight, 16)), q = this.symbolWidth + g + r + (y ? 20 : 0), m && N.attr("x", this.symbolWidth + g))), p.drawLegendSymbol(this, a), this.setItemEvents && this.setItemEvents(a, N, x));
                y && !a.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(a);
                this.colorizeItem(a, a.visible);
                !c.styledMode && h.width || N.css({
                    width: (e.itemWidth || this.widthOption || c.spacingBox.width) - q + "px"
                });
                this.setText(a);
                c = N.getBBox();
                d = this.fontMetrics && this.fontMetrics.h || 0;
                a.itemWidth = a.checkboxOffset = e.itemWidth || b.labelWidth || c.width + q;
                this.maxItemWidth = Math.max(this.maxItemWidth, a.itemWidth);
                this.totalItemWidth += a.itemWidth;
                this.itemHeight = a.itemHeight = Math.round(b.labelHeight || (c.height > 1.5 * d ? c.height : d));
            }
            layoutItem(a) {
                var b = this.options;
                const c = this.padding, d = "horizontal" === b.layout, e = a.itemHeight, l = this.itemMarginBottom, g = this.itemMarginTop, h = d ? f(b.itemDistance, 20) : 0, n = this.maxLegendWidth;
                b = b.alignColumns && this.totalItemWidth > n ? this.maxItemWidth : a.itemWidth;
                const r = a.legendItem || {};
                d && this.itemX - c + b > n && (this.itemX = c, this.lastLineHeight && (this.itemY += g + this.lastLineHeight + l), this.lastLineHeight = 0);
                this.lastItemY = g + this.itemY + l;
                this.lastLineHeight = Math.max(e, this.lastLineHeight);
                r.x = this.itemX;
                r.y = this.itemY;
                d ? this.itemX += b : (this.itemY += g + e + l, this.lastLineHeight = e);
                this.offsetWidth = this.widthOption || Math.max((d ? this.itemX - c - (a.checkbox ? 0 : h) : b) + c, this.offsetWidth);
            }
            getAllItems() {
                let a = [];
                this.chart.series.forEach(function(b) {
                    const c = b && b.options;
                    b && f(c.showInLegend, g(c.linkedTo) ? !1 : void 0, !0) && (a = a.concat((b.legendItem || {}).labels || ("point" === c.legendType ? b.data : b)));
                });
                I(this, "afterGetAllItems", {
                    allItems: a
                });
                return a;
            }
            getAlignment() {
                const a = this.options;
                return this.proximate ? a.align.charAt(0) + "tv" : a.floating ? "" : a.align.charAt(0) + a.verticalAlign.charAt(0) + a.layout.charAt(0);
            }
            adjustMargins(a, b) {
                const c = this.chart, d = this.options, e = this.getAlignment();
                e && [
                    /(lth|ct|rth)/,
                    /(rtv|rm|rbv)/,
                    /(rbh|cb|lbh)/,
                    /(lbv|lm|ltv)/
                ].forEach(function(k, l) {
                    k.test(e) && !g(a[l]) && (c[q[l]] = Math.max(c[q[l]], c.legend[(l + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                        1,
                        -1,
                        -1,
                        1
                    ][l] * d[l % 2 ? "x" : "y"] + f(d.margin, 12) + b[l] + (c.titleOffset[l] || 0)));
                });
            }
            proximatePositions() {
                const a = this.chart, b = [], c = "left" === this.options.align;
                this.allItems.forEach(function(d) {
                    var k;
                    var f = c;
                    let e;
                    d.yAxis && (d.xAxis.options.reversed && (f = !f), d.points && (k = x(f ? d.points : d.points.slice(0).reverse(), function(b) {
                        return M(b.plotY);
                    })), f = this.itemMarginTop + d.legendItem.label.getBBox().height + this.itemMarginBottom, e = d.yAxis.top - a.plotTop, d.visible ? (k = k ? k.plotY : d.yAxis.height, k += e - .3 * f) : k = e + d.yAxis.height, b.push({
                        target: k,
                        size: f,
                        item: d
                    }));
                }, this);
                let k;
                for (const c of m(b, a.plotHeight))k = c.item.legendItem || {}, M(c.pos) && (k.y = a.plotTop - a.spacing[0] + c.pos);
            }
            render() {
                const a = this.chart, b = a.renderer, c = this.options, k = this.padding;
                var f = this.getAllItems();
                let e, l = this.group, g = this.box;
                this.itemX = k;
                this.itemY = this.initialItemY;
                this.lastItemY = this.offsetWidth = 0;
                this.widthOption = y(c.width, a.spacingBox.width - k);
                var h = a.spacingBox.width - 2 * k - c.x;
                -1 < [
                    "rm",
                    "lm"
                ].indexOf(this.getAlignment().substring(0, 2)) && (h /= 2);
                this.maxLegendWidth = this.widthOption || h;
                l || (this.group = l = b.g("legend").addClass(c.className || "").attr({
                    zIndex: 7
                }).add(), this.contentGroup = b.g().attr({
                    zIndex: 1
                }).add(l), this.scrollGroup = b.g().add(this.contentGroup));
                this.renderTitle();
                r(f, (b, c)=>(b.options && b.options.legendIndex || 0) - (c.options && c.options.legendIndex || 0));
                c.reversed && f.reverse();
                this.allItems = f;
                this.display = h = !!f.length;
                this.itemHeight = this.totalItemWidth = this.maxItemWidth = this.lastLineHeight = 0;
                f.forEach(this.renderItem, this);
                f.forEach(this.layoutItem, this);
                f = (this.widthOption || this.offsetWidth) + k;
                e = this.lastItemY + this.lastLineHeight + this.titleHeight;
                e = this.handleOverflow(e);
                e += k;
                g || (this.box = g = b.rect().addClass("highcharts-legend-box").attr({
                    r: c.borderRadius
                }).add(l));
                a.styledMode || g.attr({
                    stroke: c.borderColor,
                    "stroke-width": c.borderWidth || 0,
                    fill: c.backgroundColor || "none"
                }).shadow(c.shadow);
                if (0 < f && 0 < e) g[g.placed ? "animate" : "attr"](g.crisp.call({}, {
                    x: 0,
                    y: 0,
                    width: f,
                    height: e
                }, g.strokeWidth()));
                l[h ? "show" : "hide"]();
                a.styledMode && "none" === l.getStyle("display") && (f = e = 0);
                this.legendWidth = f;
                this.legendHeight = e;
                h && this.align();
                this.proximate || this.positionItems();
                I(this, "afterRender");
            }
            align(a = this.chart.spacingBox) {
                const b = this.chart, c = this.options;
                let d = a.y;
                /(lth|ct|rth)/.test(this.getAlignment()) && 0 < b.titleOffset[0] ? d += b.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && 0 < b.titleOffset[2] && (d -= b.titleOffset[2]);
                d !== a.y && (a = C(a, {
                    y: d
                }));
                b.hasRendered || (this.group.placed = !1);
                this.group.align(C(c, {
                    width: this.legendWidth,
                    height: this.legendHeight,
                    verticalAlign: this.proximate ? "top" : c.verticalAlign
                }), !0, a);
            }
            handleOverflow(a) {
                const b = this, c = this.chart, d = c.renderer, e = this.options;
                var l = e.y;
                const g = "top" === e.verticalAlign, h = this.padding, n = e.maxHeight, r = e.navigation, m = f(r.animation, !0), v = r.arrowSize || 12, p = this.pages, q = this.allItems, y = function(c) {
                    "number" === typeof c ? I.attr({
                        height: c
                    }) : I && (b.clipRect = I.destroy(), b.contentGroup.clip());
                    b.contentGroup.div && (b.contentGroup.div.style.clip = c ? "rect(" + h + "px,9999px," + (h + c) + "px,0)" : "auto");
                }, x = function(a) {
                    b[a] = d.circle(0, 0, 1.3 * v).translate(v / 2, v / 2).add(Q);
                    c.styledMode || b[a].attr("fill", "rgba(0,0,0,0.0001)");
                    return b[a];
                };
                let t, N, u;
                l = c.spacingBox.height + (g ? -l : l) - h;
                let Q = this.nav, I = this.clipRect;
                "horizontal" !== e.layout || "middle" === e.verticalAlign || e.floating || (l /= 2);
                n && (l = Math.min(l, n));
                p.length = 0;
                a && 0 < l && a > l && !1 !== r.enabled ? (this.clipHeight = t = Math.max(l - 20 - this.titleHeight - h, 0), this.currentPage = f(this.currentPage, 1), this.fullHeight = a, q.forEach((b, c)=>{
                    u = b.legendItem || {};
                    b = u.y || 0;
                    const a = Math.round(u.label.getBBox().height);
                    let d = p.length;
                    if (!d || b - p[d - 1] > t && (N || b) !== p[d - 1]) p.push(N || b), d++;
                    u.pageIx = d - 1;
                    N && ((q[c - 1].legendItem || {}).pageIx = d - 1);
                    c === q.length - 1 && b + a - p[d - 1] > t && b > p[d - 1] && (p.push(b), u.pageIx = d);
                    b !== N && (N = b);
                }), I || (I = b.clipRect = d.clipRect(0, h - 2, 9999, 0), b.contentGroup.clip(I)), y(t), Q || (this.nav = Q = d.g().attr({
                    zIndex: 1
                }).add(this.group), this.up = d.symbol("triangle", 0, 0, v, v).add(Q), x("upTracker").on("click", function() {
                    b.scroll(-1, m);
                }), this.pager = d.text("", 15, 10).addClass("highcharts-legend-navigation"), !c.styledMode && r.style && this.pager.css(r.style), this.pager.add(Q), this.down = d.symbol("triangle-down", 0, 0, v, v).add(Q), x("downTracker").on("click", function() {
                    b.scroll(1, m);
                })), b.scroll(0), a = l) : Q && (y(), this.nav = Q.destroy(), this.scrollGroup.attr({
                    translateY: 1
                }), this.clipHeight = 0);
                return a;
            }
            scroll(a, b) {
                const c = this.chart, d = this.pages, e = d.length, g = this.clipHeight, h = this.options.navigation, n = this.pager, r = this.padding;
                let m = this.currentPage + a;
                m > e && (m = e);
                0 < m && ("undefined" !== typeof b && B(b, c), this.nav.attr({
                    translateX: r,
                    translateY: g + this.padding + 7 + this.titleHeight,
                    visibility: "inherit"
                }), [
                    this.up,
                    this.upTracker
                ].forEach(function(b) {
                    b.attr({
                        "class": 1 === m ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }), n.attr({
                    text: m + "/" + e
                }), [
                    this.down,
                    this.downTracker
                ].forEach(function(b) {
                    b.attr({
                        x: 18 + this.pager.getBBox().width,
                        "class": m === e ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }, this), c.styledMode || (this.up.attr({
                    fill: 1 === m ? h.inactiveColor : h.activeColor
                }), this.upTracker.css({
                    cursor: 1 === m ? "default" : "pointer"
                }), this.down.attr({
                    fill: m === e ? h.inactiveColor : h.activeColor
                }), this.downTracker.css({
                    cursor: m === e ? "default" : "pointer"
                })), this.scrollOffset = -d[m - 1] + this.initialItemY, this.scrollGroup.animate({
                    translateY: this.scrollOffset
                }), this.currentPage = m, this.positionCheckboxes(), a = u(f(b, c.renderer.globalAnimation, !0)), l(()=>{
                    I(this, "afterScroll", {
                        currentPage: m
                    });
                }, a.duration));
            }
            setItemEvents(a, b, c) {
                const d = this, f = a.legendItem || {}, e = d.chart.renderer.boxWrapper, l = a instanceof K, g = "highcharts-legend-" + (l ? "point" : "series") + "-active", h = d.chart.styledMode;
                c = c ? [
                    b,
                    f.symbol
                ] : [
                    f.group
                ];
                const n = (b)=>{
                    d.allItems.forEach((c)=>{
                        a !== c && [
                            c
                        ].concat(c.linkedSeries || []).forEach((c)=>{
                            c.setState(b, !l);
                        });
                    });
                };
                for (const k of c)if (k) k.on("mouseover", function() {
                    a.visible && n("inactive");
                    a.setState("hover");
                    a.visible && e.addClass(g);
                    h || b.css(d.options.itemHoverStyle);
                }).on("mouseout", function() {
                    d.chart.styledMode || b.css(C(a.visible ? d.itemStyle : d.itemHiddenStyle));
                    n("");
                    e.removeClass(g);
                    a.setState();
                }).on("click", function(b) {
                    const c = function() {
                        a.setVisible && a.setVisible();
                        n(a.visible ? "inactive" : "");
                    };
                    e.removeClass(g);
                    b = {
                        browserEvent: b
                    };
                    a.firePointEvent ? a.firePointEvent("legendItemClick", b, c) : I(a, "legendItemClick", b, c);
                });
            }
            createCheckboxForItem(a) {
                a.checkbox = n("input", {
                    type: "checkbox",
                    className: "highcharts-legend-checkbox",
                    checked: a.selected,
                    defaultChecked: a.selected
                }, this.options.itemCheckboxStyle, this.chart.container);
                p(a.checkbox, "click", function(b) {
                    I(a.series || a, "checkboxClick", {
                        checked: b.target.checked,
                        item: a
                    }, function() {
                        a.select();
                    });
                });
            }
        }
        (function(a) {
            const b = [];
            a.compose = function(c) {
                D.pushUnique(b, c) && p(c, "beforeMargins", function() {
                    this.legend = new a(this, this.options.legend);
                });
            };
        })(v || (v = {}));
        "";
        return v;
    });
    L(a, "Core/Legend/LegendSymbol.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { extend: u, merge: J, pick: K } = a;
        var G;
        (function(a) {
            a.lineMarker = function(a, B) {
                B = this.legendItem = this.legendItem || {};
                var t = this.options;
                const q = a.symbolWidth, m = a.symbolHeight, p = m / 2, n = this.chart.renderer, h = B.group;
                a = a.baseline - Math.round(.3 * a.fontMetrics.b);
                let g = {}, e = t.marker, x = 0;
                this.chart.styledMode || (g = {
                    "stroke-width": Math.min(t.lineWidth || 0, 24)
                }, t.dashStyle ? g.dashstyle = t.dashStyle : "square" !== t.linecap && (g["stroke-linecap"] = "round"));
                B.line = n.path().addClass("highcharts-graph").attr(g).add(h);
                g["stroke-linecap"] && (x = Math.min(B.line.strokeWidth(), q) / 2);
                q && B.line.attr({
                    d: [
                        [
                            "M",
                            x,
                            a
                        ],
                        [
                            "L",
                            q - x,
                            a
                        ]
                    ]
                });
                e && !1 !== e.enabled && q && (t = Math.min(K(e.radius, p), p), 0 === this.symbol.indexOf("url") && (e = J(e, {
                    width: m,
                    height: m
                }), t = 0), B.symbol = B = n.symbol(this.symbol, q / 2 - t, a - t, 2 * t, 2 * t, u({
                    context: "legend"
                }, e)).addClass("highcharts-point").add(h), B.isMarker = !0);
            };
            a.rectangle = function(a, u) {
                u = u.legendItem || {};
                const t = a.symbolHeight, q = a.options.squareSymbol;
                u.symbol = this.chart.renderer.rect(q ? (a.symbolWidth - t) / 2 : 0, a.baseline - t + 1, q ? t : a.symbolWidth, t, K(a.options.symbolRadius, t / 2)).addClass("highcharts-point").attr({
                    zIndex: 3
                }).add(u.group);
            };
        })(G || (G = {}));
        return G;
    });
    L(a, "Core/Series/SeriesDefaults.js", [], function() {
        return {
            lineWidth: 1,
            allowPointSelect: !1,
            crisp: !0,
            showCheckbox: !1,
            animation: {
                duration: 1E3
            },
            enableMouseTracking: !0,
            events: {},
            marker: {
                enabledThreshold: 2,
                lineColor: "#ffffff",
                lineWidth: 0,
                radius: 4,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 150
                        },
                        enabled: !0,
                        radiusPlus: 2,
                        lineWidthPlus: 1
                    },
                    select: {
                        fillColor: "#cccccc",
                        lineColor: "#000000",
                        lineWidth: 2
                    }
                }
            },
            point: {
                events: {}
            },
            dataLabels: {
                animation: {},
                align: "center",
                borderWidth: 0,
                defer: !0,
                formatter: function() {
                    const { numberFormatter: a } = this.series.chart;
                    return "number" !== typeof this.y ? "" : a(this.y, -1);
                },
                padding: 5,
                style: {
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    color: "contrast",
                    textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0
            },
            cropThreshold: 300,
            opacity: 1,
            pointRange: 0,
            softThreshold: !0,
            states: {
                normal: {
                    animation: !0
                },
                hover: {
                    animation: {
                        duration: 150
                    },
                    lineWidthPlus: 1,
                    marker: {},
                    halo: {
                        size: 10,
                        opacity: .25
                    }
                },
                select: {
                    animation: {
                        duration: 0
                    }
                },
                inactive: {
                    animation: {
                        duration: 150
                    },
                    opacity: .2
                }
            },
            stickyTracking: !0,
            turboThreshold: 1E3,
            findNearestPointBy: "x"
        };
    });
    L(a, "Core/Series/SeriesRegistry.js", [
        a["Core/Globals.js"],
        a["Core/Defaults.js"],
        a["Core/Series/Point.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K) {
        const { defaultOptions: u } = A, { extendClass: D, merge: E } = K;
        var B;
        (function(t) {
            function q(a, p) {
                const n = u.plotOptions || {}, h = p.defaultOptions, g = p.prototype;
                g.type = a;
                g.pointClass || (g.pointClass = J);
                h && (n[a] = h);
                t.seriesTypes[a] = p;
            }
            t.seriesTypes = a.seriesTypes;
            t.registerSeriesType = q;
            t.seriesType = function(a, p, n, h, g) {
                const e = u.plotOptions || {};
                p = p || "";
                e[a] = E(e[p], n);
                q(a, D(t.seriesTypes[p] || function() {}, h));
                t.seriesTypes[a].prototype.type = a;
                g && (t.seriesTypes[a].prototype.pointClass = D(J, g));
                return t.seriesTypes[a];
            };
        })(B || (B = {}));
        return B;
    });
    L(a, "Core/Series/Series.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Defaults.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Legend/LegendSymbol.js"],
        a["Core/Series/Point.js"],
        a["Core/Series/SeriesDefaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E, B, t, q) {
        const { animObject: m, setAnimation: p } = a, { defaultOptions: n } = A, { registerEventOptions: h } = J, { hasTouch: g, svg: e, win: x } = K, { seriesTypes: u } = B, { arrayMax: M, arrayMin: C, clamp: f, correctFloat: y, defined: r, diffObjects: l, erase: v, error: d, extend: b, find: c, fireEvent: k, getClosestDistance: w, getNestedProperty: z, insertItem: F, isArray: O, isNumber: P, isString: T, merge: U, objectEach: W, pick: H, removeEvent: Y, splat: ea, syncTimeout: aa } = q;
        class Z {
            constructor(){
                this.zones = this.yAxis = this.xAxis = this.userOptions = this.tooltipOptions = this.processedYData = this.processedXData = this.points = this.options = this.linkedSeries = this.index = this.eventsToUnbind = this.eventOptions = this.data = this.chart = this._i = void 0;
            }
            init(c, a) {
                k(this, "init", {
                    options: a
                });
                const d = this, f = c.series;
                this.eventsToUnbind = [];
                d.chart = c;
                d.options = d.setOptions(a);
                a = d.options;
                d.linkedSeries = [];
                d.bindAxes();
                b(d, {
                    name: a.name,
                    state: "",
                    visible: !1 !== a.visible,
                    selected: !0 === a.selected
                });
                h(this, a);
                const e = a.events;
                if (e && e.click || a.point && a.point.events && a.point.events.click || a.allowPointSelect) c.runTrackerClick = !0;
                d.getColor();
                d.getSymbol();
                d.parallelArrays.forEach(function(b) {
                    d[b + "Data"] || (d[b + "Data"] = []);
                });
                d.isCartesian && (c.hasCartesianSeries = !0);
                let l;
                f.length && (l = f[f.length - 1]);
                d._i = H(l && l._i, -1) + 1;
                d.opacity = d.options.opacity;
                c.orderItems("series", F(this, f));
                a.dataSorting && a.dataSorting.enabled ? d.setDataSortingOptions() : d.points || d.data || d.setData(a.data, !1);
                k(this, "afterInit");
            }
            is(b) {
                return u[b] && this instanceof u[b];
            }
            bindAxes() {
                const b = this, c = b.options, a = b.chart;
                let f;
                k(this, "bindAxes", null, function() {
                    (b.axisTypes || []).forEach(function(k) {
                        a[k].forEach(function(a) {
                            f = a.options;
                            if (H(c[k], 0) === a.index || "undefined" !== typeof c[k] && c[k] === f.id) F(b, a.series), b[k] = a, a.isDirty = !0;
                        });
                        b[k] || b.optionalAxis === k || d(18, !0, a);
                    });
                });
                k(this, "afterBindAxes");
            }
            updateParallelArrays(b, c, a) {
                const d = b.series, k = P(c) ? function(a) {
                    const k = "y" === a && d.toYData ? d.toYData(b) : b[a];
                    d[a + "Data"][c] = k;
                } : function(b) {
                    Array.prototype[c].apply(d[b + "Data"], a);
                };
                d.parallelArrays.forEach(k);
            }
            hasData() {
                return this.visible && "undefined" !== typeof this.dataMax && "undefined" !== typeof this.dataMin || this.visible && this.yData && 0 < this.yData.length;
            }
            autoIncrement(b) {
                var c = this.options;
                const a = c.pointIntervalUnit, d = c.relativeXValue, k = this.chart.time;
                let f = this.xIncrement, e;
                f = H(f, c.pointStart, 0);
                this.pointInterval = e = H(this.pointInterval, c.pointInterval, 1);
                d && P(b) && (e *= b);
                a && (c = new k.Date(f), "day" === a ? k.set("Date", c, k.get("Date", c) + e) : "month" === a ? k.set("Month", c, k.get("Month", c) + e) : "year" === a && k.set("FullYear", c, k.get("FullYear", c) + e), e = c.getTime() - f);
                if (d && P(b)) return f + e;
                this.xIncrement = f + e;
                return f;
            }
            setDataSortingOptions() {
                const c = this.options;
                b(this, {
                    requireSorting: !1,
                    sorted: !1,
                    enabledDataSorting: !0,
                    allowDG: !1
                });
                r(c.pointRange) || (c.pointRange = 1);
            }
            setOptions(b) {
                var c, a;
                const d = this.chart;
                var f = d.options.plotOptions, e = d.userOptions || {};
                const l = U(b);
                b = d.styledMode;
                const g = {
                    plotOptions: f,
                    userOptions: l
                };
                k(this, "setOptions", g);
                const h = g.plotOptions[this.type];
                e = e.plotOptions || {};
                const m = e.series || {}, w = n.plotOptions[this.type] || {}, v = e[this.type] || {};
                this.userOptions = g.userOptions;
                f = U(h, f.series, v, l);
                this.tooltipOptions = U(n.tooltip, null === (c = n.plotOptions.series) || void 0 === c ? void 0 : c.tooltip, null === w || void 0 === w ? void 0 : w.tooltip, d.userOptions.tooltip, null === (a = e.series) || void 0 === a ? void 0 : a.tooltip, v.tooltip, l.tooltip);
                this.stickyTracking = H(l.stickyTracking, v.stickyTracking, m.stickyTracking, this.tooltipOptions.shared && !this.noSharedTooltip ? !0 : f.stickyTracking);
                null === h.marker && delete f.marker;
                this.zoneAxis = f.zoneAxis;
                a = this.zones = (f.zones || []).slice();
                !f.negativeColor && !f.negativeFillColor || f.zones || (c = {
                    value: f[this.zoneAxis + "Threshold"] || f.threshold || 0,
                    className: "highcharts-negative"
                }, b || (c.color = f.negativeColor, c.fillColor = f.negativeFillColor), a.push(c));
                a.length && r(a[a.length - 1].value) && a.push(b ? {} : {
                    color: this.color,
                    fillColor: this.fillColor
                });
                k(this, "afterSetOptions", {
                    options: f
                });
                return f;
            }
            getName() {
                return H(this.options.name, "Series " + (this.index + 1));
            }
            getCyclic(b, c, a) {
                const d = this.chart, k = `${b}Index`, f = `${b}Counter`, e = (null === a || void 0 === a ? void 0 : a.length) || d.options.chart.colorCount;
                if (!c) {
                    var l = H("color" === b ? this.options.colorIndex : void 0, this[k]);
                    r(l) || (d.series.length || (d[f] = 0), l = d[f] % e, d[f] += 1);
                    a && (c = a[l]);
                }
                "undefined" !== typeof l && (this[k] = l);
                this[b] = c;
            }
            getColor() {
                this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || n.plotOptions[this.type].color, this.chart.options.colors);
            }
            getPointsCollection() {
                return (this.hasGroupedData ? this.points : this.data) || [];
            }
            getSymbol() {
                this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
            }
            findPointIndex(b, a) {
                const d = b.id, k = b.x, f = this.points;
                var e = this.options.dataSorting, l;
                let g, h;
                if (d) e = this.chart.get(d), e instanceof D && (l = e);
                else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
                    if (l = (c)=>!c.touched && c.index === b.index, e && e.matchByName ? l = (c)=>!c.touched && c.name === b.name : this.options.relativeXValue && (l = (c)=>!c.touched && c.options.x === b.x), l = c(f, l), !l) return;
                }
                l && (h = l && l.index, "undefined" !== typeof h && (g = !0));
                "undefined" === typeof h && P(k) && (h = this.xData.indexOf(k, a));
                -1 !== h && "undefined" !== typeof h && this.cropped && (h = h >= this.cropStart ? h - this.cropStart : h);
                !g && P(h) && f[h] && f[h].touched && (h = void 0);
                return h;
            }
            updateData(b, c) {
                const a = this.options, d = a.dataSorting, k = this.points, f = [], e = this.requireSorting, l = b.length === k.length;
                let g, h, n, m = !0;
                this.xIncrement = null;
                b.forEach(function(b, c) {
                    var h = r(b) && this.pointClass.prototype.optionsToObject.call({
                        series: this
                    }, b) || {};
                    const m = h.x;
                    if (h.id || P(m)) {
                        if (h = this.findPointIndex(h, n), -1 === h || "undefined" === typeof h ? f.push(b) : k[h] && b !== a.data[h] ? (k[h].update(b, !1, null, !1), k[h].touched = !0, e && (n = h + 1)) : k[h] && (k[h].touched = !0), !l || c !== h || d && d.enabled || this.hasDerivedData) g = !0;
                    } else f.push(b);
                }, this);
                if (g) for(b = k.length; b--;)(h = k[b]) && !h.touched && h.remove && h.remove(!1, c);
                else !l || d && d.enabled ? m = !1 : (b.forEach(function(b, c) {
                    b === k[c].y || k[c].destroyed || k[c].update(b, !1, null, !1);
                }), f.length = 0);
                k.forEach(function(b) {
                    b && (b.touched = !1);
                });
                if (!m) return !1;
                f.forEach(function(b) {
                    this.addPoint(b, !1, null, null, !1);
                }, this);
                null === this.xIncrement && this.xData && this.xData.length && (this.xIncrement = M(this.xData), this.autoIncrement());
                return !0;
            }
            setData(b, c = !0, a, k) {
                var f;
                const e = this, l = e.points, g = l && l.length || 0, h = e.options, n = e.chart, r = h.dataSorting, m = e.xAxis, w = h.turboThreshold, v = this.xData, z = this.yData;
                var p = e.pointArrayMap;
                p = p && p.length;
                const q = h.keys;
                let F, y = 0, x = 1, N = null;
                if (!n.options.chart.allowMutatingData) {
                    h.data && delete e.options.data;
                    e.userOptions.data && delete e.userOptions.data;
                    var t = U(!0, b);
                }
                b = t || b || [];
                t = b.length;
                r && r.enabled && (b = this.sortData(b));
                n.options.chart.allowMutatingData && !1 !== k && t && g && !e.cropped && !e.hasGroupedData && e.visible && !e.boosted && (F = this.updateData(b, a));
                if (!F) {
                    e.xIncrement = null;
                    e.colorCounter = 0;
                    this.parallelArrays.forEach(function(b) {
                        e[b + "Data"].length = 0;
                    });
                    if (w && t > w) {
                        if (N = e.getFirstValidPoint(b), P(N)) for(a = 0; a < t; a++)v[a] = this.autoIncrement(), z[a] = b[a];
                        else if (O(N)) {
                            if (p) {
                                if (N.length === p) for(a = 0; a < t; a++)v[a] = this.autoIncrement(), z[a] = b[a];
                                else for(a = 0; a < t; a++)k = b[a], v[a] = k[0], z[a] = k.slice(1, p + 1);
                            } else if (q && (y = q.indexOf("x"), x = q.indexOf("y"), y = 0 <= y ? y : 0, x = 0 <= x ? x : 1), 1 === N.length && (x = 0), y === x) for(a = 0; a < t; a++)v[a] = this.autoIncrement(), z[a] = b[a][x];
                            else for(a = 0; a < t; a++)k = b[a], v[a] = k[y], z[a] = k[x];
                        } else d(12, !1, n);
                    } else for(a = 0; a < t; a++)k = {
                        series: e
                    }, e.pointClass.prototype.applyOptions.apply(k, [
                        b[a]
                    ]), e.updateParallelArrays(k, a);
                    z && T(z[0]) && d(14, !0, n);
                    e.data = [];
                    e.options.data = e.userOptions.data = b;
                    for(a = g; a--;)null === (f = l[a]) || void 0 === f || f.destroy();
                    m && (m.minRange = m.userMinRange);
                    e.isDirty = n.isDirtyBox = !0;
                    e.isDirtyData = !!l;
                    a = !1;
                }
                "point" === h.legendType && (this.processData(), this.generatePoints());
                c && n.redraw(a);
            }
            sortData(b) {
                const c = this, a = c.options.dataSorting.sortKey || "y", d = function(b, c) {
                    return r(c) && b.pointClass.prototype.optionsToObject.call({
                        series: b
                    }, c) || {};
                };
                b.forEach(function(a, k) {
                    b[k] = d(c, a);
                    b[k].index = k;
                }, this);
                b.concat().sort((b, c)=>{
                    b = z(a, b);
                    c = z(a, c);
                    return c < b ? -1 : c > b ? 1 : 0;
                }).forEach(function(b, c) {
                    b.x = c;
                }, this);
                c.linkedSeries && c.linkedSeries.forEach(function(c) {
                    const a = c.options, k = a.data;
                    a.dataSorting && a.dataSorting.enabled || !k || (k.forEach(function(a, f) {
                        k[f] = d(c, a);
                        b[f] && (k[f].x = b[f].x, k[f].index = f);
                    }), c.setData(k, !1));
                });
                return b;
            }
            getProcessedData(b) {
                const c = this;
                var a = c.xAxis, k = c.options;
                const f = k.cropThreshold, e = b || c.getExtremesFromAll || k.getExtremesFromAll, l = null === a || void 0 === a ? void 0 : a.logarithmic, g = c.isCartesian;
                let h = 0;
                let n;
                b = c.xData;
                k = c.yData;
                let r = !1;
                const m = b.length;
                if (a) {
                    var v = a.getExtremes();
                    n = v.min;
                    v = v.max;
                    r = !(!a.categories || a.names.length);
                }
                if (g && c.sorted && !e && (!f || m > f || c.forceCrop)) {
                    if (b[m - 1] < n || b[0] > v) b = [], k = [];
                    else if (c.yData && (b[0] < n || b[m - 1] > v)) {
                        var z = this.cropData(c.xData, c.yData, n, v);
                        b = z.xData;
                        k = z.yData;
                        h = z.start;
                        z = !0;
                    }
                }
                a = w([
                    l ? b.map(l.log2lin) : b
                ], ()=>c.requireSorting && !r && d(15, !1, c.chart));
                return {
                    xData: b,
                    yData: k,
                    cropped: z,
                    cropStart: h,
                    closestPointRange: a
                };
            }
            processData(b) {
                const c = this.xAxis;
                if (this.isCartesian && !this.isDirty && !c.isDirty && !this.yAxis.isDirty && !b) return !1;
                b = this.getProcessedData();
                this.cropped = b.cropped;
                this.cropStart = b.cropStart;
                this.processedXData = b.xData;
                this.processedYData = b.yData;
                this.closestPointRange = this.basePointRange = b.closestPointRange;
                k(this, "afterProcessData");
            }
            cropData(b, c, a, d, k) {
                const f = b.length;
                let e, l = 0, g = f;
                k = H(k, this.cropShoulder);
                for(e = 0; e < f; e++)if (b[e] >= a) {
                    l = Math.max(0, e - k);
                    break;
                }
                for(a = e; a < f; a++)if (b[a] > d) {
                    g = a + k;
                    break;
                }
                return {
                    xData: b.slice(l, g),
                    yData: c.slice(l, g),
                    start: l,
                    end: g
                };
            }
            generatePoints() {
                var c = this.options;
                const a = this.processedData || c.data, d = this.processedXData, f = this.processedYData, e = this.pointClass, l = d.length, g = this.cropStart || 0, h = this.hasGroupedData, n = c.keys, r = [];
                c = c.dataGrouping && c.dataGrouping.groupAll ? g : 0;
                let m;
                let w, v, z = this.data;
                if (!z && !h) {
                    var p = [];
                    p.length = a.length;
                    z = this.data = p;
                }
                n && h && (this.options.keys = !1);
                for(v = 0; v < l; v++)p = g + v, h ? (w = (new e).init(this, [
                    d[v]
                ].concat(ea(f[v]))), w.dataGroup = this.groupMap[c + v], w.dataGroup.options && (w.options = w.dataGroup.options, b(w, w.dataGroup.options), delete w.dataLabels)) : (w = z[p]) || "undefined" === typeof a[p] || (z[p] = w = (new e).init(this, a[p], d[v])), w && (w.index = h ? c + v : p, r[v] = w);
                this.options.keys = n;
                if (z && (l !== (m = z.length) || h)) for(v = 0; v < m; v++)v !== g || h || (v += l), z[v] && (z[v].destroyElements(), z[v].plotX = void 0);
                this.data = z;
                this.points = r;
                k(this, "afterGeneratePoints");
            }
            getXExtremes(b) {
                return {
                    min: C(b),
                    max: M(b)
                };
            }
            getExtremes(b, c) {
                const a = this.xAxis;
                var d = this.yAxis;
                const f = this.processedXData || this.xData, e = [], l = this.requireSorting ? this.cropShoulder : 0;
                d = d ? d.positiveValuesOnly : !1;
                let g, h = 0, n = 0, r = 0;
                b = b || this.stackedYData || this.processedYData || [];
                const w = b.length;
                if (a) {
                    var m = a.getExtremes();
                    h = m.min;
                    n = m.max;
                }
                for(g = 0; g < w; g++){
                    var v = f[g];
                    m = b[g];
                    var z = (P(m) || O(m)) && (m.length || 0 < m || !d);
                    v = c || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !a || (f[g + l] || v) >= h && (f[g - l] || v) <= n;
                    if (z && v) {
                        if (z = m.length) for(; z--;)P(m[z]) && (e[r++] = m[z]);
                        else e[r++] = m;
                    }
                }
                b = {
                    activeYData: e,
                    dataMin: C(e),
                    dataMax: M(e)
                };
                k(this, "afterGetExtremes", {
                    dataExtremes: b
                });
                return b;
            }
            applyExtremes() {
                const b = this.getExtremes();
                this.dataMin = b.dataMin;
                this.dataMax = b.dataMax;
                return b;
            }
            getFirstValidPoint(b) {
                const c = b.length;
                let a = 0, d = null;
                for(; null === d && a < c;)d = b[a], a++;
                return d;
            }
            translate() {
                var b;
                this.processedXData || this.processData();
                this.generatePoints();
                var c = this.options;
                const a = c.stacking, d = this.xAxis, e = d.categories, l = this.enabledDataSorting, g = this.yAxis, h = this.points, n = h.length, m = this.pointPlacementToXValue(), w = !!m, v = c.threshold;
                c = c.startFromThreshold ? v : 0;
                let z, p, q, F, x = Number.MAX_VALUE;
                for(z = 0; z < n; z++){
                    const k = h[z], n = k.x;
                    let t, u, I = k.y, N = k.low;
                    const C = a && (null === (b = g.stacking) || void 0 === b ? void 0 : b.stacks[(this.negStacks && I < (c ? 0 : v) ? "-" : "") + this.stackKey]);
                    p = d.translate(n, !1, !1, !1, !0, m);
                    k.plotX = P(p) ? y(f(p, -100000, 1E5)) : void 0;
                    a && this.visible && C && C[n] && (F = this.getStackIndicator(F, n, this.index), !k.isNull && F.key && (t = C[n], u = t.points[F.key]), t && O(u) && (N = u[0], I = u[1], N === c && F.key === C[n].base && (N = H(P(v) ? v : g.min)), g.positiveValuesOnly && r(N) && 0 >= N && (N = void 0), k.total = k.stackTotal = H(t.total), k.percentage = r(k.y) && t.total ? k.y / t.total * 100 : void 0, k.stackY = I, this.irregularWidths || t.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis)));
                    k.yBottom = r(N) ? f(g.translate(N, !1, !0, !1, !0), -100000, 1E5) : void 0;
                    this.dataModify && (I = this.dataModify.modifyValue(I, z));
                    let ca;
                    P(I) && void 0 !== k.plotX && (ca = g.translate(I, !1, !0, !1, !0), ca = P(ca) ? f(ca, -100000, 1E5) : void 0);
                    k.plotY = ca;
                    k.isInside = this.isPointInside(k);
                    k.clientX = w ? y(d.translate(n, !1, !1, !1, !0, m)) : p;
                    k.negative = (k.y || 0) < (v || 0);
                    k.category = H(e && e[k.x], k.x);
                    k.isNull || !1 === k.visible || ("undefined" !== typeof q && (x = Math.min(x, Math.abs(p - q))), q = p);
                    k.zone = this.zones.length ? k.getZone() : void 0;
                    !k.graphic && this.group && l && (k.isNew = !0);
                }
                this.closestPointRangePx = x;
                k(this, "afterTranslate");
            }
            getValidPoints(b, c, a) {
                const d = this.chart;
                return (b || this.points || []).filter(function(b) {
                    const { plotX: k, plotY: f } = b;
                    return !a && (b.isNull || !P(f)) || c && !d.isInsidePlot(k, f, {
                        inverted: d.inverted
                    }) ? !1 : !1 !== b.visible;
                });
            }
            getClipBox() {
                const { chart: b, xAxis: c, yAxis: a } = this, d = U(b.clipBox);
                c && c.len !== b.plotSizeX && (d.width = c.len);
                a && a.len !== b.plotSizeY && (d.height = a.len);
                return d;
            }
            getSharedClipKey() {
                return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0);
            }
            setClip() {
                const { chart: b, group: c, markerGroup: a } = this, d = b.sharedClips, k = b.renderer, f = this.getClipBox(), e = this.getSharedClipKey();
                let l = d[e];
                l ? l.animate(f) : d[e] = l = k.clipRect(f);
                c && c.clip(!1 === this.options.clip ? void 0 : l);
                a && a.clip();
            }
            animate(b) {
                const { chart: c, group: a, markerGroup: d } = this, k = c.inverted;
                var f = m(this.options.animation), e = [
                    this.getSharedClipKey(),
                    f.duration,
                    f.easing,
                    f.defer
                ].join();
                let l = c.sharedClips[e], g = c.sharedClips[e + "m"];
                if (b && a) f = this.getClipBox(), l ? l.attr("height", f.height) : (f.width = 0, k && (f.x = c.plotHeight), l = c.renderer.clipRect(f), c.sharedClips[e] = l, g = c.renderer.clipRect({
                    x: -99,
                    y: -99,
                    width: k ? c.plotWidth + 199 : 99,
                    height: k ? 99 : c.plotHeight + 199
                }), c.sharedClips[e + "m"] = g), a.clip(l), d && d.clip(g);
                else if (l && !l.hasClass("highcharts-animating")) {
                    e = this.getClipBox();
                    const b = f.step;
                    d && d.element.childNodes.length && (f.step = function(c, a) {
                        b && b.apply(a, arguments);
                        "width" === a.prop && g && g.element && g.attr(k ? "height" : "width", c + 99);
                    });
                    l.addClass("highcharts-animating").animate(e, f);
                }
            }
            afterAnimate() {
                this.setClip();
                W(this.chart.sharedClips, (b, c, a)=>{
                    b && !this.chart.container.querySelector(`[clip-path="url(#${b.id})"]`) && (b.destroy(), delete a[c]);
                });
                this.finishedAnimating = !0;
                k(this, "afterAnimate");
            }
            drawPoints(b = this.points) {
                const c = this.chart, a = c.styledMode, { colorAxis: d, options: k } = this, f = k.marker, e = this[this.specialGroup || "markerGroup"], l = this.xAxis, g = H(f.enabled, !l || l.isRadial ? !0 : null, this.closestPointRangePx >= f.enabledThreshold * f.radius);
                let h, n, m, r;
                let w, v;
                if (!1 !== f.enabled || this._hasPointMarkers) for(h = 0; h < b.length; h++){
                    n = b[h];
                    r = (m = n.graphic) ? "animate" : "attr";
                    var z = n.marker || {};
                    w = !!n.marker;
                    if ((g && "undefined" === typeof z.enabled || z.enabled) && !n.isNull && !1 !== n.visible) {
                        const b = H(z.symbol, this.symbol, "rect");
                        v = this.markerAttribs(n, n.selected && "select");
                        this.enabledDataSorting && (n.startXPos = l.reversed ? -(v.width || 0) : l.width);
                        const k = !1 !== n.isInside;
                        !m && k && (0 < (v.width || 0) || n.hasImage) && (n.graphic = m = c.renderer.symbol(b, v.x, v.y, v.width, v.height, w ? z : f).add(e), this.enabledDataSorting && c.hasRendered && (m.attr({
                            x: n.startXPos
                        }), r = "animate"));
                        m && "animate" === r && m[k ? "show" : "hide"](k).animate(v);
                        if (m) {
                            if (z = this.pointAttribs(n, a || !n.selected ? void 0 : "select"), a) d && m.css({
                                fill: z.fill
                            });
                            else m[r](z);
                        }
                        m && m.addClass(n.getClassName(), !0);
                    } else m && (n.graphic = m.destroy());
                }
            }
            markerAttribs(b, c) {
                const a = this.options;
                var d = a.marker;
                const k = b.marker || {}, f = k.symbol || d.symbol, e = {};
                let l = H(k.radius, d && d.radius);
                c && (d = d.states[c], c = k.states && k.states[c], l = H(c && c.radius, d && d.radius, l && l + (d && d.radiusPlus || 0)));
                b.hasImage = f && 0 === f.indexOf("url");
                b.hasImage && (l = 0);
                b = b.pos();
                P(l) && b && (e.x = b[0] - l, e.y = b[1] - l, a.crisp && (e.x = Math.floor(e.x)));
                l && (e.width = e.height = 2 * l);
                return e;
            }
            pointAttribs(b, c) {
                var a = this.options.marker, d = b && b.options;
                const k = d && d.marker || {};
                var f = d && d.color, e = b && b.color;
                const l = b && b.zone && b.zone.color;
                let g = this.color;
                b = H(k.lineWidth, a.lineWidth);
                d = 1;
                g = f || l || e || g;
                f = k.fillColor || a.fillColor || g;
                e = k.lineColor || a.lineColor || g;
                c = c || "normal";
                a = a.states[c] || {};
                c = k.states && k.states[c] || {};
                b = H(c.lineWidth, a.lineWidth, b + H(c.lineWidthPlus, a.lineWidthPlus, 0));
                f = c.fillColor || a.fillColor || f;
                e = c.lineColor || a.lineColor || e;
                d = H(c.opacity, a.opacity, d);
                return {
                    stroke: e,
                    "stroke-width": b,
                    fill: f,
                    opacity: d
                };
            }
            destroy(b) {
                const c = this, a = c.chart, d = /AppleWebKit\/533/.test(x.navigator.userAgent), f = c.data || [];
                let e, l, g, h;
                k(c, "destroy", {
                    keepEventsForUpdate: b
                });
                this.removeEvents(b);
                (c.axisTypes || []).forEach(function(b) {
                    (h = c[b]) && h.series && (v(h.series, c), h.isDirty = h.forceRedraw = !0);
                });
                c.legendItem && c.chart.legend.destroyItem(c);
                for(l = f.length; l--;)(g = f[l]) && g.destroy && g.destroy();
                c.clips && c.clips.forEach((b)=>b.destroy());
                q.clearTimeout(c.animationTimeout);
                W(c, function(b, c) {
                    b instanceof t && !b.survive && (e = d && "group" === c ? "hide" : "destroy", b[e]());
                });
                a.hoverSeries === c && (a.hoverSeries = void 0);
                v(a.series, c);
                a.orderItems("series");
                W(c, function(a, d) {
                    b && "hcEvents" === d || delete c[d];
                });
            }
            applyZones() {
                const b = this, c = this.chart, a = c.renderer, d = this.zones, k = this.clips || [], e = this.graph, l = this.area, g = Math.max(c.plotWidth, c.plotHeight), h = this[(this.zoneAxis || "y") + "Axis"], n = c.inverted;
                let m, r, w, v, z, p, q, F, y, x, t, u = !1;
                d.length && (e || l) && h && "undefined" !== typeof h.min ? (z = h.reversed, p = h.horiz, e && !this.showLine && e.hide(), l && l.hide(), v = h.getExtremes(), d.forEach(function(d, I) {
                    m = z ? p ? c.plotWidth : 0 : p ? 0 : h.toPixels(v.min) || 0;
                    m = f(H(r, m), 0, g);
                    r = f(Math.round(h.toPixels(H(d.value, v.max), !0) || 0), 0, g);
                    u && (m = r = h.toPixels(v.max));
                    q = Math.abs(m - r);
                    F = Math.min(m, r);
                    y = Math.max(m, r);
                    h.isXAxis ? (w = {
                        x: n ? y : F,
                        y: 0,
                        width: q,
                        height: g
                    }, p || (w.x = c.plotHeight - w.x)) : (w = {
                        x: 0,
                        y: n ? y : F,
                        width: g,
                        height: q
                    }, p && (w.y = c.plotWidth - w.y));
                    k[I] ? k[I].animate(w) : k[I] = a.clipRect(w);
                    x = b["zone-area-" + I];
                    t = b["zone-graph-" + I];
                    e && t && t.clip(k[I]);
                    l && x && x.clip(k[I]);
                    u = d.value > v.max;
                    b.resetZones && 0 === r && (r = void 0);
                }), this.clips = k) : b.visible && (e && e.show(), l && l.show());
            }
            plotGroup(b, c, a, d, k) {
                let f = this[b];
                const e = !f;
                a = {
                    visibility: a,
                    zIndex: d || .1
                };
                "undefined" === typeof this.opacity || this.chart.styledMode || "inactive" === this.state || (a.opacity = this.opacity);
                e && (this[b] = f = this.chart.renderer.g().add(k));
                f.addClass("highcharts-" + c + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (r(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (f.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0);
                f.attr(a)[e ? "attr" : "animate"](this.getPlotBox(c));
                return f;
            }
            getPlotBox(b) {
                let c = this.xAxis, a = this.yAxis;
                const d = this.chart;
                b = d.inverted && !d.polar && c && !1 !== this.invertible && "series" === b;
                d.inverted && (c = a, a = this.xAxis);
                return {
                    translateX: c ? c.left : d.plotLeft,
                    translateY: a ? a.top : d.plotTop,
                    rotation: b ? 90 : 0,
                    rotationOriginX: b ? (c.len - a.len) / 2 : 0,
                    rotationOriginY: b ? (c.len + a.len) / 2 : 0,
                    scaleX: b ? -1 : 1,
                    scaleY: 1
                };
            }
            removeEvents(b) {
                b || Y(this);
                this.eventsToUnbind.length && (this.eventsToUnbind.forEach(function(b) {
                    b();
                }), this.eventsToUnbind.length = 0);
            }
            render() {
                const b = this;
                var c = b.chart;
                const a = b.options, d = m(a.animation), f = b.visible ? "inherit" : "hidden", e = a.zIndex, l = b.hasRendered;
                c = c.seriesGroup;
                let g = b.finishedAnimating ? 0 : d.duration;
                k(this, "render");
                b.plotGroup("group", "series", f, e, c);
                b.markerGroup = b.plotGroup("markerGroup", "markers", f, e, c);
                !1 !== a.clip && b.setClip();
                b.animate && g && b.animate(!0);
                b.drawGraph && (b.drawGraph(), b.applyZones());
                b.visible && b.drawPoints();
                b.drawDataLabels && b.drawDataLabels();
                b.redrawPoints && b.redrawPoints();
                b.drawTracker && a.enableMouseTracking && b.drawTracker();
                b.animate && g && b.animate();
                l || (g && d.defer && (g += d.defer), b.animationTimeout = aa(function() {
                    b.afterAnimate();
                }, g || 0));
                b.isDirty = !1;
                b.hasRendered = !0;
                k(b, "afterRender");
            }
            redraw() {
                const b = this.isDirty || this.isDirtyData;
                this.translate();
                this.render();
                b && delete this.kdTree;
            }
            searchPoint(b, c) {
                const a = this.xAxis, d = this.yAxis, k = this.chart.inverted;
                return this.searchKDTree({
                    clientX: k ? a.len - b.chartY + a.pos : b.chartX - a.pos,
                    plotY: k ? d.len - b.chartX + d.pos : b.chartY - d.pos
                }, c, b);
            }
            buildKDTree(b) {
                function c(b, d, k) {
                    var f = b && b.length;
                    let e;
                    if (f) return e = a.kdAxisArray[d % k], b.sort(function(b, c) {
                        return b[e] - c[e];
                    }), f = Math.floor(f / 2), {
                        point: b[f],
                        left: c(b.slice(0, f), d + 1, k),
                        right: c(b.slice(f + 1), d + 1, k)
                    };
                }
                this.buildingKdTree = !0;
                const a = this, d = -1 < a.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                delete a.kdTree;
                aa(function() {
                    a.kdTree = c(a.getValidPoints(null, !a.directTouch), d, d);
                    a.buildingKdTree = !1;
                }, a.options.kdNow || b && "touchstart" === b.type ? 0 : 1);
            }
            searchKDTree(b, c, a) {
                function d(b, c, a, g) {
                    const h = c.point;
                    var n = k.kdAxisArray[a % g];
                    let m = h;
                    var w = r(b[f]) && r(h[f]) ? Math.pow(b[f] - h[f], 2) : null;
                    var v = r(b[e]) && r(h[e]) ? Math.pow(b[e] - h[e], 2) : null;
                    v = (w || 0) + (v || 0);
                    h.dist = r(v) ? Math.sqrt(v) : Number.MAX_VALUE;
                    h.distX = r(w) ? Math.sqrt(w) : Number.MAX_VALUE;
                    n = b[n] - h[n];
                    v = 0 > n ? "left" : "right";
                    w = 0 > n ? "right" : "left";
                    c[v] && (v = d(b, c[v], a + 1, g), m = v[l] < m[l] ? v : h);
                    c[w] && Math.sqrt(n * n) < m[l] && (b = d(b, c[w], a + 1, g), m = b[l] < m[l] ? b : m);
                    return m;
                }
                const k = this, f = this.kdAxisArray[0], e = this.kdAxisArray[1], l = c ? "distX" : "dist";
                c = -1 < k.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                this.kdTree || this.buildingKdTree || this.buildKDTree(a);
                if (this.kdTree) return d(b, this.kdTree, c, c);
            }
            pointPlacementToXValue() {
                const { options: { pointPlacement: b, pointRange: c }, xAxis: a } = this;
                let d = b;
                "between" === d && (d = a.reversed ? -0.5 : .5);
                return P(d) ? d * (c || a.pointRange) : 0;
            }
            isPointInside(b) {
                const { chart: c, xAxis: a, yAxis: d } = this;
                return "undefined" !== typeof b.plotY && "undefined" !== typeof b.plotX && 0 <= b.plotY && b.plotY <= (d ? d.len : c.plotHeight) && 0 <= b.plotX && b.plotX <= (a ? a.len : c.plotWidth);
            }
            drawTracker() {
                const b = this, c = b.options, a = c.trackByArea, d = [].concat(a ? b.areaPath : b.graphPath), f = b.chart, l = f.pointer, h = f.renderer, n = f.options.tooltip.snap, m = b.tracker, r = function(a) {
                    if (c.enableMouseTracking && f.hoverSeries !== b) b.onMouseOver();
                }, w = "rgba(192,192,192," + (e ? .0001 : .002) + ")";
                m ? m.attr({
                    d: d
                }) : b.graph && (b.tracker = h.path(d).attr({
                    visibility: b.visible ? "inherit" : "hidden",
                    zIndex: 2
                }).addClass(a ? "highcharts-tracker-area" : "highcharts-tracker-line").add(b.group), f.styledMode || b.tracker.attr({
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    stroke: w,
                    fill: a ? w : "none",
                    "stroke-width": b.graph.strokeWidth() + (a ? 0 : 2 * n)
                }), [
                    b.tracker,
                    b.markerGroup,
                    b.dataLabelsGroup
                ].forEach(function(b) {
                    if (b && (b.addClass("highcharts-tracker").on("mouseover", r).on("mouseout", function(b) {
                        l.onTrackerMouseOut(b);
                    }), c.cursor && !f.styledMode && b.css({
                        cursor: c.cursor
                    }), g)) b.on("touchstart", r);
                }));
                k(this, "afterDrawTracker");
            }
            addPoint(b, c, a, d, f) {
                const e = this.options, l = this.data, g = this.chart;
                var h = this.xAxis;
                h = h && h.hasNames && h.names;
                const n = e.data, m = this.xData;
                let r, w;
                c = H(c, !0);
                const v = {
                    series: this
                };
                this.pointClass.prototype.applyOptions.apply(v, [
                    b
                ]);
                const z = v.x;
                w = m.length;
                if (this.requireSorting && z < m[w - 1]) for(r = !0; w && m[w - 1] > z;)w--;
                this.updateParallelArrays(v, "splice", [
                    w,
                    0,
                    0
                ]);
                this.updateParallelArrays(v, w);
                h && v.name && (h[z] = v.name);
                n.splice(w, 0, b);
                if (r || this.processedData) this.data.splice(w, 0, null), this.processData();
                "point" === e.legendType && this.generatePoints();
                a && (l[0] && l[0].remove ? l[0].remove(!1) : (l.shift(), this.updateParallelArrays(v, "shift"), n.shift()));
                !1 !== f && k(this, "addPoint", {
                    point: v
                });
                this.isDirtyData = this.isDirty = !0;
                c && g.redraw(d);
            }
            removePoint(b, c, a) {
                const d = this, k = d.data, f = k[b], e = d.points, l = d.chart, g = function() {
                    e && e.length === k.length && e.splice(b, 1);
                    k.splice(b, 1);
                    d.options.data.splice(b, 1);
                    d.updateParallelArrays(f || {
                        series: d
                    }, "splice", [
                        b,
                        1
                    ]);
                    f && f.destroy();
                    d.isDirty = !0;
                    d.isDirtyData = !0;
                    c && l.redraw();
                };
                p(a, l);
                c = H(c, !0);
                f ? f.firePointEvent("remove", null, g) : g();
            }
            remove(b, c, a, d) {
                function f() {
                    e.destroy(d);
                    l.isDirtyLegend = l.isDirtyBox = !0;
                    l.linkSeries(d);
                    H(b, !0) && l.redraw(c);
                }
                const e = this, l = e.chart;
                !1 !== a ? k(e, "remove", null, f) : f();
            }
            update(c, a) {
                c = l(c, this.userOptions);
                k(this, "update", {
                    options: c
                });
                const f = this, e = f.chart;
                var g = f.userOptions;
                const h = f.initialType || f.type;
                var n = e.options.plotOptions;
                const m = u[h].prototype;
                var w = f.finishedAnimating && {
                    animation: !1
                };
                const r = {};
                let v, z = [
                    "colorIndex",
                    "eventOptions",
                    "navigatorSeries",
                    "symbolIndex",
                    "baseSeries"
                ], p = c.type || g.type || e.options.chart.type;
                const q = !(this.hasDerivedData || p && p !== this.type || "undefined" !== typeof c.pointStart || "undefined" !== typeof c.pointInterval || "undefined" !== typeof c.relativeXValue || c.joinBy || c.mapData || f.hasOptionChanged("dataGrouping") || f.hasOptionChanged("pointStart") || f.hasOptionChanged("pointInterval") || f.hasOptionChanged("pointIntervalUnit") || f.hasOptionChanged("keys"));
                p = p || h;
                q && (z.push("data", "isDirtyData", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "_hasPointLabels", "clips", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX"), !1 !== c.visible && z.push("area", "graph"), f.parallelArrays.forEach(function(b) {
                    z.push(b + "Data");
                }), c.data && (c.dataSorting && b(f.options.dataSorting, c.dataSorting), this.setData(c.data, !1)));
                c = U(g, w, {
                    index: "undefined" === typeof g.index ? f.index : g.index,
                    pointStart: H(n && n.series && n.series.pointStart, g.pointStart, f.xData[0])
                }, !q && {
                    data: f.options.data
                }, c);
                q && c.data && (c.data = f.options.data);
                z = [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup",
                    "transformGroup"
                ].concat(z);
                z.forEach(function(b) {
                    z[b] = f[b];
                    delete f[b];
                });
                n = !1;
                if (u[p]) {
                    if (n = p !== f.type, f.remove(!1, !1, !1, !0), n) {
                        if (Object.setPrototypeOf) Object.setPrototypeOf(f, u[p].prototype);
                        else {
                            w = Object.hasOwnProperty.call(f, "hcEvents") && f.hcEvents;
                            for(v in m)f[v] = void 0;
                            b(f, u[p].prototype);
                            w ? f.hcEvents = w : delete f.hcEvents;
                        }
                    }
                } else d(17, !0, e, {
                    missingModuleFor: p
                });
                z.forEach(function(b) {
                    f[b] = z[b];
                });
                f.init(e, c);
                if (q && this.points) {
                    c = f.options;
                    if (!1 === c.visible) r.graphic = 1, r.dataLabel = 1;
                    else if (!f._hasPointLabels) {
                        const { marker: b, dataLabels: a } = c;
                        g = g.marker || {};
                        !b || !1 !== b.enabled && g.symbol === b.symbol && g.height === b.height && g.width === b.width || (r.graphic = 1);
                        a && !1 === a.enabled && (r.dataLabel = 1);
                    }
                    for (const b of this.points)b && b.series && (b.resolveColor(), Object.keys(r).length && b.destroyElements(r), !1 === c.showInLegend && b.legendItem && e.legend.destroyItem(b));
                }
                f.initialType = h;
                e.linkSeries();
                n && f.linkedSeries.length && (f.isDirtyData = !0);
                k(this, "afterUpdate");
                H(a, !0) && e.redraw(q ? void 0 : !1);
            }
            setName(b) {
                this.name = this.options.name = this.userOptions.name = b;
                this.chart.isDirtyLegend = !0;
            }
            hasOptionChanged(b) {
                const c = this.options[b], a = this.chart.options.plotOptions, d = this.userOptions[b];
                return d ? c !== d : c !== H(a && a[this.type] && a[this.type][b], a && a.series && a.series[b], c);
            }
            onMouseOver() {
                const b = this.chart, c = b.hoverSeries;
                b.pointer.setHoverChartIndex();
                if (c && c !== this) c.onMouseOut();
                this.options.events.mouseOver && k(this, "mouseOver");
                this.setState("hover");
                b.hoverSeries = this;
            }
            onMouseOut() {
                const b = this.options, c = this.chart, a = c.tooltip, d = c.hoverPoint;
                c.hoverSeries = null;
                if (d) d.onMouseOut();
                this && b.events.mouseOut && k(this, "mouseOut");
                !a || this.stickyTracking || a.shared && !this.noSharedTooltip || a.hide();
                c.series.forEach(function(b) {
                    b.setState("", !0);
                });
            }
            setState(b, c) {
                const a = this;
                var d = a.options;
                const k = a.graph, f = d.inactiveOtherPoints, e = d.states, l = H(e[b || "normal"] && e[b || "normal"].animation, a.chart.options.chart.animation);
                let g = d.lineWidth, h = 0, n = d.opacity;
                b = b || "";
                if (a.state !== b && ([
                    a.group,
                    a.markerGroup,
                    a.dataLabelsGroup
                ].forEach(function(c) {
                    c && (a.state && c.removeClass("highcharts-series-" + a.state), b && c.addClass("highcharts-series-" + b));
                }), a.state = b, !a.chart.styledMode)) {
                    if (e[b] && !1 === e[b].enabled) return;
                    b && (g = e[b].lineWidth || g + (e[b].lineWidthPlus || 0), n = H(e[b].opacity, n));
                    if (k && !k.dashstyle && P(g)) for(d = {
                        "stroke-width": g
                    }, k.animate(d, l); a["zone-graph-" + h];)a["zone-graph-" + h].animate(d, l), h += 1;
                    f || [
                        a.group,
                        a.markerGroup,
                        a.dataLabelsGroup,
                        a.labelBySeries
                    ].forEach(function(b) {
                        b && b.animate({
                            opacity: n
                        }, l);
                    });
                }
                c && f && a.points && a.setAllPointsToState(b || void 0);
            }
            setAllPointsToState(b) {
                this.points.forEach(function(c) {
                    c.setState && c.setState(b);
                });
            }
            setVisible(b, c) {
                const a = this, d = a.chart, f = d.options.chart.ignoreHiddenSeries, e = a.visible, l = (a.visible = b = a.options.visible = a.userOptions.visible = "undefined" === typeof b ? !e : b) ? "show" : "hide";
                [
                    "group",
                    "dataLabelsGroup",
                    "markerGroup",
                    "tracker",
                    "tt"
                ].forEach(function(b) {
                    if (a[b]) a[b][l]();
                });
                if (d.hoverSeries === a || (d.hoverPoint && d.hoverPoint.series) === a) a.onMouseOut();
                a.legendItem && d.legend.colorizeItem(a, b);
                a.isDirty = !0;
                a.options.stacking && d.series.forEach(function(b) {
                    b.options.stacking && b.visible && (b.isDirty = !0);
                });
                a.linkedSeries.forEach(function(c) {
                    c.setVisible(b, !1);
                });
                f && (d.isDirtyBox = !0);
                k(a, l);
                !1 !== c && d.redraw();
            }
            show() {
                this.setVisible(!0);
            }
            hide() {
                this.setVisible(!1);
            }
            select(b) {
                this.selected = b = this.options.selected = "undefined" === typeof b ? !this.selected : b;
                this.checkbox && (this.checkbox.checked = b);
                k(this, b ? "select" : "unselect");
            }
            shouldShowTooltip(b, c, a = {}) {
                a.series = this;
                a.visiblePlotOnly = !0;
                return this.chart.isInsidePlot(b, c, a);
            }
            drawLegendSymbol(b, c) {
                var a;
                null === (a = G[this.options.legendSymbol || "rectangle"]) || void 0 === a || a.call(this, b, c);
            }
        }
        Z.defaultOptions = E;
        Z.types = B.seriesTypes;
        Z.registerType = B.registerSeriesType;
        b(Z.prototype, {
            axisTypes: [
                "xAxis",
                "yAxis"
            ],
            coll: "series",
            colorCounter: 0,
            cropShoulder: 1,
            directTouch: !1,
            isCartesian: !0,
            kdAxisArray: [
                "clientX",
                "plotY"
            ],
            parallelArrays: [
                "x",
                "y"
            ],
            pointClass: D,
            requireSorting: !0,
            sorted: !0
        });
        B.series = Z;
        "";
        "";
        return Z;
    });
    L(a, "Core/Chart/Chart.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Defaults.js"],
        a["Core/Templating.js"],
        a["Core/Foundation.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Time.js"],
        a["Core/Utilities.js"],
        a["Core/Renderer/HTML/AST.js"]
    ], function(a, A, J, K, G, D, E, B, t, q, m, p, n) {
        const { animate: h, animObject: g, setAnimation: e } = a, { defaultOptions: x, defaultTime: u } = J, { numberFormat: M } = K, { registerEventOptions: C } = G, { charts: f, doc: y, marginNames: r, svg: l, win: v } = D, { seriesTypes: d } = t, { addEvent: b, attr: c, createElement: k, css: w, defined: z, diffObjects: F, discardElement: O, erase: P, error: T, extend: U, find: W, fireEvent: H, getStyle: Y, isArray: ea, isNumber: aa, isObject: Z, isString: N, merge: L, objectEach: Q, pick: R, pInt: V, relativeLength: ha, removeEvent: ia, splat: da, syncTimeout: ja, uniqueKey: ba } = p;
        class S {
            static chart(b, c, a) {
                return new S(b, c, a);
            }
            constructor(b, c, a){
                this.series = this.renderTo = this.renderer = this.pointer = this.pointCount = this.plotWidth = this.plotTop = this.plotLeft = this.plotHeight = this.plotBox = this.options = this.numberFormatter = this.margin = this.labelCollectors = this.isResizing = this.index = this.eventOptions = this.container = this.colorCounter = this.clipBox = this.chartWidth = this.chartHeight = this.bounds = this.axisOffset = this.axes = void 0;
                this.sharedClips = {};
                this.zooming = this.yAxis = this.xAxis = this.userOptions = this.titleOffset = this.time = this.symbolCounter = this.spacingBox = this.spacing = void 0;
                this.getArgs(b, c, a);
            }
            getArgs(b, c, a) {
                N(b) || b.nodeName ? (this.renderTo = b, this.init(c, a)) : this.init(b, c);
            }
            setZoomOptions() {
                const b = this.options.chart, c = b.zooming;
                this.zooming = Object.assign(Object.assign({}, c), {
                    type: R(b.zoomType, c.type),
                    key: R(b.zoomKey, c.key),
                    pinchType: R(b.pinchType, c.pinchType),
                    singleTouch: R(b.zoomBySingleTouch, c.singleTouch, !1),
                    resetButton: L(c.resetButton, b.resetZoomButton)
                });
            }
            init(b, c) {
                H(this, "init", {
                    args: arguments
                }, function() {
                    const a = L(x, b), d = a.chart;
                    this.userOptions = U({}, b);
                    this.margin = [];
                    this.spacing = [];
                    this.bounds = {
                        h: {},
                        v: {}
                    };
                    this.labelCollectors = [];
                    this.callback = c;
                    this.isResizing = 0;
                    this.options = a;
                    this.axes = [];
                    this.series = [];
                    this.time = b.time && Object.keys(b.time).length ? new m(b.time) : D.time;
                    this.numberFormatter = d.numberFormatter || M;
                    this.styledMode = d.styledMode;
                    this.hasCartesianSeries = d.showAxes;
                    this.index = f.length;
                    f.push(this);
                    D.chartCount++;
                    C(this, d);
                    this.xAxis = [];
                    this.yAxis = [];
                    this.pointCount = this.colorCounter = this.symbolCounter = 0;
                    this.setZoomOptions();
                    H(this, "afterInit");
                    this.firstRender();
                });
            }
            initSeries(b) {
                var c = this.options.chart;
                c = b.type || c.type;
                const a = d[c];
                a || T(17, !0, this, {
                    missingModuleFor: c
                });
                c = new a;
                "function" === typeof c.init && c.init(this, b);
                return c;
            }
            setSeriesData() {
                this.getSeriesOrderByLinks().forEach(function(b) {
                    b.points || b.data || !b.enabledDataSorting || b.setData(b.options.data, !1);
                });
            }
            getSeriesOrderByLinks() {
                return this.series.concat().sort(function(b, c) {
                    return b.linkedSeries.length || c.linkedSeries.length ? c.linkedSeries.length - b.linkedSeries.length : 0;
                });
            }
            orderItems(b, c = 0) {
                const a = this[b], d = this.options[b] = da(this.options[b]).slice();
                b = this.userOptions[b] = this.userOptions[b] ? da(this.userOptions[b]).slice() : [];
                this.hasRendered && (d.splice(c), b.splice(c));
                if (a) {
                    for(let k = c, f = a.length; k < f; ++k)if (c = a[k]) c.index = k, c instanceof B && (c.name = c.getName()), c.options.isInternal || (d[k] = c.options, b[k] = c.userOptions);
                }
            }
            isInsidePlot(b, c, a = {}) {
                const { inverted: d, plotBox: k, plotLeft: f, plotTop: e, scrollablePlotBox: l } = this;
                var g = 0;
                let h = 0;
                a.visiblePlotOnly && this.scrollingContainer && ({ scrollLeft: g, scrollTop: h } = this.scrollingContainer);
                const n = a.series, m = a.visiblePlotOnly && l || k;
                var w = a.inverted ? c : b;
                c = a.inverted ? b : c;
                b = {
                    x: w,
                    y: c,
                    isInsidePlot: !0,
                    options: a
                };
                if (!a.ignoreX) {
                    const c = n && (d && !this.polar ? n.yAxis : n.xAxis) || {
                        pos: f,
                        len: Infinity
                    };
                    w = a.paneCoordinates ? c.pos + w : f + w;
                    w >= Math.max(g + f, c.pos) && w <= Math.min(g + f + m.width, c.pos + c.len) || (b.isInsidePlot = !1);
                }
                !a.ignoreY && b.isInsidePlot && (g = !d && a.axis && !a.axis.isXAxis && a.axis || n && (d ? n.xAxis : n.yAxis) || {
                    pos: e,
                    len: Infinity
                }, a = a.paneCoordinates ? g.pos + c : e + c, a >= Math.max(h + e, g.pos) && a <= Math.min(h + e + m.height, g.pos + g.len) || (b.isInsidePlot = !1));
                H(this, "afterIsInsidePlot", b);
                return b.isInsidePlot;
            }
            redraw(b) {
                H(this, "beforeRedraw");
                const c = this.hasCartesianSeries ? this.axes : this.colorAxis || [], a = this.series, d = this.pointer, k = this.legend, f = this.userOptions.legend, l = this.renderer, g = l.isHidden(), h = [];
                let n, m, w = this.isDirtyBox, r = this.isDirtyLegend, v;
                l.rootFontSize = l.boxWrapper.getStyle("font-size");
                this.setResponsive && this.setResponsive(!1);
                e(this.hasRendered ? b : !1, this);
                g && this.temporaryDisplay();
                this.layOutTitles(!1);
                for(b = a.length; b--;)if (v = a[b], v.options.stacking || v.options.centerInCategory) {
                    if (m = !0, v.isDirty) {
                        n = !0;
                        break;
                    }
                }
                if (n) for(b = a.length; b--;)v = a[b], v.options.stacking && (v.isDirty = !0);
                a.forEach(function(b) {
                    b.isDirty && ("point" === b.options.legendType ? ("function" === typeof b.updateTotals && b.updateTotals(), r = !0) : f && (f.labelFormatter || f.labelFormat) && (r = !0));
                    b.isDirtyData && H(b, "updatedData");
                });
                r && k && k.options.enabled && (k.render(), this.isDirtyLegend = !1);
                m && this.getStacks();
                c.forEach(function(b) {
                    b.updateNames();
                    b.setScale();
                });
                this.getMargins();
                c.forEach(function(b) {
                    b.isDirty && (w = !0);
                });
                c.forEach(function(b) {
                    const c = b.min + "," + b.max;
                    b.extKey !== c && (b.extKey = c, h.push(function() {
                        H(b, "afterSetExtremes", U(b.eventArgs, b.getExtremes()));
                        delete b.eventArgs;
                    }));
                    (w || m) && b.redraw();
                });
                w && this.drawChartBox();
                H(this, "predraw");
                a.forEach(function(b) {
                    (w || b.isDirty) && b.visible && b.redraw();
                    b.isDirtyData = !1;
                });
                d && d.reset(!0);
                l.draw();
                H(this, "redraw");
                H(this, "render");
                g && this.temporaryDisplay(!0);
                h.forEach(function(b) {
                    b.call();
                });
            }
            get(b) {
                function c(c) {
                    return c.id === b || c.options && c.options.id === b;
                }
                const a = this.series;
                let d = W(this.axes, c) || W(this.series, c);
                for(let b = 0; !d && b < a.length; b++)d = W(a[b].points || [], c);
                return d;
            }
            getAxes() {
                const b = this.options;
                H(this, "getAxes");
                for (const c of [
                    "xAxis",
                    "yAxis"
                ]){
                    const a = b[c] = da(b[c] || {});
                    for (const b of a)new A(this, b, c);
                }
                H(this, "afterGetAxes");
            }
            getSelectedPoints() {
                return this.series.reduce((b, c)=>{
                    c.getPointsCollection().forEach((c)=>{
                        R(c.selectedStaging, c.selected) && b.push(c);
                    });
                    return b;
                }, []);
            }
            getSelectedSeries() {
                return this.series.filter(function(b) {
                    return b.selected;
                });
            }
            setTitle(b, c, a) {
                this.applyDescription("title", b);
                this.applyDescription("subtitle", c);
                this.applyDescription("caption", void 0);
                this.layOutTitles(a);
            }
            applyDescription(b, c) {
                const a = this, d = this.options[b] = L(this.options[b], c);
                let k = this[b];
                k && c && (this[b] = k = k.destroy());
                d && !k && (k = this.renderer.text(d.text, 0, 0, d.useHTML).attr({
                    align: d.align,
                    "class": "highcharts-" + b,
                    zIndex: d.zIndex || 4
                }).add(), k.update = function(c, d) {
                    a.applyDescription(b, c);
                    a.layOutTitles(d);
                }, this.styledMode || k.css(U("title" === b ? {
                    fontSize: this.options.isStock ? "1em" : "1.2em"
                } : {}, d.style)), this[b] = k);
            }
            layOutTitles(b = !0) {
                const c = [
                    0,
                    0,
                    0
                ], a = this.renderer, d = this.spacingBox;
                [
                    "title",
                    "subtitle",
                    "caption"
                ].forEach(function(b) {
                    const k = this[b], f = this.options[b], e = f.verticalAlign || "top";
                    b = "title" === b ? "top" === e ? -3 : 0 : "top" === e ? c[0] + 2 : 0;
                    if (k) {
                        k.css({
                            width: (f.width || d.width + (f.widthAdjust || 0)) + "px"
                        });
                        const l = a.fontMetrics(k).b, g = Math.round(k.getBBox(f.useHTML).height);
                        k.align(U({
                            y: "bottom" === e ? l : b + l,
                            height: g
                        }, f), !1, "spacingBox");
                        f.floating || ("top" === e ? c[0] = Math.ceil(c[0] + g) : "bottom" === e && (c[2] = Math.ceil(c[2] + g)));
                    }
                }, this);
                c[0] && "top" === (this.options.title.verticalAlign || "top") && (c[0] += this.options.title.margin);
                c[2] && "bottom" === this.options.caption.verticalAlign && (c[2] += this.options.caption.margin);
                const k = !this.titleOffset || this.titleOffset.join(",") !== c.join(",");
                this.titleOffset = c;
                H(this, "afterLayOutTitles");
                !this.isDirtyBox && k && (this.isDirtyBox = this.isDirtyLegend = k, this.hasRendered && b && this.isDirtyBox && this.redraw());
            }
            getContainerBox() {
                return {
                    width: Y(this.renderTo, "width", !0) || 0,
                    height: Y(this.renderTo, "height", !0) || 0
                };
            }
            getChartSize() {
                var b = this.options.chart;
                const c = b.width;
                b = b.height;
                const a = this.getContainerBox();
                this.chartWidth = Math.max(0, c || a.width || 600);
                this.chartHeight = Math.max(0, ha(b, this.chartWidth) || (1 < a.height ? a.height : 400));
                this.containerBox = a;
            }
            temporaryDisplay(b) {
                let c = this.renderTo;
                if (b) for(; c && c.style;)c.hcOrigStyle && (w(c, c.hcOrigStyle), delete c.hcOrigStyle), c.hcOrigDetached && (y.body.removeChild(c), c.hcOrigDetached = !1), c = c.parentNode;
                else for(; c && c.style;){
                    y.body.contains(c) || c.parentNode || (c.hcOrigDetached = !0, y.body.appendChild(c));
                    if ("none" === Y(c, "display", !1) || c.hcOricDetached) c.hcOrigStyle = {
                        display: c.style.display,
                        height: c.style.height,
                        overflow: c.style.overflow
                    }, b = {
                        display: "block",
                        overflow: "hidden"
                    }, c !== this.renderTo && (b.height = 0), w(c, b), c.offsetWidth || c.style.setProperty("display", "block", "important");
                    c = c.parentNode;
                    if (c === y.body) break;
                }
            }
            setClassName(b) {
                this.container.className = "highcharts-container " + (b || "");
            }
            getContainer() {
                const b = this.options, a = b.chart;
                var d = ba();
                let g, h = this.renderTo;
                h || (this.renderTo = h = a.renderTo);
                N(h) && (this.renderTo = h = y.getElementById(h));
                h || T(13, !0, this);
                var m = V(c(h, "data-highcharts-chart"));
                aa(m) && f[m] && f[m].hasRendered && f[m].destroy();
                c(h, "data-highcharts-chart", this.index);
                h.innerHTML = n.emptyHTML;
                a.skipClone || h.offsetWidth || this.temporaryDisplay();
                this.getChartSize();
                m = this.chartWidth;
                const r = this.chartHeight;
                w(h, {
                    overflow: "hidden"
                });
                this.styledMode || (g = U({
                    position: "relative",
                    overflow: "hidden",
                    width: m + "px",
                    height: r + "px",
                    textAlign: "left",
                    lineHeight: "normal",
                    zIndex: 0,
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                    userSelect: "none",
                    "touch-action": "manipulation",
                    outline: "none"
                }, a.style || {}));
                this.container = d = k("div", {
                    id: d
                }, g, h);
                this._cursor = d.style.cursor;
                this.renderer = new (a.renderer || !l ? E.getRendererType(a.renderer) : q)(d, m, r, void 0, a.forExport, b.exporting && b.exporting.allowHTML, this.styledMode);
                this.containerBox = this.getContainerBox();
                e(void 0, this);
                this.setClassName(a.className);
                if (this.styledMode) for(const c in b.defs)this.renderer.definition(b.defs[c]);
                else this.renderer.setStyle(a.style);
                this.renderer.chartIndex = this.index;
                H(this, "afterGetContainer");
            }
            getMargins(b) {
                const { spacing: c, margin: a, titleOffset: d } = this;
                this.resetMargins();
                d[0] && !z(a[0]) && (this.plotTop = Math.max(this.plotTop, d[0] + c[0]));
                d[2] && !z(a[2]) && (this.marginBottom = Math.max(this.marginBottom, d[2] + c[2]));
                this.legend && this.legend.display && this.legend.adjustMargins(a, c);
                H(this, "getMargins");
                b || this.getAxisMargins();
            }
            getAxisMargins() {
                const b = this, c = b.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], a = b.colorAxis, d = b.margin, k = function(b) {
                    b.forEach(function(b) {
                        b.visible && b.getOffset();
                    });
                };
                b.hasCartesianSeries ? k(b.axes) : a && a.length && k(a);
                r.forEach(function(a, k) {
                    z(d[k]) || (b[a] += c[k]);
                });
                b.setChartSize();
            }
            getOptions() {
                return F(this.userOptions, x);
            }
            reflow(b) {
                const c = this;
                var a = c.options.chart;
                a = z(a.width) && z(a.height);
                const d = c.containerBox, k = c.getContainerBox();
                delete c.pointer.chartPosition;
                if (!a && !c.isPrinting && d && k.width) {
                    if (k.width !== d.width || k.height !== d.height) p.clearTimeout(c.reflowTimeout), c.reflowTimeout = ja(function() {
                        c.container && c.setSize(void 0, void 0, !1);
                    }, b ? 100 : 0);
                    c.containerBox = k;
                }
            }
            setReflow() {
                const c = this;
                var a = (b)=>{
                    var a;
                    (null === (a = c.options) || void 0 === a ? 0 : a.chart.reflow) && c.hasLoaded && c.reflow(b);
                };
                "function" === typeof ResizeObserver ? new ResizeObserver(a).observe(c.renderTo) : (a = b(v, "resize", a), b(this, "destroy", a));
            }
            setSize(b, c, a) {
                const d = this, k = d.renderer;
                d.isResizing += 1;
                e(a, d);
                a = k.globalAnimation;
                d.oldChartHeight = d.chartHeight;
                d.oldChartWidth = d.chartWidth;
                "undefined" !== typeof b && (d.options.chart.width = b);
                "undefined" !== typeof c && (d.options.chart.height = c);
                d.getChartSize();
                d.styledMode || (a ? h : w)(d.container, {
                    width: d.chartWidth + "px",
                    height: d.chartHeight + "px"
                }, a);
                d.setChartSize(!0);
                k.setSize(d.chartWidth, d.chartHeight, a);
                d.axes.forEach(function(b) {
                    b.isDirty = !0;
                    b.setScale();
                });
                d.isDirtyLegend = !0;
                d.isDirtyBox = !0;
                d.layOutTitles();
                d.getMargins();
                d.redraw(a);
                d.oldChartHeight = null;
                H(d, "resize");
                ja(function() {
                    d && H(d, "endResize", null, function() {
                        --d.isResizing;
                    });
                }, g(a).duration);
            }
            setChartSize(b) {
                var c = this.inverted;
                const a = this.renderer;
                var d = this.chartWidth, k = this.chartHeight;
                const f = this.options.chart, e = this.spacing, l = this.clipOffset;
                let g, h, n, m;
                this.plotLeft = g = Math.round(this.plotLeft);
                this.plotTop = h = Math.round(this.plotTop);
                this.plotWidth = n = Math.max(0, Math.round(d - g - this.marginRight));
                this.plotHeight = m = Math.max(0, Math.round(k - h - this.marginBottom));
                this.plotSizeX = c ? m : n;
                this.plotSizeY = c ? n : m;
                this.plotBorderWidth = f.plotBorderWidth || 0;
                this.spacingBox = a.spacingBox = {
                    x: e[3],
                    y: e[0],
                    width: d - e[3] - e[1],
                    height: k - e[0] - e[2]
                };
                this.plotBox = a.plotBox = {
                    x: g,
                    y: h,
                    width: n,
                    height: m
                };
                c = 2 * Math.floor(this.plotBorderWidth / 2);
                d = Math.ceil(Math.max(c, l[3]) / 2);
                k = Math.ceil(Math.max(c, l[0]) / 2);
                this.clipBox = {
                    x: d,
                    y: k,
                    width: Math.floor(this.plotSizeX - Math.max(c, l[1]) / 2 - d),
                    height: Math.max(0, Math.floor(this.plotSizeY - Math.max(c, l[2]) / 2 - k))
                };
                b || (this.axes.forEach(function(b) {
                    b.setAxisSize();
                    b.setAxisTranslation();
                }), a.alignElements());
                H(this, "afterSetChartSize", {
                    skipAxes: b
                });
            }
            resetMargins() {
                H(this, "resetMargins");
                const b = this, c = b.options.chart;
                [
                    "margin",
                    "spacing"
                ].forEach(function(a) {
                    const d = c[a], k = Z(d) ? d : [
                        d,
                        d,
                        d,
                        d
                    ];
                    [
                        "Top",
                        "Right",
                        "Bottom",
                        "Left"
                    ].forEach(function(d, f) {
                        b[a][f] = R(c[a + d], k[f]);
                    });
                });
                r.forEach(function(c, a) {
                    b[c] = R(b.margin[a], b.spacing[a]);
                });
                b.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ];
                b.clipOffset = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            drawChartBox() {
                const b = this.options.chart, c = this.renderer, a = this.chartWidth, d = this.chartHeight, k = this.styledMode, f = this.plotBGImage;
                var e = b.backgroundColor;
                const l = b.plotBackgroundColor, g = b.plotBackgroundImage, h = this.plotLeft, n = this.plotTop, m = this.plotWidth, w = this.plotHeight, r = this.plotBox, v = this.clipRect, z = this.clipBox;
                let p = this.chartBackground, q = this.plotBackground, F = this.plotBorder, y, x, t = "animate";
                p || (this.chartBackground = p = c.rect().addClass("highcharts-background").add(), t = "attr");
                if (k) y = x = p.strokeWidth();
                else {
                    y = b.borderWidth || 0;
                    x = y + (b.shadow ? 8 : 0);
                    e = {
                        fill: e || "none"
                    };
                    if (y || p["stroke-width"]) e.stroke = b.borderColor, e["stroke-width"] = y;
                    p.attr(e).shadow(b.shadow);
                }
                p[t]({
                    x: x / 2,
                    y: x / 2,
                    width: a - x - y % 2,
                    height: d - x - y % 2,
                    r: b.borderRadius
                });
                t = "animate";
                q || (t = "attr", this.plotBackground = q = c.rect().addClass("highcharts-plot-background").add());
                q[t](r);
                k || (q.attr({
                    fill: l || "none"
                }).shadow(b.plotShadow), g && (f ? (g !== f.attr("href") && f.attr("href", g), f.animate(r)) : this.plotBGImage = c.image(g, h, n, m, w).add()));
                v ? v.animate({
                    width: z.width,
                    height: z.height
                }) : this.clipRect = c.clipRect(z);
                t = "animate";
                F || (t = "attr", this.plotBorder = F = c.rect().addClass("highcharts-plot-border").attr({
                    zIndex: 1
                }).add());
                k || F.attr({
                    stroke: b.plotBorderColor,
                    "stroke-width": b.plotBorderWidth || 0,
                    fill: "none"
                });
                F[t](F.crisp({
                    x: h,
                    y: n,
                    width: m,
                    height: w
                }, -F.strokeWidth()));
                this.isDirtyBox = !1;
                H(this, "afterDrawChartBox");
            }
            propFromSeries() {
                const b = this, c = b.options.chart, a = b.options.series;
                let k, f, e;
                [
                    "inverted",
                    "angular",
                    "polar"
                ].forEach(function(l) {
                    f = d[c.type];
                    e = c[l] || f && f.prototype[l];
                    for(k = a && a.length; !e && k--;)(f = d[a[k].type]) && f.prototype[l] && (e = !0);
                    b[l] = e;
                });
            }
            linkSeries(b) {
                const c = this, a = c.series;
                a.forEach(function(b) {
                    b.linkedSeries.length = 0;
                });
                a.forEach(function(b) {
                    let a = b.options.linkedTo;
                    N(a) && (a = ":previous" === a ? c.series[b.index - 1] : c.get(a)) && a.linkedParent !== b && (a.linkedSeries.push(b), b.linkedParent = a, a.enabledDataSorting && b.setDataSortingOptions(), b.visible = R(b.options.visible, a.options.visible, b.visible));
                });
                H(this, "afterLinkSeries", {
                    isUpdating: b
                });
            }
            renderSeries() {
                this.series.forEach(function(b) {
                    b.translate();
                    b.render();
                });
            }
            render() {
                const b = this.axes, c = this.colorAxis, a = this.renderer, d = function(b) {
                    b.forEach(function(b) {
                        b.visible && b.render();
                    });
                };
                let k = 0;
                this.setTitle();
                H(this, "beforeMargins");
                this.getStacks && this.getStacks();
                this.getMargins(!0);
                this.setChartSize();
                const f = this.plotWidth;
                b.some(function(b) {
                    if (b.horiz && b.visible && b.options.labels.enabled && b.series.length) return k = 21, !0;
                });
                const e = this.plotHeight = Math.max(this.plotHeight - k, 0);
                b.forEach(function(b) {
                    b.setScale();
                });
                this.getAxisMargins();
                const l = 1.1 < f / this.plotWidth, g = 1.05 < e / this.plotHeight;
                if (l || g) b.forEach(function(b) {
                    (b.horiz && l || !b.horiz && g) && b.setTickInterval(!0);
                }), this.getMargins();
                this.drawChartBox();
                this.hasCartesianSeries ? d(b) : c && c.length && d(c);
                this.seriesGroup || (this.seriesGroup = a.g("series-group").attr({
                    zIndex: 3
                }).shadow(this.options.chart.seriesGroupShadow).add());
                this.renderSeries();
                this.addCredits();
                this.setResponsive && this.setResponsive();
                this.hasRendered = !0;
            }
            addCredits(b) {
                const c = this, a = L(!0, this.options.credits, b);
                a.enabled && !this.credits && (this.credits = this.renderer.text(a.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                    a.href && (v.location.href = a.href);
                }).attr({
                    align: a.position.align,
                    zIndex: 8
                }), c.styledMode || this.credits.css(a.style), this.credits.add().align(a.position), this.credits.update = function(b) {
                    c.credits = c.credits.destroy();
                    c.addCredits(b);
                });
            }
            destroy() {
                const b = this, c = b.axes, a = b.series, d = b.container, k = d && d.parentNode;
                let e;
                H(b, "destroy");
                b.renderer.forExport ? P(f, b) : f[b.index] = void 0;
                D.chartCount--;
                b.renderTo.removeAttribute("data-highcharts-chart");
                ia(b);
                for(e = c.length; e--;)c[e] = c[e].destroy();
                this.scroller && this.scroller.destroy && this.scroller.destroy();
                for(e = a.length; e--;)a[e] = a[e].destroy();
                "title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(c) {
                    const a = b[c];
                    a && a.destroy && (b[c] = a.destroy());
                });
                d && (d.innerHTML = n.emptyHTML, ia(d), k && O(d));
                Q(b, function(c, a) {
                    delete b[a];
                });
            }
            firstRender() {
                const b = this, c = b.options;
                b.getContainer();
                b.resetMargins();
                b.setChartSize();
                b.propFromSeries();
                b.getAxes();
                const a = ea(c.series) ? c.series : [];
                c.series = [];
                a.forEach(function(c) {
                    b.initSeries(c);
                });
                b.linkSeries();
                b.setSeriesData();
                H(b, "beforeRender");
                b.render();
                b.pointer.getChartPosition();
                if (!b.renderer.imgCount && !b.hasLoaded) b.onload();
                b.temporaryDisplay(!0);
            }
            onload() {
                this.callbacks.concat([
                    this.callback
                ]).forEach(function(b) {
                    b && "undefined" !== typeof this.index && b.apply(this, [
                        this
                    ]);
                }, this);
                H(this, "load");
                H(this, "render");
                z(this.index) && this.setReflow();
                this.warnIfA11yModuleNotLoaded();
                this.hasLoaded = !0;
            }
            warnIfA11yModuleNotLoaded() {
                const { options: b, title: c } = this;
                b && !this.accessibility && (this.renderer.boxWrapper.attr({
                    role: "img",
                    "aria-label": (c && c.element.textContent || "").replace(/</g, "&lt;")
                }), b.accessibility && !1 === b.accessibility.enabled || T('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
            }
            addSeries(b, c, a) {
                const d = this;
                let k;
                b && (c = R(c, !0), H(d, "addSeries", {
                    options: b
                }, function() {
                    k = d.initSeries(b);
                    d.isDirtyLegend = !0;
                    d.linkSeries();
                    k.enabledDataSorting && k.setData(b.data, !1);
                    H(d, "afterAddSeries", {
                        series: k
                    });
                    c && d.redraw(a);
                }));
                return k;
            }
            addAxis(b, c, a, d) {
                return this.createAxis(c ? "xAxis" : "yAxis", {
                    axis: b,
                    redraw: a,
                    animation: d
                });
            }
            addColorAxis(b, c, a) {
                return this.createAxis("colorAxis", {
                    axis: b,
                    redraw: c,
                    animation: a
                });
            }
            createAxis(b, c) {
                b = new A(this, c.axis, b);
                R(c.redraw, !0) && this.redraw(c.animation);
                return b;
            }
            showLoading(c) {
                const a = this, d = a.options, f = d.loading, e = function() {
                    l && w(l, {
                        left: a.plotLeft + "px",
                        top: a.plotTop + "px",
                        width: a.plotWidth + "px",
                        height: a.plotHeight + "px"
                    });
                };
                let l = a.loadingDiv, g = a.loadingSpan;
                l || (a.loadingDiv = l = k("div", {
                    className: "highcharts-loading highcharts-loading-hidden"
                }, null, a.container));
                g || (a.loadingSpan = g = k("span", {
                    className: "highcharts-loading-inner"
                }, null, l), b(a, "redraw", e));
                l.className = "highcharts-loading";
                n.setElementHTML(g, R(c, d.lang.loading, ""));
                a.styledMode || (w(l, U(f.style, {
                    zIndex: 10
                })), w(g, f.labelStyle), a.loadingShown || (w(l, {
                    opacity: 0,
                    display: ""
                }), h(l, {
                    opacity: f.style.opacity || .5
                }, {
                    duration: f.showDuration || 0
                })));
                a.loadingShown = !0;
                e();
            }
            hideLoading() {
                const b = this.options, c = this.loadingDiv;
                c && (c.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || h(c, {
                    opacity: 0
                }, {
                    duration: b.loading.hideDuration || 100,
                    complete: function() {
                        w(c, {
                            display: "none"
                        });
                    }
                }));
                this.loadingShown = !1;
            }
            update(b, c, a, d) {
                const k = this, f = {
                    credits: "addCredits",
                    title: "setTitle",
                    subtitle: "setSubtitle",
                    caption: "setCaption"
                }, e = b.isResponsiveOptions, l = [];
                let g, h;
                H(k, "update", {
                    options: b
                });
                e || k.setResponsive(!1, !0);
                b = F(b, k.options);
                k.userOptions = L(k.userOptions, b);
                var n = b.chart;
                if (n) {
                    L(!0, k.options.chart, n);
                    this.setZoomOptions();
                    "className" in n && k.setClassName(n.className);
                    if ("inverted" in n || "polar" in n || "type" in n) {
                        k.propFromSeries();
                        var w = !0;
                    }
                    "alignTicks" in n && (w = !0);
                    "events" in n && C(this, n);
                    Q(n, function(b, c) {
                        -1 !== k.propsRequireUpdateSeries.indexOf("chart." + c) && (g = !0);
                        -1 !== k.propsRequireDirtyBox.indexOf(c) && (k.isDirtyBox = !0);
                        -1 !== k.propsRequireReflow.indexOf(c) && (e ? k.isDirtyBox = !0 : h = !0);
                    });
                    !k.styledMode && n.style && k.renderer.setStyle(k.options.chart.style || {});
                }
                !k.styledMode && b.colors && (this.options.colors = b.colors);
                b.time && (this.time === u && (this.time = new m(b.time)), L(!0, k.options.time, b.time));
                Q(b, function(c, a) {
                    if (k[a] && "function" === typeof k[a].update) k[a].update(c, !1);
                    else if ("function" === typeof k[f[a]]) k[f[a]](c);
                    else "colors" !== a && -1 === k.collectionsWithUpdate.indexOf(a) && L(!0, k.options[a], b[a]);
                    "chart" !== a && -1 !== k.propsRequireUpdateSeries.indexOf(a) && (g = !0);
                });
                this.collectionsWithUpdate.forEach(function(c) {
                    b[c] && (da(b[c]).forEach(function(b, d) {
                        const f = z(b.id);
                        let e;
                        f && (e = k.get(b.id));
                        !e && k[c] && (e = k[c][R(b.index, d)]) && (f && z(e.options.id) || e.options.isInternal) && (e = void 0);
                        e && e.coll === c && (e.update(b, !1), a && (e.touched = !0));
                        !e && a && k.collectionsWithInit[c] && (k.collectionsWithInit[c][0].apply(k, [
                            b
                        ].concat(k.collectionsWithInit[c][1] || []).concat([
                            !1
                        ])).touched = !0);
                    }), a && k[c].forEach(function(b) {
                        b.touched || b.options.isInternal ? delete b.touched : l.push(b);
                    }));
                });
                l.forEach(function(b) {
                    b.chart && b.remove && b.remove(!1);
                });
                w && k.axes.forEach(function(b) {
                    b.update({}, !1);
                });
                g && k.getSeriesOrderByLinks().forEach(function(b) {
                    b.chart && b.update({}, !1);
                }, this);
                w = n && n.width;
                n = n && (N(n.height) ? ha(n.height, w || k.chartWidth) : n.height);
                h || aa(w) && w !== k.chartWidth || aa(n) && n !== k.chartHeight ? k.setSize(w, n, d) : R(c, !0) && k.redraw(d);
                H(k, "afterUpdate", {
                    options: b,
                    redraw: c,
                    animation: d
                });
            }
            setSubtitle(b, c) {
                this.applyDescription("subtitle", b);
                this.layOutTitles(c);
            }
            setCaption(b, c) {
                this.applyDescription("caption", b);
                this.layOutTitles(c);
            }
            showResetZoom() {
                function b() {
                    c.zoomOut();
                }
                const c = this, a = x.lang, d = c.zooming.resetButton, k = d.theme, f = "chart" === d.relativeTo || "spacingBox" === d.relativeTo ? null : "scrollablePlotBox";
                H(this, "beforeShowResetZoom", null, function() {
                    c.resetZoomButton = c.renderer.button(a.resetZoom, null, null, b, k).attr({
                        align: d.position.align,
                        title: a.resetZoomTitle
                    }).addClass("highcharts-reset-zoom").add().align(d.position, !1, f);
                });
                H(this, "afterShowResetZoom");
            }
            zoomOut() {
                H(this, "selection", {
                    resetSelection: !0
                }, this.zoom);
            }
            zoom(b) {
                const c = this, a = c.pointer;
                let d = !1, k;
                !b || b.resetSelection ? (c.axes.forEach(function(b) {
                    k = b.zoom();
                }), a.initiated = !1) : b.xAxis.concat(b.yAxis).forEach(function(b) {
                    const f = b.axis;
                    if (a[f.isXAxis ? "zoomX" : "zoomY"] && z(a.mouseDownX) && z(a.mouseDownY) && c.isInsidePlot(a.mouseDownX - c.plotLeft, a.mouseDownY - c.plotTop, {
                        axis: f
                    }) || !z(c.inverted ? a.mouseDownX : a.mouseDownY)) k = f.zoom(b.min, b.max), f.displayBtn && (d = !0);
                });
                const f = c.resetZoomButton;
                d && !f ? c.showResetZoom() : !d && Z(f) && (c.resetZoomButton = f.destroy());
                k && c.redraw(R(c.options.chart.animation, b && b.animation, 100 > c.pointCount));
            }
            pan(b, c) {
                const a = this, d = a.hoverPoints;
                c = "object" === typeof c ? c : {
                    enabled: c,
                    type: "x"
                };
                const k = a.options.chart;
                k && k.panning && (k.panning = c);
                const f = c.type;
                let e;
                H(this, "pan", {
                    originalEvent: b
                }, function() {
                    d && d.forEach(function(b) {
                        b.setState();
                    });
                    let c = a.xAxis;
                    "xy" === f ? c = c.concat(a.yAxis) : "y" === f && (c = a.yAxis);
                    const k = {};
                    c.forEach(function(c) {
                        if (c.options.panningEnabled && !c.options.isInternal) {
                            var d = c.horiz, l = b[d ? "chartX" : "chartY"];
                            d = d ? "mouseDownX" : "mouseDownY";
                            var g = a[d], h = c.minPointOffset || 0, n = c.reversed && !a.inverted || !c.reversed && a.inverted ? -1 : 1, m = c.getExtremes(), w = c.toValue(g - l, !0) + h * n, r = c.toValue(g + c.len - l, !0) - (h * n || c.isXAxis && c.pointRangePadding || 0), v = r < w;
                            n = c.hasVerticalPanning();
                            g = v ? r : w;
                            w = v ? w : r;
                            var z = c.panningState;
                            !n || c.isXAxis || z && !z.isDirty || c.series.forEach(function(b) {
                                var c = b.getProcessedData(!0);
                                c = b.getExtremes(c.yData, !0);
                                z || (z = {
                                    startMin: Number.MAX_VALUE,
                                    startMax: -Number.MAX_VALUE
                                });
                                aa(c.dataMin) && aa(c.dataMax) && (z.startMin = Math.min(R(b.options.threshold, Infinity), c.dataMin, z.startMin), z.startMax = Math.max(R(b.options.threshold, -Infinity), c.dataMax, z.startMax));
                            });
                            n = Math.min(R(z && z.startMin, m.dataMin), h ? m.min : c.toValue(c.toPixels(m.min) - c.minPixelPadding));
                            r = Math.max(R(z && z.startMax, m.dataMax), h ? m.max : c.toValue(c.toPixels(m.max) + c.minPixelPadding));
                            c.panningState = z;
                            c.isOrdinal || (h = n - g, 0 < h && (w += h, g = n), h = w - r, 0 < h && (w = r, g -= h), c.series.length && g !== m.min && w !== m.max && g >= n && w <= r && (c.setExtremes(g, w, !1, !1, {
                                trigger: "pan"
                            }), !a.resetZoomButton && g !== n && w !== r && f.match("y") && (a.showResetZoom(), c.displayBtn = !1), e = !0), k[d] = l);
                        }
                    });
                    Q(k, (b, c)=>{
                        a[c] = b;
                    });
                    e && a.redraw(!1);
                    w(a.container, {
                        cursor: "move"
                    });
                });
            }
        }
        U(S.prototype, {
            callbacks: [],
            collectionsWithInit: {
                xAxis: [
                    S.prototype.addAxis,
                    [
                        !0
                    ]
                ],
                yAxis: [
                    S.prototype.addAxis,
                    [
                        !1
                    ]
                ],
                series: [
                    S.prototype.addSeries
                ]
            },
            collectionsWithUpdate: [
                "xAxis",
                "yAxis",
                "series"
            ],
            propsRequireDirtyBox: "backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
            propsRequireReflow: "margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
            propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" ")
        });
        "";
        return S;
    });
    L(a, "Extensions/ScrollablePlotArea.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Chart/Chart.js"],
        a["Core/Series/Series.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D) {
        const { stop: u } = a, { addEvent: B, createElement: t, defined: q, merge: m, pick: p } = D;
        B(J, "afterSetChartSize", function(a) {
            var h = this.options.chart.scrollablePlotArea, g = h && h.minWidth;
            h = h && h.minHeight;
            let e;
            if (!this.renderer.forExport) {
                if (g) {
                    if (this.scrollablePixelsX = g = Math.max(0, g - this.chartWidth)) this.scrollablePlotBox = this.renderer.scrollablePlotBox = m(this.plotBox), this.plotBox.width = this.plotWidth += g, this.inverted ? this.clipBox.height += g : this.clipBox.width += g, e = {
                        1: {
                            name: "right",
                            value: g
                        }
                    };
                } else h && (this.scrollablePixelsY = g = Math.max(0, h - this.chartHeight), q(g) && (this.scrollablePlotBox = this.renderer.scrollablePlotBox = m(this.plotBox), this.plotBox.height = this.plotHeight += g, this.inverted ? this.clipBox.width += g : this.clipBox.height += g, e = {
                    2: {
                        name: "bottom",
                        value: g
                    }
                }));
                e && !a.skipAxes && this.axes.forEach(function(a) {
                    e[a.side] ? a.getPlotLinePath = function() {
                        let g = e[a.side].name, h = this[g], n;
                        this[g] = h - e[a.side].value;
                        n = A.prototype.getPlotLinePath.apply(this, arguments);
                        this[g] = h;
                        return n;
                    } : (a.setAxisSize(), a.setAxisTranslation());
                });
            }
        });
        B(J, "render", function() {
            this.scrollablePixelsX || this.scrollablePixelsY ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
        });
        J.prototype.setUpScrolling = function() {
            const a = {
                WebkitOverflowScrolling: "touch",
                overflowX: "hidden",
                overflowY: "hidden"
            };
            this.scrollablePixelsX && (a.overflowX = "auto");
            this.scrollablePixelsY && (a.overflowY = "auto");
            this.scrollingParent = t("div", {
                className: "highcharts-scrolling-parent"
            }, {
                position: "relative"
            }, this.renderTo);
            this.scrollingContainer = t("div", {
                className: "highcharts-scrolling"
            }, a, this.scrollingParent);
            let h;
            B(this.scrollingContainer, "scroll", ()=>{
                this.pointer && (delete this.pointer.chartPosition, this.hoverPoint && (h = this.hoverPoint), this.pointer.runPointActions(void 0, h, !0));
            });
            this.innerContainer = t("div", {
                className: "highcharts-inner-container"
            }, null, this.scrollingContainer);
            this.innerContainer.appendChild(this.container);
            this.setUpScrolling = null;
        };
        J.prototype.moveFixedElements = function() {
            let a = this.container, h = this.fixedRenderer, g = ".highcharts-breadcrumbs-group .highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-drillup-button .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "), e;
            this.scrollablePixelsX && !this.inverted ? e = ".highcharts-yaxis" : this.scrollablePixelsX && this.inverted ? e = ".highcharts-xaxis" : this.scrollablePixelsY && !this.inverted ? e = ".highcharts-xaxis" : this.scrollablePixelsY && this.inverted && (e = ".highcharts-yaxis");
            e && g.push(`${e}:not(.highcharts-radial-axis)`, `${e}-labels:not(.highcharts-radial-axis-labels)`);
            g.forEach(function(e) {
                [].forEach.call(a.querySelectorAll(e), function(a) {
                    (a.namespaceURI === h.SVG_NS ? h.box : h.box.parentNode).appendChild(a);
                    a.style.pointerEvents = "auto";
                });
            });
        };
        J.prototype.applyFixed = function() {
            var a = !this.fixedDiv, h = this.options.chart, g = h.scrollablePlotArea, e = G.getRendererType();
            a ? (this.fixedDiv = t("div", {
                className: "highcharts-fixed"
            }, {
                position: "absolute",
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: (h.style && h.style.zIndex || 0) + 2,
                top: 0
            }, null, !0), this.scrollingContainer && this.scrollingContainer.parentNode.insertBefore(this.fixedDiv, this.scrollingContainer), this.renderTo.style.overflow = "visible", this.fixedRenderer = h = new e(this.fixedDiv, this.chartWidth, this.chartHeight, this.options.chart.style), this.scrollableMask = h.path().attr({
                fill: this.options.chart.backgroundColor || "#fff",
                "fill-opacity": p(g.opacity, .85),
                zIndex: -1
            }).addClass("highcharts-scrollable-mask").add(), B(this, "afterShowResetZoom", this.moveFixedElements), B(this, "afterApplyDrilldown", this.moveFixedElements), B(this, "afterLayOutTitles", this.moveFixedElements)) : this.fixedRenderer.setSize(this.chartWidth, this.chartHeight);
            if (this.scrollableDirty || a) this.scrollableDirty = !1, this.moveFixedElements();
            h = this.chartWidth + (this.scrollablePixelsX || 0);
            e = this.chartHeight + (this.scrollablePixelsY || 0);
            u(this.container);
            this.container.style.width = h + "px";
            this.container.style.height = e + "px";
            this.renderer.boxWrapper.attr({
                width: h,
                height: e,
                viewBox: [
                    0,
                    0,
                    h,
                    e
                ].join(" ")
            });
            this.chartBackground.attr({
                width: h,
                height: e
            });
            this.scrollingContainer.style.height = this.chartHeight + "px";
            a && (g.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixelsX * g.scrollPositionX), g.scrollPositionY && (this.scrollingContainer.scrollTop = this.scrollablePixelsY * g.scrollPositionY));
            e = this.axisOffset;
            a = this.plotTop - e[0] - 1;
            g = this.plotLeft - e[3] - 1;
            h = this.plotTop + this.plotHeight + e[2] + 1;
            e = this.plotLeft + this.plotWidth + e[1] + 1;
            let m = this.plotLeft + this.plotWidth - (this.scrollablePixelsX || 0), q = this.plotTop + this.plotHeight - (this.scrollablePixelsY || 0);
            a = this.scrollablePixelsX ? [
                [
                    "M",
                    0,
                    a
                ],
                [
                    "L",
                    this.plotLeft - 1,
                    a
                ],
                [
                    "L",
                    this.plotLeft - 1,
                    h
                ],
                [
                    "L",
                    0,
                    h
                ],
                [
                    "Z"
                ],
                [
                    "M",
                    m,
                    a
                ],
                [
                    "L",
                    this.chartWidth,
                    a
                ],
                [
                    "L",
                    this.chartWidth,
                    h
                ],
                [
                    "L",
                    m,
                    h
                ],
                [
                    "Z"
                ]
            ] : this.scrollablePixelsY ? [
                [
                    "M",
                    g,
                    0
                ],
                [
                    "L",
                    g,
                    this.plotTop - 1
                ],
                [
                    "L",
                    e,
                    this.plotTop - 1
                ],
                [
                    "L",
                    e,
                    0
                ],
                [
                    "Z"
                ],
                [
                    "M",
                    g,
                    q
                ],
                [
                    "L",
                    g,
                    this.chartHeight
                ],
                [
                    "L",
                    e,
                    this.chartHeight
                ],
                [
                    "L",
                    e,
                    q
                ],
                [
                    "Z"
                ]
            ] : [
                [
                    "M",
                    0,
                    0
                ]
            ];
            "adjustHeight" !== this.redrawTrigger && this.scrollableMask.attr({
                d: a
            });
        };
        B(A, "afterInit", function() {
            this.chart.scrollableDirty = !0;
        });
        B(K, "show", function() {
            this.chart.scrollableDirty = !0;
        });
        "";
    });
    L(a, "Core/Axis/Stacking/StackItem.js", [
        a["Core/Templating.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { format: u } = a, { series: G } = A, { destroyObjectProperties: D, fireEvent: E, isNumber: B, pick: t } = J;
        class q {
            constructor(a, p, n, h, g){
                const e = a.chart.inverted, m = a.reversed;
                this.axis = a;
                a = this.isNegative = !!n !== !!m;
                this.options = p = p || {};
                this.x = h;
                this.cumulative = this.total = null;
                this.points = {};
                this.hasValidPoints = !1;
                this.stack = g;
                this.rightCliff = this.leftCliff = 0;
                this.alignOptions = {
                    align: p.align || (e ? a ? "left" : "right" : "center"),
                    verticalAlign: p.verticalAlign || (e ? "middle" : a ? "bottom" : "top"),
                    y: p.y,
                    x: p.x
                };
                this.textAlign = p.textAlign || (e ? a ? "right" : "left" : "center");
            }
            destroy() {
                D(this, this.axis);
            }
            render(a) {
                const m = this.axis.chart, n = this.options;
                var h = n.format;
                h = h ? u(h, this, m) : n.formatter.call(this);
                this.label ? this.label.attr({
                    text: h,
                    visibility: "hidden"
                }) : (this.label = m.renderer.label(h, null, void 0, n.shape, void 0, void 0, n.useHTML, !1, "stack-labels"), h = {
                    r: n.borderRadius || 0,
                    text: h,
                    padding: t(n.padding, 5),
                    visibility: "hidden"
                }, m.styledMode || (h.fill = n.backgroundColor, h.stroke = n.borderColor, h["stroke-width"] = n.borderWidth, this.label.css(n.style || {})), this.label.attr(h), this.label.added || this.label.add(a));
                this.label.labelrank = m.plotSizeY;
                E(this, "afterRender");
            }
            setOffset(a, p, n, h, g, e) {
                const { alignOptions: m, axis: q, label: u, options: C, textAlign: f } = this, y = q.chart;
                n = this.getStackBox({
                    xOffset: a,
                    width: p,
                    boxBottom: n,
                    boxTop: h,
                    defaultX: g,
                    xAxis: e
                });
                var { verticalAlign: r } = m;
                if (u && n) {
                    h = u.getBBox();
                    g = u.padding;
                    e = "justify" === t(C.overflow, "justify");
                    m.x = C.x || 0;
                    m.y = C.y || 0;
                    const { x: a, y: v } = this.adjustStackPosition({
                        labelBox: h,
                        verticalAlign: r,
                        textAlign: f
                    });
                    n.x -= a;
                    n.y -= v;
                    u.align(m, !1, n);
                    (r = y.isInsidePlot(u.alignAttr.x + m.x + a, u.alignAttr.y + m.y + v)) || (e = !1);
                    e && G.prototype.justifyDataLabel.call(q, u, m, u.alignAttr, h, n);
                    u.attr({
                        x: u.alignAttr.x,
                        y: u.alignAttr.y,
                        rotation: C.rotation,
                        rotationOriginX: h.width / 2,
                        rotationOriginY: h.height / 2
                    });
                    t(!e && C.crop, !0) && (r = B(u.x) && B(u.y) && y.isInsidePlot(u.x - g + u.width, u.y) && y.isInsidePlot(u.x + g, u.y));
                    u[r ? "show" : "hide"]();
                }
                E(this, "afterSetOffset", {
                    xOffset: a,
                    width: p
                });
            }
            adjustStackPosition({ labelBox: a, verticalAlign: p, textAlign: n }) {
                const h = {
                    bottom: 0,
                    middle: 1,
                    top: 2,
                    right: 1,
                    center: 0,
                    left: -1
                };
                return {
                    x: a.width / 2 + a.width / 2 * h[n],
                    y: a.height / 2 * h[p]
                };
            }
            getStackBox(a) {
                var m = this.axis;
                const n = m.chart, { boxTop: h, defaultX: g, xOffset: e, width: q, boxBottom: u } = a;
                var M = m.stacking.usePercentage ? 100 : t(h, this.total, 0);
                M = m.toPixels(M);
                a = a.xAxis || n.xAxis[0];
                const C = t(g, a.translate(this.x)) + e;
                m = m.toPixels(u || B(m.min) && m.logarithmic && m.logarithmic.lin2log(m.min) || 0);
                m = Math.abs(M - m);
                const f = this.isNegative;
                return n.inverted ? {
                    x: (f ? M : M - m) - n.plotLeft,
                    y: a.height - C - q,
                    width: m,
                    height: q
                } : {
                    x: C + a.transB - n.plotLeft,
                    y: (f ? M - m : M) - n.plotTop,
                    width: q,
                    height: m
                };
            }
        }
        "";
        return q;
    });
    L(a, "Core/Axis/Stacking/StackingAxis.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Axis/Stacking/StackItem.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G) {
        function u() {
            const b = this, c = b.inverted;
            b.yAxis.forEach((b)=>{
                b.stacking && b.stacking.stacks && b.hasVisibleSeries && (b.stacking.oldStacks = b.stacking.stacks);
            });
            b.series.forEach((a)=>{
                const d = a.xAxis && a.xAxis.options || {};
                !a.options.stacking || !0 !== a.visible && !1 !== b.options.chart.ignoreHiddenSeries || (a.stackKey = [
                    a.type,
                    l(a.options.stack, ""),
                    c ? d.top : d.left,
                    c ? d.height : d.width
                ].join());
            });
        }
        function E() {
            const b = this.stacking;
            if (b) {
                var c = b.stacks;
                r(c, function(b, a) {
                    M(b);
                    c[a] = null;
                });
                b && b.stackTotalGroup && b.stackTotalGroup.destroy();
            }
        }
        function B() {
            "yAxis" !== this.coll || this.stacking || (this.stacking = new v(this));
        }
        function t(b, c, a, d) {
            !I(b) || b.x !== c || d && b.stackKey !== d ? b = {
                x: c,
                index: 0,
                key: d,
                stackKey: d
            } : b.index++;
            b.key = [
                a,
                c,
                b.index
            ].join();
            return b;
        }
        function q() {
            const b = this, c = b.stackKey, a = b.yAxis.stacking.stacks, d = b.processedXData, f = b[b.options.stacking + "Stacker"];
            let e;
            f && [
                c,
                "-" + c
            ].forEach((c)=>{
                let k = d.length;
                let l;
                for(; k--;){
                    var g = d[k];
                    e = b.getStackIndicator(e, g, b.index, c);
                    (l = (g = a[c] && a[c][g]) && g.points[e.key]) && f.call(b, l, g, k);
                }
            });
        }
        function m(b, c, a) {
            c = c.total ? 100 / c.total : 0;
            b[0] = x(b[0] * c);
            b[1] = x(b[1] * c);
            this.stackedYData[a] = b[1];
        }
        function p() {
            const b = this.yAxis.stacking;
            this.options.centerInCategory && (this.is("column") || this.is("columnrange")) && !this.options.stacking && 1 < this.chart.series.length ? g.setStackedPoints.call(this, "group") : b && r(b.stacks, (c, a)=>{
                "group" === a.slice(-5) && (r(c, (b)=>b.destroy()), delete b.stacks[a]);
            });
        }
        function n(b) {
            var c = this.chart;
            const a = b || this.options.stacking;
            if (a && (!0 === this.visible || !1 === c.options.chart.ignoreHiddenSeries)) {
                var d = this.processedXData, e = this.processedYData, g = [], h = e.length, n = this.options, m = n.threshold, r = l(n.startFromThreshold && m, 0);
                n = n.stack;
                b = b ? `${this.type},${a}` : this.stackKey;
                var v = "-" + b, p = this.negStacks;
                c = "group" === a ? c.yAxis[0] : this.yAxis;
                var q = c.stacking.stacks, y = c.stacking.oldStacks, t, u;
                c.stacking.stacksTouched += 1;
                for(u = 0; u < h; u++){
                    var C = d[u];
                    var B = e[u];
                    var M = this.getStackIndicator(M, C, this.index);
                    var A = M.key;
                    var E = (t = p && B < (r ? 0 : m)) ? v : b;
                    q[E] || (q[E] = {});
                    q[E][C] || (y[E] && y[E][C] ? (q[E][C] = y[E][C], q[E][C].total = null) : q[E][C] = new K(c, c.options.stackLabels, !!t, C, n));
                    E = q[E][C];
                    null !== B ? (E.points[A] = E.points[this.index] = [
                        l(E.cumulative, r)
                    ], I(E.cumulative) || (E.base = A), E.touched = c.stacking.stacksTouched, 0 < M.index && !1 === this.singleStacks && (E.points[A][0] = E.points[this.index + "," + C + ",0"][0])) : E.points[A] = E.points[this.index] = null;
                    "percent" === a ? (t = t ? b : v, p && q[t] && q[t][C] ? (t = q[t][C], E.total = t.total = Math.max(t.total, E.total) + Math.abs(B) || 0) : E.total = x(E.total + (Math.abs(B) || 0))) : "group" === a ? (f(B) && (B = B[0]), null !== B && (E.total = (E.total || 0) + 1)) : E.total = x(E.total + (B || 0));
                    E.cumulative = "group" === a ? (E.total || 1) - 1 : x(l(E.cumulative, r) + (B || 0));
                    null !== B && (E.points[A].push(E.cumulative), g[u] = E.cumulative, E.hasValidPoints = !0);
                }
                "percent" === a && (c.stacking.usePercentage = !0);
                "group" !== a && (this.stackedYData = g);
                c.stacking.oldStacks = {};
            }
        }
        const { getDeferredAnimation: h } = a, { series: { prototype: g } } = J, { addEvent: e, correctFloat: x, defined: I, destroyObjectProperties: M, fireEvent: C, isArray: f, isNumber: y, objectEach: r, pick: l } = G;
        class v {
            constructor(b){
                this.oldStacks = {};
                this.stacks = {};
                this.stacksTouched = 0;
                this.axis = b;
            }
            buildStacks() {
                const b = this.axis, c = b.series, a = b.options.reversedStacks, d = c.length;
                let f, e;
                this.usePercentage = !1;
                for(e = d; e--;)f = c[a ? e : d - e - 1], f.setStackedPoints(), f.setGroupedPoints();
                for(e = 0; e < d; e++)c[e].modifyStacks();
                C(b, "afterBuildStacks");
            }
            cleanStacks() {
                let b;
                this.oldStacks && (b = this.stacks = this.oldStacks);
                r(b, function(b) {
                    r(b, function(b) {
                        b.cumulative = b.total;
                    });
                });
            }
            resetStacks() {
                r(this.stacks, (b)=>{
                    r(b, (c, a)=>{
                        y(c.touched) && c.touched < this.stacksTouched ? (c.destroy(), delete b[a]) : (c.total = null, c.cumulative = null);
                    });
                });
            }
            renderStackTotals() {
                var b = this.axis;
                const c = b.chart, a = c.renderer, d = this.stacks;
                b = h(c, b.options.stackLabels && b.options.stackLabels.animation || !1);
                const f = this.stackTotalGroup = this.stackTotalGroup || a.g("stack-labels").attr({
                    zIndex: 6,
                    opacity: 0
                }).add();
                f.translate(c.plotLeft, c.plotTop);
                r(d, function(b) {
                    r(b, function(b) {
                        b.render(f);
                    });
                });
                f.animate({
                    opacity: 1
                }, b);
            }
        }
        var d;
        (function(b) {
            const c = [];
            b.compose = function(b, a, d) {
                G.pushUnique(c, b) && (e(b, "init", B), e(b, "destroy", E));
                G.pushUnique(c, a) && (a.prototype.getStacks = u);
                G.pushUnique(c, d) && (b = d.prototype, b.getStackIndicator = t, b.modifyStacks = q, b.percentStacker = m, b.setGroupedPoints = p, b.setStackedPoints = n);
            };
        })(d || (d = {}));
        return d;
    });
    L(a, "Series/Line/LineSeries.js", [
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { defined: u, merge: G } = J;
        class D extends a {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            drawGraph() {
                const a = this, u = this.options, t = (this.gappedPath || this.getGraphPath).call(this), q = this.chart.styledMode;
                let m = [
                    [
                        "graph",
                        "highcharts-graph"
                    ]
                ];
                q || m[0].push(u.lineColor || this.color || "#cccccc", u.dashStyle);
                m = a.getZonesGraphs(m);
                m.forEach(function(m, n) {
                    var h = m[0];
                    let g = a[h];
                    const e = g ? "animate" : "attr";
                    g ? (g.endX = a.preventGraphAnimation ? null : t.xMap, g.animate({
                        d: t
                    })) : t.length && (a[h] = g = a.chart.renderer.path(t).addClass(m[1]).attr({
                        zIndex: 1
                    }).add(a.group));
                    g && !q && (h = {
                        stroke: m[2],
                        "stroke-width": u.lineWidth || 0,
                        fill: a.fillGraph && a.color || "none"
                    }, m[3] ? h.dashstyle = m[3] : "square" !== u.linecap && (h["stroke-linecap"] = h["stroke-linejoin"] = "round"), g[e](h).shadow(2 > n && u.shadow));
                    g && (g.startX = t.xMap, g.isArea = t.isArea);
                });
            }
            getGraphPath(a, B, t) {
                const q = this, m = q.options, p = [], n = [];
                let h, g = m.step;
                a = a || q.points;
                const e = a.reversed;
                e && a.reverse();
                (g = ({
                    right: 1,
                    center: 2
                })[g] || g && 3) && e && (g = 4 - g);
                a = this.getValidPoints(a, !1, !(m.connectNulls && !B && !t));
                a.forEach(function(e, I) {
                    const x = e.plotX, C = e.plotY, f = a[I - 1], y = e.isNull || "number" !== typeof C;
                    (e.leftCliff || f && f.rightCliff) && !t && (h = !0);
                    y && !u(B) && 0 < I ? h = !m.connectNulls : y && !B ? h = !0 : (0 === I || h ? I = [
                        [
                            "M",
                            e.plotX,
                            e.plotY
                        ]
                    ] : q.getPointSpline ? I = [
                        q.getPointSpline(a, e, I)
                    ] : g ? (I = 1 === g ? [
                        [
                            "L",
                            f.plotX,
                            C
                        ]
                    ] : 2 === g ? [
                        [
                            "L",
                            (f.plotX + x) / 2,
                            f.plotY
                        ],
                        [
                            "L",
                            (f.plotX + x) / 2,
                            C
                        ]
                    ] : [
                        [
                            "L",
                            x,
                            f.plotY
                        ]
                    ], I.push([
                        "L",
                        x,
                        C
                    ])) : I = [
                        [
                            "L",
                            x,
                            C
                        ]
                    ], n.push(e.x), g && (n.push(e.x), 2 === g && n.push(e.x)), p.push.apply(p, I), h = !1);
                });
                p.xMap = n;
                return q.graphPath = p;
            }
            getZonesGraphs(a) {
                this.zones.forEach(function(u, t) {
                    t = [
                        "zone-graph-" + t,
                        "highcharts-graph highcharts-zone-graph-" + t + " " + (u.className || "")
                    ];
                    this.chart.styledMode || t.push(u.color || this.color, u.dashStyle || this.options.dashStyle);
                    a.push(t);
                }, this);
                return a;
            }
        }
        D.defaultOptions = G(a.defaultOptions, {
            legendSymbol: "lineMarker"
        });
        A.registerSeriesType("line", D);
        "";
        return D;
    });
    L(a, "Series/Area/AreaSeries.js", [
        a["Core/Color/Color.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { seriesTypes: { line: u } } = A, { extend: G, merge: D, objectEach: E, pick: B } = J;
        class t extends u {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            drawGraph() {
                this.areaPath = [];
                super.drawGraph.apply(this);
                const a = this, m = this.areaPath, p = this.options, n = [
                    [
                        "area",
                        "highcharts-area",
                        this.color,
                        p.fillColor
                    ]
                ];
                this.zones.forEach(function(h, g) {
                    n.push([
                        "zone-area-" + g,
                        "highcharts-area highcharts-zone-area-" + g + " " + h.className,
                        h.color || a.color,
                        h.fillColor || p.fillColor
                    ]);
                });
                n.forEach(function(h) {
                    const g = h[0], e = {};
                    let n = a[g];
                    const q = n ? "animate" : "attr";
                    n ? (n.endX = a.preventGraphAnimation ? null : m.xMap, n.animate({
                        d: m
                    })) : (e.zIndex = 0, n = a[g] = a.chart.renderer.path(m).addClass(h[1]).add(a.group), n.isArea = !0);
                    a.chart.styledMode || (h[3] ? e.fill = h[3] : (e.fill = h[2], e["fill-opacity"] = B(p.fillOpacity, .75)));
                    n[q](e);
                    n.startX = m.xMap;
                    n.shiftUnit = p.step ? 2 : 1;
                });
            }
            getGraphPath(a) {
                var m = u.prototype.getGraphPath, p = this.options;
                const n = p.stacking, h = this.yAxis, g = [], e = [], q = this.index, t = h.stacking.stacks[this.stackKey], M = p.threshold, C = Math.round(h.getThreshold(p.threshold));
                p = B(p.connectNulls, "percent" === n);
                var f = function(f, d, b) {
                    var c = a[f];
                    f = n && t[c.x].points[q];
                    const k = c[b + "Null"] || 0;
                    b = c[b + "Cliff"] || 0;
                    let l, m;
                    c = !0;
                    b || k ? (l = (k ? f[0] : f[1]) + b, m = f[0] + b, c = !!k) : !n && a[d] && a[d].isNull && (l = m = M);
                    "undefined" !== typeof l && (e.push({
                        plotX: y,
                        plotY: null === l ? C : h.getThreshold(l),
                        isNull: c,
                        isCliff: !0
                    }), g.push({
                        plotX: y,
                        plotY: null === m ? C : h.getThreshold(m),
                        doCurve: !1
                    }));
                };
                let y;
                a = a || this.points;
                n && (a = this.getStackPoints(a));
                for(let h = 0, d = a.length; h < d; ++h){
                    n || (a[h].leftCliff = a[h].rightCliff = a[h].leftNull = a[h].rightNull = void 0);
                    var r = a[h].isNull;
                    y = B(a[h].rectPlotX, a[h].plotX);
                    var l = n ? B(a[h].yBottom, C) : C;
                    if (!r || p) p || f(h, h - 1, "left"), r && !n && p || (e.push(a[h]), g.push({
                        x: h,
                        plotX: y,
                        plotY: l
                    })), p || f(h, h + 1, "right");
                }
                f = m.call(this, e, !0, !0);
                g.reversed = !0;
                r = m.call(this, g, !0, !0);
                (l = r[0]) && "M" === l[0] && (r[0] = [
                    "L",
                    l[1],
                    l[2]
                ]);
                r = f.concat(r);
                r.length && r.push([
                    "Z"
                ]);
                m = m.call(this, e, !1, p);
                r.xMap = f.xMap;
                this.areaPath = r;
                return m;
            }
            getStackPoints(a) {
                const m = this, p = [], n = [], h = this.xAxis, g = this.yAxis, e = g.stacking.stacks[this.stackKey], q = {}, t = g.series, u = t.length, C = g.options.reversedStacks ? 1 : -1, f = t.indexOf(m);
                a = a || this.points;
                if (this.options.stacking) {
                    for(let f = 0; f < a.length; f++)a[f].leftNull = a[f].rightNull = void 0, q[a[f].x] = a[f];
                    E(e, function(a, f) {
                        null !== a.total && n.push(f);
                    });
                    n.sort(function(a, f) {
                        return a - f;
                    });
                    const y = t.map((a)=>a.visible);
                    n.forEach(function(a, l) {
                        let r = 0, d, b;
                        if (q[a] && !q[a].isNull) p.push(q[a]), [
                            -1,
                            1
                        ].forEach(function(c) {
                            const k = 1 === c ? "rightNull" : "leftNull", g = e[n[l + c]];
                            let h = 0;
                            if (g) {
                                let c = f;
                                for(; 0 <= c && c < u;){
                                    const f = t[c].index;
                                    d = g.points[f];
                                    d || (f === m.index ? q[a][k] = !0 : y[c] && (b = e[a].points[f]) && (h -= b[1] - b[0]));
                                    c += C;
                                }
                            }
                            q[a][1 === c ? "rightCliff" : "leftCliff"] = h;
                        });
                        else {
                            let b = f;
                            for(; 0 <= b && b < u;){
                                if (d = e[a].points[t[b].index]) {
                                    r = d[1];
                                    break;
                                }
                                b += C;
                            }
                            r = B(r, 0);
                            r = g.translate(r, 0, 1, 0, 1);
                            p.push({
                                isNull: !0,
                                plotX: h.translate(a, 0, 0, 0, 1),
                                x: a,
                                plotY: r,
                                yBottom: r
                            });
                        }
                    });
                }
                return p;
            }
        }
        t.defaultOptions = D(u.defaultOptions, {
            threshold: 0,
            legendSymbol: "rectangle"
        });
        G(t.prototype, {
            singleStacks: !1
        });
        A.registerSeriesType("area", t);
        "";
        return t;
    });
    L(a, "Series/Spline/SplineSeries.js", [
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        const { line: u } = a.seriesTypes, { merge: K, pick: G } = A;
        class D extends u {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            getPointSpline(a, u, t) {
                const q = u.plotX || 0, m = u.plotY || 0, p = a[t - 1];
                t = a[t + 1];
                let n, h;
                let g;
                if (p && !p.isNull && !1 !== p.doCurve && !u.isCliff && t && !t.isNull && !1 !== t.doCurve && !u.isCliff) {
                    a = p.plotY || 0;
                    var e = t.plotX || 0;
                    t = t.plotY || 0;
                    let x = 0;
                    n = (1.5 * q + (p.plotX || 0)) / 2.5;
                    h = (1.5 * m + a) / 2.5;
                    e = (1.5 * q + e) / 2.5;
                    g = (1.5 * m + t) / 2.5;
                    e !== n && (x = (g - h) * (e - q) / (e - n) + m - g);
                    h += x;
                    g += x;
                    h > a && h > m ? (h = Math.max(a, m), g = 2 * m - h) : h < a && h < m && (h = Math.min(a, m), g = 2 * m - h);
                    g > t && g > m ? (g = Math.max(t, m), h = 2 * m - g) : g < t && g < m && (g = Math.min(t, m), h = 2 * m - g);
                    u.rightContX = e;
                    u.rightContY = g;
                }
                u = [
                    "C",
                    G(p.rightContX, p.plotX, 0),
                    G(p.rightContY, p.plotY, 0),
                    G(n, q, 0),
                    G(h, m, 0),
                    q,
                    m
                ];
                p.rightContX = p.rightContY = void 0;
                return u;
            }
        }
        D.defaultOptions = K(u.defaultOptions);
        a.registerSeriesType("spline", D);
        "";
        return D;
    });
    L(a, "Series/AreaSpline/AreaSplineSeries.js", [
        a["Series/Spline/SplineSeries.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { area: u, area: { prototype: G } } = A.seriesTypes, { extend: D, merge: E } = J;
        class B extends a {
            constructor(){
                super(...arguments);
                this.options = this.points = this.data = void 0;
            }
        }
        B.defaultOptions = E(a.defaultOptions, u.defaultOptions);
        D(B.prototype, {
            getGraphPath: G.getGraphPath,
            getStackPoints: G.getStackPoints,
            drawGraph: G.drawGraph
        });
        A.registerSeriesType("areaspline", B);
        "";
        return B;
    });
    L(a, "Series/Column/ColumnSeriesDefaults.js", [], function() {
        "";
        return {
            borderRadius: 3,
            centerInCategory: !1,
            groupPadding: .2,
            marker: null,
            pointPadding: .1,
            minPointLength: 0,
            cropThreshold: 50,
            pointRange: null,
            states: {
                hover: {
                    halo: !1,
                    brightness: .1
                },
                select: {
                    color: "#cccccc",
                    borderColor: "#000000"
                }
            },
            dataLabels: {
                align: void 0,
                verticalAlign: void 0,
                y: void 0
            },
            startFromThreshold: !0,
            stickyTracking: !1,
            tooltip: {
                distance: 6
            },
            threshold: 0,
            borderColor: "#ffffff"
        };
    });
    L(a, "Series/Column/ColumnSeries.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Color/Color.js"],
        a["Series/Column/ColumnSeriesDefaults.js"],
        a["Core/Globals.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E) {
        const { animObject: u } = a, { parse: t } = A, { hasTouch: q, noop: m } = K, { clamp: p, defined: n, extend: h, fireEvent: g, isArray: e, isNumber: x, merge: I, pick: M, objectEach: C } = E;
        class f extends G {
            constructor(){
                super(...arguments);
                this.points = this.options = this.group = this.data = this.borderWidth = void 0;
            }
            animate(a) {
                const f = this, e = this.yAxis, g = e.pos, d = f.options, b = this.chart.inverted, c = {}, k = b ? "translateX" : "translateY";
                let n;
                a ? (c.scaleY = .001, a = p(e.toPixels(d.threshold), g, g + e.len), b ? c.translateX = a - e.len : c.translateY = a, f.clipBox && f.setClip(), f.group.attr(c)) : (n = Number(f.group.attr(k)), f.group.animate({
                    scaleY: 1
                }, h(u(f.options.animation), {
                    step: function(b, a) {
                        f.group && (c[k] = n + a.pos * (g - n), f.group.attr(c));
                    }
                })));
            }
            init(a, f) {
                super.init.apply(this, arguments);
                const e = this;
                a = e.chart;
                a.hasRendered && a.series.forEach(function(a) {
                    a.type === e.type && (a.isDirty = !0);
                });
            }
            getColumnMetrics() {
                const a = this;
                var f = a.options;
                const e = a.xAxis, g = a.yAxis;
                var d = e.options.reversedStacks;
                d = e.reversed && !d || !e.reversed && d;
                const b = {};
                let c, k = 0;
                !1 === f.grouping ? k = 1 : a.chart.series.forEach(function(d) {
                    const f = d.yAxis, e = d.options;
                    let l;
                    d.type !== a.type || !d.visible && a.chart.options.chart.ignoreHiddenSeries || g.len !== f.len || g.pos !== f.pos || (e.stacking && "group" !== e.stacking ? (c = d.stackKey, "undefined" === typeof b[c] && (b[c] = k++), l = b[c]) : !1 !== e.grouping && (l = k++), d.columnIndex = l);
                });
                const h = Math.min(Math.abs(e.transA) * (e.ordinal && e.ordinal.slope || f.pointRange || e.closestPointRange || e.tickInterval || 1), e.len), n = h * f.groupPadding, m = (h - 2 * n) / (k || 1);
                f = Math.min(f.maxPointWidth || e.len, M(f.pointWidth, m * (1 - 2 * f.pointPadding)));
                a.columnMetrics = {
                    width: f,
                    offset: (m - f) / 2 + (n + ((a.columnIndex || 0) + (d ? 1 : 0)) * m - h / 2) * (d ? -1 : 1),
                    paddedWidth: m,
                    columnCount: k
                };
                return a.columnMetrics;
            }
            crispCol(a, f, e, g) {
                var d = this.borderWidth, b = -(d % 2 ? .5 : 0);
                d = d % 2 ? .5 : 1;
                this.options.crisp && (e = Math.round(a + e) + b, a = Math.round(a) + b, e -= a);
                g = Math.round(f + g) + d;
                b = .5 >= Math.abs(f) && .5 < g;
                f = Math.round(f) + d;
                g -= f;
                b && g && (--f, g += 1);
                return {
                    x: a,
                    y: f,
                    width: e,
                    height: g
                };
            }
            adjustForMissingColumns(a, f, l, g) {
                const d = this.options.stacking;
                if (!l.isNull && 1 < g.columnCount) {
                    const b = this.yAxis.options.reversedStacks;
                    let c = 0, k = b ? 0 : -g.columnCount;
                    C(this.yAxis.stacking && this.yAxis.stacking.stacks, (a)=>{
                        if ("number" === typeof l.x) {
                            const f = a[l.x.toString()];
                            f && (a = f.points[this.index], d ? (a && (c = k), f.hasValidPoints && (b ? k++ : k--)) : e(a) && (a = Object.keys(f.points).filter((b)=>!b.match(",") && f.points[b] && 1 < f.points[b].length).map(parseFloat).sort((b, a)=>a - b), c = a.indexOf(this.index), k = a.length));
                        }
                    });
                    a = (l.plotX || 0) + ((k - 1) * g.paddedWidth + f) / 2 - f - c * g.paddedWidth;
                }
                return a;
            }
            translate() {
                const a = this, f = a.chart, e = a.options;
                var h = a.dense = 2 > a.closestPointRange * a.xAxis.transA;
                h = a.borderWidth = M(e.borderWidth, h ? 0 : 1);
                const d = a.xAxis, b = a.yAxis, c = e.threshold, k = M(e.minPointLength, 5), m = a.getColumnMetrics(), z = m.width, q = a.pointXOffset = m.offset, t = a.dataMin, u = a.dataMax;
                let I = a.barW = Math.max(z, 1 + 2 * h), C = a.translatedThreshold = b.getThreshold(c);
                f.inverted && (C -= .5);
                e.pointPadding && (I = Math.ceil(I));
                G.prototype.translate.apply(a);
                a.points.forEach(function(l) {
                    const g = M(l.yBottom, C);
                    var h = 999 + Math.abs(g), w = l.plotX || 0;
                    h = p(l.plotY, -h, b.len + h);
                    let r = Math.min(h, g), v = Math.max(h, g) - r, F = z, y = w + q, O = I;
                    k && Math.abs(v) < k && (v = k, w = !b.reversed && !l.negative || b.reversed && l.negative, x(c) && x(u) && l.y === c && u <= c && (b.min || 0) < c && (t !== u || (b.max || 0) <= c) && (w = !w, l.negative = !l.negative), r = Math.abs(r - C) > k ? g - k : C - (w ? k : 0));
                    n(l.options.pointWidth) && (F = O = Math.ceil(l.options.pointWidth), y -= Math.round((F - z) / 2));
                    e.centerInCategory && (y = a.adjustForMissingColumns(y, F, l, m));
                    l.barX = y;
                    l.pointWidth = F;
                    l.tooltipPos = f.inverted ? [
                        p(b.len + b.pos - f.plotLeft - h, b.pos - f.plotLeft, b.len + b.pos - f.plotLeft),
                        d.len + d.pos - f.plotTop - y - O / 2,
                        v
                    ] : [
                        d.left - f.plotLeft + y + O / 2,
                        p(h + b.pos - f.plotTop, b.pos - f.plotTop, b.len + b.pos - f.plotTop),
                        v
                    ];
                    l.shapeType = a.pointClass.prototype.shapeType || "roundedRect";
                    l.shapeArgs = a.crispCol(y, l.isNull ? C : r, O, l.isNull ? 0 : v);
                });
                g(this, "afterColumnTranslate");
            }
            drawGraph() {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            }
            pointAttribs(a, f) {
                const e = this.options;
                var g = this.pointAttrToOptions || {}, d = g.stroke || "borderColor";
                const b = g["stroke-width"] || "borderWidth";
                let c, k = a && a.color || this.color, h = a && a[d] || e[d] || k;
                g = a && a.options.dashStyle || e.dashStyle;
                let n = a && a[b] || e[b] || this[b] || 0, m = M(a && a.opacity, e.opacity, 1);
                a && this.zones.length && (c = a.getZone(), k = a.options.color || c && (c.color || a.nonZonedColor) || this.color, c && (h = c.borderColor || h, g = c.dashStyle || g, n = c.borderWidth || n));
                f && a && (a = I(e.states[f], a.options.states && a.options.states[f] || {}), f = a.brightness, k = a.color || "undefined" !== typeof f && t(k).brighten(a.brightness).get() || k, h = a[d] || h, n = a[b] || n, g = a.dashStyle || g, m = M(a.opacity, m));
                d = {
                    fill: k,
                    stroke: h,
                    "stroke-width": n,
                    opacity: m
                };
                g && (d.dashstyle = g);
                return d;
            }
            drawPoints(a = this.points) {
                const f = this, e = this.chart, g = f.options, d = e.renderer, b = g.animationLimit || 250;
                let c;
                a.forEach(function(a) {
                    let k = a.graphic, l = !!k, h = k && e.pointCount < b ? "animate" : "attr";
                    if (x(a.plotY) && null !== a.y) {
                        c = a.shapeArgs;
                        k && a.hasNewShapeType() && (k = k.destroy());
                        f.enabledDataSorting && (a.startXPos = f.xAxis.reversed ? -(c ? c.width || 0 : 0) : f.xAxis.width);
                        k || (a.graphic = k = d[a.shapeType](c).add(a.group || f.group)) && f.enabledDataSorting && e.hasRendered && e.pointCount < b && (k.attr({
                            x: a.startXPos
                        }), l = !0, h = "animate");
                        if (k && l) k[h](I(c));
                        e.styledMode || k[h](f.pointAttribs(a, a.selected && "select")).shadow(!1 !== a.allowShadow && g.shadow);
                        k && (k.addClass(a.getClassName(), !0), k.attr({
                            visibility: a.visible ? "inherit" : "hidden"
                        }));
                    } else k && (a.graphic = k.destroy());
                });
            }
            drawTracker(a = this.points) {
                const f = this, l = f.chart, h = l.pointer, d = function(b) {
                    const a = h.getPointFromEvent(b);
                    "undefined" !== typeof a && f.options.enableMouseTracking && (h.isDirectTouch = !0, a.onMouseOver(b));
                };
                let b;
                a.forEach(function(a) {
                    b = e(a.dataLabels) ? a.dataLabels : a.dataLabel ? [
                        a.dataLabel
                    ] : [];
                    a.graphic && (a.graphic.element.point = a);
                    b.forEach(function(b) {
                        b.div ? b.div.point = a : b.element.point = a;
                    });
                });
                f._hasTracking || (f.trackerGroups.forEach(function(b) {
                    if (f[b]) {
                        f[b].addClass("highcharts-tracker").on("mouseover", d).on("mouseout", function(b) {
                            h.onTrackerMouseOut(b);
                        });
                        if (q) f[b].on("touchstart", d);
                        !l.styledMode && f.options.cursor && f[b].css({
                            cursor: f.options.cursor
                        });
                    }
                }), f._hasTracking = !0);
                g(this, "afterDrawTracker");
            }
            remove() {
                const a = this, f = a.chart;
                f.hasRendered && f.series.forEach(function(f) {
                    f.type === a.type && (f.isDirty = !0);
                });
                G.prototype.remove.apply(a, arguments);
            }
        }
        f.defaultOptions = I(G.defaultOptions, J);
        h(f.prototype, {
            cropShoulder: 0,
            directTouch: !0,
            getSymbol: m,
            negStacks: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        });
        D.registerSeriesType("column", f);
        "";
        return f;
    });
    L(a, "Core/Series/DataLabel.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Templating.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { getDeferredAnimation: u } = a, { format: G } = A, { defined: D, extend: E, fireEvent: B, isArray: t, isString: q, merge: m, objectEach: p, pick: n, splat: h } = J;
        var g;
        (function(a) {
            function e(a, b, c, f, e) {
                const d = this.chart;
                var k = this.isCartesian && d.inverted;
                const g = this.enabledDataSorting;
                var l = a.plotX, h = a.plotY;
                const m = c.rotation;
                var w = c.align;
                h = D(l) && D(h) && d.isInsidePlot(l, Math.round(h), {
                    inverted: k,
                    paneCoordinates: !0,
                    series: this
                });
                let r = "justify" === n(c.overflow, g ? "none" : "justify");
                k = this.visible && !1 !== a.visible && D(l) && (a.series.forceDL || g && !r || h || n(c.inside, !!this.options.stacking) && f && d.isInsidePlot(l, k ? f.x + 1 : f.y + f.height - 1, {
                    inverted: k,
                    paneCoordinates: !0,
                    series: this
                }));
                l = a.pos();
                if (k && l) {
                    m && b.attr({
                        align: w
                    });
                    w = b.getBBox(!0);
                    var v = [
                        0,
                        0
                    ];
                    var p = d.renderer.fontMetrics(b).b;
                    f = E({
                        x: l[0],
                        y: Math.round(l[1]),
                        width: 0,
                        height: 0
                    }, f);
                    E(c, {
                        width: w.width,
                        height: w.height
                    });
                    m ? (r = !1, v = d.renderer.rotCorr(p, m), p = {
                        x: f.x + (c.x || 0) + f.width / 2 + v.x,
                        y: f.y + (c.y || 0) + ({
                            top: 0,
                            middle: .5,
                            bottom: 1
                        })[c.verticalAlign] * f.height
                    }, v = [
                        w.x - Number(b.attr("x")),
                        w.y - Number(b.attr("y"))
                    ], g && this.xAxis && !r && this.setDataLabelStartPos(a, b, e, h, p), b[e ? "attr" : "animate"](p)) : (g && this.xAxis && !r && this.setDataLabelStartPos(a, b, e, h, f), b.align(c, void 0, f), p = b.alignAttr);
                    if (r && 0 <= f.height) this.justifyDataLabel(b, c, p, w, f, e);
                    else if (n(c.crop, !0)) {
                        let { x: b, y: a } = p;
                        b += v[0];
                        a += v[1];
                        k = d.isInsidePlot(b, a, {
                            paneCoordinates: !0,
                            series: this
                        }) && d.isInsidePlot(b + w.width, a + w.height, {
                            paneCoordinates: !0,
                            series: this
                        });
                    }
                    if (c.shape && !m) b[e ? "attr" : "animate"]({
                        anchorX: l[0],
                        anchorY: l[1]
                    });
                }
                e && g && (b.placed = !1);
                k || g && !r ? b.show() : (b.hide(), b.placed = !1);
            }
            function g(a, b) {
                var c = b.filter;
                return c ? (b = c.operator, a = a[c.property], c = c.value, ">" === b && a > c || "<" === b && a < c || ">=" === b && a >= c || "<=" === b && a <= c || "==" === b && a == c || "===" === b && a === c ? !0 : !1) : !0;
            }
            function M() {
                return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
            }
            function C(a) {
                const b = this.hasRendered || 0, c = this.initDataLabelsGroup().attr({
                    opacity: +b
                });
                !b && c && (this.visible && c.show(), this.options.animation ? c.animate({
                    opacity: 1
                }, a) : c.attr({
                    opacity: 1
                }));
                return c;
            }
            function f(a = this.points) {
                var b, c;
                const d = this, f = d.chart, e = d.options, l = f.renderer, { backgroundColor: m, plotBackgroundColor: v } = f.options.chart, x = f.options.plotOptions, y = l.getContrast(q(v) && v || q(m) && m || "#000000");
                let I = e.dataLabels, C, M;
                var A = h(I)[0];
                const E = A.animation;
                A = A.defer ? u(f, E, d) : {
                    defer: 0,
                    duration: 0
                };
                I = r(r(null === (b = null === x || void 0 === x ? void 0 : x.series) || void 0 === b ? void 0 : b.dataLabels, null === (c = null === x || void 0 === x ? void 0 : x[d.type]) || void 0 === c ? void 0 : c.dataLabels), I);
                B(this, "drawDataLabels");
                if (t(I) || I.enabled || d._hasPointLabels) M = this.initDataLabels(A), a.forEach((b)=>{
                    var a;
                    const c = b.dataLabels || [];
                    C = h(r(I, b.dlOptions || (null === (a = b.options) || void 0 === a ? void 0 : a.dataLabels)));
                    C.forEach((a, k)=>{
                        var h, m = a.enabled && (!b.isNull || b.dataLabelOnNull) && g(b, a);
                        const w = b.connectors ? b.connectors[k] : b.connector, r = a.style || {};
                        let v = {}, z = c[k], x = !z;
                        const F = n(a.distance, b.labelDistance);
                        if (m) {
                            var t = n(a[b.formatPrefix + "Format"], a.format);
                            var u = b.getLabelConfig();
                            u = D(t) ? G(t, u, f) : (a[b.formatPrefix + "Formatter"] || a.formatter).call(u, a);
                            t = a.rotation;
                            f.styledMode || (r.color = n(a.color, r.color, q(d.color) ? d.color : void 0, "#000000"), "contrast" === r.color ? (b.contrastColor = l.getContrast(b.color || d.color), r.color = !D(F) && a.inside || 0 > (F || 0) || e.stacking ? b.contrastColor : y) : delete b.contrastColor, e.cursor && (r.cursor = e.cursor));
                            v = {
                                r: a.borderRadius || 0,
                                rotation: t,
                                padding: a.padding,
                                zIndex: 1
                            };
                            if (!f.styledMode) {
                                const { backgroundColor: c, borderColor: d } = a;
                                v.fill = "auto" === c ? b.color : c;
                                v.stroke = "auto" === d ? b.color : d;
                                v["stroke-width"] = a.borderWidth;
                            }
                            p(v, (b, a)=>{
                                "undefined" === typeof b && delete v[a];
                            });
                        }
                        !z || m && D(u) && !!z.div === !!a.useHTML && (z.rotation && a.rotation || z.rotation === a.rotation) || (z = void 0, x = !0, w && b.connector && (b.connector = b.connector.destroy(), b.connectors && (1 === b.connectors.length ? delete b.connectors : delete b.connectors[k])));
                        m && D(u) && (z ? v.text = u : (z = t ? l.text(u, 0, 0, a.useHTML).addClass("highcharts-data-label") : l.label(u, 0, 0, a.shape, void 0, void 0, a.useHTML, void 0, "data-label")) && z.addClass(" highcharts-data-label-color-" + b.colorIndex + " " + (a.className || "") + (a.useHTML ? " highcharts-tracker" : "")), z && (z.options = a, z.attr(v), f.styledMode || z.css(r).shadow(a.shadow), (m = a[b.formatPrefix + "TextPath"] || a.textPath) && !a.useHTML && (z.setTextPath((null === (h = b.getDataLabelPath) || void 0 === h ? void 0 : h.call(b, z)) || b.graphic, m), b.dataLabelPath && !m.enabled && (b.dataLabelPath = b.dataLabelPath.destroy())), z.added || z.add(M), d.alignDataLabel(b, z, a, void 0, x), z.isActive = !0, c[k] && c[k] !== z && c[k].destroy(), c[k] = z));
                    });
                    for(a = c.length; a--;)c[a].isActive ? c[a].isActive = !1 : (c[a].destroy(), c.splice(a, 1));
                    b.dataLabel = c[0];
                    b.dataLabels = c;
                });
                B(this, "afterDrawDataLabels");
            }
            function y(a, b, c, f, e, l) {
                const d = this.chart, k = b.align, g = b.verticalAlign, h = a.box ? 0 : a.padding || 0;
                let { x: n = 0, y: m = 0 } = b, w, r;
                w = (c.x || 0) + h;
                0 > w && ("right" === k && 0 <= n ? (b.align = "left", b.inside = !0) : n -= w, r = !0);
                w = (c.x || 0) + f.width - h;
                w > d.plotWidth && ("left" === k && 0 >= n ? (b.align = "right", b.inside = !0) : n += d.plotWidth - w, r = !0);
                w = c.y + h;
                0 > w && ("bottom" === g && 0 <= m ? (b.verticalAlign = "top", b.inside = !0) : m -= w, r = !0);
                w = (c.y || 0) + f.height - h;
                w > d.plotHeight && ("top" === g && 0 >= m ? (b.verticalAlign = "bottom", b.inside = !0) : m += d.plotHeight - w, r = !0);
                r && (b.x = n, b.y = m, a.placed = !l, a.align(b, void 0, e));
                return r;
            }
            function r(a, b) {
                let c = [], d;
                if (t(a) && !t(b)) c = a.map(function(a) {
                    return m(a, b);
                });
                else if (t(b) && !t(a)) c = b.map(function(b) {
                    return m(a, b);
                });
                else if (!t(a) && !t(b)) c = m(a, b);
                else if (t(a) && t(b)) for(d = Math.max(a.length, b.length); d--;)c[d] = m(a[d], b[d]);
                return c;
            }
            function l(a, b, c, f, e) {
                const d = this.chart, k = d.inverted, l = this.xAxis, g = l.reversed, h = k ? b.height / 2 : b.width / 2;
                a = (a = a.pointWidth) ? a / 2 : 0;
                b.startXPos = k ? e.x : g ? -h - a : l.width - h + a;
                b.startYPos = k ? g ? this.yAxis.height - h + a : -h - a : e.y;
                f ? "hidden" === b.visibility && (b.show(), b.attr({
                    opacity: 0
                }).animate({
                    opacity: 1
                })) : b.attr({
                    opacity: 1
                }).animate({
                    opacity: 0
                }, void 0, b.hide);
                d.hasRendered && (c && b.attr({
                    x: b.startXPos,
                    y: b.startYPos
                }), b.placed = !0);
            }
            const v = [];
            a.compose = function(a) {
                J.pushUnique(v, a) && (a = a.prototype, a.initDataLabelsGroup = M, a.initDataLabels = C, a.alignDataLabel = e, a.drawDataLabels = f, a.justifyDataLabel = y, a.setDataLabelStartPos = l);
            };
        })(g || (g = {}));
        "";
        return g;
    });
    L(a, "Series/Column/ColumnDataLabel.js", [
        a["Core/Series/DataLabel.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { series: u } = A, { merge: G, pick: D } = J;
        var E;
        (function(B) {
            function t(a, p, n, h, g) {
                let e = this.chart.inverted;
                var m = a.series;
                let q = (m.xAxis ? m.xAxis.len : this.chart.plotSizeX) || 0;
                m = (m.yAxis ? m.yAxis.len : this.chart.plotSizeY) || 0;
                var t = a.dlBox || a.shapeArgs;
                let C = D(a.below, a.plotY > D(this.translatedThreshold, m)), f = D(n.inside, !!this.options.stacking);
                t && (h = G(t), 0 > h.y && (h.height += h.y, h.y = 0), t = h.y + h.height - m, 0 < t && t < h.height && (h.height -= t), e && (h = {
                    x: m - h.y - h.height,
                    y: q - h.x - h.width,
                    width: h.height,
                    height: h.width
                }), f || (e ? (h.x += C ? 0 : h.width, h.width = 0) : (h.y += C ? h.height : 0, h.height = 0)));
                n.align = D(n.align, !e || f ? "center" : C ? "right" : "left");
                n.verticalAlign = D(n.verticalAlign, e || f ? "middle" : C ? "top" : "bottom");
                u.prototype.alignDataLabel.call(this, a, p, n, h, g);
                n.inside && a.contrastColor && p.css({
                    color: a.contrastColor
                });
            }
            const q = [];
            B.compose = function(m) {
                a.compose(u);
                J.pushUnique(q, m) && (m.prototype.alignDataLabel = t);
            };
        })(E || (E = {}));
        return E;
    });
    L(a, "Series/Bar/BarSeries.js", [
        a["Series/Column/ColumnSeries.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { extend: u, merge: G } = J;
        class D extends a {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
        }
        D.defaultOptions = G(a.defaultOptions, {});
        u(D.prototype, {
            inverted: !0
        });
        A.registerSeriesType("bar", D);
        "";
        return D;
    });
    L(a, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
        "";
        return {
            lineWidth: 0,
            findNearestPointBy: "xy",
            jitter: {
                x: 0,
                y: 0
            },
            marker: {
                enabled: !0
            },
            tooltip: {
                headerFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-size: 0.8em"> {series.name}</span><br/>',
                pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
            }
        };
    });
    L(a, "Series/Scatter/ScatterSeries.js", [
        a["Series/Scatter/ScatterSeriesDefaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { column: u, line: G } = A.seriesTypes, { addEvent: D, extend: E, merge: B } = J;
        class t extends G {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            applyJitter() {
                const a = this, m = this.options.jitter, p = this.points.length;
                m && this.points.forEach(function(n, h) {
                    [
                        "x",
                        "y"
                    ].forEach(function(g, e) {
                        let q = "plot" + g.toUpperCase(), t, u;
                        if (m[g] && !n.isNull) {
                            var C = a[g + "Axis"];
                            u = m[g] * C.transA;
                            C && !C.isLog && (t = Math.max(0, n[q] - u), C = Math.min(C.len, n[q] + u), e = 1E4 * Math.sin(h + e * p), e -= Math.floor(e), n[q] = t + (C - t) * e, "x" === g && (n.clientX = n.plotX));
                        }
                    });
                });
            }
            drawGraph() {
                this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
            }
        }
        t.defaultOptions = B(G.defaultOptions, a);
        E(t.prototype, {
            drawTracker: u.prototype.drawTracker,
            sorted: !1,
            requireSorting: !1,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ],
            takeOrdinalPosition: !1
        });
        D(t, "afterTranslate", function() {
            this.applyJitter();
        });
        A.registerSeriesType("scatter", t);
        return t;
    });
    L(a, "Series/CenteredUtilities.js", [
        a["Core/Globals.js"],
        a["Core/Series/Series.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { deg2rad: u } = a, { fireEvent: G, isNumber: D, pick: E, relativeLength: B } = J;
        var t;
        (function(a) {
            a.getCenter = function() {
                var a = this.options, p = this.chart;
                const n = 2 * (a.slicedOffset || 0), h = p.plotWidth - 2 * n, g = p.plotHeight - 2 * n;
                var e = a.center;
                const q = Math.min(h, g), t = a.thickness;
                var u = a.size;
                let C = a.innerSize || 0;
                "string" === typeof u && (u = parseFloat(u));
                "string" === typeof C && (C = parseFloat(C));
                a = [
                    E(e[0], "50%"),
                    E(e[1], "50%"),
                    E(u && 0 > u ? void 0 : a.size, "100%"),
                    E(C && 0 > C ? void 0 : a.innerSize || 0, "0%")
                ];
                !p.angular || this instanceof A || (a[3] = 0);
                for(e = 0; 4 > e; ++e)u = a[e], p = 2 > e || 2 === e && /%$/.test(u), a[e] = B(u, [
                    h,
                    g,
                    q,
                    a[2]
                ][e]) + (p ? n : 0);
                a[3] > a[2] && (a[3] = a[2]);
                D(t) && 2 * t < a[2] && 0 < t && (a[3] = a[2] - 2 * t);
                G(this, "afterGetCenter", {
                    positions: a
                });
                return a;
            };
            a.getStartAndEndRadians = function(a, p) {
                a = D(a) ? a : 0;
                p = D(p) && p > a && 360 > p - a ? p : a + 360;
                return {
                    start: u * (a + -90),
                    end: u * (p + -90)
                };
            };
        })(t || (t = {}));
        "";
        return t;
    });
    L(a, "Series/Pie/PiePoint.js", [
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Series/Point.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { setAnimation: u } = a, { addEvent: G, defined: D, extend: E, isNumber: B, pick: t, relativeLength: q } = J;
        class m extends A {
            constructor(){
                super(...arguments);
                this.series = this.options = this.labelDistance = void 0;
            }
            getConnectorPath() {
                const a = this.labelPosition, n = this.series.options.dataLabels, h = this.connectorShapes;
                let g = n.connectorShape;
                h[g] && (g = h[g]);
                return g.call(this, {
                    x: a.computed.x,
                    y: a.computed.y,
                    alignment: a.alignment
                }, a.connectorPosition, n);
            }
            getTranslate() {
                return this.sliced ? this.slicedTranslation : {
                    translateX: 0,
                    translateY: 0
                };
            }
            haloPath(a) {
                const n = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(n.x, n.y, n.r + a, n.r + a, {
                    innerR: n.r - 1,
                    start: n.start,
                    end: n.end,
                    borderRadius: n.borderRadius
                });
            }
            init() {
                super.init.apply(this, arguments);
                this.name = t(this.name, "Slice");
                const a = (a)=>{
                    this.slice("select" === a.type);
                };
                G(this, "select", a);
                G(this, "unselect", a);
                return this;
            }
            isValid() {
                return B(this.y) && 0 <= this.y;
            }
            setVisible(a, n) {
                const h = this.series, g = h.chart, e = h.options.ignoreHiddenPoint;
                n = t(n, e);
                a !== this.visible && (this.visible = this.options.visible = a = "undefined" === typeof a ? !this.visible : a, h.options.data[h.data.indexOf(this)] = this.options, [
                    "graphic",
                    "dataLabel",
                    "connector"
                ].forEach((e)=>{
                    if (this[e]) this[e][a ? "show" : "hide"](a);
                }), this.legendItem && g.legend.colorizeItem(this, a), a || "hover" !== this.state || this.setState(""), e && (h.isDirty = !0), n && g.redraw());
            }
            slice(a, n, h) {
                const g = this.series;
                u(h, g.chart);
                t(n, !0);
                this.sliced = this.options.sliced = D(a) ? a : !this.sliced;
                g.options.data[g.data.indexOf(this)] = this.options;
                this.graphic && this.graphic.animate(this.getTranslate());
            }
        }
        E(m.prototype, {
            connectorShapes: {
                fixedOffset: function(a, n, h) {
                    const g = n.breakAt;
                    n = n.touchingSliceAt;
                    return [
                        [
                            "M",
                            a.x,
                            a.y
                        ],
                        h.softConnector ? [
                            "C",
                            a.x + ("left" === a.alignment ? -5 : 5),
                            a.y,
                            2 * g.x - n.x,
                            2 * g.y - n.y,
                            g.x,
                            g.y
                        ] : [
                            "L",
                            g.x,
                            g.y
                        ],
                        [
                            "L",
                            n.x,
                            n.y
                        ]
                    ];
                },
                straight: function(a, n) {
                    n = n.touchingSliceAt;
                    return [
                        [
                            "M",
                            a.x,
                            a.y
                        ],
                        [
                            "L",
                            n.x,
                            n.y
                        ]
                    ];
                },
                crookedLine: function(a, n, h) {
                    const { breakAt: g, touchingSliceAt: e } = n;
                    ({ series: n } = this);
                    const [m, p, t] = n.center, u = t / 2, f = n.chart.plotWidth, y = n.chart.plotLeft;
                    n = "left" === a.alignment;
                    const { x: r, y: l } = a;
                    h.crookDistance ? (a = q(h.crookDistance, 1), a = n ? m + u + (f + y - m - u) * (1 - a) : y + (m - u) * a) : a = m + (p - l) * Math.tan((this.angle || 0) - Math.PI / 2);
                    h = [
                        [
                            "M",
                            r,
                            l
                        ]
                    ];
                    (n ? a <= r && a >= g.x : a >= r && a <= g.x) && h.push([
                        "L",
                        a,
                        l
                    ]);
                    h.push([
                        "L",
                        g.x,
                        g.y
                    ], [
                        "L",
                        e.x,
                        e.y
                    ]);
                    return h;
                }
            }
        });
        return m;
    });
    L(a, "Series/Pie/PieSeriesDefaults.js", [], function() {
        "";
        return {
            borderRadius: 3,
            center: [
                null,
                null
            ],
            clip: !1,
            colorByPoint: !0,
            dataLabels: {
                allowOverlap: !0,
                connectorPadding: 5,
                connectorShape: "crookedLine",
                crookDistance: void 0,
                distance: 30,
                enabled: !0,
                formatter: function() {
                    return this.point.isNull ? void 0 : this.point.name;
                },
                softConnector: !0,
                x: 0
            },
            fillColor: void 0,
            ignoreHiddenPoint: !0,
            inactiveOtherPoints: !0,
            legendType: "point",
            marker: null,
            size: null,
            showInLegend: !1,
            slicedOffset: 10,
            stickyTracking: !1,
            tooltip: {
                followPointer: !0
            },
            borderColor: "#ffffff",
            borderWidth: 1,
            lineWidth: void 0,
            states: {
                hover: {
                    brightness: .1
                }
            }
        };
    });
    L(a, "Series/Pie/PieSeries.js", [
        a["Series/CenteredUtilities.js"],
        a["Series/Column/ColumnSeries.js"],
        a["Core/Globals.js"],
        a["Series/Pie/PiePoint.js"],
        a["Series/Pie/PieSeriesDefaults.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/Symbols.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E, B, t) {
        const { getStartAndEndRadians: q } = a;
        ({ noop: J } = J);
        const { clamp: m, extend: p, fireEvent: n, merge: h, pick: g, relativeLength: e } = t;
        class x extends D {
            constructor(){
                super(...arguments);
                this.points = this.options = this.maxLabelDistance = this.data = this.center = void 0;
            }
            animate(a) {
                const e = this, h = e.points, f = e.startAngleRad;
                a || h.forEach(function(a) {
                    const h = a.graphic, l = a.shapeArgs;
                    h && l && (h.attr({
                        r: g(a.startR, e.center && e.center[3] / 2),
                        start: f,
                        end: f
                    }), h.animate({
                        r: l.r,
                        start: l.start,
                        end: l.end
                    }, e.options.animation));
                });
            }
            drawEmpty() {
                const a = this.startAngleRad, e = this.endAngleRad, g = this.options;
                let f, h;
                0 === this.total && this.center ? (f = this.center[0], h = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(f, h, this.center[1] / 2, 0, a, e).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
                    d: B.arc(f, h, this.center[2] / 2, 0, {
                        start: a,
                        end: e,
                        innerR: this.center[3] / 2
                    })
                }), this.chart.styledMode || this.graph.attr({
                    "stroke-width": g.borderWidth,
                    fill: g.fillColor || "none",
                    stroke: g.color || "#cccccc"
                })) : this.graph && (this.graph = this.graph.destroy());
            }
            drawPoints() {
                const a = this.chart.renderer;
                this.points.forEach(function(e) {
                    e.graphic && e.hasNewShapeType() && (e.graphic = e.graphic.destroy());
                    e.graphic || (e.graphic = a[e.shapeType](e.shapeArgs).add(e.series.group), e.delayedRendering = !0);
                });
            }
            generatePoints() {
                super.generatePoints();
                this.updateTotals();
            }
            getX(a, e, g) {
                const f = this.center, h = this.radii ? this.radii[g.index] || 0 : f[2] / 2;
                a = Math.asin(m((a - f[1]) / (h + g.labelDistance), -1, 1));
                return f[0] + (e ? -1 : 1) * Math.cos(a) * (h + g.labelDistance) + (0 < g.labelDistance ? (e ? -1 : 1) * this.options.dataLabels.padding : 0);
            }
            hasData() {
                return !!this.processedXData.length;
            }
            redrawPoints() {
                const a = this, e = a.chart;
                let g, f, n, m;
                this.drawEmpty();
                a.group && !e.styledMode && a.group.shadow(a.options.shadow);
                a.points.forEach(function(l) {
                    const r = {};
                    f = l.graphic;
                    !l.isNull && f ? (m = l.shapeArgs, g = l.getTranslate(), e.styledMode || (n = a.pointAttribs(l, l.selected && "select")), l.delayedRendering ? (f.setRadialReference(a.center).attr(m).attr(g), e.styledMode || f.attr(n).attr({
                        "stroke-linejoin": "round"
                    }), l.delayedRendering = !1) : (f.setRadialReference(a.center), e.styledMode || h(!0, r, n), h(!0, r, m, g), f.animate(r)), f.attr({
                        visibility: l.visible ? "inherit" : "hidden"
                    }), f.addClass(l.getClassName(), !0)) : f && (l.graphic = f.destroy());
                });
            }
            sortByAngle(a, e) {
                a.sort(function(a, f) {
                    return "undefined" !== typeof a.angle && (f.angle - a.angle) * e;
                });
            }
            translate(a) {
                n(this, "translate");
                this.generatePoints();
                var h = this.options;
                const m = h.slicedOffset, f = m + (h.borderWidth || 0);
                var p = q(h.startAngle, h.endAngle);
                const r = this.startAngleRad = p.start;
                p = (this.endAngleRad = p.end) - r;
                const l = this.points, v = h.dataLabels.distance;
                h = h.ignoreHiddenPoint;
                const d = l.length;
                let b, c, k, w = 0;
                a || (this.center = a = this.getCenter());
                for(c = 0; c < d; c++){
                    k = l[c];
                    var z = r + w * p;
                    !k.isValid() || h && !k.visible || (w += k.percentage / 100);
                    var F = r + w * p;
                    var x = {
                        x: a[0],
                        y: a[1],
                        r: a[2] / 2,
                        innerR: a[3] / 2,
                        start: Math.round(1E3 * z) / 1E3,
                        end: Math.round(1E3 * F) / 1E3
                    };
                    k.shapeType = "arc";
                    k.shapeArgs = x;
                    k.labelDistance = g(k.options.dataLabels && k.options.dataLabels.distance, v);
                    k.labelDistance = e(k.labelDistance, x.r);
                    this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, k.labelDistance);
                    F = (F + z) / 2;
                    F > 1.5 * Math.PI ? F -= 2 * Math.PI : F < -Math.PI / 2 && (F += 2 * Math.PI);
                    k.slicedTranslation = {
                        translateX: Math.round(Math.cos(F) * m),
                        translateY: Math.round(Math.sin(F) * m)
                    };
                    x = Math.cos(F) * a[2] / 2;
                    b = Math.sin(F) * a[2] / 2;
                    k.tooltipPos = [
                        a[0] + .7 * x,
                        a[1] + .7 * b
                    ];
                    k.half = F < -Math.PI / 2 || F > Math.PI / 2 ? 1 : 0;
                    k.angle = F;
                    z = Math.min(f, k.labelDistance / 5);
                    k.labelPosition = {
                        natural: {
                            x: a[0] + x + Math.cos(F) * k.labelDistance,
                            y: a[1] + b + Math.sin(F) * k.labelDistance
                        },
                        computed: {},
                        alignment: 0 > k.labelDistance ? "center" : k.half ? "right" : "left",
                        connectorPosition: {
                            breakAt: {
                                x: a[0] + x + Math.cos(F) * z,
                                y: a[1] + b + Math.sin(F) * z
                            },
                            touchingSliceAt: {
                                x: a[0] + x,
                                y: a[1] + b
                            }
                        }
                    };
                }
                n(this, "afterTranslate");
            }
            updateTotals() {
                const a = this.points, e = a.length, g = this.options.ignoreHiddenPoint;
                let f, h, n = 0;
                for(f = 0; f < e; f++)h = a[f], !h.isValid() || g && !h.visible || (n += h.y);
                this.total = n;
                for(f = 0; f < e; f++)h = a[f], h.percentage = 0 < n && (h.visible || !g) ? h.y / n * 100 : 0, h.total = n;
            }
        }
        x.defaultOptions = h(D.defaultOptions, G);
        p(x.prototype, {
            axisTypes: [],
            directTouch: !0,
            drawGraph: void 0,
            drawTracker: A.prototype.drawTracker,
            getCenter: a.getCenter,
            getSymbol: J,
            isCartesian: !1,
            noSharedTooltip: !0,
            pointAttribs: A.prototype.pointAttribs,
            pointClass: K,
            requireSorting: !1,
            searchPoint: J,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        });
        E.registerSeriesType("pie", x);
        return x;
    });
    L(a, "Series/Pie/PieDataLabel.js", [
        a["Core/Series/DataLabel.js"],
        a["Core/Globals.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G) {
        const { noop: u } = A, { distribute: E } = J, { series: B } = K, { arrayMax: t, clamp: q, defined: m, merge: p, pick: n, relativeLength: h } = G;
        var g;
        (function(e) {
            function g() {
                const a = this, f = a.data, e = a.chart, g = a.options.dataLabels || {}, d = g.connectorPadding, b = e.plotWidth, c = e.plotHeight, k = e.plotLeft, h = Math.round(e.chartWidth / 3), z = a.center, q = z[2] / 2, x = z[1], u = [
                    [],
                    []
                ], C = [
                    0,
                    0,
                    0,
                    0
                ], I = a.dataLabelPositioners;
                let A, H, G, M, D, J, K, L, Q, R, V, S;
                a.visible && (g.enabled || a._hasPointLabels) && (f.forEach(function(b) {
                    b.dataLabel && b.visible && b.dataLabel.shortened && (b.dataLabel.attr({
                        width: "auto"
                    }).css({
                        width: "auto",
                        textOverflow: "clip"
                    }), b.dataLabel.shortened = !1);
                }), B.prototype.drawDataLabels.apply(a), f.forEach(function(b) {
                    b.dataLabel && (b.visible ? (u[b.half].push(b), b.dataLabel._pos = null, !m(g.style.width) && !m(b.options.dataLabels && b.options.dataLabels.style && b.options.dataLabels.style.width) && b.dataLabel.getBBox().width > h && (b.dataLabel.css({
                        width: Math.round(.7 * h) + "px"
                    }), b.dataLabel.shortened = !0)) : (b.dataLabel = b.dataLabel.destroy(), b.dataLabels && 1 === b.dataLabels.length && delete b.dataLabels));
                }), u.forEach((f, l)=>{
                    const h = f.length, w = [];
                    let r, v = 0;
                    if (h) {
                        a.sortByAngle(f, l - .5);
                        if (0 < a.maxLabelDistance) {
                            var p = Math.max(0, x - q - a.maxLabelDistance);
                            r = Math.min(x + q + a.maxLabelDistance, e.plotHeight);
                            f.forEach(function(b) {
                                0 < b.labelDistance && b.dataLabel && (b.top = Math.max(0, x - q - b.labelDistance), b.bottom = Math.min(x + q + b.labelDistance, e.plotHeight), v = b.dataLabel.getBBox().height || 21, b.distributeBox = {
                                    target: b.labelPosition.natural.y - b.top + v / 2,
                                    size: v,
                                    rank: b.y
                                }, w.push(b.distributeBox));
                            });
                            p = r + v - p;
                            E(w, p, p / 5);
                        }
                        for(V = 0; V < h; V++){
                            A = f[V];
                            J = A.labelPosition;
                            M = A.dataLabel;
                            R = !1 === A.visible ? "hidden" : "inherit";
                            Q = p = J.natural.y;
                            w && m(A.distributeBox) && ("undefined" === typeof A.distributeBox.pos ? R = "hidden" : (K = A.distributeBox.size, Q = I.radialDistributionY(A)));
                            delete A.positionIndex;
                            if (g.justify) L = I.justify(A, q, z);
                            else switch(g.alignTo){
                                case "connectors":
                                    L = I.alignToConnectors(f, l, b, k);
                                    break;
                                case "plotEdges":
                                    L = I.alignToPlotEdges(M, l, b, k);
                                    break;
                                default:
                                    L = I.radialDistributionX(a, A, Q, p);
                            }
                            M._attr = {
                                visibility: R,
                                align: J.alignment
                            };
                            S = A.options.dataLabels || {};
                            M._pos = {
                                x: L + n(S.x, g.x) + (({
                                    left: d,
                                    right: -d
                                })[J.alignment] || 0),
                                y: Q + n(S.y, g.y) - M.getBBox().height / 2
                            };
                            J && (J.computed.x = L, J.computed.y = Q);
                            n(g.crop, !0) && (D = M.getBBox().width, p = null, L - D < d && 1 === l ? (p = Math.round(D - L + d), C[3] = Math.max(p, C[3])) : L + D > b - d && 0 === l && (p = Math.round(L + D - b + d), C[1] = Math.max(p, C[1])), 0 > Q - K / 2 ? C[0] = Math.max(Math.round(-Q + K / 2), C[0]) : Q + K / 2 > c && (C[2] = Math.max(Math.round(Q + K / 2 - c), C[2])), M.sideOverflow = p);
                        }
                    }
                }), 0 === t(C) || this.verifyDataLabelOverflow(C)) && (this.placeDataLabels(), this.points.forEach(function(b) {
                    S = p(g, b.options.dataLabels);
                    if (H = n(S.connectorWidth, 1)) {
                        let c;
                        G = b.connector;
                        if ((M = b.dataLabel) && M._pos && b.visible && 0 < b.labelDistance) {
                            R = M._attr.visibility;
                            if (c = !G) b.connector = G = e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + b.colorIndex + (b.className ? " " + b.className : "")).add(a.dataLabelsGroup), e.styledMode || G.attr({
                                "stroke-width": H,
                                stroke: S.connectorColor || b.color || "#666666"
                            });
                            G[c ? "attr" : "animate"]({
                                d: b.getConnectorPath()
                            });
                            G.attr("visibility", R);
                        } else G && (b.connector = G.destroy());
                    }
                }));
            }
            function I() {
                this.points.forEach(function(a) {
                    let f = a.dataLabel, e;
                    f && a.visible && ((e = f._pos) ? (f.sideOverflow && (f._attr.width = Math.max(f.getBBox().width - f.sideOverflow, 0), f.css({
                        width: f._attr.width + "px",
                        textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis"
                    }), f.shortened = !0), f.attr(f._attr), f[f.moved ? "animate" : "attr"](e), f.moved = !0) : f && f.attr({
                        y: -9999
                    }));
                    delete a.distributeBox;
                }, this);
            }
            function A(a) {
                let f = this.center, e = this.options, g = e.center, d = e.minSize || 80, b, c = null !== e.size;
                c || (null !== g[0] ? b = Math.max(f[2] - Math.max(a[1], a[3]), d) : (b = Math.max(f[2] - a[1] - a[3], d), f[0] += (a[3] - a[1]) / 2), null !== g[1] ? b = q(b, d, f[2] - Math.max(a[0], a[2])) : (b = q(b, d, f[2] - a[0] - a[2]), f[1] += (a[0] - a[2]) / 2), b < f[2] ? (f[2] = b, f[3] = Math.min(e.thickness ? Math.max(0, b - 2 * e.thickness) : Math.max(0, h(e.innerSize || 0, b)), b), this.translate(f), this.drawDataLabels && this.drawDataLabels()) : c = !0);
                return c;
            }
            const C = [], f = {
                radialDistributionY: function(a) {
                    return a.top + a.distributeBox.pos;
                },
                radialDistributionX: function(a, f, e, g) {
                    return a.getX(e < f.top + 2 || e > f.bottom - 2 ? g : e, f.half, f);
                },
                justify: function(a, f, e) {
                    return e[0] + (a.half ? -1 : 1) * (f + a.labelDistance);
                },
                alignToPlotEdges: function(a, f, e, g) {
                    a = a.getBBox().width;
                    return f ? a + g : e - a - g;
                },
                alignToConnectors: function(a, f, e, g) {
                    let d = 0, b;
                    a.forEach(function(a) {
                        b = a.dataLabel.getBBox().width;
                        b > d && (d = b);
                    });
                    return f ? d + g : e - d - g;
                }
            };
            e.compose = function(e) {
                a.compose(B);
                G.pushUnique(C, e) && (e = e.prototype, e.dataLabelPositioners = f, e.alignDataLabel = u, e.drawDataLabels = g, e.placeDataLabels = I, e.verifyDataLabelOverflow = A);
            };
        })(g || (g = {}));
        return g;
    });
    L(a, "Extensions/OverlappingDataLabels.js", [
        a["Core/Chart/Chart.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        function u(a, m) {
            let p, n = !1;
            a && (p = a.newOpacity, a.oldOpacity !== p && (a.alignAttr && a.placed ? (a[p ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), n = !0, a.alignAttr.opacity = p, a[a.isOld ? "animate" : "attr"](a.alignAttr, null, function() {
                m.styledMode || a.css({
                    pointerEvents: p ? "auto" : "none"
                });
            }), G(m, "afterHideOverlappingLabel")) : a.attr({
                opacity: p
            })), a.isOld = !0);
            return n;
        }
        const { addEvent: K, fireEvent: G, isArray: D, isNumber: E, objectEach: B, pick: t } = A;
        K(a, "render", function() {
            let a = this, m = [];
            (this.labelCollectors || []).forEach(function(a) {
                m = m.concat(a());
            });
            (this.yAxis || []).forEach(function(a) {
                a.stacking && a.options.stackLabels && !a.options.stackLabels.allowOverlap && B(a.stacking.stacks, function(a) {
                    B(a, function(a) {
                        a.label && m.push(a.label);
                    });
                });
            });
            (this.series || []).forEach(function(q) {
                var n = q.options.dataLabels;
                q.visible && (!1 !== n.enabled || q._hasPointLabels) && (n = (h)=>h.forEach((g)=>{
                        g.visible && (D(g.dataLabels) ? g.dataLabels : g.dataLabel ? [
                            g.dataLabel
                        ] : []).forEach(function(e) {
                            const h = e.options;
                            e.labelrank = t(h.labelrank, g.labelrank, g.shapeArgs && g.shapeArgs.height);
                            h.allowOverlap ? (e.oldOpacity = e.opacity, e.newOpacity = 1, u(e, a)) : m.push(e);
                        });
                    }), n(q.nodes || []), n(q.points));
            });
            this.hideOverlappingLabels(m);
        });
        a.prototype.hideOverlappingLabels = function(a) {
            let m = this, q = a.length, n = m.renderer;
            var h;
            let g;
            let e, x, t, A = !1;
            var C = function(a) {
                let f, e;
                var g;
                let h = a.box ? 0 : a.padding || 0, d = g = 0, b, c;
                if (a && (!a.alignAttr || a.placed)) return f = a.alignAttr || {
                    x: a.attr("x"),
                    y: a.attr("y")
                }, e = a.parentGroup, a.width || (g = a.getBBox(), a.width = g.width, a.height = g.height, g = n.fontMetrics(a.element).h), b = a.width - 2 * h, (c = ({
                    left: "0",
                    center: "0.5",
                    right: "1"
                })[a.alignValue]) ? d = +c * b : E(a.x) && Math.round(a.x) !== a.translateX && (d = a.x - a.translateX), {
                    x: f.x + (e.translateX || 0) + h - (d || 0),
                    y: f.y + (e.translateY || 0) + h - g,
                    width: a.width - 2 * h,
                    height: a.height - 2 * h
                };
            };
            for(g = 0; g < q; g++)if (h = a[g]) h.oldOpacity = h.opacity, h.newOpacity = 1, h.absoluteBox = C(h);
            a.sort(function(a, e) {
                return (e.labelrank || 0) - (a.labelrank || 0);
            });
            for(g = 0; g < q; g++)for(x = (C = a[g]) && C.absoluteBox, h = g + 1; h < q; ++h)t = (e = a[h]) && e.absoluteBox, !x || !t || C === e || 0 === C.newOpacity || 0 === e.newOpacity || "hidden" === C.visibility || "hidden" === e.visibility || t.x >= x.x + x.width || t.x + t.width <= x.x || t.y >= x.y + x.height || t.y + t.height <= x.y || ((C.labelrank < e.labelrank ? C : e).newOpacity = 0);
            a.forEach(function(a) {
                u(a, m) && (A = !0);
            });
            A && G(m, "afterHideAllOverlappingLabels");
        };
    });
    L(a, "Extensions/BorderRadius.js", [
        a["Core/Defaults.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D) {
        const { defaultOptions: u } = a;
        ({ seriesTypes: a } = J);
        const { addEvent: B, extend: t, isObject: q, merge: m, relativeLength: p } = D, n = {
            radius: 0,
            scope: "stack",
            where: void 0
        }, h = (a, e)=>{
            q(a) || (a = {
                radius: a || 0
            });
            return m(n, e, a);
        };
        if (-1 === K.symbolCustomAttribs.indexOf("borderRadius")) {
            K.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY");
            const g = G.prototype.symbols.arc;
            G.prototype.symbols.arc = function(a, e, h, n, f = {}) {
                a = g(a, e, h, n, f);
                const { innerR: m = 0, r: r = h, start: l = 0, end: v = 0 } = f;
                if (f.open || !f.borderRadius) return a;
                h = v - l;
                e = Math.sin(h / 2);
                f = Math.max(Math.min(p(f.borderRadius || 0, r - m), (r - m) / 2, r * e / (1 + e)), 0);
                h = Math.min(f, h / Math.PI * 2 * m);
                for(e = a.length - 1; e--;){
                    let g = void 0, l = void 0, m = void 0;
                    n = a;
                    var d = e, b = 1 < e ? h : f, c = n[d], k = n[d + 1];
                    "Z" === k[0] && (k = n[0]);
                    "M" !== c[0] && "L" !== c[0] || "A" !== k[0] ? "A" !== c[0] || "M" !== k[0] && "L" !== k[0] || (m = k, l = c) : (m = c, l = k, g = !0);
                    if (m && l && l.params) {
                        c = l[1];
                        var w = l[5];
                        k = l.params;
                        const { start: a, end: f, cx: e, cy: h } = k;
                        var z = w ? c - b : c + b;
                        const r = z ? Math.asin(b / z) : 0;
                        w = w ? r : -r;
                        z *= Math.cos(r);
                        g ? (k.start = a + w, m[1] = e + z * Math.cos(a), m[2] = h + z * Math.sin(a), n.splice(d + 1, 0, [
                            "A",
                            b,
                            b,
                            0,
                            0,
                            1,
                            e + c * Math.cos(k.start),
                            h + c * Math.sin(k.start)
                        ])) : (k.end = f - w, l[6] = e + c * Math.cos(k.end), l[7] = h + c * Math.sin(k.end), n.splice(d + 1, 0, [
                            "A",
                            b,
                            b,
                            0,
                            0,
                            1,
                            e + z * Math.cos(f),
                            h + z * Math.sin(f)
                        ]));
                        l[4] = Math.abs(k.end - k.start) < Math.PI ? 0 : 1;
                    }
                }
                return a;
            };
            const e = G.prototype.symbols.roundedRect;
            G.prototype.symbols.roundedRect = function(a, g, h, n, f = {}) {
                const m = e(a, g, h, n, f), { r: r = 0, brBoxHeight: l = n, brBoxY: v = g } = f;
                var d = g - v, b = v + l - (g + n);
                f = -0.1 < d - r ? 0 : r;
                const c = -0.1 < b - r ? 0 : r;
                var k = Math.max(f && d, 0);
                const w = Math.max(c && b, 0);
                b = [
                    a + f,
                    g
                ];
                d = [
                    a + h - f,
                    g
                ];
                const z = [
                    a + h,
                    g + f
                ], q = [
                    a + h,
                    g + n - c
                ], p = [
                    a + h - c,
                    g + n
                ], x = [
                    a + c,
                    g + n
                ], t = [
                    a,
                    g + n - c
                ], u = [
                    a,
                    g + f
                ];
                if (k) {
                    const a = Math.sqrt(Math.pow(f, 2) - Math.pow(f - k, 2));
                    b[0] -= a;
                    d[0] += a;
                    z[1] = u[1] = g + f - k;
                }
                n < f - k && (k = Math.sqrt(Math.pow(f, 2) - Math.pow(f - k - n, 2)), z[0] = q[0] = a + h - f + k, p[0] = Math.min(z[0], p[0]), x[0] = Math.max(q[0], x[0]), t[0] = u[0] = a + f - k, z[1] = u[1] = g + n);
                w && (k = Math.sqrt(Math.pow(c, 2) - Math.pow(c - w, 2)), p[0] += k, x[0] -= k, q[1] = t[1] = g + n - c + w);
                n < c - w && (n = Math.sqrt(Math.pow(c, 2) - Math.pow(c - w - n, 2)), z[0] = q[0] = a + h - c + n, d[0] = Math.min(z[0], d[0]), b[0] = Math.max(q[0], b[0]), t[0] = u[0] = a + c - n, q[1] = t[1] = g);
                m.length = 0;
                m.push([
                    "M",
                    ...b
                ], [
                    "L",
                    ...d
                ], [
                    "A",
                    f,
                    f,
                    0,
                    0,
                    1,
                    ...z
                ], [
                    "L",
                    ...q
                ], [
                    "A",
                    c,
                    c,
                    0,
                    0,
                    1,
                    ...p
                ], [
                    "L",
                    ...x
                ], [
                    "A",
                    c,
                    c,
                    0,
                    0,
                    1,
                    ...t
                ], [
                    "L",
                    ...u
                ], [
                    "A",
                    f,
                    f,
                    0,
                    0,
                    1,
                    ...b
                ], [
                    "Z"
                ]);
                return m;
            };
            B(a.pie, "afterTranslate", function() {
                const a = h(this.options.borderRadius);
                for (const e of this.points){
                    const g = e.shapeArgs;
                    g && (g.borderRadius = p(a.radius, (g.r || 0) - (g.innerR || 0)));
                }
            });
            B(A, "afterColumnTranslate", function() {
                var a, e;
                if (this.options.borderRadius && (!this.chart.is3d || !this.chart.is3d())) {
                    const { options: m, yAxis: r } = this, l = "percent" === m.stacking;
                    var g = null === (e = null === (a = u.plotOptions) || void 0 === a ? void 0 : a[this.type]) || void 0 === e ? void 0 : e.borderRadius;
                    a = h(m.borderRadius, q(g) ? g : {});
                    e = r.options.reversed;
                    for (const h of this.points)if ({ shapeArgs: g } = h, "roundedRect" === h.shapeType && g) {
                        const { width: d = 0, height: b = 0, y: c = 0 } = g;
                        var n = c, f = b;
                        "stack" === a.scope && h.stackTotal && (n = r.translate(l ? 100 : h.stackTotal, !1, !0, !1, !0), f = r.translate(m.threshold || 0, !1, !0, !1, !0), f = this.crispCol(0, Math.min(n, f), 0, Math.abs(n - f)), n = f.y, f = f.height);
                        const k = -1 === (h.negative ? -1 : 1) * (e ? -1 : 1);
                        let w = a.where;
                        !w && this.is("waterfall") && Math.abs((h.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (w = "all");
                        w || (w = "end");
                        const v = Math.min(p(a.radius, d), d / 2, "all" === w ? b / 2 : Infinity) || 0;
                        "end" === w && (k && (n -= v), f += v);
                        t(g, {
                            brBoxHeight: f,
                            brBoxY: n,
                            r: v
                        });
                    }
                }
            }, {
                order: 9
            });
        }
        A = {
            optionsToObject: h
        };
        "";
        return A;
    });
    L(a, "Core/Responsive.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { diffObjects: u, extend: J, find: K, merge: G, pick: D, uniqueKey: E } = a;
        var B;
        (function(t) {
            function q(a, h) {
                const g = a.condition;
                (g.callback || function() {
                    return this.chartWidth <= D(g.maxWidth, Number.MAX_VALUE) && this.chartHeight <= D(g.maxHeight, Number.MAX_VALUE) && this.chartWidth >= D(g.minWidth, 0) && this.chartHeight >= D(g.minHeight, 0);
                }).call(this) && h.push(a._id);
            }
            function m(a, h) {
                const g = this.options.responsive;
                var e = this.currentResponsive;
                let n = [];
                !h && g && g.rules && g.rules.forEach((a)=>{
                    "undefined" === typeof a._id && (a._id = E());
                    this.matchResponsiveRule(a, n);
                }, this);
                h = G(...n.map((a)=>K((g || {}).rules || [], (e)=>e._id === a)).map((a)=>a && a.chartOptions));
                h.isResponsiveOptions = !0;
                n = n.toString() || void 0;
                n !== (e && e.ruleIds) && (e && this.update(e.undoOptions, a, !0), n ? (e = u(h, this.options, !0, this.collectionsWithUpdate), e.isResponsiveOptions = !0, this.currentResponsive = {
                    ruleIds: n,
                    mergedOptions: h,
                    undoOptions: e
                }, this.update(h, a, !0)) : this.currentResponsive = void 0);
            }
            const p = [];
            t.compose = function(n) {
                a.pushUnique(p, n) && J(n.prototype, {
                    matchResponsiveRule: q,
                    setResponsive: m
                });
                return n;
            };
        })(B || (B = {}));
        "";
        "";
        return B;
    });
    L(a, "masters/highcharts.src.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"],
        a["Core/Defaults.js"],
        a["Core/Animation/Fx.js"],
        a["Core/Animation/AnimationUtilities.js"],
        a["Core/Renderer/HTML/AST.js"],
        a["Core/Templating.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Renderer/HTML/HTMLElement.js"],
        a["Core/Renderer/HTML/HTMLRenderer.js"],
        a["Core/Axis/Axis.js"],
        a["Core/Axis/DateTimeAxis.js"],
        a["Core/Axis/LogarithmicAxis.js"],
        a["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"],
        a["Core/Axis/Tick.js"],
        a["Core/Tooltip.js"],
        a["Core/Series/Point.js"],
        a["Core/Pointer.js"],
        a["Core/Legend/Legend.js"],
        a["Core/Chart/Chart.js"],
        a["Core/Axis/Stacking/StackingAxis.js"],
        a["Core/Axis/Stacking/StackItem.js"],
        a["Core/Series/Series.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Series/Column/ColumnSeries.js"],
        a["Series/Column/ColumnDataLabel.js"],
        a["Series/Pie/PieSeries.js"],
        a["Series/Pie/PieDataLabel.js"],
        a["Core/Series/DataLabel.js"],
        a["Core/Responsive.js"],
        a["Core/Color/Color.js"],
        a["Core/Time.js"]
    ], function(a, A, J, K, G, D, E, B, t, q, m, p, n, h, g, e, x, I, M, C, f, y, r, l, v, d, b, c, k, w, z, F, O, P) {
        a.animate = G.animate;
        a.animObject = G.animObject;
        a.getDeferredAnimation = G.getDeferredAnimation;
        a.setAnimation = G.setAnimation;
        a.stop = G.stop;
        a.timers = K.timers;
        a.AST = D;
        a.Axis = n;
        a.Chart = y;
        a.chart = y.chart;
        a.Fx = K;
        a.Legend = f;
        a.PlotLineOrBand = e;
        a.Point = M;
        a.Pointer = C;
        a.Series = v;
        a.StackItem = l;
        a.SVGElement = t;
        a.SVGRenderer = q;
        a.Templating = E;
        a.Tick = x;
        a.Time = P;
        a.Tooltip = I;
        a.Color = O;
        a.color = O.parse;
        p.compose(q);
        m.compose(t);
        C.compose(y);
        f.compose(y);
        a.defaultOptions = J.defaultOptions;
        a.getOptions = J.getOptions;
        a.time = J.defaultTime;
        a.setOptions = J.setOptions;
        a.dateFormat = E.dateFormat;
        a.format = E.format;
        a.numberFormat = E.numberFormat;
        a.addEvent = A.addEvent;
        a.arrayMax = A.arrayMax;
        a.arrayMin = A.arrayMin;
        a.attr = A.attr;
        a.clearTimeout = A.clearTimeout;
        a.correctFloat = A.correctFloat;
        a.createElement = A.createElement;
        a.css = A.css;
        a.defined = A.defined;
        a.destroyObjectProperties = A.destroyObjectProperties;
        a.discardElement = A.discardElement;
        a.distribute = B.distribute;
        a.erase = A.erase;
        a.error = A.error;
        a.extend = A.extend;
        a.extendClass = A.extendClass;
        a.find = A.find;
        a.fireEvent = A.fireEvent;
        a.getMagnitude = A.getMagnitude;
        a.getStyle = A.getStyle;
        a.inArray = A.inArray;
        a.isArray = A.isArray;
        a.isClass = A.isClass;
        a.isDOMElement = A.isDOMElement;
        a.isFunction = A.isFunction;
        a.isNumber = A.isNumber;
        a.isObject = A.isObject;
        a.isString = A.isString;
        a.keys = A.keys;
        a.merge = A.merge;
        a.normalizeTickInterval = A.normalizeTickInterval;
        a.objectEach = A.objectEach;
        a.offset = A.offset;
        a.pad = A.pad;
        a.pick = A.pick;
        a.pInt = A.pInt;
        a.relativeLength = A.relativeLength;
        a.removeEvent = A.removeEvent;
        a.seriesType = d.seriesType;
        a.splat = A.splat;
        a.stableSort = A.stableSort;
        a.syncTimeout = A.syncTimeout;
        a.timeUnits = A.timeUnits;
        a.uniqueKey = A.uniqueKey;
        a.useSerialIds = A.useSerialIds;
        a.wrap = A.wrap;
        c.compose(b);
        z.compose(v);
        h.compose(n);
        g.compose(n);
        w.compose(k);
        e.compose(n);
        F.compose(y);
        r.compose(n, y, v);
        I.compose(C);
        return a;
    });
    L(a, "Core/Axis/BrokenAxis.js", [
        a["Core/Axis/Stacking/StackItem.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        const { addEvent: u, find: K, fireEvent: G, isArray: D, isNumber: E, pick: B } = A;
        var t;
        (function(q) {
            function m() {
                "undefined" !== typeof this.brokenAxis && this.brokenAxis.setBreaks(this.options.breaks, !1);
            }
            function p() {
                this.brokenAxis && this.brokenAxis.hasBreaks && (this.options.ordinal = !1);
            }
            function n() {
                const a = this.brokenAxis;
                if (a && a.hasBreaks) {
                    const f = this.tickPositions, e = this.tickPositions.info, g = [];
                    for(let e = 0; e < f.length; e++)a.isInAnyBreak(f[e]) || g.push(f[e]);
                    this.tickPositions = g;
                    this.tickPositions.info = e;
                }
            }
            function h() {
                this.brokenAxis || (this.brokenAxis = new C(this));
            }
            function g() {
                const { isDirty: a, options: { connectNulls: e }, points: g, xAxis: l, yAxis: h } = this;
                if (a) {
                    let a = g.length;
                    for(; a--;){
                        const b = g[a], c = !(null === b.y && !1 === e) && (l && l.brokenAxis && l.brokenAxis.isInAnyBreak(b.x, !0) || h && h.brokenAxis && h.brokenAxis.isInAnyBreak(b.y, !0));
                        b.visible = c ? !1 : !1 !== b.options.visible;
                    }
                }
            }
            function e() {
                this.drawBreaks(this.xAxis, [
                    "x"
                ]);
                this.drawBreaks(this.yAxis, B(this.pointArrayMap, [
                    "y"
                ]));
            }
            function t(a, e) {
                const f = this, g = f.points;
                let h, d, b, c;
                if (a && a.brokenAxis && a.brokenAxis.hasBreaks) {
                    const k = a.brokenAxis;
                    e.forEach(function(e) {
                        h = k && k.breakArray || [];
                        d = a.isXAxis ? a.min : B(f.options.threshold, a.min);
                        g.forEach(function(f) {
                            c = B(f["stack" + e.toUpperCase()], f[e]);
                            h.forEach(function(e) {
                                if (E(d) && E(c)) {
                                    b = !1;
                                    if (d < e.from && c > e.to || d > e.from && c < e.from) b = "pointBreak";
                                    else if (d < e.from && c > e.from && c < e.to || d > e.from && c > e.to && c < e.from) b = "pointInBreak";
                                    b && G(a, b, {
                                        point: f,
                                        brk: e
                                    });
                                }
                            });
                        });
                    });
                }
            }
            function I() {
                var e = this.currentDataGrouping, g = e && e.gapSize;
                e = this.points.slice();
                const h = this.yAxis;
                let l = this.options.gapSize, n = e.length - 1;
                var d;
                if (l && 0 < n) for("value" !== this.options.gapUnit && (l *= this.basePointRange), g && g > l && g >= this.basePointRange && (l = g); n--;)d && !1 !== d.visible || (d = e[n + 1]), g = e[n], !1 !== d.visible && !1 !== g.visible && (d.x - g.x > l && (d = (g.x + d.x) / 2, e.splice(n + 1, 0, {
                    isNull: !0,
                    x: d
                }), h.stacking && this.options.stacking && (d = h.stacking.stacks[this.stackKey][d] = new a(h, h.options.stackLabels, !1, d, this.stack), d.total = 0)), d = g);
                return this.getGraphPath(e);
            }
            const M = [];
            q.compose = function(a, q) {
                A.pushUnique(M, a) && (a.keepProps.push("brokenAxis"), u(a, "init", h), u(a, "afterInit", m), u(a, "afterSetTickPositions", n), u(a, "afterSetOptions", p));
                if (A.pushUnique(M, q)) {
                    const a = q.prototype;
                    a.drawBreaks = t;
                    a.gappedPath = I;
                    u(q, "afterGeneratePoints", g);
                    u(q, "afterRender", e);
                }
                return a;
            };
            class C {
                static isInBreak(a, e) {
                    const f = a.repeat || Infinity, g = a.from, h = a.to - a.from;
                    e = e >= g ? (e - g) % f : f - (g - e) % f;
                    return a.inclusive ? e <= h : e < h && 0 !== e;
                }
                static lin2Val(a) {
                    var e = this.brokenAxis;
                    e = e && e.breakArray;
                    if (!e || !E(a)) return a;
                    let f, g;
                    for(g = 0; g < e.length && !(f = e[g], f.from >= a); g++)f.to < a ? a += f.len : C.isInBreak(f, a) && (a += f.len);
                    return a;
                }
                static val2Lin(a) {
                    var e = this.brokenAxis;
                    e = e && e.breakArray;
                    if (!e || !E(a)) return a;
                    let f = a, g, h;
                    for(h = 0; h < e.length; h++)if (g = e[h], g.to <= a) f -= g.len;
                    else if (g.from >= a) break;
                    else if (C.isInBreak(g, a)) {
                        f -= a - g.from;
                        break;
                    }
                    return f;
                }
                constructor(a){
                    this.hasBreaks = !1;
                    this.axis = a;
                }
                findBreakAt(a, e) {
                    return K(e, function(e) {
                        return e.from < a && a < e.to;
                    });
                }
                isInAnyBreak(a, e) {
                    const f = this.axis, g = f.options.breaks || [];
                    let h = g.length, d, b, c;
                    if (h && E(a)) {
                        for(; h--;)C.isInBreak(g[h], a) && (d = !0, b || (b = B(g[h].showPoints, !f.isXAxis)));
                        c = d && e ? d && !b : d;
                    }
                    return c;
                }
                setBreaks(a, e) {
                    const f = this, g = f.axis, h = D(a) && !!a.length;
                    g.isDirty = f.hasBreaks !== h;
                    f.hasBreaks = h;
                    a !== g.options.breaks && (g.options.breaks = g.userOptions.breaks = a);
                    g.forceRedraw = !0;
                    g.series.forEach(function(a) {
                        a.isDirty = !0;
                    });
                    h || g.val2lin !== C.val2Lin || (delete g.val2lin, delete g.lin2val);
                    h && (g.userOptions.ordinal = !1, g.lin2val = C.lin2Val, g.val2lin = C.val2Lin, g.setExtremes = function(a, b, c, e, h) {
                        if (f.hasBreaks) {
                            const c = this.options.breaks || [];
                            let d;
                            for(; d = f.findBreakAt(a, c);)a = d.to;
                            for(; d = f.findBreakAt(b, c);)b = d.from;
                            b < a && (b = a);
                        }
                        g.constructor.prototype.setExtremes.call(this, a, b, c, e, h);
                    }, g.setAxisTranslation = function() {
                        g.constructor.prototype.setAxisTranslation.call(this);
                        f.unitLength = void 0;
                        if (f.hasBreaks) {
                            const a = g.options.breaks || [], b = [], c = [], e = B(g.pointRangePadding, 0);
                            let h = 0, l, n, m = g.userMin || g.min, r = g.userMax || g.max, v, q;
                            a.forEach(function(b) {
                                n = b.repeat || Infinity;
                                E(m) && E(r) && (C.isInBreak(b, m) && (m += b.to % n - m % n), C.isInBreak(b, r) && (r -= r % n - b.from % n));
                            });
                            a.forEach(function(a) {
                                v = a.from;
                                n = a.repeat || Infinity;
                                if (E(m) && E(r)) {
                                    for(; v - n > m;)v -= n;
                                    for(; v < m;)v += n;
                                    for(q = v; q < r; q += n)b.push({
                                        value: q,
                                        move: "in"
                                    }), b.push({
                                        value: q + a.to - a.from,
                                        move: "out",
                                        size: a.breakSize
                                    });
                                }
                            });
                            b.sort(function(b, a) {
                                return b.value === a.value ? ("in" === b.move ? 0 : 1) - ("in" === a.move ? 0 : 1) : b.value - a.value;
                            });
                            l = 0;
                            v = m;
                            b.forEach(function(b) {
                                l += "in" === b.move ? 1 : -1;
                                1 === l && "in" === b.move && (v = b.value);
                                0 === l && E(v) && (c.push({
                                    from: v,
                                    to: b.value,
                                    len: b.value - v - (b.size || 0)
                                }), h += b.value - v - (b.size || 0));
                            });
                            f.breakArray = c;
                            E(m) && E(r) && E(g.min) && (f.unitLength = r - m - h + e, G(g, "afterBreaks"), g.staticScale ? g.transA = g.staticScale : f.unitLength && (g.transA *= (r - g.min + e) / f.unitLength), e && (g.minPixelPadding = g.transA * (g.minPointOffset || 0)), g.min = m, g.max = r);
                        }
                    });
                    B(e, !0) && g.chart.redraw();
                }
            }
            q.Additions = C;
        })(t || (t = {}));
        return t;
    });
    L(a, "masters/modules/broken-axis.src.js", [
        a["Core/Globals.js"],
        a["Core/Axis/BrokenAxis.js"]
    ], function(a, A) {
        A.compose(a.Axis, a.Series);
    });
    L(a, "Extensions/DataGrouping/ApproximationRegistry.js", [], function() {
        return {};
    });
    L(a, "Extensions/DataGrouping/ApproximationDefaults.js", [
        a["Extensions/DataGrouping/ApproximationRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        function u(a) {
            const m = a.length;
            a = K(a);
            t(a) && m && (a = E(a / m));
            return a;
        }
        function K(a) {
            let m = a.length, q;
            if (!m && a.hasNulls) q = null;
            else if (m) for(q = 0; m--;)q += a[m];
            return q;
        }
        const { arrayMax: G, arrayMin: D, correctFloat: E, extend: B, isNumber: t } = A;
        A = {
            average: u,
            averages: function() {
                const a = [];
                [].forEach.call(arguments, function(m) {
                    a.push(u(m));
                });
                return "undefined" === typeof a[0] ? void 0 : a;
            },
            close: function(a) {
                return a.length ? a[a.length - 1] : a.hasNulls ? null : void 0;
            },
            high: function(a) {
                return a.length ? G(a) : a.hasNulls ? null : void 0;
            },
            hlc: function(q, m, p) {
                q = a.high(q);
                m = a.low(m);
                p = a.close(p);
                if (t(q) || t(m) || t(p)) return [
                    q,
                    m,
                    p
                ];
            },
            low: function(a) {
                return a.length ? D(a) : a.hasNulls ? null : void 0;
            },
            ohlc: function(q, m, p, n) {
                q = a.open(q);
                m = a.high(m);
                p = a.low(p);
                n = a.close(n);
                if (t(q) || t(m) || t(p) || t(n)) return [
                    q,
                    m,
                    p,
                    n
                ];
            },
            open: function(a) {
                return a.length ? a[0] : a.hasNulls ? null : void 0;
            },
            range: function(q, m) {
                q = a.low(q);
                m = a.high(m);
                if (t(q) || t(m)) return [
                    q,
                    m
                ];
                if (null === q && null === m) return null;
            },
            sum: K
        };
        B(a, A);
        return A;
    });
    L(a, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function() {
        return {
            common: {
                groupPixelWidth: 2,
                dateTimeLabelFormats: {
                    millisecond: [
                        "%A, %e %b, %H:%M:%S.%L",
                        "%A, %e %b, %H:%M:%S.%L",
                        "-%H:%M:%S.%L"
                    ],
                    second: [
                        "%A, %e %b, %H:%M:%S",
                        "%A, %e %b, %H:%M:%S",
                        "-%H:%M:%S"
                    ],
                    minute: [
                        "%A, %e %b, %H:%M",
                        "%A, %e %b, %H:%M",
                        "-%H:%M"
                    ],
                    hour: [
                        "%A, %e %b, %H:%M",
                        "%A, %e %b, %H:%M",
                        "-%H:%M"
                    ],
                    day: [
                        "%A, %e %b %Y",
                        "%A, %e %b",
                        "-%A, %e %b %Y"
                    ],
                    week: [
                        "Week from %A, %e %b %Y",
                        "%A, %e %b",
                        "-%A, %e %b %Y"
                    ],
                    month: [
                        "%B %Y",
                        "%B",
                        "-%B %Y"
                    ],
                    year: [
                        "%Y",
                        "%Y",
                        "-%Y"
                    ]
                }
            },
            seriesSpecific: {
                line: {},
                spline: {},
                area: {},
                areaspline: {},
                arearange: {},
                column: {
                    groupPixelWidth: 10
                },
                columnrange: {
                    groupPixelWidth: 10
                },
                candlestick: {
                    groupPixelWidth: 10
                },
                ohlc: {
                    groupPixelWidth: 5
                },
                hlc: {
                    groupPixelWidth: 5
                },
                heikinashi: {
                    groupPixelWidth: 10
                }
            },
            units: [
                [
                    "millisecond",
                    [
                        1,
                        2,
                        5,
                        10,
                        20,
                        25,
                        50,
                        100,
                        200,
                        500
                    ]
                ],
                [
                    "second",
                    [
                        1,
                        2,
                        5,
                        10,
                        15,
                        30
                    ]
                ],
                [
                    "minute",
                    [
                        1,
                        2,
                        5,
                        10,
                        15,
                        30
                    ]
                ],
                [
                    "hour",
                    [
                        1,
                        2,
                        3,
                        4,
                        6,
                        8,
                        12
                    ]
                ],
                [
                    "day",
                    [
                        1
                    ]
                ],
                [
                    "week",
                    [
                        1
                    ]
                ],
                [
                    "month",
                    [
                        1,
                        3,
                        6
                    ]
                ],
                [
                    "year",
                    null
                ]
            ]
        };
    });
    L(a, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [
        a["Extensions/DataGrouping/DataGroupingDefaults.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        function u(a) {
            const h = this, g = h.series;
            g.forEach(function(a) {
                a.groupPixelWidth = void 0;
            });
            g.forEach(function(e) {
                e.groupPixelWidth = h.getGroupPixelWidth && h.getGroupPixelWidth();
                e.groupPixelWidth && (e.hasProcessed = !0);
                e.applyGrouping(!!a.hasExtremesChanged);
            });
        }
        function K() {
            const n = this.series;
            let h = n.length, g = 0, e = !1, m, p;
            for(; h--;)if (p = n[h].options.dataGrouping) {
                if (g = Math.max(g, q(p.groupPixelWidth, a.common.groupPixelWidth)), m = (n[h].processedXData || n[h].data).length, n[h].groupPixelWidth || m > this.chart.plotSizeX / g || m && p.forced) e = !0;
            }
            return e ? g : 0;
        }
        function G() {
            this.series.forEach(function(a) {
                a.hasProcessed = !1;
            });
        }
        function D(a, h) {
            let g;
            h = q(h, !0);
            a || (a = {
                forced: !1,
                units: null
            });
            if (this instanceof p) for(g = this.series.length; g--;)this.series[g].update({
                dataGrouping: a
            }, !1);
            else this.chart.options.series.forEach(function(e) {
                e.dataGrouping = "boolean" === typeof a ? a : t(a, e.dataGrouping);
            });
            this.ordinal && (this.ordinal.slope = void 0);
            h && this.chart.redraw();
        }
        const { addEvent: E, extend: B, merge: t, pick: q } = A, m = [];
        let p;
        return {
            compose: function(a) {
                p = a;
                A.pushUnique(m, a) && (E(a, "afterSetScale", G), E(a, "postProcessData", u), B(a.prototype, {
                    applyGrouping: u,
                    getGroupPixelWidth: K,
                    setDataGrouping: D
                }));
            }
        };
    });
    L(a, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [
        a["Extensions/DataGrouping/ApproximationRegistry.js"],
        a["Extensions/DataGrouping/DataGroupingDefaults.js"],
        a["Core/Axis/DateTimeAxis.js"],
        a["Core/Defaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D) {
        function u(a) {
            var f = this.chart, h = this.options.dataGrouping, d = !1 !== this.allowDG && h && C(h.enabled, f.options.isStock), b = this.visible || !f.options.chart.ignoreHiddenSeries;
            const c = this.currentDataGrouping;
            var k = !1;
            d && !this.requireSorting && (this.requireSorting = k = !0);
            a = !1 === !(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !a) || !d;
            k && (this.requireSorting = !1);
            if (!a) {
                this.destroyGroupedData();
                a = h.groupAll ? this.xData : this.processedXData;
                d = h.groupAll ? this.yData : this.processedYData;
                var m = f.plotSizeX;
                k = this.xAxis;
                var r = k.options.ordinal, q = this.groupPixelWidth, p;
                let l;
                if (q && a && a.length && m) {
                    this.isDirty = l = !0;
                    this.points = null;
                    var t = k.getExtremes();
                    var x = t.min;
                    t = t.max;
                    r = r && k.ordinal && k.ordinal.getGroupIntervalFactor(x, t, this) || 1;
                    m = k.getTimeTicks(J.Additions.prototype.normalizeTimeTickInterval(q * (t - x) / m * r, h.units || A.units), Math.min(x, a[0]), Math.max(t, a[a.length - 1]), k.options.startOfWeek, a, this.closestPointRange);
                    q = n.groupData.apply(this, [
                        a,
                        d,
                        m,
                        h.approximation
                    ]);
                    a = q.groupedXData;
                    d = q.groupedYData;
                    r = 0;
                    h && h.smoothed && a.length && (h.firstAnchor = "firstPoint", h.anchor = "middle", h.lastAnchor = "lastPoint", e(32, !1, f, {
                        "dataGrouping.smoothed": "use dataGrouping.anchor"
                    }));
                    f = a;
                    var u = t, y = this.options.dataGrouping;
                    t = this.currentDataGrouping && this.currentDataGrouping.gapSize;
                    if (y && this.xData && t && this.groupMap) {
                        x = f.length - 1;
                        var H = y.anchor;
                        const b = C(y.firstAnchor, H);
                        y = C(y.lastAnchor, H);
                        if (H && "start" !== H) {
                            var B = t * ({
                                middle: .5,
                                end: 1
                            })[H];
                            for(H = f.length - 1; H-- && 0 < H;)f[H] += B;
                        }
                        b && "start" !== b && this.xData[0] >= f[0] && (H = this.groupMap[0].start, B = this.groupMap[0].length, I(H) && I(B) && (p = H + (B - 1)), f[0] = ({
                            middle: f[0] + .5 * t,
                            end: f[0] + t,
                            firstPoint: this.xData[0],
                            lastPoint: p && this.xData[p]
                        })[b]);
                        y && "start" !== y && t && f[x] >= u - t && (p = this.groupMap[this.groupMap.length - 1].start, f[x] = ({
                            middle: f[x] + .5 * t,
                            end: f[x] + t,
                            firstPoint: p && this.xData[p],
                            lastPoint: this.xData[this.xData.length - 1]
                        })[y]);
                    }
                    for(p = 1; p < m.length; p++)m.info.segmentStarts && -1 !== m.info.segmentStarts.indexOf(p) || (r = Math.max(m[p] - m[p - 1], r));
                    t = m.info;
                    t.gapSize = r;
                    this.closestPointRange = m.info.totalRange;
                    this.groupMap = q.groupMap;
                    if (b) {
                        b = k;
                        p = a;
                        if (g(p[0]) && I(b.min) && I(b.dataMin) && p[0] < b.min) {
                            if (!g(b.options.min) && b.min <= b.dataMin || b.min === b.dataMin) b.min = Math.min(p[0], b.min);
                            b.dataMin = Math.min(p[0], b.dataMin);
                        }
                        if (g(p[p.length - 1]) && I(b.max) && I(b.dataMax) && p[p.length - 1] > b.max) {
                            if (!g(b.options.max) && I(b.dataMax) && b.max >= b.dataMax || b.max === b.dataMax) b.max = Math.max(p[p.length - 1], b.max);
                            b.dataMax = Math.max(p[p.length - 1], b.dataMax);
                        }
                    }
                    h.groupAll && (this.allGroupedData = d, h = this.cropData(a, d, k.min, k.max, 1), a = h.xData, d = h.yData, this.cropStart = h.start);
                    this.processedXData = a;
                    this.processedYData = d;
                } else this.groupMap = null;
                this.hasGroupedData = l;
                this.currentDataGrouping = t;
                this.preventGraphAnimation = (c && c.totalRange) !== (t && t.totalRange);
            }
        }
        function B() {
            this.groupedData && (this.groupedData.forEach(function(a, e) {
                a && (this.groupedData[e] = a.destroy ? a.destroy() : null);
            }, this), this.groupedData.length = 0);
        }
        function t() {
            f.apply(this);
            this.destroyGroupedData();
            this.groupedData = this.hasGroupedData ? this.points : null;
        }
        function q() {
            return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") || this.options.cumulative ? "sum" : "average";
        }
        function m(e, f, h, d) {
            const b = this, c = b.data, k = b.options && b.options.data, l = [], n = [], m = [], r = e.length, p = !!f, v = [], q = b.pointArrayMap, t = q && q.length, x = [
                "x"
            ].concat(q || [
                "y"
            ]), u = this.options.dataGrouping && this.options.dataGrouping.groupAll;
            let y = 0, C = 0;
            d = "function" === typeof d ? d : d && a[d] ? a[d] : a[b.getDGApproximation && b.getDGApproximation() || "average"];
            if (t) for(var A = q.length; A--;)v.push([]);
            else v.push([]);
            A = t || 1;
            for(let a = 0; a <= r; a++)if (!(e[a] < h[0])) {
                for(; "undefined" !== typeof h[y + 1] && e[a] >= h[y + 1] || a === r;){
                    var B = h[y];
                    b.dataGroupInfo = {
                        start: u ? C : b.cropStart + C,
                        length: v[0].length
                    };
                    var E = d.apply(b, v);
                    b.pointClass && !g(b.dataGroupInfo.options) && (b.dataGroupInfo.options = M(b.pointClass.prototype.optionsToObject.call({
                        series: b
                    }, b.options.data[b.cropStart + C])), x.forEach(function(a) {
                        delete b.dataGroupInfo.options[a];
                    }));
                    "undefined" !== typeof E && (l.push(B), n.push(E), m.push(b.dataGroupInfo));
                    C = a;
                    for(B = 0; B < A; B++)v[B].length = 0, v[B].hasNulls = !1;
                    y += 1;
                    if (a === r) break;
                }
                if (a === r) break;
                if (q) {
                    B = b.options.dataGrouping && b.options.dataGrouping.groupAll ? a : b.cropStart + a;
                    B = c && c[B] || b.pointClass.prototype.applyOptions.apply({
                        series: b
                    }, [
                        k[B]
                    ]);
                    for(let b = 0; b < t; b++)E = B[q[b]], I(E) ? v[b].push(E) : null === E && (v[b].hasNulls = !0);
                } else B = p ? f[a] : null, I(B) ? v[0].push(B) : null === B && (v[0].hasNulls = !0);
            }
            return {
                groupedXData: l,
                groupedYData: n,
                groupMap: m
            };
        }
        function p(a) {
            a = a.options;
            const e = this.type, f = this.chart.options.plotOptions, d = this.useCommonDataGrouping && A.common, b = A.seriesSpecific;
            let c = K.defaultOptions.plotOptions[e].dataGrouping;
            if (f && (b[e] || d)) {
                const k = this.chart.rangeSelector;
                c || (c = M(A.common, b[e]));
                a.dataGrouping = M(d, c, f.series && f.series.dataGrouping, f[e].dataGrouping, this.userOptions.dataGrouping, !a.isInternal && k && I(k.selected) && k.buttonOptions[k.selected].dataGrouping);
            }
        }
        const { series: { prototype: n } } = G, { addEvent: h, defined: g, error: e, extend: x, isNumber: I, merge: M, pick: C } = D, f = n.generatePoints, y = [];
        return {
            compose: function(a) {
                const f = a.prototype.pointClass;
                D.pushUnique(y, f) && h(f, "update", function() {
                    if (this.dataGroup) return e(24, !1, this.series.chart), !1;
                });
                D.pushUnique(y, a) && (h(a, "afterSetOptions", p), h(a, "destroy", B), x(a.prototype, {
                    applyGrouping: u,
                    destroyGroupedData: B,
                    generatePoints: t,
                    getDGApproximation: q,
                    groupData: m
                }));
            },
            groupData: m
        };
    });
    L(a, "Extensions/DataGrouping/DataGrouping.js", [
        a["Extensions/DataGrouping/DataGroupingAxisComposition.js"],
        a["Extensions/DataGrouping/DataGroupingDefaults.js"],
        a["Extensions/DataGrouping/DataGroupingSeriesComposition.js"],
        a["Core/Templating.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G) {
        function u(a) {
            const n = this.chart, h = n.time, g = a.labelConfig, e = g.series;
            var m = e.tooltipOptions, p = e.options.dataGrouping;
            const u = e.xAxis;
            var C = m.xDateFormat;
            let f, y, r = m[a.isFooter ? "footerFormat" : "headerFormat"];
            u && "datetime" === u.options.type && p && q(g.key) && (y = e.currentDataGrouping, p = p.dateTimeLabelFormats || A.common.dateTimeLabelFormats, y ? (m = p[y.unitName], 1 === y.count ? C = m[0] : (C = m[1], f = m[2])) : !C && p && u.dateTime && (C = u.dateTime.getXDateFormat(g.x, m.dateTimeLabelFormats)), C = h.dateFormat(C, g.key), f && (C += h.dateFormat(f, g.key + y.totalRange - 1)), e.chart.styledMode && (r = this.styledModeFormat(r)), a.text = E(r, {
                point: t(g.point, {
                    key: C
                }),
                series: e
            }, n), a.preventDefault());
        }
        const { format: E } = K, { addEvent: B, extend: t, isNumber: q } = G, m = [];
        K = {
            compose: function(p, n, h) {
                a.compose(p);
                J.compose(n);
                h && G.pushUnique(m, h) && B(h, "headerFormatter", u);
            },
            groupData: J.groupData
        };
        "";
        "";
        return K;
    });
    L(a, "masters/modules/datagrouping.src.js", [
        a["Core/Globals.js"],
        a["Extensions/DataGrouping/ApproximationDefaults.js"],
        a["Extensions/DataGrouping/ApproximationRegistry.js"],
        a["Extensions/DataGrouping/DataGrouping.js"]
    ], function(a, A, J, K) {
        a.dataGrouping = {
            approximationDefaults: A,
            approximations: J
        };
        K.compose(a.Axis, a.Series, a.Tooltip);
    });
    L(a, "Extensions/MouseWheelZoom/MouseWheelZoom.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        function u() {
            const a = this, e = q(a.options.chart.zooming.mouseWheel);
            e.enabled && J(this.container, "wheel", (g)=>{
                g = this.pointer.normalize(g);
                if (a.isInsidePlot(g.chartX - a.plotLeft, g.chartY - a.plotTop)) {
                    const n = G(e.sensitivity, 1.1);
                    h(a, Math.pow(n, g.detail || (g.deltaY || 0) / 120), a.xAxis[0].toValue(g.chartX), a.yAxis[0].toValue(g.chartY), g.chartX, g.chartY, e);
                }
                g.preventDefault && g.preventDefault();
            });
        }
        const { addEvent: J, isObject: K, pick: G, defined: D, merge: E } = a, B = [], t = {
            enabled: !0,
            sensitivity: 1.1
        }, q = (a)=>K(a) ? E(t, a) : E(t, {
                enabled: D(a) ? a : !0
            }), m = function(a, e) {
            a.x + a.width > e.x + e.width && (a.width > e.width ? (a.width = e.width, a.x = e.x) : a.x = e.x + e.width - a.width);
            a.width > e.width && (a.width = e.width);
            a.x < e.x && (a.x = e.x);
            a.y + a.height > e.y + e.height && (a.height > e.height ? (a.height = e.height, a.y = e.y) : a.y = e.y + e.height - a.height);
            a.height > e.height && (a.height = e.height);
            a.y < e.y && (a.y = e.y);
            return a;
        };
        let p, n;
        const h = function(a, e, h, q, t, u, f) {
            const g = a.xAxis[0], r = a.yAxis[0];
            var l = G(f.type, a.options.chart.zooming.type, "x");
            f = /x/.test(l);
            l = /y/.test(l);
            if (D(g.max) && D(g.min) && D(r.max) && D(r.min) && D(g.dataMax) && D(g.dataMin) && D(r.dataMax) && D(r.dataMin)) {
                if (l) {
                    D(p) && clearTimeout(p);
                    const { startOnTick: a, endOnTick: b } = r.options;
                    n || (n = {
                        startOnTick: a,
                        endOnTick: b
                    });
                    (a || b) && r.setOptions({
                        startOnTick: !1,
                        endOnTick: !1
                    });
                    p = setTimeout(()=>{
                        if (n) {
                            r.setOptions(n);
                            const { min: a, max: b } = r.getExtremes();
                            r.forceRedraw = !0;
                            r.setExtremes(a, b);
                            n = void 0;
                        }
                    }, 400);
                }
                if (a.inverted) {
                    var v = r.pos + r.len;
                    h = g.toValue(u);
                    q = r.toValue(t);
                    var d = t;
                    t = u;
                    u = v - d + r.pos;
                }
                t = t ? (t - g.pos) / g.len : .5;
                if (g.reversed && !a.inverted || a.inverted && !g.reversed) t = 1 - t;
                u = 1 - (u ? (u - r.pos) / r.len : .5);
                r.reversed && (u = 1 - u);
                v = g.max - g.min;
                h = G(h, g.min + v / 2);
                v *= e;
                d = r.max - r.min;
                q = G(q, r.min + d / 2);
                const k = d * e;
                var b = g.dataMax - g.dataMin, c = r.dataMax - r.dataMin;
                d = g.dataMin - b * g.options.minPadding;
                b = b + b * g.options.minPadding + b * g.options.maxPadding;
                const w = r.dataMin - c * r.options.minPadding;
                c = c + c * r.options.minPadding + c * r.options.maxPadding;
                t = m({
                    x: h - v * t,
                    y: q - k * u,
                    width: v,
                    height: k
                }, {
                    x: d,
                    y: w,
                    width: b,
                    height: c
                });
                u = t.x <= d && t.width >= b && t.y <= w && t.height >= c;
                D(e) && !u ? (f && g.setExtremes(t.x, t.x + t.width, !1), l && r.setExtremes(t.y, t.y + t.height, !1)) : (f && g.setExtremes(void 0, void 0, !1), l && r.setExtremes(void 0, void 0, !1));
                a.redraw(!1);
            }
        };
        "";
        return {
            compose: function(a) {
                -1 === B.indexOf(a) && (B.push(a), J(a, "afterGetContainer", u));
            }
        };
    });
    L(a, "masters/modules/mouse-wheel-zoom.src.js", [
        a["Core/Globals.js"],
        a["Extensions/MouseWheelZoom/MouseWheelZoom.js"]
    ], function(a, A) {
        A.compose(a.Chart);
    });
    L(a, "Series/DataModifyComposition.js", [
        a["Core/Axis/Axis.js"],
        a["Core/Series/Point.js"],
        a["Core/Series/Series.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K) {
        const { prototype: { tooltipFormatter: u } } = A, { addEvent: D, arrayMax: E, arrayMin: B, correctFloat: t, defined: q, isArray: m, isNumber: p, isString: n, pick: h } = K;
        var g;
        (function(a) {
            function e(a, b, d) {
                this.isXAxis || (this.series.forEach(function(c) {
                    "compare" === a && "boolean" !== typeof b ? c.setCompare(b, !1) : "cumulative" !== a || n(b) || c.setCumulative(b, !1);
                }), h(d, !0) && this.chart.redraw());
            }
            function g(a) {
                const b = this, { numberFormatter: c } = b.series.chart, d = function(d) {
                    a = a.replace("{point." + d + "}", (0 < b[d] && "change" === d ? "+" : "") + c(b[d], h(b.series.tooltipOptions.changeDecimals, 2)));
                };
                q(b.change) && d("change");
                q(b.cumulativeSum) && d("cumulativeSum");
                return u.apply(this, [
                    a
                ]);
            }
            function A() {
                const a = this.options.compare;
                let d;
                if ("percent" === a || "value" === a || this.options.cumulative) d = new b(this), "percent" === a || "value" === a ? d.initCompare(a) : d.initCumulative();
                this.dataModify = d;
            }
            function C(a) {
                a = a.dataExtremes;
                const c = a.activeYData;
                if (this.dataModify && a) {
                    let d;
                    this.options.compare ? d = [
                        this.dataModify.modifyValue(a.dataMin),
                        this.dataModify.modifyValue(a.dataMax)
                    ] : this.options.cumulative && m(c) && 2 <= c.length && (d = b.getCumulativeExtremes(c));
                    d && (a.dataMin = B(d), a.dataMax = E(d));
                }
            }
            function f(a, b) {
                this.options.compare = this.userOptions.compare = a;
                this.update({}, h(b, !0));
                !this.dataModify || "value" !== a && "percent" !== a ? this.points.forEach((a)=>{
                    delete a.change;
                }) : this.dataModify.initCompare(a);
            }
            function y() {
                if (this.xAxis && this.processedYData && this.dataModify) {
                    const a = this.processedXData, b = this.processedYData, d = b.length, e = !0 === this.options.compareStart ? 0 : 1;
                    let f = -1, g;
                    this.pointArrayMap && (f = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y"));
                    for(g = 0; g < d - e; g++){
                        const c = b[g] && -1 < f ? b[g][f] : b[g];
                        if (p(c) && 0 !== c && a[g + e] >= (this.xAxis.min || 0)) {
                            this.dataModify.compareValue = c;
                            break;
                        }
                    }
                }
            }
            function r(a, b) {
                this.setModifier("compare", a, b);
            }
            function l(a, b) {
                a = h(a, !1);
                this.options.cumulative = this.userOptions.cumulative = a;
                this.update({}, h(b, !0));
                this.dataModify ? this.dataModify.initCumulative() : this.points.forEach((a)=>{
                    delete a.cumulativeSum;
                });
            }
            function v(a, b) {
                this.setModifier("cumulative", a, b);
            }
            const d = [];
            a.compose = function(a, b, h) {
                if (K.pushUnique(d, a)) {
                    const b = a.prototype;
                    b.setCompare = f;
                    b.setCumulative = l;
                    D(a, "afterInit", A);
                    D(a, "afterGetExtremes", C);
                    D(a, "afterProcessData", y);
                }
                K.pushUnique(d, b) && (b = b.prototype, b.setCompare = r, b.setModifier = e, b.setCumulative = v);
                K.pushUnique(d, h) && (h.prototype.tooltipFormatter = g);
                return a;
            };
            class b {
                constructor(a){
                    this.series = a;
                }
                modifyValue() {
                    return 0;
                }
                static getCumulativeExtremes(a) {
                    let b = Infinity, c = -Infinity;
                    a.reduce((a, d)=>{
                        d = a + d;
                        b = Math.min(b, d, a);
                        c = Math.max(c, d, a);
                        return d;
                    });
                    return [
                        b,
                        c
                    ];
                }
                initCompare(a) {
                    this.modifyValue = function(b, c) {
                        null === b && (b = 0);
                        const d = this.compareValue;
                        return "undefined" !== typeof b && "undefined" !== typeof d ? (b = "value" === a ? b - d : b / d * 100 - (100 === this.series.options.compareBase ? 0 : 100), "undefined" !== typeof c && (c = this.series.points[c]) && (c.change = b), b) : 0;
                    };
                }
                initCumulative() {
                    this.modifyValue = function(a, b) {
                        null === a && (a = 0);
                        if (void 0 !== a && void 0 !== b) {
                            const c = 0 < b ? this.series.points[b - 1] : null;
                            c && c.cumulativeSum && (a = t(c.cumulativeSum + a));
                            if (b = this.series.points[b]) b.cumulativeSum = a;
                            return a;
                        }
                        return 0;
                    };
                }
            }
            a.Additions = b;
        })(g || (g = {}));
        "";
        return g;
    });
    L(a, "Core/Axis/NavigatorAxisComposition.js", [
        a["Core/Globals.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        function u() {
            this.navigatorAxis || (this.navigatorAxis = new p(this));
        }
        function K(a) {
            var h = this.chart, g = h.options, e = g.navigator;
            const n = this.navigatorAxis, m = h.zooming.pinchType;
            g = g.rangeSelector;
            h = h.zooming.type;
            this.isXAxis && (e && e.enabled || g && g.enabled) && ("y" === h ? a.zoomed = !1 : (!G && "xy" === h || G && "xy" === m) && this.options.range && (e = n.previousZoom, B(a.newMin) ? n.previousZoom = [
                this.min,
                this.max
            ] : e && (a.newMin = e[0], a.newMax = e[1], n.previousZoom = void 0)));
            "undefined" !== typeof a.zoomed && a.preventDefault();
        }
        const { isTouchDevice: G } = a, { addEvent: D, correctFloat: E, defined: B, isNumber: t, pick: q } = A, m = [];
        class p {
            static compose(a) {
                A.pushUnique(m, a) && (a.keepProps.push("navigatorAxis"), D(a, "init", u), D(a, "zoom", K));
            }
            constructor(a){
                this.axis = a;
            }
            destroy() {
                this.axis = void 0;
            }
            toFixedRange(a, h, g, e) {
                const m = this.axis;
                var n = m.chart;
                a = q(g, m.translate(a, !0, !m.horiz));
                h = q(e, m.translate(h, !0, !m.horiz));
                n = n && n.fixedRange;
                const p = (m.pointRange || 0) / 2;
                B(g) || (a = E(a + p));
                B(e) || (h = E(h - p));
                n && m.dataMin && m.dataMax && (h >= m.dataMax && (a = E(m.dataMax - n)), a <= m.dataMin && (h = E(m.dataMin + n)));
                t(a) && t(h) || (a = h = void 0);
                return {
                    min: a,
                    max: h
                };
            }
        }
        return p;
    });
    L(a, "Stock/Navigator/NavigatorDefaults.js", [
        a["Core/Color/Color.js"],
        a["Core/Series/SeriesRegistry.js"]
    ], function(a, A) {
        ({ parse: a } = a);
        ({ seriesTypes: A } = A);
        A = {
            height: 40,
            margin: 25,
            maskInside: !0,
            handles: {
                width: 7,
                height: 15,
                symbols: [
                    "navigator-handle",
                    "navigator-handle"
                ],
                enabled: !0,
                lineWidth: 1,
                backgroundColor: "#f2f2f2",
                borderColor: "#999999"
            },
            maskFill: a("#667aff").setOpacity(.3).get(),
            outlineColor: "#999999",
            outlineWidth: 1,
            series: {
                type: "undefined" === typeof A.areaspline ? "line" : "areaspline",
                fillOpacity: .05,
                lineWidth: 1,
                compare: null,
                sonification: {
                    enabled: !1
                },
                dataGrouping: {
                    approximation: "average",
                    enabled: !0,
                    groupPixelWidth: 2,
                    firstAnchor: "firstPoint",
                    anchor: "middle",
                    lastAnchor: "lastPoint",
                    units: [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2,
                                3,
                                4
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2,
                                3
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                3,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ]
                },
                dataLabels: {
                    enabled: !1,
                    zIndex: 2
                },
                id: "highcharts-navigator-series",
                className: "highcharts-navigator-series",
                lineColor: null,
                marker: {
                    enabled: !1
                },
                threshold: null
            },
            xAxis: {
                overscroll: 0,
                className: "highcharts-navigator-xaxis",
                tickLength: 0,
                lineWidth: 0,
                gridLineColor: "#e6e6e6",
                gridLineWidth: 1,
                tickPixelInterval: 200,
                labels: {
                    align: "left",
                    style: {
                        color: "#000000",
                        fontSize: "0.7em",
                        opacity: .6,
                        textOutline: "2px contrast"
                    },
                    x: 3,
                    y: -4
                },
                crosshair: !1
            },
            yAxis: {
                className: "highcharts-navigator-yaxis",
                gridLineWidth: 0,
                startOnTick: !1,
                endOnTick: !1,
                minPadding: .1,
                maxPadding: .1,
                labels: {
                    enabled: !1
                },
                crosshair: !1,
                title: {
                    text: null
                },
                tickLength: 0,
                tickWidth: 0
            }
        };
        "";
        return A;
    });
    L(a, "Stock/Navigator/NavigatorSymbols.js", [], function() {
        return {
            "navigator-handle": function(a, A, J, K, G = {}) {
                a = G.width ? G.width / 2 : J;
                A = Math.round(a / 3) + .5;
                K = G.height || K;
                return [
                    [
                        "M",
                        -a - 1,
                        .5
                    ],
                    [
                        "L",
                        a,
                        .5
                    ],
                    [
                        "L",
                        a,
                        K + .5
                    ],
                    [
                        "L",
                        -a - 1,
                        K + .5
                    ],
                    [
                        "L",
                        -a - 1,
                        .5
                    ],
                    [
                        "M",
                        -A,
                        4
                    ],
                    [
                        "L",
                        -A,
                        K - 3
                    ],
                    [
                        "M",
                        A - 1,
                        4
                    ],
                    [
                        "L",
                        A - 1,
                        K - 3
                    ]
                ];
            }
        };
    });
    L(a, "Stock/Navigator/NavigatorComposition.js", [
        a["Core/Defaults.js"],
        a["Core/Globals.js"],
        a["Core/Axis/NavigatorAxisComposition.js"],
        a["Stock/Navigator/NavigatorDefaults.js"],
        a["Stock/Navigator/NavigatorSymbols.js"],
        a["Core/Renderer/RendererRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E) {
        function u() {
            this.navigator && this.navigator.setBaseSeries(null, !1);
        }
        function t() {
            var a;
            const b = this.legend, c = this.navigator;
            let e, f, g;
            if (c) {
                e = b && b.options;
                f = c.xAxis;
                g = c.yAxis;
                const { scrollbarHeight: d, scrollButtonSize: k } = c;
                this.inverted ? (c.left = c.opposite ? this.chartWidth - d - c.height : this.spacing[3] + d, c.top = this.plotTop + k) : (c.left = r(f.left, this.plotLeft + k), c.top = c.navigatorOptions.top || this.chartHeight - c.height - d - ((null === (a = this.scrollbar) || void 0 === a ? void 0 : a.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (e && "bottom" === e.verticalAlign && "proximate" !== e.layout && e.enabled && !e.floating ? b.legendHeight + r(e.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0));
                f && g && (this.inverted ? f.options.left = g.options.left = c.left : f.options.top = g.options.top = c.top, f.setAxisSize(), g.setAxisSize());
            }
        }
        function q(a) {
            this.navigator || this.scroller || !this.options.navigator.enabled && !this.options.scrollbar.enabled || (this.scroller = this.navigator = new v(this), r(a.redraw, !0) && this.redraw(a.animation));
        }
        function m() {
            const a = this.options;
            if (a.navigator.enabled || a.scrollbar.enabled) this.scroller = this.navigator = new v(this);
        }
        function p() {
            var a = this.options;
            const b = a.navigator;
            a = a.rangeSelector;
            if ((b && b.enabled || a && a.enabled) && (!I && "x" === this.zooming.type || I && "x" === this.zooming.pinchType)) return !1;
        }
        function n(a) {
            const b = a.navigator;
            b && a.xAxis[0] && (a = a.xAxis[0].getExtremes(), b.render(a.min, a.max));
        }
        function h(a) {
            const b = a.options.navigator || {}, c = a.options.scrollbar || {};
            this.navigator || this.scroller || !b.enabled && !c.enabled || (y(!0, this.options.navigator, b), y(!0, this.options.scrollbar, c), delete a.options.navigator, delete a.options.scrollbar);
        }
        function g() {
            this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
        }
        const { defaultOptions: e, setOptions: x } = a, { isTouchDevice: I } = A, { getRendererType: M } = D, { addEvent: C, extend: f, merge: y, pick: r } = E, l = [];
        let v;
        return {
            compose: function(a, b, c, k) {
                J.compose(a);
                v = c;
                E.pushUnique(l, b) && (b.prototype.callbacks.push(n), C(b, "afterAddSeries", u), C(b, "afterSetChartSize", t), C(b, "afterUpdate", q), C(b, "beforeRender", m), C(b, "beforeShowResetZoom", p), C(b, "update", h));
                E.pushUnique(l, k) && C(k, "afterUpdate", g);
                E.pushUnique(l, M) && f(M().prototype.symbols, G);
                E.pushUnique(l, x) && f(e, {
                    navigator: K
                });
            }
        };
    });
    L(a, "Core/Axis/ScrollbarAxis.js", [
        a["Core/Utilities.js"]
    ], function(a) {
        const { addEvent: u, defined: J, pick: K } = a, G = [];
        class D {
            static compose(A, B) {
                if (!a.pushUnique(G, A)) return A;
                const t = (a)=>{
                    const m = K(a.options && a.options.min, a.min), p = K(a.options && a.options.max, a.max);
                    return {
                        axisMin: m,
                        axisMax: p,
                        scrollMin: J(a.dataMin) ? Math.min(m, a.min, a.dataMin, K(a.threshold, Infinity)) : m,
                        scrollMax: J(a.dataMax) ? Math.max(p, a.max, a.dataMax, K(a.threshold, -Infinity)) : p
                    };
                };
                u(A, "afterInit", function() {
                    const a = this;
                    a.options && a.options.scrollbar && a.options.scrollbar.enabled && (a.options.scrollbar.vertical = !a.horiz, a.options.startOnTick = a.options.endOnTick = !1, a.scrollbar = new B(a.chart.renderer, a.options.scrollbar, a.chart), u(a.scrollbar, "changed", function(m) {
                        let { axisMin: p, axisMax: n, scrollMin: h, scrollMax: g } = t(a);
                        var e = g - h;
                        let q;
                        J(p) && J(n) && (a.horiz && !a.reversed || !a.horiz && a.reversed ? (q = h + e * this.to, e = h + e * this.from) : (q = h + e * (1 - this.from), e = h + e * (1 - this.to)), this.shouldUpdateExtremes(m.DOMType) ? a.setExtremes(e, q, !0, "mousemove" === m.DOMType || "touchmove" === m.DOMType ? !1 : void 0, m) : this.setRange(this.from, this.to));
                    }));
                });
                u(A, "afterRender", function() {
                    let { scrollMin: a, scrollMax: m } = t(this), p = this.scrollbar;
                    var n = this.axisTitleMargin + (this.titleOffset || 0), h = this.chart.scrollbarsOffsets;
                    let g = this.options.margin || 0;
                    p && (this.horiz ? (this.opposite || (h[1] += n), p.position(this.left, this.top + this.height + 2 + h[1] - (this.opposite ? g : 0), this.width, this.height), this.opposite || (h[1] += g), n = 1) : (this.opposite && (h[0] += n), p.position(p.options.opposite ? this.left + this.width + 2 + h[0] - (this.opposite ? 0 : g) : this.opposite ? 0 : g, this.top, this.width, this.height), this.opposite && (h[0] += g), n = 0), h[n] += p.size + (p.options.margin || 0), isNaN(a) || isNaN(m) || !J(this.min) || !J(this.max) || this.min === this.max ? p.setRange(0, 1) : (h = (this.min - a) / (m - a), n = (this.max - a) / (m - a), this.horiz && !this.reversed || !this.horiz && this.reversed ? p.setRange(h, n) : p.setRange(1 - n, 1 - h)));
                });
                u(A, "afterGetOffset", function() {
                    const a = this.scrollbar;
                    var m = a && !a.options.opposite;
                    m = this.horiz ? 2 : m ? 3 : 1;
                    a && (this.chart.scrollbarsOffsets = [
                        0,
                        0
                    ], this.chart.axisOffset[m] += a.size + (a.options.margin || 0));
                });
                return A;
            }
        }
        return D;
    });
    L(a, "Stock/Scrollbar/ScrollbarDefaults.js", [
        a["Core/Globals.js"]
    ], function(a) {
        return {
            height: 10,
            barBorderRadius: 5,
            buttonBorderRadius: 0,
            buttonsEnabled: !1,
            liveRedraw: void 0,
            margin: void 0,
            minWidth: 6,
            opposite: !0,
            step: .2,
            zIndex: 3,
            barBackgroundColor: "#cccccc",
            barBorderWidth: 0,
            barBorderColor: "#cccccc",
            buttonArrowColor: "#333333",
            buttonBackgroundColor: "#e6e6e6",
            buttonBorderColor: "#cccccc",
            buttonBorderWidth: 1,
            rifleColor: "none",
            trackBackgroundColor: "rgba(255, 255, 255, 0.001)",
            trackBorderColor: "#cccccc",
            trackBorderRadius: 5,
            trackBorderWidth: 1
        };
    });
    L(a, "Stock/Scrollbar/Scrollbar.js", [
        a["Core/Defaults.js"],
        a["Core/Globals.js"],
        a["Core/Axis/ScrollbarAxis.js"],
        a["Stock/Scrollbar/ScrollbarDefaults.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G) {
        const { defaultOptions: u } = a, { addEvent: E, correctFloat: B, defined: t, destroyObjectProperties: q, fireEvent: m, merge: p, pick: n, removeEvent: h } = G;
        class g {
            static compose(a) {
                J.compose(a, g);
            }
            static swapXY(a, g) {
                g && a.forEach((a)=>{
                    const e = a.length;
                    let g;
                    for(let f = 0; f < e; f += 2)g = a[f + 1], "number" === typeof g && (a[f + 1] = a[f + 2], a[f + 2] = g);
                });
                return a;
            }
            constructor(a, g, h){
                this._events = [];
                this.chart = void 0;
                this.from = this.chartY = this.chartX = 0;
                this.scrollbar = this.renderer = this.options = this.group = void 0;
                this.scrollbarButtons = [];
                this.scrollbarGroup = void 0;
                this.scrollbarLeft = 0;
                this.scrollbarRifles = void 0;
                this.scrollbarStrokeWidth = 1;
                this.to = this.size = this.scrollbarTop = 0;
                this.track = void 0;
                this.trackBorderWidth = 1;
                this.userOptions = void 0;
                this.y = this.x = 0;
                this.init(a, g, h);
            }
            addEvents() {
                var a = this.options.inverted ? [
                    1,
                    0
                ] : [
                    0,
                    1
                ];
                const g = this.scrollbarButtons, h = this.scrollbarGroup.element, m = this.track.element, n = this.mouseDownHandler.bind(this), f = this.mouseMoveHandler.bind(this), p = this.mouseUpHandler.bind(this);
                a = [
                    [
                        g[a[0]].element,
                        "click",
                        this.buttonToMinClick.bind(this)
                    ],
                    [
                        g[a[1]].element,
                        "click",
                        this.buttonToMaxClick.bind(this)
                    ],
                    [
                        m,
                        "click",
                        this.trackClick.bind(this)
                    ],
                    [
                        h,
                        "mousedown",
                        n
                    ],
                    [
                        h.ownerDocument,
                        "mousemove",
                        f
                    ],
                    [
                        h.ownerDocument,
                        "mouseup",
                        p
                    ]
                ];
                A.hasTouch && a.push([
                    h,
                    "touchstart",
                    n
                ], [
                    h.ownerDocument,
                    "touchmove",
                    f
                ], [
                    h.ownerDocument,
                    "touchend",
                    p
                ]);
                a.forEach(function(a) {
                    E.apply(null, a);
                });
                this._events = a;
            }
            buttonToMaxClick(a) {
                const e = (this.to - this.from) * n(this.options.step, .2);
                this.updatePosition(this.from + e, this.to + e);
                m(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: a
                });
            }
            buttonToMinClick(a) {
                const e = B(this.to - this.from) * n(this.options.step, .2);
                this.updatePosition(B(this.from - e), B(this.to - e));
                m(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: a
                });
            }
            cursorToScrollbarPosition(a) {
                var e = this.options;
                e = e.minWidth > this.calculatedWidth ? e.minWidth : 0;
                return {
                    chartX: (a.chartX - this.x - this.xOffset) / (this.barWidth - e),
                    chartY: (a.chartY - this.y - this.yOffset) / (this.barWidth - e)
                };
            }
            destroy() {
                const a = this, g = a.chart.scroller;
                a.removeEvents();
                [
                    "track",
                    "scrollbarRifles",
                    "scrollbar",
                    "scrollbarGroup",
                    "group"
                ].forEach(function(e) {
                    a[e] && a[e].destroy && (a[e] = a[e].destroy());
                });
                g && a === g.scrollbar && (g.scrollbar = null, q(g.scrollbarButtons));
            }
            drawScrollbarButton(a) {
                const e = this.renderer, h = this.scrollbarButtons, m = this.options, n = this.size;
                var f = e.g().add(this.group);
                h.push(f);
                m.buttonsEnabled && (f = e.rect().addClass("highcharts-scrollbar-button").add(f), this.chart.styledMode || f.attr({
                    stroke: m.buttonBorderColor,
                    "stroke-width": m.buttonBorderWidth,
                    fill: m.buttonBackgroundColor
                }), f.attr(f.crisp({
                    x: -0.5,
                    y: -0.5,
                    width: n + 1,
                    height: n + 1,
                    r: m.buttonBorderRadius
                }, f.strokeWidth())), a = e.path(g.swapXY([
                    [
                        "M",
                        n / 2 + (a ? -1 : 1),
                        n / 2 - 3
                    ],
                    [
                        "L",
                        n / 2 + (a ? -1 : 1),
                        n / 2 + 3
                    ],
                    [
                        "L",
                        n / 2 + (a ? 2 : -2),
                        n / 2
                    ]
                ], m.vertical)).addClass("highcharts-scrollbar-arrow").add(h[a]), this.chart.styledMode || a.attr({
                    fill: m.buttonArrowColor
                }));
            }
            init(a, g, h) {
                this.scrollbarButtons = [];
                this.renderer = a;
                this.userOptions = g;
                this.options = p(K, u.scrollbar, g);
                this.options.margin = n(this.options.margin, 10);
                this.chart = h;
                this.size = n(this.options.size, this.options.height);
                g.enabled && (this.render(), this.addEvents());
            }
            mouseDownHandler(a) {
                a = this.chart.pointer.normalize(a);
                a = this.cursorToScrollbarPosition(a);
                this.chartX = a.chartX;
                this.chartY = a.chartY;
                this.initPositions = [
                    this.from,
                    this.to
                ];
                this.grabbedCenter = !0;
            }
            mouseMoveHandler(a) {
                var e = this.chart.pointer.normalize(a), g = this.options.vertical ? "chartY" : "chartX";
                const h = this.initPositions || [];
                !this.grabbedCenter || a.touches && 0 === a.touches[0][g] || (e = this.cursorToScrollbarPosition(e)[g], g = this[g], g = e - g, this.hasDragged = !0, this.updatePosition(h[0] + g, h[1] + g), this.hasDragged && m(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMType: a.type,
                    DOMEvent: a
                }));
            }
            mouseUpHandler(a) {
                this.hasDragged && m(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMType: a.type,
                    DOMEvent: a
                });
                this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
            }
            position(a, g, h, m) {
                const { buttonsEnabled: e, margin: f = 0, vertical: n } = this.options, p = this.rendered ? "animate" : "attr";
                let l = m, v = 0;
                this.group.show();
                this.x = a;
                this.y = g + this.trackBorderWidth;
                this.width = h;
                this.height = m;
                this.xOffset = l;
                this.yOffset = v;
                n ? (this.width = this.yOffset = h = this.size, this.xOffset = l = 0, this.yOffset = v = e ? this.size : 0, this.barWidth = m - (e ? 2 * h : 0), this.x = a += f) : (this.height = m = this.size, this.xOffset = l = e ? this.size : 0, this.barWidth = h - (e ? 2 * m : 0), this.y += f);
                this.group[p]({
                    translateX: a,
                    translateY: this.y
                });
                this.track[p]({
                    width: h,
                    height: m
                });
                this.scrollbarButtons[1][p]({
                    translateX: n ? 0 : h - l,
                    translateY: n ? m - v : 0
                });
            }
            removeEvents() {
                this._events.forEach(function(a) {
                    h.apply(null, a);
                });
                this._events.length = 0;
            }
            render() {
                const a = this.renderer, h = this.options, m = this.size, n = this.chart.styledMode, p = a.g("scrollbar").attr({
                    zIndex: h.zIndex
                }).hide().add();
                this.group = p;
                this.track = a.rect().addClass("highcharts-scrollbar-track").attr({
                    r: h.trackBorderRadius || 0,
                    height: m,
                    width: m
                }).add(p);
                n || this.track.attr({
                    fill: h.trackBackgroundColor,
                    stroke: h.trackBorderColor,
                    "stroke-width": h.trackBorderWidth
                });
                const f = this.trackBorderWidth = this.track.strokeWidth();
                this.track.attr({
                    x: -f % 2 / 2,
                    y: -f % 2 / 2
                });
                this.scrollbarGroup = a.g().add(p);
                this.scrollbar = a.rect().addClass("highcharts-scrollbar-thumb").attr({
                    height: m - f,
                    width: m - f,
                    r: h.barBorderRadius || 0
                }).add(this.scrollbarGroup);
                this.scrollbarRifles = a.path(g.swapXY([
                    [
                        "M",
                        -3,
                        m / 4
                    ],
                    [
                        "L",
                        -3,
                        2 * m / 3
                    ],
                    [
                        "M",
                        0,
                        m / 4
                    ],
                    [
                        "L",
                        0,
                        2 * m / 3
                    ],
                    [
                        "M",
                        3,
                        m / 4
                    ],
                    [
                        "L",
                        3,
                        2 * m / 3
                    ]
                ], h.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup);
                n || (this.scrollbar.attr({
                    fill: h.barBackgroundColor,
                    stroke: h.barBorderColor,
                    "stroke-width": h.barBorderWidth
                }), this.scrollbarRifles.attr({
                    stroke: h.rifleColor,
                    "stroke-width": 1
                }));
                this.scrollbarStrokeWidth = this.scrollbar.strokeWidth();
                this.scrollbarGroup.translate(-this.scrollbarStrokeWidth % 2 / 2, -this.scrollbarStrokeWidth % 2 / 2);
                this.drawScrollbarButton(0);
                this.drawScrollbarButton(1);
            }
            setRange(a, g) {
                const e = this.options, h = e.vertical;
                var m = e.minWidth, f = this.barWidth;
                const n = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
                if (t(f)) {
                    var p = f * Math.min(g, 1);
                    a = Math.max(a, 0);
                    var l = Math.ceil(f * a);
                    this.calculatedWidth = p = B(p - l);
                    p < m && (l = (f - m + p) * a, p = m);
                    m = Math.floor(l + this.xOffset + this.yOffset);
                    f = p / 2 - .5;
                    this.from = a;
                    this.to = g;
                    h ? (this.scrollbarGroup[n]({
                        translateY: m
                    }), this.scrollbar[n]({
                        height: p
                    }), this.scrollbarRifles[n]({
                        translateY: f
                    }), this.scrollbarTop = m, this.scrollbarLeft = 0) : (this.scrollbarGroup[n]({
                        translateX: m
                    }), this.scrollbar[n]({
                        width: p
                    }), this.scrollbarRifles[n]({
                        translateX: f
                    }), this.scrollbarLeft = m, this.scrollbarTop = 0);
                    12 >= p ? this.scrollbarRifles.hide() : this.scrollbarRifles.show();
                    !1 === e.showFull && (0 >= a && 1 <= g ? this.group.hide() : this.group.show());
                    this.rendered = !0;
                }
            }
            shouldUpdateExtremes(a) {
                return n(this.options.liveRedraw, A.svg && !A.isTouchDevice && !this.chart.boosted) || "mouseup" === a || "touchend" === a || !t(a);
            }
            trackClick(a) {
                const e = this.chart.pointer.normalize(a), g = this.to - this.from, h = this.y + this.scrollbarTop, n = this.x + this.scrollbarLeft;
                this.options.vertical && e.chartY > h || !this.options.vertical && e.chartX > n ? this.updatePosition(this.from + g, this.to + g) : this.updatePosition(this.from - g, this.to - g);
                m(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: a
                });
            }
            update(a) {
                this.destroy();
                this.init(this.chart.renderer, p(!0, this.options, a), this.chart);
            }
            updatePosition(a, g) {
                1 < g && (a = B(1 - B(g - a)), g = 1);
                0 > a && (g = B(g - a), a = 0);
                this.from = a;
                this.to = g;
            }
        }
        g.defaultOptions = K;
        u.scrollbar = p(!0, g.defaultOptions, u.scrollbar);
        return g;
    });
    L(a, "Stock/Navigator/Navigator.js", [
        a["Core/Axis/Axis.js"],
        a["Core/Defaults.js"],
        a["Core/Globals.js"],
        a["Core/Axis/NavigatorAxisComposition.js"],
        a["Stock/Navigator/NavigatorComposition.js"],
        a["Stock/Scrollbar/Scrollbar.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E) {
        function u(a, ...c) {
            c = [].filter.call(c, f);
            if (c.length) return Math[a].apply(0, c);
        }
        const { defaultOptions: t } = A, { hasTouch: q, isTouchDevice: m } = J, { addEvent: p, clamp: n, correctFloat: h, defined: g, destroyObjectProperties: e, erase: x, extend: I, find: M, isArray: C, isNumber: f, merge: y, pick: r, removeEvent: l, splat: v } = E;
        class d {
            static compose(a, c, e) {
                G.compose(a, c, d, e);
            }
            constructor(a){
                this.rendered = this.range = this.outline = this.opposite = this.navigatorSize = this.navigatorSeries = this.navigatorOptions = this.navigatorGroup = this.navigatorEnabled = this.left = this.height = this.handles = this.chart = this.baseSeries = void 0;
                this.scrollbarHeight = 0;
                this.zoomedMin = this.zoomedMax = this.yAxis = this.xAxis = this.top = this.size = this.shades = this.scrollButtonSize = void 0;
                this.init(a);
            }
            drawHandle(a, c, d, e) {
                const b = this.navigatorOptions.handles.height;
                this.handles[c][e](d ? {
                    translateX: Math.round(this.left + this.height / 2),
                    translateY: Math.round(this.top + parseInt(a, 10) + .5 - b)
                } : {
                    translateX: Math.round(this.left + parseInt(a, 10)),
                    translateY: Math.round(this.top + this.height / 2 - b / 2 - 1)
                });
            }
            drawOutline(a, c, d, e) {
                const b = this.navigatorOptions.maskInside;
                var f = this.outline.strokeWidth();
                const k = f / 2;
                var g = f % 2 / 2;
                const h = this.scrollButtonSize, l = this.size, m = this.top;
                f = this.height;
                const n = m - k, w = m + f;
                let p = this.left;
                d ? (d = m + c + g, c = m + a + g, g = [
                    [
                        "M",
                        p + f,
                        m - h - g
                    ],
                    [
                        "L",
                        p + f,
                        d
                    ],
                    [
                        "L",
                        p,
                        d
                    ],
                    [
                        "M",
                        p,
                        c
                    ],
                    [
                        "L",
                        p + f,
                        c
                    ],
                    [
                        "L",
                        p + f,
                        m + l + h
                    ]
                ], b && g.push([
                    "M",
                    p + f,
                    d - k
                ], [
                    "L",
                    p + f,
                    c + k
                ])) : (p -= h, a += p + h - g, c += p + h - g, g = [
                    [
                        "M",
                        p,
                        n
                    ],
                    [
                        "L",
                        a,
                        n
                    ],
                    [
                        "L",
                        a,
                        w
                    ],
                    [
                        "M",
                        c,
                        w
                    ],
                    [
                        "L",
                        c,
                        n
                    ],
                    [
                        "L",
                        p + l + 2 * h,
                        m + k
                    ]
                ], b && g.push([
                    "M",
                    a - k,
                    n
                ], [
                    "L",
                    c + k,
                    n
                ]));
                this.outline[e]({
                    d: g
                });
            }
            drawMasks(a, c, d, e) {
                const b = this.left, f = this.top, k = this.height;
                let g, h, l, m;
                d ? (l = [
                    b,
                    b,
                    b
                ], m = [
                    f,
                    f + a,
                    f + c
                ], h = [
                    k,
                    k,
                    k
                ], g = [
                    a,
                    c - a,
                    this.size - c
                ]) : (l = [
                    b,
                    b + a,
                    b + c
                ], m = [
                    f,
                    f,
                    f
                ], h = [
                    a,
                    c - a,
                    this.size - c
                ], g = [
                    k,
                    k,
                    k
                ]);
                this.shades.forEach((a, b)=>{
                    a[e]({
                        x: l[b],
                        y: m[b],
                        width: h[b],
                        height: g[b]
                    });
                });
            }
            renderElements() {
                const a = this, c = a.navigatorOptions, d = c.maskInside, f = a.chart, e = f.renderer, g = {
                    cursor: f.inverted ? "ns-resize" : "ew-resize"
                }, h = a.navigatorGroup = e.g("navigator").attr({
                    zIndex: 8,
                    visibility: "hidden"
                }).add();
                [
                    !d,
                    d,
                    !d
                ].forEach((b, d)=>{
                    const k = e.rect().addClass("highcharts-navigator-mask" + (1 === d ? "-inside" : "-outside")).add(h);
                    f.styledMode || (k.attr({
                        fill: b ? c.maskFill : "rgba(0,0,0,0)"
                    }), 1 === d && k.css(g));
                    a.shades[d] = k;
                });
                a.outline = e.path().addClass("highcharts-navigator-outline").add(h);
                f.styledMode || a.outline.attr({
                    "stroke-width": c.outlineWidth,
                    stroke: c.outlineColor
                });
                if (c.handles && c.handles.enabled) {
                    const b = c.handles, { height: d, width: k } = b;
                    [
                        0,
                        1
                    ].forEach((c)=>{
                        a.handles[c] = e.symbol(b.symbols[c], -k / 2 - 1, 0, k, d, b);
                        f.inverted && a.handles[c].attr({
                            rotation: 90,
                            rotationOriginX: Math.floor(-k / 2),
                            rotationOriginY: (d + k) / 2
                        });
                        a.handles[c].attr({
                            zIndex: 7 - c
                        }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + [
                            "left",
                            "right"
                        ][c]).add(h);
                        f.styledMode || a.handles[c].attr({
                            fill: b.backgroundColor,
                            stroke: b.borderColor,
                            "stroke-width": b.lineWidth
                        }).css(g);
                    });
                }
            }
            update(a) {
                (this.series || []).forEach((a)=>{
                    a.baseSeries && delete a.baseSeries.navigatorSeries;
                });
                this.destroy();
                y(!0, this.chart.options.navigator, a);
                this.init(this.chart);
            }
            render(a, c, d, e) {
                var b = this.chart;
                const k = this.xAxis, l = k.pointRange || 0;
                var m = k.navigatorAxis.fake ? b.xAxis[0] : k;
                const p = this.navigatorEnabled;
                var w = this.rendered, v = b.inverted;
                const q = b.xAxis[0].minRange, t = b.xAxis[0].options.maxRange, u = this.scrollButtonSize;
                let x = this.scrollbarHeight, y;
                if (!this.hasDragged || g(d)) {
                    a = h(a - l / 2);
                    c = h(c + l / 2);
                    if (!f(a) || !f(c)) {
                        if (w) d = 0, e = r(k.width, m.width);
                        else return;
                    }
                    this.left = r(k.left, b.plotLeft + u + (v ? b.plotWidth : 0));
                    var A = this.size = y = r(k.len, (v ? b.plotHeight : b.plotWidth) - 2 * u);
                    b = v ? x : y + 2 * u;
                    d = r(d, k.toPixels(a, !0));
                    e = r(e, k.toPixels(c, !0));
                    f(d) && Infinity !== Math.abs(d) || (d = 0, e = b);
                    a = k.toValue(d, !0);
                    c = k.toValue(e, !0);
                    var B = Math.abs(h(c - a));
                    B < q ? this.grabbedLeft ? d = k.toPixels(c - q - l, !0) : this.grabbedRight && (e = k.toPixels(a + q + l, !0)) : g(t) && h(B - l) > t && (this.grabbedLeft ? d = k.toPixels(c - t - l, !0) : this.grabbedRight && (e = k.toPixels(a + t + l, !0)));
                    this.zoomedMax = n(Math.max(d, e), 0, A);
                    this.zoomedMin = n(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(d, e), 0, A);
                    this.range = this.zoomedMax - this.zoomedMin;
                    A = Math.round(this.zoomedMax);
                    d = Math.round(this.zoomedMin);
                    p && (this.navigatorGroup.attr({
                        visibility: "inherit"
                    }), w = w && !this.hasDragged ? "animate" : "attr", this.drawMasks(d, A, v, w), this.drawOutline(d, A, v, w), this.navigatorOptions.handles.enabled && (this.drawHandle(d, 0, v, w), this.drawHandle(A, 1, v, w)));
                    this.scrollbar && (v ? (v = this.top - u, m = this.left - x + (p || !m.opposite ? 0 : (m.titleOffset || 0) + m.axisTitleMargin), x = y + 2 * u) : (v = this.top + (p ? this.height : -x), m = this.left - u), this.scrollbar.position(m, v, b, x), this.scrollbar.setRange(this.zoomedMin / (y || 1), this.zoomedMax / (y || 1)));
                    this.rendered = !0;
                }
            }
            addMouseEvents() {
                const a = this, c = a.chart, d = c.container;
                let e = [], f, g;
                a.mouseMoveHandler = f = function(b) {
                    a.onMouseMove(b);
                };
                a.mouseUpHandler = g = function(b) {
                    a.onMouseUp(b);
                };
                e = a.getPartsEvents("mousedown");
                e.push(p(c.renderTo, "mousemove", f), p(d.ownerDocument, "mouseup", g));
                q && (e.push(p(c.renderTo, "touchmove", f), p(d.ownerDocument, "touchend", g)), e.concat(a.getPartsEvents("touchstart")));
                a.eventsToUnbind = e;
                a.series && a.series[0] && e.push(p(a.series[0].xAxis, "foundExtremes", function() {
                    c.navigator.modifyNavigatorAxisExtremes();
                }));
            }
            getPartsEvents(a) {
                const b = this, d = [];
                [
                    "shades",
                    "handles"
                ].forEach(function(c) {
                    b[c].forEach(function(e, f) {
                        d.push(p(e.element, a, function(a) {
                            b[c + "Mousedown"](a, f);
                        }));
                    });
                });
                return d;
            }
            shadesMousedown(a, c) {
                a = this.chart.pointer.normalize(a);
                const b = this.chart, d = this.xAxis, e = this.zoomedMin, f = this.size, h = this.range;
                let l = this.left, m = a.chartX, n, p;
                b.inverted && (m = a.chartY, l = this.top);
                1 === c ? (this.grabbedCenter = m, this.fixedWidth = h, this.dragOffset = m - e) : (a = m - l - h / 2, 0 === c ? a = Math.max(0, a) : 2 === c && a + h >= f && (a = f - h, this.reversedExtremes ? (a -= h, p = this.getUnionExtremes().dataMin) : n = this.getUnionExtremes().dataMax), a !== e && (this.fixedWidth = h, c = d.navigatorAxis.toFixedRange(a, a + h, p, n), g(c.min) && b.xAxis[0].setExtremes(Math.min(c.min, c.max), Math.max(c.min, c.max), !0, null, {
                    trigger: "navigator"
                })));
            }
            handlesMousedown(a, c) {
                this.chart.pointer.normalize(a);
                a = this.chart;
                const b = a.xAxis[0], d = this.reversedExtremes;
                0 === c ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = d ? b.min : b.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = d ? b.max : b.min);
                a.fixedRange = null;
            }
            onMouseMove(a) {
                const b = this;
                var d = b.chart;
                const e = b.navigatorSize, f = b.range, g = b.dragOffset, h = d.inverted;
                let l = b.left;
                a.touches && 0 === a.touches[0].pageX || (a = d.pointer.normalize(a), d = a.chartX, h && (l = b.top, d = a.chartY), b.grabbedLeft ? (b.hasDragged = !0, b.render(0, 0, d - l, b.otherHandlePos)) : b.grabbedRight ? (b.hasDragged = !0, b.render(0, 0, b.otherHandlePos, d - l)) : b.grabbedCenter && (b.hasDragged = !0, d < g ? d = g : d > e + g - f && (d = e + g - f), b.render(0, 0, d - g, d - g + f)), b.hasDragged && b.scrollbar && r(b.scrollbar.options.liveRedraw, !m && !this.chart.boosted) && (a.DOMType = a.type, setTimeout(function() {
                    b.onMouseUp(a);
                }, 0)));
            }
            onMouseUp(a) {
                var b = this.chart, d = this.xAxis, e = this.scrollbar;
                const h = a.DOMEvent || a, l = b.inverted, m = this.rendered && !this.hasDragged ? "animate" : "attr";
                let n, p;
                (!this.hasDragged || e && e.hasDragged) && "scrollbar" !== a.trigger || (e = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? n = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (p = this.fixedExtreme), this.zoomedMax === this.size && (p = this.reversedExtremes ? e.dataMin : e.dataMax), 0 === this.zoomedMin && (n = this.reversedExtremes ? e.dataMax : e.dataMin), d = d.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, n, p), g(d.min) && b.xAxis[0].setExtremes(Math.min(d.min, d.max), Math.max(d.min, d.max), !0, this.hasDragged ? !1 : null, {
                    trigger: "navigator",
                    triggerOp: "navigator-drag",
                    DOMEvent: h
                }));
                "mousemove" !== a.DOMType && "touchmove" !== a.DOMType && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null);
                this.navigatorEnabled && f(this.zoomedMin) && f(this.zoomedMax) && (b = Math.round(this.zoomedMin), a = Math.round(this.zoomedMax), this.shades && this.drawMasks(b, a, l, m), this.outline && this.drawOutline(b, a, l, m), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(b, 0, l, m), this.drawHandle(a, 1, l, m)));
            }
            removeEvents() {
                this.eventsToUnbind && (this.eventsToUnbind.forEach(function(a) {
                    a();
                }), this.eventsToUnbind = void 0);
                this.removeBaseSeriesEvents();
            }
            removeBaseSeriesEvents() {
                const a = this.baseSeries || [];
                this.navigatorEnabled && a[0] && (!1 !== this.navigatorOptions.adaptToUpdatedData && a.forEach(function(a) {
                    l(a, "updatedData", this.updatedDataHandler);
                }, this), a[0].xAxis && l(a[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
            }
            init(b) {
                var c = b.options, d = c.navigator || {}, e = d.enabled, g = c.scrollbar || {}, h = g.enabled;
                c = e && d.height || 0;
                var l = h && g.height || 0;
                const m = g.buttonsEnabled && l || 0;
                this.handles = [];
                this.shades = [];
                this.chart = b;
                this.setBaseSeries();
                this.height = c;
                this.scrollbarHeight = l;
                this.scrollButtonSize = m;
                this.scrollbarEnabled = h;
                this.navigatorEnabled = e;
                this.navigatorOptions = d;
                this.scrollbarOptions = g;
                this.opposite = r(d.opposite, !(e || !b.inverted));
                const n = this;
                e = n.baseSeries;
                g = b.xAxis.length;
                h = b.yAxis.length;
                l = e && e[0] && e[0].xAxis || b.xAxis[0] || {
                    options: {}
                };
                b.isDirtyBox = !0;
                n.navigatorEnabled ? (n.xAxis = new a(b, y({
                    breaks: l.options.breaks,
                    ordinal: l.options.ordinal
                }, d.xAxis, {
                    id: "navigator-x-axis",
                    yAxis: "navigator-y-axis",
                    type: "datetime",
                    index: g,
                    isInternal: !0,
                    offset: 0,
                    keepOrdinalPadding: !0,
                    startOnTick: !1,
                    endOnTick: !1,
                    minPadding: 0,
                    maxPadding: 0,
                    zoomEnabled: !1
                }, b.inverted ? {
                    offsets: [
                        m,
                        0,
                        -m,
                        0
                    ],
                    width: c
                } : {
                    offsets: [
                        0,
                        -m,
                        0,
                        m
                    ],
                    height: c
                }), "xAxis"), n.yAxis = new a(b, y(d.yAxis, {
                    id: "navigator-y-axis",
                    alignTicks: !1,
                    offset: 0,
                    index: h,
                    isInternal: !0,
                    reversed: r(d.yAxis && d.yAxis.reversed, b.yAxis[0] && b.yAxis[0].reversed, !1),
                    zoomEnabled: !1
                }, b.inverted ? {
                    width: c
                } : {
                    height: c
                }), "yAxis"), e || d.series.data ? n.updateNavigatorSeries(!1) : 0 === b.series.length && (n.unbindRedraw = p(b, "beforeRedraw", function() {
                    0 < b.series.length && !n.series && (n.setBaseSeries(), n.unbindRedraw());
                })), n.reversedExtremes = b.inverted && !n.xAxis.reversed || !b.inverted && n.xAxis.reversed, n.renderElements(), n.addMouseEvents()) : (n.xAxis = {
                    chart: b,
                    navigatorAxis: {
                        fake: !0
                    },
                    translate: function(a, c) {
                        var d = b.xAxis[0];
                        const e = d.getExtremes(), f = d.len - 2 * m, k = u("min", d.options.min, e.dataMin);
                        d = u("max", d.options.max, e.dataMax) - k;
                        return c ? a * d / f + k : f * (a - k) / d;
                    },
                    toPixels: function(a) {
                        return this.translate(a);
                    },
                    toValue: function(a) {
                        return this.translate(a, !0);
                    }
                }, n.xAxis.navigatorAxis.axis = n.xAxis, n.xAxis.navigatorAxis.toFixedRange = K.prototype.toFixedRange.bind(n.xAxis.navigatorAxis));
                b.options.scrollbar.enabled && (d = y(b.options.scrollbar, {
                    vertical: b.inverted
                }), !f(d.margin) && n.navigatorEnabled && (d.margin = b.inverted ? -3 : 3), b.scrollbar = n.scrollbar = new D(b.renderer, d, b), p(n.scrollbar, "changed", function(a) {
                    var b = n.size;
                    const c = b * this.to;
                    b *= this.from;
                    n.hasDragged = n.scrollbar.hasDragged;
                    n.render(0, 0, b, c);
                    this.shouldUpdateExtremes(a.DOMType) && setTimeout(function() {
                        n.onMouseUp(a);
                    });
                }));
                n.addBaseSeriesEvents();
                n.addChartEvents();
            }
            getUnionExtremes(a) {
                const b = this.chart.xAxis[0], d = this.xAxis, e = d.options, f = b.options;
                let g;
                a && null === b.dataMin || (g = {
                    dataMin: r(e && e.min, u("min", f.min, b.dataMin, d.dataMin, d.min)),
                    dataMax: r(e && e.max, u("max", f.max, b.dataMax, d.dataMax, d.max))
                });
                return g;
            }
            setBaseSeries(a, c) {
                const b = this.chart, d = this.baseSeries = [];
                a = a || b.options && b.options.navigator.baseSeries || (b.series.length ? M(b.series, (a)=>!a.options.isInternal).index : 0);
                (b.series || []).forEach((b, c)=>{
                    b.options.isInternal || !b.options.showInNavigator && (c !== a && b.options.id !== a || !1 === b.options.showInNavigator) || d.push(b);
                });
                this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, c);
            }
            updateNavigatorSeries(a, c) {
                const b = this, d = b.chart, e = b.baseSeries, f = {
                    enableMouseTracking: !1,
                    index: null,
                    linkedTo: null,
                    group: "nav",
                    padXAxis: !1,
                    xAxis: "navigator-x-axis",
                    yAxis: "navigator-y-axis",
                    showInLegend: !1,
                    stacking: void 0,
                    isInternal: !0,
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    }
                }, g = b.series = (b.series || []).filter((a)=>{
                    const c = a.baseSeries;
                    return 0 > e.indexOf(c) ? (c && (l(c, "updatedData", b.updatedDataHandler), delete c.navigatorSeries), a.chart && a.destroy(), !1) : !0;
                });
                let h, m, n = b.navigatorOptions.series, p;
                e && e.length && e.forEach((a)=>{
                    const k = a.navigatorSeries;
                    var l = I({
                        color: a.color,
                        visible: a.visible
                    }, C(n) ? t.navigator.series : n);
                    k && !1 === b.navigatorOptions.adaptToUpdatedData || (f.name = "Navigator " + e.length, h = a.options || {}, p = h.navigatorOptions || {}, l.dataLabels = v(l.dataLabels), m = y(h, f, l, p), m.pointRange = r(l.pointRange, p.pointRange, t.plotOptions[m.type || "line"].pointRange), l = p.data || l.data, b.hasNavigatorData = b.hasNavigatorData || !!l, m.data = l || h.data && h.data.slice(0), k && k.options ? k.update(m, c) : (a.navigatorSeries = d.initSeries(m), a.navigatorSeries.baseSeries = a, g.push(a.navigatorSeries)));
                });
                if (n.data && (!e || !e.length) || C(n)) b.hasNavigatorData = !1, n = v(n), n.forEach((a, c)=>{
                    f.name = "Navigator " + (g.length + 1);
                    m = y(t.navigator.series, {
                        color: d.series[c] && !d.series[c].options.isInternal && d.series[c].color || d.options.colors[c] || d.options.colors[0]
                    }, f, a);
                    m.data = a.data;
                    m.data && (b.hasNavigatorData = !0, g.push(d.initSeries(m)));
                });
                a && this.addBaseSeriesEvents();
            }
            addBaseSeriesEvents() {
                const a = this, c = a.baseSeries || [];
                c[0] && c[0].xAxis && c[0].eventsToUnbind.push(p(c[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
                c.forEach((b)=>{
                    b.eventsToUnbind.push(p(b, "show", function() {
                        this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
                    }));
                    b.eventsToUnbind.push(p(b, "hide", function() {
                        this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
                    }));
                    !1 !== this.navigatorOptions.adaptToUpdatedData && b.xAxis && b.eventsToUnbind.push(p(b, "updatedData", this.updatedDataHandler));
                    b.eventsToUnbind.push(p(b, "remove", function() {
                        this.navigatorSeries && (x(a.series, this.navigatorSeries), g(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
                    }));
                });
            }
            getBaseSeriesMin(a) {
                return this.baseSeries.reduce(function(a, b) {
                    return Math.min(a, b.xData && b.xData.length ? b.xData[0] : a);
                }, a);
            }
            modifyNavigatorAxisExtremes() {
                const a = this.xAxis;
                if ("undefined" !== typeof a.getExtremes) {
                    const b = this.getUnionExtremes(!0);
                    !b || b.dataMin === a.min && b.dataMax === a.max || (a.min = b.dataMin, a.max = b.dataMax);
                }
            }
            modifyBaseAxisExtremes() {
                const a = this.chart.navigator;
                var c = this.getExtremes();
                const d = c.dataMin, e = c.dataMax;
                c = c.max - c.min;
                const g = a.stickToMin, h = a.stickToMax, l = r(this.options.overscroll, 0), m = a.series && a.series[0], n = !!this.setExtremes;
                let p, v;
                this.eventArgs && "rangeSelectorButton" === this.eventArgs.trigger || (g && (v = d, p = v + c), h && (p = e + l, g || (v = Math.max(d, p - c, a.getBaseSeriesMin(m && m.xData ? m.xData[0] : -Number.MAX_VALUE)))), n && (g || h) && f(v) && (this.min = this.userMin = v, this.max = this.userMax = p));
                a.stickToMin = a.stickToMax = null;
            }
            updatedDataHandler() {
                const a = this.chart.navigator, c = this.navigatorSeries;
                a.stickToMax = r(this.chart.options.navigator && this.chart.options.navigator.stickToMax, a.reversedExtremes ? 0 === Math.round(a.zoomedMin) : Math.round(a.zoomedMax) >= Math.round(a.size));
                a.stickToMin = a.shouldStickToMin(this, a);
                c && !a.hasNavigatorData && (c.options.pointStart = this.xData[0], c.setData(this.options.data, !1, null, !1));
            }
            shouldStickToMin(a, c) {
                c = c.getBaseSeriesMin(a.xData[0]);
                var b = a.xAxis;
                a = b.max;
                const d = b.min;
                b = b.options.range;
                return f(a) && f(d) ? b && 0 < a - c ? a - c < b : d <= c : !1;
            }
            addChartEvents() {
                this.eventsToUnbind || (this.eventsToUnbind = []);
                this.eventsToUnbind.push(p(this.chart, "redraw", function() {
                    const a = this.navigator, c = a && (a.baseSeries && a.baseSeries[0] && a.baseSeries[0].xAxis || this.xAxis[0]);
                    c && a.render(c.min, c.max);
                }), p(this.chart, "getMargins", function() {
                    let a = this.navigator, c = a.opposite ? "plotTop" : "marginBottom";
                    this.inverted && (c = a.opposite ? "marginRight" : "plotLeft");
                    this[c] = (this[c] || 0) + (a.navigatorEnabled || !this.inverted ? a.height + a.scrollbarHeight : 0) + a.navigatorOptions.margin;
                }));
            }
            destroy() {
                this.removeEvents();
                this.xAxis && (x(this.chart.xAxis, this.xAxis), x(this.chart.axes, this.xAxis));
                this.yAxis && (x(this.chart.yAxis, this.yAxis), x(this.chart.axes, this.yAxis));
                (this.series || []).forEach((a)=>{
                    a.destroy && a.destroy();
                });
                "series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" ").forEach((a)=>{
                    this[a] && this[a].destroy && this[a].destroy();
                    this[a] = null;
                });
                [
                    this.handles
                ].forEach((a)=>{
                    e(a);
                });
            }
        }
        return d;
    });
    L(a, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function() {
        return {
            lang: {
                rangeSelectorZoom: "Zoom",
                rangeSelectorFrom: "",
                rangeSelectorTo: "\u2192"
            },
            rangeSelector: {
                allButtonsEnabled: !1,
                buttons: void 0,
                buttonSpacing: 5,
                dropdown: "responsive",
                enabled: void 0,
                verticalAlign: "top",
                buttonTheme: {
                    width: 28,
                    height: 18,
                    padding: 2,
                    zIndex: 7
                },
                floating: !1,
                x: 0,
                y: 0,
                height: void 0,
                inputBoxBorderColor: "none",
                inputBoxHeight: 17,
                inputBoxWidth: void 0,
                inputDateFormat: "%e %b %Y",
                inputDateParser: void 0,
                inputEditDateFormat: "%Y-%m-%d",
                inputEnabled: !0,
                inputPosition: {
                    align: "right",
                    x: 0,
                    y: 0
                },
                inputSpacing: 5,
                selected: void 0,
                buttonPosition: {
                    align: "left",
                    x: 0,
                    y: 0
                },
                inputStyle: {
                    color: "#334eff",
                    cursor: "pointer",
                    fontSize: "0.8em"
                },
                labelStyle: {
                    color: "#666666",
                    fontSize: "0.8em"
                }
            }
        };
    });
    L(a, "Stock/RangeSelector/RangeSelectorComposition.js", [
        a["Core/Defaults.js"],
        a["Stock/RangeSelector/RangeSelectorDefaults.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        function u() {
            const a = this.range, e = a.type, d = this.max, b = this.chart.time, c = function(a, c) {
                const d = "year" === e ? "FullYear" : "Month", f = new b.Date(a), g = b.get(d, f);
                b.set(d, f, g + c);
                g === b.get(d, f) && b.set("Date", f, 0);
                return f.getTime() - a;
            };
            let f, g;
            I(a) ? (f = d - a, g = a) : a && (f = d + c(d, -(a.count || 1)), this.chart && (this.chart.fixedRange = d - f));
            const h = C(this.dataMin, Number.MIN_VALUE);
            I(f) || (f = h);
            f <= h && (f = h, "undefined" === typeof g && (g = c(f, a.count)), this.newMax = Math.min(f + g, C(this.dataMax, Number.MAX_VALUE)));
            I(d) ? !I(a) && a && a._offsetMin && (f += a._offsetMin) : f = void 0;
            return f;
        }
        function G() {
            this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new r(this));
        }
        function D() {
            var a = this.axes;
            const e = this.rangeSelector;
            e && (I(e.deferredYTDClick) && (e.clickButton(e.deferredYTDClick), delete e.deferredYTDClick), a.forEach((a)=>{
                a.updateNames();
                a.setScale();
            }), this.getAxisMargins(), e.render(), a = e.options.verticalAlign, e.options.floating || ("bottom" === a ? this.extraBottomMargin = !0 : "middle" !== a && (this.extraTopMargin = !0)));
        }
        function E(a) {
            let e, d, b, c;
            const g = a.rangeSelector, l = ()=>{
                g && (e = a.xAxis[0].getExtremes(), d = a.legend, c = g && g.options.verticalAlign, I(e.min) && g.render(e.min, e.max), d.display && "top" === c && c === d.options.verticalAlign && (b = M(a.spacingBox), b.y = "vertical" === d.options.layout ? a.plotTop : b.y + g.getHeight(), d.group.placed = !1, d.align(b)));
            };
            g && (x(f, (b)=>b[0] === a) || f.push([
                a,
                [
                    h(a.xAxis[0], "afterSetExtremes", function(a) {
                        g && g.render(a.min, a.max);
                    }),
                    h(a, "redraw", l)
                ]
            ]), l());
        }
        function B() {
            for(let a = 0, e = f.length; a < e; ++a){
                const d = f[a];
                if (d[0] === this) {
                    d[1].forEach((a)=>a());
                    f.splice(a, 1);
                    break;
                }
            }
        }
        function t() {
            var a = this.rangeSelector;
            a && (a = a.getHeight(), this.extraTopMargin && (this.plotTop += a), this.extraBottomMargin && (this.marginBottom += a));
        }
        function q() {
            var a = this.rangeSelector;
            a && !a.options.floating && (a.render(), a = a.options.verticalAlign, "bottom" === a ? this.extraBottomMargin = !0 : "middle" !== a && (this.extraTopMargin = !0));
        }
        function m(a) {
            var e = a.options.rangeSelector;
            a = this.extraBottomMargin;
            const d = this.extraTopMargin;
            let b = this.rangeSelector;
            e && e.enabled && !g(b) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = b = new r(this));
            this.extraTopMargin = this.extraBottomMargin = !1;
            b && (E(this), e = e && e.verticalAlign || b.options && b.options.verticalAlign, b.options.floating || ("bottom" === e ? this.extraBottomMargin = !0 : "middle" !== e && (this.extraTopMargin = !0)), this.extraBottomMargin !== a || this.extraTopMargin !== d) && (this.isDirtyBox = !0);
        }
        const { defaultOptions: p, setOptions: n } = a, { addEvent: h, defined: g, extend: e, find: x, isNumber: I, merge: M, pick: C } = J, f = [], y = [];
        let r;
        return {
            compose: function(a, f, d) {
                r = d;
                J.pushUnique(y, a) && (a.prototype.minFromRange = u);
                J.pushUnique(y, f) && (h(f, "afterGetContainer", G), h(f, "beforeRender", D), h(f, "destroy", B), h(f, "getMargins", t), h(f, "render", q), h(f, "update", m), f.prototype.callbacks.push(E));
                J.pushUnique(y, n) && (e(p, {
                    rangeSelector: A.rangeSelector
                }), e(p.lang, A.lang));
            }
        };
    });
    L(a, "Stock/RangeSelector/RangeSelector.js", [
        a["Core/Axis/Axis.js"],
        a["Core/Defaults.js"],
        a["Core/Globals.js"],
        a["Stock/RangeSelector/RangeSelectorComposition.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D) {
        function u(a) {
            if (-1 !== a.indexOf("%L")) return "text";
            const d = "aAdewbBmoyY".split("").some((b)=>-1 !== a.indexOf("%" + b)), b = "HkIlMS".split("").some((b)=>-1 !== a.indexOf("%" + b));
            return d && b ? "datetime-local" : d ? "date" : b ? "time" : "text";
        }
        const { defaultOptions: B } = A, { addEvent: t, createElement: q, css: m, defined: p, destroyObjectProperties: n, discardElement: h, extend: g, fireEvent: e, isNumber: x, merge: I, objectEach: M, pad: C, pick: f, pInt: y, splat: r } = D;
        class l {
            static compose(a, d) {
                K.compose(a, d, l);
            }
            constructor(a){
                this.buttons = void 0;
                this.buttonOptions = l.prototype.defaultButtons;
                this.initialButtonGroupWidth = 0;
                this.options = void 0;
                this.chart = a;
                this.init(a);
            }
            clickButton(g, d) {
                const b = this.chart, c = this.buttonOptions[g], k = b.xAxis[0];
                var h = b.scroller && b.scroller.getUnionExtremes() || k || {}, l = c.type;
                const m = c.dataGrouping;
                let n = h.dataMin, v = h.dataMax, q, u = k && Math.round(Math.min(k.max, f(v, k.max))), y;
                h = c._range;
                let A, B, C, E = !0;
                if (null !== n && null !== v) {
                    b.fixedRange = h;
                    this.setSelected(g);
                    m && (this.forcedDataGrouping = !0, a.prototype.setDataGrouping.call(k || {
                        chart: this.chart
                    }, m, !1), this.frozenStates = c.preserveDataGrouping);
                    if ("month" === l || "year" === l) k ? (l = {
                        range: c,
                        max: u,
                        chart: b,
                        dataMin: n,
                        dataMax: v
                    }, q = k.minFromRange.call(l), x(l.newMax) && (u = l.newMax), E = !1) : h = c;
                    else if (h) q = Math.max(u - h, n), u = Math.min(q + h, v), E = !1;
                    else if ("ytd" === l) {
                        if (k) {
                            if ("undefined" === typeof v || "undefined" === typeof n) n = Number.MAX_VALUE, v = Number.MIN_VALUE, b.series.forEach((a)=>{
                                if (a = a.xData) n = Math.min(a[0], n), v = Math.max(a[a.length - 1], v);
                            }), d = !1;
                            l = this.getYTDExtremes(v, n, b.time.useUTC);
                            q = A = l.min;
                            u = l.max;
                        } else {
                            this.deferredYTDClick = g;
                            return;
                        }
                    } else "all" === l && k && (b.navigator && b.navigator.baseSeries[0] && (b.navigator.baseSeries[0].xAxis.options.range = void 0), q = n, u = v);
                    E && c._offsetMin && p(q) && (q += c._offsetMin);
                    c._offsetMax && p(u) && (u += c._offsetMax);
                    this.dropdown && (this.dropdown.selectedIndex = g + 1);
                    k ? k.setExtremes(q, u, f(d, !0), void 0, {
                        trigger: "rangeSelectorButton",
                        rangeSelectorButton: c
                    }) : (y = r(b.options.xAxis)[0], C = y.range, y.range = h, B = y.min, y.min = A, t(b, "load", function() {
                        y.range = C;
                        y.min = B;
                    }));
                    e(this, "afterBtnClick");
                }
            }
            setSelected(a) {
                this.selected = this.options.selected = a;
            }
            init(a) {
                const d = this, b = a.options.rangeSelector, c = b.buttons || d.defaultButtons.slice(), f = b.selected, g = function() {
                    const a = d.minInput, b = d.maxInput;
                    a && a.blur && e(a, "blur");
                    b && b.blur && e(b, "blur");
                };
                d.chart = a;
                d.options = b;
                d.buttons = [];
                d.buttonOptions = c;
                this.eventsToUnbind = [];
                this.eventsToUnbind.push(t(a.container, "mousedown", g));
                this.eventsToUnbind.push(t(a, "resize", g));
                c.forEach(d.computeButtonRange);
                "undefined" !== typeof f && c[f] && this.clickButton(f, !1);
                this.eventsToUnbind.push(t(a, "load", function() {
                    a.xAxis && a.xAxis[0] && t(a.xAxis[0], "setExtremes", function(b) {
                        this.max - this.min !== a.fixedRange && "rangeSelectorButton" !== b.trigger && "updatedData" !== b.trigger && d.forcedDataGrouping && !d.frozenStates && this.setDataGrouping(!1, !1);
                    });
                }));
            }
            updateButtonStates() {
                const a = this;
                var d = this.chart;
                const b = this.dropdown, c = d.xAxis[0], e = Math.round(c.max - c.min), f = !c.hasVisibleSeries, g = d.scroller && d.scroller.getUnionExtremes() || c, h = g.dataMin, l = g.dataMax;
                d = a.getYTDExtremes(l, h, d.time.useUTC);
                const m = d.min, n = d.max, p = a.selected, r = a.options.allButtonsEnabled, q = a.buttons;
                let t = x(p);
                a.buttonOptions.forEach((d, g)=>{
                    var k = d._range, w = d.type, v = d.count || 1;
                    const z = q[g], u = d._offsetMax - d._offsetMin, x = g === p, F = k > l - h, y = k < c.minRange;
                    d = 0;
                    let A = !1, H = !1;
                    k = k === e;
                    ("month" === w || "year" === w) && e + 36E5 >= 864E5 * ({
                        month: 28,
                        year: 365
                    })[w] * v - u && e - 36E5 <= 864E5 * ({
                        month: 31,
                        year: 366
                    })[w] * v + u ? k = !0 : "ytd" === w ? (k = n - m + u === e, A = !x) : "all" === w && (k = c.max - c.min >= l - h, H = !x && t && k);
                    w = !r && (F || y || H || f);
                    v = x && k || k && !t && !A || x && a.frozenStates;
                    w ? d = 3 : v && (t = !0, d = 2);
                    z.state !== d && (z.setState(d), b && (b.options[g + 1].disabled = w, 2 === d && (b.selectedIndex = g + 1)), 0 === d && p === g && a.setSelected());
                });
            }
            computeButtonRange(a) {
                const d = a.type, b = a.count || 1, c = {
                    millisecond: 1,
                    second: 1E3,
                    minute: 6E4,
                    hour: 36E5,
                    day: 864E5,
                    week: 6048E5
                };
                if (c[d]) a._range = c[d] * b;
                else if ("month" === d || "year" === d) a._range = 864E5 * ({
                    month: 30,
                    year: 365
                })[d] * b;
                a._offsetMin = f(a.offsetMin, 0);
                a._offsetMax = f(a.offsetMax, 0);
                a._range += a._offsetMax - a._offsetMin;
            }
            getInputValue(a) {
                a = "min" === a ? this.minInput : this.maxInput;
                const d = this.chart.options.rangeSelector, b = this.chart.time;
                return a ? ("text" === a.type && d.inputDateParser || this.defaultInputDateParser)(a.value, b.useUTC, b) : 0;
            }
            setInputValue(a, d) {
                const b = this.options, c = this.chart.time, e = "min" === a ? this.minInput : this.maxInput;
                a = "min" === a ? this.minDateBox : this.maxDateBox;
                if (e) {
                    var f = e.getAttribute("data-hc-time");
                    f = p(f) ? Number(f) : void 0;
                    p(d) && (p(f) && e.setAttribute("data-hc-time-previous", f), e.setAttribute("data-hc-time", d), f = d);
                    e.value = c.dateFormat(this.inputTypeFormats[e.type] || b.inputEditDateFormat, f);
                    a && a.attr({
                        text: c.dateFormat(b.inputDateFormat, f)
                    });
                }
            }
            setInputExtremes(a, d, b) {
                if (a = "min" === a ? this.minInput : this.maxInput) {
                    const c = this.inputTypeFormats[a.type], e = this.chart.time;
                    c && (d = e.dateFormat(c, d), a.min !== d && (a.min = d), b = e.dateFormat(c, b), a.max !== b && (a.max = b));
                }
            }
            showInput(a) {
                const d = "min" === a ? this.minDateBox : this.maxDateBox;
                if ((a = "min" === a ? this.minInput : this.maxInput) && d && this.inputGroup) {
                    const b = "text" === a.type, { translateX: c, translateY: e } = this.inputGroup, { inputBoxWidth: f } = this.options;
                    m(a, {
                        width: b ? d.width + (f ? -2 : 20) + "px" : "auto",
                        height: d.height - 2 + "px",
                        border: "2px solid silver"
                    });
                    b && f ? m(a, {
                        left: c + d.x + "px",
                        top: e + "px"
                    }) : m(a, {
                        left: Math.min(Math.round(d.x + c - (a.offsetWidth - d.width) / 2), this.chart.chartWidth - a.offsetWidth) + "px",
                        top: e - (a.offsetHeight - d.height) / 2 + "px"
                    });
                }
            }
            hideInput(a) {
                (a = "min" === a ? this.minInput : this.maxInput) && m(a, {
                    top: "-9999em",
                    border: 0,
                    width: "1px",
                    height: "1px"
                });
            }
            defaultInputDateParser(a, d, b) {
                var c = a.split("/").join("-").split(" ").join("T");
                -1 === c.indexOf("T") && (c += "T00:00");
                if (d) c += "Z";
                else {
                    var e;
                    if (e = J.isSafari) e = c, e = !(6 < e.length && (e.lastIndexOf("-") === e.length - 6 || e.lastIndexOf("+") === e.length - 6));
                    e && (e = new Date(c).getTimezoneOffset() / 60, c += 0 >= e ? `+${C(-e)}:00` : `-${C(e)}:00`);
                }
                c = Date.parse(c);
                x(c) || (a = a.split("-"), c = Date.UTC(y(a[0]), y(a[1]) - 1, y(a[2])));
                b && d && x(c) && (c += b.getTimezoneOffset(c));
                return c;
            }
            drawInput(a) {
                function d() {
                    const { maxInput: c, minInput: d } = f, e = b.xAxis[0];
                    var g = b.scroller && b.scroller.xAxis ? b.scroller.xAxis : e;
                    const k = g.dataMin;
                    g = g.dataMax;
                    let h = f.getInputValue(a);
                    h !== Number(t.getAttribute("data-hc-time-previous")) && x(h) && (t.setAttribute("data-hc-time-previous", h), p && c && x(k) ? h > Number(c.getAttribute("data-hc-time")) ? h = void 0 : h < k && (h = k) : d && x(g) && (h < Number(d.getAttribute("data-hc-time")) ? h = void 0 : h > g && (h = g)), "undefined" !== typeof h && e.setExtremes(p ? h : e.min, p ? e.max : h, void 0, void 0, {
                        trigger: "rangeSelectorInput"
                    }));
                }
                const { chart: b, div: c, inputGroup: e } = this, f = this, h = b.renderer.style || {};
                var l = b.renderer;
                const n = b.options.rangeSelector, p = "min" === a;
                var r = B.lang[p ? "rangeSelectorFrom" : "rangeSelectorTo"] || "";
                r = l.label(r, 0).addClass("highcharts-range-label").attr({
                    padding: r ? 2 : 0,
                    height: r ? n.inputBoxHeight : 0
                }).add(e);
                l = l.label("", 0).addClass("highcharts-range-input").attr({
                    padding: 2,
                    width: n.inputBoxWidth,
                    height: n.inputBoxHeight,
                    "text-align": "center"
                }).on("click", function() {
                    f.showInput(a);
                    f[a + "Input"].focus();
                });
                b.styledMode || l.attr({
                    stroke: n.inputBoxBorderColor,
                    "stroke-width": 1
                });
                l.add(e);
                const t = q("input", {
                    name: a,
                    className: "highcharts-range-selector"
                }, void 0, c);
                t.setAttribute("type", u(n.inputDateFormat || "%e %b %Y"));
                b.styledMode || (r.css(I(h, n.labelStyle)), l.css(I({
                    color: "#333333"
                }, h, n.inputStyle)), m(t, g({
                    position: "absolute",
                    border: 0,
                    boxShadow: "0 0 15px rgba(0,0,0,0.3)",
                    width: "1px",
                    height: "1px",
                    padding: 0,
                    textAlign: "center",
                    fontSize: h.fontSize,
                    fontFamily: h.fontFamily,
                    top: "-9999em"
                }, n.inputStyle)));
                t.onfocus = ()=>{
                    f.showInput(a);
                };
                t.onblur = ()=>{
                    t === J.doc.activeElement && d();
                    f.hideInput(a);
                    f.setInputValue(a);
                    t.blur();
                };
                let v = !1;
                t.onchange = ()=>{
                    v || (d(), f.hideInput(a), t.blur());
                };
                t.onkeypress = (a)=>{
                    13 === a.keyCode && d();
                };
                t.onkeydown = (a)=>{
                    v = !0;
                    38 !== a.keyCode && 40 !== a.keyCode || d();
                };
                t.onkeyup = ()=>{
                    v = !1;
                };
                return {
                    dateBox: l,
                    input: t,
                    label: r
                };
            }
            getPosition() {
                var a = this.chart;
                const d = a.options.rangeSelector;
                a = "top" === d.verticalAlign ? a.plotTop - a.axisOffset[0] : 0;
                return {
                    buttonTop: a + d.buttonPosition.y,
                    inputTop: a + d.inputPosition.y - 10
                };
            }
            getYTDExtremes(a, d, b) {
                const c = this.chart.time;
                var e = new c.Date(a);
                const f = c.get("FullYear", e);
                b = b ? c.Date.UTC(f, 0, 1) : +new c.Date(f, 0, 1);
                d = Math.max(d, b);
                e = e.getTime();
                return {
                    max: Math.min(a || e, e),
                    min: d
                };
            }
            render(a, d) {
                var b = this.chart, c = b.renderer;
                const e = b.container;
                var g = b.options;
                const h = g.rangeSelector, l = f(g.chart.style && g.chart.style.zIndex, 0) + 1;
                g = h.inputEnabled;
                if (!1 !== h.enabled) {
                    this.rendered || (this.group = c.g("range-selector-group").attr({
                        zIndex: 7
                    }).add(), this.div = q("div", void 0, {
                        position: "relative",
                        height: 0,
                        zIndex: l
                    }), this.buttonOptions.length && this.renderButtons(), e.parentNode && e.parentNode.insertBefore(this.div, e), g && (this.inputGroup = c.g("input-group").add(this.group), c = this.drawInput("min"), this.minDateBox = c.dateBox, this.minLabel = c.label, this.minInput = c.input, c = this.drawInput("max"), this.maxDateBox = c.dateBox, this.maxLabel = c.label, this.maxInput = c.input));
                    if (g && (this.setInputValue("min", a), this.setInputValue("max", d), a = b.scroller && b.scroller.getUnionExtremes() || b.xAxis[0] || {}, p(a.dataMin) && p(a.dataMax) && (b = b.xAxis[0].minRange || 0, this.setInputExtremes("min", a.dataMin, Math.min(a.dataMax, this.getInputValue("max")) - b), this.setInputExtremes("max", Math.max(a.dataMin, this.getInputValue("min")) + b, a.dataMax)), this.inputGroup)) {
                        let a = 0;
                        [
                            this.minLabel,
                            this.minDateBox,
                            this.maxLabel,
                            this.maxDateBox
                        ].forEach((b)=>{
                            if (b) {
                                const { width: c } = b.getBBox();
                                c && (b.attr({
                                    x: a
                                }), a += c + h.inputSpacing);
                            }
                        });
                    }
                    this.alignElements();
                    this.rendered = !0;
                }
            }
            renderButtons() {
                const { buttons: a, chart: d, options: b } = this, c = B.lang, g = d.renderer, h = I(b.buttonTheme), l = h && h.states, m = h.width || 28;
                delete h.width;
                delete h.states;
                this.buttonGroup = g.g("range-selector-buttons").add(this.group);
                const n = this.dropdown = q("select", void 0, {
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    padding: 0,
                    border: 0,
                    top: "-9999em",
                    cursor: "pointer",
                    opacity: .0001
                }, this.div);
                t(n, "touchstart", ()=>{
                    n.style.fontSize = "16px";
                });
                [
                    [
                        J.isMS ? "mouseover" : "mouseenter"
                    ],
                    [
                        J.isMS ? "mouseout" : "mouseleave"
                    ],
                    [
                        "change",
                        "click"
                    ]
                ].forEach(([b, c])=>{
                    t(n, b, ()=>{
                        const d = a[this.currentButtonIndex()];
                        d && e(d.element, c || b);
                    });
                });
                this.zoomText = g.label(c && c.rangeSelectorZoom || "", 0).attr({
                    padding: b.buttonTheme.padding,
                    height: b.buttonTheme.height,
                    paddingLeft: 0,
                    paddingRight: 0
                }).add(this.buttonGroup);
                this.chart.styledMode || (this.zoomText.css(b.labelStyle), h["stroke-width"] = f(h["stroke-width"], 0));
                q("option", {
                    textContent: this.zoomText.textStr,
                    disabled: !0
                }, void 0, n);
                this.buttonOptions.forEach((b, c)=>{
                    q("option", {
                        textContent: b.title || b.text
                    }, void 0, n);
                    a[c] = g.button(b.text, 0, 0, (a)=>{
                        const d = b.events && b.events.click;
                        let e;
                        d && (e = d.call(b, a));
                        !1 !== e && this.clickButton(c);
                        this.isActive = !0;
                    }, h, l && l.hover, l && l.select, l && l.disabled).attr({
                        "text-align": "center",
                        width: m
                    }).add(this.buttonGroup);
                    b.title && a[c].attr("title", b.title);
                });
            }
            alignElements() {
                const { buttonGroup: a, buttons: d, chart: b, group: c, inputGroup: e, options: g, zoomText: h } = this;
                var l = b.options;
                const m = l.exporting && !1 !== l.exporting.enabled && l.navigation && l.navigation.buttonOptions, { buttonPosition: n, inputPosition: p, verticalAlign: r } = g;
                l = (a, c)=>m && this.titleCollision(b) && "top" === r && "right" === c.align && c.y - a.getBBox().height - 12 < (m.y || 0) + (m.height || 0) + b.spacing[0] ? -40 : 0;
                var t = b.plotLeft;
                if (c && n && p) {
                    var q = n.x - b.spacing[3];
                    if (a) {
                        this.positionButtons();
                        if (!this.initialButtonGroupWidth) {
                            let a = 0;
                            h && (a += h.getBBox().width + 5);
                            d.forEach((b, c)=>{
                                a += b.width;
                                c !== d.length - 1 && (a += g.buttonSpacing);
                            });
                            this.initialButtonGroupWidth = a;
                        }
                        t -= b.spacing[3];
                        this.updateButtonStates();
                        var u = l(a, n);
                        this.alignButtonGroup(u);
                        c.placed = a.placed = b.hasLoaded;
                    }
                    u = 0;
                    e && (u = l(e, p), "left" === p.align ? q = t : "right" === p.align && (q = -Math.max(b.axisOffset[1], -u)), e.align({
                        y: p.y,
                        width: e.getBBox().width,
                        align: p.align,
                        x: p.x + q - 2
                    }, !0, b.spacingBox), e.placed = b.hasLoaded);
                    this.handleCollision(u);
                    c.align({
                        verticalAlign: r
                    }, !0, b.spacingBox);
                    l = c.alignAttr.translateY;
                    t = c.getBBox().height + 20;
                    q = 0;
                    "bottom" === r && (q = (q = b.legend && b.legend.options) && "bottom" === q.verticalAlign && q.enabled && !q.floating ? b.legend.legendHeight + f(q.margin, 10) : 0, t = t + q - 20, q = l - t - (g.floating ? 0 : g.y) - (b.titleOffset ? b.titleOffset[2] : 0) - 10);
                    if ("top" === r) g.floating && (q = 0), b.titleOffset && b.titleOffset[0] && (q = b.titleOffset[0]), q += b.margin[0] - b.spacing[0] || 0;
                    else if ("middle" === r) {
                        if (p.y === n.y) q = l;
                        else if (p.y || n.y) q = 0 > p.y || 0 > n.y ? q - Math.min(p.y, n.y) : l - t;
                    }
                    c.translate(g.x, g.y + Math.floor(q));
                    const { minInput: k, maxInput: m, dropdown: w } = this;
                    g.inputEnabled && k && m && (k.style.marginTop = c.translateY + "px", m.style.marginTop = c.translateY + "px");
                    w && (w.style.marginTop = c.translateY + "px");
                }
            }
            alignButtonGroup(a, d) {
                const { chart: b, options: c, buttonGroup: e } = this, { buttonPosition: g } = c, h = b.plotLeft - b.spacing[3];
                let l = g.x - b.spacing[3];
                "right" === g.align ? l += a - h : "center" === g.align && (l -= h / 2);
                e && e.align({
                    y: g.y,
                    width: f(d, this.initialButtonGroupWidth),
                    align: g.align,
                    x: l
                }, !0, b.spacingBox);
            }
            positionButtons() {
                const { buttons: a, chart: d, options: b, zoomText: c } = this, e = d.hasLoaded ? "animate" : "attr", { buttonPosition: g } = b, h = d.plotLeft;
                let l = h;
                c && "hidden" !== c.visibility && (c[e]({
                    x: f(h + g.x, h)
                }), l += g.x + c.getBBox().width + 5);
                for(let c = 0, d = this.buttonOptions.length; c < d; ++c)if ("hidden" !== a[c].visibility) a[c][e]({
                    x: l
                }), l += a[c].width + b.buttonSpacing;
                else a[c][e]({
                    x: h
                });
            }
            handleCollision(a) {
                const { chart: d, buttonGroup: b, inputGroup: c } = this, { buttonPosition: e, dropdown: f, inputPosition: g } = this.options, h = ()=>{
                    let a = 0;
                    this.buttons.forEach((b)=>{
                        b = b.getBBox();
                        b.width > a && (a = b.width);
                    });
                    return a;
                }, l = (d)=>{
                    if (c && b) {
                        const f = c.alignAttr.translateX + c.alignOptions.x - a + c.getBBox().x + 2, h = c.alignOptions.width, k = b.alignAttr.translateX + b.getBBox().x;
                        return k + d > f && f + h > k && e.y < g.y + c.getBBox().height;
                    }
                    return !1;
                }, m = ()=>{
                    c && b && c.attr({
                        translateX: c.alignAttr.translateX + (d.axisOffset[1] >= -a ? 0 : -a),
                        translateY: c.alignAttr.translateY + b.getBBox().height + 10
                    });
                };
                if (b) {
                    if ("always" === f) {
                        this.collapseButtons(a);
                        l(h()) && m();
                        return;
                    }
                    "never" === f && this.expandButtons();
                }
                c && b ? g.align === e.align || l(this.initialButtonGroupWidth + 20) ? "responsive" === f ? (this.collapseButtons(a), l(h()) && m()) : m() : "responsive" === f && this.expandButtons() : b && "responsive" === f && (this.initialButtonGroupWidth > d.plotWidth ? this.collapseButtons(a) : this.expandButtons());
            }
            collapseButtons(a) {
                const { buttons: d, buttonOptions: b, chart: c, dropdown: e, options: g, zoomText: h } = this, l = c.userOptions.rangeSelector && c.userOptions.rangeSelector.buttonTheme || {}, m = (a)=>({
                        text: a ? `${a} \u25be` : "\u25BE",
                        width: "auto",
                        paddingLeft: f(g.buttonTheme.paddingLeft, l.padding, 8),
                        paddingRight: f(g.buttonTheme.paddingRight, l.padding, 8)
                    });
                h && h.hide();
                let n = !1;
                b.forEach((a, b)=>{
                    b = d[b];
                    2 !== b.state ? b.hide() : (b.show(), b.attr(m(a.text)), n = !0);
                });
                n || (e && (e.selectedIndex = 0), d[0].show(), d[0].attr(m(this.zoomText && this.zoomText.textStr)));
                const { align: p } = g.buttonPosition;
                this.positionButtons();
                "right" !== p && "center" !== p || this.alignButtonGroup(a, d[this.currentButtonIndex()].getBBox().width);
                this.showDropdown();
            }
            expandButtons() {
                const { buttons: a, buttonOptions: d, options: b, zoomText: c } = this;
                this.hideDropdown();
                c && c.show();
                d.forEach((c, d)=>{
                    d = a[d];
                    d.show();
                    d.attr({
                        text: c.text,
                        width: b.buttonTheme.width || 28,
                        paddingLeft: f(b.buttonTheme.paddingLeft, "unset"),
                        paddingRight: f(b.buttonTheme.paddingRight, "unset")
                    });
                    2 > d.state && d.setState(0);
                });
                this.positionButtons();
            }
            currentButtonIndex() {
                const { dropdown: a } = this;
                return a && 0 < a.selectedIndex ? a.selectedIndex - 1 : 0;
            }
            showDropdown() {
                const { buttonGroup: a, buttons: d, chart: b, dropdown: c } = this;
                if (a && c) {
                    const { translateX: e, translateY: f } = a, g = d[this.currentButtonIndex()].getBBox();
                    m(c, {
                        left: b.plotLeft + e + "px",
                        top: f + .5 + "px",
                        width: g.width + "px",
                        height: g.height + "px"
                    });
                    this.hasVisibleDropdown = !0;
                }
            }
            hideDropdown() {
                const { dropdown: a } = this;
                a && (m(a, {
                    top: "-9999em",
                    width: "1px",
                    height: "1px"
                }), this.hasVisibleDropdown = !1);
            }
            getHeight() {
                var a = this.options, d = this.group;
                const b = a.y, c = a.buttonPosition.y, e = a.inputPosition.y;
                if (a.height) return a.height;
                this.alignElements();
                a = d ? d.getBBox(!0).height + 13 + b : 0;
                d = Math.min(e, c);
                if (0 > e && 0 > c || 0 < e && 0 < c) a += Math.abs(d);
                return a;
            }
            titleCollision(a) {
                return !(a.options.title.text || a.options.subtitle.text);
            }
            update(a) {
                const d = this.chart;
                I(!0, d.options.rangeSelector, a);
                this.destroy();
                this.init(d);
                this.render();
            }
            destroy() {
                const a = this, d = a.minInput, b = a.maxInput;
                a.eventsToUnbind && (a.eventsToUnbind.forEach((a)=>a()), a.eventsToUnbind = void 0);
                n(a.buttons);
                d && (d.onfocus = d.onblur = d.onchange = null);
                b && (b.onfocus = b.onblur = b.onchange = null);
                M(a, function(b, d) {
                    b && "chart" !== d && (b instanceof G ? b.destroy() : b instanceof S.HTMLElement && h(b));
                    b !== l.prototype[d] && (a[d] = null);
                }, this);
            }
        }
        g(l.prototype, {
            defaultButtons: [
                {
                    type: "month",
                    count: 1,
                    text: "1m",
                    title: "View 1 month"
                },
                {
                    type: "month",
                    count: 3,
                    text: "3m",
                    title: "View 3 months"
                },
                {
                    type: "month",
                    count: 6,
                    text: "6m",
                    title: "View 6 months"
                },
                {
                    type: "ytd",
                    text: "YTD",
                    title: "View year to date"
                },
                {
                    type: "year",
                    count: 1,
                    text: "1y",
                    title: "View 1 year"
                },
                {
                    type: "all",
                    text: "All",
                    title: "View all"
                }
            ],
            inputTypeFormats: {
                "datetime-local": "%Y-%m-%dT%H:%M:%S",
                date: "%Y-%m-%d",
                time: "%H:%M:%S"
            }
        });
        "";
        return l;
    });
    L(a, "Core/Axis/OrdinalAxis.js", [
        a["Core/Axis/Axis.js"],
        a["Core/Globals.js"],
        a["Core/Series/Series.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K) {
        const { addEvent: u, correctFloat: D, css: E, defined: B, error: t, pick: q, timeUnits: m } = K, p = [];
        var n;
        (function(a) {
            function g(a, c, d, e, f = [], g = 0, h) {
                const b = {}, k = this.options.tickPixelInterval;
                var l = this.chart.time, n = [], p;
                let r;
                let q;
                var w = 0;
                let u = [], v = -Number.MAX_VALUE;
                if (!this.options.ordinal && !this.options.breaks || !f || 3 > f.length || "undefined" === typeof c) return l.getTimeTicks.apply(l, arguments);
                const z = f.length;
                for(p = 0; p < z; p++){
                    q = p && f[p - 1] > d;
                    f[p] < c && (w = p);
                    if (p === z - 1 || f[p + 1] - f[p] > 5 * g || q) {
                        if (f[p] > v) {
                            for(r = l.getTimeTicks(a, f[w], f[p], e); r.length && r[0] <= v;)r.shift();
                            r.length && (v = r[r.length - 1]);
                            n.push(u.length);
                            u = u.concat(r);
                        }
                        w = p + 1;
                    }
                    if (q) break;
                }
                if (r) {
                    f = r.info;
                    if (h && f.unitRange <= m.hour) {
                        p = u.length - 1;
                        for(w = 1; w < p; w++)if (l.dateFormat("%d", u[w]) !== l.dateFormat("%d", u[w - 1])) {
                            b[u[w]] = "day";
                            var x = !0;
                        }
                        x && (b[u[0]] = "day");
                        f.higherRanks = b;
                    }
                    f.segmentStarts = n;
                    u.info = f;
                } else t(12, !1, this.chart);
                if (h && B(k)) {
                    w = u.length;
                    l = [];
                    x = [];
                    let a;
                    for(p = w; p--;)n = this.translate(u[p]), a && (x[p] = a - n), l[p] = a = n;
                    x.sort();
                    x = x[Math.floor(x.length / 2)];
                    x < .6 * k && (x = null);
                    p = u[w - 1] > d ? w - 1 : w;
                    for(a = void 0; p--;)n = l[p], w = Math.abs(a - n), a && w < .8 * k && (null === x || w < .8 * x) ? (b[u[p]] && !b[u[p + 1]] ? (w = p + 1, a = n) : w = p, u.splice(w, 1)) : a = n;
                }
                return u;
            }
            function e(a) {
                const b = this.ordinal.positions;
                if (!b) return a;
                let d = b.length - 1, e;
                0 > a ? a = b[0] : a > d ? a = b[d] : (d = Math.floor(a), e = a - d);
                return "undefined" !== typeof e && "undefined" !== typeof b[d] ? b[d] + (e ? e * (b[d + 1] - b[d]) : 0) : a;
            }
            function h(a) {
                var b = this.ordinal, d = b.positions;
                if (!d) return a;
                var e = D((a - (this.old ? this.old.min : this.min)) * (this.old ? this.old.transA : this.transA) + this.minPixelPadding);
                a >= d[0] && a <= d[d.length - 1] || (b.extendedOrdinalPositions || (b.extendedOrdinalPositions = b.getExtendedPositions()), d = b.extendedOrdinalPositions);
                if (d && d.length) {
                    a = d.indexOf(a);
                    b = -1 !== a ? a : D(b.getIndexOfPoint(e, d));
                    e = D(b % 1);
                    if (0 <= b && b <= d.length - 1) return d[Math.floor(b)] + e * (d[Math.ceil(b)] - d[Math.floor(b)]);
                    e = d.length;
                    a = d[0];
                    d = d[e - 1];
                    const c = (d - a) / (e - 1);
                    return 0 > b ? a + c * b : d + c * (b - e);
                }
                return a;
            }
            function n(b, c) {
                const d = a.Additions.findIndexOf(b, c, !0);
                return b[d] === c ? d : d + (c - b[d]) / (b[d + 1] - b[d]);
            }
            function G() {
                this.ordinal || (this.ordinal = new a.Additions(this));
            }
            function C() {
                this.isXAxis && B(this.options.overscroll) && this.max === this.dataMax && (!this.chart.mouseIsDown || this.isInternal) && (!this.eventArgs || this.eventArgs && "navigator" !== this.eventArgs.trigger) && (this.max += this.options.overscroll, !this.isInternal && B(this.userMin) && (this.min += this.options.overscroll));
            }
            function f() {
                this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
            }
            function y() {
                this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
            }
            function r(a) {
                const b = this.xAxis[0], d = b.options.overscroll, e = a.originalEvent.chartX, f = this.options.chart.panning;
                let g = !1;
                if (f && "y" !== f.type && b.options.ordinal && b.series.length) {
                    var h = this.mouseDownX;
                    const a = b.getExtremes(), c = a.dataMax, f = a.min, k = a.max;
                    var l = this.hoverPoints, n = b.closestPointRange || b.ordinal && b.ordinal.overscrollPointsRange;
                    h = Math.round((h - e) / (b.translationSlope * (b.ordinal.slope || n)));
                    n = b.ordinal.getExtendedPositions();
                    var m = {
                        ordinal: {
                            positions: n,
                            extendedOrdinalPositions: n
                        }
                    };
                    n = b.index2val;
                    const p = b.val2lin;
                    let r;
                    m.ordinal.positions ? 1 < Math.abs(h) && (l && l.forEach(function(a) {
                        a.setState();
                    }), 0 > h ? (l = m, r = b.ordinal.positions ? b : m) : (l = b.ordinal.positions ? b : m, r = m), m = r.ordinal.positions, c > m[m.length - 1] && m.push(c), this.fixedRange = k - f, h = b.navigatorAxis.toFixedRange(void 0, void 0, n.apply(l, [
                        p.apply(l, [
                            f,
                            !0
                        ]) + h
                    ]), n.apply(r, [
                        p.apply(r, [
                            k,
                            !0
                        ]) + h
                    ])), h.min >= Math.min(a.dataMin, f) && h.max <= Math.max(c, k) + d && b.setExtremes(h.min, h.max, !0, !1, {
                        trigger: "pan"
                    }), this.mouseDownX = e, E(this.container, {
                        cursor: "move"
                    })) : g = !0;
                } else g = !0;
                g || f && /y/.test(f.type) ? d && (b.max = b.dataMax + d) : a.preventDefault();
            }
            function l() {
                const a = this.xAxis;
                a && a.options.ordinal && (delete a.ordinal.index, delete a.ordinal.extendedOrdinalPositions);
            }
            function v(a, c) {
                const b = this.ordinal;
                var d = b.positions;
                let e = b.slope, f = b.extendedOrdinalPositions;
                if (!d) return a;
                var g = d.length;
                if (d[0] <= a && d[g - 1] >= a) a = n(d, a);
                else {
                    f || (f = b.getExtendedPositions && b.getExtendedPositions(), b.extendedOrdinalPositions = f);
                    if (!f || !f.length) return a;
                    g = f.length;
                    e || (e = (f[g - 1] - f[0]) / g);
                    d = n(f, d[0]);
                    a = a >= f[0] && a <= f[g - 1] ? n(f, a) - d : a < f[0] ? -d - (f[0] - a) / e : (a - f[g - 1]) / e + g - d;
                }
                return c ? a : e * (a || 0) + b.offset;
            }
            a.compose = function(a, c, d) {
                if (K.pushUnique(p, a)) {
                    const b = a.prototype;
                    b.getTimeTicks = g;
                    b.index2val = e;
                    b.lin2val = h;
                    b.val2lin = v;
                    b.ordinal2lin = b.val2lin;
                    u(a, "afterInit", G);
                    u(a, "foundExtremes", C);
                    u(a, "afterSetScale", f);
                    u(a, "initialAxisTranslation", y);
                }
                K.pushUnique(p, d) && u(d, "pan", r);
                K.pushUnique(p, c) && u(c, "updatedData", l);
                return a;
            };
            class d {
                constructor(a){
                    this.index = {};
                    this.axis = a;
                }
                beforeSetTickPositions() {
                    const a = this.axis, c = a.ordinal;
                    var d = a.getExtremes();
                    const e = d.min;
                    var f = d.max;
                    const g = a.isXAxis && !!a.options.breaks;
                    d = a.options.ordinal;
                    const h = a.chart.options.chart.ignoreHiddenSeries;
                    let l, n;
                    var m;
                    let p = [], r = Number.MAX_VALUE, t = !1, u = !1, v = !1;
                    if (d || g) {
                        let b = 0;
                        a.series.forEach(function(a, c) {
                            n = [];
                            0 < c && "highcharts-navigator-series" !== a.options.id && 1 < a.processedXData.length && (u = b !== a.processedXData[1] - a.processedXData[0]);
                            b = a.processedXData[1] - a.processedXData[0];
                            a.boosted && (v = a.boosted);
                            if (!(h && !1 === a.visible || !1 === a.takeOrdinalPosition && !g) && (p = p.concat(a.processedXData), l = p.length, p.sort(function(a, b) {
                                return a - b;
                            }), r = Math.min(r, q(a.closestPointRange, r)), l)) {
                                for(c = 0; c < l - 1;)p[c] !== p[c + 1] && n.push(p[c + 1]), c++;
                                n[0] !== p[0] && n.unshift(p[0]);
                                p = n;
                            }
                        });
                        u && v && (p.pop(), p.shift());
                        l = p.length;
                        if (2 < l) {
                            var x = p[1] - p[0];
                            for(m = l - 1; m-- && !t;)p[m + 1] - p[m] !== x && (t = !0);
                            !a.options.keepOrdinalPadding && (p[0] - e > x || f - p[p.length - 1] > x) && (t = !0);
                        } else a.options.overscroll && (2 === l ? r = p[1] - p[0] : 1 === l ? (r = a.options.overscroll, p = [
                            p[0],
                            p[0] + r
                        ]) : r = c.overscrollPointsRange);
                        t || a.forceOrdinal ? (a.options.overscroll && (c.overscrollPointsRange = r, p = p.concat(c.getOverscrollPositions())), c.positions = p, x = a.ordinal2lin(Math.max(e, p[0]), !0), m = Math.max(a.ordinal2lin(Math.min(f, p[p.length - 1]), !0), 1), c.slope = f = (f - e) / (m - x), c.offset = e - x * f) : (c.overscrollPointsRange = q(a.closestPointRange, c.overscrollPointsRange), c.positions = a.ordinal.slope = c.offset = void 0);
                    }
                    a.isOrdinal = d && t;
                    c.groupIntervalFactor = null;
                }
                static findIndexOf(a, c, d) {
                    let b = 0, e = a.length - 1, f;
                    for(; b < e;)f = Math.ceil((b + e) / 2), a[f] <= c ? b = f : e = f - 1;
                    return a[b] === c ? b : d ? b : -1;
                }
                getExtendedPositions() {
                    const a = this, c = a.axis, d = c.constructor.prototype, e = c.chart, f = c.series[0].currentDataGrouping, g = f ? f.count + f.unitName : "raw", h = c.options.overscroll, l = c.getExtremes();
                    let n, m = void 0, p = a.index;
                    p || (p = a.index = {});
                    p[g] || (n = {
                        series: [],
                        chart: e,
                        forceOrdinal: !1,
                        getExtremes: function() {
                            return {
                                min: l.dataMin,
                                max: l.dataMax + h
                            };
                        },
                        getGroupPixelWidth: d.getGroupPixelWidth,
                        getTimeTicks: d.getTimeTicks,
                        options: {
                            ordinal: !0
                        },
                        ordinal: {
                            getGroupIntervalFactor: this.getGroupIntervalFactor
                        },
                        ordinal2lin: d.ordinal2lin,
                        getIndexOfPoint: d.getIndexOfPoint,
                        val2lin: d.val2lin
                    }, n.ordinal.axis = n, c.series.forEach(function(b) {
                        m = {
                            xAxis: n,
                            xData: b.xData.slice(),
                            chart: e,
                            destroyGroupedData: A.noop,
                            getProcessedData: J.prototype.getProcessedData,
                            applyGrouping: J.prototype.applyGrouping
                        };
                        m.xData = m.xData.concat(a.getOverscrollPositions());
                        m.options = {
                            dataGrouping: f ? {
                                firstAnchor: "firstPoint",
                                anchor: "middle",
                                lastAnchor: "lastPoint",
                                enabled: !0,
                                forced: !0,
                                approximation: "open",
                                units: [
                                    [
                                        f.unitName,
                                        [
                                            f.count
                                        ]
                                    ]
                                ]
                            } : {
                                enabled: !1
                            }
                        };
                        n.series.push(m);
                        b.processData.apply(m);
                    }), m.closestPointRange !== m.basePointRange && m.currentDataGrouping && (n.forceOrdinal = !0), c.ordinal.beforeSetTickPositions.apply({
                        axis: n
                    }), p[g] = n.ordinal.positions);
                    return p[g];
                }
                getGroupIntervalFactor(a, c, d) {
                    d = d.processedXData;
                    const b = d.length;
                    var e = [];
                    var f = this.groupIntervalFactor;
                    if (!f) {
                        for(f = 0; f < b - 1; f++)e[f] = d[f + 1] - d[f];
                        e.sort(function(a, b) {
                            return a - b;
                        });
                        e = e[Math.floor(b / 2)];
                        a = Math.max(a, d[0]);
                        c = Math.min(c, d[b - 1]);
                        this.groupIntervalFactor = f = b * e / (c - a);
                    }
                    return f;
                }
                getIndexOfPoint(a, c) {
                    const b = this.axis, e = this.positions ? this.positions[0] : 0, f = function(a) {
                        return a.points.some((a)=>!!a.isInside);
                    };
                    let g;
                    b.series.forEach((a)=>{
                        var b;
                        const c = null === (b = a.points) || void 0 === b ? void 0 : b[0];
                        B(null === c || void 0 === c ? void 0 : c.plotX) && (c.plotX < g || !B(g)) && f(a) && (g = c.plotX);
                    });
                    null !== g && void 0 !== g ? g : g = b.minPixelPadding;
                    a = D((a - g) / (b.translationSlope * (this.slope || b.closestPointRange || this.overscrollPointsRange)));
                    return d.findIndexOf(c, e, !0) + a;
                }
                getOverscrollPositions() {
                    const a = this.axis, c = a.options.overscroll, d = this.overscrollPointsRange, e = [];
                    let f = a.dataMax;
                    if (B(d)) for(; f <= a.dataMax + c;)f += d, e.push(f);
                    return e;
                }
                postProcessTickInterval(a) {
                    const b = this.axis, d = this.slope;
                    return d ? b.options.breaks ? b.closestPointRange || a : a / (d / b.closestPointRange) : a;
                }
            }
            a.Additions = d;
        })(n || (n = {}));
        return n;
    });
    L(a, "Series/HLC/HLCPoint.js", [
        a["Core/Series/SeriesRegistry.js"]
    ], function(a) {
        ({ column: { prototype: { pointClass: a } } } = a.seriesTypes);
        class u extends a {
            constructor(){
                super(...arguments);
                this.series = this.plotClose = this.options = this.low = this.high = this.close = void 0;
            }
        }
        return u;
    });
    L(a, "Series/HLC/HLCSeriesDefaults.js", [], function() {
        "";
        return {
            lineWidth: 1,
            tooltip: {
                pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'
            },
            threshold: null,
            states: {
                hover: {
                    lineWidth: 3
                }
            },
            stickyTracking: !0
        };
    });
    L(a, "Series/HLC/HLCSeries.js", [
        a["Series/HLC/HLCPoint.js"],
        a["Series/HLC/HLCSeriesDefaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K) {
        const { column: u } = J.seriesTypes, { extend: D, merge: E } = K;
        class B extends u {
            constructor(){
                super(...arguments);
                this.yData = this.points = this.options = this.data = void 0;
            }
            extendStem(a, q, m) {
                const p = a[0];
                a = a[1];
                "number" === typeof p[2] && (p[2] = Math.max(m + q, p[2]));
                "number" === typeof a[2] && (a[2] = Math.min(m - q, a[2]));
            }
            getPointPath(a, q) {
                q = q.strokeWidth();
                const m = a.series, p = q % 2 / 2, n = Math.round(a.plotX) - p, h = Math.round(a.shapeArgs.width / 2), g = [
                    [
                        "M",
                        n,
                        Math.round(a.yBottom)
                    ],
                    [
                        "L",
                        n,
                        Math.round(a.plotHigh)
                    ]
                ];
                null !== a.close && (a = Math.round(a.plotClose) + p, g.push([
                    "M",
                    n,
                    a
                ], [
                    "L",
                    n + h,
                    a
                ]), m.extendStem(g, q / 2, a));
                return g;
            }
            drawSinglePoint(a) {
                var q = a.series;
                const m = q.chart;
                let p = a.graphic;
                "undefined" !== typeof a.plotY && (p || (a.graphic = p = m.renderer.path().add(q.group)), m.styledMode || p.attr(q.pointAttribs(a, a.selected && "select")), q = q.getPointPath(a, p), p[p ? "animate" : "attr"]({
                    d: q
                }).addClass(a.getClassName(), !0));
            }
            drawPoints() {
                this.points.forEach(this.drawSinglePoint);
            }
            init() {
                super.init.apply(this, arguments);
                this.options.stacking = void 0;
            }
            pointAttribs(a, q) {
                a = super.pointAttribs.call(this, a, q);
                delete a.fill;
                return a;
            }
            toYData(a) {
                return [
                    a.high,
                    a.low,
                    a.close
                ];
            }
            translate() {
                const a = this, q = a.yAxis, m = this.pointArrayMap && this.pointArrayMap.slice() || [], p = m.map((a)=>`plot${a.charAt(0).toUpperCase() + a.slice(1)}`);
                p.push("yBottom");
                m.push("low");
                super.translate.apply(a);
                a.points.forEach(function(n) {
                    m.forEach(function(h, g) {
                        h = n[h];
                        null !== h && (a.dataModify && (h = a.dataModify.modifyValue(h)), n[p[g]] = q.toPixels(h, !0));
                    });
                    n.tooltipPos[1] = n.plotHigh + q.pos - a.chart.plotTop;
                });
            }
        }
        B.defaultOptions = E(u.defaultOptions, A);
        D(B.prototype, {
            pointClass: a,
            animate: null,
            directTouch: !1,
            pointArrayMap: [
                "high",
                "low",
                "close"
            ],
            pointAttrToOptions: {
                stroke: "color",
                "stroke-width": "lineWidth"
            },
            pointValKey: "close"
        });
        J.registerSeriesType("hlc", B);
        return B;
    });
    L(a, "Series/OHLC/OHLCPoint.js", [
        a["Core/Series/SeriesRegistry.js"]
    ], function(a) {
        ({ seriesTypes: { hlc: a } } = a);
        class u extends a.prototype.pointClass {
            constructor(){
                super(...arguments);
                this.series = this.plotOpen = this.options = this.open = void 0;
            }
            getClassName() {
                return super.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
            }
            resolveUpColor() {
                this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
            }
            resolveColor() {
                super.resolveColor();
                this.resolveUpColor();
            }
            getZone() {
                const a = super.getZone();
                this.resolveUpColor();
                return a;
            }
            applyOptions() {
                super.applyOptions.apply(this, arguments);
                this.resolveColor && this.resolveColor();
                return this;
            }
        }
        return u;
    });
    L(a, "Series/OHLC/OHLCSeriesDefaults.js", [], function() {
        "";
        return {
            tooltip: {
                pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'
            }
        };
    });
    L(a, "Series/OHLC/OHLCSeries.js", [
        a["Series/OHLC/OHLCPoint.js"],
        a["Series/OHLC/OHLCSeriesDefaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K) {
        function u(a) {
            a = a.options;
            const h = a.dataGrouping;
            h && a.useOhlcData && "highcharts-navigator-series" !== a.id && (h.approximation = "ohlc");
        }
        function D(a) {
            a = a.options;
            a.useOhlcData && "highcharts-navigator-series" !== a.id && t(this, {
                pointValKey: p.prototype.pointValKey,
                pointArrayMap: p.prototype.pointArrayMap,
                toYData: p.prototype.toYData
            });
        }
        const { seriesTypes: { hlc: E } } = J, { addEvent: B, extend: t, merge: q } = K, m = [];
        class p extends E {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            static compose(a, ...h) {
                K.pushUnique(m, a) && (B(a, "afterSetOptions", u), B(a, "init", D));
            }
            getPointPath(a, h) {
                const g = super.getPointPath(a, h);
                h = h.strokeWidth();
                const e = h % 2 / 2, m = Math.round(a.plotX) - e, n = Math.round(a.shapeArgs.width / 2);
                null !== a.open && (a = Math.round(a.plotOpen) + e, g.push([
                    "M",
                    m,
                    a
                ], [
                    "L",
                    m - n,
                    a
                ]), super.extendStem(g, h / 2, a));
                return g;
            }
            pointAttribs(a, h) {
                h = super.pointAttribs.call(this, a, h);
                const g = this.options;
                delete h.fill;
                !a.options.color && g.upColor && a.open < a.close && (h.stroke = g.upColor);
                return h;
            }
            toYData(a) {
                return [
                    a.open,
                    a.high,
                    a.low,
                    a.close
                ];
            }
        }
        p.defaultOptions = q(E.defaultOptions, A);
        t(p.prototype, {
            pointClass: a,
            pointArrayMap: [
                "open",
                "high",
                "low",
                "close"
            ]
        });
        J.registerSeriesType("ohlc", p);
        return p;
    });
    L(a, "Series/Candlestick/CandlestickSeriesDefaults.js", [
        a["Core/Defaults.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        "";
        return {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            threshold: null,
            lineColor: "#000000",
            lineWidth: 1,
            upColor: "#ffffff",
            stickyTracking: !0
        };
    });
    L(a, "Series/Candlestick/CandlestickSeries.js", [
        a["Series/Candlestick/CandlestickSeriesDefaults.js"],
        a["Core/Defaults.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K) {
        ({ defaultOptions: A } = A);
        const { column: u, ohlc: D } = J.seriesTypes;
        ({ merge: K } = K);
        class E extends D {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            pointAttribs(a, t) {
                const q = u.prototype.pointAttribs.call(this, a, t), m = this.options, p = a.open < a.close, n = m.lineColor || this.color, h = a.color || this.color;
                q["stroke-width"] = m.lineWidth;
                q.fill = a.options.color || (p ? m.upColor || h : h);
                q.stroke = a.options.lineColor || (p ? m.upLineColor || n : n);
                t && (a = m.states[t], q.fill = a.color || q.fill, q.stroke = a.lineColor || q.stroke, q["stroke-width"] = a.lineWidth || q["stroke-width"]);
                return q;
            }
            drawPoints() {
                var a = this.points;
                const t = this.chart, q = this.yAxis.reversed;
                for (const h of a){
                    a = h.graphic;
                    var m = void 0, p = void 0;
                    let g, e;
                    var n = void 0;
                    let u, A;
                    const B = !a;
                    "undefined" !== typeof h.plotY && (a || (h.graphic = a = t.renderer.path().add(this.group)), this.chart.styledMode || a.attr(this.pointAttribs(h, h.selected && "select")).shadow(this.options.shadow), n = a.strokeWidth() % 2 / 2, u = Math.round(h.plotX) - n, m = h.plotOpen, p = h.plotClose, g = Math.min(m, p), m = Math.max(m, p), A = Math.round(h.shapeArgs.width / 2), p = q ? m !== h.yBottom : Math.round(g) !== Math.round(h.plotHigh), e = q ? Math.round(g) !== Math.round(h.plotHigh) : m !== h.yBottom, g = Math.round(g) + n, m = Math.round(m) + n, n = [], n.push([
                        "M",
                        u - A,
                        m
                    ], [
                        "L",
                        u - A,
                        g
                    ], [
                        "L",
                        u + A,
                        g
                    ], [
                        "L",
                        u + A,
                        m
                    ], [
                        "Z"
                    ], [
                        "M",
                        u,
                        g
                    ], [
                        "L",
                        u,
                        p ? Math.round(q ? h.yBottom : h.plotHigh) : g
                    ], [
                        "M",
                        u,
                        m
                    ], [
                        "L",
                        u,
                        e ? Math.round(q ? h.plotHigh : h.yBottom) : m
                    ]), a[B ? "attr" : "animate"]({
                        d: n
                    }).addClass(h.getClassName(), !0));
                }
            }
        }
        E.defaultOptions = K(D.defaultOptions, A.plotOptions, {
            tooltip: D.defaultOptions.tooltip
        }, a);
        J.registerSeriesType("candlestick", E);
        return E;
    });
    L(a, "Series/Flags/FlagsPoint.js", [
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Utilities.js"]
    ], function(a, A) {
        ({ column: { prototype: { pointClass: a } } } = a.seriesTypes);
        const { isNumber: u } = A;
        class K extends a {
            constructor(){
                super(...arguments);
                this.series = this.options = void 0;
                this.ttBelow = !1;
            }
            isValid() {
                return u(this.y) || "undefined" === typeof this.y;
            }
            hasNewShapeType() {
                const a = this.options.shape || this.series.options.shape;
                return this.graphic && a && a !== this.graphic.symbolKey;
            }
        }
        return K;
    });
    L(a, "Series/Flags/FlagsSeriesDefaults.js", [], function() {
        "";
        return {
            pointRange: 0,
            allowOverlapX: !1,
            shape: "flag",
            stackDistance: 12,
            textAlign: "center",
            tooltip: {
                pointFormat: "{point.text}"
            },
            threshold: null,
            y: -30,
            fillColor: "#ffffff",
            lineWidth: 1,
            states: {
                hover: {
                    lineColor: "#000000",
                    fillColor: "#ccd3ff"
                }
            },
            style: {
                fontSize: "0.7em",
                fontWeight: "bold"
            }
        };
    });
    L(a, "Series/Flags/FlagsSymbols.js", [
        a["Core/Renderer/RendererRegistry.js"]
    ], function(a) {
        var u;
        (function(u) {
            function A(a, u, t, q, m) {
                const p = m && m.anchorX || a;
                m = m && m.anchorY || u;
                const n = this.circle(p - 1, m - 1, 2, 2);
                n.push([
                    "M",
                    p,
                    m
                ], [
                    "L",
                    a,
                    u + q
                ], [
                    "L",
                    a,
                    u
                ], [
                    "L",
                    a + t,
                    u
                ], [
                    "L",
                    a + t,
                    u + q
                ], [
                    "L",
                    a,
                    u + q
                ], [
                    "Z"
                ]);
                return n;
            }
            function G(a, u) {
                a[u + "pin"] = function(t, q, m, p, n) {
                    const h = n && n.anchorX;
                    n = n && n.anchorY;
                    let g;
                    "circle" === u && p > m && (t -= Math.round((p - m) / 2), m = p);
                    g = a[u](t, q, m, p);
                    if (h && n) {
                        let e = h;
                        "circle" === u ? e = t + m / 2 : (t = g[0], m = g[1], "M" === t[0] && "L" === m[0] && (e = (t[1] + m[1]) / 2));
                        g.push([
                            "M",
                            e,
                            q > n ? q : q + p
                        ], [
                            "L",
                            h,
                            n
                        ]);
                        g = g.concat(a.circle(h - 1, n - 1, 2, 2));
                    }
                    return g;
                };
            }
            const D = [];
            u.compose = function(u) {
                -1 === D.indexOf(u) && (D.push(u), u = u.prototype.symbols, u.flag = A, G(u, "circle"), G(u, "square"));
                u = a.getRendererType();
                D.indexOf(u) && D.push(u);
            };
        })(u || (u = {}));
        return u;
    });
    L(a, "Series/OnSeriesComposition.js", [
        a["Series/Column/ColumnSeries.js"],
        a["Core/Series/Series.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J) {
        const { prototype: u } = a, { prototype: G } = A, { defined: D, stableSort: E } = J;
        var B;
        (function(a) {
            function q(a) {
                return G.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, a);
            }
            function m() {
                u.translate.apply(this);
                const a = this;
                var h = a.options, g = a.chart;
                const e = a.points;
                var m = h.onSeries;
                const p = (m = m && g.get(m)) && m.options.step, q = m && m.points, t = g.inverted, f = a.xAxis, y = a.yAxis;
                g = e.length - 1;
                let r;
                h = h.onKey || "y";
                let l = q && q.length, v = 0, d, b, c, k;
                if (m && m.visible && l) {
                    v = (m.pointXOffset || 0) + (m.barW || 0) / 2;
                    var w = m.currentDataGrouping;
                    b = q[l - 1].x + (w ? w.totalRange : 0);
                    E(e, (a, b)=>a.x - b.x);
                    for(h = "plot" + h[0].toUpperCase() + h.substr(1); l-- && e[g] && !(d = q[l], w = e[g], w.y = d.y, d.x <= w.x && "undefined" !== typeof d[h] && (w.x <= b && (w.plotY = d[h], d.x < w.x && !p && (c = q[l + 1]) && "undefined" !== typeof c[h] && (k = (w.x - d.x) / (c.x - d.x), w.plotY += k * (c[h] - d[h]), w.y += k * (c.y - d.y))), g--, l++, 0 > g)););
                }
                e.forEach((b, c)=>{
                    let d;
                    b.plotX += v;
                    if ("undefined" === typeof b.plotY || t) 0 <= b.plotX && b.plotX <= f.len ? t ? (b.plotY = f.translate(b.x, 0, 1, 0, 1), b.plotX = D(b.y) ? y.translate(b.y, 0, 0, 0, 1) : 0) : b.plotY = (f.opposite ? 0 : a.yAxis.len) + f.offset : b.shapeArgs = {};
                    (r = e[c - 1]) && r.plotX === b.plotX && ("undefined" === typeof r.stackIndex && (r.stackIndex = 0), d = r.stackIndex + 1);
                    b.stackIndex = d;
                });
                this.onSeries = m;
            }
            const p = [];
            a.compose = function(a) {
                if (J.pushUnique(p, a)) {
                    const h = a.prototype;
                    h.getPlotBox = q;
                    h.translate = m;
                }
                return a;
            };
            a.getPlotBox = q;
            a.translate = m;
        })(B || (B = {}));
        return B;
    });
    L(a, "Series/Flags/FlagsSeries.js", [
        a["Series/Flags/FlagsPoint.js"],
        a["Series/Flags/FlagsSeriesDefaults.js"],
        a["Series/Flags/FlagsSymbols.js"],
        a["Core/Globals.js"],
        a["Series/OnSeriesComposition.js"],
        a["Core/Renderer/RendererUtilities.js"],
        a["Core/Series/SeriesRegistry.js"],
        a["Core/Renderer/SVG/SVGElement.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E, B, t) {
        ({ noop: K } = K);
        const { distribute: q } = D, { series: m, seriesTypes: { column: p } } = E, { addEvent: n, defined: h, extend: g, merge: e, objectEach: u, wrap: I } = t;
        class L extends p {
            constructor(){
                super(...arguments);
                this.points = this.options = this.data = void 0;
            }
            animate(a) {
                a && this.setClip();
            }
            drawPoints() {
                var a = this.points, f = this.chart;
                const g = f.renderer, m = f.inverted, l = this.options, n = l.y, d = this.yAxis, b = {}, c = [];
                let k, p;
                let t, x;
                let A, E, G;
                for(t = a.length; t--;){
                    x = a[t];
                    E = (m ? x.plotY : x.plotX) > this.xAxis.len;
                    k = x.plotX;
                    var D = x.stackIndex;
                    var J = x.options.shape || l.shape;
                    p = x.plotY;
                    "undefined" !== typeof p && (p = x.plotY + n - ("undefined" !== typeof D && D * l.stackDistance));
                    x.anchorX = D ? void 0 : x.plotX;
                    A = D ? void 0 : x.plotY;
                    G = "flag" !== J;
                    D = x.graphic;
                    "undefined" !== typeof p && 0 <= k && !E ? (D && x.hasNewShapeType() && (D = D.destroy()), D || (D = x.graphic = g.label("", null, null, J, null, null, l.useHTML).addClass("highcharts-point").add(this.markerGroup), x.graphic.div && (x.graphic.div.point = x), D.isNew = !0), D.attr({
                        align: G ? "center" : "left",
                        width: l.width,
                        height: l.height,
                        "text-align": l.textAlign
                    }), f.styledMode || D.attr(this.pointAttribs(x)).css(e(l.style, x.style)).shadow(l.shadow), 0 < k && (k -= D.strokeWidth() % 2), J = {
                        y: p,
                        anchorY: A
                    }, l.allowOverlapX && (J.x = k, J.anchorX = x.anchorX), D.attr({
                        text: x.options.title || l.title || "A"
                    })[D.isNew ? "attr" : "animate"](J), l.allowOverlapX || (b[x.plotX] ? b[x.plotX].size = Math.max(b[x.plotX].size, D.width) : b[x.plotX] = {
                        align: G ? .5 : 0,
                        size: D.width,
                        target: k,
                        anchorX: k
                    }), x.tooltipPos = [
                        k,
                        p + d.pos - f.plotTop
                    ]) : D && (x.graphic = D.destroy());
                }
                if (!l.allowOverlapX) {
                    let e = 100;
                    u(b, function(a) {
                        a.plotX = a.anchorX;
                        c.push(a);
                        e = Math.max(a.size, e);
                    });
                    q(c, m ? d.len : this.xAxis.len, e);
                    for (const c of a)f = c.plotX, (f = (a = c.graphic) && b[f]) && a && (h(f.pos) ? a[a.isNew ? "attr" : "animate"]({
                        x: f.pos + (f.align || 0) * f.size,
                        anchorX: c.anchorX
                    }).show().isNew = !1 : a.hide().isNew = !0);
                }
                l.useHTML && this.markerGroup && I(this.markerGroup, "on", function(a) {
                    return B.prototype.on.apply(a.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
                });
            }
            drawTracker() {
                const a = this.points;
                super.drawTracker();
                for (const e of a){
                    const f = e.graphic;
                    f && (e.unbindMouseOver && e.unbindMouseOver(), e.unbindMouseOver = n(f.element, "mouseover", function() {
                        0 < e.stackIndex && !e.raised && (e._y = f.y, f.attr({
                            y: e._y - 8
                        }), e.raised = !0);
                        for (const f of a)f !== e && f.raised && f.graphic && (f.graphic.attr({
                            y: f._y
                        }), f.raised = !1);
                    }));
                }
            }
            pointAttribs(a, e) {
                const f = this.options, g = a && a.color || this.color;
                let h = f.lineColor, m = a && a.lineWidth;
                a = a && a.fillColor || f.fillColor;
                e && (a = f.states[e].fillColor, h = f.states[e].lineColor, m = f.states[e].lineWidth);
                return {
                    fill: a || g,
                    stroke: h || g,
                    "stroke-width": m || f.lineWidth || 0
                };
            }
            setClip() {
                m.prototype.setClip.apply(this, arguments);
                !1 !== this.options.clip && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
            }
        }
        L.compose = J.compose;
        L.defaultOptions = e(p.defaultOptions, A);
        G.compose(L);
        g(L.prototype, {
            allowDG: !1,
            forceCrop: !0,
            invertible: !1,
            noSharedTooltip: !0,
            pointClass: a,
            sorted: !1,
            takeOrdinalPosition: !1,
            trackerGroups: [
                "markerGroup"
            ],
            buildKDTree: K,
            init: m.prototype.init
        });
        E.registerSeriesType("flags", L);
        "";
        return L;
    });
    L(a, "Core/Chart/StockChart.js", [
        a["Core/Axis/Axis.js"],
        a["Core/Chart/Chart.js"],
        a["Core/Templating.js"],
        a["Core/Defaults.js"],
        a["Stock/Navigator/NavigatorDefaults.js"],
        a["Stock/RangeSelector/RangeSelectorDefaults.js"],
        a["Stock/Scrollbar/ScrollbarDefaults.js"],
        a["Core/Series/Series.js"],
        a["Core/Renderer/SVG/SVGRenderer.js"],
        a["Core/Utilities.js"]
    ], function(a, A, J, K, G, D, E, B, t, q) {
        function m(a, b) {
            return "xAxis" === a ? {
                minPadding: 0,
                maxPadding: 0,
                overscroll: 0,
                ordinal: !0,
                title: {
                    text: null
                },
                labels: {
                    overflow: "justify"
                },
                showLastLabel: !0
            } : "yAxis" === a ? {
                labels: {
                    y: -2
                },
                opposite: r(b.opposite, !0),
                showLastLabel: !(!b.categories && "category" !== b.type),
                title: {
                    text: null
                }
            } : {};
        }
        function p(a, b) {
            return "xAxis" === a ? (a = {
                type: "datetime",
                categories: void 0
            }, r(b.navigator && b.navigator.enabled, G.enabled, !0) && (a.startOnTick = !1, a.endOnTick = !1), a) : {};
        }
        const { format: n } = J, { getOptions: h } = K, { addEvent: g, clamp: e, defined: u, extend: I, find: L, isNumber: C, isString: f, merge: y, pick: r, splat: l } = q;
        class v extends A {
            init(a, b) {
                const c = h(), d = a.xAxis, e = a.yAxis;
                var f = r(a.navigator && a.navigator.enabled, G.enabled, !0);
                a.xAxis = a.yAxis = void 0;
                f = y({
                    chart: {
                        panning: {
                            enabled: !0,
                            type: "x"
                        },
                        zooming: {
                            pinchType: "x"
                        }
                    },
                    navigator: {
                        enabled: f
                    },
                    scrollbar: {
                        enabled: r(E.enabled, !0)
                    },
                    rangeSelector: {
                        enabled: r(D.rangeSelector.enabled, !0)
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        split: r(c.tooltip.split, !0),
                        crosshairs: !0
                    },
                    legend: {
                        enabled: !1
                    }
                }, a, {
                    isStock: !0
                });
                a.xAxis = d;
                a.yAxis = e;
                f.xAxis = l(a.xAxis || {}).map(function(b, d) {
                    return y(m("xAxis", b), c.xAxis, c.xAxis && c.xAxis[d], b, p("xAxis", a));
                });
                f.yAxis = l(a.yAxis || {}).map(function(a, b) {
                    return y(m("yAxis", a), c.yAxis, c.yAxis && c.yAxis[b], a);
                });
                super.init(f, b);
            }
            createAxis(a, b) {
                b.axis = y(m(a, b.axis), b.axis, p(a, this.userOptions));
                return super.createAxis(a, b);
            }
        }
        (function(a) {
            a.stockChart = function(b, c, d) {
                return new a(b, c, d);
            };
        })(v || (v = {}));
        g(B, "setOptions", function(a) {
            let b;
            this.chart.options.isStock && (this.is("column") || this.is("columnrange") ? b = {
                borderWidth: 0,
                shadow: !1
            } : this.is("scatter") || this.is("sma") || (b = {
                marker: {
                    enabled: !1,
                    radius: 2
                }
            }), b && (a.plotOptions[this.type] = y(a.plotOptions[this.type], b)));
        });
        g(a, "autoLabelAlign", function(a) {
            const { chart: b, options: c } = this, d = b._labelPanes = b._labelPanes || {}, e = c.labels;
            if (b.options.isStock && "yAxis" === this.coll) {
                const b = c.top + "," + c.height;
                !d[b] && e.enabled && (15 === e.distance && 1 === this.side && (e.distance = 0), "undefined" === typeof e.align && (e.align = "right"), d[b] = this, a.align = "right", a.preventDefault());
            }
        });
        g(a, "destroy", function() {
            const a = this.chart, b = this.options && this.options.top + "," + this.options.height;
            b && a._labelPanes && a._labelPanes[b] === this && delete a._labelPanes[b];
        });
        g(a, "getPlotLinePath", function(a) {
            function b(a) {
                const b = "xAxis" === a ? "yAxis" : "xAxis";
                a = c.options[b];
                return C(a) ? [
                    g[b][a]
                ] : f(a) ? [
                    g.get(a)
                ] : d.map(function(a) {
                    return a[b];
                });
            }
            let c = this, d = this.isLinked && !this.series ? this.linkedParent.series : this.series, g = c.chart, h = g.renderer, l = c.left, m = c.top, n, p, q, t, v = [], x = [], y, A, B = a.translatedValue, D = a.value, E = a.force, G;
            if (g.options.isStock && !1 !== a.acrossPanes && "xAxis" === c.coll || "yAxis" === c.coll) a.preventDefault(), x = b(c.coll), y = c.isXAxis ? g.yAxis : g.xAxis, y.forEach(function(a) {
                if (u(a.options.id) ? -1 === a.options.id.indexOf("navigator") : 1) {
                    var b = a.isXAxis ? "yAxis" : "xAxis";
                    b = u(a.options[b]) ? g[b][a.options[b]] : g[b][0];
                    c === b && x.push(a);
                }
            }), A = x.length ? [] : [
                c.isXAxis ? g.yAxis[0] : g.xAxis[0]
            ], x.forEach(function(a) {
                -1 !== A.indexOf(a) || L(A, function(b) {
                    return b.pos === a.pos && b.len === a.len;
                }) || A.push(a);
            }), G = r(B, c.translate(D, void 0, void 0, a.old)), C(G) && (c.horiz ? A.forEach(function(a) {
                let b;
                p = a.pos;
                t = p + a.len;
                n = q = Math.round(G + c.transB);
                "pass" !== E && (n < l || n > l + c.width) && (E ? n = q = e(n, l, l + c.width) : b = !0);
                b || v.push([
                    "M",
                    n,
                    p
                ], [
                    "L",
                    q,
                    t
                ]);
            }) : A.forEach(function(a) {
                let b;
                n = a.pos;
                q = n + a.len;
                p = t = Math.round(m + c.height - G);
                "pass" !== E && (p < m || p > m + c.height) && (E ? p = t = e(p, m, m + c.height) : b = !0);
                b || v.push([
                    "M",
                    n,
                    p
                ], [
                    "L",
                    q,
                    t
                ]);
            })), a.path = 0 < v.length ? h.crispPolyLine(v, a.lineWidth || 1) : null;
        });
        t.prototype.crispPolyLine = function(a, b) {
            for(let c = 0; c < a.length; c += 2){
                const d = a[c], e = a[c + 1];
                d[1] === e[1] && (d[1] = e[1] = Math.round(d[1]) - b % 2 / 2);
                d[2] === e[2] && (d[2] = e[2] = Math.round(d[2]) + b % 2 / 2);
            }
            return a;
        };
        g(a, "afterHideCrosshair", function() {
            this.crossLabel && (this.crossLabel = this.crossLabel.hide());
        });
        g(a, "afterDrawCrosshair", function(a) {
            var b, c;
            if (this.crosshair && this.crosshair.label && this.crosshair.label.enabled && this.cross && C(this.min) && C(this.max)) {
                var d = this.chart, e = this.logarithmic, f = this.crosshair.label, g = this.horiz, h = this.opposite, l = this.left, m = this.top, p = this.width, q = this.crossLabel, t = f.format, u = "", v = "inside" === this.options.tickPosition, x = !1 !== this.crosshair.snap, y = 0, A = a.e || this.cross && this.cross.e;
                a = a.point;
                var B = this.min, D = this.max;
                e && (B = e.lin2log(B), D = e.lin2log(D));
                e = g ? "center" : h ? "right" === this.labelAlign ? "right" : "left" : "left" === this.labelAlign ? "left" : "center";
                q || (q = this.crossLabel = d.renderer.label("", 0, void 0, f.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (a && a.series ? a.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({
                    align: f.align || e,
                    padding: r(f.padding, 8),
                    r: r(f.borderRadius, 3),
                    zIndex: 2
                }).add(this.labelGroup), d.styledMode || q.attr({
                    fill: f.backgroundColor || a && a.series && a.series.color || "#666666",
                    stroke: f.borderColor || "",
                    "stroke-width": f.borderWidth || 0
                }).css(I({
                    color: "#ffffff",
                    fontWeight: "normal",
                    fontSize: "0.7em",
                    textAlign: "center"
                }, f.style || {})));
                g ? (p = x ? (a.plotX || 0) + l : A.chartX, m += h ? 0 : this.height) : (p = l + this.offset + (h ? p : 0), m = x ? (a.plotY || 0) + m : A.chartY);
                t || f.formatter || (this.dateTime && (u = "%b %d, %Y"), t = "{value" + (u ? ":" + u : "") + "}");
                u = x ? this.isXAxis ? a.x : a.y : this.toValue(g ? A.chartX : A.chartY);
                x = a && a.series ? a.series.isPointInside(a) : C(u) && u > B && u < D;
                A = "";
                t ? A = n(t, {
                    value: u
                }, d) : f.formatter && C(u) && (A = f.formatter.call(this, u));
                q.attr({
                    text: A,
                    x: p,
                    y: m,
                    visibility: x ? "inherit" : "hidden"
                });
                f = q.getBBox();
                !C(q.x) || g || h || (p = q.x - f.width / 2);
                if (C(q.y)) {
                    if (g) {
                        if (v && !h || !v && h) m = q.y - f.height;
                    } else m = q.y - f.height / 2;
                }
                g ? (b = l - f.x, c = l + this.width - f.x) : (b = "left" === this.labelAlign ? l : 0, c = "right" === this.labelAlign ? l + this.width : d.chartWidth);
                q.translateX < b && (y = b - q.translateX);
                q.translateX + f.width >= c && (y = -(q.translateX + f.width - c));
                q.attr({
                    x: p + y,
                    y: m,
                    anchorX: g ? p : this.opposite ? 0 : d.chartWidth,
                    anchorY: g ? this.opposite ? d.chartHeight : 0 : m + f.height / 2
                });
            }
        });
        B.prototype.forceCropping = function() {
            const a = this.chart, b = this.options.dataGrouping;
            return !1 !== this.allowDG && b && r(b.enabled, a.options.isStock);
        };
        g(A, "update", function(a) {
            a = a.options;
            "scrollbar" in a && this.navigator && (y(!0, this.options.scrollbar, a.scrollbar), this.navigator.update({}), delete a.scrollbar);
        });
        return v;
    });
    L(a, "masters/modules/stock.src.js", [
        a["Core/Globals.js"],
        a["Series/DataModifyComposition.js"],
        a["Stock/Navigator/Navigator.js"],
        a["Stock/RangeSelector/RangeSelector.js"],
        a["Stock/Scrollbar/Scrollbar.js"],
        a["Core/Axis/OrdinalAxis.js"],
        a["Series/OHLC/OHLCSeries.js"],
        a["Series/Flags/FlagsSeries.js"],
        a["Core/Chart/StockChart.js"]
    ], function(a, A, J, K, G, D, E, B, t) {
        a.Navigator = J;
        a.RangeSelector = K;
        a.Scrollbar = G;
        a.StockChart = a.stockChart = t.stockChart;
        A.compose(a.Series, a.Axis, a.Point);
        B.compose(a.Renderer);
        J.compose(a.Axis, a.Chart, a.Series);
        E.compose(a.Series);
        D.compose(a.Axis, a.Series, a.Chart);
        K.compose(a.Axis, a.Chart);
        G.compose(a.Axis);
    });
    L(a, "masters/highstock.src.js", [
        a["masters/highcharts.src.js"]
    ], function(a) {
        a.product = "Highstock";
        return a;
    });
    a["masters/highstock.src.js"]._modules = a;
    return a["masters/highstock.src.js"];
});




var $jR9u2 = parcelRequire("jR9u2");

var $exYeM = parcelRequire("exYeM");
var $852989f67c24e89f$exports = {};

$852989f67c24e89f$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "WevrLogoSecondary.c31fdafd.svg";



function $739b19ac50112b53$var$SimpleChart(props) {
    //   const { theme } = useContext(ThemeContext);
    var watermark = "";
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    var newStyle = document.createElement("style");
    newStyle.appendChild(document.createTextNode("@font-face {  font-family: 'Monda';  font-style: sans-serif;  font-weight: 400;  src: url('https://fonts.googleapis.com/css2?family=Monda&display=swap')  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}"));
    document.head.appendChild(newStyle);
    const dataSource = [
        {
            id: "first",
            name: props.name,
            data: props.data[0]?.values,
            color: "#FA9173",
            yAxis: 0,
            dataGrouping: {
                approximation: "average",
                enabled: true,
                forced: true,
                units: [
                    [
                        "day",
                        [
                            1
                        ]
                    ]
                ]
            }
        }
    ];
    const [chartOptions, setChartOptions] = (0, $exYeM.useState)({
        exporting: {
            enabled: false,
            enableImages: true
        },
        legend: {
            enabled: true,
            itemStyle: {
                // color: text,
                fontWeight: "bold"
            }
        },
        chart: {
            type: "spline",
            zoomType: "x",
            backgroundColor: "transparent",
            renderTo: this,
            style: {
                fontFamily: "Monda"
            },
            events: {
                load: function() {
                    var height_image = 100;
                    var width_image = 152;
                    // var height_image = 48;
                    // var width_image = 20;
                    var textX = this.plotLeft + this.plotWidth * 0.5;
                    var textY = this.plotTop + this.plotHeight * 0.5;
                    var position_x = textX - width_image / 2;
                    var position_y = textY - height_image / 2;
                    watermark = this.renderer.image((0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports))), position_x, position_y, 152, 100).add();
                },
                redraw: function() {
                    var height_image = 100;
                    var width_image = 152;
                    // var height_image = 48;
                    // var width_image = 20;
                    var textX = this.plotLeft + this.plotWidth * 0.5;
                    var textY = this.plotTop + this.plotHeight * 0.5;
                    var position_x = textX - width_image / 2;
                    var position_y = textY - height_image / 2;
                    watermark.attr({
                        x: position_x,
                        y: position_y
                    });
                }
            }
        },
        scrollbar: {
            enabled: false
        },
        xAxis: {
            labels: {
                style: {
                    fontSize: "13px"
                }
            }
        },
        yAxis: {
            opposite: false,
            labels: {
                style: {
                    fontSize: "13px"
                }
            }
        },
        series: dataSource,
        credits: {
            enabled: false
        },
        navigator: {
            maskFill: "rgba(250, 145, 115, 0.35)"
        },
        rangeSelector: {
            enabled: false
        },
        tooltip: {
            useHTML: true,
            formatter: function() {
                return this.points.reduce(function(s, point) {
                    return s + "<br/> <div>" + '<span style="color:' + point.color + '"> <b>' + point.series.name + ": " + "</b> </span>" + "<span>" + point.y + "</span>";
                }, "<b>" + (0, (/*@__PURE__*/$parcel$interopDefault($jR9u2))).unix(this.x / 1000).format("ddd, DD, HH:mm:ss") + "</b>");
            },
            valueDecimals: 0,
            borderColor: "#FA9173",
            borderRadius: 8,
            borderWidth: 1
        },
        accessibility: {
            enabled: false
        }
    });
    const chartRef = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(()=>{
        setChartOptions({
            series: dataSource
        });
        window.dispatchEvent(new Event("resize"));
    }, []);
    (0, $exYeM.useEffect)(()=>{
        window.dispatchEvent(new Event("resize"));
    }, [
        props.sidebar
    ]);
    (0, $exYeM.useEffect)(()=>{
        var updated = {
            id: "first",
            name: props.name,
            data: props.data[0]?.values,
            color: "#FA9173",
            yAxis: 0,
            dataGrouping: {
                approximation: "average",
                enabled: true,
                forced: true,
                units: [
                    [
                        "day",
                        [
                            1
                        ]
                    ]
                ]
            }
        };
        dataSource.splice(0, 1, updated);
        setChartOptions({
            series: dataSource
        });
    }, [
        searchParams.get("blockchain")
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "relative w-full z-0",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "z-10 h-full w-full",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
                containerProps: {
                    style: {
                        width: "100%",
                        height: "100%"
                    }
                },
                highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))),
                constructorType: "stockChart",
                options: chartOptions,
                ref: chartRef
            })
        })
    });
}
var // className="h-1/3 md:h-1/2 xl:h-36"
$739b19ac50112b53$export$2e2bcd8739ae039 = $739b19ac50112b53$var$SimpleChart;



// created by James Launder
// provides a surround for the small chart w/ chart name and percentage change

var $aSiaI = parcelRequire("aSiaI");
// created by James Launder
// small and simple chart used for the small dashboard charts.

var $aSiaI = parcelRequire("aSiaI");



var $exYeM = parcelRequire("exYeM");

function $ac0c0d6227a9c899$var$SmallChart(props) {
    //   const { theme } = useContext(ThemeContext);
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    var newStyle = document.createElement("style");
    newStyle.appendChild(document.createTextNode("@font-face {  font-family: 'Monda';  font-style: sans-serif;  font-weight: 400;  src: url('https://fonts.googleapis.com/css2?family=Monda&display=swap')  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}"));
    document.head.appendChild(newStyle);
    const dataSource = [
        {
            name: props.name,
            data: props.data[0]?.values,
            color: "#FA9173",
            backgroundColor: "transparent",
            animation: false,
            lineWidth: 1,
            shadow: false,
            states: {
                hover: {
                    lineWidth: 1
                }
            },
            marker: {
                radius: 1,
                states: {
                    hover: {
                        radius: 2
                    }
                }
            },
            fillOpacity: 0.25
        }
    ];
    const [options, setChartOptions] = (0, $exYeM.useState)({
        exporting: {
            enabled: false,
            enableImages: true
        },
        chart: {
            type: "area",
            backgroundColor: "transparent"
        },
        title: {
            text: ""
        },
        xAxis: {
            visible: false,
            type: "datetime"
        },
        yAxis: {
            visible: false
        },
        legend: {
            enabled: false
        },
        series: dataSource,
        credits: {
            enabled: false
        },
        accessibility: {
            enabled: false
        }
    });
    (0, $exYeM.useEffect)(()=>{
        setChartOptions({
            series: dataSource
        });
        window.dispatchEvent(new Event("resize"));
    }, []);
    (0, $exYeM.useEffect)(()=>{
        var updated = {
            name: props.name,
            data: props.data[0]?.values,
            color: "#FA9173",
            backgroundColor: "transparent",
            animation: false,
            lineWidth: 1,
            shadow: false,
            states: {
                hover: {
                    lineWidth: 1
                }
            },
            marker: {
                radius: 1,
                states: {
                    hover: {
                        radius: 2
                    }
                }
            },
            fillOpacity: 0.25
        };
        dataSource.splice(0, 1, updated);
        setChartOptions({
            series: dataSource
        });
    }, [
        searchParams.get("blockchain")
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
        highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($bdf625fc24abd869$exports))),
        containerProps: {
            style: {
                height: props.height
            }
        },
        options: options
    });
}
var $ac0c0d6227a9c899$export$2e2bcd8739ae039 = $ac0c0d6227a9c899$var$SmallChart;


function $f1b190dd39de0d37$var$SmallChartContainer(props) {
    const colour = (first, last)=>{
        if (first > last) return false;
        return true;
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col divide-y w-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "text-center font-bold font-roboto px-3 py-2",
                children: props.graphName
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ac0c0d6227a9c899$export$2e2bcd8739ae039), {
                    data: props.smallChartData,
                    name: props.graphName,
                    height: props.graphHeight,
                    width: props.graphWidth
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex justify-around py-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                        className: "flex flex-row text-center align-baseline px-3 py-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "font-roboto align-baseline mb-[0.5] text-sm",
                                children: [
                                    props.timePeriod,
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: `${colour(props.smallChartData[0]?.values.slice(-1)[0][1], props.smallChartData[0]?.values.slice(0)[0][1]) ? "text-green-600" : "text-red-600"} font-monda font-bold align-baseline text-sm`,
                                children: [
                                    ((props.smallChartData[0]?.values.slice(0)[0][1] - props.smallChartData[0]?.values.slice(-1)[0][1]) / props.smallChartData[0]?.values.slice(0)[0][1] * 100).toFixed(1),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                        className: "flex flex-row text-center align-baseline px-3 py-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "font-roboto  align-baseline mb-[0.5] text-sm",
                                children: [
                                    "Last:",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda font-bold align-baseline text-sm",
                                children: props.smallChartData[0]?.values.slice(0)[0][1].toLocaleString("en-US", {
                                    maximumFractionDigits: 2
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $f1b190dd39de0d37$export$2e2bcd8739ae039 = $f1b190dd39de0d37$var$SmallChartContainer;


// created by James Launder
// simple ui to fill a bar based on percentage
// also changes colour based on fill

var $aSiaI = parcelRequire("aSiaI");
const $c904cb26bc87c9e1$var$SentimentBar = ({ value: value })=>{
    // var newValue;
    function calculateNewValue(value) {
        return (value + 5) * 10;
    }
    function calculateColor(value) {
        if (value == -5) return "bg-red-500";
        else if (value <= -2) return "bg-orange-500";
        else if (value < 2) return "bg-yellow-500";
        else if (value < 5) return "bg-lime-500";
        else return "bg-green-500";
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "h-2 w-full bg-gray-300 rounded-xl",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            style: {
                width: `${calculateNewValue(value)}%`
            },
            className: `h-full rounded-xl ${calculateColor(value)}`
        })
    });
};
var $c904cb26bc87c9e1$export$2e2bcd8739ae039 = $c904cb26bc87c9e1$var$SentimentBar;






function $19e795ce95df11a3$export$2e2bcd8739ae039() {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, data: data } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            searchParams.get("blockchain"),
            "dashboard"
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/staticDash/" + searchParams.get("blockchain")).catch(function(error) {
                return error.response;
            });
            return data;
        },
        staleTime: 1000
    });
    return {
        isLoading: isLoading,
        isError: isError,
        isFetching: isFetching,
        data: data
    };
}



var $aSiaI = parcelRequire("aSiaI");

var $0c5f86c746bdc3a3$exports = {};
!function(t, e) {
    $0c5f86c746bdc3a3$exports = e();
}($0c5f86c746bdc3a3$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


function $f800f3beb5ae88ff$export$2e2bcd8739ae039(props) {
    function calculateText(value) {
        if (value == -5) return "Terrible";
        else if (value <= -2) return "Poor";
        else if (value < 2) return "Neutral";
        else if (value < 5) return "Good";
        else return "Excellent";
    }
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
        href: props.data.link,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "grid grid-rows-7 h-fit bg-surface p-4 rounded-md gap-1 border border-surfaceVariant shadow-sm",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "row-span-2 flex flex-col flex-1 justify-between pb-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex items-center text-md xl:text-xs font-semibold text-gray-900",
                        children: props.data.title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex justify-between pt-[0.5]",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-md xl:text-xs text-gray-600",
                                children: props.data.author
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-md xl:text-xs text-gray-600",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(props.data.published * 1000).format("MM/DD/YYYY")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "row-span-4 flex justify-center my-auto relative mx-auto rounded-lg overflow-hidden",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                    src: props.data?.media_content != undefined ? props.data?.media_content[0]["url"] : "",
                    alt: "",
                    className: "object-fill h-52 xl:h-36"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "row-span-1 flex flex-col justify-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex gap-1 text-gray-600",
                        children: [
                            "Sentiment:",
                            " ",
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-gray-600",
                                children: calculateText(props.data.Sentiment)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c904cb26bc87c9e1$export$2e2bcd8739ae039), {
                        value: props.data.Sentiment
                    })
                ]
            })
        ]
    }, props.data.title);
}


// loops through and finds the average sentiment
function $43140a09af1520b8$var$overallSentiment(data) {
    var overall = 0;
    data.forEach(function(value) {
        overall = overall + value.Sentiment;
    });
    return overall / data.length;
}
function $43140a09af1520b8$var$ChartingDashBoard(props) {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, data: data } = (0, $19e795ce95df11a3$export$2e2bcd8739ae039)();
    // all dashboard data query
    if (isLoading || isFetching) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full p-4 bg-surface",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: " grid grid-cols-1 lg:grid-cols-12 mb-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "grid col-span-8 p-4  mr-4 bg-gray-200 animate-pulse rounded-md border border-onSurfaceVariant ",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "min-h-[55vh] bg-gray-200 rounded-xl animate-pulse flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8af33ef04486b7$exports))),
                                alt: "...",
                                className: "h-20 md:h-28 pl-14"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "grid place-content-around bg-gray-200 animate-pulse p-4 col-span-4 rounded-md border border-onSurfaceVariant"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-full bg-gray-200 rounded-md animate-pulse border border-onSurfaceVariant flex justify-around py-4  min-h-[25vh] mt-4"
            })
        ]
    });
    if (isError) return /*#__PURE__*/ (0, $aSiaI.jsx)("main", {
        className: "grid w-full place-items-center py-24 px-6 sm:py-32 lg:px-8 font-roboto bg-surface",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "text-2xl font-semibold text-primary",
                    children: "404"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                    className: "mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                    children: "Error"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "mt-6 text-base leading-7 text-gray-600",
                    children: "Sorry, we couldn\u2019t find the page you\u2019re looking for."
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "mt-6 flex items-center justify-center gap-x-6",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        onClick: ()=>{
                            navigate("/");
                        },
                        className: "rounded-lg bg-primaryContainer px-3 py-2 text-sm font-semibold text-black shadow-sm hover:text-white hover:bg-primary",
                        children: "Go back home"
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "p-4 w-full bg-surface",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: " grid grid-cols-1 gap-4 xl:gap-0 xl:grid-cols-12 mb-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex flex-col p-1 xl:col-span-7 2xl:col-span-8 lg:mr-4 rounded-md border border-surfaceVariant bg-white shadow-md",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: " bg-white rounded-md py-2 px-1 pr-4 divide-y relative h-full",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "flex justify-center font-roboto text-lg sm:text-2xl font-semibold py-4",
                                    children: data.data.mainChart.mainGraphNames.name
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "flex grow xl:relative xl:h-4/5",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $739b19ac50112b53$export$2e2bcd8739ae039), {
                                        data: data.data.mainChart.mainGraphData,
                                        name: data.data.mainChart.mainGraphNames.name,
                                        sidebar: props.sidebar
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "text-sm sm:text-lg p-1",
                                    children: data.data.mainChart.mainGraphNames.description
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex-col p-4 space-y-4 xl:col-span-5 2xl:col-span-4 rounded-md border border-surfaceVariant shadow-md",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "bg-white rounded-md border-b border-surfaceVariant",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center p-2 gap-6 pr-4",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            children: "Overall Sentiment:"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c904cb26bc87c9e1$export$2e2bcd8739ae039), {
                                            value: $43140a09af1520b8$var$overallSentiment(data.data.news)
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 gap-4",
                                children: data.data?.news?.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f800f3beb5ae88ff$export$2e2bcd8739ae039), {
                                        data: data
                                    }, data.link))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid grid-cols-1 items-center md:grid-cols-2 xl:grid-cols-4 border border-surfaceVariant p-2 rounded-md shadow-md bg-white",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "justify-center flex flex-col items-center px-2 border-b border-surfaceVariant xl:border-r",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f1b190dd39de0d37$export$2e2bcd8739ae039), {
                            graphName: data.data.smallCharts.smallChart1.smallGraphNames1.name,
                            smallChartData: data.data.smallCharts.smallChart1.smallGraphData1,
                            timePeriod: "14d",
                            graphHeight: "10vh"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "justify-center flex flex-col items-center px-2 border-b border-surfaceVariant xl:border-r",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f1b190dd39de0d37$export$2e2bcd8739ae039), {
                            graphName: data.data.smallCharts.smallChart2.smallGraphNames2.name,
                            smallChartData: data.data.smallCharts.smallChart2.smallGraphData2,
                            timePeriod: "14d",
                            graphHeight: "10vh"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "justify-center flex flex-col items-center px-2 border-b border-surfaceVariant md:border-none",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f1b190dd39de0d37$export$2e2bcd8739ae039), {
                            graphName: data.data.smallCharts.smallChart3.smallGraphNames3.name,
                            smallChartData: data.data.smallCharts.smallChart3.smallGraphData3,
                            timePeriod: "14d",
                            graphHeight: "10vh"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "justify-center flex flex-col items-center px-2 xl:border-l xl:border-surfaceVariant",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f1b190dd39de0d37$export$2e2bcd8739ae039), {
                            graphName: data.data.smallCharts.smallChart4.smallGraphNames4.name,
                            smallChartData: data.data.smallCharts.smallChart4.smallGraphData4,
                            timePeriod: "14d",
                            graphHeight: "10vh"
                        })
                    })
                ]
            })
        ]
    });
}
var $43140a09af1520b8$export$2e2bcd8739ae039 = $43140a09af1520b8$var$ChartingDashBoard;


/// Created by James Launder
// contains the query state that hold all the data for the charts

var $aSiaI = parcelRequire("aSiaI");


var $exYeM = parcelRequire("exYeM");
// Created by James Launder

var $aSiaI = parcelRequire("aSiaI");



function $0edff4a12d1a07f6$export$2e2bcd8739ae039() {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, data: queryData } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "data-names-" + searchParams.get("blockchain")
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/stores/" + searchParams.get("blockchain")).catch(function(error) {
                return error.response;
            });
            return data;
        },
        staleTime: Infinity
    });
    var name = "";
    var description = "";
    var dataSource = "";
    var sources = "";
    var resolution = "";
    if (searchParams.get("name") && (!isLoading || !isFetching)) {
        name = searchParams.get("name");
        const firstLoadValues = queryData?.data?.graphNames.find((key)=>key.name === searchParams.get("name"));
        if (!firstLoadValues) {
            description = "Error";
            resolution = "Error";
            dataSource = "Error";
        } else {
            description = firstLoadValues.description;
            resolution = firstLoadValues.resolution;
            dataSource = firstLoadValues.dataSource;
            sources = firstLoadValues.sources;
        }
    }
    return {
        isLoading: isLoading,
        isError: isError,
        isFetching: isFetching,
        queryData: queryData,
        name: name,
        description: description,
        resolution: resolution,
        dataSource: dataSource,
        sources: sources
    };
}


// shows the description text
function $13a0509bfb2c028b$var$ChartFooter() {
    const { description: description } = (0, $0edff4a12d1a07f6$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "pb-6 mx-8 py-2 font-roboto border-t border-secondary text-center",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
            children: description
        })
    });
}
var $13a0509bfb2c028b$export$2e2bcd8739ae039 = $13a0509bfb2c028b$var$ChartFooter;


// created by James Launder
// contains the chart name and share function
// also used as a part of the full screen and screenshot functions

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $f92085fcc4c2f012$var$ArrowsPointingOutIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M15 3.75a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0V5.56l-3.97 3.97a.75.75 0 11-1.06-1.06l3.97-3.97h-2.69a.75.75 0 01-.75-.75zm-12 0A.75.75 0 013.75 3h4.5a.75.75 0 010 1.5H5.56l3.97 3.97a.75.75 0 01-1.06 1.06L4.5 5.56v2.69a.75.75 0 01-1.5 0v-4.5zm11.47 11.78a.75.75 0 111.06-1.06l3.97 3.97v-2.69a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75h-4.5a.75.75 0 010-1.5h2.69l-3.97-3.97zm-4.94-1.06a.75.75 0 010 1.06L5.56 19.5h2.69a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v2.69l3.97-3.97a.75.75 0 011.06 0z",
        clipRule: "evenodd"
    }));
}
const $f92085fcc4c2f012$var$ForwardRef = $exYeM.forwardRef($f92085fcc4c2f012$var$ArrowsPointingOutIcon);
var $f92085fcc4c2f012$export$2e2bcd8739ae039 = $f92085fcc4c2f012$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $182dde3ef17cc6ab$var$BellAlertIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z"
    }), /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z",
        clipRule: "evenodd"
    }));
}
const $182dde3ef17cc6ab$var$ForwardRef = $exYeM.forwardRef($182dde3ef17cc6ab$var$BellAlertIcon);
var $182dde3ef17cc6ab$export$2e2bcd8739ae039 = $182dde3ef17cc6ab$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $7945723c9bf4c650$var$ClipboardIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M10.5 3A1.501 1.501 0 009 4.5h6A1.5 1.5 0 0013.5 3h-3zm-2.693.178A3 3 0 0110.5 1.5h3a3 3 0 012.694 1.678c.497.042.992.092 1.486.15 1.497.173 2.57 1.46 2.57 2.929V19.5a3 3 0 01-3 3H6.75a3 3 0 01-3-3V6.257c0-1.47 1.073-2.756 2.57-2.93.493-.057.989-.107 1.487-.15z",
        clipRule: "evenodd"
    }));
}
const $7945723c9bf4c650$var$ForwardRef = $exYeM.forwardRef($7945723c9bf4c650$var$ClipboardIcon);
var $7945723c9bf4c650$export$2e2bcd8739ae039 = $7945723c9bf4c650$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $2ee5a7f7ec060e3f$var$EllipsisHorizontalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
        clipRule: "evenodd"
    }));
}
const $2ee5a7f7ec060e3f$var$ForwardRef = $exYeM.forwardRef($2ee5a7f7ec060e3f$var$EllipsisHorizontalIcon);
var $2ee5a7f7ec060e3f$export$2e2bcd8739ae039 = $2ee5a7f7ec060e3f$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $304e847142aae143$var$ShareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M15.75 4.5a3 3 0 11.825 2.066l-8.421 4.679a3.002 3.002 0 010 1.51l8.421 4.679a3 3 0 11-.729 1.31l-8.421-4.678a3 3 0 110-4.132l8.421-4.679a3 3 0 01-.096-.755z",
        clipRule: "evenodd"
    }));
}
const $304e847142aae143$var$ForwardRef = $exYeM.forwardRef($304e847142aae143$var$ShareIcon);
var $304e847142aae143$export$2e2bcd8739ae039 = $304e847142aae143$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $e1b0604a14fc433e$var$StarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z",
        clipRule: "evenodd"
    }));
}
const $e1b0604a14fc433e$var$ForwardRef = $exYeM.forwardRef($e1b0604a14fc433e$var$StarIcon);
var $e1b0604a14fc433e$export$2e2bcd8739ae039 = $e1b0604a14fc433e$var$ForwardRef;



var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");



var $8461bf68a681c36b$var$o;
let $8461bf68a681c36b$export$f680877a34711e37 = ($8461bf68a681c36b$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useId) != null ? $8461bf68a681c36b$var$o : function() {
    let n = (0, $eea6929722880e02$export$44ab2b9f2d09b0fa)(), [e, u] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(n ? ()=>(0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).nextId() : null);
    return (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        e === null && u((0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};


var $58dbca9ad58e6a75$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($58dbca9ad58e6a75$export$4b0075e5ea5e1f26 || {});


function $b762bd1946006453$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $b762bd1946006453$var$i(l) ? !1 : t;
}
function $b762bd1946006453$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}





function $a54eed888c938856$export$b204af158042fbac(r) {
    return (0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}


let $2786c78eeb568d2b$var$c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $2786c78eeb568d2b$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))($2786c78eeb568d2b$export$807a7eae502106e7 || {}), $2786c78eeb568d2b$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($2786c78eeb568d2b$export$abf286375dfa6dbd || {}), $2786c78eeb568d2b$var$F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($2786c78eeb568d2b$var$F || {});
function $2786c78eeb568d2b$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($2786c78eeb568d2b$var$c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $2786c78eeb568d2b$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($2786c78eeb568d2b$export$27112a34f2f8402d || {});
function $2786c78eeb568d2b$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $a54eed888c938856$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($2786c78eeb568d2b$var$c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($2786c78eeb568d2b$var$c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $2786c78eeb568d2b$export$46388676ec35ab85(e) {
    let r = (0, $a54eed888c938856$export$b204af158042fbac)(e);
    (0, $fb27e053aa71d13a$export$12b26c28a05aa001)().nextFrame(()=>{
        r && !$2786c78eeb568d2b$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $2786c78eeb568d2b$export$5fed9cc43865dc7e(e);
    });
}
var $2786c78eeb568d2b$var$w = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($2786c78eeb568d2b$var$w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $2786c78eeb568d2b$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $2786c78eeb568d2b$var$S = [
    "textarea",
    "input"
].join(",");
function $2786c78eeb568d2b$var$H(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $2786c78eeb568d2b$var$S)) != null ? t : !1;
}
function $2786c78eeb568d2b$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $2786c78eeb568d2b$export$7fb6c844b485e870(e, r) {
    return $2786c78eeb568d2b$export$82e1f4f412218a1d($2786c78eeb568d2b$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $2786c78eeb568d2b$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? $2786c78eeb568d2b$export$20305e96f91bf103(e) : e : $2786c78eeb568d2b$export$433aaa1f216cf32d(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let E = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = r & 32 ? {
        preventScroll: !0
    } : {}, d = 0, a = n.length, u;
    do {
        if (d >= a || d + a <= 0) return 0;
        let s = x + d;
        if (r & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = n[s], u == null || u.focus(p), d += E;
    }while (u !== i.activeElement);
    return r & 6 && $2786c78eeb568d2b$var$H(u) && u.select(), 2;
}




var $exYeM = parcelRequire("exYeM");

function $5848675429035810$var$i(t) {
    var n;
    if (t.type) return t.type;
    let e = (n = t.as) != null ? n : "button";
    if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function $5848675429035810$export$53652b2b272efe9c(t, e) {
    let [n, u] = (0, $exYeM.useState)(()=>$5848675429035810$var$i(t));
    return (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        u($5848675429035810$var$i(t));
    }, [
        t.type,
        t.as
    ]), (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
    }, [
        n,
        e
    ]), n;
}



var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

function $f51a1be7374b4363$export$55d2b5df396a097b(e, r, n) {
    let o = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(r);
    (0, $exYeM.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}



var $exYeM = parcelRequire("exYeM");

function $b0bc3aac5b9fb07d$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(r);
    (0, $exYeM.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}


function $ff220859d927474a$export$71b2224f1ce5e08e(s, m, a = !0) {
    let i = (0, $exYeM.useRef)(!1);
    (0, $exYeM.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = a;
        });
    }, [
        a
    ]);
    function c(e, r) {
        if (!i.current || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
        let E = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(s);
        for (let u of E){
            if (u === null) continue;
            let n = u instanceof HTMLElement ? u : u.current;
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, $2786c78eeb568d2b$export$ff1ec1c740b3c8d5)(t, (0, $2786c78eeb568d2b$export$27112a34f2f8402d).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let o = (0, $exYeM.useRef)(null);
    (0, $f51a1be7374b4363$export$55d2b5df396a097b)("pointerdown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $f51a1be7374b4363$export$55d2b5df396a097b)("mousedown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $f51a1be7374b4363$export$55d2b5df396a097b)("click", (e)=>{
        o.current && (c(e, ()=>o.current), o.current = null);
    }, !0), (0, $f51a1be7374b4363$export$55d2b5df396a097b)("touchend", (e)=>c(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, $b0bc3aac5b9fb07d$export$ee579bb285b8d4aa)("blur", (e)=>c(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}




var $exYeM = parcelRequire("exYeM");

function $1a8daf5097665e62$export$dd9fbcea3de0ae36(...e) {
    return (0, $exYeM.useMemo)(()=>(0, $a54eed888c938856$export$b204af158042fbac)(...e), [
        ...e
    ]);
}



var $exYeM = parcelRequire("exYeM");

function $b3d7b11c4d9c7c80$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(a);
    (0, $exYeM.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}



let $3faa7861657f1c89$var$a = "div";
var $3faa7861657f1c89$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($3faa7861657f1c89$export$617d79dae526d2cf || {});
function $3faa7861657f1c89$var$s(t, o) {
    let { features: n = 1, ...e } = t, d = {
        ref: o,
        "aria-hidden": (n & 2) === 2 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(n & 4) === 4 && (n & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: e,
        slot: {},
        defaultTag: $3faa7861657f1c89$var$a,
        name: "Hidden"
    });
}
let $3faa7861657f1c89$export$8dc98ba7eadeaa56 = (0, $6da0b689c34972b7$export$e43f39796049410c)($3faa7861657f1c89$var$s);




var $exYeM = parcelRequire("exYeM");

var $58388cb581937808$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($58388cb581937808$export$cacd6541cfeeb6c1 || {});
function $58388cb581937808$export$19b797546aece48f() {
    let e = (0, $exYeM.useRef)(0);
    return (0, $b0bc3aac5b9fb07d$export$ee579bb285b8d4aa)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}






var $exYeM = parcelRequire("exYeM");



function $0eb2c86c668abd7e$export$445f2d1a3d9b1b9f({ defaultContainers: t = [], portals: r, mainTreeNodeRef: u } = {}) {
    var c;
    let o = (0, $exYeM.useRef)((c = u == null ? void 0 : u.current) != null ? c : null), l = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)(o), f = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        var i;
        let n = [];
        for (let e of t)e !== null && (e instanceof HTMLElement ? n.push(e) : "current" in e && e.current instanceof HTMLElement && n.push(e.current));
        if (r != null && r.current) for (let e of r.current)n.push(e);
        for (let e of (i = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(o.current) || n.some((T)=>e.contains(T)) || n.push(e));
        return n;
    });
    return {
        resolveContainers: f,
        contains: (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((n)=>f().some((i)=>i.contains(n))),
        mainTreeNodeRef: o,
        MainTreeNode: (0, $exYeM.useMemo)(()=>function() {
                return u != null ? null : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
                    features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Hidden,
                    ref: o
                });
            }, [
            o,
            u
        ])
    };
}
function $0eb2c86c668abd7e$export$64db24433d7f4942() {
    let t = (0, $exYeM.useRef)(null);
    return {
        mainTreeNodeRef: t,
        MainTreeNode: (0, $exYeM.useMemo)(()=>function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
                    features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Hidden,
                    ref: t
                });
            }, [
            t
        ])
    };
}



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");



var $exYeM = parcelRequire("exYeM");
let $c6396520159f7ecb$var$e = (0, $exYeM.createContext)(!1);
function $c6396520159f7ecb$export$6ecd3efa4eebe261() {
    return (0, $exYeM.useContext)($c6396520159f7ecb$var$e);
}
function $c6396520159f7ecb$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c6396520159f7ecb$var$e.Provider, {
        value: o.force
    }, o.children);
}





var $exYeM = parcelRequire("exYeM");


function $3a259e27b8b85809$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(t), e = (0, $exYeM.useRef)(!1);
    (0, $exYeM.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $92b943bceaf40d00$export$a5ff0d6a738703ca)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}





function $2a4cc9a7be671cc4$var$F(p) {
    let l = (0, $c6396520159f7ecb$export$6ecd3efa4eebe261)(), n = (0, $exYeM.useContext)($2a4cc9a7be671cc4$var$v), e = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)(p), [a, o] = (0, $exYeM.useState)(()=>{
        if (!l && n !== null || (0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let r = e.createElement("div");
        return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
    return (0, $exYeM.useEffect)(()=>{
        a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
    }, [
        a,
        e
    ]), (0, $exYeM.useEffect)(()=>{
        l || n !== null && o(n.current);
    }, [
        n,
        o,
        l
    ]), a;
}
let $2a4cc9a7be671cc4$var$U = (0, $exYeM.Fragment);
function $2a4cc9a7be671cc4$var$N(p, l) {
    let n = p, e = (0, $exYeM.useRef)(null), a = (0, $b45ba282b8330326$export$f6a25a78204acc7e)((0, $b45ba282b8330326$export$7029785b750eb74)((u)=>{
        e.current = u;
    }), l), o = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)(e), t = $2a4cc9a7be671cc4$var$F(e), [r] = (0, $exYeM.useState)(()=>{
        var u;
        return (0, $206745f75df36d9f$export$a7b6bc01c63cdfc3).isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }), i = (0, $exYeM.useContext)($2a4cc9a7be671cc4$var$f), C = (0, $eea6929722880e02$export$44ab2b9f2d09b0fa)();
    return (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
    }, [
        t,
        r
    ]), (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        if (r && i) return i.register(r);
    }, [
        i,
        r
    ]), (0, $3a259e27b8b85809$export$cd059ee7fd0e9f3d)(()=>{
        var u;
        !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
    }), C ? !t || !r ? null : (0, $d2lNW.createPortal)((0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a
        },
        theirProps: n,
        defaultTag: $2a4cc9a7be671cc4$var$U,
        name: "Portal"
    }), r) : null;
}
let $2a4cc9a7be671cc4$var$S = (0, $exYeM.Fragment), $2a4cc9a7be671cc4$var$v = (0, $exYeM.createContext)(null);
function $2a4cc9a7be671cc4$var$j(p, l) {
    let { target: n, ...e } = p, o = {
        ref: (0, $b45ba282b8330326$export$f6a25a78204acc7e)(l)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($2a4cc9a7be671cc4$var$v.Provider, {
        value: n
    }, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: e,
        defaultTag: $2a4cc9a7be671cc4$var$S,
        name: "Popover.Group"
    }));
}
let $2a4cc9a7be671cc4$var$f = (0, $exYeM.createContext)(null);
function $2a4cc9a7be671cc4$export$26b8c35244a70b37() {
    let p = (0, $exYeM.useContext)($2a4cc9a7be671cc4$var$f), l = (0, $exYeM.useRef)([]), n = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((o)=>(l.current.push(o), p && p.register(o), ()=>e(o))), e = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((o)=>{
        let t = l.current.indexOf(o);
        t !== -1 && l.current.splice(t, 1), p && p.unregister(o);
    }), a = (0, $exYeM.useMemo)(()=>({
            register: n,
            unregister: e,
            portals: l
        }), [
        n,
        e,
        l
    ]);
    return [
        l,
        (0, $exYeM.useMemo)(()=>function({ children: t }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($2a4cc9a7be671cc4$var$f.Provider, {
                    value: a
                }, t);
            }, [
            a
        ])
    ];
}
let $2a4cc9a7be671cc4$var$D = (0, $6da0b689c34972b7$export$e43f39796049410c)($2a4cc9a7be671cc4$var$N), $2a4cc9a7be671cc4$var$I = (0, $6da0b689c34972b7$export$e43f39796049410c)($2a4cc9a7be671cc4$var$j), $2a4cc9a7be671cc4$export$602eac185826482c = Object.assign($2a4cc9a7be671cc4$var$D, {
    Group: $2a4cc9a7be671cc4$var$I
});


var $9838f5ac37ea1370$var$he = ((u)=>(u[u.Open = 0] = "Open", u[u.Closed = 1] = "Closed", u))($9838f5ac37ea1370$var$he || {}), $9838f5ac37ea1370$var$He = ((e)=>(e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))($9838f5ac37ea1370$var$He || {});
let $9838f5ac37ea1370$var$_e = {
    [0]: (t)=>{
        let o = {
            ...t,
            popoverState: (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(t.popoverState, {
                [0]: 1,
                [1]: 0
            })
        };
        return o.popoverState === 0 && (o.__demoMode = !1), o;
    },
    [1] (t) {
        return t.popoverState === 1 ? t : {
            ...t,
            popoverState: 1
        };
    },
    [2] (t, o) {
        return t.button === o.button ? t : {
            ...t,
            button: o.button
        };
    },
    [3] (t, o) {
        return t.buttonId === o.buttonId ? t : {
            ...t,
            buttonId: o.buttonId
        };
    },
    [4] (t, o) {
        return t.panel === o.panel ? t : {
            ...t,
            panel: o.panel
        };
    },
    [5] (t, o) {
        return t.panelId === o.panelId ? t : {
            ...t,
            panelId: o.panelId
        };
    }
}, $9838f5ac37ea1370$var$ue = (0, $exYeM.createContext)(null);
$9838f5ac37ea1370$var$ue.displayName = "PopoverContext";
function $9838f5ac37ea1370$var$oe(t) {
    let o = (0, $exYeM.useContext)($9838f5ac37ea1370$var$ue);
    if (o === null) {
        let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(u, $9838f5ac37ea1370$var$oe), u;
    }
    return o;
}
let $9838f5ac37ea1370$var$ie = (0, $exYeM.createContext)(null);
$9838f5ac37ea1370$var$ie.displayName = "PopoverAPIContext";
function $9838f5ac37ea1370$var$fe(t) {
    let o = (0, $exYeM.useContext)($9838f5ac37ea1370$var$ie);
    if (o === null) {
        let u = new Error(`<${t} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(u, $9838f5ac37ea1370$var$fe), u;
    }
    return o;
}
let $9838f5ac37ea1370$var$Pe = (0, $exYeM.createContext)(null);
$9838f5ac37ea1370$var$Pe.displayName = "PopoverGroupContext";
function $9838f5ac37ea1370$var$Ee() {
    return (0, $exYeM.useContext)($9838f5ac37ea1370$var$Pe);
}
let $9838f5ac37ea1370$var$re = (0, $exYeM.createContext)(null);
$9838f5ac37ea1370$var$re.displayName = "PopoverPanelContext";
function $9838f5ac37ea1370$var$Ge() {
    return (0, $exYeM.useContext)($9838f5ac37ea1370$var$re);
}
function $9838f5ac37ea1370$var$Ne(t, o) {
    return (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(o.type, $9838f5ac37ea1370$var$_e, t, o);
}
let $9838f5ac37ea1370$var$ke = "div";
function $9838f5ac37ea1370$var$we(t, o) {
    var D;
    let { __demoMode: u = !1, ...R } = t, O = (0, $exYeM.useRef)(null), n = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(o, (0, $b45ba282b8330326$export$7029785b750eb74)((l)=>{
        O.current = l;
    })), e = (0, $exYeM.useRef)([]), v = (0, $exYeM.useReducer)($9838f5ac37ea1370$var$Ne, {
        __demoMode: u,
        popoverState: u ? 0 : 1,
        buttons: e,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: (0, $exYeM.createRef)(),
        afterPanelSentinel: (0, $exYeM.createRef)()
    }), [{ popoverState: P, button: s, buttonId: I, panel: p, panelId: T, beforePanelSentinel: m, afterPanelSentinel: S }, i] = v, a = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)((D = O.current) != null ? D : s), E = (0, $exYeM.useMemo)(()=>{
        if (!s || !p) return !1;
        for (let K of document.querySelectorAll("body > *"))if (Number(K == null ? void 0 : K.contains(s)) ^ Number(K == null ? void 0 : K.contains(p))) return !0;
        let l = (0, $2786c78eeb568d2b$export$433aaa1f216cf32d)(), F = l.indexOf(s), q = (F + l.length - 1) % l.length, W = (F + 1) % l.length, z = l[q], be = l[W];
        return !p.contains(z) && !p.contains(be);
    }, [
        s,
        p
    ]), C = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(I), H = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(T), x = (0, $exYeM.useMemo)(()=>({
            buttonId: C,
            panelId: H,
            close: ()=>i({
                    type: 1
                })
        }), [
        C,
        H,
        i
    ]), M = $9838f5ac37ea1370$var$Ee(), h = M == null ? void 0 : M.registerPopover, f = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        var l;
        return (l = M == null ? void 0 : M.isFocusWithinPopoverGroup()) != null ? l : (a == null ? void 0 : a.activeElement) && ((s == null ? void 0 : s.contains(a.activeElement)) || (p == null ? void 0 : p.contains(a.activeElement)));
    });
    (0, $exYeM.useEffect)(()=>h == null ? void 0 : h(x), [
        h,
        x
    ]);
    let [y, b] = (0, $2a4cc9a7be671cc4$export$26b8c35244a70b37)(), d = (0, $0eb2c86c668abd7e$export$445f2d1a3d9b1b9f)({
        mainTreeNodeRef: M == null ? void 0 : M.mainTreeNodeRef,
        portals: y,
        defaultContainers: [
            s,
            p
        ]
    });
    (0, $b3d7b11c4d9c7c80$export$7080b3e976bc91ab)(a == null ? void 0 : a.defaultView, "focus", (l)=>{
        var F, q, W, z;
        l.target !== window && l.target instanceof HTMLElement && P === 0 && (f() || s && p && (d.contains(l.target) || (q = (F = m.current) == null ? void 0 : F.contains) != null && q.call(F, l.target) || (z = (W = S.current) == null ? void 0 : W.contains) != null && z.call(W, l.target) || i({
            type: 1
        })));
    }, !0), (0, $ff220859d927474a$export$71b2224f1ce5e08e)(d.resolveContainers, (l, F)=>{
        i({
            type: 1
        }), (0, $2786c78eeb568d2b$export$ff1ec1c740b3c8d5)(F, (0, $2786c78eeb568d2b$export$27112a34f2f8402d).Loose) || (l.preventDefault(), s == null || s.focus());
    }, P === 0);
    let L = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((l)=>{
        i({
            type: 1
        });
        let F = (()=>l ? l instanceof HTMLElement ? l : "current" in l && l.current instanceof HTMLElement ? l.current : s : s)();
        F == null || F.focus();
    }), r = (0, $exYeM.useMemo)(()=>({
            close: L,
            isPortalled: E
        }), [
        L,
        E
    ]), c = (0, $exYeM.useMemo)(()=>({
            open: P === 0,
            close: L
        }), [
        P,
        L
    ]), B = {
        ref: n
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9838f5ac37ea1370$var$re.Provider, {
        value: null
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9838f5ac37ea1370$var$ue.Provider, {
        value: v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9838f5ac37ea1370$var$ie.Provider, {
        value: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d2513f66ac282f05$export$2a0ed818b175f558), {
        value: (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(P, {
            [0]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open,
            [1]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Closed
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(b, null, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: B,
        theirProps: R,
        slot: c,
        defaultTag: $9838f5ac37ea1370$var$ke,
        name: "Popover"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(d.MainTreeNode, null))))));
}
let $9838f5ac37ea1370$var$Ue = "button";
function $9838f5ac37ea1370$var$We(t, o) {
    let u = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: R = `headlessui-popover-button-${u}`, ...O } = t, [n, e] = $9838f5ac37ea1370$var$oe("Popover.Button"), { isPortalled: v } = $9838f5ac37ea1370$var$fe("Popover.Button"), P = (0, $exYeM.useRef)(null), s = `headlessui-focus-sentinel-${(0, $8461bf68a681c36b$export$f680877a34711e37)()}`, I = $9838f5ac37ea1370$var$Ee(), p = I == null ? void 0 : I.closeOthers, m = $9838f5ac37ea1370$var$Ge() !== null;
    (0, $exYeM.useEffect)(()=>{
        if (!m) return e({
            type: 3,
            buttonId: R
        }), ()=>{
            e({
                type: 3,
                buttonId: null
            });
        };
    }, [
        m,
        R,
        e
    ]);
    let [S] = (0, $exYeM.useState)(()=>Symbol()), i = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(P, o, m ? null : (r)=>{
        if (r) n.buttons.current.push(S);
        else {
            let c = n.buttons.current.indexOf(S);
            c !== -1 && n.buttons.current.splice(c, 1);
        }
        n.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), r && e({
            type: 2,
            button: r
        });
    }), a = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(P, o), E = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)(P), C = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>{
        var c, B, D;
        if (m) {
            if (n.popoverState === 1) return;
            switch(r.key){
                case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space:
                case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), (B = (c = r.target).click) == null || B.call(c), e({
                        type: 1
                    }), (D = n.button) == null || D.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space:
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (p == null || p(n.buttonId)), e({
                    type: 0
                });
                break;
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Escape:
                if (n.popoverState !== 0) return p == null ? void 0 : p(n.buttonId);
                if (!P.current || E != null && E.activeElement && !P.current.contains(E.activeElement)) return;
                r.preventDefault(), r.stopPropagation(), e({
                    type: 1
                });
                break;
        }
    }), H = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>{
        m || r.key === (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space && r.preventDefault();
    }), x = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>{
        var c, B;
        (0, $b762bd1946006453$export$db61f031a278447c)(r.currentTarget) || t.disabled || (m ? (e({
            type: 1
        }), (c = n.button) == null || c.focus()) : (r.preventDefault(), r.stopPropagation(), n.popoverState === 1 && (p == null || p(n.buttonId)), e({
            type: 0
        }), (B = n.button) == null || B.focus()));
    }), M = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>{
        r.preventDefault(), r.stopPropagation();
    }), h = n.popoverState === 0, f = (0, $exYeM.useMemo)(()=>({
            open: h
        }), [
        h
    ]), y = (0, $5848675429035810$export$53652b2b272efe9c)(t, P), b = m ? {
        ref: a,
        type: y,
        onKeyDown: C,
        onClick: x
    } : {
        ref: i,
        id: n.buttonId,
        type: y,
        "aria-expanded": n.popoverState === 0,
        "aria-controls": n.panel ? n.panelId : void 0,
        onKeyDown: C,
        onKeyUp: H,
        onClick: x,
        onMouseDown: M
    }, d = (0, $58388cb581937808$export$19b797546aece48f)(), L = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        let r = n.panel;
        if (!r) return;
        function c() {
            (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(d.current, {
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(r, (0, $2786c78eeb568d2b$export$807a7eae502106e7).First),
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(r, (0, $2786c78eeb568d2b$export$807a7eae502106e7).Last)
            }) === (0, $2786c78eeb568d2b$export$abf286375dfa6dbd).Error && (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)((0, $2786c78eeb568d2b$export$433aaa1f216cf32d)().filter((D)=>D.dataset.headlessuiFocusGuard !== "true"), (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(d.current, {
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Forwards]: (0, $2786c78eeb568d2b$export$807a7eae502106e7).Next,
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Backwards]: (0, $2786c78eeb568d2b$export$807a7eae502106e7).Previous
            }), {
                relativeTo: n.button
            });
        }
        c();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: b,
        theirProps: O,
        slot: f,
        defaultTag: $9838f5ac37ea1370$var$Ue,
        name: "Popover.Button"
    }), h && !m && v && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
        id: s,
        features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: L
    }));
}
let $9838f5ac37ea1370$var$Ke = "div", $9838f5ac37ea1370$var$je = (0, $6da0b689c34972b7$export$617d79dae526d2cf).RenderStrategy | (0, $6da0b689c34972b7$export$617d79dae526d2cf).Static;
function $9838f5ac37ea1370$var$Ve(t, o) {
    let u = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: R = `headlessui-popover-overlay-${u}`, ...O } = t, [{ popoverState: n }, e] = $9838f5ac37ea1370$var$oe("Popover.Overlay"), v = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(o), P = (0, $d2513f66ac282f05$export$fc6fdf0ecf360e)(), s = (()=>P !== null ? (P & (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open) === (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open : n === 0)(), I = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((m)=>{
        if ((0, $b762bd1946006453$export$db61f031a278447c)(m.currentTarget)) return m.preventDefault();
        e({
            type: 1
        });
    }), p = (0, $exYeM.useMemo)(()=>({
            open: n === 0
        }), [
        n
    ]);
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: v,
            id: R,
            "aria-hidden": !0,
            onClick: I
        },
        theirProps: O,
        slot: p,
        defaultTag: $9838f5ac37ea1370$var$Ke,
        features: $9838f5ac37ea1370$var$je,
        visible: s,
        name: "Popover.Overlay"
    });
}
let $9838f5ac37ea1370$var$$e = "div", $9838f5ac37ea1370$var$Je = (0, $6da0b689c34972b7$export$617d79dae526d2cf).RenderStrategy | (0, $6da0b689c34972b7$export$617d79dae526d2cf).Static;
function $9838f5ac37ea1370$var$Xe(t, o) {
    let u = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: R = `headlessui-popover-panel-${u}`, focus: O = !1, ...n } = t, [e, v] = $9838f5ac37ea1370$var$oe("Popover.Panel"), { close: P, isPortalled: s } = $9838f5ac37ea1370$var$fe("Popover.Panel"), I = `headlessui-focus-sentinel-before-${(0, $8461bf68a681c36b$export$f680877a34711e37)()}`, p = `headlessui-focus-sentinel-after-${(0, $8461bf68a681c36b$export$f680877a34711e37)()}`, T = (0, $exYeM.useRef)(null), m = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(T, o, (f)=>{
        v({
            type: 4,
            panel: f
        });
    }), S = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)(T);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>(v({
            type: 5,
            panelId: R
        }), ()=>{
            v({
                type: 5,
                panelId: null
            });
        }), [
        R,
        v
    ]);
    let i = (0, $d2513f66ac282f05$export$fc6fdf0ecf360e)(), a = (()=>i !== null ? (i & (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open) === (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open : e.popoverState === 0)(), E = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((f)=>{
        var y;
        switch(f.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Escape:
                if (e.popoverState !== 0 || !T.current || S != null && S.activeElement && !T.current.contains(S.activeElement)) return;
                f.preventDefault(), f.stopPropagation(), v({
                    type: 1
                }), (y = e.button) == null || y.focus();
                break;
        }
    });
    (0, $exYeM.useEffect)(()=>{
        var f;
        t.static || e.popoverState === 1 && ((f = t.unmount) == null || f) && v({
            type: 4,
            panel: null
        });
    }, [
        e.popoverState,
        t.unmount,
        t.static,
        v
    ]), (0, $exYeM.useEffect)(()=>{
        if (e.__demoMode || !O || e.popoverState !== 0 || !T.current) return;
        let f = S == null ? void 0 : S.activeElement;
        T.current.contains(f) || (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(T.current, (0, $2786c78eeb568d2b$export$807a7eae502106e7).First);
    }, [
        e.__demoMode,
        O,
        T,
        e.popoverState
    ]);
    let C = (0, $exYeM.useMemo)(()=>({
            open: e.popoverState === 0,
            close: P
        }), [
        e,
        P
    ]), H = {
        ref: m,
        id: R,
        onKeyDown: E,
        onBlur: O && e.popoverState === 0 ? (f)=>{
            var b, d, L, r, c;
            let y = f.relatedTarget;
            y && T.current && ((b = T.current) != null && b.contains(y) || (v({
                type: 1
            }), ((L = (d = e.beforePanelSentinel.current) == null ? void 0 : d.contains) != null && L.call(d, y) || (c = (r = e.afterPanelSentinel.current) == null ? void 0 : r.contains) != null && c.call(r, y)) && y.focus({
                preventScroll: !0
            })));
        } : void 0,
        tabIndex: -1
    }, x = (0, $58388cb581937808$export$19b797546aece48f)(), M = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        let f = T.current;
        if (!f) return;
        function y() {
            (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(x.current, {
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var d;
                    (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(f, (0, $2786c78eeb568d2b$export$807a7eae502106e7).First) === (0, $2786c78eeb568d2b$export$abf286375dfa6dbd).Error && ((d = e.afterPanelSentinel.current) == null || d.focus());
                },
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var b;
                    (b = e.button) == null || b.focus({
                        preventScroll: !0
                    });
                }
            });
        }
        y();
    }), h = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        let f = T.current;
        if (!f) return;
        function y() {
            (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(x.current, {
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var B;
                    if (!e.button) return;
                    let b = (0, $2786c78eeb568d2b$export$433aaa1f216cf32d)(), d = b.indexOf(e.button), L = b.slice(0, d + 1), c = [
                        ...b.slice(d + 1),
                        ...L
                    ];
                    for (let D of c.slice())if (D.dataset.headlessuiFocusGuard === "true" || (B = e.panel) != null && B.contains(D)) {
                        let l = c.indexOf(D);
                        l !== -1 && c.splice(l, 1);
                    }
                    (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(c, (0, $2786c78eeb568d2b$export$807a7eae502106e7).First, {
                        sorted: !1
                    });
                },
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var d;
                    (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(f, (0, $2786c78eeb568d2b$export$807a7eae502106e7).Previous) === (0, $2786c78eeb568d2b$export$abf286375dfa6dbd).Error && ((d = e.button) == null || d.focus());
                }
            });
        }
        y();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9838f5ac37ea1370$var$re.Provider, {
        value: R
    }, a && s && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
        id: I,
        ref: e.beforePanelSentinel,
        features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: M
    }), (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: H,
        theirProps: n,
        slot: C,
        defaultTag: $9838f5ac37ea1370$var$$e,
        features: $9838f5ac37ea1370$var$Je,
        visible: a,
        name: "Popover.Panel"
    }), a && s && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
        id: p,
        ref: e.afterPanelSentinel,
        features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: h
    }));
}
let $9838f5ac37ea1370$var$Ye = "div";
function $9838f5ac37ea1370$var$qe(t, o) {
    let u = (0, $exYeM.useRef)(null), R = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(u, o), [O, n] = (0, $exYeM.useState)([]), e = (0, $0eb2c86c668abd7e$export$64db24433d7f4942)(), v = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((i)=>{
        n((a)=>{
            let E = a.indexOf(i);
            if (E !== -1) {
                let C = a.slice();
                return C.splice(E, 1), C;
            }
            return a;
        });
    }), P = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((i)=>(n((a)=>[
                ...a,
                i
            ]), ()=>v(i))), s = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        var E;
        let i = (0, $a54eed888c938856$export$b204af158042fbac)(u);
        if (!i) return !1;
        let a = i.activeElement;
        return (E = u.current) != null && E.contains(a) ? !0 : O.some((C)=>{
            var H, x;
            return ((H = i.getElementById(C.buttonId.current)) == null ? void 0 : H.contains(a)) || ((x = i.getElementById(C.panelId.current)) == null ? void 0 : x.contains(a));
        });
    }), I = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((i)=>{
        for (let a of O)a.buttonId.current !== i && a.close();
    }), p = (0, $exYeM.useMemo)(()=>({
            registerPopover: P,
            unregisterPopover: v,
            isFocusWithinPopoverGroup: s,
            closeOthers: I,
            mainTreeNodeRef: e.mainTreeNodeRef
        }), [
        P,
        v,
        s,
        I,
        e.mainTreeNodeRef
    ]), T = (0, $exYeM.useMemo)(()=>({}), []), m = t, S = {
        ref: R
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9838f5ac37ea1370$var$Pe.Provider, {
        value: p
    }, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: S,
        theirProps: m,
        slot: T,
        defaultTag: $9838f5ac37ea1370$var$Ye,
        name: "Popover.Group"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(e.MainTreeNode, null));
}
let $9838f5ac37ea1370$var$ze = (0, $6da0b689c34972b7$export$e43f39796049410c)($9838f5ac37ea1370$var$we), $9838f5ac37ea1370$var$Qe = (0, $6da0b689c34972b7$export$e43f39796049410c)($9838f5ac37ea1370$var$We), $9838f5ac37ea1370$var$Ze = (0, $6da0b689c34972b7$export$e43f39796049410c)($9838f5ac37ea1370$var$Ve), $9838f5ac37ea1370$var$et = (0, $6da0b689c34972b7$export$e43f39796049410c)($9838f5ac37ea1370$var$Xe), $9838f5ac37ea1370$var$tt = (0, $6da0b689c34972b7$export$e43f39796049410c)($9838f5ac37ea1370$var$qe), $9838f5ac37ea1370$export$5b6b19405a83ff9d = Object.assign($9838f5ac37ea1370$var$ze, {
    Button: $9838f5ac37ea1370$var$Qe,
    Overlay: $9838f5ac37ea1370$var$Ze,
    Panel: $9838f5ac37ea1370$var$et,
    Group: $9838f5ac37ea1370$var$tt
});



var $exYeM = parcelRequire("exYeM");
var $aa4d1747f51f6488$var$__assign = undefined && undefined.__assign || function() {
    $aa4d1747f51f6488$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa4d1747f51f6488$var$__assign.apply(this, arguments);
};
var $aa4d1747f51f6488$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $aa4d1747f51f6488$export$2e2bcd8739ae039(iconConfig) {
    var Icon = function(_a) {
        var bgStyle = _a.bgStyle, borderRadius = _a.borderRadius, iconFillColor = _a.iconFillColor, round = _a.round, size = _a.size, rest = $aa4d1747f51f6488$var$__rest(_a, [
            "bgStyle",
            "borderRadius",
            "iconFillColor",
            "round",
            "size"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("svg", $aa4d1747f51f6488$var$__assign({
            viewBox: "0 0 64 64",
            width: size,
            height: size
        }, rest), round ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("circle", {
            cx: "32",
            cy: "32",
            r: "31",
            fill: iconConfig.color,
            style: bgStyle
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("rect", {
            width: "64",
            height: "64",
            rx: borderRadius,
            ry: borderRadius,
            fill: iconConfig.color,
            style: bgStyle
        }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: iconConfig.path,
            fill: iconFillColor
        }));
    };
    Icon.defaultProps = {
        bgStyle: {},
        borderRadius: 0,
        iconFillColor: "white",
        size: 64
    };
    return Icon;
}


var $6f87ae2557ef43b5$var$LinkedinIcon = (0, $aa4d1747f51f6488$export$2e2bcd8739ae039)({
    color: "#007fb1",
    networkName: "linkedin",
    path: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
});
var $6f87ae2557ef43b5$export$2e2bcd8739ae039 = $6f87ae2557ef43b5$var$LinkedinIcon;

var $56c1815b73504a20$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $56c1815b73504a20$var$AssertionError = /** @class */ function(_super) {
    $56c1815b73504a20$var$__extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "AssertionError";
        return _this;
    }
    return AssertionError;
}(Error);
function $56c1815b73504a20$export$2e2bcd8739ae039(value, message) {
    if (!value) throw new $56c1815b73504a20$var$AssertionError(message);
}


function $41a9e9661507de40$export$2e2bcd8739ae039(object) {
    var params = Object.entries(object).filter(function(_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    }).map(function(_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join("&")) : "";
}



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $eH0la = parcelRequire("eH0la");
var $7e4a76ba7fd2d81c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7e4a76ba7fd2d81c$var$__assign = undefined && undefined.__assign || function() {
    $7e4a76ba7fd2d81c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e4a76ba7fd2d81c$var$__assign.apply(this, arguments);
};
var $7e4a76ba7fd2d81c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7e4a76ba7fd2d81c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7e4a76ba7fd2d81c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7e4a76ba7fd2d81c$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $7e4a76ba7fd2d81c$var$getBoxPositionOnWindowCenter = function(width, height) {
    return {
        left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
        top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2
    };
};
var $7e4a76ba7fd2d81c$var$getBoxPositionOnScreenCenter = function(width, height) {
    return {
        top: (window.screen.height - height) / 2,
        left: (window.screen.width - width) / 2
    };
};
function $7e4a76ba7fd2d81c$var$windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = $7e4a76ba7fd2d81c$var$__rest(_a, [
        "height",
        "width"
    ]);
    var config = $7e4a76ba7fd2d81c$var$__assign({
        height: height,
        width: width,
        location: "no",
        toolbar: "no",
        status: "no",
        directories: "no",
        menubar: "no",
        scrollbars: "yes",
        resizable: "no",
        centerscreen: "yes",
        chrome: "yes"
    }, configRest);
    var shareDialog = window.open(url, "", Object.keys(config).map(function(key) {
        return "".concat(key, "=").concat(config[key]);
    }).join(", "));
    if (onClose) var interval_1 = window.setInterval(function() {
        try {
            if (shareDialog === null || shareDialog.closed) {
                window.clearInterval(interval_1);
                onClose(shareDialog);
            }
        } catch (e) {
            /* eslint-disable no-console */ console.error(e);
        /* eslint-enable no-console */ }
    }, 1000);
    return shareDialog;
}
var $7e4a76ba7fd2d81c$var$ShareButton = /** @class */ function(_super) {
    $7e4a76ba7fd2d81c$var$__extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function(link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? "windowCenter" : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = $7e4a76ba7fd2d81c$var$__assign({
                height: windowHeight,
                width: windowWidth
            }, windowPosition === "windowCenter" ? $7e4a76ba7fd2d81c$var$getBoxPositionOnWindowCenter(windowWidth, windowHeight) : $7e4a76ba7fd2d81c$var$getBoxPositionOnScreenCenter(windowWidth, windowHeight));
            $7e4a76ba7fd2d81c$var$windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function(event) {
            return $7e4a76ba7fd2d81c$var$__awaiter(_this, void 0, void 0, function() {
                var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
                return $7e4a76ba7fd2d81c$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                            link = networkLink(url, opts);
                            if (disabled) return [
                                2 /*return*/ 
                            ];
                            event.preventDefault();
                            if (!beforeOnClick) return [
                                3 /*break*/ ,
                                2
                            ];
                            returnVal = beforeOnClick();
                            if (!$7e4a76ba7fd2d81c$var$isPromise(returnVal)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                returnVal
                            ];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            if (openShareDialogOnClick) this.openShareDialog(link);
                            if (onClick) onClick(event, link);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _this;
    }
    ShareButton.prototype.render = function() {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = $7e4a76ba7fd2d81c$var$__rest(_a, [
            "beforeOnClick",
            "children",
            "className",
            "disabled",
            "disabledStyle",
            "forwardedRef",
            "networkLink",
            "networkName",
            "onShareWindowClose",
            "openShareDialogOnClick",
            "opts",
            "resetButtonStyle",
            "style",
            "url",
            "windowHeight",
            "windowPosition",
            "windowWidth"
        ]);
        var newClassName = (0, (/*@__PURE__*/$parcel$interopDefault($eH0la)))("react-share__ShareButton", {
            "react-share__ShareButton--disabled": !!disabled,
            disabled: !!disabled
        }, className);
        var newStyle = resetButtonStyle ? $7e4a76ba7fd2d81c$var$__assign($7e4a76ba7fd2d81c$var$__assign({
            backgroundColor: "transparent",
            border: "none",
            padding: 0,
            font: "inherit",
            color: "inherit",
            cursor: "pointer"
        }, style), disabled && disabledStyle) : $7e4a76ba7fd2d81c$var$__assign($7e4a76ba7fd2d81c$var$__assign({}, style), disabled && disabledStyle);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("button", $7e4a76ba7fd2d81c$var$__assign({}, rest, {
            "aria-label": rest["aria-label"] || networkName,
            className: newClassName,
            onClick: this.handleClick,
            ref: forwardedRef,
            style: newStyle
        }), children);
    };
    ShareButton.defaultProps = {
        disabledStyle: {
            opacity: 0.6
        },
        openShareDialogOnClick: true,
        resetButtonStyle: true
    };
    return ShareButton;
}((0, $exYeM.Component));
var $7e4a76ba7fd2d81c$export$2e2bcd8739ae039 = $7e4a76ba7fd2d81c$var$ShareButton;


var $ec2d6171e6169b29$var$__assign = undefined && undefined.__assign || function() {
    $ec2d6171e6169b29$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ec2d6171e6169b29$var$__assign.apply(this, arguments);
};
function $ec2d6171e6169b29$var$createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = $ec2d6171e6169b29$var$__assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function(key) {
            delete passedProps[key];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7e4a76ba7fd2d81c$export$2e2bcd8739ae039), $ec2d6171e6169b29$var$__assign({}, defaultProps, passedProps, {
            forwardedRef: ref,
            networkName: networkName,
            networkLink: link,
            opts: optsMap(props)
        }));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0, $exYeM.forwardRef)(CreatedButton);
}
var $ec2d6171e6169b29$export$2e2bcd8739ae039 = $ec2d6171e6169b29$var$createShareButton;


function $6d182e8471d3ba70$var$linkedinLink(url, _a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    (0, $56c1815b73504a20$export$2e2bcd8739ae039)(url, "linkedin.url");
    return "https://linkedin.com/shareArticle" + (0, $41a9e9661507de40$export$2e2bcd8739ae039)({
        url: url,
        mini: "true",
        title: title,
        summary: summary,
        source: source
    });
}
var $6d182e8471d3ba70$var$LinkedinShareButton = (0, $ec2d6171e6169b29$export$2e2bcd8739ae039)("linkedin", $6d182e8471d3ba70$var$linkedinLink, function(_a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    return {
        title: title,
        summary: summary,
        source: source
    };
}, {
    windowWidth: 750,
    windowHeight: 600
});
var $6d182e8471d3ba70$export$2e2bcd8739ae039 = $6d182e8471d3ba70$var$LinkedinShareButton;


var $fef596c67269757c$var$TelegramIcon = (0, $aa4d1747f51f6488$export$2e2bcd8739ae039)({
    color: "#37aee2",
    networkName: "telegram",
    path: "m45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957"
});
var $fef596c67269757c$export$2e2bcd8739ae039 = $fef596c67269757c$var$TelegramIcon;




function $e26074a2b4484734$var$telegramLink(url, _a) {
    var title = _a.title;
    (0, $56c1815b73504a20$export$2e2bcd8739ae039)(url, "telegram.url");
    return "https://telegram.me/share/url" + (0, $41a9e9661507de40$export$2e2bcd8739ae039)({
        url: url,
        text: title
    });
}
var $e26074a2b4484734$var$TelegramShareButton = (0, $ec2d6171e6169b29$export$2e2bcd8739ae039)("telegram", $e26074a2b4484734$var$telegramLink, function(props) {
    return {
        title: props.title
    };
}, {
    windowWidth: 550,
    windowHeight: 400
});
var $e26074a2b4484734$export$2e2bcd8739ae039 = $e26074a2b4484734$var$TelegramShareButton;


var $30be59c6ac7c486e$var$TwitterIcon = (0, $aa4d1747f51f6488$export$2e2bcd8739ae039)({
    color: "#00aced",
    networkName: "twitter",
    path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
var $30be59c6ac7c486e$export$2e2bcd8739ae039 = $30be59c6ac7c486e$var$TwitterIcon;




function $d0e5ef8bd1dc9733$var$twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    (0, $56c1815b73504a20$export$2e2bcd8739ae039)(url, "twitter.url");
    (0, $56c1815b73504a20$export$2e2bcd8739ae039)(Array.isArray(hashtags), "twitter.hashtags is not an array");
    (0, $56c1815b73504a20$export$2e2bcd8739ae039)(Array.isArray(related), "twitter.related is not an array");
    return "https://twitter.com/share" + (0, $41a9e9661507de40$export$2e2bcd8739ae039)({
        url: url,
        text: title,
        via: via,
        hashtags: hashtags.length > 0 ? hashtags.join(",") : undefined,
        related: related.length > 0 ? related.join(",") : undefined
    });
}
var $d0e5ef8bd1dc9733$var$TwitterShareButton = (0, $ec2d6171e6169b29$export$2e2bcd8739ae039)("twitter", $d0e5ef8bd1dc9733$var$twitterLink, function(props) {
    return {
        hashtags: props.hashtags,
        title: props.title,
        via: props.via,
        related: props.related
    };
}, {
    windowWidth: 550,
    windowHeight: 400
});
var $d0e5ef8bd1dc9733$export$2e2bcd8739ae039 = $d0e5ef8bd1dc9733$var$TwitterShareButton;


// Created By James Launder
// this is used to created a custom screenshot that the user can then download in the formats

var $6qd2L = parcelRequire("6qd2L");
function $b5c344f7d64514e2$export$f85c16a6d62f7d63(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement("base");
    const a = doc.createElement("a");
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const $b5c344f7d64514e2$export$31b40729666a4ae0 = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function $b5c344f7d64514e2$export$1391212d75b2ee65(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function $b5c344f7d64514e2$export$45b10814cc054894(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
function $b5c344f7d64514e2$var$px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace("px", "")) : 0;
}
function $b5c344f7d64514e2$var$getNodeWidth(node) {
    const leftBorder = $b5c344f7d64514e2$var$px(node, "border-left-width");
    const rightBorder = $b5c344f7d64514e2$var$px(node, "border-right-width");
    return node.clientWidth + leftBorder + rightBorder;
}
function $b5c344f7d64514e2$var$getNodeHeight(node) {
    const topBorder = $b5c344f7d64514e2$var$px(node, "border-top-width");
    const bottomBorder = $b5c344f7d64514e2$var$px(node, "border-bottom-width");
    return node.clientHeight + topBorder + bottomBorder;
}
function $b5c344f7d64514e2$export$ada5537b2c061996(targetNode, options = {}) {
    const width = options.width || $b5c344f7d64514e2$var$getNodeWidth(targetNode);
    const height = options.height || $b5c344f7d64514e2$var$getNodeHeight(targetNode);
    return {
        width: width,
        height: height
    };
}
function $b5c344f7d64514e2$export$d39ce20a37bba061() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = $6qd2L;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const $b5c344f7d64514e2$var$canvasDimensionLimit = 16384;
function $b5c344f7d64514e2$export$c2c809a2fe6b0f1a(canvas) {
    if (canvas.width > $b5c344f7d64514e2$var$canvasDimensionLimit || canvas.height > $b5c344f7d64514e2$var$canvasDimensionLimit) {
        if (canvas.width > $b5c344f7d64514e2$var$canvasDimensionLimit && canvas.height > $b5c344f7d64514e2$var$canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= $b5c344f7d64514e2$var$canvasDimensionLimit / canvas.width;
                canvas.width = $b5c344f7d64514e2$var$canvasDimensionLimit;
            } else {
                canvas.width *= $b5c344f7d64514e2$var$canvasDimensionLimit / canvas.height;
                canvas.height = $b5c344f7d64514e2$var$canvasDimensionLimit;
            }
        } else if (canvas.width > $b5c344f7d64514e2$var$canvasDimensionLimit) {
            canvas.height *= $b5c344f7d64514e2$var$canvasDimensionLimit / canvas.width;
            canvas.width = $b5c344f7d64514e2$var$canvasDimensionLimit;
        } else {
            canvas.width *= $b5c344f7d64514e2$var$canvasDimensionLimit / canvas.height;
            canvas.height = $b5c344f7d64514e2$var$canvasDimensionLimit;
        }
    }
}
function $b5c344f7d64514e2$export$403d539f215df596(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : "image/png", options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(",")[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : "image/png"
        }));
    });
}
function $b5c344f7d64514e2$export$ec664d7487540b(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.decode = ()=>resolve(img);
        img.onload = ()=>resolve(img);
        img.onerror = reject;
        img.crossOrigin = "anonymous";
        img.decoding = "async";
        img.src = url;
    });
}
async function $b5c344f7d64514e2$export$fe77aa9c02de4599(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function $b5c344f7d64514e2$export$b62810fb8ca515fa(node, width, height) {
    const xmlns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(xmlns, "svg");
    const foreignObject = document.createElementNS(xmlns, "foreignObject");
    svg.setAttribute("width", `${width}`);
    svg.setAttribute("height", `${height}`);
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    foreignObject.setAttribute("width", "100%");
    foreignObject.setAttribute("height", "100%");
    foreignObject.setAttribute("x", "0");
    foreignObject.setAttribute("y", "0");
    foreignObject.setAttribute("externalResourcesRequired", "true");
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return $b5c344f7d64514e2$export$fe77aa9c02de4599(svg);
}
const $b5c344f7d64514e2$export$3a92fc9ec83ef360 = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || $b5c344f7d64514e2$export$3a92fc9ec83ef360(nodePrototype, instance);
};


function $f991897f9d262716$var$formatCSSText(style) {
    const content = style.getPropertyValue("content");
    return `${style.cssText} content: '${content.replace(/'|"/g, "")}';`;
}
function $f991897f9d262716$var$formatCSSProperties(style) {
    return (0, $b5c344f7d64514e2$export$45b10814cc054894)(style).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? " !important" : ""};`;
    }).join(" ");
}
function $f991897f9d262716$var$getPseudoElementStyle(className, pseudo, style) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? $f991897f9d262716$var$formatCSSText(style) : $f991897f9d262716$var$formatCSSProperties(style);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function $f991897f9d262716$var$clonePseudoElement(nativeNode, clonedNode, pseudo) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue("content");
    if (content === "" || content === "none") return;
    const className = (0, $b5c344f7d64514e2$export$31b40729666a4ae0)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement("style");
    styleElement.appendChild($f991897f9d262716$var$getPseudoElementStyle(className, pseudo, style));
    clonedNode.appendChild(styleElement);
}
function $f991897f9d262716$export$8df63687a708ed2e(nativeNode, clonedNode) {
    $f991897f9d262716$var$clonePseudoElement(nativeNode, clonedNode, ":before");
    $f991897f9d262716$var$clonePseudoElement(nativeNode, clonedNode, ":after");
}



const $4fc9f0e8bdd33a19$var$WOFF = "application/font-woff";
const $4fc9f0e8bdd33a19$var$JPEG = "image/jpeg";
const $4fc9f0e8bdd33a19$var$mimes = {
    woff: $4fc9f0e8bdd33a19$var$WOFF,
    woff2: $4fc9f0e8bdd33a19$var$WOFF,
    ttf: "application/font-truetype",
    eot: "application/vnd.ms-fontobject",
    png: "image/png",
    jpg: $4fc9f0e8bdd33a19$var$JPEG,
    jpeg: $4fc9f0e8bdd33a19$var$JPEG,
    gif: "image/gif",
    tiff: "image/tiff",
    svg: "image/svg+xml",
    webp: "image/webp"
};
function $4fc9f0e8bdd33a19$var$getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : "";
}
function $4fc9f0e8bdd33a19$export$200548c990602f61(url) {
    const extension = $4fc9f0e8bdd33a19$var$getExtension(url).toLowerCase();
    return $4fc9f0e8bdd33a19$var$mimes[extension] || "";
}


function $5288253ed94396a8$var$getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function $5288253ed94396a8$export$f8a05efa20ffd5a(url) {
    return url.search(/^(data:)/) !== -1;
}
function $5288253ed94396a8$export$68336ea1617fa80a(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function $5288253ed94396a8$export$c20a8b76c95b0d41(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res: res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const $5288253ed94396a8$var$cache = {};
function $5288253ed94396a8$var$getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, "");
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, "");
    return contentType ? `[${contentType}]${key}` : key;
}
async function $5288253ed94396a8$export$bdf0422c029b202a(resourceUrl, contentType, options) {
    const cacheKey = $5288253ed94396a8$var$getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if ($5288253ed94396a8$var$cache[cacheKey] != null) return $5288253ed94396a8$var$cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? "&" : "?") + new Date().getTime();
    let dataURL;
    try {
        const content = await $5288253ed94396a8$export$c20a8b76c95b0d41(resourceUrl, options.fetchRequestInit, ({ res: res, result: result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get("Content-Type") || "";
            return $5288253ed94396a8$var$getContentFromDataUrl(result);
        });
        dataURL = $5288253ed94396a8$export$68336ea1617fa80a(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || "";
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === "string" ? error : error.message;
        if (msg) console.warn(msg);
    }
    $5288253ed94396a8$var$cache[cacheKey] = dataURL;
    return dataURL;
}


async function $98062e4a43f97b80$var$cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === "data:,") return canvas.cloneNode(false);
    return (0, $b5c344f7d64514e2$export$ec664d7487540b)(dataURL);
}
async function $98062e4a43f97b80$var$cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, $b5c344f7d64514e2$export$ec664d7487540b)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, $4fc9f0e8bdd33a19$export$200548c990602f61)(poster);
    const dataURL = await (0, $5288253ed94396a8$export$bdf0422c029b202a)(poster, contentType, options);
    return (0, $b5c344f7d64514e2$export$ec664d7487540b)(dataURL);
}
async function $98062e4a43f97b80$var$cloneIFrameElement(iframe) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await $98062e4a43f97b80$export$ae8e35ea29ddac22(iframe.contentDocument.body, {}, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function $98062e4a43f97b80$var$cloneSingleNode(node, options) {
    if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(node, HTMLCanvasElement)) return $98062e4a43f97b80$var$cloneCanvasElement(node);
    if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(node, HTMLVideoElement)) return $98062e4a43f97b80$var$cloneVideoElement(node, options);
    if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(node, HTMLIFrameElement)) return $98062e4a43f97b80$var$cloneIFrameElement(node);
    return node.cloneNode(false);
}
const $98062e4a43f97b80$var$isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === "SLOT";
async function $98062e4a43f97b80$var$cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    let children = [];
    if ($98062e4a43f97b80$var$isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, $b5c344f7d64514e2$export$45b10814cc054894)(nativeNode.assignedNodes());
    else if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, $b5c344f7d64514e2$export$45b10814cc054894)(nativeNode.contentDocument.body.childNodes);
    else children = (0, $b5c344f7d64514e2$export$45b10814cc054894)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>$98062e4a43f97b80$export$ae8e35ea29ddac22(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function $98062e4a43f97b80$var$cloneCSSStyle(nativeNode, clonedNode) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, $b5c344f7d64514e2$export$45b10814cc054894)(sourceStyle).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === "font-size" && value.endsWith("px")) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && name === "display" && value === "inline") value = "block";
        if (name === "d" && clonedNode.getAttribute("d")) value = `path(${clonedNode.getAttribute("d")})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function $98062e4a43f97b80$var$cloneInputValue(nativeNode, clonedNode) {
    if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(nativeNode, HTMLInputElement)) clonedNode.setAttribute("value", nativeNode.value);
}
function $98062e4a43f97b80$var$cloneSelectValue(nativeNode, clonedNode) {
    if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute("value"));
        if (selectedOption) selectedOption.setAttribute("selected", "");
    }
}
function $98062e4a43f97b80$var$decorate(nativeNode, clonedNode) {
    if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        $98062e4a43f97b80$var$cloneCSSStyle(nativeNode, clonedNode);
        (0, $f991897f9d262716$export$8df63687a708ed2e)(nativeNode, clonedNode);
        $98062e4a43f97b80$var$cloneInputValue(nativeNode, clonedNode);
        $98062e4a43f97b80$var$cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function $98062e4a43f97b80$var$ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll("use") : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute("xlink:href");
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await $98062e4a43f97b80$export$ae8e35ea29ddac22(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = "http://www.w3.org/1999/xhtml";
        const svg = document.createElementNS(ns, "svg");
        svg.setAttribute("xmlns", ns);
        svg.style.position = "absolute";
        svg.style.width = "0";
        svg.style.height = "0";
        svg.style.overflow = "hidden";
        svg.style.display = "none";
        const defs = document.createElementNS(ns, "defs");
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function $98062e4a43f97b80$export$ae8e35ea29ddac22(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>$98062e4a43f97b80$var$cloneSingleNode(clonedNode, options)).then((clonedNode)=>$98062e4a43f97b80$var$cloneChildren(node, clonedNode, options)).then((clonedNode)=>$98062e4a43f97b80$var$decorate(node, clonedNode)).then((clonedNode)=>$98062e4a43f97b80$var$ensureSVGSymbols(clonedNode, options));
}





const $0f21e13064978b66$var$URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const $0f21e13064978b66$var$URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $0f21e13064978b66$var$FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $0f21e13064978b66$var$toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, "g");
}
function $0f21e13064978b66$export$d04549d631b8762d(cssText) {
    const urls = [];
    cssText.replace($0f21e13064978b66$var$URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, $5288253ed94396a8$export$f8a05efa20ffd5a)(url));
}
async function $0f21e13064978b66$export$2be46bb7e96db87f(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, $b5c344f7d64514e2$export$f85c16a6d62f7d63)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, $4fc9f0e8bdd33a19$export$200548c990602f61)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, $5288253ed94396a8$export$68336ea1617fa80a)(content, contentType);
        } else dataURL = await (0, $5288253ed94396a8$export$bdf0422c029b202a)(resolvedURL, contentType, options);
        return cssText.replace($0f21e13064978b66$var$toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function $0f21e13064978b66$var$filterPreferredFontFormat(str, { preferredFontFormat: preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace($0f21e13064978b66$var$FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = $0f21e13064978b66$var$URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return "";
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function $0f21e13064978b66$export$7b668369e5eab853(url) {
    return url.search($0f21e13064978b66$var$URL_REGEX) !== -1;
}
async function $0f21e13064978b66$export$3d88803585cbbc21(cssText, baseUrl, options) {
    if (!$0f21e13064978b66$export$7b668369e5eab853(cssText)) return cssText;
    const filteredCSSText = $0f21e13064978b66$var$filterPreferredFontFormat(cssText, options);
    const urls = $0f21e13064978b66$export$d04549d631b8762d(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>$0f21e13064978b66$export$2be46bb7e96db87f(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}





async function $e8b4f8edae07017b$var$embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, $0f21e13064978b66$export$3d88803585cbbc21)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function $e8b4f8edae07017b$var$embedBackground(clonedNode, options) {
    if (!await $e8b4f8edae07017b$var$embedProp("background", clonedNode, options)) await $e8b4f8edae07017b$var$embedProp("background-image", clonedNode, options);
    if (!await $e8b4f8edae07017b$var$embedProp("mask", clonedNode, options)) await $e8b4f8edae07017b$var$embedProp("mask-image", clonedNode, options);
}
async function $e8b4f8edae07017b$var$embedImageNode(clonedNode, options) {
    const isImageElement = (0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, $5288253ed94396a8$export$f8a05efa20ffd5a)(clonedNode.src)) && !((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(clonedNode, SVGImageElement) && !(0, $5288253ed94396a8$export$f8a05efa20ffd5a)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, $5288253ed94396a8$export$bdf0422c029b202a)(url, (0, $4fc9f0e8bdd33a19$export$200548c990602f61)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === "lazy") image.loading = "eager";
        if (isImageElement) {
            clonedNode.srcset = "";
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function $e8b4f8edae07017b$var$embedChildren(clonedNode, options) {
    const children = (0, $b5c344f7d64514e2$export$45b10814cc054894)(clonedNode.childNodes);
    const deferreds = children.map((child)=>$e8b4f8edae07017b$export$6660fa8dd20e53aa(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function $e8b4f8edae07017b$export$6660fa8dd20e53aa(clonedNode, options) {
    if ((0, $b5c344f7d64514e2$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        await $e8b4f8edae07017b$var$embedBackground(clonedNode, options);
        await $e8b4f8edae07017b$var$embedImageNode(clonedNode, options);
        await $e8b4f8edae07017b$var$embedChildren(clonedNode, options);
    }
}


function $e3bea5c5b0507577$export$d63a6b7859608045(node, options) {
    const { style: style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}





const $c79d972fbc7be79a$var$cssFetchCache = {};
async function $c79d972fbc7be79a$var$fetchCSS(url) {
    let cache = $c79d972fbc7be79a$var$cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url: url,
        cssText: cssText
    };
    $c79d972fbc7be79a$var$cssFetchCache[url] = cache;
    return cache;
}
async function $c79d972fbc7be79a$var$embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, "$1");
        if (!url.startsWith("https://")) url = new URL(url, data.url).href;
        return (0, $5288253ed94396a8$export$c20a8b76c95b0d41)(url, options.fetchRequestInit, ({ result: result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function $c79d972fbc7be79a$var$parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, "");
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})", "gi");
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, "");
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, "gi");
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function $c79d972fbc7be79a$var$getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ("cssRules" in sheet) try {
            (0, $b5c344f7d64514e2$export$45b10814cc054894)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = $c79d972fbc7be79a$var$fetchCSS(url).then((metadata)=>$c79d972fbc7be79a$var$embedFonts(metadata, options)).then((cssText)=>$c79d972fbc7be79a$var$parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith("@import") ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error("Error inserting rule from remote css", {
                                    rule: rule,
                                    error: error
                                });
                            }
                        })).catch((e)=>{
                        console.error("Error loading remote css", e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push($c79d972fbc7be79a$var$fetchCSS(sheet.href).then((metadata)=>$c79d972fbc7be79a$var$embedFonts(metadata, options)).then((cssText)=>$c79d972fbc7be79a$var$parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, sheet.cssRules.length);
                })).catch((err)=>{
                console.error("Error loading remote stylesheet", err);
            }));
            console.error("Error inlining remote css file", e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ("cssRules" in sheet) try {
                (0, $b5c344f7d64514e2$export$45b10814cc054894)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function $c79d972fbc7be79a$var$getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, $0f21e13064978b66$export$7b668369e5eab853)(rule.style.getPropertyValue("src")));
}
async function $c79d972fbc7be79a$var$parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error("Provided element is not within a Document");
    const styleSheets = (0, $b5c344f7d64514e2$export$45b10814cc054894)(node.ownerDocument.styleSheets);
    const cssRules = await $c79d972fbc7be79a$var$getCSSRules(styleSheets, options);
    return $c79d972fbc7be79a$var$getWebFontRules(cssRules);
}
async function $c79d972fbc7be79a$export$253c9aa3d83a57b6(node, options) {
    const rules = await $c79d972fbc7be79a$var$parseWebFontRules(node, options);
    const cssTexts = await Promise.all(rules.map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, $0f21e13064978b66$export$3d88803585cbbc21)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join("\n");
}
async function $c79d972fbc7be79a$export$2c2c83b77c8cb421(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await $c79d972fbc7be79a$export$253c9aa3d83a57b6(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement("style");
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}



async function $be6363d64e26fd5d$export$20d300cb2d558b7(node, options = {}) {
    const { width: width, height: height } = (0, $b5c344f7d64514e2$export$ada5537b2c061996)(node, options);
    const clonedNode = await (0, $98062e4a43f97b80$export$ae8e35ea29ddac22)(node, options, true);
    await (0, $c79d972fbc7be79a$export$2c2c83b77c8cb421)(clonedNode, options);
    await (0, $e8b4f8edae07017b$export$6660fa8dd20e53aa)(clonedNode, options);
    (0, $e3bea5c5b0507577$export$d63a6b7859608045)(clonedNode, options);
    const datauri = await (0, $b5c344f7d64514e2$export$b62810fb8ca515fa)(clonedNode, width, height);
    return datauri;
}
async function $be6363d64e26fd5d$export$f87f6982d1fd4f81(node, options = {}) {
    const { width: width, height: height } = (0, $b5c344f7d64514e2$export$ada5537b2c061996)(node, options);
    const svg = await $be6363d64e26fd5d$export$20d300cb2d558b7(node, options);
    const img = await (0, $b5c344f7d64514e2$export$ec664d7487540b)(svg);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const ratio = options.pixelRatio || (0, $b5c344f7d64514e2$export$d39ce20a37bba061)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, $b5c344f7d64514e2$export$c2c809a2fe6b0f1a)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function $be6363d64e26fd5d$export$6f9e32581c0cde11(node, options = {}) {
    const { width: width, height: height } = (0, $b5c344f7d64514e2$export$ada5537b2c061996)(node, options);
    const canvas = await $be6363d64e26fd5d$export$f87f6982d1fd4f81(node, options);
    const ctx = canvas.getContext("2d");
    return ctx.getImageData(0, 0, width, height).data;
}
async function $be6363d64e26fd5d$export$aba256f33615c92e(node, options = {}) {
    const canvas = await $be6363d64e26fd5d$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL();
}
async function $be6363d64e26fd5d$export$ed218bd2440d33a5(node, options = {}) {
    const canvas = await $be6363d64e26fd5d$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL("image/jpeg", options.quality || 1);
}
async function $be6363d64e26fd5d$export$b20f4ee19ffa0668(node, options = {}) {
    const canvas = await $be6363d64e26fd5d$export$f87f6982d1fd4f81(node, options);
    const blob = await (0, $b5c344f7d64514e2$export$403d539f215df596)(canvas);
    return blob;
}
async function $be6363d64e26fd5d$export$92678bad7eef403b(node, options = {}) {
    return (0, $c79d972fbc7be79a$export$253c9aa3d83a57b6)(node, options);
}


const $43a7a81378273f81$var$exportImage = async (element, type)=>{
    const filter = (element)=>{
        const exclusionClasses = [
            "remove-me",
            "secret-div"
        ];
        return !exclusionClasses.some((classname)=>element.classList?.contains(classname));
    };
    if (type == "png") (0, $be6363d64e26fd5d$export$aba256f33615c92e)(element.current, {
        cacheBust: true,
        backgroundColor: "#FFFFFF",
        filter: filter
    }).then((dataUrl)=>{
        const link = document.createElement("a");
        link.download = "wevrChart.png";
        link.href = dataUrl;
        link.click();
    }).catch((err)=>{
        console.error(err);
    });
    if (type == "jpeg") (0, $be6363d64e26fd5d$export$ed218bd2440d33a5)(element.current, {
        cacheBust: true,
        backgroundColor: "#FFFFFF",
        filter: filter
    }).then((dataUrl)=>{
        const link = document.createElement("a");
        link.download = "wevrChart.jpeg";
        link.href = dataUrl;
        link.click();
    }).catch((err)=>{
        console.error(err);
    });
    if (type == "svg") (0, $be6363d64e26fd5d$export$20d300cb2d558b7)(element.current, {
        cacheBust: true,
        backgroundColor: "#FFFFFF",
        filter: filter
    }).then((dataUrl)=>{
        const link = document.createElement("a");
        link.download = "wevrChart.svg";
        link.href = dataUrl;
        link.click();
    }).catch((err)=>{
        console.error(err);
    });
};
var $43a7a81378273f81$export$2e2bcd8739ae039 = $43a7a81378273f81$var$exportImage;


/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/ 
var $exYeM = parcelRequire("exYeM");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $93031e4206e8e991$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $93031e4206e8e991$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $93031e4206e8e991$export$803cd8101b6c182b = /*#__PURE__*/ $93031e4206e8e991$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[0], side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[1]), []);
const $93031e4206e8e991$export$96ec731ed4dcb222 = Math.min;
const $93031e4206e8e991$export$8960430cfd85939f = Math.max;
const $93031e4206e8e991$export$2077e0241d6afd3c = Math.round;
const $93031e4206e8e991$export$a3fe094919f356fd = Math.floor;
const $93031e4206e8e991$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $93031e4206e8e991$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $93031e4206e8e991$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $93031e4206e8e991$export$7d15b64cf5a3a4c4(start, value, end) {
    return $93031e4206e8e991$export$8960430cfd85939f(start, $93031e4206e8e991$export$96ec731ed4dcb222(value, end));
}
function $93031e4206e8e991$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $93031e4206e8e991$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $93031e4206e8e991$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $93031e4206e8e991$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $93031e4206e8e991$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $93031e4206e8e991$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($93031e4206e8e991$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $93031e4206e8e991$export$2b57e0052a6d6d4c(placement) {
    return $93031e4206e8e991$export$8a000a963141ac32($93031e4206e8e991$export$f28e8f882010718a(placement));
}
function $93031e4206e8e991$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    const alignmentAxis = $93031e4206e8e991$export$2b57e0052a6d6d4c(placement);
    const length = $93031e4206e8e991$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $93031e4206e8e991$export$496432a3699e50b1(placement) {
    const oppositePlacement = $93031e4206e8e991$export$9c5e28bad23365fa(placement);
    return [
        $93031e4206e8e991$export$2b182c584985588b(placement),
        oppositePlacement,
        $93031e4206e8e991$export$2b182c584985588b(oppositePlacement)
    ];
}
function $93031e4206e8e991$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$93031e4206e8e991$var$oppositeAlignmentMap[alignment]);
}
function $93031e4206e8e991$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $93031e4206e8e991$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    let list = $93031e4206e8e991$var$getSideList($93031e4206e8e991$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($93031e4206e8e991$export$2b182c584985588b));
    }
    return list;
}
function $93031e4206e8e991$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$93031e4206e8e991$var$oppositeSideMap[side]);
}
function $93031e4206e8e991$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $93031e4206e8e991$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $93031e4206e8e991$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $93031e4206e8e991$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $28f1bf2594995773$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $93031e4206e8e991$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $93031e4206e8e991$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $93031e4206e8e991$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $28f1bf2594995773$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $28f1bf2594995773$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28f1bf2594995773$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $93031e4206e8e991$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $93031e4206e8e991$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $28f1bf2594995773$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $93031e4206e8e991$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28f1bf2594995773$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $93031e4206e8e991$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $93031e4206e8e991$export$803cd8101b6c182b) ? $28f1bf2594995773$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $93031e4206e8e991$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $93031e4206e8e991$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $93031e4206e8e991$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28f1bf2594995773$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $93031e4206e8e991$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $93031e4206e8e991$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $93031e4206e8e991$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $93031e4206e8e991$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $28f1bf2594995773$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $28f1bf2594995773$var$isAnySideFullyClipped(overflow) {
    return (0, $93031e4206e8e991$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28f1bf2594995773$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $28f1bf2594995773$var$getBoundingRect(rects) {
    const minX = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $93031e4206e8e991$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $93031e4206e8e991$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $28f1bf2594995773$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $93031e4206e8e991$export$ee05aea0aeecbad4)($28f1bf2594995773$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28f1bf2594995773$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $28f1bf2594995773$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)($28f1bf2594995773$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $93031e4206e8e991$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $28f1bf2594995773$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28f1bf2594995773$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $28f1bf2594995773$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28f1bf2594995773$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)((0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $93031e4206e8e991$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28f1bf2594995773$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $93031e4206e8e991$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28f1bf2594995773$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $93031e4206e8e991$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $93031e4206e8e991$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $44e0f21d4eb6a5a0$export$651544f548703224(node) {
    if ($44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $44e0f21d4eb6a5a0$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).Node;
}
function $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).Element;
}
function $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).HTMLElement;
}
function $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $44e0f21d4eb6a5a0$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $44e0f21d4eb6a5a0$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $44e0f21d4eb6a5a0$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($44e0f21d4eb6a5a0$export$651544f548703224(element));
}
function $44e0f21d4eb6a5a0$export$d6c4e8150c35fed1(element) {
    const webkit = $44e0f21d4eb6a5a0$export$78551043582a6a98();
    const css = $44e0f21d4eb6a5a0$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $44e0f21d4eb6a5a0$export$940d8225183e1404(element) {
    let currentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(element);
    while($44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(currentNode) && !$44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(currentNode)){
        if ($44e0f21d4eb6a5a0$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $44e0f21d4eb6a5a0$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($44e0f21d4eb6a5a0$export$651544f548703224(node));
}
function $44e0f21d4eb6a5a0$export$3735103072e4a80(element) {
    return $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $44e0f21d4eb6a5a0$export$dc8fc79fa2800137(element) {
    if ($44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(node) {
    if ($44e0f21d4eb6a5a0$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $44e0f21d4eb6a5a0$export$e495491855dc5418(node);
    return $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(node) {
    const parentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(node);
    if ($44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(parentNode) && $44e0f21d4eb6a5a0$export$989e911fa9af580a(parentNode)) return parentNode;
    return $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(parentNode);
}
function $44e0f21d4eb6a5a0$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $44e0f21d4eb6a5a0$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $44e0f21d4eb6a5a0$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $44e0f21d4eb6a5a0$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $729e420fd9c85e8f$var$getCssDimensions(element) {
    const css = (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $93031e4206e8e991$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $93031e4206e8e991$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $729e420fd9c85e8f$var$unwrapElement(element) {
    return !(0, $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $729e420fd9c85e8f$var$getScale(element) {
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    if (!(0, $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa)(domElement)) return (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $729e420fd9c85e8f$var$getCssDimensions(domElement);
    let x = ($ ? (0, $93031e4206e8e991$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $93031e4206e8e991$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $729e420fd9c85e8f$var$noOffsets = /*#__PURE__*/ (0, $93031e4206e8e991$export$a397704b5e280835)(0);
function $729e420fd9c85e8f$var$getVisualOffsets(element) {
    const win = (0, $44e0f21d4eb6a5a0$export$38b2d434cce3ea22)(element);
    if (!(0, $44e0f21d4eb6a5a0$export$78551043582a6a98)() || !win.visualViewport) return $729e420fd9c85e8f$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $729e420fd9c85e8f$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $44e0f21d4eb6a5a0$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $729e420fd9c85e8f$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    let scale = (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d)(offsetParent)) scale = $729e420fd9c85e8f$var$getScale(offsetParent);
        } else scale = $729e420fd9c85e8f$var$getScale(element);
    }
    const visualOffsets = $729e420fd9c85e8f$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $729e420fd9c85e8f$var$getVisualOffsets(domElement) : (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $44e0f21d4eb6a5a0$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $44e0f21d4eb6a5a0$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $729e420fd9c85e8f$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $44e0f21d4eb6a5a0$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $93031e4206e8e991$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $729e420fd9c85e8f$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $729e420fd9c85e8f$var$isTopLayer(floating) {
    return $729e420fd9c85e8f$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $44e0f21d4eb6a5a0$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $729e420fd9c85e8f$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const offsets = (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $44e0f21d4eb6a5a0$export$651544f548703224)(offsetParent) !== "body" || (0, $44e0f21d4eb6a5a0$export$989e911fa9af580a)(documentElement)) scroll = (0, $44e0f21d4eb6a5a0$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent);
            scale = $729e420fd9c85e8f$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $729e420fd9c85e8f$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $729e420fd9c85e8f$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $729e420fd9c85e8f$var$getBoundingClientRect((0, $44e0f21d4eb6a5a0$export$e495491855dc5418)(element)).left + (0, $44e0f21d4eb6a5a0$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $729e420fd9c85e8f$var$getDocumentRect(element) {
    const html = (0, $44e0f21d4eb6a5a0$export$e495491855dc5418)(element);
    const scroll = (0, $44e0f21d4eb6a5a0$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $93031e4206e8e991$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $93031e4206e8e991$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $729e420fd9c85e8f$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(body).direction === "rtl") x += (0, $93031e4206e8e991$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getViewportRect(element, strategy) {
    const win = (0, $44e0f21d4eb6a5a0$export$38b2d434cce3ea22)(element);
    const html = (0, $44e0f21d4eb6a5a0$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $44e0f21d4eb6a5a0$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $729e420fd9c85e8f$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa)(element) ? $729e420fd9c85e8f$var$getScale(element) : (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $729e420fd9c85e8f$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $729e420fd9c85e8f$var$getDocumentRect((0, $44e0f21d4eb6a5a0$export$e495491855dc5418)(element));
    else if ((0, $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $729e420fd9c85e8f$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $729e420fd9c85e8f$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(rect);
}
function $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $44e0f21d4eb6a5a0$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d)(parentNode) || (0, $44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(parentNode).position === "fixed" || $729e420fd9c85e8f$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $729e420fd9c85e8f$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $44e0f21d4eb6a5a0$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d)(el) && (0, $44e0f21d4eb6a5a0$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $44e0f21d4eb6a5a0$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d)(currentNode) && !(0, $44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $44e0f21d4eb6a5a0$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $44e0f21d4eb6a5a0$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $44e0f21d4eb6a5a0$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $729e420fd9c85e8f$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $729e420fd9c85e8f$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $93031e4206e8e991$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $93031e4206e8e991$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $729e420fd9c85e8f$var$getDimensions(element) {
    const { width: width, height: height } = $729e420fd9c85e8f$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $44e0f21d4eb6a5a0$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $44e0f21d4eb6a5a0$export$651544f548703224)(offsetParent) !== "body" || (0, $44e0f21d4eb6a5a0$export$989e911fa9af580a)(documentElement)) scroll = (0, $44e0f21d4eb6a5a0$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $729e420fd9c85e8f$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa)(element) || (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $729e420fd9c85e8f$var$getOffsetParent(element, polyfill) {
    const window = (0, $44e0f21d4eb6a5a0$export$38b2d434cce3ea22)(element);
    if (!(0, $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa)(element) || $729e420fd9c85e8f$var$isTopLayer(element)) return window;
    let offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $44e0f21d4eb6a5a0$export$71535ffaa902797f)(offsetParent) && (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $44e0f21d4eb6a5a0$export$651544f548703224)(offsetParent) === "html" || (0, $44e0f21d4eb6a5a0$export$651544f548703224)(offsetParent) === "body" && (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $44e0f21d4eb6a5a0$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $44e0f21d4eb6a5a0$export$940d8225183e1404)(element) || window;
}
const $729e420fd9c85e8f$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $729e420fd9c85e8f$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(data.floating)
        }
    };
};
function $729e420fd9c85e8f$var$isRTL(element) {
    return (0, $44e0f21d4eb6a5a0$export$3735103072e4a80)(element).direction === "rtl";
}
const $729e420fd9c85e8f$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $44e0f21d4eb6a5a0$export$e495491855dc5418,
    getClippingRect: $729e420fd9c85e8f$var$getClippingRect,
    getOffsetParent: $729e420fd9c85e8f$var$getOffsetParent,
    getElementRects: $729e420fd9c85e8f$var$getElementRects,
    getClientRects: $729e420fd9c85e8f$var$getClientRects,
    getDimensions: $729e420fd9c85e8f$var$getDimensions,
    getScale: $729e420fd9c85e8f$var$getScale,
    isElement: $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d,
    isRTL: $729e420fd9c85e8f$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $729e420fd9c85e8f$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $44e0f21d4eb6a5a0$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $93031e4206e8e991$export$a3fe094919f356fd)(top);
        const insetRight = (0, $93031e4206e8e991$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $93031e4206e8e991$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $93031e4206e8e991$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $93031e4206e8e991$export$8960430cfd85939f)(0, (0, $93031e4206e8e991$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $729e420fd9c85e8f$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $729e420fd9c85e8f$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $44e0f21d4eb6a5a0$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $44e0f21d4eb6a5a0$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $729e420fd9c85e8f$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $729e420fd9c85e8f$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $729e420fd9c85e8f$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $729e420fd9c85e8f$export$91fb6ecbd551914 = (0, $28f1bf2594995773$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $729e420fd9c85e8f$export$fba63a578e423eb = (0, $28f1bf2594995773$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $729e420fd9c85e8f$export$8a83211c878a3f1f = (0, $28f1bf2594995773$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $729e420fd9c85e8f$export$346677f925de839c = (0, $28f1bf2594995773$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $729e420fd9c85e8f$export$fe8985bb6374093c = (0, $28f1bf2594995773$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $729e420fd9c85e8f$export$f2120bbfa5450bd2 = (0, $28f1bf2594995773$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $729e420fd9c85e8f$export$18c8ad048e32c7d5 = (0, $28f1bf2594995773$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $729e420fd9c85e8f$export$7bf07e38f3dc4b69 = (0, $28f1bf2594995773$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $729e420fd9c85e8f$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $729e420fd9c85e8f$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $28f1bf2594995773$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $eH0la = parcelRequire("eH0la");

var $6qd2L = parcelRequire("6qd2L");
const $6569f55e54f7ff9d$var$f = "react-tooltip-core-styles", $6569f55e54f7ff9d$var$h = "react-tooltip-base-styles", $6569f55e54f7ff9d$var$w = {
    core: !1,
    base: !1
};
function $6569f55e54f7ff9d$var$b({ css: e, id: t = $6569f55e54f7ff9d$var$h, type: r = "base", ref: o }) {
    var n, l;
    if (!e || "undefined" == typeof document || $6569f55e54f7ff9d$var$w[r]) return;
    if ("core" === r && "undefined" != typeof $6qd2L && (null === (n = null === $6qd2L || void 0 === $6qd2L ? void 0 : $6qd2L.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
    if ("base" !== r && "undefined" != typeof $6qd2L && (null === (l = null === $6qd2L || void 0 === $6qd2L ? void 0 : $6qd2L.env) || void 0 === l ? void 0 : l.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
    "core" === r && (t = $6569f55e54f7ff9d$var$f), o || (o = {});
    const { insertAt: i } = o;
    if (document.getElementById(t)) return void console.warn(`[react-tooltip] Element with id '${t}' already exists. Call \`removeStyle()\` first`);
    const c = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
    a.id = t, a.type = "text/css", "top" === i && c.firstChild ? c.insertBefore(a, c.firstChild) : c.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e)), $6569f55e54f7ff9d$var$w[r] = !0;
}
function $6569f55e54f7ff9d$export$afe978aceb0adefd({ type: e = "base", id: t = $6569f55e54f7ff9d$var$h } = {}) {
    if (!$6569f55e54f7ff9d$var$w[e]) return;
    "core" === e && (t = $6569f55e54f7ff9d$var$f);
    const r = document.getElementById(t);
    "style" === (null == r ? void 0 : r.tagName) ? null == r || r.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), $6569f55e54f7ff9d$var$w[e] = !1;
}
const $6569f55e54f7ff9d$var$E = (e, t, r)=>{
    let o = null;
    return function(...n) {
        const l = ()=>{
            o = null, r || e.apply(this, n);
        };
        r && !o && (e.apply(this, n), o = setTimeout(l, t)), r || (o && clearTimeout(o), o = setTimeout(l, t));
    };
}, $6569f55e54f7ff9d$var$_ = "DEFAULT_TOOLTIP_ID", $6569f55e54f7ff9d$var$g = {
    anchorRefs: new Set,
    activeAnchor: {
        current: null
    },
    attach: ()=>{},
    detach: ()=>{},
    setActiveAnchor: ()=>{}
}, $6569f55e54f7ff9d$var$A = (0, $exYeM.createContext)({
    getTooltipData: ()=>$6569f55e54f7ff9d$var$g
}), $6569f55e54f7ff9d$export$f78649fb9ca566b8 = ({ children: t })=>{
    const [l, i] = (0, $exYeM.useState)({
        [$6569f55e54f7ff9d$var$_]: new Set
    }), [c, a] = (0, $exYeM.useState)({
        [$6569f55e54f7ff9d$var$_]: {
            current: null
        }
    }), s = (e, ...t)=>{
        i((r)=>{
            var o;
            const n = null !== (o = r[e]) && void 0 !== o ? o : new Set;
            return t.forEach((e)=>n.add(e)), {
                ...r,
                [e]: new Set(n)
            };
        });
    }, u = (e, ...t)=>{
        i((r)=>{
            const o = r[e];
            return o ? (t.forEach((e)=>o.delete(e)), {
                ...r
            }) : r;
        });
    }, d = (0, $exYeM.useCallback)((e = $6569f55e54f7ff9d$var$_)=>{
        var t, r;
        return {
            anchorRefs: null !== (t = l[e]) && void 0 !== t ? t : new Set,
            activeAnchor: null !== (r = c[e]) && void 0 !== r ? r : {
                current: null
            },
            attach: (...t)=>s(e, ...t),
            detach: (...t)=>u(e, ...t),
            setActiveAnchor: (t)=>((e, t)=>{
                    a((r)=>{
                        var o;
                        return (null === (o = r[e]) || void 0 === o ? void 0 : o.current) === t.current ? r : {
                            ...r,
                            [e]: t
                        };
                    });
                })(e, t)
        };
    }, [
        l,
        c,
        s,
        u
    ]), p = (0, $exYeM.useMemo)(()=>({
            getTooltipData: d
        }), [
        d
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6569f55e54f7ff9d$var$A.Provider, {
        value: p
    }, t);
};
function $6569f55e54f7ff9d$var$O(e = $6569f55e54f7ff9d$var$_) {
    return (0, $exYeM.useContext)($6569f55e54f7ff9d$var$A).getTooltipData(e);
}
const $6569f55e54f7ff9d$export$57a09c4864b20b90 = ({ tooltipId: t, children: r, className: o, place: n, content: l, html: a, variant: s, offset: u, wrapper: d, events: p, positionStrategy: v, delayShow: m, delayHide: f })=>{
    const { attach: h, detach: w } = $6569f55e54f7ff9d$var$O(t), b = (0, $exYeM.useRef)(null);
    return (0, $exYeM.useEffect)(()=>(h(b), ()=>{
            w(b);
        }), []), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        ref: b,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($eH0la)))("react-tooltip-wrapper", o),
        "data-tooltip-place": n,
        "data-tooltip-content": l,
        "data-tooltip-html": a,
        "data-tooltip-variant": s,
        "data-tooltip-offset": u,
        "data-tooltip-wrapper": d,
        "data-tooltip-events": p,
        "data-tooltip-position-strategy": v,
        "data-tooltip-delay-show": m,
        "data-tooltip-delay-hide": f
    }, r);
}, $6569f55e54f7ff9d$var$R = "undefined" != typeof window ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect), $6569f55e54f7ff9d$var$N = (e)=>{
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return [
        "overflow",
        "overflow-x",
        "overflow-y"
    ].some((e)=>{
        const r = t.getPropertyValue(e);
        return "auto" === r || "scroll" === r;
    });
}, $6569f55e54f7ff9d$var$k = (e)=>{
    if (!e) return null;
    let t = e.parentElement;
    for(; t;){
        if ($6569f55e54f7ff9d$var$N(t)) return t;
        t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
}, $6569f55e54f7ff9d$var$x = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: r = null, place: o = "top", offset: n = 10, strategy: l = "absolute", middlewares: i = [
    (0, $28f1bf2594995773$export$cc800923e997bb8)(Number(n)),
    (0, $729e420fd9c85e8f$export$8a83211c878a3f1f)(),
    (0, $729e420fd9c85e8f$export$fba63a578e423eb)({
        padding: 5
    })
], border: c })=>{
    if (!e) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: o
    };
    if (null === t) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: o
    };
    const a = i;
    return r ? (a.push((0, $729e420fd9c85e8f$export$f2120bbfa5450bd2)({
        element: r,
        padding: 5
    })), (0, $729e420fd9c85e8f$export$48a53dcb22e581d0)(e, t, {
        placement: o,
        strategy: l,
        middleware: a
    }).then(({ x: e, y: t, placement: r, middlewareData: o })=>{
        var n, l;
        const i = {
            left: `${e}px`,
            top: `${t}px`,
            border: c
        }, { x: a, y: s } = null !== (n = o.arrow) && void 0 !== n ? n : {
            x: 0,
            y: 0
        }, u = null !== (l = ({
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        })[r.split("-")[0]]) && void 0 !== l ? l : "bottom", d = c && {
            borderBottom: c,
            borderRight: c
        };
        let p = 0;
        if (c) {
            const e = `${c}`.match(/(\d+)px/);
            p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
        }
        return {
            tooltipStyles: i,
            tooltipArrowStyles: {
                left: null != a ? `${a}px` : "",
                top: null != s ? `${s}px` : "",
                right: "",
                bottom: "",
                ...d,
                [u]: `-${4 + p}px`
            },
            place: r
        };
    })) : (0, $729e420fd9c85e8f$export$48a53dcb22e581d0)(e, t, {
        placement: "bottom",
        strategy: l,
        middleware: a
    }).then(({ x: e, y: t, placement: r })=>({
            tooltipStyles: {
                left: `${e}px`,
                top: `${t}px`
            },
            tooltipArrowStyles: {},
            place: r
        }));
};
var $6569f55e54f7ff9d$var$C = "core-styles-module_tooltip__3vRRp", $6569f55e54f7ff9d$var$$ = "core-styles-module_fixed__pcSol", $6569f55e54f7ff9d$var$I = "core-styles-module_arrow__cvMwQ", $6569f55e54f7ff9d$var$j = "core-styles-module_noArrow__xock6", $6569f55e54f7ff9d$var$B = "core-styles-module_clickable__ZuTTB", $6569f55e54f7ff9d$var$D = "core-styles-module_show__Nt9eE", $6569f55e54f7ff9d$var$H = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
};
const $6569f55e54f7ff9d$var$z = ({ id: t, className: n, classNameArrow: l, variant: a = "dark", anchorId: s, anchorSelect: u, place: d = "top", offset: p = 10, events: v = [
    "hover"
], openOnClick: f = !1, positionStrategy: h = "absolute", middlewares: w, wrapper: b, delayShow: S = 0, delayHide: _ = 0, float: g = !1, hidden: A = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: N = !1, closeOnScroll: z = !1, closeOnResize: q = !1, style: W, position: M, afterShow: P, afterHide: F, content: K, contentWrapperRef: U, isOpen: X, setIsOpen: Y, activeAnchor: V, setActiveAnchor: Z, border: G, opacity: J, arrowColor: Q })=>{
    const ee = (0, $exYeM.useRef)(null), te = (0, $exYeM.useRef)(null), re = (0, $exYeM.useRef)(null), oe = (0, $exYeM.useRef)(null), [ne, le] = (0, $exYeM.useState)(d), [ie, ce] = (0, $exYeM.useState)({}), [ae, se] = (0, $exYeM.useState)({}), [ue, de] = (0, $exYeM.useState)(!1), [pe, ve] = (0, $exYeM.useState)(!1), me = (0, $exYeM.useRef)(!1), ye = (0, $exYeM.useRef)(null), { anchorRefs: fe, setActiveAnchor: he } = $6569f55e54f7ff9d$var$O(t), we = (0, $exYeM.useRef)(!1), [be, Se] = (0, $exYeM.useState)([]), Ee = (0, $exYeM.useRef)(!1), _e = f || v.includes("click");
    $6569f55e54f7ff9d$var$R(()=>(Ee.current = !0, ()=>{
            Ee.current = !1;
        }), []), (0, $exYeM.useEffect)(()=>{
        if (!ue) {
            const e = setTimeout(()=>{
                ve(!1);
            }, 150);
            return ()=>{
                clearTimeout(e);
            };
        }
        return ()=>null;
    }, [
        ue
    ]);
    const ge = (e)=>{
        Ee.current && (e && ve(!0), setTimeout(()=>{
            Ee.current && (null == Y || Y(e), void 0 === X && de(e));
        }, 10));
    };
    (0, $exYeM.useEffect)(()=>{
        if (void 0 === X) return ()=>null;
        X && ve(!0);
        const e = setTimeout(()=>{
            de(X);
        }, 10);
        return ()=>{
            clearTimeout(e);
        };
    }, [
        X
    ]), (0, $exYeM.useEffect)(()=>{
        ue !== me.current && (me.current = ue, ue ? null == P || P() : null == F || F());
    }, [
        ue
    ]);
    const Ae = (e = _)=>{
        oe.current && clearTimeout(oe.current), oe.current = setTimeout(()=>{
            we.current || ge(!1);
        }, e);
    }, Te = (e)=>{
        var t;
        if (!e) return;
        const r = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == r ? void 0 : r.isConnected)) return Z(null), void he({
            current: null
        });
        S ? (re.current && clearTimeout(re.current), re.current = setTimeout(()=>{
            ge(!0);
        }, S)) : ge(!0), Z(r), he({
            current: r
        }), oe.current && clearTimeout(oe.current);
    }, Oe = ()=>{
        L ? Ae(_ || 100) : _ ? Ae() : ge(!1), re.current && clearTimeout(re.current);
    }, Le = ({ x: e, y: t })=>{
        $6569f55e54f7ff9d$var$x({
            place: d,
            offset: p,
            elementReference: {
                getBoundingClientRect: ()=>({
                        x: e,
                        y: t,
                        width: 0,
                        height: 0,
                        top: t,
                        left: e,
                        right: e,
                        bottom: t
                    })
            },
            tooltipReference: ee.current,
            tooltipArrowReference: te.current,
            strategy: h,
            middlewares: w,
            border: G
        }).then((e)=>{
            Object.keys(e.tooltipStyles).length && ce(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && se(e.tooltipArrowStyles), le(e.place);
        });
    }, Re = (e)=>{
        if (!e) return;
        const t = e, r = {
            x: t.clientX,
            y: t.clientY
        };
        Le(r), ye.current = r;
    }, Ne = (e)=>{
        Te(e), _ && Ae();
    }, ke = (e)=>{
        var t;
        [
            document.querySelector(`[id='${s}']`),
            ...be
        ].some((t)=>null == t ? void 0 : t.contains(e.target)) || (null === (t = ee.current) || void 0 === t ? void 0 : t.contains(e.target)) || (ge(!1), re.current && clearTimeout(re.current));
    }, xe = $6569f55e54f7ff9d$var$E(Te, 50, !0), Ce = $6569f55e54f7ff9d$var$E(Oe, 50, !0), $e = (0, $exYeM.useCallback)(()=>{
        M ? Le(M) : g ? ye.current && Le(ye.current) : $6569f55e54f7ff9d$var$x({
            place: d,
            offset: p,
            elementReference: V,
            tooltipReference: ee.current,
            tooltipArrowReference: te.current,
            strategy: h,
            middlewares: w,
            border: G
        }).then((e)=>{
            Ee.current && (Object.keys(e.tooltipStyles).length && ce(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && se(e.tooltipArrowStyles), le(e.place));
        });
    }, [
        ue,
        V,
        K,
        W,
        d,
        p,
        h,
        M,
        g
    ]);
    (0, $exYeM.useEffect)(()=>{
        var e, t;
        const r = new Set(fe);
        be.forEach((e)=>{
            r.add({
                current: e
            });
        });
        const o = document.querySelector(`[id='${s}']`);
        o && r.add({
            current: o
        });
        const n = ()=>{
            ge(!1);
        }, l = $6569f55e54f7ff9d$var$k(V), i = $6569f55e54f7ff9d$var$k(ee.current);
        z && (window.addEventListener("scroll", n), null == l || l.addEventListener("scroll", n), null == i || i.addEventListener("scroll", n));
        let c = null;
        q ? window.addEventListener("resize", n) : V && ee.current && (c = (0, $729e420fd9c85e8f$export$deee3a793edee05f)(V, ee.current, $e, {
            ancestorResize: !0,
            elementResize: !0,
            layoutShift: !0
        }));
        const a = (e)=>{
            "Escape" === e.key && ge(!1);
        };
        N && window.addEventListener("keydown", a);
        const u = [];
        _e ? (window.addEventListener("click", ke), u.push({
            event: "click",
            listener: Ne
        })) : (u.push({
            event: "mouseenter",
            listener: xe
        }, {
            event: "mouseleave",
            listener: Ce
        }, {
            event: "focus",
            listener: xe
        }, {
            event: "blur",
            listener: Ce
        }), g && u.push({
            event: "mousemove",
            listener: Re
        }));
        const d = ()=>{
            we.current = !0;
        }, p = ()=>{
            we.current = !1, Oe();
        };
        return L && !_e && (null === (e = ee.current) || void 0 === e || e.addEventListener("mouseenter", d), null === (t = ee.current) || void 0 === t || t.addEventListener("mouseleave", p)), u.forEach(({ event: e, listener: t })=>{
            r.forEach((r)=>{
                var o;
                null === (o = r.current) || void 0 === o || o.addEventListener(e, t);
            });
        }), ()=>{
            var e, t;
            z && (window.removeEventListener("scroll", n), null == l || l.removeEventListener("scroll", n), null == i || i.removeEventListener("scroll", n)), q ? window.removeEventListener("resize", n) : null == c || c(), _e && window.removeEventListener("click", ke), N && window.removeEventListener("keydown", a), L && !_e && (null === (e = ee.current) || void 0 === e || e.removeEventListener("mouseenter", d), null === (t = ee.current) || void 0 === t || t.removeEventListener("mouseleave", p)), u.forEach(({ event: e, listener: t })=>{
                r.forEach((r)=>{
                    var o;
                    null === (o = r.current) || void 0 === o || o.removeEventListener(e, t);
                });
            });
        };
    }, [
        V,
        $e,
        pe,
        fe,
        be,
        N,
        v
    ]), (0, $exYeM.useEffect)(()=>{
        let e = null != u ? u : "";
        !e && t && (e = `[data-tooltip-id='${t}']`);
        const r = new MutationObserver((r)=>{
            const o = [];
            r.forEach((r)=>{
                if ("attributes" === r.type && "data-tooltip-id" === r.attributeName) r.target.getAttribute("data-tooltip-id") === t && o.push(r.target);
                if ("childList" === r.type && (V && [
                    ...r.removedNodes
                ].some((e)=>{
                    var t;
                    return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, V)) && (ve(!1), ge(!1), Z(null), re.current && clearTimeout(re.current), oe.current && clearTimeout(oe.current), !0);
                }), e)) try {
                    const t = [
                        ...r.addedNodes
                    ].filter((e)=>1 === e.nodeType);
                    o.push(...t.filter((t)=>t.matches(e))), o.push(...t.flatMap((t)=>[
                            ...t.querySelectorAll(e)
                        ]));
                } catch (e) {}
            }), o.length && Se((e)=>[
                    ...e,
                    ...o
                ]);
        });
        return r.observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                "data-tooltip-id"
            ]
        }), ()=>{
            r.disconnect();
        };
    }, [
        t,
        u,
        V
    ]), (0, $exYeM.useEffect)(()=>{
        $e();
    }, [
        $e
    ]), (0, $exYeM.useEffect)(()=>{
        if (!(null == U ? void 0 : U.current)) return ()=>null;
        const e = new ResizeObserver(()=>{
            $e();
        });
        return e.observe(U.current), ()=>{
            e.disconnect();
        };
    }, [
        K,
        null == U ? void 0 : U.current
    ]), (0, $exYeM.useEffect)(()=>{
        var e;
        const t = document.querySelector(`[id='${s}']`), r = [
            ...be,
            t
        ];
        V && r.includes(V) || Z(null !== (e = be[0]) && void 0 !== e ? e : t);
    }, [
        s,
        be,
        V
    ]), (0, $exYeM.useEffect)(()=>()=>{
            re.current && clearTimeout(re.current), oe.current && clearTimeout(oe.current);
        }, []), (0, $exYeM.useEffect)(()=>{
        let e = u;
        if (!e && t && (e = `[data-tooltip-id='${t}']`), e) try {
            const t = Array.from(document.querySelectorAll(e));
            Se(t);
        } catch (e) {
            Se([]);
        }
    }, [
        t,
        u
    ]);
    const Ie = !A && K && ue && Object.keys(ie).length > 0;
    return pe ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(b, {
        id: t,
        role: "tooltip",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($eH0la)))("react-tooltip", $6569f55e54f7ff9d$var$C, $6569f55e54f7ff9d$var$H.tooltip, $6569f55e54f7ff9d$var$H[a], n, `react-tooltip__place-${ne}`, {
            "react-tooltip__show": Ie,
            [$6569f55e54f7ff9d$var$D]: Ie,
            [$6569f55e54f7ff9d$var$$]: "fixed" === h,
            [$6569f55e54f7ff9d$var$B]: L
        }),
        style: {
            ...W,
            ...ie,
            opacity: void 0 !== J && Ie ? J : void 0
        },
        ref: ee
    }, K, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(b, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($eH0la)))("react-tooltip-arrow", $6569f55e54f7ff9d$var$I, $6569f55e54f7ff9d$var$H.arrow, l, {
            [$6569f55e54f7ff9d$var$j]: T
        }),
        style: {
            ...ae,
            background: Q ? `linear-gradient(to right bottom, transparent 50%, ${Q} 50%)` : void 0
        },
        ref: te
    })) : null;
}, $6569f55e54f7ff9d$var$q = ({ content: t })=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t
        }
    }), $6569f55e54f7ff9d$export$28c660c63b792dea = ({ id: t, anchorId: o, anchorSelect: n, content: l, html: a, render: s, className: u, classNameArrow: d, variant: p = "dark", place: v = "top", offset: m = 10, wrapper: y = "div", children: f = null, events: h = [
    "hover"
], openOnClick: w = !1, positionStrategy: b = "absolute", middlewares: S, delayShow: E = 0, delayHide: _ = 0, float: g = !1, hidden: A = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: R = !1, closeOnScroll: N = !1, closeOnResize: k = !1, style: x, position: C, isOpen: $, disableStyleInjection: I = !1, border: j, opacity: B, arrowColor: D, setIsOpen: H, afterShow: W, afterHide: M })=>{
    const [P, F] = (0, $exYeM.useState)(l), [K, U] = (0, $exYeM.useState)(a), [X, Y] = (0, $exYeM.useState)(v), [V, Z] = (0, $exYeM.useState)(p), [G, J] = (0, $exYeM.useState)(m), [Q, ee] = (0, $exYeM.useState)(E), [te, re] = (0, $exYeM.useState)(_), [oe, ne] = (0, $exYeM.useState)(g), [le, ie] = (0, $exYeM.useState)(A), [ce, ae] = (0, $exYeM.useState)(y), [se, ue] = (0, $exYeM.useState)(h), [de, pe] = (0, $exYeM.useState)(b), [ve, me] = (0, $exYeM.useState)(null), ye = (0, $exYeM.useRef)(I), { anchorRefs: fe, activeAnchor: he } = $6569f55e54f7ff9d$var$O(t), we = (e)=>null == e ? void 0 : e.getAttributeNames().reduce((t, r)=>{
            var o;
            if (r.startsWith("data-tooltip-")) t[r.replace(/^data-tooltip-/, "")] = null !== (o = null == e ? void 0 : e.getAttribute(r)) && void 0 !== o ? o : null;
            return t;
        }, {}), be = (e)=>{
        const t = {
            place: (e)=>{
                var t;
                Y(null !== (t = e) && void 0 !== t ? t : v);
            },
            content: (e)=>{
                F(null != e ? e : l);
            },
            html: (e)=>{
                U(null != e ? e : a);
            },
            variant: (e)=>{
                var t;
                Z(null !== (t = e) && void 0 !== t ? t : p);
            },
            offset: (e)=>{
                J(null === e ? m : Number(e));
            },
            wrapper: (e)=>{
                var t;
                ae(null !== (t = e) && void 0 !== t ? t : y);
            },
            events: (e)=>{
                const t = null == e ? void 0 : e.split(" ");
                ue(null != t ? t : h);
            },
            "position-strategy": (e)=>{
                var t;
                pe(null !== (t = e) && void 0 !== t ? t : b);
            },
            "delay-show": (e)=>{
                ee(null === e ? E : Number(e));
            },
            "delay-hide": (e)=>{
                re(null === e ? _ : Number(e));
            },
            float: (e)=>{
                ne(null === e ? g : "true" === e);
            },
            hidden: (e)=>{
                ie(null === e ? A : "true" === e);
            }
        };
        Object.values(t).forEach((e)=>e(null)), Object.entries(e).forEach(([e, r])=>{
            var o;
            null === (o = t[e]) || void 0 === o || o.call(t, r);
        });
    };
    (0, $exYeM.useEffect)(()=>{
        F(l);
    }, [
        l
    ]), (0, $exYeM.useEffect)(()=>{
        U(a);
    }, [
        a
    ]), (0, $exYeM.useEffect)(()=>{
        Y(v);
    }, [
        v
    ]), (0, $exYeM.useEffect)(()=>{
        Z(p);
    }, [
        p
    ]), (0, $exYeM.useEffect)(()=>{
        J(m);
    }, [
        m
    ]), (0, $exYeM.useEffect)(()=>{
        ee(E);
    }, [
        E
    ]), (0, $exYeM.useEffect)(()=>{
        re(_);
    }, [
        _
    ]), (0, $exYeM.useEffect)(()=>{
        ne(g);
    }, [
        g
    ]), (0, $exYeM.useEffect)(()=>{
        ie(A);
    }, [
        A
    ]), (0, $exYeM.useEffect)(()=>{
        pe(b);
    }, [
        b
    ]), (0, $exYeM.useEffect)(()=>{
        ye.current !== I && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [
        I
    ]), (0, $exYeM.useEffect)(()=>{
        "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
            detail: {
                disableCore: "core" === I,
                disableBase: I
            }
        }));
    }, []), (0, $exYeM.useEffect)(()=>{
        var e;
        const r = new Set(fe);
        let l = n;
        if (!l && t && (l = `[data-tooltip-id='${t}']`), l) try {
            document.querySelectorAll(l).forEach((e)=>{
                r.add({
                    current: e
                });
            });
        } catch (e) {
            console.warn(`[react-tooltip] "${l}" is not a valid CSS selector`);
        }
        const i = document.querySelector(`[id='${o}']`);
        if (i && r.add({
            current: i
        }), !r.size) return ()=>null;
        const c = null !== (e = null != ve ? ve : i) && void 0 !== e ? e : he.current, a = new MutationObserver((e)=>{
            e.forEach((e)=>{
                var t;
                if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
                const r = we(c);
                be(r);
            });
        }), s = {
            attributes: !0,
            childList: !1,
            subtree: !1
        };
        if (c) {
            const e = we(c);
            be(e), a.observe(c, s);
        }
        return ()=>{
            a.disconnect();
        };
    }, [
        fe,
        he,
        ve,
        o,
        n
    ]), (0, $exYeM.useEffect)(()=>{
        (null == x ? void 0 : x.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), j && !CSS.supports("border", `${j}`) && console.warn(`[react-tooltip] "${j}" is not a valid \`border\`.`), (null == x ? void 0 : x.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), B && !CSS.supports("opacity", `${B}`) && console.warn(`[react-tooltip] "${B}" is not a valid \`opacity\`.`);
    }, []);
    let Se = f;
    const Ee = (0, $exYeM.useRef)(null);
    if (s) {
        const t = s({
            content: null != P ? P : null,
            activeAnchor: ve
        });
        Se = t ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            ref: Ee,
            className: "react-tooltip-content-wrapper"
        }, t) : null;
    } else P && (Se = P);
    K && (Se = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6569f55e54f7ff9d$var$q, {
        content: K
    }));
    const _e = {
        id: t,
        anchorId: o,
        anchorSelect: n,
        className: u,
        classNameArrow: d,
        content: Se,
        contentWrapperRef: Ee,
        place: X,
        variant: V,
        offset: G,
        wrapper: ce,
        events: se,
        openOnClick: w,
        positionStrategy: de,
        middlewares: S,
        delayShow: Q,
        delayHide: te,
        float: oe,
        hidden: le,
        noArrow: T,
        clickable: L,
        closeOnEsc: R,
        closeOnScroll: N,
        closeOnResize: k,
        style: x,
        position: C,
        isOpen: $,
        border: j,
        opacity: B,
        arrowColor: D,
        setIsOpen: H,
        afterShow: W,
        afterHide: M,
        activeAnchor: ve,
        setActiveAnchor: (e)=>me(e)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6569f55e54f7ff9d$var$z, {
        ..._e
    });
};
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", (e)=>{
    e.detail.disableCore || $6569f55e54f7ff9d$var$b({
        css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9}.core-styles-module_tooltip__3vRRp{visibility:hidden;position:absolute;top:0;left:0;pointer-events:none;opacity:0;transition:opacity 0.3s ease-out;will-change:opacity,visibility}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{visibility:visible;opacity:var(--rt-opacity)}`,
        type: "core"
    }), e.detail.disableBase || $6569f55e54f7ff9d$var$b({
        css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
        type: "base"
    });
});



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}


function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}







function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


var $935c50c8659545b7$export$1e95b668f3b82d = "top";
var $935c50c8659545b7$export$40e543e69a8b3fbb = "bottom";
var $935c50c8659545b7$export$79ffe56a765070d2 = "right";
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = "left";
var $935c50c8659545b7$export$dfb5619354ba860 = "auto";
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = "start";
var $935c50c8659545b7$export$bd5df0f255a350f8 = "end";
var $935c50c8659545b7$export$390fd549c5303b4d = "clippingParents";
var $935c50c8659545b7$export$d7b7311ec04a3e8f = "viewport";
var $935c50c8659545b7$export$ae5ab1c730825774 = "popper";
var $935c50c8659545b7$export$ca50aac9f3ba507f = "reference";
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = "beforeRead";
var $935c50c8659545b7$export$aafa59e2e03f2942 = "read";
var $935c50c8659545b7$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = "beforeMain";
var $935c50c8659545b7$export$f22da7240b7add18 = "main";
var $935c50c8659545b7$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = "beforeWrite";
var $935c50c8659545b7$export$68d8715fc104d294 = "write";
var $935c50c8659545b7$export$70a6e5159acce2e6 = "afterWrite";
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};










var $063d2297888fea12$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $8d644778f0e020f0$var$offset
};


var $d79ddf39683d3f91$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: "end",
    end: "start"
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}







function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $bba2b2857408f717$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $bba2b2857408f717$var$hasElementType = typeof Element !== "undefined";
var $bba2b2857408f717$var$hasMap = typeof Map === "function";
var $bba2b2857408f717$var$hasSet = typeof Set === "function";
var $bba2b2857408f717$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $bba2b2857408f717$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$bba2b2857408f717$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($bba2b2857408f717$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$bba2b2857408f717$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($bba2b2857408f717$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($bba2b2857408f717$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($bba2b2857408f717$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$bba2b2857408f717$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$bba2b2857408f717$exports = function isEqual(a, b) {
    try {
        return $bba2b2857408f717$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $exYeM = parcelRequire("exYeM");
var $09d07abddf506fbd$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $09d07abddf506fbd$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $09d07abddf506fbd$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $09d07abddf506fbd$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $09d07abddf506fbd$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $09d07abddf506fbd$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $exYeM.useLayoutEffect : $exYeM.useEffect;


var $d674741d7e6ed1a9$var$EMPTY_MODIFIERS = [];
var $d674741d7e6ed1a9$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $exYeM.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $d674741d7e6ed1a9$var$EMPTY_MODIFIERS
    };
    var _React$useState = $exYeM.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $exYeM.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $d2lNW.flushSync(function() {
                    setState({
                        styles: (0, $09d07abddf506fbd$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $09d07abddf506fbd$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $exYeM.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bba2b2857408f717$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $exYeM.useRef();
    (0, $09d07abddf506fbd$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $09d07abddf506fbd$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");







var $exYeM = parcelRequire("exYeM");













var $exYeM = parcelRequire("exYeM");

function $6de2ca57ca54b61f$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $exYeM.useRef)([]), r = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(u);
    (0, $exYeM.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}



function $afe24cbccd301f47$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}



function $6dd567c6dd8bfc62$var$P(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let r = new Set;
    for (let e of t.current)e.current instanceof HTMLElement && r.add(e.current);
    return r;
}
let $6dd567c6dd8bfc62$var$J = "div";
var $6dd567c6dd8bfc62$var$h = ((n)=>(n[n.None = 1] = "None", n[n.InitialFocus = 2] = "InitialFocus", n[n.TabLock = 4] = "TabLock", n[n.FocusLock = 8] = "FocusLock", n[n.RestoreFocus = 16] = "RestoreFocus", n[n.All = 30] = "All", n))($6dd567c6dd8bfc62$var$h || {});
function $6dd567c6dd8bfc62$var$X(t, r) {
    let e = (0, $exYeM.useRef)(null), o = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(e, r), { initialFocus: u, containers: i, features: n = 30, ...l } = t;
    (0, $eea6929722880e02$export$44ab2b9f2d09b0fa)() || (n = 1);
    let m = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)(e);
    $6dd567c6dd8bfc62$var$Y({
        ownerDocument: m
    }, Boolean(n & 16));
    let c = $6dd567c6dd8bfc62$var$Z({
        ownerDocument: m,
        container: e,
        initialFocus: u
    }, Boolean(n & 2));
    $6dd567c6dd8bfc62$var$$({
        ownerDocument: m,
        container: e,
        containers: i,
        previousActiveElement: c
    }, Boolean(n & 8));
    let v = (0, $58388cb581937808$export$19b797546aece48f)(), y = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s)=>{
        let T = e.current;
        if (!T) return;
        ((B)=>B())(()=>{
            (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(v.current, {
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(T, (0, $2786c78eeb568d2b$export$807a7eae502106e7).First, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                },
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(T, (0, $2786c78eeb568d2b$export$807a7eae502106e7).Last, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                }
            });
        });
    }), _ = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)(), b = (0, $exYeM.useRef)(!1), j = {
        ref: o,
        onKeyDown (s) {
            s.key == "Tab" && (b.current = !0, _.requestAnimationFrame(()=>{
                b.current = !1;
            }));
        },
        onBlur (s) {
            let T = $6dd567c6dd8bfc62$var$P(i);
            e.current instanceof HTMLElement && T.add(e.current);
            let d = s.relatedTarget;
            d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && ($6dd567c6dd8bfc62$var$S(T, d) || (b.current ? (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(e.current, (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(v.current, {
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $2786c78eeb568d2b$export$807a7eae502106e7).Next,
                [(0, $58388cb581937808$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $2786c78eeb568d2b$export$807a7eae502106e7).Previous
            }) | (0, $2786c78eeb568d2b$export$807a7eae502106e7).WrapAround, {
                relativeTo: s.target
            }) : s.target instanceof HTMLElement && (0, $2786c78eeb568d2b$export$5fed9cc43865dc7e)(s.target)));
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, Boolean(n & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: y,
        features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Focusable
    }), (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: j,
        theirProps: l,
        defaultTag: $6dd567c6dd8bfc62$var$J,
        name: "FocusTrap"
    }), Boolean(n & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: y,
        features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Focusable
    }));
}
let $6dd567c6dd8bfc62$var$z = (0, $6da0b689c34972b7$export$e43f39796049410c)($6dd567c6dd8bfc62$var$X), $6dd567c6dd8bfc62$export$34eba2437817a67b = Object.assign($6dd567c6dd8bfc62$var$z, {
    features: $6dd567c6dd8bfc62$var$h
}), $6dd567c6dd8bfc62$var$a = [];
(0, $afe24cbccd301f47$export$a6a2315df743a26b)(()=>{
    function t(r) {
        r.target instanceof HTMLElement && r.target !== document.body && $6dd567c6dd8bfc62$var$a[0] !== r.target && ($6dd567c6dd8bfc62$var$a.unshift(r.target), $6dd567c6dd8bfc62$var$a = $6dd567c6dd8bfc62$var$a.filter((e)=>e != null && e.isConnected), $6dd567c6dd8bfc62$var$a.splice(10));
    }
    window.addEventListener("click", t, {
        capture: !0
    }), window.addEventListener("mousedown", t, {
        capture: !0
    }), window.addEventListener("focus", t, {
        capture: !0
    }), document.body.addEventListener("click", t, {
        capture: !0
    }), document.body.addEventListener("mousedown", t, {
        capture: !0
    }), document.body.addEventListener("focus", t, {
        capture: !0
    });
});
function $6dd567c6dd8bfc62$var$Q(t = !0) {
    let r = (0, $exYeM.useRef)($6dd567c6dd8bfc62$var$a.slice());
    return (0, $6de2ca57ca54b61f$export$3c773aa2b84f29e0)(([e], [o])=>{
        o === !0 && e === !1 && (0, $92b943bceaf40d00$export$a5ff0d6a738703ca)(()=>{
            r.current.splice(0);
        }), o === !1 && e === !0 && (r.current = $6dd567c6dd8bfc62$var$a.slice());
    }, [
        t,
        $6dd567c6dd8bfc62$var$a,
        r
    ]), (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        var e;
        return (e = r.current.find((o)=>o != null && o.isConnected)) != null ? e : null;
    });
}
function $6dd567c6dd8bfc62$var$Y({ ownerDocument: t }, r) {
    let e = $6dd567c6dd8bfc62$var$Q(r);
    (0, $6de2ca57ca54b61f$export$3c773aa2b84f29e0)(()=>{
        r || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && (0, $2786c78eeb568d2b$export$5fed9cc43865dc7e)(e());
    }, [
        r
    ]), (0, $3a259e27b8b85809$export$cd059ee7fd0e9f3d)(()=>{
        r && (0, $2786c78eeb568d2b$export$5fed9cc43865dc7e)(e());
    });
}
function $6dd567c6dd8bfc62$var$Z({ ownerDocument: t, container: r, initialFocus: e }, o) {
    let u = (0, $exYeM.useRef)(null), i = (0, $a674dbdb004593f0$export$80c2a3957bcb42ea)();
    return (0, $6de2ca57ca54b61f$export$3c773aa2b84f29e0)(()=>{
        if (!o) return;
        let n = r.current;
        n && (0, $92b943bceaf40d00$export$a5ff0d6a738703ca)(()=>{
            if (!i.current) return;
            let l = t == null ? void 0 : t.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === l) {
                    u.current = l;
                    return;
                }
            } else if (n.contains(l)) {
                u.current = l;
                return;
            }
            e != null && e.current ? (0, $2786c78eeb568d2b$export$5fed9cc43865dc7e)(e.current) : (0, $2786c78eeb568d2b$export$82e1f4f412218a1d)(n, (0, $2786c78eeb568d2b$export$807a7eae502106e7).First) === (0, $2786c78eeb568d2b$export$abf286375dfa6dbd).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), u.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        o
    ]), u;
}
function $6dd567c6dd8bfc62$var$$({ ownerDocument: t, container: r, containers: e, previousActiveElement: o }, u) {
    let i = (0, $a674dbdb004593f0$export$80c2a3957bcb42ea)();
    (0, $b3d7b11c4d9c7c80$export$7080b3e976bc91ab)(t == null ? void 0 : t.defaultView, "focus", (n)=>{
        if (!u || !i.current) return;
        let l = $6dd567c6dd8bfc62$var$P(e);
        r.current instanceof HTMLElement && l.add(r.current);
        let m = o.current;
        if (!m) return;
        let c = n.target;
        c && c instanceof HTMLElement ? $6dd567c6dd8bfc62$var$S(l, c) ? (o.current = c, (0, $2786c78eeb568d2b$export$5fed9cc43865dc7e)(c)) : (n.preventDefault(), n.stopPropagation(), (0, $2786c78eeb568d2b$export$5fed9cc43865dc7e)(m)) : (0, $2786c78eeb568d2b$export$5fed9cc43865dc7e)(o.current);
    }, !0);
}
function $6dd567c6dd8bfc62$var$S(t, r) {
    for (let e of t)if (e.contains(r)) return !0;
    return !1;
}





var $exYeM = parcelRequire("exYeM");





let $c661dd91897b6639$var$d = (0, $exYeM.createContext)(null);
function $c661dd91897b6639$var$f() {
    let r = (0, $exYeM.useContext)($c661dd91897b6639$var$d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $c661dd91897b6639$var$f), t;
    }
    return r;
}
function $c661dd91897b6639$export$babde88292020af7() {
    let [r, t] = (0, $exYeM.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $exYeM.useMemo)(()=>function(e) {
                let i = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s)=>(t((o)=>[
                            ...o,
                            s
                        ]), ()=>t((o)=>{
                            let p = o.slice(), c = p.indexOf(s);
                            return c !== -1 && p.splice(c, 1), p;
                        }))), n = (0, $exYeM.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c661dd91897b6639$var$d.Provider, {
                    value: n
                }, e.children);
            }, [
            t
        ])
    ];
}
let $c661dd91897b6639$var$S = "p";
function $c661dd91897b6639$var$h(r, t) {
    let a = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: e = `headlessui-description-${a}`, ...i } = r, n = $c661dd91897b6639$var$f(), s = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(t);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>n.register(e), [
        e,
        n.register
    ]);
    let o = {
        ref: s,
        ...n.props,
        id: e
    };
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: i,
        slot: n.slot || {},
        defaultTag: $c661dd91897b6639$var$S,
        name: n.name || "Description"
    });
}
let $c661dd91897b6639$var$y = (0, $6da0b689c34972b7$export$e43f39796049410c)($c661dd91897b6639$var$h), $c661dd91897b6639$export$393edc798c47379d = Object.assign($c661dd91897b6639$var$y, {});





var $exYeM = parcelRequire("exYeM");


let $66cef126f02654a5$var$a = (0, $exYeM.createContext)(()=>{});
$66cef126f02654a5$var$a.displayName = "StackContext";
var $66cef126f02654a5$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($66cef126f02654a5$export$2dd25ef07fea092e || {});
function $66cef126f02654a5$export$59510f5936c4d8c4() {
    return (0, $exYeM.useContext)($66cef126f02654a5$var$a);
}
function $66cef126f02654a5$export$4aac1a6640027f56({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = $66cef126f02654a5$export$59510f5936c4d8c4(), o = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($66cef126f02654a5$var$a.Provider, {
        value: o
    }, i);
}








var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $eb40a93b0690d152$var$i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const $eb40a93b0690d152$var$d = typeof Object.is == "function" ? Object.is : $eb40a93b0690d152$var$i, { useState: $eb40a93b0690d152$var$u, useEffect: $eb40a93b0690d152$var$h, useLayoutEffect: $eb40a93b0690d152$var$f, useDebugValue: $eb40a93b0690d152$var$p } = $exYeM;
let $eb40a93b0690d152$var$S = !1, $eb40a93b0690d152$var$_ = !1;
function $eb40a93b0690d152$export$306c0aa65ff9ec16(e, t, c) {
    const a = t(), [{ inst: n }, o] = $eb40a93b0690d152$var$u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return $eb40a93b0690d152$var$f(()=>{
        n.value = a, n.getSnapshot = t, $eb40a93b0690d152$var$r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), $eb40a93b0690d152$var$h(()=>($eb40a93b0690d152$var$r(n) && o({
            inst: n
        }), e(()=>{
            $eb40a93b0690d152$var$r(n) && o({
                inst: n
            });
        })), [
        e
    ]), $eb40a93b0690d152$var$p(a), a;
}
function $eb40a93b0690d152$var$r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !$eb40a93b0690d152$var$d(c, a);
    } catch  {
        return !0;
    }
}


function $fe8f90e89cfbd41c$export$306c0aa65ff9ec16(r, e, n) {
    return e();
}


const $552d71293bfb258d$var$r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", $552d71293bfb258d$var$s = !$552d71293bfb258d$var$r, $552d71293bfb258d$var$c = $552d71293bfb258d$var$s ? (0, $fe8f90e89cfbd41c$export$306c0aa65ff9ec16) : (0, $eb40a93b0690d152$export$306c0aa65ff9ec16), $552d71293bfb258d$export$306c0aa65ff9ec16 = "useSyncExternalStore" in $exYeM ? ((n)=>n.useSyncExternalStore)($exYeM) : $552d71293bfb258d$var$c;


function $2a605c6a84a1eff3$export$6ccbb43953eebf8(t) {
    return (0, $552d71293bfb258d$export$306c0aa65ff9ec16)(t.subscribe, t.getSnapshot, t.getSnapshot);
}



function $e2500b8f4745ec78$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}


function $453d2c59fdaae3af$export$110627fb35ef9205() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}



function $db807a8c2e3628f5$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $db807a8c2e3628f5$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $db807a8c2e3628f5$export$d0a8044dce8ff2fc() {
    return $db807a8c2e3628f5$export$fedb369cb70207f1() || $db807a8c2e3628f5$export$a11b0059900ceec8();
}


function $26c1d74adfe2180f$export$e3a523dfabf27286() {
    if (!(0, $db807a8c2e3628f5$export$fedb369cb70207f1)()) return {};
    let l;
    return {
        before () {
            l = window.pageYOffset;
        },
        after ({ doc: o, d: t, meta: s }) {
            function i(n) {
                return s.containers.flatMap((e)=>e()).some((e)=>e.contains(n));
            }
            t.microTask(()=>{
                if (window.getComputedStyle(o.documentElement).scrollBehavior !== "auto") {
                    let e = (0, $fb27e053aa71d13a$export$12b26c28a05aa001)();
                    e.style(o.documentElement, "scroll-behavior", "auto"), t.add(()=>t.microTask(()=>e.dispose()));
                }
                t.style(o.body, "marginTop", `-${l}px`), window.scrollTo(0, 0);
                let n = null;
                t.addEventListener(o, "click", (e)=>{
                    if (e.target instanceof HTMLElement) try {
                        let r = e.target.closest("a");
                        if (!r) return;
                        let { hash: c } = new URL(r.href), a = o.querySelector(c);
                        a && !i(a) && (n = a);
                    } catch  {}
                }, !0), t.addEventListener(o, "touchmove", (e)=>{
                    e.target instanceof HTMLElement && !i(e.target) && e.preventDefault();
                }, {
                    passive: !1
                }), t.add(()=>{
                    window.scrollTo(0, window.pageYOffset + l), n && n.isConnected && (n.scrollIntoView({
                        block: "nearest"
                    }), n = null);
                });
            });
        }
    };
}


function $bcf8b95709b1a3a0$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $c8f7cccd8d0d9a6b$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $c8f7cccd8d0d9a6b$export$a4161f418919b5aa = (0, $e2500b8f4745ec78$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $fb27e053aa71d13a$export$12b26c28a05aa001)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $c8f7cccd8d0d9a6b$var$m(t)
        }, c = [
            (0, $26c1d74adfe2180f$export$e3a523dfabf27286)(),
            (0, $453d2c59fdaae3af$export$110627fb35ef9205)(),
            (0, $bcf8b95709b1a3a0$export$d8b6ff28805e84e9)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$c8f7cccd8d0d9a6b$export$a4161f418919b5aa.subscribe(()=>{
    let e = $c8f7cccd8d0d9a6b$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $c8f7cccd8d0d9a6b$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $c8f7cccd8d0d9a6b$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $57e3e5413375de7f$export$bb0ae4a42bcd9e0(e, r, n) {
    let f = (0, $2a605c6a84a1eff3$export$6ccbb43953eebf8)((0, $c8f7cccd8d0d9a6b$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $c8f7cccd8d0d9a6b$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $c8f7cccd8d0d9a6b$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}



let $cb0c82ea2ca65660$var$u = new Map, $cb0c82ea2ca65660$var$t = new Map;
function $cb0c82ea2ca65660$export$bbe4e2927a3450da(r, l = !0) {
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        var o;
        if (!l) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function a() {
            var d;
            if (!e) return;
            let i = (d = $cb0c82ea2ca65660$var$t.get(e)) != null ? d : 1;
            if (i === 1 ? $cb0c82ea2ca65660$var$t.delete(e) : $cb0c82ea2ca65660$var$t.set(e, i - 1), i !== 1) return;
            let n = $cb0c82ea2ca65660$var$u.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, $cb0c82ea2ca65660$var$u.delete(e));
        }
        let f = (o = $cb0c82ea2ca65660$var$t.get(e)) != null ? o : 0;
        return $cb0c82ea2ca65660$var$t.set(e, f + 1), f !== 0 || ($cb0c82ea2ca65660$var$u.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
    }, [
        r,
        l
    ]);
}



var $8822e71bc1e566e5$var$_e = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($8822e71bc1e566e5$var$_e || {}), $8822e71bc1e566e5$var$Ie = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($8822e71bc1e566e5$var$Ie || {});
let $8822e71bc1e566e5$var$Me = {
    [0] (t, e) {
        return t.titleId === e.id ? t : {
            ...t,
            titleId: e.id
        };
    }
}, $8822e71bc1e566e5$var$I = (0, $exYeM.createContext)(null);
$8822e71bc1e566e5$var$I.displayName = "DialogContext";
function $8822e71bc1e566e5$var$b(t) {
    let e = (0, $exYeM.useContext)($8822e71bc1e566e5$var$I);
    if (e === null) {
        let o = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $8822e71bc1e566e5$var$b), o;
    }
    return e;
}
function $8822e71bc1e566e5$var$we(t, e, o = ()=>[
        document.body
    ]) {
    (0, $57e3e5413375de7f$export$bb0ae4a42bcd9e0)(t, e, (i)=>{
        var n;
        return {
            containers: [
                ...(n = i.containers) != null ? n : [],
                o
            ]
        };
    });
}
function $8822e71bc1e566e5$var$Be(t, e) {
    return (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(e.type, $8822e71bc1e566e5$var$Me, t, e);
}
let $8822e71bc1e566e5$var$He = "div", $8822e71bc1e566e5$var$Ge = (0, $6da0b689c34972b7$export$617d79dae526d2cf).RenderStrategy | (0, $6da0b689c34972b7$export$617d79dae526d2cf).Static;
function $8822e71bc1e566e5$var$Ne(t, e) {
    var X;
    let o = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: i = `headlessui-dialog-${o}`, open: n, onClose: l, initialFocus: s, __demoMode: g = !1, ...T } = t, [m, h] = (0, $exYeM.useState)(0), a = (0, $d2513f66ac282f05$export$fc6fdf0ecf360e)();
    n === void 0 && a !== null && (n = (a & (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open) === (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open);
    let D = (0, $exYeM.useRef)(null), Q = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(D, e), f = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)(D), N = t.hasOwnProperty("open") || a !== null, U = t.hasOwnProperty("onClose");
    if (!N && !U) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!N) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!U) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let p = n ? 0 : 1, [S, Z] = (0, $exYeM.useReducer)($8822e71bc1e566e5$var$Be, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $exYeM.createRef)()
    }), P = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>l(!1)), W = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>Z({
            type: 0,
            id: r
        })), L = (0, $eea6929722880e02$export$44ab2b9f2d09b0fa)() ? g ? !1 : p === 0 : !1, F = m > 1, Y = (0, $exYeM.useContext)($8822e71bc1e566e5$var$I) !== null, [ee, te] = (0, $2a4cc9a7be671cc4$export$26b8c35244a70b37)(), { resolveContainers: M, mainTreeNodeRef: k, MainTreeNode: oe } = (0, $0eb2c86c668abd7e$export$445f2d1a3d9b1b9f)({
        portals: ee,
        defaultContainers: [
            (X = S.panelRef.current) != null ? X : D.current
        ]
    }), re = F ? "parent" : "leaf", $ = a !== null ? (a & (0, $d2513f66ac282f05$export$7254cc27399e90bd).Closing) === (0, $d2513f66ac282f05$export$7254cc27399e90bd).Closing : !1, ne = (()=>Y || $ ? !1 : L)(), le = (0, $exYeM.useCallback)(()=>{
        var r, c;
        return (c = Array.from((r = f == null ? void 0 : f.querySelectorAll("body > *")) != null ? r : []).find((d)=>d.id === "headlessui-portal-root" ? !1 : d.contains(k.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        k
    ]);
    (0, $cb0c82ea2ca65660$export$bbe4e2927a3450da)(le, ne);
    let ae = (()=>F ? !0 : L)(), ie = (0, $exYeM.useCallback)(()=>{
        var r, c;
        return (c = Array.from((r = f == null ? void 0 : f.querySelectorAll("[data-headlessui-portal]")) != null ? r : []).find((d)=>d.contains(k.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        k
    ]);
    (0, $cb0c82ea2ca65660$export$bbe4e2927a3450da)(ie, ae);
    let se = (()=>!(!L || F))();
    (0, $ff220859d927474a$export$71b2224f1ce5e08e)(M, P, se);
    let pe = (()=>!(F || p !== 0))();
    (0, $b3d7b11c4d9c7c80$export$7080b3e976bc91ab)(f == null ? void 0 : f.defaultView, "keydown", (r)=>{
        pe && (r.defaultPrevented || r.key === (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Escape && (r.preventDefault(), r.stopPropagation(), P()));
    });
    let de = (()=>!($ || p !== 0 || Y))();
    $8822e71bc1e566e5$var$we(f, de, M), (0, $exYeM.useEffect)(()=>{
        if (p !== 0 || !D.current) return;
        let r = new ResizeObserver((c)=>{
            for (let d of c){
                let x = d.target.getBoundingClientRect();
                x.x === 0 && x.y === 0 && x.width === 0 && x.height === 0 && P();
            }
        });
        return r.observe(D.current), ()=>r.disconnect();
    }, [
        p,
        D,
        P
    ]);
    let [ue, fe] = (0, $c661dd91897b6639$export$babde88292020af7)(), ge = (0, $exYeM.useMemo)(()=>[
            {
                dialogState: p,
                close: P,
                setTitleId: W
            },
            S
        ], [
        p,
        S,
        P,
        W
    ]), J = (0, $exYeM.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), Te = {
        ref: Q,
        id: i,
        role: "dialog",
        "aria-modal": p === 0 ? !0 : void 0,
        "aria-labelledby": S.titleId,
        "aria-describedby": ue
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $66cef126f02654a5$export$4aac1a6640027f56), {
        type: "Dialog",
        enabled: p === 0,
        element: D,
        onUpdate: (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r, c)=>{
            c === "Dialog" && (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(r, {
                [(0, $66cef126f02654a5$export$2dd25ef07fea092e).Add]: ()=>h((d)=>d + 1),
                [(0, $66cef126f02654a5$export$2dd25ef07fea092e).Remove]: ()=>h((d)=>d - 1)
            });
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c6396520159f7ecb$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2a4cc9a7be671cc4$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($8822e71bc1e566e5$var$I.Provider, {
        value: ge
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2a4cc9a7be671cc4$export$602eac185826482c).Group, {
        target: D
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c6396520159f7ecb$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(fe, {
        slot: J,
        name: "Dialog.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6dd567c6dd8bfc62$export$34eba2437817a67b), {
        initialFocus: s,
        containers: M,
        features: L ? (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(re, {
            parent: (0, $6dd567c6dd8bfc62$export$34eba2437817a67b).features.RestoreFocus,
            leaf: (0, $6dd567c6dd8bfc62$export$34eba2437817a67b).features.All & ~(0, $6dd567c6dd8bfc62$export$34eba2437817a67b).features.FocusLock
        }) : (0, $6dd567c6dd8bfc62$export$34eba2437817a67b).features.None
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(te, null, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: Te,
        theirProps: T,
        slot: J,
        defaultTag: $8822e71bc1e566e5$var$He,
        features: $8822e71bc1e566e5$var$Ge,
        visible: p === 0,
        name: "Dialog"
    }))))))))), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(oe, null));
}
let $8822e71bc1e566e5$var$Ue = "div";
function $8822e71bc1e566e5$var$We(t, e) {
    let o = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: i = `headlessui-dialog-overlay-${o}`, ...n } = t, [{ dialogState: l, close: s }] = $8822e71bc1e566e5$var$b("Dialog.Overlay"), g = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(e), T = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((a)=>{
        if (a.target === a.currentTarget) {
            if ((0, $b762bd1946006453$export$db61f031a278447c)(a.currentTarget)) return a.preventDefault();
            a.preventDefault(), a.stopPropagation(), s();
        }
    }), m = (0, $exYeM.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: g,
            id: i,
            "aria-hidden": !0,
            onClick: T
        },
        theirProps: n,
        slot: m,
        defaultTag: $8822e71bc1e566e5$var$Ue,
        name: "Dialog.Overlay"
    });
}
let $8822e71bc1e566e5$var$Ye = "div";
function $8822e71bc1e566e5$var$$e(t, e) {
    let o = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: i = `headlessui-dialog-backdrop-${o}`, ...n } = t, [{ dialogState: l }, s] = $8822e71bc1e566e5$var$b("Dialog.Backdrop"), g = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(e);
    (0, $exYeM.useEffect)(()=>{
        if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        s.panelRef
    ]);
    let T = (0, $exYeM.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c6396520159f7ecb$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2a4cc9a7be671cc4$export$602eac185826482c), null, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: g,
            id: i,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: T,
        defaultTag: $8822e71bc1e566e5$var$Ye,
        name: "Dialog.Backdrop"
    })));
}
let $8822e71bc1e566e5$var$Je = "div";
function $8822e71bc1e566e5$var$Xe(t, e) {
    let o = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: i = `headlessui-dialog-panel-${o}`, ...n } = t, [{ dialogState: l }, s] = $8822e71bc1e566e5$var$b("Dialog.Panel"), g = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(e, s.panelRef), T = (0, $exYeM.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), m = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((a)=>{
        a.stopPropagation();
    });
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: g,
            id: i,
            onClick: m
        },
        theirProps: n,
        slot: T,
        defaultTag: $8822e71bc1e566e5$var$Je,
        name: "Dialog.Panel"
    });
}
let $8822e71bc1e566e5$var$je = "h2";
function $8822e71bc1e566e5$var$Ke(t, e) {
    let o = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: i = `headlessui-dialog-title-${o}`, ...n } = t, [{ dialogState: l, setTitleId: s }] = $8822e71bc1e566e5$var$b("Dialog.Title"), g = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(e);
    (0, $exYeM.useEffect)(()=>(s(i), ()=>s(null)), [
        i,
        s
    ]);
    let T = (0, $exYeM.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: g,
            id: i
        },
        theirProps: n,
        slot: T,
        defaultTag: $8822e71bc1e566e5$var$je,
        name: "Dialog.Title"
    });
}
let $8822e71bc1e566e5$var$Ve = (0, $6da0b689c34972b7$export$e43f39796049410c)($8822e71bc1e566e5$var$Ne), $8822e71bc1e566e5$var$qe = (0, $6da0b689c34972b7$export$e43f39796049410c)($8822e71bc1e566e5$var$$e), $8822e71bc1e566e5$var$ze = (0, $6da0b689c34972b7$export$e43f39796049410c)($8822e71bc1e566e5$var$Xe), $8822e71bc1e566e5$var$Qe = (0, $6da0b689c34972b7$export$e43f39796049410c)($8822e71bc1e566e5$var$We), $8822e71bc1e566e5$var$Ze = (0, $6da0b689c34972b7$export$e43f39796049410c)($8822e71bc1e566e5$var$Ke), $8822e71bc1e566e5$export$3ddf2d174ce01153 = Object.assign($8822e71bc1e566e5$var$Ve, {
    Backdrop: $8822e71bc1e566e5$var$qe,
    Panel: $8822e71bc1e566e5$var$ze,
    Overlay: $8822e71bc1e566e5$var$Qe,
    Title: $8822e71bc1e566e5$var$Ze,
    Description: (0, $c661dd91897b6639$export$393edc798c47379d)
});



var $exYeM = parcelRequire("exYeM");
function $390f4da5c6f7ab18$var$ChevronDoubleLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M13.28 3.97a.75.75 0 010 1.06L6.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0zm6 0a.75.75 0 010 1.06L12.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z",
        clipRule: "evenodd"
    }));
}
const $390f4da5c6f7ab18$var$ForwardRef = $exYeM.forwardRef($390f4da5c6f7ab18$var$ChevronDoubleLeftIcon);
var $390f4da5c6f7ab18$export$2e2bcd8739ae039 = $390f4da5c6f7ab18$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $145c596adda84ba6$var$PencilSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z"
    }), /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z"
    }));
}
const $145c596adda84ba6$var$ForwardRef = $exYeM.forwardRef($145c596adda84ba6$var$PencilSquareIcon);
var $145c596adda84ba6$export$2e2bcd8739ae039 = $145c596adda84ba6$var$ForwardRef;





function $713cd473769d67da$export$2e2bcd8739ae039(selected) {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const { isLoading: isLoading, data: data } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "Compare-blockchains"
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/blockchains")
    });
    //   const blockchain = data?.blockchain;
    const current = data?.blockchain?.find((o)=>o.name === searchParams.get("blockchain"));
    // query for the different charts
    const { isLoading: chartsLoading, isFetching: chartsFetching, data: charts } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "charts" + selected
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/stores/" + selected),
        enabled: !!data && selected != null
    });
    return {
        blockchains: data,
        blockchainsLoading: isLoading,
        charts: charts,
        chartsLoading: chartsLoading,
        chartsFetching: chartsFetching,
        selectedBlockchain: current
    };
}


// Created by James Launder inspired by tailwind ui
// combo with picture

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $96abd6aa52cc9bd1$var$ChevronUpDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z",
        clipRule: "evenodd"
    }));
}
const $96abd6aa52cc9bd1$var$ForwardRef = $exYeM.forwardRef($96abd6aa52cc9bd1$var$ChevronUpDownIcon);
var $96abd6aa52cc9bd1$export$2e2bcd8739ae039 = $96abd6aa52cc9bd1$var$ForwardRef;



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");


function $3eedc3e7e61b557e$export$e3d20747ab930783(e, o) {
    let [u, t] = (0, $exYeM.useState)(e), r = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)(e);
    return (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>t(r.current), [
        r,
        t,
        ...o
    ]), u;
}











var $exYeM = parcelRequire("exYeM");


function $f4504682d4d0f2a4$export$b0abce39eb34b36({ container: e, accept: t, walk: r, enabled: c = !0 }) {
    let o = (0, $exYeM.useRef)(t), l = (0, $exYeM.useRef)(r);
    (0, $exYeM.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        if (!e || !c) return;
        let n = (0, $a54eed888c938856$export$b204af158042fbac)(e);
        if (!n) return;
        let f = o.current, p = l.current, d = Object.assign((i)=>f(i), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}


function $3570165156f716f3$var$f(r) {
    throw new Error("Unexpected object: " + r);
}
var $3570165156f716f3$export$807a7eae502106e7 = ((e)=>(e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))($3570165156f716f3$export$807a7eae502106e7 || {});
function $3570165156f716f3$export$c6b4626b54936d5e(r, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let l = n.resolveActiveIndex(), s = l != null ? l : -1, d = (()=>{
        switch(r.focus){
            case 0:
                return t.findIndex((e)=>!n.resolveDisabled(e));
            case 1:
                {
                    let e = t.slice().reverse().findIndex((i, c, u)=>s !== -1 && u.length - c - 1 >= s ? !1 : !n.resolveDisabled(i));
                    return e === -1 ? e : t.length - 1 - e;
                }
            case 2:
                return t.findIndex((e, i)=>i <= s ? !1 : !n.resolveDisabled(e));
            case 3:
                {
                    let e = t.slice().reverse().findIndex((i)=>!n.resolveDisabled(i));
                    return e === -1 ? e : t.length - 1 - e;
                }
            case 4:
                return t.findIndex((e)=>n.resolveId(e) === r.id);
            case 5:
                return null;
            default:
                $3570165156f716f3$var$f(r);
        }
    })();
    return d === -1 ? l : d;
}






function $7ef5a50884dbacae$export$bc22b3e852574dab(i = {}, s = null, t = []) {
    for (let [r, n] of Object.entries(i))$7ef5a50884dbacae$var$o(t, $7ef5a50884dbacae$var$f(s, r), n);
    return t;
}
function $7ef5a50884dbacae$var$f(i, s) {
    return i ? i + "[" + s + "]" : s;
}
function $7ef5a50884dbacae$var$o(i, s, t) {
    if (Array.isArray(t)) for (let [r, n] of t.entries())$7ef5a50884dbacae$var$o(i, $7ef5a50884dbacae$var$f(s, r.toString()), n);
    else t instanceof Date ? i.push([
        s,
        t.toISOString()
    ]) : typeof t == "boolean" ? i.push([
        s,
        t ? "1" : "0"
    ]) : typeof t == "string" ? i.push([
        s,
        t
    ]) : typeof t == "number" ? i.push([
        s,
        `${t}`
    ]) : t == null ? i.push([
        s,
        ""
    ]) : $7ef5a50884dbacae$export$bc22b3e852574dab(t, s, i);
}
function $7ef5a50884dbacae$export$ee02894bdc79dd36(i) {
    var t, r;
    let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
    if (s) {
        for (let n of s.elements)if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
            n.click();
            return;
        }
        (r = s.requestSubmit) == null || r.call(s);
    }
}







var $exYeM = parcelRequire("exYeM");

function $ec3d9133814ca96e$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $exYeM.useState)(c), e = l !== void 0, t = (0, $exYeM.useRef)(e), u = (0, $exYeM.useRef)(!1), d = (0, $exYeM.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}




var $exYeM = parcelRequire("exYeM");
function $687da405a68ff5bf$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $687da405a68ff5bf$export$24ebee078bde85c3() {
    let e = (0, $exYeM.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $687da405a68ff5bf$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $687da405a68ff5bf$var$t(r);
        }
    };
}




var $2caaeccb6882c8ed$var$we = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($2caaeccb6882c8ed$var$we || {}), $2caaeccb6882c8ed$var$Ue = ((e)=>(e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))($2caaeccb6882c8ed$var$Ue || {}), $2caaeccb6882c8ed$var$Ne = ((e)=>(e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))($2caaeccb6882c8ed$var$Ne || {}), $2caaeccb6882c8ed$var$He = ((n)=>(n[n.OpenCombobox = 0] = "OpenCombobox", n[n.CloseCombobox = 1] = "CloseCombobox", n[n.GoToOption = 2] = "GoToOption", n[n.RegisterOption = 3] = "RegisterOption", n[n.UnregisterOption = 4] = "UnregisterOption", n[n.RegisterLabel = 5] = "RegisterLabel", n))($2caaeccb6882c8ed$var$He || {});
function $2caaeccb6882c8ed$var$ae(t, a = (e)=>e) {
    let e = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, r = (0, $2786c78eeb568d2b$export$20305e96f91bf103)(a(t.options.slice()), (b)=>b.dataRef.current.domRef.current), l = e ? r.indexOf(e) : null;
    return l === -1 && (l = null), {
        options: r,
        activeOptionIndex: l
    };
}
let $2caaeccb6882c8ed$var$Ge = {
    [1] (t) {
        var a;
        return (a = t.dataRef.current) != null && a.disabled || t.comboboxState === 1 ? t : {
            ...t,
            activeOptionIndex: null,
            comboboxState: 1
        };
    },
    [0] (t) {
        var e;
        if ((e = t.dataRef.current) != null && e.disabled || t.comboboxState === 0) return t;
        let a = t.activeOptionIndex;
        if (t.dataRef.current) {
            let { isSelected: r } = t.dataRef.current, l = t.options.findIndex((b)=>r(b.dataRef.current.value));
            l !== -1 && (a = l);
        }
        return {
            ...t,
            comboboxState: 0,
            activeOptionIndex: a
        };
    },
    [2] (t, a) {
        var l, b, n, d;
        if ((l = t.dataRef.current) != null && l.disabled || (b = t.dataRef.current) != null && b.optionsRef.current && !((n = t.dataRef.current) != null && n.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
        let e = $2caaeccb6882c8ed$var$ae(t);
        if (e.activeOptionIndex === null) {
            let o = e.options.findIndex((i)=>!i.dataRef.current.disabled);
            o !== -1 && (e.activeOptionIndex = o);
        }
        let r = (0, $3570165156f716f3$export$c6b4626b54936d5e)(a, {
            resolveItems: ()=>e.options,
            resolveActiveIndex: ()=>e.activeOptionIndex,
            resolveId: (o)=>o.id,
            resolveDisabled: (o)=>o.dataRef.current.disabled
        });
        return {
            ...t,
            ...e,
            activeOptionIndex: r,
            activationTrigger: (d = a.trigger) != null ? d : 1
        };
    },
    [3]: (t, a)=>{
        var b, n;
        let e = {
            id: a.id,
            dataRef: a.dataRef
        }, r = $2caaeccb6882c8ed$var$ae(t, (d)=>[
                ...d,
                e
            ]);
        t.activeOptionIndex === null && (b = t.dataRef.current) != null && b.isSelected(a.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(e));
        let l = {
            ...t,
            ...r,
            activationTrigger: 1
        };
        return (n = t.dataRef.current) != null && n.__demoMode && t.dataRef.current.value === void 0 && (l.activeOptionIndex = 0), l;
    },
    [4]: (t, a)=>{
        let e = $2caaeccb6882c8ed$var$ae(t, (r)=>{
            let l = r.findIndex((b)=>b.id === a.id);
            return l !== -1 && r.splice(l, 1), r;
        });
        return {
            ...t,
            ...e,
            activationTrigger: 1
        };
    },
    [5]: (t, a)=>({
            ...t,
            labelId: a.id
        })
}, $2caaeccb6882c8ed$var$le = (0, $exYeM.createContext)(null);
$2caaeccb6882c8ed$var$le.displayName = "ComboboxActionsContext";
function $2caaeccb6882c8ed$var$Z(t) {
    let a = (0, $exYeM.useContext)($2caaeccb6882c8ed$var$le);
    if (a === null) {
        let e = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $2caaeccb6882c8ed$var$Z), e;
    }
    return a;
}
let $2caaeccb6882c8ed$var$ie = (0, $exYeM.createContext)(null);
$2caaeccb6882c8ed$var$ie.displayName = "ComboboxDataContext";
function $2caaeccb6882c8ed$var$J(t) {
    let a = (0, $exYeM.useContext)($2caaeccb6882c8ed$var$ie);
    if (a === null) {
        let e = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $2caaeccb6882c8ed$var$J), e;
    }
    return a;
}
function $2caaeccb6882c8ed$var$Xe(t, a) {
    return (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(a.type, $2caaeccb6882c8ed$var$Ge, t, a);
}
let $2caaeccb6882c8ed$var$je = (0, $exYeM.Fragment);
function $2caaeccb6882c8ed$var$Je(t, a) {
    let { value: e, defaultValue: r, onChange: l, form: b, name: n, by: d = (u, T)=>u === T, disabled: o = !1, __demoMode: i = !1, nullable: A = !1, multiple: O = !1, ...C } = t, [f = O ? [] : void 0, g] = (0, $ec3d9133814ca96e$export$454217e89aea72b)(e, l, r), [m, c] = (0, $exYeM.useReducer)($2caaeccb6882c8ed$var$Xe, {
        dataRef: (0, $exYeM.createRef)(),
        comboboxState: i ? 0 : 1,
        options: [],
        activeOptionIndex: null,
        activationTrigger: 1,
        labelId: null
    }), D = (0, $exYeM.useRef)(!1), _ = (0, $exYeM.useRef)({
        static: !1,
        hold: !1
    }), w = (0, $exYeM.useRef)(null), U = (0, $exYeM.useRef)(null), N = (0, $exYeM.useRef)(null), K = (0, $exYeM.useRef)(null), h = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(typeof d == "string" ? (u, T)=>{
        let v = d;
        return (u == null ? void 0 : u[v]) === (T == null ? void 0 : T[v]);
    } : d), H = (0, $exYeM.useCallback)((u)=>(0, $73fd0be368b973e0$export$4659b591c19bdf3d)(p.mode, {
            [1]: ()=>f.some((T)=>h(T, u)),
            [0]: ()=>h(f, u)
        }), [
        f
    ]), p = (0, $exYeM.useMemo)(()=>({
            ...m,
            optionsPropsRef: _,
            labelRef: w,
            inputRef: U,
            buttonRef: N,
            optionsRef: K,
            value: f,
            defaultValue: r,
            disabled: o,
            mode: O ? 1 : 0,
            get activeOptionIndex () {
                if (D.current && m.activeOptionIndex === null && m.options.length > 0) {
                    let u = m.options.findIndex((T)=>!T.dataRef.current.disabled);
                    if (u !== -1) return u;
                }
                return m.activeOptionIndex;
            },
            compare: h,
            isSelected: H,
            nullable: A,
            __demoMode: i
        }), [
        f,
        r,
        o,
        O,
        A,
        i,
        m
    ]), y = (0, $exYeM.useRef)(p.activeOptionIndex !== null ? p.options[p.activeOptionIndex] : null);
    (0, $exYeM.useEffect)(()=>{
        let u = p.activeOptionIndex !== null ? p.options[p.activeOptionIndex] : null;
        y.current !== u && (y.current = u);
    }), (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        m.dataRef.current = p;
    }, [
        p
    ]), (0, $ff220859d927474a$export$71b2224f1ce5e08e)([
        p.buttonRef,
        p.inputRef,
        p.optionsRef
    ], ()=>te.closeCombobox(), p.comboboxState === 0);
    let E = (0, $exYeM.useMemo)(()=>({
            open: p.comboboxState === 0,
            disabled: o,
            activeIndex: p.activeOptionIndex,
            activeOption: p.activeOptionIndex === null ? null : p.options[p.activeOptionIndex].dataRef.current.value,
            value: f
        }), [
        p,
        o,
        f
    ]), B = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((u)=>{
        let T = p.options.find((v)=>v.id === u);
        T && V(T.dataRef.current.value);
    }), s = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        if (p.activeOptionIndex !== null) {
            let { dataRef: u, id: T } = p.options[p.activeOptionIndex];
            V(u.current.value), te.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Specific, T);
        }
    }), W = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        c({
            type: 0
        }), D.current = !0;
    }), L = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        c({
            type: 1
        }), D.current = !1;
    }), $ = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((u, T, v)=>(D.current = !1, u === (0, $3570165156f716f3$export$807a7eae502106e7).Specific ? c({
            type: 2,
            focus: (0, $3570165156f716f3$export$807a7eae502106e7).Specific,
            id: T,
            trigger: v
        }) : c({
            type: 2,
            focus: u,
            trigger: v
        }))), P = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((u, T)=>(c({
            type: 3,
            id: u,
            dataRef: T
        }), ()=>{
            var v;
            ((v = y.current) == null ? void 0 : v.id) === u && (D.current = !0), c({
                type: 4,
                id: u
            });
        })), F = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((u)=>(c({
            type: 5,
            id: u
        }), ()=>c({
                type: 5,
                id: null
            }))), V = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((u)=>(0, $73fd0be368b973e0$export$4659b591c19bdf3d)(p.mode, {
            [0] () {
                return g == null ? void 0 : g(u);
            },
            [1] () {
                let T = p.value.slice(), v = T.findIndex((q)=>h(q, u));
                return v === -1 ? T.push(u) : T.splice(v, 1), g == null ? void 0 : g(T);
            }
        })), te = (0, $exYeM.useMemo)(()=>({
            onChange: V,
            registerOption: P,
            registerLabel: F,
            goToOption: $,
            closeCombobox: L,
            openCombobox: W,
            selectActiveOption: s,
            selectOption: B
        }), []), Te = a === null ? {} : {
        ref: a
    }, z = (0, $exYeM.useRef)(null), me = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)();
    return (0, $exYeM.useEffect)(()=>{
        z.current && r !== void 0 && me.addEventListener(z.current, "reset", ()=>{
            g == null || g(r);
        });
    }, [
        z,
        g
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($2caaeccb6882c8ed$var$le.Provider, {
        value: te
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($2caaeccb6882c8ed$var$ie.Provider, {
        value: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d2513f66ac282f05$export$2a0ed818b175f558), {
        value: (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(p.comboboxState, {
            [0]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open,
            [1]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Closed
        })
    }, n != null && f != null && (0, $7ef5a50884dbacae$export$bc22b3e852574dab)({
        [n]: f
    }).map(([u, T], v)=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
            features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Hidden,
            ref: v === 0 ? (q)=>{
                var ue;
                z.current = (ue = q == null ? void 0 : q.closest("form")) != null ? ue : null;
            } : void 0,
            ...(0, $6da0b689c34972b7$export$8e16b83750b44988)({
                key: u,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: b,
                name: u,
                value: T
            })
        })), (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: Te,
        theirProps: C,
        slot: E,
        defaultTag: $2caaeccb6882c8ed$var$je,
        name: "Combobox"
    }))));
}
let $2caaeccb6882c8ed$var$Ke = "input";
function $2caaeccb6882c8ed$var$We(t, a) {
    var p, y, E, B;
    let e = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: r = `headlessui-combobox-input-${e}`, onChange: l, displayValue: b, type: n = "text", ...d } = t, o = $2caaeccb6882c8ed$var$J("Combobox.Input"), i = $2caaeccb6882c8ed$var$Z("Combobox.Input"), A = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(o.inputRef, a), O = (0, $1a8daf5097665e62$export$dd9fbcea3de0ae36)(o.inputRef), C = (0, $exYeM.useRef)(!1), f = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)(), g = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        i.onChange(null), o.optionsRef.current && (o.optionsRef.current.scrollTop = 0), i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Nothing);
    }), m = function() {
        var s;
        return typeof b == "function" && o.value !== void 0 ? (s = b(o.value)) != null ? s : "" : typeof o.value == "string" ? o.value : "";
    }();
    (0, $6de2ca57ca54b61f$export$3c773aa2b84f29e0)(([s, W], [L, $])=>{
        if (C.current) return;
        let P = o.inputRef.current;
        P && (($ === 0 && W === 1 || s !== L) && (P.value = s), requestAnimationFrame(()=>{
            if (C.current || !P || (O == null ? void 0 : O.activeElement) !== P) return;
            let { selectionStart: F, selectionEnd: V } = P;
            Math.abs((V != null ? V : 0) - (F != null ? F : 0)) === 0 && F === 0 && P.setSelectionRange(P.value.length, P.value.length);
        }));
    }, [
        m,
        o.comboboxState,
        O
    ]), (0, $6de2ca57ca54b61f$export$3c773aa2b84f29e0)(([s], [W])=>{
        if (s === 0 && W === 1) {
            if (C.current) return;
            let L = o.inputRef.current;
            if (!L) return;
            let $ = L.value, { selectionStart: P, selectionEnd: F, selectionDirection: V } = L;
            L.value = "", L.value = $, V !== null ? L.setSelectionRange(P, F, V) : L.setSelectionRange(P, F);
        }
    }, [
        o.comboboxState
    ]);
    let c = (0, $exYeM.useRef)(!1), D = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        c.current = !0;
    }), _ = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        f.nextFrame(()=>{
            c.current = !1;
        });
    }), w = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s)=>{
        switch(C.current = !0, s.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Enter:
                if (C.current = !1, o.comboboxState !== 0 || c.current) return;
                if (s.preventDefault(), s.stopPropagation(), o.activeOptionIndex === null) {
                    i.closeCombobox();
                    return;
                }
                i.selectActiveOption(), o.mode === 0 && i.closeCombobox();
                break;
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowDown:
                return C.current = !1, s.preventDefault(), s.stopPropagation(), (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(o.comboboxState, {
                    [0]: ()=>{
                        i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Next);
                    },
                    [1]: ()=>{
                        i.openCombobox();
                    }
                });
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowUp:
                return C.current = !1, s.preventDefault(), s.stopPropagation(), (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(o.comboboxState, {
                    [0]: ()=>{
                        i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Previous);
                    },
                    [1]: ()=>{
                        i.openCombobox(), f.nextFrame(()=>{
                            o.value || i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Last);
                        });
                    }
                });
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Home:
                if (s.shiftKey) break;
                return C.current = !1, s.preventDefault(), s.stopPropagation(), i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).First);
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).PageUp:
                return C.current = !1, s.preventDefault(), s.stopPropagation(), i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).First);
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).End:
                if (s.shiftKey) break;
                return C.current = !1, s.preventDefault(), s.stopPropagation(), i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Last);
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).PageDown:
                return C.current = !1, s.preventDefault(), s.stopPropagation(), i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Last);
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Escape:
                return C.current = !1, o.comboboxState !== 0 ? void 0 : (s.preventDefault(), o.optionsRef.current && !o.optionsPropsRef.current.static && s.stopPropagation(), o.nullable && o.mode === 0 && o.value === null && g(), i.closeCombobox());
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Tab:
                if (C.current = !1, o.comboboxState !== 0) return;
                o.mode === 0 && i.selectActiveOption(), i.closeCombobox();
                break;
        }
    }), U = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s)=>{
        l == null || l(s), o.nullable && o.mode === 0 && s.target.value === "" && g(), i.openCombobox();
    }), N = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        C.current = !1;
    }), K = (0, $3eedc3e7e61b557e$export$e3d20747ab930783)(()=>{
        if (o.labelId) return [
            o.labelId
        ].join(" ");
    }, [
        o.labelId
    ]), h = (0, $exYeM.useMemo)(()=>({
            open: o.comboboxState === 0,
            disabled: o.disabled
        }), [
        o
    ]), H = {
        ref: A,
        id: r,
        role: "combobox",
        type: n,
        "aria-controls": (p = o.optionsRef.current) == null ? void 0 : p.id,
        "aria-expanded": o.comboboxState === 0,
        "aria-activedescendant": o.activeOptionIndex === null || (y = o.options[o.activeOptionIndex]) == null ? void 0 : y.id,
        "aria-labelledby": K,
        "aria-autocomplete": "list",
        defaultValue: (B = (E = t.defaultValue) != null ? E : o.defaultValue !== void 0 ? b == null ? void 0 : b(o.defaultValue) : null) != null ? B : o.defaultValue,
        disabled: o.disabled,
        onCompositionStart: D,
        onCompositionEnd: _,
        onKeyDown: w,
        onChange: U,
        onBlur: N
    };
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: H,
        theirProps: d,
        slot: h,
        defaultTag: $2caaeccb6882c8ed$var$Ke,
        name: "Combobox.Input"
    });
}
let $2caaeccb6882c8ed$var$$e = "button";
function $2caaeccb6882c8ed$var$qe(t, a) {
    var g;
    let e = $2caaeccb6882c8ed$var$J("Combobox.Button"), r = $2caaeccb6882c8ed$var$Z("Combobox.Button"), l = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(e.buttonRef, a), b = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: n = `headlessui-combobox-button-${b}`, ...d } = t, o = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)(), i = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((m)=>{
        switch(m.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowDown:
                return m.preventDefault(), m.stopPropagation(), e.comboboxState === 1 && r.openCombobox(), o.nextFrame(()=>{
                    var c;
                    return (c = e.inputRef.current) == null ? void 0 : c.focus({
                        preventScroll: !0
                    });
                });
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowUp:
                return m.preventDefault(), m.stopPropagation(), e.comboboxState === 1 && (r.openCombobox(), o.nextFrame(()=>{
                    e.value || r.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Last);
                })), o.nextFrame(()=>{
                    var c;
                    return (c = e.inputRef.current) == null ? void 0 : c.focus({
                        preventScroll: !0
                    });
                });
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Escape:
                return e.comboboxState !== 0 ? void 0 : (m.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && m.stopPropagation(), r.closeCombobox(), o.nextFrame(()=>{
                    var c;
                    return (c = e.inputRef.current) == null ? void 0 : c.focus({
                        preventScroll: !0
                    });
                }));
            default:
                return;
        }
    }), A = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((m)=>{
        if ((0, $b762bd1946006453$export$db61f031a278447c)(m.currentTarget)) return m.preventDefault();
        e.comboboxState === 0 ? r.closeCombobox() : (m.preventDefault(), r.openCombobox()), o.nextFrame(()=>{
            var c;
            return (c = e.inputRef.current) == null ? void 0 : c.focus({
                preventScroll: !0
            });
        });
    }), O = (0, $3eedc3e7e61b557e$export$e3d20747ab930783)(()=>{
        if (e.labelId) return [
            e.labelId,
            n
        ].join(" ");
    }, [
        e.labelId,
        n
    ]), C = (0, $exYeM.useMemo)(()=>({
            open: e.comboboxState === 0,
            disabled: e.disabled,
            value: e.value
        }), [
        e
    ]), f = {
        ref: l,
        id: n,
        type: (0, $5848675429035810$export$53652b2b272efe9c)(t, e.buttonRef),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": (g = e.optionsRef.current) == null ? void 0 : g.id,
        "aria-expanded": e.comboboxState === 0,
        "aria-labelledby": O,
        disabled: e.disabled,
        onClick: A,
        onKeyDown: i
    };
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: f,
        theirProps: d,
        slot: C,
        defaultTag: $2caaeccb6882c8ed$var$$e,
        name: "Combobox.Button"
    });
}
let $2caaeccb6882c8ed$var$Qe = "label";
function $2caaeccb6882c8ed$var$Ye(t, a) {
    let e = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: r = `headlessui-combobox-label-${e}`, ...l } = t, b = $2caaeccb6882c8ed$var$J("Combobox.Label"), n = $2caaeccb6882c8ed$var$Z("Combobox.Label"), d = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(b.labelRef, a);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>n.registerLabel(r), [
        r
    ]);
    let o = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        var O;
        return (O = b.inputRef.current) == null ? void 0 : O.focus({
            preventScroll: !0
        });
    }), i = (0, $exYeM.useMemo)(()=>({
            open: b.comboboxState === 0,
            disabled: b.disabled
        }), [
        b
    ]);
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: d,
            id: r,
            onClick: o
        },
        theirProps: l,
        slot: i,
        defaultTag: $2caaeccb6882c8ed$var$Qe,
        name: "Combobox.Label"
    });
}
let $2caaeccb6882c8ed$var$Ze = "ul", $2caaeccb6882c8ed$var$ze = (0, $6da0b689c34972b7$export$617d79dae526d2cf).RenderStrategy | (0, $6da0b689c34972b7$export$617d79dae526d2cf).Static;
function $2caaeccb6882c8ed$var$eo(t, a) {
    let e = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: r = `headlessui-combobox-options-${e}`, hold: l = !1, ...b } = t, n = $2caaeccb6882c8ed$var$J("Combobox.Options"), d = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(n.optionsRef, a), o = (0, $d2513f66ac282f05$export$fc6fdf0ecf360e)(), i = (()=>o !== null ? (o & (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open) === (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open : n.comboboxState === 0)();
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        var f;
        n.optionsPropsRef.current.static = (f = t.static) != null ? f : !1;
    }, [
        n.optionsPropsRef,
        t.static
    ]), (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        n.optionsPropsRef.current.hold = l;
    }, [
        n.optionsPropsRef,
        l
    ]), (0, $f4504682d4d0f2a4$export$b0abce39eb34b36)({
        container: n.optionsRef.current,
        enabled: n.comboboxState === 0,
        accept (f) {
            return f.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : f.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (f) {
            f.setAttribute("role", "none");
        }
    });
    let A = (0, $3eedc3e7e61b557e$export$e3d20747ab930783)(()=>{
        var f, g;
        return (g = n.labelId) != null ? g : (f = n.buttonRef.current) == null ? void 0 : f.id;
    }, [
        n.labelId,
        n.buttonRef.current
    ]), O = (0, $exYeM.useMemo)(()=>({
            open: n.comboboxState === 0
        }), [
        n
    ]), C = {
        "aria-labelledby": A,
        role: "listbox",
        "aria-multiselectable": n.mode === 1 ? !0 : void 0,
        id: r,
        ref: d
    };
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: C,
        theirProps: b,
        slot: O,
        defaultTag: $2caaeccb6882c8ed$var$Ze,
        features: $2caaeccb6882c8ed$var$ze,
        visible: i,
        name: "Combobox.Options"
    });
}
let $2caaeccb6882c8ed$var$oo = "li";
function $2caaeccb6882c8ed$var$to(t, a) {
    var H, p;
    let e = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: r = `headlessui-combobox-option-${e}`, disabled: l = !1, value: b, ...n } = t, d = $2caaeccb6882c8ed$var$J("Combobox.Option"), o = $2caaeccb6882c8ed$var$Z("Combobox.Option"), i = d.activeOptionIndex !== null ? d.options[d.activeOptionIndex].id === r : !1, A = d.isSelected(b), O = (0, $exYeM.useRef)(null), C = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)({
        disabled: l,
        value: b,
        domRef: O,
        textValue: (p = (H = O.current) == null ? void 0 : H.textContent) == null ? void 0 : p.toLowerCase()
    }), f = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(a, O), g = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>o.selectOption(r));
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>o.registerOption(r, C), [
        C,
        r
    ]);
    let m = (0, $exYeM.useRef)(!d.__demoMode);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        if (!d.__demoMode) return;
        let y = (0, $fb27e053aa71d13a$export$12b26c28a05aa001)();
        return y.requestAnimationFrame(()=>{
            m.current = !0;
        }), y.dispose;
    }, []), (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        if (d.comboboxState !== 0 || !i || !m.current || d.activationTrigger === 0) return;
        let y = (0, $fb27e053aa71d13a$export$12b26c28a05aa001)();
        return y.requestAnimationFrame(()=>{
            var E, B;
            (B = (E = O.current) == null ? void 0 : E.scrollIntoView) == null || B.call(E, {
                block: "nearest"
            });
        }), y.dispose;
    }, [
        O,
        i,
        d.comboboxState,
        d.activationTrigger,
        d.activeOptionIndex
    ]);
    let c = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((y)=>{
        if (l) return y.preventDefault();
        g(), d.mode === 0 && o.closeCombobox(), (0, $db807a8c2e3628f5$export$d0a8044dce8ff2fc)() || requestAnimationFrame(()=>{
            var E;
            return (E = d.inputRef.current) == null ? void 0 : E.focus();
        });
    }), D = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        if (l) return o.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Nothing);
        o.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Specific, r);
    }), _ = (0, $687da405a68ff5bf$export$24ebee078bde85c3)(), w = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((y)=>_.update(y)), U = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((y)=>{
        _.wasMoved(y) && (l || i || o.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Specific, r, 0));
    }), N = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((y)=>{
        _.wasMoved(y) && (l || i && (d.optionsPropsRef.current.hold || o.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Nothing)));
    }), K = (0, $exYeM.useMemo)(()=>({
            active: i,
            selected: A,
            disabled: l
        }), [
        i,
        A,
        l
    ]);
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            id: r,
            ref: f,
            role: "option",
            tabIndex: l === !0 ? void 0 : -1,
            "aria-disabled": l === !0 ? !0 : void 0,
            "aria-selected": A,
            disabled: void 0,
            onClick: c,
            onFocus: D,
            onPointerEnter: w,
            onMouseEnter: w,
            onPointerMove: U,
            onMouseMove: U,
            onPointerLeave: N,
            onMouseLeave: N
        },
        theirProps: n,
        slot: K,
        defaultTag: $2caaeccb6882c8ed$var$oo,
        name: "Combobox.Option"
    });
}
let $2caaeccb6882c8ed$var$no = (0, $6da0b689c34972b7$export$e43f39796049410c)($2caaeccb6882c8ed$var$Je), $2caaeccb6882c8ed$var$ro = (0, $6da0b689c34972b7$export$e43f39796049410c)($2caaeccb6882c8ed$var$qe), $2caaeccb6882c8ed$var$ao = (0, $6da0b689c34972b7$export$e43f39796049410c)($2caaeccb6882c8ed$var$We), $2caaeccb6882c8ed$var$lo = (0, $6da0b689c34972b7$export$e43f39796049410c)($2caaeccb6882c8ed$var$Ye), $2caaeccb6882c8ed$var$io = (0, $6da0b689c34972b7$export$e43f39796049410c)($2caaeccb6882c8ed$var$eo), $2caaeccb6882c8ed$var$uo = (0, $6da0b689c34972b7$export$e43f39796049410c)($2caaeccb6882c8ed$var$to), $2caaeccb6882c8ed$export$27957ad87354dd7e = Object.assign($2caaeccb6882c8ed$var$no, {
    Input: $2caaeccb6882c8ed$var$ao,
    Button: $2caaeccb6882c8ed$var$ro,
    Label: $2caaeccb6882c8ed$var$lo,
    Options: $2caaeccb6882c8ed$var$io,
    Option: $2caaeccb6882c8ed$var$uo
});


function $d6fe4039eb01bf4b$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $d6fe4039eb01bf4b$export$2e2bcd8739ae039(props) {
    const [query, setQuery] = (0, $exYeM.useState)("");
    const filteredData = query === "" ? props?.data : props?.data.filter((person)=>{
        return person.name.toLowerCase().includes(query.toLowerCase());
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e), {
        value: props.selected,
        onChange: props.setSelected,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Label, {
                className: "block text-sm font-medium leading-6 text-gray-900",
                children: props.title
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative mt-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Input, {
                        className: "w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 focus:border-primary focus:outline-none",
                        onChange: (event)=>setQuery(event.target.value),
                        displayValue: (person)=>person?.name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Button, {
                        className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none ",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $96abd6aa52cc9bd1$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                        })
                    }),
                    filteredData?.length > 0 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Options, {
                        className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                        children: filteredData.map((person, idx)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Option, {
                                value: person,
                                className: ({ active: active })=>$d6fe4039eb01bf4b$var$classNames("relative cursor-default select-none py-2 pl-3 pr-9 ", active ? "bg-primary text-white group" : "text-gray-900"),
                                children: ({ active: active, selected: selected })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex items-center ",
                                                children: [
                                                    person.icon ? /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                        src: "https://api.wevr.ai/V2/" + person.icon,
                                                        alt: "",
                                                        className: "h-6 w-6 flex-shrink-0 rounded-full"
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        children: person.iconLocal ? person.iconLocal : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {})
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: $d6fe4039eb01bf4b$var$classNames("ml-3 truncate", selected && "font-semibold"),
                                                        children: person.name
                                                    })
                                                ]
                                            }),
                                            selected && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: $d6fe4039eb01bf4b$var$classNames("absolute inset-y-0 right-0 flex items-center pr-4", active ? "text-white" : "text-primary"),
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ad110a4e18e6d96b$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    })
                            }, person._id ? person._id : person.DataID ? person.DataID : idx))
                    })
                ]
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");





var $729e2f339928895f$var$_gcTimeout;
var $729e2f339928895f$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $729e2f339928895f$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $54cfa1b7ba8b31b7$export$e539f754e934e270)(this.gcTime)) (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $729e2f339928895f$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $54cfa1b7ba8b31b7$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $729e2f339928895f$var$_gcTimeout)) {
            clearTimeout((0, $baa96523396bdf41$export$18a094aefa070634)(this, $729e2f339928895f$var$_gcTimeout));
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $729e2f339928895f$var$_gcTimeout, void 0);
        }
    }
};
$729e2f339928895f$var$_gcTimeout = new WeakMap();



var $76da438f2abff68a$var$_observers, $76da438f2abff68a$var$_defaultOptions, $76da438f2abff68a$var$_mutationCache, $76da438f2abff68a$var$_retryer, $76da438f2abff68a$var$_dispatch, $76da438f2abff68a$var$dispatch_fn;
var $76da438f2abff68a$export$17b8b19c814bcf56 = class extends (0, $729e2f339928895f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $76da438f2abff68a$var$_dispatch);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $76da438f2abff68a$var$_observers, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $76da438f2abff68a$var$_defaultOptions, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $76da438f2abff68a$var$_mutationCache, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $76da438f2abff68a$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $76da438f2abff68a$var$_defaultOptions, config.defaultOptions);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $76da438f2abff68a$var$_mutationCache, config.mutationCache);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $76da438f2abff68a$var$_observers, []);
        this.state = config.state || $76da438f2abff68a$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_observers).includes(observer)) {
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $76da438f2abff68a$var$_observers, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $76da438f2abff68a$var$_retryer, (0, $537d0c641c62b96c$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $76da438f2abff68a$var$_dispatch, $76da438f2abff68a$var$dispatch_fn).call(this, {
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $76da438f2abff68a$var$_dispatch, $76da438f2abff68a$var$dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $76da438f2abff68a$var$_dispatch, $76da438f2abff68a$var$dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $76da438f2abff68a$var$_dispatch, $76da438f2abff68a$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables
                });
                await ((_b = (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $76da438f2abff68a$var$_dispatch, $76da438f2abff68a$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $76da438f2abff68a$var$_dispatch, $76da438f2abff68a$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $76da438f2abff68a$var$_dispatch, $76da438f2abff68a$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        }
    }
};
$76da438f2abff68a$var$_observers = new WeakMap();
$76da438f2abff68a$var$_defaultOptions = new WeakMap();
$76da438f2abff68a$var$_mutationCache = new WeakMap();
$76da438f2abff68a$var$_retryer = new WeakMap();
$76da438f2abff68a$var$_dispatch = new WeakSet();
$76da438f2abff68a$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, $537d0c641c62b96c$export$61b92f63f30245cf)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $76da438f2abff68a$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $76da438f2abff68a$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}





var $a5cbb021bf23668f$var$_client, $a5cbb021bf23668f$var$_currentResult, $a5cbb021bf23668f$var$_currentMutation, $a5cbb021bf23668f$var$_mutateOptions, $a5cbb021bf23668f$var$_updateResult, $a5cbb021bf23668f$var$updateResult_fn, $a5cbb021bf23668f$var$_notify, $a5cbb021bf23668f$var$notify_fn;
var $a5cbb021bf23668f$export$d3c1860ee66f291a = class extends (0, $d4b58c4894ac9142$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $a5cbb021bf23668f$var$_updateResult);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $a5cbb021bf23668f$var$_notify);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $a5cbb021bf23668f$var$_client, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $a5cbb021bf23668f$var$_currentResult, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $a5cbb021bf23668f$var$_currentMutation, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $a5cbb021bf23668f$var$_mutateOptions, void 0);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $a5cbb021bf23668f$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $a5cbb021bf23668f$var$_updateResult, $a5cbb021bf23668f$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_client).defaultMutationOptions(options);
        if (!(0, $54cfa1b7ba8b31b7$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentMutation),
            observer: this
        });
        (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentMutation)) == null || _a.setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $a5cbb021bf23668f$var$_updateResult, $a5cbb021bf23668f$var$updateResult_fn).call(this);
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $a5cbb021bf23668f$var$_notify, $a5cbb021bf23668f$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult);
    }
    reset() {
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $a5cbb021bf23668f$var$_currentMutation, void 0);
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $a5cbb021bf23668f$var$_updateResult, $a5cbb021bf23668f$var$updateResult_fn).call(this);
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $a5cbb021bf23668f$var$_notify, $a5cbb021bf23668f$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $a5cbb021bf23668f$var$_mutateOptions, options);
        (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $a5cbb021bf23668f$var$_currentMutation, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_client).getMutationCache().build((0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_client), this.options));
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentMutation).addObserver(this);
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentMutation).execute(variables);
    }
};
$a5cbb021bf23668f$var$_client = new WeakMap();
$a5cbb021bf23668f$var$_currentResult = new WeakMap();
$a5cbb021bf23668f$var$_currentMutation = new WeakMap();
$a5cbb021bf23668f$var$_mutateOptions = new WeakMap();
$a5cbb021bf23668f$var$_updateResult = new WeakSet();
$a5cbb021bf23668f$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $76da438f2abff68a$export$a1659b54bac3252a)();
    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $a5cbb021bf23668f$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$a5cbb021bf23668f$var$_notify = new WeakSet();
$a5cbb021bf23668f$var$notify_fn = function(action) {
    (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_mutateOptions) && this.hasListeners()) {
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult).variables, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult).context);
                (_d = (_c = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult).variables, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult).context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult).variables, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult).context);
                (_h = (_g = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult).variables, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult).context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $baa96523396bdf41$export$18a094aefa070634)(this, $a5cbb021bf23668f$var$_currentResult));
        });
    });
};




"use client";
function $69148cf0716ffd57$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $1773e073a683367a$export$22e77b9572c4fded)(queryClient);
    const [observer] = $exYeM.useState(()=>new (0, $a5cbb021bf23668f$export$d3c1860ee66f291a)(client, options));
    $exYeM.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $exYeM.useSyncExternalStore($exYeM.useCallback((onStoreChange)=>observer.subscribe((0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $exYeM.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($69148cf0716ffd57$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $47c0fb03fd415629$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}
function $69148cf0716ffd57$var$noop() {}




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $8da1b181472d2466$var$ExclamationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
    }));
}
const $8da1b181472d2466$var$ForwardRef = $exYeM.forwardRef($8da1b181472d2466$var$ExclamationCircleIcon);
var $8da1b181472d2466$export$2e2bcd8739ae039 = $8da1b181472d2466$var$ForwardRef;


var $405a4fa4811a9356$exports = {};
"use strict";
var $7e0acac94e75c14b$exports = {};
"use strict";
var $7e0acac94e75c14b$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $7e0acac94e75c14b$var$createStore = function createStore(createState) {
    return createState ? $7e0acac94e75c14b$var$createStoreImpl(createState) : $7e0acac94e75c14b$var$createStoreImpl;
};
var $7e0acac94e75c14b$var$vanilla = function(createState) {
    return $7e0acac94e75c14b$var$createStore(createState);
};
$7e0acac94e75c14b$exports.createStore = $7e0acac94e75c14b$var$createStore;
$7e0acac94e75c14b$exports.default = $7e0acac94e75c14b$var$vanilla;
$7e0acac94e75c14b$exports = $7e0acac94e75c14b$var$vanilla;
$7e0acac94e75c14b$exports.createStore = $7e0acac94e75c14b$var$createStore;
$7e0acac94e75c14b$exports.default = $7e0acac94e75c14b$exports;



var $exYeM = parcelRequire("exYeM");
var $e0448e6874efea69$exports = {};
"use strict";

$e0448e6874efea69$exports = (parcelRequire("eXtb5"));


var $405a4fa4811a9356$var$useSyncExternalStoreWithSelector = $e0448e6874efea69$exports.useSyncExternalStoreWithSelector;
var $405a4fa4811a9356$var$didWarnAboutEqualityFn = false;
function $405a4fa4811a9356$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $405a4fa4811a9356$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $exYeM.useDebugValue(slice);
    return slice;
}
var $405a4fa4811a9356$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $7e0acac94e75c14b$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $405a4fa4811a9356$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $405a4fa4811a9356$var$create = function create(createState) {
    return createState ? $405a4fa4811a9356$var$createImpl(createState) : $405a4fa4811a9356$var$createImpl;
};
var $405a4fa4811a9356$var$react = function(createState) {
    return $405a4fa4811a9356$var$create(createState);
};
$405a4fa4811a9356$exports.create = $405a4fa4811a9356$var$create;
$405a4fa4811a9356$exports.default = $405a4fa4811a9356$var$react;
$405a4fa4811a9356$exports.useStore = $405a4fa4811a9356$var$useStore;
Object.keys($7e0acac94e75c14b$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($405a4fa4811a9356$exports, k)) Object.defineProperty($405a4fa4811a9356$exports, k, {
        enumerable: true,
        get: function() {
            return $7e0acac94e75c14b$exports[k];
        }
    });
});
$405a4fa4811a9356$exports = $405a4fa4811a9356$var$react;
$405a4fa4811a9356$exports.create = $405a4fa4811a9356$var$create;
$405a4fa4811a9356$exports.useStore = $405a4fa4811a9356$var$useStore;
$405a4fa4811a9356$exports.createStore = $7e0acac94e75c14b$exports.createStore;
$405a4fa4811a9356$exports.default = $405a4fa4811a9356$exports;


const $640fe7a5f95bf9d5$export$24a1375a06d69907 = (0, $405a4fa4811a9356$exports.create)((set)=>({
        popup: [
            false,
            ""
        ],
        open: (message)=>set(()=>({
                    popup: [
                        true,
                        message
                    ]
                })),
        close: ()=>set(()=>({
                    popup: [
                        false,
                        ""
                    ]
                }))
    }));


function $f078a9f53a748804$export$2e2bcd8739ae039(optimistic) {
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const openSuccess = (0, $640fe7a5f95bf9d5$export$24a1375a06d69907)((state)=>state.open);
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const [success, setSuccess] = (0, $exYeM.useState)("");
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [error, setError] = (0, $exYeM.useState)(false);
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ blockchain: blockchain, chart: chart, resolution: resolution, source: source, sources: sources, condition: condition, val: val, freq: freq, email: email, name: name })=>{
            setLoading(true);
            setError(false);
            setMessage("");
            setSuccess(false);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/notification/add", {
                blockchain: blockchain.name,
                chart: chart.name,
                res: resolution,
                source: source,
                sources: sources?.name,
                condition: condition.name,
                value: val,
                frequency: freq.name,
                email: email,
                name: name
            }, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
        },
        mutationKey: [
            "addAlert"
        ],
        onSuccess: async (data)=>{
            // setSuccessful(true);
            setLoading(false);
            setSuccess(true);
            if (optimistic) {
                await queryClient.cancelQueries({
                    queryKey: [
                        "allNotifications"
                    ]
                });
                const prev = queryClient.getQueryData([
                    "allNotifications"
                ]);
                queryClient.setQueryData([
                    "allNotifications"
                ], (old)=>[
                        ...old.data,
                        data
                    ]);
                return {
                    prev: prev
                };
            } else openSuccess("Successfully added alert!");
        },
        onError: (error, id, context)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-red-500 font-semibold flex gap-1 self-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 self-center mt-[1px]"
                    }),
                    resMessage
                ]
            }));
            setError(true);
            setLoading(false);
            if (optimistic) queryClient.setQueryData([
                "allNotifications"
            ], context.prev);
        },
        onSettled: ()=>{
            setLoading(false);
            if (optimistic) queryClient.invalidateQueries({
                queryKey: [
                    "allNotifications"
                ]
            });
        }
    });
    return {
        mutation: mutation,
        loading: loading,
        error: error,
        success: success,
        message: message
    };
}



var $aSiaI = parcelRequire("aSiaI");



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $a6a80b2de3c2a5bc$var$ExclamationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
        clipRule: "evenodd"
    }));
}
const $a6a80b2de3c2a5bc$var$ForwardRef = $exYeM.forwardRef($a6a80b2de3c2a5bc$var$ExclamationCircleIcon);
var $a6a80b2de3c2a5bc$export$2e2bcd8739ae039 = $a6a80b2de3c2a5bc$var$ForwardRef;


function $1335414c010f3f0d$export$2e2bcd8739ae039(id) {
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const [success, setSuccess] = (0, $exYeM.useState)("");
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [error, setError] = (0, $exYeM.useState)(false);
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ blockchain: blockchain, chart: chart, resolution: resolution, source: source, sources: sources, condition: condition, val: val, freq: freq, channel: channel, name: name })=>{
            setLoading(true);
            setError(false);
            setMessage("");
            setSuccess(false);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put("/notification/" + id, {
                blockchain: blockchain.name,
                chart: chart.name,
                res: resolution,
                source: source,
                sources: sources,
                condition: condition.name,
                value: val,
                frequency: freq.name,
                channel: channel,
                address: "email",
                name: name
            }, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
        },
        mutationKey: [
            "editAlert"
        ],
        onSuccess: async (data)=>{
            // setSuccessful(true);
            setLoading(false);
            setSuccess(true);
            await queryClient.cancelQueries({
                queryKey: [
                    "allNotifications"
                ]
            });
            const prev = queryClient.getQueryData([
                "allNotifications"
            ]);
            queryClient.setQueryData([
                "allNotifications"
            ], (old)=>{
                let updated = old.data.map((item)=>{
                    if (item._id == id) return data;
                    else return item;
                });
                [
                    ...updated
                ];
            });
            return {
                prev: prev
            };
        },
        onError: (error, id, context)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-red-500 font-semibold flex gap-1 self-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6a80b2de3c2a5bc$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 self-center mt-[1px]"
                    }),
                    resMessage
                ]
            }));
            setError(true);
            setLoading(false);
            queryClient.setQueryData([
                "allNotifications"
            ], context.prev);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "allNotifications"
                ]
            });
        }
    });
    return {
        mutation: mutation,
        loading: loading,
        error: error,
        success: success,
        message: message
    };
}



var $exYeM = parcelRequire("exYeM");
function $2dec8258d0879bfc$var$ArrowPathIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
    }));
}
const $2dec8258d0879bfc$var$ForwardRef = $exYeM.forwardRef($2dec8258d0879bfc$var$ArrowPathIcon);
var $2dec8258d0879bfc$export$2e2bcd8739ae039 = $2dec8258d0879bfc$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $f3d183df54ad9433$var$ChevronDoubleRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"
    }));
}
const $f3d183df54ad9433$var$ForwardRef = $exYeM.forwardRef($f3d183df54ad9433$var$ChevronDoubleRightIcon);
var $f3d183df54ad9433$export$2e2bcd8739ae039 = $f3d183df54ad9433$var$ForwardRef;


function $fcf061de51445294$export$2e2bcd8739ae039(...classes) {
    return classes.filter(Boolean).join(" ");
}




function $e001a3913940767b$export$2e2bcd8739ae039(blockchain, res, id, source = null) {
    // console.log(source);
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    var string = source === null || source === "Node" ? "/" + blockchain + "/Current/" + res + "/" + id : typeof source === "object" ? "/" + blockchain + "/Current/" + res + "/" + id + "/" + source.name : "/" + blockchain + "/Current/" + res + "/" + id + "/" + source;
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, data: data, refetch: refetch } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "current-value-" + string
        ],
        queryFn: async ()=>{
            if (blockchain === null || id === undefined) return;
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(string, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }).catch(function(error) {
                return error.response;
            });
            return data;
        },
        enabled: blockchain != null || id != null || id != undefined || source != undefined,
        staleTime: 1000
    });
    return {
        isLoading: isLoading,
        isError: isError,
        isFetching: isFetching,
        data: data,
        refetch: refetch
    };
}




function $7f0198e378ac9d56$export$2e2bcd8739ae039({ open: open, setOpen: setOpen, optimistic: optimistic = false, blockchain: blockchain = null, chartName: chartName = null, resolution: resolution = "Day", sourceProp: sourceProp = null, conditionProp: conditionProp = "Greater than", frequencyProp: frequencyProp = "Once", valueProp: valueProp = 0, channelProp: channelProp = true, alertNameProp: alertNameProp = "", edit: edit = false, id: id = null }) {
    const { userData: userData } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    const [collapse, setCollapse] = (0, $exYeM.useState)(true);
    const [selectedBlockchain, setSelectedBlockchain] = (0, $exYeM.useState)({
        name: blockchain
    });
    const [selectedChart, setSelectedChart] = (0, $exYeM.useState)(chartName);
    const [selectedSource, setSelectedSource] = (0, $exYeM.useState)(sourceProp);
    const [selectedResolution, setSelectedResolution] = (0, $exYeM.useState)(resolution);
    const [selectedCondition, setSelectedCondition] = (0, $exYeM.useState)({
        name: conditionProp
    });
    const [selectedFrequency, setSelectedFrequency] = (0, $exYeM.useState)({
        name: frequencyProp
    });
    const [value, setValue] = (0, $exYeM.useState)(valueProp);
    const [email, setEmail] = (0, $exYeM.useState)(channelProp);
    const [alertName, setAlertName] = (0, $exYeM.useState)(alertNameProp);
    const [message, setMessage] = (0, $exYeM.useState)("");
    function handleChangeEmail(e) {
        let isChecked = e.target.checked;
        if (isChecked) setEmail(true);
        else setEmail(false);
    // do whatever you want with isChecked value
    }
    const { mutation: mutation, loading: loading, error: error, success: success, message: errMessage } = (0, $f078a9f53a748804$export$2e2bcd8739ae039)(optimistic);
    const { mutation: mutateEdit, loading: loadingEdit, error: errorEdit, success: successEdit, message: errMessageEdit } = (0, $1335414c010f3f0d$export$2e2bcd8739ae039)(id);
    const { blockchains: blockchains, blockchainsLoading: isLoading, charts: charts, chartsLoading: chartsLoading, chartsFetching: chartsFetching } = (0, $713cd473769d67da$export$2e2bcd8739ae039)(selectedBlockchain?.name);
    const { isLoading: currLoading, isError: currError, data: currData } = (0, $e001a3913940767b$export$2e2bcd8739ae039)(selectedBlockchain?.name, selectedResolution, selectedChart?.name, selectedSource);
    const cancelButtonRef = (0, $exYeM.useRef)(null);
    let valid = true;
    let conditions = [
        {
            name: "Greater than",
            iconLocal: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f3d183df54ad9433$export$2e2bcd8739ae039), {
                className: "h-6 w-6 flex-shrink-0 rounded-full text-primary group-hover:text-white"
            })
        },
        {
            name: "Less than",
            iconLocal: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $390f4da5c6f7ab18$export$2e2bcd8739ae039), {
                className: "h-6 w-6 flex-shrink-0 rounded-full text-primary group-hover:text-white"
            })
        }
    ];
    let frequency = [
        {
            name: "Once"
        },
        {
            name: "Daily"
        },
        {
            name: "Hours"
        }
    ];
    const submit = ()=>{
        setMessage("");
        if (edit) detectChanges();
        else if (!selectedBlockchain || !selectedChart || !selectedResolution || !selectedChart?.dataSource || !selectedCondition || value === null || !selectedFrequency) {
            if (Array.isArray(selectedChart?.sources)) setMessage(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-red-500 font-semibold flex gap-1 self-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 self-center mt-[1px]"
                    }),
                    "Missing Source!"
                ]
            }));
            else setMessage(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-red-500 font-semibold flex gap-1 self-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 self-center mt-[1px]"
                    }),
                    "Missing Values!"
                ]
            }));
            return;
        } else {
            var sourceSelect = null;
            if (Array.isArray(selectedChart?.sources)) sourceSelect = selectedSource.name;
            else sourceSelect = selectedChart.dataSource;
            mutation.mutate({
                blockchain: selectedBlockchain,
                chart: selectedChart,
                resolution: selectedResolution,
                source: sourceSelect,
                sources: selectedSource,
                condition: selectedCondition,
                val: value,
                freq: selectedFrequency,
                email: email,
                name: alertName
            });
        }
    };
    (0, $exYeM.useEffect)(()=>{
        if (!chartsLoading && !(selectedBlockchain.name === "None" || selectedBlockchain.name === null) && edit && chartName != null) {
            let editChartName = charts?.data?.graphNames.filter((chart)=>chart.name === chartName);
            if (editChartName) setSelectedChart(editChartName[0]);
            else return;
        }
    }, [
        chartsLoading
    ]);
    // changes made
    function detectChanges() {
        if (chartName != selectedChart?.name || blockchain != selectedBlockchain.name || resolution != selectedResolution || conditionProp != selectedCondition.name || frequencyProp != selectedFrequency.name || valueProp != value || alertNameProp != alertName) mutateEdit.mutate({
            blockchain: selectedBlockchain,
            chart: selectedChart,
            resolution: selectedResolution,
            source: selectedChart.dataSource,
            sources: selectedSource,
            condition: selectedCondition,
            val: value,
            freq: selectedFrequency,
            email: email,
            name: alertName
        });
    }
    function handleCurrentValue() {
        if (selectedBlockchain?.name === null || selectedChart === null || // selectedChart?.name === undefined ||
        selectedResolution === null || currData?.data?.graphData === undefined) return "Waiting...";
        if (currError) return "Error";
        if (currLoading) return "Loading...";
        return currData?.data?.graphData[0]?.data[1].toLocaleString("en-US", {
            maximumFractionDigits: 2
        }) ?? "No data";
    }
    function checkTier(res) {
        switch(userData.tier){
            case 0:
                if (res === "Day") return false;
                return true;
            case 1:
                if (res === "Block" || res === "Min") return true;
                return false;
            default:
                return false;
        }
    }
    (0, $exYeM.useEffect)(()=>{
        if (success || successEdit) setOpen(false);
        if (success) {
            setSelectedChart(null);
            setSelectedSource(null);
            setSelectedResolution("Day");
            setSelectedCondition({
                name: "Greater than"
            });
            setSelectedFrequency({
                name: "Once"
            });
            setAlertName("");
            setValue(0);
        }
    }, [
        success,
        successEdit
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
            show: open,
            as: (0, $exYeM.Fragment),
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
                as: "div",
                className: "relative z-10",
                initialFocus: cancelButtonRef,
                onClose: setOpen,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                        as: (0, $exYeM.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 z-10 overflow-y-auto",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                                as: (0, $exYeM.Fragment),
                                enter: "ease-out duration-300",
                                enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                enterTo: "opacity-100 translate-y-0 sm:scale-100",
                                leave: "ease-in duration-200",
                                leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                                leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                    className: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "absolute right-0 top-0 hidden pr-4 pt-4 sm:block",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                type: "button",
                                                className: "rounded-md bg-white text-gray-400 hover:text-gray-500",
                                                onClick: ()=>{
                                                    // setErrorMsg("");
                                                    setOpen(false);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Close"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "sm:flex sm:items-start ",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    className: "mt-3 text-center sm:mt-2 sm:text-left  w-full ",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "flex flex-row items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    className: "flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10",
                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $182dde3ef17cc6ab$export$2e2bcd8739ae039), {
                                                                        className: "h-6 w-6 text-primary",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Title, {
                                                                    as: "h3",
                                                                    className: "ml-4 text-base font-semibold leading-6 text-gray-900",
                                                                    children: "Add new alert"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "relative mt-4 bg-gray-100 p-2 rounded-lg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    className: "absolute right-0 top-0 hidden pr-2 pt-2 sm:block",
                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "rounded-md bg-white text-gray-400 hover:text-gray-500",
                                                                        onClick: ()=>setCollapse((collapse)=>!collapse),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "Close"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $145c596adda84ba6$export$2e2bcd8739ae039), {
                                                                                className: "h-6 w-6",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    className: "flex flex-col",
                                                                    children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        children: "Loading..."
                                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6fe4039eb01bf4b$export$2e2bcd8739ae039), {
                                                                        title: "Blockchain",
                                                                        data: blockchains?.data?.blockchain,
                                                                        selected: selectedBlockchain,
                                                                        setSelected: setSelectedBlockchain
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    className: "flex flex-col mt-4",
                                                                    children: selectedBlockchain.name === "None" || selectedBlockchain.name === null ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                children: "Charts"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                className: "truncate",
                                                                                children: "Select A Chart..."
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        children: chartsFetching || chartsLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                    children: "Charts"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "truncate",
                                                                                    children: "Loading..."
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6fe4039eb01bf4b$export$2e2bcd8739ae039), {
                                                                            title: "Charts",
                                                                            data: charts?.data?.graphNames,
                                                                            selected: selectedChart,
                                                                            setSelected: setSelectedChart
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                                                                    show: collapse,
                                                                    enter: "transition ease-in-out duration-300 transform",
                                                                    enterFrom: "opacity-0",
                                                                    enterTo: "opacity-100",
                                                                    leave: "transition-opacity duration-150",
                                                                    leaveFrom: "opacity-100",
                                                                    leaveTo: "opacity-0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            className: "flex flex-col mt-4",
                                                                            children: selectedChart === null ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                        children: "Source"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        className: "truncate",
                                                                                        children: "Select A Chart..."
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                children: Array.isArray(selectedChart.sources) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6fe4039eb01bf4b$export$2e2bcd8739ae039), {
                                                                                    title: "Source",
                                                                                    data: selectedChart.sources,
                                                                                    selected: selectedSource,
                                                                                    setSelected: setSelectedSource
                                                                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                            className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                            children: "Source"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                            className: "truncate",
                                                                                            children: selectedChart.dataSource
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            className: "mt-4",
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                                        className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                        children: "Resolution"
                                                                                    }),
                                                                                    selectedChart === null ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        className: "mt-2 h-[40px]",
                                                                                        children: "Select A Chart..."
                                                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                            className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 mt-2",
                                                                                            children: selectedChart.resolution?.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                                            type: "button",
                                                                                                            onClick: ()=>{
                                                                                                                //   // params("resolution", data);
                                                                                                                setSelectedResolution(data);
                                                                                                            },
                                                                                                            disabled: checkTier(data),
                                                                                                            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(checkTier(data) ? "text-gray-300" : selectedResolution === data && !checkTier(data) ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900", "rounded-lg py-1.5 text-gray-900", "res-select-" + data),
                                                                                                            children: data
                                                                                                        }, data + " combo"),
                                                                                                        checkTier(data) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6569f55e54f7ff9d$export$28c660c63b792dea), {
                                                                                                            anchorSelect: ".res-select-" + data,
                                                                                                            place: "top",
                                                                                                            children: "Upgrade!"
                                                                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {})
                                                                                                    ]
                                                                                                }))
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            className: "mt-4 w-full border-b pb-4 block text-md font-medium leading-6 text-gray-900",
                                                            children: "Options"
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            className: "mt-4",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6fe4039eb01bf4b$export$2e2bcd8739ae039), {
                                                                title: "Condition",
                                                                data: conditions,
                                                                selected: selectedCondition,
                                                                setSelected: setSelectedCondition
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "mt-4 block text-sm font-medium leading-6 text-gray-900",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                    className: "flex gap-2 justify-between items-center",
                                                                    children: [
                                                                        "Value",
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                            className: "block text-sm font-medium leading-6 text-gray-700 bg-gray-100 py-1 px-2 rounded-lg",
                                                                            children: [
                                                                                "Current: ",
                                                                                handleCurrentValue()
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                    type: "text",
                                                                    name: "value",
                                                                    placeholder: "Value",
                                                                    className: `block border mt-1 border-onSurfaceVariant w-full py-2 pl-3 pr-9 rounded-lg focus:border-primary focus:outline-none`,
                                                                    value: value,
                                                                    onInput: (e)=>setValue(e.target.value)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            className: "mt-4",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6fe4039eb01bf4b$export$2e2bcd8739ae039), {
                                                                title: "Alert Frequency",
                                                                data: frequency,
                                                                selected: selectedFrequency,
                                                                setSelected: setSelectedFrequency
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("fieldset", {
                                                            className: "mt-4 block text-sm font-medium leading-6 text-gray-900",
                                                            children: [
                                                                "Channel",
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("legend", {
                                                                    className: "sr-only",
                                                                    children: "Channel"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                    className: "relative flex items-start",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            className: "flex h-6 items-center",
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                                id: "email",
                                                                                "aria-describedby": "email-description",
                                                                                name: "email",
                                                                                type: "checkbox",
                                                                                defaultChecked: true,
                                                                                disabled: true,
                                                                                className: "h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary",
                                                                                onChange: (e)=>handleChangeEmail(e)
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                            className: "ml-3 text-sm leading-6",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                                    htmlFor: "email",
                                                                                    className: "font-medium text-gray-900",
                                                                                    children: "Email"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                    id: "comments-description",
                                                                                    className: "text-gray-500",
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                        className: "sr-only",
                                                                                        children: "Email"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "mt-4 block text-sm font-medium leading-6 text-gray-900",
                                                            children: [
                                                                "Alert Name",
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                    type: "text",
                                                                    name: "alert-name",
                                                                    placeholder: "Name",
                                                                    className: `block border mt-1 border-onSurfaceVariant w-full py-2 pl-3 pr-9 rounded-lg focus:border-primary focus:outline-none`,
                                                                    value: alertName,
                                                                    onInput: (e)=>setAlertName(e.target.value)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "bg-gray-50 px-4 py-3 sm:flex sm:justify-between sm:px-6",
                                            children: [
                                                error || errorEdit ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    children: [
                                                        errMessage,
                                                        errMessageEdit
                                                    ]
                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    children: message
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    children: valid ? /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                        type: "submit",
                                                        className: (0, $fcf061de51445294$export$2e2bcd8739ae039)("inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm  shadow-sm  sm:ml-3 sm:w-auto gap-4", loading || loadingEdit ? "bg-gray-300 text-gray-400" : "hover:text-white hover:bg-primary bg-primaryContainer"),
                                                        disabled: loading || loadingEdit,
                                                        onClick: ()=>{
                                                            // handleSubmit();
                                                            submit();
                                                        },
                                                        children: [
                                                            loading || loadingEdit ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5 animate-spin"
                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "hidden"
                                                            }),
                                                            edit ? "Save" : "Add"
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                        disabled: true,
                                                        className: "cursor-not-allowed inline-flex w-full justify-center rounded-md bg-primaryContainer px-3 py-2 text-sm shadow-sm sm:ml-3 sm:w-auto",
                                                        children: "Add"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $02c3937cc0ece46a$var$ExclamationTriangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
    }));
}
const $02c3937cc0ece46a$var$ForwardRef = $exYeM.forwardRef($02c3937cc0ece46a$var$ExclamationTriangleIcon);
var $02c3937cc0ece46a$export$2e2bcd8739ae039 = $02c3937cc0ece46a$var$ForwardRef;



function $812617e8450d6179$export$2e2bcd8739ae039({ open: open, setOpen: setOpen }) {
    //   const [open, setOpen] = useState(true)
    const cancelButtonRef = (0, $exYeM.useRef)(null);
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            initialFocus: cancelButtonRef,
            onClose: setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 w-screen overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "sm:flex sm:items-start",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-surfaceVariant sm:mx-0 sm:h-10 sm:w-10",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $02c3937cc0ece46a$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-primary",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Title, {
                                                        as: "h3",
                                                        className: "text-base font-semibold leading-6 text-gray-900",
                                                        children: "Not logged in!"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                            className: "text-sm text-gray-500",
                                                            children: "To add new alerts you must first be logged in!"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: "inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/80 sm:ml-3 sm:w-auto",
                                                onClick: ()=>navigate("/signin"),
                                                children: "Login"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: "mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto",
                                                onClick: ()=>setOpen(false),
                                                ref: cancelButtonRef,
                                                children: "Close"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}


function $9a3b74454697bd7e$var$ChartHeader(props) {
    const [openNotification, setOpenNotification] = (0, $exYeM.useState)(false);
    const [openLogin, setOpenLogin] = (0, $exYeM.useState)(false);
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const href = window.location.href;
    let [referenceElement, setReferenceElement] = (0, $exYeM.useState)();
    let [popperElement, setPopperElement] = (0, $exYeM.useState)();
    let { styles: styles, attributes: attributes } = (0, $d674741d7e6ed1a9$export$f4d5bf230a36dd6e)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        12,
                        4
                    ]
                }
            }
        ]
    });
    return(// covers the whole section
    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full grid content-center font-roboto py-1",
        children: [
            props.handle.active ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex flex-row justify-center pt-2 mx-8 px-2 border-b border-secondary pb-2",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "flex flex-row gap-4 place-items-center",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "text-2xl font-semibold place-items-center",
                        children: props.name
                    })
                })
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: " flex flex-row justify-between items-center pt-2 mx-8 border-b border-secondary pb-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-row space-x-4 place-items-center relative h-full grow",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-lg md:text-2xl font-semibold place-items-center border-r border-secondary pr-4",
                                children: props.name
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        className: "group bg-surfaceVariant rounded-lg p-2 w-full shadow-md border border-primaryContainer favs",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e1b0604a14fc433e$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 self-center text-onSurfaceVariant group-hover:text-primary"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6569f55e54f7ff9d$export$28c660c63b792dea), {
                                        anchorSelect: ".favs",
                                        place: "top",
                                        children: "Coming Soon!"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                        className: "hidden relative md:grid grid-cols-3 rounded-lg bg-surfaceVariant items-center shadow-md border border-primaryContainer",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                    className: "group flex flex-row place-content-center p-2 hover:bg-primary hover:text-white pl-2 rounded-lg py-2.5 col-span-1",
                                    onClick: ()=>{
                                        localStorage.getItem("user") === null ? setOpenLogin(true) : setOpenNotification(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $182dde3ef17cc6ab$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 mr-2 self-center text-onSurfaceVariant group-hover:text-white"
                                        }),
                                        "Alerts"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                                as: "div",
                                className: "",
                                children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                                    className: `${open ? "bg-primary text-white" : ""} group flex flex-row place-content-center p-2 hover:bg-primary hover:text-white pl-2 rounded-lg col-span-1 py-2.5`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $304e847142aae143$export$2e2bcd8739ae039), {
                                                            className: `${open ? " text-white" : ""} h-5 w-5 mr-2 self-center text-onSurfaceVariant group-hover:text-white`
                                                        }),
                                                        "Share"
                                                    ]
                                                })
                                            }),
                                            open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                                                as: (0, $exYeM.Fragment),
                                                enter: "transition-opacity ease-out duration-75",
                                                enterFrom: "transform opacity-0 scale-95",
                                                enterTo: "transform opacity-100 scale-100",
                                                leave: "transition ease-in duration-75",
                                                leaveFrom: "transform opacity-100 scale-100",
                                                leaveTo: "transform opacity-0 scale-95",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                                    className: "absolute mt-2 border-2 w-[290px] -ml-24 border-primaryContainer rounded-xl z-30",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "grid grid-cols-2 divide-x divide-secondary bg-surface rounded-t-xl p-2 pr-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                    className: "",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                            className: "font-semibold",
                                                                            children: "Download"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                                                            className: "font-light text-sm",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                                    className: "py-1  ",
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                        className: "underline underline-offset-auto hover:text-blue-500",
                                                                                        onClick: ()=>{
                                                                                            (0, $43a7a81378273f81$export$2e2bcd8739ae039)(props.divRef, "png");
                                                                                        },
                                                                                        children: "PNG"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                                    className: "py-1",
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                        className: "underline underline-offset-auto hover:text-blue-500",
                                                                                        onClick: ()=>{
                                                                                            (0, $43a7a81378273f81$export$2e2bcd8739ae039)(props.divRef, "jpeg");
                                                                                        },
                                                                                        children: "JPEG"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                                    className: "py-1",
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                        className: "underline underline-offset-auto hover:text-blue-500",
                                                                                        onClick: ()=>{
                                                                                            (0, $43a7a81378273f81$export$2e2bcd8739ae039)(props.divRef, "svg");
                                                                                        },
                                                                                        children: "SVG"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                    className: "pl-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                            className: "font-semibold",
                                                                            children: "Share"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d0e5ef8bd1dc9733$export$2e2bcd8739ae039), {
                                                                                        title: props.name + "\n",
                                                                                        url: href,
                                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                            className: "grid grid-flow-col place-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $30be59c6ac7c486e$export$2e2bcd8739ae039), {
                                                                                                    size: 18,
                                                                                                    round: true
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                                                                    className: "pl-2 py-1 text-sm font-light hover:text-blue-500",
                                                                                                    children: "Twitter"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6d182e8471d3ba70$export$2e2bcd8739ae039), {
                                                                                        title: props.name + "\n",
                                                                                        url: href,
                                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                            className: "grid grid-flow-col place-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6f87ae2557ef43b5$export$2e2bcd8739ae039), {
                                                                                                    size: 18,
                                                                                                    round: true
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                                                                    className: "pl-2 py-1 text-sm font-light hover:text-blue-500",
                                                                                                    children: "LinkedIn"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e26074a2b4484734$export$2e2bcd8739ae039), {
                                                                                        title: props.name + "\n",
                                                                                        url: href,
                                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                            className: "grid grid-flow-col place-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fef596c67269757c$export$2e2bcd8739ae039), {
                                                                                                    size: 18,
                                                                                                    round: true
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                                                                    className: "pl-2 py-1 text-sm font-light hover:text-blue-500",
                                                                                                    children: "Telegram"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "rounded-b-xl bg-surface w-full p-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                    className: "font-semibold border-t-2 border-secondary mx-2 py-1",
                                                                    children: "Link"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                    onClick: ()=>{
                                                                        navigator.clipboard.writeText(href);
                                                                    },
                                                                    className: " flex group items-center bg-white w-full p-2 rounded-xl border  border-secondary",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                                            className: "text-clip overflow-hidden h-6 bg-surface rounded-lg text-center font-light",
                                                                            children: href
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            className: "",
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7945723c9bf4c650$export$2e2bcd8739ae039), {
                                                                                className: "h-5 w-5 self-center text-onSurfaceVariant group-hover:text-primary mb-[0.5]",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                onClick: ()=>{
                                    props.handle.enter();
                                },
                                className: "group flex flex-row place-content-center p-2 hover:bg-primary hover:text-white pl-2 rounded-lg col-span-1 py-2.5",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f92085fcc4c2f012$export$2e2bcd8739ae039), {
                                        className: " h-5 w-5 mr-2 self-center text-secondary group-hover:text-white"
                                    }),
                                    "Full"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "block md:hidden",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                            as: "div",
                            className: "",
                            children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                                ref: setReferenceElement,
                                                className: `${open ? "bg-primary text-white" : ""} group flex flex-row p-2 place-content-center bg-surfaceVariant hover:bg-primary shadow-md hover:text-white border border-primaryContainer hover:border-primary rounded-lg col-span-1`,
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2ee5a7f7ec060e3f$export$2e2bcd8739ae039), {
                                                    className: `${open ? " text-white" : ""} h-5 w-5 self-center text-onSurfaceVariant group-hover:text-white`
                                                })
                                            })
                                        }),
                                        open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                                            as: (0, $exYeM.Fragment),
                                            enter: "transition-opacity ease-out duration-75",
                                            enterFrom: "transform opacity-0 scale-95",
                                            enterTo: "transform opacity-100 scale-100",
                                            leave: "transition ease-in duration-75",
                                            leaveFrom: "transform opacity-100 scale-100",
                                            leaveTo: "transform opacity-0 scale-95",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                                className: "absolute border-2 border-primaryContainer bg-white rounded-xl z-30 w-fit -ml-6",
                                                ref: setPopperElement,
                                                style: styles.popper,
                                                ...attributes.popper,
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    className: "flex flex-col divide-y p-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "flex justify-evenly gap-4 ",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    className: "py-2",
                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d0e5ef8bd1dc9733$export$2e2bcd8739ae039), {
                                                                        title: props.name + "\n",
                                                                        url: href,
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                            className: "flex flex-col justify-center items-center text-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $30be59c6ac7c486e$export$2e2bcd8739ae039), {
                                                                                        size: 32,
                                                                                        round: true
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                                                    className: "py-1",
                                                                                    children: "Twitter"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    className: "py-2",
                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e26074a2b4484734$export$2e2bcd8739ae039), {
                                                                        title: props.name + "\n",
                                                                        url: href,
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                            className: "flex flex-col justify-center items-center text-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fef596c67269757c$export$2e2bcd8739ae039), {
                                                                                    size: 32,
                                                                                    round: true
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                                                    className: "py-1",
                                                                                    children: "Telegram"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    className: "py-2",
                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                        onClick: ()=>{
                                                                            navigator.clipboard.writeText(href);
                                                                        },
                                                                        className: "flex flex-col justify-center items-center text-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7945723c9bf4c650$export$2e2bcd8739ae039), {
                                                                                className: "h-8 w-8 text-primary"
                                                                            }),
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                                                className: "py-1",
                                                                                children: "Copy"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                            onClick: ()=>{
                                                                props.handle.enter();
                                                            },
                                                            className: "flex justify-center items-center gap-2 p-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f92085fcc4c2f012$export$2e2bcd8739ae039), {
                                                                    className: " h-8 w-8  self-center text-primary"
                                                                }),
                                                                "Full Screen"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7f0198e378ac9d56$export$2e2bcd8739ae039), {
                open: openNotification,
                setOpen: setOpenNotification,
                blockchain: searchParams.get("blockchain"),
                optimistic: false
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $812617e8450d6179$export$2e2bcd8739ae039), {
                open: openLogin,
                setOpen: setOpenLogin
            })
        ]
    }));
}
var $9a3b74454697bd7e$export$2e2bcd8739ae039 = $9a3b74454697bd7e$var$ChartHeader;


// Created by James Launder
// Contains the data for different options
// functions to load data from URL
// also has structure for surrouding chart components e.g. menus, zoom...

var $aSiaI = parcelRequire("aSiaI");
// Created by James Launder
// Contains all the functions and the chart to display the dataGrouping

var $aSiaI = parcelRequire("aSiaI");



var $jR9u2 = parcelRequire("jR9u2");

var $exYeM = parcelRequire("exYeM");

var $1b9fd1c61e334a1c$exports = {};

$1b9fd1c61e334a1c$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "WevrWatermark.631d8fcc.svg";



// created by james launder, taken from somewhere online i think
// just returns the window width used for check width changes

var $exYeM = parcelRequire("exYeM");
function $a88fc3007e889430$var$getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width: width,
        height: height
    };
}
function $a88fc3007e889430$export$2e2bcd8739ae039() {
    const [windowDimensions, setWindowDimensions] = (0, $exYeM.useState)($a88fc3007e889430$var$getWindowDimensions());
    (0, $exYeM.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions($a88fc3007e889430$var$getWindowDimensions());
        }
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
}



var $exYeM = parcelRequire("exYeM");





function $5bec8ade940b537d$var$difference(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $5bec8ade940b537d$var$replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
var $5bec8ade940b537d$var$_client, $5bec8ade940b537d$var$_result, $5bec8ade940b537d$var$_queries, $5bec8ade940b537d$var$_observers, $5bec8ade940b537d$var$_options, $5bec8ade940b537d$var$_combinedResult, $5bec8ade940b537d$var$_setResult, $5bec8ade940b537d$var$setResult_fn, $5bec8ade940b537d$var$_combineResult, $5bec8ade940b537d$var$combineResult_fn, $5bec8ade940b537d$var$_findMatchingObservers, $5bec8ade940b537d$var$findMatchingObservers_fn, $5bec8ade940b537d$var$_onUpdate, $5bec8ade940b537d$var$onUpdate_fn, $5bec8ade940b537d$var$_notify, $5bec8ade940b537d$var$notify_fn;
var $5bec8ade940b537d$export$15352e437905ad4c = class extends (0, $d4b58c4894ac9142$export$d26086b469ecdbcc) {
    constructor(client, queries, options){
        super();
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_setResult);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_combineResult);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_findMatchingObservers);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_onUpdate);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_notify);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_client, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_result, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_queries, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_observers, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_options, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $5bec8ade940b537d$var$_combinedResult, void 0);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $5bec8ade940b537d$var$_client, client);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $5bec8ade940b537d$var$_queries, []);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $5bec8ade940b537d$var$_observers, []);
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_setResult, $5bec8ade940b537d$var$setResult_fn).call(this, []);
        this.setQueries(queries, options);
    }
    onSubscribe() {
        if (this.listeners.size === 1) (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_observers).forEach((observer)=>{
            observer.subscribe((result)=>{
                (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_onUpdate, $5bec8ade940b537d$var$onUpdate_fn).call(this, observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_observers).forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, options, notifyOptions) {
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $5bec8ade940b537d$var$_queries, queries);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $5bec8ade940b537d$var$_options, options);
        (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            const prevObservers = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_observers);
            const newObserverMatches = (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_findMatchingObservers, $5bec8ade940b537d$var$findMatchingObservers_fn).call(this, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_queries));
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions, notifyOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $5bec8ade940b537d$var$_observers, newObservers);
            (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_setResult, $5bec8ade940b537d$var$setResult_fn).call(this, newResult);
            if (!this.hasListeners()) return;
            $5bec8ade940b537d$var$difference(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            $5bec8ade940b537d$var$difference(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_onUpdate, $5bec8ade940b537d$var$onUpdate_fn).call(this, observer, result);
                });
            });
            (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_notify, $5bec8ade940b537d$var$notify_fn).call(this);
        });
    }
    getCurrentResult() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_combinedResult);
    }
    getQueries() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_observers).map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_observers);
    }
    getOptimisticResult(queries) {
        const matches = (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_findMatchingObservers, $5bec8ade940b537d$var$findMatchingObservers_fn).call(this, queries);
        const result = matches.map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
        return [
            result,
            (r)=>{
                return (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_combineResult, $5bec8ade940b537d$var$combineResult_fn).call(this, r ?? result);
            },
            ()=>{
                return matches.map((match, index)=>{
                    const observerResult = result[index];
                    return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult) : observerResult;
                });
            }
        ];
    }
};
$5bec8ade940b537d$var$_client = new WeakMap();
$5bec8ade940b537d$var$_result = new WeakMap();
$5bec8ade940b537d$var$_queries = new WeakMap();
$5bec8ade940b537d$var$_observers = new WeakMap();
$5bec8ade940b537d$var$_options = new WeakMap();
$5bec8ade940b537d$var$_combinedResult = new WeakMap();
$5bec8ade940b537d$var$_setResult = new WeakSet();
$5bec8ade940b537d$var$setResult_fn = function(value) {
    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $5bec8ade940b537d$var$_result, value);
    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $5bec8ade940b537d$var$_combinedResult, (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_combineResult, $5bec8ade940b537d$var$combineResult_fn).call(this, value));
};
$5bec8ade940b537d$var$_combineResult = new WeakSet();
$5bec8ade940b537d$var$combineResult_fn = function(input) {
    var _a;
    const combine = (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_options)) == null ? void 0 : _a.combine;
    if (combine) return (0, $54cfa1b7ba8b31b7$export$77a71fc411098696)((0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_combinedResult), combine(input));
    return input;
};
$5bec8ade940b537d$var$_findMatchingObservers = new WeakSet();
$5bec8ade940b537d$var$findMatchingObservers_fn = function(queries) {
    const prevObservers = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_observers);
    const prevObserversMap = new Map(prevObservers.map((observer)=>[
            observer.options.queryHash,
            observer
        ]));
    const defaultedQueryOptions = queries.map((options)=>(0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_client).defaultQueryOptions(options));
    const matchingObservers = defaultedQueryOptions.flatMap((defaultedOptions)=>{
        const match = prevObserversMap.get(defaultedOptions.queryHash);
        if (match != null) return [
            {
                defaultedQueryOptions: defaultedOptions,
                observer: match
            }
        ];
        return [];
    });
    const matchedQueryHashes = new Set(matchingObservers.map((match)=>match.defaultedQueryOptions.queryHash));
    const unmatchedQueries = defaultedQueryOptions.filter((defaultedOptions)=>!matchedQueryHashes.has(defaultedOptions.queryHash));
    const getObserver = (options)=>{
        const defaultedOptions = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_client).defaultQueryOptions(options);
        const currentObserver = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_observers).find((o)=>o.options.queryHash === defaultedOptions.queryHash);
        return currentObserver ?? new (0, $31d08b987957f909$export$a06cf8c0066f0d4c)((0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_client), defaultedOptions);
    };
    const newOrReusedObservers = unmatchedQueries.map((options)=>{
        return {
            defaultedQueryOptions: options,
            observer: getObserver(options)
        };
    });
    const sortMatchesByOrderOfQueries = (a, b)=>defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
    return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
};
$5bec8ade940b537d$var$_onUpdate = new WeakSet();
$5bec8ade940b537d$var$onUpdate_fn = function(observer, result) {
    const index = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_observers).indexOf(observer);
    if (index !== -1) {
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_setResult, $5bec8ade940b537d$var$setResult_fn).call(this, $5bec8ade940b537d$var$replaceAt((0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_result), index, result));
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $5bec8ade940b537d$var$_notify, $5bec8ade940b537d$var$notify_fn).call(this);
    }
};
$5bec8ade940b537d$var$_notify = new WeakSet();
$5bec8ade940b537d$var$notify_fn = function() {
    (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
        this.listeners.forEach((listener)=>{
            listener((0, $baa96523396bdf41$export$18a094aefa070634)(this, $5bec8ade940b537d$var$_result));
        });
    });
};







"use client";
function $d9ec3a60b698e2ea$export$408667c6c87da1e5({ queries: queries, ...options }, queryClient) {
    const client = (0, $1773e073a683367a$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $e19e6b604ff985b0$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $31d3dbc25c6d00e2$export$50dfac555130cafd)();
    const defaultedQueries = $exYeM.useMemo(()=>queries.map((opts)=>{
            const defaultedOptions = client.defaultQueryOptions(opts);
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        }), [
        queries,
        client,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, $15fb4845b820c283$export$2c40a591ad2dafb1)(query);
        (0, $a2a707fd2d0e1a70$export$ae8adb3de3d77633)(query, errorResetBoundary);
    });
    (0, $a2a707fd2d0e1a70$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $exYeM.useState(()=>new (0, $5bec8ade940b537d$export$15352e437905ad4c)(client, defaultedQueries, options));
    const [optimisticResult, getCombinedResult, trackResult] = observer.getOptimisticResult(defaultedQueries);
    $exYeM.useSyncExternalStore($exYeM.useCallback((onStoreChange)=>isRestoring ? ()=>void 0 : observer.subscribe((0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $exYeM.useEffect(()=>{
        observer.setQueries(defaultedQueries, options, {
            listeners: false
        });
    }, [
        defaultedQueries,
        options,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, $15fb4845b820c283$export$88d3586dfed64df9)(defaultedQueries[index], result, isRestoring));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const opts = defaultedQueries[index];
        const queryObserver = observer.getObservers()[index];
        if (opts && queryObserver) {
            if ((0, $15fb4845b820c283$export$88d3586dfed64df9)(opts, result, isRestoring)) return (0, $15fb4845b820c283$export$defdc11a9c9acfcf)(opts, queryObserver, errorResetBoundary);
            else if ((0, $15fb4845b820c283$export$e0a3f29513afe430)(result, isRestoring)) (0, $15fb4845b820c283$export$defdc11a9c9acfcf)(opts, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const observerQueries = observer.getQueries();
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        var _a;
        return (0, $a2a707fd2d0e1a70$export$1fbcf724762d607)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            throwOnError: ((_a = defaultedQueries[index]) == null ? void 0 : _a.throwOnError) ?? false,
            query: observerQueries[index]
        });
    });
    if (firstSingleResultWhichShouldThrow == null ? void 0 : firstSingleResultWhichShouldThrow.error) throw firstSingleResultWhichShouldThrow.error;
    return getCombinedResult(trackResult());
}





const $94784b6a454d4c0d$var$addQuery = (blockchain, res, name, source)=>{
    var newQuery = null;
    if (source === null) newQuery = {
        key: [
            blockchain,
            res,
            name
        ],
        url: "/" + blockchain + "/" + res + "/" + name
    };
    else newQuery = {
        key: [
            blockchain,
            res,
            name,
            source
        ],
        url: "/" + blockchain + "/" + res + "/" + name + "/" + source
    };
    return newQuery;
};
const $94784b6a454d4c0d$var$remove = (index, state)=>{
    const newState = [
        ...state
    ];
    newState.splice(index, 1);
    return newState;
};
const $94784b6a454d4c0d$var$removeMulti = (start, end, state)=>{
    const newState = [
        ...state
    ];
    newState.splice(start, end);
    return newState;
};
const $94784b6a454d4c0d$export$92838378c829615a = (0, $405a4fa4811a9356$exports.create)((set)=>({
        queryUrl: [],
        addQuery: (blockchain, res, name, source)=>set((state)=>({
                    queryUrl: [
                        ...state.queryUrl,
                        $94784b6a454d4c0d$var$addQuery(blockchain, res, name, source)
                    ]
                })),
        removeQuery: (index)=>set((state)=>({
                    queryUrl: $94784b6a454d4c0d$var$remove(index, state.queryUrl)
                })),
        removeMultiQuery: (start, end)=>set((state)=>({
                    queryUrl: $94784b6a454d4c0d$var$removeMulti(start, end, state.queryUrl)
                })),
        removeAll: ()=>set(()=>({
                    queryUrl: []
                }))
    }));



var $exYeM = parcelRequire("exYeM");
function $442f21bf70571909$export$2e2bcd8739ae039() {
    const queryUrl = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.queryUrl);
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    // var errorStatus = null;
    const [errorStatus, setErrorStatus] = (0, $exYeM.useState)(false);
    // console.log("usecharts Called!");
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    async function query(url) {
        return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(url, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        }).then((response)=>{
            setErrorStatus(false);
            return response;
        }).catch(function(error) {
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.log(resMessage);
            // console.log(error.response);
            setErrorStatus(resMessage);
            return resMessage;
        });
    }
    var string = searchParams.get("source") ? "/" + searchParams.get("blockchain") + "/" + searchParams.get("resolution") + "/" + searchParams.get("name") + "/" + searchParams.get("source") : "/" + searchParams.get("blockchain") + "/" + searchParams.get("resolution") + "/" + searchParams.get("name");
    var key = searchParams.get("source") ? [
        searchParams.get("blockchain"),
        searchParams.get("resolution"),
        searchParams.get("name"),
        searchParams.get("source")
    ] : [
        searchParams.get("blockchain"),
        searchParams.get("resolution"),
        searchParams.get("name")
    ];
    const queryStateV2 = [
        {
            key: key,
            url: string
        },
        {
            key: [
                "price",
                searchParams.get("blockchain"),
                searchParams.get("resolution")
            ],
            url: "/" + searchParams.get("blockchain") + "/Price/" + searchParams.get("resolution")
        }
    ];
    // console.log(queryStateV2.concat(queryUrl));
    const allQueries = queryStateV2.concat(queryUrl);
    // console.log(allQueries);
    const results = (0, $d9ec3a60b698e2ea$export$408667c6c87da1e5)({
        queries: allQueries.map((value)=>{
            // console.log("called");
            return {
                queryKey: value.key,
                queryFn: ()=>query(value.url)
            };
        })
    });
    return {
        results: results,
        error: errorStatus
    };
}



// src/index.tsx

var $exYeM = parcelRequire("exYeM");

var $ba7e136bc7a14a3f$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $ba7e136bc7a14a3f$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$ba7e136bc7a14a3f$exports = $ba7e136bc7a14a3f$var$invariant;


var $031c5e26b7af07bf$exports = {};
//
$031c5e26b7af07bf$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


// src/constants.ts
var $1b1ce360ba5de5b0$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($1b1ce360ba5de5b0$var$TAG_NAMES || {});
var $1b1ce360ba5de5b0$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $1b1ce360ba5de5b0$var$VALID_TAG_NAMES = Object.values($1b1ce360ba5de5b0$var$TAG_NAMES);
var $1b1ce360ba5de5b0$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $1b1ce360ba5de5b0$var$HTML_TAG_MAP = Object.entries($1b1ce360ba5de5b0$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $1b1ce360ba5de5b0$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $1b1ce360ba5de5b0$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $1b1ce360ba5de5b0$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $1b1ce360ba5de5b0$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $1b1ce360ba5de5b0$var$getInnermostProperty(propsList, $1b1ce360ba5de5b0$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $1b1ce360ba5de5b0$var$getInnermostProperty(propsList, $1b1ce360ba5de5b0$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $1b1ce360ba5de5b0$var$getOnChangeClientState = (propsList)=>$1b1ce360ba5de5b0$var$getInnermostProperty(propsList, $1b1ce360ba5de5b0$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $1b1ce360ba5de5b0$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $1b1ce360ba5de5b0$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $1b1ce360ba5de5b0$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $1b1ce360ba5de5b0$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $1b1ce360ba5de5b0$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $1b1ce360ba5de5b0$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $1b1ce360ba5de5b0$var$reducePropsToState = (propsList)=>({
        baseTag: $1b1ce360ba5de5b0$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $1b1ce360ba5de5b0$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $1b1ce360ba5de5b0$var$getInnermostProperty(propsList, $1b1ce360ba5de5b0$var$HELMET_PROPS.DEFER),
        encode: $1b1ce360ba5de5b0$var$getInnermostProperty(propsList, $1b1ce360ba5de5b0$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $1b1ce360ba5de5b0$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $1b1ce360ba5de5b0$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $1b1ce360ba5de5b0$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $1b1ce360ba5de5b0$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $1b1ce360ba5de5b0$var$getOnChangeClientState(propsList),
        scriptTags: $1b1ce360ba5de5b0$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $1b1ce360ba5de5b0$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $1b1ce360ba5de5b0$var$getTitleFromPropsList(propsList),
        titleAttributes: $1b1ce360ba5de5b0$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $1b1ce360ba5de5b0$var$getAnyTrueFromPropsList(propsList, $1b1ce360ba5de5b0$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $1b1ce360ba5de5b0$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $1b1ce360ba5de5b0$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $1b1ce360ba5de5b0$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($1b1ce360ba5de5b0$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $1b1ce360ba5de5b0$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $1b1ce360ba5de5b0$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $1b1ce360ba5de5b0$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $1b1ce360ba5de5b0$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $1b1ce360ba5de5b0$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $1b1ce360ba5de5b0$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $1b1ce360ba5de5b0$var$flattenArray(title);
    return attributeString ? `<${type} ${$1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$1b1ce360ba5de5b0$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE}="true">${$1b1ce360ba5de5b0$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $1b1ce360ba5de5b0$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$1b1ce360ba5de5b0$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $1b1ce360ba5de5b0$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $1b1ce360ba5de5b0$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $1b1ce360ba5de5b0$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $1b1ce360ba5de5b0$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE]: true
    };
    const props = $1b1ce360ba5de5b0$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $1b1ce360ba5de5b0$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $1b1ce360ba5de5b0$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(type, mappedTag);
    });
var $1b1ce360ba5de5b0$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$1b1ce360ba5de5b0$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$1b1ce360ba5de5b0$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$1b1ce360ba5de5b0$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$1b1ce360ba5de5b0$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$1b1ce360ba5de5b0$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$1b1ce360ba5de5b0$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $1b1ce360ba5de5b0$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $1b1ce360ba5de5b0$var$prioritizer(metaTags, $1b1ce360ba5de5b0$var$SEO_PRIORITY_TAGS.meta);
    const link = $1b1ce360ba5de5b0$var$prioritizer(linkTags, $1b1ce360ba5de5b0$var$SEO_PRIORITY_TAGS.link);
    const script = $1b1ce360ba5de5b0$var$prioritizer(scriptTags, $1b1ce360ba5de5b0$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$1b1ce360ba5de5b0$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$1b1ce360ba5de5b0$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$1b1ce360ba5de5b0$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$1b1ce360ba5de5b0$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$1b1ce360ba5de5b0$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$1b1ce360ba5de5b0$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $1b1ce360ba5de5b0$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>{},
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $1b1ce360ba5de5b0$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $1b1ce360ba5de5b0$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $1b1ce360ba5de5b0$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $1b1ce360ba5de5b0$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $1b1ce360ba5de5b0$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $1b1ce360ba5de5b0$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $1b1ce360ba5de5b0$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $1b1ce360ba5de5b0$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $1b1ce360ba5de5b0$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $1b1ce360ba5de5b0$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $1b1ce360ba5de5b0$var$server_default = $1b1ce360ba5de5b0$var$mapStateOnServer;
// src/HelmetData.ts
var $1b1ce360ba5de5b0$var$instances = [];
var $1b1ce360ba5de5b0$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $1b1ce360ba5de5b0$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $1b1ce360ba5de5b0$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $1b1ce360ba5de5b0$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $1b1ce360ba5de5b0$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $1b1ce360ba5de5b0$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $1b1ce360ba5de5b0$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $1b1ce360ba5de5b0$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
// src/Provider.tsx
var $1b1ce360ba5de5b0$var$defaultValue = {};
var $1b1ce360ba5de5b0$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext($1b1ce360ba5de5b0$var$defaultValue);
var $1b1ce360ba5de5b0$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $exYeM.Component) {
    static canUseDOM = $1b1ce360ba5de5b0$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        this.helmetData = new $1b1ce360ba5de5b0$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1b1ce360ba5de5b0$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $1b1ce360ba5de5b0$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $1b1ce360ba5de5b0$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($1b1ce360ba5de5b0$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $1b1ce360ba5de5b0$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $1b1ce360ba5de5b0$var$flattenArray(title);
    $1b1ce360ba5de5b0$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $1b1ce360ba5de5b0$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $1b1ce360ba5de5b0$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $1b1ce360ba5de5b0$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $1b1ce360ba5de5b0$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $1b1ce360ba5de5b0$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $1b1ce360ba5de5b0$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $1b1ce360ba5de5b0$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $1b1ce360ba5de5b0$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $1b1ce360ba5de5b0$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $1b1ce360ba5de5b0$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $1b1ce360ba5de5b0$var$_helmetCallback = null;
var $1b1ce360ba5de5b0$var$handleStateChangeOnClient = (newState)=>{
    if ($1b1ce360ba5de5b0$var$_helmetCallback) cancelAnimationFrame($1b1ce360ba5de5b0$var$_helmetCallback);
    if (newState.defer) $1b1ce360ba5de5b0$var$_helmetCallback = requestAnimationFrame(()=>{
        $1b1ce360ba5de5b0$var$commitTagChanges(newState, ()=>{
            $1b1ce360ba5de5b0$var$_helmetCallback = null;
        });
    });
    else {
        $1b1ce360ba5de5b0$var$commitTagChanges(newState);
        $1b1ce360ba5de5b0$var$_helmetCallback = null;
    }
};
var $1b1ce360ba5de5b0$var$client_default = $1b1ce360ba5de5b0$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $1b1ce360ba5de5b0$var$HelmetDispatcher = class extends (0, $exYeM.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($031c5e26b7af07bf$exports)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $1b1ce360ba5de5b0$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const props = {
                ...instance.props
            };
            delete props.context;
            return props;
        }));
        if ($1b1ce360ba5de5b0$export$4719288a8f5f7e71.canUseDOM) $1b1ce360ba5de5b0$var$client_default(state);
        else if ($1b1ce360ba5de5b0$var$server_default) serverState = $1b1ce360ba5de5b0$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
// src/index.tsx
var $1b1ce360ba5de5b0$export$dcef8f9bb9a41431 = class extends (0, $exYeM.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($bba2b2857408f717$exports)))($1b1ce360ba5de5b0$var$without(this.props, "helmetData"), $1b1ce360ba5de5b0$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ba7e136bc7a14a3f$exports)))($1b1ce360ba5de5b0$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$1b1ce360ba5de5b0$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($ba7e136bc7a14a3f$exports)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$1b1ce360ba5de5b0$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $1b1ce360ba5de5b0$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $1b1ce360ba5de5b0$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1b1ce360ba5de5b0$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1b1ce360ba5de5b0$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1b1ce360ba5de5b0$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};



(parcelRequire("bb2ZQ"))((0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))));

(parcelRequire("b6McJ"))((0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))));

(parcelRequire("4N9yf"))((0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))));
function $6f36bc2d81eb620e$var$Chart(props) {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const chartRef = (0, $exYeM.useRef)(null);
    const { results: results } = (0, $442f21bf70571909$export$2e2bcd8739ae039)();
    // const setSidebar = useSidebarState((state) => state.setSidebar);
    // console.log(results);
    const emaRef = (0, $exYeM.useRef)();
    const smaRef = (0, $exYeM.useRef)();
    //   const { theme } = useContext(ThemeContext);
    const [text] = (0, $exYeM.useState)();
    const { width: width } = (0, $a88fc3007e889430$export$2e2bcd8739ae039)();
    const { name: name, description: description } = (0, $0edff4a12d1a07f6$export$2e2bcd8739ae039)(); // Use the custom hook
    const pageUrl = window.location.href;
    const imageUrl = "https://api.wevr.ai/V2/assets/WevrTwitterCard.png";
    const title = `${name} Chart | Wevr.ai`;
    var watermark = "";
    var largeWatermark = (0, (/*@__PURE__*/$parcel$interopDefault($1b9fd1c61e334a1c$exports)));
    var smallWatermark = (0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports)));
    // this allow us to set a custom font for the chart
    var newStyle = document.createElement("style");
    newStyle.appendChild(document.createTextNode("@font-face {  font-family: 'Monda';  font-style: sans-serif;  font-weight: 400;  src: url('https://fonts.googleapis.com/css2?family=Monda&display=swap')  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}"));
    document.head.appendChild(newStyle);
    // Used to add new data to the chart for the compare function.
    const createData = (name, data, color, scale, style, blockchain, source, resolution)=>{
        // creates a temporary new data object that contains tha data and ID
        // the grouping may be adjusted in the future as use may not be required
        var newData = {
            id: name + blockchain + source + resolution,
            name: name,
            data: data,
            yAxis: "yaxis" + name + blockchain + source + resolution,
            color: color,
            type: style
        };
        dataSource.push(newData);
        // creates a new Y axis to go along with the new chart
        var newYaxis = {
            id: "yaxis" + name + blockchain + source + resolution,
            opposite: !yAxisSetup[yAxisSetup.length - 1].opposite,
            type: scale,
            labels: {
                style: {
                    fontSize: "14px",
                    color: color
                }
            },
            events: {}
        };
        yAxisSetup.push(newYaxis);
        // this updates the chartOptions with the new data
        setChartOptions({
            series: dataSource,
            yAxis: yAxisSetup
        });
    };
    // used for removing an additional chart
    const removeData = (name, blockchain, source, resolution)=>{
        // resets the state used to pass through updates and removals
        props.setUpdateChart(null);
        props.setRemove(null);
        // find the chart based on the ID created
        const objWithIdIndex = dataSource.findIndex((obj)=>obj.id === name + blockchain + source + resolution);
        const yAxisIndex = yAxisSetup.findIndex((obj)=>obj.id === dataSource[objWithIdIndex].yAxis);
        yAxisSetup.splice(yAxisIndex, 1);
        dataSource.splice(objWithIdIndex, 1);
        setChartOptions({
            series: dataSource,
            yAxis: yAxisSetup
        });
    };
    // used to keep the charts in sync with the query data
    const checkForNewChart = ()=>{
        // this gets all the data that has an id in the json
        // used due to SMA and EMA lines getting added and causing wrong count
        let amntOfCharts = chartOptions.series.filter((x)=>x["id"]).length;
        if (props.dataV2.length > amntOfCharts) {
            if (!props.dataV2.some((results)=>results.isFetching)) {
                if (!props.dataV2.some((results)=>results.isError)) {
                    // reduce the current series down to just the name values
                    let newChart = Object.keys(chartOptions.series.reduce((a, { id: id })=>Object.assign(a, {
                            [id]: undefined
                        }), {}));
                    // check the additional charts array to find the chart that is neww
                    let filtered = props.additionalCharts.filter(({ id: id })=>!newChart.includes(id));
                    var index = -1;
                    if (filtered.length > 0) // finds the index of each new chart
                    filtered.forEach((data)=>{
                        if (data?.source === null) index = props.dataV2.findIndex(function(el) {
                            return el.data.config.url === "/" + data.blockchain + "/" + data.resolution + "/" + data.name;
                        });
                        else index = props.dataV2.findIndex(function(el) {
                            return el.data.config.url === "/" + data.blockchain + "/" + data.resolution + "/" + data.name + "/" + data.source;
                        });
                        // adds each new chart found to the chart object
                        createData(props.dataV2[index]?.data.data.name, props.dataV2[index]?.data.data.graphData[0]?.values, data?.color.hex, data?.scale.data, data?.style.data, data?.blockchain, data?.source, data?.resolution);
                    });
                }
            }
        }
    };
    // also used to help maintain sync
    const checkRemove = ()=>{
        let amntOfCharts = chartOptions.series.filter((x)=>x["id"]).length;
        if (props.dataV2.length < amntOfCharts && props.remove != null) removeData(props.remove.name, props.remove.blockchain, props.remove.source, props.remove.resolution);
    };
    const resetCharts = ()=>{
        // console.log(resetChartsState);
        // if (resetChartsState) {
        const len = dataSource.length;
        yAxisSetup.splice(2, len - 2);
        dataSource.splice(2, len - 2);
    // resetChartsToggle;
    // }
    };
    // uses the update state to provide data for the update
    const updateAdditional = ()=>{
        if (props.updateChart != null) {
            var index = dataSource.findIndex((data)=>data.id === props.updateChart.name + props.updateChart.blockchain + props.updateChart.source + props.updateChart.resolution);
            var yAxisIndex = 0;
            if (index > -1) {
                yAxisIndex = yAxisSetup.findIndex((obj)=>obj.id === dataSource[index].yAxis);
                if (props.updateChart.key === "color") {
                    dataSource[index].color = props.updateChart.update.hex;
                    yAxisSetup[yAxisIndex].labels.style.color = props.updateChart.update.hex;
                }
                if (props.updateChart.key === "style") dataSource[index].type = props.updateChart.update.data;
                if (props.updateChart.key === "scale") yAxisSetup[yAxisIndex].type = props.updateChart.update.data;
            }
            setChartOptions({
                series: dataSource,
                yAxis: yAxisSetup
            });
            props.setUpdateChart(null);
        }
    };
    // adds or removes the ema line from the options state
    const SetEMA = ()=>{
        // finds the ema line in the state
        let index = dataSource.map((object)=>object.type).indexOf("ema");
        if (searchParams.get("ema") == "None" || searchParams.get("ema") == null) {
            if (index > 0) {
                dataSource.splice(index, 1);
                setChartOptions({
                    series: dataSource
                });
            }
            emaRef.current = 0;
        } else if (index === -1) {
            emaRef.current = 1;
            dataSource.push({
                type: "ema",
                linkedTo: "first",
                showInLegend: true,
                params: {
                    period: parseInt(searchParams.get("ema"))
                },
                color: "blue",
                dataGrouping: {
                    approximation: "average",
                    enabled: false,
                    forced: true,
                    units: [
                        [
                            "day",
                            [
                                1
                            ]
                        ]
                    ]
                }
            });
            setChartOptions({
                series: dataSource
            });
        } else {
            // EMA already exists and has been changed to a new value
            dataSource.splice(index, 1);
            dataSource.push({
                type: "ema",
                linkedTo: "first",
                showInLegend: true,
                params: {
                    period: parseInt(searchParams.get("ema"))
                },
                color: "blue",
                dataGrouping: {
                    approximation: "average",
                    enabled: false,
                    forced: true,
                    units: [
                        [
                            "day",
                            [
                                1
                            ]
                        ]
                    ]
                }
            });
            setChartOptions({
                series: dataSource
            });
        }
    };
    // adds or removes the sma line from the options state
    const SetSMA = ()=>{
        let index = dataSource.map((object)=>object.type).indexOf("sma");
        if (searchParams.get("sma") == "None" || searchParams.get("sma") == null) {
            if (index > 0) {
                dataSource.splice(index, 1);
                setChartOptions({
                    series: dataSource
                });
            }
            smaRef.current = 0;
        } else if (index === -1) {
            smaRef.current = 1;
            dataSource.push({
                type: "sma",
                linkedTo: "first",
                showInLegend: true,
                params: {
                    period: parseInt(searchParams.get("sma"))
                },
                color: "red",
                dataGrouping: {
                    approximation: "average",
                    enabled: false,
                    forced: true,
                    units: [
                        [
                            "day",
                            [
                                1
                            ]
                        ]
                    ]
                }
            });
            setChartOptions({
                series: dataSource
            });
        } else {
            // SMA already exists and has been changed to a new value
            dataSource.splice(index, 1);
            dataSource.push({
                type: "sma",
                linkedTo: "first",
                showInLegend: true,
                params: {
                    period: parseInt(searchParams.get("sma"))
                },
                color: "red",
                dataGrouping: {
                    approximation: "average",
                    enabled: false,
                    forced: true,
                    units: [
                        [
                            "day",
                            [
                                1
                            ]
                        ]
                    ]
                }
            });
            setChartOptions({
                series: dataSource
            });
        }
    };
    const setScale = ()=>{
        // find every scale in the list then split and order by number, create loop that links each y axis to th eindex to update it
        var arrayTemp = [];
        for (const key of searchParams.keys()){
            var objTemp = {};
            objTemp.key = key;
            objTemp.value = searchParams.get(key);
            arrayTemp.push(objTemp);
        }
        var i = 0;
        arrayTemp.forEach((value)=>{
            if (value.key.includes("scale")) {
                if (value.value == "Log") yAxisSetup[i].type = "logarithmic";
                else yAxisSetup[i].type = "linear";
                i++;
            }
        });
        setChartOptions({
            series: dataSource,
            yAxis: yAxisSetup
        });
        i = 0;
    };
    // grouping is unused for now but may be need later
    // is done in old way to may need to be updated if reenabled
    // const setGrouping = () => {
    //   if (searchParams.get("resolution") == "Daily") {
    //     dataSource.forEach((element) => {
    //       element.dataGrouping.enabled = true;
    //     });
    //   } else {
    //     dataSource.forEach((element) => {
    //       element.dataGrouping.enabled = false;
    //     });
    //   }
    // };
    //   const SetColour = () => {
    //     //   if (theme === "dark") {
    //     //     //   setBrush("#000000");
    //     //     setText("#32a852");
    //     //     // setInverseText("#000000");
    //     //     // setStroke(0.4);
    //     //   } else {
    //     setText("#000000");
    //     setBrush("#000000");
    //     // setInverseText("#ffffff");
    //     // setStroke(1.5);
    //     //   }
    //   };
    // updates the relevant line to bar or vice versa
    const updateSeries = ()=>{
        var arrayTemp = [];
        for (const key of searchParams.keys()){
            var objTemp = {};
            objTemp.key = key;
            objTemp.value = searchParams.get(key);
            arrayTemp.push(objTemp);
        }
        var i = 0;
        arrayTemp.forEach((value)=>{
            if (value.key.includes("type")) {
                if (value.value == "Bar") dataSource[i].type = "column";
                else dataSource[i].type = "line";
                i++;
            }
        });
        setChartOptions({
            series: dataSource,
            yAxis: yAxisSetup
        });
        i = 0;
    };
    // Stores the data for each line on the chart as well as options for each line
    const [dataSource] = (0, $exYeM.useState)([
        {
            id: "first",
            name: results[0]?.data?.data?.name,
            data: results[0]?.data?.data?.graphData[0]?.values,
            color: "#FA9173",
            type: "line",
            yAxis: "1"
        },
        {
            id: "price",
            name: results[1]?.data?.data?.name,
            data: results[1]?.data?.data?.graphData[0]?.values,
            color: "#0E0C22",
            type: "line",
            yAxis: "2"
        }
    ]);
    // stores the yaxis and settings for each one
    const [yAxisSetup] = (0, $exYeM.useState)([
        {
            id: "1",
            opposite: false,
            labels: {
                style: {
                    fontSize: "14px",
                    color: "#FA9173"
                }
            },
            events: {}
        },
        {
            id: "2",
            opposite: true,
            labels: {
                style: {
                    fontSize: "14px",
                    color: "#0E0C22"
                }
            },
            events: {}
        }
    ]);
    // stores all the options for the entire chart inculding the data and y axis states.
    const [chartOptions, setChartOptions] = (0, $exYeM.useState)({
        exporting: {
            enabled: false,
            enableImages: true
        },
        legend: {
            enabled: true,
            itemStyle: {
                color: text,
                fontWeight: "bold"
            }
        },
        chart: {
            zoomType: "x",
            backgroundColor: "transparent",
            renderTo: this,
            style: {
                fontFamily: "Monda"
            },
            events: {
                load: function() {
                    var height_image = 127;
                    var width_image = 627.98;
                    // var height_image = 48;
                    // var width_image = 20;
                    var textX = this.plotLeft + this.plotWidth * 0.5;
                    var textY = this.plotTop + this.plotHeight * 0.5;
                    var position_x = textX - width_image / 2;
                    var position_y = textY - height_image / 2;
                    // console.log(this.plotWidth);
                    watermark = this.renderer.image(largeWatermark, position_x, position_y, 627.98, 127).add();
                },
                redraw: function() {
                    var plotWidth = this.plotWidth;
                    var threshold = 800;
                    if (plotWidth < threshold && watermark.href !== smallWatermark) {
                        var height_image_sm = 100;
                        var width_image_sm = 152;
                        var textX_sm = this.plotLeft + this.plotWidth * 0.5;
                        var textY_sm = this.plotTop + this.plotHeight * 0.5;
                        var position_x_sm = textX_sm - width_image_sm / 2;
                        var position_y_sm = textY_sm - height_image_sm / 2;
                        watermark.attr({
                            x: position_x_sm,
                            y: position_y_sm
                        });
                        watermark.attr({
                            href: smallWatermark,
                            width: width_image_sm,
                            height: height_image_sm
                        });
                    } else if (plotWidth >= threshold && watermark.href !== largeWatermark) {
                        var height_image = 127;
                        var width_image = 627.98;
                        var textX = this.plotLeft + this.plotWidth * 0.5;
                        var textY = this.plotTop + this.plotHeight * 0.5;
                        var position_x = textX - width_image / 2;
                        var position_y = textY - height_image / 2;
                        watermark.attr({
                            x: position_x,
                            y: position_y
                        });
                        watermark.attr({
                            href: largeWatermark,
                            width: width_image,
                            height: height_image
                        });
                    }
                }
            }
        },
        scrollbar: {
            enabled: false
        },
        xAxis: {
            labels: {
                style: {
                    fontSize: "13px"
                }
            },
            events: {
                setExtremes (e) {
                    props.min(e.min);
                    props.max(e.max);
                    props.setMinZoom(e.min);
                    props.setMaxZoom(e.max);
                }
            }
        },
        yAxis: yAxisSetup,
        series: dataSource,
        credits: {
            enabled: false
        },
        navigator: {
            maskFill: "rgba(250, 145, 115, 0.35)"
        },
        rangeSelector: {
            enabled: false
        },
        tooltip: {
            useHTML: true,
            formatter: function() {
                return this.points.reduce(function(s, point) {
                    return s + "<br/> <div>" + '<span style="color:' + point.color + '"> <b>' + point.series.name + ": " + "</b> </span>" + "<span>" + point.y.toLocaleString("en-US", {
                        maximumFractionDigits: 2
                    }) + "</span>";
                }, "<b>" + (0, (/*@__PURE__*/$parcel$interopDefault($jR9u2))).unix(this.x / 1000).format("DD/MM/YY, HH:mm:ss") + "</b>");
            },
            valueDecimals: 2,
            split: true,
            borderColor: "#FA9173",
            borderRadius: 8,
            borderWidth: 1,
            shared: true
        },
        accessibility: {
            enabled: false
        }
    });
    // updates the zoom of the chart based off the dates buttons
    (0, $exYeM.useEffect)(()=>{
        if (chartRef != null) chartRef.current.chart?.xAxis[0].setExtremes(props.minZoom, props.maxZoom);
    }, [
        props.minZoom,
        props.maxZoom
    ]);
    // ensures that the data is always updated and checks if window should be resized
    (0, $exYeM.useEffect)(()=>{
        setChartOptions({
            series: dataSource
        });
        window.dispatchEvent(new Event("resize"));
    }, []);
    // updates settings for the main chart when the url changes
    (0, $exYeM.useEffect)(()=>{
        SetEMA();
        SetSMA();
        setScale();
        // setGrouping();
        updateSeries();
    }, [
        searchParams
    ]);
    // trys to maintain sync
    (0, $exYeM.useEffect)(()=>{
        checkForNewChart();
        checkRemove();
    }, [
        results
    ]);
    (0, $exYeM.useEffect)(()=>{
        resetCharts();
    }, [
        searchParams.get("name")
    ]);
    // syncs the updates
    (0, $exYeM.useEffect)(()=>{
        updateAdditional();
    }, [
        props.updateChart
    ]);
    // checks the size of the chart when sidebar open/closed
    // useEffect(() => {
    //   window.dispatchEvent(new Event("resize"));
    //   console.log("cllaed");
    // }, [props.sidebar]);
    (0, $exYeM.useEffect)(()=>{
        // resizeWatermark();
        // if (chartRef != null) {
        // window.dispatchEvent(new Event("resize"));
        // }
        // const handleResize = () => {
        if (chartRef.current) chartRef.current.chart.reflow();
    // };
    // window.addEventListener("resize", handleResize);
    // // Call handleResize initially to ensure the chart is sized correctly on mount
    // handleResize();
    // return () => {
    //   window.removeEventListener("resize", handleResize);
    // };
    }, [
        width,
        props.sidebar
    ]);
    (0, $exYeM.useEffect)(()=>{
        var replace = {
            id: "first",
            name: results[0]?.data?.data?.name,
            data: results[0]?.data?.data?.graphData[0]?.values,
            color: "#FA9173",
            type: "line",
            yAxis: "1"
        };
        dataSource.splice(0, 1, replace);
    }, [
        searchParams.get("blockchain"),
        searchParams.get("resolution"),
        searchParams.get("name"),
        searchParams.get("source")
    ]);
    (0, $exYeM.useEffect)(()=>{
        var replace = {
            id: "price",
            name: results[1]?.data?.data?.name,
            data: results[1]?.data?.data?.graphData[0]?.values,
            color: "#737272",
            type: "line",
            yAxis: "2"
        };
        dataSource.splice(1, 1, replace);
    }, [
        searchParams.get("blockchain"),
        searchParams.get("resolution")
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1b1ce360ba5de5b0$export$4719288a8f5f7e71), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1b1ce360ba5de5b0$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:image",
                        content: imageUrl
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:image",
                        content: imageUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "grid h-[85vh] md:h-[75vh]",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
                    containerProps: {
                        style: {
                            height: "100%"
                        }
                    },
                    highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))),
                    constructorType: "stockChart",
                    options: chartOptions,
                    ref: chartRef,
                    oneToOne: true
                })
            })
        ]
    });
}
var $6f36bc2d81eb620e$export$2e2bcd8739ae039 = $6f36bc2d81eb620e$var$Chart;


// Created By James Launder
// Chart Options Dropdown menu

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
function $9b82b6f96fc76ebd$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
        clipRule: "evenodd"
    }));
}
const $9b82b6f96fc76ebd$var$ForwardRef = $exYeM.forwardRef($9b82b6f96fc76ebd$var$ChevronDownIcon);
var $9b82b6f96fc76ebd$export$2e2bcd8739ae039 = $9b82b6f96fc76ebd$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $e5ea8ee4dc7caabc$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z",
        clipRule: "evenodd"
    }));
}
const $e5ea8ee4dc7caabc$var$ForwardRef = $exYeM.forwardRef($e5ea8ee4dc7caabc$var$ChevronRightIcon);
var $e5ea8ee4dc7caabc$export$2e2bcd8739ae039 = $e5ea8ee4dc7caabc$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $11abbe69da1e2b5b$var$Cog6ToothIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z",
        clipRule: "evenodd"
    }));
}
const $11abbe69da1e2b5b$var$ForwardRef = $exYeM.forwardRef($11abbe69da1e2b5b$var$Cog6ToothIcon);
var $11abbe69da1e2b5b$export$2e2bcd8739ae039 = $11abbe69da1e2b5b$var$ForwardRef;




// works differently to additional options as this relies on the URL params to communicate the data instaed of internal states.
function $63b80c27e867e612$var$ChartOptions(props) {
    const [selectedExchange, setSelectedExchange] = (0, $exYeM.useState)("FTX");
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [selectedResolution, setSelectedResolution] = (0, $exYeM.useState)(searchParams.get("resolution"));
    const [emaInput, setEmaInput] = (0, $exYeM.useState)("");
    const [selectedEma, setSelectedEma] = (0, $exYeM.useState)(searchParams.get("ema"));
    const [smaInput, setSmaInput] = (0, $exYeM.useState)("");
    const [selectedSma, setSelectedSma] = (0, $exYeM.useState)(searchParams.get("sma"));
    const { name: name, resolution: resolution, dataSource: dataSource, sources: sources } = (0, $0edff4a12d1a07f6$export$2e2bcd8739ae039)();
    const [chartOpts, setChartOpts] = (0, $exYeM.useState)({
        chartOptions: [
            {
                yAxis: "Linear",
                style: "Line",
                name: name
            },
            {
                yAxis: "Linear",
                style: "Line",
                name: "Price"
            }
        ]
    });
    let [referenceElement, setReferenceElement] = (0, $exYeM.useState)();
    let [popperElement, setPopperElement] = (0, $exYeM.useState)();
    let { styles: styles, attributes: attributes } = (0, $d674741d7e6ed1a9$export$f4d5bf230a36dd6e)(referenceElement, popperElement, {
        placement: "right-start"
    });
    const [EMA] = (0, $exYeM.useState)({
        None: [
            {
                disabled: "disabled"
            }
        ],
        "7d": [],
        "14d": [],
        "30d": []
    });
    const [SMA] = (0, $exYeM.useState)({
        None: [
            {
                disabled: "disabled"
            }
        ],
        "7d": [],
        "14d": [],
        "30d": []
    });
    const params = (name, value)=>{
        searchParams.set(name, value);
        setSearchParams(searchParams);
    };
    // on load
    (0, $exYeM.useEffect)(()=>{
        if (localStorage.getItem("user") != null) {
            if (JSON.parse(localStorage.getItem("user")).tier == 0) setSelectedResolution("Daily");
        }
        if (sources) // i made changes here
        setSelectedExchange(sources[0]?.name);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        updateName(0, name);
    }, [
        name
    ]);
    (0, $exYeM.useEffect)(()=>{
        setSelectedEma(searchParams.get("ema"));
        setSelectedSma(searchParams.get("sma"));
        setSelectedResolution(searchParams.get("resolution"));
        setSelectedExchange(searchParams.get("source"));
    }, [
        searchParams
    ]);
    const handleEmaInput = (event)=>{
        setEmaInput(event.target.value);
        setSelectedEma(event.target.value);
        if (!event.target.value) setSelectedEma(searchParams.get("ema"));
    };
    const handleSmaInput = (event)=>{
        setSmaInput(event.target.value);
        setSelectedSma(event.target.value);
        if (!event.target.value) setSelectedSma(searchParams.get("sma"));
    };
    const updateStyle = (name, value)=>{
        let updatedList = chartOpts.chartOptions.map((item)=>{
            if (item.name === name) return {
                ...item,
                style: value
            };
            return item;
        });
        setChartOpts({
            chartOptions: updatedList
        });
    };
    const updateYaxis = (name, value)=>{
        let updatedList = chartOpts.chartOptions.map((item)=>{
            if (item.name === name) return {
                ...item,
                yAxis: value
            };
            return item;
        });
        setChartOpts({
            chartOptions: updatedList
        });
    };
    const updateName = (itemIndex, value)=>{
        let updatedList = chartOpts.chartOptions.map((item, index)=>{
            if (index === itemIndex) return {
                ...item,
                name: value
            };
            return item;
        });
        setChartOpts({
            chartOptions: updatedList
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "font-roboto",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
            as: "div",
            className: "inline-block text-left ",
            children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                className: `${open ? "bg-primary text-white" : " bg-white md:bg-surfaceVariant shadow-md"} group flex place-content-center flex-row px-3 py-2 hover:bg-primary hover:text-white rounded-lg border border-primaryContainer focus:outline-none`,
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "hidden md:flex",
                                        children: [
                                            " ",
                                            "Options",
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9b82b6f96fc76ebd$export$2e2bcd8739ae039), {
                                                className: `${open ? " text-white" : "text-secondary"} h-5 w-5 ml-2 self-center text-secondary group-hover:text-white`,
                                                // className="h-5 w-5 ml-2 self-center text-secondary group-hover:text-white"
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex md:hidden",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11abbe69da1e2b5b$export$2e2bcd8739ae039), {
                                            className: `${open ? " text-white" : ""} h-6 w-6 text-secondary group-hover:text-white`
                                        })
                                    })
                                ]
                            })
                        }),
                        open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                            as: (0, $exYeM.Fragment),
                            enter: "transition-opacity ease-out duration-400",
                            enterFrom: "transform opacity-0 scale-95",
                            enterTo: "transform opacity-100 scale-100",
                            leave: "transition ease-in duration-75",
                            leaveFrom: "transform opacity-100 scale-100",
                            leaveTo: "transform opacity-0 scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                className: "absolute p-2 mt-2 z-10 text-sm md:text-base md:w-96 divide-y divide-secondary rounded-lg bg-white border-2 border-primaryContainer bg-opacity-60 backdrop-blur shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "p-2 flex items-center",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "pr-4 text-gray-700",
                                                    children: "Data Source"
                                                }),
                                                Array.isArray(sources) ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                                                            as: "div",
                                                            className: "hidden md:inline-block text-left",
                                                            children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                                                                ref: setReferenceElement,
                                                                                className: "group inline-flex justify-center rounded-lg w-32 bg-white ring-1 ring-inset ring-gray-300 hover:bg-primary hover:text-white px-4 py-2",
                                                                                children: [
                                                                                    selectedExchange,
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e5ea8ee4dc7caabc$export$2e2bcd8739ae039), {
                                                                                        className: "h-5 w-5 ml-2 self-center text-secondary group-hover:text-white",
                                                                                        "aria-hidden": "true"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                                                            static: true,
                                                                            className: "absolute -right-1/2 ml-2 z-10 w-28 divide-y divide-secondary rounded-lg bg-white ring-1 ring-inset ring-gray-300",
                                                                            ref: setPopperElement,
                                                                            style: styles.popper,
                                                                            ...attributes.popper,
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                className: "px-1 py-1",
                                                                                children: sources.map((exchange, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                                                                            className: "divide-y divide-secondary px-1 py-2 hover:bg-primary hover:text-white rounded-lg",
                                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                                className: "w-full text-left",
                                                                                                onClick: ()=>{
                                                                                                    setSelectedExchange(exchange.name);
                                                                                                    params("source", exchange.name);
                                                                                                },
                                                                                                children: exchange.name
                                                                                            })
                                                                                        })
                                                                                    }, index))
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                                                            as: "div",
                                                            className: "inline-block md:hidden text-left",
                                                            children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                                                                className: "group inline-flex justify-center rounded-lg bg-primaryContainer hover:bg-primary hover:text-white px-4 py-2",
                                                                                children: [
                                                                                    selectedExchange,
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e5ea8ee4dc7caabc$export$2e2bcd8739ae039), {
                                                                                        className: "h-5 w-5 ml-2 self-center text-secondary group-hover:text-white",
                                                                                        "aria-hidden": "true"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                                                            static: true,
                                                                            className: "absolute  ml-4 mt-1 z-10 divide-y divide-secondary rounded-lg bg-primaryContainer",
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                className: "px-1 py-1",
                                                                                children: props.graphSources.map((exchange, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                                                                            className: "divide-y divide-secondary px-1 py-2 hover:bg-primary hover:text-white rounded-lg",
                                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                                className: "w-full text-left",
                                                                                                onClick: ()=>{
                                                                                                    setSelectedExchange(exchange.name);
                                                                                                    params("source", exchange.name);
                                                                                                },
                                                                                                children: exchange.name
                                                                                            })
                                                                                        })
                                                                                    }, index))
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "font-robot ",
                                                    children: dataSource
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "px-2 py-2",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                    className: "pb-1 text-gray-700",
                                                    children: "Resolution"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                    children: resolution.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                            onClick: ()=>{
                                                                params("resolution", data);
                                                            },
                                                            className: `${selectedResolution === data ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900`,
                                                            children: data
                                                        }, data))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "px-2 py-2 mr-1",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                className: "pb-1 text-gray-700",
                                                children: "SMA"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-auto rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: "grid grid-flow-col grow rounded-lg",
                                                        children: Object.keys(SMA).map((category)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                onClick: ()=>{
                                                                    params("sma", category);
                                                                },
                                                                className: `${selectedSma === category ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900`,
                                                                children: category
                                                            }, category))
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                        className: "hidden md:flex place-content-end rounded-lg ",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                type: "text",
                                                                className: `${smaInput ? "bg-primary text-white" : ""} w-16 rounded-l-lg border pl-2 border-gray-300`,
                                                                placeholder: "Days",
                                                                onChange: handleSmaInput,
                                                                value: smaInput
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                className: " text-primary w-8 text-center rounded-r-lg hover:bg-primary hover:text-white",
                                                                onClick: ()=>{
                                                                    // console.log(smaInput);
                                                                    if (!smaInput) params("sma", "None");
                                                                    else params("sma", smaInput);
                                                                },
                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $788049de1171759f$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5",
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "px-2 py-2 mr-1",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                className: "pb-1 text-gray-700",
                                                children: "EMA"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-auto rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: "grid grid-flow-col grow rounded-lg",
                                                        children: Object.keys(EMA).map((category)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                onClick: ()=>{
                                                                    params("ema", category);
                                                                },
                                                                className: `${selectedEma === category ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30 hover:text-black"} w-full rounded-lg py-2.5 text-black`,
                                                                children: category
                                                            }, category))
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                        className: "hidden md:flex place-content-end rounded-lg ",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                type: "text",
                                                                className: `${emaInput ? "bg-primary text-white" : ""} w-16 rounded-l-lg border pl-2 border-gray-300`,
                                                                // className="w-16 h-full rounded-l-lg border-r-2 pl-2 border-secondary"
                                                                placeholder: "Days",
                                                                onChange: handleEmaInput,
                                                                value: emaInput
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                className: "text-primary w-8 text-center rounded-r-lg hover:bg-primary hover:text-white",
                                                                onClick: ()=>{
                                                                    if (!emaInput) params("ema", "None");
                                                                    else params("ema", emaInput);
                                                                },
                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $788049de1171759f$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5",
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "px-2 py-2",
                                        children: chartOpts.chartOptions.map((value, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                        className: "pb-1 text-gray-700",
                                                        children: value.name
                                                    }, value.name),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                        className: "grid grid-flow-col gap-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            // params("scale", "Linear");
                                                                            // setLinear("Linear");
                                                                            // let updateValue = { yAxis: "Test" };
                                                                            if (index === 0) params("scale", "Linear");
                                                                            else params("scale" + index, "Linear");
                                                                            updateYaxis(value.name, "Linear");
                                                                        // props.setChartOpts((prevState) => ({
                                                                        //   ...prevState,
                                                                        //   ...updateValue,
                                                                        // }));
                                                                        // console.log(props.chartOpts);
                                                                        },
                                                                        className: `${value.yAxis === "Linear" ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900 `,
                                                                        children: "Linear"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            // params("scale", "Log");
                                                                            // setLinear("Log");
                                                                            if (index === 0) params("scale", "Log");
                                                                            else params("scale" + index, "Log");
                                                                            updateYaxis(value.name, "Log");
                                                                        },
                                                                        className: `${value.yAxis === "Log" ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900 `,
                                                                        children: "Log"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            // params("type", "Line");
                                                                            updateStyle(value.name, "Line");
                                                                            if (index === 0) params("type", "Line");
                                                                            else params("type" + index, "Line");
                                                                        // setType("Line");
                                                                        },
                                                                        className: `${value.style === "Line" ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900 `,
                                                                        children: "Line"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            // params("type", "Bar");
                                                                            updateStyle(value.name, "Bar");
                                                                            if (index === 0) params("type", "Bar");
                                                                            else params("type" + index, "Bar");
                                                                        // setType("Bar");
                                                                        },
                                                                        className: `${value.style === "Bar" ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900 `,
                                                                        children: "Bar"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            })
                        })
                    ]
                })
        })
    });
}
var $63b80c27e867e612$export$2e2bcd8739ae039 = $63b80c27e867e612$var$ChartOptions;


// Created by James Launder
// Zoom functionality also contains the calendar

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $4a5c47d9a4bc8b28$var$CalendarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z",
        clipRule: "evenodd"
    }));
}
const $4a5c47d9a4bc8b28$var$ForwardRef = $exYeM.forwardRef($4a5c47d9a4bc8b28$var$CalendarIcon);
var $4a5c47d9a4bc8b28$export$2e2bcd8739ae039 = $4a5c47d9a4bc8b28$var$ForwardRef;




var $dbef27f15ec500a5$exports = {};
"use strict";
Object.defineProperty($dbef27f15ec500a5$exports, "__esModule", {
    value: true
});
Object.defineProperty($dbef27f15ec500a5$exports, "DateRange", {
    enumerable: true,
    get: function get() {
        return $dbef27f15ec500a5$var$_DateRange.default;
    }
});
Object.defineProperty($dbef27f15ec500a5$exports, "Calendar", {
    enumerable: true,
    get: function get() {
        return $dbef27f15ec500a5$var$_Calendar.default;
    }
});
Object.defineProperty($dbef27f15ec500a5$exports, "DateRangePicker", {
    enumerable: true,
    get: function get() {
        return $dbef27f15ec500a5$var$_DateRangePicker.default;
    }
});
Object.defineProperty($dbef27f15ec500a5$exports, "DefinedRange", {
    enumerable: true,
    get: function get() {
        return $dbef27f15ec500a5$var$_DefinedRange.default;
    }
});
Object.defineProperty($dbef27f15ec500a5$exports, "defaultInputRanges", {
    enumerable: true,
    get: function get() {
        return $fmkuw.defaultInputRanges;
    }
});
Object.defineProperty($dbef27f15ec500a5$exports, "defaultStaticRanges", {
    enumerable: true,
    get: function get() {
        return $fmkuw.defaultStaticRanges;
    }
});
Object.defineProperty($dbef27f15ec500a5$exports, "createStaticRanges", {
    enumerable: true,
    get: function get() {
        return $fmkuw.createStaticRanges;
    }
});

var $dbef27f15ec500a5$var$_DateRange = $dbef27f15ec500a5$var$_interopRequireDefault((parcelRequire("7bZYo")));

var $dbef27f15ec500a5$var$_Calendar = $dbef27f15ec500a5$var$_interopRequireDefault((parcelRequire("lvReq")));

var $dbef27f15ec500a5$var$_DateRangePicker = $dbef27f15ec500a5$var$_interopRequireDefault((parcelRequire("fFM5j")));

var $dbef27f15ec500a5$var$_DefinedRange = $dbef27f15ec500a5$var$_interopRequireDefault((parcelRequire("jalqW")));

var $fmkuw = parcelRequire("fmkuw");
function $dbef27f15ec500a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


// uses internal states to communicate
// can be improved with better calendar and better management of current zoom.
function $b1f5592f12c5f00f$var$ChartZoom(props) {
    let defaultStartDate = new Date();
    defaultStartDate.setMonth(defaultStartDate.getMonth() - 6);
    const [state, setState] = (0, $exYeM.useState)([
        {
            startDate: defaultStartDate,
            endDate: new Date(),
            key: "selection"
        }
    ]);
    const [selected, setSelected] = (0, $exYeM.useState)("6m");
    const isFirstRender = (0, $exYeM.useRef)(true);
    (0, $exYeM.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        props.setMinZoom(state[0].startDate.getTime());
        props.setMaxZoom(state[0].endDate.getTime());
    }, [
        state
    ]);
    // this was used to make the calendar stay synced with the highcharts but it causes bulk re renders as poorly designed by Launder...
    // can tidy states up and make it one to sync accross but cbs rn got more important tickets to do
    // useEffect(() => {
    //   if (isFirstRender2.current) {
    //     isFirstRender2.current = false;
    //     return;
    //   }
    //   // console.log(props.minZoom);
    //   // console.log(props.maxZoom);
    //   let tmpMin = new Date(props.minZoom);
    //   let tmpMax = new Date(props.maxZoom);
    //   setState([
    //     {
    //       startDate: tmpMin,
    //       endDate: tmpMax,
    //       key: "selection",
    //     },
    //   ]);
    // }, [props.minZoom, props.maxZoom]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                className: "hidden md:grid grid-flow-col w-full space-x-1 rounded-xl bg-surfaceVariant border border-primaryContainer shadow-md",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        type: "button",
                        className: `${selected === "1m" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30 "} w-12 rounded-xl py-2.5`,
                        onClick: ()=>{
                            setSelected("1m");
                            props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().subtract(1, "months").valueOf());
                            props.setMaxZoom(Date.now());
                        },
                        children: "1m"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        type: "button",
                        className: `${selected === "3m" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} w-12 rounded-xl py-2.5`,
                        onClick: ()=>{
                            setSelected("3m");
                            props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().subtract(3, "months").valueOf());
                            props.setMaxZoom(Date.now());
                        },
                        children: "3m"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        type: "button",
                        className: `${selected === "6m" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} w-12 rounded-xl py-2.5`,
                        onClick: ()=>{
                            setSelected("6m");
                            props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().subtract(6, "months").valueOf());
                            props.setMaxZoom(Date.now());
                        },
                        children: "6m"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        type: "button",
                        className: `${selected === "YTD" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} w-12 rounded-xl py-2.5`,
                        onClick: ()=>{
                            setSelected("YTD");
                            props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().startOf("year").valueOf());
                            props.setMaxZoom(Date.now());
                        },
                        children: "YTD"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        type: "button",
                        className: `${selected === "1y" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} w-12 rounded-xl py-2.5`,
                        onClick: ()=>{
                            setSelected("1y");
                            props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().subtract(1, "years").valueOf());
                            props.setMaxZoom(Date.now());
                        },
                        children: "1y"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                        className: "relative ",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                type: "button",
                                onClick: ()=>{
                                    setSelected(99);
                                },
                                className: `${selected == 99 ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} relative group flex place-content-center flex-row p-2 h-full items-center rounded-xl w-12`,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4a5c47d9a4bc8b28$export$2e2bcd8739ae039), {
                                    className: `${selected == 99 ? "text-white" : "text-black"}  h-5 w-5 `
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                className: "absolute z-10 -left-[270] w-screen max-w-sm px-1 py-2",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dbef27f15ec500a5$exports.DateRange), {
                                        editableDateInputs: true,
                                        onChange: (item)=>setState([
                                                item.selection
                                            ]),
                                        moveRangeOnFirstSelection: false,
                                        ranges: state
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                    as: "div",
                    className: "inline-block md:hidden text-left",
                    children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                        className: `${open ? "bg-primary text-white" : " bg-surfaceVariant shadow-md"} group flex place-content-center flex-row px-3 py-2 hover:bg-primary hover:text-white rounded-lg border border-primaryContainer focus:outline-none`,
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "grid text-center",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "h-6 text-center text-xl",
                                                children: selected
                                            })
                                        })
                                    })
                                }),
                                open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                    static: true,
                                    className: "absolute mt-1 z-10 w-[70px] divide-y divide-secondary rounded-lg bg-white border border-primaryContainer shadow-sm",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex flex-col relative w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: `${selected === "1m" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30 "} rounded-lg py-2.5`,
                                                onClick: ()=>{
                                                    setSelected("1m");
                                                    props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().subtract(1, "months").valueOf());
                                                    props.setMaxZoom(Date.now());
                                                },
                                                children: "1m"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: `${selected === "3m" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} rounded-lg py-2.5`,
                                                onClick: ()=>{
                                                    setSelected("3m");
                                                    props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().subtract(3, "months").valueOf());
                                                    props.setMaxZoom(Date.now());
                                                },
                                                children: "3m"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: `${selected === "6m" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} rounded-lg py-2.5`,
                                                onClick: ()=>{
                                                    setSelected("6m");
                                                    props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().subtract(6, "months").valueOf());
                                                    props.setMaxZoom(Date.now());
                                                },
                                                children: "6m"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: `${selected === "YTD" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} rounded-lg py-2.5`,
                                                onClick: ()=>{
                                                    setSelected("YTD");
                                                    props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().startOf("year").valueOf());
                                                    props.setMaxZoom(Date.now());
                                                },
                                                children: "YTD"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: `${selected === "1y" ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30"} rounded-lg py-2.5`,
                                                onClick: ()=>{
                                                    setSelected("1y");
                                                    props.setMinZoom((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().subtract(1, "years").valueOf());
                                                    props.setMaxZoom(Date.now());
                                                },
                                                children: "1y"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                })
            })
        ]
    });
}
var $b1f5592f12c5f00f$export$2e2bcd8739ae039 = $b1f5592f12c5f00f$var$ChartZoom;



var $exYeM = parcelRequire("exYeM");
var $a289785f4427b60e$exports = {};

$a289785f4427b60e$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "26-01-24-AvgGas.578bd958.png";



var $jR9u2 = parcelRequire("jR9u2");


// created by james launder
// Compare button with all the options to add a new chart

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $53aad749a76f9885$var$ChartBarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
    }));
}
const $53aad749a76f9885$var$ForwardRef = $exYeM.forwardRef($53aad749a76f9885$var$ChartBarIcon);
var $53aad749a76f9885$export$2e2bcd8739ae039 = $53aad749a76f9885$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $92ca66f52aed8449$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4.5v15m7.5-7.5h-15"
    }));
}
const $92ca66f52aed8449$var$ForwardRef = $exYeM.forwardRef($92ca66f52aed8449$var$PlusIcon);
var $92ca66f52aed8449$export$2e2bcd8739ae039 = $92ca66f52aed8449$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $fe24332445e161c9$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18L18 6M6 6l12 12"
    }));
}
const $fe24332445e161c9$var$ForwardRef = $exYeM.forwardRef($fe24332445e161c9$var$XMarkIcon);
var $fe24332445e161c9$export$2e2bcd8739ae039 = $fe24332445e161c9$var$ForwardRef;




// Created by James Launder
// inspired from tailwind UI dropdown

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


function $489df50ddb47d03f$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $489df50ddb47d03f$export$2e2bcd8739ae039(props) {
    const [query, setQuery] = (0, $exYeM.useState)("");
    const filteredData = query === "" ? props.data : props.data.filter((person)=>{
        return person.name.toLowerCase().includes(query.toLowerCase());
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e), {
        value: props.selected,
        onChange: props.setSelected,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Label, {
                className: "block text-sm font-medium leading-6 text-gray-900",
                children: props.title
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative mt-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Input, {
                        className: "w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 focus:border-primary focus:outline-none",
                        //   className="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                        onChange: (event)=>setQuery(event.target.value),
                        displayValue: (person)=>person?.name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Button, {
                        className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none ",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $96abd6aa52cc9bd1$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                        })
                    }),
                    filteredData.length > 0 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Options, {
                        className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                        children: filteredData.map((person)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Option, {
                                value: person,
                                className: ({ active: active })=>$489df50ddb47d03f$var$classNames("relative cursor-default select-none py-2 pl-3 pr-9", active ? "bg-primary text-white" : "text-gray-900"),
                                children: ({ active: active, selected: selected })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        style: {
                                                            background: person.hex
                                                        },
                                                        className: "inline-block h-2 w-2 flex-shrink-0 rounded-full",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: $489df50ddb47d03f$var$classNames("ml-3 truncate", selected && "font-semibold"),
                                                        children: person.name
                                                    })
                                                ]
                                            }),
                                            selected && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: $489df50ddb47d03f$var$classNames("absolute inset-y-0 right-0 flex items-center pr-4", active ? "text-white" : "text-primary"),
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ad110a4e18e6d96b$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    })
                            }, person.name))
                    })
                ]
            })
        ]
    });
}





function $f756b151c39b63cf$var$CompareButton(props) {
    const DELIMITTER = "_";
    const { userData: userData } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [selectedResolution, setSelectedResolution] = (0, $exYeM.useState)("Day");
    const [selectedSource, setSelectedSource] = (0, $exYeM.useState)(null);
    // const [checkEnabled, setCheckEnabled] = useState(false);
    const isErrorMain = (0, $exYeM.useRef)(false);
    const isErrorAdd = (0, $exYeM.useRef)(false);
    const [errorMsg, setErrorMsg] = (0, $exYeM.useState)("");
    const [valid, setValid] = (0, $exYeM.useState)(false);
    const [selectedColour, setSelectedColour] = (0, $exYeM.useState)(props.colour[0]);
    const cancelButtonRef = (0, $exYeM.useRef)(null);
    const [selectedBlockchain, setSelectedBlockchain] = (0, $exYeM.useState)({
        name: searchParams.get("blockchain")
    });
    const [selectedChart, setSelectedChart] = (0, $exYeM.useState)(null);
    const [selectedStyle, setSelectedStyle] = (0, $exYeM.useState)(props.style[0]);
    const [selectedScale, setSelectedScale] = (0, $exYeM.useState)(props.scale[0]);
    const { blockchains: data, blockchainsLoading: isLoading, charts: charts, chartsLoading: chartsLoading, chartsFetching: chartsFetching } = (0, $713cd473769d67da$export$2e2bcd8739ae039)(selectedBlockchain.name);
    const newQuery = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.addQuery);
    const chartsLen = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.queryUrl);
    // when opened validate that the user can add a new chart
    const checkCharts = ()=>{
        if (chartsLen.length >= userData?.charts) {
            setValid(false);
            setErrorMsg(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-red-500 font-semibold flex gap-1 self-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 self-center mt-[1px]"
                    }),
                    "Maximum Charts Reached!"
                ]
            }));
        } else {
            setValid(true);
            setErrorMsg("");
        }
    };
    (0, $exYeM.useEffect)(()=>{
        checkCharts();
    }, [
        chartsLen
    ]);
    (0, $exYeM.useEffect)(()=>{
        setSelectedChart(null);
    }, [
        selectedBlockchain
    ]);
    (0, $exYeM.useEffect)(()=>{
        setSelectedSource(null);
    }, [
        selectedChart
    ]);
    // called when adding a chart
    const handleSubmit = ()=>{
        if (selectedBlockchain === null || selectedChart === null) // error checking before submitting
        setErrorMsg(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "text-red-500 font-semibold flex gap-1 self-center",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 self-center mt-[1px]"
                }),
                "Missing Chart!"
            ]
        }));
        else if (Array.isArray(selectedChart.sources) && selectedSource === null) setErrorMsg(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "text-red-500 font-semibold flex gap-1 self-center",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 self-center mt-[1px]"
                }),
                "Missing Source!"
            ]
        }));
        else {
            if (selectedBlockchain.name === searchParams.get("blockchain") && selectedChart.name === searchParams.get("name") && selectedResolution === searchParams.get("resolution")) {
                if (selectedSource != null) {
                    if (selectedSource.name === searchParams.get("source")) {
                        isErrorMain.current = true;
                        setErrorMsg(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "text-red-500 font-semibold flex gap-1 self-center",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6 self-center mt-[1px]"
                                }),
                                "Same As Original Chart!"
                            ]
                        }));
                    } else {
                        setErrorMsg("");
                        isErrorMain.current = false;
                    }
                } else {
                    setErrorMsg(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "text-red-500 font-semibold flex gap-1 self-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 self-center mt-[1px]"
                            }),
                            "Same As Original Chart!"
                        ]
                    }));
                    isErrorMain.current = true;
                }
            } else {
                setErrorMsg("");
                isErrorMain.current = false;
            }
            if (selectedSource === null) {
                if (props.additionalCharts.some((chart)=>chart.id === selectedChart.name + selectedBlockchain.name + null + selectedResolution)) {
                    setErrorMsg(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "text-red-500 font-semibold flex gap-1 self-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 self-center mt-[1px]"
                            }),
                            "Chart Already Added!"
                        ]
                    }));
                    isErrorAdd.current = true;
                } else {
                    if (!isErrorMain.current) setErrorMsg("");
                    isErrorAdd.current = false;
                }
            } else if (props.additionalCharts.some((chart)=>chart.id === selectedChart.name + selectedBlockchain.name + selectedSource.name + selectedResolution)) {
                setErrorMsg(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "text-red-500 font-semibold flex gap-1 self-center",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 self-center mt-[1px]"
                        }),
                        "Chart Already Added!"
                    ]
                }));
                isErrorAdd.current = true;
            } else {
                if (!isErrorMain.current) setErrorMsg("");
                isErrorAdd.current = false;
            }
            // post error validation
            if (!isErrorAdd.current && !isErrorMain.current) {
                var newChart;
                if (selectedSource === null) {
                    newQuery(selectedBlockchain.name, selectedResolution, selectedChart.name, null);
                    newChart = {
                        id: selectedChart.name + selectedBlockchain.name + null + selectedResolution,
                        blockchain: selectedBlockchain.name,
                        name: selectedChart.name,
                        resolution: selectedResolution,
                        color: selectedColour,
                        style: selectedStyle,
                        scale: selectedScale,
                        source: null
                    };
                    searchParams.append("cmp", selectedBlockchain.name + DELIMITTER + selectedChart.name + DELIMITTER + selectedResolution + DELIMITTER + selectedColour.name + DELIMITTER + selectedStyle.name + DELIMITTER + selectedScale.name);
                    setSearchParams(searchParams);
                } else {
                    newQuery(selectedBlockchain.name, selectedResolution, selectedChart.name, selectedSource.name);
                    newChart = {
                        id: selectedChart.name + selectedBlockchain.name + selectedSource.name + selectedResolution,
                        blockchain: selectedBlockchain.name,
                        name: selectedChart.name,
                        resolution: selectedResolution,
                        color: selectedColour,
                        style: selectedStyle,
                        scale: selectedScale,
                        source: selectedSource.name
                    };
                    searchParams.append("cmp", selectedBlockchain.name + DELIMITTER + selectedChart.name + DELIMITTER + selectedResolution + DELIMITTER + selectedColour.name + DELIMITTER + selectedStyle.name + DELIMITTER + selectedScale.name + DELIMITTER + selectedSource.name);
                    setSearchParams(searchParams);
                }
                setSelectedChart(null);
                setSelectedSource(null);
                props.setAdditionalCharts((prevState)=>[
                        ...prevState,
                        newChart
                    ]);
                setOpen(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "font-roboto ",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                onClick: ()=>{
                    setOpen(true);
                },
                className: "group flex flex-row border border-primaryContainer bg-surfaceVariant px-3 py-2 hover:bg-primary hover:text-white rounded-lg shadow-md",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "hidden md:flex",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: "Add"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $92ca66f52aed8449$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 font-bold text-onSurfaceVariant self-center ml-2 group-hover:text-white",
                                "aria-hidden": "true"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "md:hidden flex",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $92ca66f52aed8449$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 font-bold text-onSurfaceVariant self-center group-hover:text-white",
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
                show: open,
                as: (0, $exYeM.Fragment),
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
                    as: "div",
                    className: "relative z-10",
                    initialFocus: cancelButtonRef,
                    onClose: setOpen,
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "fixed inset-0 z-10 overflow-y-auto",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                                    as: (0, $exYeM.Fragment),
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                        className: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "absolute right-0 top-0 hidden pr-4 pt-4 sm:block",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                    type: "button",
                                                    className: "rounded-md bg-white text-gray-400 hover:text-gray-500",
                                                    onClick: ()=>{
                                                        setErrorMsg("");
                                                        setOpen(false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Close"
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fe24332445e161c9$export$2e2bcd8739ae039), {
                                                            className: "h-6 w-6",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "sm:flex sm:items-start ",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "mt-3 text-center sm:mt-2 sm:text-left  w-full ",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                className: "flex flex-row items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10",
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $53aad749a76f9885$export$2e2bcd8739ae039), {
                                                                            className: "h-6 w-6 text-primary",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Title, {
                                                                        as: "h3",
                                                                        className: "ml-4 text-base font-semibold leading-6 text-gray-900",
                                                                        children: "Add new chart data"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                className: "mt-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "flex flex-col",
                                                                        children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            children: "Loading..."
                                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6fe4039eb01bf4b$export$2e2bcd8739ae039), {
                                                                            title: "Blockchain",
                                                                            data: data?.data?.blockchain,
                                                                            selected: selectedBlockchain,
                                                                            setSelected: setSelectedBlockchain
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "flex flex-col mt-4",
                                                                        children: selectedBlockchain.name === "None" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                    children: "Charts"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "truncate",
                                                                                    children: "Select A Chart..."
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            children: chartsFetching || chartsLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                        children: "Charts"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        className: "truncate",
                                                                                        children: "Loading..."
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6fe4039eb01bf4b$export$2e2bcd8739ae039), {
                                                                                title: "Charts",
                                                                                data: charts?.data?.graphNames,
                                                                                selected: selectedChart,
                                                                                setSelected: setSelectedChart
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "flex flex-col mt-4",
                                                                        children: selectedChart === null ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                    children: "Source"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "truncate",
                                                                                    children: "Select A Chart..."
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            children: Array.isArray(selectedChart.sources) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6fe4039eb01bf4b$export$2e2bcd8739ae039), {
                                                                                title: "Source",
                                                                                data: selectedChart.sources,
                                                                                selected: selectedSource,
                                                                                setSelected: setSelectedSource
                                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                        children: "Source"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                        className: "truncate",
                                                                                        children: selectedChart.dataSource
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "mt-4",
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $489df50ddb47d03f$export$2e2bcd8739ae039), {
                                                                            title: "Colour",
                                                                            data: props.colour,
                                                                            selected: selectedColour,
                                                                            setSelected: setSelectedColour
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "mt-4",
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                                    className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                    children: "Resolution"
                                                                                }),
                                                                                selectedChart === null ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "mt-2 h-[40px]",
                                                                                    children: "Select A Chart..."
                                                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                        className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 mt-2",
                                                                                        children: selectedChart.resolution.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                                type: "button",
                                                                                                onClick: ()=>{
                                                                                                    //   // params("resolution", data);
                                                                                                    setSelectedResolution(data);
                                                                                                },
                                                                                                className: `${selectedResolution === data ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-1.5 text-gray-900 `,
                                                                                                children: data
                                                                                            }, data + " combo"))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "mt-4",
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                                    className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                    children: "Style"
                                                                                }),
                                                                                selectedChart === null ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "mt-2 h-[40px]",
                                                                                    children: "Select A Chart..."
                                                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                        className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 mt-2",
                                                                                        children: props.style.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                                type: "button",
                                                                                                onClick: ()=>{
                                                                                                    setSelectedStyle(data);
                                                                                                },
                                                                                                className: `${selectedStyle.name === data.name ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-1.5 text-gray-900 `,
                                                                                                children: data.name
                                                                                            }, data.name + " combo"))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                        className: "mt-4",
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                                    className: "block text-sm font-medium leading-6 text-gray-900",
                                                                                    children: "Scale"
                                                                                }),
                                                                                selectedChart === null ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "mt-2 h-[40px]",
                                                                                    children: "Select A Chart..."
                                                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                        className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 mt-2",
                                                                                        children: props.scale.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                                type: "button",
                                                                                                onClick: ()=>{
                                                                                                    setSelectedScale(data);
                                                                                                },
                                                                                                className: `${selectedScale.name === data.name ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-1.5 text-gray-900 `,
                                                                                                children: data.name
                                                                                            }, data.name + " combo"))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "bg-gray-50 px-4 py-3 sm:flex sm:justify-between sm:px-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        children: errorMsg
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        children: valid ? /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                            type: "submit",
                                                            className: "inline-flex w-full justify-center rounded-md bg-primaryContainer px-3 py-2 text-sm hover:text-white shadow-sm hover:bg-primary sm:ml-3 sm:w-auto",
                                                            onClick: ()=>{
                                                                handleSubmit();
                                                            },
                                                            children: "Add"
                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                            disabled: true,
                                                            className: "cursor-not-allowed inline-flex w-full justify-center rounded-md bg-primaryContainer px-3 py-2 text-sm shadow-sm sm:ml-3 sm:w-auto",
                                                            children: "Add"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $f756b151c39b63cf$export$2e2bcd8739ae039 = $f756b151c39b63cf$var$CompareButton;


// Created by James Launder
// provides the options for each additional chart once it is added to the chart.

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $dd814d617586c39d$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z",
        clipRule: "evenodd"
    }));
}
const $dd814d617586c39d$var$ForwardRef = $exYeM.forwardRef($dd814d617586c39d$var$ChevronDownIcon);
var $dd814d617586c39d$export$2e2bcd8739ae039 = $dd814d617586c39d$var$ForwardRef;






function $9c30546b2e326875$var$AdditionalOptions(props) {
    const DELIMITTER = "_";
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const firstRender = (0, $exYeM.useRef)(true);
    const [selectedColour, setSelectedColour] = (0, $exYeM.useState)(props.data.color);
    const queryState = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.queryUrl);
    const removeQuery = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.removeQuery);
    // finds the section of the URL relevant to this data and removes it.
    function deleteParamsEntry(params) {
        const key = "cmp";
        var value = "";
        if (props.data.source === null) {
            value = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name;
            // gets all params and returns all params that dont fit the key and value
            const newEntries = Array.from(params.entries()).filter(([k, v])=>!(k === key && v === value));
            setSearchParams(newEntries);
        } else {
            value = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name + DELIMITTER + props.data.source;
            const newEntries = Array.from(params.entries()).filter(([k, v])=>!(k === key && v === value));
            setSearchParams(newEntries);
        }
    }
    // very similar to delete but removes it then readds it with the changes to the url
    function updateSearchParams(params, newValue, keyChange) {
        const key = "cmp";
        var value = "";
        var updated = "";
        // create the new thing here!!!
        if (props.data.source === null) switch(keyChange // certain key set value correctly
        ){
            case "colour":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + newValue + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name;
                break;
            case "style":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + newValue + DELIMITTER + props.data.scale.name;
                break;
            case "scale":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + newValue;
                break;
        }
        else switch(keyChange // certain key set value correctly
        ){
            case "colour":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + newValue + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name + DELIMITTER + props.data.source;
                break;
            case "style":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + newValue + DELIMITTER + props.data.scale.name + DELIMITTER + props.data.source;
                break;
            case "scale":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + newValue + DELIMITTER + props.data.source;
                break;
        }
        if (props.data.source === null) {
            value = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name;
            var newEntries = Array.from(params.entries()).filter(([k, v])=>!(k === key && v === value));
            newEntries.push([
                "cmp",
                updated
            ]);
            setSearchParams(newEntries);
        } else {
            value = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name + DELIMITTER + props.data.source;
            const newEntries = Array.from(params.entries()).filter(([k, v])=>!(k === key && v === value));
            newEntries.push([
                "cmp",
                updated
            ]);
            setSearchParams(newEntries);
        }
    }
    // updates for the internal states
    const updateColour = (updated, name, blockchain, source, resolution)=>{
        props.setAdditionalCharts((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[props.index].color = updated;
            return newState;
        });
        props.setUpdateChart({
            key: "color",
            name: name,
            blockchain: blockchain,
            update: updated,
            source: source,
            resolution: resolution
        });
    };
    const updateStyle = (updated, name, blockchain, source, resolution)=>{
        updateSearchParams(searchParams, updated.name, "style");
        props.setAdditionalCharts((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[props.index].style = updated;
            return newState;
        });
        props.setUpdateChart({
            key: "style",
            name: name,
            blockchain: blockchain,
            update: updated,
            source: source,
            resolution: resolution
        });
    };
    const updateScale = (updated, name, blockchain, source, resolution)=>{
        updateSearchParams(searchParams, updated.name, "scale");
        props.setAdditionalCharts((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[props.index].scale = updated;
            return newState;
        });
        props.setUpdateChart({
            key: "scale",
            name: name,
            blockchain: blockchain,
            update: updated,
            source: source,
            resolution: resolution
        });
    };
    // removes the chart from url, internal state and querystate
    const deleteChart = ()=>{
        var queryIndex = -1;
        if (props.data.source === null) {
            queryIndex = queryState.findIndex((obj)=>obj.key === props.data.blockchain + props.data.resolution + props.data.name);
            deleteParamsEntry(searchParams);
        } else {
            queryIndex = queryState.findIndex((obj)=>obj.key === props.data.blockchain + props.data.resolution + props.data.name + props.data.source);
            deleteParamsEntry(searchParams);
        }
        props.setRemove({
            name: props.data.name,
            blockchain: props.data.blockchain,
            source: props.data.source,
            resolution: props.data.resolution
        });
        props.setAdditionalCharts((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState.splice(props.index, 1);
            return newState;
        });
        removeQuery(queryIndex);
    };
    // updates the correct params when something is changed.
    // if this runs on first load it can delete the param or not allow the change to occur
    (0, $exYeM.useEffect)(()=>{
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        updateSearchParams(searchParams, selectedColour.name, "colour");
        updateColour(selectedColour, props.data.name, props.data.blockchain, props.data.source, props.data.resolution);
    }, [
        selectedColour
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "font-roboto w-full",
        children: props.graphData[props.index + 2]?.isLoading || props.graphData[props.index + 2]?.isFetching ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "inline-block text-left animate-pulse",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                style: {
                    boxSizing: "border-box",
                    boxShadow: "inset 0px 0px 0px 2px " + props.data.color.hex
                },
                className: "group flex place-content-center flex-row px-3 py-2 rounded-lg md:border-0 border-2 focus:outline-none",
                children: "Loading..."
            })
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            children: props.graphData[props.index + 2]?.isError ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "inline-block text-left ",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                    style: {
                        boxSizing: "border-box",
                        boxShadow: "inset 0px 0px 0px 2px " + props.data.color.hex
                    },
                    className: "group flex place-content-center flex-row px-3 py-2 rounded-lg md:border-0 border-2 focus:outline-none hover:bg-primary/30",
                    onClick: ()=>{
                        var queryIndex = -1;
                        if (props.data.source === null) {
                            queryIndex = queryState.findIndex((obj)=>obj.key === props.data.blockchain + props.data.resolution + props.data.name);
                            deleteParamsEntry(searchParams);
                        } else {
                            queryIndex = queryState.findIndex((obj)=>obj.key === props.data.blockchain + props.data.resolution + props.data.name + props.data.source);
                            deleteParamsEntry(searchParams);
                        }
                        props.setAdditionalCharts((prevState)=>{
                            const newState = [
                                ...prevState
                            ];
                            newState.splice(props.index, 1);
                            return newState;
                        });
                        removeQuery(queryIndex);
                    },
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            children: "Error!"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fe24332445e161c9$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 group-hover:text-white",
                            "aria-hidden": "true"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                as: "div",
                className: "inline-block text-left ",
                children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                    style: {
                                        boxSizing: "border-box",
                                        boxShadow: "inset 0px 0px 0px 2px " + props.data.color.hex
                                    },
                                    className: `${open ? "bg-primary/30 text-black" : "bg-white shadow-xl"} group hidden md:grid place-content-center grid-flow-col px-3 py-2 hover:bg-primary/30 rounded-lg focus:outline-none`,
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "hidden md:grid grid-flow-col md:whitespace-nowrap md:overflow-visible",
                                        children: [
                                            props.data.name,
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dd814d617586c39d$export$2e2bcd8739ae039), {
                                                className: `${open ? " text-black" : "text-onSurfaceVariant"} h-5 w-5 ml-2 self-center text-onSurfaceVariant `,
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                })
                            }),
                            open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                                as: (0, $exYeM.Fragment),
                                enter: "transition-opacity ease-out duration-400",
                                enterFrom: "transform opacity-0 scale-95",
                                enterTo: "transform opacity-100 scale-100",
                                leave: "transition ease-in duration-75",
                                leaveFrom: "transform opacity-100 scale-100",
                                leaveTo: "transform opacity-0 scale-95",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                    className: "transform transition-all absolute px-2 mt-2 z-10 text-sm md:text-base divide-y divide-secondary rounded-lg bg-white border-2 border-secondary bg-opacity-70 backdrop-blur shadow-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "px-2 py-2 flex gap-2 justify-between items-center",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex gap-2 py-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                        className: "text-gray-700 min-w-[78px]",
                                                        children: "Blockchain"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        children: props.data.blockchain
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "px-2 py-2 flex gap-2 items-center",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex gap-2 py-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                        className: "text-gray-700 min-w-[78px]",
                                                        children: "Resolution"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        children: props.data.resolution
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "px-2 py-2 flex gap-2 items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                    className: "text-gray-700 pt-1 min-w-[78px]",
                                                    children: "Colour"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "w-full mb-1",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $489df50ddb47d03f$export$2e2bcd8739ae039), {
                                                        title: "",
                                                        data: props.colour,
                                                        selected: selectedColour,
                                                        setSelected: setSelectedColour
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "px-2 py-3 flex gap-2 items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                    className: "text-gray-700 min-w-[78px]",
                                                    children: "Style"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full ",
                                                    children: props.style.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>{
                                                                updateStyle(data, props.data.name, props.data.blockchain, props.data.source, props.data.resolution);
                                                            },
                                                            className: `${props.data.style.name === data.name ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-1.5 text-gray-900 `,
                                                            children: data.name
                                                        }, data.name + " combo"))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "px-2 py-3 flex gap-2 items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                    className: "text-gray-700 min-w-[78px]",
                                                    children: "Scale"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                    children: props.scale.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>{
                                                                updateScale(data, props.data.name, props.data.blockchain, props.data.source, props.data.resolution);
                                                            },
                                                            className: `${props.data.scale.name === data.name ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-1.5 text-gray-900 `,
                                                            children: data.name
                                                        }, data.name + " combo"))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "px-2 py-2 flex gap-2 items-center bg-gray-50",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "flex gap-2",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    className: "py-2 px-3 bg-red-400 hover:bg-red-500 text-white rounded-lg",
                                                    onClick: ()=>{
                                                        deleteChart();
                                                    },
                                                    children: "Remove"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
            })
        })
    });
}
var $9c30546b2e326875$export$2e2bcd8739ae039 = $9c30546b2e326875$var$AdditionalOptions;



// Created By James Launder inspired by tailwindUI
// Modal form for mobile additional options

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");






function $d413c50062446834$export$2e2bcd8739ae039(props) {
    const DELIMITTER = "_";
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const firstRender = (0, $exYeM.useRef)(true);
    const [selectedColour, setSelectedColour] = (0, $exYeM.useState)(props.data.color);
    const queryState = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.queryUrl);
    const removeQuery = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.removeQuery);
    function deleteParamsEntry(params) {
        const key = "cmp";
        var value = "";
        if (props.data.source === null) {
            value = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name;
            const newEntries = Array.from(params.entries()).filter(([k, v])=>!(k === key && v === value));
            setSearchParams(newEntries);
        } else {
            value = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name + DELIMITTER + props.data.source;
            const newEntries = Array.from(params.entries()).filter(([k, v])=>!(k === key && v === value));
            setSearchParams(newEntries);
        }
    }
    function updateSearchParams(params, newValue, keyChange) {
        const key = "cmp";
        var value = "";
        var updated = "";
        // create the new thing here!!!
        if (props.data.source === null) switch(keyChange // certain key set value correctly
        ){
            case "colour":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + newValue + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name;
                break;
            case "style":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + newValue + DELIMITTER + props.data.scale.name;
                break;
            case "scale":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + newValue;
                break;
        }
        else switch(keyChange // certain key set value correctly
        ){
            case "colour":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + newValue + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name + DELIMITTER + props.data.source;
                break;
            case "style":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + newValue + DELIMITTER + props.data.scale.name + DELIMITTER + props.data.source;
                break;
            case "scale":
                updated = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + newValue + DELIMITTER + props.data.source;
                break;
        }
        if (props.data.source === null) {
            value = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name;
            var newEntries = Array.from(params.entries()).filter(([k, v])=>!(k === key && v === value));
            newEntries.push([
                "cmp",
                updated
            ]);
            setSearchParams(newEntries);
        } else {
            value = props.data.blockchain + DELIMITTER + props.data.name + DELIMITTER + props.data.resolution + DELIMITTER + props.data.color.name + DELIMITTER + props.data.style.name + DELIMITTER + props.data.scale.name;
            const newEntries = Array.from(params.entries()).filter(([k, v])=>!(k === key && v === value));
            newEntries.push([
                "cmp",
                updated
            ]);
            setSearchParams(newEntries);
        }
    }
    const updateColour = (updated, name, blockchain, source, resolution)=>{
        props.setAdditionalCharts((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[props.index].color = updated;
            return newState;
        });
        props.setUpdateChart({
            key: "color",
            name: name,
            blockchain: blockchain,
            update: updated,
            source: source,
            resolution: resolution
        });
    };
    const updateStyle = (updated, name, blockchain, source, resolution)=>{
        updateSearchParams(searchParams, updated.name, "style");
        props.setAdditionalCharts((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[props.index].style = updated;
            return newState;
        });
        props.setUpdateChart({
            key: "style",
            name: name,
            blockchain: blockchain,
            update: updated,
            source: source,
            resolution: resolution
        });
    };
    const updateScale = (updated, name, blockchain, source, resolution)=>{
        updateSearchParams(searchParams, updated.name, "scale");
        props.setAdditionalCharts((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[props.index].scale = updated;
            return newState;
        });
        props.setUpdateChart({
            key: "scale",
            name: name,
            blockchain: blockchain,
            update: updated,
            source: source,
            resolution: resolution
        });
    };
    // removes the chart from url, internal state and querystate
    const deleteChart = ()=>{
        var queryIndex = -1;
        if (props.data.source === null) {
            queryIndex = queryState.findIndex((obj)=>obj.key === props.data.blockchain + props.data.resolution + props.data.name);
            deleteParamsEntry(searchParams);
        } else {
            queryIndex = queryState.findIndex((obj)=>obj.key === props.data.blockchain + props.data.resolution + props.data.name + props.data.source);
            deleteParamsEntry(searchParams);
        }
        props.setRemove({
            name: props.data.name,
            blockchain: props.data.blockchain,
            source: props.data.source,
            resolution: props.data.resolution
        });
        props.setAdditionalCharts((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState.splice(props.index, 1);
            return newState;
        });
        removeQuery(queryIndex);
    };
    (0, $exYeM.useEffect)(()=>{
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        updateSearchParams(searchParams, selectedColour.name, "colour");
        updateColour(selectedColour, props.data.name, props.data.blockchain, props.data.source, props.data.resolution);
    }, [
        selectedColour
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "font-roboto ",
        children: props.graphData[props.index + 2]?.isLoading || props.graphData[props.index + 2]?.isFetching ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                style: {
                    border: "2px solid " + props.data.color.hex
                },
                className: "group flex flex-row md:bg-primaryContainer px-3 py-2 hover:bg-primary hover:text-white rounded-lg",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "md:hidden flex",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 font-bold text-secondary self-center group-hover:text-white animate-spin",
                        "aria-hidden": "true"
                    })
                })
            })
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            children: props.graphData[props.index + 2]?.isError ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    style: {
                        border: "2px solid " + props.data.color.hex
                    },
                    onClick: ()=>{
                        deleteChart();
                    },
                    className: "group flex flex-row md:bg-primaryContainer px-3 py-2 hover:bg-primary hover:text-white rounded-lg",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "md:hidden flex",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6a80b2de3c2a5bc$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 font-bold text-red-400 self-center group-hover:text-white",
                            "aria-hidden": "true"
                        })
                    })
                })
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        style: {
                            border: "2px solid " + props.data.color.hex
                        },
                        onClick: ()=>{
                            setOpen(true);
                        },
                        className: "group flex flex-row md:bg-primaryContainer px-3 py-2 hover:bg-primary hover:text-white rounded-lg",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "md:hidden flex",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $53aad749a76f9885$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 font-bold text-secondary self-center group-hover:text-white",
                                "aria-hidden": "true"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
                        show: open,
                        as: (0, $exYeM.Fragment),
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
                            as: "div",
                            className: "relative z-10",
                            onClose: setOpen,
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                                    as: (0, $exYeM.Fragment),
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0",
                                    enterTo: "opacity-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100",
                                    leaveTo: "opacity-0",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "fixed inset-0 z-10 overflow-y-auto",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex min-h-[75%] items-end justify-center p-4 text-center sm:items-center sm:p-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                                            as: (0, $exYeM.Fragment),
                                            enter: "ease-out duration-300",
                                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                                            leave: "ease-in duration-200",
                                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6 ",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "px-2 py-2 flex gap-2 justify-between items-center",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "flex gap-2 py-1.5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                    className: "text-gray-900 min-w-[78px]",
                                                                    children: "Blockchain"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    children: props.data.blockchain
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "px-2 py-2 flex gap-2 justify-between items-center",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "flex gap-2 py-1.5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                    className: "text-gray-900 min-w-[78px]",
                                                                    children: "Name"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    children: props.data.name
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "px-2 py-2 flex gap-2 items-center",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "flex gap-2 py-1.5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                    className: "text-gray-900 min-w-[78px]",
                                                                    children: "Resolution"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                    children: props.data.resolution
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "px-2 py-2 flex gap-2 items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                className: "text-gray-900 pt-1 min-w-[78px]",
                                                                children: "Colour"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "w-full mb-1",
                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $489df50ddb47d03f$export$2e2bcd8739ae039), {
                                                                    title: "",
                                                                    data: props.colour,
                                                                    selected: selectedColour,
                                                                    setSelected: setSelectedColour
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "px-2 py-3 flex gap-2 items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                className: "text-gray-900 min-w-[78px]",
                                                                children: "Style"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full ",
                                                                children: props.style.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>{
                                                                            //   // params("resolution", data);
                                                                            updateStyle(data, props.data.name, props.data.blockchain, props.data.source, props.data.resolution);
                                                                        // setSelectedStyle(data);
                                                                        },
                                                                        className: `${props.data.style.name === data.name ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-1.5 text-gray-900 `,
                                                                        children: data.name
                                                                    }, data.name + " combo"))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "px-2 py-3 flex gap-2 items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                className: "text-gray-900 min-w-[78px]",
                                                                children: "Scale"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                                children: props.scale.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: ()=>{
                                                                            //   // params("resolution", data);
                                                                            updateScale(data, props.data.name, props.data.blockchain, props.data.source, props.data.resolution);
                                                                        },
                                                                        className: `${props.data.scale.name === data.name ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-1.5 text-gray-900 `,
                                                                        children: data.name
                                                                    }, data.name + " combo"))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "px-2 py-2 flex gap-2 items-center mt-5 sm:mt-6",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "flex gap-2 justify-between w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                    className: "py-2 px-3 bg-red-400 hover:bg-red-500 text-white rounded-lg",
                                                                    onClick: ()=>{
                                                                        deleteChart();
                                                                    },
                                                                    children: "Remove"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                    className: "py-2 px-3 bg-primaryContainer  rounded-lg",
                                                                    onClick: ()=>{
                                                                        setOpen(false);
                                                                    },
                                                                    children: "Close"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


// Created By James Launder inspired by tailwindUI
// Modal form for mobile options

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




function $9ede5d08e9b2b289$export$2e2bcd8739ae039(props) {
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const { name: name, resolution: resolution, dataSource: dataSource, sources: sources } = (0, $0edff4a12d1a07f6$export$2e2bcd8739ae039)();
    const [selectedExchange, setSelectedExchange] = (0, $exYeM.useState)("FTX");
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [selectedResolution, setSelectedResolution] = (0, $exYeM.useState)(searchParams.get("resolution"));
    const [emaInput, setEmaInput] = (0, $exYeM.useState)("");
    const [selectedEma, setSelectedEma] = (0, $exYeM.useState)(searchParams.get("ema"));
    const [smaInput, setSmaInput] = (0, $exYeM.useState)("");
    const [selectedSma, setSelectedSma] = (0, $exYeM.useState)(searchParams.get("sma"));
    const [chartOpts, setChartOpts] = (0, $exYeM.useState)({
        chartOptions: [
            {
                yAxis: "Linear",
                style: "Line",
                name: name
            },
            {
                yAxis: "Linear",
                style: "Line",
                name: "Price"
            }
        ]
    });
    const [EMA] = (0, $exYeM.useState)({
        None: [
            {
                disabled: "disabled"
            }
        ],
        "7d": [],
        "14d": [],
        "30d": []
    });
    const [SMA] = (0, $exYeM.useState)({
        None: [
            {
                disabled: "disabled"
            }
        ],
        "7d": [],
        "14d": [],
        "30d": []
    });
    const params = (name, value)=>{
        searchParams.set(name, value);
        setSearchParams(searchParams);
    };
    // on load
    (0, $exYeM.useEffect)(()=>{
        if (localStorage.getItem("user") != null) {
            if (JSON.parse(localStorage.getItem("user")).tier == 0) setSelectedResolution("Daily");
        }
        if (sources) // i made changes here
        setSelectedExchange(sources[0]?.name);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        updateName(0, name);
    }, [
        name
    ]);
    (0, $exYeM.useEffect)(()=>{
        setSelectedEma(searchParams.get("ema"));
        setSelectedSma(searchParams.get("sma"));
        setSelectedResolution(searchParams.get("resolution"));
        setSelectedExchange(searchParams.get("source"));
    }, [
        searchParams
    ]);
    const handleEmaInput = (event)=>{
        setEmaInput(event.target.value);
        setSelectedEma(event.target.value);
        if (!event.target.value) setSelectedEma(searchParams.get("ema"));
    };
    const handleSmaInput = (event)=>{
        setSmaInput(event.target.value);
        setSelectedSma(event.target.value);
        if (!event.target.value) setSelectedSma(searchParams.get("sma"));
    };
    const updateStyle = (name, value)=>{
        let updatedList = chartOpts.chartOptions.map((item)=>{
            if (item.name === name) return {
                ...item,
                style: value
            };
            return item;
        });
        setChartOpts({
            chartOptions: updatedList
        });
    };
    const updateYaxis = (name, value)=>{
        let updatedList = chartOpts.chartOptions.map((item)=>{
            if (item.name === name) return {
                ...item,
                yAxis: value
            };
            return item;
        });
        setChartOpts({
            chartOptions: updatedList
        });
    };
    const updateName = (itemIndex, value)=>{
        let updatedList = chartOpts.chartOptions.map((item, index)=>{
            if (index === itemIndex) return {
                ...item,
                name: value
            };
            return item;
        });
        setChartOpts({
            chartOptions: updatedList
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "font-roboto ",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                onClick: ()=>{
                    setOpen(true);
                // console.log("clicked");
                },
                className: "group flex flex-row  px-3 py-2 rounded-lg border-primaryContainer border-2 hover:bg-primary bg-surfaceVariant shadow-md",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "md:hidden flex",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11abbe69da1e2b5b$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 font-bold text-onSurfaceVariant self-center group-hover:text-white",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
                show: open,
                as: (0, $exYeM.Fragment),
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
                    as: "div",
                    className: "relative z-10",
                    onClose: setOpen,
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "fixed inset-0 z-10 overflow-y-auto",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "flex min-h-[75%] items-end justify-center text-center sm:items-center p-4",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                                    as: (0, $exYeM.Fragment),
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                        className: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "p-2 flex items-center",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "pr-4 text-gray-700",
                                                            children: "Data Source"
                                                        }),
                                                        Array.isArray(sources) ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                                                                as: "div",
                                                                className: "inline-block md:hidden text-left",
                                                                children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                                                                    className: "group inline-flex justify-center rounded-lg w-32 bg-white ring-1 ring-inset ring-gray-300 hover:bg-primary hover:text-white px-4 py-2 text-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                            className: "mb-1",
                                                                                            children: selectedExchange
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e5ea8ee4dc7caabc$export$2e2bcd8739ae039), {
                                                                                            className: "h-5 w-5 ml-2 self-center text-secondary group-hover:text-white",
                                                                                            "aria-hidden": "true"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                                                                static: true,
                                                                                className: "absolute  ml-4 mt-1 z-10 divide-y divide-secondary rounded-lg bg-white ring-1 ring-inset ring-gray-300",
                                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                    className: "px-1 py-1",
                                                                                    children: props.graphSources.map((exchange, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                                                                                className: "divide-y divide-secondary px-1 py-2 hover:bg-primary hover:text-white rounded-lg",
                                                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                                    className: "w-full text-left",
                                                                                                    onClick: ()=>{
                                                                                                        setSelectedExchange(exchange.name);
                                                                                                        params("source", exchange.name);
                                                                                                    },
                                                                                                    children: exchange.name
                                                                                                })
                                                                                            })
                                                                                        }, index))
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            className: "font-robot  ",
                                                            children: dataSource
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "px-2 py-2 min-w-[256px]",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                            className: "pb-1 text-gray-700",
                                                            children: "Resolution"
                                                        }),
                                                        resolution ? /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                            children: resolution.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                    onClick: ()=>{
                                                                        params("resolution", data);
                                                                    },
                                                                    className: `${selectedResolution === data ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900`,
                                                                    children: data
                                                                }, data))
                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "px-2 py-2 mr-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                        className: "pb-1 text-gray-700",
                                                        children: "SMA"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "flex flex-auto rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                className: "grid grid-flow-col grow rounded-lg",
                                                                children: Object.keys(SMA).map((category)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            params("sma", category);
                                                                        },
                                                                        className: `${selectedSma === category ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900`,
                                                                        children: category
                                                                    }, category))
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                className: "hidden md:flex place-content-end rounded-lg ",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                        type: "text",
                                                                        className: `${smaInput ? "bg-primary text-white" : ""} w-16 rounded-l-lg border pl-2 border-gray-300`,
                                                                        placeholder: "Days",
                                                                        onChange: handleSmaInput,
                                                                        value: smaInput
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        className: " text-primary w-8 text-center rounded-r-lg hover:bg-primary hover:text-white",
                                                                        onClick: ()=>{
                                                                            // console.log(smaInput);
                                                                            if (!smaInput) params("sma", "None");
                                                                            else params("sma", smaInput);
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $788049de1171759f$export$2e2bcd8739ae039), {
                                                                            className: "h-5 w-5",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "px-2 py-2 mr-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                        className: "pb-1 text-gray-700",
                                                        children: "EMA"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "flex flex-auto rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                className: "grid grid-flow-col grow rounded-lg",
                                                                children: Object.keys(EMA).map((category)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            params("ema", category);
                                                                        },
                                                                        className: `${selectedEma === category ? "bg-primary text-white text-bold" : "text-black hover:bg-primary/30 hover:text-black"} w-full rounded-lg py-2.5 text-black`,
                                                                        children: category
                                                                    }, category))
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                className: "hidden md:flex place-content-end rounded-lg ",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                        type: "text",
                                                                        className: `${emaInput ? "bg-primary text-white" : ""} w-16 rounded-l-lg border pl-2 border-gray-300`,
                                                                        // className="w-16 h-full rounded-l-lg border-r-2 pl-2 border-secondary"
                                                                        placeholder: "Days",
                                                                        onChange: handleEmaInput,
                                                                        value: emaInput
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        className: "text-primary w-8 text-center rounded-r-lg hover:bg-primary hover:text-white",
                                                                        onClick: ()=>{
                                                                            if (!emaInput) params("ema", "None");
                                                                            else params("ema", emaInput);
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $788049de1171759f$export$2e2bcd8739ae039), {
                                                                            className: "h-5 w-5",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "px-2 py-2",
                                                children: chartOpts.chartOptions.map((value, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                                className: "pb-1 text-gray-700",
                                                                children: value.name
                                                            }, value.name),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                className: "grid grid-flow-col gap-x-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                        className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                onClick: ()=>{
                                                                                    // params("scale", "Linear");
                                                                                    // setLinear("Linear");
                                                                                    // let updateValue = { yAxis: "Test" };
                                                                                    if (index === 0) params("scale", "Linear");
                                                                                    else params("scale" + index, "Linear");
                                                                                    updateYaxis(value.name, "Linear");
                                                                                // props.setChartOpts((prevState) => ({
                                                                                //   ...prevState,
                                                                                //   ...updateValue,
                                                                                // }));
                                                                                // console.log(props.chartOpts);
                                                                                },
                                                                                className: `${value.yAxis === "Linear" ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900 `,
                                                                                children: "Linear"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                onClick: ()=>{
                                                                                    // params("scale", "Log");
                                                                                    // setLinear("Log");
                                                                                    if (index === 0) params("scale", "Log");
                                                                                    else params("scale" + index, "Log");
                                                                                    updateYaxis(value.name, "Log");
                                                                                },
                                                                                className: `${value.yAxis === "Log" ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900 `,
                                                                                children: "Log"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                        className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 w-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                onClick: ()=>{
                                                                                    // params("type", "Line");
                                                                                    updateStyle(value.name, "Line");
                                                                                    if (index === 0) params("type", "Line");
                                                                                    else params("type" + index, "Line");
                                                                                // setType("Line");
                                                                                },
                                                                                className: `${value.style === "Line" ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900 `,
                                                                                children: "Line"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                                onClick: ()=>{
                                                                                    // params("type", "Bar");
                                                                                    updateStyle(value.name, "Bar");
                                                                                    if (index === 0) params("type", "Bar");
                                                                                    else params("type" + index, "Bar");
                                                                                // setType("Bar");
                                                                                },
                                                                                className: `${value.style === "Bar" ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900"} rounded-lg py-2.5 text-gray-900 `,
                                                                                children: "Bar"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index))
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "px-2 py-2 justify-end flex",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    className: "px-3 py-2 rounded-lg bg-primaryContainer",
                                                    onClick: ()=>{
                                                        setOpen(false);
                                                    },
                                                    children: "Close"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}





const $db3ca1d693c83ded$export$9479dd47595eafb9 = (0, $405a4fa4811a9356$exports.create)((set)=>({
        graphState: {
            name: "",
            resetCmp: false,
            resetCharts: false
        },
        setGraphName: (input)=>set((state)=>({
                    graphState: {
                        ...state.graphState,
                        name: input
                    }
                })),
        setResetCmp: (value)=>set((state)=>({
                    graphState: {
                        ...state.graphState,
                        resetCmp: value
                    }
                })),
        setResetCharts: (value)=>set((state)=>({
                    graphState: {
                        ...state.graphState,
                        resetCharts: value
                    }
                }))
    }));


function $39b9837c01e31ffd$var$ChartMain(props) {
    const { user: user, validateUser: validateUser } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    const queryState = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.queryUrl);
    const newQuery = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.addQuery);
    const removeMultiQuery = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.removeMultiQuery);
    const removeAll = (0, $94784b6a454d4c0d$export$92838378c829615a)((state)=>state.removeAll);
    const { graphState: graphState, setResetCmp: setResetCmp } = (0, $db3ca1d693c83ded$export$9479dd47595eafb9)();
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [zoom, setZoom] = (0, $exYeM.useState)(3);
    const [minExtreme, setMinExtreme] = (0, $exYeM.useState)();
    const [maxExtreme, setMaxExtreme] = (0, $exYeM.useState)();
    const [minZoom, setMinZoom] = (0, $exYeM.useState)((0, (/*@__PURE__*/$parcel$interopDefault($jR9u2)))().subtract(6, "months").valueOf());
    const firstUrl = (0, $exYeM.useRef)(true);
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const [maxZoom, setMaxZoom] = (0, $exYeM.useState)(Date.now());
    const [additionalCharts, setAdditionalCharts] = (0, $exYeM.useState)([]);
    const [updateChart, setUpdateChart] = (0, $exYeM.useState)(null);
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { navIsLoading: navIsLoading, name: name } = (0, $0edff4a12d1a07f6$export$2e2bcd8739ae039)();
    const colours = [
        {
            name: "Green",
            hex: "rgba(76,175,80, 0.75)"
        },
        {
            name: "Blue",
            hex: "rgba(41, 98, 255, 0.75)"
        },
        {
            name: "Red",
            hex: "rgba(242, 54, 69, 0.75)"
        },
        {
            name: "Purple",
            hex: "rgba(156, 39, 176, 0.75)"
        },
        {
            name: "Yellow",
            hex: "rgba(255, 235, 59, 0.75)"
        }
    ];
    const style = [
        {
            name: "Line",
            data: "line"
        },
        {
            name: "Bar",
            data: "column"
        }
    ];
    const scales = [
        {
            name: "Linear",
            data: "linear"
        },
        {
            name: "Log",
            data: "logarithmic"
        }
    ];
    // removes the additional charts when navigating to a new chart
    function removeAllAdd() {
        setAdditionalCharts([]);
        props.setRemove(null);
        removeAll();
        searchParams.delete("cmp");
        setSearchParams(searchParams);
    }
    (0, $exYeM.useEffect)(()=>{
        if (searchParams.getAll("cmp").length > 0 && graphState.resetCmp) {
            removeAllAdd();
            setResetCmp(false);
        }
    }, [
        graphState.resetCmp,
        searchParams.get("name"),
        searchParams.get("blockchain")
    ]);
    // logic for loading in additional charts from the url on the first load
    function loadURLCmp() {
        if (!navIsLoading) // check that the query state is out of sync
        {
            if (queryState.length < searchParams.getAll("cmp").length && firstUrl.current) {
                firstUrl.current = false;
                var tmpAdditional = [];
                var index = 0;
                var toRemove = [];
                var skip = false; // skip is used to skip charts with bad settings
                // for all the additional charts extract each one
                searchParams.getAll("cmp").forEach((el)=>{
                    var data = el.split("_");
                    var colorIndex = colours.findIndex((obj)=>obj.name === data[3]);
                    var styleIndex = style.findIndex((obj)=>obj.name === data[4]);
                    var scaleIndex = scales.findIndex((obj)=>obj.name === data[5]);
                    index++;
                    // ensure no errors in the url
                    if (colorIndex === -1 || styleIndex === -1 || scaleIndex === -1) {
                        toRemove.push(index);
                        skip = true;
                        props.setShowError(true);
                        props.setErrorMessage("Incorrect settings! A chart has been removed");
                    } else // len 6 is no source listed
                    if (data.length === 6) {
                        tmpAdditional.filter((flt)=>{
                            if (flt.id === data[1] + data[0] + null + data[2]) {
                                toRemove.push(index);
                                skip = true;
                            }
                        });
                        if (!skip) tmpAdditional.push({
                            id: data[1] + data[0] + null + data[2],
                            blockchain: data[0],
                            name: data[1],
                            resolution: data[2],
                            color: colours[colorIndex],
                            style: style[styleIndex],
                            scale: scales[scaleIndex],
                            source: null
                        });
                    } else {
                        tmpAdditional.filter((flt)=>{
                            if (flt.id === data[1] + data[0] + data[6] + data[2]) {
                                toRemove.push(index);
                                skip = true;
                            }
                        });
                        if (!skip) tmpAdditional.push({
                            id: data[1] + data[0] + data[6] + data[2],
                            blockchain: data[0],
                            name: data[1],
                            resolution: data[2],
                            color: colours[colorIndex],
                            style: style[styleIndex],
                            scale: scales[scaleIndex],
                            source: data[6]
                        });
                    }
                    skip = false;
                });
                var tmpQueryUrl = Array.from(searchParams.entries());
                // using the skipped values remove them from the URL
                // this can be im proved by finding start index instead of hard coding it.
                toRemove.forEach((id)=>{
                    tmpQueryUrl.splice(id + 6, 1);
                });
                //  use the user data stored to validate how many charts they can have
                if (JSON.parse(localStorage.getItem("user")).charts < tmpAdditional.length) {
                    // amount added is invalid
                    props.setShowError(true);
                    props.setErrorMessage("Attempted to add too many charts");
                    var amtInvalid = tmpAdditional.length - JSON.parse(localStorage.getItem("user")).charts;
                    tmpAdditional.splice(tmpAdditional.length - amtInvalid, amtInvalid);
                    tmpQueryUrl.splice(tmpQueryUrl.length - amtInvalid, amtInvalid);
                }
                // amount added is valid
                setSearchParams(tmpQueryUrl);
                tmpAdditional.forEach((el)=>{
                    setAdditionalCharts((prevState)=>[
                            ...prevState,
                            el
                        ]);
                    newQuery(el.blockchain, el.resolution, el.name, el.source);
                });
            }
        }
    }
    // ensure that the local value is not tampered with
    function validateAdditionalCharts() {
        if (user.charts < additionalCharts.length) {
            // amount added is invalid
            var tmpQueryUrl = Array.from(searchParams.entries());
            var amtInvalid = additionalCharts.length - user.charts;
            tmpQueryUrl.splice(tmpQueryUrl.length - amtInvalid, amtInvalid);
            setSearchParams(tmpQueryUrl);
            setAdditionalCharts((prevState)=>{
                const newState = [
                    ...prevState
                ];
                newState.splice(additionalCharts.length - amtInvalid, amtInvalid);
                return newState;
            });
            removeMultiQuery(queryState.length - amtInvalid - 1, amtInvalid);
        }
    }
    (0, $exYeM.useEffect)(()=>{
        if (searchParams.getAll("cmp").length > 0) loadURLCmp();
    }, []);
    (0, $exYeM.useEffect)(()=>{
        if (additionalCharts.length > 0) validateAdditionalCharts();
    }, [
        user
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "mb-4 w-full relative",
        children: [
            navIsLoading || props.graphDataV2[0]?.isLoading || props.graphDataV2[1]?.isLoading || validateUser.isLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex justify-between mx-8 py-2 animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex flex-auto gap-2 items-center",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "pr-4 pl-14 py-4 rounded-xl bg-gray-300"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                            className: "grid grid-flow-col w-full space-x-1 rounded-xl bg-gray-300",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "w-12 rounded-xl py-4"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "w-12 rounded-xl py-4"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "w-12 rounded-xl py-4"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "w-12 rounded-xl py-4"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "hidden md:block w-12 rounded-xl py-4"
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex justify-between mx-8 py-2 secret-div gap-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "grid grid-flow-col gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "hidden md:block",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $63b80c27e867e612$export$2e2bcd8739ae039), {
                                    chartOpts: props.chartOpts,
                                    setChartOpts: props.setChartOpts
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "block md:hidden",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9ede5d08e9b2b289$export$2e2bcd8739ae039), {
                                    chartOpts: props.chartOpts,
                                    setChartOpts: props.setChartOpts
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f756b151c39b63cf$export$2e2bcd8739ae039), {
                                open: open,
                                setOpen: setOpen,
                                additionalCharts: additionalCharts,
                                setAdditionalCharts: setAdditionalCharts,
                                colour: colours,
                                style: style,
                                scale: scales
                            }),
                            " ",
                            additionalCharts ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "overflow-x-auto",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "hidden md:grid grid-flow-col overflow-auto w-full gap-2",
                                        children: additionalCharts.map((data, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $9c30546b2e326875$export$2e2bcd8739ae039), {
                                                index: index,
                                                data: data,
                                                setRemove: props.setRemove,
                                                setAdditionalCharts: setAdditionalCharts,
                                                additionalCharts: additionalCharts,
                                                updateChart: updateChart,
                                                setUpdateChart: setUpdateChart,
                                                graphData: props.graphDataV2,
                                                colour: colours,
                                                style: style,
                                                scale: scales
                                            }, data.name + data.blockchain))
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "md:hidden grid grid-flow-col overflow-auto w-full gap-2",
                                        children: additionalCharts.map((data, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $d413c50062446834$export$2e2bcd8739ae039), {
                                                index: index,
                                                data: data,
                                                setRemove: props.setRemove,
                                                setAdditionalCharts: setAdditionalCharts,
                                                additionalCharts: additionalCharts,
                                                updateChart: updateChart,
                                                setUpdateChart: setUpdateChart,
                                                graphData: props.graphDataV2,
                                                colour: colours,
                                                style: style,
                                                scale: scales
                                            }, data.name + data.blockchain))
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b1f5592f12c5f00f$export$2e2bcd8739ae039), {
                            set: setZoom,
                            min: minExtreme,
                            max: maxExtreme,
                            setMinZoom: setMinZoom,
                            setMaxZoom: setMaxZoom,
                            minZoom: minZoom,
                            maxZoom: maxZoom
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "mx-8",
                children: props.graphDataV2[0]?.isFetching || props.graphDataV2[1]?.isFetching ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "min-h-[80vh] bg-gray-200 rounded-xl animate-pulse flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8af33ef04486b7$exports))),
                        alt: "...",
                        className: "max-h-16 md:max-h-40 pl-14"
                    })
                }) : props.graphDataV2[0]?.data === "Unauthorized" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a289785f4427b60e$exports))),
                            className: "blur-sm min-h-[70vh]",
                            height: "100%",
                            width: "100%",
                            alt: "..."
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "absolute text-black top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 backdrop-blur-sm p-4",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                    className: "text-5xl mb-4",
                                    children: "Upgrade to access"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        className: "bg-surfaceVariant border border-primaryContainer shadow-md rounded-lg hover:bg-primary hover:text-white p-4 text-3xl font-semibold w-full",
                                        onClick: ()=>{
                                            navigate("/pricing");
                                        },
                                        children: "Upgrade"
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6f36bc2d81eb620e$export$2e2bcd8739ae039), {
                    data: props.graphData,
                    dataV2: props.graphDataV2,
                    remove: props.remove,
                    setRemove: props.setRemove,
                    additionalCharts: additionalCharts,
                    name: name,
                    sidebar: props.sidebar,
                    zoom: zoom,
                    min: setMinExtreme,
                    max: setMaxExtreme,
                    minZoom: minZoom,
                    maxZoom: maxZoom,
                    setMinZoom: setMinZoom,
                    setMaxZoom: setMaxZoom,
                    priceData: props.priceData,
                    updateChart: updateChart,
                    setUpdateChart: setUpdateChart
                })
            })
        ]
    });
}
var $39b9837c01e31ffd$export$2e2bcd8739ae039 = $39b9837c01e31ffd$var$ChartMain;



// created by james launder
// small header that is shown when a used is below a certain tier

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
function $fa37c8827eacfcfe$var$ArrowTrendingUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M15.22 6.268a.75.75 0 01.968-.432l5.942 2.28a.75.75 0 01.431.97l-2.28 5.941a.75.75 0 11-1.4-.537l1.63-4.251-1.086.483a11.2 11.2 0 00-5.45 5.174.75.75 0 01-1.199.19L9 12.31l-6.22 6.22a.75.75 0 11-1.06-1.06l6.75-6.75a.75.75 0 011.06 0l3.606 3.605a12.694 12.694 0 015.68-4.973l1.086-.484-4.251-1.631a.75.75 0 01-.432-.97z",
        clipRule: "evenodd"
    }));
}
const $fa37c8827eacfcfe$var$ForwardRef = $exYeM.forwardRef($fa37c8827eacfcfe$var$ArrowTrendingUpIcon);
var $fa37c8827eacfcfe$export$2e2bcd8739ae039 = $fa37c8827eacfcfe$var$ForwardRef;



function $cfc21d82a2d8477b$var$UpgradeHeader() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-full grid content-center font-roboto mt-2",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "flex flex-row justify-between place-items-center mx-8 px-2 pt-2 pb-2 bg-primary border border-primaryContainer shadow-md rounded-lg",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex flex-row space-x-2 text-white",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fa37c8827eacfcfe$export$2e2bcd8739ae039), {
                            className: "sm:block hidden h-6 w-6"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "sm:text-base text-sm",
                            children: "To see the latest data you must upgrade to a higher tier"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        className: "px-3 py-2 bg-surfaceVariant hover:bg-primary hover:text-white border border-primaryContainer shadow-md font-semibold rounded-lg hover:shadow-xl text-sm",
                        onClick: ()=>{
                            navigate("/Pricing");
                        },
                        children: "Upgrade"
                    })
                })
            ]
        })
    });
}
var $cfc21d82a2d8477b$export$2e2bcd8739ae039 = $cfc21d82a2d8477b$var$UpgradeHeader;



var $exYeM = parcelRequire("exYeM");
var $37ca891a4b6bc72b$var$key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var $37ca891a4b6bc72b$var$webkit = [
    "webkitFullscreenEnabled",
    "webkitFullscreenElement",
    "webkitRequestFullscreen",
    "webkitExitFullscreen",
    "webkitfullscreenchange",
    "webkitfullscreenerror",
    "-webkit-full-screen"
];
var $37ca891a4b6bc72b$var$moz = [
    "mozFullScreenEnabled",
    "mozFullScreenElement",
    "mozRequestFullScreen",
    "mozCancelFullScreen",
    "mozfullscreenchange",
    "mozfullscreenerror",
    "-moz-full-screen"
];
var $37ca891a4b6bc72b$var$ms = [
    "msFullscreenEnabled",
    "msFullscreenElement",
    "msRequestFullscreen",
    "msExitFullscreen",
    "MSFullscreenChange",
    "MSFullscreenError",
    "-ms-fullscreen"
];
// so it doesn't throw if no window or document
var $37ca891a4b6bc72b$var$document = typeof window !== "undefined" && typeof window.document !== "undefined" ? window.document : {};
var $37ca891a4b6bc72b$var$vendor = "fullscreenEnabled" in $37ca891a4b6bc72b$var$document && Object.keys($37ca891a4b6bc72b$var$key) || $37ca891a4b6bc72b$var$webkit[0] in $37ca891a4b6bc72b$var$document && $37ca891a4b6bc72b$var$webkit || $37ca891a4b6bc72b$var$moz[0] in $37ca891a4b6bc72b$var$document && $37ca891a4b6bc72b$var$moz || $37ca891a4b6bc72b$var$ms[0] in $37ca891a4b6bc72b$var$document && $37ca891a4b6bc72b$var$ms || [];
var $37ca891a4b6bc72b$var$fscreen = {
    requestFullscreen: function(element) {
        return element[$37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.requestFullscreen]]();
    },
    requestFullscreenFunction: function(element) {
        return element[$37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.requestFullscreen]];
    },
    get exitFullscreen () {
        return $37ca891a4b6bc72b$var$document[$37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.exitFullscreen]].bind($37ca891a4b6bc72b$var$document);
    },
    get fullscreenPseudoClass () {
        return ":" + $37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.fullscreen];
    },
    addEventListener: function(type, handler1, options) {
        return $37ca891a4b6bc72b$var$document.addEventListener($37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key[type]], handler1, options);
    },
    removeEventListener: function(type, handler1, options) {
        return $37ca891a4b6bc72b$var$document.removeEventListener($37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key[type]], handler1, options);
    },
    get fullscreenEnabled () {
        return Boolean($37ca891a4b6bc72b$var$document[$37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.fullscreenEnabled]]);
    },
    set fullscreenEnabled (val){},
    get fullscreenElement () {
        return $37ca891a4b6bc72b$var$document[$37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.fullscreenElement]];
    },
    set fullscreenElement (val){},
    get onfullscreenchange () {
        return $37ca891a4b6bc72b$var$document[("on" + $37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.fullscreenchange]).toLowerCase()];
    },
    set onfullscreenchange (handler){
        return $37ca891a4b6bc72b$var$document[("on" + $37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.fullscreenchange]).toLowerCase()] = handler;
    },
    get onfullscreenerror () {
        return $37ca891a4b6bc72b$var$document[("on" + $37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.fullscreenerror]).toLowerCase()];
    },
    set onfullscreenerror (handler){
        return $37ca891a4b6bc72b$var$document[("on" + $37ca891a4b6bc72b$var$vendor[$37ca891a4b6bc72b$var$key.fullscreenerror]).toLowerCase()] = handler;
    }
};
var $37ca891a4b6bc72b$export$2e2bcd8739ae039 = $37ca891a4b6bc72b$var$fscreen;


function $7f5c406343918fda$export$b7af93e5c0fa655e() {
    var _useState = (0, $exYeM.useState)(false), active = _useState[0], setActive = _useState[1];
    var node = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(function() {
        var handleChange = function handleChange() {
            setActive((0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).fullscreenElement === node.current);
        };
        (0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).addEventListener("fullscreenchange", handleChange);
        return function() {
            return (0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).removeEventListener("fullscreenchange", handleChange);
        };
    }, []);
    var enter = (0, $exYeM.useCallback)(function() {
        if ((0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).fullscreenElement) return (0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).exitFullscreen().then(function() {
            return (0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).requestFullscreen(node.current);
        });
        else if (node.current) return (0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).requestFullscreen(node.current);
    }, []);
    var exit = (0, $exYeM.useCallback)(function() {
        if ((0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).fullscreenElement === node.current) return (0, $37ca891a4b6bc72b$export$2e2bcd8739ae039).exitFullscreen();
        return Promise.resolve();
    }, []);
    return (0, $exYeM.useMemo)(function() {
        return {
            active: active,
            enter: enter,
            exit: exit,
            node: node
        };
    }, [
        active,
        enter,
        exit
    ]);
}
var $7f5c406343918fda$export$f885b95b3f0be76d = function FullScreen(_ref) {
    var handle = _ref.handle, onChange = _ref.onChange, children = _ref.children, className = _ref.className;
    var classNames = [];
    if (className) classNames.push(className);
    classNames.push("fullscreen");
    if (handle.active) classNames.push("fullscreen-enabled");
    (0, $exYeM.useEffect)(function() {
        if (onChange) onChange(handle.active, handle);
    }, [
        handle.active
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: classNames.join(" "),
        ref: handle.node,
        style: handle.active ? {
            height: "100%",
            width: "100%"
        } : undefined
    }, children);
};






function $d8d06ecc3828533f$var$MainSection(props) {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const handle = (0, $7f5c406343918fda$export$b7af93e5c0fa655e)();
    const image = (0, $exYeM.useRef)();
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [graphData] = (0, $exYeM.useState)([]);
    const [showHeader, setShowHeader] = (0, $exYeM.useState)(true);
    const [removeChart, setRemoveChart] = (0, $exYeM.useState)(null);
    const { navIsLoading: navIsLoading, navIsFetching: navIsFetching } = (0, $0edff4a12d1a07f6$export$2e2bcd8739ae039)();
    const { results: results, error: error } = (0, $442f21bf70571909$export$2e2bcd8739ae039)();
    const { userData: userData, validateUser: validateUser } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    const graphState = (0, $db3ca1d693c83ded$export$9479dd47595eafb9)((state)=>state.graphState);
    function header() {
        if (localStorage.getItem("user") === null) {
            setShowHeader(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $cfc21d82a2d8477b$export$2e2bcd8739ae039), {}));
            return;
        }
        if (userData?.tier < 1) {
            setShowHeader(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $cfc21d82a2d8477b$export$2e2bcd8739ae039), {}));
            return;
        }
        setShowHeader(/*#__PURE__*/ (0, $aSiaI.jsx)("div", {}));
    }
    (0, $exYeM.useEffect)(()=>{
        header();
    // console.log("header effect called");
    // updateQuery();
    }, [
        searchParams.get("blockchain"),
        searchParams.get("name"),
        searchParams.get("resolution"),
        searchParams.get("source"),
        userData
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-full h-fit overflow-auto relative z-0 pb-10",
        children: error === 404 || results[0].isError && !results[1]?.isError ? /*#__PURE__*/ (0, $aSiaI.jsx)("main", {
            className: "grid min-h-[70vh] place-items-center py-24 px-6 sm:py-32 lg:px-8 font-roboto",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "text-2xl font-semibold text-primary",
                        children: "404"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                        className: "mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                        children: "Graph not found"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "mt-6 text-base leading-7 text-gray-600",
                        children: "Sorry, we couldn\u2019t find the page you\u2019re looking for."
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "mt-6 flex items-center justify-center gap-x-6",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            onClick: ()=>{
                                navigate("/");
                            },
                            className: "rounded-lg bg-primaryContainer px-3 py-2 text-sm font-semibold text-black shadow-sm hover:text-white hover:bg-primary",
                            children: "Go back home"
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    children: showHeader
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7f5c406343918fda$export$f885b95b3f0be76d), {
                    handle: handle,
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        ref: image,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: navIsLoading || navIsFetching ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "h-[70] w-full grid content-center font-roboto animate-pulse",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex flex-row justify-between pt-2 mx-8 px-2 border-b border-secondary pb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-row gap-4 place-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: " place-items-center pr-4 pl-14 py-5 rounded-xl bg-gray-300"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "flex flex-row place-items-center divide-x divide-secondary bg-gray-300 rounded-xl px-2",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            className: "group  rounded-lg p-2 py-5 pl-[92px]"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                className: "relative inline-flex rounded-xl bg-gray-300 items-center  ",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "group flex flex-row place-content-center p-2 hover:bg-primary hover:text-white pl-2 rounded-xl w-24 py-2.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "group flex flex-row place-content-center p-2 hover:bg-primary hover:text-white pl-2 rounded-xl w-24 py-2.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "group flex flex-row place-content-center p-2 hover:bg-primary hover:text-white pl-2 rounded-xl w-24 py-2.5"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col relative z-10",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "flex justify-center absolute inset-0 mt-0 pt-2 text-2xl font-bold",
                                            children: graphState.name
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "z-30 bg-white secret-div",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9a3b74454697bd7e$export$2e2bcd8739ae039), {
                                                divRef: image,
                                                name: graphState.name,
                                                handle: handle
                                            })
                                        })
                                    ]
                                })
                            }),
                            error === "No Token" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a289785f4427b60e$exports))),
                                        className: "blur-sm min-h-[70vh]",
                                        height: "100%",
                                        width: "100%",
                                        alt: "..."
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "absolute text-black top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 backdrop-blur-sm p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                className: "text-5xl mb-4",
                                                children: "Login to access!"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "mt-4",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    className: "bg-surfaceVariant border border-primaryContainer shadow-md rounded-lg hover:bg-primary hover:text-white p-4 text-3xl font-semibold w-full",
                                                    onClick: ()=>{
                                                        navigate("/signin");
                                                    },
                                                    children: "Login"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "relative z-0",
                                children: navIsLoading || validateUser.isLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex justify-between mx-8 py-2 animate-pulse",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "flex flex-auto gap-2 items-center",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "pr-4 pl-14 py-4 rounded-xl bg-gray-300"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                className: "grid grid-flow-col w-full space-x-1 rounded-xl bg-gray-300",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "w-12 rounded-xl py-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "w-12 rounded-xl py-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "w-12 rounded-xl py-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "w-12 rounded-xl py-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "hidden md:block w-12 rounded-xl py-4"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $39b9837c01e31ffd$export$2e2bcd8739ae039), {
                                    graphData: graphData,
                                    graphDataV2: results,
                                    // graphDataV2={[]}
                                    remove: removeChart,
                                    setRemove: setRemoveChart,
                                    sidebar: props.sidebar,
                                    showError: props.showError,
                                    setShowError: props.setShowError,
                                    errorMessage: props.errorMessage,
                                    setErrorMessage: props.setErrorMessage,
                                    graphError: error
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13a0509bfb2c028b$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $d8d06ecc3828533f$export$2e2bcd8739ae039 = $d8d06ecc3828533f$var$MainSection;


// Created by James Launder taken from tailwindUI
// used for the error popup

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $e0712a81bd67fc1b$var$ExclamationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
}
const $e0712a81bd67fc1b$var$ForwardRef = $exYeM.forwardRef($e0712a81bd67fc1b$var$ExclamationCircleIcon);
var $e0712a81bd67fc1b$export$2e2bcd8739ae039 = $e0712a81bd67fc1b$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $a6420636464f3564$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
    }));
}
const $a6420636464f3564$var$ForwardRef = $exYeM.forwardRef($a6420636464f3564$var$XMarkIcon);
var $a6420636464f3564$export$2e2bcd8739ae039 = $a6420636464f3564$var$ForwardRef;


function $ea6937cef5e20cb0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            "aria-live": "assertive",
            className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex w-full flex-col items-center space-y-4 sm:items-end",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                    show: props.show,
                    as: (0, $exYeM.Fragment),
                    enter: "transform ease-out duration-300 transition",
                    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
                    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-surfaceVariant shadow-lg ring-1 ring-black ring-opacity-5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e0712a81bd67fc1b$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-red-500",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "ml-3 w-0 flex-1 pt-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-md font-medium text-gray-900",
                                                children: "Error"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "mt-1 text-md text-gray-500",
                                                children: props.message
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "ml-4 flex flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                            onClick: ()=>{
                                                props.setShow(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6420636464f3564$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}


// Created by James Launder taken from tailwindUI
// used for the error popup

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");
function $b1025e29a9661faf$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $b1025e29a9661faf$var$ForwardRef = $exYeM.forwardRef($b1025e29a9661faf$var$CheckCircleIcon);
var $b1025e29a9661faf$export$2e2bcd8739ae039 = $b1025e29a9661faf$var$ForwardRef;


function $1dd556b5502848ba$export$2e2bcd8739ae039() {
    const popup = (0, $640fe7a5f95bf9d5$export$24a1375a06d69907)((state)=>state.popup);
    const close = (0, $640fe7a5f95bf9d5$export$24a1375a06d69907)((state)=>state.close);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            "aria-live": "assertive",
            className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex w-full flex-col items-center space-y-4 sm:items-end",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                    show: popup[0],
                    as: (0, $exYeM.Fragment),
                    enter: "transform ease-out duration-300 transition",
                    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
                    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-surfaceVariant shadow-lg ring-1 ring-black ring-opacity-5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b1025e29a9661faf$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-green-500",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "ml-3 w-0 flex-1 pt-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-md font-medium text-gray-900",
                                                children: "Success"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "mt-1 text-md text-gray-500",
                                                children: popup[1]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "ml-4 flex flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                            onClick: ()=>{
                                                close();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6420636464f3564$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}



const $bac91e2a1be69460$export$59dca65daeaf223 = (0, $405a4fa4811a9356$exports.create)((set)=>({
        state: true,
        setSidebar: (input)=>set(()=>({
                    state: input
                }))
    }));


function $a4752a6c21eebe7d$var$Charting() {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [show, setShow] = (0, $exYeM.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $exYeM.useState)("");
    const sidebar = (0, $bac91e2a1be69460$export$59dca65daeaf223)((state)=>state.state);
    // console.log("charting rendered");
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: " max-w-full h-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex flex-row relative z-0 w-full mx-auto",
                children: searchParams.get("name") ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d8d06ecc3828533f$export$2e2bcd8739ae039), {
                    sidebar: sidebar,
                    showError: show,
                    setShowError: setShow,
                    errorMessage: errorMessage,
                    setErrorMessage: setErrorMessage
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $43140a09af1520b8$export$2e2bcd8739ae039), {
                    sidebar: sidebar
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "absolute z-30",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1dd556b5502848ba$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ea6937cef5e20cb0$export$2e2bcd8739ae039), {
                        show: show,
                        setShow: setShow,
                        message: errorMessage
                    })
                ]
            })
        ]
    });
}
var $a4752a6c21eebe7d$export$2e2bcd8739ae039 = $a4752a6c21eebe7d$var$Charting;


// Created by Matt webb
// main payment page that is shown to the user, contains the data for each plan

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");





let $f05a53bf04c28d08$var$d = (0, $exYeM.createContext)(null);
function $f05a53bf04c28d08$var$u() {
    let o = (0, $exYeM.useContext)($f05a53bf04c28d08$var$d);
    if (o === null) {
        let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $f05a53bf04c28d08$var$u), t;
    }
    return o;
}
function $f05a53bf04c28d08$export$d6875122194c7b44() {
    let [o, t] = (0, $exYeM.useState)([]);
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $exYeM.useMemo)(()=>function(e) {
                let s = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>(t((l)=>[
                            ...l,
                            r
                        ]), ()=>t((l)=>{
                            let n = l.slice(), p = n.indexOf(r);
                            return p !== -1 && n.splice(p, 1), n;
                        }))), a = (0, $exYeM.useMemo)(()=>({
                        register: s,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    s,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($f05a53bf04c28d08$var$d.Provider, {
                    value: a
                }, e.children);
            }, [
            t
        ])
    ];
}
let $f05a53bf04c28d08$var$A = "label";
function $f05a53bf04c28d08$var$h(o, t) {
    let i = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: e = `headlessui-label-${i}`, passive: s = !1, ...a } = o, r = $f05a53bf04c28d08$var$u(), l = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(t);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>r.register(e), [
        e,
        r.register
    ]);
    let n = {
        ref: l,
        ...r.props,
        id: e
    };
    return s && ("onClick" in n && (delete n.htmlFor, delete n.onClick), "onClick" in a && delete a.onClick), (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: n,
        theirProps: a,
        slot: r.slot || {},
        defaultTag: $f05a53bf04c28d08$var$A,
        name: r.name || "Label"
    });
}
let $f05a53bf04c28d08$var$v = (0, $6da0b689c34972b7$export$e43f39796049410c)($f05a53bf04c28d08$var$h), $f05a53bf04c28d08$export$b04be29aa201d4f5 = Object.assign($f05a53bf04c28d08$var$v, {});










let $f1e8c7fc303292af$var$y = (0, $exYeM.createContext)(null);
$f1e8c7fc303292af$var$y.displayName = "GroupContext";
let $f1e8c7fc303292af$var$Y = (0, $exYeM.Fragment);
function $f1e8c7fc303292af$var$Z(s) {
    var d;
    let [n, p] = (0, $exYeM.useState)(null), [c, f] = (0, $f05a53bf04c28d08$export$d6875122194c7b44)(), [r, h] = (0, $c661dd91897b6639$export$babde88292020af7)(), l = (0, $exYeM.useMemo)(()=>({
            switch: n,
            setSwitch: p,
            labelledby: c,
            describedby: r
        }), [
        n,
        p,
        c,
        r
    ]), T = {}, b = s;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(h, {
        name: "Switch.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(f, {
        name: "Switch.Label",
        props: {
            htmlFor: (d = l.switch) == null ? void 0 : d.id,
            onClick (t) {
                n && (t.currentTarget.tagName === "LABEL" && t.preventDefault(), n.click(), n.focus({
                    preventScroll: !0
                }));
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($f1e8c7fc303292af$var$y.Provider, {
        value: l
    }, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: T,
        theirProps: b,
        defaultTag: $f1e8c7fc303292af$var$Y,
        name: "Switch.Group"
    }))));
}
let $f1e8c7fc303292af$var$ee = "button";
function $f1e8c7fc303292af$var$te(s, n) {
    let p = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: c = `headlessui-switch-${p}`, checked: f, defaultChecked: r = !1, onChange: h, name: l, value: T, form: b, ...d } = s, t = (0, $exYeM.useContext)($f1e8c7fc303292af$var$y), u = (0, $exYeM.useRef)(null), D = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(u, n, t === null ? null : t.setSwitch), [o, a] = (0, $ec3d9133814ca96e$export$454217e89aea72b)(f, h, r), S = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>a == null ? void 0 : a(!o)), C = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((e)=>{
        if ((0, $b762bd1946006453$export$db61f031a278447c)(e.currentTarget)) return e.preventDefault();
        e.preventDefault(), S();
    }), L = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((e)=>{
        e.key === (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space ? (e.preventDefault(), S()) : e.key === (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Enter && (0, $7ef5a50884dbacae$export$ee02894bdc79dd36)(e.currentTarget);
    }), v = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((e)=>e.preventDefault()), G = (0, $exYeM.useMemo)(()=>({
            checked: o
        }), [
        o
    ]), R = {
        id: c,
        ref: D,
        role: "switch",
        type: (0, $5848675429035810$export$53652b2b272efe9c)(s, u),
        tabIndex: 0,
        "aria-checked": o,
        "aria-labelledby": t == null ? void 0 : t.labelledby,
        "aria-describedby": t == null ? void 0 : t.describedby,
        onClick: C,
        onKeyUp: L,
        onKeyPress: v
    }, k = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)();
    return (0, $exYeM.useEffect)(()=>{
        var w;
        let e = (w = u.current) == null ? void 0 : w.closest("form");
        e && r !== void 0 && k.addEventListener(e, "reset", ()=>{
            a(r);
        });
    }, [
        u,
        a
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, l != null && o && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
        features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Hidden,
        ...(0, $6da0b689c34972b7$export$8e16b83750b44988)({
            as: "input",
            type: "checkbox",
            hidden: !0,
            readOnly: !0,
            form: b,
            checked: o,
            name: l,
            value: T
        })
    }), (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: R,
        theirProps: d,
        slot: G,
        defaultTag: $f1e8c7fc303292af$var$ee,
        name: "Switch"
    }));
}
let $f1e8c7fc303292af$var$ne = (0, $6da0b689c34972b7$export$e43f39796049410c)($f1e8c7fc303292af$var$te), $f1e8c7fc303292af$var$re = $f1e8c7fc303292af$var$Z, $f1e8c7fc303292af$export$b5d5cf8927ab7262 = Object.assign($f1e8c7fc303292af$var$ne, {
    Group: $f1e8c7fc303292af$var$re,
    Label: (0, $f05a53bf04c28d08$export$b04be29aa201d4f5),
    Description: (0, $c661dd91897b6639$export$393edc798c47379d)
});



var $exYeM = parcelRequire("exYeM");
function $9bcddf4d25089704$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z",
        clipRule: "evenodd"
    }));
}
const $9bcddf4d25089704$var$ForwardRef = $exYeM.forwardRef($9bcddf4d25089704$var$CheckIcon);
var $9bcddf4d25089704$export$2e2bcd8739ae039 = $9bcddf4d25089704$var$ForwardRef;





var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");
const $41327f2ae7984f2e$var$TwistComponentPrimary = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 850.394 850.394",
        style: {
            enableBackground: "new 0 0 850.393677 850.393677"
        },
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("style", {
                children: ".st8,.st9{fill:none;stroke:#fcbdab;stroke-miterlimit:10}.st8{stroke-width:2;stroke-linecap:round}.st9{stroke-width:1.5}"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M385.455 389.742c-1.017-2.484-3.396-7.272-5.542-10.863-1.091-1.826-4.564-7.448-10.641-13.634-2.885-2.936-8.068-8.134-16.295-12.637-4.007-2.193-8.315-4.55-14.632-5.653-6.624-1.155-11.882-.306-15.63.333-7.183 1.224-12.319 3.59-15.296 4.988-5.05 2.37-8.482 4.758-12.637 7.648 0 0-2.322 1.616-12.636 9.644h0c-.887.665-2.771 2.771-3.658 3.436"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M388.496 388.551c-.446-1.56-1.327-4.04-2.393-6.651-.623-1.527-1.363-3.034-2.022-4.423a36.974 36.974 0 0 0-2.618-4.608 103.849 103.849 0 0 0-7.263-9.662c-1.848-2.184-4.506-4.972-8.034-7.893-2.345-1.94-5.193-4.03-8.128-5.787-1.433-.858-2.925-1.892-4.7-2.87-1.417-.78-3.046-1.611-4.943-2.362a37.277 37.277 0 0 0-7.065-2.03c-2.378-.413-5.078-.649-7.8-.54-3.81.15-6.91.867-9.384 1.373-6.805 1.392-11.727 3.548-14.698 4.971-4.782 2.293-8.173 4.533-12.172 7.433-1.017.738-3.526 2.103-13.301 10.441-2.148 1.833-4.767 5.376-6.008 6.784"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M392.562 389.403c-.25-1.551-1.853-6.07-2.659-8.77-.47-1.58-1.116-3.117-1.654-4.558a27.61 27.61 0 0 0-2.329-4.788c-1.412-2.314-3.673-5.93-6.791-10.118-1.909-2.564-4.562-5.467-7.913-8.45-2.391-2.13-5.383-4.497-8.117-6.274-1.485-.965-3.055-2.243-5.08-3.47-1.455-.884-3.238-1.91-5.42-2.855-1.936-.838-4.335-1.735-7.259-2.355-.19-.04-.381-.08-.573-.115-2.273-.417-5.383-.775-8.744-.591-4.325.236-7.74 1.212-10.447 1.849-6.43 1.513-11.136 3.504-14.098 4.955-4.516 2.211-7.811 4.382-11.707 7.216-2.034 1.479-4.505 2.877-13.967 11.24-3.406 3.01-6.762 7.98-8.358 10.131"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M394.578 388.388c-.053-1.544-.328-6.233-.874-9.02-.318-1.633-.86-3.208-1.287-4.696a23.34 23.34 0 0 0-2.04-4.967c-1.22-2.2-3.3-6.03-6.32-10.574-1.96-2.952-4.61-5.972-7.792-9.009-2.434-2.323-5.566-4.978-8.105-6.759-1.536-1.076-3.189-2.588-5.46-4.072-1.497-.978-3.433-2.203-5.897-3.346-2.027-.941-4.66-2.031-7.966-2.775-.21-.047-.42-.094-.633-.135-2.168-.416-5.688-.905-9.687-.642-4.842.318-8.572 1.55-11.511 2.325-6.06 1.597-10.544 3.46-13.498 4.938-4.252 2.128-7.45 4.232-11.243 7-3.047 2.223-5.426 3.716-14.632 12.038-4.65 4.204-8.757 10.586-10.708 13.479"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M397.724 387.36c.143-1.535.066-6.383-.22-9.258-.165-1.686-.592-3.303-.919-4.832-.285-1.334-.754-3.142-1.752-5.147-1.034-2.08-2.915-6.139-5.847-11.03-2.006-3.346-4.653-6.486-7.671-9.566-2.473-2.524-5.742-5.473-8.095-7.246-1.583-1.193-3.325-2.927-5.84-4.674-1.54-1.07-3.628-2.49-6.373-3.838-2.12-1.04-4.985-2.326-8.672-3.194-.23-.054-.46-.108-.694-.155-2.064-.412-5.993-1.036-10.631-.692-5.357.396-9.403 1.88-12.574 2.8-5.697 1.653-9.953 3.413-12.899 4.922-3.987 2.041-7.088 4.08-10.778 6.783-4.058 2.971-6.328 4.576-15.297 12.836-5.88 5.414-10.752 13.191-13.058 16.827"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M400.543 387.045c.339-1.527.788-7.246.761-10.21-.013-1.738-.317-3.398-.55-4.967-.22-1.471-.589-3.321-1.464-5.326-.854-1.956-2.52-6.254-5.375-11.487-2.043-3.744-4.688-7.008-7.55-10.124-2.507-2.73-5.912-5.977-8.084-7.731-1.628-1.316-3.466-3.263-6.22-5.276-1.585-1.159-3.825-2.777-6.85-4.33-2.214-1.137-5.313-2.614-9.379-3.614-.249-.06-.5-.122-.754-.174-1.96-.406-6.299-1.17-11.575-.744-5.873.474-10.236 2.2-13.638 3.276-5.338 1.689-9.362 3.365-12.298 4.905-3.725 1.953-6.726 3.93-10.314 6.567-5.066 3.723-7.219 5.447-15.962 13.635-7.092 6.64-12.748 15.795-15.408 20.174"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M403.425 385.539c.535-1.52 1.446-6.918 1.68-9.97.14-1.79-.037-3.494-.184-5.104-.147-1.608-.427-3.497-1.174-5.505-.68-1.828-2.116-6.372-4.904-11.944-2.074-4.144-4.716-7.534-7.429-10.681-2.534-2.94-6.075-6.49-8.072-8.217-1.669-1.444-3.61-3.594-6.6-5.877-1.632-1.247-4.025-3.06-7.327-4.822-2.31-1.233-5.638-2.91-10.086-4.034-.268-.067-.538-.135-.813-.194a42.789 42.789 0 0 0-12.52-.794c-6.39.55-11.073 2.508-14.7 3.75-4.985 1.709-8.773 3.316-11.7 4.89-3.463 1.86-6.363 3.779-9.85 6.35-6.07 4.48-8.103 6.322-16.626 14.433-8.288 7.886-14.743 18.4-17.758 23.522"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M406.849 384.532c.732-1.511 1.562-7.09 2.056-10.229.292-1.843.25-3.59.184-5.24-.068-1.745-.274-3.67-.885-5.685-.515-1.696-1.706-6.492-4.432-12.4-2.098-4.546-4.739-8.066-7.308-11.239-2.556-3.155-6.232-7.007-8.061-8.703-1.703-1.579-3.757-3.922-6.98-6.479-1.68-1.332-4.226-3.34-7.804-5.313-2.405-1.327-5.964-3.205-10.792-4.454-.288-.074-.578-.148-.874-.214-1.754-.389-6.912-1.452-13.463-.845-6.908.612-11.916 2.804-15.765 4.227-4.637 1.714-8.184 3.263-11.1 4.872-3.203 1.767-6 3.629-9.384 6.135-7.072 5.238-8.984 7.2-17.292 15.23-9.465 9.15-16.738 21.006-20.108 26.87"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M409.9 382.729c.928-1.504 2.052-6.464 2.805-9.692.445-1.896.538-3.682.552-5.376.016-1.88-.133-3.84-.597-5.864-.358-1.564-1.29-6.613-3.96-12.857-2.117-4.95-4.755-8.6-7.187-11.797-2.569-3.376-6.382-7.53-8.05-9.189-1.728-1.72-3.905-4.247-7.36-7.08-1.729-1.418-4.427-3.619-8.28-5.806-2.502-1.42-6.29-3.499-11.499-4.873-.307-.08-.617-.16-.934-.234-1.652-.378-7.218-1.584-14.407-.895-7.423.691-12.765 3.084-16.828 4.702-4.295 1.71-7.598 3.209-10.5 4.855-2.945 1.67-5.64 3.478-8.92 5.919-8.07 6.004-9.861 8.078-17.957 16.028-10.622 10.432-18.734 23.61-22.458 30.217"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M412.882 380.621c1.124-1.496 2.61-5.534 3.624-8.85.597-1.949.83-3.774.92-5.512a30.366 30.366 0 0 0-.309-6.044c-.21-1.431-.869-6.733-3.488-13.313-2.132-5.354-4.766-9.137-7.066-12.354-2.575-3.601-6.528-8.057-8.038-9.675-1.745-1.87-4.058-4.571-7.74-7.683-1.78-1.503-4.632-3.895-8.758-6.297-2.6-1.513-6.615-3.794-12.205-5.293a36.424 36.424 0 0 0-.995-.253c-1.55-.368-7.523-1.717-15.35-.947-7.94.77-13.625 3.346-17.892 5.178-3.959 1.699-7.013 3.15-9.9 4.838-2.689 1.572-5.278 3.328-8.456 5.703-9.064 6.774-10.736 8.957-18.622 16.827-11.759 11.733-20.729 26.215-24.808 33.564"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M415.866 377.834c1.32-1.487 3.166-3.925 4.44-7.33 1.649-4.405 1.478-8.13 1.268-11.87-.074-1.304-.445-6.853-3.017-13.77-2.141-5.759-4.771-9.675-6.945-12.912-2.571-3.83-6.666-8.583-8.027-10.161-1.748-2.028-4.211-4.892-8.12-8.284-1.83-1.588-4.835-4.171-9.234-6.79-2.853-1.698-7.437-4.38-13.967-5.985-1.447-.356-7.829-1.848-16.294-.998-8.456.85-14.495 3.587-18.955 5.654-6.71 3.11-10.59 5.275-17.292 10.308-10.053 7.55-11.608 9.836-19.287 17.625-12.873 13.057-22.724 28.82-27.158 36.912"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M215.638 250.186a102.445 102.445 0 0 0-21.948 24.608c-10.642 16.74-13.663 32.293-14.632 38.575-.993 6.436-2.572 20.886 1.33 37.244 6.453 27.048 24.136 43.572 40.57 58.527 28.042 25.518 55.688 37.257 75.82 44.561 22.345 8.107 44.966 14.107 71.164 16.073 26.584 1.995 54.104-3.007 65.077-15.145"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M215.538 250.485c-4.065 3.5-9.253 8.605-14.424 15.447a93.576 93.576 0 0 0-5.852 8.771 97.96 97.96 0 0 0-8.027 17.16c-3.157 8.915-4.492 16.241-4.898 20.24-.71 7.002-1.82 20.918 1.975 35.817 2.839 11.143 7.664 20.224 13.074 28.04 8.436 12.186 18.935 21.461 28.926 30.32 27.007 23.948 53.212 35.17 72.162 42.167 15.1 5.576 29.85 9.955 44.31 12.766a235.55 235.55 0 0 0 27.396 3.757c8.797.692 17.474.77 25.558.241 12.436-.812 22.97-3.313 30.272-7.04 3.458-1.761 6.56-4.75 8.972-7.398"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M215.438 250.784c-3.774 3.47-8.546 8.545-13.302 15.246-1.766 2.488-3.539 5.353-5.302 8.583a93.717 93.717 0 0 0-7.108 16.684c-2.682 8.502-3.893 15.513-4.11 19.54-.408 7.579-1.018 20.941 2.62 34.39 3.095 11.439 8.349 20.435 13.765 28.027 8.821 12.367 19.517 21.407 29.665 30.167 25.948 22.399 50.73 33.1 68.503 39.772 15.936 5.982 31.07 10.384 44.634 13.084 9.103 1.812 18.26 3.134 27.616 3.89 8.972.736 17.7.821 25.773.366 13.26-.747 23.808-3.48 30.566-6.923 3.367-1.708 7.693-5.44 10.206-8.181"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M215.338 251.084c-3.482 3.44-7.842 8.48-12.18 15.044-1.57 2.378-3.152 5.18-4.752 8.394a89.84 89.84 0 0 0-6.19 16.209c-2.222 8.08-3.28 14.787-3.321 18.84-.085 8.16-.171 20.955 3.265 32.962 3.36 11.738 9.039 20.643 14.455 28.016 9.215 12.543 20.095 21.357 30.405 30.012 24.866 20.873 48.242 31.046 64.845 37.378 16.769 6.394 32.282 10.837 44.958 13.402 9.306 1.883 18.538 3.244 27.834 4.023 9.148.78 17.929.878 25.989.49 14.086-.675 24.647-3.647 30.86-6.805 3.276-1.655 6.581-4.313 9.195-7.149"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M215.239 251.383c-3.192 3.41-7.144 8.409-11.058 14.842-1.378 2.266-2.77 5.005-4.202 8.207a86.409 86.409 0 0 0-5.272 15.732c-1.78 7.65-2.654 14.064-2.533 18.14.259 8.746.717 20.96 3.91 31.535 3.635 12.038 9.734 20.848 15.145 28.004 9.615 12.715 20.666 21.315 31.145 29.858 23.762 19.371 45.75 29.006 61.187 34.983 17.6 6.815 33.495 11.297 45.28 13.72 9.51 1.957 18.818 3.355 28.055 4.156 9.323.826 18.156.94 26.204.617 14.912-.6 25.486-3.815 31.155-6.69 3.184-1.602 7.064-4.369 9.78-7.298"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M215.139 251.682c-2.9 3.38-6.45 8.332-9.935 14.641-1.188 2.15-2.393 4.824-3.653 8.018-1.902 4.82-3.349 9.917-4.353 15.257-1.355 7.211-2.02 13.34-1.745 17.44.623 9.33 1.643 20.955 4.555 30.107 3.925 12.337 10.433 21.05 15.836 27.993 10.022 12.88 21.228 21.28 31.884 29.703 22.636 17.893 43.253 26.977 57.53 32.59 18.426 7.242 34.705 11.759 45.603 14.038 9.713 2.03 19.096 3.464 28.274 4.288 9.498.87 18.383 1.004 26.418.741 15.739-.515 26.325-3.98 31.45-6.571 3.094-1.55 7.524-4.418 10.342-7.441"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M215.04 251.982c-2.61 3.348-5.766 8.248-8.813 14.44-1 2.031-2.024 4.638-3.104 7.829-1.532 4.524-2.685 9.448-3.434 14.78-.951 6.768-1.377 12.615-.957 16.741 1.007 9.911 2.604 20.94 5.2 28.68 4.237 12.631 11.137 21.248 16.526 27.98 10.438 13.042 21.782 21.256 32.624 29.55 21.49 16.439 40.752 24.958 53.871 30.194 19.25 7.684 35.916 12.227 45.928 14.357 9.914 2.11 19.374 3.574 28.493 4.42 9.673.915 18.61 1.073 26.633.867 16.565-.425 27.159-4.157 31.744-6.454 3-1.503 6.611-3.974 9.53-7.091"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M215.638 250.186c-2.318 3.318-5.79 10.253-8.389 16.333-.817 1.912-1.664 4.45-2.554 7.641-1.177 4.224-2.037 8.977-2.515 14.305-.568 6.322-.728 11.887-.17 16.04 1.41 10.49 3.597 20.916 5.846 27.253 4.584 12.916 11.845 21.443 17.216 27.97 10.861 13.194 22.327 21.243 33.364 29.394 20.326 15.01 38.248 22.947 50.213 27.8 20.067 8.138 37.126 12.698 46.25 14.675 10.117 2.192 19.654 3.685 28.713 4.553 9.849.96 18.84 1.143 26.85.992 17.39-.328 27.997-4.324 32.037-6.337 2.909-1.45 6.621-3.809 9.642-7.02"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M214.84 252.58c-2.027 3.288-4.436 8.063-6.568 14.037-.64 1.79-1.32 4.258-2.005 7.453-.839 3.92-1.41 8.506-1.597 13.828-.205 5.877-.073 11.159.62 15.342 1.83 11.06 4.617 20.88 6.49 25.825 4.993 13.177 12.555 21.634 17.907 27.957 11.292 13.34 22.86 21.25 34.103 29.24 19.145 13.606 35.741 20.944 46.555 25.406 20.876 8.612 38.335 13.172 46.574 14.993 10.316 2.28 19.932 3.795 28.932 4.686 10.023 1.004 19.066 1.216 27.064 1.117 18.217-.226 28.84-4.482 32.333-6.22 2.82-1.391 6.888-3.976 10.01-7.28"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M214.74 252.88c-1.735 3.256-3.802 7.962-5.446 13.835-.466 1.668-.995 4.065-1.454 7.264-.52 3.618-.81 8.04-.679 13.353.135 5.436.585 10.427 1.407 14.642 2.268 11.625 5.663 20.833 7.136 24.397 5.531 13.385 13.27 21.824 18.597 27.945 11.732 13.48 23.38 21.276 34.842 29.086 17.95 12.229 33.232 18.948 42.898 23.012 21.674 9.11 39.542 13.65 46.898 15.31 10.514 2.375 20.21 3.906 29.15 4.82 10.2 1.048 19.295 1.302 27.28 1.241 19.043-.087 29.68-4.648 32.627-6.102 2.73-1.338 6.366-3.727 9.59-7.125"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M218.636 246.888c-2.998 3.298-7.194 14.154-8.319 19.925-.615 3.152-1.61 9.558-.665 19.952 1.76 19.364 8.557 33.943 9.976 36.912 6.416 13.425 13.985 22.01 19.287 27.934 12.18 13.608 23.885 21.33 35.582 28.931 16.742 10.878 30.719 16.957 39.24 20.617 22.456 9.646 40.75 14.132 47.221 15.63 23.22 5.374 42.067 6.318 56.865 6.318 19.869 0 30.518-4.815 32.921-5.986 2.639-1.284 6.514-3.557 9.84-7.049"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M245.702 358.665c10.004 5.405 23.403 10.664 30.458 13.563 8.776 3.607 15.684 5.905 19.953 7.316 8.207 2.713 14.98 4.952 24.275 6.984 12.265 2.68 21.916 3.469 28.599 3.99a237 237 0 0 0 22.28.665c7.278-.122 11.95-.22 18.29-1.33 6.344-1.11 11.452-2.004 17.292-5.32 3.75-2.13 9.239-5.247 12.478-11.744 2.858-5.73 2.472-11.095 2.153-15.525-.584-8.126-3.497-14.028-5.653-18.29-2.6-5.14-5.26-8.568-8.272-12.405a110.238 110.238 0 0 0-13.343-14.198"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M245.93 358.88c2.096 1.229 4.421 2.53 6.889 3.846 4.134 2.219 8.25 4.16 12.036 5.85a715.603 715.603 0 0 0 14.15 6.141c8.17 3.434 14.85 5.668 19.267 7.16 7.838 2.65 14.477 4.85 23.444 6.885 8.914 2.027 16.953 3.293 23.937 4.067 2.018.224 3.95.395 5.776.57 3.05.29 8.449.72 15.352.885 2.504.067 5.136.088 7.856.069 3.782-.027 6.814-.073 9.416-.218 3.275-.168 6.297-.474 9.66-1.042 2.08-.346 3.992-.682 5.81-1.067 4.435-.938 8.208-2.146 12.2-4.491 1.938-1.14 4.112-2.5 6.131-4.16 2.206-1.821 4.536-4.372 6.207-7.888.18-.375.347-.75.5-1.124 2.215-5.344 1.767-10.264 1.409-14.538-.634-7.557-3.294-13.21-5.403-17.457-2.431-4.849-4.96-8.166-7.795-11.898-3.138-4.13-7.588-9.473-13.771-15.006"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M246.159 359.096a242.965 242.965 0 0 0 7.365 4.445c4.61 2.674 9.014 4.875 12.965 6.72 5.068 2.368 10.494 4.868 15.36 6.945 7.574 3.234 14.018 5.428 18.583 7.005 7.47 2.578 13.973 4.748 22.612 6.785 8.624 2.042 16.969 3.62 24.826 4.61 2.005.252 4.017.455 6.002.673 3.314.365 8.907.847 15.963 1.097 2.669.095 5.408.142 8.172.147 4.12.006 7.323-.046 9.798-.169 3.511-.174 6.678-.478 10.063-1.022 2.205-.355 4.192-.698 6.05-1.09 4.879-1.027 8.73-2.314 12.678-4.705 2.074-1.256 4.223-2.72 6.095-4.299a23.17 23.17 0 0 0 6.59-9.193c2.135-5.375 1.6-10.253 1.178-14.66-.67-6.988-3.075-12.4-5.152-16.623-2.246-4.567-4.653-7.768-7.318-11.391-3.15-4.282-7.685-9.97-14.2-15.815"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M246.387 359.311a256.892 256.892 0 0 0 7.842 5.045c5.08 3.138 9.778 5.588 13.894 7.59 5.089 2.477 10.909 5.301 16.57 7.75 6.984 3.02 13.186 5.186 17.9 6.848 7.101 2.503 13.468 4.646 21.78 6.687 8.332 2.056 16.984 3.934 25.714 5.151 1.992.278 4.084.515 6.227.778 3.58.439 9.366.988 16.576 1.31 2.833.125 5.678.196 8.487.222 4.46.042 7.833-.01 10.18-.118 3.747-.173 7.06-.476 10.467-1.003 2.329-.36 4.39-.715 6.288-1.114 5.323-1.115 9.252-2.485 13.157-4.918 2.21-1.375 4.331-2.944 6.059-4.438 1.949-1.685 4.338-4.425 6-8.218.168-.384.327-.769.473-1.156 2.056-5.407 1.436-10.242.947-14.781-.69-6.42-2.864-11.585-4.9-15.79-2.073-4.279-4.344-7.374-6.842-10.884-3.159-4.437-7.781-10.468-14.628-16.623"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M246.616 359.527a239.795 239.795 0 0 0 8.319 5.644c5.543 3.613 10.543 6.299 14.822 8.46 5.111 2.583 11.325 5.731 17.78 8.553 6.399 2.797 12.354 4.944 17.215 6.693 6.737 2.423 12.965 4.544 20.948 6.588 8.043 2.071 17.002 4.239 26.604 5.694 1.98.3 4.151.574 6.453.881 3.844.513 9.824 1.132 17.187 1.522 2.997.159 5.95.253 8.803.3 4.798.079 8.343.025 10.563-.07 3.983-.17 7.44-.472 10.87-.981 2.453-.364 4.59-.733 6.526-1.139 5.768-1.203 9.772-2.66 13.637-5.13a48.767 48.767 0 0 0 6.022-4.578c1.818-1.62 4.245-4.449 5.896-8.383.163-.388.318-.778.46-1.172 1.976-5.439 1.275-10.231.717-14.903-.7-5.852-2.656-10.768-4.65-14.956-1.901-3.99-4.03-6.984-6.366-10.377-3.163-4.595-7.877-10.965-15.055-17.431"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M246.844 359.742a231.994 231.994 0 0 0 8.796 6.245c6.013 4.077 11.31 7.006 15.752 9.33 5.134 2.685 11.742 6.156 18.99 9.356 5.815 2.567 11.523 4.698 16.53 6.537 6.373 2.34 12.461 4.442 20.116 6.49 7.752 2.085 17.021 4.532 27.493 6.235 1.968.32 4.218.634 6.678.986 4.11.586 10.283 1.277 17.8 1.734 3.16.192 6.22.31 9.117.377 5.138.117 8.853.062 10.946-.02 4.22-.166 7.822-.469 11.274-.962 2.578-.368 4.788-.75 6.765-1.163 6.211-1.292 10.288-2.839 14.115-5.343 2.475-1.62 4.547-3.393 5.986-4.717 1.688-1.554 4.153-4.472 5.793-8.547.158-.393.308-.789.446-1.19 1.897-5.47 1.12-10.22.486-15.023-.698-5.286-2.449-9.952-4.4-14.123-1.73-3.7-3.71-6.596-5.888-9.87-3.163-4.756-7.974-11.463-15.484-18.24"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M247.073 359.958a222.452 222.452 0 0 0 9.273 6.844c6.482 4.542 12.076 7.713 16.68 10.2 5.16 2.786 12.163 6.576 20.2 10.16 5.234 2.333 10.693 4.45 15.846 6.381 6.01 2.252 11.957 4.34 19.284 6.39 7.462 2.101 17.042 4.817 28.382 6.779 1.956.338 4.285.694 6.904 1.089 4.374.66 10.741 1.425 18.41 1.947 3.326.226 6.492.369 9.434.454 5.476.157 9.363.1 11.328.029 4.456-.16 8.204-.464 11.678-.941a103.11 103.11 0 0 0 7.003-1.187c6.656-1.38 10.804-3.02 14.594-5.557 2.607-1.744 4.654-3.618 5.95-4.857 1.556-1.489 4.062-4.494 5.69-8.711.152-.397.298-.798.431-1.206 1.819-5.5.973-10.209.256-15.145-.685-4.72-2.243-9.134-4.149-13.289-1.563-3.409-3.387-6.21-5.411-9.364-3.159-4.92-8.07-11.96-15.912-19.047"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M247.301 360.173a213.368 213.368 0 0 0 9.75 7.444c6.952 5.007 12.845 8.418 17.609 11.07 5.185 2.885 12.587 6.988 21.41 10.964 4.654 2.096 9.865 4.198 15.162 6.225 5.648 2.161 11.453 4.239 18.452 6.292 7.17 2.116 17.066 5.089 29.272 7.32 1.944.356 4.351.754 7.128 1.193 4.64.735 11.2 1.574 19.023 2.16 3.49.26 6.762.428 9.75.53 5.813.2 9.872.139 11.71.079 4.691-.153 8.585-.458 12.08-.92a99.847 99.847 0 0 0 7.242-1.212c7.1-1.469 11.319-3.203 15.074-5.77 2.737-1.87 4.76-3.844 5.912-4.996 1.425-1.425 3.974-4.516 5.587-8.876.148-.401.29-.808.418-1.222 1.74-5.532.835-10.2.026-15.266-.664-4.156-2.041-8.315-3.899-12.456-1.398-3.117-3.061-5.828-4.934-8.857-3.148-5.09-8.167-12.457-16.34-19.856"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M247.53 360.389a205.461 205.461 0 0 0 10.226 8.043c7.422 5.472 13.614 9.121 18.538 11.94 5.212 2.982 13.016 7.39 22.62 11.768 4.075 1.857 9.038 3.943 14.478 6.07 5.288 2.066 10.95 4.136 17.62 6.192 6.88 2.13 17.091 5.351 30.16 7.863 1.934.372 4.42.813 7.355 1.297a238.041 238.041 0 0 0 19.635 2.371c3.653.303 7.032.488 10.064.608 6.153.243 10.383.177 12.092.128 4.929-.142 8.969-.446 12.485-.9a94.824 94.824 0 0 0 7.48-1.235c7.544-1.558 11.832-3.388 15.553-5.983 2.867-1.998 4.866-4.071 5.876-5.136 1.292-1.362 3.886-4.538 5.483-9.041.144-.405.28-.818.404-1.238 1.66-5.564.711-10.194-.204-15.387-.634-3.594-1.842-7.495-3.648-11.623-1.235-2.824-2.732-5.447-4.458-8.35-3.129-5.263-8.263-12.954-16.768-20.664"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M247.758 360.605a198.985 198.985 0 0 0 10.704 8.642c7.891 5.937 14.39 9.815 19.466 12.81 5.245 3.07 13.453 7.774 23.83 12.572a288.939 288.939 0 0 0 13.794 5.914 266.1 266.1 0 0 0 16.788 6.094c6.59 2.145 17.12 5.601 31.05 8.405 1.922.386 4.486.872 7.579 1.4a248.01 248.01 0 0 0 20.247 2.584c3.817.336 7.303.552 10.38.685 6.49.295 10.893.217 12.475.177 5.164-.13 9.35-.442 12.888-.88a93.681 93.681 0 0 0 7.719-1.259c7.988-1.646 12.343-3.574 16.032-6.196a34.518 34.518 0 0 0 5.839-5.275c1.157-1.3 3.806-4.557 5.38-9.206.14-.409.27-.827.39-1.255 1.582-5.594.609-10.191-.435-15.508-.595-3.034-1.648-6.672-3.397-10.789-1.074-2.53-2.399-5.068-3.98-7.843a86.585 86.585 0 0 0-17.197-21.472"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M247.987 360.82a193.746 193.746 0 0 0 11.18 9.242c8.361 6.402 15.157 10.523 20.396 13.68a278.386 278.386 0 0 0 25.04 13.375c5.254 2.474 15.526 7.11 29.065 11.754 6.3 2.16 17.15 5.842 31.94 8.947 5.104 1.072 15.419 3.071 28.662 4.3 12.693 1.179 21.434 1.033 23.553.99 10.259-.214 16.654-1.198 21.25-2.144 8.431-1.734 12.853-3.76 16.51-6.408 3.12-2.26 5.073-4.529 5.802-5.416 1.11-1.347 4.193-5.17 5.654-10.64 1.502-5.627.542-10.2-.665-15.63-.85-3.824-2.56-9.78-6.651-17.292-3.063-5.624-8.456-13.95-17.625-22.28"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M232.483 418.9a317.492 317.492 0 0 1-14.32-12.313c-6.284-5.735-10.839-9.92-16.227-16.158-3.712-4.298-7.519-8.747-11.52-15.46-4.902-8.222-7.312-15.17-8.091-17.528-.611-1.85-2.672-8.3-3.759-17.103-.397-3.214-1.176-10.885-.268-20.732a100.2 100.2 0 0 1 4.901-22.956 101.506 101.506 0 0 1 8.843-19.166c4.638-7.809 9.156-13.034 12.12-16.426 5.562-6.37 10.517-10.783 15.023-14.64a450.61 450.61 0 0 1 30.594-23.944c19.322-13.808 31.863-22.27 48.329-33.697a3028.636 3028.636 0 0 0 28.391-19.943"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M229.778 417.214a473.96 473.96 0 0 1-7.774-6.324c-2.466-2.047-4.904-4.168-7.383-6.332a278.593 278.593 0 0 1-4.65-4.134c-4.609-4.206-8.406-7.994-12.43-12.647-3.685-4.262-7.46-8.665-11.408-15.206a93.97 93.97 0 0 1-4.74-8.898 90.998 90.998 0 0 1-3.366-8.323c-.73-2.055-2.736-8.34-3.914-16.81a83.914 83.914 0 0 1-.61-5.827 102.745 102.745 0 0 1 0-14.585c.352-5.002 1.43-13.1 4.427-22.688 1.482-4.74 4.145-11.79 8.735-19.606a107.993 107.993 0 0 1 5.742-8.782c2.433-3.345 4.655-5.987 6.419-8.061 5.503-6.423 10.494-10.997 15.127-15.057 14.765-12.936 27.657-22.065 32.367-25.406 18.473-13.102 31.076-21.717 47.474-33.2 11.822-8.25 21.51-15.157 27.834-19.727"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M227.074 415.53a724.247 724.247 0 0 1-8.191-6.51c-2.752-2.213-5.304-4.386-7.803-6.492-2.251-1.898-3.621-3.08-4.913-4.239-5.019-4.506-9.027-8.552-13.02-13.163-3.659-4.227-7.4-8.583-11.296-14.954a94.044 94.044 0 0 1-4.732-8.738c-1.684-3.563-2.759-6.488-3.39-8.175-.85-2.26-2.81-8.38-4.068-16.518-.21-1.36-.48-3.31-.688-5.734a107.308 107.308 0 0 1-.266-14.356c.248-5.091 1.239-13.03 3.954-22.422 1.516-5.243 4.163-12.35 8.627-20.045a114.163 114.163 0 0 1 5.768-8.982c2.39-3.375 4.608-6.092 6.434-8.279 5.421-6.492 10.472-11.21 15.23-15.472 15.134-13.545 28.367-22.796 34.142-26.87 17.605-12.42 30.289-21.163 46.62-32.7 11.302-7.936 20.76-14.735 27.275-19.513"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M224.37 413.844a1138.2 1138.2 0 0 1-8.609-6.693c-3.038-2.38-5.71-4.598-8.222-6.653-2.605-2.131-3.932-3.244-5.176-4.344-5.432-4.804-9.648-9.11-13.609-13.68-3.634-4.191-7.344-8.5-11.186-14.7a93.947 93.947 0 0 1-4.723-8.58c-1.612-3.347-2.7-6.202-3.413-8.026-.97-2.464-2.895-8.42-4.224-16.225a83.618 83.618 0 0 1-.766-5.642 110.587 110.587 0 0 1-.53-14.128c.14-5.18 1.018-12.967 3.48-22.154 1.54-5.751 4.182-12.913 8.519-20.485a122.23 122.23 0 0 1 5.795-9.181c2.351-3.401 4.565-6.193 6.449-8.497 5.355-6.55 10.448-11.423 15.334-15.888 15.5-14.153 29.075-23.528 35.914-28.332 16.729-11.752 29.502-20.61 45.765-32.202 10.784-7.623 20.013-14.313 26.718-19.298"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M221.665 412.158c-2.425-1.83-5.488-4.17-9.025-6.876-3.326-2.545-6.12-4.805-8.642-6.814-2.963-2.36-4.244-3.408-5.44-4.45-5.848-5.096-10.268-9.667-14.198-14.195-3.608-4.157-7.285-8.42-11.074-14.449a93.697 93.697 0 0 1-4.716-8.419c-1.537-3.132-2.641-5.917-3.436-7.878-1.088-2.668-2.988-8.459-4.378-15.932-.265-1.422-.581-3.3-.846-5.55-.428-3.646-.824-8.39-.793-13.9.03-5.27.776-12.912 3.006-21.886 1.556-6.262 4.215-13.467 8.41-20.925a134.323 134.323 0 0 1 5.822-9.38c2.315-3.427 4.524-6.294 6.464-8.715 5.292-6.603 10.426-11.637 15.438-16.304 15.868-14.762 29.781-24.262 37.688-29.796 15.846-11.09 28.687-20.095 44.91-31.703 10.248-7.334 19.265-13.89 26.16-19.083"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M218.961 410.473c-2.487-1.847-5.7-4.256-9.442-7.06-3.615-2.709-6.534-5.009-9.061-6.975-3.325-2.585-4.558-3.57-5.704-4.555a139.527 139.527 0 0 1-14.788-14.711c-3.582-4.122-7.227-8.338-10.962-14.196-1.763-2.773-3.346-5.536-4.709-8.26-1.46-2.919-2.582-5.632-3.46-7.73-1.206-2.873-3.089-8.496-4.532-15.64a83.702 83.702 0 0 1-.924-5.457c-.484-3.597-.971-8.254-1.057-13.671-.086-5.362.515-12.863 2.531-21.619 1.56-6.777 4.235-14.03 8.304-21.365 1.937-3.493 3.917-6.656 5.848-9.58 2.279-3.45 4.483-6.393 6.479-8.932 5.23-6.655 10.402-11.85 15.54-16.72 16.236-15.37 30.487-24.998 39.462-31.259 14.96-10.435 27.898-19.545 44.055-31.205 9.729-7.021 18.518-13.468 25.603-18.868"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M216.257 408.788c-2.55-1.864-5.913-4.342-9.86-7.245-3.903-2.87-6.948-5.209-9.48-7.134-3.69-2.806-4.872-3.733-5.967-4.661-6.693-5.67-11.51-10.784-15.377-15.228-3.557-4.086-7.17-8.255-10.852-13.943-1.722-2.668-3.305-5.367-4.7-8.1-1.382-2.706-2.524-5.347-3.483-7.582-1.326-3.077-3.199-8.532-4.688-15.346a85.014 85.014 0 0 1-1.002-5.366c-.54-3.549-1.122-8.117-1.322-13.443-.204-5.452.242-12.815 2.058-21.351 1.552-7.294 4.252-14.593 8.196-21.805 1.93-3.532 3.921-6.756 5.874-9.779a133.072 133.072 0 0 1 6.494-9.15c5.173-6.705 10.38-12.064 15.645-17.136 16.602-15.978 31.19-25.738 41.235-32.722 14.071-9.783 27.11-18.992 43.2-30.706 9.21-6.707 17.77-13.046 25.045-18.653"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M213.553 407.102c-2.611-1.88-6.126-4.426-10.277-7.428-4.193-3.033-7.365-5.407-9.9-7.295-4.058-3.021-5.186-3.894-6.23-4.766-7.122-5.948-12.132-11.342-15.967-15.744-3.53-4.051-7.111-8.174-10.74-13.69-1.682-2.565-3.263-5.2-4.693-7.942-1.301-2.494-2.465-5.061-3.506-7.433-1.445-3.282-3.315-8.565-4.842-15.054a87.237 87.237 0 0 1-1.08-5.273c-.6-3.5-1.278-7.98-1.587-13.214-.327-5.542-.044-12.77 1.584-21.084 1.53-7.813 4.256-15.163 8.088-22.245 1.917-3.574 3.927-6.855 5.9-9.978a133.722 133.722 0 0 1 6.51-9.368c5.117-6.754 10.356-12.278 15.748-17.552 16.97-16.587 31.89-26.48 43.009-34.185a1796.865 1796.865 0 0 0 42.344-30.208c8.695-6.39 17.023-12.623 24.487-18.438"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M210.848 405.417a3957.775 3957.775 0 0 1-10.694-7.613c-4.487-3.187-7.782-5.604-10.32-7.455-4.428-3.232-5.5-4.055-6.493-4.871-7.556-6.22-12.752-11.9-16.556-16.26-3.504-4.017-7.053-8.092-10.629-13.438a92.406 92.406 0 0 1-4.685-7.782c-1.219-2.283-2.406-4.777-3.529-7.284-1.564-3.487-3.437-8.598-4.997-14.762a90.47 90.47 0 0 1-1.159-5.18c-.661-3.45-1.436-7.844-1.85-12.987-.454-5.631-.34-12.725 1.11-20.816 1.493-8.334 4.274-15.726 7.98-22.685 1.91-3.613 3.934-6.954 5.927-10.178 2.177-3.52 4.368-6.689 6.524-9.585 5.063-6.801 10.333-12.491 15.852-17.968 17.337-17.195 32.588-27.228 44.782-35.648 12.29-8.486 25.567-17.843 41.49-29.71 8.191-6.055 16.275-12.2 23.93-18.223"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M208.144 403.732c-2.735-1.915-6.555-4.59-11.111-7.797-4.775-3.35-8.2-5.8-10.74-7.616-4.803-3.437-5.815-4.214-6.756-4.977-7.998-6.482-13.373-12.458-17.146-16.776-3.478-3.98-6.994-8.01-10.517-13.185a92.658 92.658 0 0 1-4.677-7.623 109.94 109.94 0 0 1-3.552-7.135c-1.684-3.692-3.566-8.628-5.152-14.469a94.865 94.865 0 0 1-1.238-5.089c-.724-3.4-1.598-7.705-2.114-12.758-.586-5.72-.644-12.68.635-20.548 1.44-8.857 4.293-16.288 7.873-23.125 1.904-3.651 3.945-7.05 5.954-10.377a138.503 138.503 0 0 1 6.539-9.803c5.02-6.84 10.31-12.705 15.955-18.384 17.704-17.803 33.269-28 46.556-37.111 11.386-7.857 24.78-17.29 40.634-29.211a1028.293 1028.293 0 0 0 23.372-18.008"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M205.44 402.046a6085.898 6085.898 0 0 1-11.528-7.98c-15.395-10.685-16.856-11.804-18.18-12.859-8.446-6.735-13.994-13.016-17.735-17.292-5.005-5.721-10.077-11.518-15.075-20.396a100.566 100.566 0 0 1-10.198-26.16c-1.715-7.267-4.287-18.63-2.217-32.81 2.122-14.535 8.018-24.48 13.745-34.141 6.756-11.396 14.213-20.262 22.613-28.82 18.072-18.413 33.971-28.74 48.33-38.575 15.264-10.456 36.831-25.865 62.593-46.506M378.524 378.768c-4.613.181-9.948.764-12.8 1.33-3.812.758-7.203 1.432-11.268 3.35-3.926 1.853-7.56 4.631-9.435 6.294"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M378.109 377.157c-1.03-.162-3.268-.425-4.451-.594-1.207-.172-2.39-.341-4.854-.489-1.033-.062-2.386.025-3.858.166-1.661.16-3.063.488-4.235.75-4.054.906-7.563 1.713-11.521 3.641-2.116 1.03-3.866 2.132-5.607 3.355-1.82 1.271-5.098 4.42-6.225 5.417"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M377.11 375.618c-1.162-.36-3.74-1.547-6.11-1.963-.568-.1-3.243-.53-5.04-.684a32.205 32.205 0 0 0-4.894-.044c-2.187.15-3.957.612-5.369.954-4.298 1.04-7.919 2.006-11.773 3.933-2.375 1.188-4.254 2.43-6.343 3.933-2.086 1.49-6.135 5.524-7.401 6.64"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M375.864 373.572c-1.297-.557-4.44-1.899-6.318-2.577-1.68-.607-4.311-.9-6.431-1.128-1.098-.118-3.277-.394-5.93-.253-2.712.145-4.85.734-6.501 1.158-4.544 1.166-8.272 2.304-12.026 4.225-2.634 1.348-4.642 2.729-7.078 4.511-2.352 1.707-7.338 6.301-8.742 7.537"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M374.118 371.244c-1.43-.755-5.287-1.473-7.51-2.416-1.919-.815-3.805-1.692-6.338-2.064-1.13-.166-3.722-.602-6.965-.463-3.238.14-5.744.854-7.635 1.362-4.791 1.286-8.622 2.608-12.278 4.518-2.89 1.51-5.03 3.026-7.814 5.088-2.618 1.925-7.53 6.337-9.073 7.692"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M370.821 369.777c-1.563-.952-3.605-2.26-6.169-3.472-2.16-1.021-4.284-2.115-7.227-2.644-1.163-.21-4.167-.81-8-.673-3.765.134-6.638.973-8.768 1.566-5.04 1.404-8.971 2.915-12.531 4.81-3.147 1.674-5.417 3.324-8.55 5.666-2.883 2.144-7.707 6.712-9.389 8.187"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M371.707 368.584c-1.696-1.15-6.107-3.32-9.01-4.8-2.404-1.228-4.767-2.526-8.116-3.226-1.199-.25-4.613-1.008-9.037-.883-4.29.137-7.532 1.09-9.9 1.77-5.29 1.518-9.319 3.225-12.784 5.102-3.401 1.842-5.805 3.622-9.285 6.243-3.15 2.363-7.97 7.002-9.79 8.597"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M368.337 366.181c-1.83-1.347-4.354-3.168-7.596-4.92-2.648-1.432-5.254-2.925-9.005-3.807-1.234-.29-5.058-1.216-10.072-1.092-4.816.131-8.428 1.206-11.034 1.974-5.539 1.632-9.664 3.536-13.036 5.394-3.654 2.013-6.193 3.92-10.02 6.821-3.416 2.58-8.314 7.019-10.273 8.733"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M367.095 364.383c-1.963-1.545-4.73-3.62-8.309-5.644-2.894-1.637-5.745-3.316-9.895-4.388-1.271-.329-5.503-1.424-11.107-1.302-5.342.125-9.324 1.321-12.168 2.178-5.788 1.744-10.009 3.85-13.288 5.686-3.904 2.187-6.58 4.219-10.756 7.4-3.681 2.798-7.744 7.01-9.841 8.844"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M365.853 362.585c-2.096-1.742-5.107-4.072-9.023-6.368-3.139-1.841-6.24-3.697-10.783-4.97-1.31-.366-5.95-1.631-12.144-1.51-5.867.118-10.22 1.43-13.3 2.381-6.043 1.845-10.354 4.164-13.541 5.978-4.153 2.364-6.969 4.517-11.491 7.977-3.948 3.017-8.754 6.625-10.99 8.58"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M364.611 360.786a69.927 69.927 0 0 0-9.736-7.092c-3.385-2.045-6.738-4.07-11.673-5.55-1.349-.404-6.395-1.84-13.18-1.72-6.392.112-11.114 1.548-14.433 2.585-6.29 1.966-10.696 4.48-13.793 6.27-4.4 2.545-7.356 4.815-12.227 8.555a204.482 204.482 0 0 0-9.972 8.167M240.692 425.05a111.223 111.223 0 0 0-9.536 23.552c-.602 2.177-3.233 11.941-3.99 26.603-.468 9.06-1.22 26.45 4.877 47.443 5.066 17.447 12.505 29.264 18.179 38.131 13.808 21.577 28.681 34.7 40.792 45.226 12.347 10.731 41.794 30.874 66.244 43.52"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M244.965 428.687c-2.628 4.897-5.189 10.485-7.777 18.692A125.591 125.591 0 0 0 236.11 451c-.708 2.509-3.298 12.067-4.117 26.22-.06 1.007-.12 2.11-.18 3.3-.545 10.607-.292 26.315 4.62 43.547 4.812 16.886 11.812 28.453 17.217 37.128 1.31 2.104 2.62 4.125 3.946 6.052 11.453 16.641 23.956 28.312 34.88 38.314 8.923 8.21 25.673 20.211 42.62 30.82 7.118 4.456 14.243 8.674 20.903 12.207"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M249.42 432.018c-2.579 4.88-4.711 9.672-7.286 17.812a140.981 140.981 0 0 0-1.07 3.569c-.815 2.84-3.332 12.193-4.244 25.837-.067 1-.132 2.088-.203 3.255-.704 11.566-.209 27.18 4.205 42.995 4.557 16.326 11.12 27.64 16.256 36.125 1.246 2.06 2.479 4.035 3.738 5.902 10.327 15.31 22.201 27.056 33.124 37.605 9.056 8.746 25.026 20.34 40.742 30.45 6.921 4.453 13.749 8.642 20.058 12.082"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M254.524 434.082c-2.529 4.864-4.883 10.126-7.444 18.2a156.941 156.941 0 0 0-1.062 3.515c-.923 3.17-3.387 12.32-4.371 25.455-.075.994-.146 2.066-.226 3.21-.872 12.525-.133 28.048 3.79 42.442 4.299 15.769 10.428 26.83 15.294 35.122 1.182 2.015 2.34 3.946 3.532 5.754 9.21 13.97 20.43 25.816 31.366 36.895 9.177 9.296 24.374 20.481 38.864 30.08 6.724 4.455 13.256 8.611 19.213 11.957"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M259.276 436.836c-2.48 4.848-4.702 9.89-7.25 17.897a173.92 173.92 0 0 0-1.053 3.463c-1.033 3.5-3.447 12.446-4.5 25.071-.081.988-.16 2.045-.247 3.167-1.05 13.483-.066 28.917 3.375 41.89 4.036 15.211 9.736 26.017 14.332 34.118 1.117 1.97 2.2 3.855 3.324 5.605 8.109 12.62 18.657 24.579 29.61 36.184 9.295 9.85 23.713 20.638 36.985 29.71 6.525 4.461 12.763 8.58 18.368 11.833"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M264.093 439.462c-2.43 4.833-4.587 9.783-7.12 17.722-.342 1.07-.688 2.209-1.046 3.41-1.143 3.83-3.51 12.572-4.626 24.689-.09.98-.177 2.023-.271 3.122-1.236 14.44-.007 29.79 2.96 41.337 3.768 14.658 9.044 25.206 13.371 33.116 1.053 1.925 2.061 3.763 3.117 5.456 7.02 11.258 16.88 23.345 27.852 35.474 9.412 10.405 23.044 20.809 35.107 29.34 6.323 4.472 12.27 8.55 17.524 11.708"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M269.383 442.167c-2.381 4.817-4.944 9.596-7.465 17.469a212.074 212.074 0 0 0-1.037 3.357c-1.254 4.16-3.577 12.697-4.753 24.305-.099.975-.194 2.002-.294 3.078-1.432 15.398.042 30.666 2.546 40.785 3.491 14.106 8.35 24.395 12.409 32.113.988 1.88 1.924 3.67 2.909 5.306 5.951 9.885 15.1 22.114 26.095 34.764 9.527 10.963 22.365 20.996 33.229 28.97 6.117 4.49 11.778 8.52 16.68 11.584"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M273.613 444.943c-2.332 4.801-4.242 9.338-6.749 17.144-.327 1.02-.67 2.124-1.03 3.304-1.366 4.49-3.647 12.822-4.879 23.923-.108.968-.21 1.98-.316 3.034-1.64 16.353.079 31.544 2.13 40.232 3.203 13.557 7.66 23.583 11.448 31.11.923 1.836 1.79 3.575 2.701 5.157 4.902 8.498 13.32 20.884 24.338 34.054 9.639 11.522 21.675 21.198 31.35 28.6 5.905 4.517 11.286 8.488 15.836 11.459"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M278.913 446.54c-2.282 4.785-4.61 10.26-7.103 17.998-.32.997-.662 2.082-1.021 3.251a134.62 134.62 0 0 0-5.007 23.54c-.117.962-.228 1.96-.34 2.99-1.857 17.307.104 32.426 1.717 39.68 2.894 13.013 6.966 22.771 10.486 30.106.859 1.792 1.659 3.479 2.494 5.009 3.875 7.098 11.515 19.671 22.58 33.344 9.731 12.096 20.971 21.416 29.473 28.23 5.683 4.554 10.792 8.457 14.99 11.334"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M283.69 449.226c-2.232 4.77-4.454 10.092-6.934 17.764-.314.972-.655 2.039-1.013 3.198-1.602 5.145-3.82 13.068-5.134 23.156-.128.956-.246 1.938-.362 2.946-2.088 18.26.113 33.31 1.302 39.127 2.55 12.478 6.274 21.96 9.524 29.104.794 1.747 1.536 3.378 2.286 4.86 2.878 5.683 9.739 18.437 20.823 32.633 9.847 12.652 20.252 21.652 27.595 27.86 5.448 4.608 10.299 8.426 14.146 11.21"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M288.468 451.912c-2.183 4.754-4.3 9.924-6.766 17.53-1.917 5.911-5.07 15.803-6.65 28.82-2.332 19.21.104 34.196.886 38.574 2.659 14.878 7.347 25.486 10.642 32.811 1.915 4.258 7.96 17.203 19.065 31.924 9.963 13.207 19.515 21.9 25.717 27.49a223.329 223.329 0 0 0 13.302 11.085M305.055 456.597c-.42 5.728-.577 12.96.147 21.269.216 2.477.864 9.116 2.66 17.292 1.285 5.848 5.014 20.932 14.632 38.575 3.083 5.654 9.661 16.873 23.5 32.367 19.76 22.124 39.068 35.882 48.772 42.565 64.24 44.238 132.337 70.864 157.847 80.253 3.169 1.167 32.741 11.933 71.385 20.396 5.442 1.192 20.89 4.49 41.235 5.764 19.227 1.205 29.764-.217 38.132-2.217a104.945 104.945 0 0 0 17.292-5.764"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M303.448 456.015c-.49 4.27-.93 9.454-.953 15.363-.008 2.033.062 4.182.113 6.442.064 2.834.478 9.568 1.95 17.856.113.636.262 1.36.404 2.174 1.074 6.155 3.401 15.161 7.389 24.946a167.029 167.029 0 0 0 5.949 13.037c1.427 2.791 3.41 6.43 6.239 10.805 3.669 5.646 9.204 13.638 17.42 23.009 17.048 19.445 33.846 32.138 43.983 39.4 1.1.784 2.122 1.504 3.059 2.16 13.68 9.592 27.393 18.162 40.754 25.901 48.47 28.126 93.24 45.473 111.817 52.874 3.738 1.49 22.759 8.758 49.723 16.361 8.243 2.325 16.875 4.508 25.67 6.617 4.172 1 11.049 2.497 19.688 3.89 7.394 1.191 15.446 2.233 24.003 2.846 3.441.246 6.545.401 9.388.478 15.163.43 24.299-1.14 31.104-2.835a101.365 101.365 0 0 0 17.957-6.34"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M301.841 455.432c-.67 4.305-1.379 9.615-1.657 15.731-.093 2.053-.097 4.261-.17 6.612-.1 3.193.078 10.025 1.24 18.42.092.669.223 1.418.328 2.251.927 7.334 3.207 16.743 6.723 25.91 1.719 4.483 3.61 9.04 5.8 13.578a113.063 113.063 0 0 0 6.216 11.261c3.46 5.495 9.032 14.047 17.603 23.999 16.319 18.947 32.467 31.212 42.363 38.437 1.055.765 2.04 1.47 2.948 2.118 13.325 9.519 26.529 17.833 39.332 25.322 47.151 27.682 90.648 44.785 107.965 51.976 5.011 2.08 24.626 9.93 52.327 18.188 8.972 2.675 18.077 5.082 27.075 7.371 5.182 1.319 12.402 2.928 20.78 4.382 8.355 1.45 16.786 2.641 25.365 3.325 3.707.295 6.977.477 9.933.567 16.521.532 26.294-1.347 32.919-3.062 7.975-2.065 14.3-4.815 18.622-6.917"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M300.234 454.85c-.85 4.34-1.821 9.775-2.36 16.098-.177 2.072-.266 4.341-.454 6.782-.274 3.553-.335 10.486.529 18.982.071.704.18 1.48.254 2.33.743 8.523 2.977 18.342 6.056 26.874 1.717 4.76 3.536 9.5 5.652 14.12 1.602 3.493 3.582 7.438 6.192 11.716 3.26 5.339 8.865 14.452 17.786 24.99 15.607 18.433 31.072 30.306 40.743 37.474 1.008.747 1.958 1.436 2.838 2.075 12.969 9.445 25.664 17.504 37.909 24.744 45.833 27.236 88.015 44.2 104.112 51.076 6.282 2.683 26.488 11.126 54.931 20.016 9.701 3.032 19.274 5.678 28.48 8.125 6.191 1.646 13.754 3.376 21.874 4.875 9.313 1.718 18.125 3.054 26.726 3.803 3.972.347 7.408.552 10.477.655 17.88.634 28.288-1.559 34.735-3.289 8.29-2.225 14.829-5.216 19.287-7.493"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M298.628 454.268c-1.031 4.375-2.259 9.935-3.064 16.465-.258 2.091-.442 4.42-.738 6.952-.458 3.914-.76 10.948-.182 19.545.05.738.132 1.54.18 2.407.525 9.718 2.717 19.954 5.39 27.84 1.707 5.04 3.453 9.962 5.503 14.659 1.68 3.85 3.671 7.941 6.169 12.172 3.06 5.182 8.703 14.851 17.968 25.98 14.91 17.908 29.69 29.384 39.123 36.513.963.727 1.875 1.402 2.727 2.033 12.613 9.37 24.8 17.174 36.486 24.164 44.516 26.792 85.361 43.665 100.261 50.177 7.547 3.298 28.344 12.34 57.535 21.844 10.428 3.395 20.467 6.287 29.884 8.88a313.494 313.494 0 0 0 22.967 5.366c10.271 1.998 19.464 3.472 28.088 4.283 4.238.399 7.84.627 11.022.742 19.24.737 30.281-1.775 36.55-3.516 8.603-2.39 15.357-5.617 19.952-8.07"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M297.02 453.685c-1.21 4.41-2.69 10.096-3.766 16.832-.338 2.112-.624 4.5-1.022 7.123-.65 4.273-1.193 11.412-.892 20.108.026.773.081 1.6.104 2.485.275 10.912 2.432 21.576 4.723 28.803 1.69 5.326 3.366 10.43 5.356 15.2 1.755 4.209 3.762 8.443 6.145 12.629 2.862 5.024 8.549 15.244 18.152 26.97 14.224 17.37 28.308 28.46 37.502 35.55.918.708 1.793 1.368 2.616 1.99 12.258 9.297 23.936 16.846 35.064 23.586 43.197 26.347 82.694 43.16 96.409 49.278 8.805 3.928 30.195 13.569 60.139 23.672 11.152 3.763 21.658 6.903 31.287 9.633a334.27 334.27 0 0 0 24.062 5.86c11.226 2.289 20.802 3.892 29.449 4.761 4.504.453 8.272.702 11.567.83 20.597.839 32.273-1.994 38.365-3.743 8.916-2.558 15.886-6.019 20.617-8.646"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M295.414 453.103c-1.392 4.445-3.117 10.257-4.47 17.2-.416 2.13-.809 4.577-1.307 7.292-.849 4.63-1.635 11.876-1.602 20.672.003.806.03 1.66.03 2.562-.008 12.104 2.123 23.206 4.057 29.767 1.655 5.617 3.272 10.897 5.207 15.742 1.824 4.568 3.853 8.942 6.121 13.083 2.666 4.865 8.403 15.632 18.335 27.961 13.551 16.823 26.929 27.533 35.882 34.588.872.687 1.71 1.334 2.506 1.948 11.901 9.223 23.071 16.516 33.64 23.006 41.88 25.903 80.02 42.671 92.557 48.38 10.056 4.577 32.043 14.808 62.743 25.499 11.876 4.135 22.848 7.525 32.692 10.387 9.206 2.676 17.798 4.786 25.155 6.352 12.18 2.593 22.14 4.316 30.811 5.24 4.769.51 8.704.778 12.111.918 21.957.941 34.265-2.217 40.18-3.97 9.228-2.732 16.415-6.42 21.284-9.222"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M293.807 452.52c-1.572 4.48-3.539 10.42-5.174 17.567-.492 2.151-.996 4.655-1.59 7.463-1.055 4.985-2.086 12.338-2.312 21.235-.022.84-.024 1.72-.046 2.64-.318 13.293 1.794 24.841 3.39 30.731 1.604 5.913 3.176 11.366 5.06 16.283a126.312 126.312 0 0 0 6.098 13.538c2.47 4.706 8.265 16.012 18.517 28.953 12.888 16.268 25.552 26.603 34.263 33.625.827.667 1.628 1.3 2.394 1.905 11.546 9.149 22.207 16.186 32.218 22.428 40.561 25.457 77.34 42.193 88.705 47.48 11.293 5.251 33.886 16.057 65.347 27.327a648.542 648.542 0 0 0 34.096 11.141c10.206 3.033 19.143 5.27 26.249 6.845 13.128 2.91 23.478 4.741 32.172 5.72 5.034.565 9.135.852 12.656 1.004 23.315 1.044 36.255-2.443 41.996-4.196 9.537-2.912 16.942-6.822 21.948-9.799"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M292.2 451.938c-1.752 4.516-3.956 10.585-5.877 17.934-.568 2.172-1.185 4.73-1.874 7.633-1.266 5.337-2.543 12.8-3.023 21.798-.047.874-.079 1.78-.121 2.717-.656 14.48 1.447 26.481 2.725 31.696 1.523 6.216 3.075 11.836 4.91 16.823a135.55 135.55 0 0 0 6.075 13.995c2.278 4.544 8.138 16.384 18.7 29.943 12.235 15.706 24.177 25.671 32.643 32.663.782.646 1.545 1.265 2.284 1.862 11.19 9.075 21.342 15.857 30.794 21.849 39.244 25.012 74.654 41.723 84.854 46.58 12.514 5.96 35.725 17.315 67.95 29.156a646.458 646.458 0 0 0 35.501 11.895c11.204 3.397 20.486 5.758 27.342 7.337 14.074 3.243 24.816 5.17 33.534 6.198 5.299.626 9.567.928 13.2 1.093 24.675 1.146 38.245-2.672 43.812-4.423 9.844-3.097 17.47-7.224 22.613-10.375"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M290.593 451.356c-1.932 4.55-4.37 10.752-6.58 18.3a268.388 268.388 0 0 0-2.158 7.803c-1.481 5.69-3.006 13.26-3.733 22.362-.073.908-.134 1.84-.197 2.795-1.02 15.66 1.084 28.121 2.06 32.66 1.402 6.525 2.971 12.306 4.761 17.364 2.002 5.657 4.148 10.435 6.051 14.45 2.097 4.379 8.023 16.748 18.883 30.934 11.59 15.139 22.814 24.725 31.023 31.7.738.625 1.463 1.231 2.173 1.82 10.834 9.001 20.479 15.528 29.372 21.27 37.925 24.568 71.963 41.258 81.001 45.681 13.713 6.712 37.546 18.623 70.555 30.983a630.095 630.095 0 0 0 36.905 12.65c12.2 3.766 21.828 6.25 28.436 7.83 15.014 3.592 26.15 5.61 34.895 6.677 5.562.693 9.999 1.003 13.745 1.18 26.033 1.248 40.234-2.902 45.627-4.65 10.15-3.288 17.999-7.625 23.278-10.951"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M288.986 450.773a168.592 168.592 0 0 0-7.284 18.668c-2.256 6.981-5.871 18.399-7.156 33.77-1.407 16.835.704 29.759 1.392 33.625 2.649 14.878 7.331 25.46 10.642 32.811 1.9 4.22 7.92 17.101 19.065 31.924 10.954 14.567 21.435 23.799 29.403 30.739 11.348 9.884 21.134 16.618 30.012 22.467 36.607 24.123 69.267 40.795 77.149 44.783 14.878 7.526 39.397 19.846 73.159 32.81 32.916 12.64 56.313 18.865 67.838 21.726 26.552 6.593 40.882 7.948 50.547 8.425 27.391 1.35 42.22-3.136 47.442-4.878a105.746 105.746 0 0 0 23.943-11.528"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M366.954 586.997c9.887 6.243 16.974 11.528 34.432 21.765 13.493 7.91 22.8 12.302 37.079 18.788 4.523 2.055 26.881 12.163 53.182 22.683 17.372 6.949 35.909 14.363 61.852 20.95 16.2 4.112 27.905 6.028 43.896 8.646 14.32 2.344 23.16 3.322 33.586 3.325 12.622.004 20.165-1.422 22.946-1.995a97.926 97.926 0 0 0 21.948-7.316"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M367.987 587.87c4.783 3.09 9.145 6.093 14.39 9.553 5.06 3.316 11.709 7.593 21.474 13.337 1.596.939 3.154 1.84 4.683 2.712 10.8 6.138 20.341 10.785 33.977 17.062 4.981 2.296 25.946 11.784 50.356 21.583 17.1 6.91 34.903 13.746 58.53 20.065 14.756 3.946 26.076 6.373 37.752 8.465 2.669.478 5.43 1 8.343 1.52 7.466 1.328 13.74 2.321 19.773 3.01 5.33.608 10.287.927 15.607 1.024 4.552.071 8.56-.021 12.04-.223 6.126-.355 10.128-1.027 12.194-1.394a85.212 85.212 0 0 0 4.496-.94 96.027 96.027 0 0 0 18.75-6.475"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M369.021 588.744c4.791 3.165 9.386 6.394 14.937 10.067 4.807 3.18 11.856 7.753 22.357 13.948 1.647.97 3.27 1.913 4.88 2.834 10.396 5.92 20.733 11.115 35.362 17.925 5.439 2.537 25.032 11.356 47.53 20.484 16.843 6.834 33.874 13.225 55.208 19.18 16.11 4.496 28.418 7.46 39.546 9.59 2.79.533 5.68 1.145 8.75 1.732 7.533 1.442 14.147 2.583 20.765 3.428 5.563.711 10.807 1.136 16.407 1.316 4.68.15 8.895.127 12.67-.021 6.337-.25 10.525-.858 12.853-1.218a79.891 79.891 0 0 0 4.742-.904 95.327 95.327 0 0 0 15.53-4.769 98.086 98.086 0 0 0 4.273-1.842"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M370.055 589.617c4.8 3.241 9.633 6.688 15.482 10.582 4.562 3.037 12.006 7.913 23.242 14.558a465.047 465.047 0 0 0 5.077 2.956c9.992 5.703 21.126 11.445 36.747 18.789 5.897 2.778 24.104 10.961 44.703 19.385 16.578 6.779 32.828 12.778 51.886 18.294 17.467 5.055 30.758 8.565 41.341 10.715 2.91.592 5.93 1.288 9.155 1.946 7.603 1.55 14.556 2.84 21.759 3.846 5.796.81 11.327 1.335 17.206 1.607 4.81.222 9.232.273 13.299.18 6.55-.15 10.924-.69 13.513-1.04 1.804-.245 3.442-.559 4.988-.87a95.408 95.408 0 0 0 20.856-6.746"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M371.089 590.49c4.808 3.317 9.88 6.98 16.028 11.097 4.317 2.891 12.155 8.074 24.126 15.169 1.75 1.035 3.505 2.06 5.274 3.078 9.587 5.485 21.518 11.775 38.132 19.652 6.354 3.02 23.174 10.572 41.877 18.286 16.311 6.726 31.767 12.387 48.564 17.408 18.822 5.627 33.095 9.682 43.135 11.841 3.03.652 6.181 1.43 9.56 2.159 7.674 1.656 14.965 3.093 22.753 4.263 6.03.906 11.847 1.533 18.006 1.899 4.938.293 9.568.416 13.927.381 6.762-.054 11.323-.524 14.174-.863 1.917-.228 3.629-.533 5.234-.834 7.532-1.412 13.528-3.463 17.182-4.897a99.444 99.444 0 0 0 4.726-1.984"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M372.123 591.364c4.817 3.392 10.13 7.27 16.573 11.611 4.074 2.744 12.305 8.234 25.01 15.78 1.801 1.067 3.623 2.133 5.472 3.2 9.183 5.267 21.91 12.105 39.517 20.515 6.812 3.26 22.241 10.19 39.051 17.186 16.044 6.678 30.693 12.042 45.242 16.524 20.173 6.213 35.43 10.81 44.93 12.966 3.15.715 6.431 1.57 9.966 2.372 7.743 1.757 15.373 3.344 23.745 4.68 6.264 1 12.367 1.73 18.805 2.19 5.067.363 9.905.559 14.557.584 6.973.038 11.721-.36 14.834-.687 2.03-.213 3.816-.507 5.48-.799 8.066-1.414 14.396-3.565 18.008-4.96 1.95-.753 3.63-1.46 4.953-2.056"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M373.156 592.238c4.827 3.467 10.38 7.557 17.12 12.125 3.83 2.596 12.454 8.395 25.895 16.39a565 565 0 0 0 5.668 3.323c8.78 5.05 22.302 12.434 40.902 21.378 7.27 3.502 21.306 9.814 36.225 16.087 15.774 6.633 29.608 11.733 41.92 15.638 21.519 6.826 37.762 11.95 46.724 14.092 3.269.78 6.683 1.708 10.371 2.584 7.815 1.857 15.784 3.593 24.74 5.098 6.497 1.093 12.886 1.926 19.604 2.483 5.196.43 10.24.697 15.185.784 7.186.127 12.12-.197 15.494-.51 2.142-.199 4.004-.48 5.726-.763 8.603-1.414 15.267-3.666 18.834-5.024a100.93 100.93 0 0 0 5.18-2.127"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M374.19 593.111c4.835 3.543 10.632 7.844 17.666 12.64 3.588 2.447 12.603 8.555 26.78 17a595.156 595.156 0 0 0 5.864 3.446c8.375 4.831 22.694 12.764 42.287 22.24 7.727 3.744 20.368 9.446 33.399 14.989 15.502 6.594 28.515 11.453 38.597 14.752 22.852 7.48 40.094 13.1 48.519 15.218 3.387.85 6.934 1.845 10.777 2.797 7.886 1.954 16.193 3.839 25.732 5.515a259.09 259.09 0 0 0 20.404 2.774c5.327.488 10.577.835 15.815.987 7.397.214 12.517-.036 16.154-.334a82.021 82.021 0 0 0 5.971-.728c9.139-1.41 16.137-3.766 19.661-5.088a101.432 101.432 0 0 0 5.406-2.198"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M375.224 593.984c4.844 3.619 10.885 8.128 18.211 13.155 3.347 2.297 12.753 8.715 27.664 17.611a626.99 626.99 0 0 0 6.062 3.568c7.971 4.613 23.086 13.093 43.672 23.104 8.185 3.984 19.427 9.083 30.573 13.888 15.226 6.566 27.413 11.197 35.274 13.868 24.161 8.206 42.422 14.256 50.314 16.342 3.503.927 7.186 1.982 11.183 3.01 7.959 2.05 16.607 4.066 26.725 5.934 6.97 1.26 13.93 2.302 21.204 3.065 5.455.557 10.913.97 16.443 1.188 7.61.3 12.916.126 16.814-.157a84.698 84.698 0 0 0 6.218-.693c9.675-1.404 17.007-3.864 20.487-5.15a101.714 101.714 0 0 0 5.632-2.27"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M376.258 594.858c4.852 3.694 11.149 8.395 18.757 13.67 3.109 2.14 12.901 8.875 28.548 18.22a655.917 655.917 0 0 0 6.259 3.69c7.567 4.396 23.478 13.424 45.057 23.968 8.643 4.225 18.482 8.728 27.746 12.79 14.945 6.55 26.304 10.96 31.953 12.981 25.412 9.09 44.747 15.42 52.108 17.468 3.618 1.007 7.44 2.112 11.589 3.224 8.034 2.13 17.016 4.316 27.718 6.35 7.204 1.356 14.45 2.498 22.003 3.357 5.585.627 11.251 1.096 17.073 1.39 7.823.371 13.313.28 17.474.02a88.236 88.236 0 0 0 6.463-.658c10.213-1.384 17.88-3.958 21.313-5.215a99.013 99.013 0 0 0 5.86-2.341"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M377.292 595.731c4.861 3.77 11.399 8.684 19.302 14.185 3.225 2.244 15.722 10.881 35.889 22.644 7.163 4.177 23.87 13.752 46.442 24.83 27.148 13.323 48.364 21.745 53.55 23.786 26.487 10.423 47.07 16.59 53.904 18.594 10.757 3.154 23.428 6.835 40.705 10.204 12.864 2.509 26.008 4.401 40.505 5.24 12.747.737 19.557.256 24.843-.426 10.747-1.386 18.75-4.06 22.139-5.279 2.52-.906 4.6-1.766 6.086-2.412"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M153.09 237.313a211.64 211.64 0 0 1 15.54-17.504c4.65-4.69 12.112-11.774 26.074-22.441 11.042-8.436 10.771-7.364 30.189-21.086 18.287-12.922 32.524-23.764 42.073-31.215 4.485-3.5 9.622-7.552 12.242-9.653"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M156.551 231.927c3.634-4.57 8.962-10.873 15.507-17.437.763-.764 1.585-1.579 2.487-2.435 5.264-4.999 12.44-11.306 23.61-19.8 9.827-7.453 11.16-7.73 25.039-17.4 1.54-1.072 3.225-2.251 5.08-3.558 17.481-12.331 31.523-22.934 41.98-31.054 4.41-3.433 9.43-7.385 12.216-9.608"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M160.012 226.542c3.592-4.504 9.07-10.983 15.475-17.371.777-.772 1.599-1.583 2.49-2.412 5.793-5.386 13.002-11.577 23.63-19.617 9.676-7.284 11.6-7.977 24.984-17.292a1152.853 1152.853 0 0 0 46.951-34.431 1577.34 1577.34 0 0 0 12.19-9.563"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M163.474 221.156c3.549-4.438 9.177-11.093 15.442-17.304.79-.78 1.614-1.586 2.494-2.39 6.325-5.768 13.563-11.847 23.65-19.432 9.525-7.115 12.038-8.225 24.928-17.185 1.555-1.08 3.228-2.245 5.047-3.52 15.871-11.147 29.523-21.273 41.795-30.73 4.259-3.298 9.049-7.052 12.165-9.518"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M166.935 215.77c3.507-4.372 9.285-11.202 15.41-17.237a77.675 77.675 0 0 1 2.498-2.367c6.861-6.147 14.11-12.137 23.668-19.249 9.36-6.965 12.479-8.473 24.875-17.078 1.56-1.082 3.23-2.241 5.03-3.499 15.065-10.556 28.523-20.444 41.703-30.569 4.182-3.231 8.857-6.885 12.138-9.473"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M170.397 210.384c3.463-4.306 9.392-11.312 15.376-17.17a69.86 69.86 0 0 1 2.503-2.344c7.403-6.52 14.67-12.41 23.687-19.066 9.209-6.797 12.919-8.72 24.82-16.97 1.567-1.085 3.23-2.238 5.014-3.48 14.26-9.964 27.522-19.613 41.61-30.406 4.107-3.165 8.666-6.72 12.112-9.43"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M173.858 204.999c3.421-4.24 9.5-11.422 15.344-17.104a63.752 63.752 0 0 1 2.507-2.32c7.949-6.888 15.23-12.68 23.705-18.883 9.058-6.63 13.36-8.968 24.766-16.864 1.574-1.088 3.232-2.234 4.998-3.46 13.454-9.372 26.522-18.783 41.517-30.244a1635.99 1635.99 0 0 0 12.086-9.384"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M177.32 199.613c3.378-4.174 9.607-11.532 15.31-17.037a58.667 58.667 0 0 1 2.511-2.298c8.501-7.249 15.794-12.949 23.725-18.7 8.909-6.458 13.8-9.215 24.711-16.755 1.581-1.091 3.234-2.23 4.982-3.44 12.648-8.781 25.521-17.953 41.424-30.083 3.955-3.03 8.284-6.386 12.06-9.34"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M180.781 194.227c3.336-4.108 9.715-11.641 15.279-16.97.86-.82 1.7-1.59 2.514-2.275 9.058-7.603 16.367-13.202 23.744-18.516 8.773-6.269 14.24-9.463 24.657-16.649 1.587-1.094 3.235-2.227 4.964-3.42 11.843-8.189 24.521-17.123 41.332-29.921 3.88-2.964 8.093-6.22 12.034-9.294"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M184.243 188.842c3.293-4.043 9.822-11.752 15.245-16.903a50.559 50.559 0 0 1 2.519-2.253c9.621-7.95 16.928-13.473 23.763-18.332 8.622-6.1 14.68-9.711 24.602-16.542 1.594-1.097 3.236-2.224 4.948-3.4 11.038-7.598 23.52-16.294 41.24-29.76a1424.39 1424.39 0 0 0 12.007-9.25"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st9",
                d: "M187.704 183.456c3.797-4.645 12.273-14.622 17.736-19.066 23.91-19.447 31.899-23.297 48.329-34.584 13.204-9.07 28.922-19.543 58.06-42.183"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                className: "st8",
                d: "M461.67 408.79c-3.602 6.569-12.7 21.59-15.249 25.72-5.385 8.729-6.406 10.666-8.994 14.356-1.526 2.175-3.302 4.614-4.408 5.763M389.833 309.049c6.394 3.903 28.507 17.868 32.514 20.605 8.47 5.784 10.328 7.23 13.923 9.65 2.65 1.786 4.827 3.229 6.193 4.327M199.712 398.086c3.037 2.45 11.06 7.236 19.608 12.592 3.51 2.199 8.7 5.308 14.244 9.134"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                transform: "rotate(34.317 319.414 127.829)",
                style: {
                    fill: "none",
                    stroke: "#fcbdab",
                    strokeWidth: 2,
                    strokeMiterlimit: 10
                },
                d: "M290.483 98.898h57.862v57.862h-57.862z"
            })
        ]
    });
var $41327f2ae7984f2e$export$2e2bcd8739ae039 = $41327f2ae7984f2e$var$TwistComponentPrimary;



var $aSiaI = parcelRequire("aSiaI");


var $aSiaI = parcelRequire("aSiaI");
// created by Matt Webb
// This handles all the Stripe payment

var $aSiaI = parcelRequire("aSiaI");


var $a2e7a191743a205f$exports = {};
!function(e, i) {
    $a2e7a191743a205f$exports = i();
}($a2e7a191743a205f$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports))).extend($a2e7a191743a205f$exports);
const $98abe382e87e98f2$var$url = "https://api.wevr.ai/V2";
const $98abe382e87e98f2$var$paymentGateway = ({ cartItem: cartItem, packageName: packageName, couponCode: couponCode })=>{
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    function getTier() {
        if (localStorage.getItem("user") == null) return "NoUser";
        else if (JSON.parse(localStorage.getItem("user")).tier > 0) return "Active";
        else return "NotActive";
    }
    function getPaidBy() {
        return JSON.parse(localStorage.getItem("user")).paidBy;
    }
    // if the subscription ends within 5 days let them pay again if they paid with crypto
    function subsctionEnds() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(JSON.parse(localStorage.getItem("user")).subscriptionEnd).isBetween((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(), (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().add(5, "day"), "day");
    }
    // call to middleware to pass user through to stripe
    const handleCheckout = ()=>{
        fetch(`${$98abe382e87e98f2$var$url}/stripe/create-checkout-session`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`
            },
            // Send along all the information about the items
            body: JSON.stringify({
                id: cartItem,
                quantity: 1,
                code: couponCode
            })
        }).then((res)=>{
            if (res.ok) return res.json();
            return res.json().then((json)=>Promise.reject(json));
        }).then(({ url: url })=>{
            window.location = url;
        }).catch((e)=>{
            console.error(e.error);
        });
    };
    // this is called if the user has a current subscription
    const handleBilling = ()=>{
        fetch("https://api.wevr.ai/V2" + `/stripe/billing`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`
            },
            // Send along all the information about the items
            body: JSON.stringify({})
        }).then((res)=>{
            if (res.ok) return res.json();
            return res.json().then((json)=>Promise.reject(json));
        }).then(({ url: url })=>{
            window.location = url;
        }).catch((e)=>{
            console.error(e.error);
        });
    };
    if (getTier() === "NoUser") return /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
        onClick: ()=>navigate("/signin"),
        className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
        children: [
            "Buy ",
            packageName
        ]
    });
    if (getTier() === "Active") return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: getPaidBy() === "Coinbase" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            children: [
                " ",
                subsctionEnds() ? /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                    onClick: ()=>handleBilling(),
                    className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
                    children: [
                        "Upgrade ",
                        packageName
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    onClick: ()=>navigate("/UserSettings"),
                    className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
                    children: "Active subscription"
                })
            ]
        }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
            onClick: ()=>handleBilling(),
            className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
            children: [
                "Upgrade ",
                packageName
            ]
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
            onClick: ()=>handleCheckout(),
            className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
            children: [
                "Buy ",
                packageName
            ]
        })
    });
};
var $98abe382e87e98f2$export$2e2bcd8739ae039 = $98abe382e87e98f2$var$paymentGateway;


// Created By Matt Webb
// handles the coinbase checkout

var $aSiaI = parcelRequire("aSiaI");



(0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports))).extend($a2e7a191743a205f$exports);
const $7e9d1eae37c7e485$var$coinbasePayment = ({ packageName: packageName, cartItem: cartItem })=>{
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    function getToken() {
        // var token = JSON.parse(localStorage.getItem("user")).accessToken;
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const handleCheckout = async ()=>{
        try {
            const url = "https://api.wevr.ai/V2/coinbase/createCharge";
            const options = {
                method: "POST",
                headers: {
                    accept: "application/json",
                    "content-type": "application/json",
                    Authorization: `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    id: cartItem,
                    quantity: 1
                })
            };
            const response = await fetch(url, options);
            const data = await response.json();
            window.open(data.hosted_url);
        } catch (error) {
            console.error(error);
        }
    };
    // gets the users info from stored data
    function getTier() {
        if (localStorage.getItem("user") == null) return "NoUser";
        else if (JSON.parse(localStorage.getItem("user")).tier > 0) return "Active";
        else return "NotActive";
    }
    // checks when the users subscrption was paid
    function getPaidBy() {
        return JSON.parse(localStorage.getItem("user")).paidBy;
    }
    // if the subscription ends within 5 days let them pay again if they paid with crypto
    function subsctionEnds() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(JSON.parse(localStorage.getItem("user")).subscriptionEnd).isBetween((0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(), (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))().add(5, "day"), "day");
    }
    // changes how buttons behave based on the users plan or lack of plan
    if (getTier() === "NoUser") return /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
        onClick: ()=>navigate("/signin"),
        className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75 ",
        children: [
            "Buy ",
            packageName
        ]
    });
    if (getTier() === "Active") return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: getPaidBy() === "Coinbase" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            children: [
                " ",
                subsctionEnds() ? /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                    onClick: ()=>handleCheckout(),
                    className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
                    children: [
                        "Upgrade ",
                        packageName
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    onClick: ()=>navigate("/UserSettings"),
                    className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
                    children: "Active subscription"
                })
            ]
        }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            children: [
                " ",
                subsctionEnds() ? /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                    onClick: ()=>handleCheckout(),
                    className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
                    children: [
                        "Upgrade ",
                        packageName
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    onClick: ()=>navigate("/UserSettings"),
                    className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
                    children: "Active Stripe subscription"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
            onClick: ()=>{
                handleCheckout();
            },
            className: "w-full rounded-md bg-primary py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
            children: [
                "Buy ",
                packageName
            ]
        })
    });
};
var $7e9d1eae37c7e485$export$2e2bcd8739ae039 = $7e9d1eae37c7e485$var$coinbasePayment;



function $b57877aa15dc242f$export$2e2bcd8739ae039({ price: price, enabled: enabled, id: id, name: name, sale: sale, salePercentage: salePercentage, couponName: couponName = null, couponCode: couponCode }) {
    function countTill() {
        var num = price / (1 + salePercentage / 100);
        var str = String(num);
        let point = str.indexOf(".");
        return point;
    }
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
        className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(sale && !enabled ? "pt-4" : "pt-8", "text-4xl font-monda text-gray-900 "),
        children: [
            sale && !enabled ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "line-through text-gray-700 text-2xl mr-4",
                                children: [
                                    "$",
                                    price
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "rounded-full bg-tertiary/10 px-2.5 py-1 text-sm font-semibold leading-5 text-tertiary",
                                children: couponName ? /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                    children: [
                                        "-$",
                                        salePercentage,
                                        "% ",
                                        couponName
                                    ]
                                }) : `-${salePercentage}%`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                        children: [
                            "$",
                            (price - price * salePercentage / 100).toLocaleString("en-US", {
                                maximumFractionDigits: countTill() > 3 ? 0 : 2
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "text-base font-medium text-gray-500",
                                children: "USD"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                children: [
                    "$",
                    price,
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "text-base font-medium text-gray-500",
                        children: "/$USD mo"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(sale && !enabled ? "mt-6" : "mt-10", "text-base font-roboto font-medium text-gray-500"),
                children: enabled ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7e9d1eae37c7e485$export$2e2bcd8739ae039), {
                    cartItem: id,
                    packageName: name
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $98abe382e87e98f2$export$2e2bcd8739ae039), {
                    cartItem: id,
                    packageName: name,
                    couponCode: couponCode
                })
            })
        ]
    });
}



function $a047c7489bb68c44$export$2e2bcd8739ae039({ name: name, description: description, period: period, enabled: enabled, priceMonthly: priceMonthly, idMonthly: idMonthly, priceQuarterly: priceQuarterly, idQuarterly: idQuarterly, priceYearly: priceYearly, idYearly: idYearly, features: features, popular: popular = false, sale: sale = false, salePercentage: salePercentage, couponName: couponName, couponCode: couponCode }) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(popular ? "border-2 border-primary shadow-2xl scale-105" : "border border-primaryContainer shadow-md scale-100", "  rounded-lg  divide-y divide-gray-200 bg-white relative z-0"),
        children: [
            popular ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "absolute top-[-15px] right-[-5px] z-10 rounded-full bg-primary px-2.5 py-1 text-xs font-semibold leading-5 text-white",
                children: "Most Popular"
            }) : null,
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "p-6",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                        className: "text-lg leading-6 font-medium text-gray-900",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
                        children: [
                            period === "Monthly" ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b57877aa15dc242f$export$2e2bcd8739ae039), {
                                price: priceMonthly,
                                enabled: enabled,
                                id: idMonthly,
                                name: name,
                                sale: sale,
                                salePercentage: salePercentage,
                                couponName: couponName,
                                couponCode: couponCode
                            }) : period === "Quarterly" ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b57877aa15dc242f$export$2e2bcd8739ae039), {
                                price: priceQuarterly,
                                enabled: enabled,
                                id: idQuarterly,
                                name: name,
                                sale: sale,
                                couponName: couponName,
                                salePercentage: salePercentage,
                                couponCode: couponCode
                            }) : period === "Yearly" ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b57877aa15dc242f$export$2e2bcd8739ae039), {
                                price: priceYearly,
                                enabled: enabled,
                                id: idYearly,
                                name: name,
                                sale: sale,
                                salePercentage: salePercentage,
                                couponName: couponName,
                                couponCode: couponCode
                            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "text-4xl font-extrabold text-gray-900",
                                children: [
                                    "$",
                                    priceMonthly
                                ]
                            }),
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "pt-6 pb-8 px-6",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: "text-xs font-medium text-gray-900 tracking-wide uppercase",
                        children: "What's included"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                        className: "mt-6 space-y-4",
                        children: features.map((feature)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                className: "flex space-x-3",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9bcddf4d25089704$export$2e2bcd8739ae039), {
                                        className: "flex-shrink-0 h-5 w-5 text-green-500",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "text-sm text-gray-500",
                                        children: feature
                                    })
                                ]
                            }, feature))
                    })
                ]
            })
        ]
    });
}


function $d919cca732a1e95e$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
const $d919cca732a1e95e$var$SubscriptionButtons = [
    {
        id: 1,
        title: "Monthly"
    },
    {
        id: 2,
        title: "Quarterly"
    },
    {
        id: 3,
        title: "Yearly"
    }
];
const $d919cca732a1e95e$var$base = [
    {
        name: "Base",
        price: "Free",
        description: "Sign up to gain access to our charts!",
        features: [
            "Chart resolution: Daily (delayed by up to 60 days)",
            "Access to all charts on every blockchain listed",
            "Compare: 1 Charts",
            "Alerts: 1",
            // "Dashboard: No Custom (Coming soon)",
            "Footprint: 1 Address",
            "Favourite: 1 Chart (Coming soon)",
            "Number of seats: 1 "
        ]
    }
];
const $d919cca732a1e95e$var$tiers = [
    {
        name: "Standard",
        priceMonthly: 29,
        priceMonthlyDefault: 29,
        cryptoPriceMonthly: 25,
        priceQuarterly: 82,
        priceQuarterlyDefault: 82,
        cryptoPriceQuarterly: 78,
        priceYearlyDefault: 300,
        cryptopriceYearly: 290,
        priceYearly: 300,
        popular: false,
        sale: true,
        salePercentage: 50,
        couponName: null,
        couponCode: "DRHwWmNe",
        idMonthly: "StandardMonthly",
        idQuarterly: "StandardQuarterly",
        idYearly: "StandardYearly",
        description: "All the basics",
        features: [
            "Chart resolution: up to Hourly",
            "Historical data: access to all our historical data ",
            "Access to all charts on every blockchain listed",
            "Compare: 2 Charts",
            "Alerts: 5",
            // "Dashboard: 1 Custom (Coming soon)",
            "Footprint: 3 Addresses",
            "Favourite: 5 Charts (Coming soon)",
            "Number of seats: 1 "
        ]
    },
    {
        name: "Professional",
        priceMonthly: 59,
        priceMonthlyDefault: 59,
        cryptoPriceMonthly: 50,
        popular: true,
        sale: true,
        salePercentage: 50,
        couponName: null,
        couponCode: "DRHwWmNe",
        idMonthly: "ProfessionalMonthly",
        idQuarterly: "ProfessionalQuarterly",
        idYearly: "ProfessionalYearly",
        priceQuarterly: 160,
        priceQuarterlyDefault: 160,
        cryptoPriceQuarterly: 145,
        priceYearlyDefault: 600,
        cryptopriceYearly: 500,
        priceYearly: 600,
        description: "Access to block time data",
        features: [
            "Chart resolution: up to Block",
            "Historical data: access to all our historical data ",
            "Access to all charts on every blockchain listed",
            "Compare: 3 Charts",
            "Alerts: 10",
            // "Dashboard: 3 Custom (Coming soon)",
            "Footprint: 5 Addresses",
            "Favourite: 10 Charts (Coming soon)",
            "Number of seats: 1 "
        ]
    },
    {
        name: "Industry",
        priceMonthly: 500,
        priceMonthlyDefault: 500,
        cryptoPriceMonthly: 440,
        popular: false,
        sale: true,
        salePercentage: 50,
        couponName: null,
        couponCode: "DRHwWmNe",
        idMonthly: "IndustryMonthly",
        idQuarterly: "IndustryQuarterly",
        idYearly: "IndustryYearly",
        priceQuarterly: 1400,
        priceQuarterlyDefault: 1400,
        cryptoPriceQuarterly: 1300,
        priceYearlyDefault: 5500,
        cryptopriceYearly: 5000,
        priceYearly: 5500,
        description: "All inclusive analytics",
        features: [
            "Chart resolution: up to Block",
            "Historical data: access to all our historical data ",
            "Access to all charts on every blockchain listed",
            "Compare: 5 Charts",
            "Alerts: 50",
            // "Dashboard: 20 Custom (Coming soon)",
            "Footprint: 20 Addresses",
            "Favourite: 50 Charts (Coming soon)",
            "Access our API with up to 100 requests per minute (Coming soon)",
            // "Access to CSV download 100 per month (Coming soon)",
            "Number of seats: 1"
        ]
    }
];
const $d919cca732a1e95e$var$enterprise = [
    "Chart resolution: up to Block",
    "Historical data: access to all our historical data ",
    "Access to all our blockchains",
    "Create custom datasets using your own private blockchains",
    "Private access to custom designed features upon request",
    "Access to our features such as Dashboard, Footprint and Compare",
    "Access our API with up to 600 requests per minute (Coming soon)",
    "Number of seats: Custom "
];
function $d919cca732a1e95e$var$Payment() {
    const [enabled, setEnabled] = (0, $exYeM.useState)(false);
    const [period, setPeriod] = (0, $exYeM.useState)("Monthly");
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const handleColor = (row)=>{
        setPeriod(row.id);
    };
    if (enabled === true) $d919cca732a1e95e$var$tiers.map((tier)=>(tier.priceMonthly = tier.cryptoPriceMonthly, tier.priceQuarterly = tier.cryptoPriceQuarterly, tier.priceYearly = tier.cryptopriceYearly));
    else $d919cca732a1e95e$var$tiers.map((tier)=>(tier.priceMonthly = tier.priceMonthlyDefault, tier.priceQuarterly = tier.priceQuarterlyDefault, tier.priceYearly = tier.priceYearlyDefault));
    function getTier() {
        // var token = JSON.parse(localStorage.getItem("user")).accessToken;
        if (localStorage.getItem("user") == null) return false;
        else return true;
    }
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: " overflow-hidden pb-20 bg-surface z-0",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "relative top-[190px] left-[350px] mx-auto max-w-6xl md:block hidden z-10",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $41327f2ae7984f2e$export$2e2bcd8739ae039), {
                                className: "absolute -z-10 rotate-[-20deg] top-[-250px] sm:top-[-300px] lg:top-[-350px] xl:top-[-600px] 2xl:top-[-650px] left-[-450px] sm:left-[-550px] md:left-[-550px] lg:left-[-650px] xl:left-[-750px] 2xl:left-[-850px] h-[800px] w-[800px] lg:h-[900px] lg:w-[900px] xl:h-[1300px] xl:w-[1300px] 2xl:h-[1300px] 2xl:w-[1300px] blur-sm block"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $41327f2ae7984f2e$export$2e2bcd8739ae039), {
                                className: "absolute -z-10 rotate-[-120deg] top-[-250px] sm:top-[-300px] lg:top-[-350px] xl:top-[-700px] 2xl:top-[-750px] left-[200px] sm:left-[250px] md:left-[250px] lg:left-[250px] xl:left-[50px] 2xl:left-[50px] h-[800px] w-[800px] md:h-[800px] md:w-[800px] lg:h-[900px] lg:w-[900px] xl:h-[1300px] xl:w-[1300px] 2xl:h-[1300px] 2xl:w-[1300px] blur-sm block"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "relative z-20",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "max-w-7xl mx-auto pt-24 px-4 sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "sm:flex sm:flex-col sm:align-center",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                    className: "text-5xl font-extrabold text-gray-900 sm:text-center",
                                    children: "Pricing Plans"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                    className: "mt-5 text-xl text-gray-700 sm:text-center flex-wrap max-w-xl mx-auto",
                                    children: "Gain access to the vast arrange of added features such as the news index, dashboards, live data alongside many other features."
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("h1", {
                                    className: " text-xl font-extrabold text-gray-900 sm:text-center flex py-2 self-center justify-center px-2",
                                    children: [
                                        "Crypto Payment:",
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f1e8c7fc303292af$export$b5d5cf8927ab7262), {
                                            checked: enabled,
                                            onChange: setEnabled,
                                            className: $d919cca732a1e95e$var$classNames(enabled ? "bg-tertiary" : "bg-gray-200", " mx-2 my-1 inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"),
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                "aria-hidden": "true",
                                                className: $d919cca732a1e95e$var$classNames(enabled ? "translate-x-5 " : "translate-x-0", "  pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 ")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "relative mt-6 bg-gray-200 rounded-lg p-0.5 flex self-center sm:mt-8",
                                    children: $d919cca732a1e95e$var$SubscriptionButtons.map((list)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                            onClick: ()=>{
                                                handleColor(list);
                                                setPeriod(list.title);
                                            },
                                            className: $d919cca732a1e95e$var$classNames(list.title === period ? "bg-white" : "border-transparent", "ml-0.5 relative border  rounded-md py-2  w-1/2 text-sm font-medium text-gray-700 whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-wevr-Blue focus:z-10 sm:w-auto sm:px-8"),
                                            children: list.title
                                        }, list.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "mt-12 space-y-8 sm:mt-16  sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-4 ",
                            children: [
                                $d919cca732a1e95e$var$base.map((tier)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "border border-primaryContainer rounded-lg shadow-md divide-y divide-gray-200 bg-white",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "p-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                                        className: "text-lg leading-6 font-medium text-gray-900",
                                                        children: tier.name
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                        className: "mt-4 text-sm text-gray-500",
                                                        children: tier.description
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                        className: "mt-8",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                            className: "text-4xl font-monda text-gray-800",
                                                            children: [
                                                                tier.price,
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                    className: "text-base font-roboto font-medium text-gray-500",
                                                                    children: getTier() ? /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        onClick: ()=>navigate("/UserSettings"),
                                                                        className: "w-full rounded-md bg-primary mt-10 py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
                                                                        children: "Logged In"
                                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        onClick: ()=>navigate("/signin"),
                                                                        className: "w-full rounded-md bg-primary mt-10 py-2 text-white hover:bg-wevr-Accent-Light hover:shadow-md duration-75",
                                                                        children: "Sign Up"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "pt-6 pb-8 px-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                        className: "text-xs font-medium text-gray-900 tracking-wide uppercase",
                                                        children: "What's included"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                                        className: "mt-6 space-y-4",
                                                        children: tier.features.map((feature)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                                                className: "flex space-x-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9bcddf4d25089704$export$2e2bcd8739ae039), {
                                                                        className: "flex-shrink-0 h-5 w-5 text-green-500",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                        className: "text-sm text-gray-500",
                                                                        children: feature
                                                                    })
                                                                ]
                                                            }, feature))
                                                    })
                                                ]
                                            })
                                        ]
                                    }, tier.name)),
                                $d919cca732a1e95e$var$tiers.map((tier)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $a047c7489bb68c44$export$2e2bcd8739ae039), {
                                        name: tier.name,
                                        description: tier.description,
                                        period: period,
                                        enabled: enabled,
                                        priceMonthly: tier.priceMonthly,
                                        idMonthly: tier.idMonthly,
                                        priceQuarterly: tier.priceQuarterly,
                                        idQuarterly: tier.idQuarterly,
                                        priceYearly: tier.priceYearly,
                                        idYearly: tier.idYearly,
                                        features: tier.features,
                                        popular: tier.popular,
                                        sale: tier.sale,
                                        salePercentage: tier.salePercentage,
                                        couponName: tier.couponName,
                                        couponCode: tier.couponCode
                                    }, tier.name))
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-16 lg:px-8",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "max-w-3xl mx-auto text-center",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                        className: "text-3xl font-extrabold text-gray-900",
                                        children: "All the data you need and want in one place."
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "mt-4 text-lg text-gray-500",
                                        children: "Wevr.ai prides itself on gathering all types of unique data to help traders find a potential edge in the market below are some features that differentiate ourselves from the rest."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "relative mt-8 sm:max-w-5xl lg:max-w-4xl xl:max-w-7xl mx-auto bg-white/25",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: " border border-gray-200 flex rounded-lg shadow-sm p-8 z-0",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "absolute inset-0 -z-10 blur-md",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
                                            className: "w-full h-full",
                                            width: "1080",
                                            height: "416",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 24.95C3447.45 25.65 3321.92 46.07 3194.87 62.95C3135.23 70.86 3075.35 76.84 3015.2 79.01C2954.2 81.2 2894.77 80.91 2834.71 93.91C2742.37 113.91 2656.71 154.49 2567.33 183.76C2468.33 216.17 2367.6 228.89 2264.5 209.76C2107 180.54 1955.43 121.94 1802.56 75.49C1724.18 51.68 1645.03 29.08 1564.33 14.57C1501.88 3.34001 1435.33 -4.91997 1372.58 8.94003C1258.05 34.23 1145.08 63.69 1028.95 81.5C926.36 97.25 822.95 105.02 719.18 106.61C600.68 108.43 488.03 91.3 372.98 63.82C249.82 34.41 127.45 3.05001 -0.0200195 1.98001V0.430022C127.43 1.53002 249.81 32.88 372.98 62.26C487.98 89.71 600.64 106.86 719.13 105.07C822.86 103.49 926.28 95.78 1028.86 80.07C1145.03 62.28 1258.03 32.83 1372.58 7.37002C1435.29 -6.56997 1501.88 1.63004 1564.34 12.85C1645.04 27.35 1724.19 49.98 1802.54 73.85C1955.43 120.31 2106.98 179.02 2264.48 208.21C2367.58 227.33 2468.42 214.57 2567.48 182.15C2656.82 152.9 2742.37 112.34 2834.63 92.36C2894.72 79.36 2954.15 79.63 3015.21 77.47C3075.36 75.34 3135.21 69.34 3194.88 61.41C3321.94 44.5 3447.47 23.97 3576.05 23.41L3576 24.95Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 54.86C3448.63 57.27 3323.42 74.86 3197.16 89.86C3137.71 96.92 3078.08 102.41 3018.25 104.94C2957.56 107.5 2898.25 107.2 2838.57 120.13C2743.81 140.65 2655.57 181.84 2563.74 211.67C2464.09 244.04 2364.74 256.45 2261.05 237.32C2103.52 208.26 1951.39 152.08 1798.05 107.1C1719.31 84.02 1639.88 62.1 1559.05 47.57C1496.73 36.4 1430.15 27.47 1367.3 39.8C1253.48 62.12 1141.45 91.47 1026.76 109.8C924.488 126.197 821.19 135.383 717.63 137.29C598.99 139.47 486.57 122.51 371.55 94.29C248.84 64.21 127.19 32.47 0 31.86V30.04C127.23 30.66 248.94 62.38 371.65 92.42C486.7 120.58 599.16 137.53 717.81 135.42C821.402 133.566 924.736 124.444 1027.05 108.12C1141.85 89.79 1253.95 60.43 1367.85 37.93C1430.68 25.52 1497.26 34.42 1559.57 45.61C1640.4 60.11 1719.8 82.11 1798.51 105.25C1951.85 150.33 2103.94 206.68 2261.45 235.77C2365.08 254.91 2464.45 242.5 2564.04 210.14C2655.7 180.36 2743.7 139.22 2838.27 118.74C2897.99 105.8 2957.27 106.12 3017.95 103.57C3077.81 101.05 3137.47 95.51 3196.95 88.38C3323.29 73.23 3448.54 55.38 3576.01 53.08L3576 54.86Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 84.77C3450.73 87.86 3326.71 101.5 3202.1 113.44C3143.23 119.08 3084.26 123.55 3025.17 125.97C2964.17 128.47 2904.6 128.48 2844.61 141.49C2745.82 162.91 2653.42 205.07 2557.5 235.83C2456.17 268.33 2356.69 281.18 2251.25 262.42C2093.36 234.33 1940.25 181.08 1786.06 138.18C1706.77 116.13 1626.89 95.18 1545.75 81.03C1483.25 70.16 1416.61 61.03 1353.47 72.09C1241.23 91.78 1130.72 120.7 1018.25 139.64C916.95 156.69 814.89 167.19 712.16 169.42C593.98 171.97 482.37 154.8 368.09 125.6C246.63 94.57 126.37 62.21 0 61.77V59.68C126.44 60.09 246.78 92.43 368.38 123.39C482.74 152.5 594.38 169.65 712.65 167.12C815.46 164.92 917.65 154.52 1019.02 137.51C1131.67 118.62 1242.31 89.65 1354.68 69.79C1417.79 58.63 1484.43 67.79 1546.91 78.67C1628.02 92.82 1707.91 113.88 1787.11 136.02C1941.26 179.09 2094.26 232.55 2252.11 260.73C2357.39 279.53 2456.82 266.73 2558 234.25C2653.63 203.56 2745.63 161.48 2844.13 140.13C2904.08 127.13 2963.62 127.13 3024.57 124.64C3083.73 122.2 3142.75 117.64 3201.68 111.89C3326.43 99.7 3450.56 85.75 3576 82.68V84.77Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 114.68C3453.49 117.68 3331.43 126.39 3209.17 134.25C3151.23 137.97 3093.25 141.01 3035.22 142.95C2973.4 145.02 2913.22 145.63 2852.42 158.82C2748.3 181.44 2650.42 224.82 2549.11 256.82C2445.29 289.62 2344.37 303.44 2236.3 285.4C2077.76 258.93 1923.41 209.05 1768.1 168.7C1688.1 147.92 1607.63 128.15 1526.1 114.7C1463.18 104.33 1396.41 95.35 1332.84 105.4C1222.84 122.78 1114.42 150.97 1004.75 170.5C905.16 188.23 804.85 200.09 703.66 202.63C586.42 205.57 476.11 187.88 363.14 157.49C243.36 125.27 125.14 92.03 0.0500488 91.62V89.31C125.25 89.72 243.65 122.88 363.58 155C476.68 185.28 587.1 202.93 704.43 200C805.76 197.48 906.24 185.73 1005.98 168.05C1115.89 148.57 1224.51 120.31 1334.69 102.76C1398.22 92.64 1464.98 101.64 1527.86 112.06C1609.4 125.56 1689.86 145.44 1769.76 166.32C1924.93 206.91 2079.17 257.07 2237.63 283.69C2345.47 301.8 2446.24 288.07 2549.83 255.3C2650.66 223.41 2748.08 180.08 2851.74 157.57C2912.42 144.4 2972.58 143.85 3034.31 141.73C3092.44 139.73 3150.51 136.58 3208.53 132.73C3331 124.51 3453.24 115.37 3575.99 112.35L3576 114.68Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 144.59C3456.62 146.92 3337.26 149.98 3217.89 152.94C3100.02 155.86 2977.3 147.94 2861.6 173.08C2751.13 197.08 2646.72 242.08 2539.07 275.51C2432.14 308.74 2328.76 323.91 2217.38 306.91C2057.97 282.56 1902.14 236.36 1745.51 198.91C1664.74 179.61 1583.51 161.25 1501.39 148.7C1437.88 138.99 1370.92 130.47 1306.82 139.64C1199.57 155 1093.69 182.17 987.26 202.32C889.86 220.75 791.84 233.94 692.66 236.81C576.72 240.21 468.07 221.75 356.87 189.99C239.23 156.4 123.49 122.21 0 121.59V118.95C123.63 119.5 239.63 153.64 357.46 187.11C468.83 218.73 577.64 237.11 693.7 233.79C793.08 230.95 891.32 217.88 988.93 199.51C1095.65 179.42 1201.78 152.15 1309.28 136.62C1373.34 127.37 1440.28 135.95 1503.73 145.72C1585.82 158.35 1666.96 176.85 1747.66 196.28C1904.16 233.97 2059.86 280.51 2219.18 305.06C2330.24 322.17 2433.38 307.13 2540.01 273.94C2647.07 240.62 2750.87 195.75 2860.74 171.94C2976.42 146.86 3099.21 154.74 3217.07 151.37C3336.71 147.96 3456.34 144.37 3576 141.97V144.59Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 174.51C3459.85 175.81 3343.88 172.7 3227.77 170.14C3109.64 167.54 2987.85 159.95 2871.77 185.19C2754.24 210.74 2642.67 257.44 2527.91 292.49C2417.42 326.22 2310.91 342.95 2195.73 327.26C2035.28 305.38 1877.81 263.1 1719.73 228.87C1638.09 211.18 1556.08 194.36 1473.3 182.87C1409.07 173.94 1341.9 166.08 1277.18 174.5C1076.48 200.58 883.62 264.98 680.06 271.62C565.63 275.35 458.94 255.99 349.81 222.78C234.63 187.71 121.7 152.34 0 151.51V148.59C121.88 149.39 235.05 184.66 350.52 219.59C459.88 252.65 566.72 271.92 681.31 268.22C885.48 261.63 1078.9 197.49 1280.15 171.09C1344.81 162.61 1411.96 170.54 1476.15 179.54C1558.86 191.15 1640.78 208.13 1722.34 225.98C1880.27 260.53 2037.58 303.2 2197.92 325.33C2312.69 341.16 2418.92 324.59 2529.03 290.9C2643.03 256.02 2753.92 209.49 2870.74 184.1C2986.8 158.87 3108.74 166.5 3226.8 168.53C3343.23 170.53 3459.57 173.02 3576.03 171.61L3576 174.51Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 204.42C3462.88 204.52 3351 194.99 3238.3 186.5C3119.8 177.57 2999.3 170.6 2882.4 196.06C2757.4 223.3 2638.26 271.74 2516 308.51C2401.74 342.86 2291.56 361.14 2172.41 346.98C2010.81 327.77 1851.63 289.55 1692.03 258.64C1609.47 242.64 1526.63 227.45 1443.16 217.08C1378.16 209 1310.74 201.94 1245.34 209.63C1050.42 232.56 863.63 299.51 666.43 306.74C553.67 310.87 449.09 290.56 342.26 255.74C229.63 219.08 119.79 182.56 0 181.42V178.21C120 179.32 230.19 215.71 343.07 252.21C450.16 286.84 554.96 307.04 667.91 302.95C865.76 295.78 1053.25 229.1 1248.79 205.85C1314.11 198.08 1381.5 205.23 1446.42 213.4C1529.82 223.89 1612.57 239.27 1695.02 255.4C1854.46 286.66 2013.46 325.32 2174.94 344.82C2293.63 359.21 2403.43 341.11 2517.28 306.82C2638.73 270.24 2757.06 221.99 2881.28 194.93C2998.06 169.49 3118.73 176.56 3237.19 184.77C3350.19 192.62 3462.6 201.46 3576.03 201.23L3576 204.42Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 234.33C3347.55 232.04 3120.8 156.93 2893.21 206.64C2760.63 235.58 2633.83 285.79 2503.98 324.29C2444.64 341.88 2384.41 357.74 2322.98 366.15C2264.78 374.15 2206.98 372.45 2148.72 366.54C1985.92 350.04 1825.03 315.92 1663.87 288.38C1580.41 274.12 1496.72 260.55 1412.53 251.38C1346.75 244.17 1279.08 237.96 1213 244.92C1023.84 264.79 843.41 334.21 652.63 341.95C541.52 346.49 439.03 325.21 334.63 288.8C224.7 250.45 117.95 212.8 0.0400391 211.33V207.86C118.17 209.3 225.27 246.86 335.51 284.97C440.23 321.21 542.95 342.37 654.24 337.87C845.77 330.14 1026.95 261.05 1216.78 240.79C1282.78 233.79 1350.43 240.05 1416.12 247.36C1500.23 256.72 1583.82 270.48 1667.18 284.94C1828.18 312.86 1988.85 347.46 2151.51 364.27C2209.72 370.27 2267.35 372.01 2325.46 364.08C2386.52 355.73 2446.41 339.97 2505.4 322.45C2634.4 284.15 2760.31 234.15 2892 205.45C3119.23 155.84 3347.69 228.91 3576 230.91V234.33Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 264.21C3467.34 262.02 3365.33 239.97 3259.36 219.21C3140.44 195.88 3022.64 191.8 2903.74 217.82C2763.8 248.43 2629.54 300.35 2492.28 340.54C2430.08 358.76 2367.01 375.36 2302.73 384.36C2243.78 392.62 2185.07 391.43 2125.88 386.41C1961.88 372.53 1799.37 342.41 1636.71 318.19C1552.37 305.61 1467.86 293.64 1382.96 285.52C1316.42 279.15 1248.54 273.84 1181.77 279.92C997.92 296.66 824.06 368.64 639.26 376.92C529.76 381.86 429.26 359.72 327.16 321.67C219.83 281.67 116.16 242.94 0 241.18V237.44C116.37 239.17 220.42 277.77 328.06 317.56C430.46 355.42 531.18 377.45 640.88 372.56C826.4 364.3 1001.07 292.62 1185.57 275.56C1252.26 269.37 1320.1 274.78 1386.57 281.25C1471.38 289.5 1555.8 301.67 1640.03 314.45C1802.5 339.11 1964.83 369.69 2128.67 383.9C2187.76 389.02 2246.35 390.26 2305.22 382.04C2369.15 373.11 2431.88 356.6 2493.73 338.46C2630.08 298.46 2763.43 246.77 2902.47 216.35C3021.25 190.35 3139.19 194.7 3258.12 217.09C3364.48 237.09 3467.12 258.42 3576.02 260.49L3576 264.21Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 294.15C3515.91 292.47 3456.47 286.15 3397.92 272.26C3354.5 261.97 3312.07 248.05 3268.92 236.86C3150.38 206.12 3033.33 204.33 2913.61 230.56C2766.8 262.74 2625.61 316.24 2481.44 358.01C2416.62 376.8 2350.94 394.09 2284.03 403.63C2224.44 412.12 2164.94 411.28 2105.03 407.1C1939.92 395.57 1775.91 369.35 1611.87 348.2C1461.67 328.84 1305.06 302.91 1153.21 314.57C974.05 328.32 806.56 402.72 627.15 411.57C519.03 416.91 420.33 394.05 320.37 354.41C215.41 312.81 114.63 273.13 0 271.15V267.15C114.82 269.15 216 308.67 321.21 350.06C421.44 389.47 520.37 412.21 628.63 406.97C808.72 398.19 977.04 324.12 1156.78 309.97C1308.43 298.03 1465.05 324.47 1614.97 344.18C1778.84 365.73 1942.66 392.46 2107.62 404.28C2167.46 408.57 2226.86 409.45 2286.38 400.98C2352.95 391.51 2418.3 374.31 2482.79 355.6C2626.06 314.03 2766.37 260.73 2912.3 228.75C3031.94 202.54 3149.04 204.67 3267.67 234.43C3311.08 245.32 3353.79 258.86 3397.43 268.87C3456.19 282.34 3515.78 288.53 3575.98 290.16L3576 294.15Z",
                                                    fill: "#FA9173"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 324.06C3516.62 322.18 3458.11 314.86 3401 298.23C3359.1 286.03 3318.67 269.48 3277.14 256.23C3159.53 218.61 3042.47 219.44 2922.37 245.8C2769.46 279.31 2622.12 334.21 2471.88 377.39C2404.83 396.66 2336.93 414.55 2267.79 424.53C2207.79 433.2 2147.73 432.53 2087.3 429.04C1921.22 419.48 1755.93 396.86 1590.67 378.51C1438.67 361.63 1282.13 339.31 1128.83 348.51C1039.2 353.9 952.48 372.44 866.28 396.73C784.13 419.88 702.57 440.87 616.9 445.45C509.9 451.16 412.65 427.81 314.5 386.69C211.63 343.61 113.43 303.13 0 301.06V296.77C113.63 298.84 212.12 339.21 315.27 382.11C413.65 423.02 511.06 446.32 618.27 440.66C704.14 436.12 786.01 415.31 868.42 392.28C954.99 368.09 1042.11 349.35 1132.05 343.71C1285.15 334.11 1441.68 356.93 1593.48 374.14C1758.52 392.87 1923.63 415.99 2089.63 425.8C2150.01 429.37 2209.98 430.06 2269.96 421.41C2338.82 411.49 2406.43 393.68 2473.19 374.47C2622.62 331.47 2769.14 276.76 2921.19 243.4C3041.28 217.06 3158.29 216.61 3276.06 253.3C3317.81 266.3 3358.51 282.5 3400.61 294.44C3457.93 310.7 3516.56 317.9 3576.02 319.77L3576 324.06Z",
                                                    className: " fill-test-white dark:fill-contrast-orange"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 353.97C3517 352.2 3459.13 344.34 3403.1 325.4C3362.42 311.65 3323.72 292.88 3283.52 277.87C3167.36 234.51 3049.52 238.03 2929.6 264.36C2771.74 299.03 2619.39 355.1 2464.17 399.41C2395.42 419.03 2325.84 437.41 2254.99 447.7C2194.79 456.46 2134.59 455.7 2073.99 452.7C1907.11 444.57 1740.83 425.21 1574.63 409.21C1421.15 394.48 1264.8 375.27 1110.35 381.53C1022.59 385.08 938.35 402.28 854.35 427.28C773.67 451.28 693.91 473.51 609.35 478.35C503.01 484.43 406.84 460.88 310.02 418.43C208.73 374.01 112.66 332.96 0.0200195 330.95V326.41C112.75 328.41 209.11 369.41 310.61 413.65C407.61 455.91 503.89 479.46 610.31 473.42C694.99 468.62 774.98 446.61 855.85 422.72C940.1 397.82 1024.71 380.43 1112.72 376.59C1267.02 369.84 1423.4 389.48 1576.72 404.52C1742.82 420.81 1908.97 440.66 2075.72 448.97C2136.33 451.97 2196.54 452.75 2256.72 443.97C2327.35 433.71 2396.72 415.4 2465.25 395.82C2619.79 351.67 2771.46 295.76 2928.65 261.24C3048.65 234.9 3166.31 231.77 3282.72 274.36C3323.1 289.13 3362.04 307.6 3402.89 321.14C3459.06 339.76 3517.04 347.57 3576.04 349.38L3576 353.97Z",
                                                    className: "fill-test-white dark:fill-t-accent-DM"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 383.88C3517.14 382.63 3459.41 374.74 3404.05 354.1C3364.21 339.25 3326.84 318.78 3287.6 302.52C3173.28 255.14 3053.91 261.14 2934.94 287.28C2773.52 322.74 2617.57 379.64 2458.78 424.77C2389.02 444.59 2318.42 463.3 2246.56 473.77C2186.56 482.51 2126.62 481.29 2066.2 478.61C1898.84 471.2 1731.9 454.61 1565.02 440.49C1410.56 427.49 1254.44 410.73 1099.23 413.39C1012.75 414.88 930.23 430.99 847.85 456.64C767.92 481.55 689.28 504.95 605.13 510.05C498.97 516.48 403.33 493.12 307.2 449.51C206.89 403.99 112.32 362.63 0 360.89V356.06C112.34 357.86 207.1 399.19 307.53 444.54C403.71 487.99 499.4 511.4 605.53 505.03C689.69 499.97 768.46 476.76 848.46 452.03C931.02 426.48 1013.79 410.21 1100.46 408.37C1255.58 405.08 1411.75 422.15 1566.08 435.43C1732.88 449.79 1899.74 466.81 2067.08 474.29C2127.56 476.99 2187.57 478.12 2247.63 469.37C2319.39 458.92 2389.87 440.26 2459.52 420.45C2617.84 375.45 2773.32 318.64 2934.28 283.28C3053.44 257.1 3172.53 251.48 3287.17 298.35C3326.53 314.44 3364.09 334.68 3404.03 349.35C3459.47 369.76 3517.19 377.69 3576.03 379.05L3576 383.88Z",
                                                    className: "fill-test-white dark:fill-t-accent-DM"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                    d: "M3576 413.79C3517.07 413.2 3459.32 405.56 3404.1 384.26C3364.4 368.94 3327.42 347.66 3288.38 330.85C3175.09 282.06 3055.17 289.79 2936.99 315.75C2774.2 351.51 2616.68 408.13 2456.43 453.3C2386.43 473.03 2315.6 491.77 2243.54 502.37C2183.54 511.2 2124.23 509.24 2063.87 506.45C1896.77 498.71 1729.97 484.45 1563.19 471.83C1408.35 460.07 1252.51 444.83 1097.11 443.97C1011.31 443.48 928.96 459.85 847.43 485.41C767.16 510.57 688.27 534.74 603.72 540.21C497.63 547.21 401.9 524.08 306.11 479.75C206.11 433.48 112.47 392.37 0.110107 390.83C0.110107 388.77 0.110107 387.74 0.110107 385.69C112.54 387.15 206.39 428.43 306.45 474.61C402.45 518.91 498.13 541.92 604.45 535.16C688.85 529.78 767.45 505.56 847.45 480.16C929.01 454.29 1011.08 438.4 1096.96 438.71C1252.41 439.28 1408.29 454.64 1563.15 466.71C1730.15 479.71 1897.15 494.36 2064.55 501.91C2124.7 504.63 2184.08 506.48 2243.85 497.75C2315.79 487.21 2386.63 468.4 2456.63 448.59C2616.89 403.21 2774.4 346.21 2937.27 310.42C3055.27 284.49 3175.63 276.89 3288.69 325.74C3327.59 342.55 3364.41 363.85 3403.98 379.15C3459.22 400.52 3517.03 408.09 3575.98 408.69L3576 413.79Z",
                                                    className: "fill-test-white dark:fill-t-accent-DM"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "w-full md:w-1/2 flex flex-col justify-between md:pr-12 z-0",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "text-4xl md:text-5xl font-semibold text-[#18181B] mb-4 flex justify-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                        className: "h-[40px] md:h-[48px] w-auto pr-4 self-center pt-2",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8af33ef04486b7$exports))),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "h-full text-center",
                                                        children: "Enterprise"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-gray-800 text-md md:text-md break-words my-4",
                                                children: "For companies and teams, we offer custom built services with access to the latest blocks, historical data and tools. We also offer the ability to custom tailor our tools to your own blockchain, creating the perfect service for you. Whether you want to monitor transactions, track trends, optimize performance, or generate insights, Wevr.ai can help you achieve your goals. Contact us today!"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                onClick: ()=>{
                                                    navigate("/Contact");
                                                },
                                                className: "bg-primary text-white shadow-sm hover:shadow-lg rounded-lg px-4 py-2 w-fit text-[min(4vw,1.25rem)] mt-4",
                                                children: "Contact us"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "w-1/2 md:flex hidden ml-10 justify-items-center",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                            className: "space-y-4 flex flex-col justify-between",
                                            children: $d919cca732a1e95e$var$enterprise.map((feature)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                                    className: "flex space-x-3 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9bcddf4d25089704$export$2e2bcd8739ae039), {
                                                            className: "flex-shrink-0 h-5 w-5 text-green-500",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "text-md md:text-md text-gray-800",
                                                            children: feature
                                                        })
                                                    ]
                                                }, feature))
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $d919cca732a1e95e$export$2e2bcd8739ae039 = $d919cca732a1e95e$var$Payment;


// created by james launder
// sign up form, relatively simple just has verification for each input
/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
var $354df6ff51b92897$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $354df6ff51b92897$var$isDateObject = (value1)=>value1 instanceof Date;
var $354df6ff51b92897$var$isNullOrUndefined = (value1)=>value1 == null;
const $354df6ff51b92897$var$isObjectType = (value1)=>typeof value1 === "object";
var $354df6ff51b92897$var$isObject = (value1)=>!$354df6ff51b92897$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $354df6ff51b92897$var$isObjectType(value1) && !$354df6ff51b92897$var$isDateObject(value1);
var $354df6ff51b92897$var$getEventValue = (event)=>$354df6ff51b92897$var$isObject(event) && event.target ? $354df6ff51b92897$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $354df6ff51b92897$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $354df6ff51b92897$var$isNameInFieldArray = (names, name)=>names.has($354df6ff51b92897$var$getNodeParentName(name));
var $354df6ff51b92897$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $354df6ff51b92897$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $354df6ff51b92897$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $354df6ff51b92897$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($354df6ff51b92897$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $354df6ff51b92897$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$354df6ff51b92897$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $354df6ff51b92897$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $354df6ff51b92897$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $354df6ff51b92897$var$isUndefined = (val)=>val === undefined;
var $354df6ff51b92897$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$354df6ff51b92897$var$isObject(obj)) return defaultValue;
    const result = $354df6ff51b92897$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$354df6ff51b92897$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $354df6ff51b92897$var$isUndefined(result) || result === obj ? $354df6ff51b92897$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $354df6ff51b92897$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $354df6ff51b92897$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $354df6ff51b92897$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $354df6ff51b92897$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $354df6ff51b92897$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $354df6ff51b92897$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($354df6ff51b92897$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $354df6ff51b92897$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($354df6ff51b92897$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $354df6ff51b92897$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $354df6ff51b92897$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $354df6ff51b92897$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $354df6ff51b92897$var$isEmptyObject = (value1)=>$354df6ff51b92897$var$isObject(value1) && !Object.keys(value1).length;
var $354df6ff51b92897$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $354df6ff51b92897$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $354df6ff51b92897$var$VALIDATION_MODE.all));
};
var $354df6ff51b92897$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $354df6ff51b92897$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $354df6ff51b92897$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $354df6ff51b92897$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $354df6ff51b92897$export$606f11b2eb45ecc6(props) {
    const methods = $354df6ff51b92897$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(name);
    _name.current = name;
    $354df6ff51b92897$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $354df6ff51b92897$var$shouldSubscribeByName(_name.current, value1.name, exact) && $354df6ff51b92897$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $354df6ff51b92897$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $354df6ff51b92897$var$isString = (value1)=>typeof value1 === "string";
var $354df6ff51b92897$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($354df6ff51b92897$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $354df6ff51b92897$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $354df6ff51b92897$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $354df6ff51b92897$export$3c773aa2b84f29e0(props) {
    const methods = $354df6ff51b92897$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(name);
    _name.current = name;
    $354df6ff51b92897$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($354df6ff51b92897$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($354df6ff51b92897$var$cloneObject($354df6ff51b92897$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $354df6ff51b92897$var$isKey = (value1)=>/^\w*$/.test(value1);
var $354df6ff51b92897$var$stringToPath = (input)=>$354df6ff51b92897$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $354df6ff51b92897$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $354df6ff51b92897$var$isKey(path) ? [
        path
    ] : $354df6ff51b92897$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $354df6ff51b92897$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $354df6ff51b92897$export$e8c786024a2b0a79(props) {
    const methods = $354df6ff51b92897$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $354df6ff51b92897$var$isNameInFieldArray(control._names.array, name);
    const value1 = $354df6ff51b92897$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $354df6ff51b92897$export$3988ae62b71be9a3(control._formValues, name, $354df6ff51b92897$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $354df6ff51b92897$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    _registerProps.current = control.register(name, props.rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $354df6ff51b92897$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $354df6ff51b92897$var$cloneObject($354df6ff51b92897$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $354df6ff51b92897$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($354df6ff51b92897$var$isUndefined($354df6ff51b92897$export$3988ae62b71be9a3(control._formValues, name))) $354df6ff51b92897$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if ($354df6ff51b92897$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$354df6ff51b92897$var$isBoolean(disabled) ? {
                disabled: disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $354df6ff51b92897$var$getEventValue(event),
                        name: name
                    },
                    type: $354df6ff51b92897$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $354df6ff51b92897$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $354df6ff51b92897$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $354df6ff51b92897$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$354df6ff51b92897$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$354df6ff51b92897$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$354df6ff51b92897$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$354df6ff51b92897$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $354df6ff51b92897$export$bd0bf19f25da8474 = (props)=>props.render($354df6ff51b92897$export$e8c786024a2b0a79(props));
const $354df6ff51b92897$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $354df6ff51b92897$export$a7fed597f4b8afd8(props) {
    const methods = $354df6ff51b92897$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $354df6ff51b92897$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $354df6ff51b92897$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $354df6ff51b92897$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
const $354df6ff51b92897$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $354df6ff51b92897$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                } else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($354df6ff51b92897$var$isObject(currentField)) $354df6ff51b92897$var$focusFieldBy(currentField, callback);
        }
    }
};
var $354df6ff51b92897$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $354df6ff51b92897$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $354df6ff51b92897$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$354df6ff51b92897$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $354df6ff51b92897$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $354df6ff51b92897$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $354df6ff51b92897$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $354df6ff51b92897$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $354df6ff51b92897$var$VALIDATION_MODE.all,
        isOnTouch: mode === $354df6ff51b92897$var$VALIDATION_MODE.onTouched
    });
var $354df6ff51b92897$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var $354df6ff51b92897$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $354df6ff51b92897$var$compact($354df6ff51b92897$export$3988ae62b71be9a3(errors, name));
    $354df6ff51b92897$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $354df6ff51b92897$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $354df6ff51b92897$var$isFileInput = (element)=>element.type === "file";
var $354df6ff51b92897$var$isFunction = (value1)=>typeof value1 === "function";
var $354df6ff51b92897$var$isHTMLElement = (value1)=>{
    if (!$354df6ff51b92897$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $354df6ff51b92897$var$isMessage = (value1)=>$354df6ff51b92897$var$isString(value1);
var $354df6ff51b92897$var$isRadioInput = (element)=>element.type === "radio";
var $354df6ff51b92897$var$isRegex = (value1)=>value1 instanceof RegExp;
const $354df6ff51b92897$var$defaultResult = {
    value: false,
    isValid: false
};
const $354df6ff51b92897$var$validResult = {
    value: true,
    isValid: true
};
var $354df6ff51b92897$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$354df6ff51b92897$var$isUndefined(options[0].attributes.value) ? $354df6ff51b92897$var$isUndefined(options[0].value) || options[0].value === "" ? $354df6ff51b92897$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $354df6ff51b92897$var$validResult : $354df6ff51b92897$var$defaultResult;
    }
    return $354df6ff51b92897$var$defaultResult;
};
const $354df6ff51b92897$var$defaultReturn = {
    isValid: false,
    value: null
};
var $354df6ff51b92897$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $354df6ff51b92897$var$defaultReturn) : $354df6ff51b92897$var$defaultReturn;
function $354df6ff51b92897$var$getValidateError(result, ref, type = "validate") {
    if ($354df6ff51b92897$var$isMessage(result) || Array.isArray(result) && result.every($354df6ff51b92897$var$isMessage) || $354df6ff51b92897$var$isBoolean(result) && !result) return {
        type: type,
        message: $354df6ff51b92897$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $354df6ff51b92897$var$getValueAndMessage = (validationData)=>$354df6ff51b92897$var$isObject(validationData) && !$354df6ff51b92897$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $354df6ff51b92897$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $354df6ff51b92897$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($354df6ff51b92897$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $354df6ff51b92897$var$isRadioInput(ref);
    const isCheckBox = $354df6ff51b92897$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $354df6ff51b92897$var$isFileInput(ref)) && $354df6ff51b92897$var$isUndefined(ref.value) && $354df6ff51b92897$var$isUndefined(inputValue) || $354df6ff51b92897$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $354df6ff51b92897$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $354df6ff51b92897$var$INPUT_VALIDATION_RULES.maxLength, minType = $354df6ff51b92897$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $354df6ff51b92897$var$isNullOrUndefined(inputValue)) || $354df6ff51b92897$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$354df6ff51b92897$var$getCheckboxValue(refs).isValid || isRadio && !$354df6ff51b92897$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $354df6ff51b92897$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $354df6ff51b92897$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $354df6ff51b92897$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($354df6ff51b92897$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$354df6ff51b92897$var$isNullOrUndefined(min) || !$354df6ff51b92897$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $354df6ff51b92897$var$getValueAndMessage(max);
        const minOutput = $354df6ff51b92897$var$getValueAndMessage(min);
        if (!$354df6ff51b92897$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$354df6ff51b92897$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$354df6ff51b92897$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($354df6ff51b92897$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($354df6ff51b92897$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $354df6ff51b92897$var$INPUT_VALIDATION_RULES.max, $354df6ff51b92897$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($354df6ff51b92897$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $354df6ff51b92897$var$getValueAndMessage(maxLength);
        const minLengthOutput = $354df6ff51b92897$var$getValueAndMessage(minLength);
        const exceedMax = !$354df6ff51b92897$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$354df6ff51b92897$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $354df6ff51b92897$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $354df6ff51b92897$var$getValueAndMessage(pattern);
        if ($354df6ff51b92897$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $354df6ff51b92897$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($354df6ff51b92897$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($354df6ff51b92897$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $354df6ff51b92897$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($354df6ff51b92897$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($354df6ff51b92897$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$354df6ff51b92897$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $354df6ff51b92897$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$354df6ff51b92897$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $354df6ff51b92897$var$append(data, value1) {
    return [
        ...data,
        ...$354df6ff51b92897$var$convertToArrayPayload(value1)
    ];
}
var $354df6ff51b92897$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $354df6ff51b92897$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$354df6ff51b92897$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $354df6ff51b92897$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($354df6ff51b92897$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $354df6ff51b92897$var$prepend(data, value1) {
    return [
        ...$354df6ff51b92897$var$convertToArrayPayload(value1),
        ...$354df6ff51b92897$var$convertToArrayPayload(data)
    ];
}
function $354df6ff51b92897$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $354df6ff51b92897$var$compact(temp).length ? temp : [];
}
var $354df6ff51b92897$var$removeArrayAt = (data, index)=>$354df6ff51b92897$var$isUndefined(index) ? [] : $354df6ff51b92897$var$removeAtIndexes(data, $354df6ff51b92897$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $354df6ff51b92897$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $354df6ff51b92897$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $354df6ff51b92897$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $354df6ff51b92897$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$354df6ff51b92897$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $354df6ff51b92897$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $354df6ff51b92897$var$isKey(path) ? [
        path
    ] : $354df6ff51b92897$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $354df6ff51b92897$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($354df6ff51b92897$var$isObject(childObject) && $354df6ff51b92897$var$isEmptyObject(childObject) || Array.isArray(childObject) && $354df6ff51b92897$var$isEmptyArray(childObject))) $354df6ff51b92897$var$unset(object, paths.slice(0, -1));
    return object;
}
var $354df6ff51b92897$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $354df6ff51b92897$export$310131896651d559(props) {
    const methods = $354df6ff51b92897$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(control._getFieldArray(name).map($354df6ff51b92897$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $354df6ff51b92897$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $354df6ff51b92897$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($354df6ff51b92897$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $354df6ff51b92897$var$convertToArrayPayload($354df6ff51b92897$var$cloneObject(value1));
        const updatedFieldArrayValues = $354df6ff51b92897$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $354df6ff51b92897$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $354df6ff51b92897$var$append(ids.current, appendValue.map($354df6ff51b92897$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $354df6ff51b92897$var$append, {
            argA: $354df6ff51b92897$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $354df6ff51b92897$var$convertToArrayPayload($354df6ff51b92897$var$cloneObject(value1));
        const updatedFieldArrayValues = $354df6ff51b92897$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $354df6ff51b92897$var$getFocusFieldName(name, 0, options);
        ids.current = $354df6ff51b92897$var$prepend(ids.current, prependValue.map($354df6ff51b92897$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $354df6ff51b92897$var$prepend, {
            argA: $354df6ff51b92897$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $354df6ff51b92897$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $354df6ff51b92897$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $354df6ff51b92897$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $354df6ff51b92897$var$convertToArrayPayload($354df6ff51b92897$var$cloneObject(value1));
        const updatedFieldArrayValues = $354df6ff51b92897$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $354df6ff51b92897$var$getFocusFieldName(name, index, options);
        ids.current = $354df6ff51b92897$var$insert(ids.current, index, insertValue.map($354df6ff51b92897$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $354df6ff51b92897$var$insert, {
            argA: index,
            argB: $354df6ff51b92897$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $354df6ff51b92897$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $354df6ff51b92897$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $354df6ff51b92897$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $354df6ff51b92897$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $354df6ff51b92897$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $354df6ff51b92897$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $354df6ff51b92897$var$cloneObject(value1);
        const updatedFieldArrayValues = $354df6ff51b92897$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $354df6ff51b92897$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $354df6ff51b92897$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $354df6ff51b92897$var$convertToArrayPayload($354df6ff51b92897$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($354df6ff51b92897$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        control._state.action = false;
        $354df6ff51b92897$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$354df6ff51b92897$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $354df6ff51b92897$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $354df6ff51b92897$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $354df6ff51b92897$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $354df6ff51b92897$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $354df6ff51b92897$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $354df6ff51b92897$var$validateField(field, control._formValues, control._options.criteriaMode === $354df6ff51b92897$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$354df6ff51b92897$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $354df6ff51b92897$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $354df6ff51b92897$var$focusFieldBy(control._fields, (key)=>!!key && key.startsWith(control._names.focus || ""));
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        !$354df6ff51b92897$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $354df6ff51b92897$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $354df6ff51b92897$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $354df6ff51b92897$var$isPrimitive = (value1)=>$354df6ff51b92897$var$isNullOrUndefined(value1) || !$354df6ff51b92897$var$isObjectType(value1);
function $354df6ff51b92897$var$deepEqual(object1, object2) {
    if ($354df6ff51b92897$var$isPrimitive(object1) || $354df6ff51b92897$var$isPrimitive(object2)) return object1 === object2;
    if ($354df6ff51b92897$var$isDateObject(object1) && $354df6ff51b92897$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($354df6ff51b92897$var$isDateObject(val1) && $354df6ff51b92897$var$isDateObject(val2) || $354df6ff51b92897$var$isObject(val1) && $354df6ff51b92897$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$354df6ff51b92897$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $354df6ff51b92897$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $354df6ff51b92897$var$isRadioOrCheckbox = (ref)=>$354df6ff51b92897$var$isRadioInput(ref) || $354df6ff51b92897$var$isCheckBoxInput(ref);
var $354df6ff51b92897$var$live = (ref)=>$354df6ff51b92897$var$isHTMLElement(ref) && ref.isConnected;
var $354df6ff51b92897$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($354df6ff51b92897$var$isFunction(data[key])) return true;
    }
    return false;
};
function $354df6ff51b92897$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($354df6ff51b92897$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $354df6ff51b92897$var$isObject(data[key]) && !$354df6ff51b92897$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $354df6ff51b92897$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$354df6ff51b92897$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $354df6ff51b92897$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($354df6ff51b92897$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $354df6ff51b92897$var$isObject(data[key]) && !$354df6ff51b92897$var$objectHasFunction(data[key])) {
            if ($354df6ff51b92897$var$isUndefined(formValues) || $354df6ff51b92897$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $354df6ff51b92897$var$markFieldsDirty(data[key], []) : {
                ...$354df6ff51b92897$var$markFieldsDirty(data[key])
            };
            else $354df6ff51b92897$var$getDirtyFieldsFromDefaultValues(data[key], $354df6ff51b92897$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$354df6ff51b92897$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $354df6ff51b92897$var$getDirtyFields = (defaultValues, formValues)=>$354df6ff51b92897$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $354df6ff51b92897$var$markFieldsDirty(formValues));
var $354df6ff51b92897$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$354df6ff51b92897$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $354df6ff51b92897$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $354df6ff51b92897$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($354df6ff51b92897$var$isFileInput(ref)) return ref.files;
    if ($354df6ff51b92897$var$isRadioInput(ref)) return $354df6ff51b92897$var$getRadioValue(_f.refs).value;
    if ($354df6ff51b92897$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($354df6ff51b92897$var$isCheckBoxInput(ref)) return $354df6ff51b92897$var$getCheckboxValue(_f.refs).value;
    return $354df6ff51b92897$var$getFieldValueAs($354df6ff51b92897$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $354df6ff51b92897$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
        field && $354df6ff51b92897$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $354df6ff51b92897$var$getRuleValue = (rule)=>$354df6ff51b92897$var$isUndefined(rule) ? rule : $354df6ff51b92897$var$isRegex(rule) ? rule.source : $354df6ff51b92897$var$isObject(rule) ? $354df6ff51b92897$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $354df6ff51b92897$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $354df6ff51b92897$var$schemaErrorLookup(errors, _fields, name) {
    const error = $354df6ff51b92897$export$3988ae62b71be9a3(errors, name);
    if (error || $354df6ff51b92897$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $354df6ff51b92897$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $354df6ff51b92897$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $354df6ff51b92897$var$unsetEmptyArray = (ref, name)=>!$354df6ff51b92897$var$compact($354df6ff51b92897$export$3988ae62b71be9a3(ref, name)).length && $354df6ff51b92897$var$unset(ref, name);
const $354df6ff51b92897$var$defaultOptions = {
    mode: $354df6ff51b92897$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $354df6ff51b92897$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $354df6ff51b92897$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$354df6ff51b92897$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $354df6ff51b92897$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $354df6ff51b92897$var$isObject(_options.defaultValues) || $354df6ff51b92897$var$isObject(_options.values) ? $354df6ff51b92897$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $354df6ff51b92897$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $354df6ff51b92897$var$createSubject(),
        array: $354df6ff51b92897$var$createSubject(),
        state: $354df6ff51b92897$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $354df6ff51b92897$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $354df6ff51b92897$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $354df6ff51b92897$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $354df6ff51b92897$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($354df6ff51b92897$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($354df6ff51b92897$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $354df6ff51b92897$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($354df6ff51b92897$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($354df6ff51b92897$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $354df6ff51b92897$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($354df6ff51b92897$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($354df6ff51b92897$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $354df6ff51b92897$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $354df6ff51b92897$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $354df6ff51b92897$export$3988ae62b71be9a3(_formValues, name, $354df6ff51b92897$var$isUndefined(value1) ? $354df6ff51b92897$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $354df6ff51b92897$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $354df6ff51b92897$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $354df6ff51b92897$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $354df6ff51b92897$var$deepEqual($354df6ff51b92897$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $354df6ff51b92897$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $354df6ff51b92897$var$unset(_formState.dirtyFields, name) : $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $354df6ff51b92897$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $354df6ff51b92897$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $354df6ff51b92897$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $354df6ff51b92897$var$unset(_formState.errors, name);
        }
        if ((error ? !$354df6ff51b92897$var$deepEqual(previousFieldError, error) : previousFieldError) || !$354df6ff51b92897$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $354df6ff51b92897$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $354df6ff51b92897$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $354df6ff51b92897$export$3988ae62b71be9a3(errors, name);
            error ? $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $354df6ff51b92897$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $354df6ff51b92897$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($354df6ff51b92897$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $354df6ff51b92897$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $354df6ff51b92897$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$354df6ff51b92897$var$live(ref)) : !$354df6ff51b92897$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $354df6ff51b92897$export$adaa4cf7ef1b65be(_formValues, name, data), !$354df6ff51b92897$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$354df6ff51b92897$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $354df6ff51b92897$var$isUndefined(defaultValue) ? _defaultValues : $354df6ff51b92897$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$354df6ff51b92897$var$compact($354df6ff51b92897$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $354df6ff51b92897$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $354df6ff51b92897$export$adaa4cf7ef1b65be(_formValues, name, $354df6ff51b92897$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $354df6ff51b92897$var$isHTMLElement(fieldReference.ref) && $354df6ff51b92897$var$isNullOrUndefined(value1) ? "" : value1;
                if ($354df6ff51b92897$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($354df6ff51b92897$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($354df6ff51b92897$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$354df6ff51b92897$var$isPrimitive(fieldValue) || field && !field._f) && !$354df6ff51b92897$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $354df6ff51b92897$var$cloneObject(value1);
        $354df6ff51b92897$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $354df6ff51b92897$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$354df6ff51b92897$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $354df6ff51b92897$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $354df6ff51b92897$var$getFieldValue(field._f) : $354df6ff51b92897$var$getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $354df6ff51b92897$var$EVENTS.BLUR || event.type === $354df6ff51b92897$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$354df6ff51b92897$var$hasValidation(field._f) && !_options.resolver && !$354df6ff51b92897$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $354df6ff51b92897$var$skipValidation(isBlurEvent, $354df6ff51b92897$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $354df6ff51b92897$var$isWatched(name, _names, isBlurEvent);
            $354df6ff51b92897$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$354df6ff51b92897$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $354df6ff51b92897$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $354df6ff51b92897$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $354df6ff51b92897$var$isEmptyObject(errors);
            } else {
                error = (await $354df6ff51b92897$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $354df6ff51b92897$export$3988ae62b71be9a3(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $354df6ff51b92897$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($354df6ff51b92897$var$isUndefined(name) ? name : fieldNames);
            isValid = $354df6ff51b92897$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$354df6ff51b92897$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$354df6ff51b92897$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $354df6ff51b92897$var$focusFieldBy(_fields, (key)=>key && $354df6ff51b92897$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $354df6ff51b92897$var$isUndefined(fieldNames) ? values : $354df6ff51b92897$var$isString(fieldNames) ? $354df6ff51b92897$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$354df6ff51b92897$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$354df6ff51b92897$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$354df6ff51b92897$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$354df6ff51b92897$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $354df6ff51b92897$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $354df6ff51b92897$var$convertToArrayPayload(name).forEach((inputName)=>$354df6ff51b92897$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($354df6ff51b92897$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $354df6ff51b92897$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$354df6ff51b92897$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $354df6ff51b92897$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $354df6ff51b92897$var$unset(_fields, fieldName);
                $354df6ff51b92897$var$unset(_formValues, fieldName);
            }
            !options.keepError && $354df6ff51b92897$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $354df6ff51b92897$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $354df6ff51b92897$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $354df6ff51b92897$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields })=>{
        if ($354df6ff51b92897$var$isBoolean(disabled)) {
            const value1 = disabled ? undefined : $354df6ff51b92897$export$3988ae62b71be9a3(_formValues, name, $354df6ff51b92897$var$getFieldValue(field ? field._f : $354df6ff51b92897$export$3988ae62b71be9a3(fields, name)._f));
            $354df6ff51b92897$export$adaa4cf7ef1b65be(_formValues, name, value1);
            updateTouchAndDirty(name, value1, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $354df6ff51b92897$var$isBoolean(options.disabled);
        $354df6ff51b92897$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $354df6ff51b92897$var$getRuleValue(options.min),
                max: $354df6ff51b92897$var$getRuleValue(options.max),
                minLength: $354df6ff51b92897$var$getRuleValue(options.minLength),
                maxLength: $354df6ff51b92897$var$getRuleValue(options.maxLength),
                pattern: $354df6ff51b92897$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $354df6ff51b92897$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $354df6ff51b92897$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $354df6ff51b92897$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($354df6ff51b92897$var$live),
                                    fieldRef,
                                    ...Array.isArray($354df6ff51b92897$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($354df6ff51b92897$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $354df6ff51b92897$var$focusFieldBy(_fields, (key)=>key && $354df6ff51b92897$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $354df6ff51b92897$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $354df6ff51b92897$var$unset(_formState.errors, "root");
            if ($354df6ff51b92897$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $354df6ff51b92897$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($354df6ff51b92897$export$3988ae62b71be9a3(_fields, name)) {
            if ($354df6ff51b92897$var$isUndefined(options.defaultValue)) setValue(name, $354df6ff51b92897$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $354df6ff51b92897$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $354df6ff51b92897$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $354df6ff51b92897$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $354df6ff51b92897$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $354df6ff51b92897$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $354df6ff51b92897$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $354df6ff51b92897$var$cloneObject(updatedValues);
        const values = formValues && !$354df6ff51b92897$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$354df6ff51b92897$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $354df6ff51b92897$export$adaa4cf7ef1b65be(values, fieldName, $354df6ff51b92897$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $354df6ff51b92897$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($354df6ff51b92897$var$isWeb && $354df6ff51b92897$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($354df6ff51b92897$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $354df6ff51b92897$var$cloneObject(_defaultValues) : {} : $354df6ff51b92897$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$354df6ff51b92897$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $354df6ff51b92897$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($354df6ff51b92897$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $354df6ff51b92897$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$354df6ff51b92897$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $354df6ff51b92897$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $354df6ff51b92897$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: $354df6ff51b92897$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$354df6ff51b92897$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $354df6ff51b92897$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($354df6ff51b92897$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (props.values && !$354df6ff51b92897$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $354df6ff51b92897$var$getProxyFormState(formState, control);
    return _formControl.current;
}



var $998b2cd56352ba5f$var$e = function(i, e, t) {
    if (i && "reportValidity" in i) {
        var f = (0, $354df6ff51b92897$export$3988ae62b71be9a3)(t, e);
        i.setCustomValidity(f && f.message || ""), i.reportValidity();
    }
}, $998b2cd56352ba5f$export$6bd436d70894afff = function(r, i) {
    var t = function(t) {
        var f = i.fields[t];
        f && f.ref && "reportValidity" in f.ref ? $998b2cd56352ba5f$var$e(f.ref, t, r) : f.refs && f.refs.forEach(function(i) {
            return $998b2cd56352ba5f$var$e(i, t, r);
        });
    };
    for(var f in i.fields)t(f);
}, $998b2cd56352ba5f$export$3cfb7e8a4d7a0630 = function(e, f) {
    f.shouldUseNativeValidation && $998b2cd56352ba5f$export$6bd436d70894afff(e, f);
    var o = {};
    for(var a in e){
        var n = (0, $354df6ff51b92897$export$3988ae62b71be9a3)(f.fields, a);
        (0, $354df6ff51b92897$export$adaa4cf7ef1b65be)(o, a, Object.assign(e[a], {
            ref: n && n.ref
        }));
    }
    return o;
};



var $de3022907c3640b7$export$d55832dfcd4989a = function(o, n, a) {
    return void 0 === n && (n = {}), void 0 === a && (a = {}), function(s, i, c) {
        try {
            return Promise.resolve(function(t, r) {
                try {
                    var u = (n.context, Promise.resolve(o["sync" === a.mode ? "validateSync" : "validate"](s, Object.assign({
                        abortEarly: !1
                    }, n, {
                        context: i
                    }))).then(function(t) {
                        return c.shouldUseNativeValidation && (0, $998b2cd56352ba5f$export$6bd436d70894afff)({}, c), {
                            values: a.rawValues ? s : t,
                            errors: {}
                        };
                    }));
                } catch (e) {
                    return r(e);
                }
                return u && u.then ? u.then(void 0, r) : u;
            }(0, function(e) {
                if (!e.inner) throw e;
                var o, n;
                return {
                    values: {},
                    errors: (0, $998b2cd56352ba5f$export$3cfb7e8a4d7a0630)((o = e, n = !c.shouldUseNativeValidation && "all" === c.criteriaMode, (o.inner || []).reduce(function(e, t) {
                        if (e[t.path] || (e[t.path] = {
                            message: t.message,
                            type: t.type
                        }), n) {
                            var o = e[t.path].types, a = o && o[t.type];
                            e[t.path] = (0, $354df6ff51b92897$export$b196c2a4f765bd30)(t.path, n, e, t.type, a ? [].concat(a, t.message) : t.message);
                        }
                        return e;
                    }, {})), c)
                };
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
};


// ES6 Map
var $979e0bbd1ac83ec6$var$map;
try {
    $979e0bbd1ac83ec6$var$map = Map;
} catch (_) {}
var $979e0bbd1ac83ec6$var$set;
// ES6 Set
try {
    $979e0bbd1ac83ec6$var$set = Set;
} catch (_) {}
function $979e0bbd1ac83ec6$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== "object" || typeof src === "function") return src;
    // DOM Node
    if (src.nodeType && "cloneNode" in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($979e0bbd1ac83ec6$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($979e0bbd1ac83ec6$var$map && src instanceof $979e0bbd1ac83ec6$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($979e0bbd1ac83ec6$var$set && src instanceof $979e0bbd1ac83ec6$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $979e0bbd1ac83ec6$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $979e0bbd1ac83ec6$export$2e2bcd8739ae039(src) {
    return $979e0bbd1ac83ec6$var$baseClone(src, [], []);
}


const $0885a840b432a241$var$toString = Object.prototype.toString;
const $0885a840b432a241$var$errorToString = Error.prototype.toString;
const $0885a840b432a241$var$regExpToString = RegExp.prototype.toString;
const $0885a840b432a241$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $0885a840b432a241$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $0885a840b432a241$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $0885a840b432a241$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $0885a840b432a241$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $0885a840b432a241$var$symbolToString.call(val).replace($0885a840b432a241$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $0885a840b432a241$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $0885a840b432a241$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $0885a840b432a241$var$regExpToString.call(val);
    return null;
}
function $0885a840b432a241$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $0885a840b432a241$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $0885a840b432a241$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $79208d289975beed$export$9b30b6294c1449a8 = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $0885a840b432a241$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $0885a840b432a241$export$2e2bcd8739ae039)(originalValue, true)}\`).` : ".");
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: "${path} must be defined"
};
let $79208d289975beed$export$22b082955e083ec3 = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $79208d289975beed$export$98e628dec113755e = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $79208d289975beed$export$324d90190a8b822a = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $79208d289975beed$export$4a21f16c33752377 = {
    isValue: "${path} field must be ${value}"
};
let $79208d289975beed$export$be5493f9613cbbe = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $79208d289975beed$export$2f23118c22fb2630 = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
var $79208d289975beed$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $79208d289975beed$export$9b30b6294c1449a8,
    string: $79208d289975beed$export$22b082955e083ec3,
    number: $79208d289975beed$export$98e628dec113755e,
    date: $79208d289975beed$export$324d90190a8b822a,
    object: $79208d289975beed$export$be5493f9613cbbe,
    array: $79208d289975beed$export$2f23118c22fb2630,
    boolean: $79208d289975beed$export$4a21f16c33752377
});


var $678145309e69eaa8$exports = {};
var $6b1e3de1598e8e23$exports = {};
/** Used for built-in method references. */ var $6b1e3de1598e8e23$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6b1e3de1598e8e23$var$hasOwnProperty = $6b1e3de1598e8e23$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $6b1e3de1598e8e23$var$baseHas(object, key) {
    return object != null && $6b1e3de1598e8e23$var$hasOwnProperty.call(object, key);
}
$6b1e3de1598e8e23$exports = $6b1e3de1598e8e23$var$baseHas;


var $f29e6f17be0e64f1$exports = {};
var $026916563a5fc8ad$exports = {};
var $8cb3ae215df00a00$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $8cb3ae215df00a00$var$isArray = Array.isArray;
$8cb3ae215df00a00$exports = $8cb3ae215df00a00$var$isArray;


var $ebf30b1c72800438$exports = {};

var $b7350b23d035986b$exports = {};
var $852d1f971b259156$exports = {};
var $a090581360ce8173$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Built-in value references. */ var $a090581360ce8173$var$Symbol = $8ThvE.Symbol;
$a090581360ce8173$exports = $a090581360ce8173$var$Symbol;


var $f2cc4cee927d37c7$exports = {};

/** Used for built-in method references. */ var $f2cc4cee927d37c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2cc4cee927d37c7$var$hasOwnProperty = $f2cc4cee927d37c7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2cc4cee927d37c7$var$nativeObjectToString = $f2cc4cee927d37c7$var$objectProto.toString;
/** Built-in value references. */ var $f2cc4cee927d37c7$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f2cc4cee927d37c7$var$getRawTag(value) {
    var isOwn = $f2cc4cee927d37c7$var$hasOwnProperty.call(value, $f2cc4cee927d37c7$var$symToStringTag), tag = value[$f2cc4cee927d37c7$var$symToStringTag];
    try {
        value[$f2cc4cee927d37c7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f2cc4cee927d37c7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f2cc4cee927d37c7$var$symToStringTag] = tag;
        else delete value[$f2cc4cee927d37c7$var$symToStringTag];
    }
    return result;
}
$f2cc4cee927d37c7$exports = $f2cc4cee927d37c7$var$getRawTag;


var $934b51efa189f09c$exports = {};
/** Used for built-in method references. */ var $934b51efa189f09c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $934b51efa189f09c$var$nativeObjectToString = $934b51efa189f09c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $934b51efa189f09c$var$objectToString(value) {
    return $934b51efa189f09c$var$nativeObjectToString.call(value);
}
$934b51efa189f09c$exports = $934b51efa189f09c$var$objectToString;


/** `Object#toString` result references. */ var $852d1f971b259156$var$nullTag = "[object Null]", $852d1f971b259156$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $852d1f971b259156$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $852d1f971b259156$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $852d1f971b259156$var$undefinedTag : $852d1f971b259156$var$nullTag;
    return $852d1f971b259156$var$symToStringTag && $852d1f971b259156$var$symToStringTag in Object(value) ? $f2cc4cee927d37c7$exports(value) : $934b51efa189f09c$exports(value);
}
$852d1f971b259156$exports = $852d1f971b259156$var$baseGetTag;


var $5475ba594a8bdf91$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5475ba594a8bdf91$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$5475ba594a8bdf91$exports = $5475ba594a8bdf91$var$isObjectLike;


/** `Object#toString` result references. */ var $b7350b23d035986b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7350b23d035986b$var$isSymbol(value) {
    return typeof value == "symbol" || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $b7350b23d035986b$var$symbolTag;
}
$b7350b23d035986b$exports = $b7350b23d035986b$var$isSymbol;


/** Used to match property names within property paths. */ var $ebf30b1c72800438$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $ebf30b1c72800438$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $ebf30b1c72800438$var$isKey(value, object) {
    if ($8cb3ae215df00a00$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $b7350b23d035986b$exports(value)) return true;
    return $ebf30b1c72800438$var$reIsPlainProp.test(value) || !$ebf30b1c72800438$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$ebf30b1c72800438$exports = $ebf30b1c72800438$var$isKey;


var $2171f479fe1b9e27$exports = {};
var $b8ba2ed78ec192fa$exports = {};
var $af3456543921feb4$exports = {};
var $f6389c21d76f2f82$exports = {};
var $b06f33fda863a736$exports = {};
var $1e733182a9700f13$exports = {};
var $8fe1870119bc2ce4$exports = {};
var $1a89124de4ced368$exports = {};
var $97e6c72a80d118d2$exports = {};
var $105e649bd3deec51$exports = {};
var $63bef038e059393f$exports = {};

var $db5dfd0661742a1a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $db5dfd0661742a1a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$db5dfd0661742a1a$exports = $db5dfd0661742a1a$var$isObject;


/** `Object#toString` result references. */ var $63bef038e059393f$var$asyncTag = "[object AsyncFunction]", $63bef038e059393f$var$funcTag = "[object Function]", $63bef038e059393f$var$genTag = "[object GeneratorFunction]", $63bef038e059393f$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $63bef038e059393f$var$isFunction(value) {
    if (!$db5dfd0661742a1a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $852d1f971b259156$exports(value);
    return tag == $63bef038e059393f$var$funcTag || tag == $63bef038e059393f$var$genTag || tag == $63bef038e059393f$var$asyncTag || tag == $63bef038e059393f$var$proxyTag;
}
$63bef038e059393f$exports = $63bef038e059393f$var$isFunction;


var $989d09d10c86a3af$exports = {};
var $69576d09d95c0935$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Used to detect overreaching core-js shims. */ var $69576d09d95c0935$var$coreJsData = $8ThvE["__core-js_shared__"];
$69576d09d95c0935$exports = $69576d09d95c0935$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $989d09d10c86a3af$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($69576d09d95c0935$exports && $69576d09d95c0935$exports.keys && $69576d09d95c0935$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $989d09d10c86a3af$var$isMasked(func) {
    return !!$989d09d10c86a3af$var$maskSrcKey && $989d09d10c86a3af$var$maskSrcKey in func;
}
$989d09d10c86a3af$exports = $989d09d10c86a3af$var$isMasked;



var $3d1b4ae41857d3b0$exports = {};
/** Used for built-in method references. */ var $3d1b4ae41857d3b0$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3d1b4ae41857d3b0$var$funcToString = $3d1b4ae41857d3b0$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3d1b4ae41857d3b0$var$toSource(func) {
    if (func != null) {
        try {
            return $3d1b4ae41857d3b0$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$3d1b4ae41857d3b0$exports = $3d1b4ae41857d3b0$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $105e649bd3deec51$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $105e649bd3deec51$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $105e649bd3deec51$var$funcProto = Function.prototype, $105e649bd3deec51$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $105e649bd3deec51$var$funcToString = $105e649bd3deec51$var$funcProto.toString;
/** Used to check objects for own properties. */ var $105e649bd3deec51$var$hasOwnProperty = $105e649bd3deec51$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $105e649bd3deec51$var$reIsNative = RegExp("^" + $105e649bd3deec51$var$funcToString.call($105e649bd3deec51$var$hasOwnProperty).replace($105e649bd3deec51$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $105e649bd3deec51$var$baseIsNative(value) {
    if (!$db5dfd0661742a1a$exports(value) || $989d09d10c86a3af$exports(value)) return false;
    var pattern = $63bef038e059393f$exports(value) ? $105e649bd3deec51$var$reIsNative : $105e649bd3deec51$var$reIsHostCtor;
    return pattern.test($3d1b4ae41857d3b0$exports(value));
}
$105e649bd3deec51$exports = $105e649bd3deec51$var$baseIsNative;


var $5c63d0177b86ffa5$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $5c63d0177b86ffa5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$5c63d0177b86ffa5$exports = $5c63d0177b86ffa5$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $97e6c72a80d118d2$var$getNative(object, key) {
    var value = $5c63d0177b86ffa5$exports(object, key);
    return $105e649bd3deec51$exports(value) ? value : undefined;
}
$97e6c72a80d118d2$exports = $97e6c72a80d118d2$var$getNative;


/* Built-in method references that are verified to be native. */ var $1a89124de4ced368$var$nativeCreate = $97e6c72a80d118d2$exports(Object, "create");
$1a89124de4ced368$exports = $1a89124de4ced368$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $8fe1870119bc2ce4$var$hashClear() {
    this.__data__ = $1a89124de4ced368$exports ? $1a89124de4ced368$exports(null) : {};
    this.size = 0;
}
$8fe1870119bc2ce4$exports = $8fe1870119bc2ce4$var$hashClear;


var $7b046508d0c4b2bb$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7b046508d0c4b2bb$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$7b046508d0c4b2bb$exports = $7b046508d0c4b2bb$var$hashDelete;


var $570123ba6240e679$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $570123ba6240e679$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $570123ba6240e679$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $570123ba6240e679$var$hasOwnProperty = $570123ba6240e679$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $570123ba6240e679$var$hashGet(key) {
    var data = this.__data__;
    if ($1a89124de4ced368$exports) {
        var result = data[key];
        return result === $570123ba6240e679$var$HASH_UNDEFINED ? undefined : result;
    }
    return $570123ba6240e679$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$570123ba6240e679$exports = $570123ba6240e679$var$hashGet;


var $75e6b0027cb55f48$exports = {};

/** Used for built-in method references. */ var $75e6b0027cb55f48$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75e6b0027cb55f48$var$hasOwnProperty = $75e6b0027cb55f48$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $75e6b0027cb55f48$var$hashHas(key) {
    var data = this.__data__;
    return $1a89124de4ced368$exports ? data[key] !== undefined : $75e6b0027cb55f48$var$hasOwnProperty.call(data, key);
}
$75e6b0027cb55f48$exports = $75e6b0027cb55f48$var$hashHas;


var $315cb19b5f7dc6c3$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $315cb19b5f7dc6c3$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $315cb19b5f7dc6c3$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $1a89124de4ced368$exports && value === undefined ? $315cb19b5f7dc6c3$var$HASH_UNDEFINED : value;
    return this;
}
$315cb19b5f7dc6c3$exports = $315cb19b5f7dc6c3$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1e733182a9700f13$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$1e733182a9700f13$var$Hash.prototype.clear = $8fe1870119bc2ce4$exports;
$1e733182a9700f13$var$Hash.prototype["delete"] = $7b046508d0c4b2bb$exports;
$1e733182a9700f13$var$Hash.prototype.get = $570123ba6240e679$exports;
$1e733182a9700f13$var$Hash.prototype.has = $75e6b0027cb55f48$exports;
$1e733182a9700f13$var$Hash.prototype.set = $315cb19b5f7dc6c3$exports;
$1e733182a9700f13$exports = $1e733182a9700f13$var$Hash;


var $9655ef897f0bbdba$exports = {};
var $ed640afc4605eeaf$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $ed640afc4605eeaf$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$ed640afc4605eeaf$exports = $ed640afc4605eeaf$var$listCacheClear;


var $8dacab0aad959c1a$exports = {};
var $a5c18ae4f7c751db$exports = {};
var $6f80be9883321bbe$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6f80be9883321bbe$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$6f80be9883321bbe$exports = $6f80be9883321bbe$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a5c18ae4f7c751db$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6f80be9883321bbe$exports(array[length][0], key)) return length;
    }
    return -1;
}
$a5c18ae4f7c751db$exports = $a5c18ae4f7c751db$var$assocIndexOf;


/** Used for built-in method references. */ var $8dacab0aad959c1a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8dacab0aad959c1a$var$splice = $8dacab0aad959c1a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8dacab0aad959c1a$var$listCacheDelete(key) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8dacab0aad959c1a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$8dacab0aad959c1a$exports = $8dacab0aad959c1a$var$listCacheDelete;


var $822f7d857aa2dcb8$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $822f7d857aa2dcb8$var$listCacheGet(key) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$822f7d857aa2dcb8$exports = $822f7d857aa2dcb8$var$listCacheGet;


var $5edb34374c74a495$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5edb34374c74a495$var$listCacheHas(key) {
    return $a5c18ae4f7c751db$exports(this.__data__, key) > -1;
}
$5edb34374c74a495$exports = $5edb34374c74a495$var$listCacheHas;


var $315b693937a70245$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $315b693937a70245$var$listCacheSet(key, value) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$315b693937a70245$exports = $315b693937a70245$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9655ef897f0bbdba$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$9655ef897f0bbdba$var$ListCache.prototype.clear = $ed640afc4605eeaf$exports;
$9655ef897f0bbdba$var$ListCache.prototype["delete"] = $8dacab0aad959c1a$exports;
$9655ef897f0bbdba$var$ListCache.prototype.get = $822f7d857aa2dcb8$exports;
$9655ef897f0bbdba$var$ListCache.prototype.has = $5edb34374c74a495$exports;
$9655ef897f0bbdba$var$ListCache.prototype.set = $315b693937a70245$exports;
$9655ef897f0bbdba$exports = $9655ef897f0bbdba$var$ListCache;


var $1b8f1205e4056240$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $1b8f1205e4056240$var$Map = $97e6c72a80d118d2$exports($8ThvE, "Map");
$1b8f1205e4056240$exports = $1b8f1205e4056240$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b06f33fda863a736$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $1e733182a9700f13$exports,
        "map": new ($1b8f1205e4056240$exports || $9655ef897f0bbdba$exports),
        "string": new $1e733182a9700f13$exports
    };
}
$b06f33fda863a736$exports = $b06f33fda863a736$var$mapCacheClear;


var $5f4eea80c864f4a3$exports = {};
var $ee96f1b7eaa44ac5$exports = {};
var $3bd39081531a18a3$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $3bd39081531a18a3$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$3bd39081531a18a3$exports = $3bd39081531a18a3$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ee96f1b7eaa44ac5$var$getMapData(map, key) {
    var data = map.__data__;
    return $3bd39081531a18a3$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$ee96f1b7eaa44ac5$exports = $ee96f1b7eaa44ac5$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5f4eea80c864f4a3$var$mapCacheDelete(key) {
    var result = $ee96f1b7eaa44ac5$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$5f4eea80c864f4a3$exports = $5f4eea80c864f4a3$var$mapCacheDelete;


var $54d2d6191fb8ab24$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $54d2d6191fb8ab24$var$mapCacheGet(key) {
    return $ee96f1b7eaa44ac5$exports(this, key).get(key);
}
$54d2d6191fb8ab24$exports = $54d2d6191fb8ab24$var$mapCacheGet;


var $e8338a2a89515313$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8338a2a89515313$var$mapCacheHas(key) {
    return $ee96f1b7eaa44ac5$exports(this, key).has(key);
}
$e8338a2a89515313$exports = $e8338a2a89515313$var$mapCacheHas;


var $26a7fc4b70d5469b$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $26a7fc4b70d5469b$var$mapCacheSet(key, value) {
    var data = $ee96f1b7eaa44ac5$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$26a7fc4b70d5469b$exports = $26a7fc4b70d5469b$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f6389c21d76f2f82$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$f6389c21d76f2f82$var$MapCache.prototype.clear = $b06f33fda863a736$exports;
$f6389c21d76f2f82$var$MapCache.prototype["delete"] = $5f4eea80c864f4a3$exports;
$f6389c21d76f2f82$var$MapCache.prototype.get = $54d2d6191fb8ab24$exports;
$f6389c21d76f2f82$var$MapCache.prototype.has = $e8338a2a89515313$exports;
$f6389c21d76f2f82$var$MapCache.prototype.set = $26a7fc4b70d5469b$exports;
$f6389c21d76f2f82$exports = $f6389c21d76f2f82$var$MapCache;


/** Error message constants. */ var $af3456543921feb4$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $af3456543921feb4$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($af3456543921feb4$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($af3456543921feb4$var$memoize.Cache || $f6389c21d76f2f82$exports);
    return memoized;
}
// Expose `MapCache`.
$af3456543921feb4$var$memoize.Cache = $f6389c21d76f2f82$exports;
$af3456543921feb4$exports = $af3456543921feb4$var$memoize;


/** Used as the maximum memoize cache size. */ var $b8ba2ed78ec192fa$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b8ba2ed78ec192fa$var$memoizeCapped(func) {
    var result = $af3456543921feb4$exports(func, function(key) {
        if (cache.size === $b8ba2ed78ec192fa$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$b8ba2ed78ec192fa$exports = $b8ba2ed78ec192fa$var$memoizeCapped;


/** Used to match property names within property paths. */ var $2171f479fe1b9e27$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $2171f479fe1b9e27$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2171f479fe1b9e27$var$stringToPath = $b8ba2ed78ec192fa$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($2171f479fe1b9e27$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($2171f479fe1b9e27$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$2171f479fe1b9e27$exports = $2171f479fe1b9e27$var$stringToPath;


var $22f1dff9b3c6ff0c$exports = {};
var $c59f41c766f8804e$exports = {};

var $c0d7b47ee8b12bf1$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $c0d7b47ee8b12bf1$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$c0d7b47ee8b12bf1$exports = $c0d7b47ee8b12bf1$var$arrayMap;




/** Used as references for various `Number` constants. */ var $c59f41c766f8804e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $c59f41c766f8804e$var$symbolProto = $a090581360ce8173$exports ? $a090581360ce8173$exports.prototype : undefined, $c59f41c766f8804e$var$symbolToString = $c59f41c766f8804e$var$symbolProto ? $c59f41c766f8804e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $c59f41c766f8804e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($8cb3ae215df00a00$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $c0d7b47ee8b12bf1$exports(value, $c59f41c766f8804e$var$baseToString) + "";
    if ($b7350b23d035986b$exports(value)) return $c59f41c766f8804e$var$symbolToString ? $c59f41c766f8804e$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$c59f41c766f8804e$var$INFINITY ? "-0" : result;
}
$c59f41c766f8804e$exports = $c59f41c766f8804e$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $22f1dff9b3c6ff0c$var$toString(value) {
    return value == null ? "" : $c59f41c766f8804e$exports(value);
}
$22f1dff9b3c6ff0c$exports = $22f1dff9b3c6ff0c$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $026916563a5fc8ad$var$castPath(value, object) {
    if ($8cb3ae215df00a00$exports(value)) return value;
    return $ebf30b1c72800438$exports(value, object) ? [
        value
    ] : $2171f479fe1b9e27$exports($22f1dff9b3c6ff0c$exports(value));
}
$026916563a5fc8ad$exports = $026916563a5fc8ad$var$castPath;


var $c09020d853f4dd56$exports = {};
var $673e072344569ebe$exports = {};


/** `Object#toString` result references. */ var $673e072344569ebe$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $673e072344569ebe$var$baseIsArguments(value) {
    return $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $673e072344569ebe$var$argsTag;
}
$673e072344569ebe$exports = $673e072344569ebe$var$baseIsArguments;



/** Used for built-in method references. */ var $c09020d853f4dd56$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c09020d853f4dd56$var$hasOwnProperty = $c09020d853f4dd56$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $c09020d853f4dd56$var$propertyIsEnumerable = $c09020d853f4dd56$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $c09020d853f4dd56$var$isArguments = $673e072344569ebe$exports(function() {
    return arguments;
}()) ? $673e072344569ebe$exports : function(value) {
    return $5475ba594a8bdf91$exports(value) && $c09020d853f4dd56$var$hasOwnProperty.call(value, "callee") && !$c09020d853f4dd56$var$propertyIsEnumerable.call(value, "callee");
};
$c09020d853f4dd56$exports = $c09020d853f4dd56$var$isArguments;



var $1a5c8861aefb5e25$exports = {};
/** Used as references for various `Number` constants. */ var $1a5c8861aefb5e25$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $1a5c8861aefb5e25$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1a5c8861aefb5e25$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $1a5c8861aefb5e25$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $1a5c8861aefb5e25$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$1a5c8861aefb5e25$exports = $1a5c8861aefb5e25$var$isIndex;


var $9ad3d04370aa37c9$exports = {};
/** Used as references for various `Number` constants. */ var $9ad3d04370aa37c9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $9ad3d04370aa37c9$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $9ad3d04370aa37c9$var$MAX_SAFE_INTEGER;
}
$9ad3d04370aa37c9$exports = $9ad3d04370aa37c9$var$isLength;


var $e56d6cac75d4b6e0$exports = {};

/** Used as references for various `Number` constants. */ var $e56d6cac75d4b6e0$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e56d6cac75d4b6e0$var$toKey(value) {
    if (typeof value == "string" || $b7350b23d035986b$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$e56d6cac75d4b6e0$var$INFINITY ? "-0" : result;
}
$e56d6cac75d4b6e0$exports = $e56d6cac75d4b6e0$var$toKey;


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $f29e6f17be0e64f1$var$hasPath(object, path, hasFunc) {
    path = $026916563a5fc8ad$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $e56d6cac75d4b6e0$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $9ad3d04370aa37c9$exports(length) && $1a5c8861aefb5e25$exports(key, length) && ($8cb3ae215df00a00$exports(object) || $c09020d853f4dd56$exports(object));
}
$f29e6f17be0e64f1$exports = $f29e6f17be0e64f1$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $678145309e69eaa8$var$has(object, path) {
    return object != null && $f29e6f17be0e64f1$exports(object, path, $6b1e3de1598e8e23$exports);
}
$678145309e69eaa8$exports = $678145309e69eaa8$var$has;


const $ba7da153f070367d$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $ba7da153f070367d$export$2e2bcd8739ae039 = $ba7da153f070367d$var$isSchema;


class $d6dfdf3732f6dbe9$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === "function") {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($678145309e69eaa8$exports)))(options, "is")) throw new TypeError("`is:` is required for `when()` conditions");
        if (!options.then && !options.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === "function") return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $ba7da153f070367d$export$2e2bcd8739ae039)(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
var $d6dfdf3732f6dbe9$export$2e2bcd8739ae039 = $d6dfdf3732f6dbe9$var$Condition;



function $f01de86bb88c5ce8$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $a38c42bc1e8b64e5$var$_extends() {
    $a38c42bc1e8b64e5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a38c42bc1e8b64e5$var$_extends.apply(this, arguments);
}
let $a38c42bc1e8b64e5$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $a38c42bc1e8b64e5$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = $a38c42bc1e8b64e5$var$_extends({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($a38c42bc1e8b64e5$var$strReg, (_, key)=>(0, $0885a840b432a241$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $f01de86bb88c5ce8$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($a38c42bc1e8b64e5$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $a38c42bc1e8b64e5$export$2e2bcd8739ae039);
    }
}


const $62970f7dacccb3a4$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $62970f7dacccb3a4$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $62970f7dacccb3a4$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $b3b422bbfdb589b3$exports = {};
var $48f1054f3ca5da26$exports = {};
var $f6dfd7dc5e5ac807$exports = {};

var $f6dfd7dc5e5ac807$var$defineProperty = function() {
    try {
        var func = $97e6c72a80d118d2$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$f6dfd7dc5e5ac807$exports = $f6dfd7dc5e5ac807$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $48f1054f3ca5da26$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $f6dfd7dc5e5ac807$exports) $f6dfd7dc5e5ac807$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$48f1054f3ca5da26$exports = $48f1054f3ca5da26$var$baseAssignValue;


var $c40d9c5aec6b4ec6$exports = {};
var $964779a63aa00972$exports = {};
var $5167005b932b675c$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $5167005b932b675c$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$5167005b932b675c$exports = $5167005b932b675c$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $964779a63aa00972$var$baseFor = $5167005b932b675c$exports();
$964779a63aa00972$exports = $964779a63aa00972$var$baseFor;


var $b104760b34d6b7b1$exports = {};
var $1a01a48c6e6e7ac2$exports = {};
var $29cd5707c05bf6b8$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $29cd5707c05bf6b8$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$29cd5707c05bf6b8$exports = $29cd5707c05bf6b8$var$baseTimes;





var $7HKs8 = parcelRequire("7HKs8");

var $32e7db2a0777bb6d$exports = {};
var $404e7686b4834cf1$exports = {};



/** `Object#toString` result references. */ var $404e7686b4834cf1$var$argsTag = "[object Arguments]", $404e7686b4834cf1$var$arrayTag = "[object Array]", $404e7686b4834cf1$var$boolTag = "[object Boolean]", $404e7686b4834cf1$var$dateTag = "[object Date]", $404e7686b4834cf1$var$errorTag = "[object Error]", $404e7686b4834cf1$var$funcTag = "[object Function]", $404e7686b4834cf1$var$mapTag = "[object Map]", $404e7686b4834cf1$var$numberTag = "[object Number]", $404e7686b4834cf1$var$objectTag = "[object Object]", $404e7686b4834cf1$var$regexpTag = "[object RegExp]", $404e7686b4834cf1$var$setTag = "[object Set]", $404e7686b4834cf1$var$stringTag = "[object String]", $404e7686b4834cf1$var$weakMapTag = "[object WeakMap]";
var $404e7686b4834cf1$var$arrayBufferTag = "[object ArrayBuffer]", $404e7686b4834cf1$var$dataViewTag = "[object DataView]", $404e7686b4834cf1$var$float32Tag = "[object Float32Array]", $404e7686b4834cf1$var$float64Tag = "[object Float64Array]", $404e7686b4834cf1$var$int8Tag = "[object Int8Array]", $404e7686b4834cf1$var$int16Tag = "[object Int16Array]", $404e7686b4834cf1$var$int32Tag = "[object Int32Array]", $404e7686b4834cf1$var$uint8Tag = "[object Uint8Array]", $404e7686b4834cf1$var$uint8ClampedTag = "[object Uint8ClampedArray]", $404e7686b4834cf1$var$uint16Tag = "[object Uint16Array]", $404e7686b4834cf1$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $404e7686b4834cf1$var$typedArrayTags = {};
$404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$float32Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$float64Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int8Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int16Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int32Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint8Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint8ClampedTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint16Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint32Tag] = true;
$404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$argsTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$arrayTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$arrayBufferTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$boolTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$dataViewTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$dateTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$errorTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$funcTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$mapTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$numberTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$objectTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$regexpTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$setTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$stringTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $404e7686b4834cf1$var$baseIsTypedArray(value) {
    return $5475ba594a8bdf91$exports(value) && $9ad3d04370aa37c9$exports(value.length) && !!$404e7686b4834cf1$var$typedArrayTags[$852d1f971b259156$exports(value)];
}
$404e7686b4834cf1$exports = $404e7686b4834cf1$var$baseIsTypedArray;


var $a37b20fb7156577b$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a37b20fb7156577b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$a37b20fb7156577b$exports = $a37b20fb7156577b$var$baseUnary;



var $7vc1R = parcelRequire("7vc1R");
/* Node.js helper references. */ var $32e7db2a0777bb6d$var$nodeIsTypedArray = $7vc1R && $7vc1R.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $32e7db2a0777bb6d$var$isTypedArray = $32e7db2a0777bb6d$var$nodeIsTypedArray ? $a37b20fb7156577b$exports($32e7db2a0777bb6d$var$nodeIsTypedArray) : $404e7686b4834cf1$exports;
$32e7db2a0777bb6d$exports = $32e7db2a0777bb6d$var$isTypedArray;


/** Used for built-in method references. */ var $1a01a48c6e6e7ac2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1a01a48c6e6e7ac2$var$hasOwnProperty = $1a01a48c6e6e7ac2$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1a01a48c6e6e7ac2$var$arrayLikeKeys(value, inherited) {
    var isArr = $8cb3ae215df00a00$exports(value), isArg = !isArr && $c09020d853f4dd56$exports(value), isBuff = !isArr && !isArg && $7HKs8(value), isType = !isArr && !isArg && !isBuff && $32e7db2a0777bb6d$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $29cd5707c05bf6b8$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1a01a48c6e6e7ac2$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $1a5c8861aefb5e25$exports(key, length)))) result.push(key);
    return result;
}
$1a01a48c6e6e7ac2$exports = $1a01a48c6e6e7ac2$var$arrayLikeKeys;


var $eb634362e8bab00b$exports = {};
var $9fb63971f28e98ce$exports = {};
/** Used for built-in method references. */ var $9fb63971f28e98ce$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $9fb63971f28e98ce$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $9fb63971f28e98ce$var$objectProto;
    return value === proto;
}
$9fb63971f28e98ce$exports = $9fb63971f28e98ce$var$isPrototype;


var $d1eeca103b9aa761$exports = {};
var $10bd1c09b9f64069$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $10bd1c09b9f64069$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$10bd1c09b9f64069$exports = $10bd1c09b9f64069$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $d1eeca103b9aa761$var$nativeKeys = $10bd1c09b9f64069$exports(Object.keys, Object);
$d1eeca103b9aa761$exports = $d1eeca103b9aa761$var$nativeKeys;


/** Used for built-in method references. */ var $eb634362e8bab00b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eb634362e8bab00b$var$hasOwnProperty = $eb634362e8bab00b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $eb634362e8bab00b$var$baseKeys(object) {
    if (!$9fb63971f28e98ce$exports(object)) return $d1eeca103b9aa761$exports(object);
    var result = [];
    for(var key in Object(object))if ($eb634362e8bab00b$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$eb634362e8bab00b$exports = $eb634362e8bab00b$var$baseKeys;


var $887f7dd95a2dee62$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $887f7dd95a2dee62$var$isArrayLike(value) {
    return value != null && $9ad3d04370aa37c9$exports(value.length) && !$63bef038e059393f$exports(value);
}
$887f7dd95a2dee62$exports = $887f7dd95a2dee62$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $b104760b34d6b7b1$var$keys(object) {
    return $887f7dd95a2dee62$exports(object) ? $1a01a48c6e6e7ac2$exports(object) : $eb634362e8bab00b$exports(object);
}
$b104760b34d6b7b1$exports = $b104760b34d6b7b1$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $c40d9c5aec6b4ec6$var$baseForOwn(object, iteratee) {
    return object && $964779a63aa00972$exports(object, iteratee, $b104760b34d6b7b1$exports);
}
$c40d9c5aec6b4ec6$exports = $c40d9c5aec6b4ec6$var$baseForOwn;


var $52849359d0c345c9$exports = {};
var $1a6ab9420533a54c$exports = {};
var $85df9b6b26a2a3d6$exports = {};
var $8bfbce7e35b86105$exports = {};

var $f4765b9de3cd25a2$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f4765b9de3cd25a2$var$stackClear() {
    this.__data__ = new $9655ef897f0bbdba$exports;
    this.size = 0;
}
$f4765b9de3cd25a2$exports = $f4765b9de3cd25a2$var$stackClear;


var $4e48da7de9bc0080$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4e48da7de9bc0080$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$4e48da7de9bc0080$exports = $4e48da7de9bc0080$var$stackDelete;


var $21c09588dffa6b32$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $21c09588dffa6b32$var$stackGet(key) {
    return this.__data__.get(key);
}
$21c09588dffa6b32$exports = $21c09588dffa6b32$var$stackGet;


var $2739006159eb7a0c$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2739006159eb7a0c$var$stackHas(key) {
    return this.__data__.has(key);
}
$2739006159eb7a0c$exports = $2739006159eb7a0c$var$stackHas;


var $0ab5431b23eb293c$exports = {};



/** Used as the size to enable large array optimizations. */ var $0ab5431b23eb293c$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $0ab5431b23eb293c$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $9655ef897f0bbdba$exports) {
        var pairs = data.__data__;
        if (!$1b8f1205e4056240$exports || pairs.length < $0ab5431b23eb293c$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $f6389c21d76f2f82$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$0ab5431b23eb293c$exports = $0ab5431b23eb293c$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8bfbce7e35b86105$var$Stack(entries) {
    var data = this.__data__ = new $9655ef897f0bbdba$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8bfbce7e35b86105$var$Stack.prototype.clear = $f4765b9de3cd25a2$exports;
$8bfbce7e35b86105$var$Stack.prototype["delete"] = $4e48da7de9bc0080$exports;
$8bfbce7e35b86105$var$Stack.prototype.get = $21c09588dffa6b32$exports;
$8bfbce7e35b86105$var$Stack.prototype.has = $2739006159eb7a0c$exports;
$8bfbce7e35b86105$var$Stack.prototype.set = $0ab5431b23eb293c$exports;
$8bfbce7e35b86105$exports = $8bfbce7e35b86105$var$Stack;


var $6219f680e6e19178$exports = {};
var $bfbd466526f8d698$exports = {};

var $d78075cec53d5845$exports = {};
var $32da07863e46acec$exports = {};

var $868090bb248ca2fc$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $868090bb248ca2fc$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $868090bb248ca2fc$var$setCacheAdd(value) {
    this.__data__.set(value, $868090bb248ca2fc$var$HASH_UNDEFINED);
    return this;
}
$868090bb248ca2fc$exports = $868090bb248ca2fc$var$setCacheAdd;


var $ba2e6a93841338dc$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $ba2e6a93841338dc$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$ba2e6a93841338dc$exports = $ba2e6a93841338dc$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $32da07863e46acec$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $f6389c21d76f2f82$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$32da07863e46acec$var$SetCache.prototype.add = $32da07863e46acec$var$SetCache.prototype.push = $868090bb248ca2fc$exports;
$32da07863e46acec$var$SetCache.prototype.has = $ba2e6a93841338dc$exports;
$32da07863e46acec$exports = $32da07863e46acec$var$SetCache;


var $71c492a50c15e5ea$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $71c492a50c15e5ea$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$71c492a50c15e5ea$exports = $71c492a50c15e5ea$var$arraySome;


var $c0081f1c22a5c7b6$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c0081f1c22a5c7b6$var$cacheHas(cache, key) {
    return cache.has(key);
}
$c0081f1c22a5c7b6$exports = $c0081f1c22a5c7b6$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $d78075cec53d5845$var$COMPARE_PARTIAL_FLAG = 1, $d78075cec53d5845$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $d78075cec53d5845$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d78075cec53d5845$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $d78075cec53d5845$var$COMPARE_UNORDERED_FLAG ? new $32da07863e46acec$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$71c492a50c15e5ea$exports(other, function(othValue, othIndex) {
                if (!$c0081f1c22a5c7b6$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$d78075cec53d5845$exports = $d78075cec53d5845$var$equalArrays;


var $a632bfd5cacb9484$exports = {};

var $ddf8457b0c355418$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Built-in value references. */ var $ddf8457b0c355418$var$Uint8Array = $8ThvE.Uint8Array;
$ddf8457b0c355418$exports = $ddf8457b0c355418$var$Uint8Array;




var $65965bd4fe27ade2$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $65965bd4fe27ade2$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$65965bd4fe27ade2$exports = $65965bd4fe27ade2$var$mapToArray;


var $eee7f5e5109334c4$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $eee7f5e5109334c4$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$eee7f5e5109334c4$exports = $eee7f5e5109334c4$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $a632bfd5cacb9484$var$COMPARE_PARTIAL_FLAG = 1, $a632bfd5cacb9484$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $a632bfd5cacb9484$var$boolTag = "[object Boolean]", $a632bfd5cacb9484$var$dateTag = "[object Date]", $a632bfd5cacb9484$var$errorTag = "[object Error]", $a632bfd5cacb9484$var$mapTag = "[object Map]", $a632bfd5cacb9484$var$numberTag = "[object Number]", $a632bfd5cacb9484$var$regexpTag = "[object RegExp]", $a632bfd5cacb9484$var$setTag = "[object Set]", $a632bfd5cacb9484$var$stringTag = "[object String]", $a632bfd5cacb9484$var$symbolTag = "[object Symbol]";
var $a632bfd5cacb9484$var$arrayBufferTag = "[object ArrayBuffer]", $a632bfd5cacb9484$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $a632bfd5cacb9484$var$symbolProto = $a090581360ce8173$exports ? $a090581360ce8173$exports.prototype : undefined, $a632bfd5cacb9484$var$symbolValueOf = $a632bfd5cacb9484$var$symbolProto ? $a632bfd5cacb9484$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a632bfd5cacb9484$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $a632bfd5cacb9484$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $a632bfd5cacb9484$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $ddf8457b0c355418$exports(object), new $ddf8457b0c355418$exports(other))) return false;
            return true;
        case $a632bfd5cacb9484$var$boolTag:
        case $a632bfd5cacb9484$var$dateTag:
        case $a632bfd5cacb9484$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6f80be9883321bbe$exports(+object, +other);
        case $a632bfd5cacb9484$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $a632bfd5cacb9484$var$regexpTag:
        case $a632bfd5cacb9484$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $a632bfd5cacb9484$var$mapTag:
            var convert = $65965bd4fe27ade2$exports;
        case $a632bfd5cacb9484$var$setTag:
            var isPartial = bitmask & $a632bfd5cacb9484$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $eee7f5e5109334c4$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $a632bfd5cacb9484$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $d78075cec53d5845$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $a632bfd5cacb9484$var$symbolTag:
            if ($a632bfd5cacb9484$var$symbolValueOf) return $a632bfd5cacb9484$var$symbolValueOf.call(object) == $a632bfd5cacb9484$var$symbolValueOf.call(other);
    }
    return false;
}
$a632bfd5cacb9484$exports = $a632bfd5cacb9484$var$equalByTag;


var $b4663e3cbde1ff22$exports = {};
var $860bb4b6843d7563$exports = {};
var $9d3e3231281d182b$exports = {};
var $3fc9dba05ba16d53$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3fc9dba05ba16d53$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$3fc9dba05ba16d53$exports = $3fc9dba05ba16d53$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9d3e3231281d182b$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $8cb3ae215df00a00$exports(object) ? result : $3fc9dba05ba16d53$exports(result, symbolsFunc(object));
}
$9d3e3231281d182b$exports = $9d3e3231281d182b$var$baseGetAllKeys;


var $0eabf8f27c57cf11$exports = {};
var $68bbccdd4a21a80e$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $68bbccdd4a21a80e$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$68bbccdd4a21a80e$exports = $68bbccdd4a21a80e$var$arrayFilter;


var $11b31dfc90d4eeeb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $11b31dfc90d4eeeb$var$stubArray() {
    return [];
}
$11b31dfc90d4eeeb$exports = $11b31dfc90d4eeeb$var$stubArray;


/** Used for built-in method references. */ var $0eabf8f27c57cf11$var$objectProto = Object.prototype;
/** Built-in value references. */ var $0eabf8f27c57cf11$var$propertyIsEnumerable = $0eabf8f27c57cf11$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0eabf8f27c57cf11$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $0eabf8f27c57cf11$var$getSymbols = !$0eabf8f27c57cf11$var$nativeGetSymbols ? $11b31dfc90d4eeeb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $68bbccdd4a21a80e$exports($0eabf8f27c57cf11$var$nativeGetSymbols(object), function(symbol) {
        return $0eabf8f27c57cf11$var$propertyIsEnumerable.call(object, symbol);
    });
};
$0eabf8f27c57cf11$exports = $0eabf8f27c57cf11$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $860bb4b6843d7563$var$getAllKeys(object) {
    return $9d3e3231281d182b$exports(object, $b104760b34d6b7b1$exports, $0eabf8f27c57cf11$exports);
}
$860bb4b6843d7563$exports = $860bb4b6843d7563$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $b4663e3cbde1ff22$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $b4663e3cbde1ff22$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b4663e3cbde1ff22$var$hasOwnProperty = $b4663e3cbde1ff22$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b4663e3cbde1ff22$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b4663e3cbde1ff22$var$COMPARE_PARTIAL_FLAG, objProps = $860bb4b6843d7563$exports(object), objLength = objProps.length, othProps = $860bb4b6843d7563$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $b4663e3cbde1ff22$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$b4663e3cbde1ff22$exports = $b4663e3cbde1ff22$var$equalObjects;


var $e16b2168665de4fd$exports = {};
var $17dcac0166b81916$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $17dcac0166b81916$var$DataView = $97e6c72a80d118d2$exports($8ThvE, "DataView");
$17dcac0166b81916$exports = $17dcac0166b81916$var$DataView;



var $94f6808d7ce0e1fd$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $94f6808d7ce0e1fd$var$Promise = $97e6c72a80d118d2$exports($8ThvE, "Promise");
$94f6808d7ce0e1fd$exports = $94f6808d7ce0e1fd$var$Promise;


var $1a2f39184944fa46$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $1a2f39184944fa46$var$Set = $97e6c72a80d118d2$exports($8ThvE, "Set");
$1a2f39184944fa46$exports = $1a2f39184944fa46$var$Set;


var $7138f8441ce5e43e$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $7138f8441ce5e43e$var$WeakMap = $97e6c72a80d118d2$exports($8ThvE, "WeakMap");
$7138f8441ce5e43e$exports = $7138f8441ce5e43e$var$WeakMap;




/** `Object#toString` result references. */ var $e16b2168665de4fd$var$mapTag = "[object Map]", $e16b2168665de4fd$var$objectTag = "[object Object]", $e16b2168665de4fd$var$promiseTag = "[object Promise]", $e16b2168665de4fd$var$setTag = "[object Set]", $e16b2168665de4fd$var$weakMapTag = "[object WeakMap]";
var $e16b2168665de4fd$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $e16b2168665de4fd$var$dataViewCtorString = $3d1b4ae41857d3b0$exports($17dcac0166b81916$exports), $e16b2168665de4fd$var$mapCtorString = $3d1b4ae41857d3b0$exports($1b8f1205e4056240$exports), $e16b2168665de4fd$var$promiseCtorString = $3d1b4ae41857d3b0$exports($94f6808d7ce0e1fd$exports), $e16b2168665de4fd$var$setCtorString = $3d1b4ae41857d3b0$exports($1a2f39184944fa46$exports), $e16b2168665de4fd$var$weakMapCtorString = $3d1b4ae41857d3b0$exports($7138f8441ce5e43e$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $e16b2168665de4fd$var$getTag = $852d1f971b259156$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($17dcac0166b81916$exports && $e16b2168665de4fd$var$getTag(new $17dcac0166b81916$exports(new ArrayBuffer(1))) != $e16b2168665de4fd$var$dataViewTag || $1b8f1205e4056240$exports && $e16b2168665de4fd$var$getTag(new $1b8f1205e4056240$exports) != $e16b2168665de4fd$var$mapTag || $94f6808d7ce0e1fd$exports && $e16b2168665de4fd$var$getTag($94f6808d7ce0e1fd$exports.resolve()) != $e16b2168665de4fd$var$promiseTag || $1a2f39184944fa46$exports && $e16b2168665de4fd$var$getTag(new $1a2f39184944fa46$exports) != $e16b2168665de4fd$var$setTag || $7138f8441ce5e43e$exports && $e16b2168665de4fd$var$getTag(new $7138f8441ce5e43e$exports) != $e16b2168665de4fd$var$weakMapTag) $e16b2168665de4fd$var$getTag = function(value) {
    var result = $852d1f971b259156$exports(value), Ctor = result == $e16b2168665de4fd$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $3d1b4ae41857d3b0$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $e16b2168665de4fd$var$dataViewCtorString:
            return $e16b2168665de4fd$var$dataViewTag;
        case $e16b2168665de4fd$var$mapCtorString:
            return $e16b2168665de4fd$var$mapTag;
        case $e16b2168665de4fd$var$promiseCtorString:
            return $e16b2168665de4fd$var$promiseTag;
        case $e16b2168665de4fd$var$setCtorString:
            return $e16b2168665de4fd$var$setTag;
        case $e16b2168665de4fd$var$weakMapCtorString:
            return $e16b2168665de4fd$var$weakMapTag;
    }
    return result;
};
$e16b2168665de4fd$exports = $e16b2168665de4fd$var$getTag;




var $7HKs8 = parcelRequire("7HKs8");

/** Used to compose bitmasks for value comparisons. */ var $bfbd466526f8d698$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $bfbd466526f8d698$var$argsTag = "[object Arguments]", $bfbd466526f8d698$var$arrayTag = "[object Array]", $bfbd466526f8d698$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $bfbd466526f8d698$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bfbd466526f8d698$var$hasOwnProperty = $bfbd466526f8d698$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bfbd466526f8d698$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $8cb3ae215df00a00$exports(object), othIsArr = $8cb3ae215df00a00$exports(other), objTag = objIsArr ? $bfbd466526f8d698$var$arrayTag : $e16b2168665de4fd$exports(object), othTag = othIsArr ? $bfbd466526f8d698$var$arrayTag : $e16b2168665de4fd$exports(other);
    objTag = objTag == $bfbd466526f8d698$var$argsTag ? $bfbd466526f8d698$var$objectTag : objTag;
    othTag = othTag == $bfbd466526f8d698$var$argsTag ? $bfbd466526f8d698$var$objectTag : othTag;
    var objIsObj = objTag == $bfbd466526f8d698$var$objectTag, othIsObj = othTag == $bfbd466526f8d698$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $7HKs8(object)) {
        if (!$7HKs8(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $8bfbce7e35b86105$exports);
        return objIsArr || $32e7db2a0777bb6d$exports(object) ? $d78075cec53d5845$exports(object, other, bitmask, customizer, equalFunc, stack) : $a632bfd5cacb9484$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $bfbd466526f8d698$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $bfbd466526f8d698$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $bfbd466526f8d698$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $8bfbce7e35b86105$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $8bfbce7e35b86105$exports);
    return $b4663e3cbde1ff22$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$bfbd466526f8d698$exports = $bfbd466526f8d698$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $6219f680e6e19178$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$5475ba594a8bdf91$exports(value) && !$5475ba594a8bdf91$exports(other)) return value !== value && other !== other;
    return $bfbd466526f8d698$exports(value, other, bitmask, customizer, $6219f680e6e19178$var$baseIsEqual, stack);
}
$6219f680e6e19178$exports = $6219f680e6e19178$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $85df9b6b26a2a3d6$var$COMPARE_PARTIAL_FLAG = 1, $85df9b6b26a2a3d6$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $85df9b6b26a2a3d6$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $8bfbce7e35b86105$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $6219f680e6e19178$exports(srcValue, objValue, $85df9b6b26a2a3d6$var$COMPARE_PARTIAL_FLAG | $85df9b6b26a2a3d6$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$85df9b6b26a2a3d6$exports = $85df9b6b26a2a3d6$var$baseIsMatch;


var $9d7de89299ad2e3c$exports = {};
var $fdfd165136cf00fc$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $fdfd165136cf00fc$var$isStrictComparable(value) {
    return value === value && !$db5dfd0661742a1a$exports(value);
}
$fdfd165136cf00fc$exports = $fdfd165136cf00fc$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $9d7de89299ad2e3c$var$getMatchData(object) {
    var result = $b104760b34d6b7b1$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $fdfd165136cf00fc$exports(value)
        ];
    }
    return result;
}
$9d7de89299ad2e3c$exports = $9d7de89299ad2e3c$var$getMatchData;


var $84046984492b1213$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $84046984492b1213$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$84046984492b1213$exports = $84046984492b1213$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $1a6ab9420533a54c$var$baseMatches(source) {
    var matchData = $9d7de89299ad2e3c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $84046984492b1213$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $85df9b6b26a2a3d6$exports(object, source, matchData);
    };
}
$1a6ab9420533a54c$exports = $1a6ab9420533a54c$var$baseMatches;


var $f70cedfd69c2edab$exports = {};

var $37f57525b6598a05$exports = {};
var $01f8d472cea3b7ad$exports = {};


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $01f8d472cea3b7ad$var$baseGet(object, path) {
    path = $026916563a5fc8ad$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$e56d6cac75d4b6e0$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$01f8d472cea3b7ad$exports = $01f8d472cea3b7ad$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $37f57525b6598a05$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $01f8d472cea3b7ad$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$37f57525b6598a05$exports = $37f57525b6598a05$var$get;


var $ef091009ae184c05$exports = {};
var $c33ef5d4bef3db8d$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $c33ef5d4bef3db8d$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$c33ef5d4bef3db8d$exports = $c33ef5d4bef3db8d$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $ef091009ae184c05$var$hasIn(object, path) {
    return object != null && $f29e6f17be0e64f1$exports(object, path, $c33ef5d4bef3db8d$exports);
}
$ef091009ae184c05$exports = $ef091009ae184c05$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $f70cedfd69c2edab$var$COMPARE_PARTIAL_FLAG = 1, $f70cedfd69c2edab$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f70cedfd69c2edab$var$baseMatchesProperty(path, srcValue) {
    if ($ebf30b1c72800438$exports(path) && $fdfd165136cf00fc$exports(srcValue)) return $84046984492b1213$exports($e56d6cac75d4b6e0$exports(path), srcValue);
    return function(object) {
        var objValue = $37f57525b6598a05$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $ef091009ae184c05$exports(object, path) : $6219f680e6e19178$exports(srcValue, objValue, $f70cedfd69c2edab$var$COMPARE_PARTIAL_FLAG | $f70cedfd69c2edab$var$COMPARE_UNORDERED_FLAG);
    };
}
$f70cedfd69c2edab$exports = $f70cedfd69c2edab$var$baseMatchesProperty;


var $836ffceb73715ab3$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $836ffceb73715ab3$var$identity(value) {
    return value;
}
$836ffceb73715ab3$exports = $836ffceb73715ab3$var$identity;



var $3931b06dee0ed94b$exports = {};
var $805c81fb4b9151f2$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $805c81fb4b9151f2$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$805c81fb4b9151f2$exports = $805c81fb4b9151f2$var$baseProperty;


var $93a5b3a3d4a8ecc6$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $93a5b3a3d4a8ecc6$var$basePropertyDeep(path) {
    return function(object) {
        return $01f8d472cea3b7ad$exports(object, path);
    };
}
$93a5b3a3d4a8ecc6$exports = $93a5b3a3d4a8ecc6$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $3931b06dee0ed94b$var$property(path) {
    return $ebf30b1c72800438$exports(path) ? $805c81fb4b9151f2$exports($e56d6cac75d4b6e0$exports(path)) : $93a5b3a3d4a8ecc6$exports(path);
}
$3931b06dee0ed94b$exports = $3931b06dee0ed94b$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $52849359d0c345c9$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $836ffceb73715ab3$exports;
    if (typeof value == "object") return $8cb3ae215df00a00$exports(value) ? $f70cedfd69c2edab$exports(value[0], value[1]) : $1a6ab9420533a54c$exports(value);
    return $3931b06dee0ed94b$exports(value);
}
$52849359d0c345c9$exports = $52849359d0c345c9$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $b3b422bbfdb589b3$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $52849359d0c345c9$exports(iteratee, 3);
    $c40d9c5aec6b4ec6$exports(object, function(value, key, object) {
        $48f1054f3ca5da26$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$b3b422bbfdb589b3$exports = $b3b422bbfdb589b3$var$mapValues;



var $160fdeb028d2b801$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $160fdeb028d2b801$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$160fdeb028d2b801$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$160fdeb028d2b801$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$160fdeb028d2b801$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $160fdeb028d2b801$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $160fdeb028d2b801$var$DIGIT_REGEX = /^\d+$/, $160fdeb028d2b801$var$LEAD_DIGIT_REGEX = /^\d/, $160fdeb028d2b801$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $160fdeb028d2b801$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $160fdeb028d2b801$var$MAX_CACHE_SIZE = 512;
var $160fdeb028d2b801$var$pathCache = new $160fdeb028d2b801$var$Cache($160fdeb028d2b801$var$MAX_CACHE_SIZE), $160fdeb028d2b801$var$setCache = new $160fdeb028d2b801$var$Cache($160fdeb028d2b801$var$MAX_CACHE_SIZE), $160fdeb028d2b801$var$getCache = new $160fdeb028d2b801$var$Cache($160fdeb028d2b801$var$MAX_CACHE_SIZE);
var $160fdeb028d2b801$var$config;
$160fdeb028d2b801$exports = {
    Cache: $160fdeb028d2b801$var$Cache,
    split: $160fdeb028d2b801$var$split,
    normalizePath: $160fdeb028d2b801$var$normalizePath,
    setter: function(path) {
        var parts = $160fdeb028d2b801$var$normalizePath(path);
        return $160fdeb028d2b801$var$setCache.get(path) || $160fdeb028d2b801$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $160fdeb028d2b801$var$normalizePath(path);
        return $160fdeb028d2b801$var$getCache.get(path) || $160fdeb028d2b801$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($160fdeb028d2b801$var$isQuoted(part) || $160fdeb028d2b801$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $160fdeb028d2b801$var$forEach(Array.isArray(path) ? path : $160fdeb028d2b801$var$split(path), cb, thisArg);
    }
};
function $160fdeb028d2b801$var$normalizePath(path) {
    return $160fdeb028d2b801$var$pathCache.get(path) || $160fdeb028d2b801$var$pathCache.set(path, $160fdeb028d2b801$var$split(path).map(function(part) {
        return part.replace($160fdeb028d2b801$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $160fdeb028d2b801$var$split(path) {
    return path.match($160fdeb028d2b801$var$SPLIT_REGEX) || [
        ""
    ];
}
function $160fdeb028d2b801$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($160fdeb028d2b801$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $160fdeb028d2b801$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $160fdeb028d2b801$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $160fdeb028d2b801$var$hasLeadingNumber(part) {
    return part.match($160fdeb028d2b801$var$LEAD_DIGIT_REGEX) && !part.match($160fdeb028d2b801$var$DIGIT_REGEX);
}
function $160fdeb028d2b801$var$hasSpecialChars(part) {
    return $160fdeb028d2b801$var$SPEC_CHAR_REGEX.test(part);
}
function $160fdeb028d2b801$var$shouldBeQuoted(part) {
    return !$160fdeb028d2b801$var$isQuoted(part) && ($160fdeb028d2b801$var$hasLeadingNumber(part) || $160fdeb028d2b801$var$hasSpecialChars(part));
}


const $63ff9c708482e4b7$var$prefixes = {
    context: "$",
    value: "."
};
function $63ff9c708482e4b7$export$185802fd694ee1f5(key, options) {
    return new $63ff9c708482e4b7$export$2e2bcd8739ae039(key, options);
}
class $63ff9c708482e4b7$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $63ff9c708482e4b7$var$prefixes.context;
        this.isValue = this.key[0] === $63ff9c708482e4b7$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $63ff9c708482e4b7$var$prefixes.context : this.isValue ? $63ff9c708482e4b7$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $160fdeb028d2b801$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$63ff9c708482e4b7$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $398ea51923766840$var$_extends() {
    $398ea51923766840$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $398ea51923766840$var$_extends.apply(this, arguments);
}
function $398ea51923766840$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $398ea51923766840$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = "", label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $398ea51923766840$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $63ff9c708482e4b7$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($b3b422bbfdb589b3$exports)))($398ea51923766840$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039)((0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $398ea51923766840$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === "function") throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $d1b4365ba8101a28$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $d1b4365ba8101a28$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $160fdeb028d2b801$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $d1b4365ba8101a28$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $d1b4365ba8101a28$var$reach = (obj, path, value, context)=>$d1b4365ba8101a28$export$c52e5867d5879e24(obj, path, value, context).schema;
var $d1b4365ba8101a28$export$2e2bcd8739ae039 = $d1b4365ba8101a28$var$reach;




class $955724b01c7347e0$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $63ff9c708482e4b7$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $63ff9c708482e4b7$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $63ff9c708482e4b7$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $955724b01c7347e0$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $6bc69fe496f38d31$var$_extends() {
    $6bc69fe496f38d31$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6bc69fe496f38d31$var$_extends.apply(this, arguments);
}
class $6bc69fe496f38d31$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $955724b01c7347e0$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $955724b01c7347e0$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $79208d289975beed$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || "mixed";
        this.spec = $6bc69fe496f38d31$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: "optional"
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $6bc69fe496f38d31$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $979e0bbd1ac83ec6$export$2e2bcd8739ae039)($6bc69fe496f38d31$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $6bc69fe496f38d31$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($6bc69fe496f38d31$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $0885a840b432a241$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $0885a840b432a241$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $6bc69fe496f38d31$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $62970f7dacccb3a4$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $62970f7dacccb3a4$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($6bc69fe496f38d31$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === "function" ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($6bc69fe496f38d31$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $6bc69fe496f38d31$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this) : (0, $979e0bbd1ac83ec6$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $79208d289975beed$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: "defined",
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $79208d289975beed$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: "required"
        }).withMutation((s)=>s.test({
                message: message,
                name: "required",
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: "optional"
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== "required");
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $79208d289975beed$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = (0, $398ea51923766840$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = (0, $f01de86bb88c5ce8$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $63ff9c708482e4b7$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $d6dfdf3732f6dbe9$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $398ea51923766840$export$2e2bcd8739ae039)({
            message: message,
            name: "typeError",
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $79208d289975beed$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $398ea51923766840$export$2e2bcd8739ae039)({
            message: message,
            name: "oneOf",
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $79208d289975beed$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $398ea51923766840$export$2e2bcd8739ae039)({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$6bc69fe496f38d31$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$6bc69fe496f38d31$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $d1b4365ba8101a28$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $6bc69fe496f38d31$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$6bc69fe496f38d31$export$2e2bcd8739ae039.prototype[alias] = $6bc69fe496f38d31$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$6bc69fe496f38d31$export$2e2bcd8739ae039.prototype[alias] = $6bc69fe496f38d31$export$2e2bcd8739ae039.prototype.notOneOf;
$6bc69fe496f38d31$export$2e2bcd8739ae039.prototype.optional = $6bc69fe496f38d31$export$2e2bcd8739ae039.prototype.notRequired;


const $b76bafdf1c577241$var$Mixed = (0, $6bc69fe496f38d31$export$2e2bcd8739ae039);
var $b76bafdf1c577241$export$2e2bcd8739ae039 = $b76bafdf1c577241$var$Mixed;
function $b76bafdf1c577241$export$185802fd694ee1f5() {
    return new $b76bafdf1c577241$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$b76bafdf1c577241$export$185802fd694ee1f5.prototype = $b76bafdf1c577241$var$Mixed.prototype;




const $b31a46a4630cbcb9$var$isAbsent = (value)=>value == null;
var $b31a46a4630cbcb9$export$2e2bcd8739ae039 = $b31a46a4630cbcb9$var$isAbsent;


function $5fc6e7a7b793e415$export$185802fd694ee1f5() {
    return new $5fc6e7a7b793e415$export$2e2bcd8739ae039();
}
class $5fc6e7a7b793e415$export$2e2bcd8739ae039 extends (0, $6bc69fe496f38d31$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "boolean"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === "boolean";
    }
    isTrue(message = (0, $79208d289975beed$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $79208d289975beed$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$5fc6e7a7b793e415$export$185802fd694ee1f5.prototype = $5fc6e7a7b793e415$export$2e2bcd8739ae039.prototype;





let $c00a520989a13c1b$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $c00a520989a13c1b$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $c00a520989a13c1b$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $c00a520989a13c1b$var$isTrimmed = (value)=>(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value === value.trim();
let $c00a520989a13c1b$var$objStringTag = ({}).toString();
function $c00a520989a13c1b$export$185802fd694ee1f5() {
    return new $c00a520989a13c1b$export$2e2bcd8739ae039();
}
class $c00a520989a13c1b$export$2e2bcd8739ae039 extends (0, $6bc69fe496f38d31$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "string"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $c00a520989a13c1b$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === "string";
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $79208d289975beed$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $79208d289975beed$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $79208d289975beed$export$22b082955e083ec3).max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || (0, $79208d289975beed$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $79208d289975beed$export$22b082955e083ec3).email) {
        return this.matches($c00a520989a13c1b$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $79208d289975beed$export$22b082955e083ec3).url) {
        return this.matches($c00a520989a13c1b$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $79208d289975beed$export$22b082955e083ec3).uuid) {
        return this.matches($c00a520989a13c1b$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = (0, $79208d289975beed$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $c00a520989a13c1b$var$isTrimmed
        });
    }
    lowercase(message = (0, $79208d289975beed$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $79208d289975beed$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$c00a520989a13c1b$export$185802fd694ee1f5.prototype = $c00a520989a13c1b$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $8124dfe05647909d$var$isNaN = (value)=>value != +value;
function $8124dfe05647909d$export$185802fd694ee1f5() {
    return new $8124dfe05647909d$export$2e2bcd8739ae039();
}
class $8124dfe05647909d$export$2e2bcd8739ae039 extends (0, $6bc69fe496f38d31$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "number"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === "number" && !$8124dfe05647909d$var$isNaN(value);
    }
    min(min, message = (0, $79208d289975beed$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $79208d289975beed$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $79208d289975beed$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $79208d289975beed$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $79208d289975beed$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $79208d289975beed$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $79208d289975beed$export$98e628dec113755e).integer) {
        return this.test({
            name: "integer",
            message: message,
            test: (val)=>(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round"; // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!(0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$8124dfe05647909d$export$185802fd694ee1f5.prototype = $8124dfe05647909d$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $9eae3c130123293b$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $9eae3c130123293b$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $9eae3c130123293b$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === "") && (struct[9] === undefined || struct[9] === "")) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== "Z" && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === "+") minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $6b88cf478add81ef$var$invalidDate = new Date("");
let $6b88cf478add81ef$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $6b88cf478add81ef$export$185802fd694ee1f5() {
    return new $6b88cf478add81ef$export$2e2bcd8739ae039();
}
class $6b88cf478add81ef$export$2e2bcd8739ae039 extends (0, $6bc69fe496f38d31$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "date"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $9eae3c130123293b$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $6b88cf478add81ef$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $6b88cf478add81ef$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $63ff9c708482e4b7$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $79208d289975beed$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $79208d289975beed$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$6b88cf478add81ef$export$2e2bcd8739ae039.INVALID_DATE = $6b88cf478add81ef$var$invalidDate;
$6b88cf478add81ef$export$185802fd694ee1f5.prototype = $6b88cf478add81ef$export$2e2bcd8739ae039.prototype;
$6b88cf478add81ef$export$185802fd694ee1f5.INVALID_DATE = $6b88cf478add81ef$var$invalidDate;



var $01f761a22f0e8f00$exports = {};
var $af30e265d4ebc979$exports = {};
var $09c686e616bd6a6a$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $09c686e616bd6a6a$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$09c686e616bd6a6a$exports = $09c686e616bd6a6a$var$arrayReduce;


var $c9e08fc1384f11b3$exports = {};
var $6d4f50a5ddc3a70f$exports = {};
var $f7a7f6c2796a895e$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $f7a7f6c2796a895e$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$f7a7f6c2796a895e$exports = $f7a7f6c2796a895e$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $6d4f50a5ddc3a70f$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $6d4f50a5ddc3a70f$var$deburrLetter = $f7a7f6c2796a895e$exports($6d4f50a5ddc3a70f$var$deburredLetters);
$6d4f50a5ddc3a70f$exports = $6d4f50a5ddc3a70f$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $c9e08fc1384f11b3$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $c9e08fc1384f11b3$var$rsComboMarksRange = "\\u0300-\\u036f", $c9e08fc1384f11b3$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $c9e08fc1384f11b3$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $c9e08fc1384f11b3$var$rsComboRange = $c9e08fc1384f11b3$var$rsComboMarksRange + $c9e08fc1384f11b3$var$reComboHalfMarksRange + $c9e08fc1384f11b3$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $c9e08fc1384f11b3$var$rsCombo = "[" + $c9e08fc1384f11b3$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $c9e08fc1384f11b3$var$reComboMark = RegExp($c9e08fc1384f11b3$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $c9e08fc1384f11b3$var$deburr(string) {
    string = $22f1dff9b3c6ff0c$exports(string);
    return string && string.replace($c9e08fc1384f11b3$var$reLatin, $6d4f50a5ddc3a70f$exports).replace($c9e08fc1384f11b3$var$reComboMark, "");
}
$c9e08fc1384f11b3$exports = $c9e08fc1384f11b3$var$deburr;


var $c0bd127699c4c269$exports = {};
var $32e2a2eadbc398d1$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $32e2a2eadbc398d1$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $32e2a2eadbc398d1$var$asciiWords(string) {
    return string.match($32e2a2eadbc398d1$var$reAsciiWord) || [];
}
$32e2a2eadbc398d1$exports = $32e2a2eadbc398d1$var$asciiWords;


var $d4668bbb99bcb6ca$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $d4668bbb99bcb6ca$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $d4668bbb99bcb6ca$var$hasUnicodeWord(string) {
    return $d4668bbb99bcb6ca$var$reHasUnicodeWord.test(string);
}
$d4668bbb99bcb6ca$exports = $d4668bbb99bcb6ca$var$hasUnicodeWord;



var $d103836c0458c5fb$exports = {};
/** Used to compose unicode character classes. */ var $d103836c0458c5fb$var$rsAstralRange = "\ud800-\udfff", $d103836c0458c5fb$var$rsComboMarksRange = "\\u0300-\\u036f", $d103836c0458c5fb$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $d103836c0458c5fb$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $d103836c0458c5fb$var$rsComboRange = $d103836c0458c5fb$var$rsComboMarksRange + $d103836c0458c5fb$var$reComboHalfMarksRange + $d103836c0458c5fb$var$rsComboSymbolsRange, $d103836c0458c5fb$var$rsDingbatRange = "\\u2700-\\u27bf", $d103836c0458c5fb$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $d103836c0458c5fb$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $d103836c0458c5fb$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $d103836c0458c5fb$var$rsPunctuationRange = "\\u2000-\\u206f", $d103836c0458c5fb$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $d103836c0458c5fb$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $d103836c0458c5fb$var$rsVarRange = "\\ufe0e\\ufe0f", $d103836c0458c5fb$var$rsBreakRange = $d103836c0458c5fb$var$rsMathOpRange + $d103836c0458c5fb$var$rsNonCharRange + $d103836c0458c5fb$var$rsPunctuationRange + $d103836c0458c5fb$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $d103836c0458c5fb$var$rsApos = "['\u2019]", $d103836c0458c5fb$var$rsBreak = "[" + $d103836c0458c5fb$var$rsBreakRange + "]", $d103836c0458c5fb$var$rsCombo = "[" + $d103836c0458c5fb$var$rsComboRange + "]", $d103836c0458c5fb$var$rsDigits = "\\d+", $d103836c0458c5fb$var$rsDingbat = "[" + $d103836c0458c5fb$var$rsDingbatRange + "]", $d103836c0458c5fb$var$rsLower = "[" + $d103836c0458c5fb$var$rsLowerRange + "]", $d103836c0458c5fb$var$rsMisc = "[^" + $d103836c0458c5fb$var$rsAstralRange + $d103836c0458c5fb$var$rsBreakRange + $d103836c0458c5fb$var$rsDigits + $d103836c0458c5fb$var$rsDingbatRange + $d103836c0458c5fb$var$rsLowerRange + $d103836c0458c5fb$var$rsUpperRange + "]", $d103836c0458c5fb$var$rsFitz = "\ud83c[\udffb-\udfff]", $d103836c0458c5fb$var$rsModifier = "(?:" + $d103836c0458c5fb$var$rsCombo + "|" + $d103836c0458c5fb$var$rsFitz + ")", $d103836c0458c5fb$var$rsNonAstral = "[^" + $d103836c0458c5fb$var$rsAstralRange + "]", $d103836c0458c5fb$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $d103836c0458c5fb$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $d103836c0458c5fb$var$rsUpper = "[" + $d103836c0458c5fb$var$rsUpperRange + "]", $d103836c0458c5fb$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $d103836c0458c5fb$var$rsMiscLower = "(?:" + $d103836c0458c5fb$var$rsLower + "|" + $d103836c0458c5fb$var$rsMisc + ")", $d103836c0458c5fb$var$rsMiscUpper = "(?:" + $d103836c0458c5fb$var$rsUpper + "|" + $d103836c0458c5fb$var$rsMisc + ")", $d103836c0458c5fb$var$rsOptContrLower = "(?:" + $d103836c0458c5fb$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $d103836c0458c5fb$var$rsOptContrUpper = "(?:" + $d103836c0458c5fb$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $d103836c0458c5fb$var$reOptMod = $d103836c0458c5fb$var$rsModifier + "?", $d103836c0458c5fb$var$rsOptVar = "[" + $d103836c0458c5fb$var$rsVarRange + "]?", $d103836c0458c5fb$var$rsOptJoin = "(?:" + $d103836c0458c5fb$var$rsZWJ + "(?:" + [
    $d103836c0458c5fb$var$rsNonAstral,
    $d103836c0458c5fb$var$rsRegional,
    $d103836c0458c5fb$var$rsSurrPair
].join("|") + ")" + $d103836c0458c5fb$var$rsOptVar + $d103836c0458c5fb$var$reOptMod + ")*", $d103836c0458c5fb$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $d103836c0458c5fb$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $d103836c0458c5fb$var$rsSeq = $d103836c0458c5fb$var$rsOptVar + $d103836c0458c5fb$var$reOptMod + $d103836c0458c5fb$var$rsOptJoin, $d103836c0458c5fb$var$rsEmoji = "(?:" + [
    $d103836c0458c5fb$var$rsDingbat,
    $d103836c0458c5fb$var$rsRegional,
    $d103836c0458c5fb$var$rsSurrPair
].join("|") + ")" + $d103836c0458c5fb$var$rsSeq;
/** Used to match complex or compound words. */ var $d103836c0458c5fb$var$reUnicodeWord = RegExp([
    $d103836c0458c5fb$var$rsUpper + "?" + $d103836c0458c5fb$var$rsLower + "+" + $d103836c0458c5fb$var$rsOptContrLower + "(?=" + [
        $d103836c0458c5fb$var$rsBreak,
        $d103836c0458c5fb$var$rsUpper,
        "$"
    ].join("|") + ")",
    $d103836c0458c5fb$var$rsMiscUpper + "+" + $d103836c0458c5fb$var$rsOptContrUpper + "(?=" + [
        $d103836c0458c5fb$var$rsBreak,
        $d103836c0458c5fb$var$rsUpper + $d103836c0458c5fb$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $d103836c0458c5fb$var$rsUpper + "?" + $d103836c0458c5fb$var$rsMiscLower + "+" + $d103836c0458c5fb$var$rsOptContrLower,
    $d103836c0458c5fb$var$rsUpper + "+" + $d103836c0458c5fb$var$rsOptContrUpper,
    $d103836c0458c5fb$var$rsOrdUpper,
    $d103836c0458c5fb$var$rsOrdLower,
    $d103836c0458c5fb$var$rsDigits,
    $d103836c0458c5fb$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $d103836c0458c5fb$var$unicodeWords(string) {
    return string.match($d103836c0458c5fb$var$reUnicodeWord) || [];
}
$d103836c0458c5fb$exports = $d103836c0458c5fb$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $c0bd127699c4c269$var$words(string, pattern, guard) {
    string = $22f1dff9b3c6ff0c$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $d4668bbb99bcb6ca$exports(string) ? $d103836c0458c5fb$exports(string) : $32e2a2eadbc398d1$exports(string);
    return string.match(pattern) || [];
}
$c0bd127699c4c269$exports = $c0bd127699c4c269$var$words;


/** Used to compose unicode capture groups. */ var $af30e265d4ebc979$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $af30e265d4ebc979$var$reApos = RegExp($af30e265d4ebc979$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $af30e265d4ebc979$var$createCompounder(callback) {
    return function(string) {
        return $09c686e616bd6a6a$exports($c0bd127699c4c269$exports($c9e08fc1384f11b3$exports(string).replace($af30e265d4ebc979$var$reApos, "")), callback, "");
    };
}
$af30e265d4ebc979$exports = $af30e265d4ebc979$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $01f761a22f0e8f00$var$snakeCase = $af30e265d4ebc979$exports(function(result, word, index) {
    return result + (index ? "_" : "") + word.toLowerCase();
});
$01f761a22f0e8f00$exports = $01f761a22f0e8f00$var$snakeCase;


var $004f3a5b1274f0ec$exports = {};
var $f4f11d9329751942$exports = {};

var $7aaf1ef6e0afaf8b$exports = {};
var $5652299f76738179$exports = {};
var $28a9c3aa24afe991$exports = {};
var $da0774c3bb29a696$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $da0774c3bb29a696$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$da0774c3bb29a696$exports = $da0774c3bb29a696$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $28a9c3aa24afe991$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $da0774c3bb29a696$exports(array, start, end);
}
$28a9c3aa24afe991$exports = $28a9c3aa24afe991$var$castSlice;


var $020f842393152aff$exports = {};
/** Used to compose unicode character classes. */ var $020f842393152aff$var$rsAstralRange = "\ud800-\udfff", $020f842393152aff$var$rsComboMarksRange = "\\u0300-\\u036f", $020f842393152aff$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $020f842393152aff$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $020f842393152aff$var$rsComboRange = $020f842393152aff$var$rsComboMarksRange + $020f842393152aff$var$reComboHalfMarksRange + $020f842393152aff$var$rsComboSymbolsRange, $020f842393152aff$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $020f842393152aff$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $020f842393152aff$var$reHasUnicode = RegExp("[" + $020f842393152aff$var$rsZWJ + $020f842393152aff$var$rsAstralRange + $020f842393152aff$var$rsComboRange + $020f842393152aff$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $020f842393152aff$var$hasUnicode(string) {
    return $020f842393152aff$var$reHasUnicode.test(string);
}
$020f842393152aff$exports = $020f842393152aff$var$hasUnicode;


var $f5264446d5aa9ba8$exports = {};
var $ea8bb9dee46a9901$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $ea8bb9dee46a9901$var$asciiToArray(string) {
    return string.split("");
}
$ea8bb9dee46a9901$exports = $ea8bb9dee46a9901$var$asciiToArray;



var $f13892165578319e$exports = {};
/** Used to compose unicode character classes. */ var $f13892165578319e$var$rsAstralRange = "\ud800-\udfff", $f13892165578319e$var$rsComboMarksRange = "\\u0300-\\u036f", $f13892165578319e$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $f13892165578319e$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $f13892165578319e$var$rsComboRange = $f13892165578319e$var$rsComboMarksRange + $f13892165578319e$var$reComboHalfMarksRange + $f13892165578319e$var$rsComboSymbolsRange, $f13892165578319e$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $f13892165578319e$var$rsAstral = "[" + $f13892165578319e$var$rsAstralRange + "]", $f13892165578319e$var$rsCombo = "[" + $f13892165578319e$var$rsComboRange + "]", $f13892165578319e$var$rsFitz = "\ud83c[\udffb-\udfff]", $f13892165578319e$var$rsModifier = "(?:" + $f13892165578319e$var$rsCombo + "|" + $f13892165578319e$var$rsFitz + ")", $f13892165578319e$var$rsNonAstral = "[^" + $f13892165578319e$var$rsAstralRange + "]", $f13892165578319e$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $f13892165578319e$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $f13892165578319e$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $f13892165578319e$var$reOptMod = $f13892165578319e$var$rsModifier + "?", $f13892165578319e$var$rsOptVar = "[" + $f13892165578319e$var$rsVarRange + "]?", $f13892165578319e$var$rsOptJoin = "(?:" + $f13892165578319e$var$rsZWJ + "(?:" + [
    $f13892165578319e$var$rsNonAstral,
    $f13892165578319e$var$rsRegional,
    $f13892165578319e$var$rsSurrPair
].join("|") + ")" + $f13892165578319e$var$rsOptVar + $f13892165578319e$var$reOptMod + ")*", $f13892165578319e$var$rsSeq = $f13892165578319e$var$rsOptVar + $f13892165578319e$var$reOptMod + $f13892165578319e$var$rsOptJoin, $f13892165578319e$var$rsSymbol = "(?:" + [
    $f13892165578319e$var$rsNonAstral + $f13892165578319e$var$rsCombo + "?",
    $f13892165578319e$var$rsCombo,
    $f13892165578319e$var$rsRegional,
    $f13892165578319e$var$rsSurrPair,
    $f13892165578319e$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $f13892165578319e$var$reUnicode = RegExp($f13892165578319e$var$rsFitz + "(?=" + $f13892165578319e$var$rsFitz + ")|" + $f13892165578319e$var$rsSymbol + $f13892165578319e$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f13892165578319e$var$unicodeToArray(string) {
    return string.match($f13892165578319e$var$reUnicode) || [];
}
$f13892165578319e$exports = $f13892165578319e$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f5264446d5aa9ba8$var$stringToArray(string) {
    return $020f842393152aff$exports(string) ? $f13892165578319e$exports(string) : $ea8bb9dee46a9901$exports(string);
}
$f5264446d5aa9ba8$exports = $f5264446d5aa9ba8$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $5652299f76738179$var$createCaseFirst(methodName) {
    return function(string) {
        string = $22f1dff9b3c6ff0c$exports(string);
        var strSymbols = $020f842393152aff$exports(string) ? $f5264446d5aa9ba8$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $28a9c3aa24afe991$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$5652299f76738179$exports = $5652299f76738179$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $7aaf1ef6e0afaf8b$var$upperFirst = $5652299f76738179$exports("toUpperCase");
$7aaf1ef6e0afaf8b$exports = $7aaf1ef6e0afaf8b$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $f4f11d9329751942$var$capitalize(string) {
    return $7aaf1ef6e0afaf8b$exports($22f1dff9b3c6ff0c$exports(string).toLowerCase());
}
$f4f11d9329751942$exports = $f4f11d9329751942$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $004f3a5b1274f0ec$var$camelCase = $af30e265d4ebc979$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $f4f11d9329751942$exports(word) : word);
});
$004f3a5b1274f0ec$exports = $004f3a5b1274f0ec$var$camelCase;


var $26aab121219bc02e$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $26aab121219bc02e$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $52849359d0c345c9$exports(iteratee, 3);
    $c40d9c5aec6b4ec6$exports(object, function(value, key, object) {
        $48f1054f3ca5da26$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$26aab121219bc02e$exports = $26aab121219bc02e$var$mapKeys;






var $d09f6ca57534047b$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $d09f6ca57534047b$exports = function(edges) {
    return $d09f6ca57534047b$var$toposort($d09f6ca57534047b$var$uniqueNodes(edges), edges);
};
$d09f6ca57534047b$exports.array = $d09f6ca57534047b$var$toposort;
function $d09f6ca57534047b$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $d09f6ca57534047b$var$makeOutgoingEdges(edges), nodesHash = $d09f6ca57534047b$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $d09f6ca57534047b$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $d09f6ca57534047b$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $d09f6ca57534047b$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $f9a3d3e66eddd1ea$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $160fdeb028d2b801$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($678145309e69eaa8$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $63ff9c708482e4b7$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $ba7da153f070367d$export$2e2bcd8739ae039)(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($d09f6ca57534047b$exports))).array(Array.from(nodes), edges).reverse();
}


function $365d00d2009b022e$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $365d00d2009b022e$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $365d00d2009b022e$var$findIndex(keys, a) - $365d00d2009b022e$var$findIndex(keys, b);
    };
}





function $2665099025d48597$var$_extends() {
    $2665099025d48597$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2665099025d48597$var$_extends.apply(this, arguments);
}
let $2665099025d48597$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $2665099025d48597$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $2665099025d48597$var$defaultSort = (0, $365d00d2009b022e$export$2e2bcd8739ae039)([]);
class $2665099025d48597$export$2e2bcd8739ae039 extends (0, $6bc69fe496f38d31$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: "object"
        });
        this.fields = Object.create(null);
        this._sortErrors = $2665099025d48597$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === "string") try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $2665099025d48597$var$isObject(value) || typeof value === "function";
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $2665099025d48597$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($678145309e69eaa8$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = "spec" in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$2665099025d48597$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
                    let field = this.fields[key];
                    if (field && "validate" in field) {
                        field.validate(value[key], $2665099025d48597$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $62970f7dacccb3a4$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $2665099025d48597$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $6bc69fe496f38d31$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $6bc69fe496f38d31$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = "default" in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ("default" in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $365d00d2009b022e$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $f9a3d3e66eddd1ea$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $160fdeb028d2b801$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($678145309e69eaa8$exports)))(obj, from)) {
                newObj = $2665099025d48597$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $79208d289975beed$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === "string") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $2665099025d48597$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $79208d289975beed$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($26aab121219bc02e$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($004f3a5b1274f0ec$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($01f761a22f0e8f00$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($01f761a22f0e8f00$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($b3b422bbfdb589b3$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $2665099025d48597$export$185802fd694ee1f5(spec) {
    return new $2665099025d48597$export$2e2bcd8739ae039(spec);
}
$2665099025d48597$export$185802fd694ee1f5.prototype = $2665099025d48597$export$2e2bcd8739ae039.prototype;









function $ef95e756a34727ad$var$_extends() {
    $ef95e756a34727ad$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef95e756a34727ad$var$_extends.apply(this, arguments);
}
function $ef95e756a34727ad$export$185802fd694ee1f5(type) {
    return new $ef95e756a34727ad$export$2e2bcd8739ae039(type);
}
class $ef95e756a34727ad$export$2e2bcd8739ae039 extends (0, $6bc69fe496f38d31$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: "array"
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === "string") try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $ef95e756a34727ad$var$_extends({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $a38c42bc1e8b64e5$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ""}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $ef95e756a34727ad$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $62970f7dacccb3a4$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $ba7da153f070367d$export$2e2bcd8739ae039)(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + (0, $0885a840b432a241$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $79208d289975beed$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $79208d289975beed$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $79208d289975beed$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $b31a46a4630cbcb9$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$ef95e756a34727ad$export$185802fd694ee1f5.prototype = $ef95e756a34727ad$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $e1ed13391858c25c$export$185802fd694ee1f5(builder) {
    return new $e1ed13391858c25c$var$Lazy(builder);
}
class $e1ed13391858c25c$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $ba7da153f070367d$export$2e2bcd8739ae039)(schema)) throw new TypeError("lazy() functions must return a valid schema");
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $e1ed13391858c25c$export$2e2bcd8739ae039 = $e1ed13391858c25c$var$Lazy;






function $f16382cd11a65b91$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $79208d289975beed$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $ae93ea01037f0f37$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $ba7da153f070367d$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}




// Created by James Launder
// background component used by many pages

var $aSiaI = parcelRequire("aSiaI");

function $7da6cd7a80759224$var$Background() {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $41327f2ae7984f2e$export$2e2bcd8739ae039), {
                className: "absolute -z-10 rotate-[-20deg] top-[-250px] sm:top-[-400px] md:top-[-400px] lg:top-[-450px] xl:top-[-500px] 2xl:top-[-650px] left-[-450px] sm:left-[-250px] md:left-[-450px] lg:left-[-500px] xl:left-[-800px] 2xl:left-[-850px] h-[800px] w-[800px] lg:h-[900px] lg:w-[900px] xl:h-[1100px] xl:w-[1100px] 2xl:h-[1300px] 2xl:w-[1300px] blur-sm block"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $41327f2ae7984f2e$export$2e2bcd8739ae039), {
                className: "absolute -z-10 rotate-[-120deg] top-[-250px] sm:top-[-300px] lg:top-[-350px] xl:top-[-500px] 2xl:top-[-600px] left-[50px] sm:left-[250px] md:left-[200px] lg:left-[250px] xl:left-[120px] 2xl:left-[120px] h-[800px] w-[800px] md:h-[800px] md:w-[800px] lg:h-[900px] lg:w-[900px] xl:h-[1100px] xl:w-[1100px] 2xl:h-[1300px] 2xl:w-[1300px] blur-sm block"
            })
        ]
    });
}
var $7da6cd7a80759224$export$2e2bcd8739ae039 = $7da6cd7a80759224$var$Background;



const $13b0b96961f38c58$var$schema = $2665099025d48597$export$185802fd694ee1f5({
    username: $c00a520989a13c1b$export$185802fd694ee1f5().required(),
    email: $c00a520989a13c1b$export$185802fd694ee1f5().email().required(),
    password: $c00a520989a13c1b$export$185802fd694ee1f5().required("Please enter your password").matches(/^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, "Password must contain at least 8 characters, one uppercase, one number and one special case character"),
    confirmPwd: $c00a520989a13c1b$export$185802fd694ee1f5().required("Please confirm your password").oneOf([
        $63ff9c708482e4b7$export$185802fd694ee1f5("password")
    ], "Password doesn't match"),
    mail: $5fc6e7a7b793e415$export$185802fd694ee1f5()
}).required();
function $13b0b96961f38c58$var$SignUp() {
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $354df6ff51b92897$export$87c0cf8eb5a167e0)({
        resolver: (0, $de3022907c3640b7$export$d55832dfcd4989a)($13b0b96961f38c58$var$schema)
    });
    const [successful, setSuccessful] = (0, $exYeM.useState)(false);
    const [message, setMessage] = (0, $exYeM.useState)("");
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ username: username, email: email, password: password, mail: mail })=>{
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/signup", {
                username: username,
                email: email,
                password: password,
                mail: mail
            });
        },
        onSuccess: ()=>{
            setSuccessful(true);
            navigate("/signin", {
                state: location
            });
            window.location.reload();
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(resMessage);
            setSuccessful(false);
        }
    });
    const onSubmit = (data)=>{
        mutation.mutate({
            username: data.username,
            email: data.email,
            password: data.password,
            mail: data.mail
        });
    };
    return(// <div className="min-h-[75vh] grid place-items-center relative z-0 overflow-x-hidden">
    // <div className="flex flex-col grow gap-4 max-w-6xl">
    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "min-h-[75vh] grid place-items-center relative z-0 overflow-hidden",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-col grow gap-4 max-w-6xl",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7da6cd7a80759224$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "px-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "pt-4 px-4 pb-4 flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8af33ef04486b7$exports))),
                                        alt: "wevr.ai",
                                        className: "h-12 md:h-16 self-center pb-2"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center text-gray-600 text-lg sm:text-2xl",
                                        children: "Sign up to explore"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: " bg-surface border border-primaryContainer shadow-md rounded-2xl  p-4 w-full",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                                        className: "pt-4",
                                        onSubmit: handleSubmit(onSubmit),
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                        className: "block text-md font-roboto font-light",
                                                        children: "Username"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                        type: "text",
                                                        name: "username",
                                                        placeholder: "Username",
                                                        className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.username ? "is-invalid" : ""}`,
                                                        ...register("username")
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "invalid-feedback",
                                                        children: errors.username?.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                        className: "block text-md font-roboto font-light",
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                        type: "text",
                                                        name: "email",
                                                        placeholder: "Email",
                                                        className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.email ? "is-invalid" : ""}`,
                                                        ...register("email")
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "invalid-feedback",
                                                        children: errors.email?.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                        className: "block text-md font-roboto font-light",
                                                        children: "Password"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                        name: "password",
                                                        type: "password",
                                                        placeholder: "Password",
                                                        className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.password ? "is-invalid" : ""}`,
                                                        ...register("password")
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "invalid-feedback",
                                                        children: errors.password?.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-col form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                        className: "block text-md font-roboto font-light",
                                                        children: "Confirm Password"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                        name: "confirmPwd",
                                                        type: "password",
                                                        placeholder: "Confirm Password",
                                                        className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.confirmPwd ? "is-invalid" : ""}`,
                                                        ...register("confirmPwd")
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "invalid-feedback",
                                                        children: errors.confirmPwd?.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-row form-group items-center ml-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "mail",
                                                        ...register("mail")
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                        className: "block text-sm font-roboto px-2 text-gray-600",
                                                        children: "Subscribe to receive new and product updated. You can unsubscribe at anytime."
                                                    })
                                                ]
                                            }),
                                            message && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "form-group",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: successful ? "alert alert-success" : "alert alert-danger",
                                                    role: "alert",
                                                    children: message
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "py-4 flex flex-col sm:flex-row gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                        type: "submit",
                                                        className: " px-4 sm:px-6 py-2 min-w-[6rem] text-sm sm:text-md rounded-lg bg-surfaceVariant border border-primaryContainer shadow-md hover:text-white hover:bg-primary",
                                                        children: "Sign Up"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "px-2 flex items-center group text-gray-600",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                                            to: "/Legal",
                                                            className: "text-sm sm:text-md group-hover:underline",
                                                            children: "By signing up, you agree to the Master Agreements, Terms of Service and Privacy Policy"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                            to: "/signIn",
                                            className: "flex group",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "text-gray-600",
                                                    children: "Already have an account?\xa0"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "text-primary group-hover:underline",
                                                    children: "Log in"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
}
var $13b0b96961f38c58$export$2e2bcd8739ae039 = $13b0b96961f38c58$var$SignUp;


// created by james launder
// sign in page which contained ability to sign in via twitter and github to reenable this go back to past commit
// mostly a simple form just sends data to db and verify
/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $aSiaI = parcelRequire("aSiaI");


var $exYeM = parcelRequire("exYeM");





const $63bc3418712e965e$export$ad0e3c8bd06d67b1 = (data)=>{
    // console.log("Called set");
    localStorage.setItem("user", JSON.stringify(data));
};


// Created By James Launder
// inspired from tailwind ui
// small popup that tells the user they have been verfied

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
function $fd953693f2eb5133$var$ArrowPathIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M15.312 11.424a5.5 5.5 0 01-9.201 2.466l-.312-.311h2.433a.75.75 0 000-1.5H3.989a.75.75 0 00-.75.75v4.242a.75.75 0 001.5 0v-2.43l.31.31a7 7 0 0011.712-3.138.75.75 0 00-1.449-.39zm1.23-3.723a.75.75 0 00.219-.53V2.929a.75.75 0 00-1.5 0V5.36l-.31-.31A7 7 0 003.239 8.188a.75.75 0 101.448.389A5.5 5.5 0 0113.89 6.11l.311.31h-2.432a.75.75 0 000 1.5h4.243a.75.75 0 00.53-.219z",
        clipRule: "evenodd"
    }));
}
const $fd953693f2eb5133$var$ForwardRef = $exYeM.forwardRef($fd953693f2eb5133$var$ArrowPathIcon);
var $fd953693f2eb5133$export$2e2bcd8739ae039 = $fd953693f2eb5133$var$ForwardRef;





function $6e0a7b3ff91eeb35$export$2e2bcd8739ae039(props) {
    let { confirmationCode: confirmationCode } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    const userVerify = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "user-verify"
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/user/confirm/" + confirmationCode)
    });
    if (userVerify.isLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            "aria-live": "assertive",
            className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex w-full flex-col items-center space-y-4 sm:items-end",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                    show: props.show,
                    as: (0, $exYeM.Fragment),
                    enter: "transform ease-out duration-300 transition",
                    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
                    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-surfaceVariant shadow-lg ring-1 ring-black ring-opacity-5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fd953693f2eb5133$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-primary",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "ml-3 w-0 flex-1 pt-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-md font-medium text-gray-900",
                                                children: "Loading"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "mt-1 text-md text-gray-500",
                                                children: "Please wait!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "ml-4 flex flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                            onClick: ()=>{
                                                props.setShow(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6420636464f3564$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
    if (userVerify.isError) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            "aria-live": "assertive",
            className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex w-full flex-col items-center space-y-4 sm:items-end",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                    show: props.show,
                    as: (0, $exYeM.Fragment),
                    enter: "transform ease-out duration-300 transition",
                    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
                    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-surfaceVariant shadow-lg ring-1 ring-black ring-opacity-5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e0712a81bd67fc1b$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-red-500",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "ml-3 w-0 flex-1 pt-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-md font-medium text-gray-900",
                                                children: "Error"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "mt-1 text-md text-gray-500",
                                                children: userVerify.error.response.data.message
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "ml-4 flex flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                            onClick: ()=>{
                                                props.setShow(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6420636464f3564$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            "aria-live": "assertive",
            className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex w-full flex-col items-center space-y-4 sm:items-end",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                    show: props.show,
                    as: (0, $exYeM.Fragment),
                    enter: "transform ease-out duration-300 transition",
                    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
                    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-surfaceVariant shadow-lg ring-1 ring-black ring-opacity-5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b1025e29a9661faf$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-primary",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "ml-3 w-0 flex-1 pt-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-md font-medium text-gray-900",
                                                children: "Successfully Verified"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "mt-1 text-md text-gray-500",
                                                children: "You can now login!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "ml-4 flex flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                            onClick: ()=>{
                                                props.setShow(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6420636464f3564$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}


// Created by James Launder
// pop up modal to notify the user once registering to validate via email

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $b4693b17b2df6476$var$InboxArrowDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 3.75H6.912a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859M12 3v8.25m0 0l-3-3m3 3l3-3"
    }));
}
const $b4693b17b2df6476$var$ForwardRef = $exYeM.forwardRef($b4693b17b2df6476$var$InboxArrowDownIcon);
var $b4693b17b2df6476$export$2e2bcd8739ae039 = $b4693b17b2df6476$var$ForwardRef;


function $c0eaa5b8c55712f9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: props.setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b4693b17b2df6476$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-green-600",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "mt-3 text-center sm:mt-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Title, {
                                                        as: "h3",
                                                        className: "text-lg font-medium leading-6 text-gray-900",
                                                        children: "Confirm Email"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                            className: "text-sm text-gray-500",
                                                            children: "Please check your email to verify your account!"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "mt-5 sm:mt-6",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                            type: "button",
                                            className: "inline-flex w-full justify-center rounded-md border border-primary bg-primary text-white  px-4 py-2 text-base font-medium shadow-sm hover:bg-white hover:text-primary sm:text-sm",
                                            onClick: ()=>props.setOpen(false),
                                            children: "Close"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}



var $exYeM = parcelRequire("exYeM");
function $d823e37feee8d649$var$useLoadGsiScript(options = {}) {
    const { onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0, $exYeM.useState)(false);
    const onScriptLoadSuccessRef = (0, $exYeM.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0, $exYeM.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0, $exYeM.useEffect)(()=>{
        const scriptTag = document.createElement("script");
        scriptTag.src = "https://accounts.google.com/gsi/client";
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.onload = ()=>{
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 || _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = ()=>{
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 || _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return ()=>{
            document.body.removeChild(scriptTag);
        };
    }, []);
    return scriptLoadedSuccessfully;
}
const $d823e37feee8d649$var$GoogleOAuthContext = (0, $exYeM.createContext)(null);
function $d823e37feee8d649$export$a325976a38f291f5({ clientId: clientId, onScriptLoadSuccess: onScriptLoadSuccess, onScriptLoadError: onScriptLoadError, children: children }) {
    const scriptLoadedSuccessfully = $d823e37feee8d649$var$useLoadGsiScript({
        onScriptLoadSuccess: onScriptLoadSuccess,
        onScriptLoadError: onScriptLoadError
    });
    const contextValue = (0, $exYeM.useMemo)(()=>({
            clientId: clientId,
            scriptLoadedSuccessfully: scriptLoadedSuccessfully
        }), [
        clientId,
        scriptLoadedSuccessfully
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d823e37feee8d649$var$GoogleOAuthContext.Provider, {
        value: contextValue
    }, children);
}
function $d823e37feee8d649$var$useGoogleOAuth() {
    const context = (0, $exYeM.useContext)($d823e37feee8d649$var$GoogleOAuthContext);
    if (!context) throw new Error("Google OAuth components must be used within GoogleOAuthProvider");
    return context;
}
function $d823e37feee8d649$var$extractClientId(credentialResponse) {
    var _a;
    const clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
    return clientId;
}
const $d823e37feee8d649$var$containerHeightMap = {
    large: 40,
    medium: 32,
    small: 20
};
function $d823e37feee8d649$export$a795a627e512102a({ onSuccess: onSuccess, onError: onError, useOneTap: useOneTap, promptMomentNotification: promptMomentNotification, type: type = "standard", theme: theme = "outline", size: size = "large", text: text, shape: shape, logo_alignment: logo_alignment, width: width, locale: locale, click_listener: click_listener, ...props }) {
    const btnContainerRef = (0, $exYeM.useRef)(null);
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $d823e37feee8d649$var$useGoogleOAuth();
    const onSuccessRef = (0, $exYeM.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $exYeM.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $exYeM.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $exYeM.useEffect)(()=>{
        var _a, _b, _c;
        if (!scriptLoadedSuccessfully) return;
        (_a = window.google) === null || _a === void 0 || _a.accounts.id.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $d823e37feee8d649$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            ...props
        });
        (_b = window.google) === null || _b === void 0 || _b.accounts.id.renderButton(btnContainerRef.current, {
            type: type,
            theme: theme,
            size: size,
            text: text,
            shape: shape,
            logo_alignment: logo_alignment,
            width: width,
            locale: locale,
            click_listener: click_listener
        });
        if (useOneTap) (_c = window.google) === null || _c === void 0 || _c.accounts.id.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a;
            if (useOneTap) (_a = window.google) === null || _a === void 0 || _a.accounts.id.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ref: btnContainerRef,
        style: {
            height: $d823e37feee8d649$var$containerHeightMap[size]
        }
    });
}
function $d823e37feee8d649$export$64c51800d55c1202() {
    var _a;
    (_a = window.google) === null || _a === void 0 || _a.accounts.id.disableAutoSelect();
}
/* eslint-disable import/export */ function $d823e37feee8d649$export$6ca4c5d94f9e170b({ flow: flow = "implicit", scope: scope = "", onSuccess: onSuccess, onError: onError, onNonOAuthError: onNonOAuthError, overrideScope: overrideScope, ...props }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $d823e37feee8d649$var$useGoogleOAuth();
    const clientRef = (0, $exYeM.useRef)();
    const onSuccessRef = (0, $exYeM.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $exYeM.useRef)(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = (0, $exYeM.useRef)(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    (0, $exYeM.useEffect)(()=>{
        var _a;
        if (!scriptLoadedSuccessfully) return;
        const clientMethod = flow === "implicit" ? "initTokenClient" : "initCodeClient";
        const client = (_a = window.google) === null || _a === void 0 ? void 0 : _a.accounts.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response)=>{
                var _a, _b;
                if (response.error) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 || _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError)=>{
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 || _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            ...props
        });
        clientRef.current = client;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        flow,
        scope
    ]);
    const loginImplicitFlow = (0, $exYeM.useCallback)((overrideConfig)=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig);
    }, []);
    const loginAuthCodeFlow = (0, $exYeM.useCallback)(()=>{
        var _a;
        return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode();
    }, []);
    return flow === "implicit" ? loginImplicitFlow : loginAuthCodeFlow;
}
function $d823e37feee8d649$export$7ab2d3f76b55c251({ onSuccess: onSuccess, onError: onError, promptMomentNotification: promptMomentNotification, cancel_on_tap_outside: cancel_on_tap_outside, hosted_domain: hosted_domain }) {
    const { clientId: clientId, scriptLoadedSuccessfully: scriptLoadedSuccessfully } = $d823e37feee8d649$var$useGoogleOAuth();
    const onSuccessRef = (0, $exYeM.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $exYeM.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0, $exYeM.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0, $exYeM.useEffect)(()=>{
        var _a, _b;
        if (!scriptLoadedSuccessfully) return;
        (_a = window.google) === null || _a === void 0 || _a.accounts.id.initialize({
            client_id: clientId,
            callback: (credentialResponse)=>{
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                const { credential: credential, select_by: select_by } = credentialResponse;
                onSuccessRef.current({
                    credential: credential,
                    clientId: $d823e37feee8d649$var$extractClientId(credentialResponse),
                    select_by: select_by
                });
            },
            hosted_domain: hosted_domain,
            cancel_on_tap_outside: cancel_on_tap_outside
        });
        (_b = window.google) === null || _b === void 0 || _b.accounts.id.prompt(promptMomentNotificationRef.current);
        return ()=>{
            var _a;
            (_a = window.google) === null || _a === void 0 || _a.accounts.id.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        cancel_on_tap_outside,
        hosted_domain
    ]);
}
/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */ function $d823e37feee8d649$export$dfe7cd07eac17bc5(tokenResponse, firstScope, ...restScopes) {
    if (!window.google) return false;
    return window.google.accounts.oauth2.hasGrantedAllScopes(tokenResponse, firstScope, ...restScopes);
}
/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */ function $d823e37feee8d649$export$3413c85423c3f1d0(tokenResponse, firstScope, ...restScopes) {
    if (!window.google) return false;
    return window.google.accounts.oauth2.hasGrantedAnyScope(tokenResponse, firstScope, ...restScopes);
}


// Created by James Launder inspired by tailwind ui
// popup in the top corner that provide info if there is an error

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


function $56365c43e8482992$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            "aria-live": "assertive",
            className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex w-full flex-col items-center space-y-4 sm:items-end",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                    show: props.ErrorNotif,
                    as: (0, $exYeM.Fragment),
                    enter: "transform ease-out duration-300 transition",
                    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
                    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-surfaceVariant shadow-lg ring-1 ring-black ring-opacity-5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e0712a81bd67fc1b$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-red-500",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "ml-3 w-0 flex-1 pt-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-md font-medium text-gray-900",
                                                children: "Error"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "mt-1 text-md text-gray-500",
                                                children: props.message
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "ml-4 flex flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                            onClick: ()=>{
                                                props.setErrorNotif(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6420636464f3564$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}




const $3246ad47baf3f0f0$var$schema = $2665099025d48597$export$185802fd694ee1f5({
    username: $c00a520989a13c1b$export$185802fd694ee1f5().required(),
    password: $c00a520989a13c1b$export$185802fd694ee1f5().required("Password is required")
}).required();
function $3246ad47baf3f0f0$var$SignIn() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [isLoading, setLoading] = (0, $exYeM.useState)(false);
    const [show, setShow] = (0, $exYeM.useState)(true);
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const [ErrorNotif, setErrorNotif] = (0, $exYeM.useState)(false);
    let { confirmationCode: confirmationCode } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $354df6ff51b92897$export$87c0cf8eb5a167e0)({
        resolver: (0, $de3022907c3640b7$export$d55832dfcd4989a)($3246ad47baf3f0f0$var$schema)
    });
    (0, $exYeM.useEffect)(()=>{
        if (JSON.parse(localStorage.getItem("user"))) navigate("/");
    }, []);
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ username: username, password: password })=>{
            setLoading(true);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/signin", {
                username: username,
                password: password
            });
        },
        onSuccess: (res)=>{
            setLoading(false);
            (0, $63bc3418712e965e$export$ad0e3c8bd06d67b1)(res.data);
            window.location.reload();
        },
        onError: (error)=>{
            setLoading(false);
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(resMessage);
        }
    });
    const onSubmit = (data)=>{
        mutation.mutate({
            username: data.username,
            password: data.password
        });
    };
    const googleMutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ credential: credential, clientId: clientId })=>{
            setLoading(true);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/google", {
                credential: credential,
                clientId: clientId
            });
        },
        onSuccess: (res)=>{
            setLoading(false);
            (0, $63bc3418712e965e$export$ad0e3c8bd06d67b1)(res.data);
            window.location.reload();
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setLoading(false);
            setMessage(resMessage);
            setErrorNotif(true);
        }
    });
    const onGoogleSubmit = (data)=>{
        googleMutation.mutate({
            credential: data.credential,
            clientId: data.clientId
        });
    };
    (0, $exYeM.useEffect)(()=>{
        if (location.state?.pathname) setOpen(true);
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative z-20",
                children: [
                    confirmationCode ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6e0a7b3ff91eeb35$export$2e2bcd8739ae039), {
                        show: show,
                        setShow: setShow
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                    ErrorNotif ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $56365c43e8482992$export$2e2bcd8739ae039), {
                        setErrorNotif: setErrorNotif,
                        ErrorNotif: ErrorNotif,
                        message: message
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {})
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "min-h-[75vh] grid place-items-center relative z-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-col grow gap-4 max-w-6xl",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7da6cd7a80759224$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "pt-4 px-4 font-roboto flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8af33ef04486b7$exports))),
                                        alt: "wevr.ai",
                                        className: "h-12 md:h-16 self-center pb-2"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center text-gray-600 text-lg sm:text-2xl",
                                        children: "Login to explore"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: " bg-surface border border-primaryContainer shadow-md rounded-2xl  p-4 w-full",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                                        className: "pt-4 ",
                                        onSubmit: handleSubmit(onSubmit),
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                        className: "block text-md font-roboto font-light",
                                                        children: "Username:"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                        type: "text",
                                                        name: "username",
                                                        placeholder: "Username",
                                                        className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.username ? "is-invalid" : ""}`,
                                                        ...register("username")
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "font-semibold text-red-500 invalid-feedback -mt-2",
                                                        children: errors.username?.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                                        className: "block text-md font-roboto font-light",
                                                        children: [
                                                            "Password:",
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                        name: "password",
                                                        type: "password",
                                                        placeholder: "Password",
                                                        className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.password ? "is-invalid" : ""}`,
                                                        ...register("password")
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "font-semibold text-red-500 invalid-feedback -mt-2",
                                                        children: errors.password?.message
                                                    })
                                                ]
                                            }),
                                            message ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "form-group pt-2",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "alert alert-danger font-semibold text-red-500",
                                                    role: "alert",
                                                    children: message
                                                })
                                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "form-group pt-2"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "flex justify-center py-4",
                                                children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
                                                            "aria-hidden": "true",
                                                            className: "w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-primary",
                                                            viewBox: "0 0 100 101",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                                    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                                    fill: "currentColor"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                                    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                                    fill: "currentFill"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Loading..."
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    type: "submit",
                                                    className: "px-6 py-2 w-full font-roboto font-light rounded-lg bg-surfaceVariant border border-primaryContainer shadow-md hover:text-white hover:bg-primary",
                                                    disabled: isLoading,
                                                    children: "Sign in"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex flex-row gap-4 font-roboto mb-2 text-gray-900 font-semibold",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                                        to: "/ForgotPassword",
                                                        className: "hover:underline ",
                                                        children: "Forgot your password?"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                                        to: "/SignUp",
                                                        className: "flex group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                className: "hidden sm:block",
                                                                children: [
                                                                    "Don't have an account?\xa0",
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "text-primary group-hover:underline",
                                                                children: "Sign up for free"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "border-t-2 border-secondary flex flex-col sm:flex-row sm:justify-between",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "py-2 sm:py-4",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d823e37feee8d649$export$a795a627e512102a), {
                                                // type={"icon"}
                                                size: "large",
                                                text: "signin",
                                                shape: "rectangular",
                                                onSuccess: (credentialResponse)=>{
                                                    onGoogleSubmit(credentialResponse);
                                                },
                                                onError: ()=>{
                                                    console.error("Login Failed");
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c0eaa5b8c55712f9$export$2e2bcd8739ae039), {
                open: open,
                setOpen: setOpen
            })
        ]
    });
}
var $3246ad47baf3f0f0$export$2e2bcd8739ae039 = $3246ad47baf3f0f0$var$SignIn;


// Created By James Launder
// user settings page, this contains all the components to display info about the acc and interact withit

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $jR9u2 = parcelRequire("jR9u2");


// Created by james launder
// used to take in the current password, validate it and then change to a new password
/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");








const $2df728e2d28e425f$var$schema = $2665099025d48597$export$185802fd694ee1f5({
    currPassword: $c00a520989a13c1b$export$185802fd694ee1f5().required("Password is mandatory").matches(/^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, "Password must contain at least 8 characters, one uppercase, one number and one special case character"),
    password: $c00a520989a13c1b$export$185802fd694ee1f5().required("Please enter your password").matches(/^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, "Password must contain at least 8 characters, one uppercase, one number and one special case character"),
    confirmPwd: $c00a520989a13c1b$export$185802fd694ee1f5().required("Please confirm your password").oneOf([
        $63ff9c708482e4b7$export$185802fd694ee1f5("password")
    ], "Password doesn't match")
}).required();
function $2df728e2d28e425f$export$2e2bcd8739ae039(props) {
    const [successful, setSuccessful] = (0, $exYeM.useState)(false);
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $354df6ff51b92897$export$87c0cf8eb5a167e0)({
        resolver: (0, $de3022907c3640b7$export$d55832dfcd4989a)($2df728e2d28e425f$var$schema)
    });
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ password: password, currPassword: currPassword })=>{
            setLoading(true);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put("/user/changepassword", {
                email: JSON.parse(localStorage.getItem("user")).email,
                password: currPassword,
                newPassword: password
            }, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).accessToken}`
                }
            });
        },
        onSuccess: ()=>{
            setSuccessful(true);
            setLoading(false);
            toast({
                variant: "success",
                title: "Success!",
                description: "Successfully updated password"
            });
            props.setOpen(false);
            setMessage("Password Reset");
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(resMessage);
            setSuccessful(false);
            setLoading(false);
        }
    });
    const onSubmit = (data)=>{
        mutation.mutate({
            currPassword: data.currPassword,
            password: data.password
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: props.setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                                    className: "pt-4",
                                    onSubmit: handleSubmit(onSubmit),
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                    className: "block text-md font-roboto font-light",
                                                    children: "Current Password:"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    name: "currPassword",
                                                    type: "password",
                                                    placeholder: "Current Password",
                                                    className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.password ? "is-invalid" : ""}`,
                                                    ...register("currPassword")
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "invalid-feedback",
                                                    children: errors.currPassword?.message
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                    className: "block text-md font-roboto font-light",
                                                    children: "New Password:"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    name: "password",
                                                    type: "password",
                                                    placeholder: "Password",
                                                    className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.password ? "is-invalid" : ""}`,
                                                    ...register("password")
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "invalid-feedback",
                                                    children: errors.password?.message
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex flex-col form-group",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                    className: "block text-md font-roboto font-light",
                                                    children: "Confirm New Password:"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    name: "confirmPwd",
                                                    type: "password",
                                                    placeholder: "Confirm Password",
                                                    className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.confirmPwd ? "is-invalid" : ""}`,
                                                    ...register("confirmPwd")
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "invalid-feedback",
                                                    children: errors.confirmPwd?.message
                                                })
                                            ]
                                        }),
                                        message && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "form-group",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: successful ? "alert alert-success" : "alert alert-danger",
                                                role: "alert",
                                                children: message
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "py-4 grid grid-cols-3",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                type: "submit",
                                                className: "bg-surfaceVariant group hover:bg-primary hover:text-white text-gray-900 mt-3 inline-flex gap-4 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm  sm:mt-0 sm:w-auto",
                                                disabled: loading,
                                                children: [
                                                    loading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 animate-spin group-hover:text-white"
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {}),
                                                    "Reset"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}


// Created By James Launder
// similar to other update components
/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");








const $f61a173045955eae$var$schema = $2665099025d48597$export$185802fd694ee1f5({
    username: $c00a520989a13c1b$export$185802fd694ee1f5().required()
}).required();
function $f61a173045955eae$export$2e2bcd8739ae039(props) {
    const [successful, setSuccessful] = (0, $exYeM.useState)(false);
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $354df6ff51b92897$export$87c0cf8eb5a167e0)({
        resolver: (0, $de3022907c3640b7$export$d55832dfcd4989a)($f61a173045955eae$var$schema)
    });
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ username: username })=>{
            setLoading(true);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put("/user/updateusername", {
                username: username
            }, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).accessToken}`
                }
            });
        },
        onSuccess: ()=>{
            setSuccessful(true);
            setLoading(false);
            toast({
                variant: "success",
                title: "Success!",
                description: "Successfully updated username"
            });
            props.setOpen(false);
            setMessage("Username Updated");
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(resMessage);
            setSuccessful(false);
            setLoading(false);
        }
    });
    const onSubmit = (data)=>{
        mutation.mutate({
            username: data.username
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: props.setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                                    className: "pt-4",
                                    onSubmit: handleSubmit(onSubmit),
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                    className: "block text-md font-roboto font-light",
                                                    children: "New Username:"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    type: "text",
                                                    name: "username",
                                                    placeholder: "Username",
                                                    className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.username ? "is-invalid" : ""}`,
                                                    ...register("username")
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "invalid-feedback",
                                                    children: errors.username?.message
                                                })
                                            ]
                                        }),
                                        message && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "form-group",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: successful ? "alert alert-success font-semibold" : "alert alert-danger",
                                                role: "alert",
                                                children: message
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "py-4 grid grid-cols-3",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                type: "submit",
                                                className: "bg-surfaceVariant group hover:bg-primary hover:text-white text-gray-900 mt-3 inline-flex gap-4 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm  sm:mt-0 sm:w-auto",
                                                disabled: loading,
                                                children: [
                                                    loading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 animate-spin group-hover:text-white"
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {}),
                                                    "Update"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}


// Created by James Launder
// popup that the user can use to change the email to a new one.
/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");








const $204f36e227e46ec8$var$schema = $2665099025d48597$export$185802fd694ee1f5({
    email: $c00a520989a13c1b$export$185802fd694ee1f5().email().required()
}).required();
function $204f36e227e46ec8$export$2e2bcd8739ae039(props) {
    const [successful, setSuccessful] = (0, $exYeM.useState)(false);
    const [code, setCode] = (0, $exYeM.useState)(false);
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $354df6ff51b92897$export$87c0cf8eb5a167e0)({
        resolver: (0, $de3022907c3640b7$export$d55832dfcd4989a)($204f36e227e46ec8$var$schema)
    });
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ email: email })=>{
            setLoading(true);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put("/user/updateemail", {
                email: email
            }, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).accessToken}`
                }
            });
        },
        onSuccess: ()=>{
            setSuccessful(true);
            setMessage("Verify new email");
            setLoading(false);
            setCode(true);
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(resMessage);
            setSuccessful(false);
            setLoading(false);
        }
    });
    const verifyMutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ email: email, code: code })=>{
            setLoading(true);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put("/user/validateemail/" + code, {
                email: email
            }, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).accessToken}`
                }
            });
        },
        onSuccess: ()=>{
            setSuccessful(true);
            setLoading(false);
            toast({
                variant: "success",
                title: "Success!",
                description: "Successfully updated email"
            });
            props.setOpen(false);
            setMessage("Email Updated");
            setCode(false);
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(resMessage);
            setSuccessful(false);
            setLoading(false);
        }
    });
    const onSubmit = (data)=>{
        if (code) verifyMutation.mutate({
            email: data.email,
            code: data.code
        });
        else mutation.mutate({
            email: data.email,
            code: data.code
        });
    };
    (0, $exYeM.useEffect)(()=>{
        if (!open) setCode(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: props.setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                                    className: "pt-4",
                                    onSubmit: handleSubmit(onSubmit),
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                    className: "block text-md font-roboto font-light",
                                                    children: "Email:"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    type: "text",
                                                    name: "email",
                                                    placeholder: "Email",
                                                    className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.email ? "is-invalid" : ""}`,
                                                    ...register("email")
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "invalid-feedback",
                                                    children: errors.email?.message
                                                })
                                            ]
                                        }),
                                        code ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                    className: "block text-md font-roboto font-light",
                                                    children: "Code:"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    type: "text",
                                                    name: "code",
                                                    placeholder: "Code",
                                                    className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.code ? "is-invalid" : ""}`,
                                                    ...register("code")
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "invalid-feedback",
                                                    children: errors.code?.message
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                                        message && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "form-group",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: successful ? "alert alert-success" : "alert alert-danger",
                                                role: "alert",
                                                children: message
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "py-4 grid grid-cols-3",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                type: "submit",
                                                className: "bg-surfaceVariant group hover:bg-primary hover:text-white text-gray-900 mt-3 inline-flex gap-4 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm  sm:mt-0 sm:w-auto",
                                                disabled: loading,
                                                children: [
                                                    loading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 animate-spin group-hover:text-white"
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {}),
                                                    "Update"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}






function $6d0c9336469d7e4d$export$2e2bcd8739ae039() {
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const { isError: isError, isLoading: isLoading, isFetching: isFetching, data: data, refetch: refetch } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "userInfo"
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/user", {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }).catch(function(error) {
                return error;
            });
            return data;
        },
        staleTime: 500
    });
    return {
        isError: isError,
        data: data,
        isLoading: isLoading,
        isFetching: isFetching,
        refetch: refetch
    };
}



function $37649f0fd6e2a1d7$var$UserSettings() {
    const { user: user, signOut: signOut, setSignOut: setSignOut } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    const [selectedTier, setselectedTier] = (0, $exYeM.useState)("T1");
    const [source, setSource] = (0, $exYeM.useState)("Normal");
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const userInfo = (0, $6d0c9336469d7e4d$export$2e2bcd8739ae039)();
    // available tiers
    const [tier] = (0, $exYeM.useState)({
        0: "Basic",
        1: "Standard",
        2: "Professional",
        3: "Industry"
    });
    const [selectedMail, setSelectedMail] = (0, $exYeM.useState)("False");
    const [mail] = (0, $exYeM.useState)({
        true: "Yes",
        false: "No"
    });
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const [openUsername, setOpenUsername] = (0, $exYeM.useState)(false);
    const [openEmail, setOpenEmail] = (0, $exYeM.useState)(false);
    // checks if the user had an error when verifying then redirects
    (0, $exYeM.useEffect)(()=>{
        if (user === 401 || user === 404) navigate("/signin");
    }, [
        user
    ]);
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    function getTier() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).tier > 0;
        else return null;
    }
    // sends user to stripe billing to manage the subscription
    const handleBilling = ()=>{
        fetch("https://api.wevr.ai/V2" + `/stripe/billing`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`
            },
            // Send along all the information about the items
            body: JSON.stringify({})
        }).then((res)=>{
            if (res.ok) return res.json();
            return res.json().then((json)=>Promise.reject(json));
        }).then(({ url: url })=>{
            window.location = url;
        }).catch((e)=>{
            console.error(e.error);
        });
    };
    // gets all the user info to show the user
    if (getTier() != null) {
        const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
            mutationFn: async ({ mailList: mailList })=>{
                return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put("/user/updateMailList", {
                    mail: mailList
                }, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).accessToken}`
                    }
                });
            },
            onSuccess: (res)=>{
                setSelectedMail(mail[res.data.data]);
            },
            onError: (error)=>{
                console.error(error);
            }
        });
        const onSubmit = (data)=>{
            mutation.mutate({
                mailList: data
            });
        };
        (0, $exYeM.useEffect)(()=>{
            userInfo.refetch();
        }, [
            openUsername,
            openEmail
        ]);
        (0, $exYeM.useEffect)(()=>{
            setSelectedMail(mail[userInfo.data?.data.user.mailList]);
            setselectedTier(userInfo.data?.data.user.tier);
            setSource(userInfo.data?.data.user.source);
        }, [
            userInfo.data
        ]);
        if (userInfo.isLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "px-4 py-5 sm:p-6 h-[75vh]",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "bg-white flex h-full shadow rounded-md justify-center items-center divide-gray-200 dark:bg-primary-DM overflow-auto",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "text-center ",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
                        role: "status",
                        className: "inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-primary",
                        viewBox: "0 0 100 101",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                fill: "currentColor"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                fill: "currentFill"
                            })
                        ]
                    })
                })
            })
        });
        return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "min-h-[75vh] grid place-items-center py-2 font-roboto overflow-x-hidden sm:mb-8",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex flex-col gap-4 max-w-6xl grow pb-4 px-2",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7da6cd7a80759224$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "pt-4 px-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: " font-semibold text-center text-2xl sm:text-4xl ml-2 pb-2 text-gray-900",
                                children: "Account Information"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: " bg-white rounded-2xl p-4 grid grid-cols-1 sm:grid-cols-2 sm:gap-y-4 border border-surfaceVariant shadow-md",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 h-16 items-center flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Username"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "px-2 py-2 h-16 items-center flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                            className: "text-md sm:text-xl",
                                            children: userInfo.data?.data.user.username
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                            onClick: ()=>{
                                                setOpenUsername(true);
                                            },
                                            className: "text-md sm:text-xl bg-surfaceVariant rounded-md px-3 py-2 hover:bg-primary hover:text-white border border-primaryContainer shadow-sm",
                                            children: "Update"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 h-16 items-center flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Email"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "px-2 py-2 h-16 items-center flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                            className: "text-md sm:text-xl",
                                            children: userInfo.data?.data.user.email
                                        }),
                                        source != "" ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                            onClick: ()=>{
                                                setOpenEmail(true);
                                            },
                                            className: "text-md sm:text-xl rounded-md px-3 py-2 hover:bg-primary hover:text-white bg-surfaceVariant border border-primaryContainer shadow-sm",
                                            children: "Update"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 h-16 items-center flex",
                                    children: source != "" ? /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Registered With"
                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Password"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 h-16 items-center flex",
                                    children: source != "" ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-md sm:text-xl ",
                                        children: source
                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        onClick: ()=>{
                                            setOpen(true);
                                        },
                                        className: "text-md sm:text-xl bg-surfaceVariant border border-primaryContainer shadow-sm rounded-md px-3 py-2 hover:bg-primary hover:text-white",
                                        children: "Change Password"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 h-16 items-center flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Marketing email"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 flex gap-2",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "grid grid-flow-col space-x-1 rounded-xl bg-surfaceVariant border border-primaryContainer shadow-sm",
                                        children: Object.keys(mail).map((category)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                onClick: ()=>{
                                                    onSubmit(category);
                                                },
                                                className: `${selectedMail === mail[category] ? "bg-primary text-white text-bold" : "hover:bg-primary/30"} rounded-xl py-2.5 px-3 text-black`,
                                                children: mail[category]
                                            }, category))
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 items-center flex gap-2",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Subscription level"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "px-2 py-2 flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "block sm:hidden",
                                            children: tier[selectedTier]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "grid-flow-col space-x-2 rounded-xl bg-surfaceVariant border border-primaryContainer shadow-sm hidden sm:grid",
                                            children: Object.keys(tier).map((category)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    onClick: ()=>{
                                                        navigate("/pricing");
                                                    },
                                                    className: `${selectedTier == category ? "bg-primary text-white text-bold" : ""} rounded-xl py-2.5 px-3 text-black`,
                                                    children: tier[category]
                                                }, category))
                                        })
                                    ]
                                }),
                                userInfo.data?.data.user.paidBy ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 h-16 items-center flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Subscribed with"
                                    })
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                                userInfo.data?.data.user.paidBy ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "px-2 py-2 h-16 items-center flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                            className: "text-md sm:text-xl pr-2",
                                            children: userInfo.data?.data.user.paidBy
                                        }),
                                        userInfo.data?.data.user.paidBy === "Stripe" ? /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                            onClick: ()=>{
                                                handleBilling();
                                            },
                                            className: "text-md sm:text-xl bg-surfaceVariant border border-primaryContainer shadow-sm rounded-md px-3 py-2 hover:bg-primary hover:text-white",
                                            children: "Manage"
                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {})
                                    ]
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                                getTier() ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 h-16 items-center flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Subscription ends"
                                    })
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                                getTier() ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 h-16 items-center flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl ",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($jR9u2)))(userInfo.data?.data.user.subscriptionEnd).format("MMMM Do YYYY, h:mm a")
                                    })
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 items-center flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl font-semibold",
                                        children: "Created on"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 items-center flex",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "text-md sm:text-xl",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($jR9u2)))(userInfo.data?.data.user.createdAt).format("MMMM Do YYYY, h:mm a")
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "px-2 py-2 col-span-2 place-content-center mt-4",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        className: "text-md sm:text-xl bg-surfaceVariant border border-primaryContainer shadow-sm rounded-md px-3 py-2 w-56 hover:bg-primary hover:text-white",
                                        onClick: ()=>{
                                            // console.log("sign out called");
                                            setSignOut(true);
                                            localStorage.removeItem("user");
                                            navigate("/");
                                            window.location.reload();
                                        },
                                        children: "Sign out"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2df728e2d28e425f$export$2e2bcd8739ae039), {
                    open: open,
                    setOpen: setOpen
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f61a173045955eae$export$2e2bcd8739ae039), {
                    open: openUsername,
                    setOpen: setOpenUsername
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $204f36e227e46ec8$export$2e2bcd8739ae039), {
                    open: openEmail,
                    setOpen: setOpenEmail
                })
            ]
        });
    } else {
        if (localStorage.getItem("user") == null) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: " min-h-[75vh] flex flex-col justify-center items-center w-full mx-auto",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex items-center gap-8 py-4",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "rounded-full bg-surfaceVariant p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                                className: "w-16 h-16 text-onSurfaceVariant"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-5xl md:leading-6 text-gray-600 ",
                                children: "Not logged in!"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: " text-gray-400 text-2xl gap-6 flex flex-col items-center",
                    children: [
                        "Login to see your settings",
                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            className: "bg-surfaceVariant px-4 py-2 rounded-md text-black hover:bg-primary hover:text-white",
                            onClick: ()=>navigate("/signin"),
                            children: "Login"
                        })
                    ]
                })
            ]
        });
    }
}
var $37649f0fd6e2a1d7$export$2e2bcd8739ae039 = $37649f0fd6e2a1d7$var$UserSettings;


// created by james launder
// simple faw page pretty sure it was taken from tailwind ui cant remember tho

var $aSiaI = parcelRequire("aSiaI");


const $cedd06c48d896b34$var$faqs = [
    {
        question: "What payment options do you offer?",
        answer: "We offer many payment options as Stripe processes our payment for credit and debit cards, the available options can be viewed at checkout. We also offer crypto payment which is processed via Coinbase."
    },
    {
        question: "Do you provide a free trial?",
        answer: "We do not provide a free trial. However, we do provide a free base tier that can be used to check out the features we offer!"
    },
    {
        question: "Can I cancel my plan at any time?",
        answer: "If paid via Stripe (credit card/debit card), you will not be charged at the next billing cycle and maintain access till the end of your current subscription. If paid via crypto, this is not a subscription but a once off payment and your access will end at the current subscription period."
    },
    {
        question: "Can I upgrade my plan at any time?",
        answer: "If paid via Stripe (credit card/debit card), you can upgrade at any time via the manage button in user settings and the cost will be calculated based off the remaining time of your current subscription. If paid via crypto, you cannot upgrade until near the end of your current subscription period unless you contact us."
    }
];
function $cedd06c48d896b34$var$Faq() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative z-0 bg-surface overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "relative z-10 top-[190px] left-[350px] mx-auto max-w-6xl md:block hidden",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7da6cd7a80759224$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "relative z-20 mx-auto max-w-7xl h-full px-6 py-12 sm:pt-32 lg:py-20 lg:px-8",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "lg:grid lg:grid-cols-12 lg:gap-8",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "lg:col-span-5 bg-white border border-primaryContainer rounded-lg p-4 h-fit shadow-md",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                    className: "text-2xl font-bold leading-10 tracking-tight text-gray-900",
                                    children: "Frequently asked questions"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
                                    className: "mt-4 text-base leading-7 text-gray-600",
                                    children: [
                                        "Can\u2019t find the answer you\u2019re looking for? Reach out to our",
                                        " ",
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                            onClick: ()=>navigate("/Contact"),
                                            className: "font-semibold text-indigo-600 hover:text-indigo-500",
                                            children: "customer support"
                                        }),
                                        " ",
                                        "team. Or check out our",
                                        " ",
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                            href: "https://docs.wevr.ai",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "font-semibold text-indigo-600 hover:text-indigo-500",
                                            children: "documentation"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "mt-10 lg:col-span-7 lg:mt-0 bg-white border border-primaryContainer shadow-md rounded-lg p-4 h-fit",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("dl", {
                                className: "space-y-10",
                                children: $cedd06c48d896b34$var$faqs.map((faq)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("dt", {
                                                className: "text-base font-semibold leading-7 text-gray-900",
                                                children: faq.question
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("dd", {
                                                className: "mt-2 text-base leading-7 text-gray-600",
                                                children: faq.answer
                                            })
                                        ]
                                    }, faq.question))
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $cedd06c48d896b34$export$2e2bcd8739ae039 = $cedd06c48d896b34$var$Faq;


// Created by Matt Webb
// main News page that holds the query and calls the sub components

var $aSiaI = parcelRequire("aSiaI");


// most of these queries are for the home page.
const $dfc9d721508a4c5f$var$userInfo = (id)=>{
    return (0, $ca6473885cd32228$export$2e2bcd8739ae039)({
        url: "/user/" + id,
        method: "GET"
    });
};
const $dfc9d721508a4c5f$var$getHomepage = ()=>{
    return (0, $ca6473885cd32228$export$2e2bcd8739ae039)({
        url: "/bundledHome",
        method: "GET"
    });
};
const $dfc9d721508a4c5f$var$getBlocks = ()=>{
    return (0, $ca6473885cd32228$export$2e2bcd8739ae039)({
        url: "/homepageBlocks",
        method: "GET"
    });
};
const $dfc9d721508a4c5f$var$getSize = ()=>{
    return (0, $ca6473885cd32228$export$2e2bcd8739ae039)({
        url: "/homepageSize",
        method: "GET"
    });
};
const $dfc9d721508a4c5f$var$getChains = ()=>{
    return (0, $ca6473885cd32228$export$2e2bcd8739ae039)({
        url: "/homepageChains",
        method: "GET"
    });
};
const $dfc9d721508a4c5f$var$getNewsPage = (page)=>{
    return (0, $ca6473885cd32228$export$2e2bcd8739ae039)({
        url: `/News?page=${page}`,
        method: "GET"
    });
};
const $dfc9d721508a4c5f$var$ApiService = {
    userInfo: $dfc9d721508a4c5f$var$userInfo,
    getHomepage: $dfc9d721508a4c5f$var$getHomepage,
    getNewsPage: $dfc9d721508a4c5f$var$getNewsPage,
    getBlocks: $dfc9d721508a4c5f$var$getBlocks,
    getSize: $dfc9d721508a4c5f$var$getSize,
    getChains: $dfc9d721508a4c5f$var$getChains
};
var $dfc9d721508a4c5f$export$2e2bcd8739ae039 // export default class ApiService {
 //   static getHomepage() {
 //     return request({
 // url: "/bundledHome",
 // method: "GET",
 //     });
 //   }
 //   static login(username, password) {
 //     return request({
 //       url: "/signin",
 //       method: "POST",
 //       data: { email: username, password: password },
 //     });
 //   }
 // }
 // export async function getHomepage() {
 //   return await request({
 //     url: "/bundledHome",
 //     method: "GET",
 //   });
 // }
 = $dfc9d721508a4c5f$var$ApiService;



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $27d9ac66a331f667$var$InformationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
    }));
}
const $27d9ac66a331f667$var$ForwardRef = $exYeM.forwardRef($27d9ac66a331f667$var$InformationCircleIcon);
var $27d9ac66a331f667$export$2e2bcd8739ae039 = $27d9ac66a331f667$var$ForwardRef;



// created by james launder
// used to show the sentiment, changes based on screen size
/* eslint-disable no-unused-vars */ 
var $aSiaI = parcelRequire("aSiaI");

const $8103b6bced4b25b4$var$ProgressBar = (props)=>{
    let { size: size = 150, progress: progress = 0, trackWidth: trackWidth = 10, trackColor: trackColor = `#ddd`, indicatorWidth: indicatorWidth = 10, indicatorColor: indicatorColor = `#07c`, indicatorCap: indicatorCap = `round`, label: label = `Sentiement`, secondLabel: secondLabel = "Neutral", labelColor: labelColor = `#333`, spinnerMode: spinnerMode = false, spinnerSpeed: spinnerSpeed = 1 } = props;
    function calculateNewValue(value) {
        return (value + 5) * 10;
    }
    function calculateText(value) {
        if (value == -5) return "Terrible";
        else if (value <= -2) return "Poor";
        else if (value < 2) return "Neutral";
        else if (value < 5) return "Good";
        else return "Excellent";
    }
    function calculateColor(value) {
        if (value == -5) return "#ef4444";
        else if (value <= -2) return "#f97316";
        else if (value < 2) return "#facc15";
        else if (value < 5) return "#a3e635";
        else return "#22c55e";
    }
    var center = size / 2, radius = center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth), dashArray = 2 * Math.PI * radius, dashOffset = dashArray * ((100 - calculateNewValue(progress)) / 100);
    let hideLabel = size < 100 || !label.length || spinnerMode ? true : false;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "svg-pi-wrapper",
            style: {
                width: size,
                height: size
            },
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
                    className: "svg-pi",
                    style: {
                        width: size,
                        height: size
                    },
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                            className: "svg-pi-track",
                            cx: center,
                            cy: center,
                            fill: "transparent",
                            r: radius,
                            stroke: trackColor,
                            strokeWidth: trackWidth
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                            className: `svg-pi-indicator ${spinnerMode ? "svg-pi-indicator--spinner" : ""}`,
                            style: {
                                animationDuration: spinnerSpeed * 1000
                            },
                            cx: center,
                            cy: center,
                            fill: "transparent",
                            r: radius,
                            stroke: calculateColor(progress),
                            strokeWidth: indicatorWidth,
                            strokeDasharray: dashArray,
                            strokeDashoffset: dashOffset,
                            strokeLinecap: indicatorCap
                        })
                    ]
                }),
                !hideLabel && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "svg-pi-label",
                    style: {
                        color: labelColor
                    },
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                            className: "svg-pi-label__loading",
                            children: [
                                calculateNewValue(progress),
                                "%"
                            ]
                        }),
                        !spinnerMode && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            className: "svg-pi-label__progress",
                            children: calculateText(progress)
                        })
                    ]
                })
            ]
        })
    });
};
var $8103b6bced4b25b4$export$2e2bcd8739ae039 = $8103b6bced4b25b4$var$ProgressBar;





var $aSiaI = parcelRequire("aSiaI");

function $9da9c1ba51a50cc6$var$Error() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)("main", {
        className: "grid min-h-fit place-items-center py-24 px-6 sm:py-32 lg:px-8 font-roboto",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                    className: "mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                    children: "Page not found"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "mt-6 text-base leading-7 text-gray-600",
                    children: "Sorry, we couldn\u2019t find the page you\u2019re looking for."
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "mt-6 flex items-center justify-center gap-x-6",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        onClick: ()=>{
                            navigate("/");
                        },
                        className: "rounded-lg bg-primaryContainer px-3 py-2 text-sm font-semibold text-black shadow-sm hover:text-white hover:bg-primary",
                        children: "Go back home"
                    })
                })
            ]
        })
    });
}
var $9da9c1ba51a50cc6$export$2e2bcd8739ae039 = $9da9c1ba51a50cc6$var$Error;


// created by james launder
// similar to small chart container from charting
// minor tweaks to make it work for news format

var $aSiaI = parcelRequire("aSiaI");

// Created by James Launder
// similar to other small chart with some tweaks to make it work in the news format

var $aSiaI = parcelRequire("aSiaI");



var $exYeM = parcelRequire("exYeM");
function $4b778a1dd7f9b729$var$NewsChart(props) {
    //   const { theme } = useContext(ThemeContext);
    var newStyle = document.createElement("style");
    newStyle.appendChild(document.createTextNode("@font-face {  font-family: 'Monda';  font-style: sans-serif;  font-weight: 400;  src: url('https://fonts.googleapis.com/css2?family=Monda&display=swap')  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}"));
    document.head.appendChild(newStyle);
    const [options] = (0, $exYeM.useState)({
        exporting: {
            enabled: false,
            enableImages: true
        },
        chart: {
            type: "area",
            backgroundColor: "transparent"
        },
        title: {
            text: ""
        },
        xAxis: {
            visible: false,
            type: "datetime"
        },
        yAxis: {
            visible: false
        },
        legend: {
            enabled: false
        },
        series: [
            {
                name: props.name,
                data: props.data.graphData[0]?.values,
                color: "#FA9173",
                backgroundColor: "transparent",
                animation: false,
                lineWidth: 1,
                shadow: false,
                states: {
                    hover: {
                        lineWidth: 1
                    }
                },
                marker: {
                    radius: 1,
                    states: {
                        hover: {
                            radius: 2
                        }
                    }
                },
                fillOpacity: 0.25
            }
        ],
        credits: {
            enabled: false
        }
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
            highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($bdf625fc24abd869$exports))),
            containerProps: {
                style: {
                    height: props.height
                }
            },
            options: options
        })
    });
}
var $4b778a1dd7f9b729$export$2e2bcd8739ae039 = $4b778a1dd7f9b729$var$NewsChart;





function $fd0ad95d06e7751b$var$NewsChartContainer(props) {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const colour = (first, last)=>{
        if (first > last) return false;
        return true;
    };
    const graphData = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "news-chart-" + props.graphName + "-" + props.blockchain
        ],
        queryFn: ()=>{
            const data = (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(props.blockchain + "/Day/LimitAmount/" + props.graphName + "/14").catch(function(error) {
                return error.response.status;
            });
            return data;
        },
        enabled: props.isSuccess
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "width-fit",
        children: graphData.isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: " h-auto rounded-xl animate-pulse flex items-center justify-center",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports))),
                alt: "...",
                className: "h-[100px] md:h-[140px]"
            })
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            children: graphData.isError || graphData.data === 404 ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: "Error!"
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                className: "flex flex-col divide-y w-full justify-center",
                onClick: ()=>{
                    navigate({
                        pathname: "/Explore",
                        search: "?blockchain=" + props.blockchain + "&name=" + props.graphName
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "text-center font-bold font-roboto px-3 py-2 w-full",
                        children: props.graphName + "-" + props.blockchain
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4b778a1dd7f9b729$export$2e2bcd8739ae039), {
                            data: graphData.data.data,
                            name: props.graphName,
                            height: props.graphHeight
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex justify-around py-2 w-full",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "flex flex-row text-center align-baseline px-3 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "font-roboto align-baseline mb-[0.5] text-sm",
                                        children: [
                                            props.timePeriod,
                                            ": "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: `${colour(graphData.data.data.graphData[0]?.values.slice(-1)[0][1], graphData.data.data.graphData[0]?.values.slice(0)[0][1]) ? "text-green-600" : "text-red-600"} font-monda font-bold align-baseline text-sm`,
                                        children: [
                                            ((graphData.data.data.graphData[0]?.values.slice(0)[0][1] - graphData.data.data.graphData[0]?.values.slice(-1)[0][1]) / graphData.data.data.graphData[0]?.values.slice(0)[0][1] * 100).toFixed(1),
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "flex flex-row text-center align-baseline px-3 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "font-roboto  align-baseline mb-[0.5] text-sm",
                                        children: [
                                            "Last:",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "font-monda font-bold align-baseline text-sm",
                                        children: graphData.data.data.graphData[0]?.values.slice(0)[0][1].toLocaleString("en-US", {
                                            maximumFractionDigits: 2
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $fd0ad95d06e7751b$export$2e2bcd8739ae039 = $fd0ad95d06e7751b$var$NewsChartContainer;


function $c457c4691ba1ff56$var$calculateText(value) {
    if (value == -5) return "Terrible";
    else if (value <= -2) return "Poor";
    else if (value < 2) return "Neutral";
    else if (value < 5) return "Good";
    else return "Excellent";
}
function $c457c4691ba1ff56$var$News() {
    // thing we want to assoicate with button
    const [page, setPage] = (0, $exYeM.useState)(0);
    const { isLoading: statsLoading, isError: statsIsError, isFetching: isFetching, isSuccess: isSuccess, data: statsData2 } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "news",
            page
        ],
        queryFn: async ()=>(0, $dfc9d721508a4c5f$export$2e2bcd8739ae039).getNewsPage(page),
        keepPreviousData: true
    });
    const prevPage = ()=>{
        setPage((page)=>page - 1);
        window.scrollTo(0, 0);
    };
    const nextPage = ()=>{
        setPage((page)=>page + 1);
        window.scrollTo(0, 0);
    };
    if (statsLoading || isFetching) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "max-w-7xl mx-auto font-roboto px-4",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "py-4 flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "grid md:grid-cols-12 bg-white mt-2 border-secondary border-2 text-roboto rounded-lg gap-2 w-full h-56",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-4 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-2 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block md:hidden relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "grid md:grid-cols-12 bg-white mt-2 border-secondary border-2 text-roboto rounded-lg gap-2 w-full h-56",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-4 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-2 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block md:hidden relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "grid md:grid-cols-12 bg-white mt-2 border-secondary border-2 text-roboto rounded-lg gap-2 w-full h-56",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-4 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-2 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block md:hidden relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "grid md:grid-cols-12 bg-white mt-2 border-secondary border-2 text-roboto rounded-lg gap-2 w-full h-56",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-4 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-2 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block md:hidden relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "grid md:grid-cols-12 bg-white mt-2 border-secondary border-2 text-roboto rounded-lg gap-2 w-full h-56",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-4 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-2 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block md:hidden relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "grid md:grid-cols-12 bg-white mt-2 border-secondary border-2 text-roboto rounded-lg gap-2 w-full h-56",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-4 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-2 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block md:hidden relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "grid md:grid-cols-12 bg-white mt-2 border-secondary border-2 text-roboto rounded-lg gap-2 w-full h-56",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-4 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-3 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden md:block md:col-span-2 relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block md:hidden relative bg-gray-300 m-6 rounded-lg animate-pulse"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "max-w-7xl mx-auto font-roboto px-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: statsIsError ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9da9c1ba51a50cc6$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex flex-col gap-2 py-4",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "hidden md:grid md:grid-cols-12 gap-2 md:text-xl text-center text-gray-900 py-2 border-secondary border-b rounded-t-lg",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "md:col-span-3 border-r px-4",
                                    children: "Post"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "md:col-span-4 border-r px-4",
                                    children: "Summary"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "md:col-span-3 border-r px-4",
                                    children: "Related Chart"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "sentiment md:col-span-2 flex justify-center",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex items-center gap-1",
                                        children: [
                                            "Sentiment",
                                            " ",
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27d9ac66a331f667$export$2e2bcd8739ae039), {
                                                className: "h-[18px] w-[18px] "
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6569f55e54f7ff9d$export$28c660c63b792dea), {
                                                anchorSelect: ".sentiment",
                                                place: "bottom",
                                                className: "text-xs",
                                                children: "Sentiment is not always accurate and does not indicate journalistic bias. This sentiment does not dictate the views of journalistic outlets nor associated authors."
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        statsData2.data.news.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "grid md:grid-cols-12 bg-white mt-2 border-primaryContainer border shadow-md text-roboto rounded-lg gap-2 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "md:col-span-3 p-2 border-b md:border-r  md:border-b-0 px-6",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                                            href: data.link,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "relative mx-auto rounded-lg overflow-hidden",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                        src: data?.media_content != undefined ? data?.media_content[0]["url"] : "",
                                                        alt: "",
                                                        className: "object-contain"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                                    className: "text-md text-gray-600",
                                                    children: data.author
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                                                    className: "text-sm text-gray-600",
                                                    children: [
                                                        "Posted:",
                                                        " ",
                                                        (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(data.published * 1000).format("MM/DD/YYYY")
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "md:col-span-4 p-2 border-b md:border-r md:border-b-0 px-6",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-lg lg:text-xl text-gray-900",
                                                children: data.title
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-sm lg:text-md text-gray-600 mt-2",
                                                children: data.summary
                                            })
                                        ]
                                    }),
                                    data.blockchainChart ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "md:col-span-3 px-2 flex items-center justify-center border-b md:border-r md:border-b-0",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "block md:hidden lg:block relative w-full",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fd0ad95d06e7751b$export$2e2bcd8739ae039), {
                                                    graphName: data.chartname,
                                                    blockchain: data.blockchainChart.charAt(0).toUpperCase() + data.blockchainChart.slice(1),
                                                    timePeriod: "14d",
                                                    graphHeight: "140px",
                                                    isSuccess: isSuccess
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "hidden md:block lg:hidden relative w-full",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fd0ad95d06e7751b$export$2e2bcd8739ae039), {
                                                    graphName: data.chartname,
                                                    blockchain: data.blockchainChart.charAt(0).toUpperCase() + data.blockchainChart.slice(1),
                                                    timePeriod: "14d",
                                                    graphHeight: "100px",
                                                    isSuccess: isSuccess
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        children: "error"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "md:col-span-2 flex items-center justify-center ",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "block md:hidden pb-2 relative px-4 w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: " mb-1 text-gray-600 ",
                                                        children: [
                                                            "Sentiment: ",
                                                            $c457c4691ba1ff56$var$calculateText(data.Sentiment),
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c904cb26bc87c9e1$export$2e2bcd8739ae039), {
                                                        value: data.Sentiment
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "hidden lg:block",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8103b6bced4b25b4$export$2e2bcd8739ae039), {
                                                    trackColor: "#E6DCDC",
                                                    indicatorColor: "#FA9173",
                                                    size: 150,
                                                    progress: data.Sentiment,
                                                    trackWidth: 10,
                                                    indicatorWidth: 10,
                                                    spinnerMode: false,
                                                    secondLabel: "Neutral"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "hidden md:block lg:hidden",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8103b6bced4b25b4$export$2e2bcd8739ae039), {
                                                        trackColor: "#E6DCDC",
                                                        indicatorColor: "#FA9173",
                                                        size: 90,
                                                        progress: data.Sentiment,
                                                        trackWidth: 10,
                                                        indicatorWidth: 10,
                                                        spinnerMode: false,
                                                        secondLabel: "Neutral"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "text-center text-bold text-2xl mt-2",
                                                        children: $c457c4691ba1ff56$var$calculateText(data.Sentiment)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, data.id))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("nav", {
                className: "flex items-center justify-between border-secondary border-t p-2 rounded-b-lg",
                "aria-label": "Pagination",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "hidden sm:block",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
                            className: "text-sm text-gray-600",
                            children: [
                                "Showing ",
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                    className: "font-medium",
                                    children: [
                                        "Page : ",
                                        page + 1,
                                        " "
                                    ]
                                }),
                                " of",
                                " ",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "font-medium",
                                    children: statsData2?.data.pages - 1
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex justify-between sm:justify-end gap-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                disabled: page === 0,
                                onClick: prevPage,
                                className: "bg-surfaceVariant px-4 py-2 text-black rounded-lg shadow-md hover:bg-primary hover:text-white border border-primaryContainer",
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                disabled: page === statsData2?.data.pages,
                                onClick: nextPage,
                                className: "bg-surfaceVariant px-4 py-2 text-black rounded-lg shadow-md hover:bg-primary hover:text-white border border-primaryContainer",
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $c457c4691ba1ff56$export$2e2bcd8739ae039 = $c457c4691ba1ff56$var$News;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

const $b0bdc6a2cae10298$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, ref)=>{
    const { className: className, type: type, ...otherProps } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
        type: type,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", className),
        ref: ref,
        ...otherProps
    });
});
$b0bdc6a2cae10298$export$f5b8910cec6cf069.displayName = "Input";



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
// packages/react/primitive/src/Primitive.tsx

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
// packages/react/slot/src/Slot.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/compose-refs/src/composeRefs.tsx

var $exYeM = parcelRequire("exYeM");
function $c1ae2d19d9d64757$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $c1ae2d19d9d64757$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $c1ae2d19d9d64757$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $c1ae2d19d9d64757$var$setRef(refs[i], null);
            }
        };
    };
}
function $c1ae2d19d9d64757$export$c7b2cbe3552a0d05(...refs) {
    return $exYeM.useCallback($c1ae2d19d9d64757$export$43e446d32b3d21af(...refs), refs);
}



var $aSiaI = parcelRequire("aSiaI");
var $c7b77e38160c5c7f$export$8c6ed5c666ac1360 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $exYeM.Children.toArray(children);
    const slottable = childrenArray.find($c7b77e38160c5c7f$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($exYeM.Children.count(newElement) > 1) return $exYeM.Children.only(null);
                return $exYeM.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $aSiaI.jsx)($c7b77e38160c5c7f$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $exYeM.isValidElement(newElement) ? $exYeM.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $aSiaI.jsx)($c7b77e38160c5c7f$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$c7b77e38160c5c7f$export$8c6ed5c666ac1360.displayName = "Slot";
var $c7b77e38160c5c7f$var$SlotClone = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($exYeM.isValidElement(children)) {
        const childrenRef = $c7b77e38160c5c7f$var$getElementRef(children);
        return $exYeM.cloneElement(children, {
            ...$c7b77e38160c5c7f$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $c1ae2d19d9d64757$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $exYeM.Children.count(children) > 1 ? $exYeM.Children.only(null) : null;
});
$c7b77e38160c5c7f$var$SlotClone.displayName = "SlotClone";
var $c7b77e38160c5c7f$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: children
    });
};
function $c7b77e38160c5c7f$var$isSlottable(child) {
    return $exYeM.isValidElement(child) && child.type === $c7b77e38160c5c7f$export$d9f1ccf0bdb05d45;
}
function $c7b77e38160c5c7f$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $c7b77e38160c5c7f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $c7b77e38160c5c7f$export$be92b6f5f03c0fe9 = $c7b77e38160c5c7f$export$8c6ed5c666ac1360;



var $aSiaI = parcelRequire("aSiaI");
var $0de2bdb5fd7b9fb4$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $0de2bdb5fd7b9fb4$export$250ffa63cdc0d034 = $0de2bdb5fd7b9fb4$var$NODES.reduce((primitive, node)=>{
    const Node = $exYeM.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $c7b77e38160c5c7f$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $aSiaI.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $0de2bdb5fd7b9fb4$export$6d1a0317bde7de7f(target, event) {
    if (target) $d2lNW.flushSync(()=>target.dispatchEvent(event));
}
var $0de2bdb5fd7b9fb4$export$be92b6f5f03c0fe9 = $0de2bdb5fd7b9fb4$export$250ffa63cdc0d034;



var $exYeM = parcelRequire("exYeM");

// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $exYeM = parcelRequire("exYeM");
var $e043ec26b5b8c7d8$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $exYeM.useLayoutEffect : ()=>{};


"use client";
function $685a4afdce366793$var$useStateMachine(initialState, machine) {
    return $exYeM.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $685a4afdce366793$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $685a4afdce366793$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $exYeM.Children.only(children);
    const ref = (0, $c1ae2d19d9d64757$export$c7b2cbe3552a0d05)(presence.ref, $685a4afdce366793$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $exYeM.cloneElement(child, {
        ref: ref
    }) : null;
};
$685a4afdce366793$export$99c2b779aa4e8b8b.displayName = "Presence";
function $685a4afdce366793$var$usePresence(present) {
    const [node, setNode] = $exYeM.useState();
    const stylesRef = $exYeM.useRef({});
    const prevPresentRef = $exYeM.useRef(present);
    const prevAnimationNameRef = $exYeM.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $685a4afdce366793$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $exYeM.useEffect(()=>{
        const currentAnimationName = $685a4afdce366793$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $e043ec26b5b8c7d8$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $685a4afdce366793$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $e043ec26b5b8c7d8$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $685a4afdce366793$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $685a4afdce366793$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $exYeM.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $685a4afdce366793$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $685a4afdce366793$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}


// packages/react/context/src/createContext.tsx

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
function $37b0c6ca8fdf6142$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $exYeM.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $exYeM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $aSiaI.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $exYeM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $37b0c6ca8fdf6142$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $exYeM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $exYeM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $aSiaI.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $exYeM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $exYeM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $exYeM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $37b0c6ca8fdf6142$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $37b0c6ca8fdf6142$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $exYeM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $exYeM = parcelRequire("exYeM");
function $f897ecbf7ee2a036$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $exYeM.useRef(callback);
    $exYeM.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $exYeM.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/direction/src/Direction.tsx

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
var $9c57684066c136d0$var$DirectionContext = $exYeM.createContext(void 0);
var $9c57684066c136d0$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $aSiaI.jsx)($9c57684066c136d0$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $9c57684066c136d0$export$b39126d51d94e6f3(localDir) {
    const globalDir = $exYeM.useContext($9c57684066c136d0$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $9c57684066c136d0$export$2881499e37b75b9a = $9c57684066c136d0$export$c760c09fdd558351;



// packages/core/number/src/number.ts
function $41dd774296a8c200$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}


// packages/core/primitive/src/primitive.tsx
function $240a4d6bd00066aa$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}



var $aSiaI = parcelRequire("aSiaI");
"use client";
function $1a679747f29e7c90$var$useStateMachine(initialState, machine) {
    return $exYeM.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
var $1a679747f29e7c90$var$SCROLL_AREA_NAME = "ScrollArea";
var [$1a679747f29e7c90$var$createScrollAreaContext, $1a679747f29e7c90$export$488468afe3a6f2b1] = (0, $37b0c6ca8fdf6142$export$50c7b4e9d9f19c1)($1a679747f29e7c90$var$SCROLL_AREA_NAME);
var [$1a679747f29e7c90$var$ScrollAreaProvider, $1a679747f29e7c90$var$useScrollAreaContext] = $1a679747f29e7c90$var$createScrollAreaContext($1a679747f29e7c90$var$SCROLL_AREA_NAME);
var $1a679747f29e7c90$export$ccf8d8d7bbf3c2cc = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, type: type = "hover", dir: dir, scrollHideDelay: scrollHideDelay = 600, ...scrollAreaProps } = props;
    const [scrollArea, setScrollArea] = $exYeM.useState(null);
    const [viewport, setViewport] = $exYeM.useState(null);
    const [content, setContent] = $exYeM.useState(null);
    const [scrollbarX, setScrollbarX] = $exYeM.useState(null);
    const [scrollbarY, setScrollbarY] = $exYeM.useState(null);
    const [cornerWidth, setCornerWidth] = $exYeM.useState(0);
    const [cornerHeight, setCornerHeight] = $exYeM.useState(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = $exYeM.useState(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = $exYeM.useState(false);
    const composedRefs = (0, $c1ae2d19d9d64757$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setScrollArea(node));
    const direction = (0, $9c57684066c136d0$export$b39126d51d94e6f3)(dir);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaProvider, {
        scope: __scopeScrollArea,
        type: type,
        dir: direction,
        scrollHideDelay: scrollHideDelay,
        scrollArea: scrollArea,
        viewport: viewport,
        onViewportChange: setViewport,
        content: content,
        onContentChange: setContent,
        scrollbarX: scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled: scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY: scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled: scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $0de2bdb5fd7b9fb4$export$250ffa63cdc0d034).div, {
            dir: direction,
            ...scrollAreaProps,
            ref: composedRefs,
            style: {
                position: "relative",
                // Pass corner sizes as CSS vars to reduce re-renders of context consumers
                ["--radix-scroll-area-corner-width"]: cornerWidth + "px",
                ["--radix-scroll-area-corner-height"]: cornerHeight + "px",
                ...props.style
            }
        })
    });
});
$1a679747f29e7c90$export$ccf8d8d7bbf3c2cc.displayName = $1a679747f29e7c90$var$SCROLL_AREA_NAME;
var $1a679747f29e7c90$var$VIEWPORT_NAME = "ScrollAreaViewport";
var $1a679747f29e7c90$export$a21cbf9f11fca853 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, children: children, nonce: nonce, ...viewportProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$VIEWPORT_NAME, __scopeScrollArea);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $c1ae2d19d9d64757$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    return /* @__PURE__ */ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /* @__PURE__ */ (0, $aSiaI.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $aSiaI.jsx)((0, $0de2bdb5fd7b9fb4$export$250ffa63cdc0d034).div, {
                "data-radix-scroll-area-viewport": "",
                ...viewportProps,
                ref: composedRefs,
                style: {
                    /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */ overflowX: context.scrollbarXEnabled ? "scroll" : "hidden",
                    overflowY: context.scrollbarYEnabled ? "scroll" : "hidden",
                    ...props.style
                },
                children: /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
                    ref: context.onContentChange,
                    style: {
                        minWidth: "100%",
                        display: "table"
                    },
                    children: children
                })
            })
        ]
    });
});
$1a679747f29e7c90$export$a21cbf9f11fca853.displayName = $1a679747f29e7c90$var$VIEWPORT_NAME;
var $1a679747f29e7c90$var$SCROLLBAR_NAME = "ScrollAreaScrollbar";
var $1a679747f29e7c90$export$2fabd85d0eba3c57 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange, onScrollbarYEnabledChange: onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === "horizontal";
    $exYeM.useEffect(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === "hover" ? /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarHover, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "scroll" ? /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarScroll, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "auto" ? /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarAuto, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "always" ? /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarVisible, {
        ...scrollbarProps,
        ref: forwardedRef
    }) : null;
});
$1a679747f29e7c90$export$2fabd85d0eba3c57.displayName = $1a679747f29e7c90$var$SCROLLBAR_NAME;
var $1a679747f29e7c90$var$ScrollAreaScrollbarHover = $exYeM.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [visible, setVisible] = $exYeM.useState(false);
    $exYeM.useEffect(()=>{
        const scrollArea = context.scrollArea;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false), context.scrollHideDelay);
            };
            scrollArea.addEventListener("pointerenter", handlePointerEnter);
            scrollArea.addEventListener("pointerleave", handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener("pointerenter", handlePointerEnter);
                scrollArea.removeEventListener("pointerleave", handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $685a4afdce366793$export$99c2b779aa4e8b8b), {
        present: forceMount || visible,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarAuto, {
            "data-state": visible ? "visible" : "hidden",
            ...scrollbarProps,
            ref: forwardedRef
        })
    });
});
var $1a679747f29e7c90$var$ScrollAreaScrollbarScroll = $exYeM.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const isHorizontal = props.orientation === "horizontal";
    const debounceScrollEnd = $1a679747f29e7c90$var$useDebounceCallback(()=>send("SCROLL_END"), 100);
    const [state, send] = $1a679747f29e7c90$var$useStateMachine("hidden", {
        hidden: {
            SCROLL: "scrolling"
        },
        scrolling: {
            SCROLL_END: "idle",
            POINTER_ENTER: "interacting"
        },
        interacting: {
            SCROLL: "interacting",
            POINTER_LEAVE: "idle"
        },
        idle: {
            HIDE: "hidden",
            SCROLL: "scrolling",
            POINTER_ENTER: "interacting"
        }
    });
    $exYeM.useEffect(()=>{
        if (state === "idle") {
            const hideTimer = window.setTimeout(()=>send("HIDE"), context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer);
        }
    }, [
        state,
        context.scrollHideDelay,
        send
    ]);
    $exYeM.useEffect(()=>{
        const viewport = context.viewport;
        const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    send("SCROLL");
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        context.viewport,
        isHorizontal,
        send,
        debounceScrollEnd
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $685a4afdce366793$export$99c2b779aa4e8b8b), {
        present: forceMount || state !== "hidden",
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarVisible, {
            "data-state": state === "hidden" ? "hidden" : "visible",
            ...scrollbarProps,
            ref: forwardedRef,
            onPointerEnter: (0, $240a4d6bd00066aa$export$b9ecd428b558ff10)(props.onPointerEnter, ()=>send("POINTER_ENTER")),
            onPointerLeave: (0, $240a4d6bd00066aa$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>send("POINTER_LEAVE"))
        })
    });
});
var $1a679747f29e7c90$var$ScrollAreaScrollbarAuto = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const [visible, setVisible] = $exYeM.useState(false);
    const isHorizontal = props.orientation === "horizontal";
    const handleResize = $1a679747f29e7c90$var$useDebounceCallback(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    $1a679747f29e7c90$var$useResizeObserver(context.viewport, handleResize);
    $1a679747f29e7c90$var$useResizeObserver(context.content, handleResize);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $685a4afdce366793$export$99c2b779aa4e8b8b), {
        present: forceMount || visible,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarVisible, {
            "data-state": visible ? "visible" : "hidden",
            ...scrollbarProps,
            ref: forwardedRef
        })
    });
});
var $1a679747f29e7c90$var$ScrollAreaScrollbarVisible = $exYeM.forwardRef((props, forwardedRef)=>{
    const { orientation: orientation = "vertical", ...scrollbarProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const thumbRef = $exYeM.useRef(null);
    const pointerOffsetRef = $exYeM.useRef(0);
    const [sizes, setSizes] = $exYeM.useState({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = $1a679747f29e7c90$var$getThumbRatio(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>thumbRef.current = thumb,
        onThumbPointerUp: ()=>pointerOffsetRef.current = 0,
        onThumbPointerDown: (pointerPos)=>pointerOffsetRef.current = pointerPos
    };
    function getScrollPosition(pointerPos, dir) {
        return $1a679747f29e7c90$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
    }
    if (orientation === "horizontal") return /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarX, {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = $1a679747f29e7c90$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
        }
    });
    if (orientation === "vertical") return /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarY, {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = $1a679747f29e7c90$var$getThumbOffsetFromScroll(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    });
    return null;
});
var $1a679747f29e7c90$var$ScrollAreaScrollbarX = $exYeM.forwardRef((props, forwardedRef)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, ...scrollbarProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = $exYeM.useState();
    const ref = $exYeM.useRef(null);
    const composeRefs = (0, $c1ae2d19d9d64757$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onScrollbarXChange);
    $exYeM.useEffect(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarImpl, {
        "data-orientation": "horizontal",
        ...scrollbarProps,
        ref: composeRefs,
        sizes: sizes,
        style: {
            bottom: 0,
            left: context.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
            right: context.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
            ["--radix-scroll-area-thumb-width"]: $1a679747f29e7c90$var$getThumbSize(sizes) + "px",
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos);
                if ($1a679747f29e7c90$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollWidth,
                viewport: context.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: $1a679747f29e7c90$var$toInt(computedStyle.paddingLeft),
                    paddingEnd: $1a679747f29e7c90$var$toInt(computedStyle.paddingRight)
                }
            });
        }
    });
});
var $1a679747f29e7c90$var$ScrollAreaScrollbarY = $exYeM.forwardRef((props, forwardedRef)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, ...scrollbarProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = $exYeM.useState();
    const ref = $exYeM.useRef(null);
    const composeRefs = (0, $c1ae2d19d9d64757$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onScrollbarYChange);
    $exYeM.useEffect(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaScrollbarImpl, {
        "data-orientation": "vertical",
        ...scrollbarProps,
        ref: composeRefs,
        sizes: sizes,
        style: {
            top: 0,
            right: context.dir === "ltr" ? 0 : void 0,
            left: context.dir === "rtl" ? 0 : void 0,
            bottom: "var(--radix-scroll-area-corner-height)",
            ["--radix-scroll-area-thumb-height"]: $1a679747f29e7c90$var$getThumbSize(sizes) + "px",
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos);
                if ($1a679747f29e7c90$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: $1a679747f29e7c90$var$toInt(computedStyle.paddingTop),
                    paddingEnd: $1a679747f29e7c90$var$toInt(computedStyle.paddingBottom)
                }
            });
        }
    });
});
var [$1a679747f29e7c90$var$ScrollbarProvider, $1a679747f29e7c90$var$useScrollbarContext] = $1a679747f29e7c90$var$createScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME);
var $1a679747f29e7c90$var$ScrollAreaScrollbarImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, sizes: sizes, hasThumb: hasThumb, onThumbChange: onThumbChange, onThumbPointerUp: onThumbPointerUp, onThumbPointerDown: onThumbPointerDown, onThumbPositionChange: onThumbPositionChange, onDragScroll: onDragScroll, onWheelScroll: onWheelScroll, onResize: onResize, ...scrollbarProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$SCROLLBAR_NAME, __scopeScrollArea);
    const [scrollbar, setScrollbar] = $exYeM.useState(null);
    const composeRefs = (0, $c1ae2d19d9d64757$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setScrollbar(node));
    const rectRef = $exYeM.useRef(null);
    const prevWebkitUserSelectRef = $exYeM.useRef("");
    const viewport = context.viewport;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = (0, $f897ecbf7ee2a036$export$25bec8c6f54ee79a)(onWheelScroll);
    const handleThumbPositionChange = (0, $f897ecbf7ee2a036$export$25bec8c6f54ee79a)(onThumbPositionChange);
    const handleResize = $1a679747f29e7c90$var$useDebounceCallback(onResize, 10);
    function handleDragScroll(event) {
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x: x,
                y: y
            });
        }
    }
    $exYeM.useEffect(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar?.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener("wheel", handleWheel, {
                passive: false
            });
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    $exYeM.useEffect(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    $1a679747f29e7c90$var$useResizeObserver(scrollbar, handleResize);
    $1a679747f29e7c90$var$useResizeObserver(context.content, handleResize);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollbarProvider, {
        scope: __scopeScrollArea,
        scrollbar: scrollbar,
        hasThumb: hasThumb,
        onThumbChange: (0, $f897ecbf7ee2a036$export$25bec8c6f54ee79a)(onThumbChange),
        onThumbPointerUp: (0, $f897ecbf7ee2a036$export$25bec8c6f54ee79a)(onThumbPointerUp),
        onThumbPositionChange: handleThumbPositionChange,
        onThumbPointerDown: (0, $f897ecbf7ee2a036$export$25bec8c6f54ee79a)(onThumbPointerDown),
        children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $0de2bdb5fd7b9fb4$export$250ffa63cdc0d034).div, {
            ...scrollbarProps,
            ref: composeRefs,
            style: {
                position: "absolute",
                ...scrollbarProps.style
            },
            onPointerDown: (0, $240a4d6bd00066aa$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
                const mainPointer = 0;
                if (event.button === mainPointer) {
                    const element = event.target;
                    element.setPointerCapture(event.pointerId);
                    rectRef.current = scrollbar.getBoundingClientRect();
                    prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                    document.body.style.webkitUserSelect = "none";
                    if (context.viewport) context.viewport.style.scrollBehavior = "auto";
                    handleDragScroll(event);
                }
            }),
            onPointerMove: (0, $240a4d6bd00066aa$export$b9ecd428b558ff10)(props.onPointerMove, handleDragScroll),
            onPointerUp: (0, $240a4d6bd00066aa$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
                const element = event.target;
                if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
                document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
                if (context.viewport) context.viewport.style.scrollBehavior = "";
                rectRef.current = null;
            })
        })
    });
});
var $1a679747f29e7c90$var$THUMB_NAME = "ScrollAreaThumb";
var $1a679747f29e7c90$export$9fba1154677d7cd2 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...thumbProps } = props;
    const scrollbarContext = $1a679747f29e7c90$var$useScrollbarContext($1a679747f29e7c90$var$THUMB_NAME, props.__scopeScrollArea);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $685a4afdce366793$export$99c2b779aa4e8b8b), {
        present: forceMount || scrollbarContext.hasThumb,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaThumbImpl, {
            ref: forwardedRef,
            ...thumbProps
        })
    });
});
var $1a679747f29e7c90$var$ScrollAreaThumbImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, style: style, ...thumbProps } = props;
    const scrollAreaContext = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = $1a679747f29e7c90$var$useScrollbarContext($1a679747f29e7c90$var$THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange: onThumbPositionChange } = scrollbarContext;
    const composedRef = (0, $c1ae2d19d9d64757$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>scrollbarContext.onThumbChange(node));
    const removeUnlinkedScrollListenerRef = $exYeM.useRef(void 0);
    const debounceScrollEnd = $1a679747f29e7c90$var$useDebounceCallback(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = void 0;
        }
    }, 100);
    $exYeM.useEffect(()=>{
        const viewport = scrollAreaContext.viewport;
        if (viewport) {
            const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = $1a679747f29e7c90$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $0de2bdb5fd7b9fb4$export$250ffa63cdc0d034).div, {
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden",
        ...thumbProps,
        ref: composedRef,
        style: {
            width: "var(--radix-scroll-area-thumb-width)",
            height: "var(--radix-scroll-area-thumb-height)",
            ...style
        },
        onPointerDownCapture: (0, $240a4d6bd00066aa$export$b9ecd428b558ff10)(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: (0, $240a4d6bd00066aa$export$b9ecd428b558ff10)(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    });
});
$1a679747f29e7c90$export$9fba1154677d7cd2.displayName = $1a679747f29e7c90$var$THUMB_NAME;
var $1a679747f29e7c90$var$CORNER_NAME = "ScrollAreaCorner";
var $1a679747f29e7c90$export$56969d565df7cc4b = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$CORNER_NAME, props.__scopeScrollArea);
    const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
    const hasCorner = context.type !== "scroll" && hasBothScrollbarsVisible;
    return hasCorner ? /* @__PURE__ */ (0, $aSiaI.jsx)($1a679747f29e7c90$var$ScrollAreaCornerImpl, {
        ...props,
        ref: forwardedRef
    }) : null;
});
$1a679747f29e7c90$export$56969d565df7cc4b.displayName = $1a679747f29e7c90$var$CORNER_NAME;
var $1a679747f29e7c90$var$ScrollAreaCornerImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, ...cornerProps } = props;
    const context = $1a679747f29e7c90$var$useScrollAreaContext($1a679747f29e7c90$var$CORNER_NAME, __scopeScrollArea);
    const [width, setWidth] = $exYeM.useState(0);
    const [height, setHeight] = $exYeM.useState(0);
    const hasSize = Boolean(width && height);
    $1a679747f29e7c90$var$useResizeObserver(context.scrollbarX, ()=>{
        const height2 = context.scrollbarX?.offsetHeight || 0;
        context.onCornerHeightChange(height2);
        setHeight(height2);
    });
    $1a679747f29e7c90$var$useResizeObserver(context.scrollbarY, ()=>{
        const width2 = context.scrollbarY?.offsetWidth || 0;
        context.onCornerWidthChange(width2);
        setWidth(width2);
    });
    return hasSize ? /* @__PURE__ */ (0, $aSiaI.jsx)((0, $0de2bdb5fd7b9fb4$export$250ffa63cdc0d034).div, {
        ...cornerProps,
        ref: forwardedRef,
        style: {
            width: width,
            height: height,
            position: "absolute",
            right: context.dir === "ltr" ? 0 : void 0,
            left: context.dir === "rtl" ? 0 : void 0,
            bottom: 0,
            ...props.style
        }
    }) : null;
});
function $1a679747f29e7c90$var$toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
function $1a679747f29e7c90$var$getThumbRatio(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return isNaN(ratio) ? 0 : ratio;
}
function $1a679747f29e7c90$var$getThumbSize(sizes) {
    const ratio = $1a679747f29e7c90$var$getThumbRatio(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
    return Math.max(thumbSize, 18);
}
function $1a679747f29e7c90$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = "ltr") {
    const thumbSizePx = $1a679747f29e7c90$var$getThumbSize(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = $1a679747f29e7c90$var$linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}
function $1a679747f29e7c90$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = "ltr") {
    const thumbSizePx = $1a679747f29e7c90$var$getThumbSize(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = (0, $41dd774296a8c200$export$7d15b64cf5a3a4c4)(scrollPos, scrollClampRange);
    const interpolate = $1a679747f29e7c90$var$linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
}
function $1a679747f29e7c90$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $1a679747f29e7c90$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
}
var $1a679747f29e7c90$var$addUnlinkedScrollListener = (node, handler = ()=>{})=>{
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF);
};
function $1a679747f29e7c90$var$useDebounceCallback(callback, delay) {
    const handleCallback = (0, $f897ecbf7ee2a036$export$25bec8c6f54ee79a)(callback);
    const debounceTimerRef = $exYeM.useRef(0);
    $exYeM.useEffect(()=>()=>window.clearTimeout(debounceTimerRef.current), []);
    return $exYeM.useCallback(()=>{
        window.clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}
function $1a679747f29e7c90$var$useResizeObserver(element, onResize) {
    const handleResize = (0, $f897ecbf7ee2a036$export$25bec8c6f54ee79a)(onResize);
    (0, $e043ec26b5b8c7d8$export$e5c5a5f917a5871c)(()=>{
        let rAF = 0;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
var $1a679747f29e7c90$export$be92b6f5f03c0fe9 = $1a679747f29e7c90$export$ccf8d8d7bbf3c2cc;
var $1a679747f29e7c90$export$d5c6c08dc2d3ca7 = $1a679747f29e7c90$export$a21cbf9f11fca853;
var $1a679747f29e7c90$export$9a4e88b92edfce6b = $1a679747f29e7c90$export$2fabd85d0eba3c57;
var $1a679747f29e7c90$export$6521433ed15a34db = $1a679747f29e7c90$export$9fba1154677d7cd2;
var $1a679747f29e7c90$export$ac61190d9fc311a9 = $1a679747f29e7c90$export$56969d565df7cc4b;



const $79eee5cb5c9efd6c$export$ccf8d8d7bbf3c2cc = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
    const { className: className, children: children, ...otherProps } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($1a679747f29e7c90$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("relative overflow-hidden", className),
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($1a679747f29e7c90$export$d5c6c08dc2d3ca7, {
                className: "h-full w-full rounded-[inherit]",
                children: children
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($79eee5cb5c9efd6c$export$342551df3dea21fb, {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)($1a679747f29e7c90$export$ac61190d9fc311a9, {})
        ]
    });
});
$79eee5cb5c9efd6c$export$ccf8d8d7bbf3c2cc.displayName = $1a679747f29e7c90$export$be92b6f5f03c0fe9.displayName;
const $79eee5cb5c9efd6c$export$342551df3dea21fb = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
    const { className: className, orientation: orientation = "vertical", ...otherProps } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsx)($1a679747f29e7c90$export$2fabd85d0eba3c57, {
        ref: ref,
        orientation: orientation,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex touch-none select-none transition-colors", orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]", orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]", className),
        ...otherProps,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($1a679747f29e7c90$export$9fba1154677d7cd2, {
            className: "relative flex-1 rounded-full bg-border"
        })
    });
});
$79eee5cb5c9efd6c$export$342551df3dea21fb.displayName = $1a679747f29e7c90$export$2fabd85d0eba3c57.displayName;


/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8ae9edab39251b25$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("ArrowLeft", [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d57ee045b81b6b10$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Clock", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16 14",
            key: "68esgv"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $befd515fba4f9ccb$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Heart", [
    [
        "path",
        {
            d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
            key: "c3ymky"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $25f5a724572c1301$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("LayoutDashboard", [
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "3",
            y: "3",
            rx: "1",
            key: "10lvy0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "14",
            y: "3",
            rx: "1",
            key: "16une8"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "14",
            y: "12",
            rx: "1",
            key: "1hutg5"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "ldoo1y"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ef383e6886bf5bb$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("LogIn", [
    [
        "path",
        {
            d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
            key: "u53s6r"
        }
    ],
    [
        "polyline",
        {
            points: "10 17 15 12 10 7",
            key: "1ail0h"
        }
    ],
    [
        "line",
        {
            x1: "15",
            x2: "3",
            y1: "12",
            y2: "12",
            key: "v6grx8"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9aeb97d6992a735$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Plus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b1e81a97a7528e4e$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("TrendingUp", [
    [
        "polyline",
        {
            points: "22 7 13.5 15.5 8.5 10.5 2 17",
            key: "126l90"
        }
    ],
    [
        "polyline",
        {
            points: "16 7 22 7 22 13",
            key: "kwv8wd"
        }
    ]
]);



/* eslint-disable no-unused-vars */ 

// utils/auth.js
const $8e62f87e86da6465$export$257b2d10b709d8ef = ()=>{
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    return "";
};
const $8e62f87e86da6465$export$83d11f23a23d4a7c = ()=>{
    const user = localStorage.getItem("user");
    return user !== null;
};
const $8e62f87e86da6465$export$e5432d4c8eb97ea7 = ()=>{
    const user = localStorage.getItem("user");
    if (user) return JSON.parse(user);
    return null;
};
const $8e62f87e86da6465$export$1ec271aac917f1f1 = (dashboard)=>{
    const currentUser = $8e62f87e86da6465$export$e5432d4c8eb97ea7();
    if (!currentUser) return false;
    // User owns the dashboard
    if (dashboard.userID === currentUser.id) return true;
    // Check shared permissions
    const sharedPermission = dashboard.permissions?.sharedWith?.find((userId)=>userId === currentUser.id);
    return sharedPermission && dashboard.permissions.accessLevel === "edit";
};
const $8e62f87e86da6465$export$90a32a441cd4e4e0 = (dashboard)=>{
    const currentUser = $8e62f87e86da6465$export$e5432d4c8eb97ea7();
    // Public dashboards are accessible to all
    if (dashboard.isPublic) return true;
    // If not public, user must be authenticated
    if (!currentUser) return false;
    // User owns the dashboard
    if (dashboard.userID === currentUser.id) return true;
    // User has shared access
    return dashboard.permissions?.sharedWith?.includes(currentUser.id);
};


function $ff0220da39bef700$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    return null;
}
const $ff0220da39bef700$var$createAuthConfig = ()=>{
    const token = $ff0220da39bef700$var$getToken();
    if (!token) return {}; // Return empty config if no token
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};
const $ff0220da39bef700$var$handleAuthError = (error)=>{
    // Check if error is due to authentication
    if (error.response?.status === 401) {
        // Clear any invalid tokens
        localStorage.removeItem("user");
        // Throw a user-friendly error
        throw new Error("Your session has expired. Please log in again.");
    }
    // Handle permission errors
    if (error.response?.status === 403) throw new Error("You don't have permission to perform this action.");
    // Handle other errors
    throw error;
};
function $ff0220da39bef700$export$fa981df62a27e077() {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "dashboards"
        ],
        queryFn: async ()=>{
            try {
                return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/dashboards/user`, $ff0220da39bef700$var$createAuthConfig());
            } catch (error) {
                $ff0220da39bef700$var$handleAuthError(error);
            }
        },
        // Only fetch if user is authenticated
        enabled: (0, $8e62f87e86da6465$export$83d11f23a23d4a7c)()
    });
}
function $ff0220da39bef700$export$bc2f3c415e4383ee(uniqueCode) {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "dashboard",
            uniqueCode
        ],
        queryFn: async ()=>{
            try {
                return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/dashboards/${uniqueCode}`, $ff0220da39bef700$var$createAuthConfig());
            } catch (error) {
                $ff0220da39bef700$var$handleAuthError(error);
            }
        },
        enabled: !!uniqueCode,
        retry: (failureCount, error)=>{
            // Don't retry on 401/403 errors
            if (error.response?.status === 401 || error.response?.status === 403) return false;
            return failureCount < 3;
        }
    });
}
function $ff0220da39bef700$export$94046774b4ff53ed(options = {}) {
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    return (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ uniqueCode: uniqueCode, data: data })=>{
            try {
                if (uniqueCode) return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put(`/dashboards/${uniqueCode}`, data, $ff0220da39bef700$var$createAuthConfig());
                return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/dashboards/create", data, $ff0220da39bef700$var$createAuthConfig());
            } catch (error) {
                $ff0220da39bef700$var$handleAuthError(error);
            }
        },
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "dashboards"
                ]
            });
            if (variables.uniqueCode) queryClient.invalidateQueries({
                queryKey: [
                    "dashboard",
                    variables.uniqueCode
                ]
            });
            if (options.onSuccess) options.onSuccess(data);
        },
        onError: (error, _variables, _context)=>{
            if (options.onError) options.onError(error);
        }
    });
}
function $ff0220da39bef700$export$c589e4b2fa9a0ef9(options = {}) {
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    return (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async (uniqueCode)=>{
            try {
                return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).delete(`/dashboards/${uniqueCode}`, $ff0220da39bef700$var$createAuthConfig());
            } catch (error) {
                $ff0220da39bef700$var$handleAuthError(error);
            }
        },
        onSuccess: (data, _variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "dashboards"
                ]
            });
            if (options.onSuccess) options.onSuccess(data);
        },
        onError: (error)=>{
            if (options.onError) options.onError(error);
        }
    });
}
function $ff0220da39bef700$export$47cb2ccc854c75de() {
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    return (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ uniqueCode: uniqueCode, isPublic: isPublic })=>{
            try {
                return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put(`/dashboards/${uniqueCode}/visibility`, {
                    isPublic: isPublic
                }, $ff0220da39bef700$var$createAuthConfig());
            } catch (error) {
                $ff0220da39bef700$var$handleAuthError(error);
            }
        },
        onSuccess: (_data, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "dashboards"
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "dashboard",
                    variables.uniqueCode
                ]
            });
        }
    });
}
function $ff0220da39bef700$export$df99d7118e12b0cd() {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "liked-dashboards"
        ],
        queryFn: async ()=>{
            try {
                return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/dashboards/liked", $ff0220da39bef700$var$createAuthConfig());
            } catch (error) {
                $ff0220da39bef700$var$handleAuthError(error);
            }
        },
        enabled: (0, $8e62f87e86da6465$export$83d11f23a23d4a7c)()
    });
}
function $ff0220da39bef700$export$10c08b06097c21a9() {
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    return (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ uniqueCode: uniqueCode, isLiking: isLiking })=>{
            try {
                const response = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post(`/dashboards/${uniqueCode}/${isLiking ? "like" : "unlike"}`, {}, $ff0220da39bef700$var$createAuthConfig());
                return response;
            } catch (error) {
                $ff0220da39bef700$var$handleAuthError(error);
            }
        },
        onMutate: async ({ uniqueCode: uniqueCode, isLiking: isLiking })=>{
            // Cancel any outgoing refetches
            await queryClient.cancelQueries({
                queryKey: [
                    "dashboard",
                    uniqueCode
                ]
            });
            // Snapshot the previous value
            const previousDashboard = queryClient.getQueryData([
                "dashboard",
                uniqueCode
            ]);
            // Optimistically update the dashboard
            queryClient.setQueryData([
                "dashboard",
                uniqueCode
            ], (old)=>({
                    ...old,
                    data: {
                        ...old.data,
                        likes: old.data.likes + (isLiking ? 1 : -1),
                        likedBy: isLiking ? [
                            ...old.data.likedBy || [],
                            JSON.parse(localStorage.getItem("user")).id
                        ] : old.data.likedBy.filter((id)=>id !== JSON.parse(localStorage.getItem("user")).id)
                    }
                }));
            return {
                previousDashboard: previousDashboard
            };
        },
        onError: (_error, _variables, context)=>{
            // Revert to the previous value on error
            if (context?.previousDashboard) queryClient.setQueryData([
                "dashboard",
                context.previousDashboard.data.uniqueCode
            ], context.previousDashboard);
        },
        onSettled: (data, _error, variables)=>{
            // Always refetch to ensure server-client consistency
            queryClient.invalidateQueries({
                queryKey: [
                    "dashboard",
                    variables.uniqueCode
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "liked-dashboards"
                ]
            });
        }
    });
}
function $ff0220da39bef700$export$2d273df6c4804eb7() {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "popular-dashboards"
        ],
        queryFn: async ()=>{
            try {
                return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/dashboards/popular");
            } catch (error) {
                $ff0220da39bef700$var$handleAuthError(error);
            }
        }
    });
}





var $82065c9c3647bf9b$export$1be1fc439b849fdf;
var $82065c9c3647bf9b$export$95a3b7b12ab518f9;
var $82065c9c3647bf9b$export$6922d3b3a607469e;
var $82065c9c3647bf9b$export$9a6132153fba2e0;
var $82065c9c3647bf9b$export$4feba8a1bc8e9afd;
var $82065c9c3647bf9b$export$5c593627aef9f076;
"use strict";
function $82065c9c3647bf9b$var$_extends() {
    $82065c9c3647bf9b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $82065c9c3647bf9b$var$_extends.apply(this, arguments);
}
function $82065c9c3647bf9b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $82065c9c3647bf9b$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $82065c9c3647bf9b$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $82065c9c3647bf9b$var$redux = $82065c9c3647bf9b$var$reduxImpl;
var $82065c9c3647bf9b$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $82065c9c3647bf9b$var$_excluded2 = [
    "connection"
];
var $82065c9c3647bf9b$var$trackedConnections = new Map();
var $82065c9c3647bf9b$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $82065c9c3647bf9b$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $82065c9c3647bf9b$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $82065c9c3647bf9b$var$trackedConnections.get(options.name);
    if (existingConnection) return $82065c9c3647bf9b$var$_extends({
        type: "tracked",
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $82065c9c3647bf9b$var$trackedConnections.set(options.name, newConnection);
    return $82065c9c3647bf9b$var$_extends({
        type: "tracked",
        store: store
    }, newConnection);
};
var $82065c9c3647bf9b$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $82065c9c3647bf9b$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $82065c9c3647bf9b$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $82065c9c3647bf9b$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $82065c9c3647bf9b$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $82065c9c3647bf9b$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($82065c9c3647bf9b$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $82065c9c3647bf9b$var$_extends({}, $82065c9c3647bf9b$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $82065c9c3647bf9b$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === "__setState") {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error('\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using \'store\' option in devtools(), the \'state\' should have only one key, which is a value of \'store\' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }\n                    ');
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($82065c9c3647bf9b$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($82065c9c3647bf9b$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $82065c9c3647bf9b$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($82065c9c3647bf9b$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $82065c9c3647bf9b$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $82065c9c3647bf9b$var$devtools = $82065c9c3647bf9b$var$devtoolsImpl;
var $82065c9c3647bf9b$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== undefined) f(parsed);
};
var $82065c9c3647bf9b$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $82065c9c3647bf9b$var$subscribeWithSelector = $82065c9c3647bf9b$var$subscribeWithSelectorImpl;
var $82065c9c3647bf9b$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $82065c9c3647bf9b$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $82065c9c3647bf9b$var$toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $82065c9c3647bf9b$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $82065c9c3647bf9b$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $82065c9c3647bf9b$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $82065c9c3647bf9b$var$toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($82065c9c3647bf9b$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $82065c9c3647bf9b$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $82065c9c3647bf9b$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $82065c9c3647bf9b$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $82065c9c3647bf9b$var$_extends({
            storage: $82065c9c3647bf9b$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $82065c9c3647bf9b$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($82065c9c3647bf9b$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $82065c9c3647bf9b$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get4;
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $82065c9c3647bf9b$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $82065c9c3647bf9b$var$persistImpl = function persistImpl(config, baseOptions) {
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) return $82065c9c3647bf9b$var$oldImpl(config, baseOptions);
    return $82065c9c3647bf9b$var$newImpl(config, baseOptions);
};
var $82065c9c3647bf9b$var$persist = $82065c9c3647bf9b$var$persistImpl;
$82065c9c3647bf9b$export$1be1fc439b849fdf = $82065c9c3647bf9b$var$combine;
$82065c9c3647bf9b$export$95a3b7b12ab518f9 = $82065c9c3647bf9b$var$createJSONStorage;
$82065c9c3647bf9b$export$6922d3b3a607469e = $82065c9c3647bf9b$var$devtools;
$82065c9c3647bf9b$export$9a6132153fba2e0 = $82065c9c3647bf9b$var$persist;
$82065c9c3647bf9b$export$4feba8a1bc8e9afd = $82065c9c3647bf9b$var$redux;
$82065c9c3647bf9b$export$5c593627aef9f076 = $82065c9c3647bf9b$var$subscribeWithSelector;


const $be40906ea0dfff4f$var$MAX_RECENT_DASHBOARDS = 3;
const $be40906ea0dfff4f$export$b1669adc3c17a6f0 = (0, $405a4fa4811a9356$exports.create)((0, $82065c9c3647bf9b$export$9a6132153fba2e0)((set)=>({
        recentDashboards: [],
        addRecentDashboard: (dashboard)=>set((state)=>{
                // Remove the dashboard if it already exists
                const filtered = state.recentDashboards.filter((d)=>d.uniqueCode !== dashboard.uniqueCode);
                // Add the dashboard to the start and limit to MAX_RECENT
                return {
                    recentDashboards: [
                        dashboard,
                        ...filtered
                    ].slice(0, $be40906ea0dfff4f$var$MAX_RECENT_DASHBOARDS)
                };
            }),
        clearRecentDashboards: ()=>set({
                recentDashboards: []
            })
    }), {
    name: "recent-dashboards-storage"
}));


const $3bddef9e2b3aace7$var$DashboardSection = ({ title: title, icon: Icon, dashboards: dashboards, isCollapsed: isCollapsed, searchTerm: searchTerm, onSelect: onSelect })=>{
    if (!dashboards?.length) return null;
    const filteredDashboards = dashboards.filter((dashboard)=>dashboard.dashboardName.toLowerCase().includes(searchTerm.toLowerCase()));
    if (!filteredDashboards.length) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "space-y-2 mb-4",
        children: [
            !isCollapsed && /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                className: "font-medium text-gray-900 px-2 text-sm",
                children: title
            }),
            filteredDashboards.map((dashboard)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    onClick: ()=>onSelect(dashboard),
                    className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex place-items-center bg-white rounded-lg font-medium border border-primaryContainer hover:bg-primary hover:text-white group transition-colors", isCollapsed ? "w-10 h-10 mx-auto justify-center" : "w-full p-2"),
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex items-center", !isCollapsed && "w-full"),
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)(Icon, {
                                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-5 w-5 text-onSurfaceVariant group-hover:text-white", !isCollapsed && "mr-2")
                            }),
                            !isCollapsed && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "text-base truncate",
                                children: dashboard.dashboardName
                            })
                        ]
                    })
                }, dashboard.uniqueCode))
        ]
    });
};
const $3bddef9e2b3aace7$var$DashboardSidebar = ({ sidebar: sidebar, setSidebar: setSidebar, onDashboardSelect: onDashboardSelect, isTransitioning: isTransitioning })=>{
    const [searchTerm, setSearchTerm] = (0, $exYeM.useState)("");
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const isLoggedIn = (0, $8e62f87e86da6465$export$83d11f23a23d4a7c)();
    const { data: userDashboards } = (0, $ff0220da39bef700$export$fa981df62a27e077)();
    const { data: popularDashboards } = (0, $ff0220da39bef700$export$2d273df6c4804eb7)();
    const { data: likedDashboards } = (0, $ff0220da39bef700$export$df99d7118e12b0cd)();
    const recentDashboards = (0, $be40906ea0dfff4f$export$b1669adc3c17a6f0)((state)=>state.recentDashboards);
    const handleDashboardSelect = (dashboard)=>{
        onDashboardSelect(dashboard);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-[95vh] pb-4 transition-all font-roboto bg-surface transform border-r border-primaryContainer", sidebar ? "w-[248px] px-1" : "w-16"),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-row px-2 mx-auto py-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        onClick: ()=>setSidebar(!sidebar),
                        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("bg-surfaceVariant rounded-lg flex items-center justify-center border group border-primaryContainer hover:bg-primary hover:text-white transition-colors", sidebar ? "mr-2 w-10 h-10" : "w-10 h-10 mx-auto"),
                        disabled: isTransitioning,
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8ae9edab39251b25$export$2e2bcd8739ae039), {
                            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-5 w-5 group-hover:text-white text-onSurfaceVariant", !sidebar && "rotate-180", "transition duration-75")
                        })
                    }),
                    sidebar && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative w-full",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0bdc6a2cae10298$export$f5b8910cec6cf069), {
                            type: "text",
                            placeholder: "Search dashboards",
                            value: searchTerm,
                            onChange: (e)=>setSearchTerm(e.target.value),
                            className: "w-full px-4 h-12 rounded-xl border border-primaryContainer focus:border-primary focus:outline-none",
                            disabled: isTransitioning
                        })
                    })
                ]
            }),
            isLoggedIn && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "px-2 pt-2 pb-1",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    onClick: ()=>onDashboardSelect(null),
                    className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex place-items-center bg-surfaceVariant border border-primaryContainer hover:bg-primary hover:text-white group transition-colors rounded-lg font-medium", sidebar ? "w-full p-2 justify-between" : "w-10 h-10 mx-auto justify-center"),
                    disabled: isTransitioning,
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex items-center", sidebar && "w-full"),
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c9aeb97d6992a735$export$2e2bcd8739ae039), {
                                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-5 w-5 text-onSurfaceVariant group-hover:text-white", sidebar && "mr-2")
                            }),
                            sidebar && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "text-base",
                                children: "New Dashboard"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $79eee5cb5c9efd6c$export$ccf8d8d7bbf3c2cc), {
                className: "h-[calc(100%-6rem)] mt-1",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "mx-auto w-full p-2 space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)($3bddef9e2b3aace7$var$DashboardSection, {
                            title: "Recently Viewed",
                            icon: (0, $d57ee045b81b6b10$export$2e2bcd8739ae039),
                            dashboards: recentDashboards,
                            isCollapsed: !sidebar,
                            searchTerm: searchTerm,
                            onSelect: handleDashboardSelect
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)($3bddef9e2b3aace7$var$DashboardSection, {
                            title: "Popular",
                            icon: (0, $b1e81a97a7528e4e$export$2e2bcd8739ae039),
                            dashboards: popularDashboards?.data,
                            isCollapsed: !sidebar,
                            searchTerm: searchTerm,
                            onSelect: handleDashboardSelect
                        }),
                        !isLoggedIn && sidebar && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "p-4 bg-surfaceVariant rounded-lg border border-primaryContainer space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                    className: "font-medium text-lg text-gray-900",
                                    children: "See More"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                    className: "text-sm text-gray-600",
                                    children: "Log in to access your personal dashboards and likes."
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                            onClick: ()=>navigate("/signin"),
                                            className: "w-full gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9ef383e6886bf5bb$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4"
                                                }),
                                                "Login"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                            variant: "outline",
                                            onClick: ()=>navigate("/signup"),
                                            className: "w-full",
                                            children: "Create Account"
                                        })
                                    ]
                                })
                            ]
                        }),
                        isLoggedIn && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)($3bddef9e2b3aace7$var$DashboardSection, {
                                    title: "Liked",
                                    icon: (0, $befd515fba4f9ccb$export$2e2bcd8739ae039),
                                    dashboards: likedDashboards?.data,
                                    isCollapsed: !sidebar,
                                    searchTerm: searchTerm,
                                    onSelect: handleDashboardSelect
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)($3bddef9e2b3aace7$var$DashboardSection, {
                                    title: "My Dashboards",
                                    icon: (0, $25f5a724572c1301$export$2e2bcd8739ae039),
                                    dashboards: userDashboards?.data,
                                    isCollapsed: !sidebar,
                                    searchTerm: searchTerm,
                                    onSelect: handleDashboardSelect
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $3bddef9e2b3aace7$export$2e2bcd8739ae039 = $3bddef9e2b3aace7$var$DashboardSidebar;



const $343f8b8806fa99ed$var$createNewWidget = (w, h, len)=>({
        i: `widget${len + 1}`,
        x: 0,
        y: Infinity,
        w: w,
        h: h,
        minW: w,
        minH: h
    });
const $343f8b8806fa99ed$var$createNewItem = (type, len, props)=>({
        i: `widget${len + 1}`,
        type: type,
        title: "",
        props: type === "Chart" ? props : {
            ...props,
            lastModified: new Date().toISOString()
        }
    });
const $343f8b8806fa99ed$export$e6e525ae42e818e8 = (0, $405a4fa4811a9356$exports.create)((set)=>({
        // State
        items: [],
        layouts: [],
        dashboardName: "My Dashboard",
        // Actions
        setDashboardName: (name)=>set({
                dashboardName: name
            }),
        addItem: (type, w, h, props = null)=>set((state)=>({
                    items: [
                        ...state.items,
                        $343f8b8806fa99ed$var$createNewItem(type, state.items.length, props)
                    ],
                    layouts: [
                        ...state.layouts,
                        $343f8b8806fa99ed$var$createNewWidget(w, h, state.layouts.length, type)
                    ]
                })),
        removeItem: (id)=>set((state)=>({
                    items: state.items.filter((item)=>item.i !== id),
                    layouts: state.layouts.filter((layout)=>layout.i !== id)
                })),
        updateLayout: (layout)=>set({
                layouts: layout
            }),
        removeAll: ()=>set({
                items: [],
                layouts: [],
                dashboardName: "My Dashboard"
            }),
        setDashboardState: (items, layouts, name)=>set({
                items: items,
                layouts: layouts,
                dashboardName: name
            }),
        updateItem: (id, props)=>set((state)=>{
                const newItems = state.items.map((item)=>{
                    if (item.i === id) {
                        const updatedItem = {
                            ...item,
                            props: item.type === "Chart" ? props : {
                                ...item.props,
                                ...props,
                                lastModified: new Date().toISOString()
                            }
                        };
                        return updatedItem;
                    }
                    return item;
                });
                return {
                    items: newItems
                };
            }),
        updateWidgetTitle: (id, title)=>set((state)=>({
                    items: state.items.map((item)=>item.i === id ? {
                            ...item,
                            title: title
                        } : item)
                }))
    }));



/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $11645006cc3cfacf$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("LoaderCircle", [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
]);




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");







var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $0d95d7873b2aecf3$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $exYeM.useState)(null);
    const onMountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $exYeM.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $exYeM.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (container1) {
            $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusFirst($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$removeLinks($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $exYeM.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($0d95d7873b2aecf3$export$20e40289641fbbb6, {
    displayName: $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $0d95d7873b2aecf3$export$be92b6f5f03c0fe9 = $0d95d7873b2aecf3$export$20e40289641fbbb6;






var $exYeM = parcelRequire("exYeM");
/** Number of components which have requested interest to have focus guards */ let $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count = 0;
function $c12fde423b091e9b$export$ac5b58043b79449b(props) {
    $c12fde423b091e9b$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $c12fde423b091e9b$export$b7ece24a22aeda8c() {
    (0, $exYeM.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $c12fde423b091e9b$export$be92b6f5f03c0fe9 = $c12fde423b091e9b$export$ac5b58043b79449b;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};



var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
var $a424de23c132f073$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $a424de23c132f073$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $a424de23c132f073$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $a424de23c132f073$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $exYeM = parcelRequire("exYeM");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $584d39a8643d937a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $exYeM = parcelRequire("exYeM");
function $d00d56265ba92762$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $exYeM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $d221d2c5d570aa1d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $exYeM.useLayoutEffect : $exYeM.useEffect;
var $d221d2c5d570aa1d$var$currentValues = new WeakMap();
function $d221d2c5d570aa1d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $d00d56265ba92762$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $d221d2c5d570aa1d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $d221d2c5d570aa1d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $d221d2c5d570aa1d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $f527f4cfb322b92a$var$ItoI(a) {
    return a;
}
function $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $f527f4cfb322b92a$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    return $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware);
}
function $f527f4cfb322b92a$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $f527f4cfb322b92a$var$innerCreateMedium(null);
    medium.options = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4fc5d5f926eb9841$export$e27363444bedfeac = (0, $f527f4cfb322b92a$export$e13ec7dd7a14088d)();


var $6c2939159ce57a12$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $6c2939159ce57a12$export$22940b497e769dee = $exYeM.forwardRef(function(props, parentRef) {
    var ref = $exYeM.useRef(null);
    var _a = $exYeM.useState({
        onScrollCapture: $6c2939159ce57a12$var$nothing,
        onWheelCapture: $6c2939159ce57a12$var$nothing,
        onTouchMoveCapture: $6c2939159ce57a12$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d221d2c5d570aa1d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest), callbacks);
    return $exYeM.createElement($exYeM.Fragment, null, enabled && $exYeM.createElement(SideCar, {
        sideCar: (0, $4fc5d5f926eb9841$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $exYeM.cloneElement($exYeM.Children.only(children), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $exYeM.createElement(Container, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$6c2939159ce57a12$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$6c2939159ce57a12$export$22940b497e769dee.classNames = {
    fullWidth: (0, $a424de23c132f073$export$898e37bbd2a0ae4e),
    zeroRight: (0, $a424de23c132f073$export$1da7500147d4bc3)
};




var $exYeM = parcelRequire("exYeM");
var $20ca6eb20b4dc049$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $exYeM.createElement(Target, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest));
};
$20ca6eb20b4dc049$var$SideCar.isSideCarExport = true;
function $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $20ca6eb20b4dc049$var$SideCar;
}




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $c01c422d43bc8e57$var$currentNonce;
var $c01c422d43bc8e57$export$c5f670b24c0ae95a = function(nonce) {
    $c01c422d43bc8e57$var$currentNonce = nonce;
};
var $c01c422d43bc8e57$export$2b85b721e524d74b = function() {
    if ($c01c422d43bc8e57$var$currentNonce) return $c01c422d43bc8e57$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $00191a54979f785d$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c01c422d43bc8e57$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $00191a54979f785d$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $00191a54979f785d$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $00191a54979f785d$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $00191a54979f785d$var$makeStyleTag()) {
                    $00191a54979f785d$var$injectStyles(stylesheet, style);
                    $00191a54979f785d$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $071c3d40780405a9$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $00191a54979f785d$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $exYeM.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $3d3e09c66c873f3e$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $071c3d40780405a9$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $8c733fa2685d08ec$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $8c733fa2685d08ec$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $8c733fa2685d08ec$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $8c733fa2685d08ec$var$parse(left),
        $8c733fa2685d08ec$var$parse(top),
        $8c733fa2685d08ec$var$parse(right)
    ];
};
var $8c733fa2685d08ec$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $8c733fa2685d08ec$export$efed13b5d0ca3386;
    var offsets = $8c733fa2685d08ec$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $b8129a946e86d087$var$Style = (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
var $b8129a946e86d087$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $b8129a946e86d087$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $a424de23c132f073$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($b8129a946e86d087$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($b8129a946e86d087$export$65254d5f26cb9564, "] {\n    ").concat((0, $a424de23c132f073$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $b8129a946e86d087$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($b8129a946e86d087$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $b8129a946e86d087$export$a1939b1f9f9b02dc = function() {
    $exYeM.useEffect(function() {
        document.body.setAttribute($b8129a946e86d087$export$65254d5f26cb9564, ($b8129a946e86d087$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $b8129a946e86d087$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($b8129a946e86d087$export$65254d5f26cb9564);
            else document.body.setAttribute($b8129a946e86d087$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $b8129a946e86d087$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $b8129a946e86d087$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $exYeM.useMemo(function() {
        return (0, $8c733fa2685d08ec$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $exYeM.createElement($b8129a946e86d087$var$Style, {
        styles: $b8129a946e86d087$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $00c689171e355a98$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $00c689171e355a98$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $00c689171e355a98$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
    // @ts-ignore
    window.removeEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
} catch (err) {
    $00c689171e355a98$var$passiveSupported = false;
}
var $00c689171e355a98$export$10a6e88623fa9454 = $00c689171e355a98$var$passiveSupported ? {
    passive: false
} : false;


var $895262f629112328$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $895262f629112328$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$895262f629112328$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $895262f629112328$var$elementCouldBeVScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowY");
};
var $895262f629112328$var$elementCouldBeHScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowX");
};
var $895262f629112328$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $895262f629112328$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $895262f629112328$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $895262f629112328$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $895262f629112328$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $895262f629112328$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$elementCouldBeVScrolled(node) : $895262f629112328$var$elementCouldBeHScrolled(node);
};
var $895262f629112328$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$getVScrollVariables(node) : $895262f629112328$var$getHScrollVariables(node);
};
var $895262f629112328$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $895262f629112328$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $895262f629112328$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $895262f629112328$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($895262f629112328$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $e11a1edcdcbdc39d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $e11a1edcdcbdc39d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $e11a1edcdcbdc39d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $e11a1edcdcbdc39d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $e11a1edcdcbdc39d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $e11a1edcdcbdc39d$var$idCounter = 0;
var $e11a1edcdcbdc39d$var$lockStack = [];
function $e11a1edcdcbdc39d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $exYeM.useRef([]);
    var touchStartRef = $exYeM.useRef([
        0,
        0
    ]);
    var activeAxis = $exYeM.useRef();
    var id = $exYeM.useState($e11a1edcdcbdc39d$var$idCounter++)[0];
    var Style = $exYeM.useState(function() {
        return (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $exYeM.useRef(props);
    $exYeM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $exYeM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($e11a1edcdcbdc39d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $exYeM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $895262f629112328$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $exYeM.useCallback(function(_event) {
        var event = _event;
        if (!$e11a1edcdcbdc39d$var$lockStack.length || $e11a1edcdcbdc39d$var$lockStack[$e11a1edcdcbdc39d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event) : $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $e11a1edcdcbdc39d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($e11a1edcdcbdc39d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $exYeM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $exYeM.useCallback(function(event) {
        touchStartRef.current = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $exYeM.useEffect(function() {
        $e11a1edcdcbdc39d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        return function() {
            $e11a1edcdcbdc39d$var$lockStack = $e11a1edcdcbdc39d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $exYeM.createElement($exYeM.Fragment, null, inert ? $exYeM.createElement(Style, {
        styles: $e11a1edcdcbdc39d$var$generateStyle(id)
    }) : null, removeScrollBar ? $exYeM.createElement((0, $b8129a946e86d087$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $5f000f9080e28e0a$export$2e2bcd8739ae039 = (0, $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce)((0, $4fc5d5f926eb9841$export$e27363444bedfeac), (0, $e11a1edcdcbdc39d$export$a09dbff87b5da2d));


var $471317fac98e876e$var$ReactRemoveScroll = $exYeM.forwardRef(function(props, ref) {
    return $exYeM.createElement((0, $6c2939159ce57a12$export$22940b497e769dee), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $5f000f9080e28e0a$export$2e2bcd8739ae039)
    }));
});
$471317fac98e876e$var$ReactRemoveScroll.classNames = (0, $6c2939159ce57a12$export$22940b497e769dee).classNames;
var $471317fac98e876e$export$2e2bcd8739ae039 = $471317fac98e876e$var$ReactRemoveScroll;


var $ed7fbe99f365bc63$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $ed7fbe99f365bc63$var$counterMap = new WeakMap();
var $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
var $ed7fbe99f365bc63$var$markerMap = {};
var $ed7fbe99f365bc63$var$lockCount = 0;
var $ed7fbe99f365bc63$var$unwrapHost = function(node) {
    return node && (node.host || $ed7fbe99f365bc63$var$unwrapHost(node.parentNode));
};
var $ed7fbe99f365bc63$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $ed7fbe99f365bc63$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $ed7fbe99f365bc63$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $ed7fbe99f365bc63$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$ed7fbe99f365bc63$var$markerMap[markerName]) $ed7fbe99f365bc63$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $ed7fbe99f365bc63$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($ed7fbe99f365bc63$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $ed7fbe99f365bc63$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $ed7fbe99f365bc63$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $ed7fbe99f365bc63$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$ed7fbe99f365bc63$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $ed7fbe99f365bc63$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $ed7fbe99f365bc63$var$lockCount--;
        if (!$ed7fbe99f365bc63$var$lockCount) {
            // clear
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
            $ed7fbe99f365bc63$var$markerMap = {};
        }
    };
};
var $ed7fbe99f365bc63$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $ed7fbe99f365bc63$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $ed7fbe99f365bc63$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $ed7fbe99f365bc63$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($ed7fbe99f365bc63$export$cc95fea82d705fca() ? $ed7fbe99f365bc63$export$59151cc8db999a24 : $ed7fbe99f365bc63$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$createDialogContext, $d624d4ffa9e1ab8a$export$cc702773b8ea3e41] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogProvider, $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$createDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $d624d4ffa9e1ab8a$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = (0, $exYeM.useRef)(null);
    const contentRef = (0, $exYeM.useRef)(null);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        titleId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        descriptionId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $exYeM.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$3ddf2d174ce01153, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $d624d4ffa9e1ab8a$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$2e1e1122cf0cba88, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PortalProvider, $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$createDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $d624d4ffa9e1ab8a$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $exYeM.Children).map(children, (child)=>/*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$dad7c95542bacce0, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $d624d4ffa9e1ab8a$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$usePortalContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $aJx1R.default)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$bd1d06c79be19e17, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $exYeM.createElement)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "data-state": $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $d624d4ffa9e1ab8a$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$usePortalContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $aJx1R.default)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $aJx1R.default)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$b6d9565de1e068cf, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $exYeM.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $aJx1R.default)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $exYeM.useRef)(false);
    const hasPointerDownOutsideRef = (0, $exYeM.useRef)(false);
    return /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $aJx1R.default)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), (0, $aJx1R.default)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $d624d4ffa9e1ab8a$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).h2, (0, $aJx1R.default)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$16f7638e4a34b909, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $d624d4ffa9e1ab8a$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).p, (0, $aJx1R.default)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$94e94c2ec2c954d5, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$d624d4ffa9e1ab8a$export$69b62a49393917d6, $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $e1a745ecb8941240$export$fd42f52fd3ae1109)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useWarningContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $exYeM.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useWarningContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $exYeM.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9 = $d624d4ffa9e1ab8a$export$3ddf2d174ce01153;
const $d624d4ffa9e1ab8a$export$41fb9f06171c75f4 = $d624d4ffa9e1ab8a$export$2e1e1122cf0cba88;
const $d624d4ffa9e1ab8a$export$602eac185826482c = $d624d4ffa9e1ab8a$export$dad7c95542bacce0;
const $d624d4ffa9e1ab8a$export$c6fdb837b070b4ff = $d624d4ffa9e1ab8a$export$bd1d06c79be19e17;
const $d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2 = $d624d4ffa9e1ab8a$export$b6d9565de1e068cf;
const $d624d4ffa9e1ab8a$export$f99233281efd08a0 = $d624d4ffa9e1ab8a$export$16f7638e4a34b909;
const $d624d4ffa9e1ab8a$export$393edc798c47379d = $d624d4ffa9e1ab8a$export$94e94c2ec2c954d5;
const $d624d4ffa9e1ab8a$export$f39c2d165cd861fe = $d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac;




const $27561b24f6cc51c4$export$3ddf2d174ce01153 = $d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9;
const $27561b24f6cc51c4$export$2e1e1122cf0cba88 = $d624d4ffa9e1ab8a$export$41fb9f06171c75f4;
const $27561b24f6cc51c4$export$dad7c95542bacce0 = $d624d4ffa9e1ab8a$export$602eac185826482c;
const $27561b24f6cc51c4$export$fba2fb7cd781b7ac = $d624d4ffa9e1ab8a$export$f39c2d165cd861fe;
const $27561b24f6cc51c4$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($d624d4ffa9e1ab8a$export$c6fdb837b070b4ff, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props
    }));
$27561b24f6cc51c4$export$bd1d06c79be19e17.displayName = "DialogOverlay";
const $27561b24f6cc51c4$export$b6d9565de1e068cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)($27561b24f6cc51c4$export$dad7c95542bacce0, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($27561b24f6cc51c4$export$bd1d06c79be19e17, {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)($d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-4xl translate-x-[-50%] translate-y-[-50%] gap-4 border bg-surface p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg", className),
                ...props,
                children: [
                    children,
                    /*#__PURE__*/ (0, $aSiaI.jsxs)($d624d4ffa9e1ab8a$export$f39c2d165cd861fe, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c12e32cf04d921d4$export$b7fa469a3cb3cd4f), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
$27561b24f6cc51c4$export$b6d9565de1e068cf.displayName = "DialogContent";
const $27561b24f6cc51c4$export$742513523b177e3b = ({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex flex-col space-y-1.5 text-center sm:text-left", className),
        ...props
    });
$27561b24f6cc51c4$export$742513523b177e3b.displayName = "DialogHeader";
const $27561b24f6cc51c4$export$7bbfb2d443473050 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
$27561b24f6cc51c4$export$7bbfb2d443473050.displayName = "DialogFooter";
const $27561b24f6cc51c4$export$16f7638e4a34b909 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($d624d4ffa9e1ab8a$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("text-lg font-semibold leading-none tracking-tight", className),
        ...props
    }));
$27561b24f6cc51c4$export$16f7638e4a34b909.displayName = "DialogTitle";
const $27561b24f6cc51c4$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($d624d4ffa9e1ab8a$export$393edc798c47379d, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("text-sm text-muted-foreground", className),
        ...props
    }));
$27561b24f6cc51c4$export$94e94c2ec2c954d5.displayName = "DialogDescription";







function $28cef0ab7942cbab$export$2e2bcd8739ae039({ open: open, setOpen: setOpen }) {
    const [dashboardName, setDashboardName] = (0, $exYeM.useState)("");
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const { mutate: createDashboard, isLoading: isLoading } = (0, $ff0220da39bef700$export$94046774b4ff53ed)({
        onSuccess: (response)=>{
            toast({
                variant: "successV2",
                title: "Dashboard created successfully"
            });
            setOpen(false);
            // Navigate to the new dashboard using the uniqueCode
            navigate(`/dashboard/${response.data.uniqueCode}`);
        },
        onError: (error)=>{
            toast({
                variant: "destructive",
                title: "Failed to create dashboard",
                description: error.message || "Please try again"
            });
        }
    });
    const handleCreate = ()=>{
        if (!dashboardName.trim()) {
            toast({
                variant: "destructive",
                title: "Dashboard name required",
                description: "Please enter a name for your dashboard"
            });
            return;
        }
        createDashboard({
            data: {
                userID: "64044ac74381a8db4fb414d6",
                dashboardName: dashboardName.trim()
            }
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: setOpen,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $27561b24f6cc51c4$export$b6d9565de1e068cf), {
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $27561b24f6cc51c4$export$742513523b177e3b), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$16f7638e4a34b909), {
                            children: "Create New Dashboard"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$94e94c2ec2c954d5), {
                            children: "Give your dashboard a name to get started."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "py-4",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0bdc6a2cae10298$export$f5b8910cec6cf069), {
                        placeholder: "Dashboard name",
                        value: dashboardName,
                        onChange: (e)=>setDashboardName(e.target.value),
                        disabled: isLoading
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $27561b24f6cc51c4$export$7bbfb2d443473050), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                            variant: "outline",
                            onClick: ()=>setOpen(false),
                            disabled: isLoading,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                            onClick: handleCreate,
                            disabled: isLoading,
                            children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11645006cc3cfacf$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 animate-spin mr-2"
                                    }),
                                    "Creating..."
                                ]
                            }) : "Create Dashboard"
                        })
                    ]
                })
            ]
        })
    });
}



function $3832baf57ec23419$var$Index() {
    const [sidebar, setSidebar] = (0, $exYeM.useState)(true);
    const [isTransitioning, setIsTransitioning] = (0, $exYeM.useState)(false);
    const [createDialogOpen, setCreateDialogOpen] = (0, $exYeM.useState)(false);
    const removeAll = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.removeAll);
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { uniqueCode: uniqueCode } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    const isLoggedIn = (0, $8e62f87e86da6465$export$83d11f23a23d4a7c)();
    const addRecentDashboard = (0, $be40906ea0dfff4f$export$b1669adc3c17a6f0)((state)=>state.addRecentDashboard);
    const handleDashboardSelect = async (dashboard)=>{
        try {
            setIsTransitioning(true);
            // Clear existing state
            removeAll();
            if (dashboard === null) {
                if (!isLoggedIn) {
                    toast({
                        variant: "destructive",
                        title: "Authentication Required",
                        description: "Please log in to create a new dashboard"
                    });
                    navigate("/signin");
                    return;
                }
                // Open create dialog
                setCreateDialogOpen(true);
            } else {
                // Add to recently viewed before navigation
                addRecentDashboard(dashboard);
                // Navigate to the specific dashboard using its uniqueCode
                navigate(`/dashboard/${dashboard.uniqueCode}`);
            }
        } catch (error) {
            toast({
                variant: "destructive",
                title: "Error switching dashboard",
                description: error.message || "Failed to switch dashboard"
            });
        } finally{
            setTimeout(()=>{
                setIsTransitioning(false);
            }, 150);
        }
    };
    // If we're at the root dashboard path, render the DashboardList
    if (!uniqueCode) return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$910ae8079b2c2852), {
                context: {
                    onDashboardSelect: handleDashboardSelect
                }
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $28cef0ab7942cbab$export$2e2bcd8739ae039), {
                open: createDialogOpen,
                setOpen: setCreateDialogOpen
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full h-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-row relative z-0",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "hidden md:block",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3bddef9e2b3aace7$export$2e2bcd8739ae039), {
                            sidebar: sidebar,
                            setSidebar: setSidebar,
                            onDashboardSelect: handleDashboardSelect,
                            currentDashboardId: uniqueCode,
                            isTransitioning: isTransitioning
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex-1 transition-opacity duration-300 ease-in-out",
                        children: isTransitioning ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "flex items-center justify-center h-full",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex flex-col items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11645006cc3cfacf$export$2e2bcd8739ae039), {
                                        className: "h-8 w-8 animate-spin text-primary"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-muted-foreground",
                                        children: "Loading dashboard..."
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$910ae8079b2c2852), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $28cef0ab7942cbab$export$2e2bcd8739ae039), {
                open: createDialogOpen,
                setOpen: setCreateDialogOpen
            })
        ]
    });
}
var $3832baf57ec23419$export$2e2bcd8739ae039 = $3832baf57ec23419$var$Index;


// Created By James Launder
// kinda sketch page that just holds the legal things

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
var $fa9fe3ddad653fdc$exports = {};

$fa9fe3ddad653fdc$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "WevrMasterAgreement.41ae5d4f.pdf";



var $be75a9171eeadc45$exports = {};

$be75a9171eeadc45$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "WevrTerms&Conditions.32cb3cf7.pdf";


var $221923bd4e9de300$exports = {};

$221923bd4e9de300$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "PrivacyPolicy.47daa0e3.pdf";


function $0e3f457a44a20854$var$Legal() {
    const [currPDF, setCurrPDF] = (0, $exYeM.useState)(new URL($fa9fe3ddad653fdc$exports).toString());
    const [selected, setSelected] = (0, $exYeM.useState)(0);
    const master = new URL($fa9fe3ddad653fdc$exports).toString();
    const terms = new URL($be75a9171eeadc45$exports).toString();
    const privacy = new URL($221923bd4e9de300$exports).toString();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full h-[70vh] font-roboto",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "h-16 flex flex-row divide-x ",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        onClick: ()=>{
                            setCurrPDF(master);
                            setSelected(0);
                        },
                        className: `${selected == 0 ? "border-b-4 border-primary  font-semibold" : "text-black"} w-1/2`,
                        children: "Master Agreement"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        onClick: ()=>{
                            setCurrPDF(terms);
                            setSelected(1);
                        },
                        className: `${selected == 1 ? "border-b-4 border-primary  font-semibold" : "text-black"} w-1/2`,
                        children: "Terms and Conditions"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        onClick: ()=>{
                            setCurrPDF(privacy);
                            setSelected(2);
                        },
                        className: `${selected == 2 ? "border-b-4 border-primary  font-semibold" : "text-black"} w-1/2`,
                        children: "Privacy Policy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("iframe", {
                src: currPDF,
                title: "Legal",
                width: "100%",
                height: "100%"
            })
        ]
    });
}
var $0e3f457a44a20854$export$2e2bcd8739ae039 = $0e3f457a44a20854$var$Legal;











var $d900c99c578c5ff5$var$_initialState, $d900c99c578c5ff5$var$_revertState, $d900c99c578c5ff5$var$_cache, $d900c99c578c5ff5$var$_promise, $d900c99c578c5ff5$var$_retryer, $d900c99c578c5ff5$var$_observers, $d900c99c578c5ff5$var$_defaultOptions, $d900c99c578c5ff5$var$_abortSignalConsumed, $d900c99c578c5ff5$var$_setOptions, $d900c99c578c5ff5$var$setOptions_fn, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn;
var $d900c99c578c5ff5$export$62297b13309008b2 = class extends (0, $729e2f339928895f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_setOptions);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_dispatch);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_initialState, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_revertState, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_cache, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_promise, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_retryer, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_observers, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_defaultOptions, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $d900c99c578c5ff5$var$_abortSignalConsumed, void 0);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_abortSignalConsumed, false);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_defaultOptions, config.defaultOptions);
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_setOptions, $d900c99c578c5ff5$var$setOptions_fn).call(this, config.options);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_observers, []);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_initialState, config.state || $d900c99c578c5ff5$var$getDefaultState(this.options));
        this.state = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    optionalRemove() {
        if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).length && this.state.fetchStatus === "idle") (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $54cfa1b7ba8b31b7$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a;
        const promise = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_promise);
        (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_retryer)) == null || _a.cancel(options);
        return promise ? promise.then((0, $54cfa1b7ba8b31b7$export$8793edee2d425525)).catch((0, $54cfa1b7ba8b31b7$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_initialState));
    }
    isActive() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $54cfa1b7ba8b31b7$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).includes(observer)) {
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).includes(observer)) {
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_observers, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).filter((x)=>x !== observer));
            if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).length) {
                if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_retryer)) {
                    if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_abortSignalConsumed)) (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c, _d;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_promise)) {
                (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_retryer)) == null || _a.continueRetry();
                return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_promise);
            }
        }
        if (options) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_setOptions, $d900c99c578c5ff5$var$setOptions_fn).call(this, options);
        if (!this.options.queryFn) {
            const observer = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).find((x)=>x.options.queryFn);
            if (observer) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_setOptions, $d900c99c578c5ff5$var$setOptions_fn).call(this, observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d2;
            if (!((0, $537d0c641c62b96c$export$986cc6445c1d323)(error) && error.silent)) (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $537d0c641c62b96c$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d2 = (_c2 = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_cache).config).onSettled) == null || _d2.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_retryer, (0, $537d0c641c62b96c$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d2;
                if (typeof data === "undefined") {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d2 = (_c2 = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_cache).config).onSettled) == null || _d2.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $baa96523396bdf41$export$fa92d15b718fce20)(this, $d900c99c578c5ff5$var$_dispatch, $d900c99c578c5ff5$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $d900c99c578c5ff5$var$_promise, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_retryer).promise);
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_promise);
    }
};
$d900c99c578c5ff5$var$_initialState = new WeakMap();
$d900c99c578c5ff5$var$_revertState = new WeakMap();
$d900c99c578c5ff5$var$_cache = new WeakMap();
$d900c99c578c5ff5$var$_promise = new WeakMap();
$d900c99c578c5ff5$var$_retryer = new WeakMap();
$d900c99c578c5ff5$var$_observers = new WeakMap();
$d900c99c578c5ff5$var$_defaultOptions = new WeakMap();
$d900c99c578c5ff5$var$_abortSignalConsumed = new WeakMap();
$d900c99c578c5ff5$var$_setOptions = new WeakSet();
$d900c99c578c5ff5$var$setOptions_fn = function(options) {
    this.options = {
        ...(0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_defaultOptions),
        ...options
    };
    this.updateGcTime(this.options.gcTime);
};
$d900c99c578c5ff5$var$_dispatch = new WeakSet();
$d900c99c578c5ff5$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    fetchFailureCount: 0,
                    fetchFailureReason: null,
                    fetchMeta: action.meta ?? null,
                    fetchStatus: (0, $537d0c641c62b96c$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                    ...!state.dataUpdatedAt && {
                        error: null,
                        status: "pending"
                    }
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $537d0c641c62b96c$export$986cc6445c1d323)(error) && error.revert && (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_revertState)) return {
                    ...(0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $d900c99c578c5ff5$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $d900c99c578c5ff5$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $cb1d76738475d4b2$var$_queries;
var $cb1d76738475d4b2$export$5dde0cd941da8468 = class extends (0, $d4b58c4894ac9142$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $cb1d76738475d4b2$var$_queries, void 0);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $cb1d76738475d4b2$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $54cfa1b7ba8b31b7$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $d900c99c578c5ff5$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $baa96523396bdf41$export$18a094aefa070634)(this, $cb1d76738475d4b2$var$_queries).has(query.queryHash)) {
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $cb1d76738475d4b2$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $cb1d76738475d4b2$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $baa96523396bdf41$export$18a094aefa070634)(this, $cb1d76738475d4b2$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $cb1d76738475d4b2$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $baa96523396bdf41$export$18a094aefa070634)(this, $cb1d76738475d4b2$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $54cfa1b7ba8b31b7$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $54cfa1b7ba8b31b7$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$cb1d76738475d4b2$var$_queries = new WeakMap();







var $99463fd307fa4247$var$_mutations, $99463fd307fa4247$var$_mutationId, $99463fd307fa4247$var$_resuming;
var $99463fd307fa4247$export$1fcfd9a244434844 = class extends (0, $d4b58c4894ac9142$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $99463fd307fa4247$var$_mutations, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $99463fd307fa4247$var$_mutationId, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $99463fd307fa4247$var$_resuming, void 0);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $99463fd307fa4247$var$_mutations, []);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $99463fd307fa4247$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $76da438f2abff68a$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $baa96523396bdf41$export$b1fe7cbb4502036b)(this, $99463fd307fa4247$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_mutations).push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $99463fd307fa4247$var$_mutations, (0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_mutations).find((mutation)=>(0, $54cfa1b7ba8b31b7$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_mutations).filter((mutation)=>(0, $54cfa1b7ba8b31b7$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $99463fd307fa4247$var$_resuming, ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_mutations).filter((x)=>x.state.isPaused);
            return (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $54cfa1b7ba8b31b7$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $99463fd307fa4247$var$_resuming, void 0);
        }));
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $99463fd307fa4247$var$_resuming);
    }
};
$99463fd307fa4247$var$_mutations = new WeakMap();
$99463fd307fa4247$var$_mutationId = new WeakMap();
$99463fd307fa4247$var$_resuming = new WeakMap();







function $81b4f2feb6f03bd4$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn || (()=>Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`)));
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $54cfa1b7ba8b31b7$export$8c6246b73dd61f4a) : (0, $54cfa1b7ba8b31b7$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $81b4f2feb6f03bd4$var$getPreviousPageParam : $81b4f2feb6f03bd4$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $81b4f2feb6f03bd4$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $81b4f2feb6f03bd4$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $81b4f2feb6f03bd4$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $81b4f2feb6f03bd4$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $81b4f2feb6f03bd4$var$getNextPageParam(options, data) != null;
}
function $81b4f2feb6f03bd4$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $81b4f2feb6f03bd4$var$getPreviousPageParam(options, data) != null;
}


var $3751a76a3f332f6a$var$_queryCache, $3751a76a3f332f6a$var$_mutationCache, $3751a76a3f332f6a$var$_defaultOptions, $3751a76a3f332f6a$var$_queryDefaults, $3751a76a3f332f6a$var$_mutationDefaults, $3751a76a3f332f6a$var$_mountCount, $3751a76a3f332f6a$var$_unsubscribeFocus, $3751a76a3f332f6a$var$_unsubscribeOnline;
var $3751a76a3f332f6a$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $3751a76a3f332f6a$var$_queryCache, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $3751a76a3f332f6a$var$_mutationCache, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $3751a76a3f332f6a$var$_defaultOptions, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $3751a76a3f332f6a$var$_queryDefaults, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $3751a76a3f332f6a$var$_mutationDefaults, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $3751a76a3f332f6a$var$_mountCount, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $3751a76a3f332f6a$var$_unsubscribeFocus, void 0);
        (0, $baa96523396bdf41$export$addf369becd23283)(this, $3751a76a3f332f6a$var$_unsubscribeOnline, void 0);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_queryCache, config.queryCache || new (0, $cb1d76738475d4b2$export$5dde0cd941da8468)());
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_mutationCache, config.mutationCache || new (0, $99463fd307fa4247$export$1fcfd9a244434844)());
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_defaultOptions, config.defaultOptions || {});
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_mountCount, 0);
    }
    mount() {
        (0, $baa96523396bdf41$export$b1fe7cbb4502036b)(this, $3751a76a3f332f6a$var$_mountCount)._++;
        if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_mountCount) !== 1) return;
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_unsubscribeFocus, (0, $e6aefbda2a6ae529$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $e6aefbda2a6ae529$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).onFocus();
            }
        }));
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_unsubscribeOnline, (0, $767e6f8a936e9e12$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $767e6f8a936e9e12$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $baa96523396bdf41$export$b1fe7cbb4502036b)(this, $3751a76a3f332f6a$var$_mountCount)._--;
        if ((0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_mountCount) !== 0) return;
        (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_unsubscribeFocus, void 0);
        (_b = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        return (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(options);
    }
    getQueriesData(filters) {
        return this.getQueryCache().findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).find({
            queryKey: queryKey
        });
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $54cfa1b7ba8b31b7$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return void 0;
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        return (_a = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache);
        (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>(0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $54cfa1b7ba8b31b7$export$8793edee2d425525)).catch((0, $54cfa1b7ba8b31b7$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>{
            (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $c2ff7b8ef1de8f46$export$520687f44db6e1ab).batch(()=>(0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $54cfa1b7ba8b31b7$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $54cfa1b7ba8b31b7$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $54cfa1b7ba8b31b7$export$8793edee2d425525)).catch((0, $54cfa1b7ba8b31b7$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $81b4f2feb6f03bd4$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $54cfa1b7ba8b31b7$export$8793edee2d425525)).catch((0, $54cfa1b7ba8b31b7$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_mutationCache).resumePausedMutations();
    }
    getQueryCache() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache);
    }
    getMutationCache() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $baa96523396bdf41$export$42432efe6614d3b4)(this, $3751a76a3f332f6a$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryDefaults).set((0, $54cfa1b7ba8b31b7$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $54cfa1b7ba8b31b7$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_mutationDefaults).set((0, $54cfa1b7ba8b31b7$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $54cfa1b7ba8b31b7$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_defaultOptions).queries,
            ...(options == null ? void 0 : options.queryKey) && this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $54cfa1b7ba8b31b7$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.throwOnError === "undefined") defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (typeof defaultedOptions.networkMode === "undefined" && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_queryCache).clear();
        (0, $baa96523396bdf41$export$18a094aefa070634)(this, $3751a76a3f332f6a$var$_mutationCache).clear();
    }
};
$3751a76a3f332f6a$var$_queryCache = new WeakMap();
$3751a76a3f332f6a$var$_mutationCache = new WeakMap();
$3751a76a3f332f6a$var$_defaultOptions = new WeakMap();
$3751a76a3f332f6a$var$_queryDefaults = new WeakMap();
$3751a76a3f332f6a$var$_mutationDefaults = new WeakMap();
$3751a76a3f332f6a$var$_mountCount = new WeakMap();
$3751a76a3f332f6a$var$_unsubscribeFocus = new WeakMap();
$3751a76a3f332f6a$var$_unsubscribeOnline = new WeakMap();


// created by james launder
// This component is used when a user has got a forgot password link to then reset the password.
/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");









const $01e805ac74a28c89$var$schema = $2665099025d48597$export$185802fd694ee1f5({
    password: $c00a520989a13c1b$export$185802fd694ee1f5().required("Please enter your password").matches(/^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, "Password must contain at least 8 characters, one uppercase, one number and one special case character"),
    confirmPwd: $c00a520989a13c1b$export$185802fd694ee1f5().required("Please confirm your password").oneOf([
        $63ff9c708482e4b7$export$185802fd694ee1f5("password")
    ], "Password doesn't match")
}).required();
function $01e805ac74a28c89$var$ResetPass() {
    let { confirmationCode: confirmationCode } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [successful, setSuccessful] = (0, $exYeM.useState)(false);
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $354df6ff51b92897$export$87c0cf8eb5a167e0)({
        resolver: (0, $de3022907c3640b7$export$d55832dfcd4989a)($01e805ac74a28c89$var$schema)
    });
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ code: code, password: password })=>{
            setLoading(true);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put("/resetPassword", {
                code: code,
                newPassword: password
            });
        },
        onSuccess: ()=>{
            setLoading(false);
            setSuccessful(true);
            toast({
                variant: "success",
                title: "Success!",
                description: "Successfully updated password"
            });
            navigate("/signin");
            window.location.reload();
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(resMessage);
            setSuccessful(false);
            setLoading(false);
        }
    });
    const onSubmit = (data)=>{
        mutation.mutate({
            code: confirmationCode,
            password: data.password
        });
    };
    //   const userVerify = useQuery("user-verify", () =>
    //     request.get("/user/confirm/" + confirmationCode)
    //   );
    //   if (userVerify.isLoading) {
    //     return <div>Confirming your account</div>;
    //   }
    //   if (userVerify.isError) {
    //     return <div>{userVerify.error.response.data.message}</div>;
    //   }
    // console.log(confirmationCode);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "bg-surface w-full font-roboto relative z-0 overflow-hidden",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "min-h-[75vh] grid place-items-center py-2 font-roboto relative z-0 overflow-x-hidden",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-col grow gap-4 max-w-6xl",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative z-10 top-[-40px] md:top-[-40px] lg:top-[-70px] sm:left-[-200px] md:left-[-150px]",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7da6cd7a80759224$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative z-20 pt-4 px-4",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "font-roboto font-semibold text-4xl pb-2",
                            children: "Reset Password"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative z-20 bg-white rounded-md p-6 w-full shadow-md lg:w-96",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                            className: "pt-4",
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                            className: "block text-md font-roboto font-light",
                                            children: "New Password:"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                            name: "password",
                                            type: "password",
                                            placeholder: "Password",
                                            className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.password ? "is-invalid" : ""}`,
                                            ...register("password")
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "invalid-feedback",
                                            children: errors.password?.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                            className: "block text-md font-roboto font-light",
                                            children: "Confirm New Password:"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                            name: "confirmPwd",
                                            type: "password",
                                            placeholder: "Confirm Password",
                                            className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 form-control focus:border-primary focus:outline-none ${errors.confirmPwd ? "is-invalid" : ""}`,
                                            ...register("confirmPwd")
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "invalid-feedback",
                                            children: errors.confirmPwd?.message
                                        })
                                    ]
                                }),
                                message && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "form-group",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: successful ? "alert alert-success" : "alert alert-danger",
                                        role: "alert",
                                        children: message
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "py-4 grid grid-cols-3",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                        type: "submit",
                                        className: "bg-surfaceVariant group hover:bg-primary hover:text-white text-gray-900 mt-3 inline-flex gap-4 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm  sm:mt-0 sm:w-auto",
                                        disabled: loading,
                                        children: [
                                            loading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 animate-spin group-hover:text-white"
                                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {}),
                                            "Reset"
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $01e805ac74a28c89$export$2e2bcd8739ae039 = $01e805ac74a28c89$var$ResetPass;


// Created By James Launder
// Used to send a link to the email allowing the user to reset their password
/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");







const $d6056c06ab01c2ef$var$schema = $2665099025d48597$export$185802fd694ee1f5({
    email: $c00a520989a13c1b$export$185802fd694ee1f5().email().required()
}).required();
function $d6056c06ab01c2ef$var$ForgotPass() {
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $354df6ff51b92897$export$87c0cf8eb5a167e0)({
        resolver: (0, $de3022907c3640b7$export$d55832dfcd4989a)($d6056c06ab01c2ef$var$schema)
    });
    const [successful, setSuccessful] = (0, $exYeM.useState)(false);
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ email: email })=>{
            setLoading(true);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/forgot", {
                email: email
            });
        },
        onSuccess: ()=>{
            setMessage("Reset link sent to email");
            setLoading(false);
            setSuccessful(true);
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            // console.log(error);
            setMessage(resMessage);
            setSuccessful(false);
            setLoading(false);
        }
    });
    const onSubmit = (data)=>{
        mutation.mutate({
            email: data.email
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "bg-surface w-full font-roboto relative z-0 overflow-hidden",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "min-h-[75vh] grid place-items-center py-2 font-roboto relative z-0 overflow-x-hidden",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-col grow gap-4 max-w-6xl",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative z-10 top-[-110px] sm:top-[-40px] md:top-[-50px] lg:top-[-90px] xl:top-[-150px] 2xl:top-[-150px] sm:left-[-200px] md:left-[-130px]",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7da6cd7a80759224$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative z-20 pt-4 px-4",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "font-roboto font-semibold text-4xl pb-2",
                            children: "Forgot Password"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative z-20 bg-white rounded-md p-6 w-full lg:w-96 shadow-md",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                            className: "pt-4",
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                            className: "block text-md font-roboto font-light mb-1",
                                            children: "Email:"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                            type: "text",
                                            name: "email",
                                            placeholder: "Email",
                                            className: `block border border-onSurfaceVariant w-full p-3 rounded-md mb-4 form-control focus:border-primary focus:outline-none ${errors.email ? "is-invalid" : ""}`,
                                            ...register("email")
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "invalid-feedback",
                                            children: errors.email?.message
                                        })
                                    ]
                                }),
                                message && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "form-group",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: successful ? "alert alert-success" : "alert alert-danger",
                                        role: "alert",
                                        children: message
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "py-4 grid grid-cols-3",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                        type: "submit",
                                        className: "bg-surfaceVariant group hover:bg-primary hover:text-white text-gray-900 mt-3 inline-flex gap-4 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm  sm:mt-0 sm:w-auto",
                                        disabled: loading,
                                        children: [
                                            loading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 animate-spin group-hover:text-white"
                                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {}),
                                            "Reset"
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $d6056c06ab01c2ef$export$2e2bcd8739ae039 = $d6056c06ab01c2ef$var$ForgotPass;


// created by James Launder
// form for contact us to be sent to middleware to pass onto our inbox

var $aSiaI = parcelRequire("aSiaI");




var $exYeM = parcelRequire("exYeM");


// created by James Launder insipred by tailwind ui
// pop to indicate a message has been sent

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



function $9e0ff829f05aff26$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            "aria-live": "assertive",
            className: "pointer-events-none w-full fixed top-18 right-4 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex w-full flex-col items-center space-y-4 sm:items-end",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                    show: props.show,
                    as: (0, $exYeM.Fragment),
                    enter: "transform ease-out duration-300 transition",
                    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
                    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
                    leave: "transition ease-in duration-100",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-surfaceVariant shadow-lg ring-1 ring-black ring-opacity-5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-start",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b1025e29a9661faf$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-primary",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "ml-3 w-0 flex-1 pt-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-md font-medium text-gray-900",
                                                children: "Successfully Sent"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "mt-1 text-md text-gray-500",
                                                children: "Email has been successfully sent to our support team"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "ml-4 flex flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                                            onClick: ()=>{
                                                props.setShow(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6420636464f3564$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}



const $a69e61cef7f8059b$var$schema = $2665099025d48597$export$185802fd694ee1f5({
    name: $c00a520989a13c1b$export$185802fd694ee1f5().required(),
    email: $c00a520989a13c1b$export$185802fd694ee1f5().email().required(),
    subject: $c00a520989a13c1b$export$185802fd694ee1f5().required(),
    message: $c00a520989a13c1b$export$185802fd694ee1f5().required()
}).required();
function $a69e61cef7f8059b$var$Contact() {
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $354df6ff51b92897$export$87c0cf8eb5a167e0)({
        resolver: (0, $de3022907c3640b7$export$d55832dfcd4989a)($a69e61cef7f8059b$var$schema)
    });
    const [isLoading, setLoading] = (0, $exYeM.useState)(false);
    // eslint-disable-next-line no-unused-vars
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [show, setShow] = (0, $exYeM.useState)(false);
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ name: name, email: email, subject: subject, message: message })=>{
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/contactEmail", {
                email: email,
                name: name,
                subject: subject,
                message: message
            });
        },
        onSuccess: ()=>{
            // setSuccessful(true);
            setLoading(false);
            setShow(true);
        },
        onError: (error)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(resMessage);
            setLoading(false);
        }
    });
    const onSubmit = (data)=>{
        // console.log("done");
        setLoading(true);
        mutation.mutate({
            email: data.email,
            name: data.name,
            subject: data.subject,
            message: data.message
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "grid bg-surface w-full font-roboto relative z-0 overflow-hidden ",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "relative z-10 top-[190px] left-[350px] mx-auto max-w-6xl md:block hidden",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7da6cd7a80759224$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9e0ff829f05aff26$export$2e2bcd8739ae039), {
                show: show,
                setShow: setShow
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative z-20 grid pb-8 pt-4 place-items-center w-full",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "grid grid-flow-row gap-8  content-center py-4 w-4/5 md:w-2/3 lg:w-1/2 ",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                className: " font-semibold text-center text-4xl sm:text-6xl ml-2 pb-2 text-gray-900",
                                children: "Get in touch"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex md:flex-row flex-col gap-4 md:gap-20 lg:gap-40 justify-around",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex flex-col bg-white shadow-md border border-primaryContainer p-4 py-6 text-lg rounded-lg grow items-center ",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "font-semibold",
                                                children: "Matt Webb"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "font-light pb-4",
                                                children: "Co-founder"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "pb-4 font-medium text-indigo-600",
                                                children: "matt@wevr.ai"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex flex-col bg-white shadow-md border border-primaryContainer p-4 py-6 text-lg rounded-lg grow items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "font-semibold",
                                                children: "James Launder"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "font-light pb-4",
                                                children: "Co-founder"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "pb-4 font-medium text-indigo-600",
                                                children: "jlaunder@wevr.ai"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "bg-white shadow-md border border-primaryContainer px-8 py-4 rounded-lg w-4/5 md:w-2/3 lg:w-1/2",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                            className: "flex flex-col pt-4 gap-4",
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                            className: "block text-md font-roboto font-light",
                                            children: "Name:"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                            type: "text",
                                            name: "name",
                                            placeholder: "Name",
                                            className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 focus:border-primary focus:outline-none form-control ${errors.name ? "is-invalid" : ""}`,
                                            ...register("name")
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "font-semibold text-red-500 invalid-feedback -mt-2",
                                            children: errors.name?.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                            className: "block text-md font-roboto font-light",
                                            children: [
                                                "Email:",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                            name: "email",
                                            type: "email",
                                            placeholder: "Email",
                                            className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 focus:border-primary focus:outline-none form-control ${errors.email ? "is-invalid" : ""}`,
                                            ...register("email")
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "font-semibold text-red-500 invalid-feedback -mt-2",
                                            children: errors.email?.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                            className: "block text-md font-roboto font-light",
                                            children: [
                                                "Subject:",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                            name: "subject",
                                            type: "text",
                                            placeholder: "Subject",
                                            className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 focus:border-primary focus:outline-none form-control ${errors.subject ? "is-invalid" : ""}`,
                                            ...register("subject")
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "font-semibold text-red-500 invalid-feedback -mt-2",
                                            children: errors.subject?.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                            className: "block text-md font-roboto font-light",
                                            children: [
                                                "Message:",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("textarea", {
                                            name: "message",
                                            type: "text",
                                            //   placeholder="Message"
                                            rows: 6,
                                            className: `block border border-onSurfaceVariant w-full p-3 rounded-lg mb-4 focus:border-primary focus:outline-none form-control ${errors.message ? "is-invalid" : ""}`,
                                            ...register("message")
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "font-semibold text-red-500 invalid-feedback -mt-2",
                                            children: errors.message?.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "flex justify-center py-4",
                                    children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
                                                "aria-hidden": "true",
                                                className: "w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-primary",
                                                viewBox: "0 0 100 101",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                        fill: "currentColor"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                                                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                        fill: "currentFill"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "sr-only",
                                                children: "Loading..."
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        type: "submit",
                                        className: "px-6 py-2 w-full font-roboto font-light rounded-lg bg-surfaceVariant border border-primaryContainer shadow-md hover:text-white hover:bg-primary",
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $a69e61cef7f8059b$export$2e2bcd8739ae039 = $a69e61cef7f8059b$var$Contact;



var $aSiaI = parcelRequire("aSiaI");


var $aSiaI = parcelRequire("aSiaI");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


const $433754a817809fb2$var$getButtonVariantClass = (variant, size)=>{
    let baseClass = "inline-flex items-center justify-center whitespace-nowrap text-base 2xl:text-lg ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";
    let variantClass = "";
    let sizeClass = "";
    switch(variant){
        case "semibold":
            variantClass = "font-semibold bg-primary text-primary-foreground hover:bg-primary/90";
            break;
        case "destructive":
            variantClass = "bg-destructive text-destructive-foreground hover:bg-destructive/90";
            break;
        case "outline":
            variantClass = "border border-input bg-background hover:bg-accent hover:text-accent-foreground";
            break;
        case "secondary":
            variantClass = "bg-secondary text-secondary-foreground hover:bg-secondary/80";
            break;
        case "ghost":
            variantClass = "hover:bg-accent hover:text-accent-foreground";
            break;
        case "link":
            variantClass = "text-primary underline-offset-4 hover:underline";
            break;
        default:
            variantClass = "bg-primary text-primary-foreground hover:bg-primary/90";
    }
    switch(size){
        case "sm":
            sizeClass = "h-9 rounded-md px-3";
            break;
        case "lg":
            sizeClass = "h-11 rounded-md px-8";
            break;
        case "icon":
            sizeClass = "h-10 w-10";
            break;
        default:
            sizeClass = "h-10 px-4 py-2";
    }
    return `${baseClass} ${variantClass} ${sizeClass}`;
};
const $433754a817809fb2$export$3b0a9d598f613fa = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, variant: variant = "default", size: size = "default", asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : "button";
    const buttonClass = $433754a817809fb2$var$getButtonVariantClass(variant, size);
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Comp, {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)(buttonClass, className),
        ref: ref,
        ...props
    });
});
$433754a817809fb2$export$3b0a9d598f613fa.displayName = "Button";


/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ /* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $d04bae4fc4e24d48$export$83d89fbfd8236492 = "6.13.1";


/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $fcb333efda27d9d7$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $fcb333efda27d9d7$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $fcb333efda27d9d7$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $fcb333efda27d9d7$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}


function $bb8e52d338877b37$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($bb8e52d338877b37$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $bb8e52d338877b37$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$bb8e52d338877b37$var$stringify(k)}: ${$bb8e52d338877b37$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $bb8e52d338877b37$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $bb8e52d338877b37$export$748c4fa78f31ff35(error) {
    return $bb8e52d338877b37$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $bb8e52d338877b37$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$bb8e52d338877b37$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $bb8e52d338877b37$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $d04bae4fc4e24d48$export$83d89fbfd8236492)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $bb8e52d338877b37$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $bb8e52d338877b37$export$5a4bb2b1c89bdce7(message, code, info);
}
function $bb8e52d338877b37$export$c3d31707e5030f5e(check, message, name, value) {
    $bb8e52d338877b37$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $bb8e52d338877b37$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $bb8e52d338877b37$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $bb8e52d338877b37$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $bb8e52d338877b37$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $bb8e52d338877b37$export$d993e67fefdfecda(form) {
    $bb8e52d338877b37$export$a7a9523472993e97($bb8e52d338877b37$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $bb8e52d338877b37$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $bb8e52d338877b37$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}


/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false
/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
function $646c422fbb8bae38$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid BytesLike value", name || "value", value);
}
function $646c422fbb8bae38$export$a3521add2594f3c8(value, name) {
    return $646c422fbb8bae38$var$_getBytes(value, name, false);
}
function $646c422fbb8bae38$export$37110e7fee0af4ad(value, name) {
    return $646c422fbb8bae38$var$_getBytes(value, name, true);
}
function $646c422fbb8bae38$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $646c422fbb8bae38$export$9a14abb1a440cd5e(value) {
    return $646c422fbb8bae38$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $646c422fbb8bae38$var$HexCharacters = "0123456789abcdef";
function $646c422fbb8bae38$export$2b0d6b5fbe698c70(data) {
    const bytes = $646c422fbb8bae38$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $646c422fbb8bae38$var$HexCharacters[(v & 0xf0) >> 4] + $646c422fbb8bae38$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $646c422fbb8bae38$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$646c422fbb8bae38$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $646c422fbb8bae38$export$2321cd91b99770ff(data) {
    if ($646c422fbb8bae38$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $646c422fbb8bae38$export$a3521add2594f3c8(data).length;
}
function $646c422fbb8bae38$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $646c422fbb8bae38$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $646c422fbb8bae38$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $646c422fbb8bae38$export$9c854001a22ebaa2(data) {
    let bytes = $646c422fbb8bae38$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $646c422fbb8bae38$var$zeroPad(data, length, left) {
    const bytes = $646c422fbb8bae38$export$a3521add2594f3c8(data);
    (0, $bb8e52d338877b37$export$a7a9523472993e97)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $646c422fbb8bae38$export$2b0d6b5fbe698c70(result);
}
function $646c422fbb8bae38$export$4473860254365feb(data, length) {
    return $646c422fbb8bae38$var$zeroPad(data, length, true);
}
function $646c422fbb8bae38$export$1dc7fbe1b8738fe7(data, length) {
    return $646c422fbb8bae38$var$zeroPad(data, length, false);
}


/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 

const $80785c90802caadd$var$BN_0 = BigInt(0);
const $80785c90802caadd$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $80785c90802caadd$var$maxValue = 0x1fffffffffffff;
function $80785c90802caadd$export$92182edcfa20e5bc(_value, _width) {
    const value = $80785c90802caadd$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($80785c90802caadd$export$b14f2714108df84(_width, "width"));
    (0, $bb8e52d338877b37$export$a7a9523472993e97)(value >> width === $80785c90802caadd$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $80785c90802caadd$var$BN_1) {
        const mask = ($80785c90802caadd$var$BN_1 << width) - $80785c90802caadd$var$BN_1;
        return -((~value & mask) + $80785c90802caadd$var$BN_1);
    }
    return value;
}
function $80785c90802caadd$export$7101cd4e6275351c(_value, _width) {
    let value = $80785c90802caadd$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($80785c90802caadd$export$b14f2714108df84(_width, "width"));
    const limit = $80785c90802caadd$var$BN_1 << width - $80785c90802caadd$var$BN_1;
    if (value < $80785c90802caadd$var$BN_0) {
        value = -value;
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($80785c90802caadd$var$BN_1 << width) - $80785c90802caadd$var$BN_1;
        return (~value & mask) + $80785c90802caadd$var$BN_1;
    } else (0, $bb8e52d338877b37$export$a7a9523472993e97)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $80785c90802caadd$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $80785c90802caadd$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($80785c90802caadd$export$b14f2714108df84(_bits, "bits"));
    return value & ($80785c90802caadd$var$BN_1 << bits) - $80785c90802caadd$var$BN_1;
}
function $80785c90802caadd$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(value >= -$80785c90802caadd$var$maxValue && value <= $80785c90802caadd$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid BigNumberish value", name || "value", value);
}
function $80785c90802caadd$export$8677d6ca9282a154(value, name) {
    const result = $80785c90802caadd$export$61fe455e2b1e28a4(value, name);
    (0, $bb8e52d338877b37$export$a7a9523472993e97)(result >= $80785c90802caadd$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $80785c90802caadd$var$Nibbles = "0123456789abcdef";
function $80785c90802caadd$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $80785c90802caadd$var$Nibbles[v >> 4];
            result += $80785c90802caadd$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $80785c90802caadd$export$61fe455e2b1e28a4(value);
}
function $80785c90802caadd$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(value >= -$80785c90802caadd$var$maxValue && value <= $80785c90802caadd$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(value >= -$80785c90802caadd$var$maxValue && value <= $80785c90802caadd$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $80785c90802caadd$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid numeric value", name || "value", value);
}
function $80785c90802caadd$export$a0a81dc3380ce7d3(value) {
    return $80785c90802caadd$export$b14f2714108df84($80785c90802caadd$export$c221a145703ab783(value));
}
function $80785c90802caadd$export$c6ebe05badb16181(_value, _width) {
    const value = $80785c90802caadd$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $80785c90802caadd$export$b14f2714108df84(_width, "width");
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $80785c90802caadd$export$b627fcfb5ea68cb0(_value) {
    const value = $80785c90802caadd$export$8677d6ca9282a154(_value, "value");
    if (value === $80785c90802caadd$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $80785c90802caadd$export$d9c067986dbc68dd(value) {
    let result = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)((0, $646c422fbb8bae38$export$9a14abb1a440cd5e)(value) ? value : $80785c90802caadd$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}


const $9d29f608d1beea97$export$b4b1d1fba463e69c = 32;
const $9d29f608d1beea97$var$Padding = new Uint8Array($9d29f608d1beea97$export$b4b1d1fba463e69c);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const $9d29f608d1beea97$var$passProperties = [
    "then"
];
const $9d29f608d1beea97$var$_guard = {};
const $9d29f608d1beea97$var$resultNames = new WeakMap();
function $9d29f608d1beea97$var$getNames(result) {
    return $9d29f608d1beea97$var$resultNames.get(result);
}
function $9d29f608d1beea97$var$setNames(result, names) {
    $9d29f608d1beea97$var$resultNames.set(result, names);
}
function $9d29f608d1beea97$var$throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
function $9d29f608d1beea97$var$toObject(names, items, deep) {
    if (names.indexOf(null) >= 0) return items.map((item, index)=>{
        if (item instanceof $9d29f608d1beea97$export$8fdcabde73f49165) return $9d29f608d1beea97$var$toObject($9d29f608d1beea97$var$getNames(item), item, deep);
        return item;
    });
    return names.reduce((accum, name, index)=>{
        let item = items.getValue(name);
        if (!(name in accum)) {
            if (deep && item instanceof $9d29f608d1beea97$export$8fdcabde73f49165) item = $9d29f608d1beea97$var$toObject($9d29f608d1beea97$var$getNames(item), item, deep);
            accum[name] = item;
        }
        return accum;
    }, {});
}
class $9d29f608d1beea97$export$8fdcabde73f49165 extends Array {
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== $9d29f608d1beea97$var$_guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        $9d29f608d1beea97$var$setNames(this, Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        })));
        // Dummy operations to prevent TypeScript from complaining
        this.#names = [];
        if (this.#names == null) this.#names;
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        const proxy = new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, $80785c90802caadd$export$b14f2714108df84)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) $9d29f608d1beea97$var$throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if ($9d29f608d1beea97$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
        $9d29f608d1beea97$var$setNames(proxy, $9d29f608d1beea97$var$getNames(this));
        return proxy;
    }
    /**
     *  Returns the Result as a normal Array. If %%deep%%, any children
     *  which are Result objects are also converted to a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray(deep) {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) $9d29f608d1beea97$var$throwError(`index ${index}`, item);
            if (deep && item instanceof $9d29f608d1beea97$export$8fdcabde73f49165) item = item.toArray(deep);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair. If
     *  %%deep%%, any children which are Result objects are also
     *  converted to an Object.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject(deep) {
        const names = $9d29f608d1beea97$var$getNames(this);
        return names.reduce((accum, name, index)=>{
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(name != null, `value at index ${index} unnamed`, "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            return $9d29f608d1beea97$var$toObject(names, this, deep);
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const _names = $9d29f608d1beea97$var$getNames(this);
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(_names[i]);
        }
        return new $9d29f608d1beea97$export$8fdcabde73f49165($9d29f608d1beea97$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const _names = $9d29f608d1beea97$var$getNames(this);
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $9d29f608d1beea97$var$throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(_names[i]);
            }
        }
        return new $9d29f608d1beea97$export$8fdcabde73f49165($9d29f608d1beea97$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $9d29f608d1beea97$var$throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = $9d29f608d1beea97$var$getNames(this).indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) $9d29f608d1beea97$var$throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new $9d29f608d1beea97$export$8fdcabde73f49165($9d29f608d1beea97$var$_guard, items, keys);
    }
}
function $9d29f608d1beea97$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function $9d29f608d1beea97$var$getValue(value) {
    let bytes = (0, $80785c90802caadd$export$b627fcfb5ea68cb0)(value);
    (0, $bb8e52d338877b37$export$a7a9523472993e97)(bytes.length <= $9d29f608d1beea97$export$b4b1d1fba463e69c, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: $9d29f608d1beea97$export$b4b1d1fba463e69c,
        offset: bytes.length
    });
    if (bytes.length !== $9d29f608d1beea97$export$b4b1d1fba463e69c) bytes = (0, $646c422fbb8bae38$export$37110e7fee0af4ad)((0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
        $9d29f608d1beea97$var$Padding.slice(bytes.length % $9d29f608d1beea97$export$b4b1d1fba463e69c),
        bytes
    ]));
    return bytes;
}
class $9d29f608d1beea97$export$2c0c39526f8bad46 {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            localName: localName,
            dynamic: dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, message, this.localName, value);
    }
}
class $9d29f608d1beea97$export$d7a960146e1a269e {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, $646c422fbb8bae38$export$37110e7fee0af4ad)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, $646c422fbb8bae38$export$37110e7fee0af4ad)(value);
        const paddingOffset = bytes.length % $9d29f608d1beea97$export$b4b1d1fba463e69c;
        if (paddingOffset) bytes = (0, $646c422fbb8bae38$export$37110e7fee0af4ad)((0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
            bytes,
            $9d29f608d1beea97$var$Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData($9d29f608d1beea97$var$getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push($9d29f608d1beea97$var$Padding);
        this.#dataLength += $9d29f608d1beea97$export$b4b1d1fba463e69c;
        return (value)=>{
            this.#data[offset] = $9d29f608d1beea97$var$getValue(value);
        };
    }
}
class $9d29f608d1beea97$export$2f7a2f0e90c07dc4 {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    #bytesRead;
    #parent;
    #maxInflation;
    constructor(data, allowLoose, maxInflation){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, $646c422fbb8bae38$export$37110e7fee0af4ad)(data);
        this.#bytesRead = 0;
        this.#parent = null;
        this.#maxInflation = maxInflation != null ? maxInflation : 1024;
        this.#offset = 0;
    }
    get data() {
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #incrementBytesRead(count) {
        if (this.#parent) return this.#parent.#incrementBytesRead(count);
        this.#bytesRead += count;
        // Check for excessive inflation (see: #4537)
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https:/\/github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
            buffer: (0, $646c422fbb8bae38$export$37110e7fee0af4ad)(this.#data),
            offset: this.#offset,
            length: count,
            info: {
                bytesRead: this.#bytesRead,
                dataLength: this.dataLength
            }
        });
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / $9d29f608d1beea97$export$b4b1d1fba463e69c) * $9d29f608d1beea97$export$b4b1d1fba463e69c;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, $646c422fbb8bae38$export$37110e7fee0af4ad)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        const reader = new $9d29f608d1beea97$export$2f7a2f0e90c07dc4(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
        reader.#parent = this;
        return reader;
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#incrementBytesRead(length);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, $80785c90802caadd$export$c221a145703ab783)(this.readBytes($9d29f608d1beea97$export$b4b1d1fba463e69c));
    }
    readIndex() {
        return (0, $80785c90802caadd$export$a0a81dc3380ce7d3)(this.readBytes($9d29f608d1beea97$export$b4b1d1fba463e69c));
    }
}


/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ /**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ /* Browser Crypto Shims */ var $94b2278aec7365b2$exports = {};
"use strict";
Object.defineProperty($94b2278aec7365b2$exports, "__esModule", {
    value: true
});
$94b2278aec7365b2$exports.hmac = $94b2278aec7365b2$exports.HMAC = void 0;
var $12bfbb86ba5aff13$exports = {};
"use strict";
Object.defineProperty($12bfbb86ba5aff13$exports, "__esModule", {
    value: true
});
$12bfbb86ba5aff13$exports.output = $12bfbb86ba5aff13$exports.exists = $12bfbb86ba5aff13$exports.hash = $12bfbb86ba5aff13$exports.bytes = $12bfbb86ba5aff13$exports.bool = $12bfbb86ba5aff13$exports.number = void 0;
function $12bfbb86ba5aff13$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
$12bfbb86ba5aff13$exports.number = $12bfbb86ba5aff13$var$number;
function $12bfbb86ba5aff13$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
$12bfbb86ba5aff13$exports.bool = $12bfbb86ba5aff13$var$bool;
function $12bfbb86ba5aff13$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
$12bfbb86ba5aff13$exports.bytes = $12bfbb86ba5aff13$var$bytes;
function $12bfbb86ba5aff13$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $12bfbb86ba5aff13$var$number(hash.outputLen);
    $12bfbb86ba5aff13$var$number(hash.blockLen);
}
$12bfbb86ba5aff13$exports.hash = $12bfbb86ba5aff13$var$hash;
function $12bfbb86ba5aff13$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$12bfbb86ba5aff13$exports.exists = $12bfbb86ba5aff13$var$exists;
function $12bfbb86ba5aff13$var$output(out, instance) {
    $12bfbb86ba5aff13$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
$12bfbb86ba5aff13$exports.output = $12bfbb86ba5aff13$var$output;
const $12bfbb86ba5aff13$var$assert = {
    number: $12bfbb86ba5aff13$var$number,
    bool: $12bfbb86ba5aff13$var$bool,
    bytes: $12bfbb86ba5aff13$var$bytes,
    hash: $12bfbb86ba5aff13$var$hash,
    exists: $12bfbb86ba5aff13$var$exists,
    output: $12bfbb86ba5aff13$var$output
};
$12bfbb86ba5aff13$exports.default = $12bfbb86ba5aff13$var$assert;


var $743f5b81a9da9842$exports = {};
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($743f5b81a9da9842$exports, "__esModule", {
    value: true
});
$743f5b81a9da9842$exports.randomBytes = $743f5b81a9da9842$exports.wrapXOFConstructorWithOpts = $743f5b81a9da9842$exports.wrapConstructorWithOpts = $743f5b81a9da9842$exports.wrapConstructor = $743f5b81a9da9842$exports.checkOpts = $743f5b81a9da9842$exports.Hash = $743f5b81a9da9842$exports.concatBytes = $743f5b81a9da9842$exports.toBytes = $743f5b81a9da9842$exports.utf8ToBytes = $743f5b81a9da9842$exports.asyncLoop = $743f5b81a9da9842$exports.nextTick = $743f5b81a9da9842$exports.hexToBytes = $743f5b81a9da9842$exports.bytesToHex = $743f5b81a9da9842$exports.isLE = $743f5b81a9da9842$exports.rotr = $743f5b81a9da9842$exports.createView = $743f5b81a9da9842$exports.u32 = $743f5b81a9da9842$exports.u8 = void 0;
var $baf14c502c19c83c$exports = {};
"use strict";
Object.defineProperty($baf14c502c19c83c$exports, "__esModule", {
    value: true
});
$baf14c502c19c83c$exports.crypto = void 0;
$baf14c502c19c83c$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $743f5b81a9da9842$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $743f5b81a9da9842$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$743f5b81a9da9842$exports.u8 = $743f5b81a9da9842$var$u8;
const $743f5b81a9da9842$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$743f5b81a9da9842$exports.u32 = $743f5b81a9da9842$var$u32;
// Cast array to view
const $743f5b81a9da9842$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$743f5b81a9da9842$exports.createView = $743f5b81a9da9842$var$createView;
// The rotate right (circular right shift) operation for uint32
const $743f5b81a9da9842$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
$743f5b81a9da9842$exports.rotr = $743f5b81a9da9842$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
$743f5b81a9da9842$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$743f5b81a9da9842$exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $743f5b81a9da9842$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $743f5b81a9da9842$var$bytesToHex(bytes) {
    if (!$743f5b81a9da9842$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $743f5b81a9da9842$var$hexes[bytes[i]];
    return hex;
}
$743f5b81a9da9842$exports.bytesToHex = $743f5b81a9da9842$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $743f5b81a9da9842$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$743f5b81a9da9842$exports.hexToBytes = $743f5b81a9da9842$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $743f5b81a9da9842$var$nextTick = async ()=>{};
$743f5b81a9da9842$exports.nextTick = $743f5b81a9da9842$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $743f5b81a9da9842$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $743f5b81a9da9842$exports.nextTick)();
        ts += diff;
    }
}
$743f5b81a9da9842$exports.asyncLoop = $743f5b81a9da9842$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $743f5b81a9da9842$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$743f5b81a9da9842$exports.utf8ToBytes = $743f5b81a9da9842$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $743f5b81a9da9842$var$toBytes(data) {
    if (typeof data === "string") data = $743f5b81a9da9842$var$utf8ToBytes(data);
    if (!$743f5b81a9da9842$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
$743f5b81a9da9842$exports.toBytes = $743f5b81a9da9842$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $743f5b81a9da9842$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$743f5b81a9da9842$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
$743f5b81a9da9842$exports.concatBytes = $743f5b81a9da9842$var$concatBytes;
// For runtime check if class implements interface
class $743f5b81a9da9842$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$743f5b81a9da9842$exports.Hash = $743f5b81a9da9842$var$Hash;
const $743f5b81a9da9842$var$toStr = {}.toString;
function $743f5b81a9da9842$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $743f5b81a9da9842$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
$743f5b81a9da9842$exports.checkOpts = $743f5b81a9da9842$var$checkOpts;
function $743f5b81a9da9842$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($743f5b81a9da9842$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
$743f5b81a9da9842$exports.wrapConstructor = $743f5b81a9da9842$var$wrapConstructor;
function $743f5b81a9da9842$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($743f5b81a9da9842$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$743f5b81a9da9842$exports.wrapConstructorWithOpts = $743f5b81a9da9842$var$wrapConstructorWithOpts;
function $743f5b81a9da9842$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($743f5b81a9da9842$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$743f5b81a9da9842$exports.wrapXOFConstructorWithOpts = $743f5b81a9da9842$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $743f5b81a9da9842$var$randomBytes(bytesLength = 32) {
    if ($baf14c502c19c83c$exports.crypto && typeof $baf14c502c19c83c$exports.crypto.getRandomValues === "function") return $baf14c502c19c83c$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
$743f5b81a9da9842$exports.randomBytes = $743f5b81a9da9842$var$randomBytes;


// HMAC (RFC 2104)
class $94b2278aec7365b2$var$HMAC extends $743f5b81a9da9842$exports.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $12bfbb86ba5aff13$exports.hash)(hash);
        const key = (0, $743f5b81a9da9842$exports.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $12bfbb86ba5aff13$exports.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $12bfbb86ba5aff13$exports.exists)(this);
        (0, $12bfbb86ba5aff13$exports.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
$94b2278aec7365b2$exports.HMAC = $94b2278aec7365b2$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $94b2278aec7365b2$var$hmac = (hash, key, message)=>new $94b2278aec7365b2$var$HMAC(hash, key).update(message).digest();
$94b2278aec7365b2$exports.hmac = $94b2278aec7365b2$var$hmac;
$94b2278aec7365b2$exports.hmac.create = (hash, key)=>new $94b2278aec7365b2$var$HMAC(hash, key);


var $2616fcc4c438dd8b$exports = {};
"use strict";
Object.defineProperty($2616fcc4c438dd8b$exports, "__esModule", {
    value: true
});
$2616fcc4c438dd8b$exports.pbkdf2Async = $2616fcc4c438dd8b$exports.pbkdf2 = void 0;



// Common prologue and epilogue for sync/async functions
function $2616fcc4c438dd8b$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $12bfbb86ba5aff13$exports.hash)(hash);
    const opts = (0, $743f5b81a9da9842$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $12bfbb86ba5aff13$exports.number)(c);
    (0, $12bfbb86ba5aff13$exports.number)(dkLen);
    (0, $12bfbb86ba5aff13$exports.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $743f5b81a9da9842$exports.toBytes)(_password);
    const salt = (0, $743f5b81a9da9842$exports.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $94b2278aec7365b2$exports.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $2616fcc4c438dd8b$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $2616fcc4c438dd8b$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $2616fcc4c438dd8b$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $743f5b81a9da9842$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $2616fcc4c438dd8b$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$2616fcc4c438dd8b$exports.pbkdf2 = $2616fcc4c438dd8b$var$pbkdf2;
async function $2616fcc4c438dd8b$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $2616fcc4c438dd8b$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $743f5b81a9da9842$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $743f5b81a9da9842$exports.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $2616fcc4c438dd8b$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$2616fcc4c438dd8b$exports.pbkdf2Async = $2616fcc4c438dd8b$var$pbkdf2Async;


var $40745d2159d0279c$exports = {};
"use strict";
Object.defineProperty($40745d2159d0279c$exports, "__esModule", {
    value: true
});
$40745d2159d0279c$exports.sha224 = $40745d2159d0279c$exports.sha256 = void 0;
var $de9698a970204a80$exports = {};
"use strict";
Object.defineProperty($de9698a970204a80$exports, "__esModule", {
    value: true
});
$de9698a970204a80$exports.SHA2 = void 0;


// Polyfill for Safari 14
function $de9698a970204a80$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $de9698a970204a80$var$SHA2 extends $743f5b81a9da9842$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $743f5b81a9da9842$exports.createView)(this.buffer);
    }
    update(data) {
        (0, $12bfbb86ba5aff13$exports.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $743f5b81a9da9842$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $743f5b81a9da9842$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $12bfbb86ba5aff13$exports.exists)(this);
        (0, $12bfbb86ba5aff13$exports.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $de9698a970204a80$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $743f5b81a9da9842$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$de9698a970204a80$exports.SHA2 = $de9698a970204a80$var$SHA2;



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $40745d2159d0279c$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $40745d2159d0279c$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $40745d2159d0279c$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $40745d2159d0279c$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $40745d2159d0279c$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $40745d2159d0279c$var$SHA256 extends $de9698a970204a80$exports.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $40745d2159d0279c$var$IV[0] | 0;
        this.B = $40745d2159d0279c$var$IV[1] | 0;
        this.C = $40745d2159d0279c$var$IV[2] | 0;
        this.D = $40745d2159d0279c$var$IV[3] | 0;
        this.E = $40745d2159d0279c$var$IV[4] | 0;
        this.F = $40745d2159d0279c$var$IV[5] | 0;
        this.G = $40745d2159d0279c$var$IV[6] | 0;
        this.H = $40745d2159d0279c$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$40745d2159d0279c$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $40745d2159d0279c$var$SHA256_W[i - 15];
            const W2 = $40745d2159d0279c$var$SHA256_W[i - 2];
            const s0 = (0, $743f5b81a9da9842$exports.rotr)(W15, 7) ^ (0, $743f5b81a9da9842$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $743f5b81a9da9842$exports.rotr)(W2, 17) ^ (0, $743f5b81a9da9842$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $40745d2159d0279c$var$SHA256_W[i] = s1 + $40745d2159d0279c$var$SHA256_W[i - 7] + s0 + $40745d2159d0279c$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $743f5b81a9da9842$exports.rotr)(E, 6) ^ (0, $743f5b81a9da9842$exports.rotr)(E, 11) ^ (0, $743f5b81a9da9842$exports.rotr)(E, 25);
            const T1 = H + sigma1 + $40745d2159d0279c$var$Chi(E, F, G) + $40745d2159d0279c$var$SHA256_K[i] + $40745d2159d0279c$var$SHA256_W[i] | 0;
            const sigma0 = (0, $743f5b81a9da9842$exports.rotr)(A, 2) ^ (0, $743f5b81a9da9842$exports.rotr)(A, 13) ^ (0, $743f5b81a9da9842$exports.rotr)(A, 22);
            const T2 = sigma0 + $40745d2159d0279c$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $40745d2159d0279c$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $40745d2159d0279c$var$SHA224 extends $40745d2159d0279c$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $40745d2159d0279c$exports.sha256 = (0, $743f5b81a9da9842$exports.wrapConstructor)(()=>new $40745d2159d0279c$var$SHA256());
$40745d2159d0279c$exports.sha224 = (0, $743f5b81a9da9842$exports.wrapConstructor)(()=>new $40745d2159d0279c$var$SHA224());


var $8f37b5eac609d302$exports = {};
"use strict";
Object.defineProperty($8f37b5eac609d302$exports, "__esModule", {
    value: true
});
$8f37b5eac609d302$exports.sha384 = $8f37b5eac609d302$exports.sha512_256 = $8f37b5eac609d302$exports.sha512_224 = $8f37b5eac609d302$exports.sha512 = $8f37b5eac609d302$exports.SHA512 = void 0;

var $ee788fac11d40cfa$exports = {};
"use strict";
Object.defineProperty($ee788fac11d40cfa$exports, "__esModule", {
    value: true
});
$ee788fac11d40cfa$exports.add5L = $ee788fac11d40cfa$exports.add5H = $ee788fac11d40cfa$exports.add4H = $ee788fac11d40cfa$exports.add4L = $ee788fac11d40cfa$exports.add3H = $ee788fac11d40cfa$exports.add3L = $ee788fac11d40cfa$exports.add = $ee788fac11d40cfa$exports.rotlBL = $ee788fac11d40cfa$exports.rotlBH = $ee788fac11d40cfa$exports.rotlSL = $ee788fac11d40cfa$exports.rotlSH = $ee788fac11d40cfa$exports.rotr32L = $ee788fac11d40cfa$exports.rotr32H = $ee788fac11d40cfa$exports.rotrBL = $ee788fac11d40cfa$exports.rotrBH = $ee788fac11d40cfa$exports.rotrSL = $ee788fac11d40cfa$exports.rotrSH = $ee788fac11d40cfa$exports.shrSL = $ee788fac11d40cfa$exports.shrSH = $ee788fac11d40cfa$exports.toBig = $ee788fac11d40cfa$exports.split = $ee788fac11d40cfa$exports.fromBig = void 0;
const $ee788fac11d40cfa$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $ee788fac11d40cfa$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $ee788fac11d40cfa$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $ee788fac11d40cfa$var$U32_MASK64),
        l: Number(n >> $ee788fac11d40cfa$var$_32n & $ee788fac11d40cfa$var$U32_MASK64)
    };
    return {
        h: Number(n >> $ee788fac11d40cfa$var$_32n & $ee788fac11d40cfa$var$U32_MASK64) | 0,
        l: Number(n & $ee788fac11d40cfa$var$U32_MASK64) | 0
    };
}
$ee788fac11d40cfa$exports.fromBig = $ee788fac11d40cfa$var$fromBig;
function $ee788fac11d40cfa$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $ee788fac11d40cfa$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
$ee788fac11d40cfa$exports.split = $ee788fac11d40cfa$var$split;
const $ee788fac11d40cfa$var$toBig = (h, l)=>BigInt(h >>> 0) << $ee788fac11d40cfa$var$_32n | BigInt(l >>> 0);
$ee788fac11d40cfa$exports.toBig = $ee788fac11d40cfa$var$toBig;
// for Shift in [0, 32)
const $ee788fac11d40cfa$var$shrSH = (h, _l, s)=>h >>> s;
$ee788fac11d40cfa$exports.shrSH = $ee788fac11d40cfa$var$shrSH;
const $ee788fac11d40cfa$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
$ee788fac11d40cfa$exports.shrSL = $ee788fac11d40cfa$var$shrSL;
// Right rotate for Shift in [1, 32)
const $ee788fac11d40cfa$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
$ee788fac11d40cfa$exports.rotrSH = $ee788fac11d40cfa$var$rotrSH;
const $ee788fac11d40cfa$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
$ee788fac11d40cfa$exports.rotrSL = $ee788fac11d40cfa$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $ee788fac11d40cfa$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
$ee788fac11d40cfa$exports.rotrBH = $ee788fac11d40cfa$var$rotrBH;
const $ee788fac11d40cfa$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
$ee788fac11d40cfa$exports.rotrBL = $ee788fac11d40cfa$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $ee788fac11d40cfa$var$rotr32H = (_h, l)=>l;
$ee788fac11d40cfa$exports.rotr32H = $ee788fac11d40cfa$var$rotr32H;
const $ee788fac11d40cfa$var$rotr32L = (h, _l)=>h;
$ee788fac11d40cfa$exports.rotr32L = $ee788fac11d40cfa$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $ee788fac11d40cfa$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
$ee788fac11d40cfa$exports.rotlSH = $ee788fac11d40cfa$var$rotlSH;
const $ee788fac11d40cfa$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
$ee788fac11d40cfa$exports.rotlSL = $ee788fac11d40cfa$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $ee788fac11d40cfa$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
$ee788fac11d40cfa$exports.rotlBH = $ee788fac11d40cfa$var$rotlBH;
const $ee788fac11d40cfa$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
$ee788fac11d40cfa$exports.rotlBL = $ee788fac11d40cfa$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $ee788fac11d40cfa$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
$ee788fac11d40cfa$exports.add = $ee788fac11d40cfa$var$add;
// Addition with more than 2 elements
const $ee788fac11d40cfa$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
$ee788fac11d40cfa$exports.add3L = $ee788fac11d40cfa$var$add3L;
const $ee788fac11d40cfa$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
$ee788fac11d40cfa$exports.add3H = $ee788fac11d40cfa$var$add3H;
const $ee788fac11d40cfa$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
$ee788fac11d40cfa$exports.add4L = $ee788fac11d40cfa$var$add4L;
const $ee788fac11d40cfa$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
$ee788fac11d40cfa$exports.add4H = $ee788fac11d40cfa$var$add4H;
const $ee788fac11d40cfa$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
$ee788fac11d40cfa$exports.add5L = $ee788fac11d40cfa$var$add5L;
const $ee788fac11d40cfa$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
$ee788fac11d40cfa$exports.add5H = $ee788fac11d40cfa$var$add5H;
// prettier-ignore
const $ee788fac11d40cfa$var$u64 = {
    fromBig: $ee788fac11d40cfa$var$fromBig,
    split: $ee788fac11d40cfa$var$split,
    toBig: $ee788fac11d40cfa$var$toBig,
    shrSH: $ee788fac11d40cfa$var$shrSH,
    shrSL: $ee788fac11d40cfa$var$shrSL,
    rotrSH: $ee788fac11d40cfa$var$rotrSH,
    rotrSL: $ee788fac11d40cfa$var$rotrSL,
    rotrBH: $ee788fac11d40cfa$var$rotrBH,
    rotrBL: $ee788fac11d40cfa$var$rotrBL,
    rotr32H: $ee788fac11d40cfa$var$rotr32H,
    rotr32L: $ee788fac11d40cfa$var$rotr32L,
    rotlSH: $ee788fac11d40cfa$var$rotlSH,
    rotlSL: $ee788fac11d40cfa$var$rotlSL,
    rotlBH: $ee788fac11d40cfa$var$rotlBH,
    rotlBL: $ee788fac11d40cfa$var$rotlBL,
    add: $ee788fac11d40cfa$var$add,
    add3L: $ee788fac11d40cfa$var$add3L,
    add3H: $ee788fac11d40cfa$var$add3H,
    add4L: $ee788fac11d40cfa$var$add4L,
    add4H: $ee788fac11d40cfa$var$add4H,
    add5H: $ee788fac11d40cfa$var$add5H,
    add5L: $ee788fac11d40cfa$var$add5L
};
$ee788fac11d40cfa$exports.default = $ee788fac11d40cfa$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$8f37b5eac609d302$var$SHA512_Kh, $8f37b5eac609d302$var$SHA512_Kl] = /* @__PURE__ */ (()=>$ee788fac11d40cfa$exports.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $8f37b5eac609d302$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $8f37b5eac609d302$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $8f37b5eac609d302$var$SHA512 extends $de9698a970204a80$exports.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $8f37b5eac609d302$var$SHA512_W_H[i] = view.getUint32(offset);
            $8f37b5eac609d302$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $8f37b5eac609d302$var$SHA512_W_H[i - 15] | 0;
            const W15l = $8f37b5eac609d302$var$SHA512_W_L[i - 15] | 0;
            const s0h = $ee788fac11d40cfa$exports.default.rotrSH(W15h, W15l, 1) ^ $ee788fac11d40cfa$exports.default.rotrSH(W15h, W15l, 8) ^ $ee788fac11d40cfa$exports.default.shrSH(W15h, W15l, 7);
            const s0l = $ee788fac11d40cfa$exports.default.rotrSL(W15h, W15l, 1) ^ $ee788fac11d40cfa$exports.default.rotrSL(W15h, W15l, 8) ^ $ee788fac11d40cfa$exports.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $8f37b5eac609d302$var$SHA512_W_H[i - 2] | 0;
            const W2l = $8f37b5eac609d302$var$SHA512_W_L[i - 2] | 0;
            const s1h = $ee788fac11d40cfa$exports.default.rotrSH(W2h, W2l, 19) ^ $ee788fac11d40cfa$exports.default.rotrBH(W2h, W2l, 61) ^ $ee788fac11d40cfa$exports.default.shrSH(W2h, W2l, 6);
            const s1l = $ee788fac11d40cfa$exports.default.rotrSL(W2h, W2l, 19) ^ $ee788fac11d40cfa$exports.default.rotrBL(W2h, W2l, 61) ^ $ee788fac11d40cfa$exports.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $ee788fac11d40cfa$exports.default.add4L(s0l, s1l, $8f37b5eac609d302$var$SHA512_W_L[i - 7], $8f37b5eac609d302$var$SHA512_W_L[i - 16]);
            const SUMh = $ee788fac11d40cfa$exports.default.add4H(SUMl, s0h, s1h, $8f37b5eac609d302$var$SHA512_W_H[i - 7], $8f37b5eac609d302$var$SHA512_W_H[i - 16]);
            $8f37b5eac609d302$var$SHA512_W_H[i] = SUMh | 0;
            $8f37b5eac609d302$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $ee788fac11d40cfa$exports.default.rotrSH(Eh, El, 14) ^ $ee788fac11d40cfa$exports.default.rotrSH(Eh, El, 18) ^ $ee788fac11d40cfa$exports.default.rotrBH(Eh, El, 41);
            const sigma1l = $ee788fac11d40cfa$exports.default.rotrSL(Eh, El, 14) ^ $ee788fac11d40cfa$exports.default.rotrSL(Eh, El, 18) ^ $ee788fac11d40cfa$exports.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $ee788fac11d40cfa$exports.default.add5L(Hl, sigma1l, CHIl, $8f37b5eac609d302$var$SHA512_Kl[i], $8f37b5eac609d302$var$SHA512_W_L[i]);
            const T1h = $ee788fac11d40cfa$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $8f37b5eac609d302$var$SHA512_Kh[i], $8f37b5eac609d302$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $ee788fac11d40cfa$exports.default.rotrSH(Ah, Al, 28) ^ $ee788fac11d40cfa$exports.default.rotrBH(Ah, Al, 34) ^ $ee788fac11d40cfa$exports.default.rotrBH(Ah, Al, 39);
            const sigma0l = $ee788fac11d40cfa$exports.default.rotrSL(Ah, Al, 28) ^ $ee788fac11d40cfa$exports.default.rotrBL(Ah, Al, 34) ^ $ee788fac11d40cfa$exports.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $ee788fac11d40cfa$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $ee788fac11d40cfa$exports.default.add3L(T1l, sigma0l, MAJl);
            Ah = $ee788fac11d40cfa$exports.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $ee788fac11d40cfa$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $ee788fac11d40cfa$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $ee788fac11d40cfa$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $ee788fac11d40cfa$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $ee788fac11d40cfa$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $ee788fac11d40cfa$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $ee788fac11d40cfa$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $ee788fac11d40cfa$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $8f37b5eac609d302$var$SHA512_W_H.fill(0);
        $8f37b5eac609d302$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$8f37b5eac609d302$exports.SHA512 = $8f37b5eac609d302$var$SHA512;
class $8f37b5eac609d302$var$SHA512_224 extends $8f37b5eac609d302$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $8f37b5eac609d302$var$SHA512_256 extends $8f37b5eac609d302$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $8f37b5eac609d302$var$SHA384 extends $8f37b5eac609d302$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
$8f37b5eac609d302$exports.sha512 = (0, $743f5b81a9da9842$exports.wrapConstructor)(()=>new $8f37b5eac609d302$var$SHA512());
$8f37b5eac609d302$exports.sha512_224 = (0, $743f5b81a9da9842$exports.wrapConstructor)(()=>new $8f37b5eac609d302$var$SHA512_224());
$8f37b5eac609d302$exports.sha512_256 = (0, $743f5b81a9da9842$exports.wrapConstructor)(()=>new $8f37b5eac609d302$var$SHA512_256());
$8f37b5eac609d302$exports.sha384 = (0, $743f5b81a9da9842$exports.wrapConstructor)(()=>new $8f37b5eac609d302$var$SHA384());



function $6603c32e88d7675b$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $6603c32e88d7675b$var$anyGlobal = $6603c32e88d7675b$var$getGlobal();
const $6603c32e88d7675b$var$crypto = $6603c32e88d7675b$var$anyGlobal.crypto || $6603c32e88d7675b$var$anyGlobal.msCrypto;
function $6603c32e88d7675b$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $40745d2159d0279c$exports.sha256).create();
        case "sha512":
            return (0, $8f37b5eac609d302$exports.sha512).create();
    }
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $6603c32e88d7675b$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $40745d2159d0279c$exports.sha256,
        sha512: $8f37b5eac609d302$exports.sha512
    }[_algo];
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $94b2278aec7365b2$exports.hmac).create(algo, key);
}
function $6603c32e88d7675b$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $40745d2159d0279c$exports.sha256,
        sha512: $8f37b5eac609d302$exports.sha512
    }[_algo];
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $2616fcc4c438dd8b$exports.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $6603c32e88d7675b$export$5f828d93ff035aa8(length) {
    (0, $bb8e52d338877b37$export$a7a9523472993e97)($6603c32e88d7675b$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $6603c32e88d7675b$var$crypto.getRandomValues(result);
    return result;
}



let $e423d9237c6b8e93$var$locked = false;
const $e423d9237c6b8e93$var$_computeHmac = function(algorithm, key, data) {
    return (0, $6603c32e88d7675b$export$da39cf97e1eb7c91)(algorithm, key).update(data).digest();
};
let $e423d9237c6b8e93$var$__computeHmac = $e423d9237c6b8e93$var$_computeHmac;
function $e423d9237c6b8e93$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_key, "key");
    const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_data, "data");
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)($e423d9237c6b8e93$var$__computeHmac(algorithm, key, data));
}
$e423d9237c6b8e93$export$967075d2f3b8e7ff._ = $e423d9237c6b8e93$var$_computeHmac;
$e423d9237c6b8e93$export$967075d2f3b8e7ff.lock = function() {
    $e423d9237c6b8e93$var$locked = true;
};
$e423d9237c6b8e93$export$967075d2f3b8e7ff.register = function(func) {
    if ($e423d9237c6b8e93$var$locked) throw new Error("computeHmac is locked");
    $e423d9237c6b8e93$var$__computeHmac = func;
};
Object.freeze($e423d9237c6b8e93$export$967075d2f3b8e7ff);


/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ var $329119b7dc8a61e5$exports = {};
"use strict";
Object.defineProperty($329119b7dc8a61e5$exports, "__esModule", {
    value: true
});
$329119b7dc8a61e5$exports.shake256 = $329119b7dc8a61e5$exports.shake128 = $329119b7dc8a61e5$exports.keccak_512 = $329119b7dc8a61e5$exports.keccak_384 = $329119b7dc8a61e5$exports.keccak_256 = $329119b7dc8a61e5$exports.keccak_224 = $329119b7dc8a61e5$exports.sha3_512 = $329119b7dc8a61e5$exports.sha3_384 = $329119b7dc8a61e5$exports.sha3_256 = $329119b7dc8a61e5$exports.sha3_224 = $329119b7dc8a61e5$exports.Keccak = $329119b7dc8a61e5$exports.keccakP = void 0;



// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$329119b7dc8a61e5$var$SHA3_PI, $329119b7dc8a61e5$var$SHA3_ROTL, $329119b7dc8a61e5$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $329119b7dc8a61e5$var$_0n = /* @__PURE__ */ BigInt(0);
const $329119b7dc8a61e5$var$_1n = /* @__PURE__ */ BigInt(1);
const $329119b7dc8a61e5$var$_2n = /* @__PURE__ */ BigInt(2);
const $329119b7dc8a61e5$var$_7n = /* @__PURE__ */ BigInt(7);
const $329119b7dc8a61e5$var$_256n = /* @__PURE__ */ BigInt(256);
const $329119b7dc8a61e5$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $329119b7dc8a61e5$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $329119b7dc8a61e5$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $329119b7dc8a61e5$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $329119b7dc8a61e5$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $329119b7dc8a61e5$var$_1n ^ (R >> $329119b7dc8a61e5$var$_7n) * $329119b7dc8a61e5$var$_0x71n) % $329119b7dc8a61e5$var$_256n;
        if (R & $329119b7dc8a61e5$var$_2n) t ^= $329119b7dc8a61e5$var$_1n << ($329119b7dc8a61e5$var$_1n << /* @__PURE__ */ BigInt(j)) - $329119b7dc8a61e5$var$_1n;
    }
    $329119b7dc8a61e5$var$_SHA3_IOTA.push(t);
}
const [$329119b7dc8a61e5$var$SHA3_IOTA_H, $329119b7dc8a61e5$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $ee788fac11d40cfa$exports.split)($329119b7dc8a61e5$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $329119b7dc8a61e5$var$rotlH = (h, l, s)=>s > 32 ? (0, $ee788fac11d40cfa$exports.rotlBH)(h, l, s) : (0, $ee788fac11d40cfa$exports.rotlSH)(h, l, s);
const $329119b7dc8a61e5$var$rotlL = (h, l, s)=>s > 32 ? (0, $ee788fac11d40cfa$exports.rotlBL)(h, l, s) : (0, $ee788fac11d40cfa$exports.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $329119b7dc8a61e5$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $329119b7dc8a61e5$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $329119b7dc8a61e5$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $329119b7dc8a61e5$var$SHA3_ROTL[t];
            const Th = $329119b7dc8a61e5$var$rotlH(curH, curL, shift);
            const Tl = $329119b7dc8a61e5$var$rotlL(curH, curL, shift);
            const PI = $329119b7dc8a61e5$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $329119b7dc8a61e5$var$SHA3_IOTA_H[round];
        s[1] ^= $329119b7dc8a61e5$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
$329119b7dc8a61e5$exports.keccakP = $329119b7dc8a61e5$var$keccakP;
class $329119b7dc8a61e5$var$Keccak extends $743f5b81a9da9842$exports.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $12bfbb86ba5aff13$exports.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $743f5b81a9da9842$exports.u32)(this.state);
    }
    keccak() {
        $329119b7dc8a61e5$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $12bfbb86ba5aff13$exports.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $743f5b81a9da9842$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $12bfbb86ba5aff13$exports.exists)(this, false);
        (0, $12bfbb86ba5aff13$exports.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $12bfbb86ba5aff13$exports.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $12bfbb86ba5aff13$exports.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $329119b7dc8a61e5$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
$329119b7dc8a61e5$exports.Keccak = $329119b7dc8a61e5$var$Keccak;
const $329119b7dc8a61e5$var$gen = (suffix, blockLen, outputLen)=>(0, $743f5b81a9da9842$exports.wrapConstructor)(()=>new $329119b7dc8a61e5$var$Keccak(blockLen, suffix, outputLen));
$329119b7dc8a61e5$exports.sha3_224 = $329119b7dc8a61e5$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ $329119b7dc8a61e5$exports.sha3_256 = $329119b7dc8a61e5$var$gen(0x06, 136, 32);
$329119b7dc8a61e5$exports.sha3_384 = $329119b7dc8a61e5$var$gen(0x06, 104, 48);
$329119b7dc8a61e5$exports.sha3_512 = $329119b7dc8a61e5$var$gen(0x06, 72, 64);
$329119b7dc8a61e5$exports.keccak_224 = $329119b7dc8a61e5$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ $329119b7dc8a61e5$exports.keccak_256 = $329119b7dc8a61e5$var$gen(0x01, 136, 32);
$329119b7dc8a61e5$exports.keccak_384 = $329119b7dc8a61e5$var$gen(0x01, 104, 48);
$329119b7dc8a61e5$exports.keccak_512 = $329119b7dc8a61e5$var$gen(0x01, 72, 64);
const $329119b7dc8a61e5$var$genShake = (suffix, blockLen, outputLen)=>(0, $743f5b81a9da9842$exports.wrapXOFConstructorWithOpts)((opts = {})=>new $329119b7dc8a61e5$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
$329119b7dc8a61e5$exports.shake128 = $329119b7dc8a61e5$var$genShake(0x1f, 168, 16);
$329119b7dc8a61e5$exports.shake256 = $329119b7dc8a61e5$var$genShake(0x1f, 136, 32);



let $eb8e34a59f49e216$var$locked = false;
const $eb8e34a59f49e216$var$_keccak256 = function(data) {
    return (0, $329119b7dc8a61e5$exports.keccak_256)(data);
};
let $eb8e34a59f49e216$var$__keccak256 = $eb8e34a59f49e216$var$_keccak256;
function $eb8e34a59f49e216$export$f8151fce47ad1c35(_data) {
    const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_data, "data");
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)($eb8e34a59f49e216$var$__keccak256(data));
}
$eb8e34a59f49e216$export$f8151fce47ad1c35._ = $eb8e34a59f49e216$var$_keccak256;
$eb8e34a59f49e216$export$f8151fce47ad1c35.lock = function() {
    $eb8e34a59f49e216$var$locked = true;
};
$eb8e34a59f49e216$export$f8151fce47ad1c35.register = function(func) {
    if ($eb8e34a59f49e216$var$locked) throw new TypeError("keccak256 is locked");
    $eb8e34a59f49e216$var$__keccak256 = func;
};
Object.freeze($eb8e34a59f49e216$export$f8151fce47ad1c35);


var $8b3ad3423c825612$exports = {};
"use strict";
Object.defineProperty($8b3ad3423c825612$exports, "__esModule", {
    value: true
});
$8b3ad3423c825612$exports.ripemd160 = $8b3ad3423c825612$exports.RIPEMD160 = void 0;


// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $8b3ad3423c825612$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $8b3ad3423c825612$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $8b3ad3423c825612$var$Pi = /* @__PURE__ */ $8b3ad3423c825612$var$Id.map((i)=>(9 * i + 5) % 16);
let $8b3ad3423c825612$var$idxL = [
    $8b3ad3423c825612$var$Id
];
let $8b3ad3423c825612$var$idxR = [
    $8b3ad3423c825612$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $8b3ad3423c825612$var$idxL,
    $8b3ad3423c825612$var$idxR
])j.push(j[i].map((k)=>$8b3ad3423c825612$var$Rho[k]));
const $8b3ad3423c825612$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $8b3ad3423c825612$var$shiftsL = /* @__PURE__ */ $8b3ad3423c825612$var$idxL.map((idx, i)=>idx.map((j)=>$8b3ad3423c825612$var$shifts[i][j]));
const $8b3ad3423c825612$var$shiftsR = /* @__PURE__ */ $8b3ad3423c825612$var$idxR.map((idx, i)=>idx.map((j)=>$8b3ad3423c825612$var$shifts[i][j]));
const $8b3ad3423c825612$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $8b3ad3423c825612$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $8b3ad3423c825612$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $8b3ad3423c825612$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $8b3ad3423c825612$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $8b3ad3423c825612$var$RIPEMD160 extends $de9698a970204a80$exports.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$8b3ad3423c825612$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $8b3ad3423c825612$var$Kl[group], hbr = $8b3ad3423c825612$var$Kr[group]; // prettier-ignore
            const rl = $8b3ad3423c825612$var$idxL[group], rr = $8b3ad3423c825612$var$idxR[group]; // prettier-ignore
            const sl = $8b3ad3423c825612$var$shiftsL[group], sr = $8b3ad3423c825612$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $8b3ad3423c825612$var$rotl(al + $8b3ad3423c825612$var$f(group, bl, cl, dl) + $8b3ad3423c825612$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $8b3ad3423c825612$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $8b3ad3423c825612$var$rotl(ar + $8b3ad3423c825612$var$f(rGroup, br, cr, dr) + $8b3ad3423c825612$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $8b3ad3423c825612$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $8b3ad3423c825612$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
$8b3ad3423c825612$exports.RIPEMD160 = $8b3ad3423c825612$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ $8b3ad3423c825612$exports.ripemd160 = (0, $743f5b81a9da9842$exports.wrapConstructor)(()=>new $8b3ad3423c825612$var$RIPEMD160());



let $c6fe99323c2965cd$var$locked = false;
const $c6fe99323c2965cd$var$_ripemd160 = function(data) {
    return (0, $8b3ad3423c825612$exports.ripemd160)(data);
};
let $c6fe99323c2965cd$var$__ripemd160 = $c6fe99323c2965cd$var$_ripemd160;
function $c6fe99323c2965cd$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_data, "data");
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)($c6fe99323c2965cd$var$__ripemd160(data));
}
$c6fe99323c2965cd$export$d1cea0ee4e3f0d3e._ = $c6fe99323c2965cd$var$_ripemd160;
$c6fe99323c2965cd$export$d1cea0ee4e3f0d3e.lock = function() {
    $c6fe99323c2965cd$var$locked = true;
};
$c6fe99323c2965cd$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($c6fe99323c2965cd$var$locked) throw new TypeError("ripemd160 is locked");
    $c6fe99323c2965cd$var$__ripemd160 = func;
};
Object.freeze($c6fe99323c2965cd$export$d1cea0ee4e3f0d3e);


/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 

let $b08c23dad829fb20$var$locked = false;
const $b08c23dad829fb20$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $6603c32e88d7675b$export$b80c7ba289c8fa56)(password, salt, iterations, keylen, algo);
};
let $b08c23dad829fb20$var$__pbkdf2 = $b08c23dad829fb20$var$_pbkdf2;
function $b08c23dad829fb20$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_password, "password");
    const salt = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)($b08c23dad829fb20$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$b08c23dad829fb20$export$448fa22aedc9dbca._ = $b08c23dad829fb20$var$_pbkdf2;
$b08c23dad829fb20$export$448fa22aedc9dbca.lock = function() {
    $b08c23dad829fb20$var$locked = true;
};
$b08c23dad829fb20$export$448fa22aedc9dbca.register = function(func) {
    if ($b08c23dad829fb20$var$locked) throw new Error("pbkdf2 is locked");
    $b08c23dad829fb20$var$__pbkdf2 = func;
};
Object.freeze($b08c23dad829fb20$export$448fa22aedc9dbca);


/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
let $e2899165f684d722$var$locked = false;
const $e2899165f684d722$var$_randomBytes = function(length) {
    return new Uint8Array((0, $6603c32e88d7675b$export$5f828d93ff035aa8)(length));
};
let $e2899165f684d722$var$__randomBytes = $e2899165f684d722$var$_randomBytes;
function $e2899165f684d722$export$5f828d93ff035aa8(length) {
    return $e2899165f684d722$var$__randomBytes(length);
}
$e2899165f684d722$export$5f828d93ff035aa8._ = $e2899165f684d722$var$_randomBytes;
$e2899165f684d722$export$5f828d93ff035aa8.lock = function() {
    $e2899165f684d722$var$locked = true;
};
$e2899165f684d722$export$5f828d93ff035aa8.register = function(func) {
    if ($e2899165f684d722$var$locked) throw new Error("randomBytes is locked");
    $e2899165f684d722$var$__randomBytes = func;
};
Object.freeze($e2899165f684d722$export$5f828d93ff035aa8);


var $59c277def1948657$exports = {};
"use strict";
Object.defineProperty($59c277def1948657$exports, "__esModule", {
    value: true
});
$59c277def1948657$exports.scryptAsync = $59c277def1948657$exports.scrypt = void 0;




// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $59c277def1948657$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $59c277def1948657$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $59c277def1948657$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $59c277def1948657$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $59c277def1948657$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $59c277def1948657$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $59c277def1948657$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $59c277def1948657$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $59c277def1948657$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $59c277def1948657$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $59c277def1948657$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $59c277def1948657$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $59c277def1948657$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $59c277def1948657$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $59c277def1948657$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $59c277def1948657$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $59c277def1948657$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $59c277def1948657$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $59c277def1948657$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $59c277def1948657$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $59c277def1948657$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $59c277def1948657$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $59c277def1948657$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $59c277def1948657$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $59c277def1948657$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $59c277def1948657$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $59c277def1948657$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $59c277def1948657$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $59c277def1948657$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $59c277def1948657$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $59c277def1948657$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $59c277def1948657$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $59c277def1948657$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $59c277def1948657$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $59c277def1948657$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $59c277def1948657$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $59c277def1948657$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $59c277def1948657$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $743f5b81a9da9842$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $12bfbb86ba5aff13$exports.number)(N);
    (0, $12bfbb86ba5aff13$exports.number)(r);
    (0, $12bfbb86ba5aff13$exports.number)(p);
    (0, $12bfbb86ba5aff13$exports.number)(dkLen);
    (0, $12bfbb86ba5aff13$exports.number)(asyncTick);
    (0, $12bfbb86ba5aff13$exports.number)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $2616fcc4c438dd8b$exports.pbkdf2)($40745d2159d0279c$exports.sha256, password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $743f5b81a9da9842$exports.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $743f5b81a9da9842$exports.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $743f5b81a9da9842$exports.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $59c277def1948657$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $2616fcc4c438dd8b$exports.pbkdf2)($40745d2159d0279c$exports.sha256, password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
/**
 * Scrypt KDF from RFC 7914.
 * @param password - pass
 * @param salt - salt
 * @param opts - parameters
 * - `N` is cpu/mem work factor (power of 2 e.g. 2**18)
 * - `r` is block size (8 is common), fine-tunes sequential memory read size and performance
 * - `p` is parallelization factor (1 is common)
 * - `dkLen` is output key length in bytes e.g. 32.
 * - `asyncTick` - (default: 10) max time in ms for which async function can block execution
 * - `maxmem` - (default: `1024 ** 3 + 1024` aka 1GB+1KB). A limit that the app could use for scrypt
 * - `onProgress` - callback function that would be executed for progress report
 * @returns Derived key
 */ function $59c277def1948657$var$scrypt(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $59c277def1948657$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $59c277def1948657$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $59c277def1948657$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $59c277def1948657$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $59c277def1948657$var$scryptOutput(password, dkLen, B, V, tmp);
}
$59c277def1948657$exports.scrypt = $59c277def1948657$var$scrypt;
/**
 * Scrypt KDF from RFC 7914.
 */ async function $59c277def1948657$var$scryptAsync(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $59c277def1948657$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $743f5b81a9da9842$exports.asyncLoop)(N - 1, asyncTick, ()=>{
            $59c277def1948657$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $59c277def1948657$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $743f5b81a9da9842$exports.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $59c277def1948657$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $59c277def1948657$var$scryptOutput(password, dkLen, B, V, tmp);
}
$59c277def1948657$exports.scryptAsync = $59c277def1948657$var$scryptAsync;



let $d040a4c743127b7f$var$lockedSync = false, $d040a4c743127b7f$var$lockedAsync = false;
const $d040a4c743127b7f$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $59c277def1948657$exports.scryptAsync)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $d040a4c743127b7f$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $59c277def1948657$exports.scrypt)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $d040a4c743127b7f$var$__scryptAsync = $d040a4c743127b7f$var$_scryptAsync;
let $d040a4c743127b7f$var$__scryptSync = $d040a4c743127b7f$var$_scryptSync;
async function $d040a4c743127b7f$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(await $d040a4c743127b7f$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$d040a4c743127b7f$export$7cf7c2f1ec457bf3._ = $d040a4c743127b7f$var$_scryptAsync;
$d040a4c743127b7f$export$7cf7c2f1ec457bf3.lock = function() {
    $d040a4c743127b7f$var$lockedAsync = true;
};
$d040a4c743127b7f$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($d040a4c743127b7f$var$lockedAsync) throw new Error("scrypt is locked");
    $d040a4c743127b7f$var$__scryptAsync = func;
};
Object.freeze($d040a4c743127b7f$export$7cf7c2f1ec457bf3);
function $d040a4c743127b7f$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)($d040a4c743127b7f$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$d040a4c743127b7f$export$86c79e0734c26a76._ = $d040a4c743127b7f$var$_scryptSync;
$d040a4c743127b7f$export$86c79e0734c26a76.lock = function() {
    $d040a4c743127b7f$var$lockedSync = true;
};
$d040a4c743127b7f$export$86c79e0734c26a76.register = function(func) {
    if ($d040a4c743127b7f$var$lockedSync) throw new Error("scryptSync is locked");
    $d040a4c743127b7f$var$__scryptSync = func;
};
Object.freeze($d040a4c743127b7f$export$86c79e0734c26a76);




const $d318730f8de39247$var$_sha256 = function(data) {
    return (0, $6603c32e88d7675b$export$2fb37efbf6ae0c0e)("sha256").update(data).digest();
};
const $d318730f8de39247$var$_sha512 = function(data) {
    return (0, $6603c32e88d7675b$export$2fb37efbf6ae0c0e)("sha512").update(data).digest();
};
let $d318730f8de39247$var$__sha256 = $d318730f8de39247$var$_sha256;
let $d318730f8de39247$var$__sha512 = $d318730f8de39247$var$_sha512;
let $d318730f8de39247$var$locked256 = false, $d318730f8de39247$var$locked512 = false;
function $d318730f8de39247$export$bced8d2aada2d1c9(_data) {
    const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_data, "data");
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)($d318730f8de39247$var$__sha256(data));
}
$d318730f8de39247$export$bced8d2aada2d1c9._ = $d318730f8de39247$var$_sha256;
$d318730f8de39247$export$bced8d2aada2d1c9.lock = function() {
    $d318730f8de39247$var$locked256 = true;
};
$d318730f8de39247$export$bced8d2aada2d1c9.register = function(func) {
    if ($d318730f8de39247$var$locked256) throw new Error("sha256 is locked");
    $d318730f8de39247$var$__sha256 = func;
};
Object.freeze($d318730f8de39247$export$bced8d2aada2d1c9);
function $d318730f8de39247$export$a888d2532e6dc7bb(_data) {
    const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_data, "data");
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)($d318730f8de39247$var$__sha512(data));
}
$d318730f8de39247$export$a888d2532e6dc7bb._ = $d318730f8de39247$var$_sha512;
$d318730f8de39247$export$a888d2532e6dc7bb.lock = function() {
    $d318730f8de39247$var$locked512 = true;
};
$d318730f8de39247$export$a888d2532e6dc7bb.register = function(func) {
    if ($d318730f8de39247$var$locked512) throw new Error("sha512 is locked");
    $d318730f8de39247$var$__sha512 = func;
};
Object.freeze($d318730f8de39247$export$bced8d2aada2d1c9);


/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ var $5765a1182d26d576$exports = {};
"use strict";
Object.defineProperty($5765a1182d26d576$exports, "__esModule", {
    value: true
});
$5765a1182d26d576$exports.encodeToCurve = $5765a1182d26d576$exports.hashToCurve = $5765a1182d26d576$exports.schnorr = $5765a1182d26d576$exports.secp256k1 = void 0;



var $i945l = parcelRequire("i945l");
var $55a0bac5c8bffc9a$exports = {};
"use strict";
Object.defineProperty($55a0bac5c8bffc9a$exports, "__esModule", {
    value: true
});
$55a0bac5c8bffc9a$exports.mapToCurveSimpleSWU = $55a0bac5c8bffc9a$exports.SWUFpSqrtRatio = $55a0bac5c8bffc9a$exports.weierstrass = $55a0bac5c8bffc9a$exports.weierstrassPoints = $55a0bac5c8bffc9a$exports.DER = void 0;

var $i945l = parcelRequire("i945l");

var $1GzxI = parcelRequire("1GzxI");

var $1GzxI = parcelRequire("1GzxI");

var $kswOL = parcelRequire("kswOL");
function $55a0bac5c8bffc9a$var$validatePointOpts(curve) {
    const opts = (0, $kswOL.validateBasic)(curve);
    $1GzxI.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $55a0bac5c8bffc9a$var$b2n, hexToBytes: $55a0bac5c8bffc9a$var$h2b } = $1GzxI;
$55a0bac5c8bffc9a$exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $55a0bac5c8bffc9a$exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $55a0bac5c8bffc9a$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $55a0bac5c8bffc9a$exports.DER;
        const data = typeof hex === "string" ? $55a0bac5c8bffc9a$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $55a0bac5c8bffc9a$exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $55a0bac5c8bffc9a$exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $55a0bac5c8bffc9a$var$_0n = BigInt(0), $55a0bac5c8bffc9a$var$_1n = BigInt(1), $55a0bac5c8bffc9a$var$_2n = BigInt(2), $55a0bac5c8bffc9a$var$_3n = BigInt(3), $55a0bac5c8bffc9a$var$_4n = BigInt(4);
function $55a0bac5c8bffc9a$var$weierstrassPoints(opts) {
    const CURVE = $55a0bac5c8bffc9a$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $1GzxI.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $55a0bac5c8bffc9a$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $1GzxI.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $1GzxI.bytesToNumberBE((0, $1GzxI.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $i945l.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $1GzxI.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $55a0bac5c8bffc9a$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $55a0bac5c8bffc9a$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $55a0bac5c8bffc9a$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $55a0bac5c8bffc9a$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $55a0bac5c8bffc9a$var$_0n || k2 > $55a0bac5c8bffc9a$var$_0n){
                if (k1 & $55a0bac5c8bffc9a$var$_1n) k1p = k1p.add(d);
                if (k2 & $55a0bac5c8bffc9a$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $55a0bac5c8bffc9a$var$_1n;
                k2 >>= $55a0bac5c8bffc9a$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $55a0bac5c8bffc9a$var$_0n || a === $55a0bac5c8bffc9a$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $55a0bac5c8bffc9a$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $55a0bac5c8bffc9a$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $1GzxI.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $kswOL.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
$55a0bac5c8bffc9a$exports.weierstrassPoints = $55a0bac5c8bffc9a$var$weierstrassPoints;
function $55a0bac5c8bffc9a$var$validateOpts(curve) {
    const opts = (0, $kswOL.validateBasic)(curve);
    $1GzxI.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $55a0bac5c8bffc9a$var$weierstrass(curveDef) {
    const CURVE = $55a0bac5c8bffc9a$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $55a0bac5c8bffc9a$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $i945l.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $i945l.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $55a0bac5c8bffc9a$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $1GzxI.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $1GzxI.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $55a0bac5c8bffc9a$var$_1n) === $55a0bac5c8bffc9a$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$1GzxI.bytesToHex($1GzxI.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $55a0bac5c8bffc9a$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$1GzxI.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $1GzxI.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $55a0bac5c8bffc9a$exports.DER.toSig((0, $1GzxI.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $1GzxI.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $1GzxI.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $55a0bac5c8bffc9a$exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $1GzxI.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $i945l.getMinHashLength(CURVE.n);
            return $i945l.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $1GzxI.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $1GzxI.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($55a0bac5c8bffc9a$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $1GzxI.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $1GzxI.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $1GzxI.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $1GzxI.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $1GzxI.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $55a0bac5c8bffc9a$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $55a0bac5c8bffc9a$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $55a0bac5c8bffc9a$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $1GzxI.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $1GzxI.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $1GzxI.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $55a0bac5c8bffc9a$exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
$55a0bac5c8bffc9a$exports.weierstrass = $55a0bac5c8bffc9a$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $55a0bac5c8bffc9a$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $55a0bac5c8bffc9a$var$_0n;
    for(let o = q - $55a0bac5c8bffc9a$var$_1n; o % $55a0bac5c8bffc9a$var$_2n === $55a0bac5c8bffc9a$var$_0n; o /= $55a0bac5c8bffc9a$var$_2n)l += $55a0bac5c8bffc9a$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $55a0bac5c8bffc9a$var$_2n << c1 - $55a0bac5c8bffc9a$var$_1n - $55a0bac5c8bffc9a$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $55a0bac5c8bffc9a$var$_2n;
    const c2 = (q - $55a0bac5c8bffc9a$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $55a0bac5c8bffc9a$var$_1n) / $55a0bac5c8bffc9a$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $55a0bac5c8bffc9a$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $55a0bac5c8bffc9a$var$_1n) / $55a0bac5c8bffc9a$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $55a0bac5c8bffc9a$var$_1n; i--){
            let tv5 = i - $55a0bac5c8bffc9a$var$_2n; // 18.    tv5 = i - 2
            tv5 = $55a0bac5c8bffc9a$var$_2n << tv5 - $55a0bac5c8bffc9a$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $55a0bac5c8bffc9a$var$_4n === $55a0bac5c8bffc9a$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $55a0bac5c8bffc9a$var$_3n) / $55a0bac5c8bffc9a$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
$55a0bac5c8bffc9a$exports.SWUFpSqrtRatio = $55a0bac5c8bffc9a$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $55a0bac5c8bffc9a$var$mapToCurveSimpleSWU(Fp, opts) {
    $i945l.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $55a0bac5c8bffc9a$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
$55a0bac5c8bffc9a$exports.mapToCurveSimpleSWU = $55a0bac5c8bffc9a$var$mapToCurveSimpleSWU;



var $1GzxI = parcelRequire("1GzxI");
var $3b9801ed630d510a$exports = {};
"use strict";
Object.defineProperty($3b9801ed630d510a$exports, "__esModule", {
    value: true
});
$3b9801ed630d510a$exports.createHasher = $3b9801ed630d510a$exports.isogenyMap = $3b9801ed630d510a$exports.hash_to_field = $3b9801ed630d510a$exports.expand_message_xof = $3b9801ed630d510a$exports.expand_message_xmd = void 0;

var $i945l = parcelRequire("i945l");

var $1GzxI = parcelRequire("1GzxI");
function $3b9801ed630d510a$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $1GzxI.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $3b9801ed630d510a$var$os2ip = $1GzxI.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $3b9801ed630d510a$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $3b9801ed630d510a$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $3b9801ed630d510a$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $3b9801ed630d510a$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $3b9801ed630d510a$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $3b9801ed630d510a$var$isBytes(msg);
    $3b9801ed630d510a$var$isBytes(DST);
    $3b9801ed630d510a$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $1GzxI.concatBytes)((0, $1GzxI.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $1GzxI.concatBytes)(DST, $3b9801ed630d510a$var$i2osp(DST.length, 1));
    const Z_pad = $3b9801ed630d510a$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $3b9801ed630d510a$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $1GzxI.concatBytes)(Z_pad, msg, l_i_b_str, $3b9801ed630d510a$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $1GzxI.concatBytes)(b_0, $3b9801ed630d510a$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $3b9801ed630d510a$var$strxor(b_0, b[i - 1]),
            $3b9801ed630d510a$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $1GzxI.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $1GzxI.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
$3b9801ed630d510a$exports.expand_message_xmd = $3b9801ed630d510a$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $3b9801ed630d510a$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $3b9801ed630d510a$var$isBytes(msg);
    $3b9801ed630d510a$var$isBytes(DST);
    $3b9801ed630d510a$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $1GzxI.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($3b9801ed630d510a$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($3b9801ed630d510a$var$i2osp(DST.length, 1)).digest();
}
$3b9801ed630d510a$exports.expand_message_xof = $3b9801ed630d510a$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $3b9801ed630d510a$var$hash_to_field(msg, count, options) {
    (0, $1GzxI.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $3b9801ed630d510a$var$isBytes(msg);
    $3b9801ed630d510a$var$isNum(count);
    const DST = $3b9801ed630d510a$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $3b9801ed630d510a$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $3b9801ed630d510a$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $i945l.mod)($3b9801ed630d510a$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
$3b9801ed630d510a$exports.hash_to_field = $3b9801ed630d510a$var$hash_to_field;
function $3b9801ed630d510a$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
$3b9801ed630d510a$exports.isogenyMap = $3b9801ed630d510a$var$isogenyMap;
function $3b9801ed630d510a$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $3b9801ed630d510a$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $3b9801ed630d510a$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
$3b9801ed630d510a$exports.createHasher = $3b9801ed630d510a$var$createHasher;


var $1b2871fdba5348e8$exports = {};
"use strict";
Object.defineProperty($1b2871fdba5348e8$exports, "__esModule", {
    value: true
});
$1b2871fdba5348e8$exports.createCurve = $1b2871fdba5348e8$exports.getHash = void 0;



// connects noble-curves to noble-hashes
function $1b2871fdba5348e8$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $94b2278aec7365b2$exports.hmac)(hash, key, (0, $743f5b81a9da9842$exports.concatBytes)(...msgs)),
        randomBytes: $743f5b81a9da9842$exports.randomBytes
    };
}
$1b2871fdba5348e8$exports.getHash = $1b2871fdba5348e8$var$getHash;
function $1b2871fdba5348e8$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $55a0bac5c8bffc9a$exports.weierstrass)({
            ...curveDef,
            ...$1b2871fdba5348e8$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
$1b2871fdba5348e8$exports.createCurve = $1b2871fdba5348e8$var$createCurve;


const $5765a1182d26d576$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $5765a1182d26d576$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $5765a1182d26d576$var$_1n = BigInt(1);
const $5765a1182d26d576$var$_2n = BigInt(2);
const $5765a1182d26d576$var$divNearest = (a, b)=>(a + b / $5765a1182d26d576$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $5765a1182d26d576$var$sqrtMod(y) {
    const P = $5765a1182d26d576$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $i945l.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $i945l.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $i945l.pow2)(b9, $5765a1182d26d576$var$_2n, P) * b2 % P;
    const b22 = (0, $i945l.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $i945l.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $i945l.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $i945l.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $i945l.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $i945l.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $i945l.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $i945l.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $i945l.pow2)(t2, $5765a1182d26d576$var$_2n, P);
    if (!$5765a1182d26d576$var$Fp.eql($5765a1182d26d576$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $5765a1182d26d576$var$Fp = (0, $i945l.Field)($5765a1182d26d576$var$secp256k1P, undefined, undefined, {
    sqrt: $5765a1182d26d576$var$sqrtMod
});
$5765a1182d26d576$exports.secp256k1 = (0, $1b2871fdba5348e8$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $5765a1182d26d576$var$Fp,
    n: $5765a1182d26d576$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $5765a1182d26d576$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$5765a1182d26d576$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $5765a1182d26d576$var$divNearest(b2 * k, n);
            const c2 = $5765a1182d26d576$var$divNearest(-b1 * k, n);
            let k1 = (0, $i945l.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $i945l.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $40745d2159d0279c$exports.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $5765a1182d26d576$var$_0n = BigInt(0);
const $5765a1182d26d576$var$fe = (x)=>typeof x === "bigint" && $5765a1182d26d576$var$_0n < x && x < $5765a1182d26d576$var$secp256k1P;
const $5765a1182d26d576$var$ge = (x)=>typeof x === "bigint" && $5765a1182d26d576$var$_0n < x && x < $5765a1182d26d576$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $5765a1182d26d576$var$TAGGED_HASH_PREFIXES = {};
function $5765a1182d26d576$var$taggedHash(tag, ...messages) {
    let tagP = $5765a1182d26d576$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $40745d2159d0279c$exports.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $1GzxI.concatBytes)(tagH, tagH);
        $5765a1182d26d576$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $40745d2159d0279c$exports.sha256)((0, $1GzxI.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $5765a1182d26d576$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $5765a1182d26d576$var$numTo32b = (n)=>(0, $1GzxI.numberToBytesBE)(n, 32);
const $5765a1182d26d576$var$modP = (x)=>(0, $i945l.mod)(x, $5765a1182d26d576$var$secp256k1P);
const $5765a1182d26d576$var$modN = (x)=>(0, $i945l.mod)(x, $5765a1182d26d576$var$secp256k1N);
const $5765a1182d26d576$var$Point = $5765a1182d26d576$exports.secp256k1.ProjectivePoint;
const $5765a1182d26d576$var$GmulAdd = (Q, a, b)=>$5765a1182d26d576$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $5765a1182d26d576$var$schnorrGetExtPubKey(priv) {
    let d_ = $5765a1182d26d576$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $5765a1182d26d576$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $5765a1182d26d576$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $5765a1182d26d576$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $5765a1182d26d576$var$lift_x(x) {
    if (!$5765a1182d26d576$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $5765a1182d26d576$var$modP(x * x);
    const c = $5765a1182d26d576$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $5765a1182d26d576$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $5765a1182d26d576$var$_2n !== $5765a1182d26d576$var$_0n) y = $5765a1182d26d576$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $5765a1182d26d576$var$Point(x, y, $5765a1182d26d576$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $5765a1182d26d576$var$challenge(...args) {
    return $5765a1182d26d576$var$modN((0, $1GzxI.bytesToNumberBE)($5765a1182d26d576$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $5765a1182d26d576$var$schnorrGetPublicKey(privateKey) {
    return $5765a1182d26d576$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $5765a1182d26d576$var$schnorrSign(message, privateKey, auxRand = (0, $743f5b81a9da9842$exports.randomBytes)(32)) {
    const m = (0, $1GzxI.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $5765a1182d26d576$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $1GzxI.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $5765a1182d26d576$var$numTo32b(d ^ (0, $1GzxI.bytesToNumberBE)($5765a1182d26d576$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $5765a1182d26d576$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $5765a1182d26d576$var$modN((0, $1GzxI.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $5765a1182d26d576$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $5765a1182d26d576$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $5765a1182d26d576$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($5765a1182d26d576$var$numTo32b($5765a1182d26d576$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$5765a1182d26d576$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $5765a1182d26d576$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $1GzxI.ensureBytes)("signature", signature, 64);
    const m = (0, $1GzxI.ensureBytes)("message", message);
    const pub = (0, $1GzxI.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $5765a1182d26d576$var$lift_x((0, $1GzxI.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $1GzxI.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$5765a1182d26d576$var$fe(r)) return false;
        const s = (0, $1GzxI.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$5765a1182d26d576$var$ge(s)) return false;
        const e = $5765a1182d26d576$var$challenge($5765a1182d26d576$var$numTo32b(r), $5765a1182d26d576$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $5765a1182d26d576$var$GmulAdd(P, s, $5765a1182d26d576$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
$5765a1182d26d576$exports.schnorr = (()=>({
        getPublicKey: $5765a1182d26d576$var$schnorrGetPublicKey,
        sign: $5765a1182d26d576$var$schnorrSign,
        verify: $5765a1182d26d576$var$schnorrVerify,
        utils: {
            randomPrivateKey: $5765a1182d26d576$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $5765a1182d26d576$var$lift_x,
            pointToBytes: $5765a1182d26d576$var$pointToBytes,
            numberToBytesBE: $1GzxI.numberToBytesBE,
            bytesToNumberBE: $1GzxI.bytesToNumberBE,
            taggedHash: $5765a1182d26d576$var$taggedHash,
            mod: $i945l.mod
        }
    }))();
const $5765a1182d26d576$var$isoMap = /* @__PURE__ */ (()=>(0, $3b9801ed630d510a$exports.isogenyMap)($5765a1182d26d576$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $5765a1182d26d576$var$mapSWU = /* @__PURE__ */ (()=>(0, $55a0bac5c8bffc9a$exports.mapToCurveSimpleSWU)($5765a1182d26d576$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $5765a1182d26d576$var$Fp.create(BigInt("-11"))
    }))();
const $5765a1182d26d576$var$htf = /* @__PURE__ */ (()=>(0, $3b9801ed630d510a$exports.createHasher)($5765a1182d26d576$exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $5765a1182d26d576$var$mapSWU($5765a1182d26d576$var$Fp.create(scalars[0]));
        return $5765a1182d26d576$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $5765a1182d26d576$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $40745d2159d0279c$exports.sha256
    }))();
$5765a1182d26d576$exports.hashToCurve = (()=>$5765a1182d26d576$var$htf.hashToCurve)();
$5765a1182d26d576$exports.encodeToCurve = (()=>$5765a1182d26d576$var$htf.encodeToCurve)();



/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $e1ab700abe0d106c$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";



// Constants
const $b9b4a54a1598ff6f$var$BN_0 = BigInt(0);
const $b9b4a54a1598ff6f$var$BN_1 = BigInt(1);
const $b9b4a54a1598ff6f$var$BN_2 = BigInt(2);
const $b9b4a54a1598ff6f$var$BN_27 = BigInt(27);
const $b9b4a54a1598ff6f$var$BN_28 = BigInt(28);
const $b9b4a54a1598ff6f$var$BN_35 = BigInt(35);
const $b9b4a54a1598ff6f$var$_guard = {};
function $b9b4a54a1598ff6f$var$toUint256(value) {
    return (0, $646c422fbb8bae38$export$4473860254365feb)((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(value), 32);
}
class $b9b4a54a1598ff6f$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$2321cd91b99770ff)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$2321cd91b99770ff)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(_value);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $80785c90802caadd$export$b14f2714108df84)(value, "value");
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $b9b4a54a1598ff6f$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $bb8e52d338877b37$export$ac1a938d48ec8c7b)(guard, $b9b4a54a1598ff6f$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $b9b4a54a1598ff6f$var$BN_27 || bv == $b9b4a54a1598ff6f$var$BN_28) return $b9b4a54a1598ff6f$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(bv >= $b9b4a54a1598ff6f$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $b9b4a54a1598ff6f$var$BN_35) / $b9b4a54a1598ff6f$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $80785c90802caadd$export$61fe455e2b1e28a4)(chainId) * $b9b4a54a1598ff6f$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(v);
        if (bv === $b9b4a54a1598ff6f$var$BN_0 || bv === $b9b4a54a1598ff6f$var$BN_27) return 27;
        if (bv === $b9b4a54a1598ff6f$var$BN_1 || bv === $b9b4a54a1598ff6f$var$BN_28) return 28;
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(bv >= $b9b4a54a1598ff6f$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $b9b4a54a1598ff6f$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(check, message, "signature", sig);
        }
        if (sig == null) return new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, (0, $e1ab700abe0d106c$export$89c2533b29c23a61), (0, $e1ab700abe0d106c$export$89c2533b29c23a61), 27);
        if (typeof sig === "string") {
            const bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, r, (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $b9b4a54a1598ff6f$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, r, (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $b9b4a54a1598ff6f$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $b9b4a54a1598ff6f$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $b9b4a54a1598ff6f$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $646c422fbb8bae38$export$a3521add2594f3c8)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(_v);
                return {
                    networkV: v >= $b9b4a54a1598ff6f$var$BN_35 ? v : undefined,
                    v: $b9b4a54a1598ff6f$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $646c422fbb8bae38$export$a3521add2594f3c8)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $80785c90802caadd$export$b14f2714108df84)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $80785c90802caadd$export$b14f2714108df84)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}


class $761062c457f5b164$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$2321cd91b99770ff)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $761062c457f5b164$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $761062c457f5b164$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $5765a1182d26d576$exports.secp256k1).sign((0, $646c422fbb8bae38$export$37110e7fee0af4ad)(digest), (0, $646c422fbb8bae38$export$37110e7fee0af4ad)(this.#privateKey), {
            lowS: true
        });
        return (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).from({
            r: (0, $80785c90802caadd$export$c6ebe05badb16181)(sig.r, 32),
            s: (0, $80785c90802caadd$export$c6ebe05badb16181)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $761062c457f5b164$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)((0, $5765a1182d26d576$exports.secp256k1).getSharedSecret((0, $646c422fbb8bae38$export$37110e7fee0af4ad)(this.#privateKey), (0, $646c422fbb8bae38$export$a3521add2594f3c8)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, $5765a1182d26d576$exports.secp256k1).getPublicKey(bytes, !!compressed);
            return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, $5765a1182d26d576$exports.secp256k1).ProjectivePoint.fromHex(bytes);
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).from(signature);
        let secpSig = (0, $5765a1182d26d576$exports.secp256k1).Signature.fromCompact((0, $646c422fbb8bae38$export$37110e7fee0af4ad)((0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, $646c422fbb8bae38$export$37110e7fee0af4ad)(digest));
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(pubKey != null, "invalid signautre for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, $5765a1182d26d576$exports.secp256k1).ProjectivePoint.fromHex($761062c457f5b164$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = (0, $5765a1182d26d576$exports.secp256k1).ProjectivePoint.fromHex($761062c457f5b164$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}



/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $d5351326e726e227$export$6a9f04c98a658ecb() {
    (0, $e423d9237c6b8e93$export$967075d2f3b8e7ff).lock();
    (0, $eb8e34a59f49e216$export$f8151fce47ad1c35).lock();
    (0, $b08c23dad829fb20$export$448fa22aedc9dbca).lock();
    (0, $e2899165f684d722$export$5f828d93ff035aa8).lock();
    (0, $c6fe99323c2965cd$export$d1cea0ee4e3f0d3e).lock();
    (0, $d040a4c743127b7f$export$7cf7c2f1ec457bf3).lock();
    (0, $d040a4c743127b7f$export$86c79e0734c26a76).lock();
    (0, $d318730f8de39247$export$bced8d2aada2d1c9).lock();
    (0, $d318730f8de39247$export$a888d2532e6dc7bb).lock();
    (0, $e2899165f684d722$export$5f828d93ff035aa8).lock();
}



const $14cfbe985a29575c$var$BN_0 = BigInt(0);
const $14cfbe985a29575c$var$BN_36 = BigInt(36);
function $14cfbe985a29575c$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $646c422fbb8bae38$export$a3521add2594f3c8)((0, $eb8e34a59f49e216$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $14cfbe985a29575c$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$14cfbe985a29575c$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$14cfbe985a29575c$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $14cfbe985a29575c$var$safeDigits = 15;
function $14cfbe985a29575c$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $14cfbe985a29575c$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $14cfbe985a29575c$var$safeDigits){
        let block = expanded.substring(0, $14cfbe985a29575c$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $14cfbe985a29575c$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $14cfbe985a29575c$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $14cfbe985a29575c$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $14cfbe985a29575c$var$BN_36 + $14cfbe985a29575c$var$Base36[value[i]];
    return result;
}
function $14cfbe985a29575c$export$88411125f012957a(address) {
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $14cfbe985a29575c$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(address.substring(2, 4) === $14cfbe985a29575c$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $14cfbe985a29575c$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $14cfbe985a29575c$var$getChecksumAddress("0x" + result);
    }
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid address", "address", address);
}
function $14cfbe985a29575c$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($14cfbe985a29575c$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $14cfbe985a29575c$var$ibanChecksum("XE00" + base36) + base36;
}



/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ 
const $784e1baa090f7919$var$_gaurd = {};
function $784e1baa090f7919$var$n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new $784e1baa090f7919$export$af51273277efe223($784e1baa090f7919$var$_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed: signed,
        width: width
    });
}
function $784e1baa090f7919$var$b(value, size) {
    // @TODO: Check range is valid for value
    return new $784e1baa090f7919$export$af51273277efe223($784e1baa090f7919$var$_gaurd, `bytes${size ? size : ""}`, value, {
        size: size
    });
}
const $784e1baa090f7919$var$_typedSymbol = Symbol.for("_ethers_typed");
class $784e1baa090f7919$export$af51273277efe223 {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, $bb8e52d338877b37$export$ac1a938d48ec8c7b)($784e1baa090f7919$var$_gaurd, gaurd, "Typed");
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            _typedSymbol: $784e1baa090f7919$var$_typedSymbol,
            type: type,
            value: value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new $784e1baa090f7919$export$af51273277efe223($784e1baa090f7919$var$_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return $784e1baa090f7919$var$n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return $784e1baa090f7919$var$n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return $784e1baa090f7919$var$n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return $784e1baa090f7919$var$n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return $784e1baa090f7919$var$n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return $784e1baa090f7919$var$n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return $784e1baa090f7919$var$n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return $784e1baa090f7919$var$n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return $784e1baa090f7919$var$n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return $784e1baa090f7919$var$n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return $784e1baa090f7919$var$n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return $784e1baa090f7919$var$n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return $784e1baa090f7919$var$n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return $784e1baa090f7919$var$n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return $784e1baa090f7919$var$n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return $784e1baa090f7919$var$n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return $784e1baa090f7919$var$n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return $784e1baa090f7919$var$n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return $784e1baa090f7919$var$n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return $784e1baa090f7919$var$n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return $784e1baa090f7919$var$n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return $784e1baa090f7919$var$n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return $784e1baa090f7919$var$n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return $784e1baa090f7919$var$n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return $784e1baa090f7919$var$n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return $784e1baa090f7919$var$n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return $784e1baa090f7919$var$n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return $784e1baa090f7919$var$n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return $784e1baa090f7919$var$n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return $784e1baa090f7919$var$n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return $784e1baa090f7919$var$n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return $784e1baa090f7919$var$n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return $784e1baa090f7919$var$n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return $784e1baa090f7919$var$n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return $784e1baa090f7919$var$n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return $784e1baa090f7919$var$n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return $784e1baa090f7919$var$n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return $784e1baa090f7919$var$n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return $784e1baa090f7919$var$n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return $784e1baa090f7919$var$n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return $784e1baa090f7919$var$n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return $784e1baa090f7919$var$n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return $784e1baa090f7919$var$n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return $784e1baa090f7919$var$n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return $784e1baa090f7919$var$n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return $784e1baa090f7919$var$n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return $784e1baa090f7919$var$n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return $784e1baa090f7919$var$n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return $784e1baa090f7919$var$n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return $784e1baa090f7919$var$n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return $784e1baa090f7919$var$n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return $784e1baa090f7919$var$n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return $784e1baa090f7919$var$n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return $784e1baa090f7919$var$n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return $784e1baa090f7919$var$n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return $784e1baa090f7919$var$n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return $784e1baa090f7919$var$n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return $784e1baa090f7919$var$n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return $784e1baa090f7919$var$n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return $784e1baa090f7919$var$n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return $784e1baa090f7919$var$n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return $784e1baa090f7919$var$n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return $784e1baa090f7919$var$n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return $784e1baa090f7919$var$n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return $784e1baa090f7919$var$n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return $784e1baa090f7919$var$n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return $784e1baa090f7919$var$b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return $784e1baa090f7919$var$b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return $784e1baa090f7919$var$b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return $784e1baa090f7919$var$b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return $784e1baa090f7919$var$b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return $784e1baa090f7919$var$b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return $784e1baa090f7919$var$b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return $784e1baa090f7919$var$b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return $784e1baa090f7919$var$b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return $784e1baa090f7919$var$b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return $784e1baa090f7919$var$b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return $784e1baa090f7919$var$b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return $784e1baa090f7919$var$b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return $784e1baa090f7919$var$b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return $784e1baa090f7919$var$b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return $784e1baa090f7919$var$b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return $784e1baa090f7919$var$b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return $784e1baa090f7919$var$b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return $784e1baa090f7919$var$b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return $784e1baa090f7919$var$b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return $784e1baa090f7919$var$b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return $784e1baa090f7919$var$b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return $784e1baa090f7919$var$b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return $784e1baa090f7919$var$b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return $784e1baa090f7919$var$b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return $784e1baa090f7919$var$b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return $784e1baa090f7919$var$b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return $784e1baa090f7919$var$b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return $784e1baa090f7919$var$b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return $784e1baa090f7919$var$b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return $784e1baa090f7919$var$b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return $784e1baa090f7919$var$b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new $784e1baa090f7919$export$af51273277efe223($784e1baa090f7919$var$_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new $784e1baa090f7919$export$af51273277efe223($784e1baa090f7919$var$_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new $784e1baa090f7919$export$af51273277efe223($784e1baa090f7919$var$_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new $784e1baa090f7919$export$af51273277efe223($784e1baa090f7919$var$_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new $784e1baa090f7919$export$af51273277efe223($784e1baa090f7919$var$_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === $784e1baa090f7919$var$_typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if ($784e1baa090f7919$export$af51273277efe223.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}



class $fd443aedb8774d03$export$59dbbded7775bfe7 extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, $784e1baa090f7919$export$af51273277efe223).dereference(_value, "string");
        try {
            value = (0, $14cfbe985a29575c$export$88411125f012957a)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $14cfbe985a29575c$export$88411125f012957a)((0, $80785c90802caadd$export$c6ebe05badb16181)(reader.readValue(), 20));
    }
}






class $9add3ccac2491126$export$87c41d1139a03fa2 extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


function $f31afa947ddee045$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid tuple value", "tuple", values);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $9d29f608d1beea97$export$d7a960146e1a269e)();
    let dynamicWriter = new (0, $9d29f608d1beea97$export$d7a960146e1a269e)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $f31afa947ddee045$export$417857010dc9287f(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, $9d29f608d1beea97$export$8fdcabde73f49165).fromItems(values, keys);
}
class $f31afa947ddee045$export$88bc419d2df11f54 extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            coder: coder,
            length: length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, $784e1baa090f7919$export$af51273277efe223).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, $bb8e52d338877b37$export$d228410a8a77e4fa)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $f31afa947ddee045$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(count * (0, $9d29f608d1beea97$export$b4b1d1fba463e69c) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, $9d29f608d1beea97$export$b4b1d1fba463e69c),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $9add3ccac2491126$export$87c41d1139a03fa2)(this.coder));
        return $f31afa947ddee045$export$417857010dc9287f(reader, coders);
    }
}




class $15f82c3d7609dd2c$export$fe9118d6c093150c extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, $784e1baa090f7919$export$af51273277efe223).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}




class $1eee758486388941$export$db9eadd8df12ad2e extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $646c422fbb8bae38$export$37110e7fee0af4ad)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class $1eee758486388941$export$e5823e9574df18d2 extends $1eee758486388941$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(super.decode(reader));
    }
}





class $82d705b4b33b62b1$export$7dec9db68e6bcf5a extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            size: size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, $646c422fbb8bae38$export$37110e7fee0af4ad)((0, $784e1baa090f7919$export$af51273277efe223).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(reader.readBytes(this.size));
    }
}



const $aee3af2074cdf519$var$Empty = new Uint8Array([]);
class $aee3af2074cdf519$export$70982cadf2d6b4ec extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes($aee3af2074cdf519$var$Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}





const $37c871f73e98aa2d$var$BN_0 = BigInt(0);
const $37c871f73e98aa2d$var$BN_1 = BigInt(1);
const $37c871f73e98aa2d$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class $37c871f73e98aa2d$export$b934dc8cfe13938c extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            size: size,
            signed: signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, $80785c90802caadd$export$61fe455e2b1e28a4)((0, $784e1baa090f7919$export$af51273277efe223).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, $80785c90802caadd$export$d99f0801a68bbcf1)($37c871f73e98aa2d$var$BN_MAX_UINT256, (0, $9d29f608d1beea97$export$b4b1d1fba463e69c) * 8);
        if (this.signed) {
            let bounds = (0, $80785c90802caadd$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + $37c871f73e98aa2d$var$BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, $80785c90802caadd$export$7101cd4e6275351c)(value, 8 * (0, $9d29f608d1beea97$export$b4b1d1fba463e69c));
        } else if (value < $37c871f73e98aa2d$var$BN_0 || value > (0, $80785c90802caadd$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, $80785c90802caadd$export$d99f0801a68bbcf1)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, $80785c90802caadd$export$92182edcfa20e5bc)(value, this.size * 8);
        return value;
    }
}


/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 

function $bd5f6433d45dd8bb$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $bd5f6433d45dd8bb$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $bd5f6433d45dd8bb$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $bd5f6433d45dd8bb$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $bd5f6433d45dd8bb$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $bd5f6433d45dd8bb$var$errorFunc,
    ignore: $bd5f6433d45dd8bb$var$ignoreFunc,
    replace: $bd5f6433d45dd8bb$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $bd5f6433d45dd8bb$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $bd5f6433d45dd8bb$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $bd5f6433d45dd8bb$export$8feeb310b4b4752f(str, form) {
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, $bb8e52d338877b37$export$d993e67fefdfecda)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $bd5f6433d45dd8bb$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $bd5f6433d45dd8bb$export$7643a1dc2c38d5eb(bytes, onError) {
    return $bd5f6433d45dd8bb$var$_toUtf8String($bd5f6433d45dd8bb$var$getUtf8CodePoints(bytes, onError));
}
function $bd5f6433d45dd8bb$export$ae470a36a31b28c2(str, form) {
    return $bd5f6433d45dd8bb$var$getUtf8CodePoints($bd5f6433d45dd8bb$export$8feeb310b4b4752f(str, form));
}




class $753aa3069291cb3a$export$2d1b854518731426 extends (0, $1eee758486388941$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)((0, $784e1baa090f7919$export$af51273277efe223).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, $bd5f6433d45dd8bb$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}






class $d80010e0c3f0c78a$export$e9fceba8f110fea6 extends (0, $9d29f608d1beea97$export$2c0c39526f8bad46) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, $784e1baa090f7919$export$af51273277efe223).dereference(_value, "tuple");
        return (0, $f31afa947ddee045$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, $f31afa947ddee045$export$417857010dc9287f)(reader, this.coders);
    }
}


/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ 


function $1e8739595920e30f$export$d560c7e4a29451c2(value) {
    return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)((0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)(value));
}


// [ "a", "b" ] => { "a": 1, "b": 1 }
function $e74cf180ae7e3889$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $e74cf180ae7e3889$var$_kwVisibDeploy = "external public payable override";
const $e74cf180ae7e3889$var$KwVisibDeploy = $e74cf180ae7e3889$var$setify($e74cf180ae7e3889$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $e74cf180ae7e3889$var$_kwVisib = "constant external internal payable private public pure view override";
const $e74cf180ae7e3889$var$KwVisib = $e74cf180ae7e3889$var$setify($e74cf180ae7e3889$var$_kwVisib.split(" "));
const $e74cf180ae7e3889$var$_kwTypes = "constructor error event fallback function receive struct";
const $e74cf180ae7e3889$var$KwTypes = $e74cf180ae7e3889$var$setify($e74cf180ae7e3889$var$_kwTypes.split(" "));
const $e74cf180ae7e3889$var$_kwModifiers = "calldata memory storage payable indexed";
const $e74cf180ae7e3889$var$KwModifiers = $e74cf180ae7e3889$var$setify($e74cf180ae7e3889$var$_kwModifiers.split(" "));
const $e74cf180ae7e3889$var$_kwOther = "tuple returns";
// All Keywords
const $e74cf180ae7e3889$var$_keywords = [
    $e74cf180ae7e3889$var$_kwTypes,
    $e74cf180ae7e3889$var$_kwModifiers,
    $e74cf180ae7e3889$var$_kwOther,
    $e74cf180ae7e3889$var$_kwVisib
].join(" ");
const $e74cf180ae7e3889$var$Keywords = $e74cf180ae7e3889$var$setify($e74cf180ae7e3889$var$_keywords.split(" "));
// Single character tokens
const $e74cf180ae7e3889$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $e74cf180ae7e3889$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $e74cf180ae7e3889$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $e74cf180ae7e3889$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $e74cf180ae7e3889$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $e74cf180ae7e3889$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $e74cf180ae7e3889$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $e74cf180ae7e3889$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $e74cf180ae7e3889$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $e74cf180ae7e3889$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($e74cf180ae7e3889$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $e74cf180ae7e3889$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $80785c90802caadd$export$b14f2714108df84)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($e74cf180ae7e3889$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($e74cf180ae7e3889$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($e74cf180ae7e3889$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($e74cf180ae7e3889$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $e74cf180ae7e3889$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $e74cf180ae7e3889$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $e74cf180ae7e3889$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($e74cf180ae7e3889$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $e74cf180ae7e3889$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $e74cf180ae7e3889$var$consumeMutability(tokens) {
    let modifiers = $e74cf180ae7e3889$var$consumeKeywords(tokens, $e74cf180ae7e3889$var$KwVisib);
    // Detect conflicting modifiers
    $e74cf180ae7e3889$var$allowSingle(modifiers, $e74cf180ae7e3889$var$setify("constant payable nonpayable".split(" ")));
    $e74cf180ae7e3889$var$allowSingle(modifiers, $e74cf180ae7e3889$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $e74cf180ae7e3889$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$e74cf180ae7e3889$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $e74cf180ae7e3889$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $80785c90802caadd$export$61fe455e2b1e28a4)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $e74cf180ae7e3889$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const $e74cf180ae7e3889$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $e74cf180ae7e3889$var$verifyBasicType(type) {
    const match = type.match($e74cf180ae7e3889$var$regexType);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $e74cf180ae7e3889$var$_guard = {};
const $e74cf180ae7e3889$var$internal = Symbol.for("_ethers_internal");
const $e74cf180ae7e3889$var$ParamTypeInternal = "_ParamTypeInternal";
const $e74cf180ae7e3889$var$ErrorFragmentInternal = "_ErrorInternal";
const $e74cf180ae7e3889$var$EventFragmentInternal = "_EventInternal";
const $e74cf180ae7e3889$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $e74cf180ae7e3889$var$FallbackFragmentInternal = "_FallbackInternal";
const $e74cf180ae7e3889$var$FunctionFragmentInternal = "_FunctionInternal";
const $e74cf180ae7e3889$var$StructFragmentInternal = "_StructInternal";
class $e74cf180ae7e3889$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $bb8e52d338877b37$export$ac1a938d48ec8c7b)(guard, $e74cf180ae7e3889$var$_guard, "ParamType");
        Object.defineProperty(this, $e74cf180ae7e3889$var$internal, {
            value: $e74cf180ae7e3889$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS names by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($e74cf180ae7e3889$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $e74cf180ae7e3889$export$426dc07f493a4c47.from($e74cf180ae7e3889$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $e74cf180ae7e3889$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($e74cf180ae7e3889$var$consumeKeywords(obj, $e74cf180ae7e3889$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$e74cf180ae7e3889$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $e74cf180ae7e3889$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $e74cf180ae7e3889$export$426dc07f493a4c47($e74cf180ae7e3889$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $e74cf180ae7e3889$var$consumeKeywords(obj, $e74cf180ae7e3889$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $e74cf180ae7e3889$export$426dc07f493a4c47($e74cf180ae7e3889$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!name || typeof name === "string" && name.match($e74cf180ae7e3889$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($e74cf180ae7e3889$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $e74cf180ae7e3889$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $e74cf180ae7e3889$export$426dc07f493a4c47($e74cf180ae7e3889$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$e74cf180ae7e3889$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $e74cf180ae7e3889$export$426dc07f493a4c47($e74cf180ae7e3889$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $e74cf180ae7e3889$var$verifyBasicType(obj.type);
        return new $e74cf180ae7e3889$export$426dc07f493a4c47($e74cf180ae7e3889$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$e74cf180ae7e3889$var$internal] === $e74cf180ae7e3889$var$ParamTypeInternal;
    }
}
class $e74cf180ae7e3889$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $bb8e52d338877b37$export$ac1a938d48ec8c7b)(guard, $e74cf180ae7e3889$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $e74cf180ae7e3889$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $e74cf180ae7e3889$export$ffb0004e005737fa.from($e74cf180ae7e3889$var$lex(obj));
        }
        if (obj instanceof $e74cf180ae7e3889$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($e74cf180ae7e3889$var$KwTypes);
            switch(type){
                case "constructor":
                    return $e74cf180ae7e3889$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $e74cf180ae7e3889$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $e74cf180ae7e3889$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $e74cf180ae7e3889$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $e74cf180ae7e3889$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $e74cf180ae7e3889$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $e74cf180ae7e3889$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $e74cf180ae7e3889$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $e74cf180ae7e3889$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $e74cf180ae7e3889$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $e74cf180ae7e3889$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $e74cf180ae7e3889$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $e74cf180ae7e3889$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $e74cf180ae7e3889$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $e74cf180ae7e3889$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $e74cf180ae7e3889$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $e74cf180ae7e3889$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $e74cf180ae7e3889$export$85c6fc53d6299173 extends $e74cf180ae7e3889$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof name === "string" && name.match($e74cf180ae7e3889$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
}
function $e74cf180ae7e3889$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $e74cf180ae7e3889$export$2c42c6d543aa9b59 extends $e74cf180ae7e3889$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $e74cf180ae7e3889$var$internal, {
            value: $e74cf180ae7e3889$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $1e8739595920e30f$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $e74cf180ae7e3889$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($e74cf180ae7e3889$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $e74cf180ae7e3889$export$2c42c6d543aa9b59.from($e74cf180ae7e3889$var$lex(obj));
        else if (obj instanceof $e74cf180ae7e3889$var$TokenString) {
            const name = $e74cf180ae7e3889$var$consumeName("error", obj);
            const inputs = $e74cf180ae7e3889$var$consumeParams(obj);
            $e74cf180ae7e3889$var$consumeEoi(obj);
            return new $e74cf180ae7e3889$export$2c42c6d543aa9b59($e74cf180ae7e3889$var$_guard, name, inputs);
        }
        return new $e74cf180ae7e3889$export$2c42c6d543aa9b59($e74cf180ae7e3889$var$_guard, obj.name, obj.inputs ? obj.inputs.map($e74cf180ae7e3889$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$e74cf180ae7e3889$var$internal] === $e74cf180ae7e3889$var$ErrorFragmentInternal;
    }
}
class $e74cf180ae7e3889$export$958548f08bac2833 extends $e74cf180ae7e3889$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $e74cf180ae7e3889$var$internal, {
            value: $e74cf180ae7e3889$var$EventFragmentInternal
        });
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $1e8739595920e30f$export$d560c7e4a29451c2)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $e74cf180ae7e3889$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$e74cf180ae7e3889$export$426dc07f493a4c47.from(p));
        const fragment = new $e74cf180ae7e3889$export$958548f08bac2833($e74cf180ae7e3889$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($e74cf180ae7e3889$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $e74cf180ae7e3889$export$958548f08bac2833.from($e74cf180ae7e3889$var$lex(obj));
        } catch (error) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $e74cf180ae7e3889$var$TokenString) {
            const name = $e74cf180ae7e3889$var$consumeName("event", obj);
            const inputs = $e74cf180ae7e3889$var$consumeParams(obj, true);
            const anonymous = !!$e74cf180ae7e3889$var$consumeKeywords(obj, $e74cf180ae7e3889$var$setify([
                "anonymous"
            ])).has("anonymous");
            $e74cf180ae7e3889$var$consumeEoi(obj);
            return new $e74cf180ae7e3889$export$958548f08bac2833($e74cf180ae7e3889$var$_guard, name, inputs, anonymous);
        }
        return new $e74cf180ae7e3889$export$958548f08bac2833($e74cf180ae7e3889$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$e74cf180ae7e3889$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$e74cf180ae7e3889$var$internal] === $e74cf180ae7e3889$var$EventFragmentInternal;
    }
}
class $e74cf180ae7e3889$export$3ac5c9504f801ea4 extends $e74cf180ae7e3889$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $e74cf180ae7e3889$var$internal, {
            value: $e74cf180ae7e3889$var$ConstructorFragmentInternal
        });
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$e74cf180ae7e3889$var$joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($e74cf180ae7e3889$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $e74cf180ae7e3889$export$3ac5c9504f801ea4.from($e74cf180ae7e3889$var$lex(obj));
        } catch (error) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $e74cf180ae7e3889$var$TokenString) {
            $e74cf180ae7e3889$var$consumeKeywords(obj, $e74cf180ae7e3889$var$setify([
                "constructor"
            ]));
            const inputs = $e74cf180ae7e3889$var$consumeParams(obj);
            const payable = !!$e74cf180ae7e3889$var$consumeKeywords(obj, $e74cf180ae7e3889$var$KwVisibDeploy).has("payable");
            const gas = $e74cf180ae7e3889$var$consumeGas(obj);
            $e74cf180ae7e3889$var$consumeEoi(obj);
            return new $e74cf180ae7e3889$export$3ac5c9504f801ea4($e74cf180ae7e3889$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $e74cf180ae7e3889$export$3ac5c9504f801ea4($e74cf180ae7e3889$var$_guard, "constructor", obj.inputs ? obj.inputs.map($e74cf180ae7e3889$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$e74cf180ae7e3889$var$internal] === $e74cf180ae7e3889$var$ConstructorFragmentInternal;
    }
}
class $e74cf180ae7e3889$export$71b1ea64c89c20fc extends $e74cf180ae7e3889$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $e74cf180ae7e3889$var$internal, {
            value: $e74cf180ae7e3889$var$FallbackFragmentInternal
        });
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($e74cf180ae7e3889$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $e74cf180ae7e3889$export$71b1ea64c89c20fc.from($e74cf180ae7e3889$var$lex(obj));
        } catch (error) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $e74cf180ae7e3889$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($e74cf180ae7e3889$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($e74cf180ae7e3889$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $e74cf180ae7e3889$var$consumeParams(obj);
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $e74cf180ae7e3889$var$consumeKeywords(obj, $e74cf180ae7e3889$var$setify([
                    "payable"
                ]));
                $e74cf180ae7e3889$var$consumeEoi(obj);
                return new $e74cf180ae7e3889$export$71b1ea64c89c20fc($e74cf180ae7e3889$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $e74cf180ae7e3889$var$consumeParams(obj);
            if (inputs.length) (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $e74cf180ae7e3889$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $e74cf180ae7e3889$var$consumeMutability(obj);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($e74cf180ae7e3889$var$consumeKeywords(obj, $e74cf180ae7e3889$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $e74cf180ae7e3889$var$consumeParams(obj);
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $e74cf180ae7e3889$var$consumeEoi(obj);
            return new $e74cf180ae7e3889$export$71b1ea64c89c20fc($e74cf180ae7e3889$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $e74cf180ae7e3889$export$71b1ea64c89c20fc($e74cf180ae7e3889$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $e74cf180ae7e3889$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $e74cf180ae7e3889$export$71b1ea64c89c20fc($e74cf180ae7e3889$var$_guard, inputs, payable);
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$e74cf180ae7e3889$var$internal] === $e74cf180ae7e3889$var$FallbackFragmentInternal;
    }
}
class $e74cf180ae7e3889$export$8d576c928b93668f extends $e74cf180ae7e3889$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $e74cf180ae7e3889$var$internal, {
            value: $e74cf180ae7e3889$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $1e8739595920e30f$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $e74cf180ae7e3889$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($e74cf180ae7e3889$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$e74cf180ae7e3889$export$426dc07f493a4c47.from(p));
        const fragment = new $e74cf180ae7e3889$export$8d576c928b93668f($e74cf180ae7e3889$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($e74cf180ae7e3889$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $e74cf180ae7e3889$export$8d576c928b93668f.from($e74cf180ae7e3889$var$lex(obj));
        } catch (error) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $e74cf180ae7e3889$var$TokenString) {
            const name = $e74cf180ae7e3889$var$consumeName("function", obj);
            const inputs = $e74cf180ae7e3889$var$consumeParams(obj);
            const mutability = $e74cf180ae7e3889$var$consumeMutability(obj);
            let outputs = [];
            if ($e74cf180ae7e3889$var$consumeKeywords(obj, $e74cf180ae7e3889$var$setify([
                "returns"
            ])).has("returns")) outputs = $e74cf180ae7e3889$var$consumeParams(obj);
            const gas = $e74cf180ae7e3889$var$consumeGas(obj);
            $e74cf180ae7e3889$var$consumeEoi(obj);
            return new $e74cf180ae7e3889$export$8d576c928b93668f($e74cf180ae7e3889$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $e74cf180ae7e3889$export$8d576c928b93668f($e74cf180ae7e3889$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($e74cf180ae7e3889$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($e74cf180ae7e3889$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$e74cf180ae7e3889$var$internal] === $e74cf180ae7e3889$var$FunctionFragmentInternal;
    }
}
class $e74cf180ae7e3889$export$9f91ba10bb234ec7 extends $e74cf180ae7e3889$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $e74cf180ae7e3889$var$internal, {
            value: $e74cf180ae7e3889$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $e74cf180ae7e3889$export$9f91ba10bb234ec7.from($e74cf180ae7e3889$var$lex(obj));
        } catch (error) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $e74cf180ae7e3889$var$TokenString) {
            const name = $e74cf180ae7e3889$var$consumeName("struct", obj);
            const inputs = $e74cf180ae7e3889$var$consumeParams(obj);
            $e74cf180ae7e3889$var$consumeEoi(obj);
            return new $e74cf180ae7e3889$export$9f91ba10bb234ec7($e74cf180ae7e3889$var$_guard, name, inputs);
        }
        return new $e74cf180ae7e3889$export$9f91ba10bb234ec7($e74cf180ae7e3889$var$_guard, obj.name, obj.inputs ? obj.inputs.map($e74cf180ae7e3889$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$e74cf180ae7e3889$var$internal] === $e74cf180ae7e3889$var$StructFragmentInternal;
    }
}



// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const $dfec5cc4eff24eb3$var$PanicReasons = new Map();
$dfec5cc4eff24eb3$var$PanicReasons.set(0x00, "GENERIC_PANIC");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x01, "ASSERT_FALSE");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x11, "OVERFLOW");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x22, "BAD_STORAGE_DATA");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x31, "STACK_UNDERFLOW");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x41, "OUT_OF_MEMORY");
$dfec5cc4eff24eb3$var$PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const $dfec5cc4eff24eb3$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $dfec5cc4eff24eb3$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let $dfec5cc4eff24eb3$var$defaultCoder = null;
let $dfec5cc4eff24eb3$var$defaultMaxInflation = 1024;
function $dfec5cc4eff24eb3$var$getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(data);
        data = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${$dfec5cc4eff24eb3$var$PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, $14cfbe985a29575c$export$88411125f012957a)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, $14cfbe985a29575c$export$88411125f012957a)(tx.from);
    return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)(message, "CALL_EXCEPTION", {
        action: action,
        data: data,
        reason: reason,
        transaction: transaction,
        invocation: invocation,
        revert: revert
    });
}
class $dfec5cc4eff24eb3$export$fe041e1a83d3efc6 {
    #getCoder(param) {
        if (param.isArray()) return new (0, $f31afa947ddee045$export$88bc419d2df11f54)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, $d80010e0c3f0c78a$export$e9fceba8f110fea6)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, $fd443aedb8774d03$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $15f82c3d7609dd2c$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $753aa3069291cb3a$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $1eee758486388941$export$e5823e9574df18d2)(param.name);
            case "":
                return new (0, $aee3af2074cdf519$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($dfec5cc4eff24eb3$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, $37c871f73e98aa2d$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($dfec5cc4eff24eb3$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, $82d705b4b33b62b1$export$7dec9db68e6bcf5a)(size, param.name);
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, $e74cf180ae7e3889$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $d80010e0c3f0c78a$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, $bb8e52d338877b37$export$d228410a8a77e4fa)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, $e74cf180ae7e3889$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $d80010e0c3f0c78a$export$e9fceba8f110fea6)(coders, "_");
        const writer = new (0, $9d29f608d1beea97$export$d7a960146e1a269e)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, $e74cf180ae7e3889$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $d80010e0c3f0c78a$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(new (0, $9d29f608d1beea97$export$2f7a2f0e90c07dc4)(data, loose, $dfec5cc4eff24eb3$var$defaultMaxInflation));
    }
    static _setDefaultMaxInflation(value) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
        $dfec5cc4eff24eb3$var$defaultMaxInflation = value;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if ($dfec5cc4eff24eb3$var$defaultCoder == null) $dfec5cc4eff24eb3$var$defaultCoder = new $dfec5cc4eff24eb3$export$fe041e1a83d3efc6();
        return $dfec5cc4eff24eb3$var$defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return $dfec5cc4eff24eb3$var$getBuiltinCallException(action, tx, data, $dfec5cc4eff24eb3$export$fe041e1a83d3efc6.defaultAbiCoder());
    }
}




function $06f9d9d760226a67$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $06f9d9d760226a67$export$977e255126d763d6(value) {
    try {
        (0, $14cfbe985a29575c$export$88411125f012957a)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $06f9d9d760226a67$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $14cfbe985a29575c$export$88411125f012957a)(result);
}
function $06f9d9d760226a67$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $14cfbe985a29575c$export$88411125f012957a)(target);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $06f9d9d760226a67$var$checkAddress(target, resolver.resolveName(target));
    } else if ($06f9d9d760226a67$export$6a88e03bca5eb759(target)) return $06f9d9d760226a67$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $06f9d9d760226a67$var$checkAddress(target, target);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "unsupported addressable value", "target", target);
}


//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";




function $fab11e657c863d96$export$e67e2732ba9803f9(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, $761062c457f5b164$export$21643ca94aed3e83).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, $14cfbe985a29575c$export$88411125f012957a)((0, $eb8e34a59f49e216$export$f8151fce47ad1c35)("0x" + pubkey.substring(4)).substring(26));
}
function $fab11e657c863d96$export$23cc18f96d8510e2(digest, signature) {
    return $fab11e657c863d96$export$e67e2732ba9803f9((0, $761062c457f5b164$export$21643ca94aed3e83).recoverPublicKey(digest, signature));
}




const $ce7c7003fbfaaf87$var$padding = new Uint8Array(32);
$ce7c7003fbfaaf87$var$padding.fill(0);
const $ce7c7003fbfaaf87$var$BN__1 = BigInt(-1);
const $ce7c7003fbfaaf87$var$BN_0 = BigInt(0);
const $ce7c7003fbfaaf87$var$BN_1 = BigInt(1);
const $ce7c7003fbfaaf87$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $ce7c7003fbfaaf87$var$hexPadRight(value) {
    const bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
        bytes,
        $ce7c7003fbfaaf87$var$padding.slice(padOffset)
    ]);
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes);
}
const $ce7c7003fbfaaf87$var$hexTrue = (0, $80785c90802caadd$export$c6ebe05badb16181)($ce7c7003fbfaaf87$var$BN_1, 32);
const $ce7c7003fbfaaf87$var$hexFalse = (0, $80785c90802caadd$export$c6ebe05badb16181)($ce7c7003fbfaaf87$var$BN_0, 32);
const $ce7c7003fbfaaf87$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $ce7c7003fbfaaf87$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $ce7c7003fbfaaf87$var$checkString(key) {
    return function(value) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $ce7c7003fbfaaf87$var$domainChecks = {
    name: $ce7c7003fbfaaf87$var$checkString("name"),
    version: $ce7c7003fbfaaf87$var$checkString("version"),
    chainId: function(_value) {
        const value = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(_value, "domain.chainId");
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, $80785c90802caadd$export$d9c067986dbc68dd)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $14cfbe985a29575c$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(value, "domain.salt");
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes);
    }
};
function $ce7c7003fbfaaf87$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d+)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2]);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(width % 8 === 0 && width !== 0 && width <= 256 && match[2] === String(width), "invalid numeric width", "type", type);
            const boundsUpper = (0, $80785c90802caadd$export$d99f0801a68bbcf1)($ce7c7003fbfaaf87$var$BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + $ce7c7003fbfaaf87$var$BN_1) * $ce7c7003fbfaaf87$var$BN__1 : $ce7c7003fbfaaf87$var$BN_0;
            return function(_value) {
                const value = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(_value, "value");
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, $80785c90802caadd$export$c6ebe05badb16181)(signed ? (0, $80785c90802caadd$export$7101cd4e6275351c)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(value);
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return $ce7c7003fbfaaf87$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $646c422fbb8bae38$export$4473860254365feb)((0, $14cfbe985a29575c$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $ce7c7003fbfaaf87$var$hexFalse : $ce7c7003fbfaaf87$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $1e8739595920e30f$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $ce7c7003fbfaaf87$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
// foo[][3] => { base: "foo", index: "[][3]", array: {
//     base: "foo", prefix: "foo[]", count: 3 } }
function $ce7c7003fbfaaf87$var$splitArray(type) {
    const match = type.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    if (match) return {
        base: match[1],
        index: match[2] + match[4],
        array: {
            base: match[1],
            prefix: match[1] + match[2],
            count: match[5] ? parseInt(match[5]) : -1
        }
    };
    return {
        base: type
    };
}
class $ce7c7003fbfaaf87$export$458ab927ae635c3 {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(_types){
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        const types = {};
        Object.keys(_types).forEach((type)=>{
            types[type] = _types[type].map(({ name: name, type: type })=>{
                // Normalize the base type (unless name conflict)
                let { base: base, index: index } = $ce7c7003fbfaaf87$var$splitArray(type);
                if (base === "int" && !_types["int"]) base = "int256";
                if (base === "uint" && !_types["uint"]) base = "uint256";
                return {
                    name: name,
                    type: base + (index || "")
                };
            });
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        this.#types = JSON.stringify(types);
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", _types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = $ce7c7003fbfaaf87$var$splitArray(field.type).base;
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", _types);
                // Is this a base encoding type?
                const encoder = $ce7c7003fbfaaf87$var$getBaseEncoder(baseType);
                if (encoder) continue;
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", _types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(primaryTypes.length !== 0, "missing primary type", "types", _types);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", _types);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", _types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, $ce7c7003fbfaaf87$var$encodeType(name, types[name]) + st.map((t)=>$ce7c7003fbfaaf87$var$encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $ce7c7003fbfaaf87$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const array = $ce7c7003fbfaaf87$var$splitArray(type).array;
        if (array) {
            const subtype = array.prefix;
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, $eb8e34a59f49e216$export$f8151fce47ad1c35));
                return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)((0, $646c422fbb8bae38$export$ee1b3e54f0441b22)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $1e8739595920e30f$export$d560c7e4a29451c2)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)(values);
            };
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $ce7c7003fbfaaf87$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const array = $ce7c7003fbfaaf87$var$splitArray(type).array;
        if (array) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
            return value.map((v)=>this._visit(array.prefix, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new $ce7c7003fbfaaf87$export$458ab927ae635c3(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return $ce7c7003fbfaaf87$export$458ab927ae635c3.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return $ce7c7003fbfaaf87$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = $ce7c7003fbfaaf87$var$domainFieldTypes[name];
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $ce7c7003fbfaaf87$var$domainFieldNames.indexOf(a.name) - $ce7c7003fbfaaf87$var$domainFieldNames.indexOf(b.name);
        });
        return $ce7c7003fbfaaf87$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
            "0x1901",
            $ce7c7003fbfaaf87$export$458ab927ae635c3.hashDomain(domain),
            $ce7c7003fbfaaf87$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)($ce7c7003fbfaaf87$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = $ce7c7003fbfaaf87$export$458ab927ae635c3.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain: domain,
            value: value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        $ce7c7003fbfaaf87$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $ce7c7003fbfaaf87$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $ce7c7003fbfaaf87$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $ce7c7003fbfaaf87$var$domainFieldTypes[name]
            });
        });
        const encoder = $ce7c7003fbfaaf87$export$458ab927ae635c3.from(types);
        // Get the normalized types
        types = encoder.types;
        const typesWithDomain = Object.assign({}, types);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)((0, $646c422fbb8bae38$export$a3521add2594f3c8)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "unsupported type", "type", type);
            })
        };
    }
}
function $ce7c7003fbfaaf87$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $fab11e657c863d96$export$23cc18f96d8510e2)($ce7c7003fbfaaf87$export$458ab927ae635c3.hash(domain, types, value), signature);
}




function $7113bd4426313aea$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $14cfbe985a29575c$export$88411125f012957a)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $7113bd4426313aea$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return $7113bd4426313aea$var$accessSetify(set[0], set[1]);
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return $7113bd4426313aea$var$accessSetify(set.address, set.storageKeys);
    });
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $7113bd4426313aea$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}


/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction that each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retrieve the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentication, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ // utils/base64-browser

function $11d8aa5479634e11$export$94fdf11bafc8de6b(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, $646c422fbb8bae38$export$a3521add2594f3c8)(data);
}
function $11d8aa5479634e11$export$8fb536984ec8b4d7(_data) {
    const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}







function $27441d86e695b732$export$d3950daf7bce5bf5(options) {
    async function getUrl(req, _signal) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(_signal == null || !_signal.cancelled, "request cancelled before sending", "CANCELLED");
        const protocol = req.url.split(":")[0].toLowerCase();
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
            info: {
                protocol: protocol
            },
            operation: "request"
        });
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
        });
        let error = null;
        const controller = new AbortController();
        const timer = setTimeout(()=>{
            error = (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("request timeout", "TIMEOUT");
            controller.abort();
        }, req.timeout);
        if (_signal) _signal.addListener(()=>{
            error = (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("request cancelled", "CANCELLED");
            controller.abort();
        });
        const init = {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal: controller.signal
        };
        let resp;
        try {
            resp = await fetch(req.url, init);
        } catch (_error) {
            clearTimeout(timer);
            if (error) throw error;
            throw _error;
        }
        clearTimeout(timer);
        const headers = {};
        resp.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        const respBody = await resp.arrayBuffer();
        const body = respBody == null ? null : new Uint8Array(respBody);
        return {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers: headers,
            body: body
        };
    }
    return getUrl;
}
// @TODO: remove in v7; provided for backwards compat
const $27441d86e695b732$var$defaultGetUrl = $27441d86e695b732$export$d3950daf7bce5bf5({});
async function $27441d86e695b732$export$94df0e59ebebf4a7(req, _signal) {
    return $27441d86e695b732$var$defaultGetUrl(req, _signal);
}


const $325c1311ee8826b4$var$MAX_ATTEMPTS = 12;
const $325c1311ee8826b4$var$SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let $325c1311ee8826b4$var$defaultGetUrlFunc = (0, $27441d86e695b732$export$d3950daf7bce5bf5)();
const $325c1311ee8826b4$var$reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const $325c1311ee8826b4$var$reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let $325c1311ee8826b4$var$locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function $325c1311ee8826b4$var$dataGatewayFunc(url, signal) {
    try {
        const match = url.match($325c1311ee8826b4$var$reData);
        if (!match) throw new Error("invalid data");
        return new $325c1311ee8826b4$export$3ae09bba5b6b906e(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, $11d8aa5479634e11$export$94fdf11bafc8de6b)(match[3]) : $325c1311ee8826b4$var$unpercent(match[3]));
    } catch (error) {
        return new $325c1311ee8826b4$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid data: URI)", {}, null, new $325c1311ee8826b4$export$319b96fe59834522(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function $325c1311ee8826b4$var$getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match($325c1311ee8826b4$var$reIpfs);
            if (!match) throw new Error("invalid link");
            return new $325c1311ee8826b4$export$319b96fe59834522(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new $325c1311ee8826b4$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new $325c1311ee8826b4$export$319b96fe59834522(url));
        }
    }
    return gatewayIpfs;
}
const $325c1311ee8826b4$var$Gateways = {
    "data": $325c1311ee8826b4$var$dataGatewayFunc,
    "ipfs": $325c1311ee8826b4$var$getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
};
const $325c1311ee8826b4$var$fetchSignals = new WeakMap();
class $325c1311ee8826b4$export$ef5e7a6febaa4c8b {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        $325c1311ee8826b4$var$fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function $325c1311ee8826b4$var$checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class $325c1311ee8826b4$export$319b96fe59834522 {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    #getUrlFunc;
    /**
     *  The fetch URL to request.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, $11d8aa5479634e11$export$8fb536984ec8b4d7)((0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */ get getUrlFunc() {
        return this.#getUrlFunc || $325c1311ee8826b4$var$defaultGetUrlFunc;
    }
    set getUrlFunc(value) {
        this.#getUrlFunc = value;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: $325c1311ee8826b4$var$SLOT_INTERVAL,
            maxAttempts: $325c1311ee8826b4$var$MAX_ATTEMPTS
        };
        this.#getUrlFunc = null;
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, $bb8e52d338877b37$export$a7a9523472993e97)($325c1311ee8826b4$var$getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await $325c1311ee8826b4$var$wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in $325c1311ee8826b4$var$Gateways) {
            const result = await $325c1311ee8826b4$var$Gateways[scheme](req.url, $325c1311ee8826b4$var$checkSignal(_request.#signal));
            if (result instanceof $325c1311ee8826b4$export$3ae09bba5b6b906e) {
                let response = result;
                if (this.processFunc) {
                    $325c1311ee8826b4$var$checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await this.getUrlFunc(req, $325c1311ee8826b4$var$checkSignal(_request.#signal));
        let response = new $325c1311ee8826b4$export$3ae09bba5b6b906e(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            $325c1311ee8826b4$var$checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new $325c1311ee8826b4$export$ef5e7a6febaa4c8b(this);
        return this.#send(0, $325c1311ee8826b4$var$getTime() + this.timeout, 0, this, new $325c1311ee8826b4$export$3ae09bba5b6b906e(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = $325c1311ee8826b4$var$fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locations
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new $325c1311ee8826b4$export$319b96fe59834522(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new $325c1311ee8826b4$export$319b96fe59834522(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        clone.#throttle = Object.assign({}, this.#throttle);
        clone.#getUrlFunc = this.#getUrlFunc;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        $325c1311ee8826b4$var$locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return $325c1311ee8826b4$var$Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if ($325c1311ee8826b4$var$locked) throw new Error("gateways locked");
        $325c1311ee8826b4$var$Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if ($325c1311ee8826b4$var$locked) throw new Error("gateways locked");
        $325c1311ee8826b4$var$defaultGetUrlFunc = getUrl;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */ static createGetUrlFunc(options) {
        return (0, $27441d86e695b732$export$d3950daf7bce5bf5)(options);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return $325c1311ee8826b4$var$dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return $325c1311ee8826b4$var$getIpfsGatewayFunc(baseUrl);
    }
}
class $325c1311ee8826b4$export$3ae09bba5b6b906e {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, $bd5f6433d45dd8bb$export$7643a1dc2c38d5eb)(this.#body);
        } catch (error) {
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new $325c1311ee8826b4$export$3ae09bba5b6b906e(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message: message,
            error: error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(error, {
            stall: stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message: message, error: error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        let requestUrl = null;
        if (this.request) requestUrl = this.request.url;
        let responseBody = null;
        try {
            if (this.#body) responseBody = (0, $bd5f6433d45dd8bb$export$7643a1dc2c38d5eb)(this.#body);
        } catch (e) {}
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error: error,
            info: {
                requestUrl: requestUrl,
                responseBody: responseBody,
                responseStatus: `${this.statusCode} ${this.statusMessage}`
            }
        });
    }
}
function $325c1311ee8826b4$var$getTime() {
    return new Date().getTime();
}
function $325c1311ee8826b4$var$unpercent(value) {
    return (0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $325c1311ee8826b4$var$wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}


/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.

/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ const $ad62383365eb9d5a$export$b7cbe423ba83da17 = "0x0000000000000000000000000000000000000000";


/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ 






class $fbac6e59db866ec3$export$c2ab6499be98b3c5 {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            signature: signature,
            topic: topic,
            args: args
        });
    }
}
class $fbac6e59db866ec3$export$7a3223b0fadb690b {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector,
            value: value
        });
    }
}
class $fbac6e59db866ec3$export$cfba08fc0e40e2ab {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector
        });
    }
}
class $fbac6e59db866ec3$export$8ef99100a3c56f8c {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            hash: hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const $fbac6e59db866ec3$var$PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const $fbac6e59db866ec3$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && $fbac6e59db866ec3$var$PanicReasons[code.toString()]) reason = $fbac6e59db866ec3$var$PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class $fbac6e59db866ec3$export$48cefb51a4e315b2 {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, $e74cf180ae7e3889$export$ffb0004e005737fa).from(a));
        } catch (error) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
        }
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            deploy: (0, $e74cf180ae7e3889$export$3ac5c9504f801ea4).from("constructor()")
        });
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            fallback: fallback,
            receive: receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, $dfec5cc4eff24eb3$export$fe041e1a83d3efc6).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, $784e1baa090f7919$export$af51273277efe223).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $784e1baa090f7919$export$af51273277efe223).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, $e74cf180ae7e3889$export$8d576c928b93668f).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $784e1baa090f7919$export$af51273277efe223).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, $e74cf180ae7e3889$export$958548f08bac2833).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            if ($fbac6e59db866ec3$var$BuiltinErrors[selector]) return (0, $e74cf180ae7e3889$export$2c42c6d543aa9b59).from($fbac6e59db866ec3$var$BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, $e74cf180ae7e3889$export$2c42c6d543aa9b59).from("error Error(string)");
                if (key === "Panic") return (0, $e74cf180ae7e3889$export$2c42c6d543aa9b59).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, $e74cf180ae7e3889$export$2c42c6d543aa9b59).from(key).format();
        if (key === "Error(string)") return (0, $e74cf180ae7e3889$export$2c42c6d543aa9b59).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, $e74cf180ae7e3889$export$2c42c6d543aa9b59).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, $646c422fbb8bae38$export$37110e7fee0af4ad)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, message, "BAD_DATA", {
            value: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_data, "data");
        const error = (0, $dfec5cc4eff24eb3$export$fe041e1a83d3efc6).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args: args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $1e8739595920e30f$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)((0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, $80785c90802caadd$export$c6ebe05badb16181)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, $646c422fbb8bae38$export$1dc7fbe1b8738fe7)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $646c422fbb8bae38$export$4473860254365feb)((0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $1e8739595920e30f$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $eb8e34a59f49e216$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $e74cf180ae7e3889$export$426dc07f493a4c47).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new $fbac6e59db866ec3$export$8ef99100a3c56f8c(null);
                else if (dynamic[index]) value = new $fbac6e59db866ec3$export$8ef99100a3c56f8c(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, $9d29f608d1beea97$export$8fdcabde73f49165).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(tx.data, "tx.data");
        const value = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new $fbac6e59db866ec3$export$7a3223b0fadb690b(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $fbac6e59db866ec3$export$c2ab6499be98b3c5(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data);
        const fragment = this.getError((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(hexData, 4));
        return new $fbac6e59db866ec3$export$cfba08fc0e40e2ab(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof $fbac6e59db866ec3$export$48cefb51a4e315b2) return value;
        // JSON
        if (typeof value === "string") return new $fbac6e59db866ec3$export$48cefb51a4e315b2(JSON.parse(value));
        // An Interface; possibly from another v6 instance
        if (typeof value.formatJson === "function") return new $fbac6e59db866ec3$export$48cefb51a4e315b2(value.formatJson());
        // A legacy Interface; from an older version
        if (typeof value.format === "function") return new $fbac6e59db866ec3$export$48cefb51a4e315b2(value.format("json"));
        // Array of fragments
        return new $fbac6e59db866ec3$export$48cefb51a4e315b2(value);
    }
}



//import { resolveAddress } from "@ethersproject/address";


const $991b98fda7342cdd$var$BN_0 = BigInt(0);
// -----------------------
function $991b98fda7342cdd$var$getValue(value) {
    if (value == null) return null;
    return value;
}
function $991b98fda7342cdd$var$toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class $991b98fda7342cdd$export$116c49c1e2a96a78 {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            gasPrice: $991b98fda7342cdd$var$getValue(gasPrice),
            maxFeePerGas: $991b98fda7342cdd$var$getValue(maxFeePerGas),
            maxPriorityFeePerGas: $991b98fda7342cdd$var$getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: $991b98fda7342cdd$var$toJson(gasPrice),
            maxFeePerGas: $991b98fda7342cdd$var$toJson(maxFeePerGas),
            maxPriorityFeePerGas: $991b98fda7342cdd$var$toJson(maxPriorityFeePerGas)
        };
    }
}
function $991b98fda7342cdd$export$607b34cdac162b7f(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $80785c90802caadd$export$b14f2714108df84)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, $7113bd4426313aea$export$6c8662b1600dce2)(req.accessList);
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    if ("blobVersionedHashes" in req && req.blobVersionedHashes) result.blobVersionedHashes = req.blobVersionedHashes.slice();
    if ("kzg" in req) result.kzg = req.kzg;
    if ("blobs" in req && req.blobs) result.blobs = req.blobs.map((b)=>{
        if ((0, $646c422fbb8bae38$export$9a14abb1a440cd5e)(b)) return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(b);
        return Object.assign({}, b);
    });
    return result;
}
class $991b98fda7342cdd$export$d96a8827a60d6b69 {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */ parentBeaconBlockRoot;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */ stateRoot;
    /**
     *  The hash of the transaction receipts trie.
     */ receiptsRoot;
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */ excessBlobGas;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */ prevRandao;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new $991b98fda7342cdd$export$70966cdb3bfc0785(tx, provider);
            return tx;
        });
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            provider: provider,
            hash: $991b98fda7342cdd$var$getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            parentBeaconBlockRoot: block.parentBeaconBlockRoot,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            blobGasUsed: block.blobGasUsed,
            excessBlobGas: block.excessBlobGas,
            miner: block.miner,
            prevRandao: $991b98fda7342cdd$var$getValue(block.prevRandao),
            extraData: block.extraData,
            baseFeePerGas: $991b98fda7342cdd$var$getValue(block.baseFeePerGas),
            stateRoot: block.stateRoot,
            receiptsRoot: block.receiptsRoot
        });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas: baseFeePerGas, difficulty: difficulty, extraData: extraData, gasLimit: gasLimit, gasUsed: gasUsed, hash: hash, miner: miner, prevRandao: prevRandao, nonce: nonce, number: number, parentHash: parentHash, parentBeaconBlockRoot: parentBeaconBlockRoot, stateRoot: stateRoot, receiptsRoot: receiptsRoot, timestamp: timestamp, transactions: transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: $991b98fda7342cdd$var$toJson(baseFeePerGas),
            difficulty: $991b98fda7342cdd$var$toJson(difficulty),
            extraData: extraData,
            gasLimit: $991b98fda7342cdd$var$toJson(gasLimit),
            gasUsed: $991b98fda7342cdd$var$toJson(gasUsed),
            blobGasUsed: $991b98fda7342cdd$var$toJson(this.blobGasUsed),
            excessBlobGas: $991b98fda7342cdd$var$toJson(this.excessBlobGas),
            hash: hash,
            miner: miner,
            prevRandao: prevRandao,
            nonce: nonce,
            number: number,
            parentHash: parentHash,
            timestamp: timestamp,
            parentBeaconBlockRoot: parentBeaconBlockRoot,
            stateRoot: stateRoot,
            receiptsRoot: receiptsRoot,
            transactions: transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash === hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return $991b98fda7342cdd$var$createOrphanedBlockFilter(this);
    }
}
class $991b98fda7342cdd$export$ce30dbb46644d06c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics: topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address: address, blockHash: blockHash, blockNumber: blockNumber, data: data, index: index, removed: removed, topics: topics, transactionHash: transactionHash, transactionIndex: transactionIndex } = this;
        return {
            _type: "log",
            address: address,
            blockHash: blockHash,
            blockNumber: blockNumber,
            data: data,
            index: index,
            removed: removed,
            topics: topics,
            transactionHash: transactionHash,
            transactionIndex: transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $991b98fda7342cdd$var$createRemovedLogFilter(this);
    }
}
class $991b98fda7342cdd$export$375ffd5683aa5c1c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was sent to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */ blobGasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new $991b98fda7342cdd$export$ce30dbb46644d06c(log, provider);
        }));
        let gasPrice = $991b98fda7342cdd$var$BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            provider: provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            blobGasUsed: tx.blobGasUsed,
            gasPrice: gasPrice,
            blobGasPrice: tx.blobGasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to: to, from: from, contractAddress: contractAddress, hash: hash, index: index, blockHash: blockHash, blockNumber: blockNumber, logsBloom: logsBloom, logs: logs, status: status, root: root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash: blockHash,
            blockNumber: blockNumber,
            contractAddress: //byzantium, 
            contractAddress,
            cumulativeGasUsed: $991b98fda7342cdd$var$toJson(this.cumulativeGasUsed),
            from: from,
            gasPrice: $991b98fda7342cdd$var$toJson(this.gasPrice),
            blobGasUsed: $991b98fda7342cdd$var$toJson(this.blobGasUsed),
            blobGasPrice: $991b98fda7342cdd$var$toJson(this.blobGasPrice),
            gasUsed: $991b98fda7342cdd$var$toJson(this.gasUsed),
            hash: hash,
            index: index,
            logs: logs,
            logsBloom: logsBloom,
            root: root,
            status: status,
            to: to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $991b98fda7342cdd$var$createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return $991b98fda7342cdd$var$createReorderedTransactionFilter(this, other);
    }
}
class $991b98fda7342cdd$export$70966cdb3bfc0785 {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */ maxFeePerBlobGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */ blobVersionedHashes;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber: blockNumber, blockHash: blockHash, index: index, hash: hash, type: type, to: to, from: from, nonce: nonce, data: data, signature: signature, accessList: accessList, blobVersionedHashes: blobVersionedHashes } = this;
        return {
            _type: "TransactionResponse",
            accessList: accessList,
            blockNumber: blockNumber,
            blockHash: blockHash,
            blobVersionedHashes: blobVersionedHashes,
            chainId: $991b98fda7342cdd$var$toJson(this.chainId),
            data: data,
            from: from,
            gasLimit: $991b98fda7342cdd$var$toJson(this.gasLimit),
            gasPrice: $991b98fda7342cdd$var$toJson(this.gasPrice),
            hash: hash,
            maxFeePerGas: $991b98fda7342cdd$var$toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: $991b98fda7342cdd$var$toJson(this.maxPriorityFeePerGas),
            maxFeePerBlobGas: $991b98fda7342cdd$var$toJson(this.maxFeePerBlobGas),
            nonce: nonce,
            signature: signature,
            to: to,
            index: index,
            type: type,
            value: $991b98fda7342cdd$var$toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx: tx, blockNumber: blockNumber } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber: blockNumber, nonce: nonce } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === $991b98fda7342cdd$var$BN_0) reason = "cancelled";
                        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason: reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt: receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt: receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $991b98fda7342cdd$var$createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $991b98fda7342cdd$var$createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new $991b98fda7342cdd$export$70966cdb3bfc0785(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function $991b98fda7342cdd$var$createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function $991b98fda7342cdd$var$createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx: tx,
        other: other
    };
}
function $991b98fda7342cdd$var$createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx: tx
    };
}
function $991b98fda7342cdd$var$createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}



// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider

/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ 
class $74fe9324908d292c$export$9cec82196983b278 {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            emitter: emitter,
            filter: filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}


class $1f041bdadc4fe980$export$f8203d08df5cd081 extends (0, $991b98fda7342cdd$export$ce30dbb46644d06c) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class $1f041bdadc4fe980$export$53f6e6acc02bf489 extends (0, $991b98fda7342cdd$export$ce30dbb46644d06c) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            error: error
        });
    }
}
class $1f041bdadc4fe980$export$86bdc83e93503686 extends (0, $991b98fda7342cdd$export$375ffd5683aa5c1c) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new $1f041bdadc4fe980$export$f8203d08df5cd081(log, this.#iface, fragment);
            } catch (error) {
                return new $1f041bdadc4fe980$export$53f6e6acc02bf489(log, error);
            }
            return log;
        });
    }
}
class $1f041bdadc4fe980$export$853f7e2df34220ff extends (0, $991b98fda7342cdd$export$70966cdb3bfc0785) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms, timeout) {
        const receipt = await super.wait(confirms, timeout);
        if (receipt == null) return null;
        return new $1f041bdadc4fe980$export$86bdc83e93503686(this.#iface, this.provider, receipt);
    }
}
class $1f041bdadc4fe980$export$54be5ec94ad26a69 extends (0, $74fe9324908d292c$export$9cec82196983b278) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            log: log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class $1f041bdadc4fe980$export$35f9272dc1c07dee extends $1f041bdadc4fe980$export$54be5ec94ad26a69 {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new $1f041bdadc4fe980$export$f8203d08df5cd081(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}


const $89a5854c4eb82178$var$BN_0 = BigInt(0);
function $89a5854c4eb82178$var$canCall(value) {
    return value && typeof value.call === "function";
}
function $89a5854c4eb82178$var$canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function $89a5854c4eb82178$var$canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function $89a5854c4eb82178$var$canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
function $89a5854c4eb82178$var$getResolver(value) {
    if (value != null) {
        if ($89a5854c4eb82178$var$canResolve(value)) return value;
        if (value.provider) return value.provider;
    }
    return undefined;
}
class $89a5854c4eb82178$var$PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            fragment: fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = $89a5854c4eb82178$var$getRunner(contract.runner, "resolveName");
        const resolver = $89a5854c4eb82178$var$canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, $06f9d9d760226a67$export$687eed6b344123c9)(v, resolver)));
                        return (0, $06f9d9d760226a67$export$687eed6b344123c9)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function $89a5854c4eb82178$var$getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function $89a5854c4eb82178$var$getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function $89a5854c4eb82178$export$fc358dcec4fec380(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, $784e1baa090f7919$export$af51273277efe223).dereference(arg, "overrides");
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, $991b98fda7342cdd$export$607b34cdac162b7f)(_overrides);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = overrides.from;
    return overrides;
}
async function $89a5854c4eb82178$export$32e61c94d45e7108(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = $89a5854c4eb82178$var$getRunner(_runner, "resolveName");
    const resolver = $89a5854c4eb82178$var$canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, $784e1baa090f7919$export$af51273277efe223).dereference(value, type);
            if (type === "address") return (0, $06f9d9d760226a67$export$687eed6b344123c9)(value, resolver);
            return value;
        });
    }));
}
function $89a5854c4eb82178$var$buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await $89a5854c4eb82178$export$fc358dcec4fec380(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        if (tx.from) tx.from = await (0, $06f9d9d760226a67$export$687eed6b344123c9)(tx.from, $89a5854c4eb82178$var$getResolver(contract.runner));
        const iface = contract.interface;
        const noValue = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(tx.value || $89a5854c4eb82178$var$BN_0, "overrides.value") === $89a5854c4eb82178$var$BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = $89a5854c4eb82178$var$getRunner(contract.runner, "call");
        (0, $bb8e52d338877b37$export$a7a9523472993e97)($89a5854c4eb82178$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, $bb8e52d338877b37$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, $bb8e52d338877b37$export$a7a9523472993e97)($89a5854c4eb82178$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = $89a5854c4eb82178$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $1f041bdadc4fe980$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = $89a5854c4eb82178$var$getRunner(contract.runner, "estimateGas");
        (0, $bb8e52d338877b37$export$a7a9523472993e97)($89a5854c4eb82178$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(method, {
        _contract: contract,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall
    });
    return method;
}
function $89a5854c4eb82178$var$buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) {
            overrides = await $89a5854c4eb82178$export$fc358dcec4fec380(args.pop());
            if (overrides.from) overrides.from = await (0, $06f9d9d760226a67$export$687eed6b344123c9)(overrides.from, $89a5854c4eb82178$var$getResolver(contract.runner));
        }
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await $89a5854c4eb82178$export$32e61c94d45e7108(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, $bb8e52d338877b37$export$a7a9523472993e97)($89a5854c4eb82178$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = $89a5854c4eb82178$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $1f041bdadc4fe980$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = $89a5854c4eb82178$var$getRunner(contract.runner, "estimateGas");
        (0, $bb8e52d338877b37$export$a7a9523472993e97)($89a5854c4eb82178$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = $89a5854c4eb82178$var$getRunner(contract.runner, "call");
        (0, $bb8e52d338877b37$export$a7a9523472993e97)($89a5854c4eb82178$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, $bb8e52d338877b37$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall,
        staticCallResult: staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
function $89a5854c4eb82178$var$buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new $89a5854c4eb82178$var$PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const $89a5854c4eb82178$var$internal = Symbol.for("_ethersInternal_contract");
const $89a5854c4eb82178$var$internalValues = new WeakMap();
function $89a5854c4eb82178$var$setInternal(contract, values) {
    $89a5854c4eb82178$var$internalValues.set(contract[$89a5854c4eb82178$var$internal], values);
}
function $89a5854c4eb82178$var$getInternal(contract) {
    return $89a5854c4eb82178$var$internalValues.get(contract[$89a5854c4eb82178$var$internal]);
}
function $89a5854c4eb82178$var$isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function $89a5854c4eb82178$var$getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if ($89a5854c4eb82178$var$isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment: fragment,
        tag: tag,
        topics: topics
    };
}
async function $89a5854c4eb82178$var$hasSub(contract, event) {
    const { subs: subs } = $89a5854c4eb82178$var$getInternal(contract);
    return subs.get((await $89a5854c4eb82178$var$getSubInfo(contract, event)).tag) || null;
}
async function $89a5854c4eb82178$var$getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = $89a5854c4eb82178$var$getProvider(contract.runner);
    (0, $bb8e52d338877b37$export$a7a9523472993e97)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
    const { fragment: fragment, tag: tag, topics: topics } = await $89a5854c4eb82178$var$getSubInfo(contract, event);
    const { addr: addr, subs: subs } = $89a5854c4eb82178$var$getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address: address,
            topics: topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                $89a5854c4eb82178$var$emit(contract, event, args, (listener)=>{
                    return new (0, $1f041bdadc4fe980$export$35f9272dc1c07dee)(contract, listener, event, _foundFragment, log);
                });
            } else $89a5854c4eb82178$var$emit(contract, event, [], (listener)=>{
                return new (0, $1f041bdadc4fe980$export$54be5ec94ad26a69)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag: tag,
            listeners: [],
            start: start,
            stop: stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let $89a5854c4eb82178$var$lastEmit = Promise.resolve();
async function $89a5854c4eb82178$var$_emit(contract, event, args, payloadFunc) {
    await $89a5854c4eb82178$var$lastEmit;
    const sub = await $89a5854c4eb82178$var$hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        $89a5854c4eb82178$var$getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function $89a5854c4eb82178$var$emit(contract, event, args, payloadFunc) {
    try {
        await $89a5854c4eb82178$var$lastEmit;
    } catch (error) {}
    const resultPromise = $89a5854c4eb82178$var$_emit(contract, event, args, payloadFunc);
    $89a5854c4eb82178$var$lastEmit = resultPromise;
    return await resultPromise;
}
const $89a5854c4eb82178$var$passProperties = [
    "then"
];
class $89a5854c4eb82178$export$304faa4fc17528db {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [$89a5854c4eb82178$var$internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof target === "string" || (0, $06f9d9d760226a67$export$6a88e03bca5eb759)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, $fbac6e59db866ec3$export$48cefb51a4e315b2).from(abi);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            target: target,
            runner: runner,
            interface: iface
        });
        Object.defineProperty(this, $89a5854c4eb82178$var$internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = $89a5854c4eb82178$var$getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, $1f041bdadc4fe980$export$853f7e2df34220ff)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = $89a5854c4eb82178$var$getRunner(runner, "resolveName");
                if (!$89a5854c4eb82178$var$canResolve(resolver)) throw (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    $89a5854c4eb82178$var$getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            $89a5854c4eb82178$var$getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        $89a5854c4eb82178$var$setInternal(this, {
            addrPromise: addrPromise,
            addr: addr,
            deployTx: deployTx,
            subs: subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || $89a5854c4eb82178$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if ($89a5854c4eb82178$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            filters: filters
        });
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            fallback: iface.receive || iface.fallback ? $89a5854c4eb82178$var$buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || $89a5854c4eb82178$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || $89a5854c4eb82178$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new $89a5854c4eb82178$export$304faa4fc17528db(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new $89a5854c4eb82178$export$304faa4fc17528db(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await $89a5854c4eb82178$var$getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = $89a5854c4eb82178$var$getProvider(this.runner);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = $89a5854c4eb82178$var$getProvider(this.runner);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return $89a5854c4eb82178$var$getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = $89a5854c4eb82178$var$buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return $89a5854c4eb82178$var$buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr: addr, addrPromise: addrPromise } = $89a5854c4eb82178$var$getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment: fragment, topics: topics } = await $89a5854c4eb82178$var$getSubInfo(this, event);
        const filter = {
            address: address,
            topics: topics,
            fromBlock: fromBlock,
            toBlock: toBlock
        };
        const provider = $89a5854c4eb82178$var$getProvider(this.runner);
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, $1f041bdadc4fe980$export$f8203d08df5cd081)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, $1f041bdadc4fe980$export$53f6e6acc02bf489)(log, error);
            }
            return new (0, $991b98fda7342cdd$export$ce30dbb46644d06c)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await $89a5854c4eb82178$var$getSub(this, "on", event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await $89a5854c4eb82178$var$getSub(this, "once", event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await $89a5854c4eb82178$var$emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await $89a5854c4eb82178$var$hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs: subs } = $89a5854c4eb82178$var$getInternal(this);
        let total = 0;
        for (const { listeners: listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await $89a5854c4eb82178$var$hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        const { subs: subs } = $89a5854c4eb82178$var$getInternal(this);
        let result = [];
        for (const { listeners: listeners } of subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await $89a5854c4eb82178$var$hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            $89a5854c4eb82178$var$getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await $89a5854c4eb82178$var$hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            $89a5854c4eb82178$var$getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs: subs } = $89a5854c4eb82178$var$getInternal(this);
            for (const { tag: tag, stop: stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends $89a5854c4eb82178$export$304faa4fc17528db {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function $89a5854c4eb82178$var$_ContractBase() {
    return $89a5854c4eb82178$export$304faa4fc17528db;
}
class $89a5854c4eb82178$export$8517d80acf00e19a extends $89a5854c4eb82178$var$_ContractBase() {
}




// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $b5d77f1d2ca865aa$var$COMPRESSED$1 = "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";
const $b5d77f1d2ca865aa$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $b5d77f1d2ca865aa$var$NSM_MAX = 4;
function $b5d77f1d2ca865aa$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $b5d77f1d2ca865aa$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $b5d77f1d2ca865aa$var$read_compressed_payload(s) {
    return $b5d77f1d2ca865aa$var$read_payload($b5d77f1d2ca865aa$var$decode_arithmetic($b5d77f1d2ca865aa$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $b5d77f1d2ca865aa$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $b5d77f1d2ca865aa$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $b5d77f1d2ca865aa$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $b5d77f1d2ca865aa$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $b5d77f1d2ca865aa$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $b5d77f1d2ca865aa$var$read_sorted_arrays(next) {
    return $b5d77f1d2ca865aa$var$read_array_while(()=>{
        let v = $b5d77f1d2ca865aa$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $b5d77f1d2ca865aa$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($b5d77f1d2ca865aa$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($b5d77f1d2ca865aa$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $b5d77f1d2ca865aa$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $b5d77f1d2ca865aa$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$b5d77f1d2ca865aa$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $b5d77f1d2ca865aa$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $b5d77f1d2ca865aa$var$read_array_while(next);
    let m = $b5d77f1d2ca865aa$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $b5d77f1d2ca865aa$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $b5d77f1d2ca865aa$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $b5d77f1d2ca865aa$var$read_trie(next) {
    let ret = [];
    let sorted = $b5d77f1d2ca865aa$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $b5d77f1d2ca865aa$var$read_array_while(()=>{
            let cps = $b5d77f1d2ca865aa$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $b5d77f1d2ca865aa$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $b5d77f1d2ca865aa$var$quote_cp(cp) {
    return `{${$b5d77f1d2ca865aa$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $b5d77f1d2ca865aa$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $b5d77f1d2ca865aa$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $b5d77f1d2ca865aa$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $b5d77f1d2ca865aa$var$COMPRESSED = "AEUDTAHBCFQATQDRADAAcgAgADQAFAAsABQAHwAOACQADQARAAoAFwAHABIACAAPAAUACwAFAAwABAAQAAMABwAEAAoABQAIAAIACgABAAQAFAALAAIACwABAAIAAQAHAAMAAwAEAAsADAAMAAwACgANAA0AAwAKAAkABAAdAAYAZwDSAdsDJgC0CkMB8xhZAqfoC190UGcThgBurwf7PT09Pb09AjgJum8OjDllxHYUKXAPxzq6tABAxgK8ysUvWAgMPT09PT09PSs6LT2HcgWXWwFLoSMEEEl5RFVMKvO0XQ8ExDdJMnIgsj26PTQyy8FfEQ8AY8IPAGcEbwRwBHEEcgRzBHQEdQR2BHcEeAR6BHsEfAR+BIAEgfndBQoBYgULAWIFDAFiBNcE2ATZBRAFEQUvBdALFAsVDPcNBw13DYcOMA4xDjMB4BllHI0B2grbAMDpHLkQ7QHVAPRNQQFnGRUEg0yEB2uaJF8AJpIBpob5AERSMAKNoAXqaQLUBMCzEiACnwRZEkkVsS7tANAsBG0RuAQLEPABv9HICTUBXigPZwRBApMDOwAamhtaABqEAY8KvKx3LQ4ArAB8UhwEBAVSagD8AEFZADkBIadVj2UMUgx5Il4ANQC9AxIB1BlbEPMAs30CGxlXAhwZKQIECBc6EbsCoxngzv7UzRQA8M0BawL6ZwkN7wABAD33OQRcsgLJCjMCjqUChtw/km+NAsXPAoP2BT84PwURAK0RAvptb6cApQS/OMMey5HJS84UdxpxTPkCogVFITaTOwERAK5pAvkNBOVyA7q3BKlOJSALAgUIBRcEdASpBXqzABXFSWZOawLCOqw//AolCZdvv3dSBkEQGyelEPcMMwG1ATsN7UvYBPEGOwTJH30ZGQ/NlZwIpS3dDO0m4y6hgFoj9SqDBe1L9DzdC01RaA9ZC2UJ4zpjgU4DIQENIosK3Q05CG0Q8wrJaw3lEUUHOQPVSZoApQcBCxEdNRW1JhBirAsJOXcG+xr2C48mrxMpevwF0xohBk0BKRr/AM8u54WwWjFcHE9fBgMLJSPHFKhQIA0lQLd4SBobBxUlqQKRQ3BKh1E2HpMh9jw9DWYuE1F8B/U8BRlPC4E8nkarRQ4R0j6NPUgiSUwsBDV/LC8niwnPD4UMuXxyAVkJIQmxDHETMREXN8UIOQcZLZckJxUIIUaVYJoE958D8xPRAwsFPwlBBxMDtRwtEy4VKQUNgSTXAvM21S6zAo9WgAEXBcsPJR/fEFBH4A7pCJsCZQODJesALRUhABcimwhDYwBfj9hTBS7LCMdqbCN0A2cU52ERcweRDlcHpxwzFb8c4XDIXguGCCijrwlbAXUJmQFfBOMICTVbjKAgQWdTi1gYmyBhQT9d/AIxDGUVn0S9h3gCiw9rEhsBNQFzBzkNAQJ3Ee0RaxCVCOuGBDW1M/g6JQRPIYMgEQonA09szgsnJvkM+GkBoxJiAww0PXfuZ6tgtiQX/QcZMsVBYCHxC5JPzQycGsEYQlQuGeQHvwPzGvMn6kFXBf8DowMTOk0z7gS9C2kIiwk/AEkOoxcH1xhqCnGM0AExiwG3mQNXkYMCb48GNwcLAGcLhwV55QAdAqcIowAFAM8DVwA5Aq0HnQAZAIVBAT0DJy8BIeUCjwOTCDHLAZUvAfMpBBvDDBUA9zduSgLDsQKAamaiBd1YAo4CSTUBTSUEBU5HUQOvceEA2wBLBhPfRwEVq0rLGuNDAd9vKwDHAPsABTUHBUEBzQHzbQC3AV8LMQmis7UBTekpAIMAFWsB1wKJAN0ANQB/8QFTAE0FWfkF0wJPSQERMRgrV2EBuwMfATMBDQB5BsuNpckHHwRtB9MCEBsV4QLvLge1AQMi3xPNQsUCvd5VoWACZIECYkJbTa9bNyACofcCaJgCZgkCn4Q4GwsCZjsCZiYEbgR/A38TA36SOQY5dxc5gjojIwJsHQIyNjgKAm3HAm2u74ozZ0UrAWcA3gDhAEoFB5gMjQD+C8IADbUCdy8CdqI/AnlLQwJ4uh1c20WuRtcCfD8CesgCfQkCfPAFWQUgSABIfWMkAoFtAoAAAoAFAn+uSVhKWxUXSswC0QEC0MxLJwOITwOH5kTFkTIC8qFdAwMDrkvOTC0lA89NTE2vAos/AorYwRsHHUNnBbcCjjcCjlxAl4ECjtkCjlx4UbRTNQpS1FSFApP7ApMMAOkAHFUeVa9V0AYsGymVhjLheGZFOzkCl58C77JYIagAWSUClo8ClnycAKlZrFoJgU0AOwKWtQKWTlxEXNECmcsCmWRcyl0HGQKcmznCOp0CnBYCn5sCnriKAB0PMSoPAp3xAp6SALU9YTRh7wKe0wKgbgGpAp6fHwKeTqVjyGQnJSsCJ68CJn4CoPsCoEwCot0CocQCpi8Cpc4Cp/8AfQKn8mh8aLEAA0lqHGrRAqzjAqyuAq1nAq0CAlcdAlXcArHh1wMfTmyXArK9DQKy6Bds4G1jbUhfAyXNArZcOz9ukAMpRQK4XgK5RxUCuSp3cDZw4QK9GQK72nCWAzIRAr6IcgIDM3ECvhpzInNPAsPLAsMEc4J0SzVFdOADPKcDPJoDPb8CxXwCxkcCxhCJAshpUQLIRALJTwLJLgJknQLd0nh5YXiueSVL0AMYo2cCAmH0GfOVJHsLXpJeuxECz2sCz2wvS1PS8xOfAMatAs9zASnqA04SfksFAtwnAtuKAtJPA1JcA1NfAQEDVYyAiT8AyxbtYEWCHILTgs6DjQLaxwLZ3oQQhEmnPAOGpQAvA2QOhnFZ+QBVAt9lAt64c3cC4i/tFAHzMCcB9JsB8tKHAuvzAulweQLq+QLq5AD5RwG5Au6JAuuclqqXAwLuPwOF4Jh5cOBxoQLzAwBpA44WmZMC9xMDkW4DkocC95gC+dkC+GaaHJqruzebHgOdgwL++gEbADmfHJ+zAwWNA6ZqA6bZANHFAwZqoYiiBQkDDEkCwAA/AwDhQRdTARHzA2sHl2cFAJMtK7evvdsBiZkUfxEEOQH7KQUhDp0JnwCS/SlXxQL3AZ0AtwW5AG8LbUEuFCaNLgFDAYD8AbUmAHUDDgRtACwCFgyhAAAKAj0CagPdA34EkQEgRQUhfAoABQBEABMANhICdwEABdUDa+8KxQIA9wqfJ7+xt+UBkSFBQgHpFH8RNMCJAAQAGwBaAkUChIsABjpTOpSNbQC4Oo860ACNOME63AClAOgAywE6gTo7Ofw5+Tt2iTpbO56JOm85GAFWATMBbAUvNV01njWtNWY1dTW2NcU1gjWRNdI14TWeNa017jX9NbI1wTYCNhE1xjXVNhY2JzXeNe02LjY9Ni41LSE2OjY9Njw2yTcIBJA8VzY4Nt03IDcPNsogN4k3MAoEsDxnNiQ3GTdsOo03IULUQwdC4EMLHA8PCZsobShRVQYA6X8A6bABFCnXAukBowC9BbcAbwNzBL8MDAMMAQgDAAkKCwsLCQoGBAVVBI/DvwDz9b29kaUCb0QtsRTNLt4eGBcSHAMZFhYZEhYEARAEBUEcQRxBHEEcQRxBHEEaQRxBHEFCSTxBPElISUhBNkM2QTYbNklISVmBVIgBFLWZAu0BhQCjBcEAbykBvwGJAaQcEZ0ePCklMAAhMvAIMAL54gC7Bm8EescjzQMpARQpKgDUABavAj626xQAJP0A3etzuf4NNRA7efy2Z9NQrCnC0OSyANz5BBIbJ5IFDR6miIavYS6tprjjmuKebxm5C74Q225X1pkaYYPb6f1DK4k3xMEBb9S2WMjEibTNWhsRJIA+vwNVEiXTE5iXs/wezV66oFLfp9NZGYW+Gk19J2+bCT6Ye2w6LDYdgzKMUabk595eLBCXANz9HUpWbATq9vqXVx9XDg+Pc9Xp4+bsS005SVM/BJBM4687WUuf+Uj9dEi8aDNaPxtpbDxcG1THTImUMZq4UCaaNYpsVqraNyKLJXDYsFZ/5jl7bLRtO88t7P3xZaAxhb5OdPMXqsSkp1WCieG8jXm1U99+blvLlXzPCS+M93VnJCiK+09LfaSaBAVBomyDgJua8dfUzR7ga34IvR2Nvj+A9heJ6lsl1KG4NkI1032Cnff1m1wof2B9oHJK4bi6JkEdSqeNeiuo6QoZZincoc73/TH9SXF8sCE7XyuYyW8WSgbGFCjPV0ihLKhdPs08Tx82fYAkLLc4I2wdl4apY7GU5lHRFzRWJep7Ww3wbeA3qmd59/86P4xuNaqDpygXt6M85glSBHOCGgJDnt+pN9bK7HApMguX6+06RZNjzVmcZJ+wcUrJ9//bpRNxNuKpNl9uFds+S9tdx7LaM5ZkIrPj6nIU9mnbFtVbs9s/uLgl8MVczAwet+iOEzzBlYW7RCMgE6gyNLeq6+1tIx4dpgZnd0DksJS5f+JNDpwwcPNXaaVspq1fbQajOrJgK0ofKtJ1Ne90L6VO4MOl5S886p7u6xo7OLjG8TGL+HU1JXGJgppg4nNbNJ5nlzSpuPYy21JUEcUA94PoFiZfjZue+QnyQ80ekOuZVkxx4g+cvhJfHgNl4hy1/a6+RKcKlar/J29y//EztlbVPHVUeQ1zX86eQVAjR/M3dA9w4W8LfaXp4EgM85wOWasli837PzVMOnsLzR+k3o75/lRPAJSE1xAKQzEi5v10ke+VBvRt1cwQRMd+U5mLCTGVd6XiZtgBG5cDi0w22GKcVNvHiu5LQbZEDVtz0onn7k5+heuKXVsZtSzilkLRAUmjMXEMB3J9YC50XBxPiz53SC+EhnPl9WsKCv92SM/OFFIMJZYfl0WW8tIO3UxYcwdMAj7FSmgrsZ2aAZO03BOhP1bNNZItyXYQFTpC3SG1VuPDqH9GkiCDmE+JwxyIVSO5siDErAOpEXFgjy6PQtOVDj+s6e1r8heWVvmZnTciuf4EiNZzCAd7SOMhXERIOlsHIMG399i9aLTy3m2hRLZjJVDNLS53iGIK11dPqQt0zBDyg6qc7YqkDm2M5Ve6dCWCaCbTXX2rToaIgz6+zh4lYUi/+6nqcFMAkQJKHYLK0wYk5N9szV6xihDbDDFr45lN1K4aCXBq/FitPSud9gLt5ZVn+ZqGX7cwm2z5EGMgfFpIFyhGGuDPmso6TItTMwny+7uPnLCf4W6goFQFV0oQSsc9VfMmVLcLr6ZetDZbaSFTLqnSO/bIPjA3/zAUoqgGFAEQS4IhuMzEp2I3jJzbzkk/IEmyax+rhZTwd6f+CGtwPixu8IvzACquPWPREu9ZvGkUzpRwvRRuaNN6cr0W1wWits9ICdYJ7ltbgMiSL3sTPeufgNcVqMVWFkCPDH4jG2jA0XcVgQj62Cb29v9f/z/+2KbYvIv/zzjpQAPkliaVDzNrW57TZ/ZOyZD0nlfMmAIBIAGAI0D3k/mdN4xr9v85ZbZbbqfH2jGd5hUqNZWwl5SPfoGmfElmazUIeNL1j/mkF7VNAzTq4jNt8JoQ11NQOcmhprXoxSxfRGJ9LDEOAQ+dmxAQH90iti9e2u/MoeuaGcDTHoC+xsmEeWmxEKefQuIzHbpw5Tc5cEocboAD09oipWQhtTO1wivf/O+DRe2rpl/E9wlrzBorjJsOeG1B/XPW4EaJEFdNlECEZga5ZoGRHXgYouGRuVkm8tDESiEyFNo+3s5M5puSdTyUL2llnINVHEt91XUNW4ewdMgJ4boJfEyt/iY5WXqbA+A2Fkt5Z0lutiWhe9nZIyIUjyXDC3UsaG1t+eNx6z4W/OYoTB7A6x+dNSTOi9AInctbESqm5gvOLww7OWXPrmHwVZasrl4eD113pm+JtT7JVOvnCXqdzzdTRHgJ0PiGTFYW5Gvt9R9LD6Lzfs0v/TZZHSmyVNq7viIHE6DBK7Qp07Iz55EM8SYtQvZf/obBniTWi5C2/ovHfw4VndkE5XYdjOhCMRjDeOEfXeN/CwfGduiUIfsoFeUxXeQXba7c7972XNv8w+dTjjUM0QeNAReW+J014dKAD/McQYXT7c0GQPIkn3Ll6R7gGjuiQoZD0TEeEqQpKoZ15g/0OPQI17QiSv9AUROa/V/TQN3dvLArec3RrsYlvBm1b8LWzltdugsC50lNKYLEp2a+ZZYqPejULRlOJh5zj/LVMyTDvwKhMxxwuDkxJ1QpoNI0OTWLom4Z71SNzI9TV1iXJrIu9Wcnd+MCaAw8o1jSXd94YU/1gnkrC9BUEOtQvEIQ7g0i6h+KL2JKk8Ydl7HruvgWMSAmNe+LshGhV4qnWHhO9/RIPQzY1tHRj2VqOyNsDpK0cww+56AdDC4gsWwY0XxoucIWIqs/GcwnWqlaT0KPr8mbK5U94/301i1WLt4YINTVvCFBrFZbIbY8eycOdeJ2teD5IfPLCRg7jjcFTwlMFNl9zdh/o3E/hHPwj7BWg0MU09pPrBLbrCgm54A6H+I6v27+jL5gkjWg/iYdks9jbfVP5y/n0dlgWEMlKasl7JvFZd56LfybW1eeaVO0gxTfXZwD8G4SI116yx7UKVRgui6Ya1YpixqXeNLc8IxtAwCU5IhwQgn+NqHnRaDv61CxKhOq4pOX7M6pkA+Pmpd4j1vn6ACUALoLLc4vpXci8VidLxzm7qFBe7s+quuJs6ETYmnpgS3LwSZxPIltgBDXz8M1k/W2ySNv2f9/NPhxLGK2D21dkHeSGmenRT3Yqcdl0m/h3OYr8V+lXNYGf8aCCpd4bWjE4QIPj7vUKN4Nrfs7ML6Y2OyS830JCnofg/k7lpFpt4SqZc5HGg1HCOrHvOdC8bP6FGDbE/VV0mX4IakzbdS/op+Kt3G24/8QbBV7y86sGSQ/vZzU8FXs7u6jIvwchsEP2BpIhW3G8uWNwa3HmjfH/ZjhhCWvluAcF+nMf14ClKg5hGgtPLJ98ueNAkc5Hs2WZlk2QHvfreCK1CCGO6nMZVSb99VM/ajr8WHTte9JSmkXq/i/U943HEbdzW6Re/S88dKgg8pGOLlAeNiqrcLkUR3/aClFpMXcOUP3rmETcWSfMXZE3TUOi8i+fqRnTYLflVx/Vb/6GJ7eIRZUA6k3RYR3iFSK9c4iDdNwJuZL2FKz/IK5VimcNWEqdXjSoxSgmF0UPlDoUlNrPcM7ftmA8Y9gKiqKEHuWN+AZRIwtVSxye2Kf8rM3lhJ5XcBXU9n4v0Oy1RU2M+4qM8AQPVwse8ErNSob5oFPWxuqZnVzo1qB/IBxkM3EVUKFUUlO3e51259GgNcJbCmlvrdjtoTW7rChm1wyCKzpCTwozUUEOIcWLneRLgMXh+SjGSFkAllzbGS5HK7LlfCMRNRDSvbQPjcXaenNYxCvu2Qyznz6StuxVj66SgI0T8B6/sfHAJYZaZ78thjOSIFumNWLQbeZixDCCC+v0YBtkxiBB3jefHqZ/dFHU+crbj6OvS1x/JDD7vlm7zOVPwpUC01nhxZuY/63E7g";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $b5d77f1d2ca865aa$var$S0 = 0xAC00;
const $b5d77f1d2ca865aa$var$L0 = 0x1100;
const $b5d77f1d2ca865aa$var$V0 = 0x1161;
const $b5d77f1d2ca865aa$var$T0 = 0x11A7;
const $b5d77f1d2ca865aa$var$L_COUNT = 19;
const $b5d77f1d2ca865aa$var$V_COUNT = 21;
const $b5d77f1d2ca865aa$var$T_COUNT = 28;
const $b5d77f1d2ca865aa$var$N_COUNT = $b5d77f1d2ca865aa$var$V_COUNT * $b5d77f1d2ca865aa$var$T_COUNT;
const $b5d77f1d2ca865aa$var$S_COUNT = $b5d77f1d2ca865aa$var$L_COUNT * $b5d77f1d2ca865aa$var$N_COUNT;
const $b5d77f1d2ca865aa$var$S1 = $b5d77f1d2ca865aa$var$S0 + $b5d77f1d2ca865aa$var$S_COUNT;
const $b5d77f1d2ca865aa$var$L1 = $b5d77f1d2ca865aa$var$L0 + $b5d77f1d2ca865aa$var$L_COUNT;
const $b5d77f1d2ca865aa$var$V1 = $b5d77f1d2ca865aa$var$V0 + $b5d77f1d2ca865aa$var$V_COUNT;
const $b5d77f1d2ca865aa$var$T1 = $b5d77f1d2ca865aa$var$T0 + $b5d77f1d2ca865aa$var$T_COUNT;
function $b5d77f1d2ca865aa$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $b5d77f1d2ca865aa$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $b5d77f1d2ca865aa$var$SHIFTED_RANK, $b5d77f1d2ca865aa$var$EXCLUSIONS, $b5d77f1d2ca865aa$var$DECOMP, $b5d77f1d2ca865aa$var$RECOMP;
function $b5d77f1d2ca865aa$var$init$1() {
    //console.time('nf');
    let r = $b5d77f1d2ca865aa$var$read_compressed_payload($b5d77f1d2ca865aa$var$COMPRESSED);
    $b5d77f1d2ca865aa$var$SHIFTED_RANK = new Map($b5d77f1d2ca865aa$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $b5d77f1d2ca865aa$var$EXCLUSIONS = new Set($b5d77f1d2ca865aa$var$read_sorted(r));
    $b5d77f1d2ca865aa$var$DECOMP = new Map();
    $b5d77f1d2ca865aa$var$RECOMP = new Map();
    for (let [cp, cps] of $b5d77f1d2ca865aa$var$read_mapped(r)){
        if (!$b5d77f1d2ca865aa$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $b5d77f1d2ca865aa$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $b5d77f1d2ca865aa$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $b5d77f1d2ca865aa$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $b5d77f1d2ca865aa$var$is_hangul(cp) {
    return cp >= $b5d77f1d2ca865aa$var$S0 && cp < $b5d77f1d2ca865aa$var$S1;
}
function $b5d77f1d2ca865aa$var$compose_pair(a, b) {
    if (a >= $b5d77f1d2ca865aa$var$L0 && a < $b5d77f1d2ca865aa$var$L1 && b >= $b5d77f1d2ca865aa$var$V0 && b < $b5d77f1d2ca865aa$var$V1) return $b5d77f1d2ca865aa$var$S0 + (a - $b5d77f1d2ca865aa$var$L0) * $b5d77f1d2ca865aa$var$N_COUNT + (b - $b5d77f1d2ca865aa$var$V0) * $b5d77f1d2ca865aa$var$T_COUNT;
    else if ($b5d77f1d2ca865aa$var$is_hangul(a) && b > $b5d77f1d2ca865aa$var$T0 && b < $b5d77f1d2ca865aa$var$T1 && (a - $b5d77f1d2ca865aa$var$S0) % $b5d77f1d2ca865aa$var$T_COUNT == 0) return a + (b - $b5d77f1d2ca865aa$var$T0);
    else {
        let recomp = $b5d77f1d2ca865aa$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $b5d77f1d2ca865aa$var$decomposed(cps) {
    if (!$b5d77f1d2ca865aa$var$SHIFTED_RANK) $b5d77f1d2ca865aa$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $b5d77f1d2ca865aa$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($b5d77f1d2ca865aa$var$is_hangul(cp)) {
            let s_index = cp - $b5d77f1d2ca865aa$var$S0;
            let l_index = s_index / $b5d77f1d2ca865aa$var$N_COUNT | 0;
            let v_index = s_index % $b5d77f1d2ca865aa$var$N_COUNT / $b5d77f1d2ca865aa$var$T_COUNT | 0;
            let t_index = s_index % $b5d77f1d2ca865aa$var$T_COUNT;
            add($b5d77f1d2ca865aa$var$L0 + l_index);
            add($b5d77f1d2ca865aa$var$V0 + v_index);
            if (t_index > 0) add($b5d77f1d2ca865aa$var$T0 + t_index);
        } else {
            let mapped = $b5d77f1d2ca865aa$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $b5d77f1d2ca865aa$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $b5d77f1d2ca865aa$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $b5d77f1d2ca865aa$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $b5d77f1d2ca865aa$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $b5d77f1d2ca865aa$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $b5d77f1d2ca865aa$var$unpack_cc(packed);
        let cp = $b5d77f1d2ca865aa$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $b5d77f1d2ca865aa$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $b5d77f1d2ca865aa$export$9d0d896b286a3dba(cps) {
    return $b5d77f1d2ca865aa$var$decomposed(cps).map($b5d77f1d2ca865aa$var$unpack_cp);
}
function $b5d77f1d2ca865aa$export$f42252642e08449(cps) {
    return $b5d77f1d2ca865aa$var$composed_from_decomposed($b5d77f1d2ca865aa$var$decomposed(cps));
}
const $b5d77f1d2ca865aa$var$HYPHEN = 0x2D;
const $b5d77f1d2ca865aa$var$STOP = 0x2E;
const $b5d77f1d2ca865aa$var$STOP_CH = ".";
const $b5d77f1d2ca865aa$var$FE0F = 0xFE0F;
const $b5d77f1d2ca865aa$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $b5d77f1d2ca865aa$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $b5d77f1d2ca865aa$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $b5d77f1d2ca865aa$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $b5d77f1d2ca865aa$var$MAPPED, $b5d77f1d2ca865aa$var$IGNORED, $b5d77f1d2ca865aa$var$CM, $b5d77f1d2ca865aa$var$NSM, $b5d77f1d2ca865aa$var$ESCAPE, $b5d77f1d2ca865aa$var$NFC_CHECK, $b5d77f1d2ca865aa$var$GROUPS, $b5d77f1d2ca865aa$var$WHOLE_VALID, $b5d77f1d2ca865aa$var$WHOLE_MAP, $b5d77f1d2ca865aa$var$VALID, $b5d77f1d2ca865aa$var$EMOJI_LIST, $b5d77f1d2ca865aa$var$EMOJI_ROOT;
function $b5d77f1d2ca865aa$var$init() {
    if ($b5d77f1d2ca865aa$var$MAPPED) return;
    let r = $b5d77f1d2ca865aa$var$read_compressed_payload($b5d77f1d2ca865aa$var$COMPRESSED$1);
    const read_sorted_array = ()=>$b5d77f1d2ca865aa$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    const set_add_many = (set, v)=>v.forEach((x)=>set.add(x));
    $b5d77f1d2ca865aa$var$MAPPED = new Map($b5d77f1d2ca865aa$var$read_mapped(r));
    $b5d77f1d2ca865aa$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $b5d77f1d2ca865aa$var$CM = read_sorted_array();
    $b5d77f1d2ca865aa$var$NSM = new Set(read_sorted_array().map((i)=>$b5d77f1d2ca865aa$var$CM[i]));
    $b5d77f1d2ca865aa$var$CM = new Set($b5d77f1d2ca865aa$var$CM);
    $b5d77f1d2ca865aa$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $b5d77f1d2ca865aa$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $b5d77f1d2ca865aa$var$read_sorted_arrays(r);
    let unrestricted = r();
    //const read_chunked = () => new Set(read_sorted_array().flatMap(i => chunks[i]).concat(read_sorted_array()));
    const read_chunked = ()=>{
        // 20230921: build set in parts, 2x faster
        let set = new Set();
        read_sorted_array().forEach((i)=>set_add_many(set, chunks[i]));
        set_add_many(set, read_sorted_array());
        return set;
    };
    $b5d77f1d2ca865aa$var$GROUPS = $b5d77f1d2ca865aa$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $b5d77f1d2ca865aa$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // unrestricted then restricted
            N[0] -= 32; // capitalize
            N = $b5d77f1d2ca865aa$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $b5d77f1d2ca865aa$var$WHOLE_VALID = read_sorted_set();
    $b5d77f1d2ca865aa$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($b5d77f1d2ca865aa$var$Array_from($b5d77f1d2ca865aa$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$b5d77f1d2ca865aa$var$WHOLE_VALID.has(cp)) $b5d77f1d2ca865aa$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    // usage: WHOLE_MAP.get(cp).M.get(cp) = complement set
    for (let { V: V, M: M } of new Set($b5d77f1d2ca865aa$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $b5d77f1d2ca865aa$var$GROUPS.filter((g)=>$b5d77f1d2ca865aa$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            set_add_many(rec.G, gs);
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$b5d77f1d2ca865aa$var$Array_from(x.G)); // all of the groups used by this whole
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g))); // groups not covered by the extent
            for (let cp of V)M.set(cp, complement); // this is the same reference
        }
    }
    // compute valid set
    // 20230924: VALID was union but can be re-used
    $b5d77f1d2ca865aa$var$VALID = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>$b5d77f1d2ca865aa$var$VALID.has(cp) ? multi.add(cp) : $b5d77f1d2ca865aa$var$VALID.add(cp);
    for (let g of $b5d77f1d2ca865aa$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of $b5d77f1d2ca865aa$var$VALID)if (!$b5d77f1d2ca865aa$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $b5d77f1d2ca865aa$var$WHOLE_MAP.set(cp, $b5d77f1d2ca865aa$var$UNIQUE_PH);
    // add all decomposed parts
    // see derive: "Valid is Closed (via Brute-force)"
    set_add_many($b5d77f1d2ca865aa$var$VALID, $b5d77f1d2ca865aa$export$9d0d896b286a3dba($b5d77f1d2ca865aa$var$VALID));
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $b5d77f1d2ca865aa$var$EMOJI_LIST = $b5d77f1d2ca865aa$var$read_trie(r).map((v)=>$b5d77f1d2ca865aa$var$Emoji.from(v)).sort($b5d77f1d2ca865aa$var$compare_arrays);
    $b5d77f1d2ca865aa$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $b5d77f1d2ca865aa$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $b5d77f1d2ca865aa$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $b5d77f1d2ca865aa$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $b5d77f1d2ca865aa$var$quoted_cp(cp) {
    return ($b5d77f1d2ca865aa$export$4b1c9c18c687e5e9(cp) ? "" : `${$b5d77f1d2ca865aa$var$bidi_qq($b5d77f1d2ca865aa$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $b5d77f1d2ca865aa$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $b5d77f1d2ca865aa$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $b5d77f1d2ca865aa$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $b5d77f1d2ca865aa$var$HYPHEN && cps[3] == $b5d77f1d2ca865aa$var$HYPHEN) throw new Error(`invalid label extension: "${$b5d77f1d2ca865aa$var$str_from_cps(cps.slice(0, 4))}"`); // this can only be ascii so cant be bidi
}
function $b5d77f1d2ca865aa$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $b5d77f1d2ca865aa$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $b5d77f1d2ca865aa$var$FENCED.get(cp);
    if (prev) throw $b5d77f1d2ca865aa$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $b5d77f1d2ca865aa$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $b5d77f1d2ca865aa$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $b5d77f1d2ca865aa$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// if cps exceed max, middle truncate with ellipsis
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $b5d77f1d2ca865aa$export$6ec6f9a7f89f00db(cps, max = Infinity, quoter = $b5d77f1d2ca865aa$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($b5d77f1d2ca865aa$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    if (cps.length > max) {
        max >>= 1;
        cps = [
            ...cps.slice(0, max),
            0x2026,
            ...cps.slice(-max)
        ];
    }
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($b5d77f1d2ca865aa$export$4b1c9c18c687e5e9(cp)) {
            buf.push($b5d77f1d2ca865aa$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($b5d77f1d2ca865aa$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $b5d77f1d2ca865aa$export$e29a9e4d2573411c(cp) {
    $b5d77f1d2ca865aa$var$init();
    return $b5d77f1d2ca865aa$var$CM.has(cp);
}
function $b5d77f1d2ca865aa$export$4b1c9c18c687e5e9(cp) {
    $b5d77f1d2ca865aa$var$init();
    return $b5d77f1d2ca865aa$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $b5d77f1d2ca865aa$export$95d5ea4de7964366() {
    $b5d77f1d2ca865aa$var$init();
    return $b5d77f1d2ca865aa$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $b5d77f1d2ca865aa$export$f4e6b2721065fb3d(frag, decompose) {
    $b5d77f1d2ca865aa$var$init();
    let nf = decompose ? $b5d77f1d2ca865aa$export$9d0d896b286a3dba : $b5d77f1d2ca865aa$export$f42252642e08449;
    return frag.split($b5d77f1d2ca865aa$var$STOP_CH).map((label)=>$b5d77f1d2ca865aa$var$str_from_cps($b5d77f1d2ca865aa$var$tokens_from_str($b5d77f1d2ca865aa$var$explode_cp(label), nf, $b5d77f1d2ca865aa$var$filter_fe0f).flat())).join($b5d77f1d2ca865aa$var$STOP_CH);
}
function $b5d77f1d2ca865aa$export$499f715881831a51(name) {
    return $b5d77f1d2ca865aa$var$flatten($b5d77f1d2ca865aa$var$split(name, $b5d77f1d2ca865aa$export$f42252642e08449, $b5d77f1d2ca865aa$var$filter_fe0f));
}
function $b5d77f1d2ca865aa$export$d2ee080f6ab2341d(name) {
    let labels = $b5d77f1d2ca865aa$var$split(name, $b5d77f1d2ca865aa$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") $b5d77f1d2ca865aa$var$array_replace(output, 0x3BE, 0x39E);
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $b5d77f1d2ca865aa$var$flatten(labels);
}
function $b5d77f1d2ca865aa$var$array_replace(v, a, b) {
    let prev = 0;
    while(true){
        let next = v.indexOf(a, prev);
        if (next < 0) break;
        v[next] = b;
        prev = next + 1;
    }
}
function $b5d77f1d2ca865aa$export$d2ba335951b08421(name, preserve_emoji) {
    return $b5d77f1d2ca865aa$var$split(name, $b5d77f1d2ca865aa$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $b5d77f1d2ca865aa$var$filter_fe0f); // emoji are exposed so copy
}
function $b5d77f1d2ca865aa$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $b5d77f1d2ca865aa$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($b5d77f1d2ca865aa$var$STOP_CH).map((label)=>{
        let input = $b5d77f1d2ca865aa$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $b5d77f1d2ca865aa$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $b5d77f1d2ca865aa$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $b5d77f1d2ca865aa$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($b5d77f1d2ca865aa$var$CM.has(norm[0])) throw $b5d77f1d2ca865aa$var$error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $b5d77f1d2ca865aa$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $b5d77f1d2ca865aa$var$error_placement(`emoji + combining mark: "${$b5d77f1d2ca865aa$var$str_from_cps(tokens[i - 1])} + ${$b5d77f1d2ca865aa$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $b5d77f1d2ca865aa$var$check_fenced(norm);
                    let unique = $b5d77f1d2ca865aa$var$Array_from(new Set(chars));
                    let [g] = $b5d77f1d2ca865aa$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $b5d77f1d2ca865aa$var$check_group(g, chars); // need text in order
                    $b5d77f1d2ca865aa$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $b5d77f1d2ca865aa$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $b5d77f1d2ca865aa$var$WHOLE_MAP.get(cp);
        if (whole === $b5d77f1d2ca865aa$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $b5d77f1d2ca865aa$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$b5d77f1d2ca865aa$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $b5d77f1d2ca865aa$var$determine_group(unique) {
    let groups = $b5d77f1d2ca865aa$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$b5d77f1d2ca865aa$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$b5d77f1d2ca865aa$var$GROUPS.some((g)=>$b5d77f1d2ca865aa$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $b5d77f1d2ca865aa$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $b5d77f1d2ca865aa$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $b5d77f1d2ca865aa$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$b5d77f1d2ca865aa$var$bidi_qq($b5d77f1d2ca865aa$export$6ec6f9a7f89f00db(input, 63))}: ${msg}`);
        }
        return $b5d77f1d2ca865aa$var$str_from_cps(output);
    }).join($b5d77f1d2ca865aa$var$STOP_CH);
}
function $b5d77f1d2ca865aa$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$b5d77f1d2ca865aa$var$quoted_cp(cp)}`);
}
function $b5d77f1d2ca865aa$var$error_group_member(g, cp) {
    let quoted = $b5d77f1d2ca865aa$var$quoted_cp(cp);
    let gg = $b5d77f1d2ca865aa$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $b5d77f1d2ca865aa$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $b5d77f1d2ca865aa$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$b5d77f1d2ca865aa$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $b5d77f1d2ca865aa$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $b5d77f1d2ca865aa$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($b5d77f1d2ca865aa$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $b5d77f1d2ca865aa$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$b5d77f1d2ca865aa$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $b5d77f1d2ca865aa$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$b5d77f1d2ca865aa$var$bidi_qq($b5d77f1d2ca865aa$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$b5d77f1d2ca865aa$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $b5d77f1d2ca865aa$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $b5d77f1d2ca865aa$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($b5d77f1d2ca865aa$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $b5d77f1d2ca865aa$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$b5d77f1d2ca865aa$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $b5d77f1d2ca865aa$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $b5d77f1d2ca865aa$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $b5d77f1d2ca865aa$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $b5d77f1d2ca865aa$var$consume_emoji_reversed(cps, eaten) {
    let node = $b5d77f1d2ca865aa$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $b5d77f1d2ca865aa$var$TY_VALID = "valid";
const $b5d77f1d2ca865aa$var$TY_MAPPED = "mapped";
const $b5d77f1d2ca865aa$var$TY_IGNORED = "ignored";
const $b5d77f1d2ca865aa$var$TY_DISALLOWED = "disallowed";
const $b5d77f1d2ca865aa$var$TY_EMOJI = "emoji";
const $b5d77f1d2ca865aa$var$TY_NFC = "nfc";
const $b5d77f1d2ca865aa$var$TY_STOP = "stop";
function $b5d77f1d2ca865aa$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $b5d77f1d2ca865aa$var$init();
    let input = $b5d77f1d2ca865aa$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $b5d77f1d2ca865aa$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $b5d77f1d2ca865aa$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $b5d77f1d2ca865aa$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $b5d77f1d2ca865aa$var$STOP) tokens.push({
                type: $b5d77f1d2ca865aa$var$TY_STOP,
                cp: cp
            });
            else if ($b5d77f1d2ca865aa$var$VALID.has(cp)) tokens.push({
                type: $b5d77f1d2ca865aa$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($b5d77f1d2ca865aa$var$IGNORED.has(cp)) tokens.push({
                type: $b5d77f1d2ca865aa$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $b5d77f1d2ca865aa$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $b5d77f1d2ca865aa$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $b5d77f1d2ca865aa$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($b5d77f1d2ca865aa$var$is_valid_or_mapped(token.type)) {
            if ($b5d77f1d2ca865aa$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($b5d77f1d2ca865aa$var$is_valid_or_mapped(type)) {
                        if (!$b5d77f1d2ca865aa$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $b5d77f1d2ca865aa$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$b5d77f1d2ca865aa$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $b5d77f1d2ca865aa$export$f42252642e08449(cps0);
                if ($b5d77f1d2ca865aa$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $b5d77f1d2ca865aa$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $b5d77f1d2ca865aa$var$collapse_valid_tokens(slice),
                        tokens: $b5d77f1d2ca865aa$export$bac129d8210aa825($b5d77f1d2ca865aa$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $b5d77f1d2ca865aa$var$TY_IGNORED) start = -1; // reset
    }
    return $b5d77f1d2ca865aa$var$collapse_valid_tokens(tokens);
}
function $b5d77f1d2ca865aa$var$is_valid_or_mapped(type) {
    return type == $b5d77f1d2ca865aa$var$TY_VALID || type == $b5d77f1d2ca865aa$var$TY_MAPPED;
}
function $b5d77f1d2ca865aa$var$requires_check(cps) {
    return cps.some((cp)=>$b5d77f1d2ca865aa$var$NFC_CHECK.has(cp));
}
function $b5d77f1d2ca865aa$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $b5d77f1d2ca865aa$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $b5d77f1d2ca865aa$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $b5d77f1d2ca865aa$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}


const $f92e169184349c67$var$Zeros = new Uint8Array(32);
$f92e169184349c67$var$Zeros.fill(0);
function $f92e169184349c67$var$checkComponent(comp) {
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function $f92e169184349c67$var$ensNameSplit(name) {
    const bytes = (0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)($f92e169184349c67$export$5f232fd2f1a1e8ac(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($f92e169184349c67$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push($f92e169184349c67$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $f92e169184349c67$export$5f232fd2f1a1e8ac(name) {
    try {
        if (name.length === 0) throw new Error("empty label");
        return (0, $b5d77f1d2ca865aa$export$499f715881831a51)(name);
    } catch (error) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function $f92e169184349c67$export$cce2300886e7ace6(name) {
    try {
        return $f92e169184349c67$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $f92e169184349c67$export$91d651ee363e1209(name) {
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(name.length, `invalid ENS name (empty label)`, "name", name);
    let result = $f92e169184349c67$var$Zeros;
    const comps = $f92e169184349c67$var$ensNameSplit(name);
    while(comps.length)result = (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)((0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
        result,
        (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(result);
}
function $f92e169184349c67$export$6c0a8cdae51cb512(name, _maxLength) {
    const length = _maxLength != null ? _maxLength : 63;
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(length <= 255, "DNS encoded label cannot exceed 255", "length", length);
    return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)((0, $646c422fbb8bae38$export$ee1b3e54f0441b22)($f92e169184349c67$var$ensNameSplit(name).map((comp)=>{
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(comp.length <= length, `label ${JSON.stringify(name)} exceeds ${length} bytes`, "name", name);
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}





//See: https://github.com/ethereum/wiki/wiki/RLP


function $5effca9dac4e70ae$var$hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function $5effca9dac4e70ae$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $5effca9dac4e70ae$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $5effca9dac4e70ae$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: length,
            offset: offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $5effca9dac4e70ae$var$_decode(data, offset) {
    (0, $bb8e52d338877b37$export$a7a9523472993e97)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset: offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = $5effca9dac4e70ae$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return $5effca9dac4e70ae$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return $5effca9dac4e70ae$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = $5effca9dac4e70ae$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $5effca9dac4e70ae$var$hexlifyByte(data[offset])
    };
}
function $5effca9dac4e70ae$export$7dc021e13b2aa20d(_data) {
    const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_data, "data");
    const decoded = $5effca9dac4e70ae$var$_decode(data, 0);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

//See: https://github.com/ethereum/wiki/wiki/RLP

function $f3a1c5b25caae960$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $f3a1c5b25caae960$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($f3a1c5b25caae960$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $f3a1c5b25caae960$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, $646c422fbb8bae38$export$a3521add2594f3c8)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $f3a1c5b25caae960$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const $f3a1c5b25caae960$var$nibbles = "0123456789abcdef";
function $f3a1c5b25caae960$export$aea7770274d28b7(object) {
    let result = "0x";
    for (const v of $f3a1c5b25caae960$var$_encode(object)){
        result += $f3a1c5b25caae960$var$nibbles[v >> 4];
        result += $f3a1c5b25caae960$var$nibbles[v & 0xf];
    }
    return result;
}




const $94b8e5acbf5fee0e$var$BN_0 = BigInt(0);
const $94b8e5acbf5fee0e$var$BN_2 = BigInt(2);
const $94b8e5acbf5fee0e$var$BN_27 = BigInt(27);
const $94b8e5acbf5fee0e$var$BN_28 = BigInt(28);
const $94b8e5acbf5fee0e$var$BN_35 = BigInt(35);
const $94b8e5acbf5fee0e$var$BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $94b8e5acbf5fee0e$var$BLOB_SIZE = 131072;
function $94b8e5acbf5fee0e$var$getVersionedHash(version, hash) {
    let versioned = version.toString(16);
    while(versioned.length < 2)versioned = "0" + versioned;
    versioned += (0, $d318730f8de39247$export$bced8d2aada2d1c9)(hash).substring(4);
    return "0x" + versioned;
}
function $94b8e5acbf5fee0e$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $14cfbe985a29575c$export$88411125f012957a)(value);
}
function $94b8e5acbf5fee0e$var$handleAccessList(value, param) {
    try {
        return (0, $7113bd4426313aea$export$6c8662b1600dce2)(value);
    } catch (error) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, error.message, param, value);
    }
}
function $94b8e5acbf5fee0e$var$handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, $80785c90802caadd$export$b14f2714108df84)(_value, param);
}
function $94b8e5acbf5fee0e$var$handleUint(_value, param) {
    if (_value === "0x") return $94b8e5acbf5fee0e$var$BN_0;
    const value = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(_value, param);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(value <= $94b8e5acbf5fee0e$var$BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function $94b8e5acbf5fee0e$var$formatNumber(_value, name) {
    const value = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(_value, "value");
    const result = (0, $80785c90802caadd$export$b627fcfb5ea68cb0)(value);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function $94b8e5acbf5fee0e$var$formatAccessList(value) {
    return (0, $7113bd4426313aea$export$6c8662b1600dce2)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $94b8e5acbf5fee0e$var$formatHashes(value, param) {
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(value), `invalid ${param}`, "value", value);
    for(let i = 0; i < value.length; i++)(0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(value[i], 32), "invalid ${ param } hash", `value[${i}]`, value[i]);
    return value;
}
function $94b8e5acbf5fee0e$var$_parseLegacy(data) {
    const fields = (0, $5effca9dac4e70ae$export$7dc021e13b2aa20d)(data);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: $94b8e5acbf5fee0e$var$handleNumber(fields[0], "nonce"),
        gasPrice: $94b8e5acbf5fee0e$var$handleUint(fields[1], "gasPrice"),
        gasLimit: $94b8e5acbf5fee0e$var$handleUint(fields[2], "gasLimit"),
        to: $94b8e5acbf5fee0e$var$handleAddress(fields[3]),
        value: $94b8e5acbf5fee0e$var$handleUint(fields[4], "value"),
        data: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(fields[5]),
        chainId: $94b8e5acbf5fee0e$var$BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = $94b8e5acbf5fee0e$var$handleUint(fields[6], "v");
    const r = $94b8e5acbf5fee0e$var$handleUint(fields[7], "r");
    const s = $94b8e5acbf5fee0e$var$handleUint(fields[8], "s");
    if (r === $94b8e5acbf5fee0e$var$BN_0 && s === $94b8e5acbf5fee0e$var$BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - $94b8e5acbf5fee0e$var$BN_35) / $94b8e5acbf5fee0e$var$BN_2;
        if (chainId < $94b8e5acbf5fee0e$var$BN_0) chainId = $94b8e5acbf5fee0e$var$BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(chainId !== $94b8e5acbf5fee0e$var$BN_0 || v === $94b8e5acbf5fee0e$var$BN_27 || v === $94b8e5acbf5fee0e$var$BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).from({
            r: (0, $646c422fbb8bae38$export$4473860254365feb)(fields[7], 32),
            s: (0, $646c422fbb8bae38$export$4473860254365feb)(fields[8], 32),
            v: v
        });
    //tx.hash = keccak256(data);
    }
    return tx;
}
function $94b8e5acbf5fee0e$var$_serializeLegacy(tx, sig) {
    const fields = [
        $94b8e5acbf5fee0e$var$formatNumber(tx.nonce, "nonce"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $94b8e5acbf5fee0e$var$formatNumber(tx.value, "value"),
        tx.data
    ];
    let chainId = $94b8e5acbf5fee0e$var$BN_0;
    if (tx.chainId != $94b8e5acbf5fee0e$var$BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== $94b8e5acbf5fee0e$var$BN_0) {
            fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, $f3a1c5b25caae960$export$aea7770274d28b7)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== $94b8e5acbf5fee0e$var$BN_0) v = (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(v));
    fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(sig.r));
    fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(sig.s));
    return (0, $f3a1c5b25caae960$export$aea7770274d28b7)(fields);
}
function $94b8e5acbf5fee0e$var$_parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = $94b8e5acbf5fee0e$var$handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, $646c422fbb8bae38$export$4473860254365feb)(fields[1], 32);
    const s = (0, $646c422fbb8bae38$export$4473860254365feb)(fields[2], 32);
    const signature = (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).from({
        r: r,
        s: s,
        yParity: yParity
    });
    tx.signature = signature;
}
function $94b8e5acbf5fee0e$var$_parseEip1559(data) {
    const fields = (0, $5effca9dac4e70ae$export$7dc021e13b2aa20d)((0, $646c422fbb8bae38$export$a3521add2594f3c8)(data).slice(1));
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 2,
        chainId: $94b8e5acbf5fee0e$var$handleUint(fields[0], "chainId"),
        nonce: $94b8e5acbf5fee0e$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $94b8e5acbf5fee0e$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $94b8e5acbf5fee0e$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $94b8e5acbf5fee0e$var$handleUint(fields[4], "gasLimit"),
        to: $94b8e5acbf5fee0e$var$handleAddress(fields[5]),
        value: $94b8e5acbf5fee0e$var$handleUint(fields[6], "value"),
        data: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $94b8e5acbf5fee0e$var$handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    //tx.hash = keccak256(data);
    $94b8e5acbf5fee0e$var$_parseEipSignature(tx, fields.slice(9));
    return tx;
}
function $94b8e5acbf5fee0e$var$_serializeEip1559(tx, sig) {
    const fields = [
        $94b8e5acbf5fee0e$var$formatNumber(tx.chainId, "chainId"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.nonce, "nonce"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $94b8e5acbf5fee0e$var$formatNumber(tx.value, "value"),
        tx.data,
        $94b8e5acbf5fee0e$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($94b8e5acbf5fee0e$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
        "0x02",
        (0, $f3a1c5b25caae960$export$aea7770274d28b7)(fields)
    ]);
}
function $94b8e5acbf5fee0e$var$_parseEip2930(data) {
    const fields = (0, $5effca9dac4e70ae$export$7dc021e13b2aa20d)((0, $646c422fbb8bae38$export$a3521add2594f3c8)(data).slice(1));
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 1,
        chainId: $94b8e5acbf5fee0e$var$handleUint(fields[0], "chainId"),
        nonce: $94b8e5acbf5fee0e$var$handleNumber(fields[1], "nonce"),
        gasPrice: $94b8e5acbf5fee0e$var$handleUint(fields[2], "gasPrice"),
        gasLimit: $94b8e5acbf5fee0e$var$handleUint(fields[3], "gasLimit"),
        to: $94b8e5acbf5fee0e$var$handleAddress(fields[4]),
        value: $94b8e5acbf5fee0e$var$handleUint(fields[5], "value"),
        data: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(fields[6]),
        accessList: $94b8e5acbf5fee0e$var$handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    //tx.hash = keccak256(data);
    $94b8e5acbf5fee0e$var$_parseEipSignature(tx, fields.slice(8));
    return tx;
}
function $94b8e5acbf5fee0e$var$_serializeEip2930(tx, sig) {
    const fields = [
        $94b8e5acbf5fee0e$var$formatNumber(tx.chainId, "chainId"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.nonce, "nonce"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        $94b8e5acbf5fee0e$var$formatNumber(tx.value, "value"),
        tx.data,
        $94b8e5acbf5fee0e$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($94b8e5acbf5fee0e$var$formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
        "0x01",
        (0, $f3a1c5b25caae960$export$aea7770274d28b7)(fields)
    ]);
}
function $94b8e5acbf5fee0e$var$_parseEip4844(data) {
    let fields = (0, $5effca9dac4e70ae$export$7dc021e13b2aa20d)((0, $646c422fbb8bae38$export$a3521add2594f3c8)(data).slice(1));
    let typeName = "3";
    let blobs = null;
    // Parse the network format
    if (fields.length === 4 && Array.isArray(fields[0])) {
        typeName = "3 (network format)";
        const fBlobs = fields[1], fCommits = fields[2], fProofs = fields[3];
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(fBlobs), "invalid network format: blobs not an array", "fields[1]", fBlobs);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(fCommits), "invalid network format: commitments not an array", "fields[2]", fCommits);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(fProofs), "invalid network format: proofs not an array", "fields[3]", fProofs);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(fBlobs.length === fCommits.length, "invalid network format: blobs/commitments length mismatch", "fields", fields);
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(fBlobs.length === fProofs.length, "invalid network format: blobs/proofs length mismatch", "fields", fields);
        blobs = [];
        for(let i = 0; i < fields[1].length; i++)blobs.push({
            data: fBlobs[i],
            commitment: fCommits[i],
            proof: fProofs[i]
        });
        fields = fields[0];
    }
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 11 || fields.length === 14), `invalid field count for transaction type: ${typeName}`, "data", (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 3,
        chainId: $94b8e5acbf5fee0e$var$handleUint(fields[0], "chainId"),
        nonce: $94b8e5acbf5fee0e$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: $94b8e5acbf5fee0e$var$handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: $94b8e5acbf5fee0e$var$handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: $94b8e5acbf5fee0e$var$handleUint(fields[4], "gasLimit"),
        to: $94b8e5acbf5fee0e$var$handleAddress(fields[5]),
        value: $94b8e5acbf5fee0e$var$handleUint(fields[6], "value"),
        data: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $94b8e5acbf5fee0e$var$handleAccessList(fields[8], "accessList"),
        maxFeePerBlobGas: $94b8e5acbf5fee0e$var$handleUint(fields[9], "maxFeePerBlobGas"),
        blobVersionedHashes: fields[10]
    };
    if (blobs) tx.blobs = blobs;
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(tx.to != null, `invalid address for transaction type: ${typeName}`, "data", data);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(tx.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", data);
    for(let i = 0; i < tx.blobVersionedHashes.length; i++)(0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(tx.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", data);
    // Unsigned EIP-4844 Transaction
    if (fields.length === 11) return tx;
    // @TODO: Do we need to do this? This is only called internally
    // and used to verify hashes; it might save time to not do this
    //tx.hash = keccak256(concat([ "0x03", encodeRlp(fields) ]));
    $94b8e5acbf5fee0e$var$_parseEipSignature(tx, fields.slice(11));
    return tx;
}
function $94b8e5acbf5fee0e$var$_serializeEip4844(tx, sig, blobs) {
    const fields = [
        $94b8e5acbf5fee0e$var$formatNumber(tx.chainId, "chainId"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.nonce, "nonce"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $94b8e5acbf5fee0e$var$formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || (0, $ad62383365eb9d5a$export$b7cbe423ba83da17),
        $94b8e5acbf5fee0e$var$formatNumber(tx.value, "value"),
        tx.data,
        $94b8e5acbf5fee0e$var$formatAccessList(tx.accessList || []),
        $94b8e5acbf5fee0e$var$formatNumber(tx.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
        $94b8e5acbf5fee0e$var$formatHashes(tx.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    if (sig) {
        fields.push($94b8e5acbf5fee0e$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $80785c90802caadd$export$b627fcfb5ea68cb0)(sig.s));
        // We have blobs; return the network wrapped format
        if (blobs) return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
            "0x03",
            (0, $f3a1c5b25caae960$export$aea7770274d28b7)([
                fields,
                blobs.map((b)=>b.data),
                blobs.map((b)=>b.commitment),
                blobs.map((b)=>b.proof)
            ])
        ]);
    }
    return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
        "0x03",
        (0, $f3a1c5b25caae960$export$aea7770274d28b7)(fields)
    ]);
}
class $94b8e5acbf5fee0e$export$febc5573c75cefb0 {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    #maxFeePerBlobGas;
    #blobVersionedHashes;
    #kzg;
    #blobs;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            case 3:
            case "cancun":
            case "eip-4844":
                this.#type = 3;
                break;
            default:
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
            case 3:
                return "eip-4844";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        const value = this.#to;
        if (value == null && this.type === 3) return 0, $ad62383365eb9d5a$export$b7cbe423ba83da17;
        return value;
    }
    set to(value) {
        this.#to = value == null ? null : (0, $14cfbe985a29575c$export$88411125f012957a)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, $80785c90802caadd$export$b14f2714108df84)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return $94b8e5acbf5fee0e$var$BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $94b8e5acbf5fee0e$var$BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return $94b8e5acbf5fee0e$var$BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2 || this.type === 3) // @TODO: in v7, this should assign the value or become
            // a live object itself, otherwise mutation is inconsistent
            return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, $7113bd4426313aea$export$6c8662b1600dce2)(value);
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */ get maxFeePerBlobGas() {
        const value = this.#maxFeePerBlobGas;
        if (value == null && this.type === 3) return $94b8e5acbf5fee0e$var$BN_0;
        return value;
    }
    set maxFeePerBlobGas(value) {
        this.#maxFeePerBlobGas = value == null ? null : (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value, "maxFeePerBlobGas");
    }
    /**
     *  The BLOb versioned hashes for Cancun transactions.
     */ get blobVersionedHashes() {
        // @TODO: Mutation is inconsistent; if unset, the returned value
        // cannot mutate the object, if set it can
        let value = this.#blobVersionedHashes;
        if (value == null && this.type === 3) return [];
        return value;
    }
    set blobVersionedHashes(value) {
        if (value != null) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(Array.isArray(value), "blobVersionedHashes must be an Array", "value", value);
            value = value.slice();
            for(let i = 0; i < value.length; i++)(0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(value[i], 32), "invalid blobVersionedHash", `value[${i}]`, value[i]);
        }
        this.#blobVersionedHashes = value;
    }
    /**
     *  The BLObs for the Transaction, if any.
     *
     *  If ``blobs`` is non-``null``, then the [[seriailized]]
     *  will return the network formatted sidecar, otherwise it
     *  will return the standard [[link-eip-2718]] payload. The
     *  [[unsignedSerialized]] is unaffected regardless.
     *
     *  When setting ``blobs``, either fully valid [[Blob]] objects
     *  may be specified (i.e. correctly padded, with correct
     *  committments and proofs) or a raw [[BytesLike]] may
     *  be provided.
     *
     *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
     *  be already set. The blob will be correctly padded and the
     *  [[KzgLibrary]] will be used to compute the committment and
     *  proof for the blob.
     *
     *  A BLOb is a sequence of field elements, each of which must
     *  be within the BLS field modulo, so some additional processing
     *  may be required to encode arbitrary data to ensure each 32 byte
     *  field is within the valid range.
     *
     *  Setting this automatically populates [[blobVersionedHashes]],
     *  overwriting any existing values. Setting this to ``null``
     *  does **not** remove the [[blobVersionedHashes]], leaving them
     *  present.
     */ get blobs() {
        if (this.#blobs == null) return null;
        return this.#blobs.map((b)=>Object.assign({}, b));
    }
    set blobs(_blobs) {
        if (_blobs == null) {
            this.#blobs = null;
            return;
        }
        const blobs = [];
        const versionedHashes = [];
        for(let i = 0; i < _blobs.length; i++){
            const blob = _blobs[i];
            if ((0, $646c422fbb8bae38$export$9a14abb1a440cd5e)(blob)) {
                (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.#kzg, "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
                    operation: "set blobs()"
                });
                let data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(blob);
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(data.length <= $94b8e5acbf5fee0e$var$BLOB_SIZE, "blob is too large", `blobs[${i}]`, blob);
                // Pad blob if necessary
                if (data.length !== $94b8e5acbf5fee0e$var$BLOB_SIZE) {
                    const padded = new Uint8Array($94b8e5acbf5fee0e$var$BLOB_SIZE);
                    padded.set(data);
                    data = padded;
                }
                const commit = this.#kzg.blobToKzgCommitment(data);
                const proof = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(this.#kzg.computeBlobKzgProof(data, commit));
                blobs.push({
                    data: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(data),
                    commitment: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(commit),
                    proof: proof
                });
                versionedHashes.push($94b8e5acbf5fee0e$var$getVersionedHash(1, commit));
            } else {
                const commit = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(blob.commitment);
                blobs.push({
                    data: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(blob.data),
                    commitment: commit,
                    proof: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(blob.proof)
                });
                versionedHashes.push($94b8e5acbf5fee0e$var$getVersionedHash(1, commit));
            }
        }
        this.#blobs = blobs;
        this.#blobVersionedHashes = versionedHashes;
    }
    get kzg() {
        return this.#kzg;
    }
    set kzg(kzg) {
        this.#kzg = kzg;
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = $94b8e5acbf5fee0e$var$BN_0;
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = $94b8e5acbf5fee0e$var$BN_0;
        this.#chainId = $94b8e5acbf5fee0e$var$BN_0;
        this.#sig = null;
        this.#accessList = null;
        this.#maxFeePerBlobGas = null;
        this.#blobVersionedHashes = null;
        this.#blobs = null;
        this.#kzg = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)(this.#getSerialized(true, false));
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, $eb8e34a59f49e216$export$f8151fce47ad1c35)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, $fab11e657c863d96$export$23cc18f96d8510e2)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, $761062c457f5b164$export$21643ca94aed3e83).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        return this.signature != null;
    }
    #getSerialized(signed, sidecar) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!signed || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        const sig = signed ? this.signature : null;
        switch(this.inferType()){
            case 0:
                return $94b8e5acbf5fee0e$var$_serializeLegacy(this, sig);
            case 1:
                return $94b8e5acbf5fee0e$var$_serializeEip2930(this, sig);
            case 2:
                return $94b8e5acbf5fee0e$var$_serializeEip1559(this, sig);
            case 3:
                return $94b8e5acbf5fee0e$var$_serializeEip4844(this, sig, sidecar ? this.blobs : null);
        }
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        return this.#getSerialized(true, true);
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        return this.#getSerialized(false, false);
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        const types = this.inferTypes();
        // Prefer London (EIP-1559) over Cancun (BLOb)
        if (types.indexOf(2) >= 0) return 2;
        // Return the highest inferred type
        return types.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        const hasBlob = this.#maxFeePerBlobGas != null || this.#blobVersionedHashes;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else if (hasBlob && this.to) types.push(3);
            else {
                types.push(0);
                types.push(1);
                types.push(2);
                types.push(3);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return $94b8e5acbf5fee0e$export$febc5573c75cefb0.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new $94b8e5acbf5fee0e$export$febc5573c75cefb0();
        if (typeof tx === "string") {
            const payload = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(tx);
            if (payload[0] >= 0x7f) return $94b8e5acbf5fee0e$export$febc5573c75cefb0.from($94b8e5acbf5fee0e$var$_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return $94b8e5acbf5fee0e$export$febc5573c75cefb0.from($94b8e5acbf5fee0e$var$_parseEip2930(payload));
                case 2:
                    return $94b8e5acbf5fee0e$export$febc5573c75cefb0.from($94b8e5acbf5fee0e$var$_parseEip1559(payload));
                case 3:
                    return $94b8e5acbf5fee0e$export$febc5573c75cefb0.from($94b8e5acbf5fee0e$var$_parseEip4844(payload));
            }
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new $94b8e5acbf5fee0e$export$febc5573c75cefb0();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.maxFeePerBlobGas != null) result.maxFeePerBlobGas = tx.maxFeePerBlobGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        // This will get overwritten by blobs, if present
        if (tx.blobVersionedHashes != null) result.blobVersionedHashes = tx.blobVersionedHashes;
        // Make sure we assign the kzg before assigning blobs, which
        // require the library in the event raw blob data is provided.
        if (tx.kzg != null) result.kzg = tx.kzg;
        if (tx.blobs != null) result.blobs = tx.blobs;
        if (tx.hash != null) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define '.hash'", "tx", tx);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define '.from'", "tx", tx);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}



/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ 



/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ 


const $a388f2d5ff5077d3$var$Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let $a388f2d5ff5077d3$var$Lookup = null;
function $a388f2d5ff5077d3$var$getAlpha(letter) {
    if ($a388f2d5ff5077d3$var$Lookup == null) {
        $a388f2d5ff5077d3$var$Lookup = {};
        for(let i = 0; i < $a388f2d5ff5077d3$var$Alphabet.length; i++)$a388f2d5ff5077d3$var$Lookup[$a388f2d5ff5077d3$var$Alphabet[i]] = BigInt(i);
    }
    const result = $a388f2d5ff5077d3$var$Lookup[letter];
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const $a388f2d5ff5077d3$var$BN_0 = BigInt(0);
const $a388f2d5ff5077d3$var$BN_58 = BigInt(58);
function $a388f2d5ff5077d3$export$743e6bddc3282b13(_value) {
    const bytes = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_value);
    let value = (0, $80785c90802caadd$export$c221a145703ab783)(bytes);
    let result = "";
    while(value){
        result = $a388f2d5ff5077d3$var$Alphabet[Number(value % $a388f2d5ff5077d3$var$BN_58)] + result;
        value /= $a388f2d5ff5077d3$var$BN_58;
    }
    // Account for leading padding zeros
    for(let i = 0; i < bytes.length; i++){
        if (bytes[i]) break;
        result = $a388f2d5ff5077d3$var$Alphabet[0] + result;
    }
    return result;
}
function $a388f2d5ff5077d3$export$63d430871b22e3d9(value) {
    let result = $a388f2d5ff5077d3$var$BN_0;
    for(let i = 0; i < value.length; i++){
        result *= $a388f2d5ff5077d3$var$BN_58;
        result += $a388f2d5ff5077d3$var$getAlpha(value[i]);
    }
    return result;
}


// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function $3d9ac7bdfd348342$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class $3d9ac7bdfd348342$export$1e6016d1bbd92d2c {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resolves to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resolves to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const $3d9ac7bdfd348342$var$BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class $3d9ac7bdfd348342$export$dcf63b2028a708b5 extends $3d9ac7bdfd348342$export$1e6016d1bbd92d2c {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super($3d9ac7bdfd348342$var$BasicMulticoinPluginId);
    }
}
const $3d9ac7bdfd348342$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $3d9ac7bdfd348342$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $3d9ac7bdfd348342$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class $3d9ac7bdfd348342$export$d04afd034a0a53ae {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            provider: provider,
            address: address,
            name: name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, $89a5854c4eb82178$export$8517d80acf00e19a)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, $f92e169184349c67$export$91d651ee363e1209)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName: funcName
                }
            });
            params = [
                (0, $f92e169184349c67$export$6c0a8cdae51cb512)(this.name, 255),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, $ad62383365eb9d5a$export$b7cbe423ba83da17)) return null;
            return result;
        } catch (error) {
            if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(data, 20)) return (0, $14cfbe985a29575c$export$88411125f012957a)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof $3d9ac7bdfd348342$export$1e6016d1bbd92d2c)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType: coinType,
                data: data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, $a388f2d5ff5077d3$export$743e6bddc3282b13)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data: data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage: linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < $3d9ac7bdfd348342$var$matchers.length; i++){
                const match = avatar.match($3d9ac7bdfd348342$var$matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage: linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = $3d9ac7bdfd348342$var$getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage: linkage,
                                url: url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, $89a5854c4eb82178$export$8517d80acf00e19a)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, $80785c90802caadd$export$c6ebe05badb16181)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $3d9ac7bdfd348342$var$getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, $325c1311ee8826b4$export$319b96fe59834522)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match($3d9ac7bdfd348342$var$matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = $3d9ac7bdfd348342$var$getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage: linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage: linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network: network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await $3d9ac7bdfd348342$export$d04afd034a0a53ae.getEnsAddress(provider);
        try {
            const contract = new (0, $89a5854c4eb82178$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, $f92e169184349c67$export$91d651ee363e1209)(name), {
                enableCcipRead: true
            });
            if (addr === (0, $ad62383365eb9d5a$export$b7cbe423ba83da17)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await $3d9ac7bdfd348342$export$d04afd034a0a53ae.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new $3d9ac7bdfd348342$export$d04afd034a0a53ae(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}


/**
 *  @_ignore
 */ 


function $7e80bdaca2a34c8a$export$769b627a7e45189e(tx) {
    const from = (0, $14cfbe985a29575c$export$88411125f012957a)(tx.from);
    const nonce = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, $14cfbe985a29575c$export$88411125f012957a)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)((0, $eb8e34a59f49e216$export$f8151fce47ad1c35)((0, $f3a1c5b25caae960$export$aea7770274d28b7)([
        from,
        nonceHex
    ])), 12));
}
function $7e80bdaca2a34c8a$export$e0b22d96621f73a2(_from, _salt, _initCodeHash) {
    const from = (0, $14cfbe985a29575c$export$88411125f012957a)(_from);
    const salt = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_salt, "salt");
    const initCodeHash = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(_initCodeHash, "initCodeHash");
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, $14cfbe985a29575c$export$88411125f012957a)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)((0, $eb8e34a59f49e216$export$f8151fce47ad1c35)((0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}





const $a066bcc0d5f8d6f0$var$BN_0 = BigInt(0);
function $a066bcc0d5f8d6f0$export$4b08254e38b74fcd(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function $a066bcc0d5f8d6f0$export$e57ff0f701c44363(format, allowNull) {
    return (array)=>{
        if (allowNull && array == null) return null;
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function $a066bcc0d5f8d6f0$export$be5493f9613cbbe(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value: value
                });
            }
        }
        return result;
    };
}
function $a066bcc0d5f8d6f0$export$7a3be81718959bda(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function $a066bcc0d5f8d6f0$export$1f26277db27165ba(value) {
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(value, true), "invalid data", "value", value);
    return value;
}
function $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88(value) {
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(value, 32), "invalid hash", "value", value);
    return value;
}
function $a066bcc0d5f8d6f0$export$aff4fda55e7ac0d6(value) {
    if (!(0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
    return (0, $646c422fbb8bae38$export$4473860254365feb)(value, 32);
}
const $a066bcc0d5f8d6f0$var$_formatLog = $a066bcc0d5f8d6f0$export$be5493f9613cbbe({
    address: (0, $14cfbe985a29575c$export$88411125f012957a),
    blockHash: $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88,
    blockNumber: (0, $80785c90802caadd$export$b14f2714108df84),
    data: $a066bcc0d5f8d6f0$export$1f26277db27165ba,
    index: (0, $80785c90802caadd$export$b14f2714108df84),
    removed: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$7a3be81718959bda, false),
    topics: $a066bcc0d5f8d6f0$export$e57ff0f701c44363($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88),
    transactionHash: $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88,
    transactionIndex: (0, $80785c90802caadd$export$b14f2714108df84)
}, {
    index: [
        "logIndex"
    ]
});
function $a066bcc0d5f8d6f0$export$fccdbdc2b9d7893(value) {
    return $a066bcc0d5f8d6f0$var$_formatLog(value);
}
const $a066bcc0d5f8d6f0$var$_formatBlock = $a066bcc0d5f8d6f0$export$be5493f9613cbbe({
    hash: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88),
    parentHash: $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88,
    parentBeaconBlockRoot: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88, null),
    number: (0, $80785c90802caadd$export$b14f2714108df84),
    timestamp: (0, $80785c90802caadd$export$b14f2714108df84),
    nonce: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$1f26277db27165ba),
    difficulty: (0, $80785c90802caadd$export$61fe455e2b1e28a4),
    gasLimit: (0, $80785c90802caadd$export$61fe455e2b1e28a4),
    gasUsed: (0, $80785c90802caadd$export$61fe455e2b1e28a4),
    stateRoot: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88, null),
    receiptsRoot: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88, null),
    blobGasUsed: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4), null),
    excessBlobGas: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4), null),
    miner: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $14cfbe985a29575c$export$88411125f012957a)),
    prevRandao: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88, null),
    extraData: $a066bcc0d5f8d6f0$export$1f26277db27165ba,
    baseFeePerGas: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4))
}, {
    prevRandao: [
        "mixHash"
    ]
});
function $a066bcc0d5f8d6f0$export$ba1152bc4017d62a(value) {
    const result = $a066bcc0d5f8d6f0$var$_formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return $a066bcc0d5f8d6f0$export$fe50e42b325965d(tx);
    });
    return result;
}
const $a066bcc0d5f8d6f0$var$_formatReceiptLog = $a066bcc0d5f8d6f0$export$be5493f9613cbbe({
    transactionIndex: (0, $80785c90802caadd$export$b14f2714108df84),
    blockNumber: (0, $80785c90802caadd$export$b14f2714108df84),
    transactionHash: $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88,
    address: (0, $14cfbe985a29575c$export$88411125f012957a),
    topics: $a066bcc0d5f8d6f0$export$e57ff0f701c44363($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88),
    data: $a066bcc0d5f8d6f0$export$1f26277db27165ba,
    index: (0, $80785c90802caadd$export$b14f2714108df84),
    blockHash: $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88
}, {
    index: [
        "logIndex"
    ]
});
function $a066bcc0d5f8d6f0$export$5ec2fc59e0e92b87(value) {
    return $a066bcc0d5f8d6f0$var$_formatReceiptLog(value);
}
const $a066bcc0d5f8d6f0$var$_formatTransactionReceipt = $a066bcc0d5f8d6f0$export$be5493f9613cbbe({
    to: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $14cfbe985a29575c$export$88411125f012957a), null),
    from: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $14cfbe985a29575c$export$88411125f012957a), null),
    contractAddress: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $14cfbe985a29575c$export$88411125f012957a), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, $80785c90802caadd$export$b14f2714108df84),
    root: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)),
    gasUsed: (0, $80785c90802caadd$export$61fe455e2b1e28a4),
    blobGasUsed: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4), null),
    logsBloom: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$1f26277db27165ba),
    blockHash: $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88,
    hash: $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88,
    logs: $a066bcc0d5f8d6f0$export$e57ff0f701c44363($a066bcc0d5f8d6f0$export$5ec2fc59e0e92b87),
    blockNumber: (0, $80785c90802caadd$export$b14f2714108df84),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, $80785c90802caadd$export$61fe455e2b1e28a4),
    effectiveGasPrice: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4)),
    blobGasPrice: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4), null),
    status: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$b14f2714108df84)),
    type: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$b14f2714108df84), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function $a066bcc0d5f8d6f0$export$30da670e49d6fc31(value) {
    return $a066bcc0d5f8d6f0$var$_formatTransactionReceipt(value);
}
function $a066bcc0d5f8d6f0$export$fe50e42b325965d(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value.to) === $a066bcc0d5f8d6f0$var$BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = $a066bcc0d5f8d6f0$export$be5493f9613cbbe({
        hash: $a066bcc0d5f8d6f0$export$bb5bc852e1c64b88,
        // Some nodes do not return this, usually test nodes (like Ganache)
        index: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$b14f2714108df84), undefined),
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, $80785c90802caadd$export$b14f2714108df84)(value);
        },
        accessList: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $7113bd4426313aea$export$6c8662b1600dce2), null),
        blobVersionedHashes: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$e57ff0f701c44363($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88, true), null),
        blockHash: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd($a066bcc0d5f8d6f0$export$bb5bc852e1c64b88, null),
        blockNumber: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$b14f2714108df84), null),
        transactionIndex: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$b14f2714108df84), null),
        from: (0, $14cfbe985a29575c$export$88411125f012957a),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4)),
        maxPriorityFeePerGas: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4)),
        maxFeePerGas: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4)),
        maxFeePerBlobGas: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4), null),
        gasLimit: (0, $80785c90802caadd$export$61fe455e2b1e28a4),
        to: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $14cfbe985a29575c$export$88411125f012957a), null),
        value: (0, $80785c90802caadd$export$61fe455e2b1e28a4),
        nonce: (0, $80785c90802caadd$export$b14f2714108df84),
        data: $a066bcc0d5f8d6f0$export$1f26277db27165ba,
        creates: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $14cfbe985a29575c$export$88411125f012957a), null),
        chainId: $a066bcc0d5f8d6f0$export$4b08254e38b74fcd((0, $80785c90802caadd$export$61fe455e2b1e28a4), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ],
        index: [
            "transactionIndex"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, $7e80bdaca2a34c8a$export$769b627a7e45189e)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).from(value.signature);
    else result.signature = (0, $b9b4a54a1598ff6f$export$848620f5f2f26e86).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, $80785c90802caadd$export$61fe455e2b1e28a4)(result.blockHash) === $a066bcc0d5f8d6f0$var$BN_0) result.blockHash = null;
    return result;
}


/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ 



const $b58fc9a2a1e8f235$var$EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class $b58fc9a2a1e8f235$export$10ae60faeb7e2196 {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new $b58fc9a2a1e8f235$export$10ae60faeb7e2196(this.name);
    }
}
class $b58fc9a2a1e8f235$export$f2b0810a2dd50377 extends $b58fc9a2a1e8f235$export$10ae60faeb7e2196 {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock: effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, props);
    }
    clone() {
        return new $b58fc9a2a1e8f235$export$f2b0810a2dd50377(this.effectiveBlock, this);
    }
}
class $b58fc9a2a1e8f235$export$9be0b2c573890879 extends $b58fc9a2a1e8f235$export$10ae60faeb7e2196 {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            address: address || $b58fc9a2a1e8f235$var$EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new $b58fc9a2a1e8f235$export$9be0b2c573890879(this.address, this.targetNetwork);
    }
}
class $b58fc9a2a1e8f235$export$dd49482b7e9ea2da extends $b58fc9a2a1e8f235$export$10ae60faeb7e2196 {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new $b58fc9a2a1e8f235$export$dd49482b7e9ea2da(this.#feeDataFunc);
    }
}
class $b58fc9a2a1e8f235$export$3bee30f9880d72e8 extends $b58fc9a2a1e8f235$export$10ae60faeb7e2196 {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
} /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ 


/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const $c2853b8482d85666$var$Networks = new Map();
class $c2853b8482d85666$export$95be4ae94445245a {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, $80785c90802caadd$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, $80785c90802caadd$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, $80785c90802caadd$export$61fe455e2b1e28a4)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new $c2853b8482d85666$export$95be4ae94445245a(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, $b58fc9a2a1e8f235$export$f2b0810a2dd50377)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, $7113bd4426313aea$export$6c8662b1600dce2)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        $c2853b8482d85666$var$injectCommonNetworks();
        // Default network
        if (network == null) return $c2853b8482d85666$export$95be4ae94445245a.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = $c2853b8482d85666$var$Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new $c2853b8482d85666$export$95be4ae94445245a("unknown", network);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new $c2853b8482d85666$export$95be4ae94445245a(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, $b58fc9a2a1e8f235$export$9be0b2c573890879)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = $c2853b8482d85666$var$Networks.get(nameOrChainId);
        if (existing) (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        $c2853b8482d85666$var$Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function $c2853b8482d85666$var$parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function $c2853b8482d85666$var$getGasStationPlugin(url) {
    return new (0, $b58fc9a2a1e8f235$export$3bee30f9880d72e8)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.standard;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: $c2853b8482d85666$var$parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: $c2853b8482d85666$var$parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request: request,
                response: response,
                error: error
            });
        }
    });
}
// See: https://chainlist.org
let $c2853b8482d85666$var$injected = false;
function $c2853b8482d85666$var$injectCommonNetworks() {
    if ($c2853b8482d85666$var$injected) return;
    $c2853b8482d85666$var$injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new $c2853b8482d85666$export$95be4ae94445245a(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, $b58fc9a2a1e8f235$export$9be0b2c573890879)(null, options.ensNetwork));
            network.attachPlugin(new (0, $b58fc9a2a1e8f235$export$f2b0810a2dd50377)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        $c2853b8482d85666$export$95be4ae94445245a.register(name, func);
        $c2853b8482d85666$export$95be4ae94445245a.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            $c2853b8482d85666$export$95be4ae94445245a.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {
        ensNetwork: 11155111
    });
    registerEth("holesky", 17000, {
        ensNetwork: 17000
    });
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("arbitrum-sepolia", 421614, {});
    registerEth("base", 8453, {
        ensNetwork: 1
    });
    registerEth("base-goerli", 84531, {});
    registerEth("base-sepolia", 84532, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("linea-sepolia", 59141, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            $c2853b8482d85666$var$getGasStationPlugin("https://gasstation.polygon.technology/v2")
        ]
    });
    registerEth("matic-amoy", 80002, {});
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            $c2853b8482d85666$var$getGasStationPlugin("https://gasstation-testnet.polygon.technology/v2")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: []
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("optimism-sepolia", 11155420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}




function $e0893c0798a06950$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $e0893c0798a06950$export$c1d4f1f6d1988b77(provider, event) {
    if (event === "block") return new $e0893c0798a06950$export$aaf796a16ac1a157(provider);
    if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(event, 32)) return new $e0893c0798a06950$export$4fe8a9740765f97e(provider, event);
    (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event: event
        }
    });
}
class $e0893c0798a06950$export$aaf796a16ac1a157 {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class $e0893c0798a06950$export$e8024646c9bd1a27 {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class $e0893c0798a06950$export$63862f83f14090ef extends $e0893c0798a06950$export$e8024646c9bd1a27 {
    #tag;
    #lastBlock;
    constructor(provider, tag){
        super(provider);
        this.#tag = tag;
        this.#lastBlock = -2;
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#lastBlock = -2;
        super.pause(dropWhilePaused);
    }
    async _poll(blockNumber, provider) {
        const block = await provider.getBlock(this.#tag);
        if (block == null) return;
        if (this.#lastBlock === -2) this.#lastBlock = block.number;
        else if (block.number > this.#lastBlock) {
            provider.emit(this.#tag, block.number);
            this.#lastBlock = block.number;
        }
    }
}
class $e0893c0798a06950$export$e4ed5c6414dc4e9e extends $e0893c0798a06950$export$e8024646c9bd1a27 {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = $e0893c0798a06950$var$copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class $e0893c0798a06950$export$4fe8a9740765f97e extends $e0893c0798a06950$export$e8024646c9bd1a27 {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class $e0893c0798a06950$export$bdb759dc2fe68c72 {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = $e0893c0798a06950$var$copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = $e0893c0798a06950$var$copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}


// Constants
const $2d17e5aef6aa1106$var$BN_2 = BigInt(2);
const $2d17e5aef6aa1106$var$MAX_CCIP_REDIRECTS = 10;
function $2d17e5aef6aa1106$var$isPromise(value) {
    return value && typeof value.then === "function";
}
function $2d17e5aef6aa1106$var$getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class $2d17e5aef6aa1106$export$f255b979f86248fa {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function $2d17e5aef6aa1106$var$copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function $2d17e5aef6aa1106$var$concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function $2d17e5aef6aa1106$var$getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: $2d17e5aef6aa1106$var$getTag("tx", {
                hash: hash
            }),
            hash: hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: $2d17e5aef6aa1106$var$getTag("orphan", event),
            filter: $2d17e5aef6aa1106$var$copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return $2d17e5aef6aa1106$var$concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, $06f9d9d760226a67$export$687eed6b344123c9)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = $2d17e5aef6aa1106$var$concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter: filter,
            tag: $2d17e5aef6aa1106$var$getTag("event", filter),
            type: "event"
        };
    }
    (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "unknown ProviderEvent", "event", _event);
}
function $2d17e5aef6aa1106$var$getTime() {
    return new Date().getTime();
}
const $2d17e5aef6aa1106$var$defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $2d17e5aef6aa1106$export$ae9650e85fb229fe {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, $2d17e5aef6aa1106$var$defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, $c2853b8482d85666$export$95be4ae94445245a).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = $2d17e5aef6aa1106$var$getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, $325c1311ee8826b4$export$319b96fe59834522)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data: data,
                sender: sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request: request,
                index: i,
                urls: urls
            });
            let errorMessage = "unknown error";
            const resp = await request.send();
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request: request,
                        result: result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url: url,
                    errorMessage: errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls: urls,
                errorMessages: errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, $991b98fda7342cdd$export$d96a8827a60d6b69)((0, $a066bcc0d5f8d6f0$export$ba1152bc4017d62a)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, $991b98fda7342cdd$export$ce30dbb46644d06c)((0, $a066bcc0d5f8d6f0$export$fccdbdc2b9d7893)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, $991b98fda7342cdd$export$375ffd5683aa5c1c)((0, $a066bcc0d5f8d6f0$export$30da670e49d6fc31)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, $991b98fda7342cdd$export$70966cdb3bfc0785)((0, $a066bcc0d5f8d6f0$export$fe50e42b325965d)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, $80785c90802caadd$export$b14f2714108df84)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, $06f9d9d760226a67$export$687eed6b344123c9)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "finalized":
            case "latest":
            case "pending":
            case "safe":
                return blockTag;
        }
        if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(blockTag)) {
            if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(blockTag, 32)) return blockTag;
            return (0, $80785c90802caadd$export$d9c067986dbc68dd)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, $80785c90802caadd$export$b14f2714108df84)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, $80785c90802caadd$export$d9c067986dbc68dd)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, $80785c90802caadd$export$d9c067986dbc68dd)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, $80785c90802caadd$export$d9c067986dbc68dd)(b + blockTag));
        }
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return $2d17e5aef6aa1106$var$concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resolves to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, $991b98fda7342cdd$export$607b34cdac162b7f)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, $06f9d9d760226a67$export$687eed6b344123c9)(request[key], this);
            if ($2d17e5aef6aa1106$var$isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if ($2d17e5aef6aa1106$var$isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = (async ()=>{
                try {
                    const network = await this._detectNetwork();
                    this.emit("network", network, null);
                    return network;
                } catch (error) {
                    if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                    throw error;
                }
            })();
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block: _block, gasPrice: gasPrice, priorityFee: priorityFee } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })(),
                priorityFee: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getPriorityFee"
                        });
                        return (0, $80785c90802caadd$export$61fe455e2b1e28a4)(value, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = priorityFee != null ? priorityFee : BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * $2d17e5aef6aa1106$var$BN_2 + maxPriorityFeePerGas;
            }
            return new (0, $991b98fda7342cdd$export$116c49c1e2a96a78)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, $325c1311ee8826b4$export$319b96fe59834522)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, $991b98fda7342cdd$export$116c49c1e2a96a78)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if ($2d17e5aef6aa1106$var$isPromise(tx)) tx = await tx;
        return (0, $80785c90802caadd$export$61fe455e2b1e28a4)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(attempt < $2d17e5aef6aa1106$var$MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag: blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, $991b98fda7342cdd$export$607b34cdac162b7f)(tx);
        try {
            return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(await this._perform({
                method: "call",
                transaction: transaction,
                blockTag: blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, $bb8e52d338877b37$export$748c4fa78f31ff35)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, $06f9d9d760226a67$export$687eed6b344123c9)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = $2d17e5aef6aa1106$var$parseOffchainLookup((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(error.data, 4));
                } catch (error) {
                    (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction: transaction,
                        info: {
                            data: data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, $bb8e52d338877b37$export$a7a9523472993e97)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data: data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, $bb8e52d338877b37$export$a7a9523472993e97)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction: transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)([
                        ccipArgs.selector,
                        $2d17e5aef6aa1106$var$encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result: result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error: error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value: value } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx: tx, blockTag: blockTag } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address: address,
            blockTag: blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, $80785c90802caadd$export$61fe455e2b1e28a4)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, $80785c90802caadd$export$b14f2714108df84)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(_position, "position");
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getStorage",
            position: position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber: blockNumber, hash: hash, network: network } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, $94b8e5acbf5fee0e$export$febc5573c75cefb0).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions: includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag: blockTag,
            includeTransactions: includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network: network, params: params } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network: network, params: params } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash: hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network: network, params: params } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash: hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash: hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result: result } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash: hash
            })
        });
        if (result == null) return null;
        return (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if ($2d17e5aef6aa1106$var$isPromise(filter)) filter = await filter;
        const { network: network, params: params } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter: filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, $3d9ac7bdfd348342$export$d04afd034a0a53ae).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, $14cfbe985a29575c$export$88411125f012957a)(address);
        const node = (0, $f92e169184349c67$export$91d651ee363e1209)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, $3d9ac7bdfd348342$export$d04afd034a0a53ae).getEnsAddress(this);
            const ensContract = new (0, $89a5854c4eb82178$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, $ad62383365eb9d5a$export$b7cbe423ba83da17)) return null;
            const resolverContract = new (0, $89a5854c4eb82178$export$8517d80acf00e19a)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func: func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer: timer,
                func: func,
                time: $2d17e5aef6aa1106$var$getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new $2d17e5aef6aa1106$export$f255b979f86248fa(sub.type);
            case "block":
                {
                    const subscriber = new (0, $e0893c0798a06950$export$aaf796a16ac1a157)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "safe":
            case "finalized":
                return new (0, $e0893c0798a06950$export$63862f83f14090ef)(this, sub.type);
            case "event":
                return new (0, $e0893c0798a06950$export$bdb759dc2fe68c72)(this, sub.filter);
            case "transaction":
                return new (0, $e0893c0798a06950$export$4fe8a9740765f97e)(this, sub.hash);
            case "orphan":
                return new (0, $e0893c0798a06950$export$e4ed5c6414dc4e9e)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await $2d17e5aef6aa1106$var$getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await $2d17e5aef6aa1106$var$getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await $2d17e5aef6aa1106$var$getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber: subscriber,
                tag: tag,
                addressableMap: addressableMap,
                nameMap: nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
            const payload = new (0, $74fe9324908d292c$export$9cec82196983b278)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners: listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        let result = [];
        for (const { listeners: listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag: tag, started: started, subscriber: subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started: started, subscriber: subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = $2d17e5aef6aa1106$var$getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = $2d17e5aef6aa1106$var$getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function $2d17e5aef6aa1106$var$_parseString(result, start) {
    try {
        const bytes = $2d17e5aef6aa1106$var$_parseBytes(result, start);
        if (bytes) return (0, $bd5f6433d45dd8bb$export$7643a1dc2c38d5eb)(bytes);
    } catch (error) {}
    return null;
}
function $2d17e5aef6aa1106$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, $80785c90802caadd$export$b14f2714108df84)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(result, start, start + 32));
        const length = (0, $80785c90802caadd$export$b14f2714108df84)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(result, offset, offset + 32));
        return (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function $2d17e5aef6aa1106$var$numPad(value) {
    const result = (0, $80785c90802caadd$export$b627fcfb5ea68cb0)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $2d17e5aef6aa1106$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const $2d17e5aef6aa1106$var$empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function $2d17e5aef6aa1106$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push($2d17e5aef6aa1106$var$empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $646c422fbb8bae38$export$a3521add2594f3c8)(datas[i]);
        // Update the bytes offset
        result[i] = $2d17e5aef6aa1106$var$numPad(byteCount);
        // The length and padded value of data
        result.push($2d17e5aef6aa1106$var$numPad(data.length));
        result.push($2d17e5aef6aa1106$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $646c422fbb8bae38$export$ee1b3e54f0441b22)(result);
}
const $2d17e5aef6aa1106$var$zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $2d17e5aef6aa1106$var$parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, $bb8e52d338877b37$export$a7a9523472993e97)((0, $646c422fbb8bae38$export$2321cd91b99770ff)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, 0, 32);
    (0, $bb8e52d338877b37$export$a7a9523472993e97)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(sender, 0, 12) === (0, $646c422fbb8bae38$export$f6d845ffb449edc9)($2d17e5aef6aa1106$var$zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, $80785c90802caadd$export$b14f2714108df84)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, 32, 64));
        const urlsLength = (0, $80785c90802caadd$export$b14f2714108df84)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = $2d17e5aef6aa1106$var$_parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = $2d17e5aef6aa1106$var$_parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, $bb8e52d338877b37$export$a7a9523472993e97)((0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, 100, 128) === (0, $646c422fbb8bae38$export$f6d845ffb449edc9)($2d17e5aef6aa1106$var$zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, $646c422fbb8bae38$export$f6d845ffb449edc9)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = $2d17e5aef6aa1106$var$_parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}


/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ 



function $2fc8694982413032$var$checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
}
async function $2fc8694982413032$var$populate(signer, tx) {
    let pop = (0, $991b98fda7342cdd$export$607b34cdac162b7f)(tx);
    if (pop.to != null) pop.to = (0, $06f9d9d760226a67$export$687eed6b344123c9)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, $06f9d9d760226a67$export$687eed6b344123c9)(from, signer)
        ]).then(([address, from])=>{
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, $fcb333efda27d9d7$export$d503dd157d963b60)(pop);
}
class $2fc8694982413032$export$6c02143914c373f1 {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return $2fc8694982413032$var$checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await $2fc8694982413032$var$populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = $2fc8694982413032$var$checkProvider(this, "populateTransaction");
        const pop = await $2fc8694982413032$var$populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, $80785c90802caadd$export$61fe455e2b1e28a4)(pop.chainId);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, $bb8e52d338877b37$export$a7a9523472993e97)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, $bb8e52d338877b37$export$a7a9523472993e97)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2 || pop.type === 3) {
                // Explicitly using EIP-1559 or EIP-4844
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, $fcb333efda27d9d7$export$d503dd157d963b60)(pop);
    }
    async estimateGas(tx) {
        return $2fc8694982413032$var$checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return $2fc8694982413032$var$checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = $2fc8694982413032$var$checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = $2fc8694982413032$var$checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, $94b8e5acbf5fee0e$export$febc5573c75cefb0).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
}
class $2fc8694982413032$export$7dbc56d9b9612bad extends $2fc8694982413032$export$6c02143914c373f1 {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $2fc8694982413032$export$7dbc56d9b9612bad(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}





function $23ddc8c18cd7c224$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class $23ddc8c18cd7c224$export$a51133e713c99bbe {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                if (this.#provider.destroyed) return;
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class $23ddc8c18cd7c224$export$60f65cdabb3c5771 extends $23ddc8c18cd7c224$export$a51133e713c99bbe {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = $23ddc8c18cd7c224$var$copy(filter);
    }
    _recover(provider) {
        return new (0, $e0893c0798a06950$export$bdb759dc2fe68c72)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class $23ddc8c18cd7c224$export$285511066b2a5499 extends $23ddc8c18cd7c224$export$a51133e713c99bbe {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}



const $22d55ea3b548b1fe$var$Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function $22d55ea3b548b1fe$var$deepCopy(value) {
    if (value == null || $22d55ea3b548b1fe$var$Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map($22d55ea3b548b1fe$var$deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function $22d55ea3b548b1fe$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $22d55ea3b548b1fe$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function $22d55ea3b548b1fe$var$isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const $22d55ea3b548b1fe$var$defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $22d55ea3b548b1fe$export$5f7b5fca3508545a extends (0, $2fc8694982413032$export$6c02143914c373f1) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, $14cfbe985a29575c$export$88411125f012957a)(address);
        (0, $fcb333efda27d9d7$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    connect(provider) {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = $22d55ea3b548b1fe$var$deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, $06f9d9d760226a67$export$687eed6b344123c9)(_from, this.provider);
                (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, $06f9d9d760226a67$export$687eed6b344123c9)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            let invalids = 0;
            const checkTx = async ()=>{
                try {
                    // Try getting the transaction
                    const tx = await this.provider.getTransaction(hash);
                    if (tx != null) {
                        resolve(tx.replaceableTransaction(blockNumber));
                        return;
                    }
                } catch (error) {
                    // If we were cancelled: stop polling.
                    // If the data is bad: the node returns bad transactions
                    // If the network changed: calling again will also fail
                    // If unsupported: likely destroyed
                    if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "CANCELLED") || (0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "BAD_DATA") || (0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "NETWORK_ERROR")) {
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        reject(error);
                        return;
                    }
                    // Stop-gap for misbehaving backends; see #4513
                    if ((0, $bb8e52d338877b37$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT")) {
                        invalids++;
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        if (invalids > 10) {
                            reject(error);
                            return;
                        }
                    }
                    // Notify anyone that cares; but we will try again, since
                    // it is likely an intermittent service error
                    this.provider.emit("error", (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", {
                        error: error
                    }));
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = $22d55ea3b548b1fe$var$deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, $06f9d9d760226a67$export$687eed6b344123c9)(tx.from, this.provider);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = $22d55ea3b548b1fe$var$deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, $ce7c7003fbfaaf87$export$458ab927ae635c3).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, $06f9d9d760226a67$export$687eed6b344123c9)(value);
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, $ce7c7003fbfaaf87$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, $bd5f6433d45dd8bb$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(message)
        ]);
    }
}
class $22d55ea3b548b1fe$export$5afe35a44ca7ff9a extends (0, $2d17e5aef6aa1106$export$ae9650e85fb229fe) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #pendingDetectNetwork;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no harm in sending it immediately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload: payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result: result
                        });
                        // Process results in batch order
                        for (const { resolve: resolve, reject: reject, payload: payload } of batch){
                            if (this.destroyed) {
                                reject((0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload: payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error: error
                        });
                        for (const { reject: reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, $22d55ea3b548b1fe$var$defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        this.#pendingDetectNetwork = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise: promise,
                resolve: resolve
            };
        }
        const staticNetwork = this._getOption("staticNetwork");
        if (typeof staticNetwork === "boolean") {
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!staticNetwork || network !== "any", "staticNetwork cannot be used on special network 'any'", "options", options);
            if (staticNetwork && network != null) this.#network = (0, $c2853b8482d85666$export$95be4ae94445245a).from(network);
        } else if (staticNetwork) {
            // Make sure any static network is compatbile with the provided netwrok
            (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, $bb8e52d338877b37$export$a7a9523472993e97)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, $80785c90802caadd$export$61fe455e2b1e28a4)(tx.type)) // If there are no EIP-1559 or newer properties, it might be pre-EIP-1559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) {
            if (network === true) {
                if (this.#network) return this.#network;
            } else return network;
        }
        if (this.#pendingDetectNetwork) return await this.#pendingDetectNetwork;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) {
            this.#pendingDetectNetwork = (async ()=>{
                try {
                    const result = (0, $c2853b8482d85666$export$95be4ae94445245a).from((0, $80785c90802caadd$export$61fe455e2b1e28a4)(await this.send("eth_chainId", [])));
                    this.#pendingDetectNetwork = null;
                    return result;
                } catch (error) {
                    this.#pendingDetectNetwork = null;
                    throw error;
                }
            })();
            return await this.#pendingDetectNetwork;
        }
        // We are not ready yet; use the primitive _send
        this.#pendingDetectNetwork = (async ()=>{
            const payload = {
                id: this.#nextId++,
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0"
            };
            this.emit("debug", {
                action: "sendRpcPayload",
                payload: payload
            });
            let result;
            try {
                result = (await this._send(payload))[0];
                this.#pendingDetectNetwork = null;
            } catch (error) {
                this.#pendingDetectNetwork = null;
                this.emit("debug", {
                    action: "receiveRpcError",
                    error: error
                });
                throw error;
            }
            this.emit("debug", {
                action: "receiveRpcResult",
                result: result
            });
            if ("result" in result) return (0, $c2853b8482d85666$export$95be4ae94445245a).from((0, $80785c90802caadd$export$61fe455e2b1e28a4)(result.result));
            throw this.getRpcError(payload, result);
        })();
        return await this.#pendingDetectNetwork;
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error: error
                    }
                }));
                await $22d55ea3b548b1fe$var$stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, $23ddc8c18cd7c224$export$285511066b2a5499)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, $e0893c0798a06950$export$bdb759dc2fe68c72)(this, sub.filter);
            return new (0, $23ddc8c18cd7c224$export$60f65cdabb3c5771)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, $2d17e5aef6aa1106$export$f255b979f86248fa)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, $80785c90802caadd$export$d9c067986dbc68dd)((0, $80785c90802caadd$export$61fe455e2b1e28a4)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, $646c422fbb8bae38$export$2b0d6b5fbe698c70)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, $7113bd4426313aea$export$6c8662b1600dce2)(tx.accessList);
        if (tx.blobVersionedHashes) // @TODO: Remove this <any> case once EIP-4844 added to prepared tx
        result["blobVersionedHashes"] = tx.blobVersionedHashes.map((h)=>h.toLowerCase());
        // @TODO: blobs should probably also be copied over, optionally
        // accounting for the kzg property to backfill blobVersionedHashes
        // using the commitment. Or should that be left as an exercise to
        // the caller?
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getPriorityFee":
                return {
                    method: "eth_maxPriorityFeePerGas",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        $22d55ea3b548b1fe$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        $22d55ea3b548b1fe$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        $22d55ea3b548b1fe$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        $22d55ea3b548b1fe$var$getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map($22d55ea3b548b1fe$var$getLowerCase);
                    else req.filter.address = $22d55ea3b548b1fe$var$getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method: method } = payload;
        const { error: error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = $22d55ea3b548b1fe$var$spelunkData(error);
            const e = (0, $dfec5cc4eff24eb3$export$fe041e1a83d3efc6).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error: error,
                payload: payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify($22d55ea3b548b1fe$var$spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction: transaction,
                    info: {
                        error: error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error: error,
                payload: payload
            }
        });
        return (0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("could not coalesce error", "UNKNOWN_ERROR", {
            error: error,
            payload: payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve: resolve,
                reject: reject,
                payload: {
                    method: method,
                    params: params,
                    id: id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new $22d55ea3b548b1fe$export$5f7b5fca3508545a(this, accounts[address]);
        }
        const { accounts: accounts } = await (0, $fcb333efda27d9d7$export$d503dd157d963b60)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, $14cfbe985a29575c$export$88411125f012957a)(address);
        for (const account of accounts){
            if ((0, $14cfbe985a29575c$export$88411125f012957a)(account) === address) return new $22d55ea3b548b1fe$export$5f7b5fca3508545a(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new $22d55ea3b548b1fe$export$5f7b5fca3508545a(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload: payload, reject: reject } of this.#payloads)reject((0, $bb8e52d338877b37$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class $22d55ea3b548b1fe$export$e16ffa1aa36d1432 extends $22d55ea3b548b1fe$export$5afe35a44ca7ff9a {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        let pollingInterval = this._getOption("pollingInterval");
        if (pollingInterval == null) pollingInterval = $22d55ea3b548b1fe$var$defaultOptions.pollingInterval;
        this.#pollingInterval = pollingInterval;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if ($22d55ea3b548b1fe$var$isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if ($22d55ea3b548b1fe$var$isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class $22d55ea3b548b1fe$export$da28308012bf6748 extends $22d55ea3b548b1fe$export$e16ffa1aa36d1432 {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http://localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, $325c1311ee8826b4$export$319b96fe59834522)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function $22d55ea3b548b1fe$var$spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, $646c422fbb8bae38$export$b02a40aff8e4ad18)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $22d55ea3b548b1fe$var$spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $22d55ea3b548b1fe$var$spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function $22d55ea3b548b1fe$var$_spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)$22d55ea3b548b1fe$var$_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $22d55ea3b548b1fe$var$_spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function $22d55ea3b548b1fe$var$spelunkMessage(value) {
    const result = [];
    $22d55ea3b548b1fe$var$_spelunkMessage(value, result);
    return result;
}


class $944cdf2495302059$export$8d50d0931f78dec8 extends (0, $22d55ea3b548b1fe$export$e16ffa1aa36d1432) {
    #request;
    /**
     *  Connnect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */ constructor(ethereum, network, _options){
        // Copy the options
        const options = Object.assign({}, _options != null ? _options : {}, {
            batchMaxCount: 1
        });
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(ethereum && ethereum.request, "invalid EIP-1193 provider", "ethereum", ethereum);
        super(network, options);
        this.#request = async (method, params)=>{
            const payload = {
                method: method,
                params: params
            };
            this.emit("debug", {
                action: "sendEip1193Request",
                payload: payload
            });
            try {
                const result = await ethereum.request(payload);
                this.emit("debug", {
                    action: "receiveEip1193Result",
                    result: result
                });
                return result;
            } catch (e) {
                const error = new Error(e.message);
                error.code = e.code;
                error.data = e.data;
                error.payload = payload;
                this.emit("debug", {
                    action: "receiveEip1193Error",
                    error: error
                });
                throw error;
            }
        };
    }
    async send(method, params) {
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        (0, $bb8e52d338877b37$export$c3d31707e5030f5e)(!Array.isArray(payload), "EIP-1193 does not support batch request", "payload", payload);
        try {
            const result = await this.#request(payload.method, payload.params || []);
            return [
                {
                    id: payload.id,
                    result: result
                }
            ];
        } catch (e) {
            return [
                {
                    id: payload.id,
                    error: {
                        code: e.code,
                        data: e.data,
                        message: e.message
                    }
                }
            ];
        }
    }
    getRpcError(payload, error) {
        error = JSON.parse(JSON.stringify(error));
        // EIP-1193 gives us some machine-readable error codes, so rewrite
        // them into 
        switch(error.error.code || -1){
            case 4001:
                error.error.message = `ethers-user-denied: ${error.error.message}`;
                break;
            case 4200:
                error.error.message = `ethers-unsupported: ${error.error.message}`;
                break;
        }
        return super.getRpcError(payload, error);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */ async hasSigner(address) {
        if (address == null) address = 0;
        const accounts = await this.send("eth_accounts", []);
        if (typeof address === "number") return accounts.length > address;
        address = address.toLowerCase();
        return accounts.filter((a)=>a.toLowerCase() === address).length !== 0;
    }
    async getSigner(address) {
        if (address == null) address = 0;
        if (!await this.hasSigner(address)) try {
            //const resp = 
            await this.#request("eth_requestAccounts", []);
        //console.log("RESP", resp);
        } catch (error) {
            const payload = error.payload;
            throw this.getRpcError(payload, {
                id: payload.id,
                error: error
            });
        }
        return await super.getSigner(address);
    }
}


const $08c692ba89353911$var$ConnectWalletButton = ({ onAddressConnect: onAddressConnect })=>{
    const connectWallet = async ()=>{
        if (window.ethereum) try {
            // Requesting access to the user's accounts
            await window.ethereum.request({
                method: "eth_requestAccounts"
            });
            const provider = new (0, $944cdf2495302059$export$8d50d0931f78dec8)(window.ethereum);
            const accounts = await provider.listAccounts();
            // If the parent component provides the onAddressConnect function, call it with the first account
            if (onAddressConnect) onAddressConnect(accounts[0].address);
        } catch (error) {
            console.error("User denied account access:", error);
        }
        else console.error("Ethereum object doesn't exist!");
    };
    (0, $exYeM.useEffect)(()=>{
        const handleAccountsChanged = (accounts)=>{
            if (accounts.length === 0) ;
            else if (onAddressConnect) onAddressConnect(accounts[0]);
        };
        if (window.ethereum) window.ethereum.on("accountsChanged", handleAccountsChanged);
        // Cleanup function to remove the event listener
        return ()=>{
            if (window.ethereum) window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
        };
    }, [
        onAddressConnect
    ]); // This effect depends on onAddressConnect
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $433754a817809fb2$export$3b0a9d598f613fa), {
        type: "button",
        variant: "semibold",
        onClick: connectWallet,
        className: "rounded-md border border-onSurfaceVariant bg-white hover:bg-primary hover:text-white px-2 py-2.5 w-fit h-full shadow-md text-gray-800",
        children: "Connect"
    });
};
var $08c692ba89353911$export$2e2bcd8739ae039 = $08c692ba89353911$var$ConnectWalletButton;



var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");









const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $71edc3b1c9a6f9c6$export$c7109489551a4f4] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $71edc3b1c9a6f9c6$export$8699f7c8af148338 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $aJx1R.default)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($71edc3b1c9a6f9c6$export$8699f7c8af148338, {
    displayName: $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $exYeM.useState)(false);
    const handleEntryFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $exYeM.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $exYeM.useState)(0);
    (0, $exYeM.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $exYeM.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $exYeM.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $exYeM.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $exYeM.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $71edc3b1c9a6f9c6$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    (0, $exYeM.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $aJx1R.default)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($71edc3b1c9a6f9c6$export$ab9df7c53fe8454, {
    displayName: $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9 = $71edc3b1c9a6f9c6$export$8699f7c8af148338;
const $71edc3b1c9a6f9c6$export$6d08773d2e66f8f2 = $71edc3b1c9a6f9c6$export$ab9df7c53fe8454;







/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$7fe50bc4532e8371$var$$69cb30bb0017df05$var$createTabsContext, $7fe50bc4532e8371$export$355f5bd209d7b13a] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TABS_NAME, [
    (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)
]);
const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useRovingFocusGroupScope = (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)();
const [$7fe50bc4532e8371$var$$69cb30bb0017df05$var$TabsProvider, $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useTabsContext] = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$createTabsContext($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TABS_NAME);
const $7fe50bc4532e8371$export$b2539bed5023c21c = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", dir: dir, activationMode: activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($7fe50bc4532e8371$export$b2539bed5023c21c, {
    displayName: $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $7fe50bc4532e8371$export$9712d22edc0d78c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, loop: loop = true, ...listProps } = props;
    const context = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useTabsContext($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9), (0, $aJx1R.default)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($7fe50bc4532e8371$export$9712d22edc0d78c1, {
    displayName: $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $7fe50bc4532e8371$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, disabled: disabled = false, ...triggerProps } = props;
    const context = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useTabsContext($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $71edc3b1c9a6f9c6$export$6d08773d2e66f8f2), (0, $aJx1R.default)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? "active" : "inactive",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else event.preventDefault();
        }),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if ([
                " ",
                "Enter"
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== "manual";
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($7fe50bc4532e8371$export$8114b9fdfdf9f3ba, {
    displayName: $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $7fe50bc4532e8371$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, forceMount: forceMount, children: children, ...contentProps } = props;
    const context = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useTabsContext($7fe50bc4532e8371$var$$69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0, $exYeM.useRef)(isSelected);
    (0, $exYeM.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected
    }, ({ present: present })=>/*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
            "data-state": isSelected ? "active" : "inactive",
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? "0s" : undefined
            }
        }), present && children));
});
/*#__PURE__*/ Object.assign($7fe50bc4532e8371$export$bd905d70e8fd2ebb, {
    displayName: $7fe50bc4532e8371$var$$69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $7fe50bc4532e8371$export$be92b6f5f03c0fe9 = $7fe50bc4532e8371$export$b2539bed5023c21c;
const $7fe50bc4532e8371$export$54c2e3dc7acea9f5 = $7fe50bc4532e8371$export$9712d22edc0d78c1;
const $7fe50bc4532e8371$export$41fb9f06171c75f4 = $7fe50bc4532e8371$export$8114b9fdfdf9f3ba;
const $7fe50bc4532e8371$export$7c6e2c02157bb7d2 = $7fe50bc4532e8371$export$bd905d70e8fd2ebb;


const $125c9c6acc39e22a$export$b2539bed5023c21c = $7fe50bc4532e8371$export$be92b6f5f03c0fe9;
const $125c9c6acc39e22a$export$9712d22edc0d78c1 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($7fe50bc4532e8371$export$54c2e3dc7acea9f5, {
        ref: ref,
        className: `inline-flex items-center justify-center bg-muted text-muted-foreground grid-flow-col space-x-2 rounded-md bg-white border border-onSurfaceVariant shadow-md  ${className}`,
        ...props
    }));
$125c9c6acc39e22a$export$9712d22edc0d78c1.displayName = "TabsList";
const $125c9c6acc39e22a$export$8114b9fdfdf9f3ba = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($7fe50bc4532e8371$export$41fb9f06171c75f4, {
        ref: ref,
        className: `text-base 2xl:text-lg font-semibold rounded-sm inline-flex items-center justify-center whitespace-nowrap px-2 py-2.5 text-gray-800 ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50${className}`,
        ...props
    }));
$125c9c6acc39e22a$export$8114b9fdfdf9f3ba.displayName = "TabsTrigger";
const $125c9c6acc39e22a$export$bd905d70e8fd2ebb = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($7fe50bc4532e8371$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: `mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${className}`,
        ...props
    }));
$125c9c6acc39e22a$export$bd905d70e8fd2ebb.displayName = "TabsContent";



var $aSiaI = parcelRequire("aSiaI");


var $exYeM = parcelRequire("exYeM");























var $exYeM = parcelRequire("exYeM");
let $d4446d7208fb1103$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $d4446d7208fb1103$var$o(e) {
    var r, i;
    let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(!0);
    if (!(t instanceof HTMLElement)) return n;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let l = u ? (i = t.innerText) != null ? i : "" : n;
    return $d4446d7208fb1103$var$a.test(l) && (l = l.replace($d4446d7208fb1103$var$a, "")), l;
}
function $d4446d7208fb1103$export$6ca03cb7b75bfa13(e) {
    let n = e.getAttribute("aria-label");
    if (typeof n == "string") return n.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((l)=>{
            let r = document.getElementById(l);
            if (r) {
                let i = r.getAttribute("aria-label");
                return typeof i == "string" ? i.trim() : $d4446d7208fb1103$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $d4446d7208fb1103$var$o(e).trim();
}



function $f1236d9f13396238$export$f6862afd851a1cf4(c) {
    let t = (0, $exYeM.useRef)(""), r = (0, $exYeM.useRef)("");
    return (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $d4446d7208fb1103$export$6ca03cb7b75bfa13)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}


var $2921dee57b12a13a$var$Be = ((n)=>(n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))($2921dee57b12a13a$var$Be || {}), $2921dee57b12a13a$var$He = ((n)=>(n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))($2921dee57b12a13a$var$He || {}), $2921dee57b12a13a$var$Ge = ((n)=>(n[n.Pointer = 0] = "Pointer", n[n.Other = 1] = "Other", n))($2921dee57b12a13a$var$Ge || {}), $2921dee57b12a13a$var$Ne = ((i)=>(i[i.OpenListbox = 0] = "OpenListbox", i[i.CloseListbox = 1] = "CloseListbox", i[i.GoToOption = 2] = "GoToOption", i[i.Search = 3] = "Search", i[i.ClearSearch = 4] = "ClearSearch", i[i.RegisterOption = 5] = "RegisterOption", i[i.UnregisterOption = 6] = "UnregisterOption", i[i.RegisterLabel = 7] = "RegisterLabel", i))($2921dee57b12a13a$var$Ne || {});
function $2921dee57b12a13a$var$z(e, a = (n)=>n) {
    let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = (0, $2786c78eeb568d2b$export$20305e96f91bf103)(a(e.options.slice()), (t)=>t.dataRef.current.domRef.current), l = n ? r.indexOf(n) : null;
    return l === -1 && (l = null), {
        options: r,
        activeOptionIndex: l
    };
}
let $2921dee57b12a13a$var$je = {
    [1] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 ? e : {
            ...e,
            activeOptionIndex: null,
            listboxState: 1
        };
    },
    [0] (e) {
        if (e.dataRef.current.disabled || e.listboxState === 0) return e;
        let a = e.activeOptionIndex, { isSelected: n } = e.dataRef.current, r = e.options.findIndex((l)=>n(l.dataRef.current.value));
        return r !== -1 && (a = r), {
            ...e,
            listboxState: 0,
            activeOptionIndex: a
        };
    },
    [2] (e, a) {
        var l;
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let n = $2921dee57b12a13a$var$z(e), r = (0, $3570165156f716f3$export$c6b4626b54936d5e)(a, {
            resolveItems: ()=>n.options,
            resolveActiveIndex: ()=>n.activeOptionIndex,
            resolveId: (t)=>t.id,
            resolveDisabled: (t)=>t.dataRef.current.disabled
        });
        return {
            ...e,
            ...n,
            searchQuery: "",
            activeOptionIndex: r,
            activationTrigger: (l = a.trigger) != null ? l : 1
        };
    },
    [3]: (e, a)=>{
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let r = e.searchQuery !== "" ? 0 : 1, l = e.searchQuery + a.value.toLowerCase(), p = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((i)=>{
            var b;
            return !i.dataRef.current.disabled && ((b = i.dataRef.current.textValue) == null ? void 0 : b.startsWith(l));
        }), u = p ? e.options.indexOf(p) : -1;
        return u === -1 || u === e.activeOptionIndex ? {
            ...e,
            searchQuery: l
        } : {
            ...e,
            searchQuery: l,
            activeOptionIndex: u,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : {
            ...e,
            searchQuery: ""
        };
    },
    [5]: (e, a)=>{
        let n = {
            id: a.id,
            dataRef: a.dataRef
        }, r = $2921dee57b12a13a$var$z(e, (l)=>[
                ...l,
                n
            ]);
        return e.activeOptionIndex === null && e.dataRef.current.isSelected(a.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), {
            ...e,
            ...r
        };
    },
    [6]: (e, a)=>{
        let n = $2921dee57b12a13a$var$z(e, (r)=>{
            let l = r.findIndex((t)=>t.id === a.id);
            return l !== -1 && r.splice(l, 1), r;
        });
        return {
            ...e,
            ...n,
            activationTrigger: 1
        };
    },
    [7]: (e, a)=>({
            ...e,
            labelId: a.id
        })
}, $2921dee57b12a13a$var$J = (0, $exYeM.createContext)(null);
$2921dee57b12a13a$var$J.displayName = "ListboxActionsContext";
function $2921dee57b12a13a$var$_(e) {
    let a = (0, $exYeM.useContext)($2921dee57b12a13a$var$J);
    if (a === null) {
        let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, $2921dee57b12a13a$var$_), n;
    }
    return a;
}
let $2921dee57b12a13a$var$q = (0, $exYeM.createContext)(null);
$2921dee57b12a13a$var$q.displayName = "ListboxDataContext";
function $2921dee57b12a13a$var$U(e) {
    let a = (0, $exYeM.useContext)($2921dee57b12a13a$var$q);
    if (a === null) {
        let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, $2921dee57b12a13a$var$U), n;
    }
    return a;
}
function $2921dee57b12a13a$var$Ve(e, a) {
    return (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(a.type, $2921dee57b12a13a$var$je, e, a);
}
let $2921dee57b12a13a$var$Ke = (0, $exYeM.Fragment);
function $2921dee57b12a13a$var$Qe(e, a) {
    let { value: n, defaultValue: r, form: l, name: t, onChange: p, by: u = (s, c)=>s === c, disabled: i = !1, horizontal: b = !1, multiple: R = !1, ...m } = e;
    const P = b ? "horizontal" : "vertical";
    let S = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(a), [L = R ? [] : void 0, y] = (0, $ec3d9133814ca96e$export$454217e89aea72b)(n, p, r), [T, o] = (0, $exYeM.useReducer)($2921dee57b12a13a$var$Ve, {
        dataRef: (0, $exYeM.createRef)(),
        listboxState: 1,
        options: [],
        searchQuery: "",
        labelId: null,
        activeOptionIndex: null,
        activationTrigger: 1
    }), x = (0, $exYeM.useRef)({
        static: !1,
        hold: !1
    }), E = (0, $exYeM.useRef)(null), B = (0, $exYeM.useRef)(null), W = (0, $exYeM.useRef)(null), C = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(typeof u == "string" ? (s, c)=>{
        let O = u;
        return (s == null ? void 0 : s[O]) === (c == null ? void 0 : c[O]);
    } : u), A = (0, $exYeM.useCallback)((s)=>(0, $73fd0be368b973e0$export$4659b591c19bdf3d)(d.mode, {
            [1]: ()=>L.some((c)=>C(c, s)),
            [0]: ()=>C(L, s)
        }), [
        L
    ]), d = (0, $exYeM.useMemo)(()=>({
            ...T,
            value: L,
            disabled: i,
            mode: R ? 1 : 0,
            orientation: P,
            compare: C,
            isSelected: A,
            optionsPropsRef: x,
            labelRef: E,
            buttonRef: B,
            optionsRef: W
        }), [
        L,
        i,
        R,
        T
    ]);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        T.dataRef.current = d;
    }, [
        d
    ]), (0, $ff220859d927474a$export$71b2224f1ce5e08e)([
        d.buttonRef,
        d.optionsRef
    ], (s, c)=>{
        var O;
        o({
            type: 1
        }), (0, $2786c78eeb568d2b$export$ff1ec1c740b3c8d5)(c, (0, $2786c78eeb568d2b$export$27112a34f2f8402d).Loose) || (s.preventDefault(), (O = d.buttonRef.current) == null || O.focus());
    }, d.listboxState === 0);
    let H = (0, $exYeM.useMemo)(()=>({
            open: d.listboxState === 0,
            disabled: i,
            value: L
        }), [
        d,
        i,
        L
    ]), ie = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s)=>{
        let c = d.options.find((O)=>O.id === s);
        c && X(c.dataRef.current.value);
    }), re = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        if (d.activeOptionIndex !== null) {
            let { dataRef: s, id: c } = d.options[d.activeOptionIndex];
            X(s.current.value), o({
                type: 2,
                focus: (0, $3570165156f716f3$export$807a7eae502106e7).Specific,
                id: c
            });
        }
    }), ae = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>o({
            type: 0
        })), le = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>o({
            type: 1
        })), se = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s, c, O)=>s === (0, $3570165156f716f3$export$807a7eae502106e7).Specific ? o({
            type: 2,
            focus: (0, $3570165156f716f3$export$807a7eae502106e7).Specific,
            id: c,
            trigger: O
        }) : o({
            type: 2,
            focus: s,
            trigger: O
        })), pe = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s, c)=>(o({
            type: 5,
            id: s,
            dataRef: c
        }), ()=>o({
                type: 6,
                id: s
            }))), ue = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s)=>(o({
            type: 7,
            id: s
        }), ()=>o({
                type: 7,
                id: null
            }))), X = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s)=>(0, $73fd0be368b973e0$export$4659b591c19bdf3d)(d.mode, {
            [0] () {
                return y == null ? void 0 : y(s);
            },
            [1] () {
                let c = d.value.slice(), O = c.findIndex((F)=>C(F, s));
                return O === -1 ? c.push(s) : c.splice(O, 1), y == null ? void 0 : y(c);
            }
        })), de = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((s)=>o({
            type: 3,
            value: s
        })), ce = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>o({
            type: 4
        })), fe = (0, $exYeM.useMemo)(()=>({
            onChange: X,
            registerOption: pe,
            registerLabel: ue,
            goToOption: se,
            closeListbox: le,
            openListbox: ae,
            selectActiveOption: re,
            selectOption: ie,
            search: de,
            clearSearch: ce
        }), []), Te = {
        ref: S
    }, G = (0, $exYeM.useRef)(null), be = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)();
    return (0, $exYeM.useEffect)(()=>{
        G.current && r !== void 0 && be.addEventListener(G.current, "reset", ()=>{
            y == null || y(r);
        });
    }, [
        G,
        y
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($2921dee57b12a13a$var$J.Provider, {
        value: fe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($2921dee57b12a13a$var$q.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d2513f66ac282f05$export$2a0ed818b175f558), {
        value: (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(d.listboxState, {
            [0]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open,
            [1]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Closed
        })
    }, t != null && L != null && (0, $7ef5a50884dbacae$export$bc22b3e852574dab)({
        [t]: L
    }).map(([s, c], O)=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3faa7861657f1c89$export$8dc98ba7eadeaa56), {
            features: (0, $3faa7861657f1c89$export$617d79dae526d2cf).Hidden,
            ref: O === 0 ? (F)=>{
                var Y;
                G.current = (Y = F == null ? void 0 : F.closest("form")) != null ? Y : null;
            } : void 0,
            ...(0, $6da0b689c34972b7$export$8e16b83750b44988)({
                key: s,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: l,
                name: s,
                value: c
            })
        })), (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: Te,
        theirProps: m,
        slot: H,
        defaultTag: $2921dee57b12a13a$var$Ke,
        name: "Listbox"
    }))));
}
let $2921dee57b12a13a$var$We = "button";
function $2921dee57b12a13a$var$Xe(e, a) {
    var y;
    let n = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: r = `headlessui-listbox-button-${n}`, ...l } = e, t = $2921dee57b12a13a$var$U("Listbox.Button"), p = $2921dee57b12a13a$var$_("Listbox.Button"), u = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(t.buttonRef, a), i = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)(), b = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((T)=>{
        switch(T.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space:
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Enter:
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowDown:
                T.preventDefault(), p.openListbox(), i.nextFrame(()=>{
                    t.value || p.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).First);
                });
                break;
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowUp:
                T.preventDefault(), p.openListbox(), i.nextFrame(()=>{
                    t.value || p.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Last);
                });
                break;
        }
    }), R = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((T)=>{
        switch(T.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space:
                T.preventDefault();
                break;
        }
    }), m = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((T)=>{
        if ((0, $b762bd1946006453$export$db61f031a278447c)(T.currentTarget)) return T.preventDefault();
        t.listboxState === 0 ? (p.closeListbox(), i.nextFrame(()=>{
            var o;
            return (o = t.buttonRef.current) == null ? void 0 : o.focus({
                preventScroll: !0
            });
        })) : (T.preventDefault(), p.openListbox());
    }), P = (0, $3eedc3e7e61b557e$export$e3d20747ab930783)(()=>{
        if (t.labelId) return [
            t.labelId,
            r
        ].join(" ");
    }, [
        t.labelId,
        r
    ]), S = (0, $exYeM.useMemo)(()=>({
            open: t.listboxState === 0,
            disabled: t.disabled,
            value: t.value
        }), [
        t
    ]), L = {
        ref: u,
        id: r,
        type: (0, $5848675429035810$export$53652b2b272efe9c)(e, t.buttonRef),
        "aria-haspopup": "listbox",
        "aria-controls": (y = t.optionsRef.current) == null ? void 0 : y.id,
        "aria-expanded": t.listboxState === 0,
        "aria-labelledby": P,
        disabled: t.disabled,
        onKeyDown: b,
        onKeyUp: R,
        onClick: m
    };
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: L,
        theirProps: l,
        slot: S,
        defaultTag: $2921dee57b12a13a$var$We,
        name: "Listbox.Button"
    });
}
let $2921dee57b12a13a$var$$e = "label";
function $2921dee57b12a13a$var$ze(e, a) {
    let n = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: r = `headlessui-listbox-label-${n}`, ...l } = e, t = $2921dee57b12a13a$var$U("Listbox.Label"), p = $2921dee57b12a13a$var$_("Listbox.Label"), u = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(t.labelRef, a);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>p.registerLabel(r), [
        r
    ]);
    let i = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        var m;
        return (m = t.buttonRef.current) == null ? void 0 : m.focus({
            preventScroll: !0
        });
    }), b = (0, $exYeM.useMemo)(()=>({
            open: t.listboxState === 0,
            disabled: t.disabled
        }), [
        t
    ]);
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: u,
            id: r,
            onClick: i
        },
        theirProps: l,
        slot: b,
        defaultTag: $2921dee57b12a13a$var$$e,
        name: "Listbox.Label"
    });
}
let $2921dee57b12a13a$var$Je = "ul", $2921dee57b12a13a$var$qe = (0, $6da0b689c34972b7$export$617d79dae526d2cf).RenderStrategy | (0, $6da0b689c34972b7$export$617d79dae526d2cf).Static;
function $2921dee57b12a13a$var$Ye(e, a) {
    var T;
    let n = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: r = `headlessui-listbox-options-${n}`, ...l } = e, t = $2921dee57b12a13a$var$U("Listbox.Options"), p = $2921dee57b12a13a$var$_("Listbox.Options"), u = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(t.optionsRef, a), i = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)(), b = (0, $1a42d470fe7d2fb4$export$fd183955ff4b45d9)(), R = (0, $d2513f66ac282f05$export$fc6fdf0ecf360e)(), m = (()=>R !== null ? (R & (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open) === (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open : t.listboxState === 0)();
    (0, $exYeM.useEffect)(()=>{
        var x;
        let o = t.optionsRef.current;
        o && t.listboxState === 0 && o !== ((x = (0, $a54eed888c938856$export$b204af158042fbac)(o)) == null ? void 0 : x.activeElement) && o.focus({
            preventScroll: !0
        });
    }, [
        t.listboxState,
        t.optionsRef
    ]);
    let P = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((o)=>{
        switch(b.dispose(), o.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space:
                if (t.searchQuery !== "") return o.preventDefault(), o.stopPropagation(), p.search(o.key);
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Enter:
                if (o.preventDefault(), o.stopPropagation(), t.activeOptionIndex !== null) {
                    let { dataRef: x } = t.options[t.activeOptionIndex];
                    p.onChange(x.current.value);
                }
                t.mode === 0 && (p.closeListbox(), (0, $fb27e053aa71d13a$export$12b26c28a05aa001)().nextFrame(()=>{
                    var x;
                    return (x = t.buttonRef.current) == null ? void 0 : x.focus({
                        preventScroll: !0
                    });
                }));
                break;
            case (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(t.orientation, {
                vertical: (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowDown,
                horizontal: (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowRight
            }):
                return o.preventDefault(), o.stopPropagation(), p.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Next);
            case (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(t.orientation, {
                vertical: (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowUp,
                horizontal: (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).ArrowLeft
            }):
                return o.preventDefault(), o.stopPropagation(), p.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Previous);
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Home:
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).PageUp:
                return o.preventDefault(), o.stopPropagation(), p.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).First);
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).End:
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).PageDown:
                return o.preventDefault(), o.stopPropagation(), p.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Last);
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Escape:
                return o.preventDefault(), o.stopPropagation(), p.closeListbox(), i.nextFrame(()=>{
                    var x;
                    return (x = t.buttonRef.current) == null ? void 0 : x.focus({
                        preventScroll: !0
                    });
                });
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Tab:
                o.preventDefault(), o.stopPropagation();
                break;
            default:
                o.key.length === 1 && (p.search(o.key), b.setTimeout(()=>p.clearSearch(), 350));
                break;
        }
    }), S = (0, $3eedc3e7e61b557e$export$e3d20747ab930783)(()=>{
        var o, x, E;
        return (E = (o = t.labelRef.current) == null ? void 0 : o.id) != null ? E : (x = t.buttonRef.current) == null ? void 0 : x.id;
    }, [
        t.labelRef.current,
        t.buttonRef.current
    ]), L = (0, $exYeM.useMemo)(()=>({
            open: t.listboxState === 0
        }), [
        t
    ]), y = {
        "aria-activedescendant": t.activeOptionIndex === null || (T = t.options[t.activeOptionIndex]) == null ? void 0 : T.id,
        "aria-multiselectable": t.mode === 1 ? !0 : void 0,
        "aria-labelledby": S,
        "aria-orientation": t.orientation,
        id: r,
        onKeyDown: P,
        role: "listbox",
        tabIndex: 0,
        ref: u
    };
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: y,
        theirProps: l,
        slot: L,
        defaultTag: $2921dee57b12a13a$var$Je,
        features: $2921dee57b12a13a$var$qe,
        visible: m,
        name: "Listbox.Options"
    });
}
let $2921dee57b12a13a$var$Ze = "li";
function $2921dee57b12a13a$var$et(e, a) {
    let n = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: r = `headlessui-listbox-option-${n}`, disabled: l = !1, value: t, ...p } = e, u = $2921dee57b12a13a$var$U("Listbox.Option"), i = $2921dee57b12a13a$var$_("Listbox.Option"), b = u.activeOptionIndex !== null ? u.options[u.activeOptionIndex].id === r : !1, R = u.isSelected(t), m = (0, $exYeM.useRef)(null), P = (0, $f1236d9f13396238$export$f6862afd851a1cf4)(m), S = (0, $8dd7f512f0d6b4ee$export$86c4283a11f23f95)({
        disabled: l,
        value: t,
        domRef: m,
        get textValue () {
            return P();
        }
    }), L = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(a, m);
    (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>{
        if (u.listboxState !== 0 || !b || u.activationTrigger === 0) return;
        let A = (0, $fb27e053aa71d13a$export$12b26c28a05aa001)();
        return A.requestAnimationFrame(()=>{
            var d, H;
            (H = (d = m.current) == null ? void 0 : d.scrollIntoView) == null || H.call(d, {
                block: "nearest"
            });
        }), A.dispose;
    }, [
        m,
        b,
        u.listboxState,
        u.activationTrigger,
        u.activeOptionIndex
    ]), (0, $de1371c4941e924f$export$ce5ed857c741fd71)(()=>i.registerOption(r, S), [
        S,
        r
    ]);
    let y = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((A)=>{
        if (l) return A.preventDefault();
        i.onChange(t), u.mode === 0 && (i.closeListbox(), (0, $fb27e053aa71d13a$export$12b26c28a05aa001)().nextFrame(()=>{
            var d;
            return (d = u.buttonRef.current) == null ? void 0 : d.focus({
                preventScroll: !0
            });
        }));
    }), T = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)(()=>{
        if (l) return i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Nothing);
        i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Specific, r);
    }), o = (0, $687da405a68ff5bf$export$24ebee078bde85c3)(), x = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((A)=>o.update(A)), E = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((A)=>{
        o.wasMoved(A) && (l || b || i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Specific, r, 0));
    }), B = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((A)=>{
        o.wasMoved(A) && (l || b && i.goToOption((0, $3570165156f716f3$export$807a7eae502106e7).Nothing));
    }), W = (0, $exYeM.useMemo)(()=>({
            active: b,
            selected: R,
            disabled: l
        }), [
        b,
        R,
        l
    ]);
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: {
            id: r,
            ref: L,
            role: "option",
            tabIndex: l === !0 ? void 0 : -1,
            "aria-disabled": l === !0 ? !0 : void 0,
            "aria-selected": R,
            disabled: void 0,
            onClick: y,
            onFocus: T,
            onPointerEnter: x,
            onMouseEnter: x,
            onPointerMove: E,
            onMouseMove: E,
            onPointerLeave: B,
            onMouseLeave: B
        },
        theirProps: p,
        slot: W,
        defaultTag: $2921dee57b12a13a$var$Ze,
        name: "Listbox.Option"
    });
}
let $2921dee57b12a13a$var$tt = (0, $6da0b689c34972b7$export$e43f39796049410c)($2921dee57b12a13a$var$Qe), $2921dee57b12a13a$var$ot = (0, $6da0b689c34972b7$export$e43f39796049410c)($2921dee57b12a13a$var$Xe), $2921dee57b12a13a$var$nt = (0, $6da0b689c34972b7$export$e43f39796049410c)($2921dee57b12a13a$var$ze), $2921dee57b12a13a$var$it = (0, $6da0b689c34972b7$export$e43f39796049410c)($2921dee57b12a13a$var$Ye), $2921dee57b12a13a$var$rt = (0, $6da0b689c34972b7$export$e43f39796049410c)($2921dee57b12a13a$var$et), $2921dee57b12a13a$export$8bad31ff872c7659 = Object.assign($2921dee57b12a13a$var$tt, {
    Button: $2921dee57b12a13a$var$ot,
    Label: $2921dee57b12a13a$var$nt,
    Options: $2921dee57b12a13a$var$it,
    Option: $2921dee57b12a13a$var$rt
});



var $exYeM = parcelRequire("exYeM");
function $df22da2c4bc0f29a$export$2e2bcd8739ae039({ selectedTab: selectedTab, setSelectedTab: setSelectedTab, handleTabChange: handleTabChange, tabOptions: tabOptions }) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "block sm:hidden w-full shadow-md",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "flex flex-col gap-4",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659), {
                value: selectedTab,
                onChange: (newValue)=>{
                    setSelectedTab(newValue);
                    handleTabChange(newValue.route);
                },
                children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Button, {
                                className: "relative w-full rounded-lg border border-primary bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "ml-3 block truncate",
                                            children: selectedTab.label
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9b82b6f96fc76ebd$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                                show: open,
                                as: (0, $exYeM.Fragment),
                                leave: "transition ease-in duration-100",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Options, {
                                    className: "absolute z-10 mt-11 w-[55vw] bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                                    children: tabOptions.map((option, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Option, {
                                            className: ({ active: active })=>`relative cursor-default select-none py-2 pl-10 pr-4 ${active ? "text-white bg-primary" : "text-gray-900"}`,
                                            value: option,
                                            children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: `block truncate ${selected ? "font-medium" : "font-normal"}`,
                                                            children: option.label
                                                        }),
                                                        selected ? /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: `absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : "text-primary"}`,
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9bcddf4d25089704$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5",
                                                                "aria-hidden": "true"
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                        }, index))
                                })
                            })
                        ]
                    })
            })
        })
    });
}





var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
function $ccb23396c9d57cd4$var$PencilIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z"
    }));
}
const $ccb23396c9d57cd4$var$ForwardRef = $exYeM.forwardRef($ccb23396c9d57cd4$var$PencilIcon);
var $ccb23396c9d57cd4$export$2e2bcd8739ae039 = $ccb23396c9d57cd4$var$ForwardRef;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
var $f77cef878b3c2149$var$U = 1, $f77cef878b3c2149$var$Y = .9, $f77cef878b3c2149$var$a = .8, $f77cef878b3c2149$var$H = .17, $f77cef878b3c2149$var$p = .1, $f77cef878b3c2149$var$u = .999, $f77cef878b3c2149$var$J = .9999;
var $f77cef878b3c2149$var$k = .99, $f77cef878b3c2149$var$m = /[\\\/_+.#"@\[\(\{&]/, $f77cef878b3c2149$var$B = /[\\\/_+.#"@\[\(\{&]/g, $f77cef878b3c2149$var$K = /[\s-]/, $f77cef878b3c2149$var$X = /[\s-]/g;
function $f77cef878b3c2149$var$G(c, f, P, C, h, A, O) {
    if (A === f.length) return h === c.length ? $f77cef878b3c2149$var$U : $f77cef878b3c2149$var$k;
    var T = `${h},${A}`;
    if (O[T] !== void 0) return O[T];
    for(var L = C.charAt(A), E = P.indexOf(L, h), S = 0, _, N, R, M; E >= 0;)_ = $f77cef878b3c2149$var$G(c, f, P, C, E + 1, A + 1, O), _ > S && (E === h ? _ *= $f77cef878b3c2149$var$U : $f77cef878b3c2149$var$m.test(c.charAt(E - 1)) ? (_ *= $f77cef878b3c2149$var$a, R = c.slice(h, E - 1).match($f77cef878b3c2149$var$B), R && h > 0 && (_ *= Math.pow($f77cef878b3c2149$var$u, R.length))) : $f77cef878b3c2149$var$K.test(c.charAt(E - 1)) ? (_ *= $f77cef878b3c2149$var$Y, M = c.slice(h, E - 1).match($f77cef878b3c2149$var$X), M && h > 0 && (_ *= Math.pow($f77cef878b3c2149$var$u, M.length))) : (_ *= $f77cef878b3c2149$var$H, h > 0 && (_ *= Math.pow($f77cef878b3c2149$var$u, E - h))), c.charAt(E) !== f.charAt(A) && (_ *= $f77cef878b3c2149$var$J)), (_ < $f77cef878b3c2149$var$p && P.charAt(E - 1) === C.charAt(A + 1) || C.charAt(A + 1) === C.charAt(A) && P.charAt(E - 1) !== C.charAt(A)) && (N = $f77cef878b3c2149$var$G(c, f, P, C, E + 1, A + 2, O), N * $f77cef878b3c2149$var$p > _ && (_ = N * $f77cef878b3c2149$var$p)), _ > S && (S = _), E = P.indexOf(L, E + 1);
    return O[T] = S, S;
}
function $f77cef878b3c2149$var$D(c) {
    return c.toLowerCase().replace($f77cef878b3c2149$var$X, " ");
}
function $f77cef878b3c2149$export$407448d2b89b1813(c, f) {
    return $f77cef878b3c2149$var$G(c, f, $f77cef878b3c2149$var$D(c), $f77cef878b3c2149$var$D(f), 0, 0, {});
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");
function $d8656c10ff9e242c$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $exYeM = parcelRequire("exYeM");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6d5e3b0ba5f9ae3a$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6d5e3b0ba5f9ae3a$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6d5e3b0ba5f9ae3a$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6d5e3b0ba5f9ae3a$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $exYeM.useCallback)($6d5e3b0ba5f9ae3a$export$43e446d32b3d21af(...refs), refs);
}



var $exYeM = parcelRequire("exYeM");
function $871639f4e6a8b23a$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $exYeM.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $exYeM.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $exYeM.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $871639f4e6a8b23a$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $exYeM.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $exYeM.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $exYeM.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $exYeM.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $871639f4e6a8b23a$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $871639f4e6a8b23a$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $exYeM.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $761ce6e0661ee420$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $exYeM.useLayoutEffect) : ()=>{};


const $18ff98f388caf2b5$var$$1746a345f3d73bb7$var$useReactId = $exYeM["useId".toString()] || (()=>undefined);
let $18ff98f388caf2b5$var$$1746a345f3d73bb7$var$count = 0;
function $18ff98f388caf2b5$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $exYeM.useState($18ff98f388caf2b5$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $761ce6e0661ee420$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($18ff98f388caf2b5$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $342123e8c35ad738$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $exYeM.useRef)(callback);
    (0, $exYeM.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $exYeM.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $1dcab5d23908b05b$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $1dcab5d23908b05b$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $342123e8c35ad738$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $exYeM.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $1dcab5d23908b05b$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $exYeM.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $exYeM.useRef)(value);
    const handleChange = (0, $342123e8c35ad738$export$25bec8c6f54ee79a)(onChange);
    (0, $exYeM.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $25810755a65e7f13$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $exYeM.Children).toArray(children);
    const slottable = childrenArray.find($25810755a65e7f13$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $exYeM.Children).count(newElement) > 1) return (0, $exYeM.Children).only(null);
                return /*#__PURE__*/ (0, $exYeM.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $exYeM.createElement)($25810755a65e7f13$var$$5e63c961fc1ce211$var$SlotClone, (0, $aJx1R.default)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $exYeM.isValidElement)(newElement) ? /*#__PURE__*/ (0, $exYeM.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $exYeM.createElement)($25810755a65e7f13$var$$5e63c961fc1ce211$var$SlotClone, (0, $aJx1R.default)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$25810755a65e7f13$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $25810755a65e7f13$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $exYeM.isValidElement)(children)) return /*#__PURE__*/ (0, $exYeM.cloneElement)(children, {
        ...$25810755a65e7f13$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $6d5e3b0ba5f9ae3a$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $exYeM.Children).count(children) > 1 ? (0, $exYeM.Children).only(null) : null;
});
$25810755a65e7f13$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $25810755a65e7f13$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $25810755a65e7f13$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $exYeM.isValidElement)(child) && child.type === $25810755a65e7f13$export$d9f1ccf0bdb05d45;
}
function $25810755a65e7f13$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $25810755a65e7f13$export$be92b6f5f03c0fe9 = $25810755a65e7f13$export$8c6ed5c666ac1360;


const $4429b98f54aab8f6$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $4429b98f54aab8f6$export$250ffa63cdc0d034 = $4429b98f54aab8f6$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $25810755a65e7f13$export$8c6ed5c666ac1360) : node;
        (0, $exYeM.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $exYeM.createElement)(Comp, (0, $aJx1R.default)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $4429b98f54aab8f6$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $d2lNW.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $4429b98f54aab8f6$export$be92b6f5f03c0fe9 = $4429b98f54aab8f6$export$250ffa63cdc0d034;





var $exYeM = parcelRequire("exYeM");

/**
 * Listens for when the escape key is down
 */ function $d279e587d848d161$export$3a72a57244d6e765(onEscapeKeyDownProp) {
    const onEscapeKeyDown = (0, $342123e8c35ad738$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $exYeM.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $37df8a220b3f61b8$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $37df8a220b3f61b8$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $37df8a220b3f61b8$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $37df8a220b3f61b8$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $37df8a220b3f61b8$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $37df8a220b3f61b8$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $exYeM.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $37df8a220b3f61b8$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $exYeM.useContext)($37df8a220b3f61b8$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $exYeM.useState)(null);
    const [, force] = (0, $exYeM.useState)({});
    const composedRefs = (0, $6d5e3b0ba5f9ae3a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $37df8a220b3f61b8$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    });
    const focusOutside = $37df8a220b3f61b8$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    });
    (0, $d279e587d848d161$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    (0, $exYeM.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $37df8a220b3f61b8$var$$5cb92bef7577960e$var$originalBodyPointerEvents = document.body.style.pointerEvents;
                document.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $37df8a220b3f61b8$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) document.body.style.pointerEvents = $37df8a220b3f61b8$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $exYeM.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $37df8a220b3f61b8$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $exYeM.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($37df8a220b3f61b8$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($37df8a220b3f61b8$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $d8656c10ff9e242c$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $d8656c10ff9e242c$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $d8656c10ff9e242c$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($37df8a220b3f61b8$export$177fb62ff3ec1f22, {
    displayName: $37df8a220b3f61b8$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $37df8a220b3f61b8$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $37df8a220b3f61b8$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = (0, $exYeM.useContext)($37df8a220b3f61b8$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $6d5e3b0ba5f9ae3a$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $exYeM.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($37df8a220b3f61b8$export$4d5eb2109db14228, {
    displayName: $37df8a220b3f61b8$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $37df8a220b3f61b8$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside) {
    const handlePointerDownOutside = (0, $342123e8c35ad738$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $exYeM.useRef)(false);
    const handleClickRef = (0, $exYeM.useRef)(()=>{});
    (0, $exYeM.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $37df8a220b3f61b8$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($37df8a220b3f61b8$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    document.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    document.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            document.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            document.removeEventListener("pointerdown", handlePointerDown);
            document.removeEventListener("click", handleClickRef.current);
        };
    }, [
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $37df8a220b3f61b8$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside) {
    const handleFocusOutside = (0, $342123e8c35ad738$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $37df8a220b3f61b8$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($37df8a220b3f61b8$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        document.addEventListener("focusin", handleFocus);
        return ()=>document.removeEventListener("focusin", handleFocus);
    }, [
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $37df8a220b3f61b8$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($37df8a220b3f61b8$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $37df8a220b3f61b8$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $4429b98f54aab8f6$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $37df8a220b3f61b8$export$be92b6f5f03c0fe9 = $37df8a220b3f61b8$export$177fb62ff3ec1f22;
const $37df8a220b3f61b8$export$aecb2ddcb55c95be = $37df8a220b3f61b8$export$4d5eb2109db14228;



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



const $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $b5d5ab47271ae8e8$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $exYeM.useState)(null);
    const onMountAutoFocus = (0, $342123e8c35ad738$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $342123e8c35ad738$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $6d5e3b0ba5f9ae3a$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $exYeM.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $exYeM.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                if (!container1.contains(event.relatedTarget)) $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (container1) {
            $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focusFirst($b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$removeLinks($b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $exYeM.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($b5d5ab47271ae8e8$export$20e40289641fbbb6, {
    displayName: $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$focusScopesStack = $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $b5d5ab47271ae8e8$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $b5d5ab47271ae8e8$export$be92b6f5f03c0fe9 = $b5d5ab47271ae8e8$export$20e40289641fbbb6;



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $2a4e62d9f17c6310$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $2a4e62d9f17c6310$export$602eac185826482c = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(/*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($2a4e62d9f17c6310$export$602eac185826482c, {
    displayName: $2a4e62d9f17c6310$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $2a4e62d9f17c6310$export$be92b6f5f03c0fe9 = $2a4e62d9f17c6310$export$602eac185826482c;



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");


function $d6668a2a4ac83d3c$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $exYeM.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $d6668a2a4ac83d3c$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $d6668a2a4ac83d3c$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $exYeM.Children).only(children);
    const ref = (0, $6d5e3b0ba5f9ae3a$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $exYeM.cloneElement)(child, {
        ref: ref
    }) : null;
};
$d6668a2a4ac83d3c$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $d6668a2a4ac83d3c$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $exYeM.useState)();
    const stylesRef = (0, $exYeM.useRef)({});
    const prevPresentRef = (0, $exYeM.useRef)(present);
    const prevAnimationNameRef = (0, $exYeM.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $d6668a2a4ac83d3c$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $exYeM.useEffect)(()=>{
        const currentAnimationName = $d6668a2a4ac83d3c$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $761ce6e0661ee420$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $d6668a2a4ac83d3c$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $761ce6e0661ee420$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $d6668a2a4ac83d3c$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $d2lNW.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $d6668a2a4ac83d3c$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $exYeM.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $d6668a2a4ac83d3c$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}




var $exYeM = parcelRequire("exYeM");
/** Number of components which have requested interest to have focus guards */ let $0829d270e0d933de$var$$3db38b7d1fb3fe6a$var$count = 0;
function $0829d270e0d933de$export$ac5b58043b79449b(props) {
    $0829d270e0d933de$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $0829d270e0d933de$export$b7ece24a22aeda8c() {
    (0, $exYeM.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $0829d270e0d933de$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $0829d270e0d933de$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $0829d270e0d933de$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($0829d270e0d933de$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $0829d270e0d933de$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $0829d270e0d933de$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $0829d270e0d933de$export$be92b6f5f03c0fe9 = $0829d270e0d933de$export$ac5b58043b79449b;




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");



var $2bb7676efa81f2a7$export$e27363444bedfeac = (0, $f527f4cfb322b92a$export$e13ec7dd7a14088d)();


var $8e51a66b5c7e025f$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $8e51a66b5c7e025f$export$22940b497e769dee = $exYeM.forwardRef(function(props, parentRef) {
    var ref = $exYeM.useRef(null);
    var _a = $exYeM.useState({
        onScrollCapture: $8e51a66b5c7e025f$var$nothing,
        onWheelCapture: $8e51a66b5c7e025f$var$nothing,
        onTouchMoveCapture: $8e51a66b5c7e025f$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d221d2c5d570aa1d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest), callbacks);
    return $exYeM.createElement($exYeM.Fragment, null, enabled && $exYeM.createElement(SideCar, {
        sideCar: (0, $2bb7676efa81f2a7$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $exYeM.cloneElement($exYeM.Children.only(children), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $exYeM.createElement(Container, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$8e51a66b5c7e025f$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$8e51a66b5c7e025f$export$22940b497e769dee.classNames = {
    fullWidth: (0, $a424de23c132f073$export$898e37bbd2a0ae4e),
    zeroRight: (0, $a424de23c132f073$export$1da7500147d4bc3)
};





var $exYeM = parcelRequire("exYeM");


var $a1b02f7445506e57$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $a1b02f7445506e57$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $a1b02f7445506e57$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $a1b02f7445506e57$var$options, $a1b02f7445506e57$var$options);
    // @ts-ignore
    window.removeEventListener("test", $a1b02f7445506e57$var$options, $a1b02f7445506e57$var$options);
} catch (err) {
    $a1b02f7445506e57$var$passiveSupported = false;
}
var $a1b02f7445506e57$export$10a6e88623fa9454 = $a1b02f7445506e57$var$passiveSupported ? {
    passive: false
} : false;


var $4f7c3793a7749d41$var$elementCouldBeVScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowY !== "hidden" && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowY === "visible" // scrollable
    );
};
var $4f7c3793a7749d41$var$elementCouldBeHScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowX !== "hidden" && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowX === "visible" // scrollable
    );
};
var $4f7c3793a7749d41$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $4f7c3793a7749d41$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $4f7c3793a7749d41$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $4f7c3793a7749d41$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $4f7c3793a7749d41$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $4f7c3793a7749d41$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $4f7c3793a7749d41$var$elementCouldBeVScrolled(node) : $4f7c3793a7749d41$var$elementCouldBeHScrolled(node);
};
var $4f7c3793a7749d41$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $4f7c3793a7749d41$var$getVScrollVariables(node) : $4f7c3793a7749d41$var$getHScrollVariables(node);
};
var $4f7c3793a7749d41$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $4f7c3793a7749d41$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $4f7c3793a7749d41$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $4f7c3793a7749d41$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($4f7c3793a7749d41$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $8978253c092e1946$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $8978253c092e1946$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $8978253c092e1946$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $8978253c092e1946$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $8978253c092e1946$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $8978253c092e1946$var$idCounter = 0;
var $8978253c092e1946$var$lockStack = [];
function $8978253c092e1946$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $exYeM.useRef([]);
    var touchStartRef = $exYeM.useRef([
        0,
        0
    ]);
    var activeAxis = $exYeM.useRef();
    var id = $exYeM.useState($8978253c092e1946$var$idCounter++)[0];
    var Style = $exYeM.useState(function() {
        return (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $exYeM.useRef(props);
    $exYeM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $exYeM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($8978253c092e1946$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $exYeM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $8978253c092e1946$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $4f7c3793a7749d41$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $4f7c3793a7749d41$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $4f7c3793a7749d41$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $exYeM.useCallback(function(_event) {
        var event = _event;
        if (!$8978253c092e1946$var$lockStack.length || $8978253c092e1946$var$lockStack[$8978253c092e1946$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $8978253c092e1946$export$39efaa2ca254a28d(event) : $8978253c092e1946$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $8978253c092e1946$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($8978253c092e1946$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) event.preventDefault();
        }
    }, []);
    var shouldCancel = $exYeM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $exYeM.useCallback(function(event) {
        touchStartRef.current = $8978253c092e1946$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $8978253c092e1946$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $8978253c092e1946$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $exYeM.useEffect(function() {
        $8978253c092e1946$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $a1b02f7445506e57$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $a1b02f7445506e57$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $a1b02f7445506e57$export$10a6e88623fa9454));
        return function() {
            $8978253c092e1946$var$lockStack = $8978253c092e1946$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $a1b02f7445506e57$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $a1b02f7445506e57$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $a1b02f7445506e57$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $exYeM.createElement($exYeM.Fragment, null, inert ? $exYeM.createElement(Style, {
        styles: $8978253c092e1946$var$generateStyle(id)
    }) : null, removeScrollBar ? $exYeM.createElement((0, $b8129a946e86d087$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $5a57b9d7d9db3ac3$export$2e2bcd8739ae039 = (0, $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce)((0, $2bb7676efa81f2a7$export$e27363444bedfeac), (0, $8978253c092e1946$export$a09dbff87b5da2d));


var $0f18744df5967952$var$ReactRemoveScroll = $exYeM.forwardRef(function(props, ref) {
    return $exYeM.createElement((0, $8e51a66b5c7e025f$export$22940b497e769dee), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $5a57b9d7d9db3ac3$export$2e2bcd8739ae039)
    }));
});
$0f18744df5967952$var$ReactRemoveScroll.classNames = (0, $8e51a66b5c7e025f$export$22940b497e769dee).classNames;
var $0f18744df5967952$export$2e2bcd8739ae039 = $0f18744df5967952$var$ReactRemoveScroll;




/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$createDialogContext, $04ac4bc2d2e51e5a$export$cc702773b8ea3e41] = (0, $871639f4e6a8b23a$export$50c7b4e9d9f19c1)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogProvider, $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$createDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $04ac4bc2d2e51e5a$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = (0, $exYeM.useRef)(null);
    const contentRef = (0, $exYeM.useRef)(null);
    const [open = false, setOpen] = (0, $1dcab5d23908b05b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $18ff98f388caf2b5$export$f680877a34711e37)(),
        titleId: (0, $18ff98f388caf2b5$export$f680877a34711e37)(),
        descriptionId: (0, $18ff98f388caf2b5$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $exYeM.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($04ac4bc2d2e51e5a$export$3ddf2d174ce01153, {
    displayName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $04ac4bc2d2e51e5a$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $6d5e3b0ba5f9ae3a$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $d8656c10ff9e242c$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($04ac4bc2d2e51e5a$export$2e1e1122cf0cba88, {
    displayName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$PortalProvider, $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$createDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $04ac4bc2d2e51e5a$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $exYeM.Children).map(children, (child)=>/*#__PURE__*/ (0, $exYeM.createElement)((0, $d6668a2a4ac83d3c$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $2a4e62d9f17c6310$export$602eac185826482c), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($04ac4bc2d2e51e5a$export$dad7c95542bacce0, {
    displayName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $04ac4bc2d2e51e5a$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$usePortalContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $d6668a2a4ac83d3c$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $aJx1R.default)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($04ac4bc2d2e51e5a$export$bd1d06c79be19e17, {
    displayName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $exYeM.createElement)((0, $0f18744df5967952$export$2e2bcd8739ae039), {
        as: (0, $25810755a65e7f13$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "data-state": $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $04ac4bc2d2e51e5a$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$usePortalContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d6668a2a4ac83d3c$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $aJx1R.default)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $exYeM.createElement)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $aJx1R.default)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($04ac4bc2d2e51e5a$export$b6d9565de1e068cf, {
    displayName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $6d5e3b0ba5f9ae3a$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $exYeM.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $aJx1R.default)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $d8656c10ff9e242c$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $d8656c10ff9e242c$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $d8656c10ff9e242c$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $exYeM.useRef)(false);
    return /*#__PURE__*/ (0, $exYeM.createElement)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $aJx1R.default)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) hasInteractedOutsideRef.current = true; // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            //
            // We use `onInteractOutside` as some browsers also
            // focus on pointer down, creating the same issue.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $6d5e3b0ba5f9ae3a$export$c7b2cbe3552a0d05)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $0829d270e0d933de$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)((0, $b5d5ab47271ae8e8$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $37df8a220b3f61b8$export$177fb62ff3ec1f22), (0, $aJx1R.default)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $04ac4bc2d2e51e5a$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).h2, (0, $aJx1R.default)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($04ac4bc2d2e51e5a$export$16f7638e4a34b909, {
    displayName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $04ac4bc2d2e51e5a$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).p, (0, $aJx1R.default)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($04ac4bc2d2e51e5a$export$94e94c2ec2c954d5, {
    displayName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $04ac4bc2d2e51e5a$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useDialogContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4429b98f54aab8f6$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $d8656c10ff9e242c$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($04ac4bc2d2e51e5a$export$fba2fb7cd781b7ac, {
    displayName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$04ac4bc2d2e51e5a$export$69b62a49393917d6, $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $871639f4e6a8b23a$export$fd42f52fd3ae1109)($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useWarningContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $exYeM.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$useWarningContext($04ac4bc2d2e51e5a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $exYeM.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $04ac4bc2d2e51e5a$export$be92b6f5f03c0fe9 = $04ac4bc2d2e51e5a$export$3ddf2d174ce01153;
const $04ac4bc2d2e51e5a$export$41fb9f06171c75f4 = $04ac4bc2d2e51e5a$export$2e1e1122cf0cba88;
const $04ac4bc2d2e51e5a$export$602eac185826482c = $04ac4bc2d2e51e5a$export$dad7c95542bacce0;
const $04ac4bc2d2e51e5a$export$c6fdb837b070b4ff = $04ac4bc2d2e51e5a$export$bd1d06c79be19e17;
const $04ac4bc2d2e51e5a$export$7c6e2c02157bb7d2 = $04ac4bc2d2e51e5a$export$b6d9565de1e068cf;
const $04ac4bc2d2e51e5a$export$f99233281efd08a0 = $04ac4bc2d2e51e5a$export$16f7638e4a34b909;
const $04ac4bc2d2e51e5a$export$393edc798c47379d = $04ac4bc2d2e51e5a$export$94e94c2ec2c954d5;
const $04ac4bc2d2e51e5a$export$f39c2d165cd861fe = $04ac4bc2d2e51e5a$export$fba2fb7cd781b7ac;



var $exYeM = parcelRequire("exYeM");
var $24d57f4e18709e4d$var$fe = '[cmdk-list-sizer=""]', $24d57f4e18709e4d$var$O = '[cmdk-group=""]', $24d57f4e18709e4d$var$U = '[cmdk-group-items=""]', $24d57f4e18709e4d$var$me = '[cmdk-group-heading=""]', $24d57f4e18709e4d$var$W = '[cmdk-item=""]', $24d57f4e18709e4d$var$ae = `${$24d57f4e18709e4d$var$W}:not([aria-disabled="true"])`, $24d57f4e18709e4d$var$B = "cmdk-item-select", $24d57f4e18709e4d$var$S = "data-value", $24d57f4e18709e4d$var$pe = (r, c)=>(0, $f77cef878b3c2149$export$407448d2b89b1813)(r, c), $24d57f4e18709e4d$var$se = $exYeM.createContext(void 0), $24d57f4e18709e4d$var$A = ()=>$exYeM.useContext($24d57f4e18709e4d$var$se), $24d57f4e18709e4d$var$ie = $exYeM.createContext(void 0), $24d57f4e18709e4d$var$J = ()=>$exYeM.useContext($24d57f4e18709e4d$var$ie), $24d57f4e18709e4d$var$ce = $exYeM.createContext(void 0), $24d57f4e18709e4d$export$6def88b96ee4affb = $exYeM.forwardRef((r, c)=>{
    let n = $exYeM.useRef(null), o = $24d57f4e18709e4d$var$w(()=>{
        var e, s, a;
        return {
            search: "",
            value: (a = (s = r.value) != null ? s : (e = r.defaultValue) == null ? void 0 : e.toLowerCase()) != null ? a : "",
            filtered: {
                count: 0,
                items: new Map,
                groups: new Set
            }
        };
    }), l = $24d57f4e18709e4d$var$w(()=>new Set), d = $24d57f4e18709e4d$var$w(()=>new Map), f = $24d57f4e18709e4d$var$w(()=>new Map), g = $24d57f4e18709e4d$var$w(()=>new Set), u = $24d57f4e18709e4d$var$ue(r), { label: b, children: p, value: R, onValueChange: T, filter: I, shouldFilter: C, vimBindings: F = !0, ...P } = r, Q = $exYeM.useId(), K = $exYeM.useId(), V = $exYeM.useId(), E = $24d57f4e18709e4d$var$Le();
    $24d57f4e18709e4d$var$D(()=>{
        if (R !== void 0) {
            let e = R.trim().toLowerCase();
            o.current.value = e, E(6, Y), m.emit();
        }
    }, [
        R
    ]);
    let m = $exYeM.useMemo(()=>({
            subscribe: (e)=>(g.current.add(e), ()=>g.current.delete(e)),
            snapshot: ()=>o.current,
            setState: (e, s, a)=>{
                var i, v, h;
                if (!Object.is(o.current[e], s)) {
                    if (o.current[e] = s, e === "search") $(), N(), E(1, j);
                    else if (e === "value") {
                        if (((i = u.current) == null ? void 0 : i.value) !== void 0) {
                            let x = s != null ? s : "";
                            (h = (v = u.current).onValueChange) == null || h.call(v, x);
                            return;
                        } else a || E(5, Y);
                    }
                    m.emit();
                }
            },
            emit: ()=>{
                g.current.forEach((e)=>e());
            }
        }), []), M = $exYeM.useMemo(()=>({
            value: (e, s)=>{
                s !== f.current.get(e) && (f.current.set(e, s), o.current.filtered.items.set(e, X(s)), E(2, ()=>{
                    N(), m.emit();
                }));
            },
            item: (e, s)=>(l.current.add(e), s && (d.current.has(s) ? d.current.get(s).add(e) : d.current.set(s, new Set([
                    e
                ]))), E(3, ()=>{
                    $(), N(), o.current.value || j(), m.emit();
                }), ()=>{
                    f.current.delete(e), l.current.delete(e), o.current.filtered.items.delete(e);
                    let a = k();
                    E(4, ()=>{
                        $(), (a == null ? void 0 : a.getAttribute("id")) === e && j(), m.emit();
                    });
                }),
            group: (e)=>(d.current.has(e) || d.current.set(e, new Set), ()=>{
                    f.current.delete(e), d.current.delete(e);
                }),
            filter: ()=>u.current.shouldFilter,
            label: b || r["aria-label"],
            commandRef: n,
            listId: Q,
            inputId: V,
            labelId: K
        }), []);
    function X(e) {
        var a, i;
        let s = (i = (a = u.current) == null ? void 0 : a.filter) != null ? i : $24d57f4e18709e4d$var$pe;
        return e ? s(e, o.current.search) : 0;
    }
    function N() {
        if (!n.current || !o.current.search || u.current.shouldFilter === !1) return;
        let e = o.current.filtered.items, s = [];
        o.current.filtered.groups.forEach((i)=>{
            let v = d.current.get(i), h = 0;
            v.forEach((x)=>{
                let G = e.get(x);
                h = Math.max(G, h);
            }), s.push([
                i,
                h
            ]);
        });
        let a = n.current.querySelector($24d57f4e18709e4d$var$fe);
        H().sort((i, v)=>{
            var G, re;
            let h = i.getAttribute($24d57f4e18709e4d$var$S), x = v.getAttribute($24d57f4e18709e4d$var$S);
            return ((G = e.get(x)) != null ? G : 0) - ((re = e.get(h)) != null ? re : 0);
        }).forEach((i)=>{
            let v = i.closest($24d57f4e18709e4d$var$U);
            v ? v.appendChild(i.parentElement === v ? i : i.closest(`${$24d57f4e18709e4d$var$U} > *`)) : a.appendChild(i.parentElement === a ? i : i.closest(`${$24d57f4e18709e4d$var$U} > *`));
        }), s.sort((i, v)=>v[1] - i[1]).forEach((i)=>{
            let v = n.current.querySelector(`${$24d57f4e18709e4d$var$O}[${$24d57f4e18709e4d$var$S}="${i[0]}"]`);
            v == null || v.parentElement.appendChild(v);
        });
    }
    function j() {
        let e = H().find((a)=>!a.ariaDisabled), s = e == null ? void 0 : e.getAttribute($24d57f4e18709e4d$var$S);
        m.setState("value", s || void 0);
    }
    function $() {
        if (!o.current.search || u.current.shouldFilter === !1) {
            o.current.filtered.count = l.current.size;
            return;
        }
        o.current.filtered.groups = new Set;
        let e = 0;
        for (let s of l.current){
            let a = f.current.get(s), i = X(a);
            o.current.filtered.items.set(s, i), i > 0 && e++;
        }
        for (let [s, a] of d.current)for (let i of a)if (o.current.filtered.items.get(i) > 0) {
            o.current.filtered.groups.add(s);
            break;
        }
        o.current.filtered.count = e;
    }
    function Y() {
        var s, a, i;
        let e = k();
        e && (((s = e.parentElement) == null ? void 0 : s.firstChild) === e && ((i = (a = e.closest($24d57f4e18709e4d$var$O)) == null ? void 0 : a.querySelector($24d57f4e18709e4d$var$me)) == null || i.scrollIntoView({
            block: "nearest"
        })), e.scrollIntoView({
            block: "nearest"
        }));
    }
    function k() {
        var e;
        return (e = n.current) == null ? void 0 : e.querySelector(`${$24d57f4e18709e4d$var$W}[aria-selected="true"]`);
    }
    function H() {
        return Array.from(n.current.querySelectorAll($24d57f4e18709e4d$var$ae));
    }
    function q(e) {
        let a = H()[e];
        a && m.setState("value", a.getAttribute($24d57f4e18709e4d$var$S));
    }
    function z(e) {
        var h;
        let s = k(), a = H(), i = a.findIndex((x)=>x === s), v = a[i + e];
        (h = u.current) != null && h.loop && (v = i + e < 0 ? a[a.length - 1] : i + e === a.length ? a[0] : a[i + e]), v && m.setState("value", v.getAttribute($24d57f4e18709e4d$var$S));
    }
    function Z(e) {
        let s = k(), a = s == null ? void 0 : s.closest($24d57f4e18709e4d$var$O), i;
        for(; a && !i;)a = e > 0 ? $24d57f4e18709e4d$var$ye(a, $24d57f4e18709e4d$var$O) : $24d57f4e18709e4d$var$xe(a, $24d57f4e18709e4d$var$O), i = a == null ? void 0 : a.querySelector($24d57f4e18709e4d$var$ae);
        i ? m.setState("value", i.getAttribute($24d57f4e18709e4d$var$S)) : z(e);
    }
    let ee = ()=>q(H().length - 1), te = (e)=>{
        e.preventDefault(), e.metaKey ? ee() : e.altKey ? Z(1) : z(1);
    }, ne = (e)=>{
        e.preventDefault(), e.metaKey ? q(0) : e.altKey ? Z(-1) : z(-1);
    };
    return $exYeM.createElement("div", {
        ref: $24d57f4e18709e4d$var$_([
            n,
            c
        ]),
        ...P,
        "cmdk-root": "",
        onKeyDown: (e)=>{
            var s;
            if ((s = P.onKeyDown) == null || s.call(P, e), !e.defaultPrevented) switch(e.key){
                case "n":
                case "j":
                    F && e.ctrlKey && te(e);
                    break;
                case "ArrowDown":
                    te(e);
                    break;
                case "p":
                case "k":
                    F && e.ctrlKey && ne(e);
                    break;
                case "ArrowUp":
                    ne(e);
                    break;
                case "Home":
                    e.preventDefault(), q(0);
                    break;
                case "End":
                    e.preventDefault(), ee();
                    break;
                case "Enter":
                    if (!e.nativeEvent.isComposing) {
                        e.preventDefault();
                        let a = k();
                        if (a) {
                            let i = new Event($24d57f4e18709e4d$var$B);
                            a.dispatchEvent(i);
                        }
                    }
            }
        }
    }, $exYeM.createElement("label", {
        "cmdk-label": "",
        htmlFor: M.inputId,
        id: M.labelId,
        style: $24d57f4e18709e4d$var$Te
    }, b), $exYeM.createElement($24d57f4e18709e4d$var$ie.Provider, {
        value: m
    }, $exYeM.createElement($24d57f4e18709e4d$var$se.Provider, {
        value: M
    }, p)));
}), $24d57f4e18709e4d$export$b9b346a733d36f61 = $exYeM.forwardRef((r, c)=>{
    var V, E;
    let n = $exYeM.useId(), o = $exYeM.useRef(null), l = $exYeM.useContext($24d57f4e18709e4d$var$ce), d = $24d57f4e18709e4d$var$A(), f = $24d57f4e18709e4d$var$ue(r), g = (E = (V = f.current) == null ? void 0 : V.forceMount) != null ? E : l == null ? void 0 : l.forceMount;
    $24d57f4e18709e4d$var$D(()=>d.item(n, l == null ? void 0 : l.id), []);
    let u = $24d57f4e18709e4d$var$de(n, o, [
        r.value,
        r.children,
        o
    ]), b = $24d57f4e18709e4d$var$J(), p = $24d57f4e18709e4d$export$606184d999862dff((m)=>m.value && m.value === u.current), R = $24d57f4e18709e4d$export$606184d999862dff((m)=>g || d.filter() === !1 ? !0 : m.search ? m.filtered.items.get(n) > 0 : !0);
    $exYeM.useEffect(()=>{
        let m = o.current;
        if (!(!m || r.disabled)) return m.addEventListener($24d57f4e18709e4d$var$B, T), ()=>m.removeEventListener($24d57f4e18709e4d$var$B, T);
    }, [
        R,
        r.onSelect,
        r.disabled
    ]);
    function T() {
        var m, M;
        I(), (M = (m = f.current).onSelect) == null || M.call(m, u.current);
    }
    function I() {
        b.setState("value", u.current, !0);
    }
    if (!R) return null;
    let { disabled: C, value: F, onSelect: P, forceMount: Q, ...K } = r;
    return $exYeM.createElement("div", {
        ref: $24d57f4e18709e4d$var$_([
            o,
            c
        ]),
        ...K,
        id: n,
        "cmdk-item": "",
        role: "option",
        "aria-disabled": C || void 0,
        "aria-selected": p || void 0,
        "data-disabled": C || void 0,
        "data-selected": p || void 0,
        onPointerMove: C ? void 0 : I,
        onClick: C ? void 0 : T
    }, r.children);
}), $24d57f4e18709e4d$export$c157b9873a7a0fbd = $exYeM.forwardRef((r, c)=>{
    let { heading: n, children: o, forceMount: l, ...d } = r, f = $exYeM.useId(), g = $exYeM.useRef(null), u = $exYeM.useRef(null), b = $exYeM.useId(), p = $24d57f4e18709e4d$var$A(), R = $24d57f4e18709e4d$export$606184d999862dff((C)=>l || p.filter() === !1 ? !0 : C.search ? C.filtered.groups.has(f) : !0);
    $24d57f4e18709e4d$var$D(()=>p.group(f), []), $24d57f4e18709e4d$var$de(f, g, [
        r.value,
        r.heading,
        u
    ]);
    let T = $exYeM.useMemo(()=>({
            id: f,
            forceMount: l
        }), [
        l
    ]), I = $exYeM.createElement($24d57f4e18709e4d$var$ce.Provider, {
        value: T
    }, o);
    return $exYeM.createElement("div", {
        ref: $24d57f4e18709e4d$var$_([
            g,
            c
        ]),
        ...d,
        "cmdk-group": "",
        role: "presentation",
        hidden: R ? void 0 : !0
    }, n && $exYeM.createElement("div", {
        ref: u,
        "cmdk-group-heading": "",
        "aria-hidden": !0,
        id: b
    }, n), $exYeM.createElement("div", {
        "cmdk-group-items": "",
        role: "group",
        "aria-labelledby": n ? b : void 0
    }, I));
}), $24d57f4e18709e4d$export$ace649eed6990b42 = $exYeM.forwardRef((r, c)=>{
    let { alwaysRender: n, ...o } = r, l = $exYeM.useRef(null), d = $24d57f4e18709e4d$export$606184d999862dff((f)=>!f.search);
    return !n && !d ? null : $exYeM.createElement("div", {
        ref: $24d57f4e18709e4d$var$_([
            l,
            c
        ]),
        ...o,
        "cmdk-separator": "",
        role: "separator"
    });
}), $24d57f4e18709e4d$export$ebdebb88e46df62a = $exYeM.forwardRef((r, c)=>{
    let { onValueChange: n, ...o } = r, l = r.value != null, d = $24d57f4e18709e4d$var$J(), f = $24d57f4e18709e4d$export$606184d999862dff((p)=>p.search), g = $24d57f4e18709e4d$export$606184d999862dff((p)=>p.value), u = $24d57f4e18709e4d$var$A(), b = $exYeM.useMemo(()=>{
        var R;
        let p = (R = u.commandRef.current) == null ? void 0 : R.querySelector(`${$24d57f4e18709e4d$var$W}[${$24d57f4e18709e4d$var$S}="${g}"]`);
        return p == null ? void 0 : p.getAttribute("id");
    }, [
        g,
        u.commandRef
    ]);
    return $exYeM.useEffect(()=>{
        r.value != null && d.setState("search", r.value);
    }, [
        r.value
    ]), $exYeM.createElement("input", {
        ref: c,
        ...o,
        "cmdk-input": "",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        "aria-autocomplete": "list",
        role: "combobox",
        "aria-expanded": !0,
        "aria-controls": u.listId,
        "aria-labelledby": u.labelId,
        "aria-activedescendant": b,
        id: u.inputId,
        type: "text",
        value: l ? r.value : f,
        onChange: (p)=>{
            l || d.setState("search", p.target.value), n == null || n(p.target.value);
        }
    });
}), $24d57f4e18709e4d$export$9cffcb65e9381872 = $exYeM.forwardRef((r, c)=>{
    let { children: n, ...o } = r, l = $exYeM.useRef(null), d = $exYeM.useRef(null), f = $24d57f4e18709e4d$var$A();
    return $exYeM.useEffect(()=>{
        if (d.current && l.current) {
            let g = d.current, u = l.current, b, p = new ResizeObserver(()=>{
                b = requestAnimationFrame(()=>{
                    let R = g.offsetHeight;
                    u.style.setProperty("--cmdk-list-height", R.toFixed(1) + "px");
                });
            });
            return p.observe(g), ()=>{
                cancelAnimationFrame(b), p.unobserve(g);
            };
        }
    }, []), $exYeM.createElement("div", {
        ref: $24d57f4e18709e4d$var$_([
            l,
            c
        ]),
        ...o,
        "cmdk-list": "",
        role: "listbox",
        "aria-label": "Suggestions",
        id: f.listId,
        "aria-labelledby": f.inputId
    }, $exYeM.createElement("div", {
        ref: d,
        "cmdk-list-sizer": ""
    }, n));
}), $24d57f4e18709e4d$export$98f0540b5c04f3e8 = $exYeM.forwardRef((r, c)=>{
    let { open: n, onOpenChange: o, overlayClassName: l, contentClassName: d, container: f, ...g } = r;
    return $exYeM.createElement($04ac4bc2d2e51e5a$export$be92b6f5f03c0fe9, {
        open: n,
        onOpenChange: o
    }, $exYeM.createElement($04ac4bc2d2e51e5a$export$602eac185826482c, {
        container: f
    }, $exYeM.createElement($04ac4bc2d2e51e5a$export$c6fdb837b070b4ff, {
        "cmdk-overlay": "",
        className: l
    }), $exYeM.createElement($04ac4bc2d2e51e5a$export$7c6e2c02157bb7d2, {
        "aria-label": r.label,
        "cmdk-dialog": "",
        className: d
    }, $exYeM.createElement($24d57f4e18709e4d$export$6def88b96ee4affb, {
        ref: c,
        ...g
    }))));
}), $24d57f4e18709e4d$export$f1753c65029fce09 = $exYeM.forwardRef((r, c)=>{
    let n = $exYeM.useRef(!0), o = $24d57f4e18709e4d$export$606184d999862dff((l)=>l.filtered.count === 0);
    return $exYeM.useEffect(()=>{
        n.current = !1;
    }, []), n.current || !o ? null : $exYeM.createElement("div", {
        ref: c,
        ...r,
        "cmdk-empty": "",
        role: "presentation"
    });
}), $24d57f4e18709e4d$export$8980984ffcab084a = $exYeM.forwardRef((r, c)=>{
    let { progress: n, children: o, ...l } = r;
    return $exYeM.createElement("div", {
        ref: c,
        ...l,
        "cmdk-loading": "",
        role: "progressbar",
        "aria-valuenow": n,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": "Loading..."
    }, $exYeM.createElement("div", {
        "aria-hidden": !0
    }, o));
}), $24d57f4e18709e4d$export$cc7e12c76513e857 = Object.assign($24d57f4e18709e4d$export$6def88b96ee4affb, {
    List: $24d57f4e18709e4d$export$9cffcb65e9381872,
    Item: $24d57f4e18709e4d$export$b9b346a733d36f61,
    Input: $24d57f4e18709e4d$export$ebdebb88e46df62a,
    Group: $24d57f4e18709e4d$export$c157b9873a7a0fbd,
    Separator: $24d57f4e18709e4d$export$ace649eed6990b42,
    Dialog: $24d57f4e18709e4d$export$98f0540b5c04f3e8,
    Empty: $24d57f4e18709e4d$export$f1753c65029fce09,
    Loading: $24d57f4e18709e4d$export$8980984ffcab084a
});
function $24d57f4e18709e4d$var$ye(r, c) {
    let n = r.nextElementSibling;
    for(; n;){
        if (n.matches(c)) return n;
        n = n.nextElementSibling;
    }
}
function $24d57f4e18709e4d$var$xe(r, c) {
    let n = r.previousElementSibling;
    for(; n;){
        if (n.matches(c)) return n;
        n = n.previousElementSibling;
    }
}
function $24d57f4e18709e4d$var$ue(r) {
    let c = $exYeM.useRef(r);
    return $24d57f4e18709e4d$var$D(()=>{
        c.current = r;
    }), c;
}
var $24d57f4e18709e4d$var$D = typeof window == "undefined" ? $exYeM.useEffect : $exYeM.useLayoutEffect;
function $24d57f4e18709e4d$var$w(r) {
    let c = $exYeM.useRef();
    return c.current === void 0 && (c.current = r()), c;
}
function $24d57f4e18709e4d$var$_(r) {
    return (c)=>{
        r.forEach((n)=>{
            typeof n == "function" ? n(c) : n != null && (n.current = c);
        });
    };
}
function $24d57f4e18709e4d$export$606184d999862dff(r) {
    let c = $24d57f4e18709e4d$var$J(), n = ()=>r(c.snapshot());
    return $exYeM.useSyncExternalStore(c.subscribe, n, n);
}
function $24d57f4e18709e4d$var$de(r, c, n) {
    let o = $exYeM.useRef(), l = $24d57f4e18709e4d$var$A();
    return $24d57f4e18709e4d$var$D(()=>{
        var f;
        let d = (()=>{
            var g;
            for (let u of n){
                if (typeof u == "string") return u.trim().toLowerCase();
                if (typeof u == "object" && "current" in u) return u.current ? (g = u.current.textContent) == null ? void 0 : g.trim().toLowerCase() : o.current;
            }
        })();
        l.value(r, d), (f = c.current) == null || f.setAttribute($24d57f4e18709e4d$var$S, d), o.current = d;
    }), o;
}
var $24d57f4e18709e4d$var$Le = ()=>{
    let [r, c] = $exYeM.useState(), n = $24d57f4e18709e4d$var$w(()=>new Map);
    return $24d57f4e18709e4d$var$D(()=>{
        n.current.forEach((o)=>o()), n.current = new Map;
    }, [
        r
    ]), (o, l)=>{
        n.current.set(o, l), c({});
    };
}, $24d57f4e18709e4d$var$Te = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
};





const $46f37e857d06cd66$export$cc7e12c76513e857 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $24d57f4e18709e4d$export$cc7e12c76513e857), {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", className),
        ...props
    }));
$46f37e857d06cd66$export$cc7e12c76513e857.displayName = (0, $24d57f4e18709e4d$export$cc7e12c76513e857).displayName;
const $46f37e857d06cd66$export$98f0540b5c04f3e8 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$3ddf2d174ce01153), {
        ...props,
        className: "px-8",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$b6d9565de1e068cf), {
            className: "overflow-hidden p-0 shadow-lg bg-white",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)($46f37e857d06cd66$export$cc7e12c76513e857, {
                className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
                children: children
            })
        })
    });
};
const $46f37e857d06cd66$export$ebdebb88e46df62a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>// eslint-disable-next-line react/no-unknown-property
    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex items-center border-b px-3 w-full",
        "cmdk-input-wrapper": "",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $24d57f4e18709e4d$export$cc7e12c76513e857).Input, {
            ref: ref,
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", className),
            ...props
        })
    }));
$46f37e857d06cd66$export$ebdebb88e46df62a.displayName = (0, $24d57f4e18709e4d$export$cc7e12c76513e857).Input.displayName;
const $46f37e857d06cd66$export$9cffcb65e9381872 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $24d57f4e18709e4d$export$cc7e12c76513e857).List, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
        ...props
    }));
$46f37e857d06cd66$export$9cffcb65e9381872.displayName = (0, $24d57f4e18709e4d$export$cc7e12c76513e857).List.displayName;
const $46f37e857d06cd66$export$f1753c65029fce09 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $24d57f4e18709e4d$export$cc7e12c76513e857).Empty, {
        ref: ref,
        className: "py-6 text-center text-sm",
        ...props
    }));
$46f37e857d06cd66$export$f1753c65029fce09.displayName = (0, $24d57f4e18709e4d$export$cc7e12c76513e857).Empty.displayName;
const $46f37e857d06cd66$export$c157b9873a7a0fbd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $24d57f4e18709e4d$export$cc7e12c76513e857).Group, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground bg-white", className),
        ...props
    }));
$46f37e857d06cd66$export$c157b9873a7a0fbd.displayName = (0, $24d57f4e18709e4d$export$cc7e12c76513e857).Group.displayName;
const $46f37e857d06cd66$export$ace649eed6990b42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $24d57f4e18709e4d$export$cc7e12c76513e857).Separator, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("-mx-1 h-px bg-border", className),
        ...props
    }));
$46f37e857d06cd66$export$ace649eed6990b42.displayName = (0, $24d57f4e18709e4d$export$cc7e12c76513e857).Separator.displayName;
const $46f37e857d06cd66$export$b9b346a733d36f61 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $24d57f4e18709e4d$export$cc7e12c76513e857).Item, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", className),
        ...props
    }));
$46f37e857d06cd66$export$b9b346a733d36f61.displayName = (0, $24d57f4e18709e4d$export$cc7e12c76513e857).Item.displayName;
const $46f37e857d06cd66$export$8b2995843ab6cf09 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("ml-auto text-xs tracking-widest text-muted-foreground", className),
        ...props
    });
});
$46f37e857d06cd66$export$8b2995843ab6cf09.displayName = "CommandShortcut";



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");








var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e0dc3054c0a828de$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $729e420fd9c85e8f$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $729e420fd9c85e8f$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $e0dc3054c0a828de$var$index = typeof document !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $e0dc3054c0a828de$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$e0dc3054c0a828de$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$e0dc3054c0a828de$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // biome-ignore lint/suspicious/noSelfCompare: in source
    return a !== a && b !== b;
}
function $e0dc3054c0a828de$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $e0dc3054c0a828de$var$roundByDPR(element, value) {
    const dpr = $e0dc3054c0a828de$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $e0dc3054c0a828de$var$useLatestRef(value) {
    const ref = $exYeM.useRef(value);
    $e0dc3054c0a828de$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $e0dc3054c0a828de$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $exYeM.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $exYeM.useState(middleware);
    if (!$e0dc3054c0a828de$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $exYeM.useState(null);
    const [_floating, _setFloating] = $exYeM.useState(null);
    const setReference = $exYeM.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $exYeM.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $exYeM.useRef(null);
    const floatingRef = $exYeM.useRef(null);
    const dataRef = $exYeM.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $e0dc3054c0a828de$var$useLatestRef(whileElementsMounted);
    const platformRef = $e0dc3054c0a828de$var$useLatestRef(platform);
    const update = $exYeM.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $729e420fd9c85e8f$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$e0dc3054c0a828de$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $d2lNW.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $e0dc3054c0a828de$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $exYeM.useRef(false);
    $e0dc3054c0a828de$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `hasWhileElementsMounted` is intentionally included.
    $e0dc3054c0a828de$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $exYeM.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $exYeM.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $exYeM.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $e0dc3054c0a828de$var$roundByDPR(elements.floating, data.x);
        const y = $e0dc3054c0a828de$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$e0dc3054c0a828de$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $exYeM.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $51f35d4f6c07a0fd$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $51f35d4f6c07a0fd$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).svg, (0, $aJx1R.default)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $exYeM.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($51f35d4f6c07a0fd$export$21b07c8f274aebd5, {
    displayName: $51f35d4f6c07a0fd$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $51f35d4f6c07a0fd$export$be92b6f5f03c0fe9 = $51f35d4f6c07a0fd$export$21b07c8f274aebd5;








var $exYeM = parcelRequire("exYeM");

function $e3071ccbaf099f7e$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $exYeM.useState)(undefined);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $7b6292e260c70ed7$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $7b6292e260c70ed7$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext, $7b6292e260c70ed7$export$722aac194ae923] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperProvider, $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $7b6292e260c70ed7$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $exYeM.useState)(null);
    return /*#__PURE__*/ (0, $exYeM.createElement)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$badac9ada3a0bdf9, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $7b6292e260c70ed7$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $exYeM.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$ecd4e1ccab6ed6d, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$useContentContext] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $7b6292e260c70ed7$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $exYeM.useState)(null);
    const arrowSize = (0, $e3071ccbaf099f7e$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $e0dc3054c0a828de$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $729e420fd9c85e8f$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $28f1bf2594995773$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $729e420fd9c85e8f$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $729e420fd9c85e8f$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $729e420fd9c85e8f$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $729e420fd9c85e8f$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $e0dc3054c0a828de$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $729e420fd9c85e8f$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPlaced);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $exYeM.useState)();
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $exYeM.createElement)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$bc4ae5855d3c4fc, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $7b6292e260c70ed7$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$useContentContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $exYeM.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $51f35d4f6c07a0fd$export$be92b6f5f03c0fe9), (0, $aJx1R.default)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$79d62cd4e10a3fd0, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $7b6292e260c70ed7$export$be92b6f5f03c0fe9 = $7b6292e260c70ed7$export$badac9ada3a0bdf9;
const $7b6292e260c70ed7$export$b688253958b8dfe7 = $7b6292e260c70ed7$export$ecd4e1ccab6ed6d;
const $7b6292e260c70ed7$export$7c6e2c02157bb7d2 = $7b6292e260c70ed7$export$bc4ae5855d3c4fc;
const $7b6292e260c70ed7$export$21b07c8f274aebd5 = $7b6292e260c70ed7$export$79d62cd4e10a3fd0;









/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext, $0f2238d5081ee7b6$export$c8393c9e73286932] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $7b6292e260c70ed7$export$722aac194ae923)
]);
const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $7b6292e260c70ed7$export$722aac194ae923)();
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverProvider, $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext] = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME);
const $0f2238d5081ee7b6$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0, $exYeM.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0, $exYeM.useState)(false);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $exYeM.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $exYeM.useCallback)(()=>setHasCustomAnchor(true), []),
        onCustomAnchorRemove: (0, $exYeM.useCallback)(()=>setHasCustomAnchor(false), []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$5b6b19405a83ff9d, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $0f2238d5081ee7b6$export$96e5381f42521a79 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    (0, $exYeM.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $aJx1R.default)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$96e5381f42521a79, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $0f2238d5081ee7b6$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $aJx1R.default)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$7dacb05d26466c3, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PortalProvider, $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePortalContext] = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $0f2238d5081ee7b6$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$dd679ffb4362d2d4, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $0f2238d5081ee7b6$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePortalContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $aJx1R.default)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $aJx1R.default)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$d7e1f420b25549ff, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0, $exYeM.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $exYeM.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $aJx1R.default)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        })
    })));
});
const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0, $exYeM.useRef)(false);
    const hasPointerDownOutsideRef = (0, $exYeM.useRef)(false);
    return /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $aJx1R.default)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$7c6e2c02157bb7d2), (0, $aJx1R.default)({
        "data-state": $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
            "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
            "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $0f2238d5081ee7b6$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$d6ac43ebaa40d53e, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
const $0f2238d5081ee7b6$export$3152841115e061b2 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$21b07c8f274aebd5), (0, $aJx1R.default)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$3152841115e061b2, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
const $0f2238d5081ee7b6$export$be92b6f5f03c0fe9 = $0f2238d5081ee7b6$export$5b6b19405a83ff9d;
const $0f2238d5081ee7b6$export$b688253958b8dfe7 = $0f2238d5081ee7b6$export$96e5381f42521a79;
const $0f2238d5081ee7b6$export$41fb9f06171c75f4 = $0f2238d5081ee7b6$export$7dacb05d26466c3;
const $0f2238d5081ee7b6$export$602eac185826482c = $0f2238d5081ee7b6$export$dd679ffb4362d2d4;
const $0f2238d5081ee7b6$export$7c6e2c02157bb7d2 = $0f2238d5081ee7b6$export$d7e1f420b25549ff;
const $0f2238d5081ee7b6$export$f39c2d165cd861fe = $0f2238d5081ee7b6$export$d6ac43ebaa40d53e;
const $0f2238d5081ee7b6$export$21b07c8f274aebd5 = $0f2238d5081ee7b6$export$3152841115e061b2;



const $80641d61d869cd62$export$5b6b19405a83ff9d = $0f2238d5081ee7b6$export$be92b6f5f03c0fe9;
const $80641d61d869cd62$export$7dacb05d26466c3 = $0f2238d5081ee7b6$export$41fb9f06171c75f4;
const $80641d61d869cd62$export$d7e1f420b25549ff = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, align: align = "center", sideOffset: sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($0f2238d5081ee7b6$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($0f2238d5081ee7b6$export$7c6e2c02157bb7d2, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("z-50 w-72 rounded-md bg-white border border-onSurfaceVariant p-2 2xl:p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
            ...props
        })
    }));
$80641d61d869cd62$export$d7e1f420b25549ff.displayName = $0f2238d5081ee7b6$export$7c6e2c02157bb7d2.displayName;




var $exYeM = parcelRequire("exYeM");



function $ef70c0aee1b071d9$export$2e2bcd8739ae039() {
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "getFootprints"
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/footprint", {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
            return data;
        },
        staleTime: 1000
    });
    return {
        isLoading: isLoading,
        isError: isError,
        isFetching: isFetching,
        data: data,
        error: error
    };
}




function $bce771d29ab709c8$export$2e2bcd8739ae039(addressInput, navigate) {
    // Remove the leading and trailing slashes to ensure consistent splitting
    if (!addressInput.trim()) {
        alert("Please enter an address.");
        return; // Stop the function execution if no address is entered
    }
    const trimmedPath = location.pathname.replace(/^\/|\/$/g, "");
    const pathSegments = trimmedPath.split("/");
    // The tab is the second segment after 'Footprint'
    let currentTab = pathSegments.length > 1 ? pathSegments[1].toLowerCase() : "portfolio";
    // If currentTab is 'footprint', set it to 'portfolio'
    if (currentTab === "footprint") currentTab = "portfolio";
    const newPath = `/Footprint/${currentTab}?address=${addressInput || ""}`;
    navigate(newPath);
}


function $91fa304046735f83$export$2e2bcd8739ae039({ focused: focused, setOpenDialog: setOpenDialog, dialog: dialog, setEdit: setEdit }) {
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const [value, setValue] = (0, $exYeM.useState)(false);
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $ef70c0aee1b071d9$export$2e2bcd8739ae039)();
    // make it so that it has just button to popp down sync value with the input box, add go button, kinda jank but could work
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $80641d61d869cd62$export$5b6b19405a83ff9d), {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $80641d61d869cd62$export$7dacb05d26466c3), {
                asChild: true,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(focused ? "w-[75px]" : "w-[150px] xl:w-[200px] 2xl:w-[250px]", "duration-500 h-full overflow-hidden truncate shadow-md"),
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $433754a817809fb2$export$3b0a9d598f613fa), {
                        variant: "outline",
                        role: "combobox",
                        "aria-expanded": open,
                        className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(focused ? "p-1" : "", "w-full duration-500 justify-between rounded-md border-onSurfaceVariant bg-white hover:bg-primary group  h-full "),
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(focused ? "w-[0px] opacity-0" : "w-full opacity-100", "duration-500"),
                                children: isError ? error?.response?.status === 401 ? "Login/Sign up!" : "Error Fetching!" : isLoading ? "Loading..." : value ? data?.data.find((item)=>item.name === value)?.name : "Preset/Saved"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9b82b6f96fc76ebd$export$2e2bcd8739ae039), {
                                className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(focused ? "ml-0" : "ml-2", "h-4 w-4 xl:h-6 xl:w-6 2xl:h-8 2xl:w-8 group-hover:text-white text-onSurfaceVariant")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $80641d61d869cd62$export$d7e1f420b25549ff), {
                className: "w-[200px] 2xl:w-[250px]",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $46f37e857d06cd66$export$cc7e12c76513e857), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$ebdebb88e46df62a), {
                            placeholder: "Search footprints..."
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$f1753c65029fce09), {
                            children: "No footprints found."
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $46f37e857d06cd66$export$c157b9873a7a0fbd), {
                            children: [
                                isError ? error?.response?.status === 401 ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                    children: "Login/Sign up!"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                    children: "Error Fetching!"
                                }) : isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                    children: "Loading..."
                                }) : data?.data?.length === 0 ? "No Footprints found" : data?.data?.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                            value: item.name,
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                    onSelect: (currentValue)=>{
                                                        setValue(currentValue === value ? "" : currentValue);
                                                        setOpen(false);
                                                    },
                                                    onClick: ()=>{
                                                        (0, $bce771d29ab709c8$export$2e2bcd8739ae039)(item.addresses.address, navigate);
                                                    },
                                                    className: "flex flex-grow hover:text-primary transition-all border-r",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9bcddf4d25089704$export$2e2bcd8739ae039), {
                                                            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("mr-2 h-4 w-4", value === item.name ? "opacity-100" : "opacity-0")
                                                        }),
                                                        item.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    onClick: ()=>{
                                                        setOpenDialog(true);
                                                        dialog({
                                                            _id: item._id,
                                                            name: item.name,
                                                            address: item.addresses.address
                                                        });
                                                        setEdit(true);
                                                    },
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ccb23396c9d57cd4$export$2e2bcd8739ae039), {
                                                        className: "ml-2 h-4 w-4 text-gray-700 hover:text-primary transition-all"
                                                    })
                                                })
                                            ]
                                        }, item.name)
                                    }, item.name)),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        className: "border-t-2 border-dashed border-gray-200 pt-3 font-semibold w-full",
                                        onClick: ()=>{
                                            setOpenDialog(true);
                                            dialog({
                                                _id: null,
                                                name: "",
                                                address: ""
                                            });
                                            setEdit(false);
                                        },
                                        children: "Add +"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");



var $exYeM = parcelRequire("exYeM");

function $55e0420550879926$export$2e2bcd8739ae039(optimistic = false) {
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    //   const openSuccess = useStoreNotificationPopup((state) => state.open);
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const [success, setSuccess] = (0, $exYeM.useState)("");
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [error, setError] = (0, $exYeM.useState)(false);
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ name: name, address: address })=>{
            setLoading(true);
            setError(false);
            setMessage("");
            setSuccess(false);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/footprint", {
                name: name,
                address: address
            }, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
        },
        mutationKey: [
            "addFootprint"
        ],
        onSuccess: async (data)=>{
            // setSuccessful(true);
            setLoading(false);
            setSuccess(true);
            if (optimistic) {
                await queryClient.cancelQueries({
                    queryKey: [
                        "getFootprints"
                    ]
                });
                const prev = queryClient.getQueryData([
                    "getFootprints"
                ]);
                queryClient.setQueryData([
                    "getFootprints"
                ], (old)=>[
                        ...old.data,
                        data
                    ]);
                return {
                    prev: prev
                };
            }
        },
        onError: (error, id, context)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-red-500 font-semibold flex gap-1 self-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6a80b2de3c2a5bc$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 self-center mt-[1px]"
                    }),
                    resMessage
                ]
            }));
            setError(true);
            setLoading(false);
            if (optimistic) queryClient.setQueryData([
                "getFootprints"
            ], context.prev);
            console.error(resMessage);
        },
        onSettled: ()=>{
            setLoading(false);
            if (optimistic) queryClient.invalidateQueries({
                queryKey: [
                    "getFootprints"
                ]
            });
        }
    });
    return {
        mutation: mutation,
        loading: loading,
        error: error,
        success: success,
        message: message
    };
}



var $aSiaI = parcelRequire("aSiaI");



var $exYeM = parcelRequire("exYeM");

function $3c4d5e9063dea0bc$export$2e2bcd8739ae039(id) {
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const [success, setSuccess] = (0, $exYeM.useState)("");
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [error, setError] = (0, $exYeM.useState)(false);
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ({ name: name, address: address })=>{
            setLoading(true);
            setError(false);
            setMessage("");
            setSuccess(false);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).put("/footprint/" + id, {
                name: name,
                address: address
            }, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
        },
        mutationKey: [
            "editFootprint"
        ],
        onSuccess: async (data)=>{
            // setSuccessful(true);
            setLoading(false);
            setSuccess(true);
            await queryClient.cancelQueries({
                queryKey: [
                    "getFootprints"
                ]
            });
            const prev = queryClient.getQueryData([
                "getFootprints"
            ]);
            queryClient.setQueryData([
                "getFootprints"
            ], (old)=>{
                let updated = old.data.map((item)=>{
                    if (item._id == id) return data;
                    else return item;
                });
                [
                    ...updated
                ];
            });
            return {
                prev: prev
            };
        },
        onError: (error, id, context)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-red-500 font-semibold flex gap-1 self-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6a80b2de3c2a5bc$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 self-center mt-[1px]"
                    }),
                    resMessage
                ]
            }));
            setError(true);
            setLoading(false);
            queryClient.setQueryData([
                "getFootprints"
            ], context.prev);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "getFootprints"
                ]
            });
        }
    });
    return {
        mutation: mutation,
        loading: loading,
        error: error,
        success: success,
        message: message
    };
}



var $aSiaI = parcelRequire("aSiaI");



var $exYeM = parcelRequire("exYeM");

function $617a13fcc0b3fdf9$export$2e2bcd8739ae039(id) {
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const [success, setSuccess] = (0, $exYeM.useState)("");
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [error, setError] = (0, $exYeM.useState)(false);
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const mutation = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: async ()=>{
            setLoading(true);
            setError(false);
            setMessage("");
            setSuccess(false);
            return await (0, $ca6473885cd32228$export$2e2bcd8739ae039).delete("/footprint/" + id, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
        },
        mutationKey: [
            "removeFootprint " + id
        ],
        onSuccess: async (id)=>{
            setLoading(false);
            setSuccess(true);
            await queryClient.cancelQueries({
                queryKey: [
                    "getFootprints"
                ]
            });
            const prev = queryClient.getQueryData([
                "getFootprints"
            ]);
            queryClient.setQueryData([
                "getFootprints"
            ], (old)=>{
                let update = old.data.filter((item)=>item._id != id);
                [
                    ...update
                ];
            });
            return {
                prev: prev
            };
        },
        onError: (error, id, context)=>{
            const resMessage = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            setMessage(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-red-500 font-semibold flex gap-1 self-center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6a80b2de3c2a5bc$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 self-center mt-[1px]"
                    }),
                    resMessage
                ]
            }));
            setError(true);
            setLoading(false);
            queryClient.setQueryData([
                "getFootprints"
            ], context.prev);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "getFootprints"
                ]
            });
        }
    });
    return {
        mutation: mutation,
        loading: loading,
        error: error,
        success: success,
        message: message
    };
}



function $508d56f2e43d8c9e$export$2e2bcd8739ae039({ open: open, setOpen: setOpen, dataId: dataId, dataName: dataName, dataAddress: dataAddress, edit: edit }) {
    const [newName, setName] = (0, $exYeM.useState)(dataName ?? "");
    const [newAddress, setAddress] = (0, $exYeM.useState)(dataAddress ?? "");
    const [message, setMessage] = (0, $exYeM.useState)("");
    const { mutation: mutation, loading: loading, error: error, success: success, message: errMessage } = (0, $55e0420550879926$export$2e2bcd8739ae039)(!edit);
    const { mutation: mutationEdit, loading: loadingEdit, error: errorEdit, success: successEdit, message: errMessageEdit } = (0, $3c4d5e9063dea0bc$export$2e2bcd8739ae039)(dataId);
    const { mutation: mutationDelete, loading: loadingDelete, error: errorDelete, success: successDelete, message: errMessageDelete } = (0, $617a13fcc0b3fdf9$export$2e2bcd8739ae039)(dataId);
    const submit = ()=>{
        if (edit) mutationEdit.mutate({
            name: newName,
            address: newAddress
        });
        else mutation.mutate({
            name: newName,
            address: newAddress
        });
    };
    (0, $exYeM.useEffect)(()=>{
        setAddress(dataAddress);
    }, [
        dataAddress
    ]);
    (0, $exYeM.useEffect)(()=>{
        setName(dataName);
    }, [
        dataName
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (success || successEdit || successDelete) setOpen(false);
    }, [
        success,
        successEdit,
        successDelete
    ]);
    (0, $exYeM.useEffect)(()=>{
        setMessage(errMessage || errMessageEdit || errMessageDelete);
    }, [
        error,
        errorEdit,
        errorDelete
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!open) {
            setMessage("");
            setName("");
            setAddress("");
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 w-screen overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden  bg-white rounded-lg pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "absolute right-0 top-0 hidden pr-4 pt-4 sm:block ",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "rounded-md bg-white text-gray-400 hover:text-gray-500",
                                            onClick: ()=>{
                                                // setErrorMsg("");
                                                // clearClose();
                                                setOpen(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fe24332445e161c9$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "bg-white px-8 pb-4 pt-5 sm:p-6 sm:pb-4",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "sm:flex sm:items-start ",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "mt-3 text-center sm:mt-2 sm:text-left  w-full ",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "flex flex-row items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10",
                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $92ca66f52aed8449$export$2e2bcd8739ae039), {
                                                                    className: "h-6 w-6 text-primary",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Title, {
                                                                as: "h3",
                                                                className: "ml-4 text-base font-semibold leading-6 text-gray-900",
                                                                children: "Add new footprint"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "mt-4 pt-4 w-full border-t pb-2 block text-md font-medium leading-6 text-gray-900",
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                            type: "text",
                                                            name: "footprint-name",
                                                            placeholder: "Name",
                                                            className: `block border mt-1 border-onSurfaceVariant w-full py-2 pl-3 pr-9 rounded-md focus:border-primary focus:outline-none`,
                                                            onInput: (e)=>setName(e.target.value),
                                                            value: newName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "mt-4 w-full border-t pt-4 pb-2 block text-md font-medium leading-6 text-gray-900",
                                                        children: "Address"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                            type: "text",
                                                            name: "footprint-Address",
                                                            placeholder: "Address",
                                                            className: `block border mt-1 border-onSurfaceVariant w-full py-2 pl-3 pr-9 rounded-md focus:border-primary focus:outline-none`,
                                                            value: newAddress,
                                                            onInput: (e)=>setAddress(e.target.value)
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "bg-gray-50  w-full flex  justify-between items-center p-6 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "flex flex-grow",
                                                children: error || errorEdit || errorDelete ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    children: message
                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {})
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: " sm:flex sm:flex-row-reverse h-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                        type: "submit",
                                                        className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(loading || loadingEdit || loadingDelete ? "bg-gray-300 text-gray-400" : "hover:text-white hover:bg-primary bg-primaryContainer", "inline-flex gap-4 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm sm:ml-3 sm:w-auto"),
                                                        onClick: ()=>{
                                                            submit();
                                                        },
                                                        disabled: loading || loadingEdit || loadingDelete,
                                                        children: [
                                                            loading || loadingEdit ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5 animate-spin"
                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "hidden"
                                                            }),
                                                            edit ? "Update" : "Add"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                        type: "submit",
                                                        className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(edit ? loadingDelete ? "bg-gray-300 text-gray-400" : "bg-red-400 hover:bg-red-300 text-white" : "bg-white hover:bg-gray-50 text-gray-900", "mt-3 inline-flex gap-4 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm  sm:mt-0 sm:w-auto"),
                                                        onClick: ()=>{
                                                            edit ? mutationDelete.mutate(dataId) : setOpen(false);
                                                        // setOpen(false);
                                                        // clearClose();
                                                        },
                                                        disabled: loadingDelete,
                                                        children: [
                                                            loadingDelete ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2dec8258d0879bfc$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5 animate-spin"
                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "hidden"
                                                            }),
                                                            edit ? "Delete" : "Cancel"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}




var $exYeM = parcelRequire("exYeM");
function $8e7f67527853710b$var$ListBulletIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
    }));
}
const $8e7f67527853710b$var$ForwardRef = $exYeM.forwardRef($8e7f67527853710b$var$ListBulletIcon);
var $8e7f67527853710b$export$2e2bcd8739ae039 = $8e7f67527853710b$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $4cf1499b0af9c1c9$var$MagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
    }));
}
const $4cf1499b0af9c1c9$var$ForwardRef = $exYeM.forwardRef($4cf1499b0af9c1c9$var$MagnifyingGlassIcon);
var $4cf1499b0af9c1c9$export$2e2bcd8739ae039 = $4cf1499b0af9c1c9$var$ForwardRef;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");





function $fbfec6f68709a3e8$export$2e2bcd8739ae039({ open: open, setOpen: setOpen }) {
    const [addressInput, setAddressInput] = (0, $exYeM.useState)("");
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const handleAddressInput = (event)=>{
        setAddressInput(event.target.value);
    };
    const submit = ()=>{
        if (!addressInput.trim()) {
            alert("Please enter an address.");
            return; // Stop the function execution if no address is entered
        }
        const trimmedPath = location.pathname.replace(/^\/|\/$/g, "");
        const pathSegments = trimmedPath.split("/");
        // The tab is the second segment after 'Footprint'
        let currentTab = pathSegments.length > 1 ? pathSegments[1].toLowerCase() : "portfolio";
        // If currentTab is 'footprint', set it to 'portfolio'
        if (currentTab === "footprint") currentTab = "portfolio";
        const newPath = `/Footprint/${currentTab}?address=${addressInput || ""}`;
        navigate(newPath);
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 w-screen overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden  bg-white rounded-lg pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "absolute right-0 top-0 hidden pr-4 pt-4 sm:block ",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "rounded-md bg-white text-gray-400 hover:text-gray-500",
                                            onClick: ()=>{
                                                // setErrorMsg("");
                                                // clearClose();
                                                setOpen(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fe24332445e161c9$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 group-hover:text-white ",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "bg-white px-8 pb-4 pt-4 sm:p-6 sm:pb-4",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "sm:flex sm:items-start ",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "mt-2 text-center sm:mt-2 sm:text-left  w-full ",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "flex flex-row items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                className: "flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10",
                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4cf1499b0af9c1c9$export$2e2bcd8739ae039), {
                                                                    className: "h-6 w-6 text-primary",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Title, {
                                                                as: "h3",
                                                                className: "ml-4 text-base font-semibold leading-6 text-gray-900",
                                                                children: "Search address"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "flex flex-row mt-2  pt-4 pb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                id: "addressInput",
                                                                type: "text",
                                                                placeholder: "Add Address... 0x..",
                                                                value: addressInput,
                                                                onChange: handleAddressInput,
                                                                className: (0, $fcf061de51445294$export$2e2bcd8739ae039)("h-full text-base border px-2 py-2 w-full flex-grow focus:outline-0  duration-500 border-onSurfaceVariant shadow-lg rounded-l-md")
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $433754a817809fb2$export$3b0a9d598f613fa), {
                                                                type: "button",
                                                                variant: "semibold",
                                                                onClick: ()=>{
                                                                    submit();
                                                                },
                                                                className: "h-full rounded-r-md border-t border-b border-r border-onSurfaceVariant bg-white hover:bg-primary group p-3 shadow-md",
                                                                children: "Go"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");
function $a64483d45234c9e9$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12.75l6 6 9-13.5"
    }));
}
const $a64483d45234c9e9$var$ForwardRef = $exYeM.forwardRef($a64483d45234c9e9$var$CheckIcon);
var $a64483d45234c9e9$export$2e2bcd8739ae039 = $a64483d45234c9e9$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $665e0435cef4cba3$var$PencilIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
    }));
}
const $665e0435cef4cba3$var$ForwardRef = $exYeM.forwardRef($665e0435cef4cba3$var$PencilIcon);
var $665e0435cef4cba3$export$2e2bcd8739ae039 = $665e0435cef4cba3$var$ForwardRef;




function $9a9e89f7752f2bf4$export$2e2bcd8739ae039({ open: open, setOpen: setOpen, dialog: dialog, setEdit: setEdit, setOpenDialog: setOpenDialog }) {
    //   const [open, setOpen] = React.useState(false)
    const [value, setValue] = (0, $exYeM.useState)(false);
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $ef70c0aee1b071d9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 w-screen overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden  bg-white rounded-lg pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $46f37e857d06cd66$export$cc7e12c76513e857), {
                                    className: "bg-white px-4 pb-4 pt-4",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: " flex gap-4 w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$ebdebb88e46df62a), {
                                                    placeholder: "Search footprints...",
                                                    className: "w-full"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                    type: "button",
                                                    className: "rounded-md text-gray-400 hover:text-gray-500 p-1",
                                                    onClick: ()=>{
                                                        // setErrorMsg("");
                                                        // clearClose();
                                                        setOpen(false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Close"
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fe24332445e161c9$export$2e2bcd8739ae039), {
                                                            className: "h-6 w-6 group-hover:text-white ",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$f1753c65029fce09), {
                                            children: "No footprints found."
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $46f37e857d06cd66$export$c157b9873a7a0fbd), {
                                            children: [
                                                isError ? error?.response?.status === 401 ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                                    children: "Login/Sign up!"
                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                                    children: "Error Fetching!"
                                                }) : isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                                    children: "Loading..."
                                                }) : data?.data?.length === 0 ? "No Footprints found" : data?.data?.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "flex",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                                            value: item.name,
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                    onSelect: (currentValue)=>{
                                                                        setValue(currentValue === value ? "" : currentValue);
                                                                        setOpen(false);
                                                                    },
                                                                    onClick: ()=>{
                                                                        (0, $bce771d29ab709c8$export$2e2bcd8739ae039)(item.addresses.address, navigate);
                                                                    },
                                                                    className: "flex flex-grow hover:text-primary transition-all border-r",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a64483d45234c9e9$export$2e2bcd8739ae039), {
                                                                            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)("mr-2 h-4 w-4", value === item.name ? "opacity-100" : "opacity-0")
                                                                        }),
                                                                        item.name
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                    onClick: ()=>{
                                                                        setOpen(false);
                                                                        setOpenDialog(true);
                                                                        dialog({
                                                                            _id: item._id,
                                                                            name: item.name,
                                                                            address: item.addresses.address
                                                                        });
                                                                        setEdit(true);
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $665e0435cef4cba3$export$2e2bcd8739ae039), {
                                                                        className: "ml-2 h-4 w-4 text-gray-700 hover:text-primary transition-all"
                                                                    })
                                                                })
                                                            ]
                                                        }, item.name)
                                                    }, item.name)),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46f37e857d06cd66$export$b9b346a733d36f61), {
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                        className: "border-t-2 border-dashed border-gray-200 pt-3 font-semibold w-full",
                                                        onClick: ()=>{
                                                            setOpen(false);
                                                            setOpenDialog(true);
                                                            dialog({
                                                                _id: null,
                                                                name: "",
                                                                address: ""
                                                            });
                                                            setEdit(false);
                                                        },
                                                        children: "Add +"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}



const $085fe6c7296ee02e$var$activeClassName = "border-b-2 border-primary text-white bg-primary";
const $085fe6c7296ee02e$var$notActiveClassName = "text-black hover:text-primary";
function $085fe6c7296ee02e$var$Navbar() {
    const [addressInput, setAddressInput] = (0, $exYeM.useState)("");
    const [dialogData, setDialogData] = (0, $exYeM.useState)({
        _id: null,
        name: "",
        address: ""
    });
    const [focused, setFocused] = (0, $exYeM.useState)(false);
    const onFocus = ()=>setFocused(true);
    const onBlur = ()=>setFocused(false);
    const [edit, setEdit] = (0, $exYeM.useState)(false);
    const [openDialog, setOpenDialog] = (0, $exYeM.useState)(false);
    const [openMobileSearch, setOpenMobileSearch] = (0, $exYeM.useState)(false);
    const [openMobileFootprints, setOpenMobileFootprints] = (0, $exYeM.useState)(false);
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const { width: width } = (0, $a88fc3007e889430$export$2e2bcd8739ae039)();
    // Function to handle tab changes
    const handleTabChange = (tabRoute)=>{
        let currentAddress = addressInput;
        // If the addressInput is empty, try getting the address from the URL
        if (!currentAddress) currentAddress = new URLSearchParams(location.search).get("address");
        // Alert the user if no address is available
        if (!currentAddress) {
            toast({
                variant: "destructive",
                title: "Error!",
                description: "Please enter address!"
            });
            return;
        }
        // Navigate to the new tab with the available address
        navigate(`/Footprint/${tabRoute}?address=${currentAddress}`);
    };
    const handleAddressInput = (event)=>{
        setAddressInput(event.target.value);
    };
    const handleFormSubmit = ()=>{
        // Remove the leading and trailing slashes to ensure consistent splitting
        if (!addressInput.trim()) {
            toast({
                variant: "destructive",
                title: "Error!",
                description: "Please enter address!"
            });
            return; // Stop the function execution if no address is entered
        }
        const trimmedPath = location.pathname.replace(/^\/|\/$/g, "");
        const pathSegments = trimmedPath.split("/");
        // The tab is the second segment after 'Footprint'
        let currentTab = pathSegments.length > 1 ? pathSegments[1].toLowerCase() : "portfolio";
        // If currentTab is 'footprint', set it to 'portfolio'
        if (currentTab === "footprint") currentTab = "portfolio";
        const newPath = `/Footprint/${currentTab}?address=${addressInput || ""}`;
        navigate(newPath);
    };
    const currentTab = location.pathname.split("/").pop();
    //tabs for mobile
    const tabOptions = [
        {
            label: "Portfolio",
            route: "portfolio"
        },
        {
            label: "Transactions",
            route: "transactions"
        },
        {
            label: "NFT Footprint",
            route: "nfts"
        },
        {
            label: "Visualiser",
            route: "networkgraph"
        },
        {
            label: "Analytics",
            route: "analytics"
        }
    ];
    const [selectedTab, setSelectedTab] = (0, $exYeM.useState)(tabOptions[0]); // Assuming the first tab is the default
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-full border-b border-secondary",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "min-h-16 px-3 py-3 md:grid grid-cols-1 flex flex-row md:grid-cols-3 md:justify-items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "flex w-full col-span-1 sm:w-fit xl:mr-10 2xl:mr-8",
                            children: width < 1120 ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full sm:w-fit flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $433754a817809fb2$export$3b0a9d598f613fa), {
                                        type: "button",
                                        className: "h-full rounded-md border border-onSurfaceVariant bg-white hover:bg-primary group p-2 shadow-md mr-2",
                                        onClick: ()=>setOpenMobileFootprints(true),
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8e7f67527853710b$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-onSurfaceVariant group-hover:text-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $433754a817809fb2$export$3b0a9d598f613fa), {
                                        type: "button",
                                        className: "h-full rounded-md border border-onSurfaceVariant bg-white hover:bg-primary group p-2 shadow-md",
                                        onClick: ()=>setOpenMobileSearch(true),
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4cf1499b0af9c1c9$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-onSurfaceVariant group-hover:text-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $df22da2c4bc0f29a$export$2e2bcd8739ae039), {
                                        selectedTab: selectedTab,
                                        setSelectedTab: setSelectedTab,
                                        handleTabChange: handleTabChange,
                                        tabOptions: tabOptions
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $91fa304046735f83$export$2e2bcd8739ae039), {
                                        focused: focused,
                                        setOpenDialog: setOpenDialog,
                                        dialog: setDialogData,
                                        edit: edit,
                                        setEdit: setEdit
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                        id: "addressInput",
                                        type: "text",
                                        placeholder: "Add Address... 0x..",
                                        value: addressInput,
                                        onChange: handleAddressInput,
                                        onFocus: onFocus,
                                        onBlur: onBlur,
                                        className: (0, $fcf061de51445294$export$2e2bcd8739ae039)("h-full ml-2 xl:text-base 2xl:text-lg text-sm border px-2 xl:py-2 2xl:py-2.5 sm:w-20 xl:w-32 2xl:w-40 focus:outline-0 focus:w-full duration-500 border-onSurfaceVariant shadow-lg rounded-l-md")
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $433754a817809fb2$export$3b0a9d598f613fa), {
                                        type: "button",
                                        variant: "semibold",
                                        onClick: ()=>handleFormSubmit(),
                                        className: "h-full rounded-r-md border-t border-b border-r border-onSurfaceVariant bg-white hover:bg-primary group p-3 shadow-md",
                                        children: "Go"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "hidden sm:col-span-1 w-full flex-grow sm:flex justify-center",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$b2539bed5023c21c), {
                                defaultValue: "tab1",
                                className: "sm:flex sm:px-1 hidden md:flex gap-x-4 px-4 items-center justify-center text-center",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $125c9c6acc39e22a$export$9712d22edc0d78c1), {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>handleTabChange("portfolio"),
                                            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(currentTab === "portfolio" ? $085fe6c7296ee02e$var$activeClassName : $085fe6c7296ee02e$var$notActiveClassName),
                                            children: "Portfolio"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>handleTabChange("transactions"),
                                            className: currentTab === "transactions" ? $085fe6c7296ee02e$var$activeClassName : $085fe6c7296ee02e$var$notActiveClassName,
                                            children: "Transactions"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>handleTabChange("nfts"),
                                            className: currentTab === "nfts" ? $085fe6c7296ee02e$var$activeClassName : $085fe6c7296ee02e$var$notActiveClassName,
                                            children: "NFT Footprint"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>handleTabChange("networkgraph"),
                                            className: currentTab === "networkgraph" ? $085fe6c7296ee02e$var$activeClassName : $085fe6c7296ee02e$var$notActiveClassName,
                                            children: "Visualiser"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>handleTabChange("analytics"),
                                            className: currentTab === "analytics" ? $085fe6c7296ee02e$var$activeClassName : $085fe6c7296ee02e$var$notActiveClassName,
                                            children: "Analytics"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "justify-end md:flex hidden",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $08c692ba89353911$export$2e2bcd8739ae039), {
                                onAddressConnect: setAddressInput
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $508d56f2e43d8c9e$export$2e2bcd8739ae039), {
                open: openDialog,
                setOpen: setOpenDialog,
                dataId: dialogData._id,
                dataName: dialogData.name,
                dataAddress: dialogData.address,
                edit: edit
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fbfec6f68709a3e8$export$2e2bcd8739ae039), {
                open: openMobileSearch,
                setOpen: setOpenMobileSearch
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9a9e89f7752f2bf4$export$2e2bcd8739ae039), {
                open: openMobileFootprints,
                setOpen: setOpenMobileFootprints,
                setOpenDialog: setOpenDialog,
                dialog: setDialogData,
                edit: edit,
                setEdit: setEdit
            })
        ]
    });
}
var $085fe6c7296ee02e$export$2e2bcd8739ae039 = $085fe6c7296ee02e$var$Navbar;



var $exYeM = parcelRequire("exYeM");
function $9f0da79313b4b09b$var$Portfolio() {
    const [open, setOpen] = (0, $exYeM.useState)(true);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col relative z-0 h-full w-full mx-auto",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("nav", {
                className: "z-10",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $085fe6c7296ee02e$export$2e2bcd8739ae039), {
                    sidebar: open,
                    setSidebar: setOpen
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex flex-row w-full min-h-screen bg-surface",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("main", {
                    className: "h-full w-full z-0 pb-6",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$910ae8079b2c2852), {})
                })
            })
        ]
    });
}
var $9f0da79313b4b09b$export$2e2bcd8739ae039 = $9f0da79313b4b09b$var$Portfolio;



var $aSiaI = parcelRequire("aSiaI");


var $aSiaI = parcelRequire("aSiaI");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

const $b0ac17ca2995b452$export$60332b2344f7fe41 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        // Use clsx to concatenate the base classes with any additional classes passed through className
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("rounded-md border  text-card-foreground shadow-md transform transition duration-300 bg-white", className // additional classes passed to the component
        ),
        ...props
    }));
$b0ac17ca2995b452$export$60332b2344f7fe41.displayName = "Card";
const $b0ac17ca2995b452$export$5665775b26e26c5d = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex flex-col space-y-1.5 px-6 pt-4 pb-2", className // additional classes passed to the component
        ),
        ...props
    }));
$b0ac17ca2995b452$export$5665775b26e26c5d.displayName = "CardHeader";
const $b0ac17ca2995b452$export$474db65c3c394e1c = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, children: children, ...props }, ref)=>{
    const defaultTitle = "Card Title";
    return /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("font-semibold leading-none tracking-tight text-sm sm:text-base lg:text-lg text-gray-700", className // additional classes passed to the component
        ),
        ...props,
        children: children || defaultTitle
    });
});
$b0ac17ca2995b452$export$474db65c3c394e1c.displayName = "CardTitle";
const $b0ac17ca2995b452$export$16e0ed4cb97c00d4 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("p", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("text-sm text-muted-foreground", className // additional classes passed to the component
        ),
        ...props
    }));
$b0ac17ca2995b452$export$16e0ed4cb97c00d4.displayName = "CardDescription";
const $b0ac17ca2995b452$export$64ef9b8c11710c47 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("px-6 py-4 pt-0 font-monda text-base sm:text-xl md:text-2xl text-gray-900", className // additional classes passed to the component
        ),
        ...props
    }));
$b0ac17ca2995b452$export$64ef9b8c11710c47.displayName = "CardContent";
const $b0ac17ca2995b452$export$e9897d434e0741ee = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex items-center p-6 pt-0 ", className // additional classes passed to the component
        ),
        ...props
    }));
$b0ac17ca2995b452$export$e9897d434e0741ee.displayName = "CardFooter";



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

const $c6b436d392117be9$var$CardLoading = ({ height: height = "h-6", width: width = "w-full", className: className = "" })=>{
    // Use cn to concatenate classes
    const classes = (0, $c93813fc9a74a923$export$1343a74baacb0543)(`${width} ${height} bg-gray-300 rounded animate-pulse`, className);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: classes
    });
};
var $c6b436d392117be9$export$2e2bcd8739ae039 = $c6b436d392117be9$var$CardLoading;


function $c9ec2da6d7c9e112$export$2e2bcd8739ae039({ loading: loading, value: value, error: error, name: name, prefix: prefix = "", suffix: suffix, decimals: decimals }) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
        className: "col-span-1",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                    className: "break-words",
                    children: name
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                className: "font-monda text-gray-700",
                children: error ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "text-red-400",
                    children: "error"
                }) : loading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                    className: "flex-grow"
                }) : `${prefix}${Number(value).toLocaleString("en-US", {
                    maximumFractionDigits: decimals
                })} ${suffix}`
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

const $f23148f8ed856136$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "overflow-x-auto h-full w-full",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("table", {
            ref: ref,
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("w-full caption-bottom text-sm h-full table-auto ", className),
            ...props
        })
    }));
$f23148f8ed856136$export$54ec01a60f47d33d.displayName = "Table";
const $f23148f8ed856136$export$f850895b287ef28e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("thead", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("[_&tr]:border-b", className),
        ...props
    }));
$f23148f8ed856136$export$f850895b287ef28e.displayName = "TableHeader";
const $f23148f8ed856136$export$76ccd210b9029917 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("tbody", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("[_&tr:last-child]:border-0", className),
        ...props
    }));
$f23148f8ed856136$export$76ccd210b9029917.displayName = "TableBody";
const $f23148f8ed856136$export$1f116082bba1f9a8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("tfoot", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("border-t  font-medium [&>tr]:last:border-b-0 rounded-b-lg ", className),
        style: {
            borderBottomLeftRadius: "0.5rem",
            borderBottomRightRadius: "0.5rem"
        },
        ...props
    }));
$f23148f8ed856136$export$1f116082bba1f9a8.displayName = "TableFooter";
//bg-muted odd:bg-gray-50 even:bg-gray-100
const $f23148f8ed856136$export$b05581f4e764e162 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("tr", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", "odd:bg-white even:bg-gray-100", className),
        ...props
    }));
$f23148f8ed856136$export$b05581f4e764e162.displayName = "TableRow";
const $f23148f8ed856136$export$2f4a7be4f0dcc2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("th", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-10 px-2 text-left align-middle text-md lg:text-lg text-gray-700 font-semibold text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]", className),
        ...props
    }));
$f23148f8ed856136$export$2f4a7be4f0dcc2.displayName = "TableHead";
const $f23148f8ed856136$export$1e4baea7053fc0e3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("td", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] font-monda text-md lg:text-lg text-gray-700 truncate ...", className),
        ...props
    }));
$f23148f8ed856136$export$1e4baea7053fc0e3.displayName = "TableCell";
const $f23148f8ed856136$export$35468a455d619eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("caption", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("mt-4 text-sm text-muted-foreground", className),
        ...props
    }));
$f23148f8ed856136$export$35468a455d619eb3.displayName = "TableCaption";



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");


const $79c61f4bf1144ab1$var$PortfolioPieChart = ({ data: data, totalValue: totalValue })=>{
    const freshData = data?.data ?? [];
    var other = 0.0;
    var newData = [];
    for (const slice of freshData)if (slice.token_holdings_in_usd / totalValue * 100 < 1) other += slice.token_holdings_in_usd;
    else newData.push({
        name: slice.tokenDetails.name,
        y: parseFloat(slice.token_holdings_in_usd)
    });
    newData.push({
        name: "Other",
        y: parseFloat(other)
    });
    // Check if data is valid
    if (!newData || !Array.isArray(newData) || newData.length === 0) return /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
        children: "No data available"
    });
    const options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: "pie"
        },
        title: {
            text: undefined
        },
        tooltip: {
            pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: "pointer",
                dataLabels: {
                    enabled: true,
                    format: "<b>{point.name}</b>: {point.percentage:.1f} %"
                }
            }
        },
        series: [
            {
                name: "Share",
                colorByPoint: true,
                data: newData
            }
        ],
        credits: {
            enabled: false
        }
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
            highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($bdf625fc24abd869$exports))),
            options: options
        })
    });
};
var $79c61f4bf1144ab1$export$2e2bcd8739ae039 = $79c61f4bf1144ab1$var$PortfolioPieChart;






const $bda3f6611c7c4a37$export$9ea9f8c5d91b309d = (num, len = 0)=>{
    // num is the number in scientific notation
    // len is the desired length of the string
    var str = String(num); // convert to string
    if (str.includes("e")) {
        // check if scientific notation
        var [coef, exp] = str.split("e"); // split coefficient and exponent
        exp = Number(exp); // convert exponent to number
        if (exp < 0) {
            // negative exponent
            var zeros = -exp - 1; // number of zeros to add
            str = "0." + "0".repeat(zeros) + coef.replace(".", ""); // add zeros and remove decimal point
        } else {
            // positive exponent
            var digits = coef.replace(".", "").length; // number of digits in coefficient
            // eslint-disable-next-line no-redeclare
            var zeros = exp - digits + 1; // number of zeros to add
            str = coef.replace(".", "") + "0".repeat(zeros); // add zeros and remove decimal point
        }
    }
    return str.padStart(len, "0"); // pad with leading zeros if needed
};
const $bda3f6611c7c4a37$export$f7e4ae90baa5e54e = (value)=>{
    var str = $bda3f6611c7c4a37$export$9ea9f8c5d91b309d(value);
    // Find the index of the decimal point
    let point = str.indexOf(".");
    // Initialize a counter variable
    let count = 0;
    // Loop through the string from the index of the decimal point + 1
    for(let i = point + 2; i < str.length; i++){
        // If the current character is a zero, increment the counter
        if (str[i] == "0") count++;
        else break;
    }
    // Return the counter as the result
    return count;
};
const $bda3f6611c7c4a37$export$4e83d82c8de649f0 = (value)=>{
    let str = (value ?? 0).toString();
    // Find the index of the decimal point
    let point = str.indexOf(".");
    if (point === -1) return value;
    else {
        let result = str.slice(point + 1).replace(/^0+/, "");
        let final = result.slice(0, 4);
        return Number(final);
    }
};


function $ffe18f5bad9c0f0c$export$2e2bcd8739ae039({ tokenValueLoading: tokenValueLoading = true, totalValue: totalValue = 0, error: error, tokenValueData: tokenValueData }) {
    const topTokens = tokenValueData?.data.sort((a, b)=>parseFloat(b.token_holdings_in_usd) - parseFloat(a.token_holdings_in_usd)).slice(0, 5);
    // getting icons
    const TokenIcon = ({ tokenAddress: tokenAddress })=>{
        const { data: iconData, isLoading: isLoading, isError: isError } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
            queryKey: [
                "getCryptoIcon",
                tokenAddress
            ],
            queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/getCryptoIcon?address=${tokenAddress}`).then((res)=>res.data),
            enabled: !!tokenAddress
        });
        if (isLoading || isError || !iconData) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5446b367e373134d$export$2e2bcd8739ae039), {
            className: "h-4 w-4 lg:h-6 lg:w-6 my-2 text-primary"
        });
        return /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: `data:image/png;base64,${iconData}`,
            alt: "Token Icon",
            className: "h-4 w-4 lg:h-6 lg:w-6 my-2"
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 sm:divide-x-2 divide-onSurfaceVariant my-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "h-full flex flex-col pl-2 w-full",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-lg lg:text-xl font-semibold text-center pb-3 text-gray-700",
                                children: "Top 5 Tokens"
                            }),
                            error ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "h-96 font-monda text-5xl flex flex-col gap-4 text-center mt-6 text-red-400",
                                children: [
                                    "error",
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-gray-700 text-3xl",
                                        children: "Can't retreive value from wallet address"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-gray-700 text-3xl",
                                        children: "Refresh and try again"
                                    })
                                ]
                            }) : tokenValueLoading ? // Display the loading component for the entire table section
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                className: "flex-grow h-96"
                            }) // This will now expand to fill the flex container
                             : /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$54ec01a60f47d33d), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$f850895b287ef28e), {
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                    children: "Icon"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                    children: "Amount"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                    children: "Price"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                    children: "Value"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                    children: "Percentage"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$76ccd210b9029917), {
                                        children: topTokens && topTokens.length > 0 ? topTokens.map((token, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)(TokenIcon, {
                                                            tokenAddress: token.token_address
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                        children: token.tokenDetails.name
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                        className: "font-monda",
                                                        children: token.adjusted_token_balance < 0 ? /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                            children: [
                                                                "0.0",
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("sub", {
                                                                    children: (0, $bda3f6611c7c4a37$export$f7e4ae90baa5e54e)(Number(token.adjusted_token_balance))
                                                                }),
                                                                (0, $bda3f6611c7c4a37$export$4e83d82c8de649f0)(Number(token.adjusted_token_balance))
                                                            ]
                                                        }) : token.adjusted_token_balance.toLocaleString("en-US", {
                                                            maximumFractionDigits: 2
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                        className: "font-monda",
                                                        children: (0, $bda3f6611c7c4a37$export$f7e4ae90baa5e54e)(Number(token.tokenPriceInEth * token.latest_eth_price)) > 1 ? /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                            children: [
                                                                "$0.0",
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("sub", {
                                                                    children: (0, $bda3f6611c7c4a37$export$f7e4ae90baa5e54e)(Number(token.tokenPriceInEth * token.latest_eth_price))
                                                                }),
                                                                (0, $bda3f6611c7c4a37$export$4e83d82c8de649f0)(Number(token.tokenPriceInEth * token.latest_eth_price))
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                            children: [
                                                                "$",
                                                                (token.tokenPriceInEth * token.latest_eth_price).toFixed(3)
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                        className: "font-monda",
                                                        children: [
                                                            "$",
                                                            token.token_holdings_in_usd.toFixed(2)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                        className: "font-monda",
                                                        children: (token.token_holdings_in_usd / totalValue * 100).toFixed(2) + "%"
                                                    })
                                                ]
                                            }, index)) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("td", {
                                                colSpan: "6",
                                                children: "No data available"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "h-full flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-lg lg:text-xl font-semibold text-center pb-3 text-gray-700",
                                children: "Overview"
                            }),
                            error ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "h-96 font-monda text-5xl flex flex-col gap-4 text-center mt-6 text-red-400",
                                children: [
                                    "error",
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-gray-700 text-3xl",
                                        children: "Can't retreive values from this wallet address"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-gray-700 text-3xl",
                                        children: "Refresh and try again"
                                    })
                                ]
                            }) : tokenValueLoading ? // Display the loading component for the entire table section
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "flex h-full px-2 ",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    className: "h-full flex-grow"
                                })
                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $79c61f4bf1144ab1$export$2e2bcd8739ae039), {
                                data: tokenValueData,
                                totalValue: totalValue
                            })
                        ]
                    })
                ]
            })
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


// Missing watermark redraw as breaks pagezzzzzz

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



const $28d8a11dce05c174$var$ProfitChart = ({ data: data, name: name = "Eth" })=>{
    // Check if data is valid
    if (!data || !Array.isArray(data) || data.length === 0) return /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
        children: "No data available"
    });
    var watermark = "";
    const chartRef = (0, $exYeM.useRef)(null);
    var newStyle = document.createElement("style");
    newStyle.appendChild(document.createTextNode("@font-face {  font-family: 'Monda';  font-style: sans-serif;  font-weight: 400;  src: url('https://fonts.googleapis.com/css2?family=Monda&display=swap')  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}"));
    const dataSource = [
        {
            id: "first",
            name: name,
            data: data,
            zones: [
                {
                    value: 0,
                    color: "#f54242",
                    fillColor: {
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1
                        },
                        stops: [
                            [
                                0,
                                "rgba(255, 105, 104, 0)"
                            ],
                            [
                                1,
                                "rgba(255, 105, 104, 0.3)"
                            ]
                        ]
                    }
                },
                {
                    color: "#51bf36",
                    fillColor: {
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1
                        },
                        stops: [
                            [
                                0,
                                "rgba(34, 197, 94, 0.3)"
                            ],
                            [
                                1,
                                "rgba(34, 197, 94, 0)"
                            ]
                        ]
                    }
                }
            ]
        }
    ];
    const options = {
        exporting: {
            enabled: false,
            enableImages: true
        },
        chart: {
            type: "areaspline",
            style: {
                fontFamily: "Monda"
            },
            zoomType: "x",
            backgroundColor: "transparent",
            renderTo: undefined,
            events: {
                load: function() {
                    var height_image = 100;
                    var width_image = 152;
                    // var height_image = 48;
                    // var width_image = 20;
                    var textX = this.plotLeft + this.plotWidth * 0.5;
                    var textY = this.plotTop + this.plotHeight * 0.5;
                    var position_x = textX - width_image / 2;
                    var position_y = textY - height_image / 2;
                    watermark = this.renderer.image((0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports))), position_x, position_y, 152, 100).add();
                }
            }
        },
        title: {
            text: undefined
        },
        xAxis: {
            labels: {
                style: {
                    fontSize: "13px"
                }
            }
        },
        yAxis: {
            opposite: false,
            labels: {
                style: {
                    fontSize: "13px"
                }
            }
        },
        series: dataSource,
        credits: {
            enabled: false
        },
        rangeSelector: {
            enabled: false
        },
        navigator: {
            maskFill: "rgba(237, 212, 204, 0.35)"
        },
        plotOptions: {
            series: {
                lineWidth: 3
            }
        }
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "h-full w-full",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
            highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))),
            options: options,
            constructorType: "stockChart",
            containerProps: {
                style: {
                    width: "100%",
                    height: "100%"
                }
            },
            ref: chartRef
        })
    });
};
var $28d8a11dce05c174$export$2e2bcd8739ae039 = $28d8a11dce05c174$var$ProfitChart;




const $88f023d6c3eb184a$var$activeClassName = "border-b-2 border-primary text-white bg-primary";
const $88f023d6c3eb184a$var$notActiveClassName = "text-black hover:text-primary";
function $88f023d6c3eb184a$export$2e2bcd8739ae039({ balanceLoading: balanceLoading, balanceData: balanceData, error: error }) {
    const [showCumulative, setShowCumulative] = (0, $exYeM.useState)(true);
    const formattedBalanceData = balanceData?.map((entry)=>({
            x: new Date(entry.time).getTime(),
            y: showCumulative ? entry.cumulative_balance_in_eth : entry.balance_change_in_eth
        })) || [];
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "flex justify-center items-center py-3",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$b2539bed5023c21c), {
                        defaultValue: "tab1",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $125c9c6acc39e22a$export$9712d22edc0d78c1), {
                            className: "text-sm font-monda",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                    onClick: ()=>{
                                        setShowCumulative(false);
                                    },
                                    className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(!showCumulative ? $88f023d6c3eb184a$var$activeClassName : $88f023d6c3eb184a$var$notActiveClassName, "text-sm md:text-base"),
                                    children: "Balance Change"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                    onClick: ()=>{
                                        setShowCumulative(true);
                                    },
                                    className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(showCumulative ? $88f023d6c3eb184a$var$activeClassName : $88f023d6c3eb184a$var$notActiveClassName, "text-sm md:text-base"),
                                    children: "Cumulative Balance"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                    children: error ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "h-64 font-monda text-5xl flex flex-col gap-4 text-center mt-6 text-red-400",
                        children: [
                            "error",
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "text-gray-700 text-3xl",
                                children: "Can't retrieve values from this wallet address"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "text-gray-700 text-3xl",
                                children: "Refresh and try again"
                            })
                        ]
                    }) : balanceLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                        className: "flex-grow h-64"
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $28d8a11dce05c174$export$2e2bcd8739ae039), {
                        data: formattedBalanceData
                    })
                })
            ]
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $133f3292e600dc93$var$ChevronLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z",
        clipRule: "evenodd"
    }));
}
const $133f3292e600dc93$var$ForwardRef = $exYeM.forwardRef($133f3292e600dc93$var$ChevronLeftIcon);
var $133f3292e600dc93$export$2e2bcd8739ae039 = $133f3292e600dc93$var$ForwardRef;


const $7c10522a8a55d5a2$var$getButtonVariantClass = (variant, size)=>{
    let baseClass = "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";
    let variantClass = "";
    let sizeClass = "";
    switch(variant){
        case "destructive":
            variantClass = "bg-destructive text-destructive-foreground hover:bg-destructive/90";
            break;
        case "outline":
            variantClass = "border border-input bg-background hover:bg-accent hover:text-accent-foreground";
            break;
        case "secondary":
            variantClass = "bg-secondary text-secondary-foreground hover:bg-secondary/80";
            break;
        case "ghost":
            variantClass = "hover:bg-accent hover:text-accent-foreground";
            break;
        case "link":
            variantClass = "text-primary underline-offset-4 hover:underline";
            break;
        default:
            variantClass = "bg-primary text-primary-foreground hover:bg-primary/90";
    }
    switch(size){
        case "sm":
            sizeClass = "h-9 rounded-md px-3";
            break;
        case "lg":
            sizeClass = "h-11 rounded-md px-8";
            break;
        case "icon":
            sizeClass = "h-10 w-10";
            break;
        default:
            sizeClass = "h-10 px-4 py-2";
    }
    return `${baseClass} ${variantClass} ${sizeClass}`;
};
const $7c10522a8a55d5a2$export$68f5e1453c188a82 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsx)("nav", {
        role: "navigation",
        "aria-label": "pagination",
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("mx-auto flex w-full justify-center", className),
        ...props
    });
const $7c10522a8a55d5a2$export$e3c2252a821bad58 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex flex-row items-center gap-1", className),
        ...props
    }));
$7c10522a8a55d5a2$export$e3c2252a821bad58.displayName = "PaginationContent";
const $7c10522a8a55d5a2$export$c82a077939f0464b = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("list-none", className),
        ...props
    }));
$7c10522a8a55d5a2$export$c82a077939f0464b.displayName = "PaginationItem";
const $7c10522a8a55d5a2$export$389c2523d2fb7ac8 = ({ className: className, isActive: isActive, size: size = "icon", href: href, ...props })=>{
    const Component = href ? "a" : "button";
    return /*#__PURE__*/ (0, $aSiaI.jsx)($7c10522a8a55d5a2$export$c82a077939f0464b, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)(Component, {
            "aria-current": isActive && href ? "page" : undefined,
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)($7c10522a8a55d5a2$var$getButtonVariantClass(isActive ? "outline" : "ghost", size), className),
            href: href,
            ...props
        })
    });
};
$7c10522a8a55d5a2$export$389c2523d2fb7ac8.displayName = "PaginationLink";
const $7c10522a8a55d5a2$export$c38bddd65ea050e7 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsxs)($7c10522a8a55d5a2$export$389c2523d2fb7ac8, {
        "aria-label": "Go to previous page",
        size: "default",
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("gap-1 pl-2.5", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $133f3292e600dc93$export$2e2bcd8739ae039), {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "Previous"
            })
        ]
    });
const $7c10522a8a55d5a2$export$ef9c8bfc54489a24 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsxs)($7c10522a8a55d5a2$export$389c2523d2fb7ac8, {
        "aria-label": "Go to next page",
        size: "default",
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("gap-1 pr-2.5", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "Next"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e5ea8ee4dc7caabc$export$2e2bcd8739ae039), {
                className: "h-4 w-4"
            })
        ]
    });
const $7c10522a8a55d5a2$export$bf296fe40f0f4032 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
        "aria-hidden": true,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex h-9 w-9 items-center justify-center", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2ee5a7f7ec060e3f$export$2e2bcd8739ae039), {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "sr-only",
                children: "More pages"
            })
        ]
    });
var $7c10522a8a55d5a2$export$2e2bcd8739ae039 = $7c10522a8a55d5a2$export$68f5e1453c188a82;



var $exYeM = parcelRequire("exYeM");

function $bb6e8040c26833dc$export$2e2bcd8739ae039({ tokenValueLoading: tokenValueLoading, tokenValueError: tokenValueError, tokenValueData: tokenValueData }) {
    const [currentPage, setCurrentPage] = (0, $exYeM.useState)(1);
    const itemsPerPage = 10;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = tokenValueData?.data?.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = tokenValueData?.data?.length || 0;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const pageNumbers = [];
    for(let i = 1; i <= Math.ceil(tokenValueData?.data?.length / itemsPerPage); i++)pageNumbers.push(i);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
        className: "w-full flex flex-col min-h-[400px] md:min-h-[500px]",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                    className: "text-center",
                    children: "Total Token Value"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                className: "flex flex-col flex-grow overflow-auto",
                children: [
                    tokenValueLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                        className: "flex-grow"
                    }) : tokenValueError ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "h-96 font-monda text-5xl flex flex-col gap-4 text-center mt-6 text-red-400",
                        children: [
                            "error",
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "text-gray-700 text-3xl",
                                children: "Can't retreive value from wallet address"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "text-gray-700 text-3xl",
                                children: "Refresh and try again"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$54ec01a60f47d33d), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$f850895b287ef28e), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Token Address"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Token Name"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Symbol"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Decimals"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Total Supply"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Adjusted Token Balance"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Token Price"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Total Value in ETH"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                                children: "Total Value in USD"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$76ccd210b9029917), {
                                    children: currentItems?.map((token, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    children: token.token_address
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    children: token.tokenDetails.name
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    children: token.tokenDetails.symbol
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    children: token.tokenDetails.decimals
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    children: token.tokenDetails.totalSupply
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    className: "font-monda",
                                                    children: token.adjusted_token_balance < 0 ? /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                        children: [
                                                            "0.0",
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("sub", {
                                                                children: (0, $bda3f6611c7c4a37$export$f7e4ae90baa5e54e)(Number(token.adjusted_token_balance))
                                                            }),
                                                            (0, $bda3f6611c7c4a37$export$4e83d82c8de649f0)(Number(token.adjusted_token_balance))
                                                        ]
                                                    }) : token.adjusted_token_balance.toLocaleString("en-US", {
                                                        maximumFractionDigits: 2
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    className: "font-monda",
                                                    children: (0, $bda3f6611c7c4a37$export$f7e4ae90baa5e54e)(Number(token.tokenPriceInEth * token.latest_eth_price)) > 1 ? /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                        children: [
                                                            "$0.0",
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("sub", {
                                                                children: (0, $bda3f6611c7c4a37$export$f7e4ae90baa5e54e)(Number(token.tokenPriceInEth * token.latest_eth_price))
                                                            }),
                                                            (0, $bda3f6611c7c4a37$export$4e83d82c8de649f0)(Number(token.tokenPriceInEth * token.latest_eth_price))
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                        children: [
                                                            "$",
                                                            (token.tokenPriceInEth * token.latest_eth_price).toFixed(3)
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    children: token.token_holdings_in_eth.toFixed(2)
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                                    children: [
                                                        "$",
                                                        token.token_holdings_in_usd.toFixed(2)
                                                    ]
                                                }),
                                                " "
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $7c10522a8a55d5a2$export$68f5e1453c188a82), {
                        className: "pt-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$c38bddd65ea050e7), {
                                onClick: ()=>setCurrentPage(currentPage - 1),
                                disabled: currentPage <= 1
                            }),
                            pageNumbers.map((number)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$389c2523d2fb7ac8), {
                                    onClick: ()=>setCurrentPage(number),
                                    isActive: currentPage === number,
                                    children: number
                                }, number)),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$ef9c8bfc54489a24), {
                                onClick: ()=>setCurrentPage(currentPage + 1),
                                disabled: currentPage >= totalPages
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




function $4200c59e389d23e6$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $4200c59e389d23e6$export$4dc97199c2eb8c4c() {
    const address = new URLSearchParams(location.search).get("address");
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "getEthCurrent",
            address
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/getEthCurrent?address=${address}`, {
                headers: {
                    Authorization: `Bearer ${$4200c59e389d23e6$var$getToken()}`
                }
            });
            return data.data;
        }
    });
    return {
        isLoading: isLoading,
        isError: isError,
        data: data,
        error: error
    };
}
function $4200c59e389d23e6$export$c1f61e102f794d60() {
    const address = new URLSearchParams(location.search).get("address");
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "totalTokenValue",
            address
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/totalTokenValue?address=${address}`, {
                headers: {
                    Authorization: `Bearer ${$4200c59e389d23e6$var$getToken()}`
                }
            });
            return data;
        }
    });
    return {
        isLoading: isLoading,
        isError: isError,
        data: data,
        error: error
    };
}
function $4200c59e389d23e6$export$863b26b695b153ab() {
    const address = new URLSearchParams(location.search).get("address");
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "accountBalanceOverTime",
            address
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/accountBalanceTS?address=${address}`, {
                headers: {
                    Authorization: `Bearer ${$4200c59e389d23e6$var$getToken()}`
                }
            });
            return data.data;
        }
    });
    return {
        isLoading: isLoading,
        isError: isError,
        data: data,
        error: error
    };
}



var $exYeM = parcelRequire("exYeM");
function $4a9ee1a3aea245de$var$DisplayPortfolio() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    (0, $exYeM.useEffect)(()=>{
        if (localStorage.getItem("user") === null) navigate("/Footprint");
    }, []);
    // Use the useNavigate hook
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const address = new URLSearchParams(location.search).get("address");
    if (!address) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: "Please enter an address to view portfolio."
    });
    const { isLoading: ethLoading, isError: ethError, data: ethbalance } = (0, $4200c59e389d23e6$export$4dc97199c2eb8c4c)();
    //token
    const { isLoading: tokenValueLoading, isError: tokenValueError, data: tokenValueData, error: tokenValueErrorDetails } = (0, $4200c59e389d23e6$export$c1f61e102f794d60)();
    const topTokens = tokenValueData?.data.sort((a, b)=>parseFloat(b.token_holdings_in_usd) - parseFloat(a.token_holdings_in_usd)).slice(0, 5);
    const { isLoading: balanceLoading, data: balanceData, isError: balanceError } = (0, $4200c59e389d23e6$export$863b26b695b153ab)();
    const totalValue = topTokens && Array.isArray(topTokens) ? topTokens.reduce((acc, token)=>acc + parseFloat(token.token_holdings_in_usd), 0) : 0;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col gap-4 font-roboto p-2 px-4 pb-8",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c9ec2da6d7c9e112$export$2e2bcd8739ae039), {
                        value: ethbalance?.balanceEth,
                        loading: ethLoading,
                        error: ethError,
                        name: "Eth Value",
                        suffix: "ETH",
                        decimals: 3
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c9ec2da6d7c9e112$export$2e2bcd8739ae039), {
                        value: totalValue,
                        loading: tokenValueLoading,
                        error: tokenValueError,
                        name: "Token Value",
                        suffix: "USD",
                        decimals: 2,
                        prefix: "$"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c9ec2da6d7c9e112$export$2e2bcd8739ae039), {
                        value: parseFloat(ethbalance?.balanceEth || 0) * parseFloat(tokenValueData?.data[0]?.latest_eth_price) + (totalValue || 0),
                        loading: ethLoading || tokenValueLoading,
                        error: ethError || tokenValueError,
                        name: "Total Value",
                        suffix: "USD",
                        decimals: 2,
                        prefix: "$"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c9ec2da6d7c9e112$export$2e2bcd8739ae039), {
                        value: tokenValueData?.data[0]?.latest_eth_price,
                        loading: tokenValueLoading,
                        error: tokenValueError,
                        name: "Current Ethereum Price",
                        suffix: "USD",
                        decimals: 2,
                        prefix: "$"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid grid-cols-1 w-full gap-6",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ffe18f5bad9c0f0c$export$2e2bcd8739ae039), {
                        tokenValueLoading: tokenValueLoading,
                        totalValue: totalValue,
                        error: tokenValueError,
                        tokenValueData: tokenValueData
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $88f023d6c3eb184a$export$2e2bcd8739ae039), {
                        balanceLoading: balanceLoading,
                        balanceData: balanceData,
                        error: balanceError
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "grid grid-cols-1 w-full gap-6",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bb6e8040c26833dc$export$2e2bcd8739ae039), {
                    tokenValueLoading: tokenValueLoading,
                    tokenValueError: tokenValueError,
                    tokenValueData: tokenValueData,
                    tokenValueErrorDetails: tokenValueErrorDetails
                })
            })
        ]
    });
}
var $4a9ee1a3aea245de$export$2e2bcd8739ae039 = $4a9ee1a3aea245de$var$DisplayPortfolio;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");





function $3723a6995b786148$export$2e2bcd8739ae039() {
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const address = new URLSearchParams(location.search).get("address");
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "getTransactions",
            address
        ],
        queryFn: async ()=>{
            const data = (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/getTxns?address=${address}`, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
            return data;
        }
    });
    return {
        isLoading: isLoading,
        isError: isError,
        data: data,
        error: error
    };
}




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $f3e94f1ced736932$var$ChevronUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M11.47 7.72a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5z",
        clipRule: "evenodd"
    }));
}
const $f3e94f1ced736932$var$ForwardRef = $exYeM.forwardRef($f3e94f1ced736932$var$ChevronUpIcon);
var $f3e94f1ced736932$export$2e2bcd8739ae039 = $f3e94f1ced736932$var$ForwardRef;


/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ 
var $exYeM = parcelRequire("exYeM");
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $829253db717f8f1b$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $829253db717f8f1b$export$8793edee2d425525() {
//
}
function $829253db717f8f1b$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $829253db717f8f1b$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $829253db717f8f1b$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $829253db717f8f1b$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === "number");
}
function $829253db717f8f1b$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $829253db717f8f1b$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $829253db717f8f1b$export$b1f82222dc43996c(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function $829253db717f8f1b$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? accessorKey.replace(".", "_") : undefined) != null ? _ref : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes(".")) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split(".")){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "column.getFlatColumns")),
        getLeafColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "column.getLeafColumns"))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to uknown, because we know more than the compiler here.
    return column;
}
const $829253db717f8f1b$var$debug = "debugHeaders";
//
function $829253db717f8f1b$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const $829253db717f8f1b$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getHeaderGroups"));
        table.getCenterHeaderGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, leafColumns, table, "center");
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getCenterHeaderGroups"));
        table.getLeftHeaderGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, "left");
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeftHeaderGroups"));
        table.getRightHeaderGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, "right");
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getRightHeaderGroups"));
        // Footer Groups
        table.getFooterGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getFooterGroups"));
        table.getLeftFooterGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeftFooterGroups"));
        table.getCenterFooterGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getCenterFooterGroups"));
        table.getRightFooterGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getRightFooterGroups"));
        // Flat Headers
        table.getFlatHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getFlatHeaders"));
        table.getLeftFlatHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeftFlatHeaders"));
        table.getCenterFlatHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getCenterFlatHeaders"));
        table.getRightFlatHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getRightFlatHeaders"));
        // Leaf Headers
        table.getCenterLeafHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getCenterLeafHeaders"));
        table.getLeftLeafHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeftLeafHeaders"));
        table.getRightLeafHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getRightLeafHeaders"));
        table.getLeafHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeafHeaders"));
    }
};
function $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join("_"),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $829253db717f8f1b$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join("_"),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$829253db717f8f1b$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
//
//
const $829253db717f8f1b$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $829253db717f8f1b$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $829253db717f8f1b$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $829253db717f8f1b$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $829253db717f8f1b$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: "onEnd",
            columnResizeDirection: "ltr",
            onColumnSizingChange: $829253db717f8f1b$export$2b5605d8069324bd("columnSizing", table),
            onColumnSizingInfoChange: $829253db717f8f1b$export$2b5605d8069324bd("columnSizingInfo", table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $829253db717f8f1b$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $829253db717f8f1b$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $829253db717f8f1b$export$2f660993f4eb1f29.maxSize);
        };
        column.getStart = $829253db717f8f1b$export$7c73462e0d25e514((position)=>[
                position,
                $829253db717f8f1b$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getStart"));
        column.getAfter = $829253db717f8f1b$export$7c73462e0d25e514((position)=>[
                position,
                $829253db717f8f1b$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getAfter"));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if ($829253db717f8f1b$var$isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = $829253db717f8f1b$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== "number") return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === "rtl" ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset: deltaOffset,
                            deltaPercentage: deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === "onChange" || eventType === "end") table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset("move", clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset("end", clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = _contextDocument || typeof document !== "undefined" ? document : null;
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener("mousemove", mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener("mouseup", mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener("touchmove", touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener("touchend", touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = $829253db717f8f1b$export$4927b5943c7c0b4() ? {
                    passive: false
                } : false;
                if ($829253db717f8f1b$var$isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize: startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart: columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? $829253db717f8f1b$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $829253db717f8f1b$var$getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let $829253db717f8f1b$var$passiveSupported = null;
function $829253db717f8f1b$export$4927b5943c7c0b4() {
    if (typeof $829253db717f8f1b$var$passiveSupported === "boolean") return $829253db717f8f1b$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener("test", noop, options);
        window.removeEventListener("test", noop);
    } catch (err) {
        supported = false;
    }
    $829253db717f8f1b$var$passiveSupported = supported;
    return $829253db717f8f1b$var$passiveSupported;
}
function $829253db717f8f1b$var$isTouchStartEvent(e) {
    return e.type === "touchstart";
}
//
const $829253db717f8f1b$export$c9bad30efcce6e0c = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $829253db717f8f1b$export$2b5605d8069324bd("expanded", table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === "boolean") return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split(".");
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
const $829253db717f8f1b$var$includesString = (row, columnId, filterValue)=>{
    var _row$getValue;
    const search = filterValue.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
$829253db717f8f1b$var$includesString.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
$829253db717f8f1b$var$includesStringSensitive.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$829253db717f8f1b$var$equalsString.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$829253db717f8f1b$var$arrIncludes.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val) || !(val != null && val.length);
const $829253db717f8f1b$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$829253db717f8f1b$var$arrIncludesAll.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val) || !(val != null && val.length);
const $829253db717f8f1b$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$829253db717f8f1b$var$arrIncludesSome.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val) || !(val != null && val.length);
const $829253db717f8f1b$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$829253db717f8f1b$var$equals.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$829253db717f8f1b$var$weakEquals.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$829253db717f8f1b$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$829253db717f8f1b$var$inNumberRange.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val) || $829253db717f8f1b$var$testFalsey(val[0]) && $829253db717f8f1b$var$testFalsey(val[1]);
// Export
const $829253db717f8f1b$export$6ad8312e296ec316 = {
    includesString: $829253db717f8f1b$var$includesString,
    includesStringSensitive: $829253db717f8f1b$var$includesStringSensitive,
    equalsString: $829253db717f8f1b$var$equalsString,
    arrIncludes: $829253db717f8f1b$var$arrIncludes,
    arrIncludesAll: $829253db717f8f1b$var$arrIncludesAll,
    arrIncludesSome: $829253db717f8f1b$var$arrIncludesSome,
    equals: $829253db717f8f1b$var$equals,
    weakEquals: $829253db717f8f1b$var$weakEquals,
    inNumberRange: $829253db717f8f1b$var$inNumberRange
};
// Utils
function $829253db717f8f1b$var$testFalsey(val) {
    return val === undefined || val === null || val === "";
}
//
const $829253db717f8f1b$export$92a576f896a9bf72 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            globalFilter: undefined,
            // filtersProgress: 1,
            // facetProgress: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $829253db717f8f1b$export$2b5605d8069324bd("columnFilters", table),
            onGlobalFilterChange: $829253db717f8f1b$export$2b5605d8069324bd("globalFilter", table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100,
            globalFilterFn: "auto",
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === "string" || typeof value === "number";
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return $829253db717f8f1b$export$6ad8312e296ec316.includesString;
            if (typeof value === "number") return $829253db717f8f1b$export$6ad8312e296ec316.inNumberRange;
            if (typeof value === "boolean") return $829253db717f8f1b$export$6ad8312e296ec316.equals;
            if (value !== null && typeof value === "object") return $829253db717f8f1b$export$6ad8312e296ec316.equals;
            if (Array.isArray(value)) return $829253db717f8f1b$export$6ad8312e296ec316.arrIncludes;
            return $829253db717f8f1b$export$6ad8312e296ec316.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return $829253db717f8f1b$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === "auto" ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $829253db717f8f1b$export$6ad8312e296ec316[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena2, _table$options$enable3, _table$options$enable4, _table$options$getCol;
            return ((_column$columnDef$ena2 = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena2 : true) && ((_table$options$enable3 = table.options.enableGlobalFilter) != null ? _table$options$enable3 : true) && ((_table$options$enable4 = table.options.enableFilters) != null ? _table$options$enable4 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousfilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = $829253db717f8f1b$export$7f095f455ad5af3f(value, previousfilter ? previousfilter.value : undefined);
                //
                if ($829253db717f8f1b$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousfilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    // () => [column.getFacetedRowModel()],
    // facetedRowModel => getRowModelMinMaxValues(facetedRowModel, column.id),
    },
    createRow: (row, table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return $829253db717f8f1b$export$6ad8312e296ec316.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter3, _table$options$filter4;
            const { globalFilterFn: globalFilterFn } = table.options;
            return $829253db717f8f1b$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter3 = (_table$options$filter4 = table.options.filterFns) == null ? void 0 : _table$options$filter4[globalFilterFn]) != null ? _table$options$filter3 : $829253db717f8f1b$export$6ad8312e296ec316[globalFilterFn];
        };
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = $829253db717f8f1b$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if ($829253db717f8f1b$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__");
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__");
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__");
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
function $829253db717f8f1b$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
const $829253db717f8f1b$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === "number" ? nextValue : 0);
    }, 0);
};
const $829253db717f8f1b$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $829253db717f8f1b$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $829253db717f8f1b$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $829253db717f8f1b$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $829253db717f8f1b$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$829253db717f8f1b$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $829253db717f8f1b$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $829253db717f8f1b$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $829253db717f8f1b$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $829253db717f8f1b$export$3aa4339120b8b25b = {
    sum: $829253db717f8f1b$var$sum,
    min: $829253db717f8f1b$var$min,
    max: $829253db717f8f1b$var$max,
    extent: $829253db717f8f1b$var$extent,
    mean: $829253db717f8f1b$var$mean,
    median: $829253db717f8f1b$var$median,
    unique: $829253db717f8f1b$var$unique,
    uniqueCount: $829253db717f8f1b$var$uniqueCount,
    count: $829253db717f8f1b$var$count
};
//
const $829253db717f8f1b$export$3885c0af90651e94 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $829253db717f8f1b$export$2b5605d8069324bd("grouping", table),
            groupedColumnMode: "reorder"
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _ref, _ref2, _ref3, _column$columnDef$ena;
            return (_ref = (_ref2 = (_ref3 = (_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) != null ? _ref3 : table.options.enableGrouping) != null ? _ref2 : true) != null ? _ref : !!column.accessorFn;
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "number") return $829253db717f8f1b$export$3aa4339120b8b25b.sum;
            if (Object.prototype.toString.call(value) === "[object Date]") return $829253db717f8f1b$export$3aa4339120b8b25b.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return $829253db717f8f1b$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === "auto" ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $829253db717f8f1b$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function $829253db717f8f1b$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === "remove") return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $829253db717f8f1b$export$549aff5da5ccfd97 = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $829253db717f8f1b$export$2b5605d8069324bd("columnOrder", table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = $829253db717f8f1b$export$7c73462e0d25e514((position)=>[
                $829253db717f8f1b$export$1d7c103713892a11(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getIndex"));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = $829253db717f8f1b$export$1d7c103713892a11(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = $829253db717f8f1b$export$1d7c103713892a11(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return $829253db717f8f1b$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
            }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "_getOrderColumnsFn"));
    }
};
//
const $829253db717f8f1b$var$defaultPageIndex = 0;
const $829253db717f8f1b$var$defaultPageSize = 10;
const $829253db717f8f1b$var$getDefaultPaginationState = ()=>({
        pageIndex: $829253db717f8f1b$var$defaultPageIndex,
        pageSize: $829253db717f8f1b$var$defaultPageSize
    });
const $829253db717f8f1b$export$68f5e1453c188a82 = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$829253db717f8f1b$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $829253db717f8f1b$export$2b5605d8069324bd("pagination", table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = $829253db717f8f1b$export$7f095f455ad5af3f(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? $829253db717f8f1b$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $829253db717f8f1b$var$getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = $829253db717f8f1b$export$7f095f455ad5af3f(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex: pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? $829253db717f8f1b$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : $829253db717f8f1b$var$defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? $829253db717f8f1b$var$defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : $829253db717f8f1b$var$defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, $829253db717f8f1b$export$7f095f455ad5af3f(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex: pageIndex,
                    pageSize: pageSize
                };
            });
        };
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = $829253db717f8f1b$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === "number") newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getPageOptions"));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex: pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getPrePaginationRowModel().rows.length / table.getState().pagination.pageSize);
        };
    }
};
//
const $829253db717f8f1b$var$getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const $829253db717f8f1b$var$getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const $829253db717f8f1b$export$5289f180505593b3 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $829253db717f8f1b$var$getDefaultColumnPinningState(),
            rowPinning: $829253db717f8f1b$var$getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $829253db717f8f1b$export$2b5605d8069324bd("columnPinning", table),
            onRowPinningChange: $829253db717f8f1b$export$2b5605d8069324bd("rowPinning", table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === "right") {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === "left") {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left: left, right: right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? "left" : isRight ? "right" : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref2)=>{
                let { id: id } = _ref2;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref3)=>{
                let { id: id } = _ref3;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === "bottom") {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === "top") {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref4;
            const { enableRowPinning: enableRowPinning, enablePinning: enablePinning } = table.options;
            if (typeof enableRowPinning === "function") return enableRowPinning(row);
            return (_ref4 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref4 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top: top, bottom: bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? "top" : isBottom ? "bottom" : false;
        };
        row.getPinnedIndex = ()=>{
            var _table$_getPinnedRows, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_table$_getPinnedRows = table._getPinnedRows(position)) == null ? void 0 : _table$_getPinnedRows.map((_ref5)=>{
                let { id: id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
        row.getCenterVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getCenterVisibleCells"));
        row.getLeftVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                , 
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: "left"
                }));
            return cells;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getLeftVisibleCells"));
        row.getRightVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: "right"
                }));
            return cells;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getRightVisibleCells"));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? $829253db717f8f1b$var$getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $829253db717f8f1b$var$getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getLeftLeafColumns"));
        table.getRightLeafColumns = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getRightLeafColumns"));
        table.getCenterLeafColumns = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getCenterLeafColumns"));
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState2;
            return table.setRowPinning(defaultState ? $829253db717f8f1b$var$getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState2 = table.initialState) == null ? void 0 : _table$initialState2.rowPinning) != null ? _table$initialState$r : $829253db717f8f1b$var$getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio2;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio2 = pinningState[position]) == null ? void 0 : _pinningState$positio2.length);
        };
        table._getPinnedRows = $829253db717f8f1b$export$7c73462e0d25e514((position)=>[
                table.getRowModel().rows,
                table.getState().rowPinning[position],
                position
            ], (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position: position
                }));
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "_getPinnedRows"));
        table.getTopRows = ()=>table._getPinnedRows("top");
        table.getBottomRows = ()=>table._getPinnedRows("bottom");
        table.getCenterRows = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getCenterRows"));
    }
};
//
const $829253db717f8f1b$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $829253db717f8f1b$export$2b5605d8069324bd("rowSelection", table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    $829253db717f8f1b$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $829253db717f8f1b$export$f150e72530556b0b(table, rowModel);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getSelectedRowModel"));
        table.getFilteredSelectedRowModel = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $829253db717f8f1b$export$f150e72530556b0b(table, rowModel);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getFilteredSelectedRowModel"));
        table.getGroupedSelectedRowModel = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $829253db717f8f1b$export$f150e72530556b0b(table, rowModel);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getGroupedSelectedRowModel"));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection: rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection: rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== "undefined" ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                $829253db717f8f1b$var$mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $829253db717f8f1b$export$710e11cf672b86c(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $829253db717f8f1b$export$8f4c46e5d7907334(row, rowSelection) === "some";
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $829253db717f8f1b$export$8f4c46e5d7907334(row, rowSelection) === "all";
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === "function") return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === "function") return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === "function") return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const $829253db717f8f1b$var$mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$829253db717f8f1b$var$mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function $829253db717f8f1b$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $829253db717f8f1b$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $829253db717f8f1b$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $829253db717f8f1b$export$8f4c46e5d7907334(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if ($829253db717f8f1b$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = $829253db717f8f1b$export$8f4c46e5d7907334(subRow, selection);
            if (subRowChildrenSelected === "all") someSelected = true;
            else if (subRowChildrenSelected === "some") {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? "all" : someSelected ? "some" : false;
}
const $829253db717f8f1b$export$8758689f50bddb9f = /([0-9]+)/gm;
const $829253db717f8f1b$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareAlphanumeric($829253db717f8f1b$var$toString(rowA.getValue(columnId)).toLowerCase(), $829253db717f8f1b$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $829253db717f8f1b$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareAlphanumeric($829253db717f8f1b$var$toString(rowA.getValue(columnId)), $829253db717f8f1b$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $829253db717f8f1b$var$text = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareBasic($829253db717f8f1b$var$toString(rowA.getValue(columnId)).toLowerCase(), $829253db717f8f1b$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $829253db717f8f1b$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareBasic($829253db717f8f1b$var$toString(rowA.getValue(columnId)), $829253db717f8f1b$var$toString(rowB.getValue(columnId)));
};
const $829253db717f8f1b$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $829253db717f8f1b$var$basic = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $829253db717f8f1b$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $829253db717f8f1b$var$toString(a) {
    if (typeof a === "number") {
        if (isNaN(a) || a === Infinity || a === -Infinity) return "";
        return String(a);
    }
    if (typeof a === "string") return a;
    return "";
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $829253db717f8f1b$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($829253db717f8f1b$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($829253db717f8f1b$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $829253db717f8f1b$export$47423a4cd813a815 = {
    alphanumeric: $829253db717f8f1b$var$alphanumeric,
    alphanumericCaseSensitive: $829253db717f8f1b$var$alphanumericCaseSensitive,
    text: $829253db717f8f1b$var$text,
    textCaseSensitive: $829253db717f8f1b$var$textCaseSensitive,
    datetime: $829253db717f8f1b$var$datetime,
    basic: $829253db717f8f1b$var$basic
};
//
const $829253db717f8f1b$export$9707dace2bc98438 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: "auto",
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $829253db717f8f1b$export$2b5605d8069324bd("sorting", table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === "[object Date]") return $829253db717f8f1b$export$47423a4cd813a815.datetime;
                if (typeof value === "string") {
                    isString = true;
                    if (value.split($829253db717f8f1b$export$8758689f50bddb9f).length > 1) return $829253db717f8f1b$export$47423a4cd813a815.alphanumeric;
                }
            }
            if (isString) return $829253db717f8f1b$export$47423a4cd813a815.text;
            return $829253db717f8f1b$export$47423a4cd813a815.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return "asc";
            return "desc";
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return $829253db717f8f1b$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === "auto" ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $829253db717f8f1b$export$47423a4cd813a815[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== "undefined" && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = "toggle";
                    else sortAction = "add";
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = "replace";
                    else if (existingSorting) sortAction = "toggle";
                    else sortAction = "replace";
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === "toggle") {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = "remove";
                    }
                }
                if (sortAction === "add") {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === "toggle") // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === "remove") newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === "desc";
            return sortDescFirst ? "desc" : "asc";
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === "desc" ? "asc" : "desc";
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? "desc" : "asc";
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
//
const $829253db717f8f1b$export$5afe92775e3e701d = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $829253db717f8f1b$export$2b5605d8069324bd("columnVisibility", table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            return (_table$getState$colum = (_table$getState$colum2 = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum2[column.id]) != null ? _table$getState$colum : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "_getAllVisibleCells"));
        row.getVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getVisibleCells"));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join("_")
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod("getVisibleFlatColumns", ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod("getVisibleLeafColumns", ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod("getLeftVisibleLeafColumns", ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod("getRightVisibleLeafColumns", ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod("getCenterVisibleLeafColumns", ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function $829253db717f8f1b$export$1d7c103713892a11(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === "center" ? table.getCenterVisibleLeafColumns() : position === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
const $829253db717f8f1b$var$features = [
    $829253db717f8f1b$export$79b704688b15c0f4,
    $829253db717f8f1b$export$5afe92775e3e701d,
    $829253db717f8f1b$export$549aff5da5ccfd97,
    $829253db717f8f1b$export$5289f180505593b3,
    $829253db717f8f1b$export$92a576f896a9bf72,
    $829253db717f8f1b$export$9707dace2bc98438,
    $829253db717f8f1b$export$3885c0af90651e94,
    $829253db717f8f1b$export$c9bad30efcce6e0c,
    $829253db717f8f1b$export$68f5e1453c188a82,
    $829253db717f8f1b$export$e8905133e7bf3121,
    $829253db717f8f1b$export$9916c85814812d4a
];
//
function $829253db717f8f1b$export$33bbb3ec7652e187(options) {
    var _options$initialState;
    if (options.debugAll || options.debugTable) console.info("Creating Table Instance...");
    let table = {
        _features: $829253db717f8f1b$var$features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: $829253db717f8f1b$var$features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $829253db717f8f1b$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join(".") : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "_getDefaultColumnDef")),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $829253db717f8f1b$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "getAllColumns")),
        getAllFlatColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "getAllFlatColumns")),
        _getAllFlatColumnsById: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "getAllFlatColumnsById")),
        getAllLeafColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "getAllLeafColumns")),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function $829253db717f8f1b$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugCells", "cell.getContext"))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
const $829253db717f8f1b$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$829253db717f8f1b$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $829253db717f8f1b$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getAllCells")),
        _getAllCellsByColumnId: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getAllCellsByColumnId"))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
// type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $829253db717f8f1b$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === "function" ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
function $829253db717f8f1b$export$32d0bc001e828250() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $829253db717f8f1b$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getRowModel", ()=>table._autoResetPageIndex()));
}
function $829253db717f8f1b$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $829253db717f8f1b$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $829253db717f8f1b$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $829253db717f8f1b$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $829253db717f8f1b$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $829253db717f8f1b$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $829253db717f8f1b$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $829253db717f8f1b$export$26f255a2756e1638() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = columnFilters.map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push("__global__");
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $829253db717f8f1b$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getFilteredRowModel", ()=>table._autoResetPageIndex()));
}
function $829253db717f8f1b$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? "__global__" : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $829253db717f8f1b$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getFacetedRowModel"));
}
function $829253db717f8f1b$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", `getFacetedUniqueValues_${columnId}`));
}
function $829253db717f8f1b$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            var _facetedRowModel$flat;
            if (!facetedRowModel) return undefined;
            const firstValue = (_facetedRowModel$flat = facetedRowModel.flatRows[0]) == null ? void 0 : _facetedRowModel$flat.getUniqueValues(columnId);
            if (typeof firstValue === "undefined") return undefined;
            let facetedMinMaxValues = [
                firstValue,
                firstValue
            ];
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (value < facetedMinMaxValues[0]) facetedMinMaxValues[0] = value;
                    else if (value > facetedMinMaxValues[1]) facetedMinMaxValues[1] = value;
                }
            }
            return facetedMinMaxValues;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getFacetedMinMaxValues"));
}
function $829253db717f8f1b$export$4ca93ca80835d8c1() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (columnInfo.sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) sortInt = aUndefined && bUndefined ? 0 : aUndefined ? columnInfo.sortUndefined : -columnInfo.sortUndefined;
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getSortedRowModel", ()=>table._autoResetPageIndex()));
}
function $829253db717f8f1b$export$2b7f4b57ce71b81() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) return rowModel;
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $829253db717f8f1b$var$groupBy(rows, columnId);
                // Peform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $829253db717f8f1b$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $829253db717f8f1b$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getGroupedRowModel", ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function $829253db717f8f1b$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $829253db717f8f1b$export$53cfec7b1b8d1fcd() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $829253db717f8f1b$export$1293f966cdb38633(rowModel);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getExpandedRowModel"));
}
function $829253db717f8f1b$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $829253db717f8f1b$export$ddfd3662e196c265(opts) {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $829253db717f8f1b$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getPaginationRowModel"));
}


//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function $6f12815be8ba8421$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $6f12815be8ba8421$var$isReactComponent(Comp) ? /*#__PURE__*/ $exYeM.createElement(Comp, props) : Comp;
}
function $6f12815be8ba8421$var$isReactComponent(component) {
    return $6f12815be8ba8421$var$isClassComponent(component) || typeof component === "function" || $6f12815be8ba8421$var$isExoticComponent(component);
}
function $6f12815be8ba8421$var$isClassComponent(component) {
    return typeof component === "function" && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $6f12815be8ba8421$var$isExoticComponent(component) {
    return typeof component === "object" && typeof component.$$typeof === "symbol" && [
        "react.memo",
        "react.forward_ref"
    ].includes(component.$$typeof.description);
}
function $6f12815be8ba8421$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $exYeM.useState(()=>({
            current: (0, $829253db717f8f1b$export$33bbb3ec7652e187)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $exYeM.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}




function $06f444c49b9780e9$export$df30df7ec97b32b5({ columns: columns, data: data, pageSize: pageSize = 10, isRounded: isRounded = false, roundToDecimal: roundToDecimal = 4 }) {
    const [pagination, setPagination] = (0, $exYeM.useState)({
        pageIndex: 0,
        pageSize: pageSize
    });
    const [sorting, setSorting] = (0, $exYeM.useState)([]);
    const table = (0, $6f12815be8ba8421$export$25eaeb3743e6b31f)({
        data: data,
        columns: columns,
        state: {
            pagination: pagination,
            sorting: sorting
        },
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: (0, $829253db717f8f1b$export$32d0bc001e828250)(),
        getPaginationRowModel: (0, $829253db717f8f1b$export$ddfd3662e196c265)(),
        getSortedRowModel: (0, $829253db717f8f1b$export$4ca93ca80835d8c1)()
    });
    const currentPage = table.getState().pagination.pageIndex + 1;
    const totalPages = table.getPageCount();
    const setCurrentPage = (pageNumber)=>{
        setPagination((prev)=>({
                ...prev,
                pageIndex: pageNumber - 1
            }));
    };
    const formatValue = (value)=>{
        if (typeof value === "number" && isRounded) return value.toFixed(roundToDecimal);
        return value;
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: `h-full ${isRounded ? "rounded-md border" : " rounded-b-md border-l border-r border-b  bg-[#F8F9FC]"}  `,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$54ec01a60f47d33d), {
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$f850895b287ef28e), {
                    className: "",
                    children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                            className: "h-10",
                            children: headerGroup.headers.map((header)=>{
                                const sortingIsEnabled = header.column.getCanSort();
                                return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                    onClick: sortingIsEnabled ? header.column.getToggleSortingHandler() : undefined,
                                    style: {
                                        cursor: sortingIsEnabled ? "pointer" : "auto",
                                        minWidth: header.column.columnDef.width,
                                        maxWidth: header.column.columnDef.width,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        fontSize: "larger"
                                    },
                                    className: "text-xs font-semibold px-2",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "flex items-center justify-between",
                                        children: header.isPlaceholder ? null : /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                            children: [
                                                (0, $6f12815be8ba8421$export$f2385bb6e3ac4b4f)(header.column.columnDef.header, header.getContext()),
                                                sortingIsEnabled ? header.column.getIsSorted() ? header.column.getIsSorted() === "desc" ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9b82b6f96fc76ebd$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-primary"
                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f3e94f1ced736932$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-primary"
                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f3e94f1ced736932$export$2e2bcd8739ae039), {
                                                    className: "w-6 h-6 text-gray-400"
                                                }) : null
                                            ]
                                        })
                                    })
                                }, header.id);
                            })
                        }, headerGroup.id))
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$76ccd210b9029917), {
                    children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                            className: `text-xs`,
                            children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                    className: "text-xs px-4 h-14",
                                    style: {
                                        minWidth: cell.column.columnDef.width,
                                        maxWidth: cell.column.columnDef.width,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        fontSize: "larger"
                                    },
                                    children: formatValue((0, $6f12815be8ba8421$export$f2385bb6e3ac4b4f)(cell.column.columnDef.cell, cell.getContext()))
                                }, cell.id))
                        }, row.id))
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1f116082bba1f9a8), {
                    clas: true,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                            colSpan: columns.length,
                            className: "text-center",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $7c10522a8a55d5a2$export$68f5e1453c188a82), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$c38bddd65ea050e7), {
                                        onClick: ()=>setPagination((prev)=>({
                                                    ...prev,
                                                    pageIndex: Math.max(0, prev.pageIndex - 1)
                                                })),
                                        disabled: !table.getCanPreviousPage()
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$389c2523d2fb7ac8), {
                                        onClick: ()=>setCurrentPage(1),
                                        isActive: currentPage === 1,
                                        children: "1"
                                    }),
                                    currentPage <= 3 ? [
                                        ...Array(Math.min(3, totalPages - 1))
                                    ].map((_, i)=>{
                                        const pageNumber = i + 2;
                                        if (pageNumber < totalPages) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$389c2523d2fb7ac8), {
                                            onClick: ()=>setCurrentPage(pageNumber),
                                            isActive: currentPage === pageNumber,
                                            children: pageNumber
                                        }, pageNumber);
                                        return null;
                                    }) : currentPage >= totalPages - 2 ? [
                                        ...Array(3)
                                    ].map((_, i)=>{
                                        const pageNumber = totalPages - 3 + i;
                                        if (pageNumber > 1) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$389c2523d2fb7ac8), {
                                            onClick: ()=>setCurrentPage(pageNumber),
                                            isActive: currentPage === pageNumber,
                                            children: pageNumber
                                        }, pageNumber);
                                        return null;
                                    }) : [
                                        ...Array(3)
                                    ].map((_, i)=>{
                                        const pageNumber = currentPage + i - 1;
                                        return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$389c2523d2fb7ac8), {
                                            onClick: ()=>setCurrentPage(pageNumber),
                                            isActive: currentPage === pageNumber,
                                            children: pageNumber
                                        }, pageNumber);
                                    }),
                                    totalPages > 1 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$389c2523d2fb7ac8), {
                                        onClick: ()=>setCurrentPage(totalPages),
                                        isActive: currentPage === totalPages,
                                        children: totalPages
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$ef9c8bfc54489a24), {
                                        onClick: ()=>setPagination((prev)=>({
                                                    ...prev,
                                                    pageIndex: prev.pageIndex + 1
                                                })),
                                        disabled: !table.getCanNextPage()
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}


function $353ace93c0328113$var$DisplayTransactions() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const address = new URLSearchParams(location.search).get("address");
    (0, $exYeM.useEffect)(()=>{
        if (localStorage.getItem("user") === null) navigate("/Footprint");
    }, [
        navigate
    ]);
    if (!address) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: "Please enter an address."
    });
    const { isLoading: tickerLoading, isError: tickerError, data: txData, error: tickerErrorDetails } = (0, $3723a6995b786148$export$2e2bcd8739ae039)();
    const transactions = txData?.data || [];
    transactions.sort((a, b)=>b.block_number - a.block_number);
    const calculateTransactionFee = (gas, gasPrice)=>{
        const feeInWei = BigInt(gas) * BigInt(gasPrice);
        return Number(feeInWei) / 1e18;
    };
    const convertWeiToEth = (weiValue)=>{
        return Number(weiValue) / 1e18;
    };
    const calculateTotalGasUsedInEth = (transactions)=>{
        const totalGasUsedInWei = transactions.reduce((acc, tx)=>{
            const gasUsedInWei = BigInt(tx.gas) * BigInt(tx.gas_price);
            return acc + gasUsedInWei;
        }, BigInt(0));
        return convertWeiToEth(totalGasUsedInWei);
    };
    const totalGasUsedInEth = calculateTotalGasUsedInEth(transactions);
    const calculateUniqueCounterParties = (transactions, address)=>{
        const allAddresses = transactions.flatMap((tx)=>[
                tx.to_address,
                tx.from_address
            ]);
        const filteredAddresses = allAddresses.filter((addr)=>addr !== address);
        return new Set(filteredAddresses).size;
    };
    const uniqueCounterParties = calculateUniqueCounterParties(transactions, address);
    const totalTransactionCount = transactions.length;
    const findLargestTrade = (transactions)=>{
        return transactions.reduce((max, tx)=>BigInt(tx.value) > BigInt(max.value) ? tx : max, transactions[0]);
    };
    const largestTrade = transactions.length > 0 ? findLargestTrade(transactions) : null;
    const largestTradeValueInEth = largestTrade ? convertWeiToEth(largestTrade.value) : 0;
    const columns = [
        {
            header: "Hash",
            accessorKey: "hash",
            cell: ({ row: row })=>/*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                    href: `https://etherscan.io/tx/${row.original.hash}`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "text-primary",
                    children: row.original.hash
                }),
            width: 200
        },
        {
            header: "Block Number",
            accessorKey: "block_number",
            width: 100
        },
        {
            header: "From Address",
            accessorKey: "from_address",
            width: 200
        },
        {
            header: "To Address",
            accessorKey: "to_address",
            width: 200
        },
        {
            header: "Value (ETH)",
            accessorKey: "value",
            cell: ({ row: row })=>convertWeiToEth(row.original.value).toFixed(6),
            width: 100
        },
        {
            header: "Gas",
            accessorKey: "gas",
            width: 100
        },
        {
            header: "Transaction Fee (ETH)",
            accessorKey: "transaction_fee",
            cell: ({ row: row })=>calculateTransactionFee(row.original.gas, row.original.gas_price).toFixed(6),
            width: 150
        }
    ];
    if (tickerError) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-full flex flex-col gap-4 font-roboto p-2 px-4",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "h-64 font-monda text-5xl flex flex-col gap-4 text-center items-center mt-6 text-red-400",
            children: [
                "error",
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "text-gray-700 text-3xl",
                    children: "Can't retrieve values from this wallet address"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "text-gray-700 text-3xl",
                    children: "Refresh and try again"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                    className: "w-fit text-white mt-2",
                    onClick: ()=>navigate("/Footprint"),
                    children: "Return to Footprint"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full flex flex-col gap-4 font-roboto p-2 px-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    className: "break-words",
                                    children: "Total Transactions"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {}) : totalTransactionCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    className: "break-words",
                                    children: "Total Gas Used"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {}) : `${totalGasUsedInEth?.toFixed(3)} ETH`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    className: "break-words",
                                    children: "Unique Counter-Parties"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {}) : uniqueCounterParties
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    className: "break-words",
                                    children: "Largest Trade"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {}) : `${largestTradeValueInEth.toFixed(4)} ETH`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "text-center w-full",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                    className: "w-full min-h-[400px] md:min-h-[800px] flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                children: "Transaction Record"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                            className: "flex flex-col flex-grow overflow-x-auto",
                            children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                className: "flex-grow"
                            }) : tickerErrorDetails ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                children: [
                                    "Error: ",
                                    tickerErrorDetails.message
                                ]
                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $06f444c49b9780e9$export$df30df7ec97b32b5), {
                                columns: columns,
                                data: transactions,
                                pageSize: 20,
                                isRounded: true,
                                roundToDecimal: 6
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $353ace93c0328113$export$2e2bcd8739ae039 = $353ace93c0328113$var$DisplayTransactions;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

function $d6c6e8096bc2feb8$export$2e2bcd8739ae039({ open: open, setOpen: setOpen, onSubmit: onSubmit }) {
    const cancelButtonRef = (0, $exYeM.useRef)(null);
    const [minValue, setMinValue] = (0, $exYeM.useState)("");
    const [startDate, setStartDate] = (0, $exYeM.useState)("");
    const [endDate, setEndDate] = (0, $exYeM.useState)("");
    const handleSubmit = ()=>{
        onSubmit(minValue, startDate, endDate);
        setOpen(false); // Close the dialog
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
            show: open,
            as: (0, $exYeM.Fragment),
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
                as: "div",
                className: "relative z-10",
                initialFocus: cancelButtonRef,
                onClose: setOpen,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                        as: (0, $exYeM.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 z-10 overflow-y-auto",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                                as: (0, $exYeM.Fragment),
                                enter: "ease-out duration-300",
                                enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                enterTo: "opacity-100 translate-y-0 sm:scale-100",
                                leave: "ease-in duration-200",
                                leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                                leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                    className: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "sm:flex sm:items-start",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    className: "text-center sm:mt-0 sm:text-left w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                            className: "flex justify-between items-center mb-4"
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "space-y-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                            htmlFor: "minValue",
                                                                            className: "block text-sm font-medium text-gray-700 mr-4",
                                                                            children: "Minimum Value in Eth:"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                            type: "number",
                                                                            placeholder: "0",
                                                                            value: minValue,
                                                                            onChange: (e)=>setMinValue(e.target.value),
                                                                            className: "flex-1 block w-full border border-gray-300 rounded-lg py-2 px-3 focus:border-primary focus:ring-primary"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                            htmlFor: "startDate",
                                                                            className: "block text-sm font-medium text-gray-700 mr-4",
                                                                            children: "Start Date:"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                            type: "date",
                                                                            value: startDate,
                                                                            onChange: (e)=>setStartDate(e.target.value),
                                                                            className: "flex-1 block w-full border border-gray-300 rounded-lg py-2 px-3 focus:border-primary focus:ring-primary"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                            htmlFor: "endDate",
                                                                            className: "block text-sm font-medium text-gray-700 mr-4",
                                                                            children: "End Date:"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                            type: "date",
                                                                            value: endDate,
                                                                            onChange: (e)=>setEndDate(e.target.value),
                                                                            className: "flex-1 block w-full border border-gray-300 rounded-lg py-2 px-3 focus:border-primary focus:ring-primary"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    type: "button",
                                                    className: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primaryDark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-3 sm:w-auto sm:text-sm",
                                                    onClick: handleSubmit,
                                                    children: "Save"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    type: "button",
                                                    className: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm",
                                                    onClick: ()=>setOpen(false),
                                                    ref: cancelButtonRef,
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}




function $463f90ed829f9f89$export$2e2bcd8739ae039(minValue, startDate, endDate) {
    const address = new URLSearchParams(location.search).get("address");
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const { isLoading: isLoading, data: data, isError: isError, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "networkAddresses",
            address,
            minValue,
            startDate,
            endDate
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/networkAddresses?address=${address}&minValue=${minValue}&startDate=${startDate}&endDate=${endDate}`, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
            return data.data;
        }
    });
    return {
        isLoading: isLoading,
        isError: isError,
        data: data,
        error: error
    };
}




// Lazy load the NetworkGraph component
const $c8347f669780134b$var$NetworkGraph = /*#__PURE__*/ (0, $exYeM.lazy)(()=>(parcelRequire("ibFd0")));
const $c8347f669780134b$var$DisplayNetworkGraph = ()=>{
    const [isDialogOpen, setIsDialogOpen] = (0, $exYeM.useState)(false);
    const [minValue, setMinValue] = (0, $exYeM.useState)("0");
    const [startDate, setStartDate] = (0, $exYeM.useState)("");
    const [endDate, setEndDate] = (0, $exYeM.useState)("");
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    (0, $exYeM.useEffect)(()=>{
        if (localStorage.getItem("user") === null) navigate("/Footprint");
    }, [
        navigate
    ]);
    const onSubmit = (newMinValue, newStartDate, newEndDate)=>{
        setMinValue(newMinValue);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };
    const address = new URLSearchParams(location.search).get("address");
    let transformedData = {
        nodes: [],
        links: []
    };
    if (!address) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: "Please enter an address to view the network graph."
    });
    const { isLoading: networkLoading, data: networkData, isError: isNetworkError } = (0, $463f90ed829f9f89$export$2e2bcd8739ae039)(minValue, startDate, endDate);
    const nodeOfFocus = address;
    if (networkData) {
        const nodesMap = new Map();
        let links = [];
        networkData.forEach((item)=>{
            nodesMap.set(item.from_address, item.from_image);
            nodesMap.set(item.to_address, item.to_image);
            const valueInEth = item.value / 1e18;
            links.push({
                source: item.from_address,
                target: item.to_address,
                value: valueInEth,
                color: item.from_address.toLowerCase() === nodeOfFocus.toLowerCase() ? "rgba(255, 0, 0, 0.3)" : "rgba(0, 128, 0, 0.5)"
            });
        });
        const nodes = Array.from(nodesMap).map(([id, image])=>{
            return {
                id: id,
                image: image
            };
        });
        transformedData = {
            nodes: nodes,
            links: links
        };
    }
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full flex flex-col gap-4 font-roboto p-2 px-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex justify-center items-center h-screen",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                    className: "w-full mx-auto flex flex-col h-full",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                            className: "px-2",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                className: "my-2 py-2 px-4 text-white rounded bg-primary",
                                onClick: ()=>setIsDialogOpen(true),
                                children: "Filter Network Graph"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                            className: "flex flex-col justify-center items-center h-full",
                            children: networkLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                className: "flex-grow"
                            }) : isNetworkError ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "h-96 font-monda text-5xl flex flex-col gap-4 text-center mt-6 text-red-400",
                                children: [
                                    "error",
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-gray-700 text-3xl",
                                        children: "Cant retrieve values from this wallet address"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "text-gray-700 text-3xl",
                                        children: "Refresh and try again"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                        className: "w-fit text-white mt-2",
                                        onClick: ()=>navigate("/Footprint"),
                                        children: "Return to Footprint"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $exYeM.Suspense), {
                                fallback: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    className: "flex-grow"
                                }),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($c8347f669780134b$var$NetworkGraph, {
                                    data: transformedData
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6c6e8096bc2feb8$export$2e2bcd8739ae039), {
                open: isDialogOpen,
                setOpen: setIsDialogOpen,
                onSubmit: onSubmit
            })
        ]
    });
};
var $c8347f669780134b$export$2e2bcd8739ae039 = $c8347f669780134b$var$DisplayNetworkGraph;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");
function $8e8e0244e7865f02$var$ArrowDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25a.75.75 0 01.75.75v16.19l6.22-6.22a.75.75 0 111.06 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 111.06-1.06l6.22 6.22V3a.75.75 0 01.75-.75z",
        clipRule: "evenodd"
    }));
}
const $8e8e0244e7865f02$var$ForwardRef = $exYeM.forwardRef($8e8e0244e7865f02$var$ArrowDownIcon);
var $8e8e0244e7865f02$export$2e2bcd8739ae039 = $8e8e0244e7865f02$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $569995ca95587bc4$var$ArrowUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M11.47 2.47a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06l-6.22-6.22V21a.75.75 0 01-1.5 0V4.81l-6.22 6.22a.75.75 0 11-1.06-1.06l7.5-7.5z",
        clipRule: "evenodd"
    }));
}
const $569995ca95587bc4$var$ForwardRef = $exYeM.forwardRef($569995ca95587bc4$var$ArrowUpIcon);
var $569995ca95587bc4$export$2e2bcd8739ae039 = $569995ca95587bc4$var$ForwardRef;






function $a73948952b7d949c$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $a73948952b7d949c$export$d2a2f7e4670382ea() {
    const address = new URLSearchParams(location.search).get("address");
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "getTransactions",
            address
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/getTxns?address=${address}`, {
                headers: {
                    Authorization: `Bearer ${$a73948952b7d949c$var$getToken()}`
                }
            });
            return data;
        }
    });
    return {
        isLoading: isLoading,
        isError: isError,
        data: data,
        error: error
    };
}
function $a73948952b7d949c$export$638750c1dbf02dc3(percentile, blockchain) {
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            `getPercentileMetrics`,
            percentile,
            blockchain
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/getPercentileMetrics?percentile=${encodeURIComponent(percentile)}&blockchain=${blockchain}`, {
                headers: {
                    Authorization: `Bearer ${$a73948952b7d949c$var$getToken()}`
                }
            });
            return data;
        }
    });
    return {
        isLoading: isLoading,
        isError: isError,
        data: data,
        error: error
    };
}



const $46fb392573591b54$var$activeClassName = "border-b-2 border-primary text-white bg-primary";
const $46fb392573591b54$var$notActiveClassName = "text-black hover:text-primary";
function $46fb392573591b54$var$DisplayAnalytics() {
    const [percentile, setPercentile] = (0, $exYeM.useState)("50%");
    const [blockchain, setBlockchain] = (0, $exYeM.useState)("Ethereum");
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const address = new URLSearchParams(location.search).get("address");
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)(); // Use the useNavigate hook
    (0, $exYeM.useEffect)(()=>{
        if (localStorage.getItem("user") === null) navigate("/Footprint");
    }, []);
    if (!address) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: "Please enter an address."
    });
    const { isLoading: tickerLoading, isError: tickerError, data: txData } = (0, $a73948952b7d949c$export$d2a2f7e4670382ea)();
    const { isLoading: isLoading, isError: percentileError, data: metricsData } = (0, $a73948952b7d949c$export$638750c1dbf02dc3)(percentile, blockchain);
    const handleChangePercentile = (newPercentile)=>setPercentile(newPercentile);
    // const handleChangeBlockchain = (newBlockchain) =>
    //   setBlockchain(newBlockchain);
    // const metrics = metricsData?.metrics?.Ethereum || {};
    const transactions = txData?.data || [];
    transactions.sort((a, b)=>b.block_number - a.block_number);
    const weiToEther = (weiValue)=>parseFloat(weiValue) / Math.pow(10, 18);
    const totalETHReceived = transactions.filter((tx)=>tx.to_address.toLowerCase() === address.toLowerCase()).reduce((sum, tx)=>sum + weiToEther(tx.value), 0);
    const totalETHSent = transactions.filter((tx)=>tx.from_address.toLowerCase() === address.toLowerCase()).reduce((sum, tx)=>sum + weiToEther(tx.value), 0);
    const largestTransactionReceived = Math.max(...transactions.filter((tx)=>tx.to_address.toLowerCase() === address.toLowerCase()).map((tx)=>weiToEther(tx.value)));
    const largestTransactionSent = Math.max(...transactions.filter((tx)=>tx.from_address.toLowerCase() === address.toLowerCase()).map((tx)=>weiToEther(tx.value)));
    const numberOfTransactions = transactions.length;
    const averageTransactionValue = numberOfTransactions > 0 ? (totalETHReceived + totalETHSent) / numberOfTransactions : 0;
    const transactionDates = transactions.map((tx)=>tx.block_timestamp.split(" ")[0]);
    const mostActiveDayCalc = transactionDates.sort((a, b)=>transactionDates.filter((date)=>date === a).length - transactionDates.filter((date)=>date === b).length).pop();
    const getMostFrequentTransactionPartner = (transactions, currentAccountAddress)=>{
        if (!transactions || transactions.length === 0) return null; // Return null or any appropriate value indicating no transactions or data not loaded
        const partnerCounts = transactions.reduce((counts, tx)=>{
            const partnerAddress = tx.from_address.toLowerCase() === currentAccountAddress.toLowerCase() ? tx.to_address.toLowerCase() : tx.from_address.toLowerCase();
            counts[partnerAddress] = (counts[partnerAddress] || 0) + 1;
            return counts;
        }, {});
        if (Object.keys(partnerCounts).length === 0) return null; // Return null if no partner counts found (though this should be covered by the first check)
        // Reduce the entries to find the most frequent partner
        return Object.entries(partnerCounts).reduce((a, b)=>a[1] > b[1] ? a : b)[0];
    };
    const mostFrequentPartner = getMostFrequentTransactionPartner(transactions, address);
    const getLongestIdlePeriod = (transactions)=>{
        const sortedTransactions = transactions.sort((a, b)=>new Date(a.block_timestamp) - new Date(b.block_timestamp));
        let longestIdlePeriod = 0;
        for(let i = 1; i < sortedTransactions.length; i++){
            const currentIdlePeriod = new Date(sortedTransactions[i].block_timestamp) - new Date(sortedTransactions[i - 1].block_timestamp);
            if (currentIdlePeriod > longestIdlePeriod) longestIdlePeriod = currentIdlePeriod;
        }
        return longestIdlePeriod; // This is in milliseconds
    };
    const longestIdlePeriod = getLongestIdlePeriod(transactions);
    let totalGasUsed = 0;
    let totalGasPrice = 0;
    transactions.forEach((tx)=>{
        totalGasUsed += tx.gas;
        totalGasPrice += tx.gas_price;
    });
    const averageGasPrice = totalGasPrice / transactions.length;
    const transactionTypeCounts = transactions.reduce((acc, tx)=>{
        acc[tx.transaction_type] = (acc[tx.transaction_type] || 0) + 1;
        return acc;
    }, {});
    let mostCommonTransactionType = "N/A"; // Default value in case there are no transactions
    if (Object.keys(transactionTypeCounts).length > 0) mostCommonTransactionType = Object.keys(transactionTypeCounts).reduce((a, b)=>transactionTypeCounts[a] > transactionTypeCounts[b] ? a : b);
    const hourlyTransactionCounts = transactions.reduce((acc, tx)=>{
        const hour = new Date(tx.block_timestamp).getHours();
        acc[hour] = (acc[hour] || 0) + 1;
        return acc;
    }, {});
    let peakTransactionHour = "N/A"; // Default value in case there are no transactions
    if (Object.keys(hourlyTransactionCounts).length > 0) peakTransactionHour = Object.keys(hourlyTransactionCounts).reduce((a, b)=>hourlyTransactionCounts[a] > hourlyTransactionCounts[b] ? a : b);
    const dayOfWeekCounts = transactions.reduce((acc, tx)=>{
        const dayOfWeek = new Date(tx.block_timestamp).getDay(); // 0 (Sunday) to 6 (Saturday)
        acc[dayOfWeek] = (acc[dayOfWeek] || 0) + 1;
        return acc;
    }, {});
    // Initialize the most common day of the week as 'N/A'
    let mostCommonDayOfWeek = "N/A";
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    // Check if we have any transactions counted
    if (Object.keys(dayOfWeekCounts).length > 0) {
        // Find the day index with the maximum count
        const maxDayIndex = Object.keys(dayOfWeekCounts).reduce((a, b)=>dayOfWeekCounts[a] > dayOfWeekCounts[b] ? a : b);
        // Convert the index to the corresponding day name
        mostCommonDayOfWeek = days[parseInt(maxDayIndex)];
    }
    /// percentage stuff
    function calculateComparisonIndicator(totalValue, quantileValue) {
        let comparisonIndicator = {
            icon: null,
            color: "text-gray-500",
            formattedPercentageDiff: ""
        };
        if (totalValue !== undefined && quantileValue > 0) {
            const percentageDifference = (totalValue - quantileValue) / quantileValue * 100;
            comparisonIndicator.color = percentageDifference < 0 ? "text-red-500" : "text-green-500";
            comparisonIndicator.icon = percentageDifference < 0 ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8e8e0244e7865f02$export$2e2bcd8739ae039), {
                className: "w-5 h-5"
            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $569995ca95587bc4$export$2e2bcd8739ae039), {
                className: "w-5 h-5"
            });
            comparisonIndicator.formattedPercentageDiff = `${Math.abs(percentageDifference).toFixed(2)}%`;
        } else if (quantileValue === 0) {
            comparisonIndicator.formattedPercentageDiff = "\u221E"; // Handle special case where quantileValue is 0
            comparisonIndicator.icon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $569995ca95587bc4$export$2e2bcd8739ae039), {
                className: "w-5 h-5 text-green-500"
            });
        }
        return comparisonIndicator;
    }
    function generateComparisonIndicator(userValue, baselineValue) {
        const comparisonIndicator = {
            icon: null,
            color: "text-gray-500",
            formattedUserValue: userValue ? userValue.toString() : "N/A",
            formattedBaselineValue: baselineValue ? baselineValue.toString() : "N/A",
            match: userValue == baselineValue
        };
        if (comparisonIndicator.match) {
            comparisonIndicator.color = "text-green-500"; // Green for matching values
            comparisonIndicator.icon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9bcddf4d25089704$export$2e2bcd8739ae039), {
                className: "w-5 h-5"
            }); // Use a checkmark icon for match
        } else {
            comparisonIndicator.color = "text-red-500"; // Red for non-matching values
            comparisonIndicator.icon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
                className: "w-5 h-5"
            }); // Use an X icon for non-match
        }
        return comparisonIndicator;
    }
    let comparisonIndicatorETHReceived = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonIndicatorETHSent = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonTotalIndicatorETHReceived = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonTotalIndicatorETHSent = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonIndicatorAverageTransactionValue = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonIndicatorAverageGasUsed = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonIndicatorAverageGasPrice = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonTotalTransactions = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonTransactionType = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonMostActiveDay = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonMostCommonDay = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    let comparisonMostCommonHour = {
        icon: null,
        color: "text-gray-500",
        formattedPercentageDiff: ""
    };
    const allDataLoaded = !tickerLoading && !isLoading;
    if (allDataLoaded) {
        const metrics = metricsData?.data?.[0]?.metrics?.Ethereum;
        const { medianTransactionValue: medianTransactionValue, medianGasUsed: medianGasUsed, medianGasPrice: medianGasPrice, quantileEthReceived: quantileEthReceived, quantileEthSent: quantileEthSent, quantileTotalEthReceived: quantileTotalEthReceived, quantileTotalEthSent: quantileTotalEthSent, quantileTransactions: quantileTransactions, quantileGasPrice: quantileGasPrice, transactionType: transactionType, mostCommonDay: mostCommonDay, mostCommonHour: mostCommonHour, mostActiveDay: mostActiveDay } = metrics;
        // Assuming totalETHReceived and totalETHSent are defined and available here
        comparisonIndicatorETHReceived = calculateComparisonIndicator(totalETHReceived, quantileEthReceived);
        comparisonIndicatorETHSent = calculateComparisonIndicator(totalETHSent, quantileEthSent);
        comparisonIndicatorAverageTransactionValue = calculateComparisonIndicator(averageTransactionValue, medianTransactionValue);
        comparisonIndicatorAverageGasUsed = calculateComparisonIndicator(totalGasUsed, medianGasUsed);
        comparisonIndicatorAverageGasPrice = calculateComparisonIndicator(averageGasPrice, quantileGasPrice);
        comparisonTotalIndicatorETHReceived = calculateComparisonIndicator(totalETHReceived, quantileTotalEthReceived);
        comparisonTotalIndicatorETHSent = calculateComparisonIndicator(totalETHSent, quantileTotalEthSent);
        comparisonTotalTransactions = calculateComparisonIndicator(numberOfTransactions, quantileTransactions);
        comparisonTransactionType = generateComparisonIndicator(mostCommonTransactionType, transactionType);
        comparisonMostActiveDay = generateComparisonIndicator(mostActiveDayCalc, mostActiveDay);
        comparisonMostCommonDay = generateComparisonIndicator(mostCommonDayOfWeek, mostCommonDay);
        comparisonMostCommonHour = generateComparisonIndicator(peakTransactionHour, mostCommonHour);
    }
    //date formatter
    function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-CA", {
            // 'en-CA' format yields 'YYYY-MM-DD'
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    }
    if (tickerError || percentileError) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-96 font-monda text-5xl flex flex-col justify-center items-center gap-4 text-center mt-6 text-red-400",
        children: [
            "error",
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "text-gray-700 text-3xl",
                children: "Can't retrieve values from this wallet address"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "text-gray-700 text-3xl",
                children: "Refresh and try again"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                className: "w-fit text-white mt-2",
                onClick: ()=>navigate("/Footprint"),
                children: "Return to Footprint"
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full flex flex-col gap-4 font-roboto py-4 px-6",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid grid-cols-3 gap-4 items-end",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1 lg:block hidden h-fit",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Total ETH Received"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${totalETHReceived.toFixed(3)} ETH`
                                        }),
                                        totalETHReceived !== undefined && comparisonTotalIndicatorETHReceived.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonTotalIndicatorETHReceived.color}`,
                                            children: [
                                                comparisonTotalIndicatorETHReceived.icon,
                                                comparisonTotalIndicatorETHReceived.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "text-center p-2 col-span-3 lg:col-span-1 flex flex-col items-center w-full justify-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                className: "text-2xl font-bold text-gray-800 my-4",
                                children: "Key Metric Percentile Comparisons"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$b2539bed5023c21c), {
                                className: "sm:px-3 flex gap-x-4 text-md lg:text-lg px-4 items-center justify-center text-center",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $125c9c6acc39e22a$export$9712d22edc0d78c1), {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>{
                                                handleChangePercentile("1%");
                                            },
                                            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(percentile === "1%" ? $46fb392573591b54$var$activeClassName : $46fb392573591b54$var$notActiveClassName),
                                            children: "1%"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>{
                                                handleChangePercentile("25%");
                                            },
                                            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(percentile === "25%" ? $46fb392573591b54$var$activeClassName : $46fb392573591b54$var$notActiveClassName),
                                            children: "25%"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>{
                                                handleChangePercentile("50%");
                                            },
                                            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(percentile === "50%" ? $46fb392573591b54$var$activeClassName : $46fb392573591b54$var$notActiveClassName),
                                            children: "50%"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>{
                                                handleChangePercentile("75%");
                                            },
                                            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(percentile === "75%" ? $46fb392573591b54$var$activeClassName : $46fb392573591b54$var$notActiveClassName),
                                            children: "75%"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $125c9c6acc39e22a$export$8114b9fdfdf9f3ba), {
                                            onClick: ()=>{
                                                handleChangePercentile("99%");
                                            },
                                            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(percentile === "99%" ? $46fb392573591b54$var$activeClassName : $46fb392573591b54$var$notActiveClassName),
                                            children: "99%"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1 lg:block hidden",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Total ETH Sent"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${totalETHSent.toFixed(3)} ETH`
                                        }),
                                        totalETHSent !== undefined && comparisonTotalIndicatorETHSent.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonTotalIndicatorETHSent.color}`,
                                            children: [
                                                comparisonTotalIndicatorETHSent.icon,
                                                comparisonTotalIndicatorETHSent.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1 lg:hidden block",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Total ETH Received"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${totalETHReceived.toFixed(3)} ETH`
                                        }),
                                        totalETHReceived !== undefined && comparisonTotalIndicatorETHReceived.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonTotalIndicatorETHReceived.color}`,
                                            children: [
                                                comparisonTotalIndicatorETHReceived.icon,
                                                comparisonTotalIndicatorETHReceived.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1 lg:hidden block",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Total ETH Sent"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${totalETHSent.toFixed(3)} ETH`
                                        }),
                                        totalETHSent !== undefined && comparisonTotalIndicatorETHSent.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonTotalIndicatorETHSent.color}`,
                                            children: [
                                                comparisonTotalIndicatorETHSent.icon,
                                                comparisonTotalIndicatorETHSent.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Number of Transactions"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: numberOfTransactions
                                        }),
                                        numberOfTransactions !== undefined && comparisonTotalTransactions.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonTotalTransactions.color}`,
                                            children: [
                                                comparisonTotalTransactions.icon,
                                                comparisonTotalTransactions.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Average Transaction Value"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${averageTransactionValue.toFixed(3)} ETH`
                                        }),
                                        averageTransactionValue !== undefined && comparisonIndicatorAverageTransactionValue.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonIndicatorAverageTransactionValue.color}`,
                                            children: [
                                                comparisonIndicatorAverageTransactionValue.icon,
                                                comparisonIndicatorAverageTransactionValue.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Largest Transaction Received"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${largestTransactionReceived.toFixed(3)} ETH`
                                        }),
                                        largestTransactionReceived !== undefined && comparisonIndicatorETHReceived.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonIndicatorETHReceived.color}`,
                                            children: [
                                                comparisonIndicatorETHReceived.icon,
                                                comparisonIndicatorETHReceived.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Largest Transaction Sent"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${largestTransactionSent.toFixed(3)} ETH`
                                        }),
                                        largestTransactionSent !== undefined && comparisonIndicatorETHSent.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonIndicatorETHSent.color}`,
                                            children: [
                                                comparisonIndicatorETHSent.icon,
                                                comparisonIndicatorETHSent.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Most Active Day"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: mostActiveDayCalc
                                        }),
                                        mostActiveDayCalc !== undefined && comparisonMostActiveDay.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonMostActiveDay.color}`,
                                            children: [
                                                comparisonMostActiveDay.icon,
                                                formatDate(comparisonMostActiveDay.formattedBaselineValue)
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Total Gas Used"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${totalGasUsed.toLocaleString()} units`
                                        }),
                                        totalGasUsed !== undefined && comparisonIndicatorAverageGasUsed.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonIndicatorAverageGasUsed.color}`,
                                            children: [
                                                comparisonIndicatorAverageGasUsed.icon,
                                                comparisonIndicatorAverageGasUsed.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1 overflow-auto",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Average Gas Price"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: ` ${averageGasPrice.toFixed(2)} Wei`
                                        }),
                                        averageGasPrice !== undefined && comparisonIndicatorAverageGasPrice.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center   ${comparisonIndicatorAverageGasPrice.color}`,
                                            children: [
                                                comparisonIndicatorAverageGasPrice.icon,
                                                comparisonIndicatorAverageGasPrice.formattedPercentageDiff
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Most Common Transaction Type"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: mostCommonTransactionType
                                        }),
                                        mostCommonTransactionType !== undefined && comparisonTransactionType.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonTransactionType.color}`,
                                            children: [
                                                comparisonTransactionType.icon,
                                                comparisonTransactionType.formattedBaselineValue
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Peak Transaction Hour"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: `${peakTransactionHour}:00 - ${parseInt(peakTransactionHour) + 1}:00`
                                        }),
                                        comparisonMostCommonHour !== undefined && comparisonMostCommonHour.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonMostCommonHour.color}`,
                                            children: [
                                                comparisonMostCommonHour.icon,
                                                comparisonMostCommonHour.formattedBaselineValue
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Most Common Trading Day"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: mostCommonDayOfWeek
                                        }),
                                        comparisonMostCommonDay !== undefined && comparisonMostCommonDay.icon && /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: `flex items-center ${comparisonMostCommonDay.color}`,
                                            children: [
                                                comparisonMostCommonDay.icon,
                                                comparisonMostCommonDay.formattedBaselineValue
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Most Frequent Transaction Partner"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                className: "break-words",
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                    children: [
                                        "Address:",
                                        " ",
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                            href: `https://etherscan.io/address/${mostFrequentPartner}`,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "text-primary hover:text-primary",
                                            children: mostFrequentPartner
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                        className: "col-span-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                    children: "Longest Idle Period"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                    additionalClasses: "flex-grow"
                                }) : `${(longestIdlePeriod / 86400000).toFixed(2)} days`
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $46fb392573591b54$export$2e2bcd8739ae039 = $46fb392573591b54$var$DisplayAnalytics;



var $aSiaI = parcelRequire("aSiaI");


var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $f0f43ae2e7e7d2db$var$ArrowRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z",
        clipRule: "evenodd"
    }));
}
const $f0f43ae2e7e7d2db$var$ForwardRef = $exYeM.forwardRef($f0f43ae2e7e7d2db$var$ArrowRightIcon);
var $f0f43ae2e7e7d2db$export$2e2bcd8739ae039 = $f0f43ae2e7e7d2db$var$ForwardRef;





function $9e518a8e18b19553$var$DisplayIndex() {
    const [addressInput, setAddressInput] = (0, $exYeM.useState)("");
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    // Function to handle address input changes and navigate
    const handleAddressInput = (event)=>{
        setAddressInput(event.target.value);
    };
    // Function to handle form submission (same as on portfolio js)
    const handleFormSubmit = ()=>{
        // Check if the address input is empty
        if (!addressInput.trim()) {
            toast({
                variant: "destructive",
                title: "Error!",
                description: "Please enter address!"
            });
            return; // Stop the function execution if no address is entered
        }
        const currentTab = "portfolio"; // hardcoded in portfolio
        const newPath = `/Footprint/${currentTab}?address=${addressInput}`;
        navigate(newPath);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-fit py-10 grid place-items-center relative z-0 w-full overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative -z-30 ",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $41327f2ae7984f2e$export$2e2bcd8739ae039), {
                        className: "absolute -z-50 rotate-[-20deg] top-[-250px] sm:top-[-250px] md:top-[-250px] lg:top-[-300px] xl:top-[-450px] 2xl:top-[-500px] left-[-450px] sm:left-[-450px] md:left-[-700px] lg:left-[-800px] xl:left-[-900px] 2xl:left-[-1000px] h-[800px] w-[800px] lg:h-[900px] lg:w-[900px] xl:h-[1100px] xl:w-[1100px] 2xl:h-[1300px] 2xl:w-[1300px] blur-sm block"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $41327f2ae7984f2e$export$2e2bcd8739ae039), {
                        className: "absolute -z-50 rotate-[-120deg] top-[-250px] sm:top-[-300px] md:top-[-350px] lg:top-[-350px] xl:top-[-500px] 2xl:top-[-600px] left-[50px] sm:left-[0px] md:left-[30px] lg:left-[50px] xl:left-[100px] 2xl:left-[0px] h-[800px] w-[800px] md:h-[800px] md:w-[800px] lg:h-[900px] lg:w-[900px] xl:h-[1100px] xl:w-[1100px] 2xl:h-[1300px] 2xl:w-[1300px] blur-sm block"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex flex-col grow  lg:gap-4 max-w-6xl h-[75vh] justify-center px-4",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "bg-white border border-primaryContainer shadow-md rounded-2xl p-10 md:p-12 w-full flex flex-col gap-3 lg:gap-6",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                            className: "text-6xl md:text-6xl lg:text-7xl xl:text-8xl font-monda text-center text-primary mb-2",
                            children: "Footprint"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                            className: "hidden sm:block text-lg md:text-xl lg:text-2xl text-center text-gray-600",
                            children: "Track anyones web3 address, revealing NFT, DEFI and transfer information"
                        }),
                        localStorage.getItem("user") === null ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-4 py-2",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "hidden sm:block text-gray-700 text-lg md:text-xl lg:text-2xl mb-4",
                                    children: "Sign up/Log in to check it out"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $433754a817809fb2$export$3b0a9d598f613fa), {
                                    onClick: ()=>navigate("/signin"),
                                    className: "rounded-md border border-onSurfaceVariant bg-white hover:bg-primary hover:text-white px-2 py-2.5 text-lg font-semibold w-fit h-fit shadow-md text-gray-800",
                                    children: "Sign up/Log in"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                    className: "py-2 sm:py-0 text-lg sm:text-md md:text-lg lg:text-xl xl:text-2xl text-center text-gray-600",
                                    children: "Try it out below!"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "w-full flex items-center md:py-4 lg:py-8 h-fit",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                            id: "addressInput",
                                            type: "text",
                                            placeholder: "Track any wallet address ",
                                            value: addressInput,
                                            onChange: handleAddressInput,
                                            className: "block border border-onSurfaceVariant w-full p-2  sm:p-3 rounded-md form-control focus:border-primary focus:outline-none"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                            type: "submit",
                                            className: "rounded-md border  bg-surfaceVariant hover:bg-primary group mx-2 p-3 h-fit",
                                            onClick: handleFormSubmit,
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0f43ae2e7e7d2db$export$2e2bcd8739ae039), {
                                                className: "h-6 w-6 sm:h-8 sm:w-8 text-onSurfaceVariant group-hover:text-white"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $9e518a8e18b19553$export$2e2bcd8739ae039 = $9e518a8e18b19553$var$DisplayIndex;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");






function $82fcdbab225b8669$export$2e2bcd8739ae039() {
    const address = new URLSearchParams(location.search).get("address");
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const { isLoading: isLoading, isError: isError, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "nftData",
            address
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/nftHoldings?address=${address}`, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
            return data.data;
        }
    });
    return {
        isLoading: isLoading,
        isError: isError,
        data: data,
        error: error
    };
}



var $aSiaI = parcelRequire("aSiaI");

var $7c8a92f55f3054aa$exports = {};

$7c8a92f55f3054aa$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "eth.77f0cd7e.svg";



var $exYeM = parcelRequire("exYeM");

function $94be1ea1523e1b53$export$2e2bcd8739ae039({ nft: nft, setLoadedImages: setLoadedImages, loadedImages: loadedImages }) {
    const [flip, setFlip] = (0, $exYeM.useState)(false);
    const convertIPFSToHTTP = (url)=>{
        if (url.startsWith("ipfs://")) return url.replace("ipfs://", "https://ipfs.io/ipfs/");
        else if (url.startsWith("https://")) return url;
        else return 0, (/*@__PURE__*/$parcel$interopDefault($7c8a92f55f3054aa$exports));
    };
    const convertIPFSToHTTPCheck = (url)=>{
        if (!url) return false;
        else if (url.startsWith("https://")) return true;
        else if (url.startsWith("ipfs://")) return true;
        else return false;
    };
    const handleImageLoad = (tokenId)=>{
        setLoadedImages((prevLoadedImages)=>({
                ...prevLoadedImages,
                [tokenId]: true
            }));
    };
    const imageUrl = convertIPFSToHTTP(nft?.metadata?.image || "");
    const hasAttributes = Array.isArray(nft?.metadata.attributes) && nft?.metadata.attributes.length > 0;
    if (!nft) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {});
    return /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
        //   className="relative z-0 [perspective:1000px] h-80 group rounded-md overflow-hidden border border-onSurfaceVariant bg-white shadow-md"
        className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(flip ? "none" : "[transform:rotateY(180deg)]", "transition-all duration-700 [transform-style:preserve-3d] w-fit relative z-0 [perspective:1000px] group bg-white rounded-md overflow-hidden shadow-md pb-2"),
        onClick: ()=>setFlip(!flip),
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: (0, $fcf061de51445294$export$2e2bcd8739ae039)(flip ? "[transform:rotateY(360deg)]" : "[transform:rotateY(180deg)]", "[transform-style:preserve-3d] transition-all duration-700 w-full h-full"),
            children: flip ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-[340px] h-full p-4 overflow-y-scroll",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                            className: "text-xl font-semibold mb-2",
                            children: nft.metadata.name
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                            className: "text-gray-600 text-sm",
                            children: nft.metadata.description
                        }),
                        hasAttributes && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "p-4",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("h4", {
                                    className: "font-semibold",
                                    children: "Attributes"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                    children: nft.metadata.attributes.map((attribute, attrIndex)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                            className: "text-sm text-gray-600",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("strong", {
                                                    children: [
                                                        attribute.trait_type,
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                attribute.value
                                            ]
                                        }, attrIndex))
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-col h-fit sm:w-[320px] md:w-[360px] lg:w-[340px] 2xl:w-[320px] 3xl:w-[340px]",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "sm:h-[320px] md:h-[360px] lg:h-[340px] 2x:h-[320px] 3xl:h-[340px] flex flex-col justify-center items-center",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: " h-full w-full rounded-md overflow-hidden flex justify-center",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                src: imageUrl ?? "",
                                alt: `NFT ${nft?.tokenId}`,
                                className: (0, $fcf061de51445294$export$2e2bcd8739ae039)("h-full w-full object-contain transition rounded-md", !loadedImages[nft?.tokenId] ? "hidden" : "", convertIPFSToHTTPCheck(nft?.metadata?.image || "") ? "group-hover:scale-125" : ""),
                                onLoad: ()=>handleImageLoad(nft?.tokenId),
                                onError: (e)=>{
                                    e.target.onerror = null;
                                    e.target.src = (0, (/*@__PURE__*/$parcel$interopDefault($7c8a92f55f3054aa$exports))); // Display a fallback image
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "row-span-1 p-2 text-center flex flex-col justify-evenly items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "row-span-1 flex justify-center items-center text-gray-900 overflow-scroll-x",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "group text-2xl font-semibold p-2 py-2 truncate ... text-center flex justify-center items-center  w-[340px] px-4",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27d9ac66a331f667$export$2e2bcd8739ae039), {
                                            className: "h-6 w-6 mr-2 mb-0.5 group-hover:text-primary"
                                        }),
                                        nft.metadata.name
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex flex-col mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "font-semibold text-xl text-gray-700 mb-1",
                                        children: "Floor price:"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                        className: "flex justify-center items-center text-center gap-2 font-monda w-full text-3xl text-gray-900 ",
                                        children: [
                                            (nft.most_recent_price / 1e18).toLocaleString("en-US", {
                                                maximumFractionDigits: nft.most_recent_price / 1e18 > 0.9 ? 2 : 3
                                            }),
                                            " ",
                                            "ETH"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex flex-wrap items-center justify-center text-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "font-semibold text-xl text-gray-700",
                                        children: "Most recent purchase:"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "flex justify-center  items-center text-center gap-1 font-monda w-full text-2xl text-gray-900",
                                        children: nft.trade_timestamp.split(" ")[0]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}



function $ae19c796fd8bb77f$var$DisplayNFT() {
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const address = new URLSearchParams(location.search).get("address");
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    (0, $exYeM.useEffect)(()=>{
        if (localStorage.getItem("user") === null) navigate("/Footprint");
    }, [
        navigate
    ]);
    const [currentPage, setCurrentPage] = (0, $exYeM.useState)(1);
    const itemsPerPage = 15;
    const [loadedImages, setLoadedImages] = (0, $exYeM.useState)({});
    const { isLoading: isLoading, isError: isError, data: nftData } = (0, $82fcdbab225b8669$export$2e2bcd8739ae039)();
    const uniqueNfts = new Map();
    const filteredNftData = nftData?.filter((nft)=>{
        if (uniqueNfts.has(nft.tokenId)) return false;
        else {
            uniqueNfts.set(nft.tokenId, true);
            return true;
        }
    });
    if (!address) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: "Please enter an address to view NFT holdings."
    });
    let totalValueInWei = BigInt(0);
    let liquidityScores = [];
    let nftCount = 0;
    filteredNftData?.forEach((nft)=>{
        const priceInWei = BigInt(nft.most_recent_price);
        totalValueInWei += priceInWei;
        nftCount += 1;
        const tradeTime = new Date(nft.trade_timestamp).getTime();
        const now = new Date().getTime();
        const hoursDiff = (now - tradeTime) / (1000 * 60 * 60);
        if (hoursDiff <= 1) liquidityScores.push("Amazing");
        else if (hoursDiff <= 24) liquidityScores.push("Good");
        else if (hoursDiff <= 168) liquidityScores.push("Poor");
        else liquidityScores.push("Bad");
    });
    const totalValueInEther = Number(totalValueInWei) / 1e18;
    const formattedTotalValue = totalValueInEther.toFixed(4);
    const averagePriceInEther = nftCount > 0 ? totalValueInEther / nftCount : 0;
    const formattedAveragePrice = averagePriceInEther.toFixed(4);
    const liquidityCount = liquidityScores.reduce((acc, score)=>{
        acc[score] = (acc[score] || 0) + 1;
        return acc;
    }, {});
    let mostCommonLiquidity = "N/A";
    if (Object.keys(liquidityCount).length > 0) mostCommonLiquidity = Object.keys(liquidityCount).reduce((a, b)=>liquidityCount[a] > liquidityCount[b] ? a : b);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredNftData?.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = filteredNftData?.length || 0;
    const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    const renderPageNumbers = ()=>{
        let pages = [];
        const maxVisiblePages = 5;
        let startPage, endPage;
        if (totalPages <= maxVisiblePages) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }
        for(let i = startPage; i <= endPage; i++)pages.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$389c2523d2fb7ac8), {
            onClick: ()=>setCurrentPage(i),
            isActive: currentPage === i,
            children: i
        }, i));
        return pages;
    };
    if (isError) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-full flex flex-col gap-4 font-roboto p-2 px-4",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "h-64 font-monda text-5xl flex flex-col gap-4 text-center items-center mt-6 text-red-400",
            children: [
                "error",
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "text-gray-700 text-3xl",
                    children: "Can not retrieve values from this wallet address"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "text-gray-700 text-3xl",
                    children: "Refresh and try again"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                    className: "w-fit text-white mt-2",
                    onClick: ()=>navigate("/Footprint"),
                    children: "Return to Footprint"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "w-full font-roboto p-2 px-4 ",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "grid grid-cols-3 gap-4 mb-4 ",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                            className: "col-span-1",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                        className: "break-words",
                                        children: "Total Value"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                    children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                        additionalClasses: "flex-grow"
                                    }) : Number(formattedTotalValue).toFixed(3)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                            className: "col-span-1",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                        className: "break-words",
                                        children: "Average Price"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                    children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                        additionalClasses: "flex-grow"
                                    }) : formattedAveragePrice
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                            className: "col-span-1",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                                        className: "break-words",
                                        children: "Average Liquidity"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                                    children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                                        additionalClasses: "flex-grow"
                                    }) : mostCommonLiquidity
                                })
                            ]
                        })
                    ]
                }),
                isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "min-h-[400px] md:min-h-[800px] flex flex-col",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6b436d392117be9$export$2e2bcd8739ae039), {
                        className: "flex flex-col flex-grow col-span-full"
                    })
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5 gap-4 gap-y-6 justify-items-center",
                    children: currentItems?.map((nft, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $94be1ea1523e1b53$export$2e2bcd8739ae039), {
                            nft: nft,
                            setLoadedImages: setLoadedImages,
                            loadedImages: loadedImages
                        }, index))
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "flex justify-center pt-4",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $7c10522a8a55d5a2$export$68f5e1453c188a82), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$c38bddd65ea050e7), {
                                onClick: ()=>setCurrentPage((prev)=>Math.max(1, prev - 1)),
                                disabled: currentPage === 1
                            }),
                            renderPageNumbers(),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c10522a8a55d5a2$export$ef9c8bfc54489a24), {
                                onClick: ()=>setCurrentPage((prev)=>Math.min(totalPages, prev + 1)),
                                disabled: currentPage === totalPages
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $ae19c796fd8bb77f$export$2e2bcd8739ae039 = $ae19c796fd8bb77f$var$DisplayNFT;


// boilerplate stuff in

var $aSiaI = parcelRequire("aSiaI");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");





// Required Highcharts modules
(parcelRequire("b6McJ"))((0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))));

(parcelRequire("4N9yf"))((0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))));
var $1a0c3c818e957e66$var$largeWatermark = (0, (/*@__PURE__*/$parcel$interopDefault($1b9fd1c61e334a1c$exports)));
var $1a0c3c818e957e66$var$smallWatermark = (0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports)));
const $1a0c3c818e957e66$var$convertHexToRGBA = (hexCode, opacity)=>{
    let hex = hexCode.replace("#", "");
    if (hex.length === 3) hex = [
        ...hex
    ].map((x)=>x + x).join("");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
const $1a0c3c818e957e66$var$configurePieChart = (chartConfig)=>{
    return {
        series: chartConfig.series.map((s)=>({
                type: "pie",
                name: s.name,
                data: s.data.map((d)=>({
                        //this part different to normal charts
                        name: d.name,
                        y: d.y,
                        color: $1a0c3c818e957e66$var$convertHexToRGBA(s.color, 0.5)
                    }))
            }))
    };
};
//specific chart related settings ~ not related to data ingestion just styles
const $1a0c3c818e957e66$var$chartConfigurations = {
    line: {
        chart: {
            type: "line"
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            }
        },
        tooltip: {
            enabled: true
        },
        xAxis: {
            visible: true
        },
        yAxis: {
            visible: true
        }
    },
    column: {
        chart: {
            type: "column"
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        tooltip: {
            enabled: true
        },
        xAxis: {
            visible: true
        },
        yAxis: {
            visible: true
        }
    },
    spline: {
        chart: {
            type: "spline"
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            }
        },
        tooltip: {
            enabled: true
        },
        xAxis: {
            visible: true
        },
        yAxis: {
            visible: true
        }
    },
    area: {
        chart: {
            type: "area"
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            area: {
                lineWidth: 1,
                states: {
                    hover: {
                        lineWidth: 1
                    }
                },
                threshold: null
            }
        },
        tooltip: {
            enabled: true
        },
        xAxis: {
            visible: true
        },
        yAxis: {
            visible: true
        }
    },
    scatter: {
        chart: {
            type: "scatter"
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            scatter: {
                marker: {
                    radius: 5,
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: "rgb(100,100,100)"
                        }
                    }
                },
                tooltip: {
                    headerFormat: "<b>{series.name}</b><br>",
                    pointFormat: "{point.x}, {point.y}"
                }
            }
        },
        tooltip: {
            enabled: true
        },
        xAxis: {
            visible: true
        },
        yAxis: {
            visible: true
        },
        navigator: {
            enabled: true
        },
        rangeSelector: {
            enabled: true
        }
    },
    pie: {
        chart: {
            type: "pie"
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: "pointer",
                dataLabels: {
                    enabled: true,
                    format: "<b>{point.name}</b>: {point.percentage:.1f} %"
                }
            }
        },
        tooltip: {
            enabled: false
        },
        xAxis: {
            visible: false
        },
        yAxis: {
            visible: false
        },
        navigator: {
            enabled: false
        },
        rangeSelector: {
            enabled: false
        },
        scrollbar: {
            enabled: false
        }
    }
};
const $1a0c3c818e957e66$var$ChartComponent = ({ chartConfig: chartConfig })=>{
    const chartRef = (0, $exYeM.useRef)(null);
    const [chartOptions, setChartOptions] = (0, $exYeM.useState)({
        exporting: {
            enabled: false,
            enableImages: true
        },
        legend: {
            enabled: true,
            itemStyle: {
                // color: text,
                fontWeight: "bold"
            }
        },
        chart: {
            type: chartConfig.chartType || "line",
            zoomType: "x",
            style: {
                fontFamily: "Monda"
            },
            events: {
                load: function() {
                    const chart = this; // 'this' refers to the Highcharts chart object
                    let width_image = 627.98;
                    let height_image = 127;
                    let textX = chart.plotLeft + chart.plotWidth * 0.5;
                    let textY = chart.plotTop + chart.plotHeight * 0.5;
                    let position_x = textX - width_image / 2;
                    let position_y = textY - height_image / 2;
                    // Store the watermark reference in the chart object for easy access
                    chart.watermark = chart.renderer.image($1a0c3c818e957e66$var$largeWatermark, position_x, position_y, width_image, height_image).add();
                },
                redraw: function() {
                    const chart = this;
                    let plotWidth = chart.plotWidth;
                    let threshold = 800;
                    let watermark = chart.watermark; // Access the watermark stored in the chart object
                    if (plotWidth < threshold && watermark.href !== $1a0c3c818e957e66$var$smallWatermark) {
                        let width_image_sm = 152;
                        let height_image_sm = 100;
                        let textX_sm = chart.plotLeft + chart.plotWidth * 0.5;
                        let textY_sm = chart.plotTop + chart.plotHeight * 0.5;
                        let position_x_sm = textX_sm - width_image_sm / 2;
                        let position_y_sm = textY_sm - height_image_sm / 2;
                        watermark.attr({
                            href: $1a0c3c818e957e66$var$smallWatermark,
                            x: position_x_sm,
                            y: position_y_sm,
                            width: width_image_sm,
                            height: height_image_sm
                        });
                    } else if (plotWidth >= threshold && watermark.href !== $1a0c3c818e957e66$var$largeWatermark) {
                        let width_image = 627.98;
                        let height_image = 127;
                        let textX = chart.plotLeft + chart.plotWidth * 0.5;
                        let textY = chart.plotTop + chart.plotHeight * 0.5;
                        let position_x = textX - width_image / 2;
                        let position_y = textY - height_image / 2;
                        watermark.attr({
                            href: $1a0c3c818e957e66$var$largeWatermark,
                            x: position_x,
                            y: position_y,
                            width: width_image,
                            height: height_image
                        });
                    }
                }
            }
        },
        scrollbar: {
            enabled: false
        },
        title: {
            text: "Loading..."
        },
        xAxis: {
            type: "datetime",
            title: {
                text: "Date"
            }
        },
        yAxis: {
            title: {
                text: "Value"
            }
        },
        series: [
            {
                name: "Loading data...",
                data: []
            }
        ],
        // Adding the plotOptions with the turboThreshold setting
        plotOptions: {
            series: {
                turboThreshold: 0
            }
        },
        credits: {
            enabled: false
        },
        navigator: {
            maskFill: "rgba(250, 145, 115, 0.35)"
        },
        rangeSelector: {
            enabled: false
        },
        accessibility: {
            enabled: false
        }
    });
    // Helper function to merge chart type specific configurations
    const mergeTypeSpecificConfigurations = (baseOptions, chartType)=>{
        const typeSpecificSettings = $1a0c3c818e957e66$var$chartConfigurations[chartType] || {};
        return {
            ...baseOptions,
            ...typeSpecificSettings
        };
    };
    // if nothing is specified have the loading state which would
    (0, $exYeM.useEffect)(()=>{
        if (chartConfig) {
            let baseOptions = {
                chart: {
                    type: chartConfig.chartType || "line"
                },
                title: {
                    text: chartConfig.title || "Custom Chart Title"
                },
                xAxis: {
                    type: "datetime",
                    title: {
                        text: chartConfig.xAxisVariable || ""
                    }
                },
                yAxis: [],
                series: [],
                plotOptions: {
                    series: {
                        turboThreshold: 5000
                    }
                }
            };
            if (chartConfig.chartType === "pie") {
                baseOptions = mergeTypeSpecificConfigurations(baseOptions, "pie");
                if (chartConfig.series) Object.assign(baseOptions, $1a0c3c818e957e66$var$configurePieChart(chartConfig));
            } else {
                baseOptions = mergeTypeSpecificConfigurations(baseOptions, chartConfig.chartType);
                if (chartConfig.series) {
                    baseOptions.yAxis = chartConfig.series.map((s, index)=>({
                            id: `yAxis-${index}`,
                            title: {
                                text: s.name
                            },
                            opposite: index % 2 !== 0
                        }));
                    baseOptions.series = chartConfig.series.map((s, index)=>({
                            ...s,
                            yAxis: `yAxis-${index}`,
                            type: chartConfig.chartType,
                            color: $1a0c3c818e957e66$var$convertHexToRGBA(s.color, 0.66)
                        }));
                }
            }
            setChartOptions(baseOptions);
            setTimeout(()=>{
                if (chartRef.current && chartRef.current.chart) chartRef.current.chart.zoomOut();
            }, 100);
        }
    }, [
        chartConfig
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
        highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))),
        constructorType: "stockChart",
        options: chartOptions,
        containerProps: {
            style: {
                height: "100%"
            }
        },
        ref: chartRef
    });
};
var $1a0c3c818e957e66$export$2e2bcd8739ae039 = $1a0c3c818e957e66$var$ChartComponent;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
function $cc59cc03e94132b7$var$u() {
    return ($cc59cc03e94132b7$var$u = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }).apply(this, arguments);
}
function $cc59cc03e94132b7$var$c(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)r.indexOf(t = a[n]) >= 0 || (o[t] = e[t]);
    return o;
}
function $cc59cc03e94132b7$var$i(e) {
    var t = (0, $exYeM.useRef)(e), n = (0, $exYeM.useRef)(function(e) {
        t.current && t.current(e);
    });
    return t.current = e, n.current;
}
var $cc59cc03e94132b7$var$s = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = 1), e > t ? t : e < r ? r : e;
}, $cc59cc03e94132b7$var$f = function(e) {
    return "touches" in e;
}, $cc59cc03e94132b7$var$v = function(e) {
    return e && e.ownerDocument.defaultView || self;
}, $cc59cc03e94132b7$var$d = function(e, r, t) {
    var n = e.getBoundingClientRect(), o = $cc59cc03e94132b7$var$f(r) ? function(e, r) {
        for(var t = 0; t < e.length; t++)if (e[t].identifier === r) return e[t];
        return e[0];
    }(r.touches, t) : r;
    return {
        left: $cc59cc03e94132b7$var$s((o.pageX - (n.left + $cc59cc03e94132b7$var$v(e).pageXOffset)) / n.width),
        top: $cc59cc03e94132b7$var$s((o.pageY - (n.top + $cc59cc03e94132b7$var$v(e).pageYOffset)) / n.height)
    };
}, $cc59cc03e94132b7$var$h = function(e) {
    !$cc59cc03e94132b7$var$f(e) && e.preventDefault();
}, $cc59cc03e94132b7$var$m = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function(o) {
    var a = o.onMove, l = o.onKey, s = $cc59cc03e94132b7$var$c(o, [
        "onMove",
        "onKey"
    ]), m = (0, $exYeM.useRef)(null), g = $cc59cc03e94132b7$var$i(a), p = $cc59cc03e94132b7$var$i(l), b = (0, $exYeM.useRef)(null), _ = (0, $exYeM.useRef)(!1), x = (0, $exYeM.useMemo)(function() {
        var e = function(e) {
            $cc59cc03e94132b7$var$h(e), ($cc59cc03e94132b7$var$f(e) ? e.touches.length > 0 : e.buttons > 0) && m.current ? g($cc59cc03e94132b7$var$d(m.current, e, b.current)) : t(!1);
        }, r = function() {
            return t(!1);
        };
        function t(t) {
            var n = _.current, o = $cc59cc03e94132b7$var$v(m.current), a = t ? o.addEventListener : o.removeEventListener;
            a(n ? "touchmove" : "mousemove", e), a(n ? "touchend" : "mouseup", r);
        }
        return [
            function(e) {
                var r = e.nativeEvent, n = m.current;
                if (n && ($cc59cc03e94132b7$var$h(r), !function(e, r) {
                    return r && !$cc59cc03e94132b7$var$f(e);
                }(r, _.current) && n)) {
                    if ($cc59cc03e94132b7$var$f(r)) {
                        _.current = !0;
                        var o = r.changedTouches || [];
                        o.length && (b.current = o[0].identifier);
                    }
                    n.focus(), g($cc59cc03e94132b7$var$d(n, r, b.current)), t(!0);
                }
            },
            function(e) {
                var r = e.which || e.keyCode;
                r < 37 || r > 40 || (e.preventDefault(), p({
                    left: 39 === r ? .05 : 37 === r ? -0.05 : 0,
                    top: 40 === r ? .05 : 38 === r ? -0.05 : 0
                }));
            },
            t
        ];
    }, [
        p,
        g
    ]), C = x[0], E = x[1], H = x[2];
    return (0, $exYeM.useEffect)(function() {
        return H;
    }, [
        H
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", $cc59cc03e94132b7$var$u({}, s, {
        onTouchStart: C,
        onMouseDown: C,
        className: "react-colorful__interactive",
        ref: m,
        onKeyDown: E,
        tabIndex: 0,
        role: "slider"
    }));
}), $cc59cc03e94132b7$var$g = function(e) {
    return e.filter(Boolean).join(" ");
}, $cc59cc03e94132b7$var$p = function(r) {
    var t = r.color, n = r.left, o = r.top, a = void 0 === o ? .5 : o, l = $cc59cc03e94132b7$var$g([
        "react-colorful__pointer",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: l,
        style: {
            top: 100 * a + "%",
            left: 100 * n + "%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "react-colorful__pointer-fill",
        style: {
            backgroundColor: t
        }
    }));
}, $cc59cc03e94132b7$var$b = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = Math.pow(10, r)), Math.round(t * e) / t;
}, $cc59cc03e94132b7$var$_ = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $cc59cc03e94132b7$var$x = function(e) {
    return $cc59cc03e94132b7$var$L($cc59cc03e94132b7$var$C(e));
}, $cc59cc03e94132b7$var$C = function(e) {
    return "#" === e[0] && (e = e.substring(1)), e.length < 6 ? {
        r: parseInt(e[0] + e[0], 16),
        g: parseInt(e[1] + e[1], 16),
        b: parseInt(e[2] + e[2], 16),
        a: 4 === e.length ? $cc59cc03e94132b7$var$b(parseInt(e[3] + e[3], 16) / 255, 2) : 1
    } : {
        r: parseInt(e.substring(0, 2), 16),
        g: parseInt(e.substring(2, 4), 16),
        b: parseInt(e.substring(4, 6), 16),
        a: 8 === e.length ? $cc59cc03e94132b7$var$b(parseInt(e.substring(6, 8), 16) / 255, 2) : 1
    };
}, $cc59cc03e94132b7$var$E = function(e, r) {
    return void 0 === r && (r = "deg"), Number(e) * ($cc59cc03e94132b7$var$_[r] || 1);
}, $cc59cc03e94132b7$var$H = function(e) {
    var r = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $cc59cc03e94132b7$var$N({
        h: $cc59cc03e94132b7$var$E(r[1], r[2]),
        s: Number(r[3]),
        l: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $cc59cc03e94132b7$var$M = $cc59cc03e94132b7$var$H, $cc59cc03e94132b7$var$N = function(e) {
    var r = e.s, t = e.l;
    return {
        h: e.h,
        s: (r *= (t < 50 ? t : 100 - t) / 100) > 0 ? 2 * r / (t + r) * 100 : 0,
        v: t + r,
        a: e.a
    };
}, $cc59cc03e94132b7$var$w = function(e) {
    return $cc59cc03e94132b7$var$K($cc59cc03e94132b7$var$I(e));
}, $cc59cc03e94132b7$var$y = function(e) {
    var r = e.s, t = e.v, n = e.a, o = (200 - r) * t / 100;
    return {
        h: $cc59cc03e94132b7$var$b(e.h),
        s: $cc59cc03e94132b7$var$b(o > 0 && o < 200 ? r * t / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
        l: $cc59cc03e94132b7$var$b(o / 2),
        a: $cc59cc03e94132b7$var$b(n, 2)
    };
}, $cc59cc03e94132b7$var$q = function(e) {
    var r = $cc59cc03e94132b7$var$y(e);
    return "hsl(" + r.h + ", " + r.s + "%, " + r.l + "%)";
}, $cc59cc03e94132b7$var$k = function(e) {
    var r = $cc59cc03e94132b7$var$y(e);
    return "hsla(" + r.h + ", " + r.s + "%, " + r.l + "%, " + r.a + ")";
}, $cc59cc03e94132b7$var$I = function(e) {
    var r = e.h, t = e.s, n = e.v, o = e.a;
    r = r / 360 * 6, t /= 100, n /= 100;
    var a = Math.floor(r), l = n * (1 - t), u = n * (1 - (r - a) * t), c = n * (1 - (1 - r + a) * t), i = a % 6;
    return {
        r: $cc59cc03e94132b7$var$b(255 * [
            n,
            u,
            l,
            l,
            c,
            n
        ][i]),
        g: $cc59cc03e94132b7$var$b(255 * [
            c,
            n,
            n,
            u,
            l,
            l
        ][i]),
        b: $cc59cc03e94132b7$var$b(255 * [
            l,
            l,
            c,
            n,
            n,
            u
        ][i]),
        a: $cc59cc03e94132b7$var$b(o, 2)
    };
}, $cc59cc03e94132b7$var$O = function(e) {
    var r = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $cc59cc03e94132b7$var$A({
        h: $cc59cc03e94132b7$var$E(r[1], r[2]),
        s: Number(r[3]),
        v: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $cc59cc03e94132b7$var$j = $cc59cc03e94132b7$var$O, $cc59cc03e94132b7$var$z = function(e) {
    var r = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $cc59cc03e94132b7$var$L({
        r: Number(r[1]) / (r[2] ? 100 / 255 : 1),
        g: Number(r[3]) / (r[4] ? 100 / 255 : 1),
        b: Number(r[5]) / (r[6] ? 100 / 255 : 1),
        a: void 0 === r[7] ? 1 : Number(r[7]) / (r[8] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $cc59cc03e94132b7$var$B = $cc59cc03e94132b7$var$z, $cc59cc03e94132b7$var$D = function(e) {
    var r = e.toString(16);
    return r.length < 2 ? "0" + r : r;
}, $cc59cc03e94132b7$var$K = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = o < 1 ? $cc59cc03e94132b7$var$D($cc59cc03e94132b7$var$b(255 * o)) : "";
    return "#" + $cc59cc03e94132b7$var$D(r) + $cc59cc03e94132b7$var$D(t) + $cc59cc03e94132b7$var$D(n) + a;
}, $cc59cc03e94132b7$var$L = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = Math.max(r, t, n), l = a - Math.min(r, t, n), u = l ? a === r ? (t - n) / l : a === t ? 2 + (n - r) / l : 4 + (r - t) / l : 0;
    return {
        h: $cc59cc03e94132b7$var$b(60 * (u < 0 ? u + 6 : u)),
        s: $cc59cc03e94132b7$var$b(a ? l / a * 100 : 0),
        v: $cc59cc03e94132b7$var$b(a / 255 * 100),
        a: o
    };
}, $cc59cc03e94132b7$var$A = function(e) {
    return {
        h: $cc59cc03e94132b7$var$b(e.h),
        s: $cc59cc03e94132b7$var$b(e.s),
        v: $cc59cc03e94132b7$var$b(e.v),
        a: $cc59cc03e94132b7$var$b(e.a, 2)
    };
}, $cc59cc03e94132b7$var$S = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function(r) {
    var t = r.hue, n = r.onChange, o = $cc59cc03e94132b7$var$g([
        "react-colorful__hue",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$m, {
        onMove: function(e) {
            n({
                h: 360 * e.left
            });
        },
        onKey: function(e) {
            n({
                h: $cc59cc03e94132b7$var$s(t + 360 * e.left, 0, 360)
            });
        },
        "aria-label": "Hue",
        "aria-valuenow": $cc59cc03e94132b7$var$b(t),
        "aria-valuemax": "360",
        "aria-valuemin": "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$p, {
        className: "react-colorful__hue-pointer",
        left: t / 360,
        color: $cc59cc03e94132b7$var$q({
            h: t,
            s: 100,
            v: 100,
            a: 1
        })
    })));
}), $cc59cc03e94132b7$var$T = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function(r) {
    var t = r.hsva, n = r.onChange, o = {
        backgroundColor: $cc59cc03e94132b7$var$q({
            h: t.h,
            s: 100,
            v: 100,
            a: 1
        })
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "react-colorful__saturation",
        style: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$m, {
        onMove: function(e) {
            n({
                s: 100 * e.left,
                v: 100 - 100 * e.top
            });
        },
        onKey: function(e) {
            n({
                s: $cc59cc03e94132b7$var$s(t.s + 100 * e.left, 0, 100),
                v: $cc59cc03e94132b7$var$s(t.v - 100 * e.top, 0, 100)
            });
        },
        "aria-label": "Color",
        "aria-valuetext": "Saturation " + $cc59cc03e94132b7$var$b(t.s) + "%, Brightness " + $cc59cc03e94132b7$var$b(t.v) + "%"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$p, {
        className: "react-colorful__saturation-pointer",
        top: 1 - t.v / 100,
        left: t.s / 100,
        color: $cc59cc03e94132b7$var$q(t)
    })));
}), $cc59cc03e94132b7$var$F = function(e, r) {
    if (e === r) return !0;
    for(var t in e)if (e[t] !== r[t]) return !1;
    return !0;
}, $cc59cc03e94132b7$var$P = function(e, r) {
    return e.replace(/\s/g, "") === r.replace(/\s/g, "");
}, $cc59cc03e94132b7$var$X = function(e, r) {
    return e.toLowerCase() === r.toLowerCase() || $cc59cc03e94132b7$var$F($cc59cc03e94132b7$var$C(e), $cc59cc03e94132b7$var$C(r));
};
function $cc59cc03e94132b7$var$Y(e, t, l) {
    var u = $cc59cc03e94132b7$var$i(l), c = (0, $exYeM.useState)(function() {
        return e.toHsva(t);
    }), s = c[0], f = c[1], v = (0, $exYeM.useRef)({
        color: t,
        hsva: s
    });
    (0, $exYeM.useEffect)(function() {
        if (!e.equal(t, v.current.color)) {
            var r = e.toHsva(t);
            v.current = {
                hsva: r,
                color: t
            }, f(r);
        }
    }, [
        t,
        e
    ]), (0, $exYeM.useEffect)(function() {
        var r;
        $cc59cc03e94132b7$var$F(s, v.current.hsva) || e.equal(r = e.fromHsva(s), v.current.color) || (v.current = {
            hsva: s,
            color: r
        }, u(r));
    }, [
        s,
        e,
        u
    ]);
    var d = (0, $exYeM.useCallback)(function(e) {
        f(function(r) {
            return Object.assign({}, r, e);
        });
    }, []);
    return [
        s,
        d
    ];
}
var $cc59cc03e94132b7$var$R, $cc59cc03e94132b7$var$V = "undefined" != typeof window ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect), $cc59cc03e94132b7$var$$ = function() {
    return $cc59cc03e94132b7$var$R || ("undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0);
}, $cc59cc03e94132b7$export$c5f670b24c0ae95a = function(e) {
    $cc59cc03e94132b7$var$R = e;
}, $cc59cc03e94132b7$var$J = new Map, $cc59cc03e94132b7$var$Q = function(e) {
    $cc59cc03e94132b7$var$V(function() {
        var r = e.current ? e.current.ownerDocument : document;
        if (void 0 !== r && !$cc59cc03e94132b7$var$J.has(r)) {
            var t = r.createElement("style");
            t.innerHTML = '.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}', $cc59cc03e94132b7$var$J.set(r, t);
            var n = $cc59cc03e94132b7$var$$();
            n && t.setAttribute("nonce", n), r.head.appendChild(t);
        }
    }, []);
}, $cc59cc03e94132b7$var$U = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $cc59cc03e94132b7$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $exYeM.useRef)(null);
    $cc59cc03e94132b7$var$Q(f);
    var v = $cc59cc03e94132b7$var$Y(o, l, i), d = v[0], h = v[1], m = $cc59cc03e94132b7$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", $cc59cc03e94132b7$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$S, {
        hue: d.h,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $cc59cc03e94132b7$var$W = {
    defaultColor: "000",
    toHsva: $cc59cc03e94132b7$var$x,
    fromHsva: function(e) {
        return $cc59cc03e94132b7$var$w({
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        });
    },
    equal: $cc59cc03e94132b7$var$X
}, $cc59cc03e94132b7$export$a3bc3c32746e9f3a = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$U, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$W
    }));
}, $cc59cc03e94132b7$var$ee = function(r) {
    var t = r.className, n = r.hsva, o = r.onChange, a = {
        backgroundImage: "linear-gradient(90deg, " + $cc59cc03e94132b7$var$k(Object.assign({}, n, {
            a: 0
        })) + ", " + $cc59cc03e94132b7$var$k(Object.assign({}, n, {
            a: 1
        })) + ")"
    }, l = $cc59cc03e94132b7$var$g([
        "react-colorful__alpha",
        t
    ]), u = $cc59cc03e94132b7$var$b(100 * n.a);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "react-colorful__alpha-gradient",
        style: a
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$m, {
        onMove: function(e) {
            o({
                a: e.left
            });
        },
        onKey: function(e) {
            o({
                a: $cc59cc03e94132b7$var$s(n.a + e.left)
            });
        },
        "aria-label": "Alpha",
        "aria-valuetext": u + "%",
        "aria-valuenow": u,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$p, {
        className: "react-colorful__alpha-pointer",
        left: n.a,
        color: $cc59cc03e94132b7$var$k(n)
    })));
}, $cc59cc03e94132b7$var$re = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $cc59cc03e94132b7$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $exYeM.useRef)(null);
    $cc59cc03e94132b7$var$Q(f);
    var v = $cc59cc03e94132b7$var$Y(o, l, i), d = v[0], h = v[1], m = $cc59cc03e94132b7$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", $cc59cc03e94132b7$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$S, {
        hue: d.h,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$ee, {
        hsva: d,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $cc59cc03e94132b7$var$te = {
    defaultColor: "0001",
    toHsva: $cc59cc03e94132b7$var$x,
    fromHsva: $cc59cc03e94132b7$var$w,
    equal: $cc59cc03e94132b7$var$X
}, $cc59cc03e94132b7$export$ac2f77823341da45 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$re, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$te
    }));
}, $cc59cc03e94132b7$var$oe = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0,
        a: 1
    },
    toHsva: $cc59cc03e94132b7$var$N,
    fromHsva: $cc59cc03e94132b7$var$y,
    equal: $cc59cc03e94132b7$var$F
}, $cc59cc03e94132b7$export$ee0b0fc8d408da1d = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$re, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$oe
    }));
}, $cc59cc03e94132b7$var$le = {
    defaultColor: "hsla(0, 0%, 0%, 1)",
    toHsva: $cc59cc03e94132b7$var$H,
    fromHsva: $cc59cc03e94132b7$var$k,
    equal: $cc59cc03e94132b7$var$P
}, $cc59cc03e94132b7$export$989f0248ad966033 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$re, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$le
    }));
}, $cc59cc03e94132b7$var$ce = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0
    },
    toHsva: function(e) {
        return $cc59cc03e94132b7$var$N({
            h: e.h,
            s: e.s,
            l: e.l,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            h: (r = $cc59cc03e94132b7$var$y(e)).h,
            s: r.s,
            l: r.l
        };
    },
    equal: $cc59cc03e94132b7$var$F
}, $cc59cc03e94132b7$export$c737d6c85aab3af7 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$U, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$ce
    }));
}, $cc59cc03e94132b7$var$se = {
    defaultColor: "hsl(0, 0%, 0%)",
    toHsva: $cc59cc03e94132b7$var$M,
    fromHsva: $cc59cc03e94132b7$var$q,
    equal: $cc59cc03e94132b7$var$P
}, $cc59cc03e94132b7$export$f4f988c96ece960 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$U, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$se
    }));
}, $cc59cc03e94132b7$var$ve = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    },
    toHsva: function(e) {
        return e;
    },
    fromHsva: $cc59cc03e94132b7$var$A,
    equal: $cc59cc03e94132b7$var$F
}, $cc59cc03e94132b7$export$a2298f22bee4c5fd = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$re, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$ve
    }));
}, $cc59cc03e94132b7$var$he = {
    defaultColor: "hsva(0, 0%, 0%, 1)",
    toHsva: $cc59cc03e94132b7$var$O,
    fromHsva: function(e) {
        var r = $cc59cc03e94132b7$var$A(e);
        return "hsva(" + r.h + ", " + r.s + "%, " + r.v + "%, " + r.a + ")";
    },
    equal: $cc59cc03e94132b7$var$P
}, $cc59cc03e94132b7$export$b2c7d62665b7ee26 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$re, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$he
    }));
}, $cc59cc03e94132b7$var$ge = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0
    },
    toHsva: function(e) {
        return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        };
    },
    fromHsva: function(e) {
        var r = $cc59cc03e94132b7$var$A(e);
        return {
            h: r.h,
            s: r.s,
            v: r.v
        };
    },
    equal: $cc59cc03e94132b7$var$F
}, $cc59cc03e94132b7$export$580e7249020ee39f = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$U, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$ge
    }));
}, $cc59cc03e94132b7$var$be = {
    defaultColor: "hsv(0, 0%, 0%)",
    toHsva: $cc59cc03e94132b7$var$j,
    fromHsva: function(e) {
        var r = $cc59cc03e94132b7$var$A(e);
        return "hsv(" + r.h + ", " + r.s + "%, " + r.v + "%)";
    },
    equal: $cc59cc03e94132b7$var$P
}, $cc59cc03e94132b7$export$ef09412d0ef04fda = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$U, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$be
    }));
}, $cc59cc03e94132b7$var$xe = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    },
    toHsva: $cc59cc03e94132b7$var$L,
    fromHsva: $cc59cc03e94132b7$var$I,
    equal: $cc59cc03e94132b7$var$F
}, $cc59cc03e94132b7$export$e9c07ef2be187cb1 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$re, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$xe
    }));
}, $cc59cc03e94132b7$var$Ee = {
    defaultColor: "rgba(0, 0, 0, 1)",
    toHsva: $cc59cc03e94132b7$var$z,
    fromHsva: function(e) {
        var r = $cc59cc03e94132b7$var$I(e);
        return "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + r.a + ")";
    },
    equal: $cc59cc03e94132b7$var$P
}, $cc59cc03e94132b7$export$be07dcc7abc11a36 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$re, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$Ee
    }));
}, $cc59cc03e94132b7$var$Me = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0
    },
    toHsva: function(e) {
        return $cc59cc03e94132b7$var$L({
            r: e.r,
            g: e.g,
            b: e.b,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            r: (r = $cc59cc03e94132b7$var$I(e)).r,
            g: r.g,
            b: r.b
        };
    },
    equal: $cc59cc03e94132b7$var$F
}, $cc59cc03e94132b7$export$5ac2ba36722d4bd2 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$U, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$Me
    }));
}, $cc59cc03e94132b7$var$we = {
    defaultColor: "rgb(0, 0, 0)",
    toHsva: $cc59cc03e94132b7$var$B,
    fromHsva: function(e) {
        var r = $cc59cc03e94132b7$var$I(e);
        return "rgb(" + r.r + ", " + r.g + ", " + r.b + ")";
    },
    equal: $cc59cc03e94132b7$var$P
}, $cc59cc03e94132b7$export$9d70f030bf44a214 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$U, $cc59cc03e94132b7$var$u({}, r, {
        colorModel: $cc59cc03e94132b7$var$we
    }));
}, $cc59cc03e94132b7$var$qe = /^#?([0-9A-F]{3,8})$/i, $cc59cc03e94132b7$var$ke = function(r) {
    var t = r.color, l = void 0 === t ? "" : t, s = r.onChange, f = r.onBlur, v = r.escape, d = r.validate, h = r.format, m = r.process, g = $cc59cc03e94132b7$var$c(r, [
        "color",
        "onChange",
        "onBlur",
        "escape",
        "validate",
        "format",
        "process"
    ]), p = (0, $exYeM.useState)(function() {
        return v(l);
    }), b = p[0], _ = p[1], x = $cc59cc03e94132b7$var$i(s), C = $cc59cc03e94132b7$var$i(f), E = (0, $exYeM.useCallback)(function(e) {
        var r = v(e.target.value);
        _(r), d(r) && x(m ? m(r) : r);
    }, [
        v,
        m,
        d,
        x
    ]), H = (0, $exYeM.useCallback)(function(e) {
        d(e.target.value) || _(v(l)), C(e);
    }, [
        l,
        v,
        d,
        C
    ]);
    return (0, $exYeM.useEffect)(function() {
        _(v(l));
    }, [
        l,
        v
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("input", $cc59cc03e94132b7$var$u({}, g, {
        value: h ? h(b) : b,
        spellCheck: "false",
        onChange: E,
        onBlur: H
    }));
}, $cc59cc03e94132b7$var$Ie = function(e) {
    return "#" + e;
}, $cc59cc03e94132b7$export$9219d762117624b6 = function(r) {
    var t = r.prefixed, n = r.alpha, o = $cc59cc03e94132b7$var$c(r, [
        "prefixed",
        "alpha"
    ]), l = (0, $exYeM.useCallback)(function(e) {
        return e.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
    }, [
        n
    ]), i = (0, $exYeM.useCallback)(function(e) {
        return function(e, r) {
            var t = $cc59cc03e94132b7$var$qe.exec(e), n = t ? t[1].length : 0;
            return 3 === n || 6 === n || !!r && 4 === n || !!r && 8 === n;
        }(e, n);
    }, [
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc59cc03e94132b7$var$ke, $cc59cc03e94132b7$var$u({}, o, {
        escape: l,
        format: t ? $cc59cc03e94132b7$var$Ie : void 0,
        process: $cc59cc03e94132b7$var$Ie,
        validate: i
    }));
};


function $62c11e4655d65bf0$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, allKeys: allKeys }) {
    const cancelButtonRef = (0, $exYeM.useRef)(null);
    // New states for chart configuration
    const [chartType, setChartType] = (0, $exYeM.useState)("line");
    const [xAxisVariable, setXAxisVariable] = (0, $exYeM.useState)("");
    const [title, setTitle] = (0, $exYeM.useState)(""); // State for chart title
    (0, $exYeM.useEffect)(()=>{
        if (allKeys.length > 0 && xAxisVariable === "") setXAxisVariable(allKeys[0]);
    }, [
        isOpen,
        allKeys
    ]);
    // pass this into the dialog sectiopn and then into the
    const style = [
        {
            name: "Line",
            data: "line"
        },
        {
            name: "Bar",
            data: "column"
        },
        {
            name: "Spline",
            data: "spline"
        },
        {
            name: "Area",
            data: "area"
        },
        {
            name: "Scatter",
            data: "scatter"
        },
        {
            name: "Pie",
            data: "pie"
        }
    ];
    // Updated states for multiple Y-axis configurations
    const [yAxes, setYAxes] = (0, $exYeM.useState)([
        {
            variable: "",
            color: "#000000"
        }
    ]); // Default to one axis
    // Function to handle adding a new Y-axis configuration
    const addYAxis = ()=>{
        setYAxes([
            ...yAxes,
            {
                variable: "",
                color: "#000000"
            }
        ]); // Default color for new axis
    };
    // Function to handle removing a Y-axis configuration
    const removeYAxis = (index)=>{
        const newYAxes = [
            ...yAxes
        ];
        newYAxes.splice(index, 1);
        setYAxes(newYAxes);
    };
    // Function to update a specific Y-axis configuration
    const updateYAxis = (index, key, value)=>{
        const newYAxes = [
            ...yAxes
        ];
        newYAxes[index][key] = value;
        setYAxes(newYAxes);
    };
    // Pass the selected configuration back to the parent component
    const handleSubmit = ()=>{
        onSubmit({
            chartType: chartType,
            xAxisVariable: xAxisVariable,
            yAxes: yAxes,
            title: title
        });
        onClose();
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: isOpen,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            initialFocus: cancelButtonRef,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "sm:flex sm:items-start",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "mt-3 text-center sm:mt-0 sm:text-left w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "flex justify-end",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                            type: "button",
                                                            className: "text-gray-400 hover:text-gray-500",
                                                            onClick: onClose,
                                                            ref: cancelButtonRef,
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
                                                                className: "h-6 w-6",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "mt-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                className: "mb-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                        htmlFor: "chartTitle",
                                                                        className: "block text-sm font-medium text-gray-700",
                                                                        children: "Chart Title"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                        type: "text",
                                                                        id: "chartTitle",
                                                                        value: title,
                                                                        onChange: (e)=>setTitle(e.target.value),
                                                                        className: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md",
                                                                        placeholder: "Enter chart title"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                className: "mb-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                        htmlFor: "chartType",
                                                                        className: "block text-sm font-medium text-gray-700",
                                                                        children: "Chart Type"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("select", {
                                                                        id: "chartType",
                                                                        value: chartType,
                                                                        onChange: (e)=>setChartType(e.target.value),
                                                                        className: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md",
                                                                        children: style.map((option)=>/*#__PURE__*/ (0, $aSiaI.jsx)("option", {
                                                                                value: option.data,
                                                                                children: option.name
                                                                            }, option.data))
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                className: "mb-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                        htmlFor: "xAxisVariable",
                                                                        className: "block text-sm font-medium text-gray-700",
                                                                        children: "X-Axis Variable"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("select", {
                                                                        id: "xAxisVariable",
                                                                        value: xAxisVariable,
                                                                        onChange: (e)=>{
                                                                            setXAxisVariable(e.target.value);
                                                                        },
                                                                        className: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md",
                                                                        children: allKeys.map((key)=>/*#__PURE__*/ (0, $aSiaI.jsx)("option", {
                                                                                value: key,
                                                                                children: key
                                                                            }, key))
                                                                    })
                                                                ]
                                                            }),
                                                            yAxes.map((yAxisConfig, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                    className: "flex items-center mb-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                            className: "flex-grow",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                                    htmlFor: `yAxisVariable-${index}`,
                                                                                    className: "block text-sm font-medium text-gray-700",
                                                                                    children: "Y-Axis Variable"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("select", {
                                                                                    id: `yAxisVariable-${index}`,
                                                                                    value: yAxisConfig.variable,
                                                                                    onChange: (e)=>updateYAxis(index, "variable", e.target.value),
                                                                                    className: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md",
                                                                                    children: allKeys.map((key)=>/*#__PURE__*/ (0, $aSiaI.jsx)("option", {
                                                                                            value: key,
                                                                                            children: key
                                                                                        }, key))
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            className: "ml-4",
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                className: "w-24 h-24 relative",
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc59cc03e94132b7$export$a3bc3c32746e9f3a), {
                                                                                        color: yAxisConfig.color,
                                                                                        onChange: (color)=>updateYAxis(index, "color", color),
                                                                                        style: {
                                                                                            width: "100%",
                                                                                            height: "100%"
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                            type: "button",
                                                                            className: "ml-4 text-gray-400 hover:text-gray-500",
                                                                            onClick: ()=>removeYAxis(index),
                                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
                                                                                className: "h-6 w-6",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        })
                                                                    ]
                                                                }, index))
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "bg-gray-50 px-4 py-3 sm:flex sm:justify-between sm:items-center sm:px-6",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: "inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primaryDark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:w-auto sm:text-sm",
                                                onClick: addYAxis,
                                                children: "Add another Y variable"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "sm:flex sm:flex-row-reverse sm:space-x-0 sm:space-x-reverse",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                        type: "button",
                                                        className: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primaryDark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-3 sm:w-auto sm:text-sm",
                                                        onClick: handleSubmit,
                                                        children: "Save"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                        type: "button",
                                                        className: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm",
                                                        onClick: onClose,
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}



// Export.js
function $71cca3bac7a67ec7$var$convertToCSV(objArray) {
    const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    // Extract headers
    const header = Object.keys(array[0]);
    str += header.join(",") + "\r\n";
    // Extract rows
    for(let i = 0; i < array.length; i++){
        let line = "";
        for(let index in array[i]){
            if (line !== "") line += ",";
            line += array[i][index];
        }
        str += line + "\r\n";
    }
    return str;
}
function $71cca3bac7a67ec7$export$60d51d3f7c4f92d8(data, filename = "data.csv") {
    const csvData = $71cca3bac7a67ec7$var$convertToCSV(data);
    const blob = new Blob([
        csvData
    ], {
        type: "text/csv;charset=utf-8;"
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}




var $exYeM = parcelRequire("exYeM");
function $bf705da18b84f1aa$var$ArrowDownTrayIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z",
        clipRule: "evenodd"
    }));
}
const $bf705da18b84f1aa$var$ForwardRef = $exYeM.forwardRef($bf705da18b84f1aa$var$ArrowDownTrayIcon);
var $bf705da18b84f1aa$export$2e2bcd8739ae039 = $bf705da18b84f1aa$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $4462dec2a736c95c$var$ChartBarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75zM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 01-1.875-1.875V8.625zM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 013 19.875v-6.75z"
    }));
}
const $4462dec2a736c95c$var$ForwardRef = $exYeM.forwardRef($4462dec2a736c95c$var$ChartBarIcon);
var $4462dec2a736c95c$export$2e2bcd8739ae039 = $4462dec2a736c95c$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $562d3b51b52cc01d$var$TableCellsIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 18.375V5.625zM21 9.375A.375.375 0 0020.625 9h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 00.375-.375v-1.5zm0 3.75a.375.375 0 00-.375-.375h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 00.375-.375v-1.5zm0 3.75a.375.375 0 00-.375-.375h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 00.375-.375v-1.5zM10.875 18.75a.375.375 0 00.375-.375v-1.5a.375.375 0 00-.375-.375h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375h7.5zM3.375 15h7.5a.375.375 0 00.375-.375v-1.5a.375.375 0 00-.375-.375h-7.5a.375.375 0 00-.375.375v1.5c0 .207.168.375.375.375zm0-3.75h7.5a.375.375 0 00.375-.375v-1.5A.375.375 0 0010.875 9h-7.5A.375.375 0 003 9.375v1.5c0 .207.168.375.375.375z",
        clipRule: "evenodd"
    }));
}
const $562d3b51b52cc01d$var$ForwardRef = $exYeM.forwardRef($562d3b51b52cc01d$var$TableCellsIcon);
var $562d3b51b52cc01d$export$2e2bcd8739ae039 = $562d3b51b52cc01d$var$ForwardRef;



const $a749a2c12abc4cb4$var$BottomTable = /*#__PURE__*/ (0, $exYeM.forwardRef)(({ activeTab: activeTab, queryData: queryData, handleTabSwitch: handleTabSwitch, chartConfig: chartConfig, isOpen: isOpen, handleCloseModal: handleCloseModal, handleOpenModal: handleOpenModal, handleOnSubmit: handleOnSubmit, allKeys: allKeys, columns: columns, isMinimized: isMinimized }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
        className: `flex flex-col ${isMinimized ? "" : ""} transition-all duration-300 overflow-hidden p-4`,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "mb-4 flex justify-between",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                            className: "hidden md:inline-flex rounded-md shadow-lg bg-surfaceVariant",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                    onClick: ()=>handleTabSwitch("table"),
                                    className: `${activeTab === "table" ? "bg-primary text-white" : "text-gray-700 hover:bg-primary hover:text-white"} px-4 py-2 text-sm font-medium focus:outline-none rounded-l-md flex items-center`,
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $562d3b51b52cc01d$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 mr-2",
                                            "aria-hidden": "true"
                                        }),
                                        "Table"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                    onClick: ()=>handleTabSwitch("chart"),
                                    disabled: !chartConfig,
                                    className: `${activeTab === "chart" ? "bg-primary text-white" : "text-gray-700 hover:bg-primary hover:text-white"} ${!chartConfig ? "opacity-50 cursor-not-allowed" : ""} px-4 py-2 text-sm font-medium focus:outline-none flex items-center`,
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4462dec2a736c95c$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 mr-2",
                                            "aria-hidden": "true"
                                        }),
                                        "Graph"
                                    ]
                                }),
                                activeTab === "table" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                    onClick: ()=>(0, $71cca3bac7a67ec7$export$60d51d3f7c4f92d8)(queryData.data, "exportedQueryData.csv"),
                                    className: "text-gray-700 hover:bg-primary hover:text-white px-4 py-2 text-sm font-medium focus:outline-none flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bf705da18b84f1aa$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 mr-2",
                                            "aria-hidden": "true"
                                        }),
                                        "Export"
                                    ]
                                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                    onClick: ()=>(0, $43a7a81378273f81$export$2e2bcd8739ae039)(ref, "png"),
                                    className: "text-gray-700 hover:bg-primary hover:text-white px-4 py-2 text-sm font-medium focus:outline-none flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bf705da18b84f1aa$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 mr-2",
                                            "aria-hidden": "true"
                                        }),
                                        "Export"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                    onClick: handleOpenModal,
                                    className: "text-gray-700 hover:bg-primary hover:text-white px-4 py-2 text-sm font-medium focus:outline-none rounded-r-md flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $145c596adda84ba6$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 mr-2",
                                            "aria-hidden": "true"
                                        }),
                                        chartConfig ? "Edit" : "Add"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "md:hidden",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d), {
                                as: "div",
                                className: "",
                                children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Button, {
                                                    className: `${open ? "bg-primary text-white" : ""} group flex flex-row p-2 place-content-center bg-surfaceVariant hover:bg-primary shadow-md hover:text-white border border-primaryContainer hover:border-primary rounded-lg col-span-1`,
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2ee5a7f7ec060e3f$export$2e2bcd8739ae039), {
                                                        className: `${open ? " text-white" : ""} h-5 w-5 self-center text-gray-700 group-hover:text-white`
                                                    })
                                                })
                                            }),
                                            open && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                                                as: (0, $exYeM.Fragment),
                                                enter: "transition-opacity ease-out duration-75",
                                                enterFrom: "transform opacity-0 scale-95",
                                                enterTo: "transform opacity-100 scale-100",
                                                leave: "transition ease-in duration-75",
                                                leaveFrom: "transform opacity-100 scale-100",
                                                leaveTo: "transform opacity-0 scale-95",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9838f5ac37ea1370$export$5b6b19405a83ff9d).Panel, {
                                                    className: "absolute border-2 border-primaryContainer bg-white rounded-xl z-30 w-fit right-0",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "flex flex-col divide-y p-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                onClick: ()=>handleTabSwitch("table"),
                                                                className: "flex justify-center items-center gap-2 p-2 hover:bg-primary hover:text-white rounded-md",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $562d3b51b52cc01d$export$2e2bcd8739ae039), {
                                                                        className: "h-5 w-5",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    "Table"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                onClick: ()=>handleTabSwitch("chart"),
                                                                disabled: !chartConfig,
                                                                className: `flex justify-center items-center gap-2 p-2 hover:bg-primary hover:text-white rounded-md ${!chartConfig ? "opacity-50 cursor-not-allowed" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4462dec2a736c95c$export$2e2bcd8739ae039), {
                                                                        className: "h-5 w-5",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    "Graph"
                                                                ]
                                                            }),
                                                            activeTab === "table" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                onClick: ()=>(0, $71cca3bac7a67ec7$export$60d51d3f7c4f92d8)(queryData.data, "exportedQueryData.csv"),
                                                                className: "flex justify-center items-center gap-2 p-2 hover:bg-primary hover:text-white rounded-md",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bf705da18b84f1aa$export$2e2bcd8739ae039), {
                                                                        className: "h-5 w-5",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    "Export"
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                onClick: ()=>(0, $43a7a81378273f81$export$2e2bcd8739ae039)(ref, "png"),
                                                                className: "flex justify-center items-center gap-2 p-2 hover:bg-primary hover:text-white rounded-md",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bf705da18b84f1aa$export$2e2bcd8739ae039), {
                                                                        className: "h-5 w-5",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    "Export"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                                onClick: handleOpenModal,
                                                                className: "flex justify-center items-center gap-2 p-2 hover:bg-primary hover:text-white rounded-md",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $145c596adda84ba6$export$2e2bcd8739ae039), {
                                                                        className: "h-5 w-5",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    chartConfig ? "Edit" : "Add"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex-grow overflow-auto",
                children: activeTab === "table" ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                            className: "text-lg font-semibold mb-4",
                            children: "Query Result:"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $06f444c49b9780e9$export$df30df7ec97b32b5), {
                            pageSize: 10,
                            isRounded: true,
                            columns: columns,
                            data: queryData.data
                        })
                    ]
                }) : activeTab === "chart" && chartConfig ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "",
                    ref: ref,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1a0c3c818e957e66$export$2e2bcd8739ae039), {
                        chartConfig: chartConfig
                    })
                }) : null
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $62c11e4655d65bf0$export$2e2bcd8739ae039), {
                isOpen: isOpen,
                onClose: handleCloseModal,
                onSubmit: handleOnSubmit,
                allKeys: allKeys
            })
        ]
    }));
$a749a2c12abc4cb4$var$BottomTable.displayName = "BottomTable";
var $a749a2c12abc4cb4$export$2e2bcd8739ae039 = $a749a2c12abc4cb4$var$BottomTable;




var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



function $84789be942e9ff0a$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $84789be942e9ff0a$export$2e2bcd8739ae039() {
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, data: data, error: error } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "getPremadeQueries"
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/premadeQueries", {
                headers: {
                    Authorization: `Bearer ${$84789be942e9ff0a$var$getToken()}`
                }
            });
            return data;
        },
        staleTime: 1000
    });
    return {
        isLoading: isLoading,
        isError: isError,
        isFetching: isFetching,
        data: data,
        error: error
    };
}




function $f7e174f679c18433$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $f7e174f679c18433$export$4bfff50eb1c7dce3() {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "getSavedQueries"
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/savedQueries", {
                headers: {
                    Authorization: `Bearer ${$f7e174f679c18433$var$getToken()}`
                }
            });
            return data;
        }
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


function $711a0923c5b79c78$var$SaveQueryDialog({ open: open, setOpen: setOpen, queryName: queryName, setQueryName: setQueryName, queryDescription: queryDescription, setQueryDescription: setQueryDescription, handleSaveQuery: handleSaveQuery, isCreating: isCreating, isEdit: isEdit, handleUpdateQuery: handleUpdateQuery, handleDeleteQuery: handleDeleteQuery, selectedQueryId: selectedQueryId, chartConfig: chartConfig }) {
    const [showChartSettings, setShowChartSettings] = (0, $exYeM.useState)(!!chartConfig);
    const [isEditing, setIsEditing] = (0, $exYeM.useState)(isEdit);
    // Effect to synchronize isEditing state with isEdit prop changes.
    (0, $exYeM.useEffect)(()=>{
        setIsEditing(isEdit);
    }, [
        isEdit
    ]); // Re-run this effect if isEdit prop changes.
    const clearForm = ()=>{
        setQueryName("");
        setQueryDescription("");
    //setIsEditing(false); // Reset edit mode state
    };
    const handleClose = ()=>{
        clearForm();
        setOpen(false);
    };
    const handleDelete = ()=>{
        if (selectedQueryId && handleDeleteQuery) {
            handleDeleteQuery(selectedQueryId);
            setOpen(false);
            clearForm(); // Make sure clearForm is called here to reset the state
        }
    };
    const handleSave = ()=>{
        handleSaveQuery(showChartSettings);
    };
    const handleUpdate = ()=>{
        handleUpdateQuery(showChartSettings);
    };
    const submitButtonStyles = (loading)=>loading ? "bg-gray-300 text-gray-400" : "hover:text-white hover:bg-primary bg-primaryContainer";
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: handleClose,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $6dd567c6dd8bfc62$export$34eba2437817a67b), {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "absolute top-0 right-0 hidden pt-4 pr-4 sm:block",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                                type: "button",
                                                className: "rounded-md text-gray-400 hover:text-gray-500",
                                                onClick: handleClose,
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Close"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "sm:flex sm:items-start",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Title, {
                                                        as: "h3",
                                                        className: "text-lg leading-6 font-medium text-gray-900",
                                                        children: isEditing ? "Edit Query" : "Save Query"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
                                                            className: "text-sm text-gray-500",
                                                            children: [
                                                                "Fill in the details below to",
                                                                " ",
                                                                isEditing ? "update your" : "save a new",
                                                                " query."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "mt-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                htmlFor: "queryName",
                                                                className: "block text-sm font-medium text-gray-700",
                                                                children: "Query Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                type: "text",
                                                                name: "queryName",
                                                                id: "queryName",
                                                                value: queryName,
                                                                onChange: (e)=>setQueryName(e.target.value),
                                                                className: "mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm",
                                                                tabIndex: 0
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "mt-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                htmlFor: "queryDescription",
                                                                className: "block text-sm font-medium text-gray-700",
                                                                children: "Description"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("textarea", {
                                                                name: "queryDescription",
                                                                id: "queryDescription",
                                                                value: queryDescription,
                                                                onChange: (e)=>setQueryDescription(e.target.value),
                                                                rows: 4,
                                                                className: "mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm",
                                                                tabIndex: 0
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "mt-4 flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                                                                htmlFor: "showChartSettings",
                                                                className: "text-sm font-medium text-gray-700 mr-2",
                                                                children: "Save Chart Style"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                className: "relative inline-block w-10 align-middle select-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                                        type: "checkbox",
                                                                        id: "showChartSettings",
                                                                        checked: showChartSettings,
                                                                        onChange: ()=>setShowChartSettings(!showChartSettings),
                                                                        className: "sr-only"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                                        className: `block ${showChartSettings ? "bg-primary" : "bg-gray-300"} w-10 h-6 rounded-full cursor-pointer`,
                                                                        onClick: ()=>setShowChartSettings(!showChartSettings),
                                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                                            className: `dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition ${showChartSettings ? "transform translate-x-full" : ""}`
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse",
                                            children: [
                                                isEditing && /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    type: "button",
                                                    className: "ml-3 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm",
                                                    onClick: handleDelete,
                                                    children: "Delete Query"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    type: "button",
                                                    className: `w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-3 sm:w-auto sm:text-sm ${submitButtonStyles(isCreating)}`,
                                                    onClick: isEditing ? handleUpdate : handleSave,
                                                    disabled: isCreating,
                                                    children: isEditing ? "Update Query" : "Save Query"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                    type: "button",
                                                    className: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
                                                    onClick: handleClose,
                                                    tabIndex: 0,
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}
var $711a0923c5b79c78$export$2e2bcd8739ae039 = $711a0923c5b79c78$var$SaveQueryDialog;





function $8ea068e443b44149$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $8ea068e443b44149$export$faf1ff3a53763de6() {
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    return (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: (newQuery)=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/savedQueries", newQuery, {
                headers: {
                    Authorization: `Bearer ${$8ea068e443b44149$var$getToken()}`
                }
            }),
        onSuccess: ()=>{
            toast({
                variant: "success",
                title: "Success!",
                description: "Query created successfully!"
            });
        },
        onError: (error)=>{
            toast({
                title: "Error",
                description: `Failed to create query: ${error?.message || "An error occurred"}`,
                variant: "destructive"
            });
        }
    });
}





function $b9a1193932379a16$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $b9a1193932379a16$export$ef178906432ebc86() {
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    return (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: ({ queryId: queryId, updatedQuery: updatedQuery })=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).patch(`/savedQueries/${queryId}`, updatedQuery, {
                headers: {
                    Authorization: `Bearer ${$b9a1193932379a16$var$getToken()}`
                }
            }),
        onSuccess: ()=>{
            toast({
                variant: "success",
                title: "Success!",
                description: "Query updated successfully!"
            });
        },
        onError: (error)=>{
            toast({
                title: "Error",
                description: `Failed to update query: ${error?.message || "An error occurred"}`,
                variant: "destructive"
            });
        }
    });
}





function $ab5891cb796ab829$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $ab5891cb796ab829$export$c0617850890a2b58() {
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    return (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: (queryId)=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).delete(`/savedQueries/${queryId}`, {
                headers: {
                    Authorization: `Bearer ${$ab5891cb796ab829$var$getToken()}`
                }
            }),
        onSuccess: ()=>{
            toast({
                variant: "success",
                title: "Success!",
                description: "Query deleted successfully!"
            });
        },
        onError: (error)=>{
            toast({
                title: "Error",
                description: `Failed to delete query: ${error?.message || "An error occurred"}`,
                variant: "destructive"
            });
        }
    });
}



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
function $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}






















const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
/* -------------------------------------------------------------------------------------------------
 * Select
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME = "Select";
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext, $e552a3fd37fc9fd9$export$286727a75dc039bd] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME, [
    $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createCollectionScope,
    (0, $7b6292e260c70ed7$export$722aac194ae923)
]);
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope = (0, $7b6292e260c70ed7$export$722aac194ae923)();
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME);
const $e552a3fd37fc9fd9$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required } = props;
    const popperScope = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = (0, $exYeM.useState)(null);
    const [valueNode, setValueNode] = (0, $exYeM.useState)(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = (0, $exYeM.useState)(false);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = (0, $exYeM.useRef)(null); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = trigger ? Boolean(trigger.closest("form")) : true;
    const [nativeOptionsSet, setNativeOptionsSet] = (0, $exYeM.useState)(new Set()); // The native `select` only associates the correct default value if the corresponding
    // `option` is rendered as a child **at the same time** as itself.
    // Because it might take a few renders for our items to gather the information to build
    // the native `option`(s), we generate a key on the `select` to make sure React re-builds it
    // each time the options change.
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectProvider, {
        required: required,
        scope: __scopeSelect,
        trigger: trigger,
        onTriggerChange: setTrigger,
        valueNode: valueNode,
        onValueNodeChange: setValueNode,
        valueNodeHasChildren: valueNodeHasChildren,
        onValueNodeHasChildrenChange: setValueNodeHasChildren,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        open: open,
        onOpenChange: setOpen,
        dir: direction,
        triggerPointerDownPosRef: triggerPointerDownPosRef,
        disabled: disabled
    }, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection.Provider, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
        scope: props.__scopeSelect,
        onNativeOptionAdd: (0, $exYeM.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>new Set(prev).add(option));
        }, []),
        onNativeOptionRemove: (0, $exYeM.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>{
                const optionsSet = new Set(prev);
                optionsSet.delete(option);
                return optionsSet;
            });
        }, [])
    }, children)), isFormControl ? /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$BubbleSelect, {
        key: nativeSelectKey,
        "aria-hidden": true,
        required: required,
        tabIndex: -1,
        name: name,
        autoComplete: autoComplete,
        value: value // enable form autofill
        ,
        onChange: (event)=>setValue(event.target.value),
        disabled: disabled
    }, value === undefined ? /*#__PURE__*/ (0, $exYeM.createElement)("option", {
        value: ""
    }) : null, Array.from(nativeOptionsSet)) : null));
};
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$ef9b1a59e592288f, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectTrigger
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$TRIGGER_NAME = "SelectTrigger";
const $e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== undefined) context.onValueChange(nextItem.value);
    });
    const handleOpen = ()=>{
        if (!isDisabled) {
            context.onOpenChange(true); // reset typeahead when we open
            resetTypeahead();
        }
    };
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $aJx1R.default)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button",
        role: "combobox",
        "aria-controls": context.contentId,
        "aria-expanded": context.open,
        "aria-required": context.required,
        "aria-autocomplete": "none",
        dir: context.dir,
        "data-state": context.open ? "open" : "closed",
        disabled: isDisabled,
        "data-disabled": isDisabled ? "" : undefined,
        "data-placeholder": $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? "" : undefined
    }, triggerProps, {
        ref: composedRefs // Enable compatibility with native label or custom `Label` "click" for Safari:
        ,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
            // Whilst browsers generally have no issue focusing the trigger when clicking
            // on a label, Safari seems to struggle with the fact that there's no `onClick`.
            // We force `focus` in this case. Note: this doesn't create any other side-effect
            // because we are preventing default in `onPointerDown` so effectively
            // this only runs for a label "click"
            event.currentTarget.focus();
        }),
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
            // prevent implicit pointer capture
            // https://www.w3.org/TR/pointerevents3/#implicit-pointer-capture
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (event.button === 0 && event.ctrlKey === false) {
                handleOpen();
                context.triggerPointerDownPosRef.current = {
                    x: Math.round(event.pageX),
                    y: Math.round(event.pageY)
                }; // prevent trigger from stealing focus from the active item after opening.
                event.preventDefault();
            }
        }),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
            const isTypingAhead = searchRef.current !== "";
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if (isTypingAhead && event.key === " ") return;
            if ($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$OPEN_KEYS.includes(event.key)) {
                handleOpen();
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectValue
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VALUE_NAME = "SelectValue";
const $e552a3fd37fc9fd9$export$e288731fd71264f0 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "", ...valueProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== undefined;
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $aJx1R.default)({}, valueProps, {
        ref: composedRefs // we don't want events from the portalled `SelectValue` children to bubble
        ,
        style: {
            pointerEvents: "none"
        }
    }), $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, placeholder) : children);
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$e288731fd71264f0, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VALUE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectIcon
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ICON_NAME = "SelectIcon";
const $e552a3fd37fc9fd9$export$99b400cabb58c515 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $aJx1R.default)({
        "aria-hidden": true
    }, iconProps, {
        ref: forwardedRef
    }), children || "\u25BC");
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$99b400cabb58c515, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ICON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPortal
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$PORTAL_NAME = "SelectPortal";
const $e552a3fd37fc9fd9$export$b2af6c9944296213 = (props)=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), (0, $aJx1R.default)({
        asChild: true
    }, props));
};
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$b2af6c9944296213, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContent
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME = "SelectContent";
const $e552a3fd37fc9fd9$export$c973a4b3cb86a03d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = (0, $exYeM.useState)(); // setting the fragment in `useLayoutEffect` as `DocumentFragment` doesn't exist on the server
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? /*#__PURE__*/ (0, $d2lNW.createPortal)(/*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentProvider, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection.Slot, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $exYeM.createElement)("div", null, props.children))), frag) : null;
    }
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentImpl, (0, $aJx1R.default)({}, props, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$c973a4b3cb86a03d, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContentImpl
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN = 10;
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME);
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME = "SelectContentImpl";
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, ...contentProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = (0, $exYeM.useState)(null);
    const [viewport, setViewport] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = (0, $exYeM.useState)(null);
    const [selectedItemText, setSelectedItemText] = (0, $exYeM.useState)(null);
    const getItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = (0, $exYeM.useState)(false);
    const firstValidItemFoundRef = (0, $exYeM.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $exYeM.useEffect)(()=>{
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, [
        content
    ]); // Make sure the whole tree has focus guards as our `Select` may be
    // the last element in the DOM (because of the `Portal`)
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    const focusFirst = (0, $exYeM.useCallback)((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            // if focus is already where we want to go, we don't want to keep going through the candidates
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate === null || candidate === void 0 || candidate.scrollIntoView({
                block: "nearest"
            }); // viewport might have padding so scroll to its edges when focusing first/last items.
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate === null || candidate === void 0 || candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = (0, $exYeM.useCallback)(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]); // Since this is not dependent on layout, we want to ensure this runs at the same time as
    // other effects across components. Hence why we don't call `focusSelectedItem` inside `position`.
    (0, $exYeM.useEffect)(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]); // prevent selecting items on `pointerup` in some cases after opening from `pointerdown`
    // and close on `pointerup` outside.
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    (0, $exYeM.useEffect)(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
                    y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
                };
            };
            const handlePointerUp = (event)=>{
                // If the pointer hasn't moved by a certain threshold then we prevent selecting item on `pointerup`.
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    (0, $exYeM.useEffect)(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = (0, $exYeM.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = (0, $exYeM.useCallback)(()=>content === null || content === void 0 ? void 0 : content.focus(), [
        content
    ]);
    const itemTextRefCallback = (0, $exYeM.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectPopperPosition : $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition; // Silently ignore props that are not supported by `SelectItemAlignedPosition`
    const popperContentProps = SelectPosition === $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
        asChild: true // we make sure we're not trapping once it's been closed
        ,
        trapped: context.open,
        onMountAutoFocus: (event)=>{
            // we prevent open autofocus because we manually focus the selected item
            event.preventDefault();
        },
        onUnmountAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
            var _context$trigger;
            (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
                preventScroll: true
            });
            event.preventDefault();
        })
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: true,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside // When focus is trapped, a focusout event may still happen.
        ,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $exYeM.createElement)(SelectPosition, (0, $aJx1R.default)({
        role: "listbox",
        id: context.contentId,
        "data-state": context.open ? "open" : "closed",
        dir: context.dir,
        onContextMenu: (event)=>event.preventDefault()
    }, contentProps, popperContentProps, {
        onPlaced: ()=>setIsPositioned(true),
        ref: composedRefs,
        style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...contentProps.style
        },
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey; // select should not be navigated using tab key so we prevent it
            if (event.key === "Tab") event.preventDefault();
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if ([
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End"
            ].includes(event.key)) {
                const items = getItems().filter((item)=>!item.disabled);
                let candidateNodes = items.map((item)=>item.ref.current);
                if ([
                    "ArrowUp",
                    "End"
                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                if ([
                    "ArrowUp",
                    "ArrowDown"
                ].includes(event.key)) {
                    const currentElement = event.target;
                    const currentIndex = candidateNodes.indexOf(currentElement);
                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>focusFirst(candidateNodes));
                event.preventDefault();
            }
        })
    }))))));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentImpl, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemAlignedPosition
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = (0, $exYeM.useState)(null);
    const [content, setContent] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = (0, $exYeM.useRef)(false);
    const shouldRepositionRef = (0, $exYeM.useRef)(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = (0, $exYeM.useCallback)(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect(); // -----------------------------------------------------------------------------------------
            //  Horizontal positioning
            // -----------------------------------------------------------------------------------------
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedLeft = (0, $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4)(left, [
                    $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    rightEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedRight = (0, $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4)(right, [
                    $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    leftEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            } // -----------------------------------------------------------------------------------------
            // Vertical positioning
            // -----------------------------------------------------------------------------------------
            const items = getItems();
            const availableHeight = window.innerHeight - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth; // prettier-ignore
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px"; // -----------------------------------------------------------------------------------------
            onPlaced === null || onPlaced === void 0 || onPlaced(); // we don't want the initial scroll position adjustment to trigger "expand on scroll"
            // so we explicitly turn it on only after they've registered.
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]); // copy z-index from content to wrapper
    const [contentZIndex, setContentZIndex] = (0, $exYeM.useState)();
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]); // When the viewport becomes scrollable at the top, the scroll up button will mount.
    // Because it is part of the normal flow, it will push down the viewport, thus throwing our
    // trigger => selectedItem alignment off by the amount the viewport was pushed down.
    // We wait for this to happen and then re-run the positining logic one more time to account for it.
    const handleScrollButtonChange = (0, $exYeM.useCallback)((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem === null || focusSelectedItem === void 0 || focusSelectedItem();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange
    }, /*#__PURE__*/ (0, $exYeM.createElement)("div", {
        ref: setContentWrapper,
        style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: contentZIndex
        }
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({}, popperProps, {
        ref: composedRefs,
        style: {
            // When we get the height of the content, it includes borders. If we were to set
            // the height without having `boxSizing: 'border-box'` it would be too big.
            boxSizing: "border-box",
            // We need to ensure the content doesn't get taller than the wrapper
            maxHeight: "100%",
            ...popperProps.style
        }
    }))));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPopperPosition
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME = "SelectPopperPosition";
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectPopperPosition = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$7c6e2c02157bb7d2), (0, $aJx1R.default)({}, popperScope, popperProps, {
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectPopperPosition, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectViewport
 * -----------------------------------------------------------------------------------------------*/ const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectViewportProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectViewportContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, {});
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VIEWPORT_NAME = "SelectViewport";
const $e552a3fd37fc9fd9$export$9ed6e7b40248d36d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...viewportProps } = props;
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectViewportContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = (0, $exYeM.useRef)(0);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection.Slot, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "data-radix-select-viewport": "",
        role: "presentation"
    }, viewportProps, {
        ref: composedRefs,
        style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...viewportProps.style
        },
        onScroll: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
            const viewport = event.currentTarget;
            const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
            if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
                const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                if (scrolledBy > 0) {
                    const availableHeight = window.innerHeight - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
                    const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                    const cssHeight = parseFloat(contentWrapper.style.height);
                    const prevHeight = Math.max(cssMinHeight, cssHeight);
                    if (prevHeight < availableHeight) {
                        const nextHeight = prevHeight + scrolledBy;
                        const clampedNextHeight = Math.min(availableHeight, nextHeight);
                        const heightDiff = nextHeight - clampedNextHeight;
                        contentWrapper.style.height = clampedNextHeight + "px";
                        if (contentWrapper.style.bottom === "0px") {
                            viewport.scrollTop = heightDiff > 0 ? heightDiff : 0; // ensure the content stays pinned to the bottom
                            contentWrapper.style.justifyContent = "flex-end";
                        }
                    }
                }
            }
            prevScrollTopRef.current = viewport.scrollTop;
        })
    }))));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$9ed6e7b40248d36d, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectGroup
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$GROUP_NAME = "SelectGroup";
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectGroupContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$GROUP_NAME);
const $e552a3fd37fc9fd9$export$ee25a334c55de1f4 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        role: "group",
        "aria-labelledby": groupId
    }, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$ee25a334c55de1f4, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectLabel
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$LABEL_NAME = "SelectLabel";
const $e552a3fd37fc9fd9$export$f67338d29bd972f8 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectGroupContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$LABEL_NAME, __scopeSelect);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        id: groupContext.id
    }, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$f67338d29bd972f8, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItem
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME = "SelectItem";
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemContextProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectItemContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME);
const $e552a3fd37fc9fd9$export$13ef48a934230896 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = (0, $exYeM.useState)(textValueProp !== null && textValueProp !== void 0 ? textValueProp : "");
    const [isFocused, setIsFocused] = (0, $exYeM.useState)(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>{
        var _contentContext$itemR;
        return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node, value, disabled);
    });
    const textId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: (0, $exYeM.useCallback)((node)=>{
            setTextValue((prevTextValue)=>{
                var _node$textContent;
                return prevTextValue || ((_node$textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : "").trim();
            });
        }, [])
    }, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection.ItemSlot, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textValue: textValue
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        role: "option",
        "aria-labelledby": textId,
        "data-highlighted": isFocused ? "" : undefined // `isFocused` caveat fixes stuttering in VoiceOver
        ,
        "aria-selected": isSelected && isFocused,
        "data-state": isSelected ? "checked" : "unchecked",
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? "" : undefined,
        tabIndex: disabled ? undefined : -1
    }, itemProps, {
        ref: composedRefs,
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
        onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
        onPointerUp: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerUp, handleSelect),
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
            if (disabled) {
                var _contentContext$onIte;
                (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
            } else // as it only means it might scroll a few pixels when using the pointer.
            event.currentTarget.focus({
                preventScroll: true
            });
        }),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
            if (event.currentTarget === document.activeElement) {
                var _contentContext$onIte2;
                (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
            }
        }),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
            var _contentContext$searc;
            const isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== "";
            if (isTypingAhead && event.key === " ") return;
            if ($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECTION_KEYS.includes(event.key)) handleSelect(); // prevent page scroll if using the space key to select an item
            if (event.key === " ") event.preventDefault();
        })
    }))));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$13ef48a934230896, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemText
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME = "SelectItemText";
const $e552a3fd37fc9fd9$export$3572fb0fb821ff49 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectItemContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>{
        var _contentContext$itemT;
        return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node, itemContext.value, itemContext.disabled);
    });
    const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
    const nativeOption = (0, $exYeM.useMemo)(()=>/*#__PURE__*/ (0, $exYeM.createElement)("option", {
            key: itemContext.value,
            value: itemContext.value,
            disabled: itemContext.disabled
        }, textContent), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $aJx1R.default)({
        id: itemContext.textId
    }, itemTextProps, {
        ref: composedRefs
    })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? /*#__PURE__*/ (0, $d2lNW.createPortal)(itemTextProps.children, context.valueNode) : null);
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$3572fb0fb821ff49, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
const $e552a3fd37fc9fd9$export$6b9198de19accfe6 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectItemContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $aJx1R.default)({
        "aria-hidden": true
    }, itemIndicatorProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$6b9198de19accfe6, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollUpButton
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
const $e552a3fd37fc9fd9$export$d8117927658af6d7 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectViewportContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp1, setCanScrollUp] = (0, $exYeM.useState)(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const canScrollUp = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp);
            }
            handleScroll();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp1 ? /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $aJx1R.default)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$d8117927658af6d7, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollDownButton
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
const $e552a3fd37fc9fd9$export$ff951e476c12189 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectViewportContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown1, setCanScrollDown] = (0, $exYeM.useState)(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight; // we use Math.ceil here because if the UI is zoomed-in
                // `scrollTop` is not always reported as an integer
                const canScrollDown = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown);
            }
            handleScroll();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown1 ? /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $aJx1R.default)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$ff951e476c12189, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME
});
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = (0, $exYeM.useRef)(null);
    const getItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = (0, $exYeM.useCallback)(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    (0, $exYeM.useEffect)(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]); // When the viewport becomes scrollable on either side, the relevant scroll button will mount.
    // Because it is part of the normal flow, it will push down (top button) or shrink (bottom button)
    // the viewport, potentially causing the active item to now be partially out of view.
    // We re-run the `scrollIntoView` logic to make sure it stays within the viewport.
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        var _activeItem$ref$curre;
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem === null || activeItem === void 0 || (_activeItem$ref$curre = activeItem.ref.current) === null || _activeItem$ref$curre === void 0 || _activeItem$ref$curre.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "aria-hidden": true
    }, scrollIndicatorProps, {
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            var _contentContext$onIte3;
            (_contentContext$onIte3 = contentContext.onItemLeave) === null || _contentContext$onIte3 === void 0 || _contentContext$onIte3.call(contentContext);
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    }));
});
/* -------------------------------------------------------------------------------------------------
 * SelectSeparator
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SEPARATOR_NAME = "SelectSeparator";
const $e552a3fd37fc9fd9$export$eba4b1df07cb1d3 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $aJx1R.default)({
        "aria-hidden": true
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$eba4b1df07cb1d3, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectArrow
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ARROW_NAME = "SelectArrow";
const $e552a3fd37fc9fd9$export$314f4cb8f8099628 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$21b07c8f274aebd5), (0, $aJx1R.default)({}, popperScope, arrowProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$314f4cb8f8099628, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(value) {
    return value === "" || value === undefined;
}
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$BubbleSelect = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { value: value, ...selectProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $e863f772c7a65c44$export$5cae361ad82dce8b)(value); // Bubble value change to parents (e.g form change event)
    (0, $exYeM.useEffect)(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    /**
   * We purposefully use a `select` here to support form autofill as much
   * as possible.
   *
   * We purposefully do not add the `value` attribute here to allow the value
   * to be set programatically and bubble to any parent form `onChange` event.
   * Adding the `value` will cause React to consider the programatic
   * dispatch a duplicate and it will get swallowed.
   *
   * We use `VisuallyHidden` rather than `display: "none"` because Safari autofill
   * won't work otherwise.
   */ return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4ed20962d3818fe0$export$439d29a4e110a164), {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)("select", (0, $aJx1R.default)({}, selectProps, {
        ref: composedRefs,
        defaultValue: value
    })));
});
$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$BubbleSelect.displayName = "BubbleSelect";
function $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = (0, $exYeM.useRef)("");
    const timerRef = (0, $exYeM.useRef)(0);
    const handleTypeaheadSearch = (0, $exYeM.useCallback)((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current); // Reset `searchRef` 1 second after it was last updated
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1000);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = (0, $exYeM.useCallback)(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in a list of items,
 * the search and the current item, and returns the next item (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through items starting with that character)
 *
 * We also reorder the items by wrapping the array around the current item.
 * This is so we always look forward from the current item, and picking the first
 * item will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current item from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current item still matches.
 */ function $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : undefined;
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $e552a3fd37fc9fd9$export$be92b6f5f03c0fe9 = $e552a3fd37fc9fd9$export$ef9b1a59e592288f;
const $e552a3fd37fc9fd9$export$41fb9f06171c75f4 = $e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1;
const $e552a3fd37fc9fd9$export$4c8d1a57a761ef94 = $e552a3fd37fc9fd9$export$e288731fd71264f0;
const $e552a3fd37fc9fd9$export$f04a61298a47a40f = $e552a3fd37fc9fd9$export$99b400cabb58c515;
const $e552a3fd37fc9fd9$export$602eac185826482c = $e552a3fd37fc9fd9$export$b2af6c9944296213;
const $e552a3fd37fc9fd9$export$7c6e2c02157bb7d2 = $e552a3fd37fc9fd9$export$c973a4b3cb86a03d;
const $e552a3fd37fc9fd9$export$d5c6c08dc2d3ca7 = $e552a3fd37fc9fd9$export$9ed6e7b40248d36d;
const $e552a3fd37fc9fd9$export$eb2fcfdbd7ba97d4 = $e552a3fd37fc9fd9$export$ee25a334c55de1f4;
const $e552a3fd37fc9fd9$export$b04be29aa201d4f5 = $e552a3fd37fc9fd9$export$f67338d29bd972f8;
const $e552a3fd37fc9fd9$export$6d08773d2e66f8f2 = $e552a3fd37fc9fd9$export$13ef48a934230896;
const $e552a3fd37fc9fd9$export$d6e5bf9c43ea9319 = $e552a3fd37fc9fd9$export$3572fb0fb821ff49;
const $e552a3fd37fc9fd9$export$c3468e2714d175fa = $e552a3fd37fc9fd9$export$6b9198de19accfe6;
const $e552a3fd37fc9fd9$export$2f60d3ec9ad468f2 = $e552a3fd37fc9fd9$export$d8117927658af6d7;
const $e552a3fd37fc9fd9$export$bf1aedc3039c8d63 = $e552a3fd37fc9fd9$export$ff951e476c12189;
const $e552a3fd37fc9fd9$export$1ff3c3f08ae963c0 = $e552a3fd37fc9fd9$export$eba4b1df07cb1d3;
const $e552a3fd37fc9fd9$export$21b07c8f274aebd5 = $e552a3fd37fc9fd9$export$314f4cb8f8099628;




const $e56245bdc6005a97$export$ef9b1a59e592288f = $e552a3fd37fc9fd9$export$be92b6f5f03c0fe9;
const $e56245bdc6005a97$export$ee25a334c55de1f4 = $e552a3fd37fc9fd9$export$eb2fcfdbd7ba97d4;
const $e56245bdc6005a97$export$e288731fd71264f0 = $e552a3fd37fc9fd9$export$4c8d1a57a761ef94;
const $e56245bdc6005a97$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)($e552a3fd37fc9fd9$export$41fb9f06171c75f4, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex h-10 w-full items-center justify-between rounded-md border border-input bg-white px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$f04a61298a47a40f, {
                asChild: true,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9b82b6f96fc76ebd$export$2e2bcd8739ae039), {
                    className: "h-6 w-6"
                })
            })
        ]
    }));
$e56245bdc6005a97$export$3ac1e88a1c0b9f1.displayName = "SelectTrigger";
const $e56245bdc6005a97$export$d8117927658af6d7 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$2f60d3ec9ad468f2, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f3e94f1ced736932$export$2e2bcd8739ae039), {
            className: "h-6 w-6"
        })
    }));
$e56245bdc6005a97$export$d8117927658af6d7.displayName = "SelectScrollUpButton";
const $e56245bdc6005a97$export$ff951e476c12189 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$bf1aedc3039c8d63, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9b82b6f96fc76ebd$export$2e2bcd8739ae039), {
            className: "h-6 w-6"
        })
    }));
$e56245bdc6005a97$export$ff951e476c12189.displayName = "SelectScrollDownButton";
const $e56245bdc6005a97$export$c973a4b3cb86a03d = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, children: children, position: position = "popper", ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)($e552a3fd37fc9fd9$export$7c6e2c02157bb7d2, {
            ref: ref,
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("bg-white relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
            position: position,
            ...props,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)($e56245bdc6005a97$export$d8117927658af6d7, {}),
                /*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$d5c6c08dc2d3ca7, {
                    className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"),
                    children: children
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)($e56245bdc6005a97$export$ff951e476c12189, {})
            ]
        })
    }));
$e56245bdc6005a97$export$c973a4b3cb86a03d.displayName = "SelectContent";
const $e56245bdc6005a97$export$f67338d29bd972f8 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$b04be29aa201d4f5, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("py-1.5 pl-8 pr-2 text-sm font-semibold", className),
        ...props
    }));
$e56245bdc6005a97$export$f67338d29bd972f8.displayName = "SelectLabel";
const $e56245bdc6005a97$export$13ef48a934230896 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)($e552a3fd37fc9fd9$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", "hover:bg-gray-100", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$c3468e2714d175fa, {
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9bcddf4d25089704$export$2e2bcd8739ae039), {
                        className: "h-6 w-6"
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$d6e5bf9c43ea9319, {
                children: children
            })
        ]
    }));
$e56245bdc6005a97$export$13ef48a934230896.displayName = "SelectItem";
const $e56245bdc6005a97$export$eba4b1df07cb1d3 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($e552a3fd37fc9fd9$export$1ff3c3f08ae963c0, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    }));
$e56245bdc6005a97$export$eba4b1df07cb1d3.displayName = "SelectSeparator";


//selectedChain, was in params, add back in
const $80fd89648eaf1baa$var$ChainSelect = ({ setSelectedChain: setSelectedChain })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e56245bdc6005a97$export$ef9b1a59e592288f), {
        onValueChange: setSelectedChain,
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$3ac1e88a1c0b9f1), {
                className: "border border-gray-300 rounded-md px-3 py-2 text-left focus:outline-none focus:ring-2 focus:ring-blue-500",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$e288731fd71264f0), {
                    placeholder: "Select a chain",
                    className: "text-gray-500"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e56245bdc6005a97$export$c973a4b3cb86a03d), {
                className: "bg-white shadow-md rounded-md",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$13ef48a934230896), {
                        value: "ethereum",
                        className: "px-3 py-2 hover:bg-gray-100",
                        children: "Ethereum"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$13ef48a934230896), {
                        value: "bitcoin",
                        className: "px-3 py-2 hover:bg-gray-100",
                        children: "Bitcoin"
                    })
                ]
            })
        ]
    });
};
var $80fd89648eaf1baa$export$2e2bcd8739ae039 = $80fd89648eaf1baa$var$ChainSelect;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $b205d2149720dc64$var$ArrowLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
    }));
}
const $b205d2149720dc64$var$ForwardRef = $exYeM.forwardRef($b205d2149720dc64$var$ArrowLeftIcon);
var $b205d2149720dc64$export$2e2bcd8739ae039 = $b205d2149720dc64$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $72e41299ffd4f5c0$var$TableCellsIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
    }));
}
const $72e41299ffd4f5c0$var$ForwardRef = $exYeM.forwardRef($72e41299ffd4f5c0$var$TableCellsIcon);
var $72e41299ffd4f5c0$export$2e2bcd8739ae039 = $72e41299ffd4f5c0$var$ForwardRef;


const $53094c66d14bb3ec$var$Tables = ({ selectedCategory: selectedCategory, selectedTable: selectedTable, tablesData: tablesData, handleTableSelected: handleTableSelected, handleBackToCategories: handleBackToCategories, handleColumnSelected: handleColumnSelected })=>{
    const findTableColumns = (tableName)=>{
        return tablesData?.find((table)=>table.name === tableName)?.columns || [];
    };
    if (selectedTable) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-4/5 flex flex-col",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                onClick: handleBackToCategories,
                variant: "ghost",
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b205d2149720dc64$export$2e2bcd8739ae039), {
                        className: "h-4 w-4 mr-2"
                    }),
                    "Back to Search Results",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex-grow overflow-y-auto space-y-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("h3", {
                        className: "text-lg font-semibold",
                        children: [
                            selectedTable.name,
                            " - ",
                            selectedTable.chain
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "space-y-2",
                        children: selectedTable.columns.map((column, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                className: "flex items-center space-x-2 cursor-pointer px-2 py-1 rounded hover:bg-gray-100",
                                onClick: ()=>handleColumnSelected(column.column_name),
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $72e41299ffd4f5c0$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-gray-500"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                        className: "text-sm",
                                        children: [
                                            column.column_name,
                                            ": ",
                                            column.column_type
                                        ]
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                onClick: handleBackToCategories,
                variant: "ghost",
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b205d2149720dc64$export$2e2bcd8739ae039), {
                        className: "h-4 w-4 mr-2"
                    }),
                    "Back to Tables"
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: "text-lg font-semibold",
                        children: selectedCategory
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "space-y-2",
                        children: tablesData?.map((table)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-center space-x-2 cursor-pointer px-2 py-1 rounded hover:bg-gray-100",
                                onClick: ()=>handleTableSelected(table),
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $72e41299ffd4f5c0$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-gray-500"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "text-sm",
                                        children: table.name
                                    })
                                ]
                            }, table.name))
                    })
                ]
            })
        ]
    });
};
var $53094c66d14bb3ec$export$2e2bcd8739ae039 = $53094c66d14bb3ec$var$Tables;



var $exYeM = parcelRequire("exYeM");
function $c1c83e7bac95ca02$var$BookmarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"
    }));
}
const $c1c83e7bac95ca02$var$ForwardRef = $exYeM.forwardRef($c1c83e7bac95ca02$var$BookmarkIcon);
var $c1c83e7bac95ca02$export$2e2bcd8739ae039 = $c1c83e7bac95ca02$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $e55dae4453c51790$var$FolderIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
    }));
}
const $e55dae4453c51790$var$ForwardRef = $exYeM.forwardRef($e55dae4453c51790$var$FolderIcon);
var $e55dae4453c51790$export$2e2bcd8739ae039 = $e55dae4453c51790$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $6ae379f21b6768cd$var$Square3Stack3DIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3"
    }));
}
const $6ae379f21b6768cd$var$ForwardRef = $exYeM.forwardRef($6ae379f21b6768cd$var$Square3Stack3DIcon);
var $6ae379f21b6768cd$export$2e2bcd8739ae039 = $6ae379f21b6768cd$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $261621c22b7809c1$var$StarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
    }));
}
const $261621c22b7809c1$var$ForwardRef = $exYeM.forwardRef($261621c22b7809c1$var$StarIcon);
var $261621c22b7809c1$export$2e2bcd8739ae039 = $261621c22b7809c1$var$ForwardRef;


// LoadingSpinner.js

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");
const $a95124cff6afe936$var$LoadingSpinner = ()=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        "aria-hidden": "true",
        className: "w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-primary",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill"
            })
        ]
    });
};
var $a95124cff6afe936$export$2e2bcd8739ae039 = $a95124cff6afe936$var$LoadingSpinner;





function $e72d87f9d370222a$export$9fd3f577dfab457b(selectedChain) {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "databaseTables",
            selectedChain
        ],
        queryFn: ()=>{
            const chains = selectedChain ? [
                selectedChain
            ] : [
                "ethereum",
                "bitcoin"
            ];
            const promises = chains.map((chain)=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/executeGetTable?database=${chain}`).then((response)=>{
                    return response.data.map((table)=>({
                            ...table,
                            name: `${chain}.${table.name}`,
                            chain: chain
                        }));
                }));
            return Promise.all(promises).then((results)=>results.flat()).catch((err)=>{
                console.error("Error fetching database tables:", err);
                throw err;
            });
        },
        keepPreviousData: true
    });
}




function $60b443f8192d5c8f$export$bab4f64ba722fccf() {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "materializedViews"
        ],
        queryFn: ()=>{
            return (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/getMaterializedViews").then((response)=>response.data).catch((err)=>{
                console.error("Error fetching materialized views:", err);
                throw err;
            });
        }
    });
}


// SavedQueries.js

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $14ccfc7ccdd20cd4$var$DocumentTextIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z"
    }));
}
const $14ccfc7ccdd20cd4$var$ForwardRef = $exYeM.forwardRef($14ccfc7ccdd20cd4$var$DocumentTextIcon);
var $14ccfc7ccdd20cd4$export$2e2bcd8739ae039 = $14ccfc7ccdd20cd4$var$ForwardRef;


const $84e7cae99746aeec$var$SavedQueries = ({ userSavedQueries: userSavedQueries, isLoadingUserSavedQueries: isLoadingUserSavedQueries, onAddColumn: onAddColumn, handleEditQuery: handleEditQuery, setOpenDialog: setOpenDialog, onLoadChartSettings: onLoadChartSettings })=>{
    const handleEdit = (query)=>{
        handleEditQuery(query);
        setOpenDialog(true);
    };
    const onSelectQuery = (query)=>{
        onAddColumn(query.query); // Existing functionality
        onLoadChartSettings(query.chartSettings); // New functionality to load chart settings
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "border-t pt-4",
        children: isLoadingUserSavedQueries ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "text-sm text-gray-500",
            children: "Loading saved queries..."
        }) : userSavedQueries && userSavedQueries.length > 0 ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "max-h-48 overflow-y-auto",
            children: userSavedQueries.map((query)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex items-center justify-between py-2",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex items-center space-x-2",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $14ccfc7ccdd20cd4$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-gray-500"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "text-sm font-medium text-gray-700 hover:text-gray-900 cursor-pointer",
                                    onClick: ()=>onSelectQuery(query),
                                    children: query.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ccb23396c9d57cd4$export$2e2bcd8739ae039), {
                            className: "h-4 w-4 text-gray-500 hover:text-gray-700 cursor-pointer",
                            onClick: ()=>handleEdit(query)
                        })
                    ]
                }, query._id))
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "text-sm text-gray-500",
            children: "No saved queries found."
        })
    });
};
var $84e7cae99746aeec$export$2e2bcd8739ae039 = $84e7cae99746aeec$var$SavedQueries;


// PremadeQueries.js

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $0fe5374000de6f08$var$DocumentTextIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
    }));
}
const $0fe5374000de6f08$var$ForwardRef = $exYeM.forwardRef($0fe5374000de6f08$var$DocumentTextIcon);
var $0fe5374000de6f08$export$2e2bcd8739ae039 = $0fe5374000de6f08$var$ForwardRef;


const $4bb3704a358c379b$var$PremadeQueries = ({ premadeQueries: premadeQueries, isLoadingPremadeQueries: isLoadingPremadeQueries, onAddColumn: onAddColumn })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "border-t pt-4 space-y-2",
        children: isLoadingPremadeQueries ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "text-sm text-gray-500",
            children: "Loading premade queries..."
        }) : premadeQueries?.map((query, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                className: "flex items-center space-x-2 cursor-pointer px-2 py-1 rounded hover:bg-gray-100",
                onClick: ()=>onAddColumn(query.query),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0fe5374000de6f08$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-gray-500"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "text-sm font-medium",
                        children: query.name
                    })
                ]
            }, index))
    });
};
var $4bb3704a358c379b$export$2e2bcd8739ae039 = $4bb3704a358c379b$var$PremadeQueries;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $0e4d492646e3fb4d$var$CubeIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
    }));
}
const $0e4d492646e3fb4d$var$ForwardRef = $exYeM.forwardRef($0e4d492646e3fb4d$var$CubeIcon);
var $0e4d492646e3fb4d$export$2e2bcd8739ae039 = $0e4d492646e3fb4d$var$ForwardRef;


const $1488118def7ff47d$var$Categories = ({ handleCategorySelected: handleCategorySelected, materializedViewsData: materializedViewsData })=>{
    const categories = [
        {
            name: "Materialized Views",
            icon: (0, $72e41299ffd4f5c0$export$2e2bcd8739ae039),
            onClick: ()=>handleCategorySelected("Materialized Views", materializedViewsData)
        },
        {
            name: "Blockchain Raw Data",
            icon: (0, $0e4d492646e3fb4d$export$2e2bcd8739ae039),
            onClick: ()=>handleCategorySelected("Blockchain Raw Data")
        }
    ];
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "border-t pt-4 space-y-4",
        children: categories.map((category)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                className: "flex items-center space-x-2 cursor-pointer p-2 rounded-md hover:bg-gray-100",
                onClick: category.onClick,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)(category.icon, {
                        className: "h-6 w-6 text-gray-500"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "text-sm font-medium",
                        children: category.name
                    })
                ]
            }, category.name))
    });
};
var $1488118def7ff47d$export$2e2bcd8739ae039 = $1488118def7ff47d$var$Categories;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
function $bad8cac2604e3691$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.25 4.5l7.5 7.5-7.5 7.5"
    }));
}
const $bad8cac2604e3691$var$ForwardRef = $exYeM.forwardRef($bad8cac2604e3691$var$ChevronRightIcon);
var $bad8cac2604e3691$export$2e2bcd8739ae039 = $bad8cac2604e3691$var$ForwardRef;


const $59e0b87483c4b4dc$var$SearchComponent = ({ allData: allData, onSearchResultSelected: onSearchResultSelected, onAddColumn: onAddColumn, selectedTable: selectedTable, setSelectedTable: setSelectedTable, searchQuery: searchQuery, setSearchQuery: setSearchQuery })=>{
    const [filteredResults, setFilteredResults] = (0, $exYeM.useState)([]);
    (0, $exYeM.useEffect)(()=>{
        if (!searchQuery) setFilteredResults([]);
        else {
            const queryLower = searchQuery.toLowerCase();
            const filtered = allData.filter((data)=>data.name.toLowerCase().includes(queryLower));
            setFilteredResults(filtered);
        }
    }, [
        searchQuery,
        allData
    ]);
    const handleInputChange = (value)=>{
        setSearchQuery(value);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0bdc6a2cae10298$export$f5b8910cec6cf069), {
                placeholder: "Search...",
                value: searchQuery,
                onChange: (e)=>handleInputChange(e.target.value),
                className: "mb-4"
            }),
            selectedTable ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                        onClick: ()=>setSelectedTable(null),
                        variant: "ghost",
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b205d2149720dc64$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 mr-2"
                            }),
                            "Back to Search Results"
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                className: "text-lg font-semibold",
                                children: selectedTable.name
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "space-y-2",
                                children: selectedTable.columns.map((column, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                        className: "flex items-center space-x-2 cursor-pointer px-2 py-1 rounded hover:bg-gray-100",
                                        onClick: ()=>onAddColumn(column.column_name),
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $72e41299ffd4f5c0$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-gray-500"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                className: "text-sm",
                                                children: [
                                                    column.column_name,
                                                    ": ",
                                                    column.column_type
                                                ]
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                ]
            }) : filteredResults.length > 0 && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "border-t pt-4 space-y-2",
                children: filteredResults.map((result)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                        className: "flex justify-between items-center cursor-pointer px-2 py-1 rounded hover:bg-gray-100",
                        onClick: ()=>onSearchResultSelected(result),
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "text-sm font-medium",
                                children: result.name
                            }),
                            result.type === "Table" && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bad8cac2604e3691$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-gray-500",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    onAddColumn(result.name);
                                }
                            })
                        ]
                    }, result.name))
            })
        ]
    });
};
var $59e0b87483c4b4dc$export$2e2bcd8739ae039 = $59e0b87483c4b4dc$var$SearchComponent;


const $a0a70b37e6ff9187$var$Sidebar = ({ onAddColumn: onAddColumn, queryText: queryText, chartConfig: chartConfig, setChartConfig: setChartConfig, onLoadChartSettings: onLoadChartSettings, premadeQueries: premadeQueries, isLoadingPremadeQueries: isLoadingPremadeQueries, isLoadingPremadeQueriesError: isLoadingPremadeQueriesError, selectedChain: selectedChain, setSelectedChain: setSelectedChain })=>{
    const [openDialog, setOpenDialog] = (0, $exYeM.useState)(false);
    const handleOpenDialog = ()=>setOpenDialog(true);
    const handleCloseDialog = ()=>setOpenDialog(false);
    const [selectedTable, setSelectedTable] = (0, $exYeM.useState)(null);
    const [viewCategory, setViewCategory] = (0, $exYeM.useState)(false);
    const [isAddingQuery, setIsAddingQuery] = (0, $exYeM.useState)(false);
    const [isEditingQuery, setIsEditingQuery] = (0, $exYeM.useState)(false);
    const [queryName, setQueryName] = (0, $exYeM.useState)("");
    const [queryDescription, setQueryDescription] = (0, $exYeM.useState)("");
    const [selectedSavedQuery, setSelectedSavedQuery] = (0, $exYeM.useState)(null);
    const [materializedViewsData, setMaterializedViewsData] = (0, $exYeM.useState)([]);
    const { data: tablesData, isLoading: isLoadingTables, isError: isLoadingTablesError } = (0, $e72d87f9d370222a$export$9fd3f577dfab457b)(selectedChain && viewCategory ? selectedChain : "");
    const { data: materializedViewsTable } = (0, $60b443f8192d5c8f$export$bab4f64ba722fccf)();
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    const { data: userSavedQueries, isLoading: isLoadingUserSavedQueries, isError: isUserSavedQueriesError, error: SavedQueryError } = (0, $f7e174f679c18433$export$4bfff50eb1c7dce3)();
    const { mutate: createSavedQuery, isLoading: isCreatingSavedQuery, isError: isCreateSavedQueryError } = (0, $8ea068e443b44149$export$faf1ff3a53763de6)();
    const { mutate: updateSavedQuery, isLoading: isUpdatingSavedQuery, isError: isUpdateSavedQueryError } = (0, $b9a1193932379a16$export$ef178906432ebc86)();
    const { mutate: deleteSavedQuery, isLoading: isDeletingSavedQuery, isError: isDeleteSavedQueryError } = (0, $ab5891cb796ab829$export$c0617850890a2b58)();
    const handleSaveQuery = (showChartSettings)=>{
        const formattedChartSettings = showChartSettings ? {
            chartType: chartConfig.chartType,
            xAxisVariable: chartConfig.xAxisVariable,
            title: chartConfig.title,
            yAxes: chartConfig.series.map((serie)=>({
                    variable: serie.name,
                    color: serie.color
                }))
        } : {};
        const newQuery = {
            name: queryName,
            description: queryDescription,
            query: queryText,
            ...showChartSettings && {
                chartSettings: formattedChartSettings
            }
        };
        createSavedQuery(newQuery, {
            onSuccess: ()=>{
                queryClient.invalidateQueries("savedQueries");
                setIsAddingQuery(false);
                setQueryName("");
                setQueryDescription("");
                handleCloseDialog();
            }
        });
    };
    const handleEditQuery = (query)=>{
        setSelectedSavedQuery(query);
        setQueryName(query.name);
        setQueryDescription(query.description);
        setChartConfig(query.chartSettings);
        setOpenDialog(true);
    };
    const handleUpdateQuery = (showChartSettings)=>{
        const updatedQuery = {
            name: queryName,
            description: queryDescription,
            query: queryText,
            ...showChartSettings && {
                chartSettings: chartConfig
            }
        };
        updateSavedQuery({
            queryId: selectedSavedQuery._id,
            updatedQuery: updatedQuery
        }, {
            onSuccess: ()=>{
                queryClient.invalidateQueries("savedQueries");
                setIsEditingQuery(false);
                setSelectedSavedQuery(null);
                setQueryName("");
                setQueryDescription("");
                setOpenDialog(false);
            }
        });
    };
    const handleDeleteQuery = (queryId)=>{
        deleteSavedQuery(queryId, {
            onSuccess: ()=>{
                queryClient.invalidateQueries("getSavedQueries");
            }
        });
    };
    const [selectedCategory, setSelectedCategory] = (0, $exYeM.useState)("");
    const [searchQuery, setSearchQuery] = (0, $exYeM.useState)("");
    const handleCategorySelected = (category, data)=>{
        if (category === "Materialized Views") {
            setSelectedCategory(category);
            setViewCategory(true);
            setSelectedTable(null);
            setMaterializedViewsData(data);
        } else {
            setSelectedCategory(category);
            setViewCategory(true);
            setSelectedTable(null);
        }
    };
    const handleBackToCategories = ()=>{
        setViewCategory(false);
        setSelectedTable(null);
        setSelectedCategory("");
    };
    const handleColumnSelected = (columnName)=>{
        onAddColumn(columnName);
    };
    const allData = [
        ...(materializedViewsTable || []).map((item)=>({
                ...item,
                type: "Materialized View"
            })),
        ...(userSavedQueries || []).map((item)=>({
                ...item,
                type: "Saved Query"
            })),
        ...(premadeQueries || []).map((item)=>({
                ...item,
                type: "Premade Query"
            })),
        ...(tablesData || []).map((item)=>({
                ...item,
                type: "Table"
            }))
    ];
    const onSearchResultSelected = (result)=>{
        switch(result.type){
            case "Table":
            case "Materialized View":
                setSelectedTable(result);
                break;
            case "Saved Query":
            case "Premade Query":
                onAddColumn(result.query);
                break;
            default:
                console.error("Unknown result type", result);
        }
    };
    const shouldShowComponents = searchQuery === "";
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex flex-col h-full ",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "w-48 sm:w-56 md:w-60 lg:w-64 border-r p-4 space-y-6  overflow-y-auto",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex items-center space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e55dae4453c51790$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 text-gray-500"
                        }),
                        !viewCategory && !selectedTable && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $80fd89648eaf1baa$export$2e2bcd8739ae039), {
                            selectedChain: selectedChain,
                            setSelectedChain: setSelectedChain
                        })
                    ]
                }),
                !viewCategory && !selectedTable ? /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $59e0b87483c4b4dc$export$2e2bcd8739ae039), {
                            allData: allData,
                            onSearchResultSelected: onSearchResultSelected,
                            onAddColumn: onAddColumn,
                            selectedTable: selectedTable,
                            setSelectedTable: setSelectedTable,
                            searchQuery: searchQuery,
                            setSearchQuery: setSearchQuery
                        }),
                        shouldShowComponents && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c1c83e7bac95ca02$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-500"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                    className: "text-lg font-semibold",
                                                    children: "Saved Queries"
                                                })
                                            ]
                                        }),
                                        isLoadingUserSavedQueries ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center justify-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a95124cff6afe936$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: "Loading saved queries..."
                                                })
                                            ]
                                        }) : SavedQueryError && SavedQueryError.response?.status === 401 ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $02c3937cc0ece46a$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: "Please log in!"
                                                })
                                            ]
                                        }) : isUserSavedQueriesError ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center space-x-2 text-red-500",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $02c3937cc0ece46a$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: "Oops! An error occurred while loading saved queries. Please try again later."
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $84e7cae99746aeec$export$2e2bcd8739ae039), {
                                            userSavedQueries: userSavedQueries,
                                            isLoadingUserSavedQueries: isLoadingUserSavedQueries,
                                            onAddColumn: onAddColumn,
                                            handleEditQuery: handleEditQuery,
                                            handleDeleteQuery: handleDeleteQuery,
                                            setOpenDialog: setOpenDialog,
                                            onLoadChartSettings: onLoadChartSettings
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $261621c22b7809c1$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-500"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                    className: "text-lg font-semibold",
                                                    children: "Premade Queries"
                                                })
                                            ]
                                        }),
                                        isLoadingPremadeQueries ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center justify-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a95124cff6afe936$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: "Loading premade queries..."
                                                })
                                            ]
                                        }) : isLoadingPremadeQueriesError ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center space-x-2 text-red-500",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $02c3937cc0ece46a$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: "Oops! An error occurred while loading premade queries. Please try again later."
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4bb3704a358c379b$export$2e2bcd8739ae039), {
                                            premadeQueries: premadeQueries,
                                            isLoadingPremadeQueries: isLoadingPremadeQueries,
                                            onAddColumn: onAddColumn
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center space-x-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6ae379f21b6768cd$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-500"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                    className: "text-lg font-semibold",
                                                    children: "Categories"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1488118def7ff47d$export$2e2bcd8739ae039), {
                                            handleCategorySelected: handleCategorySelected,
                                            materializedViewsData: materializedViewsTable
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                    children: isLoadingTables ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center justify-center space-x-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a95124cff6afe936$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: "Loading tables..."
                            })
                        ]
                    }) : isLoadingTablesError ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center space-x-2 text-red-500",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $02c3937cc0ece46a$export$2e2bcd8739ae039), {
                                className: "h-5 w-5"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: "Oops! An error occurred while loading tables. Please try again later."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $53094c66d14bb3ec$export$2e2bcd8739ae039), {
                        selectedCategory: selectedCategory,
                        selectedTable: selectedTable,
                        tablesData: selectedCategory === "Materialized Views" ? materializedViewsData : tablesData,
                        handleTableSelected: setSelectedTable,
                        handleBackToCategories: handleBackToCategories,
                        handleColumnSelected: handleColumnSelected
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $711a0923c5b79c78$export$2e2bcd8739ae039), {
                    open: openDialog,
                    setOpen: setOpenDialog,
                    queryName: queryName,
                    setQueryName: setQueryName,
                    queryDescription: queryDescription,
                    setQueryDescription: setQueryDescription,
                    handleSaveQuery: handleSaveQuery,
                    isCreating: isCreatingSavedQuery,
                    isError: isCreateSavedQueryError,
                    isEdit: selectedSavedQuery !== null,
                    handleUpdateQuery: handleUpdateQuery,
                    isUpdating: isUpdatingSavedQuery,
                    isUpdateError: isUpdateSavedQueryError,
                    handleDeleteQuery: handleDeleteQuery,
                    isDeleting: isDeletingSavedQuery,
                    isDeleteError: isDeleteSavedQueryError,
                    selectedQueryId: selectedSavedQuery?._id,
                    chartConfig: chartConfig,
                    setChartConfig: setChartConfig
                })
            ]
        })
    });
};
var $a0a70b37e6ff9187$export$2e2bcd8739ae039 = $a0a70b37e6ff9187$var$Sidebar;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
function $4e45a4a56b46cf52$export$fdab3c20aae16ddf(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4e45a4a56b46cf52$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4e45a4a56b46cf52$export$df72099fd95ee399(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4e45a4a56b46cf52$var$ownKeys(Object(source), true).forEach(function(key) {
            $4e45a4a56b46cf52$export$fdab3c20aae16ddf(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4e45a4a56b46cf52$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4e45a4a56b46cf52$export$81942a8f34b531c4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4e45a4a56b46cf52$export$d8a2083381e8fcb(source, excluded) {
    if (source == null) return {};
    var target = $4e45a4a56b46cf52$export$81942a8f34b531c4(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4e45a4a56b46cf52$export$12b6a547ec390b98(arr, i) {
    return $4e45a4a56b46cf52$export$993bf82df8051d40(arr) || $4e45a4a56b46cf52$export$861af887bcb88094(arr, i) || $4e45a4a56b46cf52$export$b471fbbbe6d7806(arr, i) || $4e45a4a56b46cf52$export$37ce4bd7a39fe25f();
}
function $4e45a4a56b46cf52$export$993bf82df8051d40(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4e45a4a56b46cf52$export$861af887bcb88094(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4e45a4a56b46cf52$export$b471fbbbe6d7806(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4e45a4a56b46cf52$export$93cc12bcce4c2e3c(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4e45a4a56b46cf52$export$93cc12bcce4c2e3c(o, minLen);
}
function $4e45a4a56b46cf52$export$93cc12bcce4c2e3c(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4e45a4a56b46cf52$export$37ce4bd7a39fe25f() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $243ddafcb4430a77$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $243ddafcb4430a77$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $243ddafcb4430a77$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $243ddafcb4430a77$var$ownKeys(Object(source), true).forEach(function(key) {
            $243ddafcb4430a77$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $243ddafcb4430a77$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $243ddafcb4430a77$var$compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
}
function $243ddafcb4430a77$var$curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)nextArgs[_key3] = arguments[_key3];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
function $243ddafcb4430a77$var$isObject(value) {
    return ({}).toString.call(value).includes("Object");
}
function $243ddafcb4430a77$var$isEmpty(obj) {
    return !Object.keys(obj).length;
}
function $243ddafcb4430a77$var$isFunction(value) {
    return typeof value === "function";
}
function $243ddafcb4430a77$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
function $243ddafcb4430a77$var$validateChanges(initial, changes) {
    if (!$243ddafcb4430a77$var$isObject(changes)) $243ddafcb4430a77$var$errorHandler("changeType");
    if (Object.keys(changes).some(function(field) {
        return !$243ddafcb4430a77$var$hasOwnProperty(initial, field);
    })) $243ddafcb4430a77$var$errorHandler("changeField");
    return changes;
}
function $243ddafcb4430a77$var$validateSelector(selector) {
    if (!$243ddafcb4430a77$var$isFunction(selector)) $243ddafcb4430a77$var$errorHandler("selectorType");
}
function $243ddafcb4430a77$var$validateHandler(handler) {
    if (!($243ddafcb4430a77$var$isFunction(handler) || $243ddafcb4430a77$var$isObject(handler))) $243ddafcb4430a77$var$errorHandler("handlerType");
    if ($243ddafcb4430a77$var$isObject(handler) && Object.values(handler).some(function(_handler) {
        return !$243ddafcb4430a77$var$isFunction(_handler);
    })) $243ddafcb4430a77$var$errorHandler("handlersType");
}
function $243ddafcb4430a77$var$validateInitial(initial) {
    if (!initial) $243ddafcb4430a77$var$errorHandler("initialIsRequired");
    if (!$243ddafcb4430a77$var$isObject(initial)) $243ddafcb4430a77$var$errorHandler("initialType");
    if ($243ddafcb4430a77$var$isEmpty(initial)) $243ddafcb4430a77$var$errorHandler("initialContent");
}
function $243ddafcb4430a77$var$throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var $243ddafcb4430a77$var$errorMessages = {
    initialIsRequired: "initial state is required",
    initialType: "initial state should be an object",
    initialContent: "initial state shouldn't be an empty object",
    handlerType: "handler should be an object or a function",
    handlersType: "all handlers should be a functions",
    selectorType: "selector should be a function",
    changeType: "provided value of changes should be an object",
    changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
    "default": "an unknown error accured in `state-local` package"
};
var $243ddafcb4430a77$var$errorHandler = $243ddafcb4430a77$var$curry($243ddafcb4430a77$var$throwError)($243ddafcb4430a77$var$errorMessages);
var $243ddafcb4430a77$var$validators = {
    changes: $243ddafcb4430a77$var$validateChanges,
    selector: $243ddafcb4430a77$var$validateSelector,
    handler: $243ddafcb4430a77$var$validateHandler,
    initial: $243ddafcb4430a77$var$validateInitial
};
function $243ddafcb4430a77$var$create(initial) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $243ddafcb4430a77$var$validators.initial(initial);
    $243ddafcb4430a77$var$validators.handler(handler);
    var state = {
        current: initial
    };
    var didUpdate = $243ddafcb4430a77$var$curry($243ddafcb4430a77$var$didStateUpdate)(state, handler);
    var update = $243ddafcb4430a77$var$curry($243ddafcb4430a77$var$updateState)(state);
    var validate = $243ddafcb4430a77$var$curry($243ddafcb4430a77$var$validators.changes)(initial);
    var getChanges = $243ddafcb4430a77$var$curry($243ddafcb4430a77$var$extractChanges)(state);
    function getState() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function(state) {
            return state;
        };
        $243ddafcb4430a77$var$validators.selector(selector);
        return selector(state.current);
    }
    function setState(causedChanges) {
        $243ddafcb4430a77$var$compose(didUpdate, update, validate, getChanges)(causedChanges);
    }
    return [
        getState,
        setState
    ];
}
function $243ddafcb4430a77$var$extractChanges(state, causedChanges) {
    return $243ddafcb4430a77$var$isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}
function $243ddafcb4430a77$var$updateState(state, changes) {
    state.current = $243ddafcb4430a77$var$_objectSpread2($243ddafcb4430a77$var$_objectSpread2({}, state.current), changes);
    return changes;
}
function $243ddafcb4430a77$var$didStateUpdate(state, handler, changes) {
    $243ddafcb4430a77$var$isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function(field) {
        var _handler$field;
        return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
    });
    return changes;
}
var $243ddafcb4430a77$var$index = {
    create: $243ddafcb4430a77$var$create
};
var $243ddafcb4430a77$export$2e2bcd8739ae039 = $243ddafcb4430a77$var$index;


var $2d67d4dedd4f6817$var$config = {
    paths: {
        vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs"
    }
};
var $2d67d4dedd4f6817$export$2e2bcd8739ae039 = $2d67d4dedd4f6817$var$config;


function $788d14a144d50761$var$curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)nextArgs[_key2] = arguments[_key2];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
var $788d14a144d50761$export$2e2bcd8739ae039 = $788d14a144d50761$var$curry;


function $14d90a97e45ae1c6$var$isObject(value) {
    return ({}).toString.call(value).includes("Object");
}
var $14d90a97e45ae1c6$export$2e2bcd8739ae039 = $14d90a97e45ae1c6$var$isObject;


/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */ function $23c647e7199f5a70$var$validateConfig(config) {
    if (!config) $23c647e7199f5a70$export$cc3fdd528b56c4a9("configIsRequired");
    if (!(0, $14d90a97e45ae1c6$export$2e2bcd8739ae039)(config)) $23c647e7199f5a70$export$cc3fdd528b56c4a9("configType");
    if (config.urls) {
        $23c647e7199f5a70$var$informAboutDeprecation();
        return {
            paths: {
                vs: config.urls.monacoBase
            }
        };
    }
    return config;
}
/**
 * logs deprecation message
 */ function $23c647e7199f5a70$var$informAboutDeprecation() {
    console.warn($23c647e7199f5a70$export$d8bd0967cb58683.deprecation);
}
function $23c647e7199f5a70$var$throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var $23c647e7199f5a70$export$d8bd0967cb58683 = {
    configIsRequired: "the configuration object is required",
    configType: "the configuration object should be an object",
    "default": "an unknown error accured in `@monaco-editor/loader` package",
    deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var $23c647e7199f5a70$export$cc3fdd528b56c4a9 = (0, $788d14a144d50761$export$2e2bcd8739ae039)($23c647e7199f5a70$var$throwError)($23c647e7199f5a70$export$d8bd0967cb58683);
var $23c647e7199f5a70$var$validators = {
    config: $23c647e7199f5a70$var$validateConfig
};
var $23c647e7199f5a70$export$2e2bcd8739ae039 = $23c647e7199f5a70$var$validators;


var $685cca1bd8967d0c$var$compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
};
var $685cca1bd8967d0c$export$2e2bcd8739ae039 = $685cca1bd8967d0c$var$compose;



function $ba3cb1bcc899a8b0$var$merge(target, source) {
    Object.keys(source).forEach(function(key) {
        if (source[key] instanceof Object) {
            if (target[key]) Object.assign(source[key], $ba3cb1bcc899a8b0$var$merge(target[key], source[key]));
        }
    });
    return (0, $4e45a4a56b46cf52$export$df72099fd95ee399)((0, $4e45a4a56b46cf52$export$df72099fd95ee399)({}, target), source);
}
var $ba3cb1bcc899a8b0$export$2e2bcd8739ae039 = $ba3cb1bcc899a8b0$var$merge;


// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var $8301f1b26dcbc46c$export$ef4ebf120f9f6749 = {
    type: "cancelation",
    msg: "operation is manually canceled"
};
function $8301f1b26dcbc46c$var$makeCancelable(promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(val) {
            return hasCanceled_ ? reject($8301f1b26dcbc46c$export$ef4ebf120f9f6749) : resolve(val);
        });
        promise["catch"](reject);
    });
    return wrappedPromise.cancel = function() {
        return hasCanceled_ = true;
    }, wrappedPromise;
}
var $8301f1b26dcbc46c$export$2e2bcd8739ae039 = $8301f1b26dcbc46c$var$makeCancelable;


/** the local state of the module */ var $4676ca1b0a00e5f7$var$_state$create = (0, $243ddafcb4430a77$export$2e2bcd8739ae039).create({
    config: (0, $2d67d4dedd4f6817$export$2e2bcd8739ae039),
    isInitialized: false,
    resolve: null,
    reject: null,
    monaco: null
}), $4676ca1b0a00e5f7$var$_state$create2 = (0, $4e45a4a56b46cf52$export$12b6a547ec390b98)($4676ca1b0a00e5f7$var$_state$create, 2), $4676ca1b0a00e5f7$var$getState = $4676ca1b0a00e5f7$var$_state$create2[0], $4676ca1b0a00e5f7$var$setState = $4676ca1b0a00e5f7$var$_state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */ function $4676ca1b0a00e5f7$var$config(globalConfig) {
    var _validators$config = (0, $23c647e7199f5a70$export$2e2bcd8739ae039).config(globalConfig), monaco = _validators$config.monaco, config = (0, $4e45a4a56b46cf52$export$d8a2083381e8fcb)(_validators$config, [
        "monaco"
    ]);
    $4676ca1b0a00e5f7$var$setState(function(state) {
        return {
            config: (0, $ba3cb1bcc899a8b0$export$2e2bcd8739ae039)(state.config, config),
            monaco: monaco
        };
    });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */ function $4676ca1b0a00e5f7$var$init() {
    var state = $4676ca1b0a00e5f7$var$getState(function(_ref) {
        var monaco = _ref.monaco, isInitialized = _ref.isInitialized, resolve = _ref.resolve;
        return {
            monaco: monaco,
            isInitialized: isInitialized,
            resolve: resolve
        };
    });
    if (!state.isInitialized) {
        $4676ca1b0a00e5f7$var$setState({
            isInitialized: true
        });
        if (state.monaco) {
            state.resolve(state.monaco);
            return (0, $8301f1b26dcbc46c$export$2e2bcd8739ae039)($4676ca1b0a00e5f7$var$wrapperPromise);
        }
        if (window.monaco && window.monaco.editor) {
            $4676ca1b0a00e5f7$var$storeMonacoInstance(window.monaco);
            state.resolve(window.monaco);
            return (0, $8301f1b26dcbc46c$export$2e2bcd8739ae039)($4676ca1b0a00e5f7$var$wrapperPromise);
        }
        (0, $685cca1bd8967d0c$export$2e2bcd8739ae039)($4676ca1b0a00e5f7$var$injectScripts, $4676ca1b0a00e5f7$var$getMonacoLoaderScript)($4676ca1b0a00e5f7$var$configureLoader);
    }
    return (0, $8301f1b26dcbc46c$export$2e2bcd8739ae039)($4676ca1b0a00e5f7$var$wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */ function $4676ca1b0a00e5f7$var$injectScripts(script) {
    return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */ function $4676ca1b0a00e5f7$var$createScript(src) {
    var script = document.createElement("script");
    return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */ function $4676ca1b0a00e5f7$var$getMonacoLoaderScript(configureLoader) {
    var state = $4676ca1b0a00e5f7$var$getState(function(_ref2) {
        var config = _ref2.config, reject = _ref2.reject;
        return {
            config: config,
            reject: reject
        };
    });
    var loaderScript = $4676ca1b0a00e5f7$var$createScript("".concat(state.config.paths.vs, "/loader.js"));
    loaderScript.onload = function() {
        return configureLoader();
    };
    loaderScript.onerror = state.reject;
    return loaderScript;
}
/**
 * configures the monaco loader
 */ function $4676ca1b0a00e5f7$var$configureLoader() {
    var state = $4676ca1b0a00e5f7$var$getState(function(_ref3) {
        var config = _ref3.config, resolve = _ref3.resolve, reject = _ref3.reject;
        return {
            config: config,
            resolve: resolve,
            reject: reject
        };
    });
    var require = window.require;
    require.config(state.config);
    require([
        "vs/editor/editor.main"
    ], function(monaco) {
        $4676ca1b0a00e5f7$var$storeMonacoInstance(monaco);
        state.resolve(monaco);
    }, function(error) {
        state.reject(error);
    });
}
/**
 * store monaco instance in local state
 */ function $4676ca1b0a00e5f7$var$storeMonacoInstance(monaco) {
    if (!$4676ca1b0a00e5f7$var$getState().monaco) $4676ca1b0a00e5f7$var$setState({
        monaco: monaco
    });
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */ function $4676ca1b0a00e5f7$var$__getMonacoInstance() {
    return $4676ca1b0a00e5f7$var$getState(function(_ref4) {
        var monaco = _ref4.monaco;
        return monaco;
    });
}
var $4676ca1b0a00e5f7$var$wrapperPromise = new Promise(function(resolve, reject) {
    return $4676ca1b0a00e5f7$var$setState({
        resolve: resolve,
        reject: reject
    });
});
var $4676ca1b0a00e5f7$var$loader = {
    config: $4676ca1b0a00e5f7$var$config,
    init: $4676ca1b0a00e5f7$var$init,
    __getMonacoInstance: $4676ca1b0a00e5f7$var$__getMonacoInstance
};
var $4676ca1b0a00e5f7$export$2e2bcd8739ae039 = $4676ca1b0a00e5f7$var$loader;





var $exYeM = parcelRequire("exYeM");
var $6479fb975c3c122f$var$le = {
    wrapper: {
        display: "flex",
        position: "relative",
        textAlign: "initial"
    },
    fullWidth: {
        width: "100%"
    },
    hide: {
        display: "none"
    }
}, $6479fb975c3c122f$var$v = $6479fb975c3c122f$var$le;
var $6479fb975c3c122f$var$ae = {
    container: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center"
    }
}, $6479fb975c3c122f$var$Y = $6479fb975c3c122f$var$ae;
function $6479fb975c3c122f$var$Me({ children: e }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        style: $6479fb975c3c122f$var$Y.container
    }, e);
}
var $6479fb975c3c122f$var$Z = $6479fb975c3c122f$var$Me;
var $6479fb975c3c122f$var$$ = $6479fb975c3c122f$var$Z;
function $6479fb975c3c122f$var$Ee({ width: e, height: r, isEditorReady: n, loading: t, _ref: a, className: m, wrapperProps: E }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("section", {
        style: {
            ...$6479fb975c3c122f$var$v.wrapper,
            width: e,
            height: r
        },
        ...E
    }, !n && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6479fb975c3c122f$var$$, null, t), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ref: a,
        style: {
            ...$6479fb975c3c122f$var$v.fullWidth,
            ...!n && $6479fb975c3c122f$var$v.hide
        },
        className: m
    }));
}
var $6479fb975c3c122f$var$ee = $6479fb975c3c122f$var$Ee;
var $6479fb975c3c122f$var$H = (0, $exYeM.memo)($6479fb975c3c122f$var$ee);
function $6479fb975c3c122f$var$Ce(e) {
    (0, $exYeM.useEffect)(e, []);
}
var $6479fb975c3c122f$var$k = $6479fb975c3c122f$var$Ce;
function $6479fb975c3c122f$var$he(e, r, n = !0) {
    let t = (0, $exYeM.useRef)(!0);
    (0, $exYeM.useEffect)(t.current || !n ? ()=>{
        t.current = !1;
    } : e, r);
}
var $6479fb975c3c122f$var$l = $6479fb975c3c122f$var$he;
function $6479fb975c3c122f$var$D() {}
function $6479fb975c3c122f$var$h(e, r, n, t) {
    return $6479fb975c3c122f$var$De(e, t) || $6479fb975c3c122f$var$be(e, r, n, t);
}
function $6479fb975c3c122f$var$De(e, r) {
    return e.editor.getModel($6479fb975c3c122f$var$te(e, r));
}
function $6479fb975c3c122f$var$be(e, r, n, t) {
    return e.editor.createModel(r, n, t ? $6479fb975c3c122f$var$te(e, t) : void 0);
}
function $6479fb975c3c122f$var$te(e, r) {
    return e.Uri.parse(r);
}
function $6479fb975c3c122f$var$Oe({ original: e, modified: r, language: n, originalLanguage: t, modifiedLanguage: a, originalModelPath: m, modifiedModelPath: E, keepCurrentOriginalModel: g = !1, keepCurrentModifiedModel: N = !1, theme: x = "light", loading: P = "Loading...", options: y = {}, height: V = "100%", width: z = "100%", className: F, wrapperProps: j = {}, beforeMount: A = $6479fb975c3c122f$var$D, onMount: q = $6479fb975c3c122f$var$D }) {
    let [M, O] = (0, $exYeM.useState)(!1), [T, s] = (0, $exYeM.useState)(!0), u = (0, $exYeM.useRef)(null), c = (0, $exYeM.useRef)(null), w = (0, $exYeM.useRef)(null), d = (0, $exYeM.useRef)(q), o = (0, $exYeM.useRef)(A), b = (0, $exYeM.useRef)(!1);
    $6479fb975c3c122f$var$k(()=>{
        let i = (0, $4676ca1b0a00e5f7$export$2e2bcd8739ae039).init();
        return i.then((f)=>(c.current = f) && s(!1)).catch((f)=>f?.type !== "cancelation" && console.error("Monaco initialization: error:", f)), ()=>u.current ? I() : i.cancel();
    }), $6479fb975c3c122f$var$l(()=>{
        if (u.current && c.current) {
            let i = u.current.getOriginalEditor(), f = $6479fb975c3c122f$var$h(c.current, e || "", t || n || "text", m || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        m
    ], M), $6479fb975c3c122f$var$l(()=>{
        if (u.current && c.current) {
            let i = u.current.getModifiedEditor(), f = $6479fb975c3c122f$var$h(c.current, r || "", a || n || "text", E || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        E
    ], M), $6479fb975c3c122f$var$l(()=>{
        let i = u.current.getModifiedEditor();
        i.getOption(c.current.editor.EditorOption.readOnly) ? i.setValue(r || "") : r !== i.getValue() && (i.executeEdits("", [
            {
                range: i.getModel().getFullModelRange(),
                text: r || "",
                forceMoveMarkers: !0
            }
        ]), i.pushUndoStop());
    }, [
        r
    ], M), $6479fb975c3c122f$var$l(()=>{
        u.current?.getModel()?.original.setValue(e || "");
    }, [
        e
    ], M), $6479fb975c3c122f$var$l(()=>{
        let { original: i, modified: f } = u.current.getModel();
        c.current.editor.setModelLanguage(i, t || n || "text"), c.current.editor.setModelLanguage(f, a || n || "text");
    }, [
        n,
        t,
        a
    ], M), $6479fb975c3c122f$var$l(()=>{
        c.current?.editor.setTheme(x);
    }, [
        x
    ], M), $6479fb975c3c122f$var$l(()=>{
        u.current?.updateOptions(y);
    }, [
        y
    ], M);
    let L = (0, $exYeM.useCallback)(()=>{
        if (!c.current) return;
        o.current(c.current);
        let i = $6479fb975c3c122f$var$h(c.current, e || "", t || n || "text", m || ""), f = $6479fb975c3c122f$var$h(c.current, r || "", a || n || "text", E || "");
        u.current?.setModel({
            original: i,
            modified: f
        });
    }, [
        n,
        r,
        a,
        e,
        t,
        m,
        E
    ]), U = (0, $exYeM.useCallback)(()=>{
        !b.current && w.current && (u.current = c.current.editor.createDiffEditor(w.current, {
            automaticLayout: !0,
            ...y
        }), L(), c.current?.editor.setTheme(x), O(!0), b.current = !0);
    }, [
        y,
        x,
        L
    ]);
    (0, $exYeM.useEffect)(()=>{
        M && d.current(u.current, c.current);
    }, [
        M
    ]), (0, $exYeM.useEffect)(()=>{
        !T && !M && U();
    }, [
        T,
        M,
        U
    ]);
    function I() {
        let i = u.current?.getModel();
        g || i?.original?.dispose(), N || i?.modified?.dispose(), u.current?.dispose();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6479fb975c3c122f$var$H, {
        width: z,
        height: V,
        isEditorReady: M,
        loading: P,
        _ref: w,
        className: F,
        wrapperProps: j
    });
}
var $6479fb975c3c122f$var$ie = $6479fb975c3c122f$var$Oe;
var $6479fb975c3c122f$export$f95cfa31b5a0bc91 = (0, $exYeM.memo)($6479fb975c3c122f$var$ie);
function $6479fb975c3c122f$var$Pe() {
    let [e, r] = (0, $exYeM.useState)((0, $4676ca1b0a00e5f7$export$2e2bcd8739ae039).__getMonacoInstance());
    return $6479fb975c3c122f$var$k(()=>{
        let n;
        return e || (n = (0, $4676ca1b0a00e5f7$export$2e2bcd8739ae039).init(), n.then((t)=>{
            r(t);
        })), ()=>n?.cancel();
    }), e;
}
var $6479fb975c3c122f$export$7c29dcfb1e21cfdd = $6479fb975c3c122f$var$Pe;
function $6479fb975c3c122f$var$He(e) {
    let r = (0, $exYeM.useRef)();
    return (0, $exYeM.useEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r.current;
}
var $6479fb975c3c122f$var$se = $6479fb975c3c122f$var$He;
var $6479fb975c3c122f$var$_ = new Map;
function $6479fb975c3c122f$var$Ve({ defaultValue: e, defaultLanguage: r, defaultPath: n, value: t, language: a, path: m, theme: E = "light", line: g, loading: N = "Loading...", options: x = {}, overrideServices: P = {}, saveViewState: y = !0, keepCurrentModel: V = !1, width: z = "100%", height: F = "100%", className: j, wrapperProps: A = {}, beforeMount: q = $6479fb975c3c122f$var$D, onMount: M = $6479fb975c3c122f$var$D, onChange: O, onValidate: T = $6479fb975c3c122f$var$D }) {
    let [s, u] = (0, $exYeM.useState)(!1), [c, w] = (0, $exYeM.useState)(!0), d = (0, $exYeM.useRef)(null), o = (0, $exYeM.useRef)(null), b = (0, $exYeM.useRef)(null), L = (0, $exYeM.useRef)(M), U = (0, $exYeM.useRef)(q), I = (0, $exYeM.useRef)(), i = (0, $exYeM.useRef)(t), f = $6479fb975c3c122f$var$se(m), Q = (0, $exYeM.useRef)(!1), B = (0, $exYeM.useRef)(!1);
    $6479fb975c3c122f$var$k(()=>{
        let p = (0, $4676ca1b0a00e5f7$export$2e2bcd8739ae039).init();
        return p.then((R)=>(d.current = R) && w(!1)).catch((R)=>R?.type !== "cancelation" && console.error("Monaco initialization: error:", R)), ()=>o.current ? pe() : p.cancel();
    }), $6479fb975c3c122f$var$l(()=>{
        let p = $6479fb975c3c122f$var$h(d.current, e || t || "", r || a || "", m || n || "");
        p !== o.current?.getModel() && (y && $6479fb975c3c122f$var$_.set(f, o.current?.saveViewState()), o.current?.setModel(p), y && o.current?.restoreViewState($6479fb975c3c122f$var$_.get(m)));
    }, [
        m
    ], s), $6479fb975c3c122f$var$l(()=>{
        o.current?.updateOptions(x);
    }, [
        x
    ], s), $6479fb975c3c122f$var$l(()=>{
        !o.current || t === void 0 || (o.current.getOption(d.current.editor.EditorOption.readOnly) ? o.current.setValue(t) : t !== o.current.getValue() && (B.current = !0, o.current.executeEdits("", [
            {
                range: o.current.getModel().getFullModelRange(),
                text: t,
                forceMoveMarkers: !0
            }
        ]), o.current.pushUndoStop(), B.current = !1));
    }, [
        t
    ], s), $6479fb975c3c122f$var$l(()=>{
        let p = o.current?.getModel();
        p && a && d.current?.editor.setModelLanguage(p, a);
    }, [
        a
    ], s), $6479fb975c3c122f$var$l(()=>{
        g !== void 0 && o.current?.revealLine(g);
    }, [
        g
    ], s), $6479fb975c3c122f$var$l(()=>{
        d.current?.editor.setTheme(E);
    }, [
        E
    ], s);
    let X = (0, $exYeM.useCallback)(()=>{
        if (!(!b.current || !d.current) && !Q.current) {
            U.current(d.current);
            let p = m || n, R = $6479fb975c3c122f$var$h(d.current, t || e || "", r || a || "", p || "");
            o.current = d.current?.editor.create(b.current, {
                model: R,
                automaticLayout: !0,
                ...x
            }, P), y && o.current.restoreViewState($6479fb975c3c122f$var$_.get(p)), d.current.editor.setTheme(E), g !== void 0 && o.current.revealLine(g), u(!0), Q.current = !0;
        }
    }, [
        e,
        r,
        n,
        t,
        a,
        m,
        x,
        P,
        y,
        E,
        g
    ]);
    (0, $exYeM.useEffect)(()=>{
        s && L.current(o.current, d.current);
    }, [
        s
    ]), (0, $exYeM.useEffect)(()=>{
        !c && !s && X();
    }, [
        c,
        s,
        X
    ]), i.current = t, (0, $exYeM.useEffect)(()=>{
        s && O && (I.current?.dispose(), I.current = o.current?.onDidChangeModelContent((p)=>{
            B.current || O(o.current.getValue(), p);
        }));
    }, [
        s,
        O
    ]), (0, $exYeM.useEffect)(()=>{
        if (s) {
            let p = d.current.editor.onDidChangeMarkers((R)=>{
                let G = o.current.getModel()?.uri;
                if (G && R.find((J)=>J.path === G.path)) {
                    let J = d.current.editor.getModelMarkers({
                        resource: G
                    });
                    T?.(J);
                }
            });
            return ()=>{
                p?.dispose();
            };
        }
        return ()=>{};
    }, [
        s,
        T
    ]);
    function pe() {
        I.current?.dispose(), V ? y && $6479fb975c3c122f$var$_.set(m, o.current.saveViewState()) : o.current.getModel()?.dispose(), o.current.dispose();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6479fb975c3c122f$var$H, {
        width: z,
        height: F,
        isEditorReady: s,
        loading: N,
        _ref: b,
        className: j,
        wrapperProps: A
    });
}
var $6479fb975c3c122f$var$fe = $6479fb975c3c122f$var$Ve;
var $6479fb975c3c122f$export$7cda8d932e2f33c0 = (0, $exYeM.memo)($6479fb975c3c122f$var$fe);
var $6479fb975c3c122f$export$2e2bcd8739ae039 = $6479fb975c3c122f$export$7cda8d932e2f33c0;


const $f2300adf5a34cbfd$var$monokaiTheme = {
    base: "vs-dark",
    inherit: true,
    rules: [
        {
            token: "comment",
            foreground: "75715e"
        },
        {
            token: "keyword",
            foreground: "f92672"
        },
        {
            token: "identifier",
            foreground: "66d9ef"
        }
    ],
    colors: {
        "editor.foreground": "#F8F8F2",
        "editor.background": "#272822",
        "editor.selectionBackground": "#49483E",
        "editor.lineHighlightBackground": "#3E3D32",
        "editorCursor.foreground": "#F8F8F0",
        "editorWhitespace.foreground": "#3B3A32"
    }
};
// Editor options
const $f2300adf5a34cbfd$var$options = {
    acceptSuggestionOnCommitCharacter: true,
    acceptSuggestionOnEnter: "on",
    accessibilitySupport: "auto",
    autoIndent: false,
    automaticLayout: true,
    codeLens: true,
    colorDecorators: true,
    contextmenu: true,
    cursorBlinking: "blink",
    cursorSmoothCaretAnimation: false,
    cursorStyle: "line",
    disableLayerHinting: false,
    disableMonospaceOptimizations: false,
    dragAndDrop: false,
    fixedOverflowWidgets: false,
    folding: true,
    foldingStrategy: "auto",
    fontLigatures: false,
    formatOnPaste: false,
    formatOnType: false,
    hideCursorInOverviewRuler: false,
    highlightActiveIndentGuide: true,
    links: true,
    mouseWheelZoom: false,
    multiCursorMergeOverlapping: true,
    multiCursorModifier: "alt",
    overviewRulerBorder: false,
    overviewRulerLanes: 0,
    quickSuggestions: true,
    quickSuggestionsDelay: 100,
    readOnly: false,
    renderControlCharacters: false,
    renderFinalNewline: true,
    renderIndentGuides: true,
    renderLineHighlight: "all",
    renderWhitespace: "none",
    revealHorizontalRightPadding: 30,
    roundedSelection: true,
    rulers: [],
    scrollBeyondLastColumn: 5,
    scrollBeyondLastLine: true,
    selectOnLineNumbers: true,
    selectionClipboard: true,
    selectionHighlight: true,
    showFoldingControls: "mouseover",
    smoothScrolling: false,
    suggestOnTriggerCharacters: true,
    wordBasedSuggestions: true,
    wordSeparators: "~!@#$%^&*()-=+[{]}|;:'\",.<>/?",
    wordWrap: "off",
    wordWrapBreakAfterCharacters: "	})]?|&,;",
    wordWrapBreakBeforeCharacters: "{([+",
    wordWrapBreakObtrusiveCharacters: ".",
    wordWrapColumn: 80,
    wordWrapMinified: true,
    wrappingIndent: "none",
    minimap: {
        enabled: false
    },
    fontSize: 14,
    lineNumbers: "on",
    indentGuides: {
        activeBackground: "#444444",
        active: true
    },
    autoClosingBrackets: "always",
    autoClosingQuotes: "always",
    languages: [
        {
            id: "sql",
            completionItems: {
                provideCompletionItems: true
            }
        }
    ]
};
const $f2300adf5a34cbfd$var$TextArea = ({ value: value, onChange: onChange, height: height })=>{
    // not used
    const [dimensions, setDimensions] = (0, $exYeM.useState)({
        width: window.innerWidth * 0.75,
        height: window.innerHeight
    });
    const handleResize = ()=>{
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0, $exYeM.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    // Function to define and set the theme before the editor mounts
    const handleEditorWillMount = (monacoInstance)=>{
        monacoInstance.editor.defineTheme("monokai", $f2300adf5a34cbfd$var$monokaiTheme);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6479fb975c3c122f$export$2e2bcd8739ae039), {
            height: height,
            defaultLanguage: "sql",
            value: value,
            theme: "",
            beforeMount: handleEditorWillMount,
            onChange: onChange,
            options: $f2300adf5a34cbfd$var$options
        })
    });
};
var $f2300adf5a34cbfd$export$2e2bcd8739ae039 = $f2300adf5a34cbfd$var$TextArea;


// src/API/Query.js



function $a964d10fec79d989$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
const $a964d10fec79d989$var$useCustomQueryMutation = ({ setTimer: setTimer, setTimerActive: setTimerActive, setShowTimer: setShowTimer })=>{
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    return (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: (query)=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).post("/executeCustomQuery", {
                customQuery: query
            }, {
                headers: {
                    Authorization: `Bearer ${$a964d10fec79d989$var$getToken()}`
                }
            }),
        onMutate: ()=>{
            // Start the timer
            setTimer(0); // Reset timer whenever a new mutation starts
            setTimerActive(true); // Activate timer
            setShowTimer(true); // Show the timer as soon as the query starts
        },
        onSuccess: ()=>{
            setTimerActive(false); // Deactivate timer once query is settled (either onSuccess or onError)
        },
        onError: (error)=>{
            // Actions on error
            console.error("Query error:", error);
            setTimerActive(false); // Stop timer even on error
            if (error.response) {
                if (error.response.status === 400) toast({
                    variant: "destructive",
                    title: "Bad Request",
                    description: "The query is invalid. Please check your syntax."
                });
                else if (error.response.status === 401) toast({
                    variant: "destructive",
                    title: "Unauthorized",
                    description: "You are not authorized to perform this action."
                });
                else toast({
                    variant: "destructive",
                    title: "Error!",
                    description: error.response.data?.error || "An error occurred"
                });
            } else toast({
                variant: "destructive",
                title: "Error!",
                description: "An error occurred"
            });
        }
    });
};
var $a964d10fec79d989$export$2e2bcd8739ae039 = $a964d10fec79d989$var$useCustomQueryMutation;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $c55f946fc8e4cd99$var$ArrowsPointingInIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M3.22 3.22a.75.75 0 011.06 0l3.97 3.97V4.5a.75.75 0 011.5 0V9a.75.75 0 01-.75.75H4.5a.75.75 0 010-1.5h2.69L3.22 4.28a.75.75 0 010-1.06zm17.56 0a.75.75 0 010 1.06l-3.97 3.97h2.69a.75.75 0 010 1.5H15a.75.75 0 01-.75-.75V4.5a.75.75 0 011.5 0v2.69l3.97-3.97a.75.75 0 011.06 0zM3.75 15a.75.75 0 01.75-.75H9a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-2.69l-3.97 3.97a.75.75 0 01-1.06-1.06l3.97-3.97H4.5a.75.75 0 01-.75-.75zm10.5 0a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-2.69l3.97 3.97a.75.75 0 11-1.06 1.06l-3.97-3.97v2.69a.75.75 0 01-1.5 0V15z",
        clipRule: "evenodd"
    }));
}
const $c55f946fc8e4cd99$var$ForwardRef = $exYeM.forwardRef($c55f946fc8e4cd99$var$ArrowsPointingInIcon);
var $c55f946fc8e4cd99$export$2e2bcd8739ae039 = $c55f946fc8e4cd99$var$ForwardRef;



const $b01141b5b6f9bf00$var$MinimizeButton = ({ isMinimized: isMinimized, toggle: toggle })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
        variant: "outline",
        onClick: toggle,
        className: "mr-2",
        children: isMinimized ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f92085fcc4c2f012$export$2e2bcd8739ae039), {
            className: "h-5 w-5"
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c55f946fc8e4cd99$export$2e2bcd8739ae039), {
            className: "h-5 w-5"
        })
    });
};
var $b01141b5b6f9bf00$export$2e2bcd8739ae039 = $b01141b5b6f9bf00$var$MinimizeButton;



// useQueryStates.js

var $exYeM = parcelRequire("exYeM");





const $3a2521275a9859c3$var$useQueryStates = ()=>{
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const [openDialog, setOpenDialog] = (0, $exYeM.useState)(false);
    const [queryName, setQueryName] = (0, $exYeM.useState)("");
    const [queryDescription, setQueryDescription] = (0, $exYeM.useState)("");
    const [selectedSavedQuery, setSelectedSavedQuery] = (0, $exYeM.useState)(null);
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    const { mutate: createSavedQuery, isLoading: isCreatingSavedQuery, isError: isCreateSavedQueryError } = (0, $8ea068e443b44149$export$faf1ff3a53763de6)();
    const { mutate: updateSavedQuery, isLoading: isUpdatingSavedQuery, isError: isUpdateSavedQueryError } = (0, $b9a1193932379a16$export$ef178906432ebc86)();
    const { mutate: deleteSavedQuery, isLoading: isDeletingSavedQuery, isError: isDeleteSavedQueryError } = (0, $ab5891cb796ab829$export$c0617850890a2b58)();
    const handleOpenDialog = ()=>{
        setOpenDialog(true);
        setSelectedSavedQuery(null); // Reset selectedSavedQuery when opening the dialog
    };
    const handleSaveQuery = (showChartSettings, queryText, chartConfig)=>{
        let formattedChartSettings = {};
        if (showChartSettings) {
            if (!chartConfig || !chartConfig.series) {
                toast({
                    title: "Error",
                    description: "Cannot save a chart style without first creating a chart!",
                    variant: "destructive"
                });
                return;
            }
            formattedChartSettings = {
                chartType: chartConfig.chartType,
                xAxisVariable: chartConfig.xAxisVariable,
                title: chartConfig.title,
                yAxes: chartConfig.series.map((serie)=>({
                        variable: serie.name,
                        color: serie.color
                    }))
            };
        }
        const newQuery = {
            name: queryName,
            description: queryDescription,
            query: queryText,
            ...showChartSettings && {
                chartSettings: formattedChartSettings
            }
        };
        createSavedQuery(newQuery, {
            onSuccess: ()=>{
                queryClient.invalidateQueries("savedQueries");
                setQueryName("");
                setQueryDescription("");
                setOpenDialog(false);
            },
            onError: (error)=>{
                console.error("Error saving query:", error);
            }
        });
    };
    const handleUpdateQuery = (showChartSettings, queryText, chartConfig)=>{
        const updatedQuery = {
            name: queryName,
            description: queryDescription,
            query: queryText,
            ...showChartSettings && {
                chartSettings: chartConfig
            }
        };
        updateSavedQuery({
            queryId: selectedSavedQuery._id,
            updatedQuery: updatedQuery
        }, {
            onSuccess: ()=>{
                queryClient.invalidateQueries("savedQueries");
                setQueryName("");
                setQueryDescription("");
                setOpenDialog(false);
            }
        });
    };
    const handleDeleteQuery = (queryId)=>{
        deleteSavedQuery(queryId, {
            onSuccess: ()=>{
                queryClient.invalidateQueries("getSavedQueries");
            }
        });
    };
    return {
        openDialog: openDialog,
        setOpenDialog: setOpenDialog,
        queryName: queryName,
        setQueryName: setQueryName,
        queryDescription: queryDescription,
        setQueryDescription: setQueryDescription,
        selectedSavedQuery: selectedSavedQuery,
        setSelectedSavedQuery: setSelectedSavedQuery,
        isCreatingSavedQuery: isCreatingSavedQuery,
        isCreateSavedQueryError: isCreateSavedQueryError,
        isUpdatingSavedQuery: isUpdatingSavedQuery,
        isUpdateSavedQueryError: isUpdateSavedQueryError,
        isDeletingSavedQuery: isDeletingSavedQuery,
        isDeleteSavedQueryError: isDeleteSavedQueryError,
        handleOpenDialog: handleOpenDialog,
        handleSaveQuery: handleSaveQuery,
        handleUpdateQuery: handleUpdateQuery,
        handleDeleteQuery: handleDeleteQuery
    };
};
var $3a2521275a9859c3$export$2e2bcd8739ae039 = $3a2521275a9859c3$var$useQueryStates;





var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");









/* -------------------------------------------------------------------------------------------------
 * HoverCard
 * -----------------------------------------------------------------------------------------------*/ let $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$originalBodyUserSelect;
const $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$HOVERCARD_NAME = "HoverCard";
const [$8509dcedc7d96f9f$var$$cef8881cdc69808e$var$createHoverCardContext, $8509dcedc7d96f9f$export$47b6998a836b7260] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$HOVERCARD_NAME, [
    (0, $7b6292e260c70ed7$export$722aac194ae923)
]);
const $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$usePopperScope = (0, $7b6292e260c70ed7$export$722aac194ae923)();
const [$8509dcedc7d96f9f$var$$cef8881cdc69808e$var$HoverCardProvider, $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$useHoverCardContext] = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$createHoverCardContext($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$HOVERCARD_NAME);
const $8509dcedc7d96f9f$export$57a077cc9fbe653e = (props)=>{
    const { __scopeHoverCard: __scopeHoverCard, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, openDelay: openDelay = 700, closeDelay: closeDelay = 300 } = props;
    const popperScope = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$usePopperScope(__scopeHoverCard);
    const openTimerRef = (0, $exYeM.useRef)(0);
    const closeTimerRef = (0, $exYeM.useRef)(0);
    const hasSelectionRef = (0, $exYeM.useRef)(false);
    const isPointerDownOnContentRef = (0, $exYeM.useRef)(false);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const handleOpen = (0, $exYeM.useCallback)(()=>{
        clearTimeout(closeTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>setOpen(true), openDelay);
    }, [
        openDelay,
        setOpen
    ]);
    const handleClose = (0, $exYeM.useCallback)(()=>{
        clearTimeout(openTimerRef.current);
        if (!hasSelectionRef.current && !isPointerDownOnContentRef.current) closeTimerRef.current = window.setTimeout(()=>setOpen(false), closeDelay);
    }, [
        closeDelay,
        setOpen
    ]);
    const handleDismiss = (0, $exYeM.useCallback)(()=>setOpen(false), [
        setOpen
    ]); // cleanup any queued state updates on unmount
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            clearTimeout(openTimerRef.current);
            clearTimeout(closeTimerRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$HoverCardProvider, {
        scope: __scopeHoverCard,
        open: open,
        onOpenChange: setOpen,
        onOpen: handleOpen,
        onClose: handleClose,
        onDismiss: handleDismiss,
        hasSelectionRef: hasSelectionRef,
        isPointerDownOnContentRef: isPointerDownOnContentRef
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$be92b6f5f03c0fe9), popperScope, children));
};
/*#__PURE__*/ Object.assign($8509dcedc7d96f9f$export$57a077cc9fbe653e, {
    displayName: $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$HOVERCARD_NAME
});
/* -------------------------------------------------------------------------------------------------
 * HoverCardTrigger
 * -----------------------------------------------------------------------------------------------*/ const $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$TRIGGER_NAME = "HoverCardTrigger";
const $8509dcedc7d96f9f$export$ef9f7fd8e4ba882f = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeHoverCard: __scopeHoverCard, ...triggerProps } = props;
    const context = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$useHoverCardContext($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$TRIGGER_NAME, __scopeHoverCard);
    const popperScope = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$usePopperScope(__scopeHoverCard);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $aJx1R.default)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).a, (0, $aJx1R.default)({
        "data-state": context.open ? "open" : "closed"
    }, triggerProps, {
        ref: forwardedRef,
        onPointerEnter: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerEnter, $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$excludeTouch(context.onOpen)),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerLeave, $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$excludeTouch(context.onClose)),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, context.onOpen),
        onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlur, context.onClose) // prevent focus event on touch devices
        ,
        onTouchStart: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onTouchStart, (event)=>event.preventDefault())
    })));
});
/*#__PURE__*/ Object.assign($8509dcedc7d96f9f$export$ef9f7fd8e4ba882f, {
    displayName: $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * HoverCardPortal
 * -----------------------------------------------------------------------------------------------*/ const $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$PORTAL_NAME = "HoverCardPortal";
const [$8509dcedc7d96f9f$var$$cef8881cdc69808e$var$PortalProvider, $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$usePortalContext] = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$createHoverCardContext($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$PORTAL_NAME, {
    forceMount: undefined
});
const $8509dcedc7d96f9f$export$b384c6e0a789f88b = (props)=>{
    const { __scopeHoverCard: __scopeHoverCard, forceMount: forceMount, children: children, container: container } = props;
    const context = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$useHoverCardContext($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$PORTAL_NAME, __scopeHoverCard);
    return /*#__PURE__*/ (0, $exYeM.createElement)($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$PortalProvider, {
        scope: __scopeHoverCard,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($8509dcedc7d96f9f$export$b384c6e0a789f88b, {
    displayName: $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * HoverCardContent
 * -----------------------------------------------------------------------------------------------*/ const $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$CONTENT_NAME = "HoverCardContent";
const $8509dcedc7d96f9f$export$aa4724a5938c586 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$usePortalContext($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$CONTENT_NAME, props.__scopeHoverCard);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$useHoverCardContext($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$CONTENT_NAME, props.__scopeHoverCard);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$HoverCardContentImpl, (0, $aJx1R.default)({
        "data-state": context.open ? "open" : "closed"
    }, contentProps, {
        onPointerEnter: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerEnter, $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$excludeTouch(context.onOpen)),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerLeave, $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$excludeTouch(context.onClose)),
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($8509dcedc7d96f9f$export$aa4724a5938c586, {
    displayName: $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$HoverCardContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeHoverCard: __scopeHoverCard, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$useHoverCardContext($8509dcedc7d96f9f$var$$cef8881cdc69808e$var$CONTENT_NAME, __scopeHoverCard);
    const popperScope = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$usePopperScope(__scopeHoverCard);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [containSelection, setContainSelection] = (0, $exYeM.useState)(false);
    (0, $exYeM.useEffect)(()=>{
        if (containSelection) {
            const body = document.body; // Safari requires prefix
            $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$originalBodyUserSelect = body.style.userSelect || body.style.webkitUserSelect;
            body.style.userSelect = "none";
            body.style.webkitUserSelect = "none";
            return ()=>{
                body.style.userSelect = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$originalBodyUserSelect;
                body.style.webkitUserSelect = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$originalBodyUserSelect;
            };
        }
    }, [
        containSelection
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (ref.current) {
            const handlePointerUp = ()=>{
                setContainSelection(false);
                context.isPointerDownOnContentRef.current = false; // Delay a frame to ensure we always access the latest selection
                setTimeout(()=>{
                    var _document$getSelectio;
                    const hasSelection = ((_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : _document$getSelectio.toString()) !== "";
                    if (hasSelection) context.hasSelectionRef.current = true;
                });
            };
            document.addEventListener("pointerup", handlePointerUp);
            return ()=>{
                document.removeEventListener("pointerup", handlePointerUp);
                context.hasSelectionRef.current = false;
                context.isPointerDownOnContentRef.current = false;
            };
        }
    }, [
        context.isPointerDownOnContentRef,
        context.hasSelectionRef
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (ref.current) {
            const tabbables = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$getTabbableNodes(ref.current);
            tabbables.forEach((tabbable)=>tabbable.setAttribute("tabindex", "-1"));
        }
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(onFocusOutside, (event)=>{
            event.preventDefault();
        }),
        onDismiss: context.onDismiss
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$7c6e2c02157bb7d2), (0, $aJx1R.default)({}, popperScope, contentProps, {
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(contentProps.onPointerDown, (event)=>{
            // Contain selection to current layer
            if (event.currentTarget.contains(event.target)) setContainSelection(true);
            context.hasSelectionRef.current = false;
            context.isPointerDownOnContentRef.current = true;
        }),
        ref: composedRefs,
        style: {
            ...contentProps.style,
            userSelect: containSelection ? "text" : undefined,
            // Safari requires prefix
            WebkitUserSelect: containSelection ? "text" : undefined,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
        }
    })));
});
/* -------------------------------------------------------------------------------------------------
 * HoverCardArrow
 * -----------------------------------------------------------------------------------------------*/ const $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$ARROW_NAME = "HoverCardArrow";
const $8509dcedc7d96f9f$export$b9744d3e7456d806 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeHoverCard: __scopeHoverCard, ...arrowProps } = props;
    const popperScope = $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$usePopperScope(__scopeHoverCard);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$21b07c8f274aebd5), (0, $aJx1R.default)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($8509dcedc7d96f9f$export$b9744d3e7456d806, {
    displayName: $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$excludeTouch(eventHandler) {
    return (event)=>event.pointerType === "touch" ? undefined : eventHandler();
}
/**
 * Returns a list of nodes that can be in the tab sequence.
 * @see: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 */ function $8509dcedc7d96f9f$var$$cef8881cdc69808e$var$getTabbableNodes(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
const $8509dcedc7d96f9f$export$be92b6f5f03c0fe9 = $8509dcedc7d96f9f$export$57a077cc9fbe653e;
const $8509dcedc7d96f9f$export$41fb9f06171c75f4 = $8509dcedc7d96f9f$export$ef9f7fd8e4ba882f;
const $8509dcedc7d96f9f$export$602eac185826482c = $8509dcedc7d96f9f$export$b384c6e0a789f88b;
const $8509dcedc7d96f9f$export$7c6e2c02157bb7d2 = $8509dcedc7d96f9f$export$aa4724a5938c586;
const $8509dcedc7d96f9f$export$21b07c8f274aebd5 = $8509dcedc7d96f9f$export$b9744d3e7456d806;



const $779b7efe4205752d$export$57a077cc9fbe653e = $8509dcedc7d96f9f$export$be92b6f5f03c0fe9;
const $779b7efe4205752d$export$ef9f7fd8e4ba882f = $8509dcedc7d96f9f$export$41fb9f06171c75f4;
const $779b7efe4205752d$export$aa4724a5938c586 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, align: align = "center", sideOffset: sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($8509dcedc7d96f9f$export$7c6e2c02157bb7d2, {
        ref: ref,
        align: align,
        sideOffset: sideOffset,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
        ...props
    }));
$779b7efe4205752d$export$aa4724a5938c586.displayName = "HoverCardContent";


function $52f753a61b21f1a5$export$2e2bcd8739ae039() {
    const bottomTableRef = (0, $exYeM.useRef)(null);
    const [isMinimized, setIsMinimized] = (0, $exYeM.useState)(false);
    const toggleEditorSize = ()=>{
        setIsMinimized(!isMinimized);
    };
    const editorHeight = isMinimized ? "100px" : `${24}em`; // Adjust the editor height based on isMinimized
    const { openDialog: openDialog, setOpenDialog: setOpenDialog, queryName: queryName, setQueryName: setQueryName, queryDescription: queryDescription, setQueryDescription: setQueryDescription, selectedSavedQuery: selectedSavedQuery, isCreatingSavedQuery: isCreatingSavedQuery, isCreateSavedQueryError: isCreateSavedQueryError, isUpdatingSavedQuery: isUpdatingSavedQuery, isUpdateSavedQueryError: isUpdateSavedQueryError, isDeletingSavedQuery: isDeletingSavedQuery, isDeleteSavedQueryError: isDeleteSavedQueryError, handleOpenDialog: handleOpenDialog, handleSaveQuery: handleSaveQuery, handleUpdateQuery: handleUpdateQuery, handleDeleteQuery: handleDeleteQuery } = (0, $3a2521275a9859c3$export$2e2bcd8739ae039)();
    const { data: premadeQueries, isLoading: isLoadingPremadeQueries, isError: isLoadingPremadeQueriesError } = (0, $84789be942e9ff0a$export$2e2bcd8739ae039)();
    const [userQuery, setUserQuery] = (0, $exYeM.useState)("");
    const [timer, setTimer] = (0, $exYeM.useState)(0);
    const [timerActive, setTimerActive] = (0, $exYeM.useState)(false); // New state to control timer
    const [showTimer, setShowTimer] = (0, $exYeM.useState)(false); // State to control timer visibility
    const [isSavedQuery, setIsSavedQuery] = (0, $exYeM.useState)(false);
    const [isOpen, setIsOpen] = (0, $exYeM.useState)(false);
    const handleOpenModal = ()=>setIsOpen(true);
    const handleCloseModal = ()=>setIsOpen(false);
    const [chartConfig, setChartConfig] = (0, $exYeM.useState)(null);
    const [activeTab, setActiveTab] = (0, $exYeM.useState)("table"); // State for active tab
    const handleOnSubmit = (config)=>{
        const series = (config.yAxes || []).map((yAxisConfig)=>{
            const seriesData = queryData.data.map((item)=>{
                // Check if the timestamp is in seconds and convert to milliseconds if necessary
                const timestamp = item[config.xAxisVariable];
                const isSeconds = timestamp.toString().length <= 10; // Assumes it's in seconds if length <= 10
                const dateInMilliseconds = isSeconds ? timestamp * 1000 : timestamp;
                // Convert each item to a 2D array [x, y]
                return [
                    new Date(dateInMilliseconds).getTime(),
                    parseFloat(item[yAxisConfig.variable])
                ];
            });
            seriesData.sort((a, b)=>a[0] - b[0]);
            return {
                name: yAxisConfig.variable,
                data: seriesData,
                color: yAxisConfig.color,
                title: config.title
            };
        });
        // Here you would typically use the 'series' array, e.g., to configure a chart
        // Update the chartConfig state with the transformed series data
        setChartConfig({
            chartType: config.chartType,
            xAxisVariable: config.xAxisVariable,
            series: series,
            title: config.title
        });
        handleCloseModal(); // Close the modal after submitting
    };
    // useMutation is used here due to the nature of POST requests,
    // even if the operation is fetching data without side effects.
    const { mutate: executeQuery, data: queryData, isPending: isPending } = (0, $a964d10fec79d989$export$2e2bcd8739ae039)({
        setTimer: setTimer,
        setTimerActive: setTimerActive,
        setShowTimer: setShowTimer
    });
    (0, $exYeM.useEffect)(()=>{
        let intervalId;
        if (timerActive) intervalId = setInterval(()=>{
            setTimer((prevTimer)=>prevTimer + 1);
        }, 100);
        else if (!timerActive && intervalId) clearInterval(intervalId); // Clear interval if timer is not active
        return ()=>clearInterval(intervalId); // Cleanup on component unmount
    }, [
        timerActive
    ]);
    const handleRunQuery = ()=>{
        executeQuery(userQuery, {
            onSuccess: (queryData)=>{
                if (chartConfig && chartConfig.series && chartConfig.series.length > 0 && isSavedQuery) updateChartConfigWithData(queryData);
            }
        });
    };
    const updateChartConfigWithData = (queryData)=>{
        if (!queryData || !queryData.data) return;
        // Sort the query data by the xAxisVariable
        const sortedData = queryData.data.sort((a, b)=>{
            return new Date(a[chartConfig.xAxisVariable]).getTime() - new Date(b[chartConfig.xAxisVariable]).getTime();
        });
        const updatedSeries = chartConfig.series.map((series)=>{
            const seriesDataPoints = sortedData.map((item)=>{
                const timestamp = item[chartConfig.xAxisVariable];
                const isSeconds = timestamp.toString().length <= 10;
                const dateInMilliseconds = isSeconds ? timestamp * 1000 : timestamp;
                return [
                    new Date(dateInMilliseconds).getTime(),
                    parseFloat(item[series.name])
                ];
            });
            return {
                ...series,
                data: seriesDataPoints
            };
        });
        setChartConfig((prevConfig)=>({
                ...prevConfig,
                series: updatedSeries
            }));
        setChartConfig((prevConfig)=>({
                ...prevConfig,
                series: updatedSeries
            }));
    };
    // get keys
    let allKeys = [];
    if (queryData && queryData.data && Array.isArray(queryData.data)) queryData.data.forEach((item)=>{
        Object.keys(item).forEach((key)=>{
            if (!allKeys.includes(key)) allKeys.push(key);
        });
    });
    const columns = allKeys.map((key)=>({
            accessorKey: key,
            header: key.charAt(0).toUpperCase() + key.slice(1)
        }));
    const handleTabSwitch = (tabName)=>{
        setActiveTab(tabName);
    };
    const loadChartSettings = (settings)=>{
        if (settings) {
            setChartConfig({
                chartType: settings.chartType || "",
                xAxisVariable: settings.xAxisVariable || "",
                title: settings.title || "",
                series: settings.yAxes ? settings.yAxes.map((yAxis)=>({
                        name: yAxis.variable,
                        color: yAxis.color
                    })) : []
            });
            setIsSavedQuery(true);
        }
    };
    //passing click in
    const handleAddColumnToQuery = (columnName)=>{
        setUserQuery((currentQuery)=>{
            // Check if query already ends with a comma or space, and append accordingly
            const separator = currentQuery.trim().endsWith(",") ? " " : ", ";
            // Avoid adding a comma if the query is empty
            const newQuery = currentQuery ? `${currentQuery}${separator}${columnName}` : columnName;
            return newQuery;
        });
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex h-full ",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a0a70b37e6ff9187$export$2e2bcd8739ae039), {
                onAddColumn: handleAddColumnToQuery,
                queryText: userQuery,
                chartConfig: chartConfig,
                setChartConfig: setChartConfig,
                onLoadChartSettings: loadChartSettings,
                premadeQueries: premadeQueries,
                isLoadingPremadeQueries: isLoadingPremadeQueries,
                isLoadingPremadeQueriesError: isLoadingPremadeQueriesError
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex-1 p-4 overflow-y-hidden",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                className: "text-2xl font-bold",
                                children: "Query"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    (!userQuery.toLowerCase().includes("limit") || userQuery.toLowerCase().match(/limit\s+(\d+)/i) && parseInt(userQuery.toLowerCase().match(/limit\s+(\d+)/i)[1], 10) > 100000) && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $779b7efe4205752d$export$57a077cc9fbe653e), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $779b7efe4205752d$export$ef9f7fd8e4ba882f), {
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27d9ac66a331f667$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-black"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $779b7efe4205752d$export$aa4724a5938c586), {
                                                className: "bg-white",
                                                children: "Warning: No LIMIT clause found or LIMIT exceeds 100,000. A default limit will be applied."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                        variant: "outline",
                                        onClick: handleRunQuery,
                                        disabled: isPending,
                                        className: "ml-2",
                                        children: isPending ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: "flex items-center",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                children: "Loading..."
                                            })
                                        }) : "Run"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-col h-full",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
                                className: "p-4 flex-shrink-0",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f2300adf5a34cbfd$export$2e2bcd8739ae039), {
                                        height: editorHeight,
                                        value: userQuery,
                                        onChange: setUserQuery,
                                        className: "px-4"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b01141b5b6f9bf00$export$2e2bcd8739ae039), {
                                        isMinimized: isMinimized,
                                        toggle: toggleEditorSize,
                                        className: ""
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                        variant: "outline",
                                        onClick: handleOpenDialog,
                                        className: "ml-2",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $92ca66f52aed8449$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 mr-2"
                                            }),
                                            "Save"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $711a0923c5b79c78$export$2e2bcd8739ae039), {
                                        open: openDialog,
                                        setOpen: setOpenDialog,
                                        queryName: queryName,
                                        setQueryName: setQueryName,
                                        queryDescription: queryDescription,
                                        setQueryDescription: setQueryDescription,
                                        handleSaveQuery: (showChartSettings)=>handleSaveQuery(showChartSettings, userQuery, chartConfig),
                                        isCreating: isCreatingSavedQuery,
                                        isError: isCreateSavedQueryError,
                                        isEdit: selectedSavedQuery !== null,
                                        handleUpdateQuery: (showChartSettings)=>handleUpdateQuery(showChartSettings, userQuery, chartConfig),
                                        isUpdating: isUpdatingSavedQuery,
                                        isUpdateError: isUpdateSavedQueryError,
                                        handleDeleteQuery: handleDeleteQuery,
                                        isDeleting: isDeletingSavedQuery,
                                        isDeleteError: isDeleteSavedQueryError,
                                        selectedQueryId: selectedSavedQuery?._id,
                                        chartConfig: chartConfig,
                                        setChartConfig: setChartConfig
                                    }),
                                    queryData && queryData.data && queryData.data.length > 0 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {}),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex justify-between items-center mt-4",
                                        children: [
                                            showTimer && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                children: [
                                                    "Query Duration: ",
                                                    (timer / 10).toFixed(1),
                                                    " seconds"
                                                ]
                                            }),
                                            !showTimer && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {})
                                        ]
                                    })
                                ]
                            }),
                            queryData && queryData.data && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "flex-grow mt-8 ",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a749a2c12abc4cb4$export$2e2bcd8739ae039), {
                                    ref: bottomTableRef,
                                    activeTab: activeTab,
                                    queryData: queryData,
                                    handleTabSwitch: handleTabSwitch,
                                    chartConfig: chartConfig,
                                    isOpen: isOpen,
                                    handleCloseModal: handleCloseModal,
                                    handleOpenModal: handleOpenModal,
                                    handleOnSubmit: handleOnSubmit,
                                    allKeys: allKeys,
                                    columns: columns,
                                    isMinimized: isMinimized
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $bab2b94e392129b9$var$ArrowLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M11.03 3.97a.75.75 0 010 1.06l-6.22 6.22H21a.75.75 0 010 1.5H4.81l6.22 6.22a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z",
        clipRule: "evenodd"
    }));
}
const $bab2b94e392129b9$var$ForwardRef = $exYeM.forwardRef($bab2b94e392129b9$var$ArrowLeftIcon);
var $bab2b94e392129b9$export$2e2bcd8739ae039 = $bab2b94e392129b9$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $c2083955e5c2a4e4$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
        clipRule: "evenodd"
    }));
}
const $c2083955e5c2a4e4$var$ForwardRef = $exYeM.forwardRef($c2083955e5c2a4e4$var$Bars3Icon);
var $c2083955e5c2a4e4$export$2e2bcd8739ae039 = $c2083955e5c2a4e4$var$ForwardRef;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");











var $exYeM = parcelRequire("exYeM");
var $abf2b4c00e1ed167$var$t;
let $abf2b4c00e1ed167$export$7568632d0d33d16d = ($abf2b4c00e1ed167$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).startTransition) != null ? $abf2b4c00e1ed167$var$t : function(i) {
    i();
};


var $cc97e116d42111e1$var$q = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($cc97e116d42111e1$var$q || {}), $cc97e116d42111e1$var$z = ((t)=>(t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t))($cc97e116d42111e1$var$z || {});
let $cc97e116d42111e1$var$Q = {
    [0]: (e)=>({
            ...e,
            disclosureState: (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    [4] (e) {
        return e.linkedPanel === !0 ? e : {
            ...e,
            linkedPanel: !0
        };
    },
    [5] (e) {
        return e.linkedPanel === !1 ? e : {
            ...e,
            linkedPanel: !1
        };
    },
    [2] (e, n) {
        return e.buttonId === n.buttonId ? e : {
            ...e,
            buttonId: n.buttonId
        };
    },
    [3] (e, n) {
        return e.panelId === n.panelId ? e : {
            ...e,
            panelId: n.panelId
        };
    }
}, $cc97e116d42111e1$var$k = (0, $exYeM.createContext)(null);
$cc97e116d42111e1$var$k.displayName = "DisclosureContext";
function $cc97e116d42111e1$var$M(e) {
    let n = (0, $exYeM.useContext)($cc97e116d42111e1$var$k);
    if (n === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $cc97e116d42111e1$var$M), o;
    }
    return n;
}
let $cc97e116d42111e1$var$v = (0, $exYeM.createContext)(null);
$cc97e116d42111e1$var$v.displayName = "DisclosureAPIContext";
function $cc97e116d42111e1$var$w(e) {
    let n = (0, $exYeM.useContext)($cc97e116d42111e1$var$v);
    if (n === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $cc97e116d42111e1$var$w), o;
    }
    return n;
}
let $cc97e116d42111e1$var$H = (0, $exYeM.createContext)(null);
$cc97e116d42111e1$var$H.displayName = "DisclosurePanelContext";
function $cc97e116d42111e1$var$V() {
    return (0, $exYeM.useContext)($cc97e116d42111e1$var$H);
}
function $cc97e116d42111e1$var$Y(e, n) {
    return (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(n.type, $cc97e116d42111e1$var$Q, e, n);
}
let $cc97e116d42111e1$var$Z = (0, $exYeM.Fragment);
function $cc97e116d42111e1$var$ee(e, n) {
    let { defaultOpen: o = !1, ...u } = e, T = (0, $exYeM.useRef)(null), l = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(n, (0, $b45ba282b8330326$export$7029785b750eb74)((a)=>{
        T.current = a;
    }, e.as === void 0 || e.as === (0, $exYeM.Fragment))), t = (0, $exYeM.useRef)(null), f = (0, $exYeM.useRef)(null), s = (0, $exYeM.useReducer)($cc97e116d42111e1$var$Y, {
        disclosureState: o ? 0 : 1,
        linkedPanel: !1,
        buttonRef: f,
        panelRef: t,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: i, buttonId: c }, D] = s, d = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((a)=>{
        D({
            type: 1
        });
        let r = (0, $a54eed888c938856$export$b204af158042fbac)(T);
        if (!r || !c) return;
        let p = (()=>a ? a instanceof HTMLElement ? a : a.current instanceof HTMLElement ? a.current : r.getElementById(c) : r.getElementById(c))();
        p == null || p.focus();
    }), P = (0, $exYeM.useMemo)(()=>({
            close: d
        }), [
        d
    ]), b = (0, $exYeM.useMemo)(()=>({
            open: i === 0,
            close: d
        }), [
        i,
        d
    ]), y = {
        ref: l
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc97e116d42111e1$var$k.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc97e116d42111e1$var$v.Provider, {
        value: P
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d2513f66ac282f05$export$2a0ed818b175f558), {
        value: (0, $73fd0be368b973e0$export$4659b591c19bdf3d)(i, {
            [0]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open,
            [1]: (0, $d2513f66ac282f05$export$7254cc27399e90bd).Closed
        })
    }, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: y,
        theirProps: u,
        slot: b,
        defaultTag: $cc97e116d42111e1$var$Z,
        name: "Disclosure"
    }))));
}
let $cc97e116d42111e1$var$te = "button";
function $cc97e116d42111e1$var$ne(e, n) {
    let o = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: u = `headlessui-disclosure-button-${o}`, ...T } = e, [l, t] = $cc97e116d42111e1$var$M("Disclosure.Button"), f = $cc97e116d42111e1$var$V(), s = f === null ? !1 : f === l.panelId, i = (0, $exYeM.useRef)(null), c = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(i, n, s ? null : l.buttonRef);
    (0, $exYeM.useEffect)(()=>{
        if (!s) return t({
            type: 2,
            buttonId: u
        }), ()=>{
            t({
                type: 2,
                buttonId: null
            });
        };
    }, [
        u,
        t,
        s
    ]);
    let D = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>{
        var p;
        if (s) {
            if (l.disclosureState === 1) return;
            switch(r.key){
                case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space:
                case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), r.stopPropagation(), t({
                        type: 0
                    }), (p = l.buttonRef.current) == null || p.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space:
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), t({
                    type: 0
                });
                break;
        }
    }), d = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>{
        switch(r.key){
            case (0, $58dbca9ad58e6a75$export$4b0075e5ea5e1f26).Space:
                r.preventDefault();
                break;
        }
    }), P = (0, $0fe40135503fe52e$export$90fc3a17d93f704c)((r)=>{
        var p;
        (0, $b762bd1946006453$export$db61f031a278447c)(r.currentTarget) || e.disabled || (s ? (t({
            type: 0
        }), (p = l.buttonRef.current) == null || p.focus()) : t({
            type: 0
        }));
    }), b = (0, $exYeM.useMemo)(()=>({
            open: l.disclosureState === 0
        }), [
        l
    ]), y = (0, $5848675429035810$export$53652b2b272efe9c)(e, i), a = s ? {
        ref: c,
        type: y,
        onKeyDown: D,
        onClick: P
    } : {
        ref: c,
        id: u,
        type: y,
        "aria-expanded": l.disclosureState === 0,
        "aria-controls": l.linkedPanel ? l.panelId : void 0,
        onKeyDown: D,
        onKeyUp: d,
        onClick: P
    };
    return (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: a,
        theirProps: T,
        slot: b,
        defaultTag: $cc97e116d42111e1$var$te,
        name: "Disclosure.Button"
    });
}
let $cc97e116d42111e1$var$le = "div", $cc97e116d42111e1$var$oe = (0, $6da0b689c34972b7$export$617d79dae526d2cf).RenderStrategy | (0, $6da0b689c34972b7$export$617d79dae526d2cf).Static;
function $cc97e116d42111e1$var$re(e, n) {
    let o = (0, $8461bf68a681c36b$export$f680877a34711e37)(), { id: u = `headlessui-disclosure-panel-${o}`, ...T } = e, [l, t] = $cc97e116d42111e1$var$M("Disclosure.Panel"), { close: f } = $cc97e116d42111e1$var$w("Disclosure.Panel"), s = (0, $b45ba282b8330326$export$f6a25a78204acc7e)(n, l.panelRef, (P)=>{
        (0, $abf2b4c00e1ed167$export$7568632d0d33d16d)(()=>t({
                type: P ? 4 : 5
            }));
    });
    (0, $exYeM.useEffect)(()=>(t({
            type: 3,
            panelId: u
        }), ()=>{
            t({
                type: 3,
                panelId: null
            });
        }), [
        u,
        t
    ]);
    let i = (0, $d2513f66ac282f05$export$fc6fdf0ecf360e)(), c = (()=>i !== null ? (i & (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open) === (0, $d2513f66ac282f05$export$7254cc27399e90bd).Open : l.disclosureState === 0)(), D = (0, $exYeM.useMemo)(()=>({
            open: l.disclosureState === 0,
            close: f
        }), [
        l,
        f
    ]), d = {
        ref: s,
        id: u
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($cc97e116d42111e1$var$H.Provider, {
        value: l.panelId
    }, (0, $6da0b689c34972b7$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: T,
        slot: D,
        defaultTag: $cc97e116d42111e1$var$le,
        features: $cc97e116d42111e1$var$oe,
        visible: c,
        name: "Disclosure.Panel"
    }));
}
let $cc97e116d42111e1$var$se = (0, $6da0b689c34972b7$export$e43f39796049410c)($cc97e116d42111e1$var$ee), $cc97e116d42111e1$var$ue = (0, $6da0b689c34972b7$export$e43f39796049410c)($cc97e116d42111e1$var$ne), $cc97e116d42111e1$var$ie = (0, $6da0b689c34972b7$export$e43f39796049410c)($cc97e116d42111e1$var$re), $cc97e116d42111e1$export$74a362b31437ec83 = Object.assign($cc97e116d42111e1$var$se, {
    Button: $cc97e116d42111e1$var$ue,
    Panel: $cc97e116d42111e1$var$ie
});



var $exYeM = parcelRequire("exYeM");
function $3089dd68b3af4c30$var$CubeIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M12.378 1.602a.75.75 0 00-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03zM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 00.372-.648V7.93zM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 00.372.648l8.628 5.033z"
    }));
}
const $3089dd68b3af4c30$var$ForwardRef = $exYeM.forwardRef($3089dd68b3af4c30$var$CubeIcon);
var $3089dd68b3af4c30$export$2e2bcd8739ae039 = $3089dd68b3af4c30$var$ForwardRef;


const $ed30c16413ffd913$var$SidebarItem = ({ category: category, icon: icon, tables: tables, sidebar: sidebar, onTableSelect: onTableSelect })=>{
    const [imgError, setImgError] = (0, $exYeM.useState)(false);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc97e116d42111e1$export$74a362b31437ec83), {
        as: "div",
        children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $cc97e116d42111e1$export$74a362b31437ec83).Button, {
                        className: "flex w-full place-items-center bg-white justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "grid grid-flow-col items-center",
                                children: [
                                    imgError ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3089dd68b3af4c30$export$2e2bcd8739ae039), {
                                        className: "object-scale-down h-8 w-8 mr-2 text-primary"
                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                        className: "object-scale-down h-8 w-8 mr-2 text-primary",
                                        // src={addresses}
                                        src: "https://api.wevr.ai/V2/" + icon,
                                        alt: "",
                                        onError: ()=>setImgError(true)
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: `${sidebar ? "font-roboto font-light text-base" : "hidden"}`,
                                        children: category
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $133f3292e600dc93$export$2e2bcd8739ae039), {
                                className: `${open ? "transform -rotate-90" : ""} h-6 w-6 text-onSurfaceVariant`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc97e116d42111e1$export$74a362b31437ec83).Panel, {
                        className: "space-y-1 bg-surfaceVariant rounded-lg mt-1",
                        children: tables.map((table)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                className: "w-full flex justify-between items-center rounded-lg p-2 font-light hover:bg-primary hover:text-white transition-all",
                                onClick: ()=>onTableSelect(table),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: table.name
                                })
                            }, table._id))
                    })
                ]
            })
    });
};
var $ed30c16413ffd913$export$2e2bcd8739ae039 = $ed30c16413ffd913$var$SidebarItem;


// SidebarIcon.js

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

const $f6bdc8d0238ca63a$var$SidebarIcon = ({ category: category, setSidebar: setSidebar, sidebar: sidebar })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
            onClick: ()=>setSidebar(!sidebar),
            className: "flex justify-center items-center w-full bg-white p-2 rounded-lg border-2 border-primaryContainer",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3089dd68b3af4c30$export$2e2bcd8739ae039), {
                className: "h-6 w-6 text-primary"
            })
        })
    });
var $f6bdc8d0238ca63a$export$2e2bcd8739ae039 = $f6bdc8d0238ca63a$var$SidebarIcon;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



function $d3db549d03db2e76$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $d3db549d03db2e76$var$BlockchainDropdown({ blockchainData: blockchainData, onBlockchainChange: onBlockchainChange }) {
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [selected, setSelected] = (0, $exYeM.useState)();
    (0, $exYeM.useEffect)(()=>{
        if (blockchainData) {
            const selectedBlockchain = searchParams.get("blockchain");
            const defaultBlockchain = blockchainData[0];
            const obj = blockchainData.find((o)=>o.name.toLowerCase() === selectedBlockchain);
            setSelected(obj || defaultBlockchain);
        }
    }, [
        blockchainData,
        searchParams
    ]);
    const handleBlockchainSelect = (blockchain)=>{
        setSelected(blockchain);
        setSearchParams({
            blockchain: blockchain.name.toLowerCase()
        });
        if (onBlockchainChange) onBlockchainChange(blockchain);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659), {
        value: selected,
        onChange: handleBlockchainSelect,
        children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "relative w-full",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Button, {
                            className: "relative w-full rounded-lg border border-primary bg-white py-2 pl-3 pr-10 text-left",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                    className: "flex items-center",
                                    children: [
                                        selected && /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                            src: "https://api.wevr.ai/V2/" + selected.icon,
                                            alt: "",
                                            className: "h-6 w-6 flex-shrink-0 rounded-full"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "ml-3 block truncate font-semibold text-lg",
                                            children: selected ? selected.name : "Select a blockchain"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "absolute inset-y-0 right-0 ml-3 flex items-center pr-2",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dd814d617586c39d$export$2e2bcd8739ae039), {
                                        className: "h-6 w-6 text-primary",
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                            show: open,
                            as: (0, $exYeM.Fragment),
                            leave: "transition ease-in duration-100",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Options, {
                                className: "absolute z-30 mt-1 max-h-56 w-full overflow-auto rounded-lg bg-white shadow-lg border border-primary",
                                children: blockchainData.map((blockchain)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Option, {
                                        className: ({ active: active })=>$d3db549d03db2e76$var$classNames(active ? "text-white bg-primary" : "text-gray-900", "relative py-2 pl-3 pr-9 rounded-md cursor-pointer"),
                                        value: blockchain,
                                        children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                                src: "https://api.wevr.ai/V2/" + blockchain.icon,
                                                                alt: "",
                                                                className: "h-6 w-6 flex-shrink-0 rounded-full"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                className: $d3db549d03db2e76$var$classNames(selected ? "" : "font-normal", "ml-3 block truncate"),
                                                                children: blockchain.name
                                                            })
                                                        ]
                                                    }),
                                                    selected ? /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: $d3db549d03db2e76$var$classNames(active ? "text-white" : "text-primary", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ad110a4e18e6d96b$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5",
                                                            "aria-hidden": "true"
                                                        })
                                                    }) : null
                                                ]
                                            })
                                    }, blockchain._id))
                            })
                        })
                    ]
                })
            })
    });
}
var $d3db549d03db2e76$export$2e2bcd8739ae039 = $d3db549d03db2e76$var$BlockchainDropdown;


const $d63cbb09a3691bf2$var$SidebarWrapper = ({ tableStores: tableStores = [], onTableSelect: onTableSelect, isLoading: isLoading, blockchainData: blockchainData, onBlockchainChange: onBlockchainChange })=>{
    const [sidebar, setSidebar] = (0, $exYeM.useState)(true);
    const { width: width } = (0, $a88fc3007e889430$export$2e2bcd8739ae039)();
    const [searchQuery, setSearchQuery] = (0, $exYeM.useState)("");
    const [filteredTables, setFilteredTables] = (0, $exYeM.useState)(tableStores);
    (0, $exYeM.useEffect)(()=>{
        if (width <= 768) setSidebar(false);
        else setSidebar(true);
    }, [
        width
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (searchQuery) setFilteredTables(tableStores.filter((table)=>table.name.toLowerCase().includes(searchQuery.toLowerCase())));
        else setFilteredTables(tableStores);
    }, [
        searchQuery,
        tableStores
    ]);
    const categorizedTables = filteredTables.reduce((acc, table)=>{
        const { category: category, icon: icon } = table;
        if (!acc[category]) acc[category] = {
            category: category,
            icon: icon,
            tables: []
        }; // Initialize with category and icon
        acc[category].tables.push(table); // Push the table into the tables array
        return acc;
    }, {});
    const handleTableSelect = (table)=>{
        if (typeof onTableSelect === "function") onTableSelect(table);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col h-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "md:hidden flex items-center justify-between bg-surface p-2",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    onClick: ()=>setSidebar(!sidebar),
                    className: "bg-surfaceVariant rounded-xl p-2 border-2 group border-primaryContainer hover:bg-primary hover:text-white transition duration-0",
                    children: sidebar ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
                        className: "h-8 w-8 group-hover:text-white text-onSurfaceVariant"
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c2083955e5c2a4e4$export$2e2bcd8739ae039), {
                        className: "h-8 w-8 group-hover:text-white text-onSurfaceVariant"
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: `${sidebar ? "block w-full md:w-[248px]" : "hidden md:block md:w-20"} h-full md:h-[90vh] px-1 pb-4 transition-all font-roboto bg-surface`,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "hidden md:flex md:justify-between md:items-center md:px-2 md:py-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                onClick: ()=>setSidebar(!sidebar),
                                className: "bg-surfaceVariant rounded-xl p-2 border-2 group border-primaryContainer hover:bg-primary hover:text-white transition duration-0",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bab2b94e392129b9$export$2e2bcd8739ae039), {
                                    className: `${sidebar ? "transition duration-75" : "rotate-180 transition duration-75"} object-scale-down h-8 w-8 group-hover:text-white text-onSurfaceVariant`
                                })
                            }),
                            sidebar && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "relative w-full ml-2",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                    type: "text",
                                    name: "search",
                                    id: "search",
                                    placeholder: "Search",
                                    value: searchQuery,
                                    onChange: (e)=>setSearchQuery(e.target.value),
                                    className: "w-full px-4 h-12 rounded-xl border border-primaryContainer focus:border-primary focus:outline-none"
                                })
                            })
                        ]
                    }),
                    sidebar && blockchainData && onBlockchainChange && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "p-2",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d3db549d03db2e76$export$2e2bcd8739ae039), {
                            blockchainData: blockchainData,
                            onBlockchainChange: onBlockchainChange
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "h-full overflow-auto",
                        children: sidebar ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "mx-auto w-full p-2 space-y-2 max-h-full",
                            children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: "Loading..."
                            }) : Object.entries(categorizedTables).map(([category, { icon: icon, tables: tables }])=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $ed30c16413ffd913$export$2e2bcd8739ae039), {
                                    category: category,
                                    icon: icon,
                                    tables: tables,
                                    sidebar: sidebar,
                                    onTableSelect: handleTableSelect
                                }, category))
                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "mx-auto w-full rounded-xl p-2 space-y-4",
                            children: Object.keys(categorizedTables).map((category)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f6bdc8d0238ca63a$export$2e2bcd8739ae039), {
                                    category: category,
                                    setSidebar: setSidebar,
                                    sidebar: sidebar
                                }, category))
                        })
                    })
                ]
            })
        ]
    });
};
var $d63cbb09a3691bf2$export$2e2bcd8739ae039 = $d63cbb09a3691bf2$var$SidebarWrapper;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




function $5ccab20bb3ed28cc$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $5ccab20bb3ed28cc$export$98b14d297b92183b(blockchain, table, compare, filters) {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "getPostgresTableData",
            table?.name,
            table?.interval,
            compare,
            filters
        ],
        queryFn: ()=>{
            if (!blockchain || !table?.name || !table?.interval) return Promise.resolve(null);
            const url = `/getPostgresTableData/${blockchain}/${encodeURIComponent(table.name)}/${table.interval}`;
            const params = {
                compare: compare ? "true" : "false",
                filters: JSON.stringify(filters)
            };
            const headers = {
                Authorization: `Bearer ${$5ccab20bb3ed28cc$var$getToken()}`
            };
            return (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(url, {
                params: params,
                headers: headers
            }).then((response)=>response.data);
        },
        enabled: !!blockchain && !!table?.name && !!table?.interval,
        keepPreviousData: true,
        onError: (error)=>{
            if (error.response?.status === 404) // Return an empty data object if the table is not found for the selected blockchain
            return Promise.resolve({
                graphData: [],
                comparisonData: []
            });
            // Rethrow other errors
            throw error;
        }
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");








/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/ const $809f883df8253f8c$var$$e698a72e93240346$var$CHECKBOX_NAME = "Checkbox";
const [$809f883df8253f8c$var$$e698a72e93240346$var$createCheckboxContext, $809f883df8253f8c$export$b566c4ff5488ea01] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($809f883df8253f8c$var$$e698a72e93240346$var$CHECKBOX_NAME);
const [$809f883df8253f8c$var$$e698a72e93240346$var$CheckboxProvider, $809f883df8253f8c$var$$e698a72e93240346$var$useCheckboxContext] = $809f883df8253f8c$var$$e698a72e93240346$var$createCheckboxContext($809f883df8253f8c$var$$e698a72e93240346$var$CHECKBOX_NAME);
const $809f883df8253f8c$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...checkboxProps } = props;
    const [button, setButton] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $exYeM.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    const initialCheckedStateRef = (0, $exYeM.useRef)(checked);
    (0, $exYeM.useEffect)(()=>{
        const form = button === null || button === void 0 ? void 0 : button.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        button,
        setChecked
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($809f883df8253f8c$var$$e698a72e93240346$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $aJx1R.default)({
        type: "button",
        role: "checkbox",
        "aria-checked": $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $809f883df8253f8c$var$$e698a72e93240346$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, checkboxProps, {
        ref: composedRefs,
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            // According to WAI ARIA, Checkboxes don't activate on enter keypress
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            setChecked((prevChecked)=>$809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect checkbox updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $exYeM.createElement)($809f883df8253f8c$var$$e698a72e93240346$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($809f883df8253f8c$export$48513f6b9f8ce62d, {
    displayName: $809f883df8253f8c$var$$e698a72e93240346$var$CHECKBOX_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/ const $809f883df8253f8c$var$$e698a72e93240346$var$INDICATOR_NAME = "CheckboxIndicator";
const $809f883df8253f8c$export$59aad738f51d1c05 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $809f883df8253f8c$var$$e698a72e93240346$var$useCheckboxContext($809f883df8253f8c$var$$e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $aJx1R.default)({
        "data-state": $809f883df8253f8c$var$$e698a72e93240346$var$getState(context.state),
        "data-disabled": context.disabled ? "" : undefined
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            pointerEvents: "none",
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($809f883df8253f8c$export$59aad738f51d1c05, {
    displayName: $809f883df8253f8c$var$$e698a72e93240346$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $809f883df8253f8c$var$$e698a72e93240346$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const prevChecked = (0, $e863f772c7a65c44$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $e3071ccbaf099f7e$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $exYeM.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked);
            setChecked.call(input, $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)("input", (0, $aJx1R.default)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) ? false : checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $809f883df8253f8c$var$$e698a72e93240346$var$getState(checked) {
    return $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
const $809f883df8253f8c$export$be92b6f5f03c0fe9 = $809f883df8253f8c$export$48513f6b9f8ce62d;
const $809f883df8253f8c$export$adb584737d712b70 = $809f883df8253f8c$export$59aad738f51d1c05;




const $a4503e519d7a9229$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, ref)=>{
    const { className: className, ...otherProps } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsx)($809f883df8253f8c$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", className),
        ...otherProps,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($809f883df8253f8c$export$adb584737d712b70, {
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex items-center justify-center text-current"),
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c12e32cf04d921d4$export$7dd004358974b05d), {
                className: "h-4 w-4"
            })
        })
    });
});
$a4503e519d7a9229$export$48513f6b9f8ce62d.displayName = $809f883df8253f8c$export$be92b6f5f03c0fe9.displayName;





var $exYeM = parcelRequire("exYeM");
function $0087468faaed6f2d$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $0087468faaed6f2d$var$ForwardRef = $exYeM.forwardRef($0087468faaed6f2d$var$Bars3Icon);
var $0087468faaed6f2d$export$2e2bcd8739ae039 = $0087468faaed6f2d$var$ForwardRef;




const $598ede7617f7fc7a$var$HorizontalBar = ({ onFilterChange: onFilterChange, onGranularityChange: onGranularityChange, selectedTable: selectedTable, queryData: queryData, isGrid: isGrid })=>{
    const [dialogOpen, setDialogOpen] = (0, $exYeM.useState)(false);
    const [localInterval, setLocalInterval] = (0, $exYeM.useState)(selectedTable?.interval || "days");
    const [selectedFilters, setSelectedFilters] = (0, $exYeM.useState)([]);
    const toggleDialog = ()=>setDialogOpen(!dialogOpen);
    const handleIntervalChange = (value)=>{
        setLocalInterval(value);
        if (typeof onGranularityChange === "function") onGranularityChange(value);
    };
    const handleFilterChange = (filterName)=>{
        // console.log(filterName);
        setSelectedFilters((prevFilters)=>{
            // console.log(prevFilters);
            const newFilters = prevFilters.includes(filterName) ? prevFilters.filter((f)=>f !== filterName) : [
                ...prevFilters,
                filterName
            ];
            // console.log(newFilters);
            const filterConditions = newFilters.map((filter)=>selectedTable.filters[filter]);
            // console.log(filterConditions);
            if (typeof onFilterChange === "function") onFilterChange(filterConditions);
            // return prevFilters;
            return newFilters;
        });
    };
    (0, $exYeM.useEffect)(()=>{
        setLocalInterval(selectedTable?.interval || "days");
        if (selectedTable?.filters) setSelectedFilters([]); // Reset filters when selectedTable changes
    }, [
        selectedTable
    ]);
    const renderFilters = ()=>{
        if (selectedTable?.filters && Object.keys(selectedTable.filters).length > 0) return Object.keys(selectedTable.filters).map((filterName, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center space-x-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a4503e519d7a9229$export$48513f6b9f8ce62d), {
                        id: `filter-${index}`,
                        checked: selectedFilters.includes(filterName),
                        onCheckedChange: ()=>handleFilterChange(filterName)
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                        className: "text-sm font-medium",
                        htmlFor: `filter-${index}`,
                        children: filterName
                    })
                ]
            }, index));
        else return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {});
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative",
        children: [
            !isGrid && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "hidden sm:flex justify-between items-center py-2 px-4 rounded-t-md border bg-[#F8F9FC]",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex space-x-4",
                        children: renderFilters()
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex space-x-4 items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e56245bdc6005a97$export$ef9b1a59e592288f), {
                                value: localInterval,
                                onValueChange: handleIntervalChange,
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$3ac1e88a1c0b9f1), {
                                        className: "w-[180px]",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$e288731fd71264f0), {
                                            placeholder: "Select interval"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$c973a4b3cb86a03d), {
                                        children: selectedTable?.resolution?.map((interval)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$13ef48a934230896), {
                                                value: interval.toLowerCase(),
                                                children: interval
                                            }, interval))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                onClick: ()=>(0, $71cca3bac7a67ec7$export$60d51d3f7c4f92d8)(queryData?.graphData, "exportedQueryData.csv"),
                                className: "text-white hover:bg-primary hover:text-white px-4 py-2 text-sm font-medium focus:outline-none flex items-center",
                                children: "Export"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: `${isGrid ? "flex" : "flex sm:hidden"} justify-end items-center py-2 px-4 bg-gray-100 rounded-t-md border`,
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $27561b24f6cc51c4$export$3ddf2d174ce01153), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$2e1e1122cf0cba88), {
                            as: (0, $123f871e017f2022$export$353f5b6fc5456de1),
                            onClick: toggleDialog,
                            className: "text-sm",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0087468faaed6f2d$export$2e2bcd8739ae039), {
                                className: "h-6 w-6"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $27561b24f6cc51c4$export$b6d9565de1e068cf), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$16f7638e4a34b909), {
                                    children: "Filter Options"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$94e94c2ec2c954d5), {
                                    children: "Adjust your preferences."
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col space-y-4",
                                    children: [
                                        renderFilters(),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e56245bdc6005a97$export$ef9b1a59e592288f), {
                                            value: localInterval,
                                            onValueChange: handleIntervalChange,
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$3ac1e88a1c0b9f1), {
                                                    className: "w-full",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$e288731fd71264f0), {
                                                        placeholder: "Select interval"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$c973a4b3cb86a03d), {
                                                    children: selectedTable?.resolution?.map((interval)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $e56245bdc6005a97$export$13ef48a934230896), {
                                                            value: interval.toLowerCase(),
                                                            children: interval
                                                        }, interval))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                            onClick: ()=>(0, $71cca3bac7a67ec7$export$60d51d3f7c4f92d8)(queryData?.graphData, "exportedQueryData.csv"),
                                            className: "text-white bg-primary hover:text-gray-200 px-4 py-2 text-sm font-medium focus:outline-none flex items-center",
                                            children: "Export"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$fba2fb7cd781b7ac), {
                                            as: (0, $123f871e017f2022$export$353f5b6fc5456de1),
                                            className: "text-sm",
                                            children: "Close"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $598ede7617f7fc7a$export$2e2bcd8739ae039 = $598ede7617f7fc7a$var$HorizontalBar;


// DescriptionSection.js

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");
const $47f65e8363a2321a$var$DescriptionSection = ({ description: description, sources: sources, dataSource: dataSource, category: category })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col sm:flex-row items-center sm:gap-4 bg-[#F8F9FC] text-black p-4 rounded-lg relative shadow-sm",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-1 bg-primary rounded-full absolute left-4",
                style: {
                    height: "50%",
                    top: "25%"
                }
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex-1 pl-8 sm:pl-12",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                        className: "text-xl font-semibold mb-2",
                        children: "Description"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "text-sm text-gray-600 mb-4",
                        children: description
                    })
                ]
            })
        ]
    });
};
var $47f65e8363a2321a$export$2e2bcd8739ae039 = $47f65e8363a2321a$var$DescriptionSection;




var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");


var $g2dw1 = parcelRequire("g2dw1");

var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $f319ee1b0fdb288a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fnuNu.default)(2, arguments);
    var dateLeft = (0, $2XKMM.default)(dirtyDateLeft);
    var dateRight = (0, $2XKMM.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}



var $2XKMM = parcelRequire("2XKMM");

var $11VSy = parcelRequire("11VSy");


var $fnuNu = parcelRequire("fnuNu");

var $2XKMM = parcelRequire("2XKMM");

var $kNidb = parcelRequire("kNidb");

var $2xHvS = parcelRequire("2xHvS");

var $fnuNu = parcelRequire("fnuNu");
function $1eff655f63a9bbd9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fnuNu.default)(1, arguments);
    var date = (0, $2XKMM.default)(dirtyDate);
    return (0, $kNidb.default)(date).getTime() === (0, $2xHvS.default)(date).getTime();
}


function $f26794150f1b1a6c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fnuNu.default)(2, arguments);
    var dateLeft = (0, $2XKMM.default)(dirtyDateLeft);
    var dateRight = (0, $2XKMM.default)(dirtyDateRight);
    var sign = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $11VSy.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $1eff655f63a9bbd9$export$2e2bcd8739ae039)((0, $2XKMM.default)(dirtyDateLeft)) && difference === 1 && (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



var $2XKMM = parcelRequire("2XKMM");

var $fnuNu = parcelRequire("fnuNu");
function $c03b34c4f5393ff7$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $fnuNu.default)(2, arguments);
    return (0, $2XKMM.default)(dateLeft).getTime() - (0, $2XKMM.default)(dateRight).getTime();
}



var $fnuNu = parcelRequire("fnuNu");
var $40cb9277785070a4$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $40cb9277785070a4$var$defaultRoundingMethod = "trunc";
function $40cb9277785070a4$export$b6474a47258c1211(method) {
    return method ? $40cb9277785070a4$var$roundingMap[method] : $40cb9277785070a4$var$roundingMap[$40cb9277785070a4$var$defaultRoundingMethod];
}


function $cf34d7234eab092f$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $fnuNu.default)(2, arguments);
    var diff = (0, $c03b34c4f5393ff7$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $40cb9277785070a4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}



var $1vnJS = parcelRequire("1vnJS");

var $2XKMM = parcelRequire("2XKMM");

var $gXiwJ = parcelRequire("gXiwJ");
function $2af75fecfbb4da0a$export$2e2bcd8739ae039(object) {
    return (0, $gXiwJ.default)({}, object);
}



var $gXiwJ = parcelRequire("gXiwJ");

var $4xr1p = parcelRequire("4xr1p");

var $fnuNu = parcelRequire("fnuNu");
var $671507671fa5a6e8$var$MINUTES_IN_DAY = 1440;
var $671507671fa5a6e8$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $671507671fa5a6e8$var$MINUTES_IN_MONTH = 43200;
var $671507671fa5a6e8$var$MINUTES_IN_TWO_MONTHS = 86400;
function $671507671fa5a6e8$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $fnuNu.default)(2, arguments);
    var defaultOptions = (0, $g2dw1.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $1vnJS.default);
    if (!locale.formatDistance) throw new RangeError("locale must contain formatDistance property");
    var comparison = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $gXiwJ.default)((0, $2af75fecfbb4da0a$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $2XKMM.default)(dirtyBaseDate);
        dateRight = (0, $2XKMM.default)(dirtyDate);
    } else {
        dateLeft = (0, $2XKMM.default)(dirtyDate);
        dateRight = (0, $2XKMM.default)(dirtyBaseDate);
    }
    var seconds = (0, $cf34d7234eab092f$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $4xr1p.default)(dateRight) - (0, $4xr1p.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_MONTH);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $f26794150f1b1a6c$export$2e2bcd8739ae039)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_MONTH);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}



var $fnuNu = parcelRequire("fnuNu");
function $08c0c798d1b2bf8a$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $fnuNu.default)(1, arguments);
    return (0, $671507671fa5a6e8$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}


const $4db8d89c1fc2bd96$var$InfoIcon = ()=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M12 16V12",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M12 8H12.01",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const $4db8d89c1fc2bd96$var$TitleSection = ({ name: name, description: description, lastEdited: lastEdited, isGrid: isGrid, interval: interval = "days", blockchain: blockchain })=>{
    const formatLastEdited = (date)=>{
        return (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(new Date(date), {
            addSuffix: true
        });
    };
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    const generateLink = (blockchain, tableName, interval)=>{
        return `/Explore/Tables?blockchain=${capitalizeFirstLetter(blockchain)}&name=${encodeURIComponent(tableName)}&interval=${interval}`;
    };
    if (isGrid) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "mb-6 flex items-center gap-1 relative justify-between",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "flex items-center gap-1 w-full",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "w-1 bg-primary rounded-full absolute left-0",
                    style: {
                        height: "75%",
                        top: "25%"
                    }
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "flex items-center gap-2 pl-8 w-full truncate",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                        className: "text-xl font-bold truncate py-1",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                            className: "py-1",
                            href: generateLink(blockchain, name, interval),
                            children: name
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "mb-6 flex items-center justify-between",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center relative",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "w-1 bg-primary rounded-full absolute left-0",
                        style: {
                            height: "75%",
                            top: "25%"
                        }
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("h1", {
                        className: "text-2xl font-bold pl-8 flex items-end",
                        children: [
                            name,
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "hidden xl:inline-flex items-center ml-2 mb-1",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $779b7efe4205752d$export$57a077cc9fbe653e), {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $779b7efe4205752d$export$ef9f7fd8e4ba882f), {
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)($4db8d89c1fc2bd96$var$InfoIcon, {})
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $779b7efe4205752d$export$aa4724a5938c586), {
                                            className: "w-80 p-2 bg-white rounded-md shadow-lg border border-gray-200",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-sm text-gray-900",
                                                children: description
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            lastEdited && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $779b7efe4205752d$export$57a077cc9fbe653e), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $779b7efe4205752d$export$ef9f7fd8e4ba882f), {
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "text-sm text-gray-600 hover:underline cursor-pointer",
                                children: [
                                    "Last updated: ",
                                    formatLastEdited(lastEdited)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $779b7efe4205752d$export$aa4724a5938c586), {
                            className: "w-60 p-2 bg-white rounded-md shadow-lg border border-gray-200",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "text-sm text-gray-900",
                                children: new Date(lastEdited).toLocaleString()
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $4db8d89c1fc2bd96$export$2e2bcd8739ae039 = $4db8d89c1fc2bd96$var$TitleSection;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

function $067d6b053d54e6b5$export$8f31e4c4a37b8e9c({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("animate-pulse rounded-md bg-primary/10", className),
        ...props
    });
}



const $963a87870e110516$var$TableSkeleton = ({ columns: columns, rows: rows, isGrid: isGrid })=>{
    if (!columns || columns.length === 0) return null; // Return null if columns array is not available or empty
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f23148f8ed856136$export$54ec01a60f47d33d), {
            className: "border rounded-md",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$f850895b287ef28e), {
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                        children: columns.map((column, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$2f4a7be4f0dcc2), {
                                className: "text-xs font-semibold px-2",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: `${isGrid ? "truncate" : ""}`,
                                            title: column.header,
                                            children: isGrid && column.header.length > 10 ? `${column.header.slice(0, 10)}...` : column.header
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $067d6b053d54e6b5$export$8f31e4c4a37b8e9c), {
                                            className: "h-4 w-6"
                                        })
                                    ]
                                })
                            }, index))
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$76ccd210b9029917), {
                    children: [
                        ...Array(rows)
                    ].map((_, rowIndex)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$b05581f4e764e162), {
                            children: columns.map((column, colIndex)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23148f8ed856136$export$1e4baea7053fc0e3), {
                                    className: "text-xs px-4 h-14",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $067d6b053d54e6b5$export$8f31e4c4a37b8e9c), {
                                        className: "h-4 w-full"
                                    })
                                }, colIndex))
                        }, rowIndex))
                })
            ]
        })
    });
};
var $963a87870e110516$export$2e2bcd8739ae039 = $963a87870e110516$var$TableSkeleton;


// LoginPrompt.js

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

const $9c3489f4a78e5c9f$var$LoginPrompt = ()=>{
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "absolute text-black top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 backdrop-blur-sm p-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                className: "text-5xl mb-4",
                children: "Login to access!"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    className: "bg-surfaceVariant border border-primaryContainer shadow-md rounded-lg hover:bg-primary hover:text-white p-4 text-3xl font-semibold w-full",
                    onClick: ()=>{
                        navigate("/signin");
                    },
                    children: "Login"
                })
            })
        ]
    });
};
var $9c3489f4a78e5c9f$export$2e2bcd8739ae039 = $9c3489f4a78e5c9f$var$LoginPrompt;


/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6330a60b209bd454$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Clipboard", [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ]
]);



const $17115b10ff2686a9$var$TableView = ({ blockchain: blockchain, selectedTable: selectedTable, onGranularityChange: onGranularityChange, onFilterChange: onFilterChange, filters: filters, isLoggedIn: isLoggedIn, isGrid: isGrid = false })=>{
    const [interval, setInterval] = (0, $exYeM.useState)(selectedTable?.interval || "days");
    (0, $exYeM.useEffect)(()=>{
        setInterval(selectedTable?.interval || "days");
    }, [
        selectedTable
    ]);
    const { data: data, isLoading: isLoading, isError: isError, error: error } = (0, $5ccab20bb3ed28cc$export$98b14d297b92183b)(blockchain, {
        name: selectedTable?.name,
        interval: interval
    }, selectedTable?.compare, filters);
    const handleFilterChange = (selectedFilters)=>{
        onFilterChange(selectedFilters);
    };
    const handleGranularityChange = (granularity)=>{
        setInterval(granularity);
        if (typeof onGranularityChange === "function") onGranularityChange(granularity);
    };
    const filteredData = isGrid ? data?.graphData?.map(({ timestamp: timestamp, token_holding: token_holding, avg_buy_price: avg_buy_price, avg_buy_price_weth: avg_buy_price_weth, ...rest })=>rest) : data?.graphData;
    if (isError) {
        if (error.response?.status != 401) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            children: [
                "Error loading table data: ",
                error.message
            ]
        });
    }
    const lastEdited = data?.lastEdited;
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: `flex flex-col pt-2 ${isGrid ? "h-[1000px]" : ""}`,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
            className: `flex flex-col ${isGrid ? "h-full" : ""}`,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4db8d89c1fc2bd96$export$2e2bcd8739ae039), {
                    name: selectedTable?.name,
                    description: selectedTable?.description,
                    lastEdited: lastEdited,
                    isGrid: isGrid,
                    blockchain: blockchain,
                    interval: interval
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $598ede7617f7fc7a$export$2e2bcd8739ae039), {
                    selectedTable: selectedTable,
                    onFilterChange: handleFilterChange,
                    onGranularityChange: handleGranularityChange,
                    queryData: data,
                    isGrid: isGrid
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: `relative ${isGrid ? "flex-grow overflow-hidden" : ""}`,
                    children: [
                        isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $963a87870e110516$export$2e2bcd8739ae039), {
                            columns: selectedTable?.columns,
                            rows: isGrid ? 10 : 15,
                            isGrid: isGrid
                        }) : filteredData ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: isGrid ? "h-full overflow-auto" : "",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)($17115b10ff2686a9$var$DataTableWithRankComparison, {
                                data: filteredData,
                                comparisonData: data?.comparisonData,
                                pageSize: isGrid ? 10 : 15
                            })
                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $963a87870e110516$export$2e2bcd8739ae039), {
                            columns: selectedTable?.columns,
                            rows: 15,
                            isGrid: isGrid
                        }),
                        !isLoggedIn && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "absolute inset-0 bg-white opacity-75 blur-sm"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9c3489f4a78e5c9f$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: `mt-2 ${isGrid ? "text-sm" : ""}`,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $47f65e8363a2321a$export$2e2bcd8739ae039), {
                        description: selectedTable?.description || "",
                        sources: selectedTable?.sources || [],
                        dataSource: selectedTable?.dataSource || "",
                        category: selectedTable?.category || ""
                    })
                })
            ]
        })
    });
};
const $17115b10ff2686a9$var$RankOverlay = ({ rank: rank, rankChange: rankChange })=>{
    const isNewEntry = rankChange === null || isNaN(rankChange);
    const changeColor = rankChange > 0 ? "text-green-500" : rankChange < 0 ? "text-red-500" : "text-gray-500";
    const arrow = rankChange > 0 ? "\u2191" : rankChange < 0 ? "\u2193" : "";
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "absolute inset-0 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "flex flex-col items-center 2xl:ml-14 ml-16",
            children: isNewEntry ? /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "text-xs text-primary",
                children: "New!"
            }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex items-center",
                children: rankChange !== 0 ? /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            className: `mr-1 text-lg ${changeColor}`,
                            children: arrow
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            className: `text-xs md:text-sm ${changeColor}`,
                            children: Math.abs(rankChange)
                        })
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: "text-sm text-gray-500",
                    children: "-"
                })
            })
        })
    });
};
const $17115b10ff2686a9$var$DataTableWithRankComparison = ({ data: data, comparisonData: comparisonData, pageSize: pageSize })=>{
    const { successV2: successV2 } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const capitalizeFirstLetter = (str)=>{
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    const copyToClipboard = (text)=>{
        navigator.clipboard.writeText(text).then(()=>{
            successV2({
                title: "Address copied",
                description: "The address has been copied to your clipboard."
            });
        });
    };
    const generateColumnsWithRankComparison = (data, comparisonData)=>{
        if (!data || data.length === 0) return [];
        const columns = Object.keys(data[0]).map((key)=>({
                accessorKey: key,
                header: key.split("_").map(capitalizeFirstLetter).join(" "),
                width: key.toLowerCase().includes("rank") ? 100 : undefined,
                cell: (info)=>{
                    const value = info.getValue();
                    const holder = info.row.original.holder_address;
                    const comparisonItem = comparisonData ? comparisonData.find((item)=>item.holder === holder) : null;
                    const rankChange = comparisonItem ? comparisonItem["rank_change"] : null;
                    const addressKeys = [
                        "token_address",
                        "holder_address",
                        "addr",
                        "address",
                        "Holder",
                        "Holder Address"
                    ];
                    if (addressKeys.includes(key.toLowerCase()) && typeof value === "string") return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $779b7efe4205752d$export$57a077cc9fbe653e), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $779b7efe4205752d$export$ef9f7fd8e4ba882f), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "cursor-pointer",
                                    onClick: ()=>copyToClipboard(value),
                                    children: `${value.slice(0, 5)}...${value.slice(-5)}`
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $779b7efe4205752d$export$aa4724a5938c586), {
                                className: "bg-white p-2 rounded-md shadow-lg border border-gray-200 w-auto",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: value
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6330a60b209bd454$export$2e2bcd8739ae039), {
                                            className: "ml-2 cursor-pointer",
                                            size: 16,
                                            onClick: ()=>copyToClipboard(value)
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                    if (key.toLowerCase().includes("timestamp")) return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "text-sm text-gray-900",
                        children: value
                    });
                    const changeValue = comparisonItem ? comparisonItem[`${key}_change`] : null;
                    const formattedChangeValue = changeValue !== undefined && changeValue !== null && typeof changeValue === "number" ? `${Math.abs(changeValue).toFixed(2)}%` : "";
                    let changeColor = "text-gray-500";
                    let textColor = "text-gray-900";
                    if (changeValue !== undefined && changeValue !== null && typeof changeValue === "number") {
                        if (changeValue > 0) {
                            changeColor = "text-green-500";
                            textColor = "text-green-500";
                        } else if (changeValue < 0) {
                            changeColor = "text-red-500";
                            textColor = "text-red-500";
                        }
                    }
                    if (key.toLowerCase().includes("rank")) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "text-lg",
                                children: value
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)($17115b10ff2686a9$var$RankOverlay, {
                                rank: value,
                                rankChange: rankChange
                            })
                        ]
                    });
                    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-col items-start",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: `text-sm ${textColor}`,
                                children: value
                            }),
                            formattedChangeValue && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: `text-xs ${changeColor}`,
                                children: formattedChangeValue
                            })
                        ]
                    });
                }
            }));
        const rankColumnIndex = columns.findIndex((col)=>col.accessorKey.toLowerCase().includes("rank"));
        if (rankColumnIndex !== -1) {
            const rankColumn = columns.splice(rankColumnIndex, 1)[0];
            columns.unshift(rankColumn);
        }
        return columns;
    };
    const columns = generateColumnsWithRankComparison(data, comparisonData);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $06f444c49b9780e9$export$df30df7ec97b32b5), {
        data: data,
        columns: columns,
        pageSize: pageSize,
        roundToDecimal: 4,
        className: "table-auto w-full",
        style: {
            width: "100%",
            tableLayout: "auto",
            whiteSpace: "nowrap"
        }
    });
};
var $17115b10ff2686a9$export$2e2bcd8739ae039 = $17115b10ff2686a9$var$TableView;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

const $1fcff15e42a0833f$var$TableGrid = ({ blockchain: blockchain, isLoggedIn: isLoggedIn, tableStores: tableStores, onGranularityChange: onGranularityChange, onFilterChange: onFilterChange })=>{
    const [selectedTables, setSelectedTables] = (0, $exYeM.useState)([]);
    (0, $exYeM.useEffect)(()=>{
        if (tableStores) {
            const specificTables = getSpecificTables(tableStores, blockchain);
            setSelectedTables(specificTables);
        }
    }, [
        tableStores,
        blockchain
    ]);
    const getSpecificTables = (tables, blockchain)=>{
        const ethTables = [
            "Top Unrealized Profit",
            "Top Gas Consumers",
            "Top OpenSea NFT Sales Volume",
            "Shia Holders"
        ];
        const btcTables = [
            "Top Inflows",
            "Top Outflows",
            "Top Bitcoin Transaction Counts by Address",
            "Top Bitcoin Block Miners"
        ];
        let desiredTables;
        if (blockchain === "ethereum") desiredTables = ethTables;
        else if (blockchain === "bitcoin") desiredTables = btcTables;
        else {
            console.warn("Unknown blockchain:", blockchain);
            return [];
        }
        const filteredTables = tables.filter((table)=>desiredTables.includes(table.name));
        return filteredTables;
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "grid grid-cols-1 lg:grid-cols-2 gap-4",
        children: selectedTables.map((table)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex flex-col h-[1000px]",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $17115b10ff2686a9$export$2e2bcd8739ae039), {
                    selectedTable: table,
                    blockchain: blockchain,
                    onGranularityChange: onGranularityChange,
                    onFilterChange: onFilterChange,
                    isLoggedIn: isLoggedIn,
                    isGrid: true
                })
            }, table.name))
    });
};
var $1fcff15e42a0833f$export$2e2bcd8739ae039 = $1fcff15e42a0833f$var$TableGrid;


//hooks

var $exYeM = parcelRequire("exYeM");



// GetAllTableStores.js


function $214130b0ccdce49b$export$1a3345904baeb6f2() {
    return (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "allTableStores"
        ],
        queryFn: async ()=>{
            const blockchains = [
                "ethereum",
                "bitcoin"
            ]; // Add all your blockchains here
            const promises = blockchains.map((blockchain)=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/tableStores/${blockchain}`).then((response)=>({
                        blockchain: blockchain,
                        data: response.data.tableStores
                    })));
            const results = await Promise.all(promises);
            return results.reduce((acc, result)=>{
                acc[result.blockchain] = result.data;
                return acc;
            }, {});
        }
    });
}


const $594c43af5603e55d$export$2695b98d4c569528 = ()=>{
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const blockchain = searchParams.get("blockchain") || "Ethereum";
    const { data: tableStoresData, isLoading: tableStoresLoading, isError: tableStoresError, error: tableStoresErrorDetails } = (0, $214130b0ccdce49b$export$1a3345904baeb6f2)();
    const { data: blockchainData, isLoading: blockchainLoading, isError: blockchainError, error: blockchainErrorDetails } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "blockchains"
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/blockchains")
    });
    const [currentTableStores, setCurrentTableStores] = (0, $exYeM.useState)([]);
    const [blockchainErrorState, setBlockchainErrorState] = (0, $exYeM.useState)(null);
    (0, $exYeM.useEffect)(()=>{
        if (tableStoresData && tableStoresData[blockchain.toLowerCase()]) setCurrentTableStores(tableStoresData[blockchain.toLowerCase()]);
    }, [
        tableStoresData,
        blockchain
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (blockchainError) setBlockchainErrorState(blockchainErrorDetails);
    }, [
        blockchainError
    ]);
    return {
        blockchain: blockchain,
        searchParams: searchParams,
        setSearchParams: setSearchParams,
        tableStoresLoading: tableStoresLoading,
        tableStoresError: tableStoresError,
        tableStoresErrorDetails: tableStoresErrorDetails,
        blockchainLoading: blockchainLoading,
        blockchainData: blockchainData,
        blockchainErrorState: blockchainErrorState,
        currentTableStores: currentTableStores,
        setCurrentTableStores: setCurrentTableStores
    };
};


//hooks

var $exYeM = parcelRequire("exYeM");

const $36668da87eecb6a1$export$53f1df386d7d7c73 = (currentTableStores, blockchain)=>{
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [selectedTable, setSelectedTable] = (0, $exYeM.useState)(null);
    (0, $exYeM.useEffect)(()=>{
        const tableName = searchParams.get("name");
        const interval = searchParams.get("interval") || "days";
        const selectedBlockchain = searchParams.get("blockchain").toLowerCase();
        if (tableName && currentTableStores.length > 0 && selectedBlockchain.toLowerCase() == blockchain.toLowerCase()) {
            const table = currentTableStores.find((table)=>table.name === tableName);
            if (table) setSelectedTable({
                ...table,
                interval: interval
            });
            else setSelectedTable(null);
        }
    }, [
        currentTableStores,
        searchParams,
        blockchain
    ]);
    return {
        selectedTable: selectedTable,
        setSelectedTable: setSelectedTable
    };
};


// DataBar.js

var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
function $4dd5b1713aee0c53$var$ChevronUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M14.77 12.79a.75.75 0 01-1.06-.02L10 8.832 6.29 12.77a.75.75 0 11-1.08-1.04l4.25-4.5a.75.75 0 011.08 0l4.25 4.5a.75.75 0 01-.02 1.06z",
        clipRule: "evenodd"
    }));
}
const $4dd5b1713aee0c53$var$ForwardRef = $exYeM.forwardRef($4dd5b1713aee0c53$var$ChevronUpIcon);
var $4dd5b1713aee0c53$export$2e2bcd8739ae039 = $4dd5b1713aee0c53$var$ForwardRef;






function $bd7c7c46fd1d4916$var$DataBar({ blockchain: blockchain, blockchainData: blockchainData, onBlockchainChange: onBlockchainChange }) {
    const { isLoading: tickerLoading, isError: tickerError, data: tickerData } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "ticker-" + blockchain
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/ticker/" + blockchain.charAt(0).toUpperCase() + blockchain.slice(1))
    });
    const colour = (first, last)=>{
        if (first > last) return false;
        return true;
    };
    const isPrice = (string)=>{
        if (string.includes("Price")) return true;
        return false;
    };
    if (tickerLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "h-16 animate-pulse w-full justify-center flex",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports))),
            alt: "...",
            className: "h-6 pb-1 md:h-14 md:w-14 self-center"
        })
    });
    if (tickerError) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "h-16 w-full justify-center flex",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
            alt: "...",
            className: "h-14 w-14 self-center text-red-500"
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "md:h-16 bg-surface w-full flex flex-col md:flex-row md:divide-x-2 divide-secondary font-roboto border-b border-secondar text-roboto",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "md:w-[250px] px-[0.9rem] grid grid-flow-col place-items-center md:justify-between md:py-0 py-2 ",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d3db549d03db2e76$export$2e2bcd8739ae039), {
                    blockchainData: blockchainData,
                    onBlockchainChange: onBlockchainChange
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-full overflow-auto",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "px-4 grid grid-flow-col justify-start place-items-center max-w-full md:py-0 pb-2 h-full",
                    children: tickerData.data.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex flex-row h-4/5 gap-2 border-r-2 px-4 border-secondary place-items-center text-sm xl:text-lg",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "font-roboto text-center whitespace-nowrap overflow-visible text-gray-700",
                                    children: data.name
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "font-monda text-center flex text-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            className: `${isPrice(data.name) ? "block" : "hidden"} `,
                                            children: "$"
                                        }),
                                        data.data[0][1].toLocaleString("en-US", {
                                            maximumFractionDigits: 2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4dd5b1713aee0c53$export$2e2bcd8739ae039), {
                                        className: `${colour(data.data[1][1], data.data[0][1]) ? "text-green-500" : "text-red-500 rotate-180"} h-4 w-4 md:h-6 md:w-6`
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: `${colour(data.data[1][1], data.data[0][1]) ? "text-green-500" : "text-red-500"} font-monda font-bold align-baseline md:text-sm`,
                                    children: [
                                        ((data.data[0][1] - data.data[1][1]) / data.data[0][1] * 100).toFixed(1),
                                        "%"
                                    ]
                                })
                            ]
                        }, data.name))
                })
            })
        ]
    });
}
var $bd7c7c46fd1d4916$export$2e2bcd8739ae039 = $bd7c7c46fd1d4916$var$DataBar;




function $9d693b772bdf613a$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
const $9d693b772bdf613a$var$TablePage = ()=>{
    const { blockchain: blockchain, searchParams: searchParams, setSearchParams: setSearchParams, tableStoresLoading: tableStoresLoading, tableStoresError: tableStoresError, tableStoresErrorDetails: tableStoresErrorDetails, blockchainLoading: blockchainLoading, blockchainData: blockchainData, blockchainErrorState: blockchainErrorState, currentTableStores: currentTableStores, setCurrentTableStores: setCurrentTableStores } = (0, $594c43af5603e55d$export$2695b98d4c569528)();
    const { selectedTable: selectedTable, setSelectedTable: setSelectedTable } = (0, $36668da87eecb6a1$export$53f1df386d7d7c73)(currentTableStores, blockchain);
    const [isLoggedIn, setIsLoggedIn] = (0, $exYeM.useState)(false);
    const [filters, setFilters] = (0, $exYeM.useState)([]);
    (0, $exYeM.useEffect)(()=>{
        const token = $9d693b772bdf613a$var$getToken();
        setIsLoggedIn(token !== "");
    }, []);
    (0, $exYeM.useEffect)(()=>{
        if (!searchParams.get("blockchain")) setSearchParams({
            blockchain: "Ethereum"
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    const handleGranularityChange = (granularity)=>{
        setSearchParams((prevParams)=>({
                ...prevParams,
                blockchain: blockchain,
                name: selectedTable.name,
                interval: granularity
            }));
    };
    const handleFilterChange = (newFilters)=>{
        setFilters(newFilters);
    };
    if (blockchainErrorState) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        children: [
            "Error loading blockchains: ",
            blockchainErrorState.message
        ]
    });
    if (tableStoresError) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        children: [
            "Error loading table stores: ",
            tableStoresErrorDetails.message
        ]
    });
    if (blockchainLoading || tableStoresLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex items-center justify-center min-h-screen",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "animate-pulse flex items-center justify-center",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0a8af33ef04486b7$exports))),
                alt: "Company Logo",
                className: "max-h-16 md:max-h-40 pl-14"
            })
        })
    });
    const tableName = searchParams.get("name");
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex flex-col h-full",
        children: tableName ? selectedTable ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $17115b10ff2686a9$export$2e2bcd8739ae039), {
            selectedTable: selectedTable,
            blockchain: blockchain.toLowerCase(),
            onGranularityChange: handleGranularityChange,
            onFilterChange: handleFilterChange,
            filters: filters,
            isLoggedIn: isLoggedIn
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a95124cff6afe936$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1fcff15e42a0833f$export$2e2bcd8739ae039), {
            blockchain: blockchain.toLowerCase(),
            isLoggedIn: isLoggedIn,
            tableStores: currentTableStores,
            onGranularityChange: handleGranularityChange,
            onFilterChange: handleFilterChange
        })
    });
};
var $9d693b772bdf613a$export$2e2bcd8739ae039 = $9d693b772bdf613a$var$TablePage;


// created by James Launder
// This is the redirect page that is shown from a stripe successful payment

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
function $d440cdbedabd931c$var$CheckBadgeIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
    }));
}
const $d440cdbedabd931c$var$ForwardRef = $exYeM.forwardRef($d440cdbedabd931c$var$CheckBadgeIcon);
var $d440cdbedabd931c$export$2e2bcd8739ae039 = $d440cdbedabd931c$var$ForwardRef;







function $06517bdc959aed1d$var$CheckoutSuccess() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const { isLoading: isLoading, isError: isError, data: data } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "stripe-success"
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/stripe/checkoutSucess/" + searchParams.get("session_id"), {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }),
        onSuccess: (res)=>{
            localStorage.removeItem("user");
            (0, $63bc3418712e965e$export$ad0e3c8bd06d67b1)(res.data.user);
        }
    });
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    if (isLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "bg-surface h-[75vh] w-full grid place-items-center p-4 font-roboto ",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "bg-white p-4 px-4 flex flex-col items-center rounded-lg h-fit animate-pulse shadow-lg",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d440cdbedabd931c$export$2e2bcd8739ae039), {
                    className: "h-24 w-24 my-4 text-white"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "text-4xl font-semibold pt-1 px-4 pb-12 text-white",
                    children: "Payment Successful"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "text-white",
                    children: "g"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "text-white pb-4",
                    children: "Check out some features by clicking below"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "p-4 flex gap-4 pb-4",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            className: "px-3 py-2 font-roboto font-light text-primaryContainer bg-primaryContainer rounded-lg hover:bg-primary hover:text-white",
                            children: "Explore"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            className: "px-3 py-2 font-roboto font-light text-primaryContainer bg-primaryContainer rounded-lg hover:bg-primary hover:text-white",
                            children: "Explore"
                        })
                    ]
                })
            ]
        })
    });
    if (isError) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9da9c1ba51a50cc6$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "bg-surface h-[75vh] w-full grid place-items-center p-4 font-roboto",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "bg-white p-4 px-4 flex flex-col items-center rounded-lg h-fit shadow-md",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d440cdbedabd931c$export$2e2bcd8739ae039), {
                    className: "h-24 w-24 my-4 text-green-500"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "text-4xl font-semibold pt-1 px-4 pb-12 text-gray-800",
                    children: "Payment Successful"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "text-gray-500",
                    children: [
                        "Thanks ",
                        data.data.customer.email,
                        " for your subscription!"
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "text-gray-500 pb-4",
                    children: "Check out some features by clicking below"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "p-4 flex gap-4 pb-4",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            className: "px-3 py-2 font-roboto font-light bg-primaryContainer rounded-lg hover:bg-primary hover:text-white",
                            onClick: ()=>{
                                navigate("/Explore?blockchain=Ethereum");
                            },
                            children: "Explore"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            className: "px-3 py-2 font-roboto font-light bg-primaryContainer rounded-lg hover:bg-primary hover:text-white",
                            onClick: ()=>{
                                navigate("/Footprint");
                            },
                            children: "Footprint"
                        })
                    ]
                })
            ]
        })
    });
}
var $06517bdc959aed1d$export$2e2bcd8739ae039 = $06517bdc959aed1d$var$CheckoutSuccess;



var $aSiaI = parcelRequire("aSiaI");

function $d245be1f5f28d3a6$export$2e2bcd8739ae039() {
    const master = new URL($fa9fe3ddad653fdc$exports).toString();
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-full h-[70vh] font-roboto",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("iframe", {
            src: master,
            title: "MasterAgreement",
            width: "100%",
            height: "100%"
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");

function $f0980981023b13d1$export$2e2bcd8739ae039() {
    const privacy = new URL($221923bd4e9de300$exports).toString();
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-full h-[70vh] font-roboto",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("iframe", {
            src: privacy,
            title: "PrivacyPolicy",
            width: "100%",
            height: "100%"
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");

function $9a48167f337b77c5$export$2e2bcd8739ae039() {
    const terms = new URL($be75a9171eeadc45$exports).toString();
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-full h-[70vh] font-roboto",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("iframe", {
            src: terms,
            title: "TermsAndConditions",
            width: "100%",
            height: "100%"
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");



var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




function $f34f8daddacf37a5$export$2e2bcd8739ae039({ open: open, setOpen: setOpen, id: id }) {
    const queryClient = (0, $1773e073a683367a$export$22e77b9572c4fded)();
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const deleteNotification = (0, $69148cf0716ffd57$export$609860bf8b0084c)({
        mutationFn: (id)=>{
            return (0, $ca6473885cd32228$export$2e2bcd8739ae039).delete("/notification/" + id, {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            });
        },
        mutationKey: [
            "removeAlert-" + id
        ],
        onMutate: async (id)=>{
            await queryClient.cancelQueries({
                queryKey: [
                    "allNotifications"
                ]
            });
            const prev = queryClient.getQueryData([
                "allNotifications"
            ]);
            queryClient.setQueryData([
                "allNotifications"
            ], (old)=>{
                let update = old.data.filter((item)=>item._id != id);
                [
                    ...update
                ];
            });
            setOpen(false);
            return {
                prev: prev
            };
        },
        onError: (err, id, context)=>{
            queryClient.setQueryData([
                "allNotifications"
            ], context.prev);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "allNotifications"
                ]
            });
        }
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $exYeM.Fragment),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153), {
            as: "div",
            className: "relative z-10",
            onClose: setOpen,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                    as: (0, $exYeM.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "fixed inset-0 z-10 w-screen overflow-y-auto",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4).Child, {
                            as: (0, $exYeM.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "absolute right-0 top-0 hidden pr-4 pt-4 sm:block",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "button",
                                            className: "rounded-md bg-white text-gray-400 hover:text-gray-500",
                                            onClick: ()=>setOpen(false),
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fe24332445e161c9$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "sm:flex sm:items-start",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $02c3937cc0ece46a$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-red-500",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8822e71bc1e566e5$export$3ddf2d174ce01153).Title, {
                                                        as: "h3",
                                                        className: "text-base font-semibold leading-6 text-gray-900",
                                                        children: "Delete alert"
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                            className: "text-sm text-gray-500",
                                                            children: "Are you sure you want to delete this alert?"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: "inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 sm:ml-3 sm:w-auto",
                                                onClick: ()=>deleteNotification.mutate(id),
                                                children: "Delete"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                className: "mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto",
                                                onClick: ()=>setOpen(false),
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}




function $66ecec372a9a42a7$export$2e2bcd8739ae039({ name: name, chart: chart, blockchain: blockchain, value: value, condition: condition, resolution: resolution, source: source, freq: freq, id: id }) {
    const [openNotification, setOpenNotification] = (0, $exYeM.useState)(false);
    const [openDelete, setOpenDelete] = (0, $exYeM.useState)(false);
    const { isLoading: isLoading, isError: isError, data: data } = (0, $e001a3913940767b$export$2e2bcd8739ae039)(blockchain, resolution, chart, source);
    function handleCurrentValue() {
        if (blockchain === null || chart === null || // selectedChart?.name === undefined ||
        resolution === null || data?.data?.graphData === undefined) return "Waiting...";
        if (isError) return "Error";
        if (isLoading) return "Loading...";
        return data?.data?.graphData[0]?.data[1].toLocaleString("en-US", {
            maximumFractionDigits: 2
        }) ?? "No data";
    // return 1;
    }
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full flex flex-col gap-2 p-2 border border-500 shadow-md rounded-lg",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "w-full flex justify-between border-b py-2 text-gray-500 font-semibold leading-6 md:text-lg text-sm px-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex-grow grid grid-flow-col divide-x items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-center md:block hidden",
                                children: name || "No Name"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                className: "text-center underline hover:text-primary",
                                to: "/Explore?blockchain=" + blockchain,
                                children: blockchain
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d), {
                                className: "text-center underline hover:text-primary",
                                to: "/Explore?blockchain=" + blockchain + "&name=" + chart + "&resolution=" + resolution + "&sma=None&ema=None&scale=Linear&type=Line",
                                children: chart
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "border-l px-2 md:px-6 grid grid-flow-col gap-4 md:gap-6",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                className: "rounded-lg border p-2 bg-surfaceVariant hover:bg-primary group",
                                onClick: ()=>setOpenNotification(true),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11abbe69da1e2b5b$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 md:h-6 md:w-6 text-onSurfaceVariant group-hover:text-white"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                className: "rounded-lg border p-2 bg-surfaceVariant hover:bg-primary group",
                                onClick: ()=>{
                                    setOpenDelete(true);
                                // deleteNotification.mutate(id);
                                },
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $65f63127b2f025f8$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 md:h-6 md:w-6 text-onSurfaceVariant group-hover:text-white"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "w-full border-b py-6 flex justify-center items-center gap-4 divide-x",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex gap-4 bg-primary/25 items-center justify-center rounded-lg text-3xl md:text-5xl p-4 text-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: value.toLocaleString("en-US", {
                                    maximumFractionDigits: 2
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "italic",
                                children: condition
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "px-4 text-xl md:text-3xl h-full py-2 text-gray-500 flex flex-col items-center gap-2 text-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-gray-400 font-normal",
                                children: "Current Value"
                            }),
                            handleCurrentValue()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "w-full grid grid-flow-col divide-x py-2 text-gray-500 font-semibold leading-6 md:text-lg text-md",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "justify-center flex flex-col items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-gray-400 font-normal",
                                children: "Resolution"
                            }),
                            resolution
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "justify-center flex flex-col items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-gray-400 font-normal",
                                children: "Source"
                            }),
                            source
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "justify-center flex flex-col items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-gray-400 font-normal",
                                children: "Frequency"
                            }),
                            freq
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7f0198e378ac9d56$export$2e2bcd8739ae039), {
                open: openNotification,
                setOpen: setOpenNotification,
                edit: true,
                blockchain: blockchain,
                chartName: chart,
                resolution: resolution,
                sourceProp: source,
                conditionProp: condition,
                frequencyProp: freq,
                valueProp: value,
                alertNameProp: name,
                id: id
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f34f8daddacf37a5$export$2e2bcd8739ae039), {
                open: openDelete,
                setOpen: setOpenDelete,
                id: id
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");
function $389720338c4e683a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "w-full flex-row justify-between flex my-2 border-b border-gray-600 pb-4 gap-16 animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "p-4 rounded-full bg-gray-300 w-12 h-12"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex-grow px-20 flex flex-col gap-2 bg-gray-300 rounded-lg"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: " items-center justify-end md:flex hidden",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "bg-gray-300 h-full w-16 rounded-lg"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-col gap-6 py-6",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "w-full flex flex-col gap-2 p-2 border border-gray-600 rounded-lg animate-pulse",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full flex justify-between border-b py-2 text-gray-600 font-semibold leading-6 text-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex-grow grid grid-flow-col items-center gap-8",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 md:flex hidden justify-center px-16"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "px-6 md:grid hidden grid-flow-col gap-6",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                className: "rounded-lg border p-2 h-8 w-8 bg-gray-300"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                className: "rounded-lg border p-2 h-8 w-8 bg-gray-300"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full border-b py-6 flex justify-center items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex gap-4 bg-primary/25 items-center justify-center rounded-lg text-4xl p-4 w-1/2 h-16",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "italic"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "border-l px-4 text-3xl py-2 text-gray-600 flex flex-col items-center gap-2 w-1/2 h-16 bg-gray-300 rounded-lg "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full grid grid-flow-col divide-x py-2 text-gray-600 font-semibold leading-6 text-lg gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 md:flex hidden justify-center px-16"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "w-full flex flex-col gap-2 p-2 border border-gray-600 rounded-lg animate-pulse",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full flex justify-between border-b py-2 text-gray-600 font-semibold leading-6 text-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex-grow grid grid-flow-col items-center gap-8",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 md:flex hidden justify-center px-16"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "px-6 md:grid hidden grid-flow-col gap-6",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                className: "rounded-lg border p-2 h-8 w-8 bg-gray-300"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                className: "rounded-lg border p-2 h-8 w-8 bg-gray-300"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full border-b py-6 flex justify-center items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex gap-4 bg-primary/25 items-center justify-center rounded-lg text-4xl p-4 w-1/2 h-16",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "italic"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "border-l px-4 text-3xl py-2 text-gray-600 flex flex-col items-center gap-2 w-1/2 h-16 bg-gray-300 rounded-lg "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full grid grid-flow-col divide-x py-2 text-gray-600 font-semibold leading-6 text-lg gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 md:flex hidden justify-center px-16"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "w-full flex flex-col gap-2 p-2 border border-gray-600 rounded-lg animate-pulse",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full flex justify-between border-b py-2 text-gray-600 font-semibold leading-6 text-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex-grow grid grid-flow-col items-center gap-8",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-center bg-gray-300 rounded-lg h-8 md:flex hidden justify-center px-16"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "px-6 md:grid hidden grid-flow-col gap-6",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                className: "rounded-lg border p-2 h-8 w-8 bg-gray-300"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                className: "rounded-lg border p-2 h-8 w-8 bg-gray-300"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full border-b py-6 flex justify-center items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex gap-4 bg-primary/25 items-center justify-center rounded-lg text-4xl p-4 w-1/2 h-16",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {}),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "italic"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "border-l px-4 text-3xl py-2 text-gray-600 flex flex-col items-center gap-2 w-1/2 h-16 bg-gray-300 rounded-lg "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "w-full grid grid-flow-col divide-x py-2 text-gray-600 font-semibold leading-6 text-lg gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 flex justify-center px-16"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "text-center bg-gray-300 rounded-lg h-8 md:flex hidden justify-center px-16"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
function $b367860d05162ea9$var$BellAlertIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"
    }));
}
const $b367860d05162ea9$var$ForwardRef = $exYeM.forwardRef($b367860d05162ea9$var$BellAlertIcon);
var $b367860d05162ea9$export$2e2bcd8739ae039 = $b367860d05162ea9$var$ForwardRef;


// created by James Launder
// simple ui to fill a bar based on percentage
// also changes colour based on fill

var $aSiaI = parcelRequire("aSiaI");
const $1d682868b00a1f74$var$Bar = ({ value: value, max: max })=>{
    // var newValue;
    function calculateNewValue(value, max) {
        return value / max * 100;
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "h-4 w-full bg-gray-300 rounded-xl",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            style: {
                width: `${calculateNewValue(value, max)}%`
            },
            className: `h-full rounded-xl bg-primary`
        })
    });
};
var $1d682868b00a1f74$export$2e2bcd8739ae039 = $1d682868b00a1f74$var$Bar;



var $exYeM = parcelRequire("exYeM");
function $757822c6446a11ed$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z",
        clipRule: "evenodd"
    }));
}
const $757822c6446a11ed$var$ForwardRef = $exYeM.forwardRef($757822c6446a11ed$var$PlusIcon);
var $757822c6446a11ed$export$2e2bcd8739ae039 = $757822c6446a11ed$var$ForwardRef;




var $exYeM = parcelRequire("exYeM");

function $1a6bfac175c3e72c$export$2e2bcd8739ae039({ currAlerts: currAlerts = 0, totalAlerts: totalAlerts = 0 }) {
    const [openNotification, setOpenNotification] = (0, $exYeM.useState)(false);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full flex-row justify-between flex my-2 border-b border-gray-500 pb-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "p-4 rounded-full bg-surfaceVariant text-center flex justify-center place-items-center",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b367860d05162ea9$export$2e2bcd8739ae039), {
                    className: "md:w-10 md:h-10 h-8 w-8 text-onSurfaceVariant "
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex-grow md:px-20 px-10 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "text-lg md:text-xl font-semibold text-gray-600",
                        children: [
                            currAlerts,
                            "/",
                            totalAlerts,
                            " Alerts"
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1d682868b00a1f74$export$2e2bcd8739ae039), {
                        value: currAlerts,
                        max: totalAlerts
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    className: (0, $fcf061de51445294$export$2e2bcd8739ae039)("bg-surfaceVariant px-4 py-4 rounded-lg text-md md:text-lg flex items-center gap-4 add font-medium", currAlerts >= totalAlerts ? "bg-gray-200 text-gray-500" : "hover:bg-primary group"),
                    disabled: currAlerts >= totalAlerts,
                    onClick: ()=>setOpenNotification(true),
                    children: currAlerts >= totalAlerts ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "group-hover:text-white md:block hidden",
                                children: "Max Alerts!"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "group-hover:text-white md:hidden block",
                                children: "Max!"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $757822c6446a11ed$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 md:h-6 md:w-6 text-onSurfaceVariant group-hover:text-white"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "group-hover:text-white md:block hidden",
                                children: "Add new!"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "group-hover:text-white md:hidden block",
                                children: "Add"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7f0198e378ac9d56$export$2e2bcd8739ae039), {
                open: openNotification,
                setOpen: setOpenNotification,
                optimistic: true
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");

function $4943ec87a551c045$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: " min-h-[50vh] flex flex-col justify-center items-center w-full mx-auto",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center gap-8 py-6",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "rounded-full bg-surfaceVariant p-4",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $02c3937cc0ece46a$export$2e2bcd8739ae039), {
                            className: "w-16 h-16 text-onSurfaceVariant"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "text-5xl leading-6 text-gray-600 ",
                            children: "No Alerts!"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: " text-gray-400 text-2xl",
                children: "Add some new alerts at the top."
            })
        ]
    });
}




function $1cdf39a88ad568b5$export$2e2bcd8739ae039() {
    function getToken() {
        if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
        else return "";
    }
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, data: data, refetch: refetch } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "allNotifications"
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/notification", {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }).catch(function(error) {
                return error.response;
            });
            return data;
        },
        staleTime: 1000
    });
    return {
        isLoading: isLoading,
        isError: isError,
        isFetching: isFetching,
        data: data,
        refetch: refetch
    };
}



function $b1cfdc8690f2943a$export$2e2bcd8739ae039() {
    const { isLoading: isLoading, isError: isError, data: data } = (0, $1cdf39a88ad568b5$export$2e2bcd8739ae039)();
    const { userData: userData } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    if (isError || !data && !isLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "relative min-h-[75vh] max-w-7xl mx-auto py-4 px-8",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9da9c1ba51a50cc6$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "relative min-h-[75vh] max-w-7xl mx-auto py-4 px-8",
        children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $389720338c4e683a$export$2e2bcd8739ae039), {})
        }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: " min-h-[75vh] w-full",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1a6bfac175c3e72c$export$2e2bcd8739ae039), {
                    currAlerts: data?.data?.length,
                    totalAlerts: userData?.alerts
                }),
                data?.data?.length === 0 ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4943ec87a551c045$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "w-full flex flex-col grow gap-6 items-center pt-2",
                    children: data?.data?.map((notification, idx)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $66ecec372a9a42a7$export$2e2bcd8739ae039), {
                            name: notification?.alertName,
                            blockchain: notification.blockchain,
                            chart: notification.chart,
                            value: notification.value,
                            condition: notification.condition,
                            resolution: notification.resolution,
                            source: notification.dataSource,
                            freq: notification.frequency,
                            id: notification._id
                        }, idx))
                })
            ]
        })
    });
}





var $exYeM = parcelRequire("exYeM");

function $f174054c37467980$export$2e2bcd8739ae039() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { validateUser: validateUser } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "min-h-[75vh]",
        children: localStorage.getItem("user") === null ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: " min-h-[50vh] flex flex-col justify-center items-center w-full mx-auto",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex items-center gap-8 py-4",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "rounded-full bg-surfaceVariant p-4",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                                className: "w-16 h-16 text-onSurfaceVariant"
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "text-5xl md:leading-6 text-gray-600 ",
                                children: "Not logged in!"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: " text-gray-400 text-2xl gap-6 flex flex-col items-center",
                    children: [
                        "Login to see your alerts",
                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            className: "bg-surfaceVariant px-4 py-2 rounded-lg text-black hover:bg-primary hover:text-white",
                            onClick: ()=>navigate("/signin"),
                            children: "Login"
                        })
                    ]
                })
            ]
        }) : validateUser.isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $389720338c4e683a$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b1cfdc8690f2943a$export$2e2bcd8739ae039), {})
    });
}



var $aSiaI = parcelRequire("aSiaI");


var $exYeM = parcelRequire("exYeM");
// created by james launder
// contains the dropdown for selecting a blockchain
// also has data for the ticker

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $70738760aff060d1$var$ChartBarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        d: "M15.5 2A1.5 1.5 0 0014 3.5v13a1.5 1.5 0 001.5 1.5h1a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0016.5 2h-1zM9.5 6A1.5 1.5 0 008 7.5v9A1.5 1.5 0 009.5 18h1a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0010.5 6h-1zM3.5 10A1.5 1.5 0 002 11.5v5A1.5 1.5 0 003.5 18h1A1.5 1.5 0 006 16.5v-5A1.5 1.5 0 004.5 10h-1z"
    }));
}
const $70738760aff060d1$var$ForwardRef = $exYeM.forwardRef($70738760aff060d1$var$ChartBarIcon);
var $70738760aff060d1$export$2e2bcd8739ae039 = $70738760aff060d1$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $63addcb26601676e$var$TableCellsIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        fillRule: "evenodd",
        d: "M.99 5.24A2.25 2.25 0 013.25 3h13.5A2.25 2.25 0 0119 5.25l.01 9.5A2.25 2.25 0 0116.76 17H3.26A2.267 2.267 0 011 14.74l-.01-9.5zm8.26 9.52v-.625a.75.75 0 00-.75-.75H3.25a.75.75 0 00-.75.75v.615c0 .414.336.75.75.75h5.373a.75.75 0 00.627-.74zm1.5 0a.75.75 0 00.627.74h5.373a.75.75 0 00.75-.75v-.615a.75.75 0 00-.75-.75H11.5a.75.75 0 00-.75.75v.625zm6.75-3.63v-.625a.75.75 0 00-.75-.75H11.5a.75.75 0 00-.75.75v.625c0 .414.336.75.75.75h5.25a.75.75 0 00.75-.75zm-8.25 0v-.625a.75.75 0 00-.75-.75H3.25a.75.75 0 00-.75.75v.625c0 .414.336.75.75.75H8.5a.75.75 0 00.75-.75zM17.5 7.5v-.625a.75.75 0 00-.75-.75H11.5a.75.75 0 00-.75.75V7.5c0 .414.336.75.75.75h5.25a.75.75 0 00.75-.75zm-8.25 0v-.625a.75.75 0 00-.75-.75H3.25a.75.75 0 00-.75.75V7.5c0 .414.336.75.75.75H8.5a.75.75 0 00.75-.75z",
        clipRule: "evenodd"
    }));
}
const $63addcb26601676e$var$ForwardRef = $exYeM.forwardRef($63addcb26601676e$var$TableCellsIcon);
var $63addcb26601676e$export$2e2bcd8739ae039 = $63addcb26601676e$var$ForwardRef;






var $exYeM = parcelRequire("exYeM");
function $a6f5779ae184a7a8$var$ArrowLeftOnRectangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
    }));
}
const $a6f5779ae184a7a8$var$ForwardRef = $exYeM.forwardRef($a6f5779ae184a7a8$var$ArrowLeftOnRectangleIcon);
var $a6f5779ae184a7a8$export$2e2bcd8739ae039 = $a6f5779ae184a7a8$var$ForwardRef;




function $e199516c8f855348$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $e199516c8f855348$var$NavBar() {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const [selected, setSelected] = (0, $exYeM.useState)();
    const sidebar = (0, $bac91e2a1be69460$export$59dca65daeaf223)((state)=>state.state);
    const setSidebar = (0, $bac91e2a1be69460$export$59dca65daeaf223)((state)=>state.setSidebar);
    // used to change from green to red
    const colour = (first, last)=>{
        if (first > last) return false;
        return true;
    };
    // check if price is in the string
    const isPrice = (string)=>{
        if (string.includes("Price")) return true;
        return false;
    };
    // gets all the blockchains in the database
    const { isLoading: isLoading, isError: isError, data: data } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "blockchains-nav"
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/blockchains")
    });
    // gets all the ticker data for that blockchain
    const { isLoading: tickerLoading, isError: tickerError, data: tickerData } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "ticker-" + searchParams.get("blockchain")
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/ticker/" + searchParams.get("blockchain"))
    });
    (0, $exYeM.useEffect)(()=>{
        if (!isLoading) {
            let obj = data.data.blockchain.find((o)=>o.name === searchParams.get("blockchain"));
            setSelected(obj);
        }
    }, [
        data,
        searchParams.get("blockchain")
    ]);
    const chartTableNav = ()=>{
        const path = location.pathname.split("/");
        return path.includes("Tables");
    };
    if (isLoading || selected === undefined) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-16 bg-surface w-full flex flex-row divide-x-2 divide-secondary font-roboto border-b border-secondar text-roboto",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-[238px] px-1 grid grid-flow-col place-items-center justify-between  ",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "w-[209px] z-10",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "relative",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "relative w-full rounded-lg border border-primary bg-white py-2 pl-3 pr-10 text-left",
                                children: [
                                    " ",
                                    "Loading"
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "px-4 grid grid-flow-col justify-start place-items-center h-full w-full",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-row h-4/5 gap-4 text-lg border-r-2 px-4 border-secondary place-items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: "Price"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda",
                                children: "$100,000"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4dd5b1713aee0c53$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6 text-green-500"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda",
                                children: "24%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "grid grid-flow-col h-4/5 w-full gap-4 text-lg border-r-2 px-4 border-secondary place-items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: "Price"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda",
                                children: "$100,000"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4dd5b1713aee0c53$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6 text-green-500"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda",
                                children: "24%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "grid grid-flow-col h-4/5 w-full gap-4 text-lg border-r-2 px-4 border-secondary place-items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: "Price"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda",
                                children: "$100,000"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4dd5b1713aee0c53$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6 text-green-500"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda",
                                children: "24%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "grid grid-flow-col h-4/5 w-full gap-4 text-lg border-r-2 px-4 border-secondary place-items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: "Price"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda",
                                children: "$100,000"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4dd5b1713aee0c53$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6 text-green-500"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "font-monda",
                                children: "24%"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    if (isError) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: "Error"
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "md:h-16 bg-surface w-full flex flex-col md:flex-row  font-roboto text-roboto",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "md:w-[250px] px-[0.9rem] grid grid-flow-col place-items-center md:justify-between md:py-0 py-2 ",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "md:w-[219px] z-10 relative flex grow w-full",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            onClick: ()=>{
                                setSidebar(!sidebar);
                            // console.log(props.sidebar);
                            },
                            className: "bg-surfaceVariant rounded-xl mr-2 p-2 border-2 group border-primaryContainer hover:bg-primary hover:text-white transition duration-0 md:hidden flex justify-center items-center",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6f5779ae184a7a8$export$2e2bcd8739ae039), {
                                className: `${sidebar ? "transition  duration-75" : "rotate-180 transition duration-75"}h-6 w-6 group-hover:text-white text-onSurfaceVariant`
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659), {
                            value: selected,
                            onChange: setSelected,
                            children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "relative w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Button, {
                                                className: "relative w-full rounded-lg border border-primary bg-white py-2 pl-3 pr-10 text-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                                src: "https://api.wevr.ai/V2/" + selected.icon,
                                                                alt: "",
                                                                className: "h-6 w-6 flex-shrink-0 rounded-full"
                                                            }),
                                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                className: "ml-3 block truncate font-semibold text-lg",
                                                                children: selected.name
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: "absolute inset-y-0 right-0 ml-3 flex items-center pr-2",
                                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dd814d617586c39d$export$2e2bcd8739ae039), {
                                                            className: "h-6 w-6 text-primary",
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e43b19f549669bf9$export$be58926105124dd4), {
                                                show: open,
                                                as: (0, $exYeM.Fragment),
                                                leave: "transition ease-in duration-100",
                                                leaveFrom: "opacity-100",
                                                leaveTo: "opacity-0",
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Options, {
                                                    className: "absolute z-30 mt-1 max-h-56 w-full overflow-auto rounded-lg bg-white shadow-lg border border-primary ",
                                                    children: data.data.blockchain?.map((data, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                            className: "w-full divide-x",
                                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2921dee57b12a13a$export$8bad31ff872c7659).Option, {
                                                                onClick: ()=>{
                                                                    navigate({
                                                                        pathname: chartTableNav() ? "/Explore/Tables" : "/Explore",
                                                                        search: data.search
                                                                    });
                                                                },
                                                                className: ({ active: active })=>$e199516c8f855348$var$classNames(active ? "text-white bg-primary" : "text-gray-900", "relative py-2 pl-3 pr-9 rounded-md"),
                                                                value: data,
                                                                children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                                                className: "flex items-center",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                                                        src: "https://api.wevr.ai/V2" + "/" + data.icon,
                                                                                        alt: "",
                                                                                        className: "h-6 w-6 flex-shrink-0 rounded-full"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                        className: $e199516c8f855348$var$classNames(selected ? "" : "font-normal", "ml-3 block truncate"),
                                                                                        children: data.name
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            selected ? /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                                className: $e199516c8f855348$var$classNames(active ? "text-white" : "text-primary", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ad110a4e18e6d96b$export$2e2bcd8739ae039), {
                                                                                    className: "h-5 w-5",
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            }) : null
                                                                        ]
                                                                    })
                                                            }, data._id)
                                                        }, index))
                                                })
                                            })
                                        ]
                                    })
                                })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: " ml-2 flex items-center text-center ",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "rounded-lg   text-gray-900 bg-white border border-primary flex",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                            className: `${!chartTableNav() ? "bg-primary text-white font-semibold" : ""} flex rounded-l-md pl-2 items-center py-2.5 px-2 w-full h-full`,
                            onClick: ()=>{
                                navigate({
                                    pathname: "/Explore",
                                    search: "?blockchain=" + searchParams.get("blockchain")
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $70738760aff060d1$export$2e2bcd8739ae039), {
                                    className: "w-4 h-4 mr-1"
                                }),
                                "Charts"
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                            className: `${chartTableNav() ? "bg-primary text-white font-semibold" : "hover:bg-primary/30"} flex rounded-r-md pr-2 items-center py-2.5 px-2 w-full h-full`,
                            onClick: ()=>{
                                navigate({
                                    pathname: "/Explore/Tables",
                                    search: "?blockchain=" + searchParams.get("blockchain")
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $63addcb26601676e$export$2e2bcd8739ae039), {
                                    className: "w-4 h-4 mr-1"
                                }),
                                "Tables"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-full overflow-auto",
                children: tickerLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "h-full animate-pulse w-full justify-center flex ",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports))),
                        alt: "...",
                        className: "h-6 pb-1 md:h-14 md:w-14 self-center"
                    })
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "h-full",
                    children: tickerError ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "h-full w-full justify-center flex ",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8da1b181472d2466$export$2e2bcd8739ae039), {
                            alt: "...",
                            className: "h-14 w-14 self-center text-red-500"
                        })
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "px-4 grid grid-flow-col justify-start place-items-center max-w-full md:py-0 pb-2 h-full",
                        children: tickerData.data.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: " flex flex-row h-4/5 gap-2 first:border-l-2 border-r-2 px-4 border-secondary place-items-center text-sm xl:text-lg",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: "font-roboto text-center whitespace-nowrap overflow-visible text-gray-700",
                                        children: data.name
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "font-monda text-center flex text-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: `${isPrice(data.name) ? "block" : "hidden"} `,
                                                children: "$"
                                            }),
                                            data.data[0][1].toLocaleString("en-US", {
                                                maximumFractionDigits: 2
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4dd5b1713aee0c53$export$2e2bcd8739ae039), {
                                            className: `${colour(data.data[1][1], data.data[0][1]) ? "text-green-500" : "text-red-500 rotate-180"} h-4 w-4 md:h-6 md:w-6`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: `${colour(data.data[1][1], data.data[0][1]) ? "text-green-500" : "text-red-500"} font-monda font-bold align-baseline  md:text-sm`,
                                        children: [
                                            ((data.data[0][1] - data.data[1][1]) / data.data[0][1] * 100).toFixed(1),
                                            "%"
                                        ]
                                    })
                                ]
                            }, data.name))
                    })
                })
            })
        ]
    });
}
var $e199516c8f855348$export$2e2bcd8739ae039 = $e199516c8f855348$var$NavBar;




// created by james launder
// vertical nav bar & search function
// has problem  with scroll

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");








var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");
const $9fef5ead84cd2685$var$ImageWithFallback = ({ src: src, alt: alt, fallbackComponent: FallbackComponent, className: className })=>{
    const [imgError, setImgError] = (0, $exYeM.useState)(false);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: imgError ? /*#__PURE__*/ (0, $aSiaI.jsx)(FallbackComponent, {
            className: className
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            className: className,
            src: src,
            alt: alt,
            onError: ()=>setImgError(true)
        })
    });
};
var $9fef5ead84cd2685$export$2e2bcd8739ae039 = $9fef5ead84cd2685$var$ImageWithFallback;


const $a80d13205f1fa7e7$export$43606de922396036 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, sidebar: sidebar, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)(sidebar ? "block w-[248px]" : "hidden md:w-20 md:block", "h-[95vh] px-1 pb-4 transition-all font-roboto bg-surface transform", className),
        ...props
    }));
$a80d13205f1fa7e7$export$43606de922396036.displayName = "SidebarMain";
const $a80d13205f1fa7e7$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, sidebar: sidebar, setSidebar: setSidebar, onChange: onChange, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex flex-row px-2 mx-auto py-2", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                onClick: ()=>{
                    setSidebar(!sidebar);
                },
                className: "bg-surfaceVariant rounded-xl mr-2 p-2 border-2 group border-primaryContainer hover:bg-primary hover:text-white transition duration-0 md:block hidden",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bab2b94e392129b9$export$2e2bcd8739ae039), {
                    className: `${sidebar ? "transition  duration-75" : "rotate-180 transition duration-75"}object-scale-down h-8 w-8 group-hover:text-white text-onSurfaceVariant `
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: `${sidebar ? "relative w-full " : "hidden"}`,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                    type: "text",
                    name: "search",
                    id: "search",
                    placeholder: "Search",
                    className: "relative w-full md:w-[163px] px-4 h-12 md:h-full rounded-xl border border-primaryContainer focus:border-primary focus:outline-none",
                    onChange: onChange
                })
            })
        ]
    }));
$a80d13205f1fa7e7$export$e575a964a1fe8b0.displayName = "SidebarHeader";
const $a80d13205f1fa7e7$export$fddb90075af4c1bb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, children: children, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-full overflow-auto", className),
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "mx-auto w-full p-2 space-y-2 max-h-full",
            children: children
        })
    }));
$a80d13205f1fa7e7$export$fddb90075af4c1bb.displayName = "SidebarItems";
const $a80d13205f1fa7e7$export$b09fc4897b18f7d8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ sidebar: sidebar, setSidebar: setSidebar, item: item, onClick: onClick, width: width, searchParams: searchParams, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc97e116d42111e1$export$74a362b31437ec83), {
        as: "div",
        ref: ref,
        ...props,
        children: ({ open: open })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $cc97e116d42111e1$export$74a362b31437ec83).Button, {
                        className: "flex w-full place-items-center bg-white justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "grid grid-flow-col items-center",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9fef5ead84cd2685$export$2e2bcd8739ae039), {
                                        src: "https://api.wevr.ai/V2/" + item.icon,
                                        alt: "",
                                        fallbackComponent: (0, $3089dd68b3af4c30$export$2e2bcd8739ae039),
                                        className: "object-scale-down h-8 w-8 mr-2 text-primary"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        className: `${!sidebar ? "font-roboto font-light text-base text-black" : "hidden"}`,
                                        children: item.category
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9b82b6f96fc76ebd$export$2e2bcd8739ae039), {
                                className: `${open ? " transform" : "rotate-90"} h-6 w-6 text-onSurfaceVariant`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: `${open ? "bg-surfaceVariant border border-primaryContainer shadow-sm" : ""} rounded-xl`,
                        children: item.children.map((subItem)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc97e116d42111e1$export$74a362b31437ec83).Panel, {
                                as: "ul",
                                className: "space-y-0 gap-0",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                        onClick: ()=>{
                                            onClick(subItem);
                                            if (width <= 768) setSidebar(!sidebar);
                                        },
                                        className: `${searchParams.get("name") === subItem.name ? "bg-primary text-white" : "hover:bg-primary/50 "} w-full flex rounded-lg p-2 font-light`,
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: subItem.name
                                        })
                                    }, subItem.name)
                                })
                            }, subItem.name))
                    })
                ]
            })
    }));
$a80d13205f1fa7e7$export$b09fc4897b18f7d8.displayName = "SidebarItem";
const $a80d13205f1fa7e7$export$bbd31c05825b0e6c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ className: className, sidebar: sidebar, setSidebar: setSidebar, item: item, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-full overflow-auto", className),
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
            onClick: ()=>setSidebar(!sidebar),
            className: "flex w-full bg-white  p-2 rounded-lg border-2 border-primaryContainer",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                className: "object-scale-down h-8 w-8",
                src: "https://api.wevr.ai/V2/" + item.icon,
                alt: ""
            })
        })
    }));
$a80d13205f1fa7e7$export$bbd31c05825b0e6c.displayName = "SidebarIcon";


function $162aa999afa520c0$var$ChartSidebarV2() {
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [filteredList, setFilteredList] = (0, $exYeM.useState)([]);
    const [searchState, setSearchState] = (0, $exYeM.useState)(false);
    const { width: width } = (0, $a88fc3007e889430$export$2e2bcd8739ae039)();
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, queryData: queryData } = (0, $0edff4a12d1a07f6$export$2e2bcd8739ae039)();
    const { setGraphName: setGraphName, setResetCmp: setResetCmp } = (0, $db3ca1d693c83ded$export$9479dd47595eafb9)();
    const sidebar = (0, $bac91e2a1be69460$export$59dca65daeaf223)((state)=>state.state);
    const setSidebar = (0, $bac91e2a1be69460$export$59dca65daeaf223)((state)=>state.setSidebar);
    const group = {};
    // groups each chart by its category
    const groupCategory = (item)=>{
        item.forEach(({ category: category, icon: icon, ...rest })=>{
            // console.log(icon);
            group[category, icon] = group[category, icon] || {
                category: category,
                icon: icon,
                children: []
            };
            group[icon].children.push(rest);
        });
        return Object.values(group);
    };
    // ensures that the params are up to date
    (0, $exYeM.useEffect)(()=>{
        // setActiveName(searchParams.get("name"));
        if (searchParams.get("name")) {
            if (!searchParams.get("resolution")) searchParams.set("resolution", "Day");
            if (!searchParams.get("sma")) searchParams.set("sma", "None");
            if (!searchParams.get("ema")) searchParams.set("ema", "None");
            if (!searchParams.get("scale")) searchParams.set("scale", "Linear");
            if (!searchParams.get("type")) searchParams.set("type", "Line");
            setSearchParams(searchParams);
            setGraphName(searchParams.get("name"));
        }
    }, [
        searchParams.get("blockchain")
    ]);
    // function to interact with the params
    const params = (value)=>{
        setResetCmp(true);
        // console.log("ver nat: " + resetChartsState);
        // if (!resetChartsState) {
        //   resetChartsToggle;
        //   console.log("ver nat psot: " + resetChartsState);
        // }
        searchParams.set("name", value.name);
        if (!searchParams.get("resolution")) searchParams.set("resolution", "Day");
        if (!searchParams.get("sma")) searchParams.set("sma", "None");
        if (!searchParams.get("ema")) searchParams.set("ema", "None");
        if (!searchParams.get("scale")) searchParams.set("scale", "Linear");
        if (!searchParams.get("type")) searchParams.set("type", "Line");
        const firstLoadValues = queryData?.data?.graphNames.find((key)=>key.name === searchParams.get("name"));
        if (!firstLoadValues.resolution.includes(searchParams.get("resolution"))) searchParams.set("resolution", "Day");
        if (Array.isArray(firstLoadValues.sources)) // searchParams.delete("source");
        searchParams.set("source", firstLoadValues.sources[0].name);
        else searchParams.delete("source");
        setSearchParams(searchParams);
        setGraphName(value.name);
    // setActiveName(value);
    };
    // search function
    const filterBySearch = (event)=>{
        const query = event.target.value;
        if (query) setSearchState(true);
        else setSearchState(false);
        var updatedList = queryData?.data?.graphNames;
        updatedList = updatedList.filter((item)=>{
            return item.name.toLowerCase().startsWith(query.toLowerCase());
        });
        setFilteredList(updatedList);
    };
    const SearchItems = ({ items: items })=>/*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
            className: "mt-2",
            children: items.map((key)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "w-full px-2",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            onClick: ()=>{
                                params(key.name);
                                setSearchState(false);
                            },
                            className: `${searchParams.get("name") === key.name ? "bg-primary text-white" : "hover:bg-primary/30 bg-primaryContainer"} group w-full flex justify-between rounded-lg p-2`,
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: key.name
                            })
                        }, key.name)
                    }, key.name)
                }, key.name))
        });
    if (isError) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: "Error"
    });
    // isloading
    if (isLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-[0px] md:w-[248px] min-h-screen transition-all font-roboto bg-surface",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "flex flex-row px-2 mx-auto py-2 animate-pulse",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "mx-auto w-full rounded-xl p-2 space-y-2 mt-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $a80d13205f1fa7e7$export$43606de922396036), {
        sidebar: sidebar,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a80d13205f1fa7e7$export$e575a964a1fe8b0), {
                sidebar: sidebar,
                setSidebar: setSidebar,
                onChange: filterBySearch
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a80d13205f1fa7e7$export$fddb90075af4c1bb), {
                children: sidebar ? searchState ? /*#__PURE__*/ (0, $aSiaI.jsx)(SearchItems, {
                    items: filteredList
                }) : groupCategory(queryData?.data?.graphNames)?.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $a80d13205f1fa7e7$export$b09fc4897b18f7d8), {
                        siderbar: sidebar,
                        setSidebar: setSidebar,
                        item: item,
                        onClick: params,
                        width: width,
                        searchParams: searchParams
                    }, item.category)) : groupCategory(queryData?.data?.graphNames)?.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            onClick: ()=>setSidebar(!sidebar),
                            className: "flex w-full bg-white  p-2 rounded-lg border-2 border-primaryContainer",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "grid grid-flow-col",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                    className: "object-scale-down h-8 w-8",
                                    src: "https://api.wevr.ai/V2" + "/" + item.icon,
                                    alt: ""
                                })
                            })
                        })
                    }, item.category))
            })
        ]
    });
}
var $162aa999afa520c0$export$2e2bcd8739ae039 = $162aa999afa520c0$var$ChartSidebarV2;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



// GetEthTableStores.js



function $b2a29e888e61588f$export$d94eb8d83fa0a609() {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, data: tablesData } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "tableStores",
            searchParams.get("blockchain")
        ],
        queryFn: async ()=>{
            const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(`/tableStores/${searchParams.get("blockchain")}`).catch(function(error) {
                return error.response;
            });
            return data;
        },
        staleTime: Infinity
    });
    return {
        isLoading: isLoading,
        isError: isError,
        isFetching: isFetching,
        tablesData: tablesData
    };
}







function $1868fb05cd40ad96$export$2e2bcd8739ae039() {
    const { width: width } = (0, $a88fc3007e889430$export$2e2bcd8739ae039)();
    const [imgError, setImgError] = (0, $exYeM.useState)(false);
    const { isLoading: isLoading, isError: isError, isFetching: isFetching, tablesData: tablesData } = (0, $b2a29e888e61588f$export$d94eb8d83fa0a609)();
    const sidebar = (0, $bac91e2a1be69460$export$59dca65daeaf223)((state)=>state.state);
    const setSidebar = (0, $bac91e2a1be69460$export$59dca65daeaf223)((state)=>state.setSidebar);
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const [searchState, setSearchState] = (0, $exYeM.useState)(false);
    const [filteredList, setFilteredList] = (0, $exYeM.useState)([]);
    const firstLoad = (0, $exYeM.useRef)(true);
    const { blockchain: blockchain, tableStoresLoading: tableStoresLoading, tableStoresError: tableStoresError, tableStoresErrorDetails: tableStoresErrorDetails, blockchainLoading: blockchainLoading, blockchainData: blockchainData, blockchainErrorState: blockchainErrorState, currentTableStores: currentTableStores, setCurrentTableStores: setCurrentTableStores } = (0, $594c43af5603e55d$export$2695b98d4c569528)();
    const { selectedTable: selectedTable, setSelectedTable: setSelectedTable } = (0, $36668da87eecb6a1$export$53f1df386d7d7c73)(currentTableStores, blockchain);
    const group = {};
    // groups each chart by its category
    const groupCategory = (item)=>{
        item.forEach(({ category: category, icon: icon, ...rest })=>{
            // console.log(icon);
            group[category, icon] = group[category, icon] || {
                category: category,
                icon: icon,
                children: []
            };
            group[icon].children.push(rest);
        });
        return Object.values(group);
    };
    const handleTableSelect = (table)=>{
        // if (firstLoad.current) {
        //   firstLoad.current === false;
        //   return;
        // }
        searchParams.set("name", table.name);
        searchParams.set("interval", table.interval || "days");
        setSearchParams(searchParams);
        if (typeof onTableSelect === "function") setSelectedTable(table);
    };
    const filterBySearch = (event)=>{
        const query = event.target.value;
        if (query) setSearchState(true);
        else setSearchState(false);
        var updatedList = tablesData?.tableStores;
        updatedList = updatedList.filter((item)=>{
            return item.name.toLowerCase().startsWith(query.toLowerCase());
        });
        setFilteredList(updatedList);
    };
    const SearchItems = ({ items: items })=>/*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
            className: "mt-2",
            children: items.map((key)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "w-full px-2",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            onClick: ()=>{
                                // params(key.name);
                                setSearchState(false);
                            },
                            className: `${searchParams.get("name") === key.name ? "bg-primary text-white" : "hover:bg-primary/30 bg-primaryContainer"} group w-full flex justify-between rounded-lg p-2`,
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: key.name
                            })
                        }, key.name)
                    }, key.name)
                }, key.name))
        });
    if (isError) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        children: "Error"
    });
    // isloading
    if (isLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "w-[0px] md:w-[248px] min-h-screen transition-all font-roboto bg-surface",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "flex flex-row px-2 mx-auto py-2 animate-pulse",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "mx-auto w-full rounded-xl p-2 space-y-2 mt-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex h-14 w-full place-items-center bg-gray-300 justify-between p-2 rounded-lg font-medium text-lg border border-primaryContainer"
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $a80d13205f1fa7e7$export$43606de922396036), {
        sidebar: sidebar,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a80d13205f1fa7e7$export$e575a964a1fe8b0), {
                sidebar: sidebar,
                setSidebar: setSidebar,
                onChange: filterBySearch
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a80d13205f1fa7e7$export$fddb90075af4c1bb), {
                children: sidebar ? searchState ? /*#__PURE__*/ (0, $aSiaI.jsx)(SearchItems, {
                    items: filteredList
                }) : groupCategory(tablesData?.data?.tableStores)?.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $a80d13205f1fa7e7$export$b09fc4897b18f7d8), {
                        siderbar: sidebar,
                        setSidebar: setSidebar,
                        item: item,
                        onClick: handleTableSelect,
                        width: width,
                        searchParams: searchParams
                    }, item.category)) : groupCategory(tablesData?.data?.tableStores)?.map((item)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            onClick: ()=>setSidebar(!sidebar),
                            className: "flex w-full bg-white  p-2 rounded-lg border-2 border-primaryContainer",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "grid grid-flow-col",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9fef5ead84cd2685$export$2e2bcd8739ae039), {
                                    src: "https://api.wevr.ai/V2" + "/" + item.icon,
                                    alt: "",
                                    fallbackComponent: (0, $3089dd68b3af4c30$export$2e2bcd8739ae039),
                                    className: "object-scale-down h-8 w-8 mr-2 text-primary"
                                })
                            })
                        })
                    }, item.category))
            })
        ]
    });
}


function $438f833e9057668f$var$Explore() {
    const { width: width } = (0, $a88fc3007e889430$export$2e2bcd8739ae039)();
    const setSidebar = (0, $bac91e2a1be69460$export$59dca65daeaf223)((state)=>state.setSidebar);
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    (0, $exYeM.useEffect)(()=>{
        if (width <= 768) setSidebar(false);
        else setSidebar(true);
    }, [
        width,
        setSidebar
    ]);
    const [exploreType, setExploreType] = (0, $exYeM.useState)(()=>location.pathname.includes("Tables"));
    (0, $exYeM.useEffect)(()=>{
        setExploreType(location.pathname.includes("Tables"));
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col relative z-0 h-full max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("nav", {
                className: "z-10",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e199516c8f855348$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-row w-full min-h-screen",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "absolute z-20 md:z-0 md:relative border-r-2 border-secondary",
                        children: exploreType ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1868fb05cd40ad96$export$2e2bcd8739ae039), {}, "table") : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $162aa999afa520c0$export$2e2bcd8739ae039), {}, "chart")
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("main", {
                        className: "flex-grow",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$910ae8079b2c2852), {})
                    })
                ]
            })
        ]
    });
}
var $438f833e9057668f$export$2e2bcd8739ae039 = $438f833e9057668f$var$Explore;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

// the metadata that is programmatic exists in chart.js this is static page metadata 
const $fcd3b67f8d244ec9$var$defaultMetadata = {
    title: "Wevr.ai - Data your way",
    description: "Discover the future of data-driven insights with wevr.ai, the premier Web3 blockchain data analysis platform. Our cutting-edge solutions empower businesses to harness the true potential of decentralized networks, enabling smarter decision-making and optimized strategies."
};
const $fcd3b67f8d244ec9$var$pageMetadata = {
    "/Pricing": {
        title: "Pricing | Wevr.ai",
        description: "Explore our flexible pricing options for blockchain data analysis."
    },
    "/Faq": {
        title: "FAQ | Wevr.ai",
        description: "Find answers to frequently asked questions about Wevr.ai and our services."
    },
    "/Discover": {
        title: "Discover | Wevr.ai",
        description: "Stay updated with the latest news and insights in the blockchain, data analytics and Web3 space."
    },
    "/Explore/Tables": {
        title: "Data Tables | Wevr.ai",
        description: "Explore comprehensive blockchain data in tabular format. Analyze and compare key metrics across various blockchains and tokens."
    }
};
function $fcd3b67f8d244ec9$var$MetadataProvider({ children: children }) {
    const [metadata, setMetadata] = (0, $exYeM.useState)($fcd3b67f8d244ec9$var$defaultMetadata);
    const [currentPath, setCurrentPath] = (0, $exYeM.useState)(window.location.pathname);
    (0, $exYeM.useEffect)(()=>{
        const updateMetadata = ()=>{
            const pathname = window.location.pathname;
            setCurrentPath(pathname);
            if (pathname.startsWith("/Explore")) {
                if (pathname === "/Explore/Tables") setMetadata($fcd3b67f8d244ec9$var$pageMetadata["/Explore/Tables"]);
                else // Do nothing for other chart pages, let the Chart component handle it
                return;
            } else // Use pageMetadata if defined, otherwise use defaultMetadata
            setMetadata($fcd3b67f8d244ec9$var$pageMetadata[pathname] || $fcd3b67f8d244ec9$var$defaultMetadata);
        };
        updateMetadata();
        // Set up an interval to check for path changes
        const intervalId = setInterval(()=>{
            if (window.location.pathname !== currentPath) updateMetadata();
        }, 100);
        // Clean up the interval on component unmount
        return ()=>clearInterval(intervalId);
    }, [
        currentPath
    ]);
    // Render Helmet for all pages except chart pages (excluding /Explore/Tables)
    if (currentPath.startsWith("/Explore") && currentPath !== "/Explore/Tables") return children;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1b1ce360ba5de5b0$export$4719288a8f5f7e71), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1b1ce360ba5de5b0$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("link", {
                        rel: "icon",
                        href: "./Assets/favicon.png"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("title", {
                        children: metadata.title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "description",
                        content: metadata.description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@wevr_ai"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:title",
                        content: metadata.title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:description",
                        content: metadata.description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://api.wevr.ai/V2/assets/WevrTwitterCard.png"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:url",
                        content: `https://wevr.ai${currentPath}${window.location.search}`
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:title",
                        content: metadata.title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:description",
                        content: metadata.description
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:image",
                        content: "https://api.wevr.ai/V2/assets/WevrTwitterCard.png"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:locale",
                        content: "en_AU"
                    })
                ]
            }),
            children
        ]
    });
}
var $fcd3b67f8d244ec9$export$2e2bcd8739ae039 = $fcd3b67f8d244ec9$var$MetadataProvider;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");




const $4af6195cc5ac9db3$var$Glossary = ()=>{
    const cryptoTerms = [
        {
            term: "Blockchain",
            definition: "A decentralized, distributed ledger technology that records transactions across many computers."
        },
        {
            term: "Bitcoin",
            definition: "The first and most well-known cryptocurrency, created by an anonymous person or group under the pseudonym Satoshi Nakamoto."
        },
        {
            term: "Ethereum",
            definition: "A decentralized, open-source blockchain featuring smart contract functionality."
        },
        {
            term: "Smart Contract",
            definition: "Self-executing contracts with the terms of the agreement directly written into code."
        },
        {
            term: "DeFi",
            definition: "Decentralized Finance; a system of financial services built on blockchain technologies."
        },
        {
            term: "NFT",
            definition: "Non-Fungible Token; a unique digital asset verified using blockchain technology."
        },
        {
            term: "Mining",
            definition: "The process of validating and adding new transactions to a blockchain."
        },
        {
            term: "Wallet",
            definition: "A digital tool that allows users to store and manage their cryptocurrencies."
        },
        {
            term: "Exchange",
            definition: "A platform where users can buy, sell, or trade cryptocurrencies."
        },
        {
            term: "HODL",
            definition: "A term derived from a misspelling of 'hold,' used in the crypto community to refer to buying and holding cryptocurrencies long-term."
        },
        {
            term: "On-Chain Data",
            definition: "Information that is stored directly on a blockchain network and can be verified by anyone with access to that network."
        },
        {
            term: "Blockchain Analytics",
            definition: "The analysis of on-chain data to derive insights about network activity, user behavior, and market trends."
        },
        {
            term: "Crypto Analytics",
            definition: "The analysis of both on-chain and off-chain data related to cryptocurrencies to inform investment decisions and understand market dynamics."
        },
        {
            term: "EMA",
            definition: "Exponential Moving Average; a type of moving average that gives more weight to recent price data, used in crypto trading for identifying trends."
        },
        {
            term: "UTXO",
            definition: "Unspent Transaction Output; a model used by some cryptocurrencies to track and validate transactions."
        },
        {
            term: "Hash Rate",
            definition: "The speed at which a computer or network is completing hash operations in cryptocurrency mining."
        },
        {
            term: "Consensus Mechanism",
            definition: "A protocol that ensures all nodes in a blockchain network agree on the validity of transactions and their order."
        },
        {
            term: "Gas Fee",
            definition: "The cost required to perform a transaction or execute a contract on the Ethereum blockchain."
        },
        {
            term: "Liquidity Pool",
            definition: "A collection of funds locked in a smart contract, used to facilitate decentralized trading and other DeFi activities."
        },
        {
            term: "Yield Farming",
            definition: "A way to generate rewards with cryptocurrency holdings, usually by lending or staking crypto assets."
        },
        {
            term: "Token Burn",
            definition: "The process of permanently removing a certain amount of cryptocurrency tokens from circulation."
        },
        {
            term: "Stablecoin",
            definition: "A type of cryptocurrency designed to maintain a stable value relative to a reference asset, often a fiat currency."
        },
        {
            term: "Cold Storage",
            definition: "Keeping a reserve of cryptocurrency offline to protect it from hacking, theft, or accidental loss."
        },
        {
            term: "DEX",
            definition: "Decentralized Exchange; a type of cryptocurrency exchange that operates without a central authority."
        },
        {
            term: "Tokenomics",
            definition: "The economic model and design principles of a cryptocurrency or token."
        },
        {
            term: "Layer 2",
            definition: "A secondary framework or protocol built on top of an existing blockchain to solve transaction speed and scaling difficulties."
        },
        {
            term: "DAO",
            definition: "Decentralized Autonomous Organization; an organization represented by rules encoded as a computer program that is transparent and controlled by the organization members."
        },
        {
            term: "Nonce",
            definition: "A number used once in cryptographic communication, often used in proof-of-work mining and to ensure transaction uniqueness."
        },
        {
            term: "Mempool",
            definition: "A cryptocurrency node's mechanism for storing information on unconfirmed transactions."
        },
        {
            term: "Atomic Swap",
            definition: "A smart contract technology that enables the exchange of one cryptocurrency for another without using centralized intermediaries."
        },
        {
            term: "Hard Fork",
            definition: "A radical change to a network's protocol that makes previously invalid blocks and transactions valid, or vice-versa."
        },
        {
            term: "Multisig",
            definition: "A type of cryptocurrency wallet that requires two or more private keys to sign and send a transaction."
        },
        {
            term: "Zero-Knowledge Proof",
            definition: "A cryptographic method by which one party can prove to another party that they know a value X, without conveying any information apart from the fact that they know the value X."
        },
        {
            term: "AMM",
            definition: "Automated Market Maker; a decentralized asset trading model that uses a mathematical formula to price assets."
        },
        {
            term: "Blockchain Bridge",
            definition: "A connection that allows the transfer of tokens and/or arbitrary data from one blockchain network to another."
        },
        {
            term: "Oracle",
            definition: "A third-party service that provides smart contracts with external information."
        },
        {
            term: "Gas Optimization",
            definition: "The practice of minimizing the computational resources required for executing transactions or smart contracts on a blockchain."
        },
        {
            term: "Slippage",
            definition: "The difference between the expected price of a trade and the price at which the trade is actually executed."
        }
    ];
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative pt-10 pb-20 sm:py-24 z-0 overflow-hidden bg-white",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5f3d4e3683a59e56$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                        initial: {
                            opacity: 0.0,
                            y: 40
                        },
                        whileInView: {
                            opacity: 1,
                            y: 0
                        },
                        transition: {
                            delay: 0.2,
                            duration: 0.7,
                            ease: "easeInOut"
                        },
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "inline-block",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $30fc131f9923fe0a$export$2e2bcd8739ae039), {
                                    href: "#",
                                    newLabel: "New",
                                    children: "Crypto Knowledge Base"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                className: "mt-6 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl",
                                children: "Crypto Glossary"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                className: "mx-auto mt-3 max-w-md text-base text-gray-500 sm:text-lg md:mt-5 md:max-w-3xl md:text-xl",
                                children: "Every important crypto term explained in detail."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "mt-16 grid gap-8 md:grid-cols-2",
                        children: cryptoTerms.map((item, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: 0,
                                    y: 50
                                },
                                animate: {
                                    opacity: 1,
                                    y: 0
                                },
                                transition: {
                                    duration: 0.5,
                                    delay: index * 0.1
                                },
                                className: "relative rounded-lg border border-gray-200 bg-white px-6 py-5 shadow-sm hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                    to: `/Glossary/${item.term.toLowerCase().replace(/\s+/g, "-")}`,
                                    className: "block",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                className: "text-lg font-medium text-gray-900 mb-2",
                                                children: item.term
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                className: "text-sm text-gray-500",
                                                children: item.definition
                                            })
                                        ]
                                    })
                                })
                            }, item.term))
                    })
                ]
            })
        ]
    });
};
var $4af6195cc5ac9db3$export$2e2bcd8739ae039 = $4af6195cc5ac9db3$var$Glossary;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");





const $e271f4e3e637d312$var$GlossaryTermPage = ()=>{
    const { term: term } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    const termDetails = {
        blockchain: {
            title: "What is Blockchain?",
            definition: "A blockchain is a decentralized, distributed ledger technology that records transactions across many computers.",
            details: [
                "Decentralized: No single entity has control over the entire network.",
                "Distributed: The ledger is spread across multiple nodes or computers.",
                "Immutable: Once data is recorded, it's extremely difficult to change.",
                "Transparent: All transactions are visible to anyone on the network.",
                "Secure: Uses cryptography to ensure data integrity and security."
            ],
            examples: [
                "Bitcoin uses blockchain to record financial transactions.",
                "Ethereum uses blockchain to support smart contracts and decentralized applications.",
                "Supply chain management can use blockchain to track products from manufacture to delivery."
            ]
        },
        bitcoin: {
            title: "What is Bitcoin?",
            definition: "Bitcoin is the first and most well-known cryptocurrency, created by an anonymous person or group under the pseudonym Satoshi Nakamoto.",
            details: [
                "Decentralized: Not controlled by any central authority or government.",
                "Limited Supply: Only 21 million bitcoins will ever exist.",
                "Pseudonymous: Transactions are linked to addresses, not personal identities.",
                "Peer-to-Peer: Transactions occur directly between users without intermediaries.",
                "Blockchain-based: Uses blockchain technology to record all transactions."
            ],
            examples: [
                "Used as a store of value, often referred to as 'digital gold'.",
                "Can be used for online purchases at businesses that accept Bitcoin.",
                "Facilitates cross-border transactions without traditional banking fees."
            ]
        },
        ethereum: {
            title: "What is Ethereum?",
            definition: "Ethereum is a decentralized, open-source blockchain featuring smart contract functionality.",
            details: [
                "Smart Contracts: Self-executing contracts with the terms directly written into code.",
                "Ether: The native cryptocurrency of the Ethereum network.",
                "Decentralized Applications (dApps): Applications that run on the Ethereum network.",
                "Ethereum Virtual Machine (EVM): The runtime environment for smart contracts in Ethereum.",
                "Gas: The fee required to conduct a transaction or execute a contract on Ethereum."
            ],
            examples: [
                "Creating and trading non-fungible tokens (NFTs).",
                "Decentralized finance (DeFi) applications like lending and borrowing platforms.",
                "Decentralized autonomous organizations (DAOs) for collective decision-making."
            ]
        },
        defi: {
            title: "What is DeFi?",
            definition: "DeFi, or Decentralized Finance, refers to financial services built on blockchain technologies, primarily the Ethereum network.",
            details: [
                "Permissionless: Anyone can access DeFi services without needing approval from a centralized authority.",
                "Transparent: All transactions and smart contracts are visible on the blockchain.",
                "Interoperable: Different DeFi protocols can often work together seamlessly.",
                "Non-custodial: Users maintain control of their assets rather than trusting them to a third party.",
                "Programmable: Smart contracts automate financial services and create new possibilities."
            ],
            examples: [
                "Decentralized exchanges (DEXs) like Uniswap for trading cryptocurrencies.",
                "Lending and borrowing platforms like Aave or Compound.",
                "Stablecoins pegged to the value of fiat currencies, like DAI."
            ]
        },
        nft: {
            title: "What are NFTs?",
            definition: "NFT stands for Non-Fungible Token, a unique digital asset verified using blockchain technology.",
            details: [
                "Unique: Each NFT has distinct information that sets it apart from any other NFT.",
                "Indivisible: NFTs cannot be divided into smaller denominations.",
                "Provable Scarcity: The blockchain verifies the rarity and ownership of NFTs.",
                "Programmable: NFTs can include complex functionalities through smart contracts.",
                "Interoperable: NFTs can often be used across various platforms and applications."
            ],
            examples: [
                "Digital art pieces sold as NFTs, like Beeple's $69 million artwork.",
                "Virtual real estate in blockchain-based games like Decentraland.",
                "Collectible sports moments, such as NBA Top Shot highlights."
            ]
        },
        "onchain-data": {
            title: "What is On-Chain Data?",
            definition: "On-chain data refers to information that is stored directly on a blockchain network and can be verified by anyone with access to that network.",
            details: [
                "Transparent: All on-chain data is publicly visible and verifiable.",
                "Immutable: Once recorded, on-chain data cannot be altered without consensus.",
                "Real-time: On-chain data provides up-to-the-minute information about network activity.",
                "Trustless: No need to rely on third-party sources for data verification."
            ],
            examples: [
                "Transaction histories and balances of blockchain addresses.",
                "Smart contract code and interactions on platforms like Ethereum.",
                "Token transfers and ownership records."
            ]
        },
        "blockchain-analytics": {
            title: "What are Blockchain Analytics?",
            definition: "Blockchain analytics involves the analysis of on-chain data to derive insights about network activity, user behavior, and market trends.",
            details: [
                "Pattern Recognition: Identifying trends and anomalies in blockchain data.",
                "Forensics: Tracing the flow of funds across addresses and time.",
                "Risk Assessment: Evaluating the risk profile of addresses or transactions.",
                "Market Intelligence: Deriving trading and investment insights from on-chain activity."
            ],
            examples: [
                "Chainalysis and CipherTrace for cryptocurrency transaction monitoring.",
                "Glassnode and IntoTheBlock for market intelligence based on on-chain metrics.",
                "Etherscan for Ethereum blockchain exploration and analysis."
            ]
        },
        "crypto-analytics": {
            title: "What are Crypto Analytics?",
            definition: "Crypto analytics encompasses the analysis of both on-chain and off-chain data related to cryptocurrencies to inform investment decisions and understand market dynamics.",
            details: [
                "Price Analysis: Studying historical and real-time price movements.",
                "Sentiment Analysis: Gauging market sentiment through social media and news.",
                "On-Chain Metrics: Analyzing blockchain data for insights.",
                "Wallet Profiling: Identifying and categorizing significant market players."
            ],
            examples: [
                "CoinMetrics for comprehensive crypto asset analytics.",
                "Santiment for behavior analytics of crypto markets.",
                "LunarCrush for social media sentiment analysis in crypto."
            ]
        },
        "ema": {
            title: "What is EMA in Crypto?",
            definition: "EMA stands for Exponential Moving Average, a type of moving average that gives more weight to recent price data. It's commonly used in crypto trading for identifying trends and potential entry or exit points.",
            details: [
                "Responsive: Reacts more quickly to recent price changes than simple moving averages.",
                "Trend Indicator: Helps identify the direction and strength of trends.",
                "Support/Resistance: Often acts as dynamic support or resistance levels.",
                "Crossovers: EMA crossovers are used as trading signals."
            ],
            examples: [
                "50-day and 200-day EMAs are often used to identify long-term trends in Bitcoin.",
                "Traders might use EMA crossovers, like when a short-term EMA crosses above a long-term EMA, as a buy signal.",
                "The 20-day EMA is popular for short-term trend analysis in crypto markets."
            ]
        },
        "utxo": {
            title: "What is UTXO?",
            definition: "UTXO stands for Unspent Transaction Output. It's a model used by some cryptocurrencies, including Bitcoin, to track and validate transactions.",
            details: [
                "Discrete: Each UTXO represents a specific amount of cryptocurrency.",
                "Immutable: Once created, a UTXO cannot be altered, only spent entirely.",
                "Traceable: Allows for easy tracking of transaction history.",
                "Scalability: Can potentially offer better scalability than account-based models."
            ],
            examples: [
                "In Bitcoin, when you receive BTC, it's stored as one or more UTXOs in your wallet.",
                "When spending Bitcoin, you're actually sending one or more entire UTXOs.",
                "Change from a transaction creates a new UTXO with the remaining balance."
            ]
        },
        "smart-contract": {
            title: "What is a Smart Contract?",
            definition: "A smart contract is a self-executing contract with the terms of the agreement directly written into code. It automatically enforces and executes the terms when predetermined conditions are met.",
            details: [
                "Autonomous: Executes automatically without intermediaries.",
                "Transparent: Code and execution results are visible on the blockchain.",
                "Immutable: Once deployed, the contract code cannot be changed.",
                "Trustless: Parties don't need to trust each other, just the code."
            ],
            examples: [
                "Automated token swaps on decentralized exchanges like Uniswap.",
                "Decentralized lending protocols like Aave or Compound.",
                "NFT minting and trading contracts."
            ]
        },
        "hash-rate": {
            title: "What is Hash Rate?",
            definition: "Hash rate refers to the speed at which a computer or network is completing hash operations in cryptocurrency mining. It's a measure of computational power and mining difficulty.",
            details: [
                "Network Security: Higher hash rates generally mean more secure networks.",
                "Mining Difficulty: Hash rate directly affects mining difficulty adjustments.",
                "Performance Metric: Used to compare mining hardware efficiency.",
                "Network Health Indicator: Often used to gauge the overall health of a blockchain network."
            ],
            examples: [
                "Bitcoin's network hash rate is often used as an indicator of network security and miner confidence.",
                "ASIC miners are designed to achieve high hash rates for specific algorithms.",
                "Cloud mining services often sell hash rate to customers."
            ]
        },
        "consensus-mechanism": {
            title: "What is a Consensus Mechanism?",
            definition: "A consensus mechanism is a protocol that ensures all nodes in a blockchain network agree on the validity of transactions and the order in which they are added to the blockchain.",
            details: [
                "Agreement: Ensures all nodes have the same version of the blockchain.",
                "Security: Protects against attacks and fraudulent transactions.",
                "Decentralization: Allows for trustless operation without central authority.",
                "Finality: Determines when a transaction is considered irreversible."
            ],
            examples: [
                "Proof of Work (PoW) used by Bitcoin and (currently) Ethereum.",
                "Proof of Stake (PoS) used by Cardano and (soon) Ethereum 2.0.",
                "Delegated Proof of Stake (DPoS) used by EOS."
            ]
        },
        "gas-fee": {
            title: "What is a Gas Fee?",
            definition: "A gas fee is the cost required to perform a transaction or execute a contract on the Ethereum blockchain. It's paid in Ether and is used to compensate miners for the computational resources required to process and validate transactions.",
            details: [
                "Variable: Gas fees fluctuate based on network congestion.",
                "Customizable: Users can set gas prices to prioritize their transactions.",
                "Necessary: Required for all transactions and smart contract interactions.",
                "Burn Mechanism: In Ethereum's EIP-1559, a portion of gas fees is burned."
            ],
            examples: [
                "Sending ETH from one address to another requires a gas fee.",
                "Interacting with a DeFi protocol like Uniswap incurs gas fees.",
                "Minting an NFT on Ethereum requires paying gas fees."
            ]
        },
        "liquidity-pool": {
            title: "What is a Liquidity Pool?",
            definition: "A liquidity pool is a collection of funds locked in a smart contract, used to facilitate decentralized trading, lending, and other DeFi activities.",
            details: [
                "Automated: Enables automated market making for decentralized exchanges.",
                "Yield Generation: Liquidity providers earn fees from trades.",
                "Dual-Asset: Typically contains a pair of tokens in equal value.",
                "Slippage: Larger pools generally offer lower slippage for trades."
            ],
            examples: [
                "Uniswap's ETH/USDC pool for swapping between ETH and USDC.",
                "Curve Finance's stablecoin pools for low-slippage stablecoin swaps.",
                "Balancer's multi-asset pools for more complex token ratios."
            ]
        },
        "yield-farming": {
            title: "What is Yield Farming?",
            definition: "Yield farming, also known as liquidity mining, is a way to generate rewards with cryptocurrency holdings. It usually involves lending or staking crypto assets to generate returns.",
            details: [
                "High Yields: Can offer significantly higher returns than traditional finance.",
                "Risky: Often involves complex strategies and exposure to multiple protocols.",
                "Dynamic: Yields can change rapidly based on market conditions.",
                "Composable: Yields can be reinvested to compound returns."
            ],
            examples: [
                "Providing liquidity to a Uniswap pool and earning trading fees.",
                "Staking LP tokens in yield aggregators like Yearn Finance.",
                "Borrowing and lending across multiple protocols to maximize returns."
            ]
        },
        "token-burn": {
            title: "What is Token Burning?",
            definition: "Token burning is the process of permanently removing a certain amount of cryptocurrency tokens from circulation, often done to reduce supply and potentially increase value.",
            details: [
                "Deflationary: Can create scarcity and potentially increase token value.",
                "Verifiable: Burns are typically done by sending tokens to an unspendable address.",
                "Strategic: Often used as part of tokenomics models or governance decisions.",
                "Permanent: Burned tokens cannot be recovered or reused."
            ],
            examples: [
                "Binance's BNB quarterly burns based on trading volume.",
                "Ethereum's EIP-1559 implementation that burns a portion of transaction fees.",
                "Project-specific burns to adjust token supply or distribution."
            ]
        },
        "stablecoin": {
            title: "What is a Stablecoin?",
            definition: "A stablecoin is a type of cryptocurrency designed to maintain a stable value relative to a reference asset, often a fiat currency like the US dollar.",
            details: [
                "Stability: Aims to minimize price volatility.",
                "Pegged: Usually pegged to a fiat currency, but can be pegged to other assets.",
                "Collateralized: Often backed by reserves of the pegged asset or other cryptocurrencies.",
                "Use Cases: Used for trading, savings, and as a medium of exchange."
            ],
            examples: [
                "USDT (Tether) and USDC, fiat-collateralized stablecoins pegged to the US dollar.",
                "DAI, an over-collateralized, crypto-backed stablecoin.",
                "AMPL (Ampleforth), an algorithmic stablecoin that adjusts supply to maintain price."
            ]
        },
        "cold-storage": {
            title: "What is Cold Storage?",
            definition: "Cold storage in cryptocurrency refers to keeping a reserve of cryptocurrency offline. This is done to protect the stored cryptocurrency from hacking, theft, or accidental loss.",
            details: [
                "Security: Offers high security by keeping private keys offline.",
                "Long-term: Ideal for long-term storage of large amounts of crypto.",
                "Hardware Wallets: Often implemented using specialized hardware devices.",
                "Paper Wallets: Can also be implemented using physical paper or metal storage."
            ],
            examples: [
                "Ledger and Trezor hardware wallets for cold storage.",
                "Paper wallets containing printed private keys and addresses.",
                "Air-gapped computers used for generating and storing keys offline."
            ]
        },
        "dex": {
            title: "What is a DEX?",
            definition: "A DEX, or Decentralized Exchange, is a type of cryptocurrency exchange that operates without a central authority and allows for direct peer-to-peer cryptocurrency transactions.",
            details: [
                "Non-Custodial: Users maintain control of their funds.",
                "Permissionless: Anyone can use a DEX without approval or KYC.",
                "Smart Contract Based: Operates using blockchain smart contracts.",
                "Liquidity Pools: Often uses automated market makers and liquidity pools."
            ],
            examples: [
                "Uniswap, a popular Ethereum-based DEX using an automated market maker model.",
                "dYdX, a DEX focused on cryptocurrency derivatives trading.",
                "PancakeSwap, a DEX on the Binance Smart Chain."
            ]
        },
        "tokenomics": {
            title: "What are Tokenomics?",
            definition: "Tokenomics refers to the economic model and design principles of a cryptocurrency or token. It encompasses factors like supply, distribution, and utility that influence a token's value and use within its ecosystem.",
            details: [
                "Supply: Includes total supply, circulating supply, and emission schedule.",
                "Distribution: How tokens are allocated among stakeholders.",
                "Utility: The token's use cases within its ecosystem.",
                "Incentives: How the token model incentivizes desired behaviors."
            ],
            examples: [
                "Bitcoin's fixed supply cap and halving events.",
                "Ethereum's shift from PoW to PoS and its impact on ETH issuance.",
                "Governance tokens in DAOs that confer voting rights."
            ]
        },
        "layer-2": {
            title: "What is a Layer 2 Solution?",
            definition: "Layer 2 refers to a secondary framework or protocol built on top of an existing blockchain system. Its main goal is to solve the transaction speed and scaling difficulties faced by major cryptocurrency networks.",
            details: [
                "Scalability: Increases transaction throughput of the main chain.",
                "Lower Fees: Often results in reduced transaction costs.",
                "Security: Relies on the security of the underlying blockchain.",
                "Variety: Includes solutions like state channels, sidechains, and rollups."
            ],
            examples: [
                "Bitcoin's Lightning Network for fast, low-cost BTC transactions.",
                "Ethereum's Optimism and Arbitrum, which use optimistic rollups.",
                "Polygon, a sidechain and commit chain scaling solution for Ethereum."
            ]
        },
        "dao": {
            title: "What is a DAO?",
            definition: "A DAO, or Decentralized Autonomous Organization, is an organization represented by rules encoded as a computer program that is transparent, controlled by the organization members, and not influenced by a central government.",
            details: [
                "Decentralized: No central authority; decisions made by community.",
                "Autonomous: Operates via smart contracts without human intervention.",
                "Transparent: All rules and financial transactions are public.",
                "Token-based: Often uses tokens for governance and decision-making."
            ],
            examples: [
                "MakerDAO, which governs the DAI stablecoin.",
                "Uniswap's governance DAO for protocol upgrades and treasury management.",
                "Compound's governance system for setting protocol parameters."
            ]
        },
        "nonce": {
            title: "What is a Nonce in Blockchain?",
            definition: "In blockchain technology, a nonce (number only used once) is a random or semi-random number that's used in authentication protocols to ensure old communications cannot be reused in replay attacks.",
            details: [
                "Mining: In proof-of-work, miners change the nonce to get different hash results.",
                "Unique: Ensures each transaction or block is unique.",
                "Security: Helps prevent double-spending and replay attacks.",
                "Sequence: In account-based models, it's used to ensure transaction order."
            ],
            examples: [
                "In Bitcoin mining, changing the nonce to find a hash that meets difficulty requirements.",
                "Ethereum uses nonces to ensure the order of transactions from a single address.",
                "In cryptographic communication, nonces are used to prevent replay attacks."
            ]
        },
        "mempool": {
            title: "What is a Mempool?",
            definition: "A mempool (memory pool) is a cryptocurrency node's mechanism for storing information on unconfirmed transactions. It acts as a sort of waiting room for transactions that have been broadcast to the network but not yet included in a block.",
            details: [
                "Temporary: Transactions stay in the mempool until confirmed or dropped.",
                "Variable Size: The size of the mempool can fluctuate based on network activity.",
                "Fee Priority: Transactions with higher fees are typically prioritized.",
                "Network Congestion Indicator: A large mempool can indicate network congestion."
            ],
            examples: [
                "During times of high activity, Bitcoin's mempool can become congested, leading to longer wait times for low-fee transactions.",
                "Some wallet software allows users to view the current state of the mempool to estimate appropriate transaction fees.",
                "Mempool visualization tools can help traders and users understand current network conditions."
            ]
        },
        "atomic-swap": {
            title: "What is an Atomic Swap?",
            definition: "An atomic swap is a smart contract technology that enables the exchange of one cryptocurrency for another without using centralized intermediaries, such as exchanges.",
            details: [
                "Trustless: No need to trust a third party with your funds.",
                "Cross-chain: Allows exchanges between different blockchain networks.",
                "Decentralized: Occurs peer-to-peer without centralized control.",
                "Time-bound: Includes time locks to ensure the trade completes or fully refunds."
            ],
            examples: [
                "Swapping Bitcoin for Litecoin directly between user wallets.",
                "Cross-chain DEXs that utilize atomic swaps for trading.",
                "Lightning Network's submarine swaps for off-chain to on-chain exchanges."
            ]
        },
        "hard-fork": {
            title: "What is a Hard Fork?",
            definition: "A hard fork is a radical change to a network's protocol that makes previously invalid blocks and transactions valid, or vice-versa. It requires all nodes or users to upgrade to the latest version of the protocol software.",
            details: [
                "Backward Incompatible: Creates a permanent divergence from the previous version.",
                "New Chain: Often results in two separate blockchains and cryptocurrencies.",
                "Community Split: Can lead to ideological and economic divisions in the community.",
                "Planned or Contentious: Can be pre-planned upgrades or result from disagreements."
            ],
            examples: [
                "The creation of Bitcoin Cash from Bitcoin in August 2017.",
                "Ethereum's transition to Ethereum 2.0 (now called 'The Merge').",
                "Monero's regular hard forks to implement privacy and security upgrades."
            ]
        },
        "multisig": {
            title: "What is a Multisig Wallet?",
            definition: "A multisig (multi-signature) wallet is a type of cryptocurrency wallet that requires two or more private keys to sign and send a transaction, adding an extra layer of security.",
            details: [
                "Enhanced Security: Protects against the compromise of a single key.",
                "Shared Control: Allows multiple parties to have control over funds.",
                "Customizable: Can be set up with various configurations (e.g., 2-of-3, 3-of-5).",
                "Smart Contract Based: Often implemented using smart contracts on platforms like Ethereum."
            ],
            examples: [
                "Corporate treasuries using 3-of-5 multisig wallets for fund management.",
                "Escrow services implemented with 2-of-3 multisig arrangements.",
                "Personal use of 2-of-2 multisig for enhanced security of large holdings."
            ]
        },
        "zero-knowledge-proof": {
            title: "What is a Zero-Knowledge Proof?",
            definition: "A zero-knowledge proof is a cryptographic method by which one party can prove to another party that they know a value X, without conveying any information apart from the fact that they know the value X.",
            details: [
                "Privacy: Allows verification without revealing sensitive information.",
                "Efficiency: Can significantly reduce the amount of data needed for verification.",
                "Versatility: Applicable in various scenarios beyond cryptocurrencies.",
                "Complexity: Implementing secure zero-knowledge proofs can be challenging."
            ],
            examples: [
                "Zcash's use of zk-SNARKs for private transactions.",
                "Ethereum's implementation of zk-rollups for scaling.",
                "Identity verification systems that don't reveal personal data."
            ]
        },
        "amm": {
            title: "What is an AMM?",
            definition: "An AMM, or Automated Market Maker, is a decentralized asset trading model that uses a mathematical formula to price assets. It allows digital assets to be traded without permission and automatically by using liquidity pools instead of a traditional market of buyers and sellers.",
            details: [
                "Liquidity Pools: Uses pools of tokens to facilitate trades.",
                "Constant Product Formula: Most common AMMs use x * y = k formula.",
                "Passive Market Making: Liquidity providers can earn fees without active trading.",
                "Slippage: Large trades can result in significant price slippage."
            ],
            examples: [
                "Uniswap's x * y = k model for token swaps.",
                "Curve Finance's stable swap AMM optimized for similar assets.",
                "Balancer's generalized n-token pool AMM."
            ]
        },
        "bridge": {
            title: "What is a Blockchain Bridge?",
            definition: "A blockchain bridge, also known as a cross-chain bridge, is a connection that allows the transfer of tokens and/or arbitrary data from one blockchain network to another.",
            details: [
                "Interoperability: Enables communication between otherwise isolated blockchains.",
                "Asset Transfer: Allows tokens to be used on non-native blockchains.",
                "Liquidity: Can help in distributing liquidity across different networks.",
                "Security Risks: Bridges can be targets for attacks due to large amounts of locked assets."
            ],
            examples: [
                "Wrapped Bitcoin (WBTC) on Ethereum, allowing Bitcoin to be used in Ethereum's DeFi ecosystem.",
                "Polygon's PoS Bridge for moving assets between Ethereum and Polygon.",
                "Multichain (formerly AnySwap) for cross-chain transactions across multiple networks."
            ]
        },
        "oracle": {
            title: "What is a Blockchain Oracle?",
            definition: "A blockchain oracle is a third-party service that provides smart contracts with external information. They act as a bridge between blockchains and the outside world.",
            details: [
                "Data Feed: Provides real-world data to on-chain smart contracts.",
                "Crucial for DeFi: Many DeFi applications rely on oracles for price feeds.",
                "Types: Include software oracles, hardware oracles, consensus-based oracles, etc.",
                "Oracle Problem: The challenge of ensuring the reliability and trustworthiness of external data."
            ],
            examples: [
                "Chainlink's decentralized oracle networks providing price data to DeFi protocols.",
                "MakerDAO's use of oracles to determine the price of ETH for CDP liquidations.",
                "Sports betting dApps using oracles to fetch real-world game results."
            ]
        },
        "gas-optimization": {
            title: "What is Gas Optimization?",
            definition: "Gas optimization refers to the practice of minimizing the computational resources required for executing transactions or smart contracts on a blockchain, typically Ethereum, to reduce transaction costs.",
            details: [
                "Cost Efficiency: Reduces the cost of interacting with the blockchain.",
                "Performance: Can improve the speed and efficiency of dApps.",
                "Complexity: Often involves trade-offs between readability and efficiency.",
                "Dynamic: Optimization strategies may change with network upgrades."
            ],
            examples: [
                "Using uint8 instead of uint256 when smaller integers are sufficient.",
                "Optimizing loop operations in smart contracts.",
                "Batching multiple transactions into a single transaction."
            ]
        },
        "slippage": {
            title: "What is Slippage in Crypto Trading?",
            definition: "Slippage refers to the difference between the expected price of a trade and the price at which the trade is actually executed. It often occurs in high-volatility markets or for large-volume trades.",
            details: [
                "Market Dynamics: More common in illiquid or volatile markets.",
                "Size Dependent: Larger trades are more likely to experience slippage.",
                "Positive or Negative: Can result in better or worse prices than expected.",
                "DEX Feature: Common in decentralized exchanges due to their AMM nature."
            ],
            examples: [
                "Setting a 1% slippage tolerance when swapping tokens on Uniswap.",
                "Large Bitcoin trades on exchanges moving the market price.",
                "Using slippage protection features in DeFi aggregators like 1inch."
            ]
        }
    };
    const currentTerm = termDetails[term.toLowerCase()] || {
        title: `What is ${term}?`,
        definition: "We're still working on a detailed explanation for this term. Check back soon!",
        details: [],
        examples: [],
        extendedContent: "We're currently developing more in-depth content for this term. Please check back later for a comprehensive explanation."
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1b1ce360ba5de5b0$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("title", {
                        children: [
                            currentTerm.title,
                            " | Crypto Glossary"
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "description",
                        content: currentTerm.definition
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        name: "keywords",
                        content: `${term}, cryptocurrency, blockchain, crypto glossary`
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("link", {
                        rel: "canonical",
                        href: `https://yourdomain.com/glossary/${term.toLowerCase()}`
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:title",
                        content: `${currentTerm.title} | Crypto Glossary`
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:description",
                        content: currentTerm.definition
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:url",
                        content: `https://yourdomain.com/glossary/${term.toLowerCase()}`
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative pt-10 pb-20 sm:py-24 z-0 overflow-hidden bg-white",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5f3d4e3683a59e56$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: 0.0,
                                    y: 40
                                },
                                animate: {
                                    opacity: 1,
                                    y: 0
                                },
                                transition: {
                                    delay: 0.2,
                                    duration: 0.7,
                                    ease: "easeInOut"
                                },
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                        to: "/Glossary",
                                        className: "inline-block mb-6",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).button, {
                                            whileHover: {
                                                scale: 1.05
                                            },
                                            whileTap: {
                                                scale: 0.95
                                            },
                                            className: "bg-primary text-white font-bold py-2 px-4 rounded-full shadow-lg hover:bg-primary-dark transition duration-300",
                                            children: "\u2190 Back to Glossary"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                        className: "mt-6 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl",
                                        children: currentTerm.title
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                        className: "mx-auto mt-3 max-w-md text-base text-gray-500 sm:text-lg md:mt-5 md:max-w-3xl md:text-xl",
                                        children: currentTerm.definition
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "mt-16",
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                    initial: {
                                        opacity: 0,
                                        y: 50
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 0
                                    },
                                    transition: {
                                        duration: 0.5
                                    },
                                    className: "bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200",
                                    children: [
                                        currentTerm.details.length > 0 && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "px-4 py-5 sm:p-6",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                                    className: "text-2xl leading-6 font-medium text-gray-900",
                                                    children: "Key Details"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "mt-5",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                                        className: "list-disc pl-5 space-y-1",
                                                        children: currentTerm.details.map((detail, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                className: "text-base text-gray-500",
                                                                children: detail
                                                            }, index))
                                                    })
                                                })
                                            ]
                                        }),
                                        currentTerm.examples.length > 0 && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "px-4 py-5 sm:p-6",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                                    className: "text-2xl leading-6 font-medium text-gray-900",
                                                    children: "Examples"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    className: "mt-5",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                                        className: "list-disc pl-5 space-y-1",
                                                        children: currentTerm.examples.map((example, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                                                className: "text-base text-gray-500",
                                                                children: example
                                                            }, index))
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "mt-16",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8667dd4cd334d17b$export$e25e478948902b8b).div, {
                                    initial: {
                                        opacity: 0,
                                        y: 50
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 0
                                    },
                                    transition: {
                                        duration: 0.5,
                                        delay: 0.2
                                    },
                                    className: "bg-white overflow-hidden shadow rounded-lg",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "px-4 py-5 sm:p-6",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                                                className: "text-2xl leading-6 font-medium text-gray-900 mb-4",
                                                children: [
                                                    "Deep Dive into ",
                                                    currentTerm.title
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "prose prose-lg text-gray-500 max-w-none",
                                                children: currentTerm.extendedContent ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: currentTerm.extendedContent
                                                    }
                                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                                    children: "We're currently developing more in-depth content for this term. Please check back later for a comprehensive explanation."
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e271f4e3e637d312$export$2e2bcd8739ae039 = $e271f4e3e637d312$var$GlossaryTermPage;


/* eslint-disable no-unused-vars */ /* eslint-disable react/no-unescaped-entities */ 
var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");



/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5710fed419a1c745$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);






var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
// packages/react/context/src/createContext.tsx

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
function $5c8fd24e0d275553$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $exYeM.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $exYeM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $aSiaI.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $exYeM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $5c8fd24e0d275553$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $exYeM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $exYeM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $aSiaI.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $exYeM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $exYeM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $exYeM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $5c8fd24e0d275553$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $5c8fd24e0d275553$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $exYeM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/compose-refs/src/composeRefs.tsx

var $exYeM = parcelRequire("exYeM");
function $e9cf810736c515ab$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $e9cf810736c515ab$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $e9cf810736c515ab$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $e9cf810736c515ab$var$setRef(refs[i], null);
            }
        };
    };
}
function $e9cf810736c515ab$export$c7b2cbe3552a0d05(...refs) {
    return $exYeM.useCallback($e9cf810736c515ab$export$43e446d32b3d21af(...refs), refs);
}



var $exYeM = parcelRequire("exYeM");
// packages/core/primitive/src/primitive.tsx
function $a4fe3a8b13ff8105$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}




// packages/react/id/src/id.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $exYeM = parcelRequire("exYeM");
var $e0163e4570a11fa2$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $exYeM.useLayoutEffect : ()=>{};


var $5fc74a6769622bdf$var$useReactId = $exYeM["useId".toString()] || (()=>void 0);
var $5fc74a6769622bdf$var$count = 0;
function $5fc74a6769622bdf$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $exYeM.useState($5fc74a6769622bdf$var$useReactId());
    (0, $e0163e4570a11fa2$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($5fc74a6769622bdf$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $exYeM = parcelRequire("exYeM");
function $9d3cfe8f3aeb4376$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $exYeM.useRef(callback);
    $exYeM.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $exYeM.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $615409bfee966182$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $615409bfee966182$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $9d3cfe8f3aeb4376$export$25bec8c6f54ee79a)(onChange);
    const setValue = $exYeM.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $615409bfee966182$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $exYeM.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $exYeM.useRef(value);
    const handleChange = (0, $9d3cfe8f3aeb4376$export$25bec8c6f54ee79a)(onChange);
    $exYeM.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $exYeM = parcelRequire("exYeM");

// packages/react/primitive/src/Primitive.tsx

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
// packages/react/slot/src/Slot.tsx

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");
var $9ad58a6a96319e14$export$8c6ed5c666ac1360 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $exYeM.Children.toArray(children);
    const slottable = childrenArray.find($9ad58a6a96319e14$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($exYeM.Children.count(newElement) > 1) return $exYeM.Children.only(null);
                return $exYeM.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $aSiaI.jsx)($9ad58a6a96319e14$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $exYeM.isValidElement(newElement) ? $exYeM.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $aSiaI.jsx)($9ad58a6a96319e14$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$9ad58a6a96319e14$export$8c6ed5c666ac1360.displayName = "Slot";
var $9ad58a6a96319e14$var$SlotClone = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($exYeM.isValidElement(children)) {
        const childrenRef = $9ad58a6a96319e14$var$getElementRef(children);
        return $exYeM.cloneElement(children, {
            ...$9ad58a6a96319e14$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $e9cf810736c515ab$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $exYeM.Children.count(children) > 1 ? $exYeM.Children.only(null) : null;
});
$9ad58a6a96319e14$var$SlotClone.displayName = "SlotClone";
var $9ad58a6a96319e14$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: children
    });
};
function $9ad58a6a96319e14$var$isSlottable(child) {
    return $exYeM.isValidElement(child) && child.type === $9ad58a6a96319e14$export$d9f1ccf0bdb05d45;
}
function $9ad58a6a96319e14$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $9ad58a6a96319e14$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $9ad58a6a96319e14$export$be92b6f5f03c0fe9 = $9ad58a6a96319e14$export$8c6ed5c666ac1360;



var $aSiaI = parcelRequire("aSiaI");
var $2999657902228a54$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $2999657902228a54$export$250ffa63cdc0d034 = $2999657902228a54$var$NODES.reduce((primitive, node)=>{
    const Node = $exYeM.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $9ad58a6a96319e14$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $aSiaI.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $2999657902228a54$export$6d1a0317bde7de7f(target, event) {
    if (target) $d2lNW.flushSync(()=>target.dispatchEvent(event));
}
var $2999657902228a54$export$be92b6f5f03c0fe9 = $2999657902228a54$export$250ffa63cdc0d034;




// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $exYeM = parcelRequire("exYeM");

function $33069e49d49c3359$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $9d3cfe8f3aeb4376$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $exYeM.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



var $aSiaI = parcelRequire("aSiaI");
"use client";
var $ee558423f8082794$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $ee558423f8082794$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $ee558423f8082794$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $ee558423f8082794$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $ee558423f8082794$var$originalBodyPointerEvents;
var $ee558423f8082794$var$DismissableLayerContext = $exYeM.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $ee558423f8082794$export$177fb62ff3ec1f22 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $exYeM.useContext($ee558423f8082794$var$DismissableLayerContext);
    const [node, setNode] = $exYeM.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $exYeM.useState({});
    const composedRefs = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $ee558423f8082794$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $ee558423f8082794$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $33069e49d49c3359$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $exYeM.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $ee558423f8082794$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $ee558423f8082794$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $ee558423f8082794$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $exYeM.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $ee558423f8082794$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $exYeM.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($ee558423f8082794$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($ee558423f8082794$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$ee558423f8082794$export$177fb62ff3ec1f22.displayName = $ee558423f8082794$var$DISMISSABLE_LAYER_NAME;
var $ee558423f8082794$var$BRANCH_NAME = "DismissableLayerBranch";
var $ee558423f8082794$export$4d5eb2109db14228 = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $exYeM.useContext($ee558423f8082794$var$DismissableLayerContext);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $exYeM.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$ee558423f8082794$export$4d5eb2109db14228.displayName = $ee558423f8082794$var$BRANCH_NAME;
function $ee558423f8082794$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $9d3cfe8f3aeb4376$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $exYeM.useRef(false);
    const handleClickRef = $exYeM.useRef(()=>{});
    $exYeM.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $ee558423f8082794$var$handleAndDispatchCustomEvent($ee558423f8082794$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $ee558423f8082794$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $9d3cfe8f3aeb4376$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $exYeM.useRef(false);
    $exYeM.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $ee558423f8082794$var$handleAndDispatchCustomEvent($ee558423f8082794$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $ee558423f8082794$var$dispatchUpdate() {
    const event = new CustomEvent($ee558423f8082794$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $ee558423f8082794$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $2999657902228a54$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $ee558423f8082794$export$be92b6f5f03c0fe9 = $ee558423f8082794$export$177fb62ff3ec1f22;
var $ee558423f8082794$export$aecb2ddcb55c95be = $ee558423f8082794$export$4d5eb2109db14228;



var $exYeM = parcelRequire("exYeM");




var $aSiaI = parcelRequire("aSiaI");
"use client";
var $4764697a532b486a$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $4764697a532b486a$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $4764697a532b486a$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $4764697a532b486a$var$FOCUS_SCOPE_NAME = "FocusScope";
var $4764697a532b486a$export$20e40289641fbbb6 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $exYeM.useState(null);
    const onMountAutoFocus = (0, $9d3cfe8f3aeb4376$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $9d3cfe8f3aeb4376$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $exYeM.useRef(null);
    const composedRefs = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $exYeM.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $exYeM.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $4764697a532b486a$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $4764697a532b486a$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $4764697a532b486a$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $exYeM.useEffect(()=>{
        if (container) {
            $4764697a532b486a$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($4764697a532b486a$var$AUTOFOCUS_ON_MOUNT, $4764697a532b486a$var$EVENT_OPTIONS);
                container.addEventListener($4764697a532b486a$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $4764697a532b486a$var$focusFirst($4764697a532b486a$var$removeLinks($4764697a532b486a$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $4764697a532b486a$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($4764697a532b486a$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($4764697a532b486a$var$AUTOFOCUS_ON_UNMOUNT, $4764697a532b486a$var$EVENT_OPTIONS);
                    container.addEventListener($4764697a532b486a$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $4764697a532b486a$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($4764697a532b486a$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $4764697a532b486a$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $exYeM.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $4764697a532b486a$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $4764697a532b486a$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $4764697a532b486a$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$4764697a532b486a$export$20e40289641fbbb6.displayName = $4764697a532b486a$var$FOCUS_SCOPE_NAME;
function $4764697a532b486a$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $4764697a532b486a$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $4764697a532b486a$var$getTabbableEdges(container) {
    const candidates = $4764697a532b486a$var$getTabbableCandidates(container);
    const first = $4764697a532b486a$var$findVisible(candidates, container);
    const last = $4764697a532b486a$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $4764697a532b486a$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $4764697a532b486a$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$4764697a532b486a$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $4764697a532b486a$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $4764697a532b486a$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $4764697a532b486a$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $4764697a532b486a$var$isSelectableInput(element) && select) element.select();
    }
}
var $4764697a532b486a$var$focusScopesStack = $4764697a532b486a$var$createFocusScopesStack();
function $4764697a532b486a$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $4764697a532b486a$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $4764697a532b486a$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $4764697a532b486a$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $4764697a532b486a$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $4764697a532b486a$export$be92b6f5f03c0fe9 = $4764697a532b486a$export$20e40289641fbbb6;



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");



var $aSiaI = parcelRequire("aSiaI");
"use client";
var $34d5e47ba566e930$var$PORTAL_NAME = "Portal";
var $34d5e47ba566e930$export$602eac185826482c = $exYeM.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $exYeM.useState(false);
    (0, $e0163e4570a11fa2$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(/* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$34d5e47ba566e930$export$602eac185826482c.displayName = $34d5e47ba566e930$var$PORTAL_NAME;
var $34d5e47ba566e930$export$be92b6f5f03c0fe9 = $34d5e47ba566e930$export$602eac185826482c;



var $exYeM = parcelRequire("exYeM");


"use client";
function $446ec781d7cad1de$var$useStateMachine(initialState, machine) {
    return $exYeM.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $446ec781d7cad1de$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $446ec781d7cad1de$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $exYeM.Children.only(children);
    const ref = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(presence.ref, $446ec781d7cad1de$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $exYeM.cloneElement(child, {
        ref: ref
    }) : null;
};
$446ec781d7cad1de$export$99c2b779aa4e8b8b.displayName = "Presence";
function $446ec781d7cad1de$var$usePresence(present) {
    const [node, setNode] = $exYeM.useState();
    const stylesRef = $exYeM.useRef({});
    const prevPresentRef = $exYeM.useRef(present);
    const prevAnimationNameRef = $exYeM.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $446ec781d7cad1de$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $exYeM.useEffect(()=>{
        const currentAnimationName = $446ec781d7cad1de$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $e0163e4570a11fa2$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $446ec781d7cad1de$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $e0163e4570a11fa2$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $446ec781d7cad1de$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $446ec781d7cad1de$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $exYeM.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $446ec781d7cad1de$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $446ec781d7cad1de$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $exYeM = parcelRequire("exYeM");
"use client";
var $df0baba16e5f53a6$var$count = 0;
function $df0baba16e5f53a6$export$ac5b58043b79449b(props) {
    $df0baba16e5f53a6$export$b7ece24a22aeda8c();
    return props.children;
}
function $df0baba16e5f53a6$export$b7ece24a22aeda8c() {
    $exYeM.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $df0baba16e5f53a6$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $df0baba16e5f53a6$var$createFocusGuard());
        $df0baba16e5f53a6$var$count++;
        return ()=>{
            if ($df0baba16e5f53a6$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $df0baba16e5f53a6$var$count--;
        };
    }, []);
}
function $df0baba16e5f53a6$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
var $df0baba16e5f53a6$export$be92b6f5f03c0fe9 = $df0baba16e5f53a6$export$ac5b58043b79449b;




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");



var $5eef20d3e2219e5f$export$e27363444bedfeac = (0, $f527f4cfb322b92a$export$e13ec7dd7a14088d)();


var $0645450b05fcde35$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $0645450b05fcde35$export$22940b497e769dee = $exYeM.forwardRef(function(props, parentRef) {
    var ref = $exYeM.useRef(null);
    var _a = $exYeM.useState({
        onScrollCapture: $0645450b05fcde35$var$nothing,
        onWheelCapture: $0645450b05fcde35$var$nothing,
        onTouchMoveCapture: $0645450b05fcde35$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d221d2c5d570aa1d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest), callbacks);
    return $exYeM.createElement($exYeM.Fragment, null, enabled && $exYeM.createElement(SideCar, {
        sideCar: (0, $5eef20d3e2219e5f$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $exYeM.cloneElement($exYeM.Children.only(children), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $exYeM.createElement(Container, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$0645450b05fcde35$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$0645450b05fcde35$export$22940b497e769dee.classNames = {
    fullWidth: (0, $a424de23c132f073$export$898e37bbd2a0ae4e),
    zeroRight: (0, $a424de23c132f073$export$1da7500147d4bc3)
};





var $exYeM = parcelRequire("exYeM");


var $441233915a714ca9$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $441233915a714ca9$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $441233915a714ca9$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $441233915a714ca9$var$options, $441233915a714ca9$var$options);
    // @ts-ignore
    window.removeEventListener("test", $441233915a714ca9$var$options, $441233915a714ca9$var$options);
} catch (err) {
    $441233915a714ca9$var$passiveSupported = false;
}
var $441233915a714ca9$export$10a6e88623fa9454 = $441233915a714ca9$var$passiveSupported ? {
    passive: false
} : false;


var $4e8de301dddaff8f$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $4e8de301dddaff8f$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$4e8de301dddaff8f$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $4e8de301dddaff8f$var$elementCouldBeVScrolled = function(node) {
    return $4e8de301dddaff8f$var$elementCanBeScrolled(node, "overflowY");
};
var $4e8de301dddaff8f$var$elementCouldBeHScrolled = function(node) {
    return $4e8de301dddaff8f$var$elementCanBeScrolled(node, "overflowX");
};
var $4e8de301dddaff8f$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $4e8de301dddaff8f$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $4e8de301dddaff8f$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $4e8de301dddaff8f$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $4e8de301dddaff8f$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $4e8de301dddaff8f$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $4e8de301dddaff8f$var$elementCouldBeVScrolled(node) : $4e8de301dddaff8f$var$elementCouldBeHScrolled(node);
};
var $4e8de301dddaff8f$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $4e8de301dddaff8f$var$getVScrollVariables(node) : $4e8de301dddaff8f$var$getHScrollVariables(node);
};
var $4e8de301dddaff8f$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $4e8de301dddaff8f$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $4e8de301dddaff8f$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $4e8de301dddaff8f$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($4e8de301dddaff8f$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $1d7c6e8bcad0cccd$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $1d7c6e8bcad0cccd$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $1d7c6e8bcad0cccd$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $1d7c6e8bcad0cccd$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $1d7c6e8bcad0cccd$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $1d7c6e8bcad0cccd$var$idCounter = 0;
var $1d7c6e8bcad0cccd$var$lockStack = [];
function $1d7c6e8bcad0cccd$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $exYeM.useRef([]);
    var touchStartRef = $exYeM.useRef([
        0,
        0
    ]);
    var activeAxis = $exYeM.useRef();
    var id = $exYeM.useState($1d7c6e8bcad0cccd$var$idCounter++)[0];
    var Style = $exYeM.useState((0, $3d3e09c66c873f3e$export$c1248ee86ba532c8))[0];
    var lastProps = $exYeM.useRef(props);
    $exYeM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $exYeM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($1d7c6e8bcad0cccd$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $exYeM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $1d7c6e8bcad0cccd$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $4e8de301dddaff8f$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $4e8de301dddaff8f$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $4e8de301dddaff8f$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $exYeM.useCallback(function(_event) {
        var event = _event;
        if (!$1d7c6e8bcad0cccd$var$lockStack.length || $1d7c6e8bcad0cccd$var$lockStack[$1d7c6e8bcad0cccd$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $1d7c6e8bcad0cccd$export$39efaa2ca254a28d(event) : $1d7c6e8bcad0cccd$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $1d7c6e8bcad0cccd$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($1d7c6e8bcad0cccd$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $exYeM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $1d7c6e8bcad0cccd$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $exYeM.useCallback(function(event) {
        touchStartRef.current = $1d7c6e8bcad0cccd$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $1d7c6e8bcad0cccd$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $1d7c6e8bcad0cccd$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $exYeM.useEffect(function() {
        $1d7c6e8bcad0cccd$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $441233915a714ca9$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $441233915a714ca9$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $441233915a714ca9$export$10a6e88623fa9454));
        return function() {
            $1d7c6e8bcad0cccd$var$lockStack = $1d7c6e8bcad0cccd$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $441233915a714ca9$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $441233915a714ca9$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $441233915a714ca9$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $exYeM.createElement($exYeM.Fragment, null, inert ? $exYeM.createElement(Style, {
        styles: $1d7c6e8bcad0cccd$var$generateStyle(id)
    }) : null, removeScrollBar ? $exYeM.createElement((0, $b8129a946e86d087$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $1d7c6e8bcad0cccd$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $2bddd020d3695142$export$2e2bcd8739ae039 = (0, $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce)((0, $5eef20d3e2219e5f$export$e27363444bedfeac), (0, $1d7c6e8bcad0cccd$export$a09dbff87b5da2d));


var $1b56f170688f7166$var$ReactRemoveScroll = $exYeM.forwardRef(function(props, ref) {
    return $exYeM.createElement((0, $0645450b05fcde35$export$22940b497e769dee), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $2bddd020d3695142$export$2e2bcd8739ae039)
    }));
});
$1b56f170688f7166$var$ReactRemoveScroll.classNames = (0, $0645450b05fcde35$export$22940b497e769dee).classNames;
var $1b56f170688f7166$export$2e2bcd8739ae039 = $1b56f170688f7166$var$ReactRemoveScroll;





var $aSiaI = parcelRequire("aSiaI");
"use client";
var $bf9bf5c252013668$var$DIALOG_NAME = "Dialog";
var [$bf9bf5c252013668$var$createDialogContext, $bf9bf5c252013668$export$cc702773b8ea3e41] = (0, $5c8fd24e0d275553$export$50c7b4e9d9f19c1)($bf9bf5c252013668$var$DIALOG_NAME);
var [$bf9bf5c252013668$var$DialogProvider, $bf9bf5c252013668$var$useDialogContext] = $bf9bf5c252013668$var$createDialogContext($bf9bf5c252013668$var$DIALOG_NAME);
var $bf9bf5c252013668$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $exYeM.useRef(null);
    const contentRef = $exYeM.useRef(null);
    const [open = false, setOpen] = (0, $615409bfee966182$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $5fc74a6769622bdf$export$f680877a34711e37)(),
        titleId: (0, $5fc74a6769622bdf$export$f680877a34711e37)(),
        descriptionId: (0, $5fc74a6769622bdf$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $exYeM.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$bf9bf5c252013668$export$3ddf2d174ce01153.displayName = $bf9bf5c252013668$var$DIALOG_NAME;
var $bf9bf5c252013668$var$TRIGGER_NAME = "DialogTrigger";
var $bf9bf5c252013668$export$2e1e1122cf0cba88 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $bf9bf5c252013668$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$bf9bf5c252013668$export$2e1e1122cf0cba88.displayName = $bf9bf5c252013668$var$TRIGGER_NAME;
var $bf9bf5c252013668$var$PORTAL_NAME = "DialogPortal";
var [$bf9bf5c252013668$var$PortalProvider, $bf9bf5c252013668$var$usePortalContext] = $bf9bf5c252013668$var$createDialogContext($bf9bf5c252013668$var$PORTAL_NAME, {
    forceMount: void 0
});
var $bf9bf5c252013668$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $exYeM.Children.map(children, (child)=>/* @__PURE__ */ (0, $aSiaI.jsx)((0, $446ec781d7cad1de$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $34d5e47ba566e930$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$bf9bf5c252013668$export$dad7c95542bacce0.displayName = $bf9bf5c252013668$var$PORTAL_NAME;
var $bf9bf5c252013668$var$OVERLAY_NAME = "DialogOverlay";
var $bf9bf5c252013668$export$bd1d06c79be19e17 = $exYeM.forwardRef((props, forwardedRef)=>{
    const portalContext = $bf9bf5c252013668$var$usePortalContext($bf9bf5c252013668$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $aSiaI.jsx)((0, $446ec781d7cad1de$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$bf9bf5c252013668$export$bd1d06c79be19e17.displayName = $bf9bf5c252013668$var$OVERLAY_NAME;
var $bf9bf5c252013668$var$DialogOverlayImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $aSiaI.jsx)((0, $1b56f170688f7166$export$2e2bcd8739ae039), {
        as: (0, $9ad58a6a96319e14$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).div, {
            "data-state": $bf9bf5c252013668$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $bf9bf5c252013668$var$CONTENT_NAME = "DialogContent";
var $bf9bf5c252013668$export$b6d9565de1e068cf = $exYeM.forwardRef((props, forwardedRef)=>{
    const portalContext = $bf9bf5c252013668$var$usePortalContext($bf9bf5c252013668$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $446ec781d7cad1de$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$bf9bf5c252013668$export$b6d9565de1e068cf.displayName = $bf9bf5c252013668$var$CONTENT_NAME;
var $bf9bf5c252013668$var$DialogContentModal = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $exYeM.useRef(null);
    const composedRefs = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $exYeM.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $bf9bf5c252013668$var$DialogContentNonModal = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $exYeM.useRef(false);
    const hasPointerDownOutsideRef = $exYeM.useRef(false);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $bf9bf5c252013668$var$DialogContentImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $exYeM.useRef(null);
    const composedRefs = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $df0baba16e5f53a6$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /* @__PURE__ */ (0, $aSiaI.jsx)((0, $4764697a532b486a$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $ee558423f8082794$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $bf9bf5c252013668$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $bf9bf5c252013668$var$TITLE_NAME = "DialogTitle";
var $bf9bf5c252013668$export$16f7638e4a34b909 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$bf9bf5c252013668$export$16f7638e4a34b909.displayName = $bf9bf5c252013668$var$TITLE_NAME;
var $bf9bf5c252013668$var$DESCRIPTION_NAME = "DialogDescription";
var $bf9bf5c252013668$export$94e94c2ec2c954d5 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$bf9bf5c252013668$export$94e94c2ec2c954d5.displayName = $bf9bf5c252013668$var$DESCRIPTION_NAME;
var $bf9bf5c252013668$var$CLOSE_NAME = "DialogClose";
var $bf9bf5c252013668$export$fba2fb7cd781b7ac = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $bf9bf5c252013668$var$useDialogContext($bf9bf5c252013668$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2999657902228a54$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$bf9bf5c252013668$export$fba2fb7cd781b7ac.displayName = $bf9bf5c252013668$var$CLOSE_NAME;
function $bf9bf5c252013668$var$getState(open) {
    return open ? "open" : "closed";
}
var $bf9bf5c252013668$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$bf9bf5c252013668$export$69b62a49393917d6, $bf9bf5c252013668$var$useWarningContext] = (0, $5c8fd24e0d275553$export$fd42f52fd3ae1109)($bf9bf5c252013668$var$TITLE_WARNING_NAME, {
    contentName: $bf9bf5c252013668$var$CONTENT_NAME,
    titleName: $bf9bf5c252013668$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $bf9bf5c252013668$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $bf9bf5c252013668$var$useWarningContext($bf9bf5c252013668$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $exYeM.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $bf9bf5c252013668$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $bf9bf5c252013668$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $bf9bf5c252013668$var$useWarningContext($bf9bf5c252013668$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $exYeM.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $bf9bf5c252013668$export$be92b6f5f03c0fe9 = $bf9bf5c252013668$export$3ddf2d174ce01153;
var $bf9bf5c252013668$export$41fb9f06171c75f4 = $bf9bf5c252013668$export$2e1e1122cf0cba88;
var $bf9bf5c252013668$export$602eac185826482c = $bf9bf5c252013668$export$dad7c95542bacce0;
var $bf9bf5c252013668$export$c6fdb837b070b4ff = $bf9bf5c252013668$export$bd1d06c79be19e17;
var $bf9bf5c252013668$export$7c6e2c02157bb7d2 = $bf9bf5c252013668$export$b6d9565de1e068cf;
var $bf9bf5c252013668$export$f99233281efd08a0 = $bf9bf5c252013668$export$16f7638e4a34b909;
var $bf9bf5c252013668$export$393edc798c47379d = $bf9bf5c252013668$export$94e94c2ec2c954d5;
var $bf9bf5c252013668$export$f39c2d165cd861fe = $bf9bf5c252013668$export$fba2fb7cd781b7ac;





var $aSiaI = parcelRequire("aSiaI");
"use client";
var $6487017786257a53$var$ROOT_NAME = "AlertDialog";
var [$6487017786257a53$var$createAlertDialogContext, $6487017786257a53$export$b8891880751c2c5b] = (0, $5c8fd24e0d275553$export$50c7b4e9d9f19c1)($6487017786257a53$var$ROOT_NAME, [
    (0, $bf9bf5c252013668$export$cc702773b8ea3e41)
]);
var $6487017786257a53$var$useDialogScope = (0, $bf9bf5c252013668$export$cc702773b8ea3e41)();
var $6487017786257a53$export$de466dd8317b0b75 = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...alertDialogProps } = props;
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$be92b6f5f03c0fe9, {
        ...dialogScope,
        ...alertDialogProps,
        modal: true
    });
};
$6487017786257a53$export$de466dd8317b0b75.displayName = $6487017786257a53$var$ROOT_NAME;
var $6487017786257a53$var$TRIGGER_NAME = "AlertDialogTrigger";
var $6487017786257a53$export$6edd7a623ef0f40b = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...triggerProps } = props;
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$41fb9f06171c75f4, {
        ...dialogScope,
        ...triggerProps,
        ref: forwardedRef
    });
});
$6487017786257a53$export$6edd7a623ef0f40b.displayName = $6487017786257a53$var$TRIGGER_NAME;
var $6487017786257a53$var$PORTAL_NAME = "AlertDialogPortal";
var $6487017786257a53$export$660f2bfdb986706c = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...portalProps } = props;
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$602eac185826482c, {
        ...dialogScope,
        ...portalProps
    });
};
$6487017786257a53$export$660f2bfdb986706c.displayName = $6487017786257a53$var$PORTAL_NAME;
var $6487017786257a53$var$OVERLAY_NAME = "AlertDialogOverlay";
var $6487017786257a53$export$a707a4895ce23256 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...overlayProps } = props;
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$c6fdb837b070b4ff, {
        ...dialogScope,
        ...overlayProps,
        ref: forwardedRef
    });
});
$6487017786257a53$export$a707a4895ce23256.displayName = $6487017786257a53$var$OVERLAY_NAME;
var $6487017786257a53$var$CONTENT_NAME = "AlertDialogContent";
var [$6487017786257a53$var$AlertDialogContentProvider, $6487017786257a53$var$useAlertDialogContentContext] = $6487017786257a53$var$createAlertDialogContext($6487017786257a53$var$CONTENT_NAME);
var $6487017786257a53$export$94e6af45f0af4efd = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, children: children, ...contentProps } = props;
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    const contentRef = $exYeM.useRef(null);
    const composedRefs = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const cancelRef = $exYeM.useRef(null);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$69b62a49393917d6, {
        contentName: $6487017786257a53$var$CONTENT_NAME,
        titleName: $6487017786257a53$var$TITLE_NAME,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($6487017786257a53$var$AlertDialogContentProvider, {
            scope: __scopeAlertDialog,
            cancelRef: cancelRef,
            children: /* @__PURE__ */ (0, $aSiaI.jsxs)($bf9bf5c252013668$export$7c6e2c02157bb7d2, {
                role: "alertdialog",
                ...dialogScope,
                ...contentProps,
                ref: composedRefs,
                onOpenAutoFocus: (0, $a4fe3a8b13ff8105$export$b9ecd428b558ff10)(contentProps.onOpenAutoFocus, (event)=>{
                    event.preventDefault();
                    cancelRef.current?.focus({
                        preventScroll: true
                    });
                }),
                onPointerDownOutside: (event)=>event.preventDefault(),
                onInteractOutside: (event)=>event.preventDefault(),
                children: [
                    /* @__PURE__ */ (0, $aSiaI.jsx)((0, $9ad58a6a96319e14$export$d9f1ccf0bdb05d45), {
                        children: children
                    }),
                    /* @__PURE__ */ (0, $aSiaI.jsx)($6487017786257a53$var$DescriptionWarning, {
                        contentRef: contentRef
                    })
                ]
            })
        })
    });
});
$6487017786257a53$export$94e6af45f0af4efd.displayName = $6487017786257a53$var$CONTENT_NAME;
var $6487017786257a53$var$TITLE_NAME = "AlertDialogTitle";
var $6487017786257a53$export$225e0da62d314b7 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...titleProps } = props;
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$f99233281efd08a0, {
        ...dialogScope,
        ...titleProps,
        ref: forwardedRef
    });
});
$6487017786257a53$export$225e0da62d314b7.displayName = $6487017786257a53$var$TITLE_NAME;
var $6487017786257a53$var$DESCRIPTION_NAME = "AlertDialogDescription";
var $6487017786257a53$export$a23b55cde55ad9a5 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...descriptionProps } = props;
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$393edc798c47379d, {
        ...dialogScope,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$6487017786257a53$export$a23b55cde55ad9a5.displayName = $6487017786257a53$var$DESCRIPTION_NAME;
var $6487017786257a53$var$ACTION_NAME = "AlertDialogAction";
var $6487017786257a53$export$b454f818c58ee85d = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...actionProps } = props;
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$f39c2d165cd861fe, {
        ...dialogScope,
        ...actionProps,
        ref: forwardedRef
    });
});
$6487017786257a53$export$b454f818c58ee85d.displayName = $6487017786257a53$var$ACTION_NAME;
var $6487017786257a53$var$CANCEL_NAME = "AlertDialogCancel";
var $6487017786257a53$export$2f67a923571aaea0 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...cancelProps } = props;
    const { cancelRef: cancelRef } = $6487017786257a53$var$useAlertDialogContentContext($6487017786257a53$var$CANCEL_NAME, __scopeAlertDialog);
    const dialogScope = $6487017786257a53$var$useDialogScope(__scopeAlertDialog);
    const ref = (0, $e9cf810736c515ab$export$c7b2cbe3552a0d05)(forwardedRef, cancelRef);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($bf9bf5c252013668$export$f39c2d165cd861fe, {
        ...dialogScope,
        ...cancelProps,
        ref: ref
    });
});
$6487017786257a53$export$2f67a923571aaea0.displayName = $6487017786257a53$var$CANCEL_NAME;
var $6487017786257a53$var$DescriptionWarning = ({ contentRef: contentRef })=>{
    const MESSAGE = `\`${$6487017786257a53$var$CONTENT_NAME}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${$6487017786257a53$var$CONTENT_NAME}\` by passing a \`${$6487017786257a53$var$DESCRIPTION_NAME}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${$6487017786257a53$var$CONTENT_NAME}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
    $exYeM.useEffect(()=>{
        const hasDescription = document.getElementById(contentRef.current?.getAttribute("aria-describedby"));
        if (!hasDescription) console.warn(MESSAGE);
    }, [
        MESSAGE,
        contentRef
    ]);
    return null;
};
var $6487017786257a53$export$be92b6f5f03c0fe9 = $6487017786257a53$export$de466dd8317b0b75;
var $6487017786257a53$export$41fb9f06171c75f4 = $6487017786257a53$export$6edd7a623ef0f40b;
var $6487017786257a53$export$602eac185826482c = $6487017786257a53$export$660f2bfdb986706c;
var $6487017786257a53$export$c6fdb837b070b4ff = $6487017786257a53$export$a707a4895ce23256;
var $6487017786257a53$export$7c6e2c02157bb7d2 = $6487017786257a53$export$94e6af45f0af4efd;
var $6487017786257a53$export$e19cd5f9376f8cee = $6487017786257a53$export$b454f818c58ee85d;
var $6487017786257a53$export$848c9b7ead0df967 = $6487017786257a53$export$2f67a923571aaea0;
var $6487017786257a53$export$f99233281efd08a0 = $6487017786257a53$export$225e0da62d314b7;
var $6487017786257a53$export$393edc798c47379d = $6487017786257a53$export$a23b55cde55ad9a5;




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



const $58c1ab0b1207e5ce$export$dca1ee5a936bb312 = (0, $f6c488ee7ea67d84$export$87dc52566e90b739)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
            outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "h-9 w-9"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $58c1ab0b1207e5ce$export$353f5b6fc5456de1 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : "button";
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Comp, {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)($58c1ab0b1207e5ce$export$dca1ee5a936bb312({
            variant: variant,
            size: size,
            className: className
        })),
        ref: ref,
        ...props
    });
});
$58c1ab0b1207e5ce$export$353f5b6fc5456de1.displayName = "Button";


const $753c47cad29074a6$export$de466dd8317b0b75 = $6487017786257a53$export$be92b6f5f03c0fe9;
const $753c47cad29074a6$export$6edd7a623ef0f40b = $6487017786257a53$export$41fb9f06171c75f4;
const $753c47cad29074a6$export$660f2bfdb986706c = $6487017786257a53$export$602eac185826482c;
const $753c47cad29074a6$export$a707a4895ce23256 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($6487017786257a53$export$c6fdb837b070b4ff, {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props,
        ref: ref
    }));
$753c47cad29074a6$export$a707a4895ce23256.displayName = $6487017786257a53$export$c6fdb837b070b4ff.displayName;
const $753c47cad29074a6$export$94e6af45f0af4efd = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)($753c47cad29074a6$export$660f2bfdb986706c, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($753c47cad29074a6$export$a707a4895ce23256, {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)($6487017786257a53$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg", className),
                ...props
            })
        ]
    }));
$753c47cad29074a6$export$94e6af45f0af4efd.displayName = $6487017786257a53$export$7c6e2c02157bb7d2.displayName;
const $753c47cad29074a6$export$c9359e10414c2de7 = ({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
$753c47cad29074a6$export$c9359e10414c2de7.displayName = "AlertDialogHeader";
const $753c47cad29074a6$export$691560c8793e1baf = ({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
$753c47cad29074a6$export$691560c8793e1baf.displayName = "AlertDialogFooter";
const $753c47cad29074a6$export$225e0da62d314b7 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($6487017786257a53$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("text-lg font-semibold", className),
        ...props
    }));
$753c47cad29074a6$export$225e0da62d314b7.displayName = $6487017786257a53$export$f99233281efd08a0.displayName;
const $753c47cad29074a6$export$a23b55cde55ad9a5 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($6487017786257a53$export$393edc798c47379d, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("text-sm text-muted-foreground", className),
        ...props
    }));
$753c47cad29074a6$export$a23b55cde55ad9a5.displayName = $6487017786257a53$export$393edc798c47379d.displayName;
const $753c47cad29074a6$export$b454f818c58ee85d = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($6487017786257a53$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)((0, $58c1ab0b1207e5ce$export$dca1ee5a936bb312)(), className),
        ...props
    }));
$753c47cad29074a6$export$b454f818c58ee85d.displayName = $6487017786257a53$export$e19cd5f9376f8cee.displayName;
const $753c47cad29074a6$export$2f67a923571aaea0 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($6487017786257a53$export$848c9b7ead0df967, {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)((0, $58c1ab0b1207e5ce$export$dca1ee5a936bb312)({
            variant: "outline"
        }), "mt-2 sm:mt-0", className),
        ...props
    }));
$753c47cad29074a6$export$2f67a923571aaea0.displayName = $6487017786257a53$export$848c9b7ead0df967.displayName;



const $d23de570471ea3b6$var$DashboardCard = ({ dashboard: dashboard, onDelete: onDelete, showDelete: showDelete = false })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
        className: "p-6 hover:border-primary transition-colors relative h-full flex flex-col",
        children: [
            showDelete && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$de466dd8317b0b75), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$6edd7a623ef0f40b), {
                        asChild: true,
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                            variant: "icon",
                            className: "absolute top-2 right-2 p-0 rounded-full bg-gray-50 hover:bg-red-100 group hover:text-red-500 border border-gray-200 transition-colors",
                            onClick: (e)=>e.stopPropagation(),
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5710fed419a1c745$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 text-gray-500 group-hover:text-red-500 transition-colors"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$94e6af45f0af4efd), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$c9359e10414c2de7), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$225e0da62d314b7), {
                                        children: "Delete Dashboard"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$a23b55cde55ad9a5), {
                                        children: [
                                            'Are you sure you want to delete "',
                                            dashboard.dashboardName,
                                            '"? This action cannot be undone.'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$691560c8793e1baf), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$2f67a923571aaea0), {
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$b454f818c58ee85d), {
                                        className: "bg-red-500 hover:bg-red-600",
                                        onClick: (e)=>onDelete(e, dashboard.uniqueCode),
                                        children: "Delete"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center gap-3 mb-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $25f5a724572c1301$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 text-primary flex-shrink-0"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: "text-lg font-semibold truncate",
                        children: dashboard.dashboardName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "space-y-3 text-sm text-gray-500 flex-grow",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $befd515fba4f9ccb$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                children: [
                                    dashboard.likes || 0,
                                    " likes"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        children: [
                            "Last accessed:",
                            " ",
                            new Date(dashboard.dateLastAccessed).toLocaleDateString()
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                children: [
                                    dashboard.items.length,
                                    " widgets"
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: "\u2022"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: dashboard.isPublic ? "Public" : "Private"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $d23de570471ea3b6$var$DashboardSection = ({ dashboards: dashboards, isLoading: isLoading, error: error, onDashboardSelect: onDashboardSelect, onDelete: onDelete, showDelete: showDelete = false, twoColumns: twoColumns = false })=>{
    if (error) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "text-destructive text-center py-4",
        children: [
            "Error loading dashboards: ",
            error.message
        ]
    });
    if (isLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex items-center justify-center py-8",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11645006cc3cfacf$export$2e2bcd8739ae039), {
            className: "h-6 w-6 animate-spin text-primary"
        })
    });
    if (!dashboards?.length) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "text-muted-foreground text-center py-4",
        children: "No dashboards found"
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: `grid ${twoColumns ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1"} gap-4 p-4`,
        children: dashboards.map((dashboard)=>/*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                onClick: ()=>onDashboardSelect(dashboard),
                className: "w-full text-left",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($d23de570471ea3b6$var$DashboardCard, {
                    dashboard: dashboard,
                    onDelete: onDelete,
                    showDelete: showDelete
                })
            }, dashboard.uniqueCode))
    });
};
const $d23de570471ea3b6$var$DashboardList = ()=>{
    const { onDashboardSelect: onDashboardSelect } = (0, $b0e6fcd50b7ef685$export$4138103a3ae699cc)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const isLoggedIn = (0, $8e62f87e86da6465$export$83d11f23a23d4a7c)();
    const { data: myDashboards, isLoading: isLoadingMy, error: errorMy } = (0, $ff0220da39bef700$export$fa981df62a27e077)();
    const { data: likedDashboards, isLoading: isLoadingLiked } = (0, $ff0220da39bef700$export$df99d7118e12b0cd)();
    const { data: popularDashboards, isLoading: isLoadingPopular, error: errorPopular } = (0, $ff0220da39bef700$export$2d273df6c4804eb7)();
    const { mutate: deleteDashboard } = (0, $ff0220da39bef700$export$c589e4b2fa9a0ef9)({
        onSuccess: ()=>{
            toast({
                variant: "successV2",
                title: "Dashboard deleted successfully"
            });
        }
    });
    const handleDelete = (e, uniqueCode)=>{
        e.stopPropagation();
        deleteDashboard(uniqueCode);
    };
    if (!isLoggedIn) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "container mx-auto p-8",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-col items-center justify-center space-y-4 text-center mb-8",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                        className: "text-3xl font-bold",
                        children: "Welcome to Dashboards"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "text-lg text-gray-600 max-w-md",
                        children: "Create and manage your own custom dashboards. Please log in to get started."
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                        onClick: ()=>navigate("/signin"),
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9ef383e6886bf5bb$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 mr-2"
                            }),
                            "Log In to Continue"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "p-4 border-b",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                            className: "text-xl font-semibold flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b1e81a97a7528e4e$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-primary"
                                }),
                                "Popular Dashboards"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($d23de570471ea3b6$var$DashboardSection, {
                        dashboards: popularDashboards?.data,
                        isLoading: isLoadingPopular,
                        error: errorPopular,
                        onDashboardSelect: onDashboardSelect
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "container mx-auto p-8",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex justify-between items-center mb-4 pb-4 border-b",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                        className: "text-3xl font-bold",
                        children: "Dashboards"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                        onClick: ()=>onDashboardSelect(null),
                        className: "gap-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c9aeb97d6992a735$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            }),
                            "New Dashboard"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid md:grid-cols-2 gap-8",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                                className: "text-xl font-semibold flex items-center gap-2 px-2 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $befd515fba4f9ccb$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-primary"
                                    }),
                                    "Liked Dashboards"
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $79eee5cb5c9efd6c$export$ccf8d8d7bbf3c2cc), {
                                className: "h-[350px]",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($d23de570471ea3b6$var$DashboardSection, {
                                    dashboards: likedDashboards?.data,
                                    isLoading: isLoadingLiked,
                                    onDashboardSelect: onDashboardSelect
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "md:pl-8 border-l",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                                className: "text-xl font-semibold flex items-center gap-2 px-2 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b1e81a97a7528e4e$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-primary"
                                    }),
                                    "Popular Dashboards"
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $79eee5cb5c9efd6c$export$ccf8d8d7bbf3c2cc), {
                                className: "h-[350px]",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)($d23de570471ea3b6$var$DashboardSection, {
                                    dashboards: popularDashboards?.data,
                                    isLoading: isLoadingPopular,
                                    error: errorPopular,
                                    onDashboardSelect: onDashboardSelect
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "border-b my-8"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                        className: "text-xl font-semibold flex items-center gap-2 px-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $25f5a724572c1301$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-primary"
                            }),
                            "My Dashboards"
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($d23de570471ea3b6$var$DashboardSection, {
                        dashboards: myDashboards?.data,
                        isLoading: isLoadingMy,
                        error: errorMy,
                        onDashboardSelect: onDashboardSelect,
                        onDelete: handleDelete,
                        showDelete: true,
                        twoColumns: true
                    })
                ]
            })
        ]
    });
};
var $d23de570471ea3b6$export$2e2bcd8739ae039 = $d23de570471ea3b6$var$DashboardList;


/* eslint-disable react/no-unescaped-entities */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7c3b0b1367696494$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Earth", [
    [
        "path",
        {
            d: "M21.54 15H17a2 2 0 0 0-2 2v4.54",
            key: "1djwo0"
        }
    ],
    [
        "path",
        {
            d: "M7 3.34V5a3 3 0 0 0 3 3v0a2 2 0 0 1 2 2v0c0 1.1.9 2 2 2v0a2 2 0 0 0 2-2v0c0-1.1.9-2 2-2h3.17",
            key: "1fi5u6"
        }
    ],
    [
        "path",
        {
            d: "M11 21.95V18a2 2 0 0 0-2-2v0a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05",
            key: "xsiumc"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f23364bb7ce99c8b$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Lock", [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
]);







var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");
var $5d0c4451c391a908$exports = {};

$5d0c4451c391a908$exports = (parcelRequire("4MAdt")).default;

$5d0c4451c391a908$exports.utils = (parcelRequire("koqIv"));

$5d0c4451c391a908$exports.calculateUtils = (parcelRequire("01ySn"));

$5d0c4451c391a908$exports.Responsive = (parcelRequire("NhNjE")).default;

$5d0c4451c391a908$exports.Responsive.utils = (parcelRequire("jCBCS"));

$5d0c4451c391a908$exports.WidthProvider = (parcelRequire("7Fvrs")).default;




/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $55affc78df8683a3$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("CirclePlus", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M8 12h8",
            key: "1wcyev"
        }
    ],
    [
        "path",
        {
            d: "M12 8v8",
            key: "napkw2"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d419906ca7ecb216$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Save", [
    [
        "path",
        {
            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
            key: "1c8476"
        }
    ],
    [
        "path",
        {
            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
            key: "1ydtos"
        }
    ],
    [
        "path",
        {
            d: "M7 3v4a1 1 0 0 0 1 1h7",
            key: "t51u73"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0b58934760e74240$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("LockOpen", [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 9.9-1",
            key: "1mm8w8"
        }
    ]
]);




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4784571a21b839d8$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("GripHorizontal", [
    [
        "circle",
        {
            cx: "12",
            cy: "9",
            r: "1",
            key: "124mty"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "9",
            r: "1",
            key: "1ruzo2"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "9",
            r: "1",
            key: "1a8b28"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "15",
            r: "1",
            key: "1e56xg"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "15",
            r: "1",
            key: "1a92ep"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "15",
            r: "1",
            key: "5r1jwy"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2f25cd8b3864be90$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Pencil", [
    [
        "path",
        {
            d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z",
            key: "5qss01"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
]);





const $78bf72408c10d2b9$var$WidgetContent = ({ el: el, item: item, showEditControls: showEditControls, isEditing: isEditing, onEdit: onEdit, onDelete: onDelete, children: children })=>{
    const [titleValue, setTitleValue] = (0, $exYeM.useState)(item?.title || `${item?.type} Widget`);
    const updateWidgetTitle = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.updateWidgetTitle);
    (0, $exYeM.useEffect)(()=>{
        setTitleValue(item?.title || `${item?.type} Widget`);
    }, [
        item?.title,
        item?.type
    ]);
    const handleTitleUpdate = ()=>{
        updateWidgetTitle(item.i, titleValue);
    };
    // Determine if we should show the header based on:
    // 1. Whether we're in a dashboard (item exists)
    // 2. The widget type and edit state
    const showHeader = !item || (item?.type !== "Text" ? isEditing || showEditControls : isEditing && showEditControls);
    // Determine if we should show the title
    const showTitle = item?.type !== "Text";
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0ac17ca2995b452$export$60332b2344f7fe41), {
        className: "h-full w-full z-0 p-2 flex flex-col",
        children: [
            showHeader && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "h-10 flex w-full items-center px-2 gap-2 py-2",
                children: [
                    showEditControls && isEditing && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                        variant: "outline",
                        size: "icon",
                        onClick: ()=>{
                            onEdit?.(el.i, item);
                        },
                        className: "p-2 border-primaryContainer group hover:bg-primary transition-colors shadow-none",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2f25cd8b3864be90$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-onSurfaceVariant group-hover:text-white"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex-1 flex justify-center items-center gap-2 react-grid-dragHandleExample", isEditing && showEditControls ? "cursor-grab active:cursor-grabbing" : ""),
                        children: [
                            isEditing && showEditControls && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4784571a21b839d8$export$2e2bcd8739ae039), {
                                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-5 w-5 text-gray-400 react-grid-dragHandleExample", isEditing && showEditControls ? "cursor-grab active:cursor-grabbing" : "")
                            }),
                            showTitle && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("flex items-center justify-center react-grid-dragHandleExample px-4", isEditing && showEditControls ? "cursor-grab active:cursor-grabbing" : ""),
                                children: isEditing && showEditControls ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0bdc6a2cae10298$export$f5b8910cec6cf069), {
                                    value: titleValue,
                                    onChange: (e)=>{
                                        setTitleValue(e.target.value);
                                        handleTitleUpdate();
                                    },
                                    onBlur: handleTitleUpdate,
                                    className: "text-sm w-48 text-center"
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "text-sm font-medium truncate text-center",
                                    children: item?.title || `${item?.type} Widget`
                                })
                            }),
                            isEditing && showEditControls && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4784571a21b839d8$export$2e2bcd8739ae039), {
                                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-5 w-5 text-gray-400 react-grid-dragHandleExample", isEditing && showEditControls ? "cursor-grab active:cursor-grabbing" : "")
                            })
                        ]
                    }),
                    showEditControls && isEditing && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                        variant: "outline",
                        size: "icon",
                        onClick: ()=>onDelete(el.i),
                        className: "p-2 border-primaryContainer group hover:bg-red-100 hover:text-red-500 transition-colors shadow-none",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5710fed419a1c745$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-onSurfaceVariant group-hover:text-red-500"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("w-full bg-white flex-1 min-h-0"),
                children: children
            })
        ]
    }, el.i);
};
var $78bf72408c10d2b9$export$2e2bcd8739ae039 = $78bf72408c10d2b9$var$WidgetContent;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
// packages/core/primitive/src/primitive.tsx
function $5bfef79223bc0839$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $exYeM = parcelRequire("exYeM");
function $9ad84348d470d517$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $9ad84348d470d517$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $9ad84348d470d517$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $9ad84348d470d517$var$setRef(refs[i], null);
            }
        };
    };
}
function $9ad84348d470d517$export$c7b2cbe3552a0d05(...refs) {
    return $exYeM.useCallback($9ad84348d470d517$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
function $e06dae5b45586ba5$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $exYeM.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $exYeM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $aSiaI.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $exYeM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $e06dae5b45586ba5$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $exYeM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $exYeM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $aSiaI.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $exYeM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $exYeM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $exYeM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $e06dae5b45586ba5$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $e06dae5b45586ba5$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $exYeM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



var $exYeM = parcelRequire("exYeM");

// packages/react/primitive/src/Primitive.tsx

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
// packages/react/slot/src/Slot.tsx

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");
var $35c00cadf85c33a2$export$8c6ed5c666ac1360 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $exYeM.Children.toArray(children);
    const slottable = childrenArray.find($35c00cadf85c33a2$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($exYeM.Children.count(newElement) > 1) return $exYeM.Children.only(null);
                return $exYeM.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $aSiaI.jsx)($35c00cadf85c33a2$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $exYeM.isValidElement(newElement) ? $exYeM.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $aSiaI.jsx)($35c00cadf85c33a2$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$35c00cadf85c33a2$export$8c6ed5c666ac1360.displayName = "Slot";
var $35c00cadf85c33a2$var$SlotClone = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($exYeM.isValidElement(children)) {
        const childrenRef = $35c00cadf85c33a2$var$getElementRef(children);
        return $exYeM.cloneElement(children, {
            ...$35c00cadf85c33a2$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $9ad84348d470d517$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $exYeM.Children.count(children) > 1 ? $exYeM.Children.only(null) : null;
});
$35c00cadf85c33a2$var$SlotClone.displayName = "SlotClone";
var $35c00cadf85c33a2$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: children
    });
};
function $35c00cadf85c33a2$var$isSlottable(child) {
    return $exYeM.isValidElement(child) && child.type === $35c00cadf85c33a2$export$d9f1ccf0bdb05d45;
}
function $35c00cadf85c33a2$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $35c00cadf85c33a2$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $35c00cadf85c33a2$export$be92b6f5f03c0fe9 = $35c00cadf85c33a2$export$8c6ed5c666ac1360;



var $aSiaI = parcelRequire("aSiaI");
var $914ca9847cccd1b1$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $914ca9847cccd1b1$export$250ffa63cdc0d034 = $914ca9847cccd1b1$var$NODES.reduce((primitive, node)=>{
    const Node = $exYeM.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $35c00cadf85c33a2$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $aSiaI.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $914ca9847cccd1b1$export$6d1a0317bde7de7f(target, event) {
    if (target) $d2lNW.flushSync(()=>target.dispatchEvent(event));
}
var $914ca9847cccd1b1$export$be92b6f5f03c0fe9 = $914ca9847cccd1b1$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $exYeM = parcelRequire("exYeM");
function $134adfcd2273817d$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $exYeM.useRef(callback);
    $exYeM.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $exYeM.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $exYeM = parcelRequire("exYeM");

function $00ba34117b837688$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $134adfcd2273817d$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $exYeM.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



var $aSiaI = parcelRequire("aSiaI");
"use client";
var $2fd1c67c28f0a1ae$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $2fd1c67c28f0a1ae$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $2fd1c67c28f0a1ae$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $2fd1c67c28f0a1ae$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $2fd1c67c28f0a1ae$var$originalBodyPointerEvents;
var $2fd1c67c28f0a1ae$var$DismissableLayerContext = $exYeM.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $2fd1c67c28f0a1ae$export$177fb62ff3ec1f22 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $exYeM.useContext($2fd1c67c28f0a1ae$var$DismissableLayerContext);
    const [node, setNode] = $exYeM.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $exYeM.useState({});
    const composedRefs = (0, $9ad84348d470d517$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $2fd1c67c28f0a1ae$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $2fd1c67c28f0a1ae$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $00ba34117b837688$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $exYeM.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $2fd1c67c28f0a1ae$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $2fd1c67c28f0a1ae$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $2fd1c67c28f0a1ae$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $exYeM.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $2fd1c67c28f0a1ae$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $exYeM.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($2fd1c67c28f0a1ae$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($2fd1c67c28f0a1ae$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $914ca9847cccd1b1$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$2fd1c67c28f0a1ae$export$177fb62ff3ec1f22.displayName = $2fd1c67c28f0a1ae$var$DISMISSABLE_LAYER_NAME;
var $2fd1c67c28f0a1ae$var$BRANCH_NAME = "DismissableLayerBranch";
var $2fd1c67c28f0a1ae$export$4d5eb2109db14228 = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $exYeM.useContext($2fd1c67c28f0a1ae$var$DismissableLayerContext);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $9ad84348d470d517$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $exYeM.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $914ca9847cccd1b1$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$2fd1c67c28f0a1ae$export$4d5eb2109db14228.displayName = $2fd1c67c28f0a1ae$var$BRANCH_NAME;
function $2fd1c67c28f0a1ae$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $134adfcd2273817d$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $exYeM.useRef(false);
    const handleClickRef = $exYeM.useRef(()=>{});
    $exYeM.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $2fd1c67c28f0a1ae$var$handleAndDispatchCustomEvent($2fd1c67c28f0a1ae$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $2fd1c67c28f0a1ae$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $134adfcd2273817d$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $exYeM.useRef(false);
    $exYeM.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $2fd1c67c28f0a1ae$var$handleAndDispatchCustomEvent($2fd1c67c28f0a1ae$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $2fd1c67c28f0a1ae$var$dispatchUpdate() {
    const event = new CustomEvent($2fd1c67c28f0a1ae$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $2fd1c67c28f0a1ae$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $914ca9847cccd1b1$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $2fd1c67c28f0a1ae$export$be92b6f5f03c0fe9 = $2fd1c67c28f0a1ae$export$177fb62ff3ec1f22;
var $2fd1c67c28f0a1ae$export$aecb2ddcb55c95be = $2fd1c67c28f0a1ae$export$4d5eb2109db14228;


// packages/react/id/src/id.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $exYeM = parcelRequire("exYeM");
var $661c1f6ce25fdee4$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $exYeM.useLayoutEffect : ()=>{};


var $02bcb07fdced7707$var$useReactId = $exYeM["useId".toString()] || (()=>void 0);
var $02bcb07fdced7707$var$count = 0;
function $02bcb07fdced7707$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $exYeM.useState($02bcb07fdced7707$var$useReactId());
    (0, $661c1f6ce25fdee4$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($02bcb07fdced7707$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $exYeM = parcelRequire("exYeM");

// packages/react/arrow/src/Arrow.tsx

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");
var $933bab608111869d$var$NAME = "Arrow";
var $933bab608111869d$export$21b07c8f274aebd5 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $914ca9847cccd1b1$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $aSiaI.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$933bab608111869d$export$21b07c8f274aebd5.displayName = $933bab608111869d$var$NAME;
var $933bab608111869d$export$be92b6f5f03c0fe9 = $933bab608111869d$export$21b07c8f274aebd5;







// packages/react/use-size/src/useSize.tsx

var $exYeM = parcelRequire("exYeM");

function $e621fb8db5e2bee1$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $exYeM.useState(void 0);
    (0, $661c1f6ce25fdee4$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



var $aSiaI = parcelRequire("aSiaI");
"use client";
var $734b85bf4b85713c$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $734b85bf4b85713c$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $734b85bf4b85713c$var$POPPER_NAME = "Popper";
var [$734b85bf4b85713c$var$createPopperContext, $734b85bf4b85713c$export$722aac194ae923] = (0, $e06dae5b45586ba5$export$50c7b4e9d9f19c1)($734b85bf4b85713c$var$POPPER_NAME);
var [$734b85bf4b85713c$var$PopperProvider, $734b85bf4b85713c$var$usePopperContext] = $734b85bf4b85713c$var$createPopperContext($734b85bf4b85713c$var$POPPER_NAME);
var $734b85bf4b85713c$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $exYeM.useState(null);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($734b85bf4b85713c$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$734b85bf4b85713c$export$badac9ada3a0bdf9.displayName = $734b85bf4b85713c$var$POPPER_NAME;
var $734b85bf4b85713c$var$ANCHOR_NAME = "PopperAnchor";
var $734b85bf4b85713c$export$ecd4e1ccab6ed6d = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $734b85bf4b85713c$var$usePopperContext($734b85bf4b85713c$var$ANCHOR_NAME, __scopePopper);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $9ad84348d470d517$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $exYeM.useEffect(()=>{
        context.onAnchorChange(virtualRef?.current || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $aSiaI.jsx)((0, $914ca9847cccd1b1$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$734b85bf4b85713c$export$ecd4e1ccab6ed6d.displayName = $734b85bf4b85713c$var$ANCHOR_NAME;
var $734b85bf4b85713c$var$CONTENT_NAME = "PopperContent";
var [$734b85bf4b85713c$var$PopperContentProvider, $734b85bf4b85713c$var$useContentContext] = $734b85bf4b85713c$var$createPopperContext($734b85bf4b85713c$var$CONTENT_NAME);
var $734b85bf4b85713c$export$bc4ae5855d3c4fc = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $734b85bf4b85713c$var$usePopperContext($734b85bf4b85713c$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $exYeM.useState(null);
    const composedRefs = (0, $9ad84348d470d517$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $exYeM.useState(null);
    const arrowSize = (0, $e621fb8db5e2bee1$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($734b85bf4b85713c$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $e0dc3054c0a828de$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $729e420fd9c85e8f$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $28f1bf2594995773$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $729e420fd9c85e8f$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $729e420fd9c85e8f$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $729e420fd9c85e8f$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $729e420fd9c85e8f$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $e0dc3054c0a828de$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $734b85bf4b85713c$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $729e420fd9c85e8f$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $734b85bf4b85713c$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $134adfcd2273817d$export$25bec8c6f54ee79a)(onPlaced);
    (0, $661c1f6ce25fdee4$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $exYeM.useState();
    (0, $661c1f6ce25fdee4$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($734b85bf4b85713c$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $914ca9847cccd1b1$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$734b85bf4b85713c$export$bc4ae5855d3c4fc.displayName = $734b85bf4b85713c$var$CONTENT_NAME;
var $734b85bf4b85713c$var$ARROW_NAME = "PopperArrow";
var $734b85bf4b85713c$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $734b85bf4b85713c$export$79d62cd4e10a3fd0 = $exYeM.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $734b85bf4b85713c$var$useContentContext($734b85bf4b85713c$var$ARROW_NAME, __scopePopper);
    const baseSide = $734b85bf4b85713c$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $aSiaI.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($933bab608111869d$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$734b85bf4b85713c$export$79d62cd4e10a3fd0.displayName = $734b85bf4b85713c$var$ARROW_NAME;
function $734b85bf4b85713c$var$isNotNull(value) {
    return value !== null;
}
var $734b85bf4b85713c$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $734b85bf4b85713c$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $734b85bf4b85713c$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $734b85bf4b85713c$export$be92b6f5f03c0fe9 = $734b85bf4b85713c$export$badac9ada3a0bdf9;
var $734b85bf4b85713c$export$b688253958b8dfe7 = $734b85bf4b85713c$export$ecd4e1ccab6ed6d;
var $734b85bf4b85713c$export$7c6e2c02157bb7d2 = $734b85bf4b85713c$export$bc4ae5855d3c4fc;
var $734b85bf4b85713c$export$21b07c8f274aebd5 = $734b85bf4b85713c$export$79d62cd4e10a3fd0;



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");



var $aSiaI = parcelRequire("aSiaI");
"use client";
var $c842de3222aed03e$var$PORTAL_NAME = "Portal";
var $c842de3222aed03e$export$602eac185826482c = $exYeM.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $exYeM.useState(false);
    (0, $661c1f6ce25fdee4$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(/* @__PURE__ */ (0, $aSiaI.jsx)((0, $914ca9847cccd1b1$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$c842de3222aed03e$export$602eac185826482c.displayName = $c842de3222aed03e$var$PORTAL_NAME;
var $c842de3222aed03e$export$be92b6f5f03c0fe9 = $c842de3222aed03e$export$602eac185826482c;



var $exYeM = parcelRequire("exYeM");


"use client";
function $e48581c0f9896ed4$var$useStateMachine(initialState, machine) {
    return $exYeM.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $e48581c0f9896ed4$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $e48581c0f9896ed4$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $exYeM.Children.only(children);
    const ref = (0, $9ad84348d470d517$export$c7b2cbe3552a0d05)(presence.ref, $e48581c0f9896ed4$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $exYeM.cloneElement(child, {
        ref: ref
    }) : null;
};
$e48581c0f9896ed4$export$99c2b779aa4e8b8b.displayName = "Presence";
function $e48581c0f9896ed4$var$usePresence(present) {
    const [node, setNode] = $exYeM.useState();
    const stylesRef = $exYeM.useRef({});
    const prevPresentRef = $exYeM.useRef(present);
    const prevAnimationNameRef = $exYeM.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e48581c0f9896ed4$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $exYeM.useEffect(()=>{
        const currentAnimationName = $e48581c0f9896ed4$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $661c1f6ce25fdee4$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e48581c0f9896ed4$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $661c1f6ce25fdee4$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e48581c0f9896ed4$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $e48581c0f9896ed4$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $exYeM.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $e48581c0f9896ed4$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $e48581c0f9896ed4$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




// packages/react/use-controllable-state/src/useControllableState.tsx

var $exYeM = parcelRequire("exYeM");

function $bfd9f19ea616092c$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $bfd9f19ea616092c$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $134adfcd2273817d$export$25bec8c6f54ee79a)(onChange);
    const setValue = $exYeM.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $bfd9f19ea616092c$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $exYeM.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $exYeM.useRef(value);
    const handleChange = (0, $134adfcd2273817d$export$25bec8c6f54ee79a)(onChange);
    $exYeM.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/visually-hidden/src/VisuallyHidden.tsx

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");
var $63fd02dc94c9ca46$var$NAME = "VisuallyHidden";
var $63fd02dc94c9ca46$export$439d29a4e110a164 = $exYeM.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $914ca9847cccd1b1$export$250ffa63cdc0d034).span, {
        ...props,
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    });
});
$63fd02dc94c9ca46$export$439d29a4e110a164.displayName = $63fd02dc94c9ca46$var$NAME;
var $63fd02dc94c9ca46$export$be92b6f5f03c0fe9 = $63fd02dc94c9ca46$export$439d29a4e110a164;



var $aSiaI = parcelRequire("aSiaI");
"use client";
var [$9d584503d9945f04$var$createTooltipContext, $9d584503d9945f04$export$1c540a2224f0d865] = (0, $e06dae5b45586ba5$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $734b85bf4b85713c$export$722aac194ae923)
]);
var $9d584503d9945f04$var$usePopperScope = (0, $734b85bf4b85713c$export$722aac194ae923)();
var $9d584503d9945f04$var$PROVIDER_NAME = "TooltipProvider";
var $9d584503d9945f04$var$DEFAULT_DELAY_DURATION = 700;
var $9d584503d9945f04$var$TOOLTIP_OPEN = "tooltip.open";
var [$9d584503d9945f04$var$TooltipProviderContextProvider, $9d584503d9945f04$var$useTooltipProviderContext] = $9d584503d9945f04$var$createTooltipContext($9d584503d9945f04$var$PROVIDER_NAME);
var $9d584503d9945f04$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $9d584503d9945f04$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = $exYeM.useState(true);
    const isPointerInTransitRef = $exYeM.useRef(false);
    const skipDelayTimerRef = $exYeM.useRef(0);
    $exYeM.useEffect(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($9d584503d9945f04$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: $exYeM.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: $exYeM.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: $exYeM.useCallback((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent,
        children: children
    });
};
$9d584503d9945f04$export$f78649fb9ca566b8.displayName = $9d584503d9945f04$var$PROVIDER_NAME;
var $9d584503d9945f04$var$TOOLTIP_NAME = "Tooltip";
var [$9d584503d9945f04$var$TooltipContextProvider, $9d584503d9945f04$var$useTooltipContext] = $9d584503d9945f04$var$createTooltipContext($9d584503d9945f04$var$TOOLTIP_NAME);
var $9d584503d9945f04$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $9d584503d9945f04$var$useTooltipProviderContext($9d584503d9945f04$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $9d584503d9945f04$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = $exYeM.useState(null);
    const contentId = (0, $02bcb07fdced7707$export$f680877a34711e37)();
    const openTimerRef = $exYeM.useRef(0);
    const disableHoverableContent = disableHoverableContentProp ?? providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp ?? providerContext.delayDuration;
    const wasOpenDelayedRef = $exYeM.useRef(false);
    const [open = false, setOpen] = (0, $bfd9f19ea616092c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open2)=>{
            if (open2) {
                providerContext.onOpen();
                document.dispatchEvent(new CustomEvent($9d584503d9945f04$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange?.(open2);
        }
    });
    const stateAttribute = $exYeM.useMemo(()=>{
        return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open
    ]);
    const handleOpen = $exYeM.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = $exYeM.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = $exYeM.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
            openTimerRef.current = 0;
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    $exYeM.useEffect(()=>{
        return ()=>{
            if (openTimerRef.current) {
                window.clearTimeout(openTimerRef.current);
                openTimerRef.current = 0;
            }
        };
    }, []);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($734b85bf4b85713c$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)($9d584503d9945f04$var$TooltipContextProvider, {
            scope: __scopeTooltip,
            contentId: contentId,
            open: open,
            stateAttribute: stateAttribute,
            trigger: trigger,
            onTriggerChange: setTrigger,
            onTriggerEnter: $exYeM.useCallback(()=>{
                if (providerContext.isOpenDelayed) handleDelayedOpen();
                else handleOpen();
            }, [
                providerContext.isOpenDelayed,
                handleDelayedOpen,
                handleOpen
            ]),
            onTriggerLeave: $exYeM.useCallback(()=>{
                if (disableHoverableContent) handleClose();
                else {
                    window.clearTimeout(openTimerRef.current);
                    openTimerRef.current = 0;
                }
            }, [
                handleClose,
                disableHoverableContent
            ]),
            onOpen: handleOpen,
            onClose: handleClose,
            disableHoverableContent: disableHoverableContent,
            children: children
        })
    });
};
$9d584503d9945f04$export$28c660c63b792dea.displayName = $9d584503d9945f04$var$TOOLTIP_NAME;
var $9d584503d9945f04$var$TRIGGER_NAME = "TooltipTrigger";
var $9d584503d9945f04$export$8c610744efcf8a1d = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $9d584503d9945f04$var$useTooltipContext($9d584503d9945f04$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $9d584503d9945f04$var$useTooltipProviderContext($9d584503d9945f04$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $9d584503d9945f04$var$usePopperScope(__scopeTooltip);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $9ad84348d470d517$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = $exYeM.useRef(false);
    const hasPointerMoveOpenedRef = $exYeM.useRef(false);
    const handlePointerUp = $exYeM.useCallback(()=>isPointerDownRef.current = false, []);
    $exYeM.useEffect(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($734b85bf4b85713c$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $914ca9847cccd1b1$export$250ffa63cdc0d034).button, {
            "aria-describedby": context.open ? context.contentId : void 0,
            "data-state": context.stateAttribute,
            ...triggerProps,
            ref: composedRefs,
            onPointerMove: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
                if (event.pointerType === "touch") return;
                if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                    context.onTriggerEnter();
                    hasPointerMoveOpenedRef.current = true;
                }
            }),
            onPointerLeave: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
                context.onTriggerLeave();
                hasPointerMoveOpenedRef.current = false;
            }),
            onPointerDown: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
                isPointerDownRef.current = true;
                document.addEventListener("pointerup", handlePointerUp, {
                    once: true
                });
            }),
            onFocus: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                if (!isPointerDownRef.current) context.onOpen();
            }),
            onBlur: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
            onClick: (0, $5bfef79223bc0839$export$b9ecd428b558ff10)(props.onClick, context.onClose)
        })
    });
});
$9d584503d9945f04$export$8c610744efcf8a1d.displayName = $9d584503d9945f04$var$TRIGGER_NAME;
var $9d584503d9945f04$var$PORTAL_NAME = "TooltipPortal";
var [$9d584503d9945f04$var$PortalProvider, $9d584503d9945f04$var$usePortalContext] = $9d584503d9945f04$var$createTooltipContext($9d584503d9945f04$var$PORTAL_NAME, {
    forceMount: void 0
});
var $9d584503d9945f04$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $9d584503d9945f04$var$useTooltipContext($9d584503d9945f04$var$PORTAL_NAME, __scopeTooltip);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($9d584503d9945f04$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $e48581c0f9896ed4$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $aSiaI.jsx)((0, $c842de3222aed03e$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$9d584503d9945f04$export$7b36b8f925ab7497.displayName = $9d584503d9945f04$var$PORTAL_NAME;
var $9d584503d9945f04$var$CONTENT_NAME = "TooltipContent";
var $9d584503d9945f04$export$e9003e2be37ec060 = $exYeM.forwardRef((props, forwardedRef)=>{
    const portalContext = $9d584503d9945f04$var$usePortalContext($9d584503d9945f04$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $9d584503d9945f04$var$useTooltipContext($9d584503d9945f04$var$CONTENT_NAME, props.__scopeTooltip);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $e48581c0f9896ed4$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.disableHoverableContent ? /* @__PURE__ */ (0, $aSiaI.jsx)($9d584503d9945f04$var$TooltipContentImpl, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $aSiaI.jsx)($9d584503d9945f04$var$TooltipContentHoverable, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        })
    });
});
var $9d584503d9945f04$var$TooltipContentHoverable = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $9d584503d9945f04$var$useTooltipContext($9d584503d9945f04$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $9d584503d9945f04$var$useTooltipProviderContext($9d584503d9945f04$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $9ad84348d470d517$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = $exYeM.useState(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = $exYeM.useCallback(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = $exYeM.useCallback((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $9d584503d9945f04$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $9d584503d9945f04$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $9d584503d9945f04$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $9d584503d9945f04$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    $exYeM.useEffect(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    $exYeM.useEffect(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    $exYeM.useEffect(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = trigger?.contains(target) || content?.contains(target);
                const isPointerOutsideGraceArea = !$9d584503d9945f04$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)($9d584503d9945f04$var$TooltipContentImpl, {
        ...props,
        ref: composedRefs
    });
});
var [$9d584503d9945f04$var$VisuallyHiddenContentContextProvider, $9d584503d9945f04$var$useVisuallyHiddenContentContext] = $9d584503d9945f04$var$createTooltipContext($9d584503d9945f04$var$TOOLTIP_NAME, {
    isInside: false
});
var $9d584503d9945f04$var$TooltipContentImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $9d584503d9945f04$var$useTooltipContext($9d584503d9945f04$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $9d584503d9945f04$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context;
    $exYeM.useEffect(()=>{
        document.addEventListener($9d584503d9945f04$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($9d584503d9945f04$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]);
    $exYeM.useEffect(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target?.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $2fd1c67c28f0a1ae$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ (0, $aSiaI.jsxs)($734b85bf4b85713c$export$7c6e2c02157bb7d2, {
            "data-state": context.stateAttribute,
            ...popperScope,
            ...contentProps,
            ref: forwardedRef,
            style: {
                ...contentProps.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
                /* @__PURE__ */ (0, $aSiaI.jsx)((0, $35c00cadf85c33a2$export$d9f1ccf0bdb05d45), {
                    children: children
                }),
                /* @__PURE__ */ (0, $aSiaI.jsx)($9d584503d9945f04$var$VisuallyHiddenContentContextProvider, {
                    scope: __scopeTooltip,
                    isInside: true,
                    children: /* @__PURE__ */ (0, $aSiaI.jsx)($63fd02dc94c9ca46$export$be92b6f5f03c0fe9, {
                        id: context.contentId,
                        role: "tooltip",
                        children: ariaLabel || children
                    })
                })
            ]
        })
    });
});
$9d584503d9945f04$export$e9003e2be37ec060.displayName = $9d584503d9945f04$var$CONTENT_NAME;
var $9d584503d9945f04$var$ARROW_NAME = "TooltipArrow";
var $9d584503d9945f04$export$c27ee0ad710f7559 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $9d584503d9945f04$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $9d584503d9945f04$var$useVisuallyHiddenContentContext($9d584503d9945f04$var$ARROW_NAME, __scopeTooltip);
    return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ (0, $aSiaI.jsx)($734b85bf4b85713c$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$9d584503d9945f04$export$c27ee0ad710f7559.displayName = $9d584503d9945f04$var$ARROW_NAME;
function $9d584503d9945f04$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $9d584503d9945f04$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $9d584503d9945f04$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
}
function $9d584503d9945f04$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $9d584503d9945f04$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $9d584503d9945f04$var$getHullPresorted(newPoints);
}
function $9d584503d9945f04$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i = points.length - 1; i >= 0; i--){
        const p = points[i];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
var $9d584503d9945f04$export$2881499e37b75b9a = $9d584503d9945f04$export$f78649fb9ca566b8;
var $9d584503d9945f04$export$be92b6f5f03c0fe9 = $9d584503d9945f04$export$28c660c63b792dea;
var $9d584503d9945f04$export$41fb9f06171c75f4 = $9d584503d9945f04$export$8c610744efcf8a1d;
var $9d584503d9945f04$export$602eac185826482c = $9d584503d9945f04$export$7b36b8f925ab7497;
var $9d584503d9945f04$export$7c6e2c02157bb7d2 = $9d584503d9945f04$export$e9003e2be37ec060;
var $9d584503d9945f04$export$21b07c8f274aebd5 = $9d584503d9945f04$export$c27ee0ad710f7559;



"use client";
const $2c3dff1bb294f275$export$f78649fb9ca566b8 = $9d584503d9945f04$export$2881499e37b75b9a;
const $2c3dff1bb294f275$export$28c660c63b792dea = $9d584503d9945f04$export$be92b6f5f03c0fe9;
const $2c3dff1bb294f275$export$8c610744efcf8a1d = $9d584503d9945f04$export$41fb9f06171c75f4;
const $2c3dff1bb294f275$export$e9003e2be37ec060 = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
    const { className: className, sideOffset: sideOffset = 4, ...restProps } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsx)($9d584503d9945f04$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($9d584503d9945f04$export$7c6e2c02157bb7d2, {
            ref: ref,
            sideOffset: sideOffset,
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
            ...restProps
        })
    });
});
$2c3dff1bb294f275$export$e9003e2be37ec060.displayName = $9d584503d9945f04$export$7c6e2c02157bb7d2.displayName;




const $6b8c5152afe6fd54$var$ResponsiveGridLayout = (0, $5d0c4451c391a908$exports.WidthProvider)((0, $5d0c4451c391a908$exports.Responsive));
const $6b8c5152afe6fd54$var$defaultCreateElement = (el, items, onDelete, defaultProps)=>{
    const item = items.find((value)=>value.i === el.i);
    if (!item) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "h-full w-full",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $78bf72408c10d2b9$export$2e2bcd8739ae039), {
            el: el,
            item: item,
            ...defaultProps,
            onDelete: onDelete,
            children: defaultProps.children(item.type, item?.props)
        })
    }, el.i);
};
const $6b8c5152afe6fd54$var$DashboardLayout = ({ dashboardName: dashboardName, onDashboardNameChange: onDashboardNameChange, layout: layout, items: items, onLayoutChange: onLayoutChange, onRemoveWidget: onRemoveWidget, isEditing: isEditing, onToggleEdit: onToggleEdit, isSaving: isSaving, onSave: onSave, onOpenDialog: onOpenDialog, createElement: createElement, children: children, onEdit: onEdit, showEditControls: showEditControls = false, headerExtras: headerExtras = null })=>{
    // Extract header components from headerExtras
    const likeButton = headerExtras?.props?.children?.[0];
    const visibilityToggle = headerExtras?.props?.children?.[1];
    const responsiveProps = {
        className: "layout",
        breakpoints: {
            lg: 1200,
            md: 996,
            sm: 768,
            xs: 480,
            xxs: 0
        },
        cols: {
            lg: 12,
            md: 10,
            sm: 6,
            xs: 4,
            xxs: 2
        },
        rowHeight: 110,
        layouts: {
            lg: layout
        },
        width: 1200,
        isDraggable: isEditing && showEditControls,
        isResizable: isEditing && showEditControls,
        draggableHandle: ".react-grid-dragHandleExample",
        onLayoutChange: (newLayout)=>{
            if (showEditControls && onLayoutChange) onLayoutChange(newLayout);
        },
        margin: [
            10,
            10
        ]
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-full w-full bg-surface py-2",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "px-4 py-2 flex items-center justify-between border-b",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex-none",
                        children: visibilityToggle
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex flex-1 justify-center items-center gap-2 max-w-2xl px-4",
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex items-center gap-2 pl-2 pr-4 py-1 bg-surfaceVariant rounded-lg border-primaryContainer text-center",
                            children: [
                                likeButton,
                                isEditing ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0bdc6a2cae10298$export$f5b8910cec6cf069), {
                                    className: "w-64 bg-white text-center",
                                    value: dashboardName,
                                    onChange: (e)=>onDashboardNameChange?.(e.target.value),
                                    placeholder: "Dashboard Name",
                                    disabled: isSaving
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                                    className: "text-2xl font-semibold text-center mb-1.5",
                                    children: dashboardName
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex-none flex items-center gap-2",
                        children: showEditControls && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$f78649fb9ca566b8), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2c3dff1bb294f275$export$28c660c63b792dea), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$8c610744efcf8a1d), {
                                                asChild: true,
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                                    variant: "outline",
                                                    size: "icon",
                                                    onClick: ()=>onToggleEdit?.(),
                                                    className: "h-10 w-10 p-2 border-primaryContainer group hover:bg-primary transition-colors shadow-none",
                                                    children: isEditing ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0b58934760e74240$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-onSurfaceVariant group-hover:text-white"
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23364bb7ce99c8b$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-onSurfaceVariant group-hover:text-white"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$e9003e2be37ec060), {
                                                children: isEditing ? "Lock dashboard" : "Unlock dashboard for editing"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$f78649fb9ca566b8), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2c3dff1bb294f275$export$28c660c63b792dea), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$8c610744efcf8a1d), {
                                                asChild: true,
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                                    variant: "outline",
                                                    size: "icon",
                                                    onClick: onSave,
                                                    disabled: isSaving,
                                                    className: "h-10 w-10 p-2 border-primaryContainer group hover:bg-primary transition-colors shadow-none",
                                                    children: isSaving ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11645006cc3cfacf$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 animate-spin text-onSurfaceVariant"
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d419906ca7ecb216$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-onSurfaceVariant group-hover:text-white"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$e9003e2be37ec060), {
                                                children: "Save dashboard changes"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$f78649fb9ca566b8), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2c3dff1bb294f275$export$28c660c63b792dea), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$8c610744efcf8a1d), {
                                                asChild: true,
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                                                    variant: "outline",
                                                    size: "icon",
                                                    onClick: onOpenDialog,
                                                    className: "h-10 w-10 p-2 border-primaryContainer group hover:bg-primary transition-colors shadow-none",
                                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $55affc78df8683a3$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-onSurfaceVariant group-hover:text-white"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$e9003e2be37ec060), {
                                                children: "Add a new widget to dashboard"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "overflow-hidden p-4",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($6b8c5152afe6fd54$var$ResponsiveGridLayout, {
                    ...responsiveProps,
                    children: layout.map((el)=>{
                        const defaultProps = {
                            showEditControls: showEditControls,
                            isEditing: isEditing,
                            onEdit: onEdit,
                            children: children
                        };
                        if (createElement) return createElement(el, items, onRemoveWidget);
                        return $6b8c5152afe6fd54$var$defaultCreateElement(el, items, onRemoveWidget, defaultProps);
                    })
                })
            })
        ]
    });
};
var $6b8c5152afe6fd54$export$2e2bcd8739ae039 = $6b8c5152afe6fd54$var$DashboardLayout;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");



var $exYeM = parcelRequire("exYeM");
function $eeb626020a7cdb2a$export$2e2bcd8739ae039() {
    var newStyle = document.createElement("style");
    newStyle.appendChild(document.createTextNode("  @font-face {    font-family: 'Monda';    font-style: sans-serif;    font-weight: 400;    src: url('https://fonts.googleapis.com/css2?family=Monda&display=swap')    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;  }  "));
    const data = [
        [
            1643639400000,
            174.78
        ],
        [
            1643725800000,
            174.61
        ],
        [
            1643812200000,
            175.84
        ],
        [
            1643898600000,
            172.9
        ],
        [
            1643985000000,
            172.39
        ],
        [
            1644244200000,
            171.66
        ],
        [
            1644330600000,
            174.83
        ],
        [
            1644417000000,
            176.28
        ],
        [
            1644503400000,
            172.12
        ],
        [
            1644589800000,
            168.64
        ],
        [
            1644849000000,
            168.88
        ],
        [
            1644935400000,
            172.79
        ],
        [
            1645021800000,
            172.55
        ],
        [
            1645108200000,
            168.88
        ],
        [
            1645194600000,
            167.3
        ],
        [
            1645540200000,
            164.32
        ],
        [
            1645626600000,
            160.07
        ],
        [
            1645713000000,
            162.74
        ],
        [
            1645799400000,
            164.85
        ],
        [
            1646058600000,
            165.12
        ],
        [
            1646145000000,
            163.2
        ],
        [
            1646231400000,
            166.56
        ],
        [
            1646317800000,
            166.23
        ],
        [
            1646404200000,
            163.17
        ],
        [
            1646663400000,
            159.3
        ],
        [
            1646749800000,
            157.44
        ],
        [
            1646836200000,
            162.95
        ],
        [
            1646922600000,
            158.52
        ],
        [
            1647009000000,
            154.73
        ],
        [
            1647264600000,
            150.62
        ],
        [
            1647351000000,
            155.09
        ],
        [
            1647437400000,
            159.59
        ],
        [
            1647523800000,
            160.62
        ],
        [
            1647610200000,
            163.98
        ],
        [
            1647869400000,
            165.38
        ],
        [
            1647955800000,
            168.82
        ],
        [
            1648042200000,
            170.21
        ],
        [
            1648128600000,
            174.07
        ],
        [
            1648215000000,
            174.72
        ],
        [
            1648474200000,
            175.6
        ],
        [
            1648560600000,
            178.96
        ],
        [
            1648647000000,
            177.77
        ],
        [
            1648733400000,
            174.61
        ],
        [
            1648819800000,
            174.31
        ],
        [
            1649079000000,
            178.44
        ],
        [
            1649165400000,
            175.06
        ],
        [
            1649251800000,
            171.83
        ],
        [
            1649338200000,
            172.14
        ],
        [
            1649424600000,
            170.09
        ],
        [
            1649683800000,
            165.75
        ],
        [
            1649770200000,
            167.66
        ],
        [
            1649856600000,
            170.4
        ],
        [
            1649943000000,
            165.29
        ],
        [
            1650288600000,
            165.07
        ],
        [
            1650375000000,
            167.4
        ],
        [
            1650461400000,
            167.23
        ],
        [
            1650547800000,
            166.42
        ],
        [
            1650634200000,
            161.79
        ],
        [
            1650893400000,
            162.88
        ],
        [
            1650979800000,
            156.8
        ],
        [
            1651066200000,
            156.57
        ],
        [
            1651152600000,
            163.64
        ],
        [
            1651239000000,
            157.65
        ],
        [
            1651498200000,
            157.96
        ],
        [
            1651584600000,
            159.48
        ],
        [
            1651671000000,
            166.02
        ],
        [
            1651757400000,
            156.77
        ],
        [
            1651843800000,
            157.28
        ],
        [
            1652103000000,
            152.06
        ],
        [
            1652189400000,
            154.51
        ],
        [
            1652275800000,
            146.5
        ],
        [
            1652362200000,
            142.56
        ],
        [
            1652448600000,
            147.11
        ],
        [
            1652707800000,
            145.54
        ],
        [
            1652794200000,
            149.24
        ],
        [
            1652880600000,
            140.82
        ],
        [
            1652967000000,
            137.35
        ],
        [
            1653053400000,
            137.59
        ],
        [
            1653312600000,
            143.11
        ],
        [
            1653399000000,
            140.36
        ],
        [
            1653485400000,
            140.52
        ],
        [
            1653571800000,
            143.78
        ],
        [
            1653658200000,
            149.64
        ],
        [
            1654003800000,
            148.84
        ],
        [
            1654090200000,
            148.71
        ],
        [
            1654176600000,
            151.21
        ],
        [
            1654263000000,
            145.38
        ],
        [
            1654522200000,
            146.14
        ],
        [
            1654608600000,
            148.71
        ],
        [
            1654695000000,
            147.96
        ],
        [
            1654781400000,
            142.64
        ],
        [
            1654867800000,
            137.13
        ],
        [
            1655127000000,
            131.88
        ],
        [
            1655213400000,
            132.76
        ],
        [
            1655299800000,
            135.43
        ],
        [
            1655386200000,
            130.06
        ],
        [
            1655472600000,
            131.56
        ],
        [
            1655818200000,
            135.87
        ],
        [
            1655904600000,
            135.35
        ],
        [
            1655991000000,
            138.27
        ]
    ];
    document.head.appendChild(newStyle);
    const dataSource = [
        {
            name: "small",
            data: data,
            color: "#FA9173",
            backgroundColor: "transparent",
            animation: false,
            lineWidth: 1,
            shadow: false,
            states: {
                hover: {
                    lineWidth: 1
                }
            },
            marker: {
                radius: 1,
                states: {
                    hover: {
                        radius: 2
                    }
                }
            },
            fillOpacity: 0.25
        }
    ];
    const [options, setChartOptions] = (0, $exYeM.useState)({
        exporting: {
            enabled: false,
            enableImages: true
        },
        chart: {
            type: "area",
            backgroundColor: "transparent"
        },
        title: {
            text: ""
        },
        xAxis: {
            visible: false,
            type: "datetime"
        },
        yAxis: {
            visible: false
        },
        legend: {
            enabled: false
        },
        series: dataSource,
        credits: {
            enabled: false
        },
        accessibility: {
            enabled: false
        }
    });
    (0, $exYeM.useEffect)(()=>{
        setChartOptions({
            series: dataSource
        });
        window.dispatchEvent(new Event("resize"));
    }, []);
    const containerProps = (0, $exYeM.useMemo)(()=>({
            style: {
                height: "100%",
                width: "100%"
            }
        }), []);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
        highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($bdf625fc24abd869$exports))),
        containerProps: containerProps,
        options: options
    });
}



var $aSiaI = parcelRequire("aSiaI");


function $8ab4350084cc7af2$export$2e2bcd8739ae039({ title: title, link: link, author: author, published: published, image: image }) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "bg-white flex flex-col gap-2 rounded-md h-full w-full p-2 border border-surfaceVariant shadow-md",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "row-span-3 flex flex-1 flex-col",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "text-sm text-gray-900 font-semibold text-ellipsis overflow-hidden text-nowrap",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                        className: "text-sm text-gray-600 flex gap-2 items-center text-wrap ...",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                children: author
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(published * 1000).format("MM/DD/YYYY")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "relative mx-auto rounded-md overflow-hidden row-span-4 bg-red-400",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                    src: image != undefined ? image[0]["url"] : "",
                    alt: "",
                    className: (0, $fcf061de51445294$export$2e2bcd8739ae039)("object-contain h-fit")
                })
            })
        ]
    }, title);
}



var $aSiaI = parcelRequire("aSiaI");

function $95d1818c85576eb0$export$2e2bcd8739ae039({ loading: loading = false, value: value, error: error = false, name: name, prefix: prefix = "", suffix: suffix = "", decimals: decimals }) {
    return(// <Card className="col-span-1">
    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col items-center justify-center h-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$5665775b26e26c5d), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$474db65c3c394e1c), {
                    className: "break-words",
                    children: name
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0ac17ca2995b452$export$64ef9b8c11710c47), {
                className: "font-monda text-gray-700",
                children: error ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "text-red-400",
                    children: "error"
                }) : loading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {}) : `${prefix}${Number(value).toLocaleString("en-US", {
                    maximumFractionDigits: decimals
                })} ${suffix}`
            })
        ]
    }));
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




const $f46b4f8560d1875e$var$BaseChart = ({ data: data, minimal: minimal = false, showControls: showControls = true, height: height = "100%", width: width = "100%", watermark: watermark = false })=>{
    const chartRef = (0, $exYeM.useRef)(null);
    const processData = (data)=>{
        return data.map((item, index)=>{
            // Handle both simple and complex data structures
            const graphData = item.data?.data?.graphData?.[0]?.values || item.data;
            return {
                id: index,
                name: item.data?.data?.name || `Series ${index + 1}`,
                data: graphData,
                color: item.colour || item.data?.data?.settings?.colour || "#FA9173",
                type: item.style?.data || item.data?.data?.settings?.style?.data || "line",
                yAxis: 0
            };
        });
    };
    const [chartOptions, setChartOptions] = (0, $exYeM.useState)({
        exporting: {
            enabled: false,
            enableImages: true
        },
        legend: {
            enabled: !minimal,
            itemStyle: {
                fontWeight: "bold",
                fontFamily: "Monda"
            }
        },
        chart: {
            backgroundColor: "transparent",
            style: {
                fontFamily: "Monda"
            },
            zoomType: minimal ? undefined : "x",
            events: {
                load: function() {
                    if (!minimal && watermark) {
                        const height_image = 127;
                        const width_image = 627.98;
                        const height_image_sm = 100;
                        const width_image_sm = 152;
                        const threshold = 800;
                        const useSmallWatermark = this.plotWidth < threshold;
                        const currentWatermark = useSmallWatermark ? (0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($1b9fd1c61e334a1c$exports)));
                        const currentWidth = useSmallWatermark ? width_image_sm : width_image;
                        const currentHeight = useSmallWatermark ? height_image_sm : height_image;
                        const textX = this.plotLeft + this.plotWidth * 0.5;
                        const textY = this.plotTop + this.plotHeight * 0.5;
                        const position_x = textX - currentWidth / 2;
                        const position_y = textY - currentHeight / 2;
                        this.watermarkImg = this.renderer.image(currentWatermark, position_x, position_y, currentWidth, currentHeight).attr({
                            opacity: 0.6,
                            zIndex: 0
                        }).add();
                    }
                },
                redraw: function() {
                    if (this.watermarkImg && !minimal && watermark) {
                        const height_image = 127;
                        const width_image = 627.98;
                        const height_image_sm = 100;
                        const width_image_sm = 152;
                        const threshold = 800;
                        const useSmallWatermark = this.plotWidth < threshold;
                        const currentWatermark = useSmallWatermark ? (0, (/*@__PURE__*/$parcel$interopDefault($852989f67c24e89f$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($1b9fd1c61e334a1c$exports)));
                        const currentWidth = useSmallWatermark ? width_image_sm : width_image;
                        const currentHeight = useSmallWatermark ? height_image_sm : height_image;
                        const textX = this.plotLeft + this.plotWidth * 0.5;
                        const textY = this.plotTop + this.plotHeight * 0.5;
                        const position_x = textX - currentWidth / 2;
                        const position_y = textY - currentHeight / 2;
                        this.watermarkImg.attr({
                            href: currentWatermark,
                            x: position_x,
                            y: position_y,
                            width: currentWidth,
                            height: currentHeight
                        });
                    }
                }
            }
        },
        plotOptions: {
            series: {
                opacity: 0.75,
                lineWidth: minimal ? 1 : 4
            }
        },
        scrollbar: {
            enabled: false
        },
        xAxis: {
            visible: !minimal,
            labels: {
                style: {
                    fontSize: "13px",
                    fontFamily: "Monda"
                }
            }
        },
        yAxis: {
            visible: !minimal,
            opposite: false,
            labels: {
                style: {
                    fontSize: "13px",
                    fontFamily: "Monda"
                }
            }
        },
        credits: {
            enabled: false
        },
        navigator: {
            enabled: showControls && !minimal,
            maskFill: "rgba(250, 145, 115, 0.35)",
            series: {
                color: "#FA9173",
                lineWidth: 1
            },
            handles: {
                backgroundColor: "#FA9173",
                borderColor: "#F4F2F2"
            }
        },
        rangeSelector: {
            enabled: showControls && !minimal,
            buttonTheme: {
                // Style for the range selector buttons
                fill: "#F4F2F2",
                stroke: "#E6DCDC",
                style: {
                    color: "#AA9691",
                    fontFamily: "Monda",
                    fontWeight: "normal"
                },
                r: 8,
                padding: 8,
                states: {
                    hover: {
                        fill: "#FA9173",
                        style: {
                            color: "white"
                        }
                    },
                    select: {
                        fill: "#FA9173",
                        style: {
                            color: "white"
                        }
                    }
                }
            },
            inputBoxBorderColor: "#E6DCDC",
            inputBoxHeight: 32,
            inputBoxRadius: 8,
            inputSpacing: 8,
            inputStyle: {
                color: "#AA9691",
                fontFamily: "Monda",
                backgroundColor: "#F4F2F2",
                borderRadius: "8px",
                border: "1px solid #E6DCDC"
            },
            inputPosition: {
                align: "right",
                x: -10,
                y: 0
            },
            inputDateFormat: "%e %b %Y",
            inputEditDateFormat: "%Y-%m-%d",
            labelStyle: {
                color: "#AA9691",
                fontFamily: "Monda"
            },
            inputDateParser: function(value) {
                // Custom date parser to handle both formats
                return Date.parse(value);
            }
        },
        tooltip: {
            enabled: !minimal,
            style: {
                fontFamily: "Monda"
            }
        },
        series: processData(data),
        accessibility: {
            enabled: false
        }
    });
    (0, $exYeM.useEffect)(()=>{
        setChartOptions((prev)=>({
                ...prev,
                series: processData(data)
            }));
    }, [
        data
    ]);
    (0, $exYeM.useEffect)(()=>{
        window.dispatchEvent(new Event("resize"));
    }, [
        height,
        width
    ]);
    const containerProps = (0, $exYeM.useMemo)(()=>({
            style: {
                height: height,
                width: width
            }
        }), [
        height,
        width
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: minimal ? "h-[350px] w-[350px] border-l-2 border-b-2 border-l-gray-400 border-b-gray-400 rounded-bl-xl" : "h-full w-full",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b8e3559267404c5$exports))), {
            containerProps: containerProps,
            highcharts: (0, (/*@__PURE__*/$parcel$interopDefault($8bf0dc2281888f2c$exports))),
            constructorType: "stockChart",
            options: chartOptions,
            ref: chartRef
        })
    });
};
var $f46b4f8560d1875e$export$2e2bcd8739ae039 = $f46b4f8560d1875e$var$BaseChart;




function $14ad3dde3db7278f$var$getToken() {
    if (localStorage.getItem("user") != null) return JSON.parse(localStorage.getItem("user")).accessToken;
    else return "";
}
function $14ad3dde3db7278f$export$4dde3fff4ba8b221(charts, queryKeys) {
    async function query(blockchain, res, graphName, source, style, colour) {
        var string = source ? "/" + blockchain + "/" + res + "/" + graphName + "/" + source : "/" + blockchain + "/" + res + "/" + graphName;
        var colourCleaned = colour.replace(/^#/, "");
        string = string.concat("?settings=" + JSON.stringify({
            style: style,
            colour: colourCleaned
        }));
        const data = await (0, $ca6473885cd32228$export$2e2bcd8739ae039).get(string, {
            headers: {
                Authorization: `Bearer ${$14ad3dde3db7278f$var$getToken()}`
            }
        });
        // add the settings in here!
        // injecting data to a promise seems like a bad idea..
        // maybe can adjust the query to include a body and then return body in the query if it exists
        return data;
    }
    function genKey(id, blockchain, res, graphName, source) {
        var string = source ? "/" + blockchain + "/" + res + "/" + graphName + "/" + source : "/" + blockchain + "/" + res + "/" + graphName;
        return string.concat(id);
    }
    // can i insert meta data into the query promise when it is created?
    const results = (0, $d9ec3a60b698e2ea$export$408667c6c87da1e5)({
        queries: Array.isArray(charts) ? charts.map((value, index)=>{
            return {
                queryKey: queryKeys[index],
                queryFn: ()=>query(value.blockchain.name, value.resolution, value.name.name, value?.source, value?.style, value?.colour ?? "#FA9173"),
                // Add these options to ensure refresh on prop changes
                refetchOnMount: true,
                refetchOnWindowFocus: false
            };
        }) : []
    });
    return {
        results: results
    };
}





function $f73e36e22e7b8c56$export$2e2bcd8739ae039({ charts: charts }) {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const isLoggedIn = (0, $8e62f87e86da6465$export$83d11f23a23d4a7c)();
    // Only include data-related properties in query key
    const queryKey = (0, $exYeM.useMemo)(()=>{
        if (!Array.isArray(charts)) return [];
        return charts.map((chart)=>[
                chart.id,
                chart.blockchain?.name,
                chart.resolution,
                chart.name?.name,
                chart.source
            ]);
    }, [
        charts
    ]);
    // Get data from API
    const { results: results } = isLoggedIn ? (0, $14ad3dde3db7278f$export$4dde3fff4ba8b221)(charts, queryKey) : {
        results: []
    };
    // Apply visual properties to results
    const transformedResults = (0, $exYeM.useMemo)(()=>{
        return results.map((result, index)=>{
            const chart = charts[index];
            if (!chart || !result.data) return result;
            return {
                ...result,
                colour: chart.colour,
                style: chart.style
            };
        });
    }, [
        results,
        charts
    ]);
    if (!isLoggedIn) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col items-center justify-center h-full space-y-4 p-6 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "text-center space-y-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: "font-semibold text-gray-900",
                        children: "Authentication Required"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                        className: "text-sm text-gray-600",
                        children: "Please log in to view this chart data"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                onClick: ()=>navigate("/signin"),
                className: "gap-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9ef383e6886bf5bb$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    }),
                    "Login to View"
                ]
            })
        ]
    });
    if (results.some((items)=>items.isLoading)) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex items-center justify-center h-full",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11645006cc3cfacf$export$2e2bcd8739ae039), {
            className: "h-8 w-8 animate-spin text-primary"
        })
    });
    if (results.some((items)=>items.isError)) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex items-center justify-center h-full text-destructive",
        children: "Error loading chart data"
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f46b4f8560d1875e$export$2e2bcd8739ae039), {
        data: transformedResults,
        watermark: true,
        minimal: false,
        showControls: true
    });
}



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
// state/index.ts
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $c3ea038052888a59$var$OrderedMap(content) {
    this.content = content;
}
$c3ea038052888a59$var$OrderedMap.prototype = {
    constructor: $c3ea038052888a59$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $c3ea038052888a59$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $c3ea038052888a59$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $c3ea038052888a59$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $c3ea038052888a59$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $c3ea038052888a59$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $c3ea038052888a59$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $c3ea038052888a59$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $c3ea038052888a59$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $c3ea038052888a59$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $c3ea038052888a59$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$c3ea038052888a59$var$OrderedMap.from = function(value) {
    if (value instanceof $c3ea038052888a59$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $c3ea038052888a59$var$OrderedMap(content);
};
var $c3ea038052888a59$export$2e2bcd8739ae039 = $c3ea038052888a59$var$OrderedMap;


function $1847e9be7ba495c5$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $1847e9be7ba495c5$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $1847e9be7ba495c5$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $1847e9be7ba495c5$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $1847e9be7ba495c5$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $1847e9be7ba495c5$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $1847e9be7ba495c5$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $1847e9be7ba495c5$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $1847e9be7ba495c5$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $1847e9be7ba495c5$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $1847e9be7ba495c5$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $1847e9be7ba495c5$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $1847e9be7ba495c5$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $1847e9be7ba495c5$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $1847e9be7ba495c5$var$retIndex(0, pos);
        if (pos == this.size) return $1847e9be7ba495c5$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $1847e9be7ba495c5$var$retIndex(i + 1, end);
                return $1847e9be7ba495c5$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $1847e9be7ba495c5$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $1847e9be7ba495c5$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $1847e9be7ba495c5$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $1847e9be7ba495c5$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $1847e9be7ba495c5$export$ffb0004e005737fa.empty;
        if (nodes instanceof $1847e9be7ba495c5$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $1847e9be7ba495c5$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $1847e9be7ba495c5$export$ffb0004e005737fa.empty = new $1847e9be7ba495c5$export$ffb0004e005737fa([], 0);
const $1847e9be7ba495c5$var$found = {
    index: 0,
    offset: 0
};
function $1847e9be7ba495c5$var$retIndex(index, offset) {
    $1847e9be7ba495c5$var$found.index = index;
    $1847e9be7ba495c5$var$found.offset = offset;
    return $1847e9be7ba495c5$var$found;
}
function $1847e9be7ba495c5$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$1847e9be7ba495c5$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$1847e9be7ba495c5$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $1847e9be7ba495c5$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $1847e9be7ba495c5$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $1847e9be7ba495c5$export$c9d15bcfc6d42044.none;
        if (marks instanceof $1847e9be7ba495c5$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $1847e9be7ba495c5$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $1847e9be7ba495c5$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $1847e9be7ba495c5$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $1847e9be7ba495c5$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $1847e9be7ba495c5$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $1847e9be7ba495c5$export$b3f2e2de3a8baa1e($1847e9be7ba495c5$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $1847e9be7ba495c5$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $1847e9be7ba495c5$export$b3f2e2de3a8baa1e($1847e9be7ba495c5$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $1847e9be7ba495c5$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $1847e9be7ba495c5$export$b3f2e2de3a8baa1e.empty = new $1847e9be7ba495c5$export$b3f2e2de3a8baa1e($1847e9be7ba495c5$export$ffb0004e005737fa.empty, 0, 0);
function $1847e9be7ba495c5$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($1847e9be7ba495c5$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $1847e9be7ba495c5$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $1847e9be7ba495c5$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $1847e9be7ba495c5$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $1847e9be7ba495c5$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $1847e9be7ba495c5$export$6de0e778727af3f2("Inconsistent open depths");
    return $1847e9be7ba495c5$var$replaceOuter($from, $to, slice, 0);
}
function $1847e9be7ba495c5$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $1847e9be7ba495c5$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $1847e9be7ba495c5$var$close(node, $1847e9be7ba495c5$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $1847e9be7ba495c5$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $1847e9be7ba495c5$var$prepareSliceForReplace(slice, $from);
        return $1847e9be7ba495c5$var$close(node, $1847e9be7ba495c5$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $1847e9be7ba495c5$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $1847e9be7ba495c5$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $1847e9be7ba495c5$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $1847e9be7ba495c5$var$checkJoin(node, $after.node(depth));
    return node;
}
function $1847e9be7ba495c5$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $1847e9be7ba495c5$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $1847e9be7ba495c5$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$1847e9be7ba495c5$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $1847e9be7ba495c5$var$addNode($end.nodeBefore, target);
}
function $1847e9be7ba495c5$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $1847e9be7ba495c5$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $1847e9be7ba495c5$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $1847e9be7ba495c5$var$joinable($end, $to, depth + 1);
    let content = [];
    $1847e9be7ba495c5$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $1847e9be7ba495c5$var$checkJoin(openStart, openEnd);
        $1847e9be7ba495c5$var$addNode($1847e9be7ba495c5$var$close(openStart, $1847e9be7ba495c5$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $1847e9be7ba495c5$var$addNode($1847e9be7ba495c5$var$close(openStart, $1847e9be7ba495c5$var$replaceTwoWay($from, $start, depth + 1)), content);
        $1847e9be7ba495c5$var$addRange($start, $end, depth, content);
        if (openEnd) $1847e9be7ba495c5$var$addNode($1847e9be7ba495c5$var$close(openEnd, $1847e9be7ba495c5$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $1847e9be7ba495c5$var$addRange($to, null, depth, content);
    return new $1847e9be7ba495c5$export$ffb0004e005737fa(content);
}
function $1847e9be7ba495c5$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $1847e9be7ba495c5$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $1847e9be7ba495c5$var$joinable($from, $to, depth + 1);
        $1847e9be7ba495c5$var$addNode($1847e9be7ba495c5$var$close(type, $1847e9be7ba495c5$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $1847e9be7ba495c5$var$addRange($to, null, depth, content);
    return new $1847e9be7ba495c5$export$ffb0004e005737fa(content);
}
function $1847e9be7ba495c5$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($1847e9be7ba495c5$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $1847e9be7ba495c5$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $1847e9be7ba495c5$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $1847e9be7ba495c5$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $1847e9be7ba495c5$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $1847e9be7ba495c5$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $1847e9be7ba495c5$var$resolveCache.set(doc, cache = new $1847e9be7ba495c5$var$ResolveCache);
        let result = cache.elts[cache.i] = $1847e9be7ba495c5$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $1847e9be7ba495c5$var$resolveCacheSize;
        return result;
    }
}
class $1847e9be7ba495c5$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $1847e9be7ba495c5$var$resolveCacheSize = 12, $1847e9be7ba495c5$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $1847e9be7ba495c5$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $1847e9be7ba495c5$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $1847e9be7ba495c5$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $1847e9be7ba495c5$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $1847e9be7ba495c5$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $1847e9be7ba495c5$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $1847e9be7ba495c5$var$emptyAttrs) && $1847e9be7ba495c5$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $1847e9be7ba495c5$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $1847e9be7ba495c5$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $1847e9be7ba495c5$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $1847e9be7ba495c5$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $1847e9be7ba495c5$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $1847e9be7ba495c5$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $1847e9be7ba495c5$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $1847e9be7ba495c5$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $1847e9be7ba495c5$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $1847e9be7ba495c5$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $1847e9be7ba495c5$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$1847e9be7ba495c5$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $1847e9be7ba495c5$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$1847e9be7ba495c5$export$85c928794f8d04d4.prototype.text = undefined;
class $1847e9be7ba495c5$var$TextNode extends $1847e9be7ba495c5$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $1847e9be7ba495c5$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $1847e9be7ba495c5$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $1847e9be7ba495c5$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $1847e9be7ba495c5$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $1847e9be7ba495c5$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $1847e9be7ba495c5$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $1847e9be7ba495c5$export$364ed450558d7ec4.empty;
        let expr = $1847e9be7ba495c5$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $1847e9be7ba495c5$var$dfa($1847e9be7ba495c5$var$nfa(expr));
        $1847e9be7ba495c5$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $1847e9be7ba495c5$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $1847e9be7ba495c5$export$364ed450558d7ec4.empty = new $1847e9be7ba495c5$export$364ed450558d7ec4(true);
class $1847e9be7ba495c5$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $1847e9be7ba495c5$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($1847e9be7ba495c5$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $1847e9be7ba495c5$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($1847e9be7ba495c5$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $1847e9be7ba495c5$var$parseExprSubscript(stream) {
    let expr = $1847e9be7ba495c5$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $1847e9be7ba495c5$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $1847e9be7ba495c5$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $1847e9be7ba495c5$var$parseExprRange(stream, expr) {
    let min = $1847e9be7ba495c5$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $1847e9be7ba495c5$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $1847e9be7ba495c5$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $1847e9be7ba495c5$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $1847e9be7ba495c5$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $1847e9be7ba495c5$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $1847e9be7ba495c5$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $1847e9be7ba495c5$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $1847e9be7ba495c5$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($1847e9be7ba495c5$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $1847e9be7ba495c5$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($1847e9be7ba495c5$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $1847e9be7ba495c5$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $1847e9be7ba495c5$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($1847e9be7ba495c5$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $1847e9be7ba495c5$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $1847e9be7ba495c5$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $1847e9be7ba495c5$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $1847e9be7ba495c5$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $1847e9be7ba495c5$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $1847e9be7ba495c5$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $1847e9be7ba495c5$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $1847e9be7ba495c5$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $1847e9be7ba495c5$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $1847e9be7ba495c5$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $1847e9be7ba495c5$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $1847e9be7ba495c5$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $1847e9be7ba495c5$export$ffb0004e005737fa.from(content), $1847e9be7ba495c5$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $1847e9be7ba495c5$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $1847e9be7ba495c5$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $1847e9be7ba495c5$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $1847e9be7ba495c5$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($1847e9be7ba495c5$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $1847e9be7ba495c5$export$85c928794f8d04d4(this, attrs, content.append(after), $1847e9be7ba495c5$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $1847e9be7ba495c5$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $1847e9be7ba495c5$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $1847e9be7ba495c5$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $1847e9be7ba495c5$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $1847e9be7ba495c5$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $1847e9be7ba495c5$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $1847e9be7ba495c5$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $1847e9be7ba495c5$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $1847e9be7ba495c5$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $1847e9be7ba495c5$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $1847e9be7ba495c5$export$c9d15bcfc6d42044(this, $1847e9be7ba495c5$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $1847e9be7ba495c5$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $1847e9be7ba495c5$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $1847e9be7ba495c5$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $c3ea038052888a59$export$2e2bcd8739ae039).from(spec.nodes), instanceSpec.marks = (0, $c3ea038052888a59$export$2e2bcd8739ae039).from(spec.marks || {}), this.nodes = $1847e9be7ba495c5$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $1847e9be7ba495c5$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $1847e9be7ba495c5$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $1847e9be7ba495c5$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $1847e9be7ba495c5$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $1847e9be7ba495c5$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $1847e9be7ba495c5$var$TextNode(type, type.defaultAttrs, text, $1847e9be7ba495c5$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $1847e9be7ba495c5$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $1847e9be7ba495c5$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $1847e9be7ba495c5$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $1847e9be7ba495c5$var$isTagRule(rule) {
    return rule.tag != null;
}
function $1847e9be7ba495c5$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $1847e9be7ba495c5$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($1847e9be7ba495c5$var$isTagRule(rule)) this.tags.push(rule);
            else if ($1847e9be7ba495c5$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $1847e9be7ba495c5$var$ParseContext(this, options, false);
        context.addAll(dom, $1847e9be7ba495c5$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $1847e9be7ba495c5$var$ParseContext(this, options, true);
        context.addAll(dom, $1847e9be7ba495c5$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $1847e9be7ba495c5$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($1847e9be7ba495c5$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $1847e9be7ba495c5$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $1847e9be7ba495c5$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $1847e9be7ba495c5$export$1059c6e7d2ce5669(schema, $1847e9be7ba495c5$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $1847e9be7ba495c5$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $1847e9be7ba495c5$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $1847e9be7ba495c5$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $1847e9be7ba495c5$var$OPT_PRESERVE_WS = 1, $1847e9be7ba495c5$var$OPT_PRESERVE_WS_FULL = 2, $1847e9be7ba495c5$var$OPT_OPEN_LEFT = 4;
function $1847e9be7ba495c5$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $1847e9be7ba495c5$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $1847e9be7ba495c5$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $1847e9be7ba495c5$var$OPT_PRESERVE_WS | $1847e9be7ba495c5$var$OPT_PRESERVE_WS_FULL : base & ~$1847e9be7ba495c5$var$OPT_OPEN_LEFT;
}
class $1847e9be7ba495c5$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $1847e9be7ba495c5$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $1847e9be7ba495c5$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($1847e9be7ba495c5$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $1847e9be7ba495c5$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $1847e9be7ba495c5$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($1847e9be7ba495c5$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$1847e9be7ba495c5$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $1847e9be7ba495c5$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $1847e9be7ba495c5$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $1847e9be7ba495c5$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $1847e9be7ba495c5$var$NodeContext(topNode.type, topNode.attrs, $1847e9be7ba495c5$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $1847e9be7ba495c5$var$NodeContext(null, null, $1847e9be7ba495c5$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $1847e9be7ba495c5$var$NodeContext(parser.schema.topNodeType, null, $1847e9be7ba495c5$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $1847e9be7ba495c5$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $1847e9be7ba495c5$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($1847e9be7ba495c5$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $1847e9be7ba495c5$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $1847e9be7ba495c5$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($1847e9be7ba495c5$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $1847e9be7ba495c5$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $1847e9be7ba495c5$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $1847e9be7ba495c5$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $1847e9be7ba495c5$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $1847e9be7ba495c5$var$OPT_OPEN_LEFT;
        let applyMarks = $1847e9be7ba495c5$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $1847e9be7ba495c5$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $1847e9be7ba495c5$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $1847e9be7ba495c5$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $1847e9be7ba495c5$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $1847e9be7ba495c5$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $1847e9be7ba495c5$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $1847e9be7ba495c5$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $1847e9be7ba495c5$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $1847e9be7ba495c5$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $1847e9be7ba495c5$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $1847e9be7ba495c5$var$renderSpec($1847e9be7ba495c5$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $1847e9be7ba495c5$var$renderSpec($1847e9be7ba495c5$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $1847e9be7ba495c5$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $1847e9be7ba495c5$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $1847e9be7ba495c5$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $1847e9be7ba495c5$var$gatherToDOM(schema.marks);
    }
}
function $1847e9be7ba495c5$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $1847e9be7ba495c5$var$doc(options) {
    return options.document || window.document;
}
const $1847e9be7ba495c5$var$suspiciousAttributeCache = new WeakMap();
function $1847e9be7ba495c5$var$suspiciousAttributes(attrs) {
    let value = $1847e9be7ba495c5$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $1847e9be7ba495c5$var$suspiciousAttributeCache.set(attrs, value = $1847e9be7ba495c5$var$suspiciousAttributesInner(attrs));
    return value;
}
function $1847e9be7ba495c5$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $1847e9be7ba495c5$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $1847e9be7ba495c5$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $1847e9be7ba495c5$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}



// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $72a42b551bab6846$var$lower16 = 0xffff;
const $72a42b551bab6846$var$factor16 = Math.pow(2, 16);
function $72a42b551bab6846$var$makeRecover(index, offset) {
    return index + offset * $72a42b551bab6846$var$factor16;
}
function $72a42b551bab6846$var$recoverIndex(value) {
    return value & $72a42b551bab6846$var$lower16;
}
function $72a42b551bab6846$var$recoverOffset(value) {
    return (value - (value & $72a42b551bab6846$var$lower16)) / $72a42b551bab6846$var$factor16;
}
const $72a42b551bab6846$var$DEL_BEFORE = 1, $72a42b551bab6846$var$DEL_AFTER = 2, $72a42b551bab6846$var$DEL_ACROSS = 4, $72a42b551bab6846$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $72a42b551bab6846$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $72a42b551bab6846$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($72a42b551bab6846$var$DEL_BEFORE | $72a42b551bab6846$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($72a42b551bab6846$var$DEL_AFTER | $72a42b551bab6846$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $72a42b551bab6846$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $72a42b551bab6846$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $72a42b551bab6846$export$c53d01c3ab9721b3.empty) return $72a42b551bab6846$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $72a42b551bab6846$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $72a42b551bab6846$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $72a42b551bab6846$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $72a42b551bab6846$var$DEL_AFTER : pos == end ? $72a42b551bab6846$var$DEL_BEFORE : $72a42b551bab6846$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $72a42b551bab6846$var$DEL_SIDE;
                return new $72a42b551bab6846$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $72a42b551bab6846$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $72a42b551bab6846$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $72a42b551bab6846$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $72a42b551bab6846$export$c53d01c3ab9721b3.empty : new $72a42b551bab6846$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $72a42b551bab6846$export$c53d01c3ab9721b3.empty = new $72a42b551bab6846$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $72a42b551bab6846$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $72a42b551bab6846$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $72a42b551bab6846$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $72a42b551bab6846$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $72a42b551bab6846$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $72a42b551bab6846$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $72a42b551bab6846$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $72a42b551bab6846$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $72a42b551bab6846$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $72a42b551bab6846$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $72a42b551bab6846$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $72a42b551bab6846$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $72a42b551bab6846$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $72a42b551bab6846$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $72a42b551bab6846$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $1847e9be7ba495c5$export$6de0e778727af3f2)) return $72a42b551bab6846$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $72a42b551bab6846$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($72a42b551bab6846$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $1847e9be7ba495c5$export$ffb0004e005737fa).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $72a42b551bab6846$export$d24ba56b0e3464a9 extends $72a42b551bab6846$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($72a42b551bab6846$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $72a42b551bab6846$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $72a42b551bab6846$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $72a42b551bab6846$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $72a42b551bab6846$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $72a42b551bab6846$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $72a42b551bab6846$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$72a42b551bab6846$export$fd55ce593607084a.jsonID("addMark", $72a42b551bab6846$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $72a42b551bab6846$export$94150db1311f67a9 extends $72a42b551bab6846$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($72a42b551bab6846$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $72a42b551bab6846$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $72a42b551bab6846$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $72a42b551bab6846$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $72a42b551bab6846$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $72a42b551bab6846$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $72a42b551bab6846$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$72a42b551bab6846$export$fd55ce593607084a.jsonID("removeMark", $72a42b551bab6846$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $72a42b551bab6846$export$adefd16c402fee4e extends $72a42b551bab6846$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $72a42b551bab6846$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $72a42b551bab6846$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $72a42b551bab6846$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $72a42b551bab6846$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $72a42b551bab6846$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $72a42b551bab6846$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $72a42b551bab6846$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$72a42b551bab6846$export$fd55ce593607084a.jsonID("addNodeMark", $72a42b551bab6846$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $72a42b551bab6846$export$fdf7d1dc10724da2 extends $72a42b551bab6846$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $72a42b551bab6846$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $72a42b551bab6846$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $72a42b551bab6846$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $72a42b551bab6846$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $72a42b551bab6846$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$72a42b551bab6846$export$fd55ce593607084a.jsonID("removeNodeMark", $72a42b551bab6846$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $72a42b551bab6846$export$5c860b2e74034756 extends $72a42b551bab6846$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $72a42b551bab6846$var$contentBetween(doc, this.from, this.to)) return $72a42b551bab6846$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $72a42b551bab6846$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $72a42b551bab6846$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $72a42b551bab6846$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $72a42b551bab6846$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $72a42b551bab6846$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty : new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $72a42b551bab6846$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty : new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $72a42b551bab6846$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $72a42b551bab6846$export$5c860b2e74034756(json.from, json.to, (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).fromJSON(schema, json.slice), !!json.structure);
    }
}
$72a42b551bab6846$export$fd55ce593607084a.jsonID("replace", $72a42b551bab6846$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $72a42b551bab6846$export$444ba800d6024a98 extends $72a42b551bab6846$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($72a42b551bab6846$var$contentBetween(doc, this.from, this.gapFrom) || $72a42b551bab6846$var$contentBetween(doc, this.gapTo, this.to))) return $72a42b551bab6846$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $72a42b551bab6846$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $72a42b551bab6846$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $72a42b551bab6846$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $72a42b551bab6846$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $72a42b551bab6846$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $72a42b551bab6846$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $72a42b551bab6846$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$72a42b551bab6846$export$fd55ce593607084a.jsonID("replaceAround", $72a42b551bab6846$export$444ba800d6024a98);
function $72a42b551bab6846$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $72a42b551bab6846$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $72a42b551bab6846$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $72a42b551bab6846$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $72a42b551bab6846$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $1847e9be7ba495c5$export$b6a78689043c6521)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $72a42b551bab6846$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $72a42b551bab6846$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $72a42b551bab6846$export$5c860b2e74034756(cur, end, (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $72a42b551bab6846$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $72a42b551bab6846$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, true);
        tr.replace(cur, cur, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $72a42b551bab6846$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $72a42b551bab6846$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$72a42b551bab6846$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $72a42b551bab6846$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $72a42b551bab6846$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $72a42b551bab6846$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $72a42b551bab6846$var$findWrappingOutside(range, nodeType);
    let inner = around && $72a42b551bab6846$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($72a42b551bab6846$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($72a42b551bab6846$var$withAttrs));
}
function $72a42b551bab6846$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $72a42b551bab6846$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $72a42b551bab6846$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $72a42b551bab6846$var$wrap(tr, range, wrappers) {
    let content = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $72a42b551bab6846$export$444ba800d6024a98(start, end, start, end, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(content, 0, 0), wrappers.length, true));
}
function $72a42b551bab6846$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $72a42b551bab6846$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $72a42b551bab6846$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $72a42b551bab6846$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $72a42b551bab6846$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $72a42b551bab6846$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $72a42b551bab6846$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $72a42b551bab6846$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $72a42b551bab6846$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $72a42b551bab6846$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $72a42b551bab6846$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $72a42b551bab6846$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $72a42b551bab6846$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, after = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $72a42b551bab6846$export$5c860b2e74034756(pos, pos, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $72a42b551bab6846$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $72a42b551bab6846$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $72a42b551bab6846$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $72a42b551bab6846$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $72a42b551bab6846$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $72a42b551bab6846$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $72a42b551bab6846$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $72a42b551bab6846$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $72a42b551bab6846$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $72a42b551bab6846$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $72a42b551bab6846$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $72a42b551bab6846$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $72a42b551bab6846$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $72a42b551bab6846$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $72a42b551bab6846$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($72a42b551bab6846$var$fitsTrivially($from, $to, slice)) return new $72a42b551bab6846$export$5c860b2e74034756(from, to, slice);
    return new $72a42b551bab6846$var$Fitter($from, $to, slice).fit();
}
function $72a42b551bab6846$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $72a42b551bab6846$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(content, openStart, openEnd);
        if (moveInline > -1) return new $72a42b551bab6846$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $72a42b551bab6846$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $72a42b551bab6846$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $72a42b551bab6846$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $72a42b551bab6846$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($72a42b551bab6846$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($72a42b551bab6846$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($72a42b551bab6846$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $72a42b551bab6846$var$addToFragment(this.placed, frontierDepth, (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($72a42b551bab6846$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty : new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($72a42b551bab6846$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$72a42b551bab6846$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $72a42b551bab6846$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $72a42b551bab6846$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $72a42b551bab6846$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $72a42b551bab6846$var$addToFragment(this.placed, this.depth, (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, true);
        if (add.childCount) this.placed = $72a42b551bab6846$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $72a42b551bab6846$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($72a42b551bab6846$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $72a42b551bab6846$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($72a42b551bab6846$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $72a42b551bab6846$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $72a42b551bab6846$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $72a42b551bab6846$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, true));
    }
    return node.copy(frag);
}
function $72a42b551bab6846$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$72a42b551bab6846$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $72a42b551bab6846$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $72a42b551bab6846$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $72a42b551bab6846$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($72a42b551bab6846$var$fitsTrivially($from, $to, slice)) return tr.step(new $72a42b551bab6846$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $72a42b551bab6846$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $72a42b551bab6846$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($72a42b551bab6846$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $72a42b551bab6846$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($72a42b551bab6846$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, true));
    }
    return fragment;
}
function $72a42b551bab6846$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $72a42b551bab6846$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(node), 0, 0));
}
function $72a42b551bab6846$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $72a42b551bab6846$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $72a42b551bab6846$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $72a42b551bab6846$export$626399c38172f669 extends $72a42b551bab6846$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $72a42b551bab6846$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $72a42b551bab6846$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $72a42b551bab6846$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $72a42b551bab6846$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $72a42b551bab6846$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $72a42b551bab6846$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$72a42b551bab6846$export$fd55ce593607084a.jsonID("attr", $72a42b551bab6846$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $72a42b551bab6846$export$f50707b396300ac9 extends $72a42b551bab6846$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $72a42b551bab6846$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $72a42b551bab6846$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $72a42b551bab6846$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $72a42b551bab6846$export$f50707b396300ac9(json.attr, json.value);
    }
}
$72a42b551bab6846$export$fd55ce593607084a.jsonID("docAttr", $72a42b551bab6846$export$f50707b396300ac9);
/**
@internal
*/ let $72a42b551bab6846$export$88cc3a1dfce48dd3 = class extends Error {
};
$72a42b551bab6846$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$72a42b551bab6846$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$72a42b551bab6846$export$88cc3a1dfce48dd3.prototype.constructor = $72a42b551bab6846$export$88cc3a1dfce48dd3;
$72a42b551bab6846$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $72a42b551bab6846$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $72a42b551bab6846$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $72a42b551bab6846$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty) {
        let step = $72a42b551bab6846$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $72a42b551bab6846$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $72a42b551bab6846$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $72a42b551bab6846$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $72a42b551bab6846$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $72a42b551bab6846$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $72a42b551bab6846$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $72a42b551bab6846$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $72a42b551bab6846$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $72a42b551bab6846$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $72a42b551bab6846$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $72a42b551bab6846$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $1847e9be7ba495c5$export$c9d15bcfc6d42044))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $72a42b551bab6846$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $72a42b551bab6846$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $72a42b551bab6846$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $72a42b551bab6846$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $72a42b551bab6846$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}


const $6acde7918354ce68$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $6acde7918354ce68$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $6acde7918354ce68$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty : content);
            if (i == 0) $6acde7918354ce68$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $6acde7918354ce68$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $6acde7918354ce68$export$c2b25f346d19bcbb($pos) : $6acde7918354ce68$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $6acde7918354ce68$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $6acde7918354ce68$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $6acde7918354ce68$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $6acde7918354ce68$var$findSelectionIn(doc, doc, 0, 0, 1) || new $6acde7918354ce68$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $6acde7918354ce68$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $6acde7918354ce68$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $6acde7918354ce68$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $6acde7918354ce68$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $6acde7918354ce68$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $6acde7918354ce68$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$6acde7918354ce68$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $6acde7918354ce68$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $6acde7918354ce68$var$warnedAboutTextSelection = false;
function $6acde7918354ce68$var$checkTextSelection($pos) {
    if (!$6acde7918354ce68$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $6acde7918354ce68$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $6acde7918354ce68$export$c2b25f346d19bcbb extends $6acde7918354ce68$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $6acde7918354ce68$var$checkTextSelection($anchor);
        $6acde7918354ce68$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $6acde7918354ce68$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $6acde7918354ce68$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty) {
        super.replace(tr, content);
        if (content == (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $6acde7918354ce68$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $6acde7918354ce68$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $6acde7918354ce68$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $6acde7918354ce68$export$52baac22726c72bf.findFrom($head, bias, true) || $6acde7918354ce68$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $6acde7918354ce68$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($6acde7918354ce68$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $6acde7918354ce68$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $6acde7918354ce68$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$6acde7918354ce68$export$52baac22726c72bf.jsonID("text", $6acde7918354ce68$export$c2b25f346d19bcbb);
class $6acde7918354ce68$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $6acde7918354ce68$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $6acde7918354ce68$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $6acde7918354ce68$export$e2940151ac854c0b extends $6acde7918354ce68$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $6acde7918354ce68$export$52baac22726c72bf.near($pos);
        return new $6acde7918354ce68$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $6acde7918354ce68$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $6acde7918354ce68$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $6acde7918354ce68$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $6acde7918354ce68$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$6acde7918354ce68$export$e2940151ac854c0b.prototype.visible = false;
$6acde7918354ce68$export$52baac22726c72bf.jsonID("node", $6acde7918354ce68$export$e2940151ac854c0b);
class $6acde7918354ce68$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $6acde7918354ce68$var$TextBookmark(pos, pos) : new $6acde7918354ce68$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $6acde7918354ce68$export$e2940151ac854c0b.isSelectable(node)) return new $6acde7918354ce68$export$e2940151ac854c0b($pos);
        return $6acde7918354ce68$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $6acde7918354ce68$export$c15d9ba76bdbcd95 extends $6acde7918354ce68$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty) {
        if (content == (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $6acde7918354ce68$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $6acde7918354ce68$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $6acde7918354ce68$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $6acde7918354ce68$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $6acde7918354ce68$var$AllBookmark;
    }
}
$6acde7918354ce68$export$52baac22726c72bf.jsonID("all", $6acde7918354ce68$export$c15d9ba76bdbcd95);
const $6acde7918354ce68$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $6acde7918354ce68$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $6acde7918354ce68$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $6acde7918354ce68$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $6acde7918354ce68$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $6acde7918354ce68$export$e2940151ac854c0b.isSelectable(child)) return $6acde7918354ce68$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $6acde7918354ce68$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $72a42b551bab6846$export$5c860b2e74034756) || step instanceof (0, $72a42b551bab6846$export$444ba800d6024a98))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($6acde7918354ce68$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $6acde7918354ce68$var$UPDATED_SEL = 1, $6acde7918354ce68$var$UPDATED_MARKS = 2, $6acde7918354ce68$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $6acde7918354ce68$export$febc5573c75cefb0 extends (0, $72a42b551bab6846$export$563a914cafbdc389) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $6acde7918354ce68$var$UPDATED_SEL) & ~$6acde7918354ce68$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $6acde7918354ce68$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $6acde7918354ce68$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $1847e9be7ba495c5$export$c9d15bcfc6d42044).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $6acde7918354ce68$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$6acde7918354ce68$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $1847e9be7ba495c5$export$c9d15bcfc6d42044).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($6acde7918354ce68$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $6acde7918354ce68$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $6acde7918354ce68$var$UPDATED_SCROLL) > 0;
    }
}
function $6acde7918354ce68$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $6acde7918354ce68$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $6acde7918354ce68$var$bind(desc.init, self);
        this.apply = $6acde7918354ce68$var$bind(desc.apply, self);
    }
}
const $6acde7918354ce68$var$baseFields = [
    new $6acde7918354ce68$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $6acde7918354ce68$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $6acde7918354ce68$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $6acde7918354ce68$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $6acde7918354ce68$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $6acde7918354ce68$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $6acde7918354ce68$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $6acde7918354ce68$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $6acde7918354ce68$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $6acde7918354ce68$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $6acde7918354ce68$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $6acde7918354ce68$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $6acde7918354ce68$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $6acde7918354ce68$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $6acde7918354ce68$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == "object") for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $6acde7918354ce68$var$Configuration(config.schema, config.plugins);
        let instance = new $6acde7918354ce68$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $1847e9be7ba495c5$export$85c928794f8d04d4).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $6acde7918354ce68$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $6acde7918354ce68$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $6acde7918354ce68$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $6acde7918354ce68$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $6acde7918354ce68$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $6acde7918354ce68$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $6acde7918354ce68$var$keys = Object.create(null);
function $6acde7918354ce68$var$createKey(name) {
    if (name in $6acde7918354ce68$var$keys) return name + "$" + ++$6acde7918354ce68$var$keys[name];
    $6acde7918354ce68$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $6acde7918354ce68$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $6acde7918354ce68$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}




// view/index.ts



const $5b3735bad55c10ce$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $5b3735bad55c10ce$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $5b3735bad55c10ce$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $5b3735bad55c10ce$var$textRange = function(node, from, to) {
    let range = $5b3735bad55c10ce$var$reusedRange || ($5b3735bad55c10ce$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $5b3735bad55c10ce$var$clearReusedRange = function() {
    $5b3735bad55c10ce$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $5b3735bad55c10ce$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($5b3735bad55c10ce$var$scanFor(node, off, targetNode, targetOff, -1) || $5b3735bad55c10ce$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $5b3735bad55c10ce$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $5b3735bad55c10ce$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $5b3735bad55c10ce$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $5b3735bad55c10ce$var$hasBlockDesc(node) || $5b3735bad55c10ce$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $5b3735bad55c10ce$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $5b3735bad55c10ce$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $5b3735bad55c10ce$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $5b3735bad55c10ce$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $5b3735bad55c10ce$var$nodeSize(node);
        } else if (node.parentNode && !$5b3735bad55c10ce$var$hasBlockDesc(node)) {
            offset = $5b3735bad55c10ce$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $5b3735bad55c10ce$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$5b3735bad55c10ce$var$hasBlockDesc(node)) {
            offset = $5b3735bad55c10ce$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $5b3735bad55c10ce$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $5b3735bad55c10ce$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $5b3735bad55c10ce$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $5b3735bad55c10ce$var$nodeSize(node);
    }
}
function $5b3735bad55c10ce$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $5b3735bad55c10ce$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $5b3735bad55c10ce$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $5b3735bad55c10ce$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $5b3735bad55c10ce$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $5b3735bad55c10ce$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($5b3735bad55c10ce$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($5b3735bad55c10ce$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $5b3735bad55c10ce$var$nav = typeof navigator != "undefined" ? navigator : null;
const $5b3735bad55c10ce$var$doc = typeof document != "undefined" ? document : null;
const $5b3735bad55c10ce$var$agent = $5b3735bad55c10ce$var$nav && $5b3735bad55c10ce$var$nav.userAgent || "";
const $5b3735bad55c10ce$var$ie_edge = /Edge\/(\d+)/.exec($5b3735bad55c10ce$var$agent);
const $5b3735bad55c10ce$var$ie_upto10 = /MSIE \d/.exec($5b3735bad55c10ce$var$agent);
const $5b3735bad55c10ce$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($5b3735bad55c10ce$var$agent);
const $5b3735bad55c10ce$var$ie = !!($5b3735bad55c10ce$var$ie_upto10 || $5b3735bad55c10ce$var$ie_11up || $5b3735bad55c10ce$var$ie_edge);
const $5b3735bad55c10ce$var$ie_version = $5b3735bad55c10ce$var$ie_upto10 ? document.documentMode : $5b3735bad55c10ce$var$ie_11up ? +$5b3735bad55c10ce$var$ie_11up[1] : $5b3735bad55c10ce$var$ie_edge ? +$5b3735bad55c10ce$var$ie_edge[1] : 0;
const $5b3735bad55c10ce$var$gecko = !$5b3735bad55c10ce$var$ie && /gecko\/(\d+)/i.test($5b3735bad55c10ce$var$agent);
$5b3735bad55c10ce$var$gecko && (/Firefox\/(\d+)/.exec($5b3735bad55c10ce$var$agent) || [
    0,
    0
])[1];
const $5b3735bad55c10ce$var$_chrome = !$5b3735bad55c10ce$var$ie && /Chrome\/(\d+)/.exec($5b3735bad55c10ce$var$agent);
const $5b3735bad55c10ce$var$chrome = !!$5b3735bad55c10ce$var$_chrome;
const $5b3735bad55c10ce$var$chrome_version = $5b3735bad55c10ce$var$_chrome ? +$5b3735bad55c10ce$var$_chrome[1] : 0;
const $5b3735bad55c10ce$var$safari = !$5b3735bad55c10ce$var$ie && !!$5b3735bad55c10ce$var$nav && /Apple Computer/.test($5b3735bad55c10ce$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $5b3735bad55c10ce$var$ios = $5b3735bad55c10ce$var$safari && (/Mobile\/\w+/.test($5b3735bad55c10ce$var$agent) || !!$5b3735bad55c10ce$var$nav && $5b3735bad55c10ce$var$nav.maxTouchPoints > 2);
const $5b3735bad55c10ce$var$mac = $5b3735bad55c10ce$var$ios || ($5b3735bad55c10ce$var$nav ? /Mac/.test($5b3735bad55c10ce$var$nav.platform) : false);
const $5b3735bad55c10ce$var$windows = $5b3735bad55c10ce$var$nav ? /Win/.test($5b3735bad55c10ce$var$nav.platform) : false;
const $5b3735bad55c10ce$var$android = /Android \d/.test($5b3735bad55c10ce$var$agent);
const $5b3735bad55c10ce$var$webkit = !!$5b3735bad55c10ce$var$doc && "webkitFontSmoothing" in $5b3735bad55c10ce$var$doc.documentElement.style;
const $5b3735bad55c10ce$var$webkit_version = $5b3735bad55c10ce$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $5b3735bad55c10ce$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $5b3735bad55c10ce$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $5b3735bad55c10ce$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $5b3735bad55c10ce$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $5b3735bad55c10ce$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $5b3735bad55c10ce$var$windowRect(doc) : $5b3735bad55c10ce$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $5b3735bad55c10ce$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $5b3735bad55c10ce$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $5b3735bad55c10ce$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $5b3735bad55c10ce$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $5b3735bad55c10ce$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $5b3735bad55c10ce$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $5b3735bad55c10ce$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $5b3735bad55c10ce$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $5b3735bad55c10ce$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $5b3735bad55c10ce$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $5b3735bad55c10ce$var$scrollStack(view.dom)
    };
}
function $5b3735bad55c10ce$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $5b3735bad55c10ce$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $5b3735bad55c10ce$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $5b3735bad55c10ce$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $5b3735bad55c10ce$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $5b3735bad55c10ce$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $5b3735bad55c10ce$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($5b3735bad55c10ce$var$preventScrollSupported) return dom.focus($5b3735bad55c10ce$var$preventScrollSupported);
    let stored = $5b3735bad55c10ce$var$scrollStack(dom);
    dom.focus($5b3735bad55c10ce$var$preventScrollSupported == null ? {
        get preventScroll () {
            $5b3735bad55c10ce$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$5b3735bad55c10ce$var$preventScrollSupported) {
        $5b3735bad55c10ce$var$preventScrollSupported = false;
        $5b3735bad55c10ce$var$restoreScrollStack(stored, 0);
    }
}
function $5b3735bad55c10ce$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $5b3735bad55c10ce$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $5b3735bad55c10ce$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $5b3735bad55c10ce$var$findOffsetInNode(closest, coordsClosest);
}
function $5b3735bad55c10ce$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $5b3735bad55c10ce$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($5b3735bad55c10ce$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $5b3735bad55c10ce$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $5b3735bad55c10ce$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $5b3735bad55c10ce$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $5b3735bad55c10ce$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $5b3735bad55c10ce$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $5b3735bad55c10ce$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($5b3735bad55c10ce$var$inRect(coords, rect)) return $5b3735bad55c10ce$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $5b3735bad55c10ce$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $5b3735bad55c10ce$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$5b3735bad55c10ce$var$inRect(coords, box)) return null;
        elt = $5b3735bad55c10ce$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($5b3735bad55c10ce$var$safari) {
        for(let p = elt; node && p; p = $5b3735bad55c10ce$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $5b3735bad55c10ce$var$targetKludge(elt, coords);
    if (node) {
        if ($5b3735bad55c10ce$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($5b3735bad55c10ce$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $5b3735bad55c10ce$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $5b3735bad55c10ce$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $5b3735bad55c10ce$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $5b3735bad55c10ce$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($5b3735bad55c10ce$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $5b3735bad55c10ce$var$nonZero) || target.getBoundingClientRect();
}
const $5b3735bad55c10ce$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $5b3735bad55c10ce$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $5b3735bad55c10ce$var$webkit || $5b3735bad55c10ce$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($5b3735bad55c10ce$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $5b3735bad55c10ce$var$singleRect($5b3735bad55c10ce$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($5b3735bad55c10ce$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $5b3735bad55c10ce$var$singleRect($5b3735bad55c10ce$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $5b3735bad55c10ce$var$singleRect($5b3735bad55c10ce$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $5b3735bad55c10ce$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $5b3735bad55c10ce$var$flattenV($5b3735bad55c10ce$var$singleRect($5b3735bad55c10ce$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $5b3735bad55c10ce$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $5b3735bad55c10ce$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $5b3735bad55c10ce$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $5b3735bad55c10ce$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $5b3735bad55c10ce$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $5b3735bad55c10ce$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $5b3735bad55c10ce$var$textRange(before, $5b3735bad55c10ce$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $5b3735bad55c10ce$var$flattenV($5b3735bad55c10ce$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $5b3735bad55c10ce$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $5b3735bad55c10ce$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $5b3735bad55c10ce$var$flattenV($5b3735bad55c10ce$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $5b3735bad55c10ce$var$flattenV($5b3735bad55c10ce$var$singleRect(node.nodeType == 3 ? $5b3735bad55c10ce$var$textRange(node) : node, -side), side >= 0);
}
function $5b3735bad55c10ce$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $5b3735bad55c10ce$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $5b3735bad55c10ce$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $5b3735bad55c10ce$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $5b3735bad55c10ce$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $5b3735bad55c10ce$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $5b3735bad55c10ce$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $5b3735bad55c10ce$var$maybeRTL = /[\u0590-\u08ac]/;
function $5b3735bad55c10ce$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$5b3735bad55c10ce$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $5b3735bad55c10ce$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $5b3735bad55c10ce$var$cachedState = null;
let $5b3735bad55c10ce$var$cachedDir = null;
let $5b3735bad55c10ce$var$cachedResult = false;
function $5b3735bad55c10ce$var$endOfTextblock(view, state, dir) {
    if ($5b3735bad55c10ce$var$cachedState == state && $5b3735bad55c10ce$var$cachedDir == dir) return $5b3735bad55c10ce$var$cachedResult;
    $5b3735bad55c10ce$var$cachedState = state;
    $5b3735bad55c10ce$var$cachedDir = dir;
    return $5b3735bad55c10ce$var$cachedResult = dir == "up" || dir == "down" ? $5b3735bad55c10ce$var$endOfTextblockVertical(view, state, dir) : $5b3735bad55c10ce$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $5b3735bad55c10ce$var$NOT_DIRTY = 0, $5b3735bad55c10ce$var$CHILD_DIRTY = 1, $5b3735bad55c10ce$var$CONTENT_DIRTY = 2, $5b3735bad55c10ce$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $5b3735bad55c10ce$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $5b3735bad55c10ce$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $5b3735bad55c10ce$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $5b3735bad55c10ce$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $5b3735bad55c10ce$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $5b3735bad55c10ce$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $5b3735bad55c10ce$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $5b3735bad55c10ce$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $5b3735bad55c10ce$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($5b3735bad55c10ce$var$gecko || $5b3735bad55c10ce$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $5b3735bad55c10ce$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($5b3735bad55c10ce$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $5b3735bad55c10ce$var$safari) && $5b3735bad55c10ce$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $5b3735bad55c10ce$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $5b3735bad55c10ce$var$CONTENT_DIRTY : $5b3735bad55c10ce$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $5b3735bad55c10ce$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $5b3735bad55c10ce$var$CONTENT_DIRTY : $5b3735bad55c10ce$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $5b3735bad55c10ce$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $5b3735bad55c10ce$var$CONTENT_DIRTY : $5b3735bad55c10ce$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $5b3735bad55c10ce$var$WidgetViewDesc extends $5b3735bad55c10ce$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $5b3735bad55c10ce$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $5b3735bad55c10ce$var$CompositionViewDesc extends $5b3735bad55c10ce$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === "characterData" && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $5b3735bad55c10ce$var$MarkViewDesc extends $5b3735bad55c10ce$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $1847e9be7ba495c5$export$3476b78f8f5a8b72).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $5b3735bad55c10ce$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $5b3735bad55c10ce$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $5b3735bad55c10ce$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $5b3735bad55c10ce$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $5b3735bad55c10ce$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $5b3735bad55c10ce$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $5b3735bad55c10ce$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $5b3735bad55c10ce$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $5b3735bad55c10ce$var$NodeViewDesc extends $5b3735bad55c10ce$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $1847e9be7ba495c5$export$3476b78f8f5a8b72).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $5b3735bad55c10ce$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $5b3735bad55c10ce$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $5b3735bad55c10ce$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $5b3735bad55c10ce$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $5b3735bad55c10ce$var$NOT_DIRTY && node.eq(this.node) && $5b3735bad55c10ce$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $5b3735bad55c10ce$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $5b3735bad55c10ce$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $1847e9be7ba495c5$export$c9d15bcfc6d42044).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $5b3735bad55c10ce$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $5b3735bad55c10ce$var$renderDescs(this.contentDOM, this.children, view);
            if ($5b3735bad55c10ce$var$ios) $5b3735bad55c10ce$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $5b3735bad55c10ce$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $5b3735bad55c10ce$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $5b3735bad55c10ce$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $5b3735bad55c10ce$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $5b3735bad55c10ce$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($5b3735bad55c10ce$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $5b3735bad55c10ce$var$patchOuterDeco(this.dom, this.nodeDOM, $5b3735bad55c10ce$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $5b3735bad55c10ce$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $5b3735bad55c10ce$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $5b3735bad55c10ce$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $5b3735bad55c10ce$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $5b3735bad55c10ce$var$TextViewDesc extends $5b3735bad55c10ce$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $5b3735bad55c10ce$var$NODE_DIRTY || this.dirty != $5b3735bad55c10ce$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $5b3735bad55c10ce$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $5b3735bad55c10ce$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $5b3735bad55c10ce$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $5b3735bad55c10ce$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $5b3735bad55c10ce$var$TrailingHackViewDesc extends $5b3735bad55c10ce$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $5b3735bad55c10ce$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $5b3735bad55c10ce$var$CustomNodeViewDesc extends $5b3735bad55c10ce$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $5b3735bad55c10ce$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $5b3735bad55c10ce$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $5b3735bad55c10ce$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $5b3735bad55c10ce$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $5b3735bad55c10ce$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $5b3735bad55c10ce$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $5b3735bad55c10ce$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$5b3735bad55c10ce$var$OuterDecoLevel.prototype = Object.create(null);
const $5b3735bad55c10ce$var$noDeco = [
    new $5b3735bad55c10ce$var$OuterDecoLevel
];
function $5b3735bad55c10ce$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $5b3735bad55c10ce$var$noDeco;
    let top = needsWrap ? $5b3735bad55c10ce$var$noDeco[0] : new $5b3735bad55c10ce$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $5b3735bad55c10ce$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $5b3735bad55c10ce$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $5b3735bad55c10ce$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $5b3735bad55c10ce$var$noDeco && curComputed == $5b3735bad55c10ce$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $5b3735bad55c10ce$var$noDeco[0];
                curDOM = parent;
            }
        }
        $5b3735bad55c10ce$var$patchAttributes(curDOM, prev || $5b3735bad55c10ce$var$noDeco[0], deco);
    }
    return curDOM;
}
function $5b3735bad55c10ce$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $5b3735bad55c10ce$var$applyOuterDeco(dom, deco, node) {
    return $5b3735bad55c10ce$var$patchOuterDeco(dom, dom, $5b3735bad55c10ce$var$noDeco, $5b3735bad55c10ce$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $5b3735bad55c10ce$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $5b3735bad55c10ce$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $5b3735bad55c10ce$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $5b3735bad55c10ce$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $5b3735bad55c10ce$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $5b3735bad55c10ce$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $5b3735bad55c10ce$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $5b3735bad55c10ce$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $5b3735bad55c10ce$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $5b3735bad55c10ce$var$NODE_DIRTY && $5b3735bad55c10ce$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $5b3735bad55c10ce$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $5b3735bad55c10ce$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$5b3735bad55c10ce$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $5b3735bad55c10ce$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $5b3735bad55c10ce$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $5b3735bad55c10ce$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $5b3735bad55c10ce$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $5b3735bad55c10ce$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($5b3735bad55c10ce$var$safari || $5b3735bad55c10ce$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $5b3735bad55c10ce$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $5b3735bad55c10ce$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $5b3735bad55c10ce$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $5b3735bad55c10ce$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $5b3735bad55c10ce$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($5b3735bad55c10ce$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $5b3735bad55c10ce$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $5b3735bad55c10ce$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $5b3735bad55c10ce$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $5b3735bad55c10ce$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($5b3735bad55c10ce$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $5b3735bad55c10ce$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $6acde7918354ce68$export$e2940151ac854c0b)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $5b3735bad55c10ce$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $5b3735bad55c10ce$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $5b3735bad55c10ce$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $5b3735bad55c10ce$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $5b3735bad55c10ce$var$syncNodeSelection(view, sel);
    if (!$5b3735bad55c10ce$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $5b3735bad55c10ce$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $5b3735bad55c10ce$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $5b3735bad55c10ce$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($5b3735bad55c10ce$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $5b3735bad55c10ce$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $5b3735bad55c10ce$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($5b3735bad55c10ce$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $5b3735bad55c10ce$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $5b3735bad55c10ce$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $5b3735bad55c10ce$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $5b3735bad55c10ce$var$brokenSelectBetweenUneditable = $5b3735bad55c10ce$var$safari || $5b3735bad55c10ce$var$chrome && $5b3735bad55c10ce$var$chrome_version < 63;
function $5b3735bad55c10ce$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($5b3735bad55c10ce$var$safari && after && after.contentEditable == "false") return $5b3735bad55c10ce$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $5b3735bad55c10ce$var$setEditable(after);
        else if (before) return $5b3735bad55c10ce$var$setEditable(before);
    }
}
function $5b3735bad55c10ce$var$setEditable(element) {
    element.contentEditable = "true";
    if ($5b3735bad55c10ce$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $5b3735bad55c10ce$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $5b3735bad55c10ce$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$5b3735bad55c10ce$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $5b3735bad55c10ce$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $5b3735bad55c10ce$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $5b3735bad55c10ce$var$ie && $5b3735bad55c10ce$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $5b3735bad55c10ce$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $5b3735bad55c10ce$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $5b3735bad55c10ce$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $5b3735bad55c10ce$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $5b3735bad55c10ce$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $6acde7918354ce68$export$c2b25f346d19bcbb).between($anchor, $head, bias);
}
function $5b3735bad55c10ce$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $5b3735bad55c10ce$var$hasSelection(view);
}
function $5b3735bad55c10ce$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $5b3735bad55c10ce$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $5b3735bad55c10ce$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $5b3735bad55c10ce$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $6acde7918354ce68$export$52baac22726c72bf).findFrom($start, dir);
}
function $5b3735bad55c10ce$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $5b3735bad55c10ce$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $5b3735bad55c10ce$var$apply(view, new (0, $6acde7918354ce68$export$c2b25f346d19bcbb)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $5b3735bad55c10ce$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b)) return $5b3735bad55c10ce$var$apply(view, next);
            return false;
        } else if (!($5b3735bad55c10ce$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(node)) return $5b3735bad55c10ce$var$apply(view, new (0, $6acde7918354ce68$export$e2940151ac854c0b)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($5b3735bad55c10ce$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $5b3735bad55c10ce$var$apply(view, new (0, $6acde7918354ce68$export$c2b25f346d19bcbb)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b) && sel.node.isInline) return $5b3735bad55c10ce$var$apply(view, new (0, $6acde7918354ce68$export$c2b25f346d19bcbb)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $5b3735bad55c10ce$var$moveSelectionBlock(view.state, dir);
        if (next) return $5b3735bad55c10ce$var$apply(view, next);
        return false;
    }
}
function $5b3735bad55c10ce$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $5b3735bad55c10ce$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $5b3735bad55c10ce$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $5b3735bad55c10ce$var$skipIgnoredNodesBefore(view) : $5b3735bad55c10ce$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $5b3735bad55c10ce$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($5b3735bad55c10ce$var$gecko && node.nodeType == 1 && offset < $5b3735bad55c10ce$var$nodeLen(node) && $5b3735bad55c10ce$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($5b3735bad55c10ce$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($5b3735bad55c10ce$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $5b3735bad55c10ce$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $5b3735bad55c10ce$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $5b3735bad55c10ce$var$nodeLen(node);
            }
        }
    }
    if (force) $5b3735bad55c10ce$var$setSelFocus(view, node, offset);
    else if (moveNode) $5b3735bad55c10ce$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $5b3735bad55c10ce$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $5b3735bad55c10ce$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($5b3735bad55c10ce$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($5b3735bad55c10ce$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $5b3735bad55c10ce$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $5b3735bad55c10ce$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $5b3735bad55c10ce$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $5b3735bad55c10ce$var$setSelFocus(view, moveNode, moveOffset);
}
function $5b3735bad55c10ce$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $5b3735bad55c10ce$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$5b3735bad55c10ce$var$hasBlockDesc(node)){
        offset = $5b3735bad55c10ce$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $5b3735bad55c10ce$var$textNodeBefore(node, offset) {
    while(node && !offset && !$5b3735bad55c10ce$var$hasBlockDesc(node)){
        offset = $5b3735bad55c10ce$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $5b3735bad55c10ce$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $5b3735bad55c10ce$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $5b3735bad55c10ce$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($5b3735bad55c10ce$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $5b3735bad55c10ce$var$selectionToDOM(view);
    }, 50);
}
function $5b3735bad55c10ce$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($5b3735bad55c10ce$var$chrome || $5b3735bad55c10ce$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $5b3735bad55c10ce$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($5b3735bad55c10ce$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $5b3735bad55c10ce$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b)) return $5b3735bad55c10ce$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $6acde7918354ce68$export$c15d9ba76bdbcd95) ? (0, $6acde7918354ce68$export$52baac22726c72bf).near(side, dir) : (0, $6acde7918354ce68$export$52baac22726c72bf).findFrom(side, dir);
        return beyond ? $5b3735bad55c10ce$var$apply(view, beyond) : false;
    }
    return false;
}
function $5b3735bad55c10ce$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $5b3735bad55c10ce$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $5b3735bad55c10ce$var$safariDownArrowBug(view) {
    if (!$5b3735bad55c10ce$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $5b3735bad55c10ce$var$switchEditable(view, child, "true");
        setTimeout(()=>$5b3735bad55c10ce$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $5b3735bad55c10ce$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $5b3735bad55c10ce$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $5b3735bad55c10ce$var$getMods(event);
    if (code == 8 || $5b3735bad55c10ce$var$mac && code == 72 && mods == "c") return $5b3735bad55c10ce$var$stopNativeHorizontalDelete(view, -1) || $5b3735bad55c10ce$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $5b3735bad55c10ce$var$mac && code == 68 && mods == "c") return $5b3735bad55c10ce$var$stopNativeHorizontalDelete(view, 1) || $5b3735bad55c10ce$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $5b3735bad55c10ce$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $5b3735bad55c10ce$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $5b3735bad55c10ce$var$selectHorizontally(view, dir, mods) || $5b3735bad55c10ce$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $5b3735bad55c10ce$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $5b3735bad55c10ce$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $5b3735bad55c10ce$var$selectHorizontally(view, dir, mods) || $5b3735bad55c10ce$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $5b3735bad55c10ce$var$mac && code == 80 && mods == "c") return $5b3735bad55c10ce$var$selectVertically(view, -1, mods) || $5b3735bad55c10ce$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $5b3735bad55c10ce$var$mac && code == 78 && mods == "c") return $5b3735bad55c10ce$var$safariDownArrowBug(view) || $5b3735bad55c10ce$var$selectVertically(view, 1, mods) || $5b3735bad55c10ce$var$skipIgnoredNodes(view, 1);
    else if (mods == ($5b3735bad55c10ce$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $5b3735bad55c10ce$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $1847e9be7ba495c5$export$3476b78f8f5a8b72).fromSchema(view.state.schema);
    let doc = $5b3735bad55c10ce$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $5b3735bad55c10ce$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $5b3735bad55c10ce$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $1847e9be7ba495c5$export$3476b78f8f5a8b72).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $5b3735bad55c10ce$var$readHTML(html);
        if ($5b3735bad55c10ce$var$webkit) $5b3735bad55c10ce$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $1847e9be7ba495c5$export$1059c6e7d2ce5669).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$5b3735bad55c10ce$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $5b3735bad55c10ce$var$addContext($5b3735bad55c10ce$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).maxOpen($5b3735bad55c10ce$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $5b3735bad55c10ce$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $5b3735bad55c10ce$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $5b3735bad55c10ce$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $5b3735bad55c10ce$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $5b3735bad55c10ce$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $5b3735bad55c10ce$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(result);
    }
    return fragment;
}
function $5b3735bad55c10ce$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $5b3735bad55c10ce$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $5b3735bad55c10ce$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from($5b3735bad55c10ce$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $5b3735bad55c10ce$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $5b3735bad55c10ce$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, true);
    return node.copy(fragment.append(fill));
}
function $5b3735bad55c10ce$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $5b3735bad55c10ce$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $5b3735bad55c10ce$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($5b3735bad55c10ce$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)($5b3735bad55c10ce$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $5b3735bad55c10ce$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $5b3735bad55c10ce$var$_detachedDoc = null;
function $5b3735bad55c10ce$var$detachedDoc() {
    return $5b3735bad55c10ce$var$_detachedDoc || ($5b3735bad55c10ce$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $5b3735bad55c10ce$var$_policy = null;
function $5b3735bad55c10ce$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$5b3735bad55c10ce$var$_policy) $5b3735bad55c10ce$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $5b3735bad55c10ce$var$_policy.createHTML(html);
}
function $5b3735bad55c10ce$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $5b3735bad55c10ce$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $5b3735bad55c10ce$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $5b3735bad55c10ce$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $5b3735bad55c10ce$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($5b3735bad55c10ce$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\xa0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $5b3735bad55c10ce$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $5b3735bad55c10ce$var$handlers = {};
const $5b3735bad55c10ce$var$editHandlers = {};
const $5b3735bad55c10ce$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $5b3735bad55c10ce$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $5b3735bad55c10ce$var$initInput(view) {
    for(let event in $5b3735bad55c10ce$var$handlers){
        let handler = $5b3735bad55c10ce$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($5b3735bad55c10ce$var$eventBelongsToView(view, event) && !$5b3735bad55c10ce$var$runCustomHandler(view, event) && (view.editable || !(event.type in $5b3735bad55c10ce$var$editHandlers))) handler(view, event);
        }, $5b3735bad55c10ce$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($5b3735bad55c10ce$var$safari) view.dom.addEventListener("input", ()=>null);
    $5b3735bad55c10ce$var$ensureListeners(view);
}
function $5b3735bad55c10ce$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $5b3735bad55c10ce$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $5b3735bad55c10ce$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$5b3735bad55c10ce$var$runCustomHandler(view, event));
    });
}
function $5b3735bad55c10ce$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $5b3735bad55c10ce$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $5b3735bad55c10ce$var$dispatchEvent(view, event) {
    if (!$5b3735bad55c10ce$var$runCustomHandler(view, event) && $5b3735bad55c10ce$var$handlers[event.type] && (view.editable || !(event.type in $5b3735bad55c10ce$var$editHandlers))) $5b3735bad55c10ce$var$handlers[event.type](view, event);
}
$5b3735bad55c10ce$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($5b3735bad55c10ce$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($5b3735bad55c10ce$var$android && $5b3735bad55c10ce$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($5b3735bad55c10ce$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $5b3735bad55c10ce$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $5b3735bad55c10ce$var$captureKeyDown(view, event)) event.preventDefault();
    else $5b3735bad55c10ce$var$setSelectionOrigin(view, "key");
};
$5b3735bad55c10ce$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$5b3735bad55c10ce$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($5b3735bad55c10ce$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $5b3735bad55c10ce$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $5b3735bad55c10ce$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $5b3735bad55c10ce$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $5b3735bad55c10ce$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $5b3735bad55c10ce$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $5b3735bad55c10ce$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(node)) {
        $5b3735bad55c10ce$var$updateSelection(view, new (0, $6acde7918354ce68$export$e2940151ac854c0b)($pos), "pointer");
        return true;
    }
    return false;
}
function $5b3735bad55c10ce$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $5b3735bad55c10ce$var$updateSelection(view, (0, $6acde7918354ce68$export$e2940151ac854c0b).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $5b3735bad55c10ce$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $5b3735bad55c10ce$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $5b3735bad55c10ce$var$selectClickedNode(view, inside) : $5b3735bad55c10ce$var$selectClickedLeaf(view, inside));
}
function $5b3735bad55c10ce$var$handleDoubleClick(view, pos, inside, event) {
    return $5b3735bad55c10ce$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $5b3735bad55c10ce$var$handleTripleClick(view, pos, inside, event) {
    return $5b3735bad55c10ce$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $5b3735bad55c10ce$var$defaultTripleClick(view, inside, event);
}
function $5b3735bad55c10ce$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $5b3735bad55c10ce$var$updateSelection(view, (0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $5b3735bad55c10ce$var$updateSelection(view, (0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(node)) $5b3735bad55c10ce$var$updateSelection(view, (0, $6acde7918354ce68$export$e2940151ac854c0b).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $5b3735bad55c10ce$var$forceDOMFlush(view) {
    return $5b3735bad55c10ce$var$endComposition(view);
}
const $5b3735bad55c10ce$var$selectNodeModifier = $5b3735bad55c10ce$var$mac ? "metaKey" : "ctrlKey";
$5b3735bad55c10ce$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $5b3735bad55c10ce$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $5b3735bad55c10ce$var$isNear(event, view.input.lastClick) && !event[$5b3735bad55c10ce$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($5b3735bad55c10ce$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $5b3735bad55c10ce$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $5b3735bad55c10ce$var$handleDoubleClick : $5b3735bad55c10ce$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $5b3735bad55c10ce$var$setSelectionOrigin(view, "pointer");
};
class $5b3735bad55c10ce$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$5b3735bad55c10ce$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $5b3735bad55c10ce$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $5b3735bad55c10ce$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$5b3735bad55c10ce$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($5b3735bad55c10ce$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $5b3735bad55c10ce$var$setSelectionOrigin(this.view, "pointer");
        else if ($5b3735bad55c10ce$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $5b3735bad55c10ce$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $5b3735bad55c10ce$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $5b3735bad55c10ce$var$updateSelection(this.view, (0, $6acde7918354ce68$export$52baac22726c72bf).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $5b3735bad55c10ce$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $5b3735bad55c10ce$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$5b3735bad55c10ce$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $5b3735bad55c10ce$var$forceDOMFlush(view);
    $5b3735bad55c10ce$var$setSelectionOrigin(view, "pointer");
};
$5b3735bad55c10ce$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $5b3735bad55c10ce$var$setSelectionOrigin(view, "pointer");
};
$5b3735bad55c10ce$var$handlers.contextmenu = (view)=>$5b3735bad55c10ce$var$forceDOMFlush(view);
function $5b3735bad55c10ce$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($5b3735bad55c10ce$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $5b3735bad55c10ce$var$timeoutComposition = $5b3735bad55c10ce$var$android ? 5000 : -1;
$5b3735bad55c10ce$var$editHandlers.compositionstart = $5b3735bad55c10ce$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $5b3735bad55c10ce$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $5b3735bad55c10ce$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($5b3735bad55c10ce$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $5b3735bad55c10ce$var$scheduleComposeEnd(view, $5b3735bad55c10ce$var$timeoutComposition);
};
$5b3735bad55c10ce$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $5b3735bad55c10ce$var$scheduleComposeEnd(view, 20);
    }
};
function $5b3735bad55c10ce$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$5b3735bad55c10ce$var$endComposition(view), delay);
}
function $5b3735bad55c10ce$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $5b3735bad55c10ce$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $5b3735bad55c10ce$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $5b3735bad55c10ce$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $5b3735bad55c10ce$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $5b3735bad55c10ce$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $5b3735bad55c10ce$var$endComposition(view, restarting = false) {
    if ($5b3735bad55c10ce$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $5b3735bad55c10ce$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $5b3735bad55c10ce$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $5b3735bad55c10ce$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $5b3735bad55c10ce$var$brokenClipboardAPI = $5b3735bad55c10ce$var$ie && $5b3735bad55c10ce$var$ie_version < 15 || $5b3735bad55c10ce$var$ios && $5b3735bad55c10ce$var$webkit_version < 604;
$5b3735bad55c10ce$var$handlers.copy = $5b3735bad55c10ce$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $5b3735bad55c10ce$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $5b3735bad55c10ce$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $5b3735bad55c10ce$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $5b3735bad55c10ce$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $5b3735bad55c10ce$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $5b3735bad55c10ce$var$doPaste(view, target.value, null, plain, event);
        else $5b3735bad55c10ce$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $5b3735bad55c10ce$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $5b3735bad55c10ce$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty))) return true;
    if (!slice) return false;
    let singleNode = $5b3735bad55c10ce$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $5b3735bad55c10ce$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$5b3735bad55c10ce$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$5b3735bad55c10ce$var$android) return;
    let data = $5b3735bad55c10ce$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $5b3735bad55c10ce$var$doPaste(view, $5b3735bad55c10ce$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $5b3735bad55c10ce$var$capturePaste(view, event);
};
class $5b3735bad55c10ce$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $5b3735bad55c10ce$var$dragCopyModifier = $5b3735bad55c10ce$var$mac ? "altKey" : "ctrlKey";
$5b3735bad55c10ce$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($5b3735bad55c10ce$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $6acde7918354ce68$export$e2940151ac854c0b).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $6acde7918354ce68$export$e2940151ac854c0b).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $5b3735bad55c10ce$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$5b3735bad55c10ce$var$chrome || $5b3735bad55c10ce$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($5b3735bad55c10ce$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$5b3735bad55c10ce$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $5b3735bad55c10ce$var$Dragging(slice, !event[$5b3735bad55c10ce$var$dragCopyModifier], node);
};
$5b3735bad55c10ce$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$5b3735bad55c10ce$var$editHandlers.dragover = $5b3735bad55c10ce$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$5b3735bad55c10ce$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($5b3735bad55c10ce$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $5b3735bad55c10ce$var$parseFromClipboard(view, $5b3735bad55c10ce$var$getText(event.dataTransfer), $5b3735bad55c10ce$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$5b3735bad55c10ce$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $72a42b551bab6846$export$2819d598d048fc9c)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $6acde7918354ce68$export$e2940151ac854c0b)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($5b3735bad55c10ce$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$5b3735bad55c10ce$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $5b3735bad55c10ce$var$selectionToDOM(view);
        }, 20);
    }
};
$5b3735bad55c10ce$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$5b3735bad55c10ce$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($5b3735bad55c10ce$var$chrome && $5b3735bad55c10ce$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $5b3735bad55c10ce$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $5b3735bad55c10ce$var$editHandlers)$5b3735bad55c10ce$var$handlers[prop] = $5b3735bad55c10ce$var$editHandlers[prop];
function $5b3735bad55c10ce$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $5b3735bad55c10ce$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $5b3735bad55c10ce$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $5b3735bad55c10ce$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $5b3735bad55c10ce$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $5b3735bad55c10ce$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $5b3735bad55c10ce$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $5b3735bad55c10ce$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $5b3735bad55c10ce$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $5b3735bad55c10ce$var$InlineType && $5b3735bad55c10ce$var$compareObjs(this.attrs, other.attrs) && $5b3735bad55c10ce$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $5b3735bad55c10ce$var$InlineType;
    }
    destroy() {}
}
class $5b3735bad55c10ce$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $5b3735bad55c10ce$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $5b3735bad55c10ce$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $5b3735bad55c10ce$var$NodeType && $5b3735bad55c10ce$var$compareObjs(this.attrs, other.attrs) && $5b3735bad55c10ce$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $5b3735bad55c10ce$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $5b3735bad55c10ce$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $5b3735bad55c10ce$export$10e30b733df217ea(pos, pos, new $5b3735bad55c10ce$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $5b3735bad55c10ce$export$10e30b733df217ea(from, to, new $5b3735bad55c10ce$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $5b3735bad55c10ce$export$10e30b733df217ea(from, to, new $5b3735bad55c10ce$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $5b3735bad55c10ce$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $5b3735bad55c10ce$var$WidgetType;
    }
}
const $5b3735bad55c10ce$var$none = [], $5b3735bad55c10ce$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $5b3735bad55c10ce$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $5b3735bad55c10ce$var$none;
        this.children = children.length ? children : $5b3735bad55c10ce$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $5b3735bad55c10ce$var$buildTree(decorations, doc, 0, $5b3735bad55c10ce$var$noSpec) : $5b3735bad55c10ce$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $5b3735bad55c10ce$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $5b3735bad55c10ce$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $5b3735bad55c10ce$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $5b3735bad55c10ce$export$93bf62eb445cec98(newLocal.sort($5b3735bad55c10ce$var$byPos), $5b3735bad55c10ce$var$none) : $5b3735bad55c10ce$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $5b3735bad55c10ce$var$empty) return $5b3735bad55c10ce$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $5b3735bad55c10ce$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $5b3735bad55c10ce$var$buildTree(found, childNode, baseOffset + 1, $5b3735bad55c10ce$var$noSpec));
            childIndex += 3;
        });
        let local = $5b3735bad55c10ce$var$moveSpans(childIndex ? $5b3735bad55c10ce$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $5b3735bad55c10ce$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($5b3735bad55c10ce$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $5b3735bad55c10ce$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $5b3735bad55c10ce$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $5b3735bad55c10ce$export$93bf62eb445cec98(local, children) : $5b3735bad55c10ce$var$empty;
    }
    forChild(offset, node) {
        if (this == $5b3735bad55c10ce$var$empty) return this;
        if (node.isLeaf) return $5b3735bad55c10ce$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $5b3735bad55c10ce$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $5b3735bad55c10ce$export$93bf62eb445cec98(local.sort($5b3735bad55c10ce$var$byPos), $5b3735bad55c10ce$var$none);
            return child ? new $5b3735bad55c10ce$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $5b3735bad55c10ce$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $5b3735bad55c10ce$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $5b3735bad55c10ce$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $5b3735bad55c10ce$var$empty) return $5b3735bad55c10ce$var$none;
        if (node.inlineContent || !this.local.some($5b3735bad55c10ce$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $5b3735bad55c10ce$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $5b3735bad55c10ce$export$93bf62eb445cec98.empty = new $5b3735bad55c10ce$export$93bf62eb445cec98([], []);
/**
@internal
*/ $5b3735bad55c10ce$export$93bf62eb445cec98.removeOverlap = $5b3735bad55c10ce$var$removeOverlap;
const $5b3735bad55c10ce$var$empty = $5b3735bad55c10ce$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $5b3735bad55c10ce$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $5b3735bad55c10ce$var$noSpec));
        return $5b3735bad55c10ce$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $5b3735bad55c10ce$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $5b3735bad55c10ce$var$empty) continue;
            if (result instanceof $5b3735bad55c10ce$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $5b3735bad55c10ce$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $5b3735bad55c10ce$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $5b3735bad55c10ce$var$removeOverlap(sorted ? result : result.sort($5b3735bad55c10ce$var$byPos)) : $5b3735bad55c10ce$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $5b3735bad55c10ce$var$empty;
            case 1:
                return members[0];
            default:
                return new $5b3735bad55c10ce$var$DecorationGroup(members.every((m)=>m instanceof $5b3735bad55c10ce$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $5b3735bad55c10ce$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $5b3735bad55c10ce$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $5b3735bad55c10ce$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $5b3735bad55c10ce$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $5b3735bad55c10ce$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $5b3735bad55c10ce$export$93bf62eb445cec98(newLocal.sort($5b3735bad55c10ce$var$byPos), children);
}
function $5b3735bad55c10ce$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $5b3735bad55c10ce$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $5b3735bad55c10ce$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $5b3735bad55c10ce$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $5b3735bad55c10ce$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $5b3735bad55c10ce$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $5b3735bad55c10ce$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $5b3735bad55c10ce$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $5b3735bad55c10ce$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $5b3735bad55c10ce$var$moveSpans(hasNulls ? $5b3735bad55c10ce$var$withoutNulls(spans) : spans, -offset).sort($5b3735bad55c10ce$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $5b3735bad55c10ce$export$93bf62eb445cec98(locals, children) : $5b3735bad55c10ce$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $5b3735bad55c10ce$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $5b3735bad55c10ce$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $5b3735bad55c10ce$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $5b3735bad55c10ce$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $5b3735bad55c10ce$var$insertAhead(array, i, deco) {
    while(i < array.length && $5b3735bad55c10ce$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $5b3735bad55c10ce$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $5b3735bad55c10ce$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($5b3735bad55c10ce$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $5b3735bad55c10ce$var$DecorationGroup.from(found);
}
const $5b3735bad55c10ce$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $5b3735bad55c10ce$var$useCharData = $5b3735bad55c10ce$var$ie && $5b3735bad55c10ce$var$ie_version <= 11;
class $5b3735bad55c10ce$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $5b3735bad55c10ce$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $5b3735bad55c10ce$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($5b3735bad55c10ce$var$ie && $5b3735bad55c10ce$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($5b3735bad55c10ce$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $5b3735bad55c10ce$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$5b3735bad55c10ce$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $5b3735bad55c10ce$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($5b3735bad55c10ce$var$ie && $5b3735bad55c10ce$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $5b3735bad55c10ce$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $5b3735bad55c10ce$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $5b3735bad55c10ce$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $5b3735bad55c10ce$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($5b3735bad55c10ce$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $5b3735bad55c10ce$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $5b3735bad55c10ce$var$selectionCollapsed(sel) && (readSel = $5b3735bad55c10ce$var$selectionFromDOM(view)) && readSel.eq((0, $6acde7918354ce68$export$52baac22726c72bf).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $5b3735bad55c10ce$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $5b3735bad55c10ce$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $5b3735bad55c10ce$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($5b3735bad55c10ce$var$ie && $5b3735bad55c10ce$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $5b3735bad55c10ce$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $5b3735bad55c10ce$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $5b3735bad55c10ce$var$cssChecked = new WeakMap();
let $5b3735bad55c10ce$var$cssCheckWarned = false;
function $5b3735bad55c10ce$var$checkCSS(view) {
    if ($5b3735bad55c10ce$var$cssChecked.has(view)) return;
    $5b3735bad55c10ce$var$cssChecked.set(view, null);
    if ([
        "normal",
        "nowrap",
        "pre-line"
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $5b3735bad55c10ce$var$gecko;
        if ($5b3735bad55c10ce$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $5b3735bad55c10ce$var$cssCheckWarned = true;
    }
}
function $5b3735bad55c10ce$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($5b3735bad55c10ce$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $5b3735bad55c10ce$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $5b3735bad55c10ce$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $5b3735bad55c10ce$var$rangeToSelectionRange(view, found) : null;
}
function $5b3735bad55c10ce$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $5b3735bad55c10ce$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$5b3735bad55c10ce$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($5b3735bad55c10ce$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $1847e9be7ba495c5$export$1059c6e7d2ce5669).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $5b3735bad55c10ce$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $5b3735bad55c10ce$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($5b3735bad55c10ce$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $5b3735bad55c10ce$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $5b3735bad55c10ce$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $5b3735bad55c10ce$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $5b3735bad55c10ce$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($5b3735bad55c10ce$var$chrome && $5b3735bad55c10ce$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $5b3735bad55c10ce$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $5b3735bad55c10ce$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $5b3735bad55c10ce$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($5b3735bad55c10ce$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $5b3735bad55c10ce$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$5b3735bad55c10ce$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $5b3735bad55c10ce$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $5b3735bad55c10ce$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($5b3735bad55c10ce$var$ie && $5b3735bad55c10ce$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \xa0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($5b3735bad55c10ce$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $6acde7918354ce68$export$52baac22726c72bf).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $5b3735bad55c10ce$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $5b3735bad55c10ce$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $5b3735bad55c10ce$var$keyEvent(8, "Backspace")))) {
        if ($5b3735bad55c10ce$var$android && $5b3735bad55c10ce$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($5b3735bad55c10ce$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($5b3735bad55c10ce$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $5b3735bad55c10ce$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($5b3735bad55c10ce$var$ie && $5b3735bad55c10ce$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$5b3735bad55c10ce$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $5b3735bad55c10ce$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $5b3735bad55c10ce$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($5b3735bad55c10ce$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $5b3735bad55c10ce$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $5b3735bad55c10ce$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $5b3735bad55c10ce$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $5b3735bad55c10ce$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $5b3735bad55c10ce$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $5b3735bad55c10ce$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($5b3735bad55c10ce$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $5b3735bad55c10ce$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $5b3735bad55c10ce$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $5b3735bad55c10ce$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $5b3735bad55c10ce$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $5b3735bad55c10ce$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $5b3735bad55c10ce$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $5b3735bad55c10ce$export$38b79e3fdcfcfd68 = $5b3735bad55c10ce$var$serializeForClipboard;
/**
@internal
*/ const $5b3735bad55c10ce$export$5d42ca91c11c9e4d = $5b3735bad55c10ce$var$parseFromClipboard;
/**
@internal
*/ const $5b3735bad55c10ce$export$76b14d3c719c32fc = $5b3735bad55c10ce$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $5b3735bad55c10ce$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $5b3735bad55c10ce$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($5b3735bad55c10ce$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $5b3735bad55c10ce$var$getEditable(this);
        $5b3735bad55c10ce$var$updateCursorWrapper(this);
        this.nodeViews = $5b3735bad55c10ce$var$buildNodeViews(this);
        this.docView = $5b3735bad55c10ce$var$docViewDesc(this.state.doc, $5b3735bad55c10ce$var$computeDocDeco(this), $5b3735bad55c10ce$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $5b3735bad55c10ce$var$DOMObserver(this, (from, to, typeOver, added)=>$5b3735bad55c10ce$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $5b3735bad55c10ce$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $5b3735bad55c10ce$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($5b3735bad55c10ce$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $5b3735bad55c10ce$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $5b3735bad55c10ce$var$buildNodeViews(this);
            if ($5b3735bad55c10ce$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $5b3735bad55c10ce$var$ensureListeners(this);
        this.editable = $5b3735bad55c10ce$var$getEditable(this);
        $5b3735bad55c10ce$var$updateCursorWrapper(this);
        let innerDeco = $5b3735bad55c10ce$var$viewDecorations(this), outerDeco = $5b3735bad55c10ce$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $5b3735bad55c10ce$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($5b3735bad55c10ce$var$ie || $5b3735bad55c10ce$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $5b3735bad55c10ce$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $5b3735bad55c10ce$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $5b3735bad55c10ce$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $5b3735bad55c10ce$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $5b3735bad55c10ce$var$anchorInRightPlace(this))) $5b3735bad55c10ce$var$selectionToDOM(this, forceSelUpdate);
            else {
                $5b3735bad55c10ce$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $5b3735bad55c10ce$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $5b3735bad55c10ce$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $5b3735bad55c10ce$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $5b3735bad55c10ce$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $6acde7918354ce68$export$e2940151ac854c0b).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($5b3735bad55c10ce$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == "false") return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $5b3735bad55c10ce$var$focusPreventScroll(this.dom);
        $5b3735bad55c10ce$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $5b3735bad55c10ce$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $5b3735bad55c10ce$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $5b3735bad55c10ce$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $5b3735bad55c10ce$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $5b3735bad55c10ce$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $5b3735bad55c10ce$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $5b3735bad55c10ce$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $5b3735bad55c10ce$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $5b3735bad55c10ce$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $5b3735bad55c10ce$var$safari && this.root.nodeType === 11 && $5b3735bad55c10ce$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $5b3735bad55c10ce$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $5b3735bad55c10ce$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $5b3735bad55c10ce$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $5b3735bad55c10ce$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $5b3735bad55c10ce$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $5b3735bad55c10ce$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $5b3735bad55c10ce$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $5b3735bad55c10ce$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $5b3735bad55c10ce$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $5b3735bad55c10ce$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}




// keymap/index.ts
var $d38e4247c9678f3b$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $d38e4247c9678f3b$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
};
var $d38e4247c9678f3b$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $d38e4247c9678f3b$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $d38e4247c9678f3b$var$i = 0; $d38e4247c9678f3b$var$i < 10; $d38e4247c9678f3b$var$i++)$d38e4247c9678f3b$export$e2253033e6e1df16[48 + $d38e4247c9678f3b$var$i] = $d38e4247c9678f3b$export$e2253033e6e1df16[96 + $d38e4247c9678f3b$var$i] = String($d38e4247c9678f3b$var$i);
// The function keys
for(var $d38e4247c9678f3b$var$i = 1; $d38e4247c9678f3b$var$i <= 24; $d38e4247c9678f3b$var$i++)$d38e4247c9678f3b$export$e2253033e6e1df16[$d38e4247c9678f3b$var$i + 111] = "F" + $d38e4247c9678f3b$var$i;
// And the alphabetic keys
for(var $d38e4247c9678f3b$var$i = 65; $d38e4247c9678f3b$var$i <= 90; $d38e4247c9678f3b$var$i++){
    $d38e4247c9678f3b$export$e2253033e6e1df16[$d38e4247c9678f3b$var$i] = String.fromCharCode($d38e4247c9678f3b$var$i + 32);
    $d38e4247c9678f3b$export$fba63a578e423eb[$d38e4247c9678f3b$var$i] = String.fromCharCode($d38e4247c9678f3b$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $d38e4247c9678f3b$var$code in $d38e4247c9678f3b$export$e2253033e6e1df16)if (!$d38e4247c9678f3b$export$fba63a578e423eb.hasOwnProperty($d38e4247c9678f3b$var$code)) $d38e4247c9678f3b$export$fba63a578e423eb[$d38e4247c9678f3b$var$code] = $d38e4247c9678f3b$export$e2253033e6e1df16[$d38e4247c9678f3b$var$code];
function $d38e4247c9678f3b$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $d38e4247c9678f3b$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $d38e4247c9678f3b$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $d38e4247c9678f3b$export$fba63a578e423eb : $d38e4247c9678f3b$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}



const $08ab38e848d66b67$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $08ab38e848d66b67$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($08ab38e848d66b67$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $08ab38e848d66b67$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$08ab38e848d66b67$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $08ab38e848d66b67$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $08ab38e848d66b67$export$5043418e2ef368d5(bindings) {
    return new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
        props: {
            handleKeyDown: $08ab38e848d66b67$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $08ab38e848d66b67$export$53f558754f8b9fd1(bindings) {
    let map = $08ab38e848d66b67$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $d38e4247c9678f3b$export$fb33aafd75404f4c)(event), baseName, direct = map[$08ab38e848d66b67$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$08ab38e848d66b67$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $d38e4247c9678f3b$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$08ab38e848d66b67$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}




// model/index.ts



// transform/index.ts



// commands/index.ts



/**
Delete the selection, if there is one.
*/ const $eaf4ca4698cf30cc$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $eaf4ca4698cf30cc$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $eaf4ca4698cf30cc$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $eaf4ca4698cf30cc$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $eaf4ca4698cf30cc$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $72a42b551bab6846$export$f1508b72cc76a09e)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($eaf4ca4698cf30cc$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($eaf4ca4698cf30cc$var$textblockAt(before, "end") || (0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $72a42b551bab6846$export$ed6ac67359824afd)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($eaf4ca4698cf30cc$var$textblockAt(before, "end") ? (0, $6acde7918354ce68$export$52baac22726c72bf).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $6acde7918354ce68$export$e2940151ac854c0b).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $eaf4ca4698cf30cc$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $eaf4ca4698cf30cc$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $eaf4ca4698cf30cc$var$findCutBefore($cursor);
    return $cut ? $eaf4ca4698cf30cc$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $eaf4ca4698cf30cc$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $eaf4ca4698cf30cc$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $eaf4ca4698cf30cc$var$findCutAfter($cursor);
    return $cut ? $eaf4ca4698cf30cc$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $eaf4ca4698cf30cc$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $72a42b551bab6846$export$ed6ac67359824afd)(state.doc, beforePos, afterPos, (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty);
    if (!step || step.from != beforePos || step instanceof (0, $72a42b551bab6846$export$5c860b2e74034756) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $eaf4ca4698cf30cc$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $eaf4ca4698cf30cc$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $eaf4ca4698cf30cc$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $6acde7918354ce68$export$e2940151ac854c0b).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $eaf4ca4698cf30cc$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $eaf4ca4698cf30cc$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $eaf4ca4698cf30cc$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $eaf4ca4698cf30cc$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $eaf4ca4698cf30cc$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($eaf4ca4698cf30cc$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($eaf4ca4698cf30cc$var$textblockAt(after, "start") || (0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(after))) {
        let delStep = (0, $72a42b551bab6846$export$ed6ac67359824afd)(state.doc, $cursor.before(), $cursor.after(), (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($eaf4ca4698cf30cc$var$textblockAt(after, "start") ? (0, $6acde7918354ce68$export$52baac22726c72bf).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $6acde7918354ce68$export$e2940151ac854c0b).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $eaf4ca4698cf30cc$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $eaf4ca4698cf30cc$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $6acde7918354ce68$export$e2940151ac854c0b).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $eaf4ca4698cf30cc$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $eaf4ca4698cf30cc$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $72a42b551bab6846$export$41b1d4cb5ceb3147)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $6acde7918354ce68$export$e2940151ac854c0b).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $eaf4ca4698cf30cc$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b)) {
        if (sel.node.isTextblock || !(0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $72a42b551bab6846$export$41b1d4cb5ceb3147)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $eaf4ca4698cf30cc$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $72a42b551bab6846$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $eaf4ca4698cf30cc$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $eaf4ca4698cf30cc$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $eaf4ca4698cf30cc$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $eaf4ca4698cf30cc$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $6acde7918354ce68$export$52baac22726c72bf).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $eaf4ca4698cf30cc$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $6acde7918354ce68$export$c15d9ba76bdbcd95) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $eaf4ca4698cf30cc$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $eaf4ca4698cf30cc$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $72a42b551bab6846$export$5aaf008897aef029)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $72a42b551bab6846$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $eaf4ca4698cf30cc$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $72a42b551bab6846$export$5aaf008897aef029)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $eaf4ca4698cf30cc$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb) || state.selection instanceof (0, $6acde7918354ce68$export$c15d9ba76bdbcd95)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $72a42b551bab6846$export$5aaf008897aef029)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $72a42b551bab6846$export$5aaf008897aef029)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $eaf4ca4698cf30cc$export$e99155638ff4dff0 = $eaf4ca4698cf30cc$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $eaf4ca4698cf30cc$export$eeb429476568b72b = (state, dispatch)=>{
    return $eaf4ca4698cf30cc$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $eaf4ca4698cf30cc$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $6acde7918354ce68$export$e2940151ac854c0b).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $eaf4ca4698cf30cc$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $6acde7918354ce68$export$c15d9ba76bdbcd95)(state.doc)));
    return true;
};
function $eaf4ca4698cf30cc$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $eaf4ca4698cf30cc$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $eaf4ca4698cf30cc$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(conn[i].create(null, wrap));
            wrap = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $72a42b551bab6846$export$444ba800d6024a98)($cut.pos - 1, end, $cut.pos, end, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $6acde7918354ce68$export$52baac22726c72bf).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $72a42b551bab6846$export$f1508b72cc76a09e)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $eaf4ca4698cf30cc$var$textblockAt(after, "start", true) && $eaf4ca4698cf30cc$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $72a42b551bab6846$export$444ba800d6024a98)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $eaf4ca4698cf30cc$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $eaf4ca4698cf30cc$export$c3a64f3c9604a1b1 = $eaf4ca4698cf30cc$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $eaf4ca4698cf30cc$export$a66c1876556415e5 = $eaf4ca4698cf30cc$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $eaf4ca4698cf30cc$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $72a42b551bab6846$export$118cb9a83e81ba37)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $eaf4ca4698cf30cc$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $eaf4ca4698cf30cc$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $eaf4ca4698cf30cc$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $6acde7918354ce68$export$7bd1839c3c5d5bd4)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $6acde7918354ce68$export$7bd1839c3c5d5bd4)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $eaf4ca4698cf30cc$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$eaf4ca4698cf30cc$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $eaf4ca4698cf30cc$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $eaf4ca4698cf30cc$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $eaf4ca4698cf30cc$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $eaf4ca4698cf30cc$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $eaf4ca4698cf30cc$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $eaf4ca4698cf30cc$var$backspace = $eaf4ca4698cf30cc$export$146a774cdef7663a($eaf4ca4698cf30cc$export$e9a518a637d1e641, $eaf4ca4698cf30cc$export$979097b097459299, $eaf4ca4698cf30cc$export$52b8a4af68d19794);
let $eaf4ca4698cf30cc$var$del = $eaf4ca4698cf30cc$export$146a774cdef7663a($eaf4ca4698cf30cc$export$e9a518a637d1e641, $eaf4ca4698cf30cc$export$bf432e340007f9ef, $eaf4ca4698cf30cc$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $eaf4ca4698cf30cc$export$eb36e8971b04df36 = {
    "Enter": $eaf4ca4698cf30cc$export$146a774cdef7663a($eaf4ca4698cf30cc$export$a5d02b4b65e94f91, $eaf4ca4698cf30cc$export$d0f80ac1b4510888, $eaf4ca4698cf30cc$export$a3574cc681852c08, $eaf4ca4698cf30cc$export$e99155638ff4dff0),
    "Mod-Enter": $eaf4ca4698cf30cc$export$634b78845598ff5b,
    "Backspace": $eaf4ca4698cf30cc$var$backspace,
    "Mod-Backspace": $eaf4ca4698cf30cc$var$backspace,
    "Shift-Backspace": $eaf4ca4698cf30cc$var$backspace,
    "Delete": $eaf4ca4698cf30cc$var$del,
    "Mod-Delete": $eaf4ca4698cf30cc$var$del,
    "Mod-a": $eaf4ca4698cf30cc$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $eaf4ca4698cf30cc$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $eaf4ca4698cf30cc$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $eaf4ca4698cf30cc$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $eaf4ca4698cf30cc$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $eaf4ca4698cf30cc$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $eaf4ca4698cf30cc$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $eaf4ca4698cf30cc$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $eaf4ca4698cf30cc$export$c3a64f3c9604a1b1,
    "Ctrl-e": $eaf4ca4698cf30cc$export$a66c1876556415e5
};
for(let key in $eaf4ca4698cf30cc$export$eb36e8971b04df36)$eaf4ca4698cf30cc$export$f292ad8dbd5063c8[key] = $eaf4ca4698cf30cc$export$eb36e8971b04df36[key];
const $eaf4ca4698cf30cc$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $eaf4ca4698cf30cc$export$4a0c2b85b1f0a889 = $eaf4ca4698cf30cc$var$mac ? $eaf4ca4698cf30cc$export$f292ad8dbd5063c8 : $eaf4ca4698cf30cc$export$eb36e8971b04df36;




// schema-list/index.ts



const $466bf2c48224b2e3$var$olDOM = [
    "ol",
    0
], $466bf2c48224b2e3$var$ulDOM = [
    "ul",
    0
], $466bf2c48224b2e3$var$liDOM = [
    "li",
    0
];
/**
An ordered list [node spec](https://prosemirror.net/docs/ref/#model.NodeSpec). Has a single
attribute, `order`, which determines the number at which the list
starts counting, and defaults to 1. Represented as an `<ol>`
element.
*/ const $466bf2c48224b2e3$export$a5dc81035676e7a = {
    attrs: {
        order: {
            default: 1,
            validate: "number"
        }
    },
    parseDOM: [
        {
            tag: "ol",
            getAttrs (dom) {
                return {
                    order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1
                };
            }
        }
    ],
    toDOM (node) {
        return node.attrs.order == 1 ? $466bf2c48224b2e3$var$olDOM : [
            "ol",
            {
                start: node.attrs.order
            },
            0
        ];
    }
};
/**
A bullet list node spec, represented in the DOM as `<ul>`.
*/ const $466bf2c48224b2e3$export$a140c94e5ea26bee = {
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    toDOM () {
        return $466bf2c48224b2e3$var$ulDOM;
    }
};
/**
A list item (`<li>`) spec.
*/ const $466bf2c48224b2e3$export$76c7e83ecc9cdf05 = {
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM () {
        return $466bf2c48224b2e3$var$liDOM;
    },
    defining: true
};
function $466bf2c48224b2e3$var$add(obj, props) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    for(let prop in props)copy[prop] = props[prop];
    return copy;
}
/**
Convenience function for adding list-related node types to a map
specifying the nodes for a schema. Adds
[`orderedList`](https://prosemirror.net/docs/ref/#schema-list.orderedList) as `"ordered_list"`,
[`bulletList`](https://prosemirror.net/docs/ref/#schema-list.bulletList) as `"bullet_list"`, and
[`listItem`](https://prosemirror.net/docs/ref/#schema-list.listItem) as `"list_item"`.

`itemContent` determines the content expression for the list items.
If you want the commands defined in this module to apply to your
list structure, it should have a shape like `"paragraph block*"` or
`"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
given to assign a group name to the list node types, for example
`"block"`.
*/ function $466bf2c48224b2e3$export$fa2e7d3d1550c2ea(nodes, itemContent, listGroup) {
    return nodes.append({
        ordered_list: $466bf2c48224b2e3$var$add($466bf2c48224b2e3$export$a5dc81035676e7a, {
            content: "list_item+",
            group: listGroup
        }),
        bullet_list: $466bf2c48224b2e3$var$add($466bf2c48224b2e3$export$a140c94e5ea26bee, {
            content: "list_item+",
            group: listGroup
        }),
        list_item: $466bf2c48224b2e3$var$add($466bf2c48224b2e3$export$76c7e83ecc9cdf05, {
            content: itemContent
        })
    });
}
/**
Returns a command function that wraps the selection in a list with
the given type an attributes. If `dispatch` is null, only return a
value to indicate whether this is possible, but don't actually
perform the change.
*/ function $466bf2c48224b2e3$export$a8aef45c6262afee(listType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to);
        if (!range) return false;
        let tr = dispatch ? state.tr : null;
        if (!$466bf2c48224b2e3$export$e4d3cb74b660c6e9(tr, range, listType, attrs)) return false;
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Try to wrap the given node range in a list of the given type.
Return `true` when this is possible, `false` otherwise. When `tr`
is non-null, the wrapping is added to that transaction. When it is
`null`, the function only queries whether the wrapping is
possible.
*/ function $466bf2c48224b2e3$export$e4d3cb74b660c6e9(tr, range, listType, attrs = null) {
    let doJoin = false, outerRange = range, doc = range.$from.doc;
    // This is at the top of an existing list item
    if (range.depth >= 2 && range.$from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
        // Don't do anything if this is the top of the list
        if (range.$from.index(range.depth - 1) == 0) return false;
        let $insert = doc.resolve(range.start - 2);
        outerRange = new (0, $1847e9be7ba495c5$export$7bc461ceb770fb16)($insert, $insert, range.depth);
        if (range.endIndex < range.parent.childCount) range = new (0, $1847e9be7ba495c5$export$7bc461ceb770fb16)(range.$from, doc.resolve(range.$to.end(range.depth)), range.depth);
        doJoin = true;
    }
    let wrap = (0, $72a42b551bab6846$export$118cb9a83e81ba37)(outerRange, listType, attrs, range);
    if (!wrap) return false;
    if (tr) $466bf2c48224b2e3$var$doWrapInList(tr, range, wrap, doJoin, listType);
    return true;
}
function $466bf2c48224b2e3$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $72a42b551bab6846$export$444ba800d6024a98)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type == listType) found = i + 1;
    let splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $72a42b551bab6846$export$5aaf008897aef029)(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}
/**
Build a command that splits a non-empty textblock at the top level
of a list item by also splitting that list item.
*/ function $466bf2c48224b2e3$export$e920ee2eb756d384(itemType, itemAttrs) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to, node: node } = state.selection;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        let grandParent = $from.node(-1);
        if (grandParent.type != itemType) return false;
        if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth == 3 || $from.node(-3).type != itemType || $from.index(-2) != $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
                let depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d--)wrap = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from($from.node(d).copy(wrap));
                let depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                wrap = wrap.append((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(itemType.createAndFill()));
                let start = $from.before($from.depth - (depthBefore - 1));
                let tr = state.tr.replace(start, $from.after(-depthAfter), new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (node, pos)=>{
                    if (sel > -1) return false;
                    if (node.isTextblock && node.content.size == 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $6acde7918354ce68$export$52baac22726c72bf).near(tr.doc.resolve(sel)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        let nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        let tr = state.tr.delete($from.pos, $to.pos);
        let types = nextType ? [
            itemAttrs ? {
                type: itemType,
                attrs: itemAttrs
            } : null,
            {
                type: nextType
            }
        ] : undefined;
        if (!(0, $72a42b551bab6846$export$5aaf008897aef029)(tr.doc, $from.pos, 2, types)) return false;
        if (dispatch) dispatch(tr.split($from.pos, 2, types).scrollIntoView());
        return true;
    };
}
/**
Acts like [`splitListItem`](https://prosemirror.net/docs/ref/#schema-list.splitListItem), but
without resetting the set of active marks at the cursor.
*/ function $466bf2c48224b2e3$export$265ad35055c66d75(itemType, itemAttrs) {
    let split = $466bf2c48224b2e3$export$e920ee2eb756d384(itemType, itemAttrs);
    return (state, dispatch)=>{
        return split(state, dispatch && ((tr)=>{
            let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
            if (marks) tr.ensureMarks(marks);
            dispatch(tr);
        }));
    };
}
/**
Create a command to lift the list item around the selection up into
a wrapping list.
*/ function $466bf2c48224b2e3$export$e74cd5adb935a538(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        if (!dispatch) return true;
        if ($from.node(range.depth - 1).type == itemType) return $466bf2c48224b2e3$var$liftToOuterList(state, dispatch, itemType, range);
        else return $466bf2c48224b2e3$var$liftOutOfList(state, dispatch, range);
    };
}
function $466bf2c48224b2e3$var$liftToOuterList(state, dispatch, itemType, range) {
    let tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        tr.step(new (0, $72a42b551bab6846$export$444ba800d6024a98)(end - 1, endOfList, end, endOfList, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $1847e9be7ba495c5$export$7bc461ceb770fb16)(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = (0, $72a42b551bab6846$export$f1508b72cc76a09e)(range);
    if (target == null) return false;
    tr.lift(range, target);
    let after = tr.mapping.map(end, -1) - 1;
    if ((0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(tr.doc, after)) tr.join(after);
    dispatch(tr.scrollIntoView());
    return true;
}
function $466bf2c48224b2e3$var$liftOutOfList(state, dispatch, range) {
    let tr = state.tr, list = range.parent;
    // Merge the list items into a single big item
    for(let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        tr.delete(pos - 1, pos + 1);
    }
    let $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
    if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize) return false;
    let atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
    let parent = $start.node(-1), indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty : (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(list)))) return false;
    let start = $start.pos, end = start + item.nodeSize;
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    tr.step(new (0, $72a42b551bab6846$export$444ba800d6024a98)(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((atStart ? (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty : (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(list.copy((0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty))).append(atEnd ? (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty : (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(list.copy((0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    dispatch(tr.scrollIntoView());
    return true;
}
/**
Create a command to sink the list item around the selection down
into an inner list.
*/ function $466bf2c48224b2e3$export$dd505f850a3798a4(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        let startIndex = range.startIndex;
        if (startIndex == 0) return false;
        let parent = range.parent, nodeBefore = parent.child(startIndex - 1);
        if (nodeBefore.type != itemType) return false;
        if (dispatch) {
            let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
            let inner = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(nestedBefore ? itemType.create() : null);
            let slice = new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(itemType.create(null, (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
            let before = range.start, after = range.end;
            dispatch(state.tr.step(new (0, $72a42b551bab6846$export$444ba800d6024a98)(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true)).scrollIntoView());
        }
        return true;
    };
}




/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */ function $a769590142262cb7$export$83e24c5933427696(config) {
    const { state: state, transaction: transaction } = config;
    let { selection: selection } = transaction;
    let { doc: doc } = transaction;
    let { storedMarks: storedMarks } = transaction;
    return {
        ...state,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        plugins: state.plugins,
        schema: state.schema,
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks () {
            return storedMarks;
        },
        get selection () {
            return selection;
        },
        get doc () {
            return doc;
        },
        get tr () {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        }
    };
}
class $a769590142262cb7$export$475014de15a4c342 {
    constructor(props){
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const { tr: tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            const method = (...args)=>{
                const callback = command(...args)(props);
                if (!tr.getMeta("preventDispatch") && !this.hasCustomState) view.dispatch(tr);
                return callback;
            };
            return [
                name,
                method
            ];
        }));
    }
    get chain() {
        return ()=>this.createChain();
    }
    get can() {
        return ()=>this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = ()=>{
            if (!hasStartTransaction && shouldDispatch && !tr.getMeta("preventDispatch") && !this.hasCustomState) view.dispatch(tr);
            return callbacks.every((callback)=>callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                const chainedCommand = (...args)=>{
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [
                    name,
                    chainedCommand
                ];
            })),
            run: run
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands: rawCommands, state: state } = this;
        const dispatch = false;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            return [
                name,
                (...args)=>command(...args)({
                        ...props,
                        dispatch: undefined
                    })
            ];
        }));
        return {
            ...formattedCommands,
            chain: ()=>this.createChain(tr, dispatch)
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const props = {
            tr: tr,
            editor: editor,
            view: view,
            state: $a769590142262cb7$export$83e24c5933427696({
                state: state,
                transaction: tr
            }),
            dispatch: shouldDispatch ? ()=>undefined : undefined,
            chain: ()=>this.createChain(tr, shouldDispatch),
            can: ()=>this.createCan(tr),
            get commands () {
                return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                    return [
                        name,
                        (...args)=>command(...args)(props)
                    ];
                }));
            }
        };
        return props;
    }
}
class $a769590142262cb7$var$EventEmitter {
    constructor(){
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) this.callbacks[event] = [];
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) callbacks.forEach((callback)=>callback.apply(this, args));
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) this.callbacks[event] = callbacks.filter((callback)=>callback !== fn);
            else delete this.callbacks[event];
        }
        return this;
    }
    once(event, fn) {
        const onceFn = (...args)=>{
            this.off(event, onceFn);
            fn.apply(this, args);
        };
        return this.on(event, onceFn);
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}
/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */ function $a769590142262cb7$export$f73578b718a57eaa(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) return $a769590142262cb7$export$f73578b718a57eaa(extension.parent, field, context);
    if (typeof extension.config[field] === "function") {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent ? $a769590142262cb7$export$f73578b718a57eaa(extension.parent, field, context) : null
        });
        return value;
    }
    return extension.config[field];
}
function $a769590142262cb7$export$36e8c2990da8266f(extensions) {
    const baseExtensions = extensions.filter((extension)=>extension.type === "extension");
    const nodeExtensions = extensions.filter((extension)=>extension.type === "node");
    const markExtensions = extensions.filter((extension)=>extension.type === "mark");
    return {
        baseExtensions: baseExtensions,
        nodeExtensions: nodeExtensions,
        markExtensions: markExtensions
    };
}
/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */ function $a769590142262cb7$export$6e54e3e69d60df3d(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $a769590142262cb7$export$36e8c2990da8266f(extensions);
    const nodeAndMarkExtensions = [
        ...nodeExtensions,
        ...markExtensions
    ];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
        isRequired: false
    };
    extensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            extensions: nodeAndMarkExtensions
        };
        const addGlobalAttributes = $a769590142262cb7$export$f73578b718a57eaa(extension, "addGlobalAttributes", context);
        if (!addGlobalAttributes) return;
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach((globalAttribute)=>{
            globalAttribute.types.forEach((type)=>{
                Object.entries(globalAttribute.attributes).forEach(([name, attribute])=>{
                    extensionAttributes.push({
                        type: type,
                        name: name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute
                        }
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        const addAttributes = $a769590142262cb7$export$f73578b718a57eaa(extension, "addAttributes", context);
        if (!addAttributes) return;
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object.entries(attributes).forEach(([name, attribute])=>{
            const mergedAttr = {
                ...defaultAttribute,
                ...attribute
            };
            if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === "function") mergedAttr.default = mergedAttr.default();
            if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) delete mergedAttr.default;
            extensionAttributes.push({
                type: extension.name,
                name: name,
                attribute: mergedAttr
            });
        });
    });
    return extensionAttributes;
}
function $a769590142262cb7$export$d168cba70360dd3d(nameOrType, schema) {
    if (typeof nameOrType === "string") {
        if (!schema.nodes[nameOrType]) throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}
function $a769590142262cb7$export$9f98db6234c4bd78(...objects) {
    return objects.filter((item)=>!!item).reduce((items, item)=>{
        const mergedAttributes = {
            ...items
        };
        Object.entries(item).forEach(([key, value])=>{
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === "class") {
                const valueClasses = value ? String(value).split(" ") : [];
                const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(" ") : [];
                const insertClasses = valueClasses.filter((valueClass)=>!existingClasses.includes(valueClass));
                mergedAttributes[key] = [
                    ...existingClasses,
                    ...insertClasses
                ].join(" ");
            } else if (key === "style") {
                const newStyles = value ? value.split(";").map((style)=>style.trim()).filter(Boolean) : [];
                const existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(";").map((style)=>style.trim()).filter(Boolean) : [];
                const styleMap = new Map();
                existingStyles.forEach((style)=>{
                    const [property, val] = style.split(":").map((part)=>part.trim());
                    styleMap.set(property, val);
                });
                newStyles.forEach((style)=>{
                    const [property, val] = style.split(":").map((part)=>part.trim());
                    styleMap.set(property, val);
                });
                mergedAttributes[key] = Array.from(styleMap.entries()).map(([property, val])=>`${property}: ${val}`).join("; ");
            } else mergedAttributes[key] = value;
        });
        return mergedAttributes;
    }, {});
}
function $a769590142262cb7$export$bc79d84a417d7b02(nodeOrMark, extensionAttributes) {
    return extensionAttributes.filter((attribute)=>attribute.type === nodeOrMark.type.name).filter((item)=>item.attribute.rendered).map((item)=>{
        if (!item.attribute.renderHTML) return {
            [item.name]: nodeOrMark.attrs[item.name]
        };
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    }).reduce((attributes, attribute)=>$a769590142262cb7$export$9f98db6234c4bd78(attributes, attribute), {});
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function $a769590142262cb7$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */ function $a769590142262cb7$export$592682234826c0bd(value, context, ...props) {
    if ($a769590142262cb7$export$f6e2535fb5126e54(value)) {
        if (context) return value.bind(context)(...props);
        return value(...props);
    }
    return value;
}
function $a769590142262cb7$export$83b788b1a3698c03(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}
function $a769590142262cb7$export$3004f64547af360e(value) {
    if (typeof value !== "string") return value;
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) return Number(value);
    if (value === "true") return true;
    if (value === "false") return false;
    return value;
}
/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */ function $a769590142262cb7$export$7ce6b571718439ec(parseRule, extensionAttributes) {
    if ("style" in parseRule) return parseRule;
    return {
        ...parseRule,
        getAttrs: (node)=>{
            const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
            if (oldAttributes === false) return false;
            const newAttributes = extensionAttributes.reduce((items, item)=>{
                const value = item.attribute.parseHTML ? item.attribute.parseHTML(node) : $a769590142262cb7$export$3004f64547af360e(node.getAttribute(item.name));
                if (value === null || value === undefined) return items;
                return {
                    ...items,
                    [item.name]: value
                };
            }, {});
            return {
                ...oldAttributes,
                ...newAttributes
            };
        }
    };
}
function $a769590142262cb7$var$cleanUpSchemaItem(data) {
    return Object.fromEntries(// @ts-ignore
    Object.entries(data).filter(([key, value])=>{
        if (key === "attrs" && $a769590142262cb7$export$83b788b1a3698c03(value)) return false;
        return value !== null && value !== undefined;
    }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */ function $a769590142262cb7$export$71bc12a97b59a858(extensions, editor) {
    var _a;
    const allAttributes = $a769590142262cb7$export$6e54e3e69d60df3d(extensions);
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $a769590142262cb7$export$36e8c2990da8266f(extensions);
    const topNode = (_a = nodeExtensions.find((extension)=>$a769590142262cb7$export$f73578b718a57eaa(extension, "topNode"))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraNodeFields = extensions.reduce((fields, e)=>{
            const extendNodeSchema = $a769590142262cb7$export$f73578b718a57eaa(e, "extendNodeSchema", context);
            return {
                ...fields,
                ...extendNodeSchema ? extendNodeSchema(extension) : {}
            };
        }, {});
        const schema = $a769590142262cb7$var$cleanUpSchemaItem({
            ...extraNodeFields,
            content: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "content", context)),
            marks: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "marks", context)),
            group: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "group", context)),
            inline: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "inline", context)),
            atom: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "atom", context)),
            selectable: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "selectable", context)),
            draggable: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "draggable", context)),
            code: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "code", context)),
            whitespace: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "whitespace", context)),
            linebreakReplacement: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "linebreakReplacement", context)),
            defining: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "defining", context)),
            isolating: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "isolating", context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "parseHTML", context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$a769590142262cb7$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $a769590142262cb7$export$f73578b718a57eaa(extension, "renderHTML", context);
        if (renderHTML) schema.toDOM = (node)=>renderHTML({
                node: node,
                HTMLAttributes: $a769590142262cb7$export$bc79d84a417d7b02(node, extensionAttributes)
            });
        const renderText = $a769590142262cb7$export$f73578b718a57eaa(extension, "renderText", context);
        if (renderText) schema.toText = renderText;
        return [
            extension.name,
            schema
        ];
    }));
    const marks = Object.fromEntries(markExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraMarkFields = extensions.reduce((fields, e)=>{
            const extendMarkSchema = $a769590142262cb7$export$f73578b718a57eaa(e, "extendMarkSchema", context);
            return {
                ...fields,
                ...extendMarkSchema ? extendMarkSchema(extension) : {}
            };
        }, {});
        const schema = $a769590142262cb7$var$cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "inclusive", context)),
            excludes: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "excludes", context)),
            group: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "group", context)),
            spanning: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "spanning", context)),
            code: $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "code", context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "parseHTML", context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$a769590142262cb7$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $a769590142262cb7$export$f73578b718a57eaa(extension, "renderHTML", context);
        if (renderHTML) schema.toDOM = (mark)=>renderHTML({
                mark: mark,
                HTMLAttributes: $a769590142262cb7$export$bc79d84a417d7b02(mark, extensionAttributes)
            });
        return [
            extension.name,
            schema
        ];
    }));
    return new (0, $1847e9be7ba495c5$export$19342e026b58ebb7)({
        topNode: topNode,
        nodes: nodes,
        marks: marks
    });
}
/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */ function $a769590142262cb7$export$ea18268b31f54e5(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}
function $a769590142262cb7$export$79b791167b05aada(extension, enabled) {
    if (Array.isArray(enabled)) return enabled.some((enabledExtension)=>{
        const name = typeof enabledExtension === "string" ? enabledExtension : enabledExtension.name;
        return name === extension.name;
    });
    return enabled;
}
function $a769590142262cb7$export$d1b60002472b2c81(fragment, schema) {
    const documentFragment = (0, $1847e9be7ba495c5$export$3476b78f8f5a8b72).fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement("div");
    container.appendChild(documentFragment);
    return container.innerHTML;
}
/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */ const $a769590142262cb7$export$a3e238086d556fa9 = ($from, maxMatch = 500)=>{
    let textBefore = "";
    const sliceEndPos = $from.parentOffset;
    $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index)=>{
        var _a, _b;
        const chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
            node: node,
            pos: pos,
            parent: parent,
            index: index
        })) || node.textContent || "%leaf%";
        textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
    });
    return textBefore;
};
function $a769590142262cb7$export$49841c62b9eff15(value) {
    return Object.prototype.toString.call(value) === "[object RegExp]";
}
class $a769590142262cb7$export$9b55e2b000ad65f2 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $a769590142262cb7$var$inputRuleMatcherHandler = (text, find)=>{
    if ($a769590142262cb7$export$49841c62b9eff15(find)) return find.exec(text);
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) return null;
    const result = [
        inputRuleMatch.text
    ];
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function $a769590142262cb7$var$run$1(config) {
    var _a;
    const { editor: editor, from: from, to: to, text: text, rules: rules, plugin: plugin } = config;
    const { view: view } = editor;
    if (view.composing) return false;
    const $from = view.state.doc.resolve(from);
    if (// check for code node
    $from.parent.type.spec.code || !!((_a = $from.nodeBefore || $from.nodeAfter) === null || _a === void 0 ? void 0 : _a.marks.find((mark)=>mark.type.spec.code))) return false;
    let matched = false;
    const textBefore = $a769590142262cb7$export$a3e238086d556fa9($from) + text;
    rules.forEach((rule)=>{
        if (matched) return;
        const match = $a769590142262cb7$var$inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) return;
        const tr = view.state.tr;
        const state = $a769590142262cb7$export$83e24c5933427696({
            state: view.state,
            transaction: tr
        });
        const range = {
            from: from - (match[0].length - text.length),
            to: to
        };
        const { commands: commands, chain: chain, can: can } = new $a769590142262cb7$export$475014de15a4c342({
            editor: editor,
            state: state
        });
        const handler = rule.handler({
            state: state,
            range: range,
            match: match,
            commands: commands,
            chain: chain,
            can: can
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) return;
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from: from,
            to: to,
            text: text
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */ function $a769590142262cb7$export$f2a821f78e918151(props) {
    const { editor: editor, rules: rules } = props;
    const plugin = new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
        state: {
            init () {
                return null;
            },
            apply (tr, prev, state) {
                const stored = tr.getMeta(plugin);
                if (stored) return stored;
                // if InputRule is triggered by insertContent()
                const simulatedInputMeta = tr.getMeta("applyInputRules");
                const isSimulatedInput = !!simulatedInputMeta;
                if (isSimulatedInput) setTimeout(()=>{
                    let { text: text } = simulatedInputMeta;
                    if (typeof text === "string") text;
                    else text = $a769590142262cb7$export$d1b60002472b2c81((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(text), state.schema);
                    const { from: from } = simulatedInputMeta;
                    const to = from + text.length;
                    $a769590142262cb7$var$run$1({
                        editor: editor,
                        from: from,
                        to: to,
                        text: text,
                        rules: rules,
                        plugin: plugin
                    });
                });
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                return $a769590142262cb7$var$run$1({
                    editor: editor,
                    from: from,
                    to: to,
                    text: text,
                    rules: rules,
                    plugin: plugin
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const { $cursor: $cursor } = view.state.selection;
                        if ($cursor) $a769590142262cb7$var$run$1({
                            editor: editor,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: "",
                            rules: rules,
                            plugin: plugin
                        });
                    });
                    return false;
                }
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown (view, event) {
                if (event.key !== "Enter") return false;
                const { $cursor: $cursor } = view.state.selection;
                if ($cursor) return $a769590142262cb7$var$run$1({
                    editor: editor,
                    from: $cursor.pos,
                    to: $cursor.pos,
                    text: "\n",
                    rules: rules,
                    plugin: plugin
                });
                return false;
            }
        },
        // @ts-ignore
        isInputRules: true
    });
    return plugin;
}
// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function $a769590142262cb7$var$getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $a769590142262cb7$export$53b83ca8eaab0383(value) {
    if ($a769590142262cb7$var$getType(value) !== "Object") return false;
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}
function $a769590142262cb7$export$dd702b3c8240390c(target, source) {
    const output = {
        ...target
    };
    if ($a769590142262cb7$export$53b83ca8eaab0383(target) && $a769590142262cb7$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($a769590142262cb7$export$53b83ca8eaab0383(source[key]) && $a769590142262cb7$export$53b83ca8eaab0383(target[key])) output[key] = $a769590142262cb7$export$dd702b3c8240390c(target[key], source[key]);
        else output[key] = source[key];
    });
    return output;
}
/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $a769590142262cb7$export$c9d15bcfc6d42044 {
    constructor(config = {}){
        this.type = "mark";
        this.name = "mark";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $a769590142262cb7$export$c9d15bcfc6d42044(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $a769590142262cb7$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $a769590142262cb7$export$c9d15bcfc6d42044(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
    static handleExit({ editor: editor, mark: mark }) {
        const { tr: tr } = editor.state;
        const currentPos = editor.state.selection.$from;
        const isAtEnd = currentPos.pos === currentPos.end();
        if (isAtEnd) {
            const currentMarks = currentPos.marks();
            const isInMark = !!currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (!isInMark) return false;
            const removeMark = currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (removeMark) tr.removeStoredMark(removeMark);
            tr.insertText(" ", currentPos.pos);
            editor.view.dispatch(tr);
            return true;
        }
        return false;
    }
}
function $a769590142262cb7$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ class $a769590142262cb7$export$e75df4392d073e98 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $a769590142262cb7$var$pasteRuleMatcherHandler = (text, find, event)=>{
    if ($a769590142262cb7$export$49841c62b9eff15(find)) return [
        ...text.matchAll(find)
    ];
    const matches = find(text, event);
    if (!matches) return [];
    return matches.map((pasteRuleMatch)=>{
        const result = [
            pasteRuleMatch.text
        ];
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function $a769590142262cb7$var$run(config) {
    const { editor: editor, state: state, from: from, to: to, rule: rule, pasteEvent: pasteEvent, dropEvent: dropEvent } = config;
    const { commands: commands, chain: chain, can: can } = new $a769590142262cb7$export$475014de15a4c342({
        editor: editor,
        state: state
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isTextblock || node.type.spec.code) return;
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, "\uFFFC");
        const matches = $a769590142262cb7$var$pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
        matches.forEach((match)=>{
            if (match.index === undefined) return;
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end)
            };
            const handler = rule.handler({
                state: state,
                range: range,
                match: match,
                commands: commands,
                chain: chain,
                can: can,
                pasteEvent: pasteEvent,
                dropEvent: dropEvent
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every((handler)=>handler !== null);
    return success;
}
// When dragging across editors, must get another editor instance to delete selection content.
let $a769590142262cb7$var$tiptapDragFromOtherEditor = null;
const $a769590142262cb7$var$createClipboardPasteEvent = (text)=>{
    var _a;
    const event = new ClipboardEvent("paste", {
        clipboardData: new DataTransfer()
    });
    (_a = event.clipboardData) === null || _a === void 0 || _a.setData("text/html", text);
    return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */ function $a769590142262cb7$export$458282b0dddaaaa4(props) {
    const { editor: editor, rules: rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    let pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
    let dropEvent;
    try {
        dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
    } catch  {
        dropEvent = null;
    }
    const processEvent = ({ state: state, from: from, to: to, rule: rule, pasteEvt: pasteEvt })=>{
        const tr = state.tr;
        const chainableState = $a769590142262cb7$export$83e24c5933427696({
            state: state,
            transaction: tr
        });
        const handler = $a769590142262cb7$var$run({
            editor: editor,
            state: chainableState,
            from: Math.max(from - 1, 0),
            to: to.b - 1,
            rule: rule,
            pasteEvent: pasteEvt,
            dropEvent: dropEvent
        });
        if (!handler || !tr.steps.length) return;
        try {
            dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
        } catch  {
            dropEvent = null;
        }
        pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
        return tr;
    };
    const plugins = rules.map((rule)=>{
        return new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
            // we register a global drag handler to track the current drag source element
            view (view) {
                const handleDragstart = (event)=>{
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ? view.dom.parentElement : null;
                    if (dragSourceElement) $a769590142262cb7$var$tiptapDragFromOtherEditor = editor;
                };
                const handleDragend = ()=>{
                    if ($a769590142262cb7$var$tiptapDragFromOtherEditor) $a769590142262cb7$var$tiptapDragFromOtherEditor = null;
                };
                window.addEventListener("dragstart", handleDragstart);
                window.addEventListener("dragend", handleDragend);
                return {
                    destroy () {
                        window.removeEventListener("dragstart", handleDragstart);
                        window.removeEventListener("dragend", handleDragend);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: (view, event)=>{
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        dropEvent = event;
                        if (!isDroppedFromProseMirror) {
                            const dragFromOtherEditor = $a769590142262cb7$var$tiptapDragFromOtherEditor;
                            if (dragFromOtherEditor) // setTimeout to avoid the wrong content after drop, timeout arg can't be empty or 0
                            setTimeout(()=>{
                                const selection = dragFromOtherEditor.state.selection;
                                if (selection) dragFromOtherEditor.commands.deleteRange({
                                    from: selection.from,
                                    to: selection.to
                                });
                            }, 10);
                        }
                        return false;
                    },
                    paste: (_view, event)=>{
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData("text/html");
                        pasteEvent = event;
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes("data-pm-slice"));
                        return false;
                    }
                }
            },
            appendTransaction: (transactions, oldState, state)=>{
                const transaction = transactions[0];
                const isPaste = transaction.getMeta("uiEvent") === "paste" && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta("uiEvent") === "drop" && !isDroppedFromProseMirror;
                // if PasteRule is triggered by insertContent()
                const simulatedPasteMeta = transaction.getMeta("applyPasteRules");
                const isSimulatedPaste = !!simulatedPasteMeta;
                if (!isPaste && !isDrop && !isSimulatedPaste) return;
                // Handle simulated paste
                if (isSimulatedPaste) {
                    let { text: text } = simulatedPasteMeta;
                    if (typeof text === "string") text;
                    else text = $a769590142262cb7$export$d1b60002472b2c81((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(text), state.schema);
                    const { from: from } = simulatedPasteMeta;
                    const to = from + text.length;
                    const pasteEvt = $a769590142262cb7$var$createClipboardPasteEvent(text);
                    return processEvent({
                        rule: rule,
                        state: state,
                        from: from,
                        to: {
                            b: to
                        },
                        pasteEvt: pasteEvt
                    });
                }
                // handle actual paste/drop
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                // stop if there is no changed range
                if (!$a769590142262cb7$export$7e4aa119212bc614(from) || !to || from === to.b) return;
                return processEvent({
                    rule: rule,
                    state: state,
                    from: from,
                    to: to,
                    pasteEvt: pasteEvent
                });
            }
        });
    });
    return plugins;
}
function $a769590142262cb7$export$15704658c784aef1(items) {
    const filtered = items.filter((el, index)=>items.indexOf(el) !== index);
    return Array.from(new Set(filtered));
}
class $a769590142262cb7$var$ExtensionManager {
    constructor(extensions, editor){
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = $a769590142262cb7$var$ExtensionManager.resolve(extensions);
        this.schema = $a769590142262cb7$export$71bc12a97b59a858(this.extensions, editor);
        this.setupExtensions();
    }
    /**
     * Returns a flattened and sorted extension list while
     * also checking for duplicated extensions and warns the user.
     * @param extensions An array of Tiptap extensions
     * @returns An flattened and sorted array of Tiptap extensions
     */ static resolve(extensions) {
        const resolvedExtensions = $a769590142262cb7$var$ExtensionManager.sort($a769590142262cb7$var$ExtensionManager.flatten(extensions));
        const duplicatedNames = $a769590142262cb7$export$15704658c784aef1(resolvedExtensions.map((extension)=>extension.name));
        if (duplicatedNames.length) console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames.map((item)=>`'${item}'`).join(", ")}]. This can lead to issues.`);
        return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */ static flatten(extensions) {
        return extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage
            };
            const addExtensions = $a769590142262cb7$export$f73578b718a57eaa(extension, "addExtensions", context);
            if (addExtensions) return [
                extension,
                ...this.flatten(addExtensions())
            ];
            return extension;
        })// `Infinity` will break TypeScript so we set a number that is probably high enough
        .flat(10);
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */ static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b)=>{
            const priorityA = $a769590142262cb7$export$f73578b718a57eaa(a, "priority") || defaultPriority;
            const priorityB = $a769590142262cb7$export$f73578b718a57eaa(b, "priority") || defaultPriority;
            if (priorityA > priorityB) return -1;
            if (priorityA < priorityB) return 1;
            return 0;
        });
    }
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */ get commands() {
        return this.extensions.reduce((commands, extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $a769590142262cb7$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const addCommands = $a769590142262cb7$export$f73578b718a57eaa(extension, "addCommands", context);
            if (!addCommands) return commands;
            return {
                ...commands,
                ...addCommands()
            };
        }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */ get plugins() {
        const { editor: editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In Tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = $a769590142262cb7$var$ExtensionManager.sort([
            ...this.extensions
        ].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $a769590142262cb7$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const plugins = [];
            const addKeyboardShortcuts = $a769590142262cb7$export$f73578b718a57eaa(extension, "addKeyboardShortcuts", context);
            let defaultBindings = {};
            // bind exit handling
            if (extension.type === "mark" && $a769590142262cb7$export$f73578b718a57eaa(extension, "exitable", context)) defaultBindings.ArrowRight = ()=>$a769590142262cb7$export$c9d15bcfc6d42044.handleExit({
                    editor: editor,
                    mark: extension
                });
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method])=>{
                    return [
                        shortcut,
                        ()=>method({
                                editor: editor
                            })
                    ];
                }));
                defaultBindings = {
                    ...defaultBindings,
                    ...bindings
                };
            }
            const keyMapPlugin = (0, $08ab38e848d66b67$export$5043418e2ef368d5)(defaultBindings);
            plugins.push(keyMapPlugin);
            const addInputRules = $a769590142262cb7$export$f73578b718a57eaa(extension, "addInputRules", context);
            if ($a769590142262cb7$export$79b791167b05aada(extension, editor.options.enableInputRules) && addInputRules) inputRules.push(...addInputRules());
            const addPasteRules = $a769590142262cb7$export$f73578b718a57eaa(extension, "addPasteRules", context);
            if ($a769590142262cb7$export$79b791167b05aada(extension, editor.options.enablePasteRules) && addPasteRules) pasteRules.push(...addPasteRules());
            const addProseMirrorPlugins = $a769590142262cb7$export$f73578b718a57eaa(extension, "addProseMirrorPlugins", context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        }).flat();
        return [
            $a769590142262cb7$export$f2a821f78e918151({
                editor: editor,
                rules: inputRules
            }),
            ...$a769590142262cb7$export$458282b0dddaaaa4({
                editor: editor,
                rules: pasteRules
            }),
            ...allPlugins
        ];
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */ get attributes() {
        return $a769590142262cb7$export$6e54e3e69d60df3d(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */ get nodeViews() {
        const { editor: editor } = this;
        const { nodeExtensions: nodeExtensions } = $a769590142262cb7$export$36e8c2990da8266f(this.extensions);
        return Object.fromEntries(nodeExtensions.filter((extension)=>!!$a769590142262cb7$export$f73578b718a57eaa(extension, "addNodeView")).map((extension)=>{
            const extensionAttributes = this.attributes.filter((attribute)=>attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $a769590142262cb7$export$d168cba70360dd3d(extension.name, this.schema)
            };
            const addNodeView = $a769590142262cb7$export$f73578b718a57eaa(extension, "addNodeView", context);
            if (!addNodeView) return [];
            const nodeview = (node, view, getPos, decorations, innerDecorations)=>{
                const HTMLAttributes = $a769590142262cb7$export$bc79d84a417d7b02(node, extensionAttributes);
                return addNodeView()({
                    node: // pass-through
                    node,
                    view: view,
                    getPos: getPos,
                    decorations: decorations,
                    innerDecorations: innerDecorations,
                    editor: // tiptap-specific
                    editor,
                    extension: extension,
                    HTMLAttributes: HTMLAttributes
                });
            };
            return [
                extension.name,
                nodeview
            ];
        }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */ setupExtensions() {
        this.extensions.forEach((extension)=>{
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $a769590142262cb7$export$ea18268b31f54e5(extension.name, this.schema)
            };
            if (extension.type === "mark") {
                const keepOnSplit = (_a = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "keepOnSplit", context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) this.splittableMarks.push(extension.name);
            }
            const onBeforeCreate = $a769590142262cb7$export$f73578b718a57eaa(extension, "onBeforeCreate", context);
            const onCreate = $a769590142262cb7$export$f73578b718a57eaa(extension, "onCreate", context);
            const onUpdate = $a769590142262cb7$export$f73578b718a57eaa(extension, "onUpdate", context);
            const onSelectionUpdate = $a769590142262cb7$export$f73578b718a57eaa(extension, "onSelectionUpdate", context);
            const onTransaction = $a769590142262cb7$export$f73578b718a57eaa(extension, "onTransaction", context);
            const onFocus = $a769590142262cb7$export$f73578b718a57eaa(extension, "onFocus", context);
            const onBlur = $a769590142262cb7$export$f73578b718a57eaa(extension, "onBlur", context);
            const onDestroy = $a769590142262cb7$export$f73578b718a57eaa(extension, "onDestroy", context);
            if (onBeforeCreate) this.editor.on("beforeCreate", onBeforeCreate);
            if (onCreate) this.editor.on("create", onCreate);
            if (onUpdate) this.editor.on("update", onUpdate);
            if (onSelectionUpdate) this.editor.on("selectionUpdate", onSelectionUpdate);
            if (onTransaction) this.editor.on("transaction", onTransaction);
            if (onFocus) this.editor.on("focus", onFocus);
            if (onBlur) this.editor.on("blur", onBlur);
            if (onDestroy) this.editor.on("destroy", onDestroy);
        });
    }
}
/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $a769590142262cb7$export$eeddbf09bb970356 {
    constructor(config = {}){
        this.type = "extension";
        this.name = "extension";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $a769590142262cb7$export$eeddbf09bb970356(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $a769590142262cb7$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $a769590142262cb7$export$eeddbf09bb970356({
            ...this.config,
            ...extendedConfig
        });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */ function $a769590142262cb7$export$6e5992a7455d9ef6(startNode, range, options) {
    const { from: from, to: to } = range;
    const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
    let text = "";
    startNode.nodesBetween(from, to, (node, pos, parent, index)=>{
        var _a;
        if (node.isBlock && pos > from) text += blockSeparator;
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (parent) text += textSerializer({
                node: node,
                pos: pos,
                parent: parent,
                index: index,
                range: range
            });
            // do not descend into child nodes when there exists a serializer
            return false;
        }
        if (node.isText) text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
    });
    return text;
}
/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */ function $a769590142262cb7$export$fdd92b7d22ac071c(schema) {
    return Object.fromEntries(Object.entries(schema.nodes).filter(([, node])=>node.spec.toText).map(([name, node])=>[
            name,
            node.spec.toText
        ]));
}
const $a769590142262cb7$var$ClipboardTextSerializer = $a769590142262cb7$export$eeddbf09bb970356.create({
    name: "clipboardTextSerializer",
    addOptions () {
        return {
            blockSeparator: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
                key: new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("clipboardTextSerializer"),
                props: {
                    clipboardTextSerializer: ()=>{
                        const { editor: editor } = this;
                        const { state: state, schema: schema } = editor;
                        const { doc: doc, selection: selection } = state;
                        const { ranges: ranges } = selection;
                        const from = Math.min(...ranges.map((range)=>range.$from.pos));
                        const to = Math.max(...ranges.map((range)=>range.$to.pos));
                        const textSerializers = $a769590142262cb7$export$fdd92b7d22ac071c(schema);
                        const range = {
                            from: from,
                            to: to
                        };
                        return $a769590142262cb7$export$6e5992a7455d9ef6(doc, range, {
                            ...this.options.blockSeparator !== undefined ? {
                                blockSeparator: this.options.blockSeparator
                            } : {},
                            textSerializers: textSerializers
                        });
                    }
                }
            })
        ];
    }
});
const $a769590142262cb7$var$blur = ()=>({ editor: editor, view: view })=>{
        requestAnimationFrame(()=>{
            var _a;
            if (!editor.isDestroyed) {
                view.dom.blur();
                // Browsers should remove the caret on blur but safari does not.
                // See: https://github.com/ueberdosis/tiptap/issues/2405
                (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 || _a.removeAllRanges();
            }
        });
        return true;
    };
const $a769590142262cb7$var$clearContent = (emitUpdate = false)=>({ commands: commands })=>{
        return commands.setContent("", emitUpdate);
    };
const $a769590142262cb7$var$clearNodes = ()=>({ state: state, tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { ranges: ranges } = selection;
        if (!dispatch) return true;
        ranges.forEach(({ $from: $from, $to: $to })=>{
            state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
                if (node.type.isText) return;
                const { doc: doc, mapping: mapping } = tr;
                const $mappedFrom = doc.resolve(mapping.map(pos));
                const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
                const nodeRange = $mappedFrom.blockRange($mappedTo);
                if (!nodeRange) return;
                const targetLiftDepth = (0, $72a42b551bab6846$export$f1508b72cc76a09e)(nodeRange);
                if (node.type.isTextblock) {
                    const { defaultType: defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                    tr.setNodeMarkup(nodeRange.start, defaultType);
                }
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(nodeRange, targetLiftDepth);
            });
        });
        return true;
    };
const $a769590142262cb7$var$command = (fn)=>(props)=>{
        return fn(props);
    };
const $a769590142262cb7$var$createParagraphNear = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$d0f80ac1b4510888)(state, dispatch);
    };
const $a769590142262cb7$var$cut = (originRange, targetPos)=>({ editor: editor, tr: tr })=>{
        const { state: state } = editor;
        const contentSlice = state.doc.slice(originRange.from, originRange.to);
        tr.deleteRange(originRange.from, originRange.to);
        const newPos = tr.mapping.map(targetPos);
        tr.insert(newPos, contentSlice.content);
        tr.setSelection(new (0, $6acde7918354ce68$export$c2b25f346d19bcbb)(tr.doc.resolve(newPos - 1)));
        return true;
    };
const $a769590142262cb7$var$deleteCurrentNode = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const currentNode = selection.$anchor.node();
        // if there is content inside the current node, break out of this command
        if (currentNode.content.size > 0) return false;
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === currentNode.type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $a769590142262cb7$var$deleteNode = (typeOrName)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $a769590142262cb7$var$deleteRange = (range)=>({ tr: tr, dispatch: dispatch })=>{
        const { from: from, to: to } = range;
        if (dispatch) tr.delete(from, to);
        return true;
    };
const $a769590142262cb7$var$deleteSelection = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$e9a518a637d1e641)(state, dispatch);
    };
const $a769590142262cb7$var$enter = ()=>({ commands: commands })=>{
        return commands.keyboardShortcut("Enter");
    };
const $a769590142262cb7$var$exitCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$634b78845598ff5b)(state, dispatch);
    };
/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */ function $a769590142262cb7$export$7aeb68f71172641d(object1, object2, options = {
    strict: true
}) {
    const keys = Object.keys(object2);
    if (!keys.length) return true;
    return keys.every((key)=>{
        if (options.strict) return object2[key] === object1[key];
        if ($a769590142262cb7$export$49841c62b9eff15(object2[key])) return object2[key].test(object1[key]);
        return object2[key] === object1[key];
    });
}
function $a769590142262cb7$var$findMarkInSet(marks, type, attributes = {}) {
    return marks.find((item)=>{
        return item.type === type && $a769590142262cb7$export$7aeb68f71172641d(// Only check equality for the attributes that are provided
        Object.fromEntries(Object.keys(attributes).map((k)=>[
                k,
                item.attrs[k]
            ])), attributes);
    });
}
function $a769590142262cb7$var$isMarkInSet(marks, type, attributes = {}) {
    return !!$a769590142262cb7$var$findMarkInSet(marks, type, attributes);
}
/**
 * Get the range of a mark at a resolved position.
 */ function $a769590142262cb7$export$8ceae6d06f5c4df5(/**
 * The position to get the mark range for.
 */ $pos, /**
 * The mark type to get the range for.
 */ type, /**
 * The attributes to match against.
 * If not provided, only the first mark at the position will be matched.
 */ attributes) {
    var _a;
    if (!$pos || !type) return;
    let start = $pos.parent.childAfter($pos.parentOffset);
    // If the cursor is at the start of a text node that does not have the mark, look backward
    if (!start.node || !start.node.marks.some((mark)=>mark.type === type)) start = $pos.parent.childBefore($pos.parentOffset);
    // If there is no text node with the mark even backward, return undefined
    if (!start.node || !start.node.marks.some((mark)=>mark.type === type)) return;
    // Default to only matching against the first mark's attributes
    attributes = attributes || ((_a = start.node.marks[0]) === null || _a === void 0 ? void 0 : _a.attrs);
    // We now know that the cursor is either at the start, middle or end of a text node with the specified mark
    // so we can look it up on the targeted mark
    const mark = $a769590142262cb7$var$findMarkInSet([
        ...start.node.marks
    ], type, attributes);
    if (!mark) return;
    let startIndex = start.index;
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    while(startIndex > 0 && $a769590142262cb7$var$isMarkInSet([
        ...$pos.parent.child(startIndex - 1).marks
    ], type, attributes)){
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while(endIndex < $pos.parent.childCount && $a769590142262cb7$var$isMarkInSet([
        ...$pos.parent.child(endIndex).marks
    ], type, attributes)){
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos
    };
}
function $a769590142262cb7$export$b1269d6bf6e491ec(nameOrType, schema) {
    if (typeof nameOrType === "string") {
        if (!schema.marks[nameOrType]) throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.marks[nameOrType];
    }
    return nameOrType;
}
const $a769590142262cb7$var$extendMarkRange = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $a769590142262cb7$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { doc: doc, selection: selection } = tr;
        const { $from: $from, from: from, to: to } = selection;
        if (dispatch) {
            const range = $a769590142262cb7$export$8ceae6d06f5c4df5($from, type, attributes);
            if (range && range.from <= from && range.to >= to) {
                const newSelection = (0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(doc, range.from, range.to);
                tr.setSelection(newSelection);
            }
        }
        return true;
    };
const $a769590142262cb7$var$first = (commands)=>(props)=>{
        const items = typeof commands === "function" ? commands(props) : commands;
        for(let i = 0; i < items.length; i += 1){
            if (items[i](props)) return true;
        }
        return false;
    };
function $a769590142262cb7$export$38b50bf35e79aaf3(value) {
    return value instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb);
}
function $a769590142262cb7$export$6fb785c609d82593(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}
function $a769590142262cb7$export$225b0233b78e0d61(doc, position = null) {
    if (!position) return null;
    const selectionAtStart = (0, $6acde7918354ce68$export$52baac22726c72bf).atStart(doc);
    const selectionAtEnd = (0, $6acde7918354ce68$export$52baac22726c72bf).atEnd(doc);
    if (position === "start" || position === true) return selectionAtStart;
    if (position === "end") return selectionAtEnd;
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === "all") return (0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(doc, $a769590142262cb7$export$6fb785c609d82593(0, minPos, maxPos), $a769590142262cb7$export$6fb785c609d82593(doc.content.size, minPos, maxPos));
    return (0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(doc, $a769590142262cb7$export$6fb785c609d82593(position, minPos, maxPos), $a769590142262cb7$export$6fb785c609d82593(position, minPos, maxPos));
}
const $a769590142262cb7$var$focus = (position = null, options = {})=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        options = {
            scrollIntoView: true,
            ...options
        };
        const delayedFocus = ()=>{
            view.dom.focus();
            // For React we have to focus asynchronously. Otherwise wild things happen.
            // see: https://github.com/ueberdosis/tiptap/issues/1520
            requestAnimationFrame(()=>{
                if (!editor.isDestroyed) {
                    view.focus();
                    if (options === null || options === void 0 ? void 0 : options.scrollIntoView) editor.commands.scrollIntoView();
                }
            });
        };
        if (view.hasFocus() && position === null || position === false) return true;
        // we don’t try to resolve a NodeSelection or CellSelection
        if (dispatch && position === null && !$a769590142262cb7$export$38b50bf35e79aaf3(editor.state.selection)) {
            delayedFocus();
            return true;
        }
        // pass through tr.doc instead of editor.state.doc
        // since transactions could change the editors state before this command has been run
        const selection = $a769590142262cb7$export$225b0233b78e0d61(tr.doc, position) || editor.state.selection;
        const isSameSelection = editor.state.selection.eq(selection);
        if (dispatch) {
            if (!isSameSelection) tr.setSelection(selection);
            // `tr.setSelection` resets the stored marks
            // so we’ll restore them if the selection is the same as before
            if (isSameSelection && tr.storedMarks) tr.setStoredMarks(tr.storedMarks);
            delayedFocus();
        }
        return true;
    };
const $a769590142262cb7$var$forEach = (items, fn)=>(props)=>{
        return items.every((item, index)=>fn(item, {
                ...props,
                index: index
            }));
    };
const $a769590142262cb7$var$insertContent = (value, options)=>({ tr: tr, commands: commands })=>{
        return commands.insertContentAt({
            from: tr.selection.from,
            to: tr.selection.to
        }, value, options);
    };
const $a769590142262cb7$var$removeWhitespaces = (node)=>{
    const children = node.childNodes;
    for(let i = children.length - 1; i >= 0; i -= 1){
        const child = children[i];
        if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) node.removeChild(child);
        else if (child.nodeType === 1) $a769590142262cb7$var$removeWhitespaces(child);
    }
    return node;
};
function $a769590142262cb7$export$1b93bf03550cde01(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    const html = new window.DOMParser().parseFromString(wrappedValue, "text/html").body;
    return $a769590142262cb7$var$removeWhitespaces(html);
}
/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */ function $a769590142262cb7$export$12c64e96dddaee61(content, schema, options) {
    if (content instanceof (0, $1847e9be7ba495c5$export$85c928794f8d04d4) || content instanceof (0, $1847e9be7ba495c5$export$ffb0004e005737fa)) return content;
    options = {
        slice: true,
        parseOptions: {},
        ...options
    };
    const isJSONContent = typeof content === "object" && content !== null;
    const isTextContent = typeof content === "string";
    if (isJSONContent) try {
        const isArrayContent = Array.isArray(content) && content.length > 0;
        // if the JSON Content is an array of nodes, create a fragment for each node
        if (isArrayContent) return (0, $1847e9be7ba495c5$export$ffb0004e005737fa).fromArray(content.map((item)=>schema.nodeFromJSON(item)));
        const node = schema.nodeFromJSON(content);
        if (options.errorOnInvalidContent) node.check();
        return node;
    } catch (error) {
        if (options.errorOnInvalidContent) throw new Error("[tiptap error]: Invalid JSON content", {
            cause: error
        });
        console.warn("[tiptap warn]: Invalid content.", "Passed value:", content, "Error:", error);
        return $a769590142262cb7$export$12c64e96dddaee61("", schema, options);
    }
    if (isTextContent) {
        // Check for invalid content
        if (options.errorOnInvalidContent) {
            let hasInvalidContent = false;
            let invalidContent = "";
            // A copy of the current schema with a catch-all node at the end
            const contentCheckSchema = new (0, $1847e9be7ba495c5$export$19342e026b58ebb7)({
                topNode: schema.spec.topNode,
                marks: schema.spec.marks,
                // Prosemirror's schemas are executed such that: the last to execute, matches last
                // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
                nodes: schema.spec.nodes.append({
                    __tiptap__private__unknown__catch__all__node: {
                        content: "inline*",
                        group: "block",
                        parseDOM: [
                            {
                                tag: "*",
                                getAttrs: (e)=>{
                                    // If this is ever called, we know that the content has something that we don't know how to handle in the schema
                                    hasInvalidContent = true;
                                    // Try to stringify the element for a more helpful error message
                                    invalidContent = typeof e === "string" ? e : e.outerHTML;
                                    return null;
                                }
                            }
                        ]
                    }
                })
            });
            if (options.slice) (0, $1847e9be7ba495c5$export$1059c6e7d2ce5669).fromSchema(contentCheckSchema).parseSlice($a769590142262cb7$export$1b93bf03550cde01(content), options.parseOptions);
            else (0, $1847e9be7ba495c5$export$1059c6e7d2ce5669).fromSchema(contentCheckSchema).parse($a769590142262cb7$export$1b93bf03550cde01(content), options.parseOptions);
            if (options.errorOnInvalidContent && hasInvalidContent) throw new Error("[tiptap error]: Invalid HTML content", {
                cause: new Error(`Invalid element found: ${invalidContent}`)
            });
        }
        const parser = (0, $1847e9be7ba495c5$export$1059c6e7d2ce5669).fromSchema(schema);
        if (options.slice) return parser.parseSlice($a769590142262cb7$export$1b93bf03550cde01(content), options.parseOptions).content;
        return parser.parse($a769590142262cb7$export$1b93bf03550cde01(content), options.parseOptions);
    }
    return $a769590142262cb7$export$12c64e96dddaee61("", schema, options);
}
// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function $a769590142262cb7$export$bf93acd215057ab0(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) return;
    const step = tr.steps[last];
    if (!(step instanceof (0, $72a42b551bab6846$export$5c860b2e74034756) || step instanceof (0, $72a42b551bab6846$export$444ba800d6024a98))) return;
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end === 0) end = newTo;
    });
    tr.setSelection((0, $6acde7918354ce68$export$52baac22726c72bf).near(tr.doc.resolve(end), bias));
}
const $a769590142262cb7$var$isFragment = (nodeOrFragment)=>{
    return !("type" in nodeOrFragment);
};
const $a769590142262cb7$var$insertContentAt = (position, value, options)=>({ tr: tr, dispatch: dispatch, editor: editor })=>{
        var _a;
        if (dispatch) {
            options = {
                parseOptions: editor.options.parseOptions,
                updateSelection: true,
                applyInputRules: false,
                applyPasteRules: false,
                ...options
            };
            let content;
            try {
                content = $a769590142262cb7$export$12c64e96dddaee61(value, editor.schema, {
                    parseOptions: {
                        preserveWhitespace: "full",
                        ...options.parseOptions
                    },
                    errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
                });
            } catch (e) {
                editor.emit("contentError", {
                    editor: editor,
                    error: e,
                    disableCollaboration: ()=>{
                        if (editor.storage.collaboration) editor.storage.collaboration.isDisabled = true;
                    }
                });
                return false;
            }
            let { from: from, to: to } = typeof position === "number" ? {
                from: position,
                to: position
            } : {
                from: position.from,
                to: position.to
            };
            let isOnlyTextContent = true;
            let isOnlyBlockContent = true;
            const nodes = $a769590142262cb7$var$isFragment(content) ? content : [
                content
            ];
            nodes.forEach((node)=>{
                // check if added node is valid
                node.check();
                isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
                isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
            });
            // check if we can replace the wrapping node by
            // the newly inserted content
            // example:
            // replace an empty paragraph by an inserted image
            // instead of inserting the image below the paragraph
            if (from === to && isOnlyBlockContent) {
                const { parent: parent } = tr.doc.resolve(from);
                const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
                if (isEmptyTextBlock) {
                    from -= 1;
                    to += 1;
                }
            }
            let newContent;
            // if there is only plain text we have to use `insertText`
            // because this will keep the current marks
            if (isOnlyTextContent) {
                // if value is string, we can use it directly
                // otherwise if it is an array, we have to join it
                if (Array.isArray(value)) newContent = value.map((v)=>v.text || "").join("");
                else if (value instanceof (0, $1847e9be7ba495c5$export$ffb0004e005737fa)) {
                    let text = "";
                    value.forEach((node)=>{
                        if (node.text) text += node.text;
                    });
                    newContent = text;
                } else if (typeof value === "object" && !!value && !!value.text) newContent = value.text;
                else newContent = value;
                tr.insertText(newContent, from, to);
            } else {
                newContent = content;
                tr.replaceWith(from, to, newContent);
            }
            // set cursor at end of inserted content
            if (options.updateSelection) $a769590142262cb7$export$bf93acd215057ab0(tr, tr.steps.length - 1, -1);
            if (options.applyInputRules) tr.setMeta("applyInputRules", {
                from: from,
                text: newContent
            });
            if (options.applyPasteRules) tr.setMeta("applyPasteRules", {
                from: from,
                text: newContent
            });
        }
        return true;
    };
const $a769590142262cb7$var$joinUp = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$4bb15e6d4372b393)(state, dispatch);
    };
const $a769590142262cb7$var$joinDown = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$8dd967a262b064bb)(state, dispatch);
    };
const $a769590142262cb7$var$joinBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$979097b097459299)(state, dispatch);
    };
const $a769590142262cb7$var$joinForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$bf432e340007f9ef)(state, dispatch);
    };
const $a769590142262cb7$var$joinItemBackward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $72a42b551bab6846$export$41b1d4cb5ceb3147)(state.doc, state.selection.$from.pos, -1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch  {
            return false;
        }
    };
const $a769590142262cb7$var$joinItemForward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $72a42b551bab6846$export$41b1d4cb5ceb3147)(state.doc, state.selection.$from.pos, 1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch  {
            return false;
        }
    };
const $a769590142262cb7$var$joinTextblockBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$1dce4f5c74f5f90f)(state, dispatch);
    };
const $a769590142262cb7$var$joinTextblockForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$e796bb96d22be2cd)(state, dispatch);
    };
function $a769590142262cb7$export$86c1a3f9ab33da5c() {
    return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function $a769590142262cb7$export$6159e43e50a41987() {
    return typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
}
function $a769590142262cb7$var$normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === "Space") result = " ";
    let alt;
    let ctrl;
    let shift;
    let meta;
    for(let i = 0; i < parts.length - 1; i += 1){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($a769590142262cb7$export$86c1a3f9ab33da5c() || $a769590142262cb7$export$6159e43e50a41987()) meta = true;
            else ctrl = true;
        } else throw new Error(`Unrecognized modifier name: ${mod}`);
    }
    if (alt) result = `Alt-${result}`;
    if (ctrl) result = `Ctrl-${result}`;
    if (meta) result = `Meta-${result}`;
    if (shift) result = `Shift-${result}`;
    return result;
}
const $a769590142262cb7$var$keyboardShortcut = (name)=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        const keys = $a769590142262cb7$var$normalizeKeyName(name).split(/-(?!$)/);
        const key = keys.find((item)=>![
                "Alt",
                "Ctrl",
                "Meta",
                "Shift"
            ].includes(item));
        const event = new KeyboardEvent("keydown", {
            key: key === "Space" ? " " : key,
            altKey: keys.includes("Alt"),
            ctrlKey: keys.includes("Ctrl"),
            metaKey: keys.includes("Meta"),
            shiftKey: keys.includes("Shift"),
            bubbles: true,
            cancelable: true
        });
        const capturedTransaction = editor.captureTransaction(()=>{
            view.someProp("handleKeyDown", (f)=>f(view, event));
        });
        capturedTransaction === null || capturedTransaction === void 0 || capturedTransaction.steps.forEach((step)=>{
            const newStep = step.map(tr.mapping);
            if (newStep && dispatch) tr.maybeStep(newStep);
        });
        return true;
    };
function $a769590142262cb7$export$7a24a642b0c7ad29(state, typeOrName, attributes = {}) {
    const { from: from, to: to, empty: empty } = state.selection;
    const type = typeOrName ? $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema) : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isText) return;
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node: node,
            from: relativeFrom,
            to: relativeTo
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges.filter((nodeRange)=>{
        if (!type) return true;
        return type.name === nodeRange.node.type.name;
    }).filter((nodeRange)=>$a769590142262cb7$export$7aeb68f71172641d(nodeRange.node.attrs, attributes, {
            strict: false
        }));
    if (empty) return !!matchedNodeRanges.length;
    const range = matchedNodeRanges.reduce((sum, nodeRange)=>sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}
const $a769590142262cb7$var$lift = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $a769590142262cb7$export$7a24a642b0c7ad29(state, type, attributes);
        if (!isActive) return false;
        return (0, $eaf4ca4698cf30cc$export$590e8b2c435046d9)(state, dispatch);
    };
const $a769590142262cb7$var$liftEmptyBlock = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$a3574cc681852c08)(state, dispatch);
    };
const $a769590142262cb7$var$liftListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $466bf2c48224b2e3$export$e74cd5adb935a538)(type)(state, dispatch);
    };
const $a769590142262cb7$var$newlineInCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$a5d02b4b65e94f91)(state, dispatch);
    };
/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */ function $a769590142262cb7$export$e501dfcf737a48e0(name, schema) {
    if (schema.nodes[name]) return "node";
    if (schema.marks[name]) return "mark";
    return null;
}
/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */ function $a769590142262cb7$export$8694e5c03a4df8e6(obj, propOrProps) {
    const props = typeof propOrProps === "string" ? [
        propOrProps
    ] : propOrProps;
    return Object.keys(obj).reduce((newObj, prop)=>{
        if (!props.includes(prop)) newObj[prop] = obj[prop];
        return newObj;
    }, {});
}
const $a769590142262cb7$var$resetAttributes = (typeOrName, attributes)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $a769590142262cb7$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === "node") nodeType = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === "mark") markType = $a769590142262cb7$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos)=>{
                if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, $a769590142262cb7$export$8694e5c03a4df8e6(node.attrs, attributes));
                if (markType && node.marks.length) node.marks.forEach((mark)=>{
                    if (markType === mark.type) tr.addMark(pos, pos + node.nodeSize, markType.create($a769590142262cb7$export$8694e5c03a4df8e6(mark.attrs, attributes)));
                });
            });
        });
        return true;
    };
const $a769590142262cb7$var$scrollIntoView = ()=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) tr.scrollIntoView();
        return true;
    };
const $a769590142262cb7$var$selectAll = ()=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const selection = new (0, $6acde7918354ce68$export$c15d9ba76bdbcd95)(tr.doc);
            tr.setSelection(selection);
        }
        return true;
    };
const $a769590142262cb7$var$selectNodeBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$52b8a4af68d19794)(state, dispatch);
    };
const $a769590142262cb7$var$selectNodeForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$5835b52680b80cfd)(state, dispatch);
    };
const $a769590142262cb7$var$selectParentNode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$a37f6aaa9169911d)(state, dispatch);
    };
// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const $a769590142262cb7$var$selectTextblockEnd = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$a66c1876556415e5)(state, dispatch);
    };
// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const $a769590142262cb7$var$selectTextblockStart = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $eaf4ca4698cf30cc$export$c3a64f3c9604a1b1)(state, dispatch);
    };
/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */ function $a769590142262cb7$export$37330def6e48b4c9(content, schema, parseOptions = {}, options = {}) {
    return $a769590142262cb7$export$12c64e96dddaee61(content, schema, {
        slice: false,
        parseOptions: parseOptions,
        errorOnInvalidContent: options.errorOnInvalidContent
    });
}
const $a769590142262cb7$var$setContent = (content, emitUpdate = false, parseOptions = {}, options = {})=>({ editor: editor, tr: tr, dispatch: dispatch, commands: commands })=>{
        var _a, _b;
        const { doc: doc } = tr;
        // This is to keep backward compatibility with the previous behavior
        // TODO remove this in the next major version
        if (parseOptions.preserveWhitespace !== "full") {
            const document1 = $a769590142262cb7$export$37330def6e48b4c9(content, editor.schema, parseOptions, {
                errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
            });
            if (dispatch) tr.replaceWith(0, doc.content.size, document1).setMeta("preventUpdate", !emitUpdate);
            return true;
        }
        if (dispatch) tr.setMeta("preventUpdate", !emitUpdate);
        return commands.insertContentAt({
            from: 0,
            to: doc.content.size
        }, content, {
            parseOptions: parseOptions,
            errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck
        });
    };
function $a769590142262cb7$export$2cd1d0e1f861bae0(state, typeOrName) {
    const type = $a769590142262cb7$export$b1269d6bf6e491ec(typeOrName, state.schema);
    const { from: from, to: to, empty: empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) marks.push(...state.storedMarks);
        marks.push(...state.selection.$head.marks());
    } else state.doc.nodesBetween(from, to, (node)=>{
        marks.push(...node.marks);
    });
    const mark = marks.find((markItem)=>markItem.type.name === type.name);
    if (!mark) return {};
    return {
        ...mark.attrs
    };
}
/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */ function $a769590142262cb7$export$f945f1716a5df33d(oldDoc, transactions) {
    const transform = new (0, $72a42b551bab6846$export$563a914cafbdc389)(oldDoc);
    transactions.forEach((transaction)=>{
        transaction.steps.forEach((step)=>{
            transform.step(step);
        });
    });
    return transform;
}
/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */ function $a769590142262cb7$export$6133a2de0e8ac885(match) {
    for(let i = 0; i < match.edgeCount; i += 1){
        const { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
 * Find children inside a Prosemirror node that match a predicate.
 * @param node The Prosemirror node to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $a769590142262cb7$export$f94ca194e830789c(node, predicate) {
    const nodesWithPos = [];
    node.descendants((child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $a769590142262cb7$export$6a2a251dde98a23(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */ function $a769590142262cb7$export$fe09644e3bc6166b($pos, predicate) {
    for(let i = $pos.depth; i > 0; i -= 1){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
}
/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */ function $a769590142262cb7$export$dc159056ffdb4c76(predicate) {
    return (selection)=>$a769590142262cb7$export$fe09644e3bc6166b(selection.$from, predicate);
}
function $a769590142262cb7$export$19a621270f26273c(extensions, editor) {
    const resolvedExtensions = $a769590142262cb7$var$ExtensionManager.resolve(extensions);
    return $a769590142262cb7$export$71bc12a97b59a858(resolvedExtensions, editor);
}
/**
 * Generate HTML from a JSONContent
 * @param doc The JSONContent to generate HTML from
 * @param extensions The extensions to use for the schema
 * @returns The generated HTML
 */ function $a769590142262cb7$export$4f413073eb19378c(doc, extensions) {
    const schema = $a769590142262cb7$export$19a621270f26273c(extensions);
    const contentNode = (0, $1847e9be7ba495c5$export$85c928794f8d04d4).fromJSON(schema, doc);
    return $a769590142262cb7$export$d1b60002472b2c81(contentNode.content, schema);
}
/**
 * Generate JSONContent from HTML
 * @param html The HTML to generate JSONContent from
 * @param extensions The extensions to use for the schema
 * @returns The generated JSONContent
 */ function $a769590142262cb7$export$d23738d50f257f47(html, extensions) {
    const schema = $a769590142262cb7$export$19a621270f26273c(extensions);
    const dom = $a769590142262cb7$export$1b93bf03550cde01(html);
    return (0, $1847e9be7ba495c5$export$1059c6e7d2ce5669).fromSchema(schema).parse(dom).toJSON();
}
/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */ function $a769590142262cb7$export$c72d34660a162238(node, options) {
    const range = {
        from: 0,
        to: node.content.size
    };
    return $a769590142262cb7$export$6e5992a7455d9ef6(node, range, options);
}
/**
 * Generate raw text from a JSONContent
 * @param doc The JSONContent to generate text from
 * @param extensions The extensions to use for the schema
 * @param options Options for the text generation f.e. blockSeparator or textSerializers
 * @returns The generated text
 */ function $a769590142262cb7$export$43625cf01e0b7b62(doc, extensions, options) {
    const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
    const schema = $a769590142262cb7$export$19a621270f26273c(extensions);
    const contentNode = (0, $1847e9be7ba495c5$export$85c928794f8d04d4).fromJSON(schema, doc);
    return $a769590142262cb7$export$c72d34660a162238(contentNode, {
        blockSeparator: blockSeparator,
        textSerializers: {
            ...$a769590142262cb7$export$fdd92b7d22ac071c(schema),
            ...textSerializers
        }
    });
}
function $a769590142262cb7$export$e8c6736926dcac42(state, typeOrName) {
    const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
    const { from: from, to: to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, (node)=>{
        nodes.push(node);
    });
    const node = nodes.reverse().find((nodeItem)=>nodeItem.type.name === type.name);
    if (!node) return {};
    return {
        ...node.attrs
    };
}
/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */ function $a769590142262cb7$export$fe94072fee8a6976(state, typeOrName) {
    const schemaType = $a769590142262cb7$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === "node") return $a769590142262cb7$export$e8c6736926dcac42(state, typeOrName);
    if (schemaType === "mark") return $a769590142262cb7$export$2cd1d0e1f861bae0(state, typeOrName);
    return {};
}
/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */ function $a769590142262cb7$export$2e2262a44ac61957(array, by = JSON.stringify) {
    const seen = {};
    return array.filter((item)=>{
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
    });
}
/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */ function $a769590142262cb7$var$simplifyChangedRanges(changes) {
    const uniqueChanges = $a769590142262cb7$export$2e2262a44ac61957(changes);
    return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter((change, index)=>{
        const rest = uniqueChanges.filter((_, i)=>i !== index);
        return !rest.some((otherChange)=>{
            return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
        });
    });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */ function $a769590142262cb7$export$ba396fc65ff2f439(transform) {
    const { mapping: mapping, steps: steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index)=>{
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from: from, to: to } = steps[index];
            if (from === undefined || to === undefined) return;
            ranges.push({
                from: from,
                to: to
            });
        } else stepMap.forEach((from, to)=>{
            ranges.push({
                from: from,
                to: to
            });
        });
        ranges.forEach(({ from: from, to: to })=>{
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd
                },
                newRange: {
                    from: newStart,
                    to: newEnd
                }
            });
        });
    });
    return $a769590142262cb7$var$simplifyChangedRanges(changes);
}
function $a769590142262cb7$export$d661e0733145fb37(node, startOffset = 0) {
    const isTopNode = node.type === node.type.schema.topNodeType;
    const increment = isTopNode ? 0 : 1;
    const from = startOffset;
    const to = from + node.nodeSize;
    const marks = node.marks.map((mark)=>{
        const output = {
            type: mark.type.name
        };
        if (Object.keys(mark.attrs).length) output.attrs = {
            ...mark.attrs
        };
        return output;
    });
    const attrs = {
        ...node.attrs
    };
    const output = {
        type: node.type.name,
        from: from,
        to: to
    };
    if (Object.keys(attrs).length) output.attrs = attrs;
    if (marks.length) output.marks = marks;
    if (node.content.childCount) {
        output.content = [];
        node.forEach((child, offset)=>{
            var _a;
            (_a = output.content) === null || _a === void 0 || _a.push($a769590142262cb7$export$d661e0733145fb37(child, startOffset + offset + increment));
        });
    }
    if (node.text) output.text = node.text;
    return output;
}
function $a769590142262cb7$export$c5fd7af7c5c1efa(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) doc.resolve(from).marks().forEach((mark)=>{
        const $pos = doc.resolve(from);
        const range = $a769590142262cb7$export$8ceae6d06f5c4df5($pos, mark.type);
        if (!range) return;
        marks.push({
            mark: mark,
            ...range
        });
    });
    else doc.nodesBetween(from, to, (node, pos)=>{
        if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) return;
        marks.push(...node.marks.map((mark)=>({
                from: pos,
                to: pos + node.nodeSize,
                mark: mark
            })));
    });
    return marks;
}
/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */ const $a769590142262cb7$export$ee90757e11fae7cd = (state, typeOrName, pos, maxDepth = 20)=>{
    const $pos = state.doc.resolve(pos);
    let currentDepth = maxDepth;
    let node = null;
    while(currentDepth > 0 && node === null){
        const currentNode = $pos.node(currentDepth);
        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) node = currentNode;
        else currentDepth -= 1;
    }
    return [
        node,
        currentDepth
    ];
};
/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */ function $a769590142262cb7$export$49b565bbca5fba3a(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object.entries(attributes).filter(([name])=>{
        const extensionAttribute = extensionAttributes.find((item)=>{
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) return false;
        return extensionAttribute.attribute.keepOnSplit;
    }));
}
function $a769590142262cb7$export$72001287e2a5b413(state, typeOrName, attributes = {}) {
    const { empty: empty, ranges: ranges } = state.selection;
    const type = typeOrName ? $a769590142262cb7$export$b1269d6bf6e491ec(typeOrName, state.schema) : null;
    if (empty) return !!(state.storedMarks || state.selection.$from.marks()).filter((mark)=>{
        if (!type) return true;
        return type.name === mark.type.name;
    }).find((mark)=>$a769590142262cb7$export$7aeb68f71172641d(mark.attrs, attributes, {
            strict: false
        }));
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from: $from, $to: $to })=>{
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isText && !node.marks.length) return;
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map((mark)=>({
                    mark: mark,
                    from: relativeFrom,
                    to: relativeTo
                })));
        });
    });
    if (selectionRange === 0) return false;
    // calculate range of matched mark
    const matchedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return type.name === markRange.mark.type.name;
    }).filter((markRange)=>$a769590142262cb7$export$7aeb68f71172641d(markRange.mark.attrs, attributes, {
            strict: false
        })).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return markRange.mark.type !== type && markRange.mark.type.excludes(type);
    }).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
    return range >= selectionRange;
}
function $a769590142262cb7$export$39e04e72f972b885(state, name, attributes = {}) {
    if (!name) return $a769590142262cb7$export$7a24a642b0c7ad29(state, null, attributes) || $a769590142262cb7$export$72001287e2a5b413(state, null, attributes);
    const schemaType = $a769590142262cb7$export$e501dfcf737a48e0(name, state.schema);
    if (schemaType === "node") return $a769590142262cb7$export$7a24a642b0c7ad29(state, name, attributes);
    if (schemaType === "mark") return $a769590142262cb7$export$72001287e2a5b413(state, name, attributes);
    return false;
}
const $a769590142262cb7$export$6a042f9d56fb39ec = (state, nodeType)=>{
    const { $from: $from, $to: $to, $anchor: $anchor } = state.selection;
    if (nodeType) {
        const parentNode = $a769590142262cb7$export$dc159056ffdb4c76((node)=>node.type.name === nodeType)(state.selection);
        if (!parentNode) return false;
        const $parentPos = state.doc.resolve(parentNode.pos + 1);
        if ($anchor.pos + 1 === $parentPos.end()) return true;
        return false;
    }
    if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) return false;
    return true;
};
const $a769590142262cb7$export$d0aa6c7595396956 = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ($from.parentOffset > 0 || $from.pos !== $to.pos) return false;
    return true;
};
function $a769590142262cb7$export$ead95ff48ba53ffd(name, extensions) {
    const { nodeExtensions: nodeExtensions } = $a769590142262cb7$export$36e8c2990da8266f(extensions);
    const extension = nodeExtensions.find((item)=>item.name === name);
    if (!extension) return false;
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage
    };
    const group = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "group", context));
    if (typeof group !== "string") return false;
    return group.split(" ").includes("list");
}
/**
 * Returns true if the given prosemirror node is empty.
 */ function $a769590142262cb7$export$cd58ff1081f6abe9(node, { checkChildren: checkChildren = true, ignoreWhitespace: ignoreWhitespace = false } = {}) {
    var _a;
    if (ignoreWhitespace) {
        if (node.type.name === "hardBreak") // Hard breaks are considered empty
        return true;
        if (node.isText) return /^\s*$/m.test((_a = node.text) !== null && _a !== void 0 ? _a : "");
    }
    if (node.isText) return !node.text;
    if (node.isAtom || node.isLeaf) return false;
    if (node.content.childCount === 0) return true;
    if (checkChildren) {
        let isContentEmpty = true;
        node.content.forEach((childNode)=>{
            if (isContentEmpty === false) // Exit early for perf
            return;
            if (!$a769590142262cb7$export$cd58ff1081f6abe9(childNode, {
                ignoreWhitespace: ignoreWhitespace,
                checkChildren: checkChildren
            })) isContentEmpty = false;
        });
        return isContentEmpty;
    }
    return false;
}
function $a769590142262cb7$export$a8c1d2c13abf8822(value) {
    return value instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b);
}
function $a769590142262cb7$export$660ecae6cde71645(view, from, to) {
    const minPos = 0;
    const maxPos = view.state.doc.content.size;
    const resolvedFrom = $a769590142262cb7$export$6fb785c609d82593(from, minPos, maxPos);
    const resolvedEnd = $a769590142262cb7$export$6fb785c609d82593(to, minPos, maxPos);
    const start = view.coordsAtPos(resolvedFrom);
    const end = view.coordsAtPos(resolvedEnd, -1);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = right - left;
    const height = bottom - top;
    const x = left;
    const y = top;
    const data = {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height,
        x: x,
        y: y
    };
    return {
        ...data,
        toJSON: ()=>data
    };
}
/**
 * The actual implementation of the rewriteUnknownContent function
 */ function $a769590142262cb7$var$rewriteUnknownContentInner({ json: json, validMarks: validMarks, validNodes: validNodes, options: options, rewrittenContent: rewrittenContent = [] }) {
    if (json.marks && Array.isArray(json.marks)) json.marks = json.marks.filter((mark)=>{
        const name = typeof mark === "string" ? mark : mark.type;
        if (validMarks.has(name)) return true;
        rewrittenContent.push({
            original: JSON.parse(JSON.stringify(mark)),
            unsupported: name
        });
        // Just ignore any unknown marks
        return false;
    });
    if (json.content && Array.isArray(json.content)) json.content = json.content.map((value)=>$a769590142262cb7$var$rewriteUnknownContentInner({
            json: value,
            validMarks: validMarks,
            validNodes: validNodes,
            options: options,
            rewrittenContent: rewrittenContent
        }).json).filter((a)=>a !== null && a !== undefined);
    if (json.type && !validNodes.has(json.type)) {
        rewrittenContent.push({
            original: JSON.parse(JSON.stringify(json)),
            unsupported: json.type
        });
        if (json.content && Array.isArray(json.content) && (options === null || options === void 0 ? void 0 : options.fallbackToParagraph) !== false) {
            // Just treat it like a paragraph and hope for the best
            json.type = "paragraph";
            return {
                json: json,
                rewrittenContent: rewrittenContent
            };
        }
        // or just omit it entirely
        return {
            json: null,
            rewrittenContent: rewrittenContent
        };
    }
    return {
        json: json,
        rewrittenContent: rewrittenContent
    };
}
/**
 * Rewrite unknown nodes and marks within JSON content
 * Allowing for user within the editor
 */ function $a769590142262cb7$export$e29d20b0f4dc64ed(/**
 * The JSON content to clean of unknown nodes and marks
 */ json, /**
 * The schema to use for validation
 */ schema, /**
 * Options for the cleaning process
 */ options) {
    return $a769590142262cb7$var$rewriteUnknownContentInner({
        json: json,
        validNodes: new Set(Object.keys(schema.nodes)),
        validMarks: new Set(Object.keys(schema.marks)),
        options: options
    });
}
function $a769590142262cb7$var$canSetMark(state, tr, newMarkType) {
    var _a;
    const { selection: selection } = tr;
    let cursor = null;
    if ($a769590142262cb7$export$38b50bf35e79aaf3(selection)) cursor = selection.$cursor;
    if (cursor) {
        const currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks();
        // There can be no current marks that exclude the new mark
        return !!newMarkType.isInSet(currentMarks) || !currentMarks.some((mark)=>mark.type.excludes(newMarkType));
    }
    const { ranges: ranges } = selection;
    return ranges.some(({ $from: $from, $to: $to })=>{
        let someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
        state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent)=>{
            // If we already found a mark that we can enable, return false to bypass the remaining search
            if (someNodeSupportsMark) return false;
            if (node.isInline) {
                const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
                const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some((otherMark)=>otherMark.type.excludes(newMarkType));
                someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
            }
            return !someNodeSupportsMark;
        });
        return someNodeSupportsMark;
    });
}
const $a769590142262cb7$var$setMark = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        const type = $a769590142262cb7$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) {
            if (empty) {
                const oldAttributes = $a769590142262cb7$export$2cd1d0e1f861bae0(state, type);
                tr.addStoredMark(type.create({
                    ...oldAttributes,
                    ...attributes
                }));
            } else ranges.forEach((range)=>{
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos)=>{
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find((mark)=>mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) node.marks.forEach((mark)=>{
                        if (type === mark.type) tr.addMark(trimmedFrom, trimmedTo, type.create({
                            ...mark.attrs,
                            ...attributes
                        }));
                    });
                    else tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                });
            });
        }
        return $a769590142262cb7$var$canSetMark(state, tr, type);
    };
const $a769590142262cb7$var$setMeta = (key, value)=>({ tr: tr })=>{
        tr.setMeta(key, value);
        return true;
    };
const $a769590142262cb7$var$setNode = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch, chain: chain })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        let attributesToCopy;
        if (state.selection.$anchor.sameParent(state.selection.$head)) // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
        // TODO: use a fallback like insertContent?
        if (!type.isTextblock) {
            console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
            return false;
        }
        return chain()// try to convert node to default node if needed
        .command(({ commands: commands })=>{
            const canSetBlock = (0, $eaf4ca4698cf30cc$export$36987f561c736aad)(type, {
                ...attributesToCopy,
                ...attributes
            })(state);
            if (canSetBlock) return true;
            return commands.clearNodes();
        }).command(({ state: updatedState })=>{
            return (0, $eaf4ca4698cf30cc$export$36987f561c736aad)(type, {
                ...attributesToCopy,
                ...attributes
            })(updatedState, dispatch);
        }).run();
    };
const $a769590142262cb7$var$setNodeSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const from = $a769590142262cb7$export$6fb785c609d82593(position, 0, doc.content.size);
            const selection = (0, $6acde7918354ce68$export$e2940151ac854c0b).create(doc, from);
            tr.setSelection(selection);
        }
        return true;
    };
const $a769590142262cb7$var$setTextSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const { from: from, to: to } = typeof position === "number" ? {
                from: position,
                to: position
            } : position;
            const minPos = (0, $6acde7918354ce68$export$c2b25f346d19bcbb).atStart(doc).from;
            const maxPos = (0, $6acde7918354ce68$export$c2b25f346d19bcbb).atEnd(doc).to;
            const resolvedFrom = $a769590142262cb7$export$6fb785c609d82593(from, minPos, maxPos);
            const resolvedEnd = $a769590142262cb7$export$6fb785c609d82593(to, minPos, maxPos);
            const selection = (0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(doc, resolvedFrom, resolvedEnd);
            tr.setSelection(selection);
        }
        return true;
    };
const $a769590142262cb7$var$sinkListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $466bf2c48224b2e3$export$dd505f850a3798a4)(type)(state, dispatch);
    };
function $a769590142262cb7$var$ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
    if (marks) {
        const filteredMarks = marks.filter((mark)=>splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const $a769590142262cb7$var$splitBlock = ({ keepMarks: keepMarks = true } = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        const { selection: selection, doc: doc } = tr;
        const { $from: $from, $to: $to } = selection;
        const extensionAttributes = editor.extensionManager.attributes;
        const newAttributes = $a769590142262cb7$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs);
        if (selection instanceof (0, $6acde7918354ce68$export$e2940151ac854c0b) && selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $72a42b551bab6846$export$5aaf008897aef029)(doc, $from.pos)) return false;
            if (dispatch) {
                if (keepMarks) $a769590142262cb7$var$ensureMarks(state, editor.extensionManager.splittableMarks);
                tr.split($from.pos).scrollIntoView();
            }
            return true;
        }
        if (!$from.parent.isBlock) return false;
        const atEnd = $to.parentOffset === $to.parent.content.size;
        const deflt = $from.depth === 0 ? undefined : $a769590142262cb7$export$6133a2de0e8ac885($from.node(-1).contentMatchAt($from.indexAfter(-1)));
        let types = atEnd && deflt ? [
            {
                type: deflt,
                attrs: newAttributes
            }
        ] : undefined;
        let can = (0, $72a42b551bab6846$export$5aaf008897aef029)(tr.doc, tr.mapping.map($from.pos), 1, types);
        if (!types && !can && (0, $72a42b551bab6846$export$5aaf008897aef029)(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [
            {
                type: deflt
            }
        ] : undefined)) {
            can = true;
            types = deflt ? [
                {
                    type: deflt,
                    attrs: newAttributes
                }
            ] : undefined;
        }
        if (dispatch) {
            if (can) {
                if (selection instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb)) tr.deleteSelection();
                tr.split(tr.mapping.map($from.pos), 1, types);
                if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
                    const first = tr.mapping.map($from.before());
                    const $first = tr.doc.resolve(first);
                    if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
            if (keepMarks) $a769590142262cb7$var$ensureMarks(state, editor.extensionManager.splittableMarks);
            tr.scrollIntoView();
        }
        return can;
    };
const $a769590142262cb7$var$splitListItem = (typeOrName, overrideAttrs = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        var _a;
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        const { $from: $from, $to: $to } = state.selection;
        // @ts-ignore
        // eslint-disable-next-line
        const node = state.selection.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        const grandParent = $from.node(-1);
        if (grandParent.type !== type) return false;
        const extensionAttributes = editor.extensionManager.attributes;
        if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
                // eslint-disable-next-line
                const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1)wrap = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from($from.node(d).copy(wrap));
                // eslint-disable-next-line
                const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                const newNextTypeAttributes = {
                    ...$a769590142262cb7$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs),
                    ...overrideAttrs
                };
                const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
                wrap = wrap.append((0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(type.createAndFill(null, nextType) || undefined));
                const start = $from.before($from.depth - (depthBefore - 1));
                tr.replace(start, $from.after(-depthAfter), new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos)=>{
                    if (sel > -1) return false;
                    if (n.isTextblock && n.content.size === 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).near(tr.doc.resolve(sel)));
                tr.scrollIntoView();
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        const newTypeAttributes = {
            ...$a769590142262cb7$export$49b565bbca5fba3a(extensionAttributes, grandParent.type.name, grandParent.attrs),
            ...overrideAttrs
        };
        const newNextTypeAttributes = {
            ...$a769590142262cb7$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs),
            ...overrideAttrs
        };
        tr.delete($from.pos, $to.pos);
        const types = nextType ? [
            {
                type: type,
                attrs: newTypeAttributes
            },
            {
                type: nextType,
                attrs: newNextTypeAttributes
            }
        ] : [
            {
                type: type,
                attrs: newTypeAttributes
            }
        ];
        if (!(0, $72a42b551bab6846$export$5aaf008897aef029)(tr.doc, $from.pos, 2)) return false;
        if (dispatch) {
            const { selection: selection, storedMarks: storedMarks } = state;
            const { splittableMarks: splittableMarks } = editor.extensionManager;
            const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
            tr.split($from.pos, 2, types).scrollIntoView();
            if (!marks || !dispatch) return true;
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
        }
        return true;
    };
const $a769590142262cb7$var$joinListBackwards = (tr, listType)=>{
    const list = $a769590142262cb7$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) return true;
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && (0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(tr.doc, list.pos);
    if (!canJoinBackwards) return true;
    tr.join(list.pos);
    return true;
};
const $a769590142262cb7$var$joinListForwards = (tr, listType)=>{
    const list = $a769590142262cb7$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) return true;
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && (0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(tr.doc, after);
    if (!canJoinForwards) return true;
    tr.join(after);
    return true;
};
const $a769590142262cb7$var$toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {})=>({ editor: editor, tr: tr, state: state, dispatch: dispatch, chain: chain, commands: commands, can: can })=>{
        const { extensions: extensions, splittableMarks: splittableMarks } = editor.extensionManager;
        const listType = $a769590142262cb7$export$d168cba70360dd3d(listTypeOrName, state.schema);
        const itemType = $a769590142262cb7$export$d168cba70360dd3d(itemTypeOrName, state.schema);
        const { selection: selection, storedMarks: storedMarks } = state;
        const { $from: $from, $to: $to } = selection;
        const range = $from.blockRange($to);
        const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
        if (!range) return false;
        const parentList = $a769590142262cb7$export$dc159056ffdb4c76((node)=>$a769590142262cb7$export$ead95ff48ba53ffd(node.type.name, extensions))(selection);
        if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
            // remove list
            if (parentList.node.type === listType) return commands.liftListItem(itemType);
            // change list type
            if ($a769590142262cb7$export$ead95ff48ba53ffd(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) return chain().command(()=>{
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            }).command(()=>$a769590142262cb7$var$joinListBackwards(tr, listType)).command(()=>$a769590142262cb7$var$joinListForwards(tr, listType)).run();
        }
        if (!keepMarks || !marks || !dispatch) return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$a769590142262cb7$var$joinListBackwards(tr, listType)).command(()=>$a769590142262cb7$var$joinListForwards(tr, listType)).run();
        return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$a769590142262cb7$var$joinListBackwards(tr, listType)).command(()=>$a769590142262cb7$var$joinListForwards(tr, listType)).run();
    };
const $a769590142262cb7$var$toggleMark = (typeOrName, attributes = {}, options = {})=>({ state: state, commands: commands })=>{
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const type = $a769590142262cb7$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const isActive = $a769590142262cb7$export$72001287e2a5b413(state, type, attributes);
        if (isActive) return commands.unsetMark(type, {
            extendEmptyMarkRange: extendEmptyMarkRange
        });
        return commands.setMark(type, attributes);
    };
const $a769590142262cb7$var$toggleNode = (typeOrName, toggleTypeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        const toggleType = $a769590142262cb7$export$d168cba70360dd3d(toggleTypeOrName, state.schema);
        const isActive = $a769590142262cb7$export$7a24a642b0c7ad29(state, type, attributes);
        let attributesToCopy;
        if (state.selection.$anchor.sameParent(state.selection.$head)) // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
        if (isActive) return commands.setNode(toggleType, attributesToCopy);
        // If the node is not active, we want to set the new node type with the given attributes
        // Copying over the attributes from the current node if the selection is pointing to a node of the same type
        return commands.setNode(type, {
            ...attributesToCopy,
            ...attributes
        });
    };
const $a769590142262cb7$var$toggleWrap = (typeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $a769590142262cb7$export$7a24a642b0c7ad29(state, type, attributes);
        if (isActive) return commands.lift(type);
        return commands.wrapIn(type, attributes);
    };
const $a769590142262cb7$var$undoInputRule = ()=>({ state: state, dispatch: dispatch })=>{
        const plugins = state.plugins;
        for(let i = 0; i < plugins.length; i += 1){
            const plugin = plugins[i];
            let undoable;
            // @ts-ignore
            // eslint-disable-next-line
            if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
                if (dispatch) {
                    const tr = state.tr;
                    const toUndo = undoable.transform;
                    for(let j = toUndo.steps.length - 1; j >= 0; j -= 1)tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                    if (undoable.text) {
                        const marks = tr.doc.resolve(undoable.from).marks();
                        tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                    } else tr.delete(undoable.from, undoable.to);
                }
                return true;
            }
        }
        return false;
    };
const $a769590142262cb7$var$unsetAllMarks = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        if (empty) return true;
        if (dispatch) ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
        return true;
    };
const $a769590142262cb7$var$unsetMark = (typeOrName, options = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        var _a;
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const { selection: selection } = tr;
        const type = $a769590142262cb7$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { $from: $from, empty: empty, ranges: ranges } = selection;
        if (!dispatch) return true;
        if (empty && extendEmptyMarkRange) {
            let { from: from, to: to } = selection;
            const attrs = (_a = $from.marks().find((mark)=>mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
            const range = $a769590142262cb7$export$8ceae6d06f5c4df5($from, type, attrs);
            if (range) {
                from = range.from;
                to = range.to;
            }
            tr.removeMark(from, to, type);
        } else ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
        tr.removeStoredMark(type);
        return true;
    };
const $a769590142262cb7$var$updateAttributes = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $a769590142262cb7$export$e501dfcf737a48e0(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === "node") nodeType = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === "mark") markType = $a769590142262cb7$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            const from = range.$from.pos;
            const to = range.$to.pos;
            let lastPos;
            let lastNode;
            let trimmedFrom;
            let trimmedTo;
            if (tr.selection.empty) state.doc.nodesBetween(from, to, (node, pos)=>{
                if (nodeType && nodeType === node.type) {
                    trimmedFrom = Math.max(pos, from);
                    trimmedTo = Math.min(pos + node.nodeSize, to);
                    lastPos = pos;
                    lastNode = node;
                }
            });
            else state.doc.nodesBetween(from, to, (node, pos)=>{
                if (pos < from && nodeType && nodeType === node.type) {
                    trimmedFrom = Math.max(pos, from);
                    trimmedTo = Math.min(pos + node.nodeSize, to);
                    lastPos = pos;
                    lastNode = node;
                }
                if (pos >= from && pos <= to) {
                    if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        ...attributes
                    });
                    if (markType && node.marks.length) node.marks.forEach((mark)=>{
                        if (markType === mark.type) {
                            const trimmedFrom2 = Math.max(pos, from);
                            const trimmedTo2 = Math.min(pos + node.nodeSize, to);
                            tr.addMark(trimmedFrom2, trimmedTo2, markType.create({
                                ...mark.attrs,
                                ...attributes
                            }));
                        }
                    });
                }
            });
            if (lastNode) {
                if (lastPos !== undefined) tr.setNodeMarkup(lastPos, undefined, {
                    ...lastNode.attrs,
                    ...attributes
                });
                if (markType && lastNode.marks.length) lastNode.marks.forEach((mark)=>{
                    if (markType === mark.type) tr.addMark(trimmedFrom, trimmedTo, markType.create({
                        ...mark.attrs,
                        ...attributes
                    }));
                });
            }
        });
        return true;
    };
const $a769590142262cb7$var$wrapIn = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $eaf4ca4698cf30cc$export$6e5e3c49755affd0)(type, attributes)(state, dispatch);
    };
const $a769590142262cb7$var$wrapInList = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $a769590142262cb7$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $466bf2c48224b2e3$export$a8aef45c6262afee)(type, attributes)(state, dispatch);
    };
var $a769590142262cb7$var$commands = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    blur: $a769590142262cb7$var$blur,
    clearContent: $a769590142262cb7$var$clearContent,
    clearNodes: $a769590142262cb7$var$clearNodes,
    command: $a769590142262cb7$var$command,
    createParagraphNear: $a769590142262cb7$var$createParagraphNear,
    cut: $a769590142262cb7$var$cut,
    deleteCurrentNode: $a769590142262cb7$var$deleteCurrentNode,
    deleteNode: $a769590142262cb7$var$deleteNode,
    deleteRange: $a769590142262cb7$var$deleteRange,
    deleteSelection: $a769590142262cb7$var$deleteSelection,
    enter: $a769590142262cb7$var$enter,
    exitCode: $a769590142262cb7$var$exitCode,
    extendMarkRange: $a769590142262cb7$var$extendMarkRange,
    first: $a769590142262cb7$var$first,
    focus: $a769590142262cb7$var$focus,
    forEach: $a769590142262cb7$var$forEach,
    insertContent: $a769590142262cb7$var$insertContent,
    insertContentAt: $a769590142262cb7$var$insertContentAt,
    joinBackward: $a769590142262cb7$var$joinBackward,
    joinDown: $a769590142262cb7$var$joinDown,
    joinForward: $a769590142262cb7$var$joinForward,
    joinItemBackward: $a769590142262cb7$var$joinItemBackward,
    joinItemForward: $a769590142262cb7$var$joinItemForward,
    joinTextblockBackward: $a769590142262cb7$var$joinTextblockBackward,
    joinTextblockForward: $a769590142262cb7$var$joinTextblockForward,
    joinUp: $a769590142262cb7$var$joinUp,
    keyboardShortcut: $a769590142262cb7$var$keyboardShortcut,
    lift: $a769590142262cb7$var$lift,
    liftEmptyBlock: $a769590142262cb7$var$liftEmptyBlock,
    liftListItem: $a769590142262cb7$var$liftListItem,
    newlineInCode: $a769590142262cb7$var$newlineInCode,
    resetAttributes: $a769590142262cb7$var$resetAttributes,
    scrollIntoView: $a769590142262cb7$var$scrollIntoView,
    selectAll: $a769590142262cb7$var$selectAll,
    selectNodeBackward: $a769590142262cb7$var$selectNodeBackward,
    selectNodeForward: $a769590142262cb7$var$selectNodeForward,
    selectParentNode: $a769590142262cb7$var$selectParentNode,
    selectTextblockEnd: $a769590142262cb7$var$selectTextblockEnd,
    selectTextblockStart: $a769590142262cb7$var$selectTextblockStart,
    setContent: $a769590142262cb7$var$setContent,
    setMark: $a769590142262cb7$var$setMark,
    setMeta: $a769590142262cb7$var$setMeta,
    setNode: $a769590142262cb7$var$setNode,
    setNodeSelection: $a769590142262cb7$var$setNodeSelection,
    setTextSelection: $a769590142262cb7$var$setTextSelection,
    sinkListItem: $a769590142262cb7$var$sinkListItem,
    splitBlock: $a769590142262cb7$var$splitBlock,
    splitListItem: $a769590142262cb7$var$splitListItem,
    toggleList: $a769590142262cb7$var$toggleList,
    toggleMark: $a769590142262cb7$var$toggleMark,
    toggleNode: $a769590142262cb7$var$toggleNode,
    toggleWrap: $a769590142262cb7$var$toggleWrap,
    undoInputRule: $a769590142262cb7$var$undoInputRule,
    unsetAllMarks: $a769590142262cb7$var$unsetAllMarks,
    unsetMark: $a769590142262cb7$var$unsetMark,
    updateAttributes: $a769590142262cb7$var$updateAttributes,
    wrapIn: $a769590142262cb7$var$wrapIn,
    wrapInList: $a769590142262cb7$var$wrapInList
});
const $a769590142262cb7$var$Commands = $a769590142262cb7$export$eeddbf09bb970356.create({
    name: "commands",
    addCommands () {
        return {
            ...$a769590142262cb7$var$commands
        };
    }
});
const $a769590142262cb7$var$Drop = $a769590142262cb7$export$eeddbf09bb970356.create({
    name: "drop",
    addProseMirrorPlugins () {
        return [
            new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
                key: new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("tiptapDrop"),
                props: {
                    handleDrop: (_, e, slice, moved)=>{
                        this.editor.emit("drop", {
                            editor: this.editor,
                            event: e,
                            slice: slice,
                            moved: moved
                        });
                    }
                }
            })
        ];
    }
});
const $a769590142262cb7$var$Editable = $a769590142262cb7$export$eeddbf09bb970356.create({
    name: "editable",
    addProseMirrorPlugins () {
        return [
            new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
                key: new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("editable"),
                props: {
                    editable: ()=>this.editor.options.editable
                }
            })
        ];
    }
});
const $a769590142262cb7$var$FocusEvents = $a769590142262cb7$export$eeddbf09bb970356.create({
    name: "focusEvents",
    addProseMirrorPlugins () {
        const { editor: editor } = this;
        return [
            new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
                key: new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("focusEvents"),
                props: {
                    handleDOMEvents: {
                        focus: (view, event)=>{
                            editor.isFocused = true;
                            const transaction = editor.state.tr.setMeta("focus", {
                                event: event
                            }).setMeta("addToHistory", false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event)=>{
                            editor.isFocused = false;
                            const transaction = editor.state.tr.setMeta("blur", {
                                event: event
                            }).setMeta("addToHistory", false);
                            view.dispatch(transaction);
                            return false;
                        }
                    }
                }
            })
        ];
    }
});
const $a769590142262cb7$var$Keymap = $a769590142262cb7$export$eeddbf09bb970356.create({
    name: "keymap",
    addKeyboardShortcuts () {
        const handleBackspace = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.undoInputRule(),
                    // maybe convert first text block node to default node
                    ()=>commands.command(({ tr: tr })=>{
                            const { selection: selection, doc: doc } = tr;
                            const { empty: empty, $anchor: $anchor } = selection;
                            const { pos: pos, parent: parent } = $anchor;
                            const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
                            const parentIsIsolating = $parentPos.parent.type.spec.isolating;
                            const parentPos = $anchor.pos - $anchor.parentOffset;
                            const isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : (0, $6acde7918354ce68$export$52baac22726c72bf).atStart(doc).from === pos;
                            if (!empty || !parent.type.isTextblock || parent.textContent.length || !isAtStart || isAtStart && $anchor.parent.type.name === "paragraph" // prevent clearNodes when no nodes to clear, otherwise history stack is appended
                            ) return false;
                            return commands.clearNodes();
                        }),
                    ()=>commands.deleteSelection(),
                    ()=>commands.joinBackward(),
                    ()=>commands.selectNodeBackward()
                ]);
        const handleDelete = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.deleteSelection(),
                    ()=>commands.deleteCurrentNode(),
                    ()=>commands.joinForward(),
                    ()=>commands.selectNodeForward()
                ]);
        const handleEnter = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.newlineInCode(),
                    ()=>commands.createParagraphNear(),
                    ()=>commands.liftEmptyBlock(),
                    ()=>commands.splitBlock()
                ]);
        const baseKeymap = {
            Enter: handleEnter,
            "Mod-Enter": ()=>this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            "Mod-Backspace": handleBackspace,
            "Shift-Backspace": handleBackspace,
            Delete: handleDelete,
            "Mod-Delete": handleDelete,
            "Mod-a": ()=>this.editor.commands.selectAll()
        };
        const pcKeymap = {
            ...baseKeymap
        };
        const macKeymap = {
            ...baseKeymap,
            "Ctrl-h": handleBackspace,
            "Alt-Backspace": handleBackspace,
            "Ctrl-d": handleDelete,
            "Ctrl-Alt-Backspace": handleDelete,
            "Alt-Delete": handleDelete,
            "Alt-d": handleDelete,
            "Ctrl-a": ()=>this.editor.commands.selectTextblockStart(),
            "Ctrl-e": ()=>this.editor.commands.selectTextblockEnd()
        };
        if ($a769590142262cb7$export$86c1a3f9ab33da5c() || $a769590142262cb7$export$6159e43e50a41987()) return macKeymap;
        return pcKeymap;
    },
    addProseMirrorPlugins () {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
                key: new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("clearDocument"),
                appendTransaction: (transactions, oldState, newState)=>{
                    const docChanges = transactions.some((transaction)=>transaction.docChanged) && !oldState.doc.eq(newState.doc);
                    const ignoreTr = transactions.some((transaction)=>transaction.getMeta("preventClearDocument"));
                    if (!docChanges || ignoreTr) return;
                    const { empty: empty, from: from, to: to } = oldState.selection;
                    const allFrom = (0, $6acde7918354ce68$export$52baac22726c72bf).atStart(oldState.doc).from;
                    const allEnd = (0, $6acde7918354ce68$export$52baac22726c72bf).atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    if (empty || !allWasSelected) return;
                    const isEmpty = $a769590142262cb7$export$cd58ff1081f6abe9(newState.doc);
                    if (!isEmpty) return;
                    const tr = newState.tr;
                    const state = $a769590142262cb7$export$83e24c5933427696({
                        state: newState,
                        transaction: tr
                    });
                    const { commands: commands } = new $a769590142262cb7$export$475014de15a4c342({
                        editor: this.editor,
                        state: state
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) return;
                    return tr;
                }
            })
        ];
    }
});
const $a769590142262cb7$var$Paste = $a769590142262cb7$export$eeddbf09bb970356.create({
    name: "paste",
    addProseMirrorPlugins () {
        return [
            new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
                key: new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("tiptapPaste"),
                props: {
                    handlePaste: (_view, e, slice)=>{
                        this.editor.emit("paste", {
                            editor: this.editor,
                            event: e,
                            slice: slice
                        });
                    }
                }
            })
        ];
    }
});
const $a769590142262cb7$var$Tabindex = $a769590142262cb7$export$eeddbf09bb970356.create({
    name: "tabindex",
    addProseMirrorPlugins () {
        return [
            new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
                key: new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("tabindex"),
                props: {
                    attributes: ()=>this.editor.isEditable ? {
                            tabindex: "0"
                        } : {}
                }
            })
        ];
    }
});
var $a769590142262cb7$export$cc3e2d3244e01b7f = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ClipboardTextSerializer: $a769590142262cb7$var$ClipboardTextSerializer,
    Commands: $a769590142262cb7$var$Commands,
    Drop: $a769590142262cb7$var$Drop,
    Editable: $a769590142262cb7$var$Editable,
    FocusEvents: $a769590142262cb7$var$FocusEvents,
    Keymap: $a769590142262cb7$var$Keymap,
    Paste: $a769590142262cb7$var$Paste,
    Tabindex: $a769590142262cb7$var$Tabindex
});
class $a769590142262cb7$export$50c0270e74640068 {
    get name() {
        return this.node.type.name;
    }
    constructor(pos, editor, isBlock = false, node = null){
        this.currentNode = null;
        this.actualDepth = null;
        this.isBlock = isBlock;
        this.resolvedPos = pos;
        this.editor = editor;
        this.currentNode = node;
    }
    get node() {
        return this.currentNode || this.resolvedPos.node();
    }
    get element() {
        return this.editor.view.domAtPos(this.pos).node;
    }
    get depth() {
        var _a;
        return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
    get pos() {
        return this.resolvedPos.pos;
    }
    get content() {
        return this.node.content;
    }
    set content(content) {
        let from = this.from;
        let to = this.to;
        if (this.isBlock) {
            if (this.content.size === 0) {
                console.error(`You can\u{2019}t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
                return;
            }
            from = this.from + 1;
            to = this.to - 1;
        }
        this.editor.commands.insertContentAt({
            from: from,
            to: to
        }, content);
    }
    get attributes() {
        return this.node.attrs;
    }
    get textContent() {
        return this.node.textContent;
    }
    get size() {
        return this.node.nodeSize;
    }
    get from() {
        if (this.isBlock) return this.pos;
        return this.resolvedPos.start(this.resolvedPos.depth);
    }
    get range() {
        return {
            from: this.from,
            to: this.to
        };
    }
    get to() {
        if (this.isBlock) return this.pos + this.size;
        return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
    get parent() {
        if (this.depth === 0) return null;
        const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
        const $pos = this.resolvedPos.doc.resolve(parentPos);
        return new $a769590142262cb7$export$50c0270e74640068($pos, this.editor);
    }
    get before() {
        let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.from - 3);
        return new $a769590142262cb7$export$50c0270e74640068($pos, this.editor);
    }
    get after() {
        let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.to + 3);
        return new $a769590142262cb7$export$50c0270e74640068($pos, this.editor);
    }
    get children() {
        const children = [];
        this.node.content.forEach((node, offset)=>{
            const isBlock = node.isBlock && !node.isTextblock;
            const isNonTextAtom = node.isAtom && !node.isText;
            const targetPos = this.pos + offset + (isNonTextAtom ? 0 : 1);
            const $pos = this.resolvedPos.doc.resolve(targetPos);
            if (!isBlock && $pos.depth <= this.depth) return;
            const childNodePos = new $a769590142262cb7$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null);
            if (isBlock) childNodePos.actualDepth = this.depth + 1;
            children.push(new $a769590142262cb7$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null));
        });
        return children;
    }
    get firstChild() {
        return this.children[0] || null;
    }
    get lastChild() {
        const children = this.children;
        return children[children.length - 1] || null;
    }
    closest(selector, attributes = {}) {
        let node = null;
        let currentNode = this.parent;
        while(currentNode && !node){
            if (currentNode.node.type.name === selector) {
                if (Object.keys(attributes).length > 0) {
                    const nodeAttributes = currentNode.node.attrs;
                    const attrKeys = Object.keys(attributes);
                    for(let index = 0; index < attrKeys.length; index += 1){
                        const key = attrKeys[index];
                        if (nodeAttributes[key] !== attributes[key]) break;
                    }
                } else node = currentNode;
            }
            currentNode = currentNode.parent;
        }
        return node;
    }
    querySelector(selector, attributes = {}) {
        return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
    querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
        let nodes = [];
        if (!this.children || this.children.length === 0) return nodes;
        const attrKeys = Object.keys(attributes);
        /**
         * Finds all children recursively that match the selector and attributes
         * If firstItemOnly is true, it will return the first item found
         */ this.children.forEach((childPos)=>{
            // If we already found a node and we only want the first item, we dont need to keep going
            if (firstItemOnly && nodes.length > 0) return;
            if (childPos.node.type.name === selector) {
                const doesAllAttributesMatch = attrKeys.every((key)=>attributes[key] === childPos.node.attrs[key]);
                if (doesAllAttributesMatch) nodes.push(childPos);
            }
            // If we already found a node and we only want the first item, we can stop here and skip the recursion
            if (firstItemOnly && nodes.length > 0) return;
            nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
        });
        return nodes;
    }
    setAttribute(attributes) {
        const { tr: tr } = this.editor.state;
        tr.setNodeMarkup(this.from, undefined, {
            ...this.node.attrs,
            ...attributes
        });
        this.editor.view.dispatch(tr);
    }
}
const $a769590142262cb7$var$style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function $a769590142262cb7$export$48321b481dd8a36(style, nonce, suffix) {
    const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${suffix ? `-${suffix}` : ""}]`);
    if (tiptapStyleTag !== null) return tiptapStyleTag;
    const styleNode = document.createElement("style");
    if (nonce) styleNode.setAttribute("nonce", nonce);
    styleNode.setAttribute(`data-tiptap-style${suffix ? `-${suffix}` : ""}`, "");
    styleNode.innerHTML = style;
    document.getElementsByTagName("head")[0].appendChild(styleNode);
    return styleNode;
}
class $a769590142262cb7$export$7cda8d932e2f33c0 extends $a769590142262cb7$var$EventEmitter {
    constructor(options = {}){
        super();
        this.isFocused = false;
        /**
         * The editor is considered initialized after the `create` event has been emitted.
         */ this.isInitialized = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement("div"),
            content: "",
            injectCSS: true,
            injectNonce: undefined,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            coreExtensionOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            enableContentCheck: false,
            onBeforeCreate: ()=>null,
            onCreate: ()=>null,
            onUpdate: ()=>null,
            onSelectionUpdate: ()=>null,
            onTransaction: ()=>null,
            onFocus: ()=>null,
            onBlur: ()=>null,
            onDestroy: ()=>null,
            onContentError: ({ error: error })=>{
                throw error;
            },
            onPaste: ()=>null,
            onDrop: ()=>null
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on("beforeCreate", this.options.onBeforeCreate);
        this.emit("beforeCreate", {
            editor: this
        });
        this.on("contentError", this.options.onContentError);
        this.createView();
        this.injectCSS();
        this.on("create", this.options.onCreate);
        this.on("update", this.options.onUpdate);
        this.on("selectionUpdate", this.options.onSelectionUpdate);
        this.on("transaction", this.options.onTransaction);
        this.on("focus", this.options.onFocus);
        this.on("blur", this.options.onBlur);
        this.on("destroy", this.options.onDestroy);
        this.on("drop", ({ event: event, slice: slice, moved: moved })=>this.options.onDrop(event, slice, moved));
        this.on("paste", ({ event: event, slice: slice })=>this.options.onPaste(event, slice));
        window.setTimeout(()=>{
            if (this.isDestroyed) return;
            this.commands.focus(this.options.autofocus);
            this.emit("create", {
                editor: this
            });
            this.isInitialized = true;
        }, 0);
    }
    /**
     * Returns the editor storage.
     */ get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */ get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */ chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */ can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */ injectCSS() {
        if (this.options.injectCSS && document) this.css = $a769590142262cb7$export$48321b481dd8a36($a769590142262cb7$var$style, this.options.injectNonce);
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */ setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options
        };
        if (!this.view || !this.state || this.isDestroyed) return;
        if (this.options.editorProps) this.view.setProps(this.options.editorProps);
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */ setEditable(editable, emitUpdate = true) {
        this.setOptions({
            editable: editable
        });
        if (emitUpdate) this.emit("update", {
            editor: this,
            transaction: this.state.tr
        });
    }
    /**
     * Returns whether the editor is editable.
     */ get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */ get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     * @returns The new editor state
     */ registerPlugin(plugin, handlePlugins) {
        const plugins = $a769590142262cb7$export$f6e2535fb5126e54(handlePlugins) ? handlePlugins(plugin, [
            ...this.state.plugins
        ]) : [
            ...this.state.plugins,
            plugin
        ];
        const state = this.state.reconfigure({
            plugins: plugins
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKeyToRemove The plugins name
     * @returns The new editor state or undefined if the editor is destroyed
     */ unregisterPlugin(nameOrPluginKeyToRemove) {
        if (this.isDestroyed) return undefined;
        const prevPlugins = this.state.plugins;
        let plugins = prevPlugins;
        [].concat(nameOrPluginKeyToRemove).forEach((nameOrPluginKey)=>{
            // @ts-ignore
            const name = typeof nameOrPluginKey === "string" ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
            // @ts-ignore
            plugins = prevPlugins.filter((plugin)=>!plugin.key.startsWith(name));
        });
        if (prevPlugins.length === plugins.length) // No plugin was removed, so we don’t need to update the state
        return undefined;
        const state = this.state.reconfigure({
            plugins: plugins
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Creates an extension manager.
     */ createExtensionManager() {
        var _a, _b;
        const coreExtensions = this.options.enableCoreExtensions ? [
            $a769590142262cb7$var$Editable,
            $a769590142262cb7$var$ClipboardTextSerializer.configure({
                blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator
            }),
            $a769590142262cb7$var$Commands,
            $a769590142262cb7$var$FocusEvents,
            $a769590142262cb7$var$Keymap,
            $a769590142262cb7$var$Tabindex,
            $a769590142262cb7$var$Drop,
            $a769590142262cb7$var$Paste
        ].filter((ext)=>{
            if (typeof this.options.enableCoreExtensions === "object") return this.options.enableCoreExtensions[ext.name] !== false;
            return true;
        }) : [];
        const allExtensions = [
            ...coreExtensions,
            ...this.options.extensions
        ].filter((extension)=>{
            return [
                "extension",
                "node",
                "mark"
            ].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new $a769590142262cb7$var$ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */ createCommandManager() {
        this.commandManager = new $a769590142262cb7$export$475014de15a4c342({
            editor: this
        });
    }
    /**
     * Creates a ProseMirror schema.
     */ createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */ createView() {
        var _a;
        let doc;
        try {
            doc = $a769590142262cb7$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions, {
                errorOnInvalidContent: this.options.enableContentCheck
            });
        } catch (e) {
            if (!(e instanceof Error) || ![
                "[tiptap error]: Invalid JSON content",
                "[tiptap error]: Invalid HTML content"
            ].includes(e.message)) // Not the content error we were expecting
            throw e;
            this.emit("contentError", {
                editor: this,
                error: e,
                disableCollaboration: ()=>{
                    if (this.storage.collaboration) this.storage.collaboration.isDisabled = true;
                    // To avoid syncing back invalid content, reinitialize the extensions without the collaboration extension
                    this.options.extensions = this.options.extensions.filter((extension)=>extension.name !== "collaboration");
                    // Restart the initialization process by recreating the extension manager with the new set of extensions
                    this.createExtensionManager();
                }
            });
            // Content is invalid, but attempt to create it anyway, stripping out the invalid parts
            doc = $a769590142262cb7$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions, {
                errorOnInvalidContent: false
            });
        }
        const selection = $a769590142262cb7$export$225b0233b78e0d61(doc, this.options.autofocus);
        this.view = new (0, $5b3735bad55c10ce$export$eece2fccabbb77c5)(this.options.element, {
            ...this.options.editorProps,
            attributes: {
                // add `role="textbox"` to the editor element
                role: "textbox",
                ...(_a = this.options.editorProps) === null || _a === void 0 ? void 0 : _a.attributes
            },
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: (0, $6acde7918354ce68$export$afa855cbfaff27f2).create({
                doc: doc,
                selection: selection || undefined
            })
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins
        });
        this.view.updateState(newState);
        this.createNodeViews();
        this.prependClass();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        // @ts-ignore
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */ createNodeViews() {
        if (this.view.isDestroyed) return;
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews
        });
    }
    /**
     * Prepend class name to element.
     */ prependClass() {
        this.view.dom.className = `tiptap ${this.view.dom.className}`;
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */ dispatchTransaction(transaction) {
        // if the editor / the view of the editor was destroyed
        // the transaction should not be dispatched as there is no view anymore.
        if (this.view.isDestroyed) return;
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach((step)=>{
                var _a;
                return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step);
            });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.emit("beforeTransaction", {
            editor: this,
            transaction: transaction,
            nextState: state
        });
        this.view.updateState(state);
        this.emit("transaction", {
            editor: this,
            transaction: transaction
        });
        if (selectionHasChanged) this.emit("selectionUpdate", {
            editor: this,
            transaction: transaction
        });
        const focus = transaction.getMeta("focus");
        const blur = transaction.getMeta("blur");
        if (focus) this.emit("focus", {
            editor: this,
            event: focus.event,
            transaction: transaction
        });
        if (blur) this.emit("blur", {
            editor: this,
            event: blur.event,
            transaction: transaction
        });
        if (!transaction.docChanged || transaction.getMeta("preventUpdate")) return;
        this.emit("update", {
            editor: this,
            transaction: transaction
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */ getAttributes(nameOrType) {
        return $a769590142262cb7$export$fe94072fee8a6976(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === "string" ? nameOrAttributes : null;
        const attributes = typeof nameOrAttributes === "string" ? attributesOrUndefined : nameOrAttributes;
        return $a769590142262cb7$export$39e04e72f972b885(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */ getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */ getHTML() {
        return $a769590142262cb7$export$d1b60002472b2c81(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */ getText(options) {
        const { blockSeparator: blockSeparator = "\n\n", textSerializers: textSerializers = {} } = options || {};
        return $a769590142262cb7$export$c72d34660a162238(this.state.doc, {
            blockSeparator: blockSeparator,
            textSerializers: {
                ...$a769590142262cb7$export$fdd92b7d22ac071c(this.schema),
                ...textSerializers
            }
        });
    }
    /**
     * Check if there is no content.
     */ get isEmpty() {
        return $a769590142262cb7$export$cd58ff1081f6abe9(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */ getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */ destroy() {
        this.emit("destroy");
        if (this.view) {
            // Cleanup our reference to prevent circular references which caused memory leaks
            // @ts-ignore
            const dom = this.view.dom;
            if (dom && dom.editor) delete dom.editor;
            this.view.destroy();
        }
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */ get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
    $node(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
    $nodes(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
    $pos(pos) {
        const $pos = this.state.doc.resolve(pos);
        return new $a769590142262cb7$export$50c0270e74640068($pos, this);
    }
    get $doc() {
        return this.$pos(0);
    }
}
/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $a769590142262cb7$export$9f2cb743ab9131de(config) {
    return new $a769590142262cb7$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $a769590142262cb7$export$592682234826c0bd(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $a769590142262cb7$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                const markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $a769590142262cb7$export$6ca56856dfeaf9b6(config) {
    return new $a769590142262cb7$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $a769590142262cb7$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const { tr: tr } = state;
            const start = range.from;
            let end = range.to;
            const newNode = config.type.create(attributes);
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                let matchStart = start + offset;
                if (matchStart > end) matchStart = end;
                else end = matchStart + match[1].length;
                // insert last typed character
                const lastChar = match[0][match[0].length - 1];
                tr.insertText(lastChar, start + match[0].length - 1);
                // insert node from input rule
                tr.replaceWith(matchStart, end, newNode);
            } else if (match[0]) {
                const insertionStart = config.type.isInline ? start : start - 1;
                tr.insert(insertionStart, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
            }
            tr.scrollIntoView();
        }
    });
}
/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $a769590142262cb7$export$cc081314d3f6ffb0(config) {
    return new $a769590142262cb7$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const $start = state.doc.resolve(range.from);
            const attributes = $a769590142262cb7$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) return null;
            state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, config.type, attributes);
        }
    });
}
/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $a769590142262cb7$export$3ba5a5a15d18a35c(config) {
    return new $a769590142262cb7$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $a769590142262cb7$export$f7316d89abe4e1c1(config) {
    return new $a769590142262cb7$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match, chain: chain })=>{
            const attributes = $a769590142262cb7$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && (0, $72a42b551bab6846$export$118cb9a83e81ba37)(blockRange, config.type, attributes);
            if (!wrapping) return null;
            tr.wrap(blockRange, wrapping);
            if (config.keepMarks && config.editor) {
                const { selection: selection, storedMarks: storedMarks } = state;
                const { splittableMarks: splittableMarks } = config.editor.extensionManager;
                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                if (marks) {
                    const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                    tr.ensureMarks(filteredMarks);
                }
            }
            if (config.keepAttributes) {
                /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */ const nodeType = config.type.name === "bulletList" || config.type.name === "orderedList" ? "listItem" : "taskList";
                chain().updateAttributes(nodeType, attributes).run();
            }
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before && before.type === config.type && (0, $72a42b551bab6846$export$f15f89fd9d8cc98a)(tr.doc, range.from - 1) && (!config.joinPredicate || config.joinPredicate(match, before))) tr.join(range.from - 1);
        }
    });
}
/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $a769590142262cb7$export$85c928794f8d04d4 {
    constructor(config = {}){
        this.type = "node";
        this.name = "node";
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(this, "addOptions", {
            name: this.name
        }));
        this.storage = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(this, "addStorage", {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $a769590142262cb7$export$85c928794f8d04d4(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $a769590142262cb7$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $a769590142262cb7$export$85c928794f8d04d4(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "addOptions", {
            name: extension.name
        }));
        extension.storage = $a769590142262cb7$export$592682234826c0bd($a769590142262cb7$export$f73578b718a57eaa(extension, "addStorage", {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
function $a769590142262cb7$var$isAndroid() {
    return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
/**
 * Node views are used to customize the rendered DOM structure of a node.
 * @see https://tiptap.dev/guide/node-views
 */ class $a769590142262cb7$export$77c6811359a01a6f {
    constructor(component, props, options){
        this.isDragging = false;
        this.component = component;
        this.editor = props.editor;
        this.options = {
            stopEvent: null,
            ignoreMutation: null,
            ...options
        };
        this.extension = props.extension;
        this.node = props.node;
        this.decorations = props.decorations;
        this.innerDecorations = props.innerDecorations;
        this.view = props.view;
        this.HTMLAttributes = props.HTMLAttributes;
        this.getPos = props.getPos;
        this.mount();
    }
    mount() {
        // eslint-disable-next-line
        return;
    }
    get dom() {
        return this.editor.view.dom;
    }
    get contentDOM() {
        return null;
    }
    onDragStart(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { view: view } = this.editor;
        const target = event.target;
        // get the drag handle element
        // `closest` is not available for text nodes so we may have to use its parent
        const dragHandle = target.nodeType === 3 ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest("[data-drag-handle]") : target.closest("[data-drag-handle]");
        if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) return;
        let x = 0;
        let y = 0;
        // calculate offset for drag element if we use a different drag handle element
        if (this.dom !== dragHandle) {
            const domBox = this.dom.getBoundingClientRect();
            const handleBox = dragHandle.getBoundingClientRect();
            // In React, we have to go through nativeEvent to reach offsetX/offsetY.
            const offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
            const offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
            x = handleBox.x - domBox.x + offsetX;
            y = handleBox.y - domBox.y + offsetY;
        }
        (_g = event.dataTransfer) === null || _g === void 0 || _g.setDragImage(this.dom, x, y);
        const pos = this.getPos();
        if (typeof pos !== "number") return;
        // we need to tell ProseMirror that we want to move the whole node
        // so we create a NodeSelection
        const selection = (0, $6acde7918354ce68$export$e2940151ac854c0b).create(view.state.doc, pos);
        const transaction = view.state.tr.setSelection(selection);
        view.dispatch(transaction);
    }
    stopEvent(event) {
        var _a;
        if (!this.dom) return false;
        if (typeof this.options.stopEvent === "function") return this.options.stopEvent({
            event: event
        });
        const target = event.target;
        const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target));
        // any event from child nodes should be handled by ProseMirror
        if (!isInElement) return false;
        const isDragEvent = event.type.startsWith("drag");
        const isDropEvent = event.type === "drop";
        const isInput = [
            "INPUT",
            "BUTTON",
            "SELECT",
            "TEXTAREA"
        ].includes(target.tagName) || target.isContentEditable;
        // any input event within node views should be ignored by ProseMirror
        if (isInput && !isDropEvent && !isDragEvent) return true;
        const { isEditable: isEditable } = this.editor;
        const { isDragging: isDragging } = this;
        const isDraggable = !!this.node.type.spec.draggable;
        const isSelectable = (0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(this.node);
        const isCopyEvent = event.type === "copy";
        const isPasteEvent = event.type === "paste";
        const isCutEvent = event.type === "cut";
        const isClickEvent = event.type === "mousedown";
        // ProseMirror tries to drag selectable nodes
        // even if `draggable` is set to `false`
        // this fix prevents that
        if (!isDraggable && isSelectable && isDragEvent && event.target === this.dom) event.preventDefault();
        if (isDraggable && isDragEvent && !isDragging && event.target === this.dom) {
            event.preventDefault();
            return false;
        }
        // we have to store that dragging started
        if (isDraggable && isEditable && !isDragging && isClickEvent) {
            const dragHandle = target.closest("[data-drag-handle]");
            const isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));
            if (isValidDragHandle) {
                this.isDragging = true;
                document.addEventListener("dragend", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener("drop", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener("mouseup", ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
            }
        }
        // these events are handled by prosemirror
        if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) return false;
        return true;
    }
    /**
     * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
     * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
     * @return `true` if it can safely be ignored.
     */ ignoreMutation(mutation) {
        if (!this.dom || !this.contentDOM) return true;
        if (typeof this.options.ignoreMutation === "function") return this.options.ignoreMutation({
            mutation: mutation
        });
        // a leaf/atom node is like a black box for ProseMirror
        // and should be fully handled by the node view
        if (this.node.isLeaf || this.node.isAtom) return true;
        // ProseMirror should handle any selections
        if (mutation.type === "selection") return false;
        // try to prevent a bug on iOS and Android that will break node views on enter
        // this is because ProseMirror can’t preventDispatch on enter
        // this will lead to a re-render of the node view on enter
        // see: https://github.com/ueberdosis/tiptap/issues/1214
        // see: https://github.com/ueberdosis/tiptap/issues/2534
        if (this.dom.contains(mutation.target) && mutation.type === "childList" && ($a769590142262cb7$export$86c1a3f9ab33da5c() || $a769590142262cb7$var$isAndroid()) && this.editor.isFocused) {
            const changedNodes = [
                ...Array.from(mutation.addedNodes),
                ...Array.from(mutation.removedNodes)
            ];
            // we’ll check if every changed node is contentEditable
            // to make sure it’s probably mutated by ProseMirror
            if (changedNodes.every((node)=>node.isContentEditable)) return false;
        }
        // we will allow mutation contentDOM with attributes
        // so we can for example adding classes within our node view
        if (this.contentDOM === mutation.target && mutation.type === "attributes") return true;
        // ProseMirror should handle any changes within contentDOM
        if (this.contentDOM.contains(mutation.target)) return false;
        return true;
    }
    /**
     * Update the attributes of the prosemirror node.
     */ updateAttributes(attributes) {
        this.editor.commands.command(({ tr: tr })=>{
            const pos = this.getPos();
            if (typeof pos !== "number") return false;
            tr.setNodeMarkup(pos, undefined, {
                ...this.node.attrs,
                ...attributes
            });
            return true;
        });
    }
    /**
     * Delete the node.
     */ deleteNode() {
        const from = this.getPos();
        if (typeof from !== "number") return;
        const to = from + this.node.nodeSize;
        this.editor.commands.deleteRange({
            from: from,
            to: to
        });
    }
}
/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $a769590142262cb7$export$3845eb97abe74944(config) {
    return new $a769590142262cb7$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match, pasteEvent: pasteEvent })=>{
            const attributes = $a769590142262cb7$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $a769590142262cb7$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
// source: https://stackoverflow.com/a/6969486
function $a769590142262cb7$export$d3f82eb9fcc60fbc(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function $a769590142262cb7$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $a769590142262cb7$export$3cb77ada4d0e5bd5(config) {
    return new $a769590142262cb7$export$e75df4392d073e98({
        find: config.find,
        handler ({ match: match, chain: chain, range: range, pasteEvent: pasteEvent }) {
            const attributes = $a769590142262cb7$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            const content = $a769590142262cb7$export$592682234826c0bd(config.getContent, undefined, attributes);
            if (attributes === false || attributes === null) return null;
            const node = {
                type: config.type.name,
                attrs: attributes
            };
            if (content) node.content = content;
            if (match.input) chain().deleteRange(range).insertContentAt(range.from, node);
        }
    });
}
/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $a769590142262cb7$export$1aff23e8795559fa(config) {
    return new $a769590142262cb7$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
class $a769590142262cb7$export$254d9747e34ddc90 {
    constructor(transaction){
        this.transaction = transaction;
        this.currentStep = this.transaction.steps.length;
    }
    map(position) {
        let deleted = false;
        const mappedPosition = this.transaction.steps.slice(this.currentStep).reduce((newPosition, step)=>{
            const mapResult = step.getMap().mapResult(newPosition);
            if (mapResult.deleted) deleted = true;
            return mapResult.pos;
        }, position);
        return {
            position: mappedPosition,
            deleted: deleted
        };
    }
}



/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ 
var $c55de979aca75bc6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $c55de979aca75bc6$var$BOX_CLASS = "tippy-box";
var $c55de979aca75bc6$var$CONTENT_CLASS = "tippy-content";
var $c55de979aca75bc6$var$BACKDROP_CLASS = "tippy-backdrop";
var $c55de979aca75bc6$var$ARROW_CLASS = "tippy-arrow";
var $c55de979aca75bc6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $c55de979aca75bc6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $c55de979aca75bc6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $c55de979aca75bc6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $c55de979aca75bc6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $c55de979aca75bc6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $c55de979aca75bc6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $c55de979aca75bc6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $c55de979aca75bc6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $c55de979aca75bc6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $c55de979aca75bc6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $c55de979aca75bc6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $c55de979aca75bc6$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $c55de979aca75bc6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $c55de979aca75bc6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $c55de979aca75bc6$var$div() {
    return document.createElement("div");
}
function $c55de979aca75bc6$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $c55de979aca75bc6$var$isType(value, type);
    });
}
function $c55de979aca75bc6$var$isNodeList(value) {
    return $c55de979aca75bc6$var$isType(value, "NodeList");
}
function $c55de979aca75bc6$var$isMouseEvent(value) {
    return $c55de979aca75bc6$var$isType(value, "MouseEvent");
}
function $c55de979aca75bc6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $c55de979aca75bc6$var$getArrayOfElements(value) {
    if ($c55de979aca75bc6$var$isElement(value)) return [
        value
    ];
    if ($c55de979aca75bc6$var$isNodeList(value)) return $c55de979aca75bc6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $c55de979aca75bc6$var$arrayFrom(document.querySelectorAll(value));
}
function $c55de979aca75bc6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $c55de979aca75bc6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $c55de979aca75bc6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $c55de979aca75bc6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $c55de979aca75bc6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $c55de979aca75bc6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $c55de979aca75bc6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $c55de979aca75bc6$var$currentInput = {
    isTouch: false
};
var $c55de979aca75bc6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $c55de979aca75bc6$var$onDocumentTouchStart() {
    if ($c55de979aca75bc6$var$currentInput.isTouch) return;
    $c55de979aca75bc6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $c55de979aca75bc6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $c55de979aca75bc6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $c55de979aca75bc6$var$lastMouseMoveTime < 20) {
        $c55de979aca75bc6$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $c55de979aca75bc6$var$onDocumentMouseMove);
    }
    $c55de979aca75bc6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $c55de979aca75bc6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($c55de979aca75bc6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $c55de979aca75bc6$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $c55de979aca75bc6$var$onDocumentTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $c55de979aca75bc6$var$onWindowBlur);
}
var $c55de979aca75bc6$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $c55de979aca75bc6$var$isIE11 = $c55de979aca75bc6$var$isBrowser ? !!window.msCrypto : false;
function $c55de979aca75bc6$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $c55de979aca75bc6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $c55de979aca75bc6$var$getDevMessage(message) {
    return $c55de979aca75bc6$var$clean("\n  %ctippy.js\n\n  %c" + $c55de979aca75bc6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $c55de979aca75bc6$var$getFormattedMessage(message) {
    return [
        $c55de979aca75bc6$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $c55de979aca75bc6$var$visitedMessages;
function $c55de979aca75bc6$var$resetVisitedMessages() {
    $c55de979aca75bc6$var$visitedMessages = new Set();
}
function $c55de979aca75bc6$var$warnWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$errorWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console2;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $c55de979aca75bc6$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $c55de979aca75bc6$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $c55de979aca75bc6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $c55de979aca75bc6$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $c55de979aca75bc6$var$defaultProps = Object.assign({
    appendTo: $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $c55de979aca75bc6$var$pluginProps, $c55de979aca75bc6$var$renderProps);
var $c55de979aca75bc6$var$defaultKeys = Object.keys($c55de979aca75bc6$var$defaultProps);
var $c55de979aca75bc6$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $c55de979aca75bc6$var$defaultProps[key] = partialProps[key];
    });
};
function $c55de979aca75bc6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $c55de979aca75bc6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $c55de979aca75bc6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($c55de979aca75bc6$var$getExtendedPassedProps(Object.assign({}, $c55de979aca75bc6$var$defaultProps, {
        plugins: plugins
    }))) : $c55de979aca75bc6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $c55de979aca75bc6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $c55de979aca75bc6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $c55de979aca75bc6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $c55de979aca75bc6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $c55de979aca75bc6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $c55de979aca75bc6$var$removeProperties($c55de979aca75bc6$var$defaultProps, Object.keys($c55de979aca75bc6$var$pluginProps));
        var didPassUnknownProp = !$c55de979aca75bc6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $c55de979aca75bc6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $c55de979aca75bc6$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $c55de979aca75bc6$var$dangerouslySetInnerHTML(element, html) {
    element[$c55de979aca75bc6$var$innerHTML()] = html;
}
function $c55de979aca75bc6$var$createArrowElement(value) {
    var arrow = $c55de979aca75bc6$var$div();
    if (value === true) arrow.className = $c55de979aca75bc6$var$ARROW_CLASS;
    else {
        arrow.className = $c55de979aca75bc6$var$SVG_ARROW_CLASS;
        if ($c55de979aca75bc6$var$isElement(value)) arrow.appendChild(value);
        else $c55de979aca75bc6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $c55de979aca75bc6$var$setContent(content, props) {
    if ($c55de979aca75bc6$var$isElement(props.content)) {
        $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $c55de979aca75bc6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $c55de979aca75bc6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$ARROW_CLASS) || node.classList.contains($c55de979aca75bc6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$BACKDROP_CLASS);
        })
    };
}
function $c55de979aca75bc6$var$render(instance) {
    var popper = $c55de979aca75bc6$var$div();
    var box = $c55de979aca75bc6$var$div();
    box.className = $c55de979aca75bc6$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $c55de979aca75bc6$var$div();
    content.className = $c55de979aca75bc6$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $c55de979aca75bc6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $c55de979aca75bc6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $c55de979aca75bc6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$c55de979aca75bc6$var$render.$$tippy = true;
var $c55de979aca75bc6$var$idCounter = 1;
var $c55de979aca75bc6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $c55de979aca75bc6$var$mountedInstances = [];
function $c55de979aca75bc6$var$createTippy(reference, passedProps) {
    var props = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, $c55de979aca75bc6$var$defaultProps, $c55de979aca75bc6$var$getExtendedPassedProps($c55de979aca75bc6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $c55de979aca75bc6$var$idCounter++;
    var popperInstance = null;
    var plugins = $c55de979aca75bc6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $c55de979aca75bc6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $c55de979aca75bc6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $c55de979aca75bc6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $c55de979aca75bc6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $c55de979aca75bc6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $c55de979aca75bc6$var$mouseMoveListeners = $c55de979aca75bc6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($c55de979aca75bc6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $c55de979aca75bc6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $c55de979aca75bc6$var$actualContains(el, actualTarget);
        })) {
            if ($c55de979aca75bc6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $c55de979aca75bc6$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $c55de979aca75bc6$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $c55de979aca75bc6$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $c55de979aca75bc6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($c55de979aca75bc6$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $c55de979aca75bc6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $c55de979aca75bc6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $c55de979aca75bc6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $c55de979aca75bc6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $c55de979aca75bc6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $c55de979aca75bc6$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($c55de979aca75bc6$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, prevProps, $c55de979aca75bc6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $c55de979aca75bc6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $c55de979aca75bc6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $c55de979aca75bc6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $c55de979aca75bc6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $c55de979aca75bc6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $c55de979aca75bc6$var$mountedInstances = $c55de979aca75bc6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $c55de979aca75bc6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $c55de979aca75bc6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $c55de979aca75bc6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $c55de979aca75bc6$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $c55de979aca75bc6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $c55de979aca75bc6$var$isElement(targets) ? instances[0] : instances;
}
$c55de979aca75bc6$var$tippy.defaultProps = $c55de979aca75bc6$var$defaultProps;
$c55de979aca75bc6$var$tippy.setDefaultProps = $c55de979aca75bc6$var$setDefaultProps;
$c55de979aca75bc6$var$tippy.currentInput = $c55de979aca75bc6$var$currentInput;
var $c55de979aca75bc6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $c55de979aca75bc6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $c55de979aca75bc6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $c55de979aca75bc6$var$applyStylesModifier = Object.assign({}, (0, $312913fa2edc14b2$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $c55de979aca75bc6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $c55de979aca75bc6$var$tippy($c55de979aca75bc6$var$div(), Object.assign({}, $c55de979aca75bc6$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $c55de979aca75bc6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $c55de979aca75bc6$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $c55de979aca75bc6$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $c55de979aca75bc6$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $c55de979aca75bc6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $c55de979aca75bc6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $c55de979aca75bc6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $c55de979aca75bc6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($c55de979aca75bc6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $c55de979aca75bc6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $c55de979aca75bc6$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $c55de979aca75bc6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $c55de979aca75bc6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $c55de979aca75bc6$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $c55de979aca75bc6$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $c55de979aca75bc6$var$createBackdropElement() {
    var backdrop = $c55de979aca75bc6$var$div();
    backdrop.className = $c55de979aca75bc6$var$BACKDROP_CLASS;
    $c55de979aca75bc6$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $c55de979aca75bc6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $c55de979aca75bc6$var$activeInstances = [];
function $c55de979aca75bc6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $c55de979aca75bc6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $c55de979aca75bc6$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $c55de979aca75bc6$var$storeMouseCoords);
}
function $c55de979aca75bc6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $c55de979aca75bc6$var$storeMouseCoords);
}
var $c55de979aca75bc6$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $c55de979aca75bc6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $c55de979aca75bc6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $c55de979aca75bc6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $c55de979aca75bc6$var$activeInstances = $c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $c55de979aca75bc6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($c55de979aca75bc6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) $c55de979aca75bc6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $c55de979aca75bc6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $c55de979aca75bc6$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $c55de979aca75bc6$var$getInlineBoundingClientRect($c55de979aca75bc6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $c55de979aca75bc6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($c55de979aca75bc6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) {
                    var rects = $c55de979aca75bc6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $c55de979aca75bc6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $c55de979aca75bc6$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $c55de979aca75bc6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $c55de979aca75bc6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $c55de979aca75bc6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$c55de979aca75bc6$var$tippy.setDefaultProps({
    render: $c55de979aca75bc6$var$render
});
var $c55de979aca75bc6$export$2e2bcd8739ae039 = $c55de979aca75bc6$var$tippy;


class $0bb7784487efcae2$export$1518b7671d88a5b3 {
    constructor({ editor: editor, element: element, view: view, tippyOptions: tippyOptions = {}, updateDelay: updateDelay = 250, shouldShow: shouldShow }){
        this.preventHide = false;
        this.shouldShow = ({ view: view, state: state, from: from, to: to })=>{
            const { doc: doc, selection: selection } = state;
            const { empty: empty } = selection;
            // Sometime check for `empty` is not enough.
            // Doubleclick an empty paragraph returns a node size of 2.
            // So we check also for an empty text size.
            const isEmptyTextBlock = !doc.textBetween(from, to).length && (0, $a769590142262cb7$export$38b50bf35e79aaf3)(state.selection);
            // When clicking on a element inside the bubble menu the editor "blur" event
            // is called and the bubble menu item is focussed. In this case we should
            // consider the menu as part of the editor and keep showing the menu
            const isChildOfMenu = this.element.contains(document.activeElement);
            const hasEditorFocus = view.hasFocus() || isChildOfMenu;
            if (!hasEditorFocus || empty || isEmptyTextBlock || !this.editor.isEditable) return false;
            return true;
        };
        this.mousedownHandler = ()=>{
            this.preventHide = true;
        };
        this.dragstartHandler = ()=>{
            this.hide();
        };
        this.focusHandler = ()=>{
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(()=>this.update(this.editor.view));
        };
        this.blurHandler = ({ event: event })=>{
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) return;
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === this.editor.view.dom) return;
            this.hide();
        };
        this.tippyBlurHandler = (event)=>{
            this.blurHandler({
                event: event
            });
        };
        this.handleDebouncedUpdate = (view, oldState)=>{
            const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
            const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
            if (!selectionChanged && !docChanged) return;
            if (this.updateDebounceTimer) clearTimeout(this.updateDebounceTimer);
            this.updateDebounceTimer = window.setTimeout(()=>{
                this.updateHandler(view, selectionChanged, docChanged, oldState);
            }, this.updateDelay);
        };
        this.updateHandler = (view, selectionChanged, docChanged, oldState)=>{
            var _a, _b, _c;
            const { state: state, composing: composing } = view;
            const { selection: selection } = state;
            const isSame = !selectionChanged && !docChanged;
            if (composing || isSame) return;
            this.createTooltip();
            // support for CellSelections
            const { ranges: ranges } = selection;
            const from = Math.min(...ranges.map((range)=>range.$from.pos));
            const to = Math.max(...ranges.map((range)=>range.$to.pos));
            const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
                editor: this.editor,
                element: this.element,
                view: view,
                state: state,
                oldState: oldState,
                from: from,
                to: to
            });
            if (!shouldShow) {
                this.hide();
                return;
            }
            (_b = this.tippy) === null || _b === void 0 || _b.setProps({
                getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || (()=>{
                    if ((0, $a769590142262cb7$export$a8c1d2c13abf8822)(state.selection)) {
                        let node = view.nodeDOM(from);
                        if (node) {
                            const nodeViewWrapper = node.dataset.nodeViewWrapper ? node : node.querySelector("[data-node-view-wrapper]");
                            if (nodeViewWrapper) node = nodeViewWrapper.firstChild;
                            if (node) return node.getBoundingClientRect();
                        }
                    }
                    return (0, $a769590142262cb7$export$660ecae6cde71645)(view, from, to);
                })
            });
            this.show();
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        this.updateDelay = updateDelay;
        if (shouldShow) this.shouldShow = shouldShow;
        this.element.addEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.view.dom.addEventListener("dragstart", this.dragstartHandler);
        this.editor.on("focus", this.focusHandler);
        this.editor.on("blur", this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = "visible";
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        if (this.tippy || !editorIsAttached) return;
        this.tippy = (0, $c55de979aca75bc6$export$2e2bcd8739ae039)(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: "manual",
            placement: "top",
            hideOnClick: "toggle",
            ...this.tippyOptions
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler);
    }
    update(view, oldState) {
        const { state: state } = view;
        const hasValidSelection = state.selection.from !== state.selection.to;
        if (this.updateDelay > 0 && hasValidSelection) {
            this.handleDebouncedUpdate(view, oldState);
            return;
        }
        const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
        const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
        this.updateHandler(view, selectionChanged, docChanged, oldState);
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler);
        (_b = this.tippy) === null || _b === void 0 || _b.destroy();
        this.element.removeEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.view.dom.removeEventListener("dragstart", this.dragstartHandler);
        this.editor.off("focus", this.focusHandler);
        this.editor.off("blur", this.blurHandler);
    }
}
const $0bb7784487efcae2$export$20c12548414ed018 = (options)=>{
    return new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
        key: typeof options.pluginKey === "string" ? new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)(options.pluginKey) : options.pluginKey,
        view: (view)=>new $0bb7784487efcae2$export$1518b7671d88a5b3({
                view: view,
                ...options
            })
    });
};
/**
 * This extension allows you to create a bubble menu.
 * @see https://tiptap.dev/api/extensions/bubble-menu
 */ const $0bb7784487efcae2$export$79c1bf6a55bce827 = (0, $a769590142262cb7$export$eeddbf09bb970356).create({
    name: "bubbleMenu",
    addOptions () {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: "bubbleMenu",
            updateDelay: undefined,
            shouldShow: null
        };
    },
    addProseMirrorPlugins () {
        if (!this.options.element) return [];
        return [
            $0bb7784487efcae2$export$20c12548414ed018({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                updateDelay: this.options.updateDelay,
                shouldShow: this.options.shouldShow
            })
        ];
    }
});



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");




class $54caadc3fe0f6cd1$export$8787fd8a369cb5a5 {
    getTextContent(node) {
        return (0, $a769590142262cb7$export$c72d34660a162238)(node, {
            textSerializers: (0, $a769590142262cb7$export$fdd92b7d22ac071c)(this.editor.schema)
        });
    }
    constructor({ editor: editor, element: element, view: view, tippyOptions: tippyOptions = {}, shouldShow: shouldShow }){
        this.preventHide = false;
        this.shouldShow = ({ view: view, state: state })=>{
            const { selection: selection } = state;
            const { $anchor: $anchor, empty: empty } = selection;
            const isRootDepth = $anchor.depth === 1;
            const isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent && $anchor.parent.childCount === 0 && !this.getTextContent($anchor.parent);
            if (!view.hasFocus() || !empty || !isRootDepth || !isEmptyTextBlock || !this.editor.isEditable) return false;
            return true;
        };
        this.mousedownHandler = ()=>{
            this.preventHide = true;
        };
        this.focusHandler = ()=>{
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(()=>this.update(this.editor.view));
        };
        this.blurHandler = ({ event: event })=>{
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) return;
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === this.editor.view.dom) return;
            this.hide();
        };
        this.tippyBlurHandler = (event)=>{
            this.blurHandler({
                event: event
            });
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        if (shouldShow) this.shouldShow = shouldShow;
        this.element.addEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.editor.on("focus", this.focusHandler);
        this.editor.on("blur", this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = "visible";
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        if (this.tippy || !editorIsAttached) return;
        this.tippy = (0, $c55de979aca75bc6$export$2e2bcd8739ae039)(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: "manual",
            placement: "right",
            hideOnClick: "toggle",
            ...this.tippyOptions
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler);
    }
    update(view, oldState) {
        var _a, _b, _c;
        const { state: state } = view;
        const { doc: doc, selection: selection } = state;
        const { from: from, to: to } = selection;
        const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
        if (isSame) return;
        this.createTooltip();
        const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
            editor: this.editor,
            view: view,
            state: state,
            oldState: oldState
        });
        if (!shouldShow) {
            this.hide();
            return;
        }
        (_b = this.tippy) === null || _b === void 0 || _b.setProps({
            getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || (()=>(0, $a769590142262cb7$export$660ecae6cde71645)(view, from, to))
        });
        this.show();
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 || _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler);
        (_b = this.tippy) === null || _b === void 0 || _b.destroy();
        this.element.removeEventListener("mousedown", this.mousedownHandler, {
            capture: true
        });
        this.editor.off("focus", this.focusHandler);
        this.editor.off("blur", this.blurHandler);
    }
}
const $54caadc3fe0f6cd1$export$5e50896e3f3c0d7b = (options)=>{
    return new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
        key: typeof options.pluginKey === "string" ? new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)(options.pluginKey) : options.pluginKey,
        view: (view)=>new $54caadc3fe0f6cd1$export$8787fd8a369cb5a5({
                view: view,
                ...options
            })
    });
};
/**
 * This extension allows you to create a floating menu.
 * @see https://tiptap.dev/api/extensions/floating-menu
 */ const $54caadc3fe0f6cd1$export$695cda69e78edecd = (0, $a769590142262cb7$export$eeddbf09bb970356).create({
    name: "floatingMenu",
    addOptions () {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: "floatingMenu",
            shouldShow: null
        };
    },
    addProseMirrorPlugins () {
        if (!this.options.element) return [];
        return [
            $54caadc3fe0f6cd1$export$5e50896e3f3c0d7b({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                shouldShow: this.options.shouldShow
            })
        ];
    }
});


function $eca5d11c6814a94c$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $eca5d11c6814a94c$var$shim = {
    exports: {}
};
var $eca5d11c6814a94c$var$useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eca5d11c6814a94c$var$hasRequiredUseSyncExternalStoreShim_production_min;
function $eca5d11c6814a94c$var$requireUseSyncExternalStoreShim_production_min() {
    if ($eca5d11c6814a94c$var$hasRequiredUseSyncExternalStoreShim_production_min) return $eca5d11c6814a94c$var$useSyncExternalStoreShim_production_min;
    $eca5d11c6814a94c$var$hasRequiredUseSyncExternalStoreShim_production_min = 1;
    var e = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
    function h(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
    function q(a, b) {
        var d = b(), f = l({
            inst: {
                value: d,
                getSnapshot: b
            }
        }), c = f[0].inst, g = f[1];
        n(function() {
            c.value = d;
            c.getSnapshot = b;
            r(c) && g({
                inst: c
            });
        }, [
            a,
            d,
            b
        ]);
        m(function() {
            r(c) && g({
                inst: c
            });
            return a(function() {
                r(c) && g({
                    inst: c
                });
            });
        }, [
            a
        ]);
        p(d);
        return d;
    }
    function r(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var d = b();
            return !k(a, d);
        } catch (f) {
            return !0;
        }
    }
    function t(a, b) {
        return b();
    }
    var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
    $eca5d11c6814a94c$var$useSyncExternalStoreShim_production_min.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;
    return $eca5d11c6814a94c$var$useSyncExternalStoreShim_production_min;
}
var $eca5d11c6814a94c$var$useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eca5d11c6814a94c$var$hasRequiredUseSyncExternalStoreShim_development;
function $eca5d11c6814a94c$var$requireUseSyncExternalStoreShim_development() {
    if ($eca5d11c6814a94c$var$hasRequiredUseSyncExternalStoreShim_development) return $eca5d11c6814a94c$var$useSyncExternalStoreShim_development;
    $eca5d11c6814a94c$var$hasRequiredUseSyncExternalStoreShim_development = 1;
    return $eca5d11c6814a94c$var$useSyncExternalStoreShim_development;
}
$eca5d11c6814a94c$var$shim.exports = $eca5d11c6814a94c$var$requireUseSyncExternalStoreShim_production_min();
var $eca5d11c6814a94c$var$shimExports = $eca5d11c6814a94c$var$shim.exports;
const $eca5d11c6814a94c$var$mergeRefs = (...refs)=>{
    return (node)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(node);
            else if (ref) ref.current = node;
        });
    };
};
/**
 * This component renders all of the editor's node views.
 */ const $eca5d11c6814a94c$var$Portals = ({ contentComponent: contentComponent })=>{
    // For performance reasons, we render the node view portals on state changes only
    const renderers = $eca5d11c6814a94c$var$shimExports.useSyncExternalStore(contentComponent.subscribe, contentComponent.getSnapshot, contentComponent.getServerSnapshot);
    // This allows us to directly render the portals without any additional wrapper
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, Object.values(renderers));
};
function $eca5d11c6814a94c$var$getInstance() {
    const subscribers = new Set();
    let renderers = {};
    return {
        /**
         * Subscribe to the editor instance's changes.
         */ subscribe (callback) {
            subscribers.add(callback);
            return ()=>{
                subscribers.delete(callback);
            };
        },
        getSnapshot () {
            return renderers;
        },
        getServerSnapshot () {
            return renderers;
        },
        /**
         * Adds a new NodeView Renderer to the editor.
         */ setRenderer (id, renderer) {
            renderers = {
                ...renderers,
                [id]: (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(renderer.reactElement, renderer.element, id)
            };
            subscribers.forEach((subscriber)=>subscriber());
        },
        /**
         * Removes a NodeView Renderer from the editor.
         */ removeRenderer (id) {
            const nextRenderers = {
                ...renderers
            };
            delete nextRenderers[id];
            renderers = nextRenderers;
            subscribers.forEach((subscriber)=>subscriber());
        }
    };
}
class $eca5d11c6814a94c$export$2a77c1f2ea046ea6 extends (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component {
    constructor(props){
        var _a;
        super(props);
        this.editorContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createRef();
        this.initialized = false;
        this.state = {
            hasContentComponentInitialized: Boolean((_a = props.editor) === null || _a === void 0 ? void 0 : _a.contentComponent)
        };
    }
    componentDidMount() {
        this.init();
    }
    componentDidUpdate() {
        this.init();
    }
    init() {
        const editor = this.props.editor;
        if (editor && !editor.isDestroyed && editor.options.element) {
            if (editor.contentComponent) return;
            const element = this.editorContentRef.current;
            element.append(...editor.options.element.childNodes);
            editor.setOptions({
                element: element
            });
            editor.contentComponent = $eca5d11c6814a94c$var$getInstance();
            // Has the content component been initialized?
            if (!this.state.hasContentComponentInitialized) // Subscribe to the content component
            this.unsubscribeToContentComponent = editor.contentComponent.subscribe(()=>{
                this.setState((prevState)=>{
                    if (!prevState.hasContentComponentInitialized) return {
                        hasContentComponentInitialized: true
                    };
                    return prevState;
                });
                // Unsubscribe to previous content component
                if (this.unsubscribeToContentComponent) this.unsubscribeToContentComponent();
            });
            editor.createNodeViews();
            this.initialized = true;
        }
    }
    componentWillUnmount() {
        const editor = this.props.editor;
        if (!editor) return;
        this.initialized = false;
        if (!editor.isDestroyed) editor.view.setProps({
            nodeViews: {}
        });
        if (this.unsubscribeToContentComponent) this.unsubscribeToContentComponent();
        editor.contentComponent = null;
        if (!editor.options.element.firstChild) return;
        const newElement = document.createElement("div");
        newElement.append(...editor.options.element.childNodes);
        editor.setOptions({
            element: newElement
        });
    }
    render() {
        const { editor: editor, innerRef: innerRef, ...rest } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            ref: $eca5d11c6814a94c$var$mergeRefs(innerRef, this.editorContentRef),
            ...rest
        }), (editor === null || editor === void 0 ? void 0 : editor.contentComponent) && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($eca5d11c6814a94c$var$Portals, {
            contentComponent: editor.contentComponent
        }));
    }
}
// EditorContent should be re-created whenever the Editor instance changes
const $eca5d11c6814a94c$var$EditorContentWithKey = (0, $exYeM.forwardRef)((props, ref)=>{
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>{
        return Math.floor(Math.random() * 0xffffffff).toString();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.editor
    ]);
    // Can't use JSX here because it conflicts with the type definition of Vue's JSX, so use createElement
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($eca5d11c6814a94c$export$2a77c1f2ea046ea6, {
        key: key,
        innerRef: ref,
        ...props
    });
});
const $eca5d11c6814a94c$export$a92c4e92ed722350 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo($eca5d11c6814a94c$var$EditorContentWithKey);
var $eca5d11c6814a94c$var$react = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            for (i of a.entries())if (!equal(i[1], b.get(i[0]))) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var $eca5d11c6814a94c$var$deepEqual = /*@__PURE__*/ $eca5d11c6814a94c$var$getDefaultExportFromCjs($eca5d11c6814a94c$var$react);
var $eca5d11c6814a94c$var$withSelector = {
    exports: {}
};
var $eca5d11c6814a94c$var$withSelector_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eca5d11c6814a94c$var$hasRequiredWithSelector_production_min;
function $eca5d11c6814a94c$var$requireWithSelector_production_min() {
    if ($eca5d11c6814a94c$var$hasRequiredWithSelector_production_min) return $eca5d11c6814a94c$var$withSelector_production_min;
    $eca5d11c6814a94c$var$hasRequiredWithSelector_production_min = 1;
    var h = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))), n = $eca5d11c6814a94c$var$shimExports;
    function p(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var q = "function" === typeof Object.is ? Object.is : p, r = n.useSyncExternalStore, t = h.useRef, u = h.useEffect, v = h.useMemo, w = h.useDebugValue;
    $eca5d11c6814a94c$var$withSelector_production_min.useSyncExternalStoreWithSelector = function(a, b, e, l, g) {
        var c = t(null);
        if (null === c.current) {
            var f = {
                hasValue: !1,
                value: null
            };
            c.current = f;
        } else f = c.current;
        c = v(function() {
            function a(a) {
                if (!c) {
                    c = !0;
                    d = a;
                    a = l(a);
                    if (void 0 !== g && f.hasValue) {
                        var b = f.value;
                        if (g(b, a)) return k = b;
                    }
                    return k = a;
                }
                b = k;
                if (q(d, a)) return b;
                var e = l(a);
                if (void 0 !== g && g(b, e)) return b;
                d = a;
                return k = e;
            }
            var c = !1, d, k, m = void 0 === e ? null : e;
            return [
                function() {
                    return a(b());
                },
                null === m ? void 0 : function() {
                    return a(m());
                }
            ];
        }, [
            b,
            e,
            l,
            g
        ]);
        var d = r(a, c[0], c[1]);
        u(function() {
            f.hasValue = !0;
            f.value = d;
        }, [
            d
        ]);
        w(d);
        return d;
    };
    return $eca5d11c6814a94c$var$withSelector_production_min;
}
var $eca5d11c6814a94c$var$withSelector_development = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eca5d11c6814a94c$var$hasRequiredWithSelector_development;
function $eca5d11c6814a94c$var$requireWithSelector_development() {
    if ($eca5d11c6814a94c$var$hasRequiredWithSelector_development) return $eca5d11c6814a94c$var$withSelector_development;
    $eca5d11c6814a94c$var$hasRequiredWithSelector_development = 1;
    return $eca5d11c6814a94c$var$withSelector_development;
}
$eca5d11c6814a94c$var$withSelector.exports = $eca5d11c6814a94c$var$requireWithSelector_production_min();
var $eca5d11c6814a94c$var$withSelectorExports = $eca5d11c6814a94c$var$withSelector.exports;
const $eca5d11c6814a94c$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
/**
 * To synchronize the editor instance with the component state,
 * we need to create a separate instance that is not affected by the component re-renders.
 */ class $eca5d11c6814a94c$var$EditorStateManager {
    constructor(initialEditor){
        this.transactionNumber = 0;
        this.lastTransactionNumber = 0;
        this.subscribers = new Set();
        this.editor = initialEditor;
        this.lastSnapshot = {
            editor: initialEditor,
            transactionNumber: 0
        };
        this.getSnapshot = this.getSnapshot.bind(this);
        this.getServerSnapshot = this.getServerSnapshot.bind(this);
        this.watch = this.watch.bind(this);
        this.subscribe = this.subscribe.bind(this);
    }
    /**
     * Get the current editor instance.
     */ getSnapshot() {
        if (this.transactionNumber === this.lastTransactionNumber) return this.lastSnapshot;
        this.lastTransactionNumber = this.transactionNumber;
        this.lastSnapshot = {
            editor: this.editor,
            transactionNumber: this.transactionNumber
        };
        return this.lastSnapshot;
    }
    /**
     * Always disable the editor on the server-side.
     */ getServerSnapshot() {
        return {
            editor: null,
            transactionNumber: 0
        };
    }
    /**
     * Subscribe to the editor instance's changes.
     */ subscribe(callback) {
        this.subscribers.add(callback);
        return ()=>{
            this.subscribers.delete(callback);
        };
    }
    /**
     * Watch the editor instance for changes.
     */ watch(nextEditor) {
        this.editor = nextEditor;
        if (this.editor) {
            /**
             * This will force a re-render when the editor state changes.
             * This is to support things like `editor.can().toggleBold()` in components that `useEditor`.
             * This could be more efficient, but it's a good trade-off for now.
             */ const fn = ()=>{
                this.transactionNumber += 1;
                this.subscribers.forEach((callback)=>callback());
            };
            const currentEditor = this.editor;
            currentEditor.on("transaction", fn);
            return ()=>{
                currentEditor.off("transaction", fn);
            };
        }
        return undefined;
    }
}
/**
 * This hook allows you to watch for changes on the editor instance.
 * It will allow you to select a part of the editor state and re-render the component when it changes.
 * @example
 * ```tsx
 * const editor = useEditor({...options})
 * const { currentSelection } = useEditorState({
 *  editor,
 *  selector: snapshot => ({ currentSelection: snapshot.editor.state.selection }),
 * })
 */ function $eca5d11c6814a94c$export$e6e340c65601d57b(options) {
    var _a;
    const [editorStateManager] = (0, $exYeM.useState)(()=>new $eca5d11c6814a94c$var$EditorStateManager(options.editor));
    // Using the `useSyncExternalStore` hook to sync the editor instance with the component state
    const selectedState = $eca5d11c6814a94c$var$withSelectorExports.useSyncExternalStoreWithSelector(editorStateManager.subscribe, editorStateManager.getSnapshot, editorStateManager.getServerSnapshot, options.selector, (_a = options.equalityFn) !== null && _a !== void 0 ? _a : $eca5d11c6814a94c$var$deepEqual);
    $eca5d11c6814a94c$var$useIsomorphicLayoutEffect(()=>{
        return editorStateManager.watch(options.editor);
    }, [
        options.editor,
        editorStateManager
    ]);
    (0, $exYeM.useDebugValue)(selectedState);
    return selectedState;
}
const $eca5d11c6814a94c$var$isDev = false;
const $eca5d11c6814a94c$var$isSSR = typeof window === "undefined";
const $eca5d11c6814a94c$var$isNext = $eca5d11c6814a94c$var$isSSR || Boolean(typeof window !== "undefined" && window.next);
/**
 * This class handles the creation, destruction, and re-creation of the editor instance.
 */ class $eca5d11c6814a94c$var$EditorInstanceManager {
    constructor(options){
        /**
         * The current editor instance.
         */ this.editor = null;
        /**
         * The subscriptions to notify when the editor instance
         * has been created or destroyed.
         */ this.subscriptions = new Set();
        /**
         * Whether the editor has been mounted.
         */ this.isComponentMounted = false;
        /**
         * The most recent dependencies array.
         */ this.previousDeps = null;
        /**
         * The unique instance ID. This is used to identify the editor instance. And will be re-generated for each new instance.
         */ this.instanceId = "";
        this.options = options;
        this.subscriptions = new Set();
        this.setEditor(this.getInitialEditor());
        this.scheduleDestroy();
        this.getEditor = this.getEditor.bind(this);
        this.getServerSnapshot = this.getServerSnapshot.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.refreshEditorInstance = this.refreshEditorInstance.bind(this);
        this.scheduleDestroy = this.scheduleDestroy.bind(this);
        this.onRender = this.onRender.bind(this);
        this.createEditor = this.createEditor.bind(this);
    }
    setEditor(editor) {
        this.editor = editor;
        this.instanceId = Math.random().toString(36).slice(2, 9);
        // Notify all subscribers that the editor instance has been created
        this.subscriptions.forEach((cb)=>cb());
    }
    getInitialEditor() {
        if (this.options.current.immediatelyRender === undefined) {
            if ($eca5d11c6814a94c$var$isSSR || $eca5d11c6814a94c$var$isNext) {
                // TODO in the next major release, we should throw an error here
                if ($eca5d11c6814a94c$var$isDev) /**
                     * Throw an error in development, to make sure the developer is aware that tiptap cannot be SSR'd
                     * and that they need to set `immediatelyRender` to `false` to avoid hydration mismatches.
                     */ console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches.");
                // Best faith effort in production, run the code in the legacy mode to avoid hydration mismatches and errors in production
                return null;
            }
            // Default to immediately rendering when client-side rendering
            return this.createEditor();
        }
        if (this.options.current.immediatelyRender && $eca5d11c6814a94c$var$isSSR && $eca5d11c6814a94c$var$isDev) // Warn in development, to make sure the developer is aware that tiptap cannot be SSR'd, set `immediatelyRender` to `false` to avoid hydration mismatches.
        throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
        if (this.options.current.immediatelyRender) return this.createEditor();
        return null;
    }
    /**
     * Create a new editor instance. And attach event listeners.
     */ createEditor() {
        const optionsToApply = {
            ...this.options.current,
            // Always call the most recent version of the callback function by default
            onBeforeCreate: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onBeforeCreate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onBlur: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onCreate: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onCreate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onDestroy: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onDestroy) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onFocus: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onSelectionUpdate: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onSelectionUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onTransaction: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onTransaction) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onUpdate: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onContentError: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onContentError) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onDrop: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onDrop) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            },
            onPaste: (...args)=>{
                var _a, _b;
                return (_b = (_a = this.options.current).onPaste) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
            }
        };
        const editor = new (0, $a769590142262cb7$export$7cda8d932e2f33c0)(optionsToApply);
        // no need to keep track of the event listeners, they will be removed when the editor is destroyed
        return editor;
    }
    /**
     * Get the current editor instance.
     */ getEditor() {
        return this.editor;
    }
    /**
     * Always disable the editor on the server-side.
     */ getServerSnapshot() {
        return null;
    }
    /**
     * Subscribe to the editor instance's changes.
     */ subscribe(onStoreChange) {
        this.subscriptions.add(onStoreChange);
        return ()=>{
            this.subscriptions.delete(onStoreChange);
        };
    }
    /**
     * On each render, we will create, update, or destroy the editor instance.
     * @param deps The dependencies to watch for changes
     * @returns A cleanup function
     */ onRender(deps) {
        // The returned callback will run on each render
        return ()=>{
            this.isComponentMounted = true;
            // Cleanup any scheduled destructions, since we are currently rendering
            clearTimeout(this.scheduledDestructionTimeout);
            if (this.editor && !this.editor.isDestroyed && deps.length === 0) // if the editor does exist & deps are empty, we don't need to re-initialize the editor
            // we can fast-path to update the editor options on the existing instance
            this.editor.setOptions({
                ...this.options.current,
                editable: this.editor.isEditable
            });
            else // When the editor:
            // - does not yet exist
            // - is destroyed
            // - the deps array changes
            // We need to destroy the editor instance and re-initialize it
            this.refreshEditorInstance(deps);
            return ()=>{
                this.isComponentMounted = false;
                this.scheduleDestroy();
            };
        };
    }
    /**
     * Recreate the editor instance if the dependencies have changed.
     */ refreshEditorInstance(deps) {
        if (this.editor && !this.editor.isDestroyed) {
            // Editor instance already exists
            if (this.previousDeps === null) {
                // If lastDeps has not yet been initialized, reuse the current editor instance
                this.previousDeps = deps;
                return;
            }
            const depsAreEqual = this.previousDeps.length === deps.length && this.previousDeps.every((dep, index)=>dep === deps[index]);
            if (depsAreEqual) // deps exist and are equal, no need to recreate
            return;
        }
        if (this.editor && !this.editor.isDestroyed) // Destroy the editor instance if it exists
        this.editor.destroy();
        this.setEditor(this.createEditor());
        // Update the lastDeps to the current deps
        this.previousDeps = deps;
    }
    /**
     * Schedule the destruction of the editor instance.
     * This will only destroy the editor if it was not mounted on the next tick.
     * This is to avoid destroying the editor instance when it's actually still mounted.
     */ scheduleDestroy() {
        const currentInstanceId = this.instanceId;
        const currentEditor = this.editor;
        // Wait two ticks to see if the component is still mounted
        this.scheduledDestructionTimeout = setTimeout(()=>{
            if (this.isComponentMounted && this.instanceId === currentInstanceId) {
                // If still mounted on the following tick, with the same instanceId, do not destroy the editor
                if (currentEditor) // just re-apply options as they might have changed
                currentEditor.setOptions(this.options.current);
                return;
            }
            if (currentEditor && !currentEditor.isDestroyed) {
                currentEditor.destroy();
                if (this.instanceId === currentInstanceId) this.setEditor(null);
            }
        // This allows the effect to run again between ticks
        // which may save us from having to re-create the editor
        }, 1);
    }
}
function $eca5d11c6814a94c$export$43711a1418203bbc(options = {}, deps = []) {
    const mostRecentOptions = (0, $exYeM.useRef)(options);
    mostRecentOptions.current = options;
    const [instanceManager] = (0, $exYeM.useState)(()=>new $eca5d11c6814a94c$var$EditorInstanceManager(mostRecentOptions));
    const editor = $eca5d11c6814a94c$var$shimExports.useSyncExternalStore(instanceManager.subscribe, instanceManager.getEditor, instanceManager.getServerSnapshot);
    (0, $exYeM.useDebugValue)(editor);
    // This effect will handle creating/updating the editor instance
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $exYeM.useEffect)(instanceManager.onRender(deps));
    // The default behavior is to re-render on each transaction
    // This is legacy behavior that will be removed in future versions
    $eca5d11c6814a94c$export$e6e340c65601d57b({
        editor: editor,
        selector: ({ transactionNumber: transactionNumber })=>{
            if (options.shouldRerenderOnTransaction === false) // This will prevent the editor from re-rendering on each transaction
            return null;
            // This will avoid re-rendering on the first transaction when `immediatelyRender` is set to `true`
            if (options.immediatelyRender && transactionNumber === 0) return 0;
            return transactionNumber + 1;
        }
    });
    return editor;
}
const $eca5d11c6814a94c$export$27b8dd149e32f6c7 = (0, $exYeM.createContext)({
    editor: null
});
const $eca5d11c6814a94c$export$ce13247582c535f7 = $eca5d11c6814a94c$export$27b8dd149e32f6c7.Consumer;
/**
 * A hook to get the current editor instance.
 */ const $eca5d11c6814a94c$export$96c4d2ffb4c40e50 = ()=>(0, $exYeM.useContext)($eca5d11c6814a94c$export$27b8dd149e32f6c7);
/**
 * This is the provider component for the editor.
 * It allows the editor to be accessible across the entire component tree
 * with `useCurrentEditor`.
 */ function $eca5d11c6814a94c$export$b0c14a64ec1678d5({ children: children, slotAfter: slotAfter, slotBefore: slotBefore, editorContainerProps: editorContainerProps = {}, ...editorOptions }) {
    const editor = $eca5d11c6814a94c$export$43711a1418203bbc(editorOptions);
    if (!editor) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($eca5d11c6814a94c$export$27b8dd149e32f6c7.Provider, {
        value: {
            editor: editor
        }
    }, slotBefore, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($eca5d11c6814a94c$export$ce13247582c535f7, null, ({ editor: currentEditor })=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($eca5d11c6814a94c$export$a92c4e92ed722350, {
            editor: currentEditor,
            ...editorContainerProps
        })), children, slotAfter);
}
const $eca5d11c6814a94c$export$79c1bf6a55bce827 = (props)=>{
    const [element, setElement] = (0, $exYeM.useState)(null);
    const { editor: currentEditor } = $eca5d11c6814a94c$export$96c4d2ffb4c40e50();
    (0, $exYeM.useEffect)(()=>{
        var _a;
        if (!element) return;
        if (((_a = props.editor) === null || _a === void 0 ? void 0 : _a.isDestroyed) || (currentEditor === null || currentEditor === void 0 ? void 0 : currentEditor.isDestroyed)) return;
        const { pluginKey: pluginKey = "bubbleMenu", editor: editor, tippyOptions: tippyOptions = {}, updateDelay: updateDelay, shouldShow: shouldShow = null } = props;
        const menuEditor = editor || currentEditor;
        if (!menuEditor) {
            console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
            return;
        }
        const plugin = (0, $0bb7784487efcae2$export$20c12548414ed018)({
            updateDelay: updateDelay,
            editor: menuEditor,
            element: element,
            pluginKey: pluginKey,
            shouldShow: shouldShow,
            tippyOptions: tippyOptions
        });
        menuEditor.registerPlugin(plugin);
        return ()=>{
            menuEditor.unregisterPlugin(pluginKey);
        };
    }, [
        props.editor,
        currentEditor,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ref: setElement,
        className: props.className,
        style: {
            visibility: "hidden"
        }
    }, props.children);
};
const $eca5d11c6814a94c$export$695cda69e78edecd = (props)=>{
    const [element, setElement] = (0, $exYeM.useState)(null);
    const { editor: currentEditor } = $eca5d11c6814a94c$export$96c4d2ffb4c40e50();
    (0, $exYeM.useEffect)(()=>{
        var _a;
        if (!element) return;
        if (((_a = props.editor) === null || _a === void 0 ? void 0 : _a.isDestroyed) || (currentEditor === null || currentEditor === void 0 ? void 0 : currentEditor.isDestroyed)) return;
        const { pluginKey: pluginKey = "floatingMenu", editor: editor, tippyOptions: tippyOptions = {}, shouldShow: shouldShow = null } = props;
        const menuEditor = editor || currentEditor;
        if (!menuEditor) {
            console.warn("FloatingMenu component is not rendered inside of an editor component or does not have editor prop.");
            return;
        }
        const plugin = (0, $54caadc3fe0f6cd1$export$5e50896e3f3c0d7b)({
            pluginKey: pluginKey,
            editor: menuEditor,
            element: element,
            tippyOptions: tippyOptions,
            shouldShow: shouldShow
        });
        menuEditor.registerPlugin(plugin);
        return ()=>{
            menuEditor.unregisterPlugin(pluginKey);
        };
    }, [
        props.editor,
        currentEditor,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ref: setElement,
        className: props.className,
        style: {
            visibility: "hidden"
        }
    }, props.children);
};
const $eca5d11c6814a94c$export$3fef6c3187641c77 = (0, $exYeM.createContext)({
    onDragStart: undefined
});
const $eca5d11c6814a94c$export$b6657ee1f2411c6 = ()=>(0, $exYeM.useContext)($eca5d11c6814a94c$export$3fef6c3187641c77);
const $eca5d11c6814a94c$export$e44d28a41a78cbbb = (props)=>{
    const Tag = props.as || "div";
    const { nodeViewContentRef: nodeViewContentRef } = $eca5d11c6814a94c$export$b6657ee1f2411c6();
    return(// @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Tag, {
        ...props,
        ref: nodeViewContentRef,
        "data-node-view-content": "",
        style: {
            whiteSpace: "pre-wrap",
            ...props.style
        }
    }));
};
const $eca5d11c6814a94c$export$d02cc1f3e4390991 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, ref)=>{
    const { onDragStart: onDragStart } = $eca5d11c6814a94c$export$b6657ee1f2411c6();
    const Tag = props.as || "div";
    return(// @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Tag, {
        ...props,
        ref: ref,
        "data-node-view-wrapper": "",
        onDragStart: onDragStart,
        style: {
            whiteSpace: "normal",
            ...props.style
        }
    }));
});
/**
 * Check if a component is a class component.
 * @param Component
 * @returns {boolean}
 */ function $eca5d11c6814a94c$var$isClassComponent(Component) {
    return !!(typeof Component === "function" && Component.prototype && Component.prototype.isReactComponent);
}
/**
 * Check if a component is a forward ref component.
 * @param Component
 * @returns {boolean}
 */ function $eca5d11c6814a94c$var$isForwardRefComponent(Component) {
    var _a;
    return !!(typeof Component === "object" && ((_a = Component.$$typeof) === null || _a === void 0 ? void 0 : _a.toString()) === "Symbol(react.forward_ref)");
}
/**
 * The ReactRenderer class. It's responsible for rendering React components inside the editor.
 * @example
 * new ReactRenderer(MyComponent, {
 *   editor,
 *   props: {
 *     foo: 'bar',
 *   },
 *   as: 'span',
 * })
*/ class $eca5d11c6814a94c$export$687d546b0584d31b {
    /**
     * Immediately creates element and renders the provided React component.
     */ constructor(component, { editor: editor, props: props = {}, as: as = "div", className: className = "" }){
        this.ref = null;
        this.id = Math.floor(Math.random() * 0xFFFFFFFF).toString();
        this.component = component;
        this.editor = editor;
        this.props = props;
        this.element = document.createElement(as);
        this.element.classList.add("react-renderer");
        if (className) this.element.classList.add(...className.split(" "));
        if (this.editor.isInitialized) // On first render, we need to flush the render synchronously
        // Renders afterwards can be async, but this fixes a cursor positioning issue
        (0, $d2lNW.flushSync)(()=>{
            this.render();
        });
        else this.render();
    }
    /**
     * Render the React component.
     */ render() {
        var _a;
        const Component = this.component;
        const props = this.props;
        const editor = this.editor;
        if ($eca5d11c6814a94c$var$isClassComponent(Component) || $eca5d11c6814a94c$var$isForwardRefComponent(Component)) // @ts-ignore This is a hack to make the ref work
        props.ref = (ref)=>{
            this.ref = ref;
        };
        this.reactElement = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Component, {
            ...props
        });
        (_a = editor === null || editor === void 0 ? void 0 : editor.contentComponent) === null || _a === void 0 || _a.setRenderer(this.id, this);
    }
    /**
     * Re-renders the React component with new props.
     */ updateProps(props = {}) {
        this.props = {
            ...this.props,
            ...props
        };
        this.render();
    }
    /**
     * Destroy the React component.
     */ destroy() {
        var _a;
        const editor = this.editor;
        (_a = editor === null || editor === void 0 ? void 0 : editor.contentComponent) === null || _a === void 0 || _a.removeRenderer(this.id);
    }
    /**
     * Update the attributes of the element that holds the React component.
     */ updateAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>{
            this.element.setAttribute(key, attributes[key]);
        });
    }
}
class $eca5d11c6814a94c$export$eac36b62725dff99 extends (0, $a769590142262cb7$export$77c6811359a01a6f) {
    /**
     * Setup the React component.
     * Called on initialization.
     */ mount() {
        const props = {
            editor: this.editor,
            node: this.node,
            decorations: this.decorations,
            innerDecorations: this.innerDecorations,
            view: this.view,
            selected: false,
            extension: this.extension,
            HTMLAttributes: this.HTMLAttributes,
            getPos: ()=>this.getPos(),
            updateAttributes: (attributes = {})=>this.updateAttributes(attributes),
            deleteNode: ()=>this.deleteNode()
        };
        if (!this.component.displayName) {
            const capitalizeFirstChar = (string)=>{
                return string.charAt(0).toUpperCase() + string.substring(1);
            };
            this.component.displayName = capitalizeFirstChar(this.extension.name);
        }
        const onDragStart = this.onDragStart.bind(this);
        const nodeViewContentRef = (element)=>{
            if (element && this.contentDOMElement && element.firstChild !== this.contentDOMElement) element.appendChild(this.contentDOMElement);
        };
        const context = {
            onDragStart: onDragStart,
            nodeViewContentRef: nodeViewContentRef
        };
        const Component = this.component;
        // For performance reasons, we memoize the provider component
        // And all of the things it requires are declared outside of the component, so it doesn't need to re-render
        const ReactNodeViewProvider = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo((componentProps)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($eca5d11c6814a94c$export$3fef6c3187641c77.Provider, {
                value: context
            }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Component, componentProps));
        });
        ReactNodeViewProvider.displayName = "ReactNodeView";
        if (this.node.isLeaf) this.contentDOMElement = null;
        else if (this.options.contentDOMElementTag) this.contentDOMElement = document.createElement(this.options.contentDOMElementTag);
        else this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div");
        if (this.contentDOMElement) {
            this.contentDOMElement.dataset.nodeViewContentReact = "";
            // For some reason the whiteSpace prop is not inherited properly in Chrome and Safari
            // With this fix it seems to work fine
            // See: https://github.com/ueberdosis/tiptap/issues/1197
            this.contentDOMElement.style.whiteSpace = "inherit";
        }
        let as = this.node.isInline ? "span" : "div";
        if (this.options.as) as = this.options.as;
        const { className: className = "" } = this.options;
        this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
        this.renderer = new $eca5d11c6814a94c$export$687d546b0584d31b(ReactNodeViewProvider, {
            editor: this.editor,
            props: props,
            as: as,
            className: `node-${this.node.type.name} ${className}`.trim()
        });
        this.editor.on("selectionUpdate", this.handleSelectionUpdate);
        this.updateElementAttributes();
    }
    /**
     * Return the DOM element.
     * This is the element that will be used to display the node view.
     */ get dom() {
        var _a;
        if (this.renderer.element.firstElementChild && !((_a = this.renderer.element.firstElementChild) === null || _a === void 0 ? void 0 : _a.hasAttribute("data-node-view-wrapper"))) throw Error("Please use the NodeViewWrapper component for your node view.");
        return this.renderer.element;
    }
    /**
     * Return the content DOM element.
     * This is the element that will be used to display the rich-text content of the node.
     */ get contentDOM() {
        if (this.node.isLeaf) return null;
        return this.contentDOMElement;
    }
    /**
     * On editor selection update, check if the node is selected.
     * If it is, call `selectNode`, otherwise call `deselectNode`.
     */ handleSelectionUpdate() {
        const { from: from, to: to } = this.editor.state.selection;
        const pos = this.getPos();
        if (typeof pos !== "number") return;
        if (from <= pos && to >= pos + this.node.nodeSize) {
            if (this.renderer.props.selected) return;
            this.selectNode();
        } else {
            if (!this.renderer.props.selected) return;
            this.deselectNode();
        }
    }
    /**
     * On update, update the React component.
     * To prevent unnecessary updates, the `update` option can be used.
     */ update(node, decorations, innerDecorations) {
        const rerenderComponent = (props)=>{
            this.renderer.updateProps(props);
            if (typeof this.options.attrs === "function") this.updateElementAttributes();
        };
        if (node.type !== this.node.type) return false;
        if (typeof this.options.update === "function") {
            const oldNode = this.node;
            const oldDecorations = this.decorations;
            const oldInnerDecorations = this.innerDecorations;
            this.node = node;
            this.decorations = decorations;
            this.innerDecorations = innerDecorations;
            return this.options.update({
                oldNode: oldNode,
                oldDecorations: oldDecorations,
                newNode: node,
                newDecorations: decorations,
                oldInnerDecorations: oldInnerDecorations,
                innerDecorations: innerDecorations,
                updateProps: ()=>rerenderComponent({
                        node: node,
                        decorations: decorations,
                        innerDecorations: innerDecorations
                    })
            });
        }
        if (node === this.node && this.decorations === decorations && this.innerDecorations === innerDecorations) return true;
        this.node = node;
        this.decorations = decorations;
        this.innerDecorations = innerDecorations;
        rerenderComponent({
            node: node,
            decorations: decorations,
            innerDecorations: innerDecorations
        });
        return true;
    }
    /**
     * Select the node.
     * Add the `selected` prop and the `ProseMirror-selectednode` class.
     */ selectNode() {
        this.renderer.updateProps({
            selected: true
        });
        this.renderer.element.classList.add("ProseMirror-selectednode");
    }
    /**
     * Deselect the node.
     * Remove the `selected` prop and the `ProseMirror-selectednode` class.
     */ deselectNode() {
        this.renderer.updateProps({
            selected: false
        });
        this.renderer.element.classList.remove("ProseMirror-selectednode");
    }
    /**
     * Destroy the React component instance.
     */ destroy() {
        this.renderer.destroy();
        this.editor.off("selectionUpdate", this.handleSelectionUpdate);
        this.contentDOMElement = null;
    }
    /**
     * Update the attributes of the top-level element that holds the React component.
     * Applying the attributes defined in the `attrs` option.
     */ updateElementAttributes() {
        if (this.options.attrs) {
            let attrsObj = {};
            if (typeof this.options.attrs === "function") {
                const extensionAttributes = this.editor.extensionManager.attributes;
                const HTMLAttributes = (0, $a769590142262cb7$export$bc79d84a417d7b02)(this.node, extensionAttributes);
                attrsObj = this.options.attrs({
                    node: this.node,
                    HTMLAttributes: HTMLAttributes
                });
            } else attrsObj = this.options.attrs;
            this.renderer.updateAttributes(attrsObj);
        }
    }
}
/**
 * Create a React node view renderer.
 */ function $eca5d11c6814a94c$export$478a6cea73a8df20(component, options) {
    return (props)=>{
        // try to get the parent component
        // this is important for vue devtools to show the component hierarchy correctly
        // maybe it’s `undefined` because <editor-content> isn’t rendered yet
        if (!props.editor.contentComponent) return {};
        return new $eca5d11c6814a94c$export$eac36b62725dff99(component, props, options);
    };
}




/**
 * Matches a blockquote to a `>` as input.
 */ const $99f8c21878abcea7$export$55b9391925fcc072 = /^\s*>\s$/;
/**
 * This extension allows you to create blockquotes.
 * @see https://tiptap.dev/api/nodes/blockquote
 */ const $99f8c21878abcea7$export$29a7a275fe11687 = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "blockquote",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    content: "block+",
    group: "block",
    defining: true,
    parseHTML () {
        return [
            {
                tag: "blockquote"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "blockquote",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setBlockquote: ()=>({ commands: commands })=>{
                    return commands.wrapIn(this.name);
                },
            toggleBlockquote: ()=>({ commands: commands })=>{
                    return commands.toggleWrap(this.name);
                },
            unsetBlockquote: ()=>({ commands: commands })=>{
                    return commands.lift(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-b": ()=>this.editor.commands.toggleBlockquote()
        };
    },
    addInputRules () {
        return [
            (0, $a769590142262cb7$export$f7316d89abe4e1c1)({
                find: $99f8c21878abcea7$export$55b9391925fcc072,
                type: this.type
            })
        ];
    }
});



/**
 * Matches bold text via `**` as input.
 */ const $783f15b16d4a7ba3$export$73ba4776eeca629e = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
/**
 * Matches bold text via `**` while pasting.
 */ const $783f15b16d4a7ba3$export$47b75d481b90409 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
/**
 * Matches bold text via `__` as input.
 */ const $783f15b16d4a7ba3$export$79cd1d2695dae26d = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
/**
 * Matches bold text via `__` while pasting.
 */ const $783f15b16d4a7ba3$export$9b623891dbc7bd12 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
/**
 * This extension allows you to mark text as bold.
 * @see https://tiptap.dev/api/marks/bold
 */ const $783f15b16d4a7ba3$export$95aa4184327d6b72 = (0, $a769590142262cb7$export$c9d15bcfc6d42044).create({
    name: "bold",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "strong"
            },
            {
                tag: "b",
                getAttrs: (node)=>node.style.fontWeight !== "normal" && null
            },
            {
                style: "font-weight=400",
                clearMark: (mark)=>mark.type.name === this.name
            },
            {
                style: "font-weight",
                getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "strong",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setBold: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleBold: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetBold: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-b": ()=>this.editor.commands.toggleBold(),
            "Mod-B": ()=>this.editor.commands.toggleBold()
        };
    },
    addInputRules () {
        return [
            (0, $a769590142262cb7$export$9f2cb743ab9131de)({
                find: $783f15b16d4a7ba3$export$73ba4776eeca629e,
                type: this.type
            }),
            (0, $a769590142262cb7$export$9f2cb743ab9131de)({
                find: $783f15b16d4a7ba3$export$79cd1d2695dae26d,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $a769590142262cb7$export$3845eb97abe74944)({
                find: $783f15b16d4a7ba3$export$47b75d481b90409,
                type: this.type
            }),
            (0, $a769590142262cb7$export$3845eb97abe74944)({
                find: $783f15b16d4a7ba3$export$9b623891dbc7bd12,
                type: this.type
            })
        ];
    }
});



const $eeb2760fec8bea2a$var$ListItemName = "listItem";
const $eeb2760fec8bea2a$var$TextStyleName = "textStyle";
/**
 * Matches a bullet list to a dash or asterisk.
 */ const $eeb2760fec8bea2a$export$55b9391925fcc072 = /^\s*([-+*])\s$/;
/**
 * This extension allows you to create bullet lists.
 * This requires the ListItem extension
 * @see https://tiptap.dev/api/nodes/bullet-list
 * @see https://tiptap.dev/api/nodes/list-item.
 */ const $eeb2760fec8bea2a$export$546f606c73d35982 = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "bulletList",
    addOptions () {
        return {
            itemTypeName: "listItem",
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false
        };
    },
    group: "block list",
    content () {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML () {
        return [
            {
                tag: "ul"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "ul",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            toggleBulletList: ()=>({ commands: commands, chain: chain })=>{
                    if (this.options.keepAttributes) return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($eeb2760fec8bea2a$var$ListItemName, this.editor.getAttributes($eeb2760fec8bea2a$var$TextStyleName)).run();
                    return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-8": ()=>this.editor.commands.toggleBulletList()
        };
    },
    addInputRules () {
        let inputRule = (0, $a769590142262cb7$export$f7316d89abe4e1c1)({
            find: $eeb2760fec8bea2a$export$55b9391925fcc072,
            type: this.type
        });
        if (this.options.keepMarks || this.options.keepAttributes) inputRule = (0, $a769590142262cb7$export$f7316d89abe4e1c1)({
            find: $eeb2760fec8bea2a$export$55b9391925fcc072,
            type: this.type,
            keepMarks: this.options.keepMarks,
            keepAttributes: this.options.keepAttributes,
            getAttributes: ()=>{
                return this.editor.getAttributes($eeb2760fec8bea2a$var$TextStyleName);
            },
            editor: this.editor
        });
        return [
            inputRule
        ];
    }
});



/**
 * Regular expressions to match inline code blocks enclosed in backticks.
 *  It matches:
 *     - An opening backtick, followed by
 *     - Any text that doesn't include a backtick (captured for marking), followed by
 *     - A closing backtick.
 *  This ensures that any text between backticks is formatted as code,
 *  regardless of the surrounding characters (exception being another backtick).
 */ const $9b98815fd2b6868a$export$55b9391925fcc072 = /(^|[^`])`([^`]+)`(?!`)/;
/**
 * Matches inline code while pasting.
 */ const $9b98815fd2b6868a$export$4ed30f8936af1979 = /(^|[^`])`([^`]+)`(?!`)/g;
/**
 * This extension allows you to mark text as inline code.
 * @see https://tiptap.dev/api/marks/code
 */ const $9b98815fd2b6868a$export$52f0f02147b12c03 = (0, $a769590142262cb7$export$c9d15bcfc6d42044).create({
    name: "code",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    excludes: "_",
    code: true,
    exitable: true,
    parseHTML () {
        return [
            {
                tag: "code"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "code",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setCode: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleCode: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetCode: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-e": ()=>this.editor.commands.toggleCode()
        };
    },
    addInputRules () {
        return [
            (0, $a769590142262cb7$export$9f2cb743ab9131de)({
                find: $9b98815fd2b6868a$export$55b9391925fcc072,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $a769590142262cb7$export$3845eb97abe74944)({
                find: $9b98815fd2b6868a$export$4ed30f8936af1979,
                type: this.type
            })
        ];
    }
});




/**
 * Matches a code block with backticks.
 */ const $768a276f4d2bdd50$export$4f70c75119de8367 = /^```([a-z]+)?[\s\n]$/;
/**
 * Matches a code block with tildes.
 */ const $768a276f4d2bdd50$export$ab3d90a1a99abb84 = /^~~~([a-z]+)?[\s\n]$/;
/**
 * This extension allows you to create code blocks.
 * @see https://tiptap.dev/api/nodes/code-block
 */ const $768a276f4d2bdd50$export$6c415d1fdae3dfdb = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "codeBlock",
    addOptions () {
        return {
            languageClassPrefix: "language-",
            exitOnTripleEnter: true,
            exitOnArrowDown: true,
            defaultLanguage: null,
            HTMLAttributes: {}
        };
    },
    content: "text*",
    marks: "",
    group: "block",
    code: true,
    defining: true,
    addAttributes () {
        return {
            language: {
                default: this.options.defaultLanguage,
                parseHTML: (element)=>{
                    var _a;
                    const { languageClassPrefix: languageClassPrefix } = this.options;
                    const classNames = [
                        ...((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) || []
                    ];
                    const languages = classNames.filter((className)=>className.startsWith(languageClassPrefix)).map((className)=>className.replace(languageClassPrefix, ""));
                    const language = languages[0];
                    if (!language) return null;
                    return language;
                },
                rendered: false
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: "pre",
                preserveWhitespace: "full"
            }
        ];
    },
    renderHTML ({ node: node, HTMLAttributes: HTMLAttributes }) {
        return [
            "pre",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            [
                "code",
                {
                    class: node.attrs.language ? this.options.languageClassPrefix + node.attrs.language : null
                },
                0
            ]
        ];
    },
    addCommands () {
        return {
            setCodeBlock: (attributes)=>({ commands: commands })=>{
                    return commands.setNode(this.name, attributes);
                },
            toggleCodeBlock: (attributes)=>({ commands: commands })=>{
                    return commands.toggleNode(this.name, "paragraph", attributes);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Alt-c": ()=>this.editor.commands.toggleCodeBlock(),
            // remove code block when at start of document or code block is empty
            Backspace: ()=>{
                const { empty: empty, $anchor: $anchor } = this.editor.state.selection;
                const isAtStart = $anchor.pos === 1;
                if (!empty || $anchor.parent.type.name !== this.name) return false;
                if (isAtStart || !$anchor.parent.textContent.length) return this.editor.commands.clearNodes();
                return false;
            },
            // exit node on triple enter
            Enter: ({ editor: editor })=>{
                if (!this.options.exitOnTripleEnter) return false;
                const { state: state } = editor;
                const { selection: selection } = state;
                const { $from: $from, empty: empty } = selection;
                if (!empty || $from.parent.type !== this.type) return false;
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                const endsWithDoubleNewline = $from.parent.textContent.endsWith("\n\n");
                if (!isAtEnd || !endsWithDoubleNewline) return false;
                return editor.chain().command(({ tr: tr })=>{
                    tr.delete($from.pos - 2, $from.pos);
                    return true;
                }).exitCode().run();
            },
            // exit node on arrow down
            ArrowDown: ({ editor: editor })=>{
                if (!this.options.exitOnArrowDown) return false;
                const { state: state } = editor;
                const { selection: selection, doc: doc } = state;
                const { $from: $from, empty: empty } = selection;
                if (!empty || $from.parent.type !== this.type) return false;
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                if (!isAtEnd) return false;
                const after = $from.after();
                if (after === undefined) return false;
                const nodeAfter = doc.nodeAt(after);
                if (nodeAfter) return editor.commands.command(({ tr: tr })=>{
                    tr.setSelection((0, $6acde7918354ce68$export$52baac22726c72bf).near(doc.resolve(after)));
                    return true;
                });
                return editor.commands.exitCode();
            }
        };
    },
    addInputRules () {
        return [
            (0, $a769590142262cb7$export$cc081314d3f6ffb0)({
                find: $768a276f4d2bdd50$export$4f70c75119de8367,
                type: this.type,
                getAttributes: (match)=>({
                        language: match[1]
                    })
            }),
            (0, $a769590142262cb7$export$cc081314d3f6ffb0)({
                find: $768a276f4d2bdd50$export$ab3d90a1a99abb84,
                type: this.type,
                getAttributes: (match)=>({
                        language: match[1]
                    })
            })
        ];
    },
    addProseMirrorPlugins () {
        return [
            // this plugin creates a code block for pasted content from VS Code
            // we can also detect the copied code language
            new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
                key: new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("codeBlockVSCodeHandler"),
                props: {
                    handlePaste: (view, event)=>{
                        if (!event.clipboardData) return false;
                        // don’t create a new code block within code blocks
                        if (this.editor.isActive(this.type.name)) return false;
                        const text = event.clipboardData.getData("text/plain");
                        const vscode = event.clipboardData.getData("vscode-editor-data");
                        const vscodeData = vscode ? JSON.parse(vscode) : undefined;
                        const language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
                        if (!text || !language) return false;
                        const { tr: tr, schema: schema } = view.state;
                        // prepare a text node
                        // strip carriage return chars from text pasted as code
                        // see: https://github.com/ProseMirror/prosemirror-view/commit/a50a6bcceb4ce52ac8fcc6162488d8875613aacd
                        const textNode = schema.text(text.replace(/\r\n?/g, "\n"));
                        // create a code block with the text node
                        // replace selection with the code block
                        tr.replaceSelectionWith(this.type.create({
                            language: language
                        }, textNode));
                        if (tr.selection.$from.parent.type !== this.type) // put cursor inside the newly created code block
                        tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).near(tr.doc.resolve(Math.max(0, tr.selection.from - 2))));
                        // store meta information
                        // this is useful for other plugins that depends on the paste event
                        // like the paste rule plugin
                        tr.setMeta("paste", true);
                        view.dispatch(tr);
                        return true;
                    }
                }
            })
        ];
    }
});



/**
 * The default document node which represents the top level node of the editor.
 * @see https://tiptap.dev/api/nodes/document
 */ const $af9b5b8774c8f755$export$b34a105447964f9f = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "doc",
    topNode: true,
    content: "block+"
});



// dropcursor/index.ts


/**
Create a plugin that, when added to a ProseMirror instance,
causes a decoration to show up at the drop position when something
is dragged over the editor.

Nodes may add a `disableDropCursor` property to their spec to
control the showing of a drop cursor inside them. This may be a
boolean or a function, which will be called with a view and a
position, and should return a boolean.
*/ function $b642c9a0723a9cc8$export$b8e3092a3bfa2062(options = {}) {
    return new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
        view (editorView) {
            return new $b642c9a0723a9cc8$var$DropCursorView(editorView, options);
        }
    });
}
class $b642c9a0723a9cc8$var$DropCursorView {
    constructor(editorView, options){
        var _a;
        this.editorView = editorView;
        this.cursorPos = null;
        this.element = null;
        this.timeout = -1;
        this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 1;
        this.color = options.color === false ? undefined : options.color || "black";
        this.class = options.class;
        this.handlers = [
            "dragover",
            "dragend",
            "drop",
            "dragleave"
        ].map((name)=>{
            let handler = (e)=>{
                this[name](e);
            };
            editorView.dom.addEventListener(name, handler);
            return {
                name: name,
                handler: handler
            };
        });
    }
    destroy() {
        this.handlers.forEach(({ name: name, handler: handler })=>this.editorView.dom.removeEventListener(name, handler));
    }
    update(editorView, prevState) {
        if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
            if (this.cursorPos > editorView.state.doc.content.size) this.setCursor(null);
            else this.updateOverlay();
        }
    }
    setCursor(pos) {
        if (pos == this.cursorPos) return;
        this.cursorPos = pos;
        if (pos == null) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
        } else this.updateOverlay();
    }
    updateOverlay() {
        let $pos = this.editorView.state.doc.resolve(this.cursorPos);
        let isBlock = !$pos.parent.inlineContent, rect;
        if (isBlock) {
            let before = $pos.nodeBefore, after = $pos.nodeAfter;
            if (before || after) {
                let node = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
                if (node) {
                    let nodeRect = node.getBoundingClientRect();
                    let top = before ? nodeRect.bottom : nodeRect.top;
                    if (before && after) top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
                    rect = {
                        left: nodeRect.left,
                        right: nodeRect.right,
                        top: top - this.width / 2,
                        bottom: top + this.width / 2
                    };
                }
            }
        }
        if (!rect) {
            let coords = this.editorView.coordsAtPos(this.cursorPos);
            rect = {
                left: coords.left - this.width / 2,
                right: coords.left + this.width / 2,
                top: coords.top,
                bottom: coords.bottom
            };
        }
        let parent = this.editorView.dom.offsetParent;
        if (!this.element) {
            this.element = parent.appendChild(document.createElement("div"));
            if (this.class) this.element.className = this.class;
            this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
            if (this.color) this.element.style.backgroundColor = this.color;
        }
        this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
        this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
        let parentLeft, parentTop;
        if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
            parentLeft = -pageXOffset;
            parentTop = -pageYOffset;
        } else {
            let rect = parent.getBoundingClientRect();
            parentLeft = rect.left - parent.scrollLeft;
            parentTop = rect.top - parent.scrollTop;
        }
        this.element.style.left = rect.left - parentLeft + "px";
        this.element.style.top = rect.top - parentTop + "px";
        this.element.style.width = rect.right - rect.left + "px";
        this.element.style.height = rect.bottom - rect.top + "px";
    }
    scheduleRemoval(timeout) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(()=>this.setCursor(null), timeout);
    }
    dragover(event) {
        if (!this.editorView.editable) return;
        let pos = this.editorView.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        let node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
        let disableDropCursor = node && node.type.spec.disableDropCursor;
        let disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
        if (pos && !disabled) {
            let target = pos.pos;
            if (this.editorView.dragging && this.editorView.dragging.slice) {
                let point = (0, $72a42b551bab6846$export$2819d598d048fc9c)(this.editorView.state.doc, target, this.editorView.dragging.slice);
                if (point != null) target = point;
            }
            this.setCursor(target);
            this.scheduleRemoval(5000);
        }
    }
    dragend() {
        this.scheduleRemoval(20);
    }
    drop() {
        this.scheduleRemoval(20);
    }
    dragleave(event) {
        if (event.target == this.editorView.dom || !this.editorView.dom.contains(event.relatedTarget)) this.setCursor(null);
    }
}




/**
 * This extension allows you to add a drop cursor to your editor.
 * A drop cursor is a line that appears when you drag and drop content
 * inbetween nodes.
 * @see https://tiptap.dev/api/extensions/dropcursor
 */ const $c93a7a36afed34cc$export$bc16731f26f3900d = (0, $a769590142262cb7$export$eeddbf09bb970356).create({
    name: "dropCursor",
    addOptions () {
        return {
            color: "currentColor",
            width: 1,
            class: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $b642c9a0723a9cc8$export$b8e3092a3bfa2062)(this.options)
        ];
    }
});



// gapcursor/index.ts




/**
Gap cursor selections are represented using this class. Its
`$anchor` and `$head` properties both point at the cursor position.
*/ class $71cb895787923067$export$3d3d259665dcb4d4 extends (0, $6acde7918354ce68$export$52baac22726c72bf) {
    /**
    Create a gap cursor.
    */ constructor($pos){
        super($pos, $pos);
    }
    map(doc, mapping) {
        let $pos = doc.resolve(mapping.map(this.head));
        return $71cb895787923067$export$3d3d259665dcb4d4.valid($pos) ? new $71cb895787923067$export$3d3d259665dcb4d4($pos) : (0, $6acde7918354ce68$export$52baac22726c72bf).near($pos);
    }
    content() {
        return (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e).empty;
    }
    eq(other) {
        return other instanceof $71cb895787923067$export$3d3d259665dcb4d4 && other.head == this.head;
    }
    toJSON() {
        return {
            type: "gapcursor",
            pos: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for GapCursor.fromJSON");
        return new $71cb895787923067$export$3d3d259665dcb4d4(doc.resolve(json.pos));
    }
    /**
    @internal
    */ getBookmark() {
        return new $71cb895787923067$var$GapBookmark(this.anchor);
    }
    /**
    @internal
    */ static valid($pos) {
        let parent = $pos.parent;
        if (parent.isTextblock || !$71cb895787923067$var$closedBefore($pos) || !$71cb895787923067$var$closedAfter($pos)) return false;
        let override = parent.type.spec.allowGapCursor;
        if (override != null) return override;
        let deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    /**
    @internal
    */ static findGapCursorFrom($pos, dir, mustMove = false) {
        search: for(;;){
            if (!mustMove && $71cb895787923067$export$3d3d259665dcb4d4.valid($pos)) return $pos;
            let pos = $pos.pos, next = null;
            // Scan up from this position
            for(let d = $pos.depth;; d--){
                let parent = $pos.node(d);
                if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                    next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
                    break;
                } else if (d == 0) return null;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if ($71cb895787923067$export$3d3d259665dcb4d4.valid($cur)) return $cur;
            }
            // And then down into the next node
            for(;;){
                let inside = dir > 0 ? next.firstChild : next.lastChild;
                if (!inside) {
                    if (next.isAtom && !next.isText && !(0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(next)) {
                        $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
                        mustMove = false;
                        continue search;
                    }
                    break;
                }
                next = inside;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if ($71cb895787923067$export$3d3d259665dcb4d4.valid($cur)) return $cur;
            }
            return null;
        }
    }
}
$71cb895787923067$export$3d3d259665dcb4d4.prototype.visible = false;
$71cb895787923067$export$3d3d259665dcb4d4.findFrom = $71cb895787923067$export$3d3d259665dcb4d4.findGapCursorFrom;
(0, $6acde7918354ce68$export$52baac22726c72bf).jsonID("gapcursor", $71cb895787923067$export$3d3d259665dcb4d4);
class $71cb895787923067$var$GapBookmark {
    constructor(pos){
        this.pos = pos;
    }
    map(mapping) {
        return new $71cb895787923067$var$GapBookmark(mapping.map(this.pos));
    }
    resolve(doc) {
        let $pos = doc.resolve(this.pos);
        return $71cb895787923067$export$3d3d259665dcb4d4.valid($pos) ? new $71cb895787923067$export$3d3d259665dcb4d4($pos) : (0, $6acde7918354ce68$export$52baac22726c72bf).near($pos);
    }
}
function $71cb895787923067$var$closedBefore($pos) {
    for(let d = $pos.depth; d >= 0; d--){
        let index = $pos.index(d), parent = $pos.node(d);
        // At the start of this parent, look at next one
        if (index == 0) {
            if (parent.type.spec.isolating) return true;
            continue;
        }
        // See if the node before (or its first ancestor) is closed
        for(let before = parent.child(index - 1);; before = before.lastChild){
            if (before.childCount == 0 && !before.inlineContent || before.isAtom || before.type.spec.isolating) return true;
            if (before.inlineContent) return false;
        }
    }
    // Hit start of document
    return true;
}
function $71cb895787923067$var$closedAfter($pos) {
    for(let d = $pos.depth; d >= 0; d--){
        let index = $pos.indexAfter(d), parent = $pos.node(d);
        if (index == parent.childCount) {
            if (parent.type.spec.isolating) return true;
            continue;
        }
        for(let after = parent.child(index);; after = after.firstChild){
            if (after.childCount == 0 && !after.inlineContent || after.isAtom || after.type.spec.isolating) return true;
            if (after.inlineContent) return false;
        }
    }
    return true;
}
/**
Create a gap cursor plugin. When enabled, this will capture clicks
near and arrow-key-motion past places that don't have a normally
selectable position nearby, and create a gap cursor selection for
them. The cursor is drawn as an element with class
`ProseMirror-gapcursor`. You can either include
`style/gapcursor.css` from the package's directory or add your own
styles to make it visible.
*/ function $71cb895787923067$export$54f46a1492d5247() {
    return new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
        props: {
            decorations: $71cb895787923067$var$drawGapCursor,
            createSelectionBetween (_view, $anchor, $head) {
                return $anchor.pos == $head.pos && $71cb895787923067$export$3d3d259665dcb4d4.valid($head) ? new $71cb895787923067$export$3d3d259665dcb4d4($head) : null;
            },
            handleClick: $71cb895787923067$var$handleClick,
            handleKeyDown: $71cb895787923067$var$handleKeyDown,
            handleDOMEvents: {
                beforeinput: $71cb895787923067$var$beforeinput
            }
        }
    });
}
const $71cb895787923067$var$handleKeyDown = (0, $08ab38e848d66b67$export$53f558754f8b9fd1)({
    "ArrowLeft": $71cb895787923067$var$arrow("horiz", -1),
    "ArrowRight": $71cb895787923067$var$arrow("horiz", 1),
    "ArrowUp": $71cb895787923067$var$arrow("vert", -1),
    "ArrowDown": $71cb895787923067$var$arrow("vert", 1)
});
function $71cb895787923067$var$arrow(axis, dir) {
    const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
    return function(state, dispatch, view) {
        let sel = state.selection;
        let $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
        if (sel instanceof (0, $6acde7918354ce68$export$c2b25f346d19bcbb)) {
            if (!view.endOfTextblock(dirStr) || $start.depth == 0) return false;
            mustMove = false;
            $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
        }
        let $found = $71cb895787923067$export$3d3d259665dcb4d4.findGapCursorFrom($start, dir, mustMove);
        if (!$found) return false;
        if (dispatch) dispatch(state.tr.setSelection(new $71cb895787923067$export$3d3d259665dcb4d4($found)));
        return true;
    };
}
function $71cb895787923067$var$handleClick(view, pos, event) {
    if (!view || !view.editable) return false;
    let $pos = view.state.doc.resolve(pos);
    if (!$71cb895787923067$export$3d3d259665dcb4d4.valid($pos)) return false;
    let clickPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (clickPos && clickPos.inside > -1 && (0, $6acde7918354ce68$export$e2940151ac854c0b).isSelectable(view.state.doc.nodeAt(clickPos.inside))) return false;
    view.dispatch(view.state.tr.setSelection(new $71cb895787923067$export$3d3d259665dcb4d4($pos)));
    return true;
}
// This is a hack that, when a composition starts while a gap cursor
// is active, quickly creates an inline context for the composition to
// happen in, to avoid it being aborted by the DOM selection being
// moved into a valid position.
function $71cb895787923067$var$beforeinput(view, event) {
    if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof $71cb895787923067$export$3d3d259665dcb4d4)) return false;
    let { $from: $from } = view.state.selection;
    let insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
    if (!insert) return false;
    let frag = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).empty;
    for(let i = insert.length - 1; i >= 0; i--)frag = (0, $1847e9be7ba495c5$export$ffb0004e005737fa).from(insert[i].createAndFill(null, frag));
    let tr = view.state.tr.replace($from.pos, $from.pos, new (0, $1847e9be7ba495c5$export$b3f2e2de3a8baa1e)(frag, 0, 0));
    tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).near(tr.doc.resolve($from.pos + 1)));
    view.dispatch(tr);
    return false;
}
function $71cb895787923067$var$drawGapCursor(state) {
    if (!(state.selection instanceof $71cb895787923067$export$3d3d259665dcb4d4)) return null;
    let node = document.createElement("div");
    node.className = "ProseMirror-gapcursor";
    return (0, $5b3735bad55c10ce$export$93bf62eb445cec98).create(state.doc, [
        (0, $5b3735bad55c10ce$export$10e30b733df217ea).widget(state.selection.head, node, {
            key: "gapcursor"
        })
    ]);
}




/**
 * This extension allows you to add a gap cursor to your editor.
 * A gap cursor is a cursor that appears when you click on a place
 * where no content is present, for example inbetween nodes.
 * @see https://tiptap.dev/api/extensions/gapcursor
 */ const $107135f049e644a6$export$79c3dcaa03287f63 = (0, $a769590142262cb7$export$eeddbf09bb970356).create({
    name: "gapCursor",
    addProseMirrorPlugins () {
        return [
            (0, $71cb895787923067$export$54f46a1492d5247)()
        ];
    },
    extendNodeSchema (extension) {
        var _a;
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        return {
            allowGapCursor: (_a = (0, $a769590142262cb7$export$592682234826c0bd)((0, $a769590142262cb7$export$f73578b718a57eaa)(extension, "allowGapCursor", context))) !== null && _a !== void 0 ? _a : null
        };
    }
});



/**
 * This extension allows you to insert hard breaks.
 * @see https://www.tiptap.dev/api/nodes/hard-break
 */ const $9da270bd9990040c$export$d3d3fac13fa635d9 = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "hardBreak",
    addOptions () {
        return {
            keepMarks: true,
            HTMLAttributes: {}
        };
    },
    inline: true,
    group: "inline",
    selectable: false,
    linebreakReplacement: true,
    parseHTML () {
        return [
            {
                tag: "br"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "br",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },
    renderText () {
        return "\n";
    },
    addCommands () {
        return {
            setHardBreak: ()=>({ commands: commands, chain: chain, state: state, editor: editor })=>{
                    return commands.first([
                        ()=>commands.exitCode(),
                        ()=>commands.command(()=>{
                                const { selection: selection, storedMarks: storedMarks } = state;
                                if (selection.$from.parent.type.spec.isolating) return false;
                                const { keepMarks: keepMarks } = this.options;
                                const { splittableMarks: splittableMarks } = editor.extensionManager;
                                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                                return chain().insertContent({
                                    type: this.name
                                }).command(({ tr: tr, dispatch: dispatch })=>{
                                    if (dispatch && marks && keepMarks) {
                                        const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                                        tr.ensureMarks(filteredMarks);
                                    }
                                    return true;
                                }).run();
                            })
                    ]);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Enter": ()=>this.editor.commands.setHardBreak(),
            "Shift-Enter": ()=>this.editor.commands.setHardBreak()
        };
    }
});



/**
 * This extension allows you to create headings.
 * @see https://www.tiptap.dev/api/nodes/heading
 */ const $1031752c5dbdbe19$export$a8a3e93435678ff9 = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "heading",
    addOptions () {
        return {
            levels: [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            HTMLAttributes: {}
        };
    },
    content: "inline*",
    group: "block",
    defining: true,
    addAttributes () {
        return {
            level: {
                default: 1,
                rendered: false
            }
        };
    },
    parseHTML () {
        return this.options.levels.map((level)=>({
                tag: `h${level}`,
                attrs: {
                    level: level
                }
            }));
    },
    renderHTML ({ node: node, HTMLAttributes: HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel ? node.attrs.level : this.options.levels[0];
        return [
            `h${level}`,
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setHeading: (attributes)=>({ commands: commands })=>{
                    if (!this.options.levels.includes(attributes.level)) return false;
                    return commands.setNode(this.name, attributes);
                },
            toggleHeading: (attributes)=>({ commands: commands })=>{
                    if (!this.options.levels.includes(attributes.level)) return false;
                    return commands.toggleNode(this.name, "paragraph", attributes);
                }
        };
    },
    addKeyboardShortcuts () {
        return this.options.levels.reduce((items, level)=>({
                ...items,
                [`Mod-Alt-${level}`]: ()=>this.editor.commands.toggleHeading({
                        level: level
                    })
            }), {});
    },
    addInputRules () {
        return this.options.levels.map((level)=>{
            return (0, $a769590142262cb7$export$cc081314d3f6ffb0)({
                find: new RegExp(`^(#{${Math.min(...this.options.levels)},${level}})\\s$`),
                type: this.type,
                getAttributes: {
                    level: level
                }
            });
        });
    }
});



// history/index.ts
var $7321d26f065e71ab$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $7321d26f065e71ab$var$RopeSequence = function RopeSequence() {};
$7321d26f065e71ab$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $7321d26f065e71ab$var$RopeSequence.from(other);
    return !this.length && other || other.length < $7321d26f065e71ab$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $7321d26f065e71ab$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$7321d26f065e71ab$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $7321d26f065e71ab$var$RopeSequence.from(other).append(this);
};
$7321d26f065e71ab$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $7321d26f065e71ab$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$7321d26f065e71ab$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $7321d26f065e71ab$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$7321d26f065e71ab$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$7321d26f065e71ab$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$7321d26f065e71ab$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$7321d26f065e71ab$var$RopeSequence.from = function from(values) {
    if (values instanceof $7321d26f065e71ab$var$RopeSequence) return values;
    return values && values.length ? new $7321d26f065e71ab$var$Leaf(values) : $7321d26f065e71ab$var$RopeSequence.empty;
};
var $7321d26f065e71ab$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $7321d26f065e71ab$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $7321d26f065e71ab$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($7321d26f065e71ab$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$7321d26f065e71ab$var$RopeSequence.empty = new $7321d26f065e71ab$var$Leaf([]);
var $7321d26f065e71ab$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($7321d26f065e71ab$var$RopeSequence);
var $7321d26f065e71ab$export$2e2bcd8739ae039 = $7321d26f065e71ab$var$RopeSequence;




// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $7cc46a4636bc8ff1$var$max_empty_items = 500;
class $7cc46a4636bc8ff1$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $7cc46a4636bc8ff1$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $7cc46a4636bc8ff1$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $7cc46a4636bc8ff1$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $7cc46a4636bc8ff1$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $7cc46a4636bc8ff1$var$DEPTH_OVERFLOW) {
            oldItems = $7cc46a4636bc8ff1$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $7cc46a4636bc8ff1$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $72a42b551bab6846$export$f5f785078011b62);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $7cc46a4636bc8ff1$var$Branch(this.items.append(array.map((map)=>new $7cc46a4636bc8ff1$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $7cc46a4636bc8ff1$var$Item(map, step, selection));
            } else rebasedItems.push(new $7cc46a4636bc8ff1$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $7cc46a4636bc8ff1$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $7cc46a4636bc8ff1$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $7cc46a4636bc8ff1$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $7cc46a4636bc8ff1$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $7cc46a4636bc8ff1$var$Branch((0, $7321d26f065e71ab$export$2e2bcd8739ae039).from(items.reverse()), events);
    }
}
$7cc46a4636bc8ff1$var$Branch.empty = new $7cc46a4636bc8ff1$var$Branch((0, $7321d26f065e71ab$export$2e2bcd8739ae039).empty, 0);
function $7cc46a4636bc8ff1$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $7cc46a4636bc8ff1$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $7cc46a4636bc8ff1$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $7cc46a4636bc8ff1$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $7cc46a4636bc8ff1$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $7cc46a4636bc8ff1$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($7cc46a4636bc8ff1$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($7cc46a4636bc8ff1$var$closeHistoryKey)) history = new $7cc46a4636bc8ff1$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($7cc46a4636bc8ff1$var$historyKey)) {
        if (appended.getMeta($7cc46a4636bc8ff1$var$historyKey).redo) return new $7cc46a4636bc8ff1$var$HistoryState(history.done.addTransform(tr, undefined, options, $7cc46a4636bc8ff1$var$mustPreserveItems(state)), history.undone, $7cc46a4636bc8ff1$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $7cc46a4636bc8ff1$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $7cc46a4636bc8ff1$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$7cc46a4636bc8ff1$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $7cc46a4636bc8ff1$var$mapRanges(history.prevRanges, tr.mapping) : $7cc46a4636bc8ff1$var$rangesFor(tr.mapping.maps);
        return new $7cc46a4636bc8ff1$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $7cc46a4636bc8ff1$var$mustPreserveItems(state)), $7cc46a4636bc8ff1$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $7cc46a4636bc8ff1$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $7cc46a4636bc8ff1$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $7cc46a4636bc8ff1$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $7cc46a4636bc8ff1$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $7cc46a4636bc8ff1$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $7cc46a4636bc8ff1$var$rangesFor(maps) {
    let result = [];
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $7cc46a4636bc8ff1$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $7cc46a4636bc8ff1$var$histTransaction(history, state, redo) {
    let preserveItems = $7cc46a4636bc8ff1$var$mustPreserveItems(state);
    let histOptions = $7cc46a4636bc8ff1$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $7cc46a4636bc8ff1$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($7cc46a4636bc8ff1$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $7cc46a4636bc8ff1$var$cachedPreserveItems = false, $7cc46a4636bc8ff1$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $7cc46a4636bc8ff1$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($7cc46a4636bc8ff1$var$cachedPreserveItemsPlugins != plugins) {
        $7cc46a4636bc8ff1$var$cachedPreserveItems = false;
        $7cc46a4636bc8ff1$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $7cc46a4636bc8ff1$var$cachedPreserveItems = true;
            break;
        }
    }
    return $7cc46a4636bc8ff1$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $7cc46a4636bc8ff1$export$181a649d919c589e(tr) {
    return tr.setMeta($7cc46a4636bc8ff1$var$closeHistoryKey, true);
}
const $7cc46a4636bc8ff1$var$historyKey = new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("history");
const $7cc46a4636bc8ff1$var$closeHistoryKey = new (0, $6acde7918354ce68$export$1692d8b0e89cecc3)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $7cc46a4636bc8ff1$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $6acde7918354ce68$export$901cf72dabf2112a)({
        key: $7cc46a4636bc8ff1$var$historyKey,
        state: {
            init () {
                return new $7cc46a4636bc8ff1$var$HistoryState($7cc46a4636bc8ff1$var$Branch.empty, $7cc46a4636bc8ff1$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $7cc46a4636bc8ff1$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $7cc46a4636bc8ff1$export$21f930c44940fd98 : inputType == "historyRedo" ? $7cc46a4636bc8ff1$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $7cc46a4636bc8ff1$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $7cc46a4636bc8ff1$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $7cc46a4636bc8ff1$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $7cc46a4636bc8ff1$export$21f930c44940fd98 = $7cc46a4636bc8ff1$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $7cc46a4636bc8ff1$export$1688e416fee0a49e = $7cc46a4636bc8ff1$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $7cc46a4636bc8ff1$export$24b5d280435f3a3f = $7cc46a4636bc8ff1$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $7cc46a4636bc8ff1$export$3774e54bae7be19b = $7cc46a4636bc8ff1$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $7cc46a4636bc8ff1$export$f8a176c2b9a10bdb(state) {
    let hist = $7cc46a4636bc8ff1$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $7cc46a4636bc8ff1$export$3ffe6b288e7d941b(state) {
    let hist = $7cc46a4636bc8ff1$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}




/**
 * This extension allows you to undo and redo recent changes.
 * @see https://www.tiptap.dev/api/extensions/history
 *
 * **Important**: If the `@tiptap/extension-collaboration` package is used, make sure to remove
 * the `history` extension, as it is not compatible with the `collaboration` extension.
 *
 * `@tiptap/extension-collaboration` uses its own history implementation.
 */ const $94231ab2f1d64f9e$export$84202caead5689ba = (0, $a769590142262cb7$export$eeddbf09bb970356).create({
    name: "history",
    addOptions () {
        return {
            depth: 100,
            newGroupDelay: 500
        };
    },
    addCommands () {
        return {
            undo: ()=>({ state: state, dispatch: dispatch })=>{
                    return (0, $7cc46a4636bc8ff1$export$21f930c44940fd98)(state, dispatch);
                },
            redo: ()=>({ state: state, dispatch: dispatch })=>{
                    return (0, $7cc46a4636bc8ff1$export$1688e416fee0a49e)(state, dispatch);
                }
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $7cc46a4636bc8ff1$export$55abd4691b317664)(this.options)
        ];
    },
    addKeyboardShortcuts () {
        return {
            "Mod-z": ()=>this.editor.commands.undo(),
            "Shift-Mod-z": ()=>this.editor.commands.redo(),
            "Mod-y": ()=>this.editor.commands.redo(),
            // Russian keyboard layouts
            "Mod-\u044F": ()=>this.editor.commands.undo(),
            "Shift-Mod-\u044F": ()=>this.editor.commands.redo()
        };
    }
});




/**
 * This extension allows you to insert horizontal rules.
 * @see https://www.tiptap.dev/api/nodes/horizontal-rule
 */ const $c2d26707810f0cda$export$841e9c95e6429474 = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "horizontalRule",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: "block",
    parseHTML () {
        return [
            {
                tag: "hr"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "hr",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },
    addCommands () {
        return {
            setHorizontalRule: ()=>({ chain: chain, state: state })=>{
                    const { selection: selection } = state;
                    const { $from: $originFrom, $to: $originTo } = selection;
                    const currentChain = chain();
                    if ($originFrom.parentOffset === 0) currentChain.insertContentAt({
                        from: Math.max($originFrom.pos - 1, 0),
                        to: $originTo.pos
                    }, {
                        type: this.name
                    });
                    else if ((0, $a769590142262cb7$export$a8c1d2c13abf8822)(selection)) currentChain.insertContentAt($originTo.pos, {
                        type: this.name
                    });
                    else currentChain.insertContent({
                        type: this.name
                    });
                    return currentChain// set cursor after horizontal rule
                    .command(({ tr: tr, dispatch: dispatch })=>{
                        var _a;
                        if (dispatch) {
                            const { $to: $to } = tr.selection;
                            const posAfter = $to.end();
                            if ($to.nodeAfter) {
                                if ($to.nodeAfter.isTextblock) tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(tr.doc, $to.pos + 1));
                                else if ($to.nodeAfter.isBlock) tr.setSelection((0, $6acde7918354ce68$export$e2940151ac854c0b).create(tr.doc, $to.pos));
                                else tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(tr.doc, $to.pos));
                            } else {
                                // add node after horizontal rule if it’s the end of the document
                                const node = (_a = $to.parent.type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.create();
                                if (node) {
                                    tr.insert(posAfter, node);
                                    tr.setSelection((0, $6acde7918354ce68$export$c2b25f346d19bcbb).create(tr.doc, posAfter + 1));
                                }
                            }
                            tr.scrollIntoView();
                        }
                        return true;
                    }).run();
                }
        };
    },
    addInputRules () {
        return [
            (0, $a769590142262cb7$export$6ca56856dfeaf9b6)({
                find: /^(?:---|—-|___\s|\*\*\*\s)$/,
                type: this.type
            })
        ];
    }
});



/**
 * Matches an italic to a *italic* on input.
 */ const $0926aa12e660727a$export$73ba4776eeca629e = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
/**
 * Matches an italic to a *italic* on paste.
 */ const $0926aa12e660727a$export$47b75d481b90409 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
/**
 * Matches an italic to a _italic_ on input.
 */ const $0926aa12e660727a$export$79cd1d2695dae26d = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
/**
 * Matches an italic to a _italic_ on paste.
 */ const $0926aa12e660727a$export$9b623891dbc7bd12 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
/**
 * This extension allows you to create italic text.
 * @see https://www.tiptap.dev/api/marks/italic
 */ const $0926aa12e660727a$export$1cfcf4275506b1c6 = (0, $a769590142262cb7$export$c9d15bcfc6d42044).create({
    name: "italic",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "em"
            },
            {
                tag: "i",
                getAttrs: (node)=>node.style.fontStyle !== "normal" && null
            },
            {
                style: "font-style=normal",
                clearMark: (mark)=>mark.type.name === this.name
            },
            {
                style: "font-style=italic"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "em",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setItalic: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleItalic: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetItalic: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-i": ()=>this.editor.commands.toggleItalic(),
            "Mod-I": ()=>this.editor.commands.toggleItalic()
        };
    },
    addInputRules () {
        return [
            (0, $a769590142262cb7$export$9f2cb743ab9131de)({
                find: $0926aa12e660727a$export$73ba4776eeca629e,
                type: this.type
            }),
            (0, $a769590142262cb7$export$9f2cb743ab9131de)({
                find: $0926aa12e660727a$export$79cd1d2695dae26d,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $a769590142262cb7$export$3845eb97abe74944)({
                find: $0926aa12e660727a$export$47b75d481b90409,
                type: this.type
            }),
            (0, $a769590142262cb7$export$3845eb97abe74944)({
                find: $0926aa12e660727a$export$9b623891dbc7bd12,
                type: this.type
            })
        ];
    }
});



/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $cce2688d86eac426$export$a7b06bfba60a8a78 = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "listItem",
    addOptions () {
        return {
            HTMLAttributes: {},
            bulletListTypeName: "bulletList",
            orderedListTypeName: "orderedList"
        };
    },
    content: "paragraph block*",
    defining: true,
    parseHTML () {
        return [
            {
                tag: "li"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "li",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addKeyboardShortcuts () {
        return {
            Enter: ()=>this.editor.commands.splitListItem(this.name),
            Tab: ()=>this.editor.commands.sinkListItem(this.name),
            "Shift-Tab": ()=>this.editor.commands.liftListItem(this.name)
        };
    }
});



const $476f43c401f003f4$var$ListItemName = "listItem";
const $476f43c401f003f4$var$TextStyleName = "textStyle";
/**
 * Matches an ordered list to a 1. on input (or any number followed by a dot).
 */ const $476f43c401f003f4$export$55b9391925fcc072 = /^(\d+)\.\s$/;
/**
 * This extension allows you to create ordered lists.
 * This requires the ListItem extension
 * @see https://www.tiptap.dev/api/nodes/ordered-list
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $476f43c401f003f4$export$547f885a1fca4e31 = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "orderedList",
    addOptions () {
        return {
            itemTypeName: "listItem",
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false
        };
    },
    group: "block list",
    content () {
        return `${this.options.itemTypeName}+`;
    },
    addAttributes () {
        return {
            start: {
                default: 1,
                parseHTML: (element)=>{
                    return element.hasAttribute("start") ? parseInt(element.getAttribute("start") || "", 10) : 1;
                }
            },
            type: {
                default: undefined,
                parseHTML: (element)=>element.getAttribute("type")
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: "ol"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        const { start: start, ...attributesWithoutStart } = HTMLAttributes;
        return start === 1 ? [
            "ol",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, attributesWithoutStart),
            0
        ] : [
            "ol",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            toggleOrderedList: ()=>({ commands: commands, chain: chain })=>{
                    if (this.options.keepAttributes) return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($476f43c401f003f4$var$ListItemName, this.editor.getAttributes($476f43c401f003f4$var$TextStyleName)).run();
                    return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-7": ()=>this.editor.commands.toggleOrderedList()
        };
    },
    addInputRules () {
        let inputRule = (0, $a769590142262cb7$export$f7316d89abe4e1c1)({
            find: $476f43c401f003f4$export$55b9391925fcc072,
            type: this.type,
            getAttributes: (match)=>({
                    start: +match[1]
                }),
            joinPredicate: (match, node)=>node.childCount + node.attrs.start === +match[1]
        });
        if (this.options.keepMarks || this.options.keepAttributes) inputRule = (0, $a769590142262cb7$export$f7316d89abe4e1c1)({
            find: $476f43c401f003f4$export$55b9391925fcc072,
            type: this.type,
            keepMarks: this.options.keepMarks,
            keepAttributes: this.options.keepAttributes,
            getAttributes: (match)=>({
                    start: +match[1],
                    ...this.editor.getAttributes($476f43c401f003f4$var$TextStyleName)
                }),
            joinPredicate: (match, node)=>node.childCount + node.attrs.start === +match[1],
            editor: this.editor
        });
        return [
            inputRule
        ];
    }
});



/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */ const $c86ec1f4040cea67$export$358a232cca1ab2ac = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "paragraph",
    priority: 1000,
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: "block",
    content: "inline*",
    parseHTML () {
        return [
            {
                tag: "p"
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "p",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setParagraph: ()=>({ commands: commands })=>{
                    return commands.setNode(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Alt-0": ()=>this.editor.commands.setParagraph()
        };
    }
});



/**
 * Matches a strike to a ~~strike~~ on input.
 */ const $e077259fea55b564$export$55b9391925fcc072 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/;
/**
 * Matches a strike to a ~~strike~~ on paste.
 */ const $e077259fea55b564$export$4ed30f8936af1979 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g;
/**
 * This extension allows you to create strike text.
 * @see https://www.tiptap.dev/api/marks/strike
 */ const $e077259fea55b564$export$97176b8d51d2058f = (0, $a769590142262cb7$export$c9d15bcfc6d42044).create({
    name: "strike",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "s"
            },
            {
                tag: "del"
            },
            {
                tag: "strike"
            },
            {
                style: "text-decoration",
                consuming: false,
                getAttrs: (style)=>style.includes("line-through") ? {} : false
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            "s",
            (0, $a769590142262cb7$export$9f98db6234c4bd78)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setStrike: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleStrike: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetStrike: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-s": ()=>this.editor.commands.toggleStrike()
        };
    },
    addInputRules () {
        return [
            (0, $a769590142262cb7$export$9f2cb743ab9131de)({
                find: $e077259fea55b564$export$55b9391925fcc072,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $a769590142262cb7$export$3845eb97abe74944)({
                find: $e077259fea55b564$export$4ed30f8936af1979,
                type: this.type
            })
        ];
    }
});



/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */ const $00bb7bb65f959e5b$export$5f1af8db9871e1d6 = (0, $a769590142262cb7$export$85c928794f8d04d4).create({
    name: "text",
    group: "inline"
});


/**
 * The starter kit is a collection of essential editor extensions.
 *
 * It’s a good starting point for building your own editor.
 */ const $408286db115d2e82$export$626064c5f1b71dc = (0, $a769590142262cb7$export$eeddbf09bb970356).create({
    name: "starterKit",
    addExtensions () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        const extensions = [];
        if (this.options.bold !== false) extensions.push((0, $783f15b16d4a7ba3$export$95aa4184327d6b72).configure((_a = this.options) === null || _a === void 0 ? void 0 : _a.bold));
        if (this.options.blockquote !== false) extensions.push((0, $99f8c21878abcea7$export$29a7a275fe11687).configure((_b = this.options) === null || _b === void 0 ? void 0 : _b.blockquote));
        if (this.options.bulletList !== false) extensions.push((0, $eeb2760fec8bea2a$export$546f606c73d35982).configure((_c = this.options) === null || _c === void 0 ? void 0 : _c.bulletList));
        if (this.options.code !== false) extensions.push((0, $9b98815fd2b6868a$export$52f0f02147b12c03).configure((_d = this.options) === null || _d === void 0 ? void 0 : _d.code));
        if (this.options.codeBlock !== false) extensions.push((0, $768a276f4d2bdd50$export$6c415d1fdae3dfdb).configure((_e = this.options) === null || _e === void 0 ? void 0 : _e.codeBlock));
        if (this.options.document !== false) extensions.push((0, $af9b5b8774c8f755$export$b34a105447964f9f).configure((_f = this.options) === null || _f === void 0 ? void 0 : _f.document));
        if (this.options.dropcursor !== false) extensions.push((0, $c93a7a36afed34cc$export$bc16731f26f3900d).configure((_g = this.options) === null || _g === void 0 ? void 0 : _g.dropcursor));
        if (this.options.gapcursor !== false) extensions.push((0, $107135f049e644a6$export$79c3dcaa03287f63).configure((_h = this.options) === null || _h === void 0 ? void 0 : _h.gapcursor));
        if (this.options.hardBreak !== false) extensions.push((0, $9da270bd9990040c$export$d3d3fac13fa635d9).configure((_j = this.options) === null || _j === void 0 ? void 0 : _j.hardBreak));
        if (this.options.heading !== false) extensions.push((0, $1031752c5dbdbe19$export$a8a3e93435678ff9).configure((_k = this.options) === null || _k === void 0 ? void 0 : _k.heading));
        if (this.options.history !== false) extensions.push((0, $94231ab2f1d64f9e$export$84202caead5689ba).configure((_l = this.options) === null || _l === void 0 ? void 0 : _l.history));
        if (this.options.horizontalRule !== false) extensions.push((0, $c2d26707810f0cda$export$841e9c95e6429474).configure((_m = this.options) === null || _m === void 0 ? void 0 : _m.horizontalRule));
        if (this.options.italic !== false) extensions.push((0, $0926aa12e660727a$export$1cfcf4275506b1c6).configure((_o = this.options) === null || _o === void 0 ? void 0 : _o.italic));
        if (this.options.listItem !== false) extensions.push((0, $cce2688d86eac426$export$a7b06bfba60a8a78).configure((_p = this.options) === null || _p === void 0 ? void 0 : _p.listItem));
        if (this.options.orderedList !== false) extensions.push((0, $476f43c401f003f4$export$547f885a1fca4e31).configure((_q = this.options) === null || _q === void 0 ? void 0 : _q.orderedList));
        if (this.options.paragraph !== false) extensions.push((0, $c86ec1f4040cea67$export$358a232cca1ab2ac).configure((_r = this.options) === null || _r === void 0 ? void 0 : _r.paragraph));
        if (this.options.strike !== false) extensions.push((0, $e077259fea55b564$export$97176b8d51d2058f).configure((_s = this.options) === null || _s === void 0 ? void 0 : _s.strike));
        if (this.options.text !== false) extensions.push((0, $00bb7bb65f959e5b$export$5f1af8db9871e1d6).configure((_t = this.options) === null || _t === void 0 ? void 0 : _t.text));
        return extensions;
    }
});



/**
 * This extension allows you to align text.
 * @see https://www.tiptap.dev/api/extensions/text-align
 */ const $1ef77c37bab21197$export$3720eb13f948f394 = (0, $a769590142262cb7$export$eeddbf09bb970356).create({
    name: "textAlign",
    addOptions () {
        return {
            types: [],
            alignments: [
                "left",
                "center",
                "right",
                "justify"
            ],
            defaultAlignment: null
        };
    },
    addGlobalAttributes () {
        return [
            {
                types: this.options.types,
                attributes: {
                    textAlign: {
                        default: this.options.defaultAlignment,
                        parseHTML: (element)=>{
                            const alignment = element.style.textAlign;
                            return this.options.alignments.includes(alignment) ? alignment : this.options.defaultAlignment;
                        },
                        renderHTML: (attributes)=>{
                            if (!attributes.textAlign) return {};
                            return {
                                style: `text-align: ${attributes.textAlign}`
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands () {
        return {
            setTextAlign: (alignment)=>({ commands: commands })=>{
                    if (!this.options.alignments.includes(alignment)) return false;
                    return this.options.types.map((type)=>commands.updateAttributes(type, {
                            textAlign: alignment
                        })).every((response)=>response);
                },
            unsetTextAlign: ()=>({ commands: commands })=>{
                    return this.options.types.map((type)=>commands.resetAttributes(type, "textAlign")).every((response)=>response);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            "Mod-Shift-l": ()=>this.editor.commands.setTextAlign("left"),
            "Mod-Shift-e": ()=>this.editor.commands.setTextAlign("center"),
            "Mod-Shift-r": ()=>this.editor.commands.setTextAlign("right"),
            "Mod-Shift-j": ()=>this.editor.commands.setTextAlign("justify")
        };
    }
});



var $aSiaI = parcelRequire("aSiaI");

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1ed5a61980249929$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("AlignCenter", [
    [
        "line",
        {
            x1: "21",
            x2: "3",
            y1: "6",
            y2: "6",
            key: "1fp77t"
        }
    ],
    [
        "line",
        {
            x1: "17",
            x2: "7",
            y1: "12",
            y2: "12",
            key: "rsh8ii"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "5",
            y1: "18",
            y2: "18",
            key: "1t0tuv"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6476083d3d48e1b8$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("AlignLeft", [
    [
        "line",
        {
            x1: "21",
            x2: "3",
            y1: "6",
            y2: "6",
            key: "1fp77t"
        }
    ],
    [
        "line",
        {
            x1: "15",
            x2: "3",
            y1: "12",
            y2: "12",
            key: "v6grx8"
        }
    ],
    [
        "line",
        {
            x1: "17",
            x2: "3",
            y1: "18",
            y2: "18",
            key: "1awlsn"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6c96ed879bcb0f5$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("AlignRight", [
    [
        "line",
        {
            x1: "21",
            x2: "3",
            y1: "6",
            y2: "6",
            key: "1fp77t"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "9",
            y1: "12",
            y2: "12",
            key: "1uyos4"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "7",
            y1: "18",
            y2: "18",
            key: "1g9eri"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1388655a94bd3520$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Bold", [
    [
        "path",
        {
            d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8",
            key: "mg9rjx"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $73d81b595cd1f442$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Code", [
    [
        "polyline",
        {
            points: "16 18 22 12 16 6",
            key: "z7tu5w"
        }
    ],
    [
        "polyline",
        {
            points: "8 6 2 12 8 18",
            key: "1eg1df"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4feebfced5aa97f2$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Heading1", [
    [
        "path",
        {
            d: "M4 12h8",
            key: "17cfdx"
        }
    ],
    [
        "path",
        {
            d: "M4 18V6",
            key: "1rz3zl"
        }
    ],
    [
        "path",
        {
            d: "M12 18V6",
            key: "zqpxq5"
        }
    ],
    [
        "path",
        {
            d: "m17 12 3-2v8",
            key: "1hhhft"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c12cbe3e1ef1ac7e$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Heading2", [
    [
        "path",
        {
            d: "M4 12h8",
            key: "17cfdx"
        }
    ],
    [
        "path",
        {
            d: "M4 18V6",
            key: "1rz3zl"
        }
    ],
    [
        "path",
        {
            d: "M12 18V6",
            key: "zqpxq5"
        }
    ],
    [
        "path",
        {
            d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1",
            key: "9jr5yi"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bfd44df6c9ded000$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Heading3", [
    [
        "path",
        {
            d: "M4 12h8",
            key: "17cfdx"
        }
    ],
    [
        "path",
        {
            d: "M4 18V6",
            key: "1rz3zl"
        }
    ],
    [
        "path",
        {
            d: "M12 18V6",
            key: "zqpxq5"
        }
    ],
    [
        "path",
        {
            d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2",
            key: "68ncm8"
        }
    ],
    [
        "path",
        {
            d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2",
            key: "1ejuhz"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f69c0cd49f90a9d2$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Heading4", [
    [
        "path",
        {
            d: "M4 12h8",
            key: "17cfdx"
        }
    ],
    [
        "path",
        {
            d: "M4 18V6",
            key: "1rz3zl"
        }
    ],
    [
        "path",
        {
            d: "M12 18V6",
            key: "zqpxq5"
        }
    ],
    [
        "path",
        {
            d: "M17 10v4h4",
            key: "13sv97"
        }
    ],
    [
        "path",
        {
            d: "M21 10v8",
            key: "1kdml4"
        }
    ]
]);

/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6213a4cc429b6c01$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Italic", [
    [
        "line",
        {
            x1: "19",
            x2: "10",
            y1: "4",
            y2: "4",
            key: "15jd3p"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "5",
            y1: "20",
            y2: "20",
            key: "bu0au3"
        }
    ],
    [
        "line",
        {
            x1: "15",
            x2: "9",
            y1: "4",
            y2: "20",
            key: "uljnxc"
        }
    ]
]);



const $68483afb9e9204da$var$CHARACTER_LIMIT = 2000;
const $68483afb9e9204da$var$EditorToolbar = ({ editor: editor })=>{
    const editorState = (0, $eca5d11c6814a94c$export$e6e340c65601d57b)({
        editor: editor,
        selector: ({ editor: editor })=>({
                isBold: editor.isActive("bold"),
                isItalic: editor.isActive("italic"),
                isCode: editor.isActive("codeBlock"),
                alignment: editor.getAttributes("paragraph").textAlign || "left",
                characterCount: editor.getText().length,
                heading: {
                    1: editor.isActive("heading", {
                        level: 1
                    }),
                    2: editor.isActive("heading", {
                        level: 2
                    }),
                    3: editor.isActive("heading", {
                        level: 3
                    }),
                    4: editor.isActive("heading", {
                        level: 4
                    })
                }
            })
    });
    const { isBold: isBold, isItalic: isItalic, isCode: isCode, alignment: alignment, characterCount: characterCount, heading: heading } = editorState;
    const buttonClass = (isActive)=>(0, $c93813fc9a74a923$export$1343a74baacb0543)("h-8 w-8 p-0 border border-primaryContainer group transition-colors shadow-none inline-flex items-center justify-center whitespace-nowrap shadow-md rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", isActive ? "bg-primary text-white" : "hover:bg-primary hover:text-white text-onSurfaceVariant");
    const handleAlignment = (align)=>{
        if (alignment === align) editor.chain().focus().setTextAlign("left").run();
        else editor.chain().focus().setTextAlign(align).run();
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "border-b bg-background px-4 py-2 flex justify-between items-center shrink-0",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center gap-1 overflow-x-auto",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                onClick: ()=>editor.chain().focus().toggleBold().run(),
                                disabled: !editor.can().chain().focus().toggleBold().run(),
                                className: buttonClass(isBold),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1388655a94bd3520$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                onClick: ()=>editor.chain().focus().toggleItalic().run(),
                                disabled: !editor.can().chain().focus().toggleItalic().run(),
                                className: buttonClass(isItalic),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6213a4cc429b6c01$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "w-px h-6 bg-border mx-2"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            1,
                            2,
                            3,
                            4
                        ].map((level)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                onClick: ()=>editor.chain().focus().toggleHeading({
                                        level: level
                                    }).run(),
                                className: buttonClass(heading[level]),
                                children: [
                                    level === 1 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4feebfced5aa97f2$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    level === 2 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c12cbe3e1ef1ac7e$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    level === 3 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bfd44df6c9ded000$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    }),
                                    level === 4 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f69c0cd49f90a9d2$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4"
                                    })
                                ]
                            }, level))
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "w-px h-6 bg-border mx-2"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                onClick: ()=>handleAlignment("left"),
                                className: buttonClass(alignment === "left" || !alignment),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6476083d3d48e1b8$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                onClick: ()=>handleAlignment("center"),
                                className: buttonClass(alignment === "center"),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1ed5a61980249929$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                onClick: ()=>handleAlignment("right"),
                                className: buttonClass(alignment === "right"),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c6c96ed879bcb0f5$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "w-px h-6 bg-border mx-2"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex items-center gap-1",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                            onClick: ()=>editor.chain().focus().toggleCodeBlock().run(),
                            className: buttonClass(isCode),
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $73d81b595cd1f442$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("text-sm", characterCount > $68483afb9e9204da$var$CHARACTER_LIMIT ? "text-destructive" : "text-muted-foreground"),
                children: [
                    characterCount,
                    "/",
                    $68483afb9e9204da$var$CHARACTER_LIMIT
                ]
            })
        ]
    });
};
var $68483afb9e9204da$export$2e2bcd8739ae039 = $68483afb9e9204da$var$EditorToolbar;



var $exYeM = parcelRequire("exYeM");
const $382959215f1093da$var$TiptapEditor = ({ content: content = "", onUpdate: onUpdate, editable: editable = true, children: children })=>{
    const editor = (0, $eca5d11c6814a94c$export$43711a1418203bbc)({
        extensions: [
            (0, $408286db115d2e82$export$626064c5f1b71dc).configure({
                history: editable
            }),
            (0, $1ef77c37bab21197$export$3720eb13f948f394).configure({
                types: [
                    "heading",
                    "paragraph"
                ],
                defaultAlignment: "left"
            })
        ],
        content: content,
        editable: editable,
        autofocus: editable ? "end" : false,
        onUpdate: ({ editor: editor })=>{
            const htmlContent = editor.getHTML();
            const textContent = editor.getText();
            if (textContent.length <= 2000) onUpdate?.(htmlContent);
            else editor.commands.undo();
        }
    });
    (0, $exYeM.useEffect)(()=>{
        if (editor && editable) editor.commands.focus("end");
    }, [
        editor,
        editable
    ]);
    if (!editor) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col h-full",
        children: [
            editable && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $68483afb9e9204da$export$2e2bcd8739ae039), {
                editor: editor
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex-1 min-h-0 overflow-y-auto relative",
                onClick: ()=>{
                    if (editable && editor) editor.commands.focus("end");
                },
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $eca5d11c6814a94c$export$a92c4e92ed722350), {
                        editor: editor,
                        className: "h-full prose prose-sm max-w-none px-4 py-2"
                    }),
                    editable && !editor.getText() && /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none",
                        children: "Click anywhere to start typing..."
                    })
                ]
            }),
            children
        ]
    });
};
var $382959215f1093da$export$2e2bcd8739ae039 = $382959215f1093da$var$TiptapEditor;


const $b44f6599576b6fa9$var$TextRenderer = ({ content: content })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $382959215f1093da$export$2e2bcd8739ae039), {
        content: content,
        editable: false
    });
};
var $b44f6599576b6fa9$export$2e2bcd8739ae039 = $b44f6599576b6fa9$var$TextRenderer;


const $47bf2435abbfb6af$var$WidgetRenderer = ({ type: type, props: props })=>{
    console.log("WidgetRenderer rendering:", {
        type: type,
        props: props
    });
    switch(type){
        case "Chart":
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f73e36e22e7b8c56$export$2e2bcd8739ae039), {
                charts: props
            });
        case "Text":
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b44f6599576b6fa9$export$2e2bcd8739ae039), {
                content: props?.content || ""
            }, props?.lastModified);
        case "Small":
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $eeb626020a7cdb2a$export$2e2bcd8739ae039), {});
        case "News":
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8ab4350084cc7af2$export$2e2bcd8739ae039), {
                title: props?.title ?? "",
                link: props?.link ?? "#",
                author: props?.author ?? "",
                published: props?.published ?? Date.now(),
                image: props?.media_content ?? []
            });
        case "Value":
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $95d1818c85576eb0$export$2e2bcd8739ae039), {
                name: props?.name ?? "Value",
                prefix: props?.prefix ?? "$",
                decimals: props?.decimals ?? 2,
                value: props?.value ?? 0
            });
        default:
            return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                children: [
                    "Unsupported widget type: ",
                    type
                ]
            });
    }
};
var $47bf2435abbfb6af$export$2e2bcd8739ae039 = $47bf2435abbfb6af$var$WidgetRenderer;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


const $a7807e464dff963c$export$3b9b930cb69175e4 = {
    HOME: "HOME",
    CHART: "CHART",
    FOOTPRINT: "FOOTPRINT",
    QUERY: "QUERY",
    DISCOVER: "DISCOVER",
    TEXT: "TEXT",
    TABLE: "TABLE"
};
const $a7807e464dff963c$export$c9be54d483513c16 = (0, $405a4fa4811a9356$exports.create)((set, get)=>({
        // State
        active: 0,
        outgoing: null,
        currentType: null,
        isEditing: false,
        editData: null,
        // Actions
        initialize: (type, isEditing, initialData)=>{
            const currentState = get();
            console.log("Initializing dialog:", {
                type: type,
                isEditing: isEditing,
                initialData: initialData,
                currentState: currentState
            });
            set({
                isEditing: isEditing,
                editData: initialData,
                currentType: type
            });
        },
        goHome: ()=>{
            console.log("Going home from:", get());
            set({
                active: 0,
                outgoing: get().active,
                currentType: null,
                isEditing: false,
                editData: null
            });
        },
        navTo: (current, target, type = null)=>{
            console.log("Navigating:", {
                from: current,
                to: target,
                type: type
            });
            // Validate the navigation
            if (target < 0) {
                console.warn("Invalid navigation target:", target);
                return;
            }
            set({
                active: target,
                outgoing: current,
                currentType: type || get().currentType
            });
        },
        startEdit: (widgetType, data)=>{
            console.log("Starting edit:", {
                widgetType: widgetType,
                data: data
            });
            set({
                isEditing: true,
                editData: data,
                currentType: widgetType
            });
        },
        endEdit: ()=>{
            console.log("Ending edit");
            set({
                isEditing: false,
                editData: null
            });
        },
        reset: ()=>{
            console.log("Resetting dialog state");
            set({
                active: 0,
                outgoing: null,
                currentType: null,
                isEditing: false,
                editData: null
            });
        }
    }));
const $a7807e464dff963c$export$1a2679386ce35b71 = ()=>{
    const { active: active, navTo: navTo, currentType: currentType } = $a7807e464dff963c$export$c9be54d483513c16();
    return {
        navigateToType: (type)=>{
            const currentActive = active;
            const targetIndex = $a7807e464dff963c$var$getIndexForType(type);
            if (targetIndex !== undefined) navTo(currentActive, targetIndex, type);
        }
    };
};
// Helper function to get index for a dialog type
const $a7807e464dff963c$var$getIndexForType = (type)=>{
    const typeToIndex = {
        [$a7807e464dff963c$export$3b9b930cb69175e4.HOME]: 0,
        [$a7807e464dff963c$export$3b9b930cb69175e4.CHART]: 1,
        [$a7807e464dff963c$export$3b9b930cb69175e4.FOOTPRINT]: 2,
        [$a7807e464dff963c$export$3b9b930cb69175e4.QUERY]: 3,
        [$a7807e464dff963c$export$3b9b930cb69175e4.DISCOVER]: 4,
        [$a7807e464dff963c$export$3b9b930cb69175e4.TEXT]: 5,
        [$a7807e464dff963c$export$3b9b930cb69175e4.TABLE]: 6
    };
    return typeToIndex[type];
};



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $553755fe3dd64245$var$DocumentMagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
    }));
}
const $553755fe3dd64245$var$ForwardRef = $exYeM.forwardRef($553755fe3dd64245$var$DocumentMagnifyingGlassIcon);
var $553755fe3dd64245$export$2e2bcd8739ae039 = $553755fe3dd64245$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $895e85f5bb6c3002$var$HandRaisedIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.05 4.575a1.575 1.575 0 10-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 013.15 0v1.5m-3.15 0l.075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 013.15 0V15M6.9 7.575a1.575 1.575 0 10-3.15 0v8.175a6.75 6.75 0 006.75 6.75h2.018a5.25 5.25 0 003.712-1.538l1.732-1.732a5.25 5.25 0 001.538-3.712l.003-2.024a.668.668 0 01.198-.471 1.575 1.575 0 10-2.228-2.228 3.818 3.818 0 00-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0116.35 15m.002 0h-.002"
    }));
}
const $895e85f5bb6c3002$var$ForwardRef = $exYeM.forwardRef($895e85f5bb6c3002$var$HandRaisedIcon);
var $895e85f5bb6c3002$export$2e2bcd8739ae039 = $895e85f5bb6c3002$var$ForwardRef;


var $exYeM = parcelRequire("exYeM");
function $fced08d021bf87ca$var$NewspaperIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $exYeM.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $exYeM.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $exYeM.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z"
    }));
}
const $fced08d021bf87ca$var$ForwardRef = $exYeM.forwardRef($fced08d021bf87ca$var$NewspaperIcon);
var $fced08d021bf87ca$export$2e2bcd8739ae039 = $fced08d021bf87ca$var$ForwardRef;



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

const $ddfc38e48e55a0c2$export$60332b2344f7fe41 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, disabled: disabled, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("bg-surfaceVariant p-10 flex items-center shadow-md justify-center border border-secondary rounded-md transform transition duration-300 flex-col gap-6 font-semibold text-4xl text-gray-900", !disabled && "group hover:bg-primary hover:text-white", className),
        ...props
    }));
$ddfc38e48e55a0c2$export$60332b2344f7fe41.displayName = "Card";





var $aSiaI = parcelRequire("aSiaI");

const $1bc9e71a93ef6378$var$DialogHeader = ({ title: title, onBack: onBack, editMode: editMode = false })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        onClick: !editMode ? onBack : undefined,
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("border-b py-3 text-gray-800 flex justify-between px-2 w-full", !editMode && "group hover:text-primary transition-colors cursor-pointer"),
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "font-semibold text-xl",
            children: title
        })
    });
};
var $1bc9e71a93ef6378$export$2e2bcd8739ae039 = $1bc9e71a93ef6378$var$DialogHeader;


function $f65147e9cc20f47b$export$2e2bcd8739ae039() {
    const navTo = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.navTo);
    const widgetTypes = [
        {
            name: "Chart",
            icon: (0, $53aad749a76f9885$export$2e2bcd8739ae039),
            onClick: ()=>navTo(0, 1),
            available: true
        },
        {
            name: "Text",
            icon: (0, $0fe5374000de6f08$export$2e2bcd8739ae039),
            onClick: ()=>navTo(0, 5),
            available: true
        },
        {
            name: "Footprint",
            icon: (0, $895e85f5bb6c3002$export$2e2bcd8739ae039),
            onClick: ()=>navTo(0, 2),
            available: false
        },
        {
            name: "Query",
            icon: (0, $553755fe3dd64245$export$2e2bcd8739ae039),
            onClick: ()=>navTo(0, 3),
            available: false
        },
        {
            name: "Discover",
            icon: (0, $fced08d021bf87ca$export$2e2bcd8739ae039),
            onClick: ()=>navTo(0, 4),
            available: false
        },
        {
            name: "Table",
            icon: (0, $72e41299ffd4f5c0$export$2e2bcd8739ae039),
            onClick: ()=>navTo(0, 6),
            available: false
        }
    ];
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "w-full h-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1bc9e71a93ef6378$export$2e2bcd8739ae039), {
                title: "Widgets",
                editMode: true
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "grid grid-cols-3 grid-flow-row gap-6 p-6",
                children: widgetTypes.map((widget, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$f78649fb9ca566b8), {
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2c3dff1bb294f275$export$28c660c63b792dea), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$8c610744efcf8a1d), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                            onClick: widget.available ? widget.onClick : undefined,
                                            className: `w-full focus:outline-none ${!widget.available && "cursor-not-allowed"}`,
                                            disabled: !widget.available,
                                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $ddfc38e48e55a0c2$export$60332b2344f7fe41), {
                                                className: !widget.available ? "opacity-50" : "",
                                                disabled: !widget.available,
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)(widget.icon, {
                                                        className: `h-24 w-24 ${widget.available ? "text-onSurfaceVariant group-hover:text-white" : "text-gray-400"}`
                                                    }),
                                                    widget.name,
                                                    !widget.available && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: "absolute top-2 right-2 text-xs font-medium text-gray-500",
                                                        children: "Coming Soon"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$e9003e2be37ec060), {
                                    children: widget.available ? `Add ${widget.name} widget` : `${widget.name} widget coming soon`
                                })
                            ]
                        })
                    }, widget.name))
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

// Created by James Launder inspired by tailwind ui
// combo with picture

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


function $4a707a95e28c6b48$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $4a707a95e28c6b48$export$2e2bcd8739ae039(props) {
    const [query, setQuery] = (0, $exYeM.useState)("");
    const filteredData = query === "" ? props?.data : props?.data.filter((person)=>{
        return person.name.toLowerCase().includes(query.toLowerCase());
    });
    const handleChange = (e)=>{
        console.log(e);
        props.setSelected(e);
        props.fn(props.id, props.name, e);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e), {
        value: props.selected,
        onChange: handleChange,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Label, {
                className: "block text-sm font-medium leading-6 text-gray-900",
                children: props.title
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative mt-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Input, {
                        className: "w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 focus:border-primary focus:outline-none",
                        onChange: (event)=>setQuery(event.target.value),
                        displayValue: (person)=>person?.name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Button, {
                        className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none ",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $96abd6aa52cc9bd1$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                        })
                    }),
                    filteredData?.length > 0 && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Options, {
                        className: "absolute z-30 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                        children: filteredData.map((person, idx)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2caaeccb6882c8ed$export$27957ad87354dd7e).Option, {
                                value: person,
                                className: ({ active: active })=>$4a707a95e28c6b48$var$classNames("relative cursor-default select-none py-2 pl-3 pr-9 ", active ? "bg-primary text-white group" : "text-gray-900"),
                                children: ({ active: active, selected: selected })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                className: "flex items-center ",
                                                children: [
                                                    person.icon ? /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                        src: "https://api.wevr.ai/V2/" + person.icon,
                                                        alt: "",
                                                        className: "h-6 w-6 flex-shrink-0 rounded-full"
                                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                        children: person.iconLocal ? person.iconLocal : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {})
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: $4a707a95e28c6b48$var$classNames("ml-3 truncate", selected && "font-semibold"),
                                                        children: person.name
                                                    })
                                                ]
                                            }),
                                            selected && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: $4a707a95e28c6b48$var$classNames("absolute inset-y-0 right-0 flex items-center pr-4", active ? "text-white" : "text-primary"),
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ad110a4e18e6d96b$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    })
                            }, person._id ? person._id : person.DataID ? person.DataID : idx))
                    })
                ]
            })
        ]
    });
}





function $5f7183950f5888ca$export$2e2bcd8739ae039(selected) {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const { isLoading: isLoading, data: data } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "Compare-blockchains"
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/blockchains")
    });
    //   const blockchain = data?.blockchain;
    const current = data?.blockchain?.find((o)=>o.name === searchParams.get("blockchain"));
    // query for the different charts
    const { isLoading: chartsLoading, isFetching: chartsFetching, data: charts } = (0, $9bc35366a9d51f8d$export$dd0a697e1782aedd)({
        queryKey: [
            "charts" + selected
        ],
        queryFn: ()=>(0, $ca6473885cd32228$export$2e2bcd8739ae039).get("/stores/" + selected),
        enabled: !!data && selected != null
    });
    return {
        blockchains: data,
        blockchainsLoading: isLoading,
        charts: charts,
        chartsLoading: chartsLoading,
        chartsFetching: chartsFetching,
        selectedBlockchain: current
    };
}







const $259a4aee18dc5bdc$var$style = [
    {
        name: "Line",
        data: "line"
    },
    {
        name: "Bar",
        data: "column"
    },
    {
        name: "Spline",
        data: "spline"
    },
    {
        name: "Area",
        data: "area"
    },
    {
        name: "Scatter",
        data: "scatter"
    }
];
function $259a4aee18dc5bdc$export$2e2bcd8739ae039({ id: id, charts: charts, setCharts: setCharts, active: active, setActive: setActive, index: index, onRemove: onRemove }) {
    const { userData: userData } = (0, $exYeM.useContext)((0, $d48470880d35c8fc$export$38ee920e59704589));
    const chart = charts.find((chart)=>chart.id === id);
    const [selectedBlockchain, setSelectedBlockchain] = (0, $exYeM.useState)(chart?.blockchain || null);
    const [selectedChart, setSelectedChart] = (0, $exYeM.useState)(chart?.name || null);
    const [selectedResolution, setSelectedResolution] = (0, $exYeM.useState)(chart?.resolution || null);
    const [selectedSource, setSelectedSource] = (0, $exYeM.useState)(chart?.source || null);
    const [selectedStyle, setSelectedStyle] = (0, $exYeM.useState)(chart?.style || null);
    const [selectedColour, setSelectedColour] = (0, $exYeM.useState)(chart?.colour || "#FA9173");
    const [header, setHeader] = (0, $exYeM.useState)(`${chart?.blockchain?.name} - ${chart?.name?.name}` || "Waiting...");
    const { blockchains: blockchains, blockchainsLoading: isLoading, charts: names, chartsLoading: chartsLoading, chartsFetching: chartsFetching } = (0, $5f7183950f5888ca$export$2e2bcd8739ae039)(selectedBlockchain?.name);
    const updateFieldById = (id, fieldName, newValue)=>{
        // console.log("Updating chart field:", {
        //   id,
        //   fieldName,
        //   newValue: JSON.parse(JSON.stringify(newValue)),
        // });
        setCharts((prevData)=>{
            const updatedData = prevData.map((item)=>{
                if (item.id === id) return {
                    ...item,
                    [fieldName]: newValue
                };
                return item;
            });
            // console.log(
            //   "Updated charts array:",
            //   JSON.parse(JSON.stringify(updatedData))
            // );
            return updatedData;
        });
    };
    function checkTier(res) {
        switch(userData.tier){
            case 0:
                if (res === "Day") return false;
                return true;
            case 1:
                if (res === "Block" || res === "Min") return true;
                return false;
            default:
                return false;
        }
    }
    // useEffect to update the chart data when selections change
    (0, $exYeM.useEffect)(()=>{
        updateFieldById(id, "blockchain", selectedBlockchain);
        updateFieldById(id, "name", selectedChart);
        updateFieldById(id, "resolution", selectedResolution);
        updateFieldById(id, "source", selectedSource);
        updateFieldById(id, "style", selectedStyle);
        updateFieldById(id, "colour", selectedColour);
    }, [
        selectedBlockchain,
        selectedChart,
        selectedResolution,
        selectedSource,
        selectedStyle,
        selectedColour
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (selectedChart !== null && selectedBlockchain !== null) {
            const chart = charts.filter((chart)=>chart.id === id)[0];
            setHeader(`${chart?.blockchain?.name} - ${chart?.name?.name}`);
        }
    }, [
        selectedBlockchain,
        selectedChart,
        selectedResolution
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-full relative z-10",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                onClick: ()=>setActive(id),
                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)(active != id ? "h-8" : "h-0", "overflow-hidden flex w-full items-center justify-between"),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex items-center gap-2",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                            className: "text-lg",
                            children: header
                        })
                    }),
                    onRemove && /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        onClick: (e)=>{
                            e.stopPropagation();
                            onRemove();
                        },
                        className: "p-1 group",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fe24332445e161c9$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 text-gray-300 group-hover:text-rose-400"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    children: "Loading..."
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4a707a95e28c6b48$export$2e2bcd8739ae039), {
                    title: "Blockchain",
                    data: blockchains?.data?.blockchain,
                    selected: selectedBlockchain,
                    setSelected: setSelectedBlockchain,
                    name: "blockchain",
                    fn: updateFieldById,
                    id: id
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex flex-col mt-4",
                children: selectedBlockchain?.name === "None" || selectedBlockchain === null ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block text-sm font-medium leading-6 text-gray-900",
                            children: "Charts"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "truncate",
                            children: "Select A Blockchain..."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    children: chartsFetching || chartsLoading ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "block text-sm font-medium leading-6 text-gray-900",
                                children: "Charts"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "truncate",
                                children: "Loading..."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4a707a95e28c6b48$export$2e2bcd8739ae039), {
                        title: "Charts",
                        data: names?.data?.graphNames,
                        selected: selectedChart,
                        setSelected: setSelectedChart,
                        name: "name",
                        fn: updateFieldById,
                        id: id
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex flex-col mt-4",
                children: selectedChart === null ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "block text-sm font-medium leading-6 text-gray-900",
                            children: "Source"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "truncate",
                            children: "Select A Chart..."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    children: Array.isArray(selectedChart.sources) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4a707a95e28c6b48$export$2e2bcd8739ae039), {
                        title: "Source",
                        data: selectedChart.sources,
                        selected: selectedSource,
                        setSelected: setSelectedSource,
                        name: "source",
                        fn: updateFieldById,
                        id: id
                    }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "block text-sm font-medium leading-6 text-gray-900",
                                children: "Source"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "truncate",
                                children: selectedChart.dataSource
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                        className: "block text-sm font-medium leading-6 text-gray-900",
                        children: "Resolution"
                    }),
                    selectedChart === null ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "mt-2 h-[40px]",
                        children: "Select A Chart..."
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            className: "grid grid-flow-col rounded-lg bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 mt-2",
                            children: selectedChart.resolution?.map((data)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>{
                                                setSelectedResolution(data);
                                                updateFieldById(id, "resolution", data);
                                            },
                                            disabled: checkTier(data),
                                            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)(checkTier(data) ? "text-gray-300" : selectedResolution === data && !checkTier(data) ? "bg-primary text-white text-bold" : "text-gray-900 hover:bg-primary/30 hover:text-gray-900", "rounded-lg py-1.5 text-gray-900", "res-select-" + data),
                                            children: data
                                        }, data + " combo"),
                                        checkTier(data) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6569f55e54f7ff9d$export$28c660c63b792dea), {
                                            anchorSelect: ".res-select-" + data,
                                            place: "top",
                                            children: "Upgrade!"
                                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {})
                                    ]
                                }))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4a707a95e28c6b48$export$2e2bcd8739ae039), {
                    title: "Style",
                    data: $259a4aee18dc5bdc$var$style,
                    selected: selectedStyle,
                    setSelected: setSelectedStyle,
                    name: "style",
                    fn: updateFieldById,
                    id: id
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "block text-sm font-medium leading-6 text-gray-900",
                        children: "Colour"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $80641d61d869cd62$export$5b6b19405a83ff9d), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $80641d61d869cd62$export$7dacb05d26466c3), {
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "w-full flex items-center gap-2 rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 focus:border-primary focus:outline-none",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                            style: {
                                                backgroundColor: selectedColour
                                            },
                                            className: `h-2 w-2 rounded-full`
                                        }),
                                        selectedColour
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $80641d61d869cd62$export$d7e1f420b25549ff), {
                                align: "start",
                                className: "z-30",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cc59cc03e94132b7$export$a3bc3c32746e9f3a), {
                                    color: selectedColour,
                                    onChange: (color)=>{
                                        updateFieldById(id, "colour", color);
                                        setSelectedColour(color);
                                    },
                                    style: {
                                        width: "100%",
                                        height: "150px"
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





function $835ca2bee7114a96$export$2e2bcd8739ae039() {
    return Date.now().toString(36) + Math.floor(Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)).toString(36);
}




const $701055d5795f96fc$var$generateChartData = ()=>Array.from({
        length: 5
    }, (_, i)=>[
            Date.now() - (4 - i) * 86400000,
            Math.floor(Math.random() * 40) + 1
        ]);
function $701055d5795f96fc$export$2e2bcd8739ae039({ editMode: editMode = false, initialData: initialData = null }) {
    // console.log("ChartingInformation received:", { editMode, initialData });
    const goHome = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.goHome);
    const add = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.addItem);
    const updateItem = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.updateItem);
    // Initialize first chart
    const [charts, setCharts] = (0, $exYeM.useState)(()=>{
        // console.log(
        //   "Initializing charts with data:",
        //   JSON.parse(JSON.stringify(initialData))
        // );
        if (editMode && initialData) {
            if (Array.isArray(initialData.props)) {
                const mappedCharts = initialData.props.map((chart)=>({
                        ...chart,
                        id: chart.id || (0, $835ca2bee7114a96$export$2e2bcd8739ae039)(),
                        widgetId: initialData.widgetId
                    }));
                // console.log("Mapped charts:", JSON.parse(JSON.stringify(mappedCharts)));
                return mappedCharts;
            }
            // Return default chart if props structure doesn't match
            return [
                {
                    id: (0, $835ca2bee7114a96$export$2e2bcd8739ae039)(),
                    widgetId: initialData.widgetId,
                    blockchain: null,
                    name: null,
                    source: null,
                    resolution: null,
                    style: null,
                    colour: "#FA9173",
                    data: $701055d5795f96fc$var$generateChartData()
                }
            ];
        }
        // Default new chart
        return [
            {
                id: (0, $835ca2bee7114a96$export$2e2bcd8739ae039)(),
                blockchain: null,
                name: null,
                source: null,
                resolution: null,
                style: null,
                colour: "#FA9173",
                data: $701055d5795f96fc$var$generateChartData()
            }
        ];
    });
    const handleAddChart = ()=>{
        const newID = (0, $835ca2bee7114a96$export$2e2bcd8739ae039)();
        setActive(newID);
        setCharts((prev)=>[
                ...prev,
                {
                    id: newID,
                    blockchain: null,
                    name: null,
                    source: null,
                    resolution: null,
                    style: null,
                    colour: "#FA9173",
                    data: $701055d5795f96fc$var$generateChartData()
                }
            ]);
    };
    const handleRemoveChart = (chartId)=>{
        setCharts((prev)=>{
            const newCharts = prev.filter((chart)=>chart.id !== chartId);
            // If we're removing the active chart, set active to the first remaining chart
            if (active === chartId && newCharts.length > 0) setActive(newCharts[0].id);
            return newCharts;
        });
    };
    // console.log("Charts state after initialization:", charts);
    const [active, setActive] = (0, $exYeM.useState)(charts[0]?.id);
    const transformedData = charts.filter((chart)=>chart?.style && chart?.colour).map((chart)=>({
            data: chart.data,
            colour: chart.colour,
            style: {
                data: chart.style?.data || "line"
            }
        }));
    const shouldShowChart = charts.some((chart)=>chart?.style && chart?.colour);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-full w-full",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1bc9e71a93ef6378$export$2e2bcd8739ae039), {
                title: editMode ? "Edit Chart" : "Chart",
                onBack: goHome,
                editMode: editMode
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "grid grid-cols-2 h-[540px]",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "col-span-1 overflow-y-scroll",
                        children: charts.map((item, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: (0, $c93813fc9a74a923$export$1343a74baacb0543)(active != item.id ? "h-12 overflow-hidden border-b" : "h-[520px]", "transition-all duration-100 px-4 py-2"),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $259a4aee18dc5bdc$export$2e2bcd8739ae039), {
                                    id: item.id,
                                    charts: charts,
                                    setCharts: setCharts,
                                    active: active,
                                    setActive: setActive,
                                    index: index,
                                    onRemove: charts.length > 1 ? ()=>handleRemoveChart(item.id) : undefined
                                })
                            }, item.id))
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "col-span-1 flex items-center justify-center font-monda",
                        children: !shouldShowChart ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "text-muted-foreground",
                            children: "Configure chart settings to preview"
                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f46b4f8560d1875e$export$2e2bcd8739ae039), {
                            data: transformedData,
                            minimal: true,
                            showControls: false,
                            height: "350px",
                            width: "350px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex justify-end border-t pt-4 relative",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        className: "absolute -top-[30px] left-48 group p-2 res-select rounded-full bg-surfaceVariant hover:bg-primary shadow-md border border-primaryContainer transition-all",
                        onClick: handleAddChart,
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $92ca66f52aed8449$export$2e2bcd8739ae039), {
                            className: "h-10 w-10 text-onSurfaceVariant group-hover:text-white"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6569f55e54f7ff9d$export$28c660c63b792dea), {
                        anchorSelect: ".res-select",
                        place: "top",
                        children: "Add another data set"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: ()=>{
                            if (editMode) {
                                console.log("Current chart state before update:", JSON.parse(JSON.stringify(charts)));
                                console.log("Updating chart widget:", {
                                    widgetId: initialData.widgetId,
                                    chartData: charts.map((chart)=>({
                                            blockchain: chart.blockchain,
                                            name: chart.name,
                                            resolution: chart.resolution,
                                            style: chart.style,
                                            colour: chart.colour,
                                            data: chart.data
                                        }))
                                });
                                updateItem(initialData.widgetId, charts);
                                goHome();
                            } else add("Chart", 4, 4, charts);
                        },
                        children: editMode ? "Update Widget" : "Add to Dashboard"
                    })
                ]
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");


function $7cc640ab8e942acc$export$2e2bcd8739ae039() {
    const navTo = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.navTo);
    const goHome = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.goHome);
    const editMode = false;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-full w-full bg-blue-400",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1bc9e71a93ef6378$export$2e2bcd8739ae039), {
                title: editMode ? "Edit Footprint" : "Footprint",
                onBack: goHome,
                editMode: editMode
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "Hello add Footprint sutff plz"
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");


function $091e061139c4a297$export$2e2bcd8739ae039() {
    const navTo = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.navTo);
    const goHome = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.goHome);
    const editMode = false;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-full w-full bg-red-400",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1bc9e71a93ef6378$export$2e2bcd8739ae039), {
                title: editMode ? "Edit Query" : "Query",
                onBack: goHome,
                editMode: editMode
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "Hello add Query sutff plz"
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");


function $a23fbb054c4ea24f$export$2e2bcd8739ae039() {
    const navTo = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.navTo);
    const goHome = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.goHome);
    const editMode = false;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-full w-full bg-purple-400",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1bc9e71a93ef6378$export$2e2bcd8739ae039), {
                title: editMode ? "Edit Discover" : "Discover",
                onBack: goHome,
                editMode: editMode
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "Hello add Discover sutff plz"
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");




var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

const $78fb39c8242f5c0e$var$TextSettings = ({ content: content, onUpdate: onUpdate })=>{
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $382959215f1093da$export$2e2bcd8739ae039), {
        content: content,
        onUpdate: onUpdate
    });
};
var $78fb39c8242f5c0e$export$2e2bcd8739ae039 = $78fb39c8242f5c0e$var$TextSettings;



function $9f4a0fc973b467ae$export$2e2bcd8739ae039({ editMode: editMode = false, initialData: initialData = null, onClose: onClose }) {
    const goHome = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.goHome);
    const add = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.addItem);
    const updateItem = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.updateItem);
    const [content, setContent] = (0, $exYeM.useState)(initialData?.props?.content || "");
    const handleClose = ()=>{
        goHome();
        onClose?.();
    };
    const handleSave = ()=>{
        if (!content.trim()) return;
        const props = {
            content: content,
            lastModified: new Date().toISOString()
        };
        if (editMode) updateItem(initialData.widgetId, props);
        else add("Text", 2, 1, props);
        handleClose();
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-full w-full flex flex-col",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1bc9e71a93ef6378$export$2e2bcd8739ae039), {
                title: editMode ? "Edit Text" : "Text",
                onBack: goHome,
                editMode: editMode
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex-1 min-h-0",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $78fb39c8242f5c0e$export$2e2bcd8739ae039), {
                    content: content,
                    onUpdate: setContent
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "border-t p-4 flex justify-end shrink-0",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                    onClick: handleSave,
                    disabled: !content.trim(),
                    children: editMode ? "Update Widget" : "Add to Dashboard"
                })
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");


function $9adcff382d3bfa9f$export$2e2bcd8739ae039() {
    const navTo = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.navTo);
    const goHome = (0, $a7807e464dff963c$export$c9be54d483513c16)((state)=>state.goHome);
    const editMode = false;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "h-full w-full bg-indigo-50",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1bc9e71a93ef6378$export$2e2bcd8739ae039), {
                title: editMode ? "Edit Table" : "Table",
                onBack: goHome,
                editMode: editMode
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "Add table editor functionality here"
            })
        ]
    });
}



function $5bde197c78d867d5$export$2e2bcd8739ae039({ open: open, setOpen: setOpen, editMode: editMode = false, initialData: initialData = null }) {
    const { active: active, isEditing: isEditing, editData: editData, initialize: initialize, navTo: navTo, reset: reset } = (0, $a7807e464dff963c$export$c9be54d483513c16)();
    const hasInitialized = (0, $exYeM.useRef)(false);
    // Create the items array
    const items = [
        {
            id: "Home",
            item: !editMode ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f65147e9cc20f47b$export$2e2bcd8739ae039), {}) : null
        },
        {
            id: "Chart",
            item: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $701055d5795f96fc$export$2e2bcd8739ae039), {
                editMode: editMode,
                initialData: initialData
            })
        },
        {
            id: "Footprint",
            item: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7cc640ab8e942acc$export$2e2bcd8739ae039), {})
        },
        {
            id: "Query",
            item: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $091e061139c4a297$export$2e2bcd8739ae039), {})
        },
        {
            id: "Discover",
            item: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a23fbb054c4ea24f$export$2e2bcd8739ae039), {})
        },
        {
            id: "Text",
            item: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9f4a0fc973b467ae$export$2e2bcd8739ae039), {
                editMode: editMode,
                initialData: initialData,
                onClose: ()=>setOpen(false)
            })
        },
        {
            id: "Table",
            item: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9adcff382d3bfa9f$export$2e2bcd8739ae039), {})
        }
    ].filter((item)=>item.item !== null);
    // Generate TYPE_TO_INDEX dynamically based on filtered items
    const TYPE_TO_INDEX = (0, $exYeM.useMemo)(()=>{
        return items.reduce((acc, item, index)=>{
            acc[item.id] = index;
            return acc;
        }, {});
    }, [
        items
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (open && !hasInitialized.current && initialData) {
            hasInitialized.current = true;
            initialize(initialData.type, editMode, initialData);
            const targetIndex = TYPE_TO_INDEX[initialData.type];
            if (targetIndex !== undefined) navTo(0, targetIndex);
        }
    }, [
        open,
        initialData,
        editMode,
        initialize,
        navTo,
        TYPE_TO_INDEX
    ]);
    // Reset on close
    (0, $exYeM.useEffect)(()=>{
        if (!open) {
            hasInitialized.current = false;
            reset();
        }
    }, [
        open,
        reset
    ]);
    const handleClose = (0, $exYeM.useCallback)(()=>{
        setOpen(false);
        reset();
    }, [
        setOpen,
        reset
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$3ddf2d174ce01153), {
        onOpenChange: handleClose,
        open: open,
        modal: true,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $27561b24f6cc51c4$export$b6d9565de1e068cf), {
            className: "max-w-3xl w-full p-0",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "h-[650px] flex flex-col overflow-hidden",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "relative flex-1 grid grid-cols-1 grid-rows-1",
                    children: items.map((item, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("col-start-1 col-end-2 row-start-1 row-end-2 w-full h-full transition-all duration-500", active === index ? "translate-y-0 opacity-100 z-20" : active === 0 ? "-translate-y-full opacity-0 z-10" : "translate-y-full opacity-0 z-10"),
                            children: item.item
                        }, index))
                })
            })
        })
    });
}




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
// packages/core/primitive/src/primitive.tsx
function $d282c64a487e7d7e$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $exYeM = parcelRequire("exYeM");
function $4ec4323fee3bedd9$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $4ec4323fee3bedd9$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $4ec4323fee3bedd9$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $4ec4323fee3bedd9$var$setRef(refs[i], null);
            }
        };
    };
}
function $4ec4323fee3bedd9$export$c7b2cbe3552a0d05(...refs) {
    return $exYeM.useCallback($4ec4323fee3bedd9$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
function $3e44c3ef93fba193$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $exYeM.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $exYeM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $aSiaI.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $exYeM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $3e44c3ef93fba193$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $exYeM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $exYeM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $aSiaI.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $exYeM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $exYeM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $exYeM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $3e44c3ef93fba193$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $3e44c3ef93fba193$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $exYeM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $exYeM = parcelRequire("exYeM");
function $316146e3d8d55e1d$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $exYeM.useRef(callback);
    $exYeM.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $exYeM.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $5b4c8aca16ee0a06$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $5b4c8aca16ee0a06$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $316146e3d8d55e1d$export$25bec8c6f54ee79a)(onChange);
    const setValue = $exYeM.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $5b4c8aca16ee0a06$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $exYeM.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $exYeM.useRef(value);
    const handleChange = (0, $316146e3d8d55e1d$export$25bec8c6f54ee79a)(onChange);
    $exYeM.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/use-previous/src/usePrevious.tsx

var $exYeM = parcelRequire("exYeM");
function $670a75e097a30c2b$export$5cae361ad82dce8b(value) {
    const ref = $exYeM.useRef({
        value: value,
        previous: value
    });
    return $exYeM.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}


// packages/react/use-size/src/useSize.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $exYeM = parcelRequire("exYeM");
var $2aeb2f373e6c941d$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $exYeM.useLayoutEffect : ()=>{};


function $d908c41055b5c372$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $exYeM.useState(void 0);
    (0, $2aeb2f373e6c941d$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}


// packages/react/primitive/src/Primitive.tsx

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
// packages/react/slot/src/Slot.tsx

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");
var $972db7d5f3fd99b4$export$8c6ed5c666ac1360 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $exYeM.Children.toArray(children);
    const slottable = childrenArray.find($972db7d5f3fd99b4$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($exYeM.Children.count(newElement) > 1) return $exYeM.Children.only(null);
                return $exYeM.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $aSiaI.jsx)($972db7d5f3fd99b4$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $exYeM.isValidElement(newElement) ? $exYeM.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $aSiaI.jsx)($972db7d5f3fd99b4$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$972db7d5f3fd99b4$export$8c6ed5c666ac1360.displayName = "Slot";
var $972db7d5f3fd99b4$var$SlotClone = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($exYeM.isValidElement(children)) {
        const childrenRef = $972db7d5f3fd99b4$var$getElementRef(children);
        return $exYeM.cloneElement(children, {
            ...$972db7d5f3fd99b4$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $4ec4323fee3bedd9$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $exYeM.Children.count(children) > 1 ? $exYeM.Children.only(null) : null;
});
$972db7d5f3fd99b4$var$SlotClone.displayName = "SlotClone";
var $972db7d5f3fd99b4$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: children
    });
};
function $972db7d5f3fd99b4$var$isSlottable(child) {
    return $exYeM.isValidElement(child) && child.type === $972db7d5f3fd99b4$export$d9f1ccf0bdb05d45;
}
function $972db7d5f3fd99b4$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $972db7d5f3fd99b4$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $972db7d5f3fd99b4$export$be92b6f5f03c0fe9 = $972db7d5f3fd99b4$export$8c6ed5c666ac1360;



var $aSiaI = parcelRequire("aSiaI");
var $d7a734e2b0952949$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $d7a734e2b0952949$export$250ffa63cdc0d034 = $d7a734e2b0952949$var$NODES.reduce((primitive, node)=>{
    const Node = $exYeM.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $972db7d5f3fd99b4$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $aSiaI.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $d7a734e2b0952949$export$6d1a0317bde7de7f(target, event) {
    if (target) $d2lNW.flushSync(()=>target.dispatchEvent(event));
}
var $d7a734e2b0952949$export$be92b6f5f03c0fe9 = $d7a734e2b0952949$export$250ffa63cdc0d034;



var $aSiaI = parcelRequire("aSiaI");
"use client";
var $966477614ef4c22c$var$SWITCH_NAME = "Switch";
var [$966477614ef4c22c$var$createSwitchContext, $966477614ef4c22c$export$cf7f5f17f69cbd43] = (0, $3e44c3ef93fba193$export$50c7b4e9d9f19c1)($966477614ef4c22c$var$SWITCH_NAME);
var [$966477614ef4c22c$var$SwitchProvider, $966477614ef4c22c$var$useSwitchContext] = $966477614ef4c22c$var$createSwitchContext($966477614ef4c22c$var$SWITCH_NAME);
var $966477614ef4c22c$export$b5d5cf8927ab7262 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, form: form, ...switchProps } = props;
    const [button, setButton] = $exYeM.useState(null);
    const composedRefs = (0, $4ec4323fee3bedd9$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $exYeM.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    const [checked = false, setChecked] = (0, $5b4c8aca16ee0a06$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /* @__PURE__ */ (0, $aSiaI.jsxs)($966477614ef4c22c$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $aSiaI.jsx)((0, $d7a734e2b0952949$export$250ffa63cdc0d034).button, {
                type: "button",
                role: "switch",
                "aria-checked": checked,
                "aria-required": required,
                "data-state": $966477614ef4c22c$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...switchProps,
                ref: composedRefs,
                onClick: (0, $d282c64a487e7d7e$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>!prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $aSiaI.jsx)($966477614ef4c22c$var$BubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                form: form,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$966477614ef4c22c$export$b5d5cf8927ab7262.displayName = $966477614ef4c22c$var$SWITCH_NAME;
var $966477614ef4c22c$var$THUMB_NAME = "SwitchThumb";
var $966477614ef4c22c$export$4d07bf653ea69106 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $966477614ef4c22c$var$useSwitchContext($966477614ef4c22c$var$THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ (0, $aSiaI.jsx)((0, $d7a734e2b0952949$export$250ffa63cdc0d034).span, {
        "data-state": $966477614ef4c22c$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
    });
});
$966477614ef4c22c$export$4d07bf653ea69106.displayName = $966477614ef4c22c$var$THUMB_NAME;
var $966477614ef4c22c$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = $exYeM.useRef(null);
    const prevChecked = (0, $670a75e097a30c2b$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $d908c41055b5c372$export$1ab7ae714698c4b8)(control);
    $exYeM.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $aSiaI.jsx)("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked,
        ...inputProps,
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
};
function $966477614ef4c22c$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $966477614ef4c22c$export$be92b6f5f03c0fe9 = $966477614ef4c22c$export$b5d5cf8927ab7262;
var $966477614ef4c22c$export$6521433ed15a34db = $966477614ef4c22c$export$4d07bf653ea69106;



"use client";
const $c5dd98a9447d3637$export$b5d5cf8927ab7262 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsx)($966477614ef4c22c$export$be92b6f5f03c0fe9, {
        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input", className),
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($966477614ef4c22c$export$6521433ed15a34db, {
            className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0")
        })
    }));
$c5dd98a9447d3637$export$b5d5cf8927ab7262.displayName = $966477614ef4c22c$export$be92b6f5f03c0fe9.displayName;





function $fa2c37b2ad00d87e$var$DashboardView() {
    const { uniqueCode: uniqueCode } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { toast: toast } = (0, $37283260ab9dbfc4$export$a407b657d3044108)();
    const [edit, setEdit] = (0, $exYeM.useState)(false);
    const [dialogOpen, setDialogOpen] = (0, $exYeM.useState)(false);
    const [editingWidget, setEditingWidget] = (0, $exYeM.useState)(null);
    const [showSaveError, setShowSaveError] = (0, $exYeM.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $exYeM.useState)("");
    const [showVisibilityConfirm, setShowVisibilityConfirm] = (0, $exYeM.useState)(false);
    const [pendingVisibilityChange, setPendingVisibilityChange] = (0, $exYeM.useState)(false);
    // Local store state
    const layout = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.layouts);
    const items = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.items);
    const remove = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.removeItem);
    const updateLayout = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.updateLayout);
    const dashboardName = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.dashboardName);
    const setDashboardName = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.setDashboardName);
    const setDashboardState = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.setDashboardState);
    const removeAll = (0, $343f8b8806fa99ed$export$e6e525ae42e818e8)((state)=>state.removeAll);
    const { data: dashboardData, error: dashboardError, isLoading: isLoading } = (0, $ff0220da39bef700$export$bc2f3c415e4383ee)(uniqueCode);
    const isLoggedIn = (0, $8e62f87e86da6465$export$83d11f23a23d4a7c)();
    const { mutate: saveDashboard, isLoading: isSaving } = (0, $ff0220da39bef700$export$94046774b4ff53ed)({
        onSuccess: ()=>{
            toast({
                variant: "successV2",
                title: "Dashboard saved successfully"
            });
        },
        onError: (error)=>{
            setErrorMessage(error.message || "Failed to save dashboard");
            setShowSaveError(true);
        }
    });
    const { mutate: toggleVisibility } = (0, $ff0220da39bef700$export$47cb2ccc854c75de)({
        onSuccess: ()=>{
            toast({
                variant: "successV2",
                title: "Dashboard visibility updated"
            });
        },
        onError: (error)=>{
            toast({
                variant: "destructive",
                title: "Failed to update visibility",
                description: error.message || "Please try again"
            });
        }
    });
    const { mutate: toggleLike, isLoading: isLikeLoading } = (0, $ff0220da39bef700$export$10c08b06097c21a9)({
        onError: (error)=>{
            toast({
                variant: "destructive",
                title: "Error updating like status",
                description: error.message || "Please try again"
            });
        }
    });
    (0, $exYeM.useEffect)(()=>{
        if (dashboardData?.data) {
            const canAccess = (0, $8e62f87e86da6465$export$90a32a441cd4e4e0)(dashboardData.data);
            if (!canAccess) {
                navigate("/dashboard", {
                    replace: true,
                    state: {
                        error: "You don't have permission to view this dashboard"
                    }
                });
                return;
            }
            // Update local state with dashboard data
            const { items: items, layout: layout, dashboardName: dashboardName } = dashboardData.data;
            removeAll();
            setDashboardState(items, layout, dashboardName);
            // Check edit permissions
            const canEdit = (0, $8e62f87e86da6465$export$1ec271aac917f1f1)(dashboardData.data);
            setEdit(false); // Reset edit mode
            if (!canEdit) toast({
                variant: "default",
                title: "View Only",
                description: "You have view-only access to this dashboard"
            });
        }
    }, [
        dashboardData,
        navigate,
        removeAll,
        setDashboardState
    ]);
    const handleSave = ()=>{
        // Get the current dashboard data including permissions
        const currentData = dashboardData?.data;
        const saveData = {
            dashboardName: dashboardName,
            layout: layout,
            items: items,
            // Preserve existing permissions or set defaults if none exist
            permissions: currentData?.permissions || {
                sharedWith: [],
                accessLevel: "edit"
            },
            // Preserve other fields that should persist
            isPublic: currentData?.isPublic ?? false,
            version: currentData?.version ?? 1,
            status: currentData?.status ?? "active"
        };
        saveDashboard({
            uniqueCode: uniqueCode,
            data: saveData
        });
    };
    const handleVisibilityToggle = (newVisibility)=>{
        if (!uniqueCode) return;
        // If trying to make public, show confirmation
        if (newVisibility) {
            setPendingVisibilityChange(true);
            setShowVisibilityConfirm(true);
        } else // If making private, do it immediately
        toggleVisibility({
            uniqueCode: uniqueCode,
            isPublic: false
        });
    };
    const handleConfirmPublic = ()=>{
        toggleVisibility({
            uniqueCode: uniqueCode,
            isPublic: true
        });
        setShowVisibilityConfirm(false);
    };
    const handleEditWidget = (widgetId, widgetData)=>{
        console.log("Full widget data:", {
            widgetId: widgetId,
            type: widgetData.type,
            props: JSON.parse(JSON.stringify(widgetData.props))
        });
        setEditingWidget({
            widgetId: widgetId,
            type: widgetData.type,
            props: widgetData.props
        });
        setDialogOpen(true);
    };
    const renderHeaderExtras = ()=>{
        return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                isLoggedIn && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$f78649fb9ca566b8), {
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2c3dff1bb294f275$export$28c660c63b792dea), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$8c610744efcf8a1d), {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                    className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-10 w-10 inline-flex group items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", dashboardData?.data?.likedBy?.includes(JSON.parse(localStorage.getItem("user")).id) && "text-primary"),
                                    onClick: ()=>{
                                        if (!isLoggedIn) {
                                            toast({
                                                title: "Authentication Required",
                                                description: "Please log in to like dashboards",
                                                variant: "destructive"
                                            });
                                            return;
                                        }
                                        const isCurrentlyLiked = dashboardData?.data?.likedBy?.includes(JSON.parse(localStorage.getItem("user")).id);
                                        toggleLike({
                                            uniqueCode: uniqueCode,
                                            isLiking: !isCurrentlyLiked
                                        });
                                    },
                                    disabled: isLikeLoading,
                                    children: isLikeLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11645006cc3cfacf$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 animate-spin"
                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $befd515fba4f9ccb$export$2e2bcd8739ae039), {
                                        className: (0, $c93813fc9a74a923$export$1343a74baacb0543)("h-5 w-5 text-onSurfaceVariant group-hover:text-white ", dashboardData?.data?.likedBy?.includes(JSON.parse(localStorage.getItem("user")).id) && "fill-primary group-hover:fill-none", !dashboardData?.data?.likedBy?.includes(JSON.parse(localStorage.getItem("user")).id) && "group-hover:fill-primary")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2c3dff1bb294f275$export$e9003e2be37ec060), {
                                children: [
                                    dashboardData?.data?.likedBy?.includes(JSON.parse(localStorage.getItem("user")).id) ? "Unlike" : "Like",
                                    " ",
                                    "this dashboard"
                                ]
                            })
                        ]
                    })
                }),
                canEdit && /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        dashboardData?.data?.isPublic ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c3b0b1367696494$export$2e2bcd8739ae039), {
                            className: "h-4 w-4 text-primary"
                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f23364bb7ce99c8b$export$2e2bcd8739ae039), {
                            className: "h-4 w-4 text-primary"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$f78649fb9ca566b8), {
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $2c3dff1bb294f275$export$28c660c63b792dea), {
                                delayDuration: 300,
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$8c610744efcf8a1d), {
                                        asChild: true,
                                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c5dd98a9447d3637$export$b5d5cf8927ab7262), {
                                                    checked: dashboardData?.data?.isPublic,
                                                    onCheckedChange: handleVisibilityToggle,
                                                    disabled: isSaving,
                                                    "aria-label": "Toggle dashboard visibility"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: dashboardData?.data?.isPublic ? "Public" : "Private"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2c3dff1bb294f275$export$e9003e2be37ec060), {
                                        side: "bottom",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                                            children: dashboardData?.data?.isPublic ? "Anyone with the link can view this dashboard" : "Only you can access this dashboard"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    if (isLoading) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex items-center justify-center h-full",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "flex flex-col items-center gap-4",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $11645006cc3cfacf$export$2e2bcd8739ae039), {
                    className: "h-8 w-8 animate-spin text-primary"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "text-muted-foreground",
                    children: "Loading dashboard..."
                })
            ]
        })
    });
    if (dashboardError?.response?.status === 404) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col items-center justify-center h-full gap-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                className: "text-2xl font-bold",
                children: "Dashboard Not Found"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "text-gray-600",
                children: "This dashboard doesn't exist or has been deleted."
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                onClick: ()=>navigate("/dashboard"),
                children: "Return to Dashboards"
            })
        ]
    });
    if (dashboardError?.response?.status === 403) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col items-center justify-center h-full gap-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                className: "text-2xl font-bold",
                children: "Access Denied"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "text-gray-600",
                children: "You don't have permission to view this dashboard."
            }),
            !isLoggedIn && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                onClick: ()=>navigate("/signin"),
                children: "Log In to Continue"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                variant: "outline",
                onClick: ()=>navigate("/dashboard"),
                children: "Return to Dashboards"
            })
        ]
    });
    if (dashboardError) return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col items-center justify-center h-full gap-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                className: "text-2xl font-bold text-red-500",
                children: "Error Loading Dashboard"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "text-gray-600",
                children: dashboardError.message
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $123f871e017f2022$export$353f5b6fc5456de1), {
                onClick: ()=>navigate("/dashboard"),
                children: "Return to Dashboards"
            })
        ]
    });
    const canEdit = dashboardData?.data ? (0, $8e62f87e86da6465$export$1ec271aac917f1f1)(dashboardData.data) : false;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$de466dd8317b0b75), {
                open: showSaveError,
                onOpenChange: setShowSaveError,
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$94e6af45f0af4efd), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$c9359e10414c2de7), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$225e0da62d314b7), {
                                    children: "Error Saving Dashboard"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$a23b55cde55ad9a5), {
                                    children: errorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$691560c8793e1baf), {
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$b454f818c58ee85d), {
                                onClick: ()=>setShowSaveError(false),
                                children: "OK"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$de466dd8317b0b75), {
                open: showVisibilityConfirm,
                onOpenChange: setShowVisibilityConfirm,
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$94e6af45f0af4efd), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$c9359e10414c2de7), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$225e0da62d314b7), {
                                    children: "Make Dashboard Public?"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$a23b55cde55ad9a5), {
                                    children: "Making this dashboard public will allow anyone with the link to view it. They won't be able to edit the dashboard, but they can see all the data and widgets. Are you sure you want to continue?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $753c47cad29074a6$export$691560c8793e1baf), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$2f67a923571aaea0), {
                                    onClick: ()=>{
                                        setShowVisibilityConfirm(false);
                                        setPendingVisibilityChange(false);
                                    },
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $753c47cad29074a6$export$b454f818c58ee85d), {
                                    onClick: handleConfirmPublic,
                                    children: "Make Public"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6b8c5152afe6fd54$export$2e2bcd8739ae039), {
                dashboardName: dashboardName,
                onDashboardNameChange: canEdit ? setDashboardName : undefined,
                layout: layout,
                items: items,
                onLayoutChange: canEdit ? updateLayout : undefined,
                onRemoveWidget: canEdit ? remove : undefined,
                isEditing: edit && canEdit,
                onToggleEdit: canEdit ? ()=>setEdit(!edit) : undefined,
                isSaving: isSaving,
                onSave: canEdit ? handleSave : undefined,
                onOpenDialog: canEdit ? ()=>setDialogOpen(true) : undefined,
                onEdit: handleEditWidget,
                showEditControls: canEdit,
                headerExtras: renderHeaderExtras(),
                children: (type, props)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $47bf2435abbfb6af$export$2e2bcd8739ae039), {
                        type: type,
                        props: props
                    })
            }),
            canEdit && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5bde197c78d867d5$export$2e2bcd8739ae039), {
                open: dialogOpen,
                setOpen: (open)=>{
                    setDialogOpen(open);
                    if (!open) setEditingWidget(null);
                },
                editMode: !!editingWidget,
                initialData: editingWidget
            })
        ]
    });
}
var $fa2c37b2ad00d87e$export$2e2bcd8739ae039 = $fa2c37b2ad00d87e$var$DashboardView;


// default query client settings
const $ea0a1541df4ae3fc$var$queryClient = new (0, $3751a76a3f332f6a$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnmount: false,
            refetchOnReconnect: false,
            staleTime: 600000
        }
    }
});
// main router for the whole website
const $ea0a1541df4ae3fc$var$router = (0, $2cc1d3688dd37f6f$export$1f3f55432a00e06d)((0, $b0e6fcd50b7ef685$export$16da398f5434bdec)(/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
    path: "/",
    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $972492a0d7f6249c$export$2e2bcd8739ae039), {}),
    errorElement: /*#__PURE__*/ (0, $aSiaI.jsx)($ea0a1541df4ae3fc$var$ErrorBoundary, {}),
    children: [
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            index: true,
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e391825e47c2285e$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/twitter",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e391825e47c2285e$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/github",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e391825e47c2285e$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Explore",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $438f833e9057668f$export$2e2bcd8739ae039), {}),
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a4752a6c21eebe7d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "Tables",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9d693b772bdf613a$export$2e2bcd8739ae039), {})
                })
            ]
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Pricing",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d919cca732a1e95e$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/SignUp",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13b0b96961f38c58$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/SignIn",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3246ad47baf3f0f0$export$2e2bcd8739ae039), {})
        }),
        ";",
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Glossary",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4af6195cc5ac9db3$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Glossary/:term",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e271f4e3e637d312$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/SignIn/:confirmationCode",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3246ad47baf3f0f0$export$2e2bcd8739ae039), {})
        }),
        ";",
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/UserSettings",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $37649f0fd6e2a1d7$export$2e2bcd8739ae039), {})
        }),
        ";",
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Faq",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cedd06c48d896b34$export$2e2bcd8739ae039), {})
        }),
        ";",
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Discover",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c457c4691ba1ff56$export$2e2bcd8739ae039), {})
        }),
        ";",
        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Dashboard",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3832baf57ec23419$export$2e2bcd8739ae039), {}),
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d23de570471ea3b6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: ":uniqueCode",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fa2c37b2ad00d87e$export$2e2bcd8739ae039), {})
                })
            ]
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Alerts",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f174054c37467980$export$2e2bcd8739ae039), {})
        }),
        ";",
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Reset/:confirmationCode",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $01e805ac74a28c89$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/ForgotPassword",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6056c06ab01c2ef$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Legal",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0e3f457a44a20854$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "/Legal/Master",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d245be1f5f28d3a6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "/Legal/Privacy",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0980981023b13d1$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "/Legal/Terms",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9a48167f337b77c5$export$2e2bcd8739ae039), {})
                })
            ]
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Contact",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a69e61cef7f8059b$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Footprint",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9f0da79313b4b09b$export$2e2bcd8739ae039), {}),
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9e518a8e18b19553$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "Transactions",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $353ace93c0328113$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "Analytics",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $46fb392573591b54$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "Nfts",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ae19c796fd8bb77f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "Networkgraph",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c8347f669780134b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "Portfolio",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4a9ee1a3aea245de$export$2e2bcd8739ae039), {})
                })
            ]
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/CheckoutSuccess",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $06517bdc959aed1d$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/Query",
            element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $52f753a61b21f1a5$export$2e2bcd8739ae039), {})
        })
    ]
})));
// main error, if theres an error should end up here unless caught else where
function $ea0a1541df4ae3fc$var$ErrorBoundary() {
    let error = (0, $b0e6fcd50b7ef685$export$ed527bf60f6e05f2)();
    console.error(error);
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    // Uncaught ReferenceError: path is not defined
    return /*#__PURE__*/ (0, $aSiaI.jsx)("main", {
        className: "grid min-h-full place-items-center py-24 px-6 sm:py-32 lg:px-8 font-roboto",
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                    className: "mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                    children: "Page not found"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "mt-6 text-base leading-7 text-gray-600",
                    children: "Sorry, we couldn\u2019t find the page you\u2019re looking for."
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "mt-6 flex items-center justify-center gap-x-6",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        onClick: ()=>{
                            navigate("/");
                        },
                        className: "rounded-lg bg-primaryContainer px-3 py-2 text-sm font-semibold text-black shadow-sm hover:text-white hover:bg-primary",
                        children: "Go back home"
                    })
                })
            ]
        })
    });
}
function $ea0a1541df4ae3fc$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1773e073a683367a$export$45604f0cc8ae667b), {
        client: $ea0a1541df4ae3fc$var$queryClient,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fcd3b67f8d244ec9$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$323e4fc2fa4753fb), {
                router: $ea0a1541df4ae3fc$var$router
            })
        })
    });
}


var $e0d54fd891fbc3b9$var$e, $e0d54fd891fbc3b9$var$n, $e0d54fd891fbc3b9$var$t, $e0d54fd891fbc3b9$var$r, $e0d54fd891fbc3b9$var$i, $e0d54fd891fbc3b9$var$a = -1, $e0d54fd891fbc3b9$var$o = function(e) {
    addEventListener("pageshow", function(n) {
        n.persisted && ($e0d54fd891fbc3b9$var$a = n.timeStamp, e(n));
    }, !0);
}, $e0d54fd891fbc3b9$var$c = function() {
    return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, $e0d54fd891fbc3b9$var$u = function() {
    var e = $e0d54fd891fbc3b9$var$c();
    return e && e.activationStart || 0;
}, $e0d54fd891fbc3b9$var$f = function(e, n) {
    var t = $e0d54fd891fbc3b9$var$c(), r = "navigate";
    $e0d54fd891fbc3b9$var$a >= 0 ? r = "back-forward-cache" : t && (document.prerendering || $e0d54fd891fbc3b9$var$u() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-")));
    return {
        name: e,
        value: void 0 === n ? -1 : n,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: r
    };
}, $e0d54fd891fbc3b9$var$s = function(e, n, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            var r = new PerformanceObserver(function(e) {
                Promise.resolve().then(function() {
                    n(e.getEntries());
                });
            });
            return r.observe(Object.assign({
                type: e,
                buffered: !0
            }, t || {})), r;
        }
    } catch (e) {}
}, $e0d54fd891fbc3b9$var$d = function(e, n, t, r) {
    var i, a;
    return function(o) {
        n.value >= 0 && (o || r) && ((a = n.value - (i || 0)) || void 0 === i) && (i = n.value, n.delta = a, n.rating = function(e, n) {
            return e > n[1] ? "poor" : e > n[0] ? "needs-improvement" : "good";
        }(n.value, t), e(n));
    };
}, $e0d54fd891fbc3b9$var$l = function(e) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return e();
        });
    });
}, $e0d54fd891fbc3b9$var$p = function(e) {
    var n = function(n) {
        "pagehide" !== n.type && "hidden" !== document.visibilityState || e(n);
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $e0d54fd891fbc3b9$var$v = function(e) {
    var n = !1;
    return function(t) {
        n || (e(t), n = !0);
    };
}, $e0d54fd891fbc3b9$var$m = -1, $e0d54fd891fbc3b9$var$h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $e0d54fd891fbc3b9$var$g = function(e) {
    "hidden" === document.visibilityState && $e0d54fd891fbc3b9$var$m > -1 && ($e0d54fd891fbc3b9$var$m = "visibilitychange" === e.type ? e.timeStamp : 0, $e0d54fd891fbc3b9$var$T());
}, $e0d54fd891fbc3b9$var$y = function() {
    addEventListener("visibilitychange", $e0d54fd891fbc3b9$var$g, !0), addEventListener("prerenderingchange", $e0d54fd891fbc3b9$var$g, !0);
}, $e0d54fd891fbc3b9$var$T = function() {
    removeEventListener("visibilitychange", $e0d54fd891fbc3b9$var$g, !0), removeEventListener("prerenderingchange", $e0d54fd891fbc3b9$var$g, !0);
}, $e0d54fd891fbc3b9$var$E = function() {
    return $e0d54fd891fbc3b9$var$m < 0 && ($e0d54fd891fbc3b9$var$m = $e0d54fd891fbc3b9$var$h(), $e0d54fd891fbc3b9$var$y(), $e0d54fd891fbc3b9$var$o(function() {
        setTimeout(function() {
            $e0d54fd891fbc3b9$var$m = $e0d54fd891fbc3b9$var$h(), $e0d54fd891fbc3b9$var$y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $e0d54fd891fbc3b9$var$m;
        }
    };
}, $e0d54fd891fbc3b9$var$C = function(e) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return e();
    }, !0) : e();
}, $e0d54fd891fbc3b9$export$e610c735b5510cec = [
    1800,
    3e3
], $e0d54fd891fbc3b9$export$52489892712e8192 = function(e, n) {
    n = n || {}, $e0d54fd891fbc3b9$var$C(function() {
        var t, r = $e0d54fd891fbc3b9$var$E(), i = $e0d54fd891fbc3b9$var$f("FCP"), a = $e0d54fd891fbc3b9$var$s("paint", function(e) {
            e.forEach(function(e) {
                "first-contentful-paint" === e.name && (a.disconnect(), e.startTime < r.firstHiddenTime && (i.value = Math.max(e.startTime - $e0d54fd891fbc3b9$var$u(), 0), i.entries.push(e), t(!0)));
            });
        });
        a && (t = $e0d54fd891fbc3b9$var$d(e, i, $e0d54fd891fbc3b9$export$e610c735b5510cec, n.reportAllChanges), $e0d54fd891fbc3b9$var$o(function(r) {
            i = $e0d54fd891fbc3b9$var$f("FCP"), t = $e0d54fd891fbc3b9$var$d(e, i, $e0d54fd891fbc3b9$export$e610c735b5510cec, n.reportAllChanges), $e0d54fd891fbc3b9$var$l(function() {
                i.value = performance.now() - r.timeStamp, t(!0);
            });
        }));
    });
}, $e0d54fd891fbc3b9$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $e0d54fd891fbc3b9$export$fc6227831ee7c7 = function(e, n) {
    n = n || {}, $e0d54fd891fbc3b9$export$52489892712e8192($e0d54fd891fbc3b9$var$v(function() {
        var t, r = $e0d54fd891fbc3b9$var$f("CLS", 0), i = 0, a = [], c = function(e) {
            e.forEach(function(e) {
                if (!e.hadRecentInput) {
                    var n = a[0], t = a[a.length - 1];
                    i && e.startTime - t.startTime < 1e3 && e.startTime - n.startTime < 5e3 ? (i += e.value, a.push(e)) : (i = e.value, a = [
                        e
                    ]);
                }
            }), i > r.value && (r.value = i, r.entries = a, t());
        }, u = $e0d54fd891fbc3b9$var$s("layout-shift", c);
        u && (t = $e0d54fd891fbc3b9$var$d(e, r, $e0d54fd891fbc3b9$export$3f20d8e089ac35b2, n.reportAllChanges), $e0d54fd891fbc3b9$var$p(function() {
            c(u.takeRecords()), t(!0);
        }), $e0d54fd891fbc3b9$var$o(function() {
            i = 0, r = $e0d54fd891fbc3b9$var$f("CLS", 0), t = $e0d54fd891fbc3b9$var$d(e, r, $e0d54fd891fbc3b9$export$3f20d8e089ac35b2, n.reportAllChanges), $e0d54fd891fbc3b9$var$l(function() {
                return t();
            });
        }), setTimeout(t, 0));
    }));
}, $e0d54fd891fbc3b9$var$A = {
    passive: !0,
    capture: !0
}, $e0d54fd891fbc3b9$var$I = new Date, $e0d54fd891fbc3b9$var$P = function(r, i) {
    $e0d54fd891fbc3b9$var$e || ($e0d54fd891fbc3b9$var$e = i, $e0d54fd891fbc3b9$var$n = r, $e0d54fd891fbc3b9$var$t = new Date, $e0d54fd891fbc3b9$var$k(removeEventListener), $e0d54fd891fbc3b9$var$F());
}, $e0d54fd891fbc3b9$var$F = function() {
    if ($e0d54fd891fbc3b9$var$n >= 0 && $e0d54fd891fbc3b9$var$n < $e0d54fd891fbc3b9$var$t - $e0d54fd891fbc3b9$var$I) {
        var i = {
            entryType: "first-input",
            name: $e0d54fd891fbc3b9$var$e.type,
            target: $e0d54fd891fbc3b9$var$e.target,
            cancelable: $e0d54fd891fbc3b9$var$e.cancelable,
            startTime: $e0d54fd891fbc3b9$var$e.timeStamp,
            processingStart: $e0d54fd891fbc3b9$var$e.timeStamp + $e0d54fd891fbc3b9$var$n
        };
        $e0d54fd891fbc3b9$var$r.forEach(function(e) {
            e(i);
        }), $e0d54fd891fbc3b9$var$r = [];
    }
}, $e0d54fd891fbc3b9$var$M = function(e) {
    if (e.cancelable) {
        var n = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, n) {
            var t = function() {
                $e0d54fd891fbc3b9$var$P(e, n), i();
            }, r = function() {
                i();
            }, i = function() {
                removeEventListener("pointerup", t, $e0d54fd891fbc3b9$var$A), removeEventListener("pointercancel", r, $e0d54fd891fbc3b9$var$A);
            };
            addEventListener("pointerup", t, $e0d54fd891fbc3b9$var$A), addEventListener("pointercancel", r, $e0d54fd891fbc3b9$var$A);
        }(n, e) : $e0d54fd891fbc3b9$var$P(n, e);
    }
}, $e0d54fd891fbc3b9$var$k = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(n) {
        return e(n, $e0d54fd891fbc3b9$var$M, $e0d54fd891fbc3b9$var$A);
    });
}, $e0d54fd891fbc3b9$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $e0d54fd891fbc3b9$export$134ed2977d320dfd = function(t, i) {
    i = i || {}, $e0d54fd891fbc3b9$var$C(function() {
        var a, c = $e0d54fd891fbc3b9$var$E(), u = $e0d54fd891fbc3b9$var$f("FID"), l = function(e) {
            e.startTime < c.firstHiddenTime && (u.value = e.processingStart - e.startTime, u.entries.push(e), a(!0));
        }, m = function(e) {
            e.forEach(l);
        }, h = $e0d54fd891fbc3b9$var$s("first-input", m);
        a = $e0d54fd891fbc3b9$var$d(t, u, $e0d54fd891fbc3b9$export$8f7f3c48ca6fbe34, i.reportAllChanges), h && $e0d54fd891fbc3b9$var$p($e0d54fd891fbc3b9$var$v(function() {
            m(h.takeRecords()), h.disconnect();
        })), h && $e0d54fd891fbc3b9$var$o(function() {
            var o;
            u = $e0d54fd891fbc3b9$var$f("FID"), a = $e0d54fd891fbc3b9$var$d(t, u, $e0d54fd891fbc3b9$export$8f7f3c48ca6fbe34, i.reportAllChanges), $e0d54fd891fbc3b9$var$r = [], $e0d54fd891fbc3b9$var$n = -1, $e0d54fd891fbc3b9$var$e = null, $e0d54fd891fbc3b9$var$k(addEventListener), o = l, $e0d54fd891fbc3b9$var$r.push(o), $e0d54fd891fbc3b9$var$F();
        });
    });
}, $e0d54fd891fbc3b9$var$B = 0, $e0d54fd891fbc3b9$var$R = 1 / 0, $e0d54fd891fbc3b9$var$H = 0, $e0d54fd891fbc3b9$var$N = function(e) {
    e.forEach(function(e) {
        e.interactionId && ($e0d54fd891fbc3b9$var$R = Math.min($e0d54fd891fbc3b9$var$R, e.interactionId), $e0d54fd891fbc3b9$var$H = Math.max($e0d54fd891fbc3b9$var$H, e.interactionId), $e0d54fd891fbc3b9$var$B = $e0d54fd891fbc3b9$var$H ? ($e0d54fd891fbc3b9$var$H - $e0d54fd891fbc3b9$var$R) / 7 + 1 : 0);
    });
}, $e0d54fd891fbc3b9$var$O = function() {
    return $e0d54fd891fbc3b9$var$i ? $e0d54fd891fbc3b9$var$B : performance.interactionCount || 0;
}, $e0d54fd891fbc3b9$var$q = function() {
    "interactionCount" in performance || $e0d54fd891fbc3b9$var$i || ($e0d54fd891fbc3b9$var$i = $e0d54fd891fbc3b9$var$s("event", $e0d54fd891fbc3b9$var$N, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, $e0d54fd891fbc3b9$export$7f4cb060ded9173c = [
    200,
    500
], $e0d54fd891fbc3b9$var$_ = 0, $e0d54fd891fbc3b9$var$z = function() {
    return $e0d54fd891fbc3b9$var$O() - $e0d54fd891fbc3b9$var$_;
}, $e0d54fd891fbc3b9$var$G = [], $e0d54fd891fbc3b9$var$J = {}, $e0d54fd891fbc3b9$var$K = function(e) {
    var n = $e0d54fd891fbc3b9$var$G[$e0d54fd891fbc3b9$var$G.length - 1], t = $e0d54fd891fbc3b9$var$J[e.interactionId];
    if (t || $e0d54fd891fbc3b9$var$G.length < 10 || e.duration > n.latency) {
        if (t) t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
        else {
            var r = {
                id: e.interactionId,
                latency: e.duration,
                entries: [
                    e
                ]
            };
            $e0d54fd891fbc3b9$var$J[r.id] = r, $e0d54fd891fbc3b9$var$G.push(r);
        }
        $e0d54fd891fbc3b9$var$G.sort(function(e, n) {
            return n.latency - e.latency;
        }), $e0d54fd891fbc3b9$var$G.splice(10).forEach(function(e) {
            delete $e0d54fd891fbc3b9$var$J[e.id];
        });
    }
}, $e0d54fd891fbc3b9$export$6693a9916ea977ef = function(e, n) {
    n = n || {}, $e0d54fd891fbc3b9$var$C(function() {
        var t;
        $e0d54fd891fbc3b9$var$q();
        var r, i = $e0d54fd891fbc3b9$var$f("INP"), a = function(e) {
            e.forEach(function(e) {
                (e.interactionId && $e0d54fd891fbc3b9$var$K(e), "first-input" === e.entryType) && !$e0d54fd891fbc3b9$var$G.some(function(n) {
                    return n.entries.some(function(n) {
                        return e.duration === n.duration && e.startTime === n.startTime;
                    });
                }) && $e0d54fd891fbc3b9$var$K(e);
            });
            var n, t = (n = Math.min($e0d54fd891fbc3b9$var$G.length - 1, Math.floor($e0d54fd891fbc3b9$var$z() / 50)), $e0d54fd891fbc3b9$var$G[n]);
            t && t.latency !== i.value && (i.value = t.latency, i.entries = t.entries, r());
        }, c = $e0d54fd891fbc3b9$var$s("event", a, {
            durationThreshold: null !== (t = n.durationThreshold) && void 0 !== t ? t : 40
        });
        r = $e0d54fd891fbc3b9$var$d(e, i, $e0d54fd891fbc3b9$export$7f4cb060ded9173c, n.reportAllChanges), c && ("interactionId" in PerformanceEventTiming.prototype && c.observe({
            type: "first-input",
            buffered: !0
        }), $e0d54fd891fbc3b9$var$p(function() {
            a(c.takeRecords()), i.value < 0 && $e0d54fd891fbc3b9$var$z() > 0 && (i.value = 0, i.entries = []), r(!0);
        }), $e0d54fd891fbc3b9$var$o(function() {
            $e0d54fd891fbc3b9$var$G = [], $e0d54fd891fbc3b9$var$_ = $e0d54fd891fbc3b9$var$O(), i = $e0d54fd891fbc3b9$var$f("INP"), r = $e0d54fd891fbc3b9$var$d(e, i, $e0d54fd891fbc3b9$export$7f4cb060ded9173c, n.reportAllChanges);
        }));
    });
}, $e0d54fd891fbc3b9$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $e0d54fd891fbc3b9$var$V = {}, $e0d54fd891fbc3b9$export$da982ced0ff8a670 = function(e, n) {
    n = n || {}, $e0d54fd891fbc3b9$var$C(function() {
        var t, r = $e0d54fd891fbc3b9$var$E(), i = $e0d54fd891fbc3b9$var$f("LCP"), a = function(e) {
            var n = e[e.length - 1];
            n && n.startTime < r.firstHiddenTime && (i.value = Math.max(n.startTime - $e0d54fd891fbc3b9$var$u(), 0), i.entries = [
                n
            ], t());
        }, c = $e0d54fd891fbc3b9$var$s("largest-contentful-paint", a);
        if (c) {
            t = $e0d54fd891fbc3b9$var$d(e, i, $e0d54fd891fbc3b9$export$948521ca5b0e1b17, n.reportAllChanges);
            var m = $e0d54fd891fbc3b9$var$v(function() {
                $e0d54fd891fbc3b9$var$V[i.id] || (a(c.takeRecords()), c.disconnect(), $e0d54fd891fbc3b9$var$V[i.id] = !0, t(!0));
            });
            [
                "keydown",
                "click"
            ].forEach(function(e) {
                addEventListener(e, function() {
                    return setTimeout(m, 0);
                }, !0);
            }), $e0d54fd891fbc3b9$var$p(m), $e0d54fd891fbc3b9$var$o(function(r) {
                i = $e0d54fd891fbc3b9$var$f("LCP"), t = $e0d54fd891fbc3b9$var$d(e, i, $e0d54fd891fbc3b9$export$948521ca5b0e1b17, n.reportAllChanges), $e0d54fd891fbc3b9$var$l(function() {
                    i.value = performance.now() - r.timeStamp, $e0d54fd891fbc3b9$var$V[i.id] = !0, t(!0);
                });
            });
        }
    });
}, $e0d54fd891fbc3b9$export$65c59ea8064668fc = [
    800,
    1800
], $e0d54fd891fbc3b9$var$Y = function e(n) {
    document.prerendering ? $e0d54fd891fbc3b9$var$C(function() {
        return e(n);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return e(n);
    }, !0) : setTimeout(n, 0);
}, $e0d54fd891fbc3b9$export$6e8eea9a35032c92 = function(e, n) {
    n = n || {};
    var t = $e0d54fd891fbc3b9$var$f("TTFB"), r = $e0d54fd891fbc3b9$var$d(e, t, $e0d54fd891fbc3b9$export$65c59ea8064668fc, n.reportAllChanges);
    $e0d54fd891fbc3b9$var$Y(function() {
        var i = $e0d54fd891fbc3b9$var$c();
        if (i) {
            var a = i.responseStart;
            if (a <= 0 || a > performance.now()) return;
            t.value = Math.max(a - $e0d54fd891fbc3b9$var$u(), 0), t.entries = [
                i
            ], r(!0), $e0d54fd891fbc3b9$var$o(function() {
                t = $e0d54fd891fbc3b9$var$f("TTFB", 0), (r = $e0d54fd891fbc3b9$var$d(e, t, $e0d54fd891fbc3b9$export$65c59ea8064668fc, n.reportAllChanges))(!0);
            });
        }
    });
};


const $f7967412a8f95f32$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) {
        (0, $e0d54fd891fbc3b9$export$fc6227831ee7c7)(onPerfEntry);
        (0, $e0d54fd891fbc3b9$export$134ed2977d320dfd)(onPerfEntry);
        (0, $e0d54fd891fbc3b9$export$52489892712e8192)(onPerfEntry);
        (0, $e0d54fd891fbc3b9$export$da982ced0ff8a670)(onPerfEntry);
        (0, $e0d54fd891fbc3b9$export$6e8eea9a35032c92)(onPerfEntry);
    }
};
var $f7967412a8f95f32$export$2e2bcd8739ae039 = $f7967412a8f95f32$var$reportWebVitals;








var $93e24499638c8db0$exports = {};

var $6qd2L = parcelRequire("6qd2L");

var $3aNd6 = parcelRequire("3aNd6");
var $93e24499638c8db0$require$Buffer = $3aNd6.Buffer;

var $1wVs5 = parcelRequire("1wVs5");
var $3019497903d0e8b4$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6qd2L = parcelRequire("6qd2L");
"use strict";
function $3019497903d0e8b4$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3019497903d0e8b4$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3019497903d0e8b4$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3019497903d0e8b4$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $6qd2L.cwd();
                path = cwd;
            }
            $3019497903d0e8b4$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3019497903d0e8b4$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3019497903d0e8b4$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3019497903d0e8b4$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3019497903d0e8b4$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3019497903d0e8b4$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3019497903d0e8b4$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3019497903d0e8b4$var$assertPath(from);
        $3019497903d0e8b4$var$assertPath(to);
        if (from === to) return "";
        from = $3019497903d0e8b4$var$posix.resolve(from);
        to = $3019497903d0e8b4$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3019497903d0e8b4$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3019497903d0e8b4$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3019497903d0e8b4$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3019497903d0e8b4$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3019497903d0e8b4$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3019497903d0e8b4$var$posix.posix = $3019497903d0e8b4$var$posix;
$3019497903d0e8b4$exports = $3019497903d0e8b4$var$posix;


var $c06d6e5924b66f1f$export$edf525f30916fbb8;
var $c06d6e5924b66f1f$export$640106f6dc7d2706;
var $c06d6e5924b66f1f$export$3ea386628068cf62;
var $c06d6e5924b66f1f$export$749d472264fad440;
var $c06d6e5924b66f1f$export$8b931a48d9488767;
var $c06d6e5924b66f1f$export$9123f37609399513;
var $c06d6e5924b66f1f$export$9b60beb643db4d69;
var $c06d6e5924b66f1f$export$bf9fb029d174d554;
var $c06d6e5924b66f1f$export$23d3fad09dc44362;
var $c06d6e5924b66f1f$export$d2f3c2f7e0c7dcf5;
var $c06d6e5924b66f1f$export$3bf7c33313eba0fe;
var $c06d6e5924b66f1f$export$7925d89f138dad5b;
var $c06d6e5924b66f1f$export$722a64dea1b767dc;
var $c06d6e5924b66f1f$export$9e6c06a7d47f9af7;
var $c06d6e5924b66f1f$export$6b76988456c0292f;
var $c06d6e5924b66f1f$export$266d3b9babd1fc45;
var $c06d6e5924b66f1f$export$c1d46b5ea6262c0b;
$c06d6e5924b66f1f$export$edf525f30916fbb8 = function() {
    return "LE";
};
$c06d6e5924b66f1f$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$c06d6e5924b66f1f$export$3ea386628068cf62 = function() {
    return [];
};
$c06d6e5924b66f1f$export$749d472264fad440 = function() {
    return 0;
};
$c06d6e5924b66f1f$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$c06d6e5924b66f1f$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$c06d6e5924b66f1f$export$9b60beb643db4d69 = function() {
    return [];
};
$c06d6e5924b66f1f$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$c06d6e5924b66f1f$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$c06d6e5924b66f1f$export$d2f3c2f7e0c7dcf5 = $c06d6e5924b66f1f$export$3bf7c33313eba0fe = function() {
    return {};
};
$c06d6e5924b66f1f$export$7925d89f138dad5b = function() {
    return "javascript";
};
$c06d6e5924b66f1f$export$722a64dea1b767dc = function() {
    return "browser";
};
$c06d6e5924b66f1f$export$9e6c06a7d47f9af7 = $c06d6e5924b66f1f$export$6b76988456c0292f = function() {
    return "/tmp";
};
$c06d6e5924b66f1f$export$266d3b9babd1fc45 = "\n";
$c06d6e5924b66f1f$export$c1d46b5ea6262c0b = function() {
    return "/";
};


var $504f31b65a80c09b$export$5f828d93ff035aa8;
var $504f31b65a80c09b$export$cd94982b18c6332c;
var $504f31b65a80c09b$export$1d518568e4f529b0;
var $504f31b65a80c09b$export$5285b6d41c912b41;
var $504f31b65a80c09b$export$2fb37efbf6ae0c0e;
var $504f31b65a80c09b$export$ab85ecd77ce6a5cd;
var $504f31b65a80c09b$export$da39cf97e1eb7c91;
var $504f31b65a80c09b$export$52a9039d7177394f;
var $504f31b65a80c09b$export$f7201db400317331;
var $504f31b65a80c09b$export$448fa22aedc9dbca;
var $504f31b65a80c09b$export$b80c7ba289c8fa56;
var $504f31b65a80c09b$export$26e5786e8ac8e530;
var $504f31b65a80c09b$export$bdd223f16383713e;
var $504f31b65a80c09b$export$20533d26f07f1ee0;
var $504f31b65a80c09b$export$2f64596b8cbf08b4;
var $504f31b65a80c09b$export$2ce6d8d0e8b04e1a;
var $504f31b65a80c09b$export$12ada9414fbc594c;
var $504f31b65a80c09b$export$f5e7e39d57cd9700;
var $504f31b65a80c09b$export$36b6d6ef312eab39;
var $504f31b65a80c09b$export$58a258485f1e49f6;
var $504f31b65a80c09b$export$dedd8dc3dc62b370;
var $504f31b65a80c09b$export$971862a2fcb1bb40;
var $504f31b65a80c09b$export$c6ff6a88acbeaf40;
var $504f31b65a80c09b$export$fdc27893e98845cc;
var $504f31b65a80c09b$export$6671fb9a1323bed;
var $504f31b65a80c09b$export$d74daf141a551db;
var $504f31b65a80c09b$export$45df7cae684751af;
var $504f31b65a80c09b$export$1db683ad541682f6;
var $504f31b65a80c09b$export$6f65485f87568e37;
var $504f31b65a80c09b$export$91a8e56769aeb334;
var $504f31b65a80c09b$export$2d4117e99c2179e4;
var $504f31b65a80c09b$export$512823e338ddb1b7;
var $504f31b65a80c09b$export$9d0e0c0c4a8d30f3;
var $504f31b65a80c09b$export$b9d55ff329113abd;
var $504f31b65a80c09b$export$7efb24e2fddf99b9;
var $504f31b65a80c09b$export$bb1abf2ce84fc7e8;
var $504f31b65a80c09b$export$2f7171e78e524d5e;
var $504f31b65a80c09b$export$e1d879b482f37d98;
var $504f31b65a80c09b$export$1a988e7317c65621;
"use strict";

$504f31b65a80c09b$export$5f828d93ff035aa8 = $504f31b65a80c09b$export$cd94982b18c6332c = $504f31b65a80c09b$export$1d518568e4f529b0 = $504f31b65a80c09b$export$5285b6d41c912b41 = (parcelRequire("5LzvA"));

$504f31b65a80c09b$export$2fb37efbf6ae0c0e = $504f31b65a80c09b$export$ab85ecd77ce6a5cd = (parcelRequire("3YkjF"));

$504f31b65a80c09b$export$da39cf97e1eb7c91 = $504f31b65a80c09b$export$52a9039d7177394f = (parcelRequire("2Mjvp"));
var $5ce945955facc0cb$exports = {};
"use strict";

$5ce945955facc0cb$exports = (parcelRequire("1rAns"));


var $504f31b65a80c09b$var$algoKeys = Object.keys($5ce945955facc0cb$exports);
var $504f31b65a80c09b$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($504f31b65a80c09b$var$algoKeys);
$504f31b65a80c09b$export$f7201db400317331 = function() {
    return $504f31b65a80c09b$var$hashes;
};

var $6hZjq = parcelRequire("6hZjq");
$504f31b65a80c09b$export$448fa22aedc9dbca = $6hZjq.pbkdf2;
$504f31b65a80c09b$export$b80c7ba289c8fa56 = $6hZjq.pbkdf2Sync;
var $6f425b6d5bc75d1b$export$bdd223f16383713e;
var $6f425b6d5bc75d1b$export$26e5786e8ac8e530;
var $6f425b6d5bc75d1b$export$2f64596b8cbf08b4;
var $6f425b6d5bc75d1b$export$20533d26f07f1ee0;
var $6f425b6d5bc75d1b$export$12ada9414fbc594c;
var $6f425b6d5bc75d1b$export$2ce6d8d0e8b04e1a;
var $6f425b6d5bc75d1b$export$36b6d6ef312eab39;
var $6f425b6d5bc75d1b$export$f5e7e39d57cd9700;
var $6f425b6d5bc75d1b$export$dedd8dc3dc62b370;
var $6f425b6d5bc75d1b$export$58a258485f1e49f6;
var $091dc05511ab9752$exports = {};

var $7J5an = parcelRequire("7J5an");
var $3051b460d3c4da95$export$eab97d15b1788b8d;
var $3051b460d3c4da95$export$26e5786e8ac8e530;
var $3051b460d3c4da95$export$cc8859615686b300;
var $3051b460d3c4da95$export$8ad3f227af08fcc5;
var $3051b460d3c4da95$export$947646e34766044f;
"use strict";

$3051b460d3c4da95$export$eab97d15b1788b8d = (parcelRequire("jn6kT"));

$3051b460d3c4da95$export$26e5786e8ac8e530 = (parcelRequire("DGe5D"));

$3051b460d3c4da95$export$cc8859615686b300 = (parcelRequire("3y8O7"));

$3051b460d3c4da95$export$8ad3f227af08fcc5 = (parcelRequire("gmK95"));

$3051b460d3c4da95$export$947646e34766044f = (parcelRequire("7CBPk"));



var $9M38k = parcelRequire("9M38k");

var $2iVwY = parcelRequire("2iVwY");
var $091dc05511ab9752$require$Buffer = $2iVwY.Buffer;
var $091dc05511ab9752$var$modes = {
    "des-ede3-cbc": $3051b460d3c4da95$export$8ad3f227af08fcc5.instantiate($3051b460d3c4da95$export$947646e34766044f),
    "des-ede3": $3051b460d3c4da95$export$947646e34766044f,
    "des-ede-cbc": $3051b460d3c4da95$export$8ad3f227af08fcc5.instantiate($3051b460d3c4da95$export$947646e34766044f),
    "des-ede": $3051b460d3c4da95$export$947646e34766044f,
    "des-cbc": $3051b460d3c4da95$export$8ad3f227af08fcc5.instantiate($3051b460d3c4da95$export$cc8859615686b300),
    "des-ecb": $3051b460d3c4da95$export$cc8859615686b300
};
$091dc05511ab9752$var$modes.des = $091dc05511ab9752$var$modes["des-cbc"];
$091dc05511ab9752$var$modes.des3 = $091dc05511ab9752$var$modes["des-ede3-cbc"];
$091dc05511ab9752$exports = $091dc05511ab9752$var$DES;
$9M38k($091dc05511ab9752$var$DES, $7J5an);
function $091dc05511ab9752$var$DES(opts) {
    $7J5an.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $091dc05511ab9752$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$091dc05511ab9752$require$Buffer.isBuffer(key)) key = $091dc05511ab9752$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $091dc05511ab9752$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$091dc05511ab9752$require$Buffer.isBuffer(iv)) iv = $091dc05511ab9752$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$091dc05511ab9752$var$DES.prototype._update = function(data) {
    return $091dc05511ab9752$require$Buffer.from(this._des.update(data));
};
$091dc05511ab9752$var$DES.prototype._final = function() {
    return $091dc05511ab9752$require$Buffer.from(this._des.final());
};



var $eHJJG = parcelRequire("eHJJG");

var $l6VnM = parcelRequire("l6VnM");
var $d4a3b2ee58876549$exports = {};

$parcel$export($d4a3b2ee58876549$exports, "des-ecb", function () { return $d4a3b2ee58876549$export$116f8a5cee447347; }, function (v) { return $d4a3b2ee58876549$export$116f8a5cee447347 = v; });
$parcel$export($d4a3b2ee58876549$exports, "des-cbc", function () { return $d4a3b2ee58876549$export$7483c4066bfb7ae9; }, function (v) { return $d4a3b2ee58876549$export$7483c4066bfb7ae9 = v; });
$parcel$export($d4a3b2ee58876549$exports, "des", function () { return $d4a3b2ee58876549$export$e7a565d2e588bb06; }, function (v) { return $d4a3b2ee58876549$export$e7a565d2e588bb06 = v; });
$parcel$export($d4a3b2ee58876549$exports, "des-ede3-cbc", function () { return $d4a3b2ee58876549$export$aaa2f54a426f3eb8; }, function (v) { return $d4a3b2ee58876549$export$aaa2f54a426f3eb8 = v; });
$parcel$export($d4a3b2ee58876549$exports, "des3", function () { return $d4a3b2ee58876549$export$eba20568dde4ada; }, function (v) { return $d4a3b2ee58876549$export$eba20568dde4ada = v; });
$parcel$export($d4a3b2ee58876549$exports, "des-ede3", function () { return $d4a3b2ee58876549$export$d3b5e5996938f5ae; }, function (v) { return $d4a3b2ee58876549$export$d3b5e5996938f5ae = v; });
$parcel$export($d4a3b2ee58876549$exports, "des-ede-cbc", function () { return $d4a3b2ee58876549$export$57c08356130bc99b; }, function (v) { return $d4a3b2ee58876549$export$57c08356130bc99b = v; });
$parcel$export($d4a3b2ee58876549$exports, "des-ede", function () { return $d4a3b2ee58876549$export$c7169791d5c1e65d; }, function (v) { return $d4a3b2ee58876549$export$c7169791d5c1e65d = v; });
var $d4a3b2ee58876549$export$116f8a5cee447347;
var $d4a3b2ee58876549$export$7483c4066bfb7ae9;
var $d4a3b2ee58876549$export$e7a565d2e588bb06;
var $d4a3b2ee58876549$export$aaa2f54a426f3eb8;
var $d4a3b2ee58876549$export$eba20568dde4ada;
var $d4a3b2ee58876549$export$d3b5e5996938f5ae;
var $d4a3b2ee58876549$export$57c08356130bc99b;
var $d4a3b2ee58876549$export$c7169791d5c1e65d;
$d4a3b2ee58876549$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$d4a3b2ee58876549$export$7483c4066bfb7ae9 = $d4a3b2ee58876549$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$d4a3b2ee58876549$export$aaa2f54a426f3eb8 = $d4a3b2ee58876549$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$d4a3b2ee58876549$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$d4a3b2ee58876549$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$d4a3b2ee58876549$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $aXh1Z = parcelRequire("aXh1Z");
function $6f425b6d5bc75d1b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($l6VnM[suite]) {
        keyLen = $l6VnM[suite].key;
        ivLen = $l6VnM[suite].iv;
    } else if ($d4a3b2ee58876549$exports[suite]) {
        keyLen = $d4a3b2ee58876549$exports[suite].key * 8;
        ivLen = $d4a3b2ee58876549$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $aXh1Z(password, false, keyLen, ivLen);
    return $6f425b6d5bc75d1b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $6f425b6d5bc75d1b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($l6VnM[suite]) {
        keyLen = $l6VnM[suite].key;
        ivLen = $l6VnM[suite].iv;
    } else if ($d4a3b2ee58876549$exports[suite]) {
        keyLen = $d4a3b2ee58876549$exports[suite].key * 8;
        ivLen = $d4a3b2ee58876549$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $aXh1Z(password, false, keyLen, ivLen);
    return $6f425b6d5bc75d1b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $6f425b6d5bc75d1b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($l6VnM[suite]) return $eHJJG.createCipheriv(suite, key, iv);
    if ($d4a3b2ee58876549$exports[suite]) return new $091dc05511ab9752$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $6f425b6d5bc75d1b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($l6VnM[suite]) return $eHJJG.createDecipheriv(suite, key, iv);
    if ($d4a3b2ee58876549$exports[suite]) return new $091dc05511ab9752$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $6f425b6d5bc75d1b$var$getCiphers() {
    return Object.keys($d4a3b2ee58876549$exports).concat($eHJJG.getCiphers());
}
$6f425b6d5bc75d1b$export$bdd223f16383713e = $6f425b6d5bc75d1b$export$26e5786e8ac8e530 = $6f425b6d5bc75d1b$var$createCipher;
$6f425b6d5bc75d1b$export$2f64596b8cbf08b4 = $6f425b6d5bc75d1b$export$20533d26f07f1ee0 = $6f425b6d5bc75d1b$var$createCipheriv;
$6f425b6d5bc75d1b$export$12ada9414fbc594c = $6f425b6d5bc75d1b$export$2ce6d8d0e8b04e1a = $6f425b6d5bc75d1b$var$createDecipher;
$6f425b6d5bc75d1b$export$36b6d6ef312eab39 = $6f425b6d5bc75d1b$export$f5e7e39d57cd9700 = $6f425b6d5bc75d1b$var$createDecipheriv;
$6f425b6d5bc75d1b$export$dedd8dc3dc62b370 = $6f425b6d5bc75d1b$export$58a258485f1e49f6 = $6f425b6d5bc75d1b$var$getCiphers;


$504f31b65a80c09b$export$26e5786e8ac8e530 = $6f425b6d5bc75d1b$export$26e5786e8ac8e530;
$504f31b65a80c09b$export$bdd223f16383713e = $6f425b6d5bc75d1b$export$bdd223f16383713e;
$504f31b65a80c09b$export$20533d26f07f1ee0 = $6f425b6d5bc75d1b$export$20533d26f07f1ee0;
$504f31b65a80c09b$export$2f64596b8cbf08b4 = $6f425b6d5bc75d1b$export$2f64596b8cbf08b4;
$504f31b65a80c09b$export$2ce6d8d0e8b04e1a = $6f425b6d5bc75d1b$export$2ce6d8d0e8b04e1a;
$504f31b65a80c09b$export$12ada9414fbc594c = $6f425b6d5bc75d1b$export$12ada9414fbc594c;
$504f31b65a80c09b$export$f5e7e39d57cd9700 = $6f425b6d5bc75d1b$export$f5e7e39d57cd9700;
$504f31b65a80c09b$export$36b6d6ef312eab39 = $6f425b6d5bc75d1b$export$36b6d6ef312eab39;
$504f31b65a80c09b$export$58a258485f1e49f6 = $6f425b6d5bc75d1b$export$58a258485f1e49f6;
$504f31b65a80c09b$export$dedd8dc3dc62b370 = $6f425b6d5bc75d1b$export$dedd8dc3dc62b370;
var $4220e5a2d50cf8a2$export$971862a2fcb1bb40;
var $4220e5a2d50cf8a2$export$c6ff6a88acbeaf40;
var $4220e5a2d50cf8a2$export$fdc27893e98845cc;
var $4220e5a2d50cf8a2$export$6671fb9a1323bed;
var $4220e5a2d50cf8a2$export$d74daf141a551db;

var $3aNd6 = parcelRequire("3aNd6");
var $4220e5a2d50cf8a2$require$Buffer = $3aNd6.Buffer;
var $99c7c3fc8db05775$exports = {};

var $5LzvA = parcelRequire("5LzvA");
$99c7c3fc8db05775$exports = $99c7c3fc8db05775$var$findPrime;
$99c7c3fc8db05775$var$findPrime.simpleSieve = $99c7c3fc8db05775$var$simpleSieve;
$99c7c3fc8db05775$var$findPrime.fermatTest = $99c7c3fc8db05775$var$fermatTest;

var $jIdU0 = parcelRequire("jIdU0");
var $99c7c3fc8db05775$var$TWENTYFOUR = new $jIdU0(24);
var $0a9fe34329a90bab$exports = {};

var $d34BP = parcelRequire("d34BP");

var $lQohp = parcelRequire("lQohp");
function $0a9fe34329a90bab$var$MillerRabin(rand) {
    this.rand = rand || new $lQohp.Rand();
}
$0a9fe34329a90bab$exports = $0a9fe34329a90bab$var$MillerRabin;
$0a9fe34329a90bab$var$MillerRabin.create = function create(rand) {
    return new $0a9fe34329a90bab$var$MillerRabin(rand);
};
$0a9fe34329a90bab$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $d34BP(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$0a9fe34329a90bab$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$0a9fe34329a90bab$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $d34BP.mont(n);
    var rone = new $d34BP(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $d34BP(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$0a9fe34329a90bab$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $d34BP.mont(n);
    var rone = new $d34BP(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $d34BP(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $99c7c3fc8db05775$var$millerRabin = new $0a9fe34329a90bab$exports();
var $99c7c3fc8db05775$var$ONE = new $jIdU0(1);
var $99c7c3fc8db05775$var$TWO = new $jIdU0(2);
var $99c7c3fc8db05775$var$FIVE = new $jIdU0(5);
var $99c7c3fc8db05775$var$SIXTEEN = new $jIdU0(16);
var $99c7c3fc8db05775$var$EIGHT = new $jIdU0(8);
var $99c7c3fc8db05775$var$TEN = new $jIdU0(10);
var $99c7c3fc8db05775$var$THREE = new $jIdU0(3);
var $99c7c3fc8db05775$var$SEVEN = new $jIdU0(7);
var $99c7c3fc8db05775$var$ELEVEN = new $jIdU0(11);
var $99c7c3fc8db05775$var$FOUR = new $jIdU0(4);
var $99c7c3fc8db05775$var$TWELVE = new $jIdU0(12);
var $99c7c3fc8db05775$var$primes = null;
function $99c7c3fc8db05775$var$_getPrimes() {
    if ($99c7c3fc8db05775$var$primes !== null) return $99c7c3fc8db05775$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $99c7c3fc8db05775$var$primes = res;
    return res;
}
function $99c7c3fc8db05775$var$simpleSieve(p) {
    var primes = $99c7c3fc8db05775$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $99c7c3fc8db05775$var$fermatTest(p) {
    var red = $jIdU0.mont(p);
    return $99c7c3fc8db05775$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $99c7c3fc8db05775$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $jIdU0([
            0x8c,
            0x7b
        ]);
        else return new $jIdU0([
            0x8c,
            0x27
        ]);
    }
    gen = new $jIdU0(gen);
    var num, n2;
    while(true){
        num = new $jIdU0($5LzvA(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($99c7c3fc8db05775$var$ONE);
        if (!num.testn(1)) num.iadd($99c7c3fc8db05775$var$TWO);
        if (!gen.cmp($99c7c3fc8db05775$var$TWO)) while(num.mod($99c7c3fc8db05775$var$TWENTYFOUR).cmp($99c7c3fc8db05775$var$ELEVEN))num.iadd($99c7c3fc8db05775$var$FOUR);
        else if (!gen.cmp($99c7c3fc8db05775$var$FIVE)) while(num.mod($99c7c3fc8db05775$var$TEN).cmp($99c7c3fc8db05775$var$THREE))num.iadd($99c7c3fc8db05775$var$FOUR);
        n2 = num.shrn(1);
        if ($99c7c3fc8db05775$var$simpleSieve(n2) && $99c7c3fc8db05775$var$simpleSieve(num) && $99c7c3fc8db05775$var$fermatTest(n2) && $99c7c3fc8db05775$var$fermatTest(num) && $99c7c3fc8db05775$var$millerRabin.test(n2) && $99c7c3fc8db05775$var$millerRabin.test(num)) return num;
    }
}


var $5d389a7fb7c4bd8d$exports = {};
$5d389a7fb7c4bd8d$exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');


var $d104c7bfb0b60c64$exports = {};

var $3aNd6 = parcelRequire("3aNd6");
var $d104c7bfb0b60c64$require$Buffer = $3aNd6.Buffer;

var $jIdU0 = parcelRequire("jIdU0");

var $d104c7bfb0b60c64$var$millerRabin = new $0a9fe34329a90bab$exports();
var $d104c7bfb0b60c64$var$TWENTYFOUR = new $jIdU0(24);
var $d104c7bfb0b60c64$var$ELEVEN = new $jIdU0(11);
var $d104c7bfb0b60c64$var$TEN = new $jIdU0(10);
var $d104c7bfb0b60c64$var$THREE = new $jIdU0(3);
var $d104c7bfb0b60c64$var$SEVEN = new $jIdU0(7);


var $5LzvA = parcelRequire("5LzvA");
$d104c7bfb0b60c64$exports = $d104c7bfb0b60c64$var$DH;
function $d104c7bfb0b60c64$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$d104c7bfb0b60c64$require$Buffer.isBuffer(pub)) pub = new $d104c7bfb0b60c64$require$Buffer(pub, enc);
    this._pub = new $jIdU0(pub);
    return this;
}
function $d104c7bfb0b60c64$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$d104c7bfb0b60c64$require$Buffer.isBuffer(priv)) priv = new $d104c7bfb0b60c64$require$Buffer(priv, enc);
    this._priv = new $jIdU0(priv);
    return this;
}
var $d104c7bfb0b60c64$var$primeCache = {};
function $d104c7bfb0b60c64$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $d104c7bfb0b60c64$var$primeCache) return $d104c7bfb0b60c64$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$99c7c3fc8db05775$exports.simpleSieve || !$99c7c3fc8db05775$exports.fermatTest(prime) || !$d104c7bfb0b60c64$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $d104c7bfb0b60c64$var$primeCache[hex] = error;
        return error;
    }
    if (!$d104c7bfb0b60c64$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($d104c7bfb0b60c64$var$TWENTYFOUR).cmp($d104c7bfb0b60c64$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($d104c7bfb0b60c64$var$TEN);
            if (rem.cmp($d104c7bfb0b60c64$var$THREE) && rem.cmp($d104c7bfb0b60c64$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $d104c7bfb0b60c64$var$primeCache[hex] = error;
    return error;
}
function $d104c7bfb0b60c64$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $jIdU0(prime);
    this._prime = $jIdU0.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $d104c7bfb0b60c64$var$setPublicKey;
        this.setPrivateKey = $d104c7bfb0b60c64$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($d104c7bfb0b60c64$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $d104c7bfb0b60c64$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$d104c7bfb0b60c64$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $jIdU0($5LzvA(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$d104c7bfb0b60c64$var$DH.prototype.computeSecret = function(other) {
    other = new $jIdU0(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $d104c7bfb0b60c64$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $d104c7bfb0b60c64$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $d104c7bfb0b60c64$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$d104c7bfb0b60c64$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $d104c7bfb0b60c64$var$formatReturnValue(this._pub, enc);
};
$d104c7bfb0b60c64$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $d104c7bfb0b60c64$var$formatReturnValue(this._priv, enc);
};
$d104c7bfb0b60c64$var$DH.prototype.getPrime = function(enc) {
    return $d104c7bfb0b60c64$var$formatReturnValue(this.__prime, enc);
};
$d104c7bfb0b60c64$var$DH.prototype.getGenerator = function(enc) {
    return $d104c7bfb0b60c64$var$formatReturnValue(this._gen, enc);
};
$d104c7bfb0b60c64$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$d104c7bfb0b60c64$require$Buffer.isBuffer(gen)) gen = new $d104c7bfb0b60c64$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $jIdU0(gen);
    return this;
};
function $d104c7bfb0b60c64$var$formatReturnValue(bn, enc) {
    var buf = new $d104c7bfb0b60c64$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $4220e5a2d50cf8a2$var$getDiffieHellman(mod) {
    var prime = new $4220e5a2d50cf8a2$require$Buffer($5d389a7fb7c4bd8d$exports[mod].prime, "hex");
    var gen = new $4220e5a2d50cf8a2$require$Buffer($5d389a7fb7c4bd8d$exports[mod].gen, "hex");
    return new $d104c7bfb0b60c64$exports(prime, gen);
}
var $4220e5a2d50cf8a2$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4220e5a2d50cf8a2$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4220e5a2d50cf8a2$require$Buffer.isBuffer(enc) || $4220e5a2d50cf8a2$var$ENCODINGS[enc] === undefined) return $4220e5a2d50cf8a2$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4220e5a2d50cf8a2$require$Buffer([
        2
    ]);
    if (!$4220e5a2d50cf8a2$require$Buffer.isBuffer(generator)) generator = new $4220e5a2d50cf8a2$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $d104c7bfb0b60c64$exports($99c7c3fc8db05775$exports(prime, generator), generator, true);
    if (!$4220e5a2d50cf8a2$require$Buffer.isBuffer(prime)) prime = new $4220e5a2d50cf8a2$require$Buffer(prime, enc);
    return new $d104c7bfb0b60c64$exports(prime, generator, true);
}
$4220e5a2d50cf8a2$export$971862a2fcb1bb40 = $4220e5a2d50cf8a2$export$c6ff6a88acbeaf40 = $4220e5a2d50cf8a2$export$fdc27893e98845cc = $4220e5a2d50cf8a2$var$getDiffieHellman;
$4220e5a2d50cf8a2$export$6671fb9a1323bed = $4220e5a2d50cf8a2$export$d74daf141a551db = $4220e5a2d50cf8a2$var$createDiffieHellman;


$504f31b65a80c09b$export$971862a2fcb1bb40 = $4220e5a2d50cf8a2$export$971862a2fcb1bb40;
$504f31b65a80c09b$export$c6ff6a88acbeaf40 = $4220e5a2d50cf8a2$export$c6ff6a88acbeaf40;
$504f31b65a80c09b$export$fdc27893e98845cc = $4220e5a2d50cf8a2$export$fdc27893e98845cc;
$504f31b65a80c09b$export$6671fb9a1323bed = $4220e5a2d50cf8a2$export$6671fb9a1323bed;
$504f31b65a80c09b$export$d74daf141a551db = $4220e5a2d50cf8a2$export$d74daf141a551db;
var $1744fd5c08b76d0d$exports = {};
"use strict";

var $2iVwY = parcelRequire("2iVwY");
var $1744fd5c08b76d0d$require$Buffer = $2iVwY.Buffer;

var $3YkjF = parcelRequire("3YkjF");

var $ltxkj = parcelRequire("ltxkj");

var $9M38k = parcelRequire("9M38k");
var $d81e6f06d6d2c398$exports = {};
"use strict";

var $2iVwY = parcelRequire("2iVwY");
var $d81e6f06d6d2c398$require$Buffer = $2iVwY.Buffer;

var $2Mjvp = parcelRequire("2Mjvp");

var $gT4EJ = parcelRequire("gT4EJ");

var $7AZol = parcelRequire("7AZol");
var $d81e6f06d6d2c398$require$EC = $7AZol.ec;

var $fE5db = parcelRequire("fE5db");

var $9rqjB = parcelRequire("9rqjB");
var $45471c3b06a1b6cd$exports = {};
$45471c3b06a1b6cd$exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');


var $d81e6f06d6d2c398$var$RSA_PKCS1_PADDING = 1;
function $d81e6f06d6d2c398$var$sign(hash, key, hashType, signType, tag) {
    var priv = $9rqjB(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $d81e6f06d6d2c398$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $d81e6f06d6d2c398$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $d81e6f06d6d2c398$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $d81e6f06d6d2c398$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $gT4EJ(pad, priv);
    return out;
}
function $d81e6f06d6d2c398$var$ecSign(hash, priv) {
    var curveId = $45471c3b06a1b6cd$exports[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $d81e6f06d6d2c398$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $d81e6f06d6d2c398$require$Buffer.from(out.toDER());
}
function $d81e6f06d6d2c398$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $fE5db(0);
    var k;
    var H = $d81e6f06d6d2c398$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $d81e6f06d6d2c398$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $d81e6f06d6d2c398$var$makeKey(q, kv, algo);
        r = $d81e6f06d6d2c398$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $fE5db(0);
        }
    }
    return $d81e6f06d6d2c398$var$toDER(r, s);
}
function $d81e6f06d6d2c398$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $d81e6f06d6d2c398$require$Buffer.from(res);
}
function $d81e6f06d6d2c398$var$getKey(x, q, hash, algo) {
    x = $d81e6f06d6d2c398$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $d81e6f06d6d2c398$require$Buffer.alloc(q.byteLength() - x.length);
        x = $d81e6f06d6d2c398$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $d81e6f06d6d2c398$var$bits2octets(hash, q);
    var v = $d81e6f06d6d2c398$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $d81e6f06d6d2c398$require$Buffer.alloc(hlen);
    k = $2Mjvp(algo, k).update(v).update($d81e6f06d6d2c398$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $2Mjvp(algo, k).update(v).digest();
    k = $2Mjvp(algo, k).update(v).update($d81e6f06d6d2c398$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $2Mjvp(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $d81e6f06d6d2c398$var$bits2int(obits, q) {
    var bits = new $fE5db(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $d81e6f06d6d2c398$var$bits2octets(bits, q) {
    bits = $d81e6f06d6d2c398$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $d81e6f06d6d2c398$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $d81e6f06d6d2c398$require$Buffer.alloc(q.byteLength() - out.length);
        out = $d81e6f06d6d2c398$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $d81e6f06d6d2c398$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $d81e6f06d6d2c398$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $2Mjvp(algo, kv.k).update(kv.v).digest();
            t = $d81e6f06d6d2c398$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $d81e6f06d6d2c398$var$bits2int(t, q);
        kv.k = $2Mjvp(algo, kv.k).update(kv.v).update($d81e6f06d6d2c398$require$Buffer.from([
            0
        ])).digest();
        kv.v = $2Mjvp(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $d81e6f06d6d2c398$var$makeR(g, k, p, q) {
    return g.toRed($fE5db.mont(p)).redPow(k).fromRed().mod(q);
}
$d81e6f06d6d2c398$exports = $d81e6f06d6d2c398$var$sign;
$d81e6f06d6d2c398$exports.getKey = $d81e6f06d6d2c398$var$getKey;
$d81e6f06d6d2c398$exports.makeKey = $d81e6f06d6d2c398$var$makeKey;


var $ec9c04ba7bb6408a$exports = {};
"use strict";

var $2iVwY = parcelRequire("2iVwY");
var $ec9c04ba7bb6408a$require$Buffer = $2iVwY.Buffer;

var $fE5db = parcelRequire("fE5db");

var $7AZol = parcelRequire("7AZol");
var $ec9c04ba7bb6408a$require$EC = $7AZol.ec;

var $9rqjB = parcelRequire("9rqjB");

function $ec9c04ba7bb6408a$var$verify(sig, hash, key, signType, tag) {
    var pub = $9rqjB(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $ec9c04ba7bb6408a$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $ec9c04ba7bb6408a$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $ec9c04ba7bb6408a$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $ec9c04ba7bb6408a$require$Buffer.from(pad);
    var red = $fE5db.mont(pub.modulus);
    sig = new $fE5db(sig).toRed(red);
    sig = sig.redPow(new $fE5db(pub.publicExponent));
    sig = $ec9c04ba7bb6408a$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $ec9c04ba7bb6408a$var$ecVerify(sig, hash, pub) {
    var curveId = $45471c3b06a1b6cd$exports[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $ec9c04ba7bb6408a$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $ec9c04ba7bb6408a$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $9rqjB.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $ec9c04ba7bb6408a$var$checkValue(s, q);
    $ec9c04ba7bb6408a$var$checkValue(r, q);
    var montp = $fE5db.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $fE5db(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $ec9c04ba7bb6408a$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
$ec9c04ba7bb6408a$exports = $ec9c04ba7bb6408a$var$verify;



var $1rAns = parcelRequire("1rAns");
Object.keys($1rAns).forEach(function(key) {
    $1rAns[key].id = $1744fd5c08b76d0d$require$Buffer.from($1rAns[key].id, "hex");
    $1rAns[key.toLowerCase()] = $1rAns[key];
});
function $1744fd5c08b76d0d$var$Sign(algorithm) {
    $ltxkj.Writable.call(this);
    var data = $1rAns[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $3YkjF(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$9M38k($1744fd5c08b76d0d$var$Sign, $ltxkj.Writable);
$1744fd5c08b76d0d$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$1744fd5c08b76d0d$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $1744fd5c08b76d0d$require$Buffer.from(data, enc) : data);
    return this;
};
$1744fd5c08b76d0d$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $d81e6f06d6d2c398$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $1744fd5c08b76d0d$var$Verify(algorithm) {
    $ltxkj.Writable.call(this);
    var data = $1rAns[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $3YkjF(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$9M38k($1744fd5c08b76d0d$var$Verify, $ltxkj.Writable);
$1744fd5c08b76d0d$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$1744fd5c08b76d0d$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $1744fd5c08b76d0d$require$Buffer.from(data, enc) : data);
    return this;
};
$1744fd5c08b76d0d$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $1744fd5c08b76d0d$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $ec9c04ba7bb6408a$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $1744fd5c08b76d0d$var$createSign(algorithm) {
    return new $1744fd5c08b76d0d$var$Sign(algorithm);
}
function $1744fd5c08b76d0d$var$createVerify(algorithm) {
    return new $1744fd5c08b76d0d$var$Verify(algorithm);
}
$1744fd5c08b76d0d$exports = {
    Sign: $1744fd5c08b76d0d$var$createSign,
    Verify: $1744fd5c08b76d0d$var$createVerify,
    createSign: $1744fd5c08b76d0d$var$createSign,
    createVerify: $1744fd5c08b76d0d$var$createVerify
};


$504f31b65a80c09b$export$45df7cae684751af = $1744fd5c08b76d0d$exports.createSign;
$504f31b65a80c09b$export$1db683ad541682f6 = $1744fd5c08b76d0d$exports.Sign;
$504f31b65a80c09b$export$6f65485f87568e37 = $1744fd5c08b76d0d$exports.createVerify;
$504f31b65a80c09b$export$91a8e56769aeb334 = $1744fd5c08b76d0d$exports.Verify;

$504f31b65a80c09b$export$2d4117e99c2179e4 = (parcelRequire("6mKpT"));
var $170d84b6e7b1e1ed$export$512823e338ddb1b7;
var $170d84b6e7b1e1ed$export$7efb24e2fddf99b9;
var $170d84b6e7b1e1ed$export$9d0e0c0c4a8d30f3;
var $170d84b6e7b1e1ed$export$b9d55ff329113abd;

$170d84b6e7b1e1ed$export$512823e338ddb1b7 = (parcelRequire("dQ8X2"));

$170d84b6e7b1e1ed$export$7efb24e2fddf99b9 = (parcelRequire("8TX9t"));
$170d84b6e7b1e1ed$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $170d84b6e7b1e1ed$export$512823e338ddb1b7(key, buf, true);
};
$170d84b6e7b1e1ed$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $170d84b6e7b1e1ed$export$7efb24e2fddf99b9(key, buf, true);
};


$504f31b65a80c09b$export$512823e338ddb1b7 = $170d84b6e7b1e1ed$export$512823e338ddb1b7;
$504f31b65a80c09b$export$9d0e0c0c4a8d30f3 = $170d84b6e7b1e1ed$export$9d0e0c0c4a8d30f3;
$504f31b65a80c09b$export$b9d55ff329113abd = $170d84b6e7b1e1ed$export$b9d55ff329113abd;
$504f31b65a80c09b$export$7efb24e2fddf99b9 = $170d84b6e7b1e1ed$export$7efb24e2fddf99b9;
var $de0f6a87ab84e4d7$export$bb1abf2ce84fc7e8;
var $de0f6a87ab84e4d7$export$2f7171e78e524d5e;

var $6qd2L = parcelRequire("6qd2L");
"use strict";
function $de0f6a87ab84e4d7$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $2iVwY = parcelRequire("2iVwY");

var $5LzvA = parcelRequire("5LzvA");
var $de0f6a87ab84e4d7$var$Buffer = $2iVwY.Buffer;
var $de0f6a87ab84e4d7$var$kBufferMaxLength = $2iVwY.kMaxLength;
var $de0f6a87ab84e4d7$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $de0f6a87ab84e4d7$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $de0f6a87ab84e4d7$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $de0f6a87ab84e4d7$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $de0f6a87ab84e4d7$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $de0f6a87ab84e4d7$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $de0f6a87ab84e4d7$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $de0f6a87ab84e4d7$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($de0f6a87ab84e4d7$var$crypto && $de0f6a87ab84e4d7$var$crypto.getRandomValues || false) {
    $de0f6a87ab84e4d7$export$bb1abf2ce84fc7e8 = $de0f6a87ab84e4d7$var$randomFill;
    $de0f6a87ab84e4d7$export$2f7171e78e524d5e = $de0f6a87ab84e4d7$var$randomFillSync;
} else {
    $de0f6a87ab84e4d7$export$bb1abf2ce84fc7e8 = $de0f6a87ab84e4d7$var$oldBrowser;
    $de0f6a87ab84e4d7$export$2f7171e78e524d5e = $de0f6a87ab84e4d7$var$oldBrowser;
}
function $de0f6a87ab84e4d7$var$randomFill(buf, offset, size, cb) {
    if (!$de0f6a87ab84e4d7$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $de0f6a87ab84e4d7$var$assertOffset(offset, buf.length);
    $de0f6a87ab84e4d7$var$assertSize(size, offset, buf.length);
    return $de0f6a87ab84e4d7$var$actualFill(buf, offset, size, cb);
}
function $de0f6a87ab84e4d7$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $de0f6a87ab84e4d7$var$crypto.getRandomValues(uint);
    if (cb) {
        $6qd2L.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $5LzvA(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $5LzvA(size);
    bytes.copy(buf, offset);
    return buf;
}
function $de0f6a87ab84e4d7$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$de0f6a87ab84e4d7$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $de0f6a87ab84e4d7$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $de0f6a87ab84e4d7$var$assertSize(size, offset, buf.length);
    return $de0f6a87ab84e4d7$var$actualFill(buf, offset, size);
}


$504f31b65a80c09b$export$bb1abf2ce84fc7e8 = $de0f6a87ab84e4d7$export$bb1abf2ce84fc7e8;
$504f31b65a80c09b$export$2f7171e78e524d5e = $de0f6a87ab84e4d7$export$2f7171e78e524d5e;
$504f31b65a80c09b$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$504f31b65a80c09b$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};


var $8125e6dc9138ff43$exports = {};
$8125e6dc9138ff43$exports = JSON.parse('{"name":"dotenv","version":"16.3.1","description":"Loads environment variables from .env file","main":"lib/main.js","types":"lib/main.d.ts","exports":{".":{"types":"./lib/main.d.ts","require":"./lib/main.js","default":"./lib/main.js"},"./config":"./config.js","./config.js":"./config.js","./lib/env-options":"./lib/env-options.js","./lib/env-options.js":"./lib/env-options.js","./lib/cli-options":"./lib/cli-options.js","./lib/cli-options.js":"./lib/cli-options.js","./package.json":"./package.json"},"scripts":{"dts-check":"tsc --project tests/types/tsconfig.json","lint":"standard","lint-readme":"standard-markdown","pretest":"npm run lint && npm run dts-check","test":"tap tests/*.js --100 -Rspec","prerelease":"npm test","release":"standard-version"},"repository":{"type":"git","url":"git://github.com/motdotla/dotenv.git"},"funding":"https://github.com/motdotla/dotenv?sponsor=1","keywords":["dotenv","env",".env","environment","variables","config","settings"],"readmeFilename":"README.md","license":"BSD-2-Clause","devDependencies":{"@definitelytyped/dtslint":"^0.0.133","@types/node":"^18.11.3","decache":"^4.6.1","sinon":"^14.0.1","standard":"^17.0.0","standard-markdown":"^7.1.0","standard-version":"^9.5.0","tap":"^16.3.0","tar":"^6.1.11","typescript":"^4.8.4"},"engines":{"node":">=12"},"browser":{"fs":false}}');


const $93e24499638c8db0$var$version = $8125e6dc9138ff43$exports.version;
const $93e24499638c8db0$var$LINE = /(?:^|^)\s*(?:export\s+)?([\w.-]+)(?:\s*=\s*?|:\s+?)(\s*'(?:\\'|[^'])*'|\s*"(?:\\"|[^"])*"|\s*`(?:\\`|[^`])*`|[^#\r\n]+)?\s*(?:#.*)?(?:$|$)/mg;
// Parse src into an Object
function $93e24499638c8db0$var$parse(src) {
    const obj = {};
    // Convert buffer to string
    let lines = src.toString();
    // Convert line breaks to same format
    lines = lines.replace(/\r\n?/mg, "\n");
    let match;
    while((match = $93e24499638c8db0$var$LINE.exec(lines)) != null){
        const key = match[1];
        // Default undefined or null to empty string
        let value = match[2] || "";
        // Remove whitespace
        value = value.trim();
        // Check if double quoted
        const maybeQuote = value[0];
        // Remove surrounding quotes
        value = value.replace(/^(['"`])([\s\S]*)\1$/mg, "$2");
        // Expand newlines if double quoted
        if (maybeQuote === '"') {
            value = value.replace(/\\n/g, "\n");
            value = value.replace(/\\r/g, "\r");
        }
        // Add to object
        obj[key] = value;
    }
    return obj;
}
function $93e24499638c8db0$var$_parseVault(options) {
    const vaultPath = $93e24499638c8db0$var$_vaultPath(options);
    // Parse .env.vault
    const result = $93e24499638c8db0$var$DotenvModule.configDotenv({
        path: vaultPath
    });
    if (!result.parsed) throw new Error(`MISSING_DATA: Cannot parse ${vaultPath} for an unknown reason`);
    // handle scenario for comma separated keys - for use with key rotation
    // example: DOTENV_KEY="dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=prod,dotenv://:key_7890@dotenv.org/vault/.env.vault?environment=prod"
    const keys = $93e24499638c8db0$var$_dotenvKey(options).split(",");
    const length = keys.length;
    let decrypted;
    for(let i = 0; i < length; i++)try {
        // Get full key
        const key = keys[i].trim();
        // Get instructions for decrypt
        const attrs = $93e24499638c8db0$var$_instructions(result, key);
        // Decrypt
        decrypted = $93e24499638c8db0$var$DotenvModule.decrypt(attrs.ciphertext, attrs.key);
        break;
    } catch (error) {
        // last key
        if (i + 1 >= length) throw error;
    // try next key
    }
    // Parse decrypted .env string
    return $93e24499638c8db0$var$DotenvModule.parse(decrypted);
}
function $93e24499638c8db0$var$_log(message) {
    console.log(`[dotenv@${$93e24499638c8db0$var$version}][INFO] ${message}`);
}
function $93e24499638c8db0$var$_warn(message) {
    console.log(`[dotenv@${$93e24499638c8db0$var$version}][WARN] ${message}`);
}
function $93e24499638c8db0$var$_debug(message) {
    console.log(`[dotenv@${$93e24499638c8db0$var$version}][DEBUG] ${message}`);
}
function $93e24499638c8db0$var$_dotenvKey(options) {
    // prioritize developer directly setting options.DOTENV_KEY
    if (options && options.DOTENV_KEY && options.DOTENV_KEY.length > 0) return options.DOTENV_KEY;
    // fallback to empty string
    return "";
}
function $93e24499638c8db0$var$_instructions(result, dotenvKey) {
    // Parse DOTENV_KEY. Format is a URI
    let uri;
    try {
        uri = new URL(dotenvKey);
    } catch (error) {
        if (error.code === "ERR_INVALID_URL") throw new Error("INVALID_DOTENV_KEY: Wrong format. Must be in valid uri format like dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=development");
        throw error;
    }
    // Get decrypt key
    const key = uri.password;
    if (!key) throw new Error("INVALID_DOTENV_KEY: Missing key part");
    // Get environment
    const environment = uri.searchParams.get("environment");
    if (!environment) throw new Error("INVALID_DOTENV_KEY: Missing environment part");
    // Get ciphertext payload
    const environmentKey = `DOTENV_VAULT_${environment.toUpperCase()}`;
    const ciphertext = result.parsed[environmentKey] // DOTENV_VAULT_PRODUCTION
    ;
    if (!ciphertext) throw new Error(`NOT_FOUND_DOTENV_ENVIRONMENT: Cannot locate environment ${environmentKey} in your .env.vault file.`);
    return {
        ciphertext: ciphertext,
        key: key
    };
}
function $93e24499638c8db0$var$_vaultPath(options) {
    let dotenvPath = $3019497903d0e8b4$exports.resolve($6qd2L.cwd(), ".env");
    if (options && options.path && options.path.length > 0) dotenvPath = options.path;
    // Locate .env.vault
    return dotenvPath.endsWith(".vault") ? dotenvPath : `${dotenvPath}.vault`;
}
function $93e24499638c8db0$var$_resolveHome(envPath) {
    return envPath[0] === "~" ? $3019497903d0e8b4$exports.join($c06d6e5924b66f1f$export$c1d46b5ea6262c0b(), envPath.slice(1)) : envPath;
}
function $93e24499638c8db0$var$_configVault(options) {
    $93e24499638c8db0$var$_log("Loading env from encrypted .env.vault");
    const parsed = $93e24499638c8db0$var$DotenvModule._parseVault(options);
    let processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $93e24499638c8db0$var$DotenvModule.populate(processEnv, parsed, options);
    return {
        parsed: parsed
    };
}
function $93e24499638c8db0$var$configDotenv(options) {
    let dotenvPath = $3019497903d0e8b4$exports.resolve($6qd2L.cwd(), ".env");
    let encoding = "utf8";
    const debug = Boolean(options && options.debug);
    if (options) {
        if (options.path != null) dotenvPath = $93e24499638c8db0$var$_resolveHome(options.path);
        if (options.encoding != null) encoding = options.encoding;
    }
    try {
        // Specifying an encoding returns a string instead of a buffer
        const parsed = $93e24499638c8db0$var$DotenvModule.parse($1wVs5.readFileSync(dotenvPath, {
            encoding: encoding
        }));
        let processEnv = {};
        if (options && options.processEnv != null) processEnv = options.processEnv;
        $93e24499638c8db0$var$DotenvModule.populate(processEnv, parsed, options);
        return {
            parsed: parsed
        };
    } catch (e) {
        if (debug) $93e24499638c8db0$var$_debug(`Failed to load ${dotenvPath} ${e.message}`);
        return {
            error: e
        };
    }
}
// Populates process.env from .env file
function $93e24499638c8db0$var$config(options) {
    const vaultPath = $93e24499638c8db0$var$_vaultPath(options);
    // fallback to original dotenv if DOTENV_KEY is not set
    if ($93e24499638c8db0$var$_dotenvKey(options).length === 0) return $93e24499638c8db0$var$DotenvModule.configDotenv(options);
    // dotenvKey exists but .env.vault file does not exist
    if (!$1wVs5.existsSync(vaultPath)) {
        $93e24499638c8db0$var$_warn(`You set DOTENV_KEY but you are missing a .env.vault file at ${vaultPath}. Did you forget to build it?`);
        return $93e24499638c8db0$var$DotenvModule.configDotenv(options);
    }
    return $93e24499638c8db0$var$DotenvModule._configVault(options);
}
function $93e24499638c8db0$var$decrypt(encrypted, keyStr) {
    const key = $93e24499638c8db0$require$Buffer.from(keyStr.slice(-64), "hex");
    let ciphertext = $93e24499638c8db0$require$Buffer.from(encrypted, "base64");
    const nonce = ciphertext.slice(0, 12);
    const authTag = ciphertext.slice(-16);
    ciphertext = ciphertext.slice(12, -16);
    try {
        const aesgcm = $504f31b65a80c09b$export$36b6d6ef312eab39("aes-256-gcm", key, nonce);
        aesgcm.setAuthTag(authTag);
        return `${aesgcm.update(ciphertext)}${aesgcm.final()}`;
    } catch (error) {
        const isRange = error instanceof RangeError;
        const invalidKeyLength = error.message === "Invalid key length";
        const decryptionFailed = error.message === "Unsupported state or unable to authenticate data";
        if (isRange || invalidKeyLength) {
            const msg = "INVALID_DOTENV_KEY: It must be 64 characters long (or more)";
            throw new Error(msg);
        } else if (decryptionFailed) {
            const msg = "DECRYPTION_FAILED: Please check your DOTENV_KEY";
            throw new Error(msg);
        } else {
            console.error("Error: ", error.code);
            console.error("Error: ", error.message);
            throw error;
        }
    }
}
// Populate process.env with parsed values
function $93e24499638c8db0$var$populate(processEnv, parsed, options = {}) {
    const debug = Boolean(options && options.debug);
    const override = Boolean(options && options.override);
    if (typeof parsed !== "object") throw new Error("OBJECT_REQUIRED: Please check the processEnv argument being passed to populate");
    // Set process.env
    for (const key of Object.keys(parsed))if (Object.prototype.hasOwnProperty.call(processEnv, key)) {
        if (override === true) processEnv[key] = parsed[key];
        if (debug) {
            if (override === true) $93e24499638c8db0$var$_debug(`"${key}" is already defined and WAS overwritten`);
            else $93e24499638c8db0$var$_debug(`"${key}" is already defined and was NOT overwritten`);
        }
    } else processEnv[key] = parsed[key];
}
const $93e24499638c8db0$var$DotenvModule = {
    configDotenv: $93e24499638c8db0$var$configDotenv,
    _configVault: $93e24499638c8db0$var$_configVault,
    _parseVault: $93e24499638c8db0$var$_parseVault,
    config: $93e24499638c8db0$var$config,
    decrypt: $93e24499638c8db0$var$decrypt,
    parse: $93e24499638c8db0$var$parse,
    populate: $93e24499638c8db0$var$populate
};
$93e24499638c8db0$exports.configDotenv = $93e24499638c8db0$var$DotenvModule.configDotenv;
$93e24499638c8db0$exports._configVault = $93e24499638c8db0$var$DotenvModule._configVault;
$93e24499638c8db0$exports._parseVault = $93e24499638c8db0$var$DotenvModule._parseVault;
$93e24499638c8db0$exports.config = $93e24499638c8db0$var$DotenvModule.config;
$93e24499638c8db0$exports.decrypt = $93e24499638c8db0$var$DotenvModule.decrypt;
$93e24499638c8db0$exports.parse = $93e24499638c8db0$var$DotenvModule.parse;
$93e24499638c8db0$exports.populate = $93e24499638c8db0$var$DotenvModule.populate;
$93e24499638c8db0$exports = $93e24499638c8db0$var$DotenvModule;


var $4b4fccf5f991a92b$exports = {};
"use strict";
function $4b4fccf5f991a92b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4b4fccf5f991a92b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4b4fccf5f991a92b$var$_typeof(obj);
}
Object.defineProperty($4b4fccf5f991a92b$exports, "__esModule", {
    value: true
});
$4b4fccf5f991a92b$exports["default"] = $4b4fccf5f991a92b$exports.ReactGAImplementation = void 0;

var $4b4fccf5f991a92b$var$_ga = $4b4fccf5f991a92b$var$_interopRequireWildcard((parcelRequire("heMYq")));
function $4b4fccf5f991a92b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4b4fccf5f991a92b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4b4fccf5f991a92b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $4b4fccf5f991a92b$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $4b4fccf5f991a92b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $4b4fccf5f991a92b$var$ReactGAImplementation = $4b4fccf5f991a92b$var$_ga.GA4;
$4b4fccf5f991a92b$exports.ReactGAImplementation = $4b4fccf5f991a92b$var$ReactGAImplementation;
var $4b4fccf5f991a92b$var$_default = $4b4fccf5f991a92b$var$_ga["default"];
$4b4fccf5f991a92b$exports["default"] = $4b4fccf5f991a92b$var$_default;


(0, (/*@__PURE__*/$parcel$interopDefault($93e24499638c8db0$exports))).config();
// Google analytics key
(0, (/*@__PURE__*/$parcel$interopDefault($4b4fccf5f991a92b$exports))).initialize("G-E7XCZRLHGN");
const $b8f9b7833fa37166$var$container = document.getElementById("app");
const $b8f9b7833fa37166$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)($b8f9b7833fa37166$var$container);
$b8f9b7833fa37166$var$root.render(/*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).StrictMode, {
    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d823e37feee8d649$export$a325976a38f291f5), {
        clientId: "396072552566-27eufpu57b3husa3e52kndsts1isobio.apps.googleusercontent.com",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3c721443a32700fa$export$d8964aec282183a3), {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ea0a1541df4ae3fc$export$86fbec116b87613f), {})
        })
    })
}));
// ReactDOM.render(
//   <React.StrictMode>
//     <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
//       <ThemeProvider>
//         <App />
//       </ThemeProvider>
//     </GoogleOAuthProvider>
//   </React.StrictMode>,
//   document.getElementById("app")
// );
const $b8f9b7833fa37166$var$SendAnalytics = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($4b4fccf5f991a92b$exports))).send({
        hitType: "pageview",
        page: window.location.pathname
    });
};
(0, $f7967412a8f95f32$export$2e2bcd8739ae039)($b8f9b7833fa37166$var$SendAnalytics);

})();
//# sourceMappingURL=index.e20e7134.js.map
